
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirea099"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirea099"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("4vwom", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $34832f06e1b6f7fc$export$ffb0004e005737fa; });
$parcel$export(module.exports, "jsx", function () { return $34832f06e1b6f7fc$export$34b9dba7ce09269b; });
$parcel$export(module.exports, "jsxs", function () { return $34832f06e1b6f7fc$export$25062201e9e25d76; });

var $dRzna = parcelRequire("dRzna");

var $8ZuUP = parcelRequire("8ZuUP");
parcelRequire("eeH7J");
parcelRequire("gc3M0");
parcelRequire("eq7pw");
parcelRequire("6q2Od");

parcelRequire("3ojZ1");
parcelRequire("7sOZt");
parcelRequire("47KoV");
parcelRequire("5ziuZ");
var $34832f06e1b6f7fc$export$ffb0004e005737fa = $dRzna.Fragment;
function $34832f06e1b6f7fc$export$34b9dba7ce09269b(type, props, key) {
    if (!(0, $8ZuUP.h).call(props, "css")) return $dRzna.jsx(type, props, key);
    return $dRzna.jsx((0, $8ZuUP.E), (0, $8ZuUP.c)(type, props), key);
}
function $34832f06e1b6f7fc$export$25062201e9e25d76(type, props, key) {
    if (!(0, $8ZuUP.h).call(props, "css")) return $dRzna.jsxs(type, props, key);
    return $dRzna.jsxs((0, $8ZuUP.E), (0, $8ZuUP.c)(type, props), key);
}

});
parcelRegister("dRzna", function(module, exports) {
"use strict";

module.exports = (parcelRequire("fYWky"));

});
parcelRegister("fYWky", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $ba29b4d88c039d9b$export$ffb0004e005737fa; }, function (v) { return $ba29b4d88c039d9b$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $ba29b4d88c039d9b$export$34b9dba7ce09269b; }, function (v) { return $ba29b4d88c039d9b$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $ba29b4d88c039d9b$export$25062201e9e25d76; }, function (v) { return $ba29b4d88c039d9b$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $ba29b4d88c039d9b$export$ffb0004e005737fa;
var $ba29b4d88c039d9b$export$34b9dba7ce09269b;
var $ba29b4d88c039d9b$export$25062201e9e25d76;
"use strict";

var $eeH7J = parcelRequire("eeH7J");
var $ba29b4d88c039d9b$var$k = Symbol.for("react.element"), $ba29b4d88c039d9b$var$l = Symbol.for("react.fragment"), $ba29b4d88c039d9b$var$m = Object.prototype.hasOwnProperty, $ba29b4d88c039d9b$var$n = $eeH7J.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $ba29b4d88c039d9b$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $ba29b4d88c039d9b$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$ba29b4d88c039d9b$var$m.call(a, b) && !$ba29b4d88c039d9b$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $ba29b4d88c039d9b$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $ba29b4d88c039d9b$var$n.current
    };
}
$ba29b4d88c039d9b$export$ffb0004e005737fa = $ba29b4d88c039d9b$var$l;
$ba29b4d88c039d9b$export$34b9dba7ce09269b = $ba29b4d88c039d9b$var$q;
$ba29b4d88c039d9b$export$25062201e9e25d76 = $ba29b4d88c039d9b$var$q;

});
parcelRegister("eeH7J", function(module, exports) {
"use strict";

module.exports = (parcelRequire("7q6Dx"));

});
parcelRegister("7q6Dx", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $56701c02768f210b$export$dca3b0875bd9a954; }, function (v) { return $56701c02768f210b$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $56701c02768f210b$export$16fa2f45be04daa8; }, function (v) { return $56701c02768f210b$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $56701c02768f210b$export$ffb0004e005737fa; }, function (v) { return $56701c02768f210b$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $56701c02768f210b$export$e2c29f18771995cb; }, function (v) { return $56701c02768f210b$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $56701c02768f210b$export$221d75b3f55bb0bd; }, function (v) { return $56701c02768f210b$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $56701c02768f210b$export$5f8d39834fd61797; }, function (v) { return $56701c02768f210b$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $56701c02768f210b$export$74bf444e3cd11ea5; }, function (v) { return $56701c02768f210b$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $56701c02768f210b$export$ae55be85d98224ed; }, function (v) { return $56701c02768f210b$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "act", function () { return $56701c02768f210b$export$3ba232387fd5d6dd; }, function (v) { return $56701c02768f210b$export$3ba232387fd5d6dd = v; });
$parcel$export(module.exports, "cloneElement", function () { return $56701c02768f210b$export$e530037191fcd5d7; }, function (v) { return $56701c02768f210b$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $56701c02768f210b$export$fd42f52fd3ae1109; }, function (v) { return $56701c02768f210b$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $56701c02768f210b$export$c8a8987d4410bf2d; }, function (v) { return $56701c02768f210b$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $56701c02768f210b$export$d38cd72104c1f0e9; }, function (v) { return $56701c02768f210b$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $56701c02768f210b$export$7d1e3a5e95ceca43; }, function (v) { return $56701c02768f210b$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $56701c02768f210b$export$257a8862b851cb5b; }, function (v) { return $56701c02768f210b$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $56701c02768f210b$export$a8257692ac88316c; }, function (v) { return $56701c02768f210b$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $56701c02768f210b$export$488013bae63b21da; }, function (v) { return $56701c02768f210b$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $56701c02768f210b$export$7c73462e0d25e514; }, function (v) { return $56701c02768f210b$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $56701c02768f210b$export$7568632d0d33d16d; }, function (v) { return $56701c02768f210b$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $56701c02768f210b$export$88948ce120ea2619; }, function (v) { return $56701c02768f210b$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $56701c02768f210b$export$35808ee640e87ca7; }, function (v) { return $56701c02768f210b$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $56701c02768f210b$export$fae74005e78b1a27; }, function (v) { return $56701c02768f210b$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $56701c02768f210b$export$dc8fbce3eb94dc1e; }, function (v) { return $56701c02768f210b$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $56701c02768f210b$export$6a7bc4e911dc01cf; }, function (v) { return $56701c02768f210b$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $56701c02768f210b$export$6d9c69b0de29b591; }, function (v) { return $56701c02768f210b$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $56701c02768f210b$export$f680877a34711e37; }, function (v) { return $56701c02768f210b$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $56701c02768f210b$export$d5a552a76deda3c2; }, function (v) { return $56701c02768f210b$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $56701c02768f210b$export$aaabe4eda9ed9969; }, function (v) { return $56701c02768f210b$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $56701c02768f210b$export$e5c5a5f917a5871c; }, function (v) { return $56701c02768f210b$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $56701c02768f210b$export$1538c33de8887b59; }, function (v) { return $56701c02768f210b$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $56701c02768f210b$export$13e3392192263954; }, function (v) { return $56701c02768f210b$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $56701c02768f210b$export$b8f5890fc79d6aca; }, function (v) { return $56701c02768f210b$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $56701c02768f210b$export$60241385465d0a34; }, function (v) { return $56701c02768f210b$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $56701c02768f210b$export$306c0aa65ff9ec16; }, function (v) { return $56701c02768f210b$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $56701c02768f210b$export$7b286972b8d8ccbf; }, function (v) { return $56701c02768f210b$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $56701c02768f210b$export$83d89fbfd8236492; }, function (v) { return $56701c02768f210b$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $56701c02768f210b$export$dca3b0875bd9a954;
var $56701c02768f210b$export$16fa2f45be04daa8;
var $56701c02768f210b$export$ffb0004e005737fa;
var $56701c02768f210b$export$e2c29f18771995cb;
var $56701c02768f210b$export$221d75b3f55bb0bd;
var $56701c02768f210b$export$5f8d39834fd61797;
var $56701c02768f210b$export$74bf444e3cd11ea5;
var $56701c02768f210b$export$ae55be85d98224ed;
var $56701c02768f210b$export$3ba232387fd5d6dd;
var $56701c02768f210b$export$e530037191fcd5d7;
var $56701c02768f210b$export$fd42f52fd3ae1109;
var $56701c02768f210b$export$c8a8987d4410bf2d;
var $56701c02768f210b$export$d38cd72104c1f0e9;
var $56701c02768f210b$export$7d1e3a5e95ceca43;
var $56701c02768f210b$export$257a8862b851cb5b;
var $56701c02768f210b$export$a8257692ac88316c;
var $56701c02768f210b$export$488013bae63b21da;
var $56701c02768f210b$export$7c73462e0d25e514;
var $56701c02768f210b$export$7568632d0d33d16d;
var $56701c02768f210b$export$88948ce120ea2619;
var $56701c02768f210b$export$35808ee640e87ca7;
var $56701c02768f210b$export$fae74005e78b1a27;
var $56701c02768f210b$export$dc8fbce3eb94dc1e;
var $56701c02768f210b$export$6a7bc4e911dc01cf;
var $56701c02768f210b$export$6d9c69b0de29b591;
var $56701c02768f210b$export$f680877a34711e37;
var $56701c02768f210b$export$d5a552a76deda3c2;
var $56701c02768f210b$export$aaabe4eda9ed9969;
var $56701c02768f210b$export$e5c5a5f917a5871c;
var $56701c02768f210b$export$1538c33de8887b59;
var $56701c02768f210b$export$13e3392192263954;
var $56701c02768f210b$export$b8f5890fc79d6aca;
var $56701c02768f210b$export$60241385465d0a34;
var $56701c02768f210b$export$306c0aa65ff9ec16;
var $56701c02768f210b$export$7b286972b8d8ccbf;
var $56701c02768f210b$export$83d89fbfd8236492;
"use strict";
var $56701c02768f210b$var$l = Symbol.for("react.element"), $56701c02768f210b$var$n = Symbol.for("react.portal"), $56701c02768f210b$var$p = Symbol.for("react.fragment"), $56701c02768f210b$var$q = Symbol.for("react.strict_mode"), $56701c02768f210b$var$r = Symbol.for("react.profiler"), $56701c02768f210b$var$t = Symbol.for("react.provider"), $56701c02768f210b$var$u = Symbol.for("react.context"), $56701c02768f210b$var$v = Symbol.for("react.forward_ref"), $56701c02768f210b$var$w = Symbol.for("react.suspense"), $56701c02768f210b$var$x = Symbol.for("react.memo"), $56701c02768f210b$var$y = Symbol.for("react.lazy"), $56701c02768f210b$var$z = Symbol.iterator;
function $56701c02768f210b$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $56701c02768f210b$var$z && a[$56701c02768f210b$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $56701c02768f210b$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $56701c02768f210b$var$C = Object.assign, $56701c02768f210b$var$D = {};
function $56701c02768f210b$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $56701c02768f210b$var$D;
    this.updater = e || $56701c02768f210b$var$B;
}
$56701c02768f210b$var$E.prototype.isReactComponent = {};
$56701c02768f210b$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$56701c02768f210b$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $56701c02768f210b$var$F() {}
$56701c02768f210b$var$F.prototype = $56701c02768f210b$var$E.prototype;
function $56701c02768f210b$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $56701c02768f210b$var$D;
    this.updater = e || $56701c02768f210b$var$B;
}
var $56701c02768f210b$var$H = $56701c02768f210b$var$G.prototype = new $56701c02768f210b$var$F;
$56701c02768f210b$var$H.constructor = $56701c02768f210b$var$G;
$56701c02768f210b$var$C($56701c02768f210b$var$H, $56701c02768f210b$var$E.prototype);
$56701c02768f210b$var$H.isPureReactComponent = !0;
var $56701c02768f210b$var$I = Array.isArray, $56701c02768f210b$var$J = Object.prototype.hasOwnProperty, $56701c02768f210b$var$K = {
    current: null
}, $56701c02768f210b$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $56701c02768f210b$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$56701c02768f210b$var$J.call(b, d) && !$56701c02768f210b$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $56701c02768f210b$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $56701c02768f210b$var$K.current
    };
}
function $56701c02768f210b$var$N(a, b) {
    return {
        $$typeof: $56701c02768f210b$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $56701c02768f210b$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $56701c02768f210b$var$l;
}
function $56701c02768f210b$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $56701c02768f210b$var$P = /\/+/g;
function $56701c02768f210b$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $56701c02768f210b$var$escape("" + a.key) : b.toString(36);
}
function $56701c02768f210b$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $56701c02768f210b$var$l:
                case $56701c02768f210b$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $56701c02768f210b$var$Q(h, 0) : d, $56701c02768f210b$var$I(c) ? (e = "", null != a && (e = a.replace($56701c02768f210b$var$P, "$&/") + "/"), $56701c02768f210b$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($56701c02768f210b$var$O(c) && (c = $56701c02768f210b$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($56701c02768f210b$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($56701c02768f210b$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $56701c02768f210b$var$Q(k, g);
        h += $56701c02768f210b$var$R(k, b, e, f, c);
    }
    else if (f = $56701c02768f210b$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $56701c02768f210b$var$Q(k, g++), h += $56701c02768f210b$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $56701c02768f210b$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $56701c02768f210b$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $56701c02768f210b$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $56701c02768f210b$var$U = {
    current: null
}, $56701c02768f210b$var$V = {
    transition: null
}, $56701c02768f210b$var$W = {
    ReactCurrentDispatcher: $56701c02768f210b$var$U,
    ReactCurrentBatchConfig: $56701c02768f210b$var$V,
    ReactCurrentOwner: $56701c02768f210b$var$K
};
function $56701c02768f210b$var$X() {
    throw Error("act(...) is not supported in production builds of React.");
}
$56701c02768f210b$export$dca3b0875bd9a954 = {
    map: $56701c02768f210b$var$S,
    forEach: function(a, b, e) {
        $56701c02768f210b$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $56701c02768f210b$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $56701c02768f210b$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$56701c02768f210b$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$56701c02768f210b$export$16fa2f45be04daa8 = $56701c02768f210b$var$E;
$56701c02768f210b$export$ffb0004e005737fa = $56701c02768f210b$var$p;
$56701c02768f210b$export$e2c29f18771995cb = $56701c02768f210b$var$r;
$56701c02768f210b$export$221d75b3f55bb0bd = $56701c02768f210b$var$G;
$56701c02768f210b$export$5f8d39834fd61797 = $56701c02768f210b$var$q;
$56701c02768f210b$export$74bf444e3cd11ea5 = $56701c02768f210b$var$w;
$56701c02768f210b$export$ae55be85d98224ed = $56701c02768f210b$var$W;
$56701c02768f210b$export$3ba232387fd5d6dd = $56701c02768f210b$var$X;
$56701c02768f210b$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $56701c02768f210b$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $56701c02768f210b$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$56701c02768f210b$var$J.call(b, f) && !$56701c02768f210b$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $56701c02768f210b$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$56701c02768f210b$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $56701c02768f210b$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $56701c02768f210b$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$56701c02768f210b$export$c8a8987d4410bf2d = $56701c02768f210b$var$M;
$56701c02768f210b$export$d38cd72104c1f0e9 = function(a) {
    var b = $56701c02768f210b$var$M.bind(null, a);
    b.type = a;
    return b;
};
$56701c02768f210b$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$56701c02768f210b$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $56701c02768f210b$var$v,
        render: a
    };
};
$56701c02768f210b$export$a8257692ac88316c = $56701c02768f210b$var$O;
$56701c02768f210b$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $56701c02768f210b$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $56701c02768f210b$var$T
    };
};
$56701c02768f210b$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $56701c02768f210b$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$56701c02768f210b$export$7568632d0d33d16d = function(a) {
    var b = $56701c02768f210b$var$V.transition;
    $56701c02768f210b$var$V.transition = {};
    try {
        a();
    } finally{
        $56701c02768f210b$var$V.transition = b;
    }
};
$56701c02768f210b$export$88948ce120ea2619 = $56701c02768f210b$var$X;
$56701c02768f210b$export$35808ee640e87ca7 = function(a, b) {
    return $56701c02768f210b$var$U.current.useCallback(a, b);
};
$56701c02768f210b$export$fae74005e78b1a27 = function(a) {
    return $56701c02768f210b$var$U.current.useContext(a);
};
$56701c02768f210b$export$dc8fbce3eb94dc1e = function() {};
$56701c02768f210b$export$6a7bc4e911dc01cf = function(a) {
    return $56701c02768f210b$var$U.current.useDeferredValue(a);
};
$56701c02768f210b$export$6d9c69b0de29b591 = function(a, b) {
    return $56701c02768f210b$var$U.current.useEffect(a, b);
};
$56701c02768f210b$export$f680877a34711e37 = function() {
    return $56701c02768f210b$var$U.current.useId();
};
$56701c02768f210b$export$d5a552a76deda3c2 = function(a, b, e) {
    return $56701c02768f210b$var$U.current.useImperativeHandle(a, b, e);
};
$56701c02768f210b$export$aaabe4eda9ed9969 = function(a, b) {
    return $56701c02768f210b$var$U.current.useInsertionEffect(a, b);
};
$56701c02768f210b$export$e5c5a5f917a5871c = function(a, b) {
    return $56701c02768f210b$var$U.current.useLayoutEffect(a, b);
};
$56701c02768f210b$export$1538c33de8887b59 = function(a, b) {
    return $56701c02768f210b$var$U.current.useMemo(a, b);
};
$56701c02768f210b$export$13e3392192263954 = function(a, b, e) {
    return $56701c02768f210b$var$U.current.useReducer(a, b, e);
};
$56701c02768f210b$export$b8f5890fc79d6aca = function(a) {
    return $56701c02768f210b$var$U.current.useRef(a);
};
$56701c02768f210b$export$60241385465d0a34 = function(a) {
    return $56701c02768f210b$var$U.current.useState(a);
};
$56701c02768f210b$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $56701c02768f210b$var$U.current.useSyncExternalStore(a, b, e);
};
$56701c02768f210b$export$7b286972b8d8ccbf = function() {
    return $56701c02768f210b$var$U.current.useTransition();
};
$56701c02768f210b$export$83d89fbfd8236492 = "18.3.1";

});




parcelRegister("8ZuUP", function(module, exports) {

$parcel$export(module.exports, "i", function () { return $68bc00712ca02027$export$23f2a1d2818174ef; });
$parcel$export(module.exports, "h", function () { return $68bc00712ca02027$export$dda1d9f60106f0e9; });
$parcel$export(module.exports, "C", function () { return $68bc00712ca02027$export$e7094788287c5e9b; });
$parcel$export(module.exports, "w", function () { return $68bc00712ca02027$export$efccba1c4a2ef57b; });
$parcel$export(module.exports, "T", function () { return $68bc00712ca02027$export$971d5caa766a69d7; });
$parcel$export(module.exports, "c", function () { return $68bc00712ca02027$export$db3b6bfb95261072; });
$parcel$export(module.exports, "E", function () { return $68bc00712ca02027$export$a9c23c6ac3fc3eca; });

var $eeH7J = parcelRequire("eeH7J");

var $gc3M0 = parcelRequire("gc3M0");

var $h4XE0 = parcelRequire("h4XE0");

var $6q2Od = parcelRequire("6q2Od");

var $eU7V2 = parcelRequire("eU7V2");

var $7sOZt = parcelRequire("7sOZt");

var $47KoV = parcelRequire("47KoV");

var $5ziuZ = parcelRequire("5ziuZ");
var $68bc00712ca02027$export$23f2a1d2818174ef = true;
var $68bc00712ca02027$export$dda1d9f60106f0e9 = {}.hasOwnProperty;
var $68bc00712ca02027$var$EmotionCacheContext = /* #__PURE__ */ $eeH7J.createContext(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== "undefined" ? /* #__PURE__ */ (0, $gc3M0.default)({
    key: "css"
}) : null);
var $68bc00712ca02027$export$e7094788287c5e9b = $68bc00712ca02027$var$EmotionCacheContext.Provider;
var $68bc00712ca02027$export$71511d61b312f219 = function useEmotionCache() {
    return (0, $eeH7J.useContext)($68bc00712ca02027$var$EmotionCacheContext);
};
var $68bc00712ca02027$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    // $FlowFixMe
    return /*#__PURE__*/ (0, $eeH7J.forwardRef)(function(props, ref) {
        // the cache will never be null in the browser
        var cache = (0, $eeH7J.useContext)($68bc00712ca02027$var$EmotionCacheContext);
        return func(props, cache, ref);
    });
};
if (!$68bc00712ca02027$export$23f2a1d2818174ef) $68bc00712ca02027$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    return function(props) {
        var cache = (0, $eeH7J.useContext)($68bc00712ca02027$var$EmotionCacheContext);
        if (cache === null) {
            // yes, we're potentially creating this on every render
            // it doesn't actually matter though since it's only on the server
            // so there will only every be a single render
            // that could change in the future because of suspense and etc. but for now,
            // this works and i don't want to optimise for a future thing that we aren't sure about
            cache = (0, $gc3M0.default)({
                key: "css"
            });
            return /*#__PURE__*/ $eeH7J.createElement($68bc00712ca02027$var$EmotionCacheContext.Provider, {
                value: cache
            }, func(props, cache));
        } else return func(props, cache);
    };
};
var $68bc00712ca02027$export$971d5caa766a69d7 = /* #__PURE__ */ $eeH7J.createContext({});
var $68bc00712ca02027$export$3b14a55fb2447963 = function useTheme() {
    return $eeH7J.useContext($68bc00712ca02027$export$971d5caa766a69d7);
};
var $68bc00712ca02027$var$getTheme = function getTheme(outerTheme, theme) {
    if (typeof theme === "function") {
        var mergedTheme = theme(outerTheme);
        return mergedTheme;
    }
    return (0, $h4XE0.default)({}, outerTheme, theme);
};
var $68bc00712ca02027$var$createCacheWithTheme = /* #__PURE__ */ (0, $6q2Od.default)(function(outerTheme) {
    return (0, $6q2Od.default)(function(theme) {
        return $68bc00712ca02027$var$getTheme(outerTheme, theme);
    });
});
var $68bc00712ca02027$export$407448d2b89b1813 = function ThemeProvider(props) {
    var theme = $eeH7J.useContext($68bc00712ca02027$export$971d5caa766a69d7);
    if (props.theme !== theme) theme = $68bc00712ca02027$var$createCacheWithTheme(theme)(props.theme);
    return /*#__PURE__*/ $eeH7J.createElement($68bc00712ca02027$export$971d5caa766a69d7.Provider, {
        value: theme
    }, props.children);
};
function $68bc00712ca02027$export$8b22cf2602fb60ce(Component) {
    var componentName = Component.displayName || Component.name || "Component";
    var render = function render(props, ref) {
        var theme = $eeH7J.useContext($68bc00712ca02027$export$971d5caa766a69d7);
        return /*#__PURE__*/ $eeH7J.createElement(Component, (0, $h4XE0.default)({
            theme: theme,
            ref: ref
        }, props));
    }; // $FlowFixMe
    var WithTheme = /*#__PURE__*/ $eeH7J.forwardRef(render);
    WithTheme.displayName = "WithTheme(" + componentName + ")";
    return (0, $eU7V2.default)(WithTheme, Component);
}
var $68bc00712ca02027$var$getLastPart = function getLastPart(functionName) {
    // The match may be something like 'Object.createEmotionProps' or
    // 'Loader.prototype.render'
    var parts = functionName.split(".");
    return parts[parts.length - 1];
};
var $68bc00712ca02027$var$getFunctionNameFromStackTraceLine = function getFunctionNameFromStackTraceLine(line) {
    // V8
    var match = /^\s+at\s+([A-Za-z0-9$.]+)\s/.exec(line);
    if (match) return $68bc00712ca02027$var$getLastPart(match[1]); // Safari / Firefox
    match = /^([A-Za-z0-9$.]+)@/.exec(line);
    if (match) return $68bc00712ca02027$var$getLastPart(match[1]);
    return undefined;
};
var $68bc00712ca02027$var$internalReactFunctionNames = /* #__PURE__ */ new Set([
    "renderWithHooks",
    "processChild",
    "finishClassComponent",
    "renderToString"
]); // These identifiers come from error stacks, so they have to be valid JS
// identifiers, thus we only need to replace what is a valid character for JS,
// but not for CSS.
var $68bc00712ca02027$var$sanitizeIdentifier = function sanitizeIdentifier(identifier) {
    return identifier.replace(/\$/g, "-");
};
var $68bc00712ca02027$var$getLabelFromStackTrace = function getLabelFromStackTrace(stackTrace) {
    if (!stackTrace) return undefined;
    var lines = stackTrace.split("\n");
    for(var i = 0; i < lines.length; i++){
        var functionName = $68bc00712ca02027$var$getFunctionNameFromStackTraceLine(lines[i]); // The first line of V8 stack traces is just "Error"
        if (!functionName) continue; // If we reach one of these, we have gone too far and should quit
        if ($68bc00712ca02027$var$internalReactFunctionNames.has(functionName)) break; // The component name is the first function in the stack that starts with an
        // uppercase letter
        if (/^[A-Z]/.test(functionName)) return $68bc00712ca02027$var$sanitizeIdentifier(functionName);
    }
    return undefined;
};
var $68bc00712ca02027$var$typePropName = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__";
var $68bc00712ca02027$var$labelPropName = "__EMOTION_LABEL_PLEASE_DO_NOT_USE__";
var $68bc00712ca02027$export$db3b6bfb95261072 = function createEmotionProps(type, props) {
    var newProps = {};
    for(var key in props)if ($68bc00712ca02027$export$dda1d9f60106f0e9.call(props, key)) newProps[key] = props[key];
    newProps[$68bc00712ca02027$var$typePropName] = type; // For performance, only call getLabelFromStackTrace in development and when
    var label;
    return newProps;
};
var $68bc00712ca02027$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $7sOZt.registerStyles)(cache, serialized, isStringTag);
    (0, $5ziuZ.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $7sOZt.insertStyles)(cache, serialized, isStringTag);
    });
    return null;
};
var $68bc00712ca02027$var$Emotion = /* #__PURE__ */ $68bc00712ca02027$export$efccba1c4a2ef57b(function(props, cache, ref) {
    var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === "string" && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var WrappedComponent = props[$68bc00712ca02027$var$typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = "";
    if (typeof props.className === "string") className = (0, $7sOZt.getRegisteredStyles)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, $47KoV.serializeStyles)(registeredStyles, undefined, $eeH7J.useContext($68bc00712ca02027$export$971d5caa766a69d7));
    var labelFromStack;
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var key in props)if ($68bc00712ca02027$export$dda1d9f60106f0e9.call(props, key) && key !== "css" && key !== $68bc00712ca02027$var$typePropName && true) newProps[key] = props[key];
    newProps.ref = ref;
    newProps.className = className;
    return /*#__PURE__*/ $eeH7J.createElement($eeH7J.Fragment, null, /*#__PURE__*/ $eeH7J.createElement($68bc00712ca02027$var$Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof WrappedComponent === "string"
    }), /*#__PURE__*/ $eeH7J.createElement(WrappedComponent, newProps));
});
var $68bc00712ca02027$export$a9c23c6ac3fc3eca = $68bc00712ca02027$var$Emotion;

});
parcelRegister("gc3M0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bca0b19df9b66c20$export$2e2bcd8739ae039; });

var $cjyHC = parcelRequire("cjyHC");

var $8SDLF = parcelRequire("8SDLF");
parcelRequire("6q2Od");
parcelRequire("d5hMW");
var $bca0b19df9b66c20$var$identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;
    while(true){
        previous = character;
        character = (0, $8SDLF.peek)(); // &\f
        if (previous === 38 && character === 12) points[index] = 1;
        if ((0, $8SDLF.token)(character)) break;
        (0, $8SDLF.next)();
    }
    return (0, $8SDLF.slice)(begin, (0, $8SDLF.position));
};
var $bca0b19df9b66c20$var$toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;
    do switch((0, $8SDLF.token)(character)){
        case 0:
            // &\f
            if (character === 38 && (0, $8SDLF.peek)() === 12) // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
            parsed[index] += $bca0b19df9b66c20$var$identifierWithPointTracking((0, $8SDLF.position) - 1, points, index);
            break;
        case 2:
            parsed[index] += (0, $8SDLF.delimit)(character);
            break;
        case 4:
            // comma
            if (character === 44) {
                // colon
                parsed[++index] = (0, $8SDLF.peek)() === 58 ? "&\f" : "";
                points[index] = parsed[index].length;
                break;
            }
        // fallthrough
        default:
            parsed[index] += (0, $8SDLF.from)(character);
    }
    while (character = (0, $8SDLF.next)());
    return parsed;
};
var $bca0b19df9b66c20$var$getRules = function getRules(value, points) {
    return (0, $8SDLF.dealloc)($bca0b19df9b66c20$var$toRules((0, $8SDLF.alloc)(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11
var $bca0b19df9b66c20$var$fixedElements = /* #__PURE__ */ new WeakMap();
var $bca0b19df9b66c20$var$compat = function compat(element) {
    if (element.type !== "rule" || !element.parent || // positive .length indicates that this rule contains pseudo
    // negative .length indicates that this rule has been already prefixed
    element.length < 1) return;
    var value = element.value, parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;
    while(parent.type !== "rule"){
        parent = parent.parent;
        if (!parent) return;
    } // short-circuit for the simplest case
    if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !$bca0b19df9b66c20$var$fixedElements.get(parent)) return;
     // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"
    if (isImplicitRule) return;
    $bca0b19df9b66c20$var$fixedElements.set(element, true);
    var points = [];
    var rules = $bca0b19df9b66c20$var$getRules(value, points);
    var parentRules = parent.props;
    for(var i = 0, k = 0; i < rules.length; i++)for(var j = 0; j < parentRules.length; j++, k++)element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
};
var $bca0b19df9b66c20$var$removeLabel = function removeLabel(element) {
    if (element.type === "decl") {
        var value = element.value;
        if (value.charCodeAt(0) === 108 && // charcode for b
        value.charCodeAt(2) === 98) {
            // this ignores label
            element["return"] = "";
            element.value = "";
        }
    }
};
var $bca0b19df9b66c20$var$ignoreFlag = "emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason";
var $bca0b19df9b66c20$var$isIgnoringComment = function isIgnoringComment(element) {
    return element.type === "comm" && element.children.indexOf($bca0b19df9b66c20$var$ignoreFlag) > -1;
};
var $bca0b19df9b66c20$var$createUnsafeSelectorsAlarm = function createUnsafeSelectorsAlarm(cache) {
    return function(element, index, children) {
        if (element.type !== "rule" || cache.compat) return;
        var unsafePseudoClasses = element.value.match(/(:first|:nth|:nth-last)-child/g);
        if (unsafePseudoClasses) {
            var isNested = !!element.parent; // in nested rules comments become children of the "auto-inserted" rule and that's always the `element.parent`
            //
            // considering this input:
            // .a {
            //   .b /* comm */ {}
            //   color: hotpink;
            // }
            // we get output corresponding to this:
            // .a {
            //   & {
            //     /* comm */
            //     color: hotpink;
            //   }
            //   .b {}
            // }
            var commentContainer = isNested ? element.parent.children : children;
            for(var i = commentContainer.length - 1; i >= 0; i--){
                var node = commentContainer[i];
                if (node.line < element.line) break;
                 // it is quite weird but comments are *usually* put at `column: element.column - 1`
                // so we seek *from the end* for the node that is earlier than the rule's `element` and check that
                // this will also match inputs like this:
                // .a {
                //   /* comm */
                //   .b {}
                // }
                //
                // but that is fine
                //
                // it would be the easiest to change the placement of the comment to be the first child of the rule:
                // .a {
                //   .b { /* comm */ }
                // }
                // with such inputs we wouldn't have to search for the comment at all
                // TODO: consider changing this comment placement in the next major version
                if (node.column < element.column) {
                    if ($bca0b19df9b66c20$var$isIgnoringComment(node)) return;
                    break;
                }
            }
            unsafePseudoClasses.forEach(function(unsafePseudoClass) {
                console.error('The pseudo class "' + unsafePseudoClass + '" is potentially unsafe when doing server-side rendering. Try changing it to "' + unsafePseudoClass.split("-child")[0] + '-of-type".');
            });
        }
    };
};
var $bca0b19df9b66c20$var$isImportRule = function isImportRule(element) {
    return element.type.charCodeAt(1) === 105 && element.type.charCodeAt(0) === 64;
};
var $bca0b19df9b66c20$var$isPrependedWithRegularRules = function isPrependedWithRegularRules(index, children) {
    for(var i = index - 1; i >= 0; i--){
        if (!$bca0b19df9b66c20$var$isImportRule(children[i])) return true;
    }
    return false;
}; // use this to remove incorrect elements from further processing
// so they don't get handed to the `sheet` (or anything else)
// as that could potentially lead to additional logs which in turn could be overhelming to the user
var $bca0b19df9b66c20$var$nullifyElement = function nullifyElement(element) {
    element.type = "";
    element.value = "";
    element["return"] = "";
    element.children = "";
    element.props = "";
};
var $bca0b19df9b66c20$var$incorrectImportAlarm = function incorrectImportAlarm(element, index, children) {
    if (!$bca0b19df9b66c20$var$isImportRule(element)) return;
    if (element.parent) {
        console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles.");
        $bca0b19df9b66c20$var$nullifyElement(element);
    } else if ($bca0b19df9b66c20$var$isPrependedWithRegularRules(index, children)) {
        console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules.");
        $bca0b19df9b66c20$var$nullifyElement(element);
    }
};
/* eslint-disable no-fallthrough */ function $bca0b19df9b66c20$var$prefix(value, length) {
    switch((0, $8SDLF.hash)(value, length)){
        // color-adjust
        case 5103:
            return (0, $8SDLF.WEBKIT) + "print-" + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $8SDLF.WEBKIT) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $8SDLF.WEBKIT) + value + (0, $8SDLF.MOZ) + value + (0, $8SDLF.MS) + value + value;
        // flex, flex-direction
        case 6828:
        case 4268:
            return (0, $8SDLF.WEBKIT) + value + (0, $8SDLF.MS) + value + value;
        // order
        case 6165:
            return (0, $8SDLF.WEBKIT) + value + (0, $8SDLF.MS) + "flex-" + value + value;
        // align-items
        case 5187:
            return (0, $8SDLF.WEBKIT) + value + (0, $8SDLF.replace)(value, /(\w+).+(:[^]+)/, (0, $8SDLF.WEBKIT) + "box-$1$2" + (0, $8SDLF.MS) + "flex-$1$2") + value;
        // align-self
        case 5443:
            return (0, $8SDLF.WEBKIT) + value + (0, $8SDLF.MS) + "flex-item-" + (0, $8SDLF.replace)(value, /flex-|-self/, "") + value;
        // align-content
        case 4675:
            return (0, $8SDLF.WEBKIT) + value + (0, $8SDLF.MS) + "flex-line-pack" + (0, $8SDLF.replace)(value, /align-content|flex-|-self/, "") + value;
        // flex-shrink
        case 5548:
            return (0, $8SDLF.WEBKIT) + value + (0, $8SDLF.MS) + (0, $8SDLF.replace)(value, "shrink", "negative") + value;
        // flex-basis
        case 5292:
            return (0, $8SDLF.WEBKIT) + value + (0, $8SDLF.MS) + (0, $8SDLF.replace)(value, "basis", "preferred-size") + value;
        // flex-grow
        case 6060:
            return (0, $8SDLF.WEBKIT) + "box-" + (0, $8SDLF.replace)(value, "-grow", "") + (0, $8SDLF.WEBKIT) + value + (0, $8SDLF.MS) + (0, $8SDLF.replace)(value, "grow", "positive") + value;
        // transition
        case 4554:
            return (0, $8SDLF.WEBKIT) + (0, $8SDLF.replace)(value, /([^-])(transform)/g, "$1" + (0, $8SDLF.WEBKIT) + "$2") + value;
        // cursor
        case 6187:
            return (0, $8SDLF.replace)((0, $8SDLF.replace)((0, $8SDLF.replace)(value, /(zoom-|grab)/, (0, $8SDLF.WEBKIT) + "$1"), /(image-set)/, (0, $8SDLF.WEBKIT) + "$1"), value, "") + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $8SDLF.replace)(value, /(image-set\([^]*)/, (0, $8SDLF.WEBKIT) + "$1" + "$`$1");
        // justify-content
        case 4968:
            return (0, $8SDLF.replace)((0, $8SDLF.replace)(value, /(.+:)(flex-)?(.*)/, (0, $8SDLF.WEBKIT) + "box-pack:$3" + (0, $8SDLF.MS) + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + (0, $8SDLF.WEBKIT) + value + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $8SDLF.replace)(value, /(.+)-inline(.+)/, (0, $8SDLF.WEBKIT) + "$1$2") + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $8SDLF.strlen)(value) - 1 - length > 6) switch((0, $8SDLF.charat)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $8SDLF.charat)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $8SDLF.replace)(value, /(.+:)(.+)-([^]+)/, "$1" + (0, $8SDLF.WEBKIT) + "$2-$3" + "$1" + (0, $8SDLF.MOZ) + ((0, $8SDLF.charat)(value, length + 3) == 108 ? "$3" : "$2-$3")) + value;
                // (s)tretch
                case 115:
                    return ~(0, $8SDLF.indexof)(value, "stretch") ? $bca0b19df9b66c20$var$prefix((0, $8SDLF.replace)(value, "stretch", "fill-available"), length) + value : value;
            }
            break;
        // position: sticky
        case 4949:
            // (s)ticky?
            if ((0, $8SDLF.charat)(value, length + 1) !== 115) break;
        // display: (flex|inline-flex)
        case 6444:
            switch((0, $8SDLF.charat)(value, (0, $8SDLF.strlen)(value) - 3 - (~(0, $8SDLF.indexof)(value, "!important") && 10))){
                // stic(k)y
                case 107:
                    return (0, $8SDLF.replace)(value, ":", ":" + (0, $8SDLF.WEBKIT)) + value;
                // (inline-)?fl(e)x
                case 101:
                    return (0, $8SDLF.replace)(value, /(.+:)([^;!]+)(;|!.+)?/, "$1" + (0, $8SDLF.WEBKIT) + ((0, $8SDLF.charat)(value, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + (0, $8SDLF.WEBKIT) + "$2$3" + "$1" + (0, $8SDLF.MS) + "$2box$3") + value;
            }
            break;
        // writing-mode
        case 5936:
            switch((0, $8SDLF.charat)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $8SDLF.WEBKIT) + value + (0, $8SDLF.MS) + (0, $8SDLF.replace)(value, /[svh]\w+-[tblr]{2}/, "tb") + value;
                // vertical-r(l)
                case 108:
                    return (0, $8SDLF.WEBKIT) + value + (0, $8SDLF.MS) + (0, $8SDLF.replace)(value, /[svh]\w+-[tblr]{2}/, "tb-rl") + value;
                // horizontal(-)tb
                case 45:
                    return (0, $8SDLF.WEBKIT) + value + (0, $8SDLF.MS) + (0, $8SDLF.replace)(value, /[svh]\w+-[tblr]{2}/, "lr") + value;
            }
            return (0, $8SDLF.WEBKIT) + value + (0, $8SDLF.MS) + value + value;
    }
    return value;
}
var $bca0b19df9b66c20$var$prefixer = function prefixer(element, index, children, callback) {
    if (element.length > -1) {
        if (!element["return"]) switch(element.type){
            case 0, $8SDLF.DECLARATION:
                element["return"] = $bca0b19df9b66c20$var$prefix(element.value, element.length);
                break;
            case 0, $8SDLF.KEYFRAMES:
                return (0, $8SDLF.serialize)([
                    (0, $8SDLF.copy)(element, {
                        value: (0, $8SDLF.replace)(element.value, "@", "@" + (0, $8SDLF.WEBKIT))
                    })
                ], callback);
            case 0, $8SDLF.RULESET:
                if (element.length) return (0, $8SDLF.combine)(element.props, function(value) {
                    switch((0, $8SDLF.match)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ":read-only":
                        case ":read-write":
                            return (0, $8SDLF.serialize)([
                                (0, $8SDLF.copy)(element, {
                                    props: [
                                        (0, $8SDLF.replace)(value, /:(read-\w+)/, ":" + (0, $8SDLF.MOZ) + "$1")
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case "::placeholder":
                            return (0, $8SDLF.serialize)([
                                (0, $8SDLF.copy)(element, {
                                    props: [
                                        (0, $8SDLF.replace)(value, /:(plac\w+)/, ":" + (0, $8SDLF.WEBKIT) + "input-$1")
                                    ]
                                }),
                                (0, $8SDLF.copy)(element, {
                                    props: [
                                        (0, $8SDLF.replace)(value, /:(plac\w+)/, ":" + (0, $8SDLF.MOZ) + "$1")
                                    ]
                                }),
                                (0, $8SDLF.copy)(element, {
                                    props: [
                                        (0, $8SDLF.replace)(value, /:(plac\w+)/, (0, $8SDLF.MS) + "input-$1")
                                    ]
                                })
                            ], callback);
                    }
                    return "";
                });
        }
    }
};
var $bca0b19df9b66c20$var$defaultStylisPlugins = [
    $bca0b19df9b66c20$var$prefixer
];
var $bca0b19df9b66c20$export$2e2bcd8739ae039 = function createCache(options) {
    var key = options.key;
    if (key === "css") {
        var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
        // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
        // note this very very intentionally targets all style elements regardless of the key to ensure
        // that creating a cache works inside of render of a React component
        Array.prototype.forEach.call(ssrStyles, function(node) {
            // we want to only move elements which have a space in the data-emotion attribute value
            // because that indicates that it is an Emotion 11 server-side rendered style elements
            // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
            // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
            // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
            // will not result in the Emotion 10 styles being destroyed
            var dataEmotionAttribute = node.getAttribute("data-emotion");
            if (dataEmotionAttribute.indexOf(" ") === -1) return;
            document.head.appendChild(node);
            node.setAttribute("data-s", "");
        });
    }
    var stylisPlugins = options.stylisPlugins || $bca0b19df9b66c20$var$defaultStylisPlugins;
    var inserted = {};
    var container;
    var nodesToHydrate = [];
    container = options.container || document.head;
    Array.prototype.forEach.call(// means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + key + ' "]'), function(node) {
        var attrib = node.getAttribute("data-emotion").split(" "); // $FlowFixMe
        for(var i = 1; i < attrib.length; i++)inserted[attrib[i]] = true;
        nodesToHydrate.push(node);
    });
    var _insert;
    var omnipresentPlugins = [
        $bca0b19df9b66c20$var$compat,
        $bca0b19df9b66c20$var$removeLabel
    ];
    var currentSheet;
    var finalizingPlugins = [
        (0, $8SDLF.stringify),
        (0, $8SDLF.rulesheet)(function(rule) {
            currentSheet.insert(rule);
        })
    ];
    var serializer = (0, $8SDLF.middleware)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
    var stylis = function stylis(styles) {
        return (0, $8SDLF.serialize)((0, $8SDLF.compile)(styles), serializer);
    };
    _insert = function insert(selector, serialized, sheet, shouldCache) {
        currentSheet = sheet;
        stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
        if (shouldCache) cache.inserted[serialized.name] = true;
    };
    var cache = {
        key: key,
        sheet: new (0, $cjyHC.StyleSheet)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy,
            prepend: options.prepend,
            insertionPoint: options.insertionPoint
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
};

});
parcelRegister("cjyHC", function(module, exports) {

$parcel$export(module.exports, "StyleSheet", function () { return $8f722d9af4d4d346$export$9d753cd7ae895cce; });
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ // $FlowFixMe
function $8f722d9af4d4d346$var$sheetForTag(tag) {
    if (tag.sheet) // $FlowFixMe
    return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) // $FlowFixMe
        return document.styleSheets[i];
    }
}
function $8f722d9af4d4d346$var$createStyleElement(options) {
    var tag = document.createElement("style");
    tag.setAttribute("data-emotion", options.key);
    if (options.nonce !== undefined) tag.setAttribute("nonce", options.nonce);
    tag.appendChild(document.createTextNode(""));
    tag.setAttribute("data-s", "");
    return tag;
}
var $8f722d9af4d4d346$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    // Using Node instead of HTMLElement since container may be a ShadowRoot
    function StyleSheet(options) {
        var _this = this;
        this._insertTag = function(tag) {
            var before;
            if (_this.tags.length === 0) {
                if (_this.insertionPoint) before = _this.insertionPoint.nextSibling;
                else if (_this.prepend) before = _this.container.firstChild;
                else before = _this.before;
            } else before = _this.tags[_this.tags.length - 1].nextSibling;
            _this.container.insertBefore(tag, before);
            _this.tags.push(tag);
        };
        this.isSpeedy = options.speedy === undefined ? true : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.prepend = options.prepend;
        this.insertionPoint = options.insertionPoint;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.hydrate = function hydrate(nodes) {
        nodes.forEach(this._insertTag);
    };
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) this._insertTag($8f722d9af4d4d346$var$createStyleElement(this));
        var tag = this.tags[this.tags.length - 1];
        var isImportRule;
        if (this.isSpeedy) {
            var sheet = $8f722d9af4d4d346$var$sheetForTag(tag);
            try {
                // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        // $FlowFixMe
        this.tags.forEach(function(tag) {
            return tag.parentNode && tag.parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();

});

parcelRegister("8SDLF", function(module, exports) {

$parcel$export(module.exports, "MS", function () { return $13b056f6b69c32bc$export$71ad59f2e432cfe8; });
$parcel$export(module.exports, "MOZ", function () { return $13b056f6b69c32bc$export$2c0f367103c8d01c; });
$parcel$export(module.exports, "WEBKIT", function () { return $13b056f6b69c32bc$export$39dfd62a25e0fe93; });
$parcel$export(module.exports, "RULESET", function () { return $13b056f6b69c32bc$export$aa3a2e812ca8570d; });
$parcel$export(module.exports, "DECLARATION", function () { return $13b056f6b69c32bc$export$527d108ccf083c2b; });
$parcel$export(module.exports, "KEYFRAMES", function () { return $13b056f6b69c32bc$export$b44a8529a35fcb60; });
$parcel$export(module.exports, "from", function () { return $13b056f6b69c32bc$export$6788812c4e6611e6; });
$parcel$export(module.exports, "hash", function () { return $13b056f6b69c32bc$export$d6af199866bfb566; });
$parcel$export(module.exports, "charat", function () { return $13b056f6b69c32bc$export$a9db5e087081082d; });
$parcel$export(module.exports, "match", function () { return $13b056f6b69c32bc$export$4659b591c19bdf3d; });
$parcel$export(module.exports, "replace", function () { return $13b056f6b69c32bc$export$77ad94ebf1c2b9ed; });
$parcel$export(module.exports, "indexof", function () { return $13b056f6b69c32bc$export$f8e21b1e77979a08; });
$parcel$export(module.exports, "strlen", function () { return $13b056f6b69c32bc$export$36776f635604f274; });
$parcel$export(module.exports, "combine", function () { return $13b056f6b69c32bc$export$1be1fc439b849fdf; });
$parcel$export(module.exports, "position", function () { return $13b056f6b69c32bc$export$5880b8b5730aff45; });
$parcel$export(module.exports, "copy", function () { return $13b056f6b69c32bc$export$784d13d8ee351f07; });
$parcel$export(module.exports, "next", function () { return $13b056f6b69c32bc$export$48cfd1e771a65c4f; });
$parcel$export(module.exports, "peek", function () { return $13b056f6b69c32bc$export$4d3fb11e950abb9e; });
$parcel$export(module.exports, "slice", function () { return $13b056f6b69c32bc$export$58adb3bec8346d0f; });
$parcel$export(module.exports, "token", function () { return $13b056f6b69c32bc$export$9e1725a4cfeada27; });
$parcel$export(module.exports, "alloc", function () { return $13b056f6b69c32bc$export$2de70f21292aac9e; });
$parcel$export(module.exports, "dealloc", function () { return $13b056f6b69c32bc$export$45918ac1574455b1; });
$parcel$export(module.exports, "delimit", function () { return $13b056f6b69c32bc$export$410ac95b9ec204b8; });
$parcel$export(module.exports, "compile", function () { return $13b056f6b69c32bc$export$ef7acd7185315e22; });
$parcel$export(module.exports, "serialize", function () { return $13b056f6b69c32bc$export$dfdc1655ccc5b9cb; });
$parcel$export(module.exports, "stringify", function () { return $13b056f6b69c32bc$export$fac44ee5b035f737; });
$parcel$export(module.exports, "middleware", function () { return $13b056f6b69c32bc$export$5a7767152ae0305f; });
$parcel$export(module.exports, "rulesheet", function () { return $13b056f6b69c32bc$export$38bcb760f1d4871c; });
var $13b056f6b69c32bc$export$71ad59f2e432cfe8 = "-ms-";
var $13b056f6b69c32bc$export$2c0f367103c8d01c = "-moz-";
var $13b056f6b69c32bc$export$39dfd62a25e0fe93 = "-webkit-";
var $13b056f6b69c32bc$export$a29989082612d0d9 = "comm";
var $13b056f6b69c32bc$export$aa3a2e812ca8570d = "rule";
var $13b056f6b69c32bc$export$527d108ccf083c2b = "decl";
var $13b056f6b69c32bc$export$d3d35020fa5b54f0 = "@page";
var $13b056f6b69c32bc$export$500415a86c544f73 = "@media";
var $13b056f6b69c32bc$export$a763edbf796b780a = "@import";
var $13b056f6b69c32bc$export$2790aeb8b4e5c826 = "@charset";
var $13b056f6b69c32bc$export$1cc683e23b84b133 = "@viewport";
var $13b056f6b69c32bc$export$9447a5efea57e862 = "@supports";
var $13b056f6b69c32bc$export$ef011b4e114b1fba = "@document";
var $13b056f6b69c32bc$export$6aad947bda0f3f46 = "@namespace";
var $13b056f6b69c32bc$export$b44a8529a35fcb60 = "@keyframes";
var $13b056f6b69c32bc$export$2c16de31893252e6 = "@font-face";
var $13b056f6b69c32bc$export$3d846dd52e150c6f = "@counter-style";
var $13b056f6b69c32bc$export$22314bfbb57653fe = "@font-feature-values";
var $13b056f6b69c32bc$export$d773506282b3cfe6 = "@layer";
var $13b056f6b69c32bc$export$2335f513bbd82c6d = Math.abs;
var $13b056f6b69c32bc$export$6788812c4e6611e6 = String.fromCharCode;
var $13b056f6b69c32bc$export$e6e34fd1f2686227 = Object.assign;
function $13b056f6b69c32bc$export$d6af199866bfb566(e, r) {
    return $13b056f6b69c32bc$export$a9db5e087081082d(e, 0) ^ 45 ? (((r << 2 ^ $13b056f6b69c32bc$export$a9db5e087081082d(e, 0)) << 2 ^ $13b056f6b69c32bc$export$a9db5e087081082d(e, 1)) << 2 ^ $13b056f6b69c32bc$export$a9db5e087081082d(e, 2)) << 2 ^ $13b056f6b69c32bc$export$a9db5e087081082d(e, 3) : 0;
}
function $13b056f6b69c32bc$export$87c2784dc9fc4ab(e) {
    return e.trim();
}
function $13b056f6b69c32bc$export$4659b591c19bdf3d(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function $13b056f6b69c32bc$export$77ad94ebf1c2b9ed(e, r, a) {
    return e.replace(r, a);
}
function $13b056f6b69c32bc$export$f8e21b1e77979a08(e, r) {
    return e.indexOf(r);
}
function $13b056f6b69c32bc$export$a9db5e087081082d(e, r) {
    return e.charCodeAt(r) | 0;
}
function $13b056f6b69c32bc$export$2f35ab04d2335697(e, r, a) {
    return e.slice(r, a);
}
function $13b056f6b69c32bc$export$36776f635604f274(e) {
    return e.length;
}
function $13b056f6b69c32bc$export$f9084667e487ed46(e) {
    return e.length;
}
function $13b056f6b69c32bc$export$10d8903dec122b9d(e, r) {
    return r.push(e), e;
}
function $13b056f6b69c32bc$export$1be1fc439b849fdf(e, r) {
    return e.map(r).join("");
}
var $13b056f6b69c32bc$export$53f1d5ea8de3d7c = 1;
var $13b056f6b69c32bc$export$4e0c71f277ca26b3 = 1;
var $13b056f6b69c32bc$export$f24224f1c91d8156 = 0;
var $13b056f6b69c32bc$export$5880b8b5730aff45 = 0;
var $13b056f6b69c32bc$export$c0306caf338ac095 = 0;
var $13b056f6b69c32bc$export$30a86d91af8ff6e6 = "";
function $13b056f6b69c32bc$export$35059013cd4a06db(e, r, a, n, c, s, t) {
    return {
        value: e,
        root: r,
        parent: a,
        type: n,
        props: c,
        children: s,
        line: $13b056f6b69c32bc$export$53f1d5ea8de3d7c,
        column: $13b056f6b69c32bc$export$4e0c71f277ca26b3,
        length: t,
        return: ""
    };
}
function $13b056f6b69c32bc$export$784d13d8ee351f07(e, r) {
    return $13b056f6b69c32bc$export$e6e34fd1f2686227($13b056f6b69c32bc$export$35059013cd4a06db("", null, null, "", null, null, 0), e, {
        length: -e.length
    }, r);
}
function $13b056f6b69c32bc$export$eba6f6f03b0a92e7() {
    return $13b056f6b69c32bc$export$c0306caf338ac095;
}
function $13b056f6b69c32bc$export$232faf9add678146() {
    $13b056f6b69c32bc$export$c0306caf338ac095 = $13b056f6b69c32bc$export$5880b8b5730aff45 > 0 ? $13b056f6b69c32bc$export$a9db5e087081082d($13b056f6b69c32bc$export$30a86d91af8ff6e6, --$13b056f6b69c32bc$export$5880b8b5730aff45) : 0;
    if ($13b056f6b69c32bc$export$4e0c71f277ca26b3--, $13b056f6b69c32bc$export$c0306caf338ac095 === 10) $13b056f6b69c32bc$export$4e0c71f277ca26b3 = 1, $13b056f6b69c32bc$export$53f1d5ea8de3d7c--;
    return $13b056f6b69c32bc$export$c0306caf338ac095;
}
function $13b056f6b69c32bc$export$48cfd1e771a65c4f() {
    $13b056f6b69c32bc$export$c0306caf338ac095 = $13b056f6b69c32bc$export$5880b8b5730aff45 < $13b056f6b69c32bc$export$f24224f1c91d8156 ? $13b056f6b69c32bc$export$a9db5e087081082d($13b056f6b69c32bc$export$30a86d91af8ff6e6, $13b056f6b69c32bc$export$5880b8b5730aff45++) : 0;
    if ($13b056f6b69c32bc$export$4e0c71f277ca26b3++, $13b056f6b69c32bc$export$c0306caf338ac095 === 10) $13b056f6b69c32bc$export$4e0c71f277ca26b3 = 1, $13b056f6b69c32bc$export$53f1d5ea8de3d7c++;
    return $13b056f6b69c32bc$export$c0306caf338ac095;
}
function $13b056f6b69c32bc$export$4d3fb11e950abb9e() {
    return $13b056f6b69c32bc$export$a9db5e087081082d($13b056f6b69c32bc$export$30a86d91af8ff6e6, $13b056f6b69c32bc$export$5880b8b5730aff45);
}
function $13b056f6b69c32bc$export$e88cb2efb12ae807() {
    return $13b056f6b69c32bc$export$5880b8b5730aff45;
}
function $13b056f6b69c32bc$export$58adb3bec8346d0f(e, r) {
    return $13b056f6b69c32bc$export$2f35ab04d2335697($13b056f6b69c32bc$export$30a86d91af8ff6e6, e, r);
}
function $13b056f6b69c32bc$export$9e1725a4cfeada27(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $13b056f6b69c32bc$export$2de70f21292aac9e(e) {
    return $13b056f6b69c32bc$export$53f1d5ea8de3d7c = $13b056f6b69c32bc$export$4e0c71f277ca26b3 = 1, $13b056f6b69c32bc$export$f24224f1c91d8156 = $13b056f6b69c32bc$export$36776f635604f274($13b056f6b69c32bc$export$30a86d91af8ff6e6 = e), $13b056f6b69c32bc$export$5880b8b5730aff45 = 0, [];
}
function $13b056f6b69c32bc$export$45918ac1574455b1(e) {
    return $13b056f6b69c32bc$export$30a86d91af8ff6e6 = "", e;
}
function $13b056f6b69c32bc$export$410ac95b9ec204b8(e) {
    return $13b056f6b69c32bc$export$87c2784dc9fc4ab($13b056f6b69c32bc$export$58adb3bec8346d0f($13b056f6b69c32bc$export$5880b8b5730aff45 - 1, $13b056f6b69c32bc$export$c889f2fcc19dbf12(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function $13b056f6b69c32bc$export$660b2ee2d4fb4eff(e) {
    return $13b056f6b69c32bc$export$45918ac1574455b1($13b056f6b69c32bc$export$5f8c09e3ae6f64e1($13b056f6b69c32bc$export$2de70f21292aac9e(e)));
}
function $13b056f6b69c32bc$export$7af1228ff777d175(e) {
    while($13b056f6b69c32bc$export$c0306caf338ac095 = $13b056f6b69c32bc$export$4d3fb11e950abb9e())if ($13b056f6b69c32bc$export$c0306caf338ac095 < 33) $13b056f6b69c32bc$export$48cfd1e771a65c4f();
    else break;
    return $13b056f6b69c32bc$export$9e1725a4cfeada27(e) > 2 || $13b056f6b69c32bc$export$9e1725a4cfeada27($13b056f6b69c32bc$export$c0306caf338ac095) > 3 ? "" : " ";
}
function $13b056f6b69c32bc$export$5f8c09e3ae6f64e1(e) {
    while($13b056f6b69c32bc$export$48cfd1e771a65c4f())switch($13b056f6b69c32bc$export$9e1725a4cfeada27($13b056f6b69c32bc$export$c0306caf338ac095)){
        case 0:
            $13b056f6b69c32bc$export$10d8903dec122b9d($13b056f6b69c32bc$export$c2ab62c7bf24634($13b056f6b69c32bc$export$5880b8b5730aff45 - 1), e);
            break;
        case 2:
            $13b056f6b69c32bc$export$10d8903dec122b9d($13b056f6b69c32bc$export$410ac95b9ec204b8($13b056f6b69c32bc$export$c0306caf338ac095), e);
            break;
        default:
            $13b056f6b69c32bc$export$10d8903dec122b9d($13b056f6b69c32bc$export$6788812c4e6611e6($13b056f6b69c32bc$export$c0306caf338ac095), e);
    }
    return e;
}
function $13b056f6b69c32bc$export$955ba06d119e085e(e, r) {
    while(--r && $13b056f6b69c32bc$export$48cfd1e771a65c4f())if ($13b056f6b69c32bc$export$c0306caf338ac095 < 48 || $13b056f6b69c32bc$export$c0306caf338ac095 > 102 || $13b056f6b69c32bc$export$c0306caf338ac095 > 57 && $13b056f6b69c32bc$export$c0306caf338ac095 < 65 || $13b056f6b69c32bc$export$c0306caf338ac095 > 70 && $13b056f6b69c32bc$export$c0306caf338ac095 < 97) break;
    return $13b056f6b69c32bc$export$58adb3bec8346d0f(e, $13b056f6b69c32bc$export$e88cb2efb12ae807() + (r < 6 && $13b056f6b69c32bc$export$4d3fb11e950abb9e() == 32 && $13b056f6b69c32bc$export$48cfd1e771a65c4f() == 32));
}
function $13b056f6b69c32bc$export$c889f2fcc19dbf12(e) {
    while($13b056f6b69c32bc$export$48cfd1e771a65c4f())switch($13b056f6b69c32bc$export$c0306caf338ac095){
        case e:
            return $13b056f6b69c32bc$export$5880b8b5730aff45;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) $13b056f6b69c32bc$export$c889f2fcc19dbf12($13b056f6b69c32bc$export$c0306caf338ac095);
            break;
        case 40:
            if (e === 41) $13b056f6b69c32bc$export$c889f2fcc19dbf12(e);
            break;
        case 92:
            $13b056f6b69c32bc$export$48cfd1e771a65c4f();
            break;
    }
    return $13b056f6b69c32bc$export$5880b8b5730aff45;
}
function $13b056f6b69c32bc$export$4254d4e2b3745c4c(e, r) {
    while($13b056f6b69c32bc$export$48cfd1e771a65c4f())if (e + $13b056f6b69c32bc$export$c0306caf338ac095 === 57) break;
    else if (e + $13b056f6b69c32bc$export$c0306caf338ac095 === 84 && $13b056f6b69c32bc$export$4d3fb11e950abb9e() === 47) break;
    return "/*" + $13b056f6b69c32bc$export$58adb3bec8346d0f(r, $13b056f6b69c32bc$export$5880b8b5730aff45 - 1) + "*" + $13b056f6b69c32bc$export$6788812c4e6611e6(e === 47 ? e : $13b056f6b69c32bc$export$48cfd1e771a65c4f());
}
function $13b056f6b69c32bc$export$c2ab62c7bf24634(e) {
    while(!$13b056f6b69c32bc$export$9e1725a4cfeada27($13b056f6b69c32bc$export$4d3fb11e950abb9e()))$13b056f6b69c32bc$export$48cfd1e771a65c4f();
    return $13b056f6b69c32bc$export$58adb3bec8346d0f(e, $13b056f6b69c32bc$export$5880b8b5730aff45);
}
function $13b056f6b69c32bc$export$ef7acd7185315e22(e) {
    return $13b056f6b69c32bc$export$45918ac1574455b1($13b056f6b69c32bc$export$98e6a39c04603d36("", null, null, null, [
        ""
    ], e = $13b056f6b69c32bc$export$2de70f21292aac9e(e), 0, [
        0
    ], e));
}
function $13b056f6b69c32bc$export$98e6a39c04603d36(e, r, a, n, c, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var v = 0;
    var p = 0;
    var h = 0;
    var b = 1;
    var w = 1;
    var d = 1;
    var $ = 0;
    var g = "";
    var m = c;
    var x = s;
    var y = n;
    var j = g;
    while(w)switch(h = $, $ = $13b056f6b69c32bc$export$48cfd1e771a65c4f()){
        case 40:
            if (h != 108 && $13b056f6b69c32bc$export$a9db5e087081082d(j, l - 1) == 58) {
                if ($13b056f6b69c32bc$export$f8e21b1e77979a08(j += $13b056f6b69c32bc$export$77ad94ebf1c2b9ed($13b056f6b69c32bc$export$410ac95b9ec204b8($), "&", "&\f"), "&\f") != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            j += $13b056f6b69c32bc$export$410ac95b9ec204b8($);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            j += $13b056f6b69c32bc$export$7af1228ff777d175(h);
            break;
        case 92:
            j += $13b056f6b69c32bc$export$955ba06d119e085e($13b056f6b69c32bc$export$e88cb2efb12ae807() - 1, 7);
            continue;
        case 47:
            switch($13b056f6b69c32bc$export$4d3fb11e950abb9e()){
                case 42:
                case 47:
                    $13b056f6b69c32bc$export$10d8903dec122b9d($13b056f6b69c32bc$export$4a34f930e789283c($13b056f6b69c32bc$export$4254d4e2b3745c4c($13b056f6b69c32bc$export$48cfd1e771a65c4f(), $13b056f6b69c32bc$export$e88cb2efb12ae807()), r, a), i);
                    break;
                default:
                    j += "/";
            }
            break;
        case 123 * b:
            u[f++] = $13b056f6b69c32bc$export$36776f635604f274(j) * d;
        case 125 * b:
        case 59:
        case 0:
            switch($){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) j = $13b056f6b69c32bc$export$77ad94ebf1c2b9ed(j, /\f/g, "");
                    if (p > 0 && $13b056f6b69c32bc$export$36776f635604f274(j) - l) $13b056f6b69c32bc$export$10d8903dec122b9d(p > 32 ? $13b056f6b69c32bc$export$f8483753829ec8f3(j + ";", n, a, l - 1) : $13b056f6b69c32bc$export$f8483753829ec8f3($13b056f6b69c32bc$export$77ad94ebf1c2b9ed(j, " ", "") + ";", n, a, l - 2), i);
                    break;
                case 59:
                    j += ";";
                default:
                    $13b056f6b69c32bc$export$10d8903dec122b9d(y = $13b056f6b69c32bc$export$3307ffa7023ede1e(j, r, a, f, o, c, u, g, m = [], x = [], l), s);
                    if ($ === 123) {
                        if (o === 0) $13b056f6b69c32bc$export$98e6a39c04603d36(j, r, y, y, m, s, l, u, x);
                        else switch(v === 99 && $13b056f6b69c32bc$export$a9db5e087081082d(j, 3) === 110 ? 100 : v){
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $13b056f6b69c32bc$export$98e6a39c04603d36(e, y, y, n && $13b056f6b69c32bc$export$10d8903dec122b9d($13b056f6b69c32bc$export$3307ffa7023ede1e(e, y, y, 0, 0, c, u, g, c, m = [], l), x), c, x, l, u, n ? m : x);
                                break;
                            default:
                                $13b056f6b69c32bc$export$98e6a39c04603d36(j, y, y, y, [
                                    ""
                                ], x, 0, u, x);
                        }
                    }
            }
            f = o = p = 0, b = d = 1, g = j = "", l = t;
            break;
        case 58:
            l = 1 + $13b056f6b69c32bc$export$36776f635604f274(j), p = h;
        default:
            if (b < 1) {
                if ($ == 123) --b;
                else if ($ == 125 && b++ == 0 && $13b056f6b69c32bc$export$232faf9add678146() == 125) continue;
            }
            switch(j += $13b056f6b69c32bc$export$6788812c4e6611e6($), $ * b){
                case 38:
                    d = o > 0 ? 1 : (j += "\f", -1);
                    break;
                case 44:
                    u[f++] = ($13b056f6b69c32bc$export$36776f635604f274(j) - 1) * d, d = 1;
                    break;
                case 64:
                    if ($13b056f6b69c32bc$export$4d3fb11e950abb9e() === 45) j += $13b056f6b69c32bc$export$410ac95b9ec204b8($13b056f6b69c32bc$export$48cfd1e771a65c4f());
                    v = $13b056f6b69c32bc$export$4d3fb11e950abb9e(), o = l = $13b056f6b69c32bc$export$36776f635604f274(g = j += $13b056f6b69c32bc$export$c2ab62c7bf24634($13b056f6b69c32bc$export$e88cb2efb12ae807())), $++;
                    break;
                case 45:
                    if (h === 45 && $13b056f6b69c32bc$export$36776f635604f274(j) == 2) b = 0;
            }
    }
    return s;
}
function $13b056f6b69c32bc$export$3307ffa7023ede1e(e, r, a, n, s, t, u, i, f, o, l) {
    var v = s - 1;
    var p = s === 0 ? t : [
        ""
    ];
    var h = $13b056f6b69c32bc$export$f9084667e487ed46(p);
    for(var b = 0, w = 0, d = 0; b < n; ++b)for(var $ = 0, k = $13b056f6b69c32bc$export$2f35ab04d2335697(e, v + 1, v = $13b056f6b69c32bc$export$2335f513bbd82c6d(w = u[b])), m = e; $ < h; ++$)if (m = $13b056f6b69c32bc$export$87c2784dc9fc4ab(w > 0 ? p[$] + " " + k : $13b056f6b69c32bc$export$77ad94ebf1c2b9ed(k, /&\f/g, p[$]))) f[d++] = m;
    return $13b056f6b69c32bc$export$35059013cd4a06db(e, r, a, s === 0 ? $13b056f6b69c32bc$export$aa3a2e812ca8570d : i, f, o, l);
}
function $13b056f6b69c32bc$export$4a34f930e789283c(e, r, a) {
    return $13b056f6b69c32bc$export$35059013cd4a06db(e, r, a, $13b056f6b69c32bc$export$a29989082612d0d9, $13b056f6b69c32bc$export$6788812c4e6611e6($13b056f6b69c32bc$export$eba6f6f03b0a92e7()), $13b056f6b69c32bc$export$2f35ab04d2335697(e, 2, -2), 0);
}
function $13b056f6b69c32bc$export$f8483753829ec8f3(e, r, a, n) {
    return $13b056f6b69c32bc$export$35059013cd4a06db(e, r, a, $13b056f6b69c32bc$export$527d108ccf083c2b, $13b056f6b69c32bc$export$2f35ab04d2335697(e, 0, n), $13b056f6b69c32bc$export$2f35ab04d2335697(e, n + 1, -1), n);
}
function $13b056f6b69c32bc$export$82e9f45cca5ba907(n, c, s) {
    switch($13b056f6b69c32bc$export$d6af199866bfb566(n, c)){
        case 5103:
            return $13b056f6b69c32bc$export$39dfd62a25e0fe93 + "print-" + n + n;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return $13b056f6b69c32bc$export$39dfd62a25e0fe93 + n + n;
        case 4789:
            return $13b056f6b69c32bc$export$2c0f367103c8d01c + n + n;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return $13b056f6b69c32bc$export$39dfd62a25e0fe93 + n + $13b056f6b69c32bc$export$2c0f367103c8d01c + n + $13b056f6b69c32bc$export$71ad59f2e432cfe8 + n + n;
        case 5936:
            switch($13b056f6b69c32bc$export$a9db5e087081082d(n, c + 11)){
                case 114:
                    return $13b056f6b69c32bc$export$39dfd62a25e0fe93 + n + $13b056f6b69c32bc$export$71ad59f2e432cfe8 + $13b056f6b69c32bc$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb") + n;
                case 108:
                    return $13b056f6b69c32bc$export$39dfd62a25e0fe93 + n + $13b056f6b69c32bc$export$71ad59f2e432cfe8 + $13b056f6b69c32bc$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb-rl") + n;
                case 45:
                    return $13b056f6b69c32bc$export$39dfd62a25e0fe93 + n + $13b056f6b69c32bc$export$71ad59f2e432cfe8 + $13b056f6b69c32bc$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "lr") + n;
            }
        case 6828:
        case 4268:
        case 2903:
            return $13b056f6b69c32bc$export$39dfd62a25e0fe93 + n + $13b056f6b69c32bc$export$71ad59f2e432cfe8 + n + n;
        case 6165:
            return $13b056f6b69c32bc$export$39dfd62a25e0fe93 + n + $13b056f6b69c32bc$export$71ad59f2e432cfe8 + "flex-" + n + n;
        case 5187:
            return $13b056f6b69c32bc$export$39dfd62a25e0fe93 + n + $13b056f6b69c32bc$export$77ad94ebf1c2b9ed(n, /(\w+).+(:[^]+)/, $13b056f6b69c32bc$export$39dfd62a25e0fe93 + "box-$1$2" + $13b056f6b69c32bc$export$71ad59f2e432cfe8 + "flex-$1$2") + n;
        case 5443:
            return $13b056f6b69c32bc$export$39dfd62a25e0fe93 + n + $13b056f6b69c32bc$export$71ad59f2e432cfe8 + "flex-item-" + $13b056f6b69c32bc$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") + (!$13b056f6b69c32bc$export$4659b591c19bdf3d(n, /flex-|baseline/) ? $13b056f6b69c32bc$export$71ad59f2e432cfe8 + "grid-row-" + $13b056f6b69c32bc$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") : "") + n;
        case 4675:
            return $13b056f6b69c32bc$export$39dfd62a25e0fe93 + n + $13b056f6b69c32bc$export$71ad59f2e432cfe8 + "flex-line-pack" + $13b056f6b69c32bc$export$77ad94ebf1c2b9ed(n, /align-content|flex-|-self/g, "") + n;
        case 5548:
            return $13b056f6b69c32bc$export$39dfd62a25e0fe93 + n + $13b056f6b69c32bc$export$71ad59f2e432cfe8 + $13b056f6b69c32bc$export$77ad94ebf1c2b9ed(n, "shrink", "negative") + n;
        case 5292:
            return $13b056f6b69c32bc$export$39dfd62a25e0fe93 + n + $13b056f6b69c32bc$export$71ad59f2e432cfe8 + $13b056f6b69c32bc$export$77ad94ebf1c2b9ed(n, "basis", "preferred-size") + n;
        case 6060:
            return $13b056f6b69c32bc$export$39dfd62a25e0fe93 + "box-" + $13b056f6b69c32bc$export$77ad94ebf1c2b9ed(n, "-grow", "") + $13b056f6b69c32bc$export$39dfd62a25e0fe93 + n + $13b056f6b69c32bc$export$71ad59f2e432cfe8 + $13b056f6b69c32bc$export$77ad94ebf1c2b9ed(n, "grow", "positive") + n;
        case 4554:
            return $13b056f6b69c32bc$export$39dfd62a25e0fe93 + $13b056f6b69c32bc$export$77ad94ebf1c2b9ed(n, /([^-])(transform)/g, "$1" + $13b056f6b69c32bc$export$39dfd62a25e0fe93 + "$2") + n;
        case 6187:
            return $13b056f6b69c32bc$export$77ad94ebf1c2b9ed($13b056f6b69c32bc$export$77ad94ebf1c2b9ed($13b056f6b69c32bc$export$77ad94ebf1c2b9ed(n, /(zoom-|grab)/, $13b056f6b69c32bc$export$39dfd62a25e0fe93 + "$1"), /(image-set)/, $13b056f6b69c32bc$export$39dfd62a25e0fe93 + "$1"), n, "") + n;
        case 5495:
        case 3959:
            return $13b056f6b69c32bc$export$77ad94ebf1c2b9ed(n, /(image-set\([^]*)/, $13b056f6b69c32bc$export$39dfd62a25e0fe93 + "$1" + "$`$1");
        case 4968:
            return $13b056f6b69c32bc$export$77ad94ebf1c2b9ed($13b056f6b69c32bc$export$77ad94ebf1c2b9ed(n, /(.+:)(flex-)?(.*)/, $13b056f6b69c32bc$export$39dfd62a25e0fe93 + "box-pack:$3" + $13b056f6b69c32bc$export$71ad59f2e432cfe8 + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + $13b056f6b69c32bc$export$39dfd62a25e0fe93 + n + n;
        case 4200:
            if (!$13b056f6b69c32bc$export$4659b591c19bdf3d(n, /flex-|baseline/)) return $13b056f6b69c32bc$export$71ad59f2e432cfe8 + "grid-column-align" + $13b056f6b69c32bc$export$2f35ab04d2335697(n, c) + n;
            break;
        case 2592:
        case 3360:
            return $13b056f6b69c32bc$export$71ad59f2e432cfe8 + $13b056f6b69c32bc$export$77ad94ebf1c2b9ed(n, "template-", "") + n;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return c = r, $13b056f6b69c32bc$export$4659b591c19bdf3d(e.props, /grid-\w+-end/);
            })) return ~$13b056f6b69c32bc$export$f8e21b1e77979a08(n + (s = s[c].value), "span") ? n : $13b056f6b69c32bc$export$71ad59f2e432cfe8 + $13b056f6b69c32bc$export$77ad94ebf1c2b9ed(n, "-start", "") + n + $13b056f6b69c32bc$export$71ad59f2e432cfe8 + "grid-row-span:" + (~$13b056f6b69c32bc$export$f8e21b1e77979a08(s, "span") ? $13b056f6b69c32bc$export$4659b591c19bdf3d(s, /\d+/) : +$13b056f6b69c32bc$export$4659b591c19bdf3d(s, /\d+/) - +$13b056f6b69c32bc$export$4659b591c19bdf3d(n, /\d+/)) + ";";
            return $13b056f6b69c32bc$export$71ad59f2e432cfe8 + $13b056f6b69c32bc$export$77ad94ebf1c2b9ed(n, "-start", "") + n;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return $13b056f6b69c32bc$export$4659b591c19bdf3d(e.props, /grid-\w+-start/);
            }) ? n : $13b056f6b69c32bc$export$71ad59f2e432cfe8 + $13b056f6b69c32bc$export$77ad94ebf1c2b9ed($13b056f6b69c32bc$export$77ad94ebf1c2b9ed(n, "-end", "-span"), "span ", "") + n;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return $13b056f6b69c32bc$export$77ad94ebf1c2b9ed(n, /(.+)-inline(.+)/, $13b056f6b69c32bc$export$39dfd62a25e0fe93 + "$1$2") + n;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if ($13b056f6b69c32bc$export$36776f635604f274(n) - 1 - c > 6) switch($13b056f6b69c32bc$export$a9db5e087081082d(n, c + 1)){
                case 109:
                    if ($13b056f6b69c32bc$export$a9db5e087081082d(n, c + 4) !== 45) break;
                case 102:
                    return $13b056f6b69c32bc$export$77ad94ebf1c2b9ed(n, /(.+:)(.+)-([^]+)/, "$1" + $13b056f6b69c32bc$export$39dfd62a25e0fe93 + "$2-$3" + "$1" + $13b056f6b69c32bc$export$2c0f367103c8d01c + ($13b056f6b69c32bc$export$a9db5e087081082d(n, c + 3) == 108 ? "$3" : "$2-$3")) + n;
                case 115:
                    return ~$13b056f6b69c32bc$export$f8e21b1e77979a08(n, "stretch") ? $13b056f6b69c32bc$export$82e9f45cca5ba907($13b056f6b69c32bc$export$77ad94ebf1c2b9ed(n, "stretch", "fill-available"), c, s) + n : n;
            }
            break;
        case 5152:
        case 5920:
            return $13b056f6b69c32bc$export$77ad94ebf1c2b9ed(n, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, c, s, t, u, i) {
                return $13b056f6b69c32bc$export$71ad59f2e432cfe8 + a + ":" + c + i + (s ? $13b056f6b69c32bc$export$71ad59f2e432cfe8 + a + "-span:" + (t ? u : +u - +c) + i : "") + n;
            });
        case 4949:
            if ($13b056f6b69c32bc$export$a9db5e087081082d(n, c + 6) === 121) return $13b056f6b69c32bc$export$77ad94ebf1c2b9ed(n, ":", ":" + $13b056f6b69c32bc$export$39dfd62a25e0fe93) + n;
            break;
        case 6444:
            switch($13b056f6b69c32bc$export$a9db5e087081082d(n, $13b056f6b69c32bc$export$a9db5e087081082d(n, 14) === 45 ? 18 : 11)){
                case 120:
                    return $13b056f6b69c32bc$export$77ad94ebf1c2b9ed(n, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + $13b056f6b69c32bc$export$39dfd62a25e0fe93 + ($13b056f6b69c32bc$export$a9db5e087081082d(n, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + $13b056f6b69c32bc$export$39dfd62a25e0fe93 + "$2$3" + "$1" + $13b056f6b69c32bc$export$71ad59f2e432cfe8 + "$2box$3") + n;
                case 100:
                    return $13b056f6b69c32bc$export$77ad94ebf1c2b9ed(n, ":", ":" + $13b056f6b69c32bc$export$71ad59f2e432cfe8) + n;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return $13b056f6b69c32bc$export$77ad94ebf1c2b9ed(n, "scroll-", "scroll-snap-") + n;
    }
    return n;
}
function $13b056f6b69c32bc$export$dfdc1655ccc5b9cb(e, r) {
    var a = "";
    var n = $13b056f6b69c32bc$export$f9084667e487ed46(e);
    for(var c = 0; c < n; c++)a += r(e[c], c, e, r) || "";
    return a;
}
function $13b056f6b69c32bc$export$fac44ee5b035f737(e, r, a, t) {
    switch(e.type){
        case $13b056f6b69c32bc$export$d773506282b3cfe6:
            if (e.children.length) break;
        case $13b056f6b69c32bc$export$a763edbf796b780a:
        case $13b056f6b69c32bc$export$527d108ccf083c2b:
            return e.return = e.return || e.value;
        case $13b056f6b69c32bc$export$a29989082612d0d9:
            return "";
        case $13b056f6b69c32bc$export$b44a8529a35fcb60:
            return e.return = e.value + "{" + $13b056f6b69c32bc$export$dfdc1655ccc5b9cb(e.children, t) + "}";
        case $13b056f6b69c32bc$export$aa3a2e812ca8570d:
            e.value = e.props.join(",");
    }
    return $13b056f6b69c32bc$export$36776f635604f274(a = $13b056f6b69c32bc$export$dfdc1655ccc5b9cb(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function $13b056f6b69c32bc$export$5a7767152ae0305f(e) {
    var r = $13b056f6b69c32bc$export$f9084667e487ed46(e);
    return function(a, n, c, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, n, c, s) || "";
        return t;
    };
}
function $13b056f6b69c32bc$export$38bcb760f1d4871c(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function $13b056f6b69c32bc$export$e08c7d021b829b7a(n, t, u, i) {
    if (n.length > -1) {
        if (!n.return) switch(n.type){
            case $13b056f6b69c32bc$export$527d108ccf083c2b:
                n.return = $13b056f6b69c32bc$export$82e9f45cca5ba907(n.value, n.length, u);
                return;
            case $13b056f6b69c32bc$export$b44a8529a35fcb60:
                return $13b056f6b69c32bc$export$dfdc1655ccc5b9cb([
                    $13b056f6b69c32bc$export$784d13d8ee351f07(n, {
                        value: $13b056f6b69c32bc$export$77ad94ebf1c2b9ed(n.value, "@", "@" + $13b056f6b69c32bc$export$39dfd62a25e0fe93)
                    })
                ], i);
            case $13b056f6b69c32bc$export$aa3a2e812ca8570d:
                if (n.length) return $13b056f6b69c32bc$export$1be1fc439b849fdf(n.props, function(c) {
                    switch($13b056f6b69c32bc$export$4659b591c19bdf3d(c, /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            return $13b056f6b69c32bc$export$dfdc1655ccc5b9cb([
                                $13b056f6b69c32bc$export$784d13d8ee351f07(n, {
                                    props: [
                                        $13b056f6b69c32bc$export$77ad94ebf1c2b9ed(c, /:(read-\w+)/, ":" + $13b056f6b69c32bc$export$2c0f367103c8d01c + "$1")
                                    ]
                                })
                            ], i);
                        case "::placeholder":
                            return $13b056f6b69c32bc$export$dfdc1655ccc5b9cb([
                                $13b056f6b69c32bc$export$784d13d8ee351f07(n, {
                                    props: [
                                        $13b056f6b69c32bc$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $13b056f6b69c32bc$export$39dfd62a25e0fe93 + "input-$1")
                                    ]
                                }),
                                $13b056f6b69c32bc$export$784d13d8ee351f07(n, {
                                    props: [
                                        $13b056f6b69c32bc$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $13b056f6b69c32bc$export$2c0f367103c8d01c + "$1")
                                    ]
                                }),
                                $13b056f6b69c32bc$export$784d13d8ee351f07(n, {
                                    props: [
                                        $13b056f6b69c32bc$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, $13b056f6b69c32bc$export$71ad59f2e432cfe8 + "input-$1")
                                    ]
                                })
                            ], i);
                    }
                    return "";
                });
        }
    }
}
function $13b056f6b69c32bc$export$76a88f7de6507443(e) {
    switch(e.type){
        case $13b056f6b69c32bc$export$aa3a2e812ca8570d:
            e.props = e.props.map(function(r) {
                return $13b056f6b69c32bc$export$1be1fc439b849fdf($13b056f6b69c32bc$export$660b2ee2d4fb4eff(r), function(r, a, n) {
                    switch($13b056f6b69c32bc$export$a9db5e087081082d(r, 0)){
                        case 12:
                            return $13b056f6b69c32bc$export$2f35ab04d2335697(r, 1, $13b056f6b69c32bc$export$36776f635604f274(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (n[++a] === "global") n[a] = "", n[++a] = "\f" + $13b056f6b69c32bc$export$2f35ab04d2335697(n[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return $13b056f6b69c32bc$export$f9084667e487ed46(n) > 1 ? "" : r;
                                case a = $13b056f6b69c32bc$export$f9084667e487ed46(n) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}

});

parcelRegister("6q2Od", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4ac759958d9264be$export$2e2bcd8739ae039; });
var $4ac759958d9264be$export$2e2bcd8739ae039 = function weakMemoize(func) {
    // $FlowFixMe flow doesn't include all non-primitive types as allowed for weakmaps
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // $FlowFixMe
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};

});

parcelRegister("d5hMW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $98698a5e781a3a77$export$2e2bcd8739ae039; });
function $98698a5e781a3a77$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});


parcelRegister("h4XE0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c6f1137fdd741ee5$export$2e2bcd8739ae039; });
function $c6f1137fdd741ee5$export$2e2bcd8739ae039() {
    return $c6f1137fdd741ee5$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $c6f1137fdd741ee5$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("eU7V2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ad9c7036cfd04fbc$export$2e2bcd8739ae039; });

var $3ojZ1 = parcelRequire("3ojZ1");
// this file isolates this package that is not tree-shakeable
// and if this module doesn't actually contain any logic of its own
// then Rollup just use 'hoist-non-react-statics' directly in other chunks
var $ad9c7036cfd04fbc$export$2e2bcd8739ae039 = function(targetComponent, sourceComponent) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($3ojZ1)))(targetComponent, sourceComponent);
};

});
parcelRegister("3ojZ1", function(module, exports) {
"use strict";

var $BE9NW = parcelRequire("BE9NW");
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $27831d414646f384$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $27831d414646f384$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $27831d414646f384$var$FORWARD_REF_STATICS = {
    "$$typeof": true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $27831d414646f384$var$MEMO_STATICS = {
    "$$typeof": true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $27831d414646f384$var$TYPE_STATICS = {};
$27831d414646f384$var$TYPE_STATICS[$BE9NW.ForwardRef] = $27831d414646f384$var$FORWARD_REF_STATICS;
$27831d414646f384$var$TYPE_STATICS[$BE9NW.Memo] = $27831d414646f384$var$MEMO_STATICS;
function $27831d414646f384$var$getStatics(component) {
    // React v16.11 and below
    if ($BE9NW.isMemo(component)) return $27831d414646f384$var$MEMO_STATICS;
     // React v16.12 and above
    return $27831d414646f384$var$TYPE_STATICS[component["$$typeof"]] || $27831d414646f384$var$REACT_STATICS;
}
var $27831d414646f384$var$defineProperty = Object.defineProperty;
var $27831d414646f384$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $27831d414646f384$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $27831d414646f384$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $27831d414646f384$var$getPrototypeOf = Object.getPrototypeOf;
var $27831d414646f384$var$objectPrototype = Object.prototype;
function $27831d414646f384$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== "string") {
        // don't hoist over string (html) components
        if ($27831d414646f384$var$objectPrototype) {
            var inheritedComponent = $27831d414646f384$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $27831d414646f384$var$objectPrototype) $27831d414646f384$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $27831d414646f384$var$getOwnPropertyNames(sourceComponent);
        if ($27831d414646f384$var$getOwnPropertySymbols) keys = keys.concat($27831d414646f384$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $27831d414646f384$var$getStatics(targetComponent);
        var sourceStatics = $27831d414646f384$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$27831d414646f384$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $27831d414646f384$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $27831d414646f384$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
module.exports = $27831d414646f384$var$hoistNonReactStatics;

});
parcelRegister("BE9NW", function(module, exports) {
"use strict";

module.exports = (parcelRequire("cymWn"));

});
parcelRegister("cymWn", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", function () { return $923a7487eec9c745$export$2b8d127b894957b9; }, function (v) { return $923a7487eec9c745$export$2b8d127b894957b9 = v; });
$parcel$export(module.exports, "ConcurrentMode", function () { return $923a7487eec9c745$export$cea3a54a6425200c; }, function (v) { return $923a7487eec9c745$export$cea3a54a6425200c = v; });
$parcel$export(module.exports, "ContextConsumer", function () { return $923a7487eec9c745$export$a7c73072b1a182ae; }, function (v) { return $923a7487eec9c745$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $923a7487eec9c745$export$9f27bc3417b4524d; }, function (v) { return $923a7487eec9c745$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $923a7487eec9c745$export$db77ccec0bb4ccac; }, function (v) { return $923a7487eec9c745$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $923a7487eec9c745$export$8392c0c9d3dcbd35; }, function (v) { return $923a7487eec9c745$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $923a7487eec9c745$export$ffb0004e005737fa; }, function (v) { return $923a7487eec9c745$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $923a7487eec9c745$export$b624eff549462981; }, function (v) { return $923a7487eec9c745$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $923a7487eec9c745$export$7897aa7841a5380c; }, function (v) { return $923a7487eec9c745$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $923a7487eec9c745$export$602eac185826482c; }, function (v) { return $923a7487eec9c745$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $923a7487eec9c745$export$e2c29f18771995cb; }, function (v) { return $923a7487eec9c745$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $923a7487eec9c745$export$5f8d39834fd61797; }, function (v) { return $923a7487eec9c745$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $923a7487eec9c745$export$74bf444e3cd11ea5; }, function (v) { return $923a7487eec9c745$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $923a7487eec9c745$export$92387174baf9b227; }, function (v) { return $923a7487eec9c745$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $923a7487eec9c745$export$ec112efeb987d9c6; }, function (v) { return $923a7487eec9c745$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $923a7487eec9c745$export$b706b080d889d2c9; }, function (v) { return $923a7487eec9c745$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $923a7487eec9c745$export$5be5a87408f70ddc; }, function (v) { return $923a7487eec9c745$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $923a7487eec9c745$export$45a5e7f76e0caa8d; }, function (v) { return $923a7487eec9c745$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $923a7487eec9c745$export$455c2e768291efa6; }, function (v) { return $923a7487eec9c745$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $923a7487eec9c745$export$9522e17588c12572; }, function (v) { return $923a7487eec9c745$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $923a7487eec9c745$export$2110ac352bb060b9; }, function (v) { return $923a7487eec9c745$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $923a7487eec9c745$export$56885ab8b9c456ab; }, function (v) { return $923a7487eec9c745$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $923a7487eec9c745$export$d927fcb6adf8f9de; }, function (v) { return $923a7487eec9c745$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $923a7487eec9c745$export$b82d16f27459e05a; }, function (v) { return $923a7487eec9c745$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $923a7487eec9c745$export$522c17b4f5e123e8; }, function (v) { return $923a7487eec9c745$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $923a7487eec9c745$export$1aabd8a0274ecfd6; }, function (v) { return $923a7487eec9c745$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $923a7487eec9c745$export$9b621391a187a31a; }, function (v) { return $923a7487eec9c745$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $923a7487eec9c745$export$f5bbd400c2f4426f; }, function (v) { return $923a7487eec9c745$export$f5bbd400c2f4426f = v; });
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $923a7487eec9c745$export$2b8d127b894957b9;
var $923a7487eec9c745$export$cea3a54a6425200c;
var $923a7487eec9c745$export$a7c73072b1a182ae;
var $923a7487eec9c745$export$9f27bc3417b4524d;
var $923a7487eec9c745$export$db77ccec0bb4ccac;
var $923a7487eec9c745$export$8392c0c9d3dcbd35;
var $923a7487eec9c745$export$ffb0004e005737fa;
var $923a7487eec9c745$export$b624eff549462981;
var $923a7487eec9c745$export$7897aa7841a5380c;
var $923a7487eec9c745$export$602eac185826482c;
var $923a7487eec9c745$export$e2c29f18771995cb;
var $923a7487eec9c745$export$5f8d39834fd61797;
var $923a7487eec9c745$export$74bf444e3cd11ea5;
var $923a7487eec9c745$export$92387174baf9b227;
var $923a7487eec9c745$export$ec112efeb987d9c6;
var $923a7487eec9c745$export$b706b080d889d2c9;
var $923a7487eec9c745$export$5be5a87408f70ddc;
var $923a7487eec9c745$export$45a5e7f76e0caa8d;
var $923a7487eec9c745$export$455c2e768291efa6;
var $923a7487eec9c745$export$9522e17588c12572;
var $923a7487eec9c745$export$2110ac352bb060b9;
var $923a7487eec9c745$export$56885ab8b9c456ab;
var $923a7487eec9c745$export$d927fcb6adf8f9de;
var $923a7487eec9c745$export$b82d16f27459e05a;
var $923a7487eec9c745$export$522c17b4f5e123e8;
var $923a7487eec9c745$export$1aabd8a0274ecfd6;
var $923a7487eec9c745$export$9b621391a187a31a;
var $923a7487eec9c745$export$f5bbd400c2f4426f;
"use strict";
var $923a7487eec9c745$var$b = "function" === typeof Symbol && Symbol.for, $923a7487eec9c745$var$c = $923a7487eec9c745$var$b ? Symbol.for("react.element") : 60103, $923a7487eec9c745$var$d = $923a7487eec9c745$var$b ? Symbol.for("react.portal") : 60106, $923a7487eec9c745$var$e = $923a7487eec9c745$var$b ? Symbol.for("react.fragment") : 60107, $923a7487eec9c745$var$f = $923a7487eec9c745$var$b ? Symbol.for("react.strict_mode") : 60108, $923a7487eec9c745$var$g = $923a7487eec9c745$var$b ? Symbol.for("react.profiler") : 60114, $923a7487eec9c745$var$h = $923a7487eec9c745$var$b ? Symbol.for("react.provider") : 60109, $923a7487eec9c745$var$k = $923a7487eec9c745$var$b ? Symbol.for("react.context") : 60110, $923a7487eec9c745$var$l = $923a7487eec9c745$var$b ? Symbol.for("react.async_mode") : 60111, $923a7487eec9c745$var$m = $923a7487eec9c745$var$b ? Symbol.for("react.concurrent_mode") : 60111, $923a7487eec9c745$var$n = $923a7487eec9c745$var$b ? Symbol.for("react.forward_ref") : 60112, $923a7487eec9c745$var$p = $923a7487eec9c745$var$b ? Symbol.for("react.suspense") : 60113, $923a7487eec9c745$var$q = $923a7487eec9c745$var$b ? Symbol.for("react.suspense_list") : 60120, $923a7487eec9c745$var$r = $923a7487eec9c745$var$b ? Symbol.for("react.memo") : 60115, $923a7487eec9c745$var$t = $923a7487eec9c745$var$b ? Symbol.for("react.lazy") : 60116, $923a7487eec9c745$var$v = $923a7487eec9c745$var$b ? Symbol.for("react.block") : 60121, $923a7487eec9c745$var$w = $923a7487eec9c745$var$b ? Symbol.for("react.fundamental") : 60117, $923a7487eec9c745$var$x = $923a7487eec9c745$var$b ? Symbol.for("react.responder") : 60118, $923a7487eec9c745$var$y = $923a7487eec9c745$var$b ? Symbol.for("react.scope") : 60119;
function $923a7487eec9c745$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $923a7487eec9c745$var$c:
                switch(a = a.type, a){
                    case $923a7487eec9c745$var$l:
                    case $923a7487eec9c745$var$m:
                    case $923a7487eec9c745$var$e:
                    case $923a7487eec9c745$var$g:
                    case $923a7487eec9c745$var$f:
                    case $923a7487eec9c745$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $923a7487eec9c745$var$k:
                            case $923a7487eec9c745$var$n:
                            case $923a7487eec9c745$var$t:
                            case $923a7487eec9c745$var$r:
                            case $923a7487eec9c745$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $923a7487eec9c745$var$d:
                return u;
        }
    }
}
function $923a7487eec9c745$var$A(a) {
    return $923a7487eec9c745$var$z(a) === $923a7487eec9c745$var$m;
}
$923a7487eec9c745$export$2b8d127b894957b9 = $923a7487eec9c745$var$l;
$923a7487eec9c745$export$cea3a54a6425200c = $923a7487eec9c745$var$m;
$923a7487eec9c745$export$a7c73072b1a182ae = $923a7487eec9c745$var$k;
$923a7487eec9c745$export$9f27bc3417b4524d = $923a7487eec9c745$var$h;
$923a7487eec9c745$export$db77ccec0bb4ccac = $923a7487eec9c745$var$c;
$923a7487eec9c745$export$8392c0c9d3dcbd35 = $923a7487eec9c745$var$n;
$923a7487eec9c745$export$ffb0004e005737fa = $923a7487eec9c745$var$e;
$923a7487eec9c745$export$b624eff549462981 = $923a7487eec9c745$var$t;
$923a7487eec9c745$export$7897aa7841a5380c = $923a7487eec9c745$var$r;
$923a7487eec9c745$export$602eac185826482c = $923a7487eec9c745$var$d;
$923a7487eec9c745$export$e2c29f18771995cb = $923a7487eec9c745$var$g;
$923a7487eec9c745$export$5f8d39834fd61797 = $923a7487eec9c745$var$f;
$923a7487eec9c745$export$74bf444e3cd11ea5 = $923a7487eec9c745$var$p;
$923a7487eec9c745$export$92387174baf9b227 = function(a) {
    return $923a7487eec9c745$var$A(a) || $923a7487eec9c745$var$z(a) === $923a7487eec9c745$var$l;
};
$923a7487eec9c745$export$ec112efeb987d9c6 = $923a7487eec9c745$var$A;
$923a7487eec9c745$export$b706b080d889d2c9 = function(a) {
    return $923a7487eec9c745$var$z(a) === $923a7487eec9c745$var$k;
};
$923a7487eec9c745$export$5be5a87408f70ddc = function(a) {
    return $923a7487eec9c745$var$z(a) === $923a7487eec9c745$var$h;
};
$923a7487eec9c745$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $923a7487eec9c745$var$c;
};
$923a7487eec9c745$export$455c2e768291efa6 = function(a) {
    return $923a7487eec9c745$var$z(a) === $923a7487eec9c745$var$n;
};
$923a7487eec9c745$export$9522e17588c12572 = function(a) {
    return $923a7487eec9c745$var$z(a) === $923a7487eec9c745$var$e;
};
$923a7487eec9c745$export$2110ac352bb060b9 = function(a) {
    return $923a7487eec9c745$var$z(a) === $923a7487eec9c745$var$t;
};
$923a7487eec9c745$export$56885ab8b9c456ab = function(a) {
    return $923a7487eec9c745$var$z(a) === $923a7487eec9c745$var$r;
};
$923a7487eec9c745$export$d927fcb6adf8f9de = function(a) {
    return $923a7487eec9c745$var$z(a) === $923a7487eec9c745$var$d;
};
$923a7487eec9c745$export$b82d16f27459e05a = function(a) {
    return $923a7487eec9c745$var$z(a) === $923a7487eec9c745$var$g;
};
$923a7487eec9c745$export$522c17b4f5e123e8 = function(a) {
    return $923a7487eec9c745$var$z(a) === $923a7487eec9c745$var$f;
};
$923a7487eec9c745$export$1aabd8a0274ecfd6 = function(a) {
    return $923a7487eec9c745$var$z(a) === $923a7487eec9c745$var$p;
};
$923a7487eec9c745$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $923a7487eec9c745$var$e || a === $923a7487eec9c745$var$m || a === $923a7487eec9c745$var$g || a === $923a7487eec9c745$var$f || a === $923a7487eec9c745$var$p || a === $923a7487eec9c745$var$q || "object" === typeof a && null !== a && (a.$$typeof === $923a7487eec9c745$var$t || a.$$typeof === $923a7487eec9c745$var$r || a.$$typeof === $923a7487eec9c745$var$h || a.$$typeof === $923a7487eec9c745$var$k || a.$$typeof === $923a7487eec9c745$var$n || a.$$typeof === $923a7487eec9c745$var$w || a.$$typeof === $923a7487eec9c745$var$x || a.$$typeof === $923a7487eec9c745$var$y || a.$$typeof === $923a7487eec9c745$var$v);
};
$923a7487eec9c745$export$f5bbd400c2f4426f = $923a7487eec9c745$var$z;

});




parcelRegister("7sOZt", function(module, exports) {

$parcel$export(module.exports, "getRegisteredStyles", function () { return $56f2b393162761c5$export$95d99596f328fd52; });
$parcel$export(module.exports, "registerStyles", function () { return $56f2b393162761c5$export$580009a5da2a8b4b; });
$parcel$export(module.exports, "insertStyles", function () { return $56f2b393162761c5$export$6f077d94b33a01aa; });
var $56f2b393162761c5$var$isBrowser = true;
function $56f2b393162761c5$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = "";
    classNames.split(" ").forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
        else rawClassName += className + " ";
    });
    return rawClassName;
}
var $56f2b393162761c5$export$580009a5da2a8b4b = function registerStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $56f2b393162761c5$var$isBrowser === false) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
};
var $56f2b393162761c5$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    $56f2b393162761c5$export$580009a5da2a8b4b(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (cache.inserted[serialized.name] === undefined) {
        var current = serialized;
        do {
            cache.insert(serialized === current ? "." + className : "", current, cache.sheet, true);
            current = current.next;
        }while (current !== undefined);
    }
};

});

parcelRegister("47KoV", function(module, exports) {

$parcel$export(module.exports, "serializeStyles", function () { return $300bcf23a6ecee5a$export$6321afa313b251b5; });

var $g3tXG = parcelRequire("g3tXG");

var $3Lp5J = parcelRequire("3Lp5J");

var $d5hMW = parcelRequire("d5hMW");
var $300bcf23a6ecee5a$var$ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var $300bcf23a6ecee5a$var$UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
var $300bcf23a6ecee5a$var$hyphenateRegex = /[A-Z]|^ms/g;
var $300bcf23a6ecee5a$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $300bcf23a6ecee5a$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $300bcf23a6ecee5a$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== "boolean";
};
var $300bcf23a6ecee5a$var$processStyleName = /* #__PURE__ */ (0, $d5hMW.default)(function(styleName) {
    return $300bcf23a6ecee5a$var$isCustomProperty(styleName) ? styleName : styleName.replace($300bcf23a6ecee5a$var$hyphenateRegex, "-$&").toLowerCase();
});
var $300bcf23a6ecee5a$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case "animation":
        case "animationName":
            if (typeof value === "string") return value.replace($300bcf23a6ecee5a$var$animationRegex, function(match, p1, p2) {
                $300bcf23a6ecee5a$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $300bcf23a6ecee5a$var$cursor
                };
                return p1;
            });
    }
    if ((0, $3Lp5J.default)[key] !== 1 && !$300bcf23a6ecee5a$var$isCustomProperty(key) && typeof value === "number" && value !== 0) return value + "px";
    return value;
};
var $300bcf23a6ecee5a$var$contentValuePattern, $300bcf23a6ecee5a$var$contentValues, $300bcf23a6ecee5a$var$oldProcessStyleValue, $300bcf23a6ecee5a$var$msPattern, $300bcf23a6ecee5a$var$hyphenPattern, $300bcf23a6ecee5a$var$hyphenatedCache;
var $300bcf23a6ecee5a$var$noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function $300bcf23a6ecee5a$var$handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return "";
    if (interpolation.__emotion_styles !== undefined) return interpolation;
    switch(typeof interpolation){
        case "boolean":
            return "";
        case "object":
            if (interpolation.anim === 1) {
                $300bcf23a6ecee5a$var$cursor = {
                    name: interpolation.name,
                    styles: interpolation.styles,
                    next: $300bcf23a6ecee5a$var$cursor
                };
                return interpolation.name;
            }
            if (interpolation.styles !== undefined) {
                var next = interpolation.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $300bcf23a6ecee5a$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $300bcf23a6ecee5a$var$cursor
                    };
                    next = next.next;
                }
                var styles = interpolation.styles + ";";
                return styles;
            }
            return $300bcf23a6ecee5a$var$createStringFromObject(mergedProps, registered, interpolation);
        case "function":
            if (mergedProps !== undefined) {
                var previousCursor = $300bcf23a6ecee5a$var$cursor;
                var result = interpolation(mergedProps);
                $300bcf23a6ecee5a$var$cursor = previousCursor;
                return $300bcf23a6ecee5a$var$handleInterpolation(mergedProps, registered, result);
            }
            break;
        case "string":
            var matched, replaced;
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    if (registered == null) return interpolation;
    var cached = registered[interpolation];
    return cached !== undefined ? cached : interpolation;
}
function $300bcf23a6ecee5a$var$createStringFromObject(mergedProps, registered, obj) {
    var string = "";
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $300bcf23a6ecee5a$var$handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var _key in obj){
        var value = obj[_key];
        if (typeof value !== "object") {
            if (registered != null && registered[value] !== undefined) string += _key + "{" + registered[value] + "}";
            else if ($300bcf23a6ecee5a$var$isProcessableValue(value)) string += $300bcf23a6ecee5a$var$processStyleName(_key) + ":" + $300bcf23a6ecee5a$var$processStyleValue(_key, value) + ";";
        } else if (Array.isArray(value) && typeof value[0] === "string" && (registered == null || registered[value[0]] === undefined)) {
            for(var _i = 0; _i < value.length; _i++)if ($300bcf23a6ecee5a$var$isProcessableValue(value[_i])) string += $300bcf23a6ecee5a$var$processStyleName(_key) + ":" + $300bcf23a6ecee5a$var$processStyleValue(_key, value[_i]) + ";";
        } else {
            var interpolated = $300bcf23a6ecee5a$var$handleInterpolation(mergedProps, registered, value);
            switch(_key){
                case "animation":
                case "animationName":
                    string += $300bcf23a6ecee5a$var$processStyleName(_key) + ":" + interpolated + ";";
                    break;
                default:
                    string += _key + "{" + interpolated + "}";
            }
        }
    }
    return string;
}
var $300bcf23a6ecee5a$var$labelPattern = /label:\s*([^\s;\n{]+)\s*(;|$)/g;
var $300bcf23a6ecee5a$var$sourceMapPattern;
// keyframes are stored on the SerializedStyles object as a linked list
var $300bcf23a6ecee5a$var$cursor;
var $300bcf23a6ecee5a$export$6321afa313b251b5 = function serializeStyles(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === "object" && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = "";
    $300bcf23a6ecee5a$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $300bcf23a6ecee5a$var$handleInterpolation(mergedProps, registered, strings);
    } else styles += strings[0];
     // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $300bcf23a6ecee5a$var$handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) styles += strings[i];
    }
    var sourceMap;
    $300bcf23a6ecee5a$var$labelPattern.lastIndex = 0;
    var identifierName = "";
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $300bcf23a6ecee5a$var$labelPattern.exec(styles)) !== null)identifierName += "-" + // $FlowFixMe we know it's not null
    match[1];
    var name = (0, $g3tXG.default)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $300bcf23a6ecee5a$var$cursor
    };
};

});
parcelRegister("g3tXG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bb042aec4fffa986$export$2e2bcd8739ae039; });
/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $bb042aec4fffa986$export$2e2bcd8739ae039(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}

});

parcelRegister("3Lp5J", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2bd939849740902a$export$2e2bcd8739ae039; });
var $2bd939849740902a$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};

});


parcelRegister("5ziuZ", function(module, exports) {

$parcel$export(module.exports, "useInsertionEffectAlwaysWithSyncFallback", function () { return $40de9220eaf38fe3$export$db21c7ffa21794e7; });
$parcel$export(module.exports, "useInsertionEffectWithLayoutFallback", function () { return $40de9220eaf38fe3$export$811a713a7276cb9d; });

var $eeH7J = parcelRequire("eeH7J");
var $40de9220eaf38fe3$var$syncFallback = function syncFallback(create) {
    return create();
};
var $40de9220eaf38fe3$var$useInsertionEffect = $eeH7J.useInsertionEffect ? $eeH7J.useInsertionEffect : false;
var $40de9220eaf38fe3$export$db21c7ffa21794e7 = $40de9220eaf38fe3$var$useInsertionEffect || $40de9220eaf38fe3$var$syncFallback;
var $40de9220eaf38fe3$export$811a713a7276cb9d = $40de9220eaf38fe3$var$useInsertionEffect || $eeH7J.useLayoutEffect;

});


parcelRegister("eq7pw", function(module, exports) {
function $a7f93e0248e9369b$var$_extends() {
    return module.exports = $a7f93e0248e9369b$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $a7f93e0248e9369b$var$_extends.apply(null, arguments);
}
module.exports = $a7f93e0248e9369b$var$_extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("5K1mb", function(module, exports) {

$parcel$export(module.exports, "BrowserRouter", function () { return $42e24d1152893e59$export$9ba4e89fdfa1fc54; });
$parcel$export(module.exports, "Link", function () { return $42e24d1152893e59$export$a6c7ac8248d6e38a; });
$parcel$export(module.exports, "useSearchParams", function () { return $42e24d1152893e59$export$f1a78c17382fe22a; });
$parcel$export(module.exports, "useLocation", function () { return (parcelRequire("18Pjr")).useLocation; });
$parcel$export(module.exports, "useNavigate", function () { return (parcelRequire("18Pjr")).useNavigate; });
/**
 * React Router DOM v6.22.3
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $eeH7J = parcelRequire("eeH7J");

var $iMJCh = parcelRequire("iMJCh");

var $1ig10 = parcelRequire("1ig10");
var $18Pjr = parcelRequire("18Pjr");

var $1ig10 = parcelRequire("1ig10");
function $42e24d1152893e59$var$_extends() {
    $42e24d1152893e59$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $42e24d1152893e59$var$_extends.apply(this, arguments);
}
function $42e24d1152893e59$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $42e24d1152893e59$var$defaultMethod = "get";
const $42e24d1152893e59$var$defaultEncType = "application/x-www-form-urlencoded";
function $42e24d1152893e59$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $42e24d1152893e59$var$isButtonElement(object) {
    return $42e24d1152893e59$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $42e24d1152893e59$var$isFormElement(object) {
    return $42e24d1152893e59$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $42e24d1152893e59$var$isInputElement(object) {
    return $42e24d1152893e59$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $42e24d1152893e59$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $42e24d1152893e59$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$42e24d1152893e59$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $42e24d1152893e59$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $42e24d1152893e59$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $42e24d1152893e59$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
let $42e24d1152893e59$var$_formDataSupportsSubmitter = null;
function $42e24d1152893e59$var$isFormDataSubmitterSupported() {
    if ($42e24d1152893e59$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $42e24d1152893e59$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $42e24d1152893e59$var$_formDataSupportsSubmitter = true;
    }
    return $42e24d1152893e59$var$_formDataSupportsSubmitter;
}
const $42e24d1152893e59$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $42e24d1152893e59$var$getFormEncType(encType) {
    if (encType != null && !$42e24d1152893e59$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $42e24d1152893e59$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($42e24d1152893e59$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, $1ig10.stripBasename)(attr, basename) : null;
        method = target.getAttribute("method") || $42e24d1152893e59$var$defaultMethod;
        encType = $42e24d1152893e59$var$getFormEncType(target.getAttribute("enctype")) || $42e24d1152893e59$var$defaultEncType;
        formData = new FormData(target);
    } else if ($42e24d1152893e59$var$isButtonElement(target) || $42e24d1152893e59$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error('Cannot submit a <button> or <input type="submit"> without a <form>');
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $1ig10.stripBasename)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $42e24d1152893e59$var$defaultMethod;
        encType = $42e24d1152893e59$var$getFormEncType(target.getAttribute("formenctype")) || $42e24d1152893e59$var$getFormEncType(form.getAttribute("enctype")) || $42e24d1152893e59$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$42e24d1152893e59$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($42e24d1152893e59$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $42e24d1152893e59$var$defaultMethod;
        action = null;
        encType = $42e24d1152893e59$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
const $42e24d1152893e59$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "unstable_viewTransition"
], $42e24d1152893e59$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "unstable_viewTransition",
    "children"
], $42e24d1152893e59$var$_excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "unstable_viewTransition"
];
// HEY YOU! DON'T TOUCH THIS VARIABLE!
//
// It is replaced with the proper version at build time via a babel plugin in
// the rollup config.
//
// Export a global property onto the window for React Router detection by the
// Core Web Vitals Technology Report.  This way they can configure the `wappalyzer`
// to detect and properly classify live websites as being built with React Router:
// https://github.com/HTTPArchive/wappalyzer/blob/main/src/technologies/r.json
const $42e24d1152893e59$var$REACT_ROUTER_VERSION = "6";
try {
    window.__reactRouterVersion = $42e24d1152893e59$var$REACT_ROUTER_VERSION;
} catch (e) {
// no-op
}
function $42e24d1152893e59$export$1f3f55432a00e06d(routes, opts) {
    return (0, $1ig10.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: $42e24d1152893e59$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $1ig10.createBrowserHistory)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $42e24d1152893e59$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $18Pjr.UNSAFE_mapRouteProperties),
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $42e24d1152893e59$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $1ig10.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: $42e24d1152893e59$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $1ig10.createHashHistory)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $42e24d1152893e59$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $18Pjr.UNSAFE_mapRouteProperties),
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $42e24d1152893e59$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $42e24d1152893e59$var$_extends({}, state, {
        errors: $42e24d1152893e59$var$deserializeErrors(state.errors)
    });
    return state;
}
function $42e24d1152893e59$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $1ig10.UNSAFE_ErrorResponseImpl)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
const $42e24d1152893e59$export$7ad602f0e94e62d1 = /*#__PURE__*/ $eeH7J.createContext({
    isTransitioning: false
});
const $42e24d1152893e59$export$148fd98d095596d4 = /*#__PURE__*/ $eeH7J.createContext(new Map());
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $42e24d1152893e59$var$START_TRANSITION = "startTransition";
const $42e24d1152893e59$var$startTransitionImpl = $eeH7J[$42e24d1152893e59$var$START_TRANSITION];
const $42e24d1152893e59$var$FLUSH_SYNC = "flushSync";
const $42e24d1152893e59$var$flushSyncImpl = $iMJCh[$42e24d1152893e59$var$FLUSH_SYNC];
const $42e24d1152893e59$var$USE_ID = "useId";
const $42e24d1152893e59$var$useIdImpl = $eeH7J[$42e24d1152893e59$var$USE_ID];
function $42e24d1152893e59$var$startTransitionSafe(cb) {
    if ($42e24d1152893e59$var$startTransitionImpl) $42e24d1152893e59$var$startTransitionImpl(cb);
    else cb();
}
function $42e24d1152893e59$var$flushSyncSafe(cb) {
    if ($42e24d1152893e59$var$flushSyncImpl) $42e24d1152893e59$var$flushSyncImpl(cb);
    else cb();
}
class $42e24d1152893e59$var$Deferred {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $42e24d1152893e59$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $eeH7J.useState(router.state);
    let [pendingState, setPendingState] = $eeH7J.useState();
    let [vtContext, setVtContext] = $eeH7J.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $eeH7J.useState();
    let [transition, setTransition] = $eeH7J.useState();
    let [interruption, setInterruption] = $eeH7J.useState();
    let fetcherData = $eeH7J.useRef(new Map());
    let { v7_startTransition: v7_startTransition } = future || {};
    let optInStartTransition = $eeH7J.useCallback((cb)=>{
        if (v7_startTransition) $42e24d1152893e59$var$startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    let setState = $eeH7J.useCallback((newState, _ref2)=>{
        let { deletedFetchers: deletedFetchers, unstable_flushSync: flushSync, unstable_viewTransitionOpts: viewTransitionOpts } = _ref2;
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        let isViewTransitionUnavailable = router.window == null || typeof router.window.document.startViewTransition !== "function";
        // If this isn't a view transition or it's not available in this browser,
        // just update and be done with it
        if (!viewTransitionOpts || isViewTransitionUnavailable) {
            if (flushSync) $42e24d1152893e59$var$flushSyncSafe(()=>setStateImpl(newState));
            else optInStartTransition(()=>setStateImpl(newState));
            return;
        }
        // flushSync + startViewTransition
        if (flushSync) {
            // Flush through the context to mark DOM elements as transition=ing
            $42e24d1152893e59$var$flushSyncSafe(()=>{
                // Cancel any pending transitions
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            // Update the DOM
            let t = router.window.document.startViewTransition(()=>{
                $42e24d1152893e59$var$flushSyncSafe(()=>setStateImpl(newState));
            });
            // Clean up after the animation completes
            t.finished.finally(()=>{
                $42e24d1152893e59$var$flushSyncSafe(()=>{
                    setRenderDfd(undefined);
                    setTransition(undefined);
                    setPendingState(undefined);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            $42e24d1152893e59$var$flushSyncSafe(()=>setTransition(t));
            return;
        }
        // startTransition + startViewTransition
        if (transition) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $eeH7J.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    $eeH7J.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $42e24d1152893e59$var$Deferred());
    }, [
        vtContext
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    $eeH7J.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition = router.window.document.startViewTransition(async ()=>{
                optInStartTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition.finished.finally(()=>{
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    $eeH7J.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    $eeH7J.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    $eeH7J.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $eeH7J.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $eeH7J.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $eeH7J.createElement($eeH7J.Fragment, null, /*#__PURE__*/ $eeH7J.createElement((0, $18Pjr.UNSAFE_DataRouterContext).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $eeH7J.createElement((0, $18Pjr.UNSAFE_DataRouterStateContext).Provider, {
        value: state
    }, /*#__PURE__*/ $eeH7J.createElement($42e24d1152893e59$export$148fd98d095596d4.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ $eeH7J.createElement($42e24d1152893e59$export$7ad602f0e94e62d1.Provider, {
        value: vtContext
    }, /*#__PURE__*/ $eeH7J.createElement((0, $18Pjr.Router), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $eeH7J.createElement($42e24d1152893e59$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))))), null);
}
function $42e24d1152893e59$var$DataRoutes(_ref3) {
    let { routes: routes, future: future, state: state } = _ref3;
    return (0, $18Pjr.UNSAFE_useRoutesImpl)(routes, undefined, state, future);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $42e24d1152893e59$export$9ba4e89fdfa1fc54(_ref4) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref4;
    let historyRef = $eeH7J.useRef();
    if (historyRef.current == null) historyRef.current = (0, $1ig10.createBrowserHistory)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $eeH7J.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $eeH7J.useCallback((newState)=>{
        v7_startTransition && $42e24d1152893e59$var$startTransitionImpl ? $42e24d1152893e59$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $eeH7J.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $eeH7J.createElement((0, $18Pjr.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $42e24d1152893e59$export$7221d69dcfc8e36b(_ref5) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref5;
    let historyRef = $eeH7J.useRef();
    if (historyRef.current == null) historyRef.current = (0, $1ig10.createHashHistory)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $eeH7J.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $eeH7J.useCallback((newState)=>{
        v7_startTransition && $42e24d1152893e59$var$startTransitionImpl ? $42e24d1152893e59$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $eeH7J.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $eeH7J.createElement((0, $18Pjr.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $42e24d1152893e59$export$eefb0c834599897e(_ref6) {
    let { basename: basename, children: children, future: future, history: history } = _ref6;
    let [state, setStateImpl] = $eeH7J.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $eeH7J.useCallback((newState)=>{
        v7_startTransition && $42e24d1152893e59$var$startTransitionImpl ? $42e24d1152893e59$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $eeH7J.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $eeH7J.createElement((0, $18Pjr.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
const $42e24d1152893e59$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $42e24d1152893e59$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ const $42e24d1152893e59$export$a6c7ac8248d6e38a = /*#__PURE__*/ $eeH7J.forwardRef(function LinkWithRef(_ref7, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset, unstable_viewTransition: unstable_viewTransition } = _ref7, rest = $42e24d1152893e59$var$_objectWithoutPropertiesLoose(_ref7, $42e24d1152893e59$var$_excluded);
    let { basename: basename } = $eeH7J.useContext((0, $18Pjr.UNSAFE_NavigationContext));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $42e24d1152893e59$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($42e24d1152893e59$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $1ig10.stripBasename)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    let href = (0, $18Pjr.useHref)(to, {
        relative: relative
    });
    let internalOnClick = $42e24d1152893e59$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        unstable_viewTransition: unstable_viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $eeH7J.createElement("a", $42e24d1152893e59$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ const $42e24d1152893e59$export$b0d92dbee9b5b60d = /*#__PURE__*/ $eeH7J.forwardRef(function NavLinkWithRef(_ref8, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, unstable_viewTransition: unstable_viewTransition, children: children } = _ref8, rest = $42e24d1152893e59$var$_objectWithoutPropertiesLoose(_ref8, $42e24d1152893e59$var$_excluded2);
    let path = (0, $18Pjr.useResolvedPath)(to, {
        relative: rest.relative
    });
    let location = (0, $18Pjr.useLocation)();
    let routerState = $eeH7J.useContext((0, $18Pjr.UNSAFE_DataRouterStateContext));
    let { navigator: navigator, basename: basename } = $eeH7J.useContext((0, $18Pjr.UNSAFE_NavigationContext));
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $42e24d1152893e59$export$328fe15191788e7f(path) && unstable_viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = (0, $1ig10.stripBasename)(nextLocationPathname, basename) || nextLocationPathname;
    // If the `to` has a trailing slash, look at that exact spot.  Otherwise,
    // we're looking for a slash _after_ what's in `to`.  For example:
    //
    // <NavLink to="/users"> and <NavLink to="/users/">
    // both want to look for a / at index 6 to match URL `/users/matt`
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ $eeH7J.createElement($42e24d1152893e59$export$a6c7ac8248d6e38a, $42e24d1152893e59$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        unstable_viewTransition: unstable_viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $42e24d1152893e59$export$a7fed597f4b8afd8 = /*#__PURE__*/ $eeH7J.forwardRef((_ref9, forwardedRef)=>{
    let { fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace, state: state, method: method = $42e24d1152893e59$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, unstable_viewTransition: unstable_viewTransition } = _ref9, props = $42e24d1152893e59$var$_objectWithoutPropertiesLoose(_ref9, $42e24d1152893e59$var$_excluded3);
    let submit = $42e24d1152893e59$export$47c85c6e3a081d3();
    let formAction = $42e24d1152893e59$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            unstable_viewTransition: unstable_viewTransition
        });
    };
    return /*#__PURE__*/ $eeH7J.createElement("form", $42e24d1152893e59$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $42e24d1152893e59$export$11aac1aab828f1fa(_ref10) {
    let { getKey: getKey, storageKey: storageKey } = _ref10;
    $42e24d1152893e59$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $42e24d1152893e59$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})($42e24d1152893e59$var$DataRouterHook || ($42e24d1152893e59$var$DataRouterHook = {}));
var $42e24d1152893e59$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($42e24d1152893e59$var$DataRouterStateHook || ($42e24d1152893e59$var$DataRouterStateHook = {}));
// Internal hooks
function $42e24d1152893e59$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $42e24d1152893e59$var$useDataRouterContext(hookName) {
    let ctx = $eeH7J.useContext((0, $18Pjr.UNSAFE_DataRouterContext));
    !ctx && (0, $1ig10.UNSAFE_invariant)(false);
    return ctx;
}
function $42e24d1152893e59$var$useDataRouterState(hookName) {
    let state = $eeH7J.useContext((0, $18Pjr.UNSAFE_DataRouterStateContext));
    !state && (0, $1ig10.UNSAFE_invariant)(false);
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $42e24d1152893e59$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative, unstable_viewTransition: unstable_viewTransition } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $18Pjr.useNavigate)();
    let location = (0, $18Pjr.useLocation)();
    let path = (0, $18Pjr.useResolvedPath)(to, {
        relative: relative
    });
    return $eeH7J.useCallback((event)=>{
        if ($42e24d1152893e59$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $1ig10.createPath)(location) === (0, $1ig10.createPath)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                unstable_viewTransition: unstable_viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        unstable_viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $42e24d1152893e59$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $eeH7J.useRef($42e24d1152893e59$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $eeH7J.useRef(false);
    let location = (0, $18Pjr.useLocation)();
    let searchParams = $eeH7J.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $42e24d1152893e59$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $18Pjr.useNavigate)();
    let setSearchParams = $eeH7J.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $42e24d1152893e59$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $42e24d1152893e59$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
let $42e24d1152893e59$var$fetcherId = 0;
let $42e24d1152893e59$var$getUniqueFetcherId = ()=>"__" + String(++$42e24d1152893e59$var$fetcherId) + "__";
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $42e24d1152893e59$export$47c85c6e3a081d3() {
    let { router: router } = $42e24d1152893e59$var$useDataRouterContext($42e24d1152893e59$var$DataRouterHook.UseSubmit);
    let { basename: basename } = $eeH7J.useContext((0, $18Pjr.UNSAFE_NavigationContext));
    let currentRouteId = (0, $18Pjr.UNSAFE_useRouteId)();
    return $eeH7J.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $42e24d1152893e59$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $42e24d1152893e59$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $42e24d1152893e59$var$getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                unstable_flushSync: options.unstable_flushSync
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            unstable_flushSync: options.unstable_flushSync,
            unstable_viewTransition: options.unstable_viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $42e24d1152893e59$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $eeH7J.useContext((0, $18Pjr.UNSAFE_NavigationContext));
    let routeContext = $eeH7J.useContext((0, $18Pjr.UNSAFE_RouteContext));
    !routeContext && (0, $1ig10.UNSAFE_invariant)(false);
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $42e24d1152893e59$var$_extends({}, (0, $18Pjr.useResolvedPath)(action ? action : ".", {
        relative: relative
    }));
    // If no action was specified, browsers will persist current search params
    // when determining the path, so match that behavior
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $18Pjr.useLocation)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove any included ?index param
        // since it might not apply to our contextual route.  We add it back based
        // on match.route.index below
        let params = new URLSearchParams(path.search);
        if (params.has("index") && params.get("index") === "") {
            params.delete("index");
            path.search = params.toString() ? "?" + params.toString() : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $1ig10.joinPaths)([
        basename,
        path.pathname
    ]);
    return (0, $1ig10.createPath)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $42e24d1152893e59$export$5b0d2d9a9921565a(_temp3) {
    var _route$matches;
    let { key: key } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $42e24d1152893e59$var$useDataRouterContext($42e24d1152893e59$var$DataRouterHook.UseFetcher);
    let state = $42e24d1152893e59$var$useDataRouterState($42e24d1152893e59$var$DataRouterStateHook.UseFetcher);
    let fetcherData = $eeH7J.useContext($42e24d1152893e59$export$148fd98d095596d4);
    let route = $eeH7J.useContext((0, $18Pjr.UNSAFE_RouteContext));
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, $1ig10.UNSAFE_invariant)(false);
    !route && (0, $1ig10.UNSAFE_invariant)(false);
    !(routeId != null) && (0, $1ig10.UNSAFE_invariant)(false);
    // Fetcher key handling
    // OK to call conditionally to feature detect `useId`
    // eslint-disable-next-line react-hooks/rules-of-hooks
    let defaultKey = $42e24d1152893e59$var$useIdImpl ? $42e24d1152893e59$var$useIdImpl() : "";
    let [fetcherKey, setFetcherKey] = $eeH7J.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    else if (!fetcherKey) // We will only fall through here when `useId` is not available
    setFetcherKey($42e24d1152893e59$var$getUniqueFetcherId());
    // Registration/cleanup
    $eeH7J.useEffect(()=>{
        router.getFetcher(fetcherKey);
        return ()=>{
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    let load = $eeH7J.useCallback((href, opts)=>{
        !routeId && (0, $1ig10.UNSAFE_invariant)(false);
        router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    let submitImpl = $42e24d1152893e59$export$47c85c6e3a081d3();
    let submit = $eeH7J.useCallback((target, opts)=>{
        submitImpl(target, $42e24d1152893e59$var$_extends({}, opts, {
            navigate: false,
            fetcherKey: fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    let FetcherForm = $eeH7J.useMemo(()=>{
        let FetcherForm = /*#__PURE__*/ $eeH7J.forwardRef((props, ref)=>{
            return /*#__PURE__*/ $eeH7J.createElement($42e24d1152893e59$export$a7fed597f4b8afd8, $42e24d1152893e59$var$_extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    let fetcher = state.fetchers.get(fetcherKey) || (0, $1ig10.IDLE_FETCHER);
    let data = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $eeH7J.useMemo(()=>$42e24d1152893e59$var$_extends({
            Form: FetcherForm,
            submit: submit,
            load: load
        }, fetcher, {
            data: data
        }), [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $42e24d1152893e59$export$fa996778a3a31087() {
    let state = $42e24d1152893e59$var$useDataRouterState($42e24d1152893e59$var$DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map((_ref11)=>{
        let [key, fetcher] = _ref11;
        return $42e24d1152893e59$var$_extends({}, fetcher, {
            key: key
        });
    });
}
const $42e24d1152893e59$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $42e24d1152893e59$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $42e24d1152893e59$export$25057cfe5591e3e9(_temp4) {
    let { getKey: getKey, storageKey: storageKey } = _temp4 === void 0 ? {} : _temp4;
    let { router: router } = $42e24d1152893e59$var$useDataRouterContext($42e24d1152893e59$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $42e24d1152893e59$var$useDataRouterState($42e24d1152893e59$var$DataRouterStateHook.UseScrollRestoration);
    let { basename: basename } = $eeH7J.useContext((0, $18Pjr.UNSAFE_NavigationContext));
    let location = (0, $18Pjr.useLocation)();
    let matches = (0, $18Pjr.useMatches)();
    let navigation = (0, $18Pjr.useNavigation)();
    // Trigger manual scroll restoration while we're active
    $eeH7J.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $42e24d1152893e59$var$usePageHide($eeH7J.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $42e24d1152893e59$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $42e24d1152893e59$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($42e24d1152893e59$var$savedScrollPositions));
        } catch (error) {}
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $eeH7J.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $42e24d1152893e59$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $42e24d1152893e59$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $eeH7J.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey($42e24d1152893e59$var$_extends({}, location, {
                    pathname: (0, $1ig10.stripBasename)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($42e24d1152893e59$var$savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $eeH7J.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $42e24d1152893e59$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $eeH7J.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $42e24d1152893e59$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $eeH7J.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $42e24d1152893e59$export$39f4eb3dbd812741(_ref12) {
    let { when: when, message: message } = _ref12;
    let blocker = (0, $18Pjr.useBlocker)(when);
    $eeH7J.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $eeH7J.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function $42e24d1152893e59$export$328fe15191788e7f(to, opts) {
    if (opts === void 0) opts = {};
    let vtContext = $eeH7J.useContext($42e24d1152893e59$export$7ad602f0e94e62d1);
    !(vtContext != null) && (0, $1ig10.UNSAFE_invariant)(false);
    let { basename: basename } = $42e24d1152893e59$var$useDataRouterContext($42e24d1152893e59$var$DataRouterHook.useViewTransitionState);
    let path = (0, $18Pjr.useResolvedPath)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = (0, $1ig10.stripBasename)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = (0, $1ig10.stripBasename)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" unstable_viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" unstable_viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, $1ig10.matchPath)(path.pathname, nextPath) != null || (0, $1ig10.matchPath)(path.pathname, currentPath) != null;
}

});
parcelRegister("iMJCh", function(module, exports) {
"use strict";
function $dad018249d59322c$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($dad018249d59322c$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$dad018249d59322c$var$checkDCE();

module.exports = (parcelRequire("2Wdaw"));

});
parcelRegister("2Wdaw", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $223b3691249701c4$export$ae55be85d98224ed; }, function (v) { return $223b3691249701c4$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $223b3691249701c4$export$d39a5bbd09211389; }, function (v) { return $223b3691249701c4$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $223b3691249701c4$export$882461b6382ed46c; }, function (v) { return $223b3691249701c4$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $223b3691249701c4$export$466bfc07425424d5; }, function (v) { return $223b3691249701c4$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $223b3691249701c4$export$cd75ccfd720a3cd4; }, function (v) { return $223b3691249701c4$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $223b3691249701c4$export$fa8d919ba61d84db; }, function (v) { return $223b3691249701c4$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $223b3691249701c4$export$757ceba2d55c277e; }, function (v) { return $223b3691249701c4$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $223b3691249701c4$export$b3890eb0ae9dca99; }, function (v) { return $223b3691249701c4$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $223b3691249701c4$export$502457920280e6be; }, function (v) { return $223b3691249701c4$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $223b3691249701c4$export$c78a37762a8d58e1; }, function (v) { return $223b3691249701c4$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $223b3691249701c4$export$dc54d992c10e8a18; }, function (v) { return $223b3691249701c4$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $223b3691249701c4$export$83d89fbfd8236492; }, function (v) { return $223b3691249701c4$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $223b3691249701c4$export$ae55be85d98224ed;
var $223b3691249701c4$export$d39a5bbd09211389;
var $223b3691249701c4$export$882461b6382ed46c;
var $223b3691249701c4$export$466bfc07425424d5;
var $223b3691249701c4$export$cd75ccfd720a3cd4;
var $223b3691249701c4$export$fa8d919ba61d84db;
var $223b3691249701c4$export$757ceba2d55c277e;
var $223b3691249701c4$export$b3890eb0ae9dca99;
var $223b3691249701c4$export$502457920280e6be;
var $223b3691249701c4$export$c78a37762a8d58e1;
var $223b3691249701c4$export$dc54d992c10e8a18;
var $223b3691249701c4$export$83d89fbfd8236492;
"use strict";

var $eeH7J = parcelRequire("eeH7J");

var $l7BOg = parcelRequire("l7BOg");
function $223b3691249701c4$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $223b3691249701c4$var$da = new Set, $223b3691249701c4$var$ea = {};
function $223b3691249701c4$var$fa(a, b) {
    $223b3691249701c4$var$ha(a, b);
    $223b3691249701c4$var$ha(a + "Capture", b);
}
function $223b3691249701c4$var$ha(a, b) {
    $223b3691249701c4$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$223b3691249701c4$var$da.add(b[a]);
}
var $223b3691249701c4$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $223b3691249701c4$var$ja = Object.prototype.hasOwnProperty, $223b3691249701c4$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $223b3691249701c4$var$la = {}, $223b3691249701c4$var$ma = {};
function $223b3691249701c4$var$oa(a) {
    if ($223b3691249701c4$var$ja.call($223b3691249701c4$var$ma, a)) return !0;
    if ($223b3691249701c4$var$ja.call($223b3691249701c4$var$la, a)) return !1;
    if ($223b3691249701c4$var$ka.test(a)) return $223b3691249701c4$var$ma[a] = !0;
    $223b3691249701c4$var$la[a] = !0;
    return !1;
}
function $223b3691249701c4$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $223b3691249701c4$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $223b3691249701c4$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $223b3691249701c4$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $223b3691249701c4$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $223b3691249701c4$var$z[a] = new $223b3691249701c4$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $223b3691249701c4$var$z[b] = new $223b3691249701c4$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $223b3691249701c4$var$z[a] = new $223b3691249701c4$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $223b3691249701c4$var$z[a] = new $223b3691249701c4$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $223b3691249701c4$var$z[a] = new $223b3691249701c4$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $223b3691249701c4$var$z[a] = new $223b3691249701c4$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $223b3691249701c4$var$z[a] = new $223b3691249701c4$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $223b3691249701c4$var$z[a] = new $223b3691249701c4$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $223b3691249701c4$var$z[a] = new $223b3691249701c4$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $223b3691249701c4$var$ra = /[\-:]([a-z])/g;
function $223b3691249701c4$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($223b3691249701c4$var$ra, $223b3691249701c4$var$sa);
    $223b3691249701c4$var$z[b] = new $223b3691249701c4$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($223b3691249701c4$var$ra, $223b3691249701c4$var$sa);
    $223b3691249701c4$var$z[b] = new $223b3691249701c4$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($223b3691249701c4$var$ra, $223b3691249701c4$var$sa);
    $223b3691249701c4$var$z[b] = new $223b3691249701c4$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $223b3691249701c4$var$z[a] = new $223b3691249701c4$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$223b3691249701c4$var$z.xlinkHref = new $223b3691249701c4$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $223b3691249701c4$var$z[a] = new $223b3691249701c4$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $223b3691249701c4$var$ta(a, b, c, d) {
    var e = $223b3691249701c4$var$z.hasOwnProperty(b) ? $223b3691249701c4$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $223b3691249701c4$var$qa(b, c, e, d) && (c = null), d || null === e ? $223b3691249701c4$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $223b3691249701c4$var$ua = $eeH7J.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $223b3691249701c4$var$va = Symbol.for("react.element"), $223b3691249701c4$var$wa = Symbol.for("react.portal"), $223b3691249701c4$var$ya = Symbol.for("react.fragment"), $223b3691249701c4$var$za = Symbol.for("react.strict_mode"), $223b3691249701c4$var$Aa = Symbol.for("react.profiler"), $223b3691249701c4$var$Ba = Symbol.for("react.provider"), $223b3691249701c4$var$Ca = Symbol.for("react.context"), $223b3691249701c4$var$Da = Symbol.for("react.forward_ref"), $223b3691249701c4$var$Ea = Symbol.for("react.suspense"), $223b3691249701c4$var$Fa = Symbol.for("react.suspense_list"), $223b3691249701c4$var$Ga = Symbol.for("react.memo"), $223b3691249701c4$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $223b3691249701c4$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $223b3691249701c4$var$Ja = Symbol.iterator;
function $223b3691249701c4$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $223b3691249701c4$var$Ja && a[$223b3691249701c4$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $223b3691249701c4$var$A = Object.assign, $223b3691249701c4$var$La;
function $223b3691249701c4$var$Ma(a) {
    if (void 0 === $223b3691249701c4$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $223b3691249701c4$var$La = b && b[1] || "";
    }
    return "\n" + $223b3691249701c4$var$La + a;
}
var $223b3691249701c4$var$Na = !1;
function $223b3691249701c4$var$Oa(a, b) {
    if (!a || $223b3691249701c4$var$Na) return "";
    $223b3691249701c4$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $223b3691249701c4$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $223b3691249701c4$var$Ma(a) : "";
}
function $223b3691249701c4$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $223b3691249701c4$var$Ma(a.type);
        case 16:
            return $223b3691249701c4$var$Ma("Lazy");
        case 13:
            return $223b3691249701c4$var$Ma("Suspense");
        case 19:
            return $223b3691249701c4$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $223b3691249701c4$var$Oa(a.type, !1), a;
        case 11:
            return a = $223b3691249701c4$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $223b3691249701c4$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $223b3691249701c4$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $223b3691249701c4$var$ya:
            return "Fragment";
        case $223b3691249701c4$var$wa:
            return "Portal";
        case $223b3691249701c4$var$Aa:
            return "Profiler";
        case $223b3691249701c4$var$za:
            return "StrictMode";
        case $223b3691249701c4$var$Ea:
            return "Suspense";
        case $223b3691249701c4$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $223b3691249701c4$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $223b3691249701c4$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $223b3691249701c4$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $223b3691249701c4$var$Ga:
            return b = a.displayName || null, null !== b ? b : $223b3691249701c4$var$Qa(a.type) || "Memo";
        case $223b3691249701c4$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $223b3691249701c4$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $223b3691249701c4$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $223b3691249701c4$var$Qa(b);
        case 8:
            return b === $223b3691249701c4$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $223b3691249701c4$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $223b3691249701c4$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $223b3691249701c4$var$Ua(a) {
    var b = $223b3691249701c4$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $223b3691249701c4$var$Va(a) {
    a._valueTracker || (a._valueTracker = $223b3691249701c4$var$Ua(a));
}
function $223b3691249701c4$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $223b3691249701c4$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $223b3691249701c4$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $223b3691249701c4$var$Ya(a, b) {
    var c = b.checked;
    return $223b3691249701c4$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $223b3691249701c4$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $223b3691249701c4$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $223b3691249701c4$var$ab(a, b) {
    b = b.checked;
    null != b && $223b3691249701c4$var$ta(a, "checked", b, !1);
}
function $223b3691249701c4$var$bb(a, b) {
    $223b3691249701c4$var$ab(a, b);
    var c = $223b3691249701c4$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $223b3691249701c4$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $223b3691249701c4$var$cb(a, b.type, $223b3691249701c4$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $223b3691249701c4$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $223b3691249701c4$var$cb(a, b, c) {
    if ("number" !== b || $223b3691249701c4$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $223b3691249701c4$var$eb = Array.isArray;
function $223b3691249701c4$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $223b3691249701c4$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $223b3691249701c4$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($223b3691249701c4$var$p(91));
    return $223b3691249701c4$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $223b3691249701c4$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($223b3691249701c4$var$p(92));
            if ($223b3691249701c4$var$eb(c)) {
                if (1 < c.length) throw Error($223b3691249701c4$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $223b3691249701c4$var$Sa(c)
    };
}
function $223b3691249701c4$var$ib(a, b) {
    var c = $223b3691249701c4$var$Sa(b.value), d = $223b3691249701c4$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $223b3691249701c4$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $223b3691249701c4$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $223b3691249701c4$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $223b3691249701c4$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $223b3691249701c4$var$mb, $223b3691249701c4$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $223b3691249701c4$var$mb = $223b3691249701c4$var$mb || document.createElement("div");
        $223b3691249701c4$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $223b3691249701c4$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $223b3691249701c4$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $223b3691249701c4$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $223b3691249701c4$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($223b3691249701c4$var$pb).forEach(function(a) {
    $223b3691249701c4$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $223b3691249701c4$var$pb[b] = $223b3691249701c4$var$pb[a];
    });
});
function $223b3691249701c4$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $223b3691249701c4$var$pb.hasOwnProperty(a) && $223b3691249701c4$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $223b3691249701c4$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $223b3691249701c4$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $223b3691249701c4$var$tb = $223b3691249701c4$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $223b3691249701c4$var$ub(a, b) {
    if (b) {
        if ($223b3691249701c4$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($223b3691249701c4$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($223b3691249701c4$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($223b3691249701c4$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($223b3691249701c4$var$p(62));
    }
}
function $223b3691249701c4$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $223b3691249701c4$var$wb = null;
function $223b3691249701c4$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $223b3691249701c4$var$yb = null, $223b3691249701c4$var$zb = null, $223b3691249701c4$var$Ab = null;
function $223b3691249701c4$var$Bb(a) {
    if (a = $223b3691249701c4$var$Cb(a)) {
        if ("function" !== typeof $223b3691249701c4$var$yb) throw Error($223b3691249701c4$var$p(280));
        var b = a.stateNode;
        b && (b = $223b3691249701c4$var$Db(b), $223b3691249701c4$var$yb(a.stateNode, a.type, b));
    }
}
function $223b3691249701c4$var$Eb(a) {
    $223b3691249701c4$var$zb ? $223b3691249701c4$var$Ab ? $223b3691249701c4$var$Ab.push(a) : $223b3691249701c4$var$Ab = [
        a
    ] : $223b3691249701c4$var$zb = a;
}
function $223b3691249701c4$var$Fb() {
    if ($223b3691249701c4$var$zb) {
        var a = $223b3691249701c4$var$zb, b = $223b3691249701c4$var$Ab;
        $223b3691249701c4$var$Ab = $223b3691249701c4$var$zb = null;
        $223b3691249701c4$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$223b3691249701c4$var$Bb(b[a]);
    }
}
function $223b3691249701c4$var$Gb(a, b) {
    return a(b);
}
function $223b3691249701c4$var$Hb() {}
var $223b3691249701c4$var$Ib = !1;
function $223b3691249701c4$var$Jb(a, b, c) {
    if ($223b3691249701c4$var$Ib) return a(b, c);
    $223b3691249701c4$var$Ib = !0;
    try {
        return $223b3691249701c4$var$Gb(a, b, c);
    } finally{
        if ($223b3691249701c4$var$Ib = !1, null !== $223b3691249701c4$var$zb || null !== $223b3691249701c4$var$Ab) $223b3691249701c4$var$Hb(), $223b3691249701c4$var$Fb();
    }
}
function $223b3691249701c4$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $223b3691249701c4$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($223b3691249701c4$var$p(231, b, typeof c));
    return c;
}
var $223b3691249701c4$var$Lb = !1;
if ($223b3691249701c4$var$ia) try {
    var $223b3691249701c4$var$Mb = {};
    Object.defineProperty($223b3691249701c4$var$Mb, "passive", {
        get: function() {
            $223b3691249701c4$var$Lb = !0;
        }
    });
    window.addEventListener("test", $223b3691249701c4$var$Mb, $223b3691249701c4$var$Mb);
    window.removeEventListener("test", $223b3691249701c4$var$Mb, $223b3691249701c4$var$Mb);
} catch (a) {
    $223b3691249701c4$var$Lb = !1;
}
function $223b3691249701c4$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $223b3691249701c4$var$Ob = !1, $223b3691249701c4$var$Pb = null, $223b3691249701c4$var$Qb = !1, $223b3691249701c4$var$Rb = null, $223b3691249701c4$var$Sb = {
    onError: function(a) {
        $223b3691249701c4$var$Ob = !0;
        $223b3691249701c4$var$Pb = a;
    }
};
function $223b3691249701c4$var$Tb(a, b, c, d, e, f, g, h, k) {
    $223b3691249701c4$var$Ob = !1;
    $223b3691249701c4$var$Pb = null;
    $223b3691249701c4$var$Nb.apply($223b3691249701c4$var$Sb, arguments);
}
function $223b3691249701c4$var$Ub(a, b, c, d, e, f, g, h, k) {
    $223b3691249701c4$var$Tb.apply(this, arguments);
    if ($223b3691249701c4$var$Ob) {
        if ($223b3691249701c4$var$Ob) {
            var l = $223b3691249701c4$var$Pb;
            $223b3691249701c4$var$Ob = !1;
            $223b3691249701c4$var$Pb = null;
        } else throw Error($223b3691249701c4$var$p(198));
        $223b3691249701c4$var$Qb || ($223b3691249701c4$var$Qb = !0, $223b3691249701c4$var$Rb = l);
    }
}
function $223b3691249701c4$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $223b3691249701c4$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $223b3691249701c4$var$Xb(a) {
    if ($223b3691249701c4$var$Vb(a) !== a) throw Error($223b3691249701c4$var$p(188));
}
function $223b3691249701c4$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $223b3691249701c4$var$Vb(a);
        if (null === b) throw Error($223b3691249701c4$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $223b3691249701c4$var$Xb(e), a;
                if (f === d) return $223b3691249701c4$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($223b3691249701c4$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($223b3691249701c4$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($223b3691249701c4$var$p(190));
    }
    if (3 !== c.tag) throw Error($223b3691249701c4$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $223b3691249701c4$var$Zb(a) {
    a = $223b3691249701c4$var$Yb(a);
    return null !== a ? $223b3691249701c4$var$$b(a) : null;
}
function $223b3691249701c4$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $223b3691249701c4$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $223b3691249701c4$var$ac = $l7BOg.unstable_scheduleCallback, $223b3691249701c4$var$bc = $l7BOg.unstable_cancelCallback, $223b3691249701c4$var$cc = $l7BOg.unstable_shouldYield, $223b3691249701c4$var$dc = $l7BOg.unstable_requestPaint, $223b3691249701c4$var$B = $l7BOg.unstable_now, $223b3691249701c4$var$ec = $l7BOg.unstable_getCurrentPriorityLevel, $223b3691249701c4$var$fc = $l7BOg.unstable_ImmediatePriority, $223b3691249701c4$var$gc = $l7BOg.unstable_UserBlockingPriority, $223b3691249701c4$var$hc = $l7BOg.unstable_NormalPriority, $223b3691249701c4$var$ic = $l7BOg.unstable_LowPriority, $223b3691249701c4$var$jc = $l7BOg.unstable_IdlePriority, $223b3691249701c4$var$kc = null, $223b3691249701c4$var$lc = null;
function $223b3691249701c4$var$mc(a) {
    if ($223b3691249701c4$var$lc && "function" === typeof $223b3691249701c4$var$lc.onCommitFiberRoot) try {
        $223b3691249701c4$var$lc.onCommitFiberRoot($223b3691249701c4$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $223b3691249701c4$var$oc = Math.clz32 ? Math.clz32 : $223b3691249701c4$var$nc, $223b3691249701c4$var$pc = Math.log, $223b3691249701c4$var$qc = Math.LN2;
function $223b3691249701c4$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($223b3691249701c4$var$pc(a) / $223b3691249701c4$var$qc | 0) | 0;
}
var $223b3691249701c4$var$rc = 64, $223b3691249701c4$var$sc = 4194304;
function $223b3691249701c4$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $223b3691249701c4$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $223b3691249701c4$var$tc(h) : (f &= g, 0 !== f && (d = $223b3691249701c4$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $223b3691249701c4$var$tc(g) : 0 !== f && (d = $223b3691249701c4$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $223b3691249701c4$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $223b3691249701c4$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $223b3691249701c4$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $223b3691249701c4$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $223b3691249701c4$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $223b3691249701c4$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $223b3691249701c4$var$yc() {
    var a = $223b3691249701c4$var$rc;
    $223b3691249701c4$var$rc <<= 1;
    0 === ($223b3691249701c4$var$rc & 4194240) && ($223b3691249701c4$var$rc = 64);
    return a;
}
function $223b3691249701c4$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $223b3691249701c4$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $223b3691249701c4$var$oc(b);
    a[b] = c;
}
function $223b3691249701c4$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $223b3691249701c4$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $223b3691249701c4$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $223b3691249701c4$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $223b3691249701c4$var$C = 0;
function $223b3691249701c4$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $223b3691249701c4$var$Ec, $223b3691249701c4$var$Fc, $223b3691249701c4$var$Gc, $223b3691249701c4$var$Hc, $223b3691249701c4$var$Ic, $223b3691249701c4$var$Jc = !1, $223b3691249701c4$var$Kc = [], $223b3691249701c4$var$Lc = null, $223b3691249701c4$var$Mc = null, $223b3691249701c4$var$Nc = null, $223b3691249701c4$var$Oc = new Map, $223b3691249701c4$var$Pc = new Map, $223b3691249701c4$var$Qc = [], $223b3691249701c4$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $223b3691249701c4$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $223b3691249701c4$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $223b3691249701c4$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $223b3691249701c4$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $223b3691249701c4$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $223b3691249701c4$var$Pc.delete(b.pointerId);
    }
}
function $223b3691249701c4$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $223b3691249701c4$var$Cb(b), null !== b && $223b3691249701c4$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $223b3691249701c4$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $223b3691249701c4$var$Lc = $223b3691249701c4$var$Tc($223b3691249701c4$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $223b3691249701c4$var$Mc = $223b3691249701c4$var$Tc($223b3691249701c4$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $223b3691249701c4$var$Nc = $223b3691249701c4$var$Tc($223b3691249701c4$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $223b3691249701c4$var$Oc.set(f, $223b3691249701c4$var$Tc($223b3691249701c4$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $223b3691249701c4$var$Pc.set(f, $223b3691249701c4$var$Tc($223b3691249701c4$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $223b3691249701c4$var$Vc(a) {
    var b = $223b3691249701c4$var$Wc(a.target);
    if (null !== b) {
        var c = $223b3691249701c4$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $223b3691249701c4$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $223b3691249701c4$var$Ic(a.priority, function() {
                        $223b3691249701c4$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $223b3691249701c4$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $223b3691249701c4$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $223b3691249701c4$var$wb = d;
            c.target.dispatchEvent(d);
            $223b3691249701c4$var$wb = null;
        } else return b = $223b3691249701c4$var$Cb(c), null !== b && $223b3691249701c4$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $223b3691249701c4$var$Zc(a, b, c) {
    $223b3691249701c4$var$Xc(a) && c.delete(b);
}
function $223b3691249701c4$var$$c() {
    $223b3691249701c4$var$Jc = !1;
    null !== $223b3691249701c4$var$Lc && $223b3691249701c4$var$Xc($223b3691249701c4$var$Lc) && ($223b3691249701c4$var$Lc = null);
    null !== $223b3691249701c4$var$Mc && $223b3691249701c4$var$Xc($223b3691249701c4$var$Mc) && ($223b3691249701c4$var$Mc = null);
    null !== $223b3691249701c4$var$Nc && $223b3691249701c4$var$Xc($223b3691249701c4$var$Nc) && ($223b3691249701c4$var$Nc = null);
    $223b3691249701c4$var$Oc.forEach($223b3691249701c4$var$Zc);
    $223b3691249701c4$var$Pc.forEach($223b3691249701c4$var$Zc);
}
function $223b3691249701c4$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $223b3691249701c4$var$Jc || ($223b3691249701c4$var$Jc = !0, $l7BOg.unstable_scheduleCallback($l7BOg.unstable_NormalPriority, $223b3691249701c4$var$$c)));
}
function $223b3691249701c4$var$bd(a) {
    function b(b) {
        return $223b3691249701c4$var$ad(b, a);
    }
    if (0 < $223b3691249701c4$var$Kc.length) {
        $223b3691249701c4$var$ad($223b3691249701c4$var$Kc[0], a);
        for(var c = 1; c < $223b3691249701c4$var$Kc.length; c++){
            var d = $223b3691249701c4$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $223b3691249701c4$var$Lc && $223b3691249701c4$var$ad($223b3691249701c4$var$Lc, a);
    null !== $223b3691249701c4$var$Mc && $223b3691249701c4$var$ad($223b3691249701c4$var$Mc, a);
    null !== $223b3691249701c4$var$Nc && $223b3691249701c4$var$ad($223b3691249701c4$var$Nc, a);
    $223b3691249701c4$var$Oc.forEach(b);
    $223b3691249701c4$var$Pc.forEach(b);
    for(c = 0; c < $223b3691249701c4$var$Qc.length; c++)d = $223b3691249701c4$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $223b3691249701c4$var$Qc.length && (c = $223b3691249701c4$var$Qc[0], null === c.blockedOn);)$223b3691249701c4$var$Vc(c), null === c.blockedOn && $223b3691249701c4$var$Qc.shift();
}
var $223b3691249701c4$var$cd = $223b3691249701c4$var$ua.ReactCurrentBatchConfig, $223b3691249701c4$var$dd = !0;
function $223b3691249701c4$var$ed(a, b, c, d) {
    var e = $223b3691249701c4$var$C, f = $223b3691249701c4$var$cd.transition;
    $223b3691249701c4$var$cd.transition = null;
    try {
        $223b3691249701c4$var$C = 1, $223b3691249701c4$var$fd(a, b, c, d);
    } finally{
        $223b3691249701c4$var$C = e, $223b3691249701c4$var$cd.transition = f;
    }
}
function $223b3691249701c4$var$gd(a, b, c, d) {
    var e = $223b3691249701c4$var$C, f = $223b3691249701c4$var$cd.transition;
    $223b3691249701c4$var$cd.transition = null;
    try {
        $223b3691249701c4$var$C = 4, $223b3691249701c4$var$fd(a, b, c, d);
    } finally{
        $223b3691249701c4$var$C = e, $223b3691249701c4$var$cd.transition = f;
    }
}
function $223b3691249701c4$var$fd(a, b, c, d) {
    if ($223b3691249701c4$var$dd) {
        var e = $223b3691249701c4$var$Yc(a, b, c, d);
        if (null === e) $223b3691249701c4$var$hd(a, b, d, $223b3691249701c4$var$id, c), $223b3691249701c4$var$Sc(a, d);
        else if ($223b3691249701c4$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($223b3691249701c4$var$Sc(a, d), b & 4 && -1 < $223b3691249701c4$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $223b3691249701c4$var$Cb(e);
                null !== f && $223b3691249701c4$var$Ec(f);
                f = $223b3691249701c4$var$Yc(a, b, c, d);
                null === f && $223b3691249701c4$var$hd(a, b, d, $223b3691249701c4$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $223b3691249701c4$var$hd(a, b, d, null, c);
    }
}
var $223b3691249701c4$var$id = null;
function $223b3691249701c4$var$Yc(a, b, c, d) {
    $223b3691249701c4$var$id = null;
    a = $223b3691249701c4$var$xb(d);
    a = $223b3691249701c4$var$Wc(a);
    if (null !== a) {
        if (b = $223b3691249701c4$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $223b3691249701c4$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $223b3691249701c4$var$id = a;
    return null;
}
function $223b3691249701c4$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($223b3691249701c4$var$ec()){
                case $223b3691249701c4$var$fc:
                    return 1;
                case $223b3691249701c4$var$gc:
                    return 4;
                case $223b3691249701c4$var$hc:
                case $223b3691249701c4$var$ic:
                    return 16;
                case $223b3691249701c4$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $223b3691249701c4$var$kd = null, $223b3691249701c4$var$ld = null, $223b3691249701c4$var$md = null;
function $223b3691249701c4$var$nd() {
    if ($223b3691249701c4$var$md) return $223b3691249701c4$var$md;
    var a, b = $223b3691249701c4$var$ld, c = b.length, d, e = "value" in $223b3691249701c4$var$kd ? $223b3691249701c4$var$kd.value : $223b3691249701c4$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $223b3691249701c4$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $223b3691249701c4$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $223b3691249701c4$var$pd() {
    return !0;
}
function $223b3691249701c4$var$qd() {
    return !1;
}
function $223b3691249701c4$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $223b3691249701c4$var$pd : $223b3691249701c4$var$qd;
        this.isPropagationStopped = $223b3691249701c4$var$qd;
        return this;
    }
    $223b3691249701c4$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $223b3691249701c4$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $223b3691249701c4$var$pd);
        },
        persist: function() {},
        isPersistent: $223b3691249701c4$var$pd
    });
    return b;
}
var $223b3691249701c4$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $223b3691249701c4$var$td = $223b3691249701c4$var$rd($223b3691249701c4$var$sd), $223b3691249701c4$var$ud = $223b3691249701c4$var$A({}, $223b3691249701c4$var$sd, {
    view: 0,
    detail: 0
}), $223b3691249701c4$var$vd = $223b3691249701c4$var$rd($223b3691249701c4$var$ud), $223b3691249701c4$var$wd, $223b3691249701c4$var$xd, $223b3691249701c4$var$yd, $223b3691249701c4$var$Ad = $223b3691249701c4$var$A({}, $223b3691249701c4$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $223b3691249701c4$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $223b3691249701c4$var$yd && ($223b3691249701c4$var$yd && "mousemove" === a.type ? ($223b3691249701c4$var$wd = a.screenX - $223b3691249701c4$var$yd.screenX, $223b3691249701c4$var$xd = a.screenY - $223b3691249701c4$var$yd.screenY) : $223b3691249701c4$var$xd = $223b3691249701c4$var$wd = 0, $223b3691249701c4$var$yd = a);
        return $223b3691249701c4$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $223b3691249701c4$var$xd;
    }
}), $223b3691249701c4$var$Bd = $223b3691249701c4$var$rd($223b3691249701c4$var$Ad), $223b3691249701c4$var$Cd = $223b3691249701c4$var$A({}, $223b3691249701c4$var$Ad, {
    dataTransfer: 0
}), $223b3691249701c4$var$Dd = $223b3691249701c4$var$rd($223b3691249701c4$var$Cd), $223b3691249701c4$var$Ed = $223b3691249701c4$var$A({}, $223b3691249701c4$var$ud, {
    relatedTarget: 0
}), $223b3691249701c4$var$Fd = $223b3691249701c4$var$rd($223b3691249701c4$var$Ed), $223b3691249701c4$var$Gd = $223b3691249701c4$var$A({}, $223b3691249701c4$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $223b3691249701c4$var$Hd = $223b3691249701c4$var$rd($223b3691249701c4$var$Gd), $223b3691249701c4$var$Id = $223b3691249701c4$var$A({}, $223b3691249701c4$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $223b3691249701c4$var$Jd = $223b3691249701c4$var$rd($223b3691249701c4$var$Id), $223b3691249701c4$var$Kd = $223b3691249701c4$var$A({}, $223b3691249701c4$var$sd, {
    data: 0
}), $223b3691249701c4$var$Ld = $223b3691249701c4$var$rd($223b3691249701c4$var$Kd), $223b3691249701c4$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $223b3691249701c4$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $223b3691249701c4$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $223b3691249701c4$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $223b3691249701c4$var$Od[a]) ? !!b[a] : !1;
}
function $223b3691249701c4$var$zd() {
    return $223b3691249701c4$var$Pd;
}
var $223b3691249701c4$var$Qd = $223b3691249701c4$var$A({}, $223b3691249701c4$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $223b3691249701c4$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $223b3691249701c4$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $223b3691249701c4$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $223b3691249701c4$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $223b3691249701c4$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $223b3691249701c4$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $223b3691249701c4$var$Rd = $223b3691249701c4$var$rd($223b3691249701c4$var$Qd), $223b3691249701c4$var$Sd = $223b3691249701c4$var$A({}, $223b3691249701c4$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $223b3691249701c4$var$Td = $223b3691249701c4$var$rd($223b3691249701c4$var$Sd), $223b3691249701c4$var$Ud = $223b3691249701c4$var$A({}, $223b3691249701c4$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $223b3691249701c4$var$zd
}), $223b3691249701c4$var$Vd = $223b3691249701c4$var$rd($223b3691249701c4$var$Ud), $223b3691249701c4$var$Wd = $223b3691249701c4$var$A({}, $223b3691249701c4$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $223b3691249701c4$var$Xd = $223b3691249701c4$var$rd($223b3691249701c4$var$Wd), $223b3691249701c4$var$Yd = $223b3691249701c4$var$A({}, $223b3691249701c4$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $223b3691249701c4$var$Zd = $223b3691249701c4$var$rd($223b3691249701c4$var$Yd), $223b3691249701c4$var$$d = [
    9,
    13,
    27,
    32
], $223b3691249701c4$var$ae = $223b3691249701c4$var$ia && "CompositionEvent" in window, $223b3691249701c4$var$be = null;
$223b3691249701c4$var$ia && "documentMode" in document && ($223b3691249701c4$var$be = document.documentMode);
var $223b3691249701c4$var$ce = $223b3691249701c4$var$ia && "TextEvent" in window && !$223b3691249701c4$var$be, $223b3691249701c4$var$de = $223b3691249701c4$var$ia && (!$223b3691249701c4$var$ae || $223b3691249701c4$var$be && 8 < $223b3691249701c4$var$be && 11 >= $223b3691249701c4$var$be), $223b3691249701c4$var$ee = String.fromCharCode(32), $223b3691249701c4$var$fe = !1;
function $223b3691249701c4$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $223b3691249701c4$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $223b3691249701c4$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $223b3691249701c4$var$ie = !1;
function $223b3691249701c4$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $223b3691249701c4$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $223b3691249701c4$var$fe = !0;
            return $223b3691249701c4$var$ee;
        case "textInput":
            return a = b.data, a === $223b3691249701c4$var$ee && $223b3691249701c4$var$fe ? null : a;
        default:
            return null;
    }
}
function $223b3691249701c4$var$ke(a, b) {
    if ($223b3691249701c4$var$ie) return "compositionend" === a || !$223b3691249701c4$var$ae && $223b3691249701c4$var$ge(a, b) ? (a = $223b3691249701c4$var$nd(), $223b3691249701c4$var$md = $223b3691249701c4$var$ld = $223b3691249701c4$var$kd = null, $223b3691249701c4$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $223b3691249701c4$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $223b3691249701c4$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $223b3691249701c4$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$223b3691249701c4$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $223b3691249701c4$var$ne(a, b, c, d) {
    $223b3691249701c4$var$Eb(d);
    b = $223b3691249701c4$var$oe(b, "onChange");
    0 < b.length && (c = new $223b3691249701c4$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $223b3691249701c4$var$pe = null, $223b3691249701c4$var$qe = null;
function $223b3691249701c4$var$re(a) {
    $223b3691249701c4$var$se(a, 0);
}
function $223b3691249701c4$var$te(a) {
    var b = $223b3691249701c4$var$ue(a);
    if ($223b3691249701c4$var$Wa(b)) return a;
}
function $223b3691249701c4$var$ve(a, b) {
    if ("change" === a) return b;
}
var $223b3691249701c4$var$we = !1;
if ($223b3691249701c4$var$ia) {
    var $223b3691249701c4$var$xe;
    if ($223b3691249701c4$var$ia) {
        var $223b3691249701c4$var$ye = "oninput" in document;
        if (!$223b3691249701c4$var$ye) {
            var $223b3691249701c4$var$ze = document.createElement("div");
            $223b3691249701c4$var$ze.setAttribute("oninput", "return;");
            $223b3691249701c4$var$ye = "function" === typeof $223b3691249701c4$var$ze.oninput;
        }
        $223b3691249701c4$var$xe = $223b3691249701c4$var$ye;
    } else $223b3691249701c4$var$xe = !1;
    $223b3691249701c4$var$we = $223b3691249701c4$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $223b3691249701c4$var$Ae() {
    $223b3691249701c4$var$pe && ($223b3691249701c4$var$pe.detachEvent("onpropertychange", $223b3691249701c4$var$Be), $223b3691249701c4$var$qe = $223b3691249701c4$var$pe = null);
}
function $223b3691249701c4$var$Be(a) {
    if ("value" === a.propertyName && $223b3691249701c4$var$te($223b3691249701c4$var$qe)) {
        var b = [];
        $223b3691249701c4$var$ne(b, $223b3691249701c4$var$qe, a, $223b3691249701c4$var$xb(a));
        $223b3691249701c4$var$Jb($223b3691249701c4$var$re, b);
    }
}
function $223b3691249701c4$var$Ce(a, b, c) {
    "focusin" === a ? ($223b3691249701c4$var$Ae(), $223b3691249701c4$var$pe = b, $223b3691249701c4$var$qe = c, $223b3691249701c4$var$pe.attachEvent("onpropertychange", $223b3691249701c4$var$Be)) : "focusout" === a && $223b3691249701c4$var$Ae();
}
function $223b3691249701c4$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $223b3691249701c4$var$te($223b3691249701c4$var$qe);
}
function $223b3691249701c4$var$Ee(a, b) {
    if ("click" === a) return $223b3691249701c4$var$te(b);
}
function $223b3691249701c4$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $223b3691249701c4$var$te(b);
}
function $223b3691249701c4$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $223b3691249701c4$var$He = "function" === typeof Object.is ? Object.is : $223b3691249701c4$var$Ge;
function $223b3691249701c4$var$Ie(a, b) {
    if ($223b3691249701c4$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$223b3691249701c4$var$ja.call(b, e) || !$223b3691249701c4$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $223b3691249701c4$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $223b3691249701c4$var$Ke(a, b) {
    var c = $223b3691249701c4$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $223b3691249701c4$var$Je(c);
    }
}
function $223b3691249701c4$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $223b3691249701c4$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $223b3691249701c4$var$Me() {
    for(var a = window, b = $223b3691249701c4$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $223b3691249701c4$var$Xa(a.document);
    }
    return b;
}
function $223b3691249701c4$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $223b3691249701c4$var$Oe(a) {
    var b = $223b3691249701c4$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $223b3691249701c4$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $223b3691249701c4$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $223b3691249701c4$var$Ke(c, f);
                var g = $223b3691249701c4$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $223b3691249701c4$var$Pe = $223b3691249701c4$var$ia && "documentMode" in document && 11 >= document.documentMode, $223b3691249701c4$var$Qe = null, $223b3691249701c4$var$Re = null, $223b3691249701c4$var$Se = null, $223b3691249701c4$var$Te = !1;
function $223b3691249701c4$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $223b3691249701c4$var$Te || null == $223b3691249701c4$var$Qe || $223b3691249701c4$var$Qe !== $223b3691249701c4$var$Xa(d) || (d = $223b3691249701c4$var$Qe, "selectionStart" in d && $223b3691249701c4$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $223b3691249701c4$var$Se && $223b3691249701c4$var$Ie($223b3691249701c4$var$Se, d) || ($223b3691249701c4$var$Se = d, d = $223b3691249701c4$var$oe($223b3691249701c4$var$Re, "onSelect"), 0 < d.length && (b = new $223b3691249701c4$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $223b3691249701c4$var$Qe)));
}
function $223b3691249701c4$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $223b3691249701c4$var$We = {
    animationend: $223b3691249701c4$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $223b3691249701c4$var$Ve("Animation", "AnimationIteration"),
    animationstart: $223b3691249701c4$var$Ve("Animation", "AnimationStart"),
    transitionend: $223b3691249701c4$var$Ve("Transition", "TransitionEnd")
}, $223b3691249701c4$var$Xe = {}, $223b3691249701c4$var$Ye = {};
$223b3691249701c4$var$ia && ($223b3691249701c4$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $223b3691249701c4$var$We.animationend.animation, delete $223b3691249701c4$var$We.animationiteration.animation, delete $223b3691249701c4$var$We.animationstart.animation), "TransitionEvent" in window || delete $223b3691249701c4$var$We.transitionend.transition);
function $223b3691249701c4$var$Ze(a) {
    if ($223b3691249701c4$var$Xe[a]) return $223b3691249701c4$var$Xe[a];
    if (!$223b3691249701c4$var$We[a]) return a;
    var b = $223b3691249701c4$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $223b3691249701c4$var$Ye) return $223b3691249701c4$var$Xe[a] = b[c];
    return a;
}
var $223b3691249701c4$var$$e = $223b3691249701c4$var$Ze("animationend"), $223b3691249701c4$var$af = $223b3691249701c4$var$Ze("animationiteration"), $223b3691249701c4$var$bf = $223b3691249701c4$var$Ze("animationstart"), $223b3691249701c4$var$cf = $223b3691249701c4$var$Ze("transitionend"), $223b3691249701c4$var$df = new Map, $223b3691249701c4$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $223b3691249701c4$var$ff(a, b) {
    $223b3691249701c4$var$df.set(a, b);
    $223b3691249701c4$var$fa(b, [
        a
    ]);
}
for(var $223b3691249701c4$var$gf = 0; $223b3691249701c4$var$gf < $223b3691249701c4$var$ef.length; $223b3691249701c4$var$gf++){
    var $223b3691249701c4$var$hf = $223b3691249701c4$var$ef[$223b3691249701c4$var$gf], $223b3691249701c4$var$jf = $223b3691249701c4$var$hf.toLowerCase(), $223b3691249701c4$var$kf = $223b3691249701c4$var$hf[0].toUpperCase() + $223b3691249701c4$var$hf.slice(1);
    $223b3691249701c4$var$ff($223b3691249701c4$var$jf, "on" + $223b3691249701c4$var$kf);
}
$223b3691249701c4$var$ff($223b3691249701c4$var$$e, "onAnimationEnd");
$223b3691249701c4$var$ff($223b3691249701c4$var$af, "onAnimationIteration");
$223b3691249701c4$var$ff($223b3691249701c4$var$bf, "onAnimationStart");
$223b3691249701c4$var$ff("dblclick", "onDoubleClick");
$223b3691249701c4$var$ff("focusin", "onFocus");
$223b3691249701c4$var$ff("focusout", "onBlur");
$223b3691249701c4$var$ff($223b3691249701c4$var$cf, "onTransitionEnd");
$223b3691249701c4$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$223b3691249701c4$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$223b3691249701c4$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$223b3691249701c4$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$223b3691249701c4$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$223b3691249701c4$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$223b3691249701c4$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$223b3691249701c4$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$223b3691249701c4$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$223b3691249701c4$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $223b3691249701c4$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $223b3691249701c4$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($223b3691249701c4$var$lf));
function $223b3691249701c4$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $223b3691249701c4$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $223b3691249701c4$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $223b3691249701c4$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $223b3691249701c4$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($223b3691249701c4$var$Qb) throw a = $223b3691249701c4$var$Rb, $223b3691249701c4$var$Qb = !1, $223b3691249701c4$var$Rb = null, a;
}
function $223b3691249701c4$var$D(a, b) {
    var c = b[$223b3691249701c4$var$of];
    void 0 === c && (c = b[$223b3691249701c4$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($223b3691249701c4$var$pf(b, a, 2, !1), c.add(d));
}
function $223b3691249701c4$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $223b3691249701c4$var$pf(c, a, d, b);
}
var $223b3691249701c4$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $223b3691249701c4$var$sf(a) {
    if (!a[$223b3691249701c4$var$rf]) {
        a[$223b3691249701c4$var$rf] = !0;
        $223b3691249701c4$var$da.forEach(function(b) {
            "selectionchange" !== b && ($223b3691249701c4$var$mf.has(b) || $223b3691249701c4$var$qf(b, !1, a), $223b3691249701c4$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$223b3691249701c4$var$rf] || (b[$223b3691249701c4$var$rf] = !0, $223b3691249701c4$var$qf("selectionchange", !1, b));
    }
}
function $223b3691249701c4$var$pf(a, b, c, d) {
    switch($223b3691249701c4$var$jd(b)){
        case 1:
            var e = $223b3691249701c4$var$ed;
            break;
        case 4:
            e = $223b3691249701c4$var$gd;
            break;
        default:
            e = $223b3691249701c4$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$223b3691249701c4$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $223b3691249701c4$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $223b3691249701c4$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $223b3691249701c4$var$Jb(function() {
        var d = f, e = $223b3691249701c4$var$xb(c), g = [];
        a: {
            var h = $223b3691249701c4$var$df.get(a);
            if (void 0 !== h) {
                var k = $223b3691249701c4$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $223b3691249701c4$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $223b3691249701c4$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $223b3691249701c4$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $223b3691249701c4$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $223b3691249701c4$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $223b3691249701c4$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $223b3691249701c4$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $223b3691249701c4$var$Vd;
                        break;
                    case $223b3691249701c4$var$$e:
                    case $223b3691249701c4$var$af:
                    case $223b3691249701c4$var$bf:
                        k = $223b3691249701c4$var$Hd;
                        break;
                    case $223b3691249701c4$var$cf:
                        k = $223b3691249701c4$var$Xd;
                        break;
                    case "scroll":
                        k = $223b3691249701c4$var$vd;
                        break;
                    case "wheel":
                        k = $223b3691249701c4$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $223b3691249701c4$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $223b3691249701c4$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $223b3691249701c4$var$Kb(w, x), null != F && t.push($223b3691249701c4$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $223b3691249701c4$var$wb && (n = c.relatedTarget || c.fromElement) && ($223b3691249701c4$var$Wc(n) || n[$223b3691249701c4$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $223b3691249701c4$var$Wc(n) : null, null !== n && (J = $223b3691249701c4$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $223b3691249701c4$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $223b3691249701c4$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $223b3691249701c4$var$ue(k);
                        u = null == n ? h : $223b3691249701c4$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $223b3691249701c4$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $223b3691249701c4$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $223b3691249701c4$var$vf(F))u++;
                            for(; 0 < w - u;)t = $223b3691249701c4$var$vf(t), w--;
                            for(; 0 < u - w;)x = $223b3691249701c4$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $223b3691249701c4$var$vf(t);
                                x = $223b3691249701c4$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $223b3691249701c4$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $223b3691249701c4$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $223b3691249701c4$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $223b3691249701c4$var$ve;
                else if ($223b3691249701c4$var$me(h)) {
                    if ($223b3691249701c4$var$we) na = $223b3691249701c4$var$Fe;
                    else {
                        na = $223b3691249701c4$var$De;
                        var xa = $223b3691249701c4$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $223b3691249701c4$var$Ee);
                if (na && (na = na(a, d))) {
                    $223b3691249701c4$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $223b3691249701c4$var$cb(h, "number", h.value);
            }
            xa = d ? $223b3691249701c4$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($223b3691249701c4$var$me(xa) || "true" === xa.contentEditable) $223b3691249701c4$var$Qe = xa, $223b3691249701c4$var$Re = d, $223b3691249701c4$var$Se = null;
                    break;
                case "focusout":
                    $223b3691249701c4$var$Se = $223b3691249701c4$var$Re = $223b3691249701c4$var$Qe = null;
                    break;
                case "mousedown":
                    $223b3691249701c4$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $223b3691249701c4$var$Te = !1;
                    $223b3691249701c4$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($223b3691249701c4$var$Pe) break;
                case "keydown":
                case "keyup":
                    $223b3691249701c4$var$Ue(g, c, e);
            }
            var $a;
            if ($223b3691249701c4$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $223b3691249701c4$var$ie ? $223b3691249701c4$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($223b3691249701c4$var$de && "ko" !== c.locale && ($223b3691249701c4$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $223b3691249701c4$var$ie && ($a = $223b3691249701c4$var$nd()) : ($223b3691249701c4$var$kd = e, $223b3691249701c4$var$ld = "value" in $223b3691249701c4$var$kd ? $223b3691249701c4$var$kd.value : $223b3691249701c4$var$kd.textContent, $223b3691249701c4$var$ie = !0)), xa = $223b3691249701c4$var$oe(d, ba), 0 < xa.length && (ba = new $223b3691249701c4$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $223b3691249701c4$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $223b3691249701c4$var$ce ? $223b3691249701c4$var$je(a, c) : $223b3691249701c4$var$ke(a, c)) d = $223b3691249701c4$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $223b3691249701c4$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $223b3691249701c4$var$se(g, b);
    });
}
function $223b3691249701c4$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $223b3691249701c4$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $223b3691249701c4$var$Kb(a, c), null != f && d.unshift($223b3691249701c4$var$tf(a, f, e)), f = $223b3691249701c4$var$Kb(a, b), null != f && d.push($223b3691249701c4$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $223b3691249701c4$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $223b3691249701c4$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $223b3691249701c4$var$Kb(c, f), null != k && g.unshift($223b3691249701c4$var$tf(c, k, h))) : e || (k = $223b3691249701c4$var$Kb(c, f), null != k && g.push($223b3691249701c4$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $223b3691249701c4$var$xf = /\r\n?/g, $223b3691249701c4$var$yf = /\u0000|\uFFFD/g;
function $223b3691249701c4$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($223b3691249701c4$var$xf, "\n").replace($223b3691249701c4$var$yf, "");
}
function $223b3691249701c4$var$Af(a, b, c) {
    b = $223b3691249701c4$var$zf(b);
    if ($223b3691249701c4$var$zf(a) !== b && c) throw Error($223b3691249701c4$var$p(425));
}
function $223b3691249701c4$var$Bf() {}
var $223b3691249701c4$var$Cf = null, $223b3691249701c4$var$Df = null;
function $223b3691249701c4$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $223b3691249701c4$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $223b3691249701c4$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $223b3691249701c4$var$Hf = "function" === typeof Promise ? Promise : void 0, $223b3691249701c4$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $223b3691249701c4$var$Hf ? function(a) {
    return $223b3691249701c4$var$Hf.resolve(null).then(a).catch($223b3691249701c4$var$If);
} : $223b3691249701c4$var$Ff;
function $223b3691249701c4$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $223b3691249701c4$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $223b3691249701c4$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $223b3691249701c4$var$bd(b);
}
function $223b3691249701c4$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $223b3691249701c4$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $223b3691249701c4$var$Nf = Math.random().toString(36).slice(2), $223b3691249701c4$var$Of = "__reactFiber$" + $223b3691249701c4$var$Nf, $223b3691249701c4$var$Pf = "__reactProps$" + $223b3691249701c4$var$Nf, $223b3691249701c4$var$uf = "__reactContainer$" + $223b3691249701c4$var$Nf, $223b3691249701c4$var$of = "__reactEvents$" + $223b3691249701c4$var$Nf, $223b3691249701c4$var$Qf = "__reactListeners$" + $223b3691249701c4$var$Nf, $223b3691249701c4$var$Rf = "__reactHandles$" + $223b3691249701c4$var$Nf;
function $223b3691249701c4$var$Wc(a) {
    var b = a[$223b3691249701c4$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$223b3691249701c4$var$uf] || c[$223b3691249701c4$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $223b3691249701c4$var$Mf(a); null !== a;){
                if (c = a[$223b3691249701c4$var$Of]) return c;
                a = $223b3691249701c4$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $223b3691249701c4$var$Cb(a) {
    a = a[$223b3691249701c4$var$Of] || a[$223b3691249701c4$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $223b3691249701c4$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($223b3691249701c4$var$p(33));
}
function $223b3691249701c4$var$Db(a) {
    return a[$223b3691249701c4$var$Pf] || null;
}
var $223b3691249701c4$var$Sf = [], $223b3691249701c4$var$Tf = -1;
function $223b3691249701c4$var$Uf(a) {
    return {
        current: a
    };
}
function $223b3691249701c4$var$E(a) {
    0 > $223b3691249701c4$var$Tf || (a.current = $223b3691249701c4$var$Sf[$223b3691249701c4$var$Tf], $223b3691249701c4$var$Sf[$223b3691249701c4$var$Tf] = null, $223b3691249701c4$var$Tf--);
}
function $223b3691249701c4$var$G(a, b) {
    $223b3691249701c4$var$Tf++;
    $223b3691249701c4$var$Sf[$223b3691249701c4$var$Tf] = a.current;
    a.current = b;
}
var $223b3691249701c4$var$Vf = {}, $223b3691249701c4$var$H = $223b3691249701c4$var$Uf($223b3691249701c4$var$Vf), $223b3691249701c4$var$Wf = $223b3691249701c4$var$Uf(!1), $223b3691249701c4$var$Xf = $223b3691249701c4$var$Vf;
function $223b3691249701c4$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $223b3691249701c4$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $223b3691249701c4$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $223b3691249701c4$var$$f() {
    $223b3691249701c4$var$E($223b3691249701c4$var$Wf);
    $223b3691249701c4$var$E($223b3691249701c4$var$H);
}
function $223b3691249701c4$var$ag(a, b, c) {
    if ($223b3691249701c4$var$H.current !== $223b3691249701c4$var$Vf) throw Error($223b3691249701c4$var$p(168));
    $223b3691249701c4$var$G($223b3691249701c4$var$H, b);
    $223b3691249701c4$var$G($223b3691249701c4$var$Wf, c);
}
function $223b3691249701c4$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($223b3691249701c4$var$p(108, $223b3691249701c4$var$Ra(a) || "Unknown", e));
    return $223b3691249701c4$var$A({}, c, d);
}
function $223b3691249701c4$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $223b3691249701c4$var$Vf;
    $223b3691249701c4$var$Xf = $223b3691249701c4$var$H.current;
    $223b3691249701c4$var$G($223b3691249701c4$var$H, a);
    $223b3691249701c4$var$G($223b3691249701c4$var$Wf, $223b3691249701c4$var$Wf.current);
    return !0;
}
function $223b3691249701c4$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($223b3691249701c4$var$p(169));
    c ? (a = $223b3691249701c4$var$bg(a, b, $223b3691249701c4$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $223b3691249701c4$var$E($223b3691249701c4$var$Wf), $223b3691249701c4$var$E($223b3691249701c4$var$H), $223b3691249701c4$var$G($223b3691249701c4$var$H, a)) : $223b3691249701c4$var$E($223b3691249701c4$var$Wf);
    $223b3691249701c4$var$G($223b3691249701c4$var$Wf, c);
}
var $223b3691249701c4$var$eg = null, $223b3691249701c4$var$fg = !1, $223b3691249701c4$var$gg = !1;
function $223b3691249701c4$var$hg(a) {
    null === $223b3691249701c4$var$eg ? $223b3691249701c4$var$eg = [
        a
    ] : $223b3691249701c4$var$eg.push(a);
}
function $223b3691249701c4$var$ig(a) {
    $223b3691249701c4$var$fg = !0;
    $223b3691249701c4$var$hg(a);
}
function $223b3691249701c4$var$jg() {
    if (!$223b3691249701c4$var$gg && null !== $223b3691249701c4$var$eg) {
        $223b3691249701c4$var$gg = !0;
        var a = 0, b = $223b3691249701c4$var$C;
        try {
            var c = $223b3691249701c4$var$eg;
            for($223b3691249701c4$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $223b3691249701c4$var$eg = null;
            $223b3691249701c4$var$fg = !1;
        } catch (e) {
            throw null !== $223b3691249701c4$var$eg && ($223b3691249701c4$var$eg = $223b3691249701c4$var$eg.slice(a + 1)), $223b3691249701c4$var$ac($223b3691249701c4$var$fc, $223b3691249701c4$var$jg), e;
        } finally{
            $223b3691249701c4$var$C = b, $223b3691249701c4$var$gg = !1;
        }
    }
    return null;
}
var $223b3691249701c4$var$kg = [], $223b3691249701c4$var$lg = 0, $223b3691249701c4$var$mg = null, $223b3691249701c4$var$ng = 0, $223b3691249701c4$var$og = [], $223b3691249701c4$var$pg = 0, $223b3691249701c4$var$qg = null, $223b3691249701c4$var$rg = 1, $223b3691249701c4$var$sg = "";
function $223b3691249701c4$var$tg(a, b) {
    $223b3691249701c4$var$kg[$223b3691249701c4$var$lg++] = $223b3691249701c4$var$ng;
    $223b3691249701c4$var$kg[$223b3691249701c4$var$lg++] = $223b3691249701c4$var$mg;
    $223b3691249701c4$var$mg = a;
    $223b3691249701c4$var$ng = b;
}
function $223b3691249701c4$var$ug(a, b, c) {
    $223b3691249701c4$var$og[$223b3691249701c4$var$pg++] = $223b3691249701c4$var$rg;
    $223b3691249701c4$var$og[$223b3691249701c4$var$pg++] = $223b3691249701c4$var$sg;
    $223b3691249701c4$var$og[$223b3691249701c4$var$pg++] = $223b3691249701c4$var$qg;
    $223b3691249701c4$var$qg = a;
    var d = $223b3691249701c4$var$rg;
    a = $223b3691249701c4$var$sg;
    var e = 32 - $223b3691249701c4$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $223b3691249701c4$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $223b3691249701c4$var$rg = 1 << 32 - $223b3691249701c4$var$oc(b) + e | c << e | d;
        $223b3691249701c4$var$sg = f + a;
    } else $223b3691249701c4$var$rg = 1 << f | c << e | d, $223b3691249701c4$var$sg = a;
}
function $223b3691249701c4$var$vg(a) {
    null !== a.return && ($223b3691249701c4$var$tg(a, 1), $223b3691249701c4$var$ug(a, 1, 0));
}
function $223b3691249701c4$var$wg(a) {
    for(; a === $223b3691249701c4$var$mg;)$223b3691249701c4$var$mg = $223b3691249701c4$var$kg[--$223b3691249701c4$var$lg], $223b3691249701c4$var$kg[$223b3691249701c4$var$lg] = null, $223b3691249701c4$var$ng = $223b3691249701c4$var$kg[--$223b3691249701c4$var$lg], $223b3691249701c4$var$kg[$223b3691249701c4$var$lg] = null;
    for(; a === $223b3691249701c4$var$qg;)$223b3691249701c4$var$qg = $223b3691249701c4$var$og[--$223b3691249701c4$var$pg], $223b3691249701c4$var$og[$223b3691249701c4$var$pg] = null, $223b3691249701c4$var$sg = $223b3691249701c4$var$og[--$223b3691249701c4$var$pg], $223b3691249701c4$var$og[$223b3691249701c4$var$pg] = null, $223b3691249701c4$var$rg = $223b3691249701c4$var$og[--$223b3691249701c4$var$pg], $223b3691249701c4$var$og[$223b3691249701c4$var$pg] = null;
}
var $223b3691249701c4$var$xg = null, $223b3691249701c4$var$yg = null, $223b3691249701c4$var$I = !1, $223b3691249701c4$var$zg = null;
function $223b3691249701c4$var$Ag(a, b) {
    var c = $223b3691249701c4$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $223b3691249701c4$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $223b3691249701c4$var$xg = a, $223b3691249701c4$var$yg = $223b3691249701c4$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $223b3691249701c4$var$xg = a, $223b3691249701c4$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $223b3691249701c4$var$qg ? {
                id: $223b3691249701c4$var$rg,
                overflow: $223b3691249701c4$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $223b3691249701c4$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $223b3691249701c4$var$xg = a, $223b3691249701c4$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $223b3691249701c4$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $223b3691249701c4$var$Eg(a) {
    if ($223b3691249701c4$var$I) {
        var b = $223b3691249701c4$var$yg;
        if (b) {
            var c = b;
            if (!$223b3691249701c4$var$Cg(a, b)) {
                if ($223b3691249701c4$var$Dg(a)) throw Error($223b3691249701c4$var$p(418));
                b = $223b3691249701c4$var$Lf(c.nextSibling);
                var d = $223b3691249701c4$var$xg;
                b && $223b3691249701c4$var$Cg(a, b) ? $223b3691249701c4$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $223b3691249701c4$var$I = !1, $223b3691249701c4$var$xg = a);
            }
        } else {
            if ($223b3691249701c4$var$Dg(a)) throw Error($223b3691249701c4$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $223b3691249701c4$var$I = !1;
            $223b3691249701c4$var$xg = a;
        }
    }
}
function $223b3691249701c4$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $223b3691249701c4$var$xg = a;
}
function $223b3691249701c4$var$Gg(a) {
    if (a !== $223b3691249701c4$var$xg) return !1;
    if (!$223b3691249701c4$var$I) return $223b3691249701c4$var$Fg(a), $223b3691249701c4$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$223b3691249701c4$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $223b3691249701c4$var$yg)) {
        if ($223b3691249701c4$var$Dg(a)) throw $223b3691249701c4$var$Hg(), Error($223b3691249701c4$var$p(418));
        for(; b;)$223b3691249701c4$var$Ag(a, b), b = $223b3691249701c4$var$Lf(b.nextSibling);
    }
    $223b3691249701c4$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($223b3691249701c4$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $223b3691249701c4$var$yg = $223b3691249701c4$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $223b3691249701c4$var$yg = null;
        }
    } else $223b3691249701c4$var$yg = $223b3691249701c4$var$xg ? $223b3691249701c4$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $223b3691249701c4$var$Hg() {
    for(var a = $223b3691249701c4$var$yg; a;)a = $223b3691249701c4$var$Lf(a.nextSibling);
}
function $223b3691249701c4$var$Ig() {
    $223b3691249701c4$var$yg = $223b3691249701c4$var$xg = null;
    $223b3691249701c4$var$I = !1;
}
function $223b3691249701c4$var$Jg(a) {
    null === $223b3691249701c4$var$zg ? $223b3691249701c4$var$zg = [
        a
    ] : $223b3691249701c4$var$zg.push(a);
}
var $223b3691249701c4$var$Kg = $223b3691249701c4$var$ua.ReactCurrentBatchConfig;
function $223b3691249701c4$var$Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($223b3691249701c4$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($223b3691249701c4$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($223b3691249701c4$var$p(284));
        if (!c._owner) throw Error($223b3691249701c4$var$p(290, a));
    }
    return a;
}
function $223b3691249701c4$var$Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($223b3691249701c4$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $223b3691249701c4$var$Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function $223b3691249701c4$var$Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $223b3691249701c4$var$Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $223b3691249701c4$var$Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $223b3691249701c4$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $223b3691249701c4$var$Ha && $223b3691249701c4$var$Ng(f) === b.type)) return d = e(b, c.props), d.ref = $223b3691249701c4$var$Lg(a, b, c), d.return = a, d;
        d = $223b3691249701c4$var$Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $223b3691249701c4$var$Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $223b3691249701c4$var$Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $223b3691249701c4$var$Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $223b3691249701c4$var$Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $223b3691249701c4$var$va:
                    return c = $223b3691249701c4$var$Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = $223b3691249701c4$var$Lg(a, null, b), c.return = a, c;
                case $223b3691249701c4$var$wa:
                    return b = $223b3691249701c4$var$Sg(b, a.mode, c), b.return = a, b;
                case $223b3691249701c4$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($223b3691249701c4$var$eb(b) || $223b3691249701c4$var$Ka(b)) return b = $223b3691249701c4$var$Tg(b, a.mode, c, null), b.return = a, b;
            $223b3691249701c4$var$Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $223b3691249701c4$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $223b3691249701c4$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $223b3691249701c4$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($223b3691249701c4$var$eb(c) || $223b3691249701c4$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $223b3691249701c4$var$Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $223b3691249701c4$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $223b3691249701c4$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $223b3691249701c4$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($223b3691249701c4$var$eb(d) || $223b3691249701c4$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $223b3691249701c4$var$Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $223b3691249701c4$var$I && $223b3691249701c4$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $223b3691249701c4$var$I && $223b3691249701c4$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $223b3691249701c4$var$I && $223b3691249701c4$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $223b3691249701c4$var$Ka(h);
        if ("function" !== typeof l) throw Error($223b3691249701c4$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($223b3691249701c4$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $223b3691249701c4$var$I && $223b3691249701c4$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $223b3691249701c4$var$I && $223b3691249701c4$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $223b3691249701c4$var$I && $223b3691249701c4$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $223b3691249701c4$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $223b3691249701c4$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $223b3691249701c4$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $223b3691249701c4$var$Ha && $223b3691249701c4$var$Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $223b3691249701c4$var$Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $223b3691249701c4$var$ya ? (d = $223b3691249701c4$var$Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $223b3691249701c4$var$Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = $223b3691249701c4$var$Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $223b3691249701c4$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $223b3691249701c4$var$Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $223b3691249701c4$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($223b3691249701c4$var$eb(f)) return n(a, d, f, h);
            if ($223b3691249701c4$var$Ka(f)) return t(a, d, f, h);
            $223b3691249701c4$var$Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $223b3691249701c4$var$Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $223b3691249701c4$var$Ug = $223b3691249701c4$var$Og(!0), $223b3691249701c4$var$Vg = $223b3691249701c4$var$Og(!1), $223b3691249701c4$var$Wg = $223b3691249701c4$var$Uf(null), $223b3691249701c4$var$Xg = null, $223b3691249701c4$var$Yg = null, $223b3691249701c4$var$Zg = null;
function $223b3691249701c4$var$$g() {
    $223b3691249701c4$var$Zg = $223b3691249701c4$var$Yg = $223b3691249701c4$var$Xg = null;
}
function $223b3691249701c4$var$ah(a) {
    var b = $223b3691249701c4$var$Wg.current;
    $223b3691249701c4$var$E($223b3691249701c4$var$Wg);
    a._currentValue = b;
}
function $223b3691249701c4$var$bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $223b3691249701c4$var$ch(a, b) {
    $223b3691249701c4$var$Xg = a;
    $223b3691249701c4$var$Zg = $223b3691249701c4$var$Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($223b3691249701c4$var$dh = !0), a.firstContext = null);
}
function $223b3691249701c4$var$eh(a) {
    var b = a._currentValue;
    if ($223b3691249701c4$var$Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $223b3691249701c4$var$Yg) {
            if (null === $223b3691249701c4$var$Xg) throw Error($223b3691249701c4$var$p(308));
            $223b3691249701c4$var$Yg = a;
            $223b3691249701c4$var$Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $223b3691249701c4$var$Yg = $223b3691249701c4$var$Yg.next = a;
    }
    return b;
}
var $223b3691249701c4$var$fh = null;
function $223b3691249701c4$var$gh(a) {
    null === $223b3691249701c4$var$fh ? $223b3691249701c4$var$fh = [
        a
    ] : $223b3691249701c4$var$fh.push(a);
}
function $223b3691249701c4$var$hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $223b3691249701c4$var$gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $223b3691249701c4$var$ih(a, d);
}
function $223b3691249701c4$var$ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $223b3691249701c4$var$jh = !1;
function $223b3691249701c4$var$kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $223b3691249701c4$var$lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $223b3691249701c4$var$mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $223b3691249701c4$var$nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($223b3691249701c4$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $223b3691249701c4$var$ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $223b3691249701c4$var$gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $223b3691249701c4$var$ih(a, c);
}
function $223b3691249701c4$var$oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $223b3691249701c4$var$Cc(a, c);
    }
}
function $223b3691249701c4$var$ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $223b3691249701c4$var$qh(a, b, c, d) {
    var e = a.updateQueue;
    $223b3691249701c4$var$jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $223b3691249701c4$var$A({}, q, r);
                            break a;
                        case 2:
                            $223b3691249701c4$var$jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $223b3691249701c4$var$rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $223b3691249701c4$var$sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($223b3691249701c4$var$p(191, e));
            e.call(d);
        }
    }
}
var $223b3691249701c4$var$th = {}, $223b3691249701c4$var$uh = $223b3691249701c4$var$Uf($223b3691249701c4$var$th), $223b3691249701c4$var$vh = $223b3691249701c4$var$Uf($223b3691249701c4$var$th), $223b3691249701c4$var$wh = $223b3691249701c4$var$Uf($223b3691249701c4$var$th);
function $223b3691249701c4$var$xh(a) {
    if (a === $223b3691249701c4$var$th) throw Error($223b3691249701c4$var$p(174));
    return a;
}
function $223b3691249701c4$var$yh(a, b) {
    $223b3691249701c4$var$G($223b3691249701c4$var$wh, b);
    $223b3691249701c4$var$G($223b3691249701c4$var$vh, a);
    $223b3691249701c4$var$G($223b3691249701c4$var$uh, $223b3691249701c4$var$th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $223b3691249701c4$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $223b3691249701c4$var$lb(b, a);
    }
    $223b3691249701c4$var$E($223b3691249701c4$var$uh);
    $223b3691249701c4$var$G($223b3691249701c4$var$uh, b);
}
function $223b3691249701c4$var$zh() {
    $223b3691249701c4$var$E($223b3691249701c4$var$uh);
    $223b3691249701c4$var$E($223b3691249701c4$var$vh);
    $223b3691249701c4$var$E($223b3691249701c4$var$wh);
}
function $223b3691249701c4$var$Ah(a) {
    $223b3691249701c4$var$xh($223b3691249701c4$var$wh.current);
    var b = $223b3691249701c4$var$xh($223b3691249701c4$var$uh.current);
    var c = $223b3691249701c4$var$lb(b, a.type);
    b !== c && ($223b3691249701c4$var$G($223b3691249701c4$var$vh, a), $223b3691249701c4$var$G($223b3691249701c4$var$uh, c));
}
function $223b3691249701c4$var$Bh(a) {
    $223b3691249701c4$var$vh.current === a && ($223b3691249701c4$var$E($223b3691249701c4$var$uh), $223b3691249701c4$var$E($223b3691249701c4$var$vh));
}
var $223b3691249701c4$var$L = $223b3691249701c4$var$Uf(0);
function $223b3691249701c4$var$Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $223b3691249701c4$var$Dh = [];
function $223b3691249701c4$var$Eh() {
    for(var a = 0; a < $223b3691249701c4$var$Dh.length; a++)$223b3691249701c4$var$Dh[a]._workInProgressVersionPrimary = null;
    $223b3691249701c4$var$Dh.length = 0;
}
var $223b3691249701c4$var$Fh = $223b3691249701c4$var$ua.ReactCurrentDispatcher, $223b3691249701c4$var$Gh = $223b3691249701c4$var$ua.ReactCurrentBatchConfig, $223b3691249701c4$var$Hh = 0, $223b3691249701c4$var$M = null, $223b3691249701c4$var$N = null, $223b3691249701c4$var$O = null, $223b3691249701c4$var$Ih = !1, $223b3691249701c4$var$Jh = !1, $223b3691249701c4$var$Kh = 0, $223b3691249701c4$var$Lh = 0;
function $223b3691249701c4$var$P() {
    throw Error($223b3691249701c4$var$p(321));
}
function $223b3691249701c4$var$Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$223b3691249701c4$var$He(a[c], b[c])) return !1;
    return !0;
}
function $223b3691249701c4$var$Nh(a, b, c, d, e, f) {
    $223b3691249701c4$var$Hh = f;
    $223b3691249701c4$var$M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $223b3691249701c4$var$Fh.current = null === a || null === a.memoizedState ? $223b3691249701c4$var$Oh : $223b3691249701c4$var$Ph;
    a = c(d, e);
    if ($223b3691249701c4$var$Jh) {
        f = 0;
        do {
            $223b3691249701c4$var$Jh = !1;
            $223b3691249701c4$var$Kh = 0;
            if (25 <= f) throw Error($223b3691249701c4$var$p(301));
            f += 1;
            $223b3691249701c4$var$O = $223b3691249701c4$var$N = null;
            b.updateQueue = null;
            $223b3691249701c4$var$Fh.current = $223b3691249701c4$var$Qh;
            a = c(d, e);
        }while ($223b3691249701c4$var$Jh);
    }
    $223b3691249701c4$var$Fh.current = $223b3691249701c4$var$Rh;
    b = null !== $223b3691249701c4$var$N && null !== $223b3691249701c4$var$N.next;
    $223b3691249701c4$var$Hh = 0;
    $223b3691249701c4$var$O = $223b3691249701c4$var$N = $223b3691249701c4$var$M = null;
    $223b3691249701c4$var$Ih = !1;
    if (b) throw Error($223b3691249701c4$var$p(300));
    return a;
}
function $223b3691249701c4$var$Sh() {
    var a = 0 !== $223b3691249701c4$var$Kh;
    $223b3691249701c4$var$Kh = 0;
    return a;
}
function $223b3691249701c4$var$Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $223b3691249701c4$var$O ? $223b3691249701c4$var$M.memoizedState = $223b3691249701c4$var$O = a : $223b3691249701c4$var$O = $223b3691249701c4$var$O.next = a;
    return $223b3691249701c4$var$O;
}
function $223b3691249701c4$var$Uh() {
    if (null === $223b3691249701c4$var$N) {
        var a = $223b3691249701c4$var$M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $223b3691249701c4$var$N.next;
    var b = null === $223b3691249701c4$var$O ? $223b3691249701c4$var$M.memoizedState : $223b3691249701c4$var$O.next;
    if (null !== b) $223b3691249701c4$var$O = b, $223b3691249701c4$var$N = a;
    else {
        if (null === a) throw Error($223b3691249701c4$var$p(310));
        $223b3691249701c4$var$N = a;
        a = {
            memoizedState: $223b3691249701c4$var$N.memoizedState,
            baseState: $223b3691249701c4$var$N.baseState,
            baseQueue: $223b3691249701c4$var$N.baseQueue,
            queue: $223b3691249701c4$var$N.queue,
            next: null
        };
        null === $223b3691249701c4$var$O ? $223b3691249701c4$var$M.memoizedState = $223b3691249701c4$var$O = a : $223b3691249701c4$var$O = $223b3691249701c4$var$O.next = a;
    }
    return $223b3691249701c4$var$O;
}
function $223b3691249701c4$var$Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $223b3691249701c4$var$Wh(a) {
    var b = $223b3691249701c4$var$Uh(), c = b.queue;
    if (null === c) throw Error($223b3691249701c4$var$p(311));
    c.lastRenderedReducer = a;
    var d = $223b3691249701c4$var$N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($223b3691249701c4$var$Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $223b3691249701c4$var$M.lanes |= m;
                $223b3691249701c4$var$rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $223b3691249701c4$var$He(d, b.memoizedState) || ($223b3691249701c4$var$dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $223b3691249701c4$var$M.lanes |= f, $223b3691249701c4$var$rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $223b3691249701c4$var$Xh(a) {
    var b = $223b3691249701c4$var$Uh(), c = b.queue;
    if (null === c) throw Error($223b3691249701c4$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $223b3691249701c4$var$He(f, b.memoizedState) || ($223b3691249701c4$var$dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $223b3691249701c4$var$Yh() {}
function $223b3691249701c4$var$Zh(a, b) {
    var c = $223b3691249701c4$var$M, d = $223b3691249701c4$var$Uh(), e = b(), f = !$223b3691249701c4$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $223b3691249701c4$var$dh = !0);
    d = d.queue;
    $223b3691249701c4$var$$h($223b3691249701c4$var$ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $223b3691249701c4$var$O && $223b3691249701c4$var$O.memoizedState.tag & 1) {
        c.flags |= 2048;
        $223b3691249701c4$var$bi(9, $223b3691249701c4$var$ci.bind(null, c, d, e, b), void 0, null);
        if (null === $223b3691249701c4$var$Q) throw Error($223b3691249701c4$var$p(349));
        0 !== ($223b3691249701c4$var$Hh & 30) || $223b3691249701c4$var$di(c, b, e);
    }
    return e;
}
function $223b3691249701c4$var$di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $223b3691249701c4$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $223b3691249701c4$var$M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $223b3691249701c4$var$ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $223b3691249701c4$var$ei(b) && $223b3691249701c4$var$fi(a);
}
function $223b3691249701c4$var$ai(a, b, c) {
    return c(function() {
        $223b3691249701c4$var$ei(b) && $223b3691249701c4$var$fi(a);
    });
}
function $223b3691249701c4$var$ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$223b3691249701c4$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $223b3691249701c4$var$fi(a) {
    var b = $223b3691249701c4$var$ih(a, 1);
    null !== b && $223b3691249701c4$var$gi(b, a, 1, -1);
}
function $223b3691249701c4$var$hi(a) {
    var b = $223b3691249701c4$var$Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $223b3691249701c4$var$Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $223b3691249701c4$var$ii.bind(null, $223b3691249701c4$var$M, a);
    return [
        b.memoizedState,
        a
    ];
}
function $223b3691249701c4$var$bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $223b3691249701c4$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $223b3691249701c4$var$M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $223b3691249701c4$var$ji() {
    return $223b3691249701c4$var$Uh().memoizedState;
}
function $223b3691249701c4$var$ki(a, b, c, d) {
    var e = $223b3691249701c4$var$Th();
    $223b3691249701c4$var$M.flags |= a;
    e.memoizedState = $223b3691249701c4$var$bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function $223b3691249701c4$var$li(a, b, c, d) {
    var e = $223b3691249701c4$var$Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $223b3691249701c4$var$N) {
        var g = $223b3691249701c4$var$N.memoizedState;
        f = g.destroy;
        if (null !== d && $223b3691249701c4$var$Mh(d, g.deps)) {
            e.memoizedState = $223b3691249701c4$var$bi(b, c, f, d);
            return;
        }
    }
    $223b3691249701c4$var$M.flags |= a;
    e.memoizedState = $223b3691249701c4$var$bi(1 | b, c, f, d);
}
function $223b3691249701c4$var$mi(a, b) {
    return $223b3691249701c4$var$ki(8390656, 8, a, b);
}
function $223b3691249701c4$var$$h(a, b) {
    return $223b3691249701c4$var$li(2048, 8, a, b);
}
function $223b3691249701c4$var$ni(a, b) {
    return $223b3691249701c4$var$li(4, 2, a, b);
}
function $223b3691249701c4$var$oi(a, b) {
    return $223b3691249701c4$var$li(4, 4, a, b);
}
function $223b3691249701c4$var$pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $223b3691249701c4$var$qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $223b3691249701c4$var$li(4, 4, $223b3691249701c4$var$pi.bind(null, b, a), c);
}
function $223b3691249701c4$var$ri() {}
function $223b3691249701c4$var$si(a, b) {
    var c = $223b3691249701c4$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $223b3691249701c4$var$Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $223b3691249701c4$var$ti(a, b) {
    var c = $223b3691249701c4$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $223b3691249701c4$var$Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $223b3691249701c4$var$ui(a, b, c) {
    if (0 === ($223b3691249701c4$var$Hh & 21)) return a.baseState && (a.baseState = !1, $223b3691249701c4$var$dh = !0), a.memoizedState = c;
    $223b3691249701c4$var$He(c, b) || (c = $223b3691249701c4$var$yc(), $223b3691249701c4$var$M.lanes |= c, $223b3691249701c4$var$rh |= c, a.baseState = !0);
    return b;
}
function $223b3691249701c4$var$vi(a, b) {
    var c = $223b3691249701c4$var$C;
    $223b3691249701c4$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $223b3691249701c4$var$Gh.transition;
    $223b3691249701c4$var$Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        $223b3691249701c4$var$C = c, $223b3691249701c4$var$Gh.transition = d;
    }
}
function $223b3691249701c4$var$wi() {
    return $223b3691249701c4$var$Uh().memoizedState;
}
function $223b3691249701c4$var$xi(a, b, c) {
    var d = $223b3691249701c4$var$yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($223b3691249701c4$var$zi(a)) $223b3691249701c4$var$Ai(b, c);
    else if (c = $223b3691249701c4$var$hh(a, b, c, d), null !== c) {
        var e = $223b3691249701c4$var$R();
        $223b3691249701c4$var$gi(c, a, d, e);
        $223b3691249701c4$var$Bi(c, b, d);
    }
}
function $223b3691249701c4$var$ii(a, b, c) {
    var d = $223b3691249701c4$var$yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($223b3691249701c4$var$zi(a)) $223b3691249701c4$var$Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($223b3691249701c4$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $223b3691249701c4$var$gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $223b3691249701c4$var$hh(a, b, e, d);
        null !== c && (e = $223b3691249701c4$var$R(), $223b3691249701c4$var$gi(c, a, d, e), $223b3691249701c4$var$Bi(c, b, d));
    }
}
function $223b3691249701c4$var$zi(a) {
    var b = a.alternate;
    return a === $223b3691249701c4$var$M || null !== b && b === $223b3691249701c4$var$M;
}
function $223b3691249701c4$var$Ai(a, b) {
    $223b3691249701c4$var$Jh = $223b3691249701c4$var$Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $223b3691249701c4$var$Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $223b3691249701c4$var$Cc(a, c);
    }
}
var $223b3691249701c4$var$Rh = {
    readContext: $223b3691249701c4$var$eh,
    useCallback: $223b3691249701c4$var$P,
    useContext: $223b3691249701c4$var$P,
    useEffect: $223b3691249701c4$var$P,
    useImperativeHandle: $223b3691249701c4$var$P,
    useInsertionEffect: $223b3691249701c4$var$P,
    useLayoutEffect: $223b3691249701c4$var$P,
    useMemo: $223b3691249701c4$var$P,
    useReducer: $223b3691249701c4$var$P,
    useRef: $223b3691249701c4$var$P,
    useState: $223b3691249701c4$var$P,
    useDebugValue: $223b3691249701c4$var$P,
    useDeferredValue: $223b3691249701c4$var$P,
    useTransition: $223b3691249701c4$var$P,
    useMutableSource: $223b3691249701c4$var$P,
    useSyncExternalStore: $223b3691249701c4$var$P,
    useId: $223b3691249701c4$var$P,
    unstable_isNewReconciler: !1
}, $223b3691249701c4$var$Oh = {
    readContext: $223b3691249701c4$var$eh,
    useCallback: function(a, b) {
        $223b3691249701c4$var$Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $223b3691249701c4$var$eh,
    useEffect: $223b3691249701c4$var$mi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $223b3691249701c4$var$ki(4194308, 4, $223b3691249701c4$var$pi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $223b3691249701c4$var$ki(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $223b3691249701c4$var$ki(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $223b3691249701c4$var$Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $223b3691249701c4$var$Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $223b3691249701c4$var$xi.bind(null, $223b3691249701c4$var$M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $223b3691249701c4$var$Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $223b3691249701c4$var$hi,
    useDebugValue: $223b3691249701c4$var$ri,
    useDeferredValue: function(a) {
        return $223b3691249701c4$var$Th().memoizedState = a;
    },
    useTransition: function() {
        var a = $223b3691249701c4$var$hi(!1), b = a[0];
        a = $223b3691249701c4$var$vi.bind(null, a[1]);
        $223b3691249701c4$var$Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $223b3691249701c4$var$M, e = $223b3691249701c4$var$Th();
        if ($223b3691249701c4$var$I) {
            if (void 0 === c) throw Error($223b3691249701c4$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $223b3691249701c4$var$Q) throw Error($223b3691249701c4$var$p(349));
            0 !== ($223b3691249701c4$var$Hh & 30) || $223b3691249701c4$var$di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $223b3691249701c4$var$mi($223b3691249701c4$var$ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $223b3691249701c4$var$bi(9, $223b3691249701c4$var$ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $223b3691249701c4$var$Th(), b = $223b3691249701c4$var$Q.identifierPrefix;
        if ($223b3691249701c4$var$I) {
            var c = $223b3691249701c4$var$sg;
            var d = $223b3691249701c4$var$rg;
            c = (d & ~(1 << 32 - $223b3691249701c4$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $223b3691249701c4$var$Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $223b3691249701c4$var$Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $223b3691249701c4$var$Ph = {
    readContext: $223b3691249701c4$var$eh,
    useCallback: $223b3691249701c4$var$si,
    useContext: $223b3691249701c4$var$eh,
    useEffect: $223b3691249701c4$var$$h,
    useImperativeHandle: $223b3691249701c4$var$qi,
    useInsertionEffect: $223b3691249701c4$var$ni,
    useLayoutEffect: $223b3691249701c4$var$oi,
    useMemo: $223b3691249701c4$var$ti,
    useReducer: $223b3691249701c4$var$Wh,
    useRef: $223b3691249701c4$var$ji,
    useState: function() {
        return $223b3691249701c4$var$Wh($223b3691249701c4$var$Vh);
    },
    useDebugValue: $223b3691249701c4$var$ri,
    useDeferredValue: function(a) {
        var b = $223b3691249701c4$var$Uh();
        return $223b3691249701c4$var$ui(b, $223b3691249701c4$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $223b3691249701c4$var$Wh($223b3691249701c4$var$Vh)[0], b = $223b3691249701c4$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $223b3691249701c4$var$Yh,
    useSyncExternalStore: $223b3691249701c4$var$Zh,
    useId: $223b3691249701c4$var$wi,
    unstable_isNewReconciler: !1
}, $223b3691249701c4$var$Qh = {
    readContext: $223b3691249701c4$var$eh,
    useCallback: $223b3691249701c4$var$si,
    useContext: $223b3691249701c4$var$eh,
    useEffect: $223b3691249701c4$var$$h,
    useImperativeHandle: $223b3691249701c4$var$qi,
    useInsertionEffect: $223b3691249701c4$var$ni,
    useLayoutEffect: $223b3691249701c4$var$oi,
    useMemo: $223b3691249701c4$var$ti,
    useReducer: $223b3691249701c4$var$Xh,
    useRef: $223b3691249701c4$var$ji,
    useState: function() {
        return $223b3691249701c4$var$Xh($223b3691249701c4$var$Vh);
    },
    useDebugValue: $223b3691249701c4$var$ri,
    useDeferredValue: function(a) {
        var b = $223b3691249701c4$var$Uh();
        return null === $223b3691249701c4$var$N ? b.memoizedState = a : $223b3691249701c4$var$ui(b, $223b3691249701c4$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $223b3691249701c4$var$Xh($223b3691249701c4$var$Vh)[0], b = $223b3691249701c4$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $223b3691249701c4$var$Yh,
    useSyncExternalStore: $223b3691249701c4$var$Zh,
    useId: $223b3691249701c4$var$wi,
    unstable_isNewReconciler: !1
};
function $223b3691249701c4$var$Ci(a, b) {
    if (a && a.defaultProps) {
        b = $223b3691249701c4$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $223b3691249701c4$var$Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $223b3691249701c4$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $223b3691249701c4$var$Ei = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $223b3691249701c4$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $223b3691249701c4$var$R(), e = $223b3691249701c4$var$yi(a), f = $223b3691249701c4$var$mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $223b3691249701c4$var$nh(a, f, e);
        null !== b && ($223b3691249701c4$var$gi(b, a, e, d), $223b3691249701c4$var$oh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $223b3691249701c4$var$R(), e = $223b3691249701c4$var$yi(a), f = $223b3691249701c4$var$mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $223b3691249701c4$var$nh(a, f, e);
        null !== b && ($223b3691249701c4$var$gi(b, a, e, d), $223b3691249701c4$var$oh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $223b3691249701c4$var$R(), d = $223b3691249701c4$var$yi(a), e = $223b3691249701c4$var$mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $223b3691249701c4$var$nh(a, e, d);
        null !== b && ($223b3691249701c4$var$gi(b, a, d, c), $223b3691249701c4$var$oh(b, a, d));
    }
};
function $223b3691249701c4$var$Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$223b3691249701c4$var$Ie(c, d) || !$223b3691249701c4$var$Ie(e, f) : !0;
}
function $223b3691249701c4$var$Gi(a, b, c) {
    var d = !1, e = $223b3691249701c4$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $223b3691249701c4$var$eh(f) : (e = $223b3691249701c4$var$Zf(b) ? $223b3691249701c4$var$Xf : $223b3691249701c4$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $223b3691249701c4$var$Yf(a, e) : $223b3691249701c4$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $223b3691249701c4$var$Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $223b3691249701c4$var$Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $223b3691249701c4$var$Ei.enqueueReplaceState(b, b.state, null);
}
function $223b3691249701c4$var$Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    $223b3691249701c4$var$kh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $223b3691249701c4$var$eh(f) : (f = $223b3691249701c4$var$Zf(b) ? $223b3691249701c4$var$Xf : $223b3691249701c4$var$H.current, e.context = $223b3691249701c4$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($223b3691249701c4$var$Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $223b3691249701c4$var$Ei.enqueueReplaceState(e, e.state, null), $223b3691249701c4$var$qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $223b3691249701c4$var$Ji(a, b) {
    try {
        var c = "", d = b;
        do c += $223b3691249701c4$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $223b3691249701c4$var$Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $223b3691249701c4$var$Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $223b3691249701c4$var$Mi = "function" === typeof WeakMap ? WeakMap : Map;
function $223b3691249701c4$var$Ni(a, b, c) {
    c = $223b3691249701c4$var$mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $223b3691249701c4$var$Oi || ($223b3691249701c4$var$Oi = !0, $223b3691249701c4$var$Pi = d);
        $223b3691249701c4$var$Li(a, b);
    };
    return c;
}
function $223b3691249701c4$var$Qi(a, b, c) {
    c = $223b3691249701c4$var$mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $223b3691249701c4$var$Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $223b3691249701c4$var$Li(a, b);
        "function" !== typeof d && (null === $223b3691249701c4$var$Ri ? $223b3691249701c4$var$Ri = new Set([
            this
        ]) : $223b3691249701c4$var$Ri.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $223b3691249701c4$var$Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $223b3691249701c4$var$Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $223b3691249701c4$var$Ti.bind(null, a, b, c), b.then(a, a));
}
function $223b3691249701c4$var$Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $223b3691249701c4$var$Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $223b3691249701c4$var$mh(-1, 1), b.tag = 2, $223b3691249701c4$var$nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $223b3691249701c4$var$Wi = $223b3691249701c4$var$ua.ReactCurrentOwner, $223b3691249701c4$var$dh = !1;
function $223b3691249701c4$var$Xi(a, b, c, d) {
    b.child = null === a ? $223b3691249701c4$var$Vg(b, null, c, d) : $223b3691249701c4$var$Ug(b, a.child, c, d);
}
function $223b3691249701c4$var$Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $223b3691249701c4$var$ch(b, e);
    d = $223b3691249701c4$var$Nh(a, b, c, d, f, e);
    c = $223b3691249701c4$var$Sh();
    if (null !== a && !$223b3691249701c4$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $223b3691249701c4$var$Zi(a, b, e);
    $223b3691249701c4$var$I && c && $223b3691249701c4$var$vg(b);
    b.flags |= 1;
    $223b3691249701c4$var$Xi(a, b, d, e);
    return b.child;
}
function $223b3691249701c4$var$$i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$223b3691249701c4$var$aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $223b3691249701c4$var$bj(a, b, f, d, e);
        a = $223b3691249701c4$var$Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $223b3691249701c4$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $223b3691249701c4$var$Zi(a, b, e);
    }
    b.flags |= 1;
    a = $223b3691249701c4$var$Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $223b3691249701c4$var$bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($223b3691249701c4$var$Ie(f, d) && a.ref === b.ref) {
            if ($223b3691249701c4$var$dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($223b3691249701c4$var$dh = !0);
            else return b.lanes = a.lanes, $223b3691249701c4$var$Zi(a, b, e);
        }
    }
    return $223b3691249701c4$var$cj(a, b, c, d, e);
}
function $223b3691249701c4$var$dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $223b3691249701c4$var$G($223b3691249701c4$var$ej, $223b3691249701c4$var$fj), $223b3691249701c4$var$fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $223b3691249701c4$var$G($223b3691249701c4$var$ej, $223b3691249701c4$var$fj), $223b3691249701c4$var$fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $223b3691249701c4$var$G($223b3691249701c4$var$ej, $223b3691249701c4$var$fj);
            $223b3691249701c4$var$fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $223b3691249701c4$var$G($223b3691249701c4$var$ej, $223b3691249701c4$var$fj), $223b3691249701c4$var$fj |= d;
    $223b3691249701c4$var$Xi(a, b, e, c);
    return b.child;
}
function $223b3691249701c4$var$gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $223b3691249701c4$var$cj(a, b, c, d, e) {
    var f = $223b3691249701c4$var$Zf(c) ? $223b3691249701c4$var$Xf : $223b3691249701c4$var$H.current;
    f = $223b3691249701c4$var$Yf(b, f);
    $223b3691249701c4$var$ch(b, e);
    c = $223b3691249701c4$var$Nh(a, b, c, d, f, e);
    d = $223b3691249701c4$var$Sh();
    if (null !== a && !$223b3691249701c4$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $223b3691249701c4$var$Zi(a, b, e);
    $223b3691249701c4$var$I && d && $223b3691249701c4$var$vg(b);
    b.flags |= 1;
    $223b3691249701c4$var$Xi(a, b, c, e);
    return b.child;
}
function $223b3691249701c4$var$hj(a, b, c, d, e) {
    if ($223b3691249701c4$var$Zf(c)) {
        var f = !0;
        $223b3691249701c4$var$cg(b);
    } else f = !1;
    $223b3691249701c4$var$ch(b, e);
    if (null === b.stateNode) $223b3691249701c4$var$ij(a, b), $223b3691249701c4$var$Gi(b, c, d), $223b3691249701c4$var$Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $223b3691249701c4$var$eh(l) : (l = $223b3691249701c4$var$Zf(c) ? $223b3691249701c4$var$Xf : $223b3691249701c4$var$H.current, l = $223b3691249701c4$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $223b3691249701c4$var$Hi(b, g, d, l);
        $223b3691249701c4$var$jh = !1;
        var r = b.memoizedState;
        g.state = r;
        $223b3691249701c4$var$qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $223b3691249701c4$var$Wf.current || $223b3691249701c4$var$jh ? ("function" === typeof m && ($223b3691249701c4$var$Di(b, c, m, d), k = b.memoizedState), (h = $223b3691249701c4$var$jh || $223b3691249701c4$var$Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $223b3691249701c4$var$lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $223b3691249701c4$var$Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $223b3691249701c4$var$eh(k) : (k = $223b3691249701c4$var$Zf(c) ? $223b3691249701c4$var$Xf : $223b3691249701c4$var$H.current, k = $223b3691249701c4$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $223b3691249701c4$var$Hi(b, g, d, k);
        $223b3691249701c4$var$jh = !1;
        r = b.memoizedState;
        g.state = r;
        $223b3691249701c4$var$qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $223b3691249701c4$var$Wf.current || $223b3691249701c4$var$jh ? ("function" === typeof y && ($223b3691249701c4$var$Di(b, c, y, d), n = b.memoizedState), (l = $223b3691249701c4$var$jh || $223b3691249701c4$var$Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $223b3691249701c4$var$jj(a, b, c, d, f, e);
}
function $223b3691249701c4$var$jj(a, b, c, d, e, f) {
    $223b3691249701c4$var$gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $223b3691249701c4$var$dg(b, c, !1), $223b3691249701c4$var$Zi(a, b, f);
    d = b.stateNode;
    $223b3691249701c4$var$Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $223b3691249701c4$var$Ug(b, a.child, null, f), b.child = $223b3691249701c4$var$Ug(b, null, h, f)) : $223b3691249701c4$var$Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && $223b3691249701c4$var$dg(b, c, !0);
    return b.child;
}
function $223b3691249701c4$var$kj(a) {
    var b = a.stateNode;
    b.pendingContext ? $223b3691249701c4$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $223b3691249701c4$var$ag(a, b.context, !1);
    $223b3691249701c4$var$yh(a, b.containerInfo);
}
function $223b3691249701c4$var$lj(a, b, c, d, e) {
    $223b3691249701c4$var$Ig();
    $223b3691249701c4$var$Jg(e);
    b.flags |= 256;
    $223b3691249701c4$var$Xi(a, b, c, d);
    return b.child;
}
var $223b3691249701c4$var$mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $223b3691249701c4$var$nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $223b3691249701c4$var$oj(a, b, c) {
    var d = b.pendingProps, e = $223b3691249701c4$var$L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $223b3691249701c4$var$G($223b3691249701c4$var$L, e & 1);
    if (null === a) {
        $223b3691249701c4$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $223b3691249701c4$var$pj(g, d, 0, null), a = $223b3691249701c4$var$Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $223b3691249701c4$var$nj(c), b.memoizedState = $223b3691249701c4$var$mj, a) : $223b3691249701c4$var$qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $223b3691249701c4$var$rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $223b3691249701c4$var$Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $223b3691249701c4$var$Pg(h, f) : (f = $223b3691249701c4$var$Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $223b3691249701c4$var$nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $223b3691249701c4$var$mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $223b3691249701c4$var$Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $223b3691249701c4$var$qj(a, b) {
    b = $223b3691249701c4$var$pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $223b3691249701c4$var$sj(a, b, c, d) {
    null !== d && $223b3691249701c4$var$Jg(d);
    $223b3691249701c4$var$Ug(b, a.child, null, c);
    a = $223b3691249701c4$var$qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $223b3691249701c4$var$rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $223b3691249701c4$var$Ki(Error($223b3691249701c4$var$p(422))), $223b3691249701c4$var$sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $223b3691249701c4$var$pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $223b3691249701c4$var$Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $223b3691249701c4$var$Ug(b, a.child, null, g);
        b.child.memoizedState = $223b3691249701c4$var$nj(g);
        b.memoizedState = $223b3691249701c4$var$mj;
        return f;
    }
    if (0 === (b.mode & 1)) return $223b3691249701c4$var$sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($223b3691249701c4$var$p(419));
        d = $223b3691249701c4$var$Ki(f, d, void 0);
        return $223b3691249701c4$var$sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($223b3691249701c4$var$dh || h) {
        d = $223b3691249701c4$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $223b3691249701c4$var$ih(a, e), $223b3691249701c4$var$gi(d, a, e, -1));
        }
        $223b3691249701c4$var$tj();
        d = $223b3691249701c4$var$Ki(Error($223b3691249701c4$var$p(421)));
        return $223b3691249701c4$var$sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $223b3691249701c4$var$uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $223b3691249701c4$var$yg = $223b3691249701c4$var$Lf(e.nextSibling);
    $223b3691249701c4$var$xg = b;
    $223b3691249701c4$var$I = !0;
    $223b3691249701c4$var$zg = null;
    null !== a && ($223b3691249701c4$var$og[$223b3691249701c4$var$pg++] = $223b3691249701c4$var$rg, $223b3691249701c4$var$og[$223b3691249701c4$var$pg++] = $223b3691249701c4$var$sg, $223b3691249701c4$var$og[$223b3691249701c4$var$pg++] = $223b3691249701c4$var$qg, $223b3691249701c4$var$rg = a.id, $223b3691249701c4$var$sg = a.overflow, $223b3691249701c4$var$qg = b);
    b = $223b3691249701c4$var$qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $223b3691249701c4$var$vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $223b3691249701c4$var$bh(a.return, b, c);
}
function $223b3691249701c4$var$wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $223b3691249701c4$var$xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $223b3691249701c4$var$Xi(a, b, d.children, c);
    d = $223b3691249701c4$var$L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $223b3691249701c4$var$vj(a, c, b);
            else if (19 === a.tag) $223b3691249701c4$var$vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $223b3691249701c4$var$G($223b3691249701c4$var$L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $223b3691249701c4$var$Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $223b3691249701c4$var$wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $223b3691249701c4$var$Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $223b3691249701c4$var$wj(b, !0, c, null, f);
            break;
        case "together":
            $223b3691249701c4$var$wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $223b3691249701c4$var$ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $223b3691249701c4$var$Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $223b3691249701c4$var$rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($223b3691249701c4$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $223b3691249701c4$var$Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $223b3691249701c4$var$Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $223b3691249701c4$var$yj(a, b, c) {
    switch(b.tag){
        case 3:
            $223b3691249701c4$var$kj(b);
            $223b3691249701c4$var$Ig();
            break;
        case 5:
            $223b3691249701c4$var$Ah(b);
            break;
        case 1:
            $223b3691249701c4$var$Zf(b.type) && $223b3691249701c4$var$cg(b);
            break;
        case 4:
            $223b3691249701c4$var$yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $223b3691249701c4$var$G($223b3691249701c4$var$Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $223b3691249701c4$var$G($223b3691249701c4$var$L, $223b3691249701c4$var$L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $223b3691249701c4$var$oj(a, b, c);
                $223b3691249701c4$var$G($223b3691249701c4$var$L, $223b3691249701c4$var$L.current & 1);
                a = $223b3691249701c4$var$Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $223b3691249701c4$var$G($223b3691249701c4$var$L, $223b3691249701c4$var$L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $223b3691249701c4$var$xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $223b3691249701c4$var$G($223b3691249701c4$var$L, $223b3691249701c4$var$L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $223b3691249701c4$var$dj(a, b, c);
    }
    return $223b3691249701c4$var$Zi(a, b, c);
}
var $223b3691249701c4$var$zj, $223b3691249701c4$var$Aj, $223b3691249701c4$var$Bj, $223b3691249701c4$var$Cj;
$223b3691249701c4$var$zj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$223b3691249701c4$var$Aj = function() {};
$223b3691249701c4$var$Bj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $223b3691249701c4$var$xh($223b3691249701c4$var$uh.current);
        var f = null;
        switch(c){
            case "input":
                e = $223b3691249701c4$var$Ya(a, e);
                d = $223b3691249701c4$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $223b3691249701c4$var$A({}, e, {
                    value: void 0
                });
                d = $223b3691249701c4$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $223b3691249701c4$var$gb(a, e);
                d = $223b3691249701c4$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $223b3691249701c4$var$Bf);
        }
        $223b3691249701c4$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($223b3691249701c4$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($223b3691249701c4$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $223b3691249701c4$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$223b3691249701c4$var$Cj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $223b3691249701c4$var$Dj(a, b) {
    if (!$223b3691249701c4$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $223b3691249701c4$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $223b3691249701c4$var$Ej(a, b, c) {
    var d = b.pendingProps;
    $223b3691249701c4$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $223b3691249701c4$var$S(b), null;
        case 1:
            return $223b3691249701c4$var$Zf(b.type) && $223b3691249701c4$var$$f(), $223b3691249701c4$var$S(b), null;
        case 3:
            d = b.stateNode;
            $223b3691249701c4$var$zh();
            $223b3691249701c4$var$E($223b3691249701c4$var$Wf);
            $223b3691249701c4$var$E($223b3691249701c4$var$H);
            $223b3691249701c4$var$Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $223b3691249701c4$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $223b3691249701c4$var$zg && ($223b3691249701c4$var$Fj($223b3691249701c4$var$zg), $223b3691249701c4$var$zg = null));
            $223b3691249701c4$var$Aj(a, b);
            $223b3691249701c4$var$S(b);
            return null;
        case 5:
            $223b3691249701c4$var$Bh(b);
            var e = $223b3691249701c4$var$xh($223b3691249701c4$var$wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $223b3691249701c4$var$Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($223b3691249701c4$var$p(166));
                    $223b3691249701c4$var$S(b);
                    return null;
                }
                a = $223b3691249701c4$var$xh($223b3691249701c4$var$uh.current);
                if ($223b3691249701c4$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$223b3691249701c4$var$Of] = b;
                    d[$223b3691249701c4$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $223b3691249701c4$var$D("cancel", d);
                            $223b3691249701c4$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $223b3691249701c4$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $223b3691249701c4$var$lf.length; e++)$223b3691249701c4$var$D($223b3691249701c4$var$lf[e], d);
                            break;
                        case "source":
                            $223b3691249701c4$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $223b3691249701c4$var$D("error", d);
                            $223b3691249701c4$var$D("load", d);
                            break;
                        case "details":
                            $223b3691249701c4$var$D("toggle", d);
                            break;
                        case "input":
                            $223b3691249701c4$var$Za(d, f);
                            $223b3691249701c4$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $223b3691249701c4$var$D("invalid", d);
                            break;
                        case "textarea":
                            $223b3691249701c4$var$hb(d, f), $223b3691249701c4$var$D("invalid", d);
                    }
                    $223b3691249701c4$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $223b3691249701c4$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $223b3691249701c4$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $223b3691249701c4$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $223b3691249701c4$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $223b3691249701c4$var$Va(d);
                            $223b3691249701c4$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $223b3691249701c4$var$Va(d);
                            $223b3691249701c4$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $223b3691249701c4$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $223b3691249701c4$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$223b3691249701c4$var$Of] = b;
                    a[$223b3691249701c4$var$Pf] = d;
                    $223b3691249701c4$var$zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $223b3691249701c4$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $223b3691249701c4$var$D("cancel", a);
                                $223b3691249701c4$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $223b3691249701c4$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $223b3691249701c4$var$lf.length; e++)$223b3691249701c4$var$D($223b3691249701c4$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $223b3691249701c4$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $223b3691249701c4$var$D("error", a);
                                $223b3691249701c4$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $223b3691249701c4$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $223b3691249701c4$var$Za(a, d);
                                e = $223b3691249701c4$var$Ya(a, d);
                                $223b3691249701c4$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $223b3691249701c4$var$A({}, d, {
                                    value: void 0
                                });
                                $223b3691249701c4$var$D("invalid", a);
                                break;
                            case "textarea":
                                $223b3691249701c4$var$hb(a, d);
                                e = $223b3691249701c4$var$gb(a, d);
                                $223b3691249701c4$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $223b3691249701c4$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $223b3691249701c4$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $223b3691249701c4$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $223b3691249701c4$var$ob(a, k) : "number" === typeof k && $223b3691249701c4$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($223b3691249701c4$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $223b3691249701c4$var$D("scroll", a) : null != k && $223b3691249701c4$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $223b3691249701c4$var$Va(a);
                                $223b3691249701c4$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $223b3691249701c4$var$Va(a);
                                $223b3691249701c4$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $223b3691249701c4$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $223b3691249701c4$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $223b3691249701c4$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $223b3691249701c4$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $223b3691249701c4$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $223b3691249701c4$var$Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($223b3691249701c4$var$p(166));
                c = $223b3691249701c4$var$xh($223b3691249701c4$var$wh.current);
                $223b3691249701c4$var$xh($223b3691249701c4$var$uh.current);
                if ($223b3691249701c4$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$223b3691249701c4$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $223b3691249701c4$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $223b3691249701c4$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $223b3691249701c4$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$223b3691249701c4$var$Of] = b, b.stateNode = d;
            }
            $223b3691249701c4$var$S(b);
            return null;
        case 13:
            $223b3691249701c4$var$E($223b3691249701c4$var$L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($223b3691249701c4$var$I && null !== $223b3691249701c4$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $223b3691249701c4$var$Hg(), $223b3691249701c4$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $223b3691249701c4$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($223b3691249701c4$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($223b3691249701c4$var$p(317));
                        f[$223b3691249701c4$var$Of] = b;
                    } else $223b3691249701c4$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $223b3691249701c4$var$S(b);
                    f = !1;
                } else null !== $223b3691249701c4$var$zg && ($223b3691249701c4$var$Fj($223b3691249701c4$var$zg), $223b3691249701c4$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($223b3691249701c4$var$L.current & 1) ? 0 === $223b3691249701c4$var$T && ($223b3691249701c4$var$T = 3) : $223b3691249701c4$var$tj()));
            null !== b.updateQueue && (b.flags |= 4);
            $223b3691249701c4$var$S(b);
            return null;
        case 4:
            return $223b3691249701c4$var$zh(), $223b3691249701c4$var$Aj(a, b), null === a && $223b3691249701c4$var$sf(b.stateNode.containerInfo), $223b3691249701c4$var$S(b), null;
        case 10:
            return $223b3691249701c4$var$ah(b.type._context), $223b3691249701c4$var$S(b), null;
        case 17:
            return $223b3691249701c4$var$Zf(b.type) && $223b3691249701c4$var$$f(), $223b3691249701c4$var$S(b), null;
        case 19:
            $223b3691249701c4$var$E($223b3691249701c4$var$L);
            f = b.memoizedState;
            if (null === f) return $223b3691249701c4$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $223b3691249701c4$var$Dj(f, !1);
                else {
                    if (0 !== $223b3691249701c4$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $223b3691249701c4$var$Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $223b3691249701c4$var$Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $223b3691249701c4$var$G($223b3691249701c4$var$L, $223b3691249701c4$var$L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $223b3691249701c4$var$B() > $223b3691249701c4$var$Gj && (b.flags |= 128, d = !0, $223b3691249701c4$var$Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $223b3691249701c4$var$Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $223b3691249701c4$var$Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$223b3691249701c4$var$I) return $223b3691249701c4$var$S(b), null;
                    } else 2 * $223b3691249701c4$var$B() - f.renderingStartTime > $223b3691249701c4$var$Gj && 1073741824 !== c && (b.flags |= 128, d = !0, $223b3691249701c4$var$Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $223b3691249701c4$var$B(), b.sibling = null, c = $223b3691249701c4$var$L.current, $223b3691249701c4$var$G($223b3691249701c4$var$L, d ? c & 1 | 2 : c & 1), b;
            $223b3691249701c4$var$S(b);
            return null;
        case 22:
        case 23:
            return $223b3691249701c4$var$Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($223b3691249701c4$var$fj & 1073741824) && ($223b3691249701c4$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $223b3691249701c4$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($223b3691249701c4$var$p(156, b.tag));
}
function $223b3691249701c4$var$Ij(a, b) {
    $223b3691249701c4$var$wg(b);
    switch(b.tag){
        case 1:
            return $223b3691249701c4$var$Zf(b.type) && $223b3691249701c4$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $223b3691249701c4$var$zh(), $223b3691249701c4$var$E($223b3691249701c4$var$Wf), $223b3691249701c4$var$E($223b3691249701c4$var$H), $223b3691249701c4$var$Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $223b3691249701c4$var$Bh(b), null;
        case 13:
            $223b3691249701c4$var$E($223b3691249701c4$var$L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($223b3691249701c4$var$p(340));
                $223b3691249701c4$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $223b3691249701c4$var$E($223b3691249701c4$var$L), null;
        case 4:
            return $223b3691249701c4$var$zh(), null;
        case 10:
            return $223b3691249701c4$var$ah(b.type._context), null;
        case 22:
        case 23:
            return $223b3691249701c4$var$Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $223b3691249701c4$var$Jj = !1, $223b3691249701c4$var$U = !1, $223b3691249701c4$var$Kj = "function" === typeof WeakSet ? WeakSet : Set, $223b3691249701c4$var$V = null;
function $223b3691249701c4$var$Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $223b3691249701c4$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $223b3691249701c4$var$Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        $223b3691249701c4$var$W(a, b, d);
    }
}
var $223b3691249701c4$var$Nj = !1;
function $223b3691249701c4$var$Oj(a, b) {
    $223b3691249701c4$var$Cf = $223b3691249701c4$var$dd;
    a = $223b3691249701c4$var$Me();
    if ($223b3691249701c4$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $223b3691249701c4$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $223b3691249701c4$var$dd = !1;
    for($223b3691249701c4$var$V = b; null !== $223b3691249701c4$var$V;)if (b = $223b3691249701c4$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $223b3691249701c4$var$V = a;
    else for(; null !== $223b3691249701c4$var$V;){
        b = $223b3691249701c4$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $223b3691249701c4$var$Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($223b3691249701c4$var$p(163));
            }
        } catch (F) {
            $223b3691249701c4$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $223b3691249701c4$var$V = a;
            break;
        }
        $223b3691249701c4$var$V = b.return;
    }
    n = $223b3691249701c4$var$Nj;
    $223b3691249701c4$var$Nj = !1;
    return n;
}
function $223b3691249701c4$var$Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $223b3691249701c4$var$Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $223b3691249701c4$var$Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $223b3691249701c4$var$Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $223b3691249701c4$var$Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $223b3691249701c4$var$Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$223b3691249701c4$var$Of], delete b[$223b3691249701c4$var$Pf], delete b[$223b3691249701c4$var$of], delete b[$223b3691249701c4$var$Qf], delete b[$223b3691249701c4$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $223b3691249701c4$var$Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $223b3691249701c4$var$Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $223b3691249701c4$var$Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $223b3691249701c4$var$Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $223b3691249701c4$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($223b3691249701c4$var$Vj(a, b, c), a = a.sibling; null !== a;)$223b3691249701c4$var$Vj(a, b, c), a = a.sibling;
}
function $223b3691249701c4$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($223b3691249701c4$var$Wj(a, b, c), a = a.sibling; null !== a;)$223b3691249701c4$var$Wj(a, b, c), a = a.sibling;
}
var $223b3691249701c4$var$X = null, $223b3691249701c4$var$Xj = !1;
function $223b3691249701c4$var$Yj(a, b, c) {
    for(c = c.child; null !== c;)$223b3691249701c4$var$Zj(a, b, c), c = c.sibling;
}
function $223b3691249701c4$var$Zj(a, b, c) {
    if ($223b3691249701c4$var$lc && "function" === typeof $223b3691249701c4$var$lc.onCommitFiberUnmount) try {
        $223b3691249701c4$var$lc.onCommitFiberUnmount($223b3691249701c4$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $223b3691249701c4$var$U || $223b3691249701c4$var$Lj(c, b);
        case 6:
            var d = $223b3691249701c4$var$X, e = $223b3691249701c4$var$Xj;
            $223b3691249701c4$var$X = null;
            $223b3691249701c4$var$Yj(a, b, c);
            $223b3691249701c4$var$X = d;
            $223b3691249701c4$var$Xj = e;
            null !== $223b3691249701c4$var$X && ($223b3691249701c4$var$Xj ? (a = $223b3691249701c4$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $223b3691249701c4$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $223b3691249701c4$var$X && ($223b3691249701c4$var$Xj ? (a = $223b3691249701c4$var$X, c = c.stateNode, 8 === a.nodeType ? $223b3691249701c4$var$Kf(a.parentNode, c) : 1 === a.nodeType && $223b3691249701c4$var$Kf(a, c), $223b3691249701c4$var$bd(a)) : $223b3691249701c4$var$Kf($223b3691249701c4$var$X, c.stateNode));
            break;
        case 4:
            d = $223b3691249701c4$var$X;
            e = $223b3691249701c4$var$Xj;
            $223b3691249701c4$var$X = c.stateNode.containerInfo;
            $223b3691249701c4$var$Xj = !0;
            $223b3691249701c4$var$Yj(a, b, c);
            $223b3691249701c4$var$X = d;
            $223b3691249701c4$var$Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$223b3691249701c4$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $223b3691249701c4$var$Mj(c, b, g) : 0 !== (f & 4) && $223b3691249701c4$var$Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $223b3691249701c4$var$Yj(a, b, c);
            break;
        case 1:
            if (!$223b3691249701c4$var$U && ($223b3691249701c4$var$Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $223b3691249701c4$var$W(c, b, h);
            }
            $223b3691249701c4$var$Yj(a, b, c);
            break;
        case 21:
            $223b3691249701c4$var$Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($223b3691249701c4$var$U = (d = $223b3691249701c4$var$U) || null !== c.memoizedState, $223b3691249701c4$var$Yj(a, b, c), $223b3691249701c4$var$U = d) : $223b3691249701c4$var$Yj(a, b, c);
            break;
        default:
            $223b3691249701c4$var$Yj(a, b, c);
    }
}
function $223b3691249701c4$var$ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $223b3691249701c4$var$Kj);
        b.forEach(function(b) {
            var d = $223b3691249701c4$var$bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $223b3691249701c4$var$ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $223b3691249701c4$var$X = h.stateNode;
                        $223b3691249701c4$var$Xj = !1;
                        break a;
                    case 3:
                        $223b3691249701c4$var$X = h.stateNode.containerInfo;
                        $223b3691249701c4$var$Xj = !0;
                        break a;
                    case 4:
                        $223b3691249701c4$var$X = h.stateNode.containerInfo;
                        $223b3691249701c4$var$Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $223b3691249701c4$var$X) throw Error($223b3691249701c4$var$p(160));
            $223b3691249701c4$var$Zj(f, g, e);
            $223b3691249701c4$var$X = null;
            $223b3691249701c4$var$Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $223b3691249701c4$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$223b3691249701c4$var$dk(b, a), b = b.sibling;
}
function $223b3691249701c4$var$dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $223b3691249701c4$var$ck(b, a);
            $223b3691249701c4$var$ek(a);
            if (d & 4) {
                try {
                    $223b3691249701c4$var$Pj(3, a, a.return), $223b3691249701c4$var$Qj(3, a);
                } catch (t) {
                    $223b3691249701c4$var$W(a, a.return, t);
                }
                try {
                    $223b3691249701c4$var$Pj(5, a, a.return);
                } catch (t) {
                    $223b3691249701c4$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $223b3691249701c4$var$ck(b, a);
            $223b3691249701c4$var$ek(a);
            d & 512 && null !== c && $223b3691249701c4$var$Lj(c, c.return);
            break;
        case 5:
            $223b3691249701c4$var$ck(b, a);
            $223b3691249701c4$var$ek(a);
            d & 512 && null !== c && $223b3691249701c4$var$Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $223b3691249701c4$var$ob(e, "");
                } catch (t) {
                    $223b3691249701c4$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $223b3691249701c4$var$ab(e, f);
                    $223b3691249701c4$var$vb(h, g);
                    var l = $223b3691249701c4$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $223b3691249701c4$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $223b3691249701c4$var$nb(e, q) : "children" === m ? $223b3691249701c4$var$ob(e, q) : $223b3691249701c4$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $223b3691249701c4$var$bb(e, f);
                            break;
                        case "textarea":
                            $223b3691249701c4$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $223b3691249701c4$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $223b3691249701c4$var$fb(e, !!f.multiple, f.defaultValue, !0) : $223b3691249701c4$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$223b3691249701c4$var$Pf] = f;
                } catch (t) {
                    $223b3691249701c4$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $223b3691249701c4$var$ck(b, a);
            $223b3691249701c4$var$ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($223b3691249701c4$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $223b3691249701c4$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $223b3691249701c4$var$ck(b, a);
            $223b3691249701c4$var$ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $223b3691249701c4$var$bd(b.containerInfo);
            } catch (t) {
                $223b3691249701c4$var$W(a, a.return, t);
            }
            break;
        case 4:
            $223b3691249701c4$var$ck(b, a);
            $223b3691249701c4$var$ek(a);
            break;
        case 13:
            $223b3691249701c4$var$ck(b, a);
            $223b3691249701c4$var$ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($223b3691249701c4$var$fk = $223b3691249701c4$var$B()));
            d & 4 && $223b3691249701c4$var$ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($223b3691249701c4$var$U = (l = $223b3691249701c4$var$U) || m, $223b3691249701c4$var$ck(b, a), $223b3691249701c4$var$U = l) : $223b3691249701c4$var$ck(b, a);
            $223b3691249701c4$var$ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($223b3691249701c4$var$V = a, m = a.child; null !== m;){
                    for(q = $223b3691249701c4$var$V = m; null !== $223b3691249701c4$var$V;){
                        r = $223b3691249701c4$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $223b3691249701c4$var$Pj(4, r, r.return);
                                break;
                            case 1:
                                $223b3691249701c4$var$Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $223b3691249701c4$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $223b3691249701c4$var$Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $223b3691249701c4$var$gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $223b3691249701c4$var$V = y) : $223b3691249701c4$var$gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $223b3691249701c4$var$rb("display", g));
                            } catch (t) {
                                $223b3691249701c4$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $223b3691249701c4$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $223b3691249701c4$var$ck(b, a);
            $223b3691249701c4$var$ek(a);
            d & 4 && $223b3691249701c4$var$ak(a);
            break;
        case 21:
            break;
        default:
            $223b3691249701c4$var$ck(b, a), $223b3691249701c4$var$ek(a);
    }
}
function $223b3691249701c4$var$ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($223b3691249701c4$var$Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($223b3691249701c4$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($223b3691249701c4$var$ob(e, ""), d.flags &= -33);
                    var f = $223b3691249701c4$var$Uj(a);
                    $223b3691249701c4$var$Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $223b3691249701c4$var$Uj(a);
                    $223b3691249701c4$var$Vj(a, h, g);
                    break;
                default:
                    throw Error($223b3691249701c4$var$p(161));
            }
        } catch (k) {
            $223b3691249701c4$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $223b3691249701c4$var$hk(a, b, c) {
    $223b3691249701c4$var$V = a;
    $223b3691249701c4$var$ik(a, b, c);
}
function $223b3691249701c4$var$ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $223b3691249701c4$var$V;){
        var e = $223b3691249701c4$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $223b3691249701c4$var$Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $223b3691249701c4$var$U;
                h = $223b3691249701c4$var$Jj;
                var l = $223b3691249701c4$var$U;
                $223b3691249701c4$var$Jj = g;
                if (($223b3691249701c4$var$U = k) && !l) for($223b3691249701c4$var$V = e; null !== $223b3691249701c4$var$V;)g = $223b3691249701c4$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $223b3691249701c4$var$jk(e) : null !== k ? (k.return = g, $223b3691249701c4$var$V = k) : $223b3691249701c4$var$jk(e);
                for(; null !== f;)$223b3691249701c4$var$V = f, $223b3691249701c4$var$ik(f, b, c), f = f.sibling;
                $223b3691249701c4$var$V = e;
                $223b3691249701c4$var$Jj = h;
                $223b3691249701c4$var$U = l;
            }
            $223b3691249701c4$var$kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $223b3691249701c4$var$V = f) : $223b3691249701c4$var$kk(a, b, c);
    }
}
function $223b3691249701c4$var$kk(a) {
    for(; null !== $223b3691249701c4$var$V;){
        var b = $223b3691249701c4$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $223b3691249701c4$var$U || $223b3691249701c4$var$Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$223b3691249701c4$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $223b3691249701c4$var$Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $223b3691249701c4$var$sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $223b3691249701c4$var$sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $223b3691249701c4$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($223b3691249701c4$var$p(163));
                }
                $223b3691249701c4$var$U || b.flags & 512 && $223b3691249701c4$var$Rj(b);
            } catch (r) {
                $223b3691249701c4$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $223b3691249701c4$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $223b3691249701c4$var$V = c;
            break;
        }
        $223b3691249701c4$var$V = b.return;
    }
}
function $223b3691249701c4$var$gk(a) {
    for(; null !== $223b3691249701c4$var$V;){
        var b = $223b3691249701c4$var$V;
        if (b === a) {
            $223b3691249701c4$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $223b3691249701c4$var$V = c;
            break;
        }
        $223b3691249701c4$var$V = b.return;
    }
}
function $223b3691249701c4$var$jk(a) {
    for(; null !== $223b3691249701c4$var$V;){
        var b = $223b3691249701c4$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $223b3691249701c4$var$Qj(4, b);
                    } catch (k) {
                        $223b3691249701c4$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $223b3691249701c4$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $223b3691249701c4$var$Rj(b);
                    } catch (k) {
                        $223b3691249701c4$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $223b3691249701c4$var$Rj(b);
                    } catch (k) {
                        $223b3691249701c4$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $223b3691249701c4$var$W(b, b.return, k);
        }
        if (b === a) {
            $223b3691249701c4$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $223b3691249701c4$var$V = h;
            break;
        }
        $223b3691249701c4$var$V = b.return;
    }
}
var $223b3691249701c4$var$lk = Math.ceil, $223b3691249701c4$var$mk = $223b3691249701c4$var$ua.ReactCurrentDispatcher, $223b3691249701c4$var$nk = $223b3691249701c4$var$ua.ReactCurrentOwner, $223b3691249701c4$var$ok = $223b3691249701c4$var$ua.ReactCurrentBatchConfig, $223b3691249701c4$var$K = 0, $223b3691249701c4$var$Q = null, $223b3691249701c4$var$Y = null, $223b3691249701c4$var$Z = 0, $223b3691249701c4$var$fj = 0, $223b3691249701c4$var$ej = $223b3691249701c4$var$Uf(0), $223b3691249701c4$var$T = 0, $223b3691249701c4$var$pk = null, $223b3691249701c4$var$rh = 0, $223b3691249701c4$var$qk = 0, $223b3691249701c4$var$rk = 0, $223b3691249701c4$var$sk = null, $223b3691249701c4$var$tk = null, $223b3691249701c4$var$fk = 0, $223b3691249701c4$var$Gj = Infinity, $223b3691249701c4$var$uk = null, $223b3691249701c4$var$Oi = !1, $223b3691249701c4$var$Pi = null, $223b3691249701c4$var$Ri = null, $223b3691249701c4$var$vk = !1, $223b3691249701c4$var$wk = null, $223b3691249701c4$var$xk = 0, $223b3691249701c4$var$yk = 0, $223b3691249701c4$var$zk = null, $223b3691249701c4$var$Ak = -1, $223b3691249701c4$var$Bk = 0;
function $223b3691249701c4$var$R() {
    return 0 !== ($223b3691249701c4$var$K & 6) ? $223b3691249701c4$var$B() : -1 !== $223b3691249701c4$var$Ak ? $223b3691249701c4$var$Ak : $223b3691249701c4$var$Ak = $223b3691249701c4$var$B();
}
function $223b3691249701c4$var$yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($223b3691249701c4$var$K & 2) && 0 !== $223b3691249701c4$var$Z) return $223b3691249701c4$var$Z & -$223b3691249701c4$var$Z;
    if (null !== $223b3691249701c4$var$Kg.transition) return 0 === $223b3691249701c4$var$Bk && ($223b3691249701c4$var$Bk = $223b3691249701c4$var$yc()), $223b3691249701c4$var$Bk;
    a = $223b3691249701c4$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $223b3691249701c4$var$jd(a.type);
    return a;
}
function $223b3691249701c4$var$gi(a, b, c, d) {
    if (50 < $223b3691249701c4$var$yk) throw $223b3691249701c4$var$yk = 0, $223b3691249701c4$var$zk = null, Error($223b3691249701c4$var$p(185));
    $223b3691249701c4$var$Ac(a, c, d);
    if (0 === ($223b3691249701c4$var$K & 2) || a !== $223b3691249701c4$var$Q) a === $223b3691249701c4$var$Q && (0 === ($223b3691249701c4$var$K & 2) && ($223b3691249701c4$var$qk |= c), 4 === $223b3691249701c4$var$T && $223b3691249701c4$var$Ck(a, $223b3691249701c4$var$Z)), $223b3691249701c4$var$Dk(a, d), 1 === c && 0 === $223b3691249701c4$var$K && 0 === (b.mode & 1) && ($223b3691249701c4$var$Gj = $223b3691249701c4$var$B() + 500, $223b3691249701c4$var$fg && $223b3691249701c4$var$jg());
}
function $223b3691249701c4$var$Dk(a, b) {
    var c = a.callbackNode;
    $223b3691249701c4$var$wc(a, b);
    var d = $223b3691249701c4$var$uc(a, a === $223b3691249701c4$var$Q ? $223b3691249701c4$var$Z : 0);
    if (0 === d) null !== c && $223b3691249701c4$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $223b3691249701c4$var$bc(c);
        if (1 === b) 0 === a.tag ? $223b3691249701c4$var$ig($223b3691249701c4$var$Ek.bind(null, a)) : $223b3691249701c4$var$hg($223b3691249701c4$var$Ek.bind(null, a)), $223b3691249701c4$var$Jf(function() {
            0 === ($223b3691249701c4$var$K & 6) && $223b3691249701c4$var$jg();
        }), c = null;
        else {
            switch($223b3691249701c4$var$Dc(d)){
                case 1:
                    c = $223b3691249701c4$var$fc;
                    break;
                case 4:
                    c = $223b3691249701c4$var$gc;
                    break;
                case 16:
                    c = $223b3691249701c4$var$hc;
                    break;
                case 536870912:
                    c = $223b3691249701c4$var$jc;
                    break;
                default:
                    c = $223b3691249701c4$var$hc;
            }
            c = $223b3691249701c4$var$Fk(c, $223b3691249701c4$var$Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $223b3691249701c4$var$Gk(a, b) {
    $223b3691249701c4$var$Ak = -1;
    $223b3691249701c4$var$Bk = 0;
    if (0 !== ($223b3691249701c4$var$K & 6)) throw Error($223b3691249701c4$var$p(327));
    var c = a.callbackNode;
    if ($223b3691249701c4$var$Hk() && a.callbackNode !== c) return null;
    var d = $223b3691249701c4$var$uc(a, a === $223b3691249701c4$var$Q ? $223b3691249701c4$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $223b3691249701c4$var$Ik(a, d);
    else {
        b = d;
        var e = $223b3691249701c4$var$K;
        $223b3691249701c4$var$K |= 2;
        var f = $223b3691249701c4$var$Jk();
        if ($223b3691249701c4$var$Q !== a || $223b3691249701c4$var$Z !== b) $223b3691249701c4$var$uk = null, $223b3691249701c4$var$Gj = $223b3691249701c4$var$B() + 500, $223b3691249701c4$var$Kk(a, b);
        for(;;)try {
            $223b3691249701c4$var$Lk();
            break;
        } catch (h) {
            $223b3691249701c4$var$Mk(a, h);
        }
        $223b3691249701c4$var$$g();
        $223b3691249701c4$var$mk.current = f;
        $223b3691249701c4$var$K = e;
        null !== $223b3691249701c4$var$Y ? b = 0 : ($223b3691249701c4$var$Q = null, $223b3691249701c4$var$Z = 0, b = $223b3691249701c4$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $223b3691249701c4$var$xc(a), 0 !== e && (d = e, b = $223b3691249701c4$var$Nk(a, e)));
        if (1 === b) throw c = $223b3691249701c4$var$pk, $223b3691249701c4$var$Kk(a, 0), $223b3691249701c4$var$Ck(a, d), $223b3691249701c4$var$Dk(a, $223b3691249701c4$var$B()), c;
        if (6 === b) $223b3691249701c4$var$Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$223b3691249701c4$var$Ok(e) && (b = $223b3691249701c4$var$Ik(a, d), 2 === b && (f = $223b3691249701c4$var$xc(a), 0 !== f && (d = f, b = $223b3691249701c4$var$Nk(a, f))), 1 === b)) throw c = $223b3691249701c4$var$pk, $223b3691249701c4$var$Kk(a, 0), $223b3691249701c4$var$Ck(a, d), $223b3691249701c4$var$Dk(a, $223b3691249701c4$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($223b3691249701c4$var$p(345));
                case 2:
                    $223b3691249701c4$var$Pk(a, $223b3691249701c4$var$tk, $223b3691249701c4$var$uk);
                    break;
                case 3:
                    $223b3691249701c4$var$Ck(a, d);
                    if ((d & 130023424) === d && (b = $223b3691249701c4$var$fk + 500 - $223b3691249701c4$var$B(), 10 < b)) {
                        if (0 !== $223b3691249701c4$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $223b3691249701c4$var$R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $223b3691249701c4$var$Ff($223b3691249701c4$var$Pk.bind(null, a, $223b3691249701c4$var$tk, $223b3691249701c4$var$uk), b);
                        break;
                    }
                    $223b3691249701c4$var$Pk(a, $223b3691249701c4$var$tk, $223b3691249701c4$var$uk);
                    break;
                case 4:
                    $223b3691249701c4$var$Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $223b3691249701c4$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $223b3691249701c4$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $223b3691249701c4$var$lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $223b3691249701c4$var$Ff($223b3691249701c4$var$Pk.bind(null, a, $223b3691249701c4$var$tk, $223b3691249701c4$var$uk), d);
                        break;
                    }
                    $223b3691249701c4$var$Pk(a, $223b3691249701c4$var$tk, $223b3691249701c4$var$uk);
                    break;
                case 5:
                    $223b3691249701c4$var$Pk(a, $223b3691249701c4$var$tk, $223b3691249701c4$var$uk);
                    break;
                default:
                    throw Error($223b3691249701c4$var$p(329));
            }
        }
    }
    $223b3691249701c4$var$Dk(a, $223b3691249701c4$var$B());
    return a.callbackNode === c ? $223b3691249701c4$var$Gk.bind(null, a) : null;
}
function $223b3691249701c4$var$Nk(a, b) {
    var c = $223b3691249701c4$var$sk;
    a.current.memoizedState.isDehydrated && ($223b3691249701c4$var$Kk(a, b).flags |= 256);
    a = $223b3691249701c4$var$Ik(a, b);
    2 !== a && (b = $223b3691249701c4$var$tk, $223b3691249701c4$var$tk = c, null !== b && $223b3691249701c4$var$Fj(b));
    return a;
}
function $223b3691249701c4$var$Fj(a) {
    null === $223b3691249701c4$var$tk ? $223b3691249701c4$var$tk = a : $223b3691249701c4$var$tk.push.apply($223b3691249701c4$var$tk, a);
}
function $223b3691249701c4$var$Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$223b3691249701c4$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $223b3691249701c4$var$Ck(a, b) {
    b &= ~$223b3691249701c4$var$rk;
    b &= ~$223b3691249701c4$var$qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $223b3691249701c4$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $223b3691249701c4$var$Ek(a) {
    if (0 !== ($223b3691249701c4$var$K & 6)) throw Error($223b3691249701c4$var$p(327));
    $223b3691249701c4$var$Hk();
    var b = $223b3691249701c4$var$uc(a, 0);
    if (0 === (b & 1)) return $223b3691249701c4$var$Dk(a, $223b3691249701c4$var$B()), null;
    var c = $223b3691249701c4$var$Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $223b3691249701c4$var$xc(a);
        0 !== d && (b = d, c = $223b3691249701c4$var$Nk(a, d));
    }
    if (1 === c) throw c = $223b3691249701c4$var$pk, $223b3691249701c4$var$Kk(a, 0), $223b3691249701c4$var$Ck(a, b), $223b3691249701c4$var$Dk(a, $223b3691249701c4$var$B()), c;
    if (6 === c) throw Error($223b3691249701c4$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $223b3691249701c4$var$Pk(a, $223b3691249701c4$var$tk, $223b3691249701c4$var$uk);
    $223b3691249701c4$var$Dk(a, $223b3691249701c4$var$B());
    return null;
}
function $223b3691249701c4$var$Qk(a, b) {
    var c = $223b3691249701c4$var$K;
    $223b3691249701c4$var$K |= 1;
    try {
        return a(b);
    } finally{
        $223b3691249701c4$var$K = c, 0 === $223b3691249701c4$var$K && ($223b3691249701c4$var$Gj = $223b3691249701c4$var$B() + 500, $223b3691249701c4$var$fg && $223b3691249701c4$var$jg());
    }
}
function $223b3691249701c4$var$Rk(a) {
    null !== $223b3691249701c4$var$wk && 0 === $223b3691249701c4$var$wk.tag && 0 === ($223b3691249701c4$var$K & 6) && $223b3691249701c4$var$Hk();
    var b = $223b3691249701c4$var$K;
    $223b3691249701c4$var$K |= 1;
    var c = $223b3691249701c4$var$ok.transition, d = $223b3691249701c4$var$C;
    try {
        if ($223b3691249701c4$var$ok.transition = null, $223b3691249701c4$var$C = 1, a) return a();
    } finally{
        $223b3691249701c4$var$C = d, $223b3691249701c4$var$ok.transition = c, $223b3691249701c4$var$K = b, 0 === ($223b3691249701c4$var$K & 6) && $223b3691249701c4$var$jg();
    }
}
function $223b3691249701c4$var$Hj() {
    $223b3691249701c4$var$fj = $223b3691249701c4$var$ej.current;
    $223b3691249701c4$var$E($223b3691249701c4$var$ej);
}
function $223b3691249701c4$var$Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $223b3691249701c4$var$Gf(c));
    if (null !== $223b3691249701c4$var$Y) for(c = $223b3691249701c4$var$Y.return; null !== c;){
        var d = c;
        $223b3691249701c4$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $223b3691249701c4$var$$f();
                break;
            case 3:
                $223b3691249701c4$var$zh();
                $223b3691249701c4$var$E($223b3691249701c4$var$Wf);
                $223b3691249701c4$var$E($223b3691249701c4$var$H);
                $223b3691249701c4$var$Eh();
                break;
            case 5:
                $223b3691249701c4$var$Bh(d);
                break;
            case 4:
                $223b3691249701c4$var$zh();
                break;
            case 13:
                $223b3691249701c4$var$E($223b3691249701c4$var$L);
                break;
            case 19:
                $223b3691249701c4$var$E($223b3691249701c4$var$L);
                break;
            case 10:
                $223b3691249701c4$var$ah(d.type._context);
                break;
            case 22:
            case 23:
                $223b3691249701c4$var$Hj();
        }
        c = c.return;
    }
    $223b3691249701c4$var$Q = a;
    $223b3691249701c4$var$Y = a = $223b3691249701c4$var$Pg(a.current, null);
    $223b3691249701c4$var$Z = $223b3691249701c4$var$fj = b;
    $223b3691249701c4$var$T = 0;
    $223b3691249701c4$var$pk = null;
    $223b3691249701c4$var$rk = $223b3691249701c4$var$qk = $223b3691249701c4$var$rh = 0;
    $223b3691249701c4$var$tk = $223b3691249701c4$var$sk = null;
    if (null !== $223b3691249701c4$var$fh) {
        for(b = 0; b < $223b3691249701c4$var$fh.length; b++)if (c = $223b3691249701c4$var$fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $223b3691249701c4$var$fh = null;
    }
    return a;
}
function $223b3691249701c4$var$Mk(a, b) {
    do {
        var c = $223b3691249701c4$var$Y;
        try {
            $223b3691249701c4$var$$g();
            $223b3691249701c4$var$Fh.current = $223b3691249701c4$var$Rh;
            if ($223b3691249701c4$var$Ih) {
                for(var d = $223b3691249701c4$var$M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $223b3691249701c4$var$Ih = !1;
            }
            $223b3691249701c4$var$Hh = 0;
            $223b3691249701c4$var$O = $223b3691249701c4$var$N = $223b3691249701c4$var$M = null;
            $223b3691249701c4$var$Jh = !1;
            $223b3691249701c4$var$Kh = 0;
            $223b3691249701c4$var$nk.current = null;
            if (null === c || null === c.return) {
                $223b3691249701c4$var$T = 1;
                $223b3691249701c4$var$pk = b;
                $223b3691249701c4$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $223b3691249701c4$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $223b3691249701c4$var$Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $223b3691249701c4$var$Vi(y, g, h, f, b);
                        y.mode & 1 && $223b3691249701c4$var$Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $223b3691249701c4$var$Si(f, l, b);
                            $223b3691249701c4$var$tj();
                            break a;
                        }
                        k = Error($223b3691249701c4$var$p(426));
                    }
                } else if ($223b3691249701c4$var$I && h.mode & 1) {
                    var J = $223b3691249701c4$var$Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $223b3691249701c4$var$Vi(J, g, h, f, b);
                        $223b3691249701c4$var$Jg($223b3691249701c4$var$Ji(k, h));
                        break a;
                    }
                }
                f = k = $223b3691249701c4$var$Ji(k, h);
                4 !== $223b3691249701c4$var$T && ($223b3691249701c4$var$T = 2);
                null === $223b3691249701c4$var$sk ? $223b3691249701c4$var$sk = [
                    f
                ] : $223b3691249701c4$var$sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $223b3691249701c4$var$Ni(f, k, b);
                            $223b3691249701c4$var$ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $223b3691249701c4$var$Ri || !$223b3691249701c4$var$Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $223b3691249701c4$var$Qi(f, h, b);
                                $223b3691249701c4$var$ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $223b3691249701c4$var$Sk(c);
        } catch (na) {
            b = na;
            $223b3691249701c4$var$Y === c && null !== c && ($223b3691249701c4$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $223b3691249701c4$var$Jk() {
    var a = $223b3691249701c4$var$mk.current;
    $223b3691249701c4$var$mk.current = $223b3691249701c4$var$Rh;
    return null === a ? $223b3691249701c4$var$Rh : a;
}
function $223b3691249701c4$var$tj() {
    if (0 === $223b3691249701c4$var$T || 3 === $223b3691249701c4$var$T || 2 === $223b3691249701c4$var$T) $223b3691249701c4$var$T = 4;
    null === $223b3691249701c4$var$Q || 0 === ($223b3691249701c4$var$rh & 268435455) && 0 === ($223b3691249701c4$var$qk & 268435455) || $223b3691249701c4$var$Ck($223b3691249701c4$var$Q, $223b3691249701c4$var$Z);
}
function $223b3691249701c4$var$Ik(a, b) {
    var c = $223b3691249701c4$var$K;
    $223b3691249701c4$var$K |= 2;
    var d = $223b3691249701c4$var$Jk();
    if ($223b3691249701c4$var$Q !== a || $223b3691249701c4$var$Z !== b) $223b3691249701c4$var$uk = null, $223b3691249701c4$var$Kk(a, b);
    for(;;)try {
        $223b3691249701c4$var$Tk();
        break;
    } catch (e) {
        $223b3691249701c4$var$Mk(a, e);
    }
    $223b3691249701c4$var$$g();
    $223b3691249701c4$var$K = c;
    $223b3691249701c4$var$mk.current = d;
    if (null !== $223b3691249701c4$var$Y) throw Error($223b3691249701c4$var$p(261));
    $223b3691249701c4$var$Q = null;
    $223b3691249701c4$var$Z = 0;
    return $223b3691249701c4$var$T;
}
function $223b3691249701c4$var$Tk() {
    for(; null !== $223b3691249701c4$var$Y;)$223b3691249701c4$var$Uk($223b3691249701c4$var$Y);
}
function $223b3691249701c4$var$Lk() {
    for(; null !== $223b3691249701c4$var$Y && !$223b3691249701c4$var$cc();)$223b3691249701c4$var$Uk($223b3691249701c4$var$Y);
}
function $223b3691249701c4$var$Uk(a) {
    var b = $223b3691249701c4$var$Vk(a.alternate, a, $223b3691249701c4$var$fj);
    a.memoizedProps = a.pendingProps;
    null === b ? $223b3691249701c4$var$Sk(a) : $223b3691249701c4$var$Y = b;
    $223b3691249701c4$var$nk.current = null;
}
function $223b3691249701c4$var$Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $223b3691249701c4$var$Ej(c, b, $223b3691249701c4$var$fj), null !== c) {
                $223b3691249701c4$var$Y = c;
                return;
            }
        } else {
            c = $223b3691249701c4$var$Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $223b3691249701c4$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $223b3691249701c4$var$T = 6;
                $223b3691249701c4$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $223b3691249701c4$var$Y = b;
            return;
        }
        $223b3691249701c4$var$Y = b = a;
    }while (null !== b);
    0 === $223b3691249701c4$var$T && ($223b3691249701c4$var$T = 5);
}
function $223b3691249701c4$var$Pk(a, b, c) {
    var d = $223b3691249701c4$var$C, e = $223b3691249701c4$var$ok.transition;
    try {
        $223b3691249701c4$var$ok.transition = null, $223b3691249701c4$var$C = 1, $223b3691249701c4$var$Wk(a, b, c, d);
    } finally{
        $223b3691249701c4$var$ok.transition = e, $223b3691249701c4$var$C = d;
    }
    return null;
}
function $223b3691249701c4$var$Wk(a, b, c, d) {
    do $223b3691249701c4$var$Hk();
    while (null !== $223b3691249701c4$var$wk);
    if (0 !== ($223b3691249701c4$var$K & 6)) throw Error($223b3691249701c4$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($223b3691249701c4$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $223b3691249701c4$var$Bc(a, f);
    a === $223b3691249701c4$var$Q && ($223b3691249701c4$var$Y = $223b3691249701c4$var$Q = null, $223b3691249701c4$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $223b3691249701c4$var$vk || ($223b3691249701c4$var$vk = !0, $223b3691249701c4$var$Fk($223b3691249701c4$var$hc, function() {
        $223b3691249701c4$var$Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $223b3691249701c4$var$ok.transition;
        $223b3691249701c4$var$ok.transition = null;
        var g = $223b3691249701c4$var$C;
        $223b3691249701c4$var$C = 1;
        var h = $223b3691249701c4$var$K;
        $223b3691249701c4$var$K |= 4;
        $223b3691249701c4$var$nk.current = null;
        $223b3691249701c4$var$Oj(a, c);
        $223b3691249701c4$var$dk(c, a);
        $223b3691249701c4$var$Oe($223b3691249701c4$var$Df);
        $223b3691249701c4$var$dd = !!$223b3691249701c4$var$Cf;
        $223b3691249701c4$var$Df = $223b3691249701c4$var$Cf = null;
        a.current = c;
        $223b3691249701c4$var$hk(c, a, e);
        $223b3691249701c4$var$dc();
        $223b3691249701c4$var$K = h;
        $223b3691249701c4$var$C = g;
        $223b3691249701c4$var$ok.transition = f;
    } else a.current = c;
    $223b3691249701c4$var$vk && ($223b3691249701c4$var$vk = !1, $223b3691249701c4$var$wk = a, $223b3691249701c4$var$xk = e);
    f = a.pendingLanes;
    0 === f && ($223b3691249701c4$var$Ri = null);
    $223b3691249701c4$var$mc(c.stateNode, d);
    $223b3691249701c4$var$Dk(a, $223b3691249701c4$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($223b3691249701c4$var$Oi) throw $223b3691249701c4$var$Oi = !1, a = $223b3691249701c4$var$Pi, $223b3691249701c4$var$Pi = null, a;
    0 !== ($223b3691249701c4$var$xk & 1) && 0 !== a.tag && $223b3691249701c4$var$Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $223b3691249701c4$var$zk ? $223b3691249701c4$var$yk++ : ($223b3691249701c4$var$yk = 0, $223b3691249701c4$var$zk = a) : $223b3691249701c4$var$yk = 0;
    $223b3691249701c4$var$jg();
    return null;
}
function $223b3691249701c4$var$Hk() {
    if (null !== $223b3691249701c4$var$wk) {
        var a = $223b3691249701c4$var$Dc($223b3691249701c4$var$xk), b = $223b3691249701c4$var$ok.transition, c = $223b3691249701c4$var$C;
        try {
            $223b3691249701c4$var$ok.transition = null;
            $223b3691249701c4$var$C = 16 > a ? 16 : a;
            if (null === $223b3691249701c4$var$wk) var d = !1;
            else {
                a = $223b3691249701c4$var$wk;
                $223b3691249701c4$var$wk = null;
                $223b3691249701c4$var$xk = 0;
                if (0 !== ($223b3691249701c4$var$K & 6)) throw Error($223b3691249701c4$var$p(331));
                var e = $223b3691249701c4$var$K;
                $223b3691249701c4$var$K |= 4;
                for($223b3691249701c4$var$V = a.current; null !== $223b3691249701c4$var$V;){
                    var f = $223b3691249701c4$var$V, g = f.child;
                    if (0 !== ($223b3691249701c4$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($223b3691249701c4$var$V = l; null !== $223b3691249701c4$var$V;){
                                    var m = $223b3691249701c4$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $223b3691249701c4$var$Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $223b3691249701c4$var$V = q;
                                    else for(; null !== $223b3691249701c4$var$V;){
                                        m = $223b3691249701c4$var$V;
                                        var r = m.sibling, y = m.return;
                                        $223b3691249701c4$var$Sj(m);
                                        if (m === l) {
                                            $223b3691249701c4$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $223b3691249701c4$var$V = r;
                                            break;
                                        }
                                        $223b3691249701c4$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $223b3691249701c4$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $223b3691249701c4$var$V = g;
                    else b: for(; null !== $223b3691249701c4$var$V;){
                        f = $223b3691249701c4$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $223b3691249701c4$var$Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $223b3691249701c4$var$V = x;
                            break b;
                        }
                        $223b3691249701c4$var$V = f.return;
                    }
                }
                var w = a.current;
                for($223b3691249701c4$var$V = w; null !== $223b3691249701c4$var$V;){
                    g = $223b3691249701c4$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $223b3691249701c4$var$V = u;
                    else b: for(g = w; null !== $223b3691249701c4$var$V;){
                        h = $223b3691249701c4$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $223b3691249701c4$var$Qj(9, h);
                            }
                        } catch (na) {
                            $223b3691249701c4$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $223b3691249701c4$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $223b3691249701c4$var$V = F;
                            break b;
                        }
                        $223b3691249701c4$var$V = h.return;
                    }
                }
                $223b3691249701c4$var$K = e;
                $223b3691249701c4$var$jg();
                if ($223b3691249701c4$var$lc && "function" === typeof $223b3691249701c4$var$lc.onPostCommitFiberRoot) try {
                    $223b3691249701c4$var$lc.onPostCommitFiberRoot($223b3691249701c4$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $223b3691249701c4$var$C = c, $223b3691249701c4$var$ok.transition = b;
        }
    }
    return !1;
}
function $223b3691249701c4$var$Xk(a, b, c) {
    b = $223b3691249701c4$var$Ji(c, b);
    b = $223b3691249701c4$var$Ni(a, b, 1);
    a = $223b3691249701c4$var$nh(a, b, 1);
    b = $223b3691249701c4$var$R();
    null !== a && ($223b3691249701c4$var$Ac(a, 1, b), $223b3691249701c4$var$Dk(a, b));
}
function $223b3691249701c4$var$W(a, b, c) {
    if (3 === a.tag) $223b3691249701c4$var$Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $223b3691249701c4$var$Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $223b3691249701c4$var$Ri || !$223b3691249701c4$var$Ri.has(d))) {
                a = $223b3691249701c4$var$Ji(c, a);
                a = $223b3691249701c4$var$Qi(b, a, 1);
                b = $223b3691249701c4$var$nh(b, a, 1);
                a = $223b3691249701c4$var$R();
                null !== b && ($223b3691249701c4$var$Ac(b, 1, a), $223b3691249701c4$var$Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $223b3691249701c4$var$Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $223b3691249701c4$var$R();
    a.pingedLanes |= a.suspendedLanes & c;
    $223b3691249701c4$var$Q === a && ($223b3691249701c4$var$Z & c) === c && (4 === $223b3691249701c4$var$T || 3 === $223b3691249701c4$var$T && ($223b3691249701c4$var$Z & 130023424) === $223b3691249701c4$var$Z && 500 > $223b3691249701c4$var$B() - $223b3691249701c4$var$fk ? $223b3691249701c4$var$Kk(a, 0) : $223b3691249701c4$var$rk |= c);
    $223b3691249701c4$var$Dk(a, b);
}
function $223b3691249701c4$var$Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $223b3691249701c4$var$sc, $223b3691249701c4$var$sc <<= 1, 0 === ($223b3691249701c4$var$sc & 130023424) && ($223b3691249701c4$var$sc = 4194304)));
    var c = $223b3691249701c4$var$R();
    a = $223b3691249701c4$var$ih(a, b);
    null !== a && ($223b3691249701c4$var$Ac(a, b, c), $223b3691249701c4$var$Dk(a, c));
}
function $223b3691249701c4$var$uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $223b3691249701c4$var$Yk(a, c);
}
function $223b3691249701c4$var$bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($223b3691249701c4$var$p(314));
    }
    null !== d && d.delete(b);
    $223b3691249701c4$var$Yk(a, c);
}
var $223b3691249701c4$var$Vk;
$223b3691249701c4$var$Vk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $223b3691249701c4$var$Wf.current) $223b3691249701c4$var$dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $223b3691249701c4$var$dh = !1, $223b3691249701c4$var$yj(a, b, c);
            $223b3691249701c4$var$dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $223b3691249701c4$var$dh = !1, $223b3691249701c4$var$I && 0 !== (b.flags & 1048576) && $223b3691249701c4$var$ug(b, $223b3691249701c4$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $223b3691249701c4$var$ij(a, b);
            a = b.pendingProps;
            var e = $223b3691249701c4$var$Yf(b, $223b3691249701c4$var$H.current);
            $223b3691249701c4$var$ch(b, c);
            e = $223b3691249701c4$var$Nh(null, b, d, a, e, c);
            var f = $223b3691249701c4$var$Sh();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $223b3691249701c4$var$Zf(d) ? (f = !0, $223b3691249701c4$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $223b3691249701c4$var$kh(b), e.updater = $223b3691249701c4$var$Ei, b.stateNode = e, e._reactInternals = b, $223b3691249701c4$var$Ii(b, d, a, c), b = $223b3691249701c4$var$jj(null, b, d, !0, f, c)) : (b.tag = 0, $223b3691249701c4$var$I && f && $223b3691249701c4$var$vg(b), $223b3691249701c4$var$Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $223b3691249701c4$var$ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $223b3691249701c4$var$Zk(d);
                a = $223b3691249701c4$var$Ci(d, a);
                switch(e){
                    case 0:
                        b = $223b3691249701c4$var$cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $223b3691249701c4$var$hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $223b3691249701c4$var$Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $223b3691249701c4$var$$i(null, b, d, $223b3691249701c4$var$Ci(d.type, a), c);
                        break a;
                }
                throw Error($223b3691249701c4$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $223b3691249701c4$var$Ci(d, e), $223b3691249701c4$var$cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $223b3691249701c4$var$Ci(d, e), $223b3691249701c4$var$hj(a, b, d, e, c);
        case 3:
            a: {
                $223b3691249701c4$var$kj(b);
                if (null === a) throw Error($223b3691249701c4$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $223b3691249701c4$var$lh(a, b);
                $223b3691249701c4$var$qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $223b3691249701c4$var$Ji(Error($223b3691249701c4$var$p(423)), b);
                        b = $223b3691249701c4$var$lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $223b3691249701c4$var$Ji(Error($223b3691249701c4$var$p(424)), b);
                        b = $223b3691249701c4$var$lj(a, b, d, c, e);
                        break a;
                    } else for($223b3691249701c4$var$yg = $223b3691249701c4$var$Lf(b.stateNode.containerInfo.firstChild), $223b3691249701c4$var$xg = b, $223b3691249701c4$var$I = !0, $223b3691249701c4$var$zg = null, c = $223b3691249701c4$var$Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $223b3691249701c4$var$Ig();
                    if (d === e) {
                        b = $223b3691249701c4$var$Zi(a, b, c);
                        break a;
                    }
                    $223b3691249701c4$var$Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $223b3691249701c4$var$Ah(b), null === a && $223b3691249701c4$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $223b3691249701c4$var$Ef(d, e) ? g = null : null !== f && $223b3691249701c4$var$Ef(d, f) && (b.flags |= 32), $223b3691249701c4$var$gj(a, b), $223b3691249701c4$var$Xi(a, b, g, c), b.child;
        case 6:
            return null === a && $223b3691249701c4$var$Eg(b), null;
        case 13:
            return $223b3691249701c4$var$oj(a, b, c);
        case 4:
            return $223b3691249701c4$var$yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $223b3691249701c4$var$Ug(b, null, d, c) : $223b3691249701c4$var$Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $223b3691249701c4$var$Ci(d, e), $223b3691249701c4$var$Yi(a, b, d, e, c);
        case 7:
            return $223b3691249701c4$var$Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $223b3691249701c4$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $223b3691249701c4$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $223b3691249701c4$var$G($223b3691249701c4$var$Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($223b3691249701c4$var$He(f.value, g)) {
                        if (f.children === e.children && !$223b3691249701c4$var$Wf.current) {
                            b = $223b3691249701c4$var$Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $223b3691249701c4$var$mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $223b3691249701c4$var$bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($223b3691249701c4$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $223b3691249701c4$var$bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $223b3691249701c4$var$Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $223b3691249701c4$var$ch(b, c), e = $223b3691249701c4$var$eh(e), d = d(e), b.flags |= 1, $223b3691249701c4$var$Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $223b3691249701c4$var$Ci(d, b.pendingProps), e = $223b3691249701c4$var$Ci(d.type, e), $223b3691249701c4$var$$i(a, b, d, e, c);
        case 15:
            return $223b3691249701c4$var$bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $223b3691249701c4$var$Ci(d, e), $223b3691249701c4$var$ij(a, b), b.tag = 1, $223b3691249701c4$var$Zf(d) ? (a = !0, $223b3691249701c4$var$cg(b)) : a = !1, $223b3691249701c4$var$ch(b, c), $223b3691249701c4$var$Gi(b, d, e), $223b3691249701c4$var$Ii(b, d, e, c), $223b3691249701c4$var$jj(null, b, d, !0, a, c);
        case 19:
            return $223b3691249701c4$var$xj(a, b, c);
        case 22:
            return $223b3691249701c4$var$dj(a, b, c);
    }
    throw Error($223b3691249701c4$var$p(156, b.tag));
};
function $223b3691249701c4$var$Fk(a, b) {
    return $223b3691249701c4$var$ac(a, b);
}
function $223b3691249701c4$var$$k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $223b3691249701c4$var$Bg(a, b, c, d) {
    return new $223b3691249701c4$var$$k(a, b, c, d);
}
function $223b3691249701c4$var$aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $223b3691249701c4$var$Zk(a) {
    if ("function" === typeof a) return $223b3691249701c4$var$aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $223b3691249701c4$var$Da) return 11;
        if (a === $223b3691249701c4$var$Ga) return 14;
    }
    return 2;
}
function $223b3691249701c4$var$Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = $223b3691249701c4$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $223b3691249701c4$var$Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $223b3691249701c4$var$aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $223b3691249701c4$var$ya:
            return $223b3691249701c4$var$Tg(c.children, e, f, b);
        case $223b3691249701c4$var$za:
            g = 8;
            e |= 8;
            break;
        case $223b3691249701c4$var$Aa:
            return a = $223b3691249701c4$var$Bg(12, c, b, e | 2), a.elementType = $223b3691249701c4$var$Aa, a.lanes = f, a;
        case $223b3691249701c4$var$Ea:
            return a = $223b3691249701c4$var$Bg(13, c, b, e), a.elementType = $223b3691249701c4$var$Ea, a.lanes = f, a;
        case $223b3691249701c4$var$Fa:
            return a = $223b3691249701c4$var$Bg(19, c, b, e), a.elementType = $223b3691249701c4$var$Fa, a.lanes = f, a;
        case $223b3691249701c4$var$Ia:
            return $223b3691249701c4$var$pj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $223b3691249701c4$var$Ba:
                    g = 10;
                    break a;
                case $223b3691249701c4$var$Ca:
                    g = 9;
                    break a;
                case $223b3691249701c4$var$Da:
                    g = 11;
                    break a;
                case $223b3691249701c4$var$Ga:
                    g = 14;
                    break a;
                case $223b3691249701c4$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($223b3691249701c4$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $223b3691249701c4$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $223b3691249701c4$var$Tg(a, b, c, d) {
    a = $223b3691249701c4$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $223b3691249701c4$var$pj(a, b, c, d) {
    a = $223b3691249701c4$var$Bg(22, a, d, b);
    a.elementType = $223b3691249701c4$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $223b3691249701c4$var$Qg(a, b, c) {
    a = $223b3691249701c4$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $223b3691249701c4$var$Sg(a, b, c) {
    b = $223b3691249701c4$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $223b3691249701c4$var$al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $223b3691249701c4$var$zc(0);
    this.expirationTimes = $223b3691249701c4$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $223b3691249701c4$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $223b3691249701c4$var$bl(a, b, c, d, e, f, g, h, k) {
    a = new $223b3691249701c4$var$al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $223b3691249701c4$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $223b3691249701c4$var$kh(f);
    return a;
}
function $223b3691249701c4$var$cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $223b3691249701c4$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $223b3691249701c4$var$dl(a) {
    if (!a) return $223b3691249701c4$var$Vf;
    a = a._reactInternals;
    a: {
        if ($223b3691249701c4$var$Vb(a) !== a || 1 !== a.tag) throw Error($223b3691249701c4$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($223b3691249701c4$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($223b3691249701c4$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($223b3691249701c4$var$Zf(c)) return $223b3691249701c4$var$bg(a, c, b);
    }
    return b;
}
function $223b3691249701c4$var$el(a, b, c, d, e, f, g, h, k) {
    a = $223b3691249701c4$var$bl(c, d, !0, a, e, f, g, h, k);
    a.context = $223b3691249701c4$var$dl(null);
    c = a.current;
    d = $223b3691249701c4$var$R();
    e = $223b3691249701c4$var$yi(c);
    f = $223b3691249701c4$var$mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $223b3691249701c4$var$nh(c, f, e);
    a.current.lanes = e;
    $223b3691249701c4$var$Ac(a, e, d);
    $223b3691249701c4$var$Dk(a, d);
    return a;
}
function $223b3691249701c4$var$fl(a, b, c, d) {
    var e = b.current, f = $223b3691249701c4$var$R(), g = $223b3691249701c4$var$yi(e);
    c = $223b3691249701c4$var$dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $223b3691249701c4$var$mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $223b3691249701c4$var$nh(e, b, g);
    null !== a && ($223b3691249701c4$var$gi(a, e, g, f), $223b3691249701c4$var$oh(a, e, g));
    return g;
}
function $223b3691249701c4$var$gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $223b3691249701c4$var$hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $223b3691249701c4$var$il(a, b) {
    $223b3691249701c4$var$hl(a, b);
    (a = a.alternate) && $223b3691249701c4$var$hl(a, b);
}
function $223b3691249701c4$var$jl() {
    return null;
}
var $223b3691249701c4$var$kl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $223b3691249701c4$var$ll(a) {
    this._internalRoot = a;
}
$223b3691249701c4$var$ml.prototype.render = $223b3691249701c4$var$ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($223b3691249701c4$var$p(409));
    $223b3691249701c4$var$fl(a, b, null, null);
};
$223b3691249701c4$var$ml.prototype.unmount = $223b3691249701c4$var$ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $223b3691249701c4$var$Rk(function() {
            $223b3691249701c4$var$fl(null, a, null, null);
        });
        b[$223b3691249701c4$var$uf] = null;
    }
};
function $223b3691249701c4$var$ml(a) {
    this._internalRoot = a;
}
$223b3691249701c4$var$ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $223b3691249701c4$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $223b3691249701c4$var$Qc.length && 0 !== b && b < $223b3691249701c4$var$Qc[c].priority; c++);
        $223b3691249701c4$var$Qc.splice(c, 0, a);
        0 === c && $223b3691249701c4$var$Vc(a);
    }
};
function $223b3691249701c4$var$nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $223b3691249701c4$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $223b3691249701c4$var$pl() {}
function $223b3691249701c4$var$ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $223b3691249701c4$var$gl(g);
                f.call(a);
            };
        }
        var g = $223b3691249701c4$var$el(b, d, a, 0, null, !1, !1, "", $223b3691249701c4$var$pl);
        a._reactRootContainer = g;
        a[$223b3691249701c4$var$uf] = g.current;
        $223b3691249701c4$var$sf(8 === a.nodeType ? a.parentNode : a);
        $223b3691249701c4$var$Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $223b3691249701c4$var$gl(k);
            h.call(a);
        };
    }
    var k = $223b3691249701c4$var$bl(a, 0, !1, null, null, !1, !1, "", $223b3691249701c4$var$pl);
    a._reactRootContainer = k;
    a[$223b3691249701c4$var$uf] = k.current;
    $223b3691249701c4$var$sf(8 === a.nodeType ? a.parentNode : a);
    $223b3691249701c4$var$Rk(function() {
        $223b3691249701c4$var$fl(b, k, c, d);
    });
    return k;
}
function $223b3691249701c4$var$rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $223b3691249701c4$var$gl(g);
                h.call(a);
            };
        }
        $223b3691249701c4$var$fl(b, g, a, e);
    } else g = $223b3691249701c4$var$ql(c, b, a, e, d);
    return $223b3691249701c4$var$gl(g);
}
$223b3691249701c4$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $223b3691249701c4$var$tc(b.pendingLanes);
                0 !== c && ($223b3691249701c4$var$Cc(b, c | 1), $223b3691249701c4$var$Dk(b, $223b3691249701c4$var$B()), 0 === ($223b3691249701c4$var$K & 6) && ($223b3691249701c4$var$Gj = $223b3691249701c4$var$B() + 500, $223b3691249701c4$var$jg()));
            }
            break;
        case 13:
            $223b3691249701c4$var$Rk(function() {
                var b = $223b3691249701c4$var$ih(a, 1);
                if (null !== b) {
                    var c = $223b3691249701c4$var$R();
                    $223b3691249701c4$var$gi(b, a, 1, c);
                }
            }), $223b3691249701c4$var$il(a, 1);
    }
};
$223b3691249701c4$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $223b3691249701c4$var$ih(a, 134217728);
        if (null !== b) {
            var c = $223b3691249701c4$var$R();
            $223b3691249701c4$var$gi(b, a, 134217728, c);
        }
        $223b3691249701c4$var$il(a, 134217728);
    }
};
$223b3691249701c4$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $223b3691249701c4$var$yi(a), c = $223b3691249701c4$var$ih(a, b);
        if (null !== c) {
            var d = $223b3691249701c4$var$R();
            $223b3691249701c4$var$gi(c, a, b, d);
        }
        $223b3691249701c4$var$il(a, b);
    }
};
$223b3691249701c4$var$Hc = function() {
    return $223b3691249701c4$var$C;
};
$223b3691249701c4$var$Ic = function(a, b) {
    var c = $223b3691249701c4$var$C;
    try {
        return $223b3691249701c4$var$C = a, b();
    } finally{
        $223b3691249701c4$var$C = c;
    }
};
$223b3691249701c4$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $223b3691249701c4$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $223b3691249701c4$var$Db(d);
                        if (!e) throw Error($223b3691249701c4$var$p(90));
                        $223b3691249701c4$var$Wa(d);
                        $223b3691249701c4$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $223b3691249701c4$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $223b3691249701c4$var$fb(a, !!c.multiple, b, !1);
    }
};
$223b3691249701c4$var$Gb = $223b3691249701c4$var$Qk;
$223b3691249701c4$var$Hb = $223b3691249701c4$var$Rk;
var $223b3691249701c4$var$sl = {
    usingClientEntryPoint: !1,
    Events: [
        $223b3691249701c4$var$Cb,
        $223b3691249701c4$var$ue,
        $223b3691249701c4$var$Db,
        $223b3691249701c4$var$Eb,
        $223b3691249701c4$var$Fb,
        $223b3691249701c4$var$Qk
    ]
}, $223b3691249701c4$var$tl = {
    findFiberByHostInstance: $223b3691249701c4$var$Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var $223b3691249701c4$var$ul = {
    bundleType: $223b3691249701c4$var$tl.bundleType,
    version: $223b3691249701c4$var$tl.version,
    rendererPackageName: $223b3691249701c4$var$tl.rendererPackageName,
    rendererConfig: $223b3691249701c4$var$tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $223b3691249701c4$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $223b3691249701c4$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $223b3691249701c4$var$tl.findFiberByHostInstance || $223b3691249701c4$var$jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $223b3691249701c4$var$vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$223b3691249701c4$var$vl.isDisabled && $223b3691249701c4$var$vl.supportsFiber) try {
        $223b3691249701c4$var$kc = $223b3691249701c4$var$vl.inject($223b3691249701c4$var$ul), $223b3691249701c4$var$lc = $223b3691249701c4$var$vl;
    } catch (a) {}
}
$223b3691249701c4$export$ae55be85d98224ed = $223b3691249701c4$var$sl;
$223b3691249701c4$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$223b3691249701c4$var$nl(b)) throw Error($223b3691249701c4$var$p(200));
    return $223b3691249701c4$var$cl(a, b, null, c);
};
$223b3691249701c4$export$882461b6382ed46c = function(a, b) {
    if (!$223b3691249701c4$var$nl(a)) throw Error($223b3691249701c4$var$p(299));
    var c = !1, d = "", e = $223b3691249701c4$var$kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $223b3691249701c4$var$bl(a, 1, !1, null, null, c, !1, d, e);
    a[$223b3691249701c4$var$uf] = b.current;
    $223b3691249701c4$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $223b3691249701c4$var$ll(b);
};
$223b3691249701c4$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($223b3691249701c4$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($223b3691249701c4$var$p(268, a));
    }
    a = $223b3691249701c4$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$223b3691249701c4$export$cd75ccfd720a3cd4 = function(a) {
    return $223b3691249701c4$var$Rk(a);
};
$223b3691249701c4$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$223b3691249701c4$var$ol(b)) throw Error($223b3691249701c4$var$p(200));
    return $223b3691249701c4$var$rl(null, a, b, !0, c);
};
$223b3691249701c4$export$757ceba2d55c277e = function(a, b, c) {
    if (!$223b3691249701c4$var$nl(a)) throw Error($223b3691249701c4$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $223b3691249701c4$var$kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $223b3691249701c4$var$el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$223b3691249701c4$var$uf] = b.current;
    $223b3691249701c4$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $223b3691249701c4$var$ml(b);
};
$223b3691249701c4$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$223b3691249701c4$var$ol(b)) throw Error($223b3691249701c4$var$p(200));
    return $223b3691249701c4$var$rl(null, a, b, !1, c);
};
$223b3691249701c4$export$502457920280e6be = function(a) {
    if (!$223b3691249701c4$var$ol(a)) throw Error($223b3691249701c4$var$p(40));
    return a._reactRootContainer ? ($223b3691249701c4$var$Rk(function() {
        $223b3691249701c4$var$rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$223b3691249701c4$var$uf] = null;
        });
    }), !0) : !1;
};
$223b3691249701c4$export$c78a37762a8d58e1 = $223b3691249701c4$var$Qk;
$223b3691249701c4$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$223b3691249701c4$var$ol(c)) throw Error($223b3691249701c4$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($223b3691249701c4$var$p(38));
    return $223b3691249701c4$var$rl(a, b, c, !1, d);
};
$223b3691249701c4$export$83d89fbfd8236492 = "18.3.1-next-f1338f8080-20240426";

});
parcelRegister("l7BOg", function(module, exports) {
"use strict";

module.exports = (parcelRequire("lSa6a"));

});
parcelRegister("lSa6a", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $fec67976f0e16090$export$c4744153514ff05d; }, function (v) { return $fec67976f0e16090$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $fec67976f0e16090$export$3e506c1ccc9cc1a7; }, function (v) { return $fec67976f0e16090$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $fec67976f0e16090$export$e26fe2ed2fa76875; }, function (v) { return $fec67976f0e16090$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $fec67976f0e16090$export$502329bbf4b505b1; }, function (v) { return $fec67976f0e16090$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $fec67976f0e16090$export$6e3807111c4874c4; }, function (v) { return $fec67976f0e16090$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $fec67976f0e16090$export$c27134553091fb3a; }, function (v) { return $fec67976f0e16090$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $fec67976f0e16090$export$33ee1acdc04fd2a2; }, function (v) { return $fec67976f0e16090$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $fec67976f0e16090$export$b00a404bbd5edef2; }, function (v) { return $fec67976f0e16090$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $fec67976f0e16090$export$8352ce38b91d0c62; }, function (v) { return $fec67976f0e16090$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $fec67976f0e16090$export$d66a1c1c77bd778b; }, function (v) { return $fec67976f0e16090$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $fec67976f0e16090$export$d3dfb8e4810cb555; }, function (v) { return $fec67976f0e16090$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $fec67976f0e16090$export$839f9183b0465a69; }, function (v) { return $fec67976f0e16090$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $fec67976f0e16090$export$72fdf0e06517287b; }, function (v) { return $fec67976f0e16090$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $fec67976f0e16090$export$4b844e58a3e414b4; }, function (v) { return $fec67976f0e16090$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $fec67976f0e16090$export$816d2913ae6b83b1; }, function (v) { return $fec67976f0e16090$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $fec67976f0e16090$export$61bcfe829111a1d0; }, function (v) { return $fec67976f0e16090$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $fec67976f0e16090$export$7ee8c9beb337bc3f; }, function (v) { return $fec67976f0e16090$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $fec67976f0e16090$export$b5836b71941fa3ed; }, function (v) { return $fec67976f0e16090$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $fec67976f0e16090$export$cf845f2c119da08a; }, function (v) { return $fec67976f0e16090$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $fec67976f0e16090$export$c4744153514ff05d;
var $fec67976f0e16090$export$3e506c1ccc9cc1a7;
var $fec67976f0e16090$export$e26fe2ed2fa76875;
var $fec67976f0e16090$export$502329bbf4b505b1;
var $fec67976f0e16090$export$6e3807111c4874c4;
var $fec67976f0e16090$export$c27134553091fb3a;
var $fec67976f0e16090$export$33ee1acdc04fd2a2;
var $fec67976f0e16090$export$b00a404bbd5edef2;
var $fec67976f0e16090$export$8352ce38b91d0c62;
var $fec67976f0e16090$export$d66a1c1c77bd778b;
var $fec67976f0e16090$export$d3dfb8e4810cb555;
var $fec67976f0e16090$export$839f9183b0465a69;
var $fec67976f0e16090$export$72fdf0e06517287b;
var $fec67976f0e16090$export$4b844e58a3e414b4;
var $fec67976f0e16090$export$816d2913ae6b83b1;
var $fec67976f0e16090$export$61bcfe829111a1d0;
var $fec67976f0e16090$export$7ee8c9beb337bc3f;
var $fec67976f0e16090$export$b5836b71941fa3ed;
var $fec67976f0e16090$export$cf845f2c119da08a;
"use strict";
function $fec67976f0e16090$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $fec67976f0e16090$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $fec67976f0e16090$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $fec67976f0e16090$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $fec67976f0e16090$var$g(C, c)) n < e && 0 > $fec67976f0e16090$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $fec67976f0e16090$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $fec67976f0e16090$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $fec67976f0e16090$var$l = performance;
    $fec67976f0e16090$export$c4744153514ff05d = function() {
        return $fec67976f0e16090$var$l.now();
    };
} else {
    var $fec67976f0e16090$var$p = Date, $fec67976f0e16090$var$q = $fec67976f0e16090$var$p.now();
    $fec67976f0e16090$export$c4744153514ff05d = function() {
        return $fec67976f0e16090$var$p.now() - $fec67976f0e16090$var$q;
    };
}
var $fec67976f0e16090$var$r = [], $fec67976f0e16090$var$t = [], $fec67976f0e16090$var$u = 1, $fec67976f0e16090$var$v = null, $fec67976f0e16090$var$y = 3, $fec67976f0e16090$var$z = !1, $fec67976f0e16090$var$A = !1, $fec67976f0e16090$var$B = !1, $fec67976f0e16090$var$D = "function" === typeof setTimeout ? setTimeout : null, $fec67976f0e16090$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $fec67976f0e16090$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $fec67976f0e16090$var$G(a) {
    for(var b = $fec67976f0e16090$var$h($fec67976f0e16090$var$t); null !== b;){
        if (null === b.callback) $fec67976f0e16090$var$k($fec67976f0e16090$var$t);
        else if (b.startTime <= a) $fec67976f0e16090$var$k($fec67976f0e16090$var$t), b.sortIndex = b.expirationTime, $fec67976f0e16090$var$f($fec67976f0e16090$var$r, b);
        else break;
        b = $fec67976f0e16090$var$h($fec67976f0e16090$var$t);
    }
}
function $fec67976f0e16090$var$H(a) {
    $fec67976f0e16090$var$B = !1;
    $fec67976f0e16090$var$G(a);
    if (!$fec67976f0e16090$var$A) {
        if (null !== $fec67976f0e16090$var$h($fec67976f0e16090$var$r)) $fec67976f0e16090$var$A = !0, $fec67976f0e16090$var$I($fec67976f0e16090$var$J);
        else {
            var b = $fec67976f0e16090$var$h($fec67976f0e16090$var$t);
            null !== b && $fec67976f0e16090$var$K($fec67976f0e16090$var$H, b.startTime - a);
        }
    }
}
function $fec67976f0e16090$var$J(a, b) {
    $fec67976f0e16090$var$A = !1;
    $fec67976f0e16090$var$B && ($fec67976f0e16090$var$B = !1, $fec67976f0e16090$var$E($fec67976f0e16090$var$L), $fec67976f0e16090$var$L = -1);
    $fec67976f0e16090$var$z = !0;
    var c = $fec67976f0e16090$var$y;
    try {
        $fec67976f0e16090$var$G(b);
        for($fec67976f0e16090$var$v = $fec67976f0e16090$var$h($fec67976f0e16090$var$r); null !== $fec67976f0e16090$var$v && (!($fec67976f0e16090$var$v.expirationTime > b) || a && !$fec67976f0e16090$var$M());){
            var d = $fec67976f0e16090$var$v.callback;
            if ("function" === typeof d) {
                $fec67976f0e16090$var$v.callback = null;
                $fec67976f0e16090$var$y = $fec67976f0e16090$var$v.priorityLevel;
                var e = d($fec67976f0e16090$var$v.expirationTime <= b);
                b = $fec67976f0e16090$export$c4744153514ff05d();
                "function" === typeof e ? $fec67976f0e16090$var$v.callback = e : $fec67976f0e16090$var$v === $fec67976f0e16090$var$h($fec67976f0e16090$var$r) && $fec67976f0e16090$var$k($fec67976f0e16090$var$r);
                $fec67976f0e16090$var$G(b);
            } else $fec67976f0e16090$var$k($fec67976f0e16090$var$r);
            $fec67976f0e16090$var$v = $fec67976f0e16090$var$h($fec67976f0e16090$var$r);
        }
        if (null !== $fec67976f0e16090$var$v) var w = !0;
        else {
            var m = $fec67976f0e16090$var$h($fec67976f0e16090$var$t);
            null !== m && $fec67976f0e16090$var$K($fec67976f0e16090$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $fec67976f0e16090$var$v = null, $fec67976f0e16090$var$y = c, $fec67976f0e16090$var$z = !1;
    }
}
var $fec67976f0e16090$var$N = !1, $fec67976f0e16090$var$O = null, $fec67976f0e16090$var$L = -1, $fec67976f0e16090$var$P = 5, $fec67976f0e16090$var$Q = -1;
function $fec67976f0e16090$var$M() {
    return $fec67976f0e16090$export$c4744153514ff05d() - $fec67976f0e16090$var$Q < $fec67976f0e16090$var$P ? !1 : !0;
}
function $fec67976f0e16090$var$R() {
    if (null !== $fec67976f0e16090$var$O) {
        var a = $fec67976f0e16090$export$c4744153514ff05d();
        $fec67976f0e16090$var$Q = a;
        var b = !0;
        try {
            b = $fec67976f0e16090$var$O(!0, a);
        } finally{
            b ? $fec67976f0e16090$var$S() : ($fec67976f0e16090$var$N = !1, $fec67976f0e16090$var$O = null);
        }
    } else $fec67976f0e16090$var$N = !1;
}
var $fec67976f0e16090$var$S;
if ("function" === typeof $fec67976f0e16090$var$F) $fec67976f0e16090$var$S = function() {
    $fec67976f0e16090$var$F($fec67976f0e16090$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $fec67976f0e16090$var$T = new MessageChannel, $fec67976f0e16090$var$U = $fec67976f0e16090$var$T.port2;
    $fec67976f0e16090$var$T.port1.onmessage = $fec67976f0e16090$var$R;
    $fec67976f0e16090$var$S = function() {
        $fec67976f0e16090$var$U.postMessage(null);
    };
} else $fec67976f0e16090$var$S = function() {
    $fec67976f0e16090$var$D($fec67976f0e16090$var$R, 0);
};
function $fec67976f0e16090$var$I(a) {
    $fec67976f0e16090$var$O = a;
    $fec67976f0e16090$var$N || ($fec67976f0e16090$var$N = !0, $fec67976f0e16090$var$S());
}
function $fec67976f0e16090$var$K(a, b) {
    $fec67976f0e16090$var$L = $fec67976f0e16090$var$D(function() {
        a($fec67976f0e16090$export$c4744153514ff05d());
    }, b);
}
$fec67976f0e16090$export$3e506c1ccc9cc1a7 = 5;
$fec67976f0e16090$export$e26fe2ed2fa76875 = 1;
$fec67976f0e16090$export$502329bbf4b505b1 = 4;
$fec67976f0e16090$export$6e3807111c4874c4 = 3;
$fec67976f0e16090$export$c27134553091fb3a = null;
$fec67976f0e16090$export$33ee1acdc04fd2a2 = 2;
$fec67976f0e16090$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$fec67976f0e16090$export$8352ce38b91d0c62 = function() {
    $fec67976f0e16090$var$A || $fec67976f0e16090$var$z || ($fec67976f0e16090$var$A = !0, $fec67976f0e16090$var$I($fec67976f0e16090$var$J));
};
$fec67976f0e16090$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $fec67976f0e16090$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$fec67976f0e16090$export$d3dfb8e4810cb555 = function() {
    return $fec67976f0e16090$var$y;
};
$fec67976f0e16090$export$839f9183b0465a69 = function() {
    return $fec67976f0e16090$var$h($fec67976f0e16090$var$r);
};
$fec67976f0e16090$export$72fdf0e06517287b = function(a) {
    switch($fec67976f0e16090$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $fec67976f0e16090$var$y;
    }
    var c = $fec67976f0e16090$var$y;
    $fec67976f0e16090$var$y = b;
    try {
        return a();
    } finally{
        $fec67976f0e16090$var$y = c;
    }
};
$fec67976f0e16090$export$4b844e58a3e414b4 = function() {};
$fec67976f0e16090$export$816d2913ae6b83b1 = function() {};
$fec67976f0e16090$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $fec67976f0e16090$var$y;
    $fec67976f0e16090$var$y = a;
    try {
        return b();
    } finally{
        $fec67976f0e16090$var$y = c;
    }
};
$fec67976f0e16090$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $fec67976f0e16090$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $fec67976f0e16090$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $fec67976f0e16090$var$f($fec67976f0e16090$var$t, a), null === $fec67976f0e16090$var$h($fec67976f0e16090$var$r) && a === $fec67976f0e16090$var$h($fec67976f0e16090$var$t) && ($fec67976f0e16090$var$B ? ($fec67976f0e16090$var$E($fec67976f0e16090$var$L), $fec67976f0e16090$var$L = -1) : $fec67976f0e16090$var$B = !0, $fec67976f0e16090$var$K($fec67976f0e16090$var$H, c - d))) : (a.sortIndex = e, $fec67976f0e16090$var$f($fec67976f0e16090$var$r, a), $fec67976f0e16090$var$A || $fec67976f0e16090$var$z || ($fec67976f0e16090$var$A = !0, $fec67976f0e16090$var$I($fec67976f0e16090$var$J)));
    return a;
};
$fec67976f0e16090$export$b5836b71941fa3ed = $fec67976f0e16090$var$M;
$fec67976f0e16090$export$cf845f2c119da08a = function(a) {
    var b = $fec67976f0e16090$var$y;
    return function() {
        var c = $fec67976f0e16090$var$y;
        $fec67976f0e16090$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $fec67976f0e16090$var$y = c;
        }
    };
};

});




parcelRegister("1ig10", function(module, exports) {

$parcel$export(module.exports, "Action", function () { return $0f13e53339adf17f$export$e19cd5f9376f8cee; });
$parcel$export(module.exports, "createMemoryHistory", function () { return $0f13e53339adf17f$export$2b76ad033c6e6d08; });
$parcel$export(module.exports, "createPath", function () { return $0f13e53339adf17f$export$fe53371bee54353d; });
$parcel$export(module.exports, "parsePath", function () { return $0f13e53339adf17f$export$8ccf933b0513f8d0; });
$parcel$export(module.exports, "createBrowserHistory", function () { return $0f13e53339adf17f$export$719fc203c4e16dee; });
$parcel$export(module.exports, "createHashHistory", function () { return $0f13e53339adf17f$export$b71fdd3798280242; });
$parcel$export(module.exports, "UNSAFE_invariant", function () { return $0f13e53339adf17f$export$3e9cee6b33872309; });
$parcel$export(module.exports, "matchRoutes", function () { return $0f13e53339adf17f$export$2708184779ceb39d; });
$parcel$export(module.exports, "stripBasename", function () { return $0f13e53339adf17f$export$b69e3301ce081aa3; });
$parcel$export(module.exports, "UNSAFE_convertRouteMatchToUiMatch", function () { return $0f13e53339adf17f$export$b3fac024fad9e8ff; });
$parcel$export(module.exports, "joinPaths", function () { return $0f13e53339adf17f$export$86d9a7913e44197e; });
$parcel$export(module.exports, "matchPath", function () { return $0f13e53339adf17f$export$81336c211d5ff295; });
$parcel$export(module.exports, "UNSAFE_getResolveToMatches", function () { return $0f13e53339adf17f$export$a5784978eca585fa; });
$parcel$export(module.exports, "resolveTo", function () { return $0f13e53339adf17f$export$cae722b0cc860f13; });
$parcel$export(module.exports, "AbortedDeferredError", function () { return $0f13e53339adf17f$export$42a99a7a4bc0e76a; });
$parcel$export(module.exports, "UNSAFE_ErrorResponseImpl", function () { return $0f13e53339adf17f$export$6c6580e81da25755; });
$parcel$export(module.exports, "isRouteErrorResponse", function () { return $0f13e53339adf17f$export$972111febbeef05b; });
$parcel$export(module.exports, "IDLE_FETCHER", function () { return $0f13e53339adf17f$export$52eace9c284d3585; });
$parcel$export(module.exports, "IDLE_BLOCKER", function () { return $0f13e53339adf17f$export$386d57f03f0b2883; });
$parcel$export(module.exports, "createRouter", function () { return $0f13e53339adf17f$export$baddd0131ee8c05b; });
/**
 * @remix-run/router v1.15.3
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $0f13e53339adf17f$var$_extends() {
    $0f13e53339adf17f$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $0f13e53339adf17f$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $0f13e53339adf17f$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($0f13e53339adf17f$export$e19cd5f9376f8cee || ($0f13e53339adf17f$export$e19cd5f9376f8cee = {}));
const $0f13e53339adf17f$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $0f13e53339adf17f$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $0f13e53339adf17f$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $0f13e53339adf17f$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $0f13e53339adf17f$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $0f13e53339adf17f$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $0f13e53339adf17f$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $0f13e53339adf17f$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $0f13e53339adf17f$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $0f13e53339adf17f$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $0f13e53339adf17f$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $0f13e53339adf17f$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $0f13e53339adf17f$export$fe53371bee54353d(to);
    }
    return $0f13e53339adf17f$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $0f13e53339adf17f$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $0f13e53339adf17f$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $0f13e53339adf17f$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $0f13e53339adf17f$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $0f13e53339adf17f$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $0f13e53339adf17f$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $0f13e53339adf17f$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $0f13e53339adf17f$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $0f13e53339adf17f$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $0f13e53339adf17f$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $0f13e53339adf17f$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $0f13e53339adf17f$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $0f13e53339adf17f$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $0f13e53339adf17f$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $0f13e53339adf17f$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $0f13e53339adf17f$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $0f13e53339adf17f$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $0f13e53339adf17f$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($0f13e53339adf17f$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $0f13e53339adf17f$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $0f13e53339adf17f$export$e19cd5f9376f8cee.Push;
        let location = $0f13e53339adf17f$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $0f13e53339adf17f$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $0f13e53339adf17f$export$e19cd5f9376f8cee.Replace;
        let location = $0f13e53339adf17f$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $0f13e53339adf17f$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $0f13e53339adf17f$export$fe53371bee54353d(to);
        // Treating this as a full URL will strip any trailing spaces so we need to
        // pre-encode them since they might be part of a matching splat param from
        // an ancestor route
        href = href.replace(/ $/, "%20");
        $0f13e53339adf17f$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($0f13e53339adf17f$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($0f13e53339adf17f$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $0f13e53339adf17f$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($0f13e53339adf17f$var$ResultType || ($0f13e53339adf17f$var$ResultType = {}));
const $0f13e53339adf17f$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $0f13e53339adf17f$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $0f13e53339adf17f$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            index
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $0f13e53339adf17f$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $0f13e53339adf17f$export$3e9cee6b33872309(!manifest[id], 'Found a route id collision on id "' + id + '".  Route ' + "id's must be globally unique within Data Router usages");
        if ($0f13e53339adf17f$var$isIndexRoute(route)) {
            let indexRoute = $0f13e53339adf17f$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $0f13e53339adf17f$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $0f13e53339adf17f$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/utils/match-routes
 */ function $0f13e53339adf17f$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    let location = typeof locationArg === "string" ? $0f13e53339adf17f$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $0f13e53339adf17f$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $0f13e53339adf17f$var$flattenRoutes(routes);
    $0f13e53339adf17f$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i){
        // Incoming pathnames are generally encoded from either window.location
        // or from router.navigate, but we want to match against the unencoded
        // paths in the route definitions.  Memory router locations won't be
        // encoded here but there also shouldn't be anything to decode so this
        // should be a safe operation.  This avoids needing matchRoutes to be
        // history-aware.
        let decoded = $0f13e53339adf17f$var$decodePath(pathname);
        matches = $0f13e53339adf17f$var$matchRouteBranch(branches[i], decoded);
    }
    return matches;
}
function $0f13e53339adf17f$export$b3fac024fad9e8ff(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $0f13e53339adf17f$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $0f13e53339adf17f$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), 'Absolute route path "' + meta.relativePath + '" nested under path ' + ('"' + parentPath + '" is not valid. An absolute child route path ') + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $0f13e53339adf17f$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $0f13e53339adf17f$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ('all child routes from route path "' + path + '".'));
            $0f13e53339adf17f$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $0f13e53339adf17f$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $0f13e53339adf17f$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $0f13e53339adf17f$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $0f13e53339adf17f$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $0f13e53339adf17f$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $0f13e53339adf17f$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $0f13e53339adf17f$var$paramRe = /^:[\w-]+$/;
const $0f13e53339adf17f$var$dynamicSegmentValue = 3;
const $0f13e53339adf17f$var$indexRouteValue = 2;
const $0f13e53339adf17f$var$emptySegmentValue = 1;
const $0f13e53339adf17f$var$staticSegmentValue = 10;
const $0f13e53339adf17f$var$splatPenalty = -2;
const $0f13e53339adf17f$var$isSplat = (s)=>s === "*";
function $0f13e53339adf17f$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($0f13e53339adf17f$var$isSplat)) initialScore += $0f13e53339adf17f$var$splatPenalty;
    if (index) initialScore += $0f13e53339adf17f$var$indexRouteValue;
    return segments.filter((s)=>!$0f13e53339adf17f$var$isSplat(s)).reduce((score, segment)=>score + ($0f13e53339adf17f$var$paramRe.test(segment) ? $0f13e53339adf17f$var$dynamicSegmentValue : segment === "" ? $0f13e53339adf17f$var$emptySegmentValue : $0f13e53339adf17f$var$staticSegmentValue), initialScore);
}
function $0f13e53339adf17f$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $0f13e53339adf17f$var$matchRouteBranch(branch, pathname) {
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $0f13e53339adf17f$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        let route = meta.route;
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $0f13e53339adf17f$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $0f13e53339adf17f$export$a5c6d149b50c1d86($0f13e53339adf17f$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $0f13e53339adf17f$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/utils/generate-path
 */ function $0f13e53339adf17f$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $0f13e53339adf17f$export$c0e02632e14916fd(false, 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $0f13e53339adf17f$export$3e9cee6b33872309(optional === "?" || param != null, 'Missing ":' + key + '" param');
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/utils/match-path
 */ function $0f13e53339adf17f$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $0f13e53339adf17f$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo, _ref, index)=>{
        let { paramName: paramName, isOptional: isOptional } = _ref;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = (value || "").replace(/%2F/g, "/");
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $0f13e53339adf17f$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $0f13e53339adf17f$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function $0f13e53339adf17f$var$decodePath(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $0f13e53339adf17f$export$c0e02632e14916fd(false, 'The URL path "' + value + '" could not be decoded because it is is a ' + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $0f13e53339adf17f$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/utils/resolve-path
 */ function $0f13e53339adf17f$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $0f13e53339adf17f$export$8ccf933b0513f8d0(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $0f13e53339adf17f$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $0f13e53339adf17f$var$normalizeSearch(search),
        hash: $0f13e53339adf17f$var$normalizeHash(hash)
    };
}
function $0f13e53339adf17f$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $0f13e53339adf17f$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + 'a string in <Link to="..."> and the router will parse it for you.';
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $0f13e53339adf17f$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function $0f13e53339adf17f$export$a5784978eca585fa(matches, v7_relativeSplatPath) {
    let pathMatches = $0f13e53339adf17f$var$getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map((match, idx)=>idx === matches.length - 1 ? match.pathname : match.pathnameBase);
    return pathMatches.map((match)=>match.pathnameBase);
}
/**
 * @private
 */ function $0f13e53339adf17f$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $0f13e53339adf17f$export$8ccf933b0513f8d0(toArg);
    else {
        to = $0f13e53339adf17f$var$_extends({}, toArg);
        $0f13e53339adf17f$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $0f13e53339adf17f$var$getInvalidPathError("?", "pathname", "search", to));
        $0f13e53339adf17f$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $0f13e53339adf17f$var$getInvalidPathError("#", "pathname", "hash", to));
        $0f13e53339adf17f$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $0f13e53339adf17f$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $0f13e53339adf17f$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $0f13e53339adf17f$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $0f13e53339adf17f$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $0f13e53339adf17f$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $0f13e53339adf17f$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $0f13e53339adf17f$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $0f13e53339adf17f$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 */ const $0f13e53339adf17f$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $0f13e53339adf17f$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $0f13e53339adf17f$export$42a99a7a4bc0e76a extends Error {
}
class $0f13e53339adf17f$export$61d759255b4eec65 {
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $0f13e53339adf17f$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $0f13e53339adf17f$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $0f13e53339adf17f$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error('Deferred data for key "' + key + '" resolved/rejected with `undefined`, ' + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $0f13e53339adf17f$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref3)=>{
            let [key, value] = _ref3;
            return Object.assign(acc, {
                [key]: $0f13e53339adf17f$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
}
function $0f13e53339adf17f$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $0f13e53339adf17f$var$unwrapTrackedPromise(value) {
    if (!$0f13e53339adf17f$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
const $0f13e53339adf17f$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $0f13e53339adf17f$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $0f13e53339adf17f$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $0f13e53339adf17f$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $0f13e53339adf17f$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $0f13e53339adf17f$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ class $0f13e53339adf17f$export$6c6580e81da25755 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $0f13e53339adf17f$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $0f13e53339adf17f$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $0f13e53339adf17f$var$validMutationMethods = new Set($0f13e53339adf17f$var$validMutationMethodsArr);
const $0f13e53339adf17f$var$validRequestMethodsArr = [
    "get",
    ...$0f13e53339adf17f$var$validMutationMethodsArr
];
const $0f13e53339adf17f$var$validRequestMethods = new Set($0f13e53339adf17f$var$validRequestMethodsArr);
const $0f13e53339adf17f$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $0f13e53339adf17f$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $0f13e53339adf17f$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $0f13e53339adf17f$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $0f13e53339adf17f$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $0f13e53339adf17f$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $0f13e53339adf17f$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
const $0f13e53339adf17f$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $0f13e53339adf17f$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $0f13e53339adf17f$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $0f13e53339adf17f$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $0f13e53339adf17f$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    // Config driven behavior flags
    let future = $0f13e53339adf17f$var$_extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $0f13e53339adf17f$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialErrors = null;
    if (initialMatches == null) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $0f13e53339adf17f$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $0f13e53339adf17f$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    let initialized;
    let hasLazyRoutes = initialMatches.some((m)=>m.route.lazy);
    let hasLoaders = initialMatches.some((m)=>m.route.loader);
    if (hasLazyRoutes) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!hasLoaders) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        let errors = init.hydrationData ? init.hydrationData.errors : null;
        let isRouteInitialized = (m)=>{
            // No loader, nothing to initialize
            if (!m.route.loader) return true;
            // Explicitly opting-in to running on hydration
            if (m.route.loader.hydrate === true) return false;
            // Otherwise, initialized if hydrated with data or an error
            return loaderData && loaderData[m.route.id] !== undefined || errors && errors[m.route.id] !== undefined;
        };
        // If errors exist, don't consider routes below the boundary
        if (errors) {
            let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== undefined);
            initialized = initialMatches.slice(0, idx + 1).every(isRouteInitialized);
        } else initialized = initialMatches.every(isRouteInitialized);
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $0f13e53339adf17f$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $0f13e53339adf17f$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    let pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    let appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    let removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = [];
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    let activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    let deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let ignoreNextHistoryUpdate = false;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (ignoreNextHistoryUpdate) {
                ignoreNextHistoryUpdate = false;
                return;
            }
            $0f13e53339adf17f$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                ignoreNextHistoryUpdate = true;
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked
                        init.history.go(delta);
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $0f13e53339adf17f$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            $0f13e53339adf17f$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$0f13e53339adf17f$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($0f13e53339adf17f$export$e19cd5f9376f8cee.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = $0f13e53339adf17f$var$_extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        let completedFetchers = [];
        let deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                unstable_viewTransitionOpts: opts.viewTransitionOpts,
                unstable_flushSync: opts.flushSync === true
            }));
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach((key)=>state.fetchers.delete(key));
            deletedFetchersKeys.forEach((key)=>deleteFetcher(key));
        }
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        let { flushSync: flushSync } = _temp === void 0 ? {} : _temp;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $0f13e53339adf17f$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $0f13e53339adf17f$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $0f13e53339adf17f$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $0f13e53339adf17f$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $0f13e53339adf17f$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $0f13e53339adf17f$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $0f13e53339adf17f$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        let viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === $0f13e53339adf17f$export$e19cd5f9376f8cee.Pop) {
            // Forward takes precedence so they behave like the original navigation
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState($0f13e53339adf17f$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $0f13e53339adf17f$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = $0f13e53339adf17f$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
        cancelledFetcherLoads = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $0f13e53339adf17f$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $0f13e53339adf17f$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $0f13e53339adf17f$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $0f13e53339adf17f$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $0f13e53339adf17f$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $0f13e53339adf17f$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $0f13e53339adf17f$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $0f13e53339adf17f$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let flushSync = (opts && opts.unstable_flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $0f13e53339adf17f$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.unstable_viewTransition,
            flushSync: flushSync
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = $0f13e53339adf17f$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let error = $0f13e53339adf17f$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $0f13e53339adf17f$var$getShortCircuitMatches(routesToUse);
            // Cancel all pending deferred on 404s since we don't keep any routes
            cancelActiveDeferreds();
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial load will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (state.initialized && !isRevalidationRequired && $0f13e53339adf17f$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $0f13e53339adf17f$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $0f13e53339adf17f$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionData;
        let pendingError;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingError = {
            [$0f13e53339adf17f$var$findNearestBoundary(matches).route.id]: opts.pendingError
        };
        else if (opts && opts.submission && $0f13e53339adf17f$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionOutput = await handleAction(request, location, opts.submission, matches, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionOutput.shortCircuited) return;
            pendingActionData = actionOutput.pendingActionData;
            pendingError = actionOutput.pendingActionError;
            loadingNavigation = $0f13e53339adf17f$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            // Create a GET request for the loaders
            request = new Request(request.url, {
                signal: request.signal
            });
        }
        // Call loaders
        let { shortCircuited: shortCircuited, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionData, pendingError);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $0f13e53339adf17f$var$_extends({
            matches: matches
        }, pendingActionData ? {
            actionData: pendingActionData
        } : {}, {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $0f13e53339adf17f$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        // Call our action and get the result
        let result;
        let actionMatch = $0f13e53339adf17f$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $0f13e53339adf17f$var$ResultType.error,
            error: $0f13e53339adf17f$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            result = await $0f13e53339adf17f$var$callLoaderOrAction("action", request, actionMatch, matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath);
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($0f13e53339adf17f$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else // If the user didn't explicity indicate replace behavior, replace if
            // we redirected to the exact same location we're currently at to avoid
            // double back-buttons
            replace = result.location === state.location.pathname + state.location.search;
            await startRedirectNavigation(state, result, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($0f13e53339adf17f$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $0f13e53339adf17f$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions are REPLACE navigations, but if the
            // action threw an error that'll be rendered in an errorElement, we fall
            // back to PUSH so that the user can use the back button to get back to
            // the pre-submission form location to try again
            if ((opts && opts.replace) !== true) pendingAction = $0f13e53339adf17f$export$e19cd5f9376f8cee.Push;
            return {
                // Send back an empty object we can use to clear out any prior actionData
                pendingActionData: {},
                pendingActionError: {
                    [boundaryMatch.route.id]: result.error
                }
            };
        }
        if ($0f13e53339adf17f$var$isDeferredResult(result)) throw $0f13e53339adf17f$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        return {
            pendingActionData: {
                [actionMatch.route.id]: result.data
            }
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionData, pendingError) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $0f13e53339adf17f$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $0f13e53339adf17f$var$getSubmissionFromNavigation(loadingNavigation);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $0f13e53339adf17f$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionData, pendingError);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $0f13e53339adf17f$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingError || null
            }, pendingActionData ? {
                actionData: pendingActionData
            } : {}, updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        // If we have partialHydration enabled, then don't update the state for the
        // initial data load since it's not a "navigation"
        if (!isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration)) {
            revalidatingFetchers.forEach((rf)=>{
                let fetcher = state.fetchers.get(rf.key);
                let revalidatingFetcher = $0f13e53339adf17f$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
                state.fetchers.set(rf.key, revalidatingFetcher);
            });
            let actionData = pendingActionData || state.actionData;
            updateState($0f13e53339adf17f$var$_extends({
                navigation: loadingNavigation
            }, actionData ? Object.keys(actionData).length === 0 ? {
                actionData: null
            } : {
                actionData: actionData
            } : {}, revalidatingFetchers.length > 0 ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            if (fetchControllers.has(rf.key)) abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { results: results, loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $0f13e53339adf17f$var$findRedirect(results);
        if (redirect) {
            if (redirect.idx >= matchesToLoad.length) {
                // If this redirect came from a fetcher make sure we mark it in
                // fetchRedirectIds so it doesn't get revalidated on the next set of
                // loader executions
                let fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                fetchRedirectIds.add(fetcherKey);
            }
            await startRedirectNavigation(state, redirect.result, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $0f13e53339adf17f$var$processLoaderData(state, matches, matchesToLoad, loaderResults, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        // During partial hydration, preserve SSR errors for routes that don't re-run
        if (future.v7_partialHydration && initialHydration && state.errors) Object.entries(state.errors).filter((_ref2)=>{
            let [id] = _ref2;
            return !matchesToLoad.some((m)=>m.route.id === id);
        }).forEach((_ref3)=>{
            let [routeId, error] = _ref3;
            errors = Object.assign(errors || {}, {
                [routeId]: error
            });
        });
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $0f13e53339adf17f$var$_extends({
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        if (fetchControllers.has(key)) abortFetcher(key);
        let flushSync = (opts && opts.unstable_flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $0f13e53339adf17f$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        let matches = $0f13e53339adf17f$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        if (!matches) {
            setFetcherError(key, routeId, $0f13e53339adf17f$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $0f13e53339adf17f$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let match = $0f13e53339adf17f$var$getTargetMatch(matches, path);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $0f13e53339adf17f$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, flushSync, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, flushSync, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, flushSync, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        if (!match.route.action && !match.route.lazy) {
            let error = $0f13e53339adf17f$var$getInternalRouterError(405, {
                method: submission.formMethod,
                pathname: path,
                routeId: routeId
            });
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $0f13e53339adf17f$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        // Call the action for the fetcher
        let abortController = new AbortController();
        let fetchRequest = $0f13e53339adf17f$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResult = await $0f13e53339adf17f$var$callLoaderOrAction("action", fetchRequest, match, requestMatches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath);
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
        // or redirects processed for unmounted fetchers so we just revert them to
        // idle
        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
            if ($0f13e53339adf17f$var$isRedirectResult(actionResult) || $0f13e53339adf17f$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $0f13e53339adf17f$var$getDoneFetcher(undefined));
                return;
            }
        } else {
            if ($0f13e53339adf17f$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    // A new navigation was kicked off after our action started, so that
                    // should take precedence over this redirect navigation.  We already
                    // set isRevalidationRequired so all loaders for the new route should
                    // fire unless opted out via shouldRevalidate
                    updateFetcherState(key, $0f13e53339adf17f$var$getDoneFetcher(undefined));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $0f13e53339adf17f$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(state, actionResult, {
                        fetcherSubmission: submission
                    });
                }
            }
            // Process any non-redirect errors thrown
            if ($0f13e53339adf17f$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        if ($0f13e53339adf17f$var$isDeferredResult(actionResult)) throw $0f13e53339adf17f$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $0f13e53339adf17f$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $0f13e53339adf17f$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $0f13e53339adf17f$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $0f13e53339adf17f$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $0f13e53339adf17f$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, {
            [match.route.id]: actionResult.data
        }, undefined // No need to send through errors since we short circuit above
        );
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $0f13e53339adf17f$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            if (fetchControllers.has(staleKey)) abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { results: results, loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $0f13e53339adf17f$var$findRedirect(results);
        if (redirect) {
            if (redirect.idx >= matchesToLoad.length) {
                // If this redirect came from a fetcher make sure we mark it in
                // fetchRedirectIds so it doesn't get revalidated on the next set of
                // loader executions
                let fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                fetchRedirectIds.add(fetcherKey);
            }
            return startRedirectNavigation(state, redirect.result);
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $0f13e53339adf17f$var$processLoaderData(state, state.matches, matchesToLoad, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $0f13e53339adf17f$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $0f13e53339adf17f$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState({
                errors: errors,
                loaderData: $0f13e53339adf17f$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, flushSync, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $0f13e53339adf17f$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
            flushSync: flushSync
        });
        // Call the loader for this fetcher route match
        let abortController = new AbortController();
        let fetchRequest = $0f13e53339adf17f$var$createClientSideRequest(init.history, path, abortController.signal);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let result = await $0f13e53339adf17f$var$callLoaderOrAction("loader", fetchRequest, match, matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath);
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($0f13e53339adf17f$var$isDeferredResult(result)) result = await $0f13e53339adf17f$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // We don't want errors bubbling up or redirects followed for unmounted
        // fetchers, so short circuit here if it was removed from the UI
        if (deletedFetchers.has(key)) {
            updateFetcherState(key, $0f13e53339adf17f$var$getDoneFetcher(undefined));
            return;
        }
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($0f13e53339adf17f$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                updateFetcherState(key, $0f13e53339adf17f$var$getDoneFetcher(undefined));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(state, result);
                return;
            }
        }
        // Process any non-redirect errors thrown
        if ($0f13e53339adf17f$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        $0f13e53339adf17f$export$3e9cee6b33872309(!$0f13e53339adf17f$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        updateFetcherState(key, $0f13e53339adf17f$var$getDoneFetcher(result.data));
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(state, redirect, _temp2) {
        let { submission: submission, fetcherSubmission: fetcherSubmission, replace: replace } = _temp2 === void 0 ? {} : _temp2;
        if (redirect.revalidate) isRevalidationRequired = true;
        let redirectLocation = $0f13e53339adf17f$var$createLocation(state.location, redirect.location, {
            _isRedirect: true
        });
        $0f13e53339adf17f$export$3e9cee6b33872309(redirectLocation, "Expected a location on the redirect navigation");
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.reloadDocument) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if ($0f13e53339adf17f$var$ABSOLUTE_URL_REGEX.test(redirect.location)) {
                const url = init.history.createURL(redirect.location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $0f13e53339adf17f$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(redirect.location);
                else routerWindow.location.assign(redirect.location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true ? $0f13e53339adf17f$export$e19cd5f9376f8cee.Replace : $0f13e53339adf17f$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $0f13e53339adf17f$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if ($0f13e53339adf17f$var$redirectPreserveMethodStatusCodes.has(redirect.status) && activeSubmission && $0f13e53339adf17f$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $0f13e53339adf17f$var$_extends({}, activeSubmission, {
                formAction: redirect.location
            }),
            // Preserve this flag across redirects
            preventScrollReset: pendingPreventScrollReset
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = $0f13e53339adf17f$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve this flag across redirects
                preventScrollReset: pendingPreventScrollReset
            });
        }
    }
    async function callLoadersAndMaybeResolveData(currentMatches, matches, matchesToLoad, fetchersToLoad, request) {
        // Call all navigation loaders and revalidating fetcher loaders in parallel,
        // then slice off the results into separate arrays so we can handle them
        // accordingly
        let results = await Promise.all([
            ...matchesToLoad.map((match)=>$0f13e53339adf17f$var$callLoaderOrAction("loader", request, match, matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath)),
            ...fetchersToLoad.map((f)=>{
                if (f.matches && f.match && f.controller) return $0f13e53339adf17f$var$callLoaderOrAction("loader", $0f13e53339adf17f$var$createClientSideRequest(init.history, f.path, f.controller.signal), f.match, f.matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath);
                else {
                    let error = {
                        type: $0f13e53339adf17f$var$ResultType.error,
                        error: $0f13e53339adf17f$var$getInternalRouterError(404, {
                            pathname: f.path
                        })
                    };
                    return error;
                }
            })
        ]);
        let loaderResults = results.slice(0, matchesToLoad.length);
        let fetcherResults = results.slice(matchesToLoad.length);
        await Promise.all([
            $0f13e53339adf17f$var$resolveDeferredResults(currentMatches, matchesToLoad, loaderResults, loaderResults.map(()=>request.signal), false, state.loaderData),
            $0f13e53339adf17f$var$resolveDeferredResults(currentMatches, fetchersToLoad.map((f)=>f.match), fetcherResults, fetchersToLoad.map((f)=>f.controller ? f.controller.signal : null), true)
        ]);
        return {
            results: results,
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) {
                cancelledFetcherLoads.push(key);
                abortFetcher(key);
            }
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        let boundaryMatch = $0f13e53339adf17f$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        if (future.v7_fetcherPersist) {
            activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
            // If this fetcher was previously marked for deletion, unmark it since we
            // have a new instance
            if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        }
        return state.fetchers.get(key) || $0f13e53339adf17f$export$52eace9c284d3585;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        deletedFetchers.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        if (future.v7_fetcherPersist) {
            let count = (activeFetchers.get(key) || 0) - 1;
            if (count <= 0) {
                activeFetchers.delete(key);
                deletedFetchers.add(key);
            } else activeFetchers.set(key, count);
        } else deleteFetcher(key);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        $0f13e53339adf17f$export$3e9cee6b33872309(controller, "Expected fetch controller: " + key);
        controller.abort();
        fetchControllers.delete(key);
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $0f13e53339adf17f$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $0f13e53339adf17f$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $0f13e53339adf17f$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $0f13e53339adf17f$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $0f13e53339adf17f$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $0f13e53339adf17f$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref4) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref4;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $0f13e53339adf17f$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $0f13e53339adf17f$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$0f13e53339adf17f$export$b3fac024fad9e8ff(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $0f13e53339adf17f$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $0f13e53339adf17f$export$4d0306f8f6a4585b = Symbol("deferred");
function $0f13e53339adf17f$export$3336b097a6fbc59a(routes, opts) {
    $0f13e53339adf17f$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $0f13e53339adf17f$var$defaultMapRouteProperties;
    // Config driven behavior flags
    let future = $0f13e53339adf17f$var$_extends({
        v7_relativeSplatPath: false,
        v7_throwAbortReason: false
    }, opts ? opts.future : null);
    let dataRoutes = $0f13e53339adf17f$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   */ async function query(request, _temp3) {
        let { requestContext: requestContext } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $0f13e53339adf17f$var$createLocation("", $0f13e53339adf17f$export$fe53371bee54353d(url), null, "default");
        let matches = $0f13e53339adf17f$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$0f13e53339adf17f$var$isValidMethod(method) && method !== "HEAD") {
            let error = $0f13e53339adf17f$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $0f13e53339adf17f$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $0f13e53339adf17f$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $0f13e53339adf17f$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext);
        if ($0f13e53339adf17f$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $0f13e53339adf17f$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   */ async function queryRoute(request, _temp4) {
        let { routeId: routeId, requestContext: requestContext } = _temp4 === void 0 ? {} : _temp4;
        let url = new URL(request.url);
        let method = request.method;
        let location = $0f13e53339adf17f$var$createLocation("", $0f13e53339adf17f$export$fe53371bee54353d(url), null, "default");
        let matches = $0f13e53339adf17f$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$0f13e53339adf17f$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $0f13e53339adf17f$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $0f13e53339adf17f$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $0f13e53339adf17f$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $0f13e53339adf17f$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $0f13e53339adf17f$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, match);
        if ($0f13e53339adf17f$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$0f13e53339adf17f$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, routeMatch) {
        $0f13e53339adf17f$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($0f13e53339adf17f$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $0f13e53339adf17f$var$getTargetMatch(matches, location), requestContext, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, routeMatch);
            return $0f13e53339adf17f$var$isResponse(result) ? result : $0f13e53339adf17f$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction, we throw
            // it to bail out and then return or throw here based on whether the user
            // returned or threw
            if ($0f13e53339adf17f$var$isQueryRouteResponse(e)) {
                if (e.type === $0f13e53339adf17f$var$ResultType.error) throw e.response;
                return e.response;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($0f13e53339adf17f$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $0f13e53339adf17f$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $0f13e53339adf17f$var$ResultType.error,
                error: error
            };
        } else {
            result = await $0f13e53339adf17f$var$callLoaderOrAction("action", request, actionMatch, matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath, {
                isStaticRequest: true,
                isRouteRequest: isRouteRequest,
                requestContext: requestContext
            });
            if (request.signal.aborted) $0f13e53339adf17f$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        }
        if ($0f13e53339adf17f$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.status,
            headers: {
                Location: result.location
            }
        });
        if ($0f13e53339adf17f$var$isDeferredResult(result)) {
            let error = $0f13e53339adf17f$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $0f13e53339adf17f$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($0f13e53339adf17f$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        if ($0f13e53339adf17f$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $0f13e53339adf17f$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(request, matches, requestContext, undefined, {
                [boundaryMatch.route.id]: result.error
            });
            // action status codes take precedence over loader status codes
            return $0f13e53339adf17f$var$_extends({}, context, {
                statusCode: $0f13e53339adf17f$export$972111febbeef05b(result.error) ? result.error.status : 500,
                actionData: null,
                actionHeaders: $0f13e53339adf17f$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        let context = await loadRouteData(loaderRequest, matches, requestContext);
        return $0f13e53339adf17f$var$_extends({}, context, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionData: {
                [actionMatch.route.id]: result.data
            },
            actionHeaders: $0f13e53339adf17f$var$_extends({}, result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {})
        });
    }
    async function loadRouteData(request, matches, requestContext, routeMatch, pendingActionError) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $0f13e53339adf17f$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : $0f13e53339adf17f$var$getLoaderMatchesUntilBoundary(matches, Object.keys(pendingActionError || {})[0]);
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionError || null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await Promise.all([
            ...matchesToLoad.map((match)=>$0f13e53339adf17f$var$callLoaderOrAction("loader", request, match, matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath, {
                    isStaticRequest: true,
                    isRouteRequest: isRouteRequest,
                    requestContext: requestContext
                }))
        ]);
        if (request.signal.aborted) $0f13e53339adf17f$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $0f13e53339adf17f$var$processRouteLoaderData(matches, matchesToLoad, results, pendingActionError, activeDeferreds);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $0f13e53339adf17f$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $0f13e53339adf17f$export$fec11da027c70692(routes, context, error) {
    let newContext = $0f13e53339adf17f$var$_extends({}, context, {
        statusCode: $0f13e53339adf17f$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $0f13e53339adf17f$var$throwStaticHandlerAbortedError(request, isRouteRequest, future) {
    if (future.v7_throwAbortReason && request.signal.reason !== undefined) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(method + "() call aborted: " + request.method + " " + request.url);
}
function $0f13e53339adf17f$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $0f13e53339adf17f$var$normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $0f13e53339adf17f$export$cae722b0cc860f13(to ? to : ".", $0f13e53339adf17f$export$a5784978eca585fa(contextualMatches, v7_relativeSplatPath), $0f13e53339adf17f$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Add an ?index param for matched index routes if we don't already have one
    if ((to == null || to === "" || to === ".") && activeRouteMatch && activeRouteMatch.route.index && !$0f13e53339adf17f$var$hasNakedIndexQuery(path.search)) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $0f13e53339adf17f$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $0f13e53339adf17f$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $0f13e53339adf17f$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$0f13e53339adf17f$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$0f13e53339adf17f$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $0f13e53339adf17f$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $0f13e53339adf17f$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $0f13e53339adf17f$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$0f13e53339adf17f$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref5)=>{
                let [name, value] = _ref5;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$0f13e53339adf17f$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $0f13e53339adf17f$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $0f13e53339adf17f$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $0f13e53339adf17f$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $0f13e53339adf17f$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $0f13e53339adf17f$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($0f13e53339adf17f$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $0f13e53339adf17f$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $0f13e53339adf17f$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $0f13e53339adf17f$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes below any caught error as they aren't going to
// render so we don't need to load them
function $0f13e53339adf17f$var$getLoaderMatchesUntilBoundary(matches, boundaryId) {
    let boundaryMatches = matches;
    if (boundaryId) {
        let index = matches.findIndex((m)=>m.route.id === boundaryId);
        if (index >= 0) boundaryMatches = matches.slice(0, index);
    }
    return boundaryMatches;
}
function $0f13e53339adf17f$var$getMatchesToLoad(history, state, matches, submission, location, isInitialLoad, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionData, pendingError) {
    let actionResult = pendingError ? Object.values(pendingError)[0] : pendingActionData ? Object.values(pendingActionData)[0] : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryId = pendingError ? Object.keys(pendingError)[0] : undefined;
    let boundaryMatches = $0f13e53339adf17f$var$getLoaderMatchesUntilBoundary(matches, boundaryId);
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        let { route: route } = match;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (isInitialLoad) {
            if (route.loader.hydrate) return true;
            return state.loaderData[route.id] === undefined && // Don't re-run if the loader ran and threw an error
            (!state.errors || state.errors[route.id] === undefined);
        }
        // Always call the loader on new route instances and pending defer cancellations
        if ($0f13e53339adf17f$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $0f13e53339adf17f$var$shouldRevalidateLoader(match, $0f13e53339adf17f$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            defaultShouldRevalidate: // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || // Clicked the same link, resubmitted a GET form
            currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $0f13e53339adf17f$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate:
        //  - on initial load (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (isInitialLoad || !matches.some((m)=>m.route.id === f.routeId) || deletedFetchers.has(key)) return;
        let fetcherMatches = $0f13e53339adf17f$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $0f13e53339adf17f$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.includes(key)) // Always revalidate if the fetcher was cancelled
        shouldRevalidate = true;
        else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $0f13e53339adf17f$var$shouldRevalidateLoader(fetcherMatch, $0f13e53339adf17f$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            defaultShouldRevalidate: isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $0f13e53339adf17f$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $0f13e53339adf17f$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $0f13e53339adf17f$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $0f13e53339adf17f$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $0f13e53339adf17f$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $0f13e53339adf17f$export$c0e02632e14916fd(!isPropertyStaticallyDefined, 'Route "' + routeToUpdate.id + '" has a static property "' + lazyRouteProperty + '" ' + "defined but its lazy function is also returning a value for this property. " + ('The lazy route property "' + lazyRouteProperty + '" will be ignored.'));
        if (!isPropertyStaticallyDefined && !$0f13e53339adf17f$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $0f13e53339adf17f$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
async function $0f13e53339adf17f$var$callLoaderOrAction(type, request, match, matches, manifest, mapRouteProperties, basename, v7_relativeSplatPath, opts) {
    if (opts === void 0) opts = {};
    let resultType;
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        return Promise.race([
            handler({
                request: request,
                params: match.params,
                context: opts.requestContext
            }),
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        if (match.route.lazy) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let values = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    $0f13e53339adf17f$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest)
                ]);
                if (handlerError) throw handlerError;
                result = values[0];
            } else {
                // Load lazy route module, then run any returned handler
                await $0f13e53339adf17f$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest);
                handler = match.route[type];
                if (handler) // Handler still run even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $0f13e53339adf17f$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $0f13e53339adf17f$var$ResultType.data,
                    data: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $0f13e53339adf17f$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $0f13e53339adf17f$export$3e9cee6b33872309(result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ('"' + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        resultType = $0f13e53339adf17f$var$ResultType.error;
        result = e;
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    if ($0f13e53339adf17f$var$isResponse(result)) {
        let status = result.status;
        // Process redirects
        if ($0f13e53339adf17f$var$redirectStatusCodes.has(status)) {
            let location = result.headers.get("Location");
            $0f13e53339adf17f$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
            // Support relative routing in internal redirects
            if (!$0f13e53339adf17f$var$ABSOLUTE_URL_REGEX.test(location)) location = $0f13e53339adf17f$var$normalizeTo(new URL(request.url), matches.slice(0, matches.indexOf(match) + 1), basename, true, location, v7_relativeSplatPath);
            else if (!opts.isStaticRequest) {
                // Strip off the protocol+origin for same-origin + same-basename absolute
                // redirects. If this is a static request, we can let it go back to the
                // browser as-is
                let currentUrl = new URL(request.url);
                let url = location.startsWith("//") ? new URL(currentUrl.protocol + location) : new URL(location);
                let isSameBasename = $0f13e53339adf17f$export$b69e3301ce081aa3(url.pathname, basename) != null;
                if (url.origin === currentUrl.origin && isSameBasename) location = url.pathname + url.search + url.hash;
            }
            // Don't process redirects in the router during static requests requests.
            // Instead, throw the Response and let the server handle it with an HTTP
            // redirect.  We also update the Location header in place in this flow so
            // basename and relative routing is taken into account
            if (opts.isStaticRequest) {
                result.headers.set("Location", location);
                throw result;
            }
            return {
                type: $0f13e53339adf17f$var$ResultType.redirect,
                status: status,
                location: location,
                revalidate: result.headers.get("X-Remix-Revalidate") !== null,
                reloadDocument: result.headers.get("X-Remix-Reload-Document") !== null
            };
        }
        // For SSR single-route requests, we want to hand Responses back directly
        // without unwrapping.  We do this with the QueryRouteResponse wrapper
        // interface so we can know whether it was returned or thrown
        if (opts.isRouteRequest) {
            let queryRouteResponse = {
                type: resultType === $0f13e53339adf17f$var$ResultType.error ? $0f13e53339adf17f$var$ResultType.error : $0f13e53339adf17f$var$ResultType.data,
                response: result
            };
            throw queryRouteResponse;
        }
        let data;
        try {
            let contentType = result.headers.get("Content-Type");
            // Check between word boundaries instead of startsWith() due to the last
            // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
            if (contentType && /\bapplication\/json\b/.test(contentType)) {
                if (result.body == null) data = null;
                else data = await result.json();
            } else data = await result.text();
        } catch (e) {
            return {
                type: $0f13e53339adf17f$var$ResultType.error,
                error: e
            };
        }
        if (resultType === $0f13e53339adf17f$var$ResultType.error) return {
            type: resultType,
            error: new $0f13e53339adf17f$export$6c6580e81da25755(status, result.statusText, data),
            headers: result.headers
        };
        return {
            type: $0f13e53339adf17f$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (resultType === $0f13e53339adf17f$var$ResultType.error) return {
        type: resultType,
        error: result
    };
    if ($0f13e53339adf17f$export$fbcedacb60443473(result)) {
        var _result$init, _result$init2;
        return {
            type: $0f13e53339adf17f$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
            headers: ((_result$init2 = result.init) == null ? void 0 : _result$init2.headers) && new Headers(result.init.headers)
        };
    }
    return {
        type: $0f13e53339adf17f$var$ResultType.data,
        data: result
    };
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $0f13e53339adf17f$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($0f13e53339adf17f$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $0f13e53339adf17f$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $0f13e53339adf17f$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $0f13e53339adf17f$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $0f13e53339adf17f$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $0f13e53339adf17f$var$processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    // Process loader results into state.loaderData/state.errors
    results.forEach((result, index)=>{
        let id = matchesToLoad[index].route.id;
        $0f13e53339adf17f$export$3e9cee6b33872309(!$0f13e53339adf17f$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($0f13e53339adf17f$var$isErrorResult(result)) {
            // Look upwards from the matched route for the closest ancestor
            // error boundary, defaulting to the root match
            let boundaryMatch = $0f13e53339adf17f$var$findNearestBoundary(matches, id);
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError) {
                error = Object.values(pendingError)[0];
                pendingError = undefined;
            }
            errors = errors || {};
            // Prefer higher error values if lower errors bubble to the same boundary
            if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $0f13e53339adf17f$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            if ($0f13e53339adf17f$var$isDeferredResult(result)) {
                activeDeferreds.set(id, result.deferredData);
                loaderData[id] = result.deferredData.data;
            } else loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError) {
        errors = pendingError;
        loaderData[Object.keys(pendingError)[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $0f13e53339adf17f$var$processLoaderData(state, matches, matchesToLoad, results, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $0f13e53339adf17f$var$processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds);
    // Process results from our revalidating fetchers
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, match: match, controller: controller } = revalidatingFetchers[index];
        $0f13e53339adf17f$export$3e9cee6b33872309(fetcherResults !== undefined && fetcherResults[index] !== undefined, "Did not find corresponding fetcher result");
        let result = fetcherResults[index];
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) continue;
        else if ($0f13e53339adf17f$var$isErrorResult(result)) {
            let boundaryMatch = $0f13e53339adf17f$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $0f13e53339adf17f$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($0f13e53339adf17f$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $0f13e53339adf17f$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($0f13e53339adf17f$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $0f13e53339adf17f$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $0f13e53339adf17f$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $0f13e53339adf17f$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $0f13e53339adf17f$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $0f13e53339adf17f$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $0f13e53339adf17f$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $0f13e53339adf17f$var$getInternalRouterError(status, _temp5) {
    let { pathname: pathname, routeId: routeId, method: method, type: type } = _temp5 === void 0 ? {} : _temp5;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + ' request to "' + pathname + '" but ' + ('did not provide a `loader` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = 'Route "' + routeId + '" does not match URL "' + pathname + '"';
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = 'No route matches URL "' + pathname + '"';
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + ' request to "' + pathname + '" but ' + ('did not provide an `action` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (method) errorMessage = 'Invalid request method "' + method.toUpperCase() + '"';
    }
    return new $0f13e53339adf17f$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $0f13e53339adf17f$var$findRedirect(results) {
    for(let i = results.length - 1; i >= 0; i--){
        let result = results[i];
        if ($0f13e53339adf17f$var$isRedirectResult(result)) return {
            result: result,
            idx: i
        };
    }
}
function $0f13e53339adf17f$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $0f13e53339adf17f$export$8ccf933b0513f8d0(path) : path;
    return $0f13e53339adf17f$export$fe53371bee54353d($0f13e53339adf17f$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $0f13e53339adf17f$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $0f13e53339adf17f$var$isDeferredResult(result) {
    return result.type === $0f13e53339adf17f$var$ResultType.deferred;
}
function $0f13e53339adf17f$var$isErrorResult(result) {
    return result.type === $0f13e53339adf17f$var$ResultType.error;
}
function $0f13e53339adf17f$var$isRedirectResult(result) {
    return (result && result.type) === $0f13e53339adf17f$var$ResultType.redirect;
}
function $0f13e53339adf17f$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $0f13e53339adf17f$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $0f13e53339adf17f$var$isRedirectResponse(result) {
    if (!$0f13e53339adf17f$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $0f13e53339adf17f$var$isQueryRouteResponse(obj) {
    return obj && $0f13e53339adf17f$var$isResponse(obj.response) && (obj.type === $0f13e53339adf17f$var$ResultType.data || obj.type === $0f13e53339adf17f$var$ResultType.error);
}
function $0f13e53339adf17f$var$isValidMethod(method) {
    return $0f13e53339adf17f$var$validRequestMethods.has(method.toLowerCase());
}
function $0f13e53339adf17f$var$isMutationMethod(method) {
    return $0f13e53339adf17f$var$validMutationMethods.has(method.toLowerCase());
}
async function $0f13e53339adf17f$var$resolveDeferredResults(currentMatches, matchesToLoad, results, signals, isFetcher, currentLoaderData) {
    for(let index = 0; index < results.length; index++){
        let result = results[index];
        let match = matchesToLoad[index];
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$0f13e53339adf17f$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($0f13e53339adf17f$var$isDeferredResult(result) && (isFetcher || isRevalidatingLoader)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            let signal = signals[index];
            $0f13e53339adf17f$export$3e9cee6b33872309(signal, "Expected an AbortSignal for revalidating fetcher deferred result");
            await $0f13e53339adf17f$var$resolveDeferredData(result, signal, isFetcher).then((result)=>{
                if (result) results[index] = result || results[index];
            });
        }
    }
}
async function $0f13e53339adf17f$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $0f13e53339adf17f$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $0f13e53339adf17f$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $0f13e53339adf17f$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $0f13e53339adf17f$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $0f13e53339adf17f$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $0f13e53339adf17f$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $0f13e53339adf17f$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $0f13e53339adf17f$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $0f13e53339adf17f$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $0f13e53339adf17f$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $0f13e53339adf17f$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $0f13e53339adf17f$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher;
    }
}
function $0f13e53339adf17f$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $0f13e53339adf17f$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function $0f13e53339adf17f$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($0f13e53339adf17f$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function $0f13e53339adf17f$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($0f13e53339adf17f$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $0f13e53339adf17f$export$c0e02632e14916fd(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}

});

parcelRegister("18Pjr", function(module, exports) {

$parcel$export(module.exports, "UNSAFE_DataRouterContext", function () { return $0d4e57672a3dc010$export$3add0d5dce533e2e; });
$parcel$export(module.exports, "UNSAFE_DataRouterStateContext", function () { return $0d4e57672a3dc010$export$145dfa71566a64dc; });
$parcel$export(module.exports, "UNSAFE_NavigationContext", function () { return $0d4e57672a3dc010$export$26749e8557646306; });
$parcel$export(module.exports, "UNSAFE_RouteContext", function () { return $0d4e57672a3dc010$export$9072aa6dd1f93057; });
$parcel$export(module.exports, "useHref", function () { return $0d4e57672a3dc010$export$b66bb29c5006f12f; });
$parcel$export(module.exports, "useResolvedPath", function () { return $0d4e57672a3dc010$export$e75d2a2d1b3c245b; });
$parcel$export(module.exports, "useLocation", function () { return $0d4e57672a3dc010$export$45d76561a5302f2b; });
$parcel$export(module.exports, "useNavigate", function () { return $0d4e57672a3dc010$export$9770f232ac06a008; });
$parcel$export(module.exports, "useParams", function () { return $0d4e57672a3dc010$export$99eaa27ddbbb95ef; });
$parcel$export(module.exports, "UNSAFE_useRoutesImpl", function () { return $0d4e57672a3dc010$export$5fcee62552a12fbf; });
$parcel$export(module.exports, "UNSAFE_useRouteId", function () { return $0d4e57672a3dc010$export$5fc8298006ad9e58; });
$parcel$export(module.exports, "useNavigation", function () { return $0d4e57672a3dc010$export$d0fd4b7106de2769; });
$parcel$export(module.exports, "useMatches", function () { return $0d4e57672a3dc010$export$2378eb7f5ff86053; });
$parcel$export(module.exports, "useBlocker", function () { return $0d4e57672a3dc010$export$b273b3273281a049; });
$parcel$export(module.exports, "Router", function () { return $0d4e57672a3dc010$export$55185c17a0fcbe46; });
$parcel$export(module.exports, "Outlet", function () { return $0d4e57672a3dc010$export$910ae8079b2c2852; });
$parcel$export(module.exports, "Route", function () { return $0d4e57672a3dc010$export$e7b0ac011bb776c6; });
$parcel$export(module.exports, "Routes", function () { return $0d4e57672a3dc010$export$3565eb3d00ca5a74; });
$parcel$export(module.exports, "UNSAFE_mapRouteProperties", function () { return $0d4e57672a3dc010$export$52b333d321859367; });
/**
 * React Router v6.22.3
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $eeH7J = parcelRequire("eeH7J");

var $1ig10 = parcelRequire("1ig10");
function $0d4e57672a3dc010$var$_extends() {
    $0d4e57672a3dc010$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $0d4e57672a3dc010$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $0d4e57672a3dc010$export$3add0d5dce533e2e = /*#__PURE__*/ $eeH7J.createContext(null);
const $0d4e57672a3dc010$export$145dfa71566a64dc = /*#__PURE__*/ $eeH7J.createContext(null);
const $0d4e57672a3dc010$var$AwaitContext = /*#__PURE__*/ $eeH7J.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $0d4e57672a3dc010$export$26749e8557646306 = /*#__PURE__*/ $eeH7J.createContext(null);
const $0d4e57672a3dc010$export$c7914228fb69b0f5 = /*#__PURE__*/ $eeH7J.createContext(null);
const $0d4e57672a3dc010$export$9072aa6dd1f93057 = /*#__PURE__*/ $eeH7J.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const $0d4e57672a3dc010$var$RouteErrorContext = /*#__PURE__*/ $eeH7J.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/hooks/use-href
 */ function $0d4e57672a3dc010$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$0d4e57672a3dc010$export$9c954a9d03d32f4a() && (0, $1ig10.UNSAFE_invariant)(false);
    let { basename: basename, navigator: navigator } = $eeH7J.useContext($0d4e57672a3dc010$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $0d4e57672a3dc010$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $1ig10.joinPaths)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/hooks/use-in-router-context
 */ function $0d4e57672a3dc010$export$9c954a9d03d32f4a() {
    return $eeH7J.useContext($0d4e57672a3dc010$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/hooks/use-location
 */ function $0d4e57672a3dc010$export$45d76561a5302f2b() {
    !$0d4e57672a3dc010$export$9c954a9d03d32f4a() && (0, $1ig10.UNSAFE_invariant)(false);
    return $eeH7J.useContext($0d4e57672a3dc010$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/hooks/use-navigation-type
 */ function $0d4e57672a3dc010$export$1b3f31771c5d07c() {
    return $eeH7J.useContext($0d4e57672a3dc010$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/hooks/use-match
 */ function $0d4e57672a3dc010$export$6c330e8992e8a295(pattern) {
    !$0d4e57672a3dc010$export$9c954a9d03d32f4a() && (0, $1ig10.UNSAFE_invariant)(false);
    let { pathname: pathname } = $0d4e57672a3dc010$export$45d76561a5302f2b();
    return $eeH7J.useMemo(()=>(0, $1ig10.matchPath)(pattern, pathname), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $0d4e57672a3dc010$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $0d4e57672a3dc010$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $eeH7J.useContext($0d4e57672a3dc010$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $eeH7J.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/hooks/use-navigate
 */ function $0d4e57672a3dc010$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $eeH7J.useContext($0d4e57672a3dc010$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $0d4e57672a3dc010$var$useNavigateStable() : $0d4e57672a3dc010$var$useNavigateUnstable();
}
function $0d4e57672a3dc010$var$useNavigateUnstable() {
    !$0d4e57672a3dc010$export$9c954a9d03d32f4a() && (0, $1ig10.UNSAFE_invariant)(false);
    let dataRouterContext = $eeH7J.useContext($0d4e57672a3dc010$export$3add0d5dce533e2e);
    let { basename: basename, future: future, navigator: navigator } = $eeH7J.useContext($0d4e57672a3dc010$export$26749e8557646306);
    let { matches: matches } = $eeH7J.useContext($0d4e57672a3dc010$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $0d4e57672a3dc010$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $1ig10.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath));
    let activeRef = $eeH7J.useRef(false);
    $0d4e57672a3dc010$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $eeH7J.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $1ig10.resolveTo)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $1ig10.joinPaths)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $0d4e57672a3dc010$var$OutletContext = /*#__PURE__*/ $eeH7J.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/hooks/use-outlet-context
 */ function $0d4e57672a3dc010$export$4138103a3ae699cc() {
    return $eeH7J.useContext($0d4e57672a3dc010$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/hooks/use-outlet
 */ function $0d4e57672a3dc010$export$a3be3530d8e40d0b(context) {
    let outlet = $eeH7J.useContext($0d4e57672a3dc010$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $eeH7J.createElement($0d4e57672a3dc010$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/hooks/use-params
 */ function $0d4e57672a3dc010$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $eeH7J.useContext($0d4e57672a3dc010$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/hooks/use-resolved-path
 */ function $0d4e57672a3dc010$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { future: future } = $eeH7J.useContext($0d4e57672a3dc010$export$26749e8557646306);
    let { matches: matches } = $eeH7J.useContext($0d4e57672a3dc010$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $0d4e57672a3dc010$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $1ig10.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath));
    return $eeH7J.useMemo(()=>(0, $1ig10.resolveTo)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/hooks/use-routes
 */ function $0d4e57672a3dc010$export$5d3fca4a98652595(routes, locationArg) {
    return $0d4e57672a3dc010$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $0d4e57672a3dc010$export$5fcee62552a12fbf(routes, locationArg, dataRouterState, future) {
    !$0d4e57672a3dc010$export$9c954a9d03d32f4a() && (0, $1ig10.UNSAFE_invariant)(false);
    let { navigator: navigator } = $eeH7J.useContext($0d4e57672a3dc010$export$26749e8557646306);
    let { matches: parentMatches } = $eeH7J.useContext($0d4e57672a3dc010$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $0d4e57672a3dc010$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $1ig10.parsePath)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $1ig10.UNSAFE_invariant)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        // Determine the remaining pathname by removing the # of URL segments the
        // parentPathnameBase has, instead of removing based on character count.
        // This is because we can't guarantee that incoming/outgoing encodings/
        // decodings will match exactly.
        // We decode paths before matching on a per-segment basis with
        // decodeURIComponent(), but we re-encode pathnames via `new URL()` so they
        // match what `window.location.pathname` would reflect.  Those don't 100%
        // align when it comes to encoded URI characters such as % and &.
        //
        // So we may end up with:
        //   pathname:           "/descendant/a%25b/match"
        //   parentPathnameBase: "/descendant/a%b"
        //
        // And the direct substring removal approach won't work :/
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = (0, $1ig10.matchRoutes)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $0d4e57672a3dc010$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $1ig10.joinPaths)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $1ig10.joinPaths)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, future);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $eeH7J.createElement($0d4e57672a3dc010$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $0d4e57672a3dc010$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $1ig10.Action).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $0d4e57672a3dc010$var$DefaultErrorComponent() {
    let error = $0d4e57672a3dc010$export$ed527bf60f6e05f2();
    let message = (0, $1ig10.isRouteErrorResponse)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $eeH7J.createElement($eeH7J.Fragment, null, /*#__PURE__*/ $eeH7J.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $eeH7J.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $eeH7J.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $0d4e57672a3dc010$var$defaultErrorElement = /*#__PURE__*/ $eeH7J.createElement($0d4e57672a3dc010$var$DefaultErrorComponent, null);
class $0d4e57672a3dc010$var$RenderErrorBoundary extends $eeH7J.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error !== undefined ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error !== undefined ? /*#__PURE__*/ $eeH7J.createElement($0d4e57672a3dc010$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $eeH7J.createElement($0d4e57672a3dc010$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
}
function $0d4e57672a3dc010$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $eeH7J.useContext($0d4e57672a3dc010$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $eeH7J.createElement($0d4e57672a3dc010$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $0d4e57672a3dc010$var$_renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState2;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _dataRouterState;
        if ((_dataRouterState = dataRouterState) != null && _dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState2 = dataRouterState) == null ? void 0 : _dataRouterState2.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]));
        !(errorIndex >= 0) && (0, $1ig10.UNSAFE_invariant)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData: loaderData, errors: errors } = dataRouterState;
            let needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors || errors[match.route.id] === undefined);
            if (match.route.lazy || needsToRunLoader) {
                // We found the first route that's not ready to render (waiting on
                // lazy, or has a loader that hasn't run yet).  Flag that we need to
                // render a fallback and render up until the appropriate fallback
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        // Only data routers handle errors/fallbacks
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || $0d4e57672a3dc010$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $0d4e57672a3dc010$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $eeH7J.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $eeH7J.createElement($0d4e57672a3dc010$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $eeH7J.createElement($0d4e57672a3dc010$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $0d4e57672a3dc010$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($0d4e57672a3dc010$var$DataRouterHook || {});
var $0d4e57672a3dc010$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($0d4e57672a3dc010$var$DataRouterStateHook || {});
function $0d4e57672a3dc010$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $0d4e57672a3dc010$var$useDataRouterContext(hookName) {
    let ctx = $eeH7J.useContext($0d4e57672a3dc010$export$3add0d5dce533e2e);
    !ctx && (0, $1ig10.UNSAFE_invariant)(false);
    return ctx;
}
function $0d4e57672a3dc010$var$useDataRouterState(hookName) {
    let state = $eeH7J.useContext($0d4e57672a3dc010$export$145dfa71566a64dc);
    !state && (0, $1ig10.UNSAFE_invariant)(false);
    return state;
}
function $0d4e57672a3dc010$var$useRouteContext(hookName) {
    let route = $eeH7J.useContext($0d4e57672a3dc010$export$9072aa6dd1f93057);
    !route && (0, $1ig10.UNSAFE_invariant)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $0d4e57672a3dc010$var$useCurrentRouteId(hookName) {
    let route = $0d4e57672a3dc010$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $1ig10.UNSAFE_invariant)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $0d4e57672a3dc010$export$5fc8298006ad9e58() {
    return $0d4e57672a3dc010$var$useCurrentRouteId($0d4e57672a3dc010$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $0d4e57672a3dc010$export$d0fd4b7106de2769() {
    let state = $0d4e57672a3dc010$var$useDataRouterState($0d4e57672a3dc010$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $0d4e57672a3dc010$export$600dc272ed516c15() {
    let dataRouterContext = $0d4e57672a3dc010$var$useDataRouterContext($0d4e57672a3dc010$var$DataRouterHook.UseRevalidator);
    let state = $0d4e57672a3dc010$var$useDataRouterState($0d4e57672a3dc010$var$DataRouterStateHook.UseRevalidator);
    return $eeH7J.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $0d4e57672a3dc010$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $0d4e57672a3dc010$var$useDataRouterState($0d4e57672a3dc010$var$DataRouterStateHook.UseMatches);
    return $eeH7J.useMemo(()=>matches.map((m)=>(0, $1ig10.UNSAFE_convertRouteMatchToUiMatch)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $0d4e57672a3dc010$export$1448a5050d252c4d() {
    let state = $0d4e57672a3dc010$var$useDataRouterState($0d4e57672a3dc010$var$DataRouterStateHook.UseLoaderData);
    let routeId = $0d4e57672a3dc010$var$useCurrentRouteId($0d4e57672a3dc010$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $0d4e57672a3dc010$export$fd5d37484eab868d(routeId) {
    let state = $0d4e57672a3dc010$var$useDataRouterState($0d4e57672a3dc010$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $0d4e57672a3dc010$export$fdc00f3f26066d5e() {
    let state = $0d4e57672a3dc010$var$useDataRouterState($0d4e57672a3dc010$var$DataRouterStateHook.UseActionData);
    let routeId = $0d4e57672a3dc010$var$useCurrentRouteId($0d4e57672a3dc010$var$DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $0d4e57672a3dc010$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $eeH7J.useContext($0d4e57672a3dc010$var$RouteErrorContext);
    let state = $0d4e57672a3dc010$var$useDataRouterState($0d4e57672a3dc010$var$DataRouterStateHook.UseRouteError);
    let routeId = $0d4e57672a3dc010$var$useCurrentRouteId($0d4e57672a3dc010$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function $0d4e57672a3dc010$export$78a72ddb39bdd145() {
    let value = $eeH7J.useContext($0d4e57672a3dc010$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function $0d4e57672a3dc010$export$17f53340677d5831() {
    let value = $eeH7J.useContext($0d4e57672a3dc010$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $0d4e57672a3dc010$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $0d4e57672a3dc010$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $0d4e57672a3dc010$var$useDataRouterContext($0d4e57672a3dc010$var$DataRouterHook.UseBlocker);
    let state = $0d4e57672a3dc010$var$useDataRouterState($0d4e57672a3dc010$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $eeH7J.useState("");
    let blockerFunction = $eeH7J.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $0d4e57672a3dc010$var$_extends({}, currentLocation, {
                pathname: (0, $1ig10.stripBasename)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $0d4e57672a3dc010$var$_extends({}, nextLocation, {
                pathname: (0, $1ig10.stripBasename)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $eeH7J.useEffect(()=>{
        let key = String(++$0d4e57672a3dc010$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $eeH7J.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $1ig10.IDLE_BLOCKER);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $0d4e57672a3dc010$var$useNavigateStable() {
    let { router: router } = $0d4e57672a3dc010$var$useDataRouterContext($0d4e57672a3dc010$var$DataRouterHook.UseNavigateStable);
    let id = $0d4e57672a3dc010$var$useCurrentRouteId($0d4e57672a3dc010$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $eeH7J.useRef(false);
    $0d4e57672a3dc010$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $eeH7J.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $0d4e57672a3dc010$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $0d4e57672a3dc010$var$alreadyWarned = {};
function $0d4e57672a3dc010$var$warningOnce(key, cond, message) {
    if (!cond && !$0d4e57672a3dc010$var$alreadyWarned[key]) $0d4e57672a3dc010$var$alreadyWarned[key] = true;
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $0d4e57672a3dc010$var$START_TRANSITION = "startTransition";
const $0d4e57672a3dc010$var$startTransitionImpl = $eeH7J[$0d4e57672a3dc010$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $0d4e57672a3dc010$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $eeH7J.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $eeH7J.useCallback((newState)=>{
        if (v7_startTransition && $0d4e57672a3dc010$var$startTransitionImpl) $0d4e57672a3dc010$var$startTransitionImpl(()=>setStateImpl(newState));
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $eeH7J.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $eeH7J.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $eeH7J.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $eeH7J.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $eeH7J.createElement($eeH7J.Fragment, null, /*#__PURE__*/ $eeH7J.createElement($0d4e57672a3dc010$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $eeH7J.createElement($0d4e57672a3dc010$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $eeH7J.createElement($0d4e57672a3dc010$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $eeH7J.createElement($0d4e57672a3dc010$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
function $0d4e57672a3dc010$var$DataRoutes(_ref2) {
    let { routes: routes, future: future, state: state } = _ref2;
    return $0d4e57672a3dc010$export$5fcee62552a12fbf(routes, undefined, state, future);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/router-components/memory-router
 */ function $0d4e57672a3dc010$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $eeH7J.useRef();
    if (historyRef.current == null) historyRef.current = (0, $1ig10.createMemoryHistory)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $eeH7J.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $eeH7J.useCallback((newState)=>{
        v7_startTransition && $0d4e57672a3dc010$var$startTransitionImpl ? $0d4e57672a3dc010$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $eeH7J.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $eeH7J.createElement($0d4e57672a3dc010$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/components/navigate
 */ function $0d4e57672a3dc010$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$0d4e57672a3dc010$export$9c954a9d03d32f4a() && (0, $1ig10.UNSAFE_invariant)(false);
    let { future: future, static: isStatic } = $eeH7J.useContext($0d4e57672a3dc010$export$26749e8557646306);
    let { matches: matches } = $eeH7J.useContext($0d4e57672a3dc010$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $0d4e57672a3dc010$export$45d76561a5302f2b();
    let navigate = $0d4e57672a3dc010$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $1ig10.resolveTo)(to, (0, $1ig10.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $eeH7J.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/components/outlet
 */ function $0d4e57672a3dc010$export$910ae8079b2c2852(props) {
    return $0d4e57672a3dc010$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/components/route
 */ function $0d4e57672a3dc010$export$e7b0ac011bb776c6(_props) {
    (0, $1ig10.UNSAFE_invariant)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/router-components/router
 */ function $0d4e57672a3dc010$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $1ig10.Action).Pop, navigator: navigator, static: staticProp = false, future: future } = _ref5;
    !!$0d4e57672a3dc010$export$9c954a9d03d32f4a() && (0, $1ig10.UNSAFE_invariant)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $eeH7J.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            future: $0d4e57672a3dc010$var$_extends({
                v7_relativeSplatPath: false
            }, future)
        }), [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $1ig10.parsePath)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $eeH7J.useMemo(()=>{
        let trailingPathname = (0, $1ig10.stripBasename)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $eeH7J.createElement($0d4e57672a3dc010$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $eeH7J.createElement($0d4e57672a3dc010$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/components/routes
 */ function $0d4e57672a3dc010$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $0d4e57672a3dc010$export$5d3fca4a98652595($0d4e57672a3dc010$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $0d4e57672a3dc010$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $eeH7J.createElement($0d4e57672a3dc010$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $eeH7J.createElement($0d4e57672a3dc010$var$ResolveAwait, null, children));
}
var $0d4e57672a3dc010$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($0d4e57672a3dc010$var$AwaitRenderStatus || {});
const $0d4e57672a3dc010$var$neverSettledPromise = new Promise(()=>{});
class $0d4e57672a3dc010$var$AwaitErrorBoundary extends $eeH7J.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $0d4e57672a3dc010$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $0d4e57672a3dc010$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $0d4e57672a3dc010$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = promise._error !== undefined ? $0d4e57672a3dc010$var$AwaitRenderStatus.error : promise._data !== undefined ? $0d4e57672a3dc010$var$AwaitRenderStatus.success : $0d4e57672a3dc010$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $0d4e57672a3dc010$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $0d4e57672a3dc010$var$AwaitRenderStatus.error && promise._error instanceof (0, $1ig10.AbortedDeferredError)) // Freeze the UI by throwing a never resolved promise
        throw $0d4e57672a3dc010$var$neverSettledPromise;
        if (status === $0d4e57672a3dc010$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $0d4e57672a3dc010$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $eeH7J.createElement($0d4e57672a3dc010$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $0d4e57672a3dc010$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $eeH7J.createElement($0d4e57672a3dc010$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $0d4e57672a3dc010$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $0d4e57672a3dc010$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $eeH7J.createElement($eeH7J.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/utils/create-routes-from-children
 */ function $0d4e57672a3dc010$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $eeH7J.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $eeH7J.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $eeH7J.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $0d4e57672a3dc010$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $0d4e57672a3dc010$export$e7b0ac011bb776c6) && (0, $1ig10.UNSAFE_invariant)(false);
        !(!element.props.index || !element.props.children) && (0, $1ig10.UNSAFE_invariant)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $0d4e57672a3dc010$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $0d4e57672a3dc010$export$daf73786167a7f72(matches) {
    return $0d4e57672a3dc010$var$_renderMatches(matches);
}
function $0d4e57672a3dc010$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $eeH7J.createElement(route.Component),
        Component: undefined
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: /*#__PURE__*/ $eeH7J.createElement(route.HydrateFallback),
        HydrateFallback: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $eeH7J.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $0d4e57672a3dc010$export$f30f7e456d254e83(routes, opts) {
    return (0, $1ig10.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: $0d4e57672a3dc010$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $1ig10.createMemoryHistory)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $0d4e57672a3dc010$export$52b333d321859367
    }).initialize();
}

});


parcelRegister("4DHNO", function(module, exports) {

$parcel$export(module.exports, "Login", function () { return $360cc831837a6621$export$21a94553ffa41578; });
$parcel$export(module.exports, "login", function () { return $360cc831837a6621$export$596d806903d1f59e; });
$parcel$export(module.exports, "logout", function () { return $360cc831837a6621$export$a0973bcfe11b05c9; });

var $4vwom = parcelRequire("4vwom");

var $lDBHC = parcelRequire("lDBHC");

var $eeH7J = parcelRequire("eeH7J");

var $8jB4x = parcelRequire("8jB4x");

var $18Pjr = parcelRequire("18Pjr");

var $cNfXq = parcelRequire("cNfXq");
parcelRequire("dbwyW");
var $dAwef = parcelRequire("dAwef");
const $360cc831837a6621$var$LoginContext = /*#__PURE__*/ (0, $eeH7J.createContext)({
    isLoggedIn: false
});
function $360cc831837a6621$export$79c3258edc7d1573() {
    return (0, $eeH7J.useContext)($360cc831837a6621$var$LoginContext).isLoggedIn;
}
function $360cc831837a6621$var$parseJwt(token) {
    try {
        const base64Url = token.split(".")[1];
        const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
        const jsonPayload = decodeURIComponent(window.atob(base64).split("").map(function(c) {
            return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(""));
        return JSON.parse(jsonPayload);
    } catch (_a) {
        return {};
    }
}
/** If we got an error from the auth callback, it is set here so it is
 * immediately visible to the error handler below, so we avoid infinite retry
 * loops. */ let $360cc831837a6621$var$callbackError;
let $360cc831837a6621$var$clearTokens;
function $360cc831837a6621$export$21a94553ffa41578(props) {
    const [expiry, setExpiry] = (0, $eeH7J.useState)(undefined);
    const [isLoggedIn, setIsLoggedIn] = (0, $eeH7J.useState)(false);
    $360cc831837a6621$var$useLogin(props.always, (token)=>{
        props.tokenReady(token);
        const exp = $360cc831837a6621$var$parseJwt(token).exp;
        if (expiry !== exp) setExpiry(exp);
        if (isLoggedIn === false) setIsLoggedIn(true);
    });
    $360cc831837a6621$var$clearTokens = props.clearTokens;
    (0, $eeH7J.useEffect)(()=>{
        const handler = async (e)=>{
            var _a, _b;
            // If we got a low-level error from the auth callback - don't handle
            // it. This is e.g. unverified email address.
            if ($360cc831837a6621$var$callbackError) return {
                handled: false
            };
            if (e.status === 401) {
                if (expiry) {
                    if (expiry < Date.now() / 1000) {
                        if (await $360cc831837a6621$var$hiddenTokenRefresh()) return {
                            handled: true,
                            retry: true
                        };
                        else alert("Your login session has expired and cannot be restored.\n\nClick OK to log in again.");
                    }
                }
                setExpiry(undefined);
                setIsLoggedIn(false);
                const defaultReturnTo = typeof window === "undefined" ? "/" : `${window.location.pathname}${window.location.search}`;
                if (props.login) await props.login($360cc831837a6621$export$596d806903d1f59e, (_a = props.returnTo) !== null && _a !== void 0 ? _a : defaultReturnTo, e);
                else $360cc831837a6621$export$596d806903d1f59e((_b = props.returnTo) !== null && _b !== void 0 ? _b : defaultReturnTo);
                return {
                    handled: true
                };
            }
            return {
                handled: false
            };
        };
        /** Catch all 401's and send us to the login page */ (0, $8jB4x.SSRHook).errorHandlers.push(handler);
        return ()=>{
            (0, $8jB4x.SSRHook).errorHandlers.splice((0, $8jB4x.SSRHook).errorHandlers.indexOf(handler), 1);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        expiry,
        props.returnTo
    ]);
    if ($360cc831837a6621$var$callbackError) {
        if (props.errorDisplay) return props.errorDisplay($360cc831837a6621$var$callbackError);
        return (0, $4vwom.jsxs)("div", {
            style: {
                padding: 32
            },
            children: [
                (0, $4vwom.jsx)("h1", {
                    children: "Authentication error"
                }),
                (0, $4vwom.jsx)("p", {
                    children: $360cc831837a6621$var$callbackError
                })
            ]
        });
    }
    return (0, $4vwom.jsx)($360cc831837a6621$var$LoginContext.Provider, {
        value: {
            isLoggedIn: isLoggedIn
        },
        children: props.children
    });
}
let $360cc831837a6621$var$_tokenReady;
/** When used in a component, it indicates that the component and its subtree may be dependent on
 *  login to function.
 *
 *  The hook stores the access token in local storage, so a session can persist across page reloads.
 */ function $360cc831837a6621$var$useLogin(/** Whether to always log in eagerly, or only log in when a 401 is detected. */ always, /** Callback you receive when a new access token is available.
 *  This would be a good place to set the `Authorization` header on your API calls, e.g.
 * ```
 *  import { defaults } from "./client" // The client generated by Reactor
 *
 *  defaults.headers["Authorization"] = `Bearer ${access_token}`
 * ```
 */ tokenReady) {
    if ((0, $lDBHC.IsNode)()) throw new Error("useLogin should not be called on the server");
    $360cc831837a6621$var$_tokenReady = tokenReady;
    try {
        const { access_token: access_token, state: state } = $360cc831837a6621$var$getAuthCallback();
        if (access_token) {
            tokenReady(access_token);
            localStorage.setItem("Authorization", access_token);
            // If we are a hidden child iframe, send the hash to the parent window
            if (window.parent !== window) window.parent.postMessage({
                type: "hash",
                hash: window.location.hash
            }, "*");
            $360cc831837a6621$var$consumeHash(state);
        }
        const token = localStorage.getItem("Authorization");
        if (token) {
            const { exp: exp } = $360cc831837a6621$var$parseJwt(token);
            if (exp > Date.now() / 1000) {
                tokenReady(token);
                return;
            } else if (!exp) {
                // We probably have a demo auth token, or other token that doesn't expire
                // so we'll just use it. If it fails, we will get a 401 and log in again.
                tokenReady(token);
                return;
            } else localStorage.removeItem("Authorization");
        }
        if (always) $360cc831837a6621$export$596d806903d1f59e();
    } catch (e) {
        if (e instanceof Error) $360cc831837a6621$var$callbackError = e.message;
    }
}
function $360cc831837a6621$var$consumeHash(state) {
    if (!state) return;
    const authCallback = localStorage.getItem("authState");
    if (!authCallback) throw new Error("No auth callback state");
    const { key: key, returnTo: returnTo } = JSON.parse(authCallback);
    if (key !== state) throw new Error("Invalid auth callback state");
    window.location.replace(window.location.origin + (returnTo !== null && returnTo !== void 0 ? returnTo : window.location.pathname));
}
function $360cc831837a6621$var$getAuthCallback() {
    if ((0, $lDBHC.IsNode)()) return {};
    return $360cc831837a6621$var$parseHash(window.location.hash);
}
function $360cc831837a6621$var$parseHash(hash) {
    var _a, _b, _c, _d, _e, _f, _g;
    const hashKeys = hash.slice(1).split("&").map((x)=>x.split("=")).map((x)=>({
            key: x[0],
            value: x[1]
        }));
    if (hashKeys.find((x)=>x.key === "error")) {
        const errorDescription = (_a = hashKeys.find((x)=>x.key === "error_description")) === null || _a === void 0 ? void 0 : _a.value;
        throw new Error(errorDescription ? decodeURIComponent(errorDescription) : "Unknown error");
    }
    const id_token = (_b = hashKeys.find((x)=>x.key === "id_token")) === null || _b === void 0 ? void 0 : _b.value;
    if (id_token) {
        const { nonce: nonce } = $360cc831837a6621$var$parseJwt(id_token);
        const id = localStorage.getItem("authNonce");
        if (nonce !== id) throw new Error("Invalid id_token nonce");
        localStorage.setItem("id_token", id_token);
    }
    return {
        access_token: (_c = hashKeys.find((x)=>x.key === "access_token")) === null || _c === void 0 ? void 0 : _c.value,
        id_token: id_token,
        scope: (_d = hashKeys.find((x)=>x.key === "scope")) === null || _d === void 0 ? void 0 : _d.value,
        expires_in: (_e = hashKeys.find((x)=>x.key === "expires_in")) === null || _e === void 0 ? void 0 : _e.value,
        token_type: (_f = hashKeys.find((x)=>x.key === "token_type")) === null || _f === void 0 ? void 0 : _f.value,
        state: (_g = hashKeys.find((x)=>x.key === "state")) === null || _g === void 0 ? void 0 : _g.value
    };
}
function $360cc831837a6621$var$whenAuthReady(callback) {
    // In the SSR happy path, the authConfig should be synchronously available
    const auth = typeof authConfig !== "undefined" ? authConfig : undefined;
    if (auth) callback(auth);
    else (0, $cNfXq.whenReflectionReady)((ref)=>{
        authConfig = ref.model.authConfig;
        callback(authConfig);
    });
}
function $360cc831837a6621$export$596d806903d1f59e(returnTo = "/") {
    $360cc831837a6621$var$whenAuthReady((auth)=>{
        const url = $360cc831837a6621$var$makeAuthUrl(auth, returnTo);
        window.location.replace(url);
    });
}
function $360cc831837a6621$export$a0973bcfe11b05c9(returnTo) {
    $360cc831837a6621$var$whenAuthReady((auth)=>{
        const id_token = localStorage.getItem("id_token");
        localStorage.removeItem("id_token");
        localStorage.removeItem("Authorization");
        if ($360cc831837a6621$var$clearTokens !== undefined) $360cc831837a6621$var$clearTokens();
        if (auth === "studio-auth") {
            window.location.replace("/");
            return;
        }
        const endSessionEndpoint = auth.endSessionEndpoint ? auth.endSessionEndpoint : `https://${auth.domain}/v2/logout`;
        const url = `${endSessionEndpoint}?${[
            `client_id=${auth.clientId}`,
            `id_token_hint=${id_token}`,
            `post_logout_redirect_uri=${encodeURIComponent(window.location.origin + returnTo)}`
        ].join("&")}`;
        window.location.replace(url);
    });
}
function $360cc831837a6621$var$hiddenTokenRefresh() {
    return new Promise((resolve)=>{
        let resolved = false;
        const iframe = document.createElement("iframe");
        function listener(event) {
            if (event.data) try {
                if (event.data.type === "hash") {
                    const { access_token: access_token } = $360cc831837a6621$var$parseHash(event.data.hash);
                    if (access_token) {
                        $360cc831837a6621$var$_tokenReady(access_token);
                        localStorage.setItem("Authorization", access_token);
                        window.removeEventListener("message", listener);
                        if (!resolved) {
                            resolved = true;
                            document.body.removeChild(iframe);
                            resolve(true);
                        }
                        return;
                    }
                }
            } catch (e) {}
        }
        window.addEventListener("message", listener);
        $360cc831837a6621$var$whenAuthReady((auth)=>{
            iframe.setAttribute("src", $360cc831837a6621$var$makeAuthUrl(auth, "/"));
            iframe.style.display = "hidden";
            document.body.appendChild(iframe);
            // If we don't receive a callback in reasonable time, assume the refresh failed
            setTimeout(()=>{
                if (!resolved) {
                    document.body.removeChild(iframe);
                    resolved = true;
                    resolve(false);
                }
            }, 10000);
        });
    });
}
function $360cc831837a6621$var$makeAuthUrl(auth, returnTo = "/") {
    if (auth === "studio-auth") return "/studio/login?redirect=" + encodeURIComponent(window.location.pathname);
    const key = (0, $dAwef.Uuid)();
    localStorage.setItem("authState", JSON.stringify({
        key: key,
        returnTo: window.location.pathname
    }));
    const nonce = (0, $dAwef.Uuid)();
    localStorage.setItem("authNonce", nonce.valueOf());
    const authorizationEndpoint = auth.authorizationEndpoint ? auth.authorizationEndpoint : `https://${auth.domain}/authorize`;
    return `${authorizationEndpoint}?${[
        `response_type=id_token token`,
        `client_id=${auth.clientId}`,
        `redirect_uri=${encodeURIComponent(window.location.origin + returnTo)}`,
        `scope=openid email`,
        `state=${key}`,
        `audience=${encodeURIComponent(auth.audience)}`,
        `nonce=${nonce}`
    ].join("&")}`;
}
function $360cc831837a6621$export$b389d8ae4cb5c835(props) {
    return (0, $4vwom.jsx)((0, $18Pjr.Route), {
        path: `${props.path}/:token`,
        element: (0, $4vwom.jsx)($360cc831837a6621$var$LoginLinkPage, {
            redirectUrl: props.redirectUrl
        })
    });
}
function $360cc831837a6621$var$LoginLinkPage(props) {
    const token = (0, $18Pjr.useParams)().token;
    if (!token) return (0, $4vwom.jsx)("div", {
        children: "Invalid token"
    });
    if (!(0, $lDBHC.IsNode)()) {
        localStorage.setItem("Authorization", token);
        $360cc831837a6621$var$_tokenReady(token);
        window.location.pathname = props.redirectUrl;
    }
    return (0, $4vwom.jsx)("div", {
        children: "Authenticating..."
    });
}

});
parcelRegister("lDBHC", function(module, exports) {

$parcel$export(module.exports, "IsNode", function () { return $fc0a7c701e6faca7$export$3c2e381ecfd10bd9; });

var $2IVpK = parcelRequire("2IVpK");
const $fc0a7c701e6faca7$var$isNode = !!(typeof $2IVpK === "object" && typeof $2IVpK.versions === "object" && $2IVpK.versions.node);
function $fc0a7c701e6faca7$export$3c2e381ecfd10bd9() {
    return $fc0a7c701e6faca7$var$isNode;
}
function $fc0a7c701e6faca7$export$28bab5e896b9506e() {
    if (!$fc0a7c701e6faca7$export$3c2e381ecfd10bd9()) throw new Error("This code is only meant for a Node.js environment. Did you accidentally import it?");
}

});
parcelRegister("2IVpK", function(module, exports) {
// shim for using process in browser
var $1fbc3a1ae3c79101$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $1fbc3a1ae3c79101$var$cachedSetTimeout;
var $1fbc3a1ae3c79101$var$cachedClearTimeout;
function $1fbc3a1ae3c79101$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $1fbc3a1ae3c79101$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $1fbc3a1ae3c79101$var$cachedSetTimeout = setTimeout;
        else $1fbc3a1ae3c79101$var$cachedSetTimeout = $1fbc3a1ae3c79101$var$defaultSetTimout;
    } catch (e) {
        $1fbc3a1ae3c79101$var$cachedSetTimeout = $1fbc3a1ae3c79101$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $1fbc3a1ae3c79101$var$cachedClearTimeout = clearTimeout;
        else $1fbc3a1ae3c79101$var$cachedClearTimeout = $1fbc3a1ae3c79101$var$defaultClearTimeout;
    } catch (e) {
        $1fbc3a1ae3c79101$var$cachedClearTimeout = $1fbc3a1ae3c79101$var$defaultClearTimeout;
    }
})();
function $1fbc3a1ae3c79101$var$runTimeout(fun) {
    if ($1fbc3a1ae3c79101$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($1fbc3a1ae3c79101$var$cachedSetTimeout === $1fbc3a1ae3c79101$var$defaultSetTimout || !$1fbc3a1ae3c79101$var$cachedSetTimeout) && setTimeout) {
        $1fbc3a1ae3c79101$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $1fbc3a1ae3c79101$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $1fbc3a1ae3c79101$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $1fbc3a1ae3c79101$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $1fbc3a1ae3c79101$var$runClearTimeout(marker) {
    if ($1fbc3a1ae3c79101$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($1fbc3a1ae3c79101$var$cachedClearTimeout === $1fbc3a1ae3c79101$var$defaultClearTimeout || !$1fbc3a1ae3c79101$var$cachedClearTimeout) && clearTimeout) {
        $1fbc3a1ae3c79101$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $1fbc3a1ae3c79101$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $1fbc3a1ae3c79101$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $1fbc3a1ae3c79101$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $1fbc3a1ae3c79101$var$queue = [];
var $1fbc3a1ae3c79101$var$draining = false;
var $1fbc3a1ae3c79101$var$currentQueue;
var $1fbc3a1ae3c79101$var$queueIndex = -1;
function $1fbc3a1ae3c79101$var$cleanUpNextTick() {
    if (!$1fbc3a1ae3c79101$var$draining || !$1fbc3a1ae3c79101$var$currentQueue) return;
    $1fbc3a1ae3c79101$var$draining = false;
    if ($1fbc3a1ae3c79101$var$currentQueue.length) $1fbc3a1ae3c79101$var$queue = $1fbc3a1ae3c79101$var$currentQueue.concat($1fbc3a1ae3c79101$var$queue);
    else $1fbc3a1ae3c79101$var$queueIndex = -1;
    if ($1fbc3a1ae3c79101$var$queue.length) $1fbc3a1ae3c79101$var$drainQueue();
}
function $1fbc3a1ae3c79101$var$drainQueue() {
    if ($1fbc3a1ae3c79101$var$draining) return;
    var timeout = $1fbc3a1ae3c79101$var$runTimeout($1fbc3a1ae3c79101$var$cleanUpNextTick);
    $1fbc3a1ae3c79101$var$draining = true;
    var len = $1fbc3a1ae3c79101$var$queue.length;
    while(len){
        $1fbc3a1ae3c79101$var$currentQueue = $1fbc3a1ae3c79101$var$queue;
        $1fbc3a1ae3c79101$var$queue = [];
        while(++$1fbc3a1ae3c79101$var$queueIndex < len)if ($1fbc3a1ae3c79101$var$currentQueue) $1fbc3a1ae3c79101$var$currentQueue[$1fbc3a1ae3c79101$var$queueIndex].run();
        $1fbc3a1ae3c79101$var$queueIndex = -1;
        len = $1fbc3a1ae3c79101$var$queue.length;
    }
    $1fbc3a1ae3c79101$var$currentQueue = null;
    $1fbc3a1ae3c79101$var$draining = false;
    $1fbc3a1ae3c79101$var$runClearTimeout(timeout);
}
$1fbc3a1ae3c79101$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $1fbc3a1ae3c79101$var$queue.push(new $1fbc3a1ae3c79101$var$Item(fun, args));
    if ($1fbc3a1ae3c79101$var$queue.length === 1 && !$1fbc3a1ae3c79101$var$draining) $1fbc3a1ae3c79101$var$runTimeout($1fbc3a1ae3c79101$var$drainQueue);
};
// v8 likes predictible objects
function $1fbc3a1ae3c79101$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$1fbc3a1ae3c79101$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$1fbc3a1ae3c79101$var$process.title = "browser";
$1fbc3a1ae3c79101$var$process.browser = true;
$1fbc3a1ae3c79101$var$process.env = {};
$1fbc3a1ae3c79101$var$process.argv = [];
$1fbc3a1ae3c79101$var$process.version = ""; // empty string to avoid regexp issues
$1fbc3a1ae3c79101$var$process.versions = {};
function $1fbc3a1ae3c79101$var$noop() {}
$1fbc3a1ae3c79101$var$process.on = $1fbc3a1ae3c79101$var$noop;
$1fbc3a1ae3c79101$var$process.addListener = $1fbc3a1ae3c79101$var$noop;
$1fbc3a1ae3c79101$var$process.once = $1fbc3a1ae3c79101$var$noop;
$1fbc3a1ae3c79101$var$process.off = $1fbc3a1ae3c79101$var$noop;
$1fbc3a1ae3c79101$var$process.removeListener = $1fbc3a1ae3c79101$var$noop;
$1fbc3a1ae3c79101$var$process.removeAllListeners = $1fbc3a1ae3c79101$var$noop;
$1fbc3a1ae3c79101$var$process.emit = $1fbc3a1ae3c79101$var$noop;
$1fbc3a1ae3c79101$var$process.prependListener = $1fbc3a1ae3c79101$var$noop;
$1fbc3a1ae3c79101$var$process.prependOnceListener = $1fbc3a1ae3c79101$var$noop;
$1fbc3a1ae3c79101$var$process.listeners = function(name) {
    return [];
};
$1fbc3a1ae3c79101$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$1fbc3a1ae3c79101$var$process.cwd = function() {
    return "/";
};
$1fbc3a1ae3c79101$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$1fbc3a1ae3c79101$var$process.umask = function() {
    return 0;
};

});


parcelRegister("8jB4x", function(module, exports) {

$parcel$export(module.exports, "useDataFrom", function () { return $60dcdada2782d151$export$87b9d1c66cb4ea2d; });
$parcel$export(module.exports, "SSRHook", function () { return $60dcdada2782d151$export$f02391734a1b9120; });
/* eslint-disable react-hooks/rules-of-hooks */ 
var $eeH7J = parcelRequire("eeH7J");

var $lDBHC = parcelRequire("lDBHC");

var $3SKqX = parcelRequire("3SKqX");

var $5JGam = parcelRequire("5JGam");

var $knIBr = parcelRequire("knIBr");
function $60dcdada2782d151$export$87b9d1c66cb4ea2d(hook) {
    const [data, setData] = (0, $eeH7J.useState)(undefined);
    (0, $eeH7J.useEffect)(()=>{
        const listener = (response, args)=>{
            setData({
                args: args,
                response: response
            });
        };
        hook.addDataListener(listener);
        return ()=>hook.removeDataListener(listener);
    }, [
        hook
    ]);
    return data;
}
globalThis.ssrEndpoints = (0, $lDBHC.IsNode)() ? {} : null;

function $60dcdada2782d151$export$f02391734a1b9120(/** Name of the server side getter-function this hook maps to */ funcName, /** Name of the DTO type that this hook GETs. */ dtoName, /** Name of the DTO type that this hook PUTs.
 *
 *  This limits what properties from the GET DTO will be displayed as
 *  editable in WYSIWYG editors. Only properties that are present in both
 *  the PUT and GET DTOs will be editable.
 */ putDtoName, /** The client side getter function */ getter, /** The names of the arguments to the getter function. */ argNames, /** A function that saves the resource back to its origin. If provided, the resource will be
 * editable. */ putter) {
    const listeners = [];
    /** Returns the inputs that we are still waiting for in order for the hook
     *  to be able to resolve its data.
     *
     *  If `null` is passed for any of the arguments, this indicates the hook is
     *  waiting for an input to become available and should not evaluate yet. We
     *  still need to call all of the React hooks to get the same number of
     *  hooks per render.
     **/ function getWaitingForInputs(args) {
        return args.map((a, i)=>i).filter((i)=>args[i] === null).map((i)=>argNames[i]);
    }
    /** Returns the SSR results on the client side */ function clientSideResolve(query) {
        var _a, _b, _c;
        return {
            data: "ssrResults" in globalThis && ssrResults && ((_a = ssrResults[query]) === null || _a === void 0 ? void 0 : _a.result) || undefined,
            needsAuthenticatedRefresh: "ssrResults" in globalThis && ssrResults && ((_b = ssrResults[query]) === null || _b === void 0 ? void 0 : _b.needsAuthenticatedRefresh) ? true : false,
            error: "ssrResults" in globalThis && ssrResults && ((_c = ssrResults[query]) === null || _c === void 0 ? void 0 : _c.error) || undefined
        };
    }
    /** Resolves the SSR results on the server side. On the client side, this
     * returns `undefined`. */ function serverSideResolve(waitingForInputs, args) {
        if (ssrEndpoints && !(funcName in ssrEndpoints)) {
            $60dcdada2782d151$var$needsAuthenticatedRefresh = true;
            // Not an SSR-compatible endpoint, try again when authenticated
            return {
                data: undefined,
                originalData: undefined,
                error: {
                    type: "Unauthorized",
                    status: 401
                },
                loading: false,
                needsAuthenticatedRefresh: true,
                // Dummy, refresh not possible in SSR mode
                refresh: ()=>Promise.resolve()
            };
        }
        if (ssrEndpoints && ssrEndpoints[funcName] && ssrTransaction && ssrTransaction.current) {
            const query = JSON.stringify({
                name: funcName,
                args: args
            });
            if (waitingForInputs.length) return {
                waitingForInputs: waitingForInputs,
                data: undefined,
                loading: false,
                originalData: undefined,
                refresh: async ()=>{}
            };
            const existingError = query in ssrTransaction.current ? ssrTransaction.current[query].error : undefined;
            if (existingError) return {
                data: undefined,
                originalData: undefined,
                error: existingError,
                loading: false,
                // Dummy, refresh not possible in SSR mode
                refresh: ()=>Promise.resolve()
            };
            const existingPromise = query in ssrTransaction.current ? ssrTransaction.current[query] : undefined;
            const existingResult = existingPromise === null || existingPromise === void 0 ? void 0 : existingPromise.result;
            if (existingResult) return {
                data: existingResult,
                originalData: existingResult,
                loading: false,
                // Dummy, refresh not possible in SSR mode
                refresh: ()=>Promise.resolve()
            };
            if (existingPromise) return {
                data: undefined,
                originalData: undefined,
                loading: true,
                // Dummy, refresh not possible in SSR mode
                refresh: ()=>Promise.resolve()
            };
            try {
                $60dcdada2782d151$var$needsAuthenticatedRefresh = false;
                const promise = ssrEndpoints[funcName](...args);
                let synchronousCrash;
                if (typeof promise === "object" && "catch" in promise) {
                    // We got an asynchronous result - wait for it
                    promise.catch((e)=>{
                        synchronousCrash = e;
                    });
                    ssrTransaction.current[query] = {
                        promise: promise,
                        needsAuthenticatedRefresh: $60dcdada2782d151$var$needsAuthenticatedRefresh ? true : undefined
                    };
                } else {
                    // We got a synchronous result - hooraay!
                    ssrTransaction.current[query] = {
                        result: promise,
                        needsAuthenticatedRefresh: $60dcdada2782d151$var$needsAuthenticatedRefresh ? true : undefined
                    };
                    return {
                        data: promise,
                        originalData: promise,
                        loading: false,
                        // Dummy, refresh not possible in SSR mode
                        refresh: ()=>Promise.resolve()
                    };
                }
                if (synchronousCrash) return {
                    data: undefined,
                    originalData: undefined,
                    error: synchronousCrash,
                    loading: false,
                    // Dummy, refresh not possible in SSR mode
                    refresh: ()=>Promise.resolve()
                };
                return {
                    data: undefined,
                    originalData: undefined,
                    loading: true,
                    // Dummy, refresh not possible in SSR mode
                    refresh: ()=>Promise.resolve()
                };
            } catch (e) {
                // Failed synchronously
                return {
                    data: undefined,
                    originalData: undefined,
                    error: e,
                    loading: false,
                    // Dummy, refresh not possible in SSR mode
                    refresh: ()=>Promise.resolve()
                };
            }
        }
    }
    function hook(...args) {
        var _a;
        const waitingForInputs = getWaitingForInputs(args);
        // Shortcut for fetching data on the server as part of SSR
        const serverSideResult = serverSideResolve(waitingForInputs, args);
        if (serverSideResult) return serverSideResult;
        const query = (0, $eeH7J.useMemo)(()=>JSON.stringify({
                name: funcName,
                args: args
            }), [
            funcName,
            ...args
        ]);
        const ssr = clientSideResolve(query);
        const firstRender = (0, $eeH7J.useRef)(true);
        const [version, setVersion] = (0, $eeH7J.useState)({});
        const [originalData, setData] = (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).useState(ssr.data || undefined);
        const [error, setError] = (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).useState(ssr.error || undefined);
        const [loading, setLoading] = (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).useState(originalData === undefined);
        if (error) console.error(`Error while fetching ${funcName}(${args.join(", ")}):`, error);
        const [yEditor, setYEditor] = (0, $eeH7J.useState)(undefined);
        const currentResource = {
            query: query,
            endpoint: funcName,
            data: yEditor ? yEditor.proxy : originalData,
            dtoName: dtoName !== null && dtoName !== void 0 ? dtoName : "unknown",
            putDtoName: putDtoName
        };
        const resource = (0, $eeH7J.useRef)(currentResource);
        Object.assign(resource.current, currentResource);
        const isEditing = (0, $eeH7J.useContext)((0, $5JGam.IsEditingContext));
        const refresh = (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).useCallback(async ()=>{
            if (waitingForInputs.length) return;
            setLoading(true);
            try {
                const d = await getter(...args);
                listeners.forEach((l)=>l(d, args));
                setData(d);
                setError(undefined);
                setLoading(false);
            } catch (e) {
                // No need to handle errors or retry here, since this is handled
                // internally in the `getter` function.
                const problem = typeof e === "object" && "type" in e ? e : {
                    type: "Unknown",
                    error: e
                };
                setError(problem);
                setLoading(false);
            }
        }, [
            query
        ]);
        const onChange = (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).useCallback(async (type)=>{
            if (type === "change") await (yEditor === null || yEditor === void 0 ? void 0 : yEditor.fetchUpdates());
            if (type === "discard" || type === "save") await refresh();
        }, [
            yEditor,
            refresh
        ]);
        const selectionContext = (0, $eeH7J.useContext)((0, $knIBr.SelectionContext));
        if (putter) {
            const argList = JSON.stringify(args);
            (0, $3SKqX.useChangeNotifications)(funcName, argList, "draft", onChange, isEditing);
            (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).useEffect(()=>{
                if (waitingForInputs.length) return;
                function invalidate() {
                    setVersion({});
                }
                function reset() {
                    // In case the selection was inside the editor that was
                    // reset, we need to clear it
                    selectionContext === null || selectionContext === void 0 || selectionContext.clearSelectedObject();
                }
                let ye;
                async function initEditor() {
                    if (!originalData) return;
                    if (isEditing) {
                        const { YEditor: YEditor } = await Promise.resolve((parcelRequire("9ArIY")));
                        ye = new YEditor(funcName, argList, "draft", dtoName !== null && dtoName !== void 0 ? dtoName : "unknown", putDtoName, invalidate, reset);
                        const originalDiscard = ye.discardChanges;
                        ye.discardChanges = async ()=>{
                            await originalDiscard();
                            reset();
                        };
                        await ye.initInteractive(originalData);
                        setYEditor(ye);
                    } else {
                        yEditor === null || yEditor === void 0 || yEditor.destroy();
                        ye = undefined;
                        setYEditor(undefined);
                    }
                }
                if (isEditing) initEditor();
                return ()=>{
                    ye === null || ye === void 0 || ye.destroy();
                    ye = undefined;
                };
            }, [
                originalData,
                isEditing,
                argList,
                funcName,
                waitingForInputs.length
            ]);
        }
        (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).useEffect(()=>{
            if ((ssr.error || ssr.data) && firstRender.current) {
                // No need to fetch, we have SSR data
                firstRender.current = false;
                if (ssr.needsAuthenticatedRefresh) // The SSR data needs to be refreshed with an authenticated request
                refresh();
                return;
            }
            refresh();
        }, [
            query
        ]);
        if (waitingForInputs.length) // While waiting for inputs, we should not display any data, even if
        // we have some data cached from a previously valid set of inputs.
        // Displaying cached data that are not based on the current inputs
        // is potentially erroneous and hazardous, since the state being
        // displayed would now be inconsistent. This could mislead the user
        // into making wrong actions in the UI.
        //
        // This manifested in bugs like #1533.
        //
        return {
            data: undefined,
            originalData: undefined,
            error: error,
            loading: false,
            waitingForInputs: waitingForInputs,
            refresh: refresh
        };
        const waitingForAuthenticatedRefresh = ssr.needsAuthenticatedRefresh && firstRender.current;
        return {
            data: (_a = yEditor === null || yEditor === void 0 ? void 0 : yEditor.proxy) !== null && _a !== void 0 ? _a : originalData,
            originalData: originalData,
            error: waitingForAuthenticatedRefresh ? undefined : error,
            loading: waitingForAuthenticatedRefresh || loading,
            refresh: refresh
        };
    }
    hook.addDataListener = (listener)=>{
        listeners.push(listener);
    };
    hook.removeDataListener = (listener)=>{
        const index = listeners.indexOf(listener);
        if (index >= 0) listeners.splice(index, 1);
    };
    return hook;
}
let $60dcdada2782d151$var$needsAuthenticatedRefresh = false;
/** If called from an endpoint, it indicates that an endpoint that was read
 * during SSR will require an authenticated refresh from the client side to
 * produce the correct result. This allows the page to render the rest of its
 * content (that does not require authentication.)  */ $60dcdada2782d151$export$f02391734a1b9120.requireAuthenticatedRefresh = function() {
    $60dcdada2782d151$var$needsAuthenticatedRefresh = true;
};
$60dcdada2782d151$export$f02391734a1b9120.errorHandlers = [];
/** Handles an error from a failed fetch(). This is used by generated clients.
 *
 *  This will invoke the registered error handlers in turn to see if any of them can handle the
 *  error. If so, the error may trigger some side effect, such as refreshing the access token.
 *
 *
 *
 *  Regardless of whether the error is handled or not, it will typically throw the error, but may
 *  also (in the future) return a valid response provided by one of the handlers.
 */ $60dcdada2782d151$export$f02391734a1b9120.handleError = async (res)=>{
    const contentType = res.headers.get("Content-Type");
    if (contentType === null || contentType === void 0 ? void 0 : contentType.includes("application/problem+json")) {
        const problem = await res.json();
        for (const handler of $60dcdada2782d151$export$f02391734a1b9120.errorHandlers){
            const handledResponse = await handler(problem);
            if (handledResponse.retry) return handledResponse;
            if (handledResponse.handled) break;
        }
        throw problem;
    }
    throw new Error("Unhandled fetch error");
};
/** A registry of all the generated client endpoints. */ $60dcdada2782d151$export$f02391734a1b9120.clientEndpoints = [];

});
parcelRegister("3SKqX", function(module, exports) {

$parcel$export(module.exports, "WebSocketContext", function () { return $2d3a6f0aa124c997$export$c6437728a0fc8cc2; });
$parcel$export(module.exports, "WebSocketContextProvider", function () { return $2d3a6f0aa124c997$export$fdc07ca4b6d6eb42; });
$parcel$export(module.exports, "useChangeNotifications", function () { return $2d3a6f0aa124c997$export$5f82016abe5cb42; });

var $4vwom = parcelRequire("4vwom");

var $eeH7J = parcelRequire("eeH7J");

var $dAwef = parcelRequire("dAwef");

var $8h5s0 = parcelRequire("8h5s0");

var $3Ixuz = parcelRequire("3Ixuz");
const $2d3a6f0aa124c997$export$c6437728a0fc8cc2 = /*#__PURE__*/ (0, $eeH7J.createContext)(undefined);
let $2d3a6f0aa124c997$var$reconnectBackoff = 0.25;

function $2d3a6f0aa124c997$export$fdc07ca4b6d6eb42({ children: children }) {
    const [connectionKey, setConnectionKey] = (0, $eeH7J.useState)((0, $dAwef.Uuid)());
    const [status, setStatus] = (0, $eeH7J.useState)("disconnected");
    const [subscribers] = (0, $eeH7J.useState)([]);
    const socketPromise = (0, $eeH7J.useRef)(undefined);
    const [socket, setSocket] = (0, $eeH7J.useState)(undefined);
    function onMessage({ data: data }) {
        const msg = JSON.parse(data.toString());
        if (typeof msg === "object" && "changed" in msg) {
            const type = (0, $3Ixuz.IsResourceNotificationType)(msg.type) ? msg.type : "change";
            for (const { res: res, key: key, onChanged: onChanged } of subscribers)if (msg.changed === res && (key === undefined || msg.key === key)) onChanged(type);
        }
    }
    function onClose() {
        this.removeEventListener("open", onOpen);
        this.removeEventListener("message", onMessage);
        this.removeEventListener("close", onClose);
        this.removeEventListener("error", onClose);
        setConnectionKey(undefined);
        reconnectWithBackoff();
    }
    function reconnectWithBackoff() {
        socketPromise.current = undefined;
        setSocket(undefined);
        // automatically reconnect, with exponential backoff
        setTimeout(connect, $2d3a6f0aa124c997$var$reconnectBackoff);
        $2d3a6f0aa124c997$var$reconnectBackoff = Math.min($2d3a6f0aa124c997$var$reconnectBackoff * 2, 3000);
    }
    function onOpen() {
        var _a;
        this.addEventListener("message", onMessage);
        this.addEventListener("close", onClose);
        (_a = socketPromise.current) === null || _a === void 0 || _a.resolve(this);
        this.send(JSON.stringify({
            clientId: $2d3a6f0aa124c997$export$5f82016abe5cb42.clientId
        }));
        setSocket(this);
        setStatus("connected");
        setConnectionKey((old)=>{
            if (old) return old;
            return (0, $dAwef.Uuid)();
        });
    }
    const connect = (0, $eeH7J.useCallback)(async ()=>{
        if (socketPromise.current) return await socketPromise.current.socket;
        let resolve;
        const promise = new Promise((r)=>{
            resolve = r;
        });
        socketPromise.current = {
            socket: promise,
            resolve: (0, $8h5s0.Assert)(resolve)
        };
        setStatus("connecting");
        const { getWebSocketTicketForStudioUser: getWebSocketTicketForStudioUser } = await Promise.resolve((parcelRequire("dUDPg")));
        try {
            const ticket = await getWebSocketTicketForStudioUser();
            const proto = window.location.protocol === "https:" ? "wss:" : "ws:";
            const host = window.location.hostname;
            let port = window.location.port;
            if (port === "3001") port = "3000";
            const newSocket = new WebSocket(`${proto}//${host}:${port}/api/studio/documents/changed?ticket=${ticket.ticket}`);
            if (newSocket.readyState !== newSocket.OPEN) newSocket.addEventListener("open", onOpen);
            else onOpen.call(newSocket);
        } catch (e) {
            reconnectWithBackoff();
            return promise;
        }
        return promise;
    }, []);
    const addSubscriber = (0, $eeH7J.useCallback)(async (s)=>{
        subscribers.push(s);
        const socket = await connect();
        socket.send(JSON.stringify({
            subscribe: s.res,
            key: s.key,
            layer: s.layer
        }));
    }, [
        connect,
        subscribers
    ]);
    const removeSubscriber = (0, $eeH7J.useCallback)(async (s)=>{
        const idx = subscribers.indexOf(s);
        if (idx !== -1) subscribers.splice(idx, 1);
        const socket = await connect();
        socket.send(JSON.stringify({
            unsubscribe: s.res,
            key: s.key,
            layer: s.layer
        }));
    }, [
        connect,
        subscribers
    ]);
    const context = (0, $eeH7J.useMemo)(()=>({
            addSubscriber: addSubscriber,
            removeSubscriber: removeSubscriber,
            status: status,
            connectionKey: connectionKey
        }), [
        addSubscriber,
        removeSubscriber,
        status,
        connectionKey
    ]);
    // Ping the server every 30 seconds to keep the connection alive
    (0, $eeH7J.useEffect)(()=>{
        if (!socket) return;
        const pingInterval = setInterval(()=>{
            if (socket.readyState === socket.OPEN) socket.send(JSON.stringify({
                ping: true
            }));
        }, 30000);
        return ()=>clearInterval(pingInterval);
    }, [
        socket
    ]);
    return (0, $4vwom.jsx)($2d3a6f0aa124c997$export$c6437728a0fc8cc2.Provider, {
        value: context,
        children: children
    });
}
function $2d3a6f0aa124c997$export$5f82016abe5cb42(resource, /**
 * The key to listen for changes in. If not provided, the entire
 * resource will be listened to.
 *
 * For collections, this is the primary key of the item.
 *
 * For endpoints, this is the stringified arguments to the endpoint.
 */ key, /**
 * The layer to listen for changes in. If not provided, the base layer
 * (commited changes) will be listened to.
 */ layer, onChanged, /** Enables or disables this hook, without changing the number of hooks
 * created in the React render. */ canUseChangeNotifications = true) {
    const wsc = (0, $eeH7J.useContext)($2d3a6f0aa124c997$export$c6437728a0fc8cc2);
    // Listen for Change Stream
    (0, $eeH7J.useEffect)(()=>{
        if (!canUseChangeNotifications) return;
        if (!wsc) throw new Error("WebSocketContext not found " + resource);
        const sub = {
            res: resource,
            key: key,
            layer: layer,
            onChanged: onChanged
        };
        wsc.addSubscriber(sub);
        return ()=>{
            wsc.removeSubscriber(sub);
        };
    }, [
        resource,
        key,
        layer,
        onChanged,
        wsc,
        canUseChangeNotifications
    ]);
}
$2d3a6f0aa124c997$export$5f82016abe5cb42.clientId = (0, $dAwef.Uuid)();

});
parcelRegister("dAwef", function(module, exports) {

$parcel$export(module.exports, "Uuid", function () { return $9e47a31fa2352815$export$246bd50017fc40d5; });
$parcel$export(module.exports, "IsUuidType", function () { return $9e47a31fa2352815$export$13fa69b473ae7bd9; });

var $elTi9 = parcelRequire("elTi9");

var $hcjDr = parcelRequire("hcjDr");

var $5cQqO = parcelRequire("5cQqO");
(0, $5cQqO.TSQFunction)($9e47a31fa2352815$export$246bd50017fc40d5);
function $9e47a31fa2352815$export$246bd50017fc40d5(value) {
    if (value) return value;
    return (0, $elTi9.default)();
}
/**
 * Generates a UUID (v4) from a seed string. This is useful in testing, for
 * generating a UUID deterministically from a string, which in turn e.g. is used
 * for snapshot testing. The generated UUID is guaranteed to be the same for the
 * same seed string.
 *
 * This is NOT suitable for generating UUIDs for production use. UUIDs are meant
 * to be Universally Unique Identifiers, and introducing a seed value
 * contradicts this concept because it would cause the same "random" values to
 * be produced under the same seed.
 *
 */ $9e47a31fa2352815$export$246bd50017fc40d5.fromSeed = (seed)=>{
    const rng = new (0, $hcjDr.default)(seed);
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(c) {
        const r = rng.next() * 16 | 0;
        const v = c === "x" ? r : r & 0x3 | 0x8;
        return v.toString(16);
    });
};
/** UUID pattern: 8-4-4-4-12 hexadecimal digits separated by hyphens */ $9e47a31fa2352815$export$246bd50017fc40d5.pattern = /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/;
/** Checks that the provided string is a valid Uuid, as produced by Uuid().
 *
 *  It must match the pattern in `Uuid.pattern`.
 */ $9e47a31fa2352815$export$246bd50017fc40d5.validate = (value)=>{
    return $9e47a31fa2352815$export$246bd50017fc40d5.pattern.test(value.valueOf());
};
function $9e47a31fa2352815$export$13fa69b473ae7bd9(type) {
    return typeof type === "object" && type.alias === "Uuid";
}

});
parcelRegister("elTi9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a72deaa1b71be5bc$export$2e2bcd8739ae039; });

var $4TGnr = parcelRequire("4TGnr");

var $eO0tT = parcelRequire("eO0tT");

var $hhC3D = parcelRequire("hhC3D");
function $a72deaa1b71be5bc$var$v4(options, buf, offset) {
    if ((0, $4TGnr.default).randomUUID && !buf && !options) return (0, $4TGnr.default).randomUUID();
    options = options || {};
    const rnds = options.random || (options.rng || (0, $eO0tT.default))(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided
    if (buf) {
        offset = offset || 0;
        for(let i = 0; i < 16; ++i)buf[offset + i] = rnds[i];
        return buf;
    }
    return (0, $hhC3D.unsafeStringify)(rnds);
}
var $a72deaa1b71be5bc$export$2e2bcd8739ae039 = $a72deaa1b71be5bc$var$v4;

});
parcelRegister("4TGnr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $390d2bb43880bed0$export$2e2bcd8739ae039; });
const $390d2bb43880bed0$var$randomUUID = typeof crypto !== "undefined" && crypto.randomUUID && crypto.randomUUID.bind(crypto);
var $390d2bb43880bed0$export$2e2bcd8739ae039 = {
    randomUUID: $390d2bb43880bed0$var$randomUUID
};

});

parcelRegister("eO0tT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ac761bc26cafc6c5$export$2e2bcd8739ae039; });
// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
let $ac761bc26cafc6c5$var$getRandomValues;
const $ac761bc26cafc6c5$var$rnds8 = new Uint8Array(16);
function $ac761bc26cafc6c5$export$2e2bcd8739ae039() {
    // lazy load so that environments that need to polyfill have a chance to do so
    if (!$ac761bc26cafc6c5$var$getRandomValues) {
        // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation.
        $ac761bc26cafc6c5$var$getRandomValues = typeof crypto !== "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto);
        if (!$ac761bc26cafc6c5$var$getRandomValues) throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    }
    return $ac761bc26cafc6c5$var$getRandomValues($ac761bc26cafc6c5$var$rnds8);
}

});

parcelRegister("hhC3D", function(module, exports) {

$parcel$export(module.exports, "unsafeStringify", function () { return $c9518ba92fa242e9$export$8fb373d660548968; });

var $kYtw9 = parcelRequire("kYtw9");
/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ const $c9518ba92fa242e9$var$byteToHex = [];
for(let i = 0; i < 256; ++i)$c9518ba92fa242e9$var$byteToHex.push((i + 0x100).toString(16).slice(1));
function $c9518ba92fa242e9$export$8fb373d660548968(arr, offset = 0) {
    // Note: Be careful editing this code!  It's been tuned for performance
    // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
    return $c9518ba92fa242e9$var$byteToHex[arr[offset + 0]] + $c9518ba92fa242e9$var$byteToHex[arr[offset + 1]] + $c9518ba92fa242e9$var$byteToHex[arr[offset + 2]] + $c9518ba92fa242e9$var$byteToHex[arr[offset + 3]] + "-" + $c9518ba92fa242e9$var$byteToHex[arr[offset + 4]] + $c9518ba92fa242e9$var$byteToHex[arr[offset + 5]] + "-" + $c9518ba92fa242e9$var$byteToHex[arr[offset + 6]] + $c9518ba92fa242e9$var$byteToHex[arr[offset + 7]] + "-" + $c9518ba92fa242e9$var$byteToHex[arr[offset + 8]] + $c9518ba92fa242e9$var$byteToHex[arr[offset + 9]] + "-" + $c9518ba92fa242e9$var$byteToHex[arr[offset + 10]] + $c9518ba92fa242e9$var$byteToHex[arr[offset + 11]] + $c9518ba92fa242e9$var$byteToHex[arr[offset + 12]] + $c9518ba92fa242e9$var$byteToHex[arr[offset + 13]] + $c9518ba92fa242e9$var$byteToHex[arr[offset + 14]] + $c9518ba92fa242e9$var$byteToHex[arr[offset + 15]];
}
function $c9518ba92fa242e9$var$stringify(arr, offset = 0) {
    const uuid = $c9518ba92fa242e9$export$8fb373d660548968(arr, offset); // Consistency check for valid UUID.  If this throws, it's likely due to one
    // of the following:
    // - One or more input array values don't map to a hex octet (leading to
    // "undefined" in the uuid)
    // - Invalid input values for the RFC `version` or `variant` fields
    if (!(0, $kYtw9.default)(uuid)) throw TypeError("Stringified UUID is invalid");
    return uuid;
}
var $c9518ba92fa242e9$export$2e2bcd8739ae039 = $c9518ba92fa242e9$var$stringify;

});
parcelRegister("kYtw9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f4504ed462a60e9d$export$2e2bcd8739ae039; });

var $fdMZd = parcelRequire("fdMZd");
function $f4504ed462a60e9d$var$validate(uuid) {
    return typeof uuid === "string" && (0, $fdMZd.default).test(uuid);
}
var $f4504ed462a60e9d$export$2e2bcd8739ae039 = $f4504ed462a60e9d$var$validate;

});
parcelRegister("fdMZd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b14e1195d6a35c07$export$2e2bcd8739ae039; });
var $b14e1195d6a35c07$export$2e2bcd8739ae039 = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;

});




parcelRegister("hcjDr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c852c9d043b7a6f7$export$2e2bcd8739ae039; });
var $c852c9d043b7a6f7$var$Prando = /** @class */ function() {
    // ================================================================================================================
    // CONSTRUCTOR ----------------------------------------------------------------------------------------------------
    /**
     * Generate a new Prando pseudo-random number generator.
     *
     * @param seed - A number or string seed that determines which pseudo-random number sequence will be created. Defaults to a random seed based on `Math.random()`.
     */ function Prando(seed) {
        this._value = NaN;
        if (typeof seed === "string") // String seed
        this._seed = this.hashCode(seed);
        else if (typeof seed === "number") // Numeric seed
        this._seed = this.getSafeSeed(seed);
        else // Pseudo-random seed
        this._seed = this.getSafeSeed(Prando.MIN + Math.floor((Prando.MAX - Prando.MIN) * Math.random()));
        this.reset();
    }
    // ================================================================================================================
    // PUBLIC INTERFACE -----------------------------------------------------------------------------------------------
    /**
     * Generates a pseudo-random number between a lower (inclusive) and a higher (exclusive) bounds.
     *
     * @param min - The minimum number that can be randomly generated.
     * @param pseudoMax - The maximum number that can be randomly generated (exclusive).
     * @return The generated pseudo-random number.
     */ Prando.prototype.next = function(min, pseudoMax) {
        if (min === void 0) min = 0;
        if (pseudoMax === void 0) pseudoMax = 1;
        this.recalculate();
        return this.map(this._value, Prando.MIN, Prando.MAX, min, pseudoMax);
    };
    /**
     * Generates a pseudo-random integer number in a range (inclusive).
     *
     * @param min - The minimum number that can be randomly generated.
     * @param max - The maximum number that can be randomly generated.
     * @return The generated pseudo-random number.
     */ Prando.prototype.nextInt = function(min, max) {
        if (min === void 0) min = 10;
        if (max === void 0) max = 100;
        this.recalculate();
        return Math.floor(this.map(this._value, Prando.MIN, Prando.MAX, min, max + 1));
    };
    /**
     * Generates a pseudo-random string sequence of a particular length from a specific character range.
     *
     * Note: keep in mind that creating a random string sequence does not guarantee uniqueness; there is always a
     * 1 in (char_length^string_length) chance of collision. For real unique string ids, always check for
     * pre-existing ids, or employ a robust GUID/UUID generator.
     *
     * @param length - Length of the string to be generated.
     * @param chars - Characters that are used when creating the random string. Defaults to all alphanumeric chars (A-Z, a-z, 0-9).
     * @return The generated string sequence.
     */ Prando.prototype.nextString = function(length, chars) {
        if (length === void 0) length = 16;
        if (chars === void 0) chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
        var str = "";
        while(str.length < length)str += this.nextChar(chars);
        return str;
    };
    /**
     * Generates a pseudo-random string of 1 character specific character range.
     *
     * @param chars - Characters that are used when creating the random string. Defaults to all alphanumeric chars (A-Z, a-z, 0-9).
     * @return The generated character.
     */ Prando.prototype.nextChar = function(chars) {
        if (chars === void 0) chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
        return chars.substr(this.nextInt(0, chars.length - 1), 1);
    };
    /**
     * Picks a pseudo-random item from an array. The array is left unmodified.
     *
     * Note: keep in mind that while the returned item will be random enough, picking one item from the array at a time
     * does not guarantee nor imply that a sequence of random non-repeating items will be picked. If you want to
     * *pick items in a random order* from an array, instead of *pick one random item from an array*, it's best to
     * apply a *shuffle* transformation to the array instead, then read it linearly.
     *
     * @param array - Array of any type containing one or more candidates for random picking.
     * @return An item from the array.
     */ Prando.prototype.nextArrayItem = function(array) {
        return array[this.nextInt(0, array.length - 1)];
    };
    /**
     * Generates a pseudo-random boolean.
     *
     * @return A value of true or false.
     */ Prando.prototype.nextBoolean = function() {
        this.recalculate();
        return this._value > 0.5;
    };
    /**
     * Skips ahead in the sequence of numbers that are being generated. This is equivalent to
     * calling next() a specified number of times, but faster since it doesn't need to map the
     * new random numbers to a range and return it.
     *
     * @param iterations - The number of items to skip ahead.
     */ Prando.prototype.skip = function(iterations) {
        if (iterations === void 0) iterations = 1;
        while(iterations-- > 0)this.recalculate();
    };
    /**
     * Reset the pseudo-random number sequence back to its starting seed. Further calls to next()
     * will then produce the same sequence of numbers it had produced before. This is equivalent to
     * creating a new Prando instance with the same seed as another Prando instance.
     *
     * Example:
     * let rng = new Prando(12345678);
     * console.log(rng.next()); // 0.6177754114889017
     * console.log(rng.next()); // 0.5784605181725837
     * rng.reset();
     * console.log(rng.next()); // 0.6177754114889017 again
     * console.log(rng.next()); // 0.5784605181725837 again
     */ Prando.prototype.reset = function() {
        this._value = this._seed;
    };
    // ================================================================================================================
    // PRIVATE INTERFACE ----------------------------------------------------------------------------------------------
    Prando.prototype.recalculate = function() {
        this._value = this.xorshift(this._value);
    };
    Prando.prototype.xorshift = function(value) {
        // Xorshift*32
        // Based on George Marsaglia's work: http://www.jstatsoft.org/v08/i14/paper
        value ^= value << 13;
        value ^= value >> 17;
        value ^= value << 5;
        return value;
    };
    Prando.prototype.map = function(val, minFrom, maxFrom, minTo, maxTo) {
        return (val - minFrom) / (maxFrom - minFrom) * (maxTo - minTo) + minTo;
    };
    Prando.prototype.hashCode = function(str) {
        var hash = 0;
        if (str) {
            var l = str.length;
            for(var i = 0; i < l; i++){
                hash = (hash << 5) - hash + str.charCodeAt(i);
                hash |= 0;
                hash = this.xorshift(hash);
            }
        }
        return this.getSafeSeed(hash);
    };
    Prando.prototype.getSafeSeed = function(seed) {
        if (seed === 0) return 1;
        return seed;
    };
    Prando.MIN = -2147483648; // Int32 min
    Prando.MAX = 2147483647; // Int32 max
    return Prando;
}();
var $c852c9d043b7a6f7$export$2e2bcd8739ae039 = $c852c9d043b7a6f7$var$Prando;

});

parcelRegister("5cQqO", function(module, exports) {

$parcel$export(module.exports, "TSQFunction", function () { return $3ca6be865b9092ac$export$f3177a28d7587bca; });
/** Registers a function that is available to TSQ queries. */ function $3ca6be865b9092ac$export$f3177a28d7587bca(f) {
    $3ca6be865b9092ac$export$f3177a28d7587bca.functions.push(f);
}
$3ca6be865b9092ac$export$f3177a28d7587bca.functions = [];

});


parcelRegister("8h5s0", function(module, exports) {

$parcel$export(module.exports, "Assert", function () { return $606423a834dbcee1$export$14647bdf767968d3; });
$parcel$export(module.exports, "prettyCamel", function () { return $606423a834dbcee1$export$d0cc5e3b1954404f; });
$parcel$export(module.exports, "capitalizeFirstLetter", function () { return $606423a834dbcee1$export$d07f57595c356899; });
$parcel$export(module.exports, "lowercaseFirstLetter", function () { return $606423a834dbcee1$export$f08459d87829d2ee; });
$parcel$export(module.exports, "GroupBy", function () { return $606423a834dbcee1$export$9abad2bb8d934a7f; });
$parcel$export(module.exports, "ellipsize", function () { return $606423a834dbcee1$export$e03532b139e1514; });
/* eslint-disable no-useless-escape */ 
var $c3m5j = parcelRequire("c3m5j");

var $hcjDr = parcelRequire("hcjDr");

var $5cQqO = parcelRequire("5cQqO");
function $606423a834dbcee1$export$44418d23d2ff779d(func) {
    const code = func.toString();
    const match = code.startsWith("async function") ? /^async\s*function\s*[^\(]*\(\s*([^\)]*)\)/m : /^function\s*[^\(]*\(\s*([^\)]*)\)/m;
    const m = func.toString().replace(/((\/\/.*$)|(\/\*[\s\S]*?\*\/)|(\s))/gm, "").match(match);
    if (!m) return [];
    return m[1].split(/,/).filter((x)=>x.length).map((x)=>x.split("=")[0]); // Remove default values
}
const $606423a834dbcee1$var$whitelistedCamels = [
    "iOS",
    "undefined",
    "null"
];
function $606423a834dbcee1$export$14647bdf767968d3(value, errorMessage) {
    if (value === undefined) throw new Error(errorMessage !== null && errorMessage !== void 0 ? errorMessage : "Unexpected undefined");
    if (value === null) throw new Error(errorMessage !== null && errorMessage !== void 0 ? errorMessage : "Unexpected null");
    return value;
}
function $606423a834dbcee1$export$469e6493debd2244(pascalStr) {
    return pascalStr.replace(/([A-Z]+)([A-Z][a-z])/g, "$1_$2") // Handle transition from a group of capital letters to a single capital followed by lowercase
    .replace(/([a-z\d])([A-Z])/g, "$1_$2") // Handle transition from lowercase or digits to uppercase
    .toLowerCase(); // Convert the entire string to lowercase
}
async function $606423a834dbcee1$export$a04bb40c982411b3(arr, mapper) {
    const res = [];
    for(let i = 0; i < arr.length; i++)res.push(await mapper(arr[i], i));
    return res;
}
function $606423a834dbcee1$export$d0cc5e3b1954404f(identifier, capitalizeFirstChar = true, count = 1) {
    if (!(typeof identifier === "string")) return identifier;
    if (identifier.indexOf("_") !== -1) return identifier;
    if (identifier.toUpperCase() === identifier) return identifier;
    if ($606423a834dbcee1$var$whitelistedCamels.some((x)=>x === identifier)) return identifier;
    if (identifier.toLowerCase() === "uuid") return "item";
    identifier = identifier.replace("<", " ");
    identifier = identifier.replace(">", "");
    const parts = $606423a834dbcee1$export$d3ee1fc871530e7e(identifier).map((x, i, arr)=>i === arr.length - 1 && count !== 1 ? (0, (/*@__PURE__*/$parcel$interopDefault($c3m5j)))(x) : x).map((x, i)=>i === 0 && capitalizeFirstChar ? $606423a834dbcee1$export$d07f57595c356899(x) : x.toLocaleLowerCase()).map((x)=>{
        const abb = $606423a834dbcee1$export$d0cc5e3b1954404f.abbreviations.find((p)=>x.toLowerCase() === p.toLowerCase());
        if (abb) return abb;
        return x;
    });
    // Replace "Marketing airline i d" -> "Marketing airline ID"
    $606423a834dbcee1$export$d0cc5e3b1954404f.abbreviations.forEach((p)=>{
        for(let i = 0; i < parts.length - p.length + 1; i++){
            let match = true;
            for(let n = 0; n < p.length; n++)if (parts[i + n].toLowerCase() !== p[n].toLowerCase()) {
                match = false;
                break;
            }
            if (match) {
                parts.splice(i + 1, p.length - 1);
                parts[i] = p;
            }
        }
    });
    // Combine two or more individual characters back to uppercase abbreviation
    for(let i = 0; i < parts.length - 1; i++){
        if (parts[i].length === 1) for(let n = i + 1; n < parts.length; n++){
            if (parts[n].length === 1) {
                parts[i] = (parts[i] + parts[n]).toUpperCase();
                parts[n] = "";
            } else break;
        }
    }
    let res = parts.filter((x)=>!!x).join(" ");
    // Revert ugly spaces inserted after parens
    while(res.indexOf("( ") !== -1)res = res.replace("( ", "(");
    return res;
}
/** List of words that prettyCamel should not abbreviate */ $606423a834dbcee1$export$d0cc5e3b1954404f.abbreviations = [
    "ID",
    "API"
];
function $606423a834dbcee1$export$d3ee1fc871530e7e(identifier) {
    return identifier.split(/(?=[A-Z])/);
}
function $606423a834dbcee1$export$cbadc5a7223772a8(e) {
    throw new Error("Unhandled scenario (assertNever failed)");
}
function $606423a834dbcee1$export$d07f57595c356899(s) {
    if (s.length === 0) return s;
    return s[0].toUpperCase() + s.slice(1);
}
function $606423a834dbcee1$export$f08459d87829d2ee(s) {
    if (s.length === 0) return s;
    return s[0].toLowerCase() + s.slice(1);
}
function $606423a834dbcee1$export$ccdcb77276b6f861(arr) {
    return arr.length > 0 ? arr : undefined;
}
function $606423a834dbcee1$export$bffa455ba8c619a6(arr) {
    const res = [];
    arr.forEach((x)=>x instanceof Array ? x.forEach((y)=>res.push(y)) : res.push(x));
    return res;
}
function $606423a834dbcee1$export$5b8affa63fc6df16(arr, mapper) {
    return $606423a834dbcee1$export$bffa455ba8c619a6(arr.map(mapper));
}
function $606423a834dbcee1$export$534760f50726d5(arr) {
    return arr.reduce((a, b)=>a + b, 0);
}
function $606423a834dbcee1$export$bf78489a3eae0c4f(arr, selector) {
    const groups = new Map();
    arr.forEach((item)=>{
        const key = selector(item);
        if (!groups.has(key)) groups.set(key, []);
        $606423a834dbcee1$export$14647bdf767968d3(groups.get(key)).push(item);
    });
    return groups;
}
(0, $5cQqO.TSQFunction)($606423a834dbcee1$export$9abad2bb8d934a7f);
function $606423a834dbcee1$export$9abad2bb8d934a7f(/** The array of items to group */ arr, /** A function that selects the key of the group an item belongs to. */ selector) {
    return Array.from($606423a834dbcee1$export$bf78489a3eae0c4f(arr, selector)).map((e)=>({
            key: e[0],
            values: e[1]
        }));
}
function $606423a834dbcee1$export$ebbdf76816346a18(map, mapper) {
    const res = new Map();
    for (const [key, value] of map)res.set(key, mapper(value, key));
    return res;
}
function $606423a834dbcee1$export$a9ac1ae12bea2213(map) {
    const keys = Array.from(map.keys()).sort((a, b)=>a - b);
    return new Map(keys.map((key)=>[
            key,
            $606423a834dbcee1$export$14647bdf767968d3(map.get(key))
        ]));
}
function $606423a834dbcee1$export$e03532b139e1514(s, maxLength, ellipsis = "...") {
    if (s === undefined) return undefined;
    if (s.length > maxLength) {
        let i = maxLength - ellipsis.length;
        for(; i >= 0; i--){
            if (s[i] === " ") break;
        }
        if (i === 0) i = maxLength - ellipsis.length;
        return s.slice(0, i) + ellipsis;
    }
    return s;
}
function $606423a834dbcee1$export$8960430cfd85939f(arr, score) {
    if (!arr) return undefined;
    if (arr.length === 0) return undefined;
    let maxItem = arr[0];
    let maxValue = score(arr[0]);
    for(let i = 1; i < arr.length; i++){
        const s = score(arr[i]);
        if (s > maxValue) {
            maxValue = s;
            maxItem = arr[i];
        }
    }
    return maxItem;
}
function $606423a834dbcee1$export$96ec731ed4dcb222(arr, score) {
    if (!arr) return undefined;
    if (arr.length === 0) return undefined;
    let minItem = arr[0];
    let minValue = score(arr[0]);
    for(let i = 1; i < arr.length; i++){
        const s = score(arr[i]);
        if (s < minValue) {
            minValue = s;
            minItem = arr[i];
        }
    }
    return minItem;
}
function $606423a834dbcee1$export$62c3ee984ad46566(a, b) {
    return a.every((x)=>b.some((y)=>x === y)) && b.every((x)=>a.some((y)=>x === y));
}
const $606423a834dbcee1$var$rnd = new (0, $hcjDr.default)(3);
function $606423a834dbcee1$export$2e015b6955893291(arr, ...except) {
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition, no-constant-condition
    while(true){
        const i = Math.floor($606423a834dbcee1$var$rnd.next() * arr.length);
        const it = arr[i];
        if (except.indexOf(it) !== -1) continue;
        return it;
    }
}
function $606423a834dbcee1$export$7efad0a738a24e31(arr, metric) {
    let maxValue = Number.NEGATIVE_INFINITY;
    let maxObj;
    arr.forEach((v)=>{
        const value = metric(v);
        if (value > maxValue) {
            maxValue = value;
            maxObj = v;
        }
    });
    return maxObj;
}
function $606423a834dbcee1$export$ac6c6bc5acd809c3(arr, metric) {
    let minValue = Number.POSITIVE_INFINITY;
    let minObj;
    arr.forEach((v)=>{
        const value = metric(v);
        if (minObj === undefined || value < minValue) {
            minValue = value;
            minObj = v;
        }
    });
    return minObj;
}
function $606423a834dbcee1$export$50c379d260c027b9(stringNumber, fmt = new Intl.NumberFormat()) {
    const thousandSeparator = fmt.format(11111).replace(/\p{Number}/gu, "");
    const decimalSeparator = fmt.format(1.1).replace(/\p{Number}/gu, "");
    return parseFloat(stringNumber.replace(new RegExp("\\" + thousandSeparator, "g"), "").replace(new RegExp("\\" + decimalSeparator), "."));
}
function $606423a834dbcee1$export$d02631cccf789723(fromInclusive, toInclusive, mapper) {
    const res = [];
    for(let i = fromInclusive; i <= toInclusive; i++)res.push(mapper(i));
    return res;
}
function $606423a834dbcee1$export$c3dba0d20b1d59bc(oldObj, newObj) {
    const changedFields = new Set();
    for(const key in newObj)if (JSON.stringify(newObj[key]) !== JSON.stringify(oldObj[key])) changedFields.add(key);
    for(const key in oldObj)if (JSON.stringify(newObj[key]) !== JSON.stringify(oldObj[key])) changedFields.add(key);
    return Array.from(changedFields);
}
function $606423a834dbcee1$export$dff351f039ed48c1(a, b) {
    const setB = new Set(b);
    return a.some((item)=>setB.has(item));
}
function $606423a834dbcee1$export$7c73462e0d25e514(func) {
    const cache = new Map();
    return (t)=>{
        if (cache.has(t)) return $606423a834dbcee1$export$14647bdf767968d3(cache.get(t));
        const res = func(t);
        cache.set(t, res);
        return res;
    };
}
function $606423a834dbcee1$export$a9bc1c069e5ad01e(keys, f) {
    const result = {};
    keys.forEach((key, i)=>{
        result[key] = f(key, i);
    });
    return result;
}
function $606423a834dbcee1$export$7a248539063f2353(items, selector) {
    const seen = new Set();
    return items.filter((item)=>{
        const key = selector(item);
        if (seen.has(key)) return false;
        seen.add(key);
        return true;
    });
}
function $606423a834dbcee1$export$5e2528d1ad4fe419(arr) {
    return arr.filter((item, index)=>arr.indexOf(item) === index);
}
function $606423a834dbcee1$export$88ac5871230bca78(value) {
    return value !== null && value !== undefined;
}
async function $606423a834dbcee1$export$db13390dd07e8c87(func, defaultValue) {
    try {
        return {
            result: await func(),
            error: null
        };
    } catch (e) {
        return {
            result: defaultValue,
            error: "detail" in e ? e.detail : "message" in e ? e.message : "Error"
        };
    }
}
function $606423a834dbcee1$export$b624eff549462981(fn) {
    let result;
    return async ()=>{
        if (!result) result = fn();
        return await result;
    };
}
async function $606423a834dbcee1$export$565eb972bac3cbc4(value) {
    if (typeof value === "function") {
        const result = value();
        if (result instanceof Promise) return await result;
        return result;
    } else if (value instanceof Promise) return await value;
    return value;
}
function $606423a834dbcee1$export$dd37ae641335491a(arr, predicate) {
    const index = arr.findIndex(predicate);
    if (index !== -1) return arr.splice(index, 1)[0];
    return undefined;
}

});
parcelRegister("c3m5j", function(module, exports) {
/* global define */ (function(root, pluralize) {
    // Node.
    module.exports = pluralize();
})(module.exports, function() {
    // Rule storage - pluralize and singularize need to be run sequentially,
    // while other rules can be optimized using an object for instant lookups.
    var pluralRules = [];
    var singularRules = [];
    var uncountables = {};
    var irregularPlurals = {};
    var irregularSingles = {};
    /**
   * Sanitize a pluralization rule to a usable regular expression.
   *
   * @param  {(RegExp|string)} rule
   * @return {RegExp}
   */ function sanitizeRule(rule) {
        if (typeof rule === "string") return new RegExp("^" + rule + "$", "i");
        return rule;
    }
    /**
   * Pass in a word token to produce a function that can replicate the case on
   * another word.
   *
   * @param  {string}   word
   * @param  {string}   token
   * @return {Function}
   */ function restoreCase(word, token) {
        // Tokens are an exact match.
        if (word === token) return token;
        // Lower cased words. E.g. "hello".
        if (word === word.toLowerCase()) return token.toLowerCase();
        // Upper cased words. E.g. "WHISKY".
        if (word === word.toUpperCase()) return token.toUpperCase();
        // Title cased words. E.g. "Title".
        if (word[0] === word[0].toUpperCase()) return token.charAt(0).toUpperCase() + token.substr(1).toLowerCase();
        // Lower cased words. E.g. "test".
        return token.toLowerCase();
    }
    /**
   * Interpolate a regexp string.
   *
   * @param  {string} str
   * @param  {Array}  args
   * @return {string}
   */ function interpolate(str, args) {
        return str.replace(/\$(\d{1,2})/g, function(match, index) {
            return args[index] || "";
        });
    }
    /**
   * Replace a word using a rule.
   *
   * @param  {string} word
   * @param  {Array}  rule
   * @return {string}
   */ function replace(word, rule) {
        return word.replace(rule[0], function(match, index) {
            var result = interpolate(rule[1], arguments);
            if (match === "") return restoreCase(word[index - 1], result);
            return restoreCase(match, result);
        });
    }
    /**
   * Sanitize a word by passing in the word and sanitization rules.
   *
   * @param  {string}   token
   * @param  {string}   word
   * @param  {Array}    rules
   * @return {string}
   */ function sanitizeWord(token, word, rules) {
        // Empty string or doesn't need fixing.
        if (!token.length || uncountables.hasOwnProperty(token)) return word;
        var len = rules.length;
        // Iterate over the sanitization rules and use the first one to match.
        while(len--){
            var rule = rules[len];
            if (rule[0].test(word)) return replace(word, rule);
        }
        return word;
    }
    /**
   * Replace a word with the updated word.
   *
   * @param  {Object}   replaceMap
   * @param  {Object}   keepMap
   * @param  {Array}    rules
   * @return {Function}
   */ function replaceWord(replaceMap, keepMap, rules) {
        return function(word) {
            // Get the correct token and case restoration functions.
            var token = word.toLowerCase();
            // Check against the keep object map.
            if (keepMap.hasOwnProperty(token)) return restoreCase(word, token);
            // Check against the replacement map for a direct word replacement.
            if (replaceMap.hasOwnProperty(token)) return restoreCase(word, replaceMap[token]);
            // Run all the rules against the word.
            return sanitizeWord(token, word, rules);
        };
    }
    /**
   * Check if a word is part of the map.
   */ function checkWord(replaceMap, keepMap, rules, bool) {
        return function(word) {
            var token = word.toLowerCase();
            if (keepMap.hasOwnProperty(token)) return true;
            if (replaceMap.hasOwnProperty(token)) return false;
            return sanitizeWord(token, token, rules) === token;
        };
    }
    /**
   * Pluralize or singularize a word based on the passed in count.
   *
   * @param  {string}  word      The word to pluralize
   * @param  {number}  count     How many of the word exist
   * @param  {boolean} inclusive Whether to prefix with the number (e.g. 3 ducks)
   * @return {string}
   */ function pluralize(word, count, inclusive) {
        var pluralized = count === 1 ? pluralize.singular(word) : pluralize.plural(word);
        return (inclusive ? count + " " : "") + pluralized;
    }
    /**
   * Pluralize a word.
   *
   * @type {Function}
   */ pluralize.plural = replaceWord(irregularSingles, irregularPlurals, pluralRules);
    /**
   * Check if a word is plural.
   *
   * @type {Function}
   */ pluralize.isPlural = checkWord(irregularSingles, irregularPlurals, pluralRules);
    /**
   * Singularize a word.
   *
   * @type {Function}
   */ pluralize.singular = replaceWord(irregularPlurals, irregularSingles, singularRules);
    /**
   * Check if a word is singular.
   *
   * @type {Function}
   */ pluralize.isSingular = checkWord(irregularPlurals, irregularSingles, singularRules);
    /**
   * Add a pluralization rule to the collection.
   *
   * @param {(string|RegExp)} rule
   * @param {string}          replacement
   */ pluralize.addPluralRule = function(rule, replacement) {
        pluralRules.push([
            sanitizeRule(rule),
            replacement
        ]);
    };
    /**
   * Add a singularization rule to the collection.
   *
   * @param {(string|RegExp)} rule
   * @param {string}          replacement
   */ pluralize.addSingularRule = function(rule, replacement) {
        singularRules.push([
            sanitizeRule(rule),
            replacement
        ]);
    };
    /**
   * Add an uncountable word rule.
   *
   * @param {(string|RegExp)} word
   */ pluralize.addUncountableRule = function(word) {
        if (typeof word === "string") {
            uncountables[word.toLowerCase()] = true;
            return;
        }
        // Set singular and plural references for the word.
        pluralize.addPluralRule(word, "$0");
        pluralize.addSingularRule(word, "$0");
    };
    /**
   * Add an irregular word definition.
   *
   * @param {string} single
   * @param {string} plural
   */ pluralize.addIrregularRule = function(single, plural) {
        plural = plural.toLowerCase();
        single = single.toLowerCase();
        irregularSingles[single] = plural;
        irregularPlurals[plural] = single;
    };
    /**
   * Irregular rules.
   */ [
        // Pronouns.
        [
            "I",
            "we"
        ],
        [
            "me",
            "us"
        ],
        [
            "he",
            "they"
        ],
        [
            "she",
            "they"
        ],
        [
            "them",
            "them"
        ],
        [
            "myself",
            "ourselves"
        ],
        [
            "yourself",
            "yourselves"
        ],
        [
            "itself",
            "themselves"
        ],
        [
            "herself",
            "themselves"
        ],
        [
            "himself",
            "themselves"
        ],
        [
            "themself",
            "themselves"
        ],
        [
            "is",
            "are"
        ],
        [
            "was",
            "were"
        ],
        [
            "has",
            "have"
        ],
        [
            "this",
            "these"
        ],
        [
            "that",
            "those"
        ],
        // Words ending in with a consonant and `o`.
        [
            "echo",
            "echoes"
        ],
        [
            "dingo",
            "dingoes"
        ],
        [
            "volcano",
            "volcanoes"
        ],
        [
            "tornado",
            "tornadoes"
        ],
        [
            "torpedo",
            "torpedoes"
        ],
        // Ends with `us`.
        [
            "genus",
            "genera"
        ],
        [
            "viscus",
            "viscera"
        ],
        // Ends with `ma`.
        [
            "stigma",
            "stigmata"
        ],
        [
            "stoma",
            "stomata"
        ],
        [
            "dogma",
            "dogmata"
        ],
        [
            "lemma",
            "lemmata"
        ],
        [
            "schema",
            "schemata"
        ],
        [
            "anathema",
            "anathemata"
        ],
        // Other irregular rules.
        [
            "ox",
            "oxen"
        ],
        [
            "axe",
            "axes"
        ],
        [
            "die",
            "dice"
        ],
        [
            "yes",
            "yeses"
        ],
        [
            "foot",
            "feet"
        ],
        [
            "eave",
            "eaves"
        ],
        [
            "goose",
            "geese"
        ],
        [
            "tooth",
            "teeth"
        ],
        [
            "quiz",
            "quizzes"
        ],
        [
            "human",
            "humans"
        ],
        [
            "proof",
            "proofs"
        ],
        [
            "carve",
            "carves"
        ],
        [
            "valve",
            "valves"
        ],
        [
            "looey",
            "looies"
        ],
        [
            "thief",
            "thieves"
        ],
        [
            "groove",
            "grooves"
        ],
        [
            "pickaxe",
            "pickaxes"
        ],
        [
            "passerby",
            "passersby"
        ]
    ].forEach(function(rule) {
        return pluralize.addIrregularRule(rule[0], rule[1]);
    });
    /**
   * Pluralization rules.
   */ [
        [
            /s?$/i,
            "s"
        ],
        [
            /[^\u0000-\u007F]$/i,
            "$0"
        ],
        [
            /([^aeiou]ese)$/i,
            "$1"
        ],
        [
            /(ax|test)is$/i,
            "$1es"
        ],
        [
            /(alias|[^aou]us|t[lm]as|gas|ris)$/i,
            "$1es"
        ],
        [
            /(e[mn]u)s?$/i,
            "$1s"
        ],
        [
            /([^l]ias|[aeiou]las|[ejzr]as|[iu]am)$/i,
            "$1"
        ],
        [
            /(alumn|syllab|vir|radi|nucle|fung|cact|stimul|termin|bacill|foc|uter|loc|strat)(?:us|i)$/i,
            "$1i"
        ],
        [
            /(alumn|alg|vertebr)(?:a|ae)$/i,
            "$1ae"
        ],
        [
            /(seraph|cherub)(?:im)?$/i,
            "$1im"
        ],
        [
            /(her|at|gr)o$/i,
            "$1oes"
        ],
        [
            /(agend|addend|millenni|dat|extrem|bacteri|desiderat|strat|candelabr|errat|ov|symposi|curricul|automat|quor)(?:a|um)$/i,
            "$1a"
        ],
        [
            /(apheli|hyperbat|periheli|asyndet|noumen|phenomen|criteri|organ|prolegomen|hedr|automat)(?:a|on)$/i,
            "$1a"
        ],
        [
            /sis$/i,
            "ses"
        ],
        [
            /(?:(kni|wi|li)fe|(ar|l|ea|eo|oa|hoo)f)$/i,
            "$1$2ves"
        ],
        [
            /([^aeiouy]|qu)y$/i,
            "$1ies"
        ],
        [
            /([^ch][ieo][ln])ey$/i,
            "$1ies"
        ],
        [
            /(x|ch|ss|sh|zz)$/i,
            "$1es"
        ],
        [
            /(matr|cod|mur|sil|vert|ind|append)(?:ix|ex)$/i,
            "$1ices"
        ],
        [
            /\b((?:tit)?m|l)(?:ice|ouse)$/i,
            "$1ice"
        ],
        [
            /(pe)(?:rson|ople)$/i,
            "$1ople"
        ],
        [
            /(child)(?:ren)?$/i,
            "$1ren"
        ],
        [
            /eaux$/i,
            "$0"
        ],
        [
            /m[ae]n$/i,
            "men"
        ],
        [
            "thou",
            "you"
        ]
    ].forEach(function(rule) {
        return pluralize.addPluralRule(rule[0], rule[1]);
    });
    /**
   * Singularization rules.
   */ [
        [
            /s$/i,
            ""
        ],
        [
            /(ss)$/i,
            "$1"
        ],
        [
            /(wi|kni|(?:after|half|high|low|mid|non|night|[^\w]|^)li)ves$/i,
            "$1fe"
        ],
        [
            /(ar|(?:wo|[ae])l|[eo][ao])ves$/i,
            "$1f"
        ],
        [
            /ies$/i,
            "y"
        ],
        [
            /\b([pl]|zomb|(?:neck|cross)?t|coll|faer|food|gen|goon|group|lass|talk|goal|cut)ies$/i,
            "$1ie"
        ],
        [
            /\b(mon|smil)ies$/i,
            "$1ey"
        ],
        [
            /\b((?:tit)?m|l)ice$/i,
            "$1ouse"
        ],
        [
            /(seraph|cherub)im$/i,
            "$1"
        ],
        [
            /(x|ch|ss|sh|zz|tto|go|cho|alias|[^aou]us|t[lm]as|gas|(?:her|at|gr)o|[aeiou]ris)(?:es)?$/i,
            "$1"
        ],
        [
            /(analy|diagno|parenthe|progno|synop|the|empha|cri|ne)(?:sis|ses)$/i,
            "$1sis"
        ],
        [
            /(movie|twelve|abuse|e[mn]u)s$/i,
            "$1"
        ],
        [
            /(test)(?:is|es)$/i,
            "$1is"
        ],
        [
            /(alumn|syllab|vir|radi|nucle|fung|cact|stimul|termin|bacill|foc|uter|loc|strat)(?:us|i)$/i,
            "$1us"
        ],
        [
            /(agend|addend|millenni|dat|extrem|bacteri|desiderat|strat|candelabr|errat|ov|symposi|curricul|quor)a$/i,
            "$1um"
        ],
        [
            /(apheli|hyperbat|periheli|asyndet|noumen|phenomen|criteri|organ|prolegomen|hedr|automat)a$/i,
            "$1on"
        ],
        [
            /(alumn|alg|vertebr)ae$/i,
            "$1a"
        ],
        [
            /(cod|mur|sil|vert|ind)ices$/i,
            "$1ex"
        ],
        [
            /(matr|append)ices$/i,
            "$1ix"
        ],
        [
            /(pe)(rson|ople)$/i,
            "$1rson"
        ],
        [
            /(child)ren$/i,
            "$1"
        ],
        [
            /(eau)x?$/i,
            "$1"
        ],
        [
            /men$/i,
            "man"
        ]
    ].forEach(function(rule) {
        return pluralize.addSingularRule(rule[0], rule[1]);
    });
    /**
   * Uncountable rules.
   */ [
        // Singular words with no plurals.
        "adulthood",
        "advice",
        "agenda",
        "aid",
        "aircraft",
        "alcohol",
        "ammo",
        "analytics",
        "anime",
        "athletics",
        "audio",
        "bison",
        "blood",
        "bream",
        "buffalo",
        "butter",
        "carp",
        "cash",
        "chassis",
        "chess",
        "clothing",
        "cod",
        "commerce",
        "cooperation",
        "corps",
        "debris",
        "diabetes",
        "digestion",
        "elk",
        "energy",
        "equipment",
        "excretion",
        "expertise",
        "firmware",
        "flounder",
        "fun",
        "gallows",
        "garbage",
        "graffiti",
        "hardware",
        "headquarters",
        "health",
        "herpes",
        "highjinks",
        "homework",
        "housework",
        "information",
        "jeans",
        "justice",
        "kudos",
        "labour",
        "literature",
        "machinery",
        "mackerel",
        "mail",
        "media",
        "mews",
        "moose",
        "music",
        "mud",
        "manga",
        "news",
        "only",
        "personnel",
        "pike",
        "plankton",
        "pliers",
        "police",
        "pollution",
        "premises",
        "rain",
        "research",
        "rice",
        "salmon",
        "scissors",
        "series",
        "sewage",
        "shambles",
        "shrimp",
        "software",
        "species",
        "staff",
        "swine",
        "tennis",
        "traffic",
        "transportation",
        "trout",
        "tuna",
        "wealth",
        "welfare",
        "whiting",
        "wildebeest",
        "wildlife",
        "you",
        /pok[eé]mon$/i,
        // Regexes.
        /[^aeiou]ese$/i,
        /deer$/i,
        /fish$/i,
        /measles$/i,
        /o[iu]s$/i,
        /pox$/i,
        /sheep$/i
    ].forEach(pluralize.addUncountableRule);
    return pluralize;
});

});


parcelRegister("3Ixuz", function(module, exports) {

$parcel$export(module.exports, "IsResourceNotificationType", function () { return $2b4f76025d36422c$export$643acd4da4561ce5; });
function $2b4f76025d36422c$export$643acd4da4561ce5(value) {
    return value === "change" || value === "discard" || value === "save";
}

});

parcelRegister("dUDPg", function(module, exports) {

$parcel$export(module.exports, "defaults", function () { return $a20f65ece6f6f454$export$ebe90cb607ad99e; });
$parcel$export(module.exports, "useDocumentObjectView", function () { return $a20f65ece6f6f454$export$6a6cde42dd9bf447; });
$parcel$export(module.exports, "useDocumentPropertyDeclarations", function () { return $a20f65ece6f6f454$export$a816c83cbfb18789; });
$parcel$export(module.exports, "postDocument", function () { return $a20f65ece6f6f454$export$3b85aa17d6c57f74; });
$parcel$export(module.exports, "postDocumentConfirmChanges", function () { return $a20f65ece6f6f454$export$8da18fb561862be0; });
$parcel$export(module.exports, "putDocument", function () { return $a20f65ece6f6f454$export$7cf35861e381352b; });
$parcel$export(module.exports, "useDocumentDiagnostics", function () { return $a20f65ece6f6f454$export$1bc5ec7bfd5c9048; });
$parcel$export(module.exports, "postDocumentRefresh", function () { return $a20f65ece6f6f454$export$8dfc238869663a5d; });
$parcel$export(module.exports, "useTemplates", function () { return $a20f65ece6f6f454$export$b0a9bce6cbec665b; });
$parcel$export(module.exports, "getStudioTemplate", function () { return $a20f65ece6f6f454$export$1b1a0d390a43af65; });
$parcel$export(module.exports, "postDocumentsFromTemplate", function () { return $a20f65ece6f6f454$export$a59e203e92242e87; });
$parcel$export(module.exports, "getNewDocumentFromExisting", function () { return $a20f65ece6f6f454$export$258c0bbb24fa819f; });
$parcel$export(module.exports, "postStudioTableFilter", function () { return $a20f65ece6f6f454$export$981017dc9445d28e; });
$parcel$export(module.exports, "putStudioTableFilter", function () { return $a20f65ece6f6f454$export$fbbdbc148ab47d31; });
$parcel$export(module.exports, "deleteStudioTableFilter", function () { return $a20f65ece6f6f454$export$f4ec934196d58832; });
$parcel$export(module.exports, "useStudioTableFilterDeclarationsEndpoint", function () { return $a20f65ece6f6f454$export$e7914309dfc0a298; });
$parcel$export(module.exports, "useStudioTableColumnFilterOptions", function () { return $a20f65ece6f6f454$export$498c8bb99019344; });
$parcel$export(module.exports, "postWidget", function () { return $a20f65ece6f6f454$export$e6838830449d2b12; });
$parcel$export(module.exports, "postWidgetAction", function () { return $a20f65ece6f6f454$export$5c0787df35a2fdb1; });
$parcel$export(module.exports, "useReactorMe", function () { return $a20f65ece6f6f454$export$41d666a5186a022a; });
$parcel$export(module.exports, "getWebSocketTicketForStudioUser", function () { return $a20f65ece6f6f454$export$142990fa462ec747; });
$parcel$export(module.exports, "putCookieConsents", function () { return $a20f65ece6f6f454$export$f60be4ab695c738e; });
$parcel$export(module.exports, "useCookieConsents", function () { return $a20f65ece6f6f454$export$a75ab29ac3c01498; });
$parcel$export(module.exports, "usePaymentStatus", function () { return $a20f65ece6f6f454$export$e4818e90429e9873; });
$parcel$export(module.exports, "useMerchantConfig", function () { return $a20f65ece6f6f454$export$45f530d069573b0d; });
$parcel$export(module.exports, "getPaymentMethods", function () { return $a20f65ece6f6f454$export$ba33f6d94de735b7; });
$parcel$export(module.exports, "postPayment", function () { return $a20f65ece6f6f454$export$9f2dfacdd421cd58; });
$parcel$export(module.exports, "postAdditionalDetails", function () { return $a20f65ece6f6f454$export$34c8eb16ae69fac8; });
$parcel$export(module.exports, "useProgressOperations", function () { return $a20f65ece6f6f454$export$45aefb6aa6313e9d; });
$parcel$export(module.exports, "deleteProgressOperation", function () { return $a20f65ece6f6f454$export$e12eab7db05d8979; });
$parcel$export(module.exports, "getFileInfo", function () { return $a20f65ece6f6f454$export$ca39f27fe4f7d9b4; });
$parcel$export(module.exports, "useFileInfo", function () { return $a20f65ece6f6f454$export$ee3c5c6f3f6d9ce2; });
$parcel$export(module.exports, "useStudioConsoleDeclarations", function () { return $a20f65ece6f6f454$export$fd5972893db4924a; });
$parcel$export(module.exports, "getStudioConsoleQuery", function () { return $a20f65ece6f6f454$export$a143c71caaab659; });
$parcel$export(module.exports, "postStudioConsoleQuery", function () { return $a20f65ece6f6f454$export$95c87f0e34c00a63; });
$parcel$export(module.exports, "postStudioConsoleQueryAction", function () { return $a20f65ece6f6f454$export$f96fb6f422ff336b; });
$parcel$export(module.exports, "postStudioPage", function () { return $a20f65ece6f6f454$export$e80bf8f4e06e76c; });
$parcel$export(module.exports, "postStudioPageAction", function () { return $a20f65ece6f6f454$export$8cdaf2e04bd1ce99; });
$parcel$export(module.exports, "putUserDefinedStudioPageCode", function () { return $a20f65ece6f6f454$export$89b5f5edc5db8ed2; });
$parcel$export(module.exports, "postDocumentPage", function () { return $a20f65ece6f6f454$export$9c07cfba7c1404f6; });
$parcel$export(module.exports, "useDocumentPage", function () { return $a20f65ece6f6f454$export$d8eb8c32826d9d8c; });
$parcel$export(module.exports, "postDocumentPageAction", function () { return $a20f65ece6f6f454$export$515f69f88088292f; });
$parcel$export(module.exports, "postDocumentDefaults", function () { return $a20f65ece6f6f454$export$186ce115a6f7851; });
$parcel$export(module.exports, "getReflection", function () { return $a20f65ece6f6f454$export$6c3e17132cc7c4b8; });
$parcel$export(module.exports, "useReflection", function () { return $a20f65ece6f6f454$export$f2693381791b225e; });
$parcel$export(module.exports, "useLocales", function () { return $a20f65ece6f6f454$export$7a920adec6f03cb7; });
$parcel$export(module.exports, "useDefaultLocale", function () { return $a20f65ece6f6f454$export$188ec29ebc2bdc3a; });
$parcel$export(module.exports, "useEditingTemplates", function () { return $a20f65ece6f6f454$export$3eb16646ca00f6c; });
$parcel$export(module.exports, "postEditingTemplate", function () { return $a20f65ece6f6f454$export$198d5e39b005a16f; });
$parcel$export(module.exports, "deleteEditingTemplate", function () { return $a20f65ece6f6f454$export$65d34dfbfc97ca7a; });
$parcel$export(module.exports, "postDatasetPartialPreview", function () { return $a20f65ece6f6f454$export$23c2cc16f804b25e; });
$parcel$export(module.exports, "postDatasetPartial", function () { return $a20f65ece6f6f454$export$c9f7c31b8b787c73; });
$parcel$export(module.exports, "useDatasetPartialStatus", function () { return $a20f65ece6f6f454$export$35b55dc3a8d2f44d; });
$parcel$export(module.exports, "postStudioTranslate", function () { return $a20f65ece6f6f454$export$2d8285d5bfbc57d6; });
$parcel$export(module.exports, "useMarkdownSnippet", function () { return $a20f65ece6f6f454$export$e1cb49632f1ee55f; });
$parcel$export(module.exports, "useStudioMenu", function () { return $a20f65ece6f6f454$export$61f5615d8059000; });
$parcel$export(module.exports, "putStudioMenuScope", function () { return $a20f65ece6f6f454$export$709d2a12f20d6799; });
$parcel$export(module.exports, "getPrimaryDataset", function () { return $a20f65ece6f6f454$export$84b2c1392edca245; });
$parcel$export(module.exports, "useDocumentEvents", function () { return $a20f65ece6f6f454$export$2395466cf3e3814b; });
$parcel$export(module.exports, "useStudioGlobalSearch", function () { return $a20f65ece6f6f454$export$c9b41d9889d33da1; });
$parcel$export(module.exports, "useStudioToasts", function () { return $a20f65ece6f6f454$export$99a23bc3fc1572fe; });
$parcel$export(module.exports, "deleteStudioToast", function () { return $a20f65ece6f6f454$export$1cc30c8a3cedab1a; });
$parcel$export(module.exports, "useAnalyticsEventStatus", function () { return $a20f65ece6f6f454$export$d7b1b5e2e146ee6e; });
$parcel$export(module.exports, "postAnalyticsEvent", function () { return $a20f65ece6f6f454$export$66670472b5285f48; });
$parcel$export(module.exports, "useSharedWidget", function () { return $a20f65ece6f6f454$export$5b5e67ffcf2ba41e; });
$parcel$export(module.exports, "getLayerUpdates", function () { return $a20f65ece6f6f454$export$4ec870344b7001ea; });
$parcel$export(module.exports, "postLayerUpdates", function () { return $a20f65ece6f6f454$export$3ba7ff34a452fa58; });
$parcel$export(module.exports, "discardLayerUpdates", function () { return $a20f65ece6f6f454$export$f758c4a492381d2; });
$parcel$export(module.exports, "useWebPage", function () { return $a20f65ece6f6f454$export$29c54f290673783c; });
$parcel$export(module.exports, "useWebPageInfo", function () { return $a20f65ece6f6f454$export$93409be67e487a17; });
$parcel$export(module.exports, "useWebPagesInfos", function () { return $a20f65ece6f6f454$export$e1cdd2f33e255b36; });
$parcel$export(module.exports, "useWebPermissions", function () { return $a20f65ece6f6f454$export$9516c399ad75603f; });
$parcel$export(module.exports, "useColorStyles", function () { return $a20f65ece6f6f454$export$2b7a08e331403047; });

var $8jB4x = parcelRequire("8jB4x");

var $7m9cQ = parcelRequire("7m9cQ");
var $a20f65ece6f6f454$var$__await = undefined && undefined.__await || function(v) {
    return this instanceof $a20f65ece6f6f454$var$__await ? (this.v = v, this) : new $a20f65ece6f6f454$var$__await(v);
};
var $a20f65ece6f6f454$var$__asyncGenerator = undefined && undefined.__asyncGenerator || function(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $a20f65ece6f6f454$var$__await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
};
const $a20f65ece6f6f454$export$ebe90cb607ad99e = {
    baseUrl: (0, $7m9cQ.server)(),
    fetch (input, init) {
        // fetch() really wants to be called like this, treating it as a
        // value won't work
        return fetch(input, init);
    },
    headers: {
        "Content-Type": "application/json"
    }
};
// Creates an adapter so browser and node streams can be used interchangeably
function $a20f65ece6f6f454$var$readStream(stream) {
    return $a20f65ece6f6f454$var$__asyncGenerator(this, arguments, function* readStream_1() {
        const reader = stream.getReader();
        while(true){
            const { done: done, value: value } = yield $a20f65ece6f6f454$var$__await(reader.read());
            if (done) break;
            yield yield $a20f65ece6f6f454$var$__await(value);
        }
    });
}
/** Computes display views for the given objects, for use in studio. */ (0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "postDocumentObjectView",
    func: $a20f65ece6f6f454$export$58aa662497f7fe86
});
async function $a20f65ece6f6f454$export$58aa662497f7fe86(body, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/studio/document/object/views`, {
            method: "post",
            headers: headers,
            body: JSON.stringify(body)
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
function $a20f65ece6f6f454$export$64e2f73ebddf87ab(e) {
    return e && typeof e === "object" && "type" in e && e.type === "BadRequest";
}
const $a20f65ece6f6f454$export$6a6cde42dd9bf447 = (0, $8jB4x.SSRHook)("postDocumentObjectView", "PostDocumentObjectViewDto", undefined, $a20f65ece6f6f454$export$58aa662497f7fe86, [
    "body"
], undefined);
/** Populates an object of a specific type with defaults, according to the model.

 Returns the object with defaults populated. */ (0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "postDocumentObjectDefaults",
    func: $a20f65ece6f6f454$export$d8e75982836b0d
});
async function $a20f65ece6f6f454$export$d8e75982836b0d(body, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/studio/document/object/defaults`, {
            method: "post",
            headers: headers,
            body: JSON.stringify(body)
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
function $a20f65ece6f6f454$export$78d2712e15bbab27(e) {
    return e && typeof e === "object" && "type" in e && e.type === "BadRequest";
}
/** Computes declarations for script properties. */ (0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "postDocumentPropertyDeclarations",
    func: $a20f65ece6f6f454$export$afd0bb72d6729fd8
});
async function $a20f65ece6f6f454$export$afd0bb72d6729fd8(body, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/studio/document/property/declarations`, {
            method: "post",
            headers: headers,
            body: JSON.stringify(body)
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
const $a20f65ece6f6f454$export$a816c83cbfb18789 = (0, $8jB4x.SSRHook)("postDocumentPropertyDeclarations", "PostDocumentPropertyDeclarationsDto", undefined, $a20f65ece6f6f454$export$afd0bb72d6729fd8, [
    "body"
], undefined);
(0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "getDocumentsCount",
    func: $a20f65ece6f6f454$export$ee723413f2516051
});
async function $a20f65ece6f6f454$export$ee723413f2516051(collection, filter, search, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const queryArgs = [];
        if (collection !== undefined) queryArgs.push("collection=" + encodeURIComponent(collection.valueOf()));
        if (filter !== undefined) queryArgs.push("filter=" + encodeURIComponent(filter.valueOf()));
        if (search !== undefined) queryArgs.push("search=" + encodeURIComponent(search.valueOf()));
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/studio/documents/count${queryArgs.length ? "?" + queryArgs.join("&") : ""}`, {
            method: "get",
            headers: headers
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
function $a20f65ece6f6f454$export$8c53b5022fe3515c(e) {
    return e && typeof e === "object" && "type" in e && e.type === "BadRequest";
}
const $a20f65ece6f6f454$export$ee196065a6aa3eab = (0, $8jB4x.SSRHook)("getDocumentsCount", undefined, undefined, $a20f65ece6f6f454$export$ee723413f2516051, [
    "collection",
    "filter",
    "search"
], undefined);
/** Adds a new document to the given collection. */ (0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "postDocument",
    func: $a20f65ece6f6f454$export$3b85aa17d6c57f74
});
async function $a20f65ece6f6f454$export$3b85aa17d6c57f74(collection, body, allowErrors, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const queryArgs = [];
        if (collection !== undefined) queryArgs.push("collection=" + encodeURIComponent(collection.valueOf()));
        if (allowErrors !== undefined) queryArgs.push("allowErrors=" + encodeURIComponent(allowErrors.valueOf()));
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/studio/document${queryArgs.length ? "?" + queryArgs.join("&") : ""}`, {
            method: "post",
            headers: headers,
            body: JSON.stringify(body)
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
function $a20f65ece6f6f454$export$c7bae2476b61dc57(e) {
    return e && typeof e === "object" && "type" in e && (e.type === "BadRequest" || e.type === "Forbidden");
}
(0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "deleteDocument",
    func: $a20f65ece6f6f454$export$c00c16979ce15b0f
});
async function $a20f65ece6f6f454$export$c00c16979ce15b0f(collection, primaryKey, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const queryArgs = [];
        if (collection !== undefined) queryArgs.push("collection=" + encodeURIComponent(collection.valueOf()));
        if (primaryKey !== undefined) queryArgs.push("primaryKey=" + encodeURIComponent(primaryKey.valueOf()));
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/studio/document${queryArgs.length ? "?" + queryArgs.join("&") : ""}`, {
            method: "delete",
            headers: headers
        });
        if (_res.status >= 200 && _res.status <= 299) return;
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
function $a20f65ece6f6f454$export$2a5d23346e716200(e) {
    return e && typeof e === "object" && "type" in e && (e.type === "BadRequest" || e.type === "Forbidden");
}
/** Returns confirm change modals that the user must confirm prior to saving
 (PUT'ing) the document. */ (0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "postDocumentConfirmChanges",
    func: $a20f65ece6f6f454$export$8da18fb561862be0
});
async function $a20f65ece6f6f454$export$8da18fb561862be0(collection, primaryKey, body, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const queryArgs = [];
        if (collection !== undefined) queryArgs.push("collection=" + encodeURIComponent(collection.valueOf()));
        if (primaryKey !== undefined) queryArgs.push("primaryKey=" + encodeURIComponent(primaryKey.valueOf()));
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/studio/document/confirmChanges${queryArgs.length ? "?" + queryArgs.join("&") : ""}`, {
            method: "post",
            headers: headers,
            body: JSON.stringify(body)
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
/** Replaces an entire document. */ (0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "putDocument",
    func: $a20f65ece6f6f454$export$7cf35861e381352b
});
async function $a20f65ece6f6f454$export$7cf35861e381352b(collection, primaryKey, body, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/studio/document/${collection}/${primaryKey}`, {
            method: "put",
            headers: headers,
            body: JSON.stringify(body)
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
function $a20f65ece6f6f454$export$c30362b6f60aba56(e) {
    return e && typeof e === "object" && "type" in e && (e.type === "Conflict" || e.type === "BadRequest" || e.type === "Forbidden");
}
/** Retrieves a particular version of a document. */ (0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "getDocument",
    func: $a20f65ece6f6f454$export$f65ca476c09acec0
});
async function $a20f65ece6f6f454$export$f65ca476c09acec0(collection, key, version, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const queryArgs = [];
        if (collection !== undefined) queryArgs.push("collection=" + encodeURIComponent(collection.valueOf()));
        if (key !== undefined) queryArgs.push("key=" + encodeURIComponent(key.valueOf()));
        if (version !== undefined) queryArgs.push("version=" + encodeURIComponent(version.valueOf()));
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/studio/document${queryArgs.length ? "?" + queryArgs.join("&") : ""}`, {
            method: "get",
            headers: headers
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
function $a20f65ece6f6f454$export$fa352028383dc9cb(e) {
    return e && typeof e === "object" && "type" in e && e.type === "BadRequest";
}
const $a20f65ece6f6f454$export$e71e2fb5c5c476d5 = (0, $8jB4x.SSRHook)("getDocument", undefined, undefined, $a20f65ece6f6f454$export$f65ca476c09acec0, [
    "collection",
    "key",
    "version"
], undefined);
(0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "getDocumentDiagnostics",
    func: $a20f65ece6f6f454$export$59ac1a20d548c415
});
async function $a20f65ece6f6f454$export$59ac1a20d548c415(customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/studio/document/diagnostics`, {
            method: "get",
            headers: headers
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
function $a20f65ece6f6f454$export$7a7cbe4edf7d5553(e) {
    return e && typeof e === "object" && "type" in e && e.type === "Unauthorized";
}
const $a20f65ece6f6f454$export$1bc5ec7bfd5c9048 = (0, $8jB4x.SSRHook)("getDocumentDiagnostics", undefined, undefined, $a20f65ece6f6f454$export$59ac1a20d548c415, [], undefined);
(0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "postDocumentRefresh",
    func: $a20f65ece6f6f454$export$8dfc238869663a5d
});
async function $a20f65ece6f6f454$export$8dfc238869663a5d(collection, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const queryArgs = [];
        if (collection !== undefined) queryArgs.push("collection=" + encodeURIComponent(collection.valueOf()));
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/studio/document/refresh${queryArgs.length ? "?" + queryArgs.join("&") : ""}`, {
            method: "post",
            headers: headers
        });
        if (_res.status >= 200 && _res.status <= 299) return;
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
function $a20f65ece6f6f454$export$38f25a68c7c373b7(e) {
    return e && typeof e === "object" && "type" in e && (e.type === "BadRequest" || e.type === "TooManyRequests");
}
/** Returns all available templates that are compatible with a given type name. */ (0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "getTemplates",
    func: $a20f65ece6f6f454$export$2112de27deb5cb2c
});
async function $a20f65ece6f6f454$export$2112de27deb5cb2c(typeName, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/studio/templates/${typeName}/templates`, {
            method: "get",
            headers: headers
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
const $a20f65ece6f6f454$export$b0a9bce6cbec665b = (0, $8jB4x.SSRHook)("getTemplates", "GetTemplatesDto", undefined, $a20f65ece6f6f454$export$2112de27deb5cb2c, [
    "typeName"
], undefined);
/** Returns a new document from a studio template.

If the template belongs to a collection, it will be migrated according to the
rules of the collection.

A new primary key will be generated for the document. It is required that the
type has a UUID primary key.

The document will not be inserted into any collection (yet), but rather
returned for further processing on the client, typically for manual
inspection and editing. */ (0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "getStudioTemplate",
    func: $a20f65ece6f6f454$export$1b1a0d390a43af65
});
async function $a20f65ece6f6f454$export$1b1a0d390a43af65(id, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/studio/templates/${id}`, {
            method: "get",
            headers: headers
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
function $a20f65ece6f6f454$export$d735851e3f60b76d(e) {
    return e && typeof e === "object" && "type" in e && e.type === "BadRequest";
}
const $a20f65ece6f6f454$export$e9c48dce02a15fed = (0, $8jB4x.SSRHook)("getStudioTemplate", undefined, undefined, $a20f65ece6f6f454$export$1b1a0d390a43af65, [
    "id"
], undefined);
/** Creates a batch of template instances a given type and template. */ (0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "postDocumentsFromTemplate",
    func: $a20f65ece6f6f454$export$a59e203e92242e87
});
async function $a20f65ece6f6f454$export$a59e203e92242e87(typeName, templateName, body, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/studio/templates/${typeName}/${templateName}/create`, {
            method: "post",
            headers: headers,
            body: JSON.stringify(body)
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
function $a20f65ece6f6f454$export$3cd43abc16d0dfd(e) {
    return e && typeof e === "object" && "type" in e && (e.type === "NotFound" || e.type === "BadRequest");
}
(0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "getNewDocumentFromExisting",
    func: $a20f65ece6f6f454$export$258c0bbb24fa819f
});
async function $a20f65ece6f6f454$export$258c0bbb24fa819f(collectionName, primaryKey, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/studio/new-from-existing/${collectionName}/${primaryKey}/new`, {
            method: "get",
            headers: headers
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
function $a20f65ece6f6f454$export$22f8ea8a03b5f7d(e) {
    return e && typeof e === "object" && "type" in e && e.type === "NotFound";
}
const $a20f65ece6f6f454$export$87a88f82ac986a50 = (0, $8jB4x.SSRHook)("getNewDocumentFromExisting", undefined, undefined, $a20f65ece6f6f454$export$258c0bbb24fa819f, [
    "collectionName",
    "primaryKey"
], undefined);
(0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "getStudioTableFilters",
    func: $a20f65ece6f6f454$export$ef5a7221fe05434a
});
async function $a20f65ece6f6f454$export$ef5a7221fe05434a(collectionName, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const queryArgs = [];
        if (collectionName !== undefined) queryArgs.push("collectionName=" + encodeURIComponent(collectionName.valueOf()));
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/studio/table-filters${queryArgs.length ? "?" + queryArgs.join("&") : ""}`, {
            method: "get",
            headers: headers
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
function $a20f65ece6f6f454$export$b20a96654acceceb(e) {
    return e && typeof e === "object" && "type" in e && e.type === "NotFound";
}
const $a20f65ece6f6f454$export$7a17b6381dbab7c8 = (0, $8jB4x.SSRHook)("getStudioTableFilters", "ReturnType", undefined, $a20f65ece6f6f454$export$ef5a7221fe05434a, [
    "collectionName"
], undefined);
(0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "postStudioTableFilter",
    func: $a20f65ece6f6f454$export$981017dc9445d28e
});
async function $a20f65ece6f6f454$export$981017dc9445d28e(body, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/studio/table-filters`, {
            method: "post",
            headers: headers,
            body: JSON.stringify(body)
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
function $a20f65ece6f6f454$export$73a91c6b7a0cf856(e) {
    return e && typeof e === "object" && "type" in e && (e.type === "NotFound" || e.type === "Unauthorized" || e.type === "JWTPropertyMissing");
}
(0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "putStudioTableFilter",
    func: $a20f65ece6f6f454$export$fbbdbc148ab47d31
});
async function $a20f65ece6f6f454$export$fbbdbc148ab47d31(id, body, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/studio/table-filters/${id}`, {
            method: "put",
            headers: headers,
            body: JSON.stringify(body)
        });
        if (_res.status >= 200 && _res.status <= 299) return;
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
(0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "deleteStudioTableFilter",
    func: $a20f65ece6f6f454$export$f4ec934196d58832
});
async function $a20f65ece6f6f454$export$f4ec934196d58832(id, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/studio/table-filters/${id}`, {
            method: "delete",
            headers: headers
        });
        if (_res.status >= 200 && _res.status <= 299) return;
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
(0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "getStudioTableFilterDeclarationsEndpoint",
    func: $a20f65ece6f6f454$export$a4eb9a764e2d22d3
});
async function $a20f65ece6f6f454$export$a4eb9a764e2d22d3(collectionName, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const queryArgs = [];
        if (collectionName !== undefined) queryArgs.push("collectionName=" + encodeURIComponent(collectionName.valueOf()));
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/studio/table-filter-declarations${queryArgs.length ? "?" + queryArgs.join("&") : ""}`, {
            method: "get",
            headers: headers
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
function $a20f65ece6f6f454$export$9473cbc40c071bc6(e) {
    return e && typeof e === "object" && "type" in e && (e.type === "NotFound" || e.type === "Forbidden");
}
const $a20f65ece6f6f454$export$e7914309dfc0a298 = (0, $8jB4x.SSRHook)("getStudioTableFilterDeclarationsEndpoint", "GetStudioTableFilterDeclarationsEndpointDto", undefined, $a20f65ece6f6f454$export$a4eb9a764e2d22d3, [
    "collectionName"
], undefined);
(0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "getStudioTableColumns",
    func: $a20f65ece6f6f454$export$9705a41adfab725d
});
async function $a20f65ece6f6f454$export$9705a41adfab725d(collectionName, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const queryArgs = [];
        if (collectionName !== undefined) queryArgs.push("collectionName=" + encodeURIComponent(collectionName.valueOf()));
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/studio/table-columns${queryArgs.length ? "?" + queryArgs.join("&") : ""}`, {
            method: "get",
            headers: headers
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
function $a20f65ece6f6f454$export$a4e0ed3cbba541b6(e) {
    return e && typeof e === "object" && "type" in e && e.type === "NotFound";
}
const $a20f65ece6f6f454$export$a97c0f1053186c5 = (0, $8jB4x.SSRHook)("getStudioTableColumns", undefined, undefined, $a20f65ece6f6f454$export$9705a41adfab725d, [
    "collectionName"
], undefined);
(0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "getStudioTableColumnFilterOptions",
    func: $a20f65ece6f6f454$export$70c34aa70222d24a
});
async function $a20f65ece6f6f454$export$70c34aa70222d24a(collectionName, columnName, search, offset, limit, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const queryArgs = [];
        if (search !== undefined) queryArgs.push("search=" + encodeURIComponent(search.valueOf()));
        if (offset !== undefined) queryArgs.push("offset=" + encodeURIComponent(offset.valueOf()));
        if (limit !== undefined) queryArgs.push("limit=" + encodeURIComponent(limit.valueOf()));
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/studio/table-columns/${collectionName}/filter-options/${columnName}${queryArgs.length ? "?" + queryArgs.join("&") : ""}`, {
            method: "get",
            headers: headers
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
function $a20f65ece6f6f454$export$3e06652175b2c7ee(e) {
    return e && typeof e === "object" && "type" in e && (e.type === "NotFound" || e.type === "BadRequest");
}
const $a20f65ece6f6f454$export$498c8bb99019344 = (0, $8jB4x.SSRHook)("getStudioTableColumnFilterOptions", "GetStudioTableColumnFilterOptionsDto", undefined, $a20f65ece6f6f454$export$70c34aa70222d24a, [
    "collectionName",
    "columnName",
    "search",
    "offset",
    "limit"
], undefined);
/** Returns the result of an async widget evaluation. */ (0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "getAsyncWidget",
    func: $a20f65ece6f6f454$export$f99e65d22ed006d
});
async function $a20f65ece6f6f454$export$f99e65d22ed006d(secret, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/studio/async-widget/${secret}`, {
            method: "get",
            headers: headers
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
function $a20f65ece6f6f454$export$f8c0cdfcace50cd2(e) {
    return e && typeof e === "object" && "type" in e && (e.type === "NotFound" || e.type === "RequestTimeout");
}
const $a20f65ece6f6f454$export$7d9c9223843f5a79 = (0, $8jB4x.SSRHook)("getAsyncWidget", "GetAsyncWidgetDto", undefined, $a20f65ece6f6f454$export$f99e65d22ed006d, [
    "secret"
], undefined);
/** Renders a named widget.

 The named widget must be registered with Widget() and marked with an
 `authorize` function.

 The calling user must be authorized to render the widget by the `authroize`
 function. */ (0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "postWidget",
    func: $a20f65ece6f6f454$export$e6838830449d2b12
});
async function $a20f65ece6f6f454$export$e6838830449d2b12(name, param, body, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/widgets/${name}/${param}`, {
            method: "post",
            headers: headers,
            body: JSON.stringify(body)
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
function $a20f65ece6f6f454$export$b335b75b93f3baaf(e) {
    return e && typeof e === "object" && "type" in e && (e.type === "NotFound" || e.type === "Forbidden");
}
/** Performs an action on a named widget tree

 The named widget must be registered with Widget() and marked with an
 `authorize` attribute.

 The calling user must be authorized to render the widget by the `authroize`
 function.

 The widget my specify an additional `actionAuthorization` function, which is
 called to authorize the particular action. If the widget does not specify an
 `actionAuthorization` function, the `StudioAuthorization` is used by
 default, meaning the action is limited to what the user is allowed to do in
 Studio. */ (0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "postWidgetAction",
    func: $a20f65ece6f6f454$export$5c0787df35a2fdb1
});
async function $a20f65ece6f6f454$export$5c0787df35a2fdb1(name, param, widgetKey, body, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/widgets/${name}/${param}/${widgetKey}`, {
            method: "post",
            headers: headers,
            body: JSON.stringify(body)
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
function $a20f65ece6f6f454$export$37e3ac86e8b94ca9(e) {
    return e && typeof e === "object" && "type" in e && (e.type === "NotFound" || e.type === "Forbidden" || e.type === "Unauthorized" || e.type === "JWTPropertyMissing");
}
(0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "getReactorMe",
    func: $a20f65ece6f6f454$export$73bfb6925bb6ca89
});
async function $a20f65ece6f6f454$export$73bfb6925bb6ca89(customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/studio/reactor/me`, {
            method: "get",
            headers: headers
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
function $a20f65ece6f6f454$export$18cb3ec9e05d6733(e) {
    return e && typeof e === "object" && "type" in e && (e.type === "Unauthorized" || e.type === "JWTPropertyMissing");
}
const $a20f65ece6f6f454$export$41d666a5186a022a = (0, $8jB4x.SSRHook)("getReactorMe", "GetReactorMeDto", undefined, $a20f65ece6f6f454$export$73bfb6925bb6ca89, [], undefined);
(0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "getWebSocketTicketForStudioUser",
    func: $a20f65ece6f6f454$export$142990fa462ec747
});
async function $a20f65ece6f6f454$export$142990fa462ec747(customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/studio/reactor/ticket`, {
            method: "get",
            headers: headers
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
function $a20f65ece6f6f454$export$c77bc68c9af3a491(e) {
    return e && typeof e === "object" && "type" in e && (e.type === "Unauthorized" || e.type === "JWTPropertyMissing");
}
const $a20f65ece6f6f454$export$9f8a4179437becf = (0, $8jB4x.SSRHook)("getWebSocketTicketForStudioUser", "GetWebSocketTicketForStudioUserDto", undefined, $a20f65ece6f6f454$export$142990fa462ec747, [], undefined);
/** Updates the cookie consents for the caller. */ (0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "putCookieConsents",
    func: $a20f65ece6f6f454$export$f60be4ab695c738e
});
async function $a20f65ece6f6f454$export$f60be4ab695c738e(body, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/cookie-consents`, {
            method: "put",
            headers: headers,
            body: JSON.stringify(body)
        });
        if (_res.status >= 200 && _res.status <= 299) return;
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
function $a20f65ece6f6f454$export$d56b7037a29601d4(e) {
    return e && typeof e === "object" && "type" in e && e.type === "Conflict";
}
(0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "getCookieConsents",
    func: $a20f65ece6f6f454$export$a3d5133891671b7f
});
async function $a20f65ece6f6f454$export$a3d5133891671b7f(customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/cookie-consents`, {
            method: "get",
            headers: headers
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
const $a20f65ece6f6f454$export$a75ab29ac3c01498 = (0, $8jB4x.SSRHook)("getCookieConsents", "GetCookieConsentsDto", "CookieConsents", $a20f65ece6f6f454$export$a3d5133891671b7f, [], (args, body)=>$a20f65ece6f6f454$export$f60be4ab695c738e.apply(null, [
        body
    ]));
(0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "getPaymentStatus",
    func: $a20f65ece6f6f454$export$62bb39aa76e51fe4
});
async function $a20f65ece6f6f454$export$62bb39aa76e51fe4(adyenOrder, adyenOrderId, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/payments/status/${adyenOrder}/${adyenOrderId}`, {
            method: "get",
            headers: headers
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
const $a20f65ece6f6f454$export$e4818e90429e9873 = (0, $8jB4x.SSRHook)("getPaymentStatus", "GetPaymentStatusDto", undefined, $a20f65ece6f6f454$export$62bb39aa76e51fe4, [
    "adyenOrder",
    "adyenOrderId"
], undefined);
(0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "getMerchantConfig",
    func: $a20f65ece6f6f454$export$2b8edcd677afcd27
});
async function $a20f65ece6f6f454$export$2b8edcd677afcd27(adyenOrder, adyenOrderId, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const queryArgs = [];
        if (adyenOrder !== undefined) queryArgs.push("adyenOrder=" + encodeURIComponent(adyenOrder.valueOf()));
        if (adyenOrderId !== undefined) queryArgs.push("adyenOrderId=" + encodeURIComponent(adyenOrderId.valueOf()));
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/payments/merchant-config${queryArgs.length ? "?" + queryArgs.join("&") : ""}`, {
            method: "get",
            headers: headers
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
const $a20f65ece6f6f454$export$45f530d069573b0d = (0, $8jB4x.SSRHook)("getMerchantConfig", "GetMerchantConfigDto", undefined, $a20f65ece6f6f454$export$2b8edcd677afcd27, [
    "adyenOrder",
    "adyenOrderId"
], undefined);
(0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "getPaymentMethods",
    func: $a20f65ece6f6f454$export$ba33f6d94de735b7
});
async function $a20f65ece6f6f454$export$ba33f6d94de735b7(adyenOrder, adyenOrderId, locale, channel, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const queryArgs = [];
        if (locale !== undefined) queryArgs.push("locale=" + encodeURIComponent(locale.valueOf()));
        if (channel !== undefined) queryArgs.push("channel=" + encodeURIComponent(channel.valueOf()));
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/payments/methods/${adyenOrder}/${adyenOrderId}${queryArgs.length ? "?" + queryArgs.join("&") : ""}`, {
            method: "get",
            headers: headers
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
function $a20f65ece6f6f454$export$3439326e0e9ec6c9(e) {
    return e && typeof e === "object" && "type" in e && e.type === "InternalServerError";
}
const $a20f65ece6f6f454$export$a16567ce62387eb = (0, $8jB4x.SSRHook)("getPaymentMethods", "GetPaymentMethodsDto", undefined, $a20f65ece6f6f454$export$ba33f6d94de735b7, [
    "adyenOrder",
    "adyenOrderId",
    "locale",
    "channel"
], undefined);
(0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "postPayment",
    func: $a20f65ece6f6f454$export$9f2dfacdd421cd58
});
async function $a20f65ece6f6f454$export$9f2dfacdd421cd58(adyenOrder, adyenOrderId, body, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/payments/payment/${adyenOrder}/${adyenOrderId}`, {
            method: "post",
            headers: headers,
            body: JSON.stringify(body)
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
function $a20f65ece6f6f454$export$6480dbcacec9380e(e) {
    return e && typeof e === "object" && "type" in e && e.type === "InternalServerError";
}
(0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "postAdditionalDetails",
    func: $a20f65ece6f6f454$export$34c8eb16ae69fac8
});
async function $a20f65ece6f6f454$export$34c8eb16ae69fac8(adyenOrder, adyenOrderId, body, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const queryArgs = [];
        if (adyenOrder !== undefined) queryArgs.push("adyenOrder=" + encodeURIComponent(adyenOrder.valueOf()));
        if (adyenOrderId !== undefined) queryArgs.push("adyenOrderId=" + encodeURIComponent(adyenOrderId.valueOf()));
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/payments/additional-details${queryArgs.length ? "?" + queryArgs.join("&") : ""}`, {
            method: "post",
            headers: headers,
            body: JSON.stringify(body)
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
function $a20f65ece6f6f454$export$4864b7440fdac2e2(e) {
    return e && typeof e === "object" && "type" in e && e.type === "InternalServerError";
}
(0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "getShopperRedirect",
    func: $a20f65ece6f6f454$export$c8dfe59fd50aaff8
});
async function $a20f65ece6f6f454$export$c8dfe59fd50aaff8(paymentId, locale, redirectUrl, redirectResult, mD, paRes, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const queryArgs = [];
        if (paymentId !== undefined) queryArgs.push("paymentId=" + encodeURIComponent(paymentId.valueOf()));
        if (locale !== undefined) queryArgs.push("locale=" + encodeURIComponent(locale.valueOf()));
        if (redirectUrl !== undefined) queryArgs.push("redirectUrl=" + encodeURIComponent(redirectUrl.valueOf()));
        if (redirectResult !== undefined) queryArgs.push("redirectResult=" + encodeURIComponent(redirectResult.valueOf()));
        if (mD !== undefined) queryArgs.push("mD=" + encodeURIComponent(mD.valueOf()));
        if (paRes !== undefined) queryArgs.push("paRes=" + encodeURIComponent(paRes.valueOf()));
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/payments/shopper-redirect${queryArgs.length ? "?" + queryArgs.join("&") : ""}`, {
            method: "get",
            headers: headers
        });
        if (_res.status >= 200 && _res.status <= 299) return;
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
function $a20f65ece6f6f454$export$675b8321664d05da(e) {
    return e && typeof e === "object" && "type" in e && e.type === "InternalServerError";
}
const $a20f65ece6f6f454$export$53c8a554c0f5bbf0 = (0, $8jB4x.SSRHook)("getShopperRedirect", undefined, undefined, $a20f65ece6f6f454$export$c8dfe59fd50aaff8, [
    "paymentId",
    "locale",
    "redirectUrl",
    "redirectResult",
    "mD",
    "paRes"
], undefined);
(0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "postShopperRedirect",
    func: $a20f65ece6f6f454$export$15c276420a05fe3e
});
async function $a20f65ece6f6f454$export$15c276420a05fe3e(paymentId, locale, body, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const queryArgs = [];
        if (paymentId !== undefined) queryArgs.push("paymentId=" + encodeURIComponent(paymentId.valueOf()));
        if (locale !== undefined) queryArgs.push("locale=" + encodeURIComponent(locale.valueOf()));
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/payments/shopper-redirect/${queryArgs.length ? "?" + queryArgs.join("&") : ""}`, {
            method: "post",
            headers: headers,
            body: JSON.stringify(body)
        });
        if (_res.status >= 200 && _res.status <= 299) return;
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
function $a20f65ece6f6f454$export$1e9f87ef2e3fb56f(e) {
    return e && typeof e === "object" && "type" in e && e.type === "InternalServerError";
}
(0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "postAdyenWebhook",
    func: $a20f65ece6f6f454$export$e11e52af077aed4e
});
async function $a20f65ece6f6f454$export$e11e52af077aed4e(body, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/payments/adyen-webhook`, {
            method: "post",
            headers: headers,
            body: JSON.stringify(body)
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.text();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
function $a20f65ece6f6f454$export$3377c1afdcc48e11(e) {
    return e && typeof e === "object" && "type" in e && e.type === "Unauthorized";
}
/** Internal Receipt endpoint, do not attempt to use this endpoint directly. */ (0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "getReceiptHtml",
    func: $a20f65ece6f6f454$export$fb37bf727dcfdbd1
});
async function $a20f65ece6f6f454$export$fb37bf727dcfdbd1(secret, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const queryArgs = [];
        if (secret !== undefined) queryArgs.push("secret=" + encodeURIComponent(secret.valueOf()));
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/payments/receipts/html${queryArgs.length ? "?" + queryArgs.join("&") : ""}`, {
            method: "get",
            headers: headers
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.text();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
function $a20f65ece6f6f454$export$218966a8a7868a92(e) {
    return e && typeof e === "object" && "type" in e && e.type === "NotFound";
}
const $a20f65ece6f6f454$export$1e7b91d42db791a9 = (0, $8jB4x.SSRHook)("getReceiptHtml", undefined, undefined, $a20f65ece6f6f454$export$fb37bf727dcfdbd1, [
    "secret"
], undefined);
(0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "postSmsStatus",
    func: $a20f65ece6f6f454$export$4a5940fc022e5072
});
async function $a20f65ece6f6f454$export$4a5940fc022e5072(body, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/fuse-webhooks/sms-status`, {
            method: "post",
            headers: headers,
            body: JSON.stringify(body)
        });
        if (_res.status >= 200 && _res.status <= 299) return;
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
function $a20f65ece6f6f454$export$4dad33e3e2f99430(e) {
    return e && typeof e === "object" && "type" in e && e.type === "Unauthorized";
}
(0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "unsubscribeEndpoint",
    func: $a20f65ece6f6f454$export$4a0e110f8230f4b2
});
async function $a20f65ece6f6f454$export$4a0e110f8230f4b2(secret, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/email-unsubscribe/${secret}`, {
            method: "get",
            headers: headers
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.text();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
/** A webhook for getting status updates on email delivery from Fuseops. */ (0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "postEmailStatus",
    func: $a20f65ece6f6f454$export$23c810bd8c41062f
});
async function $a20f65ece6f6f454$export$23c810bd8c41062f(body, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/fuse-webhooks/email-status`, {
            method: "post",
            headers: headers,
            body: JSON.stringify(body)
        });
        if (_res.status >= 200 && _res.status <= 299) return;
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
function $a20f65ece6f6f454$export$5ae10059a7c0a42f(e) {
    return e && typeof e === "object" && "type" in e && (e.type === "Forbidden" || e.type === "NotFound" || e.type === "BadRequest");
}
(0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "postEmailPreviewResult",
    func: $a20f65ece6f6f454$export$15460f7f997118be
});
async function $a20f65ece6f6f454$export$15460f7f997118be(body, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/fuse-webhooks/email-preview`, {
            method: "post",
            headers: headers,
            body: JSON.stringify(body)
        });
        if (_res.status >= 200 && _res.status <= 299) return;
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
function $a20f65ece6f6f454$export$904516fab6ba8863(e) {
    return e && typeof e === "object" && "type" in e && (e.type === "NotFound" || e.type === "BadRequest");
}
(0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "getProgressOperations",
    func: $a20f65ece6f6f454$export$674500fd2dc73cbe
});
async function $a20f65ece6f6f454$export$674500fd2dc73cbe(customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/studio/progress-operations`, {
            method: "get",
            headers: headers
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
function $a20f65ece6f6f454$export$836f032484deb9aa(e) {
    return e && typeof e === "object" && "type" in e && (e.type === "Unauthorized" || e.type === "JWTPropertyMissing");
}
const $a20f65ece6f6f454$export$45aefb6aa6313e9d = (0, $8jB4x.SSRHook)("getProgressOperations", undefined, undefined, $a20f65ece6f6f454$export$674500fd2dc73cbe, [], undefined);
/** Cancels an ongoing progress operation. */ (0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "deleteProgressOperation",
    func: $a20f65ece6f6f454$export$e12eab7db05d8979
});
async function $a20f65ece6f6f454$export$e12eab7db05d8979(id, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/studio/progress-operations/${id}`, {
            method: "delete",
            headers: headers
        });
        if (_res.status >= 200 && _res.status <= 299) return;
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
function $a20f65ece6f6f454$export$90564d9d7745ab04(e) {
    return e && typeof e === "object" && "type" in e && (e.type === "Forbidden" || e.type === "Unauthorized" || e.type === "JWTPropertyMissing");
}
(0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "postFiles",
    func: $a20f65ece6f6f454$export$95da78a327b3e83c
});
async function $a20f65ece6f6f454$export$95da78a327b3e83c(folder, uploadedFiles, share, mimetype, temporaryFile, originalFileName, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const queryArgs = [];
        if (share !== undefined) queryArgs.push("share=" + encodeURIComponent(share.valueOf()));
        if (mimetype !== undefined) queryArgs.push("mimetype=" + encodeURIComponent(mimetype.valueOf()));
        if (temporaryFile !== undefined) queryArgs.push("temporaryFile=" + encodeURIComponent(temporaryFile.valueOf()));
        if (originalFileName !== undefined) queryArgs.push("originalFileName=" + encodeURIComponent(originalFileName.valueOf()));
        const formData = new FormData();
        for (const file of uploadedFiles)formData.append("file", file);
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        delete headers["Content-Type"];
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/folders/${folder}/files${queryArgs.length ? "?" + queryArgs.join("&") : ""}`, {
            method: "post",
            headers: headers,
            body: formData
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
function $a20f65ece6f6f454$export$5cc45c11858fff49(e) {
    return e && typeof e === "object" && "type" in e && (e.type === "Forbidden" || e.type === "BadRequest" || e.type === "Unauthorized" || e.type === "JWTPropertyMissing");
}
(0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "getFileInfo",
    func: $a20f65ece6f6f454$export$ca39f27fe4f7d9b4
});
async function $a20f65ece6f6f454$export$ca39f27fe4f7d9b4(id, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/files/${id}/info`, {
            method: "get",
            headers: headers
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
function $a20f65ece6f6f454$export$d7db1b28f9c31e3a(e) {
    return e && typeof e === "object" && "type" in e && e.type === "NotFound";
}
const $a20f65ece6f6f454$export$ee3c5c6f3f6d9ce2 = (0, $8jB4x.SSRHook)("getFileInfo", "FileRecord", undefined, $a20f65ece6f6f454$export$ca39f27fe4f7d9b4, [
    "id"
], undefined);
/** Imports a CSV file into a collection using a StudioImporter. */ (0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "postStudioImport",
    func: $a20f65ece6f6f454$export$9cdd14240fa100e1
});
async function $a20f65ece6f6f454$export$9cdd14240fa100e1(importerId, body, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/studio/importers/${importerId}/import`, {
            method: "post",
            headers: headers,
            body: JSON.stringify(body)
        });
        if (_res.status >= 200 && _res.status <= 299) return;
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
function $a20f65ece6f6f454$export$3d5ff9a2baaa4fdb(e) {
    return e && typeof e === "object" && "type" in e && (e.type === "BadRequest" || e.type === "Unauthorized" || e.type === "JWTPropertyMissing");
}
/** Returns the TSQ declarations available to the current user. */ (0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "getStudioConsoleDeclarations",
    func: $a20f65ece6f6f454$export$bb07a6b381093870
});
async function $a20f65ece6f6f454$export$bb07a6b381093870(customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/studio/console/declarations`, {
            method: "get",
            headers: headers
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
const $a20f65ece6f6f454$export$fd5972893db4924a = (0, $8jB4x.SSRHook)("getStudioConsoleDeclarations", "GetStudioConsoleDeclarationsDto", undefined, $a20f65ece6f6f454$export$bb07a6b381093870, [], undefined);
/** Retrieves a stored query by ID. */ (0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "getStudioConsoleQuery",
    func: $a20f65ece6f6f454$export$a143c71caaab659
});
async function $a20f65ece6f6f454$export$a143c71caaab659(id, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const queryArgs = [];
        if (id !== undefined) queryArgs.push("id=" + encodeURIComponent(id.valueOf()));
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/studio/console/query${queryArgs.length ? "?" + queryArgs.join("&") : ""}`, {
            method: "get",
            headers: headers
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
const $a20f65ece6f6f454$export$94ceba2dc16e0fc3 = (0, $8jB4x.SSRHook)("getStudioConsoleQuery", "StudioConsoleQuery", undefined, $a20f65ece6f6f454$export$a143c71caaab659, [
    "id"
], undefined);
/** Evaluates a console query (TSQ expression).

If the code snippet has not been stored before, it is stored and given an ID.
If the code snippet has been stored before, the stored ID is returned. */ (0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "postStudioConsoleQuery",
    func: $a20f65ece6f6f454$export$95c87f0e34c00a63
});
async function $a20f65ece6f6f454$export$95c87f0e34c00a63(body, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/studio/console`, {
            method: "post",
            headers: headers,
            body: JSON.stringify(body)
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
function $a20f65ece6f6f454$export$1ffc617dfcffd0e8(e) {
    return e && typeof e === "object" && "type" in e && (e.type === "BadRequest" || e.type === "Forbidden" || e.type === "NotFound" || e.type === "Conflict");
}
/** Performs an action on the result of a console query (TSQ expression). */ (0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "postStudioConsoleQueryAction",
    func: $a20f65ece6f6f454$export$f96fb6f422ff336b
});
async function $a20f65ece6f6f454$export$f96fb6f422ff336b(id, widgetKey, body, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/studio/console/${id}/actions/${widgetKey}`, {
            method: "post",
            headers: headers,
            body: JSON.stringify(body)
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
function $a20f65ece6f6f454$export$61b968f9f5926f2c(e) {
    return e && typeof e === "object" && "type" in e && (e.type === "BadRequest" || e.type === "Forbidden" || e.type === "NotFound" || e.type === "Conflict" || e.type === "Unauthorized" || e.type === "JWTPropertyMissing");
}
/** Renders a studio page into a widget tree.

 The page will be rendered using the calling user's Studio authorization. The call may fail fully
 or partially if the user is not authorized to read the necessary data to render the page. */ (0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "postStudioPage",
    func: $a20f65ece6f6f454$export$e80bf8f4e06e76c
});
async function $a20f65ece6f6f454$export$e80bf8f4e06e76c(path, body, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/studio/pages/${path}`, {
            method: "post",
            headers: headers,
            body: JSON.stringify(body)
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
function $a20f65ece6f6f454$export$8859d14dad5c6167(e) {
    return e && typeof e === "object" && "type" in e && (e.type === "Forbidden" || e.type === "Unauthorized" || e.type === "JWTPropertyMissing" || e.type === "NotFound" || e.type === "BadRequest" || e.type === "Conflict");
}
/** Performs one of the predefined actions in a widget tree returned by `postStudioPage`.

This typically means "pushing a button" in the widget tree.

The action will be performed using the calling user's Studio authorization. This means that the
user must be authorized to perform all the implied consequences of the action for the call to be
successful. */ (0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "postStudioPageAction",
    func: $a20f65ece6f6f454$export$8cdaf2e04bd1ce99
});
async function $a20f65ece6f6f454$export$8cdaf2e04bd1ce99(path, body, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/studio/pages/${path}/action`, {
            method: "post",
            headers: headers,
            body: JSON.stringify(body)
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
function $a20f65ece6f6f454$export$bf41fa9433d6b6b1(e) {
    return e && typeof e === "object" && "type" in e && (e.type === "Forbidden" || e.type === "Unauthorized" || e.type === "JWTPropertyMissing" || e.type === "NotFound" || e.type === "BadRequest" || e.type === "Conflict");
}
/** Allows updating the code of a user-defined studio page.

Implicitly requires permission to update the document through
StudioAuthorization. */ (0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "putUserDefinedStudioPageCode",
    func: $a20f65ece6f6f454$export$89b5f5edc5db8ed2
});
async function $a20f65ece6f6f454$export$89b5f5edc5db8ed2(id, body, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/studio/user-defined-page/${id}/code`, {
            method: "put",
            headers: headers,
            body: JSON.stringify(body)
        });
        if (_res.status >= 200 && _res.status <= 299) return;
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
/** Returns a single document along with all associated widget representations, making it easier to
render the document in Studio without performing additional network requests. */ (0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "postDocumentPage",
    func: $a20f65ece6f6f454$export$9c07cfba7c1404f6
});
async function $a20f65ece6f6f454$export$9c07cfba7c1404f6(target, body, primaryKey, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const queryArgs = [];
        if (primaryKey !== undefined) queryArgs.push("primaryKey=" + encodeURIComponent(primaryKey.valueOf()));
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/studio/documents/${target}${queryArgs.length ? "?" + queryArgs.join("&") : ""}`, {
            method: "post",
            headers: headers,
            body: JSON.stringify(body)
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
function $a20f65ece6f6f454$export$8883d5bc8bb3bd6e(e) {
    return e && typeof e === "object" && "type" in e && (e.type === "BadRequest" || e.type === "NotFound" || e.type === "Unauthorized" || e.type === "JWTPropertyMissing");
}
const $a20f65ece6f6f454$export$d8eb8c32826d9d8c = (0, $8jB4x.SSRHook)("postDocumentPage", "PostDocumentPageDto", undefined, $a20f65ece6f6f454$export$9c07cfba7c1404f6, [
    "target",
    "body",
    "primaryKey"
], undefined);
/** Performs one of the predefined actions in a widget tree returned by
`postDocumentPage`.

This typically means "pushing a button" in the widget tree.

The action will be performed using the calling user's Studio authorization.
This means that the user must be authorized to perform all the implied
consequences of the action for the call to be successful.

To avoid subtle bugs, `body.clientState` must be used with caution, as the
action will be performed against the canonized version of the document, and
is not able to take any client-side state into account. The user should either
save or discard their client-side changes before performing an action.

`body.clientState` may be used when creating new documents. */ (0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "postDocumentPageAction",
    func: $a20f65ece6f6f454$export$515f69f88088292f
});
async function $a20f65ece6f6f454$export$515f69f88088292f(target, tab, widgetKey, body, primaryKey, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const queryArgs = [];
        if (tab !== undefined) queryArgs.push("tab=" + encodeURIComponent(tab.valueOf()));
        if (widgetKey !== undefined) queryArgs.push("widgetKey=" + encodeURIComponent(widgetKey.valueOf()));
        if (primaryKey !== undefined) queryArgs.push("primaryKey=" + encodeURIComponent(primaryKey.valueOf()));
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/studio/documents/page/${target}/action${queryArgs.length ? "?" + queryArgs.join("&") : ""}`, {
            method: "post",
            headers: headers,
            body: JSON.stringify(body)
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
function $a20f65ece6f6f454$export$434fefc19550a453(e) {
    return e && typeof e === "object" && "type" in e && (e.type === "DocumentMustBeSavedPriorToAction" || e.type === "BadRequest" || e.type === "NotFound" || e.type === "Unauthorized" || e.type === "JWTPropertyMissing");
}
(0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "postDocumentDefaults",
    func: $a20f65ece6f6f454$export$186ce115a6f7851
});
async function $a20f65ece6f6f454$export$186ce115a6f7851(body, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/studio/documents/defaults`, {
            method: "post",
            headers: headers,
            body: JSON.stringify(body)
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
/** Returns information about the data collections managed by this server. */ (0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "getReflection",
    func: $a20f65ece6f6f454$export$6c3e17132cc7c4b8
});
async function $a20f65ece6f6f454$export$6c3e17132cc7c4b8(customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/studio/reflection`, {
            method: "get",
            headers: headers
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.text();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
const $a20f65ece6f6f454$export$f2693381791b225e = (0, $8jB4x.SSRHook)("getReflection", "SerializedGraph", undefined, $a20f65ece6f6f454$export$6c3e17132cc7c4b8, [], undefined);
/** Navigates to the link embedded in an email.

This registers the click in the database and redirects the user to the
link. */ (0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "getEmailLink",
    func: $a20f65ece6f6f454$export$68142dc28e973edc
});
async function $a20f65ece6f6f454$export$68142dc28e973edc(id, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/email/links/${id}`, {
            method: "get",
            headers: headers
        });
        if (_res.status >= 200 && _res.status <= 299) return;
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
function $a20f65ece6f6f454$export$d55dbb4428fd8778(e) {
    return e && typeof e === "object" && "type" in e && (e.type === "NotFound" || e.type === "BadRequest");
}
const $a20f65ece6f6f454$export$76396f9dc6eed503 = (0, $8jB4x.SSRHook)("getEmailLink", undefined, undefined, $a20f65ece6f6f454$export$68142dc28e973edc, [
    "id"
], undefined);
(0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "getLocales",
    func: $a20f65ece6f6f454$export$63967f17cb506053
});
async function $a20f65ece6f6f454$export$63967f17cb506053(customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/studio/locales`, {
            method: "get",
            headers: headers
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
const $a20f65ece6f6f454$export$7a920adec6f03cb7 = (0, $8jB4x.SSRHook)("getLocales", undefined, undefined, $a20f65ece6f6f454$export$63967f17cb506053, [], undefined);
(0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "getDefaultLocale",
    func: $a20f65ece6f6f454$export$f09106e7c6677ec5
});
async function $a20f65ece6f6f454$export$f09106e7c6677ec5(customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/studio/default-locale`, {
            method: "get",
            headers: headers
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
const $a20f65ece6f6f454$export$188ec29ebc2bdc3a = (0, $8jB4x.SSRHook)("getDefaultLocale", "GetDefaultLocaleDto", undefined, $a20f65ece6f6f454$export$f09106e7c6677ec5, [], undefined);
/** Returns all available editing templates for a given type. */ (0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "getEditingTemplates",
    func: $a20f65ece6f6f454$export$21236ecbfb784eda
});
async function $a20f65ece6f6f454$export$21236ecbfb784eda(type, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/studio/editing-templates/${type}`, {
            method: "get",
            headers: headers
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
const $a20f65ece6f6f454$export$3eb16646ca00f6c = (0, $8jB4x.SSRHook)("getEditingTemplates", "GetEditingTemplatesDto", undefined, $a20f65ece6f6f454$export$21236ecbfb784eda, [
    "type"
], undefined);
/** Creates a new editing template.

Returns an error if a template with the same name already exists for the given type */ (0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "postEditingTemplate",
    func: $a20f65ece6f6f454$export$198d5e39b005a16f
});
async function $a20f65ece6f6f454$export$198d5e39b005a16f(type, body, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/studio/editing-templates/${type}`, {
            method: "post",
            headers: headers,
            body: JSON.stringify(body)
        });
        if (_res.status >= 200 && _res.status <= 299) return;
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
function $a20f65ece6f6f454$export$d11d407836b0a284(e) {
    return e && typeof e === "object" && "type" in e && e.type === "BadRequest";
}
/** Overwrites an existing editing template. */ (0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "putEditingTemplate",
    func: $a20f65ece6f6f454$export$bc7bab6114223bff
});
async function $a20f65ece6f6f454$export$bc7bab6114223bff(type, id, body, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/studio/editing-templates/${type}/${id}`, {
            method: "put",
            headers: headers,
            body: JSON.stringify(body)
        });
        if (_res.status >= 200 && _res.status <= 299) return;
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
/** Deletes an editing template. */ (0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "deleteEditingTemplate",
    func: $a20f65ece6f6f454$export$65d34dfbfc97ca7a
});
async function $a20f65ece6f6f454$export$65d34dfbfc97ca7a(type, id, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/studio/editing-templates/${type}/${id}`, {
            method: "delete",
            headers: headers
        });
        if (_res.status >= 200 && _res.status <= 299) return;
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
/** Previews what will happen if a partial dataset is imported with the given settings. */ (0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "postDatasetPartialPreview",
    func: $a20f65ece6f6f454$export$23c2cc16f804b25e
});
async function $a20f65ece6f6f454$export$23c2cc16f804b25e(body, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/studio/dataset/partial/preview`, {
            method: "post",
            headers: headers,
            body: JSON.stringify(body)
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
function $a20f65ece6f6f454$export$ba8b3e2a11922016(e) {
    return e && typeof e === "object" && "type" in e && (e.type === "Unauthorized" || e.type === "JWTPropertyMissing");
}
/** Imports a partial dataset.

 The dataset will be downloaded asynchronously. You can poll `GET
 /studio/dataset/partial/:id/status` to get the progress. */ (0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "postDatasetPartial",
    func: $a20f65ece6f6f454$export$c9f7c31b8b787c73
});
async function $a20f65ece6f6f454$export$c9f7c31b8b787c73(body, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/studio/dataset/partial`, {
            method: "post",
            headers: headers,
            body: JSON.stringify(body)
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
function $a20f65ece6f6f454$export$886b639dd5309e14(e) {
    return e && typeof e === "object" && "type" in e && (e.type === "Conflict" || e.type === "Unauthorized" || e.type === "JWTPropertyMissing");
}
(0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "getDatasetPartialStatus",
    func: $a20f65ece6f6f454$export$5f591e763f89ee4b
});
async function $a20f65ece6f6f454$export$5f591e763f89ee4b(importId, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/studio/dataset/partial/${importId}/status`, {
            method: "get",
            headers: headers
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
const $a20f65ece6f6f454$export$35b55dc3a8d2f44d = (0, $8jB4x.SSRHook)("getDatasetPartialStatus", "PartialDatasetImport", undefined, $a20f65ece6f6f454$export$5f591e763f89ee4b, [
    "importId"
], undefined);
(0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "postStudioTranslate",
    func: $a20f65ece6f6f454$export$2d8285d5bfbc57d6
});
async function $a20f65ece6f6f454$export$2d8285d5bfbc57d6(body, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/studio/translate`, {
            method: "post",
            headers: headers,
            body: JSON.stringify(body)
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
function $a20f65ece6f6f454$export$262ecb60feb54731(e) {
    return e && typeof e === "object" && "type" in e && e.type === "NotFound";
}
(0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "getMarkdownSnippet",
    func: $a20f65ece6f6f454$export$c0cc98bd687a2fe3
});
async function $a20f65ece6f6f454$export$c0cc98bd687a2fe3(id, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/markdown-snippets/${id}`, {
            method: "get",
            headers: headers
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
const $a20f65ece6f6f454$export$e1cb49632f1ee55f = (0, $8jB4x.SSRHook)("getMarkdownSnippet", "GetMarkdownSnippetDto", "PutMarkdownSnippetRequestBodyDto", $a20f65ece6f6f454$export$c0cc98bd687a2fe3, [
    "id"
], (args, body)=>$a20f65ece6f6f454$export$1dd477df5f9fd1d4.apply(null, [
        args[0],
        body
    ]));
(0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "putMarkdownSnippet",
    func: $a20f65ece6f6f454$export$1dd477df5f9fd1d4
});
async function $a20f65ece6f6f454$export$1dd477df5f9fd1d4(id, body, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/markdown-snippets/${id}`, {
            method: "put",
            headers: headers,
            body: JSON.stringify(body)
        });
        if (_res.status >= 200 && _res.status <= 299) return;
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
/** Returns the studio menu for the current user. */ (0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "getStudioMenu",
    func: $a20f65ece6f6f454$export$b02fe8a117d5bb3f
});
async function $a20f65ece6f6f454$export$b02fe8a117d5bb3f(customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/studio/menu`, {
            method: "get",
            headers: headers
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
function $a20f65ece6f6f454$export$ddbad3cc0db37bdf(e) {
    return e && typeof e === "object" && "type" in e && (e.type === "Unauthorized" || e.type === "JWTPropertyMissing");
}
const $a20f65ece6f6f454$export$61f5615d8059000 = (0, $8jB4x.SSRHook)("getStudioMenu", "GetStudioMenuDto", undefined, $a20f65ece6f6f454$export$b02fe8a117d5bb3f, [], undefined);
/** Sets the current scope selection for the current user.

This typically stores the preference in a cookie for subsequent requests. */ (0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "putStudioMenuScope",
    func: $a20f65ece6f6f454$export$709d2a12f20d6799
});
async function $a20f65ece6f6f454$export$709d2a12f20d6799(slug, body, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/studio/menu/scope/${slug}`, {
            method: "put",
            headers: headers,
            body: JSON.stringify(body)
        });
        if (_res.status >= 200 && _res.status <= 299) return;
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
function $a20f65ece6f6f454$export$4eb356684d2f6adc(e) {
    return e && typeof e === "object" && "type" in e && (e.type === "NotFound" || e.type === "BadRequest");
}
/** Downloads the primary dataset from this Reactor instance.

This includes all collection data marked as `isPrimaryDataset`. */ (0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "getPrimaryDataset",
    func: $a20f65ece6f6f454$export$84b2c1392edca245
});
async function $a20f65ece6f6f454$export$84b2c1392edca245(includeFiles, secret, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const queryArgs = [];
        if (includeFiles !== undefined) queryArgs.push("includeFiles=" + encodeURIComponent(includeFiles.valueOf()));
        if (secret !== undefined) queryArgs.push("secret=" + encodeURIComponent(secret.valueOf()));
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/studio/primary-dataset${queryArgs.length ? "?" + queryArgs.join("&") : ""}`, {
            method: "get",
            headers: headers
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.text();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
function $a20f65ece6f6f454$export$681bbf4e231943ce(e) {
    return e && typeof e === "object" && "type" in e && e.type === "Forbidden";
}
const $a20f65ece6f6f454$export$7129ae44733acd42 = (0, $8jB4x.SSRHook)("getPrimaryDataset", undefined, undefined, $a20f65ece6f6f454$export$84b2c1392edca245, [
    "includeFiles",
    "secret"
], undefined);
(0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "postPrimaryDataset",
    func: $a20f65ece6f6f454$export$c44d3c9f46f1b060
});
async function $a20f65ece6f6f454$export$c44d3c9f46f1b060(files, secret, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const queryArgs = [];
        if (secret !== undefined) queryArgs.push("secret=" + encodeURIComponent(secret.valueOf()));
        const formData = new FormData();
        for (const file of files)formData.append("file", file);
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        delete headers["Content-Type"];
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/studio/primary-dataset${queryArgs.length ? "?" + queryArgs.join("&") : ""}`, {
            method: "post",
            headers: headers,
            body: formData
        });
        if (_res.status >= 200 && _res.status <= 299) return;
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
function $a20f65ece6f6f454$export$88ac8cccf1f5ef02(e) {
    return e && typeof e === "object" && "type" in e && (e.type === "BadRequest" || e.type === "Forbidden");
}
(0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "getDocumentEvents",
    func: $a20f65ece6f6f454$export$176cf02bf5158edf
});
async function $a20f65ece6f6f454$export$176cf02bf5158edf(collection, document, count, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const queryArgs = [];
        if (collection !== undefined) queryArgs.push("collection=" + encodeURIComponent(collection.valueOf()));
        if (document !== undefined) queryArgs.push("document=" + encodeURIComponent(document.valueOf()));
        if (count !== undefined) queryArgs.push("count=" + encodeURIComponent(count.valueOf()));
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/studio/documents/events${queryArgs.length ? "?" + queryArgs.join("&") : ""}`, {
            method: "get",
            headers: headers
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
function $a20f65ece6f6f454$export$1cd2afbcd3c5435f(e) {
    return e && typeof e === "object" && "type" in e && (e.type === "BadRequest" || e.type === "NotFound" || e.type === "Unauthorized" || e.type === "Forbidden");
}
const $a20f65ece6f6f454$export$2395466cf3e3814b = (0, $8jB4x.SSRHook)("getDocumentEvents", "GetDocumentEventsDto", undefined, $a20f65ece6f6f454$export$176cf02bf5158edf, [
    "collection",
    "document",
    "count"
], undefined);
/** Searches all collections that the current user has read and filter access to, and renders a
widget page with one table for each collection containing hits. */ (0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "postStudioGlobalSearch",
    func: $a20f65ece6f6f454$export$54e6a88438a044c2
});
async function $a20f65ece6f6f454$export$54e6a88438a044c2(searchString, body, searchCollection, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const queryArgs = [];
        if (searchString !== undefined) queryArgs.push("searchString=" + encodeURIComponent(searchString.valueOf()));
        if (searchCollection !== undefined) queryArgs.push("searchCollection=" + encodeURIComponent(searchCollection.valueOf()));
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/studio/search${queryArgs.length ? "?" + queryArgs.join("&") : ""}`, {
            method: "post",
            headers: headers,
            body: JSON.stringify(body)
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
function $a20f65ece6f6f454$export$c37d1723310d5234(e) {
    return e && typeof e === "object" && "type" in e && (e.type === "Forbidden" || e.type === "NotFound" || e.type === "BadRequest" || e.type === "Conflict");
}
const $a20f65ece6f6f454$export$c9b41d9889d33da1 = (0, $8jB4x.SSRHook)("postStudioGlobalSearch", "PostStudioGlobalSearchDto", undefined, $a20f65ece6f6f454$export$54e6a88438a044c2, [
    "searchString",
    "body",
    "searchCollection"
], undefined);
(0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "getSendMailTrackingPixel",
    func: $a20f65ece6f6f454$export$6138f65f2a3c9b54
});
async function $a20f65ece6f6f454$export$6138f65f2a3c9b54(id, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/email-read/${id}`, {
            method: "get",
            headers: headers
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
function $a20f65ece6f6f454$export$cf0c79a2fb47756e(e) {
    return e && typeof e === "object" && "type" in e && (e.type === "NotFound" || e.type === "Unauthorized" || e.type === "JWTPropertyMissing");
}
const $a20f65ece6f6f454$export$8d1f5b8378bd70ae = (0, $8jB4x.SSRHook)("getSendMailTrackingPixel", undefined, undefined, $a20f65ece6f6f454$export$6138f65f2a3c9b54, [
    "id"
], undefined);
/** Returns the studio toasts for the current user. */ (0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "getStudioToasts",
    func: $a20f65ece6f6f454$export$675001882e68c4a
});
async function $a20f65ece6f6f454$export$675001882e68c4a(offset, limit, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const queryArgs = [];
        if (offset !== undefined) queryArgs.push("offset=" + encodeURIComponent(offset.valueOf()));
        if (limit !== undefined) queryArgs.push("limit=" + encodeURIComponent(limit.valueOf()));
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/studio/toasts${queryArgs.length ? "?" + queryArgs.join("&") : ""}`, {
            method: "get",
            headers: headers
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
function $a20f65ece6f6f454$export$4b68536c9a4b905c(e) {
    return e && typeof e === "object" && "type" in e && (e.type === "Unauthorized" || e.type === "JWTPropertyMissing");
}
const $a20f65ece6f6f454$export$99a23bc3fc1572fe = (0, $8jB4x.SSRHook)("getStudioToasts", undefined, undefined, $a20f65ece6f6f454$export$675001882e68c4a, [
    "offset",
    "limit"
], undefined);
/** Deletes a studio toast.

This is typically called when the user dismisses the toast. */ (0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "deleteStudioToast",
    func: $a20f65ece6f6f454$export$1cc30c8a3cedab1a
});
async function $a20f65ece6f6f454$export$1cc30c8a3cedab1a(id, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/studio/toasts/${id}`, {
            method: "delete",
            headers: headers
        });
        if (_res.status >= 200 && _res.status <= 299) return;
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
function $a20f65ece6f6f454$export$3c41bae14ae0bc28(e) {
    return e && typeof e === "object" && "type" in e && (e.type === "Unauthorized" || e.type === "JWTPropertyMissing");
}
/** Returns whether a particular analytics event is enabled.

If an event is disbaled, the clients should not bother sending it.

This is intended to be used during SSR to built into the SPA whether to
send certain analytics events or not. */ (0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "getAnalyticsEventStatus",
    func: $a20f65ece6f6f454$export$9acf6305a4a41fa0
});
async function $a20f65ece6f6f454$export$9acf6305a4a41fa0(type, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/analytics-events/${type}/status`, {
            method: "get",
            headers: headers
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
const $a20f65ece6f6f454$export$d7b1b5e2e146ee6e = (0, $8jB4x.SSRHook)("getAnalyticsEventStatus", "AnalyticsEventStatus", undefined, $a20f65ece6f6f454$export$9acf6305a4a41fa0, [
    "type"
], undefined);
/** Logs an analytics event.

Mobile apps should set two additional headers:
`Fuse-Install-Id` and `Fuse-App-Version`. */ (0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "postAnalyticsEvent",
    func: $a20f65ece6f6f454$export$66670472b5285f48
});
async function $a20f65ece6f6f454$export$66670472b5285f48(type, body, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/analytics-events/${type}`, {
            method: "post",
            headers: headers,
            body: JSON.stringify(body)
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
function $a20f65ece6f6f454$export$dbbb0eeb0b02f1cd(e) {
    return e && typeof e === "object" && "type" in e && (e.type === "BadRequest" || e.type === "Unauthorized" || e.type === "JWTPropertyMissing");
}
(0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "postSharedWidget",
    func: $a20f65ece6f6f454$export$4cf04919850db7fd
});
async function $a20f65ece6f6f454$export$4cf04919850db7fd(urlSecret, body, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/studio/shared-widget/${urlSecret}`, {
            method: "post",
            headers: headers,
            body: JSON.stringify(body)
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
function $a20f65ece6f6f454$export$1f03f6241501e74c(e) {
    return e && typeof e === "object" && "type" in e && (e.type === "Unauthorized" || e.type === "BadRequest" || e.type === "NotFound" || e.type === "JWTPropertyMissing");
}
const $a20f65ece6f6f454$export$5b5e67ffcf2ba41e = (0, $8jB4x.SSRHook)("postSharedWidget", "PostSharedWidgetDto", undefined, $a20f65ece6f6f454$export$4cf04919850db7fd, [
    "urlSecret",
    "body"
], undefined);
/** Returns the updates in the given layer for the given document, from the given
version.

In order to call this endpoint, the user must have read access to the
document.

If the document doesn't exist yet, but represents an uncreated (draft)
document, the user must have insert access to the collection. */ (0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "getLayerUpdates",
    func: $a20f65ece6f6f454$export$4ec870344b7001ea
});
async function $a20f65ece6f6f454$export$4ec870344b7001ea(res, key, layer, version, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const queryArgs = [];
        if (version !== undefined) queryArgs.push("version=" + encodeURIComponent(version.valueOf()));
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/studio/layers/${res}/${key}/${layer}${queryArgs.length ? "?" + queryArgs.join("&") : ""}`, {
            method: "get",
            headers: headers
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
function $a20f65ece6f6f454$export$ead5010fead26772(e) {
    return e && typeof e === "object" && "type" in e && (e.type === "Forbidden" || e.type === "NotFound" || e.type === "Unauthorized");
}
const $a20f65ece6f6f454$export$629f24930275d49a = (0, $8jB4x.SSRHook)("getLayerUpdates", "GetLayerUpdatesDto", undefined, $a20f65ece6f6f454$export$4ec870344b7001ea, [
    "res",
    "key",
    "layer",
    "version"
], undefined);
/** Posts a new operation to the given document in the given layer.

If the document doesn't exist yet, but represents an uncreated (draft)
document, the user must have insert access to the collection.

If the document exists, the user must have update access to the document. */ (0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "postLayerUpdates",
    func: $a20f65ece6f6f454$export$3ba7ff34a452fa58
});
async function $a20f65ece6f6f454$export$3ba7ff34a452fa58(res, key, layer, body, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/studio/layers/${res}/${key}/${layer}`, {
            method: "post",
            headers: headers,
            body: JSON.stringify(body)
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
function $a20f65ece6f6f454$export$d76a1695c1d6ee6c(e) {
    return e && typeof e === "object" && "type" in e && (e.type === "Forbidden" || e.type === "NotFound" || e.type === "Unauthorized" || e.type === "JWTPropertyMissing");
}
/** Deletes all updates in the given layer.

For uncreated drafts, this will effectively delete the draft, since it only
exists as uncommitted updates.

For existing documents, this will delete all updates in the given layer (i.e.
unpublished changes). The published document will be unaffected.

For existing documents, the user must have update access to the document to
discard the updates.

For uncreated drafts, the user must have insert access to the collection to
discard the uncreated draft. */ (0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "discardLayerUpdates",
    func: $a20f65ece6f6f454$export$f758c4a492381d2
});
async function $a20f65ece6f6f454$export$f758c4a492381d2(res, key, layer, clientId, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const queryArgs = [];
        if (clientId !== undefined) queryArgs.push("clientId=" + encodeURIComponent(clientId.valueOf()));
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/studio/layers/${res}/${key}/${layer}${queryArgs.length ? "?" + queryArgs.join("&") : ""}`, {
            method: "delete",
            headers: headers
        });
        if (_res.status >= 200 && _res.status <= 299) return;
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
function $a20f65ece6f6f454$export$37e5e152c35a81de(e) {
    return e && typeof e === "object" && "type" in e && (e.type === "Forbidden" || e.type === "NotFound" || e.type === "Conflict");
}
/** Saves the operations in the given layer into the base layer, and updates the
target document. */ (0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "mergeLayer",
    func: $a20f65ece6f6f454$export$a45fc67a54b28134
});
async function $a20f65ece6f6f454$export$a45fc67a54b28134(res, key, layer, clientId, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const queryArgs = [];
        if (clientId !== undefined) queryArgs.push("clientId=" + encodeURIComponent(clientId.valueOf()));
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/studio/layers/${res}/${key}/${layer}/merge${queryArgs.length ? "?" + queryArgs.join("&") : ""}`, {
            method: "post",
            headers: headers
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
function $a20f65ece6f6f454$export$c0ba2c8930153e5(e) {
    return e && typeof e === "object" && "type" in e && (e.type === "BadRequest" || e.type === "Forbidden" || e.type === "NotFound" || e.type === "Unauthorized" || e.type === "Conflict" || e.type === "JWTPropertyMissing");
}
(0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "getWebPage",
    func: $a20f65ece6f6f454$export$a4ac49d5f0db027
});
async function $a20f65ece6f6f454$export$a4ac49d5f0db027(locale, slug, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const queryArgs = [];
        if (locale !== undefined) queryArgs.push("locale=" + encodeURIComponent(locale.valueOf()));
        if (slug !== undefined) queryArgs.push("slug=" + encodeURIComponent(slug.valueOf()));
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/web/page${queryArgs.length ? "?" + queryArgs.join("&") : ""}`, {
            method: "get",
            headers: headers
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
function $a20f65ece6f6f454$export$5ca6db9162f00d86(e) {
    return e && typeof e === "object" && "type" in e && e.type === "NotFound";
}
const $a20f65ece6f6f454$export$29c54f290673783c = (0, $8jB4x.SSRHook)("getWebPage", "GetWebPageDto", undefined, $a20f65ece6f6f454$export$a4ac49d5f0db027, [
    "locale",
    "slug"
], undefined);
/** Returns info about a web page by its ID.

This is useful if you don't have the slug of the page, but you know its ID. */ (0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "getWebPageInfo",
    func: $a20f65ece6f6f454$export$d901911f8f9d3bc
});
async function $a20f65ece6f6f454$export$d901911f8f9d3bc(id, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/web/page-info/${id}`, {
            method: "get",
            headers: headers
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
const $a20f65ece6f6f454$export$93409be67e487a17 = (0, $8jB4x.SSRHook)("getWebPageInfo", "GetWebPageInfoDto", undefined, $a20f65ece6f6f454$export$d901911f8f9d3bc, [
    "id"
], undefined);
/** Validates, checks avaialbility and calculates the price of a phone order. */ (0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "postWebPagesInfos",
    func: $a20f65ece6f6f454$export$29568ed10563ee2d
});
async function $a20f65ece6f6f454$export$29568ed10563ee2d(body, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/web/pages-infos`, {
            method: "post",
            headers: headers,
            body: JSON.stringify(body)
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
const $a20f65ece6f6f454$export$e1cdd2f33e255b36 = (0, $8jB4x.SSRHook)("postWebPagesInfos", undefined, undefined, $a20f65ece6f6f454$export$29568ed10563ee2d, [
    "body"
], undefined);
(0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "getWebMenu",
    func: $a20f65ece6f6f454$export$9dc0d6d3f9d64228
});
async function $a20f65ece6f6f454$export$9dc0d6d3f9d64228(customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/web/menu`, {
            method: "get",
            headers: headers
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
const $a20f65ece6f6f454$export$8b2d152375c92a8 = (0, $8jB4x.SSRHook)("getWebMenu", "WebMenu", undefined, $a20f65ece6f6f454$export$9dc0d6d3f9d64228, [], undefined);
(0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "getWebFooter",
    func: $a20f65ece6f6f454$export$92bff06dc1482e6a
});
async function $a20f65ece6f6f454$export$92bff06dc1482e6a(customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/web/footer`, {
            method: "get",
            headers: headers
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
const $a20f65ece6f6f454$export$313ca8d12a7ed6c1 = (0, $8jB4x.SSRHook)("getWebFooter", "WebFooter", undefined, $a20f65ece6f6f454$export$92bff06dc1482e6a, [], undefined);
(0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "getWebPermissions",
    func: $a20f65ece6f6f454$export$111b1cf667438cea
});
async function $a20f65ece6f6f454$export$111b1cf667438cea(customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/web/permissions`, {
            method: "get",
            headers: headers
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
function $a20f65ece6f6f454$export$83a9e7971b0139fa(e) {
    return e && typeof e === "object" && "type" in e && (e.type === "Unauthorized" || e.type === "JWTPropertyMissing");
}
const $a20f65ece6f6f454$export$9516c399ad75603f = (0, $8jB4x.SSRHook)("getWebPermissions", "GetWebPermissionsDto", undefined, $a20f65ece6f6f454$export$111b1cf667438cea, [], undefined);
(0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "getColorStyles",
    func: $a20f65ece6f6f454$export$aa42d30026ce41b9
});
async function $a20f65ece6f6f454$export$aa42d30026ce41b9(customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $a20f65ece6f6f454$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $a20f65ece6f6f454$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $a20f65ece6f6f454$export$ebe90cb607ad99e.baseUrl) + `/api/studio/color-styles`, {
            method: "get",
            headers: headers
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
const $a20f65ece6f6f454$export$2b7a08e331403047 = (0, $8jB4x.SSRHook)("getColorStyles", "GetColorStylesDto", undefined, $a20f65ece6f6f454$export$aa42d30026ce41b9, [], undefined);

});
parcelRegister("7m9cQ", function(module, exports) {

$parcel$export(module.exports, "server", function () { return $55b1baa4410f7873$export$b4e470744154116f; });

var $lDBHC = parcelRequire("lDBHC");
var $55b1baa4410f7873$var$_a;
// This hack allows us to not have a hard dependency on async-hooks on the
// client side
let $55b1baa4410f7873$var$getServer = ()=>"<not-initialized>";
if ((0, $lDBHC.IsNode)()) $55b1baa4410f7873$var$getServer = ($55b1baa4410f7873$var$_a = globalThis.ReactorContext) === null || $55b1baa4410f7873$var$_a === void 0 ? void 0 : $55b1baa4410f7873$var$_a.getServer;
const $55b1baa4410f7873$var$serverBaseUrl = (0, $lDBHC.IsNode)() ? undefined : undefined;
function $55b1baa4410f7873$export$b4e470744154116f(/** If set to `true`, the local IP address will be used instead of localhost
 * when a local browser is accessing the local server.
 *
 * This makes it possible for external services (e.g. Gotenberg) to access
 * the local server.
 */ preferLocalIP = false) {
    const srv = (0, $lDBHC.IsNode)() ? $55b1baa4410f7873$var$serverBaseUrl !== null && $55b1baa4410f7873$var$serverBaseUrl !== void 0 ? $55b1baa4410f7873$var$serverBaseUrl : $55b1baa4410f7873$var$getServer() : window.location.origin;
    if (preferLocalIP && srv === "http://localhost:3000") {
        // In Node, this is set by `Context.ts`, to give access to the local
        // HTTP server through the local network IP address
        if ("localHttpServer" in globalThis) return globalThis.localHttpServer;
    }
    return srv;
}
globalThis.server = $55b1baa4410f7873$export$b4e470744154116f;

});



parcelRegister("5JGam", function(module, exports) {

$parcel$export(module.exports, "IsEditingContext", function () { return $42d1dd0e4df554d5$export$bbc49a069f6f507f; });
$parcel$export(module.exports, "useIsEditing", function () { return $42d1dd0e4df554d5$export$976ddc6b4d436815; });

var $eeH7J = parcelRequire("eeH7J");
const $42d1dd0e4df554d5$export$bbc49a069f6f507f = /*#__PURE__*/ (0, $eeH7J.createContext)(false);
function $42d1dd0e4df554d5$export$976ddc6b4d436815() {
    return (0, $eeH7J.useContext)($42d1dd0e4df554d5$export$bbc49a069f6f507f);
}

});

parcelRegister("knIBr", function(module, exports) {

$parcel$export(module.exports, "DummySelectionContext", function () { return $ed688dd11cc626d4$export$75cf08b1467b2706; });
$parcel$export(module.exports, "SelectionContext", function () { return $ed688dd11cc626d4$export$7c7a4fd7f1336e2c; });
$parcel$export(module.exports, "useSelectionContext", function () { return $ed688dd11cc626d4$export$e00efe24d2be88c3; });
$parcel$export(module.exports, "SelectionContextProvider", function () { return $ed688dd11cc626d4$export$48b9cc116e7155cb; });

var $4vwom = parcelRequire("4vwom");

var $eeH7J = parcelRequire("eeH7J");
const $ed688dd11cc626d4$export$75cf08b1467b2706 = {
    /** The object that is selected for inspection */ selectedObject: null,
    setSelectedObject (obj, type) {},
    clearSelectedObject () {}
};
const $ed688dd11cc626d4$export$7c7a4fd7f1336e2c = /*#__PURE__*/ (0, $eeH7J.createContext)(null);
function $ed688dd11cc626d4$export$e00efe24d2be88c3() {
    const context = (0, $eeH7J.useContext)($ed688dd11cc626d4$export$7c7a4fd7f1336e2c);
    if (!context) throw new Error("No selection context");
    return context;
}
function $ed688dd11cc626d4$export$48b9cc116e7155cb({ children: children }) {
    const [_selectedObject, _setSelectedObject] = (0, $eeH7J.useState)(undefined);
    return (0, $4vwom.jsx)($ed688dd11cc626d4$export$7c7a4fd7f1336e2c.Provider, {
        value: {
            selectedObject: _selectedObject === null || _selectedObject === void 0 ? void 0 : _selectedObject.obj,
            selectedObjectType: _selectedObject === null || _selectedObject === void 0 ? void 0 : _selectedObject.type,
            selectedObjectPutType: _selectedObject === null || _selectedObject === void 0 ? void 0 : _selectedObject.putType,
            setSelectedObject (obj, type, putType) {
                _setSelectedObject({
                    obj: obj,
                    type: type,
                    putType: putType
                });
            },
            clearSelectedObject () {
                _setSelectedObject(undefined);
            }
        },
        children: children
    });
}

});

parcelRegister("9ArIY", function(module, exports) {

$parcel$export(module.exports, "YEditor", function () { return $6facfb550b6fb150$export$ac686e6cfed8be6b; });
$parcel$export(module.exports, "useYStaticEditor", function () { return $6facfb550b6fb150$export$1207223c179bdb6a; });

var $dUDPg = parcelRequire("dUDPg");

var $aw3rr = parcelRequire("aw3rr");

var $1aVVn = parcelRequire("1aVVn");

var $f8cmx = parcelRequire("f8cmx");

var $fH7rK = parcelRequire("fH7rK");

var $eeH7J = parcelRequire("eeH7J");

var $3SKqX = parcelRequire("3SKqX");

var $kbk6C = parcelRequire("kbk6C");
parcelRequire("2LTO8");
var $6pFwm = parcelRequire("6pFwm");

var $8vTN8 = parcelRequire("8vTN8");
class $6facfb550b6fb150$export$ac686e6cfed8be6b {
    get yDoc() {
        return this._yDoc;
    }
    get loaded() {
        return this._loaded;
    }
    get hasChanges() {
        return this._hasChanges;
    }
    set hasChanges(value) {
        if (value !== this._hasChanges) {
            this._hasChanges = value;
            if (value) (0, $8vTN8.useNavigate).unsavedChanges.add(this);
            else (0, $8vTN8.useNavigate).unsavedChanges.delete(this);
            const hasChangesListeners = Array.from($6facfb550b6fb150$export$ac686e6cfed8be6b.hasChangesListeners);
            for (const listener of hasChangesListeners)listener();
        }
    }
    /**
     * Returns an YProxy for the root document managed by this container.
     */ get proxy() {
        if (!this._proxy) this._proxy = (0, $f8cmx.YProxy)(this.root);
        return this._proxy;
    }
    /**
     * The root Y.Map or Y.Array of the document.
     */ get root() {
        return (0, $1aVVn.YTools).getRoot(this._yDoc);
    }
    /**
     * The plain JSON representation of the document.
     *
     * When reading, this will return the JSON representation of the document.
     *
     * When writing, this will set the document to the given JSON value, by diffing the current
     * document with the new value and applying the changes.
     */ get doc() {
        if (this.mode !== "interactive" || !this._docCache) this._docCache = (0, $1aVVn.YTools).valueToJSON(this.root);
        return this._docCache;
    }
    set doc(newDoc) {
        this._docCache = (0, $1aVVn.YTools).applyDiff(this._yDoc, newDoc);
    }
    /**
     * Discard changes on all open editors.
     */ static async discardChanges() {
        const snapshot = $6facfb550b6fb150$export$ac686e6cfed8be6b.editors.slice();
        for (const listener of snapshot)await listener.discardChanges();
    }
    /**
     * Save changes on all open editors.
     */ static async saveChanges() {
        // Need to snapshot the set, in case the save operation modifies
        // the set of listeners.
        const snapshot = $6facfb550b6fb150$export$ac686e6cfed8be6b.editors.slice();
        for (const listener of snapshot)await listener.saveChanges();
    }
    constructor(res, key, layer, /**
     * The name of the resource type.
     *
     * For endpoints, this corresponds to the GET-endpoint's return body.
     */ typeName, /**
     * The name of the resource PUT-endpoint requestbody, if different from
     * the resource type.
     *
     * When editing the resource, only the fields in that exist in both the
     * GET- and PUT-endpoint payload will be editable.
     */ putTypeName, /**
     * Called when the root document changes.
     */ invalidate, /**
     * Called when the UI should be reset (e.g. after a discard).
     */ reset){
        this.res = res;
        this.key = key;
        this.layer = layer;
        this.typeName = typeName;
        this.putTypeName = putTypeName;
        this.invalidate = invalidate;
        this.reset = reset;
        this._yDoc = new $aw3rr.Doc();
        this._layerVersion = -1;
        this._isLoading = false;
        this._loaded = false;
        this._hasChanges = false;
        this._docCache = undefined;
        this.mode = "static";
        /**
         * Saves the changes made to the document.
         *
         * Can be overwritten to provide custom behavior.
         */ this.saveChanges = async ()=>{
            return await (0, $fH7rK.CallEndpointWithSoftErrors)("mergeLayer", [
                this.res,
                this.key,
                this.layer,
                (0, $3SKqX.useChangeNotifications).clientId
            ], []);
        };
        /**
         * Discards the changes made to the document.
         *
         * Can be overwritten to provide custom behavior.
         */ this.discardChanges = async ()=>{
            if (this.key) {
                this._layerVersion = -1;
                this.resetYDoc();
                await (0, $dUDPg.discardLayerUpdates)(this.res, this.key, this.layer, (0, $3SKqX.useChangeNotifications).clientId);
            }
        };
        this._yDoc = new $aw3rr.Doc();
        $6facfb550b6fb150$export$ac686e6cfed8be6b.editors.push(this);
    }
    destroy() {
        (0, $8vTN8.useNavigate).unsavedChanges.delete(this);
        this._yDoc.destroy();
        const idx = $6facfb550b6fb150$export$ac686e6cfed8be6b.editors.indexOf(this);
        if (idx >= 0) $6facfb550b6fb150$export$ac686e6cfed8be6b.editors.splice(idx, 1);
    }
    static async allPostOperations() {
        if (this._postOperations.length === 0) return;
        const ops = this._postOperations.slice();
        await Promise.all(ops);
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this._postOperations = this._postOperations.filter((op)=>!ops.includes(op));
    }
    resetYDoc() {
        this._yDoc.destroy();
        this._proxy = undefined;
        this._yDoc = new $aw3rr.Doc();
        this._loaded = false;
        this._layerVersion = -1;
        if (this.mode === "interactive") this._yDoc.on("update", async (data, origin)=>{
            // Drop the cache on both local and remote updates
            this._docCache = undefined;
            // We are currently loading the initial state, so we don't want to
            // post individual updates to the server. The load() method will
            // take care of syncing the document once loading is done.
            if (this._isLoading) return;
            if (origin !== "sync") {
                if (!this.key) throw new Error("Primary key is required for interactive mode");
                const postOp = (0, $dUDPg.postLayerUpdates)(this.res, this.key, this.layer, {
                    data: (0, $1aVVn.YTools).uint8ArrayToBase64(data),
                    clientId: (0, $3SKqX.useChangeNotifications).clientId,
                    version: this._layerVersion
                });
                $6facfb550b6fb150$export$ac686e6cfed8be6b._postOperations.push(postOp);
                const res = await postOp;
                this.handleUpdates(res);
            }
        });
    }
    /**
     * Starts an interactive session with the given document.
     *
     */ async initInteractive(originalDoc) {
        this.originalDoc = (0, $6pFwm.Clone)(originalDoc);
        this.mode = "interactive";
        this.resetYDoc();
        await this.fetchUpdates();
        this._loaded = true;
        this.invalidate();
    }
    /**
     * Starts a static (view-only) session with the given document.
     *
     * This will not sync the document with the server, and will not receive
     * updates from the server.
     */ async initStatic(newDoc) {
        this.originalDoc = (0, $6pFwm.Clone)(newDoc);
        this.mode = "static";
        this._yDoc.destroy();
        this._yDoc = new $aw3rr.Doc();
        this._proxy = undefined;
        this._isLoading = true;
        try {
            (0, $1aVVn.YTools).loadDoc(this._yDoc, newDoc);
        } finally{
            this._isLoading = false;
        }
        this._loaded = true;
        this.invalidate();
    }
    async fetchUpdates() {
        if (!this.key) return;
        await $6facfb550b6fb150$export$ac686e6cfed8be6b.allPostOperations();
        const res = await (0, $dUDPg.getLayerUpdates)(this.res, this.key, this.layer, this._layerVersion);
        this.handleUpdates(res);
    }
    handleUpdates(res) {
        for (const update of res.ops)$aw3rr.applyUpdate(this._yDoc, (0, $1aVVn.YTools).base64ToUint8Array(update), "sync");
        const diff = (0, $kbk6C.compare)(this.doc, this.originalDoc);
        this.hasChanges = diff.length > 0;
        this._loaded = true;
        this._layerVersion = Math.max(this._layerVersion, res.version);
    }
}
/**
 * All currently open YEditors.
 */ $6facfb550b6fb150$export$ac686e6cfed8be6b.editors = [];
$6facfb550b6fb150$export$ac686e6cfed8be6b.hasChangesListeners = new Set();
$6facfb550b6fb150$export$ac686e6cfed8be6b._postOperations = [];
function $6facfb550b6fb150$export$1207223c179bdb6a(initialValue) {
    const [, setVersion] = (0, $eeH7J.useState)({});
    const [editor, setEditor] = (0, $eeH7J.useState)(()=>{
        const e = new $6facfb550b6fb150$export$ac686e6cfed8be6b("STATIC", "STATIC", "draft", "unknown", undefined, ()=>setVersion({}));
        e.initStatic(initialValue).then(()=>setEditor(e));
        return e;
    });
    (0, $eeH7J.useEffect)(()=>{
        return ()=>{
            editor.destroy();
        };
    // On purpose not depending on anything, as we simply want the cleanup to run
    // when the component umounts
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return editor;
}

});
parcelRegister("aw3rr", function(module, exports) {

$parcel$export(module.exports, "Doc", function () { return $fd9bbcd8ab314c6e$export$bceacc74c2212615; });
$parcel$export(module.exports, "transact", function () { return $fd9bbcd8ab314c6e$export$dac1bad6146b2469; });
$parcel$export(module.exports, "Array", function () { return $fd9bbcd8ab314c6e$export$c4be6576ca6fe4aa; });
$parcel$export(module.exports, "Map", function () { return $fd9bbcd8ab314c6e$export$a5c7b93649eaf8f8; });
$parcel$export(module.exports, "applyUpdate", function () { return $fd9bbcd8ab314c6e$export$c271737a9c02e925; });
$parcel$export(module.exports, "createRelativePositionFromJSON", function () { return $fd9bbcd8ab314c6e$export$ddad8a1b8f7475d8; });
$parcel$export(module.exports, "createRelativePositionFromTypeIndex", function () { return $fd9bbcd8ab314c6e$export$197e7d99e3857e88; });
$parcel$export(module.exports, "encodeRelativePosition", function () { return $fd9bbcd8ab314c6e$export$c5c95ef724203575; });
$parcel$export(module.exports, "decodeRelativePosition", function () { return $fd9bbcd8ab314c6e$export$58a46cebc90e7851; });
$parcel$export(module.exports, "createAbsolutePositionFromRelativePosition", function () { return $fd9bbcd8ab314c6e$export$8fc3152f62fb7ed1; });
$parcel$export(module.exports, "compareRelativePositions", function () { return $fd9bbcd8ab314c6e$export$fc8bd253c948b475; });
$parcel$export(module.exports, "UndoManager", function () { return $fd9bbcd8ab314c6e$export$932a3f9a7e88971c; });
$parcel$export(module.exports, "YTextEvent", function () { return $fd9bbcd8ab314c6e$export$51155b8ebb74188a; });
$parcel$export(module.exports, "XmlText", function () { return $fd9bbcd8ab314c6e$export$b35b8f45887823df; });

var $jFoCq = parcelRequire("jFoCq");

var $8aHnL = parcelRequire("8aHnL");

var $6O4IB = parcelRequire("6O4IB");

var $2U6oo = parcelRequire("2U6oo");

var $apPNa = parcelRequire("apPNa");

var $dW8Wq = parcelRequire("dW8Wq");

var $APxPC = parcelRequire("APxPC");

var $kCw4e = parcelRequire("kCw4e");

var $800Lz = parcelRequire("800Lz");

var $lqCPr = parcelRequire("lqCPr");

var $jnoaM = parcelRequire("jnoaM");

var $5VoPh = parcelRequire("5VoPh");

var $eq375 = parcelRequire("eq375");
parcelRequire("6nwkt");
var $esuCY = parcelRequire("esuCY");
var $6nwkt = parcelRequire("6nwkt");

var $7neOC = parcelRequire("7neOC");

var $8YS3b = parcelRequire("8YS3b");

var $59LwD = parcelRequire("59LwD");

var $8u9N6 = parcelRequire("8u9N6");

var $3LZef = parcelRequire("3LZef");
/**
 * This is an abstract interface that all Connectors should implement to keep them interchangeable.
 *
 * @note This interface is experimental and it is not advised to actually inherit this class.
 *       It just serves as typing information.
 *
 * @extends {ObservableV2<any>}
 */ class $fd9bbcd8ab314c6e$export$c3faceeb92aa39dd extends (0, $jFoCq.ObservableV2) {
    /**
   * @param {Doc} ydoc
   * @param {any} awareness
   */ constructor(ydoc, awareness){
        super();
        this.doc = ydoc;
        this.awareness = awareness;
    }
}
class $fd9bbcd8ab314c6e$var$DeleteItem {
    /**
   * @param {number} clock
   * @param {number} len
   */ constructor(clock, len){
        /**
     * @type {number}
     */ this.clock = clock;
        /**
     * @type {number}
     */ this.len = len;
    }
}
/**
 * We no longer maintain a DeleteStore. DeleteSet is a temporary object that is created when needed.
 * - When created in a transaction, it must only be accessed after sorting, and merging
 *   - This DeleteSet is send to other clients
 * - We do not create a DeleteSet when we send a sync message. The DeleteSet message is created directly from StructStore
 * - We read a DeleteSet as part of a sync/update message. In this case the DeleteSet is already sorted and merged.
 */ class $fd9bbcd8ab314c6e$var$DeleteSet {
    constructor(){
        /**
     * @type {Map<number,Array<DeleteItem>>}
     */ this.clients = new Map();
    }
}
/**
 * Iterate over all structs that the DeleteSet gc's.
 *
 * @param {Transaction} transaction
 * @param {DeleteSet} ds
 * @param {function(GC|Item):void} f
 *
 * @function
 */ const $fd9bbcd8ab314c6e$export$8afefebbaf4e4c78 = (transaction, ds, f)=>ds.clients.forEach((deletes, clientid)=>{
        const structs = /** @type {Array<GC|Item>} */ transaction.doc.store.clients.get(clientid);
        for(let i = 0; i < deletes.length; i++){
            const del = deletes[i];
            $fd9bbcd8ab314c6e$var$iterateStructs(transaction, structs, del.clock, del.len, f);
        }
    });
/**
 * @param {Array<DeleteItem>} dis
 * @param {number} clock
 * @return {number|null}
 *
 * @private
 * @function
 */ const $fd9bbcd8ab314c6e$var$findIndexDS = (dis, clock)=>{
    let left = 0;
    let right = dis.length - 1;
    while(left <= right){
        const midindex = $6O4IB.floor((left + right) / 2);
        const mid = dis[midindex];
        const midclock = mid.clock;
        if (midclock <= clock) {
            if (clock < midclock + mid.len) return midindex;
            left = midindex + 1;
        } else right = midindex - 1;
    }
    return null;
};
/**
 * @param {DeleteSet} ds
 * @param {ID} id
 * @return {boolean}
 *
 * @private
 * @function
 */ const $fd9bbcd8ab314c6e$export$dcb04af092e44fde = (ds, id)=>{
    const dis = ds.clients.get(id.client);
    return dis !== undefined && $fd9bbcd8ab314c6e$var$findIndexDS(dis, id.clock) !== null;
};
/**
 * @param {DeleteSet} ds
 *
 * @private
 * @function
 */ const $fd9bbcd8ab314c6e$var$sortAndMergeDeleteSet = (ds)=>{
    ds.clients.forEach((dels)=>{
        dels.sort((a, b)=>a.clock - b.clock);
        // merge items without filtering or splicing the array
        // i is the current pointer
        // j refers to the current insert position for the pointed item
        // try to merge dels[i] into dels[j-1] or set dels[j]=dels[i]
        let i, j;
        for(i = 1, j = 1; i < dels.length; i++){
            const left = dels[j - 1];
            const right = dels[i];
            if (left.clock + left.len >= right.clock) left.len = $6O4IB.max(left.len, right.clock + right.len - left.clock);
            else {
                if (j < i) dels[j] = right;
                j++;
            }
        }
        dels.length = j;
    });
};
/**
 * @param {Array<DeleteSet>} dss
 * @return {DeleteSet} A fresh DeleteSet
 */ const $fd9bbcd8ab314c6e$export$b7826cadad53901e = (dss)=>{
    const merged = new $fd9bbcd8ab314c6e$var$DeleteSet();
    for(let dssI = 0; dssI < dss.length; dssI++)dss[dssI].clients.forEach((delsLeft, client)=>{
        if (!merged.clients.has(client)) {
            // Write all missing keys from current ds and all following.
            // If merged already contains `client` current ds has already been added.
            /**
         * @type {Array<DeleteItem>}
         */ const dels = delsLeft.slice();
            for(let i = dssI + 1; i < dss.length; i++)$8aHnL.appendTo(dels, dss[i].clients.get(client) || []);
            merged.clients.set(client, dels);
        }
    });
    $fd9bbcd8ab314c6e$var$sortAndMergeDeleteSet(merged);
    return merged;
};
/**
 * @param {DeleteSet} ds
 * @param {number} client
 * @param {number} clock
 * @param {number} length
 *
 * @private
 * @function
 */ const $fd9bbcd8ab314c6e$var$addToDeleteSet = (ds, client, clock, length)=>{
    $2U6oo.setIfUndefined(ds.clients, client, ()=>/** @type {Array<DeleteItem>} */ []).push(new $fd9bbcd8ab314c6e$var$DeleteItem(clock, length));
};
const $fd9bbcd8ab314c6e$export$8cbac0d946238699 = ()=>new $fd9bbcd8ab314c6e$var$DeleteSet();
/**
 * @param {StructStore} ss
 * @return {DeleteSet} Merged and sorted DeleteSet
 *
 * @private
 * @function
 */ const $fd9bbcd8ab314c6e$export$8450d668bec558e2 = (ss)=>{
    const ds = $fd9bbcd8ab314c6e$export$8cbac0d946238699();
    ss.clients.forEach((structs, client)=>{
        /**
     * @type {Array<DeleteItem>}
     */ const dsitems = [];
        for(let i = 0; i < structs.length; i++){
            const struct = structs[i];
            if (struct.deleted) {
                const clock = struct.id.clock;
                let len = struct.length;
                if (i + 1 < structs.length) for(let next = structs[i + 1]; i + 1 < structs.length && next.deleted; next = structs[++i + 1])len += next.length;
                dsitems.push(new $fd9bbcd8ab314c6e$var$DeleteItem(clock, len));
            }
        }
        if (dsitems.length > 0) ds.clients.set(client, dsitems);
    });
    return ds;
};
/**
 * @param {DSEncoderV1 | DSEncoderV2} encoder
 * @param {DeleteSet} ds
 *
 * @private
 * @function
 */ const $fd9bbcd8ab314c6e$var$writeDeleteSet = (encoder, ds)=>{
    $apPNa.writeVarUint(encoder.restEncoder, ds.clients.size);
    // Ensure that the delete set is written in a deterministic order
    $8aHnL.from(ds.clients.entries()).sort((a, b)=>b[0] - a[0]).forEach(([client, dsitems])=>{
        encoder.resetDsCurVal();
        $apPNa.writeVarUint(encoder.restEncoder, client);
        const len = dsitems.length;
        $apPNa.writeVarUint(encoder.restEncoder, len);
        for(let i = 0; i < len; i++){
            const item = dsitems[i];
            encoder.writeDsClock(item.clock);
            encoder.writeDsLen(item.len);
        }
    });
};
/**
 * @param {DSDecoderV1 | DSDecoderV2} decoder
 * @return {DeleteSet}
 *
 * @private
 * @function
 */ const $fd9bbcd8ab314c6e$var$readDeleteSet = (decoder)=>{
    const ds = new $fd9bbcd8ab314c6e$var$DeleteSet();
    const numClients = $dW8Wq.readVarUint(decoder.restDecoder);
    for(let i = 0; i < numClients; i++){
        decoder.resetDsCurVal();
        const client = $dW8Wq.readVarUint(decoder.restDecoder);
        const numberOfDeletes = $dW8Wq.readVarUint(decoder.restDecoder);
        if (numberOfDeletes > 0) {
            const dsField = $2U6oo.setIfUndefined(ds.clients, client, ()=>/** @type {Array<DeleteItem>} */ []);
            for(let i = 0; i < numberOfDeletes; i++)dsField.push(new $fd9bbcd8ab314c6e$var$DeleteItem(decoder.readDsClock(), decoder.readDsLen()));
        }
    }
    return ds;
};
/**
 * @todo YDecoder also contains references to String and other Decoders. Would make sense to exchange YDecoder.toUint8Array for YDecoder.DsToUint8Array()..
 */ /**
 * @param {DSDecoderV1 | DSDecoderV2} decoder
 * @param {Transaction} transaction
 * @param {StructStore} store
 * @return {Uint8Array|null} Returns a v2 update containing all deletes that couldn't be applied yet; or null if all deletes were applied successfully.
 *
 * @private
 * @function
 */ const $fd9bbcd8ab314c6e$var$readAndApplyDeleteSet = (decoder, transaction, store)=>{
    const unappliedDS = new $fd9bbcd8ab314c6e$var$DeleteSet();
    const numClients = $dW8Wq.readVarUint(decoder.restDecoder);
    for(let i = 0; i < numClients; i++){
        decoder.resetDsCurVal();
        const client = $dW8Wq.readVarUint(decoder.restDecoder);
        const numberOfDeletes = $dW8Wq.readVarUint(decoder.restDecoder);
        const structs = store.clients.get(client) || [];
        const state = $fd9bbcd8ab314c6e$export$50fdfeece43146fd(store, client);
        for(let i = 0; i < numberOfDeletes; i++){
            const clock = decoder.readDsClock();
            const clockEnd = clock + decoder.readDsLen();
            if (clock < state) {
                if (state < clockEnd) $fd9bbcd8ab314c6e$var$addToDeleteSet(unappliedDS, client, state, clockEnd - state);
                let index = $fd9bbcd8ab314c6e$export$5f8f02523cf47b58(structs, clock);
                /**
         * We can ignore the case of GC and Delete structs, because we are going to skip them
         * @type {Item}
         */ // @ts-ignore
                let struct = structs[index];
                // split the first item if necessary
                if (!struct.deleted && struct.id.clock < clock) {
                    structs.splice(index + 1, 0, $fd9bbcd8ab314c6e$var$splitItem(transaction, struct, clock - struct.id.clock));
                    index++; // increase we now want to use the next struct
                }
                while(index < structs.length){
                    // @ts-ignore
                    struct = structs[index++];
                    if (struct.id.clock < clockEnd) {
                        if (!struct.deleted) {
                            if (clockEnd < struct.id.clock + struct.length) structs.splice(index, 0, $fd9bbcd8ab314c6e$var$splitItem(transaction, struct, clockEnd - struct.id.clock));
                            struct.delete(transaction);
                        }
                    } else break;
                }
            } else $fd9bbcd8ab314c6e$var$addToDeleteSet(unappliedDS, client, clock, clockEnd - clock);
        }
    }
    if (unappliedDS.clients.size > 0) {
        const ds = new $fd9bbcd8ab314c6e$export$30c99e08943e1c2();
        $apPNa.writeVarUint(ds.restEncoder, 0); // encode 0 structs
        $fd9bbcd8ab314c6e$var$writeDeleteSet(ds, unappliedDS);
        return ds.toUint8Array();
    }
    return null;
};
/**
 * @param {DeleteSet} ds1
 * @param {DeleteSet} ds2
 */ const $fd9bbcd8ab314c6e$export$9697b72c46fd3a5d = (ds1, ds2)=>{
    if (ds1.clients.size !== ds2.clients.size) return false;
    for (const [client, deleteItems1] of ds1.clients.entries()){
        const deleteItems2 = /** @type {Array<import('../internals.js').DeleteItem>} */ ds2.clients.get(client);
        if (deleteItems2 === undefined || deleteItems1.length !== deleteItems2.length) return false;
        for(let i = 0; i < deleteItems1.length; i++){
            const di1 = deleteItems1[i];
            const di2 = deleteItems2[i];
            if (di1.clock !== di2.clock || di1.len !== di2.len) return false;
        }
    }
    return true;
};
/**
 * @module Y
 */ const $fd9bbcd8ab314c6e$var$generateNewClientId = $APxPC.uint32;
/**
 * @typedef {Object} DocOpts
 * @property {boolean} [DocOpts.gc=true] Disable garbage collection (default: gc=true)
 * @property {function(Item):boolean} [DocOpts.gcFilter] Will be called before an Item is garbage collected. Return false to keep the Item.
 * @property {string} [DocOpts.guid] Define a globally unique identifier for this document
 * @property {string | null} [DocOpts.collectionid] Associate this document with a collection. This only plays a role if your provider has a concept of collection.
 * @property {any} [DocOpts.meta] Any kind of meta information you want to associate with this document. If this is a subdocument, remote peers will store the meta information as well.
 * @property {boolean} [DocOpts.autoLoad] If a subdocument, automatically load document. If this is a subdocument, remote peers will load the document as well automatically.
 * @property {boolean} [DocOpts.shouldLoad] Whether the document should be synced by the provider now. This is toggled to true when you call ydoc.load()
 */ /**
 * @typedef {Object} DocEvents
 * @property {function(Doc):void} DocEvents.destroy
 * @property {function(Doc):void} DocEvents.load
 * @property {function(boolean, Doc):void} DocEvents.sync
 * @property {function(Uint8Array, any, Doc, Transaction):void} DocEvents.update
 * @property {function(Uint8Array, any, Doc, Transaction):void} DocEvents.updateV2
 * @property {function(Doc):void} DocEvents.beforeAllTransactions
 * @property {function(Transaction, Doc):void} DocEvents.beforeTransaction
 * @property {function(Transaction, Doc):void} DocEvents.beforeObserverCalls
 * @property {function(Transaction, Doc):void} DocEvents.afterTransaction
 * @property {function(Transaction, Doc):void} DocEvents.afterTransactionCleanup
 * @property {function(Doc, Array<Transaction>):void} DocEvents.afterAllTransactions
 * @property {function({ loaded: Set<Doc>, added: Set<Doc>, removed: Set<Doc> }, Doc, Transaction):void} DocEvents.subdocs
 */ /**
 * A Yjs instance handles the state of shared data.
 * @extends ObservableV2<DocEvents>
 */ class $fd9bbcd8ab314c6e$export$bceacc74c2212615 extends (0, $jFoCq.ObservableV2) {
    /**
   * @param {DocOpts} opts configuration
   */ constructor({ guid: guid = $APxPC.uuidv4(), collectionid: collectionid = null, gc: gc = true, gcFilter: gcFilter = ()=>true, meta: meta = null, autoLoad: autoLoad = false, shouldLoad: shouldLoad = true } = {}){
        super();
        this.gc = gc;
        this.gcFilter = gcFilter;
        this.clientID = $fd9bbcd8ab314c6e$var$generateNewClientId();
        this.guid = guid;
        this.collectionid = collectionid;
        /**
     * @type {Map<string, AbstractType<YEvent<any>>>}
     */ this.share = new Map();
        this.store = new $fd9bbcd8ab314c6e$var$StructStore();
        /**
     * @type {Transaction | null}
     */ this._transaction = null;
        /**
     * @type {Array<Transaction>}
     */ this._transactionCleanups = [];
        /**
     * @type {Set<Doc>}
     */ this.subdocs = new Set();
        /**
     * If this document is a subdocument - a document integrated into another document - then _item is defined.
     * @type {Item?}
     */ this._item = null;
        this.shouldLoad = shouldLoad;
        this.autoLoad = autoLoad;
        this.meta = meta;
        /**
     * This is set to true when the persistence provider loaded the document from the database or when the `sync` event fires.
     * Note that not all providers implement this feature. Provider authors are encouraged to fire the `load` event when the doc content is loaded from the database.
     *
     * @type {boolean}
     */ this.isLoaded = false;
        /**
     * This is set to true when the connection provider has successfully synced with a backend.
     * Note that when using peer-to-peer providers this event may not provide very useful.
     * Also note that not all providers implement this feature. Provider authors are encouraged to fire
     * the `sync` event when the doc has been synced (with `true` as a parameter) or if connection is
     * lost (with false as a parameter).
     */ this.isSynced = false;
        this.isDestroyed = false;
        /**
     * Promise that resolves once the document has been loaded from a presistence provider.
     */ this.whenLoaded = $kCw4e.create((resolve)=>{
            this.on("load", ()=>{
                this.isLoaded = true;
                resolve(this);
            });
        });
        const provideSyncedPromise = ()=>$kCw4e.create((resolve)=>{
                /**
       * @param {boolean} isSynced
       */ const eventHandler = (isSynced)=>{
                    if (isSynced === undefined || isSynced === true) {
                        this.off("sync", eventHandler);
                        resolve();
                    }
                };
                this.on("sync", eventHandler);
            });
        this.on("sync", (isSynced)=>{
            if (isSynced === false && this.isSynced) this.whenSynced = provideSyncedPromise();
            this.isSynced = isSynced === undefined || isSynced === true;
            if (this.isSynced && !this.isLoaded) this.emit("load", [
                this
            ]);
        });
        /**
     * Promise that resolves once the document has been synced with a backend.
     * This promise is recreated when the connection is lost.
     * Note the documentation about the `isSynced` property.
     */ this.whenSynced = provideSyncedPromise();
    }
    /**
   * Notify the parent document that you request to load data into this subdocument (if it is a subdocument).
   *
   * `load()` might be used in the future to request any provider to load the most current data.
   *
   * It is safe to call `load()` multiple times.
   */ load() {
        const item = this._item;
        if (item !== null && !this.shouldLoad) $fd9bbcd8ab314c6e$export$dac1bad6146b2469(/** @type {any} */ item.parent.doc, (transaction)=>{
            transaction.subdocsLoaded.add(this);
        }, null, true);
        this.shouldLoad = true;
    }
    getSubdocs() {
        return this.subdocs;
    }
    getSubdocGuids() {
        return new Set($8aHnL.from(this.subdocs).map((doc)=>doc.guid));
    }
    /**
   * Changes that happen inside of a transaction are bundled. This means that
   * the observer fires _after_ the transaction is finished and that all changes
   * that happened inside of the transaction are sent as one message to the
   * other peers.
   *
   * @template T
   * @param {function(Transaction):T} f The function that should be executed as a transaction
   * @param {any} [origin] Origin of who started the transaction. Will be stored on transaction.origin
   * @return T
   *
   * @public
   */ transact(f, origin = null) {
        return $fd9bbcd8ab314c6e$export$dac1bad6146b2469(this, f, origin);
    }
    /**
   * Define a shared data type.
   *
   * Multiple calls of `ydoc.get(name, TypeConstructor)` yield the same result
   * and do not overwrite each other. I.e.
   * `ydoc.get(name, Y.Array) === ydoc.get(name, Y.Array)`
   *
   * After this method is called, the type is also available on `ydoc.share.get(name)`.
   *
   * *Best Practices:*
   * Define all types right after the Y.Doc instance is created and store them in a separate object.
   * Also use the typed methods `getText(name)`, `getArray(name)`, ..
   *
   * @template {typeof AbstractType<any>} Type
   * @example
   *   const ydoc = new Y.Doc(..)
   *   const appState = {
   *     document: ydoc.getText('document')
   *     comments: ydoc.getArray('comments')
   *   }
   *
   * @param {string} name
   * @param {Type} TypeConstructor The constructor of the type definition. E.g. Y.Text, Y.Array, Y.Map, ...
   * @return {InstanceType<Type>} The created type. Constructed with TypeConstructor
   *
   * @public
   */ get(name, TypeConstructor = /** @type {any} */ $fd9bbcd8ab314c6e$export$c265dc8338484497) {
        const type = $2U6oo.setIfUndefined(this.share, name, ()=>{
            // @ts-ignore
            const t = new TypeConstructor();
            t._integrate(this, null);
            return t;
        });
        const Constr = type.constructor;
        if (TypeConstructor !== $fd9bbcd8ab314c6e$export$c265dc8338484497 && Constr !== TypeConstructor) {
            if (Constr === $fd9bbcd8ab314c6e$export$c265dc8338484497) {
                // @ts-ignore
                const t = new TypeConstructor();
                t._map = type._map;
                type._map.forEach(/** @param {Item?} n */ (n)=>{
                    for(; n !== null; n = n.left)// @ts-ignore
                    n.parent = t;
                });
                t._start = type._start;
                for(let n = t._start; n !== null; n = n.right)n.parent = t;
                t._length = type._length;
                this.share.set(name, t);
                t._integrate(this, null);
                return /** @type {InstanceType<Type>} */ t;
            } else throw new Error(`Type with the name ${name} has already been defined with a different constructor`);
        }
        return /** @type {InstanceType<Type>} */ type;
    }
    /**
   * @template T
   * @param {string} [name]
   * @return {YArray<T>}
   *
   * @public
   */ getArray(name = "") {
        return /** @type {YArray<T>} */ this.get(name, $fd9bbcd8ab314c6e$export$c4be6576ca6fe4aa);
    }
    /**
   * @param {string} [name]
   * @return {YText}
   *
   * @public
   */ getText(name = "") {
        return this.get(name, $fd9bbcd8ab314c6e$export$5f1af8db9871e1d6);
    }
    /**
   * @template T
   * @param {string} [name]
   * @return {YMap<T>}
   *
   * @public
   */ getMap(name = "") {
        return /** @type {YMap<T>} */ this.get(name, $fd9bbcd8ab314c6e$export$a5c7b93649eaf8f8);
    }
    /**
   * @param {string} [name]
   * @return {YXmlElement}
   *
   * @public
   */ getXmlElement(name = "") {
        return /** @type {YXmlElement<{[key:string]:string}>} */ this.get(name, $fd9bbcd8ab314c6e$export$4db87581d3ca170d);
    }
    /**
   * @param {string} [name]
   * @return {YXmlFragment}
   *
   * @public
   */ getXmlFragment(name = "") {
        return this.get(name, $fd9bbcd8ab314c6e$export$d5ce8c3e1731f1a7);
    }
    /**
   * Converts the entire document into a js object, recursively traversing each yjs type
   * Doesn't log types that have not been defined (using ydoc.getType(..)).
   *
   * @deprecated Do not use this method and rather call toJSON directly on the shared types.
   *
   * @return {Object<string, any>}
   */ toJSON() {
        /**
     * @type {Object<string, any>}
     */ const doc = {};
        this.share.forEach((value, key)=>{
            doc[key] = value.toJSON();
        });
        return doc;
    }
    /**
   * Emit `destroy` event and unregister all event handlers.
   */ destroy() {
        this.isDestroyed = true;
        $8aHnL.from(this.subdocs).forEach((subdoc)=>subdoc.destroy());
        const item = this._item;
        if (item !== null) {
            this._item = null;
            const content = /** @type {ContentDoc} */ item.content;
            content.doc = new $fd9bbcd8ab314c6e$export$bceacc74c2212615({
                guid: this.guid,
                ...content.opts,
                shouldLoad: false
            });
            content.doc._item = item;
            $fd9bbcd8ab314c6e$export$dac1bad6146b2469(/** @type {any} */ item.parent.doc, (transaction)=>{
                const doc = content.doc;
                if (!item.deleted) transaction.subdocsAdded.add(doc);
                transaction.subdocsRemoved.add(this);
            }, null, true);
        }
        // @ts-ignore
        this.emit("destroyed", [
            true
        ]); // DEPRECATED!
        this.emit("destroy", [
            this
        ]);
        super.destroy();
    }
}
class $fd9bbcd8ab314c6e$var$DSDecoderV1 {
    /**
   * @param {decoding.Decoder} decoder
   */ constructor(decoder){
        this.restDecoder = decoder;
    }
    resetDsCurVal() {
    // nop
    }
    /**
   * @return {number}
   */ readDsClock() {
        return $dW8Wq.readVarUint(this.restDecoder);
    }
    /**
   * @return {number}
   */ readDsLen() {
        return $dW8Wq.readVarUint(this.restDecoder);
    }
}
class $fd9bbcd8ab314c6e$export$1aa46d9818b5d1ec extends $fd9bbcd8ab314c6e$var$DSDecoderV1 {
    /**
   * @return {ID}
   */ readLeftID() {
        return $fd9bbcd8ab314c6e$export$6c7d4e6171d008d0($dW8Wq.readVarUint(this.restDecoder), $dW8Wq.readVarUint(this.restDecoder));
    }
    /**
   * @return {ID}
   */ readRightID() {
        return $fd9bbcd8ab314c6e$export$6c7d4e6171d008d0($dW8Wq.readVarUint(this.restDecoder), $dW8Wq.readVarUint(this.restDecoder));
    }
    /**
   * Read the next client id.
   * Use this in favor of readID whenever possible to reduce the number of objects created.
   */ readClient() {
        return $dW8Wq.readVarUint(this.restDecoder);
    }
    /**
   * @return {number} info An unsigned 8-bit integer
   */ readInfo() {
        return $dW8Wq.readUint8(this.restDecoder);
    }
    /**
   * @return {string}
   */ readString() {
        return $dW8Wq.readVarString(this.restDecoder);
    }
    /**
   * @return {boolean} isKey
   */ readParentInfo() {
        return $dW8Wq.readVarUint(this.restDecoder) === 1;
    }
    /**
   * @return {number} info An unsigned 8-bit integer
   */ readTypeRef() {
        return $dW8Wq.readVarUint(this.restDecoder);
    }
    /**
   * Write len of a struct - well suited for Opt RLE encoder.
   *
   * @return {number} len
   */ readLen() {
        return $dW8Wq.readVarUint(this.restDecoder);
    }
    /**
   * @return {any}
   */ readAny() {
        return $dW8Wq.readAny(this.restDecoder);
    }
    /**
   * @return {Uint8Array}
   */ readBuf() {
        return $800Lz.copyUint8Array($dW8Wq.readVarUint8Array(this.restDecoder));
    }
    /**
   * Legacy implementation uses JSON parse. We use any-decoding in v2.
   *
   * @return {any}
   */ readJSON() {
        return JSON.parse($dW8Wq.readVarString(this.restDecoder));
    }
    /**
   * @return {string}
   */ readKey() {
        return $dW8Wq.readVarString(this.restDecoder);
    }
}
class $fd9bbcd8ab314c6e$var$DSDecoderV2 {
    /**
   * @param {decoding.Decoder} decoder
   */ constructor(decoder){
        /**
     * @private
     */ this.dsCurrVal = 0;
        this.restDecoder = decoder;
    }
    resetDsCurVal() {
        this.dsCurrVal = 0;
    }
    /**
   * @return {number}
   */ readDsClock() {
        this.dsCurrVal += $dW8Wq.readVarUint(this.restDecoder);
        return this.dsCurrVal;
    }
    /**
   * @return {number}
   */ readDsLen() {
        const diff = $dW8Wq.readVarUint(this.restDecoder) + 1;
        this.dsCurrVal += diff;
        return diff;
    }
}
class $fd9bbcd8ab314c6e$export$1c932452355c5571 extends $fd9bbcd8ab314c6e$var$DSDecoderV2 {
    /**
   * @param {decoding.Decoder} decoder
   */ constructor(decoder){
        super(decoder);
        /**
     * List of cached keys. If the keys[id] does not exist, we read a new key
     * from stringEncoder and push it to keys.
     *
     * @type {Array<string>}
     */ this.keys = [];
        $dW8Wq.readVarUint(decoder); // read feature flag - currently unused
        this.keyClockDecoder = new $dW8Wq.IntDiffOptRleDecoder($dW8Wq.readVarUint8Array(decoder));
        this.clientDecoder = new $dW8Wq.UintOptRleDecoder($dW8Wq.readVarUint8Array(decoder));
        this.leftClockDecoder = new $dW8Wq.IntDiffOptRleDecoder($dW8Wq.readVarUint8Array(decoder));
        this.rightClockDecoder = new $dW8Wq.IntDiffOptRleDecoder($dW8Wq.readVarUint8Array(decoder));
        this.infoDecoder = new $dW8Wq.RleDecoder($dW8Wq.readVarUint8Array(decoder), $dW8Wq.readUint8);
        this.stringDecoder = new $dW8Wq.StringDecoder($dW8Wq.readVarUint8Array(decoder));
        this.parentInfoDecoder = new $dW8Wq.RleDecoder($dW8Wq.readVarUint8Array(decoder), $dW8Wq.readUint8);
        this.typeRefDecoder = new $dW8Wq.UintOptRleDecoder($dW8Wq.readVarUint8Array(decoder));
        this.lenDecoder = new $dW8Wq.UintOptRleDecoder($dW8Wq.readVarUint8Array(decoder));
    }
    /**
   * @return {ID}
   */ readLeftID() {
        return new $fd9bbcd8ab314c6e$export$8be180ec26319f9f(this.clientDecoder.read(), this.leftClockDecoder.read());
    }
    /**
   * @return {ID}
   */ readRightID() {
        return new $fd9bbcd8ab314c6e$export$8be180ec26319f9f(this.clientDecoder.read(), this.rightClockDecoder.read());
    }
    /**
   * Read the next client id.
   * Use this in favor of readID whenever possible to reduce the number of objects created.
   */ readClient() {
        return this.clientDecoder.read();
    }
    /**
   * @return {number} info An unsigned 8-bit integer
   */ readInfo() {
        return /** @type {number} */ this.infoDecoder.read();
    }
    /**
   * @return {string}
   */ readString() {
        return this.stringDecoder.read();
    }
    /**
   * @return {boolean}
   */ readParentInfo() {
        return this.parentInfoDecoder.read() === 1;
    }
    /**
   * @return {number} An unsigned 8-bit integer
   */ readTypeRef() {
        return this.typeRefDecoder.read();
    }
    /**
   * Write len of a struct - well suited for Opt RLE encoder.
   *
   * @return {number}
   */ readLen() {
        return this.lenDecoder.read();
    }
    /**
   * @return {any}
   */ readAny() {
        return $dW8Wq.readAny(this.restDecoder);
    }
    /**
   * @return {Uint8Array}
   */ readBuf() {
        return $dW8Wq.readVarUint8Array(this.restDecoder);
    }
    /**
   * This is mainly here for legacy purposes.
   *
   * Initial we incoded objects using JSON. Now we use the much faster lib0/any-encoder. This method mainly exists for legacy purposes for the v1 encoder.
   *
   * @return {any}
   */ readJSON() {
        return $dW8Wq.readAny(this.restDecoder);
    }
    /**
   * @return {string}
   */ readKey() {
        const keyClock = this.keyClockDecoder.read();
        if (keyClock < this.keys.length) return this.keys[keyClock];
        else {
            const key = this.stringDecoder.read();
            this.keys.push(key);
            return key;
        }
    }
}
class $fd9bbcd8ab314c6e$var$DSEncoderV1 {
    constructor(){
        this.restEncoder = $apPNa.createEncoder();
    }
    toUint8Array() {
        return $apPNa.toUint8Array(this.restEncoder);
    }
    resetDsCurVal() {
    // nop
    }
    /**
   * @param {number} clock
   */ writeDsClock(clock) {
        $apPNa.writeVarUint(this.restEncoder, clock);
    }
    /**
   * @param {number} len
   */ writeDsLen(len) {
        $apPNa.writeVarUint(this.restEncoder, len);
    }
}
class $fd9bbcd8ab314c6e$export$99171b804d9c5b54 extends $fd9bbcd8ab314c6e$var$DSEncoderV1 {
    /**
   * @param {ID} id
   */ writeLeftID(id) {
        $apPNa.writeVarUint(this.restEncoder, id.client);
        $apPNa.writeVarUint(this.restEncoder, id.clock);
    }
    /**
   * @param {ID} id
   */ writeRightID(id) {
        $apPNa.writeVarUint(this.restEncoder, id.client);
        $apPNa.writeVarUint(this.restEncoder, id.clock);
    }
    /**
   * Use writeClient and writeClock instead of writeID if possible.
   * @param {number} client
   */ writeClient(client) {
        $apPNa.writeVarUint(this.restEncoder, client);
    }
    /**
   * @param {number} info An unsigned 8-bit integer
   */ writeInfo(info) {
        $apPNa.writeUint8(this.restEncoder, info);
    }
    /**
   * @param {string} s
   */ writeString(s) {
        $apPNa.writeVarString(this.restEncoder, s);
    }
    /**
   * @param {boolean} isYKey
   */ writeParentInfo(isYKey) {
        $apPNa.writeVarUint(this.restEncoder, isYKey ? 1 : 0);
    }
    /**
   * @param {number} info An unsigned 8-bit integer
   */ writeTypeRef(info) {
        $apPNa.writeVarUint(this.restEncoder, info);
    }
    /**
   * Write len of a struct - well suited for Opt RLE encoder.
   *
   * @param {number} len
   */ writeLen(len) {
        $apPNa.writeVarUint(this.restEncoder, len);
    }
    /**
   * @param {any} any
   */ writeAny(any) {
        $apPNa.writeAny(this.restEncoder, any);
    }
    /**
   * @param {Uint8Array} buf
   */ writeBuf(buf) {
        $apPNa.writeVarUint8Array(this.restEncoder, buf);
    }
    /**
   * @param {any} embed
   */ writeJSON(embed) {
        $apPNa.writeVarString(this.restEncoder, JSON.stringify(embed));
    }
    /**
   * @param {string} key
   */ writeKey(key) {
        $apPNa.writeVarString(this.restEncoder, key);
    }
}
class $fd9bbcd8ab314c6e$var$DSEncoderV2 {
    constructor(){
        this.restEncoder = $apPNa.createEncoder(); // encodes all the rest / non-optimized
        this.dsCurrVal = 0;
    }
    toUint8Array() {
        return $apPNa.toUint8Array(this.restEncoder);
    }
    resetDsCurVal() {
        this.dsCurrVal = 0;
    }
    /**
   * @param {number} clock
   */ writeDsClock(clock) {
        const diff = clock - this.dsCurrVal;
        this.dsCurrVal = clock;
        $apPNa.writeVarUint(this.restEncoder, diff);
    }
    /**
   * @param {number} len
   */ writeDsLen(len) {
        if (len === 0) $lqCPr.unexpectedCase();
        $apPNa.writeVarUint(this.restEncoder, len - 1);
        this.dsCurrVal += len;
    }
}
class $fd9bbcd8ab314c6e$export$30c99e08943e1c2 extends $fd9bbcd8ab314c6e$var$DSEncoderV2 {
    constructor(){
        super();
        /**
     * @type {Map<string,number>}
     */ this.keyMap = new Map();
        /**
     * Refers to the next uniqe key-identifier to me used.
     * See writeKey method for more information.
     *
     * @type {number}
     */ this.keyClock = 0;
        this.keyClockEncoder = new $apPNa.IntDiffOptRleEncoder();
        this.clientEncoder = new $apPNa.UintOptRleEncoder();
        this.leftClockEncoder = new $apPNa.IntDiffOptRleEncoder();
        this.rightClockEncoder = new $apPNa.IntDiffOptRleEncoder();
        this.infoEncoder = new $apPNa.RleEncoder($apPNa.writeUint8);
        this.stringEncoder = new $apPNa.StringEncoder();
        this.parentInfoEncoder = new $apPNa.RleEncoder($apPNa.writeUint8);
        this.typeRefEncoder = new $apPNa.UintOptRleEncoder();
        this.lenEncoder = new $apPNa.UintOptRleEncoder();
    }
    toUint8Array() {
        const encoder = $apPNa.createEncoder();
        $apPNa.writeVarUint(encoder, 0); // this is a feature flag that we might use in the future
        $apPNa.writeVarUint8Array(encoder, this.keyClockEncoder.toUint8Array());
        $apPNa.writeVarUint8Array(encoder, this.clientEncoder.toUint8Array());
        $apPNa.writeVarUint8Array(encoder, this.leftClockEncoder.toUint8Array());
        $apPNa.writeVarUint8Array(encoder, this.rightClockEncoder.toUint8Array());
        $apPNa.writeVarUint8Array(encoder, $apPNa.toUint8Array(this.infoEncoder));
        $apPNa.writeVarUint8Array(encoder, this.stringEncoder.toUint8Array());
        $apPNa.writeVarUint8Array(encoder, $apPNa.toUint8Array(this.parentInfoEncoder));
        $apPNa.writeVarUint8Array(encoder, this.typeRefEncoder.toUint8Array());
        $apPNa.writeVarUint8Array(encoder, this.lenEncoder.toUint8Array());
        // @note The rest encoder is appended! (note the missing var)
        $apPNa.writeUint8Array(encoder, $apPNa.toUint8Array(this.restEncoder));
        return $apPNa.toUint8Array(encoder);
    }
    /**
   * @param {ID} id
   */ writeLeftID(id) {
        this.clientEncoder.write(id.client);
        this.leftClockEncoder.write(id.clock);
    }
    /**
   * @param {ID} id
   */ writeRightID(id) {
        this.clientEncoder.write(id.client);
        this.rightClockEncoder.write(id.clock);
    }
    /**
   * @param {number} client
   */ writeClient(client) {
        this.clientEncoder.write(client);
    }
    /**
   * @param {number} info An unsigned 8-bit integer
   */ writeInfo(info) {
        this.infoEncoder.write(info);
    }
    /**
   * @param {string} s
   */ writeString(s) {
        this.stringEncoder.write(s);
    }
    /**
   * @param {boolean} isYKey
   */ writeParentInfo(isYKey) {
        this.parentInfoEncoder.write(isYKey ? 1 : 0);
    }
    /**
   * @param {number} info An unsigned 8-bit integer
   */ writeTypeRef(info) {
        this.typeRefEncoder.write(info);
    }
    /**
   * Write len of a struct - well suited for Opt RLE encoder.
   *
   * @param {number} len
   */ writeLen(len) {
        this.lenEncoder.write(len);
    }
    /**
   * @param {any} any
   */ writeAny(any) {
        $apPNa.writeAny(this.restEncoder, any);
    }
    /**
   * @param {Uint8Array} buf
   */ writeBuf(buf) {
        $apPNa.writeVarUint8Array(this.restEncoder, buf);
    }
    /**
   * This is mainly here for legacy purposes.
   *
   * Initial we incoded objects using JSON. Now we use the much faster lib0/any-encoder. This method mainly exists for legacy purposes for the v1 encoder.
   *
   * @param {any} embed
   */ writeJSON(embed) {
        $apPNa.writeAny(this.restEncoder, embed);
    }
    /**
   * Property keys are often reused. For example, in y-prosemirror the key `bold` might
   * occur very often. For a 3d application, the key `position` might occur very often.
   *
   * We cache these keys in a Map and refer to them via a unique number.
   *
   * @param {string} key
   */ writeKey(key) {
        const clock = this.keyMap.get(key);
        if (clock === undefined) {
            /**
       * @todo uncomment to introduce this feature finally
       *
       * Background. The ContentFormat object was always encoded using writeKey, but the decoder used to use readString.
       * Furthermore, I forgot to set the keyclock. So everything was working fine.
       *
       * However, this feature here is basically useless as it is not being used (it actually only consumes extra memory).
       *
       * I don't know yet how to reintroduce this feature..
       *
       * Older clients won't be able to read updates when we reintroduce this feature. So this should probably be done using a flag.
       *
       */ // this.keyMap.set(key, this.keyClock)
            this.keyClockEncoder.write(this.keyClock++);
            this.stringEncoder.write(key);
        } else this.keyClockEncoder.write(clock);
    }
}
/**
 * @module encoding
 */ /*
 * We use the first five bits in the info flag for determining the type of the struct.
 *
 * 0: GC
 * 1: Item with Deleted content
 * 2: Item with JSON content
 * 3: Item with Binary content
 * 4: Item with String content
 * 5: Item with Embed content (for richtext content)
 * 6: Item with Format content (a formatting marker for richtext content)
 * 7: Item with Type
 */ /**
 * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
 * @param {Array<GC|Item>} structs All structs by `client`
 * @param {number} client
 * @param {number} clock write structs starting with `ID(client,clock)`
 *
 * @function
 */ const $fd9bbcd8ab314c6e$var$writeStructs = (encoder, structs, client, clock)=>{
    // write first id
    clock = $6O4IB.max(clock, structs[0].id.clock); // make sure the first id exists
    const startNewStructs = $fd9bbcd8ab314c6e$export$5f8f02523cf47b58(structs, clock);
    // write # encoded structs
    $apPNa.writeVarUint(encoder.restEncoder, structs.length - startNewStructs);
    encoder.writeClient(client);
    $apPNa.writeVarUint(encoder.restEncoder, clock);
    const firstStruct = structs[startNewStructs];
    // write first struct with an offset
    firstStruct.write(encoder, clock - firstStruct.id.clock);
    for(let i = startNewStructs + 1; i < structs.length; i++)structs[i].write(encoder, 0);
};
/**
 * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
 * @param {StructStore} store
 * @param {Map<number,number>} _sm
 *
 * @private
 * @function
 */ const $fd9bbcd8ab314c6e$var$writeClientsStructs = (encoder, store, _sm)=>{
    // we filter all valid _sm entries into sm
    const sm = new Map();
    _sm.forEach((clock, client)=>{
        // only write if new structs are available
        if ($fd9bbcd8ab314c6e$export$50fdfeece43146fd(store, client) > clock) sm.set(client, clock);
    });
    $fd9bbcd8ab314c6e$var$getStateVector(store).forEach((_clock, client)=>{
        if (!_sm.has(client)) sm.set(client, 0);
    });
    // write # states that were updated
    $apPNa.writeVarUint(encoder.restEncoder, sm.size);
    // Write items with higher client ids first
    // This heavily improves the conflict algorithm.
    $8aHnL.from(sm.entries()).sort((a, b)=>b[0] - a[0]).forEach(([client, clock])=>{
        $fd9bbcd8ab314c6e$var$writeStructs(encoder, /** @type {Array<GC|Item>} */ store.clients.get(client), client, clock);
    });
};
/**
 * @param {UpdateDecoderV1 | UpdateDecoderV2} decoder The decoder object to read data from.
 * @param {Doc} doc
 * @return {Map<number, { i: number, refs: Array<Item | GC> }>}
 *
 * @private
 * @function
 */ const $fd9bbcd8ab314c6e$var$readClientsStructRefs = (decoder, doc)=>{
    /**
   * @type {Map<number, { i: number, refs: Array<Item | GC> }>}
   */ const clientRefs = $2U6oo.create();
    const numOfStateUpdates = $dW8Wq.readVarUint(decoder.restDecoder);
    for(let i = 0; i < numOfStateUpdates; i++){
        const numberOfStructs = $dW8Wq.readVarUint(decoder.restDecoder);
        /**
     * @type {Array<GC|Item>}
     */ const refs = new Array(numberOfStructs);
        const client = decoder.readClient();
        let clock = $dW8Wq.readVarUint(decoder.restDecoder);
        // const start = performance.now()
        clientRefs.set(client, {
            i: 0,
            refs: refs
        });
        for(let i = 0; i < numberOfStructs; i++){
            const info = decoder.readInfo();
            switch($jnoaM.BITS5 & info){
                case 0:
                    {
                        const len = decoder.readLen();
                        refs[i] = new $fd9bbcd8ab314c6e$export$12d259ff017e6b58($fd9bbcd8ab314c6e$export$6c7d4e6171d008d0(client, clock), len);
                        clock += len;
                        break;
                    }
                case 10:
                    {
                        // @todo we could reduce the amount of checks by adding Skip struct to clientRefs so we know that something is missing.
                        const len = $dW8Wq.readVarUint(decoder.restDecoder);
                        refs[i] = new $fd9bbcd8ab314c6e$export$38d24f5c1eb0e4c0($fd9bbcd8ab314c6e$export$6c7d4e6171d008d0(client, clock), len);
                        clock += len;
                        break;
                    }
                default:
                    {
                        /**
           * The optimized implementation doesn't use any variables because inlining variables is faster.
           * Below a non-optimized version is shown that implements the basic algorithm with
           * a few comments
           */ const cantCopyParentInfo = (info & ($jnoaM.BIT7 | $jnoaM.BIT8)) === 0;
                        // If parent = null and neither left nor right are defined, then we know that `parent` is child of `y`
                        // and we read the next string as parentYKey.
                        // It indicates how we store/retrieve parent from `y.share`
                        // @type {string|null}
                        const struct = new $fd9bbcd8ab314c6e$export$6d08773d2e66f8f2($fd9bbcd8ab314c6e$export$6c7d4e6171d008d0(client, clock), null, (info & $jnoaM.BIT8) === $jnoaM.BIT8 ? decoder.readLeftID() : null, null, (info & $jnoaM.BIT7) === $jnoaM.BIT7 ? decoder.readRightID() : null, cantCopyParentInfo ? decoder.readParentInfo() ? doc.get(decoder.readString()) : decoder.readLeftID() : null, cantCopyParentInfo && (info & $jnoaM.BIT6) === $jnoaM.BIT6 ? decoder.readString() : null, $fd9bbcd8ab314c6e$var$readItemContent(decoder, info) // item content
                        );
                        /* A non-optimized implementation of the above algorithm:

          // The item that was originally to the left of this item.
          const origin = (info & binary.BIT8) === binary.BIT8 ? decoder.readLeftID() : null
          // The item that was originally to the right of this item.
          const rightOrigin = (info & binary.BIT7) === binary.BIT7 ? decoder.readRightID() : null
          const cantCopyParentInfo = (info & (binary.BIT7 | binary.BIT8)) === 0
          const hasParentYKey = cantCopyParentInfo ? decoder.readParentInfo() : false
          // If parent = null and neither left nor right are defined, then we know that `parent` is child of `y`
          // and we read the next string as parentYKey.
          // It indicates how we store/retrieve parent from `y.share`
          // @type {string|null}
          const parentYKey = cantCopyParentInfo && hasParentYKey ? decoder.readString() : null

          const struct = new Item(
            createID(client, clock),
            null, // left
            origin, // origin
            null, // right
            rightOrigin, // right origin
            cantCopyParentInfo && !hasParentYKey ? decoder.readLeftID() : (parentYKey !== null ? doc.get(parentYKey) : null), // parent
            cantCopyParentInfo && (info & binary.BIT6) === binary.BIT6 ? decoder.readString() : null, // parentSub
            readItemContent(decoder, info) // item content
          )
          */ refs[i] = struct;
                        clock += struct.length;
                    }
            }
        }
    // console.log('time to read: ', performance.now() - start) // @todo remove
    }
    return clientRefs;
};
/**
 * Resume computing structs generated by struct readers.
 *
 * While there is something to do, we integrate structs in this order
 * 1. top element on stack, if stack is not empty
 * 2. next element from current struct reader (if empty, use next struct reader)
 *
 * If struct causally depends on another struct (ref.missing), we put next reader of
 * `ref.id.client` on top of stack.
 *
 * At some point we find a struct that has no causal dependencies,
 * then we start emptying the stack.
 *
 * It is not possible to have circles: i.e. struct1 (from client1) depends on struct2 (from client2)
 * depends on struct3 (from client1). Therefore the max stack size is eqaul to `structReaders.length`.
 *
 * This method is implemented in a way so that we can resume computation if this update
 * causally depends on another update.
 *
 * @param {Transaction} transaction
 * @param {StructStore} store
 * @param {Map<number, { i: number, refs: (GC | Item)[] }>} clientsStructRefs
 * @return { null | { update: Uint8Array, missing: Map<number,number> } }
 *
 * @private
 * @function
 */ const $fd9bbcd8ab314c6e$var$integrateStructs = (transaction, store, clientsStructRefs)=>{
    /**
   * @type {Array<Item | GC>}
   */ const stack = [];
    // sort them so that we take the higher id first, in case of conflicts the lower id will probably not conflict with the id from the higher user.
    let clientsStructRefsIds = $8aHnL.from(clientsStructRefs.keys()).sort((a, b)=>a - b);
    if (clientsStructRefsIds.length === 0) return null;
    const getNextStructTarget = ()=>{
        if (clientsStructRefsIds.length === 0) return null;
        let nextStructsTarget = /** @type {{i:number,refs:Array<GC|Item>}} */ clientsStructRefs.get(clientsStructRefsIds[clientsStructRefsIds.length - 1]);
        while(nextStructsTarget.refs.length === nextStructsTarget.i){
            clientsStructRefsIds.pop();
            if (clientsStructRefsIds.length > 0) nextStructsTarget = /** @type {{i:number,refs:Array<GC|Item>}} */ clientsStructRefs.get(clientsStructRefsIds[clientsStructRefsIds.length - 1]);
            else return null;
        }
        return nextStructsTarget;
    };
    let curStructsTarget = getNextStructTarget();
    if (curStructsTarget === null) return null;
    /**
   * @type {StructStore}
   */ const restStructs = new $fd9bbcd8ab314c6e$var$StructStore();
    const missingSV = new Map();
    /**
   * @param {number} client
   * @param {number} clock
   */ const updateMissingSv = (client, clock)=>{
        const mclock = missingSV.get(client);
        if (mclock == null || mclock > clock) missingSV.set(client, clock);
    };
    /**
   * @type {GC|Item}
   */ let stackHead = /** @type {any} */ curStructsTarget.refs[/** @type {any} */ curStructsTarget.i++];
    // caching the state because it is used very often
    const state = new Map();
    const addStackToRestSS = ()=>{
        for (const item of stack){
            const client = item.id.client;
            const unapplicableItems = clientsStructRefs.get(client);
            if (unapplicableItems) {
                // decrement because we weren't able to apply previous operation
                unapplicableItems.i--;
                restStructs.clients.set(client, unapplicableItems.refs.slice(unapplicableItems.i));
                clientsStructRefs.delete(client);
                unapplicableItems.i = 0;
                unapplicableItems.refs = [];
            } else // item was the last item on clientsStructRefs and the field was already cleared. Add item to restStructs and continue
            restStructs.clients.set(client, [
                item
            ]);
            // remove client from clientsStructRefsIds to prevent users from applying the same update again
            clientsStructRefsIds = clientsStructRefsIds.filter((c)=>c !== client);
        }
        stack.length = 0;
    };
    // iterate over all struct readers until we are done
    while(true){
        if (stackHead.constructor !== $fd9bbcd8ab314c6e$export$38d24f5c1eb0e4c0) {
            const localClock = $2U6oo.setIfUndefined(state, stackHead.id.client, ()=>$fd9bbcd8ab314c6e$export$50fdfeece43146fd(store, stackHead.id.client));
            const offset = localClock - stackHead.id.clock;
            if (offset < 0) {
                // update from the same client is missing
                stack.push(stackHead);
                updateMissingSv(stackHead.id.client, stackHead.id.clock - 1);
                // hid a dead wall, add all items from stack to restSS
                addStackToRestSS();
            } else {
                const missing = stackHead.getMissing(transaction, store);
                if (missing !== null) {
                    stack.push(stackHead);
                    // get the struct reader that has the missing struct
                    /**
           * @type {{ refs: Array<GC|Item>, i: number }}
           */ const structRefs = clientsStructRefs.get(/** @type {number} */ missing) || {
                        refs: [],
                        i: 0
                    };
                    if (structRefs.refs.length === structRefs.i) {
                        // This update message causally depends on another update message that doesn't exist yet
                        updateMissingSv(/** @type {number} */ missing, $fd9bbcd8ab314c6e$export$50fdfeece43146fd(store, missing));
                        addStackToRestSS();
                    } else {
                        stackHead = structRefs.refs[structRefs.i++];
                        continue;
                    }
                } else if (offset === 0 || offset < stackHead.length) {
                    // all fine, apply the stackhead
                    stackHead.integrate(transaction, offset);
                    state.set(stackHead.id.client, stackHead.id.clock + stackHead.length);
                }
            }
        }
        // iterate to next stackHead
        if (stack.length > 0) stackHead = /** @type {GC|Item} */ stack.pop();
        else if (curStructsTarget !== null && curStructsTarget.i < curStructsTarget.refs.length) stackHead = /** @type {GC|Item} */ curStructsTarget.refs[curStructsTarget.i++];
        else {
            curStructsTarget = getNextStructTarget();
            if (curStructsTarget === null) break;
            else stackHead = /** @type {GC|Item} */ curStructsTarget.refs[curStructsTarget.i++];
        }
    }
    if (restStructs.clients.size > 0) {
        const encoder = new $fd9bbcd8ab314c6e$export$30c99e08943e1c2();
        $fd9bbcd8ab314c6e$var$writeClientsStructs(encoder, restStructs, new Map());
        // write empty deleteset
        // writeDeleteSet(encoder, new DeleteSet())
        $apPNa.writeVarUint(encoder.restEncoder, 0); // => no need for an extra function call, just write 0 deletes
        return {
            missing: missingSV,
            update: encoder.toUint8Array()
        };
    }
    return null;
};
/**
 * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
 * @param {Transaction} transaction
 *
 * @private
 * @function
 */ const $fd9bbcd8ab314c6e$var$writeStructsFromTransaction = (encoder, transaction)=>$fd9bbcd8ab314c6e$var$writeClientsStructs(encoder, transaction.doc.store, transaction.beforeState);
/**
 * Read and apply a document update.
 *
 * This function has the same effect as `applyUpdate` but accepts a decoder.
 *
 * @param {decoding.Decoder} decoder
 * @param {Doc} ydoc
 * @param {any} [transactionOrigin] This will be stored on `transaction.origin` and `.on('update', (update, origin))`
 * @param {UpdateDecoderV1 | UpdateDecoderV2} [structDecoder]
 *
 * @function
 */ const $fd9bbcd8ab314c6e$export$7abe492a0b891b4d = (decoder, ydoc, transactionOrigin, structDecoder = new $fd9bbcd8ab314c6e$export$1c932452355c5571(decoder))=>$fd9bbcd8ab314c6e$export$dac1bad6146b2469(ydoc, (transaction)=>{
        // force that transaction.local is set to non-local
        transaction.local = false;
        let retry = false;
        const doc = transaction.doc;
        const store = doc.store;
        // let start = performance.now()
        const ss = $fd9bbcd8ab314c6e$var$readClientsStructRefs(structDecoder, doc);
        // console.log('time to read structs: ', performance.now() - start) // @todo remove
        // start = performance.now()
        // console.log('time to merge: ', performance.now() - start) // @todo remove
        // start = performance.now()
        const restStructs = $fd9bbcd8ab314c6e$var$integrateStructs(transaction, store, ss);
        const pending = store.pendingStructs;
        if (pending) {
            // check if we can apply something
            for (const [client, clock] of pending.missing)if (clock < $fd9bbcd8ab314c6e$export$50fdfeece43146fd(store, client)) {
                retry = true;
                break;
            }
            if (restStructs) {
                // merge restStructs into store.pending
                for (const [client, clock] of restStructs.missing){
                    const mclock = pending.missing.get(client);
                    if (mclock == null || mclock > clock) pending.missing.set(client, clock);
                }
                pending.update = $fd9bbcd8ab314c6e$export$ce273d78de0331d1([
                    pending.update,
                    restStructs.update
                ]);
            }
        } else store.pendingStructs = restStructs;
        // console.log('time to integrate: ', performance.now() - start) // @todo remove
        // start = performance.now()
        const dsRest = $fd9bbcd8ab314c6e$var$readAndApplyDeleteSet(structDecoder, transaction, store);
        if (store.pendingDs) {
            // @todo we could make a lower-bound state-vector check as we do above
            const pendingDSUpdate = new $fd9bbcd8ab314c6e$export$1c932452355c5571($dW8Wq.createDecoder(store.pendingDs));
            $dW8Wq.readVarUint(pendingDSUpdate.restDecoder); // read 0 structs, because we only encode deletes in pendingdsupdate
            const dsRest2 = $fd9bbcd8ab314c6e$var$readAndApplyDeleteSet(pendingDSUpdate, transaction, store);
            if (dsRest && dsRest2) // case 1: ds1 != null && ds2 != null
            store.pendingDs = $fd9bbcd8ab314c6e$export$ce273d78de0331d1([
                dsRest,
                dsRest2
            ]);
            else // case 2: ds1 != null
            // case 3: ds2 != null
            // case 4: ds1 == null && ds2 == null
            store.pendingDs = dsRest || dsRest2;
        } else // Either dsRest == null && pendingDs == null OR dsRest != null
        store.pendingDs = dsRest;
        // console.log('time to cleanup: ', performance.now() - start) // @todo remove
        // start = performance.now()
        // console.log('time to resume delete readers: ', performance.now() - start) // @todo remove
        // start = performance.now()
        if (retry) {
            const update = /** @type {{update: Uint8Array}} */ store.pendingStructs.update;
            store.pendingStructs = null;
            $fd9bbcd8ab314c6e$export$acc3b0324aabf1b6(transaction.doc, update);
        }
    }, transactionOrigin, false);
/**
 * Read and apply a document update.
 *
 * This function has the same effect as `applyUpdate` but accepts a decoder.
 *
 * @param {decoding.Decoder} decoder
 * @param {Doc} ydoc
 * @param {any} [transactionOrigin] This will be stored on `transaction.origin` and `.on('update', (update, origin))`
 *
 * @function
 */ const $fd9bbcd8ab314c6e$export$d67ac8d73b7d336c = (decoder, ydoc, transactionOrigin)=>$fd9bbcd8ab314c6e$export$7abe492a0b891b4d(decoder, ydoc, transactionOrigin, new $fd9bbcd8ab314c6e$export$1aa46d9818b5d1ec(decoder));
/**
 * Apply a document update created by, for example, `y.on('update', update => ..)` or `update = encodeStateAsUpdate()`.
 *
 * This function has the same effect as `readUpdate` but accepts an Uint8Array instead of a Decoder.
 *
 * @param {Doc} ydoc
 * @param {Uint8Array} update
 * @param {any} [transactionOrigin] This will be stored on `transaction.origin` and `.on('update', (update, origin))`
 * @param {typeof UpdateDecoderV1 | typeof UpdateDecoderV2} [YDecoder]
 *
 * @function
 */ const $fd9bbcd8ab314c6e$export$acc3b0324aabf1b6 = (ydoc, update, transactionOrigin, YDecoder = $fd9bbcd8ab314c6e$export$1c932452355c5571)=>{
    const decoder = $dW8Wq.createDecoder(update);
    $fd9bbcd8ab314c6e$export$7abe492a0b891b4d(decoder, ydoc, transactionOrigin, new YDecoder(decoder));
};
/**
 * Apply a document update created by, for example, `y.on('update', update => ..)` or `update = encodeStateAsUpdate()`.
 *
 * This function has the same effect as `readUpdate` but accepts an Uint8Array instead of a Decoder.
 *
 * @param {Doc} ydoc
 * @param {Uint8Array} update
 * @param {any} [transactionOrigin] This will be stored on `transaction.origin` and `.on('update', (update, origin))`
 *
 * @function
 */ const $fd9bbcd8ab314c6e$export$c271737a9c02e925 = (ydoc, update, transactionOrigin)=>$fd9bbcd8ab314c6e$export$acc3b0324aabf1b6(ydoc, update, transactionOrigin, $fd9bbcd8ab314c6e$export$1aa46d9818b5d1ec);
/**
 * Write all the document as a single update message. If you specify the state of the remote client (`targetStateVector`) it will
 * only write the operations that are missing.
 *
 * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
 * @param {Doc} doc
 * @param {Map<number,number>} [targetStateVector] The state of the target that receives the update. Leave empty to write all known structs
 *
 * @function
 */ const $fd9bbcd8ab314c6e$var$writeStateAsUpdate = (encoder, doc, targetStateVector = new Map())=>{
    $fd9bbcd8ab314c6e$var$writeClientsStructs(encoder, doc.store, targetStateVector);
    $fd9bbcd8ab314c6e$var$writeDeleteSet(encoder, $fd9bbcd8ab314c6e$export$8450d668bec558e2(doc.store));
};
/**
 * Write all the document as a single update message that can be applied on the remote document. If you specify the state of the remote client (`targetState`) it will
 * only write the operations that are missing.
 *
 * Use `writeStateAsUpdate` instead if you are working with lib0/encoding.js#Encoder
 *
 * @param {Doc} doc
 * @param {Uint8Array} [encodedTargetStateVector] The state of the target that receives the update. Leave empty to write all known structs
 * @param {UpdateEncoderV1 | UpdateEncoderV2} [encoder]
 * @return {Uint8Array}
 *
 * @function
 */ const $fd9bbcd8ab314c6e$export$90338e0798f6f64f = (doc, encodedTargetStateVector = new Uint8Array([
    0
]), encoder = new $fd9bbcd8ab314c6e$export$30c99e08943e1c2())=>{
    const targetStateVector = $fd9bbcd8ab314c6e$export$324ac6fb20a844e3(encodedTargetStateVector);
    $fd9bbcd8ab314c6e$var$writeStateAsUpdate(encoder, doc, targetStateVector);
    const updates = [
        encoder.toUint8Array()
    ];
    // also add the pending updates (if there are any)
    if (doc.store.pendingDs) updates.push(doc.store.pendingDs);
    if (doc.store.pendingStructs) updates.push($fd9bbcd8ab314c6e$export$a8143edf39d2ad8e(doc.store.pendingStructs.update, encodedTargetStateVector));
    if (updates.length > 1) {
        if (encoder.constructor === $fd9bbcd8ab314c6e$export$99171b804d9c5b54) return $fd9bbcd8ab314c6e$export$6319871659fd2460(updates.map((update, i)=>i === 0 ? update : $fd9bbcd8ab314c6e$export$afffbdeed14adbd(update)));
        else if (encoder.constructor === $fd9bbcd8ab314c6e$export$30c99e08943e1c2) return $fd9bbcd8ab314c6e$export$ce273d78de0331d1(updates);
    }
    return updates[0];
};
/**
 * Write all the document as a single update message that can be applied on the remote document. If you specify the state of the remote client (`targetState`) it will
 * only write the operations that are missing.
 *
 * Use `writeStateAsUpdate` instead if you are working with lib0/encoding.js#Encoder
 *
 * @param {Doc} doc
 * @param {Uint8Array} [encodedTargetStateVector] The state of the target that receives the update. Leave empty to write all known structs
 * @return {Uint8Array}
 *
 * @function
 */ const $fd9bbcd8ab314c6e$export$e5848df80e65bd53 = (doc, encodedTargetStateVector)=>$fd9bbcd8ab314c6e$export$90338e0798f6f64f(doc, encodedTargetStateVector, new $fd9bbcd8ab314c6e$export$99171b804d9c5b54());
/**
 * Read state vector from Decoder and return as Map
 *
 * @param {DSDecoderV1 | DSDecoderV2} decoder
 * @return {Map<number,number>} Maps `client` to the number next expected `clock` from that client.
 *
 * @function
 */ const $fd9bbcd8ab314c6e$var$readStateVector = (decoder)=>{
    const ss = new Map();
    const ssLength = $dW8Wq.readVarUint(decoder.restDecoder);
    for(let i = 0; i < ssLength; i++){
        const client = $dW8Wq.readVarUint(decoder.restDecoder);
        const clock = $dW8Wq.readVarUint(decoder.restDecoder);
        ss.set(client, clock);
    }
    return ss;
};
/**
 * Read decodedState and return State as Map.
 *
 * @param {Uint8Array} decodedState
 * @return {Map<number,number>} Maps `client` to the number next expected `clock` from that client.
 *
 * @function
 */ // export const decodeStateVectorV2 = decodedState => readStateVector(new DSDecoderV2(decoding.createDecoder(decodedState)))
/**
 * Read decodedState and return State as Map.
 *
 * @param {Uint8Array} decodedState
 * @return {Map<number,number>} Maps `client` to the number next expected `clock` from that client.
 *
 * @function
 */ const $fd9bbcd8ab314c6e$export$324ac6fb20a844e3 = (decodedState)=>$fd9bbcd8ab314c6e$var$readStateVector(new $fd9bbcd8ab314c6e$var$DSDecoderV1($dW8Wq.createDecoder(decodedState)));
/**
 * @param {DSEncoderV1 | DSEncoderV2} encoder
 * @param {Map<number,number>} sv
 * @function
 */ const $fd9bbcd8ab314c6e$var$writeStateVector = (encoder, sv)=>{
    $apPNa.writeVarUint(encoder.restEncoder, sv.size);
    $8aHnL.from(sv.entries()).sort((a, b)=>b[0] - a[0]).forEach(([client, clock])=>{
        $apPNa.writeVarUint(encoder.restEncoder, client); // @todo use a special client decoder that is based on mapping
        $apPNa.writeVarUint(encoder.restEncoder, clock);
    });
    return encoder;
};
/**
 * @param {DSEncoderV1 | DSEncoderV2} encoder
 * @param {Doc} doc
 *
 * @function
 */ const $fd9bbcd8ab314c6e$var$writeDocumentStateVector = (encoder, doc)=>$fd9bbcd8ab314c6e$var$writeStateVector(encoder, $fd9bbcd8ab314c6e$var$getStateVector(doc.store));
/**
 * Encode State as Uint8Array.
 *
 * @param {Doc|Map<number,number>} doc
 * @param {DSEncoderV1 | DSEncoderV2} [encoder]
 * @return {Uint8Array}
 *
 * @function
 */ const $fd9bbcd8ab314c6e$var$encodeStateVectorV2 = (doc, encoder = new $fd9bbcd8ab314c6e$var$DSEncoderV2())=>{
    if (doc instanceof Map) $fd9bbcd8ab314c6e$var$writeStateVector(encoder, doc);
    else $fd9bbcd8ab314c6e$var$writeDocumentStateVector(encoder, doc);
    return encoder.toUint8Array();
};
/**
 * Encode State as Uint8Array.
 *
 * @param {Doc|Map<number,number>} doc
 * @return {Uint8Array}
 *
 * @function
 */ const $fd9bbcd8ab314c6e$export$3e2f5393f32e71f = (doc)=>$fd9bbcd8ab314c6e$var$encodeStateVectorV2(doc, new $fd9bbcd8ab314c6e$var$DSEncoderV1());
/**
 * General event handler implementation.
 *
 * @template ARG0, ARG1
 *
 * @private
 */ class $fd9bbcd8ab314c6e$var$EventHandler {
    constructor(){
        /**
     * @type {Array<function(ARG0, ARG1):void>}
     */ this.l = [];
    }
}
/**
 * @template ARG0,ARG1
 * @returns {EventHandler<ARG0,ARG1>}
 *
 * @private
 * @function
 */ const $fd9bbcd8ab314c6e$var$createEventHandler = ()=>new $fd9bbcd8ab314c6e$var$EventHandler();
/**
 * Adds an event listener that is called when
 * {@link EventHandler#callEventListeners} is called.
 *
 * @template ARG0,ARG1
 * @param {EventHandler<ARG0,ARG1>} eventHandler
 * @param {function(ARG0,ARG1):void} f The event handler.
 *
 * @private
 * @function
 */ const $fd9bbcd8ab314c6e$var$addEventHandlerListener = (eventHandler, f)=>eventHandler.l.push(f);
/**
 * Removes an event listener.
 *
 * @template ARG0,ARG1
 * @param {EventHandler<ARG0,ARG1>} eventHandler
 * @param {function(ARG0,ARG1):void} f The event handler that was added with
 *                     {@link EventHandler#addEventListener}
 *
 * @private
 * @function
 */ const $fd9bbcd8ab314c6e$var$removeEventHandlerListener = (eventHandler, f)=>{
    const l = eventHandler.l;
    const len = l.length;
    eventHandler.l = l.filter((g)=>f !== g);
    if (len === eventHandler.l.length) console.error("[yjs] Tried to remove event handler that doesn't exist.");
};
/**
 * Call all event listeners that were added via
 * {@link EventHandler#addEventListener}.
 *
 * @template ARG0,ARG1
 * @param {EventHandler<ARG0,ARG1>} eventHandler
 * @param {ARG0} arg0
 * @param {ARG1} arg1
 *
 * @private
 * @function
 */ const $fd9bbcd8ab314c6e$var$callEventHandlerListeners = (eventHandler, arg0, arg1)=>$5VoPh.callAll(eventHandler.l, [
        arg0,
        arg1
    ]);
class $fd9bbcd8ab314c6e$export$8be180ec26319f9f {
    /**
   * @param {number} client client id
   * @param {number} clock unique per client id, continuous number
   */ constructor(client, clock){
        /**
     * Client id
     * @type {number}
     */ this.client = client;
        /**
     * unique per client id, continuous number
     * @type {number}
     */ this.clock = clock;
    }
}
/**
 * @param {ID | null} a
 * @param {ID | null} b
 * @return {boolean}
 *
 * @function
 */ const $fd9bbcd8ab314c6e$export$c0af976e7e459c02 = (a, b)=>a === b || a !== null && b !== null && a.client === b.client && a.clock === b.clock;
/**
 * @param {number} client
 * @param {number} clock
 *
 * @private
 * @function
 */ const $fd9bbcd8ab314c6e$export$6c7d4e6171d008d0 = (client, clock)=>new $fd9bbcd8ab314c6e$export$8be180ec26319f9f(client, clock);
/**
 * @param {encoding.Encoder} encoder
 * @param {ID} id
 *
 * @private
 * @function
 */ const $fd9bbcd8ab314c6e$var$writeID = (encoder, id)=>{
    $apPNa.writeVarUint(encoder, id.client);
    $apPNa.writeVarUint(encoder, id.clock);
};
/**
 * Read ID.
 * * If first varUint read is 0xFFFFFF a RootID is returned.
 * * Otherwise an ID is returned
 *
 * @param {decoding.Decoder} decoder
 * @return {ID}
 *
 * @private
 * @function
 */ const $fd9bbcd8ab314c6e$var$readID = (decoder)=>$fd9bbcd8ab314c6e$export$6c7d4e6171d008d0($dW8Wq.readVarUint(decoder), $dW8Wq.readVarUint(decoder));
/**
 * The top types are mapped from y.share.get(keyname) => type.
 * `type` does not store any information about the `keyname`.
 * This function finds the correct `keyname` for `type` and throws otherwise.
 *
 * @param {AbstractType<any>} type
 * @return {string}
 *
 * @private
 * @function
 */ const $fd9bbcd8ab314c6e$export$e726a40920d54663 = (type)=>{
    // @ts-ignore _y must be defined, otherwise unexpected case
    for (const [key, value] of type.doc.share.entries()){
        if (value === type) return key;
    }
    throw $lqCPr.unexpectedCase();
};
/**
 * Check if `parent` is a parent of `child`.
 *
 * @param {AbstractType<any>} parent
 * @param {Item|null} child
 * @return {Boolean} Whether `parent` is a parent of `child`.
 *
 * @private
 * @function
 */ const $fd9bbcd8ab314c6e$export$3c81af374b054d6a = (parent, child)=>{
    while(child !== null){
        if (child.parent === parent) return true;
        child = /** @type {AbstractType<any>} */ child.parent._item;
    }
    return false;
};
/**
 * Convenient helper to log type information.
 *
 * Do not use in productive systems as the output can be immense!
 *
 * @param {AbstractType<any>} type
 */ const $fd9bbcd8ab314c6e$export$e9068ad704ba2f79 = (type)=>{
    const res = [];
    let n = type._start;
    while(n){
        res.push(n);
        n = n.right;
    }
    console.log("Children: ", res);
    console.log("Children content: ", res.filter((m)=>!m.deleted).map((m)=>m.content));
};
class $fd9bbcd8ab314c6e$export$b9e8b5fa1162ca4e {
    /**
   * @param {Doc} doc
   * @param {YMap<any>} [storeType]
   */ constructor(doc, storeType = doc.getMap("users")){
        /**
     * @type {Map<string,DeleteSet>}
     */ const dss = new Map();
        this.yusers = storeType;
        this.doc = doc;
        /**
     * Maps from clientid to userDescription
     *
     * @type {Map<number,string>}
     */ this.clients = new Map();
        this.dss = dss;
        /**
     * @param {YMap<any>} user
     * @param {string} userDescription
     */ const initUser = (user, userDescription)=>{
            /**
       * @type {YArray<Uint8Array>}
       */ const ds = user.get("ds");
            const ids = user.get("ids");
            const addClientId = /** @param {number} clientid */ (clientid)=>this.clients.set(clientid, userDescription);
            ds.observe(/** @param {YArrayEvent<any>} event */ (event)=>{
                event.changes.added.forEach((item)=>{
                    item.content.getContent().forEach((encodedDs)=>{
                        if (encodedDs instanceof Uint8Array) this.dss.set(userDescription, $fd9bbcd8ab314c6e$export$b7826cadad53901e([
                            this.dss.get(userDescription) || $fd9bbcd8ab314c6e$export$8cbac0d946238699(),
                            $fd9bbcd8ab314c6e$var$readDeleteSet(new $fd9bbcd8ab314c6e$var$DSDecoderV1($dW8Wq.createDecoder(encodedDs)))
                        ]));
                    });
                });
            });
            this.dss.set(userDescription, $fd9bbcd8ab314c6e$export$b7826cadad53901e(ds.map((encodedDs)=>$fd9bbcd8ab314c6e$var$readDeleteSet(new $fd9bbcd8ab314c6e$var$DSDecoderV1($dW8Wq.createDecoder(encodedDs))))));
            ids.observe(/** @param {YArrayEvent<any>} event */ (event)=>event.changes.added.forEach((item)=>item.content.getContent().forEach(addClientId)));
            ids.forEach(addClientId);
        };
        // observe users
        storeType.observe((event)=>{
            event.keysChanged.forEach((userDescription)=>initUser(storeType.get(userDescription), userDescription));
        });
        // add intial data
        storeType.forEach(initUser);
    }
    /**
   * @param {Doc} doc
   * @param {number} clientid
   * @param {string} userDescription
   * @param {Object} conf
   * @param {function(Transaction, DeleteSet):boolean} [conf.filter]
   */ setUserMapping(doc, clientid, userDescription, { filter: filter = ()=>true } = {}) {
        const users = this.yusers;
        let user = users.get(userDescription);
        if (!user) {
            user = new $fd9bbcd8ab314c6e$export$a5c7b93649eaf8f8();
            user.set("ids", new $fd9bbcd8ab314c6e$export$c4be6576ca6fe4aa());
            user.set("ds", new $fd9bbcd8ab314c6e$export$c4be6576ca6fe4aa());
            users.set(userDescription, user);
        }
        user.get("ids").push([
            clientid
        ]);
        users.observe((_event)=>{
            setTimeout(()=>{
                const userOverwrite = users.get(userDescription);
                if (userOverwrite !== user) {
                    // user was overwritten, port all data over to the next user object
                    // @todo Experiment with Y.Sets here
                    user = userOverwrite;
                    // @todo iterate over old type
                    this.clients.forEach((_userDescription, clientid)=>{
                        if (userDescription === _userDescription) user.get("ids").push([
                            clientid
                        ]);
                    });
                    const encoder = new $fd9bbcd8ab314c6e$var$DSEncoderV1();
                    const ds = this.dss.get(userDescription);
                    if (ds) {
                        $fd9bbcd8ab314c6e$var$writeDeleteSet(encoder, ds);
                        user.get("ds").push([
                            encoder.toUint8Array()
                        ]);
                    }
                }
            }, 0);
        });
        doc.on("afterTransaction", /** @param {Transaction} transaction */ (transaction)=>{
            setTimeout(()=>{
                const yds = user.get("ds");
                const ds = transaction.deleteSet;
                if (transaction.local && ds.clients.size > 0 && filter(transaction, ds)) {
                    const encoder = new $fd9bbcd8ab314c6e$var$DSEncoderV1();
                    $fd9bbcd8ab314c6e$var$writeDeleteSet(encoder, ds);
                    yds.push([
                        encoder.toUint8Array()
                    ]);
                }
            });
        });
    }
    /**
   * @param {number} clientid
   * @return {any}
   */ getUserByClientId(clientid) {
        return this.clients.get(clientid) || null;
    }
    /**
   * @param {ID} id
   * @return {string | null}
   */ getUserByDeletedId(id) {
        for (const [userDescription, ds] of this.dss.entries()){
            if ($fd9bbcd8ab314c6e$export$dcb04af092e44fde(ds, id)) return userDescription;
        }
        return null;
    }
}
/**
 * A relative position is based on the Yjs model and is not affected by document changes.
 * E.g. If you place a relative position before a certain character, it will always point to this character.
 * If you place a relative position at the end of a type, it will always point to the end of the type.
 *
 * A numeric position is often unsuited for user selections, because it does not change when content is inserted
 * before or after.
 *
 * ```Insert(0, 'x')('a|bc') = 'xa|bc'``` Where | is the relative position.
 *
 * One of the properties must be defined.
 *
 * @example
 *   // Current cursor position is at position 10
 *   const relativePosition = createRelativePositionFromIndex(yText, 10)
 *   // modify yText
 *   yText.insert(0, 'abc')
 *   yText.delete(3, 10)
 *   // Compute the cursor position
 *   const absolutePosition = createAbsolutePositionFromRelativePosition(y, relativePosition)
 *   absolutePosition.type === yText // => true
 *   console.log('cursor location is ' + absolutePosition.index) // => cursor location is 3
 *
 */ class $fd9bbcd8ab314c6e$export$da21a415c5907662 {
    /**
   * @param {ID|null} type
   * @param {string|null} tname
   * @param {ID|null} item
   * @param {number} assoc
   */ constructor(type, tname, item, assoc = 0){
        /**
     * @type {ID|null}
     */ this.type = type;
        /**
     * @type {string|null}
     */ this.tname = tname;
        /**
     * @type {ID | null}
     */ this.item = item;
        /**
     * A relative position is associated to a specific character. By default
     * assoc >= 0, the relative position is associated to the character
     * after the meant position.
     * I.e. position 1 in 'ab' is associated to character 'b'.
     *
     * If assoc < 0, then the relative position is associated to the caharacter
     * before the meant position.
     *
     * @type {number}
     */ this.assoc = assoc;
    }
}
/**
 * @param {RelativePosition} rpos
 * @return {any}
 */ const $fd9bbcd8ab314c6e$export$a783b081767a452e = (rpos)=>{
    const json = {};
    if (rpos.type) json.type = rpos.type;
    if (rpos.tname) json.tname = rpos.tname;
    if (rpos.item) json.item = rpos.item;
    if (rpos.assoc != null) json.assoc = rpos.assoc;
    return json;
};
/**
 * @param {any} json
 * @return {RelativePosition}
 *
 * @function
 */ const $fd9bbcd8ab314c6e$export$ddad8a1b8f7475d8 = (json)=>new $fd9bbcd8ab314c6e$export$da21a415c5907662(json.type == null ? null : $fd9bbcd8ab314c6e$export$6c7d4e6171d008d0(json.type.client, json.type.clock), json.tname ?? null, json.item == null ? null : $fd9bbcd8ab314c6e$export$6c7d4e6171d008d0(json.item.client, json.item.clock), json.assoc == null ? 0 : json.assoc);
class $fd9bbcd8ab314c6e$export$64c95a3fb7344864 {
    /**
   * @param {AbstractType<any>} type
   * @param {number} index
   * @param {number} [assoc]
   */ constructor(type, index, assoc = 0){
        /**
     * @type {AbstractType<any>}
     */ this.type = type;
        /**
     * @type {number}
     */ this.index = index;
        this.assoc = assoc;
    }
}
/**
 * @param {AbstractType<any>} type
 * @param {number} index
 * @param {number} [assoc]
 *
 * @function
 */ const $fd9bbcd8ab314c6e$var$createAbsolutePosition = (type, index, assoc = 0)=>new $fd9bbcd8ab314c6e$export$64c95a3fb7344864(type, index, assoc);
/**
 * @param {AbstractType<any>} type
 * @param {ID|null} item
 * @param {number} [assoc]
 *
 * @function
 */ const $fd9bbcd8ab314c6e$var$createRelativePosition = (type, item, assoc)=>{
    let typeid = null;
    let tname = null;
    if (type._item === null) tname = $fd9bbcd8ab314c6e$export$e726a40920d54663(type);
    else typeid = $fd9bbcd8ab314c6e$export$6c7d4e6171d008d0(type._item.id.client, type._item.id.clock);
    return new $fd9bbcd8ab314c6e$export$da21a415c5907662(typeid, tname, item, assoc);
};
/**
 * Create a relativePosition based on a absolute position.
 *
 * @param {AbstractType<any>} type The base type (e.g. YText or YArray).
 * @param {number} index The absolute position.
 * @param {number} [assoc]
 * @return {RelativePosition}
 *
 * @function
 */ const $fd9bbcd8ab314c6e$export$197e7d99e3857e88 = (type, index, assoc = 0)=>{
    let t = type._start;
    if (assoc < 0) {
        // associated to the left character or the beginning of a type, increment index if possible.
        if (index === 0) return $fd9bbcd8ab314c6e$var$createRelativePosition(type, null, assoc);
        index--;
    }
    while(t !== null){
        if (!t.deleted && t.countable) {
            if (t.length > index) // case 1: found position somewhere in the linked list
            return $fd9bbcd8ab314c6e$var$createRelativePosition(type, $fd9bbcd8ab314c6e$export$6c7d4e6171d008d0(t.id.client, t.id.clock + index), assoc);
            index -= t.length;
        }
        if (t.right === null && assoc < 0) // left-associated position, return last available id
        return $fd9bbcd8ab314c6e$var$createRelativePosition(type, t.lastId, assoc);
        t = t.right;
    }
    return $fd9bbcd8ab314c6e$var$createRelativePosition(type, null, assoc);
};
/**
 * @param {encoding.Encoder} encoder
 * @param {RelativePosition} rpos
 *
 * @function
 */ const $fd9bbcd8ab314c6e$var$writeRelativePosition = (encoder, rpos)=>{
    const { type: type, tname: tname, item: item, assoc: assoc } = rpos;
    if (item !== null) {
        $apPNa.writeVarUint(encoder, 0);
        $fd9bbcd8ab314c6e$var$writeID(encoder, item);
    } else if (tname !== null) {
        // case 2: found position at the end of the list and type is stored in y.share
        $apPNa.writeUint8(encoder, 1);
        $apPNa.writeVarString(encoder, tname);
    } else if (type !== null) {
        // case 3: found position at the end of the list and type is attached to an item
        $apPNa.writeUint8(encoder, 2);
        $fd9bbcd8ab314c6e$var$writeID(encoder, type);
    } else throw $lqCPr.unexpectedCase();
    $apPNa.writeVarInt(encoder, assoc);
    return encoder;
};
/**
 * @param {RelativePosition} rpos
 * @return {Uint8Array}
 */ const $fd9bbcd8ab314c6e$export$c5c95ef724203575 = (rpos)=>{
    const encoder = $apPNa.createEncoder();
    $fd9bbcd8ab314c6e$var$writeRelativePosition(encoder, rpos);
    return $apPNa.toUint8Array(encoder);
};
/**
 * @param {decoding.Decoder} decoder
 * @return {RelativePosition}
 *
 * @function
 */ const $fd9bbcd8ab314c6e$var$readRelativePosition = (decoder)=>{
    let type = null;
    let tname = null;
    let itemID = null;
    switch($dW8Wq.readVarUint(decoder)){
        case 0:
            // case 1: found position somewhere in the linked list
            itemID = $fd9bbcd8ab314c6e$var$readID(decoder);
            break;
        case 1:
            // case 2: found position at the end of the list and type is stored in y.share
            tname = $dW8Wq.readVarString(decoder);
            break;
        case 2:
            // case 3: found position at the end of the list and type is attached to an item
            type = $fd9bbcd8ab314c6e$var$readID(decoder);
    }
    const assoc = $dW8Wq.hasContent(decoder) ? $dW8Wq.readVarInt(decoder) : 0;
    return new $fd9bbcd8ab314c6e$export$da21a415c5907662(type, tname, itemID, assoc);
};
/**
 * @param {Uint8Array} uint8Array
 * @return {RelativePosition}
 */ const $fd9bbcd8ab314c6e$export$58a46cebc90e7851 = (uint8Array)=>$fd9bbcd8ab314c6e$var$readRelativePosition($dW8Wq.createDecoder(uint8Array));
/**
 * Transform a relative position to an absolute position.
 *
 * If you want to share the relative position with other users, you should set
 * `followUndoneDeletions` to false to get consistent results across all clients.
 *
 * When calculating the absolute position, we try to follow the "undone deletions". This yields
 * better results for the user who performed undo. However, only the user who performed the undo
 * will get the better results, the other users don't know which operations recreated a deleted
 * range of content. There is more information in this ticket: https://github.com/yjs/yjs/issues/638
 *
 * @param {RelativePosition} rpos
 * @param {Doc} doc
 * @param {boolean} followUndoneDeletions - whether to follow undone deletions - see https://github.com/yjs/yjs/issues/638
 * @return {AbsolutePosition|null}
 *
 * @function
 */ const $fd9bbcd8ab314c6e$export$8fc3152f62fb7ed1 = (rpos, doc, followUndoneDeletions = true)=>{
    const store = doc.store;
    const rightID = rpos.item;
    const typeID = rpos.type;
    const tname = rpos.tname;
    const assoc = rpos.assoc;
    let type = null;
    let index = 0;
    if (rightID !== null) {
        if ($fd9bbcd8ab314c6e$export$50fdfeece43146fd(store, rightID.client) <= rightID.clock) return null;
        const res = followUndoneDeletions ? $fd9bbcd8ab314c6e$var$followRedone(store, rightID) : {
            item: $fd9bbcd8ab314c6e$export$f92dfeb71e9bb569(store, rightID),
            diff: 0
        };
        const right = res.item;
        if (!(right instanceof $fd9bbcd8ab314c6e$export$6d08773d2e66f8f2)) return null;
        type = /** @type {AbstractType<any>} */ right.parent;
        if (type._item === null || !type._item.deleted) {
            index = right.deleted || !right.countable ? 0 : res.diff + (assoc >= 0 ? 0 : 1); // adjust position based on left association if necessary
            let n = right.left;
            while(n !== null){
                if (!n.deleted && n.countable) index += n.length;
                n = n.left;
            }
        }
    } else {
        if (tname !== null) type = doc.get(tname);
        else if (typeID !== null) {
            if ($fd9bbcd8ab314c6e$export$50fdfeece43146fd(store, typeID.client) <= typeID.clock) // type does not exist yet
            return null;
            const { item: item } = followUndoneDeletions ? $fd9bbcd8ab314c6e$var$followRedone(store, typeID) : {
                item: $fd9bbcd8ab314c6e$export$f92dfeb71e9bb569(store, typeID)
            };
            if (item instanceof $fd9bbcd8ab314c6e$export$6d08773d2e66f8f2 && item.content instanceof $fd9bbcd8ab314c6e$export$e2e108cbe2e4f865) type = item.content.type;
            else // struct is garbage collected
            return null;
        } else throw $lqCPr.unexpectedCase();
        if (assoc >= 0) index = type._length;
        else index = 0;
    }
    return $fd9bbcd8ab314c6e$var$createAbsolutePosition(type, index, rpos.assoc);
};
/**
 * @param {RelativePosition|null} a
 * @param {RelativePosition|null} b
 * @return {boolean}
 *
 * @function
 */ const $fd9bbcd8ab314c6e$export$fc8bd253c948b475 = (a, b)=>a === b || a !== null && b !== null && a.tname === b.tname && $fd9bbcd8ab314c6e$export$c0af976e7e459c02(a.item, b.item) && $fd9bbcd8ab314c6e$export$c0af976e7e459c02(a.type, b.type) && a.assoc === b.assoc;
class $fd9bbcd8ab314c6e$export$c963130a5525248f {
    /**
   * @param {DeleteSet} ds
   * @param {Map<number,number>} sv state map
   */ constructor(ds, sv){
        /**
     * @type {DeleteSet}
     */ this.ds = ds;
        /**
     * State Map
     * @type {Map<number,number>}
     */ this.sv = sv;
    }
}
/**
 * @param {Snapshot} snap1
 * @param {Snapshot} snap2
 * @return {boolean}
 */ const $fd9bbcd8ab314c6e$export$742742a0f55b273d = (snap1, snap2)=>{
    const ds1 = snap1.ds.clients;
    const ds2 = snap2.ds.clients;
    const sv1 = snap1.sv;
    const sv2 = snap2.sv;
    if (sv1.size !== sv2.size || ds1.size !== ds2.size) return false;
    for (const [key, value] of sv1.entries()){
        if (sv2.get(key) !== value) return false;
    }
    for (const [client, dsitems1] of ds1.entries()){
        const dsitems2 = ds2.get(client) || [];
        if (dsitems1.length !== dsitems2.length) return false;
        for(let i = 0; i < dsitems1.length; i++){
            const dsitem1 = dsitems1[i];
            const dsitem2 = dsitems2[i];
            if (dsitem1.clock !== dsitem2.clock || dsitem1.len !== dsitem2.len) return false;
        }
    }
    return true;
};
/**
 * @param {Snapshot} snapshot
 * @param {DSEncoderV1 | DSEncoderV2} [encoder]
 * @return {Uint8Array}
 */ const $fd9bbcd8ab314c6e$export$b946cadc55f8e512 = (snapshot, encoder = new $fd9bbcd8ab314c6e$var$DSEncoderV2())=>{
    $fd9bbcd8ab314c6e$var$writeDeleteSet(encoder, snapshot.ds);
    $fd9bbcd8ab314c6e$var$writeStateVector(encoder, snapshot.sv);
    return encoder.toUint8Array();
};
/**
 * @param {Snapshot} snapshot
 * @return {Uint8Array}
 */ const $fd9bbcd8ab314c6e$export$a6d29989648e995 = (snapshot)=>$fd9bbcd8ab314c6e$export$b946cadc55f8e512(snapshot, new $fd9bbcd8ab314c6e$var$DSEncoderV1());
/**
 * @param {Uint8Array} buf
 * @param {DSDecoderV1 | DSDecoderV2} [decoder]
 * @return {Snapshot}
 */ const $fd9bbcd8ab314c6e$export$b0049fa299f4f58e = (buf, decoder = new $fd9bbcd8ab314c6e$var$DSDecoderV2($dW8Wq.createDecoder(buf)))=>{
    return new $fd9bbcd8ab314c6e$export$c963130a5525248f($fd9bbcd8ab314c6e$var$readDeleteSet(decoder), $fd9bbcd8ab314c6e$var$readStateVector(decoder));
};
/**
 * @param {Uint8Array} buf
 * @return {Snapshot}
 */ const $fd9bbcd8ab314c6e$export$5c696daccf32bd2e = (buf)=>$fd9bbcd8ab314c6e$export$b0049fa299f4f58e(buf, new $fd9bbcd8ab314c6e$var$DSDecoderV1($dW8Wq.createDecoder(buf)));
/**
 * @param {DeleteSet} ds
 * @param {Map<number,number>} sm
 * @return {Snapshot}
 */ const $fd9bbcd8ab314c6e$export$548fae0445f878fd = (ds, sm)=>new $fd9bbcd8ab314c6e$export$c963130a5525248f(ds, sm);
const $fd9bbcd8ab314c6e$export$d4568a81dd107a34 = $fd9bbcd8ab314c6e$export$548fae0445f878fd($fd9bbcd8ab314c6e$export$8cbac0d946238699(), new Map());
/**
 * @param {Doc} doc
 * @return {Snapshot}
 */ const $fd9bbcd8ab314c6e$export$b8801ea43165ed7d = (doc)=>$fd9bbcd8ab314c6e$export$548fae0445f878fd($fd9bbcd8ab314c6e$export$8450d668bec558e2(doc.store), $fd9bbcd8ab314c6e$var$getStateVector(doc.store));
/**
 * @param {Item} item
 * @param {Snapshot|undefined} snapshot
 *
 * @protected
 * @function
 */ const $fd9bbcd8ab314c6e$var$isVisible = (item, snapshot)=>snapshot === undefined ? !item.deleted : snapshot.sv.has(item.id.client) && (snapshot.sv.get(item.id.client) || 0) > item.id.clock && !$fd9bbcd8ab314c6e$export$dcb04af092e44fde(snapshot.ds, item.id);
/**
 * @param {Transaction} transaction
 * @param {Snapshot} snapshot
 */ const $fd9bbcd8ab314c6e$var$splitSnapshotAffectedStructs = (transaction, snapshot)=>{
    const meta = $2U6oo.setIfUndefined(transaction.meta, $fd9bbcd8ab314c6e$var$splitSnapshotAffectedStructs, $eq375.create);
    const store = transaction.doc.store;
    // check if we already split for this snapshot
    if (!meta.has(snapshot)) {
        snapshot.sv.forEach((clock, client)=>{
            if (clock < $fd9bbcd8ab314c6e$export$50fdfeece43146fd(store, client)) $fd9bbcd8ab314c6e$var$getItemCleanStart(transaction, $fd9bbcd8ab314c6e$export$6c7d4e6171d008d0(client, clock));
        });
        $fd9bbcd8ab314c6e$export$8afefebbaf4e4c78(transaction, snapshot.ds, (_item)=>{});
        meta.add(snapshot);
    }
};
/**
 * @example
 *  const ydoc = new Y.Doc({ gc: false })
 *  ydoc.getText().insert(0, 'world!')
 *  const snapshot = Y.snapshot(ydoc)
 *  ydoc.getText().insert(0, 'hello ')
 *  const restored = Y.createDocFromSnapshot(ydoc, snapshot)
 *  assert(restored.getText().toString() === 'world!')
 *
 * @param {Doc} originDoc
 * @param {Snapshot} snapshot
 * @param {Doc} [newDoc] Optionally, you may define the Yjs document that receives the data from originDoc
 * @return {Doc}
 */ const $fd9bbcd8ab314c6e$export$5be4ae1e1e56a014 = (originDoc, snapshot, newDoc = new $fd9bbcd8ab314c6e$export$bceacc74c2212615())=>{
    if (originDoc.gc) // we should not try to restore a GC-ed document, because some of the restored items might have their content deleted
    throw new Error("Garbage-collection must be disabled in `originDoc`!");
    const { sv: sv, ds: ds } = snapshot;
    const encoder = new $fd9bbcd8ab314c6e$export$30c99e08943e1c2();
    originDoc.transact((transaction)=>{
        let size = 0;
        sv.forEach((clock)=>{
            if (clock > 0) size++;
        });
        $apPNa.writeVarUint(encoder.restEncoder, size);
        // splitting the structs before writing them to the encoder
        for (const [client, clock] of sv){
            if (clock === 0) continue;
            if (clock < $fd9bbcd8ab314c6e$export$50fdfeece43146fd(originDoc.store, client)) $fd9bbcd8ab314c6e$var$getItemCleanStart(transaction, $fd9bbcd8ab314c6e$export$6c7d4e6171d008d0(client, clock));
            const structs = originDoc.store.clients.get(client) || [];
            const lastStructIndex = $fd9bbcd8ab314c6e$export$5f8f02523cf47b58(structs, clock - 1);
            // write # encoded structs
            $apPNa.writeVarUint(encoder.restEncoder, lastStructIndex + 1);
            encoder.writeClient(client);
            // first clock written is 0
            $apPNa.writeVarUint(encoder.restEncoder, 0);
            for(let i = 0; i <= lastStructIndex; i++)structs[i].write(encoder, 0);
        }
        $fd9bbcd8ab314c6e$var$writeDeleteSet(encoder, ds);
    });
    $fd9bbcd8ab314c6e$export$acc3b0324aabf1b6(newDoc, encoder.toUint8Array(), "snapshot");
    return newDoc;
};
/**
 * @param {Snapshot} snapshot
 * @param {Uint8Array} update
 * @param {typeof UpdateDecoderV2 | typeof UpdateDecoderV1} [YDecoder]
 */ const $fd9bbcd8ab314c6e$var$snapshotContainsUpdateV2 = (snapshot, update, YDecoder = $fd9bbcd8ab314c6e$export$1c932452355c5571)=>{
    const updateDecoder = new YDecoder($dW8Wq.createDecoder(update));
    const lazyDecoder = new $fd9bbcd8ab314c6e$var$LazyStructReader(updateDecoder, false);
    for(let curr = lazyDecoder.curr; curr !== null; curr = lazyDecoder.next()){
        if ((snapshot.sv.get(curr.id.client) || 0) < curr.id.clock + curr.length) return false;
    }
    const mergedDS = $fd9bbcd8ab314c6e$export$b7826cadad53901e([
        snapshot.ds,
        $fd9bbcd8ab314c6e$var$readDeleteSet(updateDecoder)
    ]);
    return $fd9bbcd8ab314c6e$export$9697b72c46fd3a5d(snapshot.ds, mergedDS);
};
/**
 * @param {Snapshot} snapshot
 * @param {Uint8Array} update
 */ const $fd9bbcd8ab314c6e$export$f938135bed5d8db7 = (snapshot, update)=>$fd9bbcd8ab314c6e$var$snapshotContainsUpdateV2(snapshot, update, $fd9bbcd8ab314c6e$export$1aa46d9818b5d1ec);
class $fd9bbcd8ab314c6e$var$StructStore {
    constructor(){
        /**
     * @type {Map<number,Array<GC|Item>>}
     */ this.clients = new Map();
        /**
     * @type {null | { missing: Map<number, number>, update: Uint8Array }}
     */ this.pendingStructs = null;
        /**
     * @type {null | Uint8Array}
     */ this.pendingDs = null;
    }
}
/**
 * Return the states as a Map<client,clock>.
 * Note that clock refers to the next expected clock id.
 *
 * @param {StructStore} store
 * @return {Map<number,number>}
 *
 * @public
 * @function
 */ const $fd9bbcd8ab314c6e$var$getStateVector = (store)=>{
    const sm = new Map();
    store.clients.forEach((structs, client)=>{
        const struct = structs[structs.length - 1];
        sm.set(client, struct.id.clock + struct.length);
    });
    return sm;
};
/**
 * @param {StructStore} store
 * @param {number} client
 * @return {number}
 *
 * @public
 * @function
 */ const $fd9bbcd8ab314c6e$export$50fdfeece43146fd = (store, client)=>{
    const structs = store.clients.get(client);
    if (structs === undefined) return 0;
    const lastStruct = structs[structs.length - 1];
    return lastStruct.id.clock + lastStruct.length;
};
/**
 * @param {StructStore} store
 * @param {GC|Item} struct
 *
 * @private
 * @function
 */ const $fd9bbcd8ab314c6e$var$addStruct = (store, struct)=>{
    let structs = store.clients.get(struct.id.client);
    if (structs === undefined) {
        structs = [];
        store.clients.set(struct.id.client, structs);
    } else {
        const lastStruct = structs[structs.length - 1];
        if (lastStruct.id.clock + lastStruct.length !== struct.id.clock) throw $lqCPr.unexpectedCase();
    }
    structs.push(struct);
};
/**
 * Perform a binary search on a sorted array
 * @param {Array<Item|GC>} structs
 * @param {number} clock
 * @return {number}
 *
 * @private
 * @function
 */ const $fd9bbcd8ab314c6e$export$5f8f02523cf47b58 = (structs, clock)=>{
    let left = 0;
    let right = structs.length - 1;
    let mid = structs[right];
    let midclock = mid.id.clock;
    if (midclock === clock) return right;
    // @todo does it even make sense to pivot the search?
    // If a good split misses, it might actually increase the time to find the correct item.
    // Currently, the only advantage is that search with pivoting might find the item on the first try.
    let midindex = $6O4IB.floor(clock / (midclock + mid.length - 1) * right); // pivoting the search
    while(left <= right){
        mid = structs[midindex];
        midclock = mid.id.clock;
        if (midclock <= clock) {
            if (clock < midclock + mid.length) return midindex;
            left = midindex + 1;
        } else right = midindex - 1;
        midindex = $6O4IB.floor((left + right) / 2);
    }
    // Always check state before looking for a struct in StructStore
    // Therefore the case of not finding a struct is unexpected
    throw $lqCPr.unexpectedCase();
};
/**
 * Expects that id is actually in store. This function throws or is an infinite loop otherwise.
 *
 * @param {StructStore} store
 * @param {ID} id
 * @return {GC|Item}
 *
 * @private
 * @function
 */ const $fd9bbcd8ab314c6e$var$find = (store, id)=>{
    /**
   * @type {Array<GC|Item>}
   */ // @ts-ignore
    const structs = store.clients.get(id.client);
    return structs[$fd9bbcd8ab314c6e$export$5f8f02523cf47b58(structs, id.clock)];
};
/**
 * Expects that id is actually in store. This function throws or is an infinite loop otherwise.
 * @private
 * @function
 */ const $fd9bbcd8ab314c6e$export$f92dfeb71e9bb569 = /** @type {function(StructStore,ID):Item} */ $fd9bbcd8ab314c6e$var$find;
/**
 * @param {Transaction} transaction
 * @param {Array<Item|GC>} structs
 * @param {number} clock
 */ const $fd9bbcd8ab314c6e$var$findIndexCleanStart = (transaction, structs, clock)=>{
    const index = $fd9bbcd8ab314c6e$export$5f8f02523cf47b58(structs, clock);
    const struct = structs[index];
    if (struct.id.clock < clock && struct instanceof $fd9bbcd8ab314c6e$export$6d08773d2e66f8f2) {
        structs.splice(index + 1, 0, $fd9bbcd8ab314c6e$var$splitItem(transaction, struct, clock - struct.id.clock));
        return index + 1;
    }
    return index;
};
/**
 * Expects that id is actually in store. This function throws or is an infinite loop otherwise.
 *
 * @param {Transaction} transaction
 * @param {ID} id
 * @return {Item}
 *
 * @private
 * @function
 */ const $fd9bbcd8ab314c6e$var$getItemCleanStart = (transaction, id)=>{
    const structs = /** @type {Array<Item>} */ transaction.doc.store.clients.get(id.client);
    return structs[$fd9bbcd8ab314c6e$var$findIndexCleanStart(transaction, structs, id.clock)];
};
/**
 * Expects that id is actually in store. This function throws or is an infinite loop otherwise.
 *
 * @param {Transaction} transaction
 * @param {StructStore} store
 * @param {ID} id
 * @return {Item}
 *
 * @private
 * @function
 */ const $fd9bbcd8ab314c6e$var$getItemCleanEnd = (transaction, store, id)=>{
    /**
   * @type {Array<Item>}
   */ // @ts-ignore
    const structs = store.clients.get(id.client);
    const index = $fd9bbcd8ab314c6e$export$5f8f02523cf47b58(structs, id.clock);
    const struct = structs[index];
    if (id.clock !== struct.id.clock + struct.length - 1 && struct.constructor !== $fd9bbcd8ab314c6e$export$12d259ff017e6b58) structs.splice(index + 1, 0, $fd9bbcd8ab314c6e$var$splitItem(transaction, struct, id.clock - struct.id.clock + 1));
    return struct;
};
/**
 * Replace `item` with `newitem` in store
 * @param {StructStore} store
 * @param {GC|Item} struct
 * @param {GC|Item} newStruct
 *
 * @private
 * @function
 */ const $fd9bbcd8ab314c6e$var$replaceStruct = (store, struct, newStruct)=>{
    const structs = /** @type {Array<GC|Item>} */ store.clients.get(struct.id.client);
    structs[$fd9bbcd8ab314c6e$export$5f8f02523cf47b58(structs, struct.id.clock)] = newStruct;
};
/**
 * Iterate over a range of structs
 *
 * @param {Transaction} transaction
 * @param {Array<Item|GC>} structs
 * @param {number} clockStart Inclusive start
 * @param {number} len
 * @param {function(GC|Item):void} f
 *
 * @function
 */ const $fd9bbcd8ab314c6e$var$iterateStructs = (transaction, structs, clockStart, len, f)=>{
    if (len === 0) return;
    const clockEnd = clockStart + len;
    let index = $fd9bbcd8ab314c6e$var$findIndexCleanStart(transaction, structs, clockStart);
    let struct;
    do {
        struct = structs[index++];
        if (clockEnd < struct.id.clock + struct.length) $fd9bbcd8ab314c6e$var$findIndexCleanStart(transaction, structs, clockEnd);
        f(struct);
    }while (index < structs.length && structs[index].id.clock < clockEnd);
};
/**
 * A transaction is created for every change on the Yjs model. It is possible
 * to bundle changes on the Yjs model in a single transaction to
 * minimize the number on messages sent and the number of observer calls.
 * If possible the user of this library should bundle as many changes as
 * possible. Here is an example to illustrate the advantages of bundling:
 *
 * @example
 * const ydoc = new Y.Doc()
 * const map = ydoc.getMap('map')
 * // Log content when change is triggered
 * map.observe(() => {
 *   console.log('change triggered')
 * })
 * // Each change on the map type triggers a log message:
 * map.set('a', 0) // => "change triggered"
 * map.set('b', 0) // => "change triggered"
 * // When put in a transaction, it will trigger the log after the transaction:
 * ydoc.transact(() => {
 *   map.set('a', 1)
 *   map.set('b', 1)
 * }) // => "change triggered"
 *
 * @public
 */ class $fd9bbcd8ab314c6e$export$febc5573c75cefb0 {
    /**
   * @param {Doc} doc
   * @param {any} origin
   * @param {boolean} local
   */ constructor(doc, origin, local){
        /**
     * The Yjs instance.
     * @type {Doc}
     */ this.doc = doc;
        /**
     * Describes the set of deleted items by ids
     * @type {DeleteSet}
     */ this.deleteSet = new $fd9bbcd8ab314c6e$var$DeleteSet();
        /**
     * Holds the state before the transaction started.
     * @type {Map<Number,Number>}
     */ this.beforeState = $fd9bbcd8ab314c6e$var$getStateVector(doc.store);
        /**
     * Holds the state after the transaction.
     * @type {Map<Number,Number>}
     */ this.afterState = new Map();
        /**
     * All types that were directly modified (property added or child
     * inserted/deleted). New types are not included in this Set.
     * Maps from type to parentSubs (`item.parentSub = null` for YArray)
     * @type {Map<AbstractType<YEvent<any>>,Set<String|null>>}
     */ this.changed = new Map();
        /**
     * Stores the events for the types that observe also child elements.
     * It is mainly used by `observeDeep`.
     * @type {Map<AbstractType<YEvent<any>>,Array<YEvent<any>>>}
     */ this.changedParentTypes = new Map();
        /**
     * @type {Array<AbstractStruct>}
     */ this._mergeStructs = [];
        /**
     * @type {any}
     */ this.origin = origin;
        /**
     * Stores meta information on the transaction
     * @type {Map<any,any>}
     */ this.meta = new Map();
        /**
     * Whether this change originates from this doc.
     * @type {boolean}
     */ this.local = local;
        /**
     * @type {Set<Doc>}
     */ this.subdocsAdded = new Set();
        /**
     * @type {Set<Doc>}
     */ this.subdocsRemoved = new Set();
        /**
     * @type {Set<Doc>}
     */ this.subdocsLoaded = new Set();
        /**
     * @type {boolean}
     */ this._needFormattingCleanup = false;
    }
}
/**
 * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
 * @param {Transaction} transaction
 * @return {boolean} Whether data was written.
 */ const $fd9bbcd8ab314c6e$var$writeUpdateMessageFromTransaction = (encoder, transaction)=>{
    if (transaction.deleteSet.clients.size === 0 && !$2U6oo.any(transaction.afterState, (clock, client)=>transaction.beforeState.get(client) !== clock)) return false;
    $fd9bbcd8ab314c6e$var$sortAndMergeDeleteSet(transaction.deleteSet);
    $fd9bbcd8ab314c6e$var$writeStructsFromTransaction(encoder, transaction);
    $fd9bbcd8ab314c6e$var$writeDeleteSet(encoder, transaction.deleteSet);
    return true;
};
/**
 * If `type.parent` was added in current transaction, `type` technically
 * did not change, it was just added and we should not fire events for `type`.
 *
 * @param {Transaction} transaction
 * @param {AbstractType<YEvent<any>>} type
 * @param {string|null} parentSub
 */ const $fd9bbcd8ab314c6e$var$addChangedTypeToTransaction = (transaction, type, parentSub)=>{
    const item = type._item;
    if (item === null || item.id.clock < (transaction.beforeState.get(item.id.client) || 0) && !item.deleted) $2U6oo.setIfUndefined(transaction.changed, type, $eq375.create).add(parentSub);
};
/**
 * @param {Array<AbstractStruct>} structs
 * @param {number} pos
 * @return {number} # of merged structs
 */ const $fd9bbcd8ab314c6e$var$tryToMergeWithLefts = (structs, pos)=>{
    let right = structs[pos];
    let left = structs[pos - 1];
    let i = pos;
    for(; i > 0; right = left, left = structs[--i - 1]){
        if (left.deleted === right.deleted && left.constructor === right.constructor) {
            if (left.mergeWith(right)) {
                if (right instanceof $fd9bbcd8ab314c6e$export$6d08773d2e66f8f2 && right.parentSub !== null && /** @type {AbstractType<any>} */ right.parent._map.get(right.parentSub) === right) /** @type {AbstractType<any>} */ right.parent._map.set(right.parentSub, /** @type {Item} */ left);
                continue;
            }
        }
        break;
    }
    const merged = pos - i;
    if (merged) // remove all merged structs from the array
    structs.splice(pos + 1 - merged, merged);
    return merged;
};
/**
 * @param {DeleteSet} ds
 * @param {StructStore} store
 * @param {function(Item):boolean} gcFilter
 */ const $fd9bbcd8ab314c6e$var$tryGcDeleteSet = (ds, store, gcFilter)=>{
    for (const [client, deleteItems] of ds.clients.entries()){
        const structs = /** @type {Array<GC|Item>} */ store.clients.get(client);
        for(let di = deleteItems.length - 1; di >= 0; di--){
            const deleteItem = deleteItems[di];
            const endDeleteItemClock = deleteItem.clock + deleteItem.len;
            for(let si = $fd9bbcd8ab314c6e$export$5f8f02523cf47b58(structs, deleteItem.clock), struct = structs[si]; si < structs.length && struct.id.clock < endDeleteItemClock; struct = structs[++si]){
                const struct = structs[si];
                if (deleteItem.clock + deleteItem.len <= struct.id.clock) break;
                if (struct instanceof $fd9bbcd8ab314c6e$export$6d08773d2e66f8f2 && struct.deleted && !struct.keep && gcFilter(struct)) struct.gc(store, false);
            }
        }
    }
};
/**
 * @param {DeleteSet} ds
 * @param {StructStore} store
 */ const $fd9bbcd8ab314c6e$var$tryMergeDeleteSet = (ds, store)=>{
    // try to merge deleted / gc'd items
    // merge from right to left for better efficiency and so we don't miss any merge targets
    ds.clients.forEach((deleteItems, client)=>{
        const structs = /** @type {Array<GC|Item>} */ store.clients.get(client);
        for(let di = deleteItems.length - 1; di >= 0; di--){
            const deleteItem = deleteItems[di];
            // start with merging the item next to the last deleted item
            const mostRightIndexToCheck = $6O4IB.min(structs.length - 1, 1 + $fd9bbcd8ab314c6e$export$5f8f02523cf47b58(structs, deleteItem.clock + deleteItem.len - 1));
            for(let si = mostRightIndexToCheck, struct = structs[si]; si > 0 && struct.id.clock >= deleteItem.clock; struct = structs[si])si -= 1 + $fd9bbcd8ab314c6e$var$tryToMergeWithLefts(structs, si);
        }
    });
};
/**
 * @param {DeleteSet} ds
 * @param {StructStore} store
 * @param {function(Item):boolean} gcFilter
 */ const $fd9bbcd8ab314c6e$export$c2e5de00fc43f658 = (ds, store, gcFilter)=>{
    $fd9bbcd8ab314c6e$var$tryGcDeleteSet(ds, store, gcFilter);
    $fd9bbcd8ab314c6e$var$tryMergeDeleteSet(ds, store);
};
/**
 * @param {Array<Transaction>} transactionCleanups
 * @param {number} i
 */ const $fd9bbcd8ab314c6e$var$cleanupTransactions = (transactionCleanups, i)=>{
    if (i < transactionCleanups.length) {
        const transaction = transactionCleanups[i];
        const doc = transaction.doc;
        const store = doc.store;
        const ds = transaction.deleteSet;
        const mergeStructs = transaction._mergeStructs;
        try {
            $fd9bbcd8ab314c6e$var$sortAndMergeDeleteSet(ds);
            transaction.afterState = $fd9bbcd8ab314c6e$var$getStateVector(transaction.doc.store);
            doc.emit("beforeObserverCalls", [
                transaction,
                doc
            ]);
            /**
       * An array of event callbacks.
       *
       * Each callback is called even if the other ones throw errors.
       *
       * @type {Array<function():void>}
       */ const fs = [];
            // observe events on changed types
            transaction.changed.forEach((subs, itemtype)=>fs.push(()=>{
                    if (itemtype._item === null || !itemtype._item.deleted) itemtype._callObserver(transaction, subs);
                }));
            fs.push(()=>{
                // deep observe events
                transaction.changedParentTypes.forEach((events, type)=>{
                    // We need to think about the possibility that the user transforms the
                    // Y.Doc in the event.
                    if (type._dEH.l.length > 0 && (type._item === null || !type._item.deleted)) {
                        events = events.filter((event)=>event.target._item === null || !event.target._item.deleted);
                        events.forEach((event)=>{
                            event.currentTarget = type;
                            // path is relative to the current target
                            event._path = null;
                        });
                        // sort events by path length so that top-level events are fired first.
                        events.sort((event1, event2)=>event1.path.length - event2.path.length);
                        // We don't need to check for events.length
                        // because we know it has at least one element
                        $fd9bbcd8ab314c6e$var$callEventHandlerListeners(type._dEH, events, transaction);
                    }
                });
            });
            fs.push(()=>doc.emit("afterTransaction", [
                    transaction,
                    doc
                ]));
            (0, $5VoPh.callAll)(fs, []);
            if (transaction._needFormattingCleanup) $fd9bbcd8ab314c6e$var$cleanupYTextAfterTransaction(transaction);
        } finally{
            // Replace deleted items with ItemDeleted / GC.
            // This is where content is actually remove from the Yjs Doc.
            if (doc.gc) $fd9bbcd8ab314c6e$var$tryGcDeleteSet(ds, store, doc.gcFilter);
            $fd9bbcd8ab314c6e$var$tryMergeDeleteSet(ds, store);
            // on all affected store.clients props, try to merge
            transaction.afterState.forEach((clock, client)=>{
                const beforeClock = transaction.beforeState.get(client) || 0;
                if (beforeClock !== clock) {
                    const structs = /** @type {Array<GC|Item>} */ store.clients.get(client);
                    // we iterate from right to left so we can safely remove entries
                    const firstChangePos = $6O4IB.max($fd9bbcd8ab314c6e$export$5f8f02523cf47b58(structs, beforeClock), 1);
                    for(let i = structs.length - 1; i >= firstChangePos;)i -= 1 + $fd9bbcd8ab314c6e$var$tryToMergeWithLefts(structs, i);
                }
            });
            // try to merge mergeStructs
            // @todo: it makes more sense to transform mergeStructs to a DS, sort it, and merge from right to left
            //        but at the moment DS does not handle duplicates
            for(let i = mergeStructs.length - 1; i >= 0; i--){
                const { client: client, clock: clock } = mergeStructs[i].id;
                const structs = /** @type {Array<GC|Item>} */ store.clients.get(client);
                const replacedStructPos = $fd9bbcd8ab314c6e$export$5f8f02523cf47b58(structs, clock);
                if (replacedStructPos + 1 < structs.length) {
                    if ($fd9bbcd8ab314c6e$var$tryToMergeWithLefts(structs, replacedStructPos + 1) > 1) continue; // no need to perform next check, both are already merged
                }
                if (replacedStructPos > 0) $fd9bbcd8ab314c6e$var$tryToMergeWithLefts(structs, replacedStructPos);
            }
            if (!transaction.local && transaction.afterState.get(doc.clientID) !== transaction.beforeState.get(doc.clientID)) {
                $6nwkt.print($esuCY.ORANGE, $esuCY.BOLD, "[yjs] ", $esuCY.UNBOLD, $esuCY.RED, "Changed the client-id because another client seems to be using it.");
                doc.clientID = $fd9bbcd8ab314c6e$var$generateNewClientId();
            }
            // @todo Merge all the transactions into one and provide send the data as a single update message
            doc.emit("afterTransactionCleanup", [
                transaction,
                doc
            ]);
            if (doc._observers.has("update")) {
                const encoder = new $fd9bbcd8ab314c6e$export$99171b804d9c5b54();
                const hasContent = $fd9bbcd8ab314c6e$var$writeUpdateMessageFromTransaction(encoder, transaction);
                if (hasContent) doc.emit("update", [
                    encoder.toUint8Array(),
                    transaction.origin,
                    doc,
                    transaction
                ]);
            }
            if (doc._observers.has("updateV2")) {
                const encoder = new $fd9bbcd8ab314c6e$export$30c99e08943e1c2();
                const hasContent = $fd9bbcd8ab314c6e$var$writeUpdateMessageFromTransaction(encoder, transaction);
                if (hasContent) doc.emit("updateV2", [
                    encoder.toUint8Array(),
                    transaction.origin,
                    doc,
                    transaction
                ]);
            }
            const { subdocsAdded: subdocsAdded, subdocsLoaded: subdocsLoaded, subdocsRemoved: subdocsRemoved } = transaction;
            if (subdocsAdded.size > 0 || subdocsRemoved.size > 0 || subdocsLoaded.size > 0) {
                subdocsAdded.forEach((subdoc)=>{
                    subdoc.clientID = doc.clientID;
                    if (subdoc.collectionid == null) subdoc.collectionid = doc.collectionid;
                    doc.subdocs.add(subdoc);
                });
                subdocsRemoved.forEach((subdoc)=>doc.subdocs.delete(subdoc));
                doc.emit("subdocs", [
                    {
                        loaded: subdocsLoaded,
                        added: subdocsAdded,
                        removed: subdocsRemoved
                    },
                    doc,
                    transaction
                ]);
                subdocsRemoved.forEach((subdoc)=>subdoc.destroy());
            }
            if (transactionCleanups.length <= i + 1) {
                doc._transactionCleanups = [];
                doc.emit("afterAllTransactions", [
                    doc,
                    transactionCleanups
                ]);
            } else $fd9bbcd8ab314c6e$var$cleanupTransactions(transactionCleanups, i + 1);
        }
    }
};
/**
 * Implements the functionality of `y.transact(()=>{..})`
 *
 * @template T
 * @param {Doc} doc
 * @param {function(Transaction):T} f
 * @param {any} [origin=true]
 * @return {T}
 *
 * @function
 */ const $fd9bbcd8ab314c6e$export$dac1bad6146b2469 = (doc, f, origin = null, local = true)=>{
    const transactionCleanups = doc._transactionCleanups;
    let initialCall = false;
    /**
   * @type {any}
   */ let result = null;
    if (doc._transaction === null) {
        initialCall = true;
        doc._transaction = new $fd9bbcd8ab314c6e$export$febc5573c75cefb0(doc, origin, local);
        transactionCleanups.push(doc._transaction);
        if (transactionCleanups.length === 1) doc.emit("beforeAllTransactions", [
            doc
        ]);
        doc.emit("beforeTransaction", [
            doc._transaction,
            doc
        ]);
    }
    try {
        result = f(doc._transaction);
    } finally{
        if (initialCall) {
            const finishCleanup = doc._transaction === transactionCleanups[0];
            doc._transaction = null;
            if (finishCleanup) // The first transaction ended, now process observer calls.
            // Observer call may create new transactions for which we need to call the observers and do cleanup.
            // We don't want to nest these calls, so we execute these calls one after
            // another.
            // Also we need to ensure that all cleanups are called, even if the
            // observes throw errors.
            // This file is full of hacky try {} finally {} blocks to ensure that an
            // event can throw errors and also that the cleanup is called.
            $fd9bbcd8ab314c6e$var$cleanupTransactions(transactionCleanups, 0);
        }
    }
    return result;
};
class $fd9bbcd8ab314c6e$var$StackItem {
    /**
   * @param {DeleteSet} deletions
   * @param {DeleteSet} insertions
   */ constructor(deletions, insertions){
        this.insertions = insertions;
        this.deletions = deletions;
        /**
     * Use this to save and restore metadata like selection range
     */ this.meta = new Map();
    }
}
/**
 * @param {Transaction} tr
 * @param {UndoManager} um
 * @param {StackItem} stackItem
 */ const $fd9bbcd8ab314c6e$var$clearUndoManagerStackItem = (tr, um, stackItem)=>{
    $fd9bbcd8ab314c6e$export$8afefebbaf4e4c78(tr, stackItem.deletions, (item)=>{
        if (item instanceof $fd9bbcd8ab314c6e$export$6d08773d2e66f8f2 && um.scope.some((type)=>$fd9bbcd8ab314c6e$export$3c81af374b054d6a(type, item))) $fd9bbcd8ab314c6e$var$keepItem(item, false);
    });
};
/**
 * @param {UndoManager} undoManager
 * @param {Array<StackItem>} stack
 * @param {'undo'|'redo'} eventType
 * @return {StackItem?}
 */ const $fd9bbcd8ab314c6e$var$popStackItem = (undoManager, stack, eventType)=>{
    /**
   * Keep a reference to the transaction so we can fire the event with the changedParentTypes
   * @type {any}
   */ let _tr = null;
    const doc = undoManager.doc;
    const scope = undoManager.scope;
    $fd9bbcd8ab314c6e$export$dac1bad6146b2469(doc, (transaction)=>{
        while(stack.length > 0 && undoManager.currStackItem === null){
            const store = doc.store;
            const stackItem = /** @type {StackItem} */ stack.pop();
            /**
       * @type {Set<Item>}
       */ const itemsToRedo = new Set();
            /**
       * @type {Array<Item>}
       */ const itemsToDelete = [];
            let performedChange = false;
            $fd9bbcd8ab314c6e$export$8afefebbaf4e4c78(transaction, stackItem.insertions, (struct)=>{
                if (struct instanceof $fd9bbcd8ab314c6e$export$6d08773d2e66f8f2) {
                    if (struct.redone !== null) {
                        let { item: item, diff: diff } = $fd9bbcd8ab314c6e$var$followRedone(store, struct.id);
                        if (diff > 0) item = $fd9bbcd8ab314c6e$var$getItemCleanStart(transaction, $fd9bbcd8ab314c6e$export$6c7d4e6171d008d0(item.id.client, item.id.clock + diff));
                        struct = item;
                    }
                    if (!struct.deleted && scope.some((type)=>$fd9bbcd8ab314c6e$export$3c81af374b054d6a(type, /** @type {Item} */ struct))) itemsToDelete.push(struct);
                }
            });
            $fd9bbcd8ab314c6e$export$8afefebbaf4e4c78(transaction, stackItem.deletions, (struct)=>{
                if (struct instanceof $fd9bbcd8ab314c6e$export$6d08773d2e66f8f2 && scope.some((type)=>$fd9bbcd8ab314c6e$export$3c81af374b054d6a(type, struct)) && // Never redo structs in stackItem.insertions because they were created and deleted in the same capture interval.
                !$fd9bbcd8ab314c6e$export$dcb04af092e44fde(stackItem.insertions, struct.id)) itemsToRedo.add(struct);
            });
            itemsToRedo.forEach((struct)=>{
                performedChange = $fd9bbcd8ab314c6e$var$redoItem(transaction, struct, itemsToRedo, stackItem.insertions, undoManager.ignoreRemoteMapChanges, undoManager) !== null || performedChange;
            });
            // We want to delete in reverse order so that children are deleted before
            // parents, so we have more information available when items are filtered.
            for(let i = itemsToDelete.length - 1; i >= 0; i--){
                const item = itemsToDelete[i];
                if (undoManager.deleteFilter(item)) {
                    item.delete(transaction);
                    performedChange = true;
                }
            }
            undoManager.currStackItem = performedChange ? stackItem : null;
        }
        transaction.changed.forEach((subProps, type)=>{
            // destroy search marker if necessary
            if (subProps.has(null) && type._searchMarker) type._searchMarker.length = 0;
        });
        _tr = transaction;
    }, undoManager);
    const res = undoManager.currStackItem;
    if (res != null) {
        const changedParentTypes = _tr.changedParentTypes;
        undoManager.emit("stack-item-popped", [
            {
                stackItem: res,
                type: eventType,
                changedParentTypes: changedParentTypes,
                origin: undoManager
            },
            undoManager
        ]);
        undoManager.currStackItem = null;
    }
    return res;
};
/**
 * @typedef {Object} UndoManagerOptions
 * @property {number} [UndoManagerOptions.captureTimeout=500]
 * @property {function(Transaction):boolean} [UndoManagerOptions.captureTransaction] Do not capture changes of a Transaction if result false.
 * @property {function(Item):boolean} [UndoManagerOptions.deleteFilter=()=>true] Sometimes
 * it is necessary to filter what an Undo/Redo operation can delete. If this
 * filter returns false, the type/item won't be deleted even it is in the
 * undo/redo scope.
 * @property {Set<any>} [UndoManagerOptions.trackedOrigins=new Set([null])]
 * @property {boolean} [ignoreRemoteMapChanges] Experimental. By default, the UndoManager will never overwrite remote changes. Enable this property to enable overwriting remote changes on key-value changes (Y.Map, properties on Y.Xml, etc..).
 * @property {Doc} [doc] The document that this UndoManager operates on. Only needed if typeScope is empty.
 */ /**
 * @typedef {Object} StackItemEvent
 * @property {StackItem} StackItemEvent.stackItem
 * @property {any} StackItemEvent.origin
 * @property {'undo'|'redo'} StackItemEvent.type
 * @property {Map<AbstractType<YEvent<any>>,Array<YEvent<any>>>} StackItemEvent.changedParentTypes
 */ /**
 * Fires 'stack-item-added' event when a stack item was added to either the undo- or
 * the redo-stack. You may store additional stack information via the
 * metadata property on `event.stackItem.meta` (it is a `Map` of metadata properties).
 * Fires 'stack-item-popped' event when a stack item was popped from either the
 * undo- or the redo-stack. You may restore the saved stack information from `event.stackItem.meta`.
 *
 * @extends {ObservableV2<{'stack-item-added':function(StackItemEvent, UndoManager):void, 'stack-item-popped': function(StackItemEvent, UndoManager):void, 'stack-cleared': function({ undoStackCleared: boolean, redoStackCleared: boolean }):void, 'stack-item-updated': function(StackItemEvent, UndoManager):void }>}
 */ class $fd9bbcd8ab314c6e$export$932a3f9a7e88971c extends (0, $jFoCq.ObservableV2) {
    /**
   * @param {AbstractType<any>|Array<AbstractType<any>>} typeScope Accepts either a single type, or an array of types
   * @param {UndoManagerOptions} options
   */ constructor(typeScope, { captureTimeout: captureTimeout = 500, captureTransaction: captureTransaction = (_tr)=>true, deleteFilter: deleteFilter = ()=>true, trackedOrigins: trackedOrigins = new Set([
        null
    ]), ignoreRemoteMapChanges: ignoreRemoteMapChanges = false, doc: doc = /** @type {Doc} */ $8aHnL.isArray(typeScope) ? typeScope[0].doc : typeScope.doc } = {}){
        super();
        /**
     * @type {Array<AbstractType<any>>}
     */ this.scope = [];
        this.doc = doc;
        this.addToScope(typeScope);
        this.deleteFilter = deleteFilter;
        trackedOrigins.add(this);
        this.trackedOrigins = trackedOrigins;
        this.captureTransaction = captureTransaction;
        /**
     * @type {Array<StackItem>}
     */ this.undoStack = [];
        /**
     * @type {Array<StackItem>}
     */ this.redoStack = [];
        /**
     * Whether the client is currently undoing (calling UndoManager.undo)
     *
     * @type {boolean}
     */ this.undoing = false;
        this.redoing = false;
        /**
     * The currently popped stack item if UndoManager.undoing or UndoManager.redoing
     *
     * @type {StackItem|null}
     */ this.currStackItem = null;
        this.lastChange = 0;
        this.ignoreRemoteMapChanges = ignoreRemoteMapChanges;
        this.captureTimeout = captureTimeout;
        /**
     * @param {Transaction} transaction
     */ this.afterTransactionHandler = (transaction)=>{
            // Only track certain transactions
            if (!this.captureTransaction(transaction) || !this.scope.some((type)=>transaction.changedParentTypes.has(type)) || !this.trackedOrigins.has(transaction.origin) && (!transaction.origin || !this.trackedOrigins.has(transaction.origin.constructor))) return;
            const undoing = this.undoing;
            const redoing = this.redoing;
            const stack = undoing ? this.redoStack : this.undoStack;
            if (undoing) this.stopCapturing(); // next undo should not be appended to last stack item
            else if (!redoing) // neither undoing nor redoing: delete redoStack
            this.clear(false, true);
            const insertions = new $fd9bbcd8ab314c6e$var$DeleteSet();
            transaction.afterState.forEach((endClock, client)=>{
                const startClock = transaction.beforeState.get(client) || 0;
                const len = endClock - startClock;
                if (len > 0) $fd9bbcd8ab314c6e$var$addToDeleteSet(insertions, client, startClock, len);
            });
            const now = $7neOC.getUnixTime();
            let didAdd = false;
            if (this.lastChange > 0 && now - this.lastChange < this.captureTimeout && stack.length > 0 && !undoing && !redoing) {
                // append change to last stack op
                const lastOp = stack[stack.length - 1];
                lastOp.deletions = $fd9bbcd8ab314c6e$export$b7826cadad53901e([
                    lastOp.deletions,
                    transaction.deleteSet
                ]);
                lastOp.insertions = $fd9bbcd8ab314c6e$export$b7826cadad53901e([
                    lastOp.insertions,
                    insertions
                ]);
            } else {
                // create a new stack op
                stack.push(new $fd9bbcd8ab314c6e$var$StackItem(transaction.deleteSet, insertions));
                didAdd = true;
            }
            if (!undoing && !redoing) this.lastChange = now;
            // make sure that deleted structs are not gc'd
            $fd9bbcd8ab314c6e$export$8afefebbaf4e4c78(transaction, transaction.deleteSet, /** @param {Item|GC} item */ (item)=>{
                if (item instanceof $fd9bbcd8ab314c6e$export$6d08773d2e66f8f2 && this.scope.some((type)=>$fd9bbcd8ab314c6e$export$3c81af374b054d6a(type, item))) $fd9bbcd8ab314c6e$var$keepItem(item, true);
            });
            /**
       * @type {[StackItemEvent, UndoManager]}
       */ const changeEvent = [
                {
                    stackItem: stack[stack.length - 1],
                    origin: transaction.origin,
                    type: undoing ? "redo" : "undo",
                    changedParentTypes: transaction.changedParentTypes
                },
                this
            ];
            if (didAdd) this.emit("stack-item-added", changeEvent);
            else this.emit("stack-item-updated", changeEvent);
        };
        this.doc.on("afterTransaction", this.afterTransactionHandler);
        this.doc.on("destroy", ()=>{
            this.destroy();
        });
    }
    /**
   * @param {Array<AbstractType<any>> | AbstractType<any>} ytypes
   */ addToScope(ytypes) {
        ytypes = $8aHnL.isArray(ytypes) ? ytypes : [
            ytypes
        ];
        ytypes.forEach((ytype)=>{
            if (this.scope.every((yt)=>yt !== ytype)) {
                if (ytype.doc !== this.doc) $6nwkt.warn("[yjs#509] Not same Y.Doc"); // use MultiDocUndoManager instead. also see https://github.com/yjs/yjs/issues/509
                this.scope.push(ytype);
            }
        });
    }
    /**
   * @param {any} origin
   */ addTrackedOrigin(origin) {
        this.trackedOrigins.add(origin);
    }
    /**
   * @param {any} origin
   */ removeTrackedOrigin(origin) {
        this.trackedOrigins.delete(origin);
    }
    clear(clearUndoStack = true, clearRedoStack = true) {
        if (clearUndoStack && this.canUndo() || clearRedoStack && this.canRedo()) this.doc.transact((tr)=>{
            if (clearUndoStack) {
                this.undoStack.forEach((item)=>$fd9bbcd8ab314c6e$var$clearUndoManagerStackItem(tr, this, item));
                this.undoStack = [];
            }
            if (clearRedoStack) {
                this.redoStack.forEach((item)=>$fd9bbcd8ab314c6e$var$clearUndoManagerStackItem(tr, this, item));
                this.redoStack = [];
            }
            this.emit("stack-cleared", [
                {
                    undoStackCleared: clearUndoStack,
                    redoStackCleared: clearRedoStack
                }
            ]);
        });
    }
    /**
   * UndoManager merges Undo-StackItem if they are created within time-gap
   * smaller than `options.captureTimeout`. Call `um.stopCapturing()` so that the next
   * StackItem won't be merged.
   *
   *
   * @example
   *     // without stopCapturing
   *     ytext.insert(0, 'a')
   *     ytext.insert(1, 'b')
   *     um.undo()
   *     ytext.toString() // => '' (note that 'ab' was removed)
   *     // with stopCapturing
   *     ytext.insert(0, 'a')
   *     um.stopCapturing()
   *     ytext.insert(0, 'b')
   *     um.undo()
   *     ytext.toString() // => 'a' (note that only 'b' was removed)
   *
   */ stopCapturing() {
        this.lastChange = 0;
    }
    /**
   * Undo last changes on type.
   *
   * @return {StackItem?} Returns StackItem if a change was applied
   */ undo() {
        this.undoing = true;
        let res;
        try {
            res = $fd9bbcd8ab314c6e$var$popStackItem(this, this.undoStack, "undo");
        } finally{
            this.undoing = false;
        }
        return res;
    }
    /**
   * Redo last undo operation.
   *
   * @return {StackItem?} Returns StackItem if a change was applied
   */ redo() {
        this.redoing = true;
        let res;
        try {
            res = $fd9bbcd8ab314c6e$var$popStackItem(this, this.redoStack, "redo");
        } finally{
            this.redoing = false;
        }
        return res;
    }
    /**
   * Are undo steps available?
   *
   * @return {boolean} `true` if undo is possible
   */ canUndo() {
        return this.undoStack.length > 0;
    }
    /**
   * Are redo steps available?
   *
   * @return {boolean} `true` if redo is possible
   */ canRedo() {
        return this.redoStack.length > 0;
    }
    destroy() {
        this.trackedOrigins.delete(this);
        this.doc.off("afterTransaction", this.afterTransactionHandler);
        super.destroy();
    }
}
/**
 * @param {UpdateDecoderV1 | UpdateDecoderV2} decoder
 */ function* $fd9bbcd8ab314c6e$var$lazyStructReaderGenerator(decoder) {
    const numOfStateUpdates = $dW8Wq.readVarUint(decoder.restDecoder);
    for(let i = 0; i < numOfStateUpdates; i++){
        const numberOfStructs = $dW8Wq.readVarUint(decoder.restDecoder);
        const client = decoder.readClient();
        let clock = $dW8Wq.readVarUint(decoder.restDecoder);
        for(let i = 0; i < numberOfStructs; i++){
            const info = decoder.readInfo();
            // @todo use switch instead of ifs
            if (info === 10) {
                const len = $dW8Wq.readVarUint(decoder.restDecoder);
                yield new $fd9bbcd8ab314c6e$export$38d24f5c1eb0e4c0($fd9bbcd8ab314c6e$export$6c7d4e6171d008d0(client, clock), len);
                clock += len;
            } else if (($jnoaM.BITS5 & info) !== 0) {
                const cantCopyParentInfo = (info & ($jnoaM.BIT7 | $jnoaM.BIT8)) === 0;
                // If parent = null and neither left nor right are defined, then we know that `parent` is child of `y`
                // and we read the next string as parentYKey.
                // It indicates how we store/retrieve parent from `y.share`
                // @type {string|null}
                const struct = new $fd9bbcd8ab314c6e$export$6d08773d2e66f8f2($fd9bbcd8ab314c6e$export$6c7d4e6171d008d0(client, clock), null, (info & $jnoaM.BIT8) === $jnoaM.BIT8 ? decoder.readLeftID() : null, null, (info & $jnoaM.BIT7) === $jnoaM.BIT7 ? decoder.readRightID() : null, // @ts-ignore Force writing a string here.
                cantCopyParentInfo ? decoder.readParentInfo() ? decoder.readString() : decoder.readLeftID() : null, cantCopyParentInfo && (info & $jnoaM.BIT6) === $jnoaM.BIT6 ? decoder.readString() : null, $fd9bbcd8ab314c6e$var$readItemContent(decoder, info) // item content
                );
                yield struct;
                clock += struct.length;
            } else {
                const len = decoder.readLen();
                yield new $fd9bbcd8ab314c6e$export$12d259ff017e6b58($fd9bbcd8ab314c6e$export$6c7d4e6171d008d0(client, clock), len);
                clock += len;
            }
        }
    }
}
class $fd9bbcd8ab314c6e$var$LazyStructReader {
    /**
   * @param {UpdateDecoderV1 | UpdateDecoderV2} decoder
   * @param {boolean} filterSkips
   */ constructor(decoder, filterSkips){
        this.gen = $fd9bbcd8ab314c6e$var$lazyStructReaderGenerator(decoder);
        /**
     * @type {null | Item | Skip | GC}
     */ this.curr = null;
        this.done = false;
        this.filterSkips = filterSkips;
        this.next();
    }
    /**
   * @return {Item | GC | Skip |null}
   */ next() {
        // ignore "Skip" structs
        do this.curr = this.gen.next().value || null;
        while (this.filterSkips && this.curr !== null && this.curr.constructor === $fd9bbcd8ab314c6e$export$38d24f5c1eb0e4c0);
        return this.curr;
    }
}
/**
 * @param {Uint8Array} update
 *
 */ const $fd9bbcd8ab314c6e$export$d6235ced6e55ace9 = (update)=>$fd9bbcd8ab314c6e$export$624b3f0248c2dc40(update, $fd9bbcd8ab314c6e$export$1aa46d9818b5d1ec);
/**
 * @param {Uint8Array} update
 * @param {typeof UpdateDecoderV2 | typeof UpdateDecoderV1} [YDecoder]
 *
 */ const $fd9bbcd8ab314c6e$export$624b3f0248c2dc40 = (update, YDecoder = $fd9bbcd8ab314c6e$export$1c932452355c5571)=>{
    const structs = [];
    const updateDecoder = new YDecoder($dW8Wq.createDecoder(update));
    const lazyDecoder = new $fd9bbcd8ab314c6e$var$LazyStructReader(updateDecoder, false);
    for(let curr = lazyDecoder.curr; curr !== null; curr = lazyDecoder.next())structs.push(curr);
    $6nwkt.print("Structs: ", structs);
    const ds = $fd9bbcd8ab314c6e$var$readDeleteSet(updateDecoder);
    $6nwkt.print("DeleteSet: ", ds);
};
/**
 * @param {Uint8Array} update
 *
 */ const $fd9bbcd8ab314c6e$export$aa45cba8121663dc = (update)=>$fd9bbcd8ab314c6e$export$2fed33908eb23d71(update, $fd9bbcd8ab314c6e$export$1aa46d9818b5d1ec);
/**
 * @param {Uint8Array} update
 * @param {typeof UpdateDecoderV2 | typeof UpdateDecoderV1} [YDecoder]
 *
 */ const $fd9bbcd8ab314c6e$export$2fed33908eb23d71 = (update, YDecoder = $fd9bbcd8ab314c6e$export$1c932452355c5571)=>{
    const structs = [];
    const updateDecoder = new YDecoder($dW8Wq.createDecoder(update));
    const lazyDecoder = new $fd9bbcd8ab314c6e$var$LazyStructReader(updateDecoder, false);
    for(let curr = lazyDecoder.curr; curr !== null; curr = lazyDecoder.next())structs.push(curr);
    return {
        structs: structs,
        ds: $fd9bbcd8ab314c6e$var$readDeleteSet(updateDecoder)
    };
};
class $fd9bbcd8ab314c6e$var$LazyStructWriter {
    /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   */ constructor(encoder){
        this.currClient = 0;
        this.startClock = 0;
        this.written = 0;
        this.encoder = encoder;
        /**
     * We want to write operations lazily, but also we need to know beforehand how many operations we want to write for each client.
     *
     * This kind of meta-information (#clients, #structs-per-client-written) is written to the restEncoder.
     *
     * We fragment the restEncoder and store a slice of it per-client until we know how many clients there are.
     * When we flush (toUint8Array) we write the restEncoder using the fragments and the meta-information.
     *
     * @type {Array<{ written: number, restEncoder: Uint8Array }>}
     */ this.clientStructs = [];
    }
}
/**
 * @param {Array<Uint8Array>} updates
 * @return {Uint8Array}
 */ const $fd9bbcd8ab314c6e$export$6319871659fd2460 = (updates)=>$fd9bbcd8ab314c6e$export$ce273d78de0331d1(updates, $fd9bbcd8ab314c6e$export$1aa46d9818b5d1ec, $fd9bbcd8ab314c6e$export$99171b804d9c5b54);
/**
 * @param {Uint8Array} update
 * @param {typeof DSEncoderV1 | typeof DSEncoderV2} YEncoder
 * @param {typeof UpdateDecoderV1 | typeof UpdateDecoderV2} YDecoder
 * @return {Uint8Array}
 */ const $fd9bbcd8ab314c6e$export$ed51750cf3ab2381 = (update, YEncoder = $fd9bbcd8ab314c6e$var$DSEncoderV2, YDecoder = $fd9bbcd8ab314c6e$export$1c932452355c5571)=>{
    const encoder = new YEncoder();
    const updateDecoder = new $fd9bbcd8ab314c6e$var$LazyStructReader(new YDecoder($dW8Wq.createDecoder(update)), false);
    let curr = updateDecoder.curr;
    if (curr !== null) {
        let size = 0;
        let currClient = curr.id.client;
        let stopCounting = curr.id.clock !== 0; // must start at 0
        let currClock = stopCounting ? 0 : curr.id.clock + curr.length;
        for(; curr !== null; curr = updateDecoder.next()){
            if (currClient !== curr.id.client) {
                if (currClock !== 0) {
                    size++;
                    // We found a new client
                    // write what we have to the encoder
                    $apPNa.writeVarUint(encoder.restEncoder, currClient);
                    $apPNa.writeVarUint(encoder.restEncoder, currClock);
                }
                currClient = curr.id.client;
                currClock = 0;
                stopCounting = curr.id.clock !== 0;
            }
            // we ignore skips
            if (curr.constructor === $fd9bbcd8ab314c6e$export$38d24f5c1eb0e4c0) stopCounting = true;
            if (!stopCounting) currClock = curr.id.clock + curr.length;
        }
        // write what we have
        if (currClock !== 0) {
            size++;
            $apPNa.writeVarUint(encoder.restEncoder, currClient);
            $apPNa.writeVarUint(encoder.restEncoder, currClock);
        }
        // prepend the size of the state vector
        const enc = $apPNa.createEncoder();
        $apPNa.writeVarUint(enc, size);
        $apPNa.writeBinaryEncoder(enc, encoder.restEncoder);
        encoder.restEncoder = enc;
        return encoder.toUint8Array();
    } else {
        $apPNa.writeVarUint(encoder.restEncoder, 0);
        return encoder.toUint8Array();
    }
};
/**
 * @param {Uint8Array} update
 * @return {Uint8Array}
 */ const $fd9bbcd8ab314c6e$export$5c451fd8502b011f = (update)=>$fd9bbcd8ab314c6e$export$ed51750cf3ab2381(update, $fd9bbcd8ab314c6e$var$DSEncoderV1, $fd9bbcd8ab314c6e$export$1aa46d9818b5d1ec);
/**
 * @param {Uint8Array} update
 * @param {typeof UpdateDecoderV1 | typeof UpdateDecoderV2} YDecoder
 * @return {{ from: Map<number,number>, to: Map<number,number> }}
 */ const $fd9bbcd8ab314c6e$export$8212a58b2178fdcf = (update, YDecoder = $fd9bbcd8ab314c6e$export$1c932452355c5571)=>{
    /**
   * @type {Map<number, number>}
   */ const from = new Map();
    /**
   * @type {Map<number, number>}
   */ const to = new Map();
    const updateDecoder = new $fd9bbcd8ab314c6e$var$LazyStructReader(new YDecoder($dW8Wq.createDecoder(update)), false);
    let curr = updateDecoder.curr;
    if (curr !== null) {
        let currClient = curr.id.client;
        let currClock = curr.id.clock;
        // write the beginning to `from`
        from.set(currClient, currClock);
        for(; curr !== null; curr = updateDecoder.next()){
            if (currClient !== curr.id.client) {
                // We found a new client
                // write the end to `to`
                to.set(currClient, currClock);
                // write the beginning to `from`
                from.set(curr.id.client, curr.id.clock);
                // update currClient
                currClient = curr.id.client;
            }
            currClock = curr.id.clock + curr.length;
        }
        // write the end to `to`
        to.set(currClient, currClock);
    }
    return {
        from: from,
        to: to
    };
};
/**
 * @param {Uint8Array} update
 * @return {{ from: Map<number,number>, to: Map<number,number> }}
 */ const $fd9bbcd8ab314c6e$export$e212b06fd4bf78fd = (update)=>$fd9bbcd8ab314c6e$export$8212a58b2178fdcf(update, $fd9bbcd8ab314c6e$export$1aa46d9818b5d1ec);
/**
 * This method is intended to slice any kind of struct and retrieve the right part.
 * It does not handle side-effects, so it should only be used by the lazy-encoder.
 *
 * @param {Item | GC | Skip} left
 * @param {number} diff
 * @return {Item | GC}
 */ const $fd9bbcd8ab314c6e$var$sliceStruct = (left, diff)=>{
    if (left.constructor === $fd9bbcd8ab314c6e$export$12d259ff017e6b58) {
        const { client: client, clock: clock } = left.id;
        return new $fd9bbcd8ab314c6e$export$12d259ff017e6b58($fd9bbcd8ab314c6e$export$6c7d4e6171d008d0(client, clock + diff), left.length - diff);
    } else if (left.constructor === $fd9bbcd8ab314c6e$export$38d24f5c1eb0e4c0) {
        const { client: client, clock: clock } = left.id;
        return new $fd9bbcd8ab314c6e$export$38d24f5c1eb0e4c0($fd9bbcd8ab314c6e$export$6c7d4e6171d008d0(client, clock + diff), left.length - diff);
    } else {
        const leftItem = /** @type {Item} */ left;
        const { client: client, clock: clock } = leftItem.id;
        return new $fd9bbcd8ab314c6e$export$6d08773d2e66f8f2($fd9bbcd8ab314c6e$export$6c7d4e6171d008d0(client, clock + diff), null, $fd9bbcd8ab314c6e$export$6c7d4e6171d008d0(client, clock + diff - 1), null, leftItem.rightOrigin, leftItem.parent, leftItem.parentSub, leftItem.content.splice(diff));
    }
};
/**
 *
 * This function works similarly to `readUpdateV2`.
 *
 * @param {Array<Uint8Array>} updates
 * @param {typeof UpdateDecoderV1 | typeof UpdateDecoderV2} [YDecoder]
 * @param {typeof UpdateEncoderV1 | typeof UpdateEncoderV2} [YEncoder]
 * @return {Uint8Array}
 */ const $fd9bbcd8ab314c6e$export$ce273d78de0331d1 = (updates, YDecoder = $fd9bbcd8ab314c6e$export$1c932452355c5571, YEncoder = $fd9bbcd8ab314c6e$export$30c99e08943e1c2)=>{
    if (updates.length === 1) return updates[0];
    const updateDecoders = updates.map((update)=>new YDecoder($dW8Wq.createDecoder(update)));
    let lazyStructDecoders = updateDecoders.map((decoder)=>new $fd9bbcd8ab314c6e$var$LazyStructReader(decoder, true));
    /**
   * @todo we don't need offset because we always slice before
   * @type {null | { struct: Item | GC | Skip, offset: number }}
   */ let currWrite = null;
    const updateEncoder = new YEncoder();
    // write structs lazily
    const lazyStructEncoder = new $fd9bbcd8ab314c6e$var$LazyStructWriter(updateEncoder);
    // Note: We need to ensure that all lazyStructDecoders are fully consumed
    // Note: Should merge document updates whenever possible - even from different updates
    // Note: Should handle that some operations cannot be applied yet ()
    while(true){
        // Write higher clients first ⇒ sort by clientID & clock and remove decoders without content
        lazyStructDecoders = lazyStructDecoders.filter((dec)=>dec.curr !== null);
        lazyStructDecoders.sort(/** @type {function(any,any):number} */ (dec1, dec2)=>{
            if (dec1.curr.id.client === dec2.curr.id.client) {
                const clockDiff = dec1.curr.id.clock - dec2.curr.id.clock;
                if (clockDiff === 0) // @todo remove references to skip since the structDecoders must filter Skips.
                return dec1.curr.constructor === dec2.curr.constructor ? 0 : dec1.curr.constructor === $fd9bbcd8ab314c6e$export$38d24f5c1eb0e4c0 ? 1 : -1 // we are filtering skips anyway.
                ;
                else return clockDiff;
            } else return dec2.curr.id.client - dec1.curr.id.client;
        });
        if (lazyStructDecoders.length === 0) break;
        const currDecoder = lazyStructDecoders[0];
        // write from currDecoder until the next operation is from another client or if filler-struct
        // then we need to reorder the decoders and find the next operation to write
        const firstClient = /** @type {Item | GC} */ currDecoder.curr.id.client;
        if (currWrite !== null) {
            let curr = /** @type {Item | GC | null} */ currDecoder.curr;
            let iterated = false;
            // iterate until we find something that we haven't written already
            // remember: first the high client-ids are written
            while(curr !== null && curr.id.clock + curr.length <= currWrite.struct.id.clock + currWrite.struct.length && curr.id.client >= currWrite.struct.id.client){
                curr = currDecoder.next();
                iterated = true;
            }
            if (curr === null || // current decoder is empty
            curr.id.client !== firstClient || // check whether there is another decoder that has has updates from `firstClient`
            iterated && curr.id.clock > currWrite.struct.id.clock + currWrite.struct.length // the above while loop was used and we are potentially missing updates
            ) continue;
            if (firstClient !== currWrite.struct.id.client) {
                $fd9bbcd8ab314c6e$var$writeStructToLazyStructWriter(lazyStructEncoder, currWrite.struct, currWrite.offset);
                currWrite = {
                    struct: curr,
                    offset: 0
                };
                currDecoder.next();
            } else if (currWrite.struct.id.clock + currWrite.struct.length < curr.id.clock) {
                // @todo write currStruct & set currStruct = Skip(clock = currStruct.id.clock + currStruct.length, length = curr.id.clock - self.clock)
                if (currWrite.struct.constructor === $fd9bbcd8ab314c6e$export$38d24f5c1eb0e4c0) // extend existing skip
                currWrite.struct.length = curr.id.clock + curr.length - currWrite.struct.id.clock;
                else {
                    $fd9bbcd8ab314c6e$var$writeStructToLazyStructWriter(lazyStructEncoder, currWrite.struct, currWrite.offset);
                    const diff = curr.id.clock - currWrite.struct.id.clock - currWrite.struct.length;
                    /**
             * @type {Skip}
             */ const struct = new $fd9bbcd8ab314c6e$export$38d24f5c1eb0e4c0($fd9bbcd8ab314c6e$export$6c7d4e6171d008d0(firstClient, currWrite.struct.id.clock + currWrite.struct.length), diff);
                    currWrite = {
                        struct: struct,
                        offset: 0
                    };
                }
            } else {
                const diff = currWrite.struct.id.clock + currWrite.struct.length - curr.id.clock;
                if (diff > 0) {
                    if (currWrite.struct.constructor === $fd9bbcd8ab314c6e$export$38d24f5c1eb0e4c0) // prefer to slice Skip because the other struct might contain more information
                    currWrite.struct.length -= diff;
                    else curr = $fd9bbcd8ab314c6e$var$sliceStruct(curr, diff);
                }
                if (!currWrite.struct.mergeWith(/** @type {any} */ curr)) {
                    $fd9bbcd8ab314c6e$var$writeStructToLazyStructWriter(lazyStructEncoder, currWrite.struct, currWrite.offset);
                    currWrite = {
                        struct: curr,
                        offset: 0
                    };
                    currDecoder.next();
                }
            }
        } else {
            currWrite = {
                struct: /** @type {Item | GC} */ currDecoder.curr,
                offset: 0
            };
            currDecoder.next();
        }
        for(let next = currDecoder.curr; next !== null && next.id.client === firstClient && next.id.clock === currWrite.struct.id.clock + currWrite.struct.length && next.constructor !== $fd9bbcd8ab314c6e$export$38d24f5c1eb0e4c0; next = currDecoder.next()){
            $fd9bbcd8ab314c6e$var$writeStructToLazyStructWriter(lazyStructEncoder, currWrite.struct, currWrite.offset);
            currWrite = {
                struct: next,
                offset: 0
            };
        }
    }
    if (currWrite !== null) {
        $fd9bbcd8ab314c6e$var$writeStructToLazyStructWriter(lazyStructEncoder, currWrite.struct, currWrite.offset);
        currWrite = null;
    }
    $fd9bbcd8ab314c6e$var$finishLazyStructWriting(lazyStructEncoder);
    const dss = updateDecoders.map((decoder)=>$fd9bbcd8ab314c6e$var$readDeleteSet(decoder));
    const ds = $fd9bbcd8ab314c6e$export$b7826cadad53901e(dss);
    $fd9bbcd8ab314c6e$var$writeDeleteSet(updateEncoder, ds);
    return updateEncoder.toUint8Array();
};
/**
 * @param {Uint8Array} update
 * @param {Uint8Array} sv
 * @param {typeof UpdateDecoderV1 | typeof UpdateDecoderV2} [YDecoder]
 * @param {typeof UpdateEncoderV1 | typeof UpdateEncoderV2} [YEncoder]
 */ const $fd9bbcd8ab314c6e$export$a8143edf39d2ad8e = (update, sv, YDecoder = $fd9bbcd8ab314c6e$export$1c932452355c5571, YEncoder = $fd9bbcd8ab314c6e$export$30c99e08943e1c2)=>{
    const state = $fd9bbcd8ab314c6e$export$324ac6fb20a844e3(sv);
    const encoder = new YEncoder();
    const lazyStructWriter = new $fd9bbcd8ab314c6e$var$LazyStructWriter(encoder);
    const decoder = new YDecoder($dW8Wq.createDecoder(update));
    const reader = new $fd9bbcd8ab314c6e$var$LazyStructReader(decoder, false);
    while(reader.curr){
        const curr = reader.curr;
        const currClient = curr.id.client;
        const svClock = state.get(currClient) || 0;
        if (reader.curr.constructor === $fd9bbcd8ab314c6e$export$38d24f5c1eb0e4c0) {
            // the first written struct shouldn't be a skip
            reader.next();
            continue;
        }
        if (curr.id.clock + curr.length > svClock) {
            $fd9bbcd8ab314c6e$var$writeStructToLazyStructWriter(lazyStructWriter, curr, $6O4IB.max(svClock - curr.id.clock, 0));
            reader.next();
            while(reader.curr && reader.curr.id.client === currClient){
                $fd9bbcd8ab314c6e$var$writeStructToLazyStructWriter(lazyStructWriter, reader.curr, 0);
                reader.next();
            }
        } else // read until something new comes up
        while(reader.curr && reader.curr.id.client === currClient && reader.curr.id.clock + reader.curr.length <= svClock)reader.next();
    }
    $fd9bbcd8ab314c6e$var$finishLazyStructWriting(lazyStructWriter);
    // write ds
    const ds = $fd9bbcd8ab314c6e$var$readDeleteSet(decoder);
    $fd9bbcd8ab314c6e$var$writeDeleteSet(encoder, ds);
    return encoder.toUint8Array();
};
/**
 * @param {Uint8Array} update
 * @param {Uint8Array} sv
 */ const $fd9bbcd8ab314c6e$export$bf60b51d6c283426 = (update, sv)=>$fd9bbcd8ab314c6e$export$a8143edf39d2ad8e(update, sv, $fd9bbcd8ab314c6e$export$1aa46d9818b5d1ec, $fd9bbcd8ab314c6e$export$99171b804d9c5b54);
/**
 * @param {LazyStructWriter} lazyWriter
 */ const $fd9bbcd8ab314c6e$var$flushLazyStructWriter = (lazyWriter)=>{
    if (lazyWriter.written > 0) {
        lazyWriter.clientStructs.push({
            written: lazyWriter.written,
            restEncoder: $apPNa.toUint8Array(lazyWriter.encoder.restEncoder)
        });
        lazyWriter.encoder.restEncoder = $apPNa.createEncoder();
        lazyWriter.written = 0;
    }
};
/**
 * @param {LazyStructWriter} lazyWriter
 * @param {Item | GC} struct
 * @param {number} offset
 */ const $fd9bbcd8ab314c6e$var$writeStructToLazyStructWriter = (lazyWriter, struct, offset)=>{
    // flush curr if we start another client
    if (lazyWriter.written > 0 && lazyWriter.currClient !== struct.id.client) $fd9bbcd8ab314c6e$var$flushLazyStructWriter(lazyWriter);
    if (lazyWriter.written === 0) {
        lazyWriter.currClient = struct.id.client;
        // write next client
        lazyWriter.encoder.writeClient(struct.id.client);
        // write startClock
        $apPNa.writeVarUint(lazyWriter.encoder.restEncoder, struct.id.clock + offset);
    }
    struct.write(lazyWriter.encoder, offset);
    lazyWriter.written++;
};
/**
 * Call this function when we collected all parts and want to
 * put all the parts together. After calling this method,
 * you can continue using the UpdateEncoder.
 *
 * @param {LazyStructWriter} lazyWriter
 */ const $fd9bbcd8ab314c6e$var$finishLazyStructWriting = (lazyWriter)=>{
    $fd9bbcd8ab314c6e$var$flushLazyStructWriter(lazyWriter);
    // this is a fresh encoder because we called flushCurr
    const restEncoder = lazyWriter.encoder.restEncoder;
    /**
   * Now we put all the fragments together.
   * This works similarly to `writeClientsStructs`
   */ // write # states that were updated - i.e. the clients
    $apPNa.writeVarUint(restEncoder, lazyWriter.clientStructs.length);
    for(let i = 0; i < lazyWriter.clientStructs.length; i++){
        const partStructs = lazyWriter.clientStructs[i];
        /**
     * Works similarly to `writeStructs`
     */ // write # encoded structs
        $apPNa.writeVarUint(restEncoder, partStructs.written);
        // write the rest of the fragment
        $apPNa.writeUint8Array(restEncoder, partStructs.restEncoder);
    }
};
/**
 * @param {Uint8Array} update
 * @param {function(Item|GC|Skip):Item|GC|Skip} blockTransformer
 * @param {typeof UpdateDecoderV2 | typeof UpdateDecoderV1} YDecoder
 * @param {typeof UpdateEncoderV2 | typeof UpdateEncoderV1 } YEncoder
 */ const $fd9bbcd8ab314c6e$var$convertUpdateFormat = (update, blockTransformer, YDecoder, YEncoder)=>{
    const updateDecoder = new YDecoder($dW8Wq.createDecoder(update));
    const lazyDecoder = new $fd9bbcd8ab314c6e$var$LazyStructReader(updateDecoder, false);
    const updateEncoder = new YEncoder();
    const lazyWriter = new $fd9bbcd8ab314c6e$var$LazyStructWriter(updateEncoder);
    for(let curr = lazyDecoder.curr; curr !== null; curr = lazyDecoder.next())$fd9bbcd8ab314c6e$var$writeStructToLazyStructWriter(lazyWriter, blockTransformer(curr), 0);
    $fd9bbcd8ab314c6e$var$finishLazyStructWriting(lazyWriter);
    const ds = $fd9bbcd8ab314c6e$var$readDeleteSet(updateDecoder);
    $fd9bbcd8ab314c6e$var$writeDeleteSet(updateEncoder, ds);
    return updateEncoder.toUint8Array();
};
/**
 * @typedef {Object} ObfuscatorOptions
 * @property {boolean} [ObfuscatorOptions.formatting=true]
 * @property {boolean} [ObfuscatorOptions.subdocs=true]
 * @property {boolean} [ObfuscatorOptions.yxml=true] Whether to obfuscate nodeName / hookName
 */ /**
 * @param {ObfuscatorOptions} obfuscator
 */ const $fd9bbcd8ab314c6e$var$createObfuscator = ({ formatting: formatting = true, subdocs: subdocs = true, yxml: yxml = true } = {})=>{
    let i = 0;
    const mapKeyCache = $2U6oo.create();
    const nodeNameCache = $2U6oo.create();
    const formattingKeyCache = $2U6oo.create();
    const formattingValueCache = $2U6oo.create();
    formattingValueCache.set(null, null); // end of a formatting range should always be the end of a formatting range
    /**
   * @param {Item|GC|Skip} block
   * @return {Item|GC|Skip}
   */ return (block)=>{
        switch(block.constructor){
            case $fd9bbcd8ab314c6e$export$12d259ff017e6b58:
            case $fd9bbcd8ab314c6e$export$38d24f5c1eb0e4c0:
                return block;
            case $fd9bbcd8ab314c6e$export$6d08773d2e66f8f2:
                {
                    const item = /** @type {Item} */ block;
                    const content = item.content;
                    switch(content.constructor){
                        case $fd9bbcd8ab314c6e$export$3b06e0b3a2ece602:
                            break;
                        case $fd9bbcd8ab314c6e$export$e2e108cbe2e4f865:
                            if (yxml) {
                                const type = /** @type {ContentType} */ content.type;
                                if (type instanceof $fd9bbcd8ab314c6e$export$4db87581d3ca170d) type.nodeName = $2U6oo.setIfUndefined(nodeNameCache, type.nodeName, ()=>"node-" + i);
                                if (type instanceof $fd9bbcd8ab314c6e$export$ec64c1dd5e7a264) type.hookName = $2U6oo.setIfUndefined(nodeNameCache, type.hookName, ()=>"hook-" + i);
                            }
                            break;
                        case $fd9bbcd8ab314c6e$export$1d788b93bbb631a0:
                            {
                                const c = /** @type {ContentAny} */ content;
                                c.arr = c.arr.map(()=>i);
                                break;
                            }
                        case $fd9bbcd8ab314c6e$export$e8d530cdf62d1cbd:
                            {
                                const c = /** @type {ContentBinary} */ content;
                                c.content = new Uint8Array([
                                    i
                                ]);
                                break;
                            }
                        case $fd9bbcd8ab314c6e$export$b564c0e69572c0e:
                            {
                                const c = /** @type {ContentDoc} */ content;
                                if (subdocs) {
                                    c.opts = {};
                                    c.doc.guid = i + "";
                                }
                                break;
                            }
                        case $fd9bbcd8ab314c6e$export$c3787ba7f6086664:
                            {
                                const c = /** @type {ContentEmbed} */ content;
                                c.embed = {};
                                break;
                            }
                        case $fd9bbcd8ab314c6e$export$3194899188fb5a88:
                            {
                                const c = /** @type {ContentFormat} */ content;
                                if (formatting) {
                                    c.key = $2U6oo.setIfUndefined(formattingKeyCache, c.key, ()=>i + "");
                                    c.value = $2U6oo.setIfUndefined(formattingValueCache, c.value, ()=>({
                                            i: i
                                        }));
                                }
                                break;
                            }
                        case $fd9bbcd8ab314c6e$export$6a907ea8f733ecf3:
                            {
                                const c = /** @type {ContentJSON} */ content;
                                c.arr = c.arr.map(()=>i);
                                break;
                            }
                        case $fd9bbcd8ab314c6e$export$ee670b2cf091bbb6:
                            {
                                const c = /** @type {ContentString} */ content;
                                c.str = $8YS3b.repeat(i % 10 + "", c.str.length);
                                break;
                            }
                        default:
                            // unknown content type
                            $lqCPr.unexpectedCase();
                    }
                    if (item.parentSub) item.parentSub = $2U6oo.setIfUndefined(mapKeyCache, item.parentSub, ()=>i + "");
                    i++;
                    return block;
                }
            default:
                // unknown block-type
                $lqCPr.unexpectedCase();
        }
    };
};
/**
 * This function obfuscates the content of a Yjs update. This is useful to share
 * buggy Yjs documents while significantly limiting the possibility that a
 * developer can on the user. Note that it might still be possible to deduce
 * some information by analyzing the "structure" of the document or by analyzing
 * the typing behavior using the CRDT-related metadata that is still kept fully
 * intact.
 *
 * @param {Uint8Array} update
 * @param {ObfuscatorOptions} [opts]
 */ const $fd9bbcd8ab314c6e$export$2dc24d59ec48a24e = (update, opts)=>$fd9bbcd8ab314c6e$var$convertUpdateFormat(update, $fd9bbcd8ab314c6e$var$createObfuscator(opts), $fd9bbcd8ab314c6e$export$1aa46d9818b5d1ec, $fd9bbcd8ab314c6e$export$99171b804d9c5b54);
/**
 * @param {Uint8Array} update
 * @param {ObfuscatorOptions} [opts]
 */ const $fd9bbcd8ab314c6e$export$90648fb14f8c31aa = (update, opts)=>$fd9bbcd8ab314c6e$var$convertUpdateFormat(update, $fd9bbcd8ab314c6e$var$createObfuscator(opts), $fd9bbcd8ab314c6e$export$1c932452355c5571, $fd9bbcd8ab314c6e$export$30c99e08943e1c2);
/**
 * @param {Uint8Array} update
 */ const $fd9bbcd8ab314c6e$export$162408325d5832c = (update)=>$fd9bbcd8ab314c6e$var$convertUpdateFormat(update, $5VoPh.id, $fd9bbcd8ab314c6e$export$1aa46d9818b5d1ec, $fd9bbcd8ab314c6e$export$30c99e08943e1c2);
/**
 * @param {Uint8Array} update
 */ const $fd9bbcd8ab314c6e$export$afffbdeed14adbd = (update)=>$fd9bbcd8ab314c6e$var$convertUpdateFormat(update, $5VoPh.id, $fd9bbcd8ab314c6e$export$1c932452355c5571, $fd9bbcd8ab314c6e$export$99171b804d9c5b54);
const $fd9bbcd8ab314c6e$var$errorComputeChanges = "You must not compute changes after the event-handler fired.";
/**
 * @template {AbstractType<any>} T
 * YEvent describes the changes on a YType.
 */ class $fd9bbcd8ab314c6e$export$80fac438977fb51c {
    /**
   * @param {T} target The changed type.
   * @param {Transaction} transaction
   */ constructor(target, transaction){
        /**
     * The type on which this event was created on.
     * @type {T}
     */ this.target = target;
        /**
     * The current target on which the observe callback is called.
     * @type {AbstractType<any>}
     */ this.currentTarget = target;
        /**
     * The transaction that triggered this event.
     * @type {Transaction}
     */ this.transaction = transaction;
        /**
     * @type {Object|null}
     */ this._changes = null;
        /**
     * @type {null | Map<string, { action: 'add' | 'update' | 'delete', oldValue: any, newValue: any }>}
     */ this._keys = null;
        /**
     * @type {null | Array<{ insert?: string | Array<any> | object | AbstractType<any>, retain?: number, delete?: number, attributes?: Object<string, any> }>}
     */ this._delta = null;
        /**
     * @type {Array<string|number>|null}
     */ this._path = null;
    }
    /**
   * Computes the path from `y` to the changed type.
   *
   * @todo v14 should standardize on path: Array<{parent, index}> because that is easier to work with.
   *
   * The following property holds:
   * @example
   *   let type = y
   *   event.path.forEach(dir => {
   *     type = type.get(dir)
   *   })
   *   type === event.target // => true
   */ get path() {
        return this._path || (this._path = $fd9bbcd8ab314c6e$var$getPathTo(this.currentTarget, this.target));
    }
    /**
   * Check if a struct is deleted by this event.
   *
   * In contrast to change.deleted, this method also returns true if the struct was added and then deleted.
   *
   * @param {AbstractStruct} struct
   * @return {boolean}
   */ deletes(struct) {
        return $fd9bbcd8ab314c6e$export$dcb04af092e44fde(this.transaction.deleteSet, struct.id);
    }
    /**
   * @type {Map<string, { action: 'add' | 'update' | 'delete', oldValue: any, newValue: any }>}
   */ get keys() {
        if (this._keys === null) {
            if (this.transaction.doc._transactionCleanups.length === 0) throw $lqCPr.create($fd9bbcd8ab314c6e$var$errorComputeChanges);
            const keys = new Map();
            const target = this.target;
            const changed = /** @type Set<string|null> */ this.transaction.changed.get(target);
            changed.forEach((key)=>{
                if (key !== null) {
                    const item = /** @type {Item} */ target._map.get(key);
                    /**
           * @type {'delete' | 'add' | 'update'}
           */ let action;
                    let oldValue;
                    if (this.adds(item)) {
                        let prev = item.left;
                        while(prev !== null && this.adds(prev))prev = prev.left;
                        if (this.deletes(item)) {
                            if (prev !== null && this.deletes(prev)) {
                                action = "delete";
                                oldValue = $8aHnL.last(prev.content.getContent());
                            } else return;
                        } else if (prev !== null && this.deletes(prev)) {
                            action = "update";
                            oldValue = $8aHnL.last(prev.content.getContent());
                        } else {
                            action = "add";
                            oldValue = undefined;
                        }
                    } else {
                        if (this.deletes(item)) {
                            action = "delete";
                            oldValue = $8aHnL.last(/** @type {Item} */ item.content.getContent());
                        } else return; // nop
                    }
                    keys.set(key, {
                        action: action,
                        oldValue: oldValue
                    });
                }
            });
            this._keys = keys;
        }
        return this._keys;
    }
    /**
   * This is a computed property. Note that this can only be safely computed during the
   * event call. Computing this property after other changes happened might result in
   * unexpected behavior (incorrect computation of deltas). A safe way to collect changes
   * is to store the `changes` or the `delta` object. Avoid storing the `transaction` object.
   *
   * @type {Array<{insert?: string | Array<any> | object | AbstractType<any>, retain?: number, delete?: number, attributes?: Object<string, any>}>}
   */ get delta() {
        return this.changes.delta;
    }
    /**
   * Check if a struct is added by this event.
   *
   * In contrast to change.deleted, this method also returns true if the struct was added and then deleted.
   *
   * @param {AbstractStruct} struct
   * @return {boolean}
   */ adds(struct) {
        return struct.id.clock >= (this.transaction.beforeState.get(struct.id.client) || 0);
    }
    /**
   * This is a computed property. Note that this can only be safely computed during the
   * event call. Computing this property after other changes happened might result in
   * unexpected behavior (incorrect computation of deltas). A safe way to collect changes
   * is to store the `changes` or the `delta` object. Avoid storing the `transaction` object.
   *
   * @type {{added:Set<Item>,deleted:Set<Item>,keys:Map<string,{action:'add'|'update'|'delete',oldValue:any}>,delta:Array<{insert?:Array<any>|string, delete?:number, retain?:number}>}}
   */ get changes() {
        let changes = this._changes;
        if (changes === null) {
            if (this.transaction.doc._transactionCleanups.length === 0) throw $lqCPr.create($fd9bbcd8ab314c6e$var$errorComputeChanges);
            const target = this.target;
            const added = $eq375.create();
            const deleted = $eq375.create();
            /**
       * @type {Array<{insert:Array<any>}|{delete:number}|{retain:number}>}
       */ const delta = [];
            changes = {
                added: added,
                deleted: deleted,
                delta: delta,
                keys: this.keys
            };
            const changed = /** @type Set<string|null> */ this.transaction.changed.get(target);
            if (changed.has(null)) {
                /**
         * @type {any}
         */ let lastOp = null;
                const packOp = ()=>{
                    if (lastOp) delta.push(lastOp);
                };
                for(let item = target._start; item !== null; item = item.right){
                    if (item.deleted) {
                        if (this.deletes(item) && !this.adds(item)) {
                            if (lastOp === null || lastOp.delete === undefined) {
                                packOp();
                                lastOp = {
                                    delete: 0
                                };
                            }
                            lastOp.delete += item.length;
                            deleted.add(item);
                        } // else nop
                    } else if (this.adds(item)) {
                        if (lastOp === null || lastOp.insert === undefined) {
                            packOp();
                            lastOp = {
                                insert: []
                            };
                        }
                        lastOp.insert = lastOp.insert.concat(item.content.getContent());
                        added.add(item);
                    } else {
                        if (lastOp === null || lastOp.retain === undefined) {
                            packOp();
                            lastOp = {
                                retain: 0
                            };
                        }
                        lastOp.retain += item.length;
                    }
                }
                if (lastOp !== null && lastOp.retain === undefined) packOp();
            }
            this._changes = changes;
        }
        return /** @type {any} */ changes;
    }
}
/**
 * Compute the path from this type to the specified target.
 *
 * @example
 *   // `child` should be accessible via `type.get(path[0]).get(path[1])..`
 *   const path = type.getPathTo(child)
 *   // assuming `type instanceof YArray`
 *   console.log(path) // might look like => [2, 'key1']
 *   child === type.get(path[0]).get(path[1])
 *
 * @param {AbstractType<any>} parent
 * @param {AbstractType<any>} child target
 * @return {Array<string|number>} Path to the target
 *
 * @private
 * @function
 */ const $fd9bbcd8ab314c6e$var$getPathTo = (parent, child)=>{
    const path = [];
    while(child._item !== null && child !== parent){
        if (child._item.parentSub !== null) // parent is map-ish
        path.unshift(child._item.parentSub);
        else {
            // parent is array-ish
            let i = 0;
            let c = /** @type {AbstractType<any>} */ child._item.parent._start;
            while(c !== child._item && c !== null){
                if (!c.deleted && c.countable) i += c.length;
                c = c.right;
            }
            path.unshift(i);
        }
        child = /** @type {AbstractType<any>} */ child._item.parent;
    }
    return path;
};
/**
 * https://docs.yjs.dev/getting-started/working-with-shared-types#caveats
 */ const $fd9bbcd8ab314c6e$var$warnPrematureAccess = ()=>{
    $6nwkt.warn("Invalid access: Add Yjs type to a document before reading data.");
};
const $fd9bbcd8ab314c6e$var$maxSearchMarker = 80;
/**
 * A unique timestamp that identifies each marker.
 *
 * Time is relative,.. this is more like an ever-increasing clock.
 *
 * @type {number}
 */ let $fd9bbcd8ab314c6e$var$globalSearchMarkerTimestamp = 0;
class $fd9bbcd8ab314c6e$var$ArraySearchMarker {
    /**
   * @param {Item} p
   * @param {number} index
   */ constructor(p, index){
        p.marker = true;
        this.p = p;
        this.index = index;
        this.timestamp = $fd9bbcd8ab314c6e$var$globalSearchMarkerTimestamp++;
    }
}
/**
 * @param {ArraySearchMarker} marker
 */ const $fd9bbcd8ab314c6e$var$refreshMarkerTimestamp = (marker)=>{
    marker.timestamp = $fd9bbcd8ab314c6e$var$globalSearchMarkerTimestamp++;
};
/**
 * This is rather complex so this function is the only thing that should overwrite a marker
 *
 * @param {ArraySearchMarker} marker
 * @param {Item} p
 * @param {number} index
 */ const $fd9bbcd8ab314c6e$var$overwriteMarker = (marker, p, index)=>{
    marker.p.marker = false;
    marker.p = p;
    p.marker = true;
    marker.index = index;
    marker.timestamp = $fd9bbcd8ab314c6e$var$globalSearchMarkerTimestamp++;
};
/**
 * @param {Array<ArraySearchMarker>} searchMarker
 * @param {Item} p
 * @param {number} index
 */ const $fd9bbcd8ab314c6e$var$markPosition = (searchMarker, p, index)=>{
    if (searchMarker.length >= $fd9bbcd8ab314c6e$var$maxSearchMarker) {
        // override oldest marker (we don't want to create more objects)
        const marker = searchMarker.reduce((a, b)=>a.timestamp < b.timestamp ? a : b);
        $fd9bbcd8ab314c6e$var$overwriteMarker(marker, p, index);
        return marker;
    } else {
        // create new marker
        const pm = new $fd9bbcd8ab314c6e$var$ArraySearchMarker(p, index);
        searchMarker.push(pm);
        return pm;
    }
};
/**
 * Search marker help us to find positions in the associative array faster.
 *
 * They speed up the process of finding a position without much bookkeeping.
 *
 * A maximum of `maxSearchMarker` objects are created.
 *
 * This function always returns a refreshed marker (updated timestamp)
 *
 * @param {AbstractType<any>} yarray
 * @param {number} index
 */ const $fd9bbcd8ab314c6e$var$findMarker = (yarray, index)=>{
    if (yarray._start === null || index === 0 || yarray._searchMarker === null) return null;
    const marker = yarray._searchMarker.length === 0 ? null : yarray._searchMarker.reduce((a, b)=>$6O4IB.abs(index - a.index) < $6O4IB.abs(index - b.index) ? a : b);
    let p = yarray._start;
    let pindex = 0;
    if (marker !== null) {
        p = marker.p;
        pindex = marker.index;
        $fd9bbcd8ab314c6e$var$refreshMarkerTimestamp(marker); // we used it, we might need to use it again
    }
    // iterate to right if possible
    while(p.right !== null && pindex < index){
        if (!p.deleted && p.countable) {
            if (index < pindex + p.length) break;
            pindex += p.length;
        }
        p = p.right;
    }
    // iterate to left if necessary (might be that pindex > index)
    while(p.left !== null && pindex > index){
        p = p.left;
        if (!p.deleted && p.countable) pindex -= p.length;
    }
    // we want to make sure that p can't be merged with left, because that would screw up everything
    // in that cas just return what we have (it is most likely the best marker anyway)
    // iterate to left until p can't be merged with left
    while(p.left !== null && p.left.id.client === p.id.client && p.left.id.clock + p.left.length === p.id.clock){
        p = p.left;
        if (!p.deleted && p.countable) pindex -= p.length;
    }
    // @todo remove!
    // assure position
    // {
    //   let start = yarray._start
    //   let pos = 0
    //   while (start !== p) {
    //     if (!start.deleted && start.countable) {
    //       pos += start.length
    //     }
    //     start = /** @type {Item} */ (start.right)
    //   }
    //   if (pos !== pindex) {
    //     debugger
    //     throw new Error('Gotcha position fail!')
    //   }
    // }
    // if (marker) {
    //   if (window.lengthes == null) {
    //     window.lengthes = []
    //     window.getLengthes = () => window.lengthes.sort((a, b) => a - b)
    //   }
    //   window.lengthes.push(marker.index - pindex)
    //   console.log('distance', marker.index - pindex, 'len', p && p.parent.length)
    // }
    if (marker !== null && $6O4IB.abs(marker.index - pindex) < /** @type {YText|YArray<any>} */ p.parent.length / $fd9bbcd8ab314c6e$var$maxSearchMarker) {
        // adjust existing marker
        $fd9bbcd8ab314c6e$var$overwriteMarker(marker, p, pindex);
        return marker;
    } else // create new marker
    return $fd9bbcd8ab314c6e$var$markPosition(yarray._searchMarker, p, pindex);
};
/**
 * Update markers when a change happened.
 *
 * This should be called before doing a deletion!
 *
 * @param {Array<ArraySearchMarker>} searchMarker
 * @param {number} index
 * @param {number} len If insertion, len is positive. If deletion, len is negative.
 */ const $fd9bbcd8ab314c6e$var$updateMarkerChanges = (searchMarker, index, len)=>{
    for(let i = searchMarker.length - 1; i >= 0; i--){
        const m = searchMarker[i];
        if (len > 0) {
            /**
       * @type {Item|null}
       */ let p = m.p;
            p.marker = false;
            // Ideally we just want to do a simple position comparison, but this will only work if
            // search markers don't point to deleted items for formats.
            // Iterate marker to prev undeleted countable position so we know what to do when updating a position
            while(p && (p.deleted || !p.countable)){
                p = p.left;
                if (p && !p.deleted && p.countable) // adjust position. the loop should break now
                m.index -= p.length;
            }
            if (p === null || p.marker === true) {
                // remove search marker if updated position is null or if position is already marked
                searchMarker.splice(i, 1);
                continue;
            }
            m.p = p;
            p.marker = true;
        }
        if (index < m.index || len > 0 && index === m.index) m.index = $6O4IB.max(index, m.index + len);
    }
};
/**
 * Accumulate all (list) children of a type and return them as an Array.
 *
 * @param {AbstractType<any>} t
 * @return {Array<Item>}
 */ const $fd9bbcd8ab314c6e$export$5418d693f13991b3 = (t)=>{
    t.doc ?? $fd9bbcd8ab314c6e$var$warnPrematureAccess();
    let s = t._start;
    const arr = [];
    while(s){
        arr.push(s);
        s = s.right;
    }
    return arr;
};
/**
 * Call event listeners with an event. This will also add an event to all
 * parents (for `.observeDeep` handlers).
 *
 * @template EventType
 * @param {AbstractType<EventType>} type
 * @param {Transaction} transaction
 * @param {EventType} event
 */ const $fd9bbcd8ab314c6e$var$callTypeObservers = (type, transaction, event)=>{
    const changedType = type;
    const changedParentTypes = transaction.changedParentTypes;
    while(true){
        // @ts-ignore
        $2U6oo.setIfUndefined(changedParentTypes, type, ()=>[]).push(event);
        if (type._item === null) break;
        type = /** @type {AbstractType<any>} */ type._item.parent;
    }
    $fd9bbcd8ab314c6e$var$callEventHandlerListeners(changedType._eH, event, transaction);
};
/**
 * @template EventType
 * Abstract Yjs Type class
 */ class $fd9bbcd8ab314c6e$export$c265dc8338484497 {
    constructor(){
        /**
     * @type {Item|null}
     */ this._item = null;
        /**
     * @type {Map<string,Item>}
     */ this._map = new Map();
        /**
     * @type {Item|null}
     */ this._start = null;
        /**
     * @type {Doc|null}
     */ this.doc = null;
        this._length = 0;
        /**
     * Event handlers
     * @type {EventHandler<EventType,Transaction>}
     */ this._eH = $fd9bbcd8ab314c6e$var$createEventHandler();
        /**
     * Deep event handlers
     * @type {EventHandler<Array<YEvent<any>>,Transaction>}
     */ this._dEH = $fd9bbcd8ab314c6e$var$createEventHandler();
        /**
     * @type {null | Array<ArraySearchMarker>}
     */ this._searchMarker = null;
    }
    /**
   * @return {AbstractType<any>|null}
   */ get parent() {
        return this._item ? /** @type {AbstractType<any>} */ this._item.parent : null;
    }
    /**
   * Integrate this type into the Yjs instance.
   *
   * * Save this struct in the os
   * * This type is sent to other client
   * * Observer functions are fired
   *
   * @param {Doc} y The Yjs instance
   * @param {Item|null} item
   */ _integrate(y, item) {
        this.doc = y;
        this._item = item;
    }
    /**
   * @return {AbstractType<EventType>}
   */ _copy() {
        throw $lqCPr.methodUnimplemented();
    }
    /**
   * Makes a copy of this data type that can be included somewhere else.
   *
   * Note that the content is only readable _after_ it has been included somewhere in the Ydoc.
   *
   * @return {AbstractType<EventType>}
   */ clone() {
        throw $lqCPr.methodUnimplemented();
    }
    /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} _encoder
   */ _write(_encoder) {}
    /**
   * The first non-deleted item
   */ get _first() {
        let n = this._start;
        while(n !== null && n.deleted)n = n.right;
        return n;
    }
    /**
   * Creates YEvent and calls all type observers.
   * Must be implemented by each type.
   *
   * @param {Transaction} transaction
   * @param {Set<null|string>} _parentSubs Keys changed on this type. `null` if list was modified.
   */ _callObserver(transaction, _parentSubs) {
        if (!transaction.local && this._searchMarker) this._searchMarker.length = 0;
    }
    /**
   * Observe all events that are created on this type.
   *
   * @param {function(EventType, Transaction):void} f Observer function
   */ observe(f) {
        $fd9bbcd8ab314c6e$var$addEventHandlerListener(this._eH, f);
    }
    /**
   * Observe all events that are created by this type and its children.
   *
   * @param {function(Array<YEvent<any>>,Transaction):void} f Observer function
   */ observeDeep(f) {
        $fd9bbcd8ab314c6e$var$addEventHandlerListener(this._dEH, f);
    }
    /**
   * Unregister an observer function.
   *
   * @param {function(EventType,Transaction):void} f Observer function
   */ unobserve(f) {
        $fd9bbcd8ab314c6e$var$removeEventHandlerListener(this._eH, f);
    }
    /**
   * Unregister an observer function.
   *
   * @param {function(Array<YEvent<any>>,Transaction):void} f Observer function
   */ unobserveDeep(f) {
        $fd9bbcd8ab314c6e$var$removeEventHandlerListener(this._dEH, f);
    }
    /**
   * @abstract
   * @return {any}
   */ toJSON() {}
}
/**
 * @param {AbstractType<any>} type
 * @param {number} start
 * @param {number} end
 * @return {Array<any>}
 *
 * @private
 * @function
 */ const $fd9bbcd8ab314c6e$var$typeListSlice = (type, start, end)=>{
    type.doc ?? $fd9bbcd8ab314c6e$var$warnPrematureAccess();
    if (start < 0) start = type._length + start;
    if (end < 0) end = type._length + end;
    let len = end - start;
    const cs = [];
    let n = type._start;
    while(n !== null && len > 0){
        if (n.countable && !n.deleted) {
            const c = n.content.getContent();
            if (c.length <= start) start -= c.length;
            else {
                for(let i = start; i < c.length && len > 0; i++){
                    cs.push(c[i]);
                    len--;
                }
                start = 0;
            }
        }
        n = n.right;
    }
    return cs;
};
/**
 * @param {AbstractType<any>} type
 * @return {Array<any>}
 *
 * @private
 * @function
 */ const $fd9bbcd8ab314c6e$var$typeListToArray = (type)=>{
    type.doc ?? $fd9bbcd8ab314c6e$var$warnPrematureAccess();
    const cs = [];
    let n = type._start;
    while(n !== null){
        if (n.countable && !n.deleted) {
            const c = n.content.getContent();
            for(let i = 0; i < c.length; i++)cs.push(c[i]);
        }
        n = n.right;
    }
    return cs;
};
/**
 * @param {AbstractType<any>} type
 * @param {Snapshot} snapshot
 * @return {Array<any>}
 *
 * @private
 * @function
 */ const $fd9bbcd8ab314c6e$export$9de42b6dda4c7e48 = (type, snapshot)=>{
    const cs = [];
    let n = type._start;
    while(n !== null){
        if (n.countable && $fd9bbcd8ab314c6e$var$isVisible(n, snapshot)) {
            const c = n.content.getContent();
            for(let i = 0; i < c.length; i++)cs.push(c[i]);
        }
        n = n.right;
    }
    return cs;
};
/**
 * Executes a provided function on once on every element of this YArray.
 *
 * @param {AbstractType<any>} type
 * @param {function(any,number,any):void} f A function to execute on every element of this YArray.
 *
 * @private
 * @function
 */ const $fd9bbcd8ab314c6e$var$typeListForEach = (type, f)=>{
    let index = 0;
    let n = type._start;
    type.doc ?? $fd9bbcd8ab314c6e$var$warnPrematureAccess();
    while(n !== null){
        if (n.countable && !n.deleted) {
            const c = n.content.getContent();
            for(let i = 0; i < c.length; i++)f(c[i], index++, type);
        }
        n = n.right;
    }
};
/**
 * @template C,R
 * @param {AbstractType<any>} type
 * @param {function(C,number,AbstractType<any>):R} f
 * @return {Array<R>}
 *
 * @private
 * @function
 */ const $fd9bbcd8ab314c6e$var$typeListMap = (type, f)=>{
    /**
   * @type {Array<any>}
   */ const result = [];
    $fd9bbcd8ab314c6e$var$typeListForEach(type, (c, i)=>{
        result.push(f(c, i, type));
    });
    return result;
};
/**
 * @param {AbstractType<any>} type
 * @return {IterableIterator<any>}
 *
 * @private
 * @function
 */ const $fd9bbcd8ab314c6e$var$typeListCreateIterator = (type)=>{
    let n = type._start;
    /**
   * @type {Array<any>|null}
   */ let currentContent = null;
    let currentContentIndex = 0;
    return {
        [Symbol.iterator] () {
            return this;
        },
        next: ()=>{
            // find some content
            if (currentContent === null) {
                while(n !== null && n.deleted)n = n.right;
                // check if we reached the end, no need to check currentContent, because it does not exist
                if (n === null) return {
                    done: true,
                    value: undefined
                };
                // we found n, so we can set currentContent
                currentContent = n.content.getContent();
                currentContentIndex = 0;
                n = n.right; // we used the content of n, now iterate to next
            }
            const value = currentContent[currentContentIndex++];
            // check if we need to empty currentContent
            if (currentContent.length <= currentContentIndex) currentContent = null;
            return {
                done: false,
                value: value
            };
        }
    };
};
/**
 * @param {AbstractType<any>} type
 * @param {number} index
 * @return {any}
 *
 * @private
 * @function
 */ const $fd9bbcd8ab314c6e$var$typeListGet = (type, index)=>{
    type.doc ?? $fd9bbcd8ab314c6e$var$warnPrematureAccess();
    const marker = $fd9bbcd8ab314c6e$var$findMarker(type, index);
    let n = type._start;
    if (marker !== null) {
        n = marker.p;
        index -= marker.index;
    }
    for(; n !== null; n = n.right)if (!n.deleted && n.countable) {
        if (index < n.length) return n.content.getContent()[index];
        index -= n.length;
    }
};
/**
 * @param {Transaction} transaction
 * @param {AbstractType<any>} parent
 * @param {Item?} referenceItem
 * @param {Array<Object<string,any>|Array<any>|boolean|number|null|string|Uint8Array>} content
 *
 * @private
 * @function
 */ const $fd9bbcd8ab314c6e$var$typeListInsertGenericsAfter = (transaction, parent, referenceItem, content)=>{
    let left = referenceItem;
    const doc = transaction.doc;
    const ownClientId = doc.clientID;
    const store = doc.store;
    const right = referenceItem === null ? parent._start : referenceItem.right;
    /**
   * @type {Array<Object|Array<any>|number|null>}
   */ let jsonContent = [];
    const packJsonContent = ()=>{
        if (jsonContent.length > 0) {
            left = new $fd9bbcd8ab314c6e$export$6d08773d2e66f8f2($fd9bbcd8ab314c6e$export$6c7d4e6171d008d0(ownClientId, $fd9bbcd8ab314c6e$export$50fdfeece43146fd(store, ownClientId)), left, left && left.lastId, right, right && right.id, parent, null, new $fd9bbcd8ab314c6e$export$1d788b93bbb631a0(jsonContent));
            left.integrate(transaction, 0);
            jsonContent = [];
        }
    };
    content.forEach((c)=>{
        if (c === null) jsonContent.push(c);
        else switch(c.constructor){
            case Number:
            case Object:
            case Boolean:
            case Array:
            case String:
                jsonContent.push(c);
                break;
            default:
                packJsonContent();
                switch(c.constructor){
                    case Uint8Array:
                    case ArrayBuffer:
                        left = new $fd9bbcd8ab314c6e$export$6d08773d2e66f8f2($fd9bbcd8ab314c6e$export$6c7d4e6171d008d0(ownClientId, $fd9bbcd8ab314c6e$export$50fdfeece43146fd(store, ownClientId)), left, left && left.lastId, right, right && right.id, parent, null, new $fd9bbcd8ab314c6e$export$e8d530cdf62d1cbd(new Uint8Array(/** @type {Uint8Array} */ c)));
                        left.integrate(transaction, 0);
                        break;
                    case $fd9bbcd8ab314c6e$export$bceacc74c2212615:
                        left = new $fd9bbcd8ab314c6e$export$6d08773d2e66f8f2($fd9bbcd8ab314c6e$export$6c7d4e6171d008d0(ownClientId, $fd9bbcd8ab314c6e$export$50fdfeece43146fd(store, ownClientId)), left, left && left.lastId, right, right && right.id, parent, null, new $fd9bbcd8ab314c6e$export$b564c0e69572c0e(/** @type {Doc} */ c));
                        left.integrate(transaction, 0);
                        break;
                    default:
                        if (c instanceof $fd9bbcd8ab314c6e$export$c265dc8338484497) {
                            left = new $fd9bbcd8ab314c6e$export$6d08773d2e66f8f2($fd9bbcd8ab314c6e$export$6c7d4e6171d008d0(ownClientId, $fd9bbcd8ab314c6e$export$50fdfeece43146fd(store, ownClientId)), left, left && left.lastId, right, right && right.id, parent, null, new $fd9bbcd8ab314c6e$export$e2e108cbe2e4f865(c));
                            left.integrate(transaction, 0);
                        } else throw new Error("Unexpected content type in insert operation");
                }
        }
    });
    packJsonContent();
};
const $fd9bbcd8ab314c6e$var$lengthExceeded = ()=>$lqCPr.create("Length exceeded!");
/**
 * @param {Transaction} transaction
 * @param {AbstractType<any>} parent
 * @param {number} index
 * @param {Array<Object<string,any>|Array<any>|number|null|string|Uint8Array>} content
 *
 * @private
 * @function
 */ const $fd9bbcd8ab314c6e$var$typeListInsertGenerics = (transaction, parent, index, content)=>{
    if (index > parent._length) throw $fd9bbcd8ab314c6e$var$lengthExceeded();
    if (index === 0) {
        if (parent._searchMarker) $fd9bbcd8ab314c6e$var$updateMarkerChanges(parent._searchMarker, index, content.length);
        return $fd9bbcd8ab314c6e$var$typeListInsertGenericsAfter(transaction, parent, null, content);
    }
    const startIndex = index;
    const marker = $fd9bbcd8ab314c6e$var$findMarker(parent, index);
    let n = parent._start;
    if (marker !== null) {
        n = marker.p;
        index -= marker.index;
        // we need to iterate one to the left so that the algorithm works
        if (index === 0) {
            // @todo refactor this as it actually doesn't consider formats
            n = n.prev; // important! get the left undeleted item so that we can actually decrease index
            index += n && n.countable && !n.deleted ? n.length : 0;
        }
    }
    for(; n !== null; n = n.right)if (!n.deleted && n.countable) {
        if (index <= n.length) {
            if (index < n.length) // insert in-between
            $fd9bbcd8ab314c6e$var$getItemCleanStart(transaction, $fd9bbcd8ab314c6e$export$6c7d4e6171d008d0(n.id.client, n.id.clock + index));
            break;
        }
        index -= n.length;
    }
    if (parent._searchMarker) $fd9bbcd8ab314c6e$var$updateMarkerChanges(parent._searchMarker, startIndex, content.length);
    return $fd9bbcd8ab314c6e$var$typeListInsertGenericsAfter(transaction, parent, n, content);
};
/**
 * Pushing content is special as we generally want to push after the last item. So we don't have to update
 * the serach marker.
 *
 * @param {Transaction} transaction
 * @param {AbstractType<any>} parent
 * @param {Array<Object<string,any>|Array<any>|number|null|string|Uint8Array>} content
 *
 * @private
 * @function
 */ const $fd9bbcd8ab314c6e$var$typeListPushGenerics = (transaction, parent, content)=>{
    // Use the marker with the highest index and iterate to the right.
    const marker = (parent._searchMarker || []).reduce((maxMarker, currMarker)=>currMarker.index > maxMarker.index ? currMarker : maxMarker, {
        index: 0,
        p: parent._start
    });
    let n = marker.p;
    if (n) while(n.right)n = n.right;
    return $fd9bbcd8ab314c6e$var$typeListInsertGenericsAfter(transaction, parent, n, content);
};
/**
 * @param {Transaction} transaction
 * @param {AbstractType<any>} parent
 * @param {number} index
 * @param {number} length
 *
 * @private
 * @function
 */ const $fd9bbcd8ab314c6e$var$typeListDelete = (transaction, parent, index, length)=>{
    if (length === 0) return;
    const startIndex = index;
    const startLength = length;
    const marker = $fd9bbcd8ab314c6e$var$findMarker(parent, index);
    let n = parent._start;
    if (marker !== null) {
        n = marker.p;
        index -= marker.index;
    }
    // compute the first item to be deleted
    for(; n !== null && index > 0; n = n.right)if (!n.deleted && n.countable) {
        if (index < n.length) $fd9bbcd8ab314c6e$var$getItemCleanStart(transaction, $fd9bbcd8ab314c6e$export$6c7d4e6171d008d0(n.id.client, n.id.clock + index));
        index -= n.length;
    }
    // delete all items until done
    while(length > 0 && n !== null){
        if (!n.deleted) {
            if (length < n.length) $fd9bbcd8ab314c6e$var$getItemCleanStart(transaction, $fd9bbcd8ab314c6e$export$6c7d4e6171d008d0(n.id.client, n.id.clock + length));
            n.delete(transaction);
            length -= n.length;
        }
        n = n.right;
    }
    if (length > 0) throw $fd9bbcd8ab314c6e$var$lengthExceeded();
    if (parent._searchMarker) $fd9bbcd8ab314c6e$var$updateMarkerChanges(parent._searchMarker, startIndex, -startLength + length /* in case we remove the above exception */ );
};
/**
 * @param {Transaction} transaction
 * @param {AbstractType<any>} parent
 * @param {string} key
 *
 * @private
 * @function
 */ const $fd9bbcd8ab314c6e$var$typeMapDelete = (transaction, parent, key)=>{
    const c = parent._map.get(key);
    if (c !== undefined) c.delete(transaction);
};
/**
 * @param {Transaction} transaction
 * @param {AbstractType<any>} parent
 * @param {string} key
 * @param {Object|number|null|Array<any>|string|Uint8Array|AbstractType<any>} value
 *
 * @private
 * @function
 */ const $fd9bbcd8ab314c6e$var$typeMapSet = (transaction, parent, key, value)=>{
    const left = parent._map.get(key) || null;
    const doc = transaction.doc;
    const ownClientId = doc.clientID;
    let content;
    if (value == null) content = new $fd9bbcd8ab314c6e$export$1d788b93bbb631a0([
        value
    ]);
    else switch(value.constructor){
        case Number:
        case Object:
        case Boolean:
        case Array:
        case String:
            content = new $fd9bbcd8ab314c6e$export$1d788b93bbb631a0([
                value
            ]);
            break;
        case Uint8Array:
            content = new $fd9bbcd8ab314c6e$export$e8d530cdf62d1cbd(/** @type {Uint8Array} */ value);
            break;
        case $fd9bbcd8ab314c6e$export$bceacc74c2212615:
            content = new $fd9bbcd8ab314c6e$export$b564c0e69572c0e(/** @type {Doc} */ value);
            break;
        default:
            if (value instanceof $fd9bbcd8ab314c6e$export$c265dc8338484497) content = new $fd9bbcd8ab314c6e$export$e2e108cbe2e4f865(value);
            else throw new Error("Unexpected content type");
    }
    new $fd9bbcd8ab314c6e$export$6d08773d2e66f8f2($fd9bbcd8ab314c6e$export$6c7d4e6171d008d0(ownClientId, $fd9bbcd8ab314c6e$export$50fdfeece43146fd(doc.store, ownClientId)), left, left && left.lastId, null, null, parent, key, content).integrate(transaction, 0);
};
/**
 * @param {AbstractType<any>} parent
 * @param {string} key
 * @return {Object<string,any>|number|null|Array<any>|string|Uint8Array|AbstractType<any>|undefined}
 *
 * @private
 * @function
 */ const $fd9bbcd8ab314c6e$var$typeMapGet = (parent, key)=>{
    parent.doc ?? $fd9bbcd8ab314c6e$var$warnPrematureAccess();
    const val = parent._map.get(key);
    return val !== undefined && !val.deleted ? val.content.getContent()[val.length - 1] : undefined;
};
/**
 * @param {AbstractType<any>} parent
 * @return {Object<string,Object<string,any>|number|null|Array<any>|string|Uint8Array|AbstractType<any>|undefined>}
 *
 * @private
 * @function
 */ const $fd9bbcd8ab314c6e$var$typeMapGetAll = (parent)=>{
    /**
   * @type {Object<string,any>}
   */ const res = {};
    parent.doc ?? $fd9bbcd8ab314c6e$var$warnPrematureAccess();
    parent._map.forEach((value, key)=>{
        if (!value.deleted) res[key] = value.content.getContent()[value.length - 1];
    });
    return res;
};
/**
 * @param {AbstractType<any>} parent
 * @param {string} key
 * @return {boolean}
 *
 * @private
 * @function
 */ const $fd9bbcd8ab314c6e$var$typeMapHas = (parent, key)=>{
    parent.doc ?? $fd9bbcd8ab314c6e$var$warnPrematureAccess();
    const val = parent._map.get(key);
    return val !== undefined && !val.deleted;
};
/**
 * @param {AbstractType<any>} parent
 * @param {string} key
 * @param {Snapshot} snapshot
 * @return {Object<string,any>|number|null|Array<any>|string|Uint8Array|AbstractType<any>|undefined}
 *
 * @private
 * @function
 */ const $fd9bbcd8ab314c6e$export$a7c089bf6c22a1db = (parent, key, snapshot)=>{
    let v = parent._map.get(key) || null;
    while(v !== null && (!snapshot.sv.has(v.id.client) || v.id.clock >= (snapshot.sv.get(v.id.client) || 0)))v = v.left;
    return v !== null && $fd9bbcd8ab314c6e$var$isVisible(v, snapshot) ? v.content.getContent()[v.length - 1] : undefined;
};
/**
 * @param {AbstractType<any>} parent
 * @param {Snapshot} snapshot
 * @return {Object<string,Object<string,any>|number|null|Array<any>|string|Uint8Array|AbstractType<any>|undefined>}
 *
 * @private
 * @function
 */ const $fd9bbcd8ab314c6e$export$7769bdedaef2c91b = (parent, snapshot)=>{
    /**
   * @type {Object<string,any>}
   */ const res = {};
    parent._map.forEach((value, key)=>{
        /**
     * @type {Item|null}
     */ let v = value;
        while(v !== null && (!snapshot.sv.has(v.id.client) || v.id.clock >= (snapshot.sv.get(v.id.client) || 0)))v = v.left;
        if (v !== null && $fd9bbcd8ab314c6e$var$isVisible(v, snapshot)) res[key] = v.content.getContent()[v.length - 1];
    });
    return res;
};
/**
 * @param {AbstractType<any> & { _map: Map<string, Item> }} type
 * @return {IterableIterator<Array<any>>}
 *
 * @private
 * @function
 */ const $fd9bbcd8ab314c6e$var$createMapIterator = (type)=>{
    type.doc ?? $fd9bbcd8ab314c6e$var$warnPrematureAccess();
    return $59LwD.iteratorFilter(type._map.entries(), /** @param {any} entry */ (entry)=>!entry[1].deleted);
};
/**
 * @module YArray
 */ /**
 * Event that describes the changes on a YArray
 * @template T
 * @extends YEvent<YArray<T>>
 */ class $fd9bbcd8ab314c6e$export$a095f7fee639264a extends $fd9bbcd8ab314c6e$export$80fac438977fb51c {
}
/**
 * A shared Array implementation.
 * @template T
 * @extends AbstractType<YArrayEvent<T>>
 * @implements {Iterable<T>}
 */ class $fd9bbcd8ab314c6e$export$c4be6576ca6fe4aa extends $fd9bbcd8ab314c6e$export$c265dc8338484497 {
    constructor(){
        super();
        /**
     * @type {Array<any>?}
     * @private
     */ this._prelimContent = [];
        /**
     * @type {Array<ArraySearchMarker>}
     */ this._searchMarker = [];
    }
    /**
   * Construct a new YArray containing the specified items.
   * @template {Object<string,any>|Array<any>|number|null|string|Uint8Array} T
   * @param {Array<T>} items
   * @return {YArray<T>}
   */ static from(items) {
        /**
     * @type {YArray<T>}
     */ const a = new $fd9bbcd8ab314c6e$export$c4be6576ca6fe4aa();
        a.push(items);
        return a;
    }
    /**
   * Integrate this type into the Yjs instance.
   *
   * * Save this struct in the os
   * * This type is sent to other client
   * * Observer functions are fired
   *
   * @param {Doc} y The Yjs instance
   * @param {Item} item
   */ _integrate(y, item) {
        super._integrate(y, item);
        this.insert(0, /** @type {Array<any>} */ this._prelimContent);
        this._prelimContent = null;
    }
    /**
   * @return {YArray<T>}
   */ _copy() {
        return new $fd9bbcd8ab314c6e$export$c4be6576ca6fe4aa();
    }
    /**
   * Makes a copy of this data type that can be included somewhere else.
   *
   * Note that the content is only readable _after_ it has been included somewhere in the Ydoc.
   *
   * @return {YArray<T>}
   */ clone() {
        /**
     * @type {YArray<T>}
     */ const arr = new $fd9bbcd8ab314c6e$export$c4be6576ca6fe4aa();
        arr.insert(0, this.toArray().map((el)=>el instanceof $fd9bbcd8ab314c6e$export$c265dc8338484497 ? /** @type {typeof el} */ el.clone() : el));
        return arr;
    }
    get length() {
        this.doc ?? $fd9bbcd8ab314c6e$var$warnPrematureAccess();
        return this._length;
    }
    /**
   * Creates YArrayEvent and calls observers.
   *
   * @param {Transaction} transaction
   * @param {Set<null|string>} parentSubs Keys changed on this type. `null` if list was modified.
   */ _callObserver(transaction, parentSubs) {
        super._callObserver(transaction, parentSubs);
        $fd9bbcd8ab314c6e$var$callTypeObservers(this, transaction, new $fd9bbcd8ab314c6e$export$a095f7fee639264a(this, transaction));
    }
    /**
   * Inserts new content at an index.
   *
   * Important: This function expects an array of content. Not just a content
   * object. The reason for this "weirdness" is that inserting several elements
   * is very efficient when it is done as a single operation.
   *
   * @example
   *  // Insert character 'a' at position 0
   *  yarray.insert(0, ['a'])
   *  // Insert numbers 1, 2 at position 1
   *  yarray.insert(1, [1, 2])
   *
   * @param {number} index The index to insert content at.
   * @param {Array<T>} content The array of content
   */ insert(index, content) {
        if (this.doc !== null) $fd9bbcd8ab314c6e$export$dac1bad6146b2469(this.doc, (transaction)=>{
            $fd9bbcd8ab314c6e$var$typeListInsertGenerics(transaction, this, index, /** @type {any} */ content);
        });
        else /** @type {Array<any>} */ this._prelimContent.splice(index, 0, ...content);
    }
    /**
   * Appends content to this YArray.
   *
   * @param {Array<T>} content Array of content to append.
   *
   * @todo Use the following implementation in all types.
   */ push(content) {
        if (this.doc !== null) $fd9bbcd8ab314c6e$export$dac1bad6146b2469(this.doc, (transaction)=>{
            $fd9bbcd8ab314c6e$var$typeListPushGenerics(transaction, this, /** @type {any} */ content);
        });
        else /** @type {Array<any>} */ this._prelimContent.push(...content);
    }
    /**
   * Prepends content to this YArray.
   *
   * @param {Array<T>} content Array of content to prepend.
   */ unshift(content) {
        this.insert(0, content);
    }
    /**
   * Deletes elements starting from an index.
   *
   * @param {number} index Index at which to start deleting elements
   * @param {number} length The number of elements to remove. Defaults to 1.
   */ delete(index, length = 1) {
        if (this.doc !== null) $fd9bbcd8ab314c6e$export$dac1bad6146b2469(this.doc, (transaction)=>{
            $fd9bbcd8ab314c6e$var$typeListDelete(transaction, this, index, length);
        });
        else /** @type {Array<any>} */ this._prelimContent.splice(index, length);
    }
    /**
   * Returns the i-th element from a YArray.
   *
   * @param {number} index The index of the element to return from the YArray
   * @return {T}
   */ get(index) {
        return $fd9bbcd8ab314c6e$var$typeListGet(this, index);
    }
    /**
   * Transforms this YArray to a JavaScript Array.
   *
   * @return {Array<T>}
   */ toArray() {
        return $fd9bbcd8ab314c6e$var$typeListToArray(this);
    }
    /**
   * Returns a portion of this YArray into a JavaScript Array selected
   * from start to end (end not included).
   *
   * @param {number} [start]
   * @param {number} [end]
   * @return {Array<T>}
   */ slice(start = 0, end = this.length) {
        return $fd9bbcd8ab314c6e$var$typeListSlice(this, start, end);
    }
    /**
   * Transforms this Shared Type to a JSON object.
   *
   * @return {Array<any>}
   */ toJSON() {
        return this.map((c)=>c instanceof $fd9bbcd8ab314c6e$export$c265dc8338484497 ? c.toJSON() : c);
    }
    /**
   * Returns an Array with the result of calling a provided function on every
   * element of this YArray.
   *
   * @template M
   * @param {function(T,number,YArray<T>):M} f Function that produces an element of the new Array
   * @return {Array<M>} A new array with each element being the result of the
   *                 callback function
   */ map(f) {
        return $fd9bbcd8ab314c6e$var$typeListMap(this, /** @type {any} */ f);
    }
    /**
   * Executes a provided function once on every element of this YArray.
   *
   * @param {function(T,number,YArray<T>):void} f A function to execute on every element of this YArray.
   */ forEach(f) {
        $fd9bbcd8ab314c6e$var$typeListForEach(this, f);
    }
    /**
   * @return {IterableIterator<T>}
   */ [Symbol.iterator]() {
        return $fd9bbcd8ab314c6e$var$typeListCreateIterator(this);
    }
    /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   */ _write(encoder) {
        encoder.writeTypeRef($fd9bbcd8ab314c6e$var$YArrayRefID);
    }
}
/**
 * @param {UpdateDecoderV1 | UpdateDecoderV2} _decoder
 *
 * @private
 * @function
 */ const $fd9bbcd8ab314c6e$var$readYArray = (_decoder)=>new $fd9bbcd8ab314c6e$export$c4be6576ca6fe4aa();
/**
 * @module YMap
 */ /**
 * @template T
 * @extends YEvent<YMap<T>>
 * Event that describes the changes on a YMap.
 */ class $fd9bbcd8ab314c6e$export$33aab1b1a47c1cc3 extends $fd9bbcd8ab314c6e$export$80fac438977fb51c {
    /**
   * @param {YMap<T>} ymap The YArray that changed.
   * @param {Transaction} transaction
   * @param {Set<any>} subs The keys that changed.
   */ constructor(ymap, transaction, subs){
        super(ymap, transaction);
        this.keysChanged = subs;
    }
}
/**
 * @template MapType
 * A shared Map implementation.
 *
 * @extends AbstractType<YMapEvent<MapType>>
 * @implements {Iterable<[string, MapType]>}
 */ class $fd9bbcd8ab314c6e$export$a5c7b93649eaf8f8 extends $fd9bbcd8ab314c6e$export$c265dc8338484497 {
    /**
   *
   * @param {Iterable<readonly [string, any]>=} entries - an optional iterable to initialize the YMap
   */ constructor(entries){
        super();
        /**
     * @type {Map<string,any>?}
     * @private
     */ this._prelimContent = null;
        if (entries === undefined) this._prelimContent = new Map();
        else this._prelimContent = new Map(entries);
    }
    /**
   * Integrate this type into the Yjs instance.
   *
   * * Save this struct in the os
   * * This type is sent to other client
   * * Observer functions are fired
   *
   * @param {Doc} y The Yjs instance
   * @param {Item} item
   */ _integrate(y, item) {
        super._integrate(y, item); /** @type {Map<string, any>} */ 
        this._prelimContent.forEach((value, key)=>{
            this.set(key, value);
        });
        this._prelimContent = null;
    }
    /**
   * @return {YMap<MapType>}
   */ _copy() {
        return new $fd9bbcd8ab314c6e$export$a5c7b93649eaf8f8();
    }
    /**
   * Makes a copy of this data type that can be included somewhere else.
   *
   * Note that the content is only readable _after_ it has been included somewhere in the Ydoc.
   *
   * @return {YMap<MapType>}
   */ clone() {
        /**
     * @type {YMap<MapType>}
     */ const map = new $fd9bbcd8ab314c6e$export$a5c7b93649eaf8f8();
        this.forEach((value, key)=>{
            map.set(key, value instanceof $fd9bbcd8ab314c6e$export$c265dc8338484497 ? /** @type {typeof value} */ value.clone() : value);
        });
        return map;
    }
    /**
   * Creates YMapEvent and calls observers.
   *
   * @param {Transaction} transaction
   * @param {Set<null|string>} parentSubs Keys changed on this type. `null` if list was modified.
   */ _callObserver(transaction, parentSubs) {
        $fd9bbcd8ab314c6e$var$callTypeObservers(this, transaction, new $fd9bbcd8ab314c6e$export$33aab1b1a47c1cc3(this, transaction, parentSubs));
    }
    /**
   * Transforms this Shared Type to a JSON object.
   *
   * @return {Object<string,any>}
   */ toJSON() {
        this.doc ?? $fd9bbcd8ab314c6e$var$warnPrematureAccess();
        /**
     * @type {Object<string,MapType>}
     */ const map = {};
        this._map.forEach((item, key)=>{
            if (!item.deleted) {
                const v = item.content.getContent()[item.length - 1];
                map[key] = v instanceof $fd9bbcd8ab314c6e$export$c265dc8338484497 ? v.toJSON() : v;
            }
        });
        return map;
    }
    /**
   * Returns the size of the YMap (count of key/value pairs)
   *
   * @return {number}
   */ get size() {
        return [
            ...$fd9bbcd8ab314c6e$var$createMapIterator(this)
        ].length;
    }
    /**
   * Returns the keys for each element in the YMap Type.
   *
   * @return {IterableIterator<string>}
   */ keys() {
        return $59LwD.iteratorMap($fd9bbcd8ab314c6e$var$createMapIterator(this), /** @param {any} v */ (v)=>v[0]);
    }
    /**
   * Returns the values for each element in the YMap Type.
   *
   * @return {IterableIterator<MapType>}
   */ values() {
        return $59LwD.iteratorMap($fd9bbcd8ab314c6e$var$createMapIterator(this), /** @param {any} v */ (v)=>v[1].content.getContent()[v[1].length - 1]);
    }
    /**
   * Returns an Iterator of [key, value] pairs
   *
   * @return {IterableIterator<[string, MapType]>}
   */ entries() {
        return $59LwD.iteratorMap($fd9bbcd8ab314c6e$var$createMapIterator(this), /** @param {any} v */ (v)=>/** @type {any} */ [
                v[0],
                v[1].content.getContent()[v[1].length - 1]
            ]);
    }
    /**
   * Executes a provided function on once on every key-value pair.
   *
   * @param {function(MapType,string,YMap<MapType>):void} f A function to execute on every element of this YArray.
   */ forEach(f) {
        this.doc ?? $fd9bbcd8ab314c6e$var$warnPrematureAccess();
        this._map.forEach((item, key)=>{
            if (!item.deleted) f(item.content.getContent()[item.length - 1], key, this);
        });
    }
    /**
   * Returns an Iterator of [key, value] pairs
   *
   * @return {IterableIterator<[string, MapType]>}
   */ [Symbol.iterator]() {
        return this.entries();
    }
    /**
   * Remove a specified element from this YMap.
   *
   * @param {string} key The key of the element to remove.
   */ delete(key) {
        if (this.doc !== null) $fd9bbcd8ab314c6e$export$dac1bad6146b2469(this.doc, (transaction)=>{
            $fd9bbcd8ab314c6e$var$typeMapDelete(transaction, this, key);
        });
        else /** @type {Map<string, any>} */ this._prelimContent.delete(key);
    }
    /**
   * Adds or updates an element with a specified key and value.
   * @template {MapType} VAL
   *
   * @param {string} key The key of the element to add to this YMap
   * @param {VAL} value The value of the element to add
   * @return {VAL}
   */ set(key, value) {
        if (this.doc !== null) $fd9bbcd8ab314c6e$export$dac1bad6146b2469(this.doc, (transaction)=>{
            $fd9bbcd8ab314c6e$var$typeMapSet(transaction, this, key, /** @type {any} */ value);
        });
        else /** @type {Map<string, any>} */ this._prelimContent.set(key, value);
        return value;
    }
    /**
   * Returns a specified element from this YMap.
   *
   * @param {string} key
   * @return {MapType|undefined}
   */ get(key) {
        return /** @type {any} */ $fd9bbcd8ab314c6e$var$typeMapGet(this, key);
    }
    /**
   * Returns a boolean indicating whether the specified key exists or not.
   *
   * @param {string} key The key to test.
   * @return {boolean}
   */ has(key) {
        return $fd9bbcd8ab314c6e$var$typeMapHas(this, key);
    }
    /**
   * Removes all elements from this YMap.
   */ clear() {
        if (this.doc !== null) $fd9bbcd8ab314c6e$export$dac1bad6146b2469(this.doc, (transaction)=>{
            this.forEach(function(_value, key, map) {
                $fd9bbcd8ab314c6e$var$typeMapDelete(transaction, map, key);
            });
        });
        else /** @type {Map<string, any>} */ this._prelimContent.clear();
    }
    /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   */ _write(encoder) {
        encoder.writeTypeRef($fd9bbcd8ab314c6e$var$YMapRefID);
    }
}
/**
 * @param {UpdateDecoderV1 | UpdateDecoderV2} _decoder
 *
 * @private
 * @function
 */ const $fd9bbcd8ab314c6e$var$readYMap = (_decoder)=>new $fd9bbcd8ab314c6e$export$a5c7b93649eaf8f8();
/**
 * @module YText
 */ /**
 * @param {any} a
 * @param {any} b
 * @return {boolean}
 */ const $fd9bbcd8ab314c6e$var$equalAttrs = (a, b)=>a === b || typeof a === "object" && typeof b === "object" && a && b && $8u9N6.equalFlat(a, b);
class $fd9bbcd8ab314c6e$var$ItemTextListPosition {
    /**
   * @param {Item|null} left
   * @param {Item|null} right
   * @param {number} index
   * @param {Map<string,any>} currentAttributes
   */ constructor(left, right, index, currentAttributes){
        this.left = left;
        this.right = right;
        this.index = index;
        this.currentAttributes = currentAttributes;
    }
    /**
   * Only call this if you know that this.right is defined
   */ forward() {
        if (this.right === null) $lqCPr.unexpectedCase();
        switch(this.right.content.constructor){
            case $fd9bbcd8ab314c6e$export$3194899188fb5a88:
                if (!this.right.deleted) $fd9bbcd8ab314c6e$var$updateCurrentAttributes(this.currentAttributes, /** @type {ContentFormat} */ this.right.content);
                break;
            default:
                if (!this.right.deleted) this.index += this.right.length;
                break;
        }
        this.left = this.right;
        this.right = this.right.right;
    }
}
/**
 * @param {Transaction} transaction
 * @param {ItemTextListPosition} pos
 * @param {number} count steps to move forward
 * @return {ItemTextListPosition}
 *
 * @private
 * @function
 */ const $fd9bbcd8ab314c6e$var$findNextPosition = (transaction, pos, count)=>{
    while(pos.right !== null && count > 0){
        switch(pos.right.content.constructor){
            case $fd9bbcd8ab314c6e$export$3194899188fb5a88:
                if (!pos.right.deleted) $fd9bbcd8ab314c6e$var$updateCurrentAttributes(pos.currentAttributes, /** @type {ContentFormat} */ pos.right.content);
                break;
            default:
                if (!pos.right.deleted) {
                    if (count < pos.right.length) // split right
                    $fd9bbcd8ab314c6e$var$getItemCleanStart(transaction, $fd9bbcd8ab314c6e$export$6c7d4e6171d008d0(pos.right.id.client, pos.right.id.clock + count));
                    pos.index += pos.right.length;
                    count -= pos.right.length;
                }
                break;
        }
        pos.left = pos.right;
        pos.right = pos.right.right;
    // pos.forward() - we don't forward because that would halve the performance because we already do the checks above
    }
    return pos;
};
/**
 * @param {Transaction} transaction
 * @param {AbstractType<any>} parent
 * @param {number} index
 * @param {boolean} useSearchMarker
 * @return {ItemTextListPosition}
 *
 * @private
 * @function
 */ const $fd9bbcd8ab314c6e$var$findPosition = (transaction, parent, index, useSearchMarker)=>{
    const currentAttributes = new Map();
    const marker = useSearchMarker ? $fd9bbcd8ab314c6e$var$findMarker(parent, index) : null;
    if (marker) {
        const pos = new $fd9bbcd8ab314c6e$var$ItemTextListPosition(marker.p.left, marker.p, marker.index, currentAttributes);
        return $fd9bbcd8ab314c6e$var$findNextPosition(transaction, pos, index - marker.index);
    } else {
        const pos = new $fd9bbcd8ab314c6e$var$ItemTextListPosition(null, parent._start, 0, currentAttributes);
        return $fd9bbcd8ab314c6e$var$findNextPosition(transaction, pos, index);
    }
};
/**
 * Negate applied formats
 *
 * @param {Transaction} transaction
 * @param {AbstractType<any>} parent
 * @param {ItemTextListPosition} currPos
 * @param {Map<string,any>} negatedAttributes
 *
 * @private
 * @function
 */ const $fd9bbcd8ab314c6e$var$insertNegatedAttributes = (transaction, parent, currPos, negatedAttributes)=>{
    // check if we really need to remove attributes
    while(currPos.right !== null && (currPos.right.deleted === true || currPos.right.content.constructor === $fd9bbcd8ab314c6e$export$3194899188fb5a88 && $fd9bbcd8ab314c6e$var$equalAttrs(negatedAttributes.get(/** @type {ContentFormat} */ currPos.right.content.key), /** @type {ContentFormat} */ currPos.right.content.value))){
        if (!currPos.right.deleted) negatedAttributes.delete(/** @type {ContentFormat} */ currPos.right.content.key);
        currPos.forward();
    }
    const doc = transaction.doc;
    const ownClientId = doc.clientID;
    negatedAttributes.forEach((val, key)=>{
        const left = currPos.left;
        const right = currPos.right;
        const nextFormat = new $fd9bbcd8ab314c6e$export$6d08773d2e66f8f2($fd9bbcd8ab314c6e$export$6c7d4e6171d008d0(ownClientId, $fd9bbcd8ab314c6e$export$50fdfeece43146fd(doc.store, ownClientId)), left, left && left.lastId, right, right && right.id, parent, null, new $fd9bbcd8ab314c6e$export$3194899188fb5a88(key, val));
        nextFormat.integrate(transaction, 0);
        currPos.right = nextFormat;
        currPos.forward();
    });
};
/**
 * @param {Map<string,any>} currentAttributes
 * @param {ContentFormat} format
 *
 * @private
 * @function
 */ const $fd9bbcd8ab314c6e$var$updateCurrentAttributes = (currentAttributes, format)=>{
    const { key: key, value: value } = format;
    if (value === null) currentAttributes.delete(key);
    else currentAttributes.set(key, value);
};
/**
 * @param {ItemTextListPosition} currPos
 * @param {Object<string,any>} attributes
 *
 * @private
 * @function
 */ const $fd9bbcd8ab314c6e$var$minimizeAttributeChanges = (currPos, attributes)=>{
    // go right while attributes[right.key] === right.value (or right is deleted)
    while(true){
        if (currPos.right === null) break;
        else if (currPos.right.deleted || currPos.right.content.constructor === $fd9bbcd8ab314c6e$export$3194899188fb5a88 && $fd9bbcd8ab314c6e$var$equalAttrs(attributes[/** @type {ContentFormat} */ currPos.right.content.key] ?? null, /** @type {ContentFormat} */ currPos.right.content.value)) ;
        else break;
        currPos.forward();
    }
};
/**
 * @param {Transaction} transaction
 * @param {AbstractType<any>} parent
 * @param {ItemTextListPosition} currPos
 * @param {Object<string,any>} attributes
 * @return {Map<string,any>}
 *
 * @private
 * @function
 **/ const $fd9bbcd8ab314c6e$var$insertAttributes = (transaction, parent, currPos, attributes)=>{
    const doc = transaction.doc;
    const ownClientId = doc.clientID;
    const negatedAttributes = new Map();
    // insert format-start items
    for(const key in attributes){
        const val = attributes[key];
        const currentVal = currPos.currentAttributes.get(key) ?? null;
        if (!$fd9bbcd8ab314c6e$var$equalAttrs(currentVal, val)) {
            // save negated attribute (set null if currentVal undefined)
            negatedAttributes.set(key, currentVal);
            const { left: left, right: right } = currPos;
            currPos.right = new $fd9bbcd8ab314c6e$export$6d08773d2e66f8f2($fd9bbcd8ab314c6e$export$6c7d4e6171d008d0(ownClientId, $fd9bbcd8ab314c6e$export$50fdfeece43146fd(doc.store, ownClientId)), left, left && left.lastId, right, right && right.id, parent, null, new $fd9bbcd8ab314c6e$export$3194899188fb5a88(key, val));
            currPos.right.integrate(transaction, 0);
            currPos.forward();
        }
    }
    return negatedAttributes;
};
/**
 * @param {Transaction} transaction
 * @param {AbstractType<any>} parent
 * @param {ItemTextListPosition} currPos
 * @param {string|object|AbstractType<any>} text
 * @param {Object<string,any>} attributes
 *
 * @private
 * @function
 **/ const $fd9bbcd8ab314c6e$var$insertText = (transaction, parent, currPos, text, attributes)=>{
    currPos.currentAttributes.forEach((_val, key)=>{
        if (attributes[key] === undefined) attributes[key] = null;
    });
    const doc = transaction.doc;
    const ownClientId = doc.clientID;
    $fd9bbcd8ab314c6e$var$minimizeAttributeChanges(currPos, attributes);
    const negatedAttributes = $fd9bbcd8ab314c6e$var$insertAttributes(transaction, parent, currPos, attributes);
    // insert content
    const content = text.constructor === String ? new $fd9bbcd8ab314c6e$export$ee670b2cf091bbb6(/** @type {string} */ text) : text instanceof $fd9bbcd8ab314c6e$export$c265dc8338484497 ? new $fd9bbcd8ab314c6e$export$e2e108cbe2e4f865(text) : new $fd9bbcd8ab314c6e$export$c3787ba7f6086664(text);
    let { left: left, right: right, index: index } = currPos;
    if (parent._searchMarker) $fd9bbcd8ab314c6e$var$updateMarkerChanges(parent._searchMarker, currPos.index, content.getLength());
    right = new $fd9bbcd8ab314c6e$export$6d08773d2e66f8f2($fd9bbcd8ab314c6e$export$6c7d4e6171d008d0(ownClientId, $fd9bbcd8ab314c6e$export$50fdfeece43146fd(doc.store, ownClientId)), left, left && left.lastId, right, right && right.id, parent, null, content);
    right.integrate(transaction, 0);
    currPos.right = right;
    currPos.index = index;
    currPos.forward();
    $fd9bbcd8ab314c6e$var$insertNegatedAttributes(transaction, parent, currPos, negatedAttributes);
};
/**
 * @param {Transaction} transaction
 * @param {AbstractType<any>} parent
 * @param {ItemTextListPosition} currPos
 * @param {number} length
 * @param {Object<string,any>} attributes
 *
 * @private
 * @function
 */ const $fd9bbcd8ab314c6e$var$formatText = (transaction, parent, currPos, length, attributes)=>{
    const doc = transaction.doc;
    const ownClientId = doc.clientID;
    $fd9bbcd8ab314c6e$var$minimizeAttributeChanges(currPos, attributes);
    const negatedAttributes = $fd9bbcd8ab314c6e$var$insertAttributes(transaction, parent, currPos, attributes);
    // iterate until first non-format or null is found
    // delete all formats with attributes[format.key] != null
    // also check the attributes after the first non-format as we do not want to insert redundant negated attributes there
    // eslint-disable-next-line no-labels
    iterationLoop: while(currPos.right !== null && (length > 0 || negatedAttributes.size > 0 && (currPos.right.deleted || currPos.right.content.constructor === $fd9bbcd8ab314c6e$export$3194899188fb5a88))){
        if (!currPos.right.deleted) switch(currPos.right.content.constructor){
            case $fd9bbcd8ab314c6e$export$3194899188fb5a88:
                {
                    const { key: key, value: value } = /** @type {ContentFormat} */ currPos.right.content;
                    const attr = attributes[key];
                    if (attr !== undefined) {
                        if ($fd9bbcd8ab314c6e$var$equalAttrs(attr, value)) negatedAttributes.delete(key);
                        else {
                            if (length === 0) break iterationLoop;
                            negatedAttributes.set(key, value);
                        }
                        currPos.right.delete(transaction);
                    } else currPos.currentAttributes.set(key, value);
                    break;
                }
            default:
                if (length < currPos.right.length) $fd9bbcd8ab314c6e$var$getItemCleanStart(transaction, $fd9bbcd8ab314c6e$export$6c7d4e6171d008d0(currPos.right.id.client, currPos.right.id.clock + length));
                length -= currPos.right.length;
                break;
        }
        currPos.forward();
    }
    // Quill just assumes that the editor starts with a newline and that it always
    // ends with a newline. We only insert that newline when a new newline is
    // inserted - i.e when length is bigger than type.length
    if (length > 0) {
        let newlines = "";
        for(; length > 0; length--)newlines += "\n";
        currPos.right = new $fd9bbcd8ab314c6e$export$6d08773d2e66f8f2($fd9bbcd8ab314c6e$export$6c7d4e6171d008d0(ownClientId, $fd9bbcd8ab314c6e$export$50fdfeece43146fd(doc.store, ownClientId)), currPos.left, currPos.left && currPos.left.lastId, currPos.right, currPos.right && currPos.right.id, parent, null, new $fd9bbcd8ab314c6e$export$ee670b2cf091bbb6(newlines));
        currPos.right.integrate(transaction, 0);
        currPos.forward();
    }
    $fd9bbcd8ab314c6e$var$insertNegatedAttributes(transaction, parent, currPos, negatedAttributes);
};
/**
 * Call this function after string content has been deleted in order to
 * clean up formatting Items.
 *
 * @param {Transaction} transaction
 * @param {Item} start
 * @param {Item|null} curr exclusive end, automatically iterates to the next Content Item
 * @param {Map<string,any>} startAttributes
 * @param {Map<string,any>} currAttributes
 * @return {number} The amount of formatting Items deleted.
 *
 * @function
 */ const $fd9bbcd8ab314c6e$var$cleanupFormattingGap = (transaction, start, curr, startAttributes, currAttributes)=>{
    /**
   * @type {Item|null}
   */ let end = start;
    /**
   * @type {Map<string,ContentFormat>}
   */ const endFormats = $2U6oo.create();
    while(end && (!end.countable || end.deleted)){
        if (!end.deleted && end.content.constructor === $fd9bbcd8ab314c6e$export$3194899188fb5a88) {
            const cf = /** @type {ContentFormat} */ end.content;
            endFormats.set(cf.key, cf);
        }
        end = end.right;
    }
    let cleanups = 0;
    let reachedCurr = false;
    while(start !== end){
        if (curr === start) reachedCurr = true;
        if (!start.deleted) {
            const content = start.content;
            switch(content.constructor){
                case $fd9bbcd8ab314c6e$export$3194899188fb5a88:
                    {
                        const { key: key, value: value } = /** @type {ContentFormat} */ content;
                        const startAttrValue = startAttributes.get(key) ?? null;
                        if (endFormats.get(key) !== content || startAttrValue === value) {
                            // Either this format is overwritten or it is not necessary because the attribute already existed.
                            start.delete(transaction);
                            cleanups++;
                            if (!reachedCurr && (currAttributes.get(key) ?? null) === value && startAttrValue !== value) {
                                if (startAttrValue === null) currAttributes.delete(key);
                                else currAttributes.set(key, startAttrValue);
                            }
                        }
                        if (!reachedCurr && !start.deleted) $fd9bbcd8ab314c6e$var$updateCurrentAttributes(currAttributes, /** @type {ContentFormat} */ content);
                        break;
                    }
            }
        }
        start = /** @type {Item} */ start.right;
    }
    return cleanups;
};
/**
 * @param {Transaction} transaction
 * @param {Item | null} item
 */ const $fd9bbcd8ab314c6e$var$cleanupContextlessFormattingGap = (transaction, item)=>{
    // iterate until item.right is null or content
    while(item && item.right && (item.right.deleted || !item.right.countable))item = item.right;
    const attrs = new Set();
    // iterate back until a content item is found
    while(item && (item.deleted || !item.countable)){
        if (!item.deleted && item.content.constructor === $fd9bbcd8ab314c6e$export$3194899188fb5a88) {
            const key = /** @type {ContentFormat} */ item.content.key;
            if (attrs.has(key)) item.delete(transaction);
            else attrs.add(key);
        }
        item = item.left;
    }
};
/**
 * This function is experimental and subject to change / be removed.
 *
 * Ideally, we don't need this function at all. Formatting attributes should be cleaned up
 * automatically after each change. This function iterates twice over the complete YText type
 * and removes unnecessary formatting attributes. This is also helpful for testing.
 *
 * This function won't be exported anymore as soon as there is confidence that the YText type works as intended.
 *
 * @param {YText} type
 * @return {number} How many formatting attributes have been cleaned up.
 */ const $fd9bbcd8ab314c6e$export$5d9f53c13ebffb65 = (type)=>{
    let res = 0;
    $fd9bbcd8ab314c6e$export$dac1bad6146b2469(/** @type {Doc} */ type.doc, (transaction)=>{
        let start = /** @type {Item} */ type._start;
        let end = type._start;
        let startAttributes = $2U6oo.create();
        const currentAttributes = $2U6oo.copy(startAttributes);
        while(end){
            if (end.deleted === false) switch(end.content.constructor){
                case $fd9bbcd8ab314c6e$export$3194899188fb5a88:
                    $fd9bbcd8ab314c6e$var$updateCurrentAttributes(currentAttributes, /** @type {ContentFormat} */ end.content);
                    break;
                default:
                    res += $fd9bbcd8ab314c6e$var$cleanupFormattingGap(transaction, start, end, startAttributes, currentAttributes);
                    startAttributes = $2U6oo.copy(currentAttributes);
                    start = end;
                    break;
            }
            end = end.right;
        }
    });
    return res;
};
/**
 * This will be called by the transction once the event handlers are called to potentially cleanup
 * formatting attributes.
 *
 * @param {Transaction} transaction
 */ const $fd9bbcd8ab314c6e$var$cleanupYTextAfterTransaction = (transaction)=>{
    /**
   * @type {Set<YText>}
   */ const needFullCleanup = new Set();
    // check if another formatting item was inserted
    const doc = transaction.doc;
    for (const [client, afterClock] of transaction.afterState.entries()){
        const clock = transaction.beforeState.get(client) || 0;
        if (afterClock === clock) continue;
        $fd9bbcd8ab314c6e$var$iterateStructs(transaction, /** @type {Array<Item|GC>} */ doc.store.clients.get(client), clock, afterClock, (item)=>{
            if (!item.deleted && /** @type {Item} */ item.content.constructor === $fd9bbcd8ab314c6e$export$3194899188fb5a88 && item.constructor !== $fd9bbcd8ab314c6e$export$12d259ff017e6b58) needFullCleanup.add(/** @type {any} */ item.parent);
        });
    }
    // cleanup in a new transaction
    $fd9bbcd8ab314c6e$export$dac1bad6146b2469(doc, (t)=>{
        $fd9bbcd8ab314c6e$export$8afefebbaf4e4c78(transaction, transaction.deleteSet, (item)=>{
            if (item instanceof $fd9bbcd8ab314c6e$export$12d259ff017e6b58 || !/** @type {YText} */ item.parent._hasFormatting || needFullCleanup.has(/** @type {YText} */ item.parent)) return;
            const parent = /** @type {YText} */ item.parent;
            if (item.content.constructor === $fd9bbcd8ab314c6e$export$3194899188fb5a88) needFullCleanup.add(parent);
            else // If no formatting attribute was inserted or deleted, we can make due with contextless
            // formatting cleanups.
            // Contextless: it is not necessary to compute currentAttributes for the affected position.
            $fd9bbcd8ab314c6e$var$cleanupContextlessFormattingGap(t, item);
        });
        // If a formatting item was inserted, we simply clean the whole type.
        // We need to compute currentAttributes for the current position anyway.
        for (const yText of needFullCleanup)$fd9bbcd8ab314c6e$export$5d9f53c13ebffb65(yText);
    });
};
/**
 * @param {Transaction} transaction
 * @param {ItemTextListPosition} currPos
 * @param {number} length
 * @return {ItemTextListPosition}
 *
 * @private
 * @function
 */ const $fd9bbcd8ab314c6e$var$deleteText = (transaction, currPos, length)=>{
    const startLength = length;
    const startAttrs = $2U6oo.copy(currPos.currentAttributes);
    const start = currPos.right;
    while(length > 0 && currPos.right !== null){
        if (currPos.right.deleted === false) switch(currPos.right.content.constructor){
            case $fd9bbcd8ab314c6e$export$e2e108cbe2e4f865:
            case $fd9bbcd8ab314c6e$export$c3787ba7f6086664:
            case $fd9bbcd8ab314c6e$export$ee670b2cf091bbb6:
                if (length < currPos.right.length) $fd9bbcd8ab314c6e$var$getItemCleanStart(transaction, $fd9bbcd8ab314c6e$export$6c7d4e6171d008d0(currPos.right.id.client, currPos.right.id.clock + length));
                length -= currPos.right.length;
                currPos.right.delete(transaction);
                break;
        }
        currPos.forward();
    }
    if (start) $fd9bbcd8ab314c6e$var$cleanupFormattingGap(transaction, start, currPos.right, startAttrs, currPos.currentAttributes);
    const parent = /** @type {AbstractType<any>} */ /** @type {Item} */ (currPos.left || currPos.right).parent;
    if (parent._searchMarker) $fd9bbcd8ab314c6e$var$updateMarkerChanges(parent._searchMarker, currPos.index, -startLength + length);
    return currPos;
};
/**
 * The Quill Delta format represents changes on a text document with
 * formatting information. For mor information visit {@link https://quilljs.com/docs/delta/|Quill Delta}
 *
 * @example
 *   {
 *     ops: [
 *       { insert: 'Gandalf', attributes: { bold: true } },
 *       { insert: ' the ' },
 *       { insert: 'Grey', attributes: { color: '#cccccc' } }
 *     ]
 *   }
 *
 */ /**
  * Attributes that can be assigned to a selection of text.
  *
  * @example
  *   {
  *     bold: true,
  *     font-size: '40px'
  *   }
  *
  * @typedef {Object} TextAttributes
  */ /**
 * @extends YEvent<YText>
 * Event that describes the changes on a YText type.
 */ class $fd9bbcd8ab314c6e$export$51155b8ebb74188a extends $fd9bbcd8ab314c6e$export$80fac438977fb51c {
    /**
   * @param {YText} ytext
   * @param {Transaction} transaction
   * @param {Set<any>} subs The keys that changed
   */ constructor(ytext, transaction, subs){
        super(ytext, transaction);
        /**
     * Whether the children changed.
     * @type {Boolean}
     * @private
     */ this.childListChanged = false;
        /**
     * Set of all changed attributes.
     * @type {Set<string>}
     */ this.keysChanged = new Set();
        subs.forEach((sub)=>{
            if (sub === null) this.childListChanged = true;
            else this.keysChanged.add(sub);
        });
    }
    /**
   * @type {{added:Set<Item>,deleted:Set<Item>,keys:Map<string,{action:'add'|'update'|'delete',oldValue:any}>,delta:Array<{insert?:Array<any>|string, delete?:number, retain?:number}>}}
   */ get changes() {
        if (this._changes === null) {
            /**
       * @type {{added:Set<Item>,deleted:Set<Item>,keys:Map<string,{action:'add'|'update'|'delete',oldValue:any}>,delta:Array<{insert?:Array<any>|string|AbstractType<any>|object, delete?:number, retain?:number}>}}
       */ const changes = {
                keys: this.keys,
                delta: this.delta,
                added: new Set(),
                deleted: new Set()
            };
            this._changes = changes;
        }
        return /** @type {any} */ this._changes;
    }
    /**
   * Compute the changes in the delta format.
   * A {@link https://quilljs.com/docs/delta/|Quill Delta}) that represents the changes on the document.
   *
   * @type {Array<{insert?:string|object|AbstractType<any>, delete?:number, retain?:number, attributes?: Object<string,any>}>}
   *
   * @public
   */ get delta() {
        if (this._delta === null) {
            const y = /** @type {Doc} */ this.target.doc;
            /**
       * @type {Array<{insert?:string|object|AbstractType<any>, delete?:number, retain?:number, attributes?: Object<string,any>}>}
       */ const delta = [];
            $fd9bbcd8ab314c6e$export$dac1bad6146b2469(y, (transaction)=>{
                const currentAttributes = new Map(); // saves all current attributes for insert
                const oldAttributes = new Map();
                let item = this.target._start;
                /**
         * @type {string?}
         */ let action = null;
                /**
         * @type {Object<string,any>}
         */ const attributes = {}; // counts added or removed new attributes for retain
                /**
         * @type {string|object}
         */ let insert = "";
                let retain = 0;
                let deleteLen = 0;
                const addOp = ()=>{
                    if (action !== null) {
                        /**
             * @type {any}
             */ let op = null;
                        switch(action){
                            case "delete":
                                if (deleteLen > 0) op = {
                                    delete: deleteLen
                                };
                                deleteLen = 0;
                                break;
                            case "insert":
                                if (typeof insert === "object" || insert.length > 0) {
                                    op = {
                                        insert: insert
                                    };
                                    if (currentAttributes.size > 0) {
                                        op.attributes = {};
                                        currentAttributes.forEach((value, key)=>{
                                            if (value !== null) op.attributes[key] = value;
                                        });
                                    }
                                }
                                insert = "";
                                break;
                            case "retain":
                                if (retain > 0) {
                                    op = {
                                        retain: retain
                                    };
                                    if (!$8u9N6.isEmpty(attributes)) op.attributes = $8u9N6.assign({}, attributes);
                                }
                                retain = 0;
                                break;
                        }
                        if (op) delta.push(op);
                        action = null;
                    }
                };
                while(item !== null){
                    switch(item.content.constructor){
                        case $fd9bbcd8ab314c6e$export$e2e108cbe2e4f865:
                        case $fd9bbcd8ab314c6e$export$c3787ba7f6086664:
                            if (this.adds(item)) {
                                if (!this.deletes(item)) {
                                    addOp();
                                    action = "insert";
                                    insert = item.content.getContent()[0];
                                    addOp();
                                }
                            } else if (this.deletes(item)) {
                                if (action !== "delete") {
                                    addOp();
                                    action = "delete";
                                }
                                deleteLen += 1;
                            } else if (!item.deleted) {
                                if (action !== "retain") {
                                    addOp();
                                    action = "retain";
                                }
                                retain += 1;
                            }
                            break;
                        case $fd9bbcd8ab314c6e$export$ee670b2cf091bbb6:
                            if (this.adds(item)) {
                                if (!this.deletes(item)) {
                                    if (action !== "insert") {
                                        addOp();
                                        action = "insert";
                                    }
                                    insert += /** @type {ContentString} */ item.content.str;
                                }
                            } else if (this.deletes(item)) {
                                if (action !== "delete") {
                                    addOp();
                                    action = "delete";
                                }
                                deleteLen += item.length;
                            } else if (!item.deleted) {
                                if (action !== "retain") {
                                    addOp();
                                    action = "retain";
                                }
                                retain += item.length;
                            }
                            break;
                        case $fd9bbcd8ab314c6e$export$3194899188fb5a88:
                            {
                                const { key: key, value: value } = /** @type {ContentFormat} */ item.content;
                                if (this.adds(item)) {
                                    if (!this.deletes(item)) {
                                        const curVal = currentAttributes.get(key) ?? null;
                                        if (!$fd9bbcd8ab314c6e$var$equalAttrs(curVal, value)) {
                                            if (action === "retain") addOp();
                                            if ($fd9bbcd8ab314c6e$var$equalAttrs(value, oldAttributes.get(key) ?? null)) delete attributes[key];
                                            else attributes[key] = value;
                                        } else if (value !== null) item.delete(transaction);
                                    }
                                } else if (this.deletes(item)) {
                                    oldAttributes.set(key, value);
                                    const curVal = currentAttributes.get(key) ?? null;
                                    if (!$fd9bbcd8ab314c6e$var$equalAttrs(curVal, value)) {
                                        if (action === "retain") addOp();
                                        attributes[key] = curVal;
                                    }
                                } else if (!item.deleted) {
                                    oldAttributes.set(key, value);
                                    const attr = attributes[key];
                                    if (attr !== undefined) {
                                        if (!$fd9bbcd8ab314c6e$var$equalAttrs(attr, value)) {
                                            if (action === "retain") addOp();
                                            if (value === null) delete attributes[key];
                                            else attributes[key] = value;
                                        } else if (attr !== null) item.delete(transaction);
                                    }
                                }
                                if (!item.deleted) {
                                    if (action === "insert") addOp();
                                    $fd9bbcd8ab314c6e$var$updateCurrentAttributes(currentAttributes, /** @type {ContentFormat} */ item.content);
                                }
                                break;
                            }
                    }
                    item = item.right;
                }
                addOp();
                while(delta.length > 0){
                    const lastOp = delta[delta.length - 1];
                    if (lastOp.retain !== undefined && lastOp.attributes === undefined) // retain delta's if they don't assign attributes
                    delta.pop();
                    else break;
                }
            });
            this._delta = delta;
        }
        return /** @type {any} */ this._delta;
    }
}
/**
 * Type that represents text with formatting information.
 *
 * This type replaces y-richtext as this implementation is able to handle
 * block formats (format information on a paragraph), embeds (complex elements
 * like pictures and videos), and text formats (**bold**, *italic*).
 *
 * @extends AbstractType<YTextEvent>
 */ class $fd9bbcd8ab314c6e$export$5f1af8db9871e1d6 extends $fd9bbcd8ab314c6e$export$c265dc8338484497 {
    /**
   * @param {String} [string] The initial value of the YText.
   */ constructor(string){
        super();
        /**
     * Array of pending operations on this type
     * @type {Array<function():void>?}
     */ this._pending = string !== undefined ? [
            ()=>this.insert(0, string)
        ] : [];
        /**
     * @type {Array<ArraySearchMarker>|null}
     */ this._searchMarker = [];
        /**
     * Whether this YText contains formatting attributes.
     * This flag is updated when a formatting item is integrated (see ContentFormat.integrate)
     */ this._hasFormatting = false;
    }
    /**
   * Number of characters of this text type.
   *
   * @type {number}
   */ get length() {
        this.doc ?? $fd9bbcd8ab314c6e$var$warnPrematureAccess();
        return this._length;
    }
    /**
   * @param {Doc} y
   * @param {Item} item
   */ _integrate(y, item) {
        super._integrate(y, item);
        try {
            /** @type {Array<function>} */ this._pending.forEach((f)=>f());
        } catch (e) {
            console.error(e);
        }
        this._pending = null;
    }
    _copy() {
        return new $fd9bbcd8ab314c6e$export$5f1af8db9871e1d6();
    }
    /**
   * Makes a copy of this data type that can be included somewhere else.
   *
   * Note that the content is only readable _after_ it has been included somewhere in the Ydoc.
   *
   * @return {YText}
   */ clone() {
        const text = new $fd9bbcd8ab314c6e$export$5f1af8db9871e1d6();
        text.applyDelta(this.toDelta());
        return text;
    }
    /**
   * Creates YTextEvent and calls observers.
   *
   * @param {Transaction} transaction
   * @param {Set<null|string>} parentSubs Keys changed on this type. `null` if list was modified.
   */ _callObserver(transaction, parentSubs) {
        super._callObserver(transaction, parentSubs);
        const event = new $fd9bbcd8ab314c6e$export$51155b8ebb74188a(this, transaction, parentSubs);
        $fd9bbcd8ab314c6e$var$callTypeObservers(this, transaction, event);
        // If a remote change happened, we try to cleanup potential formatting duplicates.
        if (!transaction.local && this._hasFormatting) transaction._needFormattingCleanup = true;
    }
    /**
   * Returns the unformatted string representation of this YText type.
   *
   * @public
   */ toString() {
        this.doc ?? $fd9bbcd8ab314c6e$var$warnPrematureAccess();
        let str = "";
        /**
     * @type {Item|null}
     */ let n = this._start;
        while(n !== null){
            if (!n.deleted && n.countable && n.content.constructor === $fd9bbcd8ab314c6e$export$ee670b2cf091bbb6) str += /** @type {ContentString} */ n.content.str;
            n = n.right;
        }
        return str;
    }
    /**
   * Returns the unformatted string representation of this YText type.
   *
   * @return {string}
   * @public
   */ toJSON() {
        return this.toString();
    }
    /**
   * Apply a {@link Delta} on this shared YText type.
   *
   * @param {any} delta The changes to apply on this element.
   * @param {object}  opts
   * @param {boolean} [opts.sanitize] Sanitize input delta. Removes ending newlines if set to true.
   *
   *
   * @public
   */ applyDelta(delta, { sanitize: sanitize = true } = {}) {
        if (this.doc !== null) $fd9bbcd8ab314c6e$export$dac1bad6146b2469(this.doc, (transaction)=>{
            const currPos = new $fd9bbcd8ab314c6e$var$ItemTextListPosition(null, this._start, 0, new Map());
            for(let i = 0; i < delta.length; i++){
                const op = delta[i];
                if (op.insert !== undefined) {
                    // Quill assumes that the content starts with an empty paragraph.
                    // Yjs/Y.Text assumes that it starts empty. We always hide that
                    // there is a newline at the end of the content.
                    // If we omit this step, clients will see a different number of
                    // paragraphs, but nothing bad will happen.
                    const ins = !sanitize && typeof op.insert === "string" && i === delta.length - 1 && currPos.right === null && op.insert.slice(-1) === "\n" ? op.insert.slice(0, -1) : op.insert;
                    if (typeof ins !== "string" || ins.length > 0) $fd9bbcd8ab314c6e$var$insertText(transaction, this, currPos, ins, op.attributes || {});
                } else if (op.retain !== undefined) $fd9bbcd8ab314c6e$var$formatText(transaction, this, currPos, op.retain, op.attributes || {});
                else if (op.delete !== undefined) $fd9bbcd8ab314c6e$var$deleteText(transaction, currPos, op.delete);
            }
        });
        else /** @type {Array<function>} */ this._pending.push(()=>this.applyDelta(delta));
    }
    /**
   * Returns the Delta representation of this YText type.
   *
   * @param {Snapshot} [snapshot]
   * @param {Snapshot} [prevSnapshot]
   * @param {function('removed' | 'added', ID):any} [computeYChange]
   * @return {any} The Delta representation of this type.
   *
   * @public
   */ toDelta(snapshot, prevSnapshot, computeYChange) {
        this.doc ?? $fd9bbcd8ab314c6e$var$warnPrematureAccess();
        /**
     * @type{Array<any>}
     */ const ops = [];
        const currentAttributes = new Map();
        const doc = /** @type {Doc} */ this.doc;
        let str = "";
        let n = this._start;
        function packStr() {
            if (str.length > 0) {
                // pack str with attributes to ops
                /**
         * @type {Object<string,any>}
         */ const attributes = {};
                let addAttributes = false;
                currentAttributes.forEach((value, key)=>{
                    addAttributes = true;
                    attributes[key] = value;
                });
                /**
         * @type {Object<string,any>}
         */ const op = {
                    insert: str
                };
                if (addAttributes) op.attributes = attributes;
                ops.push(op);
                str = "";
            }
        }
        const computeDelta = ()=>{
            while(n !== null){
                if ($fd9bbcd8ab314c6e$var$isVisible(n, snapshot) || prevSnapshot !== undefined && $fd9bbcd8ab314c6e$var$isVisible(n, prevSnapshot)) switch(n.content.constructor){
                    case $fd9bbcd8ab314c6e$export$ee670b2cf091bbb6:
                        {
                            const cur = currentAttributes.get("ychange");
                            if (snapshot !== undefined && !$fd9bbcd8ab314c6e$var$isVisible(n, snapshot)) {
                                if (cur === undefined || cur.user !== n.id.client || cur.type !== "removed") {
                                    packStr();
                                    currentAttributes.set("ychange", computeYChange ? computeYChange("removed", n.id) : {
                                        type: "removed"
                                    });
                                }
                            } else if (prevSnapshot !== undefined && !$fd9bbcd8ab314c6e$var$isVisible(n, prevSnapshot)) {
                                if (cur === undefined || cur.user !== n.id.client || cur.type !== "added") {
                                    packStr();
                                    currentAttributes.set("ychange", computeYChange ? computeYChange("added", n.id) : {
                                        type: "added"
                                    });
                                }
                            } else if (cur !== undefined) {
                                packStr();
                                currentAttributes.delete("ychange");
                            }
                            str += /** @type {ContentString} */ n.content.str;
                            break;
                        }
                    case $fd9bbcd8ab314c6e$export$e2e108cbe2e4f865:
                    case $fd9bbcd8ab314c6e$export$c3787ba7f6086664:
                        {
                            packStr();
                            /**
               * @type {Object<string,any>}
               */ const op = {
                                insert: n.content.getContent()[0]
                            };
                            if (currentAttributes.size > 0) {
                                const attrs = /** @type {Object<string,any>} */ {};
                                op.attributes = attrs;
                                currentAttributes.forEach((value, key)=>{
                                    attrs[key] = value;
                                });
                            }
                            ops.push(op);
                            break;
                        }
                    case $fd9bbcd8ab314c6e$export$3194899188fb5a88:
                        if ($fd9bbcd8ab314c6e$var$isVisible(n, snapshot)) {
                            packStr();
                            $fd9bbcd8ab314c6e$var$updateCurrentAttributes(currentAttributes, /** @type {ContentFormat} */ n.content);
                        }
                        break;
                }
                n = n.right;
            }
            packStr();
        };
        if (snapshot || prevSnapshot) // snapshots are merged again after the transaction, so we need to keep the
        // transaction alive until we are done
        $fd9bbcd8ab314c6e$export$dac1bad6146b2469(doc, (transaction)=>{
            if (snapshot) $fd9bbcd8ab314c6e$var$splitSnapshotAffectedStructs(transaction, snapshot);
            if (prevSnapshot) $fd9bbcd8ab314c6e$var$splitSnapshotAffectedStructs(transaction, prevSnapshot);
            computeDelta();
        }, "cleanup");
        else computeDelta();
        return ops;
    }
    /**
   * Insert text at a given index.
   *
   * @param {number} index The index at which to start inserting.
   * @param {String} text The text to insert at the specified position.
   * @param {TextAttributes} [attributes] Optionally define some formatting
   *                                    information to apply on the inserted
   *                                    Text.
   * @public
   */ insert(index, text, attributes) {
        if (text.length <= 0) return;
        const y = this.doc;
        if (y !== null) $fd9bbcd8ab314c6e$export$dac1bad6146b2469(y, (transaction)=>{
            const pos = $fd9bbcd8ab314c6e$var$findPosition(transaction, this, index, !attributes);
            if (!attributes) {
                attributes = {};
                // @ts-ignore
                pos.currentAttributes.forEach((v, k)=>{
                    attributes[k] = v;
                });
            }
            $fd9bbcd8ab314c6e$var$insertText(transaction, this, pos, text, attributes);
        });
        else /** @type {Array<function>} */ this._pending.push(()=>this.insert(index, text, attributes));
    }
    /**
   * Inserts an embed at a index.
   *
   * @param {number} index The index to insert the embed at.
   * @param {Object | AbstractType<any>} embed The Object that represents the embed.
   * @param {TextAttributes} [attributes] Attribute information to apply on the
   *                                    embed
   *
   * @public
   */ insertEmbed(index, embed, attributes) {
        const y = this.doc;
        if (y !== null) $fd9bbcd8ab314c6e$export$dac1bad6146b2469(y, (transaction)=>{
            const pos = $fd9bbcd8ab314c6e$var$findPosition(transaction, this, index, !attributes);
            $fd9bbcd8ab314c6e$var$insertText(transaction, this, pos, embed, attributes || {});
        });
        else /** @type {Array<function>} */ this._pending.push(()=>this.insertEmbed(index, embed, attributes || {}));
    }
    /**
   * Deletes text starting from an index.
   *
   * @param {number} index Index at which to start deleting.
   * @param {number} length The number of characters to remove. Defaults to 1.
   *
   * @public
   */ delete(index, length) {
        if (length === 0) return;
        const y = this.doc;
        if (y !== null) $fd9bbcd8ab314c6e$export$dac1bad6146b2469(y, (transaction)=>{
            $fd9bbcd8ab314c6e$var$deleteText(transaction, $fd9bbcd8ab314c6e$var$findPosition(transaction, this, index, true), length);
        });
        else /** @type {Array<function>} */ this._pending.push(()=>this.delete(index, length));
    }
    /**
   * Assigns properties to a range of text.
   *
   * @param {number} index The position where to start formatting.
   * @param {number} length The amount of characters to assign properties to.
   * @param {TextAttributes} attributes Attribute information to apply on the
   *                                    text.
   *
   * @public
   */ format(index, length, attributes) {
        if (length === 0) return;
        const y = this.doc;
        if (y !== null) $fd9bbcd8ab314c6e$export$dac1bad6146b2469(y, (transaction)=>{
            const pos = $fd9bbcd8ab314c6e$var$findPosition(transaction, this, index, false);
            if (pos.right === null) return;
            $fd9bbcd8ab314c6e$var$formatText(transaction, this, pos, length, attributes);
        });
        else /** @type {Array<function>} */ this._pending.push(()=>this.format(index, length, attributes));
    }
    /**
   * Removes an attribute.
   *
   * @note Xml-Text nodes don't have attributes. You can use this feature to assign properties to complete text-blocks.
   *
   * @param {String} attributeName The attribute name that is to be removed.
   *
   * @public
   */ removeAttribute(attributeName) {
        if (this.doc !== null) $fd9bbcd8ab314c6e$export$dac1bad6146b2469(this.doc, (transaction)=>{
            $fd9bbcd8ab314c6e$var$typeMapDelete(transaction, this, attributeName);
        });
        else /** @type {Array<function>} */ this._pending.push(()=>this.removeAttribute(attributeName));
    }
    /**
   * Sets or updates an attribute.
   *
   * @note Xml-Text nodes don't have attributes. You can use this feature to assign properties to complete text-blocks.
   *
   * @param {String} attributeName The attribute name that is to be set.
   * @param {any} attributeValue The attribute value that is to be set.
   *
   * @public
   */ setAttribute(attributeName, attributeValue) {
        if (this.doc !== null) $fd9bbcd8ab314c6e$export$dac1bad6146b2469(this.doc, (transaction)=>{
            $fd9bbcd8ab314c6e$var$typeMapSet(transaction, this, attributeName, attributeValue);
        });
        else /** @type {Array<function>} */ this._pending.push(()=>this.setAttribute(attributeName, attributeValue));
    }
    /**
   * Returns an attribute value that belongs to the attribute name.
   *
   * @note Xml-Text nodes don't have attributes. You can use this feature to assign properties to complete text-blocks.
   *
   * @param {String} attributeName The attribute name that identifies the
   *                               queried value.
   * @return {any} The queried attribute value.
   *
   * @public
   */ getAttribute(attributeName) {
        return /** @type {any} */ $fd9bbcd8ab314c6e$var$typeMapGet(this, attributeName);
    }
    /**
   * Returns all attribute name/value pairs in a JSON Object.
   *
   * @note Xml-Text nodes don't have attributes. You can use this feature to assign properties to complete text-blocks.
   *
   * @return {Object<string, any>} A JSON Object that describes the attributes.
   *
   * @public
   */ getAttributes() {
        return $fd9bbcd8ab314c6e$var$typeMapGetAll(this);
    }
    /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   */ _write(encoder) {
        encoder.writeTypeRef($fd9bbcd8ab314c6e$var$YTextRefID);
    }
}
/**
 * @param {UpdateDecoderV1 | UpdateDecoderV2} _decoder
 * @return {YText}
 *
 * @private
 * @function
 */ const $fd9bbcd8ab314c6e$var$readYText = (_decoder)=>new $fd9bbcd8ab314c6e$export$5f1af8db9871e1d6();
/**
 * @module YXml
 */ /**
 * Define the elements to which a set of CSS queries apply.
 * {@link https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Selectors|CSS_Selectors}
 *
 * @example
 *   query = '.classSelector'
 *   query = 'nodeSelector'
 *   query = '#idSelector'
 *
 * @typedef {string} CSS_Selector
 */ /**
 * Dom filter function.
 *
 * @callback domFilter
 * @param {string} nodeName The nodeName of the element
 * @param {Map} attributes The map of attributes.
 * @return {boolean} Whether to include the Dom node in the YXmlElement.
 */ /**
 * Represents a subset of the nodes of a YXmlElement / YXmlFragment and a
 * position within them.
 *
 * Can be created with {@link YXmlFragment#createTreeWalker}
 *
 * @public
 * @implements {Iterable<YXmlElement|YXmlText|YXmlElement|YXmlHook>}
 */ class $fd9bbcd8ab314c6e$var$YXmlTreeWalker {
    /**
   * @param {YXmlFragment | YXmlElement} root
   * @param {function(AbstractType<any>):boolean} [f]
   */ constructor(root, f = ()=>true){
        this._filter = f;
        this._root = root;
        /**
     * @type {Item}
     */ this._currentNode = /** @type {Item} */ root._start;
        this._firstCall = true;
        root.doc ?? $fd9bbcd8ab314c6e$var$warnPrematureAccess();
    }
    [Symbol.iterator]() {
        return this;
    }
    /**
   * Get the next node.
   *
   * @return {IteratorResult<YXmlElement|YXmlText|YXmlHook>} The next node.
   *
   * @public
   */ next() {
        /**
     * @type {Item|null}
     */ let n = this._currentNode;
        let type = n && n.content && /** @type {any} */ n.content.type;
        if (n !== null && (!this._firstCall || n.deleted || !this._filter(type))) do {
            type = /** @type {any} */ n.content.type;
            if (!n.deleted && (type.constructor === $fd9bbcd8ab314c6e$export$4db87581d3ca170d || type.constructor === $fd9bbcd8ab314c6e$export$d5ce8c3e1731f1a7) && type._start !== null) // walk down in the tree
            n = type._start;
            else // walk right or up in the tree
            while(n !== null){
                if (n.right !== null) {
                    n = n.right;
                    break;
                } else if (n.parent === this._root) n = null;
                else n = /** @type {AbstractType<any>} */ n.parent._item;
            }
        }while (n !== null && (n.deleted || !this._filter(/** @type {ContentType} */ n.content.type)));
        this._firstCall = false;
        if (n === null) // @ts-ignore
        return {
            value: undefined,
            done: true
        };
        this._currentNode = n;
        return {
            value: /** @type {any} */ n.content.type,
            done: false
        };
    }
}
/**
 * Represents a list of {@link YXmlElement}.and {@link YXmlText} types.
 * A YxmlFragment is similar to a {@link YXmlElement}, but it does not have a
 * nodeName and it does not have attributes. Though it can be bound to a DOM
 * element - in this case the attributes and the nodeName are not shared.
 *
 * @public
 * @extends AbstractType<YXmlEvent>
 */ class $fd9bbcd8ab314c6e$export$d5ce8c3e1731f1a7 extends $fd9bbcd8ab314c6e$export$c265dc8338484497 {
    constructor(){
        super();
        /**
     * @type {Array<any>|null}
     */ this._prelimContent = [];
    }
    /**
   * @type {YXmlElement|YXmlText|null}
   */ get firstChild() {
        const first = this._first;
        return first ? first.content.getContent()[0] : null;
    }
    /**
   * Integrate this type into the Yjs instance.
   *
   * * Save this struct in the os
   * * This type is sent to other client
   * * Observer functions are fired
   *
   * @param {Doc} y The Yjs instance
   * @param {Item} item
   */ _integrate(y, item) {
        super._integrate(y, item);
        this.insert(0, /** @type {Array<any>} */ this._prelimContent);
        this._prelimContent = null;
    }
    _copy() {
        return new $fd9bbcd8ab314c6e$export$d5ce8c3e1731f1a7();
    }
    /**
   * Makes a copy of this data type that can be included somewhere else.
   *
   * Note that the content is only readable _after_ it has been included somewhere in the Ydoc.
   *
   * @return {YXmlFragment}
   */ clone() {
        const el = new $fd9bbcd8ab314c6e$export$d5ce8c3e1731f1a7();
        // @ts-ignore
        el.insert(0, this.toArray().map((item)=>item instanceof $fd9bbcd8ab314c6e$export$c265dc8338484497 ? item.clone() : item));
        return el;
    }
    get length() {
        this.doc ?? $fd9bbcd8ab314c6e$var$warnPrematureAccess();
        return this._prelimContent === null ? this._length : this._prelimContent.length;
    }
    /**
   * Create a subtree of childNodes.
   *
   * @example
   * const walker = elem.createTreeWalker(dom => dom.nodeName === 'div')
   * for (let node in walker) {
   *   // `node` is a div node
   *   nop(node)
   * }
   *
   * @param {function(AbstractType<any>):boolean} filter Function that is called on each child element and
   *                          returns a Boolean indicating whether the child
   *                          is to be included in the subtree.
   * @return {YXmlTreeWalker} A subtree and a position within it.
   *
   * @public
   */ createTreeWalker(filter) {
        return new $fd9bbcd8ab314c6e$var$YXmlTreeWalker(this, filter);
    }
    /**
   * Returns the first YXmlElement that matches the query.
   * Similar to DOM's {@link querySelector}.
   *
   * Query support:
   *   - tagname
   * TODO:
   *   - id
   *   - attribute
   *
   * @param {CSS_Selector} query The query on the children.
   * @return {YXmlElement|YXmlText|YXmlHook|null} The first element that matches the query or null.
   *
   * @public
   */ querySelector(query) {
        query = query.toUpperCase();
        // @ts-ignore
        const iterator = new $fd9bbcd8ab314c6e$var$YXmlTreeWalker(this, (element)=>element.nodeName && element.nodeName.toUpperCase() === query);
        const next = iterator.next();
        if (next.done) return null;
        else return next.value;
    }
    /**
   * Returns all YXmlElements that match the query.
   * Similar to Dom's {@link querySelectorAll}.
   *
   * @todo Does not yet support all queries. Currently only query by tagName.
   *
   * @param {CSS_Selector} query The query on the children
   * @return {Array<YXmlElement|YXmlText|YXmlHook|null>} The elements that match this query.
   *
   * @public
   */ querySelectorAll(query) {
        query = query.toUpperCase();
        // @ts-ignore
        return $8aHnL.from(new $fd9bbcd8ab314c6e$var$YXmlTreeWalker(this, (element)=>element.nodeName && element.nodeName.toUpperCase() === query));
    }
    /**
   * Creates YXmlEvent and calls observers.
   *
   * @param {Transaction} transaction
   * @param {Set<null|string>} parentSubs Keys changed on this type. `null` if list was modified.
   */ _callObserver(transaction, parentSubs) {
        $fd9bbcd8ab314c6e$var$callTypeObservers(this, transaction, new $fd9bbcd8ab314c6e$export$88c9145a0c3b556c(this, parentSubs, transaction));
    }
    /**
   * Get the string representation of all the children of this YXmlFragment.
   *
   * @return {string} The string representation of all children.
   */ toString() {
        return $fd9bbcd8ab314c6e$var$typeListMap(this, (xml)=>xml.toString()).join("");
    }
    /**
   * @return {string}
   */ toJSON() {
        return this.toString();
    }
    /**
   * Creates a Dom Element that mirrors this YXmlElement.
   *
   * @param {Document} [_document=document] The document object (you must define
   *                                        this when calling this method in
   *                                        nodejs)
   * @param {Object<string, any>} [hooks={}] Optional property to customize how hooks
   *                                             are presented in the DOM
   * @param {any} [binding] You should not set this property. This is
   *                               used if DomBinding wants to create a
   *                               association to the created DOM type.
   * @return {Node} The {@link https://developer.mozilla.org/en-US/docs/Web/API/Element|Dom Element}
   *
   * @public
   */ toDOM(_document = document, hooks = {}, binding) {
        const fragment = _document.createDocumentFragment();
        if (binding !== undefined) binding._createAssociation(fragment, this);
        $fd9bbcd8ab314c6e$var$typeListForEach(this, (xmlType)=>{
            fragment.insertBefore(xmlType.toDOM(_document, hooks, binding), null);
        });
        return fragment;
    }
    /**
   * Inserts new content at an index.
   *
   * @example
   *  // Insert character 'a' at position 0
   *  xml.insert(0, [new Y.XmlText('text')])
   *
   * @param {number} index The index to insert content at
   * @param {Array<YXmlElement|YXmlText>} content The array of content
   */ insert(index, content) {
        if (this.doc !== null) $fd9bbcd8ab314c6e$export$dac1bad6146b2469(this.doc, (transaction)=>{
            $fd9bbcd8ab314c6e$var$typeListInsertGenerics(transaction, this, index, content);
        });
        else // @ts-ignore _prelimContent is defined because this is not yet integrated
        this._prelimContent.splice(index, 0, ...content);
    }
    /**
   * Inserts new content at an index.
   *
   * @example
   *  // Insert character 'a' at position 0
   *  xml.insert(0, [new Y.XmlText('text')])
   *
   * @param {null|Item|YXmlElement|YXmlText} ref The index to insert content at
   * @param {Array<YXmlElement|YXmlText>} content The array of content
   */ insertAfter(ref, content) {
        if (this.doc !== null) $fd9bbcd8ab314c6e$export$dac1bad6146b2469(this.doc, (transaction)=>{
            const refItem = ref && ref instanceof $fd9bbcd8ab314c6e$export$c265dc8338484497 ? ref._item : ref;
            $fd9bbcd8ab314c6e$var$typeListInsertGenericsAfter(transaction, this, refItem, content);
        });
        else {
            const pc = /** @type {Array<any>} */ this._prelimContent;
            const index = ref === null ? 0 : pc.findIndex((el)=>el === ref) + 1;
            if (index === 0 && ref !== null) throw $lqCPr.create("Reference item not found");
            pc.splice(index, 0, ...content);
        }
    }
    /**
   * Deletes elements starting from an index.
   *
   * @param {number} index Index at which to start deleting elements
   * @param {number} [length=1] The number of elements to remove. Defaults to 1.
   */ delete(index, length = 1) {
        if (this.doc !== null) $fd9bbcd8ab314c6e$export$dac1bad6146b2469(this.doc, (transaction)=>{
            $fd9bbcd8ab314c6e$var$typeListDelete(transaction, this, index, length);
        });
        else // @ts-ignore _prelimContent is defined because this is not yet integrated
        this._prelimContent.splice(index, length);
    }
    /**
   * Transforms this YArray to a JavaScript Array.
   *
   * @return {Array<YXmlElement|YXmlText|YXmlHook>}
   */ toArray() {
        return $fd9bbcd8ab314c6e$var$typeListToArray(this);
    }
    /**
   * Appends content to this YArray.
   *
   * @param {Array<YXmlElement|YXmlText>} content Array of content to append.
   */ push(content) {
        this.insert(this.length, content);
    }
    /**
   * Prepends content to this YArray.
   *
   * @param {Array<YXmlElement|YXmlText>} content Array of content to prepend.
   */ unshift(content) {
        this.insert(0, content);
    }
    /**
   * Returns the i-th element from a YArray.
   *
   * @param {number} index The index of the element to return from the YArray
   * @return {YXmlElement|YXmlText}
   */ get(index) {
        return $fd9bbcd8ab314c6e$var$typeListGet(this, index);
    }
    /**
   * Returns a portion of this YXmlFragment into a JavaScript Array selected
   * from start to end (end not included).
   *
   * @param {number} [start]
   * @param {number} [end]
   * @return {Array<YXmlElement|YXmlText>}
   */ slice(start = 0, end = this.length) {
        return $fd9bbcd8ab314c6e$var$typeListSlice(this, start, end);
    }
    /**
   * Executes a provided function on once on every child element.
   *
   * @param {function(YXmlElement|YXmlText,number, typeof self):void} f A function to execute on every element of this YArray.
   */ forEach(f) {
        $fd9bbcd8ab314c6e$var$typeListForEach(this, f);
    }
    /**
   * Transform the properties of this type to binary and write it to an
   * BinaryEncoder.
   *
   * This is called when this Item is sent to a remote peer.
   *
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder The encoder to write data to.
   */ _write(encoder) {
        encoder.writeTypeRef($fd9bbcd8ab314c6e$var$YXmlFragmentRefID);
    }
}
/**
 * @param {UpdateDecoderV1 | UpdateDecoderV2} _decoder
 * @return {YXmlFragment}
 *
 * @private
 * @function
 */ const $fd9bbcd8ab314c6e$var$readYXmlFragment = (_decoder)=>new $fd9bbcd8ab314c6e$export$d5ce8c3e1731f1a7();
/**
 * @typedef {Object|number|null|Array<any>|string|Uint8Array|AbstractType<any>} ValueTypes
 */ /**
 * An YXmlElement imitates the behavior of a
 * https://developer.mozilla.org/en-US/docs/Web/API/Element|Dom Element
 *
 * * An YXmlElement has attributes (key value pairs)
 * * An YXmlElement has childElements that must inherit from YXmlElement
 *
 * @template {{ [key: string]: ValueTypes }} [KV={ [key: string]: string }]
 */ class $fd9bbcd8ab314c6e$export$4db87581d3ca170d extends $fd9bbcd8ab314c6e$export$d5ce8c3e1731f1a7 {
    constructor(nodeName = "UNDEFINED"){
        super();
        this.nodeName = nodeName;
        /**
     * @type {Map<string, any>|null}
     */ this._prelimAttrs = new Map();
    }
    /**
   * @type {YXmlElement|YXmlText|null}
   */ get nextSibling() {
        const n = this._item ? this._item.next : null;
        return n ? /** @type {YXmlElement|YXmlText} */ /** @type {ContentType} */ n.content.type : null;
    }
    /**
   * @type {YXmlElement|YXmlText|null}
   */ get prevSibling() {
        const n = this._item ? this._item.prev : null;
        return n ? /** @type {YXmlElement|YXmlText} */ /** @type {ContentType} */ n.content.type : null;
    }
    /**
   * Integrate this type into the Yjs instance.
   *
   * * Save this struct in the os
   * * This type is sent to other client
   * * Observer functions are fired
   *
   * @param {Doc} y The Yjs instance
   * @param {Item} item
   */ _integrate(y, item) {
        super._integrate(y, item);
        /** @type {Map<string, any>} */ this._prelimAttrs.forEach((value, key)=>{
            this.setAttribute(key, value);
        });
        this._prelimAttrs = null;
    }
    /**
   * Creates an Item with the same effect as this Item (without position effect)
   *
   * @return {YXmlElement}
   */ _copy() {
        return new $fd9bbcd8ab314c6e$export$4db87581d3ca170d(this.nodeName);
    }
    /**
   * Makes a copy of this data type that can be included somewhere else.
   *
   * Note that the content is only readable _after_ it has been included somewhere in the Ydoc.
   *
   * @return {YXmlElement<KV>}
   */ clone() {
        /**
     * @type {YXmlElement<KV>}
     */ const el = new $fd9bbcd8ab314c6e$export$4db87581d3ca170d(this.nodeName);
        const attrs = this.getAttributes();
        $8u9N6.forEach(attrs, (value, key)=>{
            if (typeof value === "string") el.setAttribute(key, value);
        });
        // @ts-ignore
        el.insert(0, this.toArray().map((item)=>item instanceof $fd9bbcd8ab314c6e$export$c265dc8338484497 ? item.clone() : item));
        return el;
    }
    /**
   * Returns the XML serialization of this YXmlElement.
   * The attributes are ordered by attribute-name, so you can easily use this
   * method to compare YXmlElements
   *
   * @return {string} The string representation of this type.
   *
   * @public
   */ toString() {
        const attrs = this.getAttributes();
        const stringBuilder = [];
        const keys = [];
        for(const key in attrs)keys.push(key);
        keys.sort();
        const keysLen = keys.length;
        for(let i = 0; i < keysLen; i++){
            const key = keys[i];
            stringBuilder.push(key + '="' + attrs[key] + '"');
        }
        const nodeName = this.nodeName.toLocaleLowerCase();
        const attrsString = stringBuilder.length > 0 ? " " + stringBuilder.join(" ") : "";
        return `<${nodeName}${attrsString}>${super.toString()}</${nodeName}>`;
    }
    /**
   * Removes an attribute from this YXmlElement.
   *
   * @param {string} attributeName The attribute name that is to be removed.
   *
   * @public
   */ removeAttribute(attributeName) {
        if (this.doc !== null) $fd9bbcd8ab314c6e$export$dac1bad6146b2469(this.doc, (transaction)=>{
            $fd9bbcd8ab314c6e$var$typeMapDelete(transaction, this, attributeName);
        });
        else /** @type {Map<string,any>} */ this._prelimAttrs.delete(attributeName);
    }
    /**
   * Sets or updates an attribute.
   *
   * @template {keyof KV & string} KEY
   *
   * @param {KEY} attributeName The attribute name that is to be set.
   * @param {KV[KEY]} attributeValue The attribute value that is to be set.
   *
   * @public
   */ setAttribute(attributeName, attributeValue) {
        if (this.doc !== null) $fd9bbcd8ab314c6e$export$dac1bad6146b2469(this.doc, (transaction)=>{
            $fd9bbcd8ab314c6e$var$typeMapSet(transaction, this, attributeName, attributeValue);
        });
        else /** @type {Map<string, any>} */ this._prelimAttrs.set(attributeName, attributeValue);
    }
    /**
   * Returns an attribute value that belongs to the attribute name.
   *
   * @template {keyof KV & string} KEY
   *
   * @param {KEY} attributeName The attribute name that identifies the
   *                               queried value.
   * @return {KV[KEY]|undefined} The queried attribute value.
   *
   * @public
   */ getAttribute(attributeName) {
        return /** @type {any} */ $fd9bbcd8ab314c6e$var$typeMapGet(this, attributeName);
    }
    /**
   * Returns whether an attribute exists
   *
   * @param {string} attributeName The attribute name to check for existence.
   * @return {boolean} whether the attribute exists.
   *
   * @public
   */ hasAttribute(attributeName) {
        return /** @type {any} */ $fd9bbcd8ab314c6e$var$typeMapHas(this, attributeName);
    }
    /**
   * Returns all attribute name/value pairs in a JSON Object.
   *
   * @param {Snapshot} [snapshot]
   * @return {{ [Key in Extract<keyof KV,string>]?: KV[Key]}} A JSON Object that describes the attributes.
   *
   * @public
   */ getAttributes(snapshot) {
        return /** @type {any} */ snapshot ? $fd9bbcd8ab314c6e$export$7769bdedaef2c91b(this, snapshot) : $fd9bbcd8ab314c6e$var$typeMapGetAll(this);
    }
    /**
   * Creates a Dom Element that mirrors this YXmlElement.
   *
   * @param {Document} [_document=document] The document object (you must define
   *                                        this when calling this method in
   *                                        nodejs)
   * @param {Object<string, any>} [hooks={}] Optional property to customize how hooks
   *                                             are presented in the DOM
   * @param {any} [binding] You should not set this property. This is
   *                               used if DomBinding wants to create a
   *                               association to the created DOM type.
   * @return {Node} The {@link https://developer.mozilla.org/en-US/docs/Web/API/Element|Dom Element}
   *
   * @public
   */ toDOM(_document = document, hooks = {}, binding) {
        const dom = _document.createElement(this.nodeName);
        const attrs = this.getAttributes();
        for(const key in attrs){
            const value = attrs[key];
            if (typeof value === "string") dom.setAttribute(key, value);
        }
        $fd9bbcd8ab314c6e$var$typeListForEach(this, (yxml)=>{
            dom.appendChild(yxml.toDOM(_document, hooks, binding));
        });
        if (binding !== undefined) binding._createAssociation(dom, this);
        return dom;
    }
    /**
   * Transform the properties of this type to binary and write it to an
   * BinaryEncoder.
   *
   * This is called when this Item is sent to a remote peer.
   *
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder The encoder to write data to.
   */ _write(encoder) {
        encoder.writeTypeRef($fd9bbcd8ab314c6e$var$YXmlElementRefID);
        encoder.writeKey(this.nodeName);
    }
}
/**
 * @param {UpdateDecoderV1 | UpdateDecoderV2} decoder
 * @return {YXmlElement}
 *
 * @function
 */ const $fd9bbcd8ab314c6e$var$readYXmlElement = (decoder)=>new $fd9bbcd8ab314c6e$export$4db87581d3ca170d(decoder.readKey());
/**
 * @extends YEvent<YXmlElement|YXmlText|YXmlFragment>
 * An Event that describes changes on a YXml Element or Yxml Fragment
 */ class $fd9bbcd8ab314c6e$export$88c9145a0c3b556c extends $fd9bbcd8ab314c6e$export$80fac438977fb51c {
    /**
   * @param {YXmlElement|YXmlText|YXmlFragment} target The target on which the event is created.
   * @param {Set<string|null>} subs The set of changed attributes. `null` is included if the
   *                   child list changed.
   * @param {Transaction} transaction The transaction instance with wich the
   *                                  change was created.
   */ constructor(target, subs, transaction){
        super(target, transaction);
        /**
     * Whether the children changed.
     * @type {Boolean}
     * @private
     */ this.childListChanged = false;
        /**
     * Set of all changed attributes.
     * @type {Set<string>}
     */ this.attributesChanged = new Set();
        subs.forEach((sub)=>{
            if (sub === null) this.childListChanged = true;
            else this.attributesChanged.add(sub);
        });
    }
}
/**
 * You can manage binding to a custom type with YXmlHook.
 *
 * @extends {YMap<any>}
 */ class $fd9bbcd8ab314c6e$export$ec64c1dd5e7a264 extends $fd9bbcd8ab314c6e$export$a5c7b93649eaf8f8 {
    /**
   * @param {string} hookName nodeName of the Dom Node.
   */ constructor(hookName){
        super();
        /**
     * @type {string}
     */ this.hookName = hookName;
    }
    /**
   * Creates an Item with the same effect as this Item (without position effect)
   */ _copy() {
        return new $fd9bbcd8ab314c6e$export$ec64c1dd5e7a264(this.hookName);
    }
    /**
   * Makes a copy of this data type that can be included somewhere else.
   *
   * Note that the content is only readable _after_ it has been included somewhere in the Ydoc.
   *
   * @return {YXmlHook}
   */ clone() {
        const el = new $fd9bbcd8ab314c6e$export$ec64c1dd5e7a264(this.hookName);
        this.forEach((value, key)=>{
            el.set(key, value);
        });
        return el;
    }
    /**
   * Creates a Dom Element that mirrors this YXmlElement.
   *
   * @param {Document} [_document=document] The document object (you must define
   *                                        this when calling this method in
   *                                        nodejs)
   * @param {Object.<string, any>} [hooks] Optional property to customize how hooks
   *                                             are presented in the DOM
   * @param {any} [binding] You should not set this property. This is
   *                               used if DomBinding wants to create a
   *                               association to the created DOM type
   * @return {Element} The {@link https://developer.mozilla.org/en-US/docs/Web/API/Element|Dom Element}
   *
   * @public
   */ toDOM(_document = document, hooks = {}, binding) {
        const hook = hooks[this.hookName];
        let dom;
        if (hook !== undefined) dom = hook.createDom(this);
        else dom = document.createElement(this.hookName);
        dom.setAttribute("data-yjs-hook", this.hookName);
        if (binding !== undefined) binding._createAssociation(dom, this);
        return dom;
    }
    /**
   * Transform the properties of this type to binary and write it to an
   * BinaryEncoder.
   *
   * This is called when this Item is sent to a remote peer.
   *
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder The encoder to write data to.
   */ _write(encoder) {
        encoder.writeTypeRef($fd9bbcd8ab314c6e$var$YXmlHookRefID);
        encoder.writeKey(this.hookName);
    }
}
/**
 * @param {UpdateDecoderV1 | UpdateDecoderV2} decoder
 * @return {YXmlHook}
 *
 * @private
 * @function
 */ const $fd9bbcd8ab314c6e$var$readYXmlHook = (decoder)=>new $fd9bbcd8ab314c6e$export$ec64c1dd5e7a264(decoder.readKey());
/**
 * Represents text in a Dom Element. In the future this type will also handle
 * simple formatting information like bold and italic.
 */ class $fd9bbcd8ab314c6e$export$b35b8f45887823df extends $fd9bbcd8ab314c6e$export$5f1af8db9871e1d6 {
    /**
   * @type {YXmlElement|YXmlText|null}
   */ get nextSibling() {
        const n = this._item ? this._item.next : null;
        return n ? /** @type {YXmlElement|YXmlText} */ /** @type {ContentType} */ n.content.type : null;
    }
    /**
   * @type {YXmlElement|YXmlText|null}
   */ get prevSibling() {
        const n = this._item ? this._item.prev : null;
        return n ? /** @type {YXmlElement|YXmlText} */ /** @type {ContentType} */ n.content.type : null;
    }
    _copy() {
        return new $fd9bbcd8ab314c6e$export$b35b8f45887823df();
    }
    /**
   * Makes a copy of this data type that can be included somewhere else.
   *
   * Note that the content is only readable _after_ it has been included somewhere in the Ydoc.
   *
   * @return {YXmlText}
   */ clone() {
        const text = new $fd9bbcd8ab314c6e$export$b35b8f45887823df();
        text.applyDelta(this.toDelta());
        return text;
    }
    /**
   * Creates a Dom Element that mirrors this YXmlText.
   *
   * @param {Document} [_document=document] The document object (you must define
   *                                        this when calling this method in
   *                                        nodejs)
   * @param {Object<string, any>} [hooks] Optional property to customize how hooks
   *                                             are presented in the DOM
   * @param {any} [binding] You should not set this property. This is
   *                               used if DomBinding wants to create a
   *                               association to the created DOM type.
   * @return {Text} The {@link https://developer.mozilla.org/en-US/docs/Web/API/Element|Dom Element}
   *
   * @public
   */ toDOM(_document = document, hooks, binding) {
        const dom = _document.createTextNode(this.toString());
        if (binding !== undefined) binding._createAssociation(dom, this);
        return dom;
    }
    toString() {
        // @ts-ignore
        return this.toDelta().map((delta)=>{
            const nestedNodes = [];
            for(const nodeName in delta.attributes){
                const attrs = [];
                for(const key in delta.attributes[nodeName])attrs.push({
                    key: key,
                    value: delta.attributes[nodeName][key]
                });
                // sort attributes to get a unique order
                attrs.sort((a, b)=>a.key < b.key ? -1 : 1);
                nestedNodes.push({
                    nodeName: nodeName,
                    attrs: attrs
                });
            }
            // sort node order to get a unique order
            nestedNodes.sort((a, b)=>a.nodeName < b.nodeName ? -1 : 1);
            // now convert to dom string
            let str = "";
            for(let i = 0; i < nestedNodes.length; i++){
                const node = nestedNodes[i];
                str += `<${node.nodeName}`;
                for(let j = 0; j < node.attrs.length; j++){
                    const attr = node.attrs[j];
                    str += ` ${attr.key}="${attr.value}"`;
                }
                str += ">";
            }
            str += delta.insert;
            for(let i = nestedNodes.length - 1; i >= 0; i--)str += `</${nestedNodes[i].nodeName}>`;
            return str;
        }).join("");
    }
    /**
   * @return {string}
   */ toJSON() {
        return this.toString();
    }
    /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   */ _write(encoder) {
        encoder.writeTypeRef($fd9bbcd8ab314c6e$var$YXmlTextRefID);
    }
}
/**
 * @param {UpdateDecoderV1 | UpdateDecoderV2} decoder
 * @return {YXmlText}
 *
 * @private
 * @function
 */ const $fd9bbcd8ab314c6e$var$readYXmlText = (decoder)=>new $fd9bbcd8ab314c6e$export$b35b8f45887823df();
class $fd9bbcd8ab314c6e$export$3cf6f9765c5c3196 {
    /**
   * @param {ID} id
   * @param {number} length
   */ constructor(id, length){
        this.id = id;
        this.length = length;
    }
    /**
   * @type {boolean}
   */ get deleted() {
        throw $lqCPr.methodUnimplemented();
    }
    /**
   * Merge this struct with the item to the right.
   * This method is already assuming that `this.id.clock + this.length === this.id.clock`.
   * Also this method does *not* remove right from StructStore!
   * @param {AbstractStruct} right
   * @return {boolean} wether this merged with right
   */ mergeWith(right) {
        return false;
    }
    /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder The encoder to write data to.
   * @param {number} offset
   * @param {number} encodingRef
   */ write(encoder, offset, encodingRef) {
        throw $lqCPr.methodUnimplemented();
    }
    /**
   * @param {Transaction} transaction
   * @param {number} offset
   */ integrate(transaction, offset) {
        throw $lqCPr.methodUnimplemented();
    }
}
const $fd9bbcd8ab314c6e$var$structGCRefNumber = 0;
/**
 * @private
 */ class $fd9bbcd8ab314c6e$export$12d259ff017e6b58 extends $fd9bbcd8ab314c6e$export$3cf6f9765c5c3196 {
    get deleted() {
        return true;
    }
    delete() {}
    /**
   * @param {GC} right
   * @return {boolean}
   */ mergeWith(right) {
        if (this.constructor !== right.constructor) return false;
        this.length += right.length;
        return true;
    }
    /**
   * @param {Transaction} transaction
   * @param {number} offset
   */ integrate(transaction, offset) {
        if (offset > 0) {
            this.id.clock += offset;
            this.length -= offset;
        }
        $fd9bbcd8ab314c6e$var$addStruct(transaction.doc.store, this);
    }
    /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   * @param {number} offset
   */ write(encoder, offset) {
        encoder.writeInfo($fd9bbcd8ab314c6e$var$structGCRefNumber);
        encoder.writeLen(this.length - offset);
    }
    /**
   * @param {Transaction} transaction
   * @param {StructStore} store
   * @return {null | number}
   */ getMissing(transaction, store) {
        return null;
    }
}
class $fd9bbcd8ab314c6e$export$e8d530cdf62d1cbd {
    /**
   * @param {Uint8Array} content
   */ constructor(content){
        this.content = content;
    }
    /**
   * @return {number}
   */ getLength() {
        return 1;
    }
    /**
   * @return {Array<any>}
   */ getContent() {
        return [
            this.content
        ];
    }
    /**
   * @return {boolean}
   */ isCountable() {
        return true;
    }
    /**
   * @return {ContentBinary}
   */ copy() {
        return new $fd9bbcd8ab314c6e$export$e8d530cdf62d1cbd(this.content);
    }
    /**
   * @param {number} offset
   * @return {ContentBinary}
   */ splice(offset) {
        throw $lqCPr.methodUnimplemented();
    }
    /**
   * @param {ContentBinary} right
   * @return {boolean}
   */ mergeWith(right) {
        return false;
    }
    /**
   * @param {Transaction} transaction
   * @param {Item} item
   */ integrate(transaction, item) {}
    /**
   * @param {Transaction} transaction
   */ delete(transaction) {}
    /**
   * @param {StructStore} store
   */ gc(store) {}
    /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   * @param {number} offset
   */ write(encoder, offset) {
        encoder.writeBuf(this.content);
    }
    /**
   * @return {number}
   */ getRef() {
        return 3;
    }
}
/**
 * @param {UpdateDecoderV1 | UpdateDecoderV2 } decoder
 * @return {ContentBinary}
 */ const $fd9bbcd8ab314c6e$var$readContentBinary = (decoder)=>new $fd9bbcd8ab314c6e$export$e8d530cdf62d1cbd(decoder.readBuf());
class $fd9bbcd8ab314c6e$export$3b06e0b3a2ece602 {
    /**
   * @param {number} len
   */ constructor(len){
        this.len = len;
    }
    /**
   * @return {number}
   */ getLength() {
        return this.len;
    }
    /**
   * @return {Array<any>}
   */ getContent() {
        return [];
    }
    /**
   * @return {boolean}
   */ isCountable() {
        return false;
    }
    /**
   * @return {ContentDeleted}
   */ copy() {
        return new $fd9bbcd8ab314c6e$export$3b06e0b3a2ece602(this.len);
    }
    /**
   * @param {number} offset
   * @return {ContentDeleted}
   */ splice(offset) {
        const right = new $fd9bbcd8ab314c6e$export$3b06e0b3a2ece602(this.len - offset);
        this.len = offset;
        return right;
    }
    /**
   * @param {ContentDeleted} right
   * @return {boolean}
   */ mergeWith(right) {
        this.len += right.len;
        return true;
    }
    /**
   * @param {Transaction} transaction
   * @param {Item} item
   */ integrate(transaction, item) {
        $fd9bbcd8ab314c6e$var$addToDeleteSet(transaction.deleteSet, item.id.client, item.id.clock, this.len);
        item.markDeleted();
    }
    /**
   * @param {Transaction} transaction
   */ delete(transaction) {}
    /**
   * @param {StructStore} store
   */ gc(store) {}
    /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   * @param {number} offset
   */ write(encoder, offset) {
        encoder.writeLen(this.len - offset);
    }
    /**
   * @return {number}
   */ getRef() {
        return 1;
    }
}
/**
 * @private
 *
 * @param {UpdateDecoderV1 | UpdateDecoderV2 } decoder
 * @return {ContentDeleted}
 */ const $fd9bbcd8ab314c6e$var$readContentDeleted = (decoder)=>new $fd9bbcd8ab314c6e$export$3b06e0b3a2ece602(decoder.readLen());
/**
 * @param {string} guid
 * @param {Object<string, any>} opts
 */ const $fd9bbcd8ab314c6e$var$createDocFromOpts = (guid, opts)=>new $fd9bbcd8ab314c6e$export$bceacc74c2212615({
        guid: guid,
        ...opts,
        shouldLoad: opts.shouldLoad || opts.autoLoad || false
    });
/**
 * @private
 */ class $fd9bbcd8ab314c6e$export$b564c0e69572c0e {
    /**
   * @param {Doc} doc
   */ constructor(doc){
        if (doc._item) console.error("This document was already integrated as a sub-document. You should create a second instance instead with the same guid.");
        /**
     * @type {Doc}
     */ this.doc = doc;
        /**
     * @type {any}
     */ const opts = {};
        this.opts = opts;
        if (!doc.gc) opts.gc = false;
        if (doc.autoLoad) opts.autoLoad = true;
        if (doc.meta !== null) opts.meta = doc.meta;
    }
    /**
   * @return {number}
   */ getLength() {
        return 1;
    }
    /**
   * @return {Array<any>}
   */ getContent() {
        return [
            this.doc
        ];
    }
    /**
   * @return {boolean}
   */ isCountable() {
        return true;
    }
    /**
   * @return {ContentDoc}
   */ copy() {
        return new $fd9bbcd8ab314c6e$export$b564c0e69572c0e($fd9bbcd8ab314c6e$var$createDocFromOpts(this.doc.guid, this.opts));
    }
    /**
   * @param {number} offset
   * @return {ContentDoc}
   */ splice(offset) {
        throw $lqCPr.methodUnimplemented();
    }
    /**
   * @param {ContentDoc} right
   * @return {boolean}
   */ mergeWith(right) {
        return false;
    }
    /**
   * @param {Transaction} transaction
   * @param {Item} item
   */ integrate(transaction, item) {
        // this needs to be reflected in doc.destroy as well
        this.doc._item = item;
        transaction.subdocsAdded.add(this.doc);
        if (this.doc.shouldLoad) transaction.subdocsLoaded.add(this.doc);
    }
    /**
   * @param {Transaction} transaction
   */ delete(transaction) {
        if (transaction.subdocsAdded.has(this.doc)) transaction.subdocsAdded.delete(this.doc);
        else transaction.subdocsRemoved.add(this.doc);
    }
    /**
   * @param {StructStore} store
   */ gc(store) {}
    /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   * @param {number} offset
   */ write(encoder, offset) {
        encoder.writeString(this.doc.guid);
        encoder.writeAny(this.opts);
    }
    /**
   * @return {number}
   */ getRef() {
        return 9;
    }
}
/**
 * @private
 *
 * @param {UpdateDecoderV1 | UpdateDecoderV2} decoder
 * @return {ContentDoc}
 */ const $fd9bbcd8ab314c6e$var$readContentDoc = (decoder)=>new $fd9bbcd8ab314c6e$export$b564c0e69572c0e($fd9bbcd8ab314c6e$var$createDocFromOpts(decoder.readString(), decoder.readAny()));
/**
 * @private
 */ class $fd9bbcd8ab314c6e$export$c3787ba7f6086664 {
    /**
   * @param {Object} embed
   */ constructor(embed){
        this.embed = embed;
    }
    /**
   * @return {number}
   */ getLength() {
        return 1;
    }
    /**
   * @return {Array<any>}
   */ getContent() {
        return [
            this.embed
        ];
    }
    /**
   * @return {boolean}
   */ isCountable() {
        return true;
    }
    /**
   * @return {ContentEmbed}
   */ copy() {
        return new $fd9bbcd8ab314c6e$export$c3787ba7f6086664(this.embed);
    }
    /**
   * @param {number} offset
   * @return {ContentEmbed}
   */ splice(offset) {
        throw $lqCPr.methodUnimplemented();
    }
    /**
   * @param {ContentEmbed} right
   * @return {boolean}
   */ mergeWith(right) {
        return false;
    }
    /**
   * @param {Transaction} transaction
   * @param {Item} item
   */ integrate(transaction, item) {}
    /**
   * @param {Transaction} transaction
   */ delete(transaction) {}
    /**
   * @param {StructStore} store
   */ gc(store) {}
    /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   * @param {number} offset
   */ write(encoder, offset) {
        encoder.writeJSON(this.embed);
    }
    /**
   * @return {number}
   */ getRef() {
        return 5;
    }
}
/**
 * @private
 *
 * @param {UpdateDecoderV1 | UpdateDecoderV2} decoder
 * @return {ContentEmbed}
 */ const $fd9bbcd8ab314c6e$var$readContentEmbed = (decoder)=>new $fd9bbcd8ab314c6e$export$c3787ba7f6086664(decoder.readJSON());
/**
 * @private
 */ class $fd9bbcd8ab314c6e$export$3194899188fb5a88 {
    /**
   * @param {string} key
   * @param {Object} value
   */ constructor(key, value){
        this.key = key;
        this.value = value;
    }
    /**
   * @return {number}
   */ getLength() {
        return 1;
    }
    /**
   * @return {Array<any>}
   */ getContent() {
        return [];
    }
    /**
   * @return {boolean}
   */ isCountable() {
        return false;
    }
    /**
   * @return {ContentFormat}
   */ copy() {
        return new $fd9bbcd8ab314c6e$export$3194899188fb5a88(this.key, this.value);
    }
    /**
   * @param {number} _offset
   * @return {ContentFormat}
   */ splice(_offset) {
        throw $lqCPr.methodUnimplemented();
    }
    /**
   * @param {ContentFormat} _right
   * @return {boolean}
   */ mergeWith(_right) {
        return false;
    }
    /**
   * @param {Transaction} _transaction
   * @param {Item} item
   */ integrate(_transaction, item) {
        // @todo searchmarker are currently unsupported for rich text documents
        const p = /** @type {YText} */ item.parent;
        p._searchMarker = null;
        p._hasFormatting = true;
    }
    /**
   * @param {Transaction} transaction
   */ delete(transaction) {}
    /**
   * @param {StructStore} store
   */ gc(store) {}
    /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   * @param {number} offset
   */ write(encoder, offset) {
        encoder.writeKey(this.key);
        encoder.writeJSON(this.value);
    }
    /**
   * @return {number}
   */ getRef() {
        return 6;
    }
}
/**
 * @param {UpdateDecoderV1 | UpdateDecoderV2} decoder
 * @return {ContentFormat}
 */ const $fd9bbcd8ab314c6e$var$readContentFormat = (decoder)=>new $fd9bbcd8ab314c6e$export$3194899188fb5a88(decoder.readKey(), decoder.readJSON());
/**
 * @private
 */ class $fd9bbcd8ab314c6e$export$6a907ea8f733ecf3 {
    /**
   * @param {Array<any>} arr
   */ constructor(arr){
        /**
     * @type {Array<any>}
     */ this.arr = arr;
    }
    /**
   * @return {number}
   */ getLength() {
        return this.arr.length;
    }
    /**
   * @return {Array<any>}
   */ getContent() {
        return this.arr;
    }
    /**
   * @return {boolean}
   */ isCountable() {
        return true;
    }
    /**
   * @return {ContentJSON}
   */ copy() {
        return new $fd9bbcd8ab314c6e$export$6a907ea8f733ecf3(this.arr);
    }
    /**
   * @param {number} offset
   * @return {ContentJSON}
   */ splice(offset) {
        const right = new $fd9bbcd8ab314c6e$export$6a907ea8f733ecf3(this.arr.slice(offset));
        this.arr = this.arr.slice(0, offset);
        return right;
    }
    /**
   * @param {ContentJSON} right
   * @return {boolean}
   */ mergeWith(right) {
        this.arr = this.arr.concat(right.arr);
        return true;
    }
    /**
   * @param {Transaction} transaction
   * @param {Item} item
   */ integrate(transaction, item) {}
    /**
   * @param {Transaction} transaction
   */ delete(transaction) {}
    /**
   * @param {StructStore} store
   */ gc(store) {}
    /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   * @param {number} offset
   */ write(encoder, offset) {
        const len = this.arr.length;
        encoder.writeLen(len - offset);
        for(let i = offset; i < len; i++){
            const c = this.arr[i];
            encoder.writeString(c === undefined ? "undefined" : JSON.stringify(c));
        }
    }
    /**
   * @return {number}
   */ getRef() {
        return 2;
    }
}
/**
 * @private
 *
 * @param {UpdateDecoderV1 | UpdateDecoderV2} decoder
 * @return {ContentJSON}
 */ const $fd9bbcd8ab314c6e$var$readContentJSON = (decoder)=>{
    const len = decoder.readLen();
    const cs = [];
    for(let i = 0; i < len; i++){
        const c = decoder.readString();
        if (c === "undefined") cs.push(undefined);
        else cs.push(JSON.parse(c));
    }
    return new $fd9bbcd8ab314c6e$export$6a907ea8f733ecf3(cs);
};
const $fd9bbcd8ab314c6e$var$isDevMode = $3LZef.getVariable("node_env") === "development";
class $fd9bbcd8ab314c6e$export$1d788b93bbb631a0 {
    /**
   * @param {Array<any>} arr
   */ constructor(arr){
        /**
     * @type {Array<any>}
     */ this.arr = arr;
        $fd9bbcd8ab314c6e$var$isDevMode && $8u9N6.deepFreeze(arr);
    }
    /**
   * @return {number}
   */ getLength() {
        return this.arr.length;
    }
    /**
   * @return {Array<any>}
   */ getContent() {
        return this.arr;
    }
    /**
   * @return {boolean}
   */ isCountable() {
        return true;
    }
    /**
   * @return {ContentAny}
   */ copy() {
        return new $fd9bbcd8ab314c6e$export$1d788b93bbb631a0(this.arr);
    }
    /**
   * @param {number} offset
   * @return {ContentAny}
   */ splice(offset) {
        const right = new $fd9bbcd8ab314c6e$export$1d788b93bbb631a0(this.arr.slice(offset));
        this.arr = this.arr.slice(0, offset);
        return right;
    }
    /**
   * @param {ContentAny} right
   * @return {boolean}
   */ mergeWith(right) {
        this.arr = this.arr.concat(right.arr);
        return true;
    }
    /**
   * @param {Transaction} transaction
   * @param {Item} item
   */ integrate(transaction, item) {}
    /**
   * @param {Transaction} transaction
   */ delete(transaction) {}
    /**
   * @param {StructStore} store
   */ gc(store) {}
    /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   * @param {number} offset
   */ write(encoder, offset) {
        const len = this.arr.length;
        encoder.writeLen(len - offset);
        for(let i = offset; i < len; i++){
            const c = this.arr[i];
            encoder.writeAny(c);
        }
    }
    /**
   * @return {number}
   */ getRef() {
        return 8;
    }
}
/**
 * @param {UpdateDecoderV1 | UpdateDecoderV2} decoder
 * @return {ContentAny}
 */ const $fd9bbcd8ab314c6e$var$readContentAny = (decoder)=>{
    const len = decoder.readLen();
    const cs = [];
    for(let i = 0; i < len; i++)cs.push(decoder.readAny());
    return new $fd9bbcd8ab314c6e$export$1d788b93bbb631a0(cs);
};
/**
 * @private
 */ class $fd9bbcd8ab314c6e$export$ee670b2cf091bbb6 {
    /**
   * @param {string} str
   */ constructor(str){
        /**
     * @type {string}
     */ this.str = str;
    }
    /**
   * @return {number}
   */ getLength() {
        return this.str.length;
    }
    /**
   * @return {Array<any>}
   */ getContent() {
        return this.str.split("");
    }
    /**
   * @return {boolean}
   */ isCountable() {
        return true;
    }
    /**
   * @return {ContentString}
   */ copy() {
        return new $fd9bbcd8ab314c6e$export$ee670b2cf091bbb6(this.str);
    }
    /**
   * @param {number} offset
   * @return {ContentString}
   */ splice(offset) {
        const right = new $fd9bbcd8ab314c6e$export$ee670b2cf091bbb6(this.str.slice(offset));
        this.str = this.str.slice(0, offset);
        // Prevent encoding invalid documents because of splitting of surrogate pairs: https://github.com/yjs/yjs/issues/248
        const firstCharCode = this.str.charCodeAt(offset - 1);
        if (firstCharCode >= 0xD800 && firstCharCode <= 0xDBFF) {
            // Last character of the left split is the start of a surrogate utf16/ucs2 pair.
            // We don't support splitting of surrogate pairs because this may lead to invalid documents.
            // Replace the invalid character with a unicode replacement character (� / U+FFFD)
            this.str = this.str.slice(0, offset - 1) + "\uFFFD";
            // replace right as well
            right.str = "\uFFFD" + right.str.slice(1);
        }
        return right;
    }
    /**
   * @param {ContentString} right
   * @return {boolean}
   */ mergeWith(right) {
        this.str += right.str;
        return true;
    }
    /**
   * @param {Transaction} transaction
   * @param {Item} item
   */ integrate(transaction, item) {}
    /**
   * @param {Transaction} transaction
   */ delete(transaction) {}
    /**
   * @param {StructStore} store
   */ gc(store) {}
    /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   * @param {number} offset
   */ write(encoder, offset) {
        encoder.writeString(offset === 0 ? this.str : this.str.slice(offset));
    }
    /**
   * @return {number}
   */ getRef() {
        return 4;
    }
}
/**
 * @private
 *
 * @param {UpdateDecoderV1 | UpdateDecoderV2} decoder
 * @return {ContentString}
 */ const $fd9bbcd8ab314c6e$var$readContentString = (decoder)=>new $fd9bbcd8ab314c6e$export$ee670b2cf091bbb6(decoder.readString());
/**
 * @type {Array<function(UpdateDecoderV1 | UpdateDecoderV2):AbstractType<any>>}
 * @private
 */ const $fd9bbcd8ab314c6e$var$typeRefs = [
    $fd9bbcd8ab314c6e$var$readYArray,
    $fd9bbcd8ab314c6e$var$readYMap,
    $fd9bbcd8ab314c6e$var$readYText,
    $fd9bbcd8ab314c6e$var$readYXmlElement,
    $fd9bbcd8ab314c6e$var$readYXmlFragment,
    $fd9bbcd8ab314c6e$var$readYXmlHook,
    $fd9bbcd8ab314c6e$var$readYXmlText
];
const $fd9bbcd8ab314c6e$var$YArrayRefID = 0;
const $fd9bbcd8ab314c6e$var$YMapRefID = 1;
const $fd9bbcd8ab314c6e$var$YTextRefID = 2;
const $fd9bbcd8ab314c6e$var$YXmlElementRefID = 3;
const $fd9bbcd8ab314c6e$var$YXmlFragmentRefID = 4;
const $fd9bbcd8ab314c6e$var$YXmlHookRefID = 5;
const $fd9bbcd8ab314c6e$var$YXmlTextRefID = 6;
/**
 * @private
 */ class $fd9bbcd8ab314c6e$export$e2e108cbe2e4f865 {
    /**
   * @param {AbstractType<any>} type
   */ constructor(type){
        /**
     * @type {AbstractType<any>}
     */ this.type = type;
    }
    /**
   * @return {number}
   */ getLength() {
        return 1;
    }
    /**
   * @return {Array<any>}
   */ getContent() {
        return [
            this.type
        ];
    }
    /**
   * @return {boolean}
   */ isCountable() {
        return true;
    }
    /**
   * @return {ContentType}
   */ copy() {
        return new $fd9bbcd8ab314c6e$export$e2e108cbe2e4f865(this.type._copy());
    }
    /**
   * @param {number} offset
   * @return {ContentType}
   */ splice(offset) {
        throw $lqCPr.methodUnimplemented();
    }
    /**
   * @param {ContentType} right
   * @return {boolean}
   */ mergeWith(right) {
        return false;
    }
    /**
   * @param {Transaction} transaction
   * @param {Item} item
   */ integrate(transaction, item) {
        this.type._integrate(transaction.doc, item);
    }
    /**
   * @param {Transaction} transaction
   */ delete(transaction) {
        let item = this.type._start;
        while(item !== null){
            if (!item.deleted) item.delete(transaction);
            else if (item.id.clock < (transaction.beforeState.get(item.id.client) || 0)) // This will be gc'd later and we want to merge it if possible
            // We try to merge all deleted items after each transaction,
            // but we have no knowledge about that this needs to be merged
            // since it is not in transaction.ds. Hence we add it to transaction._mergeStructs
            transaction._mergeStructs.push(item);
            item = item.right;
        }
        this.type._map.forEach((item)=>{
            if (!item.deleted) item.delete(transaction);
            else if (item.id.clock < (transaction.beforeState.get(item.id.client) || 0)) // same as above
            transaction._mergeStructs.push(item);
        });
        transaction.changed.delete(this.type);
    }
    /**
   * @param {StructStore} store
   */ gc(store) {
        let item = this.type._start;
        while(item !== null){
            item.gc(store, true);
            item = item.right;
        }
        this.type._start = null;
        this.type._map.forEach(/** @param {Item | null} item */ (item)=>{
            while(item !== null){
                item.gc(store, true);
                item = item.left;
            }
        });
        this.type._map = new Map();
    }
    /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   * @param {number} offset
   */ write(encoder, offset) {
        this.type._write(encoder);
    }
    /**
   * @return {number}
   */ getRef() {
        return 7;
    }
}
/**
 * @private
 *
 * @param {UpdateDecoderV1 | UpdateDecoderV2} decoder
 * @return {ContentType}
 */ const $fd9bbcd8ab314c6e$var$readContentType = (decoder)=>new $fd9bbcd8ab314c6e$export$e2e108cbe2e4f865($fd9bbcd8ab314c6e$var$typeRefs[decoder.readTypeRef()](decoder));
/**
 * @todo This should return several items
 *
 * @param {StructStore} store
 * @param {ID} id
 * @return {{item:Item, diff:number}}
 */ const $fd9bbcd8ab314c6e$var$followRedone = (store, id)=>{
    /**
   * @type {ID|null}
   */ let nextID = id;
    let diff = 0;
    let item;
    do {
        if (diff > 0) nextID = $fd9bbcd8ab314c6e$export$6c7d4e6171d008d0(nextID.client, nextID.clock + diff);
        item = $fd9bbcd8ab314c6e$export$f92dfeb71e9bb569(store, nextID);
        diff = nextID.clock - item.id.clock;
        nextID = item.redone;
    }while (nextID !== null && item instanceof $fd9bbcd8ab314c6e$export$6d08773d2e66f8f2);
    return {
        item: item,
        diff: diff
    };
};
/**
 * Make sure that neither item nor any of its parents is ever deleted.
 *
 * This property does not persist when storing it into a database or when
 * sending it to other peers
 *
 * @param {Item|null} item
 * @param {boolean} keep
 */ const $fd9bbcd8ab314c6e$var$keepItem = (item, keep)=>{
    while(item !== null && item.keep !== keep){
        item.keep = keep;
        item = /** @type {AbstractType<any>} */ item.parent._item;
    }
};
/**
 * Split leftItem into two items
 * @param {Transaction} transaction
 * @param {Item} leftItem
 * @param {number} diff
 * @return {Item}
 *
 * @function
 * @private
 */ const $fd9bbcd8ab314c6e$var$splitItem = (transaction, leftItem, diff)=>{
    // create rightItem
    const { client: client, clock: clock } = leftItem.id;
    const rightItem = new $fd9bbcd8ab314c6e$export$6d08773d2e66f8f2($fd9bbcd8ab314c6e$export$6c7d4e6171d008d0(client, clock + diff), leftItem, $fd9bbcd8ab314c6e$export$6c7d4e6171d008d0(client, clock + diff - 1), leftItem.right, leftItem.rightOrigin, leftItem.parent, leftItem.parentSub, leftItem.content.splice(diff));
    if (leftItem.deleted) rightItem.markDeleted();
    if (leftItem.keep) rightItem.keep = true;
    if (leftItem.redone !== null) rightItem.redone = $fd9bbcd8ab314c6e$export$6c7d4e6171d008d0(leftItem.redone.client, leftItem.redone.clock + diff);
    // update left (do not set leftItem.rightOrigin as it will lead to problems when syncing)
    leftItem.right = rightItem;
    // update right
    if (rightItem.right !== null) rightItem.right.left = rightItem;
    // right is more specific.
    transaction._mergeStructs.push(rightItem);
    // update parent._map
    if (rightItem.parentSub !== null && rightItem.right === null) /** @type {AbstractType<any>} */ rightItem.parent._map.set(rightItem.parentSub, rightItem);
    leftItem.length = diff;
    return rightItem;
};
/**
 * @param {Array<StackItem>} stack
 * @param {ID} id
 */ const $fd9bbcd8ab314c6e$var$isDeletedByUndoStack = (stack, id)=>$8aHnL.some(stack, /** @param {StackItem} s */ (s)=>$fd9bbcd8ab314c6e$export$dcb04af092e44fde(s.deletions, id));
/**
 * Redoes the effect of this operation.
 *
 * @param {Transaction} transaction The Yjs instance.
 * @param {Item} item
 * @param {Set<Item>} redoitems
 * @param {DeleteSet} itemsToDelete
 * @param {boolean} ignoreRemoteMapChanges
 * @param {import('../utils/UndoManager.js').UndoManager} um
 *
 * @return {Item|null}
 *
 * @private
 */ const $fd9bbcd8ab314c6e$var$redoItem = (transaction, item, redoitems, itemsToDelete, ignoreRemoteMapChanges, um)=>{
    const doc = transaction.doc;
    const store = doc.store;
    const ownClientID = doc.clientID;
    const redone = item.redone;
    if (redone !== null) return $fd9bbcd8ab314c6e$var$getItemCleanStart(transaction, redone);
    let parentItem = /** @type {AbstractType<any>} */ item.parent._item;
    /**
   * @type {Item|null}
   */ let left = null;
    /**
   * @type {Item|null}
   */ let right;
    // make sure that parent is redone
    if (parentItem !== null && parentItem.deleted === true) {
        // try to undo parent if it will be undone anyway
        if (parentItem.redone === null && (!redoitems.has(parentItem) || $fd9bbcd8ab314c6e$var$redoItem(transaction, parentItem, redoitems, itemsToDelete, ignoreRemoteMapChanges, um) === null)) return null;
        while(parentItem.redone !== null)parentItem = $fd9bbcd8ab314c6e$var$getItemCleanStart(transaction, parentItem.redone);
    }
    const parentType = parentItem === null ? /** @type {AbstractType<any>} */ item.parent : /** @type {ContentType} */ parentItem.content.type;
    if (item.parentSub === null) {
        // Is an array item. Insert at the old position
        left = item.left;
        right = item;
        // find next cloned_redo items
        while(left !== null){
            /**
       * @type {Item|null}
       */ let leftTrace = left;
            // trace redone until parent matches
            while(leftTrace !== null && /** @type {AbstractType<any>} */ leftTrace.parent._item !== parentItem)leftTrace = leftTrace.redone === null ? null : $fd9bbcd8ab314c6e$var$getItemCleanStart(transaction, leftTrace.redone);
            if (leftTrace !== null && /** @type {AbstractType<any>} */ leftTrace.parent._item === parentItem) {
                left = leftTrace;
                break;
            }
            left = left.left;
        }
        while(right !== null){
            /**
       * @type {Item|null}
       */ let rightTrace = right;
            // trace redone until parent matches
            while(rightTrace !== null && /** @type {AbstractType<any>} */ rightTrace.parent._item !== parentItem)rightTrace = rightTrace.redone === null ? null : $fd9bbcd8ab314c6e$var$getItemCleanStart(transaction, rightTrace.redone);
            if (rightTrace !== null && /** @type {AbstractType<any>} */ rightTrace.parent._item === parentItem) {
                right = rightTrace;
                break;
            }
            right = right.right;
        }
    } else {
        right = null;
        if (item.right && !ignoreRemoteMapChanges) {
            left = item;
            // Iterate right while right is in itemsToDelete
            // If it is intended to delete right while item is redone, we can expect that item should replace right.
            while(left !== null && left.right !== null && (left.right.redone || $fd9bbcd8ab314c6e$export$dcb04af092e44fde(itemsToDelete, left.right.id) || $fd9bbcd8ab314c6e$var$isDeletedByUndoStack(um.undoStack, left.right.id) || $fd9bbcd8ab314c6e$var$isDeletedByUndoStack(um.redoStack, left.right.id))){
                left = left.right;
                // follow redone
                while(left.redone)left = $fd9bbcd8ab314c6e$var$getItemCleanStart(transaction, left.redone);
            }
            if (left && left.right !== null) // It is not possible to redo this item because it conflicts with a
            // change from another client
            return null;
        } else left = parentType._map.get(item.parentSub) || null;
    }
    const nextClock = $fd9bbcd8ab314c6e$export$50fdfeece43146fd(store, ownClientID);
    const nextId = $fd9bbcd8ab314c6e$export$6c7d4e6171d008d0(ownClientID, nextClock);
    const redoneItem = new $fd9bbcd8ab314c6e$export$6d08773d2e66f8f2(nextId, left, left && left.lastId, right, right && right.id, parentType, item.parentSub, item.content.copy());
    item.redone = nextId;
    $fd9bbcd8ab314c6e$var$keepItem(redoneItem, true);
    redoneItem.integrate(transaction, 0);
    return redoneItem;
};
/**
 * Abstract class that represents any content.
 */ class $fd9bbcd8ab314c6e$export$6d08773d2e66f8f2 extends $fd9bbcd8ab314c6e$export$3cf6f9765c5c3196 {
    /**
   * @param {ID} id
   * @param {Item | null} left
   * @param {ID | null} origin
   * @param {Item | null} right
   * @param {ID | null} rightOrigin
   * @param {AbstractType<any>|ID|null} parent Is a type if integrated, is null if it is possible to copy parent from left or right, is ID before integration to search for it.
   * @param {string | null} parentSub
   * @param {AbstractContent} content
   */ constructor(id, left, origin, right, rightOrigin, parent, parentSub, content){
        super(id, content.getLength());
        /**
     * The item that was originally to the left of this item.
     * @type {ID | null}
     */ this.origin = origin;
        /**
     * The item that is currently to the left of this item.
     * @type {Item | null}
     */ this.left = left;
        /**
     * The item that is currently to the right of this item.
     * @type {Item | null}
     */ this.right = right;
        /**
     * The item that was originally to the right of this item.
     * @type {ID | null}
     */ this.rightOrigin = rightOrigin;
        /**
     * @type {AbstractType<any>|ID|null}
     */ this.parent = parent;
        /**
     * If the parent refers to this item with some kind of key (e.g. YMap, the
     * key is specified here. The key is then used to refer to the list in which
     * to insert this item. If `parentSub = null` type._start is the list in
     * which to insert to. Otherwise it is `parent._map`.
     * @type {String | null}
     */ this.parentSub = parentSub;
        /**
     * If this type's effect is redone this type refers to the type that undid
     * this operation.
     * @type {ID | null}
     */ this.redone = null;
        /**
     * @type {AbstractContent}
     */ this.content = content;
        /**
     * bit1: keep
     * bit2: countable
     * bit3: deleted
     * bit4: mark - mark node as fast-search-marker
     * @type {number} byte
     */ this.info = this.content.isCountable() ? $jnoaM.BIT2 : 0;
    }
    /**
   * This is used to mark the item as an indexed fast-search marker
   *
   * @type {boolean}
   */ set marker(isMarked) {
        if ((this.info & $jnoaM.BIT4) > 0 !== isMarked) this.info ^= $jnoaM.BIT4;
    }
    get marker() {
        return (this.info & $jnoaM.BIT4) > 0;
    }
    /**
   * If true, do not garbage collect this Item.
   */ get keep() {
        return (this.info & $jnoaM.BIT1) > 0;
    }
    set keep(doKeep) {
        if (this.keep !== doKeep) this.info ^= $jnoaM.BIT1;
    }
    get countable() {
        return (this.info & $jnoaM.BIT2) > 0;
    }
    /**
   * Whether this item was deleted or not.
   * @type {Boolean}
   */ get deleted() {
        return (this.info & $jnoaM.BIT3) > 0;
    }
    set deleted(doDelete) {
        if (this.deleted !== doDelete) this.info ^= $jnoaM.BIT3;
    }
    markDeleted() {
        this.info |= $jnoaM.BIT3;
    }
    /**
   * Return the creator clientID of the missing op or define missing items and return null.
   *
   * @param {Transaction} transaction
   * @param {StructStore} store
   * @return {null | number}
   */ getMissing(transaction, store) {
        if (this.origin && this.origin.client !== this.id.client && this.origin.clock >= $fd9bbcd8ab314c6e$export$50fdfeece43146fd(store, this.origin.client)) return this.origin.client;
        if (this.rightOrigin && this.rightOrigin.client !== this.id.client && this.rightOrigin.clock >= $fd9bbcd8ab314c6e$export$50fdfeece43146fd(store, this.rightOrigin.client)) return this.rightOrigin.client;
        if (this.parent && this.parent.constructor === $fd9bbcd8ab314c6e$export$8be180ec26319f9f && this.id.client !== this.parent.client && this.parent.clock >= $fd9bbcd8ab314c6e$export$50fdfeece43146fd(store, this.parent.client)) return this.parent.client;
        // We have all missing ids, now find the items
        if (this.origin) {
            this.left = $fd9bbcd8ab314c6e$var$getItemCleanEnd(transaction, store, this.origin);
            this.origin = this.left.lastId;
        }
        if (this.rightOrigin) {
            this.right = $fd9bbcd8ab314c6e$var$getItemCleanStart(transaction, this.rightOrigin);
            this.rightOrigin = this.right.id;
        }
        if (this.left && this.left.constructor === $fd9bbcd8ab314c6e$export$12d259ff017e6b58 || this.right && this.right.constructor === $fd9bbcd8ab314c6e$export$12d259ff017e6b58) this.parent = null;
        else if (!this.parent) {
            // only set parent if this shouldn't be garbage collected
            if (this.left && this.left.constructor === $fd9bbcd8ab314c6e$export$6d08773d2e66f8f2) {
                this.parent = this.left.parent;
                this.parentSub = this.left.parentSub;
            }
            if (this.right && this.right.constructor === $fd9bbcd8ab314c6e$export$6d08773d2e66f8f2) {
                this.parent = this.right.parent;
                this.parentSub = this.right.parentSub;
            }
        } else if (this.parent.constructor === $fd9bbcd8ab314c6e$export$8be180ec26319f9f) {
            const parentItem = $fd9bbcd8ab314c6e$export$f92dfeb71e9bb569(store, this.parent);
            if (parentItem.constructor === $fd9bbcd8ab314c6e$export$12d259ff017e6b58) this.parent = null;
            else this.parent = /** @type {ContentType} */ parentItem.content.type;
        }
        return null;
    }
    /**
   * @param {Transaction} transaction
   * @param {number} offset
   */ integrate(transaction, offset) {
        if (offset > 0) {
            this.id.clock += offset;
            this.left = $fd9bbcd8ab314c6e$var$getItemCleanEnd(transaction, transaction.doc.store, $fd9bbcd8ab314c6e$export$6c7d4e6171d008d0(this.id.client, this.id.clock - 1));
            this.origin = this.left.lastId;
            this.content = this.content.splice(offset);
            this.length -= offset;
        }
        if (this.parent) {
            if (!this.left && (!this.right || this.right.left !== null) || this.left && this.left.right !== this.right) {
                /**
         * @type {Item|null}
         */ let left = this.left;
                /**
         * @type {Item|null}
         */ let o;
                // set o to the first conflicting item
                if (left !== null) o = left.right;
                else if (this.parentSub !== null) {
                    o = /** @type {AbstractType<any>} */ this.parent._map.get(this.parentSub) || null;
                    while(o !== null && o.left !== null)o = o.left;
                } else o = /** @type {AbstractType<any>} */ this.parent._start;
                // TODO: use something like DeleteSet here (a tree implementation would be best)
                // @todo use global set definitions
                /**
         * @type {Set<Item>}
         */ const conflictingItems = new Set();
                /**
         * @type {Set<Item>}
         */ const itemsBeforeOrigin = new Set();
                // Let c in conflictingItems, b in itemsBeforeOrigin
                // ***{origin}bbbb{this}{c,b}{c,b}{o}***
                // Note that conflictingItems is a subset of itemsBeforeOrigin
                while(o !== null && o !== this.right){
                    itemsBeforeOrigin.add(o);
                    conflictingItems.add(o);
                    if ($fd9bbcd8ab314c6e$export$c0af976e7e459c02(this.origin, o.origin)) {
                        // case 1
                        if (o.id.client < this.id.client) {
                            left = o;
                            conflictingItems.clear();
                        } else if ($fd9bbcd8ab314c6e$export$c0af976e7e459c02(this.rightOrigin, o.rightOrigin)) break;
                         // else, o might be integrated before an item that this conflicts with. If so, we will find it in the next iterations
                    } else if (o.origin !== null && itemsBeforeOrigin.has($fd9bbcd8ab314c6e$export$f92dfeb71e9bb569(transaction.doc.store, o.origin))) // case 2
                    {
                        if (!conflictingItems.has($fd9bbcd8ab314c6e$export$f92dfeb71e9bb569(transaction.doc.store, o.origin))) {
                            left = o;
                            conflictingItems.clear();
                        }
                    } else break;
                    o = o.right;
                }
                this.left = left;
            }
            // reconnect left/right + update parent map/start if necessary
            if (this.left !== null) {
                const right = this.left.right;
                this.right = right;
                this.left.right = this;
            } else {
                let r;
                if (this.parentSub !== null) {
                    r = /** @type {AbstractType<any>} */ this.parent._map.get(this.parentSub) || null;
                    while(r !== null && r.left !== null)r = r.left;
                } else {
                    r = /** @type {AbstractType<any>} */ this.parent._start; /** @type {AbstractType<any>} */ 
                    this.parent._start = this;
                }
                this.right = r;
            }
            if (this.right !== null) this.right.left = this;
            else if (this.parentSub !== null) {
                // set as current parent value if right === null and this is parentSub
                /** @type {AbstractType<any>} */ this.parent._map.set(this.parentSub, this);
                if (this.left !== null) // this is the current attribute value of parent. delete right
                this.left.delete(transaction);
            }
            // adjust length of parent
            if (this.parentSub === null && this.countable && !this.deleted) /** @type {AbstractType<any>} */ this.parent._length += this.length;
            $fd9bbcd8ab314c6e$var$addStruct(transaction.doc.store, this);
            this.content.integrate(transaction, this);
            // add parent to transaction.changed
            $fd9bbcd8ab314c6e$var$addChangedTypeToTransaction(transaction, /** @type {AbstractType<any>} */ this.parent, this.parentSub);
            if (/** @type {AbstractType<any>} */ this.parent._item !== null && /** @type {AbstractType<any>} */ this.parent._item.deleted || this.parentSub !== null && this.right !== null) // delete if parent is deleted or if this is not the current attribute value of parent
            this.delete(transaction);
        } else // parent is not defined. Integrate GC struct instead
        new $fd9bbcd8ab314c6e$export$12d259ff017e6b58(this.id, this.length).integrate(transaction, 0);
    }
    /**
   * Returns the next non-deleted item
   */ get next() {
        let n = this.right;
        while(n !== null && n.deleted)n = n.right;
        return n;
    }
    /**
   * Returns the previous non-deleted item
   */ get prev() {
        let n = this.left;
        while(n !== null && n.deleted)n = n.left;
        return n;
    }
    /**
   * Computes the last content address of this Item.
   */ get lastId() {
        // allocating ids is pretty costly because of the amount of ids created, so we try to reuse whenever possible
        return this.length === 1 ? this.id : $fd9bbcd8ab314c6e$export$6c7d4e6171d008d0(this.id.client, this.id.clock + this.length - 1);
    }
    /**
   * Try to merge two items
   *
   * @param {Item} right
   * @return {boolean}
   */ mergeWith(right) {
        if (this.constructor === right.constructor && $fd9bbcd8ab314c6e$export$c0af976e7e459c02(right.origin, this.lastId) && this.right === right && $fd9bbcd8ab314c6e$export$c0af976e7e459c02(this.rightOrigin, right.rightOrigin) && this.id.client === right.id.client && this.id.clock + this.length === right.id.clock && this.deleted === right.deleted && this.redone === null && right.redone === null && this.content.constructor === right.content.constructor && this.content.mergeWith(right.content)) {
            const searchMarker = /** @type {AbstractType<any>} */ this.parent._searchMarker;
            if (searchMarker) searchMarker.forEach((marker)=>{
                if (marker.p === right) {
                    // right is going to be "forgotten" so we need to update the marker
                    marker.p = this;
                    // adjust marker index
                    if (!this.deleted && this.countable) marker.index -= this.length;
                }
            });
            if (right.keep) this.keep = true;
            this.right = right.right;
            if (this.right !== null) this.right.left = this;
            this.length += right.length;
            return true;
        }
        return false;
    }
    /**
   * Mark this Item as deleted.
   *
   * @param {Transaction} transaction
   */ delete(transaction) {
        if (!this.deleted) {
            const parent = /** @type {AbstractType<any>} */ this.parent;
            // adjust the length of parent
            if (this.countable && this.parentSub === null) parent._length -= this.length;
            this.markDeleted();
            $fd9bbcd8ab314c6e$var$addToDeleteSet(transaction.deleteSet, this.id.client, this.id.clock, this.length);
            $fd9bbcd8ab314c6e$var$addChangedTypeToTransaction(transaction, parent, this.parentSub);
            this.content.delete(transaction);
        }
    }
    /**
   * @param {StructStore} store
   * @param {boolean} parentGCd
   */ gc(store, parentGCd) {
        if (!this.deleted) throw $lqCPr.unexpectedCase();
        this.content.gc(store);
        if (parentGCd) $fd9bbcd8ab314c6e$var$replaceStruct(store, this, new $fd9bbcd8ab314c6e$export$12d259ff017e6b58(this.id, this.length));
        else this.content = new $fd9bbcd8ab314c6e$export$3b06e0b3a2ece602(this.length);
    }
    /**
   * Transform the properties of this type to binary and write it to an
   * BinaryEncoder.
   *
   * This is called when this Item is sent to a remote peer.
   *
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder The encoder to write data to.
   * @param {number} offset
   */ write(encoder, offset) {
        const origin = offset > 0 ? $fd9bbcd8ab314c6e$export$6c7d4e6171d008d0(this.id.client, this.id.clock + offset - 1) : this.origin;
        const rightOrigin = this.rightOrigin;
        const parentSub = this.parentSub;
        const info = this.content.getRef() & $jnoaM.BITS5 | (origin === null ? 0 : $jnoaM.BIT8) | // origin is defined
        (rightOrigin === null ? 0 : $jnoaM.BIT7) | // right origin is defined
        (parentSub === null ? 0 : $jnoaM.BIT6); // parentSub is non-null
        encoder.writeInfo(info);
        if (origin !== null) encoder.writeLeftID(origin);
        if (rightOrigin !== null) encoder.writeRightID(rightOrigin);
        if (origin === null && rightOrigin === null) {
            const parent = /** @type {AbstractType<any>} */ this.parent;
            if (parent._item !== undefined) {
                const parentItem = parent._item;
                if (parentItem === null) {
                    // parent type on y._map
                    // find the correct key
                    const ykey = $fd9bbcd8ab314c6e$export$e726a40920d54663(parent);
                    encoder.writeParentInfo(true); // write parentYKey
                    encoder.writeString(ykey);
                } else {
                    encoder.writeParentInfo(false); // write parent id
                    encoder.writeLeftID(parentItem.id);
                }
            } else if (parent.constructor === String) {
                encoder.writeParentInfo(true); // write parentYKey
                encoder.writeString(parent);
            } else if (parent.constructor === $fd9bbcd8ab314c6e$export$8be180ec26319f9f) {
                encoder.writeParentInfo(false); // write parent id
                encoder.writeLeftID(parent);
            } else $lqCPr.unexpectedCase();
            if (parentSub !== null) encoder.writeString(parentSub);
        }
        this.content.write(encoder, offset);
    }
}
/**
 * @param {UpdateDecoderV1 | UpdateDecoderV2} decoder
 * @param {number} info
 */ const $fd9bbcd8ab314c6e$var$readItemContent = (decoder, info)=>$fd9bbcd8ab314c6e$var$contentRefs[info & $jnoaM.BITS5](decoder);
/**
 * A lookup map for reading Item content.
 *
 * @type {Array<function(UpdateDecoderV1 | UpdateDecoderV2):AbstractContent>}
 */ const $fd9bbcd8ab314c6e$var$contentRefs = [
    ()=>{
        $lqCPr.unexpectedCase();
    },
    $fd9bbcd8ab314c6e$var$readContentDeleted,
    $fd9bbcd8ab314c6e$var$readContentJSON,
    $fd9bbcd8ab314c6e$var$readContentBinary,
    $fd9bbcd8ab314c6e$var$readContentString,
    $fd9bbcd8ab314c6e$var$readContentEmbed,
    $fd9bbcd8ab314c6e$var$readContentFormat,
    $fd9bbcd8ab314c6e$var$readContentType,
    $fd9bbcd8ab314c6e$var$readContentAny,
    $fd9bbcd8ab314c6e$var$readContentDoc,
    ()=>{
        $lqCPr.unexpectedCase();
    } // 10 - Skip is not ItemContent
];
const $fd9bbcd8ab314c6e$var$structSkipRefNumber = 10;
/**
 * @private
 */ class $fd9bbcd8ab314c6e$export$38d24f5c1eb0e4c0 extends $fd9bbcd8ab314c6e$export$3cf6f9765c5c3196 {
    get deleted() {
        return true;
    }
    delete() {}
    /**
   * @param {Skip} right
   * @return {boolean}
   */ mergeWith(right) {
        if (this.constructor !== right.constructor) return false;
        this.length += right.length;
        return true;
    }
    /**
   * @param {Transaction} transaction
   * @param {number} offset
   */ integrate(transaction, offset) {
        // skip structs cannot be integrated
        $lqCPr.unexpectedCase();
    }
    /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   * @param {number} offset
   */ write(encoder, offset) {
        encoder.writeInfo($fd9bbcd8ab314c6e$var$structSkipRefNumber);
        // write as VarUint because Skips can't make use of predictable length-encoding
        $apPNa.writeVarUint(encoder.restEncoder, this.length - offset);
    }
    /**
   * @param {Transaction} transaction
   * @param {StructStore} store
   * @return {null | number}
   */ getMissing(transaction, store) {
        return null;
    }
}
/** eslint-env browser */ const $fd9bbcd8ab314c6e$var$glo = /** @type {any} */ typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : {};
const $fd9bbcd8ab314c6e$var$importIdentifier = "__ $YJS$ __";
if ($fd9bbcd8ab314c6e$var$glo[$fd9bbcd8ab314c6e$var$importIdentifier] === true) /**
   * Dear reader of this message. Please take this seriously.
   *
   * If you see this message, make sure that you only import one version of Yjs. In many cases,
   * your package manager installs two versions of Yjs that are used by different packages within your project.
   * Another reason for this message is that some parts of your project use the commonjs version of Yjs
   * and others use the EcmaScript version of Yjs.
   *
   * This often leads to issues that are hard to debug. We often need to perform constructor checks,
   * e.g. `struct instanceof GC`. If you imported different versions of Yjs, it is impossible for us to
   * do the constructor checks anymore - which might break the CRDT algorithm.
   *
   * https://github.com/yjs/yjs/issues/438
   */ console.error("Yjs was already imported. This breaks constructor checks and will lead to issues! - https://github.com/yjs/yjs/issues/438");
$fd9bbcd8ab314c6e$var$glo[$fd9bbcd8ab314c6e$var$importIdentifier] = true;

});
parcelRegister("jFoCq", function(module, exports) {

$parcel$export(module.exports, "ObservableV2", function () { return $e514f169b2909e51$export$e23d3436ce401adc; });
/**
 * Observable class prototype.
 *
 * @module observable
 */ 
var $2U6oo = parcelRequire("2U6oo");

var $eq375 = parcelRequire("eq375");

var $8aHnL = parcelRequire("8aHnL");
class $e514f169b2909e51$export$e23d3436ce401adc {
    constructor(){
        /**
     * Some desc.
     * @type {Map<string, Set<any>>}
     */ this._observers = $2U6oo.create();
    }
    /**
   * @template {keyof EVENTS & string} NAME
   * @param {NAME} name
   * @param {EVENTS[NAME]} f
   */ on(name, f) {
        $2U6oo.setIfUndefined(this._observers, /** @type {string} */ name, $eq375.create).add(f);
        return f;
    }
    /**
   * @template {keyof EVENTS & string} NAME
   * @param {NAME} name
   * @param {EVENTS[NAME]} f
   */ once(name, f) {
        /**
     * @param  {...any} args
     */ const _f = (...args)=>{
            this.off(name, /** @type {any} */ _f);
            f(...args);
        };
        this.on(name, /** @type {any} */ _f);
    }
    /**
   * @template {keyof EVENTS & string} NAME
   * @param {NAME} name
   * @param {EVENTS[NAME]} f
   */ off(name, f) {
        const observers = this._observers.get(name);
        if (observers !== undefined) {
            observers.delete(f);
            if (observers.size === 0) this._observers.delete(name);
        }
    }
    /**
   * Emit a named event. All registered event listeners that listen to the
   * specified name will receive the event.
   *
   * @todo This should catch exceptions
   *
   * @template {keyof EVENTS & string} NAME
   * @param {NAME} name The event name.
   * @param {Parameters<EVENTS[NAME]>} args The arguments that are applied to the event listener.
   */ emit(name, args) {
        // copy all listeners to an array first to make sure that no event is emitted to listeners that are subscribed while the event handler is called.
        return $8aHnL.from((this._observers.get(name) || $2U6oo.create()).values()).forEach((f)=>f(...args));
    }
    destroy() {
        this._observers = $2U6oo.create();
    }
}
class $e514f169b2909e51$export$77cea355fa80b5f4 {
    constructor(){
        /**
     * Some desc.
     * @type {Map<N, any>}
     */ this._observers = $2U6oo.create();
    }
    /**
   * @param {N} name
   * @param {function} f
   */ on(name, f) {
        $2U6oo.setIfUndefined(this._observers, name, $eq375.create).add(f);
    }
    /**
   * @param {N} name
   * @param {function} f
   */ once(name, f) {
        /**
     * @param  {...any} args
     */ const _f = (...args)=>{
            this.off(name, _f);
            f(...args);
        };
        this.on(name, _f);
    }
    /**
   * @param {N} name
   * @param {function} f
   */ off(name, f) {
        const observers = this._observers.get(name);
        if (observers !== undefined) {
            observers.delete(f);
            if (observers.size === 0) this._observers.delete(name);
        }
    }
    /**
   * Emit a named event. All registered event listeners that listen to the
   * specified name will receive the event.
   *
   * @todo This should catch exceptions
   *
   * @param {N} name The event name.
   * @param {Array<any>} args The arguments that are applied to the event listener.
   */ emit(name, args) {
        // copy all listeners to an array first to make sure that no event is emitted to listeners that are subscribed while the event handler is called.
        return $8aHnL.from((this._observers.get(name) || $2U6oo.create()).values()).forEach((f)=>f(...args));
    }
    destroy() {
        this._observers = $2U6oo.create();
    }
} /* c8 ignore end */ 

});
parcelRegister("2U6oo", function(module, exports) {

$parcel$export(module.exports, "create", function () { return $21d5c5229d1147ea$export$185802fd694ee1f5; });
$parcel$export(module.exports, "copy", function () { return $21d5c5229d1147ea$export$784d13d8ee351f07; });
$parcel$export(module.exports, "setIfUndefined", function () { return $21d5c5229d1147ea$export$dccd489362a8619; });
$parcel$export(module.exports, "map", function () { return $21d5c5229d1147ea$export$871de8747c9eaa88; });
$parcel$export(module.exports, "any", function () { return $21d5c5229d1147ea$export$4154a199d7d90455; });
/**
 * Utility module to work with key-value stores.
 *
 * @module map
 */ /**
 * Creates a new Map instance.
 *
 * @function
 * @return {Map<any, any>}
 *
 * @function
 */ const $21d5c5229d1147ea$export$185802fd694ee1f5 = ()=>new Map();
const $21d5c5229d1147ea$export$784d13d8ee351f07 = (m)=>{
    const r = $21d5c5229d1147ea$export$185802fd694ee1f5();
    m.forEach((v, k)=>{
        r.set(k, v);
    });
    return r;
};
const $21d5c5229d1147ea$export$dccd489362a8619 = (map, key, createT)=>{
    let set = map.get(key);
    if (set === undefined) map.set(key, set = createT());
    return set;
};
const $21d5c5229d1147ea$export$871de8747c9eaa88 = (m, f)=>{
    const res = [];
    for (const [key, value] of m)res.push(f(value, key));
    return res;
};
const $21d5c5229d1147ea$export$4154a199d7d90455 = (m, f)=>{
    for (const [key, value] of m){
        if (f(value, key)) return true;
    }
    return false;
};
const $21d5c5229d1147ea$export$84bf76cd7afc7469 = (m, f)=>{
    for (const [key, value] of m){
        if (!f(value, key)) return false;
    }
    return true;
};

});

parcelRegister("eq375", function(module, exports) {

$parcel$export(module.exports, "create", function () { return $a7f5e89ddf8a0a17$export$185802fd694ee1f5; });
$parcel$export(module.exports, "from", function () { return $a7f5e89ddf8a0a17$export$6788812c4e6611e6; });
/**
 * Utility module to work with sets.
 *
 * @module set
 */ const $a7f5e89ddf8a0a17$export$185802fd694ee1f5 = ()=>new Set();
const $a7f5e89ddf8a0a17$export$45b10814cc054894 = (set)=>Array.from(set);
const $a7f5e89ddf8a0a17$export$43128fadae87b74a = (set)=>set.values().next().value ?? undefined;
const $a7f5e89ddf8a0a17$export$6788812c4e6611e6 = (entries)=>new Set(entries);

});

parcelRegister("8aHnL", function(module, exports) {

$parcel$export(module.exports, "last", function () { return $5f30e8b9cd02da7f$export$4c7897fafd92b108; });
$parcel$export(module.exports, "appendTo", function () { return $5f30e8b9cd02da7f$export$9ceefe31f12a3778; });
$parcel$export(module.exports, "from", function () { return $5f30e8b9cd02da7f$export$6788812c4e6611e6; });
$parcel$export(module.exports, "some", function () { return $5f30e8b9cd02da7f$export$ad14ef4001db2bcd; });
$parcel$export(module.exports, "equalFlat", function () { return $5f30e8b9cd02da7f$export$4f1c34abb2bb4c8; });
$parcel$export(module.exports, "unfold", function () { return $5f30e8b9cd02da7f$export$c48e357c1a89b78d; });
$parcel$export(module.exports, "isArray", function () { return $5f30e8b9cd02da7f$export$43bee75e5e14138e; });
$parcel$export(module.exports, "map", function () { return $5f30e8b9cd02da7f$export$871de8747c9eaa88; });
/**
 * Utility module to work with Arrays.
 *
 * @module array
 */ 
var $eq375 = parcelRequire("eq375");
const $5f30e8b9cd02da7f$export$4c7897fafd92b108 = (arr)=>arr[arr.length - 1];
const $5f30e8b9cd02da7f$export$185802fd694ee1f5 = ()=>/** @type {Array<C>} */ [];
const $5f30e8b9cd02da7f$export$784d13d8ee351f07 = (a)=>/** @type {Array<D>} */ a.slice();
const $5f30e8b9cd02da7f$export$9ceefe31f12a3778 = (dest, src)=>{
    for(let i = 0; i < src.length; i++)dest.push(src[i]);
};
const $5f30e8b9cd02da7f$export$6788812c4e6611e6 = Array.from;
const $5f30e8b9cd02da7f$export$7ecc1a3b11b57dab = (arr, f)=>{
    for(let i = 0; i < arr.length; i++){
        if (!f(arr[i], i, arr)) return false;
    }
    return true;
};
const $5f30e8b9cd02da7f$export$ad14ef4001db2bcd = (arr, f)=>{
    for(let i = 0; i < arr.length; i++){
        if (f(arr[i], i, arr)) return true;
    }
    return false;
};
const $5f30e8b9cd02da7f$export$4f1c34abb2bb4c8 = (a, b)=>a.length === b.length && $5f30e8b9cd02da7f$export$7ecc1a3b11b57dab(a, (item, index)=>item === b[index]);
const $5f30e8b9cd02da7f$export$bffa455ba8c619a6 = (arr)=>$5f30e8b9cd02da7f$export$93e2b83da34ff82a(arr, /** @type {Array<ELEM>} */ [], (acc, val)=>acc.concat(val));
const $5f30e8b9cd02da7f$export$c48e357c1a89b78d = (len, f)=>{
    const array = new Array(len);
    for(let i = 0; i < len; i++)array[i] = f(i, array);
    return array;
};
const $5f30e8b9cd02da7f$export$93e2b83da34ff82a = (arr, seed, folder)=>arr.reduce(folder, seed);
const $5f30e8b9cd02da7f$export$43bee75e5e14138e = Array.isArray;
const $5f30e8b9cd02da7f$export$7a5d5c156e7dc406 = (arr)=>$5f30e8b9cd02da7f$export$6788812c4e6611e6($eq375.from(arr));
const $5f30e8b9cd02da7f$export$abf0e2545164275f = (arr, mapper)=>{
    /**
   * @type {Set<M>}
   */ const happened = $eq375.create();
    /**
   * @type {Array<T>}
   */ const result = [];
    for(let i = 0; i < arr.length; i++){
        const el = arr[i];
        const mapped = mapper(el);
        if (!happened.has(mapped)) {
            happened.add(mapped);
            result.push(el);
        }
    }
    return result;
};
const $5f30e8b9cd02da7f$export$871de8747c9eaa88 = (arr, mapper)=>{
    /**
   * @type {Array<any>}
   */ const res = Array(arr.length);
    for(let i = 0; i < arr.length; i++)res[i] = mapper(/** @type {any} */ arr[i], i, /** @type {any} */ arr);
    return /** @type {any} */ res;
};

});


parcelRegister("6O4IB", function(module, exports) {

$parcel$export(module.exports, "floor", function () { return $4f4b12939ce8a6ca$export$a3fe094919f356fd; });
$parcel$export(module.exports, "ceil", function () { return $4f4b12939ce8a6ca$export$803ce6b71a0a94b2; });
$parcel$export(module.exports, "abs", function () { return $4f4b12939ce8a6ca$export$2335f513bbd82c6d; });
$parcel$export(module.exports, "round", function () { return $4f4b12939ce8a6ca$export$2077e0241d6afd3c; });
$parcel$export(module.exports, "log10", function () { return $4f4b12939ce8a6ca$export$75e08744a3ff8516; });
$parcel$export(module.exports, "min", function () { return $4f4b12939ce8a6ca$export$96ec731ed4dcb222; });
$parcel$export(module.exports, "max", function () { return $4f4b12939ce8a6ca$export$8960430cfd85939f; });
$parcel$export(module.exports, "exp10", function () { return $4f4b12939ce8a6ca$export$1bb2a14208c790f7; });
$parcel$export(module.exports, "isNegativeZero", function () { return $4f4b12939ce8a6ca$export$dc0a61f4a9121f92; });
/**
 * Common Math expressions.
 *
 * @module math
 */ const $4f4b12939ce8a6ca$export$a3fe094919f356fd = Math.floor;
const $4f4b12939ce8a6ca$export$803ce6b71a0a94b2 = Math.ceil;
const $4f4b12939ce8a6ca$export$2335f513bbd82c6d = Math.abs;
const $4f4b12939ce8a6ca$export$46de3d998ca9a030 = Math.imul;
const $4f4b12939ce8a6ca$export$2077e0241d6afd3c = Math.round;
const $4f4b12939ce8a6ca$export$75e08744a3ff8516 = Math.log10;
const $4f4b12939ce8a6ca$export$b9fae0bba9d9094d = Math.log2;
const $4f4b12939ce8a6ca$export$bef1f36f5486a6a3 = Math.log;
const $4f4b12939ce8a6ca$export$eba8049fb5020b81 = Math.sqrt;
const $4f4b12939ce8a6ca$export$e16d8520af44a096 = (a, b)=>a + b;
const $4f4b12939ce8a6ca$export$96ec731ed4dcb222 = (a, b)=>a < b ? a : b;
const $4f4b12939ce8a6ca$export$8960430cfd85939f = (a, b)=>a > b ? a : b;
const $4f4b12939ce8a6ca$export$c9f5652083b8129d = Number.isNaN;
const $4f4b12939ce8a6ca$export$9c297f60e22e3389 = Math.pow;
const $4f4b12939ce8a6ca$export$1bb2a14208c790f7 = (exp)=>Math.pow(10, exp);
const $4f4b12939ce8a6ca$export$c5552dfdbc7cec71 = Math.sign;
const $4f4b12939ce8a6ca$export$dc0a61f4a9121f92 = (n)=>n !== 0 ? n < 0 : 1 / n < 0;

});

parcelRegister("apPNa", function(module, exports) {

$parcel$export(module.exports, "createEncoder", function () { return $795469ff85ae5647$export$4e76eeb6df88c889; });
$parcel$export(module.exports, "encode", function () { return $795469ff85ae5647$export$c564cdbbe6da493; });
$parcel$export(module.exports, "toUint8Array", function () { return $795469ff85ae5647$export$73470fd2221e6aef; });
$parcel$export(module.exports, "write", function () { return $795469ff85ae5647$export$68d8715fc104d294; });
$parcel$export(module.exports, "writeUint8", function () { return $795469ff85ae5647$export$826a1a6619653272; });
$parcel$export(module.exports, "writeVarUint", function () { return $795469ff85ae5647$export$872f48c75febcd2b; });
$parcel$export(module.exports, "writeVarInt", function () { return $795469ff85ae5647$export$ff90f819e16cc9bb; });
$parcel$export(module.exports, "writeVarUint8Array", function () { return $795469ff85ae5647$export$f7d11515275e88a2; });
$parcel$export(module.exports, "writeVarString", function () { return $795469ff85ae5647$export$dde49cb52d5f1650; });
$parcel$export(module.exports, "writeBinaryEncoder", function () { return $795469ff85ae5647$export$c029b62321ea3da; });
$parcel$export(module.exports, "writeUint8Array", function () { return $795469ff85ae5647$export$73b5e63e27d2b4c7; });
$parcel$export(module.exports, "writeAny", function () { return $795469ff85ae5647$export$264b1e8551468ea; });
$parcel$export(module.exports, "RleEncoder", function () { return $795469ff85ae5647$export$8fa72bb4fa9409ff; });
$parcel$export(module.exports, "UintOptRleEncoder", function () { return $795469ff85ae5647$export$785ebd3312c38061; });
$parcel$export(module.exports, "IntDiffOptRleEncoder", function () { return $795469ff85ae5647$export$7542c66a59375c6f; });
$parcel$export(module.exports, "StringEncoder", function () { return $795469ff85ae5647$export$7dcdc5c32f31c550; });
/**
 * Efficient schema-less binary encoding with support for variable length encoding.
 *
 * Use [lib0/encoding] with [lib0/decoding]. Every encoding function has a corresponding decoding function.
 *
 * Encodes numbers in little-endian order (least to most significant byte order)
 * and is compatible with Golang's binary encoding (https://golang.org/pkg/encoding/binary/)
 * which is also used in Protocol Buffers.
 *
 * ```js
 * // encoding step
 * const encoder = encoding.createEncoder()
 * encoding.writeVarUint(encoder, 256)
 * encoding.writeVarString(encoder, 'Hello world!')
 * const buf = encoding.toUint8Array(encoder)
 * ```
 *
 * ```js
 * // decoding step
 * const decoder = decoding.createDecoder(buf)
 * decoding.readVarUint(decoder) // => 256
 * decoding.readVarString(decoder) // => 'Hello world!'
 * decoding.hasContent(decoder) // => false - all data is read
 * ```
 *
 * @module encoding
 */ 
var $6O4IB = parcelRequire("6O4IB");

var $al3pF = parcelRequire("al3pF");

var $jnoaM = parcelRequire("jnoaM");

var $8YS3b = parcelRequire("8YS3b");

var $8aHnL = parcelRequire("8aHnL");
class $795469ff85ae5647$export$a50aceb0e02a00aa {
    constructor(){
        this.cpos = 0;
        this.cbuf = new Uint8Array(100);
        /**
     * @type {Array<Uint8Array>}
     */ this.bufs = [];
    }
}
const $795469ff85ae5647$export$4e76eeb6df88c889 = ()=>new $795469ff85ae5647$export$a50aceb0e02a00aa();
const $795469ff85ae5647$export$c564cdbbe6da493 = (f)=>{
    const encoder = $795469ff85ae5647$export$4e76eeb6df88c889();
    f(encoder);
    return $795469ff85ae5647$export$73470fd2221e6aef(encoder);
};
const $795469ff85ae5647$export$f24224f1c91d8156 = (encoder)=>{
    let len = encoder.cpos;
    for(let i = 0; i < encoder.bufs.length; i++)len += encoder.bufs[i].length;
    return len;
};
const $795469ff85ae5647$export$7ad75c69830b76d7 = (encoder)=>encoder.cpos > 0 || encoder.bufs.length > 0;
const $795469ff85ae5647$export$73470fd2221e6aef = (encoder)=>{
    const uint8arr = new Uint8Array($795469ff85ae5647$export$f24224f1c91d8156(encoder));
    let curPos = 0;
    for(let i = 0; i < encoder.bufs.length; i++){
        const d = encoder.bufs[i];
        uint8arr.set(d, curPos);
        curPos += d.length;
    }
    uint8arr.set(new Uint8Array(encoder.cbuf.buffer, 0, encoder.cpos), curPos);
    return uint8arr;
};
const $795469ff85ae5647$export$39fb588b9aff60c5 = (encoder, len)=>{
    const bufferLen = encoder.cbuf.length;
    if (bufferLen - encoder.cpos < len) {
        encoder.bufs.push(new Uint8Array(encoder.cbuf.buffer, 0, encoder.cpos));
        encoder.cbuf = new Uint8Array($6O4IB.max(bufferLen, len) * 2);
        encoder.cpos = 0;
    }
};
const $795469ff85ae5647$export$68d8715fc104d294 = (encoder, num)=>{
    const bufferLen = encoder.cbuf.length;
    if (encoder.cpos === bufferLen) {
        encoder.bufs.push(encoder.cbuf);
        encoder.cbuf = new Uint8Array(bufferLen * 2);
        encoder.cpos = 0;
    }
    encoder.cbuf[encoder.cpos++] = num;
};
const $795469ff85ae5647$export$adaa4cf7ef1b65be = (encoder, pos, num)=>{
    let buffer = null;
    // iterate all buffers and adjust position
    for(let i = 0; i < encoder.bufs.length && buffer === null; i++){
        const b = encoder.bufs[i];
        if (pos < b.length) buffer = b // found buffer
        ;
        else pos -= b.length;
    }
    if (buffer === null) // use current buffer
    buffer = encoder.cbuf;
    buffer[pos] = num;
};
const $795469ff85ae5647$export$826a1a6619653272 = $795469ff85ae5647$export$68d8715fc104d294;
const $795469ff85ae5647$export$83964ea8501fbf8 = $795469ff85ae5647$export$adaa4cf7ef1b65be;
const $795469ff85ae5647$export$ba6b74b6f3145a00 = (encoder, num)=>{
    $795469ff85ae5647$export$68d8715fc104d294(encoder, num & $jnoaM.BITS8);
    $795469ff85ae5647$export$68d8715fc104d294(encoder, num >>> 8 & $jnoaM.BITS8);
};
const $795469ff85ae5647$export$f86e1edc3d839287 = (encoder, pos, num)=>{
    $795469ff85ae5647$export$adaa4cf7ef1b65be(encoder, pos, num & $jnoaM.BITS8);
    $795469ff85ae5647$export$adaa4cf7ef1b65be(encoder, pos + 1, num >>> 8 & $jnoaM.BITS8);
};
const $795469ff85ae5647$export$835343b0f7799f5b = (encoder, num)=>{
    for(let i = 0; i < 4; i++){
        $795469ff85ae5647$export$68d8715fc104d294(encoder, num & $jnoaM.BITS8);
        num >>>= 8;
    }
};
const $795469ff85ae5647$export$efed0d8c16230d13 = (encoder, num)=>{
    for(let i = 3; i >= 0; i--)$795469ff85ae5647$export$68d8715fc104d294(encoder, num >>> 8 * i & $jnoaM.BITS8);
};
const $795469ff85ae5647$export$5517b6394fc440fb = (encoder, pos, num)=>{
    for(let i = 0; i < 4; i++){
        $795469ff85ae5647$export$adaa4cf7ef1b65be(encoder, pos + i, num & $jnoaM.BITS8);
        num >>>= 8;
    }
};
const $795469ff85ae5647$export$872f48c75febcd2b = (encoder, num)=>{
    while(num > $jnoaM.BITS7){
        $795469ff85ae5647$export$68d8715fc104d294(encoder, $jnoaM.BIT8 | $jnoaM.BITS7 & num);
        num = $6O4IB.floor(num / 128) // shift >>> 7
        ;
    }
    $795469ff85ae5647$export$68d8715fc104d294(encoder, $jnoaM.BITS7 & num);
};
const $795469ff85ae5647$export$ff90f819e16cc9bb = (encoder, num)=>{
    const isNegative = $6O4IB.isNegativeZero(num);
    if (isNegative) num = -num;
    //             |- whether to continue reading         |- whether is negative     |- number
    $795469ff85ae5647$export$68d8715fc104d294(encoder, (num > $jnoaM.BITS6 ? $jnoaM.BIT8 : 0) | (isNegative ? $jnoaM.BIT7 : 0) | $jnoaM.BITS6 & num);
    num = $6O4IB.floor(num / 64) // shift >>> 6
    ;
    // We don't need to consider the case of num === 0 so we can use a different
    // pattern here than above.
    while(num > 0){
        $795469ff85ae5647$export$68d8715fc104d294(encoder, (num > $jnoaM.BITS7 ? $jnoaM.BIT8 : 0) | $jnoaM.BITS7 & num);
        num = $6O4IB.floor(num / 128) // shift >>> 7
        ;
    }
};
/**
 * A cache to store strings temporarily
 */ const $795469ff85ae5647$var$_strBuffer = new Uint8Array(30000);
const $795469ff85ae5647$var$_maxStrBSize = $795469ff85ae5647$var$_strBuffer.length / 3;
const $795469ff85ae5647$export$dff327976627e12b = (encoder, str)=>{
    if (str.length < $795469ff85ae5647$var$_maxStrBSize) {
        // We can encode the string into the existing buffer
        /* c8 ignore next */ const written = $8YS3b.utf8TextEncoder.encodeInto(str, $795469ff85ae5647$var$_strBuffer).written || 0;
        $795469ff85ae5647$export$872f48c75febcd2b(encoder, written);
        for(let i = 0; i < written; i++)$795469ff85ae5647$export$68d8715fc104d294(encoder, $795469ff85ae5647$var$_strBuffer[i]);
    } else $795469ff85ae5647$export$f7d11515275e88a2(encoder, $8YS3b.encodeUtf8(str));
};
const $795469ff85ae5647$export$94cf4193edfe959a = (encoder, str)=>{
    const encodedString = unescape(encodeURIComponent(str));
    const len = encodedString.length;
    $795469ff85ae5647$export$872f48c75febcd2b(encoder, len);
    for(let i = 0; i < len; i++)$795469ff85ae5647$export$68d8715fc104d294(encoder, /** @type {number} */ encodedString.codePointAt(i));
};
const $795469ff85ae5647$export$dde49cb52d5f1650 = $8YS3b.utf8TextEncoder && /** @type {any} */ $8YS3b.utf8TextEncoder.encodeInto ? $795469ff85ae5647$export$dff327976627e12b : $795469ff85ae5647$export$94cf4193edfe959a;
const $795469ff85ae5647$export$be5604ffb9fbbd0c = (encoder, str)=>$795469ff85ae5647$export$6c17d6eec4abdaa6(encoder, $8YS3b.encodeUtf8(str));
const $795469ff85ae5647$export$6c17d6eec4abdaa6 = (encoder, buf)=>{
    for(let i = 0; i < buf.length; i++){
        const b = buf[i];
        if (b === 0 || b === 1) $795469ff85ae5647$export$68d8715fc104d294(encoder, 1);
        $795469ff85ae5647$export$68d8715fc104d294(encoder, buf[i]);
    }
    $795469ff85ae5647$export$68d8715fc104d294(encoder, 0);
};
const $795469ff85ae5647$export$c029b62321ea3da = (encoder, append)=>$795469ff85ae5647$export$73b5e63e27d2b4c7(encoder, $795469ff85ae5647$export$73470fd2221e6aef(append));
const $795469ff85ae5647$export$73b5e63e27d2b4c7 = (encoder, uint8Array)=>{
    const bufferLen = encoder.cbuf.length;
    const cpos = encoder.cpos;
    const leftCopyLen = $6O4IB.min(bufferLen - cpos, uint8Array.length);
    const rightCopyLen = uint8Array.length - leftCopyLen;
    encoder.cbuf.set(uint8Array.subarray(0, leftCopyLen), cpos);
    encoder.cpos += leftCopyLen;
    if (rightCopyLen > 0) {
        // Still something to write, write right half..
        // Append new buffer
        encoder.bufs.push(encoder.cbuf);
        // must have at least size of remaining buffer
        encoder.cbuf = new Uint8Array($6O4IB.max(bufferLen * 2, rightCopyLen));
        // copy array
        encoder.cbuf.set(uint8Array.subarray(leftCopyLen));
        encoder.cpos = rightCopyLen;
    }
};
const $795469ff85ae5647$export$f7d11515275e88a2 = (encoder, uint8Array)=>{
    $795469ff85ae5647$export$872f48c75febcd2b(encoder, uint8Array.byteLength);
    $795469ff85ae5647$export$73b5e63e27d2b4c7(encoder, uint8Array);
};
const $795469ff85ae5647$export$1f031ae9c71bd530 = (encoder, len)=>{
    $795469ff85ae5647$export$39fb588b9aff60c5(encoder, len);
    const dview = new DataView(encoder.cbuf.buffer, encoder.cpos, len);
    encoder.cpos += len;
    return dview;
};
const $795469ff85ae5647$export$a33455db0a9638a6 = (encoder, num)=>$795469ff85ae5647$export$1f031ae9c71bd530(encoder, 4).setFloat32(0, num, false);
const $795469ff85ae5647$export$231a04cea676c54c = (encoder, num)=>$795469ff85ae5647$export$1f031ae9c71bd530(encoder, 8).setFloat64(0, num, false);
const $795469ff85ae5647$export$4fbfa93dd6e14543 = (encoder, num)=>/** @type {any} */ $795469ff85ae5647$export$1f031ae9c71bd530(encoder, 8).setBigInt64(0, num, false);
const $795469ff85ae5647$export$663ca46034903888 = (encoder, num)=>/** @type {any} */ $795469ff85ae5647$export$1f031ae9c71bd530(encoder, 8).setBigUint64(0, num, false);
const $795469ff85ae5647$var$floatTestBed = new DataView(new ArrayBuffer(4));
/**
 * Check if a number can be encoded as a 32 bit float.
 *
 * @param {number} num
 * @return {boolean}
 */ const $795469ff85ae5647$var$isFloat32 = (num)=>{
    $795469ff85ae5647$var$floatTestBed.setFloat32(0, num);
    return $795469ff85ae5647$var$floatTestBed.getFloat32(0) === num;
};
const $795469ff85ae5647$export$264b1e8551468ea = (encoder, data)=>{
    switch(typeof data){
        case "string":
            // TYPE 119: STRING
            $795469ff85ae5647$export$68d8715fc104d294(encoder, 119);
            $795469ff85ae5647$export$dde49cb52d5f1650(encoder, data);
            break;
        case "number":
            if ($al3pF.isInteger(data) && $6O4IB.abs(data) <= $jnoaM.BITS31) {
                // TYPE 125: INTEGER
                $795469ff85ae5647$export$68d8715fc104d294(encoder, 125);
                $795469ff85ae5647$export$ff90f819e16cc9bb(encoder, data);
            } else if ($795469ff85ae5647$var$isFloat32(data)) {
                // TYPE 124: FLOAT32
                $795469ff85ae5647$export$68d8715fc104d294(encoder, 124);
                $795469ff85ae5647$export$a33455db0a9638a6(encoder, data);
            } else {
                // TYPE 123: FLOAT64
                $795469ff85ae5647$export$68d8715fc104d294(encoder, 123);
                $795469ff85ae5647$export$231a04cea676c54c(encoder, data);
            }
            break;
        case "bigint":
            // TYPE 122: BigInt
            $795469ff85ae5647$export$68d8715fc104d294(encoder, 122);
            $795469ff85ae5647$export$4fbfa93dd6e14543(encoder, data);
            break;
        case "object":
            if (data === null) // TYPE 126: null
            $795469ff85ae5647$export$68d8715fc104d294(encoder, 126);
            else if ($8aHnL.isArray(data)) {
                // TYPE 117: Array
                $795469ff85ae5647$export$68d8715fc104d294(encoder, 117);
                $795469ff85ae5647$export$872f48c75febcd2b(encoder, data.length);
                for(let i = 0; i < data.length; i++)$795469ff85ae5647$export$264b1e8551468ea(encoder, data[i]);
            } else if (data instanceof Uint8Array) {
                // TYPE 116: ArrayBuffer
                $795469ff85ae5647$export$68d8715fc104d294(encoder, 116);
                $795469ff85ae5647$export$f7d11515275e88a2(encoder, data);
            } else {
                // TYPE 118: Object
                $795469ff85ae5647$export$68d8715fc104d294(encoder, 118);
                const keys = Object.keys(data);
                $795469ff85ae5647$export$872f48c75febcd2b(encoder, keys.length);
                for(let i = 0; i < keys.length; i++){
                    const key = keys[i];
                    $795469ff85ae5647$export$dde49cb52d5f1650(encoder, key);
                    $795469ff85ae5647$export$264b1e8551468ea(encoder, data[key]);
                }
            }
            break;
        case "boolean":
            // TYPE 120/121: boolean (true/false)
            $795469ff85ae5647$export$68d8715fc104d294(encoder, data ? 120 : 121);
            break;
        default:
            // TYPE 127: undefined
            $795469ff85ae5647$export$68d8715fc104d294(encoder, 127);
    }
};
class $795469ff85ae5647$export$8fa72bb4fa9409ff extends $795469ff85ae5647$export$a50aceb0e02a00aa {
    /**
   * @param {function(Encoder, T):void} writer
   */ constructor(writer){
        super();
        /**
     * The writer
     */ this.w = writer;
        /**
     * Current state
     * @type {T|null}
     */ this.s = null;
        this.count = 0;
    }
    /**
   * @param {T} v
   */ write(v) {
        if (this.s === v) this.count++;
        else {
            if (this.count > 0) // flush counter, unless this is the first value (count = 0)
            $795469ff85ae5647$export$872f48c75febcd2b(this, this.count - 1) // since count is always > 0, we can decrement by one. non-standard encoding ftw
            ;
            this.count = 1;
            // write first value
            this.w(this, v);
            this.s = v;
        }
    }
}
class $795469ff85ae5647$export$c636f3fa46f2752c extends $795469ff85ae5647$export$a50aceb0e02a00aa {
    /**
   * @param {number} start
   */ constructor(start){
        super();
        /**
     * Current state
     * @type {number}
     */ this.s = start;
    }
    /**
   * @param {number} v
   */ write(v) {
        $795469ff85ae5647$export$ff90f819e16cc9bb(this, v - this.s);
        this.s = v;
    }
}
class $795469ff85ae5647$export$29917ece4cb403fb extends $795469ff85ae5647$export$a50aceb0e02a00aa {
    /**
   * @param {number} start
   */ constructor(start){
        super();
        /**
     * Current state
     * @type {number}
     */ this.s = start;
        this.count = 0;
    }
    /**
   * @param {number} v
   */ write(v) {
        if (this.s === v && this.count > 0) this.count++;
        else {
            if (this.count > 0) // flush counter, unless this is the first value (count = 0)
            $795469ff85ae5647$export$872f48c75febcd2b(this, this.count - 1) // since count is always > 0, we can decrement by one. non-standard encoding ftw
            ;
            this.count = 1;
            // write first value
            $795469ff85ae5647$export$ff90f819e16cc9bb(this, v - this.s);
            this.s = v;
        }
    }
}
/**
 * @param {UintOptRleEncoder} encoder
 */ const $795469ff85ae5647$var$flushUintOptRleEncoder = (encoder)=>{
    if (encoder.count > 0) {
        // flush counter, unless this is the first value (count = 0)
        // case 1: just a single value. set sign to positive
        // case 2: write several values. set sign to negative to indicate that there is a length coming
        $795469ff85ae5647$export$ff90f819e16cc9bb(encoder.encoder, encoder.count === 1 ? encoder.s : -encoder.s);
        if (encoder.count > 1) $795469ff85ae5647$export$872f48c75febcd2b(encoder.encoder, encoder.count - 2) // since count is always > 1, we can decrement by one. non-standard encoding ftw
        ;
    }
};
class $795469ff85ae5647$export$785ebd3312c38061 {
    constructor(){
        this.encoder = new $795469ff85ae5647$export$a50aceb0e02a00aa();
        /**
     * @type {number}
     */ this.s = 0;
        this.count = 0;
    }
    /**
   * @param {number} v
   */ write(v) {
        if (this.s === v) this.count++;
        else {
            $795469ff85ae5647$var$flushUintOptRleEncoder(this);
            this.count = 1;
            this.s = v;
        }
    }
    /**
   * Flush the encoded state and transform this to a Uint8Array.
   *
   * Note that this should only be called once.
   */ toUint8Array() {
        $795469ff85ae5647$var$flushUintOptRleEncoder(this);
        return $795469ff85ae5647$export$73470fd2221e6aef(this.encoder);
    }
}
class $795469ff85ae5647$export$f460a01fb0702193 {
    constructor(){
        this.encoder = new $795469ff85ae5647$export$a50aceb0e02a00aa();
        /**
     * @type {number}
     */ this.s = 0;
        this.count = 0;
    }
    /**
   * @param {number} v
   */ write(v) {
        if (this.s + this.count === v) this.count++;
        else {
            $795469ff85ae5647$var$flushUintOptRleEncoder(this);
            this.count = 1;
            this.s = v;
        }
    }
    /**
   * Flush the encoded state and transform this to a Uint8Array.
   *
   * Note that this should only be called once.
   */ toUint8Array() {
        $795469ff85ae5647$var$flushUintOptRleEncoder(this);
        return $795469ff85ae5647$export$73470fd2221e6aef(this.encoder);
    }
}
/**
 * @param {IntDiffOptRleEncoder} encoder
 */ const $795469ff85ae5647$var$flushIntDiffOptRleEncoder = (encoder)=>{
    if (encoder.count > 0) {
        //          31 bit making up the diff | wether to write the counter
        // const encodedDiff = encoder.diff << 1 | (encoder.count === 1 ? 0 : 1)
        const encodedDiff = encoder.diff * 2 + (encoder.count === 1 ? 0 : 1);
        // flush counter, unless this is the first value (count = 0)
        // case 1: just a single value. set first bit to positive
        // case 2: write several values. set first bit to negative to indicate that there is a length coming
        $795469ff85ae5647$export$ff90f819e16cc9bb(encoder.encoder, encodedDiff);
        if (encoder.count > 1) $795469ff85ae5647$export$872f48c75febcd2b(encoder.encoder, encoder.count - 2) // since count is always > 1, we can decrement by one. non-standard encoding ftw
        ;
    }
};
class $795469ff85ae5647$export$7542c66a59375c6f {
    constructor(){
        this.encoder = new $795469ff85ae5647$export$a50aceb0e02a00aa();
        /**
     * @type {number}
     */ this.s = 0;
        this.count = 0;
        this.diff = 0;
    }
    /**
   * @param {number} v
   */ write(v) {
        if (this.diff === v - this.s) {
            this.s = v;
            this.count++;
        } else {
            $795469ff85ae5647$var$flushIntDiffOptRleEncoder(this);
            this.count = 1;
            this.diff = v - this.s;
            this.s = v;
        }
    }
    /**
   * Flush the encoded state and transform this to a Uint8Array.
   *
   * Note that this should only be called once.
   */ toUint8Array() {
        $795469ff85ae5647$var$flushIntDiffOptRleEncoder(this);
        return $795469ff85ae5647$export$73470fd2221e6aef(this.encoder);
    }
}
class $795469ff85ae5647$export$7dcdc5c32f31c550 {
    constructor(){
        /**
     * @type {Array<string>}
     */ this.sarr = [];
        this.s = "";
        this.lensE = new $795469ff85ae5647$export$785ebd3312c38061();
    }
    /**
   * @param {string} string
   */ write(string) {
        this.s += string;
        if (this.s.length > 19) {
            this.sarr.push(this.s);
            this.s = "";
        }
        this.lensE.write(string.length);
    }
    toUint8Array() {
        const encoder = new $795469ff85ae5647$export$a50aceb0e02a00aa();
        this.sarr.push(this.s);
        this.s = "";
        $795469ff85ae5647$export$dde49cb52d5f1650(encoder, this.sarr.join(""));
        $795469ff85ae5647$export$73b5e63e27d2b4c7(encoder, this.lensE.toUint8Array());
        return $795469ff85ae5647$export$73470fd2221e6aef(encoder);
    }
}

});
parcelRegister("al3pF", function(module, exports) {

$parcel$export(module.exports, "MAX_SAFE_INTEGER", function () { return $786e834c116bbb5d$export$18510406f204a1b9; });
$parcel$export(module.exports, "isInteger", function () { return $786e834c116bbb5d$export$a287f47fed4544b8; });
/**
 * Utility helpers for working with numbers.
 *
 * @module number
 */ 
var $6O4IB = parcelRequire("6O4IB");

var $jnoaM = parcelRequire("jnoaM");
const $786e834c116bbb5d$export$18510406f204a1b9 = Number.MAX_SAFE_INTEGER;
const $786e834c116bbb5d$export$91ddad910c1af487 = Number.MIN_SAFE_INTEGER;
const $786e834c116bbb5d$export$7accc3db8e859605 = -2147483648;
const $786e834c116bbb5d$export$a5f353c3c14c00d0 = $jnoaM.BITS31;
const $786e834c116bbb5d$export$f055c566d4c0f541 = $jnoaM.BITS32;
const $786e834c116bbb5d$export$a287f47fed4544b8 = Number.isInteger || ((num)=>typeof num === "number" && isFinite(num) && $6O4IB.floor(num) === num);
const $786e834c116bbb5d$export$c9f5652083b8129d = Number.isNaN;
const $786e834c116bbb5d$export$5f87784a266e50a4 = Number.parseInt;
const $786e834c116bbb5d$export$33de6ea056a4cdbb = (n)=>{
    n &= $jnoaM.BITS32;
    let count = 0;
    while(n){
        n &= n - 1;
        count++;
    }
    return count;
};

});
parcelRegister("jnoaM", function(module, exports) {

$parcel$export(module.exports, "BIT1", function () { return $e1b2ea86b26d5db3$export$ee2c6657cb286da4; });
$parcel$export(module.exports, "BIT2", function () { return $e1b2ea86b26d5db3$export$1f117f3b0edc2676; });
$parcel$export(module.exports, "BIT3", function () { return $e1b2ea86b26d5db3$export$e5294f8c78cf7711; });
$parcel$export(module.exports, "BIT4", function () { return $e1b2ea86b26d5db3$export$873ae8db4cef5125; });
$parcel$export(module.exports, "BIT6", function () { return $e1b2ea86b26d5db3$export$daf23f774967089; });
$parcel$export(module.exports, "BIT7", function () { return $e1b2ea86b26d5db3$export$eb5a8e0006ab4bb5; });
$parcel$export(module.exports, "BIT8", function () { return $e1b2ea86b26d5db3$export$e25597372303a045; });
$parcel$export(module.exports, "BITS5", function () { return $e1b2ea86b26d5db3$export$bc2aba63e4099c09; });
$parcel$export(module.exports, "BITS6", function () { return $e1b2ea86b26d5db3$export$f39f4e074e983a34; });
$parcel$export(module.exports, "BITS7", function () { return $e1b2ea86b26d5db3$export$f84d6bebff154ceb; });
$parcel$export(module.exports, "BITS8", function () { return $e1b2ea86b26d5db3$export$c880072ee0e87648; });
$parcel$export(module.exports, "BITS21", function () { return $e1b2ea86b26d5db3$export$b5ffbef7f0f6f536; });
$parcel$export(module.exports, "BITS31", function () { return $e1b2ea86b26d5db3$export$87ec42487f19c66c; });
$parcel$export(module.exports, "BITS32", function () { return $e1b2ea86b26d5db3$export$3ea07c5174cba08a; });
/* eslint-env browser */ /**
 * Binary data constants.
 *
 * @module binary
 */ /**
 * n-th bit activated.
 *
 * @type {number}
 */ const $e1b2ea86b26d5db3$export$ee2c6657cb286da4 = 1;
const $e1b2ea86b26d5db3$export$1f117f3b0edc2676 = 2;
const $e1b2ea86b26d5db3$export$e5294f8c78cf7711 = 4;
const $e1b2ea86b26d5db3$export$873ae8db4cef5125 = 8;
const $e1b2ea86b26d5db3$export$b6e6496517dfbd31 = 16;
const $e1b2ea86b26d5db3$export$daf23f774967089 = 32;
const $e1b2ea86b26d5db3$export$eb5a8e0006ab4bb5 = 64;
const $e1b2ea86b26d5db3$export$e25597372303a045 = 128;
const $e1b2ea86b26d5db3$export$f15587807021fe79 = 256;
const $e1b2ea86b26d5db3$export$70939d57ba836c5 = 512;
const $e1b2ea86b26d5db3$export$9ec47920d80e8c85 = 1024;
const $e1b2ea86b26d5db3$export$bc5dd16b35d4584b = 2048;
const $e1b2ea86b26d5db3$export$76a85e893e6d6ecc = 4096;
const $e1b2ea86b26d5db3$export$fb6ca64a3ffa3aa9 = 8192;
const $e1b2ea86b26d5db3$export$e7adc86ee9ea4b00 = 16384;
const $e1b2ea86b26d5db3$export$6aa68b9346d558bb = 32768;
const $e1b2ea86b26d5db3$export$5d7aab37466c79ea = 65536;
const $e1b2ea86b26d5db3$export$3aa401309ff3940 = 131072;
const $e1b2ea86b26d5db3$export$1fd8467d3320465f = 262144;
const $e1b2ea86b26d5db3$export$d1dceb84a396f684 = 524288;
const $e1b2ea86b26d5db3$export$ef62e7729d79baec = 1048576;
const $e1b2ea86b26d5db3$export$40651ae3846a7710 = 2097152;
const $e1b2ea86b26d5db3$export$e03976987cb0b818 = 4194304;
const $e1b2ea86b26d5db3$export$dd5dceb22223d8ef = 8388608;
const $e1b2ea86b26d5db3$export$aecaefba6ae044e4 = 16777216;
const $e1b2ea86b26d5db3$export$6e47d6f6c411c0e1 = 33554432;
const $e1b2ea86b26d5db3$export$321a8fda0150a18 = 67108864;
const $e1b2ea86b26d5db3$export$d7843230fff08622 = 134217728;
const $e1b2ea86b26d5db3$export$9fe7219cb72d1ed8 = 268435456;
const $e1b2ea86b26d5db3$export$c85121a54e1cc97f = 536870912;
const $e1b2ea86b26d5db3$export$76075a64dc7c21ef = 1073741824;
const $e1b2ea86b26d5db3$export$49d5cdcf29800e09 = -2147483648;
const $e1b2ea86b26d5db3$export$853d99058378c102 = 0;
const $e1b2ea86b26d5db3$export$b859c32a415b3ec1 = 1;
const $e1b2ea86b26d5db3$export$decefe6957191373 = 3;
const $e1b2ea86b26d5db3$export$d1defff3cbd2c6f4 = 7;
const $e1b2ea86b26d5db3$export$8d2b432c8c02ae65 = 15;
const $e1b2ea86b26d5db3$export$bc2aba63e4099c09 = 31;
const $e1b2ea86b26d5db3$export$f39f4e074e983a34 = 63;
const $e1b2ea86b26d5db3$export$f84d6bebff154ceb = 127;
const $e1b2ea86b26d5db3$export$c880072ee0e87648 = 255;
const $e1b2ea86b26d5db3$export$cbbfa5d3c076ad8c = 511;
const $e1b2ea86b26d5db3$export$e365aa75b5fa7293 = 1023;
const $e1b2ea86b26d5db3$export$51bfc23c1b7b60c3 = 2047;
const $e1b2ea86b26d5db3$export$3b0a099b88523ac = 4095;
const $e1b2ea86b26d5db3$export$8345c1c06d3e5fc1 = 8191;
const $e1b2ea86b26d5db3$export$e20cffba663a7688 = 16383;
const $e1b2ea86b26d5db3$export$cd0970fd37b207c6 = 32767;
const $e1b2ea86b26d5db3$export$250487b182389b6a = 65535;
const $e1b2ea86b26d5db3$export$9d6e01d73abdaadb = $e1b2ea86b26d5db3$export$3aa401309ff3940 - 1;
const $e1b2ea86b26d5db3$export$eedeab0ac4009664 = $e1b2ea86b26d5db3$export$1fd8467d3320465f - 1;
const $e1b2ea86b26d5db3$export$e1840c3c33a76ffc = $e1b2ea86b26d5db3$export$d1dceb84a396f684 - 1;
const $e1b2ea86b26d5db3$export$f0ae3ba8312e92e3 = $e1b2ea86b26d5db3$export$ef62e7729d79baec - 1;
const $e1b2ea86b26d5db3$export$b5ffbef7f0f6f536 = $e1b2ea86b26d5db3$export$40651ae3846a7710 - 1;
const $e1b2ea86b26d5db3$export$33ae34bc8e747862 = $e1b2ea86b26d5db3$export$e03976987cb0b818 - 1;
const $e1b2ea86b26d5db3$export$3629272792e6a9a0 = $e1b2ea86b26d5db3$export$dd5dceb22223d8ef - 1;
const $e1b2ea86b26d5db3$export$a07300a4cc2ba23c = $e1b2ea86b26d5db3$export$aecaefba6ae044e4 - 1;
const $e1b2ea86b26d5db3$export$9137f2824b26e02b = $e1b2ea86b26d5db3$export$6e47d6f6c411c0e1 - 1;
const $e1b2ea86b26d5db3$export$94d4c3aa7cfbb8dd = $e1b2ea86b26d5db3$export$321a8fda0150a18 - 1;
const $e1b2ea86b26d5db3$export$8af89455097efce0 = $e1b2ea86b26d5db3$export$d7843230fff08622 - 1;
const $e1b2ea86b26d5db3$export$dee9196bb8567fe9 = $e1b2ea86b26d5db3$export$9fe7219cb72d1ed8 - 1;
const $e1b2ea86b26d5db3$export$bd0b5ef1d89e90f = $e1b2ea86b26d5db3$export$c85121a54e1cc97f - 1;
const $e1b2ea86b26d5db3$export$e5560e011efa8766 = $e1b2ea86b26d5db3$export$76075a64dc7c21ef - 1;
const $e1b2ea86b26d5db3$export$87ec42487f19c66c = 0x7FFFFFFF;
const $e1b2ea86b26d5db3$export$3ea07c5174cba08a = 0xFFFFFFFF;

});


parcelRegister("8YS3b", function(module, exports) {

$parcel$export(module.exports, "fromCharCode", function () { return $689dda9bec7a573b$export$30216c0101da0ee0; });
$parcel$export(module.exports, "fromCamelCase", function () { return $689dda9bec7a573b$export$87429743646c3257; });
$parcel$export(module.exports, "utf8TextEncoder", function () { return $689dda9bec7a573b$export$f3ce4806f2484eb; });
$parcel$export(module.exports, "encodeUtf8", function () { return $689dda9bec7a573b$export$8f647c2204da8484; });
$parcel$export(module.exports, "utf8TextDecoder", function () { return $689dda9bec7a573b$export$f477633695bbbcd; });
$parcel$export(module.exports, "decodeUtf8", function () { return $689dda9bec7a573b$export$72118b85b055afd; });
$parcel$export(module.exports, "repeat", function () { return $689dda9bec7a573b$export$76d90c956114f2c2; });

var $8aHnL = parcelRequire("8aHnL");
const $689dda9bec7a573b$export$30216c0101da0ee0 = String.fromCharCode;
const $689dda9bec7a573b$export$73bfc63873071f74 = String.fromCodePoint;
const $689dda9bec7a573b$export$e3a9a653b2a11ac1 = $689dda9bec7a573b$export$30216c0101da0ee0(65535);
/**
 * @param {string} s
 * @return {string}
 */ const $689dda9bec7a573b$var$toLowerCase = (s)=>s.toLowerCase();
const $689dda9bec7a573b$var$trimLeftRegex = /^\s*/g;
const $689dda9bec7a573b$export$c5557f40488c48ec = (s)=>s.replace($689dda9bec7a573b$var$trimLeftRegex, "");
const $689dda9bec7a573b$var$fromCamelCaseRegex = /([A-Z])/g;
const $689dda9bec7a573b$export$87429743646c3257 = (s, separator)=>$689dda9bec7a573b$export$c5557f40488c48ec(s.replace($689dda9bec7a573b$var$fromCamelCaseRegex, (match)=>`${separator}${$689dda9bec7a573b$var$toLowerCase(match)}`));
const $689dda9bec7a573b$export$ba35f6b806a3dbd4 = (str)=>unescape(encodeURIComponent(str)).length;
const $689dda9bec7a573b$export$83d8cea287b4dfcd = (str)=>{
    const encodedString = unescape(encodeURIComponent(str));
    const len = encodedString.length;
    const buf = new Uint8Array(len);
    for(let i = 0; i < len; i++)buf[i] = /** @type {number} */ encodedString.codePointAt(i);
    return buf;
};
const $689dda9bec7a573b$export$f3ce4806f2484eb = /** @type {TextEncoder} */ typeof TextEncoder !== "undefined" ? new TextEncoder() : null;
const $689dda9bec7a573b$export$9a0a70804ee285dd = (str)=>$689dda9bec7a573b$export$f3ce4806f2484eb.encode(str);
const $689dda9bec7a573b$export$8f647c2204da8484 = $689dda9bec7a573b$export$f3ce4806f2484eb ? $689dda9bec7a573b$export$9a0a70804ee285dd : $689dda9bec7a573b$export$83d8cea287b4dfcd;
const $689dda9bec7a573b$export$154b750182ae32cf = (buf)=>{
    let remainingLen = buf.length;
    let encodedString = "";
    let bufPos = 0;
    while(remainingLen > 0){
        const nextLen = remainingLen < 10000 ? remainingLen : 10000;
        const bytes = buf.subarray(bufPos, bufPos + nextLen);
        bufPos += nextLen;
        // Starting with ES5.1 we can supply a generic array-like object as arguments
        encodedString += String.fromCodePoint.apply(null, /** @type {any} */ bytes);
        remainingLen -= nextLen;
    }
    return decodeURIComponent(escape(encodedString));
};
let $689dda9bec7a573b$export$f477633695bbbcd = typeof TextDecoder === "undefined" ? null : new TextDecoder("utf-8", {
    fatal: true,
    ignoreBOM: true
});
/* c8 ignore start */ if ($689dda9bec7a573b$export$f477633695bbbcd && $689dda9bec7a573b$export$f477633695bbbcd.decode(new Uint8Array()).length === 1) // Safari doesn't handle BOM correctly.
// This fixes a bug in Safari 13.0.5 where it produces a BOM the first time it is called.
// utf8TextDecoder.decode(new Uint8Array()).length === 1 on the first call and
// utf8TextDecoder.decode(new Uint8Array()).length === 1 on the second call
// Another issue is that from then on no BOM chars are recognized anymore
/* c8 ignore next */ $689dda9bec7a573b$export$f477633695bbbcd = null;
const $689dda9bec7a573b$export$23d5f1ce72f56168 = (buf)=>/** @type {TextDecoder} */ $689dda9bec7a573b$export$f477633695bbbcd.decode(buf);
const $689dda9bec7a573b$export$72118b85b055afd = $689dda9bec7a573b$export$f477633695bbbcd ? $689dda9bec7a573b$export$23d5f1ce72f56168 : $689dda9bec7a573b$export$154b750182ae32cf;
const $689dda9bec7a573b$export$869882364835d202 = (str, index, remove, insert = "")=>str.slice(0, index) + insert + str.slice(index + remove);
const $689dda9bec7a573b$export$76d90c956114f2c2 = (source, n)=>$8aHnL.unfold(n, ()=>source).join("");

});


parcelRegister("dW8Wq", function(module, exports) {

$parcel$export(module.exports, "createDecoder", function () { return $a257a0b11ee68b87$export$f8c898e83b60faaa; });
$parcel$export(module.exports, "hasContent", function () { return $a257a0b11ee68b87$export$7ad75c69830b76d7; });
$parcel$export(module.exports, "readVarUint8Array", function () { return $a257a0b11ee68b87$export$7418bbc18dee40f3; });
$parcel$export(module.exports, "readVarUint", function () { return $a257a0b11ee68b87$export$5a476e4dbe7923d5; });
$parcel$export(module.exports, "readUint8", function () { return $a257a0b11ee68b87$export$d5778a2beba4ceef; });
$parcel$export(module.exports, "readVarInt", function () { return $a257a0b11ee68b87$export$1dd5b9ddf6575ae8; });
$parcel$export(module.exports, "readVarString", function () { return $a257a0b11ee68b87$export$3b64b4d753b81ec2; });
$parcel$export(module.exports, "readAny", function () { return $a257a0b11ee68b87$export$82863139061f472f; });
$parcel$export(module.exports, "RleDecoder", function () { return $a257a0b11ee68b87$export$f1f1200492b832af; });
$parcel$export(module.exports, "UintOptRleDecoder", function () { return $a257a0b11ee68b87$export$2dc62fb2f864b82e; });
$parcel$export(module.exports, "IntDiffOptRleDecoder", function () { return $a257a0b11ee68b87$export$d502ab0bf048a596; });
$parcel$export(module.exports, "StringDecoder", function () { return $a257a0b11ee68b87$export$63a7aa211a91ed69; });
/**
 * Efficient schema-less binary decoding with support for variable length encoding.
 *
 * Use [lib0/decoding] with [lib0/encoding]. Every encoding function has a corresponding decoding function.
 *
 * Encodes numbers in little-endian order (least to most significant byte order)
 * and is compatible with Golang's binary encoding (https://golang.org/pkg/encoding/binary/)
 * which is also used in Protocol Buffers.
 *
 * ```js
 * // encoding step
 * const encoder = encoding.createEncoder()
 * encoding.writeVarUint(encoder, 256)
 * encoding.writeVarString(encoder, 'Hello world!')
 * const buf = encoding.toUint8Array(encoder)
 * ```
 *
 * ```js
 * // decoding step
 * const decoder = decoding.createDecoder(buf)
 * decoding.readVarUint(decoder) // => 256
 * decoding.readVarString(decoder) // => 'Hello world!'
 * decoding.hasContent(decoder) // => false - all data is read
 * ```
 *
 * @module decoding
 */ 
var $jnoaM = parcelRequire("jnoaM");

var $6O4IB = parcelRequire("6O4IB");

var $al3pF = parcelRequire("al3pF");

var $8YS3b = parcelRequire("8YS3b");

var $lqCPr = parcelRequire("lqCPr");

var $apPNa = parcelRequire("apPNa");
const $a257a0b11ee68b87$var$errorUnexpectedEndOfArray = $lqCPr.create("Unexpected end of array");
const $a257a0b11ee68b87$var$errorIntegerOutOfRange = $lqCPr.create("Integer out of Range");
class $a257a0b11ee68b87$export$f9de6ca0bc043724 {
    /**
   * @param {Uint8Array} uint8Array Binary data to decode
   */ constructor(uint8Array){
        /**
     * Decoding target.
     *
     * @type {Uint8Array}
     */ this.arr = uint8Array;
        /**
     * Current decoding position.
     *
     * @type {number}
     */ this.pos = 0;
    }
}
const $a257a0b11ee68b87$export$f8c898e83b60faaa = (uint8Array)=>new $a257a0b11ee68b87$export$f9de6ca0bc043724(uint8Array);
const $a257a0b11ee68b87$export$7ad75c69830b76d7 = (decoder)=>decoder.pos !== decoder.arr.length;
const $a257a0b11ee68b87$export$9cd59f9826255e47 = (decoder, newPos = decoder.pos)=>{
    const _decoder = $a257a0b11ee68b87$export$f8c898e83b60faaa(decoder.arr);
    _decoder.pos = newPos;
    return _decoder;
};
const $a257a0b11ee68b87$export$e21b2fe168d56a89 = (decoder, len)=>{
    const view = new Uint8Array(decoder.arr.buffer, decoder.pos + decoder.arr.byteOffset, len);
    decoder.pos += len;
    return view;
};
const $a257a0b11ee68b87$export$7418bbc18dee40f3 = (decoder)=>$a257a0b11ee68b87$export$e21b2fe168d56a89(decoder, $a257a0b11ee68b87$export$5a476e4dbe7923d5(decoder));
const $a257a0b11ee68b87$export$8c9f57cb3e3e2d3b = (decoder)=>$a257a0b11ee68b87$export$e21b2fe168d56a89(decoder, decoder.arr.length - decoder.pos);
const $a257a0b11ee68b87$export$228a9507fbdfcdb6 = (decoder)=>decoder.pos++;
const $a257a0b11ee68b87$export$d5778a2beba4ceef = (decoder)=>decoder.arr[decoder.pos++];
const $a257a0b11ee68b87$export$ef14636f4cf20706 = (decoder)=>{
    const uint = decoder.arr[decoder.pos] + (decoder.arr[decoder.pos + 1] << 8);
    decoder.pos += 2;
    return uint;
};
const $a257a0b11ee68b87$export$967c96218130b9ba = (decoder)=>{
    const uint = decoder.arr[decoder.pos] + (decoder.arr[decoder.pos + 1] << 8) + (decoder.arr[decoder.pos + 2] << 16) + (decoder.arr[decoder.pos + 3] << 24) >>> 0;
    decoder.pos += 4;
    return uint;
};
const $a257a0b11ee68b87$export$adb88b5d4ab91f4e = (decoder)=>{
    const uint = decoder.arr[decoder.pos + 3] + (decoder.arr[decoder.pos + 2] << 8) + (decoder.arr[decoder.pos + 1] << 16) + (decoder.arr[decoder.pos] << 24) >>> 0;
    decoder.pos += 4;
    return uint;
};
const $a257a0b11ee68b87$export$c6eca102d0b41ca0 = (decoder)=>decoder.arr[decoder.pos];
const $a257a0b11ee68b87$export$e5eb1e52afa13f8d = (decoder)=>decoder.arr[decoder.pos] + (decoder.arr[decoder.pos + 1] << 8);
const $a257a0b11ee68b87$export$67e54e775d28f9ae = (decoder)=>decoder.arr[decoder.pos] + (decoder.arr[decoder.pos + 1] << 8) + (decoder.arr[decoder.pos + 2] << 16) + (decoder.arr[decoder.pos + 3] << 24) >>> 0;
const $a257a0b11ee68b87$export$5a476e4dbe7923d5 = (decoder)=>{
    let num = 0;
    let mult = 1;
    const len = decoder.arr.length;
    while(decoder.pos < len){
        const r = decoder.arr[decoder.pos++];
        // num = num | ((r & binary.BITS7) << len)
        num = num + (r & $jnoaM.BITS7) * mult // shift $r << (7*#iterations) and add it to num
        ;
        mult *= 128 // next iteration, shift 7 "more" to the left
        ;
        if (r < $jnoaM.BIT8) return num;
        /* c8 ignore start */ if (num > $al3pF.MAX_SAFE_INTEGER) throw $a257a0b11ee68b87$var$errorIntegerOutOfRange;
    /* c8 ignore stop */ }
    throw $a257a0b11ee68b87$var$errorUnexpectedEndOfArray;
};
const $a257a0b11ee68b87$export$1dd5b9ddf6575ae8 = (decoder)=>{
    let r = decoder.arr[decoder.pos++];
    let num = r & $jnoaM.BITS6;
    let mult = 64;
    const sign = (r & $jnoaM.BIT7) > 0 ? -1 : 1;
    if ((r & $jnoaM.BIT8) === 0) // don't continue reading
    return sign * num;
    const len = decoder.arr.length;
    while(decoder.pos < len){
        r = decoder.arr[decoder.pos++];
        // num = num | ((r & binary.BITS7) << len)
        num = num + (r & $jnoaM.BITS7) * mult;
        mult *= 128;
        if (r < $jnoaM.BIT8) return sign * num;
        /* c8 ignore start */ if (num > $al3pF.MAX_SAFE_INTEGER) throw $a257a0b11ee68b87$var$errorIntegerOutOfRange;
    /* c8 ignore stop */ }
    throw $a257a0b11ee68b87$var$errorUnexpectedEndOfArray;
};
const $a257a0b11ee68b87$export$dc86e1eb544aa5ab = (decoder)=>{
    const pos = decoder.pos;
    const s = $a257a0b11ee68b87$export$5a476e4dbe7923d5(decoder);
    decoder.pos = pos;
    return s;
};
const $a257a0b11ee68b87$export$47c43df02cd47fca = (decoder)=>{
    const pos = decoder.pos;
    const s = $a257a0b11ee68b87$export$1dd5b9ddf6575ae8(decoder);
    decoder.pos = pos;
    return s;
};
const $a257a0b11ee68b87$export$e73299e6158668bb = (decoder)=>{
    let remainingLen = $a257a0b11ee68b87$export$5a476e4dbe7923d5(decoder);
    if (remainingLen === 0) return "";
    else {
        let encodedString = String.fromCodePoint($a257a0b11ee68b87$export$d5778a2beba4ceef(decoder)) // remember to decrease remainingLen
        ;
        if (--remainingLen < 100) while(remainingLen--)encodedString += String.fromCodePoint($a257a0b11ee68b87$export$d5778a2beba4ceef(decoder));
        else while(remainingLen > 0){
            const nextLen = remainingLen < 10000 ? remainingLen : 10000;
            // this is dangerous, we create a fresh array view from the existing buffer
            const bytes = decoder.arr.subarray(decoder.pos, decoder.pos + nextLen);
            decoder.pos += nextLen;
            // Starting with ES5.1 we can supply a generic array-like object as arguments
            encodedString += String.fromCodePoint.apply(null, /** @type {any} */ bytes);
            remainingLen -= nextLen;
        }
        return decodeURIComponent(escape(encodedString));
    }
};
const $a257a0b11ee68b87$export$7247eefae50fb91a = (decoder)=>/** @type any */ $8YS3b.utf8TextDecoder.decode($a257a0b11ee68b87$export$7418bbc18dee40f3(decoder));
const $a257a0b11ee68b87$export$3b64b4d753b81ec2 = $8YS3b.utf8TextDecoder ? $a257a0b11ee68b87$export$7247eefae50fb91a : $a257a0b11ee68b87$export$e73299e6158668bb;
const $a257a0b11ee68b87$export$23764cfecad9ae2f = (decoder)=>{
    const encoder = $apPNa.createEncoder();
    let b;
    while(true){
        b = $a257a0b11ee68b87$export$d5778a2beba4ceef(decoder);
        if (b === 0) return $apPNa.toUint8Array(encoder);
        if (b === 1) b = $a257a0b11ee68b87$export$d5778a2beba4ceef(decoder);
        $apPNa.write(encoder, b);
    }
};
const $a257a0b11ee68b87$export$d38ec182b293d566 = (decoder)=>$8YS3b.decodeUtf8($a257a0b11ee68b87$export$23764cfecad9ae2f(decoder));
const $a257a0b11ee68b87$export$91c1f3f0dd9bd2f5 = (decoder)=>{
    const pos = decoder.pos;
    const s = $a257a0b11ee68b87$export$3b64b4d753b81ec2(decoder);
    decoder.pos = pos;
    return s;
};
const $a257a0b11ee68b87$export$d7dd05f632129fe5 = (decoder, len)=>{
    const dv = new DataView(decoder.arr.buffer, decoder.arr.byteOffset + decoder.pos, len);
    decoder.pos += len;
    return dv;
};
const $a257a0b11ee68b87$export$dbc4aa781d9afe3b = (decoder)=>$a257a0b11ee68b87$export$d7dd05f632129fe5(decoder, 4).getFloat32(0, false);
const $a257a0b11ee68b87$export$d89a471990a89a7f = (decoder)=>$a257a0b11ee68b87$export$d7dd05f632129fe5(decoder, 8).getFloat64(0, false);
const $a257a0b11ee68b87$export$99e633bd4f295d85 = (decoder)=>/** @type {any} */ $a257a0b11ee68b87$export$d7dd05f632129fe5(decoder, 8).getBigInt64(0, false);
const $a257a0b11ee68b87$export$21575c47d1f9b652 = (decoder)=>/** @type {any} */ $a257a0b11ee68b87$export$d7dd05f632129fe5(decoder, 8).getBigUint64(0, false);
/**
 * @type {Array<function(Decoder):any>}
 */ const $a257a0b11ee68b87$var$readAnyLookupTable = [
    (decoder)=>undefined,
    (decoder)=>null,
    $a257a0b11ee68b87$export$1dd5b9ddf6575ae8,
    $a257a0b11ee68b87$export$dbc4aa781d9afe3b,
    $a257a0b11ee68b87$export$d89a471990a89a7f,
    $a257a0b11ee68b87$export$99e633bd4f295d85,
    (decoder)=>false,
    (decoder)=>true,
    $a257a0b11ee68b87$export$3b64b4d753b81ec2,
    (decoder)=>{
        const len = $a257a0b11ee68b87$export$5a476e4dbe7923d5(decoder);
        /**
     * @type {Object<string,any>}
     */ const obj = {};
        for(let i = 0; i < len; i++){
            const key = $a257a0b11ee68b87$export$3b64b4d753b81ec2(decoder);
            obj[key] = $a257a0b11ee68b87$export$82863139061f472f(decoder);
        }
        return obj;
    },
    (decoder)=>{
        const len = $a257a0b11ee68b87$export$5a476e4dbe7923d5(decoder);
        const arr = [];
        for(let i = 0; i < len; i++)arr.push($a257a0b11ee68b87$export$82863139061f472f(decoder));
        return arr;
    },
    $a257a0b11ee68b87$export$7418bbc18dee40f3 // CASE 116: Uint8Array
];
const $a257a0b11ee68b87$export$82863139061f472f = (decoder)=>$a257a0b11ee68b87$var$readAnyLookupTable[127 - $a257a0b11ee68b87$export$d5778a2beba4ceef(decoder)](decoder);
class $a257a0b11ee68b87$export$f1f1200492b832af extends $a257a0b11ee68b87$export$f9de6ca0bc043724 {
    /**
   * @param {Uint8Array} uint8Array
   * @param {function(Decoder):T} reader
   */ constructor(uint8Array, reader){
        super(uint8Array);
        /**
     * The reader
     */ this.reader = reader;
        /**
     * Current state
     * @type {T|null}
     */ this.s = null;
        this.count = 0;
    }
    read() {
        if (this.count === 0) {
            this.s = this.reader(this);
            if ($a257a0b11ee68b87$export$7ad75c69830b76d7(this)) this.count = $a257a0b11ee68b87$export$5a476e4dbe7923d5(this) + 1 // see encoder implementation for the reason why this is incremented
            ;
            else this.count = -1 // read the current value forever
            ;
        }
        this.count--;
        return /** @type {T} */ this.s;
    }
}
class $a257a0b11ee68b87$export$938378143fffe1b4 extends $a257a0b11ee68b87$export$f9de6ca0bc043724 {
    /**
   * @param {Uint8Array} uint8Array
   * @param {number} start
   */ constructor(uint8Array, start){
        super(uint8Array);
        /**
     * Current state
     * @type {number}
     */ this.s = start;
    }
    /**
   * @return {number}
   */ read() {
        this.s += $a257a0b11ee68b87$export$1dd5b9ddf6575ae8(this);
        return this.s;
    }
}
class $a257a0b11ee68b87$export$595b36f1b42934c6 extends $a257a0b11ee68b87$export$f9de6ca0bc043724 {
    /**
   * @param {Uint8Array} uint8Array
   * @param {number} start
   */ constructor(uint8Array, start){
        super(uint8Array);
        /**
     * Current state
     * @type {number}
     */ this.s = start;
        this.count = 0;
    }
    /**
   * @return {number}
   */ read() {
        if (this.count === 0) {
            this.s += $a257a0b11ee68b87$export$1dd5b9ddf6575ae8(this);
            if ($a257a0b11ee68b87$export$7ad75c69830b76d7(this)) this.count = $a257a0b11ee68b87$export$5a476e4dbe7923d5(this) + 1 // see encoder implementation for the reason why this is incremented
            ;
            else this.count = -1 // read the current value forever
            ;
        }
        this.count--;
        return /** @type {number} */ this.s;
    }
}
class $a257a0b11ee68b87$export$2dc62fb2f864b82e extends $a257a0b11ee68b87$export$f9de6ca0bc043724 {
    /**
   * @param {Uint8Array} uint8Array
   */ constructor(uint8Array){
        super(uint8Array);
        /**
     * @type {number}
     */ this.s = 0;
        this.count = 0;
    }
    read() {
        if (this.count === 0) {
            this.s = $a257a0b11ee68b87$export$1dd5b9ddf6575ae8(this);
            // if the sign is negative, we read the count too, otherwise count is 1
            const isNegative = $6O4IB.isNegativeZero(this.s);
            this.count = 1;
            if (isNegative) {
                this.s = -this.s;
                this.count = $a257a0b11ee68b87$export$5a476e4dbe7923d5(this) + 2;
            }
        }
        this.count--;
        return /** @type {number} */ this.s;
    }
}
class $a257a0b11ee68b87$export$727389af14dfe417 extends $a257a0b11ee68b87$export$f9de6ca0bc043724 {
    /**
   * @param {Uint8Array} uint8Array
   */ constructor(uint8Array){
        super(uint8Array);
        /**
     * @type {number}
     */ this.s = 0;
        this.count = 0;
    }
    read() {
        if (this.count === 0) {
            this.s = $a257a0b11ee68b87$export$1dd5b9ddf6575ae8(this);
            // if the sign is negative, we read the count too, otherwise count is 1
            const isNegative = $6O4IB.isNegativeZero(this.s);
            this.count = 1;
            if (isNegative) {
                this.s = -this.s;
                this.count = $a257a0b11ee68b87$export$5a476e4dbe7923d5(this) + 2;
            }
        }
        this.count--;
        return /** @type {number} */ this.s++;
    }
}
class $a257a0b11ee68b87$export$d502ab0bf048a596 extends $a257a0b11ee68b87$export$f9de6ca0bc043724 {
    /**
   * @param {Uint8Array} uint8Array
   */ constructor(uint8Array){
        super(uint8Array);
        /**
     * @type {number}
     */ this.s = 0;
        this.count = 0;
        this.diff = 0;
    }
    /**
   * @return {number}
   */ read() {
        if (this.count === 0) {
            const diff = $a257a0b11ee68b87$export$1dd5b9ddf6575ae8(this);
            // if the first bit is set, we read more data
            const hasCount = diff & 1;
            this.diff = $6O4IB.floor(diff / 2) // shift >> 1
            ;
            this.count = 1;
            if (hasCount) this.count = $a257a0b11ee68b87$export$5a476e4dbe7923d5(this) + 2;
        }
        this.s += this.diff;
        this.count--;
        return this.s;
    }
}
class $a257a0b11ee68b87$export$63a7aa211a91ed69 {
    /**
   * @param {Uint8Array} uint8Array
   */ constructor(uint8Array){
        this.decoder = new $a257a0b11ee68b87$export$2dc62fb2f864b82e(uint8Array);
        this.str = $a257a0b11ee68b87$export$3b64b4d753b81ec2(this.decoder);
        /**
     * @type {number}
     */ this.spos = 0;
    }
    /**
   * @return {string}
   */ read() {
        const end = this.spos + this.decoder.read();
        const res = this.str.slice(this.spos, end);
        this.spos = end;
        return res;
    }
}

});
parcelRegister("lqCPr", function(module, exports) {

$parcel$export(module.exports, "create", function () { return $f99a253a4ead174f$export$185802fd694ee1f5; });
$parcel$export(module.exports, "methodUnimplemented", function () { return $f99a253a4ead174f$export$73ced5c7e10d6d0f; });
$parcel$export(module.exports, "unexpectedCase", function () { return $f99a253a4ead174f$export$965b6bccecbd9673; });
/**
 * Error helpers.
 *
 * @module error
 */ /**
 * @param {string} s
 * @return {Error}
 */ /* c8 ignore next */ const $f99a253a4ead174f$export$185802fd694ee1f5 = (s)=>new Error(s);
const $f99a253a4ead174f$export$73ced5c7e10d6d0f = ()=>{
    throw $f99a253a4ead174f$export$185802fd694ee1f5("Method unimplemented");
};
const $f99a253a4ead174f$export$965b6bccecbd9673 = ()=>{
    throw $f99a253a4ead174f$export$185802fd694ee1f5("Unexpected case");
};

});


parcelRegister("APxPC", function(module, exports) {

$parcel$export(module.exports, "uint32", function () { return $06eb589af18adebe$export$de9ffb9418dd7d0d; });
$parcel$export(module.exports, "uuidv4", function () { return $06eb589af18adebe$export$abe4376e1bf796d6; });
/**
 * Isomorphic module for true random numbers / buffers / uuids.
 *
 * Attention: falls back to Math.random if the browser does not support crypto.
 *
 * @module random
 */ 
var $6O4IB = parcelRequire("6O4IB");

var $jnoaM = parcelRequire("jnoaM");

var $4cgMA = parcelRequire("4cgMA");
const $06eb589af18adebe$export$bb0a9c36cf454ea0 = Math.random;
const $06eb589af18adebe$export$de9ffb9418dd7d0d = ()=>(0, $4cgMA.getRandomValues)(new Uint32Array(1))[0];
const $06eb589af18adebe$export$6bf94e3d82617e4e = ()=>{
    const arr = (0, $4cgMA.getRandomValues)(new Uint32Array(8));
    return (arr[0] & $jnoaM.BITS21) * ($jnoaM.BITS32 + 1) + (arr[1] >>> 0);
};
const $06eb589af18adebe$export$a9a18ae5ba42aeab = (arr)=>arr[$6O4IB.floor($06eb589af18adebe$export$bb0a9c36cf454ea0() * arr.length)];
// @ts-ignore
const $06eb589af18adebe$var$uuidv4Template = "10000000-1000-4000-8000-100000000000";
const $06eb589af18adebe$export$abe4376e1bf796d6 = ()=>$06eb589af18adebe$var$uuidv4Template.replace(/[018]/g, /** @param {number} c */ (c)=>(c ^ $06eb589af18adebe$export$de9ffb9418dd7d0d() & 15 >> c / 4).toString(16));

});
parcelRegister("4cgMA", function(module, exports) {

$parcel$export(module.exports, "getRandomValues", function () { return $30e54d1c0ce6b0d4$export$960b9ff25e7d4257; });
/* eslint-env browser */ const $30e54d1c0ce6b0d4$export$f45422fd2e8042d4 = crypto.subtle;
const $30e54d1c0ce6b0d4$export$960b9ff25e7d4257 = crypto.getRandomValues.bind(crypto);

});


parcelRegister("kCw4e", function(module, exports) {

$parcel$export(module.exports, "create", function () { return $f0303b265407a0f2$export$185802fd694ee1f5; });
/**
 * Utility helpers to work with promises.
 *
 * @module promise
 */ 
var $7neOC = parcelRequire("7neOC");
const $f0303b265407a0f2$export$185802fd694ee1f5 = (f)=>/** @type {Promise<T>} */ new Promise(f);
const $f0303b265407a0f2$export$fe201bb3bbe031e9 = (f)=>new Promise(f);
const $f0303b265407a0f2$export$84bf76cd7afc7469 = Promise.all.bind(Promise);
const $f0303b265407a0f2$export$2800f3ceda99eb84 = (reason)=>Promise.reject(reason);
const $f0303b265407a0f2$export$f7ad0328861e2f03 = (res)=>Promise.resolve(res);
const $f0303b265407a0f2$export$65eff93aa071dbbd = (res)=>Promise.resolve(res);
const $f0303b265407a0f2$export$a40009bd2c363351 = (timeout, check, intervalResolution = 10)=>$f0303b265407a0f2$export$185802fd694ee1f5((resolve, reject)=>{
        const startTime = $7neOC.getUnixTime();
        const hasTimeout = timeout > 0;
        const untilInterval = ()=>{
            if (check()) {
                clearInterval(intervalHandle);
                resolve();
            } else if (hasTimeout) /* c8 ignore else */ {
                if ($7neOC.getUnixTime() - startTime > timeout) {
                    clearInterval(intervalHandle);
                    reject(new Error("Timeout"));
                }
            }
        };
        const intervalHandle = setInterval(untilInterval, intervalResolution);
    });
const $f0303b265407a0f2$export$6ab8c822a2b03a03 = async (check, timeout = 0, intervalResolution = 10)=>{
    const startTime = $7neOC.getUnixTime();
    const noTimeout = timeout <= 0;
    // eslint-disable-next-line no-unmodified-loop-condition
    while(noTimeout || $7neOC.getUnixTime() - startTime <= timeout){
        if (await check()) return;
        await $f0303b265407a0f2$export$5c069c93d2b7493f(intervalResolution);
    }
    throw new Error("Timeout");
};
const $f0303b265407a0f2$export$5c069c93d2b7493f = (timeout)=>$f0303b265407a0f2$export$185802fd694ee1f5((resolve, _reject)=>setTimeout(resolve, timeout));
const $f0303b265407a0f2$export$4369c812aac99591 = (p)=>p instanceof Promise || p && p.then && p.catch && p.finally;

});
parcelRegister("7neOC", function(module, exports) {

$parcel$export(module.exports, "getUnixTime", function () { return $0162ae22d57084d9$export$1f77c0008d16313; });
/**
 * Utility module to work with time.
 *
 * @module time
 */ 
var $k8rB0 = parcelRequire("k8rB0");

var $6O4IB = parcelRequire("6O4IB");
const $0162ae22d57084d9$export$aa350b96d91cd94 = ()=>new Date();
const $0162ae22d57084d9$export$1f77c0008d16313 = Date.now;
const $0162ae22d57084d9$export$70cb903099cabea3 = (d)=>{
    if (d < 60000) {
        const p = $k8rB0.prefix(d, -1);
        return $6O4IB.round(p.n * 100) / 100 + p.prefix + "s";
    }
    d = $6O4IB.floor(d / 1000);
    const seconds = d % 60;
    const minutes = $6O4IB.floor(d / 60) % 60;
    const hours = $6O4IB.floor(d / 3600) % 24;
    const days = $6O4IB.floor(d / 86400);
    if (days > 0) return days + "d" + (hours > 0 || minutes > 30 ? " " + (minutes > 30 ? hours + 1 : hours) + "h" : "");
    if (hours > 0) /* c8 ignore next */ return hours + "h" + (minutes > 0 || seconds > 30 ? " " + (seconds > 30 ? minutes + 1 : minutes) + "min" : "");
    return minutes + "min" + (seconds > 0 ? " " + seconds + "s" : "");
};

});
parcelRegister("k8rB0", function(module, exports) {

$parcel$export(module.exports, "prefix", function () { return $03c86b3167fb653e$export$82e9f45cca5ba907; });
/**
 * Utility module to convert metric values.
 *
 * @module metric
 */ 
var $6O4IB = parcelRequire("6O4IB");
const $03c86b3167fb653e$export$3c3f39195836e927 = 1e24;
const $03c86b3167fb653e$export$bc1fc8bc8e1895cf = 1e21;
const $03c86b3167fb653e$export$91377b751fc464a0 = 1e18;
const $03c86b3167fb653e$export$fc10d2598c9417a5 = 1e15;
const $03c86b3167fb653e$export$ce366dc9d5abf7ac = 1e12;
const $03c86b3167fb653e$export$197e40aa3a484017 = 1e9;
const $03c86b3167fb653e$export$580f1e8cf64f2815 = 1e6;
const $03c86b3167fb653e$export$a3ed9693cfbf67fa = 1e3;
const $03c86b3167fb653e$export$6ec17edd70114a88 = 1e2;
const $03c86b3167fb653e$export$6ffbaf3528ca9f3f = 10;
const $03c86b3167fb653e$export$ec5800edbd9f0b69 = 0.1;
const $03c86b3167fb653e$export$9faf718fe58aaa35 = 0.01;
const $03c86b3167fb653e$export$fab274f99578ceb6 = 1e-3;
const $03c86b3167fb653e$export$77bd0ce503b87b26 = 1e-6;
const $03c86b3167fb653e$export$ddef5c050164e23e = 1e-9;
const $03c86b3167fb653e$export$e10c52a2ab594201 = 1e-12;
const $03c86b3167fb653e$export$c49f04803481822 = 1e-15;
const $03c86b3167fb653e$export$5510a0bcf77f39 = 1e-18;
const $03c86b3167fb653e$export$2b85cc24af20b7fe = 1e-21;
const $03c86b3167fb653e$export$a2878e23774b59ce = 1e-24;
const $03c86b3167fb653e$var$prefixUp = [
    "",
    "k",
    "M",
    "G",
    "T",
    "P",
    "E",
    "Z",
    "Y"
];
const $03c86b3167fb653e$var$prefixDown = [
    "",
    "m",
    "\u03BC",
    "n",
    "p",
    "f",
    "a",
    "z",
    "y"
];
const $03c86b3167fb653e$export$82e9f45cca5ba907 = (n, baseMultiplier = 0)=>{
    const nPow = n === 0 ? 0 : $6O4IB.log10(n);
    let mult = 0;
    while(nPow < mult * 3 && baseMultiplier > -8){
        baseMultiplier--;
        mult--;
    }
    while(nPow >= 3 + mult * 3 && baseMultiplier < 8){
        baseMultiplier++;
        mult++;
    }
    const prefix = baseMultiplier < 0 ? $03c86b3167fb653e$var$prefixDown[-baseMultiplier] : $03c86b3167fb653e$var$prefixUp[baseMultiplier];
    return {
        n: $6O4IB.round((mult > 0 ? n / $6O4IB.exp10(mult * 3) : n * $6O4IB.exp10(mult * -3)) * 1e12) / 1e12,
        prefix: prefix
    };
};

});



parcelRegister("800Lz", function(module, exports) {

$parcel$export(module.exports, "copyUint8Array", function () { return $5d2eeaf539f04994$export$fe6f60023cd5ffaf; });
/**
 * Utility functions to work with buffers (Uint8Array).
 *
 * @module buffer
 */ 
var $8YS3b = parcelRequire("8YS3b");

var $3LZef = parcelRequire("3LZef");

var $8aHnL = parcelRequire("8aHnL");

var $6O4IB = parcelRequire("6O4IB");

var $apPNa = parcelRequire("apPNa");

var $dW8Wq = parcelRequire("dW8Wq");

var $85H1q = parcelRequire("85H1q");
var $5d2eeaf539f04994$require$Buffer = $85H1q.Buffer;
const $5d2eeaf539f04994$export$79a0c4c40eecffbb = (len)=>new Uint8Array(len);
const $5d2eeaf539f04994$export$f3c8b5f6d250ec43 = (buffer, byteOffset, length)=>new Uint8Array(buffer, byteOffset, length);
const $5d2eeaf539f04994$export$1b999ddd54e5bed1 = (buffer)=>new Uint8Array(buffer);
/* c8 ignore start */ /**
 * @param {Uint8Array} bytes
 * @return {string}
 */ const $5d2eeaf539f04994$var$toBase64Browser = (bytes)=>{
    let s = "";
    for(let i = 0; i < bytes.byteLength; i++)s += $8YS3b.fromCharCode(bytes[i]);
    // eslint-disable-next-line no-undef
    return btoa(s);
};
/* c8 ignore stop */ /**
 * @param {Uint8Array} bytes
 * @return {string}
 */ const $5d2eeaf539f04994$var$toBase64Node = (bytes)=>$5d2eeaf539f04994$require$Buffer.from(bytes.buffer, bytes.byteOffset, bytes.byteLength).toString("base64");
/* c8 ignore start */ /**
 * @param {string} s
 * @return {Uint8Array}
 */ const $5d2eeaf539f04994$var$fromBase64Browser = (s)=>{
    // eslint-disable-next-line no-undef
    const a = atob(s);
    const bytes = $5d2eeaf539f04994$export$79a0c4c40eecffbb(a.length);
    for(let i = 0; i < a.length; i++)bytes[i] = a.charCodeAt(i);
    return bytes;
};
/* c8 ignore stop */ /**
 * @param {string} s
 */ const $5d2eeaf539f04994$var$fromBase64Node = (s)=>{
    const buf = $5d2eeaf539f04994$require$Buffer.from(s, "base64");
    return $5d2eeaf539f04994$export$f3c8b5f6d250ec43(buf.buffer, buf.byteOffset, buf.byteLength);
};
const $5d2eeaf539f04994$export$37cc283d8fbd3462 = $3LZef.isBrowser ? $5d2eeaf539f04994$var$toBase64Browser : $5d2eeaf539f04994$var$toBase64Node;
const $5d2eeaf539f04994$export$c537b38001c583b7 = $3LZef.isBrowser ? $5d2eeaf539f04994$var$fromBase64Browser : $5d2eeaf539f04994$var$fromBase64Node;
const $5d2eeaf539f04994$export$31f478961f22a29 = (buf)=>$5d2eeaf539f04994$export$37cc283d8fbd3462(buf).replaceAll("+", "-").replaceAll("/", "_").replaceAll("=", "");
const $5d2eeaf539f04994$export$2fcb175ca881fa06 = (base64)=>$5d2eeaf539f04994$export$c537b38001c583b7(base64.replaceAll("-", "+").replaceAll("_", "/"));
const $5d2eeaf539f04994$export$f4915efbb94d4d01 = (buf)=>$8aHnL.map(buf, (b)=>b.toString(16).padStart(2, "0")).join("");
const $5d2eeaf539f04994$export$99a70112ceb8327b = (hex)=>{
    const hlen = hex.length;
    const buf = new Uint8Array($6O4IB.ceil(hlen / 2));
    for(let i = 0; i < hlen; i += 2)buf[buf.length - i / 2 - 1] = Number.parseInt(hex.slice(hlen - i - 2, hlen - i), 16);
    return buf;
};
const $5d2eeaf539f04994$export$fe6f60023cd5ffaf = (uint8Array)=>{
    const newBuf = $5d2eeaf539f04994$export$79a0c4c40eecffbb(uint8Array.byteLength);
    newBuf.set(uint8Array);
    return newBuf;
};
const $5d2eeaf539f04994$export$355ad3726be07997 = (data)=>$apPNa.encode((encoder)=>$apPNa.writeAny(encoder, data));
const $5d2eeaf539f04994$export$929c279cfec29a23 = (buf)=>$dW8Wq.readAny($dW8Wq.createDecoder(buf));
const $5d2eeaf539f04994$export$e87773390ebfdab4 = (bs, N)=>{
    if (N === 0) return bs;
    bs = new Uint8Array(bs);
    bs[0] <<= N;
    for(let i = 1; i < bs.length; i++){
        bs[i - 1] |= bs[i] >>> 8 - N;
        bs[i] <<= N;
    }
    return bs;
};

});
parcelRegister("3LZef", function(module, exports) {

$parcel$export(module.exports, "isBrowser", function () { return $2bf541a7820e56df$export$4e09c449d6c407f7; });
$parcel$export(module.exports, "getVariable", function () { return $2bf541a7820e56df$export$39fb32ac18db3f88; });
$parcel$export(module.exports, "supportsColor", function () { return $2bf541a7820e56df$export$fcbe44f5d6fcebd; });
/**
 * Isomorphic module to work access the environment (query params, env variables).
 *
 * @module environment
 */ 
var $2U6oo = parcelRequire("2U6oo");

var $8YS3b = parcelRequire("8YS3b");

var $48mr0 = parcelRequire("48mr0");

var $bcUm8 = parcelRequire("bcUm8");

var $5VoPh = parcelRequire("5VoPh");

var $2IVpK = parcelRequire("2IVpK");
const $2bf541a7820e56df$export$8ee0fc9ee280b4ee = typeof $2IVpK !== "undefined" && $2IVpK.release && /node|io\.js/.test($2IVpK.release.name) && Object.prototype.toString.call(typeof $2IVpK !== "undefined" ? $2IVpK : 0) === "[object process]";
const $2bf541a7820e56df$export$4e09c449d6c407f7 = typeof window !== "undefined" && typeof document !== "undefined" && !$2bf541a7820e56df$export$8ee0fc9ee280b4ee;
const $2bf541a7820e56df$export$9ac100e40613ea10 = typeof navigator !== "undefined" ? /Mac/.test(navigator.platform) : false;
/**
 * @type {Map<string,string>}
 */ let $2bf541a7820e56df$var$params;
const $2bf541a7820e56df$var$args = [];
/* c8 ignore start */ const $2bf541a7820e56df$var$computeParams = ()=>{
    if ($2bf541a7820e56df$var$params === undefined) {
        if ($2bf541a7820e56df$export$8ee0fc9ee280b4ee) {
            $2bf541a7820e56df$var$params = $2U6oo.create();
            const pargs = $2IVpK.argv;
            let currParamName = null;
            for(let i = 0; i < pargs.length; i++){
                const parg = pargs[i];
                if (parg[0] === "-") {
                    if (currParamName !== null) $2bf541a7820e56df$var$params.set(currParamName, "");
                    currParamName = parg;
                } else if (currParamName !== null) {
                    $2bf541a7820e56df$var$params.set(currParamName, parg);
                    currParamName = null;
                } else $2bf541a7820e56df$var$args.push(parg);
            }
            if (currParamName !== null) $2bf541a7820e56df$var$params.set(currParamName, "");
        // in ReactNative for example this would not be true (unless connected to the Remote Debugger)
        } else if (typeof location === "object") {
            $2bf541a7820e56df$var$params = $2U6oo.create(); // eslint-disable-next-line no-undef
            (location.search || "?").slice(1).split("&").forEach((kv)=>{
                if (kv.length !== 0) {
                    const [key, value] = kv.split("=");
                    $2bf541a7820e56df$var$params.set(`--${$8YS3b.fromCamelCase(key, "-")}`, value);
                    $2bf541a7820e56df$var$params.set(`-${$8YS3b.fromCamelCase(key, "-")}`, value);
                }
            });
        } else $2bf541a7820e56df$var$params = $2U6oo.create();
    }
    return $2bf541a7820e56df$var$params;
};
const $2bf541a7820e56df$export$3ad523d4e4ddff75 = (name)=>$2bf541a7820e56df$var$computeParams().has(name);
const $2bf541a7820e56df$export$ecf541e09a511845 = (name, defaultVal)=>$2bf541a7820e56df$var$computeParams().get(name) || defaultVal;
const $2bf541a7820e56df$export$39fb32ac18db3f88 = (name)=>$2bf541a7820e56df$export$8ee0fc9ee280b4ee ? $48mr0.undefinedToNull($2IVpK.env[name.toUpperCase().replaceAll("-", "_")]) : $48mr0.undefinedToNull($bcUm8.varStorage.getItem(name));
const $2bf541a7820e56df$export$137940a4fd07b923 = (name)=>$2bf541a7820e56df$var$computeParams().get("--" + name) || $2bf541a7820e56df$export$39fb32ac18db3f88(name);
const $2bf541a7820e56df$export$e336c1d2b3b2390d = (name)=>{
    const c = $2bf541a7820e56df$export$137940a4fd07b923(name);
    if (c == null) throw new Error(`Expected configuration "${name.toUpperCase().replaceAll("-", "_")}"`);
    return c;
};
const $2bf541a7820e56df$export$41f29dc169f5b0eb = (name)=>$2bf541a7820e56df$export$3ad523d4e4ddff75("--" + name) || $2bf541a7820e56df$export$39fb32ac18db3f88(name) !== null;
const $2bf541a7820e56df$export$d71d1489bc353e92 = $2bf541a7820e56df$export$41f29dc169f5b0eb("production");
/* c8 ignore next 2 */ const $2bf541a7820e56df$var$forceColor = $2bf541a7820e56df$export$8ee0fc9ee280b4ee && $5VoPh.isOneOf(undefined, [
    "true",
    "1",
    "2"
]);
const $2bf541a7820e56df$export$fcbe44f5d6fcebd = $2bf541a7820e56df$var$forceColor || !$2bf541a7820e56df$export$3ad523d4e4ddff75("--no-colors") && // @todo deprecate --no-colors
!$2bf541a7820e56df$export$41f29dc169f5b0eb("no-color") && (!$2bf541a7820e56df$export$8ee0fc9ee280b4ee || $2IVpK.stdout.isTTY) && (!$2bf541a7820e56df$export$8ee0fc9ee280b4ee || $2bf541a7820e56df$export$3ad523d4e4ddff75("--color") || $2bf541a7820e56df$export$39fb32ac18db3f88("COLORTERM") !== null || ($2bf541a7820e56df$export$39fb32ac18db3f88("TERM") || "").includes("color")) /* c8 ignore stop */ ;

});
parcelRegister("48mr0", function(module, exports) {

$parcel$export(module.exports, "undefinedToNull", function () { return $30294fce780de248$export$43874719a1af321f; });
/**
 * Often used conditions.
 *
 * @module conditions
 */ /**
 * @template T
 * @param {T|null|undefined} v
 * @return {T|null}
 */ /* c8 ignore next */ const $30294fce780de248$export$43874719a1af321f = (v)=>v === undefined ? null : v;

});

parcelRegister("bcUm8", function(module, exports) {

$parcel$export(module.exports, "varStorage", function () { return $828c87d7b819c90e$export$86b84a8d42aa2c65; });
/* eslint-env browser */ /**
 * Isomorphic variable storage.
 *
 * Uses LocalStorage in the browser and falls back to in-memory storage.
 *
 * @module storage
 */ /* c8 ignore start */ class $828c87d7b819c90e$var$VarStoragePolyfill {
    constructor(){
        this.map = new Map();
    }
    /**
   * @param {string} key
   * @param {any} newValue
   */ setItem(key, newValue) {
        this.map.set(key, newValue);
    }
    /**
   * @param {string} key
   */ getItem(key) {
        return this.map.get(key);
    }
}
/* c8 ignore stop */ /**
 * @type {any}
 */ let $828c87d7b819c90e$var$_localStorage = new $828c87d7b819c90e$var$VarStoragePolyfill();
let $828c87d7b819c90e$var$usePolyfill = true;
/* c8 ignore start */ try {
    // if the same-origin rule is violated, accessing localStorage might thrown an error
    if (typeof localStorage !== "undefined" && localStorage) {
        $828c87d7b819c90e$var$_localStorage = localStorage;
        $828c87d7b819c90e$var$usePolyfill = false;
    }
} catch (e) {}
const $828c87d7b819c90e$export$86b84a8d42aa2c65 = $828c87d7b819c90e$var$_localStorage;
const $828c87d7b819c90e$export$bd913411069e59d3 = (eventHandler)=>$828c87d7b819c90e$var$usePolyfill || addEventListener("storage", /** @type {any} */ eventHandler);
const $828c87d7b819c90e$export$ff6a13ad336aa064 = (eventHandler)=>$828c87d7b819c90e$var$usePolyfill || removeEventListener("storage", /** @type {any} */ eventHandler);

});

parcelRegister("5VoPh", function(module, exports) {

$parcel$export(module.exports, "callAll", function () { return $450588950ef2930e$export$9dd9a52f2dd5b9ce; });
$parcel$export(module.exports, "nop", function () { return $450588950ef2930e$export$b5f1cfe7b08e6ed5; });
$parcel$export(module.exports, "id", function () { return $450588950ef2930e$export$d560c7e4a29451c2; });
$parcel$export(module.exports, "isOneOf", function () { return $450588950ef2930e$export$532a90c0e5e8e48c; });
/**
 * Common functions and function call helpers.
 *
 * @module function
 */ 
var $8aHnL = parcelRequire("8aHnL");

var $8u9N6 = parcelRequire("8u9N6");
const $450588950ef2930e$export$9dd9a52f2dd5b9ce = (fs, args, i = 0)=>{
    try {
        for(; i < fs.length; i++)fs[i](...args);
    } finally{
        if (i < fs.length) $450588950ef2930e$export$9dd9a52f2dd5b9ce(fs, args, i + 1);
    }
};
const $450588950ef2930e$export$b5f1cfe7b08e6ed5 = ()=>{};
const $450588950ef2930e$export$5635d7ef4b8fee1c = (f)=>f();
const $450588950ef2930e$export$d560c7e4a29451c2 = (a)=>a;
const $450588950ef2930e$export$bbb1dcf8c6c6bac1 = (a, b)=>a === b;
const $450588950ef2930e$export$6ca82605a98f2278 = (a, b)=>a === b || a != null && b != null && a.constructor === b.constructor && ($8aHnL.isArray(a) && $8aHnL.equalFlat(a, /** @type {Array<T>} */ b) || typeof a === "object" && $8u9N6.equalFlat(a, b));
const $450588950ef2930e$export$2ca9a723affd5d11 = (a, b)=>{
    if (a == null || b == null) return $450588950ef2930e$export$bbb1dcf8c6c6bac1(a, b);
    if (a.constructor !== b.constructor) return false;
    if (a === b) return true;
    switch(a.constructor){
        case ArrayBuffer:
            a = new Uint8Array(a);
            b = new Uint8Array(b);
        // eslint-disable-next-line no-fallthrough
        case Uint8Array:
            if (a.byteLength !== b.byteLength) return false;
            for(let i = 0; i < a.length; i++){
                if (a[i] !== b[i]) return false;
            }
            break;
        case Set:
            if (a.size !== b.size) return false;
            for (const value of a){
                if (!b.has(value)) return false;
            }
            break;
        case Map:
            if (a.size !== b.size) return false;
            for (const key of a.keys()){
                if (!b.has(key) || !$450588950ef2930e$export$2ca9a723affd5d11(a.get(key), b.get(key))) return false;
            }
            break;
        case Object:
            if ($8u9N6.length(a) !== $8u9N6.length(b)) return false;
            for(const key in a){
                if (!$8u9N6.hasProperty(a, key) || !$450588950ef2930e$export$2ca9a723affd5d11(a[key], b[key])) return false;
            }
            break;
        case Array:
            if (a.length !== b.length) return false;
            for(let i = 0; i < a.length; i++){
                if (!$450588950ef2930e$export$2ca9a723affd5d11(a[i], b[i])) return false;
            }
            break;
        default:
            return false;
    }
    return true;
};
const $450588950ef2930e$export$532a90c0e5e8e48c = (value, options)=>options.includes(value);
const $450588950ef2930e$export$43bee75e5e14138e = $8aHnL.isArray;
const $450588950ef2930e$export$844ec244b1367d54 = (s)=>s && s.constructor === String;
const $450588950ef2930e$export$7e4aa119212bc614 = (n)=>n != null && n.constructor === Number;
const $450588950ef2930e$export$226b3eccf92c9ed9 = (n, T)=>n && n.constructor === T;
const $450588950ef2930e$export$6306e0d85c68df69 = (T)=>/**
   * @param {any} n
   * @return {n is InstanceType<TYPE>}
   **/ (n)=>n && n.constructor === T;

});
parcelRegister("8u9N6", function(module, exports) {

$parcel$export(module.exports, "assign", function () { return $62d8b8607391edfa$export$e6e34fd1f2686227; });
$parcel$export(module.exports, "forEach", function () { return $62d8b8607391edfa$export$4b80e395e36b5a56; });
$parcel$export(module.exports, "length", function () { return $62d8b8607391edfa$export$f24224f1c91d8156; });
$parcel$export(module.exports, "isEmpty", function () { return $62d8b8607391edfa$export$dd1bc94b04021eeb; });
$parcel$export(module.exports, "hasProperty", function () { return $62d8b8607391edfa$export$bf9617eaf5d2451; });
$parcel$export(module.exports, "equalFlat", function () { return $62d8b8607391edfa$export$4f1c34abb2bb4c8; });
$parcel$export(module.exports, "deepFreeze", function () { return $62d8b8607391edfa$export$7e32b29e1cb162e1; });
/**
 * Utility functions for working with EcmaScript objects.
 *
 * @module object
 */ /**
 * @return {Object<string,any>} obj
 */ const $62d8b8607391edfa$export$185802fd694ee1f5 = ()=>Object.create(null);
const $62d8b8607391edfa$export$e6e34fd1f2686227 = Object.assign;
const $62d8b8607391edfa$export$ed97f33186d4b816 = Object.keys;
const $62d8b8607391edfa$export$4b80e395e36b5a56 = (obj, f)=>{
    for(const key in obj)f(obj[key], key);
};
const $62d8b8607391edfa$export$871de8747c9eaa88 = (obj, f)=>{
    const results = [];
    for(const key in obj)results.push(f(obj[key], key));
    return results;
};
const $62d8b8607391edfa$export$f24224f1c91d8156 = (obj)=>$62d8b8607391edfa$export$ed97f33186d4b816(obj).length;
const $62d8b8607391edfa$export$346677f925de839c = (obj)=>$62d8b8607391edfa$export$ed97f33186d4b816(obj).length;
const $62d8b8607391edfa$export$ad14ef4001db2bcd = (obj, f)=>{
    for(const key in obj){
        if (f(obj[key], key)) return true;
    }
    return false;
};
const $62d8b8607391edfa$export$dd1bc94b04021eeb = (obj)=>{
    // eslint-disable-next-line
    for(const _k in obj)return false;
    return true;
};
const $62d8b8607391edfa$export$7ecc1a3b11b57dab = (obj, f)=>{
    for(const key in obj){
        if (!f(obj[key], key)) return false;
    }
    return true;
};
const $62d8b8607391edfa$export$bf9617eaf5d2451 = (obj, key)=>Object.prototype.hasOwnProperty.call(obj, key);
const $62d8b8607391edfa$export$4f1c34abb2bb4c8 = (a, b)=>a === b || $62d8b8607391edfa$export$346677f925de839c(a) === $62d8b8607391edfa$export$346677f925de839c(b) && $62d8b8607391edfa$export$7ecc1a3b11b57dab(a, (val, key)=>(val !== undefined || $62d8b8607391edfa$export$bf9617eaf5d2451(b, key)) && b[key] === val);
const $62d8b8607391edfa$export$792f3d81ea979f55 = Object.freeze;
const $62d8b8607391edfa$export$7e32b29e1cb162e1 = (o)=>{
    for(const key in o){
        const c = o[key];
        if (typeof c === "object" || typeof c === "function") $62d8b8607391edfa$export$7e32b29e1cb162e1(o[key]);
    }
    return $62d8b8607391edfa$export$792f3d81ea979f55(o);
};

});



parcelRegister("85H1q", function(module, exports) {

$parcel$export(module.exports, "Buffer", function () { return $5e4029a0026c7a4d$export$a143d493d941bafc; }, function (v) { return $5e4029a0026c7a4d$export$a143d493d941bafc = v; });
$parcel$export(module.exports, "INSPECT_MAX_BYTES", function () { return $5e4029a0026c7a4d$export$f99ded8fe4b79145; }, function (v) { return $5e4029a0026c7a4d$export$f99ded8fe4b79145 = v; });
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $5e4029a0026c7a4d$export$a143d493d941bafc;
var $5e4029a0026c7a4d$export$e4cf37d7f6fb9e0a;
var $5e4029a0026c7a4d$export$f99ded8fe4b79145;
var $5e4029a0026c7a4d$export$599f31c3813fae4d;
"use strict";

var $k3q6n = parcelRequire("k3q6n");

var $d2OHZ = parcelRequire("d2OHZ");
const $5e4029a0026c7a4d$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$5e4029a0026c7a4d$export$a143d493d941bafc = $5e4029a0026c7a4d$var$Buffer;
$5e4029a0026c7a4d$export$e4cf37d7f6fb9e0a = $5e4029a0026c7a4d$var$SlowBuffer;
$5e4029a0026c7a4d$export$f99ded8fe4b79145 = 50;
const $5e4029a0026c7a4d$var$K_MAX_LENGTH = 0x7fffffff;
$5e4029a0026c7a4d$export$599f31c3813fae4d = $5e4029a0026c7a4d$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $5e4029a0026c7a4d$var$Buffer.TYPED_ARRAY_SUPPORT = $5e4029a0026c7a4d$var$typedArraySupport();
if (!$5e4029a0026c7a4d$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $5e4029a0026c7a4d$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($5e4029a0026c7a4d$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!$5e4029a0026c7a4d$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($5e4029a0026c7a4d$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!$5e4029a0026c7a4d$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $5e4029a0026c7a4d$var$createBuffer(length) {
    if (length > $5e4029a0026c7a4d$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $5e4029a0026c7a4d$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $5e4029a0026c7a4d$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $5e4029a0026c7a4d$var$allocUnsafe(arg);
    }
    return $5e4029a0026c7a4d$var$from(arg, encodingOrOffset, length);
}
$5e4029a0026c7a4d$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $5e4029a0026c7a4d$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $5e4029a0026c7a4d$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $5e4029a0026c7a4d$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($5e4029a0026c7a4d$var$isInstance(value, ArrayBuffer) || value && $5e4029a0026c7a4d$var$isInstance(value.buffer, ArrayBuffer)) return $5e4029a0026c7a4d$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($5e4029a0026c7a4d$var$isInstance(value, SharedArrayBuffer) || value && $5e4029a0026c7a4d$var$isInstance(value.buffer, SharedArrayBuffer))) return $5e4029a0026c7a4d$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $5e4029a0026c7a4d$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $5e4029a0026c7a4d$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $5e4029a0026c7a4d$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $5e4029a0026c7a4d$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $5e4029a0026c7a4d$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($5e4029a0026c7a4d$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($5e4029a0026c7a4d$var$Buffer, Uint8Array);
function $5e4029a0026c7a4d$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $5e4029a0026c7a4d$var$alloc(size, fill, encoding) {
    $5e4029a0026c7a4d$var$assertSize(size);
    if (size <= 0) return $5e4029a0026c7a4d$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $5e4029a0026c7a4d$var$createBuffer(size).fill(fill, encoding) : $5e4029a0026c7a4d$var$createBuffer(size).fill(fill);
    return $5e4029a0026c7a4d$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $5e4029a0026c7a4d$var$Buffer.alloc = function(size, fill, encoding) {
    return $5e4029a0026c7a4d$var$alloc(size, fill, encoding);
};
function $5e4029a0026c7a4d$var$allocUnsafe(size) {
    $5e4029a0026c7a4d$var$assertSize(size);
    return $5e4029a0026c7a4d$var$createBuffer(size < 0 ? 0 : $5e4029a0026c7a4d$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $5e4029a0026c7a4d$var$Buffer.allocUnsafe = function(size) {
    return $5e4029a0026c7a4d$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $5e4029a0026c7a4d$var$Buffer.allocUnsafeSlow = function(size) {
    return $5e4029a0026c7a4d$var$allocUnsafe(size);
};
function $5e4029a0026c7a4d$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$5e4029a0026c7a4d$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    const length = $5e4029a0026c7a4d$var$byteLength(string, encoding) | 0;
    let buf = $5e4029a0026c7a4d$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $5e4029a0026c7a4d$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $5e4029a0026c7a4d$var$checked(array.length) | 0;
    const buf = $5e4029a0026c7a4d$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $5e4029a0026c7a4d$var$fromArrayView(arrayView) {
    if ($5e4029a0026c7a4d$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $5e4029a0026c7a4d$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $5e4029a0026c7a4d$var$fromArrayLike(arrayView);
}
function $5e4029a0026c7a4d$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $5e4029a0026c7a4d$var$Buffer.prototype);
    return buf;
}
function $5e4029a0026c7a4d$var$fromObject(obj) {
    if ($5e4029a0026c7a4d$var$Buffer.isBuffer(obj)) {
        const len = $5e4029a0026c7a4d$var$checked(obj.length) | 0;
        const buf = $5e4029a0026c7a4d$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $5e4029a0026c7a4d$var$numberIsNaN(obj.length)) return $5e4029a0026c7a4d$var$createBuffer(0);
        return $5e4029a0026c7a4d$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $5e4029a0026c7a4d$var$fromArrayLike(obj.data);
}
function $5e4029a0026c7a4d$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $5e4029a0026c7a4d$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $5e4029a0026c7a4d$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $5e4029a0026c7a4d$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $5e4029a0026c7a4d$var$Buffer.alloc(+length);
}
$5e4029a0026c7a4d$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $5e4029a0026c7a4d$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$5e4029a0026c7a4d$var$Buffer.compare = function compare(a, b) {
    if ($5e4029a0026c7a4d$var$isInstance(a, Uint8Array)) a = $5e4029a0026c7a4d$var$Buffer.from(a, a.offset, a.byteLength);
    if ($5e4029a0026c7a4d$var$isInstance(b, Uint8Array)) b = $5e4029a0026c7a4d$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$5e4029a0026c7a4d$var$Buffer.isBuffer(a) || !$5e4029a0026c7a4d$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$5e4029a0026c7a4d$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$5e4029a0026c7a4d$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $5e4029a0026c7a4d$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $5e4029a0026c7a4d$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($5e4029a0026c7a4d$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$5e4029a0026c7a4d$var$Buffer.isBuffer(buf)) buf = $5e4029a0026c7a4d$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$5e4029a0026c7a4d$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $5e4029a0026c7a4d$var$byteLength(string, encoding) {
    if ($5e4029a0026c7a4d$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $5e4029a0026c7a4d$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $5e4029a0026c7a4d$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $5e4029a0026c7a4d$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $5e4029a0026c7a4d$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$5e4029a0026c7a4d$var$Buffer.byteLength = $5e4029a0026c7a4d$var$byteLength;
function $5e4029a0026c7a4d$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $5e4029a0026c7a4d$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $5e4029a0026c7a4d$var$utf8Slice(this, start, end);
        case "ascii":
            return $5e4029a0026c7a4d$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $5e4029a0026c7a4d$var$latin1Slice(this, start, end);
        case "base64":
            return $5e4029a0026c7a4d$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $5e4029a0026c7a4d$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$5e4029a0026c7a4d$var$Buffer.prototype._isBuffer = true;
function $5e4029a0026c7a4d$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$5e4029a0026c7a4d$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(let i = 0; i < len; i += 2)$5e4029a0026c7a4d$var$swap(this, i, i + 1);
    return this;
};
$5e4029a0026c7a4d$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(let i = 0; i < len; i += 4){
        $5e4029a0026c7a4d$var$swap(this, i, i + 3);
        $5e4029a0026c7a4d$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$5e4029a0026c7a4d$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(let i = 0; i < len; i += 8){
        $5e4029a0026c7a4d$var$swap(this, i, i + 7);
        $5e4029a0026c7a4d$var$swap(this, i + 1, i + 6);
        $5e4029a0026c7a4d$var$swap(this, i + 2, i + 5);
        $5e4029a0026c7a4d$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$5e4029a0026c7a4d$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $5e4029a0026c7a4d$var$utf8Slice(this, 0, length);
    return $5e4029a0026c7a4d$var$slowToString.apply(this, arguments);
};
$5e4029a0026c7a4d$var$Buffer.prototype.toLocaleString = $5e4029a0026c7a4d$var$Buffer.prototype.toString;
$5e4029a0026c7a4d$var$Buffer.prototype.equals = function equals(b) {
    if (!$5e4029a0026c7a4d$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $5e4029a0026c7a4d$var$Buffer.compare(this, b) === 0;
};
$5e4029a0026c7a4d$var$Buffer.prototype.inspect = function inspect() {
    let str = "";
    const max = $5e4029a0026c7a4d$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($5e4029a0026c7a4d$var$customInspectSymbol) $5e4029a0026c7a4d$var$Buffer.prototype[$5e4029a0026c7a4d$var$customInspectSymbol] = $5e4029a0026c7a4d$var$Buffer.prototype.inspect;
$5e4029a0026c7a4d$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($5e4029a0026c7a4d$var$isInstance(target, Uint8Array)) target = $5e4029a0026c7a4d$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$5e4029a0026c7a4d$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $5e4029a0026c7a4d$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($5e4029a0026c7a4d$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $5e4029a0026c7a4d$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($5e4029a0026c7a4d$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $5e4029a0026c7a4d$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $5e4029a0026c7a4d$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $5e4029a0026c7a4d$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$5e4029a0026c7a4d$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$5e4029a0026c7a4d$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $5e4029a0026c7a4d$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$5e4029a0026c7a4d$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $5e4029a0026c7a4d$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $5e4029a0026c7a4d$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($5e4029a0026c7a4d$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $5e4029a0026c7a4d$var$utf8Write(buf, string, offset, length) {
    return $5e4029a0026c7a4d$var$blitBuffer($5e4029a0026c7a4d$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $5e4029a0026c7a4d$var$asciiWrite(buf, string, offset, length) {
    return $5e4029a0026c7a4d$var$blitBuffer($5e4029a0026c7a4d$var$asciiToBytes(string), buf, offset, length);
}
function $5e4029a0026c7a4d$var$base64Write(buf, string, offset, length) {
    return $5e4029a0026c7a4d$var$blitBuffer($5e4029a0026c7a4d$var$base64ToBytes(string), buf, offset, length);
}
function $5e4029a0026c7a4d$var$ucs2Write(buf, string, offset, length) {
    return $5e4029a0026c7a4d$var$blitBuffer($5e4029a0026c7a4d$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$5e4029a0026c7a4d$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    let loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $5e4029a0026c7a4d$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $5e4029a0026c7a4d$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $5e4029a0026c7a4d$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $5e4029a0026c7a4d$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $5e4029a0026c7a4d$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$5e4029a0026c7a4d$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $5e4029a0026c7a4d$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $k3q6n.fromByteArray(buf);
    else return $k3q6n.fromByteArray(buf.slice(start, end));
}
function $5e4029a0026c7a4d$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $5e4029a0026c7a4d$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $5e4029a0026c7a4d$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $5e4029a0026c7a4d$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $5e4029a0026c7a4d$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = "";
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $5e4029a0026c7a4d$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $5e4029a0026c7a4d$var$asciiSlice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $5e4029a0026c7a4d$var$latin1Slice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $5e4029a0026c7a4d$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = "";
    for(let i = start; i < end; ++i)out += $5e4029a0026c7a4d$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $5e4029a0026c7a4d$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$5e4029a0026c7a4d$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $5e4029a0026c7a4d$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $5e4029a0026c7a4d$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$5e4029a0026c7a4d$var$Buffer.prototype.readUintLE = $5e4029a0026c7a4d$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $5e4029a0026c7a4d$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$5e4029a0026c7a4d$var$Buffer.prototype.readUintBE = $5e4029a0026c7a4d$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $5e4029a0026c7a4d$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$5e4029a0026c7a4d$var$Buffer.prototype.readUint8 = $5e4029a0026c7a4d$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5e4029a0026c7a4d$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$5e4029a0026c7a4d$var$Buffer.prototype.readUint16LE = $5e4029a0026c7a4d$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5e4029a0026c7a4d$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$5e4029a0026c7a4d$var$Buffer.prototype.readUint16BE = $5e4029a0026c7a4d$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5e4029a0026c7a4d$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$5e4029a0026c7a4d$var$Buffer.prototype.readUint32LE = $5e4029a0026c7a4d$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5e4029a0026c7a4d$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$5e4029a0026c7a4d$var$Buffer.prototype.readUint32BE = $5e4029a0026c7a4d$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5e4029a0026c7a4d$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$5e4029a0026c7a4d$var$Buffer.prototype.readBigUInt64LE = $5e4029a0026c7a4d$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $5e4029a0026c7a4d$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $5e4029a0026c7a4d$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$5e4029a0026c7a4d$var$Buffer.prototype.readBigUInt64BE = $5e4029a0026c7a4d$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $5e4029a0026c7a4d$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $5e4029a0026c7a4d$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$5e4029a0026c7a4d$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $5e4029a0026c7a4d$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$5e4029a0026c7a4d$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $5e4029a0026c7a4d$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$5e4029a0026c7a4d$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5e4029a0026c7a4d$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$5e4029a0026c7a4d$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5e4029a0026c7a4d$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$5e4029a0026c7a4d$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5e4029a0026c7a4d$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$5e4029a0026c7a4d$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5e4029a0026c7a4d$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$5e4029a0026c7a4d$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5e4029a0026c7a4d$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$5e4029a0026c7a4d$var$Buffer.prototype.readBigInt64LE = $5e4029a0026c7a4d$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $5e4029a0026c7a4d$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $5e4029a0026c7a4d$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$5e4029a0026c7a4d$var$Buffer.prototype.readBigInt64BE = $5e4029a0026c7a4d$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $5e4029a0026c7a4d$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $5e4029a0026c7a4d$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$5e4029a0026c7a4d$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5e4029a0026c7a4d$var$checkOffset(offset, 4, this.length);
    return $d2OHZ.read(this, offset, true, 23, 4);
};
$5e4029a0026c7a4d$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5e4029a0026c7a4d$var$checkOffset(offset, 4, this.length);
    return $d2OHZ.read(this, offset, false, 23, 4);
};
$5e4029a0026c7a4d$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5e4029a0026c7a4d$var$checkOffset(offset, 8, this.length);
    return $d2OHZ.read(this, offset, true, 52, 8);
};
$5e4029a0026c7a4d$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5e4029a0026c7a4d$var$checkOffset(offset, 8, this.length);
    return $d2OHZ.read(this, offset, false, 52, 8);
};
function $5e4029a0026c7a4d$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$5e4029a0026c7a4d$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$5e4029a0026c7a4d$var$Buffer.prototype.writeUintLE = $5e4029a0026c7a4d$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $5e4029a0026c7a4d$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$5e4029a0026c7a4d$var$Buffer.prototype.writeUintBE = $5e4029a0026c7a4d$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $5e4029a0026c7a4d$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$5e4029a0026c7a4d$var$Buffer.prototype.writeUint8 = $5e4029a0026c7a4d$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $5e4029a0026c7a4d$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$5e4029a0026c7a4d$var$Buffer.prototype.writeUint16LE = $5e4029a0026c7a4d$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $5e4029a0026c7a4d$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$5e4029a0026c7a4d$var$Buffer.prototype.writeUint16BE = $5e4029a0026c7a4d$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $5e4029a0026c7a4d$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$5e4029a0026c7a4d$var$Buffer.prototype.writeUint32LE = $5e4029a0026c7a4d$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $5e4029a0026c7a4d$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$5e4029a0026c7a4d$var$Buffer.prototype.writeUint32BE = $5e4029a0026c7a4d$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $5e4029a0026c7a4d$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $5e4029a0026c7a4d$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $5e4029a0026c7a4d$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $5e4029a0026c7a4d$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $5e4029a0026c7a4d$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$5e4029a0026c7a4d$var$Buffer.prototype.writeBigUInt64LE = $5e4029a0026c7a4d$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $5e4029a0026c7a4d$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$5e4029a0026c7a4d$var$Buffer.prototype.writeBigUInt64BE = $5e4029a0026c7a4d$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $5e4029a0026c7a4d$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$5e4029a0026c7a4d$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $5e4029a0026c7a4d$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$5e4029a0026c7a4d$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $5e4029a0026c7a4d$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$5e4029a0026c7a4d$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $5e4029a0026c7a4d$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$5e4029a0026c7a4d$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $5e4029a0026c7a4d$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$5e4029a0026c7a4d$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $5e4029a0026c7a4d$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$5e4029a0026c7a4d$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $5e4029a0026c7a4d$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$5e4029a0026c7a4d$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $5e4029a0026c7a4d$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$5e4029a0026c7a4d$var$Buffer.prototype.writeBigInt64LE = $5e4029a0026c7a4d$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $5e4029a0026c7a4d$var$wrtBigUInt64LE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
$5e4029a0026c7a4d$var$Buffer.prototype.writeBigInt64BE = $5e4029a0026c7a4d$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $5e4029a0026c7a4d$var$wrtBigUInt64BE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
function $5e4029a0026c7a4d$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $5e4029a0026c7a4d$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $5e4029a0026c7a4d$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $d2OHZ.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$5e4029a0026c7a4d$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $5e4029a0026c7a4d$var$writeFloat(this, value, offset, true, noAssert);
};
$5e4029a0026c7a4d$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $5e4029a0026c7a4d$var$writeFloat(this, value, offset, false, noAssert);
};
function $5e4029a0026c7a4d$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $5e4029a0026c7a4d$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $d2OHZ.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$5e4029a0026c7a4d$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $5e4029a0026c7a4d$var$writeDouble(this, value, offset, true, noAssert);
};
$5e4029a0026c7a4d$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $5e4029a0026c7a4d$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$5e4029a0026c7a4d$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$5e4029a0026c7a4d$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$5e4029a0026c7a4d$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$5e4029a0026c7a4d$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $5e4029a0026c7a4d$var$Buffer.isBuffer(val) ? val : $5e4029a0026c7a4d$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $5e4029a0026c7a4d$var$errors = {};
function $5e4029a0026c7a4d$var$E(sym, getMessage, Base) {
    $5e4029a0026c7a4d$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, "message", {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, "code", {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$5e4029a0026c7a4d$var$E("ERR_BUFFER_OUT_OF_BOUNDS", function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return "Attempt to access memory outside buffer bounds";
}, RangeError);
$5e4029a0026c7a4d$var$E("ERR_INVALID_ARG_TYPE", function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$5e4029a0026c7a4d$var$E("ERR_OUT_OF_RANGE", function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $5e4029a0026c7a4d$var$addNumericalSeparator(String(input));
    else if (typeof input === "bigint") {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $5e4029a0026c7a4d$var$addNumericalSeparator(received);
        received += "n";
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $5e4029a0026c7a4d$var$addNumericalSeparator(val) {
    let res = "";
    let i = val.length;
    const start = val[0] === "-" ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $5e4029a0026c7a4d$var$checkBounds(buf, offset, byteLength) {
    $5e4029a0026c7a4d$var$validateNumber(offset, "offset");
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $5e4029a0026c7a4d$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $5e4029a0026c7a4d$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === "bigint" ? "n" : "";
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $5e4029a0026c7a4d$var$errors.ERR_OUT_OF_RANGE("value", range, value);
    }
    $5e4029a0026c7a4d$var$checkBounds(buf, offset, byteLength);
}
function $5e4029a0026c7a4d$var$validateNumber(value, name) {
    if (typeof value !== "number") throw new $5e4029a0026c7a4d$var$errors.ERR_INVALID_ARG_TYPE(name, "number", value);
}
function $5e4029a0026c7a4d$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $5e4029a0026c7a4d$var$validateNumber(value, type);
        throw new $5e4029a0026c7a4d$var$errors.ERR_OUT_OF_RANGE(type || "offset", "an integer", value);
    }
    if (length < 0) throw new $5e4029a0026c7a4d$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $5e4029a0026c7a4d$var$errors.ERR_OUT_OF_RANGE(type || "offset", `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $5e4029a0026c7a4d$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $5e4029a0026c7a4d$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($5e4029a0026c7a4d$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $5e4029a0026c7a4d$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $5e4029a0026c7a4d$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $5e4029a0026c7a4d$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $5e4029a0026c7a4d$var$base64ToBytes(str) {
    return $k3q6n.toByteArray($5e4029a0026c7a4d$var$base64clean(str));
}
function $5e4029a0026c7a4d$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $5e4029a0026c7a4d$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $5e4029a0026c7a4d$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $5e4029a0026c7a4d$var$hexSliceLookupTable = function() {
    const alphabet = "0123456789abcdef";
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $5e4029a0026c7a4d$var$defineBigIntMethod(fn) {
    return typeof BigInt === "undefined" ? $5e4029a0026c7a4d$var$BufferBigIntNotDefined : fn;
}
function $5e4029a0026c7a4d$var$BufferBigIntNotDefined() {
    throw new Error("BigInt not supported");
}

});
parcelRegister("k3q6n", function(module, exports) {

$parcel$export(module.exports, "toByteArray", function () { return $e99855b80474511a$export$d622b2ad8d90c771; }, function (v) { return $e99855b80474511a$export$d622b2ad8d90c771 = v; });
$parcel$export(module.exports, "fromByteArray", function () { return $e99855b80474511a$export$6100ba28696e12de; }, function (v) { return $e99855b80474511a$export$6100ba28696e12de = v; });
var $e99855b80474511a$export$a48f0734ac7c2329;
var $e99855b80474511a$export$d622b2ad8d90c771;
var $e99855b80474511a$export$6100ba28696e12de;
"use strict";
$e99855b80474511a$export$a48f0734ac7c2329 = $e99855b80474511a$var$byteLength;
$e99855b80474511a$export$d622b2ad8d90c771 = $e99855b80474511a$var$toByteArray;
$e99855b80474511a$export$6100ba28696e12de = $e99855b80474511a$var$fromByteArray;
var $e99855b80474511a$var$lookup = [];
var $e99855b80474511a$var$revLookup = [];
var $e99855b80474511a$var$Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var $e99855b80474511a$var$code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var $e99855b80474511a$var$i = 0, $e99855b80474511a$var$len = $e99855b80474511a$var$code.length; $e99855b80474511a$var$i < $e99855b80474511a$var$len; ++$e99855b80474511a$var$i){
    $e99855b80474511a$var$lookup[$e99855b80474511a$var$i] = $e99855b80474511a$var$code[$e99855b80474511a$var$i];
    $e99855b80474511a$var$revLookup[$e99855b80474511a$var$code.charCodeAt($e99855b80474511a$var$i)] = $e99855b80474511a$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$e99855b80474511a$var$revLookup["-".charCodeAt(0)] = 62;
$e99855b80474511a$var$revLookup["_".charCodeAt(0)] = 63;
function $e99855b80474511a$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $e99855b80474511a$var$byteLength(b64) {
    var lens = $e99855b80474511a$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $e99855b80474511a$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $e99855b80474511a$var$toByteArray(b64) {
    var tmp;
    var lens = $e99855b80474511a$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $e99855b80474511a$var$Arr($e99855b80474511a$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $e99855b80474511a$var$revLookup[b64.charCodeAt(i)] << 18 | $e99855b80474511a$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $e99855b80474511a$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $e99855b80474511a$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $e99855b80474511a$var$revLookup[b64.charCodeAt(i)] << 2 | $e99855b80474511a$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $e99855b80474511a$var$revLookup[b64.charCodeAt(i)] << 10 | $e99855b80474511a$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $e99855b80474511a$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $e99855b80474511a$var$tripletToBase64(num) {
    return $e99855b80474511a$var$lookup[num >> 18 & 0x3F] + $e99855b80474511a$var$lookup[num >> 12 & 0x3F] + $e99855b80474511a$var$lookup[num >> 6 & 0x3F] + $e99855b80474511a$var$lookup[num & 0x3F];
}
function $e99855b80474511a$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($e99855b80474511a$var$tripletToBase64(tmp));
    }
    return output.join("");
}
function $e99855b80474511a$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($e99855b80474511a$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($e99855b80474511a$var$lookup[tmp >> 2] + $e99855b80474511a$var$lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($e99855b80474511a$var$lookup[tmp >> 10] + $e99855b80474511a$var$lookup[tmp >> 4 & 0x3F] + $e99855b80474511a$var$lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}

});

parcelRegister("d2OHZ", function(module, exports) {

$parcel$export(module.exports, "read", function () { return $97f2cbef79bb903e$export$aafa59e2e03f2942; }, function (v) { return $97f2cbef79bb903e$export$aafa59e2e03f2942 = v; });
$parcel$export(module.exports, "write", function () { return $97f2cbef79bb903e$export$68d8715fc104d294; }, function (v) { return $97f2cbef79bb903e$export$68d8715fc104d294 = v; });
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $97f2cbef79bb903e$export$aafa59e2e03f2942;
var $97f2cbef79bb903e$export$68d8715fc104d294;
$97f2cbef79bb903e$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$97f2cbef79bb903e$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});



parcelRegister("6nwkt", function(module, exports) {

$parcel$export(module.exports, "print", function () { return $4a4df7fbc986993a$export$c2d084dc44961371; });
$parcel$export(module.exports, "warn", function () { return $4a4df7fbc986993a$export$c106dd0671a0fc2d; });
$parcel$export(module.exports, "BOLD", function () { return (parcelRequire("esuCY")).BOLD; });
$parcel$export(module.exports, "UNBOLD", function () { return (parcelRequire("esuCY")).UNBOLD; });
$parcel$export(module.exports, "RED", function () { return (parcelRequire("esuCY")).RED; });
$parcel$export(module.exports, "ORANGE", function () { return (parcelRequire("esuCY")).ORANGE; });
/**
 * Isomorphic logging module with support for colors!
 *
 * @module logging
 */ 
var $3LZef = parcelRequire("3LZef");

var $eq375 = parcelRequire("eq375");

var $9VuZf = parcelRequire("9VuZf");

var $ekru0 = parcelRequire("ekru0");

var $eKi88 = parcelRequire("eKi88");

var $2U6oo = parcelRequire("2U6oo");

var $5wQnU = parcelRequire("5wQnU");

var $6O4IB = parcelRequire("6O4IB");

var $esuCY = parcelRequire("esuCY");
/**
 * @type {Object<Symbol,pair.Pair<string,string>>}
 */ const $4a4df7fbc986993a$var$_browserStyleMap = {
    [$esuCY.BOLD]: $9VuZf.create("font-weight", "bold"),
    [$esuCY.UNBOLD]: $9VuZf.create("font-weight", "normal"),
    [$esuCY.BLUE]: $9VuZf.create("color", "blue"),
    [$esuCY.GREEN]: $9VuZf.create("color", "green"),
    [$esuCY.GREY]: $9VuZf.create("color", "grey"),
    [$esuCY.RED]: $9VuZf.create("color", "red"),
    [$esuCY.PURPLE]: $9VuZf.create("color", "purple"),
    [$esuCY.ORANGE]: $9VuZf.create("color", "orange"),
    [$esuCY.UNCOLOR]: $9VuZf.create("color", "black")
};
/**
 * @param {Array<string|Symbol|Object|number|function():any>} args
 * @return {Array<string|object|number>}
 */ /* c8 ignore start */ const $4a4df7fbc986993a$var$computeBrowserLoggingArgs = (args)=>{
    if (args.length === 1 && args[0]?.constructor === Function) args = /** @type {Array<string|Symbol|Object|number>} */ /** @type {[function]} */ args[0]();
    const strBuilder = [];
    const styles = [];
    const currentStyle = $2U6oo.create();
    /**
   * @type {Array<string|Object|number>}
   */ let logArgs = [];
    // try with formatting until we find something unsupported
    let i = 0;
    for(; i < args.length; i++){
        const arg = args[i];
        // @ts-ignore
        const style = $4a4df7fbc986993a$var$_browserStyleMap[arg];
        if (style !== undefined) currentStyle.set(style.left, style.right);
        else {
            if (arg === undefined) break;
            if (arg.constructor === String || arg.constructor === Number) {
                const style = $ekru0.mapToStyleString(currentStyle);
                if (i > 0 || style.length > 0) {
                    strBuilder.push("%c" + arg);
                    styles.push(style);
                } else strBuilder.push(arg);
            } else break;
        }
    }
    if (i > 0) {
        // create logArgs with what we have so far
        logArgs = styles;
        logArgs.unshift(strBuilder.join(""));
    }
    // append the rest
    for(; i < args.length; i++){
        const arg = args[i];
        if (!(arg instanceof Symbol)) logArgs.push(arg);
    }
    return logArgs;
};
/* c8 ignore stop */ /* c8 ignore start */ const $4a4df7fbc986993a$var$computeLoggingArgs = $3LZef.supportsColor ? $4a4df7fbc986993a$var$computeBrowserLoggingArgs : $esuCY.computeNoColorLoggingArgs;
const $4a4df7fbc986993a$export$c2d084dc44961371 = (...args)=>{
    console.log(...$4a4df7fbc986993a$var$computeLoggingArgs(args));
    /* c8 ignore next */ $4a4df7fbc986993a$export$6f0283bff34730a1.forEach((vc)=>vc.print(args));
};
const $4a4df7fbc986993a$export$c106dd0671a0fc2d = (...args)=>{
    console.warn(...$4a4df7fbc986993a$var$computeLoggingArgs(args));
    args.unshift($esuCY.ORANGE);
    $4a4df7fbc986993a$export$6f0283bff34730a1.forEach((vc)=>vc.print(args));
};
const $4a4df7fbc986993a$export$55ee1551a3f962e6 = (err)=>{
    console.error(err);
    $4a4df7fbc986993a$export$6f0283bff34730a1.forEach((vc)=>vc.printError(err));
};
const $4a4df7fbc986993a$export$85acd411250ab137 = (url, height)=>{
    if ($3LZef.isBrowser) console.log("%c                      ", `font-size: ${height}px; background-size: contain; background-repeat: no-repeat; background-image: url(${url})`);
    $4a4df7fbc986993a$export$6f0283bff34730a1.forEach((vc)=>vc.printImg(url, height));
};
const $4a4df7fbc986993a$export$fcd48d8a033dbfbf = (base64, height)=>$4a4df7fbc986993a$export$85acd411250ab137(`data:image/gif;base64,${base64}`, height);
const $4a4df7fbc986993a$export$e5e25fbcc1f7affe = (...args)=>{
    console.group(...$4a4df7fbc986993a$var$computeLoggingArgs(args));
    /* c8 ignore next */ $4a4df7fbc986993a$export$6f0283bff34730a1.forEach((vc)=>vc.group(args));
};
const $4a4df7fbc986993a$export$488ef8fb3416a29f = (...args)=>{
    console.groupCollapsed(...$4a4df7fbc986993a$var$computeLoggingArgs(args));
    /* c8 ignore next */ $4a4df7fbc986993a$export$6f0283bff34730a1.forEach((vc)=>vc.groupCollapsed(args));
};
const $4a4df7fbc986993a$export$a57f3dfe595273e6 = ()=>{
    console.groupEnd();
    /* c8 ignore next */ $4a4df7fbc986993a$export$6f0283bff34730a1.forEach((vc)=>vc.groupEnd());
};
const $4a4df7fbc986993a$export$76dff282388623b3 = (createNode)=>$4a4df7fbc986993a$export$6f0283bff34730a1.forEach((vc)=>vc.printDom(createNode()));
const $4a4df7fbc986993a$export$98f2e847362d891 = (canvas, height)=>$4a4df7fbc986993a$export$85acd411250ab137(canvas.toDataURL(), height);
const $4a4df7fbc986993a$export$6f0283bff34730a1 = $eq375.create();
/**
 * @param {Array<string|Symbol|Object|number>} args
 * @return {Array<Element>}
 */ /* c8 ignore start */ const $4a4df7fbc986993a$var$_computeLineSpans = (args)=>{
    const spans = [];
    const currentStyle = new Map();
    // try with formatting until we find something unsupported
    let i = 0;
    for(; i < args.length; i++){
        let arg = args[i];
        // @ts-ignore
        const style = $4a4df7fbc986993a$var$_browserStyleMap[arg];
        if (style !== undefined) currentStyle.set(style.left, style.right);
        else {
            if (arg === undefined) arg = "undefined ";
            if (arg.constructor === String || arg.constructor === Number) {
                // @ts-ignore
                const span = $ekru0.element("span", [
                    $9VuZf.create("style", $ekru0.mapToStyleString(currentStyle))
                ], [
                    $ekru0.text(arg.toString())
                ]);
                if (span.innerHTML === "") span.innerHTML = "&nbsp;";
                spans.push(span);
            } else break;
        }
    }
    // append the rest
    for(; i < args.length; i++){
        let content = args[i];
        if (!(content instanceof Symbol)) {
            if (content.constructor !== String && content.constructor !== Number) content = " " + $eKi88.stringify(content) + " ";
            spans.push($ekru0.element("span", [], [
                $ekru0.text(/** @type {string} */ content)
            ]));
        }
    }
    return spans;
};
/* c8 ignore stop */ const $4a4df7fbc986993a$var$lineStyle = "font-family:monospace;border-bottom:1px solid #e2e2e2;padding:2px;";
class $4a4df7fbc986993a$export$79dd518d42f6d7a1 {
    /**
   * @param {Element} dom
   */ constructor(dom){
        this.dom = dom;
        /**
     * @type {Element}
     */ this.ccontainer = this.dom;
        this.depth = 0;
        $4a4df7fbc986993a$export$6f0283bff34730a1.add(this);
    }
    /**
   * @param {Array<string|Symbol|Object|number>} args
   * @param {boolean} collapsed
   */ group(args, collapsed = false) {
        $5wQnU.enqueue(()=>{
            const triangleDown = $ekru0.element("span", [
                $9VuZf.create("hidden", collapsed),
                $9VuZf.create("style", "color:grey;font-size:120%;")
            ], [
                $ekru0.text("\u25BC")
            ]);
            const triangleRight = $ekru0.element("span", [
                $9VuZf.create("hidden", !collapsed),
                $9VuZf.create("style", "color:grey;font-size:125%;")
            ], [
                $ekru0.text("\u25B6")
            ]);
            const content = $ekru0.element("div", [
                $9VuZf.create("style", `${$4a4df7fbc986993a$var$lineStyle};padding-left:${this.depth * 10}px`)
            ], [
                triangleDown,
                triangleRight,
                $ekru0.text(" ")
            ].concat($4a4df7fbc986993a$var$_computeLineSpans(args)));
            const nextContainer = $ekru0.element("div", [
                $9VuZf.create("hidden", collapsed)
            ]);
            const nextLine = $ekru0.element("div", [], [
                content,
                nextContainer
            ]);
            $ekru0.append(this.ccontainer, [
                nextLine
            ]);
            this.ccontainer = nextContainer;
            this.depth++;
            // when header is clicked, collapse/uncollapse container
            $ekru0.addEventListener(content, "click", (_event)=>{
                nextContainer.toggleAttribute("hidden");
                triangleDown.toggleAttribute("hidden");
                triangleRight.toggleAttribute("hidden");
            });
        });
    }
    /**
   * @param {Array<string|Symbol|Object|number>} args
   */ groupCollapsed(args) {
        this.group(args, true);
    }
    groupEnd() {
        $5wQnU.enqueue(()=>{
            if (this.depth > 0) {
                this.depth--;
                // @ts-ignore
                this.ccontainer = this.ccontainer.parentElement.parentElement;
            }
        });
    }
    /**
   * @param {Array<string|Symbol|Object|number>} args
   */ print(args) {
        $5wQnU.enqueue(()=>{
            $ekru0.append(this.ccontainer, [
                $ekru0.element("div", [
                    $9VuZf.create("style", `${$4a4df7fbc986993a$var$lineStyle};padding-left:${this.depth * 10}px`)
                ], $4a4df7fbc986993a$var$_computeLineSpans(args))
            ]);
        });
    }
    /**
   * @param {Error} err
   */ printError(err) {
        this.print([
            $esuCY.RED,
            $esuCY.BOLD,
            err.toString()
        ]);
    }
    /**
   * @param {string} url
   * @param {number} height
   */ printImg(url, height) {
        $5wQnU.enqueue(()=>{
            $ekru0.append(this.ccontainer, [
                $ekru0.element("img", [
                    $9VuZf.create("src", url),
                    $9VuZf.create("height", `${$6O4IB.round(height * 1.5)}px`)
                ])
            ]);
        });
    }
    /**
   * @param {Node} node
   */ printDom(node) {
        $5wQnU.enqueue(()=>{
            $ekru0.append(this.ccontainer, [
                node
            ]);
        });
    }
    destroy() {
        $5wQnU.enqueue(()=>{
            $4a4df7fbc986993a$export$6f0283bff34730a1.delete(this);
        });
    }
}
const $4a4df7fbc986993a$export$3b589da4ab12cf23 = (dom)=>new $4a4df7fbc986993a$export$79dd518d42f6d7a1(dom);
const $4a4df7fbc986993a$export$c2977e725d59a2fd = (moduleName)=>$esuCY.createModuleLogger($4a4df7fbc986993a$export$c2d084dc44961371, moduleName);

});
parcelRegister("9VuZf", function(module, exports) {

$parcel$export(module.exports, "create", function () { return $73a17944017a92a4$export$185802fd694ee1f5; });
$parcel$export(module.exports, "forEach", function () { return $73a17944017a92a4$export$4b80e395e36b5a56; });
/**
 * Working with value pairs.
 *
 * @module pair
 */ /**
 * @template L,R
 */ class $73a17944017a92a4$export$d63d7cff08fe4dc9 {
    /**
   * @param {L} left
   * @param {R} right
   */ constructor(left, right){
        this.left = left;
        this.right = right;
    }
}
const $73a17944017a92a4$export$185802fd694ee1f5 = (left, right)=>new $73a17944017a92a4$export$d63d7cff08fe4dc9(left, right);
const $73a17944017a92a4$export$ca0ea131672c5a9b = (right, left)=>new $73a17944017a92a4$export$d63d7cff08fe4dc9(left, right);
const $73a17944017a92a4$export$4b80e395e36b5a56 = (arr, f)=>arr.forEach((p)=>f(p.left, p.right));
const $73a17944017a92a4$export$871de8747c9eaa88 = (arr, f)=>arr.map((p)=>f(p.left, p.right));

});

parcelRegister("ekru0", function(module, exports) {

$parcel$export(module.exports, "append", function () { return $a6e8407c0e27ceff$export$10d8903dec122b9d; });
$parcel$export(module.exports, "addEventListener", function () { return $a6e8407c0e27ceff$export$3f65cefe8380dbea; });
$parcel$export(module.exports, "element", function () { return $a6e8407c0e27ceff$export$8454457683f90105; });
$parcel$export(module.exports, "text", function () { return $a6e8407c0e27ceff$export$6f093cfa640b7166; });
$parcel$export(module.exports, "mapToStyleString", function () { return $a6e8407c0e27ceff$export$7d9cafe158c3b49; });
/* eslint-env browser */ /**
 * Utility module to work with the DOM.
 *
 * @module dom
 */ 
var $9VuZf = parcelRequire("9VuZf");

var $2U6oo = parcelRequire("2U6oo");
const $a6e8407c0e27ceff$export$2a111da947c407d2 = /** @type {Document} */ typeof document !== "undefined" ? document : {};
const $a6e8407c0e27ceff$export$c8a8987d4410bf2d = (name)=>$a6e8407c0e27ceff$export$2a111da947c407d2.createElement(name);
const $a6e8407c0e27ceff$export$fb51152cd5328759 = ()=>$a6e8407c0e27ceff$export$2a111da947c407d2.createDocumentFragment();
const $a6e8407c0e27ceff$export$b2ce9ad90858ed7a = (text)=>$a6e8407c0e27ceff$export$2a111da947c407d2.createTextNode(text);
const $a6e8407c0e27ceff$export$fb621bb527230cda = /** @type {DOMParser} */ typeof DOMParser !== "undefined" ? new DOMParser() : null;
const $a6e8407c0e27ceff$export$77c9ee5a14f9d7cf = (el, name, opts)=>el.dispatchEvent(new CustomEvent(name, opts));
const $a6e8407c0e27ceff$export$74da2cba014bdc09 = (el, attrs)=>{
    $9VuZf.forEach(attrs, (key, value)=>{
        if (value === false) el.removeAttribute(key);
        else if (value === true) el.setAttribute(key, "");
        else // @ts-ignore
        el.setAttribute(key, value);
    });
    return el;
};
const $a6e8407c0e27ceff$export$ba744f7d152abea1 = (el, attrs)=>{
    attrs.forEach((value, key)=>{
        el.setAttribute(key, value);
    });
    return el;
};
const $a6e8407c0e27ceff$export$f00aeb236b6f05af = (children)=>{
    const fragment = $a6e8407c0e27ceff$export$fb51152cd5328759();
    for(let i = 0; i < children.length; i++)$a6e8407c0e27ceff$export$1b8e57c9ea42f1d2(fragment, children[i]);
    return fragment;
};
const $a6e8407c0e27ceff$export$10d8903dec122b9d = (parent, nodes)=>{
    $a6e8407c0e27ceff$export$1b8e57c9ea42f1d2(parent, $a6e8407c0e27ceff$export$f00aeb236b6f05af(nodes));
    return parent;
};
const $a6e8407c0e27ceff$export$cd7f480d6b8286c3 = (el)=>el.remove();
const $a6e8407c0e27ceff$export$3f65cefe8380dbea = (el, name, f)=>el.addEventListener(name, f);
const $a6e8407c0e27ceff$export$8ff9f68337b520c0 = (el, name, f)=>el.removeEventListener(name, f);
const $a6e8407c0e27ceff$export$40a4ed63e5cb7043 = (node, listeners)=>{
    $9VuZf.forEach(listeners, (name, f)=>$a6e8407c0e27ceff$export$3f65cefe8380dbea(node, name, f));
    return node;
};
const $a6e8407c0e27ceff$export$8c7b13b21690651d = (node, listeners)=>{
    $9VuZf.forEach(listeners, (name, f)=>$a6e8407c0e27ceff$export$8ff9f68337b520c0(node, name, f));
    return node;
};
const $a6e8407c0e27ceff$export$8454457683f90105 = (name, attrs = [], children = [])=>$a6e8407c0e27ceff$export$10d8903dec122b9d($a6e8407c0e27ceff$export$74da2cba014bdc09($a6e8407c0e27ceff$export$c8a8987d4410bf2d(name), attrs), children);
const $a6e8407c0e27ceff$export$67ea982130081db = (width, height)=>{
    const c = /** @type {HTMLCanvasElement} */ $a6e8407c0e27ceff$export$c8a8987d4410bf2d("canvas");
    c.height = height;
    c.width = width;
    return c;
};
const $a6e8407c0e27ceff$export$6f093cfa640b7166 = $a6e8407c0e27ceff$export$b2ce9ad90858ed7a;
const $a6e8407c0e27ceff$export$7f60f118cd3e6292 = (pair)=>`${pair.left}:${pair.right};`;
const $a6e8407c0e27ceff$export$3d24a00500154f45 = (pairs)=>pairs.map($a6e8407c0e27ceff$export$7f60f118cd3e6292).join("");
const $a6e8407c0e27ceff$export$7d9cafe158c3b49 = (m)=>$2U6oo.map(m, (value, key)=>`${key}:${value};`).join("");
const $a6e8407c0e27ceff$export$78fb49a702cc1f2 = (el, query)=>el.querySelector(query);
const $a6e8407c0e27ceff$export$2e83b5c43fb7af7b = (el, query)=>el.querySelectorAll(query);
const $a6e8407c0e27ceff$export$83595b84fc78b9b4 = (id)=>/** @type {HTMLElement} */ $a6e8407c0e27ceff$export$2a111da947c407d2.getElementById(id);
/**
 * @param {string} html
 * @return {HTMLElement}
 */ const $a6e8407c0e27ceff$var$_parse = (html)=>$a6e8407c0e27ceff$export$fb621bb527230cda.parseFromString(`<html><body>${html}</body></html>`, "text/html").body;
const $a6e8407c0e27ceff$export$e1152f5efcc82ad = (html)=>$a6e8407c0e27ceff$export$f00aeb236b6f05af(/** @type {any} */ $a6e8407c0e27ceff$var$_parse(html).childNodes);
const $a6e8407c0e27ceff$export$b23064c2dcaf2b63 = (html)=>/** @type HTMLElement */ $a6e8407c0e27ceff$var$_parse(html).firstElementChild;
const $a6e8407c0e27ceff$export$e6a6680780233a77 = (oldEl, newEl)=>oldEl.replaceWith(newEl);
const $a6e8407c0e27ceff$export$86b68c7dbeb53c22 = (parent, el, ref)=>parent.insertBefore(el, ref);
const $a6e8407c0e27ceff$export$1b8e57c9ea42f1d2 = (parent, child)=>parent.appendChild(child);
const $a6e8407c0e27ceff$export$51c8a276ee4b8f51 = $a6e8407c0e27ceff$export$2a111da947c407d2.ELEMENT_NODE;
const $a6e8407c0e27ceff$export$5bcc40203615fc2e = $a6e8407c0e27ceff$export$2a111da947c407d2.TEXT_NODE;
const $a6e8407c0e27ceff$export$e5fc6332c1c8eb8e = $a6e8407c0e27ceff$export$2a111da947c407d2.CDATA_SECTION_NODE;
const $a6e8407c0e27ceff$export$3d597a6ef0f08b0a = $a6e8407c0e27ceff$export$2a111da947c407d2.COMMENT_NODE;
const $a6e8407c0e27ceff$export$4139dcda4f7f83db = $a6e8407c0e27ceff$export$2a111da947c407d2.DOCUMENT_NODE;
const $a6e8407c0e27ceff$export$e9e7ddfdb004b848 = $a6e8407c0e27ceff$export$2a111da947c407d2.DOCUMENT_TYPE_NODE;
const $a6e8407c0e27ceff$export$b86725031ae151ee = $a6e8407c0e27ceff$export$2a111da947c407d2.DOCUMENT_FRAGMENT_NODE;
const $a6e8407c0e27ceff$export$1aa65d86db59b879 = (node, type)=>node.nodeType === type;
const $a6e8407c0e27ceff$export$3c81af374b054d6a = (parent, child)=>{
    let p = child.parentNode;
    while(p && p !== parent)p = p.parentNode;
    return p === parent;
} /* c8 ignore stop */ ;

});

parcelRegister("eKi88", function(module, exports) {

$parcel$export(module.exports, "stringify", function () { return $abc36cd4efdd8b5d$export$fac44ee5b035f737; });
/**
 * JSON utility functions.
 *
 * @module json
 */ /**
 * Transform JavaScript object to JSON.
 *
 * @param {any} object
 * @return {string}
 */ const $abc36cd4efdd8b5d$export$fac44ee5b035f737 = JSON.stringify;
const $abc36cd4efdd8b5d$export$98e6a39c04603d36 = JSON.parse;

});

parcelRegister("5wQnU", function(module, exports) {

$parcel$export(module.exports, "enqueue", function () { return $4068936396fc8943$export$513072ba72100d9c; });
/* global requestIdleCallback, requestAnimationFrame, cancelIdleCallback, cancelAnimationFrame */ /**
 * Utility module to work with EcmaScript's event loop.
 *
 * @module eventloop
 */ /**
 * @type {Array<function>}
 */ let $4068936396fc8943$var$queue = [];
const $4068936396fc8943$var$_runQueue = ()=>{
    for(let i = 0; i < $4068936396fc8943$var$queue.length; i++)$4068936396fc8943$var$queue[i]();
    $4068936396fc8943$var$queue = [];
};
const $4068936396fc8943$export$513072ba72100d9c = (f)=>{
    $4068936396fc8943$var$queue.push(f);
    if ($4068936396fc8943$var$queue.length === 1) setTimeout($4068936396fc8943$var$_runQueue, 0);
};
/**
 * @typedef {Object} TimeoutObject
 * @property {function} TimeoutObject.destroy
 */ /**
 * @param {function(number):void} clearFunction
 */ const $4068936396fc8943$var$createTimeoutClass = (clearFunction)=>class TT {
        /**
   * @param {number} timeoutId
   */ constructor(timeoutId){
            this._ = timeoutId;
        }
        destroy() {
            clearFunction(this._);
        }
    };
const $4068936396fc8943$var$Timeout = $4068936396fc8943$var$createTimeoutClass(clearTimeout);
const $4068936396fc8943$export$83e74882c5df8fe1 = (timeout, callback)=>new $4068936396fc8943$var$Timeout(setTimeout(callback, timeout));
const $4068936396fc8943$var$Interval = $4068936396fc8943$var$createTimeoutClass(clearInterval);
const $4068936396fc8943$export$3174cdbf0a0cbc84 = (timeout, callback)=>new $4068936396fc8943$var$Interval(setInterval(callback, timeout));
const $4068936396fc8943$export$c35d437ae5945fcd = $4068936396fc8943$var$createTimeoutClass((arg)=>typeof requestAnimationFrame !== "undefined" && cancelAnimationFrame(arg));
const $4068936396fc8943$export$1402cba6a733f33a = (cb)=>typeof requestAnimationFrame === "undefined" ? $4068936396fc8943$export$83e74882c5df8fe1(0, cb) : new $4068936396fc8943$export$c35d437ae5945fcd(requestAnimationFrame(cb));
/* c8 ignore next */ // @ts-ignore
const $4068936396fc8943$var$Idle = $4068936396fc8943$var$createTimeoutClass((arg)=>typeof cancelIdleCallback !== "undefined" && cancelIdleCallback(arg));
const $4068936396fc8943$export$9f62c65f1b707875 = (cb)=>typeof requestIdleCallback !== "undefined" ? new $4068936396fc8943$var$Idle(requestIdleCallback(cb)) : $4068936396fc8943$export$83e74882c5df8fe1(1000, cb);
const $4068936396fc8943$export$21cd608c50c2ba31 = (timeout)=>{
    let timer = -1;
    return (f)=>{
        clearTimeout(timer);
        if (f) timer = /** @type {any} */ setTimeout(f, timeout);
    };
};

});

parcelRegister("esuCY", function(module, exports) {

$parcel$export(module.exports, "BOLD", function () { return $a86b703989ce8966$export$c1286c4c2a7c066; });
$parcel$export(module.exports, "UNBOLD", function () { return $a86b703989ce8966$export$f0ce1666bb40789b; });
$parcel$export(module.exports, "BLUE", function () { return $a86b703989ce8966$export$738c3b9a44c87ecc; });
$parcel$export(module.exports, "GREY", function () { return $a86b703989ce8966$export$7d278ca694634874; });
$parcel$export(module.exports, "GREEN", function () { return $a86b703989ce8966$export$48d4b2cd5bc0e88b; });
$parcel$export(module.exports, "RED", function () { return $a86b703989ce8966$export$aa201224bb439d47; });
$parcel$export(module.exports, "PURPLE", function () { return $a86b703989ce8966$export$7ffdeca4b2f927a2; });
$parcel$export(module.exports, "ORANGE", function () { return $a86b703989ce8966$export$3de5e29ed1757f9b; });
$parcel$export(module.exports, "UNCOLOR", function () { return $a86b703989ce8966$export$b586f81201748dd0; });
$parcel$export(module.exports, "computeNoColorLoggingArgs", function () { return $a86b703989ce8966$export$3454091cc3c6c473; });
$parcel$export(module.exports, "createModuleLogger", function () { return $a86b703989ce8966$export$c2977e725d59a2fd; });

var $24Pz8 = parcelRequire("24Pz8");

var $7neOC = parcelRequire("7neOC");

var $3LZef = parcelRequire("3LZef");

var $5VoPh = parcelRequire("5VoPh");

var $eKi88 = parcelRequire("eKi88");
const $a86b703989ce8966$export$c1286c4c2a7c066 = $24Pz8.create();
const $a86b703989ce8966$export$f0ce1666bb40789b = $24Pz8.create();
const $a86b703989ce8966$export$738c3b9a44c87ecc = $24Pz8.create();
const $a86b703989ce8966$export$7d278ca694634874 = $24Pz8.create();
const $a86b703989ce8966$export$48d4b2cd5bc0e88b = $24Pz8.create();
const $a86b703989ce8966$export$aa201224bb439d47 = $24Pz8.create();
const $a86b703989ce8966$export$7ffdeca4b2f927a2 = $24Pz8.create();
const $a86b703989ce8966$export$3de5e29ed1757f9b = $24Pz8.create();
const $a86b703989ce8966$export$b586f81201748dd0 = $24Pz8.create();
const $a86b703989ce8966$export$3454091cc3c6c473 = (args)=>{
    if (args.length === 1 && args[0]?.constructor === Function) args = /** @type {Array<string|Symbol|Object|number>} */ /** @type {[function]} */ args[0]();
    const strBuilder = [];
    const logArgs = [];
    // try with formatting until we find something unsupported
    let i = 0;
    for(; i < args.length; i++){
        const arg = args[i];
        if (arg === undefined) break;
        else if (arg.constructor === String || arg.constructor === Number) strBuilder.push(arg);
        else if (arg.constructor === Object) break;
    }
    if (i > 0) // create logArgs with what we have so far
    logArgs.push(strBuilder.join(""));
    // append the rest
    for(; i < args.length; i++){
        const arg = args[i];
        if (!(arg instanceof Symbol)) logArgs.push(arg);
    }
    return logArgs;
};
/* c8 ignore stop */ const $a86b703989ce8966$var$loggingColors = [
    $a86b703989ce8966$export$48d4b2cd5bc0e88b,
    $a86b703989ce8966$export$7ffdeca4b2f927a2,
    $a86b703989ce8966$export$3de5e29ed1757f9b,
    $a86b703989ce8966$export$738c3b9a44c87ecc
];
let $a86b703989ce8966$var$nextColor = 0;
let $a86b703989ce8966$var$lastLoggingTime = $7neOC.getUnixTime();
const $a86b703989ce8966$export$c2977e725d59a2fd = (_print, moduleName)=>{
    const color = $a86b703989ce8966$var$loggingColors[$a86b703989ce8966$var$nextColor];
    const debugRegexVar = $3LZef.getVariable("log");
    const doLogging = debugRegexVar !== null && (debugRegexVar === "*" || debugRegexVar === "true" || new RegExp(debugRegexVar, "gi").test(moduleName));
    $a86b703989ce8966$var$nextColor = ($a86b703989ce8966$var$nextColor + 1) % $a86b703989ce8966$var$loggingColors.length;
    moduleName += ": ";
    return !doLogging ? $5VoPh.nop : (...args)=>{
        if (args.length === 1 && args[0]?.constructor === Function) args = args[0]();
        const timeNow = $7neOC.getUnixTime();
        const timeDiff = timeNow - $a86b703989ce8966$var$lastLoggingTime;
        $a86b703989ce8966$var$lastLoggingTime = timeNow;
        _print(color, moduleName, $a86b703989ce8966$export$b586f81201748dd0, ...args.map((arg)=>{
            if (arg != null && arg.constructor === Uint8Array) arg = Array.from(arg);
            const t = typeof arg;
            switch(t){
                case "string":
                case "symbol":
                    return arg;
                default:
                    return $eKi88.stringify(arg);
            }
        }), color, " +" + timeDiff + "ms");
    };
} /* c8 ignore stop */ ;

});
parcelRegister("24Pz8", function(module, exports) {

$parcel$export(module.exports, "create", function () { return $1833f45896fde09b$export$185802fd694ee1f5; });
/**
 * Utility module to work with EcmaScript Symbols.
 *
 * @module symbol
 */ /**
 * Return fresh symbol.
 *
 * @return {Symbol}
 */ const $1833f45896fde09b$export$185802fd694ee1f5 = Symbol;
const $1833f45896fde09b$export$a244864fd9645c7f = (s)=>typeof s === "symbol";

});



parcelRegister("59LwD", function(module, exports) {

$parcel$export(module.exports, "iteratorFilter", function () { return $3c12a89466084e6a$export$88f0b2eef157f31a; });
$parcel$export(module.exports, "iteratorMap", function () { return $3c12a89466084e6a$export$1570d514f543056a; });
/**
 * Utility module to create and manipulate Iterators.
 *
 * @module iterator
 */ /**
 * @template T,R
 * @param {Iterator<T>} iterator
 * @param {function(T):R} f
 * @return {IterableIterator<R>}
 */ const $3c12a89466084e6a$export$68b1bda190f54159 = (iterator, f)=>({
        [Symbol.iterator] () {
            return this;
        },
        // @ts-ignore
        next () {
            const r = iterator.next();
            return {
                value: r.done ? undefined : f(r.value),
                done: r.done
            };
        }
    });
const $3c12a89466084e6a$export$7342c78d7e13e778 = (next)=>({
        /**
   * @return {IterableIterator<T>}
   */ [Symbol.iterator] () {
            return this;
        },
        next: // @ts-ignore
        next
    });
const $3c12a89466084e6a$export$88f0b2eef157f31a = (iterator, filter)=>$3c12a89466084e6a$export$7342c78d7e13e778(()=>{
        let res;
        do res = iterator.next();
        while (!res.done && !filter(res.value));
        return res;
    });
const $3c12a89466084e6a$export$1570d514f543056a = (iterator, fmap)=>$3c12a89466084e6a$export$7342c78d7e13e778(()=>{
        const { done: done, value: value } = iterator.next();
        return {
            done: done,
            value: done ? undefined : fmap(value)
        };
    });

});


parcelRegister("1aVVn", function(module, exports) {

$parcel$export(module.exports, "YTools", function () { return $0db3a8339b677870$export$fa9ccc772e1d8909; });
$parcel$export(module.exports, "useYDocDerivedState", function () { return $0db3a8339b677870$export$c67b2fc143bc7b9b; });
$parcel$export(module.exports, "useYState", function () { return $0db3a8339b677870$export$6eb91a212755c952; });
$parcel$export(module.exports, "useYCell", function () { return $0db3a8339b677870$export$345c1afb73c7fd7d; });

var $4H8rR = parcelRequire("4H8rR");

var $eeH7J = parcelRequire("eeH7J");

var $aw3rr = parcelRequire("aw3rr");

var $kbk6C = parcelRequire("kbk6C");

var $lyFh9 = parcelRequire("lyFh9");

var $f8cmx = parcelRequire("f8cmx");
var $0db3a8339b677870$export$fa9ccc772e1d8909;
(function(YTools) {
    function isArray(doc) {
        return doc.getMap("type").get("root") === "array";
    }
    YTools.isArray = isArray;
    function getRoot(doc) {
        return isArray(doc) ? doc.getArray("root") : doc.getMap("root");
    }
    YTools.getRoot = getRoot;
    function loadDoc(doc, root) {
        doc.transact(()=>{
            const type = doc.getMap("type");
            if (root instanceof Array) {
                type.set("root", "array");
                const yroot = doc.getArray("root");
                for (const item of root)yroot.push([
                    valueToYValue(item)
                ]);
                return;
            } else {
                type.set("root", "map");
                const yroot = doc.getMap("root");
                for(const key in root)yroot.set(key, valueToYValue(root[key]));
            }
        });
    }
    YTools.loadDoc = loadDoc;
    function valueToYValue(value) {
        if (value instanceof Array) return arrayToYArray(value);
        else if (value instanceof Object) return objectToYValue(value);
        else return value;
    }
    YTools.valueToYValue = valueToYValue;
    function arrayToYArray(arr) {
        const yarray = new $aw3rr.Array();
        for (const item of arr)yarray.push([
            valueToYValue(item)
        ]);
        return yarray;
    }
    YTools.arrayToYArray = arrayToYArray;
    function objectToYValue(obj) {
        if ((0, $lyFh9.IsRichText)(obj)) {
            const text = new $aw3rr.XmlText();
            text.applyDelta((0, $4H8rR.slateNodesToInsertDelta)(obj.$RichText));
            return text;
        }
        const map = new $aw3rr.Map();
        for(const key in obj)map.set(key, valueToYValue(obj[key]));
        return map;
    }
    YTools.objectToYValue = objectToYValue;
    function toJSON(doc) {
        return valueToJSON(YTools.getRoot(doc));
    }
    YTools.toJSON = toJSON;
    function valueToJSON(value) {
        if (value instanceof $aw3rr.Array) return arrayToJSON(value);
        else if (value instanceof $aw3rr.Map) return mapToJSON(value);
        else if (value instanceof $aw3rr.XmlText) {
            const elm = (0, $4H8rR.yTextToSlateElement)(value);
            if (typeof elm === "object" && "children" in elm && !("type" in elm)) return (0, $lyFh9.RichText)(...elm.children);
            if (elm instanceof Array) return (0, $lyFh9.RichText)(...elm);
            else return (0, $lyFh9.RichText)(elm);
        } else return value;
    }
    YTools.valueToJSON = valueToJSON;
    function arrayToJSON(arr) {
        const result = [];
        arr.forEach((value)=>{
            result.push(valueToJSON(value));
        });
        return result;
    }
    YTools.arrayToJSON = arrayToJSON;
    function mapToJSON(map) {
        const obj = {};
        map.forEach((value, key)=>{
            const kv = valueToJSON(value);
            if (kv !== undefined) obj[key] = kv;
        });
        return obj;
    }
    YTools.mapToJSON = mapToJSON;
    function set(parent, key, value) {
        if (parent instanceof $aw3rr.Array) {
            parent.delete(key, 1);
            parent.insert(key, [
                (0, $f8cmx.AdoptYValue)(value)
            ]);
        } else parent.set(key, (0, $f8cmx.AdoptYValue)(value));
        return value;
    }
    YTools.set = set;
    function get(parent, key) {
        if (parent instanceof $aw3rr.Array) return parent.get(key);
        else if (parent instanceof $aw3rr.Map) return parent.get(key);
        else throw new Error("Expected an Y.Array or Y.Map, got " + JSON.stringify(parent));
    }
    YTools.get = get;
    function getString(parent, key) {
        const str = get(parent, key);
        if (typeof str !== "string") throw new Error("Expected a string");
        return str;
    }
    YTools.getString = getString;
    function getStringOrUndefined(parent, key) {
        const str = get(parent, key);
        if (str === undefined) return;
        if (typeof str !== "string") throw new Error("Expected a string");
        return str;
    }
    YTools.getStringOrUndefined = getStringOrUndefined;
    function getArray(parent, key) {
        const arr = get(parent, key);
        if (!(arr instanceof $aw3rr.Array)) throw new Error("Expected an Y.Array");
        return arr;
    }
    YTools.getArray = getArray;
    function getMap(parent, key) {
        const map = get(parent, key);
        if (!(map instanceof $aw3rr.Map)) throw new Error("Expected an Y.Map");
        return map;
    }
    YTools.getMap = getMap;
    function getNode(parent, key) {
        const node = get(parent, key);
        if (!(node instanceof $aw3rr.Array || node instanceof $aw3rr.Map)) throw new Error("Expected an Y.Array or Y.Map, got " + JSON.stringify(node));
        return node;
    }
    YTools.getNode = getNode;
    function deleteKey(parent, key) {
        if (parent instanceof $aw3rr.Array) parent.delete(key, 1);
        else parent.delete(key);
    }
    YTools.deleteKey = deleteKey;
    /**
     * The encoding used to serialize Y.js payloads
     */ function uint8ArrayToBase64(uint8Array) {
        const chunkSize = 8192;
        let binary = "";
        for(let i = 0; i < uint8Array.length; i += chunkSize)binary += String.fromCharCode(...uint8Array.subarray(i, i + chunkSize));
        return btoa(binary);
    }
    YTools.uint8ArrayToBase64 = uint8ArrayToBase64;
    /**
     * The decoding used to deserialize Y.js payloads
     */ function base64ToUint8Array(base64) {
        const binaryString = atob(base64);
        const bytes = new Uint8Array(binaryString.length);
        for(let i = 0; i < binaryString.length; i++)bytes[i] = binaryString.charCodeAt(i);
        return bytes;
    }
    YTools.base64ToUint8Array = base64ToUint8Array;
    /**
     * Compares the newDoc to the provided yDoc, and applies all differences as
     * operations to the yDoc. This is done using fast-json-patch.
     *
     * Returns the resulting JSON object.
     */ function applyDiff(yDoc, newDoc, oldDoc, origin) {
        const root = YTools.getRoot(yDoc);
        oldDoc !== null && oldDoc !== void 0 ? oldDoc : oldDoc = valueToJSON(root);
        const operations = (0, $kbk6C.compare)(oldDoc, newDoc);
        if (operations.length === 0) return newDoc;
        applyOperations(yDoc, root, operations, origin);
        return newDoc;
    }
    YTools.applyDiff = applyDiff;
    function applyOperations(yDoc, root, operations, origin) {
        yDoc.transact(()=>{
            for (const operation of operations)switch(operation.op){
                case "add":
                    {
                        const path = operation.path.split("/").slice(1);
                        let node = root;
                        for(let i = 0; i < path.length - 1; i++)node = YTools.get(node, path[i]);
                        const value = YTools.valueToYValue(operation.value);
                        if (node instanceof $aw3rr.Array) node.insert(parseInt(path[path.length - 1]), [
                            value
                        ]);
                        else if (node instanceof $aw3rr.Map) node.set(path[path.length - 1], value);
                    }
                    break;
                case "remove":
                    {
                        const path = operation.path.split("/").slice(1);
                        let node = root;
                        for(let i = 0; i < path.length - 1; i++)node = YTools.get(node, path[i]);
                        if (node instanceof $aw3rr.Array) node.delete(parseInt(path[path.length - 1]), 1);
                        else if (node instanceof $aw3rr.Map) node.delete(path[path.length - 1]);
                    }
                    break;
                case "replace":
                    {
                        const path = operation.path.split("/").slice(1);
                        let node = root;
                        for(let i = 0; i < path.length - 1; i++)node = YTools.get(node, path[i]);
                        const value = YTools.valueToYValue(operation.value);
                        YTools.set(node, path[path.length - 1], value);
                    }
                    break;
                default:
                    throw new Error(`Unsupported operation: ${operation.op}`);
            }
        }, origin);
    }
    YTools.applyOperations = applyOperations;
})($0db3a8339b677870$export$fa9ccc772e1d8909 || ($0db3a8339b677870$export$fa9ccc772e1d8909 = {}));
function $0db3a8339b677870$export$c67b2fc143bc7b9b(doc, computeState, deps) {
    const [state, setState] = (0, $eeH7J.useState)(computeState);
    (0, $eeH7J.useEffect)(()=>{
        const observer = ()=>{
            setState(computeState());
        };
        doc.on("update", observer);
        return ()=>{
            doc.off("update", observer);
        };
    }, deps);
    return state;
}
function $0db3a8339b677870$export$6eb91a212755c952(obj, property) {
    const [localValue, setLocalValue] = (0, $eeH7J.useState)($0db3a8339b677870$export$fa9ccc772e1d8909.get(obj, property));
    const setValue = (0, $eeH7J.useCallback)((v)=>{
        setLocalValue(v);
        $0db3a8339b677870$export$fa9ccc772e1d8909.set(obj, property, v);
    }, [
        obj,
        property
    ]);
    (0, $eeH7J.useEffect)(()=>{
        function handler() {
            setLocalValue($0db3a8339b677870$export$fa9ccc772e1d8909.get(obj, property));
        }
        obj.observe(handler);
        handler();
        return ()=>{
            obj.unobserve(handler);
        };
    }, [
        obj,
        property
    ]);
    return [
        localValue,
        setValue,
        setLocalValue
    ];
}
function $0db3a8339b677870$export$345c1afb73c7fd7d(value, setValue, propName = "value") {
    const [cell, setCell] = (0, $eeH7J.useState)();
    (0, $eeH7J.useEffect)(()=>{
        const doc = new $aw3rr.Doc();
        const obj = doc.getMap("obj");
        obj.set(propName, value);
        const observer = ()=>{
            const current = obj.get("value");
            if (typeof current === "string") setValue(current);
        };
        obj.observe(observer);
        setCell(obj);
        return ()=>{
            obj.unobserve(observer);
            doc.destroy();
        };
    }, [
        setValue,
        propName
    ]);
    return cell;
}

});
parcelRegister("4H8rR", function(module, exports) {

$parcel$export(module.exports, "yTextToSlateElement", function () { return $36b1bb3ecf592bc6$export$8ef2301867112b96; });
$parcel$export(module.exports, "slateNodesToInsertDelta", function () { return $36b1bb3ecf592bc6$export$fdd76aa0c17f0d3b; });
$parcel$export(module.exports, "YjsEditor", function () { return $36b1bb3ecf592bc6$export$44093d155363d0da; });
$parcel$export(module.exports, "withYjs", function () { return $36b1bb3ecf592bc6$export$387d76e1896bf98c; });
$parcel$export(module.exports, "withYHistory", function () { return $36b1bb3ecf592bc6$export$596ecc3746f812c8; });

var $akZf2 = parcelRequire("akZf2");

var $aw3rr = parcelRequire("aw3rr");
var $36b1bb3ecf592bc6$var$__defProp = Object.defineProperty;
var $36b1bb3ecf592bc6$var$__defProps = Object.defineProperties;
var $36b1bb3ecf592bc6$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $36b1bb3ecf592bc6$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $36b1bb3ecf592bc6$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $36b1bb3ecf592bc6$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $36b1bb3ecf592bc6$var$__defNormalProp = (obj, key, value)=>key in obj ? $36b1bb3ecf592bc6$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $36b1bb3ecf592bc6$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($36b1bb3ecf592bc6$var$__hasOwnProp.call(b, prop)) $36b1bb3ecf592bc6$var$__defNormalProp(a, prop, b[prop]);
    if ($36b1bb3ecf592bc6$var$__getOwnPropSymbols) {
        for (var prop of $36b1bb3ecf592bc6$var$__getOwnPropSymbols(b))if ($36b1bb3ecf592bc6$var$__propIsEnum.call(b, prop)) $36b1bb3ecf592bc6$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $36b1bb3ecf592bc6$var$__spreadProps = (a, b)=>$36b1bb3ecf592bc6$var$__defProps(a, $36b1bb3ecf592bc6$var$__getOwnPropDescs(b));
var $36b1bb3ecf592bc6$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($36b1bb3ecf592bc6$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $36b1bb3ecf592bc6$var$__getOwnPropSymbols) {
        for (var prop of $36b1bb3ecf592bc6$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $36b1bb3ecf592bc6$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
// src/utils/object.ts
function $36b1bb3ecf592bc6$var$isObject(o) {
    return Object.prototype.toString.call(o) === "[object Object]";
}
function $36b1bb3ecf592bc6$var$isPlainObject(o) {
    if (!$36b1bb3ecf592bc6$var$isObject(o)) return false;
    const ctor = o.constructor;
    if (ctor === void 0) return true;
    const prot = ctor.prototype;
    if ($36b1bb3ecf592bc6$var$isObject(prot) === false) return false;
    if (prot.hasOwnProperty("isPrototypeOf") === false) return false;
    return true;
}
function $36b1bb3ecf592bc6$var$deepEquals(node, another) {
    for(const key in node){
        const a = node[key];
        const b = another[key];
        if ($36b1bb3ecf592bc6$var$isPlainObject(a) && $36b1bb3ecf592bc6$var$isPlainObject(b)) {
            if (!$36b1bb3ecf592bc6$var$deepEquals(a, b)) return false;
        } else if (Array.isArray(a) && Array.isArray(b)) {
            if (a.length !== b.length) return false;
            for(let i = 0; i < a.length; i++){
                if (a[i] !== b[i]) return false;
            }
        } else if (a !== b) return false;
    }
    for(const key in another){
        if (node[key] === void 0 && another[key] !== void 0) return false;
    }
    return true;
}
function $36b1bb3ecf592bc6$var$pick(obj, ...keys) {
    return Object.fromEntries(Object.entries(obj).filter(([key])=>keys.includes(key)));
}
function $36b1bb3ecf592bc6$var$omit(obj, ...keys) {
    return Object.fromEntries(Object.entries(obj).filter(([key])=>!keys.includes(key)));
}
function $36b1bb3ecf592bc6$var$omitNullEntries(obj) {
    return Object.fromEntries(Object.entries(obj).filter(([, value])=>value !== null));
}
// src/utils/delta.ts
function $36b1bb3ecf592bc6$var$normalizeInsertDelta(delta) {
    var _a, _b;
    const normalized = [];
    for (const element of delta){
        if (typeof element.insert === "string" && element.insert.length === 0) continue;
        const prev = normalized[normalized.length - 1];
        if (!prev || typeof prev.insert !== "string" || typeof element.insert !== "string") {
            normalized.push(element);
            continue;
        }
        const merge = prev.attributes === element.attributes || !prev.attributes === !element.attributes && $36b1bb3ecf592bc6$var$deepEquals((_a = prev.attributes) != null ? _a : {}, (_b = element.attributes) != null ? _b : {});
        if (merge) {
            prev.insert += element.insert;
            continue;
        }
        normalized.push(element);
    }
    return normalized;
}
function $36b1bb3ecf592bc6$var$yTextToInsertDelta(yText) {
    return $36b1bb3ecf592bc6$var$normalizeInsertDelta(yText.toDelta());
}
function $36b1bb3ecf592bc6$var$getInsertLength({ insert: insert }) {
    return typeof insert === "string" ? insert.length : 1;
}
function $36b1bb3ecf592bc6$var$getInsertDeltaLength(delta) {
    return delta.reduce((curr, element)=>curr + $36b1bb3ecf592bc6$var$getInsertLength(element), 0);
}
function $36b1bb3ecf592bc6$var$sliceInsertDelta(delta, start, length) {
    if (length < 1) return [];
    let currentOffset = 0;
    const sliced = [];
    const end = start + length;
    for(let i = 0; i < delta.length; i++){
        if (currentOffset >= end) break;
        const element = delta[i];
        const elementLength = $36b1bb3ecf592bc6$var$getInsertLength(element);
        if (currentOffset + elementLength <= start) {
            currentOffset += elementLength;
            continue;
        }
        if (typeof element.insert !== "string") {
            currentOffset += elementLength;
            sliced.push(element);
            continue;
        }
        const startOffset = Math.max(0, start - currentOffset);
        const endOffset = Math.min(elementLength, elementLength - (currentOffset + elementLength - end));
        sliced.push($36b1bb3ecf592bc6$var$__spreadProps($36b1bb3ecf592bc6$var$__spreadValues({}, element), {
            insert: element.insert.slice(startOffset, endOffset)
        }));
        currentOffset += elementLength;
    }
    return sliced;
}
function $36b1bb3ecf592bc6$var$getProperties(node) {
    return $36b1bb3ecf592bc6$var$omit(node, (0, $akZf2.Text).isText(node) ? "text" : "children");
}
// src/utils/convert.ts
function $36b1bb3ecf592bc6$export$8ef2301867112b96(yText) {
    const delta = $36b1bb3ecf592bc6$var$yTextToInsertDelta(yText);
    const children = delta.length > 0 ? delta.map($36b1bb3ecf592bc6$var$deltaInsertToSlateNode) : [
        {
            text: ""
        }
    ];
    return $36b1bb3ecf592bc6$var$__spreadProps($36b1bb3ecf592bc6$var$__spreadValues({}, yText.getAttributes()), {
        children: children
    });
}
function $36b1bb3ecf592bc6$var$deltaInsertToSlateNode(insert) {
    if (typeof insert.insert === "string") return $36b1bb3ecf592bc6$var$__spreadProps($36b1bb3ecf592bc6$var$__spreadValues({}, insert.attributes), {
        text: insert.insert
    });
    return $36b1bb3ecf592bc6$export$8ef2301867112b96(insert.insert);
}
function $36b1bb3ecf592bc6$export$fdd76aa0c17f0d3b(nodes) {
    return nodes.map((node)=>{
        if ((0, $akZf2.Text).isText(node)) return {
            insert: node.text,
            attributes: $36b1bb3ecf592bc6$var$getProperties(node)
        };
        return {
            insert: $36b1bb3ecf592bc6$var$slateElementToYText(node)
        };
    });
}
function $36b1bb3ecf592bc6$var$slateElementToYText(_a) {
    var _b = _a, { children: children } = _b, attributes = $36b1bb3ecf592bc6$var$__objRest(_b, [
        "children"
    ]);
    const yElement = new $aw3rr.XmlText();
    Object.entries(attributes).forEach(([key, value])=>{
        yElement.setAttribute(key, value);
    });
    yElement.applyDelta($36b1bb3ecf592bc6$export$fdd76aa0c17f0d3b(children), {
        sanitize: false
    });
    return yElement;
}
function $36b1bb3ecf592bc6$var$getSlateNodeYLength(node) {
    if (!node) return 0;
    return (0, $akZf2.Text).isText(node) ? node.text.length : 1;
}
function $36b1bb3ecf592bc6$var$slatePathOffsetToYOffset(element, pathOffset) {
    return element.children.slice(0, pathOffset).reduce((yOffset, node)=>yOffset + $36b1bb3ecf592bc6$var$getSlateNodeYLength(node), 0);
}
function $36b1bb3ecf592bc6$var$getYTarget(yRoot, slateRoot, path) {
    var _a;
    if (path.length === 0) throw new Error("Path has to a have a length >= 1");
    if ((0, $akZf2.Text).isText(slateRoot)) throw new Error("Cannot descent into slate text");
    const [pathOffset, ...childPath] = path;
    const yOffset = $36b1bb3ecf592bc6$var$slatePathOffsetToYOffset(slateRoot, pathOffset);
    const targetNode = slateRoot.children[pathOffset];
    const delta = $36b1bb3ecf592bc6$var$yTextToInsertDelta(yRoot);
    const targetLength = $36b1bb3ecf592bc6$var$getSlateNodeYLength(targetNode);
    const targetDelta = $36b1bb3ecf592bc6$var$sliceInsertDelta(delta, yOffset, targetLength);
    if (targetDelta.length > 1) throw new Error("Path doesn't match yText, yTarget spans multiple nodes");
    const yTarget = (_a = targetDelta[0]) == null ? void 0 : _a.insert;
    if (childPath.length > 0) {
        if (!(yTarget instanceof $aw3rr.XmlText)) throw new Error("Path doesn't match yText, cannot descent into non-yText");
        return $36b1bb3ecf592bc6$var$getYTarget(yTarget, targetNode, childPath);
    }
    return {
        yParent: yRoot,
        textRange: {
            start: yOffset,
            end: yOffset + targetLength
        },
        yTarget: yTarget instanceof $aw3rr.XmlText ? yTarget : void 0,
        slateParent: slateRoot,
        slateTarget: targetNode,
        targetDelta: targetDelta
    };
}
function $36b1bb3ecf592bc6$var$yOffsetToSlateOffsets(parent, yOffset, opts = {}) {
    const { assoc: assoc = 0, insert: insert = false } = opts;
    let currentOffset = 0;
    let lastNonEmptyPathOffset = 0;
    for(let pathOffset = 0; pathOffset < parent.children.length; pathOffset++){
        const child2 = parent.children[pathOffset];
        const nodeLength = (0, $akZf2.Text).isText(child2) ? child2.text.length : 1;
        if (nodeLength > 0) lastNonEmptyPathOffset = pathOffset;
        const endOffset = currentOffset + nodeLength;
        if (nodeLength > 0 && (assoc >= 0 ? endOffset > yOffset : endOffset >= yOffset)) return [
            pathOffset,
            yOffset - currentOffset
        ];
        currentOffset += nodeLength;
    }
    if (yOffset > currentOffset + (insert ? 1 : 0)) throw new Error("yOffset out of bounds");
    if (insert) return [
        parent.children.length,
        0
    ];
    const child = parent.children[lastNonEmptyPathOffset];
    const textOffset = (0, $akZf2.Text).isText(child) ? child.text.length : 1;
    return [
        lastNonEmptyPathOffset,
        textOffset
    ];
}
function $36b1bb3ecf592bc6$var$getSlatePath(sharedRoot, slateRoot, yText) {
    const yNodePath = [
        yText
    ];
    while(yNodePath[0] !== sharedRoot){
        const { parent: yParent } = yNodePath[0];
        if (!yParent) throw new Error("yText isn't a descendant of root element");
        if (!(yParent instanceof $aw3rr.XmlText)) throw new Error("Unexpected y parent type");
        yNodePath.unshift(yParent);
    }
    if (yNodePath.length < 2) return [];
    let slateParent = slateRoot;
    return yNodePath.reduce((path, yParent, idx)=>{
        const yChild = yNodePath[idx + 1];
        if (!yChild) return path;
        let yOffset = 0;
        const currentDelta = $36b1bb3ecf592bc6$var$yTextToInsertDelta(yParent);
        for (const element of currentDelta){
            if (element.insert === yChild) break;
            yOffset += typeof element.insert === "string" ? element.insert.length : 1;
        }
        if ((0, $akZf2.Text).isText(slateParent)) throw new Error("Cannot descent into slate text");
        const [pathOffset] = $36b1bb3ecf592bc6$var$yOffsetToSlateOffsets(slateParent, yOffset);
        slateParent = slateParent.children[pathOffset];
        return path.concat(pathOffset);
    }, []);
}
// src/applyToSlate/textEvent.ts
function $36b1bb3ecf592bc6$var$applyDelta(node, slatePath, delta) {
    const ops = [];
    let yOffset = delta.reduce((length, change)=>{
        if ("retain" in change) return length + change.retain;
        if ("delete" in change) return length + change.delete;
        return length;
    }, 0);
    delta.reverse().forEach((change)=>{
        var _a;
        if ("attributes" in change && "retain" in change) {
            const [startPathOffset, startTextOffset] = $36b1bb3ecf592bc6$var$yOffsetToSlateOffsets(node, yOffset - change.retain);
            const [endPathOffset, endTextOffset] = $36b1bb3ecf592bc6$var$yOffsetToSlateOffsets(node, yOffset, {
                assoc: -1
            });
            for(let pathOffset = endPathOffset; pathOffset >= startPathOffset; pathOffset--){
                const child = node.children[pathOffset];
                const childPath = [
                    ...slatePath,
                    pathOffset
                ];
                if (!(0, $akZf2.Text).isText(child)) continue;
                const newProperties = change.attributes;
                const properties = $36b1bb3ecf592bc6$var$pick(node, ...Object.keys(change.attributes));
                if (pathOffset === startPathOffset || pathOffset === endPathOffset) {
                    const start = pathOffset === startPathOffset ? startTextOffset : 0;
                    const end = pathOffset === endPathOffset ? endTextOffset : child.text.length;
                    if (end !== child.text.length) ops.push({
                        type: "split_node",
                        path: childPath,
                        position: end,
                        properties: $36b1bb3ecf592bc6$var$getProperties(child)
                    });
                    if (start !== 0) {
                        ops.push({
                            type: "split_node",
                            path: childPath,
                            position: start,
                            properties: $36b1bb3ecf592bc6$var$omitNullEntries($36b1bb3ecf592bc6$var$__spreadValues($36b1bb3ecf592bc6$var$__spreadValues({}, $36b1bb3ecf592bc6$var$getProperties(child)), newProperties))
                        });
                        continue;
                    }
                }
                ops.push({
                    type: "set_node",
                    newProperties: newProperties,
                    path: childPath,
                    properties: properties
                });
            }
        }
        if ("retain" in change) yOffset -= change.retain;
        if ("delete" in change) {
            const [startPathOffset, startTextOffset] = $36b1bb3ecf592bc6$var$yOffsetToSlateOffsets(node, yOffset - change.delete);
            const [endPathOffset, endTextOffset] = $36b1bb3ecf592bc6$var$yOffsetToSlateOffsets(node, yOffset, {
                assoc: -1
            });
            for(let pathOffset = endTextOffset === 0 ? endPathOffset - 1 : endPathOffset; pathOffset >= startPathOffset; pathOffset--){
                const child = node.children[pathOffset];
                const childPath = [
                    ...slatePath,
                    pathOffset
                ];
                if ((0, $akZf2.Text).isText(child) && (pathOffset === startPathOffset || pathOffset === endPathOffset)) {
                    const start = pathOffset === startPathOffset ? startTextOffset : 0;
                    const end = pathOffset === endPathOffset ? endTextOffset : child.text.length;
                    ops.push({
                        type: "remove_text",
                        offset: start,
                        text: child.text.slice(start, end),
                        path: childPath
                    });
                    yOffset -= end - start;
                    continue;
                }
                ops.push({
                    type: "remove_node",
                    node: child,
                    path: childPath
                });
                yOffset -= $36b1bb3ecf592bc6$var$getSlateNodeYLength(child);
            }
            return;
        }
        if ("insert" in change) {
            const [pathOffset, textOffset] = $36b1bb3ecf592bc6$var$yOffsetToSlateOffsets(node, yOffset, {
                insert: true
            });
            const child = node.children[pathOffset];
            const childPath = [
                ...slatePath,
                pathOffset
            ];
            if ((0, $akZf2.Text).isText(child)) {
                const lastOp = ops[ops.length - 1];
                const currentProps = lastOp != null && lastOp.type === "insert_node" ? lastOp.node : $36b1bb3ecf592bc6$var$getProperties(child);
                let lastPath = [];
                if (lastOp != null && (lastOp.type === "insert_node" || lastOp.type === "insert_text" || lastOp.type === "split_node" || lastOp.type === "set_node")) lastPath = lastOp.path;
                if (typeof change.insert === "string" && $36b1bb3ecf592bc6$var$deepEquals((_a = change.attributes) != null ? _a : {}, currentProps) && (0, $akZf2.Path).equals(childPath, lastPath)) return ops.push({
                    type: "insert_text",
                    offset: textOffset,
                    text: change.insert,
                    path: childPath
                });
                const toInsert = $36b1bb3ecf592bc6$var$deltaInsertToSlateNode(change);
                if (textOffset === 0) return ops.push({
                    type: "insert_node",
                    path: childPath,
                    node: toInsert
                });
                if (textOffset < child.text.length) ops.push({
                    type: "split_node",
                    path: childPath,
                    position: textOffset,
                    properties: $36b1bb3ecf592bc6$var$getProperties(child)
                });
                return ops.push({
                    type: "insert_node",
                    path: (0, $akZf2.Path).next(childPath),
                    node: toInsert
                });
            }
            return ops.push({
                type: "insert_node",
                path: childPath,
                node: $36b1bb3ecf592bc6$var$deltaInsertToSlateNode(change)
            });
        }
    });
    return ops;
}
function $36b1bb3ecf592bc6$var$translateYTextEvent(sharedRoot, editor, event) {
    const { target: target, changes: changes } = event;
    const delta = event.delta;
    if (!(target instanceof $aw3rr.XmlText)) throw new Error("Unexpected target node type");
    const ops = [];
    const slatePath = $36b1bb3ecf592bc6$var$getSlatePath(sharedRoot, editor, target);
    const targetElement = (0, $akZf2.Node).get(editor, slatePath);
    if ((0, $akZf2.Text).isText(targetElement)) throw new Error("Cannot apply yTextEvent to text node");
    const keyChanges = Array.from(changes.keys.entries());
    if (slatePath.length > 0 && keyChanges.length > 0) {
        const newProperties = Object.fromEntries(keyChanges.map(([key, info])=>[
                key,
                info.action === "delete" ? null : target.getAttribute(key)
            ]));
        const properties = Object.fromEntries(keyChanges.map(([key])=>[
                key,
                targetElement[key]
            ]));
        ops.push({
            type: "set_node",
            newProperties: newProperties,
            properties: properties,
            path: slatePath
        });
    }
    if (delta.length > 0) ops.push(...$36b1bb3ecf592bc6$var$applyDelta(targetElement, slatePath, delta));
    return ops;
}
// src/applyToSlate/index.ts
function $36b1bb3ecf592bc6$var$translateYjsEvent(sharedRoot, editor, event) {
    if (event instanceof $aw3rr.YTextEvent) return $36b1bb3ecf592bc6$var$translateYTextEvent(sharedRoot, editor, event);
    throw new Error("Unexpected Y event type");
}
function $36b1bb3ecf592bc6$var$applyYjsEvents(sharedRoot, editor, events) {
    (0, $akZf2.Editor).withoutNormalizing(editor, ()=>{
        events.forEach((event)=>{
            $36b1bb3ecf592bc6$var$translateYjsEvent(sharedRoot, editor, event).forEach((op)=>{
                editor.apply(op);
            });
        });
    });
}
function $36b1bb3ecf592bc6$var$insertNode(sharedRoot, slateRoot, op) {
    const { yParent: yParent, textRange: textRange } = $36b1bb3ecf592bc6$var$getYTarget(sharedRoot, slateRoot, op.path);
    if ((0, $akZf2.Text).isText(op.node)) return yParent.insert(textRange.start, op.node.text, $36b1bb3ecf592bc6$var$getProperties(op.node));
    yParent.insertEmbed(textRange.start, $36b1bb3ecf592bc6$var$slateElementToYText(op.node));
}
function $36b1bb3ecf592bc6$var$cloneInsertDeltaDeep(delta) {
    return delta.map((element)=>{
        if (typeof element.insert === "string") return element;
        return $36b1bb3ecf592bc6$var$__spreadProps($36b1bb3ecf592bc6$var$__spreadValues({}, element), {
            insert: $36b1bb3ecf592bc6$var$cloneDeep(element.insert)
        });
    });
}
function $36b1bb3ecf592bc6$var$cloneDeep(yText) {
    const clone = new $aw3rr.XmlText();
    const attributes = yText.getAttributes();
    Object.entries(attributes).forEach(([key, value])=>{
        clone.setAttribute(key, value);
    });
    clone.applyDelta($36b1bb3ecf592bc6$var$cloneInsertDeltaDeep($36b1bb3ecf592bc6$var$yTextToInsertDelta(yText)), {
        sanitize: false
    });
    return clone;
}
// src/utils/yjs.ts
function $36b1bb3ecf592bc6$var$assertDocumentAttachment(sharedType) {
    if (!sharedType.doc) throw new Error("shared type isn't attached to a document");
}
// src/utils/position.ts
var $36b1bb3ecf592bc6$var$STORED_POSITION_PREFIX = "__slateYjsStoredPosition_";
function $36b1bb3ecf592bc6$export$609533058754fd73(sharedRoot, slateRoot, point) {
    const { yTarget: yTarget, yParent: yParent, textRange: textRange } = $36b1bb3ecf592bc6$var$getYTarget(sharedRoot, slateRoot, point.path);
    if (yTarget) throw new Error("Slate point points to a non-text element inside sharedRoot");
    const index = textRange.start + point.offset;
    return $aw3rr.createRelativePositionFromTypeIndex(yParent, index, index === textRange.end ? -1 : 0);
}
function $36b1bb3ecf592bc6$var$absolutePositionToSlatePoint(sharedRoot, slateRoot, { type: type, index: index, assoc: assoc }) {
    if (!(type instanceof $aw3rr.XmlText)) throw new Error("Absolute position points to a non-XMLText");
    const parentPath = $36b1bb3ecf592bc6$var$getSlatePath(sharedRoot, slateRoot, type);
    const parent = (0, $akZf2.Node).get(slateRoot, parentPath);
    if ((0, $akZf2.Text).isText(parent)) throw new Error("Absolute position doesn't match slateRoot, cannot descent into text");
    const [pathOffset, textOffset] = $36b1bb3ecf592bc6$var$yOffsetToSlateOffsets(parent, index, {
        assoc: assoc
    });
    const target = parent.children[pathOffset];
    if (!(0, $akZf2.Text).isText(target)) return null;
    return {
        path: [
            ...parentPath,
            pathOffset
        ],
        offset: textOffset
    };
}
function $36b1bb3ecf592bc6$export$b8d38944688a99cc(sharedRoot, slateRoot, pos) {
    if (!sharedRoot.doc) throw new Error("sharedRoot isn't attach to a yDoc");
    const absPos = $aw3rr.createAbsolutePositionFromRelativePosition(pos, sharedRoot.doc);
    return absPos && $36b1bb3ecf592bc6$var$absolutePositionToSlatePoint(sharedRoot, slateRoot, absPos);
}
function $36b1bb3ecf592bc6$var$getStoredPosition(sharedRoot, key) {
    const rawPosition = sharedRoot.getAttribute($36b1bb3ecf592bc6$var$STORED_POSITION_PREFIX + key);
    if (!rawPosition) return null;
    return $aw3rr.decodeRelativePosition(rawPosition);
}
function $36b1bb3ecf592bc6$var$getStoredPositions(sharedRoot) {
    return Object.fromEntries(Object.entries(sharedRoot.getAttributes()).filter(([key])=>key.startsWith($36b1bb3ecf592bc6$var$STORED_POSITION_PREFIX)).map(([key, position])=>[
            key.slice($36b1bb3ecf592bc6$var$STORED_POSITION_PREFIX.length),
            $aw3rr.createRelativePositionFromJSON(position)
        ]));
}
function $36b1bb3ecf592bc6$var$getStoredPositionsAbsolute(sharedRoot) {
    $36b1bb3ecf592bc6$var$assertDocumentAttachment(sharedRoot);
    return Object.fromEntries(Object.entries(sharedRoot.getAttributes()).filter(([key])=>key.startsWith($36b1bb3ecf592bc6$var$STORED_POSITION_PREFIX)).map(([key, position])=>[
            key.slice($36b1bb3ecf592bc6$var$STORED_POSITION_PREFIX.length),
            $aw3rr.createAbsolutePositionFromRelativePosition($aw3rr.decodeRelativePosition(position), sharedRoot.doc)
        ]).filter(([, position])=>position));
}
function $36b1bb3ecf592bc6$var$removeStoredPosition(sharedRoot, key) {
    sharedRoot.removeAttribute($36b1bb3ecf592bc6$var$STORED_POSITION_PREFIX + key);
}
function $36b1bb3ecf592bc6$var$setStoredPosition(sharedRoot, key, position) {
    sharedRoot.setAttribute($36b1bb3ecf592bc6$var$STORED_POSITION_PREFIX + key, $aw3rr.encodeRelativePosition(position));
}
function $36b1bb3ecf592bc6$var$getAbsolutePositionsInTextRange(absolutePositions, yTarget, textRange) {
    return Object.fromEntries(Object.entries(absolutePositions).filter(([, position])=>{
        if (position.type !== yTarget) return false;
        if (!textRange) return true;
        return position.assoc >= 0 ? position.index >= textRange.start && position.index < textRange.end : position.index > textRange.start && position.index >= textRange.end;
    }));
}
function $36b1bb3ecf592bc6$var$getAbsolutePositionsInYText(absolutePositions, yText, parentPath = "") {
    const positions = {
        [parentPath]: $36b1bb3ecf592bc6$var$getAbsolutePositionsInTextRange(absolutePositions, yText)
    };
    const insertDelta = $36b1bb3ecf592bc6$var$yTextToInsertDelta(yText);
    insertDelta.forEach(({ insert: insert }, i)=>{
        if (insert instanceof $aw3rr.XmlText) Object.assign(positions, $36b1bb3ecf592bc6$var$getAbsolutePositionsInYText(absolutePositions, insert, parentPath ? `${parentPath}.${i}` : i.toString()));
    });
    return positions;
}
function $36b1bb3ecf592bc6$var$getStoredPositionsInDeltaAbsolute(sharedRoot, yText, delta, deltaOffset = 0) {
    const absolutePositions = $36b1bb3ecf592bc6$var$getStoredPositionsAbsolute(sharedRoot);
    const positions = {
        "": $36b1bb3ecf592bc6$var$getAbsolutePositionsInTextRange(absolutePositions, yText, {
            start: deltaOffset,
            end: deltaOffset + $36b1bb3ecf592bc6$var$getInsertDeltaLength(delta)
        })
    };
    delta.forEach(({ insert: insert }, i)=>{
        if (insert instanceof $aw3rr.XmlText) Object.assign(positions, $36b1bb3ecf592bc6$var$getAbsolutePositionsInYText(absolutePositions, insert, i.toString()));
    });
    return positions;
}
function $36b1bb3ecf592bc6$var$restoreStoredPositionsWithDeltaAbsolute(sharedRoot, yText, absolutePositions, delta, newDeltaOffset = 0, previousDeltaOffset = 0, path = "") {
    const toRestore = absolutePositions[path];
    if (toRestore) Object.entries(toRestore).forEach(([key, position])=>{
        $36b1bb3ecf592bc6$var$setStoredPosition(sharedRoot, key, $aw3rr.createRelativePositionFromTypeIndex(yText, position.index - previousDeltaOffset + newDeltaOffset, position.assoc));
    });
    delta.forEach(({ insert: insert }, i)=>{
        if (insert instanceof $aw3rr.XmlText) $36b1bb3ecf592bc6$var$restoreStoredPositionsWithDeltaAbsolute(sharedRoot, insert, absolutePositions, $36b1bb3ecf592bc6$var$yTextToInsertDelta(insert), 0, 0, path ? `${path}.${i}` : i.toString());
    });
}
function $36b1bb3ecf592bc6$export$d4e3c4ad38d71003(sharedRoot, slateRoot, range) {
    return {
        anchor: $36b1bb3ecf592bc6$export$609533058754fd73(sharedRoot, slateRoot, range.anchor),
        focus: $36b1bb3ecf592bc6$export$609533058754fd73(sharedRoot, slateRoot, range.focus)
    };
}
function $36b1bb3ecf592bc6$export$2dabdbc9ed7f0c0(sharedRoot, slateRoot, range) {
    const anchor = $36b1bb3ecf592bc6$export$b8d38944688a99cc(sharedRoot, slateRoot, range.anchor);
    if (!anchor) return null;
    const focus = $36b1bb3ecf592bc6$export$b8d38944688a99cc(sharedRoot, slateRoot, range.focus);
    if (!focus) return null;
    return {
        anchor: anchor,
        focus: focus
    };
}
// src/applyToYjs/node/mergeNode.ts
function $36b1bb3ecf592bc6$var$mergeNode(sharedRoot, slateRoot, op) {
    const target = $36b1bb3ecf592bc6$var$getYTarget(sharedRoot, slateRoot, op.path);
    const prev = $36b1bb3ecf592bc6$var$getYTarget(target.yParent, target.slateParent, (0, $akZf2.Path).previous(op.path.slice(-1)));
    if (!target.yTarget !== !prev.yTarget) throw new Error("Cannot merge y text with y element");
    if (!prev.yTarget || !target.yTarget) {
        const { yParent: parent, textRange: textRange, slateTarget: slateTarget } = target;
        if (!slateTarget) throw new Error("Expected Slate target node for merge op.");
        const prevSibling = (0, $akZf2.Node).get(slateRoot, (0, $akZf2.Path).previous(op.path));
        if (!(0, $akZf2.Text).isText(prevSibling)) throw new Error("Path points to Y.Text but not a Slate text node.");
        const targetProps = $36b1bb3ecf592bc6$var$getProperties(slateTarget);
        const prevSiblingProps = $36b1bb3ecf592bc6$var$getProperties(prevSibling);
        const unsetProps = Object.keys(targetProps).reduce((acc, key)=>{
            const prevSiblingHasProp = key in prevSiblingProps;
            return prevSiblingHasProp ? acc : $36b1bb3ecf592bc6$var$__spreadProps($36b1bb3ecf592bc6$var$__spreadValues({}, acc), {
                [key]: null
            });
        }, {});
        return parent.format(textRange.start, textRange.end - textRange.start, $36b1bb3ecf592bc6$var$__spreadValues($36b1bb3ecf592bc6$var$__spreadValues({}, unsetProps), prevSiblingProps));
    }
    const deltaApplyYOffset = prev.yTarget.length;
    const targetDelta = $36b1bb3ecf592bc6$var$yTextToInsertDelta(target.yTarget);
    const clonedDelta = $36b1bb3ecf592bc6$var$cloneInsertDeltaDeep(targetDelta);
    const storedPositions = $36b1bb3ecf592bc6$var$getStoredPositionsInDeltaAbsolute(sharedRoot, target.yTarget, targetDelta, deltaApplyYOffset);
    const applyDelta2 = [
        {
            retain: deltaApplyYOffset
        },
        ...clonedDelta
    ];
    prev.yTarget.applyDelta(applyDelta2, {
        sanitize: false
    });
    target.yParent.delete(target.textRange.start, target.textRange.end - target.textRange.start);
    $36b1bb3ecf592bc6$var$restoreStoredPositionsWithDeltaAbsolute(sharedRoot, prev.yTarget, storedPositions, clonedDelta, deltaApplyYOffset);
}
function $36b1bb3ecf592bc6$var$moveNode(sharedRoot, slateRoot, op) {
    const newParentPath = (0, $akZf2.Path).parent(op.newPath);
    const newPathOffset = op.newPath[op.newPath.length - 1];
    const parent = (0, $akZf2.Node).get(slateRoot, newParentPath);
    if ((0, $akZf2.Text).isText(parent)) throw new Error("Cannot move slate node into text element");
    const normalizedNewPath = [
        ...newParentPath,
        Math.min(newPathOffset, parent.children.length)
    ];
    const origin = $36b1bb3ecf592bc6$var$getYTarget(sharedRoot, slateRoot, op.path);
    const target = $36b1bb3ecf592bc6$var$getYTarget(sharedRoot, slateRoot, normalizedNewPath);
    const insertDelta = $36b1bb3ecf592bc6$var$cloneInsertDeltaDeep(origin.targetDelta);
    const storedPositions = $36b1bb3ecf592bc6$var$getStoredPositionsInDeltaAbsolute(sharedRoot, origin.yParent, origin.targetDelta);
    origin.yParent.delete(origin.textRange.start, origin.textRange.end - origin.textRange.start);
    const targetLength = $36b1bb3ecf592bc6$var$getInsertDeltaLength($36b1bb3ecf592bc6$var$yTextToInsertDelta(target.yParent));
    const deltaApplyYOffset = Math.min(target.textRange.start, targetLength);
    const applyDelta2 = [
        {
            retain: deltaApplyYOffset
        },
        ...insertDelta
    ];
    target.yParent.applyDelta(applyDelta2, {
        sanitize: false
    });
    $36b1bb3ecf592bc6$var$restoreStoredPositionsWithDeltaAbsolute(sharedRoot, target.yParent, storedPositions, insertDelta, deltaApplyYOffset, origin.textRange.start);
}
// src/applyToYjs/node/removeNode.ts
function $36b1bb3ecf592bc6$var$removeNode(sharedRoot, slateRoot, op) {
    const { yParent: parent, textRange: textRange } = $36b1bb3ecf592bc6$var$getYTarget(sharedRoot, slateRoot, op.path);
    parent.delete(textRange.start, textRange.end - textRange.start);
}
// src/applyToYjs/node/setNode.ts
function $36b1bb3ecf592bc6$var$setNode(sharedRoot, slateRoot, op) {
    const { yTarget: yTarget, textRange: textRange, yParent: yParent } = $36b1bb3ecf592bc6$var$getYTarget(sharedRoot, slateRoot, op.path);
    if (yTarget) {
        Object.entries(op.newProperties).forEach(([key, value])=>{
            if (value === null) return yTarget.removeAttribute(key);
            yTarget.setAttribute(key, value);
        });
        return Object.entries(op.properties).forEach(([key])=>{
            if (!op.newProperties.hasOwnProperty(key)) yTarget.removeAttribute(key);
        });
    }
    const unset = Object.fromEntries(Object.keys(op.properties).map((key)=>[
            key,
            null
        ]));
    const newProperties = $36b1bb3ecf592bc6$var$__spreadValues($36b1bb3ecf592bc6$var$__spreadValues({}, unset), op.newProperties);
    yParent.format(textRange.start, textRange.end - textRange.start, newProperties);
}
function $36b1bb3ecf592bc6$var$splitNode(sharedRoot, slateRoot, op) {
    const target = $36b1bb3ecf592bc6$var$getYTarget(sharedRoot, slateRoot, op.path);
    if (!target.slateTarget) throw new Error("Y target without corresponding slate node");
    if (!target.yTarget) {
        if (!(0, $akZf2.Text).isText(target.slateTarget)) throw new Error("Mismatch node type between y target and slate node");
        const unset = {};
        target.targetDelta.forEach((element)=>{
            if (element.attributes) Object.keys(element.attributes).forEach((key)=>{
                unset[key] = null;
            });
        });
        return target.yParent.format(target.textRange.start, target.textRange.end - target.textRange.start, $36b1bb3ecf592bc6$var$__spreadValues($36b1bb3ecf592bc6$var$__spreadValues({}, unset), op.properties));
    }
    if ((0, $akZf2.Text).isText(target.slateTarget)) throw new Error("Mismatch node type between y target and slate node");
    const splitTarget = $36b1bb3ecf592bc6$var$getYTarget(target.yTarget, target.slateTarget, [
        op.position
    ]);
    const ySplitOffset = target.slateTarget.children.slice(0, op.position).reduce((length2, child)=>length2 + $36b1bb3ecf592bc6$var$getSlateNodeYLength(child), 0);
    const length = target.slateTarget.children.reduce((current, child)=>current + $36b1bb3ecf592bc6$var$getSlateNodeYLength(child), 0);
    const splitDelta = $36b1bb3ecf592bc6$var$sliceInsertDelta($36b1bb3ecf592bc6$var$yTextToInsertDelta(target.yTarget), ySplitOffset, length - ySplitOffset);
    const clonedDelta = $36b1bb3ecf592bc6$var$cloneInsertDeltaDeep(splitDelta);
    const storedPositions = $36b1bb3ecf592bc6$var$getStoredPositionsInDeltaAbsolute(sharedRoot, target.yTarget, splitDelta, ySplitOffset);
    const toInsert = new $aw3rr.XmlText();
    toInsert.applyDelta(clonedDelta, {
        sanitize: false
    });
    Object.entries(op.properties).forEach(([key, value])=>{
        toInsert.setAttribute(key, value);
    });
    target.yTarget.delete(splitTarget.textRange.start, target.yTarget.length - splitTarget.textRange.start);
    target.yParent.insertEmbed(target.textRange.end, toInsert);
    $36b1bb3ecf592bc6$var$restoreStoredPositionsWithDeltaAbsolute(sharedRoot, toInsert, storedPositions, clonedDelta, 0, ySplitOffset);
}
// src/applyToYjs/node/index.ts
var $36b1bb3ecf592bc6$var$NODE_MAPPER = {
    insert_node: $36b1bb3ecf592bc6$var$insertNode,
    remove_node: $36b1bb3ecf592bc6$var$removeNode,
    set_node: $36b1bb3ecf592bc6$var$setNode,
    merge_node: $36b1bb3ecf592bc6$var$mergeNode,
    move_node: $36b1bb3ecf592bc6$var$moveNode,
    split_node: $36b1bb3ecf592bc6$var$splitNode
};
function $36b1bb3ecf592bc6$var$insertText(sharedRoot, slateRoot, op) {
    const { yParent: target, textRange: textRange } = $36b1bb3ecf592bc6$var$getYTarget(sharedRoot, slateRoot, op.path);
    const targetNode = (0, $akZf2.Node).get(slateRoot, op.path);
    if (!(0, $akZf2.Text).isText(targetNode)) throw new Error("Cannot insert text into non-text node");
    target.insert(textRange.start + op.offset, op.text, $36b1bb3ecf592bc6$var$getProperties(targetNode));
}
// src/applyToYjs/text/removeText.ts
function $36b1bb3ecf592bc6$var$removeText(sharedRoot, slateRoot, op) {
    const { yParent: target, textRange: textRange } = $36b1bb3ecf592bc6$var$getYTarget(sharedRoot, slateRoot, op.path);
    target.delete(textRange.start + op.offset, op.text.length);
}
// src/applyToYjs/text/index.ts
var $36b1bb3ecf592bc6$var$TEXT_MAPPER = {
    insert_text: $36b1bb3ecf592bc6$var$insertText,
    remove_text: $36b1bb3ecf592bc6$var$removeText
};
// src/applyToYjs/index.ts
var $36b1bb3ecf592bc6$var$NOOP = ()=>{};
var $36b1bb3ecf592bc6$var$opMappers = $36b1bb3ecf592bc6$var$__spreadProps($36b1bb3ecf592bc6$var$__spreadValues($36b1bb3ecf592bc6$var$__spreadValues({}, $36b1bb3ecf592bc6$var$TEXT_MAPPER), $36b1bb3ecf592bc6$var$NODE_MAPPER), {
    set_selection: $36b1bb3ecf592bc6$var$NOOP
});
function $36b1bb3ecf592bc6$var$applySlateOp(sharedRoot, slateRoot, op) {
    const apply = $36b1bb3ecf592bc6$var$opMappers[op.type];
    if (!apply) throw new Error(`Unknown operation: ${op.type}`);
    apply(sharedRoot, slateRoot, op);
}
// src/plugins/withYjs.ts
var $36b1bb3ecf592bc6$var$DEFAULT_LOCAL_ORIGIN = Symbol("slate-yjs-operation");
var $36b1bb3ecf592bc6$var$DEFAULT_POSITION_STORAGE_ORIGIN = Symbol("slate-yjs-position-storage");
var $36b1bb3ecf592bc6$var$ORIGIN = /* @__PURE__ */ new WeakMap();
var $36b1bb3ecf592bc6$var$LOCAL_CHANGES = /* @__PURE__ */ new WeakMap();
var $36b1bb3ecf592bc6$var$CONNECTED = /* @__PURE__ */ new WeakSet();
var $36b1bb3ecf592bc6$export$44093d155363d0da = {
    isYjsEditor (value) {
        return (0, $akZf2.Editor).isEditor(value) && value.sharedRoot instanceof $aw3rr.XmlText && "localOrigin" in value && "positionStorageOrigin" in value && typeof value.applyRemoteEvents === "function" && typeof value.storeLocalChange === "function" && typeof value.flushLocalChanges === "function" && typeof value.isLocalOrigin === "function" && typeof value.connect === "function" && typeof value.disconnect === "function";
    },
    localChanges (editor) {
        var _a;
        return (_a = $36b1bb3ecf592bc6$var$LOCAL_CHANGES.get(editor)) != null ? _a : [];
    },
    applyRemoteEvents (editor, events, origin) {
        editor.applyRemoteEvents(events, origin);
    },
    storeLocalChange (editor, op) {
        editor.storeLocalChange(op);
    },
    flushLocalChanges (editor) {
        editor.flushLocalChanges();
    },
    connected (editor) {
        return $36b1bb3ecf592bc6$var$CONNECTED.has(editor);
    },
    connect (editor) {
        editor.connect();
    },
    disconnect (editor) {
        editor.disconnect();
    },
    isLocal (editor) {
        return editor.isLocalOrigin($36b1bb3ecf592bc6$export$44093d155363d0da.origin(editor));
    },
    origin (editor) {
        const origin = $36b1bb3ecf592bc6$var$ORIGIN.get(editor);
        return origin !== void 0 ? origin : editor.localOrigin;
    },
    withOrigin (editor, origin, fn) {
        const prev = $36b1bb3ecf592bc6$export$44093d155363d0da.origin(editor);
        $36b1bb3ecf592bc6$var$ORIGIN.set(editor, origin);
        fn();
        $36b1bb3ecf592bc6$var$ORIGIN.set(editor, prev);
    },
    storePosition (editor, key, point) {
        const { sharedRoot: sharedRoot, positionStorageOrigin: locationStorageOrigin } = editor;
        $36b1bb3ecf592bc6$var$assertDocumentAttachment(sharedRoot);
        const position = $36b1bb3ecf592bc6$export$609533058754fd73(sharedRoot, editor, point);
        sharedRoot.doc.transact(()=>{
            $36b1bb3ecf592bc6$var$setStoredPosition(sharedRoot, key, position);
        }, locationStorageOrigin);
    },
    removeStoredPosition (editor, key) {
        const { sharedRoot: sharedRoot, positionStorageOrigin: locationStorageOrigin } = editor;
        $36b1bb3ecf592bc6$var$assertDocumentAttachment(sharedRoot);
        sharedRoot.doc.transact(()=>{
            $36b1bb3ecf592bc6$var$removeStoredPosition(sharedRoot, key);
        }, locationStorageOrigin);
    },
    position (editor, key) {
        const position = $36b1bb3ecf592bc6$var$getStoredPosition(editor.sharedRoot, key);
        if (!position) return void 0;
        return $36b1bb3ecf592bc6$export$b8d38944688a99cc(editor.sharedRoot, editor, position);
    },
    storedPositionsRelative (editor) {
        return $36b1bb3ecf592bc6$var$getStoredPositions(editor.sharedRoot);
    }
};
function $36b1bb3ecf592bc6$export$387d76e1896bf98c(editor, sharedRoot, { localOrigin: localOrigin, positionStorageOrigin: positionStorageOrigin, autoConnect: autoConnect = false } = {}) {
    const e = editor;
    e.sharedRoot = sharedRoot;
    e.localOrigin = localOrigin != null ? localOrigin : $36b1bb3ecf592bc6$var$DEFAULT_LOCAL_ORIGIN;
    e.positionStorageOrigin = positionStorageOrigin != null ? positionStorageOrigin : $36b1bb3ecf592bc6$var$DEFAULT_POSITION_STORAGE_ORIGIN;
    e.applyRemoteEvents = (events, origin)=>{
        $36b1bb3ecf592bc6$export$44093d155363d0da.flushLocalChanges(e);
        (0, $akZf2.Editor).withoutNormalizing(e, ()=>{
            $36b1bb3ecf592bc6$export$44093d155363d0da.withOrigin(e, origin, ()=>{
                $36b1bb3ecf592bc6$var$applyYjsEvents(e.sharedRoot, e, events);
            });
        });
    };
    e.isLocalOrigin = (origin)=>origin === e.localOrigin;
    const handleYEvents = (events, transaction)=>{
        if (e.isLocalOrigin(transaction.origin)) return;
        $36b1bb3ecf592bc6$export$44093d155363d0da.applyRemoteEvents(e, events, transaction.origin);
    };
    let autoConnectTimeoutId = null;
    if (autoConnect) autoConnectTimeoutId = setTimeout(()=>{
        autoConnectTimeoutId = null;
        $36b1bb3ecf592bc6$export$44093d155363d0da.connect(e);
    });
    e.connect = ()=>{
        if ($36b1bb3ecf592bc6$export$44093d155363d0da.connected(e)) throw new Error("already connected");
        e.sharedRoot.observeDeep(handleYEvents);
        const content = $36b1bb3ecf592bc6$export$8ef2301867112b96(e.sharedRoot);
        e.children = content.children;
        $36b1bb3ecf592bc6$var$CONNECTED.add(e);
        (0, $akZf2.Editor).normalize(editor, {
            force: true
        });
        if (!editor.operations.length) editor.onChange();
    };
    e.disconnect = ()=>{
        if (autoConnectTimeoutId) clearTimeout(autoConnectTimeoutId);
        $36b1bb3ecf592bc6$export$44093d155363d0da.flushLocalChanges(e);
        e.sharedRoot.unobserveDeep(handleYEvents);
        $36b1bb3ecf592bc6$var$CONNECTED.delete(e);
    };
    e.storeLocalChange = (op)=>{
        $36b1bb3ecf592bc6$var$LOCAL_CHANGES.set(e, [
            ...$36b1bb3ecf592bc6$export$44093d155363d0da.localChanges(e),
            {
                op: op,
                doc: editor.children,
                origin: $36b1bb3ecf592bc6$export$44093d155363d0da.origin(e)
            }
        ]);
    };
    e.flushLocalChanges = ()=>{
        $36b1bb3ecf592bc6$var$assertDocumentAttachment(e.sharedRoot);
        const localChanges = $36b1bb3ecf592bc6$export$44093d155363d0da.localChanges(e);
        $36b1bb3ecf592bc6$var$LOCAL_CHANGES.delete(e);
        const txGroups = [];
        localChanges.forEach((change)=>{
            const currentGroup = txGroups[txGroups.length - 1];
            if (currentGroup && currentGroup[0].origin === change.origin) return currentGroup.push(change);
            txGroups.push([
                change
            ]);
        });
        txGroups.forEach((txGroup)=>{
            $36b1bb3ecf592bc6$var$assertDocumentAttachment(e.sharedRoot);
            e.sharedRoot.doc.transact(()=>{
                txGroup.forEach((change)=>{
                    $36b1bb3ecf592bc6$var$assertDocumentAttachment(e.sharedRoot);
                    $36b1bb3ecf592bc6$var$applySlateOp(e.sharedRoot, {
                        children: change.doc
                    }, change.op);
                });
            }, txGroup[0].origin);
        });
    };
    const { apply: apply, onChange: onChange } = e;
    e.apply = (op)=>{
        if ($36b1bb3ecf592bc6$export$44093d155363d0da.connected(e) && $36b1bb3ecf592bc6$export$44093d155363d0da.isLocal(e)) $36b1bb3ecf592bc6$export$44093d155363d0da.storeLocalChange(e, op);
        apply(op);
    };
    e.onChange = ()=>{
        if ($36b1bb3ecf592bc6$export$44093d155363d0da.connected(e)) $36b1bb3ecf592bc6$export$44093d155363d0da.flushLocalChanges(e);
        onChange();
    };
    return e;
}
var $36b1bb3ecf592bc6$var$LAST_SELECTION = /* @__PURE__ */ new WeakMap();
var $36b1bb3ecf592bc6$var$DEFAULT_WITHOUT_SAVING_ORIGIN = Symbol("slate-yjs-history-without-saving");
var $36b1bb3ecf592bc6$export$bcd78cbc0c2aa26 = {
    isYHistoryEditor (value) {
        return $36b1bb3ecf592bc6$export$44093d155363d0da.isYjsEditor(value) && value.undoManager instanceof $aw3rr.UndoManager && typeof value.undo === "function" && typeof value.redo === "function" && "withoutSavingOrigin" in value;
    },
    canUndo (editor) {
        return editor.undoManager.undoStack.length > 0;
    },
    canRedo (editor) {
        return editor.undoManager.redoStack.length > 0;
    },
    isSaving (editor) {
        return editor.undoManager.trackedOrigins.has($36b1bb3ecf592bc6$export$44093d155363d0da.origin(editor));
    },
    withoutSaving (editor, fn) {
        $36b1bb3ecf592bc6$export$44093d155363d0da.withOrigin(editor, editor.withoutSavingOrigin, fn);
    }
};
function $36b1bb3ecf592bc6$export$596ecc3746f812c8(editor, _a = {}) {
    var _b = _a, { withoutSavingOrigin: withoutSavingOrigin = $36b1bb3ecf592bc6$var$DEFAULT_WITHOUT_SAVING_ORIGIN, trackedOrigins: trackedOrigins = /* @__PURE__ */ new Set([
        editor.localOrigin
    ]) } = _b, options = $36b1bb3ecf592bc6$var$__objRest(_b, [
        "withoutSavingOrigin",
        "trackedOrigins"
    ]);
    const e = editor;
    const undoManager = new $aw3rr.UndoManager(e.sharedRoot, $36b1bb3ecf592bc6$var$__spreadValues({
        trackedOrigins: trackedOrigins
    }, options));
    e.undoManager = undoManager;
    e.withoutSavingOrigin = withoutSavingOrigin;
    const { onChange: onChange, isLocalOrigin: isLocalOrigin } = e;
    e.onChange = ()=>{
        onChange();
        $36b1bb3ecf592bc6$var$LAST_SELECTION.set(e, e.selection && $36b1bb3ecf592bc6$export$d4e3c4ad38d71003(e.sharedRoot, e, e.selection));
    };
    e.isLocalOrigin = (origin)=>origin === e.withoutSavingOrigin || isLocalOrigin(origin);
    const handleStackItemAdded = ({ stackItem: stackItem })=>{
        stackItem.meta.set("selection", e.selection && $36b1bb3ecf592bc6$export$d4e3c4ad38d71003(e.sharedRoot, e, e.selection));
        stackItem.meta.set("selectionBefore", $36b1bb3ecf592bc6$var$LAST_SELECTION.get(e));
    };
    const handleStackItemUpdated = ({ stackItem: stackItem })=>{
        stackItem.meta.set("selection", e.selection && $36b1bb3ecf592bc6$export$d4e3c4ad38d71003(e.sharedRoot, e, e.selection));
    };
    const handleStackItemPopped = ({ stackItem: stackItem, type: type })=>{
        const inverseStack = type === "undo" ? e.undoManager.redoStack : e.undoManager.undoStack;
        const inverseItem = inverseStack[inverseStack.length - 1];
        if (inverseItem) {
            inverseItem.meta.set("selection", stackItem.meta.get("selectionBefore"));
            inverseItem.meta.set("selectionBefore", stackItem.meta.get("selection"));
        }
        const relativeSelection = stackItem.meta.get("selectionBefore");
        if (!relativeSelection) return;
        const selection = $36b1bb3ecf592bc6$export$2dabdbc9ed7f0c0(e.sharedRoot, e, relativeSelection);
        if (!selection) return;
        (0, $akZf2.Transforms).select(e, selection);
    };
    const { connect: connect, disconnect: disconnect } = e;
    e.connect = ()=>{
        connect();
        e.undoManager.on("stack-item-added", handleStackItemAdded);
        e.undoManager.on("stack-item-popped", handleStackItemPopped);
        e.undoManager.on("stack-item-updated", handleStackItemUpdated);
    };
    e.disconnect = ()=>{
        e.undoManager.off("stack-item-added", handleStackItemAdded);
        e.undoManager.off("stack-item-popped", handleStackItemPopped);
        e.undoManager.off("stack-item-updated", handleStackItemUpdated);
        disconnect();
    };
    e.undo = ()=>{
        if ($36b1bb3ecf592bc6$export$44093d155363d0da.connected(e)) {
            $36b1bb3ecf592bc6$export$44093d155363d0da.flushLocalChanges(e);
            e.undoManager.undo();
        }
    };
    e.redo = ()=>{
        if ($36b1bb3ecf592bc6$export$44093d155363d0da.connected(e)) {
            $36b1bb3ecf592bc6$export$44093d155363d0da.flushLocalChanges(e);
            e.undoManager.redo();
        }
    };
    return e;
}
var $36b1bb3ecf592bc6$var$CURSOR_CHANGE_EVENT_LISTENERS = /* @__PURE__ */ new WeakMap();
var $36b1bb3ecf592bc6$export$fbf2a032534b7347 = {
    isCursorEditor (value) {
        return $36b1bb3ecf592bc6$export$44093d155363d0da.isYjsEditor(value) && value.awareness && typeof value.cursorDataField === "string" && typeof value.selectionStateField === "string" && typeof value.sendCursorPosition === "function" && typeof value.sendCursorData === "function";
    },
    sendCursorPosition (editor, range = editor.selection) {
        editor.sendCursorPosition(range);
    },
    sendCursorData (editor, data) {
        editor.sendCursorData(data);
    },
    on (editor, event, handler) {
        var _a;
        if (event !== "change") return;
        const listeners = (_a = $36b1bb3ecf592bc6$var$CURSOR_CHANGE_EVENT_LISTENERS.get(editor)) != null ? _a : /* @__PURE__ */ new Set();
        listeners.add(handler);
        $36b1bb3ecf592bc6$var$CURSOR_CHANGE_EVENT_LISTENERS.set(editor, listeners);
    },
    off (editor, event, listener) {
        if (event !== "change") return;
        const listeners = $36b1bb3ecf592bc6$var$CURSOR_CHANGE_EVENT_LISTENERS.get(editor);
        if (listeners) listeners.delete(listener);
    },
    cursorState (editor, clientId) {
        var _a;
        if (clientId === editor.awareness.clientID || !$36b1bb3ecf592bc6$export$44093d155363d0da.connected(editor)) return null;
        const state = editor.awareness.getStates().get(clientId);
        if (!state) return null;
        return {
            relativeSelection: (_a = state[editor.selectionStateField]) != null ? _a : null,
            data: state[editor.cursorDataField],
            clientId: clientId
        };
    },
    cursorStates (editor) {
        if (!$36b1bb3ecf592bc6$export$44093d155363d0da.connected(editor)) return {};
        return Object.fromEntries(Array.from(editor.awareness.getStates().entries(), ([id, state])=>{
            if (id === editor.awareness.clientID || !state) return null;
            return [
                id,
                {
                    relativeSelection: state[editor.selectionStateField],
                    data: state[editor.cursorDataField]
                }
            ];
        }).filter(Array.isArray));
    }
};
function $36b1bb3ecf592bc6$export$1627a314b215ea23(editor, awareness, { cursorStateField: selectionStateField = "selection", cursorDataField: cursorDataField = "data", autoSend: autoSend = true, data: data } = {}) {
    const e = editor;
    e.awareness = awareness;
    e.cursorDataField = cursorDataField;
    e.selectionStateField = selectionStateField;
    e.sendCursorData = (cursorData)=>{
        e.awareness.setLocalStateField(e.cursorDataField, cursorData);
    };
    e.sendCursorPosition = (range)=>{
        const localState = e.awareness.getLocalState();
        const currentRange = localState == null ? void 0 : localState[selectionStateField];
        if (!range) {
            if (currentRange) e.awareness.setLocalStateField(e.selectionStateField, null);
            return;
        }
        const { anchor: anchor, focus: focus } = $36b1bb3ecf592bc6$export$d4e3c4ad38d71003(e.sharedRoot, e, range);
        if (!currentRange || !$aw3rr.compareRelativePositions(anchor, currentRange) || !$aw3rr.compareRelativePositions(focus, currentRange)) e.awareness.setLocalStateField(e.selectionStateField, {
            anchor: anchor,
            focus: focus
        });
    };
    const awarenessChangeListener = (yEvent)=>{
        const listeners = $36b1bb3ecf592bc6$var$CURSOR_CHANGE_EVENT_LISTENERS.get(e);
        if (!listeners) return;
        const localId = e.awareness.clientID;
        const event = {
            added: yEvent.added.filter((id)=>id !== localId),
            removed: yEvent.removed.filter((id)=>id !== localId),
            updated: yEvent.updated.filter((id)=>id !== localId)
        };
        if (event.added.length > 0 || event.removed.length > 0 || event.updated.length > 0) listeners.forEach((listener)=>listener(event));
    };
    const { connect: connect, disconnect: disconnect } = e;
    e.connect = ()=>{
        connect();
        e.awareness.on("change", awarenessChangeListener);
        awarenessChangeListener({
            removed: [],
            added: Array.from(e.awareness.getStates().keys()),
            updated: []
        });
        if (autoSend) {
            if (data) $36b1bb3ecf592bc6$export$fbf2a032534b7347.sendCursorData(e, data);
            const { onChange: onChange } = e;
            e.onChange = ()=>{
                onChange();
                if ($36b1bb3ecf592bc6$export$44093d155363d0da.connected(e)) $36b1bb3ecf592bc6$export$fbf2a032534b7347.sendCursorPosition(e);
            };
        }
    };
    e.disconnect = ()=>{
        e.awareness.off("change", awarenessChangeListener);
        awarenessChangeListener({
            removed: Array.from(e.awareness.getStates().keys()),
            added: [],
            updated: []
        });
        disconnect();
    };
    return e;
}

});
parcelRegister("akZf2", function(module, exports) {

$parcel$export(module.exports, "Path", function () { return $786b46ea7ddafaee$export$4b2950bdac9b6ee9; });
$parcel$export(module.exports, "Point", function () { return $786b46ea7ddafaee$export$baf26146a414f24a; });
$parcel$export(module.exports, "Range", function () { return $786b46ea7ddafaee$export$9a58ef0d7ad3278c; });
$parcel$export(module.exports, "Node", function () { return $786b46ea7ddafaee$export$85c928794f8d04d4; });
$parcel$export(module.exports, "Text", function () { return $786b46ea7ddafaee$export$5f1af8db9871e1d6; });
$parcel$export(module.exports, "Scrubber", function () { return $786b46ea7ddafaee$export$1e3096e79001f1db; });
$parcel$export(module.exports, "Editor", function () { return $786b46ea7ddafaee$export$7cda8d932e2f33c0; });
$parcel$export(module.exports, "Element", function () { return $786b46ea7ddafaee$export$db77ccec0bb4ccac; });
$parcel$export(module.exports, "Transforms", function () { return $786b46ea7ddafaee$export$2e7e2a6179fcdd5c; });
$parcel$export(module.exports, "createEditor", function () { return $786b46ea7ddafaee$export$eb02d1ee0d3cac30; });

var $lmEbS = parcelRequire("lmEbS");

var $6JaFW = parcelRequire("6JaFW");
// eslint-disable-next-line no-redeclare
var $786b46ea7ddafaee$export$c30b5041fe25721a = {
    transform (ref, op) {
        var { current: current, affinity: affinity } = ref;
        if (current == null) return;
        var path = $786b46ea7ddafaee$export$4b2950bdac9b6ee9.transform(current, op, {
            affinity: affinity
        });
        ref.current = path;
        if (path == null) ref.unref();
    }
};
// eslint-disable-next-line no-redeclare
var $786b46ea7ddafaee$export$2f63ff8a9fd3c92d = {
    transform (ref, op) {
        var { current: current, affinity: affinity } = ref;
        if (current == null) return;
        var point = $786b46ea7ddafaee$export$baf26146a414f24a.transform(current, op, {
            affinity: affinity
        });
        ref.current = point;
        if (point == null) ref.unref();
    }
};
// eslint-disable-next-line no-redeclare
var $786b46ea7ddafaee$export$6de705947f0c0c72 = {
    transform (ref, op) {
        var { current: current, affinity: affinity } = ref;
        if (current == null) return;
        var path = $786b46ea7ddafaee$export$9a58ef0d7ad3278c.transform(current, op, {
            affinity: affinity
        });
        ref.current = path;
        if (path == null) ref.unref();
    }
};
var $786b46ea7ddafaee$var$DIRTY_PATHS = new WeakMap();
var $786b46ea7ddafaee$var$DIRTY_PATH_KEYS = new WeakMap();
var $786b46ea7ddafaee$var$FLUSHING = new WeakMap();
var $786b46ea7ddafaee$var$NORMALIZING = new WeakMap();
var $786b46ea7ddafaee$var$PATH_REFS = new WeakMap();
var $786b46ea7ddafaee$var$POINT_REFS = new WeakMap();
var $786b46ea7ddafaee$var$RANGE_REFS = new WeakMap();
// eslint-disable-next-line no-redeclare
var $786b46ea7ddafaee$export$4b2950bdac9b6ee9 = {
    ancestors (path) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var { reverse: reverse = false } = options;
        var paths = $786b46ea7ddafaee$export$4b2950bdac9b6ee9.levels(path, options);
        if (reverse) paths = paths.slice(1);
        else paths = paths.slice(0, -1);
        return paths;
    },
    common (path, another) {
        var common = [];
        for(var i = 0; i < path.length && i < another.length; i++){
            var av = path[i];
            var bv = another[i];
            if (av !== bv) break;
            common.push(av);
        }
        return common;
    },
    compare (path, another) {
        var min = Math.min(path.length, another.length);
        for(var i = 0; i < min; i++){
            if (path[i] < another[i]) return -1;
            if (path[i] > another[i]) return 1;
        }
        return 0;
    },
    endsAfter (path, another) {
        var i = path.length - 1;
        var as = path.slice(0, i);
        var bs = another.slice(0, i);
        var av = path[i];
        var bv = another[i];
        return $786b46ea7ddafaee$export$4b2950bdac9b6ee9.equals(as, bs) && av > bv;
    },
    endsAt (path, another) {
        var i = path.length;
        var as = path.slice(0, i);
        var bs = another.slice(0, i);
        return $786b46ea7ddafaee$export$4b2950bdac9b6ee9.equals(as, bs);
    },
    endsBefore (path, another) {
        var i = path.length - 1;
        var as = path.slice(0, i);
        var bs = another.slice(0, i);
        var av = path[i];
        var bv = another[i];
        return $786b46ea7ddafaee$export$4b2950bdac9b6ee9.equals(as, bs) && av < bv;
    },
    equals (path, another) {
        return path.length === another.length && path.every((n, i)=>n === another[i]);
    },
    hasPrevious (path) {
        return path[path.length - 1] > 0;
    },
    isAfter (path, another) {
        return $786b46ea7ddafaee$export$4b2950bdac9b6ee9.compare(path, another) === 1;
    },
    isAncestor (path, another) {
        return path.length < another.length && $786b46ea7ddafaee$export$4b2950bdac9b6ee9.compare(path, another) === 0;
    },
    isBefore (path, another) {
        return $786b46ea7ddafaee$export$4b2950bdac9b6ee9.compare(path, another) === -1;
    },
    isChild (path, another) {
        return path.length === another.length + 1 && $786b46ea7ddafaee$export$4b2950bdac9b6ee9.compare(path, another) === 0;
    },
    isCommon (path, another) {
        return path.length <= another.length && $786b46ea7ddafaee$export$4b2950bdac9b6ee9.compare(path, another) === 0;
    },
    isDescendant (path, another) {
        return path.length > another.length && $786b46ea7ddafaee$export$4b2950bdac9b6ee9.compare(path, another) === 0;
    },
    isParent (path, another) {
        return path.length + 1 === another.length && $786b46ea7ddafaee$export$4b2950bdac9b6ee9.compare(path, another) === 0;
    },
    isPath (value) {
        return Array.isArray(value) && (value.length === 0 || typeof value[0] === "number");
    },
    isSibling (path, another) {
        if (path.length !== another.length) return false;
        var as = path.slice(0, -1);
        var bs = another.slice(0, -1);
        var al = path[path.length - 1];
        var bl = another[another.length - 1];
        return al !== bl && $786b46ea7ddafaee$export$4b2950bdac9b6ee9.equals(as, bs);
    },
    levels (path) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var { reverse: reverse = false } = options;
        var list = [];
        for(var i = 0; i <= path.length; i++)list.push(path.slice(0, i));
        if (reverse) list.reverse();
        return list;
    },
    next (path) {
        if (path.length === 0) throw new Error("Cannot get the next path of a root path [".concat(path, "], because it has no next index."));
        var last = path[path.length - 1];
        return path.slice(0, -1).concat(last + 1);
    },
    operationCanTransformPath (operation) {
        switch(operation.type){
            case "insert_node":
            case "remove_node":
            case "merge_node":
            case "split_node":
            case "move_node":
                return true;
            default:
                return false;
        }
    },
    parent (path) {
        if (path.length === 0) throw new Error("Cannot get the parent path of the root path [".concat(path, "]."));
        return path.slice(0, -1);
    },
    previous (path) {
        if (path.length === 0) throw new Error("Cannot get the previous path of a root path [".concat(path, "], because it has no previous index."));
        var last = path[path.length - 1];
        if (last <= 0) throw new Error("Cannot get the previous path of a first child path [".concat(path, "] because it would result in a negative index."));
        return path.slice(0, -1).concat(last - 1);
    },
    relative (path, ancestor) {
        if (!$786b46ea7ddafaee$export$4b2950bdac9b6ee9.isAncestor(ancestor, path) && !$786b46ea7ddafaee$export$4b2950bdac9b6ee9.equals(path, ancestor)) throw new Error("Cannot get the relative path of [".concat(path, "] inside ancestor [").concat(ancestor, "], because it is not above or equal to the path."));
        return path.slice(ancestor.length);
    },
    transform (path, operation) {
        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        if (!path) return null;
        // PERF: use destructing instead of immer
        var p = [
            ...path
        ];
        var { affinity: affinity = "forward" } = options;
        // PERF: Exit early if the operation is guaranteed not to have an effect.
        if (path.length === 0) return p;
        switch(operation.type){
            case "insert_node":
                var { path: op } = operation;
                if ($786b46ea7ddafaee$export$4b2950bdac9b6ee9.equals(op, p) || $786b46ea7ddafaee$export$4b2950bdac9b6ee9.endsBefore(op, p) || $786b46ea7ddafaee$export$4b2950bdac9b6ee9.isAncestor(op, p)) p[op.length - 1] += 1;
                break;
            case "remove_node":
                var { path: _op } = operation;
                if ($786b46ea7ddafaee$export$4b2950bdac9b6ee9.equals(_op, p) || $786b46ea7ddafaee$export$4b2950bdac9b6ee9.isAncestor(_op, p)) return null;
                else if ($786b46ea7ddafaee$export$4b2950bdac9b6ee9.endsBefore(_op, p)) p[_op.length - 1] -= 1;
                break;
            case "merge_node":
                var { path: _op2, position: position } = operation;
                if ($786b46ea7ddafaee$export$4b2950bdac9b6ee9.equals(_op2, p) || $786b46ea7ddafaee$export$4b2950bdac9b6ee9.endsBefore(_op2, p)) p[_op2.length - 1] -= 1;
                else if ($786b46ea7ddafaee$export$4b2950bdac9b6ee9.isAncestor(_op2, p)) {
                    p[_op2.length - 1] -= 1;
                    p[_op2.length] += position;
                }
                break;
            case "split_node":
                var { path: _op3, position: _position } = operation;
                if ($786b46ea7ddafaee$export$4b2950bdac9b6ee9.equals(_op3, p)) {
                    if (affinity === "forward") p[p.length - 1] += 1;
                    else if (affinity === "backward") ;
                    else return null;
                } else if ($786b46ea7ddafaee$export$4b2950bdac9b6ee9.endsBefore(_op3, p)) p[_op3.length - 1] += 1;
                else if ($786b46ea7ddafaee$export$4b2950bdac9b6ee9.isAncestor(_op3, p) && path[_op3.length] >= _position) {
                    p[_op3.length - 1] += 1;
                    p[_op3.length] -= _position;
                }
                break;
            case "move_node":
                var { path: _op4, newPath: onp } = operation;
                // If the old and new path are the same, it's a no-op.
                if ($786b46ea7ddafaee$export$4b2950bdac9b6ee9.equals(_op4, onp)) return p;
                if ($786b46ea7ddafaee$export$4b2950bdac9b6ee9.isAncestor(_op4, p) || $786b46ea7ddafaee$export$4b2950bdac9b6ee9.equals(_op4, p)) {
                    var copy = onp.slice();
                    if ($786b46ea7ddafaee$export$4b2950bdac9b6ee9.endsBefore(_op4, onp) && _op4.length < onp.length) copy[_op4.length - 1] -= 1;
                    return copy.concat(p.slice(_op4.length));
                } else if ($786b46ea7ddafaee$export$4b2950bdac9b6ee9.isSibling(_op4, onp) && ($786b46ea7ddafaee$export$4b2950bdac9b6ee9.isAncestor(onp, p) || $786b46ea7ddafaee$export$4b2950bdac9b6ee9.equals(onp, p))) {
                    if ($786b46ea7ddafaee$export$4b2950bdac9b6ee9.endsBefore(_op4, p)) p[_op4.length - 1] -= 1;
                    else p[_op4.length - 1] += 1;
                } else if ($786b46ea7ddafaee$export$4b2950bdac9b6ee9.endsBefore(onp, p) || $786b46ea7ddafaee$export$4b2950bdac9b6ee9.equals(onp, p) || $786b46ea7ddafaee$export$4b2950bdac9b6ee9.isAncestor(onp, p)) {
                    if ($786b46ea7ddafaee$export$4b2950bdac9b6ee9.endsBefore(_op4, p)) p[_op4.length - 1] -= 1;
                    p[onp.length - 1] += 1;
                } else if ($786b46ea7ddafaee$export$4b2950bdac9b6ee9.endsBefore(_op4, p)) {
                    if ($786b46ea7ddafaee$export$4b2950bdac9b6ee9.equals(onp, p)) p[onp.length - 1] += 1;
                    p[_op4.length - 1] -= 1;
                }
                break;
        }
        return p;
    }
};
function $786b46ea7ddafaee$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $786b46ea7ddafaee$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $786b46ea7ddafaee$var$_typeof(o);
}
function $786b46ea7ddafaee$var$_toPrimitive(input, hint) {
    if ($786b46ea7ddafaee$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($786b46ea7ddafaee$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $786b46ea7ddafaee$var$_toPropertyKey(arg) {
    var key = $786b46ea7ddafaee$var$_toPrimitive(arg, "string");
    return $786b46ea7ddafaee$var$_typeof(key) === "symbol" ? key : String(key);
}
function $786b46ea7ddafaee$var$_defineProperty(obj, key, value) {
    key = $786b46ea7ddafaee$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $786b46ea7ddafaee$var$ownKeys$e(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $786b46ea7ddafaee$var$_objectSpread$e(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $786b46ea7ddafaee$var$ownKeys$e(Object(t), !0).forEach(function(r) {
            $786b46ea7ddafaee$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $786b46ea7ddafaee$var$ownKeys$e(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $786b46ea7ddafaee$var$applyToDraft = (editor, selection, op)=>{
    switch(op.type){
        case "insert_node":
            var { path: path, node: node } = op;
            var parent = $786b46ea7ddafaee$export$85c928794f8d04d4.parent(editor, path);
            var index = path[path.length - 1];
            if (index > parent.children.length) throw new Error('Cannot apply an "insert_node" operation at path ['.concat(path, "] because the destination is past the end of the node."));
            parent.children.splice(index, 0, node);
            if (selection) for (var [point, key] of $786b46ea7ddafaee$export$9a58ef0d7ad3278c.points(selection))selection[key] = $786b46ea7ddafaee$export$baf26146a414f24a.transform(point, op);
            break;
        case "insert_text":
            var { path: _path, offset: offset, text: text } = op;
            if (text.length === 0) break;
            var _node = $786b46ea7ddafaee$export$85c928794f8d04d4.leaf(editor, _path);
            var before = _node.text.slice(0, offset);
            var after = _node.text.slice(offset);
            _node.text = before + text + after;
            if (selection) for (var [_point, _key] of $786b46ea7ddafaee$export$9a58ef0d7ad3278c.points(selection))selection[_key] = $786b46ea7ddafaee$export$baf26146a414f24a.transform(_point, op);
            break;
        case "merge_node":
            var { path: _path2 } = op;
            var _node2 = $786b46ea7ddafaee$export$85c928794f8d04d4.get(editor, _path2);
            var prevPath = $786b46ea7ddafaee$export$4b2950bdac9b6ee9.previous(_path2);
            var prev = $786b46ea7ddafaee$export$85c928794f8d04d4.get(editor, prevPath);
            var _parent = $786b46ea7ddafaee$export$85c928794f8d04d4.parent(editor, _path2);
            var _index = _path2[_path2.length - 1];
            if ($786b46ea7ddafaee$export$5f1af8db9871e1d6.isText(_node2) && $786b46ea7ddafaee$export$5f1af8db9871e1d6.isText(prev)) prev.text += _node2.text;
            else if (!$786b46ea7ddafaee$export$5f1af8db9871e1d6.isText(_node2) && !$786b46ea7ddafaee$export$5f1af8db9871e1d6.isText(prev)) prev.children.push(..._node2.children);
            else throw new Error('Cannot apply a "merge_node" operation at path ['.concat(_path2, "] to nodes of different interfaces: ").concat($786b46ea7ddafaee$export$1e3096e79001f1db.stringify(_node2), " ").concat($786b46ea7ddafaee$export$1e3096e79001f1db.stringify(prev)));
            _parent.children.splice(_index, 1);
            if (selection) for (var [_point2, _key2] of $786b46ea7ddafaee$export$9a58ef0d7ad3278c.points(selection))selection[_key2] = $786b46ea7ddafaee$export$baf26146a414f24a.transform(_point2, op);
            break;
        case "move_node":
            var { path: _path3, newPath: newPath } = op;
            if ($786b46ea7ddafaee$export$4b2950bdac9b6ee9.isAncestor(_path3, newPath)) throw new Error("Cannot move a path [".concat(_path3, "] to new path [").concat(newPath, "] because the destination is inside itself."));
            var _node3 = $786b46ea7ddafaee$export$85c928794f8d04d4.get(editor, _path3);
            var _parent2 = $786b46ea7ddafaee$export$85c928794f8d04d4.parent(editor, _path3);
            var _index2 = _path3[_path3.length - 1];
            // This is tricky, but since the `path` and `newPath` both refer to
            // the same snapshot in time, there's a mismatch. After either
            // removing the original position, the second step's path can be out
            // of date. So instead of using the `op.newPath` directly, we
            // transform `op.path` to ascertain what the `newPath` would be after
            // the operation was applied.
            _parent2.children.splice(_index2, 1);
            var truePath = $786b46ea7ddafaee$export$4b2950bdac9b6ee9.transform(_path3, op);
            var newParent = $786b46ea7ddafaee$export$85c928794f8d04d4.get(editor, $786b46ea7ddafaee$export$4b2950bdac9b6ee9.parent(truePath));
            var newIndex = truePath[truePath.length - 1];
            newParent.children.splice(newIndex, 0, _node3);
            if (selection) for (var [_point3, _key3] of $786b46ea7ddafaee$export$9a58ef0d7ad3278c.points(selection))selection[_key3] = $786b46ea7ddafaee$export$baf26146a414f24a.transform(_point3, op);
            break;
        case "remove_node":
            var { path: _path4 } = op;
            var _index3 = _path4[_path4.length - 1];
            var _parent3 = $786b46ea7ddafaee$export$85c928794f8d04d4.parent(editor, _path4);
            _parent3.children.splice(_index3, 1);
            // Transform all the points in the value, but if the point was in the
            // node that was removed we need to update the range or remove it.
            if (selection) for (var [_point4, _key4] of $786b46ea7ddafaee$export$9a58ef0d7ad3278c.points(selection)){
                var result = $786b46ea7ddafaee$export$baf26146a414f24a.transform(_point4, op);
                if (selection != null && result != null) selection[_key4] = result;
                else {
                    var _prev = void 0;
                    var next = void 0;
                    for (var [n, p] of $786b46ea7ddafaee$export$85c928794f8d04d4.texts(editor))if ($786b46ea7ddafaee$export$4b2950bdac9b6ee9.compare(p, _path4) === -1) _prev = [
                        n,
                        p
                    ];
                    else {
                        next = [
                            n,
                            p
                        ];
                        break;
                    }
                    var preferNext = false;
                    if (_prev && next) {
                        if ($786b46ea7ddafaee$export$4b2950bdac9b6ee9.equals(next[1], _path4)) preferNext = !$786b46ea7ddafaee$export$4b2950bdac9b6ee9.hasPrevious(next[1]);
                        else preferNext = $786b46ea7ddafaee$export$4b2950bdac9b6ee9.common(_prev[1], _path4).length < $786b46ea7ddafaee$export$4b2950bdac9b6ee9.common(next[1], _path4).length;
                    }
                    if (_prev && !preferNext) {
                        _point4.path = _prev[1];
                        _point4.offset = _prev[0].text.length;
                    } else if (next) {
                        _point4.path = next[1];
                        _point4.offset = 0;
                    } else selection = null;
                }
            }
            break;
        case "remove_text":
            var { path: _path5, offset: _offset, text: _text } = op;
            if (_text.length === 0) break;
            var _node4 = $786b46ea7ddafaee$export$85c928794f8d04d4.leaf(editor, _path5);
            var _before = _node4.text.slice(0, _offset);
            var _after = _node4.text.slice(_offset + _text.length);
            _node4.text = _before + _after;
            if (selection) for (var [_point5, _key5] of $786b46ea7ddafaee$export$9a58ef0d7ad3278c.points(selection))selection[_key5] = $786b46ea7ddafaee$export$baf26146a414f24a.transform(_point5, op);
            break;
        case "set_node":
            var { path: _path6, properties: properties, newProperties: newProperties } = op;
            if (_path6.length === 0) throw new Error("Cannot set properties on the root node!");
            var _node5 = $786b46ea7ddafaee$export$85c928794f8d04d4.get(editor, _path6);
            for(var _key6 in newProperties){
                if (_key6 === "children" || _key6 === "text") throw new Error('Cannot set the "'.concat(_key6, '" property of nodes!'));
                var value = newProperties[_key6];
                if (value == null) delete _node5[_key6];
                else _node5[_key6] = value;
            }
            // properties that were previously defined, but are now missing, must be deleted
            for(var _key7 in properties)if (!newProperties.hasOwnProperty(_key7)) delete _node5[_key7];
            break;
        case "set_selection":
            var { newProperties: _newProperties } = op;
            if (_newProperties == null) selection = _newProperties;
            else {
                if (selection == null) {
                    if (!$786b46ea7ddafaee$export$9a58ef0d7ad3278c.isRange(_newProperties)) throw new Error('Cannot apply an incomplete "set_selection" operation properties '.concat($786b46ea7ddafaee$export$1e3096e79001f1db.stringify(_newProperties), " when there is no current selection."));
                    selection = $786b46ea7ddafaee$var$_objectSpread$e({}, _newProperties);
                }
                for(var _key8 in _newProperties){
                    var _value = _newProperties[_key8];
                    if (_value == null) {
                        if (_key8 === "anchor" || _key8 === "focus") throw new Error('Cannot remove the "'.concat(_key8, '" selection property'));
                        delete selection[_key8];
                    } else selection[_key8] = _value;
                }
            }
            break;
        case "split_node":
            var { path: _path7, position: position, properties: _properties } = op;
            if (_path7.length === 0) throw new Error('Cannot apply a "split_node" operation at path ['.concat(_path7, "] because the root node cannot be split."));
            var _node6 = $786b46ea7ddafaee$export$85c928794f8d04d4.get(editor, _path7);
            var _parent4 = $786b46ea7ddafaee$export$85c928794f8d04d4.parent(editor, _path7);
            var _index4 = _path7[_path7.length - 1];
            var newNode;
            if ($786b46ea7ddafaee$export$5f1af8db9871e1d6.isText(_node6)) {
                var _before2 = _node6.text.slice(0, position);
                var _after2 = _node6.text.slice(position);
                _node6.text = _before2;
                newNode = $786b46ea7ddafaee$var$_objectSpread$e($786b46ea7ddafaee$var$_objectSpread$e({}, _properties), {}, {
                    text: _after2
                });
            } else {
                var _before3 = _node6.children.slice(0, position);
                var _after3 = _node6.children.slice(position);
                _node6.children = _before3;
                newNode = $786b46ea7ddafaee$var$_objectSpread$e($786b46ea7ddafaee$var$_objectSpread$e({}, _properties), {}, {
                    children: _after3
                });
            }
            _parent4.children.splice(_index4 + 1, 0, newNode);
            if (selection) for (var [_point6, _key9] of $786b46ea7ddafaee$export$9a58ef0d7ad3278c.points(selection))selection[_key9] = $786b46ea7ddafaee$export$baf26146a414f24a.transform(_point6, op);
            break;
    }
    return selection;
};
// eslint-disable-next-line no-redeclare
var $786b46ea7ddafaee$var$GeneralTransforms = {
    transform (editor, op) {
        editor.children = (0, $6JaFW.createDraft)(editor.children);
        var selection = editor.selection && (0, $6JaFW.createDraft)(editor.selection);
        try {
            selection = $786b46ea7ddafaee$var$applyToDraft(editor, selection, op);
        } finally{
            editor.children = (0, $6JaFW.finishDraft)(editor.children);
            if (selection) editor.selection = (0, $6JaFW.isDraft)(selection) ? (0, $6JaFW.finishDraft)(selection) : selection;
            else editor.selection = null;
        }
    }
};
// eslint-disable-next-line no-redeclare
var $786b46ea7ddafaee$var$NodeTransforms = {
    insertNodes (editor, nodes, options) {
        editor.insertNodes(nodes, options);
    },
    liftNodes (editor, options) {
        editor.liftNodes(options);
    },
    mergeNodes (editor, options) {
        editor.mergeNodes(options);
    },
    moveNodes (editor, options) {
        editor.moveNodes(options);
    },
    removeNodes (editor, options) {
        editor.removeNodes(options);
    },
    setNodes (editor, props, options) {
        editor.setNodes(props, options);
    },
    splitNodes (editor, options) {
        editor.splitNodes(options);
    },
    unsetNodes (editor, props, options) {
        editor.unsetNodes(props, options);
    },
    unwrapNodes (editor, options) {
        editor.unwrapNodes(options);
    },
    wrapNodes (editor, element, options) {
        editor.wrapNodes(element, options);
    }
};
// eslint-disable-next-line no-redeclare
var $786b46ea7ddafaee$var$SelectionTransforms = {
    collapse (editor, options) {
        editor.collapse(options);
    },
    deselect (editor) {
        editor.deselect();
    },
    move (editor, options) {
        editor.move(options);
    },
    select (editor, target) {
        editor.select(target);
    },
    setPoint (editor, props, options) {
        editor.setPoint(props, options);
    },
    setSelection (editor, props) {
        editor.setSelection(props);
    }
};
/*
  Custom deep equal comparison for Slate nodes.

  We don't need general purpose deep equality;
  Slate only supports plain values, Arrays, and nested objects.
  Complex values nested inside Arrays are not supported.

  Slate objects are designed to be serialised, so
  missing keys are deliberately normalised to undefined.
 */ var $786b46ea7ddafaee$var$isDeepEqual = (node, another)=>{
    for(var key in node){
        var a = node[key];
        var b = another[key];
        if ((0, $lmEbS.isPlainObject)(a) && (0, $lmEbS.isPlainObject)(b)) {
            if (!$786b46ea7ddafaee$var$isDeepEqual(a, b)) return false;
        } else if (Array.isArray(a) && Array.isArray(b)) {
            if (a.length !== b.length) return false;
            for(var i = 0; i < a.length; i++){
                if (a[i] !== b[i]) return false;
            }
        } else if (a !== b) return false;
    }
    /*
    Deep object equality is only necessary in one direction; in the reverse direction
    we are only looking for keys that are missing.
    As above, undefined keys are normalised to missing.
  */ for(var _key in another){
        if (node[_key] === undefined && another[_key] !== undefined) return false;
    }
    return true;
};
function $786b46ea7ddafaee$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $786b46ea7ddafaee$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $786b46ea7ddafaee$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
var $786b46ea7ddafaee$var$_excluded$4 = [
    "anchor",
    "focus"
];
function $786b46ea7ddafaee$var$ownKeys$d(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $786b46ea7ddafaee$var$_objectSpread$d(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $786b46ea7ddafaee$var$ownKeys$d(Object(t), !0).forEach(function(r) {
            $786b46ea7ddafaee$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $786b46ea7ddafaee$var$ownKeys$d(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
// eslint-disable-next-line no-redeclare
var $786b46ea7ddafaee$export$9a58ef0d7ad3278c = {
    edges (range) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var { reverse: reverse = false } = options;
        var { anchor: anchor, focus: focus } = range;
        return $786b46ea7ddafaee$export$9a58ef0d7ad3278c.isBackward(range) === reverse ? [
            anchor,
            focus
        ] : [
            focus,
            anchor
        ];
    },
    end (range) {
        var [, end] = $786b46ea7ddafaee$export$9a58ef0d7ad3278c.edges(range);
        return end;
    },
    equals (range, another) {
        return $786b46ea7ddafaee$export$baf26146a414f24a.equals(range.anchor, another.anchor) && $786b46ea7ddafaee$export$baf26146a414f24a.equals(range.focus, another.focus);
    },
    surrounds (range, target) {
        var intersectionRange = $786b46ea7ddafaee$export$9a58ef0d7ad3278c.intersection(range, target);
        if (!intersectionRange) return false;
        return $786b46ea7ddafaee$export$9a58ef0d7ad3278c.equals(intersectionRange, target);
    },
    includes (range, target) {
        if ($786b46ea7ddafaee$export$9a58ef0d7ad3278c.isRange(target)) {
            if ($786b46ea7ddafaee$export$9a58ef0d7ad3278c.includes(range, target.anchor) || $786b46ea7ddafaee$export$9a58ef0d7ad3278c.includes(range, target.focus)) return true;
            var [rs, re] = $786b46ea7ddafaee$export$9a58ef0d7ad3278c.edges(range);
            var [ts, te] = $786b46ea7ddafaee$export$9a58ef0d7ad3278c.edges(target);
            return $786b46ea7ddafaee$export$baf26146a414f24a.isBefore(rs, ts) && $786b46ea7ddafaee$export$baf26146a414f24a.isAfter(re, te);
        }
        var [start, end] = $786b46ea7ddafaee$export$9a58ef0d7ad3278c.edges(range);
        var isAfterStart = false;
        var isBeforeEnd = false;
        if ($786b46ea7ddafaee$export$baf26146a414f24a.isPoint(target)) {
            isAfterStart = $786b46ea7ddafaee$export$baf26146a414f24a.compare(target, start) >= 0;
            isBeforeEnd = $786b46ea7ddafaee$export$baf26146a414f24a.compare(target, end) <= 0;
        } else {
            isAfterStart = $786b46ea7ddafaee$export$4b2950bdac9b6ee9.compare(target, start.path) >= 0;
            isBeforeEnd = $786b46ea7ddafaee$export$4b2950bdac9b6ee9.compare(target, end.path) <= 0;
        }
        return isAfterStart && isBeforeEnd;
    },
    intersection (range, another) {
        var rest = $786b46ea7ddafaee$var$_objectWithoutProperties(range, $786b46ea7ddafaee$var$_excluded$4);
        var [s1, e1] = $786b46ea7ddafaee$export$9a58ef0d7ad3278c.edges(range);
        var [s2, e2] = $786b46ea7ddafaee$export$9a58ef0d7ad3278c.edges(another);
        var start = $786b46ea7ddafaee$export$baf26146a414f24a.isBefore(s1, s2) ? s2 : s1;
        var end = $786b46ea7ddafaee$export$baf26146a414f24a.isBefore(e1, e2) ? e1 : e2;
        if ($786b46ea7ddafaee$export$baf26146a414f24a.isBefore(end, start)) return null;
        else return $786b46ea7ddafaee$var$_objectSpread$d({
            anchor: start,
            focus: end
        }, rest);
    },
    isBackward (range) {
        var { anchor: anchor, focus: focus } = range;
        return $786b46ea7ddafaee$export$baf26146a414f24a.isAfter(anchor, focus);
    },
    isCollapsed (range) {
        var { anchor: anchor, focus: focus } = range;
        return $786b46ea7ddafaee$export$baf26146a414f24a.equals(anchor, focus);
    },
    isExpanded (range) {
        return !$786b46ea7ddafaee$export$9a58ef0d7ad3278c.isCollapsed(range);
    },
    isForward (range) {
        return !$786b46ea7ddafaee$export$9a58ef0d7ad3278c.isBackward(range);
    },
    isRange (value) {
        return (0, $lmEbS.isPlainObject)(value) && $786b46ea7ddafaee$export$baf26146a414f24a.isPoint(value.anchor) && $786b46ea7ddafaee$export$baf26146a414f24a.isPoint(value.focus);
    },
    *points (range) {
        yield [
            range.anchor,
            "anchor"
        ];
        yield [
            range.focus,
            "focus"
        ];
    },
    start (range) {
        var [start] = $786b46ea7ddafaee$export$9a58ef0d7ad3278c.edges(range);
        return start;
    },
    transform (range, op) {
        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        return (0, $6JaFW.produce)(range, (r)=>{
            if (r === null) return null;
            var { affinity: affinity = "inward" } = options;
            var affinityAnchor;
            var affinityFocus;
            if (affinity === "inward") {
                // If the range is collapsed, make sure to use the same affinity to
                // avoid the two points passing each other and expanding in the opposite
                // direction
                var isCollapsed = $786b46ea7ddafaee$export$9a58ef0d7ad3278c.isCollapsed(r);
                if ($786b46ea7ddafaee$export$9a58ef0d7ad3278c.isForward(r)) {
                    affinityAnchor = "forward";
                    affinityFocus = isCollapsed ? affinityAnchor : "backward";
                } else {
                    affinityAnchor = "backward";
                    affinityFocus = isCollapsed ? affinityAnchor : "forward";
                }
            } else if (affinity === "outward") {
                if ($786b46ea7ddafaee$export$9a58ef0d7ad3278c.isForward(r)) {
                    affinityAnchor = "backward";
                    affinityFocus = "forward";
                } else {
                    affinityAnchor = "forward";
                    affinityFocus = "backward";
                }
            } else {
                affinityAnchor = affinity;
                affinityFocus = affinity;
            }
            var anchor = $786b46ea7ddafaee$export$baf26146a414f24a.transform(r.anchor, op, {
                affinity: affinityAnchor
            });
            var focus = $786b46ea7ddafaee$export$baf26146a414f24a.transform(r.focus, op, {
                affinity: affinityFocus
            });
            if (!anchor || !focus) return null;
            r.anchor = anchor;
            r.focus = focus;
        });
    }
};
/**
 * Shared the function with isElementType utility
 */ var $786b46ea7ddafaee$var$isElement = (value)=>{
    return (0, $lmEbS.isPlainObject)(value) && $786b46ea7ddafaee$export$85c928794f8d04d4.isNodeList(value.children) && !$786b46ea7ddafaee$export$7cda8d932e2f33c0.isEditor(value);
};
// eslint-disable-next-line no-redeclare
var $786b46ea7ddafaee$export$db77ccec0bb4ccac = {
    isAncestor (value) {
        return (0, $lmEbS.isPlainObject)(value) && $786b46ea7ddafaee$export$85c928794f8d04d4.isNodeList(value.children);
    },
    isElement: $786b46ea7ddafaee$var$isElement,
    isElementList (value) {
        return Array.isArray(value) && value.every((val)=>$786b46ea7ddafaee$export$db77ccec0bb4ccac.isElement(val));
    },
    isElementProps (props) {
        return props.children !== undefined;
    },
    isElementType: function isElementType(value, elementVal) {
        var elementKey = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "type";
        return $786b46ea7ddafaee$var$isElement(value) && value[elementKey] === elementVal;
    },
    matches (element, props) {
        for(var key in props){
            if (key === "children") continue;
            if (element[key] !== props[key]) return false;
        }
        return true;
    }
};
var $786b46ea7ddafaee$var$_excluded$3 = [
    "children"
], $786b46ea7ddafaee$var$_excluded2$3 = [
    "text"
];
var $786b46ea7ddafaee$var$IS_NODE_LIST_CACHE = new WeakMap();
// eslint-disable-next-line no-redeclare
var $786b46ea7ddafaee$export$85c928794f8d04d4 = {
    ancestor (root, path) {
        var node = $786b46ea7ddafaee$export$85c928794f8d04d4.get(root, path);
        if ($786b46ea7ddafaee$export$5f1af8db9871e1d6.isText(node)) throw new Error("Cannot get the ancestor node at path [".concat(path, "] because it refers to a text node instead: ").concat($786b46ea7ddafaee$export$1e3096e79001f1db.stringify(node)));
        return node;
    },
    ancestors (root, path) {
        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        return function*() {
            for (var p of $786b46ea7ddafaee$export$4b2950bdac9b6ee9.ancestors(path, options)){
                var n = $786b46ea7ddafaee$export$85c928794f8d04d4.ancestor(root, p);
                var entry = [
                    n,
                    p
                ];
                yield entry;
            }
        }();
    },
    child (root, index) {
        if ($786b46ea7ddafaee$export$5f1af8db9871e1d6.isText(root)) throw new Error("Cannot get the child of a text node: ".concat($786b46ea7ddafaee$export$1e3096e79001f1db.stringify(root)));
        var c = root.children[index];
        if (c == null) throw new Error("Cannot get child at index `".concat(index, "` in node: ").concat($786b46ea7ddafaee$export$1e3096e79001f1db.stringify(root)));
        return c;
    },
    children (root, path) {
        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        return function*() {
            var { reverse: reverse = false } = options;
            var ancestor = $786b46ea7ddafaee$export$85c928794f8d04d4.ancestor(root, path);
            var { children: children } = ancestor;
            var index = reverse ? children.length - 1 : 0;
            while(reverse ? index >= 0 : index < children.length){
                var child = $786b46ea7ddafaee$export$85c928794f8d04d4.child(ancestor, index);
                var childPath = path.concat(index);
                yield [
                    child,
                    childPath
                ];
                index = reverse ? index - 1 : index + 1;
            }
        }();
    },
    common (root, path, another) {
        var p = $786b46ea7ddafaee$export$4b2950bdac9b6ee9.common(path, another);
        var n = $786b46ea7ddafaee$export$85c928794f8d04d4.get(root, p);
        return [
            n,
            p
        ];
    },
    descendant (root, path) {
        var node = $786b46ea7ddafaee$export$85c928794f8d04d4.get(root, path);
        if ($786b46ea7ddafaee$export$7cda8d932e2f33c0.isEditor(node)) throw new Error("Cannot get the descendant node at path [".concat(path, "] because it refers to the root editor node instead: ").concat($786b46ea7ddafaee$export$1e3096e79001f1db.stringify(node)));
        return node;
    },
    descendants (root) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return function*() {
            for (var [node, path] of $786b46ea7ddafaee$export$85c928794f8d04d4.nodes(root, options))if (path.length !== 0) // NOTE: we have to coerce here because checking the path's length does
            // guarantee that `node` is not a `Editor`, but TypeScript doesn't know.
            yield [
                node,
                path
            ];
        }();
    },
    elements (root) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return function*() {
            for (var [node, path] of $786b46ea7ddafaee$export$85c928794f8d04d4.nodes(root, options))if ($786b46ea7ddafaee$export$db77ccec0bb4ccac.isElement(node)) yield [
                node,
                path
            ];
        }();
    },
    extractProps (node) {
        if ($786b46ea7ddafaee$export$db77ccec0bb4ccac.isAncestor(node)) {
            var properties = $786b46ea7ddafaee$var$_objectWithoutProperties(node, $786b46ea7ddafaee$var$_excluded$3);
            return properties;
        } else {
            var properties = $786b46ea7ddafaee$var$_objectWithoutProperties(node, $786b46ea7ddafaee$var$_excluded2$3);
            return properties;
        }
    },
    first (root, path) {
        var p = path.slice();
        var n = $786b46ea7ddafaee$export$85c928794f8d04d4.get(root, p);
        while(n){
            if ($786b46ea7ddafaee$export$5f1af8db9871e1d6.isText(n) || n.children.length === 0) break;
            else {
                n = n.children[0];
                p.push(0);
            }
        }
        return [
            n,
            p
        ];
    },
    fragment (root, range) {
        if ($786b46ea7ddafaee$export$5f1af8db9871e1d6.isText(root)) throw new Error("Cannot get a fragment starting from a root text node: ".concat($786b46ea7ddafaee$export$1e3096e79001f1db.stringify(root)));
        var newRoot = (0, $6JaFW.produce)({
            children: root.children
        }, (r)=>{
            var [start, end] = $786b46ea7ddafaee$export$9a58ef0d7ad3278c.edges(range);
            var nodeEntries = $786b46ea7ddafaee$export$85c928794f8d04d4.nodes(r, {
                reverse: true,
                pass: (_ref)=>{
                    var [, path] = _ref;
                    return !$786b46ea7ddafaee$export$9a58ef0d7ad3278c.includes(range, path);
                }
            });
            for (var [, path] of nodeEntries){
                if (!$786b46ea7ddafaee$export$9a58ef0d7ad3278c.includes(range, path)) {
                    var parent = $786b46ea7ddafaee$export$85c928794f8d04d4.parent(r, path);
                    var index = path[path.length - 1];
                    parent.children.splice(index, 1);
                }
                if ($786b46ea7ddafaee$export$4b2950bdac9b6ee9.equals(path, end.path)) {
                    var leaf = $786b46ea7ddafaee$export$85c928794f8d04d4.leaf(r, path);
                    leaf.text = leaf.text.slice(0, end.offset);
                }
                if ($786b46ea7ddafaee$export$4b2950bdac9b6ee9.equals(path, start.path)) {
                    var _leaf = $786b46ea7ddafaee$export$85c928794f8d04d4.leaf(r, path);
                    _leaf.text = _leaf.text.slice(start.offset);
                }
            }
            if ($786b46ea7ddafaee$export$7cda8d932e2f33c0.isEditor(r)) r.selection = null;
        });
        return newRoot.children;
    },
    get (root, path) {
        var node = $786b46ea7ddafaee$export$85c928794f8d04d4.getIf(root, path);
        if (node === undefined) throw new Error("Cannot find a descendant at path [".concat(path, "] in node: ").concat($786b46ea7ddafaee$export$1e3096e79001f1db.stringify(root)));
        return node;
    },
    getIf (root, path) {
        var node = root;
        for(var i = 0; i < path.length; i++){
            var p = path[i];
            if ($786b46ea7ddafaee$export$5f1af8db9871e1d6.isText(node) || !node.children[p]) return;
            node = node.children[p];
        }
        return node;
    },
    has (root, path) {
        var node = root;
        for(var i = 0; i < path.length; i++){
            var p = path[i];
            if ($786b46ea7ddafaee$export$5f1af8db9871e1d6.isText(node) || !node.children[p]) return false;
            node = node.children[p];
        }
        return true;
    },
    isNode (value) {
        return $786b46ea7ddafaee$export$5f1af8db9871e1d6.isText(value) || $786b46ea7ddafaee$export$db77ccec0bb4ccac.isElement(value) || $786b46ea7ddafaee$export$7cda8d932e2f33c0.isEditor(value);
    },
    isNodeList (value) {
        if (!Array.isArray(value)) return false;
        var cachedResult = $786b46ea7ddafaee$var$IS_NODE_LIST_CACHE.get(value);
        if (cachedResult !== undefined) return cachedResult;
        var isNodeList = value.every((val)=>$786b46ea7ddafaee$export$85c928794f8d04d4.isNode(val));
        $786b46ea7ddafaee$var$IS_NODE_LIST_CACHE.set(value, isNodeList);
        return isNodeList;
    },
    last (root, path) {
        var p = path.slice();
        var n = $786b46ea7ddafaee$export$85c928794f8d04d4.get(root, p);
        while(n){
            if ($786b46ea7ddafaee$export$5f1af8db9871e1d6.isText(n) || n.children.length === 0) break;
            else {
                var i = n.children.length - 1;
                n = n.children[i];
                p.push(i);
            }
        }
        return [
            n,
            p
        ];
    },
    leaf (root, path) {
        var node = $786b46ea7ddafaee$export$85c928794f8d04d4.get(root, path);
        if (!$786b46ea7ddafaee$export$5f1af8db9871e1d6.isText(node)) throw new Error("Cannot get the leaf node at path [".concat(path, "] because it refers to a non-leaf node: ").concat($786b46ea7ddafaee$export$1e3096e79001f1db.stringify(node)));
        return node;
    },
    levels (root, path) {
        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        return function*() {
            for (var p of $786b46ea7ddafaee$export$4b2950bdac9b6ee9.levels(path, options)){
                var n = $786b46ea7ddafaee$export$85c928794f8d04d4.get(root, p);
                yield [
                    n,
                    p
                ];
            }
        }();
    },
    matches (node, props) {
        return $786b46ea7ddafaee$export$db77ccec0bb4ccac.isElement(node) && $786b46ea7ddafaee$export$db77ccec0bb4ccac.isElementProps(props) && $786b46ea7ddafaee$export$db77ccec0bb4ccac.matches(node, props) || $786b46ea7ddafaee$export$5f1af8db9871e1d6.isText(node) && $786b46ea7ddafaee$export$5f1af8db9871e1d6.isTextProps(props) && $786b46ea7ddafaee$export$5f1af8db9871e1d6.matches(node, props);
    },
    nodes (root) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return function*() {
            var { pass: pass, reverse: reverse = false } = options;
            var { from: from = [], to: to } = options;
            var visited = new Set();
            var p = [];
            var n = root;
            while(true){
                if (to && (reverse ? $786b46ea7ddafaee$export$4b2950bdac9b6ee9.isBefore(p, to) : $786b46ea7ddafaee$export$4b2950bdac9b6ee9.isAfter(p, to))) break;
                if (!visited.has(n)) yield [
                    n,
                    p
                ];
                // If we're allowed to go downward and we haven't descended yet, do.
                if (!visited.has(n) && !$786b46ea7ddafaee$export$5f1af8db9871e1d6.isText(n) && n.children.length !== 0 && (pass == null || pass([
                    n,
                    p
                ]) === false)) {
                    visited.add(n);
                    var nextIndex = reverse ? n.children.length - 1 : 0;
                    if ($786b46ea7ddafaee$export$4b2950bdac9b6ee9.isAncestor(p, from)) nextIndex = from[p.length];
                    p = p.concat(nextIndex);
                    n = $786b46ea7ddafaee$export$85c928794f8d04d4.get(root, p);
                    continue;
                }
                // If we're at the root and we can't go down, we're done.
                if (p.length === 0) break;
                // If we're going forward...
                if (!reverse) {
                    var newPath = $786b46ea7ddafaee$export$4b2950bdac9b6ee9.next(p);
                    if ($786b46ea7ddafaee$export$85c928794f8d04d4.has(root, newPath)) {
                        p = newPath;
                        n = $786b46ea7ddafaee$export$85c928794f8d04d4.get(root, p);
                        continue;
                    }
                }
                // If we're going backward...
                if (reverse && p[p.length - 1] !== 0) {
                    var _newPath = $786b46ea7ddafaee$export$4b2950bdac9b6ee9.previous(p);
                    p = _newPath;
                    n = $786b46ea7ddafaee$export$85c928794f8d04d4.get(root, p);
                    continue;
                }
                // Otherwise we're going upward...
                p = $786b46ea7ddafaee$export$4b2950bdac9b6ee9.parent(p);
                n = $786b46ea7ddafaee$export$85c928794f8d04d4.get(root, p);
                visited.add(n);
            }
        }();
    },
    parent (root, path) {
        var parentPath = $786b46ea7ddafaee$export$4b2950bdac9b6ee9.parent(path);
        var p = $786b46ea7ddafaee$export$85c928794f8d04d4.get(root, parentPath);
        if ($786b46ea7ddafaee$export$5f1af8db9871e1d6.isText(p)) throw new Error("Cannot get the parent of path [".concat(path, "] because it does not exist in the root."));
        return p;
    },
    string (node) {
        if ($786b46ea7ddafaee$export$5f1af8db9871e1d6.isText(node)) return node.text;
        else return node.children.map($786b46ea7ddafaee$export$85c928794f8d04d4.string).join("");
    },
    texts (root) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return function*() {
            for (var [node, path] of $786b46ea7ddafaee$export$85c928794f8d04d4.nodes(root, options))if ($786b46ea7ddafaee$export$5f1af8db9871e1d6.isText(node)) yield [
                node,
                path
            ];
        }();
    }
};
function $786b46ea7ddafaee$var$ownKeys$c(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $786b46ea7ddafaee$var$_objectSpread$c(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $786b46ea7ddafaee$var$ownKeys$c(Object(t), !0).forEach(function(r) {
            $786b46ea7ddafaee$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $786b46ea7ddafaee$var$ownKeys$c(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
// eslint-disable-next-line no-redeclare
var $786b46ea7ddafaee$export$ab5aad00225c5662 = {
    isNodeOperation (value) {
        return $786b46ea7ddafaee$export$ab5aad00225c5662.isOperation(value) && value.type.endsWith("_node");
    },
    isOperation (value) {
        if (!(0, $lmEbS.isPlainObject)(value)) return false;
        switch(value.type){
            case "insert_node":
                return $786b46ea7ddafaee$export$4b2950bdac9b6ee9.isPath(value.path) && $786b46ea7ddafaee$export$85c928794f8d04d4.isNode(value.node);
            case "insert_text":
                return typeof value.offset === "number" && typeof value.text === "string" && $786b46ea7ddafaee$export$4b2950bdac9b6ee9.isPath(value.path);
            case "merge_node":
                return typeof value.position === "number" && $786b46ea7ddafaee$export$4b2950bdac9b6ee9.isPath(value.path) && (0, $lmEbS.isPlainObject)(value.properties);
            case "move_node":
                return $786b46ea7ddafaee$export$4b2950bdac9b6ee9.isPath(value.path) && $786b46ea7ddafaee$export$4b2950bdac9b6ee9.isPath(value.newPath);
            case "remove_node":
                return $786b46ea7ddafaee$export$4b2950bdac9b6ee9.isPath(value.path) && $786b46ea7ddafaee$export$85c928794f8d04d4.isNode(value.node);
            case "remove_text":
                return typeof value.offset === "number" && typeof value.text === "string" && $786b46ea7ddafaee$export$4b2950bdac9b6ee9.isPath(value.path);
            case "set_node":
                return $786b46ea7ddafaee$export$4b2950bdac9b6ee9.isPath(value.path) && (0, $lmEbS.isPlainObject)(value.properties) && (0, $lmEbS.isPlainObject)(value.newProperties);
            case "set_selection":
                return value.properties === null && $786b46ea7ddafaee$export$9a58ef0d7ad3278c.isRange(value.newProperties) || value.newProperties === null && $786b46ea7ddafaee$export$9a58ef0d7ad3278c.isRange(value.properties) || (0, $lmEbS.isPlainObject)(value.properties) && (0, $lmEbS.isPlainObject)(value.newProperties);
            case "split_node":
                return $786b46ea7ddafaee$export$4b2950bdac9b6ee9.isPath(value.path) && typeof value.position === "number" && (0, $lmEbS.isPlainObject)(value.properties);
            default:
                return false;
        }
    },
    isOperationList (value) {
        return Array.isArray(value) && value.every((val)=>$786b46ea7ddafaee$export$ab5aad00225c5662.isOperation(val));
    },
    isSelectionOperation (value) {
        return $786b46ea7ddafaee$export$ab5aad00225c5662.isOperation(value) && value.type.endsWith("_selection");
    },
    isTextOperation (value) {
        return $786b46ea7ddafaee$export$ab5aad00225c5662.isOperation(value) && value.type.endsWith("_text");
    },
    inverse (op) {
        switch(op.type){
            case "insert_node":
                return $786b46ea7ddafaee$var$_objectSpread$c($786b46ea7ddafaee$var$_objectSpread$c({}, op), {}, {
                    type: "remove_node"
                });
            case "insert_text":
                return $786b46ea7ddafaee$var$_objectSpread$c($786b46ea7ddafaee$var$_objectSpread$c({}, op), {}, {
                    type: "remove_text"
                });
            case "merge_node":
                return $786b46ea7ddafaee$var$_objectSpread$c($786b46ea7ddafaee$var$_objectSpread$c({}, op), {}, {
                    type: "split_node",
                    path: $786b46ea7ddafaee$export$4b2950bdac9b6ee9.previous(op.path)
                });
            case "move_node":
                var { newPath: newPath, path: path } = op;
                // PERF: in this case the move operation is a no-op anyways.
                if ($786b46ea7ddafaee$export$4b2950bdac9b6ee9.equals(newPath, path)) return op;
                // If the move happens completely within a single parent the path and
                // newPath are stable with respect to each other.
                if ($786b46ea7ddafaee$export$4b2950bdac9b6ee9.isSibling(path, newPath)) return $786b46ea7ddafaee$var$_objectSpread$c($786b46ea7ddafaee$var$_objectSpread$c({}, op), {}, {
                    path: newPath,
                    newPath: path
                });
                // If the move does not happen within a single parent it is possible
                // for the move to impact the true path to the location where the node
                // was removed from and where it was inserted. We have to adjust for this
                // and find the original path. We can accomplish this (only in non-sibling)
                // moves by looking at the impact of the move operation on the node
                // after the original move path.
                var inversePath = $786b46ea7ddafaee$export$4b2950bdac9b6ee9.transform(path, op);
                var inverseNewPath = $786b46ea7ddafaee$export$4b2950bdac9b6ee9.transform($786b46ea7ddafaee$export$4b2950bdac9b6ee9.next(path), op);
                return $786b46ea7ddafaee$var$_objectSpread$c($786b46ea7ddafaee$var$_objectSpread$c({}, op), {}, {
                    path: inversePath,
                    newPath: inverseNewPath
                });
            case "remove_node":
                return $786b46ea7ddafaee$var$_objectSpread$c($786b46ea7ddafaee$var$_objectSpread$c({}, op), {}, {
                    type: "insert_node"
                });
            case "remove_text":
                return $786b46ea7ddafaee$var$_objectSpread$c($786b46ea7ddafaee$var$_objectSpread$c({}, op), {}, {
                    type: "insert_text"
                });
            case "set_node":
                var { properties: properties, newProperties: newProperties } = op;
                return $786b46ea7ddafaee$var$_objectSpread$c($786b46ea7ddafaee$var$_objectSpread$c({}, op), {}, {
                    properties: newProperties,
                    newProperties: properties
                });
            case "set_selection":
                var { properties: _properties, newProperties: _newProperties } = op;
                if (_properties == null) return $786b46ea7ddafaee$var$_objectSpread$c($786b46ea7ddafaee$var$_objectSpread$c({}, op), {}, {
                    properties: _newProperties,
                    newProperties: null
                });
                else if (_newProperties == null) return $786b46ea7ddafaee$var$_objectSpread$c($786b46ea7ddafaee$var$_objectSpread$c({}, op), {}, {
                    properties: null,
                    newProperties: _properties
                });
                else return $786b46ea7ddafaee$var$_objectSpread$c($786b46ea7ddafaee$var$_objectSpread$c({}, op), {}, {
                    properties: _newProperties,
                    newProperties: _properties
                });
            case "split_node":
                return $786b46ea7ddafaee$var$_objectSpread$c($786b46ea7ddafaee$var$_objectSpread$c({}, op), {}, {
                    type: "merge_node",
                    path: $786b46ea7ddafaee$export$4b2950bdac9b6ee9.next(op.path)
                });
        }
    }
};
var $786b46ea7ddafaee$var$IS_EDITOR_CACHE = new WeakMap();
var $786b46ea7ddafaee$export$922bf39e68800b0 = (value)=>{
    var cachedIsEditor = $786b46ea7ddafaee$var$IS_EDITOR_CACHE.get(value);
    if (cachedIsEditor !== undefined) return cachedIsEditor;
    if (!(0, $lmEbS.isPlainObject)(value)) return false;
    var isEditor = typeof value.addMark === "function" && typeof value.apply === "function" && typeof value.deleteFragment === "function" && typeof value.insertBreak === "function" && typeof value.insertSoftBreak === "function" && typeof value.insertFragment === "function" && typeof value.insertNode === "function" && typeof value.insertText === "function" && typeof value.isElementReadOnly === "function" && typeof value.isInline === "function" && typeof value.isSelectable === "function" && typeof value.isVoid === "function" && typeof value.normalizeNode === "function" && typeof value.onChange === "function" && typeof value.removeMark === "function" && typeof value.getDirtyPaths === "function" && (value.marks === null || (0, $lmEbS.isPlainObject)(value.marks)) && (value.selection === null || $786b46ea7ddafaee$export$9a58ef0d7ad3278c.isRange(value.selection)) && $786b46ea7ddafaee$export$85c928794f8d04d4.isNodeList(value.children) && $786b46ea7ddafaee$export$ab5aad00225c5662.isOperationList(value.operations);
    $786b46ea7ddafaee$var$IS_EDITOR_CACHE.set(value, isEditor);
    return isEditor;
};
// eslint-disable-next-line no-redeclare
var $786b46ea7ddafaee$export$7cda8d932e2f33c0 = {
    above (editor, options) {
        return editor.above(options);
    },
    addMark (editor, key, value) {
        editor.addMark(key, value);
    },
    after (editor, at, options) {
        return editor.after(at, options);
    },
    before (editor, at, options) {
        return editor.before(at, options);
    },
    deleteBackward (editor) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var { unit: unit = "character" } = options;
        editor.deleteBackward(unit);
    },
    deleteForward (editor) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var { unit: unit = "character" } = options;
        editor.deleteForward(unit);
    },
    deleteFragment (editor, options) {
        editor.deleteFragment(options);
    },
    edges (editor, at) {
        return editor.edges(at);
    },
    elementReadOnly (editor) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return editor.elementReadOnly(options);
    },
    end (editor, at) {
        return editor.end(at);
    },
    first (editor, at) {
        return editor.first(at);
    },
    fragment (editor, at) {
        return editor.fragment(at);
    },
    hasBlocks (editor, element) {
        return editor.hasBlocks(element);
    },
    hasInlines (editor, element) {
        return editor.hasInlines(element);
    },
    hasPath (editor, path) {
        return editor.hasPath(path);
    },
    hasTexts (editor, element) {
        return editor.hasTexts(element);
    },
    insertBreak (editor) {
        editor.insertBreak();
    },
    insertFragment (editor, fragment, options) {
        editor.insertFragment(fragment, options);
    },
    insertNode (editor, node) {
        editor.insertNode(node);
    },
    insertSoftBreak (editor) {
        editor.insertSoftBreak();
    },
    insertText (editor, text) {
        editor.insertText(text);
    },
    isBlock (editor, value) {
        return editor.isBlock(value);
    },
    isEdge (editor, point, at) {
        return editor.isEdge(point, at);
    },
    isEditor (value) {
        return $786b46ea7ddafaee$export$922bf39e68800b0(value);
    },
    isElementReadOnly (editor, element) {
        return editor.isElementReadOnly(element);
    },
    isEmpty (editor, element) {
        return editor.isEmpty(element);
    },
    isEnd (editor, point, at) {
        return editor.isEnd(point, at);
    },
    isInline (editor, value) {
        return editor.isInline(value);
    },
    isNormalizing (editor) {
        return editor.isNormalizing();
    },
    isSelectable (editor, value) {
        return editor.isSelectable(value);
    },
    isStart (editor, point, at) {
        return editor.isStart(point, at);
    },
    isVoid (editor, value) {
        return editor.isVoid(value);
    },
    last (editor, at) {
        return editor.last(at);
    },
    leaf (editor, at, options) {
        return editor.leaf(at, options);
    },
    levels (editor, options) {
        return editor.levels(options);
    },
    marks (editor) {
        return editor.getMarks();
    },
    next (editor, options) {
        return editor.next(options);
    },
    node (editor, at, options) {
        return editor.node(at, options);
    },
    nodes (editor, options) {
        return editor.nodes(options);
    },
    normalize (editor, options) {
        editor.normalize(options);
    },
    parent (editor, at, options) {
        return editor.parent(at, options);
    },
    path (editor, at, options) {
        return editor.path(at, options);
    },
    pathRef (editor, path, options) {
        return editor.pathRef(path, options);
    },
    pathRefs (editor) {
        return editor.pathRefs();
    },
    point (editor, at, options) {
        return editor.point(at, options);
    },
    pointRef (editor, point, options) {
        return editor.pointRef(point, options);
    },
    pointRefs (editor) {
        return editor.pointRefs();
    },
    positions (editor, options) {
        return editor.positions(options);
    },
    previous (editor, options) {
        return editor.previous(options);
    },
    range (editor, at, to) {
        return editor.range(at, to);
    },
    rangeRef (editor, range, options) {
        return editor.rangeRef(range, options);
    },
    rangeRefs (editor) {
        return editor.rangeRefs();
    },
    removeMark (editor, key) {
        editor.removeMark(key);
    },
    setNormalizing (editor, isNormalizing) {
        editor.setNormalizing(isNormalizing);
    },
    start (editor, at) {
        return editor.start(at);
    },
    string (editor, at, options) {
        return editor.string(at, options);
    },
    unhangRange (editor, range, options) {
        return editor.unhangRange(range, options);
    },
    void (editor, options) {
        return editor.void(options);
    },
    withoutNormalizing (editor, fn) {
        editor.withoutNormalizing(fn);
    },
    shouldMergeNodesRemovePrevNode: (editor, prevNode, curNode)=>{
        return editor.shouldMergeNodesRemovePrevNode(prevNode, curNode);
    }
};
// eslint-disable-next-line no-redeclare
var $786b46ea7ddafaee$export$18a2be9195644f38 = {
    isLocation (value) {
        return $786b46ea7ddafaee$export$4b2950bdac9b6ee9.isPath(value) || $786b46ea7ddafaee$export$baf26146a414f24a.isPoint(value) || $786b46ea7ddafaee$export$9a58ef0d7ad3278c.isRange(value);
    }
};
// eslint-disable-next-line no-redeclare
var $786b46ea7ddafaee$export$5f1714a13ed34c01 = {
    isSpan (value) {
        return Array.isArray(value) && value.length === 2 && value.every($786b46ea7ddafaee$export$4b2950bdac9b6ee9.isPath);
    }
};
function $786b46ea7ddafaee$var$ownKeys$b(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $786b46ea7ddafaee$var$_objectSpread$b(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $786b46ea7ddafaee$var$ownKeys$b(Object(t), !0).forEach(function(r) {
            $786b46ea7ddafaee$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $786b46ea7ddafaee$var$ownKeys$b(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
// eslint-disable-next-line no-redeclare
var $786b46ea7ddafaee$export$baf26146a414f24a = {
    compare (point, another) {
        var result = $786b46ea7ddafaee$export$4b2950bdac9b6ee9.compare(point.path, another.path);
        if (result === 0) {
            if (point.offset < another.offset) return -1;
            if (point.offset > another.offset) return 1;
            return 0;
        }
        return result;
    },
    isAfter (point, another) {
        return $786b46ea7ddafaee$export$baf26146a414f24a.compare(point, another) === 1;
    },
    isBefore (point, another) {
        return $786b46ea7ddafaee$export$baf26146a414f24a.compare(point, another) === -1;
    },
    equals (point, another) {
        // PERF: ensure the offsets are equal first since they are cheaper to check.
        return point.offset === another.offset && $786b46ea7ddafaee$export$4b2950bdac9b6ee9.equals(point.path, another.path);
    },
    isPoint (value) {
        return (0, $lmEbS.isPlainObject)(value) && typeof value.offset === "number" && $786b46ea7ddafaee$export$4b2950bdac9b6ee9.isPath(value.path);
    },
    transform (point, op) {
        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        return (0, $6JaFW.produce)(point, (p)=>{
            if (p === null) return null;
            var { affinity: affinity = "forward" } = options;
            var { path: path, offset: offset } = p;
            switch(op.type){
                case "insert_node":
                case "move_node":
                    p.path = $786b46ea7ddafaee$export$4b2950bdac9b6ee9.transform(path, op, options);
                    break;
                case "insert_text":
                    if ($786b46ea7ddafaee$export$4b2950bdac9b6ee9.equals(op.path, path) && (op.offset < offset || op.offset === offset && affinity === "forward")) p.offset += op.text.length;
                    break;
                case "merge_node":
                    if ($786b46ea7ddafaee$export$4b2950bdac9b6ee9.equals(op.path, path)) p.offset += op.position;
                    p.path = $786b46ea7ddafaee$export$4b2950bdac9b6ee9.transform(path, op, options);
                    break;
                case "remove_text":
                    if ($786b46ea7ddafaee$export$4b2950bdac9b6ee9.equals(op.path, path) && op.offset <= offset) p.offset -= Math.min(offset - op.offset, op.text.length);
                    break;
                case "remove_node":
                    if ($786b46ea7ddafaee$export$4b2950bdac9b6ee9.equals(op.path, path) || $786b46ea7ddafaee$export$4b2950bdac9b6ee9.isAncestor(op.path, path)) return null;
                    p.path = $786b46ea7ddafaee$export$4b2950bdac9b6ee9.transform(path, op, options);
                    break;
                case "split_node":
                    if ($786b46ea7ddafaee$export$4b2950bdac9b6ee9.equals(op.path, path)) {
                        if (op.position === offset && affinity == null) return null;
                        else if (op.position < offset || op.position === offset && affinity === "forward") {
                            p.offset -= op.position;
                            p.path = $786b46ea7ddafaee$export$4b2950bdac9b6ee9.transform(path, op, $786b46ea7ddafaee$var$_objectSpread$b($786b46ea7ddafaee$var$_objectSpread$b({}, options), {}, {
                                affinity: "forward"
                            }));
                        }
                    } else p.path = $786b46ea7ddafaee$export$4b2950bdac9b6ee9.transform(path, op, options);
                    break;
            }
        });
    }
};
var $786b46ea7ddafaee$var$_scrubber = undefined;
/**
 * This interface implements a stringify() function, which is used by Slate
 * internally when generating exceptions containing end user data. Developers
 * using Slate may call Scrubber.setScrubber() to alter the behavior of this
 * stringify() function.
 *
 * For example, to prevent the cleartext logging of 'text' fields within Nodes:
 *
 *    import { Scrubber } from 'slate';
 *    Scrubber.setScrubber((key, val) => {
 *      if (key === 'text') return '...scrubbed...'
 *      return val
 *    });
 *
 */ // eslint-disable-next-line no-redeclare
var $786b46ea7ddafaee$export$1e3096e79001f1db = {
    setScrubber (scrubber) {
        $786b46ea7ddafaee$var$_scrubber = scrubber;
    },
    stringify (value) {
        return JSON.stringify(value, $786b46ea7ddafaee$var$_scrubber);
    }
};
var $786b46ea7ddafaee$var$_excluded$2 = [
    "text"
], $786b46ea7ddafaee$var$_excluded2$2 = [
    "anchor",
    "focus",
    "merge"
];
function $786b46ea7ddafaee$var$ownKeys$a(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $786b46ea7ddafaee$var$_objectSpread$a(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $786b46ea7ddafaee$var$ownKeys$a(Object(t), !0).forEach(function(r) {
            $786b46ea7ddafaee$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $786b46ea7ddafaee$var$ownKeys$a(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
// eslint-disable-next-line no-redeclare
var $786b46ea7ddafaee$export$5f1af8db9871e1d6 = {
    equals (text, another) {
        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var { loose: loose = false } = options;
        function omitText(obj) {
            var rest = $786b46ea7ddafaee$var$_objectWithoutProperties(obj, $786b46ea7ddafaee$var$_excluded$2);
            return rest;
        }
        return $786b46ea7ddafaee$var$isDeepEqual(loose ? omitText(text) : text, loose ? omitText(another) : another);
    },
    isText (value) {
        return (0, $lmEbS.isPlainObject)(value) && typeof value.text === "string";
    },
    isTextList (value) {
        return Array.isArray(value) && value.every((val)=>$786b46ea7ddafaee$export$5f1af8db9871e1d6.isText(val));
    },
    isTextProps (props) {
        return props.text !== undefined;
    },
    matches (text, props) {
        for(var key in props){
            if (key === "text") continue;
            if (!text.hasOwnProperty(key) || text[key] !== props[key]) return false;
        }
        return true;
    },
    decorations (node, decorations) {
        var leaves = [
            $786b46ea7ddafaee$var$_objectSpread$a({}, node)
        ];
        for (var dec of decorations){
            var { anchor: anchor, focus: focus, merge: mergeDecoration } = dec, rest = $786b46ea7ddafaee$var$_objectWithoutProperties(dec, $786b46ea7ddafaee$var$_excluded2$2);
            var [start, end] = $786b46ea7ddafaee$export$9a58ef0d7ad3278c.edges(dec);
            var next = [];
            var leafEnd = 0;
            var decorationStart = start.offset;
            var decorationEnd = end.offset;
            var merge = mergeDecoration !== null && mergeDecoration !== void 0 ? mergeDecoration : Object.assign;
            for (var leaf of leaves){
                var { length: length } = leaf.text;
                var leafStart = leafEnd;
                leafEnd += length;
                // If the range encompasses the entire leaf, add the range.
                if (decorationStart <= leafStart && leafEnd <= decorationEnd) {
                    merge(leaf, rest);
                    next.push(leaf);
                    continue;
                }
                // If the range expanded and match the leaf, or starts after, or ends before it, continue.
                if (decorationStart !== decorationEnd && (decorationStart === leafEnd || decorationEnd === leafStart) || decorationStart > leafEnd || decorationEnd < leafStart || decorationEnd === leafStart && leafStart !== 0) {
                    next.push(leaf);
                    continue;
                }
                // Otherwise we need to split the leaf, at the start, end, or both,
                // and add the range to the middle intersecting section. Do the end
                // split first since we don't need to update the offset that way.
                var middle = leaf;
                var before = void 0;
                var after = void 0;
                if (decorationEnd < leafEnd) {
                    var off = decorationEnd - leafStart;
                    after = $786b46ea7ddafaee$var$_objectSpread$a($786b46ea7ddafaee$var$_objectSpread$a({}, middle), {}, {
                        text: middle.text.slice(off)
                    });
                    middle = $786b46ea7ddafaee$var$_objectSpread$a($786b46ea7ddafaee$var$_objectSpread$a({}, middle), {}, {
                        text: middle.text.slice(0, off)
                    });
                }
                if (decorationStart > leafStart) {
                    var _off = decorationStart - leafStart;
                    before = $786b46ea7ddafaee$var$_objectSpread$a($786b46ea7ddafaee$var$_objectSpread$a({}, middle), {}, {
                        text: middle.text.slice(0, _off)
                    });
                    middle = $786b46ea7ddafaee$var$_objectSpread$a($786b46ea7ddafaee$var$_objectSpread$a({}, middle), {}, {
                        text: middle.text.slice(_off)
                    });
                }
                merge(middle, rest);
                if (before) next.push(before);
                next.push(middle);
                if (after) next.push(after);
            }
            leaves = next;
        }
        return leaves;
    }
};
/**
 * Get the default location to insert content into the editor.
 * By default, use the selection as the target location. But if there is
 * no selection, insert at the end of the document since that is such a
 * common use case when inserting from a non-selected state.
 */ var $786b46ea7ddafaee$var$getDefaultInsertLocation = (editor)=>{
    if (editor.selection) return editor.selection;
    else if (editor.children.length > 0) return $786b46ea7ddafaee$export$7cda8d932e2f33c0.end(editor, []);
    else return [
        0
    ];
};
var $786b46ea7ddafaee$var$matchPath = (editor, path)=>{
    var [node] = $786b46ea7ddafaee$export$7cda8d932e2f33c0.node(editor, path);
    return (n)=>n === node;
};
// Character (grapheme cluster) boundaries are determined according to
// the default grapheme cluster boundary specification, extended grapheme clusters variant[1].
//
// References:
//
// [1] https://www.unicode.org/reports/tr29/#Default_Grapheme_Cluster_Table
// [2] https://www.unicode.org/Public/UCD/latest/ucd/auxiliary/GraphemeBreakProperty.txt
// [3] https://www.unicode.org/Public/UCD/latest/ucd/auxiliary/GraphemeBreakTest.html
// [4] https://www.unicode.org/Public/UCD/latest/ucd/auxiliary/GraphemeBreakTest.txt
/**
 * Get the distance to the end of the first character in a string of text.
 */ var $786b46ea7ddafaee$var$getCharacterDistance = function getCharacterDistance(str) {
    var isRTL = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var isLTR = !isRTL;
    var codepoints = isRTL ? $786b46ea7ddafaee$var$codepointsIteratorRTL(str) : str;
    var left = $786b46ea7ddafaee$var$CodepointType.None;
    var right = $786b46ea7ddafaee$var$CodepointType.None;
    var distance = 0;
    // Evaluation of these conditions are deferred.
    var gb11 = null; // Is GB11 applicable?
    var gb12Or13 = null; // Is GB12 or GB13 applicable?
    for (var char of codepoints){
        var code = char.codePointAt(0);
        if (!code) break;
        var type = $786b46ea7ddafaee$var$getCodepointType(char, code);
        [left, right] = isLTR ? [
            right,
            type
        ] : [
            type,
            left
        ];
        if ($786b46ea7ddafaee$var$intersects(left, $786b46ea7ddafaee$var$CodepointType.ZWJ) && $786b46ea7ddafaee$var$intersects(right, $786b46ea7ddafaee$var$CodepointType.ExtPict)) {
            if (isLTR) gb11 = $786b46ea7ddafaee$var$endsWithEmojiZWJ(str.substring(0, distance));
            else gb11 = $786b46ea7ddafaee$var$endsWithEmojiZWJ(str.substring(0, str.length - distance));
            if (!gb11) break;
        }
        if ($786b46ea7ddafaee$var$intersects(left, $786b46ea7ddafaee$var$CodepointType.RI) && $786b46ea7ddafaee$var$intersects(right, $786b46ea7ddafaee$var$CodepointType.RI)) {
            if (gb12Or13 !== null) gb12Or13 = !gb12Or13;
            else if (isLTR) gb12Or13 = true;
            else gb12Or13 = $786b46ea7ddafaee$var$endsWithOddNumberOfRIs(str.substring(0, str.length - distance));
            if (!gb12Or13) break;
        }
        if (left !== $786b46ea7ddafaee$var$CodepointType.None && right !== $786b46ea7ddafaee$var$CodepointType.None && $786b46ea7ddafaee$var$isBoundaryPair(left, right)) break;
        distance += char.length;
    }
    return distance || 1;
};
var $786b46ea7ddafaee$var$SPACE = /\s/;
var $786b46ea7ddafaee$var$PUNCTUATION = /[\u002B\u0021-\u0023\u0025-\u002A\u002C-\u002F\u003A\u003B\u003F\u0040\u005B-\u005D\u005F\u007B\u007D\u00A1\u00A7\u00AB\u00B6\u00B7\u00BB\u00BF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061E\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u0AF0\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166D\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E3B\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]/;
var $786b46ea7ddafaee$var$CHAMELEON = /['\u2018\u2019]/;
/**
 * Get the distance to the end of the first word in a string of text.
 */ var $786b46ea7ddafaee$var$getWordDistance = function getWordDistance(text) {
    var isRTL = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var dist = 0;
    var started = false;
    while(text.length > 0){
        var charDist = $786b46ea7ddafaee$var$getCharacterDistance(text, isRTL);
        var [char, remaining] = $786b46ea7ddafaee$var$splitByCharacterDistance(text, charDist, isRTL);
        if ($786b46ea7ddafaee$var$isWordCharacter(char, remaining, isRTL)) {
            started = true;
            dist += charDist;
        } else if (!started) dist += charDist;
        else break;
        text = remaining;
    }
    return dist;
};
/**
 * Split a string in two parts at a given distance starting from the end when
 * `isRTL` is set to `true`.
 */ var $786b46ea7ddafaee$var$splitByCharacterDistance = (str, dist, isRTL)=>{
    if (isRTL) {
        var at = str.length - dist;
        return [
            str.slice(at, str.length),
            str.slice(0, at)
        ];
    }
    return [
        str.slice(0, dist),
        str.slice(dist)
    ];
};
/**
 * Check if a character is a word character. The `remaining` argument is used
 * because sometimes you must read subsequent characters to truly determine it.
 */ var $786b46ea7ddafaee$var$isWordCharacter = function isWordCharacter(char, remaining) {
    var isRTL = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    if ($786b46ea7ddafaee$var$SPACE.test(char)) return false;
    // Chameleons count as word characters as long as they're in a word, so
    // recurse to see if the next one is a word character or not.
    if ($786b46ea7ddafaee$var$CHAMELEON.test(char)) {
        var charDist = $786b46ea7ddafaee$var$getCharacterDistance(remaining, isRTL);
        var [nextChar, nextRemaining] = $786b46ea7ddafaee$var$splitByCharacterDistance(remaining, charDist, isRTL);
        if (isWordCharacter(nextChar, nextRemaining, isRTL)) return true;
    }
    if ($786b46ea7ddafaee$var$PUNCTUATION.test(char)) return false;
    return true;
};
/**
 * Iterate on codepoints from right to left.
 */ var $786b46ea7ddafaee$var$codepointsIteratorRTL = function* codepointsIteratorRTL(str) {
    var end = str.length - 1;
    for(var i = 0; i < str.length; i++){
        var char1 = str.charAt(end - i);
        if ($786b46ea7ddafaee$var$isLowSurrogate(char1.charCodeAt(0))) {
            var char2 = str.charAt(end - i - 1);
            if ($786b46ea7ddafaee$var$isHighSurrogate(char2.charCodeAt(0))) {
                yield char2 + char1;
                i++;
                continue;
            }
        }
        yield char1;
    }
};
/**
 * Is `charCode` a high surrogate.
 *
 * https://en.wikipedia.org/wiki/Universal_Character_Set_characters#Surrogates
 */ var $786b46ea7ddafaee$var$isHighSurrogate = (charCode)=>{
    return charCode >= 0xd800 && charCode <= 0xdbff;
};
/**
 * Is `charCode` a low surrogate.
 *
 * https://en.wikipedia.org/wiki/Universal_Character_Set_characters#Surrogates
 */ var $786b46ea7ddafaee$var$isLowSurrogate = (charCode)=>{
    return charCode >= 0xdc00 && charCode <= 0xdfff;
};
var $786b46ea7ddafaee$var$CodepointType;
(function(CodepointType) {
    CodepointType[CodepointType["None"] = 0] = "None";
    CodepointType[CodepointType["Extend"] = 1] = "Extend";
    CodepointType[CodepointType["ZWJ"] = 2] = "ZWJ";
    CodepointType[CodepointType["RI"] = 4] = "RI";
    CodepointType[CodepointType["Prepend"] = 8] = "Prepend";
    CodepointType[CodepointType["SpacingMark"] = 16] = "SpacingMark";
    CodepointType[CodepointType["L"] = 32] = "L";
    CodepointType[CodepointType["V"] = 64] = "V";
    CodepointType[CodepointType["T"] = 128] = "T";
    CodepointType[CodepointType["LV"] = 256] = "LV";
    CodepointType[CodepointType["LVT"] = 512] = "LVT";
    CodepointType[CodepointType["ExtPict"] = 1024] = "ExtPict";
    CodepointType[CodepointType["Any"] = 2048] = "Any";
})($786b46ea7ddafaee$var$CodepointType || ($786b46ea7ddafaee$var$CodepointType = {}));
var $786b46ea7ddafaee$var$reExtend = /^(?:[\u0300-\u036F\u0483-\u0489\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u0610-\u061A\u064B-\u065F\u0670\u06D6-\u06DC\u06DF-\u06E4\u06E7\u06E8\u06EA-\u06ED\u0711\u0730-\u074A\u07A6-\u07B0\u07EB-\u07F3\u07FD\u0816-\u0819\u081B-\u0823\u0825-\u0827\u0829-\u082D\u0859-\u085B\u0898-\u089F\u08CA-\u08E1\u08E3-\u0902\u093A\u093C\u0941-\u0948\u094D\u0951-\u0957\u0962\u0963\u0981\u09BC\u09BE\u09C1-\u09C4\u09CD\u09D7\u09E2\u09E3\u09FE\u0A01\u0A02\u0A3C\u0A41\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A70\u0A71\u0A75\u0A81\u0A82\u0ABC\u0AC1-\u0AC5\u0AC7\u0AC8\u0ACD\u0AE2\u0AE3\u0AFA-\u0AFF\u0B01\u0B3C\u0B3E\u0B3F\u0B41-\u0B44\u0B4D\u0B55-\u0B57\u0B62\u0B63\u0B82\u0BBE\u0BC0\u0BCD\u0BD7\u0C00\u0C04\u0C3C\u0C3E-\u0C40\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C62\u0C63\u0C81\u0CBC\u0CBF\u0CC2\u0CC6\u0CCC\u0CCD\u0CD5\u0CD6\u0CE2\u0CE3\u0D00\u0D01\u0D3B\u0D3C\u0D3E\u0D41-\u0D44\u0D4D\u0D57\u0D62\u0D63\u0D81\u0DCA\u0DCF\u0DD2-\u0DD4\u0DD6\u0DDF\u0E31\u0E34-\u0E3A\u0E47-\u0E4E\u0EB1\u0EB4-\u0EBC\u0EC8-\u0ECE\u0F18\u0F19\u0F35\u0F37\u0F39\u0F71-\u0F7E\u0F80-\u0F84\u0F86\u0F87\u0F8D-\u0F97\u0F99-\u0FBC\u0FC6\u102D-\u1030\u1032-\u1037\u1039\u103A\u103D\u103E\u1058\u1059\u105E-\u1060\u1071-\u1074\u1082\u1085\u1086\u108D\u109D\u135D-\u135F\u1712-\u1714\u1732\u1733\u1752\u1753\u1772\u1773\u17B4\u17B5\u17B7-\u17BD\u17C6\u17C9-\u17D3\u17DD\u180B-\u180D\u180F\u1885\u1886\u18A9\u1920-\u1922\u1927\u1928\u1932\u1939-\u193B\u1A17\u1A18\u1A1B\u1A56\u1A58-\u1A5E\u1A60\u1A62\u1A65-\u1A6C\u1A73-\u1A7C\u1A7F\u1AB0-\u1ACE\u1B00-\u1B03\u1B34-\u1B3A\u1B3C\u1B42\u1B6B-\u1B73\u1B80\u1B81\u1BA2-\u1BA5\u1BA8\u1BA9\u1BAB-\u1BAD\u1BE6\u1BE8\u1BE9\u1BED\u1BEF-\u1BF1\u1C2C-\u1C33\u1C36\u1C37\u1CD0-\u1CD2\u1CD4-\u1CE0\u1CE2-\u1CE8\u1CED\u1CF4\u1CF8\u1CF9\u1DC0-\u1DFF\u200C\u20D0-\u20F0\u2CEF-\u2CF1\u2D7F\u2DE0-\u2DFF\u302A-\u302F\u3099\u309A\uA66F-\uA672\uA674-\uA67D\uA69E\uA69F\uA6F0\uA6F1\uA802\uA806\uA80B\uA825\uA826\uA82C\uA8C4\uA8C5\uA8E0-\uA8F1\uA8FF\uA926-\uA92D\uA947-\uA951\uA980-\uA982\uA9B3\uA9B6-\uA9B9\uA9BC\uA9BD\uA9E5\uAA29-\uAA2E\uAA31\uAA32\uAA35\uAA36\uAA43\uAA4C\uAA7C\uAAB0\uAAB2-\uAAB4\uAAB7\uAAB8\uAABE\uAABF\uAAC1\uAAEC\uAAED\uAAF6\uABE5\uABE8\uABED\uFB1E\uFE00-\uFE0F\uFE20-\uFE2F\uFF9E\uFF9F]|\uD800[\uDDFD\uDEE0\uDF76-\uDF7A]|\uD802[\uDE01-\uDE03\uDE05\uDE06\uDE0C-\uDE0F\uDE38-\uDE3A\uDE3F\uDEE5\uDEE6]|\uD803[\uDD24-\uDD27\uDEAB\uDEAC\uDEFD-\uDEFF\uDF46-\uDF50\uDF82-\uDF85]|\uD804[\uDC01\uDC38-\uDC46\uDC70\uDC73\uDC74\uDC7F-\uDC81\uDCB3-\uDCB6\uDCB9\uDCBA\uDCC2\uDD00-\uDD02\uDD27-\uDD2B\uDD2D-\uDD34\uDD73\uDD80\uDD81\uDDB6-\uDDBE\uDDC9-\uDDCC\uDDCF\uDE2F-\uDE31\uDE34\uDE36\uDE37\uDE3E\uDE41\uDEDF\uDEE3-\uDEEA\uDF00\uDF01\uDF3B\uDF3C\uDF3E\uDF40\uDF57\uDF66-\uDF6C\uDF70-\uDF74]|\uD805[\uDC38-\uDC3F\uDC42-\uDC44\uDC46\uDC5E\uDCB0\uDCB3-\uDCB8\uDCBA\uDCBD\uDCBF\uDCC0\uDCC2\uDCC3\uDDAF\uDDB2-\uDDB5\uDDBC\uDDBD\uDDBF\uDDC0\uDDDC\uDDDD\uDE33-\uDE3A\uDE3D\uDE3F\uDE40\uDEAB\uDEAD\uDEB0-\uDEB5\uDEB7\uDF1D-\uDF1F\uDF22-\uDF25\uDF27-\uDF2B]|\uD806[\uDC2F-\uDC37\uDC39\uDC3A\uDD30\uDD3B\uDD3C\uDD3E\uDD43\uDDD4-\uDDD7\uDDDA\uDDDB\uDDE0\uDE01-\uDE0A\uDE33-\uDE38\uDE3B-\uDE3E\uDE47\uDE51-\uDE56\uDE59-\uDE5B\uDE8A-\uDE96\uDE98\uDE99]|\uD807[\uDC30-\uDC36\uDC38-\uDC3D\uDC3F\uDC92-\uDCA7\uDCAA-\uDCB0\uDCB2\uDCB3\uDCB5\uDCB6\uDD31-\uDD36\uDD3A\uDD3C\uDD3D\uDD3F-\uDD45\uDD47\uDD90\uDD91\uDD95\uDD97\uDEF3\uDEF4\uDF00\uDF01\uDF36-\uDF3A\uDF40\uDF42]|\uD80D[\uDC40\uDC47-\uDC55]|\uD81A[\uDEF0-\uDEF4\uDF30-\uDF36]|\uD81B[\uDF4F\uDF8F-\uDF92\uDFE4]|\uD82F[\uDC9D\uDC9E]|\uD833[\uDF00-\uDF2D\uDF30-\uDF46]|\uD834[\uDD65\uDD67-\uDD69\uDD6E-\uDD72\uDD7B-\uDD82\uDD85-\uDD8B\uDDAA-\uDDAD\uDE42-\uDE44]|\uD836[\uDE00-\uDE36\uDE3B-\uDE6C\uDE75\uDE84\uDE9B-\uDE9F\uDEA1-\uDEAF]|\uD838[\uDC00-\uDC06\uDC08-\uDC18\uDC1B-\uDC21\uDC23\uDC24\uDC26-\uDC2A\uDC8F\uDD30-\uDD36\uDEAE\uDEEC-\uDEEF]|\uD839[\uDCEC-\uDCEF]|\uD83A[\uDCD0-\uDCD6\uDD44-\uDD4A]|\uD83C[\uDFFB-\uDFFF]|\uDB40[\uDC20-\uDC7F\uDD00-\uDDEF])$/;
var $786b46ea7ddafaee$var$rePrepend = /^(?:[\u0600-\u0605\u06DD\u070F\u0890\u0891\u08E2\u0D4E]|\uD804[\uDCBD\uDCCD\uDDC2\uDDC3]|\uD806[\uDD3F\uDD41\uDE3A\uDE84-\uDE89]|\uD807\uDD46)$/;
var $786b46ea7ddafaee$var$reSpacingMark = /^(?:[\u0903\u093B\u093E-\u0940\u0949-\u094C\u094E\u094F\u0982\u0983\u09BF\u09C0\u09C7\u09C8\u09CB\u09CC\u0A03\u0A3E-\u0A40\u0A83\u0ABE-\u0AC0\u0AC9\u0ACB\u0ACC\u0B02\u0B03\u0B40\u0B47\u0B48\u0B4B\u0B4C\u0BBF\u0BC1\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCC\u0C01-\u0C03\u0C41-\u0C44\u0C82\u0C83\u0CBE\u0CC0\u0CC1\u0CC3\u0CC4\u0CC7\u0CC8\u0CCA\u0CCB\u0D02\u0D03\u0D3F\u0D40\u0D46-\u0D48\u0D4A-\u0D4C\u0D82\u0D83\u0DD0\u0DD1\u0DD8-\u0DDE\u0DF2\u0DF3\u0E33\u0EB3\u0F3E\u0F3F\u0F7F\u1031\u103B\u103C\u1056\u1057\u1084\u1715\u1734\u17B6\u17BE-\u17C5\u17C7\u17C8\u1923-\u1926\u1929-\u192B\u1930\u1931\u1933-\u1938\u1A19\u1A1A\u1A55\u1A57\u1A6D-\u1A72\u1B04\u1B3B\u1B3D-\u1B41\u1B43\u1B44\u1B82\u1BA1\u1BA6\u1BA7\u1BAA\u1BE7\u1BEA-\u1BEC\u1BEE\u1BF2\u1BF3\u1C24-\u1C2B\u1C34\u1C35\u1CE1\u1CF7\uA823\uA824\uA827\uA880\uA881\uA8B4-\uA8C3\uA952\uA953\uA983\uA9B4\uA9B5\uA9BA\uA9BB\uA9BE-\uA9C0\uAA2F\uAA30\uAA33\uAA34\uAA4D\uAAEB\uAAEE\uAAEF\uAAF5\uABE3\uABE4\uABE6\uABE7\uABE9\uABEA\uABEC]|\uD804[\uDC00\uDC02\uDC82\uDCB0-\uDCB2\uDCB7\uDCB8\uDD2C\uDD45\uDD46\uDD82\uDDB3-\uDDB5\uDDBF\uDDC0\uDDCE\uDE2C-\uDE2E\uDE32\uDE33\uDE35\uDEE0-\uDEE2\uDF02\uDF03\uDF3F\uDF41-\uDF44\uDF47\uDF48\uDF4B-\uDF4D\uDF62\uDF63]|\uD805[\uDC35-\uDC37\uDC40\uDC41\uDC45\uDCB1\uDCB2\uDCB9\uDCBB\uDCBC\uDCBE\uDCC1\uDDB0\uDDB1\uDDB8-\uDDBB\uDDBE\uDE30-\uDE32\uDE3B\uDE3C\uDE3E\uDEAC\uDEAE\uDEAF\uDEB6\uDF26]|\uD806[\uDC2C-\uDC2E\uDC38\uDD31-\uDD35\uDD37\uDD38\uDD3D\uDD40\uDD42\uDDD1-\uDDD3\uDDDC-\uDDDF\uDDE4\uDE39\uDE57\uDE58\uDE97]|\uD807[\uDC2F\uDC3E\uDCA9\uDCB1\uDCB4\uDD8A-\uDD8E\uDD93\uDD94\uDD96\uDEF5\uDEF6]|\uD81B[\uDF51-\uDF87\uDFF0\uDFF1]|\uD834[\uDD66\uDD6D])$/;
var $786b46ea7ddafaee$var$reL = /^[\u1100-\u115F\uA960-\uA97C]$/;
var $786b46ea7ddafaee$var$reV = /^[\u1160-\u11A7\uD7B0-\uD7C6]$/;
var $786b46ea7ddafaee$var$reT = /^[\u11A8-\u11FF\uD7CB-\uD7FB]$/;
var $786b46ea7ddafaee$var$reLV = /^[\uAC00\uAC1C\uAC38\uAC54\uAC70\uAC8C\uACA8\uACC4\uACE0\uACFC\uAD18\uAD34\uAD50\uAD6C\uAD88\uADA4\uADC0\uADDC\uADF8\uAE14\uAE30\uAE4C\uAE68\uAE84\uAEA0\uAEBC\uAED8\uAEF4\uAF10\uAF2C\uAF48\uAF64\uAF80\uAF9C\uAFB8\uAFD4\uAFF0\uB00C\uB028\uB044\uB060\uB07C\uB098\uB0B4\uB0D0\uB0EC\uB108\uB124\uB140\uB15C\uB178\uB194\uB1B0\uB1CC\uB1E8\uB204\uB220\uB23C\uB258\uB274\uB290\uB2AC\uB2C8\uB2E4\uB300\uB31C\uB338\uB354\uB370\uB38C\uB3A8\uB3C4\uB3E0\uB3FC\uB418\uB434\uB450\uB46C\uB488\uB4A4\uB4C0\uB4DC\uB4F8\uB514\uB530\uB54C\uB568\uB584\uB5A0\uB5BC\uB5D8\uB5F4\uB610\uB62C\uB648\uB664\uB680\uB69C\uB6B8\uB6D4\uB6F0\uB70C\uB728\uB744\uB760\uB77C\uB798\uB7B4\uB7D0\uB7EC\uB808\uB824\uB840\uB85C\uB878\uB894\uB8B0\uB8CC\uB8E8\uB904\uB920\uB93C\uB958\uB974\uB990\uB9AC\uB9C8\uB9E4\uBA00\uBA1C\uBA38\uBA54\uBA70\uBA8C\uBAA8\uBAC4\uBAE0\uBAFC\uBB18\uBB34\uBB50\uBB6C\uBB88\uBBA4\uBBC0\uBBDC\uBBF8\uBC14\uBC30\uBC4C\uBC68\uBC84\uBCA0\uBCBC\uBCD8\uBCF4\uBD10\uBD2C\uBD48\uBD64\uBD80\uBD9C\uBDB8\uBDD4\uBDF0\uBE0C\uBE28\uBE44\uBE60\uBE7C\uBE98\uBEB4\uBED0\uBEEC\uBF08\uBF24\uBF40\uBF5C\uBF78\uBF94\uBFB0\uBFCC\uBFE8\uC004\uC020\uC03C\uC058\uC074\uC090\uC0AC\uC0C8\uC0E4\uC100\uC11C\uC138\uC154\uC170\uC18C\uC1A8\uC1C4\uC1E0\uC1FC\uC218\uC234\uC250\uC26C\uC288\uC2A4\uC2C0\uC2DC\uC2F8\uC314\uC330\uC34C\uC368\uC384\uC3A0\uC3BC\uC3D8\uC3F4\uC410\uC42C\uC448\uC464\uC480\uC49C\uC4B8\uC4D4\uC4F0\uC50C\uC528\uC544\uC560\uC57C\uC598\uC5B4\uC5D0\uC5EC\uC608\uC624\uC640\uC65C\uC678\uC694\uC6B0\uC6CC\uC6E8\uC704\uC720\uC73C\uC758\uC774\uC790\uC7AC\uC7C8\uC7E4\uC800\uC81C\uC838\uC854\uC870\uC88C\uC8A8\uC8C4\uC8E0\uC8FC\uC918\uC934\uC950\uC96C\uC988\uC9A4\uC9C0\uC9DC\uC9F8\uCA14\uCA30\uCA4C\uCA68\uCA84\uCAA0\uCABC\uCAD8\uCAF4\uCB10\uCB2C\uCB48\uCB64\uCB80\uCB9C\uCBB8\uCBD4\uCBF0\uCC0C\uCC28\uCC44\uCC60\uCC7C\uCC98\uCCB4\uCCD0\uCCEC\uCD08\uCD24\uCD40\uCD5C\uCD78\uCD94\uCDB0\uCDCC\uCDE8\uCE04\uCE20\uCE3C\uCE58\uCE74\uCE90\uCEAC\uCEC8\uCEE4\uCF00\uCF1C\uCF38\uCF54\uCF70\uCF8C\uCFA8\uCFC4\uCFE0\uCFFC\uD018\uD034\uD050\uD06C\uD088\uD0A4\uD0C0\uD0DC\uD0F8\uD114\uD130\uD14C\uD168\uD184\uD1A0\uD1BC\uD1D8\uD1F4\uD210\uD22C\uD248\uD264\uD280\uD29C\uD2B8\uD2D4\uD2F0\uD30C\uD328\uD344\uD360\uD37C\uD398\uD3B4\uD3D0\uD3EC\uD408\uD424\uD440\uD45C\uD478\uD494\uD4B0\uD4CC\uD4E8\uD504\uD520\uD53C\uD558\uD574\uD590\uD5AC\uD5C8\uD5E4\uD600\uD61C\uD638\uD654\uD670\uD68C\uD6A8\uD6C4\uD6E0\uD6FC\uD718\uD734\uD750\uD76C\uD788]$/;
var $786b46ea7ddafaee$var$reLVT = /^[\uAC01-\uAC1B\uAC1D-\uAC37\uAC39-\uAC53\uAC55-\uAC6F\uAC71-\uAC8B\uAC8D-\uACA7\uACA9-\uACC3\uACC5-\uACDF\uACE1-\uACFB\uACFD-\uAD17\uAD19-\uAD33\uAD35-\uAD4F\uAD51-\uAD6B\uAD6D-\uAD87\uAD89-\uADA3\uADA5-\uADBF\uADC1-\uADDB\uADDD-\uADF7\uADF9-\uAE13\uAE15-\uAE2F\uAE31-\uAE4B\uAE4D-\uAE67\uAE69-\uAE83\uAE85-\uAE9F\uAEA1-\uAEBB\uAEBD-\uAED7\uAED9-\uAEF3\uAEF5-\uAF0F\uAF11-\uAF2B\uAF2D-\uAF47\uAF49-\uAF63\uAF65-\uAF7F\uAF81-\uAF9B\uAF9D-\uAFB7\uAFB9-\uAFD3\uAFD5-\uAFEF\uAFF1-\uB00B\uB00D-\uB027\uB029-\uB043\uB045-\uB05F\uB061-\uB07B\uB07D-\uB097\uB099-\uB0B3\uB0B5-\uB0CF\uB0D1-\uB0EB\uB0ED-\uB107\uB109-\uB123\uB125-\uB13F\uB141-\uB15B\uB15D-\uB177\uB179-\uB193\uB195-\uB1AF\uB1B1-\uB1CB\uB1CD-\uB1E7\uB1E9-\uB203\uB205-\uB21F\uB221-\uB23B\uB23D-\uB257\uB259-\uB273\uB275-\uB28F\uB291-\uB2AB\uB2AD-\uB2C7\uB2C9-\uB2E3\uB2E5-\uB2FF\uB301-\uB31B\uB31D-\uB337\uB339-\uB353\uB355-\uB36F\uB371-\uB38B\uB38D-\uB3A7\uB3A9-\uB3C3\uB3C5-\uB3DF\uB3E1-\uB3FB\uB3FD-\uB417\uB419-\uB433\uB435-\uB44F\uB451-\uB46B\uB46D-\uB487\uB489-\uB4A3\uB4A5-\uB4BF\uB4C1-\uB4DB\uB4DD-\uB4F7\uB4F9-\uB513\uB515-\uB52F\uB531-\uB54B\uB54D-\uB567\uB569-\uB583\uB585-\uB59F\uB5A1-\uB5BB\uB5BD-\uB5D7\uB5D9-\uB5F3\uB5F5-\uB60F\uB611-\uB62B\uB62D-\uB647\uB649-\uB663\uB665-\uB67F\uB681-\uB69B\uB69D-\uB6B7\uB6B9-\uB6D3\uB6D5-\uB6EF\uB6F1-\uB70B\uB70D-\uB727\uB729-\uB743\uB745-\uB75F\uB761-\uB77B\uB77D-\uB797\uB799-\uB7B3\uB7B5-\uB7CF\uB7D1-\uB7EB\uB7ED-\uB807\uB809-\uB823\uB825-\uB83F\uB841-\uB85B\uB85D-\uB877\uB879-\uB893\uB895-\uB8AF\uB8B1-\uB8CB\uB8CD-\uB8E7\uB8E9-\uB903\uB905-\uB91F\uB921-\uB93B\uB93D-\uB957\uB959-\uB973\uB975-\uB98F\uB991-\uB9AB\uB9AD-\uB9C7\uB9C9-\uB9E3\uB9E5-\uB9FF\uBA01-\uBA1B\uBA1D-\uBA37\uBA39-\uBA53\uBA55-\uBA6F\uBA71-\uBA8B\uBA8D-\uBAA7\uBAA9-\uBAC3\uBAC5-\uBADF\uBAE1-\uBAFB\uBAFD-\uBB17\uBB19-\uBB33\uBB35-\uBB4F\uBB51-\uBB6B\uBB6D-\uBB87\uBB89-\uBBA3\uBBA5-\uBBBF\uBBC1-\uBBDB\uBBDD-\uBBF7\uBBF9-\uBC13\uBC15-\uBC2F\uBC31-\uBC4B\uBC4D-\uBC67\uBC69-\uBC83\uBC85-\uBC9F\uBCA1-\uBCBB\uBCBD-\uBCD7\uBCD9-\uBCF3\uBCF5-\uBD0F\uBD11-\uBD2B\uBD2D-\uBD47\uBD49-\uBD63\uBD65-\uBD7F\uBD81-\uBD9B\uBD9D-\uBDB7\uBDB9-\uBDD3\uBDD5-\uBDEF\uBDF1-\uBE0B\uBE0D-\uBE27\uBE29-\uBE43\uBE45-\uBE5F\uBE61-\uBE7B\uBE7D-\uBE97\uBE99-\uBEB3\uBEB5-\uBECF\uBED1-\uBEEB\uBEED-\uBF07\uBF09-\uBF23\uBF25-\uBF3F\uBF41-\uBF5B\uBF5D-\uBF77\uBF79-\uBF93\uBF95-\uBFAF\uBFB1-\uBFCB\uBFCD-\uBFE7\uBFE9-\uC003\uC005-\uC01F\uC021-\uC03B\uC03D-\uC057\uC059-\uC073\uC075-\uC08F\uC091-\uC0AB\uC0AD-\uC0C7\uC0C9-\uC0E3\uC0E5-\uC0FF\uC101-\uC11B\uC11D-\uC137\uC139-\uC153\uC155-\uC16F\uC171-\uC18B\uC18D-\uC1A7\uC1A9-\uC1C3\uC1C5-\uC1DF\uC1E1-\uC1FB\uC1FD-\uC217\uC219-\uC233\uC235-\uC24F\uC251-\uC26B\uC26D-\uC287\uC289-\uC2A3\uC2A5-\uC2BF\uC2C1-\uC2DB\uC2DD-\uC2F7\uC2F9-\uC313\uC315-\uC32F\uC331-\uC34B\uC34D-\uC367\uC369-\uC383\uC385-\uC39F\uC3A1-\uC3BB\uC3BD-\uC3D7\uC3D9-\uC3F3\uC3F5-\uC40F\uC411-\uC42B\uC42D-\uC447\uC449-\uC463\uC465-\uC47F\uC481-\uC49B\uC49D-\uC4B7\uC4B9-\uC4D3\uC4D5-\uC4EF\uC4F1-\uC50B\uC50D-\uC527\uC529-\uC543\uC545-\uC55F\uC561-\uC57B\uC57D-\uC597\uC599-\uC5B3\uC5B5-\uC5CF\uC5D1-\uC5EB\uC5ED-\uC607\uC609-\uC623\uC625-\uC63F\uC641-\uC65B\uC65D-\uC677\uC679-\uC693\uC695-\uC6AF\uC6B1-\uC6CB\uC6CD-\uC6E7\uC6E9-\uC703\uC705-\uC71F\uC721-\uC73B\uC73D-\uC757\uC759-\uC773\uC775-\uC78F\uC791-\uC7AB\uC7AD-\uC7C7\uC7C9-\uC7E3\uC7E5-\uC7FF\uC801-\uC81B\uC81D-\uC837\uC839-\uC853\uC855-\uC86F\uC871-\uC88B\uC88D-\uC8A7\uC8A9-\uC8C3\uC8C5-\uC8DF\uC8E1-\uC8FB\uC8FD-\uC917\uC919-\uC933\uC935-\uC94F\uC951-\uC96B\uC96D-\uC987\uC989-\uC9A3\uC9A5-\uC9BF\uC9C1-\uC9DB\uC9DD-\uC9F7\uC9F9-\uCA13\uCA15-\uCA2F\uCA31-\uCA4B\uCA4D-\uCA67\uCA69-\uCA83\uCA85-\uCA9F\uCAA1-\uCABB\uCABD-\uCAD7\uCAD9-\uCAF3\uCAF5-\uCB0F\uCB11-\uCB2B\uCB2D-\uCB47\uCB49-\uCB63\uCB65-\uCB7F\uCB81-\uCB9B\uCB9D-\uCBB7\uCBB9-\uCBD3\uCBD5-\uCBEF\uCBF1-\uCC0B\uCC0D-\uCC27\uCC29-\uCC43\uCC45-\uCC5F\uCC61-\uCC7B\uCC7D-\uCC97\uCC99-\uCCB3\uCCB5-\uCCCF\uCCD1-\uCCEB\uCCED-\uCD07\uCD09-\uCD23\uCD25-\uCD3F\uCD41-\uCD5B\uCD5D-\uCD77\uCD79-\uCD93\uCD95-\uCDAF\uCDB1-\uCDCB\uCDCD-\uCDE7\uCDE9-\uCE03\uCE05-\uCE1F\uCE21-\uCE3B\uCE3D-\uCE57\uCE59-\uCE73\uCE75-\uCE8F\uCE91-\uCEAB\uCEAD-\uCEC7\uCEC9-\uCEE3\uCEE5-\uCEFF\uCF01-\uCF1B\uCF1D-\uCF37\uCF39-\uCF53\uCF55-\uCF6F\uCF71-\uCF8B\uCF8D-\uCFA7\uCFA9-\uCFC3\uCFC5-\uCFDF\uCFE1-\uCFFB\uCFFD-\uD017\uD019-\uD033\uD035-\uD04F\uD051-\uD06B\uD06D-\uD087\uD089-\uD0A3\uD0A5-\uD0BF\uD0C1-\uD0DB\uD0DD-\uD0F7\uD0F9-\uD113\uD115-\uD12F\uD131-\uD14B\uD14D-\uD167\uD169-\uD183\uD185-\uD19F\uD1A1-\uD1BB\uD1BD-\uD1D7\uD1D9-\uD1F3\uD1F5-\uD20F\uD211-\uD22B\uD22D-\uD247\uD249-\uD263\uD265-\uD27F\uD281-\uD29B\uD29D-\uD2B7\uD2B9-\uD2D3\uD2D5-\uD2EF\uD2F1-\uD30B\uD30D-\uD327\uD329-\uD343\uD345-\uD35F\uD361-\uD37B\uD37D-\uD397\uD399-\uD3B3\uD3B5-\uD3CF\uD3D1-\uD3EB\uD3ED-\uD407\uD409-\uD423\uD425-\uD43F\uD441-\uD45B\uD45D-\uD477\uD479-\uD493\uD495-\uD4AF\uD4B1-\uD4CB\uD4CD-\uD4E7\uD4E9-\uD503\uD505-\uD51F\uD521-\uD53B\uD53D-\uD557\uD559-\uD573\uD575-\uD58F\uD591-\uD5AB\uD5AD-\uD5C7\uD5C9-\uD5E3\uD5E5-\uD5FF\uD601-\uD61B\uD61D-\uD637\uD639-\uD653\uD655-\uD66F\uD671-\uD68B\uD68D-\uD6A7\uD6A9-\uD6C3\uD6C5-\uD6DF\uD6E1-\uD6FB\uD6FD-\uD717\uD719-\uD733\uD735-\uD74F\uD751-\uD76B\uD76D-\uD787\uD789-\uD7A3]$/;
var $786b46ea7ddafaee$var$reExtPict = /^(?:[\xA9\xAE\u203C\u2049\u2122\u2139\u2194-\u2199\u21A9\u21AA\u231A\u231B\u2328\u2388\u23CF\u23E9-\u23F3\u23F8-\u23FA\u24C2\u25AA\u25AB\u25B6\u25C0\u25FB-\u25FE\u2600-\u2605\u2607-\u2612\u2614-\u2685\u2690-\u2705\u2708-\u2712\u2714\u2716\u271D\u2721\u2728\u2733\u2734\u2744\u2747\u274C\u274E\u2753-\u2755\u2757\u2763-\u2767\u2795-\u2797\u27A1\u27B0\u27BF\u2934\u2935\u2B05-\u2B07\u2B1B\u2B1C\u2B50\u2B55\u3030\u303D\u3297\u3299]|\uD83C[\uDC00-\uDCFF\uDD0D-\uDD0F\uDD2F\uDD6C-\uDD71\uDD7E\uDD7F\uDD8E\uDD91-\uDD9A\uDDAD-\uDDE5\uDE01-\uDE0F\uDE1A\uDE2F\uDE32-\uDE3A\uDE3C-\uDE3F\uDE49-\uDFFA]|\uD83D[\uDC00-\uDD3D\uDD46-\uDE4F\uDE80-\uDEFF\uDF74-\uDF7F\uDFD5-\uDFFF]|\uD83E[\uDC0C-\uDC0F\uDC48-\uDC4F\uDC5A-\uDC5F\uDC88-\uDC8F\uDCAE-\uDCFF\uDD0C-\uDD3A\uDD3C-\uDD45\uDD47-\uDEFF]|\uD83F[\uDC00-\uDFFD])$/;
var $786b46ea7ddafaee$var$getCodepointType = (char, code)=>{
    var type = $786b46ea7ddafaee$var$CodepointType.Any;
    if (char.search($786b46ea7ddafaee$var$reExtend) !== -1) type |= $786b46ea7ddafaee$var$CodepointType.Extend;
    if (code === 0x200d) type |= $786b46ea7ddafaee$var$CodepointType.ZWJ;
    if (code >= 0x1f1e6 && code <= 0x1f1ff) type |= $786b46ea7ddafaee$var$CodepointType.RI;
    if (char.search($786b46ea7ddafaee$var$rePrepend) !== -1) type |= $786b46ea7ddafaee$var$CodepointType.Prepend;
    if (char.search($786b46ea7ddafaee$var$reSpacingMark) !== -1) type |= $786b46ea7ddafaee$var$CodepointType.SpacingMark;
    if (char.search($786b46ea7ddafaee$var$reL) !== -1) type |= $786b46ea7ddafaee$var$CodepointType.L;
    if (char.search($786b46ea7ddafaee$var$reV) !== -1) type |= $786b46ea7ddafaee$var$CodepointType.V;
    if (char.search($786b46ea7ddafaee$var$reT) !== -1) type |= $786b46ea7ddafaee$var$CodepointType.T;
    if (char.search($786b46ea7ddafaee$var$reLV) !== -1) type |= $786b46ea7ddafaee$var$CodepointType.LV;
    if (char.search($786b46ea7ddafaee$var$reLVT) !== -1) type |= $786b46ea7ddafaee$var$CodepointType.LVT;
    if (char.search($786b46ea7ddafaee$var$reExtPict) !== -1) type |= $786b46ea7ddafaee$var$CodepointType.ExtPict;
    return type;
};
function $786b46ea7ddafaee$var$intersects(x, y) {
    return (x & y) !== 0;
}
var $786b46ea7ddafaee$var$NonBoundaryPairs = [
    // GB6
    [
        $786b46ea7ddafaee$var$CodepointType.L,
        $786b46ea7ddafaee$var$CodepointType.L | $786b46ea7ddafaee$var$CodepointType.V | $786b46ea7ddafaee$var$CodepointType.LV | $786b46ea7ddafaee$var$CodepointType.LVT
    ],
    // GB7
    [
        $786b46ea7ddafaee$var$CodepointType.LV | $786b46ea7ddafaee$var$CodepointType.V,
        $786b46ea7ddafaee$var$CodepointType.V | $786b46ea7ddafaee$var$CodepointType.T
    ],
    // GB8
    [
        $786b46ea7ddafaee$var$CodepointType.LVT | $786b46ea7ddafaee$var$CodepointType.T,
        $786b46ea7ddafaee$var$CodepointType.T
    ],
    // GB9
    [
        $786b46ea7ddafaee$var$CodepointType.Any,
        $786b46ea7ddafaee$var$CodepointType.Extend | $786b46ea7ddafaee$var$CodepointType.ZWJ
    ],
    // GB9a
    [
        $786b46ea7ddafaee$var$CodepointType.Any,
        $786b46ea7ddafaee$var$CodepointType.SpacingMark
    ],
    // GB9b
    [
        $786b46ea7ddafaee$var$CodepointType.Prepend,
        $786b46ea7ddafaee$var$CodepointType.Any
    ],
    // GB11
    [
        $786b46ea7ddafaee$var$CodepointType.ZWJ,
        $786b46ea7ddafaee$var$CodepointType.ExtPict
    ],
    // GB12 and GB13
    [
        $786b46ea7ddafaee$var$CodepointType.RI,
        $786b46ea7ddafaee$var$CodepointType.RI
    ]
];
function $786b46ea7ddafaee$var$isBoundaryPair(left, right) {
    return $786b46ea7ddafaee$var$NonBoundaryPairs.findIndex((r)=>$786b46ea7ddafaee$var$intersects(left, r[0]) && $786b46ea7ddafaee$var$intersects(right, r[1])) === -1;
}
var $786b46ea7ddafaee$var$endingEmojiZWJ = /(?:[\xA9\xAE\u203C\u2049\u2122\u2139\u2194-\u2199\u21A9\u21AA\u231A\u231B\u2328\u2388\u23CF\u23E9-\u23F3\u23F8-\u23FA\u24C2\u25AA\u25AB\u25B6\u25C0\u25FB-\u25FE\u2600-\u2605\u2607-\u2612\u2614-\u2685\u2690-\u2705\u2708-\u2712\u2714\u2716\u271D\u2721\u2728\u2733\u2734\u2744\u2747\u274C\u274E\u2753-\u2755\u2757\u2763-\u2767\u2795-\u2797\u27A1\u27B0\u27BF\u2934\u2935\u2B05-\u2B07\u2B1B\u2B1C\u2B50\u2B55\u3030\u303D\u3297\u3299]|\uD83C[\uDC00-\uDCFF\uDD0D-\uDD0F\uDD2F\uDD6C-\uDD71\uDD7E\uDD7F\uDD8E\uDD91-\uDD9A\uDDAD-\uDDE5\uDE01-\uDE0F\uDE1A\uDE2F\uDE32-\uDE3A\uDE3C-\uDE3F\uDE49-\uDFFA]|\uD83D[\uDC00-\uDD3D\uDD46-\uDE4F\uDE80-\uDEFF\uDF74-\uDF7F\uDFD5-\uDFFF]|\uD83E[\uDC0C-\uDC0F\uDC48-\uDC4F\uDC5A-\uDC5F\uDC88-\uDC8F\uDCAE-\uDCFF\uDD0C-\uDD3A\uDD3C-\uDD45\uDD47-\uDEFF]|\uD83F[\uDC00-\uDFFD])(?:[\u0300-\u036F\u0483-\u0489\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u0610-\u061A\u064B-\u065F\u0670\u06D6-\u06DC\u06DF-\u06E4\u06E7\u06E8\u06EA-\u06ED\u0711\u0730-\u074A\u07A6-\u07B0\u07EB-\u07F3\u07FD\u0816-\u0819\u081B-\u0823\u0825-\u0827\u0829-\u082D\u0859-\u085B\u0898-\u089F\u08CA-\u08E1\u08E3-\u0902\u093A\u093C\u0941-\u0948\u094D\u0951-\u0957\u0962\u0963\u0981\u09BC\u09BE\u09C1-\u09C4\u09CD\u09D7\u09E2\u09E3\u09FE\u0A01\u0A02\u0A3C\u0A41\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A70\u0A71\u0A75\u0A81\u0A82\u0ABC\u0AC1-\u0AC5\u0AC7\u0AC8\u0ACD\u0AE2\u0AE3\u0AFA-\u0AFF\u0B01\u0B3C\u0B3E\u0B3F\u0B41-\u0B44\u0B4D\u0B55-\u0B57\u0B62\u0B63\u0B82\u0BBE\u0BC0\u0BCD\u0BD7\u0C00\u0C04\u0C3C\u0C3E-\u0C40\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C62\u0C63\u0C81\u0CBC\u0CBF\u0CC2\u0CC6\u0CCC\u0CCD\u0CD5\u0CD6\u0CE2\u0CE3\u0D00\u0D01\u0D3B\u0D3C\u0D3E\u0D41-\u0D44\u0D4D\u0D57\u0D62\u0D63\u0D81\u0DCA\u0DCF\u0DD2-\u0DD4\u0DD6\u0DDF\u0E31\u0E34-\u0E3A\u0E47-\u0E4E\u0EB1\u0EB4-\u0EBC\u0EC8-\u0ECE\u0F18\u0F19\u0F35\u0F37\u0F39\u0F71-\u0F7E\u0F80-\u0F84\u0F86\u0F87\u0F8D-\u0F97\u0F99-\u0FBC\u0FC6\u102D-\u1030\u1032-\u1037\u1039\u103A\u103D\u103E\u1058\u1059\u105E-\u1060\u1071-\u1074\u1082\u1085\u1086\u108D\u109D\u135D-\u135F\u1712-\u1714\u1732\u1733\u1752\u1753\u1772\u1773\u17B4\u17B5\u17B7-\u17BD\u17C6\u17C9-\u17D3\u17DD\u180B-\u180D\u180F\u1885\u1886\u18A9\u1920-\u1922\u1927\u1928\u1932\u1939-\u193B\u1A17\u1A18\u1A1B\u1A56\u1A58-\u1A5E\u1A60\u1A62\u1A65-\u1A6C\u1A73-\u1A7C\u1A7F\u1AB0-\u1ACE\u1B00-\u1B03\u1B34-\u1B3A\u1B3C\u1B42\u1B6B-\u1B73\u1B80\u1B81\u1BA2-\u1BA5\u1BA8\u1BA9\u1BAB-\u1BAD\u1BE6\u1BE8\u1BE9\u1BED\u1BEF-\u1BF1\u1C2C-\u1C33\u1C36\u1C37\u1CD0-\u1CD2\u1CD4-\u1CE0\u1CE2-\u1CE8\u1CED\u1CF4\u1CF8\u1CF9\u1DC0-\u1DFF\u200C\u20D0-\u20F0\u2CEF-\u2CF1\u2D7F\u2DE0-\u2DFF\u302A-\u302F\u3099\u309A\uA66F-\uA672\uA674-\uA67D\uA69E\uA69F\uA6F0\uA6F1\uA802\uA806\uA80B\uA825\uA826\uA82C\uA8C4\uA8C5\uA8E0-\uA8F1\uA8FF\uA926-\uA92D\uA947-\uA951\uA980-\uA982\uA9B3\uA9B6-\uA9B9\uA9BC\uA9BD\uA9E5\uAA29-\uAA2E\uAA31\uAA32\uAA35\uAA36\uAA43\uAA4C\uAA7C\uAAB0\uAAB2-\uAAB4\uAAB7\uAAB8\uAABE\uAABF\uAAC1\uAAEC\uAAED\uAAF6\uABE5\uABE8\uABED\uFB1E\uFE00-\uFE0F\uFE20-\uFE2F\uFF9E\uFF9F]|\uD800[\uDDFD\uDEE0\uDF76-\uDF7A]|\uD802[\uDE01-\uDE03\uDE05\uDE06\uDE0C-\uDE0F\uDE38-\uDE3A\uDE3F\uDEE5\uDEE6]|\uD803[\uDD24-\uDD27\uDEAB\uDEAC\uDEFD-\uDEFF\uDF46-\uDF50\uDF82-\uDF85]|\uD804[\uDC01\uDC38-\uDC46\uDC70\uDC73\uDC74\uDC7F-\uDC81\uDCB3-\uDCB6\uDCB9\uDCBA\uDCC2\uDD00-\uDD02\uDD27-\uDD2B\uDD2D-\uDD34\uDD73\uDD80\uDD81\uDDB6-\uDDBE\uDDC9-\uDDCC\uDDCF\uDE2F-\uDE31\uDE34\uDE36\uDE37\uDE3E\uDE41\uDEDF\uDEE3-\uDEEA\uDF00\uDF01\uDF3B\uDF3C\uDF3E\uDF40\uDF57\uDF66-\uDF6C\uDF70-\uDF74]|\uD805[\uDC38-\uDC3F\uDC42-\uDC44\uDC46\uDC5E\uDCB0\uDCB3-\uDCB8\uDCBA\uDCBD\uDCBF\uDCC0\uDCC2\uDCC3\uDDAF\uDDB2-\uDDB5\uDDBC\uDDBD\uDDBF\uDDC0\uDDDC\uDDDD\uDE33-\uDE3A\uDE3D\uDE3F\uDE40\uDEAB\uDEAD\uDEB0-\uDEB5\uDEB7\uDF1D-\uDF1F\uDF22-\uDF25\uDF27-\uDF2B]|\uD806[\uDC2F-\uDC37\uDC39\uDC3A\uDD30\uDD3B\uDD3C\uDD3E\uDD43\uDDD4-\uDDD7\uDDDA\uDDDB\uDDE0\uDE01-\uDE0A\uDE33-\uDE38\uDE3B-\uDE3E\uDE47\uDE51-\uDE56\uDE59-\uDE5B\uDE8A-\uDE96\uDE98\uDE99]|\uD807[\uDC30-\uDC36\uDC38-\uDC3D\uDC3F\uDC92-\uDCA7\uDCAA-\uDCB0\uDCB2\uDCB3\uDCB5\uDCB6\uDD31-\uDD36\uDD3A\uDD3C\uDD3D\uDD3F-\uDD45\uDD47\uDD90\uDD91\uDD95\uDD97\uDEF3\uDEF4\uDF00\uDF01\uDF36-\uDF3A\uDF40\uDF42]|\uD80D[\uDC40\uDC47-\uDC55]|\uD81A[\uDEF0-\uDEF4\uDF30-\uDF36]|\uD81B[\uDF4F\uDF8F-\uDF92\uDFE4]|\uD82F[\uDC9D\uDC9E]|\uD833[\uDF00-\uDF2D\uDF30-\uDF46]|\uD834[\uDD65\uDD67-\uDD69\uDD6E-\uDD72\uDD7B-\uDD82\uDD85-\uDD8B\uDDAA-\uDDAD\uDE42-\uDE44]|\uD836[\uDE00-\uDE36\uDE3B-\uDE6C\uDE75\uDE84\uDE9B-\uDE9F\uDEA1-\uDEAF]|\uD838[\uDC00-\uDC06\uDC08-\uDC18\uDC1B-\uDC21\uDC23\uDC24\uDC26-\uDC2A\uDC8F\uDD30-\uDD36\uDEAE\uDEEC-\uDEEF]|\uD839[\uDCEC-\uDCEF]|\uD83A[\uDCD0-\uDCD6\uDD44-\uDD4A]|\uD83C[\uDFFB-\uDFFF]|\uDB40[\uDC20-\uDC7F\uDD00-\uDDEF])*\u200D$/;
var $786b46ea7ddafaee$var$endsWithEmojiZWJ = (str)=>{
    return str.search($786b46ea7ddafaee$var$endingEmojiZWJ) !== -1;
};
var $786b46ea7ddafaee$var$endingRIs = /(?:\uD83C[\uDDE6-\uDDFF])+$/g;
var $786b46ea7ddafaee$var$endsWithOddNumberOfRIs = (str)=>{
    var match = str.match($786b46ea7ddafaee$var$endingRIs);
    if (match === null) return false;
    else {
        // A RI is represented by a surrogate pair.
        var numRIs = match[0].length / 2;
        return numRIs % 2 === 1;
    }
};
// eslint-disable-next-line no-redeclare
var $786b46ea7ddafaee$var$TextTransforms = {
    delete (editor, options) {
        editor.delete(options);
    },
    insertFragment (editor, fragment, options) {
        editor.insertFragment(fragment, options);
    },
    insertText (editor, text) {
        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        $786b46ea7ddafaee$export$7cda8d932e2f33c0.withoutNormalizing(editor, ()=>{
            var { voids: voids = false } = options;
            var { at: at = $786b46ea7ddafaee$var$getDefaultInsertLocation(editor) } = options;
            if ($786b46ea7ddafaee$export$4b2950bdac9b6ee9.isPath(at)) at = $786b46ea7ddafaee$export$7cda8d932e2f33c0.range(editor, at);
            if ($786b46ea7ddafaee$export$9a58ef0d7ad3278c.isRange(at)) {
                if ($786b46ea7ddafaee$export$9a58ef0d7ad3278c.isCollapsed(at)) at = at.anchor;
                else {
                    var end = $786b46ea7ddafaee$export$9a58ef0d7ad3278c.end(at);
                    if (!voids && $786b46ea7ddafaee$export$7cda8d932e2f33c0.void(editor, {
                        at: end
                    })) return;
                    var start = $786b46ea7ddafaee$export$9a58ef0d7ad3278c.start(at);
                    var startRef = $786b46ea7ddafaee$export$7cda8d932e2f33c0.pointRef(editor, start);
                    var endRef = $786b46ea7ddafaee$export$7cda8d932e2f33c0.pointRef(editor, end);
                    $786b46ea7ddafaee$export$2e7e2a6179fcdd5c.delete(editor, {
                        at: at,
                        voids: voids
                    });
                    var startPoint = startRef.unref();
                    var endPoint = endRef.unref();
                    at = startPoint || endPoint;
                    $786b46ea7ddafaee$export$2e7e2a6179fcdd5c.setSelection(editor, {
                        anchor: at,
                        focus: at
                    });
                }
            }
            if (!voids && $786b46ea7ddafaee$export$7cda8d932e2f33c0.void(editor, {
                at: at
            }) || $786b46ea7ddafaee$export$7cda8d932e2f33c0.elementReadOnly(editor, {
                at: at
            })) return;
            var { path: path, offset: offset } = at;
            if (text.length > 0) editor.apply({
                type: "insert_text",
                path: path,
                offset: offset,
                text: text
            });
        });
    }
};
function $786b46ea7ddafaee$var$ownKeys$9(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $786b46ea7ddafaee$var$_objectSpread$9(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $786b46ea7ddafaee$var$ownKeys$9(Object(t), !0).forEach(function(r) {
            $786b46ea7ddafaee$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $786b46ea7ddafaee$var$ownKeys$9(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $786b46ea7ddafaee$export$2e7e2a6179fcdd5c = $786b46ea7ddafaee$var$_objectSpread$9($786b46ea7ddafaee$var$_objectSpread$9($786b46ea7ddafaee$var$_objectSpread$9($786b46ea7ddafaee$var$_objectSpread$9({}, $786b46ea7ddafaee$var$GeneralTransforms), $786b46ea7ddafaee$var$NodeTransforms), $786b46ea7ddafaee$var$SelectionTransforms), $786b46ea7ddafaee$var$TextTransforms);
// perf
var $786b46ea7ddafaee$var$BATCHING_DIRTY_PATHS = new WeakMap();
var $786b46ea7ddafaee$var$isBatchingDirtyPaths = (editor)=>{
    return $786b46ea7ddafaee$var$BATCHING_DIRTY_PATHS.get(editor) || false;
};
var $786b46ea7ddafaee$var$batchDirtyPaths = (editor, fn, update)=>{
    var value = $786b46ea7ddafaee$var$BATCHING_DIRTY_PATHS.get(editor) || false;
    $786b46ea7ddafaee$var$BATCHING_DIRTY_PATHS.set(editor, true);
    try {
        fn();
        update();
    } finally{
        $786b46ea7ddafaee$var$BATCHING_DIRTY_PATHS.set(editor, value);
    }
};
/**
 * update editor dirty paths
 *
 * @param newDirtyPaths: Path[]; new dirty paths
 * @param transform: (p: Path) => Path | null; how to transform existing dirty paths
 */ function $786b46ea7ddafaee$var$updateDirtyPaths(editor, newDirtyPaths, transform) {
    var oldDirtyPaths = $786b46ea7ddafaee$var$DIRTY_PATHS.get(editor) || [];
    var oldDirtyPathKeys = $786b46ea7ddafaee$var$DIRTY_PATH_KEYS.get(editor) || new Set();
    var dirtyPaths;
    var dirtyPathKeys;
    var add = (path)=>{
        if (path) {
            var key = path.join(",");
            if (!dirtyPathKeys.has(key)) {
                dirtyPathKeys.add(key);
                dirtyPaths.push(path);
            }
        }
    };
    if (transform) {
        dirtyPaths = [];
        dirtyPathKeys = new Set();
        for (var path of oldDirtyPaths){
            var newPath = transform(path);
            add(newPath);
        }
    } else {
        dirtyPaths = oldDirtyPaths;
        dirtyPathKeys = oldDirtyPathKeys;
    }
    for (var _path of newDirtyPaths)add(_path);
    $786b46ea7ddafaee$var$DIRTY_PATHS.set(editor, dirtyPaths);
    $786b46ea7ddafaee$var$DIRTY_PATH_KEYS.set(editor, dirtyPathKeys);
}
var $786b46ea7ddafaee$export$5635d7ef4b8fee1c = (editor, op)=>{
    for (var ref of $786b46ea7ddafaee$export$7cda8d932e2f33c0.pathRefs(editor))$786b46ea7ddafaee$export$c30b5041fe25721a.transform(ref, op);
    for (var _ref of $786b46ea7ddafaee$export$7cda8d932e2f33c0.pointRefs(editor))$786b46ea7ddafaee$export$2f63ff8a9fd3c92d.transform(_ref, op);
    for (var _ref2 of $786b46ea7ddafaee$export$7cda8d932e2f33c0.rangeRefs(editor))$786b46ea7ddafaee$export$6de705947f0c0c72.transform(_ref2, op);
    // update dirty paths
    if (!$786b46ea7ddafaee$var$isBatchingDirtyPaths(editor)) {
        var transform = $786b46ea7ddafaee$export$4b2950bdac9b6ee9.operationCanTransformPath(op) ? (p)=>$786b46ea7ddafaee$export$4b2950bdac9b6ee9.transform(p, op) : undefined;
        $786b46ea7ddafaee$var$updateDirtyPaths(editor, editor.getDirtyPaths(op), transform);
    }
    $786b46ea7ddafaee$export$2e7e2a6179fcdd5c.transform(editor, op);
    editor.operations.push(op);
    $786b46ea7ddafaee$export$7cda8d932e2f33c0.normalize(editor, {
        operation: op
    });
    // Clear any formats applied to the cursor if the selection changes.
    if (op.type === "set_selection") editor.marks = null;
    if (!$786b46ea7ddafaee$var$FLUSHING.get(editor)) {
        $786b46ea7ddafaee$var$FLUSHING.set(editor, true);
        Promise.resolve().then(()=>{
            $786b46ea7ddafaee$var$FLUSHING.set(editor, false);
            editor.onChange({
                operation: op
            });
            editor.operations = [];
        });
    }
};
/**
 * Get the "dirty" paths generated from an operation.
 */ var $786b46ea7ddafaee$export$19d7c64d3d3b658b = (editor, op)=>{
    switch(op.type){
        case "insert_text":
        case "remove_text":
        case "set_node":
            var { path: path } = op;
            return $786b46ea7ddafaee$export$4b2950bdac9b6ee9.levels(path);
        case "insert_node":
            var { node: node, path: _path } = op;
            var levels = $786b46ea7ddafaee$export$4b2950bdac9b6ee9.levels(_path);
            var descendants = $786b46ea7ddafaee$export$5f1af8db9871e1d6.isText(node) ? [] : Array.from($786b46ea7ddafaee$export$85c928794f8d04d4.nodes(node), (_ref)=>{
                var [, p] = _ref;
                return _path.concat(p);
            });
            return [
                ...levels,
                ...descendants
            ];
        case "merge_node":
            var { path: _path2 } = op;
            var ancestors = $786b46ea7ddafaee$export$4b2950bdac9b6ee9.ancestors(_path2);
            var previousPath = $786b46ea7ddafaee$export$4b2950bdac9b6ee9.previous(_path2);
            return [
                ...ancestors,
                previousPath
            ];
        case "move_node":
            var { path: _path3, newPath: newPath } = op;
            if ($786b46ea7ddafaee$export$4b2950bdac9b6ee9.equals(_path3, newPath)) return [];
            var oldAncestors = [];
            var newAncestors = [];
            for (var ancestor of $786b46ea7ddafaee$export$4b2950bdac9b6ee9.ancestors(_path3)){
                var p = $786b46ea7ddafaee$export$4b2950bdac9b6ee9.transform(ancestor, op);
                oldAncestors.push(p);
            }
            for (var _ancestor of $786b46ea7ddafaee$export$4b2950bdac9b6ee9.ancestors(newPath)){
                var _p = $786b46ea7ddafaee$export$4b2950bdac9b6ee9.transform(_ancestor, op);
                newAncestors.push(_p);
            }
            var newParent = newAncestors[newAncestors.length - 1];
            var newIndex = newPath[newPath.length - 1];
            var resultPath = newParent.concat(newIndex);
            return [
                ...oldAncestors,
                ...newAncestors,
                resultPath
            ];
        case "remove_node":
            var { path: _path4 } = op;
            var _ancestors = $786b46ea7ddafaee$export$4b2950bdac9b6ee9.ancestors(_path4);
            return [
                ..._ancestors
            ];
        case "split_node":
            var { path: _path5 } = op;
            var _levels = $786b46ea7ddafaee$export$4b2950bdac9b6ee9.levels(_path5);
            var nextPath = $786b46ea7ddafaee$export$4b2950bdac9b6ee9.next(_path5);
            return [
                ..._levels,
                nextPath
            ];
        default:
            return [];
    }
};
var $786b46ea7ddafaee$export$7ddaa488b9a570c = (editor)=>{
    var { selection: selection } = editor;
    if (selection) return $786b46ea7ddafaee$export$85c928794f8d04d4.fragment(editor, selection);
    return [];
};
var $786b46ea7ddafaee$export$775064d9a0021ab5 = (editor, entry)=>{
    var [node, path] = entry;
    // There are no core normalizations for text nodes.
    if ($786b46ea7ddafaee$export$5f1af8db9871e1d6.isText(node)) return;
    // Ensure that block and inline nodes have at least one text child.
    if ($786b46ea7ddafaee$export$db77ccec0bb4ccac.isElement(node) && node.children.length === 0) {
        var child = {
            text: ""
        };
        $786b46ea7ddafaee$export$2e7e2a6179fcdd5c.insertNodes(editor, child, {
            at: path.concat(0),
            voids: true
        });
        return;
    }
    // Determine whether the node should have block or inline children.
    var shouldHaveInlines = $786b46ea7ddafaee$export$7cda8d932e2f33c0.isEditor(node) ? false : $786b46ea7ddafaee$export$db77ccec0bb4ccac.isElement(node) && (editor.isInline(node) || node.children.length === 0 || $786b46ea7ddafaee$export$5f1af8db9871e1d6.isText(node.children[0]) || editor.isInline(node.children[0]));
    // Since we'll be applying operations while iterating, keep track of an
    // index that accounts for any added/removed nodes.
    var n = 0;
    for(var i = 0; i < node.children.length; i++, n++){
        var currentNode = $786b46ea7ddafaee$export$85c928794f8d04d4.get(editor, path);
        if ($786b46ea7ddafaee$export$5f1af8db9871e1d6.isText(currentNode)) continue;
        var _child = currentNode.children[n];
        var prev = currentNode.children[n - 1];
        var isLast = i === node.children.length - 1;
        var isInlineOrText = $786b46ea7ddafaee$export$5f1af8db9871e1d6.isText(_child) || $786b46ea7ddafaee$export$db77ccec0bb4ccac.isElement(_child) && editor.isInline(_child);
        // Only allow block nodes in the top-level children and parent blocks
        // that only contain block nodes. Similarly, only allow inline nodes in
        // other inline nodes, or parent blocks that only contain inlines and
        // text.
        if (isInlineOrText !== shouldHaveInlines) {
            if (isInlineOrText) $786b46ea7ddafaee$export$2e7e2a6179fcdd5c.removeNodes(editor, {
                at: path.concat(n),
                voids: true
            });
            else $786b46ea7ddafaee$export$2e7e2a6179fcdd5c.unwrapNodes(editor, {
                at: path.concat(n),
                voids: true
            });
            n--;
        } else if ($786b46ea7ddafaee$export$db77ccec0bb4ccac.isElement(_child)) // Ensure that inline nodes are surrounded by text nodes.
        {
            if (editor.isInline(_child)) {
                if (prev == null || !$786b46ea7ddafaee$export$5f1af8db9871e1d6.isText(prev)) {
                    var newChild = {
                        text: ""
                    };
                    $786b46ea7ddafaee$export$2e7e2a6179fcdd5c.insertNodes(editor, newChild, {
                        at: path.concat(n),
                        voids: true
                    });
                    n++;
                } else if (isLast) {
                    var _newChild = {
                        text: ""
                    };
                    $786b46ea7ddafaee$export$2e7e2a6179fcdd5c.insertNodes(editor, _newChild, {
                        at: path.concat(n + 1),
                        voids: true
                    });
                    n++;
                }
            }
        } else {
            // If the child is not a text node, and doesn't have a `children` field,
            // then we have an invalid node that will upset slate.
            //
            // eg: `{ type: 'some_node' }`.
            //
            // To prevent slate from breaking, we can add the `children` field,
            // and now that it is valid, we can to many more operations easily,
            // such as extend normalizers to fix erronous structure.
            if (!$786b46ea7ddafaee$export$5f1af8db9871e1d6.isText(_child) && !("children" in _child)) {
                var elementChild = _child;
                elementChild.children = [];
            }
            // Merge adjacent text nodes that are empty or match.
            if (prev != null && $786b46ea7ddafaee$export$5f1af8db9871e1d6.isText(prev)) {
                if ($786b46ea7ddafaee$export$5f1af8db9871e1d6.equals(_child, prev, {
                    loose: true
                })) {
                    $786b46ea7ddafaee$export$2e7e2a6179fcdd5c.mergeNodes(editor, {
                        at: path.concat(n),
                        voids: true
                    });
                    n--;
                } else if (prev.text === "") {
                    $786b46ea7ddafaee$export$2e7e2a6179fcdd5c.removeNodes(editor, {
                        at: path.concat(n - 1),
                        voids: true
                    });
                    n--;
                } else if (_child.text === "") {
                    $786b46ea7ddafaee$export$2e7e2a6179fcdd5c.removeNodes(editor, {
                        at: path.concat(n),
                        voids: true
                    });
                    n--;
                }
            }
        }
    }
};
var $786b46ea7ddafaee$export$8124630c93d7bb9c = (editor, _ref)=>{
    var { iteration: iteration, initialDirtyPathsLength: initialDirtyPathsLength } = _ref;
    var maxIterations = initialDirtyPathsLength * 42; // HACK: better way?
    if (iteration > maxIterations) throw new Error("Could not completely normalize the editor after ".concat(maxIterations, " iterations! This is usually due to incorrect normalization logic that leaves a node in an invalid state."));
    return true;
};
var $786b46ea7ddafaee$export$1b61d973339d4399 = function above(editor) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var { voids: voids = false, mode: mode = "lowest", at: at = editor.selection, match: match } = options;
    if (!at) return;
    var path = $786b46ea7ddafaee$export$7cda8d932e2f33c0.path(editor, at);
    var reverse = mode === "lowest";
    for (var [n, p] of $786b46ea7ddafaee$export$7cda8d932e2f33c0.levels(editor, {
        at: path,
        voids: voids,
        match: match,
        reverse: reverse
    })){
        if ($786b46ea7ddafaee$export$5f1af8db9871e1d6.isText(n)) continue;
        if ($786b46ea7ddafaee$export$9a58ef0d7ad3278c.isRange(at)) {
            if ($786b46ea7ddafaee$export$4b2950bdac9b6ee9.isAncestor(p, at.anchor.path) && $786b46ea7ddafaee$export$4b2950bdac9b6ee9.isAncestor(p, at.focus.path)) return [
                n,
                p
            ];
        } else {
            if (!$786b46ea7ddafaee$export$4b2950bdac9b6ee9.equals(path, p)) return [
                n,
                p
            ];
        }
    }
};
function $786b46ea7ddafaee$var$ownKeys$8(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $786b46ea7ddafaee$var$_objectSpread$8(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $786b46ea7ddafaee$var$ownKeys$8(Object(t), !0).forEach(function(r) {
            $786b46ea7ddafaee$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $786b46ea7ddafaee$var$ownKeys$8(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $786b46ea7ddafaee$export$728e28c22a0fba4 = (editor, key, value)=>{
    var { selection: selection } = editor;
    if (selection) {
        var match = (node, path)=>{
            if (!$786b46ea7ddafaee$export$5f1af8db9871e1d6.isText(node)) return false; // marks can only be applied to text
            var [parentNode, parentPath] = $786b46ea7ddafaee$export$7cda8d932e2f33c0.parent(editor, path);
            return !editor.isVoid(parentNode) || editor.markableVoid(parentNode);
        };
        var expandedSelection = $786b46ea7ddafaee$export$9a58ef0d7ad3278c.isExpanded(selection);
        var markAcceptingVoidSelected = false;
        if (!expandedSelection) {
            var [selectedNode, selectedPath] = $786b46ea7ddafaee$export$7cda8d932e2f33c0.node(editor, selection);
            if (selectedNode && match(selectedNode, selectedPath)) {
                var [parentNode] = $786b46ea7ddafaee$export$7cda8d932e2f33c0.parent(editor, selectedPath);
                markAcceptingVoidSelected = parentNode && editor.markableVoid(parentNode);
            }
        }
        if (expandedSelection || markAcceptingVoidSelected) $786b46ea7ddafaee$export$2e7e2a6179fcdd5c.setNodes(editor, {
            [key]: value
        }, {
            match: match,
            split: true,
            voids: true
        });
        else {
            var marks = $786b46ea7ddafaee$var$_objectSpread$8($786b46ea7ddafaee$var$_objectSpread$8({}, $786b46ea7ddafaee$export$7cda8d932e2f33c0.marks(editor) || {}), {}, {
                [key]: value
            });
            editor.marks = marks;
            if (!$786b46ea7ddafaee$var$FLUSHING.get(editor)) editor.onChange();
        }
    }
};
function $786b46ea7ddafaee$var$ownKeys$7(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $786b46ea7ddafaee$var$_objectSpread$7(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $786b46ea7ddafaee$var$ownKeys$7(Object(t), !0).forEach(function(r) {
            $786b46ea7ddafaee$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $786b46ea7ddafaee$var$ownKeys$7(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $786b46ea7ddafaee$export$742acabee3dd6465 = function after(editor, at) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var anchor = $786b46ea7ddafaee$export$7cda8d932e2f33c0.point(editor, at, {
        edge: "end"
    });
    var focus = $786b46ea7ddafaee$export$7cda8d932e2f33c0.end(editor, []);
    var range = {
        anchor: anchor,
        focus: focus
    };
    var { distance: distance = 1 } = options;
    var d = 0;
    var target;
    for (var p of $786b46ea7ddafaee$export$7cda8d932e2f33c0.positions(editor, $786b46ea7ddafaee$var$_objectSpread$7($786b46ea7ddafaee$var$_objectSpread$7({}, options), {}, {
        at: range
    }))){
        if (d > distance) break;
        if (d !== 0) target = p;
        d++;
    }
    return target;
};
function $786b46ea7ddafaee$var$ownKeys$6(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $786b46ea7ddafaee$var$_objectSpread$6(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $786b46ea7ddafaee$var$ownKeys$6(Object(t), !0).forEach(function(r) {
            $786b46ea7ddafaee$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $786b46ea7ddafaee$var$ownKeys$6(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $786b46ea7ddafaee$export$1c4c1e3098bf5ebe = function before(editor, at) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var anchor = $786b46ea7ddafaee$export$7cda8d932e2f33c0.start(editor, []);
    var focus = $786b46ea7ddafaee$export$7cda8d932e2f33c0.point(editor, at, {
        edge: "start"
    });
    var range = {
        anchor: anchor,
        focus: focus
    };
    var { distance: distance = 1 } = options;
    var d = 0;
    var target;
    for (var p of $786b46ea7ddafaee$export$7cda8d932e2f33c0.positions(editor, $786b46ea7ddafaee$var$_objectSpread$6($786b46ea7ddafaee$var$_objectSpread$6({}, options), {}, {
        at: range,
        reverse: true
    }))){
        if (d > distance) break;
        if (d !== 0) target = p;
        d++;
    }
    return target;
};
var $786b46ea7ddafaee$export$f2323afd0aa0bdea = (editor, unit)=>{
    var { selection: selection } = editor;
    if (selection && $786b46ea7ddafaee$export$9a58ef0d7ad3278c.isCollapsed(selection)) $786b46ea7ddafaee$export$2e7e2a6179fcdd5c.delete(editor, {
        unit: unit,
        reverse: true
    });
};
var $786b46ea7ddafaee$export$948b9f836237b4b4 = (editor, unit)=>{
    var { selection: selection } = editor;
    if (selection && $786b46ea7ddafaee$export$9a58ef0d7ad3278c.isCollapsed(selection)) $786b46ea7ddafaee$export$2e7e2a6179fcdd5c.delete(editor, {
        unit: unit
    });
};
var $786b46ea7ddafaee$export$de5307279b49fffb = function deleteFragment(editor) {
    var { direction: direction = "forward" } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var { selection: selection } = editor;
    if (selection && $786b46ea7ddafaee$export$9a58ef0d7ad3278c.isExpanded(selection)) $786b46ea7ddafaee$export$2e7e2a6179fcdd5c.delete(editor, {
        reverse: direction === "backward"
    });
};
var $786b46ea7ddafaee$export$4544a00f8eb65eb2 = (editor, at)=>{
    return [
        $786b46ea7ddafaee$export$7cda8d932e2f33c0.start(editor, at),
        $786b46ea7ddafaee$export$7cda8d932e2f33c0.end(editor, at)
    ];
};
function $786b46ea7ddafaee$var$ownKeys$5(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $786b46ea7ddafaee$var$_objectSpread$5(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $786b46ea7ddafaee$var$ownKeys$5(Object(t), !0).forEach(function(r) {
            $786b46ea7ddafaee$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $786b46ea7ddafaee$var$ownKeys$5(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $786b46ea7ddafaee$export$7b9289b4576eb4e5 = function elementReadOnly(editor) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return $786b46ea7ddafaee$export$7cda8d932e2f33c0.above(editor, $786b46ea7ddafaee$var$_objectSpread$5($786b46ea7ddafaee$var$_objectSpread$5({}, options), {}, {
        match: (n)=>$786b46ea7ddafaee$export$db77ccec0bb4ccac.isElement(n) && $786b46ea7ddafaee$export$7cda8d932e2f33c0.isElementReadOnly(editor, n)
    }));
};
var $786b46ea7ddafaee$export$bd5df0f255a350f8 = (editor, at)=>{
    return $786b46ea7ddafaee$export$7cda8d932e2f33c0.point(editor, at, {
        edge: "end"
    });
};
var $786b46ea7ddafaee$export$43128fadae87b74a = (editor, at)=>{
    var path = $786b46ea7ddafaee$export$7cda8d932e2f33c0.path(editor, at, {
        edge: "start"
    });
    return $786b46ea7ddafaee$export$7cda8d932e2f33c0.node(editor, path);
};
var $786b46ea7ddafaee$export$f00aeb236b6f05af = (editor, at)=>{
    var range = $786b46ea7ddafaee$export$7cda8d932e2f33c0.range(editor, at);
    return $786b46ea7ddafaee$export$85c928794f8d04d4.fragment(editor, range);
};
function $786b46ea7ddafaee$var$ownKeys$4(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $786b46ea7ddafaee$var$_objectSpread$4(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $786b46ea7ddafaee$var$ownKeys$4(Object(t), !0).forEach(function(r) {
            $786b46ea7ddafaee$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $786b46ea7ddafaee$var$ownKeys$4(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $786b46ea7ddafaee$export$a03ecfa95a44c405 = function getVoid(editor) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return $786b46ea7ddafaee$export$7cda8d932e2f33c0.above(editor, $786b46ea7ddafaee$var$_objectSpread$4($786b46ea7ddafaee$var$_objectSpread$4({}, options), {}, {
        match: (n)=>$786b46ea7ddafaee$export$db77ccec0bb4ccac.isElement(n) && $786b46ea7ddafaee$export$7cda8d932e2f33c0.isVoid(editor, n)
    }));
};
var $786b46ea7ddafaee$export$9a188849e4e12045 = (editor, element)=>{
    return element.children.some((n)=>$786b46ea7ddafaee$export$db77ccec0bb4ccac.isElement(n) && $786b46ea7ddafaee$export$7cda8d932e2f33c0.isBlock(editor, n));
};
var $786b46ea7ddafaee$export$56b28c1fe6207902 = (editor, element)=>{
    return element.children.some((n)=>$786b46ea7ddafaee$export$5f1af8db9871e1d6.isText(n) || $786b46ea7ddafaee$export$7cda8d932e2f33c0.isInline(editor, n));
};
var $786b46ea7ddafaee$export$733a1929a329d022 = (editor, path)=>{
    return $786b46ea7ddafaee$export$85c928794f8d04d4.has(editor, path);
};
var $786b46ea7ddafaee$export$63613c7b0e5f8059 = (editor, element)=>{
    return element.children.every((n)=>$786b46ea7ddafaee$export$5f1af8db9871e1d6.isText(n));
};
var $786b46ea7ddafaee$export$674f9c199a622991 = (editor)=>{
    $786b46ea7ddafaee$export$2e7e2a6179fcdd5c.splitNodes(editor, {
        always: true
    });
};
var $786b46ea7ddafaee$export$f694843d4c7ee42a = (editor, node, options)=>{
    $786b46ea7ddafaee$export$2e7e2a6179fcdd5c.insertNodes(editor, node, options);
};
var $786b46ea7ddafaee$export$6260290d896a55f3 = (editor)=>{
    $786b46ea7ddafaee$export$2e7e2a6179fcdd5c.splitNodes(editor, {
        always: true
    });
};
function $786b46ea7ddafaee$var$ownKeys$3(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $786b46ea7ddafaee$var$_objectSpread$3(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $786b46ea7ddafaee$var$ownKeys$3(Object(t), !0).forEach(function(r) {
            $786b46ea7ddafaee$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $786b46ea7ddafaee$var$ownKeys$3(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $786b46ea7ddafaee$export$78ba03e296d6b5ac = function insertText(editor, text) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var { selection: selection, marks: marks } = editor;
    if (selection) {
        if (marks) {
            var node = $786b46ea7ddafaee$var$_objectSpread$3({
                text: text
            }, marks);
            $786b46ea7ddafaee$export$2e7e2a6179fcdd5c.insertNodes(editor, node, {
                at: options.at,
                voids: options.voids
            });
        } else $786b46ea7ddafaee$export$2e7e2a6179fcdd5c.insertText(editor, text, options);
        editor.marks = null;
    }
};
var $786b46ea7ddafaee$export$de5a9e42c1dff8da = (editor, value)=>{
    return !editor.isInline(value);
};
var $786b46ea7ddafaee$export$cac3980734d91fbe = (editor, point, at)=>{
    return $786b46ea7ddafaee$export$7cda8d932e2f33c0.isStart(editor, point, at) || $786b46ea7ddafaee$export$7cda8d932e2f33c0.isEnd(editor, point, at);
};
var $786b46ea7ddafaee$export$dd1bc94b04021eeb = (editor, element)=>{
    var { children: children } = element;
    var [first] = children;
    return children.length === 0 || children.length === 1 && $786b46ea7ddafaee$export$5f1af8db9871e1d6.isText(first) && first.text === "" && !editor.isVoid(element);
};
var $786b46ea7ddafaee$export$42af6f45c6e0d09f = (editor, point, at)=>{
    var end = $786b46ea7ddafaee$export$7cda8d932e2f33c0.end(editor, at);
    return $786b46ea7ddafaee$export$baf26146a414f24a.equals(point, end);
};
var $786b46ea7ddafaee$export$79baf32bd2ec6469 = (editor)=>{
    var isNormalizing = $786b46ea7ddafaee$var$NORMALIZING.get(editor);
    return isNormalizing === undefined ? true : isNormalizing;
};
var $786b46ea7ddafaee$export$d801051673333b73 = (editor, point, at)=>{
    // PERF: If the offset isn't `0` we know it's not the start.
    if (point.offset !== 0) return false;
    var start = $786b46ea7ddafaee$export$7cda8d932e2f33c0.start(editor, at);
    return $786b46ea7ddafaee$export$baf26146a414f24a.equals(point, start);
};
var $786b46ea7ddafaee$export$4c7897fafd92b108 = (editor, at)=>{
    var path = $786b46ea7ddafaee$export$7cda8d932e2f33c0.path(editor, at, {
        edge: "end"
    });
    return $786b46ea7ddafaee$export$7cda8d932e2f33c0.node(editor, path);
};
var $786b46ea7ddafaee$export$bf2348675e1fe8e = function leaf(editor, at) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var path = $786b46ea7ddafaee$export$7cda8d932e2f33c0.path(editor, at, options);
    var node = $786b46ea7ddafaee$export$85c928794f8d04d4.leaf(editor, path);
    return [
        node,
        path
    ];
};
function $786b46ea7ddafaee$export$cc32c6afed33d362(editor) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return function*() {
        var { at: at = editor.selection, reverse: reverse = false, voids: voids = false } = options;
        var { match: match } = options;
        if (match == null) match = ()=>true;
        if (!at) return;
        var levels = [];
        var path = $786b46ea7ddafaee$export$7cda8d932e2f33c0.path(editor, at);
        for (var [n, p] of $786b46ea7ddafaee$export$85c928794f8d04d4.levels(editor, path)){
            if (!match(n, p)) continue;
            levels.push([
                n,
                p
            ]);
            if (!voids && $786b46ea7ddafaee$export$db77ccec0bb4ccac.isElement(n) && $786b46ea7ddafaee$export$7cda8d932e2f33c0.isVoid(editor, n)) break;
        }
        if (reverse) levels.reverse();
        yield* levels;
    }();
}
var $786b46ea7ddafaee$var$_excluded$1 = [
    "text"
], $786b46ea7ddafaee$var$_excluded2$1 = [
    "text"
];
var $786b46ea7ddafaee$export$3a8025f2f3e0c64 = function marks(editor) {
    var { marks: marks, selection: selection } = editor;
    if (!selection) return null;
    var { anchor: anchor, focus: focus } = selection;
    if (marks) return marks;
    if ($786b46ea7ddafaee$export$9a58ef0d7ad3278c.isExpanded(selection)) {
        var isBackward = $786b46ea7ddafaee$export$9a58ef0d7ad3278c.isBackward(selection);
        if (isBackward) [focus, anchor] = [
            anchor,
            focus
        ];
        /**
     * COMPAT: Make sure hanging ranges (caused by double clicking in Firefox)
     * do not adversely affect the returned marks.
     */ var isEnd = $786b46ea7ddafaee$export$7cda8d932e2f33c0.isEnd(editor, anchor, anchor.path);
        if (isEnd) {
            var after = $786b46ea7ddafaee$export$7cda8d932e2f33c0.after(editor, anchor);
            if (after) anchor = after;
        }
        var [match] = $786b46ea7ddafaee$export$7cda8d932e2f33c0.nodes(editor, {
            match: $786b46ea7ddafaee$export$5f1af8db9871e1d6.isText,
            at: {
                anchor: anchor,
                focus: focus
            }
        });
        if (match) {
            var [_node] = match;
            var _rest = $786b46ea7ddafaee$var$_objectWithoutProperties(_node, $786b46ea7ddafaee$var$_excluded$1);
            return _rest;
        } else return {};
    }
    var { path: path } = anchor;
    var [node] = $786b46ea7ddafaee$export$7cda8d932e2f33c0.leaf(editor, path);
    if (anchor.offset === 0) {
        var prev = $786b46ea7ddafaee$export$7cda8d932e2f33c0.previous(editor, {
            at: path,
            match: $786b46ea7ddafaee$export$5f1af8db9871e1d6.isText
        });
        var markedVoid = $786b46ea7ddafaee$export$7cda8d932e2f33c0.above(editor, {
            match: (n)=>$786b46ea7ddafaee$export$db77ccec0bb4ccac.isElement(n) && $786b46ea7ddafaee$export$7cda8d932e2f33c0.isVoid(editor, n) && editor.markableVoid(n)
        });
        if (!markedVoid) {
            var block = $786b46ea7ddafaee$export$7cda8d932e2f33c0.above(editor, {
                match: (n)=>$786b46ea7ddafaee$export$db77ccec0bb4ccac.isElement(n) && $786b46ea7ddafaee$export$7cda8d932e2f33c0.isBlock(editor, n)
            });
            if (prev && block) {
                var [prevNode, prevPath] = prev;
                var [, blockPath] = block;
                if ($786b46ea7ddafaee$export$4b2950bdac9b6ee9.isAncestor(blockPath, prevPath)) node = prevNode;
            }
        }
    }
    var rest = $786b46ea7ddafaee$var$_objectWithoutProperties(node, $786b46ea7ddafaee$var$_excluded2$1);
    return rest;
};
var $786b46ea7ddafaee$export$48cfd1e771a65c4f = function next(editor) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var { mode: mode = "lowest", voids: voids = false } = options;
    var { match: match, at: at = editor.selection } = options;
    if (!at) return;
    var pointAfterLocation = $786b46ea7ddafaee$export$7cda8d932e2f33c0.after(editor, at, {
        voids: voids
    });
    if (!pointAfterLocation) return;
    var [, to] = $786b46ea7ddafaee$export$7cda8d932e2f33c0.last(editor, []);
    var span = [
        pointAfterLocation.path,
        to
    ];
    if ($786b46ea7ddafaee$export$4b2950bdac9b6ee9.isPath(at) && at.length === 0) throw new Error("Cannot get the next node from the root node!");
    if (match == null) {
        if ($786b46ea7ddafaee$export$4b2950bdac9b6ee9.isPath(at)) {
            var [parent] = $786b46ea7ddafaee$export$7cda8d932e2f33c0.parent(editor, at);
            match = (n)=>parent.children.includes(n);
        } else match = ()=>true;
    }
    var [next] = $786b46ea7ddafaee$export$7cda8d932e2f33c0.nodes(editor, {
        at: span,
        match: match,
        mode: mode,
        voids: voids
    });
    return next;
};
var $786b46ea7ddafaee$export$35059013cd4a06db = function node(editor, at) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var path = $786b46ea7ddafaee$export$7cda8d932e2f33c0.path(editor, at, options);
    var node = $786b46ea7ddafaee$export$85c928794f8d04d4.get(editor, path);
    return [
        node,
        path
    ];
};
function $786b46ea7ddafaee$export$695720b7e7a61533(editor) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return function*() {
        var { at: at = editor.selection, mode: mode = "all", universal: universal = false, reverse: reverse = false, voids: voids = false, ignoreNonSelectable: ignoreNonSelectable = false } = options;
        var { match: match } = options;
        if (!match) match = ()=>true;
        if (!at) return;
        var from;
        var to;
        if ($786b46ea7ddafaee$export$5f1714a13ed34c01.isSpan(at)) {
            from = at[0];
            to = at[1];
        } else {
            var first = $786b46ea7ddafaee$export$7cda8d932e2f33c0.path(editor, at, {
                edge: "start"
            });
            var last = $786b46ea7ddafaee$export$7cda8d932e2f33c0.path(editor, at, {
                edge: "end"
            });
            from = reverse ? last : first;
            to = reverse ? first : last;
        }
        var nodeEntries = $786b46ea7ddafaee$export$85c928794f8d04d4.nodes(editor, {
            reverse: reverse,
            from: from,
            to: to,
            pass: (_ref)=>{
                var [node] = _ref;
                if (!$786b46ea7ddafaee$export$db77ccec0bb4ccac.isElement(node)) return false;
                if (!voids && ($786b46ea7ddafaee$export$7cda8d932e2f33c0.isVoid(editor, node) || $786b46ea7ddafaee$export$7cda8d932e2f33c0.isElementReadOnly(editor, node))) return true;
                if (ignoreNonSelectable && !$786b46ea7ddafaee$export$7cda8d932e2f33c0.isSelectable(editor, node)) return true;
                return false;
            }
        });
        var matches = [];
        var hit;
        for (var [node, path] of nodeEntries){
            if (ignoreNonSelectable && $786b46ea7ddafaee$export$db77ccec0bb4ccac.isElement(node) && !$786b46ea7ddafaee$export$7cda8d932e2f33c0.isSelectable(editor, node)) continue;
            var isLower = hit && $786b46ea7ddafaee$export$4b2950bdac9b6ee9.compare(path, hit[1]) === 0;
            // In highest mode any node lower than the last hit is not a match.
            if (mode === "highest" && isLower) continue;
            if (!match(node, path)) {
                // If we've arrived at a leaf text node that is not lower than the last
                // hit, then we've found a branch that doesn't include a match, which
                // means the match is not universal.
                if (universal && !isLower && $786b46ea7ddafaee$export$5f1af8db9871e1d6.isText(node)) return;
                else continue;
            }
            // If there's a match and it's lower than the last, update the hit.
            if (mode === "lowest" && isLower) {
                hit = [
                    node,
                    path
                ];
                continue;
            }
            // In lowest mode we emit the last hit, once it's guaranteed lowest.
            var emit = mode === "lowest" ? hit : [
                node,
                path
            ];
            if (emit) {
                if (universal) matches.push(emit);
                else yield emit;
            }
            hit = [
                node,
                path
            ];
        }
        // Since lowest is always emitting one behind, catch up at the end.
        if (mode === "lowest" && hit) {
            if (universal) matches.push(hit);
            else yield hit;
        }
        // Universal defers to ensure that the match occurs in every branch, so we
        // yield all of the matches after iterating.
        if (universal) yield* matches;
    }();
}
var $786b46ea7ddafaee$export$a3295358bff77e = function normalize(editor) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var { force: force = false, operation: operation } = options;
    var getDirtyPaths = (editor)=>{
        return $786b46ea7ddafaee$var$DIRTY_PATHS.get(editor) || [];
    };
    var getDirtyPathKeys = (editor)=>{
        return $786b46ea7ddafaee$var$DIRTY_PATH_KEYS.get(editor) || new Set();
    };
    var popDirtyPath = (editor)=>{
        var path = getDirtyPaths(editor).pop();
        var key = path.join(",");
        getDirtyPathKeys(editor).delete(key);
        return path;
    };
    if (!$786b46ea7ddafaee$export$7cda8d932e2f33c0.isNormalizing(editor)) return;
    if (force) {
        var allPaths = Array.from($786b46ea7ddafaee$export$85c928794f8d04d4.nodes(editor), (_ref)=>{
            var [, p] = _ref;
            return p;
        });
        var allPathKeys = new Set(allPaths.map((p)=>p.join(",")));
        $786b46ea7ddafaee$var$DIRTY_PATHS.set(editor, allPaths);
        $786b46ea7ddafaee$var$DIRTY_PATH_KEYS.set(editor, allPathKeys);
    }
    if (getDirtyPaths(editor).length === 0) return;
    $786b46ea7ddafaee$export$7cda8d932e2f33c0.withoutNormalizing(editor, ()=>{
        /*
      Fix dirty elements with no children.
      editor.normalizeNode() does fix this, but some normalization fixes also require it to work.
      Running an initial pass avoids the catch-22 race condition.
    */ for (var dirtyPath of getDirtyPaths(editor))if ($786b46ea7ddafaee$export$85c928794f8d04d4.has(editor, dirtyPath)) {
            var entry = $786b46ea7ddafaee$export$7cda8d932e2f33c0.node(editor, dirtyPath);
            var [node, _] = entry;
            /*
          The default normalizer inserts an empty text node in this scenario, but it can be customised.
          So there is some risk here.
                   As long as the normalizer only inserts child nodes for this case it is safe to do in any order;
          by definition adding children to an empty node can't cause other paths to change.
        */ if ($786b46ea7ddafaee$export$db77ccec0bb4ccac.isElement(node) && node.children.length === 0) editor.normalizeNode(entry, {
                operation: operation
            });
        }
        var dirtyPaths = getDirtyPaths(editor);
        var initialDirtyPathsLength = dirtyPaths.length;
        var iteration = 0;
        while(dirtyPaths.length !== 0){
            if (!editor.shouldNormalize({
                dirtyPaths: dirtyPaths,
                iteration: iteration,
                initialDirtyPathsLength: initialDirtyPathsLength,
                operation: operation
            })) return;
            var _dirtyPath = popDirtyPath(editor);
            // If the node doesn't exist in the tree, it does not need to be normalized.
            if ($786b46ea7ddafaee$export$85c928794f8d04d4.has(editor, _dirtyPath)) {
                var _entry = $786b46ea7ddafaee$export$7cda8d932e2f33c0.node(editor, _dirtyPath);
                editor.normalizeNode(_entry, {
                    operation: operation
                });
            }
            iteration++;
            dirtyPaths = getDirtyPaths(editor);
        }
    });
};
var $786b46ea7ddafaee$export$91124bb58bc04465 = function parent(editor, at) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var path = $786b46ea7ddafaee$export$7cda8d932e2f33c0.path(editor, at, options);
    var parentPath = $786b46ea7ddafaee$export$4b2950bdac9b6ee9.parent(path);
    var entry = $786b46ea7ddafaee$export$7cda8d932e2f33c0.node(editor, parentPath);
    return entry;
};
var $786b46ea7ddafaee$export$52534ff19b1ca625 = function pathRef(editor, path) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var { affinity: affinity = "forward" } = options;
    var ref = {
        current: path,
        affinity: affinity,
        unref () {
            var { current: current } = ref;
            var pathRefs = $786b46ea7ddafaee$export$7cda8d932e2f33c0.pathRefs(editor);
            pathRefs.delete(ref);
            ref.current = null;
            return current;
        }
    };
    var refs = $786b46ea7ddafaee$export$7cda8d932e2f33c0.pathRefs(editor);
    refs.add(ref);
    return ref;
};
var $786b46ea7ddafaee$export$26cece2e9e7da5a5 = (editor)=>{
    var refs = $786b46ea7ddafaee$var$PATH_REFS.get(editor);
    if (!refs) {
        refs = new Set();
        $786b46ea7ddafaee$var$PATH_REFS.set(editor, refs);
    }
    return refs;
};
var $786b46ea7ddafaee$export$bb654e07daaf8c3a = function path(editor, at) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var { depth: depth, edge: edge } = options;
    if ($786b46ea7ddafaee$export$4b2950bdac9b6ee9.isPath(at)) {
        if (edge === "start") {
            var [, firstPath] = $786b46ea7ddafaee$export$85c928794f8d04d4.first(editor, at);
            at = firstPath;
        } else if (edge === "end") {
            var [, lastPath] = $786b46ea7ddafaee$export$85c928794f8d04d4.last(editor, at);
            at = lastPath;
        }
    }
    if ($786b46ea7ddafaee$export$9a58ef0d7ad3278c.isRange(at)) {
        if (edge === "start") at = $786b46ea7ddafaee$export$9a58ef0d7ad3278c.start(at);
        else if (edge === "end") at = $786b46ea7ddafaee$export$9a58ef0d7ad3278c.end(at);
        else at = $786b46ea7ddafaee$export$4b2950bdac9b6ee9.common(at.anchor.path, at.focus.path);
    }
    if ($786b46ea7ddafaee$export$baf26146a414f24a.isPoint(at)) at = at.path;
    if (depth != null) at = at.slice(0, depth);
    return at;
};
var $786b46ea7ddafaee$export$9b86f3b8771165fe = function pointRef(editor, point) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var { affinity: affinity = "forward" } = options;
    var ref = {
        current: point,
        affinity: affinity,
        unref () {
            var { current: current } = ref;
            var pointRefs = $786b46ea7ddafaee$export$7cda8d932e2f33c0.pointRefs(editor);
            pointRefs.delete(ref);
            ref.current = null;
            return current;
        }
    };
    var refs = $786b46ea7ddafaee$export$7cda8d932e2f33c0.pointRefs(editor);
    refs.add(ref);
    return ref;
};
var $786b46ea7ddafaee$export$d0cf3b1b1f3deaba = (editor)=>{
    var refs = $786b46ea7ddafaee$var$POINT_REFS.get(editor);
    if (!refs) {
        refs = new Set();
        $786b46ea7ddafaee$var$POINT_REFS.set(editor, refs);
    }
    return refs;
};
var $786b46ea7ddafaee$export$105684a3041cb6f3 = function point(editor, at) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var { edge: edge = "start" } = options;
    if ($786b46ea7ddafaee$export$4b2950bdac9b6ee9.isPath(at)) {
        var path;
        if (edge === "end") {
            var [, lastPath] = $786b46ea7ddafaee$export$85c928794f8d04d4.last(editor, at);
            path = lastPath;
        } else {
            var [, firstPath] = $786b46ea7ddafaee$export$85c928794f8d04d4.first(editor, at);
            path = firstPath;
        }
        var node = $786b46ea7ddafaee$export$85c928794f8d04d4.get(editor, path);
        if (!$786b46ea7ddafaee$export$5f1af8db9871e1d6.isText(node)) throw new Error("Cannot get the ".concat(edge, " point in the node at path [").concat(at, "] because it has no ").concat(edge, " text node."));
        return {
            path: path,
            offset: edge === "end" ? node.text.length : 0
        };
    }
    if ($786b46ea7ddafaee$export$9a58ef0d7ad3278c.isRange(at)) {
        var [start, end] = $786b46ea7ddafaee$export$9a58ef0d7ad3278c.edges(at);
        return edge === "start" ? start : end;
    }
    return at;
};
function $786b46ea7ddafaee$export$878041e1e4cd4218(editor) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return function*() {
        var { at: at = editor.selection, unit: unit = "offset", reverse: reverse = false, voids: voids = false, ignoreNonSelectable: ignoreNonSelectable = false } = options;
        if (!at) return;
        /**
     * Algorithm notes:
     *
     * Each step `distance` is dynamic depending on the underlying text
     * and the `unit` specified.  Each step, e.g., a line or word, may
     * span multiple text nodes, so we iterate through the text both on
     * two levels in step-sync:
     *
     * `leafText` stores the text on a text leaf level, and is advanced
     * through using the counters `leafTextOffset` and `leafTextRemaining`.
     *
     * `blockText` stores the text on a block level, and is shortened
     * by `distance` every time it is advanced.
     *
     * We only maintain a window of one blockText and one leafText because
     * a block node always appears before all of its leaf nodes.
     */ var range = $786b46ea7ddafaee$export$7cda8d932e2f33c0.range(editor, at);
        var [start, end] = $786b46ea7ddafaee$export$9a58ef0d7ad3278c.edges(range);
        var first = reverse ? end : start;
        var isNewBlock = false;
        var blockText = "";
        var distance = 0; // Distance for leafText to catch up to blockText.
        var leafTextRemaining = 0;
        var leafTextOffset = 0;
        // Iterate through all nodes in range, grabbing entire textual content
        // of block nodes in blockText, and text nodes in leafText.
        // Exploits the fact that nodes are sequenced in such a way that we first
        // encounter the block node, then all of its text nodes, so when iterating
        // through the blockText and leafText we just need to remember a window of
        // one block node and leaf node, respectively.
        for (var [node, path] of $786b46ea7ddafaee$export$7cda8d932e2f33c0.nodes(editor, {
            at: at,
            reverse: reverse,
            voids: voids,
            ignoreNonSelectable: ignoreNonSelectable
        })){
            /*
       * ELEMENT NODE - Yield position(s) for voids, collect blockText for blocks
       */ if ($786b46ea7ddafaee$export$db77ccec0bb4ccac.isElement(node)) {
                // Void nodes are a special case, so by default we will always
                // yield their first point. If the `voids` option is set to true,
                // then we will iterate over their content.
                if (!voids && (editor.isVoid(node) || editor.isElementReadOnly(node))) {
                    yield $786b46ea7ddafaee$export$7cda8d932e2f33c0.start(editor, path);
                    continue;
                }
                // Inline element nodes are ignored as they don't themselves
                // contribute to `blockText` or `leafText` - their parent and
                // children do.
                if (editor.isInline(node)) continue;
                // Block element node - set `blockText` to its text content.
                if ($786b46ea7ddafaee$export$7cda8d932e2f33c0.hasInlines(editor, node)) {
                    // We always exhaust block nodes before encountering a new one:
                    //   console.assert(blockText === '',
                    //     `blockText='${blockText}' - `+
                    //     `not exhausted before new block node`, path)
                    // Ensure range considered is capped to `range`, in the
                    // start/end edge cases where block extends beyond range.
                    // Equivalent to this, but presumably more performant:
                    //   blockRange = Editor.range(editor, ...Editor.edges(editor, path))
                    //   blockRange = Range.intersection(range, blockRange) // intersect
                    //   blockText = Editor.string(editor, blockRange, { voids })
                    var e = $786b46ea7ddafaee$export$4b2950bdac9b6ee9.isAncestor(path, end.path) ? end : $786b46ea7ddafaee$export$7cda8d932e2f33c0.end(editor, path);
                    var s = $786b46ea7ddafaee$export$4b2950bdac9b6ee9.isAncestor(path, start.path) ? start : $786b46ea7ddafaee$export$7cda8d932e2f33c0.start(editor, path);
                    blockText = $786b46ea7ddafaee$export$7cda8d932e2f33c0.string(editor, {
                        anchor: s,
                        focus: e
                    }, {
                        voids: voids
                    });
                    isNewBlock = true;
                }
            }
            /*
       * TEXT LEAF NODE - Iterate through text content, yielding
       * positions every `distance` offset according to `unit`.
       */ if ($786b46ea7ddafaee$export$5f1af8db9871e1d6.isText(node)) {
                var isFirst = $786b46ea7ddafaee$export$4b2950bdac9b6ee9.equals(path, first.path);
                // Proof that we always exhaust text nodes before encountering a new one:
                //   console.assert(leafTextRemaining <= 0,
                //     `leafTextRemaining=${leafTextRemaining} - `+
                //     `not exhausted before new leaf text node`, path)
                // Reset `leafText` counters for new text node.
                if (isFirst) {
                    leafTextRemaining = reverse ? first.offset : node.text.length - first.offset;
                    leafTextOffset = first.offset; // Works for reverse too.
                } else {
                    leafTextRemaining = node.text.length;
                    leafTextOffset = reverse ? leafTextRemaining : 0;
                }
                // Yield position at the start of node (potentially).
                if (isFirst || isNewBlock || unit === "offset") {
                    yield {
                        path: path,
                        offset: leafTextOffset
                    };
                    isNewBlock = false;
                }
                // Yield positions every (dynamically calculated) `distance` offset.
                while(true){
                    // If `leafText` has caught up with `blockText` (distance=0),
                    // and if blockText is exhausted, break to get another block node,
                    // otherwise advance blockText forward by the new `distance`.
                    if (distance === 0) {
                        if (blockText === "") break;
                        distance = calcDistance(blockText, unit, reverse);
                        // Split the string at the previously found distance and use the
                        // remaining string for the next iteration.
                        blockText = $786b46ea7ddafaee$var$splitByCharacterDistance(blockText, distance, reverse)[1];
                    }
                    // Advance `leafText` by the current `distance`.
                    leafTextOffset = reverse ? leafTextOffset - distance : leafTextOffset + distance;
                    leafTextRemaining = leafTextRemaining - distance;
                    // If `leafText` is exhausted, break to get a new leaf node
                    // and set distance to the overflow amount, so we'll (maybe)
                    // catch up to blockText in the next leaf text node.
                    if (leafTextRemaining < 0) {
                        distance = -leafTextRemaining;
                        break;
                    }
                    // Successfully walked `distance` offsets through `leafText`
                    // to catch up with `blockText`, so we can reset `distance`
                    // and yield this position in this node.
                    distance = 0;
                    yield {
                        path: path,
                        offset: leafTextOffset
                    };
                }
            }
        }
        // Proof that upon completion, we've exahusted both leaf and block text:
        //   console.assert(leafTextRemaining <= 0, "leafText wasn't exhausted")
        //   console.assert(blockText === '', "blockText wasn't exhausted")
        // Helper:
        // Return the distance in offsets for a step of size `unit` on given string.
        function calcDistance(text, unit, reverse) {
            if (unit === "character") return $786b46ea7ddafaee$var$getCharacterDistance(text, reverse);
            else if (unit === "word") return $786b46ea7ddafaee$var$getWordDistance(text, reverse);
            else if (unit === "line" || unit === "block") return text.length;
            return 1;
        }
    }();
}
var $786b46ea7ddafaee$export$3abb7e718992aa6e = function previous(editor) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var { mode: mode = "lowest", voids: voids = false } = options;
    var { match: match, at: at = editor.selection } = options;
    if (!at) return;
    var pointBeforeLocation = $786b46ea7ddafaee$export$7cda8d932e2f33c0.before(editor, at, {
        voids: voids
    });
    if (!pointBeforeLocation) return;
    var [, to] = $786b46ea7ddafaee$export$7cda8d932e2f33c0.first(editor, []);
    // The search location is from the start of the document to the path of
    // the point before the location passed in
    var span = [
        pointBeforeLocation.path,
        to
    ];
    if ($786b46ea7ddafaee$export$4b2950bdac9b6ee9.isPath(at) && at.length === 0) throw new Error("Cannot get the previous node from the root node!");
    if (match == null) {
        if ($786b46ea7ddafaee$export$4b2950bdac9b6ee9.isPath(at)) {
            var [parent] = $786b46ea7ddafaee$export$7cda8d932e2f33c0.parent(editor, at);
            match = (n)=>parent.children.includes(n);
        } else match = ()=>true;
    }
    var [previous] = $786b46ea7ddafaee$export$7cda8d932e2f33c0.nodes(editor, {
        reverse: true,
        at: span,
        match: match,
        mode: mode,
        voids: voids
    });
    return previous;
};
var $786b46ea7ddafaee$export$d9cd3b5ae0eb95d1 = function rangeRef(editor, range) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var { affinity: affinity = "forward" } = options;
    var ref = {
        current: range,
        affinity: affinity,
        unref () {
            var { current: current } = ref;
            var rangeRefs = $786b46ea7ddafaee$export$7cda8d932e2f33c0.rangeRefs(editor);
            rangeRefs.delete(ref);
            ref.current = null;
            return current;
        }
    };
    var refs = $786b46ea7ddafaee$export$7cda8d932e2f33c0.rangeRefs(editor);
    refs.add(ref);
    return ref;
};
var $786b46ea7ddafaee$export$9a23b22fca0fae65 = (editor)=>{
    var refs = $786b46ea7ddafaee$var$RANGE_REFS.get(editor);
    if (!refs) {
        refs = new Set();
        $786b46ea7ddafaee$var$RANGE_REFS.set(editor, refs);
    }
    return refs;
};
var $786b46ea7ddafaee$export$d02631cccf789723 = (editor, at, to)=>{
    if ($786b46ea7ddafaee$export$9a58ef0d7ad3278c.isRange(at) && !to) return at;
    var start = $786b46ea7ddafaee$export$7cda8d932e2f33c0.start(editor, at);
    var end = $786b46ea7ddafaee$export$7cda8d932e2f33c0.end(editor, to || at);
    return {
        anchor: start,
        focus: end
    };
};
function $786b46ea7ddafaee$var$ownKeys$2(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $786b46ea7ddafaee$var$_objectSpread$2(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $786b46ea7ddafaee$var$ownKeys$2(Object(t), !0).forEach(function(r) {
            $786b46ea7ddafaee$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $786b46ea7ddafaee$var$ownKeys$2(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $786b46ea7ddafaee$export$5c9d031211c1b7c9 = (editor, key)=>{
    var { selection: selection } = editor;
    if (selection) {
        var match = (node, path)=>{
            if (!$786b46ea7ddafaee$export$5f1af8db9871e1d6.isText(node)) return false; // marks can only be applied to text
            var [parentNode, parentPath] = $786b46ea7ddafaee$export$7cda8d932e2f33c0.parent(editor, path);
            return !editor.isVoid(parentNode) || editor.markableVoid(parentNode);
        };
        var expandedSelection = $786b46ea7ddafaee$export$9a58ef0d7ad3278c.isExpanded(selection);
        var markAcceptingVoidSelected = false;
        if (!expandedSelection) {
            var [selectedNode, selectedPath] = $786b46ea7ddafaee$export$7cda8d932e2f33c0.node(editor, selection);
            if (selectedNode && match(selectedNode, selectedPath)) {
                var [parentNode] = $786b46ea7ddafaee$export$7cda8d932e2f33c0.parent(editor, selectedPath);
                markAcceptingVoidSelected = parentNode && editor.markableVoid(parentNode);
            }
        }
        if (expandedSelection || markAcceptingVoidSelected) $786b46ea7ddafaee$export$2e7e2a6179fcdd5c.unsetNodes(editor, key, {
            match: match,
            split: true,
            voids: true
        });
        else {
            var marks = $786b46ea7ddafaee$var$_objectSpread$2({}, $786b46ea7ddafaee$export$7cda8d932e2f33c0.marks(editor) || {});
            delete marks[key];
            editor.marks = marks;
            if (!$786b46ea7ddafaee$var$FLUSHING.get(editor)) editor.onChange();
        }
    }
};
var $786b46ea7ddafaee$export$7d41de07b364f759 = (editor, isNormalizing)=>{
    $786b46ea7ddafaee$var$NORMALIZING.set(editor, isNormalizing);
};
var $786b46ea7ddafaee$export$b3571188c770cc5a = (editor, at)=>{
    return $786b46ea7ddafaee$export$7cda8d932e2f33c0.point(editor, at, {
        edge: "start"
    });
};
var $786b46ea7ddafaee$export$22b082955e083ec3 = function string(editor, at) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var { voids: voids = false } = options;
    var range = $786b46ea7ddafaee$export$7cda8d932e2f33c0.range(editor, at);
    var [start, end] = $786b46ea7ddafaee$export$9a58ef0d7ad3278c.edges(range);
    var text = "";
    for (var [node, path] of $786b46ea7ddafaee$export$7cda8d932e2f33c0.nodes(editor, {
        at: range,
        match: $786b46ea7ddafaee$export$5f1af8db9871e1d6.isText,
        voids: voids
    })){
        var t = node.text;
        if ($786b46ea7ddafaee$export$4b2950bdac9b6ee9.equals(path, end.path)) t = t.slice(0, end.offset);
        if ($786b46ea7ddafaee$export$4b2950bdac9b6ee9.equals(path, start.path)) t = t.slice(start.offset);
        text += t;
    }
    return text;
};
var $786b46ea7ddafaee$export$5bbda963d3cff9cf = function unhangRange(editor, range) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var { voids: voids = false } = options;
    var [start, end] = $786b46ea7ddafaee$export$9a58ef0d7ad3278c.edges(range);
    // PERF: exit early if we can guarantee that the range isn't hanging.
    if (start.offset !== 0 || end.offset !== 0 || $786b46ea7ddafaee$export$9a58ef0d7ad3278c.isCollapsed(range) || $786b46ea7ddafaee$export$4b2950bdac9b6ee9.hasPrevious(end.path)) return range;
    var endBlock = $786b46ea7ddafaee$export$7cda8d932e2f33c0.above(editor, {
        at: end,
        match: (n)=>$786b46ea7ddafaee$export$db77ccec0bb4ccac.isElement(n) && $786b46ea7ddafaee$export$7cda8d932e2f33c0.isBlock(editor, n),
        voids: voids
    });
    var blockPath = endBlock ? endBlock[1] : [];
    var first = $786b46ea7ddafaee$export$7cda8d932e2f33c0.start(editor, start);
    var before = {
        anchor: first,
        focus: end
    };
    var skip = true;
    for (var [node, path] of $786b46ea7ddafaee$export$7cda8d932e2f33c0.nodes(editor, {
        at: before,
        match: $786b46ea7ddafaee$export$5f1af8db9871e1d6.isText,
        reverse: true,
        voids: voids
    })){
        if (skip) {
            skip = false;
            continue;
        }
        if (node.text !== "" || $786b46ea7ddafaee$export$4b2950bdac9b6ee9.isBefore(path, blockPath)) {
            end = {
                path: path,
                offset: node.text.length
            };
            break;
        }
    }
    return {
        anchor: start,
        focus: end
    };
};
var $786b46ea7ddafaee$export$2a1709eb902e594d = (editor, fn)=>{
    var value = $786b46ea7ddafaee$export$7cda8d932e2f33c0.isNormalizing(editor);
    $786b46ea7ddafaee$export$7cda8d932e2f33c0.setNormalizing(editor, false);
    try {
        fn();
    } finally{
        $786b46ea7ddafaee$export$7cda8d932e2f33c0.setNormalizing(editor, value);
    }
    $786b46ea7ddafaee$export$7cda8d932e2f33c0.normalize(editor);
};
var $786b46ea7ddafaee$export$efaf25ec32264289 = (editor, _ref, _ref2)=>{
    var [prevNode, prevPath] = _ref;
    // If the target node that we're merging with is empty, remove it instead
    // of merging the two. This is a common rich text editor behavior to
    // prevent losing formatting when deleting entire nodes when you have a
    // hanging selection.
    // if prevNode is first child in parent,don't remove it.
    return $786b46ea7ddafaee$export$db77ccec0bb4ccac.isElement(prevNode) && $786b46ea7ddafaee$export$7cda8d932e2f33c0.isEmpty(editor, prevNode) || $786b46ea7ddafaee$export$5f1af8db9871e1d6.isText(prevNode) && prevNode.text === "" && prevPath[prevPath.length - 1] !== 0;
};
var $786b46ea7ddafaee$export$69b97c52b23537e1 = function deleteText(editor) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    $786b46ea7ddafaee$export$7cda8d932e2f33c0.withoutNormalizing(editor, ()=>{
        var _Editor$void, _Editor$void2;
        var { reverse: reverse = false, unit: unit = "character", distance: distance = 1, voids: voids = false } = options;
        var { at: at = editor.selection, hanging: hanging = false } = options;
        if (!at) return;
        var isCollapsed = false;
        if ($786b46ea7ddafaee$export$9a58ef0d7ad3278c.isRange(at) && $786b46ea7ddafaee$export$9a58ef0d7ad3278c.isCollapsed(at)) {
            isCollapsed = true;
            at = at.anchor;
        }
        if ($786b46ea7ddafaee$export$baf26146a414f24a.isPoint(at)) {
            var furthestVoid = $786b46ea7ddafaee$export$7cda8d932e2f33c0.void(editor, {
                at: at,
                mode: "highest"
            });
            if (!voids && furthestVoid) {
                var [, voidPath] = furthestVoid;
                at = voidPath;
            } else {
                var opts = {
                    unit: unit,
                    distance: distance
                };
                var target = reverse ? $786b46ea7ddafaee$export$7cda8d932e2f33c0.before(editor, at, opts) || $786b46ea7ddafaee$export$7cda8d932e2f33c0.start(editor, []) : $786b46ea7ddafaee$export$7cda8d932e2f33c0.after(editor, at, opts) || $786b46ea7ddafaee$export$7cda8d932e2f33c0.end(editor, []);
                at = {
                    anchor: at,
                    focus: target
                };
                hanging = true;
            }
        }
        if ($786b46ea7ddafaee$export$4b2950bdac9b6ee9.isPath(at)) {
            $786b46ea7ddafaee$export$2e7e2a6179fcdd5c.removeNodes(editor, {
                at: at,
                voids: voids
            });
            return;
        }
        if ($786b46ea7ddafaee$export$9a58ef0d7ad3278c.isCollapsed(at)) return;
        if (!hanging) {
            var [, _end] = $786b46ea7ddafaee$export$9a58ef0d7ad3278c.edges(at);
            var endOfDoc = $786b46ea7ddafaee$export$7cda8d932e2f33c0.end(editor, []);
            if (!$786b46ea7ddafaee$export$baf26146a414f24a.equals(_end, endOfDoc)) at = $786b46ea7ddafaee$export$7cda8d932e2f33c0.unhangRange(editor, at, {
                voids: voids
            });
        }
        var [start, end] = $786b46ea7ddafaee$export$9a58ef0d7ad3278c.edges(at);
        var startBlock = $786b46ea7ddafaee$export$7cda8d932e2f33c0.above(editor, {
            match: (n)=>$786b46ea7ddafaee$export$db77ccec0bb4ccac.isElement(n) && $786b46ea7ddafaee$export$7cda8d932e2f33c0.isBlock(editor, n),
            at: start,
            voids: voids
        });
        var endBlock = $786b46ea7ddafaee$export$7cda8d932e2f33c0.above(editor, {
            match: (n)=>$786b46ea7ddafaee$export$db77ccec0bb4ccac.isElement(n) && $786b46ea7ddafaee$export$7cda8d932e2f33c0.isBlock(editor, n),
            at: end,
            voids: voids
        });
        var isAcrossBlocks = startBlock && endBlock && !$786b46ea7ddafaee$export$4b2950bdac9b6ee9.equals(startBlock[1], endBlock[1]);
        var isSingleText = $786b46ea7ddafaee$export$4b2950bdac9b6ee9.equals(start.path, end.path);
        var startNonEditable = voids ? null : (_Editor$void = $786b46ea7ddafaee$export$7cda8d932e2f33c0.void(editor, {
            at: start,
            mode: "highest"
        })) !== null && _Editor$void !== void 0 ? _Editor$void : $786b46ea7ddafaee$export$7cda8d932e2f33c0.elementReadOnly(editor, {
            at: start,
            mode: "highest"
        });
        var endNonEditable = voids ? null : (_Editor$void2 = $786b46ea7ddafaee$export$7cda8d932e2f33c0.void(editor, {
            at: end,
            mode: "highest"
        })) !== null && _Editor$void2 !== void 0 ? _Editor$void2 : $786b46ea7ddafaee$export$7cda8d932e2f33c0.elementReadOnly(editor, {
            at: end,
            mode: "highest"
        });
        // If the start or end points are inside an inline void, nudge them out.
        if (startNonEditable) {
            var before = $786b46ea7ddafaee$export$7cda8d932e2f33c0.before(editor, start);
            if (before && startBlock && $786b46ea7ddafaee$export$4b2950bdac9b6ee9.isAncestor(startBlock[1], before.path)) start = before;
        }
        if (endNonEditable) {
            var after = $786b46ea7ddafaee$export$7cda8d932e2f33c0.after(editor, end);
            if (after && endBlock && $786b46ea7ddafaee$export$4b2950bdac9b6ee9.isAncestor(endBlock[1], after.path)) end = after;
        }
        // Get the highest nodes that are completely inside the range, as well as
        // the start and end nodes.
        var matches = [];
        var lastPath;
        for (var entry of $786b46ea7ddafaee$export$7cda8d932e2f33c0.nodes(editor, {
            at: at,
            voids: voids
        })){
            var [node, path] = entry;
            if (lastPath && $786b46ea7ddafaee$export$4b2950bdac9b6ee9.compare(path, lastPath) === 0) continue;
            if (!voids && $786b46ea7ddafaee$export$db77ccec0bb4ccac.isElement(node) && ($786b46ea7ddafaee$export$7cda8d932e2f33c0.isVoid(editor, node) || $786b46ea7ddafaee$export$7cda8d932e2f33c0.isElementReadOnly(editor, node)) || !$786b46ea7ddafaee$export$4b2950bdac9b6ee9.isCommon(path, start.path) && !$786b46ea7ddafaee$export$4b2950bdac9b6ee9.isCommon(path, end.path)) {
                matches.push(entry);
                lastPath = path;
            }
        }
        var pathRefs = Array.from(matches, (_ref)=>{
            var [, p] = _ref;
            return $786b46ea7ddafaee$export$7cda8d932e2f33c0.pathRef(editor, p);
        });
        var startRef = $786b46ea7ddafaee$export$7cda8d932e2f33c0.pointRef(editor, start);
        var endRef = $786b46ea7ddafaee$export$7cda8d932e2f33c0.pointRef(editor, end);
        var removedText = "";
        if (!isSingleText && !startNonEditable) {
            var _point = startRef.current;
            var [_node] = $786b46ea7ddafaee$export$7cda8d932e2f33c0.leaf(editor, _point);
            var { path: _path } = _point;
            var { offset: offset } = start;
            var text = _node.text.slice(offset);
            if (text.length > 0) {
                editor.apply({
                    type: "remove_text",
                    path: _path,
                    offset: offset,
                    text: text
                });
                removedText = text;
            }
        }
        pathRefs.reverse().map((r)=>r.unref()).filter((r)=>r !== null).forEach((p)=>$786b46ea7ddafaee$export$2e7e2a6179fcdd5c.removeNodes(editor, {
                at: p,
                voids: voids
            }));
        if (!endNonEditable) {
            var _point2 = endRef.current;
            var [_node2] = $786b46ea7ddafaee$export$7cda8d932e2f33c0.leaf(editor, _point2);
            var { path: _path2 } = _point2;
            var _offset = isSingleText ? start.offset : 0;
            var _text = _node2.text.slice(_offset, end.offset);
            if (_text.length > 0) {
                editor.apply({
                    type: "remove_text",
                    path: _path2,
                    offset: _offset,
                    text: _text
                });
                removedText = _text;
            }
        }
        if (!isSingleText && isAcrossBlocks && endRef.current && startRef.current) $786b46ea7ddafaee$export$2e7e2a6179fcdd5c.mergeNodes(editor, {
            at: endRef.current,
            hanging: true,
            voids: voids
        });
        // For Thai script, deleting N character(s) backward should delete
        // N code point(s) instead of an entire grapheme cluster.
        // Therefore, the remaining code points should be inserted back.
        if (isCollapsed && reverse && unit === "character" && removedText.length > 1 && removedText.match(/[\u0E00-\u0E7F]+/)) $786b46ea7ddafaee$export$2e7e2a6179fcdd5c.insertText(editor, removedText.slice(0, removedText.length - distance));
        var startUnref = startRef.unref();
        var endUnref = endRef.unref();
        var point = reverse ? startUnref || endUnref : endUnref || startUnref;
        if (options.at == null && point) $786b46ea7ddafaee$export$2e7e2a6179fcdd5c.select(editor, point);
    });
};
var $786b46ea7ddafaee$export$88d0f1fc1c16e147 = function insertFragment(editor, fragment) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    $786b46ea7ddafaee$export$7cda8d932e2f33c0.withoutNormalizing(editor, ()=>{
        var { hanging: hanging = false, voids: voids = false } = options;
        var { at: at = $786b46ea7ddafaee$var$getDefaultInsertLocation(editor), batchDirty: batchDirty = true } = options;
        if (!fragment.length) return;
        if ($786b46ea7ddafaee$export$9a58ef0d7ad3278c.isRange(at)) {
            if (!hanging) at = $786b46ea7ddafaee$export$7cda8d932e2f33c0.unhangRange(editor, at, {
                voids: voids
            });
            if ($786b46ea7ddafaee$export$9a58ef0d7ad3278c.isCollapsed(at)) at = at.anchor;
            else {
                var [, end] = $786b46ea7ddafaee$export$9a58ef0d7ad3278c.edges(at);
                if (!voids && $786b46ea7ddafaee$export$7cda8d932e2f33c0.void(editor, {
                    at: end
                })) return;
                var pointRef = $786b46ea7ddafaee$export$7cda8d932e2f33c0.pointRef(editor, end);
                $786b46ea7ddafaee$export$2e7e2a6179fcdd5c.delete(editor, {
                    at: at
                });
                at = pointRef.unref();
            }
        } else if ($786b46ea7ddafaee$export$4b2950bdac9b6ee9.isPath(at)) at = $786b46ea7ddafaee$export$7cda8d932e2f33c0.start(editor, at);
        if (!voids && $786b46ea7ddafaee$export$7cda8d932e2f33c0.void(editor, {
            at: at
        })) return;
        // If the insert point is at the edge of an inline node, move it outside
        // instead since it will need to be split otherwise.
        var inlineElementMatch = $786b46ea7ddafaee$export$7cda8d932e2f33c0.above(editor, {
            at: at,
            match: (n)=>$786b46ea7ddafaee$export$db77ccec0bb4ccac.isElement(n) && $786b46ea7ddafaee$export$7cda8d932e2f33c0.isInline(editor, n),
            mode: "highest",
            voids: voids
        });
        if (inlineElementMatch) {
            var [, _inlinePath] = inlineElementMatch;
            if ($786b46ea7ddafaee$export$7cda8d932e2f33c0.isEnd(editor, at, _inlinePath)) {
                var after = $786b46ea7ddafaee$export$7cda8d932e2f33c0.after(editor, _inlinePath);
                at = after;
            } else if ($786b46ea7ddafaee$export$7cda8d932e2f33c0.isStart(editor, at, _inlinePath)) {
                var before = $786b46ea7ddafaee$export$7cda8d932e2f33c0.before(editor, _inlinePath);
                at = before;
            }
        }
        var blockMatch = $786b46ea7ddafaee$export$7cda8d932e2f33c0.above(editor, {
            match: (n)=>$786b46ea7ddafaee$export$db77ccec0bb4ccac.isElement(n) && $786b46ea7ddafaee$export$7cda8d932e2f33c0.isBlock(editor, n),
            at: at,
            voids: voids
        });
        var [, blockPath] = blockMatch;
        var isBlockStart = $786b46ea7ddafaee$export$7cda8d932e2f33c0.isStart(editor, at, blockPath);
        var isBlockEnd = $786b46ea7ddafaee$export$7cda8d932e2f33c0.isEnd(editor, at, blockPath);
        var isBlockEmpty = isBlockStart && isBlockEnd;
        var mergeStart = !isBlockStart || isBlockStart && isBlockEnd;
        var mergeEnd = !isBlockEnd;
        var [, firstPath] = $786b46ea7ddafaee$export$85c928794f8d04d4.first({
            children: fragment
        }, []);
        var [, lastPath] = $786b46ea7ddafaee$export$85c928794f8d04d4.last({
            children: fragment
        }, []);
        var matches = [];
        var matcher = (_ref)=>{
            var [n, p] = _ref;
            var isRoot = p.length === 0;
            if (isRoot) return false;
            if (isBlockEmpty) return true;
            if (mergeStart && $786b46ea7ddafaee$export$4b2950bdac9b6ee9.isAncestor(p, firstPath) && $786b46ea7ddafaee$export$db77ccec0bb4ccac.isElement(n) && !editor.isVoid(n) && !editor.isInline(n)) return false;
            if (mergeEnd && $786b46ea7ddafaee$export$4b2950bdac9b6ee9.isAncestor(p, lastPath) && $786b46ea7ddafaee$export$db77ccec0bb4ccac.isElement(n) && !editor.isVoid(n) && !editor.isInline(n)) return false;
            return true;
        };
        for (var entry of $786b46ea7ddafaee$export$85c928794f8d04d4.nodes({
            children: fragment
        }, {
            pass: matcher
        }))if (matcher(entry)) matches.push(entry);
        var starts = [];
        var middles = [];
        var ends = [];
        var starting = true;
        var hasBlocks = false;
        for (var [node] of matches){
            if ($786b46ea7ddafaee$export$db77ccec0bb4ccac.isElement(node) && !editor.isInline(node)) {
                starting = false;
                hasBlocks = true;
                middles.push(node);
            } else if (starting) starts.push(node);
            else ends.push(node);
        }
        var [inlineMatch] = $786b46ea7ddafaee$export$7cda8d932e2f33c0.nodes(editor, {
            at: at,
            match: (n)=>$786b46ea7ddafaee$export$5f1af8db9871e1d6.isText(n) || $786b46ea7ddafaee$export$7cda8d932e2f33c0.isInline(editor, n),
            mode: "highest",
            voids: voids
        });
        var [, inlinePath] = inlineMatch;
        var isInlineStart = $786b46ea7ddafaee$export$7cda8d932e2f33c0.isStart(editor, at, inlinePath);
        var isInlineEnd = $786b46ea7ddafaee$export$7cda8d932e2f33c0.isEnd(editor, at, inlinePath);
        var middleRef = $786b46ea7ddafaee$export$7cda8d932e2f33c0.pathRef(editor, isBlockEnd && !ends.length ? $786b46ea7ddafaee$export$4b2950bdac9b6ee9.next(blockPath) : blockPath);
        var endRef = $786b46ea7ddafaee$export$7cda8d932e2f33c0.pathRef(editor, isInlineEnd ? $786b46ea7ddafaee$export$4b2950bdac9b6ee9.next(inlinePath) : inlinePath);
        $786b46ea7ddafaee$export$2e7e2a6179fcdd5c.splitNodes(editor, {
            at: at,
            match: (n)=>hasBlocks ? $786b46ea7ddafaee$export$db77ccec0bb4ccac.isElement(n) && $786b46ea7ddafaee$export$7cda8d932e2f33c0.isBlock(editor, n) : $786b46ea7ddafaee$export$5f1af8db9871e1d6.isText(n) || $786b46ea7ddafaee$export$7cda8d932e2f33c0.isInline(editor, n),
            mode: hasBlocks ? "lowest" : "highest",
            always: hasBlocks && (!isBlockStart || starts.length > 0) && (!isBlockEnd || ends.length > 0),
            voids: voids
        });
        var startRef = $786b46ea7ddafaee$export$7cda8d932e2f33c0.pathRef(editor, !isInlineStart || isInlineStart && isInlineEnd ? $786b46ea7ddafaee$export$4b2950bdac9b6ee9.next(inlinePath) : inlinePath);
        $786b46ea7ddafaee$export$2e7e2a6179fcdd5c.insertNodes(editor, starts, {
            at: startRef.current,
            match: (n)=>$786b46ea7ddafaee$export$5f1af8db9871e1d6.isText(n) || $786b46ea7ddafaee$export$7cda8d932e2f33c0.isInline(editor, n),
            mode: "highest",
            voids: voids,
            batchDirty: batchDirty
        });
        if (isBlockEmpty && !starts.length && middles.length && !ends.length) $786b46ea7ddafaee$export$2e7e2a6179fcdd5c.delete(editor, {
            at: blockPath,
            voids: voids
        });
        $786b46ea7ddafaee$export$2e7e2a6179fcdd5c.insertNodes(editor, middles, {
            at: middleRef.current,
            match: (n)=>$786b46ea7ddafaee$export$db77ccec0bb4ccac.isElement(n) && $786b46ea7ddafaee$export$7cda8d932e2f33c0.isBlock(editor, n),
            mode: "lowest",
            voids: voids,
            batchDirty: batchDirty
        });
        $786b46ea7ddafaee$export$2e7e2a6179fcdd5c.insertNodes(editor, ends, {
            at: endRef.current,
            match: (n)=>$786b46ea7ddafaee$export$5f1af8db9871e1d6.isText(n) || $786b46ea7ddafaee$export$7cda8d932e2f33c0.isInline(editor, n),
            mode: "highest",
            voids: voids,
            batchDirty: batchDirty
        });
        if (!options.at) {
            var path;
            if (ends.length > 0 && endRef.current) path = $786b46ea7ddafaee$export$4b2950bdac9b6ee9.previous(endRef.current);
            else if (middles.length > 0 && middleRef.current) path = $786b46ea7ddafaee$export$4b2950bdac9b6ee9.previous(middleRef.current);
            else if (startRef.current) path = $786b46ea7ddafaee$export$4b2950bdac9b6ee9.previous(startRef.current);
            if (path) {
                var _end = $786b46ea7ddafaee$export$7cda8d932e2f33c0.end(editor, path);
                $786b46ea7ddafaee$export$2e7e2a6179fcdd5c.select(editor, _end);
            }
        }
        startRef.unref();
        middleRef.unref();
        endRef.unref();
    });
};
var $786b46ea7ddafaee$export$ec45920981e0ca9b = function collapse(editor) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var { edge: edge = "anchor" } = options;
    var { selection: selection } = editor;
    if (!selection) return;
    else if (edge === "anchor") $786b46ea7ddafaee$export$2e7e2a6179fcdd5c.select(editor, selection.anchor);
    else if (edge === "focus") $786b46ea7ddafaee$export$2e7e2a6179fcdd5c.select(editor, selection.focus);
    else if (edge === "start") {
        var [start] = $786b46ea7ddafaee$export$9a58ef0d7ad3278c.edges(selection);
        $786b46ea7ddafaee$export$2e7e2a6179fcdd5c.select(editor, start);
    } else if (edge === "end") {
        var [, end] = $786b46ea7ddafaee$export$9a58ef0d7ad3278c.edges(selection);
        $786b46ea7ddafaee$export$2e7e2a6179fcdd5c.select(editor, end);
    }
};
var $786b46ea7ddafaee$export$5bb86370ea51314a = (editor)=>{
    var { selection: selection } = editor;
    if (selection) editor.apply({
        type: "set_selection",
        properties: selection,
        newProperties: null
    });
};
var $786b46ea7ddafaee$export$d947e5f4f4c48d48 = function move(editor) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var { selection: selection } = editor;
    var { distance: distance = 1, unit: unit = "character", reverse: reverse = false } = options;
    var { edge: edge = null } = options;
    if (!selection) return;
    if (edge === "start") edge = $786b46ea7ddafaee$export$9a58ef0d7ad3278c.isBackward(selection) ? "focus" : "anchor";
    if (edge === "end") edge = $786b46ea7ddafaee$export$9a58ef0d7ad3278c.isBackward(selection) ? "anchor" : "focus";
    var { anchor: anchor, focus: focus } = selection;
    var opts = {
        distance: distance,
        unit: unit,
        ignoreNonSelectable: true
    };
    var props = {};
    if (edge == null || edge === "anchor") {
        var point = reverse ? $786b46ea7ddafaee$export$7cda8d932e2f33c0.before(editor, anchor, opts) : $786b46ea7ddafaee$export$7cda8d932e2f33c0.after(editor, anchor, opts);
        if (point) props.anchor = point;
    }
    if (edge == null || edge === "focus") {
        var _point = reverse ? $786b46ea7ddafaee$export$7cda8d932e2f33c0.before(editor, focus, opts) : $786b46ea7ddafaee$export$7cda8d932e2f33c0.after(editor, focus, opts);
        if (_point) props.focus = _point;
    }
    $786b46ea7ddafaee$export$2e7e2a6179fcdd5c.setSelection(editor, props);
};
var $786b46ea7ddafaee$export$2e6c959c16ff56b8 = (editor, target)=>{
    var { selection: selection } = editor;
    target = $786b46ea7ddafaee$export$7cda8d932e2f33c0.range(editor, target);
    if (selection) {
        $786b46ea7ddafaee$export$2e7e2a6179fcdd5c.setSelection(editor, target);
        return;
    }
    if (!$786b46ea7ddafaee$export$9a58ef0d7ad3278c.isRange(target)) throw new Error("When setting the selection and the current selection is `null` you must provide at least an `anchor` and `focus`, but you passed: ".concat($786b46ea7ddafaee$export$1e3096e79001f1db.stringify(target)));
    editor.apply({
        type: "set_selection",
        properties: selection,
        newProperties: target
    });
};
function $786b46ea7ddafaee$var$ownKeys$1(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $786b46ea7ddafaee$var$_objectSpread$1(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $786b46ea7ddafaee$var$ownKeys$1(Object(t), !0).forEach(function(r) {
            $786b46ea7ddafaee$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $786b46ea7ddafaee$var$ownKeys$1(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $786b46ea7ddafaee$export$f2cbf0fb72c305dd = function setPoint(editor, props) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var { selection: selection } = editor;
    var { edge: edge = "both" } = options;
    if (!selection) return;
    if (edge === "start") edge = $786b46ea7ddafaee$export$9a58ef0d7ad3278c.isBackward(selection) ? "focus" : "anchor";
    if (edge === "end") edge = $786b46ea7ddafaee$export$9a58ef0d7ad3278c.isBackward(selection) ? "anchor" : "focus";
    var { anchor: anchor, focus: focus } = selection;
    var point = edge === "anchor" ? anchor : focus;
    $786b46ea7ddafaee$export$2e7e2a6179fcdd5c.setSelection(editor, {
        [edge === "anchor" ? "anchor" : "focus"]: $786b46ea7ddafaee$var$_objectSpread$1($786b46ea7ddafaee$var$_objectSpread$1({}, point), props)
    });
};
var $786b46ea7ddafaee$export$f6e36f80a8190133 = (editor, props)=>{
    var { selection: selection } = editor;
    var oldProps = {};
    var newProps = {};
    if (!selection) return;
    for(var k in props)if (k === "anchor" && props.anchor != null && !$786b46ea7ddafaee$export$baf26146a414f24a.equals(props.anchor, selection.anchor) || k === "focus" && props.focus != null && !$786b46ea7ddafaee$export$baf26146a414f24a.equals(props.focus, selection.focus) || k !== "anchor" && k !== "focus" && props[k] !== selection[k]) {
        oldProps[k] = selection[k];
        newProps[k] = props[k];
    }
    if (Object.keys(oldProps).length > 0) editor.apply({
        type: "set_selection",
        properties: oldProps,
        newProperties: newProps
    });
};
var $786b46ea7ddafaee$export$a6177d5829f70ebc = function insertNodes(editor, nodes) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    $786b46ea7ddafaee$export$7cda8d932e2f33c0.withoutNormalizing(editor, ()=>{
        var { hanging: hanging = false, voids: voids = false, mode: mode = "lowest", batchDirty: batchDirty = true } = options;
        var { at: at, match: match, select: select } = options;
        if ($786b46ea7ddafaee$export$85c928794f8d04d4.isNode(nodes)) nodes = [
            nodes
        ];
        if (nodes.length === 0) return;
        var [node] = nodes;
        if (!at) {
            at = $786b46ea7ddafaee$var$getDefaultInsertLocation(editor);
            if (select !== false) select = true;
        }
        if (select == null) select = false;
        if ($786b46ea7ddafaee$export$9a58ef0d7ad3278c.isRange(at)) {
            if (!hanging) at = $786b46ea7ddafaee$export$7cda8d932e2f33c0.unhangRange(editor, at, {
                voids: voids
            });
            if ($786b46ea7ddafaee$export$9a58ef0d7ad3278c.isCollapsed(at)) at = at.anchor;
            else {
                var [, end] = $786b46ea7ddafaee$export$9a58ef0d7ad3278c.edges(at);
                var pointRef = $786b46ea7ddafaee$export$7cda8d932e2f33c0.pointRef(editor, end);
                $786b46ea7ddafaee$export$2e7e2a6179fcdd5c.delete(editor, {
                    at: at
                });
                at = pointRef.unref();
            }
        }
        if ($786b46ea7ddafaee$export$baf26146a414f24a.isPoint(at)) {
            if (match == null) {
                if ($786b46ea7ddafaee$export$5f1af8db9871e1d6.isText(node)) match = (n)=>$786b46ea7ddafaee$export$5f1af8db9871e1d6.isText(n);
                else if (editor.isInline(node)) match = (n)=>$786b46ea7ddafaee$export$5f1af8db9871e1d6.isText(n) || $786b46ea7ddafaee$export$7cda8d932e2f33c0.isInline(editor, n);
                else match = (n)=>$786b46ea7ddafaee$export$db77ccec0bb4ccac.isElement(n) && $786b46ea7ddafaee$export$7cda8d932e2f33c0.isBlock(editor, n);
            }
            var [entry] = $786b46ea7ddafaee$export$7cda8d932e2f33c0.nodes(editor, {
                at: at.path,
                match: match,
                mode: mode,
                voids: voids
            });
            if (entry) {
                var [, matchPath] = entry;
                var pathRef = $786b46ea7ddafaee$export$7cda8d932e2f33c0.pathRef(editor, matchPath);
                var isAtEnd = $786b46ea7ddafaee$export$7cda8d932e2f33c0.isEnd(editor, at, matchPath);
                $786b46ea7ddafaee$export$2e7e2a6179fcdd5c.splitNodes(editor, {
                    at: at,
                    match: match,
                    mode: mode,
                    voids: voids
                });
                var path = pathRef.unref();
                at = isAtEnd ? $786b46ea7ddafaee$export$4b2950bdac9b6ee9.next(path) : path;
            } else return;
        }
        var parentPath = $786b46ea7ddafaee$export$4b2950bdac9b6ee9.parent(at);
        var index = at[at.length - 1];
        if (!voids && $786b46ea7ddafaee$export$7cda8d932e2f33c0.void(editor, {
            at: parentPath
        })) return;
        if (batchDirty) {
            // PERF: batch update dirty paths
            // batched ops used to transform existing dirty paths
            var batchedOps = [];
            var newDirtyPaths = $786b46ea7ddafaee$export$4b2950bdac9b6ee9.levels(parentPath);
            $786b46ea7ddafaee$var$batchDirtyPaths(editor, ()=>{
                var _loop = function _loop() {
                    var path = parentPath.concat(index);
                    index++;
                    var op = {
                        type: "insert_node",
                        path: path,
                        node: _node
                    };
                    editor.apply(op);
                    at = $786b46ea7ddafaee$export$4b2950bdac9b6ee9.next(at);
                    batchedOps.push(op);
                    if (!$786b46ea7ddafaee$export$5f1af8db9871e1d6.isText) newDirtyPaths.push(path);
                    else newDirtyPaths.push(...Array.from($786b46ea7ddafaee$export$85c928794f8d04d4.nodes(_node), (_ref)=>{
                        var [, p] = _ref;
                        return path.concat(p);
                    }));
                };
                for (var _node of nodes)_loop();
            }, ()=>{
                $786b46ea7ddafaee$var$updateDirtyPaths(editor, newDirtyPaths, (p)=>{
                    var newPath = p;
                    for (var op of batchedOps)if ($786b46ea7ddafaee$export$4b2950bdac9b6ee9.operationCanTransformPath(op)) {
                        newPath = $786b46ea7ddafaee$export$4b2950bdac9b6ee9.transform(newPath, op);
                        if (!newPath) return null;
                    }
                    return newPath;
                });
            });
        } else for (var _node2 of nodes){
            var _path = parentPath.concat(index);
            index++;
            editor.apply({
                type: "insert_node",
                path: _path,
                node: _node2
            });
            at = $786b46ea7ddafaee$export$4b2950bdac9b6ee9.next(at);
        }
        at = $786b46ea7ddafaee$export$4b2950bdac9b6ee9.previous(at);
        if (select) {
            var point = $786b46ea7ddafaee$export$7cda8d932e2f33c0.end(editor, at);
            if (point) $786b46ea7ddafaee$export$2e7e2a6179fcdd5c.select(editor, point);
        }
    });
};
var $786b46ea7ddafaee$export$a3cae1b703a549d3 = function liftNodes(editor) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    $786b46ea7ddafaee$export$7cda8d932e2f33c0.withoutNormalizing(editor, ()=>{
        var { at: at = editor.selection, mode: mode = "lowest", voids: voids = false } = options;
        var { match: match } = options;
        if (match == null) match = $786b46ea7ddafaee$export$4b2950bdac9b6ee9.isPath(at) ? $786b46ea7ddafaee$var$matchPath(editor, at) : (n)=>$786b46ea7ddafaee$export$db77ccec0bb4ccac.isElement(n) && $786b46ea7ddafaee$export$7cda8d932e2f33c0.isBlock(editor, n);
        if (!at) return;
        var matches = $786b46ea7ddafaee$export$7cda8d932e2f33c0.nodes(editor, {
            at: at,
            match: match,
            mode: mode,
            voids: voids
        });
        var pathRefs = Array.from(matches, (_ref)=>{
            var [, p] = _ref;
            return $786b46ea7ddafaee$export$7cda8d932e2f33c0.pathRef(editor, p);
        });
        for (var pathRef of pathRefs){
            var path = pathRef.unref();
            if (path.length < 2) throw new Error("Cannot lift node at a path [".concat(path, "] because it has a depth of less than `2`."));
            var parentNodeEntry = $786b46ea7ddafaee$export$7cda8d932e2f33c0.node(editor, $786b46ea7ddafaee$export$4b2950bdac9b6ee9.parent(path));
            var [parent, parentPath] = parentNodeEntry;
            var index = path[path.length - 1];
            var { length: length } = parent.children;
            if (length === 1) {
                var toPath = $786b46ea7ddafaee$export$4b2950bdac9b6ee9.next(parentPath);
                $786b46ea7ddafaee$export$2e7e2a6179fcdd5c.moveNodes(editor, {
                    at: path,
                    to: toPath,
                    voids: voids
                });
                $786b46ea7ddafaee$export$2e7e2a6179fcdd5c.removeNodes(editor, {
                    at: parentPath,
                    voids: voids
                });
            } else if (index === 0) $786b46ea7ddafaee$export$2e7e2a6179fcdd5c.moveNodes(editor, {
                at: path,
                to: parentPath,
                voids: voids
            });
            else if (index === length - 1) {
                var _toPath = $786b46ea7ddafaee$export$4b2950bdac9b6ee9.next(parentPath);
                $786b46ea7ddafaee$export$2e7e2a6179fcdd5c.moveNodes(editor, {
                    at: path,
                    to: _toPath,
                    voids: voids
                });
            } else {
                var splitPath = $786b46ea7ddafaee$export$4b2950bdac9b6ee9.next(path);
                var _toPath2 = $786b46ea7ddafaee$export$4b2950bdac9b6ee9.next(parentPath);
                $786b46ea7ddafaee$export$2e7e2a6179fcdd5c.splitNodes(editor, {
                    at: splitPath,
                    voids: voids
                });
                $786b46ea7ddafaee$export$2e7e2a6179fcdd5c.moveNodes(editor, {
                    at: path,
                    to: _toPath2,
                    voids: voids
                });
            }
        }
    });
};
var $786b46ea7ddafaee$var$_excluded = [
    "text"
], $786b46ea7ddafaee$var$_excluded2 = [
    "children"
];
var $786b46ea7ddafaee$var$hasSingleChildNest = (editor, node)=>{
    if ($786b46ea7ddafaee$export$db77ccec0bb4ccac.isElement(node)) {
        var element = node;
        if ($786b46ea7ddafaee$export$7cda8d932e2f33c0.isVoid(editor, node)) return true;
        else if (element.children.length === 1) return $786b46ea7ddafaee$var$hasSingleChildNest(editor, element.children[0]);
        else return false;
    } else if ($786b46ea7ddafaee$export$7cda8d932e2f33c0.isEditor(node)) return false;
    else return true;
};
var $786b46ea7ddafaee$export$417cbb44eeade501 = function mergeNodes(editor) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    $786b46ea7ddafaee$export$7cda8d932e2f33c0.withoutNormalizing(editor, ()=>{
        var { match: match, at: at = editor.selection } = options;
        var { hanging: hanging = false, voids: voids = false, mode: mode = "lowest" } = options;
        if (!at) return;
        if (match == null) {
            if ($786b46ea7ddafaee$export$4b2950bdac9b6ee9.isPath(at)) {
                var [parent] = $786b46ea7ddafaee$export$7cda8d932e2f33c0.parent(editor, at);
                match = (n)=>parent.children.includes(n);
            } else match = (n)=>$786b46ea7ddafaee$export$db77ccec0bb4ccac.isElement(n) && $786b46ea7ddafaee$export$7cda8d932e2f33c0.isBlock(editor, n);
        }
        if (!hanging && $786b46ea7ddafaee$export$9a58ef0d7ad3278c.isRange(at)) at = $786b46ea7ddafaee$export$7cda8d932e2f33c0.unhangRange(editor, at, {
            voids: voids
        });
        if ($786b46ea7ddafaee$export$9a58ef0d7ad3278c.isRange(at)) {
            if ($786b46ea7ddafaee$export$9a58ef0d7ad3278c.isCollapsed(at)) at = at.anchor;
            else {
                var [, end] = $786b46ea7ddafaee$export$9a58ef0d7ad3278c.edges(at);
                var pointRef = $786b46ea7ddafaee$export$7cda8d932e2f33c0.pointRef(editor, end);
                $786b46ea7ddafaee$export$2e7e2a6179fcdd5c.delete(editor, {
                    at: at
                });
                at = pointRef.unref();
                if (options.at == null) $786b46ea7ddafaee$export$2e7e2a6179fcdd5c.select(editor, at);
            }
        }
        var [current] = $786b46ea7ddafaee$export$7cda8d932e2f33c0.nodes(editor, {
            at: at,
            match: match,
            voids: voids,
            mode: mode
        });
        var prev = $786b46ea7ddafaee$export$7cda8d932e2f33c0.previous(editor, {
            at: at,
            match: match,
            voids: voids,
            mode: mode
        });
        if (!current || !prev) return;
        var [node, path] = current;
        var [prevNode, prevPath] = prev;
        if (path.length === 0 || prevPath.length === 0) return;
        var newPath = $786b46ea7ddafaee$export$4b2950bdac9b6ee9.next(prevPath);
        var commonPath = $786b46ea7ddafaee$export$4b2950bdac9b6ee9.common(path, prevPath);
        var isPreviousSibling = $786b46ea7ddafaee$export$4b2950bdac9b6ee9.isSibling(path, prevPath);
        var levels = Array.from($786b46ea7ddafaee$export$7cda8d932e2f33c0.levels(editor, {
            at: path
        }), (_ref)=>{
            var [n] = _ref;
            return n;
        }).slice(commonPath.length).slice(0, -1);
        // Determine if the merge will leave an ancestor of the path empty as a
        // result, in which case we'll want to remove it after merging.
        var emptyAncestor = $786b46ea7ddafaee$export$7cda8d932e2f33c0.above(editor, {
            at: path,
            mode: "highest",
            match: (n)=>levels.includes(n) && $786b46ea7ddafaee$var$hasSingleChildNest(editor, n)
        });
        var emptyRef = emptyAncestor && $786b46ea7ddafaee$export$7cda8d932e2f33c0.pathRef(editor, emptyAncestor[1]);
        var properties;
        var position;
        // Ensure that the nodes are equivalent, and figure out what the position
        // and extra properties of the merge will be.
        if ($786b46ea7ddafaee$export$5f1af8db9871e1d6.isText(node) && $786b46ea7ddafaee$export$5f1af8db9871e1d6.isText(prevNode)) {
            var rest = $786b46ea7ddafaee$var$_objectWithoutProperties(node, $786b46ea7ddafaee$var$_excluded);
            position = prevNode.text.length;
            properties = rest;
        } else if ($786b46ea7ddafaee$export$db77ccec0bb4ccac.isElement(node) && $786b46ea7ddafaee$export$db77ccec0bb4ccac.isElement(prevNode)) {
            var rest = $786b46ea7ddafaee$var$_objectWithoutProperties(node, $786b46ea7ddafaee$var$_excluded2);
            position = prevNode.children.length;
            properties = rest;
        } else throw new Error("Cannot merge the node at path [".concat(path, "] with the previous sibling because it is not the same kind: ").concat($786b46ea7ddafaee$export$1e3096e79001f1db.stringify(node), " ").concat($786b46ea7ddafaee$export$1e3096e79001f1db.stringify(prevNode)));
        // If the node isn't already the next sibling of the previous node, move
        // it so that it is before merging.
        if (!isPreviousSibling) $786b46ea7ddafaee$export$2e7e2a6179fcdd5c.moveNodes(editor, {
            at: path,
            to: newPath,
            voids: voids
        });
        // If there was going to be an empty ancestor of the node that was merged,
        // we remove it from the tree.
        if (emptyRef) $786b46ea7ddafaee$export$2e7e2a6179fcdd5c.removeNodes(editor, {
            at: emptyRef.current,
            voids: voids
        });
        if ($786b46ea7ddafaee$export$7cda8d932e2f33c0.shouldMergeNodesRemovePrevNode(editor, prev, current)) $786b46ea7ddafaee$export$2e7e2a6179fcdd5c.removeNodes(editor, {
            at: prevPath,
            voids: voids
        });
        else editor.apply({
            type: "merge_node",
            path: newPath,
            position: position,
            properties: properties
        });
        if (emptyRef) emptyRef.unref();
    });
};
var $786b46ea7ddafaee$export$8d4d613265124058 = (editor, options)=>{
    $786b46ea7ddafaee$export$7cda8d932e2f33c0.withoutNormalizing(editor, ()=>{
        var { to: to, at: at = editor.selection, mode: mode = "lowest", voids: voids = false } = options;
        var { match: match } = options;
        if (!at) return;
        if (match == null) match = $786b46ea7ddafaee$export$4b2950bdac9b6ee9.isPath(at) ? $786b46ea7ddafaee$var$matchPath(editor, at) : (n)=>$786b46ea7ddafaee$export$db77ccec0bb4ccac.isElement(n) && $786b46ea7ddafaee$export$7cda8d932e2f33c0.isBlock(editor, n);
        var toRef = $786b46ea7ddafaee$export$7cda8d932e2f33c0.pathRef(editor, to);
        var targets = $786b46ea7ddafaee$export$7cda8d932e2f33c0.nodes(editor, {
            at: at,
            match: match,
            mode: mode,
            voids: voids
        });
        var pathRefs = Array.from(targets, (_ref)=>{
            var [, p] = _ref;
            return $786b46ea7ddafaee$export$7cda8d932e2f33c0.pathRef(editor, p);
        });
        for (var pathRef of pathRefs){
            var path = pathRef.unref();
            var newPath = toRef.current;
            if (path.length !== 0) editor.apply({
                type: "move_node",
                path: path,
                newPath: newPath
            });
            if (toRef.current && $786b46ea7ddafaee$export$4b2950bdac9b6ee9.isSibling(newPath, path) && $786b46ea7ddafaee$export$4b2950bdac9b6ee9.isAfter(newPath, path)) // When performing a sibling move to a later index, the path at the destination is shifted
            // to before the insertion point instead of after. To ensure our group of nodes are inserted
            // in the correct order we increment toRef to account for that
            toRef.current = $786b46ea7ddafaee$export$4b2950bdac9b6ee9.next(toRef.current);
        }
        toRef.unref();
    });
};
var $786b46ea7ddafaee$export$77f49a256021c8de = function removeNodes(editor) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    $786b46ea7ddafaee$export$7cda8d932e2f33c0.withoutNormalizing(editor, ()=>{
        var { hanging: hanging = false, voids: voids = false, mode: mode = "lowest" } = options;
        var { at: at = editor.selection, match: match } = options;
        if (!at) return;
        if (match == null) match = $786b46ea7ddafaee$export$4b2950bdac9b6ee9.isPath(at) ? $786b46ea7ddafaee$var$matchPath(editor, at) : (n)=>$786b46ea7ddafaee$export$db77ccec0bb4ccac.isElement(n) && $786b46ea7ddafaee$export$7cda8d932e2f33c0.isBlock(editor, n);
        if (!hanging && $786b46ea7ddafaee$export$9a58ef0d7ad3278c.isRange(at)) at = $786b46ea7ddafaee$export$7cda8d932e2f33c0.unhangRange(editor, at, {
            voids: voids
        });
        var depths = $786b46ea7ddafaee$export$7cda8d932e2f33c0.nodes(editor, {
            at: at,
            match: match,
            mode: mode,
            voids: voids
        });
        var pathRefs = Array.from(depths, (_ref)=>{
            var [, p] = _ref;
            return $786b46ea7ddafaee$export$7cda8d932e2f33c0.pathRef(editor, p);
        });
        for (var pathRef of pathRefs){
            var path = pathRef.unref();
            if (path) {
                var [node] = $786b46ea7ddafaee$export$7cda8d932e2f33c0.node(editor, path);
                editor.apply({
                    type: "remove_node",
                    path: path,
                    node: node
                });
            }
        }
    });
};
var $786b46ea7ddafaee$export$4d3b7bb67cb076c7 = function setNodes(editor, props) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    $786b46ea7ddafaee$export$7cda8d932e2f33c0.withoutNormalizing(editor, ()=>{
        var { match: match, at: at = editor.selection, compare: compare, merge: merge } = options;
        var { hanging: hanging = false, mode: mode = "lowest", split: split = false, voids: voids = false } = options;
        if (!at) return;
        if (match == null) match = $786b46ea7ddafaee$export$4b2950bdac9b6ee9.isPath(at) ? $786b46ea7ddafaee$var$matchPath(editor, at) : (n)=>$786b46ea7ddafaee$export$db77ccec0bb4ccac.isElement(n) && $786b46ea7ddafaee$export$7cda8d932e2f33c0.isBlock(editor, n);
        if (!hanging && $786b46ea7ddafaee$export$9a58ef0d7ad3278c.isRange(at)) at = $786b46ea7ddafaee$export$7cda8d932e2f33c0.unhangRange(editor, at, {
            voids: voids
        });
        if (split && $786b46ea7ddafaee$export$9a58ef0d7ad3278c.isRange(at)) {
            if ($786b46ea7ddafaee$export$9a58ef0d7ad3278c.isCollapsed(at) && $786b46ea7ddafaee$export$7cda8d932e2f33c0.leaf(editor, at.anchor)[0].text.length > 0) // If the range is collapsed in a non-empty node and 'split' is true, there's nothing to
            // set that won't get normalized away
            return;
            var rangeRef = $786b46ea7ddafaee$export$7cda8d932e2f33c0.rangeRef(editor, at, {
                affinity: "inward"
            });
            var [start, end] = $786b46ea7ddafaee$export$9a58ef0d7ad3278c.edges(at);
            var splitMode = mode === "lowest" ? "lowest" : "highest";
            var endAtEndOfNode = $786b46ea7ddafaee$export$7cda8d932e2f33c0.isEnd(editor, end, end.path);
            $786b46ea7ddafaee$export$2e7e2a6179fcdd5c.splitNodes(editor, {
                at: end,
                match: match,
                mode: splitMode,
                voids: voids,
                always: !endAtEndOfNode
            });
            var startAtStartOfNode = $786b46ea7ddafaee$export$7cda8d932e2f33c0.isStart(editor, start, start.path);
            $786b46ea7ddafaee$export$2e7e2a6179fcdd5c.splitNodes(editor, {
                at: start,
                match: match,
                mode: splitMode,
                voids: voids,
                always: !startAtStartOfNode
            });
            at = rangeRef.unref();
            if (options.at == null) $786b46ea7ddafaee$export$2e7e2a6179fcdd5c.select(editor, at);
        }
        if (!compare) compare = (prop, nodeProp)=>prop !== nodeProp;
        for (var [node, path] of $786b46ea7ddafaee$export$7cda8d932e2f33c0.nodes(editor, {
            at: at,
            match: match,
            mode: mode,
            voids: voids
        })){
            var properties = {};
            // FIXME: is this correct?
            var newProperties = {};
            // You can't set properties on the editor node.
            if (path.length === 0) continue;
            var hasChanges = false;
            for(var k in props){
                if (k === "children" || k === "text") continue;
                if (compare(props[k], node[k])) {
                    hasChanges = true;
                    // Omit new properties from the old properties list
                    if (node.hasOwnProperty(k)) properties[k] = node[k];
                    // Omit properties that have been removed from the new properties list
                    if (merge) {
                        if (props[k] != null) newProperties[k] = merge(node[k], props[k]);
                    } else if (props[k] != null) newProperties[k] = props[k];
                }
            }
            if (hasChanges) editor.apply({
                type: "set_node",
                path: path,
                properties: properties,
                newProperties: newProperties
            });
        }
    });
};
/**
 * Convert a range into a point by deleting it's content.
 */ var $786b46ea7ddafaee$var$deleteRange = (editor, range)=>{
    if ($786b46ea7ddafaee$export$9a58ef0d7ad3278c.isCollapsed(range)) return range.anchor;
    else {
        var [, end] = $786b46ea7ddafaee$export$9a58ef0d7ad3278c.edges(range);
        var pointRef = $786b46ea7ddafaee$export$7cda8d932e2f33c0.pointRef(editor, end);
        $786b46ea7ddafaee$export$2e7e2a6179fcdd5c.delete(editor, {
            at: range
        });
        return pointRef.unref();
    }
};
var $786b46ea7ddafaee$export$8cae13a34cef6097 = function splitNodes(editor) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    $786b46ea7ddafaee$export$7cda8d932e2f33c0.withoutNormalizing(editor, ()=>{
        var { mode: mode = "lowest", voids: voids = false } = options;
        var { match: match, at: at = editor.selection, height: height = 0, always: always = false } = options;
        if (match == null) match = (n)=>$786b46ea7ddafaee$export$db77ccec0bb4ccac.isElement(n) && $786b46ea7ddafaee$export$7cda8d932e2f33c0.isBlock(editor, n);
        if ($786b46ea7ddafaee$export$9a58ef0d7ad3278c.isRange(at)) at = $786b46ea7ddafaee$var$deleteRange(editor, at);
        // If the target is a path, the default height-skipping and position
        // counters need to account for us potentially splitting at a non-leaf.
        if ($786b46ea7ddafaee$export$4b2950bdac9b6ee9.isPath(at)) {
            var path = at;
            var point = $786b46ea7ddafaee$export$7cda8d932e2f33c0.point(editor, path);
            var [parent] = $786b46ea7ddafaee$export$7cda8d932e2f33c0.parent(editor, path);
            match = (n)=>n === parent;
            height = point.path.length - path.length + 1;
            at = point;
            always = true;
        }
        if (!at) return;
        var beforeRef = $786b46ea7ddafaee$export$7cda8d932e2f33c0.pointRef(editor, at, {
            affinity: "backward"
        });
        var afterRef;
        try {
            var [highest] = $786b46ea7ddafaee$export$7cda8d932e2f33c0.nodes(editor, {
                at: at,
                match: match,
                mode: mode,
                voids: voids
            });
            if (!highest) return;
            var voidMatch = $786b46ea7ddafaee$export$7cda8d932e2f33c0.void(editor, {
                at: at,
                mode: "highest"
            });
            var nudge = 0;
            if (!voids && voidMatch) {
                var [voidNode, voidPath] = voidMatch;
                if ($786b46ea7ddafaee$export$db77ccec0bb4ccac.isElement(voidNode) && editor.isInline(voidNode)) {
                    var after = $786b46ea7ddafaee$export$7cda8d932e2f33c0.after(editor, voidPath);
                    if (!after) {
                        var text = {
                            text: ""
                        };
                        var afterPath = $786b46ea7ddafaee$export$4b2950bdac9b6ee9.next(voidPath);
                        $786b46ea7ddafaee$export$2e7e2a6179fcdd5c.insertNodes(editor, text, {
                            at: afterPath,
                            voids: voids
                        });
                        after = $786b46ea7ddafaee$export$7cda8d932e2f33c0.point(editor, afterPath);
                    }
                    at = after;
                    always = true;
                }
                var siblingHeight = at.path.length - voidPath.length;
                height = siblingHeight + 1;
                always = true;
            }
            afterRef = $786b46ea7ddafaee$export$7cda8d932e2f33c0.pointRef(editor, at);
            var depth = at.path.length - height;
            var [, highestPath] = highest;
            var lowestPath = at.path.slice(0, depth);
            var position = height === 0 ? at.offset : at.path[depth] + nudge;
            for (var [node, _path] of $786b46ea7ddafaee$export$7cda8d932e2f33c0.levels(editor, {
                at: lowestPath,
                reverse: true,
                voids: voids
            })){
                var split = false;
                if (_path.length < highestPath.length || _path.length === 0 || !voids && $786b46ea7ddafaee$export$db77ccec0bb4ccac.isElement(node) && $786b46ea7ddafaee$export$7cda8d932e2f33c0.isVoid(editor, node)) break;
                var _point = beforeRef.current;
                var isEnd = $786b46ea7ddafaee$export$7cda8d932e2f33c0.isEnd(editor, _point, _path);
                if (always || !beforeRef || !$786b46ea7ddafaee$export$7cda8d932e2f33c0.isEdge(editor, _point, _path)) {
                    split = true;
                    var properties = $786b46ea7ddafaee$export$85c928794f8d04d4.extractProps(node);
                    editor.apply({
                        type: "split_node",
                        path: _path,
                        position: position,
                        properties: properties
                    });
                }
                position = _path[_path.length - 1] + (split || isEnd ? 1 : 0);
            }
            if (options.at == null) {
                var _point2 = afterRef.current || $786b46ea7ddafaee$export$7cda8d932e2f33c0.end(editor, []);
                $786b46ea7ddafaee$export$2e7e2a6179fcdd5c.select(editor, _point2);
            }
        } finally{
            var _afterRef;
            beforeRef.unref();
            (_afterRef = afterRef) === null || _afterRef === void 0 || _afterRef.unref();
        }
    });
};
var $786b46ea7ddafaee$export$6ba811b1d416e3b0 = function unsetNodes(editor, props) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    if (!Array.isArray(props)) props = [
        props
    ];
    var obj = {};
    for (var key of props)obj[key] = null;
    $786b46ea7ddafaee$export$2e7e2a6179fcdd5c.setNodes(editor, obj, options);
};
var $786b46ea7ddafaee$export$e992688ecb704d56 = function unwrapNodes(editor) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    $786b46ea7ddafaee$export$7cda8d932e2f33c0.withoutNormalizing(editor, ()=>{
        var { mode: mode = "lowest", split: split = false, voids: voids = false } = options;
        var { at: at = editor.selection, match: match } = options;
        if (!at) return;
        if (match == null) match = $786b46ea7ddafaee$export$4b2950bdac9b6ee9.isPath(at) ? $786b46ea7ddafaee$var$matchPath(editor, at) : (n)=>$786b46ea7ddafaee$export$db77ccec0bb4ccac.isElement(n) && $786b46ea7ddafaee$export$7cda8d932e2f33c0.isBlock(editor, n);
        if ($786b46ea7ddafaee$export$4b2950bdac9b6ee9.isPath(at)) at = $786b46ea7ddafaee$export$7cda8d932e2f33c0.range(editor, at);
        var rangeRef = $786b46ea7ddafaee$export$9a58ef0d7ad3278c.isRange(at) ? $786b46ea7ddafaee$export$7cda8d932e2f33c0.rangeRef(editor, at) : null;
        var matches = $786b46ea7ddafaee$export$7cda8d932e2f33c0.nodes(editor, {
            at: at,
            match: match,
            mode: mode,
            voids: voids
        });
        var pathRefs = Array.from(matches, (_ref)=>{
            var [, p] = _ref;
            return $786b46ea7ddafaee$export$7cda8d932e2f33c0.pathRef(editor, p);
        }).reverse();
        var _loop = function _loop() {
            var path = pathRef.unref();
            var [node] = $786b46ea7ddafaee$export$7cda8d932e2f33c0.node(editor, path);
            var range = $786b46ea7ddafaee$export$7cda8d932e2f33c0.range(editor, path);
            if (split && rangeRef) range = $786b46ea7ddafaee$export$9a58ef0d7ad3278c.intersection(rangeRef.current, range);
            $786b46ea7ddafaee$export$2e7e2a6179fcdd5c.liftNodes(editor, {
                at: range,
                match: (n)=>$786b46ea7ddafaee$export$db77ccec0bb4ccac.isAncestor(node) && node.children.includes(n),
                voids: voids
            });
        };
        for (var pathRef of pathRefs)_loop();
        if (rangeRef) rangeRef.unref();
    });
};
function $786b46ea7ddafaee$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $786b46ea7ddafaee$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $786b46ea7ddafaee$var$ownKeys(Object(t), !0).forEach(function(r) {
            $786b46ea7ddafaee$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $786b46ea7ddafaee$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $786b46ea7ddafaee$export$e10a714a452c78c8 = function wrapNodes(editor, element) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    $786b46ea7ddafaee$export$7cda8d932e2f33c0.withoutNormalizing(editor, ()=>{
        var { mode: mode = "lowest", split: split = false, voids: voids = false } = options;
        var { match: match, at: at = editor.selection } = options;
        if (!at) return;
        if (match == null) {
            if ($786b46ea7ddafaee$export$4b2950bdac9b6ee9.isPath(at)) match = $786b46ea7ddafaee$var$matchPath(editor, at);
            else if (editor.isInline(element)) match = (n)=>$786b46ea7ddafaee$export$db77ccec0bb4ccac.isElement(n) && $786b46ea7ddafaee$export$7cda8d932e2f33c0.isInline(editor, n) || $786b46ea7ddafaee$export$5f1af8db9871e1d6.isText(n);
            else match = (n)=>$786b46ea7ddafaee$export$db77ccec0bb4ccac.isElement(n) && $786b46ea7ddafaee$export$7cda8d932e2f33c0.isBlock(editor, n);
        }
        if (split && $786b46ea7ddafaee$export$9a58ef0d7ad3278c.isRange(at)) {
            var [start, end] = $786b46ea7ddafaee$export$9a58ef0d7ad3278c.edges(at);
            var rangeRef = $786b46ea7ddafaee$export$7cda8d932e2f33c0.rangeRef(editor, at, {
                affinity: "inward"
            });
            $786b46ea7ddafaee$export$2e7e2a6179fcdd5c.splitNodes(editor, {
                at: end,
                match: match,
                voids: voids
            });
            $786b46ea7ddafaee$export$2e7e2a6179fcdd5c.splitNodes(editor, {
                at: start,
                match: match,
                voids: voids
            });
            at = rangeRef.unref();
            if (options.at == null) $786b46ea7ddafaee$export$2e7e2a6179fcdd5c.select(editor, at);
        }
        var roots = Array.from($786b46ea7ddafaee$export$7cda8d932e2f33c0.nodes(editor, {
            at: at,
            match: editor.isInline(element) ? (n)=>$786b46ea7ddafaee$export$db77ccec0bb4ccac.isElement(n) && $786b46ea7ddafaee$export$7cda8d932e2f33c0.isBlock(editor, n) : (n)=>$786b46ea7ddafaee$export$7cda8d932e2f33c0.isEditor(n),
            mode: "lowest",
            voids: voids
        }));
        var _loop = function _loop() {
            var a = $786b46ea7ddafaee$export$9a58ef0d7ad3278c.isRange(at) ? $786b46ea7ddafaee$export$9a58ef0d7ad3278c.intersection(at, $786b46ea7ddafaee$export$7cda8d932e2f33c0.range(editor, rootPath)) : at;
            if (!a) return 0; // continue
            var matches = Array.from($786b46ea7ddafaee$export$7cda8d932e2f33c0.nodes(editor, {
                at: a,
                match: match,
                mode: mode,
                voids: voids
            }));
            if (matches.length > 0) {
                var [first] = matches;
                var last = matches[matches.length - 1];
                var [, firstPath] = first;
                var [, lastPath] = last;
                if (firstPath.length === 0 && lastPath.length === 0) // if there's no matching parent - usually means the node is an editor - don't do anything
                return 0; // continue
                var commonPath = $786b46ea7ddafaee$export$4b2950bdac9b6ee9.equals(firstPath, lastPath) ? $786b46ea7ddafaee$export$4b2950bdac9b6ee9.parent(firstPath) : $786b46ea7ddafaee$export$4b2950bdac9b6ee9.common(firstPath, lastPath);
                var range = $786b46ea7ddafaee$export$7cda8d932e2f33c0.range(editor, firstPath, lastPath);
                var commonNodeEntry = $786b46ea7ddafaee$export$7cda8d932e2f33c0.node(editor, commonPath);
                var [commonNode] = commonNodeEntry;
                var depth = commonPath.length + 1;
                var wrapperPath = $786b46ea7ddafaee$export$4b2950bdac9b6ee9.next(lastPath.slice(0, depth));
                var wrapper = $786b46ea7ddafaee$var$_objectSpread($786b46ea7ddafaee$var$_objectSpread({}, element), {}, {
                    children: []
                });
                $786b46ea7ddafaee$export$2e7e2a6179fcdd5c.insertNodes(editor, wrapper, {
                    at: wrapperPath,
                    voids: voids
                });
                $786b46ea7ddafaee$export$2e7e2a6179fcdd5c.moveNodes(editor, {
                    at: range,
                    match: (n)=>$786b46ea7ddafaee$export$db77ccec0bb4ccac.isAncestor(commonNode) && commonNode.children.includes(n),
                    to: wrapperPath.concat(0),
                    voids: voids
                });
            }
        }, _ret;
        for (var [, rootPath] of roots){
            _ret = _loop();
            if (_ret === 0) continue;
        }
    });
};
/**
 * Create a new Slate `Editor` object.
 */ var $786b46ea7ddafaee$export$eb02d1ee0d3cac30 = ()=>{
    var editor = {
        children: [],
        operations: [],
        selection: null,
        marks: null,
        isElementReadOnly: ()=>false,
        isInline: ()=>false,
        isSelectable: ()=>true,
        isVoid: ()=>false,
        markableVoid: ()=>false,
        onChange: ()=>{},
        // Core
        apply: function apply$1() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return $786b46ea7ddafaee$export$5635d7ef4b8fee1c(editor, ...args);
        },
        // Editor
        addMark: function addMark$1() {
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            return $786b46ea7ddafaee$export$728e28c22a0fba4(editor, ...args);
        },
        deleteBackward: function deleteBackward$1() {
            for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
            return $786b46ea7ddafaee$export$f2323afd0aa0bdea(editor, ...args);
        },
        deleteForward: function deleteForward$1() {
            for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
            return $786b46ea7ddafaee$export$948b9f836237b4b4(editor, ...args);
        },
        deleteFragment: function deleteFragment$1() {
            for(var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++)args[_key5] = arguments[_key5];
            return $786b46ea7ddafaee$export$de5307279b49fffb(editor, ...args);
        },
        getFragment: function getFragment$1() {
            for(var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++)args[_key6] = arguments[_key6];
            return $786b46ea7ddafaee$export$7ddaa488b9a570c(editor, ...args);
        },
        insertBreak: function insertBreak$1() {
            for(var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++)args[_key7] = arguments[_key7];
            return $786b46ea7ddafaee$export$674f9c199a622991(editor, ...args);
        },
        insertSoftBreak: function insertSoftBreak$1() {
            for(var _len8 = arguments.length, args = new Array(_len8), _key8 = 0; _key8 < _len8; _key8++)args[_key8] = arguments[_key8];
            return $786b46ea7ddafaee$export$6260290d896a55f3(editor, ...args);
        },
        insertFragment: function insertFragment$1() {
            for(var _len9 = arguments.length, args = new Array(_len9), _key9 = 0; _key9 < _len9; _key9++)args[_key9] = arguments[_key9];
            return $786b46ea7ddafaee$export$88d0f1fc1c16e147(editor, ...args);
        },
        insertNode: function insertNode$1() {
            for(var _len10 = arguments.length, args = new Array(_len10), _key10 = 0; _key10 < _len10; _key10++)args[_key10] = arguments[_key10];
            return $786b46ea7ddafaee$export$f694843d4c7ee42a(editor, ...args);
        },
        insertText: function insertText$1() {
            for(var _len11 = arguments.length, args = new Array(_len11), _key11 = 0; _key11 < _len11; _key11++)args[_key11] = arguments[_key11];
            return $786b46ea7ddafaee$export$78ba03e296d6b5ac(editor, ...args);
        },
        normalizeNode: function normalizeNode$1() {
            for(var _len12 = arguments.length, args = new Array(_len12), _key12 = 0; _key12 < _len12; _key12++)args[_key12] = arguments[_key12];
            return $786b46ea7ddafaee$export$775064d9a0021ab5(editor, ...args);
        },
        removeMark: function removeMark$1() {
            for(var _len13 = arguments.length, args = new Array(_len13), _key13 = 0; _key13 < _len13; _key13++)args[_key13] = arguments[_key13];
            return $786b46ea7ddafaee$export$5c9d031211c1b7c9(editor, ...args);
        },
        getDirtyPaths: function getDirtyPaths$1() {
            for(var _len14 = arguments.length, args = new Array(_len14), _key14 = 0; _key14 < _len14; _key14++)args[_key14] = arguments[_key14];
            return $786b46ea7ddafaee$export$19d7c64d3d3b658b(editor, ...args);
        },
        shouldNormalize: function shouldNormalize$1() {
            for(var _len15 = arguments.length, args = new Array(_len15), _key15 = 0; _key15 < _len15; _key15++)args[_key15] = arguments[_key15];
            return $786b46ea7ddafaee$export$8124630c93d7bb9c(editor, ...args);
        },
        // Editor interface
        above: function above$1() {
            for(var _len16 = arguments.length, args = new Array(_len16), _key16 = 0; _key16 < _len16; _key16++)args[_key16] = arguments[_key16];
            return $786b46ea7ddafaee$export$1b61d973339d4399(editor, ...args);
        },
        after: function after$1() {
            for(var _len17 = arguments.length, args = new Array(_len17), _key17 = 0; _key17 < _len17; _key17++)args[_key17] = arguments[_key17];
            return $786b46ea7ddafaee$export$742acabee3dd6465(editor, ...args);
        },
        before: function before$1() {
            for(var _len18 = arguments.length, args = new Array(_len18), _key18 = 0; _key18 < _len18; _key18++)args[_key18] = arguments[_key18];
            return $786b46ea7ddafaee$export$1c4c1e3098bf5ebe(editor, ...args);
        },
        collapse: function collapse$1() {
            for(var _len19 = arguments.length, args = new Array(_len19), _key19 = 0; _key19 < _len19; _key19++)args[_key19] = arguments[_key19];
            return $786b46ea7ddafaee$export$ec45920981e0ca9b(editor, ...args);
        },
        delete: function _delete() {
            for(var _len20 = arguments.length, args = new Array(_len20), _key20 = 0; _key20 < _len20; _key20++)args[_key20] = arguments[_key20];
            return $786b46ea7ddafaee$export$69b97c52b23537e1(editor, ...args);
        },
        deselect: function deselect$1() {
            for(var _len21 = arguments.length, args = new Array(_len21), _key21 = 0; _key21 < _len21; _key21++)args[_key21] = arguments[_key21];
            return $786b46ea7ddafaee$export$5bb86370ea51314a(editor, ...args);
        },
        edges: function edges$1() {
            for(var _len22 = arguments.length, args = new Array(_len22), _key22 = 0; _key22 < _len22; _key22++)args[_key22] = arguments[_key22];
            return $786b46ea7ddafaee$export$4544a00f8eb65eb2(editor, ...args);
        },
        elementReadOnly: function elementReadOnly$1() {
            for(var _len23 = arguments.length, args = new Array(_len23), _key23 = 0; _key23 < _len23; _key23++)args[_key23] = arguments[_key23];
            return $786b46ea7ddafaee$export$7b9289b4576eb4e5(editor, ...args);
        },
        end: function end$1() {
            for(var _len24 = arguments.length, args = new Array(_len24), _key24 = 0; _key24 < _len24; _key24++)args[_key24] = arguments[_key24];
            return $786b46ea7ddafaee$export$bd5df0f255a350f8(editor, ...args);
        },
        first: function first$1() {
            for(var _len25 = arguments.length, args = new Array(_len25), _key25 = 0; _key25 < _len25; _key25++)args[_key25] = arguments[_key25];
            return $786b46ea7ddafaee$export$43128fadae87b74a(editor, ...args);
        },
        fragment: function fragment$1() {
            for(var _len26 = arguments.length, args = new Array(_len26), _key26 = 0; _key26 < _len26; _key26++)args[_key26] = arguments[_key26];
            return $786b46ea7ddafaee$export$f00aeb236b6f05af(editor, ...args);
        },
        getMarks: function getMarks() {
            for(var _len27 = arguments.length, args = new Array(_len27), _key27 = 0; _key27 < _len27; _key27++)args[_key27] = arguments[_key27];
            return $786b46ea7ddafaee$export$3a8025f2f3e0c64(editor, ...args);
        },
        hasBlocks: function hasBlocks$1() {
            for(var _len28 = arguments.length, args = new Array(_len28), _key28 = 0; _key28 < _len28; _key28++)args[_key28] = arguments[_key28];
            return $786b46ea7ddafaee$export$9a188849e4e12045(editor, ...args);
        },
        hasInlines: function hasInlines$1() {
            for(var _len29 = arguments.length, args = new Array(_len29), _key29 = 0; _key29 < _len29; _key29++)args[_key29] = arguments[_key29];
            return $786b46ea7ddafaee$export$56b28c1fe6207902(editor, ...args);
        },
        hasPath: function hasPath$1() {
            for(var _len30 = arguments.length, args = new Array(_len30), _key30 = 0; _key30 < _len30; _key30++)args[_key30] = arguments[_key30];
            return $786b46ea7ddafaee$export$733a1929a329d022(editor, ...args);
        },
        hasTexts: function hasTexts$1() {
            for(var _len31 = arguments.length, args = new Array(_len31), _key31 = 0; _key31 < _len31; _key31++)args[_key31] = arguments[_key31];
            return $786b46ea7ddafaee$export$63613c7b0e5f8059(editor, ...args);
        },
        insertNodes: function insertNodes$1() {
            for(var _len32 = arguments.length, args = new Array(_len32), _key32 = 0; _key32 < _len32; _key32++)args[_key32] = arguments[_key32];
            return $786b46ea7ddafaee$export$a6177d5829f70ebc(editor, ...args);
        },
        isBlock: function isBlock$1() {
            for(var _len33 = arguments.length, args = new Array(_len33), _key33 = 0; _key33 < _len33; _key33++)args[_key33] = arguments[_key33];
            return $786b46ea7ddafaee$export$de5a9e42c1dff8da(editor, ...args);
        },
        isEdge: function isEdge$1() {
            for(var _len34 = arguments.length, args = new Array(_len34), _key34 = 0; _key34 < _len34; _key34++)args[_key34] = arguments[_key34];
            return $786b46ea7ddafaee$export$cac3980734d91fbe(editor, ...args);
        },
        isEmpty: function isEmpty$1() {
            for(var _len35 = arguments.length, args = new Array(_len35), _key35 = 0; _key35 < _len35; _key35++)args[_key35] = arguments[_key35];
            return $786b46ea7ddafaee$export$dd1bc94b04021eeb(editor, ...args);
        },
        isEnd: function isEnd$1() {
            for(var _len36 = arguments.length, args = new Array(_len36), _key36 = 0; _key36 < _len36; _key36++)args[_key36] = arguments[_key36];
            return $786b46ea7ddafaee$export$42af6f45c6e0d09f(editor, ...args);
        },
        isNormalizing: function isNormalizing$1() {
            for(var _len37 = arguments.length, args = new Array(_len37), _key37 = 0; _key37 < _len37; _key37++)args[_key37] = arguments[_key37];
            return $786b46ea7ddafaee$export$79baf32bd2ec6469(editor, ...args);
        },
        isStart: function isStart$1() {
            for(var _len38 = arguments.length, args = new Array(_len38), _key38 = 0; _key38 < _len38; _key38++)args[_key38] = arguments[_key38];
            return $786b46ea7ddafaee$export$d801051673333b73(editor, ...args);
        },
        last: function last$1() {
            for(var _len39 = arguments.length, args = new Array(_len39), _key39 = 0; _key39 < _len39; _key39++)args[_key39] = arguments[_key39];
            return $786b46ea7ddafaee$export$4c7897fafd92b108(editor, ...args);
        },
        leaf: function leaf$1() {
            for(var _len40 = arguments.length, args = new Array(_len40), _key40 = 0; _key40 < _len40; _key40++)args[_key40] = arguments[_key40];
            return $786b46ea7ddafaee$export$bf2348675e1fe8e(editor, ...args);
        },
        levels: function levels$1() {
            for(var _len41 = arguments.length, args = new Array(_len41), _key41 = 0; _key41 < _len41; _key41++)args[_key41] = arguments[_key41];
            return $786b46ea7ddafaee$export$cc32c6afed33d362(editor, ...args);
        },
        liftNodes: function liftNodes$1() {
            for(var _len42 = arguments.length, args = new Array(_len42), _key42 = 0; _key42 < _len42; _key42++)args[_key42] = arguments[_key42];
            return $786b46ea7ddafaee$export$a3cae1b703a549d3(editor, ...args);
        },
        mergeNodes: function mergeNodes$1() {
            for(var _len43 = arguments.length, args = new Array(_len43), _key43 = 0; _key43 < _len43; _key43++)args[_key43] = arguments[_key43];
            return $786b46ea7ddafaee$export$417cbb44eeade501(editor, ...args);
        },
        move: function move$1() {
            for(var _len44 = arguments.length, args = new Array(_len44), _key44 = 0; _key44 < _len44; _key44++)args[_key44] = arguments[_key44];
            return $786b46ea7ddafaee$export$d947e5f4f4c48d48(editor, ...args);
        },
        moveNodes: function moveNodes$1() {
            for(var _len45 = arguments.length, args = new Array(_len45), _key45 = 0; _key45 < _len45; _key45++)args[_key45] = arguments[_key45];
            return $786b46ea7ddafaee$export$8d4d613265124058(editor, ...args);
        },
        next: function next$1() {
            for(var _len46 = arguments.length, args = new Array(_len46), _key46 = 0; _key46 < _len46; _key46++)args[_key46] = arguments[_key46];
            return $786b46ea7ddafaee$export$48cfd1e771a65c4f(editor, ...args);
        },
        node: function node$1() {
            for(var _len47 = arguments.length, args = new Array(_len47), _key47 = 0; _key47 < _len47; _key47++)args[_key47] = arguments[_key47];
            return $786b46ea7ddafaee$export$35059013cd4a06db(editor, ...args);
        },
        nodes: function nodes$1() {
            for(var _len48 = arguments.length, args = new Array(_len48), _key48 = 0; _key48 < _len48; _key48++)args[_key48] = arguments[_key48];
            return $786b46ea7ddafaee$export$695720b7e7a61533(editor, ...args);
        },
        normalize: function normalize$1() {
            for(var _len49 = arguments.length, args = new Array(_len49), _key49 = 0; _key49 < _len49; _key49++)args[_key49] = arguments[_key49];
            return $786b46ea7ddafaee$export$a3295358bff77e(editor, ...args);
        },
        parent: function parent$1() {
            for(var _len50 = arguments.length, args = new Array(_len50), _key50 = 0; _key50 < _len50; _key50++)args[_key50] = arguments[_key50];
            return $786b46ea7ddafaee$export$91124bb58bc04465(editor, ...args);
        },
        path: function path$1() {
            for(var _len51 = arguments.length, args = new Array(_len51), _key51 = 0; _key51 < _len51; _key51++)args[_key51] = arguments[_key51];
            return $786b46ea7ddafaee$export$bb654e07daaf8c3a(editor, ...args);
        },
        pathRef: function pathRef$1() {
            for(var _len52 = arguments.length, args = new Array(_len52), _key52 = 0; _key52 < _len52; _key52++)args[_key52] = arguments[_key52];
            return $786b46ea7ddafaee$export$52534ff19b1ca625(editor, ...args);
        },
        pathRefs: function pathRefs$1() {
            for(var _len53 = arguments.length, args = new Array(_len53), _key53 = 0; _key53 < _len53; _key53++)args[_key53] = arguments[_key53];
            return $786b46ea7ddafaee$export$26cece2e9e7da5a5(editor, ...args);
        },
        point: function point$1() {
            for(var _len54 = arguments.length, args = new Array(_len54), _key54 = 0; _key54 < _len54; _key54++)args[_key54] = arguments[_key54];
            return $786b46ea7ddafaee$export$105684a3041cb6f3(editor, ...args);
        },
        pointRef: function pointRef$1() {
            for(var _len55 = arguments.length, args = new Array(_len55), _key55 = 0; _key55 < _len55; _key55++)args[_key55] = arguments[_key55];
            return $786b46ea7ddafaee$export$9b86f3b8771165fe(editor, ...args);
        },
        pointRefs: function pointRefs$1() {
            for(var _len56 = arguments.length, args = new Array(_len56), _key56 = 0; _key56 < _len56; _key56++)args[_key56] = arguments[_key56];
            return $786b46ea7ddafaee$export$d0cf3b1b1f3deaba(editor, ...args);
        },
        positions: function positions$1() {
            for(var _len57 = arguments.length, args = new Array(_len57), _key57 = 0; _key57 < _len57; _key57++)args[_key57] = arguments[_key57];
            return $786b46ea7ddafaee$export$878041e1e4cd4218(editor, ...args);
        },
        previous: function previous$1() {
            for(var _len58 = arguments.length, args = new Array(_len58), _key58 = 0; _key58 < _len58; _key58++)args[_key58] = arguments[_key58];
            return $786b46ea7ddafaee$export$3abb7e718992aa6e(editor, ...args);
        },
        range: function range$1() {
            for(var _len59 = arguments.length, args = new Array(_len59), _key59 = 0; _key59 < _len59; _key59++)args[_key59] = arguments[_key59];
            return $786b46ea7ddafaee$export$d02631cccf789723(editor, ...args);
        },
        rangeRef: function rangeRef$1() {
            for(var _len60 = arguments.length, args = new Array(_len60), _key60 = 0; _key60 < _len60; _key60++)args[_key60] = arguments[_key60];
            return $786b46ea7ddafaee$export$d9cd3b5ae0eb95d1(editor, ...args);
        },
        rangeRefs: function rangeRefs$1() {
            for(var _len61 = arguments.length, args = new Array(_len61), _key61 = 0; _key61 < _len61; _key61++)args[_key61] = arguments[_key61];
            return $786b46ea7ddafaee$export$9a23b22fca0fae65(editor, ...args);
        },
        removeNodes: function removeNodes$1() {
            for(var _len62 = arguments.length, args = new Array(_len62), _key62 = 0; _key62 < _len62; _key62++)args[_key62] = arguments[_key62];
            return $786b46ea7ddafaee$export$77f49a256021c8de(editor, ...args);
        },
        select: function select$1() {
            for(var _len63 = arguments.length, args = new Array(_len63), _key63 = 0; _key63 < _len63; _key63++)args[_key63] = arguments[_key63];
            return $786b46ea7ddafaee$export$2e6c959c16ff56b8(editor, ...args);
        },
        setNodes: function setNodes$1() {
            for(var _len64 = arguments.length, args = new Array(_len64), _key64 = 0; _key64 < _len64; _key64++)args[_key64] = arguments[_key64];
            return $786b46ea7ddafaee$export$4d3b7bb67cb076c7(editor, ...args);
        },
        setNormalizing: function setNormalizing$1() {
            for(var _len65 = arguments.length, args = new Array(_len65), _key65 = 0; _key65 < _len65; _key65++)args[_key65] = arguments[_key65];
            return $786b46ea7ddafaee$export$7d41de07b364f759(editor, ...args);
        },
        setPoint: function setPoint$1() {
            for(var _len66 = arguments.length, args = new Array(_len66), _key66 = 0; _key66 < _len66; _key66++)args[_key66] = arguments[_key66];
            return $786b46ea7ddafaee$export$f2cbf0fb72c305dd(editor, ...args);
        },
        setSelection: function setSelection$1() {
            for(var _len67 = arguments.length, args = new Array(_len67), _key67 = 0; _key67 < _len67; _key67++)args[_key67] = arguments[_key67];
            return $786b46ea7ddafaee$export$f6e36f80a8190133(editor, ...args);
        },
        splitNodes: function splitNodes$1() {
            for(var _len68 = arguments.length, args = new Array(_len68), _key68 = 0; _key68 < _len68; _key68++)args[_key68] = arguments[_key68];
            return $786b46ea7ddafaee$export$8cae13a34cef6097(editor, ...args);
        },
        start: function start$1() {
            for(var _len69 = arguments.length, args = new Array(_len69), _key69 = 0; _key69 < _len69; _key69++)args[_key69] = arguments[_key69];
            return $786b46ea7ddafaee$export$b3571188c770cc5a(editor, ...args);
        },
        string: function string$1() {
            for(var _len70 = arguments.length, args = new Array(_len70), _key70 = 0; _key70 < _len70; _key70++)args[_key70] = arguments[_key70];
            return $786b46ea7ddafaee$export$22b082955e083ec3(editor, ...args);
        },
        unhangRange: function unhangRange$1() {
            for(var _len71 = arguments.length, args = new Array(_len71), _key71 = 0; _key71 < _len71; _key71++)args[_key71] = arguments[_key71];
            return $786b46ea7ddafaee$export$5bbda963d3cff9cf(editor, ...args);
        },
        unsetNodes: function unsetNodes$1() {
            for(var _len72 = arguments.length, args = new Array(_len72), _key72 = 0; _key72 < _len72; _key72++)args[_key72] = arguments[_key72];
            return $786b46ea7ddafaee$export$6ba811b1d416e3b0(editor, ...args);
        },
        unwrapNodes: function unwrapNodes$1() {
            for(var _len73 = arguments.length, args = new Array(_len73), _key73 = 0; _key73 < _len73; _key73++)args[_key73] = arguments[_key73];
            return $786b46ea7ddafaee$export$e992688ecb704d56(editor, ...args);
        },
        void: function _void() {
            for(var _len74 = arguments.length, args = new Array(_len74), _key74 = 0; _key74 < _len74; _key74++)args[_key74] = arguments[_key74];
            return $786b46ea7ddafaee$export$a03ecfa95a44c405(editor, ...args);
        },
        withoutNormalizing: function withoutNormalizing$1() {
            for(var _len75 = arguments.length, args = new Array(_len75), _key75 = 0; _key75 < _len75; _key75++)args[_key75] = arguments[_key75];
            return $786b46ea7ddafaee$export$2a1709eb902e594d(editor, ...args);
        },
        wrapNodes: function wrapNodes$1() {
            for(var _len76 = arguments.length, args = new Array(_len76), _key76 = 0; _key76 < _len76; _key76++)args[_key76] = arguments[_key76];
            return $786b46ea7ddafaee$export$e10a714a452c78c8(editor, ...args);
        },
        shouldMergeNodesRemovePrevNode: function shouldMergeNodesRemovePrevNode$1() {
            for(var _len77 = arguments.length, args = new Array(_len77), _key77 = 0; _key77 < _len77; _key77++)args[_key77] = arguments[_key77];
            return $786b46ea7ddafaee$export$efaf25ec32264289(editor, ...args);
        }
    };
    return editor;
};

});
parcelRegister("lmEbS", function(module, exports) {

$parcel$export(module.exports, "isPlainObject", function () { return $36c904b40dbf7456$export$53b83ca8eaab0383; });
/*!
 * is-plain-object <https://github.com/jonschlinkert/is-plain-object>
 *
 * Copyright (c) 2014-2017, Jon Schlinkert.
 * Released under the MIT License.
 */ function $36c904b40dbf7456$var$isObject(o) {
    return Object.prototype.toString.call(o) === "[object Object]";
}
function $36c904b40dbf7456$export$53b83ca8eaab0383(o) {
    var ctor, prot;
    if ($36c904b40dbf7456$var$isObject(o) === false) return false;
    // If has modified constructor
    ctor = o.constructor;
    if (ctor === undefined) return true;
    // If has modified prototype
    prot = ctor.prototype;
    if ($36c904b40dbf7456$var$isObject(prot) === false) return false;
    // If constructor does not have an Object-specific method
    if (prot.hasOwnProperty("isPrototypeOf") === false) return false;
    // Most likely a plain Object
    return true;
}

});

parcelRegister("6JaFW", function(module, exports) {

$parcel$export(module.exports, "isDraft", function () { return $4e5f39ff88a07be9$export$541ac630993a4c84; });
$parcel$export(module.exports, "produce", function () { return $4e5f39ff88a07be9$export$b46cabe22e78bc00; });
$parcel$export(module.exports, "createDraft", function () { return $4e5f39ff88a07be9$export$3c3214997190395f; });
$parcel$export(module.exports, "finishDraft", function () { return $4e5f39ff88a07be9$export$c60f5e69c521b528; });
var $4e5f39ff88a07be9$var$__defProp = Object.defineProperty;
var $4e5f39ff88a07be9$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $4e5f39ff88a07be9$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $4e5f39ff88a07be9$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $4e5f39ff88a07be9$var$__defNormalProp = (obj, key, value)=>key in obj ? $4e5f39ff88a07be9$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $4e5f39ff88a07be9$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($4e5f39ff88a07be9$var$__hasOwnProp.call(b, prop)) $4e5f39ff88a07be9$var$__defNormalProp(a, prop, b[prop]);
    if ($4e5f39ff88a07be9$var$__getOwnPropSymbols) {
        for (var prop of $4e5f39ff88a07be9$var$__getOwnPropSymbols(b))if ($4e5f39ff88a07be9$var$__propIsEnum.call(b, prop)) $4e5f39ff88a07be9$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
// src/utils/env.ts
var $4e5f39ff88a07be9$export$45b790e32b2810ee = Symbol.for("immer-nothing");
var $4e5f39ff88a07be9$export$6ee2082928bcb0ee = Symbol.for("immer-draftable");
var $4e5f39ff88a07be9$var$DRAFT_STATE = Symbol.for("immer-state");
// src/utils/errors.ts
var $4e5f39ff88a07be9$var$errors = [];
function $4e5f39ff88a07be9$var$die(error, ...args) {
    throw new Error(`[Immer] minified error nr: ${error}. Full error at: https://bit.ly/3cXEKWf`);
}
// src/utils/common.ts
var $4e5f39ff88a07be9$var$getPrototypeOf = Object.getPrototypeOf;
function $4e5f39ff88a07be9$export$541ac630993a4c84(value) {
    return !!value && !!value[$4e5f39ff88a07be9$var$DRAFT_STATE];
}
function $4e5f39ff88a07be9$export$16e3aed3edb85946(value) {
    var _a;
    if (!value) return false;
    return $4e5f39ff88a07be9$var$isPlainObject(value) || Array.isArray(value) || !!value[$4e5f39ff88a07be9$export$6ee2082928bcb0ee] || !!((_a = value.constructor) == null ? void 0 : _a[$4e5f39ff88a07be9$export$6ee2082928bcb0ee]) || $4e5f39ff88a07be9$var$isMap(value) || $4e5f39ff88a07be9$var$isSet(value);
}
var $4e5f39ff88a07be9$var$objectCtorString = Object.prototype.constructor.toString();
function $4e5f39ff88a07be9$var$isPlainObject(value) {
    if (!value || typeof value !== "object") return false;
    const proto = $4e5f39ff88a07be9$var$getPrototypeOf(value);
    if (proto === null) return true;
    const Ctor = Object.hasOwnProperty.call(proto, "constructor") && proto.constructor;
    if (Ctor === Object) return true;
    return typeof Ctor == "function" && Function.toString.call(Ctor) === $4e5f39ff88a07be9$var$objectCtorString;
}
function $4e5f39ff88a07be9$export$22e8af3f75a010e3(value) {
    if (!$4e5f39ff88a07be9$export$541ac630993a4c84(value)) $4e5f39ff88a07be9$var$die(15, value);
    return value[$4e5f39ff88a07be9$var$DRAFT_STATE].base_;
}
function $4e5f39ff88a07be9$var$each(obj, iter) {
    if ($4e5f39ff88a07be9$var$getArchtype(obj) === 0 /* Object */ ) Reflect.ownKeys(obj).forEach((key)=>{
        iter(key, obj[key], obj);
    });
    else obj.forEach((entry, index)=>iter(index, entry, obj));
}
function $4e5f39ff88a07be9$var$getArchtype(thing) {
    const state = thing[$4e5f39ff88a07be9$var$DRAFT_STATE];
    return state ? state.type_ : Array.isArray(thing) ? 1 /* Array */  : $4e5f39ff88a07be9$var$isMap(thing) ? 2 /* Map */  : $4e5f39ff88a07be9$var$isSet(thing) ? 3 /* Set */  : 0 /* Object */ ;
}
function $4e5f39ff88a07be9$var$has(thing, prop) {
    return $4e5f39ff88a07be9$var$getArchtype(thing) === 2 /* Map */  ? thing.has(prop) : Object.prototype.hasOwnProperty.call(thing, prop);
}
function $4e5f39ff88a07be9$var$get(thing, prop) {
    return $4e5f39ff88a07be9$var$getArchtype(thing) === 2 /* Map */  ? thing.get(prop) : thing[prop];
}
function $4e5f39ff88a07be9$var$set(thing, propOrOldValue, value) {
    const t = $4e5f39ff88a07be9$var$getArchtype(thing);
    if (t === 2 /* Map */ ) thing.set(propOrOldValue, value);
    else if (t === 3 /* Set */ ) thing.add(value);
    else thing[propOrOldValue] = value;
}
function $4e5f39ff88a07be9$var$is(x, y) {
    if (x === y) return x !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $4e5f39ff88a07be9$var$isMap(target) {
    return target instanceof Map;
}
function $4e5f39ff88a07be9$var$isSet(target) {
    return target instanceof Set;
}
function $4e5f39ff88a07be9$var$latest(state) {
    return state.copy_ || state.base_;
}
function $4e5f39ff88a07be9$var$shallowCopy(base, strict) {
    if ($4e5f39ff88a07be9$var$isMap(base)) return new Map(base);
    if ($4e5f39ff88a07be9$var$isSet(base)) return new Set(base);
    if (Array.isArray(base)) return Array.prototype.slice.call(base);
    const isPlain = $4e5f39ff88a07be9$var$isPlainObject(base);
    if (strict === true || strict === "class_only" && !isPlain) {
        const descriptors = Object.getOwnPropertyDescriptors(base);
        delete descriptors[$4e5f39ff88a07be9$var$DRAFT_STATE];
        let keys = Reflect.ownKeys(descriptors);
        for(let i = 0; i < keys.length; i++){
            const key = keys[i];
            const desc = descriptors[key];
            if (desc.writable === false) {
                desc.writable = true;
                desc.configurable = true;
            }
            if (desc.get || desc.set) descriptors[key] = {
                configurable: true,
                writable: true,
                // could live with !!desc.set as well here...
                enumerable: desc.enumerable,
                value: base[key]
            };
        }
        return Object.create($4e5f39ff88a07be9$var$getPrototypeOf(base), descriptors);
    } else {
        const proto = $4e5f39ff88a07be9$var$getPrototypeOf(base);
        if (proto !== null && isPlain) return $4e5f39ff88a07be9$var$__spreadValues({}, base);
        const obj = Object.create(proto);
        return Object.assign(obj, base);
    }
}
function $4e5f39ff88a07be9$export$792f3d81ea979f55(obj, deep = false) {
    if ($4e5f39ff88a07be9$var$isFrozen(obj) || $4e5f39ff88a07be9$export$541ac630993a4c84(obj) || !$4e5f39ff88a07be9$export$16e3aed3edb85946(obj)) return obj;
    if ($4e5f39ff88a07be9$var$getArchtype(obj) > 1) obj.set = obj.add = obj.clear = obj.delete = $4e5f39ff88a07be9$var$dontMutateFrozenCollections;
    Object.freeze(obj);
    if (deep) Object.entries(obj).forEach(([key, value])=>$4e5f39ff88a07be9$export$792f3d81ea979f55(value, true));
    return obj;
}
function $4e5f39ff88a07be9$var$dontMutateFrozenCollections() {
    $4e5f39ff88a07be9$var$die(2);
}
function $4e5f39ff88a07be9$var$isFrozen(obj) {
    return Object.isFrozen(obj);
}
// src/utils/plugins.ts
var $4e5f39ff88a07be9$var$plugins = {};
function $4e5f39ff88a07be9$var$getPlugin(pluginKey) {
    const plugin = $4e5f39ff88a07be9$var$plugins[pluginKey];
    if (!plugin) $4e5f39ff88a07be9$var$die(0, pluginKey);
    return plugin;
}
function $4e5f39ff88a07be9$var$loadPlugin(pluginKey, implementation) {
    if (!$4e5f39ff88a07be9$var$plugins[pluginKey]) $4e5f39ff88a07be9$var$plugins[pluginKey] = implementation;
}
// src/core/scope.ts
var $4e5f39ff88a07be9$var$currentScope;
function $4e5f39ff88a07be9$var$getCurrentScope() {
    return $4e5f39ff88a07be9$var$currentScope;
}
function $4e5f39ff88a07be9$var$createScope(parent_, immer_) {
    return {
        drafts_: [],
        parent_: parent_,
        immer_: immer_,
        // Whenever the modified draft contains a draft from another scope, we
        // need to prevent auto-freezing so the unowned draft can be finalized.
        canAutoFreeze_: true,
        unfinalizedDrafts_: 0
    };
}
function $4e5f39ff88a07be9$var$usePatchesInScope(scope, patchListener) {
    if (patchListener) {
        $4e5f39ff88a07be9$var$getPlugin("Patches");
        scope.patches_ = [];
        scope.inversePatches_ = [];
        scope.patchListener_ = patchListener;
    }
}
function $4e5f39ff88a07be9$var$revokeScope(scope) {
    $4e5f39ff88a07be9$var$leaveScope(scope);
    scope.drafts_.forEach($4e5f39ff88a07be9$var$revokeDraft);
    scope.drafts_ = null;
}
function $4e5f39ff88a07be9$var$leaveScope(scope) {
    if (scope === $4e5f39ff88a07be9$var$currentScope) $4e5f39ff88a07be9$var$currentScope = scope.parent_;
}
function $4e5f39ff88a07be9$var$enterScope(immer2) {
    return $4e5f39ff88a07be9$var$currentScope = $4e5f39ff88a07be9$var$createScope($4e5f39ff88a07be9$var$currentScope, immer2);
}
function $4e5f39ff88a07be9$var$revokeDraft(draft) {
    const state = draft[$4e5f39ff88a07be9$var$DRAFT_STATE];
    if (state.type_ === 0 /* Object */  || state.type_ === 1 /* Array */ ) state.revoke_();
    else state.revoked_ = true;
}
// src/core/finalize.ts
function $4e5f39ff88a07be9$var$processResult(result, scope) {
    scope.unfinalizedDrafts_ = scope.drafts_.length;
    const baseDraft = scope.drafts_[0];
    const isReplaced = result !== void 0 && result !== baseDraft;
    if (isReplaced) {
        if (baseDraft[$4e5f39ff88a07be9$var$DRAFT_STATE].modified_) {
            $4e5f39ff88a07be9$var$revokeScope(scope);
            $4e5f39ff88a07be9$var$die(4);
        }
        if ($4e5f39ff88a07be9$export$16e3aed3edb85946(result)) {
            result = $4e5f39ff88a07be9$var$finalize(scope, result);
            if (!scope.parent_) $4e5f39ff88a07be9$var$maybeFreeze(scope, result);
        }
        if (scope.patches_) $4e5f39ff88a07be9$var$getPlugin("Patches").generateReplacementPatches_(baseDraft[$4e5f39ff88a07be9$var$DRAFT_STATE].base_, result, scope.patches_, scope.inversePatches_);
    } else result = $4e5f39ff88a07be9$var$finalize(scope, baseDraft, []);
    $4e5f39ff88a07be9$var$revokeScope(scope);
    if (scope.patches_) scope.patchListener_(scope.patches_, scope.inversePatches_);
    return result !== $4e5f39ff88a07be9$export$45b790e32b2810ee ? result : void 0;
}
function $4e5f39ff88a07be9$var$finalize(rootScope, value, path) {
    if ($4e5f39ff88a07be9$var$isFrozen(value)) return value;
    const state = value[$4e5f39ff88a07be9$var$DRAFT_STATE];
    if (!state) {
        $4e5f39ff88a07be9$var$each(value, (key, childValue)=>$4e5f39ff88a07be9$var$finalizeProperty(rootScope, state, value, key, childValue, path));
        return value;
    }
    if (state.scope_ !== rootScope) return value;
    if (!state.modified_) {
        $4e5f39ff88a07be9$var$maybeFreeze(rootScope, state.base_, true);
        return state.base_;
    }
    if (!state.finalized_) {
        state.finalized_ = true;
        state.scope_.unfinalizedDrafts_--;
        const result = state.copy_;
        let resultEach = result;
        let isSet2 = false;
        if (state.type_ === 3 /* Set */ ) {
            resultEach = new Set(result);
            result.clear();
            isSet2 = true;
        }
        $4e5f39ff88a07be9$var$each(resultEach, (key, childValue)=>$4e5f39ff88a07be9$var$finalizeProperty(rootScope, state, result, key, childValue, path, isSet2));
        $4e5f39ff88a07be9$var$maybeFreeze(rootScope, result, false);
        if (path && rootScope.patches_) $4e5f39ff88a07be9$var$getPlugin("Patches").generatePatches_(state, path, rootScope.patches_, rootScope.inversePatches_);
    }
    return state.copy_;
}
function $4e5f39ff88a07be9$var$finalizeProperty(rootScope, parentState, targetObject, prop, childValue, rootPath, targetIsSet) {
    if ($4e5f39ff88a07be9$export$541ac630993a4c84(childValue)) {
        const path = rootPath && parentState && parentState.type_ !== 3 /* Set */  && // Set objects are atomic since they have no keys.
        !$4e5f39ff88a07be9$var$has(parentState.assigned_, prop) ? rootPath.concat(prop) : void 0;
        const res = $4e5f39ff88a07be9$var$finalize(rootScope, childValue, path);
        $4e5f39ff88a07be9$var$set(targetObject, prop, res);
        if ($4e5f39ff88a07be9$export$541ac630993a4c84(res)) rootScope.canAutoFreeze_ = false;
        else return;
    } else if (targetIsSet) targetObject.add(childValue);
    if ($4e5f39ff88a07be9$export$16e3aed3edb85946(childValue) && !$4e5f39ff88a07be9$var$isFrozen(childValue)) {
        if (!rootScope.immer_.autoFreeze_ && rootScope.unfinalizedDrafts_ < 1) return;
        $4e5f39ff88a07be9$var$finalize(rootScope, childValue);
        if ((!parentState || !parentState.scope_.parent_) && typeof prop !== "symbol" && Object.prototype.propertyIsEnumerable.call(targetObject, prop)) $4e5f39ff88a07be9$var$maybeFreeze(rootScope, childValue);
    }
}
function $4e5f39ff88a07be9$var$maybeFreeze(scope, value, deep = false) {
    if (!scope.parent_ && scope.immer_.autoFreeze_ && scope.canAutoFreeze_) $4e5f39ff88a07be9$export$792f3d81ea979f55(value, deep);
}
// src/core/proxy.ts
function $4e5f39ff88a07be9$var$createProxyProxy(base, parent) {
    const isArray = Array.isArray(base);
    const state = {
        type_: isArray ? 1 /* Array */  : 0 /* Object */ ,
        // Track which produce call this is associated with.
        scope_: parent ? parent.scope_ : $4e5f39ff88a07be9$var$getCurrentScope(),
        // True for both shallow and deep changes.
        modified_: false,
        // Used during finalization.
        finalized_: false,
        // Track which properties have been assigned (true) or deleted (false).
        assigned_: {},
        // The parent draft state.
        parent_: parent,
        // The base state.
        base_: base,
        // The base proxy.
        draft_: null,
        // set below
        // The base copy with any updated values.
        copy_: null,
        // Called by the `produce` function.
        revoke_: null,
        isManual_: false
    };
    let target = state;
    let traps = $4e5f39ff88a07be9$var$objectTraps;
    if (isArray) {
        target = [
            state
        ];
        traps = $4e5f39ff88a07be9$var$arrayTraps;
    }
    const { revoke: revoke, proxy: proxy } = Proxy.revocable(target, traps);
    state.draft_ = proxy;
    state.revoke_ = revoke;
    return proxy;
}
var $4e5f39ff88a07be9$var$objectTraps = {
    get (state, prop) {
        if (prop === $4e5f39ff88a07be9$var$DRAFT_STATE) return state;
        const source = $4e5f39ff88a07be9$var$latest(state);
        if (!$4e5f39ff88a07be9$var$has(source, prop)) return $4e5f39ff88a07be9$var$readPropFromProto(state, source, prop);
        const value = source[prop];
        if (state.finalized_ || !$4e5f39ff88a07be9$export$16e3aed3edb85946(value)) return value;
        if (value === $4e5f39ff88a07be9$var$peek(state.base_, prop)) {
            $4e5f39ff88a07be9$var$prepareCopy(state);
            return state.copy_[prop] = $4e5f39ff88a07be9$var$createProxy(value, state);
        }
        return value;
    },
    has (state, prop) {
        return prop in $4e5f39ff88a07be9$var$latest(state);
    },
    ownKeys (state) {
        return Reflect.ownKeys($4e5f39ff88a07be9$var$latest(state));
    },
    set (state, prop, value) {
        const desc = $4e5f39ff88a07be9$var$getDescriptorFromProto($4e5f39ff88a07be9$var$latest(state), prop);
        if (desc == null ? void 0 : desc.set) {
            desc.set.call(state.draft_, value);
            return true;
        }
        if (!state.modified_) {
            const current2 = $4e5f39ff88a07be9$var$peek($4e5f39ff88a07be9$var$latest(state), prop);
            const currentState = current2 == null ? void 0 : current2[$4e5f39ff88a07be9$var$DRAFT_STATE];
            if (currentState && currentState.base_ === value) {
                state.copy_[prop] = value;
                state.assigned_[prop] = false;
                return true;
            }
            if ($4e5f39ff88a07be9$var$is(value, current2) && (value !== void 0 || $4e5f39ff88a07be9$var$has(state.base_, prop))) return true;
            $4e5f39ff88a07be9$var$prepareCopy(state);
            $4e5f39ff88a07be9$var$markChanged(state);
        }
        if (state.copy_[prop] === value && // special case: handle new props with value 'undefined'
        (value !== void 0 || prop in state.copy_) || // special case: NaN
        Number.isNaN(value) && Number.isNaN(state.copy_[prop])) return true;
        state.copy_[prop] = value;
        state.assigned_[prop] = true;
        return true;
    },
    deleteProperty (state, prop) {
        if ($4e5f39ff88a07be9$var$peek(state.base_, prop) !== void 0 || prop in state.base_) {
            state.assigned_[prop] = false;
            $4e5f39ff88a07be9$var$prepareCopy(state);
            $4e5f39ff88a07be9$var$markChanged(state);
        } else delete state.assigned_[prop];
        if (state.copy_) delete state.copy_[prop];
        return true;
    },
    // Note: We never coerce `desc.value` into an Immer draft, because we can't make
    // the same guarantee in ES5 mode.
    getOwnPropertyDescriptor (state, prop) {
        const owner = $4e5f39ff88a07be9$var$latest(state);
        const desc = Reflect.getOwnPropertyDescriptor(owner, prop);
        if (!desc) return desc;
        return {
            writable: true,
            configurable: state.type_ !== 1 /* Array */  || prop !== "length",
            enumerable: desc.enumerable,
            value: owner[prop]
        };
    },
    defineProperty () {
        $4e5f39ff88a07be9$var$die(11);
    },
    getPrototypeOf (state) {
        return $4e5f39ff88a07be9$var$getPrototypeOf(state.base_);
    },
    setPrototypeOf () {
        $4e5f39ff88a07be9$var$die(12);
    }
};
var $4e5f39ff88a07be9$var$arrayTraps = {};
$4e5f39ff88a07be9$var$each($4e5f39ff88a07be9$var$objectTraps, (key, fn)=>{
    $4e5f39ff88a07be9$var$arrayTraps[key] = function() {
        arguments[0] = arguments[0][0];
        return fn.apply(this, arguments);
    };
});
$4e5f39ff88a07be9$var$arrayTraps.deleteProperty = function(state, prop) {
    return $4e5f39ff88a07be9$var$arrayTraps.set.call(this, state, prop, void 0);
};
$4e5f39ff88a07be9$var$arrayTraps.set = function(state, prop, value) {
    return $4e5f39ff88a07be9$var$objectTraps.set.call(this, state[0], prop, value, state[0]);
};
function $4e5f39ff88a07be9$var$peek(draft, prop) {
    const state = draft[$4e5f39ff88a07be9$var$DRAFT_STATE];
    const source = state ? $4e5f39ff88a07be9$var$latest(state) : draft;
    return source[prop];
}
function $4e5f39ff88a07be9$var$readPropFromProto(state, source, prop) {
    var _a;
    const desc = $4e5f39ff88a07be9$var$getDescriptorFromProto(source, prop);
    return desc ? `value` in desc ? desc.value : // This is a very special case, if the prop is a getter defined by the
    // prototype, we should invoke it with the draft as context!
    (_a = desc.get) == null ? void 0 : _a.call(state.draft_) : void 0;
}
function $4e5f39ff88a07be9$var$getDescriptorFromProto(source, prop) {
    if (!(prop in source)) return void 0;
    let proto = $4e5f39ff88a07be9$var$getPrototypeOf(source);
    while(proto){
        const desc = Object.getOwnPropertyDescriptor(proto, prop);
        if (desc) return desc;
        proto = $4e5f39ff88a07be9$var$getPrototypeOf(proto);
    }
    return void 0;
}
function $4e5f39ff88a07be9$var$markChanged(state) {
    if (!state.modified_) {
        state.modified_ = true;
        if (state.parent_) $4e5f39ff88a07be9$var$markChanged(state.parent_);
    }
}
function $4e5f39ff88a07be9$var$prepareCopy(state) {
    if (!state.copy_) state.copy_ = $4e5f39ff88a07be9$var$shallowCopy(state.base_, state.scope_.immer_.useStrictShallowCopy_);
}
// src/core/immerClass.ts
var $4e5f39ff88a07be9$export$aaadc6ff0f822719 = class {
    constructor(config){
        this.autoFreeze_ = true;
        this.useStrictShallowCopy_ = false;
        /**
     * The `produce` function takes a value and a "recipe function" (whose
     * return value often depends on the base state). The recipe function is
     * free to mutate its first argument however it wants. All mutations are
     * only ever applied to a __copy__ of the base state.
     *
     * Pass only a function to create a "curried producer" which relieves you
     * from passing the recipe function every time.
     *
     * Only plain objects and arrays are made mutable. All other objects are
     * considered uncopyable.
     *
     * Note: This function is __bound__ to its `Immer` instance.
     *
     * @param {any} base - the initial state
     * @param {Function} recipe - function that receives a proxy of the base state as first argument and which can be freely modified
     * @param {Function} patchListener - optional function that will be called with all the patches produced here
     * @returns {any} a new state, or the initial state if nothing was modified
     */ this.produce = (base, recipe, patchListener)=>{
            if (typeof base === "function" && typeof recipe !== "function") {
                const defaultBase = recipe;
                recipe = base;
                const self = this;
                return function curriedProduce(base2 = defaultBase, ...args) {
                    return self.produce(base2, (draft)=>recipe.call(this, draft, ...args));
                };
            }
            if (typeof recipe !== "function") $4e5f39ff88a07be9$var$die(6);
            if (patchListener !== void 0 && typeof patchListener !== "function") $4e5f39ff88a07be9$var$die(7);
            let result;
            if ($4e5f39ff88a07be9$export$16e3aed3edb85946(base)) {
                const scope = $4e5f39ff88a07be9$var$enterScope(this);
                const proxy = $4e5f39ff88a07be9$var$createProxy(base, void 0);
                let hasError = true;
                try {
                    result = recipe(proxy);
                    hasError = false;
                } finally{
                    if (hasError) $4e5f39ff88a07be9$var$revokeScope(scope);
                    else $4e5f39ff88a07be9$var$leaveScope(scope);
                }
                $4e5f39ff88a07be9$var$usePatchesInScope(scope, patchListener);
                return $4e5f39ff88a07be9$var$processResult(result, scope);
            } else if (!base || typeof base !== "object") {
                result = recipe(base);
                if (result === void 0) result = base;
                if (result === $4e5f39ff88a07be9$export$45b790e32b2810ee) result = void 0;
                if (this.autoFreeze_) $4e5f39ff88a07be9$export$792f3d81ea979f55(result, true);
                if (patchListener) {
                    const p = [];
                    const ip = [];
                    $4e5f39ff88a07be9$var$getPlugin("Patches").generateReplacementPatches_(base, result, p, ip);
                    patchListener(p, ip);
                }
                return result;
            } else $4e5f39ff88a07be9$var$die(1, base);
        };
        this.produceWithPatches = (base, recipe)=>{
            if (typeof base === "function") return (state, ...args)=>this.produceWithPatches(state, (draft)=>base(draft, ...args));
            let patches, inversePatches;
            const result = this.produce(base, recipe, (p, ip)=>{
                patches = p;
                inversePatches = ip;
            });
            return [
                result,
                patches,
                inversePatches
            ];
        };
        if (typeof (config == null ? void 0 : config.autoFreeze) === "boolean") this.setAutoFreeze(config.autoFreeze);
        if (typeof (config == null ? void 0 : config.useStrictShallowCopy) === "boolean") this.setUseStrictShallowCopy(config.useStrictShallowCopy);
    }
    createDraft(base) {
        if (!$4e5f39ff88a07be9$export$16e3aed3edb85946(base)) $4e5f39ff88a07be9$var$die(8);
        if ($4e5f39ff88a07be9$export$541ac630993a4c84(base)) base = $4e5f39ff88a07be9$export$97aac956da55dae9(base);
        const scope = $4e5f39ff88a07be9$var$enterScope(this);
        const proxy = $4e5f39ff88a07be9$var$createProxy(base, void 0);
        proxy[$4e5f39ff88a07be9$var$DRAFT_STATE].isManual_ = true;
        $4e5f39ff88a07be9$var$leaveScope(scope);
        return proxy;
    }
    finishDraft(draft, patchListener) {
        const state = draft && draft[$4e5f39ff88a07be9$var$DRAFT_STATE];
        if (!state || !state.isManual_) $4e5f39ff88a07be9$var$die(9);
        const { scope_: scope } = state;
        $4e5f39ff88a07be9$var$usePatchesInScope(scope, patchListener);
        return $4e5f39ff88a07be9$var$processResult(void 0, scope);
    }
    /**
   * Pass true to automatically freeze all copies created by Immer.
   *
   * By default, auto-freezing is enabled.
   */ setAutoFreeze(value) {
        this.autoFreeze_ = value;
    }
    /**
   * Pass true to enable strict shallow copy.
   *
   * By default, immer does not copy the object descriptors such as getter, setter and non-enumrable properties.
   */ setUseStrictShallowCopy(value) {
        this.useStrictShallowCopy_ = value;
    }
    applyPatches(base, patches) {
        let i;
        for(i = patches.length - 1; i >= 0; i--){
            const patch = patches[i];
            if (patch.path.length === 0 && patch.op === "replace") {
                base = patch.value;
                break;
            }
        }
        if (i > -1) patches = patches.slice(i + 1);
        const applyPatchesImpl = $4e5f39ff88a07be9$var$getPlugin("Patches").applyPatches_;
        if ($4e5f39ff88a07be9$export$541ac630993a4c84(base)) return applyPatchesImpl(base, patches);
        return this.produce(base, (draft)=>applyPatchesImpl(draft, patches));
    }
};
function $4e5f39ff88a07be9$var$createProxy(value, parent) {
    const draft = $4e5f39ff88a07be9$var$isMap(value) ? $4e5f39ff88a07be9$var$getPlugin("MapSet").proxyMap_(value, parent) : $4e5f39ff88a07be9$var$isSet(value) ? $4e5f39ff88a07be9$var$getPlugin("MapSet").proxySet_(value, parent) : $4e5f39ff88a07be9$var$createProxyProxy(value, parent);
    const scope = parent ? parent.scope_ : $4e5f39ff88a07be9$var$getCurrentScope();
    scope.drafts_.push(draft);
    return draft;
}
// src/core/current.ts
function $4e5f39ff88a07be9$export$97aac956da55dae9(value) {
    if (!$4e5f39ff88a07be9$export$541ac630993a4c84(value)) $4e5f39ff88a07be9$var$die(10, value);
    return $4e5f39ff88a07be9$var$currentImpl(value);
}
function $4e5f39ff88a07be9$var$currentImpl(value) {
    if (!$4e5f39ff88a07be9$export$16e3aed3edb85946(value) || $4e5f39ff88a07be9$var$isFrozen(value)) return value;
    const state = value[$4e5f39ff88a07be9$var$DRAFT_STATE];
    let copy;
    if (state) {
        if (!state.modified_) return state.base_;
        state.finalized_ = true;
        copy = $4e5f39ff88a07be9$var$shallowCopy(value, state.scope_.immer_.useStrictShallowCopy_);
    } else copy = $4e5f39ff88a07be9$var$shallowCopy(value, true);
    $4e5f39ff88a07be9$var$each(copy, (key, childValue)=>{
        $4e5f39ff88a07be9$var$set(copy, key, $4e5f39ff88a07be9$var$currentImpl(childValue));
    });
    if (state) state.finalized_ = false;
    return copy;
}
// src/plugins/patches.ts
function $4e5f39ff88a07be9$export$d3a6659991a0696c() {
    const errorOffset = 16;
    const REPLACE = "replace";
    const ADD = "add";
    const REMOVE = "remove";
    function generatePatches_(state, basePath, patches, inversePatches) {
        switch(state.type_){
            case 0 /* Object */ :
            case 2 /* Map */ :
                return generatePatchesFromAssigned(state, basePath, patches, inversePatches);
            case 1 /* Array */ :
                return generateArrayPatches(state, basePath, patches, inversePatches);
            case 3 /* Set */ :
                return generateSetPatches(state, basePath, patches, inversePatches);
        }
    }
    function generateArrayPatches(state, basePath, patches, inversePatches) {
        let { base_: base_, assigned_: assigned_ } = state;
        let copy_ = state.copy_;
        if (copy_.length < base_.length) {
            [base_, copy_] = [
                copy_,
                base_
            ];
            [patches, inversePatches] = [
                inversePatches,
                patches
            ];
        }
        for(let i = 0; i < base_.length; i++)if (assigned_[i] && copy_[i] !== base_[i]) {
            const path = basePath.concat([
                i
            ]);
            patches.push({
                op: REPLACE,
                path: path,
                // Need to maybe clone it, as it can in fact be the original value
                // due to the base/copy inversion at the start of this function
                value: clonePatchValueIfNeeded(copy_[i])
            });
            inversePatches.push({
                op: REPLACE,
                path: path,
                value: clonePatchValueIfNeeded(base_[i])
            });
        }
        for(let i = base_.length; i < copy_.length; i++){
            const path = basePath.concat([
                i
            ]);
            patches.push({
                op: ADD,
                path: path,
                // Need to maybe clone it, as it can in fact be the original value
                // due to the base/copy inversion at the start of this function
                value: clonePatchValueIfNeeded(copy_[i])
            });
        }
        for(let i = copy_.length - 1; base_.length <= i; --i){
            const path = basePath.concat([
                i
            ]);
            inversePatches.push({
                op: REMOVE,
                path: path
            });
        }
    }
    function generatePatchesFromAssigned(state, basePath, patches, inversePatches) {
        const { base_: base_, copy_: copy_ } = state;
        $4e5f39ff88a07be9$var$each(state.assigned_, (key, assignedValue)=>{
            const origValue = $4e5f39ff88a07be9$var$get(base_, key);
            const value = $4e5f39ff88a07be9$var$get(copy_, key);
            const op = !assignedValue ? REMOVE : $4e5f39ff88a07be9$var$has(base_, key) ? REPLACE : ADD;
            if (origValue === value && op === REPLACE) return;
            const path = basePath.concat(key);
            patches.push(op === REMOVE ? {
                op: op,
                path: path
            } : {
                op: op,
                path: path,
                value: value
            });
            inversePatches.push(op === ADD ? {
                op: REMOVE,
                path: path
            } : op === REMOVE ? {
                op: ADD,
                path: path,
                value: clonePatchValueIfNeeded(origValue)
            } : {
                op: REPLACE,
                path: path,
                value: clonePatchValueIfNeeded(origValue)
            });
        });
    }
    function generateSetPatches(state, basePath, patches, inversePatches) {
        let { base_: base_, copy_: copy_ } = state;
        let i = 0;
        base_.forEach((value)=>{
            if (!copy_.has(value)) {
                const path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: REMOVE,
                    path: path,
                    value: value
                });
                inversePatches.unshift({
                    op: ADD,
                    path: path,
                    value: value
                });
            }
            i++;
        });
        i = 0;
        copy_.forEach((value)=>{
            if (!base_.has(value)) {
                const path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: ADD,
                    path: path,
                    value: value
                });
                inversePatches.unshift({
                    op: REMOVE,
                    path: path,
                    value: value
                });
            }
            i++;
        });
    }
    function generateReplacementPatches_(baseValue, replacement, patches, inversePatches) {
        patches.push({
            op: REPLACE,
            path: [],
            value: replacement === $4e5f39ff88a07be9$export$45b790e32b2810ee ? void 0 : replacement
        });
        inversePatches.push({
            op: REPLACE,
            path: [],
            value: baseValue
        });
    }
    function applyPatches_(draft, patches) {
        patches.forEach((patch)=>{
            const { path: path, op: op } = patch;
            let base = draft;
            for(let i = 0; i < path.length - 1; i++){
                const parentType = $4e5f39ff88a07be9$var$getArchtype(base);
                let p = path[i];
                if (typeof p !== "string" && typeof p !== "number") p = "" + p;
                if ((parentType === 0 /* Object */  || parentType === 1 /* Array */ ) && (p === "__proto__" || p === "constructor")) $4e5f39ff88a07be9$var$die(errorOffset + 3);
                if (typeof base === "function" && p === "prototype") $4e5f39ff88a07be9$var$die(errorOffset + 3);
                base = $4e5f39ff88a07be9$var$get(base, p);
                if (typeof base !== "object") $4e5f39ff88a07be9$var$die(errorOffset + 2, path.join("/"));
            }
            const type = $4e5f39ff88a07be9$var$getArchtype(base);
            const value = deepClonePatchValue(patch.value);
            const key = path[path.length - 1];
            switch(op){
                case REPLACE:
                    switch(type){
                        case 2 /* Map */ :
                            return base.set(key, value);
                        case 3 /* Set */ :
                            $4e5f39ff88a07be9$var$die(errorOffset);
                        default:
                            return base[key] = value;
                    }
                case ADD:
                    switch(type){
                        case 1 /* Array */ :
                            return key === "-" ? base.push(value) : base.splice(key, 0, value);
                        case 2 /* Map */ :
                            return base.set(key, value);
                        case 3 /* Set */ :
                            return base.add(value);
                        default:
                            return base[key] = value;
                    }
                case REMOVE:
                    switch(type){
                        case 1 /* Array */ :
                            return base.splice(key, 1);
                        case 2 /* Map */ :
                            return base.delete(key);
                        case 3 /* Set */ :
                            return base.delete(patch.value);
                        default:
                            return delete base[key];
                    }
                default:
                    $4e5f39ff88a07be9$var$die(errorOffset + 1, op);
            }
        });
        return draft;
    }
    function deepClonePatchValue(obj) {
        if (!$4e5f39ff88a07be9$export$16e3aed3edb85946(obj)) return obj;
        if (Array.isArray(obj)) return obj.map(deepClonePatchValue);
        if ($4e5f39ff88a07be9$var$isMap(obj)) return new Map(Array.from(obj.entries()).map(([k, v])=>[
                k,
                deepClonePatchValue(v)
            ]));
        if ($4e5f39ff88a07be9$var$isSet(obj)) return new Set(Array.from(obj).map(deepClonePatchValue));
        const cloned = Object.create($4e5f39ff88a07be9$var$getPrototypeOf(obj));
        for(const key in obj)cloned[key] = deepClonePatchValue(obj[key]);
        if ($4e5f39ff88a07be9$var$has(obj, $4e5f39ff88a07be9$export$6ee2082928bcb0ee)) cloned[$4e5f39ff88a07be9$export$6ee2082928bcb0ee] = obj[$4e5f39ff88a07be9$export$6ee2082928bcb0ee];
        return cloned;
    }
    function clonePatchValueIfNeeded(obj) {
        if ($4e5f39ff88a07be9$export$541ac630993a4c84(obj)) return deepClonePatchValue(obj);
        else return obj;
    }
    $4e5f39ff88a07be9$var$loadPlugin("Patches", {
        applyPatches_: applyPatches_,
        generatePatches_: generatePatches_,
        generateReplacementPatches_: generateReplacementPatches_
    });
}
// src/plugins/mapset.ts
function $4e5f39ff88a07be9$export$7d9f65390203b435() {
    class DraftMap extends Map {
        constructor(target, parent){
            super();
            this[$4e5f39ff88a07be9$var$DRAFT_STATE] = {
                type_: 2 /* Map */ ,
                parent_: parent,
                scope_: parent ? parent.scope_ : $4e5f39ff88a07be9$var$getCurrentScope(),
                modified_: false,
                finalized_: false,
                copy_: void 0,
                assigned_: void 0,
                base_: target,
                draft_: this,
                isManual_: false,
                revoked_: false
            };
        }
        get size() {
            return $4e5f39ff88a07be9$var$latest(this[$4e5f39ff88a07be9$var$DRAFT_STATE]).size;
        }
        has(key) {
            return $4e5f39ff88a07be9$var$latest(this[$4e5f39ff88a07be9$var$DRAFT_STATE]).has(key);
        }
        set(key, value) {
            const state = this[$4e5f39ff88a07be9$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!$4e5f39ff88a07be9$var$latest(state).has(key) || $4e5f39ff88a07be9$var$latest(state).get(key) !== value) {
                prepareMapCopy(state);
                $4e5f39ff88a07be9$var$markChanged(state);
                state.assigned_.set(key, true);
                state.copy_.set(key, value);
                state.assigned_.set(key, true);
            }
            return this;
        }
        delete(key) {
            if (!this.has(key)) return false;
            const state = this[$4e5f39ff88a07be9$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareMapCopy(state);
            $4e5f39ff88a07be9$var$markChanged(state);
            if (state.base_.has(key)) state.assigned_.set(key, false);
            else state.assigned_.delete(key);
            state.copy_.delete(key);
            return true;
        }
        clear() {
            const state = this[$4e5f39ff88a07be9$var$DRAFT_STATE];
            assertUnrevoked(state);
            if ($4e5f39ff88a07be9$var$latest(state).size) {
                prepareMapCopy(state);
                $4e5f39ff88a07be9$var$markChanged(state);
                state.assigned_ = /* @__PURE__ */ new Map();
                $4e5f39ff88a07be9$var$each(state.base_, (key)=>{
                    state.assigned_.set(key, false);
                });
                state.copy_.clear();
            }
        }
        forEach(cb, thisArg) {
            const state = this[$4e5f39ff88a07be9$var$DRAFT_STATE];
            $4e5f39ff88a07be9$var$latest(state).forEach((_value, key, _map)=>{
                cb.call(thisArg, this.get(key), key, this);
            });
        }
        get(key) {
            const state = this[$4e5f39ff88a07be9$var$DRAFT_STATE];
            assertUnrevoked(state);
            const value = $4e5f39ff88a07be9$var$latest(state).get(key);
            if (state.finalized_ || !$4e5f39ff88a07be9$export$16e3aed3edb85946(value)) return value;
            if (value !== state.base_.get(key)) return value;
            const draft = $4e5f39ff88a07be9$var$createProxy(value, state);
            prepareMapCopy(state);
            state.copy_.set(key, draft);
            return draft;
        }
        keys() {
            return $4e5f39ff88a07be9$var$latest(this[$4e5f39ff88a07be9$var$DRAFT_STATE]).keys();
        }
        values() {
            const iterator = this.keys();
            return {
                [Symbol.iterator]: ()=>this.values(),
                next: ()=>{
                    const r = iterator.next();
                    if (r.done) return r;
                    const value = this.get(r.value);
                    return {
                        done: false,
                        value: value
                    };
                }
            };
        }
        entries() {
            const iterator = this.keys();
            return {
                [Symbol.iterator]: ()=>this.entries(),
                next: ()=>{
                    const r = iterator.next();
                    if (r.done) return r;
                    const value = this.get(r.value);
                    return {
                        done: false,
                        value: [
                            r.value,
                            value
                        ]
                    };
                }
            };
        }
        [($4e5f39ff88a07be9$var$DRAFT_STATE, Symbol.iterator)]() {
            return this.entries();
        }
    }
    function proxyMap_(target, parent) {
        return new DraftMap(target, parent);
    }
    function prepareMapCopy(state) {
        if (!state.copy_) {
            state.assigned_ = /* @__PURE__ */ new Map();
            state.copy_ = new Map(state.base_);
        }
    }
    class DraftSet extends Set {
        constructor(target, parent){
            super();
            this[$4e5f39ff88a07be9$var$DRAFT_STATE] = {
                type_: 3 /* Set */ ,
                parent_: parent,
                scope_: parent ? parent.scope_ : $4e5f39ff88a07be9$var$getCurrentScope(),
                modified_: false,
                finalized_: false,
                copy_: void 0,
                base_: target,
                draft_: this,
                drafts_: /* @__PURE__ */ new Map(),
                revoked_: false,
                isManual_: false
            };
        }
        get size() {
            return $4e5f39ff88a07be9$var$latest(this[$4e5f39ff88a07be9$var$DRAFT_STATE]).size;
        }
        has(value) {
            const state = this[$4e5f39ff88a07be9$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!state.copy_) return state.base_.has(value);
            if (state.copy_.has(value)) return true;
            if (state.drafts_.has(value) && state.copy_.has(state.drafts_.get(value))) return true;
            return false;
        }
        add(value) {
            const state = this[$4e5f39ff88a07be9$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!this.has(value)) {
                prepareSetCopy(state);
                $4e5f39ff88a07be9$var$markChanged(state);
                state.copy_.add(value);
            }
            return this;
        }
        delete(value) {
            if (!this.has(value)) return false;
            const state = this[$4e5f39ff88a07be9$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            $4e5f39ff88a07be9$var$markChanged(state);
            return state.copy_.delete(value) || (state.drafts_.has(value) ? state.copy_.delete(state.drafts_.get(value)) : /* istanbul ignore next */ false);
        }
        clear() {
            const state = this[$4e5f39ff88a07be9$var$DRAFT_STATE];
            assertUnrevoked(state);
            if ($4e5f39ff88a07be9$var$latest(state).size) {
                prepareSetCopy(state);
                $4e5f39ff88a07be9$var$markChanged(state);
                state.copy_.clear();
            }
        }
        values() {
            const state = this[$4e5f39ff88a07be9$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            return state.copy_.values();
        }
        entries() {
            const state = this[$4e5f39ff88a07be9$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            return state.copy_.entries();
        }
        keys() {
            return this.values();
        }
        [($4e5f39ff88a07be9$var$DRAFT_STATE, Symbol.iterator)]() {
            return this.values();
        }
        forEach(cb, thisArg) {
            const iterator = this.values();
            let result = iterator.next();
            while(!result.done){
                cb.call(thisArg, result.value, result.value, this);
                result = iterator.next();
            }
        }
    }
    function proxySet_(target, parent) {
        return new DraftSet(target, parent);
    }
    function prepareSetCopy(state) {
        if (!state.copy_) {
            state.copy_ = /* @__PURE__ */ new Set();
            state.base_.forEach((value)=>{
                if ($4e5f39ff88a07be9$export$16e3aed3edb85946(value)) {
                    const draft = $4e5f39ff88a07be9$var$createProxy(value, state);
                    state.drafts_.set(value, draft);
                    state.copy_.add(draft);
                } else state.copy_.add(value);
            });
        }
    }
    function assertUnrevoked(state) {
        if (state.revoked_) $4e5f39ff88a07be9$var$die(3, JSON.stringify($4e5f39ff88a07be9$var$latest(state)));
    }
    $4e5f39ff88a07be9$var$loadPlugin("MapSet", {
        proxyMap_: proxyMap_,
        proxySet_: proxySet_
    });
}
// src/immer.ts
var $4e5f39ff88a07be9$var$immer = new $4e5f39ff88a07be9$export$aaadc6ff0f822719();
var $4e5f39ff88a07be9$export$b46cabe22e78bc00 = $4e5f39ff88a07be9$var$immer.produce;
var $4e5f39ff88a07be9$export$4da66d41c9492c78 = $4e5f39ff88a07be9$var$immer.produceWithPatches.bind($4e5f39ff88a07be9$var$immer);
var $4e5f39ff88a07be9$export$573f26f60825c493 = $4e5f39ff88a07be9$var$immer.setAutoFreeze.bind($4e5f39ff88a07be9$var$immer);
var $4e5f39ff88a07be9$export$333ce65961cbe047 = $4e5f39ff88a07be9$var$immer.setUseStrictShallowCopy.bind($4e5f39ff88a07be9$var$immer);
var $4e5f39ff88a07be9$export$a8b8e03e6bbe5473 = $4e5f39ff88a07be9$var$immer.applyPatches.bind($4e5f39ff88a07be9$var$immer);
var $4e5f39ff88a07be9$export$3c3214997190395f = $4e5f39ff88a07be9$var$immer.createDraft.bind($4e5f39ff88a07be9$var$immer);
var $4e5f39ff88a07be9$export$c60f5e69c521b528 = $4e5f39ff88a07be9$var$immer.finishDraft.bind($4e5f39ff88a07be9$var$immer);
function $4e5f39ff88a07be9$export$c05b21e3257751e5(value) {
    return value;
}
function $4e5f39ff88a07be9$export$20f911b3f8cf0b74(value) {
    return value;
}

});



parcelRegister("kbk6C", function(module, exports) {

$parcel$export(module.exports, "compare", function () { return $eb146e4d00a2d7d5$export$398604a469f7de9a; });
// @ts-nocheck
/*!
 * https://github.com/Starcounter-Jack/JSON-Patch
 * (c) 2017-2021 Joachim Wester
 * MIT license
 */ 
var $6zHVx = parcelRequire("6zHVx");

var $dokaz = parcelRequire("dokaz");
var $eb146e4d00a2d7d5$var$beforeDict = new WeakMap();
class $eb146e4d00a2d7d5$var$Mirror {
    constructor(obj){
        this.observers = new Map();
        this.obj = obj;
    }
}
class $eb146e4d00a2d7d5$var$ObserverInfo {
    constructor(callback, observer){
        this.callback = callback;
        this.observer = observer;
    }
}
function $eb146e4d00a2d7d5$var$getMirror(obj) {
    return $eb146e4d00a2d7d5$var$beforeDict.get(obj);
}
function $eb146e4d00a2d7d5$var$getObserverFromMirror(mirror, callback) {
    return mirror.observers.get(callback);
}
function $eb146e4d00a2d7d5$var$removeObserverFromMirror(mirror, observer) {
    mirror.observers.delete(observer.callback);
}
function $eb146e4d00a2d7d5$export$23a2283368c55ea2(root, observer) {
    observer.unobserve();
}
function $eb146e4d00a2d7d5$export$d1203567a167490e(obj, callback) {
    var patches = [];
    var observer;
    var mirror = $eb146e4d00a2d7d5$var$getMirror(obj);
    if (!mirror) {
        mirror = new $eb146e4d00a2d7d5$var$Mirror(obj);
        $eb146e4d00a2d7d5$var$beforeDict.set(obj, mirror);
    } else {
        const observerInfo = $eb146e4d00a2d7d5$var$getObserverFromMirror(mirror, callback);
        observer = observerInfo && observerInfo.observer;
    }
    if (observer) return observer;
    observer = {};
    mirror.value = (0, $6zHVx._deepClone)(obj);
    if (callback) {
        observer.callback = callback;
        observer.next = null;
        var dirtyCheck = ()=>{
            $eb146e4d00a2d7d5$export$80d376111cc09ad7(observer);
        };
        var fastCheck = ()=>{
            clearTimeout(observer.next);
            observer.next = setTimeout(dirtyCheck);
        };
        if (typeof window !== "undefined") {
            //not Node
            window.addEventListener("mouseup", fastCheck);
            window.addEventListener("keyup", fastCheck);
            window.addEventListener("mousedown", fastCheck);
            window.addEventListener("keydown", fastCheck);
            window.addEventListener("change", fastCheck);
        }
    }
    observer.patches = patches;
    observer.object = obj;
    observer.unobserve = ()=>{
        $eb146e4d00a2d7d5$export$80d376111cc09ad7(observer);
        clearTimeout(observer.next);
        $eb146e4d00a2d7d5$var$removeObserverFromMirror(mirror, observer);
        if (typeof window !== "undefined") {
            window.removeEventListener("mouseup", fastCheck);
            window.removeEventListener("keyup", fastCheck);
            window.removeEventListener("mousedown", fastCheck);
            window.removeEventListener("keydown", fastCheck);
            window.removeEventListener("change", fastCheck);
        }
    };
    mirror.observers.set(callback, new $eb146e4d00a2d7d5$var$ObserverInfo(callback, observer));
    return observer;
}
function $eb146e4d00a2d7d5$export$80d376111cc09ad7(observer, invertible = false) {
    var mirror = $eb146e4d00a2d7d5$var$beforeDict.get(observer.object);
    $eb146e4d00a2d7d5$var$_generate(mirror.value, observer.object, observer.patches, "", invertible);
    if (observer.patches.length) (0, $dokaz.applyPatch)(mirror.value, observer.patches);
    var temp = observer.patches;
    if (temp.length > 0) {
        observer.patches = [];
        if (observer.callback) observer.callback(temp);
    }
    return temp;
}
// Dirty check if obj is different from mirror, generate patches and update mirror
function $eb146e4d00a2d7d5$var$_generate(mirror, obj, patches, path, invertible) {
    if (obj === mirror) return;
    if (typeof obj.toJSON === "function") obj = obj.toJSON();
    var newKeys = (0, $6zHVx._objectKeys)(obj);
    var oldKeys = (0, $6zHVx._objectKeys)(mirror);
    var changed = false;
    var deleted = false;
    //if ever "move" operation is implemented here, make sure this test runs OK: "should not generate the same patch twice (move)"
    for(var t = oldKeys.length - 1; t >= 0; t--){
        var key = oldKeys[t];
        var oldVal = mirror[key];
        if ((0, $6zHVx.hasOwnProperty)(obj, key) && !(obj[key] === undefined && oldVal !== undefined && Array.isArray(obj) === false)) {
            var newVal = obj[key];
            if (typeof oldVal == "object" && oldVal != null && typeof newVal == "object" && newVal != null && Array.isArray(oldVal) === Array.isArray(newVal)) $eb146e4d00a2d7d5$var$_generate(oldVal, newVal, patches, path + "/" + (0, $6zHVx.escapePathComponent)(key), invertible);
            else if (oldVal !== newVal) {
                changed = true;
                if (invertible) patches.push({
                    op: "test",
                    path: path + "/" + (0, $6zHVx.escapePathComponent)(key),
                    value: (0, $6zHVx._deepClone)(oldVal)
                });
                patches.push({
                    op: "replace",
                    path: path + "/" + (0, $6zHVx.escapePathComponent)(key),
                    value: (0, $6zHVx._deepClone)(newVal)
                });
            }
        } else if (Array.isArray(mirror) === Array.isArray(obj)) {
            if (invertible) patches.push({
                op: "test",
                path: path + "/" + (0, $6zHVx.escapePathComponent)(key),
                value: (0, $6zHVx._deepClone)(oldVal)
            });
            patches.push({
                op: "remove",
                path: path + "/" + (0, $6zHVx.escapePathComponent)(key)
            });
            deleted = true; // property has been deleted
        } else {
            if (invertible) patches.push({
                op: "test",
                path: path,
                value: mirror
            });
            patches.push({
                op: "replace",
                path: path,
                value: obj
            });
            changed = true;
        }
    }
    if (!deleted && newKeys.length == oldKeys.length) return;
    for(var t = 0; t < newKeys.length; t++){
        var key = newKeys[t];
        if (!(0, $6zHVx.hasOwnProperty)(mirror, key) && obj[key] !== undefined) patches.push({
            op: "add",
            path: path + "/" + (0, $6zHVx.escapePathComponent)(key),
            value: (0, $6zHVx._deepClone)(obj[key])
        });
    }
}
function $eb146e4d00a2d7d5$export$398604a469f7de9a(tree1, tree2, invertible = false) {
    var patches = [];
    $eb146e4d00a2d7d5$var$_generate(tree1, tree2, patches, "", invertible);
    return patches;
}

});
parcelRegister("6zHVx", function(module, exports) {

$parcel$export(module.exports, "hasOwnProperty", function () { return $4c9815f97c7bd515$export$5a15a386532a5ea4; });
$parcel$export(module.exports, "_objectKeys", function () { return $4c9815f97c7bd515$export$612729bc7b5af0e1; });
$parcel$export(module.exports, "_deepClone", function () { return $4c9815f97c7bd515$export$30e5c1af6b2bfcc9; });
$parcel$export(module.exports, "isInteger", function () { return $4c9815f97c7bd515$export$a287f47fed4544b8; });
$parcel$export(module.exports, "escapePathComponent", function () { return $4c9815f97c7bd515$export$12a12353f06097f4; });
$parcel$export(module.exports, "unescapePathComponent", function () { return $4c9815f97c7bd515$export$44050cece5779d54; });
$parcel$export(module.exports, "hasUndefined", function () { return $4c9815f97c7bd515$export$9156409884499467; });
$parcel$export(module.exports, "PatchError", function () { return $4c9815f97c7bd515$export$a87af518d936c0f; });
// @ts-nocheck
// @reactor-ignore
/*!
 * https://github.com/Starcounter-Jack/JSON-Patch
 * (c) 2017-2022 Joachim Wester
 * MIT licensed
 */ const $4c9815f97c7bd515$var$_hasOwnProperty = Object.prototype.hasOwnProperty;
function $4c9815f97c7bd515$export$5a15a386532a5ea4(obj, key) {
    return $4c9815f97c7bd515$var$_hasOwnProperty.call(obj, key);
}
function $4c9815f97c7bd515$export$612729bc7b5af0e1(obj) {
    if (Array.isArray(obj)) {
        const keys = new Array(obj.length);
        for(let k = 0; k < keys.length; k++)keys[k] = "" + k;
        return keys;
    }
    if (Object.keys) return Object.keys(obj);
    const keys = [];
    for(const i in obj)if ($4c9815f97c7bd515$export$5a15a386532a5ea4(obj, i)) keys.push(i);
    return keys;
}
function $4c9815f97c7bd515$export$30e5c1af6b2bfcc9(obj) {
    switch(typeof obj){
        case "object":
            return JSON.parse(JSON.stringify(obj)); //Faster than ES5 clone - http://jsperf.com/deep-cloning-of-objects/5
        case "undefined":
            return null; //this is how JSON.stringify behaves for array items
        default:
            return obj; //no need to clone primitives
    }
}
function $4c9815f97c7bd515$export$a287f47fed4544b8(str) {
    let i = 0;
    const len = str.length;
    let charCode;
    while(i < len){
        charCode = str.charCodeAt(i);
        if (charCode >= 48 && charCode <= 57) {
            i++;
            continue;
        }
        return false;
    }
    return true;
}
function $4c9815f97c7bd515$export$12a12353f06097f4(path) {
    if (path.indexOf("/") === -1 && path.indexOf("~") === -1) return path;
    return path.replace(/~/g, "~0").replace(/\//g, "~1");
}
function $4c9815f97c7bd515$export$44050cece5779d54(path) {
    return path.replace(/~1/g, "/").replace(/~0/g, "~");
}
function $4c9815f97c7bd515$export$8b88a033a1d9dadb(root, obj) {
    let found;
    for(const key in root)if ($4c9815f97c7bd515$export$5a15a386532a5ea4(root, key)) {
        if (root[key] === obj) return $4c9815f97c7bd515$export$12a12353f06097f4(key) + "/";
        else if (typeof root[key] === "object") {
            found = $4c9815f97c7bd515$export$8b88a033a1d9dadb(root[key], obj);
            if (found !== "") return $4c9815f97c7bd515$export$12a12353f06097f4(key) + "/" + found;
        }
    }
    return "";
}
function $4c9815f97c7bd515$export$2aa3fd96c49a84a8(root, obj) {
    if (root === obj) return "/";
    const path = $4c9815f97c7bd515$export$8b88a033a1d9dadb(root, obj);
    if (path === "") throw new Error("Object not found in root");
    return `/${path}`;
}
function $4c9815f97c7bd515$export$9156409884499467(obj) {
    if (obj === undefined) return true;
    if (obj) {
        if (Array.isArray(obj)) for(let i = 0, len = obj.length; i < len; i++){
            if ($4c9815f97c7bd515$export$9156409884499467(obj[i])) return true;
        }
        else if (typeof obj === "object") {
            const objKeys = $4c9815f97c7bd515$export$612729bc7b5af0e1(obj);
            const objKeysLength = objKeys.length;
            for(let i = 0; i < objKeysLength; i++){
                if ($4c9815f97c7bd515$export$9156409884499467(obj[objKeys[i]])) return true;
            }
        }
    }
    return false;
}
function $4c9815f97c7bd515$var$patchErrorMessageFormatter(message, args) {
    const messageParts = [
        message
    ];
    for(const key in args){
        const value = typeof args[key] === "object" ? JSON.stringify(args[key], null, 2) : args[key]; // pretty print
        if (typeof value !== "undefined") messageParts.push(`${key}: ${value}`);
    }
    return messageParts.join("\n");
}
class $4c9815f97c7bd515$export$a87af518d936c0f extends Error {
    constructor(message, name, index, operation, tree){
        super($4c9815f97c7bd515$var$patchErrorMessageFormatter(message, {
            name: name,
            index: index,
            operation: operation,
            tree: tree
        }));
        this.name = name;
        this.index = index;
        this.operation = operation;
        this.tree = tree;
        Object.setPrototypeOf(this, new.target.prototype); // restore prototype chain, see https://stackoverflow.com/a/48342359
        this.message = $4c9815f97c7bd515$var$patchErrorMessageFormatter(message, {
            name: name,
            index: index,
            operation: operation,
            tree: tree
        });
    }
}

});

parcelRegister("dokaz", function(module, exports) {

$parcel$export(module.exports, "applyPatch", function () { return $9bfd297acba008d7$export$7383fd3fd73657b6; });
// @ts-nocheck
// @reactor-ignore

var $6zHVx = parcelRequire("6zHVx");
const $9bfd297acba008d7$export$b08003336606c830 = (0, $6zHVx.PatchError);
const $9bfd297acba008d7$export$b7d58db314e0ac27 = (0, $6zHVx._deepClone);
/* We use a Javascript hash to store each
 function. Each hash entry (property) uses
 the operation identifiers specified in rfc6902.
 In this way, we can map each patch operation
 to its dedicated function in efficient way.
 */ /* The operations applicable to an object */ const $9bfd297acba008d7$var$objOps = {
    add (obj, key, document) {
        obj[key] = this.value;
        return {
            newDocument: document
        };
    },
    remove (obj, key, document) {
        const removed = obj[key];
        delete obj[key];
        return {
            newDocument: document,
            removed: removed
        };
    },
    replace (obj, key, document) {
        const removed = obj[key];
        obj[key] = this.value;
        return {
            newDocument: document,
            removed: removed
        };
    },
    move (obj, key, document) {
        /* in case move target overwrites an existing value,
    return the removed value, this can be taxing performance-wise,
    and is potentially unneeded */ let removed = $9bfd297acba008d7$export$76eb22daa3ab123e(document, this.path);
        if (removed) removed = (0, $6zHVx._deepClone)(removed);
        const originalValue = $9bfd297acba008d7$export$c8dff1b83c22eaf2(document, {
            op: "remove",
            path: this.from
        }).removed;
        $9bfd297acba008d7$export$c8dff1b83c22eaf2(document, {
            op: "add",
            path: this.path,
            value: originalValue
        });
        return {
            newDocument: document,
            removed: removed
        };
    },
    copy (obj, key, document) {
        const valueToCopy = $9bfd297acba008d7$export$76eb22daa3ab123e(document, this.from);
        // enforce copy by value so further operations don't affect source (see issue #177)
        $9bfd297acba008d7$export$c8dff1b83c22eaf2(document, {
            op: "add",
            path: this.path,
            value: (0, $6zHVx._deepClone)(valueToCopy)
        });
        return {
            newDocument: document
        };
    },
    test (obj, key, document) {
        return {
            newDocument: document,
            test: $9bfd297acba008d7$export$6cabac8132d3b997(obj[key], this.value)
        };
    },
    _get (obj, key, document) {
        this.value = obj[key];
        return {
            newDocument: document
        };
    }
};
/* The operations applicable to an array. Many are the same as for the object */ const $9bfd297acba008d7$var$arrOps = {
    add (arr, i, document) {
        if ((0, $6zHVx.isInteger)(i)) arr.splice(i, 0, this.value);
        else // array props
        arr[i] = this.value;
        // this may be needed when using '-' in an array
        return {
            newDocument: document,
            index: i
        };
    },
    remove (arr, i, document) {
        const removedList = arr.splice(i, 1);
        return {
            newDocument: document,
            removed: removedList[0]
        };
    },
    replace (arr, i, document) {
        const removed = arr[i];
        arr[i] = this.value;
        return {
            newDocument: document,
            removed: removed
        };
    },
    move: $9bfd297acba008d7$var$objOps.move,
    copy: $9bfd297acba008d7$var$objOps.copy,
    test: $9bfd297acba008d7$var$objOps.test,
    _get: $9bfd297acba008d7$var$objOps._get
};
function $9bfd297acba008d7$export$76eb22daa3ab123e(document, pointer) {
    if (pointer === "") return document;
    const getOriginalDestination = {
        op: "_get",
        path: pointer
    };
    $9bfd297acba008d7$export$c8dff1b83c22eaf2(document, getOriginalDestination);
    return getOriginalDestination.value;
}
function $9bfd297acba008d7$export$c8dff1b83c22eaf2(document, operation, validateOperation = false, mutateDocument = true, banPrototypeModifications = true, index = 0) {
    if (validateOperation) {
        if (typeof validateOperation === "function") validateOperation(operation, 0, document, operation.path);
        else $9bfd297acba008d7$export$956325f45c5d174a(operation, 0);
    }
    /* ROOT OPERATIONS */ if (operation.path === "") {
        const returnValue = {
            newDocument: document
        };
        if (operation.op === "add") {
            returnValue.newDocument = operation.value;
            return returnValue;
        } else if (operation.op === "replace") {
            returnValue.newDocument = operation.value;
            returnValue.removed = document; //document we removed
            return returnValue;
        } else if (operation.op === "move" || operation.op === "copy") {
            // it's a move or copy to root
            returnValue.newDocument = $9bfd297acba008d7$export$76eb22daa3ab123e(document, operation.from); // get the value by json-pointer in `from` field
            if (operation.op === "move") // report removed item
            returnValue.removed = document;
            return returnValue;
        } else if (operation.op === "test") {
            returnValue.test = $9bfd297acba008d7$export$6cabac8132d3b997(document, operation.value);
            if (returnValue.test === false) throw new $9bfd297acba008d7$export$b08003336606c830("Test operation failed", "TEST_OPERATION_FAILED", index, operation, document);
            returnValue.newDocument = document;
            return returnValue;
        } else if (operation.op === "remove") {
            // a remove on root
            returnValue.removed = document;
            returnValue.newDocument = null;
            return returnValue;
        } else if (operation.op === "_get") {
            operation.value = document;
            return returnValue;
        } else {
            /* bad operation */ if (validateOperation) throw new $9bfd297acba008d7$export$b08003336606c830("Operation `op` property is not one of operations defined in RFC-6902", "OPERATION_OP_INVALID", index, operation, document);
            else return returnValue;
        }
    } else {
        if (!mutateDocument) document = (0, $6zHVx._deepClone)(document);
        const path = operation.path || "";
        const keys = path.split("/");
        let obj = document;
        let t = 1; //skip empty element - http://jsperf.com/to-shift-or-not-to-shift
        const len = keys.length;
        let existingPathFragment;
        let key;
        let validateFunction;
        if (typeof validateOperation == "function") validateFunction = validateOperation;
        else validateFunction = $9bfd297acba008d7$export$956325f45c5d174a;
        while(true){
            key = keys[t];
            if (key && key.indexOf("~") !== -1) key = (0, $6zHVx.unescapePathComponent)(key);
            if (banPrototypeModifications && (key === "__proto__" || key === "prototype" && t > 0 && keys[t - 1] === "constructor")) throw new TypeError("JSON-Patch: modifying `__proto__` or `constructor/prototype` prop is banned for security reasons, if this was on purpose, please set `banPrototypeModifications` flag false and pass it to this function. More info in fast-json-patch README");
            if (validateOperation) {
                if (existingPathFragment === undefined) {
                    if (obj[key] === undefined) existingPathFragment = keys.slice(0, t).join("/");
                    else if (t === len - 1) existingPathFragment = operation.path;
                    if (existingPathFragment !== undefined) validateFunction(operation, 0, document, existingPathFragment);
                }
            }
            t++;
            if (Array.isArray(obj)) {
                if (key === "-") key = obj.length;
                else {
                    if (validateOperation && !(0, $6zHVx.isInteger)(key)) throw new $9bfd297acba008d7$export$b08003336606c830("Expected an unsigned base-10 integer value, making the new referenced value the array element with the zero-based index", "OPERATION_PATH_ILLEGAL_ARRAY_INDEX", index, operation, document);
                    else if ((0, $6zHVx.isInteger)(key)) key = ~~key;
                }
                if (t >= len) {
                    if (validateOperation && operation.op === "add" && key > obj.length) throw new $9bfd297acba008d7$export$b08003336606c830("The specified index MUST NOT be greater than the number of elements in the array", "OPERATION_VALUE_OUT_OF_BOUNDS", index, operation, document);
                    const returnValue = $9bfd297acba008d7$var$arrOps[operation.op].call(operation, obj, key, document); // Apply patch
                    if (returnValue.test === false) throw new $9bfd297acba008d7$export$b08003336606c830("Test operation failed", "TEST_OPERATION_FAILED", index, operation, document);
                    return returnValue;
                }
            } else if (t >= len) {
                const returnValue = $9bfd297acba008d7$var$objOps[operation.op].call(operation, obj, key, document); // Apply patch
                if (returnValue.test === false) throw new $9bfd297acba008d7$export$b08003336606c830("Test operation failed", "TEST_OPERATION_FAILED", index, operation, document);
                return returnValue;
            }
            obj = obj[key];
            // If we have more keys in the path, but the next value isn't a non-null object,
            // throw an OPERATION_PATH_UNRESOLVABLE error instead of iterating again.
            if (validateOperation && t < len && (!obj || typeof obj !== "object")) throw new $9bfd297acba008d7$export$b08003336606c830("Cannot perform operation at the desired path", "OPERATION_PATH_UNRESOLVABLE", index, operation, document);
        }
    }
}
function $9bfd297acba008d7$export$7383fd3fd73657b6(document, patch, validateOperation, mutateDocument = true, banPrototypeModifications = true) {
    if (validateOperation) {
        if (!Array.isArray(patch)) throw new $9bfd297acba008d7$export$b08003336606c830("Patch sequence must be an array", "SEQUENCE_NOT_AN_ARRAY");
    }
    if (!mutateDocument) document = (0, $6zHVx._deepClone)(document);
    const results = new Array(patch.length);
    for(let i = 0, length = patch.length; i < length; i++){
        // we don't need to pass mutateDocument argument because if it was true, we already deep cloned the object, we'll just pass `true`
        results[i] = $9bfd297acba008d7$export$c8dff1b83c22eaf2(document, patch[i], validateOperation, true, banPrototypeModifications, i);
        document = results[i].newDocument; // in case root was replaced
    }
    results.newDocument = document;
    return results;
}
function $9bfd297acba008d7$export$69915a94c4b58251(document, operation, index) {
    const operationResult = $9bfd297acba008d7$export$c8dff1b83c22eaf2(document, operation);
    if (operationResult.test === false) // failed test
    throw new $9bfd297acba008d7$export$b08003336606c830("Test operation failed", "TEST_OPERATION_FAILED", index, operation, document);
    return operationResult.newDocument;
}
function $9bfd297acba008d7$export$956325f45c5d174a(operation, index, document, existingPathFragment) {
    if (typeof operation !== "object" || operation === null || Array.isArray(operation)) throw new $9bfd297acba008d7$export$b08003336606c830("Operation is not an object", "OPERATION_NOT_AN_OBJECT", index, operation, document);
    else if (!$9bfd297acba008d7$var$objOps[operation.op]) throw new $9bfd297acba008d7$export$b08003336606c830("Operation `op` property is not one of operations defined in RFC-6902", "OPERATION_OP_INVALID", index, operation, document);
    else if (typeof operation.path !== "string") throw new $9bfd297acba008d7$export$b08003336606c830("Operation `path` property is not a string", "OPERATION_PATH_INVALID", index, operation, document);
    else if (operation.path.indexOf("/") !== 0 && operation.path.length > 0) // paths that aren't empty string should start with "/"
    throw new $9bfd297acba008d7$export$b08003336606c830('Operation `path` property must start with "/"', "OPERATION_PATH_INVALID", index, operation, document);
    else if ((operation.op === "move" || operation.op === "copy") && typeof operation.from !== "string") throw new $9bfd297acba008d7$export$b08003336606c830("Operation `from` property is not present (applicable in `move` and `copy` operations)", "OPERATION_FROM_REQUIRED", index, operation, document);
    else if ((operation.op === "add" || operation.op === "replace" || operation.op === "test") && operation.value === undefined) throw new $9bfd297acba008d7$export$b08003336606c830("Operation `value` property is not present (applicable in `add`, `replace` and `test` operations)", "OPERATION_VALUE_REQUIRED", index, operation, document);
    else if ((operation.op === "add" || operation.op === "replace" || operation.op === "test") && (0, $6zHVx.hasUndefined)(operation.value)) throw new $9bfd297acba008d7$export$b08003336606c830("Operation `value` property is not present (applicable in `add`, `replace` and `test` operations)", "OPERATION_VALUE_CANNOT_CONTAIN_UNDEFINED", index, operation, document);
    else if (document) {
        if (operation.op === "add") {
            const pathLen = operation.path.split("/").length;
            const existingPathLen = existingPathFragment.split("/").length;
            if (pathLen !== existingPathLen + 1 && pathLen !== existingPathLen) throw new $9bfd297acba008d7$export$b08003336606c830("Cannot perform an `add` operation at the desired path", "OPERATION_PATH_CANNOT_ADD", index, operation, document);
        } else if (operation.op === "replace" || operation.op === "remove" || operation.op === "_get") {
            if (operation.path !== existingPathFragment) throw new $9bfd297acba008d7$export$b08003336606c830("Cannot perform the operation at a path that does not exist", "OPERATION_PATH_UNRESOLVABLE", index, operation, document);
        } else if (operation.op === "move" || operation.op === "copy") {
            const existingValue = {
                op: "_get",
                path: operation.from,
                value: undefined
            };
            const error = $9bfd297acba008d7$export$a22775fa5e2eebd9([
                existingValue
            ], document);
            if (error && error.name === "OPERATION_PATH_UNRESOLVABLE") throw new $9bfd297acba008d7$export$b08003336606c830("Cannot perform the operation from a path that does not exist", "OPERATION_FROM_UNRESOLVABLE", index, operation, document);
        }
    }
}
function $9bfd297acba008d7$export$a22775fa5e2eebd9(sequence, document, externalValidator) {
    try {
        if (!Array.isArray(sequence)) throw new $9bfd297acba008d7$export$b08003336606c830("Patch sequence must be an array", "SEQUENCE_NOT_AN_ARRAY");
        if (document) //clone document and sequence so that we can safely try applying operations
        $9bfd297acba008d7$export$7383fd3fd73657b6((0, $6zHVx._deepClone)(document), (0, $6zHVx._deepClone)(sequence), externalValidator || true);
        else {
            externalValidator = externalValidator || $9bfd297acba008d7$export$956325f45c5d174a;
            for(let i = 0; i < sequence.length; i++)externalValidator(sequence[i], i, document, undefined);
        }
    } catch (e) {
        if (e instanceof $9bfd297acba008d7$export$b08003336606c830) return e;
        else throw e;
    }
}
function $9bfd297acba008d7$export$6cabac8132d3b997(a, b) {
    if (a === b) return true;
    if (a && b && typeof a == "object" && typeof b == "object") {
        const arrA = Array.isArray(a);
        const arrB = Array.isArray(b);
        let i;
        let length;
        let key;
        if (arrA && arrB) {
            length = a.length;
            if (length !== b.length) return false;
            for(i = length; i-- !== 0;)if (!$9bfd297acba008d7$export$6cabac8132d3b997(a[i], b[i])) return false;
            return true;
        }
        if (arrA !== arrB) return false;
        const keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!b.hasOwnProperty(keys[i])) return false;
        for(i = length; i-- !== 0;){
            key = keys[i];
            if (!$9bfd297acba008d7$export$6cabac8132d3b997(a[key], b[key])) return false;
        }
        return true;
    }
    return a !== a && b !== b;
}

});


parcelRegister("lyFh9", function(module, exports) {

$parcel$export(module.exports, "RichText", function () { return $fb1cca6845732ab8$export$f284d8638abd8920; });
$parcel$export(module.exports, "IsRichText", function () { return $fb1cca6845732ab8$export$e7443681c6b75de1; });
$parcel$export(module.exports, "Heading1", function () { return $fb1cca6845732ab8$export$c3c64e31852769d4; });
/*
 * This holds a general prupose structure for representing rich text, which is
 * compatible with the Slate.js editor.
 *
 * This can be used in model fields, whenever you want to store rich text that
 * can be manipulated using a WYSIWYG editor.
 */ /**
 * Converts a list of rich text elements into a rich text document.
 */ function $fb1cca6845732ab8$export$f284d8638abd8920(...elements) {
    // Rich text must have at least one element
    if (elements.length === 0) return $fb1cca6845732ab8$export$f284d8638abd8920("");
    return {
        $RichText: elements.map((e)=>typeof e === "string" ? $fb1cca6845732ab8$export$358a232cca1ab2ac(e) : e)
    };
}
function $fb1cca6845732ab8$export$e7443681c6b75de1(value) {
    return value && typeof value === "object" && "$RichText" in value;
}
function $fb1cca6845732ab8$export$c3c64e31852769d4(...args) {
    return {
        type: "Heading1",
        children: args.length === 1 ? [
            {
                text: args[0]
            }
        ] : args
    };
}
function $fb1cca6845732ab8$export$f5a7f5a165424d76(...args) {
    return {
        type: "Heading2",
        children: args.length === 1 ? [
            {
                text: args[0]
            }
        ] : args
    };
}
function $fb1cca6845732ab8$export$358a232cca1ab2ac(...args) {
    return {
        type: "Paragraph",
        children: args.length === 1 ? [
            {
                text: args[0]
            }
        ] : args
    };
}

});

parcelRegister("f8cmx", function(module, exports) {

$parcel$export(module.exports, "YProxy", function () { return $b041314a9eda04af$export$bc666e2a08b420ab; });
$parcel$export(module.exports, "useYProxy", function () { return $b041314a9eda04af$export$ad48a77f76c97349; });
$parcel$export(module.exports, "AdoptYValue", function () { return $b041314a9eda04af$export$29736178b6a6a21d; });

var $eeH7J = parcelRequire("eeH7J");

var $aw3rr = parcelRequire("aw3rr");

var $1aVVn = parcelRequire("1aVVn");

var $4FdkC = parcelRequire("4FdkC");
const $b041314a9eda04af$var$proxies = new WeakMap();
function $b041314a9eda04af$export$bc666e2a08b420ab(value) {
    if (value instanceof $aw3rr.Map) return $b041314a9eda04af$var$YProxyMap(value);
    else if (value instanceof $aw3rr.Array) return $b041314a9eda04af$var$YProxyArray(value);
    else return value;
}
function $b041314a9eda04af$export$ad48a77f76c97349(/**
 * The Y.Map or Y.Array that contains the object you want to proxy.
 */ obj, /**
 * The property name of the object you want to proxy.
 */ prop) {
    return (0, $eeH7J.useMemo)(()=>$b041314a9eda04af$export$bc666e2a08b420ab((0, $1aVVn.YTools).get(obj, prop)), [
        obj,
        prop
    ]);
}
function $b041314a9eda04af$var$YProxyMap(yMap) {
    const existing = $b041314a9eda04af$var$proxies.get(yMap);
    if (existing) return existing;
    function get(target, prop) {
        if (prop === (0, $4FdkC.YProxyTarget)) return yMap;
        // Handle special object methods like keys, entries, values
        if (prop === "keys") return ()=>Array.from(yMap.keys());
        if (prop === "entries") return ()=>Array.from(yMap.entries());
        if (prop === "values") return ()=>Array.from(yMap.values());
        if (prop === Symbol.iterator) return function*() {
            for (const [key, value] of yMap.entries())yield [
                key,
                value
            ];
        };
        if (prop === "toJSON") return ()=>{
            const obj = {};
            for (const [key, value] of yMap.entries())obj[key] = value;
            return obj;
        };
        // Handle dynamic property access
        if (typeof prop === "string") {
            const value = yMap.get(prop);
            if (value instanceof $aw3rr.Map) return $b041314a9eda04af$var$YProxyMap(value);
            else if (value instanceof $aw3rr.Array) return $b041314a9eda04af$var$YProxyArray(value);
            else return value;
        }
        // Fallback for other properties
        return Reflect.get(target, prop);
    }
    const handler = {
        ownKeys () {
            return Array.from(yMap.keys());
        },
        getOwnPropertyDescriptor (target, prop) {
            // Define property descriptors to make keys enumerable
            return {
                configurable: true,
                enumerable: true,
                value: get(target, prop)
            };
        },
        get: get,
        set (target, prop, value) {
            if (typeof prop === "string") {
                yMap.set(prop, $b041314a9eda04af$export$29736178b6a6a21d(value));
                return true;
            }
            return false;
        }
    };
    const proxy = new Proxy(yMap, handler);
    $b041314a9eda04af$var$proxies.set(yMap, proxy);
    return proxy;
}
function $b041314a9eda04af$var$YProxyArray(yArray) {
    const existing = $b041314a9eda04af$var$proxies.get(yArray);
    if (existing) return existing;
    const proxy = new Proxy(yArray, {
        get (target, prop) {
            if (prop === (0, $4FdkC.YProxyTarget)) return yArray;
            if (prop === "map") return (callback)=>{
                const raw = yArray.toArray();
                const res = [];
                for(let i = 0; i < yArray.length; i++){
                    const value = $b041314a9eda04af$export$bc666e2a08b420ab(yArray.get(i));
                    res.push(callback(value, i, raw));
                }
                return res;
            };
            if (prop === "splice") return (start, deleteCount, ...items)=>{
                const deleted = yArray.slice(start, start + deleteCount);
                if (deleteCount) yArray.delete(start, deleteCount);
                if (items.length) yArray.insert(start, items.map($b041314a9eda04af$export$29736178b6a6a21d));
                return deleted;
            };
            if (prop === "find") return (callback)=>{
                for(let i = 0; i < yArray.length; i++){
                    const value = $b041314a9eda04af$export$bc666e2a08b420ab(yArray.get(i));
                    if (callback(value, i, yArray.toArray())) return value;
                }
                return undefined;
            };
            if (prop === "some") return (callback)=>{
                for(let i = 0; i < yArray.length; i++){
                    const value = $b041314a9eda04af$export$bc666e2a08b420ab(yArray.get(i));
                    if (callback(value, i, yArray.toArray())) return true;
                }
                return false;
            };
            if (prop === "every") return (callback)=>{
                for(let i = 0; i < yArray.length; i++){
                    const value = $b041314a9eda04af$export$bc666e2a08b420ab(yArray.get(i));
                    if (!callback(value, i, yArray.toArray())) return false;
                }
                return true;
            };
            if (prop === "filter") return (callback)=>{
                const res = [];
                for(let i = 0; i < yArray.length; i++){
                    const value = $b041314a9eda04af$export$bc666e2a08b420ab(yArray.get(i));
                    if (callback(value, i, yArray.toArray())) res.push(value);
                }
                return res;
            };
            if (prop === "forEach") return (callback)=>{
                for(let i = 0; i < yArray.length; i++){
                    const value = $b041314a9eda04af$export$bc666e2a08b420ab(yArray.get(i));
                    callback(value, i, yArray.toArray());
                }
            };
            if (prop === "push") return (...items)=>{
                yArray.insert(yArray.length, items.map($b041314a9eda04af$export$29736178b6a6a21d));
                return yArray.length;
            };
            if (prop === "pop") return ()=>{
                const index = yArray.length - 1;
                const value = yArray.get(index);
                yArray.delete(index, 1);
                return value;
            };
            if (prop === "shift") return ()=>{
                const value = yArray.get(0);
                yArray.delete(0, 1);
                return value;
            };
            if (prop === "unshift") return (...items)=>{
                yArray.insert(0, items.map($b041314a9eda04af$export$29736178b6a6a21d));
                return yArray.length;
            };
            if (prop === "length") return yArray.length;
            if (prop === "reduce") return (callback, initialValue)=>{
                let acc = initialValue;
                for(let i = 0; i < yArray.length; i++){
                    const value = $b041314a9eda04af$export$bc666e2a08b420ab(yArray.get(i));
                    acc = callback(acc, value, i, yArray.toArray());
                }
                return acc;
            };
            if (prop === "toJSON") return ()=>yArray.toArray();
            if (prop in Array.prototype) return (...args)=>{
                const snapshot = yArray.toArray(); // Convert Y.Array to a JS array
                const result = snapshot[prop](...args); // Call the array method
                return result;
            };
            // Access numeric indices
            const index = typeof prop === "string" ? Number(prop) : prop;
            if (!Number.isNaN(index)) {
                const value = yArray.get(index);
                if (value instanceof $aw3rr.Map) return $b041314a9eda04af$var$YProxyMap(value);
                else if (value instanceof $aw3rr.Array) return $b041314a9eda04af$var$YProxyArray(value);
                else return value;
            }
            throw new Error(`YProxyArray: Unsupported property: ${prop.toString()}`);
        },
        set (target, prop, value) {
            const index = typeof prop === "string" ? parseInt(prop) : typeof prop === "number" ? prop : 0;
            yArray.delete(index, 1);
            yArray.insert(index, [
                $b041314a9eda04af$export$29736178b6a6a21d(value)
            ]);
            return true;
        }
    });
    $b041314a9eda04af$var$proxies.set(yArray, proxy);
    return proxy;
}
function $b041314a9eda04af$export$29736178b6a6a21d(value) {
    if (typeof value === "number" || typeof value === "string" || typeof value === "boolean" || value === null || value === undefined) // Do nothing, can be inserted directly
    return value;
    const target = (0, $4FdkC.GetYProxyTarget)(value);
    if (target) return target;
    if (value instanceof $aw3rr.Map || value instanceof $aw3rr.Array || value instanceof $aw3rr.XmlText) return value;
    // Value is not a proxy, nor a Yjs object, so we need to convert it to a Yjs
    // object
    return (0, $1aVVn.YTools).valueToYValue(value);
}

});
parcelRegister("4FdkC", function(module, exports) {

$parcel$export(module.exports, "YProxyTarget", function () { return $3655551c6310b583$export$1416164d941e528f; });
$parcel$export(module.exports, "GetYProxyTarget", function () { return $3655551c6310b583$export$8d965473a46a1c61; });
// To avoid importing all of Y.js prematurely, this file contains the utilities needed
// for detecting whether a given object is a YProxy object
const $3655551c6310b583$export$1416164d941e528f = Symbol("proxy-target");
function $3655551c6310b583$export$b4a63b144ecf4f6f(obj) {
    return $3655551c6310b583$export$8d965473a46a1c61(obj) !== undefined;
}
function $3655551c6310b583$export$8d965473a46a1c61(obj) {
    return obj && typeof obj === "object" && obj[$3655551c6310b583$export$1416164d941e528f] || undefined;
}

});



parcelRegister("fH7rK", function(module, exports) {

$parcel$export(module.exports, "CallEndpointWithSoftErrors", function () { return $b6d0a5e253ba02ac$export$47266bbca520d2c0; });

var $4vwom = parcelRequire("4vwom");
parcelRequire("eeH7J");

var $ikBJm = parcelRequire("ikBJm");

var $ht6im = parcelRequire("ht6im");
parcelRequire("2LTO8");
var $cwhCA = parcelRequire("cwhCA");

var $7m9cQ = parcelRequire("7m9cQ");

var $dUDPg = parcelRequire("dUDPg");

var $fT6Pt = parcelRequire("fT6Pt");

var $cSf8f = parcelRequire("cSf8f");
async function $b6d0a5e253ba02ac$export$47266bbca520d2c0(funcDescOrName, args, ignoredSoftErrors) {
    const func = typeof funcDescOrName === "string" ? (0, $cwhCA.GetReflectionInfo)().functions.find((f)=>f.name === funcDescOrName) : funcDescOrName;
    if (!func) throw new Error("No function");
    const { verb: verb, path: path } = func;
    if (!verb) throw new Error(`No verb specified for ${func.name}`);
    if (!path) throw new Error(`No path specified for ${func.name}`);
    const pathSegments = path.split("/").filter((p)=>!!p);
    const partArgNames = pathSegments.filter((p)=>p.startsWith(":")).map((p)=>p.slice(1));
    const bodyArg = func.args.find((a)=>a.name === func.body);
    const body = bodyArg ? args[func.args.findIndex((a)=>a.name === func.body)] : undefined;
    const pathParts = path.split("/").map((p, i)=>{
        if (!p.startsWith(":")) return p;
        const argIndex = func.args.findIndex((a)=>a.name === p.slice(1));
        if (argIndex === -1) throw new Error(`Path segment ${p} not found in args`);
        return args[argIndex];
    });
    const queryArgs = func.args.slice().map((a, index)=>{
        return {
            name: a.name,
            value: args[index],
            keep: !partArgNames.includes(a.name) && a.name !== func.body
        };
    }).filter((a)=>a.keep);
    const url = `${(0, $7m9cQ.server)()}/api${pathParts.join("/")}?${queryArgs.map((q)=>`${q.name}=${q.value}`).join("&")}`;
    const res = await fetch(url, {
        method: func.verb,
        headers: Object.assign(Object.assign({}, (0, $dUDPg.defaults).headers), {
            "Reactor-Ignore-Soft-Errors": ignoredSoftErrors.join(",")
        }),
        body: JSON.stringify(body)
    });
    if (res.status >= 200 && res.status < 300) {
        const isNoContent = res.status === 204;
        return {
            response: isNoContent ? undefined : await res.json()
        };
    } else {
        const error = await res.json();
        const softError = res.headers.get("Reactor-Soft-Error");
        if (softError) {
            const modalRes = await (0, $ikBJm.Modal)((close)=>(0, $4vwom.jsxs)("div", {
                    style: {
                        padding: 20,
                        backgroundColor: "#fff",
                        borderRadius: 8,
                        maxWidth: 600
                    },
                    children: [
                        (0, $4vwom.jsx)((0, $ht6im.ChipWidget), {
                            value: {
                                color: "warning",
                                icon: "exclamation-triangle",
                                text: "Warning",
                                type: "Chip"
                            }
                        }),
                        (0, $4vwom.jsx)("div", {
                            style: {
                                marginTop: 32
                            },
                            children: (0, $4vwom.jsx)("b", {
                                children: error.detail
                            })
                        }),
                        (0, $4vwom.jsx)("div", {
                            style: {
                                marginTop: 32
                            },
                            children: (0, $cSf8f.Strings)["Are you sure you want to continue?"]
                        }),
                        (0, $4vwom.jsxs)("div", {
                            style: {
                                display: "flex",
                                flexDirection: "row",
                                justifyContent: "flex-end",
                                marginTop: 32
                            },
                            children: [
                                (0, $4vwom.jsx)((0, $fT6Pt.RButton), {
                                    variant: "primary",
                                    onClick: ()=>{
                                        close("cancel");
                                    },
                                    children: (0, $cSf8f.Strings).Cancel
                                }),
                                (0, $4vwom.jsx)((0, $fT6Pt.RButton), {
                                    variant: "danger",
                                    onClick: ()=>{
                                        ignoredSoftErrors.push();
                                        close([
                                            ...ignoredSoftErrors,
                                            softError
                                        ]);
                                    },
                                    children: (0, $cSf8f.Strings)["Ignore and continue"]
                                })
                            ]
                        })
                    ]
                }));
            if (modalRes === "cancel") return "cancel";
            else if (modalRes instanceof Array) return await $b6d0a5e253ba02ac$export$47266bbca520d2c0(func, args, modalRes);
        }
        throw error;
    }
}

});
parcelRegister("ikBJm", function(module, exports) {

$parcel$export(module.exports, "ModalContext", function () { return $d5875cc29dc443c7$export$ab57792b9b6974a6; });
$parcel$export(module.exports, "ModalProvider", function () { return $d5875cc29dc443c7$export$178405afcd8c5eb; });
$parcel$export(module.exports, "Modal", function () { return $d5875cc29dc443c7$export$2b77a92f1a5ad772; });
$parcel$export(module.exports, "useContextualModal", function () { return $d5875cc29dc443c7$export$d8d2fc9be59e6858; });
$parcel$export(module.exports, "closeContextualModal", function () { return $d5875cc29dc443c7$export$fd5a43132b1bbce7; });

var $4vwom = parcelRequire("4vwom");

var $eeH7J = parcelRequire("eeH7J");

var $iMJCh = parcelRequire("iMJCh");
let $d5875cc29dc443c7$var$setRoot;
let $d5875cc29dc443c7$var$root;
let $d5875cc29dc443c7$var$close;
const $d5875cc29dc443c7$export$ab57792b9b6974a6 = /*#__PURE__*/ (0, $eeH7J.createContext)(undefined);
function $d5875cc29dc443c7$export$178405afcd8c5eb(props) {
    const state = (0, $eeH7J.useState)(undefined);
    $d5875cc29dc443c7$var$root = state[0];
    $d5875cc29dc443c7$var$setRoot = state[1];
    return (0, $4vwom.jsxs)((0, $4vwom.Fragment), {
        children: [
            props.children,
            $d5875cc29dc443c7$var$root && (0, $4vwom.jsx)($d5875cc29dc443c7$export$ab57792b9b6974a6.Provider, {
                value: $d5875cc29dc443c7$var$root ? {
                    close: $d5875cc29dc443c7$var$close
                } : undefined,
                children: (0, $4vwom.jsx)("div", {
                    onClick: (e)=>{
                        if (e.target === e.currentTarget) // Only trigger this if the user clicked outside of
                        // the modal, not inside the modal (got here by
                        // bubbling)
                        $d5875cc29dc443c7$var$close(undefined);
                        else if (// Don't stop event propagation when clicking on normal links,
                        // otherwise they don't work (#1093)
                        Object.getPrototypeOf(e.target) !== HTMLAnchorElement.prototype) {
                            e.preventDefault();
                            e.stopPropagation();
                        }
                    },
                    style: {
                        backgroundColor: "#0008",
                        position: "fixed",
                        zIndex: 100,
                        width: "100%",
                        height: "100%",
                        top: 0,
                        left: 0,
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center"
                    },
                    children: (0, $4vwom.jsx)("div", {
                        style: {
                            maxHeight: "100%",
                            overflowY: "auto"
                        },
                        children: $d5875cc29dc443c7$var$root
                    })
                })
            })
        ]
    });
}
function $d5875cc29dc443c7$export$2b77a92f1a5ad772(render) {
    const _setRoot = $d5875cc29dc443c7$var$setRoot;
    if (!_setRoot) throw new Error("Modal must be used inside a ModalProvider");
    return new Promise((resolve)=>{
        $d5875cc29dc443c7$var$close = (result)=>{
            _setRoot(undefined);
            resolve(result);
        };
        _setRoot(render($d5875cc29dc443c7$var$close));
    });
}
function $d5875cc29dc443c7$export$d8d2fc9be59e6858() {
    const [root, setRoot] = (0, $eeH7J.useState)(null);
    const [portal, setPortal] = (0, $eeH7J.useState)(null);
    const modal = root && portal && /*#__PURE__*/ (0, $iMJCh.createPortal)(root, portal);
    function Portal() {
        return (0, $4vwom.jsx)("div", {
            ref: (r)=>setPortal(r),
            children: (0, $4vwom.jsx)("div", {
                style: {
                    height: 0,
                    width: 0
                }
            })
        });
    }
    const showModal = async (render)=>{
        return await $d5875cc29dc443c7$export$2b77a92f1a5ad772((close)=>{
            setRoot(render(close));
            return (0, $4vwom.jsx)(Portal, {});
        });
    };
    return {
        modal: modal,
        showModal: showModal,
        showingModal: !!root
    };
}
function $d5875cc29dc443c7$export$fd5a43132b1bbce7() {
    if ($d5875cc29dc443c7$var$close) $d5875cc29dc443c7$var$close(undefined);
}

});

parcelRegister("ht6im", function(module, exports) {

$parcel$export(module.exports, "ChipWidget", function () { return $cb7a0731c11cd17b$export$c71f432cc1640ad; });

var $4vwom = parcelRequire("4vwom");

var $14q7s = parcelRequire("14q7s");

var $l079f = parcelRequire("l079f");

var $4rY0U = parcelRequire("4rY0U");

var $9Q5xE = parcelRequire("9Q5xE");

var $6sp4J = parcelRequire("6sp4J");
parcelRequire("2LTO8");
var $hsrrX = parcelRequire("hsrrX");

var $hV5w0 = parcelRequire("hV5w0");
(0, $4rY0U.RegisterWidget)("Chip", $cb7a0731c11cd17b$export$c71f432cc1640ad);
function $cb7a0731c11cd17b$export$c71f432cc1640ad({ value: value }) {
    var _a;
    const performAction = (0, $hV5w0.usePerformWidgetAction)();
    const colorSeed = value.text || value.icon;
    const colors = value.color ? value.color in (0, $9Q5xE.ColorStyles) ? (0, $9Q5xE.ColorStyles)[value.color] : value.color : colorSeed ? (0, $l079f.UntitledUI).randomSecondaryColor(colorSeed) : (0, $9Q5xE.ColorStyles).gray;
    const dark = typeof colors === "object" ? undefined : (0, $hsrrX.Color).isDark(colors);
    async function onClick() {
        if (value.widgetKey) await performAction(value.widgetKey);
    }
    function getTextColor() {
        var _a;
        if (value.disabled) return (0, $9Q5xE.ColorStyles).gray[400];
        if (dark !== undefined) return dark ? "white" : "black";
        return value.foregroundWeight === 0 ? "white" : colors[(_a = value.foregroundWeight) !== null && _a !== void 0 ? _a : 700];
    }
    return (0, $4vwom.jsxs)("div", {
        style: {
            display: "flex",
            flexDirection: "row"
        },
        onClick: onClick,
        children: [
            value.disabled,
            (0, $4vwom.jsxs)("div", {
                style: {
                    backgroundColor: !value.disabled ? typeof colors === "object" ? colors[(_a = value.backgroundWeight) !== null && _a !== void 0 ? _a : 50] : colors : "unset",
                    color: getTextColor(),
                    border: value.disabled ? `1px solid ${(0, $9Q5xE.ColorStyles).gray[400]}` : "unset",
                    borderRadius: 16,
                    paddingRight: 8,
                    fontSize: 12,
                    fontWeight: 500,
                    marginRight: 2,
                    maxHeight: 30,
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center"
                },
                children: [
                    value.image && (0, $4vwom.jsx)("div", {
                        style: {
                            display: "flex",
                            width: 24,
                            height: 24,
                            backgroundImage: (0, $14q7s.ImageToCSS)(value.image, {
                                width: 24
                            }),
                            backgroundSize: "cover",
                            backgroundPosition: "center",
                            backgroundRepeat: "no-repeat",
                            borderRadius: 12
                        }
                    }),
                    (0, $4vwom.jsxs)("div", {
                        style: {
                            paddingTop: 6,
                            paddingBottom: 6,
                            paddingLeft: 8,
                            display: "flex",
                            flexDirection: "row",
                            // if the strikeThrough prop is true, add a line-through style
                            textDecoration: value.strikeThrough ? "line-through" : "none"
                        },
                        children: [
                            value.icon && (0, $4vwom.jsx)((0, $6sp4J.Icon), {
                                icon: value.icon,
                                style: {
                                    color: colors[500],
                                    marginRight: value.text ? value.icon.startsWith("ui-") ? 6 : 4 : 0,
                                    marginTop: !value.icon || value.icon.startsWith("ui-") ? 0 : 3,
                                    marginLeft: !value.icon || value.icon.startsWith("ui-") ? 0 : 3,
                                    width: 16
                                }
                            }),
                            value.text
                        ]
                    })
                ]
            })
        ]
    });
}

});
parcelRegister("14q7s", function(module, exports) {

$parcel$export(module.exports, "GetFileTypeMimeTypes", function () { return $0c7a6cef28e734b1$export$d452d10e32b524e4; });
$parcel$export(module.exports, "ImageToUrl", function () { return $0c7a6cef28e734b1$export$d85247f7a9f240bc; });
$parcel$export(module.exports, "UndoImageToUrl", function () { return $0c7a6cef28e734b1$export$3699a36e09881599; });
$parcel$export(module.exports, "ImageToCSS", function () { return $0c7a6cef28e734b1$export$b6be8aee23e40625; });
$parcel$export(module.exports, "FileToUrl", function () { return $0c7a6cef28e734b1$export$6a9e367146026a4; });

var $7m9cQ = parcelRequire("7m9cQ");

var $43jhg = parcelRequire("43jhg");
function $0c7a6cef28e734b1$export$d452d10e32b524e4(type) {
    if ((0, $43jhg.IsUnionType)(type)) return type.union.map($0c7a6cef28e734b1$export$d452d10e32b524e4).reduce((a, b)=>[
            ...a,
            ...b
        ]);
    if ((0, $43jhg.IsFileType)(type)) return [
        type.mimeType
    ];
    return [];
}
function $0c7a6cef28e734b1$export$d85247f7a9f240bc(image, options, /** Optimization.
 *
 * Computing the server URL of the request can be slow (due to context-lookup), in
 * performance-critical code the URL for the current request can be precomputed and passed in
 * here. */ serverBaseUrl) {
    // This happens sometimes during WYSIWYG editing, when the image is not yet uploaded.
    if (!image) return "";
    // On the client, the image is already a full URL. We need to undo that to encode the new options.
    const url = $0c7a6cef28e734b1$export$3699a36e09881599(image);
    const width = (options === null || options === void 0 ? void 0 : options.width) || "";
    const height = (options === null || options === void 0 ? void 0 : options.height) ? "x" + options.height : "";
    const ext = (options === null || options === void 0 ? void 0 : options.format) ? "." + options.format : ".png";
    serverBaseUrl !== null && serverBaseUrl !== void 0 ? serverBaseUrl : serverBaseUrl = (0, $7m9cQ.server)();
    return (url.startsWith(serverBaseUrl) ? url : `${serverBaseUrl}/api/images/${url}`) + `_${width}${height}${ext}`;
}
function $0c7a6cef28e734b1$export$3699a36e09881599(/** An image handle that might be in a full URL form. */ image) {
    let str = image.valueOf();
    const lastSlash = str.lastIndexOf("/");
    if (lastSlash !== -1) str = str.slice(lastSlash + 1);
    const lastUnderscore = str.lastIndexOf("_");
    if (lastUnderscore !== -1) str = str.slice(0, lastUnderscore);
    return str;
}
function $0c7a6cef28e734b1$export$b6be8aee23e40625(image, options) {
    let str = image.valueOf();
    if (str.toString().startsWith("url(")) str = str.slice(4, -1);
    return "url(" + $0c7a6cef28e734b1$export$d85247f7a9f240bc(image, options) + ")";
}
function $0c7a6cef28e734b1$export$c88e32e07e07186b(video, options, /** Optimization.
 *
 * Computing the server URL of the request can be slow (due to context-lookup), in
 * performance-critical code the URL for the current request can be precomputed and passed in
 * here. */ serverBaseUrl) {
    // This happens sometimes during WYSIWYG editing, when the video is not yet uploaded.
    if (!video) return "";
    // On the client, the video is already a full URL. We need to undo that to encode the new options.
    const url = $0c7a6cef28e734b1$export$3699a36e09881599(video);
    const ext = (options === null || options === void 0 ? void 0 : options.format) ? "." + options.format : ".mp4";
    serverBaseUrl !== null && serverBaseUrl !== void 0 ? serverBaseUrl : serverBaseUrl = (0, $7m9cQ.server)();
    return (url.startsWith(serverBaseUrl) ? url : `${serverBaseUrl}/api/videos/${url}`) + `${ext}`;
}
function $0c7a6cef28e734b1$export$6a9e367146026a4(file, /** Optimization.
 *
 * Computing the server URL of the request can be slow (due to context-lookup), in
 * performance-critical code the URL for the current request can be precomputed and passed in
 * here. */ serverBaseUrl) {
    serverBaseUrl !== null && serverBaseUrl !== void 0 ? serverBaseUrl : serverBaseUrl = (0, $7m9cQ.server)();
    if (file.toString().startsWith(serverBaseUrl)) return file.toString();
    return `${serverBaseUrl}/api/files/${file.toString()}`;
}

});
parcelRegister("43jhg", function(module, exports) {

$parcel$export(module.exports, "IsOpaqueStringType", function () { return IsOpaqueStringType; });
$parcel$export(module.exports, "GetTypeAlias", function () { return GetTypeAlias; });
$parcel$export(module.exports, "UnionType", function () { return UnionType; });
$parcel$export(module.exports, "UndefinedType", function () { return UndefinedType; });
$parcel$export(module.exports, "IsFileType", function () { return IsFileType; });
$parcel$export(module.exports, "IsStringType", function () { return IsStringType; });
$parcel$export(module.exports, "IsNumberType", function () { return IsNumberType; });
$parcel$export(module.exports, "IsBooleanType", function () { return IsBooleanType; });
$parcel$export(module.exports, "IsLiteralType", function () { return IsLiteralType; });
$parcel$export(module.exports, "IsStringLiteral", function () { return IsStringLiteral; });
$parcel$export(module.exports, "IsNumberLiteral", function () { return IsNumberLiteral; });
$parcel$export(module.exports, "IsBooleanLiteral", function () { return IsBooleanLiteral; });
$parcel$export(module.exports, "IsNullType", function () { return IsNullType; });
$parcel$export(module.exports, "IsUndefinedType", function () { return IsUndefinedType; });
$parcel$export(module.exports, "IsAnyType", function () { return IsAnyType; });
$parcel$export(module.exports, "IsUnknownType", function () { return IsUnknownType; });
$parcel$export(module.exports, "IsUnionType", function () { return IsUnionType; });
$parcel$export(module.exports, "IsIntersectionType", function () { return IsIntersectionType; });
$parcel$export(module.exports, "IsArrayType", function () { return IsArrayType; });
$parcel$export(module.exports, "IsObjectType", function () { return IsObjectType; });
$parcel$export(module.exports, "IsVoidType", function () { return IsVoidType; });
$parcel$export(module.exports, "IsParameterType", function () { return IsParameterType; });
$parcel$export(module.exports, "IsAtomic", function () { return IsAtomic; });
$parcel$export(module.exports, "IsFunctionType", function () { return IsFunctionType; });
$parcel$export(module.exports, "IsPromiseType", function () { return IsPromiseType; });
$parcel$export(module.exports, "IsNeverType", function () { return IsNeverType; });
$parcel$export(module.exports, "IsAsyncGeneratorType", function () { return IsAsyncGeneratorType; });
$parcel$export(module.exports, "TypeToString", function () { return TypeToString; });
$parcel$export(module.exports, "GetTypeModel", function () { return GetTypeModel; });
$parcel$export(module.exports, "GetTypeProps", function () { return GetTypeProps; });
$parcel$export(module.exports, "Discriminate", function () { return Discriminate; });
$parcel$export(module.exports, "AreTypesAssignable", function () { return AreTypesAssignable; });
$parcel$export(module.exports, "TypeDiagnosticToString", function () { return TypeDiagnosticToString; });
$parcel$export(module.exports, "MatchesType", function () { return MatchesType; });
$parcel$export(module.exports, "GetTypeValidator", function () { return GetTypeValidator; });
$parcel$export(module.exports, "ValidateType", function () { return ValidateType; });
$parcel$export(module.exports, "MatchesTypeTurbo", function () { return MatchesTypeTurbo; });
$parcel$export(module.exports, "IsTypeOrUndefined", function () { return IsTypeOrUndefined; });
$parcel$export(module.exports, "IsNumberOrUndefinedType", function () { return IsNumberOrUndefinedType; });
$parcel$export(module.exports, "VisitType", function () { return VisitType; });
$parcel$export(module.exports, "ReplaceValuesByType", function () { return ReplaceValuesByType; });

var $lDBHC = parcelRequire("lDBHC");

var $3oicm = parcelRequire("3oicm");

var $14q7s = parcelRequire("14q7s");

var $g0jSz = parcelRequire("g0jSz");

var $lHoPV = parcelRequire("lHoPV");

var $dAwef = parcelRequire("dAwef");

var $cv7r0 = parcelRequire("cv7r0");

var $cwhCA = parcelRequire("cwhCA");
function OpaqueStringType(opaque) {
    return {
        string: null,
        opaque: opaque
    };
}
const TimestampType = {
    string: null,
    opaque: "Timestamp",
    alias: "Timestamp"
};
const TimestampWithoutTimezoneType = {
    string: null,
    opaque: "TimestampWithoutTimezone",
    alias: "TimestampWithoutTimezone"
};
function IsOpaqueStringType(type) {
    return typeof type === "object" && "string" in type && "opaque" in type;
}
function IsTimestampType(type) {
    return typeof type === "object" && type.alias === "Timestamp";
}
function HasDocumentation(type) {
    return typeof type === "object" && "documentation" in type;
}
function SetTypeAlias(alias, type) {
    if (typeof type === "object" && alias && !type.alias && !alias.startsWith("__") && alias !== "Array") type.alias = alias;
    return type;
}
function GetTypeAlias(type) {
    if (typeof type === "object") return type.alias;
}
function UnionType(...union) {
    return {
        union: union
    };
}
function IntersectionType(...intersection) {
    return {
        intersection: intersection
    };
}
const StringType = "string";
const NumberType = "number";
const IntegerType = "number";
const BooleanType = "boolean";
const NullType = "null";
const UndefinedType = "undefined";
const VoidType = "void";
const AnyType = "any";
const UnknownType = "unknown";
const NeverType = "never";
const FunctionType = "function";
function RangedIntegerType(alias, minValue, maxValue) {
    return {
        number: null,
        integer: true,
        alias: alias,
        minValue: minValue,
        maxValue: maxValue
    };
}
function StringLiteral(value) {
    return {
        string: value
    };
}
function NumberLiteral(value) {
    return {
        number: value
    };
}
function BooleanLiteral(value) {
    return {
        boolean: value
    };
}
function ArrayType(itemType = "unknown") {
    return {
        array: itemType
    };
}
const BufferType = {
    buffer: null
};
function PromiseType(payloadType) {
    return {
        promise: payloadType
    };
}
function ParameterType(name) {
    return {
        param: name
    };
}
function IsFileType(type) {
    return typeof type === "object" && "mimeType" in type;
}
function IsFileTypeCompatible(type) {
    if (typeof type === "object") {
        if ("mimeType" in type) return true;
        if ("union" in type) return type.union.every(IsFileTypeCompatible);
    }
    return false;
}
function IsStringType(type) {
    return Is(type, "string");
}
function IsNumberType(type) {
    return Is(type, "number") || Is(type, "integer");
}
function IsIntegerType(type) {
    return typeof type === "string" ? type === "integer" : "number" in type && !!type.integer;
}
function IsBooleanType(type) {
    return Is(type, "boolean");
}
function IsLiteralType(type) {
    return IsStringLiteral(type) || IsNumberLiteral(type) || IsBooleanLiteral(type) || IsNullType(type) || IsUndefinedType(type);
}
function IsStringLiteral(type) {
    return typeof type !== "string" && "string" in type && type.string !== null;
}
function IsNumberLiteral(type) {
    return typeof type !== "string" && "number" in type && type.number !== null;
}
function IsBooleanLiteral(type) {
    return typeof type !== "string" && "boolean" in type && type.boolean !== null;
}
function Is(a, keyword) {
    return typeof a === "string" ? a === keyword : typeof a === "object" && keyword in a;
}
function IsNullType(type) {
    return Is(type, "null");
}
function IsUndefinedType(type) {
    return Is(type, "undefined");
}
function IsAnyType(type) {
    return Is(type, "any");
}
function IsUnknownType(type) {
    return Is(type, "unknown");
}
function IsUnionType(type) {
    return Is(type, "union");
}
function IsIntersectionType(type) {
    return Is(type, "intersection");
}
function IsArrayType(type) {
    return Is(type, "array");
}
function IsObjectType(type) {
    return Is(type, "props");
}
function IsClassType(type, /** Specifies a class name that either must be equal to the alias of this
 * type, or one of its super types. */ className) {
    return IsObjectType(type) && "isClass" in type && !!type.isClass && (!className ? true : type.alias === className || !!type.super && IsClassType(type.super, className));
}
function IsVoidType(type) {
    return typeof type !== "string" ? "void" in type : type === "void";
}
function IsParameterType(type) {
    return Is(type, "param");
}
function IsAtomic(type) {
    return IsStringType(type) || IsNumberType(type) || IsBooleanType(type);
}
function IsFunctionType(type) {
    return Is(type, "function");
}
function IsPromiseType(type) {
    return Is(type, "promise");
}
function IsNeverType(type) {
    return Is(type, "never");
}
function GetTypeReference(type) {
    if (typeof type !== "object") return;
    if (type.reference) return type.reference;
    if (IsArrayType(type)) return GetTypeReference(type.array);
}
function AsyncGeneratorType(generator, returns, next) {
    return {
        generator: generator,
        returns: returns,
        next: next
    };
}
function IsAsyncGeneratorType(t) {
    return typeof t === "object" && "generator" in t;
}
const typeToStringCache = new WeakMap();
function TypeToString(t) {
    if (typeof t === "string") return t;
    let cached = typeToStringCache.get(t);
    if (cached === undefined) {
        cached = TypeToStringUncached(t, true, false);
        typeToStringCache.set(t, cached);
    }
    return cached;
}
function TypeToStringUncached(t, alias, docs, options) {
    var _a, _b, _c, _d;
    if (typeof t === "string") return t;
    if (t.opaque && t.alias) {
        if (IsOpaqueStringType(t) && "precision" in t && t.precision) {
            (_a = options === null || options === void 0 ? void 0 : options.aliasEncounter) === null || _a === void 0 || _a.call(options, t);
            return `${t.alias}<"${t.precision}">`;
        }
        if ((_b = options === null || options === void 0 ? void 0 : options.preserveOpaques) === null || _b === void 0 ? void 0 : _b.includes(t.alias)) return t.alias + '<"' + t.opaque + '">';
    }
    if (((_c = t.typeArgs) === null || _c === void 0 ? void 0 : _c.length) && alias && GetTypeAlias(t) !== undefined && (options === null || options === void 0 ? void 0 : options.emitTypeArgs) !== false) return TypeToStringUncached(t, alias, docs, Object.assign(Object.assign({}, options), {
        emitTypeArgs: false
    })) + "<" + t.typeArgs.map((b)=>TypeToStringUncached(b, true, docs, options)) + ">";
    if (alias && t.alias && t.alias !== "Array") {
        (_d = options === null || options === void 0 ? void 0 : options.aliasEncounter) === null || _d === void 0 || _d.call(options, t);
        return t.alias;
    } else if (IsStringType(t) && typeof t === "object") return t.string == null ? "string" : JSON.stringify(t.string);
    else if (IsNumberType(t)) return t.number === null ? "number" : "" + t.number;
    else if (IsBooleanType(t)) return t.boolean === null ? "boolean" : "" + t.boolean;
    else if (IsUndefinedType(t)) return "undefined";
    else if (IsNullType(t)) return "null";
    else if (IsAnyType(t)) return "any";
    else if (IsUnionType(t)) return "(" + t.union.map((x)=>TypeToStringUncached(x, true, docs, options)).join(" | ") + ")";
    else if (IsIntersectionType(t)) return "(" + t.intersection.map((x)=>TypeToStringUncached(x, true, docs, options)).join(" & ") + ")";
    else if (IsArrayType(t)) return TypeToStringUncached(t.array, true, docs, options) + "[]";
    else if (IsObjectType(t)) return "{ " + t.props.map((x)=>{
        var _a;
        return (docs && ((_a = x.description) === null || _a === void 0 ? void 0 : _a.en) ? "/** " + x.description.en + "*/\n" : "") + JSON.stringify(x.name) + (x.optional ? "?" : "") + ": " + TypeToStringUncached(x.type, true, docs, options);
    }).join(",\n") + (t.additionalProps ? `\n[key: string]: ${TypeToStringUncached(t.additionalProps, true, docs, options)}` : "") + " }";
    else if (IsVoidType(t)) return "void";
    else if (IsParameterType(t)) return t.param;
    else if (IsNeverType(t)) return "never";
    else if (IsUnknownType(t)) return "unknown";
    else if (IsPromiseType(t)) return "Promise<" + TypeToString(t.promise) + ">";
    else if (IsAsyncGeneratorType(t)) return "AsyncIterable<" + TypeToString(t.generator) + ">";
    else if (IsFileType(t)) return 'File<"' + t.mimeType + '">';
    else throw new Error("Cannot stringify " + t);
}
function GetTypeModel(type) {
    if (typeof type !== "object") return;
    if (!type.sourceFile) return;
    if (!type.sourceFile.startsWith("/models/")) return;
    return type.sourceFile.split("/")[2];
}
const typePropsCache = new Map();
const emptyProps = Object.freeze([]);
function GetTypeProps(type, /** Optionally provide a value. If the type is a union, this will be used to attempt to
 * discriminate the union to get a more precise property set. */ value) {
    if (IsObjectType(type)) {
        if (!(type.props instanceof Array)) throw new Error();
        return type.props;
    }
    if (IsIntersectionType(type)) {
        const props = typePropsCache.get(type);
        if (props) return props;
        const newProps = type.intersection.map(GetTypeProps).reduce((a, b)=>a.concat(b), []);
        typePropsCache.set(type, newProps);
        return newProps;
    } else if (IsUnionType(type)) {
        if (value) {
            const discType = Discriminate(value, type);
            if (discType !== type) return GetTypeProps(discType);
        }
        const props = typePropsCache.get(type);
        if (props) return props;
        const u = type.union.map((x)=>GetTypeProps(x));
        if (u.length === 0) return emptyProps;
        const newProps = u[0].filter((x)=>u.every((y)=>y.some((z)=>z.name === x.name)));
        typePropsCache.set(type, newProps);
        return newProps;
    } else return emptyProps;
}
const areTypesAssignableCache = new WeakMap();
function AreTypesAssignable(dest, source) {
    if (source === dest) return true;
    if (source === "any") return true;
    if (dest === "any") return true;
    if (typeof dest === "string") {
        if (typeof source === "object") {
            if (source.opaque) return false;
        }
        if (dest === "string") return IsStringType(source);
        if (dest === "number") return IsNumberType(source);
        if (dest === "integer") return IsIntegerType(source);
        if (dest === "boolean") return IsBooleanType(source);
        return dest === source;
    }
    let cached;
    if (typeof source === "object") {
        cached = areTypesAssignableCache.get(dest);
        if (cached) {
            const value = cached.get(source);
            if (value !== undefined) return value;
        } else {
            cached = new Map();
            areTypesAssignableCache.set(dest, cached);
        }
    }
    const result = AreTypesAssignableUncached(dest, source);
    if (cached && typeof source === "object") cached.set(source, result);
    return result;
}
function AreTypesAssignableUncached(dest, source) {
    if (IsUnionType(source)) return source.union.every((x)=>AreTypesAssignable(dest, x));
    if (IsUnionType(dest)) return dest.union.some((d)=>AreTypesAssignable(d, source));
    if (IsFileType(source) && IsFileType(dest)) return source.mimeType === dest.mimeType;
    if (typeof source === "object" && typeof dest === "object") {
        if (dest.opaque !== source.opaque) return false;
        if (source.alias && source.alias === dest.alias) return true;
        if (source.alias && dest.alias && source.alias !== dest.alias) return false;
    }
    if (IsAnyType(dest)) return true;
    if (IsIntersectionType(dest)) return dest.intersection.every((d)=>AreTypesAssignable(d, source));
    if (IsFileType(dest)) return IsFileType(source) && (source.mimeType.startsWith(dest.mimeType) || dest.mimeType.startsWith(source.mimeType));
    if (IsStringType(dest)) {
        if (!IsStringType(source)) return false;
        if (dest === "string") return true;
        if (dest.string === null) return true;
        if (typeof source !== "object") return false;
        if (source.string === null) return false;
        else return dest.string === source.string;
    }
    if (IsNumberType(dest)) {
        if (!IsNumberType(source)) return false;
        if (dest === "number") return true;
        if (dest === "integer") return IsIntegerType(source);
        if (dest.number === null) return true;
        if (typeof source !== "object") return false;
        if (source.number === null) return false;
        else return dest.number === source.number;
    }
    if (IsBooleanType(dest)) {
        if (!IsBooleanType(source)) return false;
        if (dest === "boolean") return true;
        if (dest.boolean === null) return true;
        if (typeof source !== "object") return false;
        if (source.boolean === null) return false;
        else return dest.boolean === source.boolean;
    }
    if (IsNullType(dest)) return IsNullType(source);
    if (IsUndefinedType(dest)) return IsUndefinedType(source);
    if (IsArrayType(dest)) {
        if (!IsArrayType(source)) return false;
        return AreTypesAssignable(dest.array, source.array);
    }
    if (IsPromiseType(dest)) {
        if (!IsPromiseType(source)) return false;
        return AreTypesAssignable(dest.promise, source.promise);
    }
    if (IsObjectType(dest)) {
        if (!IsObjectType(source)) return false;
        return dest.props.every((pd)=>{
            const ps = source.props.find((p)=>p.name === pd.name);
            if (!ps) return pd.optional;
            return AreTypesAssignable(pd.type, ps.type);
        });
    }
    if (IsParameterType(dest)) {
        if (!IsParameterType(source)) return false;
        return dest.param === source.param;
    }
    if (IsUnknownType(dest)) return false;
    if (IsVoidType(dest)) {
        if (IsVoidType(source)) return true;
        if (IsUndefinedType(source)) return true;
        return false;
    }
    if (IsFunctionType(dest)) return false; // TODO
    if (IsNeverType(dest)) return false;
    throw new Error("Unhandled type: " + TypeToString(dest));
}
function AreTypesAssignableBothWays(a, b) {
    return AreTypesAssignable(a, b) && AreTypesAssignable(b, a);
}
function TypeDiagnosticToString(e, indent = 0) {
    if (e.subErrors && e.subErrors.length === 1) return TypeDiagnosticToString(e.subErrors[0], indent);
    return " ".repeat(indent) + e.path + ": " + e.error + (e.subErrors && e.subErrors.length ? e.subErrors.map((x)=>"\n" + TypeDiagnosticToString(x, indent + 1)).join("") : "");
}
function RepairDefaultTypes(v, type) {
    return RepairTypes(v, type, [
        (x, t)=>AreTypesAssignable(t, UndefinedType) && x === null ? undefined : x
    ]);
}
function RepairTypes(v, type, rules) {
    if (IsAnyType(type)) return v;
    if (rules.length) for (const rule of rules)v = rule(v, type);
    if (IsUnionType(type)) {
        const dt = Discriminate(v, type);
        if (IsUnionType(dt)) {
            if (dt.union.find((x)=>MatchesType(RepairTypes(v, x, rules), x) === true)) return v;
        } else type = dt;
    }
    if (IsIntersectionType(type)) for (const t of type.intersection)v = RepairTypes(v, t, rules);
    if (IsObjectType(type) && v && typeof v === "object") type.props.forEach((p)=>{
        if (p.name in v) v[p.name] = RepairTypes(v[p.name], p.type, rules);
    });
    if (IsArrayType(type) && v instanceof Array) for(let i = 0; i < v.length; i++)v[i] = RepairTypes(v[i], type.array, rules);
    if (IsFileType(type)) {
        if (typeof v === "string" && v.startsWith("http://") || v.startsWith("https://")) return (0, $14q7s.UndoImageToUrl)(v);
    }
    return v;
}
function typeOf(v) {
    if (v === null) return "null";
    return typeof v;
}
const validatorCache = new Map();
function GetTypeValidator(type) {
    if (typeof type === "object") {
        const alias = GetTypeAlias(type);
        if (type.validator) {
            if ((0, $lDBHC.IsNode)() && alias) return (0, $lHoPV.TypeValidator).functions.find((t)=>t.name === alias);
            else {
                let val = validatorCache.get(type);
                if (!val) {
                    // eslint-disable-next-line no-eval
                    val = eval("(" + type.validator + ")");
                    validatorCache.set(type, val);
                }
                return val;
            }
        }
    }
}
function ValidateType(value, type) {
    if (typeof type === "object" && type.validator) {
        const validator = GetTypeValidator(type);
        if (validator) return validator(value);
    }
    return value;
}
function MatchesTypeTurbo(value, type, validate = false) {
    // Fast paths for common cases
    const t = typeof value;
    if (t === type) return true;
    if (typeof type === "object") {
        if (validate && type.validator) try {
            value = ValidateType(value, type);
        } catch (e) {
            return false;
        }
        switch(t){
            case "string":
                if (type.string === null) return true;
                if (type.string === value) return true;
                break;
            case "number":
                if (IsNumberType(type)) {
                    if (type.minValue !== undefined) break;
                    if (type.maxValue !== undefined) break;
                    if (type.integer) break;
                }
                if (type.number === null) return true;
                if (type.number === value) return true;
                break;
            case "boolean":
                if (type.boolean === null) return true;
                if (type.boolean === value) return true;
                break;
        }
    } else if (typeof type === "string") switch(type){
        case "string":
            return t === "string";
        case "number":
            return t === "number";
        case "integer":
            return t === "number" && Number.isInteger(value);
        case "function":
            return t === "function";
        case "void":
            return t === "undefined";
        case "symbol":
            return t === "symbol";
        case "boolean":
            return t === "boolean";
        case "null":
            return value === null;
        case "undefined":
            return value === undefined;
        case "any":
            return true;
        case "unknown":
        case "never":
            return false;
    }
    // Fast path for successful matches using fast JIT'ed checker
    if (typeof type === "object" && (0, $g0jSz.MatchesTypeJIT)(type, value, validate)) return true;
    return false;
}
function MatchesType(value, type, /** If true, the function will return on the first error.
 *  If false, the function will find all errors before returning.
 */ fast = true, /** If true, this function will report overposting/superfluous props as errors.
 *  If false, superfluous props will be ignored.
 */ strict = false, /** If true, this function will include validator functions as part of asserting a value's
 *  conformance to a type. If false, validator functions will be ignored.
 */ validate = true, path = "") {
    const turboMatch = MatchesTypeTurbo(value, type, validate);
    if (turboMatch) return true;
    if (typeof type === "object") {
        if (validate && type.validator) try {
            value = ValidateType(value, type);
        } catch (e) {
            return {
                error: e.message,
                fields: e.fields,
                path: path
            };
        }
    }
    // Fast matcher failed, producing proper error message
    const t = typeof value;
    if (typeof t === "string") switch(type){
        case "string":
            return t === "string" ? true : {
                error: "Expected string, got " + t,
                path: path
            };
        case "number":
            return t === "number" ? true : {
                error: "Expected number, got " + t,
                path: path
            };
        case "boolean":
            return t === "boolean" ? true : {
                error: "Expected boolean, got " + t,
                path: path
            };
        case "null":
            return value === null ? true : {
                error: "Expected null, got " + t,
                path: path
            };
        case "undefined":
            return value === undefined ? true : {
                error: "Expected undefined, got " + t,
                path: path
            };
    }
    if (IsObjectType(type)) {
        if (value === null) return {
            error: "Expected object, got null",
            path: path
        };
        if (t !== "object") return {
            error: "Expected object, got " + typeOf(value),
            path: path
        };
        const props = type.props;
        const getSuperfluousProps = ()=>Object.keys(value).filter((x)=>!props.some((y)=>x === y.name));
        const subErrors = [];
        for (const p of props){
            const optional = p.optional || AreTypesAssignable(p.type, "undefined");
            if (optional && value[p.name] === undefined) continue;
            if (!optional && !(p.name in value)) {
                subErrors.push({
                    error: "Missing required property " + p.name,
                    subErrors: [],
                    path: path
                });
                if (fast) break;
            }
            const res = MatchesType(value[p.name], p.type, fast, strict, validate, path ? path + "." + p.name : p.name);
            if (res !== true) {
                subErrors.push({
                    error: "Property '" + p.name + "' did not match",
                    subErrors: [
                        res
                    ],
                    path: path
                });
                if (fast) break;
            }
        }
        if (strict) {
            const extraProps = getSuperfluousProps();
            if (extraProps.length > 0) subErrors.push({
                error: "The following props were present but not expected",
                subErrors: extraProps.map((x)=>({
                        error: x,
                        path: path
                    })),
                path: path
            });
        }
        if (subErrors.length > 0) return {
            error: "Did not match object type " + TypeToString(type),
            subErrors: subErrors,
            path: path
        };
        return true;
    } else if (IsArrayType(type)) {
        if (!(value instanceof Array)) return {
            error: "Expected array, got " + typeOf(value),
            path: path
        };
        const subErrors = [];
        const len = value.length;
        for(let i = 0; i < len; i++){
            const res = MatchesType(value[i], type.array, fast, strict, validate, path + "[" + i + "]");
            if (res !== true) {
                subErrors.push({
                    error: "Element at index " + i + " did not match",
                    subErrors: [
                        res
                    ],
                    path: path
                });
                if (fast) break;
            }
        }
        if (subErrors.length === 1) return {
            error: "An item does not match expected type " + TypeToString(type.array),
            subErrors: subErrors,
            path: path
        };
        else if (subErrors.length > 1 && subErrors.length < value.length) return {
            error: subErrors.length + " out of " + value.length + " items do not match expected type " + TypeToString(type.array),
            subErrors: subErrors,
            path: path
        };
        else if (subErrors.length) return {
            error: "None of the items match expected type " + TypeToString(type.array),
            subErrors: subErrors,
            path: path
        };
        return true;
    } else if (IsAnyType(type)) return true;
    else if (IsNullType(type)) return value === null ? true : {
        error: "Expected null, got " + typeOf(value),
        path: path
    };
    else if (IsUnionType(type)) {
        const d = Discriminate(value, type);
        if (d !== type) {
            const res = MatchesType(value, d, fast, strict, true, "(" + path + " as " + TypeToString(d) + ")");
            if (res === true) return true;
            else return {
                error: "Did not match discriminated type " + TypeToString(d),
                subErrors: [
                    res
                ],
                path: path
            };
        } else {
            const results = type.union.map((x)=>MatchesType(value, x, fast, strict, true, TypeToString(x)));
            if (results.some((x)=>x === true)) return true;
            else return {
                error: "Did not match any types in the union " + TypeToString(type),
                subErrors: results.filter((x)=>typeof x === "object"),
                path: path
            };
        }
    } else if (IsIntersectionType(type)) {
        const subErrors = [];
        for (const x of type.intersection){
            const err = MatchesType(value, x, fast, false, validate);
            if (err !== true) subErrors.push(err);
        }
        if (subErrors.length === 0 && strict && typeof value === "object" && value !== null) {
            const props = GetTypeProps(type);
            Object.keys(value).forEach((x)=>{
                if (!props.find((y)=>y.name === x)) subErrors.push({
                    error: "Property '" + x + "' was not expected in type " + TypeToString(type),
                    path: path
                });
            });
        }
        if (subErrors.length > 0) return {
            error: "Did not match intersection " + TypeToString(type),
            subErrors: subErrors,
            path: path
        };
        return true;
    } else if (IsVoidType(type)) return value === undefined ? true : {
        error: "Expected void, got a value",
        path: path
    };
    else if (IsUnknownType(type)) return {
        error: "No value is compatible with 'unknown'",
        path: path
    };
    else if (IsUndefinedType(type)) return t === "undefined" ? true : {
        error: "Expected undefined, got " + typeOf(value),
        path: path
    };
    else if (IsFileType(type)) {
        if (t !== "string") return {
            error: "Expected file handle, got " + JSON.stringify(value),
            path: path
        };
        if (value.startsWith("http://") || value.startsWith("https://")) return {
            error: "Expected file handle, got URL: " + value,
            path: path
        };
        if (!(0, $dAwef.Uuid).validate(value)) return {
            error: "Expected UUID file handle, got " + JSON.stringify(value),
            path: path
        };
        return true;
    } else if (IsStringType(type)) {
        if (typeof type === "object") {
            if (type.string !== null && value !== type.string) return {
                error: "Expected '" + type.string + "', got " + JSON.stringify(value),
                path: path
            };
            if (type.string === null) {
                if (t !== "string") return {
                    error: "Expected string, got " + typeOf(value),
                    path: path
                };
            }
        }
        return true;
    } else if (IsNumberType(type)) {
        if (type === "integer" || typeof type === "object" && type.integer) {
            if ((value | 0) !== value) return {
                error: "Expected integer, got " + JSON.stringify(value),
                path: path
            };
        }
        if (typeof type === "object") {
            if (type.number !== null) {
                if (value !== type.number) return {
                    error: "Expected " + type.number + ", got " + typeOf(value),
                    path: path
                };
            }
            if (type.maxValue !== undefined) {
                if (value > type.maxValue) return {
                    error: "Maximum value is " + type.maxValue + ", got " + value,
                    path: path
                };
            }
            if (type.minValue !== undefined) {
                if (value < type.minValue) return {
                    error: "Minimum value is " + type.minValue + ", got " + value,
                    path: path
                };
            }
        }
        if (t !== "number") return {
            error: "Expected number, got " + typeOf(value),
            path: path
        };
        return true;
    } else if (IsBooleanType(type)) {
        if (t !== "boolean") return {
            error: "Expected boolean, got " + typeOf(value),
            path: path
        };
        if (typeof type === "object" && type.boolean !== null) {
            if (type.boolean === value) return true;
            else return {
                error: "Expected '" + type.boolean + "', got " + value,
                path: path
            };
        } else return true;
    }
    throw new Error("Unhandled type: " + TypeToString(type));
}
function EnumerateTypeOptions(type, result = []) {
    if (IsUnionType(type)) type.union.forEach((t)=>EnumerateTypeOptions(t, result));
    else result.push(type);
    return result;
}
const isStringLiteralUnionCache = new Map();
let discriminateDepth = 0;
function Discriminate(value, union) {
    if (union.ifDefinedCache) {
        if (value === undefined) return "undefined";
        return union.ifDefinedCache;
    } else if (union.union.length === 2) {
        const t = union.union.filter((x)=>!IsUndefinedType(x));
        if (t.length === 1) {
            union.ifDefinedCache = t[0];
            if (value === undefined) return "undefined";
            return union.ifDefinedCache;
        }
    }
    const alias = GetTypeAlias(union);
    const plugin = alias && Discriminate.plugins.get(alias);
    if (plugin) return plugin(value, union);
    if (discriminateDepth > 8) {
        console.log("Warning - deep type recursion, unable to discriminate " + TypeToString(union));
        // Probably a recursive definition - unable to discriminate
        return union;
    }
    discriminateDepth++;
    try {
        if (typeof value === "object" && value !== null) {
            let d = discriminatorCache.get(union);
            if (!d) {
                const u = FlattenTypeIntersections(union);
                d = FindDiscriminator(u);
                if (d) discriminatorCache.set(union, d);
            }
            if (d) {
                const key = value[d.prop];
                return d.mapping[key] || union;
            }
        }
        // A common case that becomes a performance issue is to discriminate large string unions
        // (enums). This optimizes that case.
        let stringLiteralUnion = isStringLiteralUnionCache.get(union);
        if (stringLiteralUnion === undefined) {
            stringLiteralUnion = union.union.every(IsStringLiteral) ? new Map(union.union.map((t)=>[
                    t.string,
                    t
                ])) : false;
            isStringLiteralUnionCache.set(union, stringLiteralUnion);
        }
        if (stringLiteralUnion) {
            const stringLiteral = stringLiteralUnion.get(value);
            if (stringLiteral) return stringLiteral;
        }
        const types = union.union.filter((x)=>MatchesTypeTurbo(value, x, false));
        if (types.length === 1) return types[0];
        // Try resolving the ambiguous match by matching again in strict mode (#75)
        const types2 = union.union.filter((x)=>MatchesTypeTurbo(value, x, false));
        if (types2.length === 1) return types2[0];
        return union;
    } finally{
        discriminateDepth--;
    }
}
Discriminate.plugins = new Map();
function DiscriminatePlugin(alias, discriminate) {
    Discriminate.plugins.set(alias, discriminate);
}
const discriminatorCache = new WeakMap();
function FindDiscriminator(u) {
    let discriminator = discriminatorCache.get(u);
    if (!discriminator) {
        const t = u.union[0];
        if (IsObjectType(t)) {
            discriminator = t.props.map((p)=>buildDiscriminatorProp(u, {
                    prop: p.name,
                    mapping: {}
                })).find((x)=>!!x);
            if (discriminator) discriminatorCache.set(u, discriminator);
        }
    }
    return discriminator;
}
function buildDiscriminatorProp(t, context) {
    if (IsObjectType(t)) {
        const p = t.props.find((x)=>x.name === context.prop);
        return p && buildDiscriminatorMapping(p.type, t, context);
    } else if (IsUnionType(t)) {
        for (const u of t.union){
            if (!buildDiscriminatorProp(u, context)) return undefined;
        }
        return context;
    }
}
function buildDiscriminatorMapping(propType, targetType, context) {
    if (IsStringLiteral(propType)) {
        context.mapping[propType.string] = targetType;
        return context;
    } else if (IsUnionType(propType)) {
        if (propType.union.every((u)=>buildDiscriminatorMapping(u, targetType, context))) return context;
    }
}
const flattenedTypesCache = new WeakMap();
function FlattenTypeIntersections(type) {
    if (typeof type === "string") return type;
    let flat = flattenedTypesCache.get(type);
    if (!flat) {
        flat = FlattenTypeIntersectionsUncached(type);
        flattenedTypesCache.set(type, flat);
    }
    return flat;
}
function FlattenTypeIntersectionsUncached(type) {
    let t = typeof type === "string" ? type : (0, $3oicm.CloneGraph)(type);
    let keepGoing = true;
    while(keepGoing){
        keepGoing = false;
        t = new class extends (0, $cv7r0.Visitor) {
            intersection(i) {
                var _a;
                // (T & (T | undefined)) -> T
                if (i.intersection.length === 2) {
                    if (AreTypesAssignableBothWays(i.intersection[0], UnionType(i.intersection[1], UndefinedType))) return i.intersection[1];
                    if (AreTypesAssignableBothWays(i.intersection[1], UnionType(i.intersection[0], UndefinedType))) return i.intersection[0];
                }
                if (i.intersection.every(IsObjectType)) {
                    keepGoing = true;
                    const props = i.intersection.map((x)=>x.props).reduce((a, b)=>a.concat(b), [])// Shallow copy the props, as we will be modifying their optionality
                    .map((p)=>Object.assign({}, p));
                    // If properties occur multiple times in the intersection,
                    // compute the intersection of the property types and optionality
                    for(let n = 0; n < props.length; n++){
                        for(let m = n + 1; m < props.length; m++)if (props[m].name === props[n].name) {
                            if (!props[m].optional) props[n].optional = false;
                            props[n].type = FlattenTypeIntersections(IntersectionType(props[n].type, props[m].type));
                            props.splice(m, 1);
                        }
                    }
                    const objType = {
                        props: props,
                        additionalProps: (_a = i.intersection.find((x)=>x.additionalProps)) === null || _a === void 0 ? void 0 : _a.additionalProps,
                        alias: i.alias,
                        documentation: i.documentation
                    };
                    return objType;
                }
            }
        }().type(t) || t;
    }
    return t;
}
function IsTypeOrUndefined(type, isType) {
    if (IsUnionType(type) && type.union.length === 2) {
        if (isType(type.union[0]) && IsUndefinedType(type.union[1])) return type.union[0];
        else if (isType(type.union[1]) && IsUndefinedType(type.union[0])) return type.union[1];
    }
}
function IsStringOrUndefinedType(type) {
    return IsTypeOrUndefined(type, IsStringType);
}
function IsNumberOrUndefinedType(type) {
    return IsTypeOrUndefined(type, IsNumberType);
}
function VisitType(type, visitor, visitedSet = new Set(), path = []) {
    var _a;
    if (visitedSet.has(type)) return;
    visitedSet.add(type);
    visitor(type, path);
    if (typeof type === "object") (_a = type.typeArgs) === null || _a === void 0 || _a.forEach((x)=>VisitType(x, visitor, visitedSet, path));
    if (IsObjectType(type)) {
        type.props.forEach((x)=>VisitType(x.type, visitor, visitedSet, [
                ...path,
                x.name
            ]));
        if (type.additionalProps) VisitType(type.additionalProps, visitor, visitedSet, [
            ...path,
            "additionalProps"
        ]);
    } else if (IsArrayType(type)) VisitType(type.array, visitor, visitedSet, path);
    else if (IsUnionType(type)) {
        const disc = FindDiscriminator(type);
        type.union.forEach((x, i)=>{
            var _a;
            const dp = GetTypeProps(x).find((p)=>p.name === (disc === null || disc === void 0 ? void 0 : disc.prop));
            const name = dp ? IsStringLiteral(dp.type) ? dp.type.string : undefined : undefined;
            VisitType(x, visitor, visitedSet, [
                ...path,
                (_a = name !== null && name !== void 0 ? name : GetTypeAlias(x)) !== null && _a !== void 0 ? _a : i.toString()
            ]);
        });
    } else if (IsIntersectionType(type)) type.intersection.forEach((x, i)=>VisitType(x, visitor, visitedSet, [
            ...path,
            GetTypeAlias(x) || i.toString()
        ]));
}
function ContainsType(type, predicate) {
    let res = false;
    VisitType(type, (x)=>{
        if (predicate(x)) res = true;
    });
    return res;
}
function ReplaceTypes(t, replacer, visitedSet = new Map(), /**
 * Whether to continue recursing after a successful replacement.
 *
 * This can cause infinite recursion if the replacer function in some cases.
 * Defaults to true, can be turned off if problematic.
 */ recurseAfterReplace = true) {
    const visited = visitedSet.get(t);
    if (visited) return visited;
    const type = replacer(t);
    visitedSet.set(t, type);
    if (type !== t && !recurseAfterReplace) return type;
    if (typeof type === "object") {
        const args = type.typeArgs;
        if (args) for(let i = 0; i < args.length; i++)args[i] = ReplaceTypes(args[i], replacer, visitedSet, recurseAfterReplace);
    }
    if (IsObjectType(type)) {
        type.props.forEach((x, i)=>type.props[i].type = ReplaceTypes(x.type, replacer, visitedSet, recurseAfterReplace));
        if (type.additionalProps) type.additionalProps = ReplaceTypes(type.additionalProps, replacer, visitedSet, recurseAfterReplace);
    } else if (IsArrayType(type)) type.array = ReplaceTypes(type.array, replacer, visitedSet, recurseAfterReplace);
    else if (IsUnionType(type)) type.union.forEach((x, i)=>type.union[i] = ReplaceTypes(x, replacer, visitedSet, recurseAfterReplace));
    else if (IsIntersectionType(type)) type.intersection.forEach((x, i)=>type.intersection[i] = ReplaceTypes(x, replacer, visitedSet, recurseAfterReplace));
    return type;
}
function ReplaceValuesByType(value, type, /** Returns the new value to replace the existing one with.
 *  Return the incoming `value` to leave it unchanged.
 */ replacer, visitedObjects = new Set(), path = []) {
    const dt = (0, $cwhCA.SubstituteAndDiscriminate)(value, type);
    if (dt !== type) return ReplaceValuesByType(value, dt, replacer, visitedObjects, path);
    value = replacer(value, type, path);
    if ((IsObjectType(type) || IsIntersectionType(type)) && typeof value === "object") {
        if (visitedObjects.has(value)) return value;
        visitedObjects.add(value);
        const props = GetTypeProps(type);
        props.forEach((x)=>{
            if (x.name in value) value[x.name] = ReplaceValuesByType(value[x.name], x.type, replacer, visitedObjects, [
                ...path,
                x.name
            ]);
        });
        if (IsObjectType(type)) {
            const { additionalProps } = type;
            if (additionalProps) Object.keys(value).forEach((key)=>{
                if (!type.props.some((x)=>x.name === key)) value[key] = ReplaceValuesByType(value[key], additionalProps, replacer, visitedObjects, [
                    ...path,
                    key
                ]);
            });
        }
    } else if (IsArrayType(type) && value instanceof Array) {
        if (visitedObjects.has(value)) return value;
        visitedObjects.add(value);
        value.forEach((x, i)=>value[i] = ReplaceValuesByType(x, type.array, replacer, visitedObjects, [
                ...path,
                i
            ]));
    }
    return value;
}
function VisitPropertiesByType(value, type, /** Returns the new value to replace the existing one with.
 *  Return the incoming `value` to leave it unchanged.
 */ visitor, path = [], /** The property currently being visited. If unspecified, this root node will not be visited,
 * only its subtree. */ property, visitedObjects = new Set()) {
    property !== null && property !== void 0 ? property : property = {
        name: "$root",
        type: type
    };
    if (IsUnionType(type)) {
        const dt = Discriminate(value, type);
        if (dt !== type) {
            VisitPropertiesByType(value, dt, visitor, path, property, visitedObjects);
            return;
        }
    }
    if (property) visitor(value, property, path);
    // This allows visiting the subtree of WebPage sections
    type = (0, $cwhCA.SubstituteAndDiscriminate)(value, type);
    if ((IsObjectType(type) || IsIntersectionType(type)) && typeof value === "object") {
        if (visitedObjects.has(value)) return;
        visitedObjects.add(value);
        GetTypeProps(type).forEach((p)=>{
            if (p.name in value) VisitPropertiesByType(value[p.name], p.type, visitor, [
                ...path,
                p.name
            ], p, visitedObjects);
        });
        if (IsObjectType(type)) {
            const { additionalProps } = type;
            if (additionalProps) Object.keys(value).forEach((key)=>{
                if (!type.props.some((x)=>x.name === key)) VisitPropertiesByType(value[key], additionalProps, visitor, [
                    ...path,
                    key
                ], {
                    name: key,
                    type: additionalProps
                }, visitedObjects);
            });
        }
    } else if (IsArrayType(type) && value instanceof Array) {
        if (visitedObjects.has(value)) return;
        visitedObjects.add(value);
        value.forEach((x, i)=>VisitPropertiesByType(x, type.array, visitor, [
                ...path,
                i.toString()
            ], {
                name: i.toString(),
                type: type.array
            }, visitedObjects));
    }
    return;
}

});
parcelRegister("3oicm", function(module, exports) {

$parcel$export(module.exports, "DeserializeGraph", function () { return $2781bacb23374681$export$562fe2de8f878a14; });
$parcel$export(module.exports, "CloneGraph", function () { return $2781bacb23374681$export$53e4bbf0b9578766; });
const $2781bacb23374681$var$handlePrefix = "\xa9#";
function $2781bacb23374681$var$isHandle(s) {
    return typeof s === "string" && s.startsWith($2781bacb23374681$var$handlePrefix);
}
function $2781bacb23374681$export$6ad0bf001fa83026(root) {
    const refCount = new Map();
    function countRefs(obj) {
        if (obj === undefined) return;
        if (obj === null) return;
        if (typeof obj === "object") {
            const o = obj;
            const ref = refCount.get(o);
            if (ref === undefined) {
                refCount.set(o, 1);
                if (obj instanceof Array) obj.forEach(countRefs);
                else Object.keys(obj).forEach((key)=>countRefs(obj[key]));
            } else refCount.set(o, ref + 1);
        }
        // Internalize long strings
        if (typeof obj === "string" && obj.length > 7) {
            const ref = refCount.get(obj);
            if (ref === undefined) refCount.set(obj, 1);
            else refCount.set(obj, ref + 1);
        }
    }
    countRefs(root);
    const nodes = Array.from(refCount).filter((x, i)=>i === 0 || x[1] > 1).map((x)=>x[0]);
    const ids = new Map();
    nodes.forEach((x, i)=>ids.set(x, i));
    function encode(key, value) {
        if (this === nodes) return value;
        const id = ids.get(value);
        if (id !== undefined) return $2781bacb23374681$var$handlePrefix + id;
        return value;
    }
    return JSON.stringify(nodes, encode);
}
function $2781bacb23374681$export$562fe2de8f878a14(graph) {
    const nodes = JSON.parse(graph.toString());
    function revive(obj) {
        if ($2781bacb23374681$var$isHandle(obj)) {
            const index = parseInt(obj.substr($2781bacb23374681$var$handlePrefix.length));
            return nodes[index];
        }
        if (obj instanceof Array) for(let i = 0; i < obj.length; i++)obj[i] = revive(obj[i]);
        else if (obj instanceof Object) for (const key of Object.keys(obj))obj[key] = revive(obj[key]);
        return obj;
    }
    nodes.forEach(revive);
    return nodes[0];
}
function $2781bacb23374681$export$53e4bbf0b9578766(graph) {
    if (typeof graph !== "object") return graph;
    return $2781bacb23374681$export$562fe2de8f878a14($2781bacb23374681$export$6ad0bf001fa83026(graph));
}

});

parcelRegister("g0jSz", function(module, exports) {

$parcel$export(module.exports, "MatchesTypeJIT", function () { return MatchesTypeJIT; });

var $43jhg = parcelRequire("43jhg");
const cache = new WeakMap();
const noValidateCache = new WeakMap();
function MatchesTypeJIT(type, value, validate = true) {
    if (validate) {
        let jit = cache.get(type);
        if (!jit) {
            jit = JIT(type, true);
            cache.set(type, jit);
        }
        return jit(value);
    } else {
        let jit = noValidateCache.get(type);
        if (!jit) {
            jit = JIT(type, false);
            noValidateCache.set(type, jit);
        }
        return jit(value);
    }
}
function JIT(type, validate) {
    const args = [];
    const argNames = [];
    function registerArg(value, argName) {
        args.push(value);
        argNames.push(argName);
        return argName;
    }
    let varCount = 0;
    function variable() {
        varCount++;
        return "v" + varCount;
    }
    const inlineFuncs = new Map();
    function exp(t, p, ignoreValidator = false, ignoreAlias = false) {
        const alias = (0, $43jhg.GetTypeAlias)(t);
        if (!ignoreAlias && alias) {
            if (!inlineFuncs.has(alias)) {
                inlineFuncs.set(alias, "(temp)"); // prevent infinite recursion
                inlineFuncs.set(alias, `function ${alias}(v) { return ${exp(t, "v", ignoreValidator, true)} }`);
            }
            return `${alias}(${p})`;
        }
        if (validate && !ignoreValidator && typeof t === "object" && "validator" in t) {
            const arg = registerArg((0, $43jhg.GetTypeValidator)(t), t.alias + "_validator");
            return `( ${exp(t, p, true, ignoreAlias)} && try_validate(${p},${arg}))`;
        }
        if ((0, $43jhg.IsFileType)(t)) // Check that the value is a valid UUID file handle
        return `((typeof ${p}) === 'string' && /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/i.test(${p}))`;
        if ((0, $43jhg.IsStringType)(t)) {
            if (t === "string" || t.string === null) return `((typeof ${p}) === 'string')`;
            else return `(${p} === ${JSON.stringify(t.string)})`;
        }
        if ((0, $43jhg.IsBooleanType)(t)) {
            if (t === "boolean" || t.boolean === null) return `((typeof ${p}) === 'boolean')`;
            else return `(${p} === ${JSON.stringify(t.boolean)})`;
        }
        if ((0, $43jhg.IsNumberType)(t)) {
            if (t === "number") return `((typeof ${p}) === 'number')`;
            const isInteger = `((${p}|0) === ${p})`;
            if (t === "integer") return `((typeof ${p}) === 'number' && ${isInteger})`;
            let ee = t.number === null ? `((typeof ${p}) === 'number')` : `(${p} === ${JSON.stringify(t.number)})`;
            if (t.minValue !== undefined) ee = `( ${ee} && ${p} >= ${t.minValue})`;
            if (t.maxValue !== undefined) ee = `( ${ee} && ${p} <= ${t.maxValue})`;
            if (t.integer) ee = `( ${ee} && ${isInteger} )`;
            return ee;
        }
        if ((0, $43jhg.IsIntersectionType)(t)) return "(" + t.intersection.map((x)=>exp(x, p)).reduce(and) + ")";
        if ((0, $43jhg.IsUnionType)(t)) return t.union.length ? `(${t.union.map((x)=>exp(x, p)).reduce(or)})` : // the type must match at least one of the union types.
        `false`;
        if ((0, $43jhg.IsObjectType)(t)) {
            const props = t.props.map((prop)=>prop.optional ? `((${p + `[${JSON.stringify(prop.name)}]`} === undefined) || ${exp(prop.type, p + `[${JSON.stringify(prop.name)}]`)})` : `('${prop.name}' in ${p} && ${exp(prop.type, p + `[${JSON.stringify(prop.name)}]`)})`);
            return `(${p} !== null && (typeof ${p}) === 'object'${props.length ? " && " + props.reduce(and) : ""})`;
        }
        if ((0, $43jhg.IsUndefinedType)(t)) return `(${p} === undefined)`;
        if ((0, $43jhg.IsNullType)(t)) return `(${p} === null)`;
        if ((0, $43jhg.IsAnyType)(t) || (0, $43jhg.IsUnknownType)(t)) return `true`;
        if ((0, $43jhg.IsArrayType)(t)) {
            const v = variable();
            return `((${p} instanceof Array) && ${p}.every(${v} => ${exp(t.array, v)}))`;
        }
        if ((0, $43jhg.IsVoidType)(t)) return `(${p} === undefined)`;
        throw new Error("Unhandled type in MatchesTypeJIT: " + (0, $43jhg.TypeToString)(t));
    }
    const res = exp(type, "v");
    const e = `(function(${argNames.join(",")})
{
    function try_validate(v, validator) {
        try {
            validator(v)
        }
        catch(e) {
            return false
        }
        return true
    }
    ${Array.from(inlineFuncs.values()).join("\n")}
    return function(v) { return ${res} }
})`;
    // eslint-disable-next-line no-eval
    return eval(e)(...args);
}
function and(a, b) {
    return a + " && " + b;
}
function or(a, b) {
    return a + " || " + b;
}

});

parcelRegister("lHoPV", function(module, exports) {

$parcel$export(module.exports, "TypeValidator", function () { return $fcc0e121744d5810$export$9ced0f77dc6abfd7; });
/** Registers a type validator function.
 *
 *  See `docs/Type validators.md`
 */ function $fcc0e121744d5810$export$9ced0f77dc6abfd7(func) {
    $fcc0e121744d5810$export$9ced0f77dc6abfd7.functions.push(func);
}
$fcc0e121744d5810$export$9ced0f77dc6abfd7.functions = [];

});

parcelRegister("cv7r0", function(module, exports) {

$parcel$export(module.exports, "Visitor", function () { return $919e25a5701e386b$export$9d54d4ec2dd4b364; });

var $43jhg = parcelRequire("43jhg");
class $919e25a5701e386b$export$9d54d4ec2dd4b364 {
    constructor(){
        this.visitedAliases = new Set();
        this.visited = new Set();
    }
    type(t) {
        if (this.visited.has(t)) return;
        this.visited.add(t);
        // For some reason, the above is not enough to prevent all forms of infinite recursion. Also
        // testing for aliases fixes the problems seen so far, but there is probably a better
        // fix(tm) waiting to be found.
        const alias = (0, $43jhg.GetTypeAlias)(t);
        if (alias) {
            if (this.visitedAliases.has(alias)) return;
            this.visitedAliases.add(alias);
        }
        if ((0, $43jhg.IsUnionType)(t)) return this.union(t);
        else if ((0, $43jhg.IsIntersectionType)(t)) return this.intersection(t);
        else if ((0, $43jhg.IsObjectType)(t)) return this.object(t);
        else if ((0, $43jhg.IsArrayType)(t)) return this.array(t);
        else if ((0, $43jhg.IsAtomic)(t)) return this.atomic(t);
        else if ((0, $43jhg.IsUndefinedType)(t)) return this.undefined(t);
        else if ((0, $43jhg.IsNullType)(t)) return this.null(t);
        else if ((0, $43jhg.IsAnyType)(t)) return this.any(t);
        else if ((0, $43jhg.IsVoidType)(t)) return this.void(t);
        else if ((0, $43jhg.IsParameterType)(t)) return this.parameter(t);
        else if ((0, $43jhg.IsNeverType)(t)) return this.never(t);
        else if ((0, $43jhg.IsUnknownType)(t)) return this.unknown(t);
        else if ((0, $43jhg.IsPromiseType)(t)) return this.promise(t);
        else if ((0, $43jhg.IsAsyncGeneratorType)(t)) return this.asyncGenerator(t);
        else if ((0, $43jhg.IsFunctionType)(t)) return this.func(t);
        else if ((0, $43jhg.IsFileType)(t)) return this.file(t);
        else if (t === "symbol") return;
        else throw new Error("Unhandled type in Visitor: " + (0, $43jhg.TypeToString)(t));
    }
    never(t) {}
    unknown(t) {}
    promise(t) {}
    asyncGenerator(t) {}
    func(t) {}
    parameter(t) {}
    void(v) {}
    any(t) {}
    null(n) {}
    undefined(u) {}
    file(f) {}
    union(u) {
        let anyChanged = false;
        const nu = {
            alias: u.alias,
            documentation: u.documentation,
            typeArgs: u.typeArgs,
            union: u.union.map((x, i)=>{
                const nt = this.type(x);
                if (nt) {
                    anyChanged = true;
                    return nt;
                } else return x;
            })
        };
        if (anyChanged) return nu;
    }
    intersection(i) {
        let anyChanged = false;
        const ni = {
            alias: i.alias,
            documentation: i.documentation,
            typeArgs: i.typeArgs,
            intersection: i.intersection.map((x)=>{
                const nt = this.type(x);
                if (nt) {
                    anyChanged = true;
                    return nt;
                } else return x;
            })
        };
        if (anyChanged) return ni;
    }
    object(o) {
        const nap = o.additionalProps && (this.type(o.additionalProps) || o.additionalProps);
        let anyChanged = nap !== o.additionalProps;
        const no = {
            alias: o.alias,
            documentation: o.documentation,
            isClass: o.isClass,
            super: o.super,
            typeArgs: o.typeArgs,
            props: o.props.map((p)=>{
                const np = this.property(p);
                if (np) {
                    anyChanged = true;
                    return np;
                } else return p;
            }),
            additionalProps: nap ? nap : undefined
        };
        if (anyChanged) return no;
    }
    property(p) {
        const type = this.type(p.type);
        if (type) return Object.assign(Object.assign({}, p), {
            type: type
        });
    }
    array(a) {
        const t = this.type(a.array);
        if (t) return Object.assign(Object.assign({}, a), {
            array: t
        });
    }
    atomic(a) {}
}

});

parcelRegister("cwhCA", function(module, exports) {

$parcel$export(module.exports, "SetReflectionInfo", function () { return $91d6246c2fad74b9$export$d9a88c5d97ffbf61; });
$parcel$export(module.exports, "GetReflectionInfo", function () { return $91d6246c2fad74b9$export$72743ac1fea589d5; });
$parcel$export(module.exports, "IsReflectionInfoReady", function () { return $91d6246c2fad74b9$export$fec01e36cfb8ed9b; });
$parcel$export(module.exports, "GetType", function () { return $91d6246c2fad74b9$export$3d7f8909aa61994; });
$parcel$export(module.exports, "SubstituteType", function () { return $91d6246c2fad74b9$export$bd5de6299d95aa3; });
$parcel$export(module.exports, "SubstituteAndDiscriminate", function () { return $91d6246c2fad74b9$export$91d57c864c7c6cf2; });
$parcel$export(module.exports, "GetPrimaryKey", function () { return $91d6246c2fad74b9$export$e976441c51ae56b5; });

var $43jhg = parcelRequire("43jhg");

var $8h5s0 = parcelRequire("8h5s0");
let $91d6246c2fad74b9$var$resolveReflectionInfo;
let $91d6246c2fad74b9$var$info;
function $91d6246c2fad74b9$export$d9a88c5d97ffbf61(ri) {
    $91d6246c2fad74b9$var$info = ri;
    $91d6246c2fad74b9$var$info.types.forEach((type)=>{
        // Don't add reference types to the dictionary
        if (typeof type === "object" && type.reference) return;
        const alias = (0, $43jhg.GetTypeAlias)(type);
        if (alias) $91d6246c2fad74b9$var$aliasToType.set(alias, type);
    });
    $91d6246c2fad74b9$var$resolveReflectionInfo(ri);
}
function $91d6246c2fad74b9$export$72743ac1fea589d5() {
    if ($91d6246c2fad74b9$var$info === undefined) throw new Error("Cannot GetReflectionInfo prior to SetReflectionInfo");
    return $91d6246c2fad74b9$var$info;
}
const $91d6246c2fad74b9$export$cade07fb2f9cd061 = new Promise((resolve)=>$91d6246c2fad74b9$var$resolveReflectionInfo = resolve);
function $91d6246c2fad74b9$export$fec01e36cfb8ed9b() {
    return !!$91d6246c2fad74b9$var$info;
}
const $91d6246c2fad74b9$var$aliasToType = new Map();
function $91d6246c2fad74b9$export$3d7f8909aa61994(locator) {
    var _a, _b;
    if (!$91d6246c2fad74b9$var$info) throw new Error("GetType(): No reflection info available");
    const alias = typeof locator === "string" ? locator : locator[0];
    const path = typeof locator === "string" ? [] : locator.slice(1);
    if (alias === "unknown") return "unknown";
    if (alias === "undefined") return "undefined";
    if (alias === "null") return "null";
    let type = (_b = (_a = $91d6246c2fad74b9$var$aliasToType.get(alias)) !== null && _a !== void 0 ? _a : $91d6246c2fad74b9$var$info.clientTypes.external.find((t)=>(0, $43jhg.GetTypeAlias)(t) === alias)) !== null && _b !== void 0 ? _b : $91d6246c2fad74b9$var$info.clientTypes.internal.find((t)=>(0, $43jhg.GetTypeAlias)(t) === alias);
    if (!type) throw new Error("GetType(): Type not found: " + alias);
    if (!path.length) return type;
    for (const part of path){
        if (typeof part === "string") {
            const props = (0, $43jhg.GetTypeProps)(type);
            const prop = props.find((p)=>p.name === part);
            if (!prop) throw new Error("GetType(): Property not found: " + part);
            type = prop.type;
        } else if (typeof part === "number") {
            if (!(0, $43jhg.IsArrayType)(type)) throw new Error("GetType(): Property is not an array: " + part);
            type = type.array;
        }
    }
    return type;
}
const $91d6246c2fad74b9$var$substituteTypesCache = new Map();
function $91d6246c2fad74b9$export$e73170052c4666d4(type) {
    if (!$91d6246c2fad74b9$var$substituteTypesCache.has(type)) $91d6246c2fad74b9$var$substituteTypesCache.set(type, $91d6246c2fad74b9$var$GetSubstituteTypesUncached(type));
    return (0, $8h5s0.Assert)($91d6246c2fad74b9$var$substituteTypesCache.get(type));
}
function $91d6246c2fad74b9$var$GetSubstituteTypesUncached(type) {
    const alias = (0, $43jhg.GetTypeAlias)(type);
    return alias ? $91d6246c2fad74b9$export$72743ac1fea589d5().types.filter((t)=>{
        var _a;
        return typeof t === "object" && ((_a = t.tags) === null || _a === void 0 ? void 0 : _a.substitute) === alias;
    }) : [];
}
const $91d6246c2fad74b9$var$sectionsCache = new Map();
function $91d6246c2fad74b9$export$bd5de6299d95aa3(value, type) {
    var _a;
    if (value === undefined) return type;
    let types = $91d6246c2fad74b9$export$e73170052c4666d4(type);
    if (types.length === 1) return types[0];
    // Special case for section types
    if ((0, $43jhg.GetTypeAlias)(type) === "Section") {
        if ("type" in value) {
            if (!$91d6246c2fad74b9$var$sectionsCache.size) $91d6246c2fad74b9$export$72743ac1fea589d5().sections.forEach((s)=>$91d6246c2fad74b9$var$sectionsCache.set(s.name, s.type));
            const section = $91d6246c2fad74b9$var$sectionsCache.get(value.type);
            if (section) return section;
        }
        types = [
            ...types,
            ...$91d6246c2fad74b9$export$72743ac1fea589d5().sections.map((s)=>s.type)
        ];
    }
    // Special case for section types
    if ((0, $43jhg.GetTypeAlias)(type) === "EmailSection") {
        if ("type" in value) {
            if (!$91d6246c2fad74b9$var$sectionsCache.size) $91d6246c2fad74b9$export$72743ac1fea589d5().emailSections.forEach((s)=>$91d6246c2fad74b9$var$sectionsCache.set(s.name, s.type));
            const section = $91d6246c2fad74b9$var$sectionsCache.get(value.type);
            if (section) return section;
        }
        types = [
            ...types,
            ...$91d6246c2fad74b9$export$72743ac1fea589d5().sections.map((s)=>s.type)
        ];
    }
    return (_a = types.find((t)=>(0, $43jhg.MatchesTypeTurbo)(value, t, false))) !== null && _a !== void 0 ? _a : type;
}
function $91d6246c2fad74b9$export$91d57c864c7c6cf2(value, type) {
    type = $91d6246c2fad74b9$export$bd5de6299d95aa3(value, type);
    return (0, $43jhg.IsUnionType)(type) ? (0, $43jhg.Discriminate)(value, type) : type;
}
function $91d6246c2fad74b9$export$e976441c51ae56b5(type) {
    var _a;
    const props = (0, $43jhg.GetTypeProps)(type);
    return (_a = props.find((p)=>{
        var _a;
        return ((_a = p.tags) === null || _a === void 0 ? void 0 : _a.primary) && p.isReadonly;
    })) !== null && _a !== void 0 ? _a : props.find((p)=>p.name === "id" && p.isReadonly);
}

});



parcelRegister("l079f", function(module, exports) {

$parcel$export(module.exports, "UntitledUI", function () { return $f49f248341bf3308$export$3069487f41ab5fbf; });

var $hcjDr = parcelRequire("hcjDr");
var $f49f248341bf3308$export$3069487f41ab5fbf;
(function(UntitledUI) {
    /** Along with primary colors, it's helpful to have a selection of secondary colors to use in components such as pills, alerts and labels. These secondary colors should be used sparingly or as accents, while the primary color(s) should take precendence. */ UntitledUI.secondaryColors = [
        "gray-blue",
        "gray-cool",
        "gray-modern",
        "gray-neutral",
        "gray-iron",
        "gray-true",
        "gray-warm",
        "moss",
        "green-light",
        "green",
        "teal",
        "cyan",
        "blue-light",
        "blue",
        "blue-dark",
        "indigo",
        "violet",
        "purple",
        "fuchsia",
        "pink",
        "ros\xe9",
        "orange-dark",
        "orange",
        "yellow"
    ];
    /** A selection from the secondary colors that gives a balanced mix of colors when randomized.
     * */ UntitledUI.secondaryColorBalanced = [
        "gray-neutral",
        "moss",
        "green-light",
        "green",
        "teal",
        "cyan",
        "blue-light",
        "blue",
        "blue-dark",
        "indigo",
        "violet",
        "purple",
        "fuchsia",
        "pink",
        "ros\xe9",
        "orange-dark",
        "orange",
        "yellow"
    ];
    UntitledUI.secondaryColorsDistinct = [
        "ros\xe9",
        "gray-neutral",
        "moss",
        "orange",
        "cyan",
        "yellow",
        "orange",
        "orange-dark",
        "purple",
        "fuchsia",
        "pink",
        "blue",
        "indigo",
        "yellow",
        "green",
        "violet",
        "teal"
    ];
    function randomSecondaryColorNameDistinct(seed) {
        if (typeof seed === "string") {
            const rnd = new (0, $hcjDr.default)(seed);
            seed = rnd.nextInt();
        }
        return UntitledUI.secondaryColorsDistinct[seed % UntitledUI.secondaryColorsDistinct.length];
    }
    UntitledUI.randomSecondaryColorNameDistinct = randomSecondaryColorNameDistinct;
    function randomSecondaryColorName(seed) {
        const rnd = new (0, $hcjDr.default)(seed);
        return UntitledUI.secondaryColorBalanced[rnd.nextInt(0, UntitledUI.secondaryColorBalanced.length - 1)];
    }
    UntitledUI.randomSecondaryColorName = randomSecondaryColorName;
    function randomSecondaryColor(seed) {
        return UntitledUI.colorStyles[randomSecondaryColorName(seed)];
    }
    UntitledUI.randomSecondaryColor = randomSecondaryColor;
    function isColorStyle(s) {
        return s in UntitledUI.colorStyles;
    }
    UntitledUI.isColorStyle = isColorStyle;
    UntitledUI.colorStyles = {
        gray: {
            25: "#FCFCFD",
            50: "#F9FAFB",
            100: "#F2F4F7",
            200: "#EAECF0",
            300: "#D0D5DD",
            400: "#98A2B3",
            500: "#667085",
            600: "#475467",
            700: "#344054",
            800: "#1D2939",
            900: "#101828"
        },
        primary: {
            25: "#FCFAFF",
            50: "#F9F5FF",
            100: "#F4EBFF",
            200: "#E9D7FE",
            300: "#D6BBFB",
            400: "#B692F6",
            500: "#9E77ED",
            600: "#7F56D9",
            700: "#6941C6",
            800: "#53389E",
            900: "#42307D"
        },
        error: {
            25: "#FFFBFA",
            50: "#FEF3F2",
            100: "#FEE4E2",
            200: "#FECDCA",
            300: "#FDA29B",
            400: "#F97066",
            500: "#F04438",
            600: "#D92D20",
            700: "#B42318",
            800: "#912018",
            900: "#7A271A"
        },
        warning: {
            25: "#FFFCF5",
            50: "#FFFAEB",
            100: "#FEF0C7",
            200: "#FEDF89",
            300: "#FEC84B",
            400: "#FDB022",
            500: "#F79009",
            600: "#DC6803",
            700: "#B54708",
            800: "#93370D",
            900: "#7A2E0E"
        },
        success: {
            25: "#F6FEF9",
            50: "#ECFDF3",
            100: "#D1FADF",
            200: "#A6F4C5",
            300: "#6CE9A6",
            400: "#32D583",
            500: "#12B76A",
            600: "#039855",
            700: "#027A48",
            800: "#05603A",
            900: "#054F31"
        },
        "gray-blue": {
            25: "#FCFCFD",
            50: "#F8F9FC",
            100: "#EAECF5",
            200: "#D5D9EB",
            300: "#B3B8DB",
            400: "#717BBC",
            500: "#4E5BA6",
            600: "#3E4784",
            700: "#363F72",
            800: "#293056",
            900: "#101323"
        },
        "gray-cool": {
            25: "#FCFCFD",
            50: "#F9F9FB",
            100: "#EFF1F5",
            200: "#DCDFEA",
            300: "#B9C0D4",
            400: "#7D89B0",
            500: "#5D6B98",
            600: "#4A5578",
            700: "#404968",
            800: "#30374F",
            900: "#111322"
        },
        "gray-modern": {
            25: "#FCFCFD",
            50: "#F8FAFC",
            100: "#EEF2F6",
            200: "#E3E8EF",
            300: "#CDD5DF",
            400: "#9AA4B2",
            500: "#697586",
            600: "#4B5565",
            700: "#364152",
            800: "#202939",
            900: "#121926"
        },
        "gray-neutral": {
            25: "#FCFCFD",
            50: "#F9FAFB",
            100: "#F3F4F6",
            200: "#E5E7EB",
            300: "#D2D6DB",
            400: "#9DA4AE",
            500: "#6C737F",
            600: "#4D5761",
            700: "#384250",
            800: "#1F2A37",
            900: "#111927"
        },
        "gray-iron": {
            25: "#FCFCFC",
            50: "#FAFAFA",
            100: "#F4F4F5",
            200: "#E4E4E7",
            300: "#D1D1D6",
            400: "#A0A0AB",
            500: "#70707B",
            600: "#51525C",
            700: "#3F3F46",
            800: "#26272B",
            900: "#18181B"
        },
        "gray-true": {
            25: "#FCFCFC",
            50: "#FAFAFA",
            100: "#F5F5F5",
            200: "#E5E5E5",
            300: "#D6D6D6",
            400: "#A3A3A3",
            500: "#737373",
            600: "#525252",
            700: "#424242",
            800: "#292929",
            900: "#141414"
        },
        "gray-warm": {
            25: "#FDFDFC",
            50: "#FAFAF9",
            100: "#F5F5F4",
            200: "#E7E5E4",
            300: "#D7D3D0",
            400: "#A9A29D",
            500: "#79716B",
            600: "#57534E",
            700: "#44403C",
            800: "#292524",
            900: "#1C1917"
        },
        moss: {
            25: "#FAFDF7",
            50: "#F5FBEE",
            100: "#E6F4D7",
            200: "#CEEAB0",
            300: "#ACDC79",
            400: "#86CB3C",
            500: "#669F2A",
            600: "#4F7A21",
            700: "#3F621A",
            800: "#335015",
            900: "#2B4212"
        },
        "green-light": {
            25: "#FAFEF5",
            50: "#F3FEE7",
            100: "#E3FBCC",
            200: "#D0F8AB",
            300: "#A6EF67",
            400: "#85E13A",
            500: "#66C61C",
            600: "#4CA30D",
            700: "#3B7C0F",
            800: "#326212",
            900: "#2B5314"
        },
        green: {
            25: "#F6FEF9",
            50: "#EDFCF2",
            100: "#D3F8DF",
            200: "#AAF0C4",
            300: "#73E2A3",
            400: "#3CCB7F",
            500: "#16B364",
            600: "#099250",
            700: "#087443",
            800: "#095C37",
            900: "#084C2E"
        },
        teal: {
            25: "#F6FEFC",
            50: "#F0FDF9",
            100: "#CCFBEF",
            200: "#99F6E0",
            300: "#5FE9D0",
            400: "#2ED3B7",
            500: "#15B79E",
            600: "#0E9384",
            700: "#107569",
            800: "#125D56",
            900: "#134E48"
        },
        cyan: {
            25: "#F5FEFF",
            50: "#ECFDFF",
            100: "#CFF9FE",
            200: "#A5F0FC",
            300: "#67E3F9",
            400: "#22CCEE",
            500: "#06AED4",
            600: "#088AB2",
            700: "#0E7090",
            800: "#155B75",
            900: "#164C63"
        },
        "blue-light": {
            25: "#F5FBFF",
            50: "#F0F9FF",
            100: "#E0F2FE",
            200: "#B9E6FE",
            300: "#7CD4FD",
            400: "#36BFFA",
            500: "#0BA5EC",
            600: "#0086C9",
            700: "#026AA2",
            800: "#065986",
            900: "#0B4A6F"
        },
        blue: {
            25: "#F5FAFF",
            50: "#EFF8FF",
            100: "#D1E9FF",
            200: "#B2DDFF",
            300: "#84CAFF",
            400: "#53B1FD",
            500: "#2E90FA",
            600: "#1570EF",
            700: "#175CD3",
            800: "#1849A9",
            900: "#194185"
        },
        "blue-dark": {
            25: "#F5F8FF",
            50: "#EFF4FF",
            100: "#D1E0FF",
            200: "#B2CCFF",
            300: "#84ADFF",
            400: "#528BFF",
            500: "#2970FF",
            600: "#155EEF",
            700: "#004EEB",
            800: "#0040C1",
            900: "#00359E"
        },
        indigo: {
            25: "#F5F8FF",
            50: "#EEF4FF",
            100: "#E0EAFF",
            200: "#C7D7FE",
            300: "#A4BCFD",
            400: "#8098F9",
            500: "#6172F3",
            600: "#444CE7",
            700: "#3538CD",
            800: "#2D31A6",
            900: "#2D3282"
        },
        violet: {
            25: "#FBFAFF",
            50: "#F5F3FF",
            100: "#ECE9FE",
            200: "#DDD6FE",
            300: "#C3B5FD",
            400: "#A48AFB",
            500: "#875BF7",
            600: "#7839EE",
            700: "#6927DA",
            800: "#5720B7",
            900: "#491C96"
        },
        purple: {
            25: "#FAFAFF",
            50: "#F4F3FF",
            100: "#EBE9FE",
            200: "#D9D6FE",
            300: "#BDB4FE",
            400: "#9B8AFB",
            500: "#7A5AF8",
            600: "#6938EF",
            700: "#5925DC",
            800: "#4A1FB8",
            900: "#3E1C96"
        },
        fuchsia: {
            25: "#FEFAFF",
            50: "#FDF4FF",
            100: "#FBE8FF",
            200: "#F6D0FE",
            300: "#EEAAFD",
            400: "#E478FA",
            500: "#D444F1",
            600: "#BA24D5",
            700: "#9F1AB1",
            800: "#821890",
            900: "#6F1877"
        },
        pink: {
            25: "#FEF6FB",
            50: "#FDF2FA",
            100: "#FCE7F6",
            200: "#FCCEEE",
            300: "#FAA7E0",
            400: "#F670C7",
            500: "#EE46BC",
            600: "#DD2590",
            700: "#C11574",
            800: "#9E165F",
            900: "#851651"
        },
        "ros\xe9": {
            25: "#FFF5F6",
            50: "#FFF1F3",
            100: "#FFE4E8",
            200: "#FECDD6",
            300: "#FEA3B4",
            400: "#FD6F8E",
            500: "#F63D68",
            600: "#E31B54",
            700: "#C01048",
            800: "#A11043",
            900: "#89123E"
        },
        "orange-dark": {
            25: "#FFF9F5",
            50: "#FFF4ED",
            100: "#FFE6D5",
            200: "#FFD6AE",
            300: "#FF9C66",
            400: "#FF692E",
            500: "#FF4405",
            600: "#E62E05",
            700: "#BC1B06",
            800: "#97180C",
            900: "#771A0D"
        },
        orange: {
            25: "#FEFAF5",
            50: "#FEF6EE",
            100: "#FDEAD7",
            200: "#F9DBAF",
            300: "#F7B27A",
            400: "#F38744",
            500: "#EF6820",
            600: "#E04F16",
            700: "#B93815",
            800: "#932F19",
            900: "#772917"
        },
        yellow: {
            25: "#FEFDF0",
            50: "#FEFBE8",
            100: "#FEF7C3",
            200: "#FEEE95",
            300: "#FDE272",
            400: "#FAC515",
            500: "#EAAA08",
            600: "#CA8504",
            700: "#A15C07",
            800: "#854A0E",
            900: "#713B12"
        }
    };
})($f49f248341bf3308$export$3069487f41ab5fbf || ($f49f248341bf3308$export$3069487f41ab5fbf = {}));

});

parcelRegister("4rY0U", function(module, exports) {

$parcel$export(module.exports, "WidgetView", function () { return $33d83c7f9591d66d$export$ae6a4a1be5e9cbfc; });
$parcel$export(module.exports, "RegisterWidget", function () { return $33d83c7f9591d66d$export$4848b266ceb89698; });

var $4vwom = parcelRequire("4vwom");
parcelRequire("eeH7J");

var $9Q5xE = parcelRequire("9Q5xE");

var $bUDfc = parcelRequire("bUDfc");
const $33d83c7f9591d66d$var$widgets = [];
function $33d83c7f9591d66d$export$ae6a4a1be5e9cbfc(props) {
    if (props.value === undefined) return (0, $4vwom.jsx)((0, $4vwom.Fragment), {});
    // Modals are not rendered in the normal widget tree, so we don't want to
    // display them here.
    if (props.value && (0, $bUDfc.IsModal)(props.value)) return (0, $4vwom.jsx)((0, $4vwom.Fragment), {});
    for (const widget of $33d83c7f9591d66d$var$widgets){
        if (typeof widget.typeOrPredicate === "string") {
            if (props.value === null) continue;
            if (props.value instanceof Array) continue;
            if (typeof props.value !== "object") continue;
            if (!("type" in props.value)) continue;
            if (props.value.type !== widget.typeOrPredicate) continue;
        } else {
            if (!widget.typeOrPredicate(props)) continue;
        }
        return (0, $4vwom.jsx)(widget.func, Object.assign({}, props));
    }
    try {
        return (0, $4vwom.jsx)("div", {
            style: {
                color: "orangered"
            },
            children: JSON.stringify(props)
        });
    } catch (_a) {
        return (0, $4vwom.jsx)("div", {
            style: {
                color: "orangered"
            },
            children: "(There was a problem displaying this widget)"
        });
    }
}
function $33d83c7f9591d66d$export$4848b266ceb89698(typeOrPredicate, widget) {
    if (typeof typeOrPredicate !== "function" && typeof typeOrPredicate !== "string") throw new Error("Widget typeOrPredicate is not a function");
    $33d83c7f9591d66d$var$widgets.push({
        typeOrPredicate: typeOrPredicate,
        func: widget
    });
}
$33d83c7f9591d66d$export$4848b266ceb89698(({ value: value })=>typeof value === "string", ({ value: value, tableCell: tableCell })=>{
    if (tableCell) return (0, $4vwom.jsx)("div", {
        style: {
            fontSize: 14,
            color: (0, $9Q5xE.ColorStyles).gray[500],
            overflowWrap: "anywhere"
        },
        children: value
    });
    else return (0, $4vwom.jsx)("div", {
        style: {
            marginLeft: 16,
            marginRight: 16
        },
        children: value
    });
});
$33d83c7f9591d66d$export$4848b266ceb89698(({ value: value })=>typeof value === "number", ({ value: value, tableCell: tableCell })=>{
    if (tableCell) return (0, $4vwom.jsx)("div", {
        style: {
            fontSize: 14,
            color: (0, $9Q5xE.ColorStyles).gray[500]
        },
        children: value
    });
    else return (0, $4vwom.jsx)("div", {
        style: {
            marginLeft: 16,
            marginRight: 16
        },
        children: value.toString()
    });
});
$33d83c7f9591d66d$export$4848b266ceb89698(({ value: value })=>value === null, ()=>{
    return (0, $4vwom.jsx)("code", {
        children: "null"
    });
});
$33d83c7f9591d66d$export$4848b266ceb89698(({ value: value })=>value === undefined, ()=>{
    return (0, $4vwom.jsx)("code", {
        children: "undefined"
    });
});

});
parcelRegister("9Q5xE", function(module, exports) {

$parcel$export(module.exports, "ColorStyles", function () { return $729d44d6c5bbc062$export$bb593cab2c3c47ba; });
$parcel$export(module.exports, "OverlayShadow", function () { return $729d44d6c5bbc062$export$9314c39552ab0f3e; });

var $l079f = parcelRequire("l079f");
const $729d44d6c5bbc062$export$bb593cab2c3c47ba = (0, $l079f.UntitledUI).colorStyles;
const $729d44d6c5bbc062$export$9314c39552ab0f3e = "2px 2px 10px #bbb";

});

parcelRegister("bUDfc", function(module, exports) {

$parcel$export(module.exports, "IsTableRow", function () { return $8ac35dc18aa11ea5$export$8f761ebef3f2c9fc; });
$parcel$export(module.exports, "IsTable", function () { return $8ac35dc18aa11ea5$export$dbad54f406b7fd2a; });
$parcel$export(module.exports, "IsItem", function () { return $8ac35dc18aa11ea5$export$3904c07b31859f10; });
$parcel$export(module.exports, "IsButton", function () { return $8ac35dc18aa11ea5$export$26d3ab61f34a55fe; });
$parcel$export(module.exports, "IsModal", function () { return $8ac35dc18aa11ea5$export$ce54036c659cba49; });
$parcel$export(module.exports, "IsWidgetBase", function () { return $8ac35dc18aa11ea5$export$6613534c3ddf540a; });
function $8ac35dc18aa11ea5$export$8f761ebef3f2c9fc(w) {
    return w !== null && !(w instanceof Array) && typeof w === "object" && !("type" in w);
}
function $8ac35dc18aa11ea5$export$dbad54f406b7fd2a(w) {
    return w !== null && typeof w === "object" && "type" in w && w.type === "Table";
}
function $8ac35dc18aa11ea5$export$3904c07b31859f10(w) {
    return !!(w && typeof w === "object" && "type" in w && w.type === "Item");
}
function $8ac35dc18aa11ea5$export$26d3ab61f34a55fe(widget) {
    return !!(widget && typeof widget === "object" && "type" in widget && widget.type === "Button");
}
function $8ac35dc18aa11ea5$export$ce54036c659cba49(widget) {
    return !!(widget && typeof widget === "object" && "type" in widget && widget.type === "Modal");
}
function $8ac35dc18aa11ea5$export$6613534c3ddf540a(widget) {
    return widget && typeof widget === "object";
}

});


parcelRegister("6sp4J", function(module, exports) {

$parcel$export(module.exports, "Icon", function () { return $4b38cf077d3cd72a$export$f04a61298a47a40f; });

var $4vwom = parcelRequire("4vwom");

var $eeH7J = parcelRequire("eeH7J");

var $7m9cQ = parcelRequire("7m9cQ");
function $4b38cf077d3cd72a$export$f04a61298a47a40f({ icon: icon, width: width, height: height, color: color, size: size, style: style }) {
    width !== null && width !== void 0 ? width : width = size;
    height !== null && height !== void 0 ? height : height = size;
    if (icon.startsWith("ui-")) {
        const iconUrl = `${(0, $7m9cQ.server)()}/ui-icons/${icon.slice(3)}${color ? `?stroke=${encodeURIComponent(color)}` : ""}`;
        // Untitled UI icons
        return (0, $4vwom.jsx)($4b38cf077d3cd72a$var$Svg, {
            url: iconUrl,
            width: width,
            height: height,
            color: color,
            style: style
        });
    }
    return (0, $4vwom.jsx)("i", {
        className: "fas fa-" + icon,
        style: Object.assign({
            width: width,
            height: height,
            color: color
        }, style)
    });
}
const $4b38cf077d3cd72a$var$iconCache = new Map();
function $4b38cf077d3cd72a$var$Svg({ url: url, width: width, height: height, style: style, color: color }) {
    const [data, setData] = (0, $eeH7J.useState)($4b38cf077d3cd72a$var$iconCache.get(url));
    (0, $eeH7J.useEffect)(()=>{
        if (!$4b38cf077d3cd72a$var$iconCache.has(url)) {
            const listeners = [];
            $4b38cf077d3cd72a$var$iconCache.set(url, listeners);
            listeners.push(setData);
            fetch(url).then((res)=>res.text()).then((d)=>{
                $4b38cf077d3cd72a$var$iconCache.set(url, d);
                listeners.forEach((listener)=>listener(d));
            });
        }
        const cacheEntry = $4b38cf077d3cd72a$var$iconCache.get(url);
        if (cacheEntry instanceof Array) {
            if (!cacheEntry.includes(setData)) cacheEntry.push(setData);
        } else setData(cacheEntry);
    }, [
        color,
        url,
        style
    ]);
    return typeof data === "string" ? (0, $4vwom.jsx)("svg", {
        viewBox: "0 0 24 24",
        width: width,
        height: height,
        fill: "none",
        dangerouslySetInnerHTML: {
            __html: data
        },
        style: style
    }) : null;
}

});

parcelRegister("2LTO8", function(module, exports) {
$parcel$export(module.exports, "CountryCode", function () { return (parcelRequire("97R5C")).CountryCode; });
$parcel$export(module.exports, "CurrencyCode", function () { return (parcelRequire("2zTLn")).CurrencyCode; });
$parcel$export(module.exports, "Email", function () { return (parcelRequire("2uVAW")).Email; });
$parcel$export(module.exports, "Markdown", function () { return (parcelRequire("gGZ2r")).Markdown; });
$parcel$export(module.exports, "NonNegativeInteger", function () { return (parcelRequire("fR074")).NonNegativeInteger; });
$parcel$export(module.exports, "ParseDateTimePrecision", function () { return (parcelRequire("4vUfp")).ParseDateTimePrecision; });
$parcel$export(module.exports, "PhoneNumber", function () { return (parcelRequire("4QAvl")).PhoneNumber; });
$parcel$export(module.exports, "Timestamp", function () { return (parcelRequire("4vUfp")).Timestamp; });
$parcel$export(module.exports, "Url", function () { return (parcelRequire("iXeBy")).Url; });
$parcel$export(module.exports, "Uuid", function () { return (parcelRequire("dAwef")).Uuid; });
$parcel$export(module.exports, "FileToUrl", function () { return (parcelRequire("14q7s")).FileToUrl; });
$parcel$export(module.exports, "ImageToCSS", function () { return (parcelRequire("14q7s")).ImageToCSS; });
$parcel$export(module.exports, "ImageToUrl", function () { return (parcelRequire("14q7s")).ImageToUrl; });
$parcel$export(module.exports, "Color", function () { return (parcelRequire("hsrrX")).Color; });
$parcel$export(module.exports, "IsNode", function () { return (parcelRequire("lDBHC")).IsNode; });
$parcel$export(module.exports, "Clone", function () { return (parcelRequire("6pFwm")).Clone; });
$parcel$export(module.exports, "CreateDefault", function () { return (parcelRequire("5c9Ym")).CreateDefault; });
$parcel$export(module.exports, "Default", function () { return (parcelRequire("5c9Ym")).Default; });
$parcel$export(module.exports, "UninitializedArrayValue", function () { return (parcelRequire("5c9Ym")).UninitializedArrayValue; });
$parcel$export(module.exports, "UninitializedDefaults", function () { return (parcelRequire("5c9Ym")).UninitializedDefaults; });
$parcel$export(module.exports, "GetPrimaryKey", function () { return (parcelRequire("cwhCA")).GetPrimaryKey; });
$parcel$export(module.exports, "GetReflectionInfo", function () { return (parcelRequire("cwhCA")).GetReflectionInfo; });
$parcel$export(module.exports, "GetType", function () { return (parcelRequire("cwhCA")).GetType; });
$parcel$export(module.exports, "SubstituteAndDiscriminate", function () { return (parcelRequire("cwhCA")).SubstituteAndDiscriminate; });
$parcel$export(module.exports, "DeserializeGraph", function () { return (parcelRequire("3oicm")).DeserializeGraph; });
$parcel$export(module.exports, "Assert", function () { return (parcelRequire("8h5s0")).Assert; });
$parcel$export(module.exports, "ellipsize", function () { return (parcelRequire("8h5s0")).ellipsize; });
$parcel$export(module.exports, "lowercaseFirstLetter", function () { return (parcelRequire("8h5s0")).lowercaseFirstLetter; });
$parcel$export(module.exports, "prettyCamel", function () { return (parcelRequire("8h5s0")).prettyCamel; });
$parcel$export(module.exports, "OrderBy", function () { return (parcelRequire("a1m73")).OrderBy; });
$parcel$export(module.exports, "GetIconForTypedValue", function () { return (parcelRequire("3LK53")).GetIconForTypedValue; });
parcelRequire("dbwyW");
parcelRequire("14q7s");
parcelRequire("hsrrX");
parcelRequire("lDBHC");
parcelRequire("6pFwm");
parcelRequire("hVoVD");

var $43jhg = parcelRequire("43jhg");
parcelRequire("5c9Ym");
parcelRequire("cwhCA");
parcelRequire("3oicm");
parcelRequire("8h5s0");
parcelRequire("4Zgmd");
parcelRequire("c9WcJ");
parcelRequire("a1m73");
parcelRequire("3LK53");
$parcel$exportWildcard(module.exports, $43jhg);

});
parcelRegister("dbwyW", function(module, exports) {
$parcel$export(module.exports, "CurrencyCode", function () { return (parcelRequire("2zTLn")).CurrencyCode; });
$parcel$export(module.exports, "CountryCode", function () { return (parcelRequire("97R5C")).CountryCode; });
$parcel$export(module.exports, "ParseDateTimePrecision", function () { return (parcelRequire("4vUfp")).ParseDateTimePrecision; });
$parcel$export(module.exports, "Timestamp", function () { return (parcelRequire("4vUfp")).Timestamp; });
$parcel$export(module.exports, "Email", function () { return (parcelRequire("2uVAW")).Email; });
$parcel$export(module.exports, "Markdown", function () { return (parcelRequire("gGZ2r")).Markdown; });
$parcel$export(module.exports, "NonNegativeInteger", function () { return (parcelRequire("fR074")).NonNegativeInteger; });
$parcel$export(module.exports, "PhoneNumber", function () { return (parcelRequire("4QAvl")).PhoneNumber; });
$parcel$export(module.exports, "Url", function () { return (parcelRequire("iXeBy")).Url; });
$parcel$export(module.exports, "Uuid", function () { return (parcelRequire("dAwef")).Uuid; });
parcelRequire("2zTLn");
parcelRequire("97R5C");
parcelRequire("4vUfp");
parcelRequire("2uVAW");
parcelRequire("6oG4E");
parcelRequire("gGZ2r");
parcelRequire("fR074");
parcelRequire("iDHvF");
parcelRequire("eHTbG");
parcelRequire("4QAvl");
parcelRequire("gBv4p");
parcelRequire("iXeBy");
parcelRequire("dAwef");

});
parcelRegister("2zTLn", function(module, exports) {

$parcel$export(module.exports, "CurrencyCode", function () { return $1e0a1b0afa9066a3$export$6e3fca9a737174b; });

var $lHoPV = parcelRequire("lHoPV");
function $1e0a1b0afa9066a3$export$6e3fca9a737174b(currency) {
    const currencyCode = currency;
    if ($1e0a1b0afa9066a3$export$a01df35ce0858603.includes(currencyCode)) return currencyCode;
    throw new Error(`${currency} is not a recognized currency code`);
}
const $1e0a1b0afa9066a3$export$a01df35ce0858603 = [
    "AFA",
    "ALL",
    "DZD",
    "AOA",
    "ARS",
    "AMD",
    "AWG",
    "AUD",
    "AZN",
    "BSD",
    "BHD",
    "BDT",
    "BBD",
    "BYR",
    "BEF",
    "BZD",
    "BMD",
    "BTN",
    "BTC",
    "BOB",
    "BAM",
    "BWP",
    "BRL",
    "GBP",
    "BND",
    "BGN",
    "BIF",
    "KHR",
    "CAD",
    "CVE",
    "KYD",
    "XOF",
    "XAF",
    "XPF",
    "CLP",
    "CNY",
    "COP",
    "KMF",
    "CDF",
    "CRC",
    "HRK",
    "CUC",
    "CZK",
    "DKK",
    "DJF",
    "DOP",
    "XCD",
    "EGP",
    "ERN",
    "EEK",
    "ETB",
    "EUR",
    "FKP",
    "FJD",
    "GMD",
    "GEL",
    "DEM",
    "GHS",
    "GIP",
    "GRD",
    "GTQ",
    "GNF",
    "GYD",
    "HTG",
    "HNL",
    "HKD",
    "HUF",
    "ISK",
    "INR",
    "IDR",
    "IRR",
    "IQD",
    "ILS",
    "ITL",
    "JMD",
    "JPY",
    "JOD",
    "KZT",
    "KES",
    "KWD",
    "KGS",
    "LAK",
    "LVL",
    "LBP",
    "LSL",
    "LRD",
    "LYD",
    "LTL",
    "MOP",
    "MKD",
    "MGA",
    "MWK",
    "MYR",
    "MVR",
    "MRO",
    "MUR",
    "MXN",
    "MDL",
    "MNT",
    "MAD",
    "MZM",
    "MMK",
    "NAD",
    "NPR",
    "ANG",
    "TWD",
    "NZD",
    "NIO",
    "NGN",
    "KPW",
    "NOK",
    "OMR",
    "PKR",
    "PAB",
    "PGK",
    "PYG",
    "PEN",
    "PHP",
    "PLN",
    "QAR",
    "RON",
    "RUB",
    "RWF",
    "SVC",
    "WST",
    "SAR",
    "RSD",
    "SCR",
    "SLL",
    "SGD",
    "SKK",
    "SBD",
    "SOS",
    "ZAR",
    "KRW",
    "XDR",
    "LKR",
    "SHP",
    "SDG",
    "SRD",
    "SZL",
    "SEK",
    "CHF",
    "SYP",
    "STD",
    "TJS",
    "TZS",
    "THB",
    "TOP",
    "TTD",
    "TND",
    "TRY",
    "TMT",
    "UGX",
    "UAH",
    "AED",
    "UYU",
    "USD",
    "UZS",
    "VUV",
    "VEF",
    "VND",
    "YER",
    "ZMK"
];
(0, $lHoPV.TypeValidator)($1e0a1b0afa9066a3$export$a943a6a971a692b0);
function $1e0a1b0afa9066a3$export$a943a6a971a692b0(minorUnits, rounding = Math.round) {
    if (typeof minorUnits !== "number") throw new Error(`CurrencyMinorUnits must be a number, got ${minorUnits}`);
    minorUnits = rounding(minorUnits);
    if (!Number.isInteger(minorUnits)) throw new Error(`CurrencyMinorUnits must be an integer, got ${minorUnits}`);
    return minorUnits;
}
(0, $lHoPV.TypeValidator)($1e0a1b0afa9066a3$export$8029ec46e65f5f2f);
function $1e0a1b0afa9066a3$export$8029ec46e65f5f2f(minorUnits, rounding = Math.round) {
    if (minorUnits < 0) throw new Error(`CurrencyMinorUnitsNonNegative must be non-negative, got ${minorUnits}`);
    return $1e0a1b0afa9066a3$export$a943a6a971a692b0(minorUnits, rounding);
}
function $1e0a1b0afa9066a3$export$abc4224b069a4365(a, currency) {
    switch(currency){
        case "BHD":
        case "IQD":
        case "JOD":
        case "KWD":
        case "LYD":
        case "OMR":
        case "TND":
            return $1e0a1b0afa9066a3$export$c04c0f410a62d82e(a.valueOf() / 1000);
    }
    return $1e0a1b0afa9066a3$export$c04c0f410a62d82e(a.valueOf() / 100);
}
(0, $lHoPV.TypeValidator)($1e0a1b0afa9066a3$export$c04c0f410a62d82e);
function $1e0a1b0afa9066a3$export$c04c0f410a62d82e(majorUnits) {
    if (typeof majorUnits !== "number") throw new Error(`CurencyMajorUnits must be a number, got ${majorUnits}`);
    return majorUnits;
}
(0, $lHoPV.TypeValidator)($1e0a1b0afa9066a3$export$87dfc6c52c55dafa);
function $1e0a1b0afa9066a3$export$87dfc6c52c55dafa(majorUnits) {
    if (majorUnits < 0) throw new Error(`CurrencyMajorUnitsNonNegative must be non-negative, got ${majorUnits}`);
    return majorUnits;
}
const $1e0a1b0afa9066a3$export$502c7752de83fe40 = 0;
function $1e0a1b0afa9066a3$export$5cfb1f43e8a5f3dc(minorUnits, currency) {
    return Object.freeze({
        minorUnits: minorUnits,
        majorUnits: $1e0a1b0afa9066a3$export$abc4224b069a4365(minorUnits, currency),
        currency: currency
    });
}
$1e0a1b0afa9066a3$export$5cfb1f43e8a5f3dc.add = (a, b)=>{
    if (a.currency !== b.currency) throw new Error(`Cannot add amounts in different currencies: ${a.currency} and ${b.currency}`);
    const sum = a.minorUnits.valueOf() + b.minorUnits.valueOf();
    return $1e0a1b0afa9066a3$export$5cfb1f43e8a5f3dc($1e0a1b0afa9066a3$export$a943a6a971a692b0(sum), a.currency);
};
$1e0a1b0afa9066a3$export$5cfb1f43e8a5f3dc.subtract = (a, b)=>{
    if (a.currency !== b.currency) throw new Error(`Cannot subtract amounts in different currencies: ${a.currency} and ${b.currency}`);
    const difference = a.minorUnits.valueOf() - b.minorUnits.valueOf();
    return $1e0a1b0afa9066a3$export$5cfb1f43e8a5f3dc($1e0a1b0afa9066a3$export$a943a6a971a692b0(difference), a.currency);
};
$1e0a1b0afa9066a3$export$5cfb1f43e8a5f3dc.multiply = (a, b, /**
 * The rounding function to use to convert to an integer amount of minor
 * units. Defaults to Math.round, but can be set to e.g. Math.floor or
 * Math.ceil.
 */ rounding = Math.round)=>{
    const product = a.minorUnits.valueOf() * b;
    return $1e0a1b0afa9066a3$export$5cfb1f43e8a5f3dc($1e0a1b0afa9066a3$export$a943a6a971a692b0(product, rounding), a.currency);
};
$1e0a1b0afa9066a3$export$5cfb1f43e8a5f3dc.divide = (a, b, /**
 * The rounding function to use to convert to an integer amount of minor
 * units. Defaults to Math.round, but can be set to e.g. Math.floor or Math.ceil.
 */ rounding = Math.round)=>{
    const quotient = a.minorUnits.valueOf() / b;
    return $1e0a1b0afa9066a3$export$5cfb1f43e8a5f3dc($1e0a1b0afa9066a3$export$a943a6a971a692b0(quotient, rounding), a.currency);
};
/**
 * Formats a currency amount as a string (in major units) according to the
 * specified locale and options. If no locale or options are specified, the
 * runtime's default locale is used.
 */ $1e0a1b0afa9066a3$export$5cfb1f43e8a5f3dc.format = (/**
 * The amount of currency.
 */ amount, /**
 * The locale to use for formatting. If not specified, the runtime's default
 * locale is used.
 */ locale, /**
 * Options to pass to the Intl.NumberFormat constructor.
 *
 * The defaults `{ style: "currency", currency: amount.currency }` will be
 * set unless overridden by this parameter.
 */ options)=>{
    const format = new Intl.NumberFormat(locale, Object.assign({
        style: "currency",
        currency: amount.currency
    }, options));
    return format.format(amount.majorUnits.valueOf());
};

});

parcelRegister("97R5C", function(module, exports) {

$parcel$export(module.exports, "CountryCode", function () { return $6a4df2fb9acfbc14$export$34a98f1791d1800e; });
function $6a4df2fb9acfbc14$export$34a98f1791d1800e(country) {
    const countryCode = country;
    if ($6a4df2fb9acfbc14$export$7bc41e2d36612b98.includes(countryCode)) return countryCode;
    throw new Error(`${country} is not a recognized country code`);
}
const $6a4df2fb9acfbc14$export$7bc41e2d36612b98 = [
    "AF",
    "AX",
    "AL",
    "DZ",
    "AS",
    "AD",
    "AO",
    "AI",
    "AQ",
    "AG",
    "AR",
    "AM",
    "AW",
    "AU",
    "AT",
    "AZ",
    "BS",
    "BH",
    "BD",
    "BB",
    "BY",
    "BE",
    "BZ",
    "BJ",
    "BM",
    "BT",
    "BO",
    "BQ",
    "BA",
    "BW",
    "BV",
    "BR",
    "IO",
    "BN",
    "BG",
    "BF",
    "BI",
    "KH",
    "CM",
    "CA",
    "CV",
    "KY",
    "CF",
    "TD",
    "CL",
    "CN",
    "CX",
    "CC",
    "CO",
    "KM",
    "CG",
    "CD",
    "CK",
    "CR",
    "CI",
    "HR",
    "CU",
    "CW",
    "CY",
    "CZ",
    "DK",
    "DJ",
    "DM",
    "DO",
    "EC",
    "EG",
    "SV",
    "GQ",
    "ER",
    "EE",
    "ET",
    "FK",
    "FO",
    "FJ",
    "FI",
    "FR",
    "GF",
    "PF",
    "TF",
    "GA",
    "GM",
    "GE",
    "DE",
    "GH",
    "GI",
    "GR",
    "GL",
    "GD",
    "GP",
    "GU",
    "GT",
    "GG",
    "GN",
    "GW",
    "GY",
    "HT",
    "HM",
    "VA",
    "HN",
    "HK",
    "HU",
    "IS",
    "IN",
    "ID",
    "IR",
    "IQ",
    "IE",
    "IM",
    "IL",
    "IT",
    "JM",
    "JP",
    "JE",
    "JO",
    "KZ",
    "KE",
    "KI",
    "KP",
    "KR",
    "KW",
    "KG",
    "LA",
    "LV",
    "LB",
    "LS",
    "LR",
    "LY",
    "LI",
    "LT",
    "LU",
    "MO",
    "MK",
    "MG",
    "MW",
    "MY",
    "MV",
    "ML",
    "MT",
    "MH",
    "MQ",
    "MR",
    "MU",
    "YT",
    "MX",
    "FM",
    "MD",
    "MC",
    "MN",
    "ME",
    "MS",
    "MA",
    "MZ",
    "MM",
    "NA",
    "NR",
    "NP",
    "NL",
    "NC",
    "NZ",
    "NI",
    "NE",
    "NG",
    "NU",
    "NF",
    "MP",
    "NO",
    "OM",
    "PK",
    "PW",
    "PS",
    "PA",
    "PG",
    "PY",
    "PE",
    "PH",
    "PN",
    "PL",
    "PT",
    "PR",
    "QA",
    "RE",
    "RO",
    "RU",
    "RW",
    "BL",
    "SH",
    "KN",
    "LC",
    "MF",
    "PM",
    "VC",
    "WS",
    "SM",
    "ST",
    "SA",
    "SN",
    "RS",
    "SC",
    "SL",
    "SG",
    "SX",
    "SK",
    "SI",
    "SB",
    "SO",
    "ZA",
    "GS",
    "SS",
    "ES",
    "LK",
    "SD",
    "SR",
    "SJ",
    "SZ",
    "SE",
    "CH",
    "SY",
    "TW",
    "TJ",
    "TZ",
    "TH",
    "TL",
    "TG",
    "TK",
    "TO",
    "TT",
    "TN",
    "TR",
    "TM",
    "TC",
    "TV",
    "UG",
    "UA",
    "AE",
    "GB",
    "US",
    "UM",
    "UY",
    "UZ",
    "VU",
    "VE",
    "VN",
    "VG",
    "VI",
    "WF",
    "EH",
    "YE",
    "ZM",
    "ZW"
];

});

parcelRegister("4vUfp", function(module, exports) {

$parcel$export(module.exports, "ParseDateTimePrecision", function () { return $3495b0420ba46046$export$ad5e9dd1497adaff; });
$parcel$export(module.exports, "Timestamp", function () { return $3495b0420ba46046$export$d9bcbd5e1ff81430; });

var $5cQqO = parcelRequire("5cQqO");

var $lHoPV = parcelRequire("lHoPV");
function $3495b0420ba46046$export$ad5e9dd1497adaff(s) {
    const parts = s.split(" ");
    const units = parts.length === 1 ? 1 : parseInt(parts[0]);
    let unit = parts[parts.length - 1].toLowerCase();
    // allow both plural and singular
    if (unit.endsWith("s")) unit = unit.substring(0, unit.length - 1);
    switch(unit){
        case "year":
        case "month":
        case "day":
        case "hour":
        case "minute":
        case "second":
        case "millisecond":
            return {
                unit: unit,
                units: units
            };
    }
    throw new Error("Invalid date time precision: " + JSON.stringify(s));
}
(0, $lHoPV.TypeValidator)($3495b0420ba46046$export$d9bcbd5e1ff81430);
(0, $5cQqO.TSQFunction)($3495b0420ba46046$export$d9bcbd5e1ff81430);
function $3495b0420ba46046$export$d9bcbd5e1ff81430(d = Date.now()) {
    return new Date(d.valueOf()).toISOString();
}
(0, $lHoPV.TypeValidator)($3495b0420ba46046$export$d37d00a93355eb5e);
(0, $5cQqO.TSQFunction)($3495b0420ba46046$export$d37d00a93355eb5e);
function $3495b0420ba46046$export$d37d00a93355eb5e(d) {
    return d.millisecond() ? d.format("YYYY-MM-DD HH:mm:ss.SSS") : d.format("YYYY-MM-DD HH:mm:ss");
}
/** Formats the string in YYYY[-MM[-DD[Thh:mm[:ss[.000]]]]] format in local time, according to the
 * specified precision. This is the format expected by HTML's <input> tag, conveniently. */ $3495b0420ba46046$export$d9bcbd5e1ff81430.toLocal = function(ds, precision) {
    function pad(s) {
        s = s.toString();
        if (s.length === 1) return "0" + s;
        return s;
    }
    const unit = typeof precision === "string" ? precision : precision.unit;
    const d = new Date(ds.valueOf());
    if (unit === "year") return `${d.getFullYear().toString()}`;
    else if (unit === "month") return `${d.getFullYear().toString()}-${pad(d.getMonth() + 1)}`;
    else {
        const date = `${d.getFullYear().toString()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
        if (unit === "day") return date;
        else {
            const hourAndMinutes = pad(d.getHours()) + ":" + pad(d.getMinutes());
            if (unit === "minute") return date + "T" + hourAndMinutes;
            else {
                const hoursAndMinutesAndSeconds = `${hourAndMinutes}:${pad(d.getSeconds())}`;
                if (unit === "second") return date + "T" + hoursAndMinutesAndSeconds;
                else if (unit === "millisecond") {
                    let ms = d.getMilliseconds().toString();
                    while(ms.length < 3)ms = "0" + ms;
                    return `${date}T${hoursAndMinutesAndSeconds}.${ms}`;
                }
            }
        }
    }
    throw new Error("Invalid timestamp precision: " + JSON.stringify(precision));
};
/**
 * Checks if date `a` is after date `b`.
 */ $3495b0420ba46046$export$d9bcbd5e1ff81430.isAfter = function(a, b) {
    return new Date(a.valueOf()) > new Date(b.valueOf());
};
/**
 * Checks if date `a` is before date `b`.
 */ $3495b0420ba46046$export$d9bcbd5e1ff81430.isBefore = function(a, b) {
    return new Date(a.valueOf()) < new Date(b.valueOf());
};
/**
 * Checks if date `a` is identical to date `b` (milliseconds are the same)
 */ $3495b0420ba46046$export$d9bcbd5e1ff81430.isSame = function(a, b) {
    return new Date(a.valueOf()).getTime() === new Date(b.valueOf()).getTime();
};
/**
 * Sort function for Timestamps, sorts ascending
 */ $3495b0420ba46046$export$d9bcbd5e1ff81430.sortAscending = function(a, b) {
    return new Date(a.valueOf()).getTime() - new Date(b.valueOf()).getTime();
};
/**
 * Sort function for Timestamps, sorts descending
 */ $3495b0420ba46046$export$d9bcbd5e1ff81430.sortDescending = function(a, b) {
    return new Date(b.valueOf()).getTime() - new Date(a.valueOf()).getTime();
};

});

parcelRegister("2uVAW", function(module, exports) {

$parcel$export(module.exports, "Email", function () { return $1d1b0f43ef9f64df$export$5a6b8595f311cbb0; });

var $lHoPV = parcelRequire("lHoPV");
(0, $lHoPV.TypeValidator)($1d1b0f43ef9f64df$export$5a6b8595f311cbb0);
function $1d1b0f43ef9f64df$export$5a6b8595f311cbb0(email) {
    email = email.trim();
    if (/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-\.]+\.[a-zA-Z0-9]{2,}$/.test(email)) return email.toLowerCase();
    throw new Error("Invalid email address");
}
/** Abbreviates the email address, e.g. "foo.bar@email.com" => "FB" */ $1d1b0f43ef9f64df$export$5a6b8595f311cbb0.abbreviate = (e, maxLength = 2)=>{
    try {
        const i = e.indexOf("@");
        const n = e.slice(0, i);
        const r = n.split(/[^A-Za-z]/);
        return r.slice(0, maxLength).map((x)=>x[0].toUpperCase()).join("");
    } catch (_a) {
        return e.charAt(0);
    }
};

});

parcelRegister("6oG4E", function(module, exports) {
/** Converts the provided number to an Integer.
 *
 *  Throws an error if the provided number is not an integer
 */ function $4a859f034b88e15c$export$70ffa26850098d01(int) {
    if ((int | 0) !== int) throw new Error("Not an integer: " + int);
    return int;
}

});

parcelRegister("gGZ2r", function(module, exports) {

$parcel$export(module.exports, "Markdown", function () { return $c26fea84ff7eb781$export$7460c8b7e4ce9582; });

var $lHoPV = parcelRequire("lHoPV");
(0, $lHoPV.TypeValidator)($c26fea84ff7eb781$export$7460c8b7e4ce9582);
function $c26fea84ff7eb781$export$7460c8b7e4ce9582(md) {
    return md;
}
$c26fea84ff7eb781$export$7460c8b7e4ce9582.trim = (md)=>{
    return md.split("\n").map((x)=>x.trim()).join("\n");
};
const $c26fea84ff7eb781$var$regexMdLinks = /\[([^\[]+)\]\((.*)\)/gm;
$c26fea84ff7eb781$export$7460c8b7e4ce9582.transformLinks = (md, transform)=>{
    return $c26fea84ff7eb781$export$7460c8b7e4ce9582(md.replace($c26fea84ff7eb781$var$regexMdLinks, (substr, p1, p2)=>{
        const { alt: alt, link: link } = transform(p1, p2);
        return `[${alt}](${link})`;
    }));
};

});

parcelRegister("fR074", function(module, exports) {

$parcel$export(module.exports, "NonNegativeInteger", function () { return $b8abe4afef8ffe29$export$3aa437e0bb159f44; });
function $b8abe4afef8ffe29$export$9901fe19cc8242bc(nonNegativeNumber) {
    if (nonNegativeNumber >= 0) return nonNegativeNumber;
    throw new Error("NonNegativeNumber must be 0 or a positive number");
}
function $b8abe4afef8ffe29$export$3aa437e0bb159f44(nonNegativeInteger) {
    if (Number.isInteger(nonNegativeInteger) && nonNegativeInteger >= 0) return nonNegativeInteger;
    throw new Error("NonNegativeInteger must be 0 or a positive integer");
}

});

parcelRegister("iDHvF", function(module, exports) {

});

parcelRegister("eHTbG", function(module, exports) {

var $lHoPV = parcelRequire("lHoPV");
(0, $lHoPV.TypeValidator)($ab4fe3e65807cce1$export$cbc348af47898b5e);
function $ab4fe3e65807cce1$export$cbc348af47898b5e(pct, minValue, maxValue) {
    return pct;
}

});

parcelRegister("4QAvl", function(module, exports) {

$parcel$export(module.exports, "PhoneNumber", function () { return $387855cc94c1b07f$export$3d623a7758cab61e; });

var $hVoVD = parcelRequire("hVoVD");

var $lHoPV = parcelRequire("lHoPV");

var $6XCaz = parcelRequire("6XCaz");
(0, $lHoPV.TypeValidator)($387855cc94c1b07f$export$3d623a7758cab61e);
function $387855cc94c1b07f$export$3d623a7758cab61e(pn) {
    var _a;
    if (!pn.startsWith("+")) throw new Error("Phone number must start with a country code, e.g. +47");
    if (pn.includes(" ")) throw new Error("Phone number must not contain spaces");
    // Check for illegal characters, if found, throw an error with the illegal characters
    if (pn.match(/[^0-9+]/)) throw new $387855cc94c1b07f$export$c37555231a66b87c(`Phone number contains illegal characters: ${(_a = pn.match(/[^0-9+]/)) === null || _a === void 0 ? void 0 : _a.join(", ")}`);
    return pn;
}
class $387855cc94c1b07f$export$c37555231a66b87c extends (0, $hVoVD.BadRequest) {
    constructor(message = "Phone number is not in a valid format - Requires the phone number to be in E.164 format, with a leading +"){
        super(message);
    }
}
$387855cc94c1b07f$export$3d623a7758cab61e.flagOf = function(prefix) {
    var _a;
    return ((_a = $6XCaz.findOne("countryCallingCode", prefix.replace("+", ""))) === null || _a === void 0 ? void 0 : _a.flag) || "\uD83C\uDFF3\uFE0F";
};

});
parcelRegister("hVoVD", function(module, exports) {

$parcel$export(module.exports, "BadRequest", function () { return $d0cb18d27936a491$export$99341f548497676e; });

var $8h5s0 = parcelRequire("8h5s0");
class $d0cb18d27936a491$export$d4e71bc0b80dc0fb extends Error {
    constructor(status, detail){
        super();
        this.status = status;
        this.detail = detail;
        /** The problem type. This is a string that uniquely identifies the problem
         * case. */ this.type = this.constructor.name;
    }
    get message() {
        return `${this.detail} (${this.status} ${this.description})`;
    }
    /** This serializes the ErrorCode exception as compliant with the `application/problem+json` mime
     * type, appropriate for returning in the HTTP response. */ toJSON() {
        return {
            type: this.type,
            detail: this.detail,
            status: this.status
        };
    }
    get description() {
        return this.constructor.description || this.type;
    }
}
class $d0cb18d27936a491$export$99341f548497676e extends $d0cb18d27936a491$export$d4e71bc0b80dc0fb {
    constructor(detail){
        super(400, detail);
    }
}
$d0cb18d27936a491$export$99341f548497676e.description = "Bad Request";
class $d0cb18d27936a491$export$19c9d77d7b17be8 extends $d0cb18d27936a491$export$99341f548497676e {
    constructor(detail){
        super(detail);
    }
    withDiagnostic(diagnostic) {
        this.diagnostic = diagnostic;
        return this;
    }
}
class $d0cb18d27936a491$export$3ec1ce42a7e09129 extends $d0cb18d27936a491$export$d4e71bc0b80dc0fb {
    constructor(detail){
        super(401, detail);
    }
}
$d0cb18d27936a491$export$3ec1ce42a7e09129.description = "Unauthorized";
class $d0cb18d27936a491$export$19e402bf0a6cad34 extends $d0cb18d27936a491$export$d4e71bc0b80dc0fb {
    constructor(detail = "Forbidden"){
        super(403, detail);
    }
}
$d0cb18d27936a491$export$19e402bf0a6cad34.description = "Forbidden";
class $d0cb18d27936a491$export$271f9f08425019c7 extends $d0cb18d27936a491$export$d4e71bc0b80dc0fb {
    constructor(detail = "Not Found"){
        super(404, detail);
    }
    /**
     * Generates the default not found message returned by endpoints that use
     * the reference syntax for arguments.
     *
     * This is placed here to ensure consistency between the spec and
     * implementation.
     */ static referenceNotFoundMessage(typeName, paramName) {
        return `No ${(0, $8h5s0.prettyCamel)(typeName, false)} matching the specified ${paramName}`;
    }
}
$d0cb18d27936a491$export$271f9f08425019c7.description = "Not Found";
class $d0cb18d27936a491$export$5440db93490b0465 extends $d0cb18d27936a491$export$d4e71bc0b80dc0fb {
    constructor(detail){
        super(408, detail);
    }
}
class $d0cb18d27936a491$export$97a560b147cd48ee extends $d0cb18d27936a491$export$d4e71bc0b80dc0fb {
    constructor(detail){
        super(409, detail);
    }
}
class $d0cb18d27936a491$export$803afdee88dc528c extends $d0cb18d27936a491$export$d4e71bc0b80dc0fb {
    constructor(detail){
        super(410, detail);
    }
}
class $d0cb18d27936a491$export$40f5430a96d2cacf extends $d0cb18d27936a491$export$d4e71bc0b80dc0fb {
    constructor(detail){
        super(412, detail);
    }
}
class $d0cb18d27936a491$export$74b671f8c35e14da extends $d0cb18d27936a491$export$d4e71bc0b80dc0fb {
    constructor(detail){
        super(422, detail);
    }
}
class $d0cb18d27936a491$export$1e0c583012b77b4e extends $d0cb18d27936a491$export$d4e71bc0b80dc0fb {
    constructor(detail){
        super(424, detail);
    }
}
class $d0cb18d27936a491$export$77ccdd88bc9a7bc extends $d0cb18d27936a491$export$d4e71bc0b80dc0fb {
    constructor(detail){
        super(425, detail);
    }
}
class $d0cb18d27936a491$export$f2598bad29b0c174 extends $d0cb18d27936a491$export$d4e71bc0b80dc0fb {
    constructor(detail){
        super(429, detail);
    }
}
class $d0cb18d27936a491$export$2004b0625b599107 extends $d0cb18d27936a491$export$d4e71bc0b80dc0fb {
    constructor(detail){
        super(500, detail);
    }
}
$d0cb18d27936a491$export$2004b0625b599107.description = "Internal Server Error";
class $d0cb18d27936a491$export$236f3942bde1acd0 extends $d0cb18d27936a491$export$d4e71bc0b80dc0fb {
    constructor(detail){
        super(503, detail);
    }
}

});

parcelRegister("6XCaz", function(module, exports) {
"use strict";
var $5115dc6fe3656715$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.customList = module.exports.customArray = module.exports.findOne = module.exports.filter = module.exports.all = module.exports.utils = void 0;

const $5115dc6fe3656715$var$groupBy_1 = $5115dc6fe3656715$var$__importDefault((parcelRequire("43e6h")));

const $5115dc6fe3656715$var$supplant_1 = $5115dc6fe3656715$var$__importDefault((parcelRequire("J9DCy")));

const $5115dc6fe3656715$var$countriesData_1 = $5115dc6fe3656715$var$__importDefault((parcelRequire("VtZo9")));
module.exports.utils = {
    groupBy: $5115dc6fe3656715$var$groupBy_1.default
};
function $5115dc6fe3656715$var$all() {
    return $5115dc6fe3656715$var$countriesData_1.default;
}
module.exports.all = $5115dc6fe3656715$var$all;
function $5115dc6fe3656715$var$filter(countryProperty, value) {
    return $5115dc6fe3656715$var$countriesData_1.default.filter((countryData)=>countryData[countryProperty] === value);
}
module.exports.filter = $5115dc6fe3656715$var$filter;
function $5115dc6fe3656715$var$findOne(countryProperty, value) {
    return $5115dc6fe3656715$var$countriesData_1.default.find((countryData)=>countryData[countryProperty] === value);
}
module.exports.findOne = $5115dc6fe3656715$var$findOne;
function $5115dc6fe3656715$var$customArray(fields = {
    name: "{countryNameEn} ({countryCode})",
    value: "{countryCode}"
}, { sortBy: sortBy, sortDataBy: sortDataBy, filter: filterFunc } = {}) {
    const finalCollection = [];
    let data = $5115dc6fe3656715$var$countriesData_1.default;
    if (typeof filterFunc === "function") data = data.filter(filterFunc);
    if (sortDataBy) {
        const collator = new Intl.Collator([], {
            sensitivity: "accent"
        });
        data.sort((a, b)=>collator.compare(a[sortDataBy], b[sortDataBy]));
    }
    data.forEach((countryData)=>{
        const collectionObject = {};
        for(const field in fields)collectionObject[field] = (0, $5115dc6fe3656715$var$supplant_1.default)(fields[field], countryData);
        finalCollection.push(collectionObject);
    });
    if (sortBy && fields[sortBy]) {
        const collator = new Intl.Collator([], {
            sensitivity: "accent"
        });
        finalCollection.sort((a, b)=>collator.compare(a[sortBy], b[sortBy]));
    }
    return finalCollection;
}
module.exports.customArray = $5115dc6fe3656715$var$customArray;
function $5115dc6fe3656715$var$customList(key = "countryCode", label = "{countryNameEn} ({countryCode})", { filter: filterFunc } = {}) {
    const finalObject = {};
    let data = $5115dc6fe3656715$var$countriesData_1.default;
    if (typeof filterFunc === "function") data = data.filter(filterFunc);
    data.forEach((countryData)=>{
        const value = (0, $5115dc6fe3656715$var$supplant_1.default)(label, countryData);
        finalObject[String(countryData[key])] = value;
    });
    return finalObject;
}
module.exports.customList = $5115dc6fe3656715$var$customList;

});
parcelRegister("43e6h", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
/**
 * Groups an array by a specified key.
 * @param array - The array to group.
 * @param key - The key to group the array by.
 * @returns An object where each key is a unique value from the array, and each value is an array of items from the original array that match the key.
 */ function $2f326141a2f7a51a$var$groupBy(array, key) {
    return array.reduce((result, item)=>{
        const groupKey = String(item[key]);
        if (!result[groupKey]) result[groupKey] = [];
        result[groupKey].push(item);
        return result;
    }, {});
}
module.exports.default = $2f326141a2f7a51a$var$groupBy;

});

parcelRegister("J9DCy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
/**
 * Replaces placeholders in a string with values from an object.
 * @param template - The string containing placeholders.
 * @param data - The object containing key-value pairs for replacement.
 * @returns The string with placeholders replaced by values.
 */ function $087badffd2f70006$var$supplant(template, data) {
    return template.replace(/{([^{}]*)}/g, (match, key)=>{
        const value = data[key];
        return typeof value === "string" || typeof value === "number" ? value.toString() : match;
    });
}
module.exports.default = $087badffd2f70006$var$supplant;

});

parcelRegister("VtZo9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
const $0acc96342647e474$var$countriesData = [
    {
        countryNameEn: "Andorra",
        countryNameLocal: "Andorra",
        countryCode: "AD",
        currencyCode: "EUR",
        currencyNameEn: "Euro",
        tinType: "",
        tinName: "",
        officialLanguageCode: "ca",
        officialLanguageNameEn: "Catalan, Valencian",
        officialLanguageNameLocal: "Catal\xe0, Valenci\xe0",
        countryCallingCode: "376",
        areaCodes: [],
        region: "Europe",
        flag: "\uD83C\uDDE6\uD83C\uDDE9"
    },
    {
        countryNameEn: "Afghanistan",
        countryNameLocal: "\u062F \u0627\u0641\u063A\u0627\u0646\u0633\u062A\u0627\u0646 \u0627\u0633\u0644\u0627\u0645\u064A \u062F\u0648\u0644\u062A\u062F\u0648\u0644\u062A \u0627\u0633\u0644\u0627\u0645\u06CC \u0627\u0641\u063A\u0627\u0646\u0633\u062A\u0627\u0646, \u062C\u0645\u0647\u0648\u0631\u06CC \u0627\u0633\u0644\u0627\u0645\u06CC \u0627\u0641\u063A\u0627\u0646\u0633\u062A\u0627\u0646",
        countryCode: "AF",
        currencyCode: "AFN",
        currencyNameEn: "Afghan afghani",
        tinType: "",
        tinName: "",
        officialLanguageCode: "fa",
        officialLanguageNameEn: "Persian",
        officialLanguageNameLocal: "\u0641\u0627\u0631\u0633\u06CC",
        countryCallingCode: "93",
        areaCodes: [],
        region: "Asia & Pacific",
        flag: "\uD83C\uDDE6\uD83C\uDDEB"
    },
    {
        countryNameEn: "Antigua and Barbuda",
        countryNameLocal: "Antigua and Barbuda",
        countryCode: "AG",
        currencyCode: "XCD",
        currencyNameEn: "East Caribbean dollar",
        tinType: "",
        tinName: "",
        officialLanguageCode: "en",
        officialLanguageNameEn: "English",
        officialLanguageNameLocal: "English",
        countryCallingCode: "1268",
        areaCodes: [],
        region: "South/Latin America",
        flag: "\uD83C\uDDE6\uD83C\uDDEC"
    },
    {
        countryNameEn: "Anguilla",
        countryNameLocal: "Anguilla",
        countryCode: "AI",
        currencyCode: "XCD",
        currencyNameEn: "East Caribbean dollar",
        tinType: "",
        tinName: "",
        officialLanguageCode: "en",
        officialLanguageNameEn: "English",
        officialLanguageNameLocal: "English",
        countryCallingCode: "1264",
        areaCodes: [],
        region: "South/Latin America",
        flag: "\uD83C\uDDE6\uD83C\uDDEE"
    },
    {
        countryNameEn: "Albania",
        countryNameLocal: "Shqip\xebria",
        countryCode: "AL",
        currencyCode: "ALL",
        currencyNameEn: "Albanian lek",
        tinType: "NIPT",
        tinName: "Numri i Identifikimit p\xebr Personin e Tatuesh\xebm",
        officialLanguageCode: "sq",
        officialLanguageNameEn: "Albanian",
        officialLanguageNameLocal: "Shqip",
        countryCallingCode: "355",
        areaCodes: [],
        region: "Europe",
        flag: "\uD83C\uDDE6\uD83C\uDDF1"
    },
    {
        countryNameEn: "Armenia",
        countryNameLocal: "\u0540\u0561\u0575\u0561\u057D\u057F\u0561\u0576",
        countryCode: "AM",
        currencyCode: "AMD",
        currencyNameEn: "Armenian dram",
        tinType: "",
        tinName: "",
        officialLanguageCode: "hy",
        officialLanguageNameEn: "Armenian",
        officialLanguageNameLocal: "\u0540\u0561\u0575\u0565\u0580\u0565\u0576",
        countryCallingCode: "374",
        areaCodes: [],
        region: "Europe",
        flag: "\uD83C\uDDE6\uD83C\uDDF2"
    },
    {
        countryNameEn: "Angola",
        countryNameLocal: "Angola",
        countryCode: "AO",
        currencyCode: "AOA",
        currencyNameEn: "Angolan kwanza",
        tinType: "",
        tinName: "",
        officialLanguageCode: "pt",
        officialLanguageNameEn: "Portuguese",
        officialLanguageNameLocal: "Portugu\xeas",
        countryCallingCode: "244",
        areaCodes: [],
        region: "Africa",
        flag: "\uD83C\uDDE6\uD83C\uDDF4"
    },
    {
        countryNameEn: "Antarctica",
        countryNameLocal: "Antarctica, Ant\xe1rtico, Antarctique, \u0410\u043D\u0442\u0430\u0440\u043A\u0442\u0438\u043A\u0435",
        countryCode: "AQ",
        currencyCode: "",
        currencyNameEn: "",
        tinType: "",
        tinName: "",
        officialLanguageCode: "en",
        officialLanguageNameEn: "English",
        officialLanguageNameLocal: "English",
        countryCallingCode: "672",
        areaCodes: [],
        region: "Asia & Pacific",
        flag: "\uD83C\uDDE6\uD83C\uDDF6"
    },
    {
        countryNameEn: "Argentina",
        countryNameLocal: "Argentina",
        countryCode: "AR",
        currencyCode: "ARS",
        currencyNameEn: "Argentine peso",
        tinType: "CUIT",
        tinName: "C\xf3digo \xdanico de Identificaci\xf3n Tributaria",
        officialLanguageCode: "es",
        officialLanguageNameEn: "Spanish, Castilian",
        officialLanguageNameLocal: "Espa\xf1ol",
        countryCallingCode: "54",
        areaCodes: [],
        region: "South/Latin America",
        flag: "\uD83C\uDDE6\uD83C\uDDF7"
    },
    {
        countryNameEn: "American Samoa",
        countryNameLocal: "American Samoa",
        countryCode: "AS",
        currencyCode: "USD",
        currencyNameEn: "United States dollar",
        tinType: "",
        tinName: "",
        officialLanguageCode: "en",
        officialLanguageNameEn: "English",
        officialLanguageNameLocal: "English",
        countryCallingCode: "1684",
        areaCodes: [],
        region: "Asia & Pacific",
        flag: "\uD83C\uDDE6\uD83C\uDDF8"
    },
    {
        countryNameEn: "Austria",
        countryNameLocal: "\xd6sterreich",
        countryCode: "AT",
        currencyCode: "EUR",
        currencyNameEn: "Euro",
        tinType: "UID",
        tinName: "Umsatzsteuer-Identifikationsnummer",
        officialLanguageCode: "de",
        officialLanguageNameEn: "German",
        officialLanguageNameLocal: "Deutsch",
        countryCallingCode: "43",
        areaCodes: [],
        region: "Europe",
        flag: "\uD83C\uDDE6\uD83C\uDDF9"
    },
    {
        countryNameEn: "Australia",
        countryNameLocal: "Australia",
        countryCode: "AU",
        currencyCode: "AUD",
        currencyNameEn: "Australian dollar",
        tinType: "ABN",
        tinName: "Australian Business Number",
        officialLanguageCode: "en",
        officialLanguageNameEn: "English",
        officialLanguageNameLocal: "English",
        countryCallingCode: "61",
        areaCodes: [],
        region: "Asia & Pacific",
        flag: "\uD83C\uDDE6\uD83C\uDDFA"
    },
    {
        countryNameEn: "Aruba",
        countryNameLocal: "Aruba",
        countryCode: "AW",
        currencyCode: "AWG",
        currencyNameEn: "Aruban florin",
        tinType: "",
        tinName: "",
        officialLanguageCode: "nl",
        officialLanguageNameEn: "Dutch, Flemish",
        officialLanguageNameLocal: "Nederlands, Vlaams",
        countryCallingCode: "297",
        areaCodes: [],
        region: "South/Latin America",
        flag: "\uD83C\uDDE6\uD83C\uDDFC"
    },
    {
        countryNameEn: "\xc5land Islands",
        countryNameLocal: "\xc5land",
        countryCode: "AX",
        currencyCode: "EUR",
        currencyNameEn: "Euro",
        tinType: "",
        tinName: "",
        officialLanguageCode: "sv",
        officialLanguageNameEn: "Swedish",
        officialLanguageNameLocal: "Svenska",
        countryCallingCode: "358",
        areaCodes: [],
        region: "Europe",
        flag: "\uD83C\uDDE6\uD83C\uDDFD"
    },
    {
        countryNameEn: "Azerbaijan",
        countryNameLocal: "Az\u0259rbaycan",
        countryCode: "AZ",
        currencyCode: "AZN",
        currencyNameEn: "Azerbaijani manat",
        tinType: "",
        tinName: "",
        officialLanguageCode: "az",
        officialLanguageNameEn: "Azerbaijani",
        officialLanguageNameLocal: "az\u0259rbaycan dili",
        countryCallingCode: "994",
        areaCodes: [],
        region: "Asia & Pacific",
        flag: "\uD83C\uDDE6\uD83C\uDDFF"
    },
    {
        countryNameEn: "Bosnia and Herzegovina",
        countryNameLocal: "Bosna i Hercegovina",
        countryCode: "BA",
        currencyCode: "BAM",
        currencyNameEn: "Bosnia and Herzegovina convertible mark",
        tinType: "",
        tinName: "",
        officialLanguageCode: "bs",
        officialLanguageNameEn: "Bosnian",
        officialLanguageNameLocal: "bosanski jezik",
        countryCallingCode: "387",
        areaCodes: [],
        region: "Europe",
        flag: "\uD83C\uDDE7\uD83C\uDDE6"
    },
    {
        countryNameEn: "Barbados",
        countryNameLocal: "Barbados",
        countryCode: "BB",
        currencyCode: "BBD",
        currencyNameEn: "Barbados dollar",
        tinType: "",
        tinName: "",
        officialLanguageCode: "en",
        officialLanguageNameEn: "English",
        officialLanguageNameLocal: "English",
        countryCallingCode: "1246",
        areaCodes: [],
        region: "South/Latin America",
        flag: "\uD83C\uDDE7\uD83C\uDDE7"
    },
    {
        countryNameEn: "Bangladesh",
        countryNameLocal: "\u0997\u09A3\u09AA\u09CD\u09B0\u099C\u09BE\u09A4\u09A8\u09CD\u09A4\u09CD\u09B0\u09C0 \u09AC\u09BE\u0982\u09B2\u09BE\u09A6\u09C7\u09B6",
        countryCode: "BD",
        currencyCode: "BDT",
        currencyNameEn: "Bangladeshi taka",
        tinType: "",
        tinName: "",
        officialLanguageCode: "bn",
        officialLanguageNameEn: "Bengali",
        officialLanguageNameLocal: "\u09AC\u09BE\u0982\u09B2\u09BE",
        countryCallingCode: "880",
        areaCodes: [],
        region: "Asia & Pacific",
        flag: "\uD83C\uDDE7\uD83C\uDDE9"
    },
    {
        countryNameEn: "Belgium",
        countryNameLocal: "Belgi\xeb, Belgique, Belgien",
        countryCode: "BE",
        currencyCode: "EUR",
        currencyNameEn: "Euro",
        tinType: "n\xb0 TVABTW-nr Mwst-nr",
        tinName: "BTW identificatienummer / Num\xe9ro de TVA",
        officialLanguageCode: "nl",
        officialLanguageNameEn: "Dutch, Flemish",
        officialLanguageNameLocal: "Nederlands, Vlaams",
        countryCallingCode: "32",
        areaCodes: [],
        region: "Europe",
        flag: "\uD83C\uDDE7\uD83C\uDDEA"
    },
    {
        countryNameEn: "Burkina Faso",
        countryNameLocal: "Burkina Faso",
        countryCode: "BF",
        currencyCode: "XOF",
        currencyNameEn: "CFA franc BCEAO",
        tinType: "",
        tinName: "",
        officialLanguageCode: "fr",
        officialLanguageNameEn: "French",
        officialLanguageNameLocal: "Fran\xe7ais",
        countryCallingCode: "226",
        areaCodes: [],
        region: "Africa",
        flag: "\uD83C\uDDE7\uD83C\uDDEB"
    },
    {
        countryNameEn: "Bulgaria",
        countryNameLocal: "\u0411\u044A\u043B\u0433\u0430\u0440\u0438\u044F",
        countryCode: "BG",
        currencyCode: "BGN",
        currencyNameEn: "Bulgarian lev",
        tinType: "\u0414\u0414\u0421 \u043D\u043E\u043C\u0435\u0440",
        tinName: "\u0418\u0434\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u043E\u043D\u0435\u043D \u043D\u043E\u043C\u0435\u0440 \u043F\u043E \u0414\u0414\u0421",
        officialLanguageCode: "bg",
        officialLanguageNameEn: "Bulgarian",
        officialLanguageNameLocal: "\u0431\u044A\u043B\u0433\u0430\u0440\u0441\u043A\u0438 \u0435\u0437\u0438\u043A",
        countryCallingCode: "359",
        areaCodes: [],
        region: "Europe",
        flag: "\uD83C\uDDE7\uD83C\uDDEC"
    },
    {
        countryNameEn: "Bahrain",
        countryNameLocal: "\u0627\u0644\u0628\u062D\u0631\u064A\u0646",
        countryCode: "BH",
        currencyCode: "BHD",
        currencyNameEn: "Bahraini dinar",
        tinType: "",
        tinName: "",
        officialLanguageCode: "ar",
        officialLanguageNameEn: "Arabic",
        officialLanguageNameLocal: "\u0627\u0644\u0639\u0631\u0628\u064A\u0629",
        countryCallingCode: "973",
        areaCodes: [],
        region: "Arab States",
        flag: "\uD83C\uDDE7\uD83C\uDDED"
    },
    {
        countryNameEn: "Burundi",
        countryNameLocal: "Burundi",
        countryCode: "BI",
        currencyCode: "BIF",
        currencyNameEn: "Burundian franc",
        tinType: "",
        tinName: "",
        officialLanguageCode: "fr",
        officialLanguageNameEn: "French",
        officialLanguageNameLocal: "Fran\xe7ais",
        countryCallingCode: "257",
        areaCodes: [],
        region: "Africa",
        flag: "\uD83C\uDDE7\uD83C\uDDEE"
    },
    {
        countryNameEn: "Benin",
        countryNameLocal: "B\xe9nin",
        countryCode: "BJ",
        currencyCode: "XOF",
        currencyNameEn: "CFA franc BCEAO",
        tinType: "",
        tinName: "",
        officialLanguageCode: "fr",
        officialLanguageNameEn: "French",
        officialLanguageNameLocal: "Fran\xe7ais",
        countryCallingCode: "229",
        areaCodes: [],
        region: "Africa",
        flag: "\uD83C\uDDE7\uD83C\uDDEF"
    },
    {
        countryNameEn: "Saint Barth\xe9lemy",
        countryNameLocal: "Saint-Barth\xe9lemy",
        countryCode: "BL",
        currencyCode: "EUR",
        currencyNameEn: "Euro",
        tinType: "",
        tinName: "",
        officialLanguageCode: "fr",
        officialLanguageNameEn: "French",
        officialLanguageNameLocal: "Fran\xe7ais",
        countryCallingCode: "590",
        areaCodes: [],
        region: "South/Latin America",
        flag: "\uD83C\uDDE7\uD83C\uDDF1"
    },
    {
        countryNameEn: "Bermuda",
        countryNameLocal: "Bermuda",
        countryCode: "BM",
        currencyCode: "BMD",
        currencyNameEn: "Bermudian dollar",
        tinType: "",
        tinName: "",
        officialLanguageCode: "en",
        officialLanguageNameEn: "English",
        officialLanguageNameLocal: "English",
        countryCallingCode: "1441",
        areaCodes: [],
        region: "North America",
        flag: "\uD83C\uDDE7\uD83C\uDDF2"
    },
    {
        countryNameEn: "Brunei Darussalam",
        countryNameLocal: "Brunei Darussalam",
        countryCode: "BN",
        currencyCode: "BND",
        currencyNameEn: "Brunei dollar",
        tinType: "",
        tinName: "",
        officialLanguageCode: "ms",
        officialLanguageNameEn: "Malay",
        officialLanguageNameLocal: "Bahasa Melayu, \u0628\u0647\u0627\u0633 \u0645\u0644\u0627\u064A\u0648\u200E",
        countryCallingCode: "673",
        areaCodes: [],
        region: "Asia & Pacific",
        flag: "\uD83C\uDDE7\uD83C\uDDF3"
    },
    {
        countryNameEn: "Bolivia (Plurinational State of)",
        countryNameLocal: "Bolivia, Bulibiya, Vol\xedvia, Wuliwya",
        countryCode: "BO",
        currencyCode: "BOP",
        currencyNameEn: "",
        tinType: "NIT",
        tinName: "N\xfamero de Identificaci\xf3n Tributaria",
        officialLanguageCode: "es",
        officialLanguageNameEn: "Spanish, Castilian",
        officialLanguageNameLocal: "Espa\xf1ol",
        countryCallingCode: "591",
        areaCodes: [],
        region: "South/Latin America",
        flag: "\uD83C\uDDE7\uD83C\uDDF4"
    },
    {
        countryNameEn: "Bonaire, Sint Eustatius and Saba",
        countryNameLocal: "Caribisch Nederland",
        countryCode: "BQ",
        currencyCode: "USD",
        currencyNameEn: "United States dollar",
        tinType: "",
        tinName: "",
        officialLanguageCode: "nl",
        officialLanguageNameEn: "Dutch, Flemish",
        officialLanguageNameLocal: "Nederlands, Vlaams",
        countryCallingCode: "5997",
        areaCodes: [],
        region: "Unknown",
        flag: "\uD83C\uDDE7\uD83C\uDDF6"
    },
    {
        countryNameEn: "Brazil",
        countryNameLocal: "Brasil",
        countryCode: "BR",
        currencyCode: "BRL",
        currencyNameEn: "Brazilian real",
        tinType: "CNPJ",
        tinName: "Cadastro Nacional de Pessoa Jur\xeddica",
        officialLanguageCode: "pt",
        officialLanguageNameEn: "Portuguese",
        officialLanguageNameLocal: "Portugu\xeas",
        countryCallingCode: "55",
        areaCodes: [],
        region: "South/Latin America",
        flag: "\uD83C\uDDE7\uD83C\uDDF7"
    },
    {
        countryNameEn: "Bhutan",
        countryNameLocal: "\u0F60\u0F56\u0FB2\u0F74\u0F42\u0F0B\u0F61\u0F74\u0F63",
        countryCode: "BT",
        currencyCode: "BTN",
        currencyNameEn: "Bhutanese ngultrum",
        tinType: "",
        tinName: "",
        officialLanguageCode: "dz",
        officialLanguageNameEn: "Dzongkha",
        officialLanguageNameLocal: "\u0F62\u0FAB\u0F7C\u0F44\u0F0B\u0F41",
        countryCallingCode: "975",
        areaCodes: [],
        region: "Asia & Pacific",
        flag: "\uD83C\uDDE7\uD83C\uDDF9"
    },
    {
        countryNameEn: "Bouvet Island",
        countryNameLocal: "Bouvet\xf8ya",
        countryCode: "BV",
        currencyCode: "NOK",
        currencyNameEn: "Norwegian krone",
        tinType: "",
        tinName: "",
        officialLanguageCode: "no",
        officialLanguageNameEn: "Norwegian",
        officialLanguageNameLocal: "Norsk",
        countryCallingCode: "47",
        areaCodes: [],
        region: "South/Latin America",
        flag: "\uD83C\uDDE7\uD83C\uDDFB"
    },
    {
        countryNameEn: "Botswana",
        countryNameLocal: "Botswana",
        countryCode: "BW",
        currencyCode: "BWP",
        currencyNameEn: "Botswana pula",
        tinType: "",
        tinName: "",
        officialLanguageCode: "en",
        officialLanguageNameEn: "English",
        officialLanguageNameLocal: "English",
        countryCallingCode: "267",
        areaCodes: [],
        region: "Africa",
        flag: "\uD83C\uDDE7\uD83C\uDDFC"
    },
    {
        countryNameEn: "Belarus",
        countryNameLocal: "\u0411\u0435\u043B\u0430\u0440\u0443\u0441\u044C",
        countryCode: "BY",
        currencyCode: "BYR",
        currencyNameEn: "",
        tinType: "\u0423\u041D\u041F (UNP)",
        tinName: "\u0423\u0447\u0435\u0442\u043D\u044B\u0439 \u043D\u043E\u043C\u0435\u0440 \u043F\u043B\u0430\u0442\u0435\u043B\u044C\u0449\u0438\u043A\u0430",
        officialLanguageCode: "be",
        officialLanguageNameEn: "Belarusian",
        officialLanguageNameLocal: "\u0431\u0435\u043B\u0430\u0440\u0443\u0441\u043A\u0430\u044F \u043C\u043E\u0432\u0430",
        countryCallingCode: "375",
        areaCodes: [],
        region: "Europe",
        flag: "\uD83C\uDDE7\uD83C\uDDFE"
    },
    {
        countryNameEn: "Belize",
        countryNameLocal: "Belize",
        countryCode: "BZ",
        currencyCode: "BZD",
        currencyNameEn: "Belize dollar",
        tinType: "",
        tinName: "",
        officialLanguageCode: "en",
        officialLanguageNameEn: "English",
        officialLanguageNameLocal: "English",
        countryCallingCode: "501",
        areaCodes: [],
        region: "South/Latin America",
        flag: "\uD83C\uDDE7\uD83C\uDDFF"
    },
    {
        countryNameEn: "Canada",
        countryNameLocal: "Canada",
        countryCode: "CA",
        currencyCode: "CAD",
        currencyNameEn: "Canadian dollar",
        tinType: "BN / NE",
        tinName: "Business Number",
        officialLanguageCode: "en",
        officialLanguageNameEn: "English",
        officialLanguageNameLocal: "English",
        countryCallingCode: "1",
        areaCodes: [
            "403",
            "587",
            "780",
            "825",
            "236",
            "250",
            "604",
            "672",
            "778",
            "204",
            "431",
            "506",
            "709",
            "782",
            "902",
            "226",
            "249",
            "289",
            "343",
            "365",
            "416",
            "437",
            "519",
            "548",
            "613",
            "647",
            "705",
            "807",
            "905",
            "367",
            "418",
            "438",
            "450",
            "514",
            "579",
            "581",
            "819",
            "873",
            "306",
            "639",
            "867"
        ],
        region: "North America",
        flag: "\uD83C\uDDE8\uD83C\uDDE6"
    },
    {
        countryNameEn: "Switzerland",
        countryNameLocal: "Schweiz, Suisse, Svizzera, Svizra",
        countryCode: "CH",
        currencyCode: "CHF",
        currencyNameEn: "Swiss franc",
        tinType: "MWST/TVA/IVA",
        tinName: "Mehrwertsteuernummer",
        officialLanguageCode: "de",
        officialLanguageNameEn: "German",
        officialLanguageNameLocal: "Deutsch",
        countryCallingCode: "41",
        areaCodes: [],
        region: "Europe",
        flag: "\uD83C\uDDE8\uD83C\uDDED"
    },
    {
        countryNameEn: "C\xf4te d'Ivoire",
        countryNameLocal: "C\xf4te d'Ivoire",
        countryCode: "CI",
        currencyCode: "XOF",
        currencyNameEn: "CFA franc BCEAO",
        tinType: "",
        tinName: "",
        officialLanguageCode: "fr",
        officialLanguageNameEn: "French",
        officialLanguageNameLocal: "Fran\xe7ais",
        countryCallingCode: "225",
        areaCodes: [],
        region: "Africa",
        flag: "\uD83C\uDDE8\uD83C\uDDEE"
    },
    {
        countryNameEn: "Chile",
        countryNameLocal: "Chile",
        countryCode: "CL",
        currencyCode: "CLP",
        currencyNameEn: "Chilean peso",
        tinType: "RUT",
        tinName: "Rol \xdanico Tributario",
        officialLanguageCode: "es",
        officialLanguageNameEn: "Spanish, Castilian",
        officialLanguageNameLocal: "Espa\xf1ol",
        countryCallingCode: "56",
        areaCodes: [],
        region: "South/Latin America",
        flag: "\uD83C\uDDE8\uD83C\uDDF1"
    },
    {
        countryNameEn: "Cameroon",
        countryNameLocal: "Cameroun, Cameroon",
        countryCode: "CM",
        currencyCode: "XAF",
        currencyNameEn: "CFA franc BEAC",
        tinType: "",
        tinName: "",
        officialLanguageCode: "fr",
        officialLanguageNameEn: "French",
        officialLanguageNameLocal: "Fran\xe7ais",
        countryCallingCode: "237",
        areaCodes: [],
        region: "Africa",
        flag: "\uD83C\uDDE8\uD83C\uDDF2"
    },
    {
        countryNameEn: "China",
        countryNameLocal: "\u4E2D\u56FD",
        countryCode: "CN",
        currencyCode: "CNY",
        currencyNameEn: "Renminbi (Chinese) yuan",
        tinType: "",
        tinName: "",
        officialLanguageCode: "zh-hans",
        officialLanguageNameEn: "",
        officialLanguageNameLocal: "",
        countryCallingCode: "86",
        areaCodes: [],
        region: "Asia & Pacific",
        flag: "\uD83C\uDDE8\uD83C\uDDF3"
    },
    {
        countryNameEn: "Colombia",
        countryNameLocal: "Colombia",
        countryCode: "CO",
        currencyCode: "COP",
        currencyNameEn: "Colombian peso",
        tinType: "NIT",
        tinName: "N\xfamero De Identificaci\xf3n Tributaria",
        officialLanguageCode: "es",
        officialLanguageNameEn: "Spanish, Castilian",
        officialLanguageNameLocal: "Espa\xf1ol",
        countryCallingCode: "57",
        areaCodes: [],
        region: "South/Latin America",
        flag: "\uD83C\uDDE8\uD83C\uDDF4"
    },
    {
        countryNameEn: "Costa Rica",
        countryNameLocal: "Costa Rica",
        countryCode: "CR",
        currencyCode: "CRC",
        currencyNameEn: "Costa Rican colon",
        tinType: "",
        tinName: "C\xe9dula Jur\xeddica",
        officialLanguageCode: "es",
        officialLanguageNameEn: "Spanish, Castilian",
        officialLanguageNameLocal: "Espa\xf1ol",
        countryCallingCode: "506",
        areaCodes: [],
        region: "South/Latin America",
        flag: "\uD83C\uDDE8\uD83C\uDDF7"
    },
    {
        countryNameEn: "Cuba",
        countryNameLocal: "Cuba",
        countryCode: "CU",
        currencyCode: "CUC",
        currencyNameEn: "Cuban convertible peso",
        tinType: "",
        tinName: "",
        officialLanguageCode: "es",
        officialLanguageNameEn: "Spanish, Castilian",
        officialLanguageNameLocal: "Espa\xf1ol",
        countryCallingCode: "53",
        areaCodes: [],
        region: "South/Latin America",
        flag: "\uD83C\uDDE8\uD83C\uDDFA"
    },
    {
        countryNameEn: "Cabo Verde",
        countryNameLocal: "Cabo Verde",
        countryCode: "CV",
        currencyCode: "CVE",
        currencyNameEn: "Cape Verdean escudo",
        tinType: "",
        tinName: "",
        officialLanguageCode: "pt",
        officialLanguageNameEn: "Portuguese",
        officialLanguageNameLocal: "Portugu\xeas",
        countryCallingCode: "238",
        areaCodes: [],
        region: "Africa",
        flag: "\uD83C\uDDE8\uD83C\uDDFB"
    },
    {
        countryNameEn: "Cura\xe7ao",
        countryNameLocal: "Cura\xe7ao",
        countryCode: "CW",
        currencyCode: "ANG",
        currencyNameEn: "Netherlands Antillean guilder",
        tinType: "",
        tinName: "",
        officialLanguageCode: "nl",
        officialLanguageNameEn: "Dutch, Flemish",
        officialLanguageNameLocal: "Nederlands, Vlaams",
        countryCallingCode: "599",
        areaCodes: [],
        region: "Unknown",
        flag: "\uD83C\uDDE8\uD83C\uDDFC"
    },
    {
        countryNameEn: "Christmas Island",
        countryNameLocal: "Christmas Island",
        countryCode: "CX",
        currencyCode: "AUD",
        currencyNameEn: "Australian dollar",
        tinType: "",
        tinName: "",
        officialLanguageCode: "en",
        officialLanguageNameEn: "English",
        officialLanguageNameLocal: "English",
        countryCallingCode: "61",
        areaCodes: [],
        region: "Asia & Pacific",
        flag: "\uD83C\uDDE8\uD83C\uDDFD"
    },
    {
        countryNameEn: "Cyprus",
        countryNameLocal: "\u039A\u03CD\u03C0\u03C1\u03BF\u03C2, Kibris",
        countryCode: "CY",
        currencyCode: "EUR",
        currencyNameEn: "Euro",
        tinType: "\u03A6\u03A0\u0391",
        tinName: "\u0391\u03C1\u03B9\u03B8\u03BC\u03CC\u03C2 \u0395\u03B3\u03B3\u03C1\u03B1\u03C6\u03AE\u03C2 \u03A6.\u03A0.\u0391.",
        officialLanguageCode: "el",
        officialLanguageNameEn: "Greek, Modern (1453-)",
        officialLanguageNameLocal: "\u03B5\u03BB\u03BB\u03B7\u03BD\u03B9\u03BA\u03AC",
        countryCallingCode: "357",
        areaCodes: [],
        region: "Europe",
        flag: "\uD83C\uDDE8\uD83C\uDDFE"
    },
    {
        countryNameEn: "Germany",
        countryNameLocal: "Deutschland",
        countryCode: "DE",
        currencyCode: "EUR",
        currencyNameEn: "Euro",
        tinType: "USt-IdNr.",
        tinName: "Umsatzsteuer-Identifikationsnummer",
        officialLanguageCode: "de",
        officialLanguageNameEn: "German",
        officialLanguageNameLocal: "Deutsch",
        countryCallingCode: "49",
        areaCodes: [],
        region: "Europe",
        flag: "\uD83C\uDDE9\uD83C\uDDEA"
    },
    {
        countryNameEn: "Djibouti",
        countryNameLocal: "Djibouti, \u062C\u064A\u0628\u0648\u062A\u064A, Jabuuti, Gabuutih",
        countryCode: "DJ",
        currencyCode: "DJF",
        currencyNameEn: "Djiboutian franc",
        tinType: "",
        tinName: "",
        officialLanguageCode: "fr",
        officialLanguageNameEn: "French",
        officialLanguageNameLocal: "Fran\xe7ais",
        countryCallingCode: "253",
        areaCodes: [],
        region: "Arab States",
        flag: "\uD83C\uDDE9\uD83C\uDDEF"
    },
    {
        countryNameEn: "Denmark",
        countryNameLocal: "Danmark",
        countryCode: "DK",
        currencyCode: "DKK",
        currencyNameEn: "Danish krone",
        tinType: "CVR",
        tinName: "Momsregistreringsnummer",
        officialLanguageCode: "da",
        officialLanguageNameEn: "Danish",
        officialLanguageNameLocal: "dansk",
        countryCallingCode: "45",
        areaCodes: [],
        region: "Europe",
        flag: "\uD83C\uDDE9\uD83C\uDDF0"
    },
    {
        countryNameEn: "Dominica",
        countryNameLocal: "Dominica",
        countryCode: "DM",
        currencyCode: "XCD",
        currencyNameEn: "East Caribbean dollar",
        tinType: "",
        tinName: "",
        officialLanguageCode: "en",
        officialLanguageNameEn: "English",
        officialLanguageNameLocal: "English",
        countryCallingCode: "767",
        areaCodes: [],
        region: "South/Latin America",
        flag: "\uD83C\uDDE9\uD83C\uDDF2"
    },
    {
        countryNameEn: "Algeria",
        countryNameLocal: "\u0627\u0644\u062C\u0632\u0627\u0626\u0631",
        countryCode: "DZ",
        currencyCode: "DZD",
        currencyNameEn: "Algerian dinar",
        tinType: "",
        tinName: "",
        officialLanguageCode: "ar",
        officialLanguageNameEn: "Arabic",
        officialLanguageNameLocal: "\u0627\u0644\u0639\u0631\u0628\u064A\u0629",
        countryCallingCode: "213",
        areaCodes: [],
        region: "Arab States",
        flag: "\uD83C\uDDE9\uD83C\uDDFF"
    },
    {
        countryNameEn: "Ecuador",
        countryNameLocal: "Ecuador",
        countryCode: "EC",
        currencyCode: "USD",
        currencyNameEn: "United States dollar",
        tinType: "RUC",
        tinName: "N\xfamero de Registro Unico de Contribuyentes",
        officialLanguageCode: "es",
        officialLanguageNameEn: "Spanish, Castilian",
        officialLanguageNameLocal: "Espa\xf1ol",
        countryCallingCode: "593",
        areaCodes: [],
        region: "South/Latin America",
        flag: "\uD83C\uDDEA\uD83C\uDDE8"
    },
    {
        countryNameEn: "Estonia",
        countryNameLocal: "Eesti",
        countryCode: "EE",
        currencyCode: "EUR",
        currencyNameEn: "Euro",
        tinType: "KMKR",
        tinName: "K\xe4ibemaksukohustuslase number",
        officialLanguageCode: "et",
        officialLanguageNameEn: "Estonian",
        officialLanguageNameLocal: "eesti, eesti keel",
        countryCallingCode: "372",
        areaCodes: [],
        region: "Europe",
        flag: "\uD83C\uDDEA\uD83C\uDDEA"
    },
    {
        countryNameEn: "Egypt",
        countryNameLocal: "\u0645\u0635\u0631",
        countryCode: "EG",
        currencyCode: "EGP",
        currencyNameEn: "Egyptian pound",
        tinType: "",
        tinName: "",
        officialLanguageCode: "ar",
        officialLanguageNameEn: "Arabic",
        officialLanguageNameLocal: "\u0627\u0644\u0639\u0631\u0628\u064A\u0629",
        countryCallingCode: "20",
        areaCodes: [],
        region: "Arab States",
        flag: "\uD83C\uDDEA\uD83C\uDDEC"
    },
    {
        countryNameEn: "Western Sahara",
        countryNameLocal: "Sahara Occidental",
        countryCode: "EH",
        currencyCode: "MAD",
        currencyNameEn: "Moroccan dirham",
        tinType: "",
        tinName: "",
        officialLanguageCode: "ar",
        officialLanguageNameEn: "Arabic",
        officialLanguageNameLocal: "\u0627\u0644\u0639\u0631\u0628\u064A\u0629",
        countryCallingCode: "212",
        areaCodes: [],
        region: "Africa",
        flag: "\uD83C\uDDEA\uD83C\uDDED"
    },
    {
        countryNameEn: "Eritrea",
        countryNameLocal: "\u12A4\u122D\u1275\u122B, \u0625\u0631\u062A\u0631\u064A\u0627, Eritrea",
        countryCode: "ER",
        currencyCode: "ERN",
        currencyNameEn: "Eritrean nakfa",
        tinType: "",
        tinName: "",
        officialLanguageCode: "ti",
        officialLanguageNameEn: "Tigrinya",
        officialLanguageNameLocal: "\u1275\u130D\u122D\u129B",
        countryCallingCode: "291",
        areaCodes: [],
        region: "Africa",
        flag: "\uD83C\uDDEA\uD83C\uDDF7"
    },
    {
        countryNameEn: "Spain",
        countryNameLocal: "Espa\xf1a",
        countryCode: "ES",
        currencyCode: "EUR",
        currencyNameEn: "Euro",
        tinType: "NIF (CIF)",
        tinName: "N\xfamero de Identificaci\xf3n Fiscal (formerly named C\xf3digo de Identificaci\xf3n Fiscal)",
        officialLanguageCode: "es",
        officialLanguageNameEn: "Spanish, Castilian",
        officialLanguageNameLocal: "Espa\xf1ol",
        countryCallingCode: "34",
        areaCodes: [],
        region: "Europe",
        flag: "\uD83C\uDDEA\uD83C\uDDF8"
    },
    {
        countryNameEn: "Ethiopia",
        countryNameLocal: "\u12A2\u1275\u12EE\u1335\u12EB, Itoophiyaa",
        countryCode: "ET",
        currencyCode: "ETB",
        currencyNameEn: "Ethiopian birr",
        tinType: "",
        tinName: "",
        officialLanguageCode: "am",
        officialLanguageNameEn: "Amharic",
        officialLanguageNameLocal: "\u12A0\u121B\u122D\u129B",
        countryCallingCode: "251",
        areaCodes: [],
        region: "Africa",
        flag: "\uD83C\uDDEA\uD83C\uDDF9"
    },
    {
        countryNameEn: "Finland",
        countryNameLocal: "Suomi",
        countryCode: "FI",
        currencyCode: "EUR",
        currencyNameEn: "Euro",
        tinType: "ALV nro",
        tinName: "Arvonlis\xe4veronumero",
        officialLanguageCode: "fi",
        officialLanguageNameEn: "Finnish",
        officialLanguageNameLocal: "suomi, suomen kieli",
        countryCallingCode: "358",
        areaCodes: [],
        region: "Europe",
        flag: "\uD83C\uDDEB\uD83C\uDDEE"
    },
    {
        countryNameEn: "Fiji",
        countryNameLocal: "Fiji",
        countryCode: "FJ",
        currencyCode: "FJD",
        currencyNameEn: "Fiji dollar",
        tinType: "",
        tinName: "",
        officialLanguageCode: "en",
        officialLanguageNameEn: "English",
        officialLanguageNameLocal: "English",
        countryCallingCode: "679",
        areaCodes: [],
        region: "Asia & Pacific",
        flag: "\uD83C\uDDEB\uD83C\uDDEF"
    },
    {
        countryNameEn: "Micronesia (Federated States of)",
        countryNameLocal: "Micronesia",
        countryCode: "FM",
        currencyCode: "USD",
        currencyNameEn: "United States dollar",
        tinType: "",
        tinName: "",
        officialLanguageCode: "en",
        officialLanguageNameEn: "English",
        officialLanguageNameLocal: "English",
        countryCallingCode: "691",
        areaCodes: [],
        region: "Asia & Pacific",
        flag: "\uD83C\uDDEB\uD83C\uDDF2"
    },
    {
        countryNameEn: "France",
        countryNameLocal: "France",
        countryCode: "FR",
        currencyCode: "EUR",
        currencyNameEn: "Euro",
        tinType: "n\xb0 TVA",
        tinName: "Num\xe9ro d'identification \xe0 la taxe sur la valeur ajout\xe9e / Num\xe9ro de TVA intracommunautaire",
        officialLanguageCode: "fr",
        officialLanguageNameEn: "French",
        officialLanguageNameLocal: "Fran\xe7ais",
        countryCallingCode: "33",
        areaCodes: [],
        region: "Europe",
        flag: "\uD83C\uDDEB\uD83C\uDDF7"
    },
    {
        countryNameEn: "Gabon",
        countryNameLocal: "Gabon",
        countryCode: "GA",
        currencyCode: "XAF",
        currencyNameEn: "CFA franc BEAC",
        tinType: "",
        tinName: "",
        officialLanguageCode: "fr",
        officialLanguageNameEn: "French",
        officialLanguageNameLocal: "Fran\xe7ais",
        countryCallingCode: "241",
        areaCodes: [],
        region: "Africa",
        flag: "\uD83C\uDDEC\uD83C\uDDE6"
    },
    {
        countryNameEn: "Grenada",
        countryNameLocal: "Grenada",
        countryCode: "GD",
        currencyCode: "XCD",
        currencyNameEn: "East Caribbean dollar",
        tinType: "",
        tinName: "",
        officialLanguageCode: "en",
        officialLanguageNameEn: "English",
        officialLanguageNameLocal: "English",
        countryCallingCode: "1473",
        areaCodes: [],
        region: "South/Latin America",
        flag: "\uD83C\uDDEC\uD83C\uDDE9"
    },
    {
        countryNameEn: "Georgia",
        countryNameLocal: "\u10E1\u10D0\u10E5\u10D0\u10E0\u10D7\u10D5\u10D4\u10DA\u10DD",
        countryCode: "GE",
        currencyCode: "GEL",
        currencyNameEn: "Georgian lari",
        tinType: "",
        tinName: "",
        officialLanguageCode: "ka",
        officialLanguageNameEn: "Georgian",
        officialLanguageNameLocal: "\u10E5\u10D0\u10E0\u10D7\u10E3\u10DA\u10D8",
        countryCallingCode: "995",
        areaCodes: [],
        region: "Europe",
        flag: "\uD83C\uDDEC\uD83C\uDDEA"
    },
    {
        countryNameEn: "French Guiana",
        countryNameLocal: "Guyane fran\xe7aise",
        countryCode: "GF",
        currencyCode: "EUR",
        currencyNameEn: "Euro",
        tinType: "",
        tinName: "",
        officialLanguageCode: "fr",
        officialLanguageNameEn: "French",
        officialLanguageNameLocal: "Fran\xe7ais",
        countryCallingCode: "594",
        areaCodes: [],
        region: "South/Latin America",
        flag: "\uD83C\uDDEC\uD83C\uDDEB"
    },
    {
        countryNameEn: "Guernsey",
        countryNameLocal: "Guernsey",
        countryCode: "GG",
        currencyCode: "GBP",
        currencyNameEn: "Pound sterling",
        tinType: "",
        tinName: "",
        officialLanguageCode: "en",
        officialLanguageNameEn: "English",
        officialLanguageNameLocal: "English",
        countryCallingCode: "44",
        areaCodes: [],
        region: "Europe",
        flag: "\uD83C\uDDEC\uD83C\uDDEC"
    },
    {
        countryNameEn: "Ghana",
        countryNameLocal: "Ghana",
        countryCode: "GH",
        currencyCode: "GHS",
        currencyNameEn: "Ghanaian cedi",
        tinType: "",
        tinName: "",
        officialLanguageCode: "en",
        officialLanguageNameEn: "English",
        officialLanguageNameLocal: "English",
        countryCallingCode: "233",
        areaCodes: [],
        region: "Africa",
        flag: "\uD83C\uDDEC\uD83C\uDDED"
    },
    {
        countryNameEn: "Gibraltar",
        countryNameLocal: "Gibraltar",
        countryCode: "GI",
        currencyCode: "GIP",
        currencyNameEn: "Gibraltar pound",
        tinType: "",
        tinName: "",
        officialLanguageCode: "en",
        officialLanguageNameEn: "English",
        officialLanguageNameLocal: "English",
        countryCallingCode: "350",
        areaCodes: [],
        region: "Europe",
        flag: "\uD83C\uDDEC\uD83C\uDDEE"
    },
    {
        countryNameEn: "Greenland",
        countryNameLocal: "Kalaallit Nunaat, Gr\xf8nland",
        countryCode: "GL",
        currencyCode: "DKK",
        currencyNameEn: "Danish krone",
        tinType: "",
        tinName: "",
        officialLanguageCode: "kl",
        officialLanguageNameEn: "Kalaallisut, Greenlandic",
        officialLanguageNameLocal: "kalaallisut, kalaallit oqaasii",
        countryCallingCode: "299",
        areaCodes: [],
        region: "Europe",
        flag: "\uD83C\uDDEC\uD83C\uDDF1"
    },
    {
        countryNameEn: "Guinea",
        countryNameLocal: "Guin\xe9e",
        countryCode: "GN",
        currencyCode: "GNF",
        currencyNameEn: "Guinean franc",
        tinType: "",
        tinName: "",
        officialLanguageCode: "fr",
        officialLanguageNameEn: "French",
        officialLanguageNameLocal: "Fran\xe7ais",
        countryCallingCode: "224",
        areaCodes: [],
        region: "Africa",
        flag: "\uD83C\uDDEC\uD83C\uDDF3"
    },
    {
        countryNameEn: "Guadeloupe",
        countryNameLocal: "Guadeloupe",
        countryCode: "GP",
        currencyCode: "EUR",
        currencyNameEn: "Euro",
        tinType: "",
        tinName: "",
        officialLanguageCode: "fr",
        officialLanguageNameEn: "French",
        officialLanguageNameLocal: "Fran\xe7ais",
        countryCallingCode: "590",
        areaCodes: [],
        region: "South/Latin America",
        flag: "\uD83C\uDDEC\uD83C\uDDF5"
    },
    {
        countryNameEn: "Equatorial Guinea",
        countryNameLocal: "Guiena ecuatorial, Guin\xe9e \xe9quatoriale, Guin\xe9 Equatorial",
        countryCode: "GQ",
        currencyCode: "XAF",
        currencyNameEn: "CFA franc BEAC",
        tinType: "",
        tinName: "",
        officialLanguageCode: "es",
        officialLanguageNameEn: "Spanish, Castilian",
        officialLanguageNameLocal: "Espa\xf1ol",
        countryCallingCode: "240",
        areaCodes: [],
        region: "Africa",
        flag: "\uD83C\uDDEC\uD83C\uDDF6"
    },
    {
        countryNameEn: "Greece",
        countryNameLocal: "\u0395\u03BB\u03BB\u03AC\u03B4\u03B1",
        countryCode: "GR",
        currencyCode: "EUR",
        currencyNameEn: "Euro",
        tinType: "",
        tinName: "",
        officialLanguageCode: "el",
        officialLanguageNameEn: "Greek, Modern (1453-)",
        officialLanguageNameLocal: "\u03B5\u03BB\u03BB\u03B7\u03BD\u03B9\u03BA\u03AC",
        countryCallingCode: "30",
        areaCodes: [],
        region: "Europe",
        flag: "\uD83C\uDDEC\uD83C\uDDF7"
    },
    {
        countryNameEn: "South Georgia and the South Sandwich Islands",
        countryNameLocal: "South Georgia and the South Sandwich Islands",
        countryCode: "GS",
        currencyCode: "",
        currencyNameEn: "",
        tinType: "",
        tinName: "",
        officialLanguageCode: "en",
        officialLanguageNameEn: "English",
        officialLanguageNameLocal: "English",
        countryCallingCode: "500",
        areaCodes: [],
        region: "South/Latin America",
        flag: "\uD83C\uDDEC\uD83C\uDDF8"
    },
    {
        countryNameEn: "Guatemala",
        countryNameLocal: "Guatemala",
        countryCode: "GT",
        currencyCode: "GTQ",
        currencyNameEn: "Guatemalan quetzal",
        tinType: "NIT",
        tinName: "N\xfamero de Identificaci\xf3n Tributaria",
        officialLanguageCode: "es",
        officialLanguageNameEn: "Spanish, Castilian",
        officialLanguageNameLocal: "Espa\xf1ol",
        countryCallingCode: "502",
        areaCodes: [],
        region: "South/Latin America",
        flag: "\uD83C\uDDEC\uD83C\uDDF9"
    },
    {
        countryNameEn: "Guam",
        countryNameLocal: "Guam, Gu\xe5h\xe5n",
        countryCode: "GU",
        currencyCode: "USD",
        currencyNameEn: "United States dollar",
        tinType: "",
        tinName: "",
        officialLanguageCode: "en",
        officialLanguageNameEn: "English",
        officialLanguageNameLocal: "English",
        countryCallingCode: "1",
        areaCodes: [],
        region: "Asia & Pacific",
        flag: "\uD83C\uDDEC\uD83C\uDDFA"
    },
    {
        countryNameEn: "Guinea-Bissau",
        countryNameLocal: "Guin\xe9-Bissau",
        countryCode: "GW",
        currencyCode: "XOF",
        currencyNameEn: "CFA franc BCEAO",
        tinType: "",
        tinName: "",
        officialLanguageCode: "pt",
        officialLanguageNameEn: "Portuguese",
        officialLanguageNameLocal: "Portugu\xeas",
        countryCallingCode: "245",
        areaCodes: [],
        region: "Africa",
        flag: "\uD83C\uDDEC\uD83C\uDDFC"
    },
    {
        countryNameEn: "Guyana",
        countryNameLocal: "Guyana",
        countryCode: "GY",
        currencyCode: "GYD",
        currencyNameEn: "Guyanese dollar",
        tinType: "",
        tinName: "",
        officialLanguageCode: "en",
        officialLanguageNameEn: "English",
        officialLanguageNameLocal: "English",
        countryCallingCode: "592",
        areaCodes: [],
        region: "South/Latin America",
        flag: "\uD83C\uDDEC\uD83C\uDDFE"
    },
    {
        countryNameEn: "Hong Kong",
        countryNameLocal: "\u9999\u6E2F, Hong Kong",
        countryCode: "HK",
        currencyCode: "HKD",
        currencyNameEn: "Hong Kong dollar",
        tinType: "",
        tinName: "",
        officialLanguageCode: "zh-hant",
        officialLanguageNameEn: "",
        officialLanguageNameLocal: "",
        countryCallingCode: "852",
        areaCodes: [],
        region: "Asia & Pacific",
        flag: "\uD83C\uDDED\uD83C\uDDF0"
    },
    {
        countryNameEn: "Honduras",
        countryNameLocal: "Honduras",
        countryCode: "HN",
        currencyCode: "HNL",
        currencyNameEn: "Honduran lempira",
        tinType: "RTN",
        tinName: "Registro Tributario Nacional",
        officialLanguageCode: "es",
        officialLanguageNameEn: "Spanish, Castilian",
        officialLanguageNameLocal: "Espa\xf1ol",
        countryCallingCode: "504",
        areaCodes: [],
        region: "South/Latin America",
        flag: "\uD83C\uDDED\uD83C\uDDF3"
    },
    {
        countryNameEn: "Croatia",
        countryNameLocal: "Hrvatska",
        countryCode: "HR",
        currencyCode: "HRK",
        currencyNameEn: "Croatian kuna",
        tinType: "PDV-ID; OIB",
        tinName: "PDV Id. Broj OIB",
        officialLanguageCode: "hr",
        officialLanguageNameEn: "Croatian",
        officialLanguageNameLocal: "hrvatski jezik",
        countryCallingCode: "385",
        areaCodes: [],
        region: "Europe",
        flag: "\uD83C\uDDED\uD83C\uDDF7"
    },
    {
        countryNameEn: "Haiti",
        countryNameLocal: "Ha\xefti, Ayiti",
        countryCode: "HT",
        currencyCode: "HTG",
        currencyNameEn: "Haitian gourde",
        tinType: "",
        tinName: "",
        officialLanguageCode: "fr",
        officialLanguageNameEn: "French",
        officialLanguageNameLocal: "Fran\xe7ais",
        countryCallingCode: "509",
        areaCodes: [],
        region: "South/Latin America",
        flag: "\uD83C\uDDED\uD83C\uDDF9"
    },
    {
        countryNameEn: "Hungary",
        countryNameLocal: "Magyarorsz\xe1g",
        countryCode: "HU",
        currencyCode: "HUF",
        currencyNameEn: "Hungarian forint",
        tinType: "ANUM",
        tinName: "K\xf6z\xf6ss\xe9gi ad\xf3sz\xe1m",
        officialLanguageCode: "hu",
        officialLanguageNameEn: "Hungarian",
        officialLanguageNameLocal: "magyar",
        countryCallingCode: "36",
        areaCodes: [],
        region: "Europe",
        flag: "\uD83C\uDDED\uD83C\uDDFA"
    },
    {
        countryNameEn: "Indonesia",
        countryNameLocal: "Indonesia",
        countryCode: "ID",
        currencyCode: "IDR",
        currencyNameEn: "Indonesian rupiah",
        tinType: "NPWP",
        tinName: "Nomor Pokok Wajib Pajak",
        officialLanguageCode: "id",
        officialLanguageNameEn: "Indonesian",
        officialLanguageNameLocal: "Bahasa Indonesia",
        countryCallingCode: "62",
        areaCodes: [],
        region: "Asia & Pacific",
        flag: "\uD83C\uDDEE\uD83C\uDDE9"
    },
    {
        countryNameEn: "Ireland",
        countryNameLocal: "Ireland, \xc9ire",
        countryCode: "IE",
        currencyCode: "EUR",
        currencyNameEn: "Euro",
        tinType: "VAT or CBL",
        tinName: "Value added tax identification no.",
        officialLanguageCode: "en",
        officialLanguageNameEn: "English",
        officialLanguageNameLocal: "English",
        countryCallingCode: "353",
        areaCodes: [],
        region: "Europe",
        flag: "\uD83C\uDDEE\uD83C\uDDEA"
    },
    {
        countryNameEn: "Israel",
        countryNameLocal: "\u05D9\u05E9\u05E8\u05D0\u05DC",
        countryCode: "IL",
        currencyCode: "ILS",
        currencyNameEn: "Israeli new shekel",
        tinType: "",
        tinName: "\u05DE\u05E1' \u05E2\u05D5\u05E1\u05E7 \u05DE\u05D5\u05E8\u05E9\u05D4 / \u05D7\"\u05E4",
        officialLanguageCode: "he",
        officialLanguageNameEn: "Hebrew",
        officialLanguageNameLocal: "\u05E2\u05D1\u05E8\u05D9\u05EA",
        countryCallingCode: "972",
        areaCodes: [],
        region: "Europe",
        flag: "\uD83C\uDDEE\uD83C\uDDF1"
    },
    {
        countryNameEn: "Isle of Man",
        countryNameLocal: "Isle of Man",
        countryCode: "IM",
        currencyCode: "GBP",
        currencyNameEn: "Pound sterling",
        tinType: "",
        tinName: "",
        officialLanguageCode: "en",
        officialLanguageNameEn: "English",
        officialLanguageNameLocal: "English",
        countryCallingCode: "44",
        areaCodes: [],
        region: "Europe",
        flag: "\uD83C\uDDEE\uD83C\uDDF2"
    },
    {
        countryNameEn: "India",
        countryNameLocal: "\u092D\u093E\u0930\u0924, India",
        countryCode: "IN",
        currencyCode: "INR",
        currencyNameEn: "Indian rupee",
        tinType: "VAT TIN / CST TIN",
        tinName: "Value Added Tax - Taxpayer Identification Number / Central Sales Tax - Taxpayer Identification Number (In most states)Not applicable",
        officialLanguageCode: "hi",
        officialLanguageNameEn: "Hindi",
        officialLanguageNameLocal: "\u0939\u093F\u0928\u094D\u0926\u0940, \u0939\u093F\u0902\u0926\u0940",
        countryCallingCode: "91",
        areaCodes: [],
        region: "Asia & Pacific",
        flag: "\uD83C\uDDEE\uD83C\uDDF3"
    },
    {
        countryNameEn: "British Indian Ocean Territories",
        countryNameLocal: "British Indian Ocean Territories",
        countryCode: "IO",
        currencyCode: "USD",
        currencyNameEn: "United States dollar",
        tinType: "",
        tinName: "",
        officialLanguageCode: "en",
        officialLanguageNameEn: "English",
        officialLanguageNameLocal: "English",
        countryCallingCode: "246",
        areaCodes: [],
        region: "Indian Ocean",
        flag: "\uD83C\uDDEE\uD83C\uDDF4"
    },
    {
        countryNameEn: "Iraq",
        countryNameLocal: "\u0627\u0644\u0639\u0631\u0627\u0642, Iraq",
        countryCode: "IQ",
        currencyCode: "IQD",
        currencyNameEn: "Iraqi dinar",
        tinType: "",
        tinName: "",
        officialLanguageCode: "ar",
        officialLanguageNameEn: "Arabic",
        officialLanguageNameLocal: "\u0627\u0644\u0639\u0631\u0628\u064A\u0629",
        countryCallingCode: "964",
        areaCodes: [],
        region: "Arab States",
        flag: "\uD83C\uDDEE\uD83C\uDDF6"
    },
    {
        countryNameEn: "Iran (Islamic Republic of)",
        countryNameLocal: "\u0627\u06CC\u0631\u0627\u0646",
        countryCode: "IR",
        currencyCode: "IRR",
        currencyNameEn: "Iranian rial",
        tinType: "",
        tinName: "",
        officialLanguageCode: "fa",
        officialLanguageNameEn: "Persian",
        officialLanguageNameLocal: "\u0641\u0627\u0631\u0633\u06CC",
        countryCallingCode: "98",
        areaCodes: [],
        region: "Asia & Pacific",
        flag: "\uD83C\uDDEE\uD83C\uDDF7"
    },
    {
        countryNameEn: "Iceland",
        countryNameLocal: "\xcdsland",
        countryCode: "IS",
        currencyCode: "ISK",
        currencyNameEn: "Icelandic kr\xf3na",
        tinType: "VSK / VASK",
        tinName: "Vir\xf0isaukaskattsn\xfamer",
        officialLanguageCode: "is",
        officialLanguageNameEn: "Icelandic",
        officialLanguageNameLocal: "\xcdslenska",
        countryCallingCode: "354",
        areaCodes: [],
        region: "Europe",
        flag: "\uD83C\uDDEE\uD83C\uDDF8"
    },
    {
        countryNameEn: "Italy",
        countryNameLocal: "Italia",
        countryCode: "IT",
        currencyCode: "EUR",
        currencyNameEn: "Euro",
        tinType: "P.IVA",
        tinName: "Partita IVA(IVA = Imposta sul Valore Aggiunto)",
        officialLanguageCode: "it",
        officialLanguageNameEn: "Italian",
        officialLanguageNameLocal: "Italiano",
        countryCallingCode: "39",
        areaCodes: [],
        region: "Europe",
        flag: "\uD83C\uDDEE\uD83C\uDDF9"
    },
    {
        countryNameEn: "Jersey",
        countryNameLocal: "Jersey",
        countryCode: "JE",
        currencyCode: "GBP",
        currencyNameEn: "Pound sterling",
        tinType: "",
        tinName: "",
        officialLanguageCode: "en",
        officialLanguageNameEn: "English",
        officialLanguageNameLocal: "English",
        countryCallingCode: "44",
        areaCodes: [],
        region: "Europe",
        flag: "\uD83C\uDDEF\uD83C\uDDEA"
    },
    {
        countryNameEn: "Jamaica",
        countryNameLocal: "Jamaica",
        countryCode: "JM",
        currencyCode: "JMD",
        currencyNameEn: "Jamaican dollar",
        tinType: "",
        tinName: "",
        officialLanguageCode: "en",
        officialLanguageNameEn: "English",
        officialLanguageNameLocal: "English",
        countryCallingCode: "876",
        areaCodes: [],
        region: "South/Latin America",
        flag: "\uD83C\uDDEF\uD83C\uDDF2"
    },
    {
        countryNameEn: "Jordan",
        countryNameLocal: "\u0627\u0644\u0623\u064F\u0631\u0652\u062F\u064F\u0646",
        countryCode: "JO",
        currencyCode: "JOD",
        currencyNameEn: "Jordanian dinar",
        tinType: "",
        tinName: "",
        officialLanguageCode: "ar",
        officialLanguageNameEn: "Arabic",
        officialLanguageNameLocal: "\u0627\u0644\u0639\u0631\u0628\u064A\u0629",
        countryCallingCode: "962",
        areaCodes: [],
        region: "Arab States",
        flag: "\uD83C\uDDEF\uD83C\uDDF4"
    },
    {
        countryNameEn: "Japan",
        countryNameLocal: "\u65E5\u672C",
        countryCode: "JP",
        currencyCode: "JPY",
        currencyNameEn: "Japanese yen",
        tinType: "",
        tinName: "",
        officialLanguageCode: "ja",
        officialLanguageNameEn: "Japanese",
        officialLanguageNameLocal: "\u65E5\u672C\u8A9E (\u306B\u307B\u3093\u3054)",
        countryCallingCode: "81",
        areaCodes: [],
        region: "Asia & Pacific",
        flag: "\uD83C\uDDEF\uD83C\uDDF5"
    },
    {
        countryNameEn: "Kenya",
        countryNameLocal: "Kenya",
        countryCode: "KE",
        currencyCode: "KES",
        currencyNameEn: "Kenyan shilling",
        tinType: "",
        tinName: "",
        officialLanguageCode: "sw",
        officialLanguageNameEn: "Swahili",
        officialLanguageNameLocal: "Kiswahili",
        countryCallingCode: "254",
        areaCodes: [],
        region: "Africa",
        flag: "\uD83C\uDDF0\uD83C\uDDEA"
    },
    {
        countryNameEn: "Kyrgyzstan",
        countryNameLocal: "\u041A\u044B\u0440\u0433\u044B\u0437\u0441\u0442\u0430\u043D, \u041A\u0438\u0440\u0433\u0438\u0437\u0438\u044F",
        countryCode: "KG",
        currencyCode: "KGS",
        currencyNameEn: "Kyrgyzstani som",
        tinType: "",
        tinName: "",
        officialLanguageCode: "ky",
        officialLanguageNameEn: "Kirghiz, Kyrgyz",
        officialLanguageNameLocal: "\u041A\u044B\u0440\u0433\u044B\u0437\u0447\u0430, \u041A\u044B\u0440\u0433\u044B\u0437 \u0442\u0438\u043B\u0438",
        countryCallingCode: "996",
        areaCodes: [],
        region: "Asia & Pacific",
        flag: "\uD83C\uDDF0\uD83C\uDDEC"
    },
    {
        countryNameEn: "Cambodia",
        countryNameLocal: "\u1780\u1798\u17D2\u1796\u17BB\u1787\u17B6",
        countryCode: "KH",
        currencyCode: "KHR",
        currencyNameEn: "Cambodian riel",
        tinType: "",
        tinName: "",
        officialLanguageCode: "km",
        officialLanguageNameEn: "Central Khmer",
        officialLanguageNameLocal: "\u1781\u17D2\u1798\u17C2\u179A, \u1781\u17C1\u1798\u179A\u1797\u17B6\u179F\u17B6, \u1797\u17B6\u179F\u17B6\u1781\u17D2\u1798\u17C2\u179A",
        countryCallingCode: "855",
        areaCodes: [],
        region: "Asia & Pacific",
        flag: "\uD83C\uDDF0\uD83C\uDDED"
    },
    {
        countryNameEn: "North Korea",
        countryNameLocal: "\uC870\uC120\uBBFC\uC8FC\uC8FC\uC758\uC778\uBBFC\uACF5\uD654\uAD6D",
        countryCode: "KP",
        currencyCode: "KPW",
        currencyNameEn: "North Korean won",
        tinType: "",
        tinName: "",
        officialLanguageCode: "ko",
        officialLanguageNameEn: "Korean",
        officialLanguageNameLocal: "\uC870\uC120\uC5B4",
        countryCallingCode: "850",
        areaCodes: [],
        region: "Asia",
        flag: "\uD83C\uDDF0\uD83C\uDDF5"
    },
    {
        countryNameEn: "South Korea",
        countryNameLocal: "\uB300\uD55C\uBBFC\uAD6D",
        countryCode: "KR",
        currencyCode: "KRW",
        currencyNameEn: "South Korean won",
        tinType: "",
        tinName: "",
        officialLanguageCode: "ko",
        officialLanguageNameEn: "Korean",
        officialLanguageNameLocal: "\uD55C\uAD6D\uC5B4",
        countryCallingCode: "82",
        areaCodes: [],
        region: "Asia",
        flag: "\uD83C\uDDF0\uD83C\uDDF7"
    },
    {
        countryNameEn: "Kiribati",
        countryNameLocal: "Kiribati",
        countryCode: "KI",
        currencyCode: "AUD",
        currencyNameEn: "Australian dollar",
        tinType: "",
        tinName: "",
        officialLanguageCode: "en",
        officialLanguageNameEn: "English",
        officialLanguageNameLocal: "English",
        countryCallingCode: "686",
        areaCodes: [],
        region: "Asia & Pacific",
        flag: "\uD83C\uDDF0\uD83C\uDDEE"
    },
    {
        countryNameEn: "Saint Kitts and Nevis",
        countryNameLocal: "Saint Kitts and Nevis",
        countryCode: "KN",
        currencyCode: "XCD",
        currencyNameEn: "East Caribbean dollar",
        tinType: "",
        tinName: "",
        officialLanguageCode: "en",
        officialLanguageNameEn: "English",
        officialLanguageNameLocal: "English",
        countryCallingCode: "1869",
        areaCodes: [],
        region: "South/Latin America",
        flag: "\uD83C\uDDF0\uD83C\uDDF3"
    },
    {
        countryNameEn: "Kuwait",
        countryNameLocal: "\u0627\u0644\u0643\u0648\u064A\u062A",
        countryCode: "KW",
        currencyCode: "KWD",
        currencyNameEn: "Kuwaiti dinar",
        tinType: "",
        tinName: "",
        officialLanguageCode: "ar",
        officialLanguageNameEn: "Arabic",
        officialLanguageNameLocal: "\u0627\u0644\u0639\u0631\u0628\u064A\u0629",
        countryCallingCode: "965",
        areaCodes: [],
        region: "Arab States",
        flag: "\uD83C\uDDF0\uD83C\uDDFC"
    },
    {
        countryNameEn: "Kazakhstan",
        countryNameLocal: "\u049A\u0430\u0437\u0430\u049B\u0441\u0442\u0430\u043D, \u041A\u0430\u0437\u0430\u0445\u0441\u0442\u0430\u043D",
        countryCode: "KZ",
        currencyCode: "KZT",
        currencyNameEn: "Kazakhstani tenge",
        tinType: "",
        tinName: "",
        officialLanguageCode: "kk",
        officialLanguageNameEn: "Kazakh",
        officialLanguageNameLocal: "\u049B\u0430\u0437\u0430\u049B \u0442\u0456\u043B\u0456",
        countryCallingCode: "7",
        areaCodes: [],
        region: "Asia & Pacific",
        flag: "\uD83C\uDDF0\uD83C\uDDFF"
    },
    {
        countryNameEn: "Lebanon",
        countryNameLocal: "\u0644\u0628\u0646\u0627\u0646, Liban",
        countryCode: "LB",
        currencyCode: "LBP",
        currencyNameEn: "Lebanese pound",
        tinType: "",
        tinName: "",
        officialLanguageCode: "ar",
        officialLanguageNameEn: "Arabic",
        officialLanguageNameLocal: "\u0627\u0644\u0639\u0631\u0628\u064A\u0629",
        countryCallingCode: "961",
        areaCodes: [],
        region: "Arab States",
        flag: "\uD83C\uDDF1\uD83C\uDDE7"
    },
    {
        countryNameEn: "Saint Lucia",
        countryNameLocal: "Saint Lucia",
        countryCode: "LC",
        currencyCode: "XCD",
        currencyNameEn: "East Caribbean dollar",
        tinType: "",
        tinName: "",
        officialLanguageCode: "en",
        officialLanguageNameEn: "English",
        officialLanguageNameLocal: "English",
        countryCallingCode: "1758",
        areaCodes: [],
        region: "South/Latin America",
        flag: "\uD83C\uDDF1\uD83C\uDDE8"
    },
    {
        countryNameEn: "Liechtenstein",
        countryNameLocal: "Liechtenstein",
        countryCode: "LI",
        currencyCode: "CHF",
        currencyNameEn: "Swiss franc",
        tinType: "",
        tinName: "",
        officialLanguageCode: "de",
        officialLanguageNameEn: "German",
        officialLanguageNameLocal: "Deutsch",
        countryCallingCode: "423",
        areaCodes: [],
        region: "Europe",
        flag: "\uD83C\uDDF1\uD83C\uDDEE"
    },
    {
        countryNameEn: "Sri Lanka",
        countryNameLocal: "\u0DC1\u0DCA\u200D\u0DBB\u0DD3 \u0DBD\u0D82\u0D9A\u0DCF, \u0B87\u0BB2\u0B99\u0BCD\u0B95\u0BC8",
        countryCode: "LK",
        currencyCode: "LKR",
        currencyNameEn: "Sri Lankan rupee",
        tinType: "",
        tinName: "",
        officialLanguageCode: "si",
        officialLanguageNameEn: "Sinhala, Sinhalese",
        officialLanguageNameLocal: "\u0DC3\u0DD2\u0D82\u0DC4\u0DBD",
        countryCallingCode: "94",
        areaCodes: [],
        region: "Asia & Pacific",
        flag: "\uD83C\uDDF1\uD83C\uDDF0"
    },
    {
        countryNameEn: "Liberia",
        countryNameLocal: "Liberia",
        countryCode: "LR",
        currencyCode: "LRD",
        currencyNameEn: "Liberian dollar",
        tinType: "",
        tinName: "",
        officialLanguageCode: "en",
        officialLanguageNameEn: "English",
        officialLanguageNameLocal: "English",
        countryCallingCode: "231",
        areaCodes: [],
        region: "Africa",
        flag: "\uD83C\uDDF1\uD83C\uDDF7"
    },
    {
        countryNameEn: "Lesotho",
        countryNameLocal: "Lesotho",
        countryCode: "LS",
        currencyCode: "LSL",
        currencyNameEn: "Lesotho loti",
        tinType: "",
        tinName: "",
        officialLanguageCode: "en",
        officialLanguageNameEn: "English",
        officialLanguageNameLocal: "English",
        countryCallingCode: "266",
        areaCodes: [],
        region: "Africa",
        flag: "\uD83C\uDDF1\uD83C\uDDF8"
    },
    {
        countryNameEn: "Lithuania",
        countryNameLocal: "Lietuva",
        countryCode: "LT",
        currencyCode: "EUR",
        currencyNameEn: "Euro",
        tinType: "PVM kodas",
        tinName: "PVM (abbrev. Prid\u0117tin\u0117s vert\u0117s mokestis) mok\u0117tojo kodas",
        officialLanguageCode: "lt",
        officialLanguageNameEn: "Lithuanian",
        officialLanguageNameLocal: "lietuvi\u0173 kalba",
        countryCallingCode: "370",
        areaCodes: [],
        region: "Europe",
        flag: "\uD83C\uDDF1\uD83C\uDDF9"
    },
    {
        countryNameEn: "Luxembourg",
        countryNameLocal: "L\xebtzebuerg, Luxembourg, Luxemburg",
        countryCode: "LU",
        currencyCode: "EUR",
        currencyNameEn: "Euro",
        tinType: "No. TVA",
        tinName: "Num\xe9ro d'identification \xe0 la taxe sur la valeur ajout\xe9e",
        officialLanguageCode: "lb",
        officialLanguageNameEn: "Luxembourgish, Letzeburgesch",
        officialLanguageNameLocal: "L\xebtzebuergesch",
        countryCallingCode: "352",
        areaCodes: [],
        region: "Europe",
        flag: "\uD83C\uDDF1\uD83C\uDDFA"
    },
    {
        countryNameEn: "Latvia",
        countryNameLocal: "Latvija",
        countryCode: "LV",
        currencyCode: "EUR",
        currencyNameEn: "Euro",
        tinType: "PVN",
        tinName: "Pievienot\u0101s v\u0113rt\u012Bbas nodok\u013Ca (PVN) re\u0123istr\u0101cijas numurs",
        officialLanguageCode: "lv",
        officialLanguageNameEn: "Latvian",
        officialLanguageNameLocal: "latvie\u0161u valoda",
        countryCallingCode: "371",
        areaCodes: [],
        region: "Europe",
        flag: "\uD83C\uDDF1\uD83C\uDDFB"
    },
    {
        countryNameEn: "Libya",
        countryNameLocal: "\u0644\u064A\u0628\u064A\u0627",
        countryCode: "LY",
        currencyCode: "LYD",
        currencyNameEn: "Libyan dinar",
        tinType: "",
        tinName: "",
        officialLanguageCode: "ar",
        officialLanguageNameEn: "Arabic",
        officialLanguageNameLocal: "\u0627\u0644\u0639\u0631\u0628\u064A\u0629",
        countryCallingCode: "218",
        areaCodes: [],
        region: "Arab States",
        flag: "\uD83C\uDDF1\uD83C\uDDFE"
    },
    {
        countryNameEn: "Morocco",
        countryNameLocal: "Maroc, \u2D4D\u2D4E\u2D56\u2D54\u2D49\u2D31, \u0627\u0644\u0645\u063A\u0631\u0628",
        countryCode: "MA",
        currencyCode: "MAD",
        currencyNameEn: "Moroccan dirham",
        tinType: "",
        tinName: "",
        officialLanguageCode: "fr",
        officialLanguageNameEn: "French",
        officialLanguageNameLocal: "Fran\xe7ais",
        countryCallingCode: "212",
        areaCodes: [],
        region: "Arab States",
        flag: "\uD83C\uDDF2\uD83C\uDDE6"
    },
    {
        countryNameEn: "Monaco",
        countryNameLocal: "Monaco",
        countryCode: "MC",
        currencyCode: "EUR",
        currencyNameEn: "Euro",
        tinType: "",
        tinName: "",
        officialLanguageCode: "fr",
        officialLanguageNameEn: "French",
        officialLanguageNameLocal: "Fran\xe7ais",
        countryCallingCode: "377",
        areaCodes: [],
        region: "Europe",
        flag: "\uD83C\uDDF2\uD83C\uDDE8"
    },
    {
        countryNameEn: "Montenegro",
        countryNameLocal: "Crna Gora, \u0426\u0440\u043D\u0430 \u0413\u043E\u0440\u0430",
        countryCode: "ME",
        currencyCode: "EUR",
        currencyNameEn: "Euro",
        tinType: "",
        tinName: "",
        officialLanguageCode: "srp",
        officialLanguageNameEn: "\u0441\u0440\u043F\u0441\u043A\u0438 \u0458\u0435\u0437\u0438\u043A",
        officialLanguageNameLocal: "",
        countryCallingCode: "382",
        areaCodes: [],
        region: "Europe",
        flag: "\uD83C\uDDF2\uD83C\uDDEA"
    },
    {
        countryNameEn: "Saint Martin (French part)",
        countryNameLocal: "Saint-Martin",
        countryCode: "MF",
        currencyCode: "EUR",
        currencyNameEn: "Euro",
        tinType: "",
        tinName: "",
        officialLanguageCode: "fr",
        officialLanguageNameEn: "French",
        officialLanguageNameLocal: "Fran\xe7ais",
        countryCallingCode: "590",
        areaCodes: [],
        region: "South/Latin America",
        flag: "\uD83C\uDDF2\uD83C\uDDEB"
    },
    {
        countryNameEn: "Madagascar",
        countryNameLocal: "Madagasikara, Madagascar",
        countryCode: "MG",
        currencyCode: "MGA",
        currencyNameEn: "Malagasy ariary",
        tinType: "",
        tinName: "",
        officialLanguageCode: "mg",
        officialLanguageNameEn: "Malagasy",
        officialLanguageNameLocal: "fiteny malagasy",
        countryCallingCode: "261",
        areaCodes: [],
        region: "Africa",
        flag: "\uD83C\uDDF2\uD83C\uDDEC"
    },
    {
        countryNameEn: "Mali",
        countryNameLocal: "Mali",
        countryCode: "ML",
        currencyCode: "XOF",
        currencyNameEn: "CFA franc BCEAO",
        tinType: "",
        tinName: "",
        officialLanguageCode: "fr",
        officialLanguageNameEn: "French",
        officialLanguageNameLocal: "Fran\xe7ais",
        countryCallingCode: "223",
        areaCodes: [],
        region: "Africa",
        flag: "\uD83C\uDDF2\uD83C\uDDF1"
    },
    {
        countryNameEn: "Myanmar",
        countryNameLocal: "\u1019\u103C\u1014\u103A\u1019\u102C",
        countryCode: "MM",
        currencyCode: "MMK",
        currencyNameEn: "Myanmar kyat",
        tinType: "",
        tinName: "",
        officialLanguageCode: "my",
        officialLanguageNameEn: "Burmese",
        officialLanguageNameLocal: "\u1017\u1019\u102C\u1005\u102C",
        countryCallingCode: "95",
        areaCodes: [],
        region: "Asia & Pacific",
        flag: "\uD83C\uDDF2\uD83C\uDDF2"
    },
    {
        countryNameEn: "Mongolia",
        countryNameLocal: "\u041C\u043E\u043D\u0433\u043E\u043B \u0423\u043B\u0441",
        countryCode: "MN",
        currencyCode: "MNT",
        currencyNameEn: "Mongolian t\xf6gr\xf6g",
        tinType: "",
        tinName: "",
        officialLanguageCode: "mn",
        officialLanguageNameEn: "Mongolian",
        officialLanguageNameLocal: "\u041C\u043E\u043D\u0433\u043E\u043B \u0445\u044D\u043B",
        countryCallingCode: "976",
        areaCodes: [],
        region: "Asia & Pacific",
        flag: "\uD83C\uDDF2\uD83C\uDDF3"
    },
    {
        countryNameEn: "Macao",
        countryNameLocal: "\u6FB3\u9580, Macau",
        countryCode: "MO",
        currencyCode: "MOP",
        currencyNameEn: "Macanese pataca",
        tinType: "",
        tinName: "",
        officialLanguageCode: "zh-hant",
        officialLanguageNameEn: "",
        officialLanguageNameLocal: "",
        countryCallingCode: "853",
        areaCodes: [],
        region: "Asia & Pacific",
        flag: "\uD83C\uDDF2\uD83C\uDDF4"
    },
    {
        countryNameEn: "Martinique",
        countryNameLocal: "Martinique",
        countryCode: "MQ",
        currencyCode: "EUR",
        currencyNameEn: "Euro",
        tinType: "",
        tinName: "",
        officialLanguageCode: "fr",
        officialLanguageNameEn: "French",
        officialLanguageNameLocal: "Fran\xe7ais",
        countryCallingCode: "596",
        areaCodes: [],
        region: "South/Latin America",
        flag: "\uD83C\uDDF2\uD83C\uDDF6"
    },
    {
        countryNameEn: "Mauritania",
        countryNameLocal: "\u0645\u0648\u0631\u064A\u062A\u0627\u0646\u064A\u0627, Mauritanie",
        countryCode: "MR",
        currencyCode: "MRU",
        currencyNameEn: "",
        tinType: "",
        tinName: "",
        officialLanguageCode: "ar",
        officialLanguageNameEn: "Arabic",
        officialLanguageNameLocal: "\u0627\u0644\u0639\u0631\u0628\u064A\u0629",
        countryCallingCode: "222",
        areaCodes: [],
        region: "Arab States",
        flag: "\uD83C\uDDF2\uD83C\uDDF7"
    },
    {
        countryNameEn: "Montserrat",
        countryNameLocal: "Montserrat",
        countryCode: "MS",
        currencyCode: "XCD",
        currencyNameEn: "East Caribbean dollar",
        tinType: "",
        tinName: "",
        officialLanguageCode: "en",
        officialLanguageNameEn: "English",
        officialLanguageNameLocal: "English",
        countryCallingCode: "1664",
        areaCodes: [],
        region: "South/Latin America",
        flag: "\uD83C\uDDF2\uD83C\uDDF8"
    },
    {
        countryNameEn: "Malta",
        countryNameLocal: "Malta",
        countryCode: "MT",
        currencyCode: "EUR",
        currencyNameEn: "Euro",
        tinType: "Vat No.",
        tinName: "Vat reg. no.",
        officialLanguageCode: "mt",
        officialLanguageNameEn: "Maltese",
        officialLanguageNameLocal: "Malti",
        countryCallingCode: "356",
        areaCodes: [],
        region: "Europe",
        flag: "\uD83C\uDDF2\uD83C\uDDF9"
    },
    {
        countryNameEn: "Mauritius",
        countryNameLocal: "Maurice, Mauritius",
        countryCode: "MU",
        currencyCode: "MUR",
        currencyNameEn: "Mauritian rupee",
        tinType: "",
        tinName: "",
        officialLanguageCode: "mfe",
        officialLanguageNameEn: "",
        officialLanguageNameLocal: "",
        countryCallingCode: "230",
        areaCodes: [],
        region: "Africa",
        flag: "\uD83C\uDDF2\uD83C\uDDFA"
    },
    {
        countryNameEn: "Maldives",
        countryNameLocal: "",
        countryCode: "MV",
        currencyCode: "MVR",
        currencyNameEn: "Maldivian rufiyaa",
        tinType: "",
        tinName: "",
        officialLanguageCode: "dv",
        officialLanguageNameEn: "Divehi, Dhivehi, Maldivian",
        officialLanguageNameLocal: "\u078B\u07A8\u0788\u07AC\u0780\u07A8",
        countryCallingCode: "960",
        areaCodes: [],
        region: "Asia & Pacific",
        flag: "\uD83C\uDDF2\uD83C\uDDFB"
    },
    {
        countryNameEn: "Malawi",
        countryNameLocal: "Malawi",
        countryCode: "MW",
        currencyCode: "MWK",
        currencyNameEn: "Malawian kwacha",
        tinType: "",
        tinName: "",
        officialLanguageCode: "en",
        officialLanguageNameEn: "English",
        officialLanguageNameLocal: "English",
        countryCallingCode: "265",
        areaCodes: [],
        region: "Africa",
        flag: "\uD83C\uDDF2\uD83C\uDDFC"
    },
    {
        countryNameEn: "Mexico",
        countryNameLocal: "M\xe9xico",
        countryCode: "MX",
        currencyCode: "MXN",
        currencyNameEn: "Mexican peso",
        tinType: "RFC",
        tinName: "Registro Federal de Contribuyentes",
        officialLanguageCode: "es",
        officialLanguageNameEn: "Spanish, Castilian",
        officialLanguageNameLocal: "Espa\xf1ol",
        countryCallingCode: "52",
        areaCodes: [],
        region: "South/Latin America",
        flag: "\uD83C\uDDF2\uD83C\uDDFD"
    },
    {
        countryNameEn: "Malaysia",
        countryNameLocal: "",
        countryCode: "MY",
        currencyCode: "MYR",
        currencyNameEn: "Malaysian ringgit",
        tinType: "",
        tinName: "",
        officialLanguageCode: "ms",
        officialLanguageNameEn: "Malay",
        officialLanguageNameLocal: "Bahasa Melayu, \u0628\u0647\u0627\u0633 \u0645\u0644\u0627\u064A\u0648\u200E",
        countryCallingCode: "60",
        areaCodes: [],
        region: "Asia & Pacific",
        flag: "\uD83C\uDDF2\uD83C\uDDFE"
    },
    {
        countryNameEn: "Mozambique",
        countryNameLocal: "Mozambique",
        countryCode: "MZ",
        currencyCode: "MZN",
        currencyNameEn: "Mozambican metical",
        tinType: "",
        tinName: "",
        officialLanguageCode: "pt",
        officialLanguageNameEn: "Portuguese",
        officialLanguageNameLocal: "Portugu\xeas",
        countryCallingCode: "258",
        areaCodes: [],
        region: "Africa",
        flag: "\uD83C\uDDF2\uD83C\uDDFF"
    },
    {
        countryNameEn: "Namibia",
        countryNameLocal: "Namibia",
        countryCode: "NA",
        currencyCode: "NAD",
        currencyNameEn: "Namibian dollar",
        tinType: "",
        tinName: "",
        officialLanguageCode: "en",
        officialLanguageNameEn: "English",
        officialLanguageNameLocal: "English",
        countryCallingCode: "264",
        areaCodes: [],
        region: "Africa",
        flag: "\uD83C\uDDF3\uD83C\uDDE6"
    },
    {
        countryNameEn: "New Caledonia",
        countryNameLocal: "Nouvelle-Cal\xe9donie",
        countryCode: "NC",
        currencyCode: "XPF",
        currencyNameEn: "CFP franc (franc Pacifique)",
        tinType: "",
        tinName: "",
        officialLanguageCode: "fr",
        officialLanguageNameEn: "French",
        officialLanguageNameLocal: "Fran\xe7ais",
        countryCallingCode: "687",
        areaCodes: [],
        region: "Asia & Pacific",
        flag: "\uD83C\uDDF3\uD83C\uDDE8"
    },
    {
        countryNameEn: "Norfolk Island",
        countryNameLocal: "Norfolk Island",
        countryCode: "NF",
        currencyCode: "AUD",
        currencyNameEn: "Australian dollar",
        tinType: "",
        tinName: "",
        officialLanguageCode: "en",
        officialLanguageNameEn: "English",
        officialLanguageNameLocal: "English",
        countryCallingCode: "672",
        areaCodes: [],
        region: "Asia & Pacific",
        flag: "\uD83C\uDDF3\uD83C\uDDEB"
    },
    {
        countryNameEn: "Nigeria",
        countryNameLocal: "Nigeria",
        countryCode: "NG",
        currencyCode: "NGN",
        currencyNameEn: "Nigerian naira",
        tinType: "",
        tinName: "",
        officialLanguageCode: "en",
        officialLanguageNameEn: "English",
        officialLanguageNameLocal: "English",
        countryCallingCode: "234",
        areaCodes: [],
        region: "Africa",
        flag: "\uD83C\uDDF3\uD83C\uDDEC"
    },
    {
        countryNameEn: "Nicaragua",
        countryNameLocal: "Nicaragua",
        countryCode: "NI",
        currencyCode: "NIO",
        currencyNameEn: "Nicaraguan c\xf3rdoba",
        tinType: "RUC",
        tinName: "Registro Unico de Contribuyentes",
        officialLanguageCode: "es",
        officialLanguageNameEn: "Spanish, Castilian",
        officialLanguageNameLocal: "Espa\xf1ol",
        countryCallingCode: "505",
        areaCodes: [],
        region: "South/Latin America",
        flag: "\uD83C\uDDF3\uD83C\uDDEE"
    },
    {
        countryNameEn: "Norway",
        countryNameLocal: "Norge, Noreg",
        countryCode: "NO",
        currencyCode: "NOK",
        currencyNameEn: "Norwegian krone",
        tinType: "Orgnr",
        tinName: "Organisasjonsnummer",
        officialLanguageCode: "nb",
        officialLanguageNameEn: "Norwegian Bokm\xe5l",
        officialLanguageNameLocal: "Norsk Bokm\xe5l",
        countryCallingCode: "47",
        areaCodes: [],
        region: "Europe",
        flag: "\uD83C\uDDF3\uD83C\uDDF4"
    },
    {
        countryNameEn: "Nepal",
        countryNameLocal: "",
        countryCode: "NP",
        currencyCode: "NPR",
        currencyNameEn: "Nepalese rupee",
        tinType: "",
        tinName: "",
        officialLanguageCode: "ne",
        officialLanguageNameEn: "Nepali",
        officialLanguageNameLocal: "\u0928\u0947\u092A\u093E\u0932\u0940",
        countryCallingCode: "977",
        areaCodes: [],
        region: "Asia & Pacific",
        flag: "\uD83C\uDDF3\uD83C\uDDF5"
    },
    {
        countryNameEn: "Nauru",
        countryNameLocal: "Nauru",
        countryCode: "NR",
        currencyCode: "AUD",
        currencyNameEn: "Australian dollar",
        tinType: "",
        tinName: "",
        officialLanguageCode: "na",
        officialLanguageNameEn: "Nauru",
        officialLanguageNameLocal: "Dorerin Naoero",
        countryCallingCode: "674",
        areaCodes: [],
        region: "Asia & Pacific",
        flag: "\uD83C\uDDF3\uD83C\uDDF7"
    },
    {
        countryNameEn: "Niue",
        countryNameLocal: "Niue",
        countryCode: "NU",
        currencyCode: "NZD",
        currencyNameEn: "New Zealand dollar",
        tinType: "",
        tinName: "",
        officialLanguageCode: "niu",
        officialLanguageNameEn: "",
        officialLanguageNameLocal: "",
        countryCallingCode: "683",
        areaCodes: [],
        region: "Asia & Pacific",
        flag: "\uD83C\uDDF3\uD83C\uDDFA"
    },
    {
        countryNameEn: "New Zealand",
        countryNameLocal: "New Zealand",
        countryCode: "NZ",
        currencyCode: "NZD",
        currencyNameEn: "New Zealand dollar",
        tinType: "NZBN",
        tinName: "NZ Business Number",
        officialLanguageCode: "mi",
        officialLanguageNameEn: "Maori",
        officialLanguageNameLocal: "te reo M\u0101ori",
        countryCallingCode: "64",
        areaCodes: [],
        region: "Asia & Pacific",
        flag: "\uD83C\uDDF3\uD83C\uDDFF"
    },
    {
        countryNameEn: "Oman",
        countryNameLocal: "\u0633\u0644\u0637\u0646\u0629 \u0639\u064F\u0645\u0627\u0646",
        countryCode: "OM",
        currencyCode: "OMR",
        currencyNameEn: "Omani rial",
        tinType: "",
        tinName: "",
        officialLanguageCode: "ar",
        officialLanguageNameEn: "Arabic",
        officialLanguageNameLocal: "\u0627\u0644\u0639\u0631\u0628\u064A\u0629",
        countryCallingCode: "968",
        areaCodes: [],
        region: "Arab States",
        flag: "\uD83C\uDDF4\uD83C\uDDF2"
    },
    {
        countryNameEn: "Panama",
        countryNameLocal: "Panama",
        countryCode: "PA",
        currencyCode: "PAB",
        currencyNameEn: "Panamanian balboa",
        tinType: "RUC",
        tinName: "Registro Unico de Contribuyentes",
        officialLanguageCode: "es",
        officialLanguageNameEn: "Spanish, Castilian",
        officialLanguageNameLocal: "Espa\xf1ol",
        countryCallingCode: "507",
        areaCodes: [],
        region: "South/Latin America",
        flag: "\uD83C\uDDF5\uD83C\uDDE6"
    },
    {
        countryNameEn: "Peru",
        countryNameLocal: "Per\xfa",
        countryCode: "PE",
        currencyCode: "PEN",
        currencyNameEn: "Peruvian sol",
        tinType: "RUC",
        tinName: "Registro Unico de Contribuyentes",
        officialLanguageCode: "es",
        officialLanguageNameEn: "Spanish, Castilian",
        officialLanguageNameLocal: "Espa\xf1ol",
        countryCallingCode: "51",
        areaCodes: [],
        region: "South/Latin America",
        flag: "\uD83C\uDDF5\uD83C\uDDEA"
    },
    {
        countryNameEn: "French Polynesia",
        countryNameLocal: "Polyn\xe9sie fran\xe7aise",
        countryCode: "PF",
        currencyCode: "XPF",
        currencyNameEn: "CFP franc (franc Pacifique)",
        tinType: "",
        tinName: "",
        officialLanguageCode: "fr",
        officialLanguageNameEn: "French",
        officialLanguageNameLocal: "Fran\xe7ais",
        countryCallingCode: "689",
        areaCodes: [],
        region: "Asia & Pacific",
        flag: "\uD83C\uDDF5\uD83C\uDDEB"
    },
    {
        countryNameEn: "Papua New Guinea",
        countryNameLocal: "Papua New Guinea",
        countryCode: "PG",
        currencyCode: "PGK",
        currencyNameEn: "Papua New Guinean kina",
        tinType: "",
        tinName: "",
        officialLanguageCode: "en",
        officialLanguageNameEn: "English",
        officialLanguageNameLocal: "English",
        countryCallingCode: "675",
        areaCodes: [],
        region: "Asia & Pacific",
        flag: "\uD83C\uDDF5\uD83C\uDDEC"
    },
    {
        countryNameEn: "Pakistan",
        countryNameLocal: "\u067E\u0627\u06A9\u0633\u062A\u0627\u0646",
        countryCode: "PK",
        currencyCode: "PKR",
        currencyNameEn: "Pakistani rupee",
        tinType: "",
        tinName: "",
        officialLanguageCode: "en",
        officialLanguageNameEn: "English",
        officialLanguageNameLocal: "English",
        countryCallingCode: "92",
        areaCodes: [],
        region: "Asia & Pacific",
        flag: "\uD83C\uDDF5\uD83C\uDDF0"
    },
    {
        countryNameEn: "Poland",
        countryNameLocal: "Polska",
        countryCode: "PL",
        currencyCode: "PLN",
        currencyNameEn: "Polish z\u0142oty",
        tinType: "NIP",
        tinName: "numer identyfikacji podatkowej",
        officialLanguageCode: "pl",
        officialLanguageNameEn: "Polish",
        officialLanguageNameLocal: "j\u0119zyk polski, polszczyzna",
        countryCallingCode: "48",
        areaCodes: [],
        region: "Europe",
        flag: "\uD83C\uDDF5\uD83C\uDDF1"
    },
    {
        countryNameEn: "Saint Pierre and Miquelon",
        countryNameLocal: "Saint-Pierre-et-Miquelon",
        countryCode: "PM",
        currencyCode: "EUR",
        currencyNameEn: "Euro",
        tinType: "",
        tinName: "",
        officialLanguageCode: "fr",
        officialLanguageNameEn: "French",
        officialLanguageNameLocal: "Fran\xe7ais",
        countryCallingCode: "508",
        areaCodes: [],
        region: "North America",
        flag: "\uD83C\uDDF5\uD83C\uDDF2"
    },
    {
        countryNameEn: "Pitcairn",
        countryNameLocal: "Pitcairn",
        countryCode: "PN",
        currencyCode: "NZD",
        currencyNameEn: "New Zealand dollar",
        tinType: "",
        tinName: "",
        officialLanguageCode: "en",
        officialLanguageNameEn: "English",
        officialLanguageNameLocal: "English",
        countryCallingCode: "64",
        areaCodes: [],
        region: "Asia & Pacific",
        flag: "\uD83C\uDDF5\uD83C\uDDF3"
    },
    {
        countryNameEn: "Puerto Rico",
        countryNameLocal: "Puerto Rico",
        countryCode: "PR",
        currencyCode: "USD",
        currencyNameEn: "United States dollar",
        tinType: "",
        tinName: "",
        officialLanguageCode: "es",
        officialLanguageNameEn: "Spanish, Castilian",
        officialLanguageNameLocal: "Espa\xf1ol",
        countryCallingCode: "1",
        areaCodes: [],
        region: "South/Latin America",
        flag: "\uD83C\uDDF5\uD83C\uDDF7"
    },
    {
        countryNameEn: "Palestine, State of",
        countryNameLocal: "Palestinian Territory",
        countryCode: "PS",
        currencyCode: "",
        currencyNameEn: "",
        tinType: "",
        tinName: "",
        officialLanguageCode: "ar",
        officialLanguageNameEn: "Arabic",
        officialLanguageNameLocal: "\u0627\u0644\u0639\u0631\u0628\u064A\u0629",
        countryCallingCode: "970",
        areaCodes: [],
        region: "Arab States",
        flag: "\uD83C\uDDF5\uD83C\uDDF8"
    },
    {
        countryNameEn: "Portugal",
        countryNameLocal: "Portugal",
        countryCode: "PT",
        currencyCode: "EUR",
        currencyNameEn: "Euro",
        tinType: "NIPC",
        tinName: "N\xfamero de Identifica\xe7\xe3o de Pessoa Coletiva (NIPC)",
        officialLanguageCode: "pt",
        officialLanguageNameEn: "Portuguese",
        officialLanguageNameLocal: "Portugu\xeas",
        countryCallingCode: "351",
        areaCodes: [],
        region: "Europe",
        flag: "\uD83C\uDDF5\uD83C\uDDF9"
    },
    {
        countryNameEn: "Palau",
        countryNameLocal: "Palau",
        countryCode: "PW",
        currencyCode: "USD",
        currencyNameEn: "United States dollar",
        tinType: "",
        tinName: "",
        officialLanguageCode: "en",
        officialLanguageNameEn: "English",
        officialLanguageNameLocal: "English",
        countryCallingCode: "680",
        areaCodes: [],
        region: "Asia & Pacific",
        flag: "\uD83C\uDDF5\uD83C\uDDFC"
    },
    {
        countryNameEn: "Paraguay",
        countryNameLocal: "Paraguay",
        countryCode: "PY",
        currencyCode: "PYG",
        currencyNameEn: "Paraguayan guaran\xed",
        tinType: "RUC",
        tinName: "Registro Unico de Contribuyentes",
        officialLanguageCode: "es",
        officialLanguageNameEn: "Spanish, Castilian",
        officialLanguageNameLocal: "Espa\xf1ol",
        countryCallingCode: "595",
        areaCodes: [],
        region: "South/Latin America",
        flag: "\uD83C\uDDF5\uD83C\uDDFE"
    },
    {
        countryNameEn: "Qatar",
        countryNameLocal: "\u0642\u0637\u0631",
        countryCode: "QA",
        currencyCode: "QAR",
        currencyNameEn: "Qatari riyal",
        tinType: "",
        tinName: "",
        officialLanguageCode: "ar",
        officialLanguageNameEn: "Arabic",
        officialLanguageNameLocal: "\u0627\u0644\u0639\u0631\u0628\u064A\u0629",
        countryCallingCode: "974",
        areaCodes: [],
        region: "Arab States",
        flag: "\uD83C\uDDF6\uD83C\uDDE6"
    },
    {
        countryNameEn: "R\xe9union",
        countryNameLocal: "La R\xe9union",
        countryCode: "RE",
        currencyCode: "EUR",
        currencyNameEn: "Euro",
        tinType: "",
        tinName: "",
        officialLanguageCode: "fr",
        officialLanguageNameEn: "French",
        officialLanguageNameLocal: "Fran\xe7ais",
        countryCallingCode: "262",
        areaCodes: [],
        region: "Asia & Pacific",
        flag: "\uD83C\uDDF7\uD83C\uDDEA"
    },
    {
        countryNameEn: "Romania",
        countryNameLocal: "Rom\xe2nia",
        countryCode: "RO",
        currencyCode: "RON",
        currencyNameEn: "Romanian leu",
        tinType: "CIF",
        tinName: "Codul de identificare fiscal\u0103",
        officialLanguageCode: "ro",
        officialLanguageNameEn: "Romanian, Moldavian, Moldovan",
        officialLanguageNameLocal: "Rom\xe2n\u0103",
        countryCallingCode: "40",
        areaCodes: [],
        region: "Europe",
        flag: "\uD83C\uDDF7\uD83C\uDDF4"
    },
    {
        countryNameEn: "Serbia",
        countryNameLocal: "\u0421\u0440\u0431\u0438\u0458\u0430",
        countryCode: "RS",
        currencyCode: "RSD",
        currencyNameEn: "Serbian dinar",
        tinType: "PIB",
        tinName: "Poreski identifikacioni broj",
        officialLanguageCode: "sr",
        officialLanguageNameEn: "Serbian",
        officialLanguageNameLocal: "\u0441\u0440\u043F\u0441\u043A\u0438 \u0458\u0435\u0437\u0438\u043A",
        countryCallingCode: "381",
        areaCodes: [],
        region: "Europe",
        flag: "\uD83C\uDDF7\uD83C\uDDF8"
    },
    {
        countryNameEn: "Russia",
        countryNameLocal: "\u0420\u043E\u0441\u0441\u0438\u044F",
        countryCode: "RU",
        currencyCode: "RUB",
        currencyNameEn: "Russian ruble",
        tinType: "\u0418\u041D\u041D",
        tinName: "\u0418\u0434\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u043E\u043D\u043D\u044B\u0439 \u043D\u043E\u043C\u0435\u0440 \u043D\u0430\u043B\u043E\u0433\u043E\u043F\u043B\u0430\u0442\u0435\u043B\u044C\u0449\u0438\u043A\u0430",
        officialLanguageCode: "ru",
        officialLanguageNameEn: "Russian",
        officialLanguageNameLocal: "\u0440\u0443\u0441\u0441\u043A\u0438\u0439",
        countryCallingCode: "7",
        areaCodes: [],
        region: "Europe",
        flag: "\uD83C\uDDF7\uD83C\uDDFA"
    },
    {
        countryNameEn: "Rwanda",
        countryNameLocal: "Rwanda",
        countryCode: "RW",
        currencyCode: "RWF",
        currencyNameEn: "Rwandan franc",
        tinType: "",
        tinName: "",
        officialLanguageCode: "rw",
        officialLanguageNameEn: "Kinyarwanda",
        officialLanguageNameLocal: "Ikinyarwanda",
        countryCallingCode: "250",
        areaCodes: [],
        region: "Africa",
        flag: "\uD83C\uDDF7\uD83C\uDDFC"
    },
    {
        countryNameEn: "Saudi Arabia",
        countryNameLocal: "\u0627\u0644\u0633\u0639\u0648\u062F\u064A\u0629",
        countryCode: "SA",
        currencyCode: "SAR",
        currencyNameEn: "Saudi riyal",
        tinType: "",
        tinName: "",
        officialLanguageCode: "ar",
        officialLanguageNameEn: "Arabic",
        officialLanguageNameLocal: "\u0627\u0644\u0639\u0631\u0628\u064A\u0629",
        countryCallingCode: "966",
        areaCodes: [],
        region: "Arab States",
        flag: "\uD83C\uDDF8\uD83C\uDDE6"
    },
    {
        countryNameEn: "Solomon Islands",
        countryNameLocal: "Solomon Islands",
        countryCode: "SB",
        currencyCode: "SBD",
        currencyNameEn: "Solomon Islands dollar",
        tinType: "",
        tinName: "",
        officialLanguageCode: "en",
        officialLanguageNameEn: "English",
        officialLanguageNameLocal: "English",
        countryCallingCode: "677",
        areaCodes: [],
        region: "Asia & Pacific",
        flag: "\uD83C\uDDF8\uD83C\uDDE7"
    },
    {
        countryNameEn: "Seychelles",
        countryNameLocal: "Seychelles",
        countryCode: "SC",
        currencyCode: "SCR",
        currencyNameEn: "Seychelles rupee",
        tinType: "",
        tinName: "",
        officialLanguageCode: "fr",
        officialLanguageNameEn: "French",
        officialLanguageNameLocal: "Fran\xe7ais",
        countryCallingCode: "248",
        areaCodes: [],
        region: "Africa",
        flag: "\uD83C\uDDF8\uD83C\uDDE8"
    },
    {
        countryNameEn: "Sweden",
        countryNameLocal: "Sverige",
        countryCode: "SE",
        currencyCode: "SEK",
        currencyNameEn: "Swedish krona/kronor",
        tinType: "Momsnr.",
        tinName: "VAT-nummer",
        officialLanguageCode: "sv",
        officialLanguageNameEn: "Swedish",
        officialLanguageNameLocal: "Svenska",
        countryCallingCode: "46",
        areaCodes: [],
        region: "Europe",
        flag: "\uD83C\uDDF8\uD83C\uDDEA"
    },
    {
        countryNameEn: "Singapore",
        countryNameLocal: "Singapore",
        countryCode: "SG",
        currencyCode: "SGD",
        currencyNameEn: "Singapore dollar",
        tinType: "",
        tinName: "",
        officialLanguageCode: "zh-hans",
        officialLanguageNameEn: "",
        officialLanguageNameLocal: "",
        countryCallingCode: "65",
        areaCodes: [],
        region: "Asia & Pacific",
        flag: "\uD83C\uDDF8\uD83C\uDDEC"
    },
    {
        countryNameEn: "Saint Helena, Ascension and Tristan da Cunha",
        countryNameLocal: "Saint Helena",
        countryCode: "SH",
        currencyCode: "SHP",
        currencyNameEn: "Saint Helena pound",
        tinType: "",
        tinName: "",
        officialLanguageCode: "en",
        officialLanguageNameEn: "English",
        officialLanguageNameLocal: "English",
        countryCallingCode: "290",
        areaCodes: [],
        region: "Africa",
        flag: "\uD83C\uDDF8\uD83C\uDDED"
    },
    {
        countryNameEn: "Slovenia",
        countryNameLocal: "Slovenija",
        countryCode: "SI",
        currencyCode: "EUR",
        currencyNameEn: "Euro",
        tinType: "ID za DDV",
        tinName: "Dav\u010Dna \u0161tevilka",
        officialLanguageCode: "sl",
        officialLanguageNameEn: "Slovenian",
        officialLanguageNameLocal: "Slovenski Jezik, Sloven\u0161\u010Dina",
        countryCallingCode: "386",
        areaCodes: [],
        region: "Europe",
        flag: "\uD83C\uDDF8\uD83C\uDDEE"
    },
    {
        countryNameEn: "Svalbard and Jan Mayen",
        countryNameLocal: "Svalbard and Jan Mayen",
        countryCode: "SJ",
        currencyCode: "NOK",
        currencyNameEn: "Norwegian krone",
        tinType: "",
        tinName: "",
        officialLanguageCode: "no",
        officialLanguageNameEn: "Norwegian",
        officialLanguageNameLocal: "Norsk",
        countryCallingCode: "4779",
        areaCodes: [],
        region: "Europe",
        flag: "\uD83C\uDDF8\uD83C\uDDEF"
    },
    {
        countryNameEn: "Slovakia",
        countryNameLocal: "Slovensko",
        countryCode: "SK",
        currencyCode: "EUR",
        currencyNameEn: "Euro",
        tinType: "I\u010C DPH",
        tinName: "Identifika\u010Dn\xe9 \u010D\xedslo pre da\u0148 z pridanej hodnoty",
        officialLanguageCode: "sk",
        officialLanguageNameEn: "Slovak",
        officialLanguageNameLocal: "Sloven\u010Dina, Slovensk\xfd Jazyk",
        countryCallingCode: "421",
        areaCodes: [],
        region: "Europe",
        flag: "\uD83C\uDDF8\uD83C\uDDF0"
    },
    {
        countryNameEn: "Sierra Leone",
        countryNameLocal: "Sierra Leone",
        countryCode: "SL",
        currencyCode: "SLL",
        currencyNameEn: "Sierra Leonean leone",
        tinType: "",
        tinName: "",
        officialLanguageCode: "en",
        officialLanguageNameEn: "English",
        officialLanguageNameLocal: "English",
        countryCallingCode: "232",
        areaCodes: [],
        region: "Africa",
        flag: "\uD83C\uDDF8\uD83C\uDDF1"
    },
    {
        countryNameEn: "Republic of San Marino",
        countryNameLocal: "Repubblica di San Marino",
        countryCode: "SM",
        currencyCode: "EUR",
        currencyNameEn: "Euro",
        tinType: "C.O.E.",
        tinName: "Codice operatore economico",
        officialLanguageCode: "it",
        officialLanguageNameEn: "Italian",
        officialLanguageNameLocal: "Italiano",
        countryCallingCode: "378",
        areaCodes: [],
        region: "Europe",
        flag: "\uD83C\uDDF8\uD83C\uDDF2"
    },
    {
        countryNameEn: "Senegal",
        countryNameLocal: "S\xe9n\xe9gal",
        countryCode: "SN",
        currencyCode: "XOF",
        currencyNameEn: "CFA franc BCEAO",
        tinType: "",
        tinName: "",
        officialLanguageCode: "fr",
        officialLanguageNameEn: "French",
        officialLanguageNameLocal: "Fran\xe7ais",
        countryCallingCode: "221",
        areaCodes: [],
        region: "Africa",
        flag: "\uD83C\uDDF8\uD83C\uDDF3"
    },
    {
        countryNameEn: "Somalia",
        countryNameLocal: "Somalia, \u0627\u0644\u0635\u0648\u0645\u0627\u0644",
        countryCode: "SO",
        currencyCode: "SOS",
        currencyNameEn: "Somali shilling",
        tinType: "",
        tinName: "",
        officialLanguageCode: "so",
        officialLanguageNameEn: "Somali",
        officialLanguageNameLocal: "Soomaaliga, af Soomaali",
        countryCallingCode: "252",
        areaCodes: [],
        region: "Arab States",
        flag: "\uD83C\uDDF8\uD83C\uDDF4"
    },
    {
        countryNameEn: "Suriname",
        countryNameLocal: "Suriname",
        countryCode: "SR",
        currencyCode: "SRD",
        currencyNameEn: "Surinamese dollar",
        tinType: "",
        tinName: "",
        officialLanguageCode: "nl",
        officialLanguageNameEn: "Dutch, Flemish",
        officialLanguageNameLocal: "Nederlands, Vlaams",
        countryCallingCode: "597",
        areaCodes: [],
        region: "South/Latin America",
        flag: "\uD83C\uDDF8\uD83C\uDDF7"
    },
    {
        countryNameEn: "South Sudan",
        countryNameLocal: "South Sudan",
        countryCode: "SS",
        currencyCode: "SSP",
        currencyNameEn: "South Sudanese pound",
        tinType: "",
        tinName: "",
        officialLanguageCode: "en",
        officialLanguageNameEn: "English",
        officialLanguageNameLocal: "English",
        countryCallingCode: "211",
        areaCodes: [],
        region: "Africa",
        flag: "\uD83C\uDDF8\uD83C\uDDF8"
    },
    {
        countryNameEn: "Sao Tome and Principe",
        countryNameLocal: "S\xe3o Tom\xe9 e Pr\xedncipe",
        countryCode: "ST",
        currencyCode: "STN",
        currencyNameEn: "",
        tinType: "",
        tinName: "",
        officialLanguageCode: "pt",
        officialLanguageNameEn: "Portuguese",
        officialLanguageNameLocal: "Portugu\xeas",
        countryCallingCode: "239",
        areaCodes: [],
        region: "Africa",
        flag: "\uD83C\uDDF8\uD83C\uDDF9"
    },
    {
        countryNameEn: "El Salvador",
        countryNameLocal: "El Salvador",
        countryCode: "SV",
        currencyCode: "SVC",
        currencyNameEn: "Salvadoran col\xf3n",
        tinType: "NIT",
        tinName: "N\xfamero de Identificaci\xf3n Tributaria",
        officialLanguageCode: "es",
        officialLanguageNameEn: "Spanish, Castilian",
        officialLanguageNameLocal: "Espa\xf1ol",
        countryCallingCode: "503",
        areaCodes: [],
        region: "South/Latin America",
        flag: "\uD83C\uDDF8\uD83C\uDDFB"
    },
    {
        countryNameEn: "Sint Maarten (Dutch part)",
        countryNameLocal: "Sint Maarten",
        countryCode: "SX",
        currencyCode: "ANG",
        currencyNameEn: "Netherlands Antillean guilder",
        tinType: "",
        tinName: "",
        officialLanguageCode: "nl",
        officialLanguageNameEn: "Dutch, Flemish",
        officialLanguageNameLocal: "Nederlands, Vlaams",
        countryCallingCode: "1721",
        areaCodes: [],
        region: "Unknown",
        flag: "\uD83C\uDDF8\uD83C\uDDFD"
    },
    {
        countryNameEn: "Syrian Arab Republic",
        countryNameLocal: "\u0633\u0648\u0631\u064A\u0627, S\u016Briyya",
        countryCode: "SY",
        currencyCode: "SYP",
        currencyNameEn: "Syrian pound",
        tinType: "",
        tinName: "",
        officialLanguageCode: "ar",
        officialLanguageNameEn: "Arabic",
        officialLanguageNameLocal: "\u0627\u0644\u0639\u0631\u0628\u064A\u0629",
        countryCallingCode: "963",
        areaCodes: [],
        region: "Asia & Pacific",
        flag: "\uD83C\uDDF8\uD83C\uDDFE"
    },
    {
        countryNameEn: "Chad",
        countryNameLocal: "Tchad, \u062A\u0634\u0627\u062F",
        countryCode: "TD",
        currencyCode: "XAF",
        currencyNameEn: "CFA franc BEAC",
        tinType: "",
        tinName: "",
        officialLanguageCode: "fr",
        officialLanguageNameEn: "French",
        officialLanguageNameLocal: "Fran\xe7ais",
        countryCallingCode: "235",
        areaCodes: [],
        region: "Africa",
        flag: "\uD83C\uDDF9\uD83C\uDDE9"
    },
    {
        countryNameEn: "Togo",
        countryNameLocal: "Togo",
        countryCode: "TG",
        currencyCode: "XOF",
        currencyNameEn: "CFA franc BCEAO",
        tinType: "",
        tinName: "",
        officialLanguageCode: "fr",
        officialLanguageNameEn: "French",
        officialLanguageNameLocal: "Fran\xe7ais",
        countryCallingCode: "228",
        areaCodes: [],
        region: "Africa",
        flag: "\uD83C\uDDF9\uD83C\uDDEC"
    },
    {
        countryNameEn: "Thailand",
        countryNameLocal: "\u0E1B\u0E23\u0E30\u0E40\u0E17\u0E28\u0E44\u0E17\u0E22",
        countryCode: "TH",
        currencyCode: "THB",
        currencyNameEn: "Thai baht",
        tinType: "",
        tinName: "",
        officialLanguageCode: "th",
        officialLanguageNameEn: "Thai",
        officialLanguageNameLocal: "\u0E44\u0E17\u0E22",
        countryCallingCode: "66",
        areaCodes: [],
        region: "Asia & Pacific",
        flag: "\uD83C\uDDF9\uD83C\uDDED"
    },
    {
        countryNameEn: "Tajikistan",
        countryNameLocal: ",",
        countryCode: "TJ",
        currencyCode: "TJS",
        currencyNameEn: "Tajikistani somoni",
        tinType: "",
        tinName: "",
        officialLanguageCode: "tg",
        officialLanguageNameEn: "Tajik",
        officialLanguageNameLocal: "\u0442\u043E\u04B7\u0438\u043A\u04E3, to\xe7ik\u012B, \u062A\u0627\u062C\u06CC\u06A9\u06CC\u200E",
        countryCallingCode: "992",
        areaCodes: [],
        region: "Asia & Pacific",
        flag: "\uD83C\uDDF9\uD83C\uDDEF"
    },
    {
        countryNameEn: "Tokelau",
        countryNameLocal: "Tokelau",
        countryCode: "TK",
        currencyCode: "NZD",
        currencyNameEn: "New Zealand dollar",
        tinType: "",
        tinName: "",
        officialLanguageCode: "tkl",
        officialLanguageNameEn: "",
        officialLanguageNameLocal: "",
        countryCallingCode: "690",
        areaCodes: [],
        region: "Asia & Pacific",
        flag: "\uD83C\uDDF9\uD83C\uDDF0"
    },
    {
        countryNameEn: "Timor-Leste",
        countryNameLocal: "Timor-Leste, Timor Lorosa'e",
        countryCode: "TL",
        currencyCode: "USD",
        currencyNameEn: "United States dollar",
        tinType: "",
        tinName: "",
        officialLanguageCode: "pt",
        officialLanguageNameEn: "Portuguese",
        officialLanguageNameLocal: "Portugu\xeas",
        countryCallingCode: "670",
        areaCodes: [],
        region: "Asia & Pacific",
        flag: "\uD83C\uDDF9\uD83C\uDDF1"
    },
    {
        countryNameEn: "Turkmenistan",
        countryNameLocal: "T\xfcrkmenistan",
        countryCode: "TM",
        currencyCode: "TMT",
        currencyNameEn: "Turkmenistan manat",
        tinType: "",
        tinName: "",
        officialLanguageCode: "tk",
        officialLanguageNameEn: "Turkmen",
        officialLanguageNameLocal: "T\xfcrkmen, \u0422\u04AF\u0440\u043A\u043C\u0435\u043D",
        countryCallingCode: "993",
        areaCodes: [],
        region: "Asia & Pacific",
        flag: "\uD83C\uDDF9\uD83C\uDDF2"
    },
    {
        countryNameEn: "Tunisia",
        countryNameLocal: "\u062A\u0648\u0646\u0633, Tunisie",
        countryCode: "TN",
        currencyCode: "TND",
        currencyNameEn: "Tunisian dinar",
        tinType: "",
        tinName: "",
        officialLanguageCode: "ar",
        officialLanguageNameEn: "Arabic",
        officialLanguageNameLocal: "\u0627\u0644\u0639\u0631\u0628\u064A\u0629",
        countryCallingCode: "216",
        areaCodes: [],
        region: "Arab States",
        flag: "\uD83C\uDDF9\uD83C\uDDF3"
    },
    {
        countryNameEn: "Tonga",
        countryNameLocal: "Tonga",
        countryCode: "TO",
        currencyCode: "TOP",
        currencyNameEn: "Tongan pa\u02BBanga",
        tinType: "",
        tinName: "",
        officialLanguageCode: "en",
        officialLanguageNameEn: "English",
        officialLanguageNameLocal: "English",
        countryCallingCode: "676",
        areaCodes: [],
        region: "Asia & Pacific",
        flag: "\uD83C\uDDF9\uD83C\uDDF4"
    },
    {
        countryNameEn: "Turkey",
        countryNameLocal: "T\xfcrkiye",
        countryCode: "TR",
        currencyCode: "TRY",
        currencyNameEn: "Turkish lira",
        tinType: "KDV",
        tinName: "Vergi Kimlik Numaras\u0131",
        officialLanguageCode: "tr",
        officialLanguageNameEn: "Turkish",
        officialLanguageNameLocal: "T\xfcrk\xe7e",
        countryCallingCode: "90",
        areaCodes: [],
        region: "Europe",
        flag: "\uD83C\uDDF9\uD83C\uDDF7"
    },
    {
        countryNameEn: "Trinidad and Tobago",
        countryNameLocal: "Trinidad and Tobago",
        countryCode: "TT",
        currencyCode: "TTD",
        currencyNameEn: "Trinidad and Tobago dollar",
        tinType: "",
        tinName: "",
        officialLanguageCode: "en",
        officialLanguageNameEn: "English",
        officialLanguageNameLocal: "English",
        countryCallingCode: "868",
        areaCodes: [],
        region: "South/Latin America",
        flag: "\uD83C\uDDF9\uD83C\uDDF9"
    },
    {
        countryNameEn: "Tuvalu",
        countryNameLocal: "Tuvalu",
        countryCode: "TV",
        currencyCode: "AUD",
        currencyNameEn: "Australian dollar",
        tinType: "",
        tinName: "",
        officialLanguageCode: "en",
        officialLanguageNameEn: "English",
        officialLanguageNameLocal: "English",
        countryCallingCode: "688",
        areaCodes: [],
        region: "Asia & Pacific",
        flag: "\uD83C\uDDF9\uD83C\uDDFB"
    },
    {
        countryNameEn: "United Republic of Tanzania",
        countryNameLocal: "Tanzania",
        countryCode: "TZ",
        currencyCode: "TZS",
        currencyNameEn: "Tanzanian shilling",
        tinType: "",
        tinName: "",
        officialLanguageCode: "sw",
        officialLanguageNameEn: "Swahili",
        officialLanguageNameLocal: "Kiswahili",
        countryCallingCode: "255",
        areaCodes: [],
        region: "Africa",
        flag: "\uD83C\uDDF9\uD83C\uDDFF"
    },
    {
        countryNameEn: "Ukraine",
        countryNameLocal: "\u0423\u043A\u0440\u0430\u0457\u043D\u0430",
        countryCode: "UA",
        currencyCode: "UAH",
        currencyNameEn: "Ukrainian hryvnia",
        tinType: "\u0406\u041D\u041F\u041F",
        tinName: "\u0406\u0434\u0435\u043D\u0442\u0438\u0444\u0456\u043A\u0430\u0446\u0456\u0439\u043D\u0438\u0439 \u043D\u043E\u043C\u0435\u0440 \u043F\u043B\u0430\u0442\u043D\u0438\u043A\u0430 \u043F\u043E\u0434\u0430\u0442\u043A\u0456\u0432",
        officialLanguageCode: "uk",
        officialLanguageNameEn: "Ukrainian",
        officialLanguageNameLocal: "\u0423\u043A\u0440\u0430\u0457\u043D\u0441\u044C\u043A\u0430",
        countryCallingCode: "380",
        areaCodes: [],
        region: "Europe",
        flag: "\uD83C\uDDFA\uD83C\uDDE6"
    },
    {
        countryNameEn: "Uganda",
        countryNameLocal: "Uganda",
        countryCode: "UG",
        currencyCode: "UGX",
        currencyNameEn: "Ugandan shilling",
        tinType: "",
        tinName: "",
        officialLanguageCode: "en",
        officialLanguageNameEn: "English",
        officialLanguageNameLocal: "English",
        countryCallingCode: "256",
        areaCodes: [],
        region: "Africa",
        flag: "\uD83C\uDDFA\uD83C\uDDEC"
    },
    {
        countryNameEn: "United States of America",
        countryNameLocal: "United States of America",
        countryCode: "US",
        currencyCode: "USD",
        currencyNameEn: "United States dollar",
        tinType: "EIN",
        tinName: "Tax Identification Number",
        officialLanguageCode: "en",
        officialLanguageNameEn: "English",
        officialLanguageNameLocal: "English",
        countryCallingCode: "1",
        areaCodes: [],
        region: "North America",
        flag: "\uD83C\uDDFA\uD83C\uDDF8"
    },
    {
        countryNameEn: "Uruguay",
        countryNameLocal: "Uruguay",
        countryCode: "UY",
        currencyCode: "UYU",
        currencyNameEn: "Uruguayan peso",
        tinType: "RUT",
        tinName: "Registro \xdanico Tributario",
        officialLanguageCode: "es",
        officialLanguageNameEn: "Spanish, Castilian",
        officialLanguageNameLocal: "Espa\xf1ol",
        countryCallingCode: "598",
        areaCodes: [],
        region: "South/Latin America",
        flag: "\uD83C\uDDFA\uD83C\uDDFE"
    },
    {
        countryNameEn: "Uzbekistan",
        countryNameLocal: "",
        countryCode: "UZ",
        currencyCode: "UZS",
        currencyNameEn: "Uzbekistan som",
        tinType: "\u0421\u0422\u0418\u0420",
        tinName: "\u0421\u043E\u043B\u0438\u049B \u0442\u045E\u043B\u043E\u0432\u0447\u0438\u043B\u0430\u0440\u043D\u0438\u043D\u0433 \u0438\u0434\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u044F \u0440\u0430\u049B\u0430\u043C\u0438",
        officialLanguageCode: "uz",
        officialLanguageNameEn: "Uzbek",
        officialLanguageNameLocal: "O\u02BBzbek, \u040E\u0437\u0431\u0435\u043A, \u0623\u06C7\u0632\u0628\u06D0\u0643\u200E",
        countryCallingCode: "998",
        areaCodes: [],
        region: "Asia & Pacific",
        flag: "\uD83C\uDDFA\uD83C\uDDFF"
    },
    {
        countryNameEn: "Saint Vincent and the Grenadines",
        countryNameLocal: "Saint Vincent and the Grenadines",
        countryCode: "VC",
        currencyCode: "XCD",
        currencyNameEn: "East Caribbean dollar",
        tinType: "",
        tinName: "",
        officialLanguageCode: "en",
        officialLanguageNameEn: "English",
        officialLanguageNameLocal: "English",
        countryCallingCode: "1784",
        areaCodes: [],
        region: "South/Latin America",
        flag: "\uD83C\uDDFB\uD83C\uDDE8"
    },
    {
        countryNameEn: "Venezuela (Bolivarian Republic of)",
        countryNameLocal: "Venezuela",
        countryCode: "VE",
        currencyCode: "VES",
        currencyNameEn: "",
        tinType: "RIF",
        tinName: "Registro de Informacion Fiscal",
        officialLanguageCode: "es",
        officialLanguageNameEn: "Spanish, Castilian",
        officialLanguageNameLocal: "Espa\xf1ol",
        countryCallingCode: "58",
        areaCodes: [],
        region: "South/Latin America",
        flag: "\uD83C\uDDFB\uD83C\uDDEA"
    },
    {
        countryNameEn: "Virgin Islands (British)",
        countryNameLocal: "British Virgin Islands",
        countryCode: "VG",
        currencyCode: "USD",
        currencyNameEn: "United States dollar",
        tinType: "",
        tinName: "",
        officialLanguageCode: "en",
        officialLanguageNameEn: "English",
        officialLanguageNameLocal: "English",
        countryCallingCode: "1284",
        areaCodes: [],
        region: "South/Latin America",
        flag: "\uD83C\uDDFB\uD83C\uDDEC"
    },
    {
        countryNameEn: "Virgin Islands (U.S.)",
        countryNameLocal: "United States Virgin Islands",
        countryCode: "VI",
        currencyCode: "USD",
        currencyNameEn: "United States dollar",
        tinType: "",
        tinName: "",
        officialLanguageCode: "en",
        officialLanguageNameEn: "English",
        officialLanguageNameLocal: "English",
        countryCallingCode: "1340",
        areaCodes: [],
        region: "South/Latin America",
        flag: "\uD83C\uDDFB\uD83C\uDDEE"
    },
    {
        countryNameEn: "Vietnam",
        countryNameLocal: "Vi\u1EC7t Nam",
        countryCode: "VN",
        currencyCode: "VND",
        currencyNameEn: "Vietnamese \u0111\u1ED3ng",
        tinType: "",
        tinName: "",
        officialLanguageCode: "vi",
        officialLanguageNameEn: "Vietnamese",
        officialLanguageNameLocal: "Ti\u1EBFng Vi\u1EC7t",
        countryCallingCode: "84",
        areaCodes: [],
        region: "Asia & Pacific",
        flag: "\uD83C\uDDFB\uD83C\uDDF3"
    },
    {
        countryNameEn: "Vanuatu",
        countryNameLocal: "Vanuatu",
        countryCode: "VU",
        currencyCode: "VUV",
        currencyNameEn: "Vanuatu vatu",
        tinType: "",
        tinName: "",
        officialLanguageCode: "bi",
        officialLanguageNameEn: "Bislama",
        officialLanguageNameLocal: "Bislama",
        countryCallingCode: "678",
        areaCodes: [],
        region: "Asia & Pacific",
        flag: "\uD83C\uDDFB\uD83C\uDDFA"
    },
    {
        countryNameEn: "Wallis and Futuna",
        countryNameLocal: "Wallis-et-Futuna",
        countryCode: "WF",
        currencyCode: "XPF",
        currencyNameEn: "CFP franc (franc Pacifique)",
        tinType: "",
        tinName: "",
        officialLanguageCode: "fr",
        officialLanguageNameEn: "French",
        officialLanguageNameLocal: "Fran\xe7ais",
        countryCallingCode: "681",
        areaCodes: [],
        region: "Asia & Pacific",
        flag: "\uD83C\uDDFC\uD83C\uDDEB"
    },
    {
        countryNameEn: "Samoa",
        countryNameLocal: "Samoa",
        countryCode: "WS",
        currencyCode: "WST",
        currencyNameEn: "Samoan tala",
        tinType: "",
        tinName: "",
        officialLanguageCode: "sm",
        officialLanguageNameEn: "Samoan",
        officialLanguageNameLocal: "gagana fa'a Samoa",
        countryCallingCode: "685",
        areaCodes: [],
        region: "Asia & Pacific",
        flag: "\uD83C\uDDFC\uD83C\uDDF8"
    },
    {
        countryNameEn: "Yemen",
        countryNameLocal: "\u0627\u0644\u064A\u064E\u0645\u064E\u0646",
        countryCode: "YE",
        currencyCode: "YER",
        currencyNameEn: "Yemeni rial",
        tinType: "",
        tinName: "",
        officialLanguageCode: "ar",
        officialLanguageNameEn: "Arabic",
        officialLanguageNameLocal: "\u0627\u0644\u0639\u0631\u0628\u064A\u0629",
        countryCallingCode: "967",
        areaCodes: [],
        region: "Arab States",
        flag: "\uD83C\uDDFE\uD83C\uDDEA"
    },
    {
        countryNameEn: "Mayotte",
        countryNameLocal: "Mayotte",
        countryCode: "YT",
        currencyCode: "EUR",
        currencyNameEn: "Euro",
        tinType: "",
        tinName: "",
        officialLanguageCode: "fr",
        officialLanguageNameEn: "French",
        officialLanguageNameLocal: "Fran\xe7ais",
        countryCallingCode: "262",
        areaCodes: [],
        region: "Africa",
        flag: "\uD83C\uDDFE\uD83C\uDDF9"
    },
    {
        countryNameEn: "South Africa",
        countryNameLocal: "South Africa",
        countryCode: "ZA",
        currencyCode: "ZAR",
        currencyNameEn: "South African rand",
        tinType: "",
        tinName: "",
        officialLanguageCode: "en",
        officialLanguageNameEn: "English",
        officialLanguageNameLocal: "English",
        countryCallingCode: "27",
        areaCodes: [],
        region: "Africa",
        flag: "\uD83C\uDDFF\uD83C\uDDE6"
    },
    {
        countryNameEn: "Zambia",
        countryNameLocal: "Zambia",
        countryCode: "ZM",
        currencyCode: "ZMW",
        currencyNameEn: "Zambian kwacha",
        tinType: "",
        tinName: "",
        officialLanguageCode: "en",
        officialLanguageNameEn: "English",
        officialLanguageNameLocal: "English",
        countryCallingCode: "260",
        areaCodes: [],
        region: "Africa",
        flag: "\uD83C\uDDFF\uD83C\uDDF2"
    },
    {
        countryNameEn: "Zimbabwe",
        countryNameLocal: "Zimbabwe",
        countryCode: "ZW",
        currencyCode: "ZWL",
        currencyNameEn: "Zimbabwean dollar",
        tinType: "",
        tinName: "",
        officialLanguageCode: "en",
        officialLanguageNameEn: "English",
        officialLanguageNameLocal: "English",
        countryCallingCode: "263",
        areaCodes: [],
        region: "Africa",
        flag: "\uD83C\uDDFF\uD83C\uDDFC"
    },
    {
        countryNameEn: "Eswatini",
        countryNameLocal: "Swaziland",
        countryCode: "SZ",
        currencyCode: "SZL",
        currencyNameEn: "Swazi lilangeni",
        tinType: "",
        tinName: "",
        officialLanguageCode: "en",
        officialLanguageNameEn: "English",
        officialLanguageNameLocal: "English",
        countryCallingCode: "268",
        areaCodes: [],
        region: "Africa",
        flag: "\uD83C\uDDF8\uD83C\uDDFF"
    },
    {
        countryNameEn: "North Macedonia",
        countryNameLocal: "\u041C\u0430\u043A\u0435\u0434\u043E\u043D\u0438\u0458\u0430",
        countryCode: "MK",
        currencyCode: "MKD",
        currencyNameEn: "Macedonian denar",
        tinType: "",
        tinName: "",
        officialLanguageCode: "mk",
        officialLanguageNameEn: "Macedonian",
        officialLanguageNameLocal: "\u043C\u0430\u043A\u0435\u0434\u043E\u043D\u0441\u043A\u0438 \u0458\u0430\u0437\u0438\u043A",
        countryCallingCode: "389",
        areaCodes: [],
        region: "Europe",
        flag: "\uD83C\uDDF2\uD83C\uDDF0"
    },
    {
        countryNameEn: "Philippines",
        countryNameLocal: "Philippines",
        countryCode: "PH",
        currencyCode: "PHP",
        currencyNameEn: "Philippine peso",
        tinType: "TIN",
        tinName: "Tax Identification Number",
        officialLanguageCode: "en",
        officialLanguageNameEn: "English",
        officialLanguageNameLocal: "English",
        countryCallingCode: "63",
        areaCodes: [],
        region: "Asia & Pacific",
        flag: "\uD83C\uDDF5\uD83C\uDDED"
    },
    {
        countryNameEn: "Netherlands",
        countryNameLocal: "Nederland",
        countryCode: "NL",
        currencyCode: "EUR",
        currencyNameEn: "Euro",
        tinType: "Btw-nr.",
        tinName: "Btw-nummer",
        officialLanguageCode: "nl",
        officialLanguageNameEn: "Dutch, Flemish",
        officialLanguageNameLocal: "Nederlands, Vlaams",
        countryCallingCode: "31",
        areaCodes: [],
        region: "Europe",
        flag: "\uD83C\uDDF3\uD83C\uDDF1"
    },
    {
        countryNameEn: "United Arab Emirates",
        countryNameLocal: "\u062F\u0648\u0644\u0629 \u0627\u0644\u0625\u0645\u0627\u0631\u0627\u062A \u0627\u0644\u0639\u0631\u0628\u064A\u0651\u0629 \u0627\u0644\u0645\u062A\u0651\u062D\u062F\u0629",
        countryCode: "AE",
        currencyCode: "AED",
        currencyNameEn: "United Arab Emirates dirham",
        tinType: "",
        tinName: "",
        officialLanguageCode: "ar",
        officialLanguageNameEn: "Arabic",
        officialLanguageNameLocal: "\u0627\u0644\u0639\u0631\u0628\u064A\u0629",
        countryCallingCode: "971",
        areaCodes: [],
        region: "Arab States",
        flag: "\uD83C\uDDE6\uD83C\uDDEA"
    },
    {
        countryNameEn: "Republic of Moldova",
        countryNameLocal: "Moldova, \u041C\u043E\u043B\u0434\u0430\u0432\u0438\u044F",
        countryCode: "MD",
        currencyCode: "MDL",
        currencyNameEn: "Moldovan leu",
        tinType: "",
        tinName: "",
        officialLanguageCode: "ro",
        officialLanguageNameEn: "Romanian, Moldavian, Moldovan",
        officialLanguageNameLocal: "Rom\xe2n\u0103",
        countryCallingCode: "373",
        areaCodes: [],
        region: "Europe",
        flag: "\uD83C\uDDF2\uD83C\uDDE9"
    },
    {
        countryNameEn: "Gambia",
        countryNameLocal: "The Gambia",
        countryCode: "GM",
        currencyCode: "GMD",
        currencyNameEn: "Gambian dalasi",
        tinType: "",
        tinName: "",
        officialLanguageCode: "en",
        officialLanguageNameEn: "English",
        officialLanguageNameLocal: "English",
        countryCallingCode: "220",
        areaCodes: [],
        region: "Africa",
        flag: "\uD83C\uDDEC\uD83C\uDDF2"
    },
    {
        countryNameEn: "Dominican Republic",
        countryNameLocal: "Rep\xfablica Dominicana",
        countryCode: "DO",
        currencyCode: "DOP",
        currencyNameEn: "Dominican peso",
        tinType: "RNC",
        tinName: "Registro Nacional del Contribuyente",
        officialLanguageCode: "es",
        officialLanguageNameEn: "Spanish, Castilian",
        officialLanguageNameLocal: "Espa\xf1ol",
        countryCallingCode: "1",
        areaCodes: [],
        region: "South/Latin America",
        flag: "\uD83C\uDDE9\uD83C\uDDF4"
    },
    {
        countryNameEn: "Sudan",
        countryNameLocal: "\u0627\u0644\u0633\u0648\u062F\u0627\u0646",
        countryCode: "SD",
        currencyCode: "SDG",
        currencyNameEn: "Sudanese pound",
        tinType: "",
        tinName: "",
        officialLanguageCode: "ar",
        officialLanguageNameEn: "Arabic",
        officialLanguageNameLocal: "\u0627\u0644\u0639\u0631\u0628\u064A\u0629",
        countryCallingCode: "249",
        areaCodes: [],
        region: "Arab States",
        flag: "\uD83C\uDDF8\uD83C\uDDE9"
    },
    {
        countryNameEn: "Lao People's Democratic Republic",
        countryNameLocal: "\u0E9B\u0EB0\u0E8A\u0EB2\u0E8A\u0EBB\u0E99\u0EA5\u0EB2\u0EA7",
        countryCode: "LA",
        currencyCode: "LAK",
        currencyNameEn: "Lao kip",
        tinType: "",
        tinName: "",
        officialLanguageCode: "lo",
        officialLanguageNameEn: "Lao",
        officialLanguageNameLocal: "\u0E9E\u0EB2\u0EAA\u0EB2\u0EA5\u0EB2\u0EA7",
        countryCallingCode: "856",
        areaCodes: [],
        region: "Asia & Pacific",
        flag: "\uD83C\uDDF1\uD83C\uDDE6"
    },
    {
        countryNameEn: "Taiwan, Province of China",
        countryNameLocal: "Taiwan",
        countryCode: "TW",
        currencyCode: "TWD",
        currencyNameEn: "New Taiwan dollar",
        tinType: "",
        tinName: "",
        officialLanguageCode: "zh-hant",
        officialLanguageNameEn: "",
        officialLanguageNameLocal: "",
        countryCallingCode: "886",
        areaCodes: [],
        region: "Asia & Pacific",
        flag: "\uD83C\uDDF9\uD83C\uDDFC"
    },
    {
        countryNameEn: "Republic of the Congo",
        countryNameLocal: "R\xe9publique du Congo",
        countryCode: "CG",
        currencyCode: "XAF",
        currencyNameEn: "CFA franc BEAC",
        tinType: "",
        tinName: "",
        officialLanguageCode: "fr",
        officialLanguageNameEn: "French",
        officialLanguageNameLocal: "Fran\xe7ais",
        countryCallingCode: "242",
        areaCodes: [],
        region: "Africa",
        flag: "\uD83C\uDDE8\uD83C\uDDEC"
    },
    {
        countryNameEn: "Czechia",
        countryNameLocal: "\u010Cesk\xe1 republika",
        countryCode: "CZ",
        currencyCode: "CZK",
        currencyNameEn: "Czech koruna",
        tinType: "DI\u010C",
        tinName: "Da\u0148ov\xe9 identifika\u010Dn\xed \u010D\xedslo",
        officialLanguageCode: "cs",
        officialLanguageNameEn: "Czech",
        officialLanguageNameLocal: "\u010Ce\u0161tina",
        countryCallingCode: "420",
        areaCodes: [],
        region: "Europe",
        flag: "\uD83C\uDDE8\uD83C\uDDFF"
    },
    {
        countryNameEn: "United Kingdom",
        countryNameLocal: "Great Britain",
        countryCode: "GB",
        currencyCode: "GBP",
        currencyNameEn: "Pound sterling",
        tinType: "VAT Reg No",
        tinName: "Value added tax registration number",
        officialLanguageCode: "en",
        officialLanguageNameEn: "English",
        officialLanguageNameLocal: "English",
        countryCallingCode: "44",
        areaCodes: [],
        region: "Europe",
        flag: "\uD83C\uDDEC\uD83C\uDDE7"
    },
    {
        countryNameEn: "Niger",
        countryNameLocal: "Niger",
        countryCode: "NE",
        currencyCode: "XOF",
        currencyNameEn: "CFA franc BCEAO",
        tinType: "",
        tinName: "",
        officialLanguageCode: "fr",
        officialLanguageNameEn: "French",
        officialLanguageNameLocal: "Fran\xe7ais",
        countryCallingCode: "227",
        areaCodes: [],
        region: "Africa",
        flag: "\uD83C\uDDF3\uD83C\uDDEA"
    },
    {
        countryNameEn: "Democratic Republic of the Congo",
        countryNameLocal: "Democratic Republic of the Congo",
        countryCode: "CD",
        currencyCode: "CDF",
        currencyNameEn: "Congolese franc",
        tinType: "",
        tinName: "",
        officialLanguageCode: "fr",
        officialLanguageNameEn: "French",
        officialLanguageNameLocal: "Fran\xe7ais",
        countryCallingCode: "243",
        areaCodes: [],
        region: "Africa",
        flag: "\uD83C\uDDE8\uD83C\uDDE9"
    },
    {
        countryNameEn: "Commonwealth of The Bahamas",
        countryNameLocal: "Commonwealth of The Bahamas",
        countryCode: "BS",
        currencyCode: "BSD",
        currencyNameEn: "Bahamian dollar",
        tinType: "",
        tinName: "",
        officialLanguageCode: "en",
        officialLanguageNameEn: "English",
        officialLanguageNameLocal: "English",
        countryCallingCode: "1 242",
        areaCodes: [],
        region: "Caribbean",
        flag: "\uD83C\uDDE7\uD83C\uDDF8"
    },
    {
        countryNameEn: "Cocos (Keeling) Islands",
        countryNameLocal: "Pulu Kokos (Keeling)",
        countryCode: "CC",
        currencyCode: "AUD",
        currencyNameEn: "Australian dollar",
        tinType: "",
        tinName: "",
        officialLanguageCode: "en",
        officialLanguageNameEn: "English",
        officialLanguageNameLocal: "English",
        countryCallingCode: "61 891",
        areaCodes: [],
        region: "Australia",
        flag: "\uD83C\uDDE8\uD83C\uDDE8"
    },
    {
        countryNameEn: "Central African Republic",
        countryNameLocal: "R\xe9publique centrafricaine",
        countryCode: "CF",
        currencyCode: "XAF",
        currencyNameEn: "Central African CFA",
        tinType: "",
        tinName: "",
        officialLanguageCode: "fr",
        officialLanguageNameEn: "French",
        officialLanguageNameLocal: "Fran\xe7ais",
        countryCallingCode: "236",
        areaCodes: [],
        region: "Africa",
        flag: "\uD83C\uDDE8\uD83C\uDDEB"
    },
    {
        countryNameEn: "Cook Islands",
        countryNameLocal: "K\u016Bki '\u0100irani",
        countryCode: "CK",
        currencyCode: "NZD",
        currencyNameEn: "New Zealand dollar",
        tinType: "",
        tinName: "",
        officialLanguageCode: "en",
        officialLanguageNameEn: "English",
        officialLanguageNameLocal: "English",
        countryCallingCode: "682",
        areaCodes: [],
        region: "South Pacific Ocean",
        flag: "\uD83C\uDDE8\uD83C\uDDF0"
    },
    {
        countryNameEn: "Falkland Islands",
        countryNameLocal: "Falkland Islands",
        countryCode: "FK",
        currencyCode: "FKP",
        currencyNameEn: "Falklands pound",
        tinType: "",
        tinName: "",
        officialLanguageCode: "en",
        officialLanguageNameEn: "English",
        officialLanguageNameLocal: "English",
        countryCallingCode: "500",
        areaCodes: [],
        region: "South Atlantic Ocean",
        flag: "\uD83C\uDDEB\uD83C\uDDF0"
    },
    {
        countryNameEn: "Faroe Islands",
        countryNameLocal: "F\xe6r\xf8erne",
        countryCode: "FO",
        currencyCode: "DKK",
        currencyNameEn: "Faroese kr\xf3na",
        tinType: "",
        tinName: "",
        officialLanguageCode: "da",
        officialLanguageNameEn: "Danish",
        officialLanguageNameLocal: "dansk",
        countryCallingCode: "298",
        areaCodes: [],
        region: "Europe",
        flag: "\uD83C\uDDEB\uD83C\uDDF4"
    },
    {
        countryNameEn: "Territory of Heard Island and McDonald Islands",
        countryNameLocal: "Territory of Heard Island and McDonald Islands",
        countryCode: "HM",
        currencyCode: "AUD",
        currencyNameEn: "Australian dollar",
        tinType: "",
        tinName: "",
        officialLanguageCode: "en",
        officialLanguageNameEn: "English",
        officialLanguageNameLocal: "English",
        countryCallingCode: "672",
        areaCodes: [],
        region: "Indian Ocean",
        flag: "\uD83C\uDDED\uD83C\uDDF2"
    },
    {
        countryNameEn: "British Indian Ocean Territory",
        countryNameLocal: "British Indian Ocean Territory",
        countryCode: "IO",
        currencyCode: "USD",
        currencyNameEn: "United States Dollar",
        tinType: "",
        tinName: "",
        officialLanguageCode: "en",
        officialLanguageNameEn: "English",
        officialLanguageNameLocal: "English",
        countryCallingCode: "246",
        areaCodes: [],
        region: "Indian Ocean",
        flag: "\uD83C\uDDEE\uD83C\uDDF4"
    },
    {
        countryNameEn: "Comoros",
        countryNameLocal: "Umoja wa Komori",
        countryCode: "KM",
        currencyCode: "KMF",
        currencyNameEn: "Comorian franc",
        tinType: "",
        tinName: "",
        officialLanguageCode: "fr",
        officialLanguageNameEn: "French",
        officialLanguageNameLocal: "Fran\xe7ais",
        countryCallingCode: "269",
        areaCodes: [],
        region: "Indian Ocean",
        flag: "\uD83C\uDDF0\uD83C\uDDF2"
    },
    {
        countryNameEn: "Cayman Islands",
        countryNameLocal: "Cayman Islands",
        countryCode: "KY",
        currencyCode: "KYD",
        currencyNameEn: "Cayman Islands dollar",
        tinType: "",
        tinName: "",
        officialLanguageCode: "en",
        officialLanguageNameEn: "English",
        officialLanguageNameLocal: "English",
        countryCallingCode: "1 345",
        areaCodes: [],
        region: "Caribbean Sea",
        flag: "\uD83C\uDDF0\uD83C\uDDFE"
    },
    {
        countryNameEn: "Republic of the Marshall Islands",
        countryNameLocal: "Aolep\u0101n Aor\u014Dkin \u1E42aje\u1E37",
        countryCode: "MH",
        currencyCode: "USD",
        currencyNameEn: "United States dollar",
        tinType: "",
        tinName: "",
        officialLanguageCode: "en",
        officialLanguageNameEn: "English",
        officialLanguageNameLocal: "English",
        countryCallingCode: "692",
        areaCodes: [],
        region: "Pacific Ocean",
        flag: "\uD83C\uDDF2\uD83C\uDDED"
    },
    {
        countryNameEn: "Commonwealth of the Northern Mariana Islands",
        countryNameLocal: "Sankattan Siha Na Islas Mari\xe5nas",
        countryCode: "MP",
        currencyCode: "USD",
        currencyNameEn: "United States dollar",
        tinType: "",
        tinName: "",
        officialLanguageCode: "en",
        officialLanguageNameEn: "English",
        officialLanguageNameLocal: "English",
        countryCallingCode: "1 670",
        areaCodes: [],
        region: "Pacific Ocean",
        flag: "\uD83C\uDDF2\uD83C\uDDF5"
    },
    {
        countryNameEn: "Turks and Caicos Islands",
        countryNameLocal: "Turks and Caicos Islands",
        countryCode: "TC",
        currencyCode: "USD",
        currencyNameEn: "United States dollar",
        tinType: "",
        tinName: "",
        officialLanguageCode: "en",
        officialLanguageNameEn: "English",
        officialLanguageNameLocal: "English",
        countryCallingCode: "1 649",
        areaCodes: [],
        region: "Atlantic Ocean",
        flag: "\uD83C\uDDF9\uD83C\uDDE8"
    },
    {
        countryNameEn: "French Southern and Antarctic Lands",
        countryNameLocal: "Terres australes et antarctiques fran\xe7aises",
        countryCode: "TF",
        currencyCode: "EUR",
        currencyNameEn: "Euro",
        tinType: "",
        tinName: "",
        officialLanguageCode: "fr",
        officialLanguageNameEn: "French",
        officialLanguageNameLocal: "Fran\xe7ais",
        countryCallingCode: "672",
        areaCodes: [],
        region: "Indian Ocean",
        flag: "\uD83C\uDDF9\uD83C\uDDEB"
    },
    {
        countryNameEn: "United States Minor Outlying Islands",
        countryNameLocal: "United States Minor Outlying Islands",
        countryCode: "UM",
        currencyCode: "USD",
        currencyNameEn: "United States dollar",
        tinType: "",
        tinName: "",
        officialLanguageCode: "en",
        officialLanguageNameEn: "English",
        officialLanguageNameLocal: "English",
        countryCallingCode: "1",
        areaCodes: [],
        region: "Pacific Ocean",
        flag: "\uD83C\uDDFA\uD83C\uDDF2"
    },
    {
        countryNameEn: "Holy See",
        countryNameLocal: "Sancta Sedes",
        countryCode: "VA",
        currencyCode: "EUR",
        currencyNameEn: "Euro",
        tinType: "",
        tinName: "",
        officialLanguageCode: "la",
        officialLanguageNameEn: "Latin",
        officialLanguageNameLocal: "lingua lat\u012Bna",
        countryCallingCode: "39",
        areaCodes: [],
        region: "Europe",
        flag: "\uD83C\uDDFB\uD83C\uDDE6"
    },
    {
        countryNameEn: "Republic of Kosovo",
        countryNameLocal: "Republika e Kosov\xebs",
        countryCode: "XK",
        currencyCode: "EUR",
        currencyNameEn: "Euro",
        tinType: "",
        tinName: "",
        officialLanguageCode: "sq",
        officialLanguageNameEn: "Albanian",
        officialLanguageNameLocal: "Shqip",
        countryCallingCode: "383",
        region: "Europe",
        flag: "\uD83C\uDDFD\uD83C\uDDF0"
    },
    {
        countryNameEn: "Netherlands Antilles",
        countryNameLocal: "Nederlandse Antillen",
        countryCode: "AN",
        currencyCode: "ANG",
        currencyNameEn: "Netherlands Antillean guilder",
        tinType: "",
        tinName: "",
        officialLanguageCode: "nl",
        officialLanguageNameEn: "Dutch, Flemish",
        officialLanguageNameLocal: "Nederlands, Vlaams",
        countryCallingCode: "599",
        region: "Europe",
        flag: "\uD83C\uDDE7\uD83C\uDDF6"
    }
];
module.exports.default = $0acc96342647e474$var$countriesData;

});



parcelRegister("gBv4p", function(module, exports) {

var $lHoPV = parcelRequire("lHoPV");
(0, $lHoPV.TypeValidator)($c16833e72b319999$export$50792b0e93539fde);
function $c16833e72b319999$export$50792b0e93539fde(token) {
    let res = "";
    let run = false;
    for (const c of token){
        if (c === "	" || c === "\n" || c === "\r") {
            if (!run) {
                run = true;
                res += " ";
            }
        } else {
            run = false;
            res += c;
        }
    }
    return res;
}

});

parcelRegister("iXeBy", function(module, exports) {

$parcel$export(module.exports, "Url", function () { return $dcc910dd5223d4d2$export$59d795186a5d3f58; });

var $lHoPV = parcelRequire("lHoPV");
(0, $lHoPV.TypeValidator)($dcc910dd5223d4d2$export$59d795186a5d3f58);
function $dcc910dd5223d4d2$export$59d795186a5d3f58(url) {
    return url;
}

});


parcelRegister("hsrrX", function(module, exports) {

$parcel$export(module.exports, "Color", function () { return $cb5a58304adaf600$export$892596cec99bc70e; });

var $lHoPV = parcelRequire("lHoPV");
(0, $lHoPV.TypeValidator)($cb5a58304adaf600$export$892596cec99bc70e);
function $cb5a58304adaf600$export$892596cec99bc70e(color) {
    return color;
}
/**
 * Returns the luminance of a hex color in the range [0, 255].
 *
 * Uses the formula from https://www.w3.org/TR/WCAG20/#relativeluminancedef
 */ $cb5a58304adaf600$export$892596cec99bc70e.getLuminance = (hex)=>{
    const rgb = parseInt(hex, 16);
    const r = rgb >> 16 & 0xff;
    const g = rgb >> 8 & 0xff;
    const b = rgb & 0xff;
    return 0.2126 * r + 0.7152 * g + 0.0722 * b;
};
/**
 * Returns whether a hex color is dark (less than 50% luminance).
 *
 * This can e.g. be used to determine whether to use a light or dark text color
 * on top of a background color.
 */ $cb5a58304adaf600$export$892596cec99bc70e.isDark = (hex)=>$cb5a58304adaf600$export$892596cec99bc70e.getLuminance(hex) < 128;

});

parcelRegister("6pFwm", function(module, exports) {

$parcel$export(module.exports, "Clone", function () { return $4ab5490cf9310952$export$b5d07669a5562b23; });
function $4ab5490cf9310952$export$b5d07669a5562b23(obj) {
    if (typeof obj !== "object") return obj;
    return JSON.parse(JSON.stringify(obj));
}

});

parcelRegister("5c9Ym", function(module, exports) {

$parcel$export(module.exports, "CreateDefault", function () { return $3c85cf15e8f9fc08$export$64083afede9217e1; });
$parcel$export(module.exports, "DefaultDefaults", function () { return $3c85cf15e8f9fc08$export$73100be7e4e9cd6e; });
$parcel$export(module.exports, "UninitializedDefaults", function () { return $3c85cf15e8f9fc08$export$3e00805fcb1cfee7; });
$parcel$export(module.exports, "UninitializedArrayValue", function () { return $3c85cf15e8f9fc08$export$9948121d4484b3a3; });
$parcel$export(module.exports, "Default", function () { return $3c85cf15e8f9fc08$export$39bcc3f08a9b5fa4; });

var $cwhCA = parcelRequire("cwhCA");

var $34lt5 = parcelRequire("34lt5");

var $fK1QV = parcelRequire("fK1QV");

var $dAwef = parcelRequire("dAwef");

var $43jhg = parcelRequire("43jhg");

var $8h5s0 = parcelRequire("8h5s0");

var $lyFh9 = parcelRequire("lyFh9");

var $k71sq = parcelRequire("k71sq");
function $3c85cf15e8f9fc08$export$fafc52a04a0a9d07(type, defaults, locale) {
    const res = {};
    (0, $43jhg.GetTypeProps)(type).forEach((prop)=>{
        const value = $3c85cf15e8f9fc08$export$609e8570bac5255e(prop, defaults, locale);
        if (value !== undefined) res[prop.name] = value;
    });
    return res;
}
function $3c85cf15e8f9fc08$export$609e8570bac5255e(prop, defaults, locale) {
    var _a, _b, _c, _d, _e;
    if ((_a = prop.tags) === null || _a === void 0 ? void 0 : _a.defaultFile) {
        const defaultFiles = (0, $cwhCA.GetReflectionInfo)().defaultFiles;
        if (!defaultFiles) throw new Error("No default files found");
        const file = (_b = defaultFiles[prop.tags.defaultFile]) === null || _b === void 0 ? void 0 : _b.file;
        if (!file) throw new Error(`No default file found for ${prop.tags.defaultFile}`);
        return file;
    }
    if ((_c = prop.tags) === null || _c === void 0 ? void 0 : _c.serial) // -1 = PGTable.SerialInteger default. We don't want to import
    // `PGTable` in this file, so hardcoding it.
    return -1;
    if (typeof prop.type === "object" && prop.type.reference) return; // Do not fill in bogus Uuid/key
    const def = ((_d = prop.tags) === null || _d === void 0 ? void 0 : _d.default) !== undefined ? (0, $fK1QV.ParseTagValue)("default", (_e = prop.tags) === null || _e === void 0 ? void 0 : _e.default, prop.type) : undefined;
    if (def !== undefined) return def;
    else {
        if (!prop.optional) return $3c85cf15e8f9fc08$export$64083afede9217e1(prop.type, defaults, locale);
    }
}
const $3c85cf15e8f9fc08$export$73100be7e4e9cd6e = {
    string: "",
    number: 0,
    boolean: false,
    null: null,
    array (item, defaults) {
        return [];
    },
    object (type, defaults, locale) {
        return $3c85cf15e8f9fc08$export$fafc52a04a0a9d07(type, defaults, locale);
    },
    intersection (type, defaults, locale) {
        return type.intersection.map((t)=>$3c85cf15e8f9fc08$export$64083afede9217e1(t, defaults, locale)).reduce((a, b)=>{
            if (a !== null && b !== null && typeof a === "object" && typeof b === "object") return Object.assign(a, b);
            else // Not an object - that means its some form of primitive type where both a and b
            // are valid values. Let's return one of them
            return a;
        });
    },
    uuid (type) {
        if (typeof type === "object" && type.reference) return undefined;
        return (0, $dAwef.Uuid)();
    }
};
const $3c85cf15e8f9fc08$export$ab9194fea8e5abfb = Object.assign(Object.assign({}, $3c85cf15e8f9fc08$export$73100be7e4e9cd6e), {
    string: "string",
    object (type, defaults, locale) {
        const props = $3c85cf15e8f9fc08$export$fafc52a04a0a9d07(type, defaults, locale);
        for (const p of (0, $43jhg.GetTypeProps)(type))if (props[p.name] === "" || props[p.name] === "string" || p.type === "string" && p.optional) props[p.name] = (0, $8h5s0.prettyCamel)(p.name, true);
        return props;
    }
});
const $3c85cf15e8f9fc08$export$3e00805fcb1cfee7 = {
    string: undefined,
    number: undefined,
    boolean: false,
    array () {
        return [];
    },
    object (type, defaults, locale) {
        return $3c85cf15e8f9fc08$export$fafc52a04a0a9d07(type, defaults, locale);
    },
    intersection (type, defaults, locale) {
        return type.intersection.map((t)=>$3c85cf15e8f9fc08$export$64083afede9217e1(t, defaults, locale)).reduce((a, b)=>{
            if (a !== null && b !== null && typeof a === "object" && typeof b === "object") return Object.assign(a, b);
            else // Not an object - that means its some form of primitive type where both a and b
            // are valid values. Let's return one of them
            return a;
        });
    },
    uuid (type) {
        if (typeof type === "object" && type.reference) return undefined;
        return (0, $dAwef.Uuid)();
    }
};
const $3c85cf15e8f9fc08$export$9948121d4484b3a3 = Object.assign(Object.assign({}, $3c85cf15e8f9fc08$export$3e00805fcb1cfee7), {
    string: "",
    number: 0
});
function $3c85cf15e8f9fc08$export$64083afede9217e1(type, defaults = $3c85cf15e8f9fc08$export$73100be7e4e9cd6e, /** The locale that will be used as the only initial key in any `Localized<T>` value. */ locale = (0, $34lt5.LocaleKey).en, ignoreDefaultFunctions = false) {
    const alias = (0, $43jhg.GetTypeAlias)(type);
    if (alias && alias in defaults) return defaults[alias];
    if (alias && !ignoreDefaultFunctions) {
        const func = $3c85cf15e8f9fc08$var$getDefaultFuncForType(alias);
        if (func) {
            // Get the defaults without invoking the function
            const t = $3c85cf15e8f9fc08$export$64083afede9217e1(type, defaults, locale, true);
            // Invoke the function
            const res = func(t);
            if (res !== undefined) return res;
            return t;
        }
    }
    if (alias === "Uuid") return defaults.uuid ? defaults.uuid(type) : (0, $dAwef.Uuid)();
    if (alias === "RichText") return (0, $lyFh9.RichText)();
    if (typeof type === "object" && alias === "Localized" && type.typeArgs) // Localized values must have at least one locale defined to be valid
    return {
        [locale]: $3c85cf15e8f9fc08$export$64083afede9217e1(type.typeArgs[0], defaults, locale)
    };
    if ((0, $43jhg.IsAnyType)(type) || (0, $43jhg.IsUnknownType)(type)) return {};
    else if ((0, $43jhg.IsStringType)(type)) {
        if (typeof type === "object" && type.string !== null) return type.string;
        return "string" in defaults ? defaults.string : $3c85cf15e8f9fc08$export$73100be7e4e9cd6e.string;
    } else if ((0, $43jhg.IsNumberType)(type)) {
        if (typeof type === "object" && type.number !== null) return type.number;
        return "number" in defaults ? defaults.number : $3c85cf15e8f9fc08$export$73100be7e4e9cd6e.number;
    } else if ((0, $43jhg.IsBooleanType)(type)) {
        if (typeof type === "object" && type.boolean !== null) return type.boolean;
        return "boolean" in defaults ? defaults.boolean : $3c85cf15e8f9fc08$export$73100be7e4e9cd6e.boolean;
    } else if ((0, $43jhg.IsNullType)(type)) return "null" in defaults ? defaults.null : $3c85cf15e8f9fc08$export$73100be7e4e9cd6e.null;
    else if ((0, $43jhg.IsUndefinedType)(type)) return undefined;
    else if ((0, $43jhg.IsUnionType)(type)) {
        // The TypeScript compiler sometimes re-uses union types internally,
        // e.g. if one type `"a" | "b"` is encountered first, and then `"b" |
        // "a"`, they will sometimes be merged into a single union type. This
        // means that the order of the union types in the source code definition
        // is not guaranteed to be the same as the order of the union types in
        // the reflection info. To make sure we generate consistent results, we
        // sort the union types by their string representation before picking
        // the first one.
        if (type.union.length > 0 && type.union.every((t)=>(0, $43jhg.IsStringType)(t) && typeof t === "object" && t.string !== null)) {
            const sortedUnion = type.union.slice().sort((a, b)=>a.string.localeCompare(b.string));
            return sortedUnion[0].string;
        }
        return $3c85cf15e8f9fc08$export$64083afede9217e1(type.union[0], defaults, locale);
    } else if ((0, $43jhg.IsIntersectionType)(type)) return defaults.intersection ? defaults.intersection(type, defaults, locale) : $3c85cf15e8f9fc08$export$73100be7e4e9cd6e.intersection(type, defaults, locale);
    else if ((0, $43jhg.IsArrayType)(type)) return defaults.array ? defaults.array(type.array, defaults, locale) : $3c85cf15e8f9fc08$export$73100be7e4e9cd6e.array(type.array, defaults);
    else if ((0, $43jhg.IsObjectType)(type)) return defaults.object ? defaults.object(type, defaults, locale) : $3c85cf15e8f9fc08$export$73100be7e4e9cd6e.object(type, defaults, locale);
    else if ((0, $43jhg.IsFileType)(type)) return defaults.file;
    else if ((0, $43jhg.IsVoidType)(type)) return undefined;
    else if ((0, $43jhg.IsNeverType)(type)) throw new Error("Cannot create a default value of type 'never'");
    throw new Error("CreateDefault: Unhandled type: " + (0, $43jhg.TypeToString)(type));
}
function $3c85cf15e8f9fc08$export$39bcc3f08a9b5fa4(/**
 * The function that provides the default.
 *
 * Returns the default value, or `void` if the function mutates the input
 * value and does not return a new one.
 */ defaultProvider, /**
 * If provided, this registers the default provider for the given type name,
 * without relying on reflection.
 */ typeName) {
    Object.assign(defaultProvider, {
        fileName: (0, $k71sq.CallSites)()[1].getFileName()
    });
    $3c85cf15e8f9fc08$export$39bcc3f08a9b5fa4.functions.push(defaultProvider);
    if (typeName) $3c85cf15e8f9fc08$var$defaultFuncForTypeCache.set(typeName, defaultProvider);
}
$3c85cf15e8f9fc08$export$39bcc3f08a9b5fa4.functions = [];
const $3c85cf15e8f9fc08$var$defaultFuncForTypeCache = new Map();
function $3c85cf15e8f9fc08$var$getDefaultFuncForType(typeName) {
    const res = $3c85cf15e8f9fc08$var$defaultFuncForTypeCache.get(typeName);
    if (res === null) return undefined;
    if (res) return res;
    const defaults = (0, $cwhCA.IsReflectionInfoReady)() ? (0, $cwhCA.GetReflectionInfo)().defaults : [];
    // Match up the correct functions based on their declaration order in the source file
    for (const f of defaults){
        for(let i = 0; i < f.types.length; i++)if (f.types[i] === typeName) {
            let c = 0;
            for(let n = 0; n < $3c85cf15e8f9fc08$export$39bcc3f08a9b5fa4.functions.length; n++){
                const fn = $3c85cf15e8f9fc08$export$39bcc3f08a9b5fa4.functions[n];
                if (!fn.fileName) continue;
                const sourcePath = (0, $k71sq.ResolveTypeScriptSourceFile)(fn.fileName);
                const foo = (0, $k71sq.ResolveTypeScriptSourceFile)(f.sourcePath);
                if (sourcePath === foo) {
                    if (c === i) {
                        $3c85cf15e8f9fc08$var$defaultFuncForTypeCache.set(typeName, fn);
                        return fn;
                    }
                    c++;
                }
            }
        }
    }
    $3c85cf15e8f9fc08$var$defaultFuncForTypeCache.set(typeName, null);
}

});
parcelRegister("34lt5", function(module, exports) {

$parcel$export(module.exports, "LocaleKey", function () { return $23c265f07b7f1f26$export$8f9bd71e42971d18; });
$parcel$export(module.exports, "getLocaleKeyMoment", function () { return $23c265f07b7f1f26$export$aba88338213610b8; });
function $23c265f07b7f1f26$export$8f9bd71e42971d18(key) {
    return key;
}
/** International English locale (default). */ $23c265f07b7f1f26$export$8f9bd71e42971d18.en = $23c265f07b7f1f26$export$8f9bd71e42971d18("en");
/** Norwegian (bokmål). */ $23c265f07b7f1f26$export$8f9bd71e42971d18.no = $23c265f07b7f1f26$export$8f9bd71e42971d18("no");
/** Swedish. */ $23c265f07b7f1f26$export$8f9bd71e42971d18.sv = $23c265f07b7f1f26$export$8f9bd71e42971d18("sv");
const $23c265f07b7f1f26$export$aba88338213610b8 = (l)=>{
    // This can be easily extended with a switch to support multiple discrepancies
    return l === $23c265f07b7f1f26$export$8f9bd71e42971d18.no ? "nb" : (l === null || l === void 0 ? void 0 : l.valueOf()) || "en";
};

});

parcelRegister("fK1QV", function(module, exports) {

$parcel$export(module.exports, "ParseTagValue", function () { return $b75c96ceff12131f$export$235e153031164642; });

var $43jhg = parcelRequire("43jhg");

var $dAwef = parcelRequire("dAwef");
function $b75c96ceff12131f$export$803216f325b64510(tags, tagName) {
    const defaultStrings = tags === null || tags === void 0 ? void 0 : tags.filter((t)=>t.title === tagName).map((t)=>t.description);
    if (defaultStrings === null || defaultStrings === void 0 ? void 0 : defaultStrings.length) {
        const res = {};
        for (let s of defaultStrings)if (s) {
            let locale;
            const i = s.indexOf(" ");
            if (i !== -1) {
                locale = s.slice(0, i);
                s = s.slice(i + 1);
            } else throw new Error("Invalid tag: Must specify locale key first");
            // Extract genus hints
            if (locale.includes(":")) {
                const [key, genus] = locale.split(":");
                locale = key;
                res[locale + ":genus"] = genus;
            }
            // Replaces all new lines in s with escaped new lines
            s = s.replace(/\n/g, "\\n");
            if (s.startsWith('"') && s.endsWith('"')) s = s.slice(1, -1);
            res[locale] = s;
        }
        return res;
    }
}
function $b75c96ceff12131f$export$235e153031164642(tagName, s, type) {
    function isCompatible(type, pred) {
        return pred(type) || (0, $43jhg.IsUnionType)(type) && type.union.every((t)=>isCompatible(t, pred));
    }
    let value;
    if (isCompatible(type, (0, $43jhg.IsStringType))) value = s.startsWith('"') ? JSON.parse(s) : s;
    else if (isCompatible(type, (0, $43jhg.IsNumberType))) value = parseFloat(s);
    else if (isCompatible(type, (0, $43jhg.IsBooleanType))) value = s === "true";
    else try {
        if (s.startsWith("'")) s = s.slice(1);
        if (s.endsWith("'")) s = s.slice(0, -1);
        while(s.includes("%UUID%"))s = s.replace("%UUID%", (0, $dAwef.Uuid)().valueOf());
        value = s ? JSON.parse(s) : null;
        const match = (0, $43jhg.MatchesType)(value, type);
        if (match !== true) throw new Error(`Type mismatch for @${tagName} value: ${(0, $43jhg.TypeDiagnosticToString)(match)}`);
    } catch (e) {
        throw new Error(`Unable to parse JSON for @${tagName} tag: ${e.message}, value: ${s}`);
    }
    return value;
}

});

parcelRegister("k71sq", function(module, exports) {

$parcel$export(module.exports, "CallSites", function () { return $ea4597855aa41024$export$33223852e6b80b5f; });
$parcel$export(module.exports, "ResolveTypeScriptSourceFile", function () { return $ea4597855aa41024$export$427395a5f76562ba; });

var $b9Wiv = parcelRequire("b9Wiv");

var $8Hv2S = parcelRequire("8Hv2S");
function $ea4597855aa41024$export$33223852e6b80b5f() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($b9Wiv))).getSync().slice(1);
}
function $ea4597855aa41024$export$427395a5f76562ba(/** The file name as returned by `CallSites()` */ sourcePath) {
    sourcePath = (0, (/*@__PURE__*/$parcel$interopDefault($8Hv2S))).relative(".", sourcePath);
    // TODO: This is a hack to get the file name of the function's corresponding TS
    // file. Ideally there should be no knowledge of the `build/` folder here.
    if (sourcePath.startsWith("build/")) sourcePath = sourcePath.substring(6);
    if (sourcePath === null || sourcePath === void 0 ? void 0 : sourcePath.endsWith(".js")) sourcePath = sourcePath.substring(0, sourcePath.length - 3) + ".ts";
    return sourcePath;
}
function $ea4597855aa41024$export$d2224cd1e9618412() {
    const stack = $ea4597855aa41024$export$33223852e6b80b5f();
    for (const sf of stack){
        const fn = sf.getFileName();
        if (fn === null || fn === void 0 ? void 0 : fn.includes("/models/")) {
            const modelName = fn.split("/models/")[1].split("/")[0];
            return modelName;
        }
    }
}

});
parcelRegister("b9Wiv", function(module, exports) {



(function(root, factory) {
    "use strict";
    // Universal Module Definition (UMD) to support AMD, CommonJS/Node.js, Rhino, and browsers.
    /* istanbul ignore next */ if (typeof define === "function" && define.amd) define("stacktrace", [
        "error-stack-parser",
        "stack-generator",
        "stacktrace-gps"
    ], factory);
    else module.exports = factory((parcelRequire("5q4Xp")), (parcelRequire("FwcmS")), (parcelRequire("lKzMa")));
})(module.exports, function StackTrace(ErrorStackParser, StackGenerator, StackTraceGPS) {
    var _options = {
        filter: function(stackframe) {
            // Filter out stackframes for this library by default
            return (stackframe.functionName || "").indexOf("StackTrace$$") === -1 && (stackframe.functionName || "").indexOf("ErrorStackParser$$") === -1 && (stackframe.functionName || "").indexOf("StackTraceGPS$$") === -1 && (stackframe.functionName || "").indexOf("StackGenerator$$") === -1;
        },
        sourceCache: {}
    };
    var _generateError = function StackTrace$$GenerateError() {
        try {
            // Error must be thrown to get stack in IE
            throw new Error();
        } catch (err) {
            return err;
        }
    };
    /**
     * Merge 2 given Objects. If a conflict occurs the second object wins.
     * Does not do deep merges.
     *
     * @param {Object} first base object
     * @param {Object} second overrides
     * @returns {Object} merged first and second
     * @private
     */ function _merge(first, second) {
        var target = {};
        [
            first,
            second
        ].forEach(function(obj) {
            for(var prop in obj)if (Object.prototype.hasOwnProperty.call(obj, prop)) target[prop] = obj[prop];
            return target;
        });
        return target;
    }
    function _isShapedLikeParsableError(err) {
        return err.stack || err["opera#sourceloc"];
    }
    function _filtered(stackframes, filter) {
        if (typeof filter === "function") return stackframes.filter(filter);
        return stackframes;
    }
    return {
        /**
         * Get a backtrace from invocation point.
         *
         * @param {Object} opts
         * @returns {Array} of StackFrame
         */ get: function StackTrace$$get(opts) {
            var err = _generateError();
            return _isShapedLikeParsableError(err) ? this.fromError(err, opts) : this.generateArtificially(opts);
        },
        /**
         * Get a backtrace from invocation point.
         * IMPORTANT: Does not handle source maps or guess function names!
         *
         * @param {Object} opts
         * @returns {Array} of StackFrame
         */ getSync: function StackTrace$$getSync(opts) {
            opts = _merge(_options, opts);
            var err = _generateError();
            var stack = _isShapedLikeParsableError(err) ? ErrorStackParser.parse(err) : StackGenerator.backtrace(opts);
            return _filtered(stack, opts.filter);
        },
        /**
         * Given an error object, parse it.
         *
         * @param {Error} error object
         * @param {Object} opts
         * @returns {Promise} for Array[StackFrame}
         */ fromError: function StackTrace$$fromError(error, opts) {
            opts = _merge(_options, opts);
            var gps = new StackTraceGPS(opts);
            return new Promise((function(resolve) {
                var stackframes = _filtered(ErrorStackParser.parse(error), opts.filter);
                resolve(Promise.all(stackframes.map(function(sf) {
                    return new Promise(function(resolve) {
                        function resolveOriginal() {
                            resolve(sf);
                        }
                        gps.pinpoint(sf).then(resolve, resolveOriginal)["catch"](resolveOriginal);
                    });
                })));
            }).bind(this));
        },
        /**
         * Use StackGenerator to generate a backtrace.
         *
         * @param {Object} opts
         * @returns {Promise} of Array[StackFrame]
         */ generateArtificially: function StackTrace$$generateArtificially(opts) {
            opts = _merge(_options, opts);
            var stackFrames = StackGenerator.backtrace(opts);
            if (typeof opts.filter === "function") stackFrames = stackFrames.filter(opts.filter);
            return Promise.resolve(stackFrames);
        },
        /**
         * Given a function, wrap it such that invocations trigger a callback that
         * is called with a stack trace.
         *
         * @param {Function} fn to be instrumented
         * @param {Function} callback function to call with a stack trace on invocation
         * @param {Function} errback optional function to call with error if unable to get stack trace.
         * @param {Object} thisArg optional context object (e.g. window)
         */ instrument: function StackTrace$$instrument(fn, callback, errback, thisArg) {
            if (typeof fn !== "function") throw new Error("Cannot instrument non-function object");
            else if (typeof fn.__stacktraceOriginalFn === "function") // Already instrumented, return given Function
            return fn;
            var instrumented = (function StackTrace$$instrumented() {
                try {
                    this.get().then(callback, errback)["catch"](errback);
                    return fn.apply(thisArg || this, arguments);
                } catch (e) {
                    if (_isShapedLikeParsableError(e)) this.fromError(e).then(callback, errback)["catch"](errback);
                    throw e;
                }
            }).bind(this);
            instrumented.__stacktraceOriginalFn = fn;
            return instrumented;
        },
        /**
         * Given a function that has been instrumented,
         * revert the function to it's original (non-instrumented) state.
         *
         * @param {Function} fn to de-instrument
         */ deinstrument: function StackTrace$$deinstrument(fn) {
            if (typeof fn !== "function") throw new Error("Cannot de-instrument non-function object");
            else if (typeof fn.__stacktraceOriginalFn === "function") return fn.__stacktraceOriginalFn;
            else // Function not instrumented, return original
            return fn;
        },
        /**
         * Given an error message and Array of StackFrames, serialize and POST to given URL.
         *
         * @param {Array} stackframes
         * @param {String} url
         * @param {String} errorMsg
         * @param {Object} requestOptions
         */ report: function StackTrace$$report(stackframes, url, errorMsg, requestOptions) {
            return new Promise(function(resolve, reject) {
                var req = new XMLHttpRequest();
                req.onerror = reject;
                req.onreadystatechange = function onreadystatechange() {
                    if (req.readyState === 4) {
                        if (req.status >= 200 && req.status < 400) resolve(req.responseText);
                        else reject(new Error("POST to " + url + " failed with status: " + req.status));
                    }
                };
                req.open("post", url);
                // Set request headers
                req.setRequestHeader("Content-Type", "application/json");
                if (requestOptions && typeof requestOptions.headers === "object") {
                    var headers = requestOptions.headers;
                    for(var header in headers)if (Object.prototype.hasOwnProperty.call(headers, header)) req.setRequestHeader(header, headers[header]);
                }
                var reportPayload = {
                    stack: stackframes
                };
                if (errorMsg !== undefined && errorMsg !== null) reportPayload.message = errorMsg;
                req.send(JSON.stringify(reportPayload));
            });
        }
    };
});

});
parcelRegister("5q4Xp", function(module, exports) {

(function(root, factory) {
    "use strict";
    // Universal Module Definition (UMD) to support AMD, CommonJS/Node.js, Rhino, and browsers.
    /* istanbul ignore next */ if (typeof define === "function" && define.amd) define("error-stack-parser", [
        "stackframe"
    ], factory);
    else module.exports = factory((parcelRequire("2kV53")));
})(module.exports, function ErrorStackParser(StackFrame) {
    "use strict";
    var FIREFOX_SAFARI_STACK_REGEXP = /(^|@)\S+:\d+/;
    var CHROME_IE_STACK_REGEXP = /^\s*at .*(\S+:\d+|\(native\))/m;
    var SAFARI_NATIVE_CODE_REGEXP = /^(eval@)?(\[native code])?$/;
    return {
        /**
         * Given an Error object, extract the most information from it.
         *
         * @param {Error} error object
         * @return {Array} of StackFrames
         */ parse: function ErrorStackParser$$parse(error) {
            if (typeof error.stacktrace !== "undefined" || typeof error["opera#sourceloc"] !== "undefined") return this.parseOpera(error);
            else if (error.stack && error.stack.match(CHROME_IE_STACK_REGEXP)) return this.parseV8OrIE(error);
            else if (error.stack) return this.parseFFOrSafari(error);
            else throw new Error("Cannot parse given Error object");
        },
        // Separate line and column numbers from a string of the form: (URI:Line:Column)
        extractLocation: function ErrorStackParser$$extractLocation(urlLike) {
            // Fail-fast but return locations like "(native)"
            if (urlLike.indexOf(":") === -1) return [
                urlLike
            ];
            var regExp = /(.+?)(?::(\d+))?(?::(\d+))?$/;
            var parts = regExp.exec(urlLike.replace(/[()]/g, ""));
            return [
                parts[1],
                parts[2] || undefined,
                parts[3] || undefined
            ];
        },
        parseV8OrIE: function ErrorStackParser$$parseV8OrIE(error) {
            var filtered = error.stack.split("\n").filter(function(line) {
                return !!line.match(CHROME_IE_STACK_REGEXP);
            }, this);
            return filtered.map(function(line) {
                if (line.indexOf("(eval ") > -1) // Throw away eval information until we implement stacktrace.js/stackframe#8
                line = line.replace(/eval code/g, "eval").replace(/(\(eval at [^()]*)|(\),.*$)/g, "");
                var sanitizedLine = line.replace(/^\s+/, "").replace(/\(eval code/g, "(");
                // capture and preseve the parenthesized location "(/foo/my bar.js:12:87)" in
                // case it has spaces in it, as the string is split on \s+ later on
                var location = sanitizedLine.match(/ (\((.+):(\d+):(\d+)\)$)/);
                // remove the parenthesized location from the line, if it was matched
                sanitizedLine = location ? sanitizedLine.replace(location[0], "") : sanitizedLine;
                var tokens = sanitizedLine.split(/\s+/).slice(1);
                // if a location was matched, pass it to extractLocation() otherwise pop the last token
                var locationParts = this.extractLocation(location ? location[1] : tokens.pop());
                var functionName = tokens.join(" ") || undefined;
                var fileName = [
                    "eval",
                    "<anonymous>"
                ].indexOf(locationParts[0]) > -1 ? undefined : locationParts[0];
                return new StackFrame({
                    functionName: functionName,
                    fileName: fileName,
                    lineNumber: locationParts[1],
                    columnNumber: locationParts[2],
                    source: line
                });
            }, this);
        },
        parseFFOrSafari: function ErrorStackParser$$parseFFOrSafari(error) {
            var filtered = error.stack.split("\n").filter(function(line) {
                return !line.match(SAFARI_NATIVE_CODE_REGEXP);
            }, this);
            return filtered.map(function(line) {
                // Throw away eval information until we implement stacktrace.js/stackframe#8
                if (line.indexOf(" > eval") > -1) line = line.replace(/ line (\d+)(?: > eval line \d+)* > eval:\d+:\d+/g, ":$1");
                if (line.indexOf("@") === -1 && line.indexOf(":") === -1) // Safari eval frames only have function names and nothing else
                return new StackFrame({
                    functionName: line
                });
                else {
                    var functionNameRegex = /((.*".+"[^@]*)?[^@]*)(?:@)/;
                    var matches = line.match(functionNameRegex);
                    var functionName = matches && matches[1] ? matches[1] : undefined;
                    var locationParts = this.extractLocation(line.replace(functionNameRegex, ""));
                    return new StackFrame({
                        functionName: functionName,
                        fileName: locationParts[0],
                        lineNumber: locationParts[1],
                        columnNumber: locationParts[2],
                        source: line
                    });
                }
            }, this);
        },
        parseOpera: function ErrorStackParser$$parseOpera(e) {
            if (!e.stacktrace || e.message.indexOf("\n") > -1 && e.message.split("\n").length > e.stacktrace.split("\n").length) return this.parseOpera9(e);
            else if (!e.stack) return this.parseOpera10(e);
            else return this.parseOpera11(e);
        },
        parseOpera9: function ErrorStackParser$$parseOpera9(e) {
            var lineRE = /Line (\d+).*script (?:in )?(\S+)/i;
            var lines = e.message.split("\n");
            var result = [];
            for(var i = 2, len = lines.length; i < len; i += 2){
                var match = lineRE.exec(lines[i]);
                if (match) result.push(new StackFrame({
                    fileName: match[2],
                    lineNumber: match[1],
                    source: lines[i]
                }));
            }
            return result;
        },
        parseOpera10: function ErrorStackParser$$parseOpera10(e) {
            var lineRE = /Line (\d+).*script (?:in )?(\S+)(?:: In function (\S+))?$/i;
            var lines = e.stacktrace.split("\n");
            var result = [];
            for(var i = 0, len = lines.length; i < len; i += 2){
                var match = lineRE.exec(lines[i]);
                if (match) result.push(new StackFrame({
                    functionName: match[3] || undefined,
                    fileName: match[2],
                    lineNumber: match[1],
                    source: lines[i]
                }));
            }
            return result;
        },
        // Opera 10.65+ Error.stack very similar to FF/Safari
        parseOpera11: function ErrorStackParser$$parseOpera11(error) {
            var filtered = error.stack.split("\n").filter(function(line) {
                return !!line.match(FIREFOX_SAFARI_STACK_REGEXP) && !line.match(/^Error created at/);
            }, this);
            return filtered.map(function(line) {
                var tokens = line.split("@");
                var locationParts = this.extractLocation(tokens.pop());
                var functionCall = tokens.shift() || "";
                var functionName = functionCall.replace(/<anonymous function(: (\w+))?>/, "$2").replace(/\([^)]*\)/g, "") || undefined;
                var argsRaw;
                if (functionCall.match(/\(([^)]*)\)/)) argsRaw = functionCall.replace(/^[^(]+\(([^)]*)\)$/, "$1");
                var args = argsRaw === undefined || argsRaw === "[arguments not available]" ? undefined : argsRaw.split(",");
                return new StackFrame({
                    functionName: functionName,
                    args: args,
                    fileName: locationParts[0],
                    lineNumber: locationParts[1],
                    columnNumber: locationParts[2],
                    source: line
                });
            }, this);
        }
    };
});

});
parcelRegister("2kV53", function(module, exports) {
(function(root, factory) {
    "use strict";
    // Universal Module Definition (UMD) to support AMD, CommonJS/Node.js, Rhino, and browsers.
    /* istanbul ignore next */ if (typeof define === "function" && define.amd) define("stackframe", [], factory);
    else module.exports = factory();
})(module.exports, function() {
    "use strict";
    function _isNumber(n) {
        return !isNaN(parseFloat(n)) && isFinite(n);
    }
    function _capitalize(str) {
        return str.charAt(0).toUpperCase() + str.substring(1);
    }
    function _getter(p) {
        return function() {
            return this[p];
        };
    }
    var booleanProps = [
        "isConstructor",
        "isEval",
        "isNative",
        "isToplevel"
    ];
    var numericProps = [
        "columnNumber",
        "lineNumber"
    ];
    var stringProps = [
        "fileName",
        "functionName",
        "source"
    ];
    var arrayProps = [
        "args"
    ];
    var objectProps = [
        "evalOrigin"
    ];
    var props = booleanProps.concat(numericProps, stringProps, arrayProps, objectProps);
    function StackFrame(obj) {
        if (!obj) return;
        for(var i = 0; i < props.length; i++)if (obj[props[i]] !== undefined) this["set" + _capitalize(props[i])](obj[props[i]]);
    }
    StackFrame.prototype = {
        getArgs: function() {
            return this.args;
        },
        setArgs: function(v) {
            if (Object.prototype.toString.call(v) !== "[object Array]") throw new TypeError("Args must be an Array");
            this.args = v;
        },
        getEvalOrigin: function() {
            return this.evalOrigin;
        },
        setEvalOrigin: function(v) {
            if (v instanceof StackFrame) this.evalOrigin = v;
            else if (v instanceof Object) this.evalOrigin = new StackFrame(v);
            else throw new TypeError("Eval Origin must be an Object or StackFrame");
        },
        toString: function() {
            var fileName = this.getFileName() || "";
            var lineNumber = this.getLineNumber() || "";
            var columnNumber = this.getColumnNumber() || "";
            var functionName = this.getFunctionName() || "";
            if (this.getIsEval()) {
                if (fileName) return "[eval] (" + fileName + ":" + lineNumber + ":" + columnNumber + ")";
                return "[eval]:" + lineNumber + ":" + columnNumber;
            }
            if (functionName) return functionName + " (" + fileName + ":" + lineNumber + ":" + columnNumber + ")";
            return fileName + ":" + lineNumber + ":" + columnNumber;
        }
    };
    StackFrame.fromString = function StackFrame$$fromString(str) {
        var argsStartIndex = str.indexOf("(");
        var argsEndIndex = str.lastIndexOf(")");
        var functionName = str.substring(0, argsStartIndex);
        var args = str.substring(argsStartIndex + 1, argsEndIndex).split(",");
        var locationString = str.substring(argsEndIndex + 1);
        if (locationString.indexOf("@") === 0) {
            var parts = /@(.+?)(?::(\d+))?(?::(\d+))?$/.exec(locationString, "");
            var fileName = parts[1];
            var lineNumber = parts[2];
            var columnNumber = parts[3];
        }
        return new StackFrame({
            functionName: functionName,
            args: args || undefined,
            fileName: fileName,
            lineNumber: lineNumber || undefined,
            columnNumber: columnNumber || undefined
        });
    };
    for(var i = 0; i < booleanProps.length; i++){
        StackFrame.prototype["get" + _capitalize(booleanProps[i])] = _getter(booleanProps[i]);
        StackFrame.prototype["set" + _capitalize(booleanProps[i])] = function(p) {
            return function(v) {
                this[p] = Boolean(v);
            };
        }(booleanProps[i]);
    }
    for(var j = 0; j < numericProps.length; j++){
        StackFrame.prototype["get" + _capitalize(numericProps[j])] = _getter(numericProps[j]);
        StackFrame.prototype["set" + _capitalize(numericProps[j])] = function(p) {
            return function(v) {
                if (!_isNumber(v)) throw new TypeError(p + " must be a Number");
                this[p] = Number(v);
            };
        }(numericProps[j]);
    }
    for(var k = 0; k < stringProps.length; k++){
        StackFrame.prototype["get" + _capitalize(stringProps[k])] = _getter(stringProps[k]);
        StackFrame.prototype["set" + _capitalize(stringProps[k])] = function(p) {
            return function(v) {
                this[p] = String(v);
            };
        }(stringProps[k]);
    }
    return StackFrame;
});

});


parcelRegister("FwcmS", function(module, exports) {

(function(root, factory) {
    "use strict";
    // Universal Module Definition (UMD) to support AMD, CommonJS/Node.js, Rhino, and browsers.
    /* istanbul ignore next */ if (typeof define === "function" && define.amd) define("stack-generator", [
        "stackframe"
    ], factory);
    else module.exports = factory((parcelRequire("2kV53")));
})(module.exports, function(StackFrame) {
    return {
        backtrace: function StackGenerator$$backtrace(opts) {
            var stack = [];
            var maxStackSize = 10;
            if (typeof opts === "object" && typeof opts.maxStackSize === "number") maxStackSize = opts.maxStackSize;
            var curr = arguments.callee;
            while(curr && stack.length < maxStackSize && curr["arguments"]){
                // Allow V8 optimizations
                var args = new Array(curr["arguments"].length);
                for(var i = 0; i < args.length; ++i)args[i] = curr["arguments"][i];
                if (/function(?:\s+([\w$]+))+\s*\(/.test(curr.toString())) stack.push(new StackFrame({
                    functionName: RegExp.$1 || undefined,
                    args: args
                }));
                else stack.push(new StackFrame({
                    args: args
                }));
                try {
                    curr = curr.caller;
                } catch (e) {
                    break;
                }
            }
            return stack;
        }
    };
});

});

parcelRegister("lKzMa", function(module, exports) {


(function(root, factory) {
    "use strict";
    // Universal Module Definition (UMD) to support AMD, CommonJS/Node.js, Rhino, and browsers.
    /* istanbul ignore next */ if (typeof define === "function" && define.amd) define("stacktrace-gps", [
        "source-map",
        "stackframe"
    ], factory);
    else module.exports = factory((parcelRequire("1wJRr")), (parcelRequire("2kV53")));
})(module.exports, function(SourceMap, StackFrame) {
    "use strict";
    /**
     * Make a X-Domain request to url and callback.
     *
     * @param {String} url
     * @returns {Promise} with response text if fulfilled
     */ function _xdr(url) {
        return new Promise(function(resolve, reject) {
            var req = new XMLHttpRequest();
            req.open("get", url);
            req.onerror = reject;
            req.onreadystatechange = function onreadystatechange() {
                if (req.readyState === 4) {
                    if (req.status >= 200 && req.status < 300 || url.substr(0, 7) === "file://" && req.responseText) resolve(req.responseText);
                    else reject(new Error("HTTP status: " + req.status + " retrieving " + url));
                }
            };
            req.send();
        });
    }
    /**
     * Convert a Base64-encoded string into its original representation.
     * Used for inline sourcemaps.
     *
     * @param {String} b64str Base-64 encoded string
     * @returns {String} original representation of the base64-encoded string.
     */ function _atob(b64str) {
        if (typeof window !== "undefined" && window.atob) return window.atob(b64str);
        else throw new Error("You must supply a polyfill for window.atob in this environment");
    }
    function _parseJson(string) {
        if (typeof JSON !== "undefined" && JSON.parse) return JSON.parse(string);
        else throw new Error("You must supply a polyfill for JSON.parse in this environment");
    }
    function _findFunctionName(source, lineNumber /*, columnNumber*/ ) {
        var syntaxes = [
            // {name} = function ({args}) TODO args capture
            /['"]?([$_A-Za-z][$_A-Za-z0-9]*)['"]?\s*[:=]\s*function\b/,
            // function {name}({args}) m[1]=name m[2]=args
            /function\s+([^('"`]*?)\s*\(([^)]*)\)/,
            // {name} = eval()
            /['"]?([$_A-Za-z][$_A-Za-z0-9]*)['"]?\s*[:=]\s*(?:eval|new Function)\b/,
            // fn_name() {
            /\b(?!(?:if|for|switch|while|with|catch)\b)(?:(?:static)\s+)?(\S+)\s*\(.*?\)\s*\{/,
            // {name} = () => {
            /['"]?([$_A-Za-z][$_A-Za-z0-9]*)['"]?\s*[:=]\s*\(.*?\)\s*=>/
        ];
        var lines = source.split("\n");
        // Walk backwards in the source lines until we find the line which matches one of the patterns above
        var code = "";
        var maxLines = Math.min(lineNumber, 20);
        for(var i = 0; i < maxLines; ++i){
            // lineNo is 1-based, source[] is 0-based
            var line = lines[lineNumber - i - 1];
            var commentPos = line.indexOf("//");
            if (commentPos >= 0) line = line.substr(0, commentPos);
            if (line) {
                code = line + code;
                var len = syntaxes.length;
                for(var index = 0; index < len; index++){
                    var m = syntaxes[index].exec(code);
                    if (m && m[1]) return m[1];
                }
            }
        }
        return undefined;
    }
    function _ensureSupportedEnvironment() {
        if (typeof Object.defineProperty !== "function" || typeof Object.create !== "function") throw new Error("Unable to consume source maps in older browsers");
    }
    function _ensureStackFrameIsLegit(stackframe) {
        if (typeof stackframe !== "object") throw new TypeError("Given StackFrame is not an object");
        else if (typeof stackframe.fileName !== "string") throw new TypeError("Given file name is not a String");
        else if (typeof stackframe.lineNumber !== "number" || stackframe.lineNumber % 1 !== 0 || stackframe.lineNumber < 1) throw new TypeError("Given line number must be a positive integer");
        else if (typeof stackframe.columnNumber !== "number" || stackframe.columnNumber % 1 !== 0 || stackframe.columnNumber < 0) throw new TypeError("Given column number must be a non-negative integer");
        return true;
    }
    function _findSourceMappingURL(source) {
        var sourceMappingUrlRegExp = /\/\/[#@] ?sourceMappingURL=([^\s'"]+)\s*$/mg;
        var lastSourceMappingUrl;
        var matchSourceMappingUrl;
        // eslint-disable-next-line no-cond-assign
        while(matchSourceMappingUrl = sourceMappingUrlRegExp.exec(source))lastSourceMappingUrl = matchSourceMappingUrl[1];
        if (lastSourceMappingUrl) return lastSourceMappingUrl;
        else throw new Error("sourceMappingURL not found");
    }
    function _extractLocationInfoFromSourceMapSource(stackframe, sourceMapConsumer, sourceCache) {
        return new Promise(function(resolve, reject) {
            var loc = sourceMapConsumer.originalPositionFor({
                line: stackframe.lineNumber,
                column: stackframe.columnNumber
            });
            if (loc.source) {
                // cache mapped sources
                var mappedSource = sourceMapConsumer.sourceContentFor(loc.source);
                if (mappedSource) sourceCache[loc.source] = mappedSource;
                resolve(// given stackframe and source location, update stackframe
                new StackFrame({
                    functionName: loc.name || stackframe.functionName,
                    args: stackframe.args,
                    fileName: loc.source,
                    lineNumber: loc.line,
                    columnNumber: loc.column
                }));
            } else reject(new Error("Could not get original source for given stackframe and source map"));
        });
    }
    /**
     * @constructor
     * @param {Object} opts
     *      opts.sourceCache = {url: "Source String"} => preload source cache
     *      opts.sourceMapConsumerCache = {/path/file.js.map: SourceMapConsumer}
     *      opts.offline = True to prevent network requests.
     *              Best effort without sources or source maps.
     *      opts.ajax = Promise returning function to make X-Domain requests
     */ return function StackTraceGPS(opts) {
        if (!(this instanceof StackTraceGPS)) return new StackTraceGPS(opts);
        opts = opts || {};
        this.sourceCache = opts.sourceCache || {};
        this.sourceMapConsumerCache = opts.sourceMapConsumerCache || {};
        this.ajax = opts.ajax || _xdr;
        this._atob = opts.atob || _atob;
        this._get = function _get(location) {
            return new Promise((function(resolve, reject) {
                var isDataUrl = location.substr(0, 5) === "data:";
                if (this.sourceCache[location]) resolve(this.sourceCache[location]);
                else if (opts.offline && !isDataUrl) reject(new Error("Cannot make network requests in offline mode"));
                else if (isDataUrl) {
                    // data URLs can have parameters.
                    // see http://tools.ietf.org/html/rfc2397
                    var supportedEncodingRegexp = /^data:application\/json;([\w=:"-]+;)*base64,/;
                    var match = location.match(supportedEncodingRegexp);
                    if (match) {
                        var sourceMapStart = match[0].length;
                        var encodedSource = location.substr(sourceMapStart);
                        var source = this._atob(encodedSource);
                        this.sourceCache[location] = source;
                        resolve(source);
                    } else reject(new Error("The encoding of the inline sourcemap is not supported"));
                } else {
                    var xhrPromise = this.ajax(location, {
                        method: "get"
                    });
                    // Cache the Promise to prevent duplicate in-flight requests
                    this.sourceCache[location] = xhrPromise;
                    xhrPromise.then(resolve, reject);
                }
            }).bind(this));
        };
        /**
         * Creating SourceMapConsumers is expensive, so this wraps the creation of a
         * SourceMapConsumer in a per-instance cache.
         *
         * @param {String} sourceMappingURL = URL to fetch source map from
         * @param {String} defaultSourceRoot = Default source root for source map if undefined
         * @returns {Promise} that resolves a SourceMapConsumer
         */ this._getSourceMapConsumer = function _getSourceMapConsumer(sourceMappingURL, defaultSourceRoot) {
            return new Promise((function(resolve) {
                if (this.sourceMapConsumerCache[sourceMappingURL]) resolve(this.sourceMapConsumerCache[sourceMappingURL]);
                else {
                    var sourceMapConsumerPromise = new Promise((function(resolve, reject) {
                        return this._get(sourceMappingURL).then(function(sourceMapSource) {
                            if (typeof sourceMapSource === "string") sourceMapSource = _parseJson(sourceMapSource.replace(/^\)\]\}'/, ""));
                            if (typeof sourceMapSource.sourceRoot === "undefined") sourceMapSource.sourceRoot = defaultSourceRoot;
                            resolve(new SourceMap.SourceMapConsumer(sourceMapSource));
                        }).catch(reject);
                    }).bind(this));
                    this.sourceMapConsumerCache[sourceMappingURL] = sourceMapConsumerPromise;
                    resolve(sourceMapConsumerPromise);
                }
            }).bind(this));
        };
        /**
         * Given a StackFrame, enhance function name and use source maps for a
         * better StackFrame.
         *
         * @param {StackFrame} stackframe object
         * @returns {Promise} that resolves with with source-mapped StackFrame
         */ this.pinpoint = function StackTraceGPS$$pinpoint(stackframe) {
            return new Promise((function(resolve, reject) {
                this.getMappedLocation(stackframe).then((function(mappedStackFrame) {
                    function resolveMappedStackFrame() {
                        resolve(mappedStackFrame);
                    }
                    this.findFunctionName(mappedStackFrame).then(resolve, resolveMappedStackFrame)["catch"](resolveMappedStackFrame);
                }).bind(this), reject);
            }).bind(this));
        };
        /**
         * Given a StackFrame, guess function name from location information.
         *
         * @param {StackFrame} stackframe
         * @returns {Promise} that resolves with enhanced StackFrame.
         */ this.findFunctionName = function StackTraceGPS$$findFunctionName(stackframe) {
            return new Promise((function(resolve, reject) {
                _ensureStackFrameIsLegit(stackframe);
                this._get(stackframe.fileName).then(function getSourceCallback(source) {
                    var lineNumber = stackframe.lineNumber;
                    var columnNumber = stackframe.columnNumber;
                    var guessedFunctionName = _findFunctionName(source, lineNumber, columnNumber);
                    // Only replace functionName if we found something
                    if (guessedFunctionName) resolve(new StackFrame({
                        functionName: guessedFunctionName,
                        args: stackframe.args,
                        fileName: stackframe.fileName,
                        lineNumber: lineNumber,
                        columnNumber: columnNumber
                    }));
                    else resolve(stackframe);
                }, reject)["catch"](reject);
            }).bind(this));
        };
        /**
         * Given a StackFrame, seek source-mapped location and return new enhanced StackFrame.
         *
         * @param {StackFrame} stackframe
         * @returns {Promise} that resolves with enhanced StackFrame.
         */ this.getMappedLocation = function StackTraceGPS$$getMappedLocation(stackframe) {
            return new Promise((function(resolve, reject) {
                _ensureSupportedEnvironment();
                _ensureStackFrameIsLegit(stackframe);
                var sourceCache = this.sourceCache;
                var fileName = stackframe.fileName;
                this._get(fileName).then((function(source) {
                    var sourceMappingURL = _findSourceMappingURL(source);
                    var isDataUrl = sourceMappingURL.substr(0, 5) === "data:";
                    var defaultSourceRoot = fileName.substring(0, fileName.lastIndexOf("/") + 1);
                    if (sourceMappingURL[0] !== "/" && !isDataUrl && !/^https?:\/\/|^\/\//i.test(sourceMappingURL)) sourceMappingURL = defaultSourceRoot + sourceMappingURL;
                    return this._getSourceMapConsumer(sourceMappingURL, defaultSourceRoot).then(function(sourceMapConsumer) {
                        return _extractLocationInfoFromSourceMapSource(stackframe, sourceMapConsumer, sourceCache).then(resolve)["catch"](function() {
                            resolve(stackframe);
                        });
                    });
                }).bind(this), reject)["catch"](reject);
            }).bind(this));
        };
    };
});

});
parcelRegister("1wJRr", function(module, exports) {

$parcel$export(module.exports, "SourceMapConsumer", function () { return $11cc5aa7ba07b448$export$194e92554d04abdd; }, function (v) { return $11cc5aa7ba07b448$export$194e92554d04abdd = v; });
$parcel$export(module.exports, "BasicSourceMapConsumer", function () { return $11cc5aa7ba07b448$export$bef6691594139a79; }, function (v) { return $11cc5aa7ba07b448$export$bef6691594139a79 = v; });
$parcel$export(module.exports, "IndexedSourceMapConsumer", function () { return $11cc5aa7ba07b448$export$823525094e5b803c; }, function (v) { return $11cc5aa7ba07b448$export$823525094e5b803c = v; });
/* -*- Mode: js; js-indent-level: 2; -*- */ /*
 * Copyright 2011 Mozilla Foundation and contributors
 * Licensed under the New BSD license. See LICENSE or:
 * http://opensource.org/licenses/BSD-3-Clause
 */ var $11cc5aa7ba07b448$export$194e92554d04abdd;
var $11cc5aa7ba07b448$export$bef6691594139a79;
var $11cc5aa7ba07b448$export$823525094e5b803c;

var $jAnEU = parcelRequire("jAnEU");

var $9EEuM = parcelRequire("9EEuM");

var $lA9c0 = parcelRequire("lA9c0");
var $11cc5aa7ba07b448$require$ArraySet = $lA9c0.ArraySet;

var $40yPQ = parcelRequire("40yPQ");

var $e5fKN = parcelRequire("e5fKN");
var $11cc5aa7ba07b448$require$quickSort = $e5fKN.quickSort;
function $11cc5aa7ba07b448$var$SourceMapConsumer(aSourceMap) {
    var sourceMap = aSourceMap;
    if (typeof aSourceMap === "string") sourceMap = JSON.parse(aSourceMap.replace(/^\)\]\}'/, ""));
    return sourceMap.sections != null ? new $11cc5aa7ba07b448$var$IndexedSourceMapConsumer(sourceMap) : new $11cc5aa7ba07b448$var$BasicSourceMapConsumer(sourceMap);
}
$11cc5aa7ba07b448$var$SourceMapConsumer.fromSourceMap = function(aSourceMap) {
    return $11cc5aa7ba07b448$var$BasicSourceMapConsumer.fromSourceMap(aSourceMap);
};
/**
 * The version of the source mapping spec that we are consuming.
 */ $11cc5aa7ba07b448$var$SourceMapConsumer.prototype._version = 3;
// `__generatedMappings` and `__originalMappings` are arrays that hold the
// parsed mapping coordinates from the source map's "mappings" attribute. They
// are lazily instantiated, accessed via the `_generatedMappings` and
// `_originalMappings` getters respectively, and we only parse the mappings
// and create these arrays once queried for a source location. We jump through
// these hoops because there can be many thousands of mappings, and parsing
// them is expensive, so we only want to do it if we must.
//
// Each object in the arrays is of the form:
//
//     {
//       generatedLine: The line number in the generated code,
//       generatedColumn: The column number in the generated code,
//       source: The path to the original source file that generated this
//               chunk of code,
//       originalLine: The line number in the original source that
//                     corresponds to this chunk of generated code,
//       originalColumn: The column number in the original source that
//                       corresponds to this chunk of generated code,
//       name: The name of the original symbol which generated this chunk of
//             code.
//     }
//
// All properties except for `generatedLine` and `generatedColumn` can be
// `null`.
//
// `_generatedMappings` is ordered by the generated positions.
//
// `_originalMappings` is ordered by the original positions.
$11cc5aa7ba07b448$var$SourceMapConsumer.prototype.__generatedMappings = null;
Object.defineProperty($11cc5aa7ba07b448$var$SourceMapConsumer.prototype, "_generatedMappings", {
    get: function() {
        if (!this.__generatedMappings) this._parseMappings(this._mappings, this.sourceRoot);
        return this.__generatedMappings;
    }
});
$11cc5aa7ba07b448$var$SourceMapConsumer.prototype.__originalMappings = null;
Object.defineProperty($11cc5aa7ba07b448$var$SourceMapConsumer.prototype, "_originalMappings", {
    get: function() {
        if (!this.__originalMappings) this._parseMappings(this._mappings, this.sourceRoot);
        return this.__originalMappings;
    }
});
$11cc5aa7ba07b448$var$SourceMapConsumer.prototype._charIsMappingSeparator = function SourceMapConsumer_charIsMappingSeparator(aStr, index) {
    var c = aStr.charAt(index);
    return c === ";" || c === ",";
};
/**
 * Parse the mappings in a string in to a data structure which we can easily
 * query (the ordered arrays in the `this.__generatedMappings` and
 * `this.__originalMappings` properties).
 */ $11cc5aa7ba07b448$var$SourceMapConsumer.prototype._parseMappings = function SourceMapConsumer_parseMappings(aStr, aSourceRoot) {
    throw new Error("Subclasses must implement _parseMappings");
};
$11cc5aa7ba07b448$var$SourceMapConsumer.GENERATED_ORDER = 1;
$11cc5aa7ba07b448$var$SourceMapConsumer.ORIGINAL_ORDER = 2;
$11cc5aa7ba07b448$var$SourceMapConsumer.GREATEST_LOWER_BOUND = 1;
$11cc5aa7ba07b448$var$SourceMapConsumer.LEAST_UPPER_BOUND = 2;
/**
 * Iterate over each mapping between an original source/line/column and a
 * generated line/column in this source map.
 *
 * @param Function aCallback
 *        The function that is called with each mapping.
 * @param Object aContext
 *        Optional. If specified, this object will be the value of `this` every
 *        time that `aCallback` is called.
 * @param aOrder
 *        Either `SourceMapConsumer.GENERATED_ORDER` or
 *        `SourceMapConsumer.ORIGINAL_ORDER`. Specifies whether you want to
 *        iterate over the mappings sorted by the generated file's line/column
 *        order or the original's source/line/column order, respectively. Defaults to
 *        `SourceMapConsumer.GENERATED_ORDER`.
 */ $11cc5aa7ba07b448$var$SourceMapConsumer.prototype.eachMapping = function SourceMapConsumer_eachMapping(aCallback, aContext, aOrder) {
    var context = aContext || null;
    var order = aOrder || $11cc5aa7ba07b448$var$SourceMapConsumer.GENERATED_ORDER;
    var mappings;
    switch(order){
        case $11cc5aa7ba07b448$var$SourceMapConsumer.GENERATED_ORDER:
            mappings = this._generatedMappings;
            break;
        case $11cc5aa7ba07b448$var$SourceMapConsumer.ORIGINAL_ORDER:
            mappings = this._originalMappings;
            break;
        default:
            throw new Error("Unknown order of iteration.");
    }
    var sourceRoot = this.sourceRoot;
    mappings.map(function(mapping) {
        var source = mapping.source === null ? null : this._sources.at(mapping.source);
        if (source != null && sourceRoot != null) source = $jAnEU.join(sourceRoot, source);
        return {
            source: source,
            generatedLine: mapping.generatedLine,
            generatedColumn: mapping.generatedColumn,
            originalLine: mapping.originalLine,
            originalColumn: mapping.originalColumn,
            name: mapping.name === null ? null : this._names.at(mapping.name)
        };
    }, this).forEach(aCallback, context);
};
/**
 * Returns all generated line and column information for the original source,
 * line, and column provided. If no column is provided, returns all mappings
 * corresponding to a either the line we are searching for or the next
 * closest line that has any mappings. Otherwise, returns all mappings
 * corresponding to the given line and either the column we are searching for
 * or the next closest column that has any offsets.
 *
 * The only argument is an object with the following properties:
 *
 *   - source: The filename of the original source.
 *   - line: The line number in the original source.
 *   - column: Optional. the column number in the original source.
 *
 * and an array of objects is returned, each with the following properties:
 *
 *   - line: The line number in the generated source, or null.
 *   - column: The column number in the generated source, or null.
 */ $11cc5aa7ba07b448$var$SourceMapConsumer.prototype.allGeneratedPositionsFor = function SourceMapConsumer_allGeneratedPositionsFor(aArgs) {
    var line = $jAnEU.getArg(aArgs, "line");
    // When there is no exact match, BasicSourceMapConsumer.prototype._findMapping
    // returns the index of the closest mapping less than the needle. By
    // setting needle.originalColumn to 0, we thus find the last mapping for
    // the given line, provided such a mapping exists.
    var needle = {
        source: $jAnEU.getArg(aArgs, "source"),
        originalLine: line,
        originalColumn: $jAnEU.getArg(aArgs, "column", 0)
    };
    if (this.sourceRoot != null) needle.source = $jAnEU.relative(this.sourceRoot, needle.source);
    if (!this._sources.has(needle.source)) return [];
    needle.source = this._sources.indexOf(needle.source);
    var mappings = [];
    var index = this._findMapping(needle, this._originalMappings, "originalLine", "originalColumn", $jAnEU.compareByOriginalPositions, $9EEuM.LEAST_UPPER_BOUND);
    if (index >= 0) {
        var mapping = this._originalMappings[index];
        if (aArgs.column === undefined) {
            var originalLine = mapping.originalLine;
            // Iterate until either we run out of mappings, or we run into
            // a mapping for a different line than the one we found. Since
            // mappings are sorted, this is guaranteed to find all mappings for
            // the line we found.
            while(mapping && mapping.originalLine === originalLine){
                mappings.push({
                    line: $jAnEU.getArg(mapping, "generatedLine", null),
                    column: $jAnEU.getArg(mapping, "generatedColumn", null),
                    lastColumn: $jAnEU.getArg(mapping, "lastGeneratedColumn", null)
                });
                mapping = this._originalMappings[++index];
            }
        } else {
            var originalColumn = mapping.originalColumn;
            // Iterate until either we run out of mappings, or we run into
            // a mapping for a different line than the one we were searching for.
            // Since mappings are sorted, this is guaranteed to find all mappings for
            // the line we are searching for.
            while(mapping && mapping.originalLine === line && mapping.originalColumn == originalColumn){
                mappings.push({
                    line: $jAnEU.getArg(mapping, "generatedLine", null),
                    column: $jAnEU.getArg(mapping, "generatedColumn", null),
                    lastColumn: $jAnEU.getArg(mapping, "lastGeneratedColumn", null)
                });
                mapping = this._originalMappings[++index];
            }
        }
    }
    return mappings;
};
$11cc5aa7ba07b448$export$194e92554d04abdd = $11cc5aa7ba07b448$var$SourceMapConsumer;
/**
 * A BasicSourceMapConsumer instance represents a parsed source map which we can
 * query for information about the original file positions by giving it a file
 * position in the generated source.
 *
 * The only parameter is the raw source map (either as a JSON string, or
 * already parsed to an object). According to the spec, source maps have the
 * following attributes:
 *
 *   - version: Which version of the source map spec this map is following.
 *   - sources: An array of URLs to the original source files.
 *   - names: An array of identifiers which can be referrenced by individual mappings.
 *   - sourceRoot: Optional. The URL root from which all sources are relative.
 *   - sourcesContent: Optional. An array of contents of the original source files.
 *   - mappings: A string of base64 VLQs which contain the actual mappings.
 *   - file: Optional. The generated file this source map is associated with.
 *
 * Here is an example source map, taken from the source map spec[0]:
 *
 *     {
 *       version : 3,
 *       file: "out.js",
 *       sourceRoot : "",
 *       sources: ["foo.js", "bar.js"],
 *       names: ["src", "maps", "are", "fun"],
 *       mappings: "AA,AB;;ABCDE;"
 *     }
 *
 * [0]: https://docs.google.com/document/d/1U1RGAehQwRypUTovF1KRlpiOFze0b-_2gc6fAH0KY0k/edit?pli=1#
 */ function $11cc5aa7ba07b448$var$BasicSourceMapConsumer(aSourceMap) {
    var sourceMap = aSourceMap;
    if (typeof aSourceMap === "string") sourceMap = JSON.parse(aSourceMap.replace(/^\)\]\}'/, ""));
    var version = $jAnEU.getArg(sourceMap, "version");
    var sources = $jAnEU.getArg(sourceMap, "sources");
    // Sass 3.3 leaves out the 'names' array, so we deviate from the spec (which
    // requires the array) to play nice here.
    var names = $jAnEU.getArg(sourceMap, "names", []);
    var sourceRoot = $jAnEU.getArg(sourceMap, "sourceRoot", null);
    var sourcesContent = $jAnEU.getArg(sourceMap, "sourcesContent", null);
    var mappings = $jAnEU.getArg(sourceMap, "mappings");
    var file = $jAnEU.getArg(sourceMap, "file", null);
    // Once again, Sass deviates from the spec and supplies the version as a
    // string rather than a number, so we use loose equality checking here.
    if (version != this._version) throw new Error("Unsupported version: " + version);
    sources = sources.map(String)// Some source maps produce relative source paths like "./foo.js" instead of
    // "foo.js".  Normalize these first so that future comparisons will succeed.
    // See bugzil.la/1090768.
    .map($jAnEU.normalize)// Always ensure that absolute sources are internally stored relative to
    // the source root, if the source root is absolute. Not doing this would
    // be particularly problematic when the source root is a prefix of the
    // source (valid, but why??). See github issue #199 and bugzil.la/1188982.
    .map(function(source) {
        return sourceRoot && $jAnEU.isAbsolute(sourceRoot) && $jAnEU.isAbsolute(source) ? $jAnEU.relative(sourceRoot, source) : source;
    });
    // Pass `true` below to allow duplicate names and sources. While source maps
    // are intended to be compressed and deduplicated, the TypeScript compiler
    // sometimes generates source maps with duplicates in them. See Github issue
    // #72 and bugzil.la/889492.
    this._names = $11cc5aa7ba07b448$require$ArraySet.fromArray(names.map(String), true);
    this._sources = $11cc5aa7ba07b448$require$ArraySet.fromArray(sources, true);
    this.sourceRoot = sourceRoot;
    this.sourcesContent = sourcesContent;
    this._mappings = mappings;
    this.file = file;
}
$11cc5aa7ba07b448$var$BasicSourceMapConsumer.prototype = Object.create($11cc5aa7ba07b448$var$SourceMapConsumer.prototype);
$11cc5aa7ba07b448$var$BasicSourceMapConsumer.prototype.consumer = $11cc5aa7ba07b448$var$SourceMapConsumer;
/**
 * Create a BasicSourceMapConsumer from a SourceMapGenerator.
 *
 * @param SourceMapGenerator aSourceMap
 *        The source map that will be consumed.
 * @returns BasicSourceMapConsumer
 */ $11cc5aa7ba07b448$var$BasicSourceMapConsumer.fromSourceMap = function SourceMapConsumer_fromSourceMap(aSourceMap) {
    var smc = Object.create($11cc5aa7ba07b448$var$BasicSourceMapConsumer.prototype);
    var names = smc._names = $11cc5aa7ba07b448$require$ArraySet.fromArray(aSourceMap._names.toArray(), true);
    var sources = smc._sources = $11cc5aa7ba07b448$require$ArraySet.fromArray(aSourceMap._sources.toArray(), true);
    smc.sourceRoot = aSourceMap._sourceRoot;
    smc.sourcesContent = aSourceMap._generateSourcesContent(smc._sources.toArray(), smc.sourceRoot);
    smc.file = aSourceMap._file;
    // Because we are modifying the entries (by converting string sources and
    // names to indices into the sources and names ArraySets), we have to make
    // a copy of the entry or else bad things happen. Shared mutable state
    // strikes again! See github issue #191.
    var generatedMappings = aSourceMap._mappings.toArray().slice();
    var destGeneratedMappings = smc.__generatedMappings = [];
    var destOriginalMappings = smc.__originalMappings = [];
    for(var i = 0, length = generatedMappings.length; i < length; i++){
        var srcMapping = generatedMappings[i];
        var destMapping = new $11cc5aa7ba07b448$var$Mapping;
        destMapping.generatedLine = srcMapping.generatedLine;
        destMapping.generatedColumn = srcMapping.generatedColumn;
        if (srcMapping.source) {
            destMapping.source = sources.indexOf(srcMapping.source);
            destMapping.originalLine = srcMapping.originalLine;
            destMapping.originalColumn = srcMapping.originalColumn;
            if (srcMapping.name) destMapping.name = names.indexOf(srcMapping.name);
            destOriginalMappings.push(destMapping);
        }
        destGeneratedMappings.push(destMapping);
    }
    $11cc5aa7ba07b448$require$quickSort(smc.__originalMappings, $jAnEU.compareByOriginalPositions);
    return smc;
};
/**
 * The version of the source mapping spec that we are consuming.
 */ $11cc5aa7ba07b448$var$BasicSourceMapConsumer.prototype._version = 3;
/**
 * The list of original sources.
 */ Object.defineProperty($11cc5aa7ba07b448$var$BasicSourceMapConsumer.prototype, "sources", {
    get: function() {
        return this._sources.toArray().map(function(s) {
            return this.sourceRoot != null ? $jAnEU.join(this.sourceRoot, s) : s;
        }, this);
    }
});
/**
 * Provide the JIT with a nice shape / hidden class.
 */ function $11cc5aa7ba07b448$var$Mapping() {
    this.generatedLine = 0;
    this.generatedColumn = 0;
    this.source = null;
    this.originalLine = null;
    this.originalColumn = null;
    this.name = null;
}
/**
 * Parse the mappings in a string in to a data structure which we can easily
 * query (the ordered arrays in the `this.__generatedMappings` and
 * `this.__originalMappings` properties).
 */ $11cc5aa7ba07b448$var$BasicSourceMapConsumer.prototype._parseMappings = function SourceMapConsumer_parseMappings(aStr, aSourceRoot) {
    var generatedLine = 1;
    var previousGeneratedColumn = 0;
    var previousOriginalLine = 0;
    var previousOriginalColumn = 0;
    var previousSource = 0;
    var previousName = 0;
    var length = aStr.length;
    var index = 0;
    var cachedSegments = {};
    var temp = {};
    var originalMappings = [];
    var generatedMappings = [];
    var mapping, str, segment, end, value;
    while(index < length){
        if (aStr.charAt(index) === ";") {
            generatedLine++;
            index++;
            previousGeneratedColumn = 0;
        } else if (aStr.charAt(index) === ",") index++;
        else {
            mapping = new $11cc5aa7ba07b448$var$Mapping();
            mapping.generatedLine = generatedLine;
            // Because each offset is encoded relative to the previous one,
            // many segments often have the same encoding. We can exploit this
            // fact by caching the parsed variable length fields of each segment,
            // allowing us to avoid a second parse if we encounter the same
            // segment again.
            for(end = index; end < length; end++){
                if (this._charIsMappingSeparator(aStr, end)) break;
            }
            str = aStr.slice(index, end);
            segment = cachedSegments[str];
            if (segment) index += str.length;
            else {
                segment = [];
                while(index < end){
                    $40yPQ.decode(aStr, index, temp);
                    value = temp.value;
                    index = temp.rest;
                    segment.push(value);
                }
                if (segment.length === 2) throw new Error("Found a source, but no line and column");
                if (segment.length === 3) throw new Error("Found a source and line, but no column");
                cachedSegments[str] = segment;
            }
            // Generated column.
            mapping.generatedColumn = previousGeneratedColumn + segment[0];
            previousGeneratedColumn = mapping.generatedColumn;
            if (segment.length > 1) {
                // Original source.
                mapping.source = previousSource + segment[1];
                previousSource += segment[1];
                // Original line.
                mapping.originalLine = previousOriginalLine + segment[2];
                previousOriginalLine = mapping.originalLine;
                // Lines are stored 0-based
                mapping.originalLine += 1;
                // Original column.
                mapping.originalColumn = previousOriginalColumn + segment[3];
                previousOriginalColumn = mapping.originalColumn;
                if (segment.length > 4) {
                    // Original name.
                    mapping.name = previousName + segment[4];
                    previousName += segment[4];
                }
            }
            generatedMappings.push(mapping);
            if (typeof mapping.originalLine === "number") originalMappings.push(mapping);
        }
    }
    $11cc5aa7ba07b448$require$quickSort(generatedMappings, $jAnEU.compareByGeneratedPositionsDeflated);
    this.__generatedMappings = generatedMappings;
    $11cc5aa7ba07b448$require$quickSort(originalMappings, $jAnEU.compareByOriginalPositions);
    this.__originalMappings = originalMappings;
};
/**
 * Find the mapping that best matches the hypothetical "needle" mapping that
 * we are searching for in the given "haystack" of mappings.
 */ $11cc5aa7ba07b448$var$BasicSourceMapConsumer.prototype._findMapping = function SourceMapConsumer_findMapping(aNeedle, aMappings, aLineName, aColumnName, aComparator, aBias) {
    // To return the position we are searching for, we must first find the
    // mapping for the given position and then return the opposite position it
    // points to. Because the mappings are sorted, we can use binary search to
    // find the best mapping.
    if (aNeedle[aLineName] <= 0) throw new TypeError("Line must be greater than or equal to 1, got " + aNeedle[aLineName]);
    if (aNeedle[aColumnName] < 0) throw new TypeError("Column must be greater than or equal to 0, got " + aNeedle[aColumnName]);
    return $9EEuM.search(aNeedle, aMappings, aComparator, aBias);
};
/**
 * Compute the last column for each generated mapping. The last column is
 * inclusive.
 */ $11cc5aa7ba07b448$var$BasicSourceMapConsumer.prototype.computeColumnSpans = function SourceMapConsumer_computeColumnSpans() {
    for(var index = 0; index < this._generatedMappings.length; ++index){
        var mapping = this._generatedMappings[index];
        // Mappings do not contain a field for the last generated columnt. We
        // can come up with an optimistic estimate, however, by assuming that
        // mappings are contiguous (i.e. given two consecutive mappings, the
        // first mapping ends where the second one starts).
        if (index + 1 < this._generatedMappings.length) {
            var nextMapping = this._generatedMappings[index + 1];
            if (mapping.generatedLine === nextMapping.generatedLine) {
                mapping.lastGeneratedColumn = nextMapping.generatedColumn - 1;
                continue;
            }
        }
        // The last mapping for each line spans the entire line.
        mapping.lastGeneratedColumn = Infinity;
    }
};
/**
 * Returns the original source, line, and column information for the generated
 * source's line and column positions provided. The only argument is an object
 * with the following properties:
 *
 *   - line: The line number in the generated source.
 *   - column: The column number in the generated source.
 *   - bias: Either 'SourceMapConsumer.GREATEST_LOWER_BOUND' or
 *     'SourceMapConsumer.LEAST_UPPER_BOUND'. Specifies whether to return the
 *     closest element that is smaller than or greater than the one we are
 *     searching for, respectively, if the exact element cannot be found.
 *     Defaults to 'SourceMapConsumer.GREATEST_LOWER_BOUND'.
 *
 * and an object is returned with the following properties:
 *
 *   - source: The original source file, or null.
 *   - line: The line number in the original source, or null.
 *   - column: The column number in the original source, or null.
 *   - name: The original identifier, or null.
 */ $11cc5aa7ba07b448$var$BasicSourceMapConsumer.prototype.originalPositionFor = function SourceMapConsumer_originalPositionFor(aArgs) {
    var needle = {
        generatedLine: $jAnEU.getArg(aArgs, "line"),
        generatedColumn: $jAnEU.getArg(aArgs, "column")
    };
    var index = this._findMapping(needle, this._generatedMappings, "generatedLine", "generatedColumn", $jAnEU.compareByGeneratedPositionsDeflated, $jAnEU.getArg(aArgs, "bias", $11cc5aa7ba07b448$var$SourceMapConsumer.GREATEST_LOWER_BOUND));
    if (index >= 0) {
        var mapping = this._generatedMappings[index];
        if (mapping.generatedLine === needle.generatedLine) {
            var source = $jAnEU.getArg(mapping, "source", null);
            if (source !== null) {
                source = this._sources.at(source);
                if (this.sourceRoot != null) source = $jAnEU.join(this.sourceRoot, source);
            }
            var name = $jAnEU.getArg(mapping, "name", null);
            if (name !== null) name = this._names.at(name);
            return {
                source: source,
                line: $jAnEU.getArg(mapping, "originalLine", null),
                column: $jAnEU.getArg(mapping, "originalColumn", null),
                name: name
            };
        }
    }
    return {
        source: null,
        line: null,
        column: null,
        name: null
    };
};
/**
 * Return true if we have the source content for every source in the source
 * map, false otherwise.
 */ $11cc5aa7ba07b448$var$BasicSourceMapConsumer.prototype.hasContentsOfAllSources = function BasicSourceMapConsumer_hasContentsOfAllSources() {
    if (!this.sourcesContent) return false;
    return this.sourcesContent.length >= this._sources.size() && !this.sourcesContent.some(function(sc) {
        return sc == null;
    });
};
/**
 * Returns the original source content. The only argument is the url of the
 * original source file. Returns null if no original source content is
 * available.
 */ $11cc5aa7ba07b448$var$BasicSourceMapConsumer.prototype.sourceContentFor = function SourceMapConsumer_sourceContentFor(aSource, nullOnMissing) {
    if (!this.sourcesContent) return null;
    if (this.sourceRoot != null) aSource = $jAnEU.relative(this.sourceRoot, aSource);
    if (this._sources.has(aSource)) return this.sourcesContent[this._sources.indexOf(aSource)];
    var url;
    if (this.sourceRoot != null && (url = $jAnEU.urlParse(this.sourceRoot))) {
        // XXX: file:// URIs and absolute paths lead to unexpected behavior for
        // many users. We can help them out when they expect file:// URIs to
        // behave like it would if they were running a local HTTP server. See
        // https://bugzilla.mozilla.org/show_bug.cgi?id=885597.
        var fileUriAbsPath = aSource.replace(/^file:\/\//, "");
        if (url.scheme == "file" && this._sources.has(fileUriAbsPath)) return this.sourcesContent[this._sources.indexOf(fileUriAbsPath)];
        if ((!url.path || url.path == "/") && this._sources.has("/" + aSource)) return this.sourcesContent[this._sources.indexOf("/" + aSource)];
    }
    // This function is used recursively from
    // IndexedSourceMapConsumer.prototype.sourceContentFor. In that case, we
    // don't want to throw if we can't find the source - we just want to
    // return null, so we provide a flag to exit gracefully.
    if (nullOnMissing) return null;
    else throw new Error('"' + aSource + '" is not in the SourceMap.');
};
/**
 * Returns the generated line and column information for the original source,
 * line, and column positions provided. The only argument is an object with
 * the following properties:
 *
 *   - source: The filename of the original source.
 *   - line: The line number in the original source.
 *   - column: The column number in the original source.
 *   - bias: Either 'SourceMapConsumer.GREATEST_LOWER_BOUND' or
 *     'SourceMapConsumer.LEAST_UPPER_BOUND'. Specifies whether to return the
 *     closest element that is smaller than or greater than the one we are
 *     searching for, respectively, if the exact element cannot be found.
 *     Defaults to 'SourceMapConsumer.GREATEST_LOWER_BOUND'.
 *
 * and an object is returned with the following properties:
 *
 *   - line: The line number in the generated source, or null.
 *   - column: The column number in the generated source, or null.
 */ $11cc5aa7ba07b448$var$BasicSourceMapConsumer.prototype.generatedPositionFor = function SourceMapConsumer_generatedPositionFor(aArgs) {
    var source = $jAnEU.getArg(aArgs, "source");
    if (this.sourceRoot != null) source = $jAnEU.relative(this.sourceRoot, source);
    if (!this._sources.has(source)) return {
        line: null,
        column: null,
        lastColumn: null
    };
    source = this._sources.indexOf(source);
    var needle = {
        source: source,
        originalLine: $jAnEU.getArg(aArgs, "line"),
        originalColumn: $jAnEU.getArg(aArgs, "column")
    };
    var index = this._findMapping(needle, this._originalMappings, "originalLine", "originalColumn", $jAnEU.compareByOriginalPositions, $jAnEU.getArg(aArgs, "bias", $11cc5aa7ba07b448$var$SourceMapConsumer.GREATEST_LOWER_BOUND));
    if (index >= 0) {
        var mapping = this._originalMappings[index];
        if (mapping.source === needle.source) return {
            line: $jAnEU.getArg(mapping, "generatedLine", null),
            column: $jAnEU.getArg(mapping, "generatedColumn", null),
            lastColumn: $jAnEU.getArg(mapping, "lastGeneratedColumn", null)
        };
    }
    return {
        line: null,
        column: null,
        lastColumn: null
    };
};
$11cc5aa7ba07b448$export$bef6691594139a79 = $11cc5aa7ba07b448$var$BasicSourceMapConsumer;
/**
 * An IndexedSourceMapConsumer instance represents a parsed source map which
 * we can query for information. It differs from BasicSourceMapConsumer in
 * that it takes "indexed" source maps (i.e. ones with a "sections" field) as
 * input.
 *
 * The only parameter is a raw source map (either as a JSON string, or already
 * parsed to an object). According to the spec for indexed source maps, they
 * have the following attributes:
 *
 *   - version: Which version of the source map spec this map is following.
 *   - file: Optional. The generated file this source map is associated with.
 *   - sections: A list of section definitions.
 *
 * Each value under the "sections" field has two fields:
 *   - offset: The offset into the original specified at which this section
 *       begins to apply, defined as an object with a "line" and "column"
 *       field.
 *   - map: A source map definition. This source map could also be indexed,
 *       but doesn't have to be.
 *
 * Instead of the "map" field, it's also possible to have a "url" field
 * specifying a URL to retrieve a source map from, but that's currently
 * unsupported.
 *
 * Here's an example source map, taken from the source map spec[0], but
 * modified to omit a section which uses the "url" field.
 *
 *  {
 *    version : 3,
 *    file: "app.js",
 *    sections: [{
 *      offset: {line:100, column:10},
 *      map: {
 *        version : 3,
 *        file: "section.js",
 *        sources: ["foo.js", "bar.js"],
 *        names: ["src", "maps", "are", "fun"],
 *        mappings: "AAAA,E;;ABCDE;"
 *      }
 *    }],
 *  }
 *
 * [0]: https://docs.google.com/document/d/1U1RGAehQwRypUTovF1KRlpiOFze0b-_2gc6fAH0KY0k/edit#heading=h.535es3xeprgt
 */ function $11cc5aa7ba07b448$var$IndexedSourceMapConsumer(aSourceMap) {
    var sourceMap = aSourceMap;
    if (typeof aSourceMap === "string") sourceMap = JSON.parse(aSourceMap.replace(/^\)\]\}'/, ""));
    var version = $jAnEU.getArg(sourceMap, "version");
    var sections = $jAnEU.getArg(sourceMap, "sections");
    if (version != this._version) throw new Error("Unsupported version: " + version);
    this._sources = new $11cc5aa7ba07b448$require$ArraySet();
    this._names = new $11cc5aa7ba07b448$require$ArraySet();
    var lastOffset = {
        line: -1,
        column: 0
    };
    this._sections = sections.map(function(s) {
        if (s.url) // The url field will require support for asynchronicity.
        // See https://github.com/mozilla/source-map/issues/16
        throw new Error("Support for url field in sections not implemented.");
        var offset = $jAnEU.getArg(s, "offset");
        var offsetLine = $jAnEU.getArg(offset, "line");
        var offsetColumn = $jAnEU.getArg(offset, "column");
        if (offsetLine < lastOffset.line || offsetLine === lastOffset.line && offsetColumn < lastOffset.column) throw new Error("Section offsets must be ordered and non-overlapping.");
        lastOffset = offset;
        return {
            generatedOffset: {
                // The offset fields are 0-based, but we use 1-based indices when
                // encoding/decoding from VLQ.
                generatedLine: offsetLine + 1,
                generatedColumn: offsetColumn + 1
            },
            consumer: new $11cc5aa7ba07b448$var$SourceMapConsumer($jAnEU.getArg(s, "map"))
        };
    });
}
$11cc5aa7ba07b448$var$IndexedSourceMapConsumer.prototype = Object.create($11cc5aa7ba07b448$var$SourceMapConsumer.prototype);
$11cc5aa7ba07b448$var$IndexedSourceMapConsumer.prototype.constructor = $11cc5aa7ba07b448$var$SourceMapConsumer;
/**
 * The version of the source mapping spec that we are consuming.
 */ $11cc5aa7ba07b448$var$IndexedSourceMapConsumer.prototype._version = 3;
/**
 * The list of original sources.
 */ Object.defineProperty($11cc5aa7ba07b448$var$IndexedSourceMapConsumer.prototype, "sources", {
    get: function() {
        var sources = [];
        for(var i = 0; i < this._sections.length; i++)for(var j = 0; j < this._sections[i].consumer.sources.length; j++)sources.push(this._sections[i].consumer.sources[j]);
        return sources;
    }
});
/**
 * Returns the original source, line, and column information for the generated
 * source's line and column positions provided. The only argument is an object
 * with the following properties:
 *
 *   - line: The line number in the generated source.
 *   - column: The column number in the generated source.
 *
 * and an object is returned with the following properties:
 *
 *   - source: The original source file, or null.
 *   - line: The line number in the original source, or null.
 *   - column: The column number in the original source, or null.
 *   - name: The original identifier, or null.
 */ $11cc5aa7ba07b448$var$IndexedSourceMapConsumer.prototype.originalPositionFor = function IndexedSourceMapConsumer_originalPositionFor(aArgs) {
    var needle = {
        generatedLine: $jAnEU.getArg(aArgs, "line"),
        generatedColumn: $jAnEU.getArg(aArgs, "column")
    };
    // Find the section containing the generated position we're trying to map
    // to an original position.
    var sectionIndex = $9EEuM.search(needle, this._sections, function(needle, section) {
        var cmp = needle.generatedLine - section.generatedOffset.generatedLine;
        if (cmp) return cmp;
        return needle.generatedColumn - section.generatedOffset.generatedColumn;
    });
    var section = this._sections[sectionIndex];
    if (!section) return {
        source: null,
        line: null,
        column: null,
        name: null
    };
    return section.consumer.originalPositionFor({
        line: needle.generatedLine - (section.generatedOffset.generatedLine - 1),
        column: needle.generatedColumn - (section.generatedOffset.generatedLine === needle.generatedLine ? section.generatedOffset.generatedColumn - 1 : 0),
        bias: aArgs.bias
    });
};
/**
 * Return true if we have the source content for every source in the source
 * map, false otherwise.
 */ $11cc5aa7ba07b448$var$IndexedSourceMapConsumer.prototype.hasContentsOfAllSources = function IndexedSourceMapConsumer_hasContentsOfAllSources() {
    return this._sections.every(function(s) {
        return s.consumer.hasContentsOfAllSources();
    });
};
/**
 * Returns the original source content. The only argument is the url of the
 * original source file. Returns null if no original source content is
 * available.
 */ $11cc5aa7ba07b448$var$IndexedSourceMapConsumer.prototype.sourceContentFor = function IndexedSourceMapConsumer_sourceContentFor(aSource, nullOnMissing) {
    for(var i = 0; i < this._sections.length; i++){
        var section = this._sections[i];
        var content = section.consumer.sourceContentFor(aSource, true);
        if (content) return content;
    }
    if (nullOnMissing) return null;
    else throw new Error('"' + aSource + '" is not in the SourceMap.');
};
/**
 * Returns the generated line and column information for the original source,
 * line, and column positions provided. The only argument is an object with
 * the following properties:
 *
 *   - source: The filename of the original source.
 *   - line: The line number in the original source.
 *   - column: The column number in the original source.
 *
 * and an object is returned with the following properties:
 *
 *   - line: The line number in the generated source, or null.
 *   - column: The column number in the generated source, or null.
 */ $11cc5aa7ba07b448$var$IndexedSourceMapConsumer.prototype.generatedPositionFor = function IndexedSourceMapConsumer_generatedPositionFor(aArgs) {
    for(var i = 0; i < this._sections.length; i++){
        var section = this._sections[i];
        // Only consider this section if the requested source is in the list of
        // sources of the consumer.
        if (section.consumer.sources.indexOf($jAnEU.getArg(aArgs, "source")) === -1) continue;
        var generatedPosition = section.consumer.generatedPositionFor(aArgs);
        if (generatedPosition) {
            var ret = {
                line: generatedPosition.line + (section.generatedOffset.generatedLine - 1),
                column: generatedPosition.column + (section.generatedOffset.generatedLine === generatedPosition.line ? section.generatedOffset.generatedColumn - 1 : 0)
            };
            return ret;
        }
    }
    return {
        line: null,
        column: null
    };
};
/**
 * Parse the mappings in a string in to a data structure which we can easily
 * query (the ordered arrays in the `this.__generatedMappings` and
 * `this.__originalMappings` properties).
 */ $11cc5aa7ba07b448$var$IndexedSourceMapConsumer.prototype._parseMappings = function IndexedSourceMapConsumer_parseMappings(aStr, aSourceRoot) {
    this.__generatedMappings = [];
    this.__originalMappings = [];
    for(var i = 0; i < this._sections.length; i++){
        var section = this._sections[i];
        var sectionMappings = section.consumer._generatedMappings;
        for(var j = 0; j < sectionMappings.length; j++){
            var mapping = sectionMappings[j];
            var source = section.consumer._sources.at(mapping.source);
            if (section.consumer.sourceRoot !== null) source = $jAnEU.join(section.consumer.sourceRoot, source);
            this._sources.add(source);
            source = this._sources.indexOf(source);
            var name = section.consumer._names.at(mapping.name);
            this._names.add(name);
            name = this._names.indexOf(name);
            // The mappings coming from the consumer for the section have
            // generated positions relative to the start of the section, so we
            // need to offset them to be relative to the start of the concatenated
            // generated file.
            var adjustedMapping = {
                source: source,
                generatedLine: mapping.generatedLine + (section.generatedOffset.generatedLine - 1),
                generatedColumn: mapping.generatedColumn + (section.generatedOffset.generatedLine === mapping.generatedLine ? section.generatedOffset.generatedColumn - 1 : 0),
                originalLine: mapping.originalLine,
                originalColumn: mapping.originalColumn,
                name: name
            };
            this.__generatedMappings.push(adjustedMapping);
            if (typeof adjustedMapping.originalLine === "number") this.__originalMappings.push(adjustedMapping);
        }
    }
    $11cc5aa7ba07b448$require$quickSort(this.__generatedMappings, $jAnEU.compareByGeneratedPositionsDeflated);
    $11cc5aa7ba07b448$require$quickSort(this.__originalMappings, $jAnEU.compareByOriginalPositions);
};
$11cc5aa7ba07b448$export$823525094e5b803c = $11cc5aa7ba07b448$var$IndexedSourceMapConsumer;

});
parcelRegister("jAnEU", function(module, exports) {

$parcel$export(module.exports, "getArg", function () { return $e423bb486a8e7861$export$6e45e70adce70bb2; }, function (v) { return $e423bb486a8e7861$export$6e45e70adce70bb2 = v; });
$parcel$export(module.exports, "urlParse", function () { return $e423bb486a8e7861$export$d6e833647f7f5f17; }, function (v) { return $e423bb486a8e7861$export$d6e833647f7f5f17 = v; });
$parcel$export(module.exports, "isAbsolute", function () { return $e423bb486a8e7861$export$e434c7255acda994; }, function (v) { return $e423bb486a8e7861$export$e434c7255acda994 = v; });
$parcel$export(module.exports, "normalize", function () { return $e423bb486a8e7861$export$a3295358bff77e; }, function (v) { return $e423bb486a8e7861$export$a3295358bff77e = v; });
$parcel$export(module.exports, "join", function () { return $e423bb486a8e7861$export$f7e2c8231c57a8bd; }, function (v) { return $e423bb486a8e7861$export$f7e2c8231c57a8bd = v; });
$parcel$export(module.exports, "relative", function () { return $e423bb486a8e7861$export$f0e7d1106eeabbe6; }, function (v) { return $e423bb486a8e7861$export$f0e7d1106eeabbe6 = v; });
$parcel$export(module.exports, "toSetString", function () { return $e423bb486a8e7861$export$be0fa1163fa7a4c; }, function (v) { return $e423bb486a8e7861$export$be0fa1163fa7a4c = v; });
$parcel$export(module.exports, "compareByOriginalPositions", function () { return $e423bb486a8e7861$export$273077902de92ff2; }, function (v) { return $e423bb486a8e7861$export$273077902de92ff2 = v; });
$parcel$export(module.exports, "compareByGeneratedPositionsDeflated", function () { return $e423bb486a8e7861$export$b7acf533941302f6; }, function (v) { return $e423bb486a8e7861$export$b7acf533941302f6 = v; });
/* -*- Mode: js; js-indent-level: 2; -*- */ /*
 * Copyright 2011 Mozilla Foundation and contributors
 * Licensed under the New BSD license. See LICENSE or:
 * http://opensource.org/licenses/BSD-3-Clause
 */ /**
 * This is a helper function for getting values from parameter/options
 * objects.
 *
 * @param args The object we are extracting values from
 * @param name The name of the property we are getting.
 * @param defaultValue An optional value to return if the property is missing
 * from the object. If this is not specified and the property is missing, an
 * error will be thrown.
 */ var $e423bb486a8e7861$export$6e45e70adce70bb2;
var $e423bb486a8e7861$export$d6e833647f7f5f17;
var $e423bb486a8e7861$export$2ec9abc2d2cac192;
var $e423bb486a8e7861$export$a3295358bff77e;
var $e423bb486a8e7861$export$f7e2c8231c57a8bd;
var $e423bb486a8e7861$export$e434c7255acda994;
var $e423bb486a8e7861$export$f0e7d1106eeabbe6;
var $e423bb486a8e7861$export$be0fa1163fa7a4c;
var $e423bb486a8e7861$export$1fc47c3d4c3302a1;
var $e423bb486a8e7861$export$273077902de92ff2;
var $e423bb486a8e7861$export$b7acf533941302f6;
var $e423bb486a8e7861$export$f9c43907549d61f1;
function $e423bb486a8e7861$var$getArg(aArgs, aName, aDefaultValue) {
    if (aName in aArgs) return aArgs[aName];
    else if (arguments.length === 3) return aDefaultValue;
    else throw new Error('"' + aName + '" is a required argument.');
}
$e423bb486a8e7861$export$6e45e70adce70bb2 = $e423bb486a8e7861$var$getArg;
var $e423bb486a8e7861$var$urlRegexp = /^(?:([\w+\-.]+):)?\/\/(?:(\w+:\w+)@)?([\w.]*)(?::(\d+))?(\S*)$/;
var $e423bb486a8e7861$var$dataUrlRegexp = /^data:.+\,.+$/;
function $e423bb486a8e7861$var$urlParse(aUrl) {
    var match = aUrl.match($e423bb486a8e7861$var$urlRegexp);
    if (!match) return null;
    return {
        scheme: match[1],
        auth: match[2],
        host: match[3],
        port: match[4],
        path: match[5]
    };
}
$e423bb486a8e7861$export$d6e833647f7f5f17 = $e423bb486a8e7861$var$urlParse;
function $e423bb486a8e7861$var$urlGenerate(aParsedUrl) {
    var url = "";
    if (aParsedUrl.scheme) url += aParsedUrl.scheme + ":";
    url += "//";
    if (aParsedUrl.auth) url += aParsedUrl.auth + "@";
    if (aParsedUrl.host) url += aParsedUrl.host;
    if (aParsedUrl.port) url += ":" + aParsedUrl.port;
    if (aParsedUrl.path) url += aParsedUrl.path;
    return url;
}
$e423bb486a8e7861$export$2ec9abc2d2cac192 = $e423bb486a8e7861$var$urlGenerate;
/**
 * Normalizes a path, or the path portion of a URL:
 *
 * - Replaces consecutive slashes with one slash.
 * - Removes unnecessary '.' parts.
 * - Removes unnecessary '<dir>/..' parts.
 *
 * Based on code in the Node.js 'path' core module.
 *
 * @param aPath The path or url to normalize.
 */ function $e423bb486a8e7861$var$normalize(aPath) {
    var path = aPath;
    var url = $e423bb486a8e7861$var$urlParse(aPath);
    if (url) {
        if (!url.path) return aPath;
        path = url.path;
    }
    var isAbsolute = $e423bb486a8e7861$export$e434c7255acda994(path);
    var parts = path.split(/\/+/);
    for(var part, up = 0, i = parts.length - 1; i >= 0; i--){
        part = parts[i];
        if (part === ".") parts.splice(i, 1);
        else if (part === "..") up++;
        else if (up > 0) {
            if (part === "") {
                // The first part is blank if the path is absolute. Trying to go
                // above the root is a no-op. Therefore we can remove all '..' parts
                // directly after the root.
                parts.splice(i + 1, up);
                up = 0;
            } else {
                parts.splice(i, 2);
                up--;
            }
        }
    }
    path = parts.join("/");
    if (path === "") path = isAbsolute ? "/" : ".";
    if (url) {
        url.path = path;
        return $e423bb486a8e7861$var$urlGenerate(url);
    }
    return path;
}
$e423bb486a8e7861$export$a3295358bff77e = $e423bb486a8e7861$var$normalize;
/**
 * Joins two paths/URLs.
 *
 * @param aRoot The root path or URL.
 * @param aPath The path or URL to be joined with the root.
 *
 * - If aPath is a URL or a data URI, aPath is returned, unless aPath is a
 *   scheme-relative URL: Then the scheme of aRoot, if any, is prepended
 *   first.
 * - Otherwise aPath is a path. If aRoot is a URL, then its path portion
 *   is updated with the result and aRoot is returned. Otherwise the result
 *   is returned.
 *   - If aPath is absolute, the result is aPath.
 *   - Otherwise the two paths are joined with a slash.
 * - Joining for example 'http://' and 'www.example.com' is also supported.
 */ function $e423bb486a8e7861$var$join(aRoot, aPath) {
    if (aRoot === "") aRoot = ".";
    if (aPath === "") aPath = ".";
    var aPathUrl = $e423bb486a8e7861$var$urlParse(aPath);
    var aRootUrl = $e423bb486a8e7861$var$urlParse(aRoot);
    if (aRootUrl) aRoot = aRootUrl.path || "/";
    // `join(foo, '//www.example.org')`
    if (aPathUrl && !aPathUrl.scheme) {
        if (aRootUrl) aPathUrl.scheme = aRootUrl.scheme;
        return $e423bb486a8e7861$var$urlGenerate(aPathUrl);
    }
    if (aPathUrl || aPath.match($e423bb486a8e7861$var$dataUrlRegexp)) return aPath;
    // `join('http://', 'www.example.com')`
    if (aRootUrl && !aRootUrl.host && !aRootUrl.path) {
        aRootUrl.host = aPath;
        return $e423bb486a8e7861$var$urlGenerate(aRootUrl);
    }
    var joined = aPath.charAt(0) === "/" ? aPath : $e423bb486a8e7861$var$normalize(aRoot.replace(/\/+$/, "") + "/" + aPath);
    if (aRootUrl) {
        aRootUrl.path = joined;
        return $e423bb486a8e7861$var$urlGenerate(aRootUrl);
    }
    return joined;
}
$e423bb486a8e7861$export$f7e2c8231c57a8bd = $e423bb486a8e7861$var$join;
$e423bb486a8e7861$export$e434c7255acda994 = function(aPath) {
    return aPath.charAt(0) === "/" || !!aPath.match($e423bb486a8e7861$var$urlRegexp);
};
/**
 * Make a path relative to a URL or another path.
 *
 * @param aRoot The root path or URL.
 * @param aPath The path or URL to be made relative to aRoot.
 */ function $e423bb486a8e7861$var$relative(aRoot, aPath) {
    if (aRoot === "") aRoot = ".";
    aRoot = aRoot.replace(/\/$/, "");
    // It is possible for the path to be above the root. In this case, simply
    // checking whether the root is a prefix of the path won't work. Instead, we
    // need to remove components from the root one by one, until either we find
    // a prefix that fits, or we run out of components to remove.
    var level = 0;
    while(aPath.indexOf(aRoot + "/") !== 0){
        var index = aRoot.lastIndexOf("/");
        if (index < 0) return aPath;
        // If the only part of the root that is left is the scheme (i.e. http://,
        // file:///, etc.), one or more slashes (/), or simply nothing at all, we
        // have exhausted all components, so the path is not relative to the root.
        aRoot = aRoot.slice(0, index);
        if (aRoot.match(/^([^\/]+:\/)?\/*$/)) return aPath;
        ++level;
    }
    // Make sure we add a "../" for each component we removed from the root.
    return Array(level + 1).join("../") + aPath.substr(aRoot.length + 1);
}
$e423bb486a8e7861$export$f0e7d1106eeabbe6 = $e423bb486a8e7861$var$relative;
var $e423bb486a8e7861$var$supportsNullProto = function() {
    var obj = Object.create(null);
    return !("__proto__" in obj);
}();
function $e423bb486a8e7861$var$identity(s) {
    return s;
}
/**
 * Because behavior goes wacky when you set `__proto__` on objects, we
 * have to prefix all the strings in our set with an arbitrary character.
 *
 * See https://github.com/mozilla/source-map/pull/31 and
 * https://github.com/mozilla/source-map/issues/30
 *
 * @param String aStr
 */ function $e423bb486a8e7861$var$toSetString(aStr) {
    if ($e423bb486a8e7861$var$isProtoString(aStr)) return "$" + aStr;
    return aStr;
}
$e423bb486a8e7861$export$be0fa1163fa7a4c = $e423bb486a8e7861$var$supportsNullProto ? $e423bb486a8e7861$var$identity : $e423bb486a8e7861$var$toSetString;
function $e423bb486a8e7861$var$fromSetString(aStr) {
    if ($e423bb486a8e7861$var$isProtoString(aStr)) return aStr.slice(1);
    return aStr;
}
$e423bb486a8e7861$export$1fc47c3d4c3302a1 = $e423bb486a8e7861$var$supportsNullProto ? $e423bb486a8e7861$var$identity : $e423bb486a8e7861$var$fromSetString;
function $e423bb486a8e7861$var$isProtoString(s) {
    if (!s) return false;
    var length = s.length;
    if (length < 9 /* "__proto__".length */ ) return false;
    if (s.charCodeAt(length - 1) !== 95 /* '_' */  || s.charCodeAt(length - 2) !== 95 /* '_' */  || s.charCodeAt(length - 3) !== 111 /* 'o' */  || s.charCodeAt(length - 4) !== 116 /* 't' */  || s.charCodeAt(length - 5) !== 111 /* 'o' */  || s.charCodeAt(length - 6) !== 114 /* 'r' */  || s.charCodeAt(length - 7) !== 112 /* 'p' */  || s.charCodeAt(length - 8) !== 95 /* '_' */  || s.charCodeAt(length - 9) !== 95 /* '_' */ ) return false;
    for(var i = length - 10; i >= 0; i--){
        if (s.charCodeAt(i) !== 36 /* '$' */ ) return false;
    }
    return true;
}
/**
 * Comparator between two mappings where the original positions are compared.
 *
 * Optionally pass in `true` as `onlyCompareGenerated` to consider two
 * mappings with the same original source/line/column, but different generated
 * line and column the same. Useful when searching for a mapping with a
 * stubbed out mapping.
 */ function $e423bb486a8e7861$var$compareByOriginalPositions(mappingA, mappingB, onlyCompareOriginal) {
    var cmp = mappingA.source - mappingB.source;
    if (cmp !== 0) return cmp;
    cmp = mappingA.originalLine - mappingB.originalLine;
    if (cmp !== 0) return cmp;
    cmp = mappingA.originalColumn - mappingB.originalColumn;
    if (cmp !== 0 || onlyCompareOriginal) return cmp;
    cmp = mappingA.generatedColumn - mappingB.generatedColumn;
    if (cmp !== 0) return cmp;
    cmp = mappingA.generatedLine - mappingB.generatedLine;
    if (cmp !== 0) return cmp;
    return mappingA.name - mappingB.name;
}
$e423bb486a8e7861$export$273077902de92ff2 = $e423bb486a8e7861$var$compareByOriginalPositions;
/**
 * Comparator between two mappings with deflated source and name indices where
 * the generated positions are compared.
 *
 * Optionally pass in `true` as `onlyCompareGenerated` to consider two
 * mappings with the same generated line and column, but different
 * source/name/original line and column the same. Useful when searching for a
 * mapping with a stubbed out mapping.
 */ function $e423bb486a8e7861$var$compareByGeneratedPositionsDeflated(mappingA, mappingB, onlyCompareGenerated) {
    var cmp = mappingA.generatedLine - mappingB.generatedLine;
    if (cmp !== 0) return cmp;
    cmp = mappingA.generatedColumn - mappingB.generatedColumn;
    if (cmp !== 0 || onlyCompareGenerated) return cmp;
    cmp = mappingA.source - mappingB.source;
    if (cmp !== 0) return cmp;
    cmp = mappingA.originalLine - mappingB.originalLine;
    if (cmp !== 0) return cmp;
    cmp = mappingA.originalColumn - mappingB.originalColumn;
    if (cmp !== 0) return cmp;
    return mappingA.name - mappingB.name;
}
$e423bb486a8e7861$export$b7acf533941302f6 = $e423bb486a8e7861$var$compareByGeneratedPositionsDeflated;
function $e423bb486a8e7861$var$strcmp(aStr1, aStr2) {
    if (aStr1 === aStr2) return 0;
    if (aStr1 > aStr2) return 1;
    return -1;
}
/**
 * Comparator between two mappings with inflated source and name strings where
 * the generated positions are compared.
 */ function $e423bb486a8e7861$var$compareByGeneratedPositionsInflated(mappingA, mappingB) {
    var cmp = mappingA.generatedLine - mappingB.generatedLine;
    if (cmp !== 0) return cmp;
    cmp = mappingA.generatedColumn - mappingB.generatedColumn;
    if (cmp !== 0) return cmp;
    cmp = $e423bb486a8e7861$var$strcmp(mappingA.source, mappingB.source);
    if (cmp !== 0) return cmp;
    cmp = mappingA.originalLine - mappingB.originalLine;
    if (cmp !== 0) return cmp;
    cmp = mappingA.originalColumn - mappingB.originalColumn;
    if (cmp !== 0) return cmp;
    return $e423bb486a8e7861$var$strcmp(mappingA.name, mappingB.name);
}
$e423bb486a8e7861$export$f9c43907549d61f1 = $e423bb486a8e7861$var$compareByGeneratedPositionsInflated;

});

parcelRegister("9EEuM", function(module, exports) {

$parcel$export(module.exports, "GREATEST_LOWER_BOUND", function () { return $707743081a8e9eb6$export$4ecd616dce182dff; }, function (v) { return $707743081a8e9eb6$export$4ecd616dce182dff = v; });
$parcel$export(module.exports, "LEAST_UPPER_BOUND", function () { return $707743081a8e9eb6$export$b99fbecff261243; }, function (v) { return $707743081a8e9eb6$export$b99fbecff261243 = v; });
$parcel$export(module.exports, "search", function () { return $707743081a8e9eb6$export$d76128d007d19019; }, function (v) { return $707743081a8e9eb6$export$d76128d007d19019 = v; });
/* -*- Mode: js; js-indent-level: 2; -*- */ /*
 * Copyright 2011 Mozilla Foundation and contributors
 * Licensed under the New BSD license. See LICENSE or:
 * http://opensource.org/licenses/BSD-3-Clause
 */ var $707743081a8e9eb6$export$4ecd616dce182dff;
var $707743081a8e9eb6$export$b99fbecff261243;
/**
 * This is an implementation of binary search which will always try and return
 * the index of the closest element if there is no exact hit. This is because
 * mappings between original and generated line/col pairs are single points,
 * and there is an implicit region between each of them, so a miss just means
 * that you aren't on the very start of a region.
 *
 * @param aNeedle The element you are looking for.
 * @param aHaystack The array that is being searched.
 * @param aCompare A function which takes the needle and an element in the
 *     array and returns -1, 0, or 1 depending on whether the needle is less
 *     than, equal to, or greater than the element, respectively.
 * @param aBias Either 'binarySearch.GREATEST_LOWER_BOUND' or
 *     'binarySearch.LEAST_UPPER_BOUND'. Specifies whether to return the
 *     closest element that is smaller than or greater than the one we are
 *     searching for, respectively, if the exact element cannot be found.
 *     Defaults to 'binarySearch.GREATEST_LOWER_BOUND'.
 */ var $707743081a8e9eb6$export$d76128d007d19019;
$707743081a8e9eb6$export$4ecd616dce182dff = 1;
$707743081a8e9eb6$export$b99fbecff261243 = 2;
/**
 * Recursive implementation of binary search.
 *
 * @param aLow Indices here and lower do not contain the needle.
 * @param aHigh Indices here and higher do not contain the needle.
 * @param aNeedle The element being searched for.
 * @param aHaystack The non-empty array being searched.
 * @param aCompare Function which takes two elements and returns -1, 0, or 1.
 * @param aBias Either 'binarySearch.GREATEST_LOWER_BOUND' or
 *     'binarySearch.LEAST_UPPER_BOUND'. Specifies whether to return the
 *     closest element that is smaller than or greater than the one we are
 *     searching for, respectively, if the exact element cannot be found.
 */ function $707743081a8e9eb6$var$recursiveSearch(aLow, aHigh, aNeedle, aHaystack, aCompare, aBias) {
    // This function terminates when one of the following is true:
    //
    //   1. We find the exact element we are looking for.
    //
    //   2. We did not find the exact element, but we can return the index of
    //      the next-closest element.
    //
    //   3. We did not find the exact element, and there is no next-closest
    //      element than the one we are searching for, so we return -1.
    var mid = Math.floor((aHigh - aLow) / 2) + aLow;
    var cmp = aCompare(aNeedle, aHaystack[mid], true);
    if (cmp === 0) // Found the element we are looking for.
    return mid;
    else if (cmp > 0) {
        // Our needle is greater than aHaystack[mid].
        if (aHigh - mid > 1) // The element is in the upper half.
        return $707743081a8e9eb6$var$recursiveSearch(mid, aHigh, aNeedle, aHaystack, aCompare, aBias);
        // The exact needle element was not found in this haystack. Determine if
        // we are in termination case (3) or (2) and return the appropriate thing.
        if (aBias == $707743081a8e9eb6$export$b99fbecff261243) return aHigh < aHaystack.length ? aHigh : -1;
        else return mid;
    } else {
        // Our needle is less than aHaystack[mid].
        if (mid - aLow > 1) // The element is in the lower half.
        return $707743081a8e9eb6$var$recursiveSearch(aLow, mid, aNeedle, aHaystack, aCompare, aBias);
        // we are in termination case (3) or (2) and return the appropriate thing.
        if (aBias == $707743081a8e9eb6$export$b99fbecff261243) return mid;
        else return aLow < 0 ? -1 : aLow;
    }
}
$707743081a8e9eb6$export$d76128d007d19019 = function search(aNeedle, aHaystack, aCompare, aBias) {
    if (aHaystack.length === 0) return -1;
    var index = $707743081a8e9eb6$var$recursiveSearch(-1, aHaystack.length, aNeedle, aHaystack, aCompare, aBias || $707743081a8e9eb6$export$4ecd616dce182dff);
    if (index < 0) return -1;
    // We have found either the exact element, or the next-closest element than
    // the one we are searching for. However, there may be more than one such
    // element. Make sure we always return the smallest of these.
    while(index - 1 >= 0){
        if (aCompare(aHaystack[index], aHaystack[index - 1], true) !== 0) break;
        --index;
    }
    return index;
};

});

parcelRegister("lA9c0", function(module, exports) {

$parcel$export(module.exports, "ArraySet", function () { return $fb641740934ab1d2$export$605bbf5ea7b60ba3; }, function (v) { return $fb641740934ab1d2$export$605bbf5ea7b60ba3 = v; });
/* -*- Mode: js; js-indent-level: 2; -*- */ /*
 * Copyright 2011 Mozilla Foundation and contributors
 * Licensed under the New BSD license. See LICENSE or:
 * http://opensource.org/licenses/BSD-3-Clause
 */ var $fb641740934ab1d2$export$605bbf5ea7b60ba3;

var $jAnEU = parcelRequire("jAnEU");
var $fb641740934ab1d2$var$has = Object.prototype.hasOwnProperty;
/**
 * A data structure which is a combination of an array and a set. Adding a new
 * member is O(1), testing for membership is O(1), and finding the index of an
 * element is O(1). Removing elements from the set is not supported. Only
 * strings are supported for membership.
 */ function $fb641740934ab1d2$var$ArraySet() {
    this._array = [];
    this._set = Object.create(null);
}
/**
 * Static method for creating ArraySet instances from an existing array.
 */ $fb641740934ab1d2$var$ArraySet.fromArray = function ArraySet_fromArray(aArray, aAllowDuplicates) {
    var set = new $fb641740934ab1d2$var$ArraySet();
    for(var i = 0, len = aArray.length; i < len; i++)set.add(aArray[i], aAllowDuplicates);
    return set;
};
/**
 * Return how many unique items are in this ArraySet. If duplicates have been
 * added, than those do not count towards the size.
 *
 * @returns Number
 */ $fb641740934ab1d2$var$ArraySet.prototype.size = function ArraySet_size() {
    return Object.getOwnPropertyNames(this._set).length;
};
/**
 * Add the given string to this set.
 *
 * @param String aStr
 */ $fb641740934ab1d2$var$ArraySet.prototype.add = function ArraySet_add(aStr, aAllowDuplicates) {
    var sStr = $jAnEU.toSetString(aStr);
    var isDuplicate = $fb641740934ab1d2$var$has.call(this._set, sStr);
    var idx = this._array.length;
    if (!isDuplicate || aAllowDuplicates) this._array.push(aStr);
    if (!isDuplicate) this._set[sStr] = idx;
};
/**
 * Is the given string a member of this set?
 *
 * @param String aStr
 */ $fb641740934ab1d2$var$ArraySet.prototype.has = function ArraySet_has(aStr) {
    var sStr = $jAnEU.toSetString(aStr);
    return $fb641740934ab1d2$var$has.call(this._set, sStr);
};
/**
 * What is the index of the given string in the array?
 *
 * @param String aStr
 */ $fb641740934ab1d2$var$ArraySet.prototype.indexOf = function ArraySet_indexOf(aStr) {
    var sStr = $jAnEU.toSetString(aStr);
    if ($fb641740934ab1d2$var$has.call(this._set, sStr)) return this._set[sStr];
    throw new Error('"' + aStr + '" is not in the set.');
};
/**
 * What is the element at the given index?
 *
 * @param Number aIdx
 */ $fb641740934ab1d2$var$ArraySet.prototype.at = function ArraySet_at(aIdx) {
    if (aIdx >= 0 && aIdx < this._array.length) return this._array[aIdx];
    throw new Error("No element indexed by " + aIdx);
};
/**
 * Returns the array representation of this set (which has the proper indices
 * indicated by indexOf). Note that this is a copy of the internal array used
 * for storing the members so that no one can mess with internal state.
 */ $fb641740934ab1d2$var$ArraySet.prototype.toArray = function ArraySet_toArray() {
    return this._array.slice();
};
$fb641740934ab1d2$export$605bbf5ea7b60ba3 = $fb641740934ab1d2$var$ArraySet;

});

parcelRegister("40yPQ", function(module, exports) {

$parcel$export(module.exports, "decode", function () { return $2eb22f0d829d9688$export$2f872c0f2117be69; }, function (v) { return $2eb22f0d829d9688$export$2f872c0f2117be69 = v; });
/* -*- Mode: js; js-indent-level: 2; -*- */ /*
 * Copyright 2011 Mozilla Foundation and contributors
 * Licensed under the New BSD license. See LICENSE or:
 * http://opensource.org/licenses/BSD-3-Clause
 *
 * Based on the Base 64 VLQ implementation in Closure Compiler:
 * https://code.google.com/p/closure-compiler/source/browse/trunk/src/com/google/debugging/sourcemap/Base64VLQ.java
 *
 * Copyright 2011 The Closure Compiler Authors. All rights reserved.
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are
 * met:
 *
 *  * Redistributions of source code must retain the above copyright
 *    notice, this list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above
 *    copyright notice, this list of conditions and the following
 *    disclaimer in the documentation and/or other materials provided
 *    with the distribution.
 *  * Neither the name of Google Inc. nor the names of its
 *    contributors may be used to endorse or promote products derived
 *    from this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
 * A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT
 * OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
 * SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT
 * LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE,
 * DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY
 * THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
 * OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */ /**
 * Returns the base 64 VLQ encoded value.
 */ var $2eb22f0d829d9688$export$c564cdbbe6da493;
/**
 * Decodes the next base 64 VLQ value from the given string and returns the
 * value and the rest of the string via the out parameter.
 */ var $2eb22f0d829d9688$export$2f872c0f2117be69;

var $l5UhZ = parcelRequire("l5UhZ");
// A single base 64 digit can contain 6 bits of data. For the base 64 variable
// length quantities we use in the source map spec, the first bit is the sign,
// the next four bits are the actual value, and the 6th bit is the
// continuation bit. The continuation bit tells us whether there are more
// digits in this value following this digit.
//
//   Continuation
//   |    Sign
//   |    |
//   V    V
//   101011
var $2eb22f0d829d9688$var$VLQ_BASE_SHIFT = 5;
// binary: 100000
var $2eb22f0d829d9688$var$VLQ_BASE = 1 << $2eb22f0d829d9688$var$VLQ_BASE_SHIFT;
// binary: 011111
var $2eb22f0d829d9688$var$VLQ_BASE_MASK = $2eb22f0d829d9688$var$VLQ_BASE - 1;
// binary: 100000
var $2eb22f0d829d9688$var$VLQ_CONTINUATION_BIT = $2eb22f0d829d9688$var$VLQ_BASE;
/**
 * Converts from a two-complement value to a value where the sign bit is
 * placed in the least significant bit.  For example, as decimals:
 *   1 becomes 2 (10 binary), -1 becomes 3 (11 binary)
 *   2 becomes 4 (100 binary), -2 becomes 5 (101 binary)
 */ function $2eb22f0d829d9688$var$toVLQSigned(aValue) {
    return aValue < 0 ? (-aValue << 1) + 1 : (aValue << 1) + 0;
}
/**
 * Converts to a two-complement value from a value where the sign bit is
 * placed in the least significant bit.  For example, as decimals:
 *   2 (10 binary) becomes 1, 3 (11 binary) becomes -1
 *   4 (100 binary) becomes 2, 5 (101 binary) becomes -2
 */ function $2eb22f0d829d9688$var$fromVLQSigned(aValue) {
    var isNegative = (aValue & 1) === 1;
    var shifted = aValue >> 1;
    return isNegative ? -shifted : shifted;
}
$2eb22f0d829d9688$export$c564cdbbe6da493 = function base64VLQ_encode(aValue) {
    var encoded = "";
    var digit;
    var vlq = $2eb22f0d829d9688$var$toVLQSigned(aValue);
    do {
        digit = vlq & $2eb22f0d829d9688$var$VLQ_BASE_MASK;
        vlq >>>= $2eb22f0d829d9688$var$VLQ_BASE_SHIFT;
        if (vlq > 0) // There are still more digits in this value, so we must make sure the
        // continuation bit is marked.
        digit |= $2eb22f0d829d9688$var$VLQ_CONTINUATION_BIT;
        encoded += $l5UhZ.encode(digit);
    }while (vlq > 0);
    return encoded;
};
$2eb22f0d829d9688$export$2f872c0f2117be69 = function base64VLQ_decode(aStr, aIndex, aOutParam) {
    var strLen = aStr.length;
    var result = 0;
    var shift = 0;
    var continuation, digit;
    do {
        if (aIndex >= strLen) throw new Error("Expected more digits in base 64 VLQ value.");
        digit = $l5UhZ.decode(aStr.charCodeAt(aIndex++));
        if (digit === -1) throw new Error("Invalid base64 digit: " + aStr.charAt(aIndex - 1));
        continuation = !!(digit & $2eb22f0d829d9688$var$VLQ_CONTINUATION_BIT);
        digit &= $2eb22f0d829d9688$var$VLQ_BASE_MASK;
        result = result + (digit << shift);
        shift += $2eb22f0d829d9688$var$VLQ_BASE_SHIFT;
    }while (continuation);
    aOutParam.value = $2eb22f0d829d9688$var$fromVLQSigned(result);
    aOutParam.rest = aIndex;
};

});
parcelRegister("l5UhZ", function(module, exports) {

$parcel$export(module.exports, "encode", function () { return $f5b5ba79f5f0b860$export$c564cdbbe6da493; }, function (v) { return $f5b5ba79f5f0b860$export$c564cdbbe6da493 = v; });
$parcel$export(module.exports, "decode", function () { return $f5b5ba79f5f0b860$export$2f872c0f2117be69; }, function (v) { return $f5b5ba79f5f0b860$export$2f872c0f2117be69 = v; });
/* -*- Mode: js; js-indent-level: 2; -*- */ /*
 * Copyright 2011 Mozilla Foundation and contributors
 * Licensed under the New BSD license. See LICENSE or:
 * http://opensource.org/licenses/BSD-3-Clause
 */ /**
 * Encode an integer in the range of 0 to 63 to a single base 64 digit.
 */ var $f5b5ba79f5f0b860$export$c564cdbbe6da493;
/**
 * Decode a single base 64 character code digit to an integer. Returns -1 on
 * failure.
 */ var $f5b5ba79f5f0b860$export$2f872c0f2117be69;
var $f5b5ba79f5f0b860$var$intToCharMap = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/".split("");
$f5b5ba79f5f0b860$export$c564cdbbe6da493 = function(number) {
    if (0 <= number && number < $f5b5ba79f5f0b860$var$intToCharMap.length) return $f5b5ba79f5f0b860$var$intToCharMap[number];
    throw new TypeError("Must be between 0 and 63: " + number);
};
$f5b5ba79f5f0b860$export$2f872c0f2117be69 = function(charCode) {
    var bigA = 65; // 'A'
    var bigZ = 90; // 'Z'
    var littleA = 97; // 'a'
    var littleZ = 122; // 'z'
    var zero = 48; // '0'
    var nine = 57; // '9'
    var plus = 43; // '+'
    var slash = 47; // '/'
    var littleOffset = 26;
    var numberOffset = 52;
    // 0 - 25: ABCDEFGHIJKLMNOPQRSTUVWXYZ
    if (bigA <= charCode && charCode <= bigZ) return charCode - bigA;
    // 26 - 51: abcdefghijklmnopqrstuvwxyz
    if (littleA <= charCode && charCode <= littleZ) return charCode - littleA + littleOffset;
    // 52 - 61: 0123456789
    if (zero <= charCode && charCode <= nine) return charCode - zero + numberOffset;
    // 62: +
    if (charCode == plus) return 62;
    // 63: /
    if (charCode == slash) return 63;
    // Invalid base64 digit.
    return -1;
};

});


parcelRegister("e5fKN", function(module, exports) {

$parcel$export(module.exports, "quickSort", function () { return $a40dc0ad3bfcf5f0$export$866270269b9544a5; }, function (v) { return $a40dc0ad3bfcf5f0$export$866270269b9544a5 = v; });
/* -*- Mode: js; js-indent-level: 2; -*- */ /*
 * Copyright 2011 Mozilla Foundation and contributors
 * Licensed under the New BSD license. See LICENSE or:
 * http://opensource.org/licenses/BSD-3-Clause
 */ // It turns out that some (most?) JavaScript engines don't self-host
// `Array.prototype.sort`. This makes sense because C++ will likely remain
// faster than JS when doing raw CPU-intensive sorting. However, when using a
// custom comparator function, calling back and forth between the VM's C++ and
// JIT'd JS is rather slow *and* loses JIT type information, resulting in
// worse generated code for the comparator function than would be optimal. In
// fact, when sorting with a comparator, these costs outweigh the benefits of
// sorting in C++. By using our own JS-implemented Quick Sort (below), we get
// a ~3500ms mean speed-up in `bench/bench.html`.
/**
 * Swap the elements indexed by `x` and `y` in the array `ary`.
 *
 * @param {Array} ary
 *        The array.
 * @param {Number} x
 *        The index of the first item.
 * @param {Number} y
 *        The index of the second item.
 */ /**
 * Sort the given array in-place with the given comparator function.
 *
 * @param {Array} ary
 *        An array to sort.
 * @param {function} comparator
 *        Function to use to compare two items.
 */ var $a40dc0ad3bfcf5f0$export$866270269b9544a5;
function $a40dc0ad3bfcf5f0$var$swap(ary, x, y) {
    var temp = ary[x];
    ary[x] = ary[y];
    ary[y] = temp;
}
/**
 * Returns a random integer within the range `low .. high` inclusive.
 *
 * @param {Number} low
 *        The lower bound on the range.
 * @param {Number} high
 *        The upper bound on the range.
 */ function $a40dc0ad3bfcf5f0$var$randomIntInRange(low, high) {
    return Math.round(low + Math.random() * (high - low));
}
/**
 * The Quick Sort algorithm.
 *
 * @param {Array} ary
 *        An array to sort.
 * @param {function} comparator
 *        Function to use to compare two items.
 * @param {Number} p
 *        Start index of the array
 * @param {Number} r
 *        End index of the array
 */ function $a40dc0ad3bfcf5f0$var$doQuickSort(ary, comparator, p, r) {
    // If our lower bound is less than our upper bound, we (1) partition the
    // array into two pieces and (2) recurse on each half. If it is not, this is
    // the empty array and our base case.
    if (p < r) {
        // (1) Partitioning.
        //
        // The partitioning chooses a pivot between `p` and `r` and moves all
        // elements that are less than or equal to the pivot to the before it, and
        // all the elements that are greater than it after it. The effect is that
        // once partition is done, the pivot is in the exact place it will be when
        // the array is put in sorted order, and it will not need to be moved
        // again. This runs in O(n) time.
        // Always choose a random pivot so that an input array which is reverse
        // sorted does not cause O(n^2) running time.
        var pivotIndex = $a40dc0ad3bfcf5f0$var$randomIntInRange(p, r);
        var i = p - 1;
        $a40dc0ad3bfcf5f0$var$swap(ary, pivotIndex, r);
        var pivot = ary[r];
        // Immediately after `j` is incremented in this loop, the following hold
        // true:
        //
        //   * Every element in `ary[p .. i]` is less than or equal to the pivot.
        //
        //   * Every element in `ary[i+1 .. j-1]` is greater than the pivot.
        for(var j = p; j < r; j++)if (comparator(ary[j], pivot) <= 0) {
            i += 1;
            $a40dc0ad3bfcf5f0$var$swap(ary, i, j);
        }
        $a40dc0ad3bfcf5f0$var$swap(ary, i + 1, j);
        var q = i + 1;
        // (2) Recurse on each half.
        $a40dc0ad3bfcf5f0$var$doQuickSort(ary, comparator, p, q - 1);
        $a40dc0ad3bfcf5f0$var$doQuickSort(ary, comparator, q + 1, r);
    }
}
$a40dc0ad3bfcf5f0$export$866270269b9544a5 = function(ary, comparator) {
    $a40dc0ad3bfcf5f0$var$doQuickSort(ary, comparator, 0, ary.length - 1);
};

});




parcelRegister("8Hv2S", function(module, exports) {
// 'path' module extracted from Node.js v8.11.1 (only the posix part)
// transplited with Babel
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $2IVpK = parcelRequire("2IVpK");
"use strict";
function $655a6bdb16b925e8$var$assertPath(path) {
    if (typeof path !== "string") throw new TypeError("Path must be a string. Received " + JSON.stringify(path));
}
// Resolves . and .. elements in a path with directory names
function $655a6bdb16b925e8$var$normalizeStringPosix(path, allowAboveRoot) {
    var res = "";
    var lastSegmentLength = 0;
    var lastSlash = -1;
    var dots = 0;
    var code;
    for(var i = 0; i <= path.length; ++i){
        if (i < path.length) code = path.charCodeAt(i);
        else if (code === 47 /*/*/ ) break;
        else code = 47 /*/*/ ;
        if (code === 47 /*/*/ ) {
            if (lastSlash === i - 1 || dots === 1) ;
            else if (lastSlash !== i - 1 && dots === 2) {
                if (res.length < 2 || lastSegmentLength !== 2 || res.charCodeAt(res.length - 1) !== 46 /*.*/  || res.charCodeAt(res.length - 2) !== 46 /*.*/ ) {
                    if (res.length > 2) {
                        var lastSlashIndex = res.lastIndexOf("/");
                        if (lastSlashIndex !== res.length - 1) {
                            if (lastSlashIndex === -1) {
                                res = "";
                                lastSegmentLength = 0;
                            } else {
                                res = res.slice(0, lastSlashIndex);
                                lastSegmentLength = res.length - 1 - res.lastIndexOf("/");
                            }
                            lastSlash = i;
                            dots = 0;
                            continue;
                        }
                    } else if (res.length === 2 || res.length === 1) {
                        res = "";
                        lastSegmentLength = 0;
                        lastSlash = i;
                        dots = 0;
                        continue;
                    }
                }
                if (allowAboveRoot) {
                    if (res.length > 0) res += "/..";
                    else res = "..";
                    lastSegmentLength = 2;
                }
            } else {
                if (res.length > 0) res += "/" + path.slice(lastSlash + 1, i);
                else res = path.slice(lastSlash + 1, i);
                lastSegmentLength = i - lastSlash - 1;
            }
            lastSlash = i;
            dots = 0;
        } else if (code === 46 /*.*/  && dots !== -1) ++dots;
        else dots = -1;
    }
    return res;
}
function $655a6bdb16b925e8$var$_format(sep, pathObject) {
    var dir = pathObject.dir || pathObject.root;
    var base = pathObject.base || (pathObject.name || "") + (pathObject.ext || "");
    if (!dir) return base;
    if (dir === pathObject.root) return dir + base;
    return dir + sep + base;
}
var $655a6bdb16b925e8$var$posix = {
    // path.resolve([from ...], to)
    resolve: function resolve() {
        var resolvedPath = "";
        var resolvedAbsolute = false;
        var cwd;
        for(var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--){
            var path;
            if (i >= 0) path = arguments[i];
            else {
                if (cwd === undefined) cwd = $2IVpK.cwd();
                path = cwd;
            }
            $655a6bdb16b925e8$var$assertPath(path);
            // Skip empty entries
            if (path.length === 0) continue;
            resolvedPath = path + "/" + resolvedPath;
            resolvedAbsolute = path.charCodeAt(0) === 47 /*/*/ ;
        }
        // At this point the path should be resolved to a full absolute path, but
        // handle relative paths to be safe (might happen when process.cwd() fails)
        // Normalize the path
        resolvedPath = $655a6bdb16b925e8$var$normalizeStringPosix(resolvedPath, !resolvedAbsolute);
        if (resolvedAbsolute) {
            if (resolvedPath.length > 0) return "/" + resolvedPath;
            else return "/";
        } else if (resolvedPath.length > 0) return resolvedPath;
        else return ".";
    },
    normalize: function normalize(path) {
        $655a6bdb16b925e8$var$assertPath(path);
        if (path.length === 0) return ".";
        var isAbsolute = path.charCodeAt(0) === 47 /*/*/ ;
        var trailingSeparator = path.charCodeAt(path.length - 1) === 47 /*/*/ ;
        // Normalize the path
        path = $655a6bdb16b925e8$var$normalizeStringPosix(path, !isAbsolute);
        if (path.length === 0 && !isAbsolute) path = ".";
        if (path.length > 0 && trailingSeparator) path += "/";
        if (isAbsolute) return "/" + path;
        return path;
    },
    isAbsolute: function isAbsolute(path) {
        $655a6bdb16b925e8$var$assertPath(path);
        return path.length > 0 && path.charCodeAt(0) === 47 /*/*/ ;
    },
    join: function join() {
        if (arguments.length === 0) return ".";
        var joined;
        for(var i = 0; i < arguments.length; ++i){
            var arg = arguments[i];
            $655a6bdb16b925e8$var$assertPath(arg);
            if (arg.length > 0) {
                if (joined === undefined) joined = arg;
                else joined += "/" + arg;
            }
        }
        if (joined === undefined) return ".";
        return $655a6bdb16b925e8$var$posix.normalize(joined);
    },
    relative: function relative(from, to) {
        $655a6bdb16b925e8$var$assertPath(from);
        $655a6bdb16b925e8$var$assertPath(to);
        if (from === to) return "";
        from = $655a6bdb16b925e8$var$posix.resolve(from);
        to = $655a6bdb16b925e8$var$posix.resolve(to);
        if (from === to) return "";
        // Trim any leading backslashes
        var fromStart = 1;
        for(; fromStart < from.length; ++fromStart){
            if (from.charCodeAt(fromStart) !== 47 /*/*/ ) break;
        }
        var fromEnd = from.length;
        var fromLen = fromEnd - fromStart;
        // Trim any leading backslashes
        var toStart = 1;
        for(; toStart < to.length; ++toStart){
            if (to.charCodeAt(toStart) !== 47 /*/*/ ) break;
        }
        var toEnd = to.length;
        var toLen = toEnd - toStart;
        // Compare paths to find the longest common path from root
        var length = fromLen < toLen ? fromLen : toLen;
        var lastCommonSep = -1;
        var i = 0;
        for(; i <= length; ++i){
            if (i === length) {
                if (toLen > length) {
                    if (to.charCodeAt(toStart + i) === 47 /*/*/ ) // We get here if `from` is the exact base path for `to`.
                    // For example: from='/foo/bar'; to='/foo/bar/baz'
                    return to.slice(toStart + i + 1);
                    else if (i === 0) // We get here if `from` is the root
                    // For example: from='/'; to='/foo'
                    return to.slice(toStart + i);
                } else if (fromLen > length) {
                    if (from.charCodeAt(fromStart + i) === 47 /*/*/ ) // We get here if `to` is the exact base path for `from`.
                    // For example: from='/foo/bar/baz'; to='/foo/bar'
                    lastCommonSep = i;
                    else if (i === 0) // We get here if `to` is the root.
                    // For example: from='/foo'; to='/'
                    lastCommonSep = 0;
                }
                break;
            }
            var fromCode = from.charCodeAt(fromStart + i);
            var toCode = to.charCodeAt(toStart + i);
            if (fromCode !== toCode) break;
            else if (fromCode === 47 /*/*/ ) lastCommonSep = i;
        }
        var out = "";
        // Generate the relative path based on the path difference between `to`
        // and `from`
        for(i = fromStart + lastCommonSep + 1; i <= fromEnd; ++i)if (i === fromEnd || from.charCodeAt(i) === 47 /*/*/ ) {
            if (out.length === 0) out += "..";
            else out += "/..";
        }
        // Lastly, append the rest of the destination (`to`) path that comes after
        // the common path parts
        if (out.length > 0) return out + to.slice(toStart + lastCommonSep);
        else {
            toStart += lastCommonSep;
            if (to.charCodeAt(toStart) === 47 /*/*/ ) ++toStart;
            return to.slice(toStart);
        }
    },
    _makeLong: function _makeLong(path) {
        return path;
    },
    dirname: function dirname(path) {
        $655a6bdb16b925e8$var$assertPath(path);
        if (path.length === 0) return ".";
        var code = path.charCodeAt(0);
        var hasRoot = code === 47 /*/*/ ;
        var end = -1;
        var matchedSlash = true;
        for(var i = path.length - 1; i >= 1; --i){
            code = path.charCodeAt(i);
            if (code === 47 /*/*/ ) {
                if (!matchedSlash) {
                    end = i;
                    break;
                }
            } else // We saw the first non-path separator
            matchedSlash = false;
        }
        if (end === -1) return hasRoot ? "/" : ".";
        if (hasRoot && end === 1) return "//";
        return path.slice(0, end);
    },
    basename: function basename(path, ext) {
        if (ext !== undefined && typeof ext !== "string") throw new TypeError('"ext" argument must be a string');
        $655a6bdb16b925e8$var$assertPath(path);
        var start = 0;
        var end = -1;
        var matchedSlash = true;
        var i;
        if (ext !== undefined && ext.length > 0 && ext.length <= path.length) {
            if (ext.length === path.length && ext === path) return "";
            var extIdx = ext.length - 1;
            var firstNonSlashEnd = -1;
            for(i = path.length - 1; i >= 0; --i){
                var code = path.charCodeAt(i);
                if (code === 47 /*/*/ ) // If we reached a path separator that was not part of a set of path
                // separators at the end of the string, stop now
                {
                    if (!matchedSlash) {
                        start = i + 1;
                        break;
                    }
                } else {
                    if (firstNonSlashEnd === -1) {
                        // We saw the first non-path separator, remember this index in case
                        // we need it if the extension ends up not matching
                        matchedSlash = false;
                        firstNonSlashEnd = i + 1;
                    }
                    if (extIdx >= 0) {
                        // Try to match the explicit extension
                        if (code === ext.charCodeAt(extIdx)) {
                            if (--extIdx === -1) // We matched the extension, so mark this as the end of our path
                            // component
                            end = i;
                        } else {
                            // Extension does not match, so our result is the entire path
                            // component
                            extIdx = -1;
                            end = firstNonSlashEnd;
                        }
                    }
                }
            }
            if (start === end) end = firstNonSlashEnd;
            else if (end === -1) end = path.length;
            return path.slice(start, end);
        } else {
            for(i = path.length - 1; i >= 0; --i){
                if (path.charCodeAt(i) === 47 /*/*/ ) // If we reached a path separator that was not part of a set of path
                // separators at the end of the string, stop now
                {
                    if (!matchedSlash) {
                        start = i + 1;
                        break;
                    }
                } else if (end === -1) {
                    // We saw the first non-path separator, mark this as the end of our
                    // path component
                    matchedSlash = false;
                    end = i + 1;
                }
            }
            if (end === -1) return "";
            return path.slice(start, end);
        }
    },
    extname: function extname(path) {
        $655a6bdb16b925e8$var$assertPath(path);
        var startDot = -1;
        var startPart = 0;
        var end = -1;
        var matchedSlash = true;
        // Track the state of characters (if any) we see before our first dot and
        // after any path separator we find
        var preDotState = 0;
        for(var i = path.length - 1; i >= 0; --i){
            var code = path.charCodeAt(i);
            if (code === 47 /*/*/ ) {
                // If we reached a path separator that was not part of a set of path
                // separators at the end of the string, stop now
                if (!matchedSlash) {
                    startPart = i + 1;
                    break;
                }
                continue;
            }
            if (end === -1) {
                // We saw the first non-path separator, mark this as the end of our
                // extension
                matchedSlash = false;
                end = i + 1;
            }
            if (code === 46 /*.*/ ) {
                // If this is our first dot, mark it as the start of our extension
                if (startDot === -1) startDot = i;
                else if (preDotState !== 1) preDotState = 1;
            } else if (startDot !== -1) // We saw a non-dot and non-path separator before our dot, so we should
            // have a good chance at having a non-empty extension
            preDotState = -1;
        }
        if (startDot === -1 || end === -1 || // We saw a non-dot character immediately before the dot
        preDotState === 0 || // The (right-most) trimmed path component is exactly '..'
        preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) return "";
        return path.slice(startDot, end);
    },
    format: function format(pathObject) {
        if (pathObject === null || typeof pathObject !== "object") throw new TypeError('The "pathObject" argument must be of type Object. Received type ' + typeof pathObject);
        return $655a6bdb16b925e8$var$_format("/", pathObject);
    },
    parse: function parse(path) {
        $655a6bdb16b925e8$var$assertPath(path);
        var ret = {
            root: "",
            dir: "",
            base: "",
            ext: "",
            name: ""
        };
        if (path.length === 0) return ret;
        var code = path.charCodeAt(0);
        var isAbsolute = code === 47 /*/*/ ;
        var start;
        if (isAbsolute) {
            ret.root = "/";
            start = 1;
        } else start = 0;
        var startDot = -1;
        var startPart = 0;
        var end = -1;
        var matchedSlash = true;
        var i = path.length - 1;
        // Track the state of characters (if any) we see before our first dot and
        // after any path separator we find
        var preDotState = 0;
        // Get non-dir info
        for(; i >= start; --i){
            code = path.charCodeAt(i);
            if (code === 47 /*/*/ ) {
                // If we reached a path separator that was not part of a set of path
                // separators at the end of the string, stop now
                if (!matchedSlash) {
                    startPart = i + 1;
                    break;
                }
                continue;
            }
            if (end === -1) {
                // We saw the first non-path separator, mark this as the end of our
                // extension
                matchedSlash = false;
                end = i + 1;
            }
            if (code === 46 /*.*/ ) {
                // If this is our first dot, mark it as the start of our extension
                if (startDot === -1) startDot = i;
                else if (preDotState !== 1) preDotState = 1;
            } else if (startDot !== -1) // We saw a non-dot and non-path separator before our dot, so we should
            // have a good chance at having a non-empty extension
            preDotState = -1;
        }
        if (startDot === -1 || end === -1 || // We saw a non-dot character immediately before the dot
        preDotState === 0 || // The (right-most) trimmed path component is exactly '..'
        preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) {
            if (end !== -1) {
                if (startPart === 0 && isAbsolute) ret.base = ret.name = path.slice(1, end);
                else ret.base = ret.name = path.slice(startPart, end);
            }
        } else {
            if (startPart === 0 && isAbsolute) {
                ret.name = path.slice(1, startDot);
                ret.base = path.slice(1, end);
            } else {
                ret.name = path.slice(startPart, startDot);
                ret.base = path.slice(startPart, end);
            }
            ret.ext = path.slice(startDot, end);
        }
        if (startPart > 0) ret.dir = path.slice(0, startPart - 1);
        else if (isAbsolute) ret.dir = "/";
        return ret;
    },
    sep: "/",
    delimiter: ":",
    win32: null,
    posix: null
};
$655a6bdb16b925e8$var$posix.posix = $655a6bdb16b925e8$var$posix;
module.exports = $655a6bdb16b925e8$var$posix;

});



parcelRegister("4Zgmd", function(module, exports) {

});

parcelRegister("c9WcJ", function(module, exports) {

});

parcelRegister("a1m73", function(module, exports) {

$parcel$export(module.exports, "OrderBy", function () { return $74bb2681c2353b32$export$5792beb64642ec7a; });

var $43jhg = parcelRequire("43jhg");
function $74bb2681c2353b32$export$5297a33ad542842a(type) {
    return (0, $43jhg.IsStringType)(type) || (0, $43jhg.IsNumberType)(type) || (0, $43jhg.IsBooleanType)(type);
}
function $74bb2681c2353b32$export$5792beb64642ec7a(input, selector, mode = "ascending") {
    return $74bb2681c2353b32$export$f05254b67a915186(input, [
        [
            selector,
            mode
        ]
    ]);
}
function $74bb2681c2353b32$export$f05254b67a915186(input, orderings) {
    const res = input.slice().sort((a, b)=>{
        for(let i = 0; i < orderings.length; i++){
            const [selector, mode] = orderings[i];
            let xa = selector(a);
            let xb = selector(b);
            // Be a little pragmatic
            if (xa === xb) continue;
            if (xa === undefined && typeof xb === "string") xa = "";
            if (xb === undefined && typeof xa === "string") xb = "";
            if (xa === undefined && typeof xb === "number") xa = 0;
            if (xb === undefined && typeof xa === "number") xb = 0;
            if (xa === undefined && typeof xb === "boolean") xa = false;
            if (xb === undefined && typeof xa === "boolean") xb = false;
            if (xa === null && typeof xb === "string") xa = "";
            if (xb === null && typeof xa === "string") xb = "";
            if (xa === null && typeof xb === "number") xa = 0;
            if (xb === null && typeof xa === "number") xb = 0;
            if (xa === null && typeof xb === "boolean") xa = false;
            if (xb === null && typeof xa === "boolean") xb = false;
            let comparison = 0;
            if (typeof xa === "string" && typeof xb === "string") comparison = xa.localeCompare(xb);
            else if (typeof xa === "number" && typeof xb === "number") comparison = xa - xb;
            else if (xa instanceof Date && xb instanceof Date) comparison = xa.getTime() - xb.getTime();
            else if (typeof xa === "boolean" && typeof xb === "boolean") comparison = (xa ? 1 : 0) - (xb ? 1 : 0);
            else if (typeof xa === "undefined" && typeof xb === "undefined") continue;
            else throw new Error("Unsupported sort: " + JSON.stringify(xa) + " :: " + JSON.stringify(xb));
            if (mode === "descending") comparison *= -1;
            if (comparison !== 0) return comparison;
        }
        return 0;
    });
    return res;
}

});

parcelRegister("3LK53", function(module, exports) {

$parcel$export(module.exports, "GetIconForTypedValue", function () { return $2be98180cf52f065$export$3bf4b675ef577259; });

var $cwhCA = parcelRequire("cwhCA");

var $43jhg = parcelRequire("43jhg");
function $2be98180cf52f065$export$c202da2393745d77(value, property) {
    var _a;
    const icon = (_a = property.tags) === null || _a === void 0 ? void 0 : _a.icon;
    if (icon) return icon;
    return $2be98180cf52f065$export$3bf4b675ef577259(value, property.type);
}
function $2be98180cf52f065$export$3bf4b675ef577259(value, type) {
    var _a, _b, _c, _d;
    const discriminatedType = (0, $cwhCA.SubstituteAndDiscriminate)(value, type);
    if (typeof discriminatedType === "object") {
        const icon = (_a = discriminatedType.tags) === null || _a === void 0 ? void 0 : _a.icon;
        if (icon) return icon;
    }
    if (typeof type === "object") {
        const icon = (_b = type.tags) === null || _b === void 0 ? void 0 : _b.icon;
        if (icon) return icon;
        if (type.reference) {
            const refIcon = (_d = (_c = (0, $cwhCA.GetReflectionInfo)()) === null || _c === void 0 ? void 0 : _c.collections.find((c)=>{
                var _a;
                return (0, $43jhg.GetTypeAlias)(c.type.typeArgs[0]) === ((_a = type.reference) === null || _a === void 0 ? void 0 : _a.typeName);
            })) === null || _d === void 0 ? void 0 : _d.icon;
            if (refIcon) return refIcon;
        }
    }
}

});


parcelRegister("hV5w0", function(module, exports) {

$parcel$export(module.exports, "WidgetContext", function () { return $d0bc09c0ad65b593$export$a0936c9989b92d74; });
$parcel$export(module.exports, "useWidgetState", function () { return $d0bc09c0ad65b593$export$b323c00015b1e5c6; });
$parcel$export(module.exports, "useQueryWidgetState", function () { return $d0bc09c0ad65b593$export$9dcbef1d878cbdab; });
$parcel$export(module.exports, "usePerformWidgetAction", function () { return $d0bc09c0ad65b593$export$d11f059ac44ffa64; });
$parcel$export(module.exports, "useExecuteClientEffects", function () { return $d0bc09c0ad65b593$export$39be389e71712c16; });

var $4vwom = parcelRequire("4vwom");

var $xQZCR = parcelRequire("xQZCR");

var $eeH7J = parcelRequire("eeH7J");

var $8vTN8 = parcelRequire("8vTN8");

var $ikBJm = parcelRequire("ikBJm");

var $4rY0U = parcelRequire("4rY0U");

var $9SFXB = parcelRequire("9SFXB");

var $bUDfc = parcelRequire("bUDfc");
parcelRequire("jniej");
var $eK8Q4 = parcelRequire("eK8Q4");
var $cWF8g = parcelRequire("cWF8g");
const $d0bc09c0ad65b593$export$a0936c9989b92d74 = /*#__PURE__*/ (0, $eeH7J.createContext)({
    state: {},
    setState: ()=>{
        throw new Error("No widget context");
    },
    refresh: ()=>{
        throw new Error("No widget context");
    },
    performAction: ()=>{
        throw new Error("No widget context");
    },
    root: null
});
function $d0bc09c0ad65b593$var$useWidgetContext() {
    return (0, $eeH7J.useContext)($d0bc09c0ad65b593$export$a0936c9989b92d74);
}
function $d0bc09c0ad65b593$export$af108391d0e7838c(key) {
    const { state: state, setState: setState } = $d0bc09c0ad65b593$var$useWidgetContext();
    if (!(key in state)) state[key] = {};
    const setWidgetContextState = (0, $eeH7J.useCallback)((value)=>{
        return setState(Object.assign(Object.assign({}, state), {
            [key]: value
        }));
    }, [
        setState,
        state,
        key
    ]);
    return [
        state[key],
        setWidgetContextState
    ];
}
function $d0bc09c0ad65b593$export$b323c00015b1e5c6(/**
 * The key (namespace) to store the widget state under.
 */ key, /**
 * The name of the particular state variable to retrieve, within the key namespace.
 */ name, defaultValue, /**
 * Whether the state should be stored globally, i.e. across all pages and widget contexts.
 * By default, the state is stored only within the current widget context.
 */ global = false) {
    // Dirty hack to allow global preferences to be used as widget state by
    // simply prefixing the widget key. This violates the react hooks rules, but
    // is necessary to allow global preferences to be used as widget state.
    const [pref, setPref] = global ? (0, $eK8Q4.usePreference)(`${key}::${name}`, defaultValue) : [
        undefined,
        undefined
    ];
    const [state, setState] = $d0bc09c0ad65b593$export$af108391d0e7838c(key);
    const setter = (0, $eeH7J.useCallback)(async (value)=>{
        if (setPref) setPref(value);
        if (value === defaultValue) {
            const newState = Object.assign({}, state);
            delete newState[name];
            await setState(newState);
        } else await setState(Object.assign(Object.assign({}, state), {
            [name]: value
        }));
    }, [
        setPref,
        defaultValue,
        state,
        name,
        setState
    ]);
    return [
        (pref !== undefined ? pref : state[name]) || defaultValue,
        setter
    ];
}
function $d0bc09c0ad65b593$export$9dcbef1d878cbdab(key, name, defaultValue, /**
 * Whether the caller is the page master widget. If true, the name of the
 * state will be used directly for a prettier URL. If false, the name will
 * be prefixed with the key to avoid conflicts with other widgets on the
 * same page.
 */ isPageMaster = false, disabled = false) {
    var _a;
    const [state, setState] = $d0bc09c0ad65b593$export$b323c00015b1e5c6(key, name, defaultValue);
    const [masterState, setMasterState] = (0, $eeH7J.useState)(state);
    const query = isPageMaster ? name : `${key}.${name}`;
    const [queryValue, setQueryValue] = // eslint-disable-next-line react-hooks/rules-of-hooks
    typeof defaultValue === "string" ? (0, $cWF8g.useQueryString)(query) : (0, $cWF8g.useQueryNumber)(query);
    (0, $eeH7J.useEffect)(()=>{
        if (disabled) return;
        // Query param absent → fall back to default
        if (queryValue === undefined && state !== defaultValue) {
            setMasterState(defaultValue);
            setState(defaultValue);
            return;
        }
        // Query param changed → propagate to widget state
        if (queryValue !== undefined && queryValue !== masterState) {
            setMasterState(queryValue);
            setState(queryValue);
        }
    }, [
        disabled,
        queryValue,
        defaultValue,
        masterState,
        state,
        setState
    ]);
    const setBoth = (0, $eeH7J.useCallback)((value)=>{
        if (!disabled) {
            if (value === defaultValue) setQueryValue(undefined, {
                replace: true
            });
            else setQueryValue(value, {
                replace: true
            });
        }
        setMasterState(value);
        setState(value);
    }, [
        defaultValue,
        setQueryValue,
        setState
    ]);
    return [
        (_a = disabled ? state : queryValue) !== null && _a !== void 0 ? _a : defaultValue,
        setBoth
    ];
}
function $d0bc09c0ad65b593$export$d11f059ac44ffa64() {
    return $d0bc09c0ad65b593$var$useWidgetContext().performAction;
}
function $d0bc09c0ad65b593$export$39be389e71712c16() {
    const navigate = (0, $8vTN8.useNavigate)();
    const { modal: modal, showModal: showModal } = (0, $ikBJm.useContextualModal)();
    return {
        modal: modal,
        showModal: showModal,
        executeClientEffects: (0, $eeH7J.useCallback)((effects)=>{
            var _a;
            for (const effect of effects)switch(effect.type){
                case "Navigate":
                    navigate(effect.to.valueOf());
                    break;
                case "NavigateOpen":
                    window.open(effect.to.valueOf(), "");
                    break;
                case "SaveFile":
                    {
                        let data;
                        if (effect.contentType === "application/pdf") {
                            if (typeof effect.fileContent !== "string") throw new Error("PDF content must be a data URI string");
                            data = $d0bc09c0ad65b593$var$mapUriToUIntArray(effect.fileContent); // returns Uint8Array
                        } else if (typeof effect.fileContent === "string") data = effect.fileContent; // text or binary-safe string
                        else {
                            const bin = atob(effect.fileContent.base64);
                            const arr = new Uint8Array(bin.length);
                            for(let i = 0; i < bin.length; i++)arr[i] = bin.charCodeAt(i);
                            data = arr;
                        }
                        const part = typeof data === "string" ? data : data.buffer instanceof ArrayBuffer ? data.buffer : data.slice().buffer;
                        (0, $xQZCR.saveAs)(new Blob([
                            part
                        ], {
                            type: (_a = effect.contentType) !== null && _a !== void 0 ? _a : "text/plain;charset=utf-8"
                        }), effect.fileName);
                    }
                    break;
                case "MessageBox":
                    alert(effect.message);
                    break;
                case "CopyToClipboard":
                    navigator.clipboard.writeText(effect.text).catch((err)=>{
                        alert("Failed to copy text to clipboard:");
                    });
                    break;
                case "OpenModal":
                    showModal(()=>(0, $4vwom.jsx)($d0bc09c0ad65b593$var$WidgetKeyView, {
                            widgetKey: effect.widgetKey
                        }));
                    break;
                case "CloseModal":
                    (0, $ikBJm.closeContextualModal)();
                    break;
                default:
                    alert("Unimplemented client effect: " + JSON.stringify(effect));
                    break;
            }
        }, [
            navigate,
            showModal
        ])
    };
}
function $d0bc09c0ad65b593$var$WidgetKeyView(props) {
    const { root: root } = $d0bc09c0ad65b593$var$useWidgetContext();
    const widget = (0, $9SFXB.FindWidgetByKey)(root, props.widgetKey);
    if (!widget) return (0, $4vwom.jsxs)("div", {
        children: [
            "Widget not found: ",
            props.widgetKey
        ]
    });
    if (!(0, $bUDfc.IsModal)(widget)) return (0, $4vwom.jsxs)("div", {
        children: [
            "Widget is not modal: ",
            props.widgetKey
        ]
    });
    return (0, $4vwom.jsx)((0, $4rY0U.WidgetView), {
        value: widget.widget
    });
}
function $d0bc09c0ad65b593$var$mapUriToUIntArray(uri) {
    const base64String = uri.split(",")[1];
    const binaryString = atob(base64String);
    return Uint8Array.from([
        ...binaryString
    ].map((char)=>char.charCodeAt(0)));
}

});
parcelRegister("xQZCR", function(module, exports) {
(function(a, b) {
    if ("function" == typeof define && define.amd) define([], b);
    else b();
})(module.exports, function() {
    "use strict";
    function b(a, b) {
        return "undefined" == typeof b ? b = {
            autoBom: !1
        } : "object" != typeof b && (console.warn("Deprecated: Expected third argument to be a object"), b = {
            autoBom: !b
        }), b.autoBom && /^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(a.type) ? new Blob([
            "\uFEFF",
            a
        ], {
            type: a.type
        }) : a;
    }
    function c(a, b, c) {
        var d = new XMLHttpRequest;
        d.open("GET", a), d.responseType = "blob", d.onload = function() {
            g(d.response, b, c);
        }, d.onerror = function() {
            console.error("could not download file");
        }, d.send();
    }
    function d(a) {
        var b = new XMLHttpRequest;
        b.open("HEAD", a, !1);
        try {
            b.send();
        } catch (a) {}
        return 200 <= b.status && 299 >= b.status;
    }
    function e(a) {
        try {
            a.dispatchEvent(new MouseEvent("click"));
        } catch (c) {
            var b = document.createEvent("MouseEvents");
            b.initMouseEvent("click", !0, !0, window, 0, 0, 0, 80, 20, !1, !1, !1, !1, 0, null), a.dispatchEvent(b);
        }
    }
    var f = "object" == typeof window && window.window === window ? window : "object" == typeof self && self.self === self ? self : "object" == typeof $parcel$global && $parcel$global.global === $parcel$global ? $parcel$global : void 0, a = f.navigator && /Macintosh/.test(navigator.userAgent) && /AppleWebKit/.test(navigator.userAgent) && !/Safari/.test(navigator.userAgent), g = f.saveAs || ("object" != typeof window || window !== f ? function() {} : "download" in HTMLAnchorElement.prototype && !a ? function(b, g, h) {
        var i = f.URL || f.webkitURL, j = document.createElement("a");
        g = g || b.name || "download", j.download = g, j.rel = "noopener", "string" == typeof b ? (j.href = b, j.origin === location.origin ? e(j) : d(j.href) ? c(b, g, h) : e(j, j.target = "_blank")) : (j.href = i.createObjectURL(b), setTimeout(function() {
            i.revokeObjectURL(j.href);
        }, 4E4), setTimeout(function() {
            e(j);
        }, 0));
    } : "msSaveOrOpenBlob" in navigator ? function(f, g, h) {
        if (g = g || f.name || "download", "string" != typeof f) navigator.msSaveOrOpenBlob(b(f, h), g);
        else if (d(f)) c(f, g, h);
        else {
            var i = document.createElement("a");
            i.href = f, i.target = "_blank", setTimeout(function() {
                e(i);
            });
        }
    } : function(b, d, e, g) {
        if (g = g || open("", "_blank"), g && (g.document.title = g.document.body.innerText = "downloading..."), "string" == typeof b) return c(b, d, e);
        var h = "application/octet-stream" === b.type, i = /constructor/i.test(f.HTMLElement) || f.safari, j = /CriOS\/[\d]+/.test(navigator.userAgent);
        if ((j || h && i || a) && "undefined" != typeof FileReader) {
            var k = new FileReader;
            k.onloadend = function() {
                var a = k.result;
                a = j ? a : a.replace(/^data:[^;]*;/, "data:attachment/file;"), g ? g.location.href = a : location = a, g = null;
            }, k.readAsDataURL(b);
        } else {
            var l = f.URL || f.webkitURL, m = l.createObjectURL(b);
            g ? g.location = m : location.href = m, g = null, setTimeout(function() {
                l.revokeObjectURL(m);
            }, 4E4);
        }
    });
    f.saveAs = g.saveAs = g, module.exports = g;
});

});

parcelRegister("8vTN8", function(module, exports) {

$parcel$export(module.exports, "useNavigate", function () { return $632c7f077da66289$export$9770f232ac06a008; });
parcelRequire("5K1mb");
var $18Pjr = parcelRequire("18Pjr");

var $cSf8f = parcelRequire("cSf8f");
function $632c7f077da66289$export$9770f232ac06a008() {
    const routerNavigate = (0, $18Pjr.useNavigate)();
    return function(to, options) {
        if ($632c7f077da66289$export$9770f232ac06a008.unsavedChanges.size > 0) {
            if (!confirm((0, $cSf8f.ClientSideLocalize)({
                en: "You have unsaved changes, that will stay as draft but not be applied if you leave. Are you sure you want to leave?",
                no: "Du har endringer som ikke er lagret, men som forblir som utkast hvis du forlater siden. Er du sikker p\xe5 at du vil forlate siden?",
                sv: "Du har \xe4ndringar som inte \xe4r sparade, men som f\xf6rblir som utkast om du l\xe4mnar sidan. \xc4r du s\xe4ker p\xe5 att du vill l\xe4mna sidan?",
                da: "Du har \xe6ndringer, der ikke er gemt, men som forbliver som kladde, hvis du forlader siden. Er du sikker p\xe5, at du vil forlade siden?"
            }))) return;
        }
        // Call the right overload for "number"
        if (typeof to === "number") routerNavigate(to);
        else routerNavigate(to, options);
    };
}
/**
 * A set of things that contain unsaved changes, that should be checked before
 * navigating away from the page. If this set is non-empty, the user will be
 * prompted to confirm navigation.
 */ $632c7f077da66289$export$9770f232ac06a008.unsavedChanges = new Set();

});
parcelRegister("cSf8f", function(module, exports) {

$parcel$export(module.exports, "Strings", function () { return $95f644123f72f456$export$b261e9de8f5b6a97; });
$parcel$export(module.exports, "Dictionary", function () { return $95f644123f72f456$export$4ee70ab773570fb9; });
$parcel$export(module.exports, "Translations", function () { return $95f644123f72f456$export$1f12680e68c5100d; });
$parcel$export(module.exports, "ClientSideLocalize", function () { return $95f644123f72f456$export$13fb7ba1b775ff6b; });

var $34lt5 = parcelRequire("34lt5");

var $geOdl = parcelRequire("geOdl");
parcelRequire("2LTO8");
var $8h5s0 = parcelRequire("8h5s0");
const $95f644123f72f456$export$b261e9de8f5b6a97 = $95f644123f72f456$export$4ee70ab773570fb9({
    Edit: {
        no: "Rediger",
        sv: "Redigera"
    },
    "Done editing": {
        no: "Ferdig med redigering",
        sv: "Klar med redigering"
    },
    Show: {
        no: "Vis",
        sv: "Visa"
    },
    Hide: {
        no: "Skjul",
        sv: "D\xf6lj"
    },
    More: {
        no: "Mer",
        sv: "Mer"
    },
    Less: {
        no: "Mindre",
        sv: "Mindre"
    },
    Previous: {
        no: "Forrige",
        sv: "F\xf6reg\xe5ende"
    },
    Next: {
        no: "Neste",
        sv: "N\xe4sta"
    },
    Search: {
        no: "S\xf8k",
        sv: "S\xf6k"
    },
    matching: {
        no: "matcher",
        sv: "matchar"
    },
    "Order by": {
        no: "Sorter etter",
        sv: "Sortera efter"
    },
    ascending: {
        no: "stigende",
        sv: "stigande"
    },
    descending: {
        no: "synkende",
        sv: "synkande"
    },
    Ascending: {
        no: "Stigende",
        sv: "Stigande"
    },
    Descending: {
        no: "Synkende",
        sv: "Synkande"
    },
    "per page": {
        no: "per side",
        sv: "per sida"
    },
    "Last modified date": {
        no: "Sist endret",
        sv: "Senast \xe4ndrad"
    },
    "Created date": {
        no: "Opprettet",
        sv: "Skapad"
    },
    Download: {
        no: "Last ned",
        sv: "Ladda ner"
    },
    "Download as .JSON file": {
        no: "Last ned som .JSON-fil",
        sv: "Ladda ner som .JSON-fil"
    },
    "Download as .CSV file": {
        no: "Last ned som .CSV-fil",
        sv: "Ladda ner som .CSV-fil"
    },
    "Download as Excel (.xlsx) file": {
        no: "Last ned som Excel (.xlsx)-fil",
        sv: "Ladda ner som Excel (.xlsx)-fil",
        da: "Hent som Excel (.xlsx)-fil"
    },
    "Please enter a search string...": {
        no: "Skriv inn s\xf8kestreng...",
        sv: "Skriv in s\xf6kstr\xe4ng..."
    },
    "Please specify": {
        no: "Vennligst spesifiser",
        sv: "V\xe4nligen specificera"
    },
    Replace: {
        no: "Erstatt",
        sv: "Ers\xe4tt"
    },
    Cancel: {
        no: "Avbryt",
        sv: "Avbryt"
    },
    Delete: {
        no: "Slett",
        sv: "Ta bort"
    },
    Duplicate: {
        no: "Dupliser",
        sv: "Duplicera"
    },
    Export: {
        no: "Eksporter",
        sv: "Exportera"
    },
    "Are you sure you want to continue?": {
        no: "Er du sikker p\xe5 at du vil fortsette?",
        sv: "\xc4r du s\xe4ker p\xe5 att du vill forts\xe4tta?"
    },
    "Ignore and continue": {
        no: "Ignorer og fortsett",
        sv: "Ignorera och forts\xe4tt"
    }
});
const $95f644123f72f456$export$1f12680e68c5100d = {
    Open () {
        switch((0, $geOdl.getStudioLocale)()){
            case "no":
                return "\xc5pne";
            case "sv":
                return "\xd6ppna";
            default:
                return "Open";
        }
    },
    DeleteThis (x) {
        switch((0, $geOdl.getStudioLocale)()){
            case "no":
                switch(x["no:genus"]){
                    case "neuter":
                        return `Slett dette ${(0, $8h5s0.lowercaseFirstLetter)($95f644123f72f456$export$13fb7ba1b775ff6b(x))}et`;
                    default:
                        return `Slett denne ${(0, $8h5s0.lowercaseFirstLetter)($95f644123f72f456$export$13fb7ba1b775ff6b(x))}en`;
                }
            case "sv":
                switch(x["sv:genus"]){
                    case "neuter":
                        return `Radera detta ${(0, $8h5s0.lowercaseFirstLetter)($95f644123f72f456$export$13fb7ba1b775ff6b(x))}`;
                    default:
                        return `Radera denna ${(0, $8h5s0.lowercaseFirstLetter)($95f644123f72f456$export$13fb7ba1b775ff6b(x))}`;
                }
            default:
                return `Delete this ${(0, $8h5s0.lowercaseFirstLetter)($95f644123f72f456$export$13fb7ba1b775ff6b(x))}`;
        }
    },
    SelectX (x) {
        const lx = (0, $8h5s0.lowercaseFirstLetter)($95f644123f72f456$export$13fb7ba1b775ff6b(x));
        switch((0, $geOdl.getStudioLocale)()){
            case "no":
                switch(x["no:genus"]){
                    case "neuter":
                        return `Velg et ${lx}`;
                    default:
                        return `Velg en ${lx}`;
                }
            case "sv":
                switch(x["sv:genus"]){
                    case "neuter":
                        return `V\xe4lj et ${lx}`;
                    default:
                        return `V\xe4lj en ${lx}`;
                }
            default:
                return `Select a ${lx}`;
        }
    },
    SelectXToRepalceY (x, y) {
        const lx = (0, $8h5s0.lowercaseFirstLetter)($95f644123f72f456$export$13fb7ba1b775ff6b(x));
        switch((0, $geOdl.getStudioLocale)()){
            case "no":
                switch(x["no:genus"]){
                    case "neuter":
                        return `Velg et ${lx} for \xe5 erstatte ${y}`;
                    default:
                        return `Velg en ${lx} for \xe5 erstatte ${y}`;
                }
            case "sv":
                switch(x["sv:genus"]){
                    case "neuter":
                        return `V\xe4lj ett ${lx} f\xf6r att ers\xe4tta ${y}`;
                    default:
                        return `V\xe4lj en ${lx} f\xf6r att ers\xe4tta ${y}`;
                }
            default:
                return `Please specify a ${lx} to replace ${y}`;
        }
    },
    DragAndDropAFileHereToInsert () {
        switch((0, $geOdl.getStudioLocale)()){
            case "no":
                return "Dra og slipp en fil her for \xe5 sette inn";
            case "sv":
                return "Dra och sl\xe4pp en fil h\xe4r f\xf6r att s\xe4tta in";
            default:
                return "Drag and drop a file here to insert";
        }
    },
    LockedField () {
        switch((0, $geOdl.getStudioLocale)()){
            case "no":
                return "L\xe5st felt";
            case "sv":
                return "L\xe5st f\xe4lt";
            default:
                return "Locked field";
        }
    },
    Add () {
        switch((0, $geOdl.getStudioLocale)()){
            case "no":
                return "Legg til";
            case "sv":
                return "L\xe4gg till";
            default:
                return "Add";
        }
    },
    Change () {
        switch((0, $geOdl.getStudioLocale)()){
            case "no":
                return "Endre";
            case "sv":
                return "\xc4ndra";
            default:
                return "Change";
        }
    },
    Specify () {
        switch((0, $geOdl.getStudioLocale)()){
            case "no":
                return "Velg";
            case "sv":
                return "V\xe4lj";
            default:
                return "Choose";
        }
    },
    Incomplete () {
        switch((0, $geOdl.getStudioLocale)()){
            case "no":
                return "Mangler utfylling";
            case "sv":
                return "Saknar ifyllnad";
            default:
                return "Incomplete";
        }
    },
    New (noun, locale = (0, $geOdl.getStudioLocale)()) {
        switch(locale){
            case "no":
                switch(noun["no:genus"]){
                    case "neuter":
                        return "Nytt";
                    default:
                        return "Ny";
                }
            case "sv":
                switch(noun["sv:genus"]){
                    case "neuter":
                        return "Nytt";
                    default:
                        return "Ny";
                }
            default:
                return "New";
        }
    },
    Create (noun, locale = (0, $geOdl.getStudioLocale)()) {
        switch(locale){
            case "no":
                return "Opprett";
            case "sv":
                return "Skapa";
            case "en":
                return "Create";
        }
    },
    Blank (noun) {
        switch((0, $geOdl.getStudioLocale)()){
            case "no":
                switch(noun["no:genus"]){
                    case "neuter":
                        return "Tomt";
                    default:
                        return "Tom";
                }
            case "sv":
                switch(noun["sv:genus"]){
                    case "neuter":
                        return "Blankt";
                    default:
                        return "Blank";
                }
            case "da":
                switch(noun["da:genus"]){
                    case "neuter":
                        return "Blankt";
                    default:
                        return "Blank";
                }
        }
        return "Blank";
    },
    ReplaceOnlyThisReference () {
        switch((0, $geOdl.getStudioLocale)()){
            case "no":
                return "Erstatt bare denne referansen";
            case "sv":
                return "Ers\xe4tt bara denna referens";
            default:
                return "Replace only this reference";
        }
    },
    ReplaceAllReferencesInDocument (old) {
        switch((0, $geOdl.getStudioLocale)()){
            case "no":
                return `Erstatt alle referanser til ${old} i dokumentet`;
            case "sv":
                return `Ers\xe4tt alla referenser till ${old} i dokumentet`;
            default:
                return `Replace all references to ${old} in document`;
        }
    },
    ReplacedXReferences (count) {
        switch((0, $geOdl.getStudioLocale)()){
            case "no":
                return `Erstattet ${count} referanser`;
            case "sv":
                return `Ersatte ${count} referenser`;
            default:
                return `Replaced ${count} references`;
        }
    },
    NoItemMatchesTheSearch (noun) {
        switch((0, $geOdl.getStudioLocale)()){
            case "no":
                return `Ingen ${noun} matcher s\xf8ket`;
            case "sv":
                return `Ingen ${noun} matchar s\xf6ket`;
            case "en":
                return `No ${noun} matches the search`;
        }
    },
    NoItems (noun) {
        switch((0, $geOdl.getStudioLocale)()){
            case "no":
                return `Ingen ${noun}e${noun.endsWith("r") ? "" : "r"}`;
            case "sv":
                return `Ingen ${noun}ar`;
            case "en":
                return `No ${noun}s`;
        }
    },
    ShowingXtoYofZ (x, y, z) {
        switch((0, $geOdl.getStudioLocale)()){
            case "no":
                return `Viser ${x} ${y !== undefined ? "- " + y : ""} av ${z}`;
            case "sv":
                return `Visar ${x} ${y !== undefined ? "- " + y : ""} av ${z}`;
            default:
                return `Showing ${x} ${y !== undefined ? "- " + y : ""} of ${z}`;
        }
    },
    AreYouSureYouWantToDeleteThis (noun) {
        switch((0, $geOdl.getStudioLocale)()){
            case "no":
                switch(noun["no:genus"]){
                    case "neuter":
                        return `Er du sikker p\xe5 at du vil slette dette ${(0, $8h5s0.lowercaseFirstLetter)($95f644123f72f456$export$13fb7ba1b775ff6b(noun))}et?`;
                    default:
                        return `Er du sikker p\xe5 at du vil slette denne ${(0, $8h5s0.lowercaseFirstLetter)($95f644123f72f456$export$13fb7ba1b775ff6b(noun))}en?`;
                }
            case "sv":
                switch(noun["sv:genus"]){
                    case "neuter":
                        return `\xc4r du s\xe4ker p\xe5 att du vill ta bort detta ${(0, $8h5s0.lowercaseFirstLetter)($95f644123f72f456$export$13fb7ba1b775ff6b(noun))}?`;
                    default:
                        return `\xc4r du s\xe4ker p\xe5 att du vill ta bort denna ${(0, $8h5s0.lowercaseFirstLetter)($95f644123f72f456$export$13fb7ba1b775ff6b(noun))}?`;
                }
            default:
                return `Are you sure you want to delete this ${(0, $8h5s0.lowercaseFirstLetter)($95f644123f72f456$export$13fb7ba1b775ff6b(noun))}?`;
        }
    },
    AreYouSureYouWantToDeleteThisHistoryWillBeKept (noun) {
        switch((0, $geOdl.getStudioLocale)()){
            case "no":
                switch(noun["no:genus"]){
                    case "neuter":
                        return `Er du sikker p\xe5 at du vil slette dette ${$95f644123f72f456$export$13fb7ba1b775ff6b(noun)}et, men beholde historikken? Dersom dokumentet inneholder persondata, b\xf8r du heller slette dokumentet permanent.`;
                    default:
                        return `Er du sikker p\xe5 at du vil slette denne ${$95f644123f72f456$export$13fb7ba1b775ff6b(noun)}en? Dersom dokumentet inneholder persondata, b\xf8r du heller slette dokumentet permanent.`;
                }
            case "sv":
                switch(noun["sv:genus"]){
                    case "neuter":
                        return `\xc4r du s\xe4ker p\xe5 att du vill ta bort detta ${$95f644123f72f456$export$13fb7ba1b775ff6b(noun)}et, men beh\xe5lla historiken? Om dokumentet inneh\xe5ller personuppgifter b\xf6r du ist\xe4llet radera dokumentet permanent.`;
                    default:
                        return `\xc4r du s\xe4ker p\xe5 att du vill ta bort denna ${$95f644123f72f456$export$13fb7ba1b775ff6b(noun)}? Om dokumentet inneh\xe5ller personuppgifter b\xf6r du ist\xe4llet radera dokumentet permanent.`;
                }
            default:
                return `Are you sure you want to delete this ${$95f644123f72f456$export$13fb7ba1b775ff6b(noun)}, but keep its event history? If the document contains personal data, you should permanently delete the document instead.`;
        }
    },
    CanNotDeleteThis (noun) {
        switch((0, $geOdl.getStudioLocale)()){
            case "no":
                switch(noun["no:genus"]){
                    case "neuter":
                        return `Kan ikke slette dette ${$95f644123f72f456$export$13fb7ba1b775ff6b(noun)}et`;
                    default:
                        return `Kan ikke slette denne ${$95f644123f72f456$export$13fb7ba1b775ff6b(noun)}en`;
                }
            case "sv":
                switch(noun["sv:genus"]){
                    case "neuter":
                        return `Kan inte ta bort detta ${$95f644123f72f456$export$13fb7ba1b775ff6b(noun)}`;
                    default:
                        return `Kan inte ta bort denna ${$95f644123f72f456$export$13fb7ba1b775ff6b(noun)}`;
                }
            default:
                return `Can not delete this ${$95f644123f72f456$export$13fb7ba1b775ff6b(noun)}`;
        }
    },
    ShowAll () {
        switch((0, $geOdl.getStudioLocale)()){
            case "no":
                return "Vis alle";
            case "sv":
                return "Visa alla";
            default:
                return "Show all";
        }
    },
    Save () {
        switch((0, $geOdl.getStudioLocale)()){
            case "no":
                return "Lagre";
            case "sv":
                return "Spara";
            default:
                return "Save";
        }
    },
    Saved () {
        switch((0, $geOdl.getStudioLocale)()){
            case "no":
                return "Lagret";
            case "sv":
                return "Sparad";
            default:
                return "Saved";
        }
    },
    SaveAsTemplate () {
        switch((0, $geOdl.getStudioLocale)()){
            case "no":
                return "Lagre som mal";
            case "sv":
                return "Spara som mall";
            default:
                return "Save as template";
        }
    },
    Discard () {
        switch((0, $geOdl.getStudioLocale)()){
            case "no":
                return "Forkast";
            case "sv":
                return "Sl\xe4ng";
            default:
                return "Discard";
        }
    },
    SaveChanges () {
        switch((0, $geOdl.getStudioLocale)()){
            case "no":
                return "Lagre endringer";
            case "sv":
                return "Spara \xe4ndringar";
            default:
                return "Save changes";
        }
    },
    DiscardChanges () {
        switch((0, $geOdl.getStudioLocale)()){
            case "no":
                return "Forkast endringer";
            case "sv":
                return "Sl\xe4ng \xe4ndringar";
            default:
                return "Discard changes";
        }
    }
};
function $95f644123f72f456$export$4ee70ab773570fb9(strings) {
    const res = {};
    for(const key in strings){
        const value = strings[key];
        Object.defineProperty(res, key, {
            get () {
                var _a;
                return (_a = value[(0, $geOdl.getStudioLocale)()]) !== null && _a !== void 0 ? _a : key;
            }
        });
    }
    return res;
}
/** The available locales for client-side localization. */ $95f644123f72f456$export$4ee70ab773570fb9.locales = [
    {
        flag: "\uD83C\uDDEC\uD83C\uDDE7",
        key: (0, $34lt5.LocaleKey).en,
        displayName: {
            en: "English",
            no: "Engelsk",
            sv: "Engelska"
        }
    },
    {
        flag: "\uD83C\uDDF3\uD83C\uDDF4",
        key: (0, $34lt5.LocaleKey).no,
        displayName: {
            en: "Norwegian",
            no: "Norsk",
            sv: "Norska"
        }
    },
    {
        flag: "\uD83C\uDDF8\uD83C\uDDEA",
        key: (0, $34lt5.LocaleKey).sv,
        displayName: {
            en: "Swedish",
            no: "Svensk",
            sv: "Svenska"
        }
    }
];
$95f644123f72f456$export$4ee70ab773570fb9.chooseLocale = function(value, locale) {
    locale !== null && locale !== void 0 ? locale : locale = (0, $34lt5.LocaleKey)((0, $geOdl.getStudioLocale)());
    if (value === undefined) return undefined;
    if (value[locale]) return locale;
    if (value.en) return (0, $34lt5.LocaleKey).en;
};
function $95f644123f72f456$export$13fb7ba1b775ff6b(value, locale) {
    if (value === undefined) return undefined;
    locale = $95f644123f72f456$export$4ee70ab773570fb9.chooseLocale(value, locale);
    if (locale) return value[locale.valueOf()];
    const keys = Object.keys(value)// Filter grammar metadata
    .filter((x)=>!x.includes(":"));
    return value[keys[0]];
}

});
parcelRegister("geOdl", function(module, exports) {

$parcel$export(module.exports, "useStudioLocale", function () { return $bd24e7a9948bbd6e$export$227065a72e40df58; });
$parcel$export(module.exports, "StudioLocalePicker", function () { return $bd24e7a9948bbd6e$export$443f1cd30410b21b; });
$parcel$export(module.exports, "getStudioLocale", function () { return $bd24e7a9948bbd6e$export$76f11bb6b2cff4b3; });

var $4vwom = parcelRequire("4vwom");

var $eeH7J = parcelRequire("eeH7J");

var $lDBHC = parcelRequire("lDBHC");

var $dUDPg = parcelRequire("dUDPg");

var $34lt5 = parcelRequire("34lt5");

var $cSf8f = parcelRequire("cSf8f");

var $ebjYm = parcelRequire("ebjYm");

var $9Q5xE = parcelRequire("9Q5xE");
const $bd24e7a9948bbd6e$var$defaultLocale = (0, $34lt5.LocaleKey).en;
let $bd24e7a9948bbd6e$var$currentLocale = "default";
const $bd24e7a9948bbd6e$var$listeners = [];
if (!(0, $lDBHC.IsNode)()) // setTimeout to avoid touching `default` before it's initialized
setTimeout(()=>{
    const setting = window.localStorage.getItem("studio-locale");
    if (setting !== null) $bd24e7a9948bbd6e$export$14d924aea281b5a0((0, $34lt5.LocaleKey)(setting));
    else $bd24e7a9948bbd6e$export$14d924aea281b5a0($bd24e7a9948bbd6e$var$defaultLocale);
}, 0);
function $bd24e7a9948bbd6e$export$227065a72e40df58(/** Called when the locale changes. Since locale is passed as header, not an
 * explicit request parameter, some resources may require manual
 * invalidation to refresh correctly. */ callback) {
    const [locale, setLocale] = (0, $eeH7J.useState)($bd24e7a9948bbd6e$var$currentLocale);
    (0, $eeH7J.useEffect)(()=>{
        $bd24e7a9948bbd6e$var$listeners.push((newLocale)=>{
            setLocale(newLocale);
            if (callback) callback(newLocale);
        });
        return ()=>{
            const i = $bd24e7a9948bbd6e$var$listeners.indexOf(setLocale);
            if (i >= 0) $bd24e7a9948bbd6e$var$listeners.splice(i, 1);
        };
    }, []);
    if (locale === "default") return $bd24e7a9948bbd6e$var$defaultLocale;
    return locale;
}
function $bd24e7a9948bbd6e$export$14d924aea281b5a0(locale) {
    if (!(0, $lDBHC.IsNode)()) {
        window.localStorage.setItem("studio-locale", locale.valueOf());
        $bd24e7a9948bbd6e$var$currentLocale = locale;
        (0, $dUDPg.defaults).headers["Accept-Language"] = locale.valueOf();
    }
    for (const listener of $bd24e7a9948bbd6e$var$listeners)listener(locale);
}
function $bd24e7a9948bbd6e$export$443f1cd30410b21b() {
    const locale = $bd24e7a9948bbd6e$export$227065a72e40df58();
    return (0, $4vwom.jsxs)("div", {
        style: {
            display: "flex",
            flexDirection: "row",
            margin: 16,
            alignItems: "center",
            backgroundColor: (0, $9Q5xE.ColorStyles).gray[50],
            borderRadius: 8,
            padding: 8,
            paddingTop: 4,
            paddingBottom: 4
        },
        children: [
            (0, $4vwom.jsx)("div", {
                style: {
                    marginRight: 16
                },
                children: (0, $cSf8f.ClientSideLocalize)({
                    en: "Studio locale",
                    no: "Studio-spr\xe5k",
                    sv: "Studio-spr\xe5k",
                    da: "Studio-sprog"
                })
            }),
            (0, $4vwom.jsx)((0, $ebjYm.LocalePicker), {
                locale: locale,
                setLocale: $bd24e7a9948bbd6e$export$14d924aea281b5a0,
                locales: (0, $cSf8f.Dictionary).locales,
                ignoreDefault: true
            })
        ]
    });
}
function $bd24e7a9948bbd6e$export$76f11bb6b2cff4b3() {
    return $bd24e7a9948bbd6e$export$8eee6780d5b65d02().valueOf();
}
function $bd24e7a9948bbd6e$export$8eee6780d5b65d02() {
    if ($bd24e7a9948bbd6e$var$currentLocale === "default") return $bd24e7a9948bbd6e$var$defaultLocale;
    else return $bd24e7a9948bbd6e$var$currentLocale;
}

});
parcelRegister("ebjYm", function(module, exports) {

$parcel$export(module.exports, "LocalizedView", function () { return $a53195ed5a927706$export$2a0861ffaf8b54d0; });
$parcel$export(module.exports, "LocalePicker", function () { return $a53195ed5a927706$export$3170d3214a55335c; });
$parcel$export(module.exports, "CurrentLocalePicker", function () { return $a53195ed5a927706$export$1c525333428011dc; });

var $4vwom = parcelRequire("4vwom");

var $eeH7J = parcelRequire("eeH7J");

var $fT6Pt = parcelRequire("fT6Pt");

var $hRViu = parcelRequire("hRViu");

var $6cx8r = parcelRequire("6cx8r");

var $eBaY3 = parcelRequire("eBaY3");

var $8h5s0 = parcelRequire("8h5s0");

var $5c9Ym = parcelRequire("5c9Ym");

var $geOdl = parcelRequire("geOdl");

var $aIeEI = parcelRequire("aIeEI");

var $gssTr = parcelRequire("gssTr");

var $cSf8f = parcelRequire("cSf8f");

var $7FrRx = parcelRequire("7FrRx");

var $9HOw2 = parcelRequire("9HOw2");

var $1aVVn = parcelRequire("1aVVn");

var $dOFTp = parcelRequire("dOFTp");
/** A client-side version of Localize() based on an Y.js localized value. */ function $a53195ed5a927706$var$ClientSideLocalizeY(value, locale) {
    if (value === undefined) return undefined;
    locale = (0, $cSf8f.Dictionary).chooseLocale(value.toJSON(), locale);
    if (locale) return value.get(locale.valueOf());
    const keys = Array.from(value.keys())// Filter grammar metadata
    .filter((x)=>!x.includes(":"));
    return value.get(keys[0]);
}
function $a53195ed5a927706$export$2a0861ffaf8b54d0({ obj: obj, label: label, property: property, buttons: buttons, isEmbedded: isEmbedded, mode: mode }) {
    const type = property.type;
    const name = property.name;
    if (!(typeof type === "object" && "typeArgs" in type)) throw new Error();
    const valueType = (0, $8h5s0.Assert)(type.typeArgs)[0];
    const [locale, setLocale] = (0, $eeH7J.useState)(undefined);
    const dictionary = (0, $1aVVn.YTools).get(obj, name);
    const isReadonly = (0, $eBaY3.useIsReadonlyField)(property);
    const placeholder = dictionary && typeof dictionary === "object" && !("locale" in dictionary) ? $a53195ed5a927706$var$ClientSideLocalizeY(dictionary, locale) : undefined;
    const chosenLocale = (0, $cSf8f.Dictionary).chooseLocale(dictionary === null || dictionary === void 0 ? void 0 : dictionary.toJSON(), locale);
    (0, $dOFTp.useObserveYProxy)(dictionary, true);
    return (0, $4vwom.jsx)("div", {
        children: (0, $4vwom.jsx)((0, $hRViu.PropRow), {
            isReadonly: isReadonly,
            buttons: buttons,
            isEmbedded: isEmbedded,
            description: property.description,
            badge: (0, $4vwom.jsxs)("div", {
                style: {
                    display: "flex",
                    alignItems: "center"
                },
                children: [
                    (0, $4vwom.jsx)($a53195ed5a927706$export$3170d3214a55335c, {
                        currentFallback: chosenLocale !== locale ? chosenLocale : undefined,
                        locale: locale,
                        setLocale: setLocale,
                        hasLocales: dictionary ? Array.from(dictionary.keys()) : []
                    }),
                    (0, $4vwom.jsx)((0, $9HOw2.DiagnosticView), {
                        property: property,
                        value: dictionary
                    })
                ]
            }),
            label: label !== null && label !== void 0 ? label : (0, $8h5s0.prettyCamel)(name.toString()),
            children: (0, $4vwom.jsx)("div", {
                style: {
                    display: "flex",
                    flexDirection: "row",
                    width: "100%"
                },
                children: (0, $4vwom.jsx)("div", {
                    style: {
                        flex: 1
                    },
                    children: locale && (dictionary ? (0, $4vwom.jsx)((0, $6cx8r.PropView), {
                        obj: dictionary,
                        property: {
                            name: locale.toString(),
                            type: valueType,
                            isReadonly: property.isReadonly,
                            optional: true,
                            // Inherit tags such as @multiline from parent
                            tags: property.tags,
                            placeholder: placeholder
                        },
                        bubbleButtons: (b)=>buttons.push(...b),
                        mode: mode,
                        buttons: [],
                        isEmbedded: true
                    }, locale.toString()) : (0, $4vwom.jsx)((0, $fT6Pt.RButton), {
                        variant: "secondary",
                        onClick: ()=>{
                            (0, $1aVVn.YTools).set(obj, name, (0, $1aVVn.YTools).valueToYValue({
                                [locale.valueOf()]: (0, $5c9Ym.CreateDefault)(valueType, (0, $5c9Ym.UninitializedDefaults))
                            }));
                        },
                        children: (0, $cSf8f.Translations).Add()
                    }))
                })
            })
        })
    });
}
const $a53195ed5a927706$var$flagButtonStyle = {
    alignSelf: "center",
    fontSize: 24,
    padding: 0,
    paddingLeft: 8,
    paddingRight: 8
};
function $a53195ed5a927706$export$3170d3214a55335c({ locale: locale, setLocale: setLocale, hasLocales: hasLocales, locales: locales, ignoreDefault: ignoreDefault, currentFallback: currentFallback }) {
    (0, $geOdl.useStudioLocale)();
    const currentDefaultLocale = (0, $aIeEI.useCurrentLocale)();
    const backendLocales = (0, $gssTr.useLocalesContext)();
    locales !== null && locales !== void 0 ? locales : locales = backendLocales !== null && backendLocales !== void 0 ? backendLocales : [];
    const loc = locales === null || locales === void 0 ? void 0 : locales.find((x)=>x.key === locale);
    (0, $eeH7J.useEffect)(()=>{
        if (!ignoreDefault && currentDefaultLocale) setLocale(currentDefaultLocale);
    }, [
        currentDefaultLocale
    ]);
    if (!locales || locales.length < 2) return (0, $4vwom.jsx)((0, $4vwom.Fragment), {});
    const fallback = locales.find((l)=>l.key === currentFallback);
    return (0, $4vwom.jsxs)((0, $fT6Pt.RButton), {
        style: $a53195ed5a927706$var$flagButtonStyle,
        popup: (close)=>(0, $4vwom.jsx)((0, $4vwom.Fragment), {
                children: locales === null || locales === void 0 ? void 0 : locales.map((l)=>(0, $4vwom.jsxs)((0, $fT6Pt.RButton), {
                        style: (hover)=>Object.assign(Object.assign({}, $a53195ed5a927706$var$flagButtonStyle), {
                                backgroundColor: l.key === locale ? "#ddd" : hover ? "#eee" : undefined
                            }),
                        onClick: ()=>{
                            setLocale(l.key);
                            close();
                        },
                        children: [
                            $a53195ed5a927706$var$LocaleView(locales, l),
                            hasLocales && (hasLocales.some((x)=>x === l.key) ? (0, $4vwom.jsx)("span", {
                                style: {
                                    fontSize: 12,
                                    color: "green",
                                    marginLeft: 4
                                },
                                children: "\u2713"
                            }) : (0, $4vwom.jsx)("span", {
                                style: {
                                    fontSize: 12,
                                    color: "red",
                                    marginLeft: 4
                                },
                                children: "\u2717"
                            }))
                        ]
                    }, l.key.valueOf()))
            }),
        children: [
            loc && $a53195ed5a927706$var$LocaleView(locales, loc, {
                opacity: fallback ? 0.5 : 1
            }),
            fallback && (0, $4vwom.jsxs)((0, $4vwom.Fragment), {
                children: [
                    (0, $4vwom.jsx)("span", {
                        style: {
                            fontSize: 12,
                            color: "red",
                            marginLeft: -8,
                            marginTop: 6,
                            marginRight: 4
                        },
                        children: "\u2717"
                    }),
                    (0, $4vwom.jsxs)("div", {
                        style: {
                            fontSize: 14
                        },
                        children: [
                            "\u2192",
                            $a53195ed5a927706$var$LocaleView(locales, fallback)
                        ]
                    })
                ]
            })
        ]
    });
}
function $a53195ed5a927706$var$LocaleView(locales, loc, style) {
    /* Disambiguate between multiple locales having the same flag */ return (0, $4vwom.jsxs)("span", {
        style: style,
        children: [
            loc.flag,
            (0, $4vwom.jsx)("span", {
                style: {
                    fontSize: 12,
                    marginLeft: 4
                },
                children: (locales === null || locales === void 0 ? void 0 : locales.some((x)=>x !== loc && x.flag === loc.flag)) ? loc.key : ""
            })
        ]
    });
}
function $a53195ed5a927706$export$1c525333428011dc() {
    const { locale: locale, setLocale: setLocale } = (0, $eeH7J.useContext)((0, $7FrRx.CurrentLocaleContext));
    return (0, $4vwom.jsx)($a53195ed5a927706$export$3170d3214a55335c, {
        locale: locale,
        setLocale: (loc)=>{
            if (setLocale) setLocale(loc);
            else alert("Cannot change locales in this context");
        }
    });
}

});
parcelRegister("fT6Pt", function(module, exports) {

$parcel$export(module.exports, "RButton", function () { return $b9114a3b4926548e$export$b4ae8418df2fbc; });
$parcel$export(module.exports, "ContextButton", function () { return $b9114a3b4926548e$export$d937a95be28526bd; });

var $4vwom = parcelRequire("4vwom");

var $eeH7J = parcelRequire("eeH7J");

var $fTlTn = parcelRequire("fTlTn");
var $1rVia = parcelRequire("1rVia");
var $gLzHS = parcelRequire("gLzHS");

var $fz3r9 = parcelRequire("fz3r9");

var $gaj8U = parcelRequire("gaj8U");

var $6sp4J = parcelRequire("6sp4J");

var $5K1mb = parcelRequire("5K1mb");

var $9Q5xE = parcelRequire("9Q5xE");
var $b9114a3b4926548e$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
function $b9114a3b4926548e$export$b4ae8418df2fbc(props) {
    var _a, _b;
    const [popupVisible, setPopupVisible] = (0, $eeH7J.useState)(false);
    const { hover: hover, hoverProps: hoverProps } = (0, $fz3r9.useHover)();
    const [busy, setBusy] = (0, $eeH7J.useState)(false);
    const busyIndicatorVisible = (0, $gaj8U.useDebounce)(busy, 250);
    const style = props.style instanceof Function ? props.style(hover) : props.style;
    const highlight = hover && !props.disabled;
    let backgroundColor = props.variant === "primary" ? highlight ? (0, $9Q5xE.ColorStyles).primary[700] : (0, $9Q5xE.ColorStyles).primary[800] : highlight ? (0, $9Q5xE.ColorStyles).gray[100] : undefined;
    const active = props.active || popupVisible;
    let color = (0, $9Q5xE.ColorStyles).gray[700];
    if (active) color = (0, $9Q5xE.ColorStyles).primary[700];
    if (props.variant === "secondary") color = (0, $9Q5xE.ColorStyles).primary[700];
    if (props.variant === "primary") color = "white";
    if (props.variant === "link") {
        backgroundColor = undefined;
        color = hover ? (0, $9Q5xE.ColorStyles).primary[700] : (0, $9Q5xE.ColorStyles).primary[500];
    }
    if (props.variant === "danger" && hover) {
        backgroundColor = (0, $9Q5xE.ColorStyles).error[500];
        color = "white";
    }
    if (props.color) color = props.color;
    const anyContent = props.children !== undefined && (props.children instanceof Array ? props.children.some((x)=>!!x) : true);
    const { popup: popup } = props;
    const elementTarget = (0, $eeH7J.useRef)(null);
    const hoverDelayed = (0, $gaj8U.useDebounce)(hover, 1000);
    const iconSize = (_a = props.iconSize) !== null && _a !== void 0 ? _a : 22;
    const btn = (0, $4vwom.jsxs)((0, $4vwom.Fragment), {
        children: [
            props.tooltip && (0, $4vwom.jsx)((0, $fTlTn.default), {
                target: elementTarget,
                show: hover && hoverDelayed,
                placement: (_b = props.tooltipPlacement) !== null && _b !== void 0 ? _b : "top",
                children: (p)=>{
                    var _a;
                    return (0, $4vwom.jsx)((0, $gLzHS.default), Object.assign({
                        id: "overlay-example"
                    }, p, {
                        children: (_a = props.tooltip) === null || _a === void 0 ? void 0 : _a.split("\n").map((line, i)=>(0, $4vwom.jsx)("div", {
                                style: {
                                    minHeight: 20
                                },
                                children: line
                            }, i))
                    }));
                }
            }),
            (0, $4vwom.jsxs)("div", Object.assign({
                ref: elementTarget,
                onClick: props.link && !props.onClick ? undefined : async (e)=>{
                    e.stopPropagation();
                    if (props.disabled) return;
                    if (props.onClick) {
                        setBusy(true);
                        await props.onClick();
                        setBusy(false);
                    }
                    if (popup) setPopupVisible(!popupVisible);
                }
            }, hoverProps, {
                className: props.className ? props.className + " hide-in-print" : "hide-in-print",
                style: Object.assign({
                    flexDirection: "row",
                    alignItems: "center",
                    opacity: props.disabled ? 0.6 : 1,
                    borderRadius: 8,
                    borderStyle: props.variant === "link" ? undefined : "solid",
                    borderWidth: props.borderColor ? 1 : 0,
                    borderColor: props.borderColor,
                    userSelect: "none",
                    padding: "0.5rem",
                    paddingLeft: "1rem",
                    paddingRight: "1rem",
                    fontSize: 16,
                    backgroundColor: backgroundColor,
                    color: color,
                    cursor: props.disabled ? undefined : "pointer"
                }, style),
                children: [
                    props.icon && (0, $4vwom.jsx)((0, $6sp4J.Icon), {
                        icon: props.icon,
                        color: color,
                        size: iconSize,
                        style: {
                            marginTop: 0,
                            color: color,
                            fontSize: iconSize,
                            width: iconSize,
                            height: iconSize
                        }
                    }),
                    props.children && (0, $4vwom.jsx)("div", {
                        className: props.icon ? "studio-button-content-with-icon" : undefined,
                        children: props.children
                    }),
                    busyIndicatorVisible && (0, $4vwom.jsx)((0, $1rVia.default), {
                        animation: "grow",
                        size: "sm",
                        style: {
                            marginLeft: 8
                        }
                    }),
                    (popup || props.chevron) && !props.hideChevron && (0, $4vwom.jsx)((0, $6sp4J.Icon), {
                        color: (0, $9Q5xE.ColorStyles).gray[700],
                        icon: props.chevron || "chevron-down",
                        style: {
                            marginLeft: anyContent ? 16 : 0,
                            color: color,
                            fontSize: 14,
                            maxWidth: 24,
                            maxHeight: 24
                        }
                    })
                ]
            })),
            popup && (0, $4vwom.jsx)((0, $fTlTn.default), {
                target: elementTarget,
                show: popupVisible,
                placement: props.popupPlacement || "bottom-start",
                children: (_a)=>{
                    var { placement: placement, arrowProps: arrowProps, show: _show, popper: popper } = _a, popperProps = $b9114a3b4926548e$var$__rest(_a, [
                        "placement",
                        "arrowProps",
                        "show",
                        "popper"
                    ]);
                    return (0, $4vwom.jsx)("div", Object.assign({
                        onMouseLeave: ()=>setPopupVisible(false)
                    }, popperProps, {
                        style: Object.assign({
                            backgroundColor: "white",
                            padding: "0.5rem",
                            boxShadow: (0, $9Q5xE.OverlayShadow),
                            maxHeight: "50vh",
                            overflow: "auto",
                            borderRadius: 3,
                            zIndex: 110
                        }, popperProps.style),
                        children: popup(()=>setPopupVisible(false))
                    }));
                }
            })
        ]
    });
    if (props.link && !props.disabled) return (0, $4vwom.jsx)((0, $5K1mb.Link), {
        to: props.link,
        target: props.openLinkInNewTab ? "_blank" : undefined,
        style: {
            textDecoration: "none"
        },
        children: btn
    });
    else return btn;
}
function $b9114a3b4926548e$export$d6f68d0fe29f8050({ onClick: onClick, style: style }) {
    return (0, $4vwom.jsx)($b9114a3b4926548e$export$b4ae8418df2fbc, {
        variant: "danger",
        onClick: onClick,
        icon: "trash",
        color: (0, $9Q5xE.ColorStyles).gray[300],
        style: Object.assign({
            borderWidth: 0
        }, style)
    });
}
function $b9114a3b4926548e$export$a74f9e4ec49e14f8({ onClick: onClick }) {
    return (0, $4vwom.jsx)($b9114a3b4926548e$export$b4ae8418df2fbc, {
        variant: "primary",
        icon: "bars",
        onClick: onClick
    });
}
function $b9114a3b4926548e$export$6d88ebe453be59d7({ onClick: onClick, text: text, style: style }) {
    return (0, $4vwom.jsx)($b9114a3b4926548e$export$b4ae8418df2fbc, {
        style: style,
        variant: "secondary",
        icon: "plus",
        onClick: onClick,
        className: "reactor-form-small-label",
        children: text
    });
}
function $b9114a3b4926548e$export$d937a95be28526bd(props) {
    return (0, $4vwom.jsx)($b9114a3b4926548e$export$b4ae8418df2fbc, {
        icon: "ui-dots-horizontal",
        hideChevron: true,
        style: {
            borderWidth: 0,
            padding: 4,
            margin: 0
        },
        popup: ()=>props.buttons,
        iconSize: 16,
        popupPlacement: "left-start"
    });
}
function $b9114a3b4926548e$export$e475faf34e2d9799({ text: text, buttons: buttons }) {
    return (0, $4vwom.jsx)($b9114a3b4926548e$export$b4ae8418df2fbc, {
        variant: "secondary",
        icon: "plus",
        popup: ()=>buttons,
        children: text
    });
}

});
parcelRegister("fTlTn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b91cf96b1a229d59$export$2e2bcd8739ae039; });

var $h4XE0 = parcelRequire("h4XE0");

var $fbOaB = parcelRequire("fbOaB");

var $eeH7J = parcelRequire("eeH7J");

var $aienp = parcelRequire("aienp");

var $dMkHl = parcelRequire("dMkHl");

var $fP80V = parcelRequire("fP80V");

var $ezE35 = parcelRequire("ezE35");

var $4NnQi = parcelRequire("4NnQi");
var $b91cf96b1a229d59$var$_excluded = [
    "children",
    "transition",
    "popperConfig"
], $b91cf96b1a229d59$var$_excluded2 = [
    "props",
    "arrowProps",
    "show",
    "update",
    "forceUpdate",
    "placement",
    "state"
];
var $b91cf96b1a229d59$var$defaultProps = {
    transition: (0, $4NnQi.default),
    rootClose: false,
    show: false,
    placement: "top"
};
function $b91cf96b1a229d59$var$wrapRefs(props, arrowProps) {
    var ref = props.ref;
    var aRef = arrowProps.ref;
    props.ref = ref.__wrapped || (ref.__wrapped = function(r) {
        return ref((0, $fP80V.default)(r));
    });
    arrowProps.ref = aRef.__wrapped || (aRef.__wrapped = function(r) {
        return aRef((0, $fP80V.default)(r));
    });
}
function $b91cf96b1a229d59$var$Overlay(_ref) {
    var overlay = _ref.children, transition = _ref.transition, _ref$popperConfig = _ref.popperConfig, popperConfig = _ref$popperConfig === void 0 ? {} : _ref$popperConfig, outerProps = (0, $fbOaB.default)(_ref, $b91cf96b1a229d59$var$_excluded);
    var popperRef = (0, $eeH7J.useRef)({});
    var _usePopperMarginModif = (0, $ezE35.default)(), ref = _usePopperMarginModif[0], marginModifiers = _usePopperMarginModif[1];
    var actualTransition = transition === true ? (0, $4NnQi.default) : transition || null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $dMkHl.default), (0, $h4XE0.default)({}, outerProps, {
        ref: ref,
        popperConfig: (0, $h4XE0.default)({}, popperConfig, {
            modifiers: marginModifiers.concat(popperConfig.modifiers || [])
        }),
        transition: actualTransition
    }), function(_ref2) {
        var _state$modifiersData$;
        var overlayProps = _ref2.props, arrowProps = _ref2.arrowProps, show = _ref2.show, update = _ref2.update, _ = _ref2.forceUpdate, placement = _ref2.placement, state = _ref2.state, props = (0, $fbOaB.default)(_ref2, $b91cf96b1a229d59$var$_excluded2);
        $b91cf96b1a229d59$var$wrapRefs(overlayProps, arrowProps);
        var popper = Object.assign(popperRef.current, {
            state: state,
            scheduleUpdate: update,
            placement: placement,
            outOfBoundaries: (state == null ? void 0 : (_state$modifiersData$ = state.modifiersData.hide) == null ? void 0 : _state$modifiersData$.isReferenceHidden) || false
        });
        if (typeof overlay === "function") return overlay((0, $h4XE0.default)({}, props, overlayProps, {
            placement: placement,
            show: show
        }, !transition && show && {
            className: "show"
        }, {
            popper: popper,
            arrowProps: arrowProps
        }));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).cloneElement(overlay, (0, $h4XE0.default)({}, props, overlayProps, {
            placement: placement,
            arrowProps: arrowProps,
            popper: popper,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($aienp)))(overlay.props.className, !transition && show && "show"),
            style: (0, $h4XE0.default)({}, overlay.props.style, overlayProps.style)
        }));
    });
}
$b91cf96b1a229d59$var$Overlay.defaultProps = $b91cf96b1a229d59$var$defaultProps;
var $b91cf96b1a229d59$export$2e2bcd8739ae039 = $b91cf96b1a229d59$var$Overlay;

});
parcelRegister("fbOaB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b0eeccd462f407d6$export$2e2bcd8739ae039; });
function $b0eeccd462f407d6$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}

});

parcelRegister("aienp", function(module, exports) {
/*!
  Copyright (c) 2018 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    "use strict";
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = [];
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (!arg) continue;
            var argType = typeof arg;
            if (argType === "string" || argType === "number") classes.push(arg);
            else if (Array.isArray(arg)) {
                if (arg.length) {
                    var inner = classNames.apply(null, arg);
                    if (inner) classes.push(inner);
                }
            } else if (argType === "object") {
                if (arg.toString === Object.prototype.toString) {
                    for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes.push(key);
                } else classes.push(arg.toString());
            }
        }
        return classes.join(" ");
    }
    if (0, module.exports) {
        classNames.default = classNames;
        module.exports = classNames;
    } else if (typeof define === "function" && typeof define.amd === "object" && define.amd) // register as 'classnames', consistent with npm package name
    define("classnames", [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();

});

parcelRegister("dMkHl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a07fd04508a326a6$export$2e2bcd8739ae039; });

var $h4XE0 = parcelRequire("h4XE0");

var $fbOaB = parcelRequire("fbOaB");

var $4yBem = parcelRequire("4yBem");

var $eeH7J = parcelRequire("eeH7J");

var $iMJCh = parcelRequire("iMJCh");

var $boXcK = parcelRequire("boXcK");

var $kTadk = parcelRequire("kTadk");

var $d2T2o = parcelRequire("d2T2o");

var $5zGaS = parcelRequire("5zGaS");

var $1xBVt = parcelRequire("1xBVt");

var $7EllR = parcelRequire("7EllR");

var $9Wxjw = parcelRequire("9Wxjw");
/**
 * Built on top of `Popper.js`, the overlay component is
 * great for custom tooltip overlays.
 */ var $a07fd04508a326a6$var$Overlay = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).forwardRef(function(props, outerRef) {
    var flip = props.flip, offset = props.offset, placement = props.placement, _props$containerPaddi = props.containerPadding, containerPadding = _props$containerPaddi === void 0 ? 5 : _props$containerPaddi, _props$popperConfig = props.popperConfig, popperConfig = _props$popperConfig === void 0 ? {} : _props$popperConfig, Transition = props.transition;
    var _useCallbackRef = (0, $boXcK.default)(), rootElement = _useCallbackRef[0], attachRef = _useCallbackRef[1];
    var _useCallbackRef2 = (0, $boXcK.default)(), arrowElement = _useCallbackRef2[0], attachArrowRef = _useCallbackRef2[1];
    var mergedRef = (0, $kTadk.default)(attachRef, outerRef);
    var container = (0, $7EllR.default)(props.container);
    var target = (0, $7EllR.default)(props.target);
    var _useState = (0, $eeH7J.useState)(!props.show), exited = _useState[0], setExited = _useState[1];
    var _usePopper = (0, $5zGaS.default)(target, rootElement, (0, $9Wxjw.default)({
        placement: placement,
        enableEvents: !!props.show,
        containerPadding: containerPadding || 5,
        flip: flip,
        offset: offset,
        arrowElement: arrowElement,
        popperConfig: popperConfig
    })), styles = _usePopper.styles, attributes = _usePopper.attributes, popper = (0, $fbOaB.default)(_usePopper, [
        "styles",
        "attributes"
    ]);
    if (props.show) {
        if (exited) setExited(false);
    } else if (!props.transition && !exited) setExited(true);
    var handleHidden = function handleHidden() {
        setExited(true);
        if (props.onExited) props.onExited.apply(props, arguments);
    }; // Don't un-render the overlay while it's transitioning out.
    var mountOverlay = props.show || Transition && !exited;
    (0, $1xBVt.default)(rootElement, props.onHide, {
        disabled: !props.rootClose || props.rootCloseDisabled,
        clickTrigger: props.rootCloseEvent
    });
    if (!mountOverlay) // Don't bother showing anything if we don't have to.
    return null;
    var child = props.children((0, $h4XE0.default)({}, popper, {
        show: !!props.show,
        props: (0, $h4XE0.default)({}, attributes.popper, {
            style: styles.popper,
            ref: mergedRef
        }),
        arrowProps: (0, $h4XE0.default)({}, attributes.arrow, {
            style: styles.arrow,
            ref: attachArrowRef
        })
    }));
    if (Transition) {
        var onExit = props.onExit, onExiting = props.onExiting, onEnter = props.onEnter, onEntering = props.onEntering, onEntered = props.onEntered;
        child = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement(Transition, {
            "in": props.show,
            appear: true,
            onExit: onExit,
            onExiting: onExiting,
            onExited: handleHidden,
            onEnter: onEnter,
            onEntering: onEntering,
            onEntered: onEntered
        }, child);
    }
    return container ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iMJCh))).createPortal(child, container) : null;
});
$a07fd04508a326a6$var$Overlay.displayName = "Overlay";
$a07fd04508a326a6$var$Overlay.propTypes = {
    /**
   * Set the visibility of the Overlay
   */ show: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /** Specify where the overlay element is positioned in relation to the target element */ placement: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOf((0, $d2T2o.placements)),
    /**
   * A DOM Element, Ref to an element, or function that returns either. The `target` element is where
   * the overlay is positioned relative to.
   */ target: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).any,
    /**
   * A DOM Element, Ref to an element, or function that returns either. The `container` will have the Portal children
   * appended to it.
   */ container: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).any,
    /**
   * Enables the Popper.js `flip` modifier, allowing the Overlay to
   * automatically adjust it's placement in case of overlap with the viewport or toggle.
   * Refer to the [flip docs](https://popper.js.org/popper-documentation.html#modifiers..flip.enabled) for more info
   */ flip: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * A render prop that returns an element to overlay and position. See
   * the [react-popper documentation](https://github.com/FezVrasta/react-popper#children) for more info.
   *
   * @type {Function ({
   *   show: boolean,
   *   placement: Placement,
   *   update: () => void,
   *   forceUpdate: () => void,
   *   props: {
   *     ref: (?HTMLElement) => void,
   *     style: { [string]: string | number },
   *     aria-labelledby: ?string
   *     [string]: string | number,
   *   },
   *   arrowProps: {
   *     ref: (?HTMLElement) => void,
   *     style: { [string]: string | number },
   *     [string]: string | number,
   *   },
   * }) => React.Element}
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func.isRequired,
    /**
   * Control how much space there is between the edge of the boundary element and overlay.
   * A convenience shortcut to setting `popperConfig.modfiers.preventOverflow.padding`
   */ containerPadding: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).number,
    /**
   * A set of popper options and props passed directly to react-popper's Popper component.
   */ popperConfig: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
    /**
   * Specify whether the overlay should trigger `onHide` when the user clicks outside the overlay
   */ rootClose: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * Specify event for toggling overlay
   */ rootCloseEvent: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOf([
        "click",
        "mousedown"
    ]),
    /**
   * Specify disabled for disable RootCloseWrapper
   */ rootCloseDisabled: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * A Callback fired by the Overlay when it wishes to be hidden.
   *
   * __required__ when `rootClose` is `true`.
   *
   * @type func
   */ onHide: function onHide(props) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        if (props.rootClose) {
            var _PropTypes$func;
            return (_PropTypes$func = (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func).isRequired.apply(_PropTypes$func, [
                props
            ].concat(args));
        }
        return (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func.apply((0, (/*@__PURE__*/$parcel$interopDefault($4yBem))), [
            props
        ].concat(args));
    },
    /**
   * A `react-transition-group@2.0.0` `<Transition/>` component
   * used to animate the overlay as it changes visibility.
   */ // @ts-ignore
    transition: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).elementType,
    /**
   * Callback fired before the Overlay transitions in
   */ onEnter: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
    /**
   * Callback fired as the Overlay begins to transition in
   */ onEntering: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
    /**
   * Callback fired after the Overlay finishes transitioning in
   */ onEntered: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
    /**
   * Callback fired right before the Overlay transitions out
   */ onExit: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
    /**
   * Callback fired as the Overlay begins to transition out
   */ onExiting: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
    /**
   * Callback fired after the Overlay finishes transitioning out
   */ onExited: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func
};
var $a07fd04508a326a6$export$2e2bcd8739ae039 = $a07fd04508a326a6$var$Overlay;

});
parcelRegister("4yBem", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $351737a4f5900595$var$ReactIs, $351737a4f5900595$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = (parcelRequire("3TnLK"))();

});
parcelRegister("3TnLK", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";

var $e6VZV = parcelRequire("e6VZV");
function $2d58f23349affbc5$var$emptyFunction() {}
function $2d58f23349affbc5$var$emptyFunctionWithReset() {}
$2d58f23349affbc5$var$emptyFunctionWithReset.resetWarningCache = $2d58f23349affbc5$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $e6VZV) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = "Invariant Violation";
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $2d58f23349affbc5$var$emptyFunctionWithReset,
        resetWarningCache: $2d58f23349affbc5$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("e6VZV", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var $a45e9d61400164c5$var$ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
module.exports = $a45e9d61400164c5$var$ReactPropTypesSecret;

});



parcelRegister("boXcK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $84cfdc60e57a1506$export$2e2bcd8739ae039; });

var $eeH7J = parcelRequire("eeH7J");
function $84cfdc60e57a1506$export$2e2bcd8739ae039() {
    return (0, $eeH7J.useState)(null);
}

});

parcelRegister("kTadk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f350ddfb99b7887d$export$2e2bcd8739ae039; });

var $eeH7J = parcelRequire("eeH7J");
const $f350ddfb99b7887d$var$toFnRef = (ref)=>!ref || typeof ref === "function" ? ref : (value)=>{
        ref.current = value;
    };
function $f350ddfb99b7887d$export$c9058316764c140e(refA, refB) {
    const a = $f350ddfb99b7887d$var$toFnRef(refA);
    const b = $f350ddfb99b7887d$var$toFnRef(refB);
    return (value)=>{
        if (a) a(value);
        if (b) b(value);
    };
}
/**
 * Create and returns a single callback ref composed from two other Refs.
 *
 * ```tsx
 * const Button = React.forwardRef((props, ref) => {
 *   const [element, attachRef] = useCallbackRef<HTMLButtonElement>();
 *   const mergedRef = useMergedRefs(ref, attachRef);
 *
 *   return <button ref={mergedRef} {...props}/>
 * })
 * ```
 *
 * @param refA A Callback or mutable Ref
 * @param refB A Callback or mutable Ref
 * @category refs
 */ function $f350ddfb99b7887d$var$useMergedRefs(refA, refB) {
    return (0, $eeH7J.useMemo)(()=>$f350ddfb99b7887d$export$c9058316764c140e(refA, refB), [
        refA,
        refB
    ]);
}
var $f350ddfb99b7887d$export$2e2bcd8739ae039 = $f350ddfb99b7887d$var$useMergedRefs;

});

parcelRegister("d2T2o", function(module, exports) {

$parcel$export(module.exports, "top", function () { return $97f6279b6bda8f09$export$1e95b668f3b82d; });
$parcel$export(module.exports, "bottom", function () { return $97f6279b6bda8f09$export$40e543e69a8b3fbb; });
$parcel$export(module.exports, "right", function () { return $97f6279b6bda8f09$export$79ffe56a765070d2; });
$parcel$export(module.exports, "left", function () { return $97f6279b6bda8f09$export$eabcd2c8791e7bf4; });
$parcel$export(module.exports, "auto", function () { return $97f6279b6bda8f09$export$dfb5619354ba860; });
$parcel$export(module.exports, "basePlacements", function () { return $97f6279b6bda8f09$export$aec2ce47c367b8c3; });
$parcel$export(module.exports, "start", function () { return $97f6279b6bda8f09$export$b3571188c770cc5a; });
$parcel$export(module.exports, "end", function () { return $97f6279b6bda8f09$export$bd5df0f255a350f8; });
$parcel$export(module.exports, "clippingParents", function () { return $97f6279b6bda8f09$export$390fd549c5303b4d; });
$parcel$export(module.exports, "viewport", function () { return $97f6279b6bda8f09$export$d7b7311ec04a3e8f; });
$parcel$export(module.exports, "popper", function () { return $97f6279b6bda8f09$export$ae5ab1c730825774; });
$parcel$export(module.exports, "reference", function () { return $97f6279b6bda8f09$export$ca50aac9f3ba507f; });
$parcel$export(module.exports, "variationPlacements", function () { return $97f6279b6bda8f09$export$368f9a87e87fa4e1; });
$parcel$export(module.exports, "placements", function () { return $97f6279b6bda8f09$export$803cd8101b6c182b; });
$parcel$export(module.exports, "modifierPhases", function () { return $97f6279b6bda8f09$export$d087d3878fdf71d5; });
var $97f6279b6bda8f09$export$1e95b668f3b82d = "top";
var $97f6279b6bda8f09$export$40e543e69a8b3fbb = "bottom";
var $97f6279b6bda8f09$export$79ffe56a765070d2 = "right";
var $97f6279b6bda8f09$export$eabcd2c8791e7bf4 = "left";
var $97f6279b6bda8f09$export$dfb5619354ba860 = "auto";
var $97f6279b6bda8f09$export$aec2ce47c367b8c3 = [
    $97f6279b6bda8f09$export$1e95b668f3b82d,
    $97f6279b6bda8f09$export$40e543e69a8b3fbb,
    $97f6279b6bda8f09$export$79ffe56a765070d2,
    $97f6279b6bda8f09$export$eabcd2c8791e7bf4
];
var $97f6279b6bda8f09$export$b3571188c770cc5a = "start";
var $97f6279b6bda8f09$export$bd5df0f255a350f8 = "end";
var $97f6279b6bda8f09$export$390fd549c5303b4d = "clippingParents";
var $97f6279b6bda8f09$export$d7b7311ec04a3e8f = "viewport";
var $97f6279b6bda8f09$export$ae5ab1c730825774 = "popper";
var $97f6279b6bda8f09$export$ca50aac9f3ba507f = "reference";
var $97f6279b6bda8f09$export$368f9a87e87fa4e1 = /*#__PURE__*/ $97f6279b6bda8f09$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $97f6279b6bda8f09$export$b3571188c770cc5a,
        placement + "-" + $97f6279b6bda8f09$export$bd5df0f255a350f8
    ]);
}, []);
var $97f6279b6bda8f09$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($97f6279b6bda8f09$export$aec2ce47c367b8c3, [
    $97f6279b6bda8f09$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $97f6279b6bda8f09$export$b3571188c770cc5a,
        placement + "-" + $97f6279b6bda8f09$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $97f6279b6bda8f09$export$421679a7c3d56e = "beforeRead";
var $97f6279b6bda8f09$export$aafa59e2e03f2942 = "read";
var $97f6279b6bda8f09$export$6964f6c886723980 = "afterRead"; // pure-logic modifiers
var $97f6279b6bda8f09$export$c65e99957a05207c = "beforeMain";
var $97f6279b6bda8f09$export$f22da7240b7add18 = "main";
var $97f6279b6bda8f09$export$bab79516f2d662fe = "afterMain"; // modifier with the purpose to write to the DOM (or write into a framework state)
var $97f6279b6bda8f09$export$8d4d2d70e7d46032 = "beforeWrite";
var $97f6279b6bda8f09$export$68d8715fc104d294 = "write";
var $97f6279b6bda8f09$export$70a6e5159acce2e6 = "afterWrite";
var $97f6279b6bda8f09$export$d087d3878fdf71d5 = [
    $97f6279b6bda8f09$export$421679a7c3d56e,
    $97f6279b6bda8f09$export$aafa59e2e03f2942,
    $97f6279b6bda8f09$export$6964f6c886723980,
    $97f6279b6bda8f09$export$c65e99957a05207c,
    $97f6279b6bda8f09$export$f22da7240b7add18,
    $97f6279b6bda8f09$export$bab79516f2d662fe,
    $97f6279b6bda8f09$export$8d4d2d70e7d46032,
    $97f6279b6bda8f09$export$68d8715fc104d294,
    $97f6279b6bda8f09$export$70a6e5159acce2e6
];

});

parcelRegister("5zGaS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $40f0ef952b109bf1$export$2e2bcd8739ae039; });

var $h4XE0 = parcelRequire("h4XE0");

var $fbOaB = parcelRequire("fbOaB");

var $eeH7J = parcelRequire("eeH7J");

var $fNi2x = parcelRequire("fNi2x");

var $bKRFj = parcelRequire("bKRFj");
var $40f0ef952b109bf1$var$initialPopperStyles = function initialPopperStyles(position) {
    return {
        position: position,
        top: "0",
        left: "0",
        opacity: "0",
        pointerEvents: "none"
    };
};
var $40f0ef952b109bf1$var$disabledApplyStylesModifier = {
    name: "applyStyles",
    enabled: false
}; // In order to satisfy the current usage of options, including undefined
var $40f0ef952b109bf1$var$ariaDescribedByModifier = {
    name: "ariaDescribedBy",
    enabled: true,
    phase: "afterWrite",
    effect: function effect(_ref) {
        var state = _ref.state;
        return function() {
            var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper;
            if ("removeAttribute" in reference) {
                var ids = (reference.getAttribute("aria-describedby") || "").split(",").filter(function(id) {
                    return id.trim() !== popper.id;
                });
                if (!ids.length) reference.removeAttribute("aria-describedby");
                else reference.setAttribute("aria-describedby", ids.join(","));
            }
        };
    },
    fn: function fn(_ref2) {
        var _popper$getAttribute;
        var state = _ref2.state;
        var _state$elements2 = state.elements, popper = _state$elements2.popper, reference = _state$elements2.reference;
        var role = (_popper$getAttribute = popper.getAttribute("role")) == null ? void 0 : _popper$getAttribute.toLowerCase();
        if (popper.id && role === "tooltip" && "setAttribute" in reference) {
            var ids = reference.getAttribute("aria-describedby");
            if (ids && ids.split(",").indexOf(popper.id) !== -1) return;
            reference.setAttribute("aria-describedby", ids ? ids + "," + popper.id : popper.id);
        }
    }
};
var $40f0ef952b109bf1$var$EMPTY_MODIFIERS = [];
/**
 * Position an element relative some reference element using Popper.js
 *
 * @param referenceElement
 * @param popperElement
 * @param {object}      options
 * @param {object=}     options.modifiers Popper.js modifiers
 * @param {boolean=}    options.enabled toggle the popper functionality on/off
 * @param {string=}     options.placement The popper element placement relative to the reference element
 * @param {string=}     options.strategy the positioning strategy
 * @param {boolean=}    options.eventsEnabled have Popper listen on window resize events to reposition the element
 * @param {function=}   options.onCreate called when the popper is created
 * @param {function=}   options.onUpdate called when the popper is updated
 *
 * @returns {UsePopperState} The popper state
 */ function $40f0ef952b109bf1$var$usePopper(referenceElement, popperElement, _temp) {
    var _ref3 = _temp === void 0 ? {} : _temp, _ref3$enabled = _ref3.enabled, enabled = _ref3$enabled === void 0 ? true : _ref3$enabled, _ref3$placement = _ref3.placement, placement = _ref3$placement === void 0 ? "bottom" : _ref3$placement, _ref3$strategy = _ref3.strategy, strategy = _ref3$strategy === void 0 ? "absolute" : _ref3$strategy, _ref3$modifiers = _ref3.modifiers, modifiers = _ref3$modifiers === void 0 ? $40f0ef952b109bf1$var$EMPTY_MODIFIERS : _ref3$modifiers, config = (0, $fbOaB.default)(_ref3, [
        "enabled",
        "placement",
        "strategy",
        "modifiers"
    ]);
    var popperInstanceRef = (0, $eeH7J.useRef)();
    var update = (0, $eeH7J.useCallback)(function() {
        var _popperInstanceRef$cu;
        (_popperInstanceRef$cu = popperInstanceRef.current) == null || _popperInstanceRef$cu.update();
    }, []);
    var forceUpdate = (0, $eeH7J.useCallback)(function() {
        var _popperInstanceRef$cu2;
        (_popperInstanceRef$cu2 = popperInstanceRef.current) == null || _popperInstanceRef$cu2.forceUpdate();
    }, []);
    var _useSafeState = (0, $fNi2x.default)((0, $eeH7J.useState)({
        placement: placement,
        update: update,
        forceUpdate: forceUpdate,
        attributes: {},
        styles: {
            popper: $40f0ef952b109bf1$var$initialPopperStyles(strategy),
            arrow: {}
        }
    })), popperState = _useSafeState[0], setState = _useSafeState[1];
    var updateModifier = (0, $eeH7J.useMemo)(function() {
        return {
            name: "updateStateModifier",
            enabled: true,
            phase: "write",
            requires: [
                "computeStyles"
            ],
            fn: function fn(_ref4) {
                var state = _ref4.state;
                var styles = {};
                var attributes = {};
                Object.keys(state.elements).forEach(function(element) {
                    styles[element] = state.styles[element];
                    attributes[element] = state.attributes[element];
                });
                setState({
                    state: state,
                    styles: styles,
                    attributes: attributes,
                    update: update,
                    forceUpdate: forceUpdate,
                    placement: state.placement
                });
            }
        };
    }, [
        update,
        forceUpdate,
        setState
    ]);
    (0, $eeH7J.useEffect)(function() {
        if (!popperInstanceRef.current || !enabled) return;
        popperInstanceRef.current.setOptions({
            placement: placement,
            strategy: strategy,
            modifiers: [].concat(modifiers, [
                updateModifier,
                $40f0ef952b109bf1$var$disabledApplyStylesModifier
            ])
        }); // intentionally NOT re-running on new modifiers
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        strategy,
        placement,
        updateModifier,
        enabled
    ]);
    (0, $eeH7J.useEffect)(function() {
        if (!enabled || referenceElement == null || popperElement == null) return undefined;
        popperInstanceRef.current = (0, $bKRFj.createPopper)(referenceElement, popperElement, (0, $h4XE0.default)({}, config, {
            placement: placement,
            strategy: strategy,
            modifiers: [].concat(modifiers, [
                $40f0ef952b109bf1$var$ariaDescribedByModifier,
                updateModifier
            ])
        }));
        return function() {
            if (popperInstanceRef.current != null) {
                popperInstanceRef.current.destroy();
                popperInstanceRef.current = undefined;
                setState(function(s) {
                    return (0, $h4XE0.default)({}, s, {
                        attributes: {},
                        styles: {
                            popper: $40f0ef952b109bf1$var$initialPopperStyles(strategy)
                        }
                    });
                });
            }
        }; // This is only run once to _create_ the popper
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        enabled,
        referenceElement,
        popperElement
    ]);
    return popperState;
}
var $40f0ef952b109bf1$export$2e2bcd8739ae039 = $40f0ef952b109bf1$var$usePopper;

});
parcelRegister("fNi2x", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b7f96cf498fad852$export$2e2bcd8739ae039; });

var $eeH7J = parcelRequire("eeH7J");

var $gUToj = parcelRequire("gUToj");
/**
 * `useSafeState` takes the return value of a `useState` hook and wraps the
 * setter to prevent updates onces the component has unmounted. Can used
 * with `useMergeState` and `useStateAsync` as well
 *
 * @param state The return value of a useStateHook
 *
 * ```ts
 * const [show, setShow] = useSafeState(useState(true));
 * ```
 */ function $b7f96cf498fad852$var$useSafeState(state) {
    const isMounted = (0, $gUToj.default)();
    return [
        state[0],
        (0, $eeH7J.useCallback)((nextState)=>{
            if (!isMounted()) return;
            return state[1](nextState);
        }, [
            isMounted,
            state[1]
        ])
    ];
}
var $b7f96cf498fad852$export$2e2bcd8739ae039 = $b7f96cf498fad852$var$useSafeState;

});
parcelRegister("gUToj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c50cd7d4ec6cf7bc$export$2e2bcd8739ae039; });

var $eeH7J = parcelRequire("eeH7J");
function $c50cd7d4ec6cf7bc$export$2e2bcd8739ae039() {
    const mounted = (0, $eeH7J.useRef)(true);
    const isMounted = (0, $eeH7J.useRef)(()=>mounted.current);
    (0, $eeH7J.useEffect)(()=>{
        mounted.current = true;
        return ()=>{
            mounted.current = false;
        };
    }, []);
    return isMounted.current;
}

});


parcelRegister("bKRFj", function(module, exports) {

$parcel$export(module.exports, "createPopper", function () { return $88ed9e6bab58ab8c$export$8f7491d57c8f97a9; });

var $aQoIM = parcelRequire("aQoIM");

var $6yP7f = parcelRequire("6yP7f");

var $f63Hh = parcelRequire("f63Hh");

var $bgNku = parcelRequire("bgNku");

var $j3jMG = parcelRequire("j3jMG");

var $gXYWO = parcelRequire("gXYWO");

var $5CAqp = parcelRequire("5CAqp");

var $919wP = parcelRequire("919wP");

var $d2T2o = parcelRequire("d2T2o");

var $1dXwT = parcelRequire("1dXwT");
var $88ed9e6bab58ab8c$export$8f7491d57c8f97a9 = (0, $1dXwT.popperGenerator)({
    defaultModifiers: [
        (0, $j3jMG.default),
        (0, $5CAqp.default),
        (0, $6yP7f.default),
        (0, $f63Hh.default),
        (0, $gXYWO.default),
        (0, $bgNku.default),
        (0, $919wP.default),
        (0, $aQoIM.default)
    ]
});

});
parcelRegister("aQoIM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7e51efda9e6180a8$export$2e2bcd8739ae039; });

var $a98ZV = parcelRequire("a98ZV");

var $iaeAc = parcelRequire("iaeAc");

var $hjcJU = parcelRequire("hjcJU");

var $ferRV = parcelRequire("ferRV");

var $bS91E = parcelRequire("bS91E");

var $czvfC = parcelRequire("czvfC");

var $9z3Qe = parcelRequire("9z3Qe");

var $4NkCO = parcelRequire("4NkCO");

var $d2T2o = parcelRequire("d2T2o");
var $7e51efda9e6180a8$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === "function" ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $9z3Qe.default)(typeof padding !== "number" ? padding : (0, $4NkCO.default)(padding, (0, $d2T2o.basePlacements)));
};
function $7e51efda9e6180a8$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $a98ZV.default)(state.placement);
    var axis = (0, $bS91E.default)(basePlacement);
    var isVertical = [
        (0, $d2T2o.left),
        (0, $d2T2o.right)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? "height" : "width";
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $7e51efda9e6180a8$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $iaeAc.default)(arrowElement);
    var minProp = axis === "y" ? (0, $d2T2o.top) : (0, $d2T2o.left);
    var maxProp = axis === "y" ? (0, $d2T2o.bottom) : (0, $d2T2o.right);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $ferRV.default)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === "y" ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $czvfC.within)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $7e51efda9e6180a8$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? "[data-popper-arrow]" : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === "string") {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $hjcJU.default)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $7e51efda9e6180a8$export$2e2bcd8739ae039 = {
    name: "arrow",
    enabled: true,
    phase: "main",
    fn: $7e51efda9e6180a8$var$arrow,
    effect: $7e51efda9e6180a8$var$effect,
    requires: [
        "popperOffsets"
    ],
    requiresIfExists: [
        "preventOverflow"
    ]
};

});
parcelRegister("a98ZV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7631b9671a26e6a6$export$2e2bcd8739ae039; });

function $7631b9671a26e6a6$export$2e2bcd8739ae039(placement) {
    return placement.split("-")[0];
}

});

parcelRegister("iaeAc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d3947904e79cb06b$export$2e2bcd8739ae039; });

var $7LHdV = parcelRequire("7LHdV");
function $d3947904e79cb06b$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $7LHdV.default)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}

});
parcelRegister("7LHdV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5a7e7382b73c29b9$export$2e2bcd8739ae039; });

var $58Qwv = parcelRequire("58Qwv");

var $dEzG4 = parcelRequire("dEzG4");

var $6TTa5 = parcelRequire("6TTa5");

var $bkw0z = parcelRequire("bkw0z");
function $5a7e7382b73c29b9$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $58Qwv.isHTMLElement)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $dEzG4.round)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $dEzG4.round)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $58Qwv.isElement)(element) ? (0, $6TTa5.default)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $bkw0z.default)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}

});
parcelRegister("58Qwv", function(module, exports) {

$parcel$export(module.exports, "isElement", function () { return $3be67126bd9b4dac$export$45a5e7f76e0caa8d; });
$parcel$export(module.exports, "isHTMLElement", function () { return $3be67126bd9b4dac$export$1b3bfaa9684536aa; });
$parcel$export(module.exports, "isShadowRoot", function () { return $3be67126bd9b4dac$export$af51f0f06c0f328a; });

var $6TTa5 = parcelRequire("6TTa5");
function $3be67126bd9b4dac$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $6TTa5.default)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $3be67126bd9b4dac$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $6TTa5.default)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $3be67126bd9b4dac$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === "undefined") return false;
    var OwnElement = (0, $6TTa5.default)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}

});
parcelRegister("6TTa5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5062ab1154804816$export$2e2bcd8739ae039; });
function $5062ab1154804816$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== "[object Window]") {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}

});


parcelRegister("dEzG4", function(module, exports) {

$parcel$export(module.exports, "max", function () { return $9f0aaf9815ede3ec$export$8960430cfd85939f; });
$parcel$export(module.exports, "min", function () { return $9f0aaf9815ede3ec$export$96ec731ed4dcb222; });
$parcel$export(module.exports, "round", function () { return $9f0aaf9815ede3ec$export$2077e0241d6afd3c; });
var $9f0aaf9815ede3ec$export$8960430cfd85939f = Math.max;
var $9f0aaf9815ede3ec$export$96ec731ed4dcb222 = Math.min;
var $9f0aaf9815ede3ec$export$2077e0241d6afd3c = Math.round;

});

parcelRegister("bkw0z", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $83fa64234a2d533a$export$2e2bcd8739ae039; });

var $iKeNn = parcelRequire("iKeNn");
function $83fa64234a2d533a$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $iKeNn.default)());
}

});
parcelRegister("iKeNn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $da57ffef1a6cfc98$export$2e2bcd8739ae039; });
function $da57ffef1a6cfc98$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(" ");
    return navigator.userAgent;
}

});




parcelRegister("hjcJU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c99e17cd1650e2ac$export$2e2bcd8739ae039; });

var $58Qwv = parcelRequire("58Qwv");
function $c99e17cd1650e2ac$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $58Qwv.isShadowRoot)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}

});

parcelRegister("ferRV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b16dc7f6a8cdadb3$export$2e2bcd8739ae039; });

var $6TTa5 = parcelRequire("6TTa5");

var $1kiMy = parcelRequire("1kiMy");

var $2Ib3u = parcelRequire("2Ib3u");

var $58Qwv = parcelRequire("58Qwv");

var $jKun1 = parcelRequire("jKun1");

var $9MvYu = parcelRequire("9MvYu");

var $iKeNn = parcelRequire("iKeNn");
function $b16dc7f6a8cdadb3$var$getTrueOffsetParent(element) {
    if (!(0, $58Qwv.isHTMLElement)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $2Ib3u.default)(element).position === "fixed") return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $b16dc7f6a8cdadb3$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $iKeNn.default)());
    var isIE = /Trident/i.test((0, $iKeNn.default)());
    if (isIE && (0, $58Qwv.isHTMLElement)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $2Ib3u.default)(element);
        if (elementCss.position === "fixed") return null;
    }
    var currentNode = (0, $9MvYu.default)(element);
    if ((0, $58Qwv.isShadowRoot)(currentNode)) currentNode = currentNode.host;
    while((0, $58Qwv.isHTMLElement)(currentNode) && [
        "html",
        "body"
    ].indexOf((0, $1kiMy.default)(currentNode)) < 0){
        var css = (0, $2Ib3u.default)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== "none" || css.perspective !== "none" || css.contain === "paint" || [
            "transform",
            "perspective"
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === "filter" || isFirefox && css.filter && css.filter !== "none") return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $b16dc7f6a8cdadb3$export$2e2bcd8739ae039(element) {
    var window = (0, $6TTa5.default)(element);
    var offsetParent = $b16dc7f6a8cdadb3$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $jKun1.default)(offsetParent) && (0, $2Ib3u.default)(offsetParent).position === "static")offsetParent = $b16dc7f6a8cdadb3$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $1kiMy.default)(offsetParent) === "html" || (0, $1kiMy.default)(offsetParent) === "body" && (0, $2Ib3u.default)(offsetParent).position === "static")) return window;
    return offsetParent || $b16dc7f6a8cdadb3$var$getContainingBlock(element) || window;
}

});
parcelRegister("1kiMy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0f763a778cdfb4f7$export$2e2bcd8739ae039; });
function $0f763a778cdfb4f7$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || "").toLowerCase() : null;
}

});

parcelRegister("2Ib3u", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1f98442955c0287f$export$2e2bcd8739ae039; });

var $6TTa5 = parcelRequire("6TTa5");
function $1f98442955c0287f$export$2e2bcd8739ae039(element) {
    return (0, $6TTa5.default)(element).getComputedStyle(element);
}

});

parcelRegister("jKun1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e609df1e643ee305$export$2e2bcd8739ae039; });

var $1kiMy = parcelRequire("1kiMy");
function $e609df1e643ee305$export$2e2bcd8739ae039(element) {
    return [
        "table",
        "td",
        "th"
    ].indexOf((0, $1kiMy.default)(element)) >= 0;
}

});

parcelRegister("9MvYu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $71f1663d3b2ae7fc$export$2e2bcd8739ae039; });

var $1kiMy = parcelRequire("1kiMy");

var $7D7XN = parcelRequire("7D7XN");

var $58Qwv = parcelRequire("58Qwv");
function $71f1663d3b2ae7fc$export$2e2bcd8739ae039(element) {
    if ((0, $1kiMy.default)(element) === "html") return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $58Qwv.isShadowRoot)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $7D7XN.default)(element) // fallback
    );
}

});
parcelRegister("7D7XN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $58e25a4811883d5e$export$2e2bcd8739ae039; });

var $58Qwv = parcelRequire("58Qwv");
function $58e25a4811883d5e$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $58Qwv.isElement)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}

});



parcelRegister("bS91E", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8a4bbd2407e0bd00$export$2e2bcd8739ae039; });
function $8a4bbd2407e0bd00$export$2e2bcd8739ae039(placement) {
    return [
        "top",
        "bottom"
    ].indexOf(placement) >= 0 ? "x" : "y";
}

});

parcelRegister("czvfC", function(module, exports) {

$parcel$export(module.exports, "within", function () { return $9270feb2329bc5b0$export$f28d906d67a997f3; });
$parcel$export(module.exports, "withinMaxClamp", function () { return $9270feb2329bc5b0$export$86c8af6d3ef0b4a; });

var $dEzG4 = parcelRequire("dEzG4");
function $9270feb2329bc5b0$export$f28d906d67a997f3(min, value, max) {
    return (0, $dEzG4.max)(min, (0, $dEzG4.min)(value, max));
}
function $9270feb2329bc5b0$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $9270feb2329bc5b0$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}

});

parcelRegister("9z3Qe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6f6a5cc1e66b5e82$export$2e2bcd8739ae039; });

var $hCncA = parcelRequire("hCncA");
function $6f6a5cc1e66b5e82$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $hCncA.default)(), paddingObject);
}

});
parcelRegister("hCncA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cd37fbb3bc42b26b$export$2e2bcd8739ae039; });
function $cd37fbb3bc42b26b$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}

});


parcelRegister("4NkCO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $37dbbcbe71d27e14$export$2e2bcd8739ae039; });
function $37dbbcbe71d27e14$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}

});


parcelRegister("6yP7f", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4c6d919568662c13$export$2e2bcd8739ae039; });

var $d2T2o = parcelRequire("d2T2o");

var $ferRV = parcelRequire("ferRV");

var $6TTa5 = parcelRequire("6TTa5");

var $7D7XN = parcelRequire("7D7XN");

var $2Ib3u = parcelRequire("2Ib3u");

var $a98ZV = parcelRequire("a98ZV");

var $2wRyc = parcelRequire("2wRyc");

var $dEzG4 = parcelRequire("dEzG4");
var $4c6d919568662c13$var$unsetSides = {
    top: "auto",
    right: "auto",
    bottom: "auto",
    left: "auto"
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $4c6d919568662c13$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $dEzG4.round)(x * dpr) / dpr || 0,
        y: (0, $dEzG4.round)(y * dpr) / dpr || 0
    };
}
function $4c6d919568662c13$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === "function" ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty("x");
    var hasY = offsets.hasOwnProperty("y");
    var sideX = (0, $d2T2o.left);
    var sideY = (0, $d2T2o.top);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $ferRV.default)(popper);
        var heightProp = "clientHeight";
        var widthProp = "clientWidth";
        if (offsetParent === (0, $6TTa5.default)(popper)) {
            offsetParent = (0, $7D7XN.default)(popper);
            if ((0, $2Ib3u.default)(offsetParent).position !== "static" && position === "absolute") {
                heightProp = "scrollHeight";
                widthProp = "scrollWidth";
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $d2T2o.top) || (placement === (0, $d2T2o.left) || placement === (0, $d2T2o.right)) && variation === (0, $d2T2o.end)) {
            sideY = (0, $d2T2o.bottom);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $d2T2o.left) || (placement === (0, $d2T2o.top) || placement === (0, $d2T2o.bottom)) && variation === (0, $d2T2o.end)) {
            sideX = (0, $d2T2o.right);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $4c6d919568662c13$var$unsetSides);
    var _ref4 = roundOffsets === true ? $4c6d919568662c13$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $6TTa5.default)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? "0" : "", _Object$assign[sideX] = hasX ? "0" : "", _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : "", _Object$assign2[sideX] = hasX ? x + "px" : "", _Object$assign2.transform = "", _Object$assign2));
}
function $4c6d919568662c13$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $a98ZV.default)(state.placement),
        variation: (0, $2wRyc.default)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === "fixed"
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $4c6d919568662c13$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $4c6d919568662c13$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: "absolute",
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-placement": state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $4c6d919568662c13$export$2e2bcd8739ae039 = {
    name: "computeStyles",
    enabled: true,
    phase: "beforeWrite",
    fn: $4c6d919568662c13$var$computeStyles,
    data: {}
};

});
parcelRegister("2wRyc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1d781bfd78c28180$export$2e2bcd8739ae039; });
function $1d781bfd78c28180$export$2e2bcd8739ae039(placement) {
    return placement.split("-")[1];
}

});


parcelRegister("f63Hh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $afda48b4f33d0664$export$2e2bcd8739ae039; });

var $6TTa5 = parcelRequire("6TTa5");
var $afda48b4f33d0664$var$passive = {
    passive: true
};
function $afda48b4f33d0664$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $6TTa5.default)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener("scroll", instance.update, $afda48b4f33d0664$var$passive);
    });
    if (resize) window.addEventListener("resize", instance.update, $afda48b4f33d0664$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener("scroll", instance.update, $afda48b4f33d0664$var$passive);
        });
        if (resize) window.removeEventListener("resize", instance.update, $afda48b4f33d0664$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $afda48b4f33d0664$export$2e2bcd8739ae039 = {
    name: "eventListeners",
    enabled: true,
    phase: "write",
    fn: function fn() {},
    effect: $afda48b4f33d0664$var$effect,
    data: {}
};

});

parcelRegister("bgNku", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8347741fa45ac751$export$2e2bcd8739ae039; });

var $dbBDc = parcelRequire("dbBDc");

var $a98ZV = parcelRequire("a98ZV");

var $fPRet = parcelRequire("fPRet");

var $gEFKV = parcelRequire("gEFKV");

var $frI8X = parcelRequire("frI8X");

var $d2T2o = parcelRequire("d2T2o");

var $2wRyc = parcelRequire("2wRyc");
function $8347741fa45ac751$var$getExpandedFallbackPlacements(placement) {
    if ((0, $a98ZV.default)(placement) === (0, $d2T2o.auto)) return [];
    var oppositePlacement = (0, $dbBDc.default)(placement);
    return [
        (0, $fPRet.default)(placement),
        oppositePlacement,
        (0, $fPRet.default)(oppositePlacement)
    ];
}
function $8347741fa45ac751$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $a98ZV.default)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $dbBDc.default)(preferredPlacement)
    ] : $8347741fa45ac751$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $a98ZV.default)(placement) === (0, $d2T2o.auto) ? (0, $frI8X.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $a98ZV.default)(placement);
        var isStartVariation = (0, $2wRyc.default)(placement) === (0, $d2T2o.start);
        var isVertical = [
            (0, $d2T2o.top),
            (0, $d2T2o.bottom)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? "width" : "height";
        var overflow = (0, $gEFKV.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $d2T2o.right) : (0, $d2T2o.left) : isStartVariation ? (0, $d2T2o.bottom) : (0, $d2T2o.top);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $dbBDc.default)(mainVariationSide);
        var altVariationSide = (0, $dbBDc.default)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $8347741fa45ac751$export$2e2bcd8739ae039 = {
    name: "flip",
    enabled: true,
    phase: "main",
    fn: $8347741fa45ac751$var$flip,
    requiresIfExists: [
        "offset"
    ],
    data: {
        _skip: false
    }
};

});
parcelRegister("dbBDc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $99997e3aabfce6f4$export$2e2bcd8739ae039; });
var $99997e3aabfce6f4$var$hash = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
function $99997e3aabfce6f4$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $99997e3aabfce6f4$var$hash[matched];
    });
}

});

parcelRegister("fPRet", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b874e944140421a8$export$2e2bcd8739ae039; });
var $b874e944140421a8$var$hash = {
    start: "end",
    end: "start"
};
function $b874e944140421a8$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $b874e944140421a8$var$hash[matched];
    });
}

});

parcelRegister("gEFKV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c200c59b1c59e334$export$2e2bcd8739ae039; });

var $dFPka = parcelRequire("dFPka");

var $7D7XN = parcelRequire("7D7XN");

var $7LHdV = parcelRequire("7LHdV");

var $gstCb = parcelRequire("gstCb");

var $ldIhZ = parcelRequire("ldIhZ");

var $d2T2o = parcelRequire("d2T2o");

var $58Qwv = parcelRequire("58Qwv");

var $9z3Qe = parcelRequire("9z3Qe");

var $4NkCO = parcelRequire("4NkCO");
function $c200c59b1c59e334$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $d2T2o.clippingParents) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $d2T2o.viewport) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $d2T2o.popper) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $9z3Qe.default)(typeof padding !== "number" ? padding : (0, $4NkCO.default)(padding, (0, $d2T2o.basePlacements)));
    var altContext = elementContext === (0, $d2T2o.popper) ? (0, $d2T2o.reference) : (0, $d2T2o.popper);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $dFPka.default)((0, $58Qwv.isElement)(element) ? element : element.contextElement || (0, $7D7XN.default)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $7LHdV.default)(state.elements.reference);
    var popperOffsets = (0, $gstCb.default)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: "absolute",
        placement: placement
    });
    var popperClientRect = (0, $ldIhZ.default)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $d2T2o.popper) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $d2T2o.popper) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $d2T2o.right),
                (0, $d2T2o.bottom)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $d2T2o.top),
                (0, $d2T2o.bottom)
            ].indexOf(key) >= 0 ? "y" : "x";
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}

});
parcelRegister("dFPka", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9f46eaa0437a5d7f$export$2e2bcd8739ae039; });

var $d2T2o = parcelRequire("d2T2o");

var $ahYfF = parcelRequire("ahYfF");

var $6Wb1F = parcelRequire("6Wb1F");

var $6L2NG = parcelRequire("6L2NG");

var $ferRV = parcelRequire("ferRV");

var $7D7XN = parcelRequire("7D7XN");

var $2Ib3u = parcelRequire("2Ib3u");

var $58Qwv = parcelRequire("58Qwv");

var $7LHdV = parcelRequire("7LHdV");

var $9MvYu = parcelRequire("9MvYu");

var $hjcJU = parcelRequire("hjcJU");

var $1kiMy = parcelRequire("1kiMy");

var $ldIhZ = parcelRequire("ldIhZ");

var $dEzG4 = parcelRequire("dEzG4");
function $9f46eaa0437a5d7f$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $7LHdV.default)(element, false, strategy === "fixed");
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $9f46eaa0437a5d7f$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $d2T2o.viewport) ? (0, $ldIhZ.default)((0, $ahYfF.default)(element, strategy)) : (0, $58Qwv.isElement)(clippingParent) ? $9f46eaa0437a5d7f$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $ldIhZ.default)((0, $6Wb1F.default)((0, $7D7XN.default)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $9f46eaa0437a5d7f$var$getClippingParents(element) {
    var clippingParents = (0, $6L2NG.default)((0, $9MvYu.default)(element));
    var canEscapeClipping = [
        "absolute",
        "fixed"
    ].indexOf((0, $2Ib3u.default)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $58Qwv.isHTMLElement)(element) ? (0, $ferRV.default)(element) : element;
    if (!(0, $58Qwv.isElement)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $58Qwv.isElement)(clippingParent) && (0, $hjcJU.default)(clippingParent, clipperElement) && (0, $1kiMy.default)(clippingParent) !== "body";
    });
} // Gets the maximum area that the element is visible in due to any number of
function $9f46eaa0437a5d7f$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === "clippingParents" ? $9f46eaa0437a5d7f$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $9f46eaa0437a5d7f$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $dEzG4.max)(rect.top, accRect.top);
        accRect.right = (0, $dEzG4.min)(rect.right, accRect.right);
        accRect.bottom = (0, $dEzG4.min)(rect.bottom, accRect.bottom);
        accRect.left = (0, $dEzG4.max)(rect.left, accRect.left);
        return accRect;
    }, $9f46eaa0437a5d7f$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}

});
parcelRegister("ahYfF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $77da3a9ff5c0c00a$export$2e2bcd8739ae039; });

var $6TTa5 = parcelRequire("6TTa5");

var $7D7XN = parcelRequire("7D7XN");

var $5vIv3 = parcelRequire("5vIv3");

var $bkw0z = parcelRequire("bkw0z");
function $77da3a9ff5c0c00a$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $6TTa5.default)(element);
    var html = (0, $7D7XN.default)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $bkw0z.default)();
        if (layoutViewport || !layoutViewport && strategy === "fixed") {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $5vIv3.default)(element),
        y: y
    };
}

});
parcelRegister("5vIv3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $40325dba5ebcfc53$export$2e2bcd8739ae039; });

var $7LHdV = parcelRequire("7LHdV");

var $7D7XN = parcelRequire("7D7XN");

var $031S4 = parcelRequire("031S4");
function $40325dba5ebcfc53$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $7LHdV.default)((0, $7D7XN.default)(element)).left + (0, $031S4.default)(element).scrollLeft;
}

});
parcelRegister("031S4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0091bb8083db7897$export$2e2bcd8739ae039; });

var $6TTa5 = parcelRequire("6TTa5");
function $0091bb8083db7897$export$2e2bcd8739ae039(node) {
    var win = (0, $6TTa5.default)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}

});



parcelRegister("6Wb1F", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $50d0b65a65510f94$export$2e2bcd8739ae039; });

var $7D7XN = parcelRequire("7D7XN");

var $2Ib3u = parcelRequire("2Ib3u");

var $5vIv3 = parcelRequire("5vIv3");

var $031S4 = parcelRequire("031S4");

var $dEzG4 = parcelRequire("dEzG4");
function $50d0b65a65510f94$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $7D7XN.default)(element);
    var winScroll = (0, $031S4.default)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $dEzG4.max)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $dEzG4.max)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $5vIv3.default)(element);
    var y = -winScroll.scrollTop;
    if ((0, $2Ib3u.default)(body || html).direction === "rtl") x += (0, $dEzG4.max)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}

});

parcelRegister("6L2NG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4eb94df7a2b1652b$export$2e2bcd8739ae039; });

var $01cxl = parcelRequire("01cxl");

var $9MvYu = parcelRequire("9MvYu");

var $6TTa5 = parcelRequire("6TTa5");

var $3cb7c = parcelRequire("3cb7c");
function $4eb94df7a2b1652b$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $01cxl.default)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $6TTa5.default)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $3cb7c.default)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($4eb94df7a2b1652b$export$2e2bcd8739ae039((0, $9MvYu.default)(target)));
}

});
parcelRegister("01cxl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0039d1aed561a14a$export$2e2bcd8739ae039; });

var $9MvYu = parcelRequire("9MvYu");

var $3cb7c = parcelRequire("3cb7c");

var $1kiMy = parcelRequire("1kiMy");

var $58Qwv = parcelRequire("58Qwv");
function $0039d1aed561a14a$export$2e2bcd8739ae039(node) {
    if ([
        "html",
        "body",
        "#document"
    ].indexOf((0, $1kiMy.default)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $58Qwv.isHTMLElement)(node) && (0, $3cb7c.default)(node)) return node;
    return $0039d1aed561a14a$export$2e2bcd8739ae039((0, $9MvYu.default)(node));
}

});
parcelRegister("3cb7c", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $253b1d530d9fc7c9$export$2e2bcd8739ae039; });

var $2Ib3u = parcelRequire("2Ib3u");
function $253b1d530d9fc7c9$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $2Ib3u.default)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}

});



parcelRegister("ldIhZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f72d2aca653c44b2$export$2e2bcd8739ae039; });
function $f72d2aca653c44b2$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}

});


parcelRegister("gstCb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bfb63bbfa459ee48$export$2e2bcd8739ae039; });

var $a98ZV = parcelRequire("a98ZV");

var $2wRyc = parcelRequire("2wRyc");

var $bS91E = parcelRequire("bS91E");

var $d2T2o = parcelRequire("d2T2o");
function $bfb63bbfa459ee48$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $a98ZV.default)(placement) : null;
    var variation = placement ? (0, $2wRyc.default)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $d2T2o.top:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $d2T2o.bottom:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $d2T2o.right:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $d2T2o.left:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $bS91E.default)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === "y" ? "height" : "width";
        switch(variation){
            case 0, $d2T2o.start:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $d2T2o.end:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}

});


parcelRegister("frI8X", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b3eb9ea1beb1c95a$export$2e2bcd8739ae039; });

var $2wRyc = parcelRequire("2wRyc");

var $d2T2o = parcelRequire("d2T2o");

var $gEFKV = parcelRequire("gEFKV");

var $a98ZV = parcelRequire("a98ZV");
function $b3eb9ea1beb1c95a$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $d2T2o.placements) : _options$allowedAutoP;
    var variation = (0, $2wRyc.default)(placement);
    var placements = variation ? flipVariations ? (0, $d2T2o.variationPlacements) : (0, $d2T2o.variationPlacements).filter(function(placement) {
        return (0, $2wRyc.default)(placement) === variation;
    }) : (0, $d2T2o.basePlacements);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $gEFKV.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $a98ZV.default)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}

});


parcelRegister("j3jMG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ddeda4e2671100b0$export$2e2bcd8739ae039; });

var $d2T2o = parcelRequire("d2T2o");

var $gEFKV = parcelRequire("gEFKV");
function $ddeda4e2671100b0$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $ddeda4e2671100b0$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $d2T2o.top),
        (0, $d2T2o.right),
        (0, $d2T2o.bottom),
        (0, $d2T2o.left)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $ddeda4e2671100b0$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $gEFKV.default)(state, {
        elementContext: "reference"
    });
    var popperAltOverflow = (0, $gEFKV.default)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $ddeda4e2671100b0$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $ddeda4e2671100b0$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $ddeda4e2671100b0$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $ddeda4e2671100b0$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-reference-hidden": isReferenceHidden,
        "data-popper-escaped": hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $ddeda4e2671100b0$export$2e2bcd8739ae039 = {
    name: "hide",
    enabled: true,
    phase: "main",
    requiresIfExists: [
        "preventOverflow"
    ],
    fn: $ddeda4e2671100b0$var$hide
};

});

parcelRegister("gXYWO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c5a16ef44d34e30a$export$2e2bcd8739ae039; });

var $a98ZV = parcelRequire("a98ZV");

var $d2T2o = parcelRequire("d2T2o");
function $c5a16ef44d34e30a$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $a98ZV.default)(placement);
    var invertDistance = [
        (0, $d2T2o.left),
        (0, $d2T2o.top)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === "function" ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $d2T2o.left),
        (0, $d2T2o.right)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $c5a16ef44d34e30a$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $d2T2o.placements).reduce(function(acc, placement) {
        acc[placement] = $c5a16ef44d34e30a$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $c5a16ef44d34e30a$export$2e2bcd8739ae039 = {
    name: "offset",
    enabled: true,
    phase: "main",
    requires: [
        "popperOffsets"
    ],
    fn: $c5a16ef44d34e30a$var$offset
};

});

parcelRegister("5CAqp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $417cc193dc0883b1$export$2e2bcd8739ae039; });

var $gstCb = parcelRequire("gstCb");
function $417cc193dc0883b1$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $gstCb.default)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: "absolute",
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $417cc193dc0883b1$export$2e2bcd8739ae039 = {
    name: "popperOffsets",
    enabled: true,
    phase: "read",
    fn: $417cc193dc0883b1$var$popperOffsets,
    data: {}
};

});

parcelRegister("919wP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $690b99350124879d$export$2e2bcd8739ae039; });

var $d2T2o = parcelRequire("d2T2o");

var $a98ZV = parcelRequire("a98ZV");

var $bS91E = parcelRequire("bS91E");

var $1eQu3 = parcelRequire("1eQu3");

var $czvfC = parcelRequire("czvfC");

var $iaeAc = parcelRequire("iaeAc");

var $ferRV = parcelRequire("ferRV");

var $gEFKV = parcelRequire("gEFKV");

var $2wRyc = parcelRequire("2wRyc");

var $hCncA = parcelRequire("hCncA");

var $dEzG4 = parcelRequire("dEzG4");
function $690b99350124879d$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $gEFKV.default)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $a98ZV.default)(state.placement);
    var variation = (0, $2wRyc.default)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $bS91E.default)(basePlacement);
    var altAxis = (0, $1eQu3.default)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === "function" ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === "number" ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === "y" ? (0, $d2T2o.top) : (0, $d2T2o.left);
        var altSide = mainAxis === "y" ? (0, $d2T2o.bottom) : (0, $d2T2o.right);
        var len = mainAxis === "y" ? "height" : "width";
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $d2T2o.start) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $d2T2o.start) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $iaeAc.default)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData["arrow#persistent"] ? state.modifiersData["arrow#persistent"].padding : (0, $hCncA.default)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $czvfC.within)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $ferRV.default)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === "y" ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $czvfC.within)(tether ? (0, $dEzG4.min)(min, tetherMin) : min, offset, tether ? (0, $dEzG4.max)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === "x" ? (0, $d2T2o.top) : (0, $d2T2o.left);
        var _altSide = mainAxis === "x" ? (0, $d2T2o.bottom) : (0, $d2T2o.right);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === "y" ? "height" : "width";
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $d2T2o.top),
            (0, $d2T2o.left)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $czvfC.withinMaxClamp)(_tetherMin, _offset, _tetherMax) : (0, $czvfC.within)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $690b99350124879d$export$2e2bcd8739ae039 = {
    name: "preventOverflow",
    enabled: true,
    phase: "main",
    fn: $690b99350124879d$var$preventOverflow,
    requiresIfExists: [
        "offset"
    ]
};

});
parcelRegister("1eQu3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0e6fcf6842904e1b$export$2e2bcd8739ae039; });
function $0e6fcf6842904e1b$export$2e2bcd8739ae039(axis) {
    return axis === "x" ? "y" : "x";
}

});


parcelRegister("1dXwT", function(module, exports) {

$parcel$export(module.exports, "popperGenerator", function () { return $0e452eaeef801f41$export$ed5e13716264f202; });

var $3Lz9a = parcelRequire("3Lz9a");

var $iaeAc = parcelRequire("iaeAc");

var $6L2NG = parcelRequire("6L2NG");

var $ferRV = parcelRequire("ferRV");

var $aTD1P = parcelRequire("aTD1P");

var $GmSWC = parcelRequire("GmSWC");

var $kOwWT = parcelRequire("kOwWT");


var $58Qwv = parcelRequire("58Qwv");
var $0e452eaeef801f41$var$DEFAULT_OPTIONS = {
    placement: "bottom",
    modifiers: [],
    strategy: "absolute"
};
function $0e452eaeef801f41$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === "function");
    });
}
function $0e452eaeef801f41$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $0e452eaeef801f41$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: "bottom",
            orderedModifiers: [],
            options: Object.assign({}, $0e452eaeef801f41$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === "function" ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $58Qwv.isElement)(reference) ? (0, $6L2NG.default)(reference) : reference.contextElement ? (0, $6L2NG.default)(reference.contextElement) : [],
                    popper: (0, $6L2NG.default)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $aTD1P.default)((0, $kOwWT.default)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$0e452eaeef801f41$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $3Lz9a.default)(reference, (0, $ferRV.default)(popper), state.options.strategy === "fixed"),
                    popper: (0, $iaeAc.default)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === "function") state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $GmSWC.default)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$0e452eaeef801f41$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === "function") {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $0e452eaeef801f41$export$8f7491d57c8f97a9 = /*#__PURE__*/ $0e452eaeef801f41$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("3Lz9a", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2be1064b9c8a4d4e$export$2e2bcd8739ae039; });

var $7LHdV = parcelRequire("7LHdV");

var $kOhUS = parcelRequire("kOhUS");

var $1kiMy = parcelRequire("1kiMy");

var $58Qwv = parcelRequire("58Qwv");

var $5vIv3 = parcelRequire("5vIv3");

var $7D7XN = parcelRequire("7D7XN");

var $3cb7c = parcelRequire("3cb7c");

var $dEzG4 = parcelRequire("dEzG4");
function $2be1064b9c8a4d4e$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $dEzG4.round)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $dEzG4.round)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $2be1064b9c8a4d4e$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $58Qwv.isHTMLElement)(offsetParent);
    var offsetParentIsScaled = (0, $58Qwv.isHTMLElement)(offsetParent) && $2be1064b9c8a4d4e$var$isElementScaled(offsetParent);
    var documentElement = (0, $7D7XN.default)(offsetParent);
    var rect = (0, $7LHdV.default)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $1kiMy.default)(offsetParent) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
        (0, $3cb7c.default)(documentElement)) scroll = (0, $kOhUS.default)(offsetParent);
        if ((0, $58Qwv.isHTMLElement)(offsetParent)) {
            offsets = (0, $7LHdV.default)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $5vIv3.default)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}

});
parcelRegister("kOhUS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f2665ffdcfb247eb$export$2e2bcd8739ae039; });

var $031S4 = parcelRequire("031S4");

var $6TTa5 = parcelRequire("6TTa5");

var $58Qwv = parcelRequire("58Qwv");

var $2Hb3X = parcelRequire("2Hb3X");
function $f2665ffdcfb247eb$export$2e2bcd8739ae039(node) {
    if (node === (0, $6TTa5.default)(node) || !(0, $58Qwv.isHTMLElement)(node)) return (0, $031S4.default)(node);
    else return (0, $2Hb3X.default)(node);
}

});
parcelRegister("2Hb3X", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1f682dc8f3467c95$export$2e2bcd8739ae039; });
function $1f682dc8f3467c95$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}

});



parcelRegister("aTD1P", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $020c15f23ea3ef06$export$2e2bcd8739ae039; });

var $d2T2o = parcelRequire("d2T2o");
function $020c15f23ea3ef06$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $020c15f23ea3ef06$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $020c15f23ea3ef06$var$order(modifiers); // order based on phase
    return (0, $d2T2o.modifierPhases).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}

});

parcelRegister("GmSWC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $07f5ace1f6980bf8$export$2e2bcd8739ae039; });
function $07f5ace1f6980bf8$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}

});

parcelRegister("kOwWT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f2720922427b522a$export$2e2bcd8739ae039; });
function $f2720922427b522a$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}

});




parcelRegister("1xBVt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $11f64ad8eb11c439$export$2e2bcd8739ae039; });

var $4yFOi = parcelRequire("4yFOi");

var $insCM = parcelRequire("insCM");

var $eeH7J = parcelRequire("eeH7J");

var $jw1K9 = parcelRequire("jw1K9");

var $bVrkV = parcelRequire("bVrkV");

var $37Z19 = parcelRequire("37Z19");
var $11f64ad8eb11c439$var$escapeKeyCode = 27;
var $11f64ad8eb11c439$var$noop = function noop() {};
function $11f64ad8eb11c439$var$isLeftClickEvent(event) {
    return event.button === 0;
}
function $11f64ad8eb11c439$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
var $11f64ad8eb11c439$var$getRefTarget = function getRefTarget(ref) {
    return ref && ("current" in ref ? ref.current : ref);
};
/**
 * The `useRootClose` hook registers your callback on the document
 * when rendered. Powers the `<Overlay/>` component. This is used achieve modal
 * style behavior where your callback is triggered when the user tries to
 * interact with the rest of the document or hits the `esc` key.
 *
 * @param {Ref<HTMLElement>| HTMLElement} ref  The element boundary
 * @param {function} onRootClose
 * @param {object=}  options
 * @param {boolean=} options.disabled
 * @param {string=}  options.clickTrigger The DOM event name (click, mousedown, etc) to attach listeners on
 */ function $11f64ad8eb11c439$var$useRootClose(ref, onRootClose, _temp) {
    var _ref = _temp === void 0 ? {} : _temp, disabled = _ref.disabled, _ref$clickTrigger = _ref.clickTrigger, clickTrigger = _ref$clickTrigger === void 0 ? "click" : _ref$clickTrigger;
    var preventMouseRootCloseRef = (0, $eeH7J.useRef)(false);
    var onClose = onRootClose || $11f64ad8eb11c439$var$noop;
    var handleMouseCapture = (0, $eeH7J.useCallback)(function(e) {
        var _e$composedPath$;
        var currentTarget = $11f64ad8eb11c439$var$getRefTarget(ref);
        (0, (/*@__PURE__*/$parcel$interopDefault($bVrkV)))(!!currentTarget, "RootClose captured a close event but does not have a ref to compare it to. useRootClose(), should be passed a ref that resolves to a DOM node");
        preventMouseRootCloseRef.current = !currentTarget || $11f64ad8eb11c439$var$isModifiedEvent(e) || !$11f64ad8eb11c439$var$isLeftClickEvent(e) || !!(0, $4yFOi.default)(currentTarget, (_e$composedPath$ = e.composedPath == null ? void 0 : e.composedPath()[0]) != null ? _e$composedPath$ : e.target);
    }, [
        ref
    ]);
    var handleMouse = (0, $jw1K9.default)(function(e) {
        if (!preventMouseRootCloseRef.current) onClose(e);
    });
    var handleKeyUp = (0, $jw1K9.default)(function(e) {
        if (e.keyCode === $11f64ad8eb11c439$var$escapeKeyCode) onClose(e);
    });
    (0, $eeH7J.useEffect)(function() {
        if (disabled || ref == null) return undefined; // Store the current event to avoid triggering handlers immediately
        // https://github.com/facebook/react/issues/20074
        var currentEvent = window.event;
        var doc = (0, $37Z19.default)($11f64ad8eb11c439$var$getRefTarget(ref)); // Use capture for this listener so it fires before React's listener, to
        // avoid false positives in the contains() check below if the target DOM
        // element is removed in the React mouse callback.
        var removeMouseCaptureListener = (0, $insCM.default)(doc, clickTrigger, handleMouseCapture, true);
        var removeMouseListener = (0, $insCM.default)(doc, clickTrigger, function(e) {
            // skip if this event is the same as the one running when we added the handlers
            if (e === currentEvent) {
                currentEvent = undefined;
                return;
            }
            handleMouse(e);
        });
        var removeKeyupListener = (0, $insCM.default)(doc, "keyup", function(e) {
            // skip if this event is the same as the one running when we added the handlers
            if (e === currentEvent) {
                currentEvent = undefined;
                return;
            }
            handleKeyUp(e);
        });
        var mobileSafariHackListeners = [];
        if ("ontouchstart" in doc.documentElement) mobileSafariHackListeners = [].slice.call(doc.body.children).map(function(el) {
            return (0, $insCM.default)(el, "mousemove", $11f64ad8eb11c439$var$noop);
        });
        return function() {
            removeMouseCaptureListener();
            removeMouseListener();
            removeKeyupListener();
            mobileSafariHackListeners.forEach(function(remove) {
                return remove();
            });
        };
    }, [
        ref,
        disabled,
        clickTrigger,
        handleMouseCapture,
        handleMouse,
        handleKeyUp
    ]);
}
var $11f64ad8eb11c439$export$2e2bcd8739ae039 = $11f64ad8eb11c439$var$useRootClose;

});
parcelRegister("4yFOi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $351ac50e48019a88$export$2e2bcd8739ae039; });
/* eslint-disable no-bitwise, no-cond-assign */ /**
 * Checks if an element contains another given element.
 * 
 * @param context the context element
 * @param node the element to check
 */ function $351ac50e48019a88$export$2e2bcd8739ae039(context, node) {
    // HTML DOM and SVG DOM may have different support levels,
    // so we need to check on context instead of a document root element.
    if (context.contains) return context.contains(node);
    if (context.compareDocumentPosition) return context === node || !!(context.compareDocumentPosition(node) & 16);
}

});

parcelRegister("insCM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d61094350546bb71$export$2e2bcd8739ae039; });

var $4EL4i = parcelRequire("4EL4i");

var $hDfEg = parcelRequire("hDfEg");
function $d61094350546bb71$var$listen(node, eventName, handler, options) {
    (0, $4EL4i.default)(node, eventName, handler, options);
    return function() {
        (0, $hDfEg.default)(node, eventName, handler, options);
    };
}
var $d61094350546bb71$export$2e2bcd8739ae039 = $d61094350546bb71$var$listen;

});
parcelRegister("4EL4i", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $363f68a8cb702929$export$2e2bcd8739ae039; });
/* eslint-disable no-return-assign */ 
var $jRSSO = parcelRequire("jRSSO");
var $363f68a8cb702929$export$63fefd044b2bc624 = false;
var $363f68a8cb702929$export$a614c6b395900f69 = false;
try {
    var $363f68a8cb702929$var$options = {
        get passive () {
            return $363f68a8cb702929$export$63fefd044b2bc624 = true;
        },
        get once () {
            // eslint-disable-next-line no-multi-assign
            return $363f68a8cb702929$export$a614c6b395900f69 = $363f68a8cb702929$export$63fefd044b2bc624 = true;
        }
    };
    if (0, $jRSSO.default) {
        window.addEventListener("test", $363f68a8cb702929$var$options, $363f68a8cb702929$var$options);
        window.removeEventListener("test", $363f68a8cb702929$var$options, true);
    }
} catch (e) {
/* */ }
/**
 * An `addEventListener` ponyfill, supports the `once` option
 * 
 * @param node the element
 * @param eventName the event name
 * @param handle the handler
 * @param options event options
 */ function $363f68a8cb702929$var$addEventListener(node, eventName, handler, options) {
    if (options && typeof options !== "boolean" && !$363f68a8cb702929$export$a614c6b395900f69) {
        var once = options.once, capture = options.capture;
        var wrappedHandler = handler;
        if (!$363f68a8cb702929$export$a614c6b395900f69 && once) {
            wrappedHandler = handler.__once || function onceHandler(event) {
                this.removeEventListener(eventName, onceHandler, capture);
                handler.call(this, event);
            };
            handler.__once = wrappedHandler;
        }
        node.addEventListener(eventName, wrappedHandler, $363f68a8cb702929$export$63fefd044b2bc624 ? options : capture);
    }
    node.addEventListener(eventName, handler, options);
}
var $363f68a8cb702929$export$2e2bcd8739ae039 = $363f68a8cb702929$var$addEventListener;

});
parcelRegister("jRSSO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e76d8a2e01758481$export$2e2bcd8739ae039; });
var $e76d8a2e01758481$export$2e2bcd8739ae039 = !!(typeof window !== "undefined" && window.document && window.document.createElement);

});


parcelRegister("hDfEg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cd6237a4b7546442$export$2e2bcd8739ae039; });
/**
 * A `removeEventListener` ponyfill
 * 
 * @param node the element
 * @param eventName the event name
 * @param handle the handler
 * @param options event options
 */ function $cd6237a4b7546442$var$removeEventListener(node, eventName, handler, options) {
    var capture = options && typeof options !== "boolean" ? options.capture : options;
    node.removeEventListener(eventName, handler, capture);
    if (handler.__once) node.removeEventListener(eventName, handler.__once, capture);
}
var $cd6237a4b7546442$export$2e2bcd8739ae039 = $cd6237a4b7546442$var$removeEventListener;

});


parcelRegister("jw1K9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e3525ba9bbcddb4f$export$2e2bcd8739ae039; });

var $eeH7J = parcelRequire("eeH7J");

var $8fyfJ = parcelRequire("8fyfJ");
function $e3525ba9bbcddb4f$export$2e2bcd8739ae039(fn) {
    const ref = (0, $8fyfJ.default)(fn);
    return (0, $eeH7J.useCallback)(function(...args) {
        return ref.current && ref.current(...args);
    }, [
        ref
    ]);
}

});
parcelRegister("8fyfJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $601a4b53b1c202fc$export$2e2bcd8739ae039; });

var $eeH7J = parcelRequire("eeH7J");
/**
 * Creates a `Ref` whose value is updated in an effect, ensuring the most recent
 * value is the one rendered with. Generally only required for Concurrent mode usage
 * where previous work in `render()` may be discarded before being used.
 *
 * This is safe to access in an event handler.
 *
 * @param value The `Ref` value
 */ function $601a4b53b1c202fc$var$useCommittedRef(value) {
    const ref = (0, $eeH7J.useRef)(value);
    (0, $eeH7J.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref;
}
var $601a4b53b1c202fc$export$2e2bcd8739ae039 = $601a4b53b1c202fc$var$useCommittedRef;

});


parcelRegister("bVrkV", function(module, exports) {
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */ var $8aea3910c4b32633$var$__DEV__ = false;
var $8aea3910c4b32633$var$warning = function() {};
if ($8aea3910c4b32633$var$__DEV__) {
    var $8aea3910c4b32633$var$printWarning = function printWarning(format, args) {
        var len = arguments.length;
        args = new Array(len > 1 ? len - 1 : 0);
        for(var key = 1; key < len; key++)args[key - 1] = arguments[key];
        var argIndex = 0;
        var message = "Warning: " + format.replace(/%s/g, function() {
            return args[argIndex++];
        });
        if (typeof console !== "undefined") console.error(message);
        try {
            // --- Welcome to debugging React ---
            // This error was thrown as a convenience so that you can use this stack
            // to find the callsite that caused this warning to fire.
            throw new Error(message);
        } catch (x) {}
    };
    $8aea3910c4b32633$var$warning = function(condition, format, args) {
        var len = arguments.length;
        args = new Array(len > 2 ? len - 2 : 0);
        for(var key = 2; key < len; key++)args[key - 2] = arguments[key];
        if (format === undefined) throw new Error("`warning(condition, format, ...args)` requires a warning message argument");
        if (!condition) $8aea3910c4b32633$var$printWarning.apply(null, [
            format
        ].concat(args));
    };
}
module.exports = $8aea3910c4b32633$var$warning;

});

parcelRegister("37Z19", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $24715b5e7821742f$export$2e2bcd8739ae039; });

var $84cPa = parcelRequire("84cPa");

var $fP80V = parcelRequire("fP80V");
var $24715b5e7821742f$export$2e2bcd8739ae039 = function(componentOrElement) {
    return (0, $84cPa.default)((0, $fP80V.default)(componentOrElement));
};

});
parcelRegister("84cPa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5df8a51b8ef3525e$export$2e2bcd8739ae039; });
/**
 * Returns the owner document of a given element.
 * 
 * @param node the element
 */ function $5df8a51b8ef3525e$export$2e2bcd8739ae039(node) {
    return node && node.ownerDocument || document;
}

});

parcelRegister("fP80V", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b851d5d1240cd882$export$2e2bcd8739ae039; });

var $iMJCh = parcelRequire("iMJCh");
function $b851d5d1240cd882$export$2e2bcd8739ae039(componentOrElement) {
    if (componentOrElement && "setState" in componentOrElement) return (0, (/*@__PURE__*/$parcel$interopDefault($iMJCh))).findDOMNode(componentOrElement);
    return componentOrElement != null ? componentOrElement : null;
}

});



parcelRegister("7EllR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $591cd4d58e0d9c64$export$2e2bcd8739ae039; });

var $84cPa = parcelRequire("84cPa");

var $eeH7J = parcelRequire("eeH7J");
var $591cd4d58e0d9c64$export$c91fd81e6d65f84a = function resolveContainerRef(ref) {
    var _ref;
    if (typeof document === "undefined") return null;
    if (ref == null) return (0, $84cPa.default)().body;
    if (typeof ref === "function") ref = ref();
    if (ref && "current" in ref) ref = ref.current;
    if ((_ref = ref) != null && _ref.nodeType) return ref || null;
    return null;
};
function $591cd4d58e0d9c64$export$2e2bcd8739ae039(ref, onResolved) {
    var _useState = (0, $eeH7J.useState)(function() {
        return $591cd4d58e0d9c64$export$c91fd81e6d65f84a(ref);
    }), resolvedRef = _useState[0], setRef = _useState[1];
    if (!resolvedRef) {
        var earlyRef = $591cd4d58e0d9c64$export$c91fd81e6d65f84a(ref);
        if (earlyRef) setRef(earlyRef);
    }
    (0, $eeH7J.useEffect)(function() {
        if (onResolved && resolvedRef) onResolved(resolvedRef);
    }, [
        onResolved,
        resolvedRef
    ]);
    (0, $eeH7J.useEffect)(function() {
        var nextRef = $591cd4d58e0d9c64$export$c91fd81e6d65f84a(ref);
        if (nextRef !== resolvedRef) setRef(nextRef);
    }, [
        ref,
        resolvedRef
    ]);
    return resolvedRef;
}

});

parcelRegister("9Wxjw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $73d35f4b00b17fc6$export$2e2bcd8739ae039; });

var $h4XE0 = parcelRequire("h4XE0");
function $73d35f4b00b17fc6$export$ba6dad097c8f5c38(modifiers) {
    var result = {};
    if (!Array.isArray(modifiers)) return modifiers || result;
     // eslint-disable-next-line no-unused-expressions
    modifiers == null || modifiers.forEach(function(m) {
        result[m.name] = m;
    });
    return result;
}
function $73d35f4b00b17fc6$export$af3a999d4a134c86(map) {
    if (map === void 0) map = {};
    if (Array.isArray(map)) return map;
    return Object.keys(map).map(function(k) {
        map[k].name = k;
        return map[k];
    });
}
function $73d35f4b00b17fc6$export$2e2bcd8739ae039(_ref) {
    var _modifiers$preventOve, _modifiers$preventOve2, _modifiers$offset, _modifiers$arrow;
    var enabled = _ref.enabled, enableEvents = _ref.enableEvents, placement = _ref.placement, flip = _ref.flip, offset = _ref.offset, fixed = _ref.fixed, containerPadding = _ref.containerPadding, arrowElement = _ref.arrowElement, _ref$popperConfig = _ref.popperConfig, popperConfig = _ref$popperConfig === void 0 ? {} : _ref$popperConfig;
    var modifiers = $73d35f4b00b17fc6$export$ba6dad097c8f5c38(popperConfig.modifiers);
    return (0, $h4XE0.default)({}, popperConfig, {
        placement: placement,
        enabled: enabled,
        strategy: fixed ? "fixed" : popperConfig.strategy,
        modifiers: $73d35f4b00b17fc6$export$af3a999d4a134c86((0, $h4XE0.default)({}, modifiers, {
            eventListeners: {
                enabled: enableEvents
            },
            preventOverflow: (0, $h4XE0.default)({}, modifiers.preventOverflow, {
                options: containerPadding ? (0, $h4XE0.default)({
                    padding: containerPadding
                }, (_modifiers$preventOve = modifiers.preventOverflow) == null ? void 0 : _modifiers$preventOve.options) : (_modifiers$preventOve2 = modifiers.preventOverflow) == null ? void 0 : _modifiers$preventOve2.options
            }),
            offset: {
                options: (0, $h4XE0.default)({
                    offset: offset
                }, (_modifiers$offset = modifiers.offset) == null ? void 0 : _modifiers$offset.options)
            },
            arrow: (0, $h4XE0.default)({}, modifiers.arrow, {
                enabled: !!arrowElement,
                options: (0, $h4XE0.default)({}, (_modifiers$arrow = modifiers.arrow) == null ? void 0 : _modifiers$arrow.options, {
                    element: arrowElement
                })
            }),
            flip: (0, $h4XE0.default)({
                enabled: !!flip
            }, modifiers.flip)
        }))
    });
}

});


parcelRegister("ezE35", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a9c3666bc8130731$export$2e2bcd8739ae039; });

var $eeH7J = parcelRequire("eeH7J");

var $8fwbf = parcelRequire("8fwbf");

var $57SUk = parcelRequire("57SUk");
function $a9c3666bc8130731$var$getMargins(element) {
    var styles = window.getComputedStyle(element);
    var top = parseFloat(styles.marginTop) || 0;
    var right = parseFloat(styles.marginRight) || 0;
    var bottom = parseFloat(styles.marginBottom) || 0;
    var left = parseFloat(styles.marginLeft) || 0;
    return {
        top: top,
        right: right,
        bottom: bottom,
        left: left
    };
}
function $a9c3666bc8130731$export$2e2bcd8739ae039() {
    var overlayRef = (0, $eeH7J.useRef)(null);
    var margins = (0, $eeH7J.useRef)(null);
    var arrowMargins = (0, $eeH7J.useRef)(null);
    var popoverClass = (0, $57SUk.useBootstrapPrefix)(undefined, "popover");
    var dropdownMenuClass = (0, $57SUk.useBootstrapPrefix)(undefined, "dropdown-menu");
    var callback = (0, $eeH7J.useCallback)(function(overlay) {
        if (!overlay || !((0, $8fwbf.default)(overlay, popoverClass) || (0, $8fwbf.default)(overlay, dropdownMenuClass))) return;
        margins.current = $a9c3666bc8130731$var$getMargins(overlay);
        overlay.style.margin = "0";
        overlayRef.current = overlay;
    }, [
        popoverClass,
        dropdownMenuClass
    ]);
    var offset = (0, $eeH7J.useMemo)(function() {
        return {
            name: "offset",
            options: {
                offset: function offset(_ref) {
                    var placement = _ref.placement;
                    if (!margins.current) return [
                        0,
                        0
                    ];
                    var _margins$current = margins.current, top = _margins$current.top, left = _margins$current.left, bottom = _margins$current.bottom, right = _margins$current.right;
                    switch(placement.split("-")[0]){
                        case "top":
                            return [
                                0,
                                bottom
                            ];
                        case "left":
                            return [
                                0,
                                right
                            ];
                        case "bottom":
                            return [
                                0,
                                top
                            ];
                        case "right":
                            return [
                                0,
                                left
                            ];
                        default:
                            return [
                                0,
                                0
                            ];
                    }
                }
            }
        };
    }, [
        margins
    ]);
    var arrow = (0, $eeH7J.useMemo)(function() {
        return {
            name: "arrow",
            options: {
                padding: function padding() {
                    // The options here are used for Popper 2.8.4 and up.
                    // For earlier version, padding is handled in popoverArrowMargins below.
                    if (!arrowMargins.current) return 0;
                    var _arrowMargins$current = arrowMargins.current, top = _arrowMargins$current.top, right = _arrowMargins$current.right;
                    var padding = top || right;
                    return {
                        top: padding,
                        left: padding,
                        right: padding,
                        bottom: padding
                    };
                }
            }
        };
    }, [
        arrowMargins
    ]); // Converts popover arrow margin to arrow modifier padding
    var popoverArrowMargins = (0, $eeH7J.useMemo)(function() {
        return {
            name: "popoverArrowMargins",
            enabled: true,
            phase: "main",
            fn: function fn() {
                return undefined;
            },
            requiresIfExists: [
                "arrow"
            ],
            effect: function effect(_ref2) {
                var state = _ref2.state;
                if (!overlayRef.current || !state.elements.arrow || !(0, $8fwbf.default)(overlayRef.current, popoverClass)) return undefined;
                if (state.modifiersData["arrow#persistent"]) {
                    // @popperjs/core <= 2.8.3 uses arrow#persistent to pass padding to arrow modifier.
                    var _getMargins = $a9c3666bc8130731$var$getMargins(state.elements.arrow), top = _getMargins.top, right = _getMargins.right;
                    var padding = top || right;
                    state.modifiersData["arrow#persistent"].padding = {
                        top: padding,
                        left: padding,
                        right: padding,
                        bottom: padding
                    };
                } else // @popperjs/core >= 2.8.4 gets the padding from the arrow modifier options,
                // so we'll get the margins here, and let the arrow modifier above pass
                // it to popper.
                arrowMargins.current = $a9c3666bc8130731$var$getMargins(state.elements.arrow);
                state.elements.arrow.style.margin = "0";
                return function() {
                    if (state.elements.arrow) state.elements.arrow.style.margin = "";
                };
            }
        };
    }, [
        popoverClass
    ]);
    return [
        callback,
        [
            offset,
            arrow,
            popoverArrowMargins
        ]
    ];
}

});
parcelRegister("8fwbf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6018afd3224e0a55$export$2e2bcd8739ae039; });
/**
 * Checks if a given element has a CSS class.
 * 
 * @param element the element
 * @param className the CSS class name
 */ function $6018afd3224e0a55$export$2e2bcd8739ae039(element, className) {
    if (element.classList) return !!className && element.classList.contains(className);
    return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}

});

parcelRegister("57SUk", function(module, exports) {

$parcel$export(module.exports, "useBootstrapPrefix", function () { return $3bb832a98a20d43f$export$7f387860ebffb32c; });

var $h4XE0 = parcelRequire("h4XE0");

var $eeH7J = parcelRequire("eeH7J");
var $3bb832a98a20d43f$var$ThemeContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createContext({});
var $3bb832a98a20d43f$export$b631efc24e9d5e2f = $3bb832a98a20d43f$var$ThemeContext.Consumer, $3bb832a98a20d43f$var$Provider = $3bb832a98a20d43f$var$ThemeContext.Provider;
function $3bb832a98a20d43f$var$ThemeProvider(_ref) {
    var prefixes = _ref.prefixes, children = _ref.children;
    var copiedPrefixes = (0, $eeH7J.useMemo)(function() {
        return (0, $h4XE0.default)({}, prefixes);
    }, [
        prefixes
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement($3bb832a98a20d43f$var$Provider, {
        value: copiedPrefixes
    }, children);
}
function $3bb832a98a20d43f$export$7f387860ebffb32c(prefix, defaultPrefix) {
    var prefixes = (0, $eeH7J.useContext)($3bb832a98a20d43f$var$ThemeContext);
    return prefix || prefixes[defaultPrefix] || defaultPrefix;
}
function $3bb832a98a20d43f$export$ce75053c20498f85(Component, opts) {
    if (typeof opts === "string") opts = {
        prefix: opts
    };
    var isClassy = Component.prototype && Component.prototype.isReactComponent; // If it's a functional component make sure we don't break it with a ref
    var _opts = opts, prefix = _opts.prefix, _opts$forwardRefAs = _opts.forwardRefAs, forwardRefAs = _opts$forwardRefAs === void 0 ? isClassy ? "ref" : "innerRef" : _opts$forwardRefAs;
    var Wrapped = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).forwardRef(function(_ref2, ref) {
        var props = (0, $h4XE0.default)({}, _ref2);
        props[forwardRefAs] = ref;
        var bsPrefix = $3bb832a98a20d43f$export$7f387860ebffb32c(props.bsPrefix, prefix);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement(Component, (0, $h4XE0.default)({}, props, {
            bsPrefix: bsPrefix
        }));
    });
    Wrapped.displayName = "Bootstrap(" + (Component.displayName || Component.name) + ")";
    return Wrapped;
}
var $3bb832a98a20d43f$export$2e2bcd8739ae039 = $3bb832a98a20d43f$var$ThemeProvider;

});


parcelRegister("4NnQi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $37de3ba95f4cd307$export$2e2bcd8739ae039; });

var $h4XE0 = parcelRequire("h4XE0");

var $fbOaB = parcelRequire("fbOaB");

var $aienp = parcelRequire("aienp");

var $eeH7J = parcelRequire("eeH7J");

var $dgdSM = parcelRequire("dgdSM");

var $kYTG4 = parcelRequire("kYTG4");

var $u31lg = parcelRequire("u31lg");
var $37de3ba95f4cd307$var$_excluded = [
    "className",
    "children"
];
var $37de3ba95f4cd307$var$_fadeStyles;
var $37de3ba95f4cd307$var$defaultProps = {
    in: false,
    timeout: 300,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false
};
var $37de3ba95f4cd307$var$fadeStyles = ($37de3ba95f4cd307$var$_fadeStyles = {}, $37de3ba95f4cd307$var$_fadeStyles[0, $dgdSM.ENTERING] = "show", $37de3ba95f4cd307$var$_fadeStyles[0, $dgdSM.ENTERED] = "show", $37de3ba95f4cd307$var$_fadeStyles);
var $37de3ba95f4cd307$var$Fade = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).forwardRef(function(_ref, ref) {
    var className = _ref.className, children = _ref.children, props = (0, $fbOaB.default)(_ref, $37de3ba95f4cd307$var$_excluded);
    var handleEnter = (0, $eeH7J.useCallback)(function(node) {
        (0, $u31lg.default)(node);
        if (props.onEnter) props.onEnter(node);
    }, [
        props
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $dgdSM.default), (0, $h4XE0.default)({
        ref: ref,
        addEndListener: (0, $kYTG4.default)
    }, props, {
        onEnter: handleEnter
    }), function(status, innerProps) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).cloneElement(children, (0, $h4XE0.default)({}, innerProps, {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($aienp)))("fade", className, children.props.className, $37de3ba95f4cd307$var$fadeStyles[status])
        }));
    });
});
$37de3ba95f4cd307$var$Fade.defaultProps = $37de3ba95f4cd307$var$defaultProps;
$37de3ba95f4cd307$var$Fade.displayName = "Fade";
var $37de3ba95f4cd307$export$2e2bcd8739ae039 = $37de3ba95f4cd307$var$Fade;

});
parcelRegister("dgdSM", function(module, exports) {

$parcel$export(module.exports, "EXITED", function () { return $9a7789c95be58aaf$export$84cbff306f539230; });
$parcel$export(module.exports, "ENTERING", function () { return $9a7789c95be58aaf$export$df38205c966be359; });
$parcel$export(module.exports, "ENTERED", function () { return $9a7789c95be58aaf$export$78e9e6e3e014d60a; });
$parcel$export(module.exports, "EXITING", function () { return $9a7789c95be58aaf$export$4aacc83d4d59139f; });
$parcel$export(module.exports, "default", function () { return $9a7789c95be58aaf$export$2e2bcd8739ae039; });

var $fbOaB = parcelRequire("fbOaB");

var $ltdWF = parcelRequire("ltdWF");


var $eeH7J = parcelRequire("eeH7J");

var $iMJCh = parcelRequire("iMJCh");

var $dCkbE = parcelRequire("dCkbE");


var $kABMZ = parcelRequire("kABMZ");

var $gzx7L = parcelRequire("gzx7L");
var $9a7789c95be58aaf$export$bb38bb9a1161268 = "unmounted";
var $9a7789c95be58aaf$export$84cbff306f539230 = "exited";
var $9a7789c95be58aaf$export$df38205c966be359 = "entering";
var $9a7789c95be58aaf$export$78e9e6e3e014d60a = "entered";
var $9a7789c95be58aaf$export$4aacc83d4d59139f = "exiting";
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ var $9a7789c95be58aaf$var$Transition = /*#__PURE__*/ function(_React$Component) {
    (0, $ltdWF.default)(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = $9a7789c95be58aaf$export$84cbff306f539230;
                _this.appearStatus = $9a7789c95be58aaf$export$df38205c966be359;
            } else initialStatus = $9a7789c95be58aaf$export$78e9e6e3e014d60a;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = $9a7789c95be58aaf$export$bb38bb9a1161268;
        else initialStatus = $9a7789c95be58aaf$export$84cbff306f539230;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === $9a7789c95be58aaf$export$bb38bb9a1161268) return {
            status: $9a7789c95be58aaf$export$84cbff306f539230
        };
        return null;
    } // getSnapshotBeforeUpdate(prevProps) {
    ;
    var _proto = Transition.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== $9a7789c95be58aaf$export$df38205c966be359 && status !== $9a7789c95be58aaf$export$78e9e6e3e014d60a) nextStatus = $9a7789c95be58aaf$export$df38205c966be359;
            } else if (status === $9a7789c95be58aaf$export$df38205c966be359 || status === $9a7789c95be58aaf$export$78e9e6e3e014d60a) nextStatus = $9a7789c95be58aaf$export$4aacc83d4d59139f;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== "number") {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            if (nextStatus === $9a7789c95be58aaf$export$df38205c966be359) {
                if (this.props.unmountOnExit || this.props.mountOnEnter) {
                    var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($iMJCh))).findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
                    // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
                    // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.
                    if (node) (0, $gzx7L.forceReflow)(node);
                }
                this.performEnter(mounting);
            } else this.performExit();
        } else if (this.props.unmountOnExit && this.state.status === $9a7789c95be58aaf$export$84cbff306f539230) this.setState({
            status: $9a7789c95be58aaf$export$bb38bb9a1161268
        });
    };
    _proto.performEnter = function performEnter(mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context ? this.context.isMounting : mounting;
        var _ref2 = this.props.nodeRef ? [
            appearing
        ] : [
            (0, (/*@__PURE__*/$parcel$interopDefault($iMJCh))).findDOMNode(this),
            appearing
        ], maybeNode = _ref2[0], maybeAppearing = _ref2[1];
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter || (0, $dCkbE.default).disabled) {
            this.safeSetState({
                status: $9a7789c95be58aaf$export$78e9e6e3e014d60a
            }, function() {
                _this2.props.onEntered(maybeNode);
            });
            return;
        }
        this.props.onEnter(maybeNode, maybeAppearing);
        this.safeSetState({
            status: $9a7789c95be58aaf$export$df38205c966be359
        }, function() {
            _this2.props.onEntering(maybeNode, maybeAppearing);
            _this2.onTransitionEnd(enterTimeout, function() {
                _this2.safeSetState({
                    status: $9a7789c95be58aaf$export$78e9e6e3e014d60a
                }, function() {
                    _this2.props.onEntered(maybeNode, maybeAppearing);
                });
            });
        });
    };
    _proto.performExit = function performExit() {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts();
        var maybeNode = this.props.nodeRef ? undefined : (0, (/*@__PURE__*/$parcel$interopDefault($iMJCh))).findDOMNode(this); // no exit animation skip right to EXITED
        if (!exit || (0, $dCkbE.default).disabled) {
            this.safeSetState({
                status: $9a7789c95be58aaf$export$84cbff306f539230
            }, function() {
                _this3.props.onExited(maybeNode);
            });
            return;
        }
        this.props.onExit(maybeNode);
        this.safeSetState({
            status: $9a7789c95be58aaf$export$4aacc83d4d59139f
        }, function() {
            _this3.props.onExiting(maybeNode);
            _this3.onTransitionEnd(timeouts.exit, function() {
                _this3.safeSetState({
                    status: $9a7789c95be58aaf$export$84cbff306f539230
                }, function() {
                    _this3.props.onExited(maybeNode);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
        this.setNextCallback(handler);
        var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($iMJCh))).findDOMNode(this);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) {
            var _ref3 = this.props.nodeRef ? [
                this.nextCallback
            ] : [
                node,
                this.nextCallback
            ], maybeNode = _ref3[0], maybeNextCallback = _ref3[1];
            this.props.addEndListener(maybeNode, maybeNextCallback);
        }
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === $9a7789c95be58aaf$export$bb38bb9a1161268) return null;
        var _this$props = this.props, children = _this$props.children, _in = _this$props.in, _mountOnEnter = _this$props.mountOnEnter, _unmountOnExit = _this$props.unmountOnExit, _appear = _this$props.appear, _enter = _this$props.enter, _exit = _this$props.exit, _timeout = _this$props.timeout, _addEndListener = _this$props.addEndListener, _onEnter = _this$props.onEnter, _onEntering = _this$props.onEntering, _onEntered = _this$props.onEntered, _onExit = _this$props.onExit, _onExiting = _this$props.onExiting, _onExited = _this$props.onExited, _nodeRef = _this$props.nodeRef, childProps = (0, $fbOaB.default)(_this$props, [
            "children",
            "in",
            "mountOnEnter",
            "unmountOnExit",
            "appear",
            "enter",
            "exit",
            "timeout",
            "addEndListener",
            "onEnter",
            "onEntering",
            "onEntered",
            "onExit",
            "onExiting",
            "onExited",
            "nodeRef"
        ]);
        return(/*#__PURE__*/ // allows for nested Transitions
        (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $kABMZ.default).Provider, {
            value: null
        }, typeof children === "function" ? children(status, childProps) : (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).Children.only(children), childProps)));
    };
    return Transition;
}((0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).Component);
$9a7789c95be58aaf$var$Transition.contextType = (0, $kABMZ.default);
$9a7789c95be58aaf$var$Transition.propTypes = {}; // Name the function so it is clearer in the documentation
function $9a7789c95be58aaf$var$noop() {}
$9a7789c95be58aaf$var$Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: $9a7789c95be58aaf$var$noop,
    onEntering: $9a7789c95be58aaf$var$noop,
    onEntered: $9a7789c95be58aaf$var$noop,
    onExit: $9a7789c95be58aaf$var$noop,
    onExiting: $9a7789c95be58aaf$var$noop,
    onExited: $9a7789c95be58aaf$var$noop
};
$9a7789c95be58aaf$var$Transition.UNMOUNTED = $9a7789c95be58aaf$export$bb38bb9a1161268;
$9a7789c95be58aaf$var$Transition.EXITED = $9a7789c95be58aaf$export$84cbff306f539230;
$9a7789c95be58aaf$var$Transition.ENTERING = $9a7789c95be58aaf$export$df38205c966be359;
$9a7789c95be58aaf$var$Transition.ENTERED = $9a7789c95be58aaf$export$78e9e6e3e014d60a;
$9a7789c95be58aaf$var$Transition.EXITING = $9a7789c95be58aaf$export$4aacc83d4d59139f;
var $9a7789c95be58aaf$export$2e2bcd8739ae039 = $9a7789c95be58aaf$var$Transition;

});
parcelRegister("ltdWF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fa171fa37ae5504e$export$2e2bcd8739ae039; });

var $1SHDq = parcelRequire("1SHDq");
function $fa171fa37ae5504e$export$2e2bcd8739ae039(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0, $1SHDq.default)(t, o);
}

});
parcelRegister("1SHDq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $15ecae95fe777e95$export$2e2bcd8739ae039; });
function $15ecae95fe777e95$export$2e2bcd8739ae039(t, e) {
    return $15ecae95fe777e95$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $15ecae95fe777e95$export$2e2bcd8739ae039(t, e);
}

});


parcelRegister("dCkbE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9e9e7bae783ed0bd$export$2e2bcd8739ae039; });
var $9e9e7bae783ed0bd$export$2e2bcd8739ae039 = {
    disabled: false
};

});

parcelRegister("kABMZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $efd47b99065a7704$export$2e2bcd8739ae039; });

var $eeH7J = parcelRequire("eeH7J");
var $efd47b99065a7704$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createContext(null);

});

parcelRegister("gzx7L", function(module, exports) {

$parcel$export(module.exports, "forceReflow", function () { return $c1099c01480d60c0$export$7d26bbb1236dafd6; });
var $c1099c01480d60c0$export$7d26bbb1236dafd6 = function forceReflow(node) {
    return node.scrollTop;
};

});


parcelRegister("kYTG4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f46499abb6168b12$export$2e2bcd8739ae039; });

var $5u0qA = parcelRequire("5u0qA");

var $ljFof = parcelRequire("ljFof");
function $f46499abb6168b12$var$parseDuration(node, property) {
    var str = (0, $5u0qA.default)(node, property) || "";
    var mult = str.indexOf("ms") === -1 ? 1000 : 1;
    return parseFloat(str) * mult;
}
function $f46499abb6168b12$export$2e2bcd8739ae039(element, handler) {
    var duration = $f46499abb6168b12$var$parseDuration(element, "transitionDuration");
    var delay = $f46499abb6168b12$var$parseDuration(element, "transitionDelay");
    var remove = (0, $ljFof.default)(element, function(e) {
        if (e.target === element) {
            remove();
            handler(e);
        }
    }, duration + delay);
}

});
parcelRegister("5u0qA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3fe01611bb49f91e$export$2e2bcd8739ae039; });

var $2Sp6S = parcelRequire("2Sp6S");

var $4Sp77 = parcelRequire("4Sp77");

var $ht0jY = parcelRequire("ht0jY");
function $3fe01611bb49f91e$var$style(node, property) {
    var css = "";
    var transforms = "";
    if (typeof property === "string") return node.style.getPropertyValue((0, $4Sp77.default)(property)) || (0, $2Sp6S.default)(node).getPropertyValue((0, $4Sp77.default)(property));
    Object.keys(property).forEach(function(key) {
        var value = property[key];
        if (!value && value !== 0) node.style.removeProperty((0, $4Sp77.default)(key));
        else if ((0, $ht0jY.default)(key)) transforms += key + "(" + value + ") ";
        else css += (0, $4Sp77.default)(key) + ": " + value + ";";
    });
    if (transforms) css += "transform: " + transforms + ";";
    node.style.cssText += ";" + css;
}
var $3fe01611bb49f91e$export$2e2bcd8739ae039 = $3fe01611bb49f91e$var$style;

});
parcelRegister("2Sp6S", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $21841a3c38daf6fb$export$2e2bcd8739ae039; });

var $6lE56 = parcelRequire("6lE56");
function $21841a3c38daf6fb$export$2e2bcd8739ae039(node, psuedoElement) {
    return (0, $6lE56.default)(node).getComputedStyle(node, psuedoElement);
}

});
parcelRegister("6lE56", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $49f3cb8b52c700bb$export$2e2bcd8739ae039; });

var $84cPa = parcelRequire("84cPa");
function $49f3cb8b52c700bb$export$2e2bcd8739ae039(node) {
    var doc = (0, $84cPa.default)(node);
    return doc && doc.defaultView || window;
}

});


parcelRegister("4Sp77", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $38cfafa288feede8$export$2e2bcd8739ae039; });
/**
 * Copyright 2013-2014, Facebook, Inc.
 * All rights reserved.
 * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/hyphenateStyleName.js
 */ 
var $dFJJa = parcelRequire("dFJJa");
var $38cfafa288feede8$var$msPattern = /^ms-/;
function $38cfafa288feede8$export$2e2bcd8739ae039(string) {
    return (0, $dFJJa.default)(string).replace($38cfafa288feede8$var$msPattern, "-ms-");
}

});
parcelRegister("dFJJa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9f4293402fe8d4ea$export$2e2bcd8739ae039; });
var $9f4293402fe8d4ea$var$rUpper = /([A-Z])/g;
function $9f4293402fe8d4ea$export$2e2bcd8739ae039(string) {
    return string.replace($9f4293402fe8d4ea$var$rUpper, "-$1").toLowerCase();
}

});


parcelRegister("ht0jY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cb7564e3206732b8$export$2e2bcd8739ae039; });
var $cb7564e3206732b8$var$supportedTransforms = /^((translate|rotate|scale)(X|Y|Z|3d)?|matrix(3d)?|perspective|skew(X|Y)?)$/i;
function $cb7564e3206732b8$export$2e2bcd8739ae039(value) {
    return !!(value && $cb7564e3206732b8$var$supportedTransforms.test(value));
}

});


parcelRegister("ljFof", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f84b7a8775eb2c4a$export$2e2bcd8739ae039; });

var $5u0qA = parcelRequire("5u0qA");

var $insCM = parcelRequire("insCM");

var $faZXm = parcelRequire("faZXm");
function $f84b7a8775eb2c4a$var$parseDuration(node) {
    var str = (0, $5u0qA.default)(node, "transitionDuration") || "";
    var mult = str.indexOf("ms") === -1 ? 1000 : 1;
    return parseFloat(str) * mult;
}
function $f84b7a8775eb2c4a$var$emulateTransitionEnd(element, duration, padding) {
    if (padding === void 0) padding = 5;
    var called = false;
    var handle = setTimeout(function() {
        if (!called) (0, $faZXm.default)(element, "transitionend", true);
    }, duration + padding);
    var remove = (0, $insCM.default)(element, "transitionend", function() {
        called = true;
    }, {
        once: true
    });
    return function() {
        clearTimeout(handle);
        remove();
    };
}
function $f84b7a8775eb2c4a$export$2e2bcd8739ae039(element, handler, duration, padding) {
    if (duration == null) duration = $f84b7a8775eb2c4a$var$parseDuration(element) || 0;
    var removeEmulate = $f84b7a8775eb2c4a$var$emulateTransitionEnd(element, duration, padding);
    var remove = (0, $insCM.default)(element, "transitionend", handler);
    return function() {
        removeEmulate();
        remove();
    };
}

});
parcelRegister("faZXm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b0c7d97643588a9e$export$2e2bcd8739ae039; });
/**
 * Triggers an event on a given element.
 * 
 * @param node the element
 * @param eventName the event name to trigger
 * @param bubbles whether the event should bubble up
 * @param cancelable whether the event should be cancelable
 */ function $b0c7d97643588a9e$export$2e2bcd8739ae039(node, eventName, bubbles, cancelable) {
    if (bubbles === void 0) bubbles = false;
    if (cancelable === void 0) cancelable = true;
    if (node) {
        var event = document.createEvent("HTMLEvents");
        event.initEvent(eventName, bubbles, cancelable);
        node.dispatchEvent(event);
    }
}

});



parcelRegister("u31lg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $05a5254b267ceee7$export$2e2bcd8739ae039; });
// reading a dimension prop will cause the browser to recalculate,
// which will let our animations work
function $05a5254b267ceee7$export$2e2bcd8739ae039(node) {
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    node.offsetHeight;
}

});



parcelRegister("1rVia", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $10e4c1119a20bf51$export$2e2bcd8739ae039; });

var $h4XE0 = parcelRequire("h4XE0");

var $fbOaB = parcelRequire("fbOaB");

var $aienp = parcelRequire("aienp");

var $eeH7J = parcelRequire("eeH7J");

var $57SUk = parcelRequire("57SUk");
var $10e4c1119a20bf51$var$_excluded = [
    "bsPrefix",
    "variant",
    "animation",
    "size",
    "children",
    "as",
    "className"
];
var $10e4c1119a20bf51$var$Spinner = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).forwardRef(function(_ref, ref) {
    var bsPrefix = _ref.bsPrefix, variant = _ref.variant, animation = _ref.animation, size = _ref.size, children = _ref.children, _ref$as = _ref.as, Component = _ref$as === void 0 ? "div" : _ref$as, className = _ref.className, props = (0, $fbOaB.default)(_ref, $10e4c1119a20bf51$var$_excluded);
    bsPrefix = (0, $57SUk.useBootstrapPrefix)(bsPrefix, "spinner");
    var bsSpinnerPrefix = bsPrefix + "-" + animation;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement(Component, (0, $h4XE0.default)({
        ref: ref
    }, props, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($aienp)))(className, bsSpinnerPrefix, size && bsSpinnerPrefix + "-" + size, variant && "text-" + variant)
    }), children);
});
$10e4c1119a20bf51$var$Spinner.displayName = "Spinner";
var $10e4c1119a20bf51$export$2e2bcd8739ae039 = $10e4c1119a20bf51$var$Spinner;

});

parcelRegister("gLzHS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c34cbbbca6dc5c29$export$2e2bcd8739ae039; });

var $h4XE0 = parcelRequire("h4XE0");

var $fbOaB = parcelRequire("fbOaB");

var $aienp = parcelRequire("aienp");

var $eeH7J = parcelRequire("eeH7J");
parcelRequire("eKizm");

var $57SUk = parcelRequire("57SUk");
var $c34cbbbca6dc5c29$var$_excluded = [
    "bsPrefix",
    "placement",
    "className",
    "style",
    "children",
    "arrowProps",
    "popper",
    "show"
];
var $c34cbbbca6dc5c29$var$defaultProps = {
    placement: "right"
};
var $c34cbbbca6dc5c29$var$Tooltip = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).forwardRef(function(_ref, ref) {
    var bsPrefix = _ref.bsPrefix, placement = _ref.placement, className = _ref.className, style = _ref.style, children = _ref.children, arrowProps = _ref.arrowProps, _ = _ref.popper, _2 = _ref.show, props = (0, $fbOaB.default)(_ref, $c34cbbbca6dc5c29$var$_excluded);
    bsPrefix = (0, $57SUk.useBootstrapPrefix)(bsPrefix, "tooltip");
    var _ref2 = (placement == null ? void 0 : placement.split("-")) || [], primaryPlacement = _ref2[0];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", (0, $h4XE0.default)({
        ref: ref,
        style: style,
        role: "tooltip",
        "x-placement": primaryPlacement,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($aienp)))(className, bsPrefix, "bs-tooltip-" + primaryPlacement)
    }, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", (0, $h4XE0.default)({
        className: "arrow"
    }, arrowProps)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        className: bsPrefix + "-inner"
    }, children));
});
$c34cbbbca6dc5c29$var$Tooltip.defaultProps = $c34cbbbca6dc5c29$var$defaultProps;
$c34cbbbca6dc5c29$var$Tooltip.displayName = "Tooltip";
var $c34cbbbca6dc5c29$export$2e2bcd8739ae039 = $c34cbbbca6dc5c29$var$Tooltip;

});
parcelRegister("eKizm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $abc3c40975986791$var$isRequiredForA11y;
function $abc3c40975986791$var$isRequiredForA11y(validator) {
    return function validate(props, propName, componentName, location, propFullName) {
        var componentNameSafe = componentName || "<<anonymous>>";
        var propFullNameSafe = propFullName || propName;
        if (props[propName] == null) return new Error("The " + location + " `" + propFullNameSafe + "` is required to make " + ("`" + componentNameSafe + "` accessible for users of assistive ") + "technologies such as screen readers.");
        for(var _len = arguments.length, args = Array(_len > 5 ? _len - 5 : 0), _key = 5; _key < _len; _key++)args[_key - 5] = arguments[_key];
        return validator.apply(undefined, [
            props,
            propName,
            componentName,
            location,
            propFullName
        ].concat(args));
    };
}
module.exports = module.exports["default"];

});


parcelRegister("fz3r9", function(module, exports) {

$parcel$export(module.exports, "useHover", function () { return $b54cca65c87cf2f5$export$ae780daf29e6d456; });

var $eeH7J = parcelRequire("eeH7J");
function $b54cca65c87cf2f5$export$ae780daf29e6d456() {
    const [hover, setHover] = (0, $eeH7J.useState)(false);
    return {
        hover: hover,
        setHover: setHover,
        hoverProps: {
            onMouseEnter () {
                setHover(true);
            },
            onMouseLeave () {
                setHover(false);
            }
        }
    };
}

});

parcelRegister("gaj8U", function(module, exports) {

$parcel$export(module.exports, "useDebounce", function () { return $bc4c6dd8bc02cf10$export$21805fee57372823; });
$parcel$export(module.exports, "useDebounceContent", function () { return $bc4c6dd8bc02cf10$export$3c99bec7f5d8d03c; });

var $eeH7J = parcelRequire("eeH7J");
function $bc4c6dd8bc02cf10$export$21805fee57372823(state /** How many milliseconds the signal must be idle before we fire. */ , milliseconds = 500, /** Whether the debounce is currently suspended. It will not fire until un-suspened. */ suspend = false, /**
 * The initial state to use before the first debounce. If not provided, the
 * initial state will be the same as the current state.
 */ initialState) {
    const [debounced, setDebounced] = (0, $eeH7J.useState)(initialState !== undefined ? initialState : state);
    (0, $eeH7J.useEffect)(()=>{
        if (suspend) return;
        const timeout = setTimeout(()=>setDebounced(state), milliseconds);
        return ()=>clearTimeout(timeout);
    }, [
        state,
        milliseconds,
        suspend
    ]);
    return debounced;
}
function $bc4c6dd8bc02cf10$export$3c99bec7f5d8d03c(object, /** How many milliseconds the signal must be idle before we fire. */ milliseconds = 500, /** Whether the debounce is currently suspended. It will not fire until un-suspened. */ suspend = false) {
    const str = JSON.stringify(object);
    const res = $bc4c6dd8bc02cf10$export$21805fee57372823(str, milliseconds, suspend);
    if (res === str) return object;
    else return JSON.parse(res);
}

});


parcelRegister("hRViu", function(module, exports) {

$parcel$export(module.exports, "PropRow", function () { return $d023d4f74148a597$export$6f0573f1c56899d7; });

var $4vwom = parcelRequire("4vwom");

var $eeH7J = parcelRequire("eeH7J");

var $f2yFo = parcelRequire("f2yFo");

var $cSf8f = parcelRequire("cSf8f");

var $fT6Pt = parcelRequire("fT6Pt");

var $eBaY3 = parcelRequire("eBaY3");

var $5eFGD = parcelRequire("5eFGD");

var $9Q5xE = parcelRequire("9Q5xE");

var $4SFVE = parcelRequire("4SFVE");
function $d023d4f74148a597$export$6f0573f1c56899d7({ children: children, label: label, buttons: buttons, badge: badge, description: descriptionLocalized, isEmbedded: isEmbedded, childrenInBadge: childrenInBadge, descriptionAbove: descriptionAbove, isReadonly: isReadonly }) {
    const readonlyContext = (0, $eeH7J.useContext)((0, $eBaY3.ReadonlyContext)).mode === "readonly";
    const contextButtons = (0, $5eFGD.RenderButtons)(buttons);
    const [showAll, setShowAll] = (0, $eeH7J.useState)(false);
    const description = (0, $cSf8f.ClientSideLocalize)(descriptionLocalized);
    let desc = null;
    if (description) {
        const d = description.split("\n");
        desc = (0, $4vwom.jsxs)("div", {
            style: {
                flexDirection: showAll ? undefined : "row",
                display: showAll ? undefined : "flex"
            },
            children: [
                (0, $4vwom.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($f2yFo))), {
                    children: showAll ? description : d[0]
                }),
                d.length > 1 ? (0, $4vwom.jsx)((0, $fT6Pt.RButton), {
                    onClick: ()=>setShowAll(!showAll),
                    style: {
                        fontSize: 12,
                        padding: 1,
                        paddingLeft: 4,
                        paddingRight: 4,
                        paddingTop: 0,
                        borderRadius: 4,
                        height: 20,
                        marginLeft: 4,
                        color: (0, $9Q5xE.ColorStyles).primary[500]
                    },
                    children: showAll ? (0, $cSf8f.Strings).Less : (0, $cSf8f.Strings).More
                }) : undefined
            ]
        });
    }
    return (0, $4vwom.jsx)("div", {
        style: {
            marginTop: isEmbedded ? undefined : "1rem",
            width: "100%"
        },
        children: (0, $4vwom.jsxs)("div", {
            style: {
                display: "flex",
                flexDirection: "column"
            },
            children: [
                (label || badge || childrenInBadge || contextButtons) && (0, $4vwom.jsxs)("div", {
                    style: {
                        display: "flex",
                        flexDirection: "row",
                        justifyItems: "center",
                        alignItems: "center",
                        marginBottom: label ? 6 : undefined,
                        marginTop: isEmbedded ? 0 : "0.35rem"
                    },
                    children: [
                        label && (0, $4vwom.jsx)("div", {
                            className: "reactor-form-label",
                            style: {
                                marginRight: "0.5rem",
                                color: (0, $9Q5xE.ColorStyles).gray[700],
                                display: "flex",
                                flexDirection: "row",
                                alignItems: "center",
                                maxWidth: 600
                            },
                            children: label
                        }),
                        isReadonly && !readonlyContext && !isEmbedded && (0, $4vwom.jsx)("i", {
                            title: `You are not allowed to modify this property. Contact an administrator to request access.`,
                            style: {
                                fontSize: 12,
                                color: "#ededed"
                            },
                            className: "fas fa-lock"
                        }),
                        (0, $4vwom.jsxs)("div", {
                            style: {
                                marginLeft: "0.5rem"
                            },
                            children: [
                                badge,
                                childrenInBadge && children
                            ]
                        }),
                        (0, $4vwom.jsx)("div", {
                            style: {
                                flex: 1
                            }
                        }),
                        contextButtons
                    ]
                }),
                descriptionAbove && description && (0, $4vwom.jsx)("div", {
                    className: "reactor-form-small-label",
                    style: {
                        color: (0, $9Q5xE.ColorStyles).gray[600],
                        marginLeft: 8
                    },
                    children: desc
                }),
                !childrenInBadge && (0, $4vwom.jsx)("div", {
                    style: {
                        display: "flex",
                        flex: 1,
                        flexDirection: "row",
                        width: "100%"
                    },
                    children: (0, $4vwom.jsx)((0, $4SFVE.ErrorBoundary), {
                        fallbackRender: ({ error: error })=>(0, $4vwom.jsxs)("div", {
                                style: {
                                    borderRadius: 8,
                                    padding: 16,
                                    backgroundColor: (0, $9Q5xE.ColorStyles).error[100],
                                    color: (0, $9Q5xE.ColorStyles).error[500]
                                },
                                children: [
                                    (0, $4vwom.jsx)("span", {
                                        style: {
                                            padding: 8
                                        },
                                        children: "\u274C"
                                    }),
                                    " There was an error rendering this property:",
                                    " ",
                                    "message" in error && typeof error.message === "string" ? error.message : JSON.stringify(Object.assign({}, error))
                                ]
                            }),
                        children: (0, $4vwom.jsx)("div", {
                            style: {
                                flex: 1
                            },
                            children: children
                        })
                    })
                }),
                !descriptionAbove && description && (0, $4vwom.jsx)("div", {
                    className: "reactor-form-small-label",
                    style: {
                        color: (0, $9Q5xE.ColorStyles).gray[600],
                        marginTop: 6,
                        marginLeft: 8
                    },
                    children: desc
                })
            ]
        })
    });
}

});
parcelRegister("f2yFo", function(module, exports) {
"use strict";

var $fv6YB = parcelRequire("fv6YB");

var $4uly0 = parcelRequire("4uly0");

var $bK6CN = parcelRequire("bK6CN");

var $4yBem = parcelRequire("4yBem");

var $dYNzc = parcelRequire("dYNzc");

var $kidYf = parcelRequire("kidYf");

var $ahrfr = parcelRequire("ahrfr");

var $2owNN = parcelRequire("2owNN");

var $9sKTW = parcelRequire("9sKTW");

var $6MxVG = parcelRequire("6MxVG");

var $g3q3g = parcelRequire("g3q3g");

var $k6xnT = parcelRequire("k6xnT");

var $28Nw1 = parcelRequire("28Nw1");
var $af31ef03bb71279c$var$allTypes = Object.keys($k6xnT);
var $af31ef03bb71279c$var$ReactMarkdown = function ReactMarkdown(props) {
    // To do in next major: remove `source`.
    var src = props.source || props.children || "";
    if (props.allowedTypes && props.disallowedTypes) throw new Error("Only one of `allowedTypes` and `disallowedTypes` should be defined");
    var renderers = $fv6YB($k6xnT, props.renderers);
    var processor = $4uly0().use($bK6CN).use(props.plugins || []); // eslint-disable-next-line no-sync
    var tree = processor.runSync(processor.parse(src));
    var renderProps = $fv6YB(props, {
        renderers: renderers,
        definitions: $6MxVG(tree)
    });
    $af31ef03bb71279c$var$determineAstToReactTransforms(props).forEach(function(transform) {
        tree = transform(tree, renderProps);
    });
    return tree;
};
function $af31ef03bb71279c$var$determineAstToReactTransforms(props) {
    var transforms = [
        $9sKTW,
        $dYNzc()
    ];
    var disallowedTypes = props.disallowedTypes;
    if (props.allowedTypes) disallowedTypes = $af31ef03bb71279c$var$allTypes.filter(function(type) {
        return type !== "root" && props.allowedTypes.indexOf(type) === -1;
    });
    var removalMethod = props.unwrapDisallowed ? "unwrap" : "remove";
    if (disallowedTypes && disallowedTypes.length > 0) transforms.push($ahrfr.ofType(disallowedTypes, removalMethod));
    if (props.allowNode) transforms.push($ahrfr.ifNotMatch(props.allowNode, removalMethod));
     // To do in next major: remove `escapeHtml`.
    var renderHtml = (props.allowDangerousHtml || props.escapeHtml === false) && !props.skipHtml;
    var hasHtmlParser = (props.astPlugins || []).some(function(transform) {
        return transform.identity === $28Nw1.HtmlParser;
    });
    if (renderHtml && !hasHtmlParser) transforms.push($kidYf);
    if (props.astPlugins) transforms = transforms.concat(props.astPlugins);
     // Add the final transform to turn everything into React.
    transforms.push($2owNN);
    return transforms;
}
$af31ef03bb71279c$var$ReactMarkdown.defaultProps = {
    transformLinkUri: $g3q3g
};
$af31ef03bb71279c$var$ReactMarkdown.propTypes = {
    className: $4yBem.string,
    source: $4yBem.string,
    children: $4yBem.string,
    sourcePos: $4yBem.bool,
    rawSourcePos: $4yBem.bool,
    escapeHtml: $4yBem.bool,
    allowDangerousHtml: $4yBem.bool,
    skipHtml: $4yBem.bool,
    allowNode: $4yBem.func,
    allowedTypes: $4yBem.arrayOf($4yBem.oneOf($af31ef03bb71279c$var$allTypes)),
    disallowedTypes: $4yBem.arrayOf($4yBem.oneOf($af31ef03bb71279c$var$allTypes)),
    transformLinkUri: $4yBem.oneOfType([
        $4yBem.func,
        $4yBem.bool
    ]),
    linkTarget: $4yBem.oneOfType([
        $4yBem.func,
        $4yBem.string
    ]),
    transformImageUri: $4yBem.func,
    astPlugins: $4yBem.arrayOf($4yBem.func),
    unwrapDisallowed: $4yBem.bool,
    renderers: $4yBem.object,
    plugins: $4yBem.array
};
$af31ef03bb71279c$var$ReactMarkdown.types = $af31ef03bb71279c$var$allTypes;
$af31ef03bb71279c$var$ReactMarkdown.renderers = $k6xnT;
$af31ef03bb71279c$var$ReactMarkdown.uriTransformer = $g3q3g;
module.exports = $af31ef03bb71279c$var$ReactMarkdown;

});
parcelRegister("fv6YB", function(module, exports) {
module.exports = $b48f299eee477116$var$extend;
var $b48f299eee477116$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $b48f299eee477116$var$extend() {
    var target = {};
    for(var i = 0; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if ($b48f299eee477116$var$hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
}

});

parcelRegister("4uly0", function(module, exports) {
"use strict";

var $flvVI = parcelRequire("flvVI");

var $Wt5Sk = parcelRequire("Wt5Sk");

var $3BIJi = parcelRequire("3BIJi");

var $djWjq = parcelRequire("djWjq");

var $e1oqg = parcelRequire("e1oqg");

var $bsyhs = parcelRequire("bsyhs");
// Expose a frozen processor.
module.exports = $344aada288b13f4a$var$unified().freeze();
var $344aada288b13f4a$var$slice = [].slice;
var $344aada288b13f4a$var$own = {}.hasOwnProperty;
// Process pipeline.
var $344aada288b13f4a$var$pipeline = $e1oqg().use($344aada288b13f4a$var$pipelineParse).use($344aada288b13f4a$var$pipelineRun).use($344aada288b13f4a$var$pipelineStringify);
function $344aada288b13f4a$var$pipelineParse(p, ctx) {
    ctx.tree = p.parse(ctx.file);
}
function $344aada288b13f4a$var$pipelineRun(p, ctx, next) {
    p.run(ctx.tree, ctx.file, done);
    function done(error, tree, file) {
        if (error) next(error);
        else {
            ctx.tree = tree;
            ctx.file = file;
            next();
        }
    }
}
function $344aada288b13f4a$var$pipelineStringify(p, ctx) {
    var result = p.stringify(ctx.tree, ctx.file);
    if (result === undefined || result === null) ;
    else if (typeof result === "string" || $Wt5Sk(result)) {
        if ("value" in ctx.file) ctx.file.value = result;
        ctx.file.contents = result;
    } else ctx.file.result = result;
}
// Function to create the first processor.
function $344aada288b13f4a$var$unified() {
    var attachers = [];
    var transformers = $e1oqg();
    var namespace = {};
    var freezeIndex = -1;
    var frozen;
    // Data management.
    processor.data = data;
    // Lock.
    processor.freeze = freeze;
    // Plugins.
    processor.attachers = attachers;
    processor.use = use;
    // API.
    processor.parse = parse;
    processor.stringify = stringify;
    processor.run = run;
    processor.runSync = runSync;
    processor.process = process;
    processor.processSync = processSync;
    // Expose.
    return processor;
    // Create a new processor based on the processor in the current scope.
    function processor() {
        var destination = $344aada288b13f4a$var$unified();
        var index = -1;
        while(++index < attachers.length)destination.use.apply(null, attachers[index]);
        destination.data($3BIJi(true, {}, namespace));
        return destination;
    }
    // Freeze: used to signal a processor that has finished configuration.
    //
    // For example, take unified itself: it’s frozen.
    // Plugins should not be added to it.
    // Rather, it should be extended, by invoking it, before modifying it.
    //
    // In essence, always invoke this when exporting a processor.
    function freeze() {
        var values;
        var transformer;
        if (frozen) return processor;
        while(++freezeIndex < attachers.length){
            values = attachers[freezeIndex];
            if (values[1] === false) continue;
            if (values[1] === true) values[1] = undefined;
            transformer = values[0].apply(processor, values.slice(1));
            if (typeof transformer === "function") transformers.use(transformer);
        }
        frozen = true;
        freezeIndex = Infinity;
        return processor;
    }
    // Data management.
    // Getter / setter for processor-specific informtion.
    function data(key, value) {
        if (typeof key === "string") {
            // Set `key`.
            if (arguments.length === 2) {
                $344aada288b13f4a$var$assertUnfrozen("data", frozen);
                namespace[key] = value;
                return processor;
            }
            // Get `key`.
            return $344aada288b13f4a$var$own.call(namespace, key) && namespace[key] || null;
        }
        // Set space.
        if (key) {
            $344aada288b13f4a$var$assertUnfrozen("data", frozen);
            namespace = key;
            return processor;
        }
        // Get space.
        return namespace;
    }
    // Plugin management.
    //
    // Pass it:
    // *   an attacher and options,
    // *   a preset,
    // *   a list of presets, attachers, and arguments (list of attachers and
    //     options).
    function use(value) {
        var settings;
        $344aada288b13f4a$var$assertUnfrozen("use", frozen);
        if (value === null || value === undefined) ;
        else if (typeof value === "function") addPlugin.apply(null, arguments);
        else if (typeof value === "object") {
            if ("length" in value) addList(value);
            else addPreset(value);
        } else throw new Error("Expected usable value, not `" + value + "`");
        if (settings) namespace.settings = $3BIJi(namespace.settings || {}, settings);
        return processor;
        function addPreset(result) {
            addList(result.plugins);
            if (result.settings) settings = $3BIJi(settings || {}, result.settings);
        }
        function add(value) {
            if (typeof value === "function") addPlugin(value);
            else if (typeof value === "object") {
                if ("length" in value) addPlugin.apply(null, value);
                else addPreset(value);
            } else throw new Error("Expected usable value, not `" + value + "`");
        }
        function addList(plugins) {
            var index = -1;
            if (plugins === null || plugins === undefined) ;
            else if (typeof plugins === "object" && "length" in plugins) while(++index < plugins.length)add(plugins[index]);
            else throw new Error("Expected a list of plugins, not `" + plugins + "`");
        }
        function addPlugin(plugin, value) {
            var entry = find(plugin);
            if (entry) {
                if ($djWjq(entry[1]) && $djWjq(value)) value = $3BIJi(true, entry[1], value);
                entry[1] = value;
            } else attachers.push($344aada288b13f4a$var$slice.call(arguments));
        }
    }
    function find(plugin) {
        var index = -1;
        while(++index < attachers.length){
            if (attachers[index][0] === plugin) return attachers[index];
        }
    }
    // Parse a file (in string or vfile representation) into a unist node using
    // the `Parser` on the processor.
    function parse(doc) {
        var file = $bsyhs(doc);
        var Parser;
        freeze();
        Parser = processor.Parser;
        $344aada288b13f4a$var$assertParser("parse", Parser);
        if ($344aada288b13f4a$var$newable(Parser, "parse")) return new Parser(String(file), file).parse();
        return Parser(String(file), file) // eslint-disable-line new-cap
        ;
    }
    // Run transforms on a unist node representation of a file (in string or
    // vfile representation), async.
    function run(node, file, cb) {
        $344aada288b13f4a$var$assertNode(node);
        freeze();
        if (!cb && typeof file === "function") {
            cb = file;
            file = null;
        }
        if (!cb) return new Promise(executor);
        executor(null, cb);
        function executor(resolve, reject) {
            transformers.run(node, $bsyhs(file), done);
            function done(error, tree, file) {
                tree = tree || node;
                if (error) reject(error);
                else if (resolve) resolve(tree);
                else cb(null, tree, file);
            }
        }
    }
    // Run transforms on a unist node representation of a file (in string or
    // vfile representation), sync.
    function runSync(node, file) {
        var result;
        var complete;
        run(node, file, done);
        $344aada288b13f4a$var$assertDone("runSync", "run", complete);
        return result;
        function done(error, tree) {
            complete = true;
            result = tree;
            $flvVI(error);
        }
    }
    // Stringify a unist node representation of a file (in string or vfile
    // representation) into a string using the `Compiler` on the processor.
    function stringify(node, doc) {
        var file = $bsyhs(doc);
        var Compiler;
        freeze();
        Compiler = processor.Compiler;
        $344aada288b13f4a$var$assertCompiler("stringify", Compiler);
        $344aada288b13f4a$var$assertNode(node);
        if ($344aada288b13f4a$var$newable(Compiler, "compile")) return new Compiler(node, file).compile();
        return Compiler(node, file) // eslint-disable-line new-cap
        ;
    }
    // Parse a file (in string or vfile representation) into a unist node using
    // the `Parser` on the processor, then run transforms on that node, and
    // compile the resulting node using the `Compiler` on the processor, and
    // store that result on the vfile.
    function process(doc, cb) {
        freeze();
        $344aada288b13f4a$var$assertParser("process", processor.Parser);
        $344aada288b13f4a$var$assertCompiler("process", processor.Compiler);
        if (!cb) return new Promise(executor);
        executor(null, cb);
        function executor(resolve, reject) {
            var file = $bsyhs(doc);
            $344aada288b13f4a$var$pipeline.run(processor, {
                file: file
            }, done);
            function done(error) {
                if (error) reject(error);
                else if (resolve) resolve(file);
                else cb(null, file);
            }
        }
    }
    // Process the given document (in string or vfile representation), sync.
    function processSync(doc) {
        var file;
        var complete;
        freeze();
        $344aada288b13f4a$var$assertParser("processSync", processor.Parser);
        $344aada288b13f4a$var$assertCompiler("processSync", processor.Compiler);
        file = $bsyhs(doc);
        process(file, done);
        $344aada288b13f4a$var$assertDone("processSync", "process", complete);
        return file;
        function done(error) {
            complete = true;
            $flvVI(error);
        }
    }
}
// Check if `value` is a constructor.
function $344aada288b13f4a$var$newable(value, name) {
    return typeof value === "function" && value.prototype && // A function with keys in its prototype is probably a constructor.
    // Classes’ prototype methods are not enumerable, so we check if some value
    // exists in the prototype.
    ($344aada288b13f4a$var$keys(value.prototype) || name in value.prototype);
}
// Check if `value` is an object with keys.
function $344aada288b13f4a$var$keys(value) {
    var key;
    for(key in value)return true;
    return false;
}
// Assert a parser is available.
function $344aada288b13f4a$var$assertParser(name, Parser) {
    if (typeof Parser !== "function") throw new Error("Cannot `" + name + "` without `Parser`");
}
// Assert a compiler is available.
function $344aada288b13f4a$var$assertCompiler(name, Compiler) {
    if (typeof Compiler !== "function") throw new Error("Cannot `" + name + "` without `Compiler`");
}
// Assert the processor is not frozen.
function $344aada288b13f4a$var$assertUnfrozen(name, frozen) {
    if (frozen) throw new Error("Cannot invoke `" + name + "` on a frozen processor.\nCreate a new processor first, by invoking it: use `processor()` instead of `processor`.");
}
// Assert `node` is a unist node.
function $344aada288b13f4a$var$assertNode(node) {
    if (!node || typeof node.type !== "string") throw new Error("Expected node, got `" + node + "`");
}
// Assert that `complete` is `true`.
function $344aada288b13f4a$var$assertDone(name, asyncName, complete) {
    if (!complete) throw new Error("`" + name + "` finished async. Use `" + asyncName + "` instead");
}

});
parcelRegister("flvVI", function(module, exports) {
"use strict";
module.exports = $b2c195c98fc342f1$var$bail;
function $b2c195c98fc342f1$var$bail(err) {
    if (err) throw err;
}

});

parcelRegister("Wt5Sk", function(module, exports) {
/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ module.exports = function isBuffer(obj) {
    return obj != null && obj.constructor != null && typeof obj.constructor.isBuffer === "function" && obj.constructor.isBuffer(obj);
};

});

parcelRegister("3BIJi", function(module, exports) {
"use strict";
var $2a07862fe96d60ca$var$hasOwn = Object.prototype.hasOwnProperty;
var $2a07862fe96d60ca$var$toStr = Object.prototype.toString;
var $2a07862fe96d60ca$var$defineProperty = Object.defineProperty;
var $2a07862fe96d60ca$var$gOPD = Object.getOwnPropertyDescriptor;
var $2a07862fe96d60ca$var$isArray = function isArray(arr) {
    if (typeof Array.isArray === "function") return Array.isArray(arr);
    return $2a07862fe96d60ca$var$toStr.call(arr) === "[object Array]";
};
var $2a07862fe96d60ca$var$isPlainObject = function isPlainObject(obj) {
    if (!obj || $2a07862fe96d60ca$var$toStr.call(obj) !== "[object Object]") return false;
    var hasOwnConstructor = $2a07862fe96d60ca$var$hasOwn.call(obj, "constructor");
    var hasIsPrototypeOf = obj.constructor && obj.constructor.prototype && $2a07862fe96d60ca$var$hasOwn.call(obj.constructor.prototype, "isPrototypeOf");
    // Not own constructor property must be Object
    if (obj.constructor && !hasOwnConstructor && !hasIsPrototypeOf) return false;
    // Own properties are enumerated firstly, so to speed up,
    // if last one is own, then all properties are own.
    var key;
    for(key in obj);
    return typeof key === "undefined" || $2a07862fe96d60ca$var$hasOwn.call(obj, key);
};
// If name is '__proto__', and Object.defineProperty is available, define __proto__ as an own property on target
var $2a07862fe96d60ca$var$setProperty = function setProperty(target, options) {
    if ($2a07862fe96d60ca$var$defineProperty && options.name === "__proto__") $2a07862fe96d60ca$var$defineProperty(target, options.name, {
        enumerable: true,
        configurable: true,
        value: options.newValue,
        writable: true
    });
    else target[options.name] = options.newValue;
};
// Return undefined instead of __proto__ if '__proto__' is not an own property
var $2a07862fe96d60ca$var$getProperty = function getProperty(obj, name) {
    if (name === "__proto__") {
        if (!$2a07862fe96d60ca$var$hasOwn.call(obj, name)) return void 0;
        else if ($2a07862fe96d60ca$var$gOPD) // In early versions of node, obj['__proto__'] is buggy when obj has
        // __proto__ as an own property. Object.getOwnPropertyDescriptor() works.
        return $2a07862fe96d60ca$var$gOPD(obj, name).value;
    }
    return obj[name];
};
module.exports = function extend() {
    var options, name, src, copy, copyIsArray, clone;
    var target = arguments[0];
    var i = 1;
    var length = arguments.length;
    var deep = false;
    // Handle a deep copy situation
    if (typeof target === "boolean") {
        deep = target;
        target = arguments[1] || {};
        // skip the boolean and the target
        i = 2;
    }
    if (target == null || typeof target !== "object" && typeof target !== "function") target = {};
    for(; i < length; ++i){
        options = arguments[i];
        // Only deal with non-null/undefined values
        if (options != null) // Extend the base object
        for(name in options){
            src = $2a07862fe96d60ca$var$getProperty(target, name);
            copy = $2a07862fe96d60ca$var$getProperty(options, name);
            // Prevent never-ending loop
            if (target !== copy) {
                // Recurse if we're merging plain objects or arrays
                if (deep && copy && ($2a07862fe96d60ca$var$isPlainObject(copy) || (copyIsArray = $2a07862fe96d60ca$var$isArray(copy)))) {
                    if (copyIsArray) {
                        copyIsArray = false;
                        clone = src && $2a07862fe96d60ca$var$isArray(src) ? src : [];
                    } else clone = src && $2a07862fe96d60ca$var$isPlainObject(src) ? src : {};
                    // Never move original objects, clone them
                    $2a07862fe96d60ca$var$setProperty(target, {
                        name: name,
                        newValue: extend(deep, clone, copy)
                    });
                // Don't bring in undefined values
                } else if (typeof copy !== "undefined") $2a07862fe96d60ca$var$setProperty(target, {
                    name: name,
                    newValue: copy
                });
            }
        }
    }
    // Return the modified object
    return target;
};

});

parcelRegister("djWjq", function(module, exports) {
"use strict";
module.exports = (value)=>{
    if (Object.prototype.toString.call(value) !== "[object Object]") return false;
    const prototype = Object.getPrototypeOf(value);
    return prototype === null || prototype === Object.prototype;
};

});

parcelRegister("e1oqg", function(module, exports) {
"use strict";

var $1ydmx = parcelRequire("1ydmx");
module.exports = $a3541a83587eb408$var$trough;
$a3541a83587eb408$var$trough.wrap = $1ydmx;
var $a3541a83587eb408$var$slice = [].slice;
// Create new middleware.
function $a3541a83587eb408$var$trough() {
    var fns = [];
    var middleware = {};
    middleware.run = run;
    middleware.use = use;
    return middleware;
    // Run `fns`.  Last argument must be a completion handler.
    function run() {
        var index = -1;
        var input = $a3541a83587eb408$var$slice.call(arguments, 0, -1);
        var done = arguments[arguments.length - 1];
        if (typeof done !== "function") throw new Error("Expected function as last argument, not " + done);
        next.apply(null, [
            null
        ].concat(input));
        // Run the next `fn`, if any.
        function next(err) {
            var fn = fns[++index];
            var params = $a3541a83587eb408$var$slice.call(arguments, 0);
            var values = params.slice(1);
            var length = input.length;
            var pos = -1;
            if (err) {
                done(err);
                return;
            }
            // Copy non-nully input into values.
            while(++pos < length)if (values[pos] === null || values[pos] === undefined) values[pos] = input[pos];
            input = values;
            // Next or done.
            if (fn) $1ydmx(fn, next).apply(null, input);
            else done.apply(null, [
                null
            ].concat(input));
        }
    }
    // Add `fn` to the list.
    function use(fn) {
        if (typeof fn !== "function") throw new Error("Expected `fn` to be a function, not " + fn);
        fns.push(fn);
        return middleware;
    }
}

});
parcelRegister("1ydmx", function(module, exports) {
"use strict";
var $121354f466b0e59e$var$slice = [].slice;
module.exports = $121354f466b0e59e$var$wrap;
// Wrap `fn`.
// Can be sync or async; return a promise, receive a completion handler, return
// new values and errors.
function $121354f466b0e59e$var$wrap(fn, callback) {
    var invoked;
    return wrapped;
    function wrapped() {
        var params = $121354f466b0e59e$var$slice.call(arguments, 0);
        var callback = fn.length > params.length;
        var result;
        if (callback) params.push(done);
        try {
            result = fn.apply(null, params);
        } catch (error) {
            // Well, this is quite the pickle.
            // `fn` received a callback and invoked it (thus continuing the pipeline),
            // but later also threw an error.
            // We’re not about to restart the pipeline again, so the only thing left
            // to do is to throw the thing instead.
            if (callback && invoked) throw error;
            return done(error);
        }
        if (!callback) {
            if (result && typeof result.then === "function") result.then(then, done);
            else if (result instanceof Error) done(result);
            else then(result);
        }
    }
    // Invoke `next`, only once.
    function done() {
        if (!invoked) {
            invoked = true;
            callback.apply(null, arguments);
        }
    }
    // Invoke `done` with one value.
    // Tracks if an error is passed, too.
    function then(value) {
        done(null, value);
    }
}

});


parcelRegister("bsyhs", function(module, exports) {
"use strict";

module.exports = (parcelRequire("lxTn2"));

});
parcelRegister("lxTn2", function(module, exports) {
"use strict";

var $ixGEn = parcelRequire("ixGEn");

var $gTpAy = parcelRequire("gTpAy");
module.exports = $gTpAy;
$gTpAy.prototype.message = $faf7a17e149609ff$var$message;
$gTpAy.prototype.info = $faf7a17e149609ff$var$info;
$gTpAy.prototype.fail = $faf7a17e149609ff$var$fail;
// Create a message with `reason` at `position`.
// When an error is passed in as `reason`, copies the stack.
function $faf7a17e149609ff$var$message(reason, position, origin) {
    var message = new $ixGEn(reason, position, origin);
    if (this.path) {
        message.name = this.path + ":" + message.name;
        message.file = this.path;
    }
    message.fatal = false;
    this.messages.push(message);
    return message;
}
// Fail: creates a vmessage, associates it with the file, and throws it.
function $faf7a17e149609ff$var$fail() {
    var message = this.message.apply(this, arguments);
    message.fatal = true;
    throw message;
}
// Info: creates a vmessage, associates it with the file, and marks the fatality
// as null.
function $faf7a17e149609ff$var$info() {
    var message = this.message.apply(this, arguments);
    message.fatal = null;
    return message;
}

});
parcelRegister("ixGEn", function(module, exports) {
"use strict";

var $fQtvf = parcelRequire("fQtvf");
module.exports = $d7fc64844594b76b$var$VMessage;
// Inherit from `Error#`.
function $d7fc64844594b76b$var$VMessagePrototype() {}
$d7fc64844594b76b$var$VMessagePrototype.prototype = Error.prototype;
$d7fc64844594b76b$var$VMessage.prototype = new $d7fc64844594b76b$var$VMessagePrototype();
// Message properties.
var $d7fc64844594b76b$var$proto = $d7fc64844594b76b$var$VMessage.prototype;
$d7fc64844594b76b$var$proto.file = "";
$d7fc64844594b76b$var$proto.name = "";
$d7fc64844594b76b$var$proto.reason = "";
$d7fc64844594b76b$var$proto.message = "";
$d7fc64844594b76b$var$proto.stack = "";
$d7fc64844594b76b$var$proto.fatal = null;
$d7fc64844594b76b$var$proto.column = null;
$d7fc64844594b76b$var$proto.line = null;
// Construct a new VMessage.
//
// Note: We cannot invoke `Error` on the created context, as that adds readonly
// `line` and `column` attributes on Safari 9, thus throwing and failing the
// data.
function $d7fc64844594b76b$var$VMessage(reason, position, origin) {
    var parts;
    var range;
    var location;
    if (typeof position === "string") {
        origin = position;
        position = null;
    }
    parts = $d7fc64844594b76b$var$parseOrigin(origin);
    range = $fQtvf(position) || "1:1";
    location = {
        start: {
            line: null,
            column: null
        },
        end: {
            line: null,
            column: null
        }
    };
    // Node.
    if (position && position.position) position = position.position;
    if (position) {
        // Position.
        if (position.start) {
            location = position;
            position = position.start;
        } else // Point.
        location.start = position;
    }
    if (reason.stack) {
        this.stack = reason.stack;
        reason = reason.message;
    }
    this.message = reason;
    this.name = range;
    this.reason = reason;
    this.line = position ? position.line : null;
    this.column = position ? position.column : null;
    this.location = location;
    this.source = parts[0];
    this.ruleId = parts[1];
}
function $d7fc64844594b76b$var$parseOrigin(origin) {
    var result = [
        null,
        null
    ];
    var index;
    if (typeof origin === "string") {
        index = origin.indexOf(":");
        if (index === -1) result[1] = origin;
        else {
            result[0] = origin.slice(0, index);
            result[1] = origin.slice(index + 1);
        }
    }
    return result;
}

});
parcelRegister("fQtvf", function(module, exports) {
"use strict";
var $b89299013b57c39d$var$own = {}.hasOwnProperty;
module.exports = $b89299013b57c39d$var$stringify;
function $b89299013b57c39d$var$stringify(value) {
    // Nothing.
    if (!value || typeof value !== "object") return "";
    // Node.
    if ($b89299013b57c39d$var$own.call(value, "position") || $b89299013b57c39d$var$own.call(value, "type")) return $b89299013b57c39d$var$position(value.position);
    // Position.
    if ($b89299013b57c39d$var$own.call(value, "start") || $b89299013b57c39d$var$own.call(value, "end")) return $b89299013b57c39d$var$position(value);
    // Point.
    if ($b89299013b57c39d$var$own.call(value, "line") || $b89299013b57c39d$var$own.call(value, "column")) return $b89299013b57c39d$var$point(value);
    // ?
    return "";
}
function $b89299013b57c39d$var$point(point) {
    if (!point || typeof point !== "object") point = {};
    return $b89299013b57c39d$var$index(point.line) + ":" + $b89299013b57c39d$var$index(point.column);
}
function $b89299013b57c39d$var$position(pos) {
    if (!pos || typeof pos !== "object") pos = {};
    return $b89299013b57c39d$var$point(pos.start) + "-" + $b89299013b57c39d$var$point(pos.end);
}
function $b89299013b57c39d$var$index(value) {
    return value && typeof value === "number" ? value : 1;
}

});


parcelRegister("gTpAy", function(module, exports) {
"use strict";

var $lTiTy = parcelRequire("lTiTy");

var $2qJZ2 = parcelRequire("2qJZ2");

var $Wt5Sk = parcelRequire("Wt5Sk");
module.exports = $c4c5a1beaa92482f$var$VFile;
var $c4c5a1beaa92482f$var$own = {}.hasOwnProperty;
// Order of setting (least specific to most), we need this because otherwise
// `{stem: 'a', path: '~/b.js'}` would throw, as a path is needed before a
// stem can be set.
var $c4c5a1beaa92482f$var$order = [
    "history",
    "path",
    "basename",
    "stem",
    "extname",
    "dirname"
];
$c4c5a1beaa92482f$var$VFile.prototype.toString = $c4c5a1beaa92482f$var$toString;
// Access full path (`~/index.min.js`).
Object.defineProperty($c4c5a1beaa92482f$var$VFile.prototype, "path", {
    get: $c4c5a1beaa92482f$var$getPath,
    set: $c4c5a1beaa92482f$var$setPath
});
// Access parent path (`~`).
Object.defineProperty($c4c5a1beaa92482f$var$VFile.prototype, "dirname", {
    get: $c4c5a1beaa92482f$var$getDirname,
    set: $c4c5a1beaa92482f$var$setDirname
});
// Access basename (`index.min.js`).
Object.defineProperty($c4c5a1beaa92482f$var$VFile.prototype, "basename", {
    get: $c4c5a1beaa92482f$var$getBasename,
    set: $c4c5a1beaa92482f$var$setBasename
});
// Access extname (`.js`).
Object.defineProperty($c4c5a1beaa92482f$var$VFile.prototype, "extname", {
    get: $c4c5a1beaa92482f$var$getExtname,
    set: $c4c5a1beaa92482f$var$setExtname
});
// Access stem (`index.min`).
Object.defineProperty($c4c5a1beaa92482f$var$VFile.prototype, "stem", {
    get: $c4c5a1beaa92482f$var$getStem,
    set: $c4c5a1beaa92482f$var$setStem
});
// Construct a new file.
function $c4c5a1beaa92482f$var$VFile(options) {
    var prop;
    var index;
    if (!options) options = {};
    else if (typeof options === "string" || $Wt5Sk(options)) options = {
        contents: options
    };
    else if ("message" in options && "messages" in options) return options;
    if (!(this instanceof $c4c5a1beaa92482f$var$VFile)) return new $c4c5a1beaa92482f$var$VFile(options);
    this.data = {};
    this.messages = [];
    this.history = [];
    this.cwd = $2qJZ2.cwd();
    // Set path related properties in the correct order.
    index = -1;
    while(++index < $c4c5a1beaa92482f$var$order.length){
        prop = $c4c5a1beaa92482f$var$order[index];
        if ($c4c5a1beaa92482f$var$own.call(options, prop)) this[prop] = options[prop];
    }
    // Set non-path related properties.
    for(prop in options)if ($c4c5a1beaa92482f$var$order.indexOf(prop) < 0) this[prop] = options[prop];
}
function $c4c5a1beaa92482f$var$getPath() {
    return this.history[this.history.length - 1];
}
function $c4c5a1beaa92482f$var$setPath(path) {
    $c4c5a1beaa92482f$var$assertNonEmpty(path, "path");
    if (this.path !== path) this.history.push(path);
}
function $c4c5a1beaa92482f$var$getDirname() {
    return typeof this.path === "string" ? $lTiTy.dirname(this.path) : undefined;
}
function $c4c5a1beaa92482f$var$setDirname(dirname) {
    $c4c5a1beaa92482f$var$assertPath(this.path, "dirname");
    this.path = $lTiTy.join(dirname || "", this.basename);
}
function $c4c5a1beaa92482f$var$getBasename() {
    return typeof this.path === "string" ? $lTiTy.basename(this.path) : undefined;
}
function $c4c5a1beaa92482f$var$setBasename(basename) {
    $c4c5a1beaa92482f$var$assertNonEmpty(basename, "basename");
    $c4c5a1beaa92482f$var$assertPart(basename, "basename");
    this.path = $lTiTy.join(this.dirname || "", basename);
}
function $c4c5a1beaa92482f$var$getExtname() {
    return typeof this.path === "string" ? $lTiTy.extname(this.path) : undefined;
}
function $c4c5a1beaa92482f$var$setExtname(extname) {
    $c4c5a1beaa92482f$var$assertPart(extname, "extname");
    $c4c5a1beaa92482f$var$assertPath(this.path, "extname");
    if (extname) {
        if (extname.charCodeAt(0) !== 46 /* `.` */ ) throw new Error("`extname` must start with `.`");
        if (extname.indexOf(".", 1) > -1) throw new Error("`extname` cannot contain multiple dots");
    }
    this.path = $lTiTy.join(this.dirname, this.stem + (extname || ""));
}
function $c4c5a1beaa92482f$var$getStem() {
    return typeof this.path === "string" ? $lTiTy.basename(this.path, this.extname) : undefined;
}
function $c4c5a1beaa92482f$var$setStem(stem) {
    $c4c5a1beaa92482f$var$assertNonEmpty(stem, "stem");
    $c4c5a1beaa92482f$var$assertPart(stem, "stem");
    this.path = $lTiTy.join(this.dirname || "", stem + (this.extname || ""));
}
// Get the value of the file.
function $c4c5a1beaa92482f$var$toString(encoding) {
    return (this.contents || "").toString(encoding);
}
// Assert that `part` is not a path (i.e., does not contain `p.sep`).
function $c4c5a1beaa92482f$var$assertPart(part, name) {
    if (part && part.indexOf($lTiTy.sep) > -1) throw new Error("`" + name + "` cannot be a path: did not expect `" + $lTiTy.sep + "`");
}
// Assert that `part` is not empty.
function $c4c5a1beaa92482f$var$assertNonEmpty(part, name) {
    if (!part) throw new Error("`" + name + "` cannot be empty");
}
// Assert `path` exists.
function $c4c5a1beaa92482f$var$assertPath(path, name) {
    if (!path) throw new Error("Setting `" + name + "` requires `path` to be set too");
}

});
parcelRegister("lTiTy", function(module, exports) {

$parcel$export(module.exports, "basename", function () { return $fefd642f8649f47a$export$9bf319d8f74f51d1; }, function (v) { return $fefd642f8649f47a$export$9bf319d8f74f51d1 = v; });
$parcel$export(module.exports, "dirname", function () { return $fefd642f8649f47a$export$7f7b8152cc673abe; }, function (v) { return $fefd642f8649f47a$export$7f7b8152cc673abe = v; });
$parcel$export(module.exports, "extname", function () { return $fefd642f8649f47a$export$d0e86f3a75393fa3; }, function (v) { return $fefd642f8649f47a$export$d0e86f3a75393fa3 = v; });
$parcel$export(module.exports, "join", function () { return $fefd642f8649f47a$export$f7e2c8231c57a8bd; }, function (v) { return $fefd642f8649f47a$export$f7e2c8231c57a8bd = v; });
$parcel$export(module.exports, "sep", function () { return $fefd642f8649f47a$export$5aee1a5bd9743d8f; }, function (v) { return $fefd642f8649f47a$export$5aee1a5bd9743d8f = v; });
// A derivative work based on:
// <https://github.com/browserify/path-browserify>.
// Which is licensed:
//
// MIT License
//
// Copyright (c) 2013 James Halliday
//
// Permission is hereby granted, free of charge, to any person obtaining a copy of
// this software and associated documentation files (the "Software"), to deal in
// the Software without restriction, including without limitation the rights to
// use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of
// the Software, and to permit persons to whom the Software is furnished to do so,
// subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in all
// copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS
// FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
// COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER
// IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
// CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
// A derivative work based on:
//
// Parts of that are extracted from Node’s internal `path` module:
// <https://github.com/nodejs/node/blob/master/lib/path.js>.
// Which is licensed:
//
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
var $fefd642f8649f47a$export$9bf319d8f74f51d1;
var $fefd642f8649f47a$export$7f7b8152cc673abe;
var $fefd642f8649f47a$export$d0e86f3a75393fa3;
var $fefd642f8649f47a$export$f7e2c8231c57a8bd;
var $fefd642f8649f47a$export$5aee1a5bd9743d8f;
"use strict";
$fefd642f8649f47a$export$9bf319d8f74f51d1 = $fefd642f8649f47a$var$basename;
$fefd642f8649f47a$export$7f7b8152cc673abe = $fefd642f8649f47a$var$dirname;
$fefd642f8649f47a$export$d0e86f3a75393fa3 = $fefd642f8649f47a$var$extname;
$fefd642f8649f47a$export$f7e2c8231c57a8bd = $fefd642f8649f47a$var$join;
$fefd642f8649f47a$export$5aee1a5bd9743d8f = "/";
function $fefd642f8649f47a$var$basename(path, ext) {
    var start = 0;
    var end = -1;
    var index;
    var firstNonSlashEnd;
    var seenNonSlash;
    var extIndex;
    if (ext !== undefined && typeof ext !== "string") throw new TypeError('"ext" argument must be a string');
    $fefd642f8649f47a$var$assertPath(path);
    index = path.length;
    if (ext === undefined || !ext.length || ext.length > path.length) {
        while(index--){
            if (path.charCodeAt(index) === 47 /* `/` */ ) // If we reached a path separator that was not part of a set of path
            // separators at the end of the string, stop now.
            {
                if (seenNonSlash) {
                    start = index + 1;
                    break;
                }
            } else if (end < 0) {
                // We saw the first non-path separator, mark this as the end of our
                // path component.
                seenNonSlash = true;
                end = index + 1;
            }
        }
        return end < 0 ? "" : path.slice(start, end);
    }
    if (ext === path) return "";
    firstNonSlashEnd = -1;
    extIndex = ext.length - 1;
    while(index--){
        if (path.charCodeAt(index) === 47 /* `/` */ ) // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now.
        {
            if (seenNonSlash) {
                start = index + 1;
                break;
            }
        } else {
            if (firstNonSlashEnd < 0) {
                // We saw the first non-path separator, remember this index in case
                // we need it if the extension ends up not matching.
                seenNonSlash = true;
                firstNonSlashEnd = index + 1;
            }
            if (extIndex > -1) {
                // Try to match the explicit extension.
                if (path.charCodeAt(index) === ext.charCodeAt(extIndex--)) {
                    if (extIndex < 0) // We matched the extension, so mark this as the end of our path
                    // component
                    end = index;
                } else {
                    // Extension does not match, so our result is the entire path
                    // component
                    extIndex = -1;
                    end = firstNonSlashEnd;
                }
            }
        }
    }
    if (start === end) end = firstNonSlashEnd;
    else if (end < 0) end = path.length;
    return path.slice(start, end);
}
function $fefd642f8649f47a$var$dirname(path) {
    var end;
    var unmatchedSlash;
    var index;
    $fefd642f8649f47a$var$assertPath(path);
    if (!path.length) return ".";
    end = -1;
    index = path.length;
    // Prefix `--` is important to not run on `0`.
    while(--index){
        if (path.charCodeAt(index) === 47 /* `/` */ ) {
            if (unmatchedSlash) {
                end = index;
                break;
            }
        } else if (!unmatchedSlash) // We saw the first non-path separator
        unmatchedSlash = true;
    }
    return end < 0 ? path.charCodeAt(0) === 47 /* `/` */  ? "/" : "." : end === 1 && path.charCodeAt(0) === 47 /* `/` */  ? "//" : path.slice(0, end);
}
function $fefd642f8649f47a$var$extname(path) {
    var startDot = -1;
    var startPart = 0;
    var end = -1;
    // Track the state of characters (if any) we see before our first dot and
    // after any path separator we find.
    var preDotState = 0;
    var unmatchedSlash;
    var code;
    var index;
    $fefd642f8649f47a$var$assertPath(path);
    index = path.length;
    while(index--){
        code = path.charCodeAt(index);
        if (code === 47 /* `/` */ ) {
            // If we reached a path separator that was not part of a set of path
            // separators at the end of the string, stop now.
            if (unmatchedSlash) {
                startPart = index + 1;
                break;
            }
            continue;
        }
        if (end < 0) {
            // We saw the first non-path separator, mark this as the end of our
            // extension.
            unmatchedSlash = true;
            end = index + 1;
        }
        if (code === 46 /* `.` */ ) {
            // If this is our first dot, mark it as the start of our extension.
            if (startDot < 0) startDot = index;
            else if (preDotState !== 1) preDotState = 1;
        } else if (startDot > -1) // We saw a non-dot and non-path separator before our dot, so we should
        // have a good chance at having a non-empty extension.
        preDotState = -1;
    }
    if (startDot < 0 || end < 0 || // We saw a non-dot character immediately before the dot.
    preDotState === 0 || // The (right-most) trimmed path component is exactly `..`.
    preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) return "";
    return path.slice(startDot, end);
}
function $fefd642f8649f47a$var$join() {
    var index = -1;
    var joined;
    while(++index < arguments.length){
        $fefd642f8649f47a$var$assertPath(arguments[index]);
        if (arguments[index]) joined = joined === undefined ? arguments[index] : joined + "/" + arguments[index];
    }
    return joined === undefined ? "." : $fefd642f8649f47a$var$normalize(joined);
}
// Note: `normalize` is not exposed as `path.normalize`, so some code is
// manually removed from it.
function $fefd642f8649f47a$var$normalize(path) {
    var absolute;
    var value;
    $fefd642f8649f47a$var$assertPath(path);
    absolute = path.charCodeAt(0) === 47 /* `/` */ ;
    // Normalize the path according to POSIX rules.
    value = $fefd642f8649f47a$var$normalizeString(path, !absolute);
    if (!value.length && !absolute) value = ".";
    if (value.length && path.charCodeAt(path.length - 1) === 47 /* / */ ) value += "/";
    return absolute ? "/" + value : value;
}
// Resolve `.` and `..` elements in a path with directory names.
function $fefd642f8649f47a$var$normalizeString(path, allowAboveRoot) {
    var result = "";
    var lastSegmentLength = 0;
    var lastSlash = -1;
    var dots = 0;
    var index = -1;
    var code;
    var lastSlashIndex;
    while(++index <= path.length){
        if (index < path.length) code = path.charCodeAt(index);
        else if (code === 47 /* `/` */ ) break;
        else code = 47 /* `/` */ ;
        if (code === 47 /* `/` */ ) {
            if (lastSlash === index - 1 || dots === 1) ;
            else if (lastSlash !== index - 1 && dots === 2) {
                if (result.length < 2 || lastSegmentLength !== 2 || result.charCodeAt(result.length - 1) !== 46 /* `.` */  || result.charCodeAt(result.length - 2) !== 46 /* `.` */ ) {
                    if (result.length > 2) {
                        lastSlashIndex = result.lastIndexOf("/");
                        /* istanbul ignore else - No clue how to cover it. */ if (lastSlashIndex !== result.length - 1) {
                            if (lastSlashIndex < 0) {
                                result = "";
                                lastSegmentLength = 0;
                            } else {
                                result = result.slice(0, lastSlashIndex);
                                lastSegmentLength = result.length - 1 - result.lastIndexOf("/");
                            }
                            lastSlash = index;
                            dots = 0;
                            continue;
                        }
                    } else if (result.length) {
                        result = "";
                        lastSegmentLength = 0;
                        lastSlash = index;
                        dots = 0;
                        continue;
                    }
                }
                if (allowAboveRoot) {
                    result = result.length ? result + "/.." : "..";
                    lastSegmentLength = 2;
                }
            } else {
                if (result.length) result += "/" + path.slice(lastSlash + 1, index);
                else result = path.slice(lastSlash + 1, index);
                lastSegmentLength = index - lastSlash - 1;
            }
            lastSlash = index;
            dots = 0;
        } else if (code === 46 /* `.` */  && dots > -1) dots++;
        else dots = -1;
    }
    return result;
}
function $fefd642f8649f47a$var$assertPath(path) {
    if (typeof path !== "string") throw new TypeError("Path must be a string. Received " + JSON.stringify(path));
}

});

parcelRegister("2qJZ2", function(module, exports) {

$parcel$export(module.exports, "cwd", function () { return $1c51add8544dece2$export$5f7bb87daeae59c1; }, function (v) { return $1c51add8544dece2$export$5f7bb87daeae59c1 = v; });
// Somewhat based on:
// <https://github.com/defunctzombie/node-process/blob/master/browser.js>.
// But I don’t think one tiny line of code can be copyrighted. 😅
var $1c51add8544dece2$export$5f7bb87daeae59c1;
"use strict";
$1c51add8544dece2$export$5f7bb87daeae59c1 = $1c51add8544dece2$var$cwd;
function $1c51add8544dece2$var$cwd() {
    return "/";
}

});





parcelRegister("bK6CN", function(module, exports) {
"use strict";
module.exports = $88c9211f115d49d4$var$parse;

var $jdnWJ = parcelRequire("jdnWJ");
function $88c9211f115d49d4$var$parse(options) {
    var self = this;
    this.Parser = parse;
    function parse(doc) {
        return $jdnWJ(doc, Object.assign({}, self.data("settings"), options, {
            // Note: these options are not in the readme.
            // The goal is for them to be set by plugins on `data` instead of being
            // passed by users.
            extensions: self.data("micromarkExtensions") || [],
            mdastExtensions: self.data("fromMarkdownExtensions") || []
        }));
    }
}

});
parcelRegister("jdnWJ", function(module, exports) {
"use strict";

module.exports = (parcelRequire("4UjLH"));

});
parcelRegister("4UjLH", function(module, exports) {
"use strict";
module.exports = $392bb9fab9df7560$var$fromMarkdown;

var $aEaBe = parcelRequire("aEaBe");

var $37cBN = parcelRequire("37cBN");

var $ffxyv = parcelRequire("ffxyv");

var $k6MDZ = parcelRequire("k6MDZ");

var $cQo6B = parcelRequire("cQo6B");

var $iAUDy = parcelRequire("iAUDy");

var $f7LfF = parcelRequire("f7LfF");

var $kmVDs = parcelRequire("kmVDs");

var $hKKfc = parcelRequire("hKKfc");

var $fQtvf = parcelRequire("fQtvf");
function $392bb9fab9df7560$var$fromMarkdown(value, encoding, options) {
    if (typeof encoding !== "string") {
        options = encoding;
        encoding = undefined;
    }
    return $392bb9fab9df7560$var$compiler(options)($kmVDs($iAUDy(options).document().write($f7LfF()(value, encoding, true))));
}
// Note this compiler only understand complete buffering, not streaming.
function $392bb9fab9df7560$var$compiler(options) {
    var settings = options || {};
    var config = $392bb9fab9df7560$var$configure({
        transforms: [],
        canContainEols: [
            "emphasis",
            "fragment",
            "heading",
            "paragraph",
            "strong"
        ],
        enter: {
            autolink: opener(link),
            autolinkProtocol: onenterdata,
            autolinkEmail: onenterdata,
            atxHeading: opener(heading),
            blockQuote: opener(blockQuote),
            characterEscape: onenterdata,
            characterReference: onenterdata,
            codeFenced: opener(codeFlow),
            codeFencedFenceInfo: buffer,
            codeFencedFenceMeta: buffer,
            codeIndented: opener(codeFlow, buffer),
            codeText: opener(codeText, buffer),
            codeTextData: onenterdata,
            data: onenterdata,
            codeFlowValue: onenterdata,
            definition: opener(definition),
            definitionDestinationString: buffer,
            definitionLabelString: buffer,
            definitionTitleString: buffer,
            emphasis: opener(emphasis),
            hardBreakEscape: opener(hardBreak),
            hardBreakTrailing: opener(hardBreak),
            htmlFlow: opener(html, buffer),
            htmlFlowData: onenterdata,
            htmlText: opener(html, buffer),
            htmlTextData: onenterdata,
            image: opener(image),
            label: buffer,
            link: opener(link),
            listItem: opener(listItem),
            listItemValue: onenterlistitemvalue,
            listOrdered: opener(list, onenterlistordered),
            listUnordered: opener(list),
            paragraph: opener(paragraph),
            reference: onenterreference,
            referenceString: buffer,
            resourceDestinationString: buffer,
            resourceTitleString: buffer,
            setextHeading: opener(heading),
            strong: opener(strong),
            thematicBreak: opener(thematicBreak)
        },
        exit: {
            atxHeading: closer(),
            atxHeadingSequence: onexitatxheadingsequence,
            autolink: closer(),
            autolinkEmail: onexitautolinkemail,
            autolinkProtocol: onexitautolinkprotocol,
            blockQuote: closer(),
            characterEscapeValue: onexitdata,
            characterReferenceMarkerHexadecimal: onexitcharacterreferencemarker,
            characterReferenceMarkerNumeric: onexitcharacterreferencemarker,
            characterReferenceValue: onexitcharacterreferencevalue,
            codeFenced: closer(onexitcodefenced),
            codeFencedFence: onexitcodefencedfence,
            codeFencedFenceInfo: onexitcodefencedfenceinfo,
            codeFencedFenceMeta: onexitcodefencedfencemeta,
            codeFlowValue: onexitdata,
            codeIndented: closer(onexitcodeindented),
            codeText: closer(onexitcodetext),
            codeTextData: onexitdata,
            data: onexitdata,
            definition: closer(),
            definitionDestinationString: onexitdefinitiondestinationstring,
            definitionLabelString: onexitdefinitionlabelstring,
            definitionTitleString: onexitdefinitiontitlestring,
            emphasis: closer(),
            hardBreakEscape: closer(onexithardbreak),
            hardBreakTrailing: closer(onexithardbreak),
            htmlFlow: closer(onexithtmlflow),
            htmlFlowData: onexitdata,
            htmlText: closer(onexithtmltext),
            htmlTextData: onexitdata,
            image: closer(onexitimage),
            label: onexitlabel,
            labelText: onexitlabeltext,
            lineEnding: onexitlineending,
            link: closer(onexitlink),
            listItem: closer(),
            listOrdered: closer(),
            listUnordered: closer(),
            paragraph: closer(),
            referenceString: onexitreferencestring,
            resourceDestinationString: onexitresourcedestinationstring,
            resourceTitleString: onexitresourcetitlestring,
            resource: onexitresource,
            setextHeading: closer(onexitsetextheading),
            setextHeadingLineSequence: onexitsetextheadinglinesequence,
            setextHeadingText: onexitsetextheadingtext,
            strong: closer(),
            thematicBreak: closer()
        }
    }, settings.mdastExtensions || []);
    var data = {};
    return compile;
    function compile(events) {
        var tree = {
            type: "root",
            children: []
        };
        var stack = [
            tree
        ];
        var tokenStack = [];
        var listStack = [];
        var index = -1;
        var handler;
        var listStart;
        var context = {
            stack: stack,
            tokenStack: tokenStack,
            config: config,
            enter: enter,
            exit: exit,
            buffer: buffer,
            resume: resume,
            setData: setData,
            getData: getData
        };
        while(++index < events.length)// We preprocess lists to add `listItem` tokens, and to infer whether
        // items the list itself are spread out.
        if (events[index][1].type === "listOrdered" || events[index][1].type === "listUnordered") {
            if (events[index][0] === "enter") listStack.push(index);
            else {
                listStart = listStack.pop(index);
                index = prepareList(events, listStart, index);
            }
        }
        index = -1;
        while(++index < events.length){
            handler = config[events[index][0]];
            if ($ffxyv.call(handler, events[index][1].type)) handler[events[index][1].type].call($37cBN({
                sliceSerialize: events[index][2].sliceSerialize
            }, context), events[index][1]);
        }
        if (tokenStack.length) throw new Error("Cannot close document, a token (`" + tokenStack[tokenStack.length - 1].type + "`, " + $fQtvf({
            start: tokenStack[tokenStack.length - 1].start,
            end: tokenStack[tokenStack.length - 1].end
        }) + ") is still open");
        // Figure out `root` position.
        tree.position = {
            start: point(events.length ? events[0][1].start : {
                line: 1,
                column: 1,
                offset: 0
            }),
            end: point(events.length ? events[events.length - 2][1].end : {
                line: 1,
                column: 1,
                offset: 0
            })
        };
        index = -1;
        while(++index < config.transforms.length)tree = config.transforms[index](tree) || tree;
        return tree;
    }
    function prepareList(events, start, length) {
        var index = start - 1;
        var containerBalance = -1;
        var listSpread = false;
        var listItem;
        var tailIndex;
        var lineIndex;
        var tailEvent;
        var event;
        var firstBlankLineIndex;
        var atMarker;
        while(++index <= length){
            event = events[index];
            if (event[1].type === "listUnordered" || event[1].type === "listOrdered" || event[1].type === "blockQuote") {
                if (event[0] === "enter") containerBalance++;
                else containerBalance--;
                atMarker = undefined;
            } else if (event[1].type === "lineEndingBlank") {
                if (event[0] === "enter") {
                    if (listItem && !atMarker && !containerBalance && !firstBlankLineIndex) firstBlankLineIndex = index;
                    atMarker = undefined;
                }
            } else if (event[1].type === "linePrefix" || event[1].type === "listItemValue" || event[1].type === "listItemMarker" || event[1].type === "listItemPrefix" || event[1].type === "listItemPrefixWhitespace") ;
            else atMarker = undefined;
            if (!containerBalance && event[0] === "enter" && event[1].type === "listItemPrefix" || containerBalance === -1 && event[0] === "exit" && (event[1].type === "listUnordered" || event[1].type === "listOrdered")) {
                if (listItem) {
                    tailIndex = index;
                    lineIndex = undefined;
                    while(tailIndex--){
                        tailEvent = events[tailIndex];
                        if (tailEvent[1].type === "lineEnding" || tailEvent[1].type === "lineEndingBlank") {
                            if (tailEvent[0] === "exit") continue;
                            if (lineIndex) {
                                events[lineIndex][1].type = "lineEndingBlank";
                                listSpread = true;
                            }
                            tailEvent[1].type = "lineEnding";
                            lineIndex = tailIndex;
                        } else if (tailEvent[1].type === "linePrefix" || tailEvent[1].type === "blockQuotePrefix" || tailEvent[1].type === "blockQuotePrefixWhitespace" || tailEvent[1].type === "blockQuoteMarker" || tailEvent[1].type === "listItemIndent") ;
                        else break;
                    }
                    if (firstBlankLineIndex && (!lineIndex || firstBlankLineIndex < lineIndex)) listItem._spread = true;
                    // Fix position.
                    listItem.end = point(lineIndex ? events[lineIndex][1].start : event[1].end);
                    events.splice(lineIndex || index, 0, [
                        "exit",
                        listItem,
                        event[2]
                    ]);
                    index++;
                    length++;
                }
                // Create a new list item.
                if (event[1].type === "listItemPrefix") {
                    listItem = {
                        type: "listItem",
                        _spread: false,
                        start: point(event[1].start)
                    };
                    events.splice(index, 0, [
                        "enter",
                        listItem,
                        event[2]
                    ]);
                    index++;
                    length++;
                    firstBlankLineIndex = undefined;
                    atMarker = true;
                }
            }
        }
        events[start][1]._spread = listSpread;
        return length;
    }
    function setData(key, value) {
        data[key] = value;
    }
    function getData(key) {
        return data[key];
    }
    function point(d) {
        return {
            line: d.line,
            column: d.column,
            offset: d.offset
        };
    }
    function opener(create, and) {
        return open;
        function open(token) {
            enter.call(this, create(token), token);
            if (and) and.call(this, token);
        }
    }
    function buffer() {
        this.stack.push({
            type: "fragment",
            children: []
        });
    }
    function enter(node, token) {
        this.stack[this.stack.length - 1].children.push(node);
        this.stack.push(node);
        this.tokenStack.push(token);
        node.position = {
            start: point(token.start)
        };
        return node;
    }
    function closer(and) {
        return close;
        function close(token) {
            if (and) and.call(this, token);
            exit.call(this, token);
        }
    }
    function exit(token) {
        var node = this.stack.pop();
        var open = this.tokenStack.pop();
        if (!open) throw new Error("Cannot close `" + token.type + "` (" + $fQtvf({
            start: token.start,
            end: token.end
        }) + "): it\u2019s not open");
        else if (open.type !== token.type) throw new Error("Cannot close `" + token.type + "` (" + $fQtvf({
            start: token.start,
            end: token.end
        }) + "): a different token (`" + open.type + "`, " + $fQtvf({
            start: open.start,
            end: open.end
        }) + ") is open");
        node.position.end = point(token.end);
        return node;
    }
    function resume() {
        return $aEaBe(this.stack.pop());
    }
    //
    // Handlers.
    //
    function onenterlistordered() {
        setData("expectingFirstListItemValue", true);
    }
    function onenterlistitemvalue(token) {
        if (getData("expectingFirstListItemValue")) {
            this.stack[this.stack.length - 2].start = parseInt(this.sliceSerialize(token), 10);
            setData("expectingFirstListItemValue");
        }
    }
    function onexitcodefencedfenceinfo() {
        var data = this.resume();
        this.stack[this.stack.length - 1].lang = data;
    }
    function onexitcodefencedfencemeta() {
        var data = this.resume();
        this.stack[this.stack.length - 1].meta = data;
    }
    function onexitcodefencedfence() {
        // Exit if this is the closing fence.
        if (getData("flowCodeInside")) return;
        this.buffer();
        setData("flowCodeInside", true);
    }
    function onexitcodefenced() {
        var data = this.resume();
        this.stack[this.stack.length - 1].value = data.replace(/^(\r?\n|\r)|(\r?\n|\r)$/g, "");
        setData("flowCodeInside");
    }
    function onexitcodeindented() {
        var data = this.resume();
        this.stack[this.stack.length - 1].value = data;
    }
    function onexitdefinitionlabelstring(token) {
        // Discard label, use the source content instead.
        var label = this.resume();
        this.stack[this.stack.length - 1].label = label;
        this.stack[this.stack.length - 1].identifier = $k6MDZ(this.sliceSerialize(token)).toLowerCase();
    }
    function onexitdefinitiontitlestring() {
        var data = this.resume();
        this.stack[this.stack.length - 1].title = data;
    }
    function onexitdefinitiondestinationstring() {
        var data = this.resume();
        this.stack[this.stack.length - 1].url = data;
    }
    function onexitatxheadingsequence(token) {
        if (!this.stack[this.stack.length - 1].depth) this.stack[this.stack.length - 1].depth = this.sliceSerialize(token).length;
    }
    function onexitsetextheadingtext() {
        setData("setextHeadingSlurpLineEnding", true);
    }
    function onexitsetextheadinglinesequence(token) {
        this.stack[this.stack.length - 1].depth = this.sliceSerialize(token).charCodeAt(0) === 61 ? 1 : 2;
    }
    function onexitsetextheading() {
        setData("setextHeadingSlurpLineEnding");
    }
    function onenterdata(token) {
        var siblings = this.stack[this.stack.length - 1].children;
        var tail = siblings[siblings.length - 1];
        if (!tail || tail.type !== "text") {
            // Add a new text node.
            tail = text();
            tail.position = {
                start: point(token.start)
            };
            this.stack[this.stack.length - 1].children.push(tail);
        }
        this.stack.push(tail);
    }
    function onexitdata(token) {
        var tail = this.stack.pop();
        tail.value += this.sliceSerialize(token);
        tail.position.end = point(token.end);
    }
    function onexitlineending(token) {
        var context = this.stack[this.stack.length - 1];
        // If we’re at a hard break, include the line ending in there.
        if (getData("atHardBreak")) {
            context.children[context.children.length - 1].position.end = point(token.end);
            setData("atHardBreak");
            return;
        }
        if (!getData("setextHeadingSlurpLineEnding") && config.canContainEols.indexOf(context.type) > -1) {
            onenterdata.call(this, token);
            onexitdata.call(this, token);
        }
    }
    function onexithardbreak() {
        setData("atHardBreak", true);
    }
    function onexithtmlflow() {
        var data = this.resume();
        this.stack[this.stack.length - 1].value = data;
    }
    function onexithtmltext() {
        var data = this.resume();
        this.stack[this.stack.length - 1].value = data;
    }
    function onexitcodetext() {
        var data = this.resume();
        this.stack[this.stack.length - 1].value = data;
    }
    function onexitlink() {
        var context = this.stack[this.stack.length - 1];
        // To do: clean.
        if (getData("inReference")) {
            context.type += "Reference";
            context.referenceType = getData("referenceType") || "shortcut";
            delete context.url;
            delete context.title;
        } else {
            delete context.identifier;
            delete context.label;
            delete context.referenceType;
        }
        setData("referenceType");
    }
    function onexitimage() {
        var context = this.stack[this.stack.length - 1];
        // To do: clean.
        if (getData("inReference")) {
            context.type += "Reference";
            context.referenceType = getData("referenceType") || "shortcut";
            delete context.url;
            delete context.title;
        } else {
            delete context.identifier;
            delete context.label;
            delete context.referenceType;
        }
        setData("referenceType");
    }
    function onexitlabeltext(token) {
        this.stack[this.stack.length - 2].identifier = $k6MDZ(this.sliceSerialize(token)).toLowerCase();
    }
    function onexitlabel() {
        var fragment = this.stack[this.stack.length - 1];
        var value = this.resume();
        this.stack[this.stack.length - 1].label = value;
        // Assume a reference.
        setData("inReference", true);
        if (this.stack[this.stack.length - 1].type === "link") this.stack[this.stack.length - 1].children = fragment.children;
        else this.stack[this.stack.length - 1].alt = value;
    }
    function onexitresourcedestinationstring() {
        var data = this.resume();
        this.stack[this.stack.length - 1].url = data;
    }
    function onexitresourcetitlestring() {
        var data = this.resume();
        this.stack[this.stack.length - 1].title = data;
    }
    function onexitresource() {
        setData("inReference");
    }
    function onenterreference() {
        setData("referenceType", "collapsed");
    }
    function onexitreferencestring(token) {
        var label = this.resume();
        this.stack[this.stack.length - 1].label = label;
        this.stack[this.stack.length - 1].identifier = $k6MDZ(this.sliceSerialize(token)).toLowerCase();
        setData("referenceType", "full");
    }
    function onexitcharacterreferencemarker(token) {
        setData("characterReferenceType", token.type);
    }
    function onexitcharacterreferencevalue(token) {
        var data = this.sliceSerialize(token);
        var type = getData("characterReferenceType");
        var value;
        var tail;
        if (type) {
            value = $cQo6B(data, type === "characterReferenceMarkerNumeric" ? 10 : 16);
            setData("characterReferenceType");
        } else value = $hKKfc(data);
        tail = this.stack.pop();
        tail.value += value;
        tail.position.end = point(token.end);
    }
    function onexitautolinkprotocol(token) {
        onexitdata.call(this, token);
        this.stack[this.stack.length - 1].url = this.sliceSerialize(token);
    }
    function onexitautolinkemail(token) {
        onexitdata.call(this, token);
        this.stack[this.stack.length - 1].url = "mailto:" + this.sliceSerialize(token);
    }
    //
    // Creaters.
    //
    function blockQuote() {
        return {
            type: "blockquote",
            children: []
        };
    }
    function codeFlow() {
        return {
            type: "code",
            lang: null,
            meta: null,
            value: ""
        };
    }
    function codeText() {
        return {
            type: "inlineCode",
            value: ""
        };
    }
    function definition() {
        return {
            type: "definition",
            identifier: "",
            label: null,
            title: null,
            url: ""
        };
    }
    function emphasis() {
        return {
            type: "emphasis",
            children: []
        };
    }
    function heading() {
        return {
            type: "heading",
            depth: undefined,
            children: []
        };
    }
    function hardBreak() {
        return {
            type: "break"
        };
    }
    function html() {
        return {
            type: "html",
            value: ""
        };
    }
    function image() {
        return {
            type: "image",
            title: null,
            url: "",
            alt: null
        };
    }
    function link() {
        return {
            type: "link",
            title: null,
            url: "",
            children: []
        };
    }
    function list(token) {
        return {
            type: "list",
            ordered: token.type === "listOrdered",
            start: null,
            spread: token._spread,
            children: []
        };
    }
    function listItem(token) {
        return {
            type: "listItem",
            spread: token._spread,
            checked: null,
            children: []
        };
    }
    function paragraph() {
        return {
            type: "paragraph",
            children: []
        };
    }
    function strong() {
        return {
            type: "strong",
            children: []
        };
    }
    function text() {
        return {
            type: "text",
            value: ""
        };
    }
    function thematicBreak() {
        return {
            type: "thematicBreak"
        };
    }
}
function $392bb9fab9df7560$var$configure(config, extensions) {
    var index = -1;
    while(++index < extensions.length)$392bb9fab9df7560$var$extension(config, extensions[index]);
    return config;
}
function $392bb9fab9df7560$var$extension(config, extension) {
    var key;
    var left;
    for(key in extension){
        left = $ffxyv.call(config, key) ? config[key] : config[key] = {};
        if (key === "canContainEols" || key === "transforms") config[key] = [].concat(left, extension[key]);
        else Object.assign(left, extension[key]);
    }
}

});
parcelRegister("aEaBe", function(module, exports) {
"use strict";
module.exports = $7c05dca1f8f8b90f$var$toString;
// Get the text content of a node.
// Prefer the node’s plain-text fields, otherwise serialize its children,
// and if the given value is an array, serialize the nodes in it.
function $7c05dca1f8f8b90f$var$toString(node) {
    return node && (node.value || node.alt || node.title || "children" in node && $7c05dca1f8f8b90f$var$all(node.children) || "length" in node && $7c05dca1f8f8b90f$var$all(node)) || "";
}
function $7c05dca1f8f8b90f$var$all(values) {
    var result = [];
    var index = -1;
    while(++index < values.length)result[index] = $7c05dca1f8f8b90f$var$toString(values[index]);
    return result.join("");
}

});

parcelRegister("37cBN", function(module, exports) {
"use strict";
var $244bce53d23a3288$var$assign = Object.assign;
module.exports = $244bce53d23a3288$var$assign;

});

parcelRegister("ffxyv", function(module, exports) {
"use strict";
var $b1a2492dc6ebad8e$var$own = {}.hasOwnProperty;
module.exports = $b1a2492dc6ebad8e$var$own;

});

parcelRegister("k6MDZ", function(module, exports) {
"use strict";
function $ea3a19db581d28a6$var$normalizeIdentifier(value) {
    return value // Collapse Markdown whitespace.
    .replace(/[\t\n\r ]+/g, " ") // Trim.
    .replace(/^ | $/g, "") // Some characters are considered “uppercase”, but if their lowercase
    // counterpart is uppercased will result in a different uppercase
    // character.
    // Hence, to get that form, we perform both lower- and uppercase.
    // Upper case makes sure keys will not interact with default prototypal
    // methods: no object method is uppercase.
    .toLowerCase().toUpperCase();
}
module.exports = $ea3a19db581d28a6$var$normalizeIdentifier;

});

parcelRegister("cQo6B", function(module, exports) {
"use strict";

var $iaAMG = parcelRequire("iaAMG");
function $959d0a3b3afcb4a1$var$safeFromInt(value, base) {
    var code = parseInt(value, base);
    if (// C0 except for HT, LF, FF, CR, space
    code < 9 || code === 11 || code > 13 && code < 32 || // Control character (DEL) of the basic block and C1 controls.
    code > 126 && code < 160 || // Lone high surrogates and low surrogates.
    code > 55295 && code < 57344 || // Noncharacters.
    code > 64975 && code < 65008 || (code & 65535) === 65535 || (code & 65535) === 65534 || // Out of range
    code > 1114111) return "\uFFFD";
    return $iaAMG(code);
}
module.exports = $959d0a3b3afcb4a1$var$safeFromInt;

});
parcelRegister("iaAMG", function(module, exports) {
"use strict";
var $d3a5b1c46ac8904b$var$fromCharCode = String.fromCharCode;
module.exports = $d3a5b1c46ac8904b$var$fromCharCode;

});


parcelRegister("iAUDy", function(module, exports) {
"use strict";

var $hBIR9 = parcelRequire("hBIR9");

var $8Zcf1 = parcelRequire("8Zcf1");

var $3gHLf = parcelRequire("3gHLf");

var $7zJWl = parcelRequire("7zJWl");

var $jL26E = parcelRequire("jL26E");

var $i37N3 = parcelRequire("i37N3");

var $5EpjL = parcelRequire("5EpjL");

var $fgcfR = parcelRequire("fgcfR");
function $d89785b2e0910b71$var$parse(options) {
    var settings = options || {};
    var parser = {
        defined: [],
        constructs: $jL26E([
            $fgcfR
        ].concat($5EpjL(settings.extensions))),
        content: create($hBIR9),
        document: create($8Zcf1),
        flow: create($3gHLf),
        string: create($7zJWl.string),
        text: create($7zJWl.text)
    };
    return parser;
    function create(initializer) {
        return creator;
        function creator(from) {
            return $i37N3(parser, initializer, from);
        }
    }
}
module.exports = $d89785b2e0910b71$var$parse;

});
parcelRegister("hBIR9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $bl5Ae = parcelRequire("bl5Ae");

var $10n72 = parcelRequire("10n72");
var $cd18afdfd7c33cab$var$tokenize = $cd18afdfd7c33cab$var$initializeContent;
function $cd18afdfd7c33cab$var$initializeContent(effects) {
    var contentStart = effects.attempt(this.parser.constructs.contentInitial, afterContentStartConstruct, paragraphInitial);
    var previous;
    return contentStart;
    function afterContentStartConstruct(code) {
        if (code === null) {
            effects.consume(code);
            return;
        }
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return $10n72(effects, contentStart, "linePrefix");
    }
    function paragraphInitial(code) {
        effects.enter("paragraph");
        return lineStart(code);
    }
    function lineStart(code) {
        var token = effects.enter("chunkText", {
            contentType: "text",
            previous: previous
        });
        if (previous) previous.next = token;
        previous = token;
        return data(code);
    }
    function data(code) {
        if (code === null) {
            effects.exit("chunkText");
            effects.exit("paragraph");
            effects.consume(code);
            return;
        }
        if ($bl5Ae(code)) {
            effects.consume(code);
            effects.exit("chunkText");
            return lineStart;
        } // Data.
        effects.consume(code);
        return data;
    }
}
module.exports.tokenize = $cd18afdfd7c33cab$var$tokenize;

});
parcelRegister("bl5Ae", function(module, exports) {
"use strict";
function $8415fca3c7e2efa3$var$markdownLineEnding(code) {
    return code < -2;
}
module.exports = $8415fca3c7e2efa3$var$markdownLineEnding;

});

parcelRegister("10n72", function(module, exports) {
"use strict";

var $5br2F = parcelRequire("5br2F");
function $0bb7b8360fcc21ae$var$spaceFactory(effects, ok, type, max) {
    var limit = max ? max - 1 : Infinity;
    var size = 0;
    return start;
    function start(code) {
        if ($5br2F(code)) {
            effects.enter(type);
            return prefix(code);
        }
        return ok(code);
    }
    function prefix(code) {
        if ($5br2F(code) && size++ < limit) {
            effects.consume(code);
            return prefix;
        }
        effects.exit(type);
        return ok(code);
    }
}
module.exports = $0bb7b8360fcc21ae$var$spaceFactory;

});
parcelRegister("5br2F", function(module, exports) {
"use strict";
function $3c62f4d3140cd9e3$var$markdownSpace(code) {
    return code === -2 || code === -1 || code === 32;
}
module.exports = $3c62f4d3140cd9e3$var$markdownSpace;

});



parcelRegister("8Zcf1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $bl5Ae = parcelRequire("bl5Ae");

var $10n72 = parcelRequire("10n72");

var $9em3z = parcelRequire("9em3z");
var $68ad841ab685197a$var$tokenize = $68ad841ab685197a$var$initializeDocument;
var $68ad841ab685197a$var$containerConstruct = {
    tokenize: $68ad841ab685197a$var$tokenizeContainer
};
var $68ad841ab685197a$var$lazyFlowConstruct = {
    tokenize: $68ad841ab685197a$var$tokenizeLazyFlow
};
function $68ad841ab685197a$var$initializeDocument(effects) {
    var self = this;
    var stack = [];
    var continued = 0;
    var inspectConstruct = {
        tokenize: tokenizeInspect,
        partial: true
    };
    var inspectResult;
    var childFlow;
    var childToken;
    return start;
    function start(code) {
        if (continued < stack.length) {
            self.containerState = stack[continued][1];
            return effects.attempt(stack[continued][0].continuation, documentContinue, documentContinued)(code);
        }
        return documentContinued(code);
    }
    function documentContinue(code) {
        continued++;
        return start(code);
    }
    function documentContinued(code) {
        // If we’re in a concrete construct (such as when expecting another line of
        // HTML, or we resulted in lazy content), we can immediately start flow.
        if (inspectResult && inspectResult.flowContinue) return flowStart(code);
        self.interrupt = childFlow && childFlow.currentConstruct && childFlow.currentConstruct.interruptible;
        self.containerState = {};
        return effects.attempt($68ad841ab685197a$var$containerConstruct, containerContinue, flowStart)(code);
    }
    function containerContinue(code) {
        stack.push([
            self.currentConstruct,
            self.containerState
        ]);
        self.containerState = undefined;
        return documentContinued(code);
    }
    function flowStart(code) {
        if (code === null) {
            exitContainers(0, true);
            effects.consume(code);
            return;
        }
        childFlow = childFlow || self.parser.flow(self.now());
        effects.enter("chunkFlow", {
            contentType: "flow",
            previous: childToken,
            _tokenizer: childFlow
        });
        return flowContinue(code);
    }
    function flowContinue(code) {
        if (code === null) {
            continueFlow(effects.exit("chunkFlow"));
            return flowStart(code);
        }
        if ($bl5Ae(code)) {
            effects.consume(code);
            continueFlow(effects.exit("chunkFlow"));
            return effects.check(inspectConstruct, documentAfterPeek);
        }
        effects.consume(code);
        return flowContinue;
    }
    function documentAfterPeek(code) {
        exitContainers(inspectResult.continued, inspectResult && inspectResult.flowEnd);
        continued = 0;
        return start(code);
    }
    function continueFlow(token) {
        if (childToken) childToken.next = token;
        childToken = token;
        childFlow.lazy = inspectResult && inspectResult.lazy;
        childFlow.defineSkip(token.start);
        childFlow.write(self.sliceStream(token));
    }
    function exitContainers(size, end) {
        var index = stack.length // Close the flow.
        ;
        if (childFlow && end) {
            childFlow.write([
                null
            ]);
            childToken = childFlow = undefined;
        } // Exit open containers.
        while(index-- > size){
            self.containerState = stack[index][1];
            stack[index][0].exit.call(self, effects);
        }
        stack.length = size;
    }
    function tokenizeInspect(effects, ok) {
        var subcontinued = 0;
        inspectResult = {};
        return inspectStart;
        function inspectStart(code) {
            if (subcontinued < stack.length) {
                self.containerState = stack[subcontinued][1];
                return effects.attempt(stack[subcontinued][0].continuation, inspectContinue, inspectLess)(code);
            } // If we’re continued but in a concrete flow, we can’t have more
            // containers.
            if (childFlow.currentConstruct && childFlow.currentConstruct.concrete) {
                inspectResult.flowContinue = true;
                return inspectDone(code);
            }
            self.interrupt = childFlow.currentConstruct && childFlow.currentConstruct.interruptible;
            self.containerState = {};
            return effects.attempt($68ad841ab685197a$var$containerConstruct, inspectFlowEnd, inspectDone)(code);
        }
        function inspectContinue(code) {
            subcontinued++;
            return self.containerState._closeFlow ? inspectFlowEnd(code) : inspectStart(code);
        }
        function inspectLess(code) {
            if (childFlow.currentConstruct && childFlow.currentConstruct.lazy) {
                // Maybe another container?
                self.containerState = {};
                return effects.attempt($68ad841ab685197a$var$containerConstruct, inspectFlowEnd, effects.attempt($68ad841ab685197a$var$lazyFlowConstruct, inspectFlowEnd, effects.check($9em3z, inspectFlowEnd, inspectLazy)))(code);
            } // Otherwise we’re interrupting.
            return inspectFlowEnd(code);
        }
        function inspectLazy(code) {
            // Act as if all containers are continued.
            subcontinued = stack.length;
            inspectResult.lazy = true;
            inspectResult.flowContinue = true;
            return inspectDone(code);
        } // We’re done with flow if we have more containers, or an interruption.
        function inspectFlowEnd(code) {
            inspectResult.flowEnd = true;
            return inspectDone(code);
        }
        function inspectDone(code) {
            inspectResult.continued = subcontinued;
            self.interrupt = self.containerState = undefined;
            return ok(code);
        }
    }
}
function $68ad841ab685197a$var$tokenizeContainer(effects, ok, nok) {
    return $10n72(effects, effects.attempt(this.parser.constructs.document, ok, nok), "linePrefix", this.parser.constructs.disable.null.indexOf("codeIndented") > -1 ? undefined : 4);
}
function $68ad841ab685197a$var$tokenizeLazyFlow(effects, ok, nok) {
    return $10n72(effects, effects.lazy(this.parser.constructs.flow, ok, nok), "linePrefix", this.parser.constructs.disable.null.indexOf("codeIndented") > -1 ? undefined : 4);
}
module.exports.tokenize = $68ad841ab685197a$var$tokenize;

});
parcelRegister("9em3z", function(module, exports) {
"use strict";

var $bl5Ae = parcelRequire("bl5Ae");

var $10n72 = parcelRequire("10n72");
var $6b8687d77556d1c3$var$partialBlankLine = {
    tokenize: $6b8687d77556d1c3$var$tokenizePartialBlankLine,
    partial: true
};
function $6b8687d77556d1c3$var$tokenizePartialBlankLine(effects, ok, nok) {
    return $10n72(effects, afterWhitespace, "linePrefix");
    function afterWhitespace(code) {
        return code === null || $bl5Ae(code) ? ok(code) : nok(code);
    }
}
module.exports = $6b8687d77556d1c3$var$partialBlankLine;

});


parcelRegister("3gHLf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $aCNuy = parcelRequire("aCNuy");

var $10n72 = parcelRequire("10n72");

var $9em3z = parcelRequire("9em3z");
var $2614cfc6acea6433$var$tokenize = $2614cfc6acea6433$var$initializeFlow;
function $2614cfc6acea6433$var$initializeFlow(effects) {
    var self = this;
    var initial = effects.attempt(// Try to parse a blank line.
    $9em3z, atBlankEnding, effects.attempt(this.parser.constructs.flowInitial, afterConstruct, $10n72(effects, effects.attempt(this.parser.constructs.flow, afterConstruct, effects.attempt($aCNuy, afterConstruct)), "linePrefix")));
    return initial;
    function atBlankEnding(code) {
        if (code === null) {
            effects.consume(code);
            return;
        }
        effects.enter("lineEndingBlank");
        effects.consume(code);
        effects.exit("lineEndingBlank");
        self.currentConstruct = undefined;
        return initial;
    }
    function afterConstruct(code) {
        if (code === null) {
            effects.consume(code);
            return;
        }
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        self.currentConstruct = undefined;
        return initial;
    }
}
module.exports.tokenize = $2614cfc6acea6433$var$tokenize;

});
parcelRegister("aCNuy", function(module, exports) {
"use strict";

var $bl5Ae = parcelRequire("bl5Ae");

var $bUBdZ = parcelRequire("bUBdZ");

var $kzBoo = parcelRequire("kzBoo");

var $10n72 = parcelRequire("10n72");
// No name because it must not be turned off.
var $7bc3d80ea03d912e$var$content = {
    tokenize: $7bc3d80ea03d912e$var$tokenizeContent,
    resolve: $7bc3d80ea03d912e$var$resolveContent,
    interruptible: true,
    lazy: true
};
var $7bc3d80ea03d912e$var$continuationConstruct = {
    tokenize: $7bc3d80ea03d912e$var$tokenizeContinuation,
    partial: true
} // Content is transparent: it’s parsed right now. That way, definitions are also
;
// parsed right now: before text in paragraphs (specifically, media) are parsed.
function $7bc3d80ea03d912e$var$resolveContent(events) {
    $kzBoo(events);
    return events;
}
function $7bc3d80ea03d912e$var$tokenizeContent(effects, ok) {
    var previous;
    return start;
    function start(code) {
        effects.enter("content");
        previous = effects.enter("chunkContent", {
            contentType: "content"
        });
        return data(code);
    }
    function data(code) {
        if (code === null) return contentEnd(code);
        if ($bl5Ae(code)) return effects.check($7bc3d80ea03d912e$var$continuationConstruct, contentContinue, contentEnd)(code);
         // Data.
        effects.consume(code);
        return data;
    }
    function contentEnd(code) {
        effects.exit("chunkContent");
        effects.exit("content");
        return ok(code);
    }
    function contentContinue(code) {
        effects.consume(code);
        effects.exit("chunkContent");
        previous = previous.next = effects.enter("chunkContent", {
            contentType: "content",
            previous: previous
        });
        return data;
    }
}
function $7bc3d80ea03d912e$var$tokenizeContinuation(effects, ok, nok) {
    var self = this;
    return startLookahead;
    function startLookahead(code) {
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return $10n72(effects, prefixed, "linePrefix");
    }
    function prefixed(code) {
        if (code === null || $bl5Ae(code)) return nok(code);
        if (self.parser.constructs.disable.null.indexOf("codeIndented") > -1 || $bUBdZ(self.events, "linePrefix") < 4) return effects.interrupt(self.parser.constructs.flow, nok, ok)(code);
        return ok(code);
    }
}
module.exports = $7bc3d80ea03d912e$var$content;

});
parcelRegister("bUBdZ", function(module, exports) {
"use strict";

var $5rIMu = parcelRequire("5rIMu");
function $8ac1ccb5a08e6c9e$var$prefixSize(events, type) {
    var tail = events[events.length - 1];
    if (!tail || tail[1].type !== type) return 0;
    return $5rIMu(tail[2].sliceStream(tail[1]));
}
module.exports = $8ac1ccb5a08e6c9e$var$prefixSize;

});
parcelRegister("5rIMu", function(module, exports) {
"use strict";
// Counts tabs based on their expanded size, and CR+LF as one character.
function $3f7235f71b6a2ad1$var$sizeChunks(chunks) {
    var index = -1;
    var size = 0;
    while(++index < chunks.length)size += typeof chunks[index] === "string" ? chunks[index].length : 1;
    return size;
}
module.exports = $3f7235f71b6a2ad1$var$sizeChunks;

});


parcelRegister("kzBoo", function(module, exports) {
"use strict";

var $37cBN = parcelRequire("37cBN");

var $9Q1oe = parcelRequire("9Q1oe");

var $1Gh3S = parcelRequire("1Gh3S");
function $efa414e392210bc3$var$subtokenize(events) {
    var jumps = {};
    var index = -1;
    var event;
    var lineIndex;
    var otherIndex;
    var otherEvent;
    var parameters;
    var subevents;
    var more;
    while(++index < events.length){
        while(index in jumps)index = jumps[index];
        event = events[index] // Add a hook for the GFM tasklist extension, which needs to know if text
        ;
        // is in the first content of a list item.
        if (index && event[1].type === "chunkFlow" && events[index - 1][1].type === "listItemPrefix") {
            subevents = event[1]._tokenizer.events;
            otherIndex = 0;
            if (otherIndex < subevents.length && subevents[otherIndex][1].type === "lineEndingBlank") otherIndex += 2;
            if (otherIndex < subevents.length && subevents[otherIndex][1].type === "content") while(++otherIndex < subevents.length){
                if (subevents[otherIndex][1].type === "content") break;
                if (subevents[otherIndex][1].type === "chunkText") {
                    subevents[otherIndex][1].isInFirstContentOfListItem = true;
                    otherIndex++;
                }
            }
        } // Enter.
        if (event[0] === "enter") {
            if (event[1].contentType) {
                $37cBN(jumps, $efa414e392210bc3$var$subcontent(events, index));
                index = jumps[index];
                more = true;
            }
        } else if (event[1]._container || event[1]._movePreviousLineEndings) {
            otherIndex = index;
            lineIndex = undefined;
            while(otherIndex--){
                otherEvent = events[otherIndex];
                if (otherEvent[1].type === "lineEnding" || otherEvent[1].type === "lineEndingBlank") {
                    if (otherEvent[0] === "enter") {
                        if (lineIndex) events[lineIndex][1].type = "lineEndingBlank";
                        otherEvent[1].type = "lineEnding";
                        lineIndex = otherIndex;
                    }
                } else break;
            }
            if (lineIndex) {
                // Fix position.
                event[1].end = $1Gh3S(events[lineIndex][1].start) // Switch container exit w/ line endings.
                ;
                parameters = events.slice(lineIndex, index);
                parameters.unshift(event);
                $9Q1oe(events, lineIndex, index - lineIndex + 1, parameters);
            }
        }
    }
    return !more;
}
function $efa414e392210bc3$var$subcontent(events, eventIndex) {
    var token = events[eventIndex][1];
    var context = events[eventIndex][2];
    var startPosition = eventIndex - 1;
    var startPositions = [];
    var tokenizer = token._tokenizer || context.parser[token.contentType](token.start);
    var childEvents = tokenizer.events;
    var jumps = [];
    var gaps = {};
    var stream;
    var previous;
    var index;
    var entered;
    var end;
    var adjust // Loop forward through the linked tokens to pass them in order to the
    ;
    // subtokenizer.
    while(token){
        // Find the position of the event for this token.
        while(events[++startPosition][1] !== token);
        startPositions.push(startPosition);
        if (!token._tokenizer) {
            stream = context.sliceStream(token);
            if (!token.next) stream.push(null);
            if (previous) tokenizer.defineSkip(token.start);
            if (token.isInFirstContentOfListItem) tokenizer._gfmTasklistFirstContentOfListItem = true;
            tokenizer.write(stream);
            if (token.isInFirstContentOfListItem) tokenizer._gfmTasklistFirstContentOfListItem = undefined;
        } // Unravel the next token.
        previous = token;
        token = token.next;
    } // Now, loop back through all events (and linked tokens), to figure out which
    // parts belong where.
    token = previous;
    index = childEvents.length;
    while(index--){
        // Make sure we’ve at least seen something (final eol is part of the last
        // token).
        if (childEvents[index][0] === "enter") entered = true;
        else if (// Find a void token that includes a break.
        entered && childEvents[index][1].type === childEvents[index - 1][1].type && childEvents[index][1].start.line !== childEvents[index][1].end.line) {
            add(childEvents.slice(index + 1, end));
            // Help GC.
            token._tokenizer = token.next = undefined;
            token = token.previous;
            end = index + 1;
        }
    }
    // Help GC.
    tokenizer.events = token._tokenizer = token.next = undefined // Do head:
    ;
    add(childEvents.slice(0, end));
    index = -1;
    adjust = 0;
    while(++index < jumps.length){
        gaps[adjust + jumps[index][0]] = adjust + jumps[index][1];
        adjust += jumps[index][1] - jumps[index][0] - 1;
    }
    return gaps;
    function add(slice) {
        var start = startPositions.pop();
        jumps.unshift([
            start,
            start + slice.length - 1
        ]);
        $9Q1oe(events, start, 2, slice);
    }
}
module.exports = $efa414e392210bc3$var$subtokenize;

});
parcelRegister("9Q1oe", function(module, exports) {
"use strict";

var $jpRg0 = parcelRequire("jpRg0");
// causes a stack overflow in V8 when trying to insert 100k items for instance.
function $729a0c6528f6e202$var$chunkedSplice(list, start, remove, items) {
    var end = list.length;
    var chunkStart = 0;
    var parameters // Make start between zero and `end` (included).
    ;
    if (start < 0) start = -start > end ? 0 : end + start;
    else start = start > end ? end : start;
    remove = remove > 0 ? remove : 0 // No need to chunk the items if there’s only a couple (10k) items.
    ;
    if (items.length < 10000) {
        parameters = Array.from(items);
        parameters.unshift(start, remove);
        $jpRg0.apply(list, parameters);
    } else {
        // Delete `remove` items starting from `start`
        if (remove) $jpRg0.apply(list, [
            start,
            remove
        ]) // Insert the items in chunks to not cause stack overflows.
        ;
        while(chunkStart < items.length){
            parameters = items.slice(chunkStart, chunkStart + 10000);
            parameters.unshift(start, 0);
            $jpRg0.apply(list, parameters);
            chunkStart += 10000;
            start += 10000;
        }
    }
}
module.exports = $729a0c6528f6e202$var$chunkedSplice;

});
parcelRegister("jpRg0", function(module, exports) {
"use strict";
var $e229a9dcd185861d$var$splice = [].splice;
module.exports = $e229a9dcd185861d$var$splice;

});


parcelRegister("1Gh3S", function(module, exports) {
"use strict";

var $37cBN = parcelRequire("37cBN");
function $1396f2c03451bdda$var$shallow(object) {
    return $37cBN({}, object);
}
module.exports = $1396f2c03451bdda$var$shallow;

});




parcelRegister("7zJWl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $37cBN = parcelRequire("37cBN");

var $1Gh3S = parcelRequire("1Gh3S");
var $583f7005874c2006$var$text = $583f7005874c2006$var$initializeFactory("text");
var $583f7005874c2006$var$string = $583f7005874c2006$var$initializeFactory("string");
var $583f7005874c2006$var$resolver = {
    resolveAll: $583f7005874c2006$var$createResolver()
};
function $583f7005874c2006$var$initializeFactory(field) {
    return {
        tokenize: initializeText,
        resolveAll: $583f7005874c2006$var$createResolver(field === "text" ? $583f7005874c2006$var$resolveAllLineSuffixes : undefined)
    };
    function initializeText(effects) {
        var self = this;
        var constructs = this.parser.constructs[field];
        var text = effects.attempt(constructs, start, notText);
        return start;
        function start(code) {
            return atBreak(code) ? text(code) : notText(code);
        }
        function notText(code) {
            if (code === null) {
                effects.consume(code);
                return;
            }
            effects.enter("data");
            effects.consume(code);
            return data;
        }
        function data(code) {
            if (atBreak(code)) {
                effects.exit("data");
                return text(code);
            } // Data.
            effects.consume(code);
            return data;
        }
        function atBreak(code) {
            var list = constructs[code];
            var index = -1;
            if (code === null) return true;
            if (list) while(++index < list.length){
                if (!list[index].previous || list[index].previous.call(self, self.previous)) return true;
            }
        }
    }
}
function $583f7005874c2006$var$createResolver(extraResolver) {
    return resolveAllText;
    function resolveAllText(events, context) {
        var index = -1;
        var enter // A rather boring computation (to merge adjacent `data` events) which
        ;
        // improves mm performance by 29%.
        while(++index <= events.length){
            if (enter === undefined) {
                if (events[index] && events[index][1].type === "data") {
                    enter = index;
                    index++;
                }
            } else if (!events[index] || events[index][1].type !== "data") {
                // Don’t do anything if there is one data token.
                if (index !== enter + 2) {
                    events[enter][1].end = events[index - 1][1].end;
                    events.splice(enter + 2, index - enter - 2);
                    index = enter + 2;
                }
                enter = undefined;
            }
        }
        return extraResolver ? extraResolver(events, context) : events;
    }
} // A rather ugly set of instructions which again looks at chunks in the input
// stream.
// The reason to do this here is that it is *much* faster to parse in reverse.
// And that we can’t hook into `null` to split the line suffix before an EOF.
// To do: figure out if we can make this into a clean utility, or even in core.
// As it will be useful for GFMs literal autolink extension (and maybe even
// tables?)
function $583f7005874c2006$var$resolveAllLineSuffixes(events, context) {
    var eventIndex = -1;
    var chunks;
    var data;
    var chunk;
    var index;
    var bufferIndex;
    var size;
    var tabs;
    var token;
    while(++eventIndex <= events.length)if ((eventIndex === events.length || events[eventIndex][1].type === "lineEnding") && events[eventIndex - 1][1].type === "data") {
        data = events[eventIndex - 1][1];
        chunks = context.sliceStream(data);
        index = chunks.length;
        bufferIndex = -1;
        size = 0;
        tabs = undefined;
        while(index--){
            chunk = chunks[index];
            if (typeof chunk === "string") {
                bufferIndex = chunk.length;
                while(chunk.charCodeAt(bufferIndex - 1) === 32){
                    size++;
                    bufferIndex--;
                }
                if (bufferIndex) break;
                bufferIndex = -1;
            } else if (chunk === -2) {
                tabs = true;
                size++;
            } else if (chunk === -1) ;
            else {
                // Replacement character, exit.
                index++;
                break;
            }
        }
        if (size) {
            token = {
                type: eventIndex === events.length || tabs || size < 2 ? "lineSuffix" : "hardBreakTrailing",
                start: {
                    line: data.end.line,
                    column: data.end.column - size,
                    offset: data.end.offset - size,
                    _index: data.start._index + index,
                    _bufferIndex: index ? bufferIndex : data.start._bufferIndex + bufferIndex
                },
                end: $1Gh3S(data.end)
            };
            data.end = $1Gh3S(token.start);
            if (data.start.offset === data.end.offset) $37cBN(data, token);
            else {
                events.splice(eventIndex, 0, [
                    "enter",
                    token,
                    context
                ], [
                    "exit",
                    token,
                    context
                ]);
                eventIndex += 2;
            }
        }
        eventIndex++;
    }
    return events;
}
module.exports.resolver = $583f7005874c2006$var$resolver;
module.exports.string = $583f7005874c2006$var$string;
module.exports.text = $583f7005874c2006$var$text;

});

parcelRegister("jL26E", function(module, exports) {
"use strict";

var $ffxyv = parcelRequire("ffxyv");

var $9Q1oe = parcelRequire("9Q1oe");

var $5EpjL = parcelRequire("5EpjL");
function $e6240a5d5b2dcf23$var$combineExtensions(extensions) {
    var all = {};
    var index = -1;
    while(++index < extensions.length)$e6240a5d5b2dcf23$var$extension(all, extensions[index]);
    return all;
}
function $e6240a5d5b2dcf23$var$extension(all, extension) {
    var hook;
    var left;
    var right;
    var code;
    for(hook in extension){
        left = $ffxyv.call(all, hook) ? all[hook] : all[hook] = {};
        right = extension[hook];
        for(code in right)left[code] = $e6240a5d5b2dcf23$var$constructs($5EpjL(right[code]), $ffxyv.call(left, code) ? left[code] : []);
    }
}
function $e6240a5d5b2dcf23$var$constructs(list, existing) {
    var index = -1;
    var before = [];
    while(++index < list.length)(list[index].add === "after" ? existing : before).push(list[index]);
    $9Q1oe(existing, 0, 0, before);
    return existing;
}
module.exports = $e6240a5d5b2dcf23$var$combineExtensions;

});
parcelRegister("5EpjL", function(module, exports) {
"use strict";
function $41d453c2d53c7900$var$miniflat(value) {
    return value === null || value === undefined ? [] : "length" in value ? value : [
        value
    ];
}
module.exports = $41d453c2d53c7900$var$miniflat;

});


parcelRegister("i37N3", function(module, exports) {
"use strict";

var $37cBN = parcelRequire("37cBN");

var $bl5Ae = parcelRequire("bl5Ae");

var $6jG9Y = parcelRequire("6jG9Y");

var $9Q1oe = parcelRequire("9Q1oe");

var $5EpjL = parcelRequire("5EpjL");

var $5ZU3u = parcelRequire("5ZU3u");

var $56FCn = parcelRequire("56FCn");

var $1Gh3S = parcelRequire("1Gh3S");

var $5Z1aC = parcelRequire("5Z1aC");
// Create a tokenizer.
// Tokenizers deal with one type of data (e.g., containers, flow, text).
// The parser is the object dealing with it all.
// `initialize` works like other constructs, except that only its `tokenize`
// function is used, in which case it doesn’t receive an `ok` or `nok`.
// `from` can be given to set the point before the first character, although
// when further lines are indented, they must be set with `defineSkip`.
function $d23e8ccdd317b177$var$createTokenizer(parser, initialize, from) {
    var point = from ? $1Gh3S(from) : {
        line: 1,
        column: 1,
        offset: 0
    };
    var columnStart = {};
    var resolveAllConstructs = [];
    var chunks = [];
    var stack = [];
    var effects = {
        consume: consume,
        enter: enter,
        exit: exit,
        attempt: constructFactory(onsuccessfulconstruct),
        check: constructFactory(onsuccessfulcheck),
        interrupt: constructFactory(onsuccessfulcheck, {
            interrupt: true
        }),
        lazy: constructFactory(onsuccessfulcheck, {
            lazy: true
        })
    } // State and tools for resolving and serializing.
    ;
    var context = {
        previous: null,
        events: [],
        parser: parser,
        sliceStream: sliceStream,
        sliceSerialize: sliceSerialize,
        now: now,
        defineSkip: skip,
        write: write
    } // The state function.
    ;
    var state = initialize.tokenize.call(context, effects) // Track which character we expect to be consumed, to catch bugs.
    ;
    if (initialize.resolveAll) resolveAllConstructs.push(initialize);
     // Store where we are in the input stream.
    point._index = 0;
    point._bufferIndex = -1;
    return context;
    function write(slice) {
        chunks = $6jG9Y(chunks, slice);
        main() // Exit if we’re not done, resolve might change stuff.
        ;
        if (chunks[chunks.length - 1] !== null) return [];
        addResult(initialize, 0) // Otherwise, resolve, and exit.
        ;
        context.events = $5ZU3u(resolveAllConstructs, context.events, context);
        return context.events;
    } //
    // Tools.
    //
    function sliceSerialize(token) {
        return $56FCn(sliceStream(token));
    }
    function sliceStream(token) {
        return $5Z1aC(chunks, token);
    }
    function now() {
        return $1Gh3S(point);
    }
    function skip(value) {
        columnStart[value.line] = value.column;
        accountForPotentialSkip();
    } //
    // State management.
    //
    // Main loop (note that `_index` and `_bufferIndex` in `point` are modified by
    // `consume`).
    // Here is where we walk through the chunks, which either include strings of
    // several characters, or numerical character codes.
    // The reason to do this in a loop instead of a call is so the stack can
    // drain.
    function main() {
        var chunkIndex;
        var chunk;
        while(point._index < chunks.length){
            chunk = chunks[point._index] // If we’re in a buffer chunk, loop through it.
            ;
            if (typeof chunk === "string") {
                chunkIndex = point._index;
                if (point._bufferIndex < 0) point._bufferIndex = 0;
                while(point._index === chunkIndex && point._bufferIndex < chunk.length)go(chunk.charCodeAt(point._bufferIndex));
            } else go(chunk);
        }
    } // Deal with one code.
    function go(code) {
        state = state(code);
    } // Move a character forward.
    function consume(code) {
        if ($bl5Ae(code)) {
            point.line++;
            point.column = 1;
            point.offset += code === -3 ? 2 : 1;
            accountForPotentialSkip();
        } else if (code !== -1) {
            point.column++;
            point.offset++;
        } // Not in a string chunk.
        if (point._bufferIndex < 0) point._index++;
        else {
            point._bufferIndex++ // At end of string chunk.
            ;
            if (point._bufferIndex === chunks[point._index].length) {
                point._bufferIndex = -1;
                point._index++;
            }
        } // Expose the previous character.
        context.previous = code // Mark as consumed.
        ;
    } // Start a token.
    function enter(type, fields) {
        var token = fields || {};
        token.type = type;
        token.start = now();
        context.events.push([
            "enter",
            token,
            context
        ]);
        stack.push(token);
        return token;
    } // Stop a token.
    function exit(type) {
        var token = stack.pop();
        token.end = now();
        context.events.push([
            "exit",
            token,
            context
        ]);
        return token;
    } // Use results.
    function onsuccessfulconstruct(construct, info) {
        addResult(construct, info.from);
    } // Discard results.
    function onsuccessfulcheck(construct, info) {
        info.restore();
    } // Factory to attempt/check/interrupt.
    function constructFactory(onreturn, fields) {
        return hook // Handle either an object mapping codes to constructs, a list of
        ;
        // constructs, or a single construct.
        function hook(constructs, returnState, bogusState) {
            var listOfConstructs;
            var constructIndex;
            var currentConstruct;
            var info;
            return constructs.tokenize || "length" in constructs ? handleListOfConstructs($5EpjL(constructs)) : handleMapOfConstructs;
            function handleMapOfConstructs(code) {
                if (code in constructs || null in constructs) return handleListOfConstructs(constructs.null ? /* c8 ignore next */ $5EpjL(constructs[code]).concat($5EpjL(constructs.null)) : constructs[code])(code);
                return bogusState(code);
            }
            function handleListOfConstructs(list) {
                listOfConstructs = list;
                constructIndex = 0;
                return handleConstruct(list[constructIndex]);
            }
            function handleConstruct(construct) {
                return start;
                function start(code) {
                    // To do: not nede to store if there is no bogus state, probably?
                    // Currently doesn’t work because `inspect` in document does a check
                    // w/o a bogus, which doesn’t make sense. But it does seem to help perf
                    // by not storing.
                    info = store();
                    currentConstruct = construct;
                    if (!construct.partial) context.currentConstruct = construct;
                    if (construct.name && context.parser.constructs.disable.null.indexOf(construct.name) > -1) return nok();
                    return construct.tokenize.call(fields ? $37cBN({}, context, fields) : context, effects, ok, nok)(code);
                }
            }
            function ok(code) {
                onreturn(currentConstruct, info);
                return returnState;
            }
            function nok(code) {
                info.restore();
                if (++constructIndex < listOfConstructs.length) return handleConstruct(listOfConstructs[constructIndex]);
                return bogusState;
            }
        }
    }
    function addResult(construct, from) {
        if (construct.resolveAll && resolveAllConstructs.indexOf(construct) < 0) resolveAllConstructs.push(construct);
        if (construct.resolve) $9Q1oe(context.events, from, context.events.length - from, construct.resolve(context.events.slice(from), context));
        if (construct.resolveTo) context.events = construct.resolveTo(context.events, context);
    }
    function store() {
        var startPoint = now();
        var startPrevious = context.previous;
        var startCurrentConstruct = context.currentConstruct;
        var startEventsIndex = context.events.length;
        var startStack = Array.from(stack);
        return {
            restore: restore,
            from: startEventsIndex
        };
        function restore() {
            point = startPoint;
            context.previous = startPrevious;
            context.currentConstruct = startCurrentConstruct;
            context.events.length = startEventsIndex;
            stack = startStack;
            accountForPotentialSkip();
        }
    }
    function accountForPotentialSkip() {
        if (point.line in columnStart && point.column < 2) {
            point.column = columnStart[point.line];
            point.offset += columnStart[point.line] - 1;
        }
    }
}
module.exports = $d23e8ccdd317b177$var$createTokenizer;

});
parcelRegister("6jG9Y", function(module, exports) {
"use strict";

var $9Q1oe = parcelRequire("9Q1oe");
function $49953878f965e6a4$var$chunkedPush(list, items) {
    if (list.length) {
        $9Q1oe(list, list.length, 0, items);
        return list;
    }
    return items;
}
module.exports = $49953878f965e6a4$var$chunkedPush;

});

parcelRegister("5ZU3u", function(module, exports) {
"use strict";
function $45de21ae342607c4$var$resolveAll(constructs, events, context) {
    var called = [];
    var index = -1;
    var resolve;
    while(++index < constructs.length){
        resolve = constructs[index].resolveAll;
        if (resolve && called.indexOf(resolve) < 0) {
            events = resolve(events, context);
            called.push(resolve);
        }
    }
    return events;
}
module.exports = $45de21ae342607c4$var$resolveAll;

});

parcelRegister("56FCn", function(module, exports) {
"use strict";

var $iaAMG = parcelRequire("iaAMG");
function $3b7dcbc2d450a56a$var$serializeChunks(chunks) {
    var index = -1;
    var result = [];
    var chunk;
    var value;
    var atTab;
    while(++index < chunks.length){
        chunk = chunks[index];
        if (typeof chunk === "string") value = chunk;
        else if (chunk === -5) value = "\r";
        else if (chunk === -4) value = "\n";
        else if (chunk === -3) value = "\r\n";
        else if (chunk === -2) value = "	";
        else if (chunk === -1) {
            if (atTab) continue;
            value = " ";
        } else // Currently only replacement character.
        value = $iaAMG(chunk);
        atTab = chunk === -2;
        result.push(value);
    }
    return result.join("");
}
module.exports = $3b7dcbc2d450a56a$var$serializeChunks;

});

parcelRegister("5Z1aC", function(module, exports) {
"use strict";
function $45b38ea0e88b1150$var$sliceChunks(chunks, token) {
    var startIndex = token.start._index;
    var startBufferIndex = token.start._bufferIndex;
    var endIndex = token.end._index;
    var endBufferIndex = token.end._bufferIndex;
    var view;
    if (startIndex === endIndex) view = [
        chunks[startIndex].slice(startBufferIndex, endBufferIndex)
    ];
    else {
        view = chunks.slice(startIndex, endIndex);
        if (startBufferIndex > -1) view[0] = view[0].slice(startBufferIndex);
        if (endBufferIndex > 0) view.push(chunks[endIndex].slice(0, endBufferIndex));
    }
    return view;
}
module.exports = $45b38ea0e88b1150$var$sliceChunks;

});


parcelRegister("fgcfR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $7zJWl = parcelRequire("7zJWl");

var $4M8lw = parcelRequire("4M8lw");

var $9j6SN = parcelRequire("9j6SN");

var $dbFbQ = parcelRequire("dbFbQ");

var $ivizM = parcelRequire("ivizM");

var $546s7 = parcelRequire("546s7");

var $7Tc0q = parcelRequire("7Tc0q");

var $gEZYG = parcelRequire("gEZYG");

var $cBoLz = parcelRequire("cBoLz");

var $49kdc = parcelRequire("49kdc");

var $4nvRC = parcelRequire("4nvRC");

var $j2t7S = parcelRequire("j2t7S");

var $hkodS = parcelRequire("hkodS");

var $5oF5S = parcelRequire("5oF5S");

var $9m5UN = parcelRequire("9m5UN");

var $7dco3 = parcelRequire("7dco3");

var $2fkxI = parcelRequire("2fkxI");

var $dkR72 = parcelRequire("dkR72");

var $hTP9P = parcelRequire("hTP9P");

var $1ncd9 = parcelRequire("1ncd9");

var $6JLsZ = parcelRequire("6JLsZ");
var $b1c1db36706ac8fd$var$document = {
    42: $hTP9P,
    // Asterisk
    43: $hTP9P,
    // Plus sign
    45: $hTP9P,
    // Dash
    48: $hTP9P,
    // 0
    49: $hTP9P,
    // 1
    50: $hTP9P,
    // 2
    51: $hTP9P,
    // 3
    52: $hTP9P,
    // 4
    53: $hTP9P,
    // 5
    54: $hTP9P,
    // 6
    55: $hTP9P,
    // 7
    56: $hTP9P,
    // 8
    57: $hTP9P,
    // 9
    62: $dbFbQ // Greater than
};
var $b1c1db36706ac8fd$var$contentInitial = {
    91: $49kdc // Left square bracket
};
var $b1c1db36706ac8fd$var$flowInitial = {
    "-2": $gEZYG,
    // Horizontal tab
    "-1": $gEZYG,
    // Virtual space
    32: $gEZYG // Space
};
var $b1c1db36706ac8fd$var$flow = {
    35: $j2t7S,
    // Number sign
    42: $6JLsZ,
    // Asterisk
    45: [
        $1ncd9,
        $6JLsZ
    ],
    // Dash
    60: $hkodS,
    // Less than
    61: $1ncd9,
    // Equals to
    95: $6JLsZ,
    // Underscore
    96: $7Tc0q,
    // Grave accent
    126: $7Tc0q // Tilde
};
var $b1c1db36706ac8fd$var$string = {
    38: $546s7,
    // Ampersand
    92: $ivizM // Backslash
};
var $b1c1db36706ac8fd$var$text = {
    "-5": $dkR72,
    // Carriage return
    "-4": $dkR72,
    // Line feed
    "-3": $dkR72,
    // Carriage return + line feed
    33: $7dco3,
    // Exclamation mark
    38: $546s7,
    // Ampersand
    42: $4M8lw,
    // Asterisk
    60: [
        $9j6SN,
        $5oF5S
    ],
    // Less than
    91: $2fkxI,
    // Left square bracket
    92: [
        $4nvRC,
        $ivizM
    ],
    // Backslash
    93: $9m5UN,
    // Right square bracket
    95: $4M8lw,
    // Underscore
    96: $cBoLz // Grave accent
};
var $b1c1db36706ac8fd$var$insideSpan = {
    null: [
        $4M8lw,
        $7zJWl.resolver
    ]
};
var $b1c1db36706ac8fd$var$disable = {
    null: []
};
module.exports.contentInitial = $b1c1db36706ac8fd$var$contentInitial;
module.exports.disable = $b1c1db36706ac8fd$var$disable;
module.exports.document = $b1c1db36706ac8fd$var$document;
module.exports.flow = $b1c1db36706ac8fd$var$flow;
module.exports.flowInitial = $b1c1db36706ac8fd$var$flowInitial;
module.exports.insideSpan = $b1c1db36706ac8fd$var$insideSpan;
module.exports.string = $b1c1db36706ac8fd$var$string;
module.exports.text = $b1c1db36706ac8fd$var$text;

});
parcelRegister("4M8lw", function(module, exports) {
"use strict";

var $6jG9Y = parcelRequire("6jG9Y");

var $9Q1oe = parcelRequire("9Q1oe");

var $372dT = parcelRequire("372dT");

var $ji9a7 = parcelRequire("ji9a7");

var $5ZU3u = parcelRequire("5ZU3u");

var $1Gh3S = parcelRequire("1Gh3S");
var $37a21e7e9322062d$var$attention = {
    name: "attention",
    tokenize: $37a21e7e9322062d$var$tokenizeAttention,
    resolveAll: $37a21e7e9322062d$var$resolveAllAttention
};
function $37a21e7e9322062d$var$resolveAllAttention(events, context) {
    var index = -1;
    var open;
    var group;
    var text;
    var openingSequence;
    var closingSequence;
    var use;
    var nextEvents;
    var offset // Walk through all events.
    ;
    //
    // Note: performance of this is fine on an mb of normal markdown, but it’s
    // a bottleneck for malicious stuff.
    while(++index < events.length)// Find a token that can close.
    if (events[index][0] === "enter" && events[index][1].type === "attentionSequence" && events[index][1]._close) {
        open = index // Now walk back to find an opener.
        ;
        while(open--)// Find a token that can open the closer.
        if (events[open][0] === "exit" && events[open][1].type === "attentionSequence" && events[open][1]._open && // If the markers are the same:
        context.sliceSerialize(events[open][1]).charCodeAt(0) === context.sliceSerialize(events[index][1]).charCodeAt(0)) {
            // If the opening can close or the closing can open,
            // and the close size *is not* a multiple of three,
            // but the sum of the opening and closing size *is* multiple of three,
            // then don’t match.
            if ((events[open][1]._close || events[index][1]._open) && (events[index][1].end.offset - events[index][1].start.offset) % 3 && !((events[open][1].end.offset - events[open][1].start.offset + events[index][1].end.offset - events[index][1].start.offset) % 3)) continue;
             // Number of markers to use from the sequence.
            use = events[open][1].end.offset - events[open][1].start.offset > 1 && events[index][1].end.offset - events[index][1].start.offset > 1 ? 2 : 1;
            openingSequence = {
                type: use > 1 ? "strongSequence" : "emphasisSequence",
                start: $ji9a7($1Gh3S(events[open][1].end), -use),
                end: $1Gh3S(events[open][1].end)
            };
            closingSequence = {
                type: use > 1 ? "strongSequence" : "emphasisSequence",
                start: $1Gh3S(events[index][1].start),
                end: $ji9a7($1Gh3S(events[index][1].start), use)
            };
            text = {
                type: use > 1 ? "strongText" : "emphasisText",
                start: $1Gh3S(events[open][1].end),
                end: $1Gh3S(events[index][1].start)
            };
            group = {
                type: use > 1 ? "strong" : "emphasis",
                start: $1Gh3S(openingSequence.start),
                end: $1Gh3S(closingSequence.end)
            };
            events[open][1].end = $1Gh3S(openingSequence.start);
            events[index][1].start = $1Gh3S(closingSequence.end);
            nextEvents = [] // If there are more markers in the opening, add them before.
            ;
            if (events[open][1].end.offset - events[open][1].start.offset) nextEvents = $6jG9Y(nextEvents, [
                [
                    "enter",
                    events[open][1],
                    context
                ],
                [
                    "exit",
                    events[open][1],
                    context
                ]
            ]);
             // Opening.
            nextEvents = $6jG9Y(nextEvents, [
                [
                    "enter",
                    group,
                    context
                ],
                [
                    "enter",
                    openingSequence,
                    context
                ],
                [
                    "exit",
                    openingSequence,
                    context
                ],
                [
                    "enter",
                    text,
                    context
                ]
            ]) // Between.
            ;
            nextEvents = $6jG9Y(nextEvents, $5ZU3u(context.parser.constructs.insideSpan.null, events.slice(open + 1, index), context)) // Closing.
            ;
            nextEvents = $6jG9Y(nextEvents, [
                [
                    "exit",
                    text,
                    context
                ],
                [
                    "enter",
                    closingSequence,
                    context
                ],
                [
                    "exit",
                    closingSequence,
                    context
                ],
                [
                    "exit",
                    group,
                    context
                ]
            ]) // If there are more markers in the closing, add them after.
            ;
            if (events[index][1].end.offset - events[index][1].start.offset) {
                offset = 2;
                nextEvents = $6jG9Y(nextEvents, [
                    [
                        "enter",
                        events[index][1],
                        context
                    ],
                    [
                        "exit",
                        events[index][1],
                        context
                    ]
                ]);
            } else offset = 0;
            $9Q1oe(events, open - 1, index - open + 3, nextEvents);
            index = open + nextEvents.length - offset - 2;
            break;
        }
    }
     // Remove remaining sequences.
    index = -1;
    while(++index < events.length)if (events[index][1].type === "attentionSequence") events[index][1].type = "data";
    return events;
}
function $37a21e7e9322062d$var$tokenizeAttention(effects, ok) {
    var before = $372dT(this.previous);
    var marker;
    return start;
    function start(code) {
        effects.enter("attentionSequence");
        marker = code;
        return sequence(code);
    }
    function sequence(code) {
        var token;
        var after;
        var open;
        var close;
        if (code === marker) {
            effects.consume(code);
            return sequence;
        }
        token = effects.exit("attentionSequence");
        after = $372dT(code);
        open = !after || after === 2 && before;
        close = !before || before === 2 && after;
        token._open = marker === 42 ? open : open && (before || !close);
        token._close = marker === 42 ? close : close && (after || !open);
        return ok(code);
    }
}
module.exports = $37a21e7e9322062d$var$attention;

});
parcelRegister("372dT", function(module, exports) {
"use strict";

var $5zMHo = parcelRequire("5zMHo");

var $eavH7 = parcelRequire("eavH7");

var $1mH0l = parcelRequire("1mH0l");
// Classify whether a character is unicode whitespace, unicode punctuation, or
// anything else.
// Used for attention (emphasis, strong), whose sequences can open or close
// based on the class of surrounding characters.
function $2443c00325c45520$var$classifyCharacter(code) {
    if (code === null || $5zMHo(code) || $1mH0l(code)) return 1;
    if ($eavH7(code)) return 2;
}
module.exports = $2443c00325c45520$var$classifyCharacter;

});
parcelRegister("5zMHo", function(module, exports) {
"use strict";
function $40f5ff3371a0baba$var$markdownLineEndingOrSpace(code) {
    return code < 0 || code === 32;
}
module.exports = $40f5ff3371a0baba$var$markdownLineEndingOrSpace;

});

parcelRegister("eavH7", function(module, exports) {
"use strict";

var $fwxdI = parcelRequire("fwxdI");

var $gx0ph = parcelRequire("gx0ph");
// In fact adds to the bundle size.
var $a50a95bb6596f49d$var$unicodePunctuation = $gx0ph($fwxdI);
module.exports = $a50a95bb6596f49d$var$unicodePunctuation;

});
parcelRegister("fwxdI", function(module, exports) {
"use strict";
// This module is generated by `script/`.
//
// CommonMark handles attention (emphasis, strong) markers based on what comes
// before or after them.
// One such difference is if those characters are Unicode punctuation.
// This script is generated from the Unicode data.
var $b4d39d011099fe59$var$unicodePunctuation = /[!-\/:-@\[-`\{-~\xA1\xA7\xAB\xB6\xB7\xBB\xBF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061E\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u09FD\u0A76\u0AF0\u0C77\u0C84\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2308-\u230B\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E4F\u2E52\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]/;
module.exports = $b4d39d011099fe59$var$unicodePunctuation;

});

parcelRegister("gx0ph", function(module, exports) {
"use strict";

var $iaAMG = parcelRequire("iaAMG");
function $c0900b3390b0fde2$var$regexCheck(regex) {
    return check;
    function check(code) {
        return regex.test($iaAMG(code));
    }
}
module.exports = $c0900b3390b0fde2$var$regexCheck;

});


parcelRegister("1mH0l", function(module, exports) {
"use strict";

var $gx0ph = parcelRequire("gx0ph");
var $0fe934530ac1d549$var$unicodeWhitespace = $gx0ph(/\s/);
module.exports = $0fe934530ac1d549$var$unicodeWhitespace;

});


parcelRegister("ji9a7", function(module, exports) {
"use strict";
// chunks (replacement characters, tabs, or line endings).
function $e0b6ce28e5c2ca8a$var$movePoint(point, offset) {
    point.column += offset;
    point.offset += offset;
    point._bufferIndex += offset;
    return point;
}
module.exports = $e0b6ce28e5c2ca8a$var$movePoint;

});


parcelRegister("9j6SN", function(module, exports) {
"use strict";

var $gMacN = parcelRequire("gMacN");

var $ja7BD = parcelRequire("ja7BD");

var $aMtuc = parcelRequire("aMtuc");

var $glVfv = parcelRequire("glVfv");
var $6c6b3a2d2f203e72$var$autolink = {
    name: "autolink",
    tokenize: $6c6b3a2d2f203e72$var$tokenizeAutolink
};
function $6c6b3a2d2f203e72$var$tokenizeAutolink(effects, ok, nok) {
    var size = 1;
    return start;
    function start(code) {
        effects.enter("autolink");
        effects.enter("autolinkMarker");
        effects.consume(code);
        effects.exit("autolinkMarker");
        effects.enter("autolinkProtocol");
        return open;
    }
    function open(code) {
        if ($gMacN(code)) {
            effects.consume(code);
            return schemeOrEmailAtext;
        }
        return $aMtuc(code) ? emailAtext(code) : nok(code);
    }
    function schemeOrEmailAtext(code) {
        return code === 43 || code === 45 || code === 46 || $ja7BD(code) ? schemeInsideOrEmailAtext(code) : emailAtext(code);
    }
    function schemeInsideOrEmailAtext(code) {
        if (code === 58) {
            effects.consume(code);
            return urlInside;
        }
        if ((code === 43 || code === 45 || code === 46 || $ja7BD(code)) && size++ < 32) {
            effects.consume(code);
            return schemeInsideOrEmailAtext;
        }
        return emailAtext(code);
    }
    function urlInside(code) {
        if (code === 62) {
            effects.exit("autolinkProtocol");
            return end(code);
        }
        if (code === 32 || code === 60 || $glVfv(code)) return nok(code);
        effects.consume(code);
        return urlInside;
    }
    function emailAtext(code) {
        if (code === 64) {
            effects.consume(code);
            size = 0;
            return emailAtSignOrDot;
        }
        if ($aMtuc(code)) {
            effects.consume(code);
            return emailAtext;
        }
        return nok(code);
    }
    function emailAtSignOrDot(code) {
        return $ja7BD(code) ? emailLabel(code) : nok(code);
    }
    function emailLabel(code) {
        if (code === 46) {
            effects.consume(code);
            size = 0;
            return emailAtSignOrDot;
        }
        if (code === 62) {
            // Exit, then change the type.
            effects.exit("autolinkProtocol").type = "autolinkEmail";
            return end(code);
        }
        return emailValue(code);
    }
    function emailValue(code) {
        if ((code === 45 || $ja7BD(code)) && size++ < 63) {
            effects.consume(code);
            return code === 45 ? emailValue : emailLabel;
        }
        return nok(code);
    }
    function end(code) {
        effects.enter("autolinkMarker");
        effects.consume(code);
        effects.exit("autolinkMarker");
        effects.exit("autolink");
        return ok;
    }
}
module.exports = $6c6b3a2d2f203e72$var$autolink;

});
parcelRegister("gMacN", function(module, exports) {
"use strict";

var $gx0ph = parcelRequire("gx0ph");
var $c3690b9a3abe7bd1$var$asciiAlpha = $gx0ph(/[A-Za-z]/);
module.exports = $c3690b9a3abe7bd1$var$asciiAlpha;

});

parcelRegister("ja7BD", function(module, exports) {
"use strict";

var $gx0ph = parcelRequire("gx0ph");
var $df34d9e85411bbed$var$asciiAlphanumeric = $gx0ph(/[\dA-Za-z]/);
module.exports = $df34d9e85411bbed$var$asciiAlphanumeric;

});

parcelRegister("aMtuc", function(module, exports) {
"use strict";

var $gx0ph = parcelRequire("gx0ph");
var $7d95426c886164e5$var$asciiAtext = $gx0ph(/[#-'*+\--9=?A-Z^-~]/);
module.exports = $7d95426c886164e5$var$asciiAtext;

});

parcelRegister("glVfv", function(module, exports) {
"use strict";
// Note: EOF is seen as ASCII control here, because `null < 32 == true`.
function $be7b0401cc55bc9f$var$asciiControl(code) {
    return(// Special whitespace codes (which have negative values), C0 and Control
    // character DEL
    code < 32 || code === 127);
}
module.exports = $be7b0401cc55bc9f$var$asciiControl;

});


parcelRegister("dbFbQ", function(module, exports) {
"use strict";

var $5br2F = parcelRequire("5br2F");

var $10n72 = parcelRequire("10n72");
var $999c40ef1f48829d$var$blockQuote = {
    name: "blockQuote",
    tokenize: $999c40ef1f48829d$var$tokenizeBlockQuoteStart,
    continuation: {
        tokenize: $999c40ef1f48829d$var$tokenizeBlockQuoteContinuation
    },
    exit: $999c40ef1f48829d$var$exit
};
function $999c40ef1f48829d$var$tokenizeBlockQuoteStart(effects, ok, nok) {
    var self = this;
    return start;
    function start(code) {
        if (code === 62) {
            if (!self.containerState.open) {
                effects.enter("blockQuote", {
                    _container: true
                });
                self.containerState.open = true;
            }
            effects.enter("blockQuotePrefix");
            effects.enter("blockQuoteMarker");
            effects.consume(code);
            effects.exit("blockQuoteMarker");
            return after;
        }
        return nok(code);
    }
    function after(code) {
        if ($5br2F(code)) {
            effects.enter("blockQuotePrefixWhitespace");
            effects.consume(code);
            effects.exit("blockQuotePrefixWhitespace");
            effects.exit("blockQuotePrefix");
            return ok;
        }
        effects.exit("blockQuotePrefix");
        return ok(code);
    }
}
function $999c40ef1f48829d$var$tokenizeBlockQuoteContinuation(effects, ok, nok) {
    return $10n72(effects, effects.attempt($999c40ef1f48829d$var$blockQuote, ok, nok), "linePrefix", this.parser.constructs.disable.null.indexOf("codeIndented") > -1 ? undefined : 4);
}
function $999c40ef1f48829d$var$exit(effects) {
    effects.exit("blockQuote");
}
module.exports = $999c40ef1f48829d$var$blockQuote;

});

parcelRegister("ivizM", function(module, exports) {
"use strict";

var $8xApo = parcelRequire("8xApo");
var $d789880bd1227673$var$characterEscape = {
    name: "characterEscape",
    tokenize: $d789880bd1227673$var$tokenizeCharacterEscape
};
function $d789880bd1227673$var$tokenizeCharacterEscape(effects, ok, nok) {
    return start;
    function start(code) {
        effects.enter("characterEscape");
        effects.enter("escapeMarker");
        effects.consume(code);
        effects.exit("escapeMarker");
        return open;
    }
    function open(code) {
        if ($8xApo(code)) {
            effects.enter("characterEscapeValue");
            effects.consume(code);
            effects.exit("characterEscapeValue");
            effects.exit("characterEscape");
            return ok;
        }
        return nok(code);
    }
}
module.exports = $d789880bd1227673$var$characterEscape;

});
parcelRegister("8xApo", function(module, exports) {
"use strict";

var $gx0ph = parcelRequire("gx0ph");
var $637da5c63171a9af$var$asciiPunctuation = $gx0ph(/[!-/:-@[-`{-~]/);
module.exports = $637da5c63171a9af$var$asciiPunctuation;

});


parcelRegister("546s7", function(module, exports) {
"use strict";

var $hKKfc = parcelRequire("hKKfc");

var $ja7BD = parcelRequire("ja7BD");

var $kxhMS = parcelRequire("kxhMS");

var $avp72 = parcelRequire("avp72");
function $3b0254cb80f78831$var$_interopDefaultLegacy(e) {
    return e && typeof e === "object" && "default" in e ? e : {
        default: e
    };
}
var $3b0254cb80f78831$var$decodeEntity__default = /*#__PURE__*/ $3b0254cb80f78831$var$_interopDefaultLegacy($hKKfc);
var $3b0254cb80f78831$var$characterReference = {
    name: "characterReference",
    tokenize: $3b0254cb80f78831$var$tokenizeCharacterReference
};
function $3b0254cb80f78831$var$tokenizeCharacterReference(effects, ok, nok) {
    var self = this;
    var size = 0;
    var max;
    var test;
    return start;
    function start(code) {
        effects.enter("characterReference");
        effects.enter("characterReferenceMarker");
        effects.consume(code);
        effects.exit("characterReferenceMarker");
        return open;
    }
    function open(code) {
        if (code === 35) {
            effects.enter("characterReferenceMarkerNumeric");
            effects.consume(code);
            effects.exit("characterReferenceMarkerNumeric");
            return numeric;
        }
        effects.enter("characterReferenceValue");
        max = 31;
        test = $ja7BD;
        return value(code);
    }
    function numeric(code) {
        if (code === 88 || code === 120) {
            effects.enter("characterReferenceMarkerHexadecimal");
            effects.consume(code);
            effects.exit("characterReferenceMarkerHexadecimal");
            effects.enter("characterReferenceValue");
            max = 6;
            test = $avp72;
            return value;
        }
        effects.enter("characterReferenceValue");
        max = 7;
        test = $kxhMS;
        return value(code);
    }
    function value(code) {
        var token;
        if (code === 59 && size) {
            token = effects.exit("characterReferenceValue");
            if (test === $ja7BD && !$3b0254cb80f78831$var$decodeEntity__default["default"](self.sliceSerialize(token))) return nok(code);
            effects.enter("characterReferenceMarker");
            effects.consume(code);
            effects.exit("characterReferenceMarker");
            effects.exit("characterReference");
            return ok;
        }
        if (test(code) && size++ < max) {
            effects.consume(code);
            return value;
        }
        return nok(code);
    }
}
module.exports = $3b0254cb80f78831$var$characterReference;

});
parcelRegister("hKKfc", function(module, exports) {
"use strict";
/* eslint-env browser */ var $ceca9aad1bf52f6f$var$el;
var $ceca9aad1bf52f6f$var$semicolon = 59 //  ';'
;
module.exports = $ceca9aad1bf52f6f$var$decodeEntity;
function $ceca9aad1bf52f6f$var$decodeEntity(characters) {
    var entity = "&" + characters + ";";
    var char;
    $ceca9aad1bf52f6f$var$el = $ceca9aad1bf52f6f$var$el || document.createElement("i");
    $ceca9aad1bf52f6f$var$el.innerHTML = entity;
    char = $ceca9aad1bf52f6f$var$el.textContent;
    // Some entities do not require the closing semicolon (`&not` - for instance),
    // which leads to situations where parsing the assumed entity of &notit; will
    // result in the string `¬it;`.  When we encounter a trailing semicolon after
    // parsing and the entity to decode was not a semicolon (`&semi;`), we can
    // assume that the matching was incomplete
    if (char.charCodeAt(char.length - 1) === $ceca9aad1bf52f6f$var$semicolon && characters !== "semi") return false;
    // If the decoded string is equal to the input, the entity was not valid
    return char === entity ? false : char;
}

});

parcelRegister("kxhMS", function(module, exports) {
"use strict";

var $gx0ph = parcelRequire("gx0ph");
var $ef34afe6845ea5a2$var$asciiDigit = $gx0ph(/\d/);
module.exports = $ef34afe6845ea5a2$var$asciiDigit;

});

parcelRegister("avp72", function(module, exports) {
"use strict";

var $gx0ph = parcelRequire("gx0ph");
var $7a604771e2d8f62d$var$asciiHexDigit = $gx0ph(/[\dA-Fa-f]/);
module.exports = $7a604771e2d8f62d$var$asciiHexDigit;

});


parcelRegister("7Tc0q", function(module, exports) {
"use strict";

var $bl5Ae = parcelRequire("bl5Ae");

var $5zMHo = parcelRequire("5zMHo");

var $bUBdZ = parcelRequire("bUBdZ");

var $10n72 = parcelRequire("10n72");
var $5be6fb931dd02f83$var$codeFenced = {
    name: "codeFenced",
    tokenize: $5be6fb931dd02f83$var$tokenizeCodeFenced,
    concrete: true
};
function $5be6fb931dd02f83$var$tokenizeCodeFenced(effects, ok, nok) {
    var self = this;
    var closingFenceConstruct = {
        tokenize: tokenizeClosingFence,
        partial: true
    };
    var initialPrefix = $bUBdZ(this.events, "linePrefix");
    var sizeOpen = 0;
    var marker;
    return start;
    function start(code) {
        effects.enter("codeFenced");
        effects.enter("codeFencedFence");
        effects.enter("codeFencedFenceSequence");
        marker = code;
        return sequenceOpen(code);
    }
    function sequenceOpen(code) {
        if (code === marker) {
            effects.consume(code);
            sizeOpen++;
            return sequenceOpen;
        }
        effects.exit("codeFencedFenceSequence");
        return sizeOpen < 3 ? nok(code) : $10n72(effects, infoOpen, "whitespace")(code);
    }
    function infoOpen(code) {
        if (code === null || $bl5Ae(code)) return openAfter(code);
        effects.enter("codeFencedFenceInfo");
        effects.enter("chunkString", {
            contentType: "string"
        });
        return info(code);
    }
    function info(code) {
        if (code === null || $5zMHo(code)) {
            effects.exit("chunkString");
            effects.exit("codeFencedFenceInfo");
            return $10n72(effects, infoAfter, "whitespace")(code);
        }
        if (code === 96 && code === marker) return nok(code);
        effects.consume(code);
        return info;
    }
    function infoAfter(code) {
        if (code === null || $bl5Ae(code)) return openAfter(code);
        effects.enter("codeFencedFenceMeta");
        effects.enter("chunkString", {
            contentType: "string"
        });
        return meta(code);
    }
    function meta(code) {
        if (code === null || $bl5Ae(code)) {
            effects.exit("chunkString");
            effects.exit("codeFencedFenceMeta");
            return openAfter(code);
        }
        if (code === 96 && code === marker) return nok(code);
        effects.consume(code);
        return meta;
    }
    function openAfter(code) {
        effects.exit("codeFencedFence");
        return self.interrupt ? ok(code) : content(code);
    }
    function content(code) {
        if (code === null) return after(code);
        if ($bl5Ae(code)) {
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            return effects.attempt(closingFenceConstruct, after, initialPrefix ? $10n72(effects, content, "linePrefix", initialPrefix + 1) : content);
        }
        effects.enter("codeFlowValue");
        return contentContinue(code);
    }
    function contentContinue(code) {
        if (code === null || $bl5Ae(code)) {
            effects.exit("codeFlowValue");
            return content(code);
        }
        effects.consume(code);
        return contentContinue;
    }
    function after(code) {
        effects.exit("codeFenced");
        return ok(code);
    }
    function tokenizeClosingFence(effects, ok, nok) {
        var size = 0;
        return $10n72(effects, closingSequenceStart, "linePrefix", this.parser.constructs.disable.null.indexOf("codeIndented") > -1 ? undefined : 4);
        function closingSequenceStart(code) {
            effects.enter("codeFencedFence");
            effects.enter("codeFencedFenceSequence");
            return closingSequence(code);
        }
        function closingSequence(code) {
            if (code === marker) {
                effects.consume(code);
                size++;
                return closingSequence;
            }
            if (size < sizeOpen) return nok(code);
            effects.exit("codeFencedFenceSequence");
            return $10n72(effects, closingSequenceEnd, "whitespace")(code);
        }
        function closingSequenceEnd(code) {
            if (code === null || $bl5Ae(code)) {
                effects.exit("codeFencedFence");
                return ok(code);
            }
            return nok(code);
        }
    }
}
module.exports = $5be6fb931dd02f83$var$codeFenced;

});

parcelRegister("gEZYG", function(module, exports) {
"use strict";

var $bl5Ae = parcelRequire("bl5Ae");

var $9Q1oe = parcelRequire("9Q1oe");

var $bUBdZ = parcelRequire("bUBdZ");

var $10n72 = parcelRequire("10n72");
var $c2107547df49c8ad$var$codeIndented = {
    name: "codeIndented",
    tokenize: $c2107547df49c8ad$var$tokenizeCodeIndented,
    resolve: $c2107547df49c8ad$var$resolveCodeIndented
};
var $c2107547df49c8ad$var$indentedContentConstruct = {
    tokenize: $c2107547df49c8ad$var$tokenizeIndentedContent,
    partial: true
};
function $c2107547df49c8ad$var$resolveCodeIndented(events, context) {
    var code = {
        type: "codeIndented",
        start: events[0][1].start,
        end: events[events.length - 1][1].end
    };
    $9Q1oe(events, 0, 0, [
        [
            "enter",
            code,
            context
        ]
    ]);
    $9Q1oe(events, events.length, 0, [
        [
            "exit",
            code,
            context
        ]
    ]);
    return events;
}
function $c2107547df49c8ad$var$tokenizeCodeIndented(effects, ok, nok) {
    return effects.attempt($c2107547df49c8ad$var$indentedContentConstruct, afterPrefix, nok);
    function afterPrefix(code) {
        if (code === null) return ok(code);
        if ($bl5Ae(code)) return effects.attempt($c2107547df49c8ad$var$indentedContentConstruct, afterPrefix, ok)(code);
        effects.enter("codeFlowValue");
        return content(code);
    }
    function content(code) {
        if (code === null || $bl5Ae(code)) {
            effects.exit("codeFlowValue");
            return afterPrefix(code);
        }
        effects.consume(code);
        return content;
    }
}
function $c2107547df49c8ad$var$tokenizeIndentedContent(effects, ok, nok) {
    var self = this;
    return $10n72(effects, afterPrefix, "linePrefix", 5);
    function afterPrefix(code) {
        if ($bl5Ae(code)) {
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            return $10n72(effects, afterPrefix, "linePrefix", 5);
        }
        return $bUBdZ(self.events, "linePrefix") < 4 ? nok(code) : ok(code);
    }
}
module.exports = $c2107547df49c8ad$var$codeIndented;

});

parcelRegister("cBoLz", function(module, exports) {
"use strict";

var $bl5Ae = parcelRequire("bl5Ae");
var $92cc26cf44ecaea6$var$codeText = {
    name: "codeText",
    tokenize: $92cc26cf44ecaea6$var$tokenizeCodeText,
    resolve: $92cc26cf44ecaea6$var$resolveCodeText,
    previous: $92cc26cf44ecaea6$var$previous
};
function $92cc26cf44ecaea6$var$resolveCodeText(events) {
    var tailExitIndex = events.length - 4;
    var headEnterIndex = 3;
    var index;
    var enter // If we start and end with an EOL or a space.
    ;
    if ((events[headEnterIndex][1].type === "lineEnding" || events[headEnterIndex][1].type === "space") && (events[tailExitIndex][1].type === "lineEnding" || events[tailExitIndex][1].type === "space")) {
        index = headEnterIndex // And we have data.
        ;
        while(++index < tailExitIndex)if (events[index][1].type === "codeTextData") {
            // Then we have padding.
            events[tailExitIndex][1].type = events[headEnterIndex][1].type = "codeTextPadding";
            headEnterIndex += 2;
            tailExitIndex -= 2;
            break;
        }
    } // Merge adjacent spaces and data.
    index = headEnterIndex - 1;
    tailExitIndex++;
    while(++index <= tailExitIndex){
        if (enter === undefined) {
            if (index !== tailExitIndex && events[index][1].type !== "lineEnding") enter = index;
        } else if (index === tailExitIndex || events[index][1].type === "lineEnding") {
            events[enter][1].type = "codeTextData";
            if (index !== enter + 2) {
                events[enter][1].end = events[index - 1][1].end;
                events.splice(enter + 2, index - enter - 2);
                tailExitIndex -= index - enter - 2;
                index = enter + 2;
            }
            enter = undefined;
        }
    }
    return events;
}
function $92cc26cf44ecaea6$var$previous(code) {
    // If there is a previous code, there will always be a tail.
    return code !== 96 || this.events[this.events.length - 1][1].type === "characterEscape";
}
function $92cc26cf44ecaea6$var$tokenizeCodeText(effects, ok, nok) {
    var sizeOpen = 0;
    var size;
    var token;
    return start;
    function start(code) {
        effects.enter("codeText");
        effects.enter("codeTextSequence");
        return openingSequence(code);
    }
    function openingSequence(code) {
        if (code === 96) {
            effects.consume(code);
            sizeOpen++;
            return openingSequence;
        }
        effects.exit("codeTextSequence");
        return gap(code);
    }
    function gap(code) {
        // EOF.
        if (code === null) return nok(code);
         // Closing fence?
        // Could also be data.
        if (code === 96) {
            token = effects.enter("codeTextSequence");
            size = 0;
            return closingSequence(code);
        } // Tabs don’t work, and virtual spaces don’t make sense.
        if (code === 32) {
            effects.enter("space");
            effects.consume(code);
            effects.exit("space");
            return gap;
        }
        if ($bl5Ae(code)) {
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            return gap;
        } // Data.
        effects.enter("codeTextData");
        return data(code);
    } // In code.
    function data(code) {
        if (code === null || code === 32 || code === 96 || $bl5Ae(code)) {
            effects.exit("codeTextData");
            return gap(code);
        }
        effects.consume(code);
        return data;
    } // Closing fence.
    function closingSequence(code) {
        // More.
        if (code === 96) {
            effects.consume(code);
            size++;
            return closingSequence;
        } // Done!
        if (size === sizeOpen) {
            effects.exit("codeTextSequence");
            effects.exit("codeText");
            return ok(code);
        } // More or less accents: mark as data.
        token.type = "codeTextData";
        return data(code);
    }
}
module.exports = $92cc26cf44ecaea6$var$codeText;

});

parcelRegister("49kdc", function(module, exports) {
"use strict";

var $bl5Ae = parcelRequire("bl5Ae");

var $5zMHo = parcelRequire("5zMHo");

var $k6MDZ = parcelRequire("k6MDZ");

var $3QbhL = parcelRequire("3QbhL");

var $cp8tp = parcelRequire("cp8tp");

var $10n72 = parcelRequire("10n72");

var $l0Wff = parcelRequire("l0Wff");

var $gJHek = parcelRequire("gJHek");
var $3057ae5f411a85d3$var$definition = {
    name: "definition",
    tokenize: $3057ae5f411a85d3$var$tokenizeDefinition
};
var $3057ae5f411a85d3$var$titleConstruct = {
    tokenize: $3057ae5f411a85d3$var$tokenizeTitle,
    partial: true
};
function $3057ae5f411a85d3$var$tokenizeDefinition(effects, ok, nok) {
    var self = this;
    var identifier;
    return start;
    function start(code) {
        effects.enter("definition");
        return $cp8tp.call(self, effects, labelAfter, nok, "definitionLabel", "definitionLabelMarker", "definitionLabelString")(code);
    }
    function labelAfter(code) {
        identifier = $k6MDZ(self.sliceSerialize(self.events[self.events.length - 1][1]).slice(1, -1));
        if (code === 58) {
            effects.enter("definitionMarker");
            effects.consume(code);
            effects.exit("definitionMarker") // Note: blank lines can’t exist in content.
            ;
            return $l0Wff(effects, $3QbhL(effects, effects.attempt($3057ae5f411a85d3$var$titleConstruct, $10n72(effects, after, "whitespace"), $10n72(effects, after, "whitespace")), nok, "definitionDestination", "definitionDestinationLiteral", "definitionDestinationLiteralMarker", "definitionDestinationRaw", "definitionDestinationString"));
        }
        return nok(code);
    }
    function after(code) {
        if (code === null || $bl5Ae(code)) {
            effects.exit("definition");
            if (self.parser.defined.indexOf(identifier) < 0) self.parser.defined.push(identifier);
            return ok(code);
        }
        return nok(code);
    }
}
function $3057ae5f411a85d3$var$tokenizeTitle(effects, ok, nok) {
    return start;
    function start(code) {
        return $5zMHo(code) ? $l0Wff(effects, before)(code) : nok(code);
    }
    function before(code) {
        if (code === 34 || code === 39 || code === 40) return $gJHek(effects, $10n72(effects, after, "whitespace"), nok, "definitionTitle", "definitionTitleMarker", "definitionTitleString")(code);
        return nok(code);
    }
    function after(code) {
        return code === null || $bl5Ae(code) ? ok(code) : nok(code);
    }
}
module.exports = $3057ae5f411a85d3$var$definition;

});
parcelRegister("3QbhL", function(module, exports) {
"use strict";

var $glVfv = parcelRequire("glVfv");

var $5zMHo = parcelRequire("5zMHo");

var $bl5Ae = parcelRequire("bl5Ae");
// eslint-disable-next-line max-params
function $2cbefb80cf30fcdc$var$destinationFactory(effects, ok, nok, type, literalType, literalMarkerType, rawType, stringType, max) {
    var limit = max || Infinity;
    var balance = 0;
    return start;
    function start(code) {
        if (code === 60) {
            effects.enter(type);
            effects.enter(literalType);
            effects.enter(literalMarkerType);
            effects.consume(code);
            effects.exit(literalMarkerType);
            return destinationEnclosedBefore;
        }
        if ($glVfv(code) || code === 41) return nok(code);
        effects.enter(type);
        effects.enter(rawType);
        effects.enter(stringType);
        effects.enter("chunkString", {
            contentType: "string"
        });
        return destinationRaw(code);
    }
    function destinationEnclosedBefore(code) {
        if (code === 62) {
            effects.enter(literalMarkerType);
            effects.consume(code);
            effects.exit(literalMarkerType);
            effects.exit(literalType);
            effects.exit(type);
            return ok;
        }
        effects.enter(stringType);
        effects.enter("chunkString", {
            contentType: "string"
        });
        return destinationEnclosed(code);
    }
    function destinationEnclosed(code) {
        if (code === 62) {
            effects.exit("chunkString");
            effects.exit(stringType);
            return destinationEnclosedBefore(code);
        }
        if (code === null || code === 60 || $bl5Ae(code)) return nok(code);
        effects.consume(code);
        return code === 92 ? destinationEnclosedEscape : destinationEnclosed;
    }
    function destinationEnclosedEscape(code) {
        if (code === 60 || code === 62 || code === 92) {
            effects.consume(code);
            return destinationEnclosed;
        }
        return destinationEnclosed(code);
    }
    function destinationRaw(code) {
        if (code === 40) {
            if (++balance > limit) return nok(code);
            effects.consume(code);
            return destinationRaw;
        }
        if (code === 41) {
            if (!balance--) {
                effects.exit("chunkString");
                effects.exit(stringType);
                effects.exit(rawType);
                effects.exit(type);
                return ok(code);
            }
            effects.consume(code);
            return destinationRaw;
        }
        if (code === null || $5zMHo(code)) {
            if (balance) return nok(code);
            effects.exit("chunkString");
            effects.exit(stringType);
            effects.exit(rawType);
            effects.exit(type);
            return ok(code);
        }
        if ($glVfv(code)) return nok(code);
        effects.consume(code);
        return code === 92 ? destinationRawEscape : destinationRaw;
    }
    function destinationRawEscape(code) {
        if (code === 40 || code === 41 || code === 92) {
            effects.consume(code);
            return destinationRaw;
        }
        return destinationRaw(code);
    }
}
module.exports = $2cbefb80cf30fcdc$var$destinationFactory;

});

parcelRegister("cp8tp", function(module, exports) {
"use strict";

var $bl5Ae = parcelRequire("bl5Ae");

var $5br2F = parcelRequire("5br2F");
// eslint-disable-next-line max-params
function $907e647538d621c3$var$labelFactory(effects, ok, nok, type, markerType, stringType) {
    var self = this;
    var size = 0;
    var data;
    return start;
    function start(code) {
        effects.enter(type);
        effects.enter(markerType);
        effects.consume(code);
        effects.exit(markerType);
        effects.enter(stringType);
        return atBreak;
    }
    function atBreak(code) {
        if (code === null || code === 91 || code === 93 && !data || /* c8 ignore next */ code === 94 && /* c8 ignore next */ !size && /* c8 ignore next */ "_hiddenFootnoteSupport" in self.parser.constructs || size > 999) return nok(code);
        if (code === 93) {
            effects.exit(stringType);
            effects.enter(markerType);
            effects.consume(code);
            effects.exit(markerType);
            effects.exit(type);
            return ok;
        }
        if ($bl5Ae(code)) {
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            return atBreak;
        }
        effects.enter("chunkString", {
            contentType: "string"
        });
        return label(code);
    }
    function label(code) {
        if (code === null || code === 91 || code === 93 || $bl5Ae(code) || size++ > 999) {
            effects.exit("chunkString");
            return atBreak(code);
        }
        effects.consume(code);
        data = data || !$5br2F(code);
        return code === 92 ? labelEscape : label;
    }
    function labelEscape(code) {
        if (code === 91 || code === 92 || code === 93) {
            effects.consume(code);
            size++;
            return label;
        }
        return label(code);
    }
}
module.exports = $907e647538d621c3$var$labelFactory;

});

parcelRegister("l0Wff", function(module, exports) {
"use strict";

var $bl5Ae = parcelRequire("bl5Ae");

var $5br2F = parcelRequire("5br2F");

var $10n72 = parcelRequire("10n72");
function $f4c6c74a96b2f701$var$whitespaceFactory(effects, ok) {
    var seen;
    return start;
    function start(code) {
        if ($bl5Ae(code)) {
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            seen = true;
            return start;
        }
        if ($5br2F(code)) return $10n72(effects, start, seen ? "linePrefix" : "lineSuffix")(code);
        return ok(code);
    }
}
module.exports = $f4c6c74a96b2f701$var$whitespaceFactory;

});

parcelRegister("gJHek", function(module, exports) {
"use strict";

var $bl5Ae = parcelRequire("bl5Ae");

var $10n72 = parcelRequire("10n72");
function $c2f261e348ca5972$var$titleFactory(effects, ok, nok, type, markerType, stringType) {
    var marker;
    return start;
    function start(code) {
        effects.enter(type);
        effects.enter(markerType);
        effects.consume(code);
        effects.exit(markerType);
        marker = code === 40 ? 41 : code;
        return atFirstTitleBreak;
    }
    function atFirstTitleBreak(code) {
        if (code === marker) {
            effects.enter(markerType);
            effects.consume(code);
            effects.exit(markerType);
            effects.exit(type);
            return ok;
        }
        effects.enter(stringType);
        return atTitleBreak(code);
    }
    function atTitleBreak(code) {
        if (code === marker) {
            effects.exit(stringType);
            return atFirstTitleBreak(marker);
        }
        if (code === null) return nok(code);
         // Note: blank lines can’t exist in content.
        if ($bl5Ae(code)) {
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            return $10n72(effects, atTitleBreak, "linePrefix");
        }
        effects.enter("chunkString", {
            contentType: "string"
        });
        return title(code);
    }
    function title(code) {
        if (code === marker || code === null || $bl5Ae(code)) {
            effects.exit("chunkString");
            return atTitleBreak(code);
        }
        effects.consume(code);
        return code === 92 ? titleEscape : title;
    }
    function titleEscape(code) {
        if (code === marker || code === 92) {
            effects.consume(code);
            return title;
        }
        return title(code);
    }
}
module.exports = $c2f261e348ca5972$var$titleFactory;

});


parcelRegister("4nvRC", function(module, exports) {
"use strict";

var $bl5Ae = parcelRequire("bl5Ae");
var $330206e14bd3fe38$var$hardBreakEscape = {
    name: "hardBreakEscape",
    tokenize: $330206e14bd3fe38$var$tokenizeHardBreakEscape
};
function $330206e14bd3fe38$var$tokenizeHardBreakEscape(effects, ok, nok) {
    return start;
    function start(code) {
        effects.enter("hardBreakEscape");
        effects.enter("escapeMarker");
        effects.consume(code);
        return open;
    }
    function open(code) {
        if ($bl5Ae(code)) {
            effects.exit("escapeMarker");
            effects.exit("hardBreakEscape");
            return ok(code);
        }
        return nok(code);
    }
}
module.exports = $330206e14bd3fe38$var$hardBreakEscape;

});

parcelRegister("j2t7S", function(module, exports) {
"use strict";

var $bl5Ae = parcelRequire("bl5Ae");

var $5zMHo = parcelRequire("5zMHo");

var $5br2F = parcelRequire("5br2F");

var $9Q1oe = parcelRequire("9Q1oe");

var $10n72 = parcelRequire("10n72");
var $ddc4cc11b77cfe25$var$headingAtx = {
    name: "headingAtx",
    tokenize: $ddc4cc11b77cfe25$var$tokenizeHeadingAtx,
    resolve: $ddc4cc11b77cfe25$var$resolveHeadingAtx
};
function $ddc4cc11b77cfe25$var$resolveHeadingAtx(events, context) {
    var contentEnd = events.length - 2;
    var contentStart = 3;
    var content;
    var text // Prefix whitespace, part of the opening.
    ;
    if (events[contentStart][1].type === "whitespace") contentStart += 2;
     // Suffix whitespace, part of the closing.
    if (contentEnd - 2 > contentStart && events[contentEnd][1].type === "whitespace") contentEnd -= 2;
    if (events[contentEnd][1].type === "atxHeadingSequence" && (contentStart === contentEnd - 1 || contentEnd - 4 > contentStart && events[contentEnd - 2][1].type === "whitespace")) contentEnd -= contentStart + 1 === contentEnd ? 2 : 4;
    if (contentEnd > contentStart) {
        content = {
            type: "atxHeadingText",
            start: events[contentStart][1].start,
            end: events[contentEnd][1].end
        };
        text = {
            type: "chunkText",
            start: events[contentStart][1].start,
            end: events[contentEnd][1].end,
            contentType: "text"
        };
        $9Q1oe(events, contentStart, contentEnd - contentStart + 1, [
            [
                "enter",
                content,
                context
            ],
            [
                "enter",
                text,
                context
            ],
            [
                "exit",
                text,
                context
            ],
            [
                "exit",
                content,
                context
            ]
        ]);
    }
    return events;
}
function $ddc4cc11b77cfe25$var$tokenizeHeadingAtx(effects, ok, nok) {
    var self = this;
    var size = 0;
    return start;
    function start(code) {
        effects.enter("atxHeading");
        effects.enter("atxHeadingSequence");
        return fenceOpenInside(code);
    }
    function fenceOpenInside(code) {
        if (code === 35 && size++ < 6) {
            effects.consume(code);
            return fenceOpenInside;
        }
        if (code === null || $5zMHo(code)) {
            effects.exit("atxHeadingSequence");
            return self.interrupt ? ok(code) : headingBreak(code);
        }
        return nok(code);
    }
    function headingBreak(code) {
        if (code === 35) {
            effects.enter("atxHeadingSequence");
            return sequence(code);
        }
        if (code === null || $bl5Ae(code)) {
            effects.exit("atxHeading");
            return ok(code);
        }
        if ($5br2F(code)) return $10n72(effects, headingBreak, "whitespace")(code);
        effects.enter("atxHeadingText");
        return data(code);
    }
    function sequence(code) {
        if (code === 35) {
            effects.consume(code);
            return sequence;
        }
        effects.exit("atxHeadingSequence");
        return headingBreak(code);
    }
    function data(code) {
        if (code === null || code === 35 || $5zMHo(code)) {
            effects.exit("atxHeadingText");
            return headingBreak(code);
        }
        effects.consume(code);
        return data;
    }
}
module.exports = $ddc4cc11b77cfe25$var$headingAtx;

});

parcelRegister("hkodS", function(module, exports) {
"use strict";

var $gMacN = parcelRequire("gMacN");

var $ja7BD = parcelRequire("ja7BD");

var $bl5Ae = parcelRequire("bl5Ae");

var $5zMHo = parcelRequire("5zMHo");

var $5br2F = parcelRequire("5br2F");

var $iaAMG = parcelRequire("iaAMG");

var $aXmud = parcelRequire("aXmud");

var $gK7os = parcelRequire("gK7os");

var $9em3z = parcelRequire("9em3z");
var $c9d7181446c8a2d6$var$htmlFlow = {
    name: "htmlFlow",
    tokenize: $c9d7181446c8a2d6$var$tokenizeHtmlFlow,
    resolveTo: $c9d7181446c8a2d6$var$resolveToHtmlFlow,
    concrete: true
};
var $c9d7181446c8a2d6$var$nextBlankConstruct = {
    tokenize: $c9d7181446c8a2d6$var$tokenizeNextBlank,
    partial: true
};
function $c9d7181446c8a2d6$var$resolveToHtmlFlow(events) {
    var index = events.length;
    while(index--){
        if (events[index][0] === "enter" && events[index][1].type === "htmlFlow") break;
    }
    if (index > 1 && events[index - 2][1].type === "linePrefix") {
        // Add the prefix start to the HTML token.
        events[index][1].start = events[index - 2][1].start // Add the prefix start to the HTML line token.
        ;
        events[index + 1][1].start = events[index - 2][1].start // Remove the line prefix.
        ;
        events.splice(index - 2, 2);
    }
    return events;
}
function $c9d7181446c8a2d6$var$tokenizeHtmlFlow(effects, ok, nok) {
    var self = this;
    var kind;
    var startTag;
    var buffer;
    var index;
    var marker;
    return start;
    function start(code) {
        effects.enter("htmlFlow");
        effects.enter("htmlFlowData");
        effects.consume(code);
        return open;
    }
    function open(code) {
        if (code === 33) {
            effects.consume(code);
            return declarationStart;
        }
        if (code === 47) {
            effects.consume(code);
            return tagCloseStart;
        }
        if (code === 63) {
            effects.consume(code);
            kind = 3 // While we’re in an instruction instead of a declaration, we’re on a `?`
            ;
            // right now, so we do need to search for `>`, similar to declarations.
            return self.interrupt ? ok : continuationDeclarationInside;
        }
        if ($gMacN(code)) {
            effects.consume(code);
            buffer = $iaAMG(code);
            startTag = true;
            return tagName;
        }
        return nok(code);
    }
    function declarationStart(code) {
        if (code === 45) {
            effects.consume(code);
            kind = 2;
            return commentOpenInside;
        }
        if (code === 91) {
            effects.consume(code);
            kind = 5;
            buffer = "CDATA[";
            index = 0;
            return cdataOpenInside;
        }
        if ($gMacN(code)) {
            effects.consume(code);
            kind = 4;
            return self.interrupt ? ok : continuationDeclarationInside;
        }
        return nok(code);
    }
    function commentOpenInside(code) {
        if (code === 45) {
            effects.consume(code);
            return self.interrupt ? ok : continuationDeclarationInside;
        }
        return nok(code);
    }
    function cdataOpenInside(code) {
        if (code === buffer.charCodeAt(index++)) {
            effects.consume(code);
            return index === buffer.length ? self.interrupt ? ok : continuation : cdataOpenInside;
        }
        return nok(code);
    }
    function tagCloseStart(code) {
        if ($gMacN(code)) {
            effects.consume(code);
            buffer = $iaAMG(code);
            return tagName;
        }
        return nok(code);
    }
    function tagName(code) {
        if (code === null || code === 47 || code === 62 || $5zMHo(code)) {
            if (code !== 47 && startTag && $gK7os.indexOf(buffer.toLowerCase()) > -1) {
                kind = 1;
                return self.interrupt ? ok(code) : continuation(code);
            }
            if ($aXmud.indexOf(buffer.toLowerCase()) > -1) {
                kind = 6;
                if (code === 47) {
                    effects.consume(code);
                    return basicSelfClosing;
                }
                return self.interrupt ? ok(code) : continuation(code);
            }
            kind = 7 // Do not support complete HTML when interrupting.
            ;
            return self.interrupt ? nok(code) : startTag ? completeAttributeNameBefore(code) : completeClosingTagAfter(code);
        }
        if (code === 45 || $ja7BD(code)) {
            effects.consume(code);
            buffer += $iaAMG(code);
            return tagName;
        }
        return nok(code);
    }
    function basicSelfClosing(code) {
        if (code === 62) {
            effects.consume(code);
            return self.interrupt ? ok : continuation;
        }
        return nok(code);
    }
    function completeClosingTagAfter(code) {
        if ($5br2F(code)) {
            effects.consume(code);
            return completeClosingTagAfter;
        }
        return completeEnd(code);
    }
    function completeAttributeNameBefore(code) {
        if (code === 47) {
            effects.consume(code);
            return completeEnd;
        }
        if (code === 58 || code === 95 || $gMacN(code)) {
            effects.consume(code);
            return completeAttributeName;
        }
        if ($5br2F(code)) {
            effects.consume(code);
            return completeAttributeNameBefore;
        }
        return completeEnd(code);
    }
    function completeAttributeName(code) {
        if (code === 45 || code === 46 || code === 58 || code === 95 || $ja7BD(code)) {
            effects.consume(code);
            return completeAttributeName;
        }
        return completeAttributeNameAfter(code);
    }
    function completeAttributeNameAfter(code) {
        if (code === 61) {
            effects.consume(code);
            return completeAttributeValueBefore;
        }
        if ($5br2F(code)) {
            effects.consume(code);
            return completeAttributeNameAfter;
        }
        return completeAttributeNameBefore(code);
    }
    function completeAttributeValueBefore(code) {
        if (code === null || code === 60 || code === 61 || code === 62 || code === 96) return nok(code);
        if (code === 34 || code === 39) {
            effects.consume(code);
            marker = code;
            return completeAttributeValueQuoted;
        }
        if ($5br2F(code)) {
            effects.consume(code);
            return completeAttributeValueBefore;
        }
        marker = undefined;
        return completeAttributeValueUnquoted(code);
    }
    function completeAttributeValueQuoted(code) {
        if (code === marker) {
            effects.consume(code);
            return completeAttributeValueQuotedAfter;
        }
        if (code === null || $bl5Ae(code)) return nok(code);
        effects.consume(code);
        return completeAttributeValueQuoted;
    }
    function completeAttributeValueUnquoted(code) {
        if (code === null || code === 34 || code === 39 || code === 60 || code === 61 || code === 62 || code === 96 || $5zMHo(code)) return completeAttributeNameAfter(code);
        effects.consume(code);
        return completeAttributeValueUnquoted;
    }
    function completeAttributeValueQuotedAfter(code) {
        if (code === 47 || code === 62 || $5br2F(code)) return completeAttributeNameBefore(code);
        return nok(code);
    }
    function completeEnd(code) {
        if (code === 62) {
            effects.consume(code);
            return completeAfter;
        }
        return nok(code);
    }
    function completeAfter(code) {
        if ($5br2F(code)) {
            effects.consume(code);
            return completeAfter;
        }
        return code === null || $bl5Ae(code) ? continuation(code) : nok(code);
    }
    function continuation(code) {
        if (code === 45 && kind === 2) {
            effects.consume(code);
            return continuationCommentInside;
        }
        if (code === 60 && kind === 1) {
            effects.consume(code);
            return continuationRawTagOpen;
        }
        if (code === 62 && kind === 4) {
            effects.consume(code);
            return continuationClose;
        }
        if (code === 63 && kind === 3) {
            effects.consume(code);
            return continuationDeclarationInside;
        }
        if (code === 93 && kind === 5) {
            effects.consume(code);
            return continuationCharacterDataInside;
        }
        if ($bl5Ae(code) && (kind === 6 || kind === 7)) return effects.check($c9d7181446c8a2d6$var$nextBlankConstruct, continuationClose, continuationAtLineEnding)(code);
        if (code === null || $bl5Ae(code)) return continuationAtLineEnding(code);
        effects.consume(code);
        return continuation;
    }
    function continuationAtLineEnding(code) {
        effects.exit("htmlFlowData");
        return htmlContinueStart(code);
    }
    function htmlContinueStart(code) {
        if (code === null) return done(code);
        if ($bl5Ae(code)) {
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            return htmlContinueStart;
        }
        effects.enter("htmlFlowData");
        return continuation(code);
    }
    function continuationCommentInside(code) {
        if (code === 45) {
            effects.consume(code);
            return continuationDeclarationInside;
        }
        return continuation(code);
    }
    function continuationRawTagOpen(code) {
        if (code === 47) {
            effects.consume(code);
            buffer = "";
            return continuationRawEndTag;
        }
        return continuation(code);
    }
    function continuationRawEndTag(code) {
        if (code === 62 && $gK7os.indexOf(buffer.toLowerCase()) > -1) {
            effects.consume(code);
            return continuationClose;
        }
        if ($gMacN(code) && buffer.length < 8) {
            effects.consume(code);
            buffer += $iaAMG(code);
            return continuationRawEndTag;
        }
        return continuation(code);
    }
    function continuationCharacterDataInside(code) {
        if (code === 93) {
            effects.consume(code);
            return continuationDeclarationInside;
        }
        return continuation(code);
    }
    function continuationDeclarationInside(code) {
        if (code === 62) {
            effects.consume(code);
            return continuationClose;
        }
        return continuation(code);
    }
    function continuationClose(code) {
        if (code === null || $bl5Ae(code)) {
            effects.exit("htmlFlowData");
            return done(code);
        }
        effects.consume(code);
        return continuationClose;
    }
    function done(code) {
        effects.exit("htmlFlow");
        return ok(code);
    }
}
function $c9d7181446c8a2d6$var$tokenizeNextBlank(effects, ok, nok) {
    return start;
    function start(code) {
        effects.exit("htmlFlowData");
        effects.enter("lineEndingBlank");
        effects.consume(code);
        effects.exit("lineEndingBlank");
        return effects.attempt($9em3z, ok, nok);
    }
}
module.exports = $c9d7181446c8a2d6$var$htmlFlow;

});
parcelRegister("aXmud", function(module, exports) {
"use strict";
// This module is copied from <https://spec.commonmark.org/0.29/#html-blocks>.
var $7fa0db6510ed0c2b$var$basics = [
    "address",
    "article",
    "aside",
    "base",
    "basefont",
    "blockquote",
    "body",
    "caption",
    "center",
    "col",
    "colgroup",
    "dd",
    "details",
    "dialog",
    "dir",
    "div",
    "dl",
    "dt",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "frame",
    "frameset",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "head",
    "header",
    "hr",
    "html",
    "iframe",
    "legend",
    "li",
    "link",
    "main",
    "menu",
    "menuitem",
    "nav",
    "noframes",
    "ol",
    "optgroup",
    "option",
    "p",
    "param",
    "section",
    "source",
    "summary",
    "table",
    "tbody",
    "td",
    "tfoot",
    "th",
    "thead",
    "title",
    "tr",
    "track",
    "ul"
];
module.exports = $7fa0db6510ed0c2b$var$basics;

});

parcelRegister("gK7os", function(module, exports) {
"use strict";
// This module is copied from <https://spec.commonmark.org/0.29/#html-blocks>.
var $c306ad6ba07cbb12$var$raws = [
    "pre",
    "script",
    "style",
    "textarea"
];
module.exports = $c306ad6ba07cbb12$var$raws;

});


parcelRegister("5oF5S", function(module, exports) {
"use strict";

var $gMacN = parcelRequire("gMacN");

var $ja7BD = parcelRequire("ja7BD");

var $bl5Ae = parcelRequire("bl5Ae");

var $5zMHo = parcelRequire("5zMHo");

var $5br2F = parcelRequire("5br2F");

var $10n72 = parcelRequire("10n72");
var $3edf11ff49cf25f9$var$htmlText = {
    name: "htmlText",
    tokenize: $3edf11ff49cf25f9$var$tokenizeHtmlText
};
function $3edf11ff49cf25f9$var$tokenizeHtmlText(effects, ok, nok) {
    var self = this;
    var marker;
    var buffer;
    var index;
    var returnState;
    return start;
    function start(code) {
        effects.enter("htmlText");
        effects.enter("htmlTextData");
        effects.consume(code);
        return open;
    }
    function open(code) {
        if (code === 33) {
            effects.consume(code);
            return declarationOpen;
        }
        if (code === 47) {
            effects.consume(code);
            return tagCloseStart;
        }
        if (code === 63) {
            effects.consume(code);
            return instruction;
        }
        if ($gMacN(code)) {
            effects.consume(code);
            return tagOpen;
        }
        return nok(code);
    }
    function declarationOpen(code) {
        if (code === 45) {
            effects.consume(code);
            return commentOpen;
        }
        if (code === 91) {
            effects.consume(code);
            buffer = "CDATA[";
            index = 0;
            return cdataOpen;
        }
        if ($gMacN(code)) {
            effects.consume(code);
            return declaration;
        }
        return nok(code);
    }
    function commentOpen(code) {
        if (code === 45) {
            effects.consume(code);
            return commentStart;
        }
        return nok(code);
    }
    function commentStart(code) {
        if (code === null || code === 62) return nok(code);
        if (code === 45) {
            effects.consume(code);
            return commentStartDash;
        }
        return comment(code);
    }
    function commentStartDash(code) {
        if (code === null || code === 62) return nok(code);
        return comment(code);
    }
    function comment(code) {
        if (code === null) return nok(code);
        if (code === 45) {
            effects.consume(code);
            return commentClose;
        }
        if ($bl5Ae(code)) {
            returnState = comment;
            return atLineEnding(code);
        }
        effects.consume(code);
        return comment;
    }
    function commentClose(code) {
        if (code === 45) {
            effects.consume(code);
            return end;
        }
        return comment(code);
    }
    function cdataOpen(code) {
        if (code === buffer.charCodeAt(index++)) {
            effects.consume(code);
            return index === buffer.length ? cdata : cdataOpen;
        }
        return nok(code);
    }
    function cdata(code) {
        if (code === null) return nok(code);
        if (code === 93) {
            effects.consume(code);
            return cdataClose;
        }
        if ($bl5Ae(code)) {
            returnState = cdata;
            return atLineEnding(code);
        }
        effects.consume(code);
        return cdata;
    }
    function cdataClose(code) {
        if (code === 93) {
            effects.consume(code);
            return cdataEnd;
        }
        return cdata(code);
    }
    function cdataEnd(code) {
        if (code === 62) return end(code);
        if (code === 93) {
            effects.consume(code);
            return cdataEnd;
        }
        return cdata(code);
    }
    function declaration(code) {
        if (code === null || code === 62) return end(code);
        if ($bl5Ae(code)) {
            returnState = declaration;
            return atLineEnding(code);
        }
        effects.consume(code);
        return declaration;
    }
    function instruction(code) {
        if (code === null) return nok(code);
        if (code === 63) {
            effects.consume(code);
            return instructionClose;
        }
        if ($bl5Ae(code)) {
            returnState = instruction;
            return atLineEnding(code);
        }
        effects.consume(code);
        return instruction;
    }
    function instructionClose(code) {
        return code === 62 ? end(code) : instruction(code);
    }
    function tagCloseStart(code) {
        if ($gMacN(code)) {
            effects.consume(code);
            return tagClose;
        }
        return nok(code);
    }
    function tagClose(code) {
        if (code === 45 || $ja7BD(code)) {
            effects.consume(code);
            return tagClose;
        }
        return tagCloseBetween(code);
    }
    function tagCloseBetween(code) {
        if ($bl5Ae(code)) {
            returnState = tagCloseBetween;
            return atLineEnding(code);
        }
        if ($5br2F(code)) {
            effects.consume(code);
            return tagCloseBetween;
        }
        return end(code);
    }
    function tagOpen(code) {
        if (code === 45 || $ja7BD(code)) {
            effects.consume(code);
            return tagOpen;
        }
        if (code === 47 || code === 62 || $5zMHo(code)) return tagOpenBetween(code);
        return nok(code);
    }
    function tagOpenBetween(code) {
        if (code === 47) {
            effects.consume(code);
            return end;
        }
        if (code === 58 || code === 95 || $gMacN(code)) {
            effects.consume(code);
            return tagOpenAttributeName;
        }
        if ($bl5Ae(code)) {
            returnState = tagOpenBetween;
            return atLineEnding(code);
        }
        if ($5br2F(code)) {
            effects.consume(code);
            return tagOpenBetween;
        }
        return end(code);
    }
    function tagOpenAttributeName(code) {
        if (code === 45 || code === 46 || code === 58 || code === 95 || $ja7BD(code)) {
            effects.consume(code);
            return tagOpenAttributeName;
        }
        return tagOpenAttributeNameAfter(code);
    }
    function tagOpenAttributeNameAfter(code) {
        if (code === 61) {
            effects.consume(code);
            return tagOpenAttributeValueBefore;
        }
        if ($bl5Ae(code)) {
            returnState = tagOpenAttributeNameAfter;
            return atLineEnding(code);
        }
        if ($5br2F(code)) {
            effects.consume(code);
            return tagOpenAttributeNameAfter;
        }
        return tagOpenBetween(code);
    }
    function tagOpenAttributeValueBefore(code) {
        if (code === null || code === 60 || code === 61 || code === 62 || code === 96) return nok(code);
        if (code === 34 || code === 39) {
            effects.consume(code);
            marker = code;
            return tagOpenAttributeValueQuoted;
        }
        if ($bl5Ae(code)) {
            returnState = tagOpenAttributeValueBefore;
            return atLineEnding(code);
        }
        if ($5br2F(code)) {
            effects.consume(code);
            return tagOpenAttributeValueBefore;
        }
        effects.consume(code);
        marker = undefined;
        return tagOpenAttributeValueUnquoted;
    }
    function tagOpenAttributeValueQuoted(code) {
        if (code === marker) {
            effects.consume(code);
            return tagOpenAttributeValueQuotedAfter;
        }
        if (code === null) return nok(code);
        if ($bl5Ae(code)) {
            returnState = tagOpenAttributeValueQuoted;
            return atLineEnding(code);
        }
        effects.consume(code);
        return tagOpenAttributeValueQuoted;
    }
    function tagOpenAttributeValueQuotedAfter(code) {
        if (code === 62 || code === 47 || $5zMHo(code)) return tagOpenBetween(code);
        return nok(code);
    }
    function tagOpenAttributeValueUnquoted(code) {
        if (code === null || code === 34 || code === 39 || code === 60 || code === 61 || code === 96) return nok(code);
        if (code === 62 || $5zMHo(code)) return tagOpenBetween(code);
        effects.consume(code);
        return tagOpenAttributeValueUnquoted;
    } // We can’t have blank lines in content, so no need to worry about empty
    // tokens.
    function atLineEnding(code) {
        effects.exit("htmlTextData");
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return $10n72(effects, afterPrefix, "linePrefix", self.parser.constructs.disable.null.indexOf("codeIndented") > -1 ? undefined : 4);
    }
    function afterPrefix(code) {
        effects.enter("htmlTextData");
        return returnState(code);
    }
    function end(code) {
        if (code === 62) {
            effects.consume(code);
            effects.exit("htmlTextData");
            effects.exit("htmlText");
            return ok;
        }
        return nok(code);
    }
}
module.exports = $3edf11ff49cf25f9$var$htmlText;

});

parcelRegister("9m5UN", function(module, exports) {
"use strict";

var $5zMHo = parcelRequire("5zMHo");

var $6jG9Y = parcelRequire("6jG9Y");

var $9Q1oe = parcelRequire("9Q1oe");

var $k6MDZ = parcelRequire("k6MDZ");

var $5ZU3u = parcelRequire("5ZU3u");

var $1Gh3S = parcelRequire("1Gh3S");

var $3QbhL = parcelRequire("3QbhL");

var $cp8tp = parcelRequire("cp8tp");

var $gJHek = parcelRequire("gJHek");

var $l0Wff = parcelRequire("l0Wff");
var $6cfac1bdb5c6ef63$var$labelEnd = {
    name: "labelEnd",
    tokenize: $6cfac1bdb5c6ef63$var$tokenizeLabelEnd,
    resolveTo: $6cfac1bdb5c6ef63$var$resolveToLabelEnd,
    resolveAll: $6cfac1bdb5c6ef63$var$resolveAllLabelEnd
};
var $6cfac1bdb5c6ef63$var$resourceConstruct = {
    tokenize: $6cfac1bdb5c6ef63$var$tokenizeResource
};
var $6cfac1bdb5c6ef63$var$fullReferenceConstruct = {
    tokenize: $6cfac1bdb5c6ef63$var$tokenizeFullReference
};
var $6cfac1bdb5c6ef63$var$collapsedReferenceConstruct = {
    tokenize: $6cfac1bdb5c6ef63$var$tokenizeCollapsedReference
};
function $6cfac1bdb5c6ef63$var$resolveAllLabelEnd(events) {
    var index = -1;
    var token;
    while(++index < events.length){
        token = events[index][1];
        if (!token._used && (token.type === "labelImage" || token.type === "labelLink" || token.type === "labelEnd")) {
            // Remove the marker.
            events.splice(index + 1, token.type === "labelImage" ? 4 : 2);
            token.type = "data";
            index++;
        }
    }
    return events;
}
function $6cfac1bdb5c6ef63$var$resolveToLabelEnd(events, context) {
    var index = events.length;
    var offset = 0;
    var group;
    var label;
    var text;
    var token;
    var open;
    var close;
    var media // Find an opening.
    ;
    while(index--){
        token = events[index][1];
        if (open) {
            // If we see another link, or inactive link label, we’ve been here before.
            if (token.type === "link" || token.type === "labelLink" && token._inactive) break;
             // Mark other link openings as inactive, as we can’t have links in
            // links.
            if (events[index][0] === "enter" && token.type === "labelLink") token._inactive = true;
        } else if (close) {
            if (events[index][0] === "enter" && (token.type === "labelImage" || token.type === "labelLink") && !token._balanced) {
                open = index;
                if (token.type !== "labelLink") {
                    offset = 2;
                    break;
                }
            }
        } else if (token.type === "labelEnd") close = index;
    }
    group = {
        type: events[open][1].type === "labelLink" ? "link" : "image",
        start: $1Gh3S(events[open][1].start),
        end: $1Gh3S(events[events.length - 1][1].end)
    };
    label = {
        type: "label",
        start: $1Gh3S(events[open][1].start),
        end: $1Gh3S(events[close][1].end)
    };
    text = {
        type: "labelText",
        start: $1Gh3S(events[open + offset + 2][1].end),
        end: $1Gh3S(events[close - 2][1].start)
    };
    media = [
        [
            "enter",
            group,
            context
        ],
        [
            "enter",
            label,
            context
        ]
    ] // Opening marker.
    ;
    media = $6jG9Y(media, events.slice(open + 1, open + offset + 3)) // Text open.
    ;
    media = $6jG9Y(media, [
        [
            "enter",
            text,
            context
        ]
    ]) // Between.
    ;
    media = $6jG9Y(media, $5ZU3u(context.parser.constructs.insideSpan.null, events.slice(open + offset + 4, close - 3), context)) // Text close, marker close, label close.
    ;
    media = $6jG9Y(media, [
        [
            "exit",
            text,
            context
        ],
        events[close - 2],
        events[close - 1],
        [
            "exit",
            label,
            context
        ]
    ]) // Reference, resource, or so.
    ;
    media = $6jG9Y(media, events.slice(close + 1)) // Media close.
    ;
    media = $6jG9Y(media, [
        [
            "exit",
            group,
            context
        ]
    ]);
    $9Q1oe(events, open, events.length, media);
    return events;
}
function $6cfac1bdb5c6ef63$var$tokenizeLabelEnd(effects, ok, nok) {
    var self = this;
    var index = self.events.length;
    var labelStart;
    var defined // Find an opening.
    ;
    while(index--)if ((self.events[index][1].type === "labelImage" || self.events[index][1].type === "labelLink") && !self.events[index][1]._balanced) {
        labelStart = self.events[index][1];
        break;
    }
    return start;
    function start(code) {
        if (!labelStart) return nok(code);
         // It’s a balanced bracket, but contains a link.
        if (labelStart._inactive) return balanced(code);
        defined = self.parser.defined.indexOf($k6MDZ(self.sliceSerialize({
            start: labelStart.end,
            end: self.now()
        }))) > -1;
        effects.enter("labelEnd");
        effects.enter("labelMarker");
        effects.consume(code);
        effects.exit("labelMarker");
        effects.exit("labelEnd");
        return afterLabelEnd;
    }
    function afterLabelEnd(code) {
        // Resource: `[asd](fgh)`.
        if (code === 40) return effects.attempt($6cfac1bdb5c6ef63$var$resourceConstruct, ok, defined ? ok : balanced)(code);
         // Collapsed (`[asd][]`) or full (`[asd][fgh]`) reference?
        if (code === 91) return effects.attempt($6cfac1bdb5c6ef63$var$fullReferenceConstruct, ok, defined ? effects.attempt($6cfac1bdb5c6ef63$var$collapsedReferenceConstruct, ok, balanced) : balanced)(code);
         // Shortcut reference: `[asd]`?
        return defined ? ok(code) : balanced(code);
    }
    function balanced(code) {
        labelStart._balanced = true;
        return nok(code);
    }
}
function $6cfac1bdb5c6ef63$var$tokenizeResource(effects, ok, nok) {
    return start;
    function start(code) {
        effects.enter("resource");
        effects.enter("resourceMarker");
        effects.consume(code);
        effects.exit("resourceMarker");
        return $l0Wff(effects, open);
    }
    function open(code) {
        if (code === 41) return end(code);
        return $3QbhL(effects, destinationAfter, nok, "resourceDestination", "resourceDestinationLiteral", "resourceDestinationLiteralMarker", "resourceDestinationRaw", "resourceDestinationString", 3)(code);
    }
    function destinationAfter(code) {
        return $5zMHo(code) ? $l0Wff(effects, between)(code) : end(code);
    }
    function between(code) {
        if (code === 34 || code === 39 || code === 40) return $gJHek(effects, $l0Wff(effects, end), nok, "resourceTitle", "resourceTitleMarker", "resourceTitleString")(code);
        return end(code);
    }
    function end(code) {
        if (code === 41) {
            effects.enter("resourceMarker");
            effects.consume(code);
            effects.exit("resourceMarker");
            effects.exit("resource");
            return ok;
        }
        return nok(code);
    }
}
function $6cfac1bdb5c6ef63$var$tokenizeFullReference(effects, ok, nok) {
    var self = this;
    return start;
    function start(code) {
        return $cp8tp.call(self, effects, afterLabel, nok, "reference", "referenceMarker", "referenceString")(code);
    }
    function afterLabel(code) {
        return self.parser.defined.indexOf($k6MDZ(self.sliceSerialize(self.events[self.events.length - 1][1]).slice(1, -1))) < 0 ? nok(code) : ok(code);
    }
}
function $6cfac1bdb5c6ef63$var$tokenizeCollapsedReference(effects, ok, nok) {
    return start;
    function start(code) {
        effects.enter("reference");
        effects.enter("referenceMarker");
        effects.consume(code);
        effects.exit("referenceMarker");
        return open;
    }
    function open(code) {
        if (code === 93) {
            effects.enter("referenceMarker");
            effects.consume(code);
            effects.exit("referenceMarker");
            effects.exit("reference");
            return ok;
        }
        return nok(code);
    }
}
module.exports = $6cfac1bdb5c6ef63$var$labelEnd;

});

parcelRegister("7dco3", function(module, exports) {
"use strict";

var $9m5UN = parcelRequire("9m5UN");
var $54035b17334f3e16$var$labelStartImage = {
    name: "labelStartImage",
    tokenize: $54035b17334f3e16$var$tokenizeLabelStartImage,
    resolveAll: $9m5UN.resolveAll
};
function $54035b17334f3e16$var$tokenizeLabelStartImage(effects, ok, nok) {
    var self = this;
    return start;
    function start(code) {
        effects.enter("labelImage");
        effects.enter("labelImageMarker");
        effects.consume(code);
        effects.exit("labelImageMarker");
        return open;
    }
    function open(code) {
        if (code === 91) {
            effects.enter("labelMarker");
            effects.consume(code);
            effects.exit("labelMarker");
            effects.exit("labelImage");
            return after;
        }
        return nok(code);
    }
    function after(code) {
        /* c8 ignore next */ return code === 94 && /* c8 ignore next */ "_hiddenFootnoteSupport" in self.parser.constructs ? /* c8 ignore next */ nok(code) : ok(code);
    }
}
module.exports = $54035b17334f3e16$var$labelStartImage;

});

parcelRegister("2fkxI", function(module, exports) {
"use strict";

var $9m5UN = parcelRequire("9m5UN");
var $1a2cead5cc13baa3$var$labelStartLink = {
    name: "labelStartLink",
    tokenize: $1a2cead5cc13baa3$var$tokenizeLabelStartLink,
    resolveAll: $9m5UN.resolveAll
};
function $1a2cead5cc13baa3$var$tokenizeLabelStartLink(effects, ok, nok) {
    var self = this;
    return start;
    function start(code) {
        effects.enter("labelLink");
        effects.enter("labelMarker");
        effects.consume(code);
        effects.exit("labelMarker");
        effects.exit("labelLink");
        return after;
    }
    function after(code) {
        /* c8 ignore next */ return code === 94 && /* c8 ignore next */ "_hiddenFootnoteSupport" in self.parser.constructs ? /* c8 ignore next */ nok(code) : ok(code);
    }
}
module.exports = $1a2cead5cc13baa3$var$labelStartLink;

});

parcelRegister("dkR72", function(module, exports) {
"use strict";

var $10n72 = parcelRequire("10n72");
var $9b5657ae6e2fc06a$var$lineEnding = {
    name: "lineEnding",
    tokenize: $9b5657ae6e2fc06a$var$tokenizeLineEnding
};
function $9b5657ae6e2fc06a$var$tokenizeLineEnding(effects, ok) {
    return start;
    function start(code) {
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return $10n72(effects, ok, "linePrefix");
    }
}
module.exports = $9b5657ae6e2fc06a$var$lineEnding;

});

parcelRegister("hTP9P", function(module, exports) {
"use strict";

var $kxhMS = parcelRequire("kxhMS");

var $5br2F = parcelRequire("5br2F");

var $bUBdZ = parcelRequire("bUBdZ");

var $5rIMu = parcelRequire("5rIMu");

var $10n72 = parcelRequire("10n72");

var $9em3z = parcelRequire("9em3z");

var $6JLsZ = parcelRequire("6JLsZ");
var $035ce4274db96b0c$var$list = {
    name: "list",
    tokenize: $035ce4274db96b0c$var$tokenizeListStart,
    continuation: {
        tokenize: $035ce4274db96b0c$var$tokenizeListContinuation
    },
    exit: $035ce4274db96b0c$var$tokenizeListEnd
};
var $035ce4274db96b0c$var$listItemPrefixWhitespaceConstruct = {
    tokenize: $035ce4274db96b0c$var$tokenizeListItemPrefixWhitespace,
    partial: true
};
var $035ce4274db96b0c$var$indentConstruct = {
    tokenize: $035ce4274db96b0c$var$tokenizeIndent,
    partial: true
};
function $035ce4274db96b0c$var$tokenizeListStart(effects, ok, nok) {
    var self = this;
    var initialSize = $bUBdZ(self.events, "linePrefix");
    var size = 0;
    return start;
    function start(code) {
        var kind = self.containerState.type || (code === 42 || code === 43 || code === 45 ? "listUnordered" : "listOrdered");
        if (kind === "listUnordered" ? !self.containerState.marker || code === self.containerState.marker : $kxhMS(code)) {
            if (!self.containerState.type) {
                self.containerState.type = kind;
                effects.enter(kind, {
                    _container: true
                });
            }
            if (kind === "listUnordered") {
                effects.enter("listItemPrefix");
                return code === 42 || code === 45 ? effects.check($6JLsZ, nok, atMarker)(code) : atMarker(code);
            }
            if (!self.interrupt || code === 49) {
                effects.enter("listItemPrefix");
                effects.enter("listItemValue");
                return inside(code);
            }
        }
        return nok(code);
    }
    function inside(code) {
        if ($kxhMS(code) && ++size < 10) {
            effects.consume(code);
            return inside;
        }
        if ((!self.interrupt || size < 2) && (self.containerState.marker ? code === self.containerState.marker : code === 41 || code === 46)) {
            effects.exit("listItemValue");
            return atMarker(code);
        }
        return nok(code);
    }
    function atMarker(code) {
        effects.enter("listItemMarker");
        effects.consume(code);
        effects.exit("listItemMarker");
        self.containerState.marker = self.containerState.marker || code;
        return effects.check($9em3z, self.interrupt ? nok : onBlank, effects.attempt($035ce4274db96b0c$var$listItemPrefixWhitespaceConstruct, endOfPrefix, otherPrefix));
    }
    function onBlank(code) {
        self.containerState.initialBlankLine = true;
        initialSize++;
        return endOfPrefix(code);
    }
    function otherPrefix(code) {
        if ($5br2F(code)) {
            effects.enter("listItemPrefixWhitespace");
            effects.consume(code);
            effects.exit("listItemPrefixWhitespace");
            return endOfPrefix;
        }
        return nok(code);
    }
    function endOfPrefix(code) {
        self.containerState.size = initialSize + $5rIMu(self.sliceStream(effects.exit("listItemPrefix")));
        return ok(code);
    }
}
function $035ce4274db96b0c$var$tokenizeListContinuation(effects, ok, nok) {
    var self = this;
    self.containerState._closeFlow = undefined;
    return effects.check($9em3z, onBlank, notBlank);
    function onBlank(code) {
        self.containerState.furtherBlankLines = self.containerState.furtherBlankLines || self.containerState.initialBlankLine // We have a blank line.
        ;
        // Still, try to consume at most the items size.
        return $10n72(effects, ok, "listItemIndent", self.containerState.size + 1)(code);
    }
    function notBlank(code) {
        if (self.containerState.furtherBlankLines || !$5br2F(code)) {
            self.containerState.furtherBlankLines = self.containerState.initialBlankLine = undefined;
            return notInCurrentItem(code);
        }
        self.containerState.furtherBlankLines = self.containerState.initialBlankLine = undefined;
        return effects.attempt($035ce4274db96b0c$var$indentConstruct, ok, notInCurrentItem)(code);
    }
    function notInCurrentItem(code) {
        // While we do continue, we signal that the flow should be closed.
        self.containerState._closeFlow = true // As we’re closing flow, we’re no longer interrupting.
        ;
        self.interrupt = undefined;
        return $10n72(effects, effects.attempt($035ce4274db96b0c$var$list, ok, nok), "linePrefix", self.parser.constructs.disable.null.indexOf("codeIndented") > -1 ? undefined : 4)(code);
    }
}
function $035ce4274db96b0c$var$tokenizeIndent(effects, ok, nok) {
    var self = this;
    return $10n72(effects, afterPrefix, "listItemIndent", self.containerState.size + 1);
    function afterPrefix(code) {
        return $bUBdZ(self.events, "listItemIndent") === self.containerState.size ? ok(code) : nok(code);
    }
}
function $035ce4274db96b0c$var$tokenizeListEnd(effects) {
    effects.exit(this.containerState.type);
}
function $035ce4274db96b0c$var$tokenizeListItemPrefixWhitespace(effects, ok, nok) {
    var self = this;
    return $10n72(effects, afterPrefix, "listItemPrefixWhitespace", self.parser.constructs.disable.null.indexOf("codeIndented") > -1 ? undefined : 5);
    function afterPrefix(code) {
        return $5br2F(code) || !$bUBdZ(self.events, "listItemPrefixWhitespace") ? nok(code) : ok(code);
    }
}
module.exports = $035ce4274db96b0c$var$list;

});
parcelRegister("6JLsZ", function(module, exports) {
"use strict";

var $bl5Ae = parcelRequire("bl5Ae");

var $5br2F = parcelRequire("5br2F");

var $10n72 = parcelRequire("10n72");
var $4e7bc3eab271186b$var$thematicBreak = {
    name: "thematicBreak",
    tokenize: $4e7bc3eab271186b$var$tokenizeThematicBreak
};
function $4e7bc3eab271186b$var$tokenizeThematicBreak(effects, ok, nok) {
    var size = 0;
    var marker;
    return start;
    function start(code) {
        effects.enter("thematicBreak");
        marker = code;
        return atBreak(code);
    }
    function atBreak(code) {
        if (code === marker) {
            effects.enter("thematicBreakSequence");
            return sequence(code);
        }
        if ($5br2F(code)) return $10n72(effects, atBreak, "whitespace")(code);
        if (size < 3 || code !== null && !$bl5Ae(code)) return nok(code);
        effects.exit("thematicBreak");
        return ok(code);
    }
    function sequence(code) {
        if (code === marker) {
            effects.consume(code);
            size++;
            return sequence;
        }
        effects.exit("thematicBreakSequence");
        return atBreak(code);
    }
}
module.exports = $4e7bc3eab271186b$var$thematicBreak;

});


parcelRegister("1ncd9", function(module, exports) {
"use strict";

var $bl5Ae = parcelRequire("bl5Ae");

var $1Gh3S = parcelRequire("1Gh3S");

var $10n72 = parcelRequire("10n72");
var $100169484653d90a$var$setextUnderline = {
    name: "setextUnderline",
    tokenize: $100169484653d90a$var$tokenizeSetextUnderline,
    resolveTo: $100169484653d90a$var$resolveToSetextUnderline
};
function $100169484653d90a$var$resolveToSetextUnderline(events, context) {
    var index = events.length;
    var content;
    var text;
    var definition;
    var heading // Find the opening of the content.
    ;
    // It’ll always exist: we don’t tokenize if it isn’t there.
    while(index--)if (events[index][0] === "enter") {
        if (events[index][1].type === "content") {
            content = index;
            break;
        }
        if (events[index][1].type === "paragraph") text = index;
    } else {
        if (events[index][1].type === "content") // Remove the content end (if needed we’ll add it later)
        events.splice(index, 1);
        if (!definition && events[index][1].type === "definition") definition = index;
    }
    heading = {
        type: "setextHeading",
        start: $1Gh3S(events[text][1].start),
        end: $1Gh3S(events[events.length - 1][1].end)
    } // Change the paragraph to setext heading text.
    ;
    events[text][1].type = "setextHeadingText" // If we have definitions in the content, we’ll keep on having content,
    ;
    // but we need move it.
    if (definition) {
        events.splice(text, 0, [
            "enter",
            heading,
            context
        ]);
        events.splice(definition + 1, 0, [
            "exit",
            events[content][1],
            context
        ]);
        events[content][1].end = $1Gh3S(events[definition][1].end);
    } else events[content][1] = heading;
     // Add the heading exit at the end.
    events.push([
        "exit",
        heading,
        context
    ]);
    return events;
}
function $100169484653d90a$var$tokenizeSetextUnderline(effects, ok, nok) {
    var self = this;
    var index = self.events.length;
    var marker;
    var paragraph // Find an opening.
    ;
    while(index--)// Skip enter/exit of line ending, line prefix, and content.
    // We can now either have a definition or a paragraph.
    if (self.events[index][1].type !== "lineEnding" && self.events[index][1].type !== "linePrefix" && self.events[index][1].type !== "content") {
        paragraph = self.events[index][1].type === "paragraph";
        break;
    }
    return start;
    function start(code) {
        if (!self.lazy && (self.interrupt || paragraph)) {
            effects.enter("setextHeadingLine");
            effects.enter("setextHeadingLineSequence");
            marker = code;
            return closingSequence(code);
        }
        return nok(code);
    }
    function closingSequence(code) {
        if (code === marker) {
            effects.consume(code);
            return closingSequence;
        }
        effects.exit("setextHeadingLineSequence");
        return $10n72(effects, closingSequenceEnd, "lineSuffix")(code);
    }
    function closingSequenceEnd(code) {
        if (code === null || $bl5Ae(code)) {
            effects.exit("setextHeadingLine");
            return ok(code);
        }
        return nok(code);
    }
}
module.exports = $100169484653d90a$var$setextUnderline;

});



parcelRegister("f7LfF", function(module, exports) {
"use strict";
var $b02c29acb33e7590$var$search = /[\0\t\n\r]/g;
function $b02c29acb33e7590$var$preprocess() {
    var start = true;
    var column = 1;
    var buffer = "";
    var atCarriageReturn;
    return preprocessor;
    function preprocessor(value, encoding, end) {
        var chunks = [];
        var match;
        var next;
        var startPosition;
        var endPosition;
        var code;
        value = buffer + value.toString(encoding);
        startPosition = 0;
        buffer = "";
        if (start) {
            if (value.charCodeAt(0) === 65279) startPosition++;
            start = undefined;
        }
        while(startPosition < value.length){
            $b02c29acb33e7590$var$search.lastIndex = startPosition;
            match = $b02c29acb33e7590$var$search.exec(value);
            endPosition = match ? match.index : value.length;
            code = value.charCodeAt(endPosition);
            if (!match) {
                buffer = value.slice(startPosition);
                break;
            }
            if (code === 10 && startPosition === endPosition && atCarriageReturn) {
                chunks.push(-3);
                atCarriageReturn = undefined;
            } else {
                if (atCarriageReturn) {
                    chunks.push(-5);
                    atCarriageReturn = undefined;
                }
                if (startPosition < endPosition) {
                    chunks.push(value.slice(startPosition, endPosition));
                    column += endPosition - startPosition;
                }
                if (code === 0) {
                    chunks.push(65533);
                    column++;
                } else if (code === 9) {
                    next = Math.ceil(column / 4) * 4;
                    chunks.push(-2);
                    while(column++ < next)chunks.push(-1);
                } else if (code === 10) {
                    chunks.push(-4);
                    column = 1;
                } else {
                    atCarriageReturn = true;
                    column = 1;
                }
            }
            startPosition = endPosition + 1;
        }
        if (end) {
            if (atCarriageReturn) chunks.push(-5);
            if (buffer) chunks.push(buffer);
            chunks.push(null);
        }
        return chunks;
    }
}
module.exports = $b02c29acb33e7590$var$preprocess;

});

parcelRegister("kmVDs", function(module, exports) {
"use strict";

var $kzBoo = parcelRequire("kzBoo");
function $ed4291ec8b6df8c8$var$postprocess(events) {
    while(!$kzBoo(events));
    return events;
}
module.exports = $ed4291ec8b6df8c8$var$postprocess;

});




parcelRegister("dYNzc", function(module, exports) {

var $k3YWX = parcelRequire("k3YWX");
function $a2d753de3e1149e5$var$addListMetadata() {
    return function(ast) {
        $k3YWX(ast, "list", function(listNode, parents) {
            var depth = 0, i, n;
            for(i = 0, n = parents.length; i < n; i++)if (parents[i].type === "list") depth += 1;
            for(i = 0, n = listNode.children.length; i < n; i++){
                var child = listNode.children[i];
                child.index = i;
                child.ordered = listNode.ordered;
            }
            listNode.depth = depth;
        });
        return ast;
    };
}
module.exports = $a2d753de3e1149e5$var$addListMetadata;

});
parcelRegister("k3YWX", function(module, exports) {
"use strict";
/* Expose. */ module.exports = $e9b35dd4951df554$var$visitParents;
/* Visit. */ function $e9b35dd4951df554$var$visitParents(tree, type, visitor) {
    var stack = [];
    if (typeof type === "function") {
        visitor = type;
        type = null;
    }
    one(tree);
    /* Visit a single node. */ function one(node) {
        var result;
        if (!type || node.type === type) result = visitor(node, stack.concat());
        if (node.children && result !== false) return all(node.children, node);
        return result;
    }
    /* Visit children in `parent`. */ function all(children, parent) {
        var length = children.length;
        var index = -1;
        var child;
        stack.push(parent);
        while(++index < length){
            child = children[index];
            if (child && one(child) === false) return false;
        }
        stack.pop();
        return true;
    }
}

});


parcelRegister("kidYf", function(module, exports) {
"use strict";

var $prIHh = parcelRequire("prIHh");
var $ec60536225a19932$var$type = "virtualHtml";
var $ec60536225a19932$var$selfClosingRe = /^<(area|base|br|col|embed|hr|img|input|keygen|link|meta|param|source|track|wbr)\s*\/?>$/i;
var $ec60536225a19932$var$simpleTagRe = /^<(\/?)([a-z]+)\s*>$/;
module.exports = function(tree) {
    var open;
    var currentParent;
    $prIHh(tree, "html", function(node, index, parent) {
        if (currentParent !== parent) {
            open = [];
            currentParent = parent;
        }
        var selfClosing = $ec60536225a19932$var$getSelfClosing(node);
        if (selfClosing) {
            parent.children.splice(index, 1, {
                type: $ec60536225a19932$var$type,
                tag: selfClosing,
                position: node.position
            });
            return true;
        }
        var current = $ec60536225a19932$var$getSimpleTag(node, parent);
        if (!current) return true;
        var matching = $ec60536225a19932$var$findAndPull(open, current.tag);
        if (matching) parent.children.splice(index, 0, $ec60536225a19932$var$virtual(current, matching, parent));
        else if (!current.opening) open.push(current);
        return true;
    }, true // Iterate in reverse
    );
    return tree;
};
function $ec60536225a19932$var$findAndPull(open, matchingTag) {
    var i = open.length;
    while(i--){
        if (open[i].tag === matchingTag) return open.splice(i, 1)[0];
    }
    return false;
}
function $ec60536225a19932$var$getSimpleTag(node, parent) {
    var match = node.value.match($ec60536225a19932$var$simpleTagRe);
    return match ? {
        tag: match[2],
        opening: !match[1],
        node: node
    } : false;
}
function $ec60536225a19932$var$getSelfClosing(node) {
    var match = node.value.match($ec60536225a19932$var$selfClosingRe);
    return match ? match[1] : false;
}
function $ec60536225a19932$var$virtual(fromNode, toNode, parent) {
    var fromIndex = parent.children.indexOf(fromNode.node);
    var toIndex = parent.children.indexOf(toNode.node);
    var extracted = parent.children.splice(fromIndex, toIndex - fromIndex + 1);
    var children = extracted.slice(1, -1);
    return {
        type: $ec60536225a19932$var$type,
        children: children,
        tag: fromNode.tag,
        position: {
            start: fromNode.node.position.start,
            end: toNode.node.position.end,
            indent: []
        }
    };
}

});
parcelRegister("prIHh", function(module, exports) {
"use strict";
module.exports = $04c7d6835fa8e392$var$visit;

var $9WECV = parcelRequire("9WECV");
var $04c7d6835fa8e392$var$CONTINUE = $9WECV.CONTINUE;
var $04c7d6835fa8e392$var$SKIP = $9WECV.SKIP;
var $04c7d6835fa8e392$var$EXIT = $9WECV.EXIT;
$04c7d6835fa8e392$var$visit.CONTINUE = $04c7d6835fa8e392$var$CONTINUE;
$04c7d6835fa8e392$var$visit.SKIP = $04c7d6835fa8e392$var$SKIP;
$04c7d6835fa8e392$var$visit.EXIT = $04c7d6835fa8e392$var$EXIT;
function $04c7d6835fa8e392$var$visit(tree, test, visitor, reverse) {
    if (typeof test === "function" && typeof visitor !== "function") {
        reverse = visitor;
        visitor = test;
        test = null;
    }
    $9WECV(tree, test, overload, reverse);
    function overload(node, parents) {
        var parent = parents[parents.length - 1];
        var index = parent ? parent.children.indexOf(node) : null;
        return visitor(node, index, parent);
    }
}

});
parcelRegister("9WECV", function(module, exports) {
"use strict";
module.exports = $73d90b7f7f3a4777$var$visitParents;

var $bSiTt = parcelRequire("bSiTt");

var $8ZmB0 = parcelRequire("8ZmB0");
var $73d90b7f7f3a4777$var$CONTINUE = true;
var $73d90b7f7f3a4777$var$SKIP = "skip";
var $73d90b7f7f3a4777$var$EXIT = false;
$73d90b7f7f3a4777$var$visitParents.CONTINUE = $73d90b7f7f3a4777$var$CONTINUE;
$73d90b7f7f3a4777$var$visitParents.SKIP = $73d90b7f7f3a4777$var$SKIP;
$73d90b7f7f3a4777$var$visitParents.EXIT = $73d90b7f7f3a4777$var$EXIT;
function $73d90b7f7f3a4777$var$visitParents(tree, test, visitor, reverse) {
    var step;
    var is;
    if (typeof test === "function" && typeof visitor !== "function") {
        reverse = visitor;
        visitor = test;
        test = null;
    }
    is = $bSiTt(test);
    step = reverse ? -1 : 1;
    factory(tree, null, [])();
    function factory(node, index, parents) {
        var value = typeof node === "object" && node !== null ? node : {};
        var name;
        if (typeof value.type === "string") {
            name = typeof value.tagName === "string" ? value.tagName : typeof value.name === "string" ? value.name : undefined;
            visit.displayName = "node (" + $8ZmB0(value.type + (name ? "<" + name + ">" : "")) + ")";
        }
        return visit;
        function visit() {
            var grandparents = parents.concat(node);
            var result = [];
            var subresult;
            var offset;
            if (!test || is(node, index, parents[parents.length - 1] || null)) {
                result = $73d90b7f7f3a4777$var$toResult(visitor(node, parents));
                if (result[0] === $73d90b7f7f3a4777$var$EXIT) return result;
            }
            if (node.children && result[0] !== $73d90b7f7f3a4777$var$SKIP) {
                offset = (reverse ? node.children.length : -1) + step;
                while(offset > -1 && offset < node.children.length){
                    subresult = factory(node.children[offset], offset, grandparents)();
                    if (subresult[0] === $73d90b7f7f3a4777$var$EXIT) return subresult;
                    offset = typeof subresult[1] === "number" ? subresult[1] : offset + step;
                }
            }
            return result;
        }
    }
}
function $73d90b7f7f3a4777$var$toResult(value) {
    if (value !== null && typeof value === "object" && "length" in value) return value;
    if (typeof value === "number") return [
        $73d90b7f7f3a4777$var$CONTINUE,
        value
    ];
    return [
        value
    ];
}

});
parcelRegister("bSiTt", function(module, exports) {
"use strict";
module.exports = $8a5364c0c5ee77df$var$convert;
function $8a5364c0c5ee77df$var$convert(test) {
    if (test == null) return $8a5364c0c5ee77df$var$ok;
    if (typeof test === "string") return $8a5364c0c5ee77df$var$typeFactory(test);
    if (typeof test === "object") return "length" in test ? $8a5364c0c5ee77df$var$anyFactory(test) : $8a5364c0c5ee77df$var$allFactory(test);
    if (typeof test === "function") return test;
    throw new Error("Expected function, string, or object as test");
}
// Utility assert each property in `test` is represented in `node`, and each
// values are strictly equal.
function $8a5364c0c5ee77df$var$allFactory(test) {
    return all;
    function all(node) {
        var key;
        for(key in test){
            if (node[key] !== test[key]) return false;
        }
        return true;
    }
}
function $8a5364c0c5ee77df$var$anyFactory(tests) {
    var checks = [];
    var index = -1;
    while(++index < tests.length)checks[index] = $8a5364c0c5ee77df$var$convert(tests[index]);
    return any;
    function any() {
        var index = -1;
        while(++index < checks.length){
            if (checks[index].apply(this, arguments)) return true;
        }
        return false;
    }
}
// Utility to convert a string into a function which checks a given node’s type
// for said string.
function $8a5364c0c5ee77df$var$typeFactory(test) {
    return type;
    function type(node) {
        return Boolean(node && node.type === test);
    }
}
// Utility to return true.
function $8a5364c0c5ee77df$var$ok() {
    return true;
}

});

parcelRegister("8ZmB0", function(module, exports) {
module.exports = $68b58c5468c8bef0$var$identity;
function $68b58c5468c8bef0$var$identity(d) {
    return d;
}

});




parcelRegister("ahrfr", function(module, exports) {

$parcel$export(module.exports, "ofType", function () { return $77c0a0d2d9546f5a$export$5db8774c0df95fce; }, function (v) { return $77c0a0d2d9546f5a$export$5db8774c0df95fce = v; });
$parcel$export(module.exports, "ifNotMatch", function () { return $77c0a0d2d9546f5a$export$2062fb542207e794; }, function (v) { return $77c0a0d2d9546f5a$export$2062fb542207e794 = v; });
var $77c0a0d2d9546f5a$export$5db8774c0df95fce;
var $77c0a0d2d9546f5a$export$2062fb542207e794;
"use strict";

var $prIHh = parcelRequire("prIHh");
var $77c0a0d2d9546f5a$var$splice = [].splice;
$77c0a0d2d9546f5a$export$5db8774c0df95fce = function(types, mode) {
    return $77c0a0d2d9546f5a$var$ifNotMatch(allow, mode);
    function allow(node, index, parent) {
        return !types.includes(node.type);
    }
};
$77c0a0d2d9546f5a$export$2062fb542207e794 = $77c0a0d2d9546f5a$var$ifNotMatch;
function $77c0a0d2d9546f5a$var$ifNotMatch(allow, mode) {
    return transform;
    function transform(tree) {
        $prIHh(tree, filter);
        return tree;
    } // eslint-disable-next-line consistent-return
    function filter(node, index, parent) {
        if (parent && !allow(node, index, parent)) {
            var parameters = [
                index,
                1
            ];
            if (mode === "unwrap" && node.children) parameters = parameters.concat(node.children);
            $77c0a0d2d9546f5a$var$splice.apply(parent.children, parameters);
            return index;
        }
    }
}

});

parcelRegister("2owNN", function(module, exports) {
"use strict";

var $eeH7J = parcelRequire("eeH7J");

var $fv6YB = parcelRequire("fv6YB");

var $Pbw8Y = parcelRequire("Pbw8Y");
function $1be7447adf641cff$var$astToReact(node, options) {
    var parent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var index = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
    var renderer = options.renderers[node.type]; // Nodes created by plugins do not have positional info, in which case we set
    // an object that matches the positon interface.
    if (!node.position) node.position = {
        start: {
            line: null,
            column: null,
            offset: null
        },
        end: {
            line: null,
            column: null,
            offset: null
        }
    };
    var pos = node.position.start;
    var key = [
        node.type,
        pos.line,
        pos.column,
        index
    ].join("-");
    if (!$Pbw8Y.isValidElementType(renderer)) throw new Error("Renderer for type `".concat(node.type, "` not defined or is not renderable"));
    var nodeProps = $1be7447adf641cff$var$getNodeProps(node, key, options, renderer, parent, index);
    return $eeH7J.createElement(renderer, nodeProps, nodeProps.children || resolveChildren() || undefined);
    function resolveChildren() {
        return node.children && node.children.map(function(childNode, i) {
            return $1be7447adf641cff$var$astToReact(childNode, options, {
                node: node,
                props: nodeProps
            }, i);
        });
    }
} // eslint-disable-next-line max-params, complexity
function $1be7447adf641cff$var$getNodeProps(node, key, opts, renderer, parent, index) {
    var props = {
        key: key
    };
    var isSimpleRenderer = typeof renderer === "string" || renderer === $eeH7J.Fragment; // `sourcePos` is true if the user wants source information (line/column info from markdown source)
    if (opts.sourcePos && node.position) props["data-sourcepos"] = $1be7447adf641cff$var$flattenPosition(node.position);
    if (opts.rawSourcePos && !isSimpleRenderer) props.sourcePosition = node.position;
     // If `includeNodeIndex` is true, pass node index info to all non-tag renderers
    if (opts.includeNodeIndex && parent.node && parent.node.children && !isSimpleRenderer) {
        props.index = parent.node.children.indexOf(node);
        props.parentChildCount = parent.node.children.length;
    }
    var ref = node.identifier !== null && node.identifier !== undefined ? /* istanbul ignore next - plugins could inject an undefined reference. */ opts.definitions[node.identifier.toUpperCase()] || {} : null;
    switch(node.type){
        case "root":
            $1be7447adf641cff$var$assignDefined(props, {
                className: opts.className
            });
            break;
        case "text":
            props.nodeKey = key;
            props.children = node.value;
            break;
        case "heading":
            props.level = node.depth;
            break;
        case "list":
            props.start = node.start;
            props.ordered = node.ordered;
            props.spread = node.spread;
            props.depth = node.depth;
            break;
        case "listItem":
            props.checked = node.checked;
            props.spread = node.spread;
            props.ordered = node.ordered;
            props.index = node.index;
            props.children = $1be7447adf641cff$var$getListItemChildren(node, parent).map(function(childNode, i) {
                return $1be7447adf641cff$var$astToReact(childNode, opts, {
                    node: node,
                    props: props
                }, i);
            });
            break;
        case "definition":
            $1be7447adf641cff$var$assignDefined(props, {
                identifier: node.identifier,
                title: node.title,
                url: node.url
            });
            break;
        case "code":
            $1be7447adf641cff$var$assignDefined(props, {
                language: node.lang && node.lang.split(/\s/, 1)[0]
            });
            break;
        case "inlineCode":
            props.children = node.value;
            props.inline = true;
            break;
        case "link":
            $1be7447adf641cff$var$assignDefined(props, {
                title: node.title || undefined,
                target: typeof opts.linkTarget === "function" ? opts.linkTarget(node.url, node.children, node.title) : opts.linkTarget,
                href: opts.transformLinkUri ? opts.transformLinkUri(node.url, node.children, node.title) : node.url
            });
            break;
        case "image":
            $1be7447adf641cff$var$assignDefined(props, {
                src: opts.transformImageUri ? opts.transformImageUri(node.url, node.children, node.title, node.alt) : node.url,
                alt: node.alt || "",
                title: node.title || undefined
            });
            break;
        case "linkReference":
            $1be7447adf641cff$var$assignDefined(props, $fv6YB(ref, {
                href: opts.transformLinkUri ? opts.transformLinkUri(ref.href) : ref.href
            }));
            break;
        case "imageReference":
            $1be7447adf641cff$var$assignDefined(props, {
                src: opts.transformImageUri && ref.href ? opts.transformImageUri(ref.href, node.children, ref.title, node.alt) : ref.href,
                alt: node.alt || "",
                title: ref.title || undefined
            });
            break;
        case "table":
        case "tableHead":
        case "tableBody":
            props.columnAlignment = node.align;
            break;
        case "tableRow":
            props.isHeader = parent.node.type === "tableHead";
            props.columnAlignment = parent.props.columnAlignment;
            break;
        case "tableCell":
            $1be7447adf641cff$var$assignDefined(props, {
                isHeader: parent.props.isHeader,
                align: parent.props.columnAlignment[index]
            });
            break;
        case "virtualHtml":
            props.tag = node.tag;
            break;
        case "html":
            // @todo find a better way than this
            props.isBlock = node.position.start.line !== node.position.end.line;
            props.allowDangerousHtml = opts.allowDangerousHtml;
            props.escapeHtml = opts.escapeHtml;
            props.skipHtml = opts.skipHtml;
            break;
        case "parsedHtml":
            var parsedChildren;
            if (node.children) parsedChildren = node.children.map(function(child, i) {
                return $1be7447adf641cff$var$astToReact(child, opts, {
                    node: node,
                    props: props
                }, i);
            });
            props.allowDangerousHtml = opts.allowDangerousHtml;
            props.escapeHtml = opts.escapeHtml;
            props.skipHtml = opts.skipHtml;
            props.element = node.element ? $1be7447adf641cff$var$mergeNodeChildren(node, parsedChildren) : null;
            break;
        default:
            $1be7447adf641cff$var$assignDefined(props, $fv6YB(node, {
                type: undefined,
                position: undefined,
                children: undefined
            }));
    }
    if (!isSimpleRenderer && node.value) props.value = node.value;
    if (!isSimpleRenderer) props.node = node;
    return props;
}
function $1be7447adf641cff$var$assignDefined(target, attrs) {
    for(var key in attrs)if (typeof attrs[key] !== "undefined") target[key] = attrs[key];
}
function $1be7447adf641cff$var$mergeNodeChildren(node, parsedChildren) {
    var el = node.element;
    if (Array.isArray(el)) {
        /* istanbul ignore next - `div` fallback for old React. */ var Fragment = $eeH7J.Fragment || "div";
        return $eeH7J.createElement(Fragment, null, el);
    }
    if (el.props.children || parsedChildren) {
        var children = $eeH7J.Children.toArray(el.props.children).concat(parsedChildren);
        return $eeH7J.cloneElement(el, null, children);
    }
    return $eeH7J.cloneElement(el, null);
}
function $1be7447adf641cff$var$flattenPosition(pos) {
    return [
        pos.start.line,
        ":",
        pos.start.column,
        "-",
        pos.end.line,
        ":",
        pos.end.column
    ].map(String).join("");
}
function $1be7447adf641cff$var$getListItemChildren(node, parent) {
    /* istanbul ignore next - list items are always in a list, but best to be sure. */ var loose = parent && parent.node ? $1be7447adf641cff$var$listLoose(parent.node) : $1be7447adf641cff$var$listItemLoose(node);
    return loose ? node.children : $1be7447adf641cff$var$unwrapParagraphs(node);
}
function $1be7447adf641cff$var$unwrapParagraphs(node) {
    return node.children.reduce(function(array, child) {
        return array.concat(child.type === "paragraph" ? child.children : [
            child
        ]);
    }, []);
}
function $1be7447adf641cff$var$listLoose(node) {
    var children = node.children;
    var loose = node.spread;
    var index = -1;
    while(!loose && ++index < children.length)loose = $1be7447adf641cff$var$listItemLoose(children[index]);
    return loose;
}
function $1be7447adf641cff$var$listItemLoose(node) {
    var spread = node.spread;
    /* istanbul ignore next - spread is present from remark-parse, but maybe plugins don’t set it. */ return spread === undefined || spread === null ? node.children.length > 1 : spread;
}
module.exports = $1be7447adf641cff$var$astToReact;

});
parcelRegister("Pbw8Y", function(module, exports) {
"use strict";

module.exports = (parcelRequire("4mhCT"));

});
parcelRegister("4mhCT", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", function () { return $32c6e3bbbd5b9a41$export$2b8d127b894957b9; }, function (v) { return $32c6e3bbbd5b9a41$export$2b8d127b894957b9 = v; });
$parcel$export(module.exports, "ConcurrentMode", function () { return $32c6e3bbbd5b9a41$export$cea3a54a6425200c; }, function (v) { return $32c6e3bbbd5b9a41$export$cea3a54a6425200c = v; });
$parcel$export(module.exports, "ContextConsumer", function () { return $32c6e3bbbd5b9a41$export$a7c73072b1a182ae; }, function (v) { return $32c6e3bbbd5b9a41$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $32c6e3bbbd5b9a41$export$9f27bc3417b4524d; }, function (v) { return $32c6e3bbbd5b9a41$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $32c6e3bbbd5b9a41$export$db77ccec0bb4ccac; }, function (v) { return $32c6e3bbbd5b9a41$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $32c6e3bbbd5b9a41$export$8392c0c9d3dcbd35; }, function (v) { return $32c6e3bbbd5b9a41$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $32c6e3bbbd5b9a41$export$ffb0004e005737fa; }, function (v) { return $32c6e3bbbd5b9a41$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $32c6e3bbbd5b9a41$export$b624eff549462981; }, function (v) { return $32c6e3bbbd5b9a41$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $32c6e3bbbd5b9a41$export$7897aa7841a5380c; }, function (v) { return $32c6e3bbbd5b9a41$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $32c6e3bbbd5b9a41$export$602eac185826482c; }, function (v) { return $32c6e3bbbd5b9a41$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $32c6e3bbbd5b9a41$export$e2c29f18771995cb; }, function (v) { return $32c6e3bbbd5b9a41$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $32c6e3bbbd5b9a41$export$5f8d39834fd61797; }, function (v) { return $32c6e3bbbd5b9a41$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $32c6e3bbbd5b9a41$export$74bf444e3cd11ea5; }, function (v) { return $32c6e3bbbd5b9a41$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $32c6e3bbbd5b9a41$export$92387174baf9b227; }, function (v) { return $32c6e3bbbd5b9a41$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $32c6e3bbbd5b9a41$export$ec112efeb987d9c6; }, function (v) { return $32c6e3bbbd5b9a41$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $32c6e3bbbd5b9a41$export$b706b080d889d2c9; }, function (v) { return $32c6e3bbbd5b9a41$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $32c6e3bbbd5b9a41$export$5be5a87408f70ddc; }, function (v) { return $32c6e3bbbd5b9a41$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $32c6e3bbbd5b9a41$export$45a5e7f76e0caa8d; }, function (v) { return $32c6e3bbbd5b9a41$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $32c6e3bbbd5b9a41$export$455c2e768291efa6; }, function (v) { return $32c6e3bbbd5b9a41$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $32c6e3bbbd5b9a41$export$9522e17588c12572; }, function (v) { return $32c6e3bbbd5b9a41$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $32c6e3bbbd5b9a41$export$2110ac352bb060b9; }, function (v) { return $32c6e3bbbd5b9a41$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $32c6e3bbbd5b9a41$export$56885ab8b9c456ab; }, function (v) { return $32c6e3bbbd5b9a41$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $32c6e3bbbd5b9a41$export$d927fcb6adf8f9de; }, function (v) { return $32c6e3bbbd5b9a41$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $32c6e3bbbd5b9a41$export$b82d16f27459e05a; }, function (v) { return $32c6e3bbbd5b9a41$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $32c6e3bbbd5b9a41$export$522c17b4f5e123e8; }, function (v) { return $32c6e3bbbd5b9a41$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $32c6e3bbbd5b9a41$export$1aabd8a0274ecfd6; }, function (v) { return $32c6e3bbbd5b9a41$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $32c6e3bbbd5b9a41$export$9b621391a187a31a; }, function (v) { return $32c6e3bbbd5b9a41$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $32c6e3bbbd5b9a41$export$f5bbd400c2f4426f; }, function (v) { return $32c6e3bbbd5b9a41$export$f5bbd400c2f4426f = v; });
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $32c6e3bbbd5b9a41$export$2b8d127b894957b9;
var $32c6e3bbbd5b9a41$export$cea3a54a6425200c;
var $32c6e3bbbd5b9a41$export$a7c73072b1a182ae;
var $32c6e3bbbd5b9a41$export$9f27bc3417b4524d;
var $32c6e3bbbd5b9a41$export$db77ccec0bb4ccac;
var $32c6e3bbbd5b9a41$export$8392c0c9d3dcbd35;
var $32c6e3bbbd5b9a41$export$ffb0004e005737fa;
var $32c6e3bbbd5b9a41$export$b624eff549462981;
var $32c6e3bbbd5b9a41$export$7897aa7841a5380c;
var $32c6e3bbbd5b9a41$export$602eac185826482c;
var $32c6e3bbbd5b9a41$export$e2c29f18771995cb;
var $32c6e3bbbd5b9a41$export$5f8d39834fd61797;
var $32c6e3bbbd5b9a41$export$74bf444e3cd11ea5;
var $32c6e3bbbd5b9a41$export$92387174baf9b227;
var $32c6e3bbbd5b9a41$export$ec112efeb987d9c6;
var $32c6e3bbbd5b9a41$export$b706b080d889d2c9;
var $32c6e3bbbd5b9a41$export$5be5a87408f70ddc;
var $32c6e3bbbd5b9a41$export$45a5e7f76e0caa8d;
var $32c6e3bbbd5b9a41$export$455c2e768291efa6;
var $32c6e3bbbd5b9a41$export$9522e17588c12572;
var $32c6e3bbbd5b9a41$export$2110ac352bb060b9;
var $32c6e3bbbd5b9a41$export$56885ab8b9c456ab;
var $32c6e3bbbd5b9a41$export$d927fcb6adf8f9de;
var $32c6e3bbbd5b9a41$export$b82d16f27459e05a;
var $32c6e3bbbd5b9a41$export$522c17b4f5e123e8;
var $32c6e3bbbd5b9a41$export$1aabd8a0274ecfd6;
var $32c6e3bbbd5b9a41$export$9b621391a187a31a;
var $32c6e3bbbd5b9a41$export$f5bbd400c2f4426f;
"use strict";
var $32c6e3bbbd5b9a41$var$b = "function" === typeof Symbol && Symbol.for, $32c6e3bbbd5b9a41$var$c = $32c6e3bbbd5b9a41$var$b ? Symbol.for("react.element") : 60103, $32c6e3bbbd5b9a41$var$d = $32c6e3bbbd5b9a41$var$b ? Symbol.for("react.portal") : 60106, $32c6e3bbbd5b9a41$var$e = $32c6e3bbbd5b9a41$var$b ? Symbol.for("react.fragment") : 60107, $32c6e3bbbd5b9a41$var$f = $32c6e3bbbd5b9a41$var$b ? Symbol.for("react.strict_mode") : 60108, $32c6e3bbbd5b9a41$var$g = $32c6e3bbbd5b9a41$var$b ? Symbol.for("react.profiler") : 60114, $32c6e3bbbd5b9a41$var$h = $32c6e3bbbd5b9a41$var$b ? Symbol.for("react.provider") : 60109, $32c6e3bbbd5b9a41$var$k = $32c6e3bbbd5b9a41$var$b ? Symbol.for("react.context") : 60110, $32c6e3bbbd5b9a41$var$l = $32c6e3bbbd5b9a41$var$b ? Symbol.for("react.async_mode") : 60111, $32c6e3bbbd5b9a41$var$m = $32c6e3bbbd5b9a41$var$b ? Symbol.for("react.concurrent_mode") : 60111, $32c6e3bbbd5b9a41$var$n = $32c6e3bbbd5b9a41$var$b ? Symbol.for("react.forward_ref") : 60112, $32c6e3bbbd5b9a41$var$p = $32c6e3bbbd5b9a41$var$b ? Symbol.for("react.suspense") : 60113, $32c6e3bbbd5b9a41$var$q = $32c6e3bbbd5b9a41$var$b ? Symbol.for("react.suspense_list") : 60120, $32c6e3bbbd5b9a41$var$r = $32c6e3bbbd5b9a41$var$b ? Symbol.for("react.memo") : 60115, $32c6e3bbbd5b9a41$var$t = $32c6e3bbbd5b9a41$var$b ? Symbol.for("react.lazy") : 60116, $32c6e3bbbd5b9a41$var$v = $32c6e3bbbd5b9a41$var$b ? Symbol.for("react.block") : 60121, $32c6e3bbbd5b9a41$var$w = $32c6e3bbbd5b9a41$var$b ? Symbol.for("react.fundamental") : 60117, $32c6e3bbbd5b9a41$var$x = $32c6e3bbbd5b9a41$var$b ? Symbol.for("react.responder") : 60118, $32c6e3bbbd5b9a41$var$y = $32c6e3bbbd5b9a41$var$b ? Symbol.for("react.scope") : 60119;
function $32c6e3bbbd5b9a41$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $32c6e3bbbd5b9a41$var$c:
                switch(a = a.type, a){
                    case $32c6e3bbbd5b9a41$var$l:
                    case $32c6e3bbbd5b9a41$var$m:
                    case $32c6e3bbbd5b9a41$var$e:
                    case $32c6e3bbbd5b9a41$var$g:
                    case $32c6e3bbbd5b9a41$var$f:
                    case $32c6e3bbbd5b9a41$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $32c6e3bbbd5b9a41$var$k:
                            case $32c6e3bbbd5b9a41$var$n:
                            case $32c6e3bbbd5b9a41$var$t:
                            case $32c6e3bbbd5b9a41$var$r:
                            case $32c6e3bbbd5b9a41$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $32c6e3bbbd5b9a41$var$d:
                return u;
        }
    }
}
function $32c6e3bbbd5b9a41$var$A(a) {
    return $32c6e3bbbd5b9a41$var$z(a) === $32c6e3bbbd5b9a41$var$m;
}
$32c6e3bbbd5b9a41$export$2b8d127b894957b9 = $32c6e3bbbd5b9a41$var$l;
$32c6e3bbbd5b9a41$export$cea3a54a6425200c = $32c6e3bbbd5b9a41$var$m;
$32c6e3bbbd5b9a41$export$a7c73072b1a182ae = $32c6e3bbbd5b9a41$var$k;
$32c6e3bbbd5b9a41$export$9f27bc3417b4524d = $32c6e3bbbd5b9a41$var$h;
$32c6e3bbbd5b9a41$export$db77ccec0bb4ccac = $32c6e3bbbd5b9a41$var$c;
$32c6e3bbbd5b9a41$export$8392c0c9d3dcbd35 = $32c6e3bbbd5b9a41$var$n;
$32c6e3bbbd5b9a41$export$ffb0004e005737fa = $32c6e3bbbd5b9a41$var$e;
$32c6e3bbbd5b9a41$export$b624eff549462981 = $32c6e3bbbd5b9a41$var$t;
$32c6e3bbbd5b9a41$export$7897aa7841a5380c = $32c6e3bbbd5b9a41$var$r;
$32c6e3bbbd5b9a41$export$602eac185826482c = $32c6e3bbbd5b9a41$var$d;
$32c6e3bbbd5b9a41$export$e2c29f18771995cb = $32c6e3bbbd5b9a41$var$g;
$32c6e3bbbd5b9a41$export$5f8d39834fd61797 = $32c6e3bbbd5b9a41$var$f;
$32c6e3bbbd5b9a41$export$74bf444e3cd11ea5 = $32c6e3bbbd5b9a41$var$p;
$32c6e3bbbd5b9a41$export$92387174baf9b227 = function(a) {
    return $32c6e3bbbd5b9a41$var$A(a) || $32c6e3bbbd5b9a41$var$z(a) === $32c6e3bbbd5b9a41$var$l;
};
$32c6e3bbbd5b9a41$export$ec112efeb987d9c6 = $32c6e3bbbd5b9a41$var$A;
$32c6e3bbbd5b9a41$export$b706b080d889d2c9 = function(a) {
    return $32c6e3bbbd5b9a41$var$z(a) === $32c6e3bbbd5b9a41$var$k;
};
$32c6e3bbbd5b9a41$export$5be5a87408f70ddc = function(a) {
    return $32c6e3bbbd5b9a41$var$z(a) === $32c6e3bbbd5b9a41$var$h;
};
$32c6e3bbbd5b9a41$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $32c6e3bbbd5b9a41$var$c;
};
$32c6e3bbbd5b9a41$export$455c2e768291efa6 = function(a) {
    return $32c6e3bbbd5b9a41$var$z(a) === $32c6e3bbbd5b9a41$var$n;
};
$32c6e3bbbd5b9a41$export$9522e17588c12572 = function(a) {
    return $32c6e3bbbd5b9a41$var$z(a) === $32c6e3bbbd5b9a41$var$e;
};
$32c6e3bbbd5b9a41$export$2110ac352bb060b9 = function(a) {
    return $32c6e3bbbd5b9a41$var$z(a) === $32c6e3bbbd5b9a41$var$t;
};
$32c6e3bbbd5b9a41$export$56885ab8b9c456ab = function(a) {
    return $32c6e3bbbd5b9a41$var$z(a) === $32c6e3bbbd5b9a41$var$r;
};
$32c6e3bbbd5b9a41$export$d927fcb6adf8f9de = function(a) {
    return $32c6e3bbbd5b9a41$var$z(a) === $32c6e3bbbd5b9a41$var$d;
};
$32c6e3bbbd5b9a41$export$b82d16f27459e05a = function(a) {
    return $32c6e3bbbd5b9a41$var$z(a) === $32c6e3bbbd5b9a41$var$g;
};
$32c6e3bbbd5b9a41$export$522c17b4f5e123e8 = function(a) {
    return $32c6e3bbbd5b9a41$var$z(a) === $32c6e3bbbd5b9a41$var$f;
};
$32c6e3bbbd5b9a41$export$1aabd8a0274ecfd6 = function(a) {
    return $32c6e3bbbd5b9a41$var$z(a) === $32c6e3bbbd5b9a41$var$p;
};
$32c6e3bbbd5b9a41$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $32c6e3bbbd5b9a41$var$e || a === $32c6e3bbbd5b9a41$var$m || a === $32c6e3bbbd5b9a41$var$g || a === $32c6e3bbbd5b9a41$var$f || a === $32c6e3bbbd5b9a41$var$p || a === $32c6e3bbbd5b9a41$var$q || "object" === typeof a && null !== a && (a.$$typeof === $32c6e3bbbd5b9a41$var$t || a.$$typeof === $32c6e3bbbd5b9a41$var$r || a.$$typeof === $32c6e3bbbd5b9a41$var$h || a.$$typeof === $32c6e3bbbd5b9a41$var$k || a.$$typeof === $32c6e3bbbd5b9a41$var$n || a.$$typeof === $32c6e3bbbd5b9a41$var$w || a.$$typeof === $32c6e3bbbd5b9a41$var$x || a.$$typeof === $32c6e3bbbd5b9a41$var$y || a.$$typeof === $32c6e3bbbd5b9a41$var$v);
};
$32c6e3bbbd5b9a41$export$f5bbd400c2f4426f = $32c6e3bbbd5b9a41$var$z;

});



parcelRegister("9sKTW", function(module, exports) {
"use strict";

var $prIHh = parcelRequire("prIHh");
module.exports = function(node) {
    $prIHh(node, "table", $6e3b1c371543f66e$var$wrap);
    return node;
};
function $6e3b1c371543f66e$var$wrap(table) {
    var children = table.children;
    table.children = [
        {
            type: "tableHead",
            align: table.align,
            children: [
                children[0]
            ],
            position: children[0].position
        }
    ];
    if (children.length > 1) table.children.push({
        type: "tableBody",
        align: table.align,
        children: children.slice(1),
        position: {
            start: children[1].position.start,
            end: children[children.length - 1].position.end
        }
    });
}

});

parcelRegister("6MxVG", function(module, exports) {
"use strict";

var $prIHh = parcelRequire("prIHh");
module.exports = function getDefinitions(tree) {
    var definitions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    $prIHh(tree, "definition", function(node) {
        var identifier = node.identifier.toUpperCase();
        if (identifier in definitions) return;
        definitions[identifier] = {
            href: node.url,
            title: node.title
        };
    });
    return definitions;
};

});

parcelRegister("g3q3g", function(module, exports) {
"use strict";
var $bb01227df617c8df$var$protocols = [
    "http",
    "https",
    "mailto",
    "tel"
];
module.exports = function uriTransformer(uri) {
    var url = (uri || "").trim();
    var first = url.charAt(0);
    if (first === "#" || first === "/") return url;
    var colon = url.indexOf(":");
    if (colon === -1) return url;
    var length = $bb01227df617c8df$var$protocols.length;
    var index = -1;
    while(++index < length){
        var protocol = $bb01227df617c8df$var$protocols[index];
        if (colon === protocol.length && url.slice(0, protocol.length).toLowerCase() === protocol) return url;
    }
    index = url.indexOf("?");
    if (index !== -1 && colon > index) return url;
    index = url.indexOf("#");
    if (index !== -1 && colon > index) return url;
     // eslint-disable-next-line no-script-url
    return "javascript:void(0)";
};

});

parcelRegister("k6xnT", function(module, exports) {
/* eslint-disable react/prop-types, react/no-multi-comp */ "use strict";

var $fv6YB = parcelRequire("fv6YB");

var $eeH7J = parcelRequire("eeH7J");
/* istanbul ignore next - Don’t crash on old React. */ var $ea2e43a448bbe55e$var$supportsStringRender = parseInt(($eeH7J.version || "16").slice(0, 2), 10) >= 16;
var $ea2e43a448bbe55e$var$createElement = $eeH7J.createElement;
module.exports = {
    break: "br",
    paragraph: "p",
    emphasis: "em",
    strong: "strong",
    thematicBreak: "hr",
    blockquote: "blockquote",
    delete: "del",
    link: "a",
    image: "img",
    linkReference: "a",
    imageReference: "img",
    table: $ea2e43a448bbe55e$var$SimpleRenderer.bind(null, "table"),
    tableHead: $ea2e43a448bbe55e$var$SimpleRenderer.bind(null, "thead"),
    tableBody: $ea2e43a448bbe55e$var$SimpleRenderer.bind(null, "tbody"),
    tableRow: $ea2e43a448bbe55e$var$SimpleRenderer.bind(null, "tr"),
    tableCell: $ea2e43a448bbe55e$var$TableCell,
    root: $ea2e43a448bbe55e$var$Root,
    text: $ea2e43a448bbe55e$var$TextRenderer,
    list: $ea2e43a448bbe55e$var$List,
    listItem: $ea2e43a448bbe55e$var$ListItem,
    definition: $ea2e43a448bbe55e$var$NullRenderer,
    heading: $ea2e43a448bbe55e$var$Heading,
    inlineCode: $ea2e43a448bbe55e$var$InlineCode,
    code: $ea2e43a448bbe55e$var$CodeBlock,
    html: $ea2e43a448bbe55e$var$Html,
    virtualHtml: $ea2e43a448bbe55e$var$VirtualHtml,
    parsedHtml: $ea2e43a448bbe55e$var$ParsedHtml
};
function $ea2e43a448bbe55e$var$TextRenderer(props) {
    /* istanbul ignore next - a text node w/o a value could be injected by plugins */ var children = props.children || "";
    /* istanbul ignore next - `span` is a fallback for old React. */ return $ea2e43a448bbe55e$var$supportsStringRender ? children : $ea2e43a448bbe55e$var$createElement("span", null, children);
}
function $ea2e43a448bbe55e$var$Root(props) {
    var className = props.className;
    var root = !className && $eeH7J.Fragment || "div";
    return $ea2e43a448bbe55e$var$createElement(root, className ? {
        className: className
    } : null, props.children);
}
function $ea2e43a448bbe55e$var$SimpleRenderer(tag, props) {
    return $ea2e43a448bbe55e$var$createElement(tag, $ea2e43a448bbe55e$var$getCoreProps(props), props.children);
}
function $ea2e43a448bbe55e$var$TableCell(props) {
    var style = props.align ? {
        textAlign: props.align
    } : undefined;
    var coreProps = $ea2e43a448bbe55e$var$getCoreProps(props);
    return $ea2e43a448bbe55e$var$createElement(props.isHeader ? "th" : "td", style ? $fv6YB({
        style: style
    }, coreProps) : coreProps, props.children);
}
function $ea2e43a448bbe55e$var$Heading(props) {
    return $ea2e43a448bbe55e$var$createElement("h".concat(props.level), $ea2e43a448bbe55e$var$getCoreProps(props), props.children);
}
function $ea2e43a448bbe55e$var$List(props) {
    var attrs = $ea2e43a448bbe55e$var$getCoreProps(props);
    if (props.start !== null && props.start !== 1 && props.start !== undefined) attrs.start = props.start.toString();
    return $ea2e43a448bbe55e$var$createElement(props.ordered ? "ol" : "ul", attrs, props.children);
}
function $ea2e43a448bbe55e$var$ListItem(props) {
    var checkbox = null;
    if (props.checked !== null && props.checked !== undefined) {
        var checked = props.checked;
        checkbox = $ea2e43a448bbe55e$var$createElement("input", {
            type: "checkbox",
            checked: checked,
            readOnly: true
        });
    }
    return $ea2e43a448bbe55e$var$createElement("li", $ea2e43a448bbe55e$var$getCoreProps(props), checkbox, props.children);
}
function $ea2e43a448bbe55e$var$CodeBlock(props) {
    var className = props.language && "language-".concat(props.language);
    var code = $ea2e43a448bbe55e$var$createElement("code", className ? {
        className: className
    } : null, props.value);
    return $ea2e43a448bbe55e$var$createElement("pre", $ea2e43a448bbe55e$var$getCoreProps(props), code);
}
function $ea2e43a448bbe55e$var$InlineCode(props) {
    return $ea2e43a448bbe55e$var$createElement("code", $ea2e43a448bbe55e$var$getCoreProps(props), props.children);
}
function $ea2e43a448bbe55e$var$Html(props) {
    if (props.skipHtml) return null;
    var dangerous = props.allowDangerousHtml || props.escapeHtml === false;
    var tag = props.isBlock ? "div" : "span";
    if (!dangerous) /* istanbul ignore next - `tag` is a fallback for old React. */ return $ea2e43a448bbe55e$var$createElement($eeH7J.Fragment || tag, null, props.value);
    var nodeProps = {
        dangerouslySetInnerHTML: {
            __html: props.value
        }
    };
    return $ea2e43a448bbe55e$var$createElement(tag, nodeProps);
}
function $ea2e43a448bbe55e$var$ParsedHtml(props) {
    /* To do: `React.cloneElement` is slow, is it really needed? */ return props["data-sourcepos"] ? $eeH7J.cloneElement(props.element, {
        "data-sourcepos": props["data-sourcepos"]
    }) : props.element;
}
function $ea2e43a448bbe55e$var$VirtualHtml(props) {
    return $ea2e43a448bbe55e$var$createElement(props.tag, $ea2e43a448bbe55e$var$getCoreProps(props), props.children);
}
function $ea2e43a448bbe55e$var$NullRenderer() {
    return null;
}
function $ea2e43a448bbe55e$var$getCoreProps(props) {
    var source = props["data-sourcepos"];
    /* istanbul ignore next - nodes from plugins w/o position */ return source ? {
        "data-sourcepos": source
    } : {};
}

});

parcelRegister("28Nw1", function(module, exports) {

$parcel$export(module.exports, "HtmlParser", function () { return $18f2bce0cfb1d3dd$export$cd4d4c3e9818d120; }, function (v) { return $18f2bce0cfb1d3dd$export$cd4d4c3e9818d120 = v; });
/* istanbul ignore next - Fallback for `Symbol`. */ var $18f2bce0cfb1d3dd$export$cd4d4c3e9818d120;
"use strict";
var $18f2bce0cfb1d3dd$var$HtmlParser = "__RMD_HTML_PARSER__";
$18f2bce0cfb1d3dd$export$cd4d4c3e9818d120 = typeof Symbol === "undefined" ? $18f2bce0cfb1d3dd$var$HtmlParser : Symbol($18f2bce0cfb1d3dd$var$HtmlParser);

});


parcelRegister("eBaY3", function(module, exports) {

$parcel$export(module.exports, "ObjectPathProvider", function () { return $aa0d0755834dffaa$export$3ec3c6d68e85dc09; });
$parcel$export(module.exports, "useObjectPath", function () { return $aa0d0755834dffaa$export$c64238854ca31f1e; });
$parcel$export(module.exports, "ReadonlyContext", function () { return $aa0d0755834dffaa$export$589de21c3e0d3d73; });
$parcel$export(module.exports, "useIsReadonlyField", function () { return $aa0d0755834dffaa$export$90ba2930ba928414; });
$parcel$export(module.exports, "useCanUpdateField", function () { return $aa0d0755834dffaa$export$3974d529be07cc4f; });

var $4vwom = parcelRequire("4vwom");

var $eeH7J = parcelRequire("eeH7J");

var $43jhg = parcelRequire("43jhg");

var $1TOtF = parcelRequire("1TOtF");
const $aa0d0755834dffaa$export$b86796b8fb63a35b = /*#__PURE__*/ (0, $eeH7J.createContext)(null);
function $aa0d0755834dffaa$export$3ec3c6d68e85dc09({ name: name, obj: obj, type: type, children: children }) {
    const objectContext = {
        obj: obj,
        name: name,
        type: type,
        parent: (0, $eeH7J.useContext)($aa0d0755834dffaa$export$b86796b8fb63a35b)
    };
    // Protects against infinite object loops
    let chain = 0;
    let p = objectContext;
    while(p && chain < 10){
        p = p.parent;
        chain++;
    }
    if (chain > 9) throw new Error("Too deep object path");
    return (0, $4vwom.jsx)($aa0d0755834dffaa$export$b86796b8fb63a35b.Provider, {
        value: objectContext,
        children: children
    });
}
function $aa0d0755834dffaa$export$cf005ea9a0b17126() {
    const objectContext = (0, $eeH7J.useContext)($aa0d0755834dffaa$export$b86796b8fb63a35b);
    return (type)=>{
        const p = $aa0d0755834dffaa$var$findParentObject(type, objectContext);
        return p && $aa0d0755834dffaa$var$pathOf(p);
    };
}
function $aa0d0755834dffaa$var$pathOf(context) {
    if (context.parent) return [
        ...$aa0d0755834dffaa$var$pathOf(context.parent),
        context.name
    ];
    else return [
        context.name
    ];
}
function $aa0d0755834dffaa$var$findParentObject(type, context) {
    if (!context) return;
    if ((0, $43jhg.AreTypesAssignable)(type, context === null || context === void 0 ? void 0 : context.type)) return context;
    return $aa0d0755834dffaa$var$findParentObject(type, context.parent);
}
function $aa0d0755834dffaa$export$c64238854ca31f1e() {
    const objectContext = (0, $eeH7J.useContext)($aa0d0755834dffaa$export$b86796b8fb63a35b);
    const path = [];
    let context = objectContext;
    while(context){
        path.unshift(context.name);
        context = context.parent;
    }
    return path;
}
const $aa0d0755834dffaa$export$589de21c3e0d3d73 = /*#__PURE__*/ (0, $eeH7J.createContext)({
    mode: "edit"
});
function $aa0d0755834dffaa$export$90ba2930ba928414(property, /** Setting this to true  allows filling in illegal readonly blanks, e.g. when adding a new
    blank item in a list with readonly fields.
*/ needsEditing) {
    const { mode: mode, updateableSubtree: updateableSubtree } = (0, $eeH7J.useContext)($aa0d0755834dffaa$export$589de21c3e0d3d73);
    const doc = (0, $1TOtF.useDocument)();
    const canUpdate = $aa0d0755834dffaa$export$3974d529be07cc4f(property.name);
    switch(mode){
        case "readonly":
            return true; // readonly
        case "create":
            return false; // not readonly
        case "edit":
            if (property.isLocked || property.isReadonly) {
                if (!needsEditing) return true; // readonly
            }
    }
    if (!doc) // no DocumentContext, but ReadonlyContext says edit, so not readonly
    return false;
    // Are we in an explicitly updateable subtree context?
    if (updateableSubtree) return false; // not readonly
    return !canUpdate; // If we can't update, its readonly
}
function $aa0d0755834dffaa$export$3974d529be07cc4f(fieldName) {
    const path = $aa0d0755834dffaa$export$c64238854ca31f1e();
    const doc = (0, $1TOtF.useDocument)();
    const docCanUpdate = (0, $1TOtF.useDocumentCanUpdate)();
    if (!doc) return true;
    // Do we have carte blanche update permissions?
    const canUpdate = docCanUpdate !== null && docCanUpdate !== void 0 ? docCanUpdate : false;
    if (canUpdate === true) return true;
    // For now, we only support field-specific permissions at the top-level
    if (path.length === 0) {
        // Do we have specific update permissions?
        const canUpdateThisParticularField = canUpdate instanceof Array && canUpdate.includes(fieldName);
        if (canUpdateThisParticularField) return true;
    }
    // No update permissions
    return false;
}

});
parcelRegister("1TOtF", function(module, exports) {

$parcel$export(module.exports, "DocumentRefreshContext", function () { return $16221546fbd9b0f1$export$379f46dce4f15359; });
$parcel$export(module.exports, "useDocumentRefresh", function () { return $16221546fbd9b0f1$export$ec990de4ddb78a9f; });
$parcel$export(module.exports, "ShowAllPropsContext", function () { return $16221546fbd9b0f1$export$61cc5cc6648852fb; });
$parcel$export(module.exports, "useShowAllProps", function () { return $16221546fbd9b0f1$export$87fb642bdf4f5ffa; });
$parcel$export(module.exports, "useToggleShowAllProps", function () { return $16221546fbd9b0f1$export$1eecde8893596e9c; });
$parcel$export(module.exports, "DocumentContext", function () { return $16221546fbd9b0f1$export$41b6c5189865fe72; });
$parcel$export(module.exports, "useDocument", function () { return $16221546fbd9b0f1$export$e71e2fb5c5c476d5; });
$parcel$export(module.exports, "useDocumentType", function () { return $16221546fbd9b0f1$export$86294d87e4207046; });
$parcel$export(module.exports, "DocumentFilesContext", function () { return $16221546fbd9b0f1$export$7d507c4e270ad44e; });
$parcel$export(module.exports, "useDocumentFiles", function () { return $16221546fbd9b0f1$export$57c6b529f015840d; });
$parcel$export(module.exports, "DocumentTypeExtensionsContext", function () { return $16221546fbd9b0f1$export$4a4ebd16b6b44aeb; });
$parcel$export(module.exports, "useDocumentTypeExtensions", function () { return $16221546fbd9b0f1$export$80a028a719e8f043; });
$parcel$export(module.exports, "DocumentWidgetsContext", function () { return $16221546fbd9b0f1$export$c18700947eee6325; });
$parcel$export(module.exports, "useDocumentWidgets", function () { return $16221546fbd9b0f1$export$c6dcc4a4037dbbd2; });
$parcel$export(module.exports, "DocumentRefsContext", function () { return $16221546fbd9b0f1$export$453fd65b9646d14f; });
$parcel$export(module.exports, "useDocumentRefs", function () { return $16221546fbd9b0f1$export$13d835e68b83aede; });
$parcel$export(module.exports, "useDocumentPrimaryKey", function () { return $16221546fbd9b0f1$export$38dc63f53258eba; });
$parcel$export(module.exports, "useDocumentCollection", function () { return $16221546fbd9b0f1$export$c90a903b1e47a05c; });
$parcel$export(module.exports, "DocumentOptionsContext", function () { return $16221546fbd9b0f1$export$51ec9caf3279c082; });
$parcel$export(module.exports, "useDocumentOptions", function () { return $16221546fbd9b0f1$export$fe26d111b2d3cec4; });
$parcel$export(module.exports, "DocumentCanUpdateContext", function () { return $16221546fbd9b0f1$export$48c5e931104274e2; });
$parcel$export(module.exports, "useDocumentCanUpdate", function () { return $16221546fbd9b0f1$export$1b2c870badf108e7; });
$parcel$export(module.exports, "DocumentContextProvider", function () { return $16221546fbd9b0f1$export$30e869153d18a2e6; });

var $4vwom = parcelRequire("4vwom");

var $eeH7J = parcelRequire("eeH7J");
const $16221546fbd9b0f1$export$379f46dce4f15359 = /*#__PURE__*/ (0, $eeH7J.createContext)(undefined);
function $16221546fbd9b0f1$export$ec990de4ddb78a9f() {
    return (0, $eeH7J.useContext)($16221546fbd9b0f1$export$379f46dce4f15359);
}
const $16221546fbd9b0f1$export$61cc5cc6648852fb = /*#__PURE__*/ (0, $eeH7J.createContext)(true);
function $16221546fbd9b0f1$export$87fb642bdf4f5ffa() {
    return (0, $eeH7J.useContext)($16221546fbd9b0f1$export$61cc5cc6648852fb);
}
const $16221546fbd9b0f1$export$d21793970f74f35 = /*#__PURE__*/ (0, $eeH7J.createContext)(undefined);
function $16221546fbd9b0f1$export$1eecde8893596e9c() {
    return (0, $eeH7J.useContext)($16221546fbd9b0f1$export$d21793970f74f35);
}
const $16221546fbd9b0f1$export$41b6c5189865fe72 = /*#__PURE__*/ (0, $eeH7J.createContext)(undefined);
function $16221546fbd9b0f1$export$e71e2fb5c5c476d5() {
    return (0, $eeH7J.useContext)($16221546fbd9b0f1$export$41b6c5189865fe72);
}
const $16221546fbd9b0f1$export$ad48c00e5b92e19a = /*#__PURE__*/ (0, $eeH7J.createContext)(undefined);
function $16221546fbd9b0f1$export$86294d87e4207046() {
    return (0, $eeH7J.useContext)($16221546fbd9b0f1$export$ad48c00e5b92e19a);
}
const $16221546fbd9b0f1$export$7d507c4e270ad44e = /*#__PURE__*/ (0, $eeH7J.createContext)(undefined);
function $16221546fbd9b0f1$export$57c6b529f015840d() {
    return (0, $eeH7J.useContext)($16221546fbd9b0f1$export$7d507c4e270ad44e);
}
const $16221546fbd9b0f1$export$4a4ebd16b6b44aeb = /*#__PURE__*/ (0, $eeH7J.createContext)(undefined);
function $16221546fbd9b0f1$export$80a028a719e8f043() {
    return (0, $eeH7J.useContext)($16221546fbd9b0f1$export$4a4ebd16b6b44aeb);
}
const $16221546fbd9b0f1$export$c18700947eee6325 = /*#__PURE__*/ (0, $eeH7J.createContext)(undefined);
function $16221546fbd9b0f1$export$c6dcc4a4037dbbd2() {
    return (0, $eeH7J.useContext)($16221546fbd9b0f1$export$c18700947eee6325);
}
const $16221546fbd9b0f1$export$453fd65b9646d14f = /*#__PURE__*/ (0, $eeH7J.createContext)(undefined);
function $16221546fbd9b0f1$export$13d835e68b83aede() {
    return (0, $eeH7J.useContext)($16221546fbd9b0f1$export$453fd65b9646d14f);
}
const $16221546fbd9b0f1$export$276ad87503ef4b9e = /*#__PURE__*/ (0, $eeH7J.createContext)(undefined);
function $16221546fbd9b0f1$export$38dc63f53258eba() {
    return (0, $eeH7J.useContext)($16221546fbd9b0f1$export$276ad87503ef4b9e);
}
const $16221546fbd9b0f1$export$491b93aabdd2bc4d = /*#__PURE__*/ (0, $eeH7J.createContext)(undefined);
function $16221546fbd9b0f1$export$c90a903b1e47a05c() {
    return (0, $eeH7J.useContext)($16221546fbd9b0f1$export$491b93aabdd2bc4d);
}
const $16221546fbd9b0f1$export$51ec9caf3279c082 = /*#__PURE__*/ (0, $eeH7J.createContext)(undefined);
function $16221546fbd9b0f1$export$fe26d111b2d3cec4() {
    return (0, $eeH7J.useContext)($16221546fbd9b0f1$export$51ec9caf3279c082);
}
const $16221546fbd9b0f1$export$48c5e931104274e2 = /*#__PURE__*/ (0, $eeH7J.createContext)(undefined);
function $16221546fbd9b0f1$export$1b2c870badf108e7() {
    return (0, $eeH7J.useContext)($16221546fbd9b0f1$export$48c5e931104274e2);
}
function $16221546fbd9b0f1$export$30e869153d18a2e6(props) {
    return (0, $4vwom.jsx)($16221546fbd9b0f1$export$41b6c5189865fe72.Provider, {
        value: props.doc,
        children: (0, $4vwom.jsx)($16221546fbd9b0f1$export$c18700947eee6325.Provider, {
            value: props.widgets,
            children: (0, $4vwom.jsx)($16221546fbd9b0f1$export$276ad87503ef4b9e.Provider, {
                value: props.primaryKey,
                children: (0, $4vwom.jsx)($16221546fbd9b0f1$export$491b93aabdd2bc4d.Provider, {
                    value: props.collection,
                    children: (0, $4vwom.jsx)($16221546fbd9b0f1$export$51ec9caf3279c082.Provider, {
                        value: props.options,
                        children: (0, $4vwom.jsx)($16221546fbd9b0f1$export$453fd65b9646d14f.Provider, {
                            value: props.refs,
                            children: (0, $4vwom.jsx)($16221546fbd9b0f1$export$7d507c4e270ad44e.Provider, {
                                value: props.files,
                                children: (0, $4vwom.jsx)($16221546fbd9b0f1$export$4a4ebd16b6b44aeb.Provider, {
                                    value: props.typeExtensions,
                                    children: (0, $4vwom.jsx)($16221546fbd9b0f1$export$d21793970f74f35.Provider, {
                                        value: props.toggleShowAllProps,
                                        children: (0, $4vwom.jsx)($16221546fbd9b0f1$export$61cc5cc6648852fb.Provider, {
                                            value: props.showAllProps,
                                            children: (0, $4vwom.jsx)($16221546fbd9b0f1$export$379f46dce4f15359.Provider, {
                                                value: props.refresh,
                                                children: (0, $4vwom.jsx)($16221546fbd9b0f1$export$ad48c00e5b92e19a.Provider, {
                                                    value: props.type,
                                                    children: (0, $4vwom.jsx)($16221546fbd9b0f1$export$48c5e931104274e2.Provider, {
                                                        value: props.canUpdate,
                                                        children: props.children
                                                    })
                                                })
                                            })
                                        })
                                    })
                                })
                            })
                        })
                    })
                })
            })
        })
    });
}

});


parcelRegister("5eFGD", function(module, exports) {

$parcel$export(module.exports, "RenderButtons", function () { return $3cfe98a794b371b5$export$b9116b2721afaa7a; });

var $4vwom = parcelRequire("4vwom");

var $fT6Pt = parcelRequire("fT6Pt");
function $3cfe98a794b371b5$export$b9116b2721afaa7a(buttons) {
    return !!buttons.length && (0, $4vwom.jsx)((0, $fT6Pt.ContextButton), {
        buttons: (0, $4vwom.jsx)((0, $4vwom.Fragment), {
            children: buttons.map((b)=>(0, $4vwom.jsx)((0, $fT6Pt.RButton), {
                    icon: b.icon,
                    disabled: b.disabled,
                    onClick: b.onClick,
                    children: b.variant === "primary" ? (0, $4vwom.jsx)("b", {
                        children: b.text
                    }) : b.text
                }, b.text))
        })
    });
}

});

parcelRegister("4SFVE", function(module, exports) {

$parcel$export(module.exports, "ErrorBoundary", function () { return $38dcbac045f34589$export$e926676385687eaf; });

var $eeH7J = parcelRequire("eeH7J");
"use client";
const $38dcbac045f34589$export$b16d9fb1a22de840 = (0, $eeH7J.createContext)(null);
const $38dcbac045f34589$var$initialState = {
    didCatch: false,
    error: null
};
class $38dcbac045f34589$export$e926676385687eaf extends (0, $eeH7J.Component) {
    constructor(props){
        super(props);
        this.resetErrorBoundary = this.resetErrorBoundary.bind(this);
        this.state = $38dcbac045f34589$var$initialState;
    }
    static getDerivedStateFromError(error) {
        return {
            didCatch: true,
            error: error
        };
    }
    resetErrorBoundary() {
        const { error: error } = this.state;
        if (error !== null) {
            var _this$props$onReset, _this$props;
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            (_this$props$onReset = (_this$props = this.props).onReset) === null || _this$props$onReset === void 0 || _this$props$onReset.call(_this$props, {
                args: args,
                reason: "imperative-api"
            });
            this.setState($38dcbac045f34589$var$initialState);
        }
    }
    componentDidCatch(error, info) {
        var _this$props$onError, _this$props2;
        (_this$props$onError = (_this$props2 = this.props).onError) === null || _this$props$onError === void 0 || _this$props$onError.call(_this$props2, error, info);
    }
    componentDidUpdate(prevProps, prevState) {
        const { didCatch: didCatch } = this.state;
        const { resetKeys: resetKeys } = this.props;
        // There's an edge case where if the thing that triggered the error happens to *also* be in the resetKeys array,
        // we'd end up resetting the error boundary immediately.
        // This would likely trigger a second error to be thrown.
        // So we make sure that we don't check the resetKeys on the first call of cDU after the error is set.
        if (didCatch && prevState.error !== null && $38dcbac045f34589$var$hasArrayChanged(prevProps.resetKeys, resetKeys)) {
            var _this$props$onReset2, _this$props3;
            (_this$props$onReset2 = (_this$props3 = this.props).onReset) === null || _this$props$onReset2 === void 0 || _this$props$onReset2.call(_this$props3, {
                next: resetKeys,
                prev: prevProps.resetKeys,
                reason: "keys"
            });
            this.setState($38dcbac045f34589$var$initialState);
        }
    }
    render() {
        const { children: children, fallbackRender: fallbackRender, FallbackComponent: FallbackComponent, fallback: fallback } = this.props;
        const { didCatch: didCatch, error: error } = this.state;
        let childToRender = children;
        if (didCatch) {
            const props = {
                error: error,
                resetErrorBoundary: this.resetErrorBoundary
            };
            if (typeof fallbackRender === "function") childToRender = fallbackRender(props);
            else if (FallbackComponent) childToRender = (0, $eeH7J.createElement)(FallbackComponent, props);
            else if (fallback !== undefined) childToRender = fallback;
            else throw error;
        }
        return (0, $eeH7J.createElement)($38dcbac045f34589$export$b16d9fb1a22de840.Provider, {
            value: {
                didCatch: didCatch,
                error: error,
                resetErrorBoundary: this.resetErrorBoundary
            }
        }, childToRender);
    }
}
function $38dcbac045f34589$var$hasArrayChanged() {
    let a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    let b = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    return a.length !== b.length || a.some((item, index)=>!Object.is(item, b[index]));
}
function $38dcbac045f34589$var$assertErrorBoundaryContext(value) {
    if (value == null || typeof value.didCatch !== "boolean" || typeof value.resetErrorBoundary !== "function") throw new Error("ErrorBoundaryContext not found");
}
function $38dcbac045f34589$export$c052f6604b7d51fe() {
    const context = (0, $eeH7J.useContext)($38dcbac045f34589$export$b16d9fb1a22de840);
    $38dcbac045f34589$var$assertErrorBoundaryContext(context);
    const [state, setState] = (0, $eeH7J.useState)({
        error: null,
        hasError: false
    });
    const memoized = (0, $eeH7J.useMemo)(()=>({
            resetBoundary: ()=>{
                context.resetErrorBoundary();
                setState({
                    error: null,
                    hasError: false
                });
            },
            showBoundary: (error)=>setState({
                    error: error,
                    hasError: true
                })
        }), [
        context.resetErrorBoundary
    ]);
    if (state.hasError) throw state.error;
    return memoized;
}
function $38dcbac045f34589$export$f0c7a449e0cfaec7(component, errorBoundaryProps) {
    const Wrapped = (0, $eeH7J.forwardRef)((props, ref)=>(0, $eeH7J.createElement)($38dcbac045f34589$export$e926676385687eaf, errorBoundaryProps, (0, $eeH7J.createElement)(component, {
            ...props,
            ref: ref
        })));
    // Format for display in DevTools
    const name = component.displayName || component.name || "Unknown";
    Wrapped.displayName = "withErrorBoundary(".concat(name, ")");
    return Wrapped;
}

});


parcelRegister("6cx8r", function(module, exports) {

$parcel$export(module.exports, "PropView", function () { return $483d90fe249ccbff$export$cfbb072ee809fa0a; });

var $4vwom = parcelRequire("4vwom");

var $eeH7J = parcelRequire("eeH7J");

var $kMyqA = parcelRequire("kMyqA");

var $2tM8G = parcelRequire("2tM8G");

var $1y435 = parcelRequire("1y435");

var $eXq7x = parcelRequire("eXq7x");

var $6sxDY = parcelRequire("6sxDY");

var $hRViu = parcelRequire("hRViu");

var $fT6Pt = parcelRequire("fT6Pt");

var $ebjYm = parcelRequire("ebjYm");

var $KiyG5 = parcelRequire("KiyG5");

var $xSO5T = parcelRequire("xSO5T");

var $ft2ED = parcelRequire("ft2ED");

var $4n6CL = parcelRequire("4n6CL");

var $4rY0U = parcelRequire("4rY0U");

var $eBaY3 = parcelRequire("eBaY3");

var $43jhg = parcelRequire("43jhg");

var $14q7s = parcelRequire("14q7s");

var $cSf8f = parcelRequire("cSf8f");

var $4W8fY = parcelRequire("4W8fY");
parcelRequire("2LTO8");
var $cwhCA = parcelRequire("cwhCA");

var $1TOtF = parcelRequire("1TOtF");

var $hQ8BL = parcelRequire("hQ8BL");

var $4bhEs = parcelRequire("4bhEs");

var $1aVVn = parcelRequire("1aVVn");

var $6woBW = parcelRequire("6woBW");

var $8z9Wu = parcelRequire("8z9Wu");
function $483d90fe249ccbff$export$cfbb072ee809fa0a({ obj: obj, label: label, mode: mode, buttons: buttons, isEmbedded: isEmbedded, property: property, bubbleButtons: bubbleButtons }) {
    var _a, _b, _c;
    const name = property.name;
    const type = property.type;
    const optional = property.optional;
    const value = (0, $1aVVn.YTools).get(obj, name);
    const shallowLocked = (_a = property.tags) === null || _a === void 0 ? void 0 : _a.shallowLocked;
    const widgets = (0, $1TOtF.useDocumentWidgets)();
    const optionalAndUndefined = (optional || (0, $43jhg.AreTypesAssignable)(type, (0, $43jhg.UndefinedType))) && value !== undefined;
    const noClearButton = !buttons.some((x)=>x.text === "Clear");
    if (optionalAndUndefined && noClearButton && !shallowLocked) buttons.unshift({
        text: "Clear",
        onClick () {
            (0, $1aVVn.YTools).deleteKey(obj, name);
        }
    });
    if (bubbleButtons) {
        bubbleButtons(buttons);
        buttons = [];
    }
    const match = (0, $43jhg.MatchesType)(value, type) === true;
    const compactState = (0, $eeH7J.useState)(match ? true : undefined);
    let compact = compactState[0];
    const setCompact = compactState[1];
    // If we started as expanded because match was false, but it later became
    // true, lets compact by default
    if (match && compact === undefined) {
        setCompact(true);
        compact = true;
    }
    const alias = (0, $43jhg.GetTypeAlias)(type);
    const path = (0, $eBaY3.useObjectPath)();
    /** Whether to use widget representation, if available */ const [widgetMode, setWidgetMode] = (0, $eeH7J.useState)(true);
    function findWidget() {
        var _a;
        if (typeof property.type === "object") {
            const widget = (_a = property.type.tags) === null || _a === void 0 ? void 0 : _a.widget;
            if (widget) {
                let w = widgets;
                for (const p of path){
                    if (!w) break;
                    w = w[p];
                }
                w = w && w[property.name];
                w = w && w[widget];
                return w;
            }
        }
    }
    const typeProp = (_b = property.tags) === null || _b === void 0 ? void 0 : _b.typeField;
    if (typeProp) {
        const typeName = (0, $1aVVn.YTools).getString(obj, typeProp);
        const type = (0, $cwhCA.GetType)(typeName);
        return (0, $4vwom.jsx)((0, $kMyqA.ObjectPropView), {
            obj: obj,
            property: {
                name: property.name,
                type: type,
                tags: property.tags
            },
            buttons: buttons,
            label: label,
            isEmbedded: true
        });
    }
    // Custom @editor support
    const editor = (_c = property.tags) === null || _c === void 0 ? void 0 : _c.editor;
    const Editor = editor ? (0, $hQ8BL.Editors).get(editor) : undefined;
    if (Editor) return (0, $4vwom.jsx)((0, $hRViu.PropRow), {
        buttons: [],
        description: property.description,
        label: label,
        children: (0, $4vwom.jsx)(Editor, {
            obj: obj,
            property: property
        })
    });
    const widget = findWidget();
    if (widget && widgetMode) return (0, $4vwom.jsxs)("div", {
        style: {
            position: "relative",
            margin: 16
        },
        children: [
            (0, $4vwom.jsx)((0, $4rY0U.WidgetView), {
                value: widget,
                obj: obj,
                property: property
            }),
            (0, $4vwom.jsx)((0, $fT6Pt.RButton), {
                onClick: ()=>setWidgetMode(false),
                variant: "secondary",
                icon: "edit",
                style: {
                    position: "absolute",
                    top: 0,
                    right: 0
                },
                children: (0, $cSf8f.Strings).Edit
            })
        ]
    });
    if (widget) {
        const text = (0, $cSf8f.Strings)["Done editing"];
        if (!buttons.some((b)=>b.text === text)) buttons.push({
            text: text,
            onClick () {
                setWidgetMode(true);
            }
        });
    }
    if (alias && $483d90fe249ccbff$export$cfbb072ee809fa0a.componentOverride.has(alias)) {
        const Comp = $483d90fe249ccbff$export$cfbb072ee809fa0a.componentOverride.get(alias);
        if (Comp) return (0, $4vwom.jsx)(Comp, {
            obj: obj,
            prop: name,
            label: label,
            buttons: buttons,
            description: property.description
        });
    }
    if (alias === "Record") return (0, $4vwom.jsx)((0, $4W8fY.RecordView), {
        obj: obj,
        property: property,
        label: label,
        buttons: buttons
    });
    if (alias === "TypeScript") return (0, $4vwom.jsx)((0, $4n6CL.TypeScriptView), {
        obj: obj,
        label: label,
        property: property
    });
    if (alias === "RichText") return (0, $4vwom.jsx)((0, $4bhEs.RichTextView), {
        obj: obj,
        property: property,
        label: label,
        buttons: buttons
    });
    if (alias === "ThumbHash") return (0, $4vwom.jsx)((0, $hRViu.PropRow), {
        label: label,
        buttons: [],
        children: value === "generate" || value === "generating" ? value : value ? (0, $4vwom.jsx)((0, $8z9Wu.ThumbHashView), {
            base64: value
        }) : (0, $4vwom.jsx)((0, $4vwom.Fragment), {
            children: "Not set"
        })
    });
    if (alias === "SecretHash") return (0, $4vwom.jsx)((0, $6woBW.SecretHashView), {
        obj: obj,
        property: property,
        label: label,
        buttons: buttons,
        isEmbedded: isEmbedded
    });
    // Don't show color picker if choosing from a predefined set of colors.
    // TODO: Implement support for color picker with a predefined set of colors.
    if (alias === "Color" && !(0, $43jhg.IsUnionType)(type)) return (0, $4vwom.jsx)((0, $xSO5T.ColorView), {
        label: label,
        obj: obj,
        property: property,
        buttons: buttons,
        isEmbedded: isEmbedded
    });
    if (alias === "Localized") return (0, $4vwom.jsx)((0, $ebjYm.LocalizedView), {
        obj: obj,
        label: label,
        property: property,
        buttons: buttons,
        isEmbedded: isEmbedded,
        mode: mode
    });
    if ((0, $14q7s.GetFileTypeMimeTypes)(type).length > 0) return (0, $4vwom.jsx)((0, $KiyG5.FileView), {
        obj: obj,
        label: label,
        property: property,
        buttons: buttons,
        icon: "image",
        isEmbedded: isEmbedded
    });
    if (typeof property.type === "object" && property.type.reference && !(0, $43jhg.IsArrayType)(type)) return (0, $4vwom.jsx)((0, $1y435.RefView), {
        buttons: buttons,
        obj: obj,
        property: property,
        label: label,
        isEmbedded: isEmbedded
    });
    const primary = buttons.find((x)=>x.primary);
    if ((0, $43jhg.IsStringType)(type) && primary && typeof value === "string" && property.isReadonly) return (0, $4vwom.jsx)((0, $hRViu.PropRow), {
        isReadonly: true,
        label: label,
        buttons: buttons,
        description: property.description,
        children: (0, $4vwom.jsx)((0, $fT6Pt.RButton), {
            variant: "link",
            onClick: primary.onClick,
            chevron: primary.expanded === undefined ? undefined : primary.expanded ? "chevron-up" : "chevron-down",
            children: value
        })
    });
    if ((0, $43jhg.IsStringLiteral)(type) && property.optional) return (0, $4vwom.jsx)((0, $6sxDY.UnionView), {
        mode: mode,
        obj: obj,
        property: Object.assign(Object.assign({}, property), {
            type: (0, $43jhg.UnionType)(type, (0, $43jhg.UndefinedType))
        }),
        label: label,
        buttons: buttons,
        isEmbedded: isEmbedded
    });
    const scalarOrUndefined = optional && (0, $43jhg.IsStringType)(type) || optional && (0, $43jhg.IsNumberType)(type) || (0, $43jhg.IsTypeOrUndefined)(type, (0, $43jhg.IsStringType)) || (0, $43jhg.IsNumberOrUndefinedType)(type);
    if (scalarOrUndefined) return (0, $4vwom.jsx)((0, $2tM8G.StringView), {
        obj: obj,
        property: property,
        label: label,
        buttons: buttons,
        isEmbedded: isEmbedded
    });
    else if ((0, $43jhg.IsStringType)(type) || (0, $43jhg.IsNumberType)(type)) return (0, $4vwom.jsx)((0, $2tM8G.StringView), {
        obj: obj,
        property: property,
        label: label,
        buttons: buttons,
        isEmbedded: isEmbedded
    });
    else if ((0, $43jhg.IsUnionType)(type)) return (0, $4vwom.jsx)((0, $6sxDY.UnionView), {
        mode: mode,
        obj: obj,
        property: property,
        label: label,
        buttons: buttons,
        isEmbedded: isEmbedded
    });
    else if ((0, $43jhg.IsBooleanType)(type)) return (0, $4vwom.jsx)((0, $eXq7x.BooleanView), {
        obj: obj,
        property: property,
        label: label,
        buttons: buttons
    });
    else if ((0, $43jhg.IsArrayType)(type)) return (0, $4vwom.jsx)((0, $ft2ED.ListPropView), {
        property: property,
        obj: obj,
        buttons: buttons,
        label: label,
        isRoot: false
    });
    else if ((0, $43jhg.IsObjectType)(type) || (0, $43jhg.IsIntersectionType)(type)) return (0, $4vwom.jsx)((0, $kMyqA.ObjectPropView), {
        property: property,
        obj: obj,
        label: label,
        buttons: buttons,
        isEmbedded: !!isEmbedded
    });
    else if ((0, $43jhg.IsAnyType)(type)) return (0, $4vwom.jsx)((0, $4n6CL.TypeScriptView), {
        mode: "json-stringify",
        property: property,
        label: label,
        obj: obj
    });
    return (0, $4vwom.jsxs)((0, $4vwom.Fragment), {
        children: [
            "Unrecognized type: ",
            (0, $43jhg.TypeToString)(type)
        ]
    });
}
$483d90fe249ccbff$export$cfbb072ee809fa0a.componentOverride = new Map();

});
parcelRegister("kMyqA", function(module, exports) {

$parcel$export(module.exports, "ObjectPropView", function () { return $f212fefd9659d816$export$4fb4bdc93d5663a3; });
$parcel$export(module.exports, "ObjectView", function () { return $f212fefd9659d816$export$c93bdb9e9400c13c; });
$parcel$export(module.exports, "ContainsShouldHideProps", function () { return $f212fefd9659d816$export$f78bad51ce700d4e; });

var $4vwom = parcelRequire("4vwom");

var $eeH7J = parcelRequire("eeH7J");

var $6cx8r = parcelRequire("6cx8r");

var $caNEj = parcelRequire("caNEj");
var $jbbp2 = parcelRequire("jbbp2");
var $42fiX = parcelRequire("42fiX");

var $9HOw2 = parcelRequire("9HOw2");

var $eBaY3 = parcelRequire("eBaY3");

var $8h5s0 = parcelRequire("8h5s0");

var $fT6Pt = parcelRequire("fT6Pt");

var $hRViu = parcelRequire("hRViu");

var $eF5Lx = parcelRequire("eF5Lx");

var $4rY0U = parcelRequire("4rY0U");

var $dIDCa = parcelRequire("dIDCa");

var $l079f = parcelRequire("l079f");

var $hXi3j = parcelRequire("hXi3j");

var $cSf8f = parcelRequire("cSf8f");

var $9Q5xE = parcelRequire("9Q5xE");

var $43jhg = parcelRequire("43jhg");

var $5c9Ym = parcelRequire("5c9Ym");

var $dAwef = parcelRequire("dAwef");

var $1TOtF = parcelRequire("1TOtF");

var $1aVVn = parcelRequire("1aVVn");

var $4n6CL = parcelRequire("4n6CL");
function $f212fefd9659d816$export$4fb4bdc93d5663a3({ label: label, buttons: buttons, isEmbedded: isEmbedded, property: property, obj: obj }) {
    var _a, _b;
    const [value] = (0, $1aVVn.useYState)(obj, property.name);
    const expand = !!((_a = property.tags) === null || _a === void 0 ? void 0 : _a.expand);
    const [show, setShow] = (0, $eeH7J.useState)(!label || expand);
    if (!value && show && !expand) setShow(false);
    const explicitlyUpdateable = (0, $eBaY3.useCanUpdateField)(property.name);
    const readonlyContext = (0, $eeH7J.useContext)((0, $eBaY3.ReadonlyContext));
    const isReadonly = (0, $eBaY3.useIsReadonlyField)(property);
    const unwrap = !!((_b = property.tags) === null || _b === void 0 ? void 0 : _b.unwrap);
    const objectView = (0, $4vwom.jsx)($f212fefd9659d816$export$c93bdb9e9400c13c, {
        mode: unwrap ? "root" : "card-no-header",
        property: property,
        obj: (0, $1aVVn.YTools).get(obj, property.name),
        replaceObj: (o)=>(0, $1aVVn.YTools).set(obj, property.name, o),
        buttons: []
    });
    if (unwrap) return objectView;
    return (0, $4vwom.jsxs)((0, $hRViu.PropRow), {
        isReadonly: isReadonly,
        label: label,
        buttons: buttons,
        isEmbedded: isEmbedded,
        description: property.description,
        descriptionAbove: true,
        badge: (0, $4vwom.jsxs)((0, $4vwom.Fragment), {
            children: [
                value && label && !expand && (0, $4vwom.jsx)((0, $fT6Pt.RButton), {
                    chevron: !show ? "chevron-down" : "chevron-up",
                    onClick: ()=>setShow(!show)
                }),
                !value && !isReadonly && (0, $4vwom.jsx)((0, $fT6Pt.RButton), {
                    variant: "secondary",
                    onClick: ()=>{
                        (0, $1aVVn.YTools).set(obj, property.name, (0, $1aVVn.YTools).valueToYValue((0, $5c9Ym.CreateDefault)(property.type, (0, $5c9Ym.UninitializedDefaults))));
                        setShow(true);
                    },
                    children: "Specify"
                })
            ]
        }),
        children: [
            !value && isReadonly && (0, $4vwom.jsx)((0, $hXi3j.None), {}),
            show && (0, $4vwom.jsx)((0, $eBaY3.ReadonlyContext).Provider, {
                value: {
                    mode: isReadonly ? "readonly" : readonlyContext.mode,
                    updateableSubtree: readonlyContext.updateableSubtree || explicitlyUpdateable
                },
                children: objectView
            })
        ]
    });
}
function $f212fefd9659d816$export$c93bdb9e9400c13c({ obj: obj, replaceObj: replaceObj, property: property, filter: filter, buttons: buttons, header: header, mode: mode, declarations: declarations }) {
    var _a;
    const { type: type } = property;
    const alias = (0, $43jhg.GetTypeAlias)(type);
    const props = (0, $43jhg.GetTypeProps)(type);
    const buttonsJsx = buttons.map((b)=>(0, $4vwom.jsx)((0, $fT6Pt.RButton), {
            style: {
                marginLeft: "1rem"
            },
            variant: b.variant,
            onClick: b.onClick,
            disabled: b.disabled,
            children: b.text
        }, b.text));
    const head = (0, $4vwom.jsxs)("div", {
        style: {
            flexDirection: "row",
            display: "flex",
            justifyContent: "center",
            alignItems: "center"
        },
        children: [
            (0, $4vwom.jsx)("div", {
                style: {
                    flex: 1
                },
                children: header || alias
            }),
            buttonsJsx
        ]
    });
    if (obj === undefined) {
        const a = (0, $8h5s0.prettyCamel)((0, $43jhg.TypeToString)(type), false);
        const b = (0, $8h5s0.prettyCamel)(property.name, false);
        return (0, $4vwom.jsx)((0, $fT6Pt.RButton), {
            variant: "secondary",
            onClick: ()=>{
                replaceObj((0, $5c9Ym.CreateDefault)(type, Object.assign(Object.assign({}, (0, $5c9Ym.DefaultDefaults)), {
                    array: undefined,
                    string: undefined,
                    number: undefined
                })));
            },
            children: a !== b ? `Specify ${a} for ${b}` : `Specify ${a}`
        });
    }
    const optionalize = typeof type === "string" ? false : !!((_a = property.tags) === null || _a === void 0 ? void 0 : _a.optionalize);
    let body = $f212fefd9659d816$export$4a37b7c8dd3f87fa(props, type, obj, optionalize, filter, mode !== "root" ? property.name : undefined, declarations);
    if (mode !== "root") body = (0, $4vwom.jsx)((0, $eBaY3.ObjectPathProvider), {
        obj: obj,
        type: type,
        name: property.name,
        children: body
    });
    if (mode === "root") return body;
    if (mode === "inline") return (0, $4vwom.jsxs)((0, $4vwom.Fragment), {
        children: [
            (0, $4vwom.jsxs)("div", {
                style: {
                    flexDirection: "row"
                },
                children: [
                    (0, $4vwom.jsx)((0, $jbbp2.default).Label, {
                        column: true,
                        sm: "2",
                        children: header
                    }),
                    (0, $4vwom.jsxs)("div", {
                        style: {
                            paddingTop: 7
                        },
                        children: [
                            property.description && (0, $4vwom.jsx)((0, $jbbp2.default).Text, {
                                className: "text-muted",
                                children: property.description.en
                            }),
                            (0, $4vwom.jsx)((0, $9HOw2.DiagnosticView), {
                                property: property,
                                value: obj
                            })
                        ]
                    })
                ]
            }),
            (0, $4vwom.jsxs)((0, $42fiX.default), {
                style: {
                    paddingLeft: "1rem",
                    paddingRight: "1rem"
                },
                children: [
                    (0, $4vwom.jsx)((0, $caNEj.default), {
                        children: body
                    }),
                    (0, $4vwom.jsx)((0, $caNEj.default), {
                        md: "auto",
                        children: buttonsJsx
                    })
                ]
            })
        ]
    });
    else if (mode === "card-no-header") return (0, $4vwom.jsxs)("div", {
        style: {
            display: "flex",
            flex: 1,
            paddingLeft: "1rem",
            paddingRight: "1rem",
            borderRadius: 8,
            flexDirection: "column",
            borderWidth: 1,
            borderStyle: "solid",
            borderColor: (0, $l079f.UntitledUI).colorStyles.gray[200],
            paddingBottom: "1rem"
        },
        children: [
            (0, $4vwom.jsx)((0, $9HOw2.DiagnosticView), {
                property: property,
                value: obj
            }),
            body
        ]
    });
    else return (0, $4vwom.jsxs)("div", {
        className: "card",
        children: [
            (0, $4vwom.jsxs)("div", {
                className: "card-header",
                children: [
                    head,
                    (0, $4vwom.jsx)((0, $9HOw2.DiagnosticView), {
                        property: property,
                        value: obj
                    })
                ]
            }),
            (0, $4vwom.jsx)("div", {
                className: "card-body",
                style: {
                    paddingLeft: 20,
                    marginRight: 20,
                    width: "100%"
                },
                children: body
            })
        ]
    });
}
function $f212fefd9659d816$export$4a37b7c8dd3f87fa(props, type, obj, optionalize, filter, leafName, /**
 * If provided, data binding features will be enabled for this object. The provided
 * declarations will be available to the data binding script expressions.
 */ declarations) {
    const { error: error } = (0, $eeH7J.useContext)((0, $eF5Lx.ErrorContext));
    const diagnostic = (0, $9HOw2.useDiagnostic)(type, obj);
    const path = (0, $eBaY3.useObjectPath)();
    if (leafName !== undefined) path.push(leafName);
    const showAllProps = (0, $1TOtF.useShowAllProps)();
    // Look up the extra fields defined for this path
    let typeExtensionsTree = (0, $1TOtF.useDocumentTypeExtensions)();
    for (const p of path)typeExtensionsTree = (typeExtensionsTree === null || typeExtensionsTree === void 0 ? void 0 : typeExtensionsTree.subtree) ? typeExtensionsTree.subtree[p] : undefined;
    const typeExtensions = typeExtensionsTree === null || typeExtensionsTree === void 0 ? void 0 : typeExtensionsTree.extensions;
    const docWidgets = (0, $1TOtF.useDocumentWidgets)();
    // The widget representation for props that have it. If the same widget is found multiple times,
    // we should only render it once, hence using a Set
    const widgets = new Set();
    const propViews = props.filter((p)=>{
        var _a;
        // Hide the property if its @toggle is falsy
        const toggle = (_a = p.tags) === null || _a === void 0 ? void 0 : _a.toggle;
        if (toggle && !obj[toggle]) return false;
        return true;
    }).filter((p)=>!filter || filter(p)).map((p)=>{
        var _a, _b, _c, _d, _e;
        const widget = (_a = p.tags) === null || _a === void 0 ? void 0 : _a.widget;
        if (widget) widgets.add(widget);
        if ((0, $43jhg.IsStringLiteral)(p.type) && !p.optional) // This is a constant value that cannot be changed, i.e. a type brand
        // This should not be presented in the UI
        return (0, $4vwom.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).Fragment, {}, p.name);
        if (!showAllProps && $f212fefd9659d816$export$eac3f86094ba297f(p)) return (0, $4vwom.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).Fragment, {}, p.name);
        const section = (_b = p.tags) === null || _b === void 0 ? void 0 : _b.section;
        const trans = Object.assign({
            en: (0, $8h5s0.prettyCamel)(p.name)
        }, (_c = p.tags) === null || _c === void 0 ? void 0 : _c.translation);
        const label = trans ? (0, $cSf8f.ClientSideLocalize)(trans) : ((_d = p.tags) === null || _d === void 0 ? void 0 : _d.label) || (0, $8h5s0.prettyCamel)(p.name);
        if (optionalize) p = Object.assign(Object.assign({}, p), {
            optional: true
        });
        return (0, $4vwom.jsx)((0, $eF5Lx.ErrorContext).Provider, {
            value: {
                error: error || !!((_e = diagnostic === null || diagnostic === void 0 ? void 0 : diagnostic.fields) === null || _e === void 0 ? void 0 : _e.some((x)=>x === p.name))
            },
            children: (0, $4vwom.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).Fragment, {
                children: [
                    section && (0, $4vwom.jsx)("div", {
                        className: "reactor-form-section-header",
                        style: {
                            marginTop: 64
                        },
                        children: section
                    }, section),
                    (0, $4vwom.jsx)((0, $6cx8r.PropView), {
                        mode: "inline",
                        obj: obj,
                        property: p,
                        label: label,
                        buttons: []
                    }, p.name)
                ]
            })
        }, p.name);
    });
    const extensionSections = (0, $4vwom.jsxs)("div", {
        children: [
            (0, $4vwom.jsx)("div", {
                style: {
                    height: 16
                }
            }),
            typeExtensions === null || typeExtensions === void 0 ? void 0 : typeExtensions.map((extension)=>{
                var _a;
                const extraProps = (_a = extension.fields) === null || _a === void 0 ? void 0 : _a.filter((ef)=>!props.some((p)=>p.name === ef.name)).map((ef)=>({
                        name: ef.name,
                        label: ef.label,
                        type: (0, $dIDCa.SchemaToType)(ef.schema),
                        description: {
                            en: ef.description
                        },
                        optional: !ef.required,
                        tags: ef.tags
                    }));
                const extendedFields = filter ? extraProps === null || extraProps === void 0 ? void 0 : extraProps.filter(filter) : extraProps;
                if (extendedFields && extendedFields.length) {
                    const color = extension.color === undefined ? (0, $l079f.UntitledUI).randomSecondaryColor(extension.title || "") : extension.color !== "none" ? (0, $9Q5xE.ColorStyles)[extension.color] : "none";
                    return (0, $4vwom.jsxs)("div", {
                        style: {
                            borderColor: color === "none" ? undefined : color[200],
                            borderWidth: 1,
                            borderStyle: "solid",
                            marginTop: 16,
                            paddingBottom: 16,
                            borderRadius: 8
                        },
                        children: [
                            extension.title && (0, $4vwom.jsx)("div", {
                                style: {
                                    fontSize: 12,
                                    padding: 16,
                                    color: color === "none" ? undefined : color[500],
                                    backgroundColor: color === "none" ? undefined : color[25],
                                    borderTopLeftRadius: 8,
                                    borderTopRightRadius: 8
                                },
                                children: extension.title
                            }),
                            (0, $4vwom.jsx)("div", {
                                style: {
                                    paddingLeft: 16,
                                    paddingRight: 16
                                },
                                children: extendedFields.map((ef)=>{
                                    var _a;
                                    return (0, $4vwom.jsx)((0, $6cx8r.PropView), {
                                        obj: obj,
                                        mode: "inline",
                                        label: (_a = ef.label) !== null && _a !== void 0 ? _a : (0, $8h5s0.prettyCamel)(ef.name),
                                        buttons: [],
                                        property: ef
                                    });
                                })
                            })
                        ]
                    });
                }
            })
        ]
    });
    return (0, $4vwom.jsxs)((0, $4vwom.Fragment), {
        children: [
            declarations !== undefined ? (0, $4vwom.jsx)((0, $4n6CL.TypeScriptView), {
                obj: obj,
                label: "Display condition",
                declarations: declarations,
                property: {
                    name: "$Condition",
                    optional: true,
                    type: {
                        alias: "TypeScript",
                        opaque: "TypeScript",
                        string: null
                    },
                    description: {
                        en: "A TypeScript expression that determines whether this object should be included in the final output"
                    }
                }
            }) : undefined,
            Array.from(widgets.values()).map((w)=>{
                let n = docWidgets;
                for (const p of path)n = n ? n[p] : undefined;
                n = n ? n[w] : undefined;
                return (0, $4vwom.jsx)((0, $4rY0U.WidgetView), {
                    value: n
                }, w);
            }),
            propViews,
            extensionSections
        ]
    });
}
function $f212fefd9659d816$export$eac3f86094ba297f(p) {
    var _a, _b;
    return !!((_a = p.tags) === null || _a === void 0 ? void 0 : _a.hide) || (0, $43jhg.IsArrayType)(p.type) && ((_b = p.tags) === null || _b === void 0 ? void 0 : _b.subtree) || (0, $dAwef.IsUuidType)(p.type) && p.isReadonly && !(typeof p.type === "object" && p.type.reference);
}
function $f212fefd9659d816$export$f78bad51ce700d4e(type) {
    let containsShouldHide = false;
    (0, $43jhg.VisitType)(type, (t)=>{
        if ((0, $43jhg.IsObjectType)(t)) {
            if (t.props.some($f212fefd9659d816$export$eac3f86094ba297f)) containsShouldHide = true;
        }
    });
    return containsShouldHide;
}

});
parcelRegister("caNEj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8dccee84e3996483$export$2e2bcd8739ae039; });

var $h4XE0 = parcelRequire("h4XE0");

var $fbOaB = parcelRequire("fbOaB");

var $aienp = parcelRequire("aienp");

var $eeH7J = parcelRequire("eeH7J");

var $57SUk = parcelRequire("57SUk");
var $8dccee84e3996483$var$_excluded = [
    "bsPrefix",
    "className",
    "as"
];
var $8dccee84e3996483$var$DEVICE_SIZES = [
    "xl",
    "lg",
    "md",
    "sm",
    "xs"
];
var $8dccee84e3996483$var$Col = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).forwardRef(function(_ref, ref) {
    var bsPrefix = _ref.bsPrefix, className = _ref.className, _ref$as = _ref.as, Component = _ref$as === void 0 ? "div" : _ref$as, props = (0, $fbOaB.default)(_ref, $8dccee84e3996483$var$_excluded);
    var prefix = (0, $57SUk.useBootstrapPrefix)(bsPrefix, "col");
    var spans = [];
    var classes = [];
    $8dccee84e3996483$var$DEVICE_SIZES.forEach(function(brkPoint) {
        var propValue = props[brkPoint];
        delete props[brkPoint];
        var span;
        var offset;
        var order;
        if (typeof propValue === "object" && propValue != null) {
            var _propValue$span = propValue.span;
            span = _propValue$span === void 0 ? true : _propValue$span;
            offset = propValue.offset;
            order = propValue.order;
        } else span = propValue;
        var infix = brkPoint !== "xs" ? "-" + brkPoint : "";
        if (span) spans.push(span === true ? "" + prefix + infix : "" + prefix + infix + "-" + span);
        if (order != null) classes.push("order" + infix + "-" + order);
        if (offset != null) classes.push("offset" + infix + "-" + offset);
    });
    if (!spans.length) spans.push(prefix); // plain 'col'
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement(Component, (0, $h4XE0.default)({}, props, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($aienp))).apply(void 0, [
            className
        ].concat(spans, classes))
    }));
});
$8dccee84e3996483$var$Col.displayName = "Col";
var $8dccee84e3996483$export$2e2bcd8739ae039 = $8dccee84e3996483$var$Col;

});

parcelRegister("jbbp2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $df67e3c08011012a$export$2e2bcd8739ae039; });

var $h4XE0 = parcelRequire("h4XE0");

var $fbOaB = parcelRequire("fbOaB");

var $aienp = parcelRequire("aienp");

var $eeH7J = parcelRequire("eeH7J");

var $7iQoI = parcelRequire("7iQoI");

var $SMrUq = parcelRequire("SMrUq");

var $50CRy = parcelRequire("50CRy");

var $9OLGE = parcelRequire("9OLGE");

var $4S2dd = parcelRequire("4S2dd");

var $aA5Bz = parcelRequire("aA5Bz");

var $86Qhc = parcelRequire("86Qhc");

var $57SUk = parcelRequire("57SUk");

var $b3Riz = parcelRequire("b3Riz");
var $df67e3c08011012a$var$_excluded = [
    "bsPrefix",
    "inline",
    "className",
    "validated",
    "as"
];
var $df67e3c08011012a$var$FormRow = (0, $b3Riz.default)("form-row");
var $df67e3c08011012a$var$defaultProps = {
    inline: false
};
var $df67e3c08011012a$var$FormImpl = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).forwardRef(function(_ref, ref) {
    var bsPrefix = _ref.bsPrefix, inline = _ref.inline, className = _ref.className, validated = _ref.validated, _ref$as = _ref.as, Component = _ref$as === void 0 ? "form" : _ref$as, props = (0, $fbOaB.default)(_ref, $df67e3c08011012a$var$_excluded);
    bsPrefix = (0, $57SUk.useBootstrapPrefix)(bsPrefix, "form");
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement(Component, (0, $h4XE0.default)({}, props, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($aienp)))(className, validated && "was-validated", inline && bsPrefix + "-inline")
    }));
});
$df67e3c08011012a$var$FormImpl.displayName = "Form";
$df67e3c08011012a$var$FormImpl.defaultProps = $df67e3c08011012a$var$defaultProps;
$df67e3c08011012a$var$FormImpl.Row = $df67e3c08011012a$var$FormRow;
$df67e3c08011012a$var$FormImpl.Group = (0, $9OLGE.default);
$df67e3c08011012a$var$FormImpl.Control = (0, $50CRy.default);
$df67e3c08011012a$var$FormImpl.Check = (0, $7iQoI.default);
$df67e3c08011012a$var$FormImpl.File = (0, $SMrUq.default);
$df67e3c08011012a$var$FormImpl.Switch = (0, $86Qhc.default);
$df67e3c08011012a$var$FormImpl.Label = (0, $4S2dd.default);
$df67e3c08011012a$var$FormImpl.Text = (0, $aA5Bz.default);
var $df67e3c08011012a$export$2e2bcd8739ae039 = $df67e3c08011012a$var$FormImpl;

});
parcelRegister("7iQoI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5512dbec362bdd38$export$2e2bcd8739ae039; });

var $h4XE0 = parcelRequire("h4XE0");

var $fbOaB = parcelRequire("fbOaB");

var $aienp = parcelRequire("aienp");
parcelRequire("hob7e");

var $eeH7J = parcelRequire("eeH7J");

var $kKNeT = parcelRequire("kKNeT");

var $7XDHp = parcelRequire("7XDHp");

var $eEZDr = parcelRequire("eEZDr");

var $ehjce = parcelRequire("ehjce");

var $57SUk = parcelRequire("57SUk");
var $5512dbec362bdd38$var$_excluded = [
    "id",
    "bsPrefix",
    "bsCustomPrefix",
    "inline",
    "disabled",
    "isValid",
    "isInvalid",
    "feedbackTooltip",
    "feedback",
    "className",
    "style",
    "title",
    "type",
    "label",
    "children",
    "custom",
    "as"
];
var $5512dbec362bdd38$var$FormCheck = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).forwardRef(function(_ref, ref) {
    var id = _ref.id, bsPrefix = _ref.bsPrefix, bsCustomPrefix = _ref.bsCustomPrefix, _ref$inline = _ref.inline, inline = _ref$inline === void 0 ? false : _ref$inline, _ref$disabled = _ref.disabled, disabled = _ref$disabled === void 0 ? false : _ref$disabled, _ref$isValid = _ref.isValid, isValid = _ref$isValid === void 0 ? false : _ref$isValid, _ref$isInvalid = _ref.isInvalid, isInvalid = _ref$isInvalid === void 0 ? false : _ref$isInvalid, _ref$feedbackTooltip = _ref.feedbackTooltip, feedbackTooltip = _ref$feedbackTooltip === void 0 ? false : _ref$feedbackTooltip, feedback = _ref.feedback, className = _ref.className, style = _ref.style, _ref$title = _ref.title, title = _ref$title === void 0 ? "" : _ref$title, _ref$type = _ref.type, type = _ref$type === void 0 ? "checkbox" : _ref$type, label = _ref.label, children = _ref.children, propCustom = _ref.custom, _ref$as = _ref.as, as = _ref$as === void 0 ? "input" : _ref$as, props = (0, $fbOaB.default)(_ref, $5512dbec362bdd38$var$_excluded);
    var custom = type === "switch" ? true : propCustom;
    var _ref2 = custom ? [
        bsCustomPrefix,
        "custom-control"
    ] : [
        bsPrefix,
        "form-check"
    ], prefix = _ref2[0], defaultPrefix = _ref2[1];
    bsPrefix = (0, $57SUk.useBootstrapPrefix)(prefix, defaultPrefix);
    var _useContext = (0, $eeH7J.useContext)((0, $ehjce.default)), controlId = _useContext.controlId;
    var innerFormContext = (0, $eeH7J.useMemo)(function() {
        return {
            controlId: id || controlId,
            custom: custom
        };
    }, [
        controlId,
        custom,
        id
    ]);
    var hasLabel = custom || label != null && label !== false && !children;
    var input = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $7XDHp.default), (0, $h4XE0.default)({}, props, {
        type: type === "switch" ? "checkbox" : type,
        ref: ref,
        isValid: isValid,
        isInvalid: isInvalid,
        isStatic: !hasLabel,
        disabled: disabled,
        as: as
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $ehjce.default).Provider, {
        value: innerFormContext
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        style: style,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($aienp)))(className, bsPrefix, custom && "custom-" + type, inline && bsPrefix + "-inline")
    }, children || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).Fragment, null, input, hasLabel && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $eEZDr.default), {
        title: title
    }, label), (isValid || isInvalid) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $kKNeT.default), {
        type: isValid ? "valid" : "invalid",
        tooltip: feedbackTooltip
    }, feedback))));
});
$5512dbec362bdd38$var$FormCheck.displayName = "FormCheck";
$5512dbec362bdd38$var$FormCheck.Input = (0, $7XDHp.default);
$5512dbec362bdd38$var$FormCheck.Label = (0, $eEZDr.default);
var $5512dbec362bdd38$export$2e2bcd8739ae039 = $5512dbec362bdd38$var$FormCheck;

});
parcelRegister("hob7e", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ca8d4ce0ca211e6f$var$all;

var $fYBj0 = parcelRequire("fYBj0");
var $ca8d4ce0ca211e6f$var$_createChainableTypeChecker2 = $ca8d4ce0ca211e6f$var$_interopRequireDefault($fYBj0);
function $ca8d4ce0ca211e6f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $ca8d4ce0ca211e6f$var$all() {
    for(var _len = arguments.length, validators = Array(_len), _key = 0; _key < _len; _key++)validators[_key] = arguments[_key];
    function allPropTypes() {
        for(var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        var error = null;
        validators.forEach(function(validator) {
            if (error != null) return;
            var result = validator.apply(undefined, args);
            if (result != null) error = result;
        });
        return error;
    }
    return (0, $ca8d4ce0ca211e6f$var$_createChainableTypeChecker2.default)(allPropTypes);
}
module.exports = module.exports["default"];

});
parcelRegister("fYBj0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ba1965b385196d4b$var$createChainableTypeChecker;
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */ // Mostly taken from ReactPropTypes.
function $ba1965b385196d4b$var$createChainableTypeChecker(validate) {
    function checkType(isRequired, props, propName, componentName, location, propFullName) {
        var componentNameSafe = componentName || "<<anonymous>>";
        var propFullNameSafe = propFullName || propName;
        if (props[propName] == null) {
            if (isRequired) return new Error("Required " + location + " `" + propFullNameSafe + "` was not specified " + ("in `" + componentNameSafe + "`."));
            return null;
        }
        for(var _len = arguments.length, args = Array(_len > 6 ? _len - 6 : 0), _key = 6; _key < _len; _key++)args[_key - 6] = arguments[_key];
        return validate.apply(undefined, [
            props,
            propName,
            componentNameSafe,
            location,
            propFullNameSafe
        ].concat(args));
    }
    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);
    return chainedCheckType;
}
module.exports = module.exports["default"];

});


parcelRegister("kKNeT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f1be4c63a4530049$export$2e2bcd8739ae039; });

var $h4XE0 = parcelRequire("h4XE0");

var $fbOaB = parcelRequire("fbOaB");

var $aienp = parcelRequire("aienp");

var $eeH7J = parcelRequire("eeH7J");

var $4yBem = parcelRequire("4yBem");
var $f1be4c63a4530049$var$_excluded = [
    "as",
    "className",
    "type",
    "tooltip"
];
var $f1be4c63a4530049$var$propTypes = {
    /**
   * Specify whether the feedback is for valid or invalid fields
   *
   * @type {('valid'|'invalid')}
   */ type: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string,
    /** Display feedback as a tooltip. */ tooltip: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    as: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).elementType
};
var $f1be4c63a4530049$var$Feedback = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).forwardRef(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? "div" : _ref$as, className = _ref.className, _ref$type = _ref.type, type = _ref$type === void 0 ? "valid" : _ref$type, _ref$tooltip = _ref.tooltip, tooltip = _ref$tooltip === void 0 ? false : _ref$tooltip, props = (0, $fbOaB.default)(_ref, $f1be4c63a4530049$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement(Component, (0, $h4XE0.default)({}, props, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($aienp)))(className, type + "-" + (tooltip ? "tooltip" : "feedback"))
    }));
});
$f1be4c63a4530049$var$Feedback.displayName = "Feedback";
$f1be4c63a4530049$var$Feedback.propTypes = $f1be4c63a4530049$var$propTypes;
var $f1be4c63a4530049$export$2e2bcd8739ae039 = $f1be4c63a4530049$var$Feedback;

});

parcelRegister("7XDHp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5cbcd686f5f6fdd7$export$2e2bcd8739ae039; });

var $h4XE0 = parcelRequire("h4XE0");

var $fbOaB = parcelRequire("fbOaB");

var $aienp = parcelRequire("aienp");

var $eeH7J = parcelRequire("eeH7J");

var $ehjce = parcelRequire("ehjce");

var $57SUk = parcelRequire("57SUk");
var $5cbcd686f5f6fdd7$var$_excluded = [
    "id",
    "bsPrefix",
    "bsCustomPrefix",
    "className",
    "type",
    "isValid",
    "isInvalid",
    "isStatic",
    "as"
];
var $5cbcd686f5f6fdd7$var$FormCheckInput = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).forwardRef(function(_ref, ref) {
    var id = _ref.id, bsPrefix = _ref.bsPrefix, bsCustomPrefix = _ref.bsCustomPrefix, className = _ref.className, _ref$type = _ref.type, type = _ref$type === void 0 ? "checkbox" : _ref$type, _ref$isValid = _ref.isValid, isValid = _ref$isValid === void 0 ? false : _ref$isValid, _ref$isInvalid = _ref.isInvalid, isInvalid = _ref$isInvalid === void 0 ? false : _ref$isInvalid, isStatic = _ref.isStatic, _ref$as = _ref.as, Component = _ref$as === void 0 ? "input" : _ref$as, props = (0, $fbOaB.default)(_ref, $5cbcd686f5f6fdd7$var$_excluded);
    var _useContext = (0, $eeH7J.useContext)((0, $ehjce.default)), controlId = _useContext.controlId, custom = _useContext.custom;
    var _ref2 = custom ? [
        bsCustomPrefix,
        "custom-control-input"
    ] : [
        bsPrefix,
        "form-check-input"
    ], prefix = _ref2[0], defaultPrefix = _ref2[1];
    bsPrefix = (0, $57SUk.useBootstrapPrefix)(prefix, defaultPrefix);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement(Component, (0, $h4XE0.default)({}, props, {
        ref: ref,
        type: type,
        id: id || controlId,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($aienp)))(className, bsPrefix, isValid && "is-valid", isInvalid && "is-invalid", isStatic && "position-static")
    }));
});
$5cbcd686f5f6fdd7$var$FormCheckInput.displayName = "FormCheckInput";
var $5cbcd686f5f6fdd7$export$2e2bcd8739ae039 = $5cbcd686f5f6fdd7$var$FormCheckInput;

});
parcelRegister("ehjce", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a6518b30ae20d53e$export$2e2bcd8739ae039; });

var $eeH7J = parcelRequire("eeH7J");
var $a6518b30ae20d53e$var$FormContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createContext({
    controlId: undefined
});
var $a6518b30ae20d53e$export$2e2bcd8739ae039 = $a6518b30ae20d53e$var$FormContext;

});


parcelRegister("eEZDr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $aac49c983b3ed3fd$export$2e2bcd8739ae039; });

var $h4XE0 = parcelRequire("h4XE0");

var $fbOaB = parcelRequire("fbOaB");

var $aienp = parcelRequire("aienp");

var $eeH7J = parcelRequire("eeH7J");

var $ehjce = parcelRequire("ehjce");

var $57SUk = parcelRequire("57SUk");
var $aac49c983b3ed3fd$var$_excluded = [
    "bsPrefix",
    "bsCustomPrefix",
    "className",
    "htmlFor"
];
var $aac49c983b3ed3fd$var$FormCheckLabel = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).forwardRef(function(_ref, ref) {
    var bsPrefix = _ref.bsPrefix, bsCustomPrefix = _ref.bsCustomPrefix, className = _ref.className, htmlFor = _ref.htmlFor, props = (0, $fbOaB.default)(_ref, $aac49c983b3ed3fd$var$_excluded);
    var _useContext = (0, $eeH7J.useContext)((0, $ehjce.default)), controlId = _useContext.controlId, custom = _useContext.custom;
    var _ref2 = custom ? [
        bsCustomPrefix,
        "custom-control-label"
    ] : [
        bsPrefix,
        "form-check-label"
    ], prefix = _ref2[0], defaultPrefix = _ref2[1];
    bsPrefix = (0, $57SUk.useBootstrapPrefix)(prefix, defaultPrefix);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("label", (0, $h4XE0.default)({}, props, {
        ref: ref,
        htmlFor: htmlFor || controlId,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($aienp)))(className, bsPrefix)
    }));
});
$aac49c983b3ed3fd$var$FormCheckLabel.displayName = "FormCheckLabel";
var $aac49c983b3ed3fd$export$2e2bcd8739ae039 = $aac49c983b3ed3fd$var$FormCheckLabel;

});


parcelRegister("SMrUq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0a4aa0406febc1cf$export$2e2bcd8739ae039; });

var $h4XE0 = parcelRequire("h4XE0");

var $fbOaB = parcelRequire("fbOaB");

var $aienp = parcelRequire("aienp");

var $eeH7J = parcelRequire("eeH7J");
parcelRequire("hob7e");

var $kKNeT = parcelRequire("kKNeT");

var $826WN = parcelRequire("826WN");

var $ydKef = parcelRequire("ydKef");

var $ehjce = parcelRequire("ehjce");

var $57SUk = parcelRequire("57SUk");
var $0a4aa0406febc1cf$var$_excluded = [
    "id",
    "bsPrefix",
    "bsCustomPrefix",
    "disabled",
    "isValid",
    "isInvalid",
    "feedbackTooltip",
    "feedback",
    "className",
    "style",
    "label",
    "children",
    "custom",
    "lang",
    "data-browse",
    "as",
    "inputAs"
];
var $0a4aa0406febc1cf$var$FormFile = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).forwardRef(function(_ref, ref) {
    var id = _ref.id, bsPrefix = _ref.bsPrefix, bsCustomPrefix = _ref.bsCustomPrefix, _ref$disabled = _ref.disabled, disabled = _ref$disabled === void 0 ? false : _ref$disabled, _ref$isValid = _ref.isValid, isValid = _ref$isValid === void 0 ? false : _ref$isValid, _ref$isInvalid = _ref.isInvalid, isInvalid = _ref$isInvalid === void 0 ? false : _ref$isInvalid, _ref$feedbackTooltip = _ref.feedbackTooltip, feedbackTooltip = _ref$feedbackTooltip === void 0 ? false : _ref$feedbackTooltip, feedback = _ref.feedback, className = _ref.className, style = _ref.style, label = _ref.label, children = _ref.children, custom = _ref.custom, lang = _ref.lang, dataBrowse = _ref["data-browse"], _ref$as = _ref.as, Component = _ref$as === void 0 ? "div" : _ref$as, _ref$inputAs = _ref.inputAs, inputAs = _ref$inputAs === void 0 ? "input" : _ref$inputAs, props = (0, $fbOaB.default)(_ref, $0a4aa0406febc1cf$var$_excluded);
    var _ref2 = custom ? [
        bsCustomPrefix,
        "custom"
    ] : [
        bsPrefix,
        "form-file"
    ], prefix = _ref2[0], defaultPrefix = _ref2[1];
    bsPrefix = (0, $57SUk.useBootstrapPrefix)(prefix, defaultPrefix);
    var type = "file";
    var _useContext = (0, $eeH7J.useContext)((0, $ehjce.default)), controlId = _useContext.controlId;
    var innerFormContext = (0, $eeH7J.useMemo)(function() {
        return {
            controlId: id || controlId,
            custom: custom
        };
    }, [
        controlId,
        custom,
        id
    ]);
    var hasLabel = label != null && label !== false && !children;
    var input = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $826WN.default), (0, $h4XE0.default)({}, props, {
        ref: ref,
        isValid: isValid,
        isInvalid: isInvalid,
        disabled: disabled,
        as: inputAs,
        lang: lang
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $ehjce.default).Provider, {
        value: innerFormContext
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement(Component, {
        style: style,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($aienp)))(className, bsPrefix, custom && "custom-" + type)
    }, children || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).Fragment, null, custom ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).Fragment, null, input, hasLabel && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $ydKef.default), {
        "data-browse": dataBrowse
    }, label)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).Fragment, null, hasLabel && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $ydKef.default), null, label), input), (isValid || isInvalid) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $kKNeT.default), {
        type: isValid ? "valid" : "invalid",
        tooltip: feedbackTooltip
    }, feedback))));
});
$0a4aa0406febc1cf$var$FormFile.displayName = "FormFile";
$0a4aa0406febc1cf$var$FormFile.Input = (0, $826WN.default);
$0a4aa0406febc1cf$var$FormFile.Label = (0, $ydKef.default);
var $0a4aa0406febc1cf$export$2e2bcd8739ae039 = $0a4aa0406febc1cf$var$FormFile;

});
parcelRegister("826WN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5d93e640d6bce244$export$2e2bcd8739ae039; });

var $h4XE0 = parcelRequire("h4XE0");

var $fbOaB = parcelRequire("fbOaB");

var $aienp = parcelRequire("aienp");

var $eeH7J = parcelRequire("eeH7J");

var $ehjce = parcelRequire("ehjce");

var $57SUk = parcelRequire("57SUk");
var $5d93e640d6bce244$var$_excluded = [
    "id",
    "bsPrefix",
    "bsCustomPrefix",
    "className",
    "isValid",
    "isInvalid",
    "lang",
    "as"
];
var $5d93e640d6bce244$var$FormFileInput = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).forwardRef(function(_ref, ref) {
    var id = _ref.id, bsPrefix = _ref.bsPrefix, bsCustomPrefix = _ref.bsCustomPrefix, className = _ref.className, isValid = _ref.isValid, isInvalid = _ref.isInvalid, lang = _ref.lang, _ref$as = _ref.as, Component = _ref$as === void 0 ? "input" : _ref$as, props = (0, $fbOaB.default)(_ref, $5d93e640d6bce244$var$_excluded);
    var _useContext = (0, $eeH7J.useContext)((0, $ehjce.default)), controlId = _useContext.controlId, custom = _useContext.custom;
    var type = "file";
    var _ref2 = custom ? [
        bsCustomPrefix,
        "custom-file-input"
    ] : [
        bsPrefix,
        "form-control-file"
    ], prefix = _ref2[0], defaultPrefix = _ref2[1];
    bsPrefix = (0, $57SUk.useBootstrapPrefix)(prefix, defaultPrefix);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement(Component, (0, $h4XE0.default)({}, props, {
        ref: ref,
        id: id || controlId,
        type: type,
        lang: lang,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($aienp)))(className, bsPrefix, isValid && "is-valid", isInvalid && "is-invalid")
    }));
});
$5d93e640d6bce244$var$FormFileInput.displayName = "FormFileInput";
var $5d93e640d6bce244$export$2e2bcd8739ae039 = $5d93e640d6bce244$var$FormFileInput;

});

parcelRegister("ydKef", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $066dd67c93109a26$export$2e2bcd8739ae039; });

var $h4XE0 = parcelRequire("h4XE0");

var $fbOaB = parcelRequire("fbOaB");

var $aienp = parcelRequire("aienp");

var $eeH7J = parcelRequire("eeH7J");

var $ehjce = parcelRequire("ehjce");

var $57SUk = parcelRequire("57SUk");
var $066dd67c93109a26$var$_excluded = [
    "bsPrefix",
    "bsCustomPrefix",
    "className",
    "htmlFor"
];
var $066dd67c93109a26$var$FormFileLabel = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).forwardRef(function(_ref, ref) {
    var bsPrefix = _ref.bsPrefix, bsCustomPrefix = _ref.bsCustomPrefix, className = _ref.className, htmlFor = _ref.htmlFor, props = (0, $fbOaB.default)(_ref, $066dd67c93109a26$var$_excluded);
    var _useContext = (0, $eeH7J.useContext)((0, $ehjce.default)), controlId = _useContext.controlId, custom = _useContext.custom;
    var _ref2 = custom ? [
        bsCustomPrefix,
        "custom-file-label"
    ] : [
        bsPrefix,
        "form-file-label"
    ], prefix = _ref2[0], defaultPrefix = _ref2[1];
    bsPrefix = (0, $57SUk.useBootstrapPrefix)(prefix, defaultPrefix);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("label", (0, $h4XE0.default)({}, props, {
        ref: ref,
        htmlFor: htmlFor || controlId,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($aienp)))(className, bsPrefix),
        "data-browse": props["data-browse"]
    }));
});
$066dd67c93109a26$var$FormFileLabel.displayName = "FormFileLabel";
var $066dd67c93109a26$export$2e2bcd8739ae039 = $066dd67c93109a26$var$FormFileLabel;

});


parcelRegister("50CRy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3a5b192923a0498b$export$2e2bcd8739ae039; });

var $h4XE0 = parcelRequire("h4XE0");

var $fbOaB = parcelRequire("fbOaB");

var $aienp = parcelRequire("aienp");
parcelRequire("hob7e");

var $eeH7J = parcelRequire("eeH7J");
parcelRequire("bVrkV");

var $kKNeT = parcelRequire("kKNeT");

var $ehjce = parcelRequire("ehjce");

var $57SUk = parcelRequire("57SUk");
var $3a5b192923a0498b$var$_excluded = [
    "bsPrefix",
    "bsCustomPrefix",
    "type",
    "size",
    "htmlSize",
    "id",
    "className",
    "isValid",
    "isInvalid",
    "plaintext",
    "readOnly",
    "custom",
    "as"
];
var $3a5b192923a0498b$var$FormControl = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).forwardRef(function(_ref, ref) {
    var bsPrefix = _ref.bsPrefix, bsCustomPrefix = _ref.bsCustomPrefix, type = _ref.type, size = _ref.size, htmlSize = _ref.htmlSize, id = _ref.id, className = _ref.className, _ref$isValid = _ref.isValid, isValid = _ref$isValid === void 0 ? false : _ref$isValid, _ref$isInvalid = _ref.isInvalid, isInvalid = _ref$isInvalid === void 0 ? false : _ref$isInvalid, plaintext = _ref.plaintext, readOnly = _ref.readOnly, custom = _ref.custom, _ref$as = _ref.as, Component = _ref$as === void 0 ? "input" : _ref$as, props = (0, $fbOaB.default)(_ref, $3a5b192923a0498b$var$_excluded);
    var _useContext = (0, $eeH7J.useContext)((0, $ehjce.default)), controlId = _useContext.controlId;
    var _ref2 = custom ? [
        bsCustomPrefix,
        "custom"
    ] : [
        bsPrefix,
        "form-control"
    ], prefix = _ref2[0], defaultPrefix = _ref2[1];
    bsPrefix = (0, $57SUk.useBootstrapPrefix)(prefix, defaultPrefix);
    var classes;
    if (plaintext) {
        var _classes;
        classes = (_classes = {}, _classes[bsPrefix + "-plaintext"] = true, _classes);
    } else if (type === "file") {
        var _classes2;
        classes = (_classes2 = {}, _classes2[bsPrefix + "-file"] = true, _classes2);
    } else if (type === "range") {
        var _classes3;
        classes = (_classes3 = {}, _classes3[bsPrefix + "-range"] = true, _classes3);
    } else if (Component === "select" && custom) {
        var _classes4;
        classes = (_classes4 = {}, _classes4[bsPrefix + "-select"] = true, _classes4[bsPrefix + "-select-" + size] = size, _classes4);
    } else {
        var _classes5;
        classes = (_classes5 = {}, _classes5[bsPrefix] = true, _classes5[bsPrefix + "-" + size] = size, _classes5);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement(Component, (0, $h4XE0.default)({}, props, {
        type: type,
        size: htmlSize,
        ref: ref,
        readOnly: readOnly,
        id: id || controlId,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($aienp)))(className, classes, isValid && "is-valid", isInvalid && "is-invalid")
    }));
});
$3a5b192923a0498b$var$FormControl.displayName = "FormControl";
var $3a5b192923a0498b$export$2e2bcd8739ae039 = Object.assign($3a5b192923a0498b$var$FormControl, {
    Feedback: (0, $kKNeT.default)
});

});

parcelRegister("9OLGE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $725dc63862a62308$export$2e2bcd8739ae039; });

var $h4XE0 = parcelRequire("h4XE0");

var $fbOaB = parcelRequire("fbOaB");

var $aienp = parcelRequire("aienp");

var $eeH7J = parcelRequire("eeH7J");

var $ehjce = parcelRequire("ehjce");

var $57SUk = parcelRequire("57SUk");
var $725dc63862a62308$var$_excluded = [
    "bsPrefix",
    "className",
    "children",
    "controlId",
    "as"
];
var $725dc63862a62308$var$FormGroup = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).forwardRef(function(_ref, ref) {
    var bsPrefix = _ref.bsPrefix, className = _ref.className, children = _ref.children, controlId = _ref.controlId, _ref$as = _ref.as, Component = _ref$as === void 0 ? "div" : _ref$as, props = (0, $fbOaB.default)(_ref, $725dc63862a62308$var$_excluded);
    bsPrefix = (0, $57SUk.useBootstrapPrefix)(bsPrefix, "form-group");
    var context = (0, $eeH7J.useMemo)(function() {
        return {
            controlId: controlId
        };
    }, [
        controlId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $ehjce.default).Provider, {
        value: context
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement(Component, (0, $h4XE0.default)({}, props, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($aienp)))(className, bsPrefix)
    }), children));
});
$725dc63862a62308$var$FormGroup.displayName = "FormGroup";
var $725dc63862a62308$export$2e2bcd8739ae039 = $725dc63862a62308$var$FormGroup;

});

parcelRegister("4S2dd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $38bdebdb57b17c8b$export$2e2bcd8739ae039; });

var $h4XE0 = parcelRequire("h4XE0");

var $fbOaB = parcelRequire("fbOaB");

var $aienp = parcelRequire("aienp");

var $eeH7J = parcelRequire("eeH7J");
parcelRequire("bVrkV");

var $caNEj = parcelRequire("caNEj");

var $ehjce = parcelRequire("ehjce");

var $57SUk = parcelRequire("57SUk");
var $38bdebdb57b17c8b$var$_excluded = [
    "as",
    "bsPrefix",
    "column",
    "srOnly",
    "className",
    "htmlFor"
];
var $38bdebdb57b17c8b$var$defaultProps = {
    column: false,
    srOnly: false
};
var $38bdebdb57b17c8b$var$FormLabel = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).forwardRef(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? "label" : _ref$as, bsPrefix = _ref.bsPrefix, column = _ref.column, srOnly = _ref.srOnly, className = _ref.className, htmlFor = _ref.htmlFor, props = (0, $fbOaB.default)(_ref, $38bdebdb57b17c8b$var$_excluded);
    var _useContext = (0, $eeH7J.useContext)((0, $ehjce.default)), controlId = _useContext.controlId;
    bsPrefix = (0, $57SUk.useBootstrapPrefix)(bsPrefix, "form-label");
    var columnClass = "col-form-label";
    if (typeof column === "string") columnClass = columnClass + " " + columnClass + "-" + column;
    var classes = (0, (/*@__PURE__*/$parcel$interopDefault($aienp)))(className, bsPrefix, srOnly && "sr-only", column && columnClass);
    htmlFor = htmlFor || controlId;
    if (column) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $caNEj.default), (0, $h4XE0.default)({
        ref: ref,
        as: "label",
        className: classes,
        htmlFor: htmlFor
    }, props));
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/label-has-for, jsx-a11y/label-has-associated-control
    (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement(Component, (0, $h4XE0.default)({
        ref: ref,
        className: classes,
        htmlFor: htmlFor
    }, props)));
});
$38bdebdb57b17c8b$var$FormLabel.displayName = "FormLabel";
$38bdebdb57b17c8b$var$FormLabel.defaultProps = $38bdebdb57b17c8b$var$defaultProps;
var $38bdebdb57b17c8b$export$2e2bcd8739ae039 = $38bdebdb57b17c8b$var$FormLabel;

});

parcelRegister("aA5Bz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7b419d362f7ab9e0$export$2e2bcd8739ae039; });

var $h4XE0 = parcelRequire("h4XE0");

var $fbOaB = parcelRequire("fbOaB");

var $aienp = parcelRequire("aienp");

var $eeH7J = parcelRequire("eeH7J");

var $57SUk = parcelRequire("57SUk");
var $7b419d362f7ab9e0$var$_excluded = [
    "bsPrefix",
    "className",
    "as",
    "muted"
];
var $7b419d362f7ab9e0$var$FormText = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).forwardRef(function(_ref, ref) {
    var bsPrefix = _ref.bsPrefix, className = _ref.className, _ref$as = _ref.as, Component = _ref$as === void 0 ? "small" : _ref$as, muted = _ref.muted, props = (0, $fbOaB.default)(_ref, $7b419d362f7ab9e0$var$_excluded);
    bsPrefix = (0, $57SUk.useBootstrapPrefix)(bsPrefix, "form-text");
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement(Component, (0, $h4XE0.default)({}, props, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($aienp)))(className, bsPrefix, muted && "text-muted")
    }));
});
$7b419d362f7ab9e0$var$FormText.displayName = "FormText";
var $7b419d362f7ab9e0$export$2e2bcd8739ae039 = $7b419d362f7ab9e0$var$FormText;

});

parcelRegister("86Qhc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5e776f43fb02a0ed$export$2e2bcd8739ae039; });

var $h4XE0 = parcelRequire("h4XE0");

var $eeH7J = parcelRequire("eeH7J");

var $7iQoI = parcelRequire("7iQoI");
var $5e776f43fb02a0ed$var$Switch = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).forwardRef(function(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $7iQoI.default), (0, $h4XE0.default)({}, props, {
        ref: ref,
        type: "switch"
    }));
});
$5e776f43fb02a0ed$var$Switch.displayName = "Switch";
$5e776f43fb02a0ed$var$Switch.Input = (0, $7iQoI.default).Input;
$5e776f43fb02a0ed$var$Switch.Label = (0, $7iQoI.default).Label;
var $5e776f43fb02a0ed$export$2e2bcd8739ae039 = $5e776f43fb02a0ed$var$Switch;

});

parcelRegister("b3Riz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $80d95180b0175046$export$2e2bcd8739ae039; });

var $h4XE0 = parcelRequire("h4XE0");

var $fbOaB = parcelRequire("fbOaB");

var $aienp = parcelRequire("aienp");

var $hM76s = parcelRequire("hM76s");

var $eeH7J = parcelRequire("eeH7J");

var $57SUk = parcelRequire("57SUk");
var $80d95180b0175046$var$_excluded = [
    "className",
    "bsPrefix",
    "as"
];
var $80d95180b0175046$var$pascalCase = function pascalCase(str) {
    return str[0].toUpperCase() + (0, $hM76s.default)(str).slice(1);
};
function $80d95180b0175046$export$2e2bcd8739ae039(prefix, _temp) {
    var _ref = _temp === void 0 ? {} : _temp, _ref$displayName = _ref.displayName, displayName = _ref$displayName === void 0 ? $80d95180b0175046$var$pascalCase(prefix) : _ref$displayName, Component = _ref.Component, defaultProps = _ref.defaultProps;
    var BsComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).forwardRef(function(_ref2, ref) {
        var className = _ref2.className, bsPrefix = _ref2.bsPrefix, _ref2$as = _ref2.as, Tag = _ref2$as === void 0 ? Component || "div" : _ref2$as, props = (0, $fbOaB.default)(_ref2, $80d95180b0175046$var$_excluded);
        var resolvedPrefix = (0, $57SUk.useBootstrapPrefix)(bsPrefix, prefix);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement(Tag, (0, $h4XE0.default)({
            ref: ref,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($aienp)))(className, resolvedPrefix)
        }, props));
    });
    BsComponent.defaultProps = defaultProps;
    BsComponent.displayName = displayName;
    return BsComponent;
}

});
parcelRegister("hM76s", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cf0c6ded28cac0f1$export$2e2bcd8739ae039; });
var $cf0c6ded28cac0f1$var$rHyphen = /-(.)/g;
function $cf0c6ded28cac0f1$export$2e2bcd8739ae039(string) {
    return string.replace($cf0c6ded28cac0f1$var$rHyphen, function(_, chr) {
        return chr.toUpperCase();
    });
}

});



parcelRegister("42fiX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2f03388ae4e2ef62$export$2e2bcd8739ae039; });

var $h4XE0 = parcelRequire("h4XE0");

var $fbOaB = parcelRequire("fbOaB");

var $aienp = parcelRequire("aienp");

var $eeH7J = parcelRequire("eeH7J");

var $57SUk = parcelRequire("57SUk");
var $2f03388ae4e2ef62$var$_excluded = [
    "bsPrefix",
    "className",
    "noGutters",
    "as"
];
var $2f03388ae4e2ef62$var$DEVICE_SIZES = [
    "xl",
    "lg",
    "md",
    "sm",
    "xs"
];
var $2f03388ae4e2ef62$var$defaultProps = {
    noGutters: false
};
var $2f03388ae4e2ef62$var$Row = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).forwardRef(function(_ref, ref) {
    var bsPrefix = _ref.bsPrefix, className = _ref.className, noGutters = _ref.noGutters, _ref$as = _ref.as, Component = _ref$as === void 0 ? "div" : _ref$as, props = (0, $fbOaB.default)(_ref, $2f03388ae4e2ef62$var$_excluded);
    var decoratedBsPrefix = (0, $57SUk.useBootstrapPrefix)(bsPrefix, "row");
    var sizePrefix = decoratedBsPrefix + "-cols";
    var classes = [];
    $2f03388ae4e2ef62$var$DEVICE_SIZES.forEach(function(brkPoint) {
        var propValue = props[brkPoint];
        delete props[brkPoint];
        var cols;
        if (propValue != null && typeof propValue === "object") cols = propValue.cols;
        else cols = propValue;
        var infix = brkPoint !== "xs" ? "-" + brkPoint : "";
        if (cols != null) classes.push("" + sizePrefix + infix + "-" + cols);
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement(Component, (0, $h4XE0.default)({
        ref: ref
    }, props, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($aienp))).apply(void 0, [
            className,
            decoratedBsPrefix,
            noGutters && "no-gutters"
        ].concat(classes))
    }));
});
$2f03388ae4e2ef62$var$Row.displayName = "Row";
$2f03388ae4e2ef62$var$Row.defaultProps = $2f03388ae4e2ef62$var$defaultProps;
var $2f03388ae4e2ef62$export$2e2bcd8739ae039 = $2f03388ae4e2ef62$var$Row;

});

parcelRegister("9HOw2", function(module, exports) {

$parcel$export(module.exports, "useDiagnostic", function () { return $710f508ffdd79dc7$export$69009b9dd3976720; });
$parcel$export(module.exports, "DiagnosticView", function () { return $710f508ffdd79dc7$export$ecd78ddd2af2b763; });

var $4vwom = parcelRequire("4vwom");

var $eeH7J = parcelRequire("eeH7J");

var $43jhg = parcelRequire("43jhg");

var $9Q5xE = parcelRequire("9Q5xE");

var $cSf8f = parcelRequire("cSf8f");

var $gDYj4 = parcelRequire("gDYj4");
function $710f508ffdd79dc7$export$69009b9dd3976720(type, value, version) {
    return (0, $eeH7J.useMemo)(()=>{
        const match = (0, $43jhg.MatchesType)(value, type, false);
        if (match === true) return null;
        else return match;
    }, [
        type,
        value,
        version
    ]);
}
function $710f508ffdd79dc7$export$ecd78ddd2af2b763({ value: value, property: property, noSubtree: noSubtree, overrideText: overrideText }) {
    var _a, _b;
    const { type: type, optional: optional } = property;
    const diagnostic = $710f508ffdd79dc7$export$69009b9dd3976720(type, value);
    let text = diagnostic === null || diagnostic === void 0 ? void 0 : diagnostic.error;
    const requiredAndUndefined = value === undefined && !optional && !(0, $43jhg.AreTypesAssignable)(type, (0, $43jhg.UndefinedType)) && !((_a = property.tags) === null || _a === void 0 ? void 0 : _a.serial);
    const localizedAndNoLocales = value && typeof value === "object" && (0, $gDYj4.IsLocalized)(property.type) && (Object.keys(value).length === 0 || Object.values(value).every((v)=>!v));
    if (requiredAndUndefined || localizedAndNoLocales) text = (0, $cSf8f.ClientSideLocalize)({
        en: "Required",
        no: "P\xe5krevd",
        de: "Erforderlich",
        sv: "Obligatorisk",
        da: "P\xe5kr\xe6vet"
    });
    if (overrideText) text = overrideText;
    if (!text || value === undefined && optional || !noSubtree && ((_b = diagnostic === null || diagnostic === void 0 ? void 0 : diagnostic.subErrors) === null || _b === void 0 ? void 0 : _b.length)) return (0, $4vwom.jsx)((0, $4vwom.Fragment), {}); // Will be displayed by a sub-component
    return (0, $4vwom.jsx)("div", {
        style: {
            color: (0, $9Q5xE.ColorStyles).error[500],
            fontSize: 12,
            paddingLeft: 8,
            paddingRight: 8,
            backgroundColor: (0, $9Q5xE.ColorStyles).error[100],
            borderRadius: 8
        },
        children: text
    });
}

});
parcelRegister("gDYj4", function(module, exports) {

$parcel$export(module.exports, "IsLocalized", function () { return $c1df118268a94ee2$export$e537022c61a985db; });
$parcel$export(module.exports, "ContainsLocalized", function () { return $c1df118268a94ee2$export$ff5818bc22cc1c17; });

var $lHoPV = parcelRequire("lHoPV");

var $43jhg = parcelRequire("43jhg");
(0, $lHoPV.TypeValidator)($c1df118268a94ee2$export$83669d75c31e40c5);
function $c1df118268a94ee2$export$83669d75c31e40c5(loc) {
    if (typeof loc !== "object" || Object.keys(loc).length < 1) throw new Error("Localized value must be defined for at least one locale");
    return loc;
}
function $c1df118268a94ee2$export$e537022c61a985db(type) {
    if (typeof type !== "object") return;
    const alias = (0, $43jhg.GetTypeAlias)(type);
    if (alias !== "Localized") return;
    const arg = type.typeArgs && type.typeArgs[0];
    if (arg === undefined) return;
    return arg;
}
function $c1df118268a94ee2$export$2a0861ffaf8b54d0(loc) {
    return loc.en;
}
const $c1df118268a94ee2$var$containsLocalizedCache = new Map();
function $c1df118268a94ee2$export$ff5818bc22cc1c17(type) {
    const cached = $c1df118268a94ee2$var$containsLocalizedCache.get(type);
    if (cached !== undefined) return cached;
    let res = false;
    (0, $43jhg.VisitType)(type, (x, path)=>{
        if ((0, $43jhg.GetTypeAlias)(x) === "Localized") res = true;
    });
    $c1df118268a94ee2$var$containsLocalizedCache.set(type, res);
    return res;
}
function $c1df118268a94ee2$export$bebd23513faa9a0d(localized, desiredLocale = "en") {
    var _a, _b, _c, _d;
    if (localized === undefined) return "Missing localized text";
    return (_d = (_c = (_b = (_a = localized[desiredLocale.valueOf()]) !== null && _a !== void 0 ? _a : localized.en) !== null && _b !== void 0 ? _b : localized.no) !== null && _c !== void 0 ? _c : Object.values(localized)[0]) !== null && _d !== void 0 ? _d : "Missing localized text";
}
function $c1df118268a94ee2$export$43681192f4e68734(localized, desiredLocale = "en") {
    var _a, _b, _c, _d;
    if (localized === undefined) return undefined;
    return (_d = (_c = (_b = (_a = localized[desiredLocale.valueOf()]) !== null && _a !== void 0 ? _a : localized.en) !== null && _b !== void 0 ? _b : localized.no) !== null && _c !== void 0 ? _c : Object.values(localized)[0]) !== null && _d !== void 0 ? _d : undefined;
}

});


parcelRegister("eF5Lx", function(module, exports) {

$parcel$export(module.exports, "ErrorContext", function () { return $aac95df92667733d$export$21818dff4f4f7174; });

var $eeH7J = parcelRequire("eeH7J");
const $aac95df92667733d$export$21818dff4f4f7174 = /*#__PURE__*/ (0, $eeH7J.createContext)({
    error: false
});

});

parcelRegister("dIDCa", function(module, exports) {

$parcel$export(module.exports, "SchemaToType", function () { return $9fce1d15336aae2c$export$4e3562bb1701c03; });
$parcel$export(module.exports, "GetTypePropsWithExtensions", function () { return $9fce1d15336aae2c$export$4a08ec1d9262027; });

var $8h5s0 = parcelRequire("8h5s0");

var $cwhCA = parcelRequire("cwhCA");

var $k71sq = parcelRequire("k71sq");

var $43jhg = parcelRequire("43jhg");
function $9fce1d15336aae2c$export$88a252eee8940122(func) {
    Object.assign(func, {
        fileName: (0, $k71sq.CallSites)()[1].getFileName()
    });
    $9fce1d15336aae2c$export$88a252eee8940122.functions.push(func);
}
$9fce1d15336aae2c$export$88a252eee8940122.functions = [];
$9fce1d15336aae2c$export$88a252eee8940122.predicates = [];
function $9fce1d15336aae2c$export$32416add6e73ad81(tep) {
    $9fce1d15336aae2c$export$88a252eee8940122.predicates.push(tep);
}
/**
 * The key is `modelName:TypeName` for extenders defined in models
 */ const $9fce1d15336aae2c$var$staticTypeExtenders = new Map();
/**
 * The extensions declared with the @extension attribute.
 */ $9fce1d15336aae2c$export$88a252eee8940122.findStatic = (modelName, typeName)=>$9fce1d15336aae2c$var$staticTypeExtenders.get(modelName ? `${modelName}:${typeName}` : typeName);
const $9fce1d15336aae2c$var$typeExtendersForTypeCache = new Map();
function $9fce1d15336aae2c$export$7c4ce3743ab5a617(typeName, obj, doc) {
    return $9fce1d15336aae2c$export$e052e12fb1ba17c5(typeName).map((extender)=>extender(obj, doc)).filter((x)=>!!x).flatMap((te)=>te.fields);
}
function $9fce1d15336aae2c$var$addTypeExtender(typeName, extender) {
    const type = Array.from($9fce1d15336aae2c$var$extendedPropsCache.keys()).find((t)=>(0, $43jhg.GetTypeAlias)(t) === typeName);
    if (type) $9fce1d15336aae2c$var$extendedPropsCache.delete(type);
    let arr = $9fce1d15336aae2c$var$typeExtendersForTypeCache.get(typeName);
    if (!arr) {
        arr = [];
        $9fce1d15336aae2c$var$typeExtendersForTypeCache.set(typeName, arr);
    }
    arr.push(extender);
}
function $9fce1d15336aae2c$export$589210f816a1ac2b(modelName, typeName, extension) {
    const key = modelName ? `${modelName}:${typeName}` : typeName;
    let arr = $9fce1d15336aae2c$var$staticTypeExtenders.get(key);
    if (!arr) {
        arr = [];
        $9fce1d15336aae2c$var$staticTypeExtenders.set(key, arr);
    }
    arr.push(extension);
    if ((0, $cwhCA.IsReflectionInfoReady)()) {
        $9fce1d15336aae2c$var$extendedPropsCache.delete((0, $cwhCA.GetType)(typeName));
        $9fce1d15336aae2c$var$typeExtendersForTypeCache.delete(typeName);
    }
}
function $9fce1d15336aae2c$export$e052e12fb1ba17c5(typeName) {
    const res = $9fce1d15336aae2c$var$typeExtendersForTypeCache.get(typeName);
    if (res) return res;
    // Match up the correct functions based on their declaration order in the source file
    const arr = [];
    $9fce1d15336aae2c$var$typeExtendersForTypeCache.set(typeName, arr);
    for (const f of (0, $cwhCA.GetReflectionInfo)().typeExtenders){
        for(let i = 0; i < f.types.length; i++)if (f.types[i] === typeName) {
            let c = 0;
            for(let n = 0; n < $9fce1d15336aae2c$export$88a252eee8940122.functions.length; n++){
                const fn = $9fce1d15336aae2c$export$88a252eee8940122.functions[n];
                if (!fn.fileName) continue;
                const sourcePath = (0, $k71sq.ResolveTypeScriptSourceFile)(fn.fileName);
                if (sourcePath === f.sourcePath) {
                    if (c === i) arr.push(fn);
                    c++;
                }
            }
        }
    }
    return arr;
}
function $9fce1d15336aae2c$export$a5acc2168edbea9e(type, value, document) {
    const extensions = [];
    const specificType = (0, $cwhCA.SubstituteAndDiscriminate)(value, type);
    if (specificType !== type) extensions.push(...$9fce1d15336aae2c$export$a5acc2168edbea9e(specificType, value, document));
    const alias = (0, $43jhg.GetTypeAlias)(type);
    const extenders = alias ? $9fce1d15336aae2c$export$e052e12fb1ba17c5(alias) : [];
    extensions.push(...extenders.map((e)=>{
        try {
            return e(value, document);
        } catch (_a) {
            // Errors are some times to be expected, e.g. when adding new
            // items to a list that are not completely filled out yet.
            return undefined;
        }
    }).filter((e)=>!!e));
    return extensions;
}
function $9fce1d15336aae2c$export$ae3b5653cc1d23a9(type, obj, doc, visitor) {
    function visitSchema(v, f) {
        visitor(v, f);
        if (v === undefined) return;
        if (v === null) return;
        if (typeof f !== "object") return;
        if ("union" in f) f.union.forEach((u)=>visitSchema(v, u));
        if ("array" in f) {
            if (v instanceof Array) v.forEach((e)=>visitSchema(e, f.array));
        }
        if ("fields" in f) f.fields.forEach((field)=>visitSchema(v[field.name], field.schema));
    }
    $9fce1d15336aae2c$export$a5acc2168edbea9e(type, obj, doc).forEach((extension)=>{
        var _a;
        (_a = extension.fields) === null || _a === void 0 || _a.forEach((f)=>visitSchema(obj[f.name], f.schema));
    });
}
function $9fce1d15336aae2c$export$4e3562bb1701c03(t) {
    if (t === "string") return "string";
    if (t === "number") return "number";
    if (t === "boolean") return "boolean";
    // These are shortcuts for frequently used types
    if (t === "Markdown") return (0, $cwhCA.GetType)("Markdown");
    if (t === "Image") return (0, $cwhCA.GetType)("Image");
    if ("integer" in t) return {
        number: null,
        minValue: t.min,
        maxValue: t.max,
        integer: t.integer
    };
    if ("name" in t) return (0, $cwhCA.GetType)(t.name);
    if ("array" in t) return {
        array: $9fce1d15336aae2c$export$4e3562bb1701c03(t.array)
    };
    if ("fields" in t) return {
        props: $9fce1d15336aae2c$export$9a83619d426bb2e9(t.fields)
    };
    if ("ref" in t) return {
        string: null,
        reference: {
            fieldName: t.field,
            typeName: t.ref.valueOf()
        }
    };
    if ("union" in t) return {
        union: t.union.map($9fce1d15336aae2c$export$4e3562bb1701c03)
    };
    if ("type" in t) return t.type;
    throw new Error("Unable to convert schema to type: " + JSON.stringify(t));
}
function $9fce1d15336aae2c$export$9a83619d426bb2e9(fields) {
    return fields.map((f)=>({
            name: f.name,
            description: {
                en: f.description
            },
            type: $9fce1d15336aae2c$export$4e3562bb1701c03(f.schema),
            optional: !f.required,
            tags: f.tags
        }));
}
const $9fce1d15336aae2c$var$hasTypeExtendersCache = new Map();
function $9fce1d15336aae2c$export$3e4ff0cfbc757f51(type) {
    const cache = $9fce1d15336aae2c$var$hasTypeExtendersCache.get(type);
    if (cache !== undefined) return cache;
    const alias = (0, $43jhg.GetTypeAlias)(type);
    const result = alias ? $9fce1d15336aae2c$export$e052e12fb1ba17c5(alias).length > 0 : false;
    $9fce1d15336aae2c$var$hasTypeExtendersCache.set(type, result);
    return result;
}
const $9fce1d15336aae2c$var$extendedPropsCache = new Map();
function $9fce1d15336aae2c$export$4a08ec1d9262027(type, value) {
    var _a;
    const hasExtenders = $9fce1d15336aae2c$export$3e4ff0cfbc757f51(type);
    const originalType = type;
    type = value ? (0, $cwhCA.SubstituteAndDiscriminate)(value, type) : type;
    const cacheable = !(value && originalType === type && (0, $43jhg.IsUnionType)(type));
    if (!hasExtenders && value !== undefined && cacheable) {
        // If there are no type extenders, or no value that can affect the type extenders
        // it is viable to return the result from cache
        const cached = $9fce1d15336aae2c$var$extendedPropsCache.get(type);
        if (cached) return cached;
    }
    const typeName = (0, $43jhg.GetTypeAlias)(type);
    let props = (0, $43jhg.GetTypeProps)(type, value);
    if (value === undefined) {
        const modelName = (0, $43jhg.GetTypeModel)(type);
        const extensions = typeName ? $9fce1d15336aae2c$export$88a252eee8940122.findStatic(modelName, typeName) : undefined;
        if (extensions === null || extensions === void 0 ? void 0 : extensions.length) {
            const extendedProps = (_a = extensions === null || extensions === void 0 ? void 0 : extensions.flatMap((e)=>$9fce1d15336aae2c$export$9a83619d426bb2e9(e.fields))) !== null && _a !== void 0 ? _a : [];
            props = [
                ...props,
                ...extendedProps
            ];
        }
        // Static extensions, not specific to the value can be cached
        if (cacheable) $9fce1d15336aae2c$var$extendedPropsCache.set(type, props);
        return props;
    } else {
        // Looking for extensions specific to the value
        const extensions = $9fce1d15336aae2c$export$a5acc2168edbea9e(type, value, {});
        if (extensions.length) {
            const extendedProps = extensions.flatMap((e)=>$9fce1d15336aae2c$export$9a83619d426bb2e9(e.fields));
            props = [
                ...props,
                ...extendedProps
            ];
        }
        if (!hasExtenders && extensions.length === 0) // If the type in general has no extensions, we can cache the props
        {
            if (cacheable) $9fce1d15336aae2c$var$extendedPropsCache.set(type, props);
        }
        return props;
    }
}
function $9fce1d15336aae2c$export$a30af10eb5d98c3a(type, value, doc) {
    const extensions = $9fce1d15336aae2c$export$a5acc2168edbea9e(type, value, doc);
    if (extensions.length === 0) return type;
    const union = [
        type
    ];
    for (const ext of extensions)if (ext.alias) union.push((0, $cwhCA.GetType)(ext.alias));
    else {
        const schema = {
            alias: ext.alias,
            tags: ext.tags,
            props: $9fce1d15336aae2c$export$9a83619d426bb2e9(ext.fields)
        };
        union.push(schema);
    }
    return {
        union: union
    };
}
function $9fce1d15336aae2c$export$37851d16760865ca() {
    var _a;
    const extensions = (0, $cwhCA.GetReflectionInfo)().types.filter((t)=>{
        var _a;
        if (!(0, $43jhg.IsIntersectionType)(t)) return false;
        if (!((_a = t.tags) === null || _a === void 0 ? void 0 : _a.extension)) return false;
        const [col, ext] = t.intersection;
        if (typeof col !== "object" || typeof ext !== "object") return false;
        if (!col.alias) return false;
        return true;
    });
    for (const extension of extensions){
        const baseType = extension.intersection[0];
        const baseAlias = typeof baseType === "object" && "alias" in baseType ? baseType.alias : undefined;
        if (!baseAlias) throw new Error("@extension type must be an intersection of an aliased collection type and an object type");
        const alias = extension.alias;
        if (!alias) throw new Error("@extension type must have an alias");
        // When inheriting through more than one layer, we only want to inherit
        // the last type in the chain. E.g. if B extends A, and C extends B, the
        // intersection chain will be [A, B, C], and we want to use the props from C.
        const ext = extension.intersection[extension.intersection.length - 1];
        if (typeof ext !== "object" || !("props" in ext)) throw new Error("@extension type must be an object type with plain properties");
        const typeExtension = {
            title: (0, $8h5s0.prettyCamel)(alias !== null && alias !== void 0 ? alias : "Item"),
            alias: alias,
            tags: ext.tags,
            fields: ext.props.map((p)=>{
                var _a, _b;
                return {
                    name: p.name,
                    schema: {
                        type: p.type
                    },
                    description: (_b = (_a = p.description) === null || _a === void 0 ? void 0 : _a.en) !== null && _b !== void 0 ? _b : "",
                    required: !p.optional,
                    tags: p.tags
                };
            })
        };
        const predicateName = (_a = extension.tags) === null || _a === void 0 ? void 0 : _a.extension;
        const predicate = typeof predicateName === "string" ? $9fce1d15336aae2c$export$88a252eee8940122.predicates.find((p)=>p.name === predicateName) : undefined;
        $9fce1d15336aae2c$var$addTypeExtender(baseAlias, (obj, doc)=>{
            if (!predicate || predicate(obj, doc)) return typeExtension;
        });
        const modelName = (0, $43jhg.GetTypeModel)(baseType);
        let staticExts = $9fce1d15336aae2c$export$88a252eee8940122.findStatic(modelName, baseAlias);
        if (!staticExts) {
            staticExts = [];
            $9fce1d15336aae2c$var$staticTypeExtenders.set(modelName ? `${modelName}:${baseAlias}` : baseAlias, staticExts);
        }
        staticExts.push(typeExtension);
    }
}

});

parcelRegister("hXi3j", function(module, exports) {

$parcel$export(module.exports, "None", function () { return $d125f32abdc1780f$export$57ca7e07b341709d; });

var $4vwom = parcelRequire("4vwom");
parcelRequire("eeH7J");

var $9Q5xE = parcelRequire("9Q5xE");
function $d125f32abdc1780f$export$57ca7e07b341709d() {
    return (0, $4vwom.jsx)("div", {
        style: {
            border: `1px solid ${(0, $9Q5xE.ColorStyles).gray[200]}`,
            borderRadius: 8,
            padding: 8,
            paddingLeft: 12,
            fontStyle: "italic",
            color: (0, $9Q5xE.ColorStyles).gray[400]
        },
        children: "None"
    });
}

});

parcelRegister("4n6CL", function(module, exports) {

$parcel$export(module.exports, "TypeScriptView", function () { return $32ee72d1747380b4$export$7a5d564e41388b25; });

var $4vwom = parcelRequire("4vwom");

var $eeH7J = parcelRequire("eeH7J");

var $dUDPg = parcelRequire("dUDPg");

var $fT6Pt = parcelRequire("fT6Pt");

var $koJkl = parcelRequire("koJkl");

var $hRViu = parcelRequire("hRViu");

var $1TOtF = parcelRequire("1TOtF");

var $1aVVn = parcelRequire("1aVVn");
function $32ee72d1747380b4$export$7a5d564e41388b25({ obj: obj, property: property, label: label, mode: mode, declarations: declarations }) {
    const [editing, setEditing] = (0, $eeH7J.useState)(false);
    const value = (0, $1aVVn.YTools).get(obj, property.name);
    const buttons = [];
    if (property.optional) buttons.unshift({
        text: "Clear",
        onClick () {
            (0, $1aVVn.YTools).deleteKey(obj, property.name);
        }
    });
    return (0, $4vwom.jsx)((0, $hRViu.PropRow), {
        buttons: buttons,
        badge: (0, $4vwom.jsx)("div", {
            style: {
                display: "flex",
                flexDirection: "row"
            },
            children: (0, $4vwom.jsx)((0, $fT6Pt.RButton), {
                variant: "secondary",
                icon: editing ? "check" : "pencil",
                onClick: ()=>setEditing(!editing),
                children: editing ? "Done" : "Edit"
            })
        }),
        description: property.description,
        label: label,
        children: editing ? (0, $4vwom.jsx)($32ee72d1747380b4$var$TypeScriptViewInner, {
            obj: obj,
            property: property,
            mode: mode,
            declarations: declarations
        }) : (0, $4vwom.jsx)("pre", {
            style: {
                backgroundColor: "#f8f8f8",
                padding: 16
            },
            children: mode === "json-stringify" ? JSON.stringify(value, null, 2) : value
        })
    });
}
function $32ee72d1747380b4$var$TypeScriptViewInner({ obj: obj, property: property, mode: mode, declarations: explicitDeclarations }) {
    var _a, _b;
    const declarationsFunc = (_a = property.tags) === null || _a === void 0 ? void 0 : _a.declarations;
    const doc = (0, $1TOtF.useDocument)();
    const [value, setValue] = (0, $1aVVn.useYState)(obj, property.name);
    const { data: data } = (0, $dUDPg.useDocumentPropertyDeclarations)(!!declarationsFunc && !explicitDeclarations ? {
        document: doc,
        object: obj !== doc ? obj : null,
        declarationsFunc: declarationsFunc,
        includeMutations: (_b = property.tags) === null || _b === void 0 ? void 0 : _b.includeMutations
    } : null);
    const declarations = explicitDeclarations || (data === null || data === void 0 ? void 0 : data.code);
    return (0, $4vwom.jsx)((0, $koJkl.CodeEdit), {
        text: mode === "json-stringify" ? JSON.stringify(value, null, 2) : value,
        declarations: declarations || "",
        language: mode === "json-stringify" ? "json" : "typescript",
        onEdited: (code)=>{
            if (mode === "json-stringify") try {
                setValue(JSON.parse(code));
            } catch (e) {
                alert(e.message);
                return;
            }
            else setValue(code);
        }
    });
}

});
parcelRegister("koJkl", function(module, exports) {

$parcel$export(module.exports, "CodeEdit", function () { return $ed9935909e9505a2$export$ee34b5f8cbf8c3ad; });

var $4vwom = parcelRequire("4vwom");

var $eeH7J = parcelRequire("eeH7J");

var $7m9cQ = parcelRequire("7m9cQ");
function $ed9935909e9505a2$export$ee34b5f8cbf8c3ad({ text: text, declarations: declarations, language: language, height: height, innerHeight: innerHeight, error: error, onEdited: onEdited }) {
    var _a, _b, _c;
    const frame = (0, $eeH7J.useRef)(null);
    const [ready, setReady] = (0, $eeH7J.useState)(false);
    (0, $eeH7J.useEffect)(()=>{
        function handler(e) {
            var _a, _b, _c;
            if (e.source !== ((_a = frame.current) === null || _a === void 0 ? void 0 : _a.contentWindow)) return;
            if ("onEdited" in e.data) onEdited(e.data.onEdited);
            if ("readyForConfig" in e.data) (_c = (_b = frame.current) === null || _b === void 0 ? void 0 : _b.contentWindow) === null || _c === void 0 || _c.postMessage({
                config: {
                    language: language,
                    height: innerHeight !== null && innerHeight !== void 0 ? innerHeight : height
                }
            }, "*");
            if ("ready" in e.data) setReady(e.data.ready);
        }
        window.addEventListener("message", handler);
        return ()=>window.removeEventListener("message", handler);
    }, [
        onEdited
    ]);
    (0, $eeH7J.useEffect)(()=>{
        var _a, _b;
        if (ready) (_b = (_a = frame.current) === null || _a === void 0 ? void 0 : _a.contentWindow) === null || _b === void 0 || _b.postMessage({
            text: text
        }, "*");
    }, [
        text,
        (_a = frame.current) === null || _a === void 0 ? void 0 : _a.contentWindow,
        ready
    ]);
    (0, $eeH7J.useEffect)(()=>{
        var _a, _b;
        (_b = (_a = frame.current) === null || _a === void 0 ? void 0 : _a.contentWindow) === null || _b === void 0 || _b.postMessage({
            declarations: declarations
        }, "*");
    }, [
        declarations,
        (_b = frame.current) === null || _b === void 0 ? void 0 : _b.contentWindow,
        ready
    ]);
    (0, $eeH7J.useEffect)(()=>{
        var _a, _b;
        (_b = (_a = frame.current) === null || _a === void 0 ? void 0 : _a.contentWindow) === null || _b === void 0 || _b.postMessage({
            error: error
        }, "*");
    }, [
        error,
        (_c = frame.current) === null || _c === void 0 ? void 0 : _c.contentWindow,
        ready
    ]);
    return (0, $4vwom.jsx)("iframe", {
        ref: frame,
        src: `${(0, $7m9cQ.server)()}/code-edit`,
        style: {
            width: "100%",
            height: height || 300,
            margin: 0,
            padding: 0,
            border: "1px solid #ddd",
            borderRadius: 4
        }
    });
}

});



parcelRegister("2tM8G", function(module, exports) {

$parcel$export(module.exports, "StringView", function () { return $1ce3a19ba86dbd51$export$71a9f02850b85b8; });

var $4vwom = parcelRequire("4vwom");

var $eeH7J = parcelRequire("eeH7J");

var $1TOtF = parcelRequire("1TOtF");

var $43jhg = parcelRequire("43jhg");

var $9HOw2 = parcelRequire("9HOw2");

var $hRViu = parcelRequire("hRViu");
parcelRequire("2LTO8");
var $4vUfp = parcelRequire("4vUfp");

var $eF5Lx = parcelRequire("eF5Lx");

var $eBaY3 = parcelRequire("eBaY3");

var $dUDPg = parcelRequire("dUDPg");

var $3kELz = parcelRequire("3kELz");

var $7iytm = parcelRequire("7iytm");

var $9Q5xE = parcelRequire("9Q5xE");

var $cSf8f = parcelRequire("cSf8f");

var $1aVVn = parcelRequire("1aVVn");
function $1ce3a19ba86dbd51$export$71a9f02850b85b8({ obj: obj, property: property, label: label, buttons: buttons, isEmbedded: isEmbedded }) {
    var _a, _b, _c, _d, _e, _f, _g;
    const type = property.type;
    const isMarkdown = (0, $43jhg.IsOpaqueStringType)(type) && type.opaque === "Markdown";
    const isMultiline = isMarkdown || ((_a = property.tags) === null || _a === void 0 ? void 0 : _a.multiline) || typeof type === "object" && ((_b = type.tags) === null || _b === void 0 ? void 0 : _b.multiline);
    const [value, setValue, setLocalValue] = (0, $1aVVn.useYState)(obj, property.name);
    const [markdownMode, setMarkdownMode] = (0, $eeH7J.useState)("preview");
    const [focused, setFocused] = (0, $eeH7J.useState)(false);
    const path = (0, $eBaY3.useObjectPath)();
    const docCollection = (0, $1TOtF.useDocumentCollection)();
    const docPrimaryKey = (0, $1TOtF.useDocumentPrimaryKey)();
    const docOptions = (0, $1TOtF.useDocumentOptions)();
    const docRefresh = (0, $1TOtF.useDocumentRefresh)();
    function findOptions() {
        let opts = docOptions;
        for (const pathPart of path){
            if (!opts) break;
            opts = opts[pathPart];
        }
        opts = opts && opts[property.name];
        if (opts instanceof Array) return opts;
    }
    const options = findOptions();
    const hasValidationError = (0, $43jhg.MatchesType)(value, property.type) !== true;
    const [needsEditing] = (0, $eeH7J.useState)(hasValidationError && !value || // Empty strings is rarely the desired value for a string field.
    // Although it CAN theoretically be valid and the desired value for
    // a readonly field, it is more common that it has been
    // "accientally" filled in by the requirement that a
    // Localized<string> requires at least one key to be defined. We
    // want to let the user edit it even if the field is readonly.
    value === "");
    const rc = (0, $eeH7J.useContext)((0, $eBaY3.ReadonlyContext));
    const autoGenerated = ((_c = property.tags) === null || _c === void 0 ? void 0 : _c.serial) && rc.mode === "create";
    const isReadonly = (0, $eBaY3.useIsReadonlyField)(property, needsEditing) || autoGenerated;
    const placeholder = (_f = (_d = property.placeholder) !== null && _d !== void 0 ? _d : ((_e = property.tags) === null || _e === void 0 ? void 0 : _e.placeholder) || undefined) !== null && _f !== void 0 ? _f : autoGenerated ? (0, $cSf8f.ClientSideLocalize)({
        en: "(auto generated)",
        no: "(automatisk generert)",
        sv: "(automatisk genererad)"
    }) : undefined;
    const [textareaRef, setTextAreaRef] = (0, $eeH7J.useState)(null);
    const [textAreaHeight, setTextAreaHeight] = (0, $eeH7J.useState)(100);
    (0, $eeH7J.useEffect)(()=>{
        if (textareaRef) {
            const height = Math.max(30, textareaRef.scrollHeight + 10);
            setTextAreaHeight(height);
        }
    }, [
        textareaRef
    ]);
    const alias = (0, $43jhg.GetTypeAlias)(type);
    const isTimestamp = alias === "Timestamp";
    const isDate = isTimestamp || alias === "LocalDateTime";
    const isDateWithPrecision = isTimestamp;
    const precisionStr = isDateWithPrecision ? (_g = property.tags) === null || _g === void 0 ? void 0 : _g.precision : undefined;
    const prec = precisionStr ? (0, $4vUfp.ParseDateTimePrecision)(precisionStr) : undefined;
    const { error: error } = (0, $eeH7J.useContext)((0, $eF5Lx.ErrorContext));
    const backgroundColor = error ? "#f004" : isReadonly ? (0, $9Q5xE.ColorStyles).gray[50] : "white";
    function insertMedia({ mediaId: mediaId, name: name, mimeType: mimeType }) {
        const start = textareaRef === null || textareaRef === void 0 ? void 0 : textareaRef.selectionStart;
        let media = `![${name}](/api/images/${mediaId}${(name === null || name === void 0 ? void 0 : name.endsWith(".json")) ? "_.json" : "_.png"})`;
        if (name === null || name === void 0 ? void 0 : name.endsWith(".mp4")) media = `![${name}](/api/files/${mediaId})`;
        setValue(`${value.slice(0, start)}\n\n${media}\n\n${value.slice(start)}`);
    }
    async function fileDrop(e) {
        var _a, _b;
        if (e.dataTransfer.files.length > 1) alert("Only one file at a time please");
        const folder = (_b = (_a = property.tags) === null || _a === void 0 ? void 0 : _a.folder) !== null && _b !== void 0 ? _b : "Media";
        const file = e.dataTransfer.files[0];
        const mimetype = file.type === "application/json" ? "application/lottie+json" : file.type;
        const data = new FormData();
        data.append("file", file);
        const id = await (0, $7iytm.UploadFile)(folder, file, mimetype, false, "AnyoneWithLink", file.name);
        if (id) return {
            id: id,
            name: file.name
        };
    }
    const markdownModeToggle = (0, $4vwom.jsxs)("div", {
        style: {
            display: "flex",
            flexDirection: "row",
            width: "100%",
            alignItems: "center",
            fontSize: 10
        },
        children: [
            (0, $4vwom.jsx)("div", {
                onClick: ()=>setMarkdownMode("preview"),
                style: {
                    border: "1px solid #eee",
                    backgroundColor: markdownMode === "preview" ? "#eee" : undefined,
                    borderTopLeftRadius: 2,
                    borderBottomLeftRadius: 2,
                    paddingLeft: 4,
                    paddingRight: 4,
                    cursor: "pointer"
                },
                children: "Preview"
            }),
            (0, $4vwom.jsx)("div", {
                onClick: ()=>setMarkdownMode("markdown"),
                style: {
                    marginRight: 8,
                    backgroundColor: markdownMode === "markdown" ? "#eee" : undefined,
                    border: "1px solid #eee",
                    borderTopRightRadius: 2,
                    borderBottomRightRadius: 2,
                    paddingLeft: 4,
                    paddingRight: 4,
                    cursor: "pointer"
                },
                children: "Markdown"
            })
        ]
    });
    function renderContent() {
        var _a;
        if (isMultiline) return (0, $4vwom.jsx)("div", {
            style: {
                display: "flex",
                flexDirection: "column",
                width: "100%"
            },
            children: (0, $4vwom.jsx)("div", {
                style: {
                    display: "flex",
                    flexDirection: "row",
                    width: "100%"
                },
                children: markdownMode === "preview" && isMarkdown ? (0, $4vwom.jsx)((0, $3kELz.MarkdownEditor), {
                    style: "studio",
                    value: value,
                    onDrop: fileDrop,
                    readOnly: isReadonly,
                    onChanged: (text)=>{
                        if (text === value) return;
                        setValue(text);
                    },
                    markdownSnippetId: // Make it hard to create a circular
                    // reference by embedding the snippet in
                    // a snippet
                    docCollection === "MarkdownSnippets" ? docPrimaryKey : undefined
                }, "md-editor") : (0, $4vwom.jsx)("textarea", {
                    ref: setTextAreaRef,
                    className: "form-control",
                    style: {
                        width: "100%",
                        height: textAreaHeight
                    },
                    placeholder: placeholder,
                    value: value,
                    readOnly: isReadonly,
                    onChange: (e)=>{
                        setValue(e.target.value);
                    },
                    onDrop: async (e)=>{
                        const file = await fileDrop(e);
                        if (file) {
                            const fileInfo = await (0, $dUDPg.getFileInfo)(file.id.valueOf());
                            insertMedia({
                                mediaId: file.toString(),
                                name: file.name,
                                mimeType: fileInfo.mimetype
                            });
                        }
                    }
                }, "textarea")
            })
        });
        let valueString = value === undefined ? "" : value instanceof Date ? value.toISOString().substring(0, value.toISOString().lastIndexOf(".")) : value;
        if (isTimestamp && typeof value === "number") try {
            valueString = (0, $4vUfp.Timestamp).toLocal((0, $4vUfp.Timestamp)(new Date(value)), "millisecond");
        } catch (e) {
            valueString = value.toString();
        }
        let dateType = "datetime-local";
        if (isDateWithPrecision) {
            let unit = typeof prec === "string" ? prec : typeof prec === "object" ? prec.unit : "millisecond";
            // TODO: translate units into HTML5 date input types + step
            // TODO: HTML's date input doesn't support picking years or months. For now mapping this
            // to Day to make it work. Should be replaced by special purpose pickers
            if (unit === "year") unit = "day";
            if (unit === "month") unit = "day";
            // enforce the type's declared precision
            if (valueString) valueString = (0, $4vUfp.Timestamp).toLocal(valueString, unit);
            if (unit === "day") dateType = "date";
        }
        if (options) {
            const valueIndex = options.indexOf(value);
            return (0, $4vwom.jsxs)("select", {
                className: "form-select",
                onChange: (x)=>{
                    if (x.target.value === undefined) setValue(undefined);
                    else setValue(options[parseInt(x.target.value)]);
                    if (docRefresh) docRefresh();
                },
                value: valueIndex === -1 ? undefined : valueIndex,
                children: [
                    (0, $4vwom.jsx)("option", {
                        value: undefined
                    }, "null"),
                    options.map((x, i)=>(0, $4vwom.jsx)("option", {
                            value: i,
                            children: x
                        }, i))
                ]
            });
        }
        const textBox = (0, $4vwom.jsx)("input", {
            readOnly: isReadonly,
            className: "form-control",
            style: {
                backgroundColor: backgroundColor,
                width: "100%",
                margin: isEmbedded ? 2 : undefined
            },
            type: isDate ? dateType : "text",
            placeholder: placeholder,
            value: focused || autoGenerated ? undefined : valueString,
            onChange: (e)=>{
                if (isReadonly) return;
                let v = property.optional && !e.target.value ? undefined : e.target.value;
                if (isDateWithPrecision) // Get it back in zulu format and declared precision before storing
                try {
                    v = (0, $4vUfp.Timestamp)(v);
                } catch (_a) {
                    // If the date was unparsable, just leave it as is
                    return;
                }
                setLocalValue(v);
                if ((0, $43jhg.IsNumberType)(type)) // Don't try to update or parse numbers until we are done editing
                return;
                if (v !== (0, $1aVVn.YTools).get(obj, property.name)) setValue(v);
            },
            onClick: (e)=>e.stopPropagation(),
            onFocus: ()=>{
                setFocused(true);
            },
            onBlur: (e)=>{
                e.stopPropagation();
                if (isReadonly) return;
                setFocused(false);
                let v = value;
                if ((0, $43jhg.IsNumberType)(type) && v !== undefined) {
                    v = parseFloat(v);
                    if (Number.isNaN(v)) {
                        if (property.optional) v = undefined;
                        else v = 0;
                    }
                    if (typeof type === "object") {
                        if (type.integer) v = Math.round(v);
                        if (type.minValue !== undefined) v = Math.max(type.minValue, v);
                        if (type.maxValue !== undefined) v = Math.min(type.maxValue, v);
                    }
                }
                if (isDateWithPrecision) // Get it back in zulu format and declared precision before storing
                try {
                    v = (0, $4vUfp.Timestamp)(v);
                } catch (_a) {
                    // If the date was unparsable, just leave it as is
                    return;
                }
                const validated = v === undefined && property.optional ? v : (0, $43jhg.ValidateType)(v, type);
                setLocalValue(validated);
                if (validated !== (0, $1aVVn.YTools).get(obj, property.name)) setValue(validated);
                if (docRefresh) docRefresh();
            }
        }, "input");
        if ((_a = property.tags) === null || _a === void 0 ? void 0 : _a.slider) {
            let min = 0;
            let max = 100;
            let step = 1;
            if (typeof type === "object" && (0, $43jhg.IsNumberType)(type)) {
                if (type.minValue) min = type.minValue;
                if (type.maxValue) max = type.maxValue;
                if (!type.integer) step = (max - min) / 100;
            }
            return (0, $4vwom.jsxs)("div", {
                style: {
                    display: "flex",
                    flexDirection: "row"
                },
                children: [
                    (0, $4vwom.jsx)("input", {
                        type: "range",
                        min: min,
                        max: max,
                        value: value,
                        step: step,
                        onChange: (e)=>{
                            const v = parseFloat(e.target.value);
                            setValue(v);
                        },
                        style: {
                            flex: 2,
                            marginRight: 8
                        }
                    }),
                    textBox
                ]
            });
        }
        return textBox;
    }
    return (0, $4vwom.jsx)((0, $hRViu.PropRow), {
        isReadonly: isReadonly,
        label: label,
        buttons: buttons,
        description: property.description,
        isEmbedded: isEmbedded,
        badge: (0, $4vwom.jsxs)("div", {
            style: {
                display: "flex",
                flexDirection: "row"
            },
            children: [
                isMarkdown && markdownModeToggle,
                (0, $4vwom.jsx)((0, $9HOw2.DiagnosticView), {
                    property: property,
                    value: (0, $43jhg.IsNumberType)(type) ? value !== undefined ? parseFloat(value) : undefined : value
                })
            ]
        }),
        children: renderContent()
    });
}

});
parcelRegister("3kELz", function(module, exports) {

$parcel$export(module.exports, "MarkdownEditor", function () { return $26d2dcaeddf4c8de$export$18a9461578883ec4; });

var $4vwom = parcelRequire("4vwom");

var $eeH7J = parcelRequire("eeH7J");

var $jF6Vs = parcelRequire("jF6Vs");

var $14q7s = parcelRequire("14q7s");

var $4SGh4 = parcelRequire("4SGh4");

var $dUDPg = parcelRequire("dUDPg");

var $9Q5xE = parcelRequire("9Q5xE");

var $aIeEI = parcelRequire("aIeEI");

var $cSf8f = parcelRequire("cSf8f");

var $6sp4J = parcelRequire("6sp4J");

var $ikBJm = parcelRequire("ikBJm");

var $fT6Pt = parcelRequire("fT6Pt");

var $8MAXm = parcelRequire("8MAXm");

var $2chu2 = parcelRequire("2chu2");


function $26d2dcaeddf4c8de$export$18a9461578883ec4(props) {
    const [editor, setEditor] = (0, $eeH7J.useState)(null);
    (0, $eeH7J.useEffect)(()=>{
        async function load() {
            const draftJs = await (parcelRequire("cUDOr"));
            const draftJsMdConverter = await (parcelRequire("hPh1J"));
            setEditor((0, $4vwom.jsx)($26d2dcaeddf4c8de$var$MarkdownEditorInternal, Object.assign({}, props, {
                draftJs: draftJs,
                draftJsMdConverter: draftJsMdConverter,
                style: props.style,
                autoFocus: props.autoFocus !== undefined ? props.autoFocus : props.style === "wysiwyg",
                markdownSnippetId: props.markdownSnippetId,
                readOnly: props.readOnly === true
            })));
        }
        load();
    }, [
        props.value,
        props.onChanged,
        props.onDrop,
        props.onDone,
        props.markdownSnippetId
    ]);
    return editor;
}
function $26d2dcaeddf4c8de$var$MarkdownEditorInternal(props) {
    const [ref, setRef] = (0, $eeH7J.useState)(null);
    const [focus, setFocus] = (0, $eeH7J.useState)(false);
    const getEditorStateFromProps = ()=>{
        var _a;
        return props.draftJs.EditorState.createWithContent(props.draftJs.convertFromRaw(props.draftJsMdConverter.mdToDraftjs(((_a = props.value) === null || _a === void 0 ? void 0 : _a.valueOf()) || "")));
    };
    const [editorState, setEditorState] = (0, $eeH7J.useState)(getEditorStateFromProps);
    function onNewEditorState(e) {
        setEditorState(e);
        const newValue = props.draftJsMdConverter.draftjsToMd(props.draftJs.convertToRaw(e.getCurrentContent()));
        // If the value is undefined and the new value is an empty string, we
        // don't want to call onChanged, because that would mark the document as
        // dirty before we have started typing anything
        if (props.value === undefined && newValue.valueOf() === "") return;
        if (props.value !== newValue) props.onChanged(newValue);
    }
    // Detect changes in the value prop and update the editor state accordingly
    (0, $eeH7J.useEffect)(()=>{
        var _a;
        if (!focus) setEditorState(props.draftJs.EditorState.createWithContent(props.draftJs.convertFromRaw(props.draftJsMdConverter.mdToDraftjs(((_a = props.value) === null || _a === void 0 ? void 0 : _a.valueOf()) || ""))));
    }, [
        focus,
        props.value
    ]);
    (0, $eeH7J.useEffect)(()=>{
        if (props.autoFocus && ref) ref.focus();
    }, [
        ref,
        props.autoFocus
    ]);
    return (0, $4vwom.jsxs)("div", {
        className: props.style === "studio" ? "form-control" : undefined,
        style: {
            display: "flex",
            flexDirection: "column",
            padding: 0,
            position: "relative",
            border: props.style === "wysiwyg" ? "1px solid " + (0, $9Q5xE.ColorStyles).primary[400] : undefined
        },
        children: [
            (0, $4vwom.jsx)((0, $jF6Vs.Toolbar), {
                editorState: editorState,
                setEditorState: onNewEditorState,
                draftJs: props.draftJs,
                style: props.style,
                currentMarkdownSnippet: props.markdownSnippetId,
                onDone: props.onDone
            }),
            (0, $4vwom.jsx)("div", {
                style: {
                    padding: props.style === "studio" ? 16 : 0
                },
                onDrop: async (e)=>{
                    const file = await props.onDrop(e);
                    if (file) {
                        const fileInfo = await (0, $dUDPg.getFileInfo)(file.id.valueOf());
                        onNewEditorState((0, $4SGh4.InsertImage)(props.draftJs, editorState, fileInfo.mimetype.startsWith("image") ? (0, $14q7s.ImageToUrl)(file.id) : (0, $14q7s.FileToUrl)(file.id), file.name));
                    }
                },
                children: (0, $4vwom.jsx)(props.draftJs.Editor, {
                    ref: setRef,
                    customStyleMap: $26d2dcaeddf4c8de$export$18a9461578883ec4.customStyleMap,
                    editorState: editorState,
                    readOnly: props.readOnly,
                    onChange: onNewEditorState,
                    onFocus: ()=>setFocus(true),
                    onBlur: ()=>setFocus(false),
                    blockRendererFn: (b)=>{
                        if (b.getType() === "atomic") return {
                            component: $26d2dcaeddf4c8de$var$AtomicBlock,
                            editable: false
                        };
                        return null;
                    }
                })
            })
        ]
    });
}
/**
 * Allows the model to override the default style map for Draft.js.
 */ $26d2dcaeddf4c8de$export$18a9461578883ec4.customStyleMap = undefined; // Draft.Component.Base.DraftStyleMap | undefined
function $26d2dcaeddf4c8de$var$AtomicBlock(props) {
    const entity = props.contentState.getEntity(props.block.getEntityAt(0));
    const type = entity.getType();
    if (type === "IMAGE") {
        const { src: src, alt: alt, fileName: fileName } = entity.getData();
        return (0, $4vwom.jsx)($26d2dcaeddf4c8de$var$Media, {
            src: src,
            // Due to a quirk in draftjs-md-converter, the alt text is placed in
            // fileName instead of alt. This is a workaround.
            alt: fileName
        });
    } else return (0, $4vwom.jsx)("div", {
        children: "Unknown atomic block type"
    });
}

function $26d2dcaeddf4c8de$var$Media(props) {
    var _a, _b, _c, _d;
    const id = (0, $14q7s.UndoImageToUrl)(props.src);
    const needFileInfo = !((_a = props.alt) === null || _a === void 0 ? void 0 : _a.startsWith("#IFRAME")) && !((_b = props.alt) === null || _b === void 0 ? void 0 : _b.startsWith("#MARKDOWN_SNIPPET"));
    const { data: fileInfo } = (0, $dUDPg.useFileInfo)(needFileInfo ? id : null);
    if ((_c = props.alt) === null || _c === void 0 ? void 0 : _c.startsWith("#IFRAME")) {
        // Styles are encoded like this: #IFRAME{"width":100,"height":400}
        const style = props.alt.length > 7 ? JSON.parse(props.alt.slice(7)) : {};
        if (props.src.startsWith("/") && !props.src.startsWith("//")) return (0, $4vwom.jsx)("iframe", {
            src: props.src,
            style: Object.assign({
                width: "100%",
                maxWidth: 480,
                height: 500
            }, style)
        });
        else return (0, $4vwom.jsx)("div", {
            style: {
                padding: 8,
                backgroundColor: "#eee",
                color: "red"
            },
            children: "Only relative URLs are supported for embedding"
        });
    }
    if ((_d = props.alt) === null || _d === void 0 ? void 0 : _d.startsWith("#MARKDOWN_SNIPPET")) {
        const id = props.src;
        return (0, $4vwom.jsx)($26d2dcaeddf4c8de$var$EditableMarkdownSnippetView, {
            id: id
        });
    }
    if (fileInfo === null || fileInfo === void 0 ? void 0 : fileInfo.mimetype.startsWith("video")) return (0, $4vwom.jsx)("video", {
        muted: true,
        autoPlay: true,
        controls: true,
        src: props.src,
        style: {
            width: "100%",
            maxWidth: 480
        }
    });
    if (fileInfo === null || fileInfo === void 0 ? void 0 : fileInfo.mimetype.startsWith("application/lottie+json")) return (0, $4vwom.jsx)("div", {
        children: (0, $4vwom.jsx)((0, $2chu2.Lazy), {
            target: async ()=>{
                const Lottie = (await Promise.resolve((parcelRequire("2vh9S")))).Lottie;
                return ()=>(0, $4vwom.jsx)(Lottie, {
                        file: id,
                        style: {
                            width: 400,
                            height: 400
                        }
                    });
            }
        })
    });
    if ((fileInfo === null || fileInfo === void 0 ? void 0 : fileInfo.mimetype.startsWith("image")) || props.src.includes("/api/images")) return (0, $4vwom.jsx)("img", {
        src: props.src,
        style: {
            width: "100%",
            maxWidth: 480
        }
    });
    return (0, $4vwom.jsx)("div", {
        children: "Loading..."
    });
}
function $26d2dcaeddf4c8de$var$EditableMarkdownSnippetView({ id: id }) {
    const { data: data } = (0, $dUDPg.useMarkdownSnippet)(id);
    const locale = (0, $aIeEI.useCurrentLocale)();
    const { modal: modal, showModal: showModal } = (0, $ikBJm.useContextualModal)();
    if (!data) return (0, $4vwom.jsx)("div", {
        children: "Loading..."
    });
    return (0, $4vwom.jsxs)("div", {
        style: {
            border: `1px dashed ${(0, $9Q5xE.ColorStyles).primary[600]}`,
            position: "relative"
        },
        onClick: async ()=>await showModal((close)=>(0, $4vwom.jsx)($26d2dcaeddf4c8de$var$MarkdownSnippetModal, {
                    data: data,
                    close: ()=>close(undefined)
                })),
        children: [
            modal,
            (0, $4vwom.jsxs)("div", {
                style: {
                    fontSize: 10,
                    backgroundColor: (0, $9Q5xE.ColorStyles).primary[600],
                    color: "white",
                    paddingLeft: 4,
                    paddingRight: 4,
                    position: "absolute",
                    top: -16,
                    left: -1,
                    height: 16
                },
                children: [
                    (0, $4vwom.jsx)((0, $6sp4J.Icon), {
                        icon: "ui-sticker-square",
                        size: 10,
                        style: {
                            marginRight: 4,
                            marginTop: -2
                        }
                    }),
                    (0, $cSf8f.ClientSideLocalize)(data.name)
                ]
            }),
            (0, $4vwom.jsx)((0, $8MAXm.MarkdownView), {
                value: data.hydratedSnippet[locale.valueOf()]
            })
        ]
    });
}
function $26d2dcaeddf4c8de$var$MarkdownSnippetModal({ close: close, data: data }) {
    const locale = (0, $aIeEI.useCurrentLocale)();
    return (0, $4vwom.jsxs)("div", {
        style: {
            background: "white",
            borderRadius: 8,
            minWidth: 800,
            minHeight: 480
        },
        children: [
            (0, $4vwom.jsx)($26d2dcaeddf4c8de$export$18a9461578883ec4, {
                style: "studio",
                onDrop: async ()=>undefined,
                value: data.snippet[locale.valueOf()],
                autoFocus: true,
                onChanged: (newValue)=>{
                    data.snippet[locale.valueOf()] = newValue;
                },
                markdownSnippetId: data.id
            }),
            (0, $4vwom.jsx)((0, $fT6Pt.RButton), {
                onClick: close,
                children: "Close"
            })
        ]
    });
}

});
parcelRegister("jF6Vs", function(module, exports) {

$parcel$export(module.exports, "Toolbar", function () { return $e50737f8aa2c85a4$export$4c260019440d418f; });

var $4vwom = parcelRequire("4vwom");

var $eeH7J = parcelRequire("eeH7J");

var $fTlTn = parcelRequire("fTlTn");

var $14q7s = parcelRequire("14q7s");

var $fz3r9 = parcelRequire("fz3r9");

var $4SGh4 = parcelRequire("4SGh4");

var $ikBJm = parcelRequire("ikBJm");

var $9SFXB = parcelRequire("9SFXB");

var $6sp4J = parcelRequire("6sp4J");

var $9Q5xE = parcelRequire("9Q5xE");
function $e50737f8aa2c85a4$var$ToolbarButton(props) {
    const [elementTarget, setElementTarget] = (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).useState(null);
    const { hover: hover, hoverProps: hoverProps } = (0, $fz3r9.useHover)();
    const [showPopup, setShowPopup] = (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).useState(false);
    const popup = props.popup;
    return (0, $4vwom.jsxs)((0, $4vwom.Fragment), {
        children: [
            popup && (0, $4vwom.jsx)((0, $fTlTn.default), {
                target: elementTarget,
                show: showPopup,
                placement: "bottom-start",
                children: (p)=>(0, $4vwom.jsx)("div", Object.assign({
                        onMouseLeave: ()=>setShowPopup(false)
                    }, p, {
                        children: popup(()=>setShowPopup(false))
                    }))
            }),
            (0, $4vwom.jsxs)("div", Object.assign({
                ref: setElementTarget
            }, hoverProps, {
                style: {
                    marginBottom: 2,
                    marginTop: 2,
                    padding: 2,
                    paddingLeft: 8,
                    paddingRight: 8,
                    borderRadius: 4,
                    cursor: "pointer",
                    backgroundColor: hover ? "#ddd" : undefined,
                    color: props.primary ? (0, $9Q5xE.ColorStyles).primary[600] : undefined,
                    fontSize: 12
                },
                // This prevents the markdown editor from losing focus when
                // clicking on the toolbar
                onMouseDown: (e)=>e.preventDefault(),
                onClick: (e)=>{
                    if (props.popup) setShowPopup(!showPopup);
                    if (props.onClick) props.onClick();
                },
                children: [
                    props.icon && (0, $4vwom.jsx)((0, $6sp4J.Icon), {
                        icon: props.icon,
                        size: 12,
                        style: {
                            marginRight: props.text ? 4 : 0
                        }
                    }),
                    props.text && (0, $4vwom.jsx)("span", {
                        onMouseEnter: ()=>setShowPopup(true),
                        style: props.style,
                        children: props.text
                    }),
                    props.children
                ]
            }))
        ]
    });
}
function $e50737f8aa2c85a4$var$ToolbarSeparator() {
    return (0, $4vwom.jsx)("div", {
        style: {
            width: 1,
            marginLeft: 4,
            marginRight: 4,
            height: 16,
            backgroundColor: "#aaa",
            alignSelf: "center"
        }
    });
}


function $e50737f8aa2c85a4$export$4c260019440d418f({ currentMarkdownSnippet: currentMarkdownSnippet, editorState: editorState, setEditorState: setEditorState, draftJs: draftJs, style: style, onDone: onDone }) {
    async function pickFile() {
        var _a;
        const { DocumentPicker: DocumentPicker } = await Promise.resolve((parcelRequire("7c6pE")));
        const doc = await (0, $ikBJm.Modal)((close)=>(0, $4vwom.jsx)(DocumentPicker, {
                collection: "FileRecords",
                current: undefined,
                cancel: ()=>close(undefined),
                itemName: {
                    en: "Image",
                    no: "Bilde",
                    sv: "Bild"
                },
                itemSelected: (row)=>close(row)
            }));
        if (doc) {
            const name = (0, $9SFXB.ExtractPropFromWidget)(doc, "primary");
            const id = (_a = doc._primaryKey) === null || _a === void 0 ? void 0 : _a.toString();
            if (id && name) return {
                id: id,
                name: name
            };
        }
    }
    async function pickSnippet() {
        var _a;
        const { DocumentPicker: DocumentPicker } = await Promise.resolve((parcelRequire("7c6pE")));
        const doc = await (0, $ikBJm.Modal)((close)=>(0, $4vwom.jsx)(DocumentPicker, {
                collection: "MarkdownSnippets",
                current: undefined,
                cancel: ()=>close(undefined),
                itemName: {
                    en: "Markdown snippet"
                },
                itemSelected: (row)=>close(row),
                excludePrimaryKeys: // Avoid making it easy to create a circular reference
                currentMarkdownSnippet ? [
                    currentMarkdownSnippet.valueOf()
                ] : undefined
            }));
        if (doc) {
            const name = (0, $9SFXB.ExtractPropFromWidget)(doc, "primary");
            const id = (_a = doc._primaryKey) === null || _a === void 0 ? void 0 : _a.toString();
            if (id && name) return {
                id: id,
                name: name
            };
        }
    }
    return (0, $4vwom.jsxs)("div", {
        style: {
            display: "flex",
            flexDirection: "row",
            borderBottom: "1px solid #ddd",
            backgroundColor: "#f8f8f8",
            borderTopLeftRadius: 4,
            borderTopRightRadius: 4,
            position: style === "wysiwyg" ? "absolute" : undefined,
            bottom: style === "wysiwyg" ? "100%" : undefined,
            boxShadow: style === "wysiwyg" ? "0px 0px 4px 0px rgba(0,0,0,0.2)" : undefined,
            color: "#333",
            paddingLeft: 3,
            paddingRight: 3
        },
        children: [
            (0, $4vwom.jsx)($e50737f8aa2c85a4$var$ToolbarButton, {
                text: "Heading",
                popup: (close)=>(0, $4vwom.jsxs)("div", {
                        style: {
                            backgroundColor: "#fff",
                            padding: 8,
                            boxShadow: "0px 0px 4px 0px rgba(0,0,0,0.2)",
                            zIndex: 100
                        },
                        children: [
                            (0, $4vwom.jsx)($e50737f8aa2c85a4$var$ToolbarButton, {
                                onClick: ()=>{
                                    setEditorState(draftJs.RichUtils.toggleBlockType(editorState, "header-two"));
                                    close();
                                },
                                children: (0, $4vwom.jsx)("h2", {
                                    children: "Heading 2"
                                })
                            }),
                            (0, $4vwom.jsx)($e50737f8aa2c85a4$var$ToolbarButton, {
                                onClick: ()=>{
                                    setEditorState(draftJs.RichUtils.toggleBlockType(editorState, "header-three"));
                                    close();
                                },
                                children: (0, $4vwom.jsx)("h3", {
                                    children: "Heading 3"
                                })
                            }),
                            (0, $4vwom.jsx)($e50737f8aa2c85a4$var$ToolbarButton, {
                                onClick: ()=>{
                                    setEditorState(draftJs.RichUtils.toggleBlockType(editorState, "header-four"));
                                    close();
                                },
                                children: (0, $4vwom.jsx)("h4", {
                                    children: "Heading 4"
                                })
                            }),
                            (0, $4vwom.jsx)($e50737f8aa2c85a4$var$ToolbarButton, {
                                onClick: ()=>{
                                    // Remove heading style
                                    setEditorState(draftJs.RichUtils.toggleBlockType(editorState, "unstyled"));
                                    close();
                                },
                                children: (0, $4vwom.jsx)((0, $4vwom.Fragment), {
                                    children: "Regular text"
                                })
                            })
                        ]
                    }),
                style: {
                    marginTop: 9
                }
            }),
            (0, $4vwom.jsx)($e50737f8aa2c85a4$var$ToolbarSeparator, {}),
            (0, $4vwom.jsx)($e50737f8aa2c85a4$var$ToolbarButton, {
                icon: "ui-bold-01",
                onClick: ()=>setEditorState(draftJs.RichUtils.toggleInlineStyle(editorState, "BOLD"))
            }),
            (0, $4vwom.jsx)($e50737f8aa2c85a4$var$ToolbarButton, {
                icon: "ui-italic-01",
                onClick: ()=>setEditorState(draftJs.RichUtils.toggleInlineStyle(editorState, "ITALIC"))
            }),
            (0, $4vwom.jsx)($e50737f8aa2c85a4$var$ToolbarButton, {
                icon: "ui-underline-01",
                style: {
                    marginTop: 9
                },
                onClick: ()=>setEditorState(draftJs.RichUtils.toggleInlineStyle(editorState, "UNDERLINE"))
            }),
            (0, $4vwom.jsx)($e50737f8aa2c85a4$var$ToolbarSeparator, {}),
            (0, $4vwom.jsx)($e50737f8aa2c85a4$var$ToolbarButton, {
                icon: "ui-dotpoints-01",
                style: {
                    marginTop: 9
                },
                onClick: ()=>setEditorState(draftJs.RichUtils.toggleBlockType(editorState, "unordered-list-item"))
            }),
            (0, $4vwom.jsx)($e50737f8aa2c85a4$var$ToolbarButton, {
                icon: "ui-image-01",
                style: {
                    marginTop: 9
                },
                onClick: async ()=>{
                    const file = await pickFile();
                    if (!file) return;
                    setEditorState((0, $4SGh4.InsertImage)(draftJs, editorState, (0, $14q7s.ImageToUrl)(file.id), file.name));
                }
            }),
            (0, $4vwom.jsx)($e50737f8aa2c85a4$var$ToolbarButton, {
                icon: "ui-sticker-square",
                style: {
                    marginTop: 9
                },
                onClick: async ()=>{
                    const snippet = await pickSnippet();
                    if (!snippet) return;
                    setEditorState((0, $4SGh4.InsertImage)(draftJs, editorState, snippet.id, "#MARKDOWN_SNIPPET"));
                }
            }),
            onDone && (0, $4vwom.jsxs)((0, $4vwom.Fragment), {
                children: [
                    (0, $4vwom.jsx)($e50737f8aa2c85a4$var$ToolbarSeparator, {}),
                    (0, $4vwom.jsx)($e50737f8aa2c85a4$var$ToolbarButton, {
                        icon: "ui-check",
                        text: "Done",
                        primary: true,
                        onClick: onDone
                    })
                ]
            })
        ]
    });
}

});
parcelRegister("4SGh4", function(module, exports) {

$parcel$export(module.exports, "InsertImage", function () { return $38dcff59e0b191e5$export$4ff79810d1c58efe; });
function $38dcff59e0b191e5$export$4ff79810d1c58efe(draftJs, editorState, src, alt) {
    const contentState = editorState.getCurrentContent();
    const contentStateWithEntity = contentState.createEntity("IMAGE", "IMMUTABLE", {
        src: src,
        alt: alt,
        // This is a workaround for a quirk in draftjs-md-converter, which
        // expects the image to have a fileName property, which in turn is
        // passet as "alt"
        fileName: alt
    });
    const entityKey = contentStateWithEntity.getLastCreatedEntityKey();
    const newEditorState = draftJs.EditorState.set(editorState, {
        currentContent: contentStateWithEntity
    });
    return draftJs.AtomicBlockUtils.insertAtomicBlock(newEditorState, entityKey, " ");
}

});

parcelRegister("9SFXB", function(module, exports) {

$parcel$export(module.exports, "FindWidgetByKey", function () { return $7319b4ab976d7169$export$8877d2178be5a8e9; });
$parcel$export(module.exports, "ExtractPrimaryItemFromWidget", function () { return $7319b4ab976d7169$export$b3961701b234014; });
$parcel$export(module.exports, "ExtractPropFromWidget", function () { return $7319b4ab976d7169$export$c7c832d3f94b6f1f; });

var $fQXMV = parcelRequire("fQXMV");

var $bUDfc = parcelRequire("bUDfc");
function $7319b4ab976d7169$export$11228c853abac5c6(row) {
    if (row instanceof Promise) return row;
    if ((0, $bUDfc.IsTableRow)(row)) {
        const res = {};
        let promises;
        for (const key of Object.keys(row))try {
            const fn = row[key];
            if (fn instanceof Function) res[key] = fn();
            else res[key] = fn;
            const widget = res[key];
            if (widget instanceof Promise) {
                promises !== null && promises !== void 0 ? promises : promises = [];
                promises.push(widget);
                // Avoid global unhandled promise rejection (which would
                // crash the entire server). Instead we catch the error
                // and display the error message in place of the widget
                widget.catch((e)=>{
                    res[key] = (0, $fQXMV.Empty)(e.message, "Error");
                });
            }
        } catch (e) {
            res[key] = [
                "This tab failed to render because of an error",
                e.message
            ].concat(e.stack.split("\n"));
        }
        if (promises) return Promise.all(promises).then(()=>res);
        return res;
    }
    return row;
}
function $7319b4ab976d7169$var$isWidget(obj) {
    return !!obj && typeof obj === "object" && "type" in obj && "widgetKey" in obj && typeof obj.widgetKey === "string";
}
function $7319b4ab976d7169$export$40fb48d0451e4a99(root, res = [], seen = new Set()) {
    if (seen.has(root)) return res;
    seen.add(root);
    if ($7319b4ab976d7169$var$isWidget(root)) res.push(root);
    if (typeof root === "object") for(const prop in root)$7319b4ab976d7169$export$40fb48d0451e4a99(root[prop], res, seen);
    return res;
}
function $7319b4ab976d7169$export$b2ecdf4402c9d7eb(root) {
    const widgets = $7319b4ab976d7169$export$40fb48d0451e4a99(root);
    const keys = new Set();
    for (const widget of widgets){
        if (keys.has(widget.widgetKey)) throw new Error(`Duplicate widgetKey '${widget.widgetKey}'`);
        keys.add(widget.widgetKey);
    }
}
function $7319b4ab976d7169$export$8877d2178be5a8e9(root, key) {
    const res = [];
    $7319b4ab976d7169$var$FindMultipleWidgetsByKey(root, key, res);
    if (res.length > 1) throw new Error(`Multiple widgets with key '${key}' - please provide unique widgetKey to disambiguate`);
    if (res.length === 0) return undefined;
    return res[0];
}
function $7319b4ab976d7169$var$FindMultipleWidgetsByKey(root, key, result) {
    if ((0, $bUDfc.IsWidgetBase)(root) && root.widgetKey === key) result.push(root);
    if (root instanceof Array) {
        for (const child of root)$7319b4ab976d7169$var$FindMultipleWidgetsByKey(child, key, result);
        return;
    }
    if ((0, $bUDfc.IsButton)(root)) {
        if (root.dropdown) {
            for (const subButton of root.dropdown)$7319b4ab976d7169$var$FindMultipleWidgetsByKey(subButton, key, result);
            return;
        }
    }
    if ((0, $bUDfc.IsModal)(root)) {
        $7319b4ab976d7169$var$FindMultipleWidgetsByKey(root.widget, key, result);
        return;
    }
    if ((0, $bUDfc.IsTable)(root)) {
        $7319b4ab976d7169$var$FindMultipleWidgetsByKey(root.buttons, key, result);
        $7319b4ab976d7169$var$FindMultipleWidgetsByKey(root.widget, key, result);
        for (const row of root.rows)for (const column of Object.keys(row)){
            const cell = row[column];
            $7319b4ab976d7169$var$FindMultipleWidgetsByKey(cell, key, result);
        }
        return;
    }
    // Table row case
    if (root !== null && typeof root === "object") for(const field in root)$7319b4ab976d7169$var$FindMultipleWidgetsByKey(root[field], key, result);
}
function $7319b4ab976d7169$export$cbbb192622182f06(root, key, method = "action") {
    const widget = $7319b4ab976d7169$export$8877d2178be5a8e9(root, key);
    return widget && typeof widget === "object" && method in widget && widget[method] instanceof Function ? widget[method] : undefined;
}
function $7319b4ab976d7169$export$b3961701b234014(view) {
    var _a;
    if (view === undefined) return (0, $fQXMV.Empty)("Not specified");
    if ((0, $bUDfc.IsItem)(view)) return view;
    if (view && typeof view === "object") for (const col of Object.keys(view)){
        const w = view[col];
        if ((0, $bUDfc.IsItem)(w)) return w;
    }
    const text = (_a = $7319b4ab976d7169$export$c7c832d3f94b6f1f(view, "primary")) !== null && _a !== void 0 ? _a : "(no text)";
    return {
        type: "Item",
        primary: text
    };
}
function $7319b4ab976d7169$export$c7c832d3f94b6f1f(view, field = "primary") {
    if ((0, $bUDfc.IsItem)(view)) return view[field];
    if (view && typeof view === "object") for (const col of Object.keys(view)){
        const w = view[col];
        if ((0, $bUDfc.IsItem)(w)) return w[field];
    }
    if (view && typeof view === "object") for (const col of Object.keys(view)){
        const w = view[col];
        if (typeof w === "string") return w;
        if (typeof w === "number") return "" + w;
    }
    if (typeof view === "string") return view;
    if (typeof view === "number") return "" + view;
    return "" + JSON.stringify(view);
}

});
parcelRegister("fQXMV", function(module, exports) {

$parcel$export(module.exports, "Empty", function () { return $b8aa17044d722db5$export$1f74963c34e8bfec; });

var $5cQqO = parcelRequire("5cQqO");
(0, $5cQqO.TSQFunction)($b8aa17044d722db5$export$1f74963c34e8bfec);
function $b8aa17044d722db5$export$1f74963c34e8bfec(widget, variant) {
    return {
        type: "Empty",
        widget: widget !== null && widget !== void 0 ? widget : "Empty",
        variant: variant
    };
}

});


parcelRegister("7c6pE", function(module, exports) {

$parcel$export(module.exports, "DocumentPicker", function () { return $53cea0d76a816792$export$fb9adcae9aa30f9e; });

var $4vwom = parcelRequire("4vwom");

var $eeH7J = parcelRequire("eeH7J");

var $9SFXB = parcelRequire("9SFXB");

var $bUDfc = parcelRequire("bUDfc");

var $1TOtF = parcelRequire("1TOtF");

var $eBuVL = parcelRequire("eBuVL");

var $dUDPg = parcelRequire("dUDPg");

var $2CKKq = parcelRequire("2CKKq");

var $cSf8f = parcelRequire("cSf8f");
function $53cea0d76a816792$export$fb9adcae9aa30f9e(props) {
    var _a;
    const doc = (0, $1TOtF.useDocument)();
    const [scope, setScope] = (0, $eeH7J.useState)("only-this");
    const itemName = (_a = props.itemName) !== null && _a !== void 0 ? _a : {
        en: "Item",
        sv: "Objekt",
        no: "Objekt"
    };
    return (0, $4vwom.jsx)((0, $eBuVL.WidgetContextProvider), {
        busy: props.busy,
        path: [
            "picker",
            props.collection
        ],
        fetcher: async (req)=>{
            var _a;
            return await (0, $dUDPg.postStudioPage)(props.collection, Object.assign({
                document: (_a = props.document) !== null && _a !== void 0 ? _a : doc,
                object: props.obj,
                refKey: props.refKey,
                excludePrimaryKeys: props.excludePrimaryKeys
            }, req));
        },
        callAction: async (req)=>await (0, $dUDPg.postStudioPageAction)(props.collection, req),
        children: (table)=>{
            if (!(0, $bUDfc.IsTable)(table)) return (0, $4vwom.jsx)((0, $4vwom.Fragment), {});
            const primaryText = (0, $9SFXB.ExtractPropFromWidget)(props.current, "primary");
            table.title = primaryText === undefined || primaryText === "undefined" ? (0, $cSf8f.Strings)["Please specify"] : `${(0, $cSf8f.Strings).Replace} '${primaryText}'`;
            table.subTitle = primaryText === undefined || primaryText === "undefined" ? (0, $cSf8f.Translations).SelectX(itemName) : (0, $cSf8f.Translations).SelectXToRepalceY(itemName, primaryText);
            table.onRowClicked = (doc)=>props.itemSelected(doc, scope);
            table.primaryAction = {
                icon: "times",
                text: (0, $cSf8f.Strings).Cancel,
                onClicked: props.cancel
            };
            table.hideAddButton = true;
            table.hideTitle = false;
            return (0, $4vwom.jsx)((0, $2CKKq.TableWidget), Object.assign({}, table, {
                disableQuery: true,
                titleButtons: (0, $4vwom.jsxs)("select", {
                    className: "reactor-document-picker-reference-mode",
                    value: scope,
                    onChange: (e)=>setScope(e.target.value),
                    style: {
                        fontSize: 12,
                        padding: 4,
                        border: "1px solid #eee",
                        borderRadius: 8,
                        maxWidth: 200
                    },
                    children: [
                        (0, $4vwom.jsx)("option", {
                            value: "only-this",
                            children: (0, $cSf8f.Translations).ReplaceOnlyThisReference()
                        }),
                        (0, $4vwom.jsx)("option", {
                            value: "all-in-document",
                            children: (0, $cSf8f.Translations).ReplaceAllReferencesInDocument(primaryText !== null && primaryText !== void 0 ? primaryText : "(?)")
                        })
                    ]
                })
            }));
        }
    });
}

});
parcelRegister("eBuVL", function(module, exports) {

$parcel$export(module.exports, "WidgetContextProvider", function () { return $aa1c83956a83ff7d$export$b8f72d78744dcaa7; });

var $4vwom = parcelRequire("4vwom");

var $eeH7J = parcelRequire("eeH7J");

var $lDBHC = parcelRequire("lDBHC");
parcelRequire("jniej");
var $eK8Q4 = parcelRequire("eK8Q4");

var $53syj = parcelRequire("53syj");

var $hV5w0 = parcelRequire("hV5w0");
function $aa1c83956a83ff7d$export$b8f72d78744dcaa7(props) {
    var _a;
    const path = props.path.join("/");
    const [prefrence, setPreference] = (0, $eK8Q4.usePreference)(path, "{}");
    const state = (0, $eeH7J.useRef)(JSON.parse(prefrence) || {});
    state.current = JSON.parse(prefrence) || {};
    const [page, setPage] = (0, $eeH7J.useState)(null);
    const [error, setError] = (0, $eeH7J.useState)(null);
    const stateVersion = (0, $eeH7J.useRef)(0);
    const { executeClientEffects: executeClientEffects, modal: modal } = (0, $hV5w0.useExecuteClientEffects)();
    const refreshResolvers = (0, $eeH7J.useRef)([]);
    const refresh = (newState, version = ++stateVersion.current)=>{
        return new Promise((resolve, reject)=>{
            const currentState = newState !== null && newState !== void 0 ? newState : state.current;
            refreshResolvers.current.push(resolve);
            setTimeout(async ()=>{
                try {
                    // Check if the state has changed again the last 100 ms, if so, cancel to avoid
                    // spamming the server with expensive requests. (poor man's debounce)
                    if (version !== stateVersion.current) return;
                    const res = await props.fetcher({
                        state: currentState
                    });
                    setError(undefined);
                    // Check that the response is still the most recent one we have requested Otherwise,
                    // writing the state will overwrite the most recent state causing annoying glitches
                    if (version === stateVersion.current) {
                        setPreference(JSON.stringify(res.state));
                        setPage(res.content);
                    }
                    refreshResolvers.current.forEach((r)=>r());
                    refreshResolvers.current = [];
                } catch (e) {
                    setError(e);
                    reject(e);
                }
            }, 100);
        });
    };
    const setState = async (newState)=>{
        if (JSON.stringify(newState) !== JSON.stringify(state.current)) {
            state.current = newState;
            setPreference(JSON.stringify(newState));
            await refresh(newState);
        }
    };
    (0, $eeH7J.useEffect)(()=>{
        refresh().catch((e)=>setError(e));
    }, (_a = props.fetcherDeps) !== null && _a !== void 0 ? _a : []);
    const oldPath = (0, $eeH7J.useRef)(null);
    if (oldPath.current !== path) {
        oldPath.current = path;
        if (!(0, $lDBHC.IsNode)()) refresh();
    }
    if (error && !props.handlesError) return (0, $4vwom.jsx)((0, $53syj.ErrorView), {
        error: error
    });
    if (!page && props.busy && !error) return props.busy();
    async function performAction(widgetKey, method = "action", args, onResponse) {
        const res = await props.callAction({
            state: state.current,
            widgetKey: widgetKey,
            method: method,
            args: args
        });
        setPreference(JSON.stringify(res.state));
        setPage(res.content);
        if (onResponse) {
            onResponse();
            // Allow onResponse changes to propagate before executing client effects
            setTimeout(()=>executeClientEffects(res.effects), 10);
        } else executeClientEffects(res.effects);
        return res.result;
    }
    return (0, $4vwom.jsxs)((0, $hV5w0.WidgetContext).Provider, {
        value: {
            state: state.current,
            setState: setState,
            refresh: refresh,
            performAction: performAction,
            root: page
        },
        children: [
            modal,
            props.children(page, error)
        ]
    });
}

});
parcelRegister("jniej", function(module, exports) {
$parcel$export(module.exports, "getQuery", function () { return (parcelRequire("cWF8g")).getQuery; });
$parcel$export(module.exports, "useQueryNumber", function () { return (parcelRequire("cWF8g")).useQueryNumber; });
$parcel$export(module.exports, "useQueryString", function () { return (parcelRequire("cWF8g")).useQueryString; });
$parcel$export(module.exports, "useDebounce", function () { return (parcelRequire("gaj8U")).useDebounce; });
$parcel$export(module.exports, "useDebounceContent", function () { return (parcelRequire("gaj8U")).useDebounceContent; });
$parcel$export(module.exports, "usePreference", function () { return (parcelRequire("eK8Q4")).usePreference; });
$parcel$export(module.exports, "useSessionState", function () { return (parcelRequire("eK8Q4")).useSessionState; });
$parcel$export(module.exports, "useChangeNotifications", function () { return (parcelRequire("3SKqX")).useChangeNotifications; });
$parcel$export(module.exports, "WebSocketContext", function () { return (parcelRequire("3SKqX")).WebSocketContext; });
$parcel$export(module.exports, "WebSocketContextProvider", function () { return (parcelRequire("3SKqX")).WebSocketContextProvider; });
$parcel$export(module.exports, "useStateContainer", function () { return (parcelRequire("cCNWd")).useStateContainer; });
parcelRequire("cWF8g");
parcelRequire("gaj8U");
parcelRequire("jg1lX");
parcelRequire("eK8Q4");
parcelRequire("3SKqX");
parcelRequire("cCNWd");

});
parcelRegister("cWF8g", function(module, exports) {

$parcel$export(module.exports, "getQuery", function () { return $96caced927e146db$export$71eec30d9db46a56; });
$parcel$export(module.exports, "useQueryString", function () { return $96caced927e146db$export$5d88e6cb5cd2f422; });
$parcel$export(module.exports, "useQueryNumber", function () { return $96caced927e146db$export$1650421d65c0c1c0; });

var $eeH7J = parcelRequire("eeH7J");

var $kEB1E = parcelRequire("kEB1E");

var $lDBHC = parcelRequire("lDBHC");
function $96caced927e146db$export$796b81a51be0b38a(qsValue, options) {
    const newUrl = window.location.protocol + "//" + window.location.host + window.location.pathname + qsValue + window.location.hash;
    if (options === null || options === void 0 ? void 0 : options.replace) window.history.replaceState({
        path: newUrl
    }, "", newUrl);
    else window.history.pushState({
        path: newUrl
    }, "", newUrl);
    $96caced927e146db$var$listeners.forEach((x)=>x());
}
function $96caced927e146db$export$8c7da94d5c72705a(path, options) {
    const newUrl = window.location.protocol + "//" + window.location.host + path + window.location.search + window.location.hash;
    if (options === null || options === void 0 ? void 0 : options.replace) window.history.replaceState({
        path: newUrl
    }, "", newUrl);
    else window.history.pushState({
        path: newUrl
    }, "", newUrl);
    $96caced927e146db$var$listeners.forEach((x)=>x());
}
function $96caced927e146db$export$71eec30d9db46a56() {
    if ((0, $lDBHC.IsNode)()) return {};
    return (0, (/*@__PURE__*/$parcel$interopDefault($kEB1E))).parse(window.location.search);
}
function $96caced927e146db$var$setQueryStringValue(key, value, queryString = window.location.search, options) {
    const values = (0, (/*@__PURE__*/$parcel$interopDefault($kEB1E))).parse(queryString);
    if (values[key] !== value) {
        const newQsValue = (0, (/*@__PURE__*/$parcel$interopDefault($kEB1E))).stringify(Object.assign(Object.assign({}, values), {
            [key]: value
        }));
        $96caced927e146db$export$796b81a51be0b38a(`?${newQsValue}`, options);
    }
}
function $96caced927e146db$var$getQueryStringValue(key, queryString) {
    const values = (0, (/*@__PURE__*/$parcel$interopDefault($kEB1E))).parse(queryString || (0, $lDBHC.IsNode)() ? "0" : window.location.search);
    return values[key];
}
const $96caced927e146db$var$listeners = [];
function $96caced927e146db$export$5d88e6cb5cd2f422(key, initialValue) {
    const [value, setValue] = (0, $eeH7J.useState)(key && $96caced927e146db$var$getQueryStringValue(key) || initialValue);
    const onSetValue = (0, $eeH7J.useCallback)((newValue, options)=>{
        setValue(newValue);
        $96caced927e146db$var$setQueryStringValue(key, newValue, undefined, options);
        $96caced927e146db$var$listeners.forEach((x)=>x());
    }, [
        key
    ]);
    (0, $eeH7J.useEffect)(()=>{
        function listen() {
            setValue($96caced927e146db$var$getQueryStringValue(key) || initialValue);
        }
        window.addEventListener("popstate", listen);
        $96caced927e146db$var$listeners.push(listen);
        return ()=>{
            window.removeEventListener("popstate", listen);
            $96caced927e146db$var$listeners.splice($96caced927e146db$var$listeners.indexOf(listen), 1);
        };
    }, [
        key
    ]);
    return [
        value instanceof Array ? "" + value : value,
        onSetValue
    ];
}
function $96caced927e146db$export$1650421d65c0c1c0(key, initialValue) {
    const [valueStr, setValueStr] = $96caced927e146db$export$5d88e6cb5cd2f422(key, initialValue ? "" + initialValue : undefined);
    function setValue(newValue) {
        setValueStr(newValue === undefined ? undefined : "" + newValue);
    }
    const value = valueStr ? parseInt(valueStr) : initialValue;
    return [
        value === undefined || isNaN(value) ? initialValue : value,
        setValue
    ];
}

});
parcelRegister("kEB1E", function(module, exports) {

$parcel$export(module.exports, "extract", function () { return $f09443988f46afe0$export$f9380c9a627682d3; }, function (v) { return $f09443988f46afe0$export$f9380c9a627682d3 = v; });
$parcel$export(module.exports, "parse", function () { return $f09443988f46afe0$export$98e6a39c04603d36; }, function (v) { return $f09443988f46afe0$export$98e6a39c04603d36 = v; });
$parcel$export(module.exports, "stringify", function () { return $f09443988f46afe0$export$fac44ee5b035f737; }, function (v) { return $f09443988f46afe0$export$fac44ee5b035f737 = v; });
$parcel$export(module.exports, "parseUrl", function () { return $f09443988f46afe0$export$7a5253c0f62e0150; }, function (v) { return $f09443988f46afe0$export$7a5253c0f62e0150 = v; });
$parcel$export(module.exports, "stringifyUrl", function () { return $f09443988f46afe0$export$a8c1621ea79325d3; }, function (v) { return $f09443988f46afe0$export$a8c1621ea79325d3 = v; });
$parcel$export(module.exports, "pick", function () { return $f09443988f46afe0$export$357523c63a2253b9; }, function (v) { return $f09443988f46afe0$export$357523c63a2253b9 = v; });
$parcel$export(module.exports, "exclude", function () { return $f09443988f46afe0$export$44c361b8ec72ef7f; }, function (v) { return $f09443988f46afe0$export$44c361b8ec72ef7f = v; });
var $f09443988f46afe0$export$f9380c9a627682d3;
var $f09443988f46afe0$export$98e6a39c04603d36;
var $f09443988f46afe0$export$fac44ee5b035f737;
var $f09443988f46afe0$export$7a5253c0f62e0150;
var $f09443988f46afe0$export$a8c1621ea79325d3;
var $f09443988f46afe0$export$357523c63a2253b9;
var $f09443988f46afe0$export$44c361b8ec72ef7f;
"use strict";

var $3D7b0 = parcelRequire("3D7b0");

var $fHWdY = parcelRequire("fHWdY");

var $dejnV = parcelRequire("dejnV");

var $ktOwS = parcelRequire("ktOwS");
const $f09443988f46afe0$var$isNullOrUndefined = (value)=>value === null || value === undefined;
const $f09443988f46afe0$var$encodeFragmentIdentifier = Symbol("encodeFragmentIdentifier");
function $f09443988f46afe0$var$encoderForArrayFormat(options) {
    switch(options.arrayFormat){
        case "index":
            return (key)=>(result, value)=>{
                    const index = result.length;
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                    if (value === null) return [
                        ...result,
                        [
                            $f09443988f46afe0$var$encode(key, options),
                            "[",
                            index,
                            "]"
                        ].join("")
                    ];
                    return [
                        ...result,
                        [
                            $f09443988f46afe0$var$encode(key, options),
                            "[",
                            $f09443988f46afe0$var$encode(index, options),
                            "]=",
                            $f09443988f46afe0$var$encode(value, options)
                        ].join("")
                    ];
                };
        case "bracket":
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                    if (value === null) return [
                        ...result,
                        [
                            $f09443988f46afe0$var$encode(key, options),
                            "[]"
                        ].join("")
                    ];
                    return [
                        ...result,
                        [
                            $f09443988f46afe0$var$encode(key, options),
                            "[]=",
                            $f09443988f46afe0$var$encode(value, options)
                        ].join("")
                    ];
                };
        case "colon-list-separator":
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                    if (value === null) return [
                        ...result,
                        [
                            $f09443988f46afe0$var$encode(key, options),
                            ":list="
                        ].join("")
                    ];
                    return [
                        ...result,
                        [
                            $f09443988f46afe0$var$encode(key, options),
                            ":list=",
                            $f09443988f46afe0$var$encode(value, options)
                        ].join("")
                    ];
                };
        case "comma":
        case "separator":
        case "bracket-separator":
            {
                const keyValueSep = options.arrayFormat === "bracket-separator" ? "[]=" : "=";
                return (key)=>(result, value)=>{
                        if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                        // Translate null to an empty string so that it doesn't serialize as 'null'
                        value = value === null ? "" : value;
                        if (result.length === 0) return [
                            [
                                $f09443988f46afe0$var$encode(key, options),
                                keyValueSep,
                                $f09443988f46afe0$var$encode(value, options)
                            ].join("")
                        ];
                        return [
                            [
                                result,
                                $f09443988f46afe0$var$encode(value, options)
                            ].join(options.arrayFormatSeparator)
                        ];
                    };
            }
        default:
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                    if (value === null) return [
                        ...result,
                        $f09443988f46afe0$var$encode(key, options)
                    ];
                    return [
                        ...result,
                        [
                            $f09443988f46afe0$var$encode(key, options),
                            "=",
                            $f09443988f46afe0$var$encode(value, options)
                        ].join("")
                    ];
                };
    }
}
function $f09443988f46afe0$var$parserForArrayFormat(options) {
    let result;
    switch(options.arrayFormat){
        case "index":
            return (key, value, accumulator)=>{
                result = /\[(\d*)\]$/.exec(key);
                key = key.replace(/\[\d*\]$/, "");
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) accumulator[key] = {};
                accumulator[key][result[1]] = value;
            };
        case "bracket":
            return (key, value, accumulator)=>{
                result = /(\[\])$/.exec(key);
                key = key.replace(/\[\]$/, "");
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
        case "colon-list-separator":
            return (key, value, accumulator)=>{
                result = /(:list)$/.exec(key);
                key = key.replace(/:list$/, "");
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
        case "comma":
        case "separator":
            return (key, value, accumulator)=>{
                const isArray = typeof value === "string" && value.includes(options.arrayFormatSeparator);
                const isEncodedArray = typeof value === "string" && !isArray && $f09443988f46afe0$var$decode(value, options).includes(options.arrayFormatSeparator);
                value = isEncodedArray ? $f09443988f46afe0$var$decode(value, options) : value;
                const newValue = isArray || isEncodedArray ? value.split(options.arrayFormatSeparator).map((item)=>$f09443988f46afe0$var$decode(item, options)) : value === null ? value : $f09443988f46afe0$var$decode(value, options);
                accumulator[key] = newValue;
            };
        case "bracket-separator":
            return (key, value, accumulator)=>{
                const isArray = /(\[\])$/.test(key);
                key = key.replace(/\[\]$/, "");
                if (!isArray) {
                    accumulator[key] = value ? $f09443988f46afe0$var$decode(value, options) : value;
                    return;
                }
                const arrayValue = value === null ? [] : value.split(options.arrayFormatSeparator).map((item)=>$f09443988f46afe0$var$decode(item, options));
                if (accumulator[key] === undefined) {
                    accumulator[key] = arrayValue;
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], arrayValue);
            };
        default:
            return (key, value, accumulator)=>{
                if (accumulator[key] === undefined) {
                    accumulator[key] = value;
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
    }
}
function $f09443988f46afe0$var$validateArrayFormatSeparator(value) {
    if (typeof value !== "string" || value.length !== 1) throw new TypeError("arrayFormatSeparator must be single character string");
}
function $f09443988f46afe0$var$encode(value, options) {
    if (options.encode) return options.strict ? $3D7b0(value) : encodeURIComponent(value);
    return value;
}
function $f09443988f46afe0$var$decode(value, options) {
    if (options.decode) return $fHWdY(value);
    return value;
}
function $f09443988f46afe0$var$keysSorter(input) {
    if (Array.isArray(input)) return input.sort();
    if (typeof input === "object") return $f09443988f46afe0$var$keysSorter(Object.keys(input)).sort((a, b)=>Number(a) - Number(b)).map((key)=>input[key]);
    return input;
}
function $f09443988f46afe0$var$removeHash(input) {
    const hashStart = input.indexOf("#");
    if (hashStart !== -1) input = input.slice(0, hashStart);
    return input;
}
function $f09443988f46afe0$var$getHash(url) {
    let hash = "";
    const hashStart = url.indexOf("#");
    if (hashStart !== -1) hash = url.slice(hashStart);
    return hash;
}
function $f09443988f46afe0$var$extract(input) {
    input = $f09443988f46afe0$var$removeHash(input);
    const queryStart = input.indexOf("?");
    if (queryStart === -1) return "";
    return input.slice(queryStart + 1);
}
function $f09443988f46afe0$var$parseValue(value, options) {
    if (options.parseNumbers && !Number.isNaN(Number(value)) && typeof value === "string" && value.trim() !== "") value = Number(value);
    else if (options.parseBooleans && value !== null && (value.toLowerCase() === "true" || value.toLowerCase() === "false")) value = value.toLowerCase() === "true";
    return value;
}
function $f09443988f46afe0$var$parse(query, options) {
    options = Object.assign({
        decode: true,
        sort: true,
        arrayFormat: "none",
        arrayFormatSeparator: ",",
        parseNumbers: false,
        parseBooleans: false
    }, options);
    $f09443988f46afe0$var$validateArrayFormatSeparator(options.arrayFormatSeparator);
    const formatter = $f09443988f46afe0$var$parserForArrayFormat(options);
    // Create an object with no prototype
    const ret = Object.create(null);
    if (typeof query !== "string") return ret;
    query = query.trim().replace(/^[?#&]/, "");
    if (!query) return ret;
    for (const param of query.split("&")){
        if (param === "") continue;
        let [key, value] = $dejnV(options.decode ? param.replace(/\+/g, " ") : param, "=");
        // Missing `=` should be `null`:
        // http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
        value = value === undefined ? null : [
            "comma",
            "separator",
            "bracket-separator"
        ].includes(options.arrayFormat) ? value : $f09443988f46afe0$var$decode(value, options);
        formatter($f09443988f46afe0$var$decode(key, options), value, ret);
    }
    for (const key of Object.keys(ret)){
        const value = ret[key];
        if (typeof value === "object" && value !== null) for (const k of Object.keys(value))value[k] = $f09443988f46afe0$var$parseValue(value[k], options);
        else ret[key] = $f09443988f46afe0$var$parseValue(value, options);
    }
    if (options.sort === false) return ret;
    return (options.sort === true ? Object.keys(ret).sort() : Object.keys(ret).sort(options.sort)).reduce((result, key)=>{
        const value = ret[key];
        if (Boolean(value) && typeof value === "object" && !Array.isArray(value)) // Sort object keys, not values
        result[key] = $f09443988f46afe0$var$keysSorter(value);
        else result[key] = value;
        return result;
    }, Object.create(null));
}
$f09443988f46afe0$export$f9380c9a627682d3 = $f09443988f46afe0$var$extract;
$f09443988f46afe0$export$98e6a39c04603d36 = $f09443988f46afe0$var$parse;
$f09443988f46afe0$export$fac44ee5b035f737 = (object, options)=>{
    if (!object) return "";
    options = Object.assign({
        encode: true,
        strict: true,
        arrayFormat: "none",
        arrayFormatSeparator: ","
    }, options);
    $f09443988f46afe0$var$validateArrayFormatSeparator(options.arrayFormatSeparator);
    const shouldFilter = (key)=>options.skipNull && $f09443988f46afe0$var$isNullOrUndefined(object[key]) || options.skipEmptyString && object[key] === "";
    const formatter = $f09443988f46afe0$var$encoderForArrayFormat(options);
    const objectCopy = {};
    for (const key of Object.keys(object))if (!shouldFilter(key)) objectCopy[key] = object[key];
    const keys = Object.keys(objectCopy);
    if (options.sort !== false) keys.sort(options.sort);
    return keys.map((key)=>{
        const value = object[key];
        if (value === undefined) return "";
        if (value === null) return $f09443988f46afe0$var$encode(key, options);
        if (Array.isArray(value)) {
            if (value.length === 0 && options.arrayFormat === "bracket-separator") return $f09443988f46afe0$var$encode(key, options) + "[]";
            return value.reduce(formatter(key), []).join("&");
        }
        return $f09443988f46afe0$var$encode(key, options) + "=" + $f09443988f46afe0$var$encode(value, options);
    }).filter((x)=>x.length > 0).join("&");
};
$f09443988f46afe0$export$7a5253c0f62e0150 = (url, options)=>{
    options = Object.assign({
        decode: true
    }, options);
    const [url_, hash] = $dejnV(url, "#");
    return Object.assign({
        url: url_.split("?")[0] || "",
        query: $f09443988f46afe0$var$parse($f09443988f46afe0$var$extract(url), options)
    }, options && options.parseFragmentIdentifier && hash ? {
        fragmentIdentifier: $f09443988f46afe0$var$decode(hash, options)
    } : {});
};
$f09443988f46afe0$export$a8c1621ea79325d3 = (object, options)=>{
    options = Object.assign({
        encode: true,
        strict: true,
        [$f09443988f46afe0$var$encodeFragmentIdentifier]: true
    }, options);
    const url = $f09443988f46afe0$var$removeHash(object.url).split("?")[0] || "";
    const queryFromUrl = $f09443988f46afe0$export$f9380c9a627682d3(object.url);
    const parsedQueryFromUrl = $f09443988f46afe0$export$98e6a39c04603d36(queryFromUrl, {
        sort: false
    });
    const query = Object.assign(parsedQueryFromUrl, object.query);
    let queryString = $f09443988f46afe0$export$fac44ee5b035f737(query, options);
    if (queryString) queryString = `?${queryString}`;
    let hash = $f09443988f46afe0$var$getHash(object.url);
    if (object.fragmentIdentifier) hash = `#${options[$f09443988f46afe0$var$encodeFragmentIdentifier] ? $f09443988f46afe0$var$encode(object.fragmentIdentifier, options) : object.fragmentIdentifier}`;
    return `${url}${queryString}${hash}`;
};
$f09443988f46afe0$export$357523c63a2253b9 = (input, filter, options)=>{
    options = Object.assign({
        parseFragmentIdentifier: true,
        [$f09443988f46afe0$var$encodeFragmentIdentifier]: false
    }, options);
    const { url: url, query: query, fragmentIdentifier: fragmentIdentifier } = $f09443988f46afe0$export$7a5253c0f62e0150(input, options);
    return $f09443988f46afe0$export$a8c1621ea79325d3({
        url: url,
        query: $ktOwS(query, filter),
        fragmentIdentifier: fragmentIdentifier
    }, options);
};
$f09443988f46afe0$export$44c361b8ec72ef7f = (input, filter, options)=>{
    const exclusionFilter = Array.isArray(filter) ? (key)=>!filter.includes(key) : (key, value)=>!filter(key, value);
    return $f09443988f46afe0$export$357523c63a2253b9(input, exclusionFilter, options);
};

});
parcelRegister("3D7b0", function(module, exports) {
"use strict";
module.exports = (str)=>encodeURIComponent(str).replace(/[!'()*]/g, (x)=>`%${x.charCodeAt(0).toString(16).toUpperCase()}`);

});

parcelRegister("fHWdY", function(module, exports) {
"use strict";
var $b6f80952369f3352$var$token = "%[a-f0-9]{2}";
var $b6f80952369f3352$var$singleMatcher = new RegExp("(" + $b6f80952369f3352$var$token + ")|([^%]+?)", "gi");
var $b6f80952369f3352$var$multiMatcher = new RegExp("(" + $b6f80952369f3352$var$token + ")+", "gi");
function $b6f80952369f3352$var$decodeComponents(components, split) {
    try {
        // Try to decode the entire string first
        return [
            decodeURIComponent(components.join(""))
        ];
    } catch (err) {
    // Do nothing
    }
    if (components.length === 1) return components;
    split = split || 1;
    // Split the array in 2 parts
    var left = components.slice(0, split);
    var right = components.slice(split);
    return Array.prototype.concat.call([], $b6f80952369f3352$var$decodeComponents(left), $b6f80952369f3352$var$decodeComponents(right));
}
function $b6f80952369f3352$var$decode(input) {
    try {
        return decodeURIComponent(input);
    } catch (err) {
        var tokens = input.match($b6f80952369f3352$var$singleMatcher) || [];
        for(var i = 1; i < tokens.length; i++){
            input = $b6f80952369f3352$var$decodeComponents(tokens, i).join("");
            tokens = input.match($b6f80952369f3352$var$singleMatcher) || [];
        }
        return input;
    }
}
function $b6f80952369f3352$var$customDecodeURIComponent(input) {
    // Keep track of all the replacements and prefill the map with the `BOM`
    var replaceMap = {
        "%FE%FF": "\uFFFD\uFFFD",
        "%FF%FE": "\uFFFD\uFFFD"
    };
    var match = $b6f80952369f3352$var$multiMatcher.exec(input);
    while(match){
        try {
            // Decode as big chunks as possible
            replaceMap[match[0]] = decodeURIComponent(match[0]);
        } catch (err) {
            var result = $b6f80952369f3352$var$decode(match[0]);
            if (result !== match[0]) replaceMap[match[0]] = result;
        }
        match = $b6f80952369f3352$var$multiMatcher.exec(input);
    }
    // Add `%C2` at the end of the map to make sure it does not replace the combinator before everything else
    replaceMap["%C2"] = "\uFFFD";
    var entries = Object.keys(replaceMap);
    for(var i = 0; i < entries.length; i++){
        // Replace all decoded components
        var key = entries[i];
        input = input.replace(new RegExp(key, "g"), replaceMap[key]);
    }
    return input;
}
module.exports = function(encodedURI) {
    if (typeof encodedURI !== "string") throw new TypeError("Expected `encodedURI` to be of type `string`, got `" + typeof encodedURI + "`");
    try {
        encodedURI = encodedURI.replace(/\+/g, " ");
        // Try the built in decoder first
        return decodeURIComponent(encodedURI);
    } catch (err) {
        // Fallback to a more advanced decoder
        return $b6f80952369f3352$var$customDecodeURIComponent(encodedURI);
    }
};

});

parcelRegister("dejnV", function(module, exports) {
"use strict";
module.exports = (string, separator)=>{
    if (!(typeof string === "string" && typeof separator === "string")) throw new TypeError("Expected the arguments to be of type `string`");
    if (separator === "") return [
        string
    ];
    const separatorIndex = string.indexOf(separator);
    if (separatorIndex === -1) return [
        string
    ];
    return [
        string.slice(0, separatorIndex),
        string.slice(separatorIndex + separator.length)
    ];
};

});

parcelRegister("ktOwS", function(module, exports) {
"use strict";
module.exports = function(obj, predicate) {
    var ret = {};
    var keys = Object.keys(obj);
    var isArr = Array.isArray(predicate);
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        var val = obj[key];
        if (isArr ? predicate.indexOf(key) !== -1 : predicate(key, val, obj)) ret[key] = val;
    }
    return ret;
};

});



parcelRegister("jg1lX", function(module, exports) {

var $eeH7J = parcelRequire("eeH7J");
function $e0508fa916efea46$export$69f38700ea0cb3b9(value, milliseconds, shouldDelay) {
    const [delayedValue, setDelayedValue] = (0, $eeH7J.useState)(value);
    (0, $eeH7J.useEffect)(()=>{
        if (delayedValue !== value) {
            if (!shouldDelay || shouldDelay(value)) setTimeout(()=>setDelayedValue(value), milliseconds);
            else setDelayedValue(value);
        }
    }, [
        value
    ]);
    return !shouldDelay || shouldDelay(value) ? delayedValue : value;
}

});

parcelRegister("eK8Q4", function(module, exports) {

$parcel$export(module.exports, "usePreference", function () { return $abbc37c23b102598$export$e74c857c8e0242d6; });
$parcel$export(module.exports, "useSessionState", function () { return $abbc37c23b102598$export$8898ce2744bba29f; });

var $eeH7J = parcelRequire("eeH7J");

var $lDBHC = parcelRequire("lDBHC");
function $abbc37c23b102598$export$e74c857c8e0242d6(settingName, defaultValue, /**
 * The storage to use. Defaults to `localStorage`.
 */ storageClass) {
    if ((0, $lDBHC.IsNode)()) return (0, $eeH7J.useState)(defaultValue);
    const storage = storageClass !== null && storageClass !== void 0 ? storageClass : localStorage;
    const key = `user-preference[${settingName}]`;
    const item = storage.getItem(key);
    let value = defaultValue;
    if (typeof item === "string") try {
        value = JSON.parse(item);
    } catch (e) {
    // Invalid JSON, ignore and use default value
    }
    const [version, setVersion] = (0, $eeH7J.useState)({}); // Used to invalidate
    if (JSON.stringify(value) === JSON.stringify(defaultValue)) storage.removeItem(key);
    function setValue(v) {
        if (JSON.stringify(v) !== storage.getItem(key)) {
            if (JSON.stringify(v) === JSON.stringify(defaultValue)) storage.removeItem(key);
            else storage.setItem(key, JSON.stringify(v));
            setVersion({});
        }
    }
    (0, $eeH7J.useEffect)(()=>{
        function onStorage(e) {
            if (e.key === key) {
                if (e.newValue !== JSON.stringify(value)) setVersion({});
            }
        }
        window.addEventListener("storage", onStorage);
        return ()=>window.removeEventListener("storage", onStorage);
    }, [
        key,
        value
    ]);
    return [
        value,
        setValue
    ];
}
function $abbc37c23b102598$export$8898ce2744bba29f(key, defaultValue) {
    return $abbc37c23b102598$export$e74c857c8e0242d6(key, defaultValue, (0, $lDBHC.IsNode)() ? undefined : sessionStorage);
}

});

parcelRegister("cCNWd", function(module, exports) {

$parcel$export(module.exports, "useStateContainer", function () { return $930fc549b97c0fee$export$352ab317a531d821; });

var $eeH7J = parcelRequire("eeH7J");
function $930fc549b97c0fee$export$352ab317a531d821(/** A function that creates the state container. Will be called once for the lifetime of the
 * component. Returns an object that reflects a piece of state. */ create) {
    const [, setVersion] = (0, $eeH7J.useState)({});
    const [state, setState] = (0, $eeH7J.useState)();
    (0, $eeH7J.useEffect)(()=>{
        const sc = create(()=>setVersion({}));
        setState(sc);
        return ()=>{
            var _a;
            (_a = sc.destroy) === null || _a === void 0 || _a.call(sc);
        };
    }, // Intentional empty dependency array, we want this effect to run
    // EXACTLY once when the component is mounted/unmounted.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    return state;
}

});


parcelRegister("53syj", function(module, exports) {

$parcel$export(module.exports, "ErrorView", function () { return $3ae361799af923ca$export$8c68b6013ae44ca6; });

var $4vwom = parcelRequire("4vwom");

var $eeH7J = parcelRequire("eeH7J");

var $k6E9r = parcelRequire("k6E9r");

var $ikBJm = parcelRequire("ikBJm");

var $8h5s0 = parcelRequire("8h5s0");

var $cwhCA = parcelRequire("cwhCA");

var $7m9cQ = parcelRequire("7m9cQ");

var $3pEVp = parcelRequire("3pEVp");

var $fT6Pt = parcelRequire("fT6Pt");

var $9Q5xE = parcelRequire("9Q5xE");
function $3ae361799af923ca$export$8c68b6013ae44ca6({ error: error }) {
    var _a, _b, _c, _d;
    const modal = (0, $eeH7J.useContext)((0, $ikBJm.ModalContext));
    let body = (0, $4vwom.jsx)("table", {
        children: Object.keys(error).map((key)=>(0, $4vwom.jsxs)("tr", {
                children: [
                    (0, $4vwom.jsx)("td", {
                        style: {
                            width: 100
                        },
                        children: (0, $8h5s0.prettyCamel)(key)
                    }),
                    (0, $4vwom.jsx)("td", {
                        children: JSON.stringify(error[key])
                    })
                ]
            }))
    });
    const [details, setDetails] = (0, $eeH7J.useState)(false);
    if (error.type === "TSQError") body = (0, $4vwom.jsxs)("div", {
        children: [
            (0, $4vwom.jsx)("div", {
                children: error.detail
            }),
            (0, $4vwom.jsxs)("div", {
                style: {
                    fontFamily: "monospace",
                    backgroundColor: (0, $9Q5xE.ColorStyles).error[400],
                    marginTop: "1rem",
                    marginBottom: "1rem"
                },
                children: [
                    (0, $4vwom.jsx)("span", {
                        children: (_a = error.code) === null || _a === void 0 ? void 0 : _a.substr(0, error.start.character + 1)
                    }),
                    (0, $4vwom.jsx)("span", {
                        style: {
                            backgroundColor: (0, $9Q5xE.ColorStyles).error[400]
                        },
                        children: (_b = error.code) === null || _b === void 0 ? void 0 : _b.substr(error.start.character + 1, error.end.character - error.start.character)
                    }),
                    (0, $4vwom.jsx)("span", {
                        children: (_c = error.code) === null || _c === void 0 ? void 0 : _c.substr(error.end.character)
                    })
                ]
            }),
            details ? body : (0, $4vwom.jsx)((0, $4vwom.Fragment), {}),
            (0, $4vwom.jsxs)((0, $fT6Pt.RButton), {
                onClick: ()=>setDetails(!details),
                children: [
                    details ? "Hide" : "Show",
                    " details"
                ]
            })
        ]
    });
    const infoCard = (0, $4vwom.jsxs)((0, $k6E9r.default), {
        style: {
            margin: "4rem"
        },
        children: [
            (0, $4vwom.jsx)((0, $k6E9r.default).Header, {
                children: error.type
            }),
            (0, $4vwom.jsx)((0, $k6E9r.default).Body, {
                children: body
            })
        ]
    });
    if (error.status === 401) {
        // Waiting to be redirected to login page
        const smallLogo = (_d = (0, $cwhCA.GetReflectionInfo)().model.logo) === null || _d === void 0 ? void 0 : _d.smallPath;
        if (smallLogo) return (0, $4vwom.jsx)("div", {
            style: {
                width: "100%",
                height: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center"
            },
            children: (0, $4vwom.jsx)("img", {
                src: `${(0, $7m9cQ.server)()}${smallLogo}`
            })
        });
        else return (0, $4vwom.jsx)((0, $3pEVp.Busy), {
            backgroundColor: "white"
        });
    }
    return (0, $4vwom.jsx)("div", {
        style: {
            margin: "4rem",
            backgroundColor: "white",
            border: "1px solid #ddd",
            borderRadius: 8,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column"
        },
        children: error.status === 403 ? (0, $4vwom.jsxs)((0, $4vwom.Fragment), {
            children: [
                (0, $4vwom.jsxs)("div", {
                    style: {
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "center",
                        padding: 32,
                        paddingTop: 64,
                        alignItems: "center"
                    },
                    children: [
                        (0, $4vwom.jsx)("i", {
                            className: "fas fa-user-shield",
                            style: {
                                fontSize: 50,
                                paddingRight: 32,
                                color: (0, $9Q5xE.ColorStyles).error[400]
                            }
                        }),
                        (0, $4vwom.jsxs)("div", {
                            style: {
                                flexDirection: "column",
                                alignContent: "center",
                                alignItems: "center",
                                justifyItems: "center",
                                justifyContent: "center"
                            },
                            children: [
                                (0, $4vwom.jsx)("div", {
                                    style: {
                                        fontSize: 24,
                                        fontWeight: 500,
                                        color: (0, $9Q5xE.ColorStyles).error[800]
                                    },
                                    children: "You need permission to do this."
                                }),
                                (0, $4vwom.jsx)("div", {
                                    style: {
                                        fontSize: 20,
                                        fontWeight: 400,
                                        color: (0, $9Q5xE.ColorStyles).gray[600]
                                    },
                                    children: "Contact an administrator to request permission."
                                })
                            ]
                        })
                    ]
                }),
                modal ? (0, $4vwom.jsx)((0, $fT6Pt.RButton), {
                    variant: "primary",
                    onClick: ()=>modal.close(undefined),
                    children: "Close"
                }) : undefined,
                infoCard
            ]
        }) : infoCard
    });
}

});
parcelRegister("k6E9r", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ea338365c64f8cd1$export$2e2bcd8739ae039; });

var $h4XE0 = parcelRequire("h4XE0");

var $fbOaB = parcelRequire("fbOaB");

var $aienp = parcelRequire("aienp");

var $eeH7J = parcelRequire("eeH7J");

var $57SUk = parcelRequire("57SUk");

var $b3Riz = parcelRequire("b3Riz");

var $4xdRr = parcelRequire("4xdRr");

var $go4DJ = parcelRequire("go4DJ");

var $gXOE3 = parcelRequire("gXOE3");
var $ea338365c64f8cd1$var$_excluded = [
    "bsPrefix",
    "className",
    "bg",
    "text",
    "border",
    "body",
    "children",
    "as"
];
var $ea338365c64f8cd1$var$DivStyledAsH5 = (0, $4xdRr.default)("h5");
var $ea338365c64f8cd1$var$DivStyledAsH6 = (0, $4xdRr.default)("h6");
var $ea338365c64f8cd1$var$CardBody = (0, $b3Riz.default)("card-body");
var $ea338365c64f8cd1$var$CardTitle = (0, $b3Riz.default)("card-title", {
    Component: $ea338365c64f8cd1$var$DivStyledAsH5
});
var $ea338365c64f8cd1$var$CardSubtitle = (0, $b3Riz.default)("card-subtitle", {
    Component: $ea338365c64f8cd1$var$DivStyledAsH6
});
var $ea338365c64f8cd1$var$CardLink = (0, $b3Riz.default)("card-link", {
    Component: "a"
});
var $ea338365c64f8cd1$var$CardText = (0, $b3Riz.default)("card-text", {
    Component: "p"
});
var $ea338365c64f8cd1$var$CardHeader = (0, $b3Riz.default)("card-header");
var $ea338365c64f8cd1$var$CardFooter = (0, $b3Riz.default)("card-footer");
var $ea338365c64f8cd1$var$CardImgOverlay = (0, $b3Riz.default)("card-img-overlay");
var $ea338365c64f8cd1$var$defaultProps = {
    body: false
};
var $ea338365c64f8cd1$var$Card = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).forwardRef(function(_ref, ref) {
    var bsPrefix = _ref.bsPrefix, className = _ref.className, bg = _ref.bg, text = _ref.text, border = _ref.border, body = _ref.body, children = _ref.children, _ref$as = _ref.as, Component = _ref$as === void 0 ? "div" : _ref$as, props = (0, $fbOaB.default)(_ref, $ea338365c64f8cd1$var$_excluded);
    var prefix = (0, $57SUk.useBootstrapPrefix)(bsPrefix, "card");
    var cardContext = (0, $eeH7J.useMemo)(function() {
        return {
            cardHeaderBsPrefix: prefix + "-header"
        };
    }, [
        prefix
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $go4DJ.default).Provider, {
        value: cardContext
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement(Component, (0, $h4XE0.default)({
        ref: ref
    }, props, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($aienp)))(className, prefix, bg && "bg-" + bg, text && "text-" + text, border && "border-" + border)
    }), body ? /*#__PURE__*/ // @ts-ignore
    (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement($ea338365c64f8cd1$var$CardBody, null, children) : children));
});
$ea338365c64f8cd1$var$Card.displayName = "Card";
$ea338365c64f8cd1$var$Card.defaultProps = $ea338365c64f8cd1$var$defaultProps;
$ea338365c64f8cd1$var$Card.Img = (0, $gXOE3.default);
$ea338365c64f8cd1$var$Card.Title = $ea338365c64f8cd1$var$CardTitle;
$ea338365c64f8cd1$var$Card.Subtitle = $ea338365c64f8cd1$var$CardSubtitle;
$ea338365c64f8cd1$var$Card.Body = $ea338365c64f8cd1$var$CardBody;
$ea338365c64f8cd1$var$Card.Link = $ea338365c64f8cd1$var$CardLink;
$ea338365c64f8cd1$var$Card.Text = $ea338365c64f8cd1$var$CardText;
$ea338365c64f8cd1$var$Card.Header = $ea338365c64f8cd1$var$CardHeader;
$ea338365c64f8cd1$var$Card.Footer = $ea338365c64f8cd1$var$CardFooter;
$ea338365c64f8cd1$var$Card.ImgOverlay = $ea338365c64f8cd1$var$CardImgOverlay;
var $ea338365c64f8cd1$export$2e2bcd8739ae039 = $ea338365c64f8cd1$var$Card;

});
parcelRegister("4xdRr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $34d4fefef4be980b$export$2e2bcd8739ae039; });

var $h4XE0 = parcelRequire("h4XE0");

var $eeH7J = parcelRequire("eeH7J");

var $aienp = parcelRequire("aienp");
var $34d4fefef4be980b$export$2e2bcd8739ae039 = function(className) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).forwardRef(function(p, ref) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", (0, $h4XE0.default)({}, p, {
            ref: ref,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($aienp)))(p.className, className)
        }));
    });
};

});

parcelRegister("go4DJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bee27ca19ba4ba36$export$2e2bcd8739ae039; });

var $eeH7J = parcelRequire("eeH7J");
var $bee27ca19ba4ba36$var$context = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createContext(null);
$bee27ca19ba4ba36$var$context.displayName = "CardContext";
var $bee27ca19ba4ba36$export$2e2bcd8739ae039 = $bee27ca19ba4ba36$var$context;

});

parcelRegister("gXOE3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c59971142cfebfaf$export$2e2bcd8739ae039; });

var $h4XE0 = parcelRequire("h4XE0");

var $fbOaB = parcelRequire("fbOaB");

var $aienp = parcelRequire("aienp");

var $eeH7J = parcelRequire("eeH7J");

var $57SUk = parcelRequire("57SUk");
var $c59971142cfebfaf$var$_excluded = [
    "bsPrefix",
    "className",
    "variant",
    "as"
];
var $c59971142cfebfaf$var$defaultProps = {
    variant: null
};
var $c59971142cfebfaf$var$CardImg = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).forwardRef(function(_ref, ref) {
    var bsPrefix = _ref.bsPrefix, className = _ref.className, variant = _ref.variant, _ref$as = _ref.as, Component = _ref$as === void 0 ? "img" : _ref$as, props = (0, $fbOaB.default)(_ref, $c59971142cfebfaf$var$_excluded);
    var prefix = (0, $57SUk.useBootstrapPrefix)(bsPrefix, "card-img");
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement(Component, (0, $h4XE0.default)({
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($aienp)))(variant ? prefix + "-" + variant : prefix, className)
    }, props));
});
$c59971142cfebfaf$var$CardImg.displayName = "CardImg";
$c59971142cfebfaf$var$CardImg.defaultProps = $c59971142cfebfaf$var$defaultProps;
var $c59971142cfebfaf$export$2e2bcd8739ae039 = $c59971142cfebfaf$var$CardImg;

});


parcelRegister("3pEVp", function(module, exports) {

$parcel$export(module.exports, "Busy", function () { return $27c373b767a5f315$export$ff95fabeea2e966a; });

var $4vwom = parcelRequire("4vwom");
parcelRequire("eeH7J");

var $1rVia = parcelRequire("1rVia");
function $27c373b767a5f315$export$ff95fabeea2e966a(props) {
    return (0, $4vwom.jsx)("div", {
        style: {
            width: "100%",
            height: "100%",
            display: "flex",
            alignItems: "center",
            backgroundColor: props.backgroundColor
        },
        children: (0, $4vwom.jsx)((0, $1rVia.default), {
            style: {
                margin: "0 auto"
            },
            animation: "border"
        })
    });
}

});



parcelRegister("2CKKq", function(module, exports) {

$parcel$export(module.exports, "TableWidget", function () { return $1e93648432c98720$export$cb28d834c1ef6d6a; });

var $lhaLc = parcelRequire("lhaLc");

var $4vwom = parcelRequire("4vwom");

var $eeH7J = parcelRequire("eeH7J");

var $cniWT = parcelRequire("cniWT");

var $8h5s0 = parcelRequire("8h5s0");

var $fT6Pt = parcelRequire("fT6Pt");

var $dUDPg = parcelRequire("dUDPg");

var $fz3r9 = parcelRequire("fz3r9");

var $8vTN8 = parcelRequire("8vTN8");

var $cSf8f = parcelRequire("cSf8f");

var $ikBJm = parcelRequire("ikBJm");

var $3aX8U = parcelRequire("3aX8U");

var $bUDfc = parcelRequire("bUDfc");

var $8IeBr = parcelRequire("8IeBr");

var $9AQ2B = parcelRequire("9AQ2B");

var $hV5w0 = parcelRequire("hV5w0");

var $4rY0U = parcelRequire("4rY0U");

var $7iytm = parcelRequire("7iytm");

var $9Q5xE = parcelRequire("9Q5xE");

var $aIeEI = parcelRequire("aIeEI");

var $1TOtF = parcelRequire("1TOtF");

var $kHZ99 = parcelRequire("kHZ99");

var $6sp4J = parcelRequire("6sp4J");

var $5fzQ8 = parcelRequire("5fzQ8");

var $1Elc1 = parcelRequire("1Elc1");

var $efVcO = parcelRequire("efVcO");
parcelRequire("jniej");
var $eK8Q4 = parcelRequire("eK8Q4");

var $1rVia = parcelRequire("1rVia");
(0, $4rY0U.RegisterWidget)("Table", ({ value: value, isRoot: isRoot })=>(0, $4vwom.jsx)($1e93648432c98720$export$cb28d834c1ef6d6a, Object.assign({}, value, {
        isRoot: isRoot
    })));
const $1e93648432c98720$var$headerBg = "rgb(249, 250, 251)";
const $1e93648432c98720$var$headerFg = "rgb(102, 112, 133)";
const $1e93648432c98720$var$hairline = (0, $9Q5xE.ColorStyles).gray[200];
const $1e93648432c98720$var$buttonStyle = {
    border: `1px solid ${(0, $9Q5xE.ColorStyles).gray[300]}`,
    fontSize: 14,
    boxShadow: "0px 1px 2px 0px #1018280D"
};
const $1e93648432c98720$var$smallButtonStyle = Object.assign(Object.assign({}, $1e93648432c98720$var$buttonStyle), {
    paddingTop: 8,
    paddingBottom: 8,
    paddingLeft: 14,
    paddingRight: 14
});
const $1e93648432c98720$var$getColumnKey = (c)=>typeof c === "string" ? c : c.name;
function $1e93648432c98720$export$cb28d834c1ef6d6a(props) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
    const localize = (0, $aIeEI.useLocalize)();
    // Drag-and-drop import support
    const performAction = (0, $hV5w0.usePerformWidgetAction)();
    const { refresh: refresh } = (0, $eeH7J.useContext)((0, $hV5w0.WidgetContext));
    const supportsFileDrop = !!(((_a = props.methods) === null || _a === void 0 ? void 0 : _a.includes("onFileDropped")) || ((_b = props.methods) === null || _b === void 0 ? void 0 : _b.includes("onFileUploaded")));
    const { modal: modal, showModal: showModal } = (0, $ikBJm.useContextualModal)();
    const onDrop = (0, $eeH7J.useCallback)(async (acceptedFiles)=>{
        var _a;
        if (acceptedFiles.length !== 1) {
            alert("Please drop only one file at a time");
            return;
        }
        const widgetKey = props.widgetKey;
        if (!widgetKey) {
            alert("Cannot drop file on a widget without a widgetKey");
            return;
        }
        const file = acceptedFiles[0];
        if (props.folder) {
            const fileId = await (0, $7iytm.UploadFile)(props.folder, file, file.type, false, "FolderDefault", file.name);
            try {
                await performAction(widgetKey, "onFileUploaded", [
                    fileId,
                    undefined /*TODO: support _droptarget */ 
                ]);
                await refresh();
            } catch (e) {
                alert(e.detail);
            }
        } else if ((_a = props.methods) === null || _a === void 0 ? void 0 : _a.includes("onFileDropped")) {
            if (!props.fileDropMethods) {
                alert("Widget has onFileDropped method but no fileDropMethods");
                return;
            }
            const reader = new FileReader();
            reader.onload = async function(e) {
                var _a;
                const content = (_a = e.target) === null || _a === void 0 ? void 0 : _a.result;
                const fileDropMethod = await (0, $ikBJm.Modal)((close)=>{
                    var _a;
                    return (0, $4vwom.jsxs)("div", {
                        style: {
                            backgroundColor: "#fff",
                            borderRadius: 8,
                            padding: 32
                        },
                        children: [
                            "Select method to use:",
                            (_a = props.fileDropMethods) === null || _a === void 0 ? void 0 : _a.map((fdm)=>(0, $4vwom.jsx)((0, $fT6Pt.RButton), {
                                    onClick: ()=>close(fdm.id),
                                    style: {
                                        marginTop: 12,
                                        marginBottom: 12,
                                        minWidth: 400,
                                        maxWidth: 600,
                                        border: `1px solid ${(0, $9Q5xE.ColorStyles).gray[200]}`
                                    },
                                    children: (0, $4vwom.jsxs)("div", {
                                        style: {
                                            display: "flex",
                                            flexDirection: "column"
                                        },
                                        children: [
                                            (0, $4vwom.jsx)("div", {
                                                style: {
                                                    fontWeight: "bold"
                                                },
                                                children: fdm.name
                                            }),
                                            (0, $4vwom.jsx)("div", {
                                                children: fdm.description
                                            })
                                        ]
                                    })
                                }, fdm.id)),
                            (0, $4vwom.jsx)((0, $fT6Pt.RButton), {
                                onClick: ()=>close(undefined),
                                children: "Cancel"
                            })
                        ]
                    });
                });
                try {
                    await performAction(widgetKey, "onFileDropped", [
                        content,
                        fileDropMethod
                    ]);
                } catch (error) {
                    alert(error.detail);
                }
            };
            reader.readAsText(file);
        }
    }, []);
    const { getRootProps: getRootProps, getInputProps: getInputProps, isDragActive: isDragActive } = (0, $cniWT.useDropzone)({
        onDrop: onDrop,
        noClick: true
    });
    const dropProps = supportsFileDrop ? getRootProps() : undefined;
    const dropInputProps = supportsFileDrop ? getInputProps() : undefined;
    const { rows: rows, extraRows: extraRows } = props;
    const widths = new Map();
    props.rows.forEach((row)=>{
        Object.keys(row).forEach((key)=>{
            const widget = row[key];
            if ((0, $bUDfc.IsWidgetBase)(widget)) {
                if (widget.width !== undefined) widths.set(key, widget.width);
            }
        });
    });
    const wc = (0, $eeH7J.useContext)((0, $hV5w0.WidgetContext));
    const [rawColumns, setRawColumns] = (0, $hV5w0.useWidgetState)(props.stateKey, "rawColumns", []);
    const [hiddenColumns, setHiddenColumns] = (0, $hV5w0.useWidgetState)(props.stateKey, "hiddenColumns", []);
    const nonPanelColumns = props.columns.filter((p)=>{
        const key = typeof p === "string" ? p : p.name;
        return !rows.some((r)=>{
            var _a;
            return r[key] && typeof r[key] === "object" && ((_a = r[key]) === null || _a === void 0 ? void 0 : _a.type) === "TablePanel";
        });
    });
    const [orderBy, setOrderBy] = (0, $hV5w0.useQueryWidgetState)(props.stateKey, "orderBy", "", props.isPageMaster, props.disableQuery);
    const [orderMode, setOrderMode] = (0, $hV5w0.useQueryWidgetState)(props.stateKey, "orderMode", "ascending", props.isPageMaster, props.disableQuery);
    const [filters, setFilters] = (0, $hV5w0.useWidgetState)(props.stateKey, "filters", []);
    const removedFilters = filters.filter((f)=>{
        var _a;
        return !((_a = props.filters) === null || _a === void 0 ? void 0 : _a.some((x)=>x.id === f.id));
    });
    // Remove filters that are no longer available
    (0, $eeH7J.useEffect)(()=>{
        if (removedFilters.length > 0) setFilters(filters.filter((f)=>!removedFilters.some((rf)=>rf.id === f.id)));
    }, [
        JSON.stringify([
            props.filters,
            filters
        ])
    ]);
    const orderByOptions = [
        ...props.extraOrderByColumns,
        ...props.colProps
    ];
    const orderByPicker = (0, $4vwom.jsx)((0, $fT6Pt.RButton), {
        style: Object.assign(Object.assign({}, $1e93648432c98720$var$buttonStyle), {
            marginRight: 12
        }),
        popup: (close)=>(0, $4vwom.jsxs)("div", {
                children: [
                    (0, $4vwom.jsxs)("div", {
                        style: {
                            display: "flex",
                            flexDirection: "row"
                        },
                        children: [
                            (0, $4vwom.jsx)((0, $fT6Pt.RButton), {
                                active: orderMode === "ascending",
                                onClick: ()=>{
                                    setOrderMode("ascending");
                                    close();
                                },
                                children: (0, $cSf8f.Strings).Ascending
                            }),
                            (0, $4vwom.jsx)((0, $fT6Pt.RButton), {
                                active: orderMode === "descending",
                                onClick: ()=>{
                                    setOrderMode("descending");
                                    close();
                                },
                                children: (0, $cSf8f.Strings).Descending
                            })
                        ]
                    }),
                    (0, $4vwom.jsx)("div", {
                        style: {
                            height: 1,
                            backgroundColor: $1e93648432c98720$var$hairline,
                            margin: "0.5rem"
                        }
                    }),
                    orderByOptions.map((x)=>(0, $4vwom.jsx)((0, $fT6Pt.RButton), {
                            active: orderBy === x.name,
                            onClick: ()=>{
                                if (orderBy === x.name) setOrderBy("");
                                else setOrderBy(x.name);
                                close();
                            },
                            children: (0, $cSf8f.ClientSideLocalize)(x.displayName)
                        }, x.name))
                ]
            }),
        children: (0, $cSf8f.Strings)["Order by"] + (orderBy ? " " + (0, $8h5s0.lowercaseFirstLetter)((0, $cSf8f.ClientSideLocalize)((_d = (_c = orderByOptions.find((x)=>x.name === orderBy)) === null || _c === void 0 ? void 0 : _c.displayName) !== null && _d !== void 0 ? _d : {
            en: (0, $8h5s0.prettyCamel)(orderBy)
        })) + (orderMode === "ascending" ? ` (${(0, $cSf8f.Strings).ascending})` : ` (${(0, $cSf8f.Strings).descending})`) : "")
    });
    const [pageIndex, setPageIndex] = (0, $hV5w0.useQueryWidgetState)(props.stateKey, "pageIndex", 0, props.isPageMaster, props.disableQuery);
    (0, $eeH7J.useEffect)(()=>{
        if (!props.loading && pageIndex >= props.pageCount) setPageIndex(0);
    }, [
        props.loading,
        props.pageCount,
        pageIndex
    ]);
    const [itemsPerPage, setItemsPerPage] = (0, $hV5w0.useQueryWidgetState)(props.stateKey, "itemsPerPage", props.defaultItemsPerPage, props.isPageMaster, props.disableQuery);
    const [search, setSearch] = (0, $hV5w0.useQueryWidgetState)(props.stateKey, "search", "", props.isPageMaster, props.disableQuery);
    const itemsPerPagePicker = (0, $4vwom.jsx)((0, $fT6Pt.RButton), {
        style: $1e93648432c98720$var$buttonStyle,
        popup: (close)=>(0, $4vwom.jsx)("input", {
                type: "number",
                min: 1,
                max: props.maxItemsPerPage,
                value: itemsPerPage,
                onChange: (e)=>{
                    setItemsPerPage(parseInt(e.target.value));
                }
            }),
        children: itemsPerPage + " " + (0, $cSf8f.Strings)["per page"]
    });
    const collectionName = props.collection;
    const filterPicker = collectionName && (0, $kHZ99.TableWidgetFilters)(localize, props.filters, filters, setFilters, collectionName, refresh);
    const [select, setSelect] = (0, $hV5w0.useWidgetState)(props.stateKey, "select", (_e = props.selectFilters) === null || _e === void 0 ? void 0 : _e.map((sf)=>({
            [sf.name]: []
        })).reduce((a, b)=>Object.assign(Object.assign({}, a), b), {}));
    const [selectedWidgets, setSelectWidgets] = (0, $eeH7J.useState)(()=>{
        var _a;
        return (_a = props.selectFilters) === null || _a === void 0 ? void 0 : _a.map((sf)=>({
                [sf.name]: []
            })).reduce((a, b)=>Object.assign(Object.assign({}, a), b), {});
    });
    const selectFilters = collectionName && ((_f = props.selectFilters) === null || _f === void 0 ? void 0 : _f.map((sf)=>(0, $4vwom.jsx)((0, $fT6Pt.RButton), {
            style: Object.assign(Object.assign({}, $1e93648432c98720$var$buttonStyle), {
                marginLeft: 12
            }),
            popup: (close)=>(0, $4vwom.jsx)((0, $1Elc1.TableSelectFilter), {
                    collectionName: collectionName,
                    columnName: sf.name,
                    selection: select[sf.name],
                    onChange: (newSelection, newWidgets)=>{
                        setSelect(Object.assign(Object.assign({}, select), {
                            [sf.name]: newSelection
                        }));
                        setSelectWidgets(Object.assign(Object.assign({}, selectedWidgets), {
                            [sf.name]: newWidgets
                        }));
                    }
                }),
            children: (0, $4vwom.jsxs)("div", {
                style: {
                    display: "flex",
                    flexDirection: "row"
                },
                children: [
                    localize(sf.displayName),
                    selectedWidgets[sf.name].length === 0 ? "" : selectedWidgets[sf.name].length === 1 ? (0, $4vwom.jsxs)((0, $4vwom.Fragment), {
                        children: [
                            ": ",
                            (0, $4vwom.jsx)((0, $4rY0U.WidgetView), {
                                value: selectedWidgets[sf.name][0]
                            })
                        ]
                    }) : ": (multiple)"
                ]
            })
        }, `select-filter-${sf}`)));
    const searchBox = (0, $4vwom.jsxs)("div", {
        style: {
            position: "relative",
            marginRight: 12
        },
        children: [
            (0, $4vwom.jsx)("div", {
                style: {
                    position: "absolute",
                    top: 9,
                    left: 12,
                    color: (0, $9Q5xE.ColorStyles).gray[500]
                },
                children: (0, $4vwom.jsx)($1e93648432c98720$var$SearchIcon, {})
            }),
            (0, $4vwom.jsx)("input", {
                type: "text",
                placeholder: (0, $cSf8f.Strings).Search,
                value: search,
                onChange: (e)=>setSearch(e.target.value),
                style: {
                    borderColor: (0, $9Q5xE.ColorStyles).gray[300],
                    borderRadius: 8,
                    borderWidth: 1,
                    padding: 10,
                    paddingLeft: 40,
                    fontSize: 16,
                    fontWeight: 400,
                    boxShadow: "0px 1px 2px 0px #1018280D",
                    borderStyle: "solid"
                }
            })
        ]
    });
    const createNewLink = ()=>{
        var _a;
        const query = props.partial ? Object.keys(props.partial).map((key)=>`${key}=${encodeURIComponent(props.partial[key])}`) : [];
        if (props.templateName) query.push(`_template=${props.templateName}`);
        const queryPostfix = query.length ? "?" + query.join("&") : "";
        if (props.createNewLink) return props.createNewLink + queryPostfix;
        return `/studio/${(_a = props.collection) === null || _a === void 0 ? void 0 : _a.toLowerCase()}/new${queryPostfix}`;
    };
    const docCollection = (0, $1TOtF.useDocumentCollection)();
    const docPrimaryKey = (0, $1TOtF.useDocumentPrimaryKey)();
    const propButtons = (_h = (_g = props.buttons) === null || _g === void 0 ? void 0 : _g.slice()) !== null && _h !== void 0 ? _h : [];
    if (docCollection && props.widgetKey && docPrimaryKey) propButtons.unshift({
        type: "Button",
        style: "print",
        text: "Print",
        link: `/print/${docCollection}/${docPrimaryKey}/${props.widgetKey}`
    });
    const partialQuery = props.partial ? "?" + Object.entries(props.partial).map(([key, value])=>`${encodeURIComponent(key)}=${encodeURIComponent(value)}`).reduce((a, b)=>a + "&" + b, "") : "";
    const buttons = (0, $4vwom.jsxs)((0, $4vwom.Fragment), {
        children: [
            props.canRefresh && props.collection && (0, $4vwom.jsx)($1e93648432c98720$var$RefreshButton, {
                refresh: async ()=>{
                    if (props.collection) {
                        await (0, $dUDPg.postDocumentRefresh)(props.collection);
                        await (wc === null || wc === void 0 ? void 0 : wc.refresh());
                    }
                }
            }),
            propButtons.map((b)=>(0, $3aX8U.ButtonWidget)(b)),
            supportsFileDrop && props.hasVisibleUploadButton && (0, $4vwom.jsxs)("label", {
                htmlFor: "upload",
                children: [
                    (0, $4vwom.jsx)((0, $fT6Pt.RButton), {
                        icon: "ui-file-plus-03",
                        hideChevron: true
                    }),
                    (0, $4vwom.jsx)("input", Object.assign({
                        id: "upload"
                    }, dropInputProps))
                ]
            }),
            props.collection && (props.hideAddButton !== undefined ? !props.hideAddButton : props.canInsert) && (0, $4vwom.jsxs)((0, $fT6Pt.RButton), {
                link: props.templates || props.studioTemplates ? undefined : createNewLink(),
                style: {
                    marginLeft: 16
                },
                variant: "primary",
                popupPlacement: "left-start",
                popup: props.templates || props.studioTemplates ? (close)=>{
                    var _a, _b, _c;
                    return (0, $4vwom.jsxs)("div", {
                        style: {
                            padding: 4
                        },
                        children: [
                            (_a = props.templates) === null || _a === void 0 ? void 0 : _a.map((t)=>{
                                var _a, _b, _c;
                                return (0, $4vwom.jsx)((0, $fT6Pt.RButton), {
                                    icon: (_a = t.tags) === null || _a === void 0 ? void 0 : _a.icon,
                                    link: `/studio/${(_b = props.collection) === null || _b === void 0 ? void 0 : _b.toLowerCase()}/new-from-template/${t.name.toLowerCase()}${partialQuery}`,
                                    children: localize(Object.assign({
                                        en: (0, $8h5s0.prettyCamel)(t.name)
                                    }, (_c = t.tags) === null || _c === void 0 ? void 0 : _c.translation))
                                }, t.name);
                            }),
                            (_b = props.studioTemplates) === null || _b === void 0 ? void 0 : _b.map((t)=>{
                                var _a;
                                return (0, $4vwom.jsx)((0, $fT6Pt.RButton), {
                                    icon: t.icon,
                                    link: `/studio/${(_a = props.collection) === null || _a === void 0 ? void 0 : _a.toLowerCase()}/new?studio-template=${t.id}${partialQuery}`,
                                    children: localize(t.name)
                                }, t.id.valueOf());
                            }),
                            (0, $4vwom.jsxs)((0, $fT6Pt.RButton), {
                                icon: "ui-file-plus-01",
                                onClick: close,
                                link: `/studio/${(_c = props.collection) === null || _c === void 0 ? void 0 : _c.toLowerCase()}/new${partialQuery}`,
                                children: [
                                    (0, $cSf8f.Translations).Blank(props.itemNameMetadata),
                                    " ",
                                    props.itemNameLocalized
                                ]
                            })
                        ]
                    });
                } : undefined,
                icon: "ui-plus",
                children: [
                    (0, $cSf8f.Translations).New(props.itemNameMetadata),
                    " ",
                    (0, $8h5s0.lowercaseFirstLetter)((0, $cSf8f.ClientSideLocalize)(props.itemNameMetadata))
                ]
            })
        ]
    });
    const title = props.title || props.collection && (0, $8h5s0.prettyCamel)(props.collection);
    const subTitle = props.subTitle || props.description;
    const titleSection = (0, $4vwom.jsxs)("div", {
        style: {
            padding: 24,
            display: "flex",
            flexDirection: "row"
        },
        children: [
            (0, $4vwom.jsxs)("div", {
                style: {
                    flexDirection: "column",
                    flex: 1
                },
                children: [
                    (0, $4vwom.jsx)("div", {
                        style: {
                            fontSize: 18,
                            fontWeight: 500
                        },
                        children: title
                    }),
                    (0, $4vwom.jsx)("div", {
                        style: {
                            fontSize: 14,
                            fontWeight: 400,
                            color: (0, $9Q5xE.ColorStyles).gray[500]
                        },
                        children: subTitle
                    })
                ]
            }),
            props.titleButtons,
            props.primaryAction && (0, $4vwom.jsx)((0, $fT6Pt.RButton), {
                onClick: props.primaryAction.onClicked,
                style: {
                    marginLeft: 16
                },
                variant: "primary",
                icon: props.primaryAction.icon,
                children: props.primaryAction.text
            }),
            props.hideToolbar && buttons,
            props.widget && (0, $4vwom.jsx)((0, $4rY0U.WidgetView), {
                value: props.widget
            })
        ]
    });
    const hasHeader = true;
    const showTitleSection = !props.isRoot && !props.hideTitle;
    const onRowClicked = ((_j = props.methods) === null || _j === void 0 ? void 0 : _j.includes("onRowClicked")) || props.resolve || props.onRowClicked ? async (r)=>{
        if (props.widgetKey) await performAction(props.widgetKey, "onRowClicked", [
            r
        ]);
        if (props.resolve) props.resolve(r);
        else if (props.onRowClicked) props.onRowClicked(r);
    } : undefined;
    const gridStyle = props.gridTemplateColumns ? {
        display: "grid",
        gridTemplateColumns: props.gridTemplateColumns
    } : undefined;
    const visibleColumns = props.columns.filter((c)=>typeof c === "string" ? !hiddenColumns.includes(c) : !hiddenColumns.includes(c.name));
    let visibleNonPanelColumns = nonPanelColumns.filter((c)=>typeof c === "string" ? !hiddenColumns.includes(c) : !hiddenColumns.includes(c.name));
    // This somewhat convoluted logic makes sure it remembers you preferred
    // position of columns, even if you toggle them on and off
    let [ordering, setOrdering] = (0, $eK8Q4.usePreference)(props.widgetKey + "-column-ordering", visibleNonPanelColumns.map($1e93648432c98720$var$getColumnKey));
    ordering = ordering.filter((x)=>visibleNonPanelColumns.some((c)=>$1e93648432c98720$var$getColumnKey(c) === x));
    visibleNonPanelColumns = [
        ...ordering.map((x)=>(0, $8h5s0.Assert)(visibleNonPanelColumns.find((c)=>$1e93648432c98720$var$getColumnKey(c) === x))),
        ...visibleNonPanelColumns.filter((c)=>!ordering.includes($1e93648432c98720$var$getColumnKey(c)))
    ];
    const rowColumns = [
        ...visibleNonPanelColumns,
        ...visibleColumns.filter((x)=>!visibleNonPanelColumns.some((y)=>$1e93648432c98720$var$getColumnKey(y) === $1e93648432c98720$var$getColumnKey(x)))
    ];
    const body = (0, $4vwom.jsxs)("div", Object.assign({}, dropProps, {
        style: {
            background: "#fff",
            borderColor: $1e93648432c98720$var$hairline,
            borderWidth: 1,
            borderStyle: "solid",
            borderRadius: 8,
            margin: (_k = props.margin) !== null && _k !== void 0 ? _k : 16,
            boxShadow: "0px 2px 4px -2px #1018280F, 0px 4px 8px -2px #1018281A",
            position: "relative"
        },
        children: [
            showTitleSection && titleSection,
            !props.hideToolbar && (0, $4vwom.jsxs)("div", {
                style: {
                    display: "flex",
                    flexDirection: "row",
                    flexWrap: "wrap",
                    borderTop: showTitleSection ? "1px solid" : undefined,
                    borderColor: $1e93648432c98720$var$hairline,
                    padding: 16
                },
                children: [
                    searchBox,
                    orderByPicker,
                    itemsPerPagePicker,
                    filterPicker,
                    selectFilters,
                    (0, $4vwom.jsx)("div", {
                        style: {
                            flex: 1
                        }
                    }),
                    !props.isRoot && buttons
                ]
            }),
            props.studioColumnsError && (0, $4vwom.jsxs)("div", {
                style: {
                    padding: 16,
                    backgroundColor: (0, $9Q5xE.ColorStyles).error[100],
                    color: (0, $9Q5xE.ColorStyles).error[600],
                    borderRadius: 8
                },
                children: [
                    (0, $4vwom.jsx)("b", {
                        children: "There was a problem with displaying the custom columns: "
                    }),
                    props.studioColumnsError
                ]
            }),
            props.filterError && (0, $4vwom.jsxs)("div", {
                style: {
                    padding: 16,
                    backgroundColor: (0, $9Q5xE.ColorStyles).error[100],
                    color: (0, $9Q5xE.ColorStyles).error[600],
                    borderRadius: 8
                },
                children: [
                    (0, $4vwom.jsx)("b", {
                        children: "There was a problem with applying the filters: "
                    }),
                    props.filterError
                ]
            }),
            modal,
            dropInputProps ? (0, $4vwom.jsx)("input", Object.assign({}, dropInputProps)) : undefined,
            isDragActive ? (0, $4vwom.jsxs)("div", {
                style: {
                    position: "absolute",
                    top: 0,
                    left: 0,
                    bottom: 0,
                    right: 0,
                    backgroundColor: "#dddb",
                    borderRadius: 8,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexDirection: "column"
                },
                children: [
                    (0, $4vwom.jsx)("i", {
                        className: "fas fa-file-import",
                        style: {
                            fontSize: 48,
                            color: "#444",
                            marginBottom: 32
                        }
                    }),
                    (0, $4vwom.jsx)("div", {
                        children: "Drop file here to start import"
                    })
                ]
            }) : undefined,
            (0, $4vwom.jsx)((0, $efVcO.DragDropContext), {
                onDragEnd: (result)=>{
                    if (!result.destination) return;
                    const reorder = (list, startIndex, endIndex)=>{
                        const temp = Array.from(list);
                        const [removed] = temp.splice(startIndex, 1);
                        temp.splice(endIndex, 0, removed);
                        return temp;
                    };
                    setOrdering(reorder(visibleNonPanelColumns.map($1e93648432c98720$var$getColumnKey), result.source.index, result.destination.index));
                },
                children: (0, $4vwom.jsxs)("table", {
                    style: {
                        pageBreakInside: "auto",
                        width: "100%",
                        borderCollapse: "separate",
                        borderRadius: 8,
                        borderSpacing: 0
                    },
                    children: [
                        !props.hideColumnHeaders && (0, $4vwom.jsx)("thead", {
                            style: {
                                backgroundColor: $1e93648432c98720$var$headerBg,
                                position: "relative"
                            },
                            children: (0, $4vwom.jsx)((0, $efVcO.Droppable), {
                                droppableId: "droppable",
                                direction: "horizontal",
                                children: (provided)=>(0, $4vwom.jsx)("tr", Object.assign({
                                        ref: provided.innerRef
                                    }, provided.droppableProps, {
                                        style: gridStyle,
                                        children: visibleNonPanelColumns.map((c, i)=>{
                                            const columnName = typeof c === "object" ? c.name : c;
                                            const canSortBy = orderByOptions.some((obo)=>obo.name === columnName);
                                            return (0, $4vwom.jsx)((0, $efVcO.Draggable), {
                                                draggableId: columnName,
                                                index: i,
                                                children: (provided)=>(0, $4vwom.jsx)("th", Object.assign({
                                                        onClick: canSortBy ? ()=>{
                                                            if (orderBy !== columnName) setOrderBy(columnName);
                                                            else {
                                                                if (orderMode === "ascending") setOrderMode("descending");
                                                                if (orderMode === "descending") setOrderMode("ascending");
                                                            }
                                                        } : undefined,
                                                        ref: provided.innerRef
                                                    }, provided.draggableProps, provided.dragHandleProps, {
                                                        style: Object.assign({
                                                            userSelect: "none",
                                                            cursor: canSortBy ? "pointer" : undefined,
                                                            padding: 8,
                                                            paddingLeft: i === 0 ? 24 : 8,
                                                            borderTopLeftRadius: !hasHeader && i === 0 ? 8 : 0,
                                                            borderTopRightRadius: !hasHeader && i === props.columns.length - 1 ? 8 : 0,
                                                            borderTop: "1px solid",
                                                            borderTopColor: $1e93648432c98720$var$hairline,
                                                            borderBottom: "1px solid",
                                                            borderBottomColor: $1e93648432c98720$var$hairline,
                                                            tableLayout: widths.get($1e93648432c98720$var$getColumnKey(c)) !== undefined ? "fixed" : undefined,
                                                            width: widths.get($1e93648432c98720$var$getColumnKey(c)),
                                                            gridColumn: i + 1,
                                                            fontSize: 12,
                                                            color: $1e93648432c98720$var$headerFg,
                                                            fontWeight: 400
                                                        }, provided.draggableProps.style),
                                                        children: (0, $4vwom.jsxs)("div", {
                                                            style: {
                                                                display: "flex",
                                                                flexDirection: "row",
                                                                alignItems: "center",
                                                                justifyContent: "space-between"
                                                            },
                                                            children: [
                                                                (0, $4vwom.jsxs)("div", {
                                                                    children: [
                                                                        typeof c === "string" ? c : localize(c.displayName),
                                                                        canSortBy ? (0, $4vwom.jsx)((0, $6sp4J.Icon), {
                                                                            style: {
                                                                                marginBottom: 2,
                                                                                marginLeft: 4
                                                                            },
                                                                            icon: orderBy === (typeof c === "object" ? c.name : c) ? orderMode === "ascending" ? "ui-chevron-up-double" : "ui-chevron-down-double" : "ui-chevron-selector-vertical",
                                                                            size: 14
                                                                        }) : undefined
                                                                    ]
                                                                }),
                                                                i === visibleNonPanelColumns.length - 1 ? (0, $4vwom.jsx)((0, $fT6Pt.RButton), {
                                                                    style: {
                                                                        padding: 4,
                                                                        marginRight: 10,
                                                                        justifyContent: "flex-end"
                                                                    },
                                                                    icon: "ui-settings-01",
                                                                    color: $1e93648432c98720$var$headerFg,
                                                                    iconSize: 16,
                                                                    hideChevron: true,
                                                                    popup: ()=>(0, $5fzQ8.TableWidgetColumns)(collectionName, props.colProps, nonPanelColumns, rawColumns, setRawColumns, hiddenColumns, setHiddenColumns)
                                                                }) : undefined
                                                            ]
                                                        })
                                                    }), typeof c === "string" ? c : c.name)
                                            }, columnName);
                                        })
                                    }))
                            })
                        }),
                        (0, $4vwom.jsxs)("tbody", {
                            children: [
                                props.error || props.countError ? (0, $4vwom.jsx)("div", {
                                    style: {
                                        padding: 8,
                                        backgroundColor: (0, $9Q5xE.ColorStyles).error[100],
                                        color: (0, $9Q5xE.ColorStyles).error[600]
                                    },
                                    children: (_l = props.error) !== null && _l !== void 0 ? _l : props.countError
                                }) : undefined,
                                props.loading ? (0, $4vwom.jsx)("tr", {
                                    children: (0, $4vwom.jsx)("td", {
                                        colSpan: rowColumns.length,
                                        style: {
                                            height: 240,
                                            textAlign: "center"
                                        },
                                        children: (0, $4vwom.jsx)((0, $1rVia.default), {
                                            animation: "grow"
                                        })
                                    })
                                }) : undefined,
                                rows.map((row, i)=>{
                                    var _a, _b, _c;
                                    return (0, $4vwom.jsx)($1e93648432c98720$var$RowView, {
                                        index: i,
                                        row: row,
                                        collection: props.collection,
                                        columns: rowColumns,
                                        table: props,
                                        isTotal: !!(props.lastRowIsTotal && i === rows.length + ((_a = extraRows === null || extraRows === void 0 ? void 0 : extraRows.length) !== null && _a !== void 0 ? _a : 0) - 1),
                                        gridStyle: gridStyle,
                                        onRowClicked: onRowClicked
                                    }, (_c = (_b = row._primaryKey) === null || _b === void 0 ? void 0 : _b.toString()) !== null && _c !== void 0 ? _c : "row-" + i);
                                }),
                                extraRows === null || extraRows === void 0 ? void 0 : extraRows.map((row, i)=>{
                                    var _a, _b, _c;
                                    return (0, $4vwom.jsx)($1e93648432c98720$var$RowView, {
                                        index: i + rows.length,
                                        row: row,
                                        collection: props.collection,
                                        columns: rowColumns,
                                        table: props,
                                        isTotal: !!(props.lastRowIsTotal && i === rows.length + ((_a = extraRows === null || extraRows === void 0 ? void 0 : extraRows.length) !== null && _a !== void 0 ? _a : 0) - 1),
                                        gridStyle: gridStyle,
                                        onRowClicked: onRowClicked
                                    }, (_c = (_b = row._primaryKey) === null || _b === void 0 ? void 0 : _b.toString()) !== null && _c !== void 0 ? _c : "row-" + i);
                                })
                            ]
                        })
                    ]
                })
            }),
            !props.hidePagingBar && (0, $4vwom.jsxs)("div", {
                style: {
                    borderTop: "1px solid " + $1e93648432c98720$var$hairline,
                    padding: 11,
                    paddingLeft: 24,
                    paddingRight: 24,
                    display: "flex",
                    flexDirection: "row",
                    width: "100%"
                },
                children: [
                    (0, $4vwom.jsx)((0, $fT6Pt.RButton), {
                        disabled: pageIndex <= 0,
                        onClick: ()=>{
                            if (pageIndex > 0) setPageIndex(pageIndex - 1);
                        },
                        style: $1e93648432c98720$var$smallButtonStyle,
                        children: (0, $cSf8f.Strings).Previous
                    }),
                    (0, $4vwom.jsx)("div", {
                        style: {
                            flex: 1,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            fontSize: 14,
                            fontWeight: 400,
                            color: (0, $9Q5xE.ColorStyles).gray[700]
                        },
                        children: props.totalCount === 0 ? search ? (0, $4vwom.jsxs)((0, $4vwom.Fragment), {
                            children: [
                                (0, $cSf8f.Translations).NoItemMatchesTheSearch(props.itemNameLocalized),
                                (0, $4vwom.jsxs)("code", {
                                    style: {
                                        marginLeft: 6,
                                        marginTop: 4
                                    },
                                    children: [
                                        '"',
                                        search,
                                        '"'
                                    ]
                                })
                            ]
                        }) : (0, $4vwom.jsx)((0, $4vwom.Fragment), {
                            children: (0, $cSf8f.Translations).NoItems(props.itemNameLocalized)
                        }) : (0, $4vwom.jsxs)((0, $4vwom.Fragment), {
                            children: [
                                (0, $cSf8f.Translations).ShowingXtoYofZ(props.pageIndex * itemsPerPage + 1, props.rows.length === 1 ? undefined : props.pageIndex * itemsPerPage + props.rows.length, props.totalCount),
                                search ? (0, $4vwom.jsxs)("div", {
                                    style: {
                                        marginLeft: 6
                                    },
                                    children: [
                                        (0, $cSf8f.Strings).matching,
                                        " ",
                                        (0, $4vwom.jsxs)("code", {
                                            children: [
                                                '"',
                                                search,
                                                '"'
                                            ]
                                        })
                                    ]
                                }) : ""
                            ]
                        })
                    }),
                    (0, $4vwom.jsx)((0, $fT6Pt.RButton), {
                        disabled: pageIndex >= props.pageCount - 1,
                        onClick: ()=>{
                            if (pageIndex < props.pageCount - 1) setPageIndex(pageIndex + 1);
                        },
                        style: $1e93648432c98720$var$smallButtonStyle,
                        children: (0, $cSf8f.Strings).Next
                    })
                ]
            })
        ]
    }));
    if (props.isRoot) return (0, $4vwom.jsxs)("div", {
        style: {
            marginLeft: 8,
            marginRight: 8
        },
        children: [
            (0, $4vwom.jsx)((0, $9AQ2B.TitleWidget), {
                title: title || "(untitled)",
                subTitle: subTitle,
                buttons: buttons,
                sticky: true,
                widget: props.widget
            }),
            body
        ]
    });
    return body;
}
function $1e93648432c98720$var$RowView({ index: index, row: row, collection: collection, columns: columns, table: table, isTotal: isTotal, onRowClicked: onRowClicked, gridStyle: gridStyle }) {
    var _a;
    const { hover: hover, hoverProps: hoverProps } = (0, $fz3r9.useHover)();
    const navigate = (0, $8vTN8.useNavigate)();
    const panelColumns = columns.filter((c)=>{
        var _a;
        return ((_a = row[$1e93648432c98720$var$getColumnKey(c)]) === null || _a === void 0 ? void 0 : _a.type) === "TablePanel";
    });
    const regularColumns = columns.filter((c)=>{
        var _a;
        return ((_a = row[$1e93648432c98720$var$getColumnKey(c)]) === null || _a === void 0 ? void 0 : _a.type) !== "TablePanel";
    });
    return (0, $4vwom.jsxs)((0, $8IeBr.DirectionContext).Provider, {
        value: "row",
        children: [
            (0, $lhaLc.createElement)("tr", Object.assign({}, hoverProps, {
                style: Object.assign({
                    backgroundColor: !isTotal && hover ? "#f8f8f8" : undefined,
                    cursor: "pointer",
                    pageBreakInside: "avoid",
                    pageBreakAfter: "auto"
                }, gridStyle),
                key: (_a = row._primaryKey) === null || _a === void 0 ? void 0 : _a.toString(),
                onClick: ()=>{
                    if (onRowClicked) onRowClicked(row);
                    else if (typeof row._link === "string") navigate(`${row._link}`);
                    else if (typeof row._link_new_tab === "string") window.open(`${row._link_new_tab}`);
                    else if (collection && typeof row._primaryKey === "string") navigate(`/studio/${collection.toLowerCase()}/${row._primaryKey}`);
                }
            }), regularColumns.map((c, ci)=>(0, $4vwom.jsx)("td", {
                    style: {
                        pageBreakInside: "avoid",
                        pageBreakAfter: panelColumns.length > 0 ? "avoid" : "auto",
                        padding: 16,
                        paddingLeft: ci === 0 ? 24 : 8,
                        borderTopWidth: index > 0 ? 1 : 0,
                        borderTopStyle: "solid",
                        borderColor: $1e93648432c98720$var$hairline,
                        borderRight: table.columnBorders ? "1px solid " + $1e93648432c98720$var$hairline : undefined,
                        gridColumn: ci + 1
                    },
                    children: (0, $4vwom.jsx)((0, $4rY0U.WidgetView), {
                        value: row[$1e93648432c98720$var$getColumnKey(c)],
                        isRoot: false,
                        tableCell: {
                            row: index,
                            column: ci
                        }
                    })
                }, $1e93648432c98720$var$getColumnKey(c)))),
            panelColumns.map((p, pi)=>(0, $4vwom.jsx)("tr", {
                    style: {
                        pageBreakInside: "avoid"
                    },
                    children: (0, $4vwom.jsx)("td", {
                        style: {
                            paddingLeft: 24,
                            paddingRight: 24,
                            paddingBottom: 16
                        },
                        colSpan: columns.length,
                        children: (0, $4vwom.jsx)((0, $4rY0U.WidgetView), {
                            value: row[$1e93648432c98720$var$getColumnKey(p)].content,
                            isRoot: false
                        })
                    })
                }, pi))
        ]
    });
}
function $1e93648432c98720$var$SearchIcon() {
    return (0, $4vwom.jsx)("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: (0, $4vwom.jsx)("path", {
            d: "M17.5 17.5L13.875 13.875M15.8333 9.16667C15.8333 12.8486 12.8486 15.8333 9.16667 15.8333C5.48477 15.8333 2.5 12.8486 2.5 9.16667C2.5 5.48477 5.48477 2.5 9.16667 2.5C12.8486 2.5 15.8333 5.48477 15.8333 9.16667Z",
            stroke: "#667085",
            strokeWidth: "1.66667",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
}
function $1e93648432c98720$var$RefreshButton(props) {
    const [refreshing, setRefreshing] = (0, $eeH7J.useState)(false);
    async function refresh() {
        if (refreshing) return;
        setRefreshing(true);
        try {
            await props.refresh();
        } catch (e) {
            if ("detail" in e) alert(e.detail);
            else alert(JSON.stringify(e));
        } finally{
            setRefreshing(false);
        }
    }
    return (0, $4vwom.jsxs)((0, $fT6Pt.RButton), {
        onClick: refresh,
        disabled: refreshing,
        tooltip: "Fetches the latest data from the backend",
        tooltipPlacement: "bottom",
        popupPlacement: "left",
        style: Object.assign(Object.assign({}, $1e93648432c98720$var$buttonStyle), {
            marginLeft: 16,
            width: refreshing ? 160 : 115,
            fontSize: 14,
            fontWeight: 500,
            opacity: 1,
            transition: "all 0.235s ease",
            color: (0, $9Q5xE.ColorStyles).gray[700]
        }),
        children: [
            (0, $4vwom.jsx)("i", {
                className: `fas fa-sync ${refreshing ? "spinning" : ""}`,
                style: {
                    transition: "all 0.3s ease",
                    color: refreshing ? (0, $9Q5xE.ColorStyles)["green-light"][500] : undefined
                }
            }),
            (0, $4vwom.jsx)("div", {
                style: {
                    marginLeft: 12
                },
                children: refreshing ? "Refreshing..." : "Refresh"
            })
        ]
    });
}

});
parcelRegister("lhaLc", function(module, exports) {

$parcel$export(module.exports, "createElement", function () { return $f7d3884205bad6eb$export$c8a8987d4410bf2d; });
$parcel$export(module.exports, "Global", function () { return $f7d3884205bad6eb$export$98f03c5d19621d70; });
$parcel$export(module.exports, "css", function () { return $f7d3884205bad6eb$export$dbf350e5966cf602; });
$parcel$export(module.exports, "keyframes", function () { return $f7d3884205bad6eb$export$d25ddfdf17c3ad3e; });
$parcel$export(module.exports, "jsx", function () { return $f7d3884205bad6eb$export$c8a8987d4410bf2d; });

var $8ZuUP = parcelRequire("8ZuUP");

var $eeH7J = parcelRequire("eeH7J");

var $7sOZt = parcelRequire("7sOZt");

var $5ziuZ = parcelRequire("5ziuZ");

var $47KoV = parcelRequire("47KoV");
parcelRequire("gc3M0");
parcelRequire("eq7pw");
parcelRequire("6q2Od");

parcelRequire("3ojZ1");
var $f7d3884205bad6eb$var$pkg = {
    name: "@emotion/react",
    version: "11.11.4",
    main: "dist/emotion-react.cjs.js",
    module: "dist/emotion-react.esm.js",
    browser: {
        "./dist/emotion-react.esm.js": "./dist/emotion-react.browser.esm.js"
    },
    exports: {
        ".": {
            module: {
                worker: "./dist/emotion-react.worker.esm.js",
                browser: "./dist/emotion-react.browser.esm.js",
                "default": "./dist/emotion-react.esm.js"
            },
            "import": "./dist/emotion-react.cjs.mjs",
            "default": "./dist/emotion-react.cjs.js"
        },
        "./jsx-runtime": {
            module: {
                worker: "./jsx-runtime/dist/emotion-react-jsx-runtime.worker.esm.js",
                browser: "./jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js",
                "default": "./jsx-runtime/dist/emotion-react-jsx-runtime.esm.js"
            },
            "import": "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.mjs",
            "default": "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.js"
        },
        "./_isolated-hnrs": {
            module: {
                worker: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.worker.esm.js",
                browser: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.browser.esm.js",
                "default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.esm.js"
            },
            "import": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.mjs",
            "default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.js"
        },
        "./jsx-dev-runtime": {
            module: {
                worker: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.worker.esm.js",
                browser: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.browser.esm.js",
                "default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.esm.js"
            },
            "import": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.mjs",
            "default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.js"
        },
        "./package.json": "./package.json",
        "./types/css-prop": "./types/css-prop.d.ts",
        "./macro": {
            types: {
                "import": "./macro.d.mts",
                "default": "./macro.d.ts"
            },
            "default": "./macro.js"
        }
    },
    types: "types/index.d.ts",
    files: [
        "src",
        "dist",
        "jsx-runtime",
        "jsx-dev-runtime",
        "_isolated-hnrs",
        "types/*.d.ts",
        "macro.*"
    ],
    sideEffects: false,
    author: "Emotion Contributors",
    license: "MIT",
    scripts: {
        "test:typescript": "dtslint types"
    },
    dependencies: {
        "@babel/runtime": "^7.18.3",
        "@emotion/babel-plugin": "^11.11.0",
        "@emotion/cache": "^11.11.0",
        "@emotion/serialize": "^1.1.3",
        "@emotion/use-insertion-effect-with-fallbacks": "^1.0.1",
        "@emotion/utils": "^1.2.1",
        "@emotion/weak-memoize": "^0.3.1",
        "hoist-non-react-statics": "^3.3.1"
    },
    peerDependencies: {
        react: ">=16.8.0"
    },
    peerDependenciesMeta: {
        "@types/react": {
            optional: true
        }
    },
    devDependencies: {
        "@definitelytyped/dtslint": "0.0.112",
        "@emotion/css": "11.11.2",
        "@emotion/css-prettifier": "1.1.3",
        "@emotion/server": "11.11.0",
        "@emotion/styled": "11.11.0",
        "html-tag-names": "^1.1.2",
        react: "16.14.0",
        "svg-tag-names": "^1.1.1",
        typescript: "^4.5.5"
    },
    repository: "https://github.com/emotion-js/emotion/tree/main/packages/react",
    publishConfig: {
        access: "public"
    },
    "umd:main": "dist/emotion-react.umd.min.js",
    preconstruct: {
        entrypoints: [
            "./index.js",
            "./jsx-runtime.js",
            "./jsx-dev-runtime.js",
            "./_isolated-hnrs.js"
        ],
        umdName: "emotionReact",
        exports: {
            envConditions: [
                "browser",
                "worker"
            ],
            extra: {
                "./types/css-prop": "./types/css-prop.d.ts",
                "./macro": {
                    types: {
                        "import": "./macro.d.mts",
                        "default": "./macro.d.ts"
                    },
                    "default": "./macro.js"
                }
            }
        }
    }
};
var $f7d3884205bad6eb$export$c8a8987d4410bf2d = function jsx(type, props) {
    var args = arguments;
    if (props == null || !(0, $8ZuUP.h).call(props, "css")) // $FlowFixMe
    return $eeH7J.createElement.apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, $8ZuUP.E);
    createElementArgArray[1] = (0, $8ZuUP.c)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
     // $FlowFixMe
    return $eeH7J.createElement.apply(null, createElementArgArray);
};
var $f7d3884205bad6eb$var$warnedAboutCssPropForGlobal = false; // maintain place over rerenders.
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var $f7d3884205bad6eb$export$98f03c5d19621d70 = /* #__PURE__ */ (0, $8ZuUP.w)(function(props, cache) {
    var styles = props.styles;
    var serialized = (0, $47KoV.serializeStyles)([
        styles
    ], undefined, $eeH7J.useContext((0, $8ZuUP.T)));
    if (!(0, $8ZuUP.i)) {
        var _ref;
        var serializedNames = serialized.name;
        var serializedStyles = serialized.styles;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += " " + next.name;
            serializedStyles += next.styles;
            next = next.next;
        }
        var shouldCache = cache.compat === true;
        var rules = cache.insert("", {
            name: serializedNames,
            styles: serializedStyles
        }, cache.sheet, shouldCache);
        if (shouldCache) return null;
        return /*#__PURE__*/ $eeH7J.createElement("style", (_ref = {}, _ref["data-emotion"] = cache.key + "-global " + serializedNames, _ref.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref.nonce = cache.sheet.nonce, _ref));
    } // yes, i know these hooks are used conditionally
    // but it is based on a constant that will never change at runtime
    // it's effectively like having two implementations and switching them out
    // so it's not actually breaking anything
    var sheetRef = $eeH7J.useRef();
    (0, $5ziuZ.useInsertionEffectWithLayoutFallback)(function() {
        var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675
        var sheet = new cache.sheet.constructor({
            key: key,
            nonce: cache.sheet.nonce,
            container: cache.sheet.container,
            speedy: cache.sheet.isSpeedy
        });
        var rehydrating = false; // $FlowFixMe
        var node = document.querySelector('style[data-emotion="' + key + " " + serialized.name + '"]');
        if (cache.sheet.tags.length) sheet.before = cache.sheet.tags[0];
        if (node !== null) {
            rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s
            node.setAttribute("data-emotion", key);
            sheet.hydrate([
                node
            ]);
        }
        sheetRef.current = [
            sheet,
            rehydrating
        ];
        return function() {
            sheet.flush();
        };
    }, [
        cache
    ]);
    (0, $5ziuZ.useInsertionEffectWithLayoutFallback)(function() {
        var sheetRefCurrent = sheetRef.current;
        var sheet = sheetRefCurrent[0], rehydrating = sheetRefCurrent[1];
        if (rehydrating) {
            sheetRefCurrent[1] = false;
            return;
        }
        if (serialized.next !== undefined) // insert keyframes
        (0, $7sOZt.insertStyles)(cache, serialized.next, true);
        if (sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
            sheet.before = element;
            sheet.flush();
        }
        cache.insert("", serialized, sheet, false);
    }, [
        cache,
        serialized.name
    ]);
    return null;
});
function $f7d3884205bad6eb$export$dbf350e5966cf602() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $47KoV.serializeStyles)(args);
}
var $f7d3884205bad6eb$export$d25ddfdf17c3ad3e = function keyframes() {
    var insertable = $f7d3884205bad6eb$export$dbf350e5966cf602.apply(void 0, arguments);
    var name = "animation-" + insertable.name; // $FlowFixMe
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
};
var $f7d3884205bad6eb$var$classnames = function classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = "";
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case "boolean":
                break;
            case "object":
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = "";
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += " ");
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += " ");
            cls += toAdd;
        }
    }
    return cls;
};
function $f7d3884205bad6eb$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $7sOZt.getRegisteredStyles)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $f7d3884205bad6eb$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serializedArr = _ref.serializedArr;
    (0, $5ziuZ.useInsertionEffectAlwaysWithSyncFallback)(function() {
        for(var i = 0; i < serializedArr.length; i++)(0, $7sOZt.insertStyles)(cache, serializedArr[i], false);
    });
    return null;
};
var $f7d3884205bad6eb$export$9b9c0f9d9f3552b8 = /* #__PURE__ */ (0, $8ZuUP.w)(function(props, cache) {
    var hasRendered = false;
    var serializedArr = [];
    var css = function css() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, $47KoV.serializeStyles)(args, cache.registered);
        serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`
        (0, $7sOZt.registerStyles)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var cx = function cx() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return $f7d3884205bad6eb$var$merge(cache.registered, css, $f7d3884205bad6eb$var$classnames(args));
    };
    var content = {
        css: css,
        cx: cx,
        theme: $eeH7J.useContext((0, $8ZuUP.T))
    };
    var ele = props.children(content);
    hasRendered = true;
    return /*#__PURE__*/ $eeH7J.createElement($eeH7J.Fragment, null, /*#__PURE__*/ $eeH7J.createElement($f7d3884205bad6eb$var$Insertion, {
        cache: cache,
        serializedArr: serializedArr
    }), ele);
});
var $f7d3884205bad6eb$var$isBrowser, $f7d3884205bad6eb$var$isTestEnv, $f7d3884205bad6eb$var$globalContext, $f7d3884205bad6eb$var$globalKey;

});

parcelRegister("cniWT", function(module, exports) {

$parcel$export(module.exports, "useDropzone", function () { return $902654ddcf2304ad$export$cd49c0ecc5be9f36; });

var $eeH7J = parcelRequire("eeH7J");

var $4yBem = parcelRequire("4yBem");
parcelRequire("5CMEY");
var $aBrdc = parcelRequire("aBrdc");

var $1V0AZ = parcelRequire("1V0AZ");

var $1V0AZ = parcelRequire("1V0AZ");
var $902654ddcf2304ad$var$_excluded = [
    "children"
], $902654ddcf2304ad$var$_excluded2 = [
    "open"
], $902654ddcf2304ad$var$_excluded3 = [
    "refKey",
    "onKeyDown",
    "onFocus",
    "onBlur",
    "onClick",
    "onDragEnter",
    "onDragOver",
    "onDragLeave",
    "onDrop"
], $902654ddcf2304ad$var$_excluded4 = [
    "refKey",
    "onChange",
    "onClick"
];
function $902654ddcf2304ad$var$_toConsumableArray(arr) {
    return $902654ddcf2304ad$var$_arrayWithoutHoles(arr) || $902654ddcf2304ad$var$_iterableToArray(arr) || $902654ddcf2304ad$var$_unsupportedIterableToArray(arr) || $902654ddcf2304ad$var$_nonIterableSpread();
}
function $902654ddcf2304ad$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $902654ddcf2304ad$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $902654ddcf2304ad$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $902654ddcf2304ad$var$_arrayLikeToArray(arr);
}
function $902654ddcf2304ad$var$_slicedToArray(arr, i) {
    return $902654ddcf2304ad$var$_arrayWithHoles(arr) || $902654ddcf2304ad$var$_iterableToArrayLimit(arr, i) || $902654ddcf2304ad$var$_unsupportedIterableToArray(arr, i) || $902654ddcf2304ad$var$_nonIterableRest();
}
function $902654ddcf2304ad$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $902654ddcf2304ad$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $902654ddcf2304ad$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $902654ddcf2304ad$var$_arrayLikeToArray(o, minLen);
}
function $902654ddcf2304ad$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $902654ddcf2304ad$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $902654ddcf2304ad$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $902654ddcf2304ad$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $902654ddcf2304ad$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $902654ddcf2304ad$var$ownKeys(Object(source), true).forEach(function(key) {
            $902654ddcf2304ad$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $902654ddcf2304ad$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $902654ddcf2304ad$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $902654ddcf2304ad$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $902654ddcf2304ad$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $902654ddcf2304ad$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
/**
 * Convenience wrapper component for the `useDropzone` hook
 *
 * ```jsx
 * <Dropzone>
 *   {({getRootProps, getInputProps}) => (
 *     <div {...getRootProps()}>
 *       <input {...getInputProps()} />
 *       <p>Drag 'n' drop some files here, or click to select files</p>
 *     </div>
 *   )}
 * </Dropzone>
 * ```
 */ var $902654ddcf2304ad$var$Dropzone = /*#__PURE__*/ (0, $eeH7J.forwardRef)(function(_ref, ref) {
    var children = _ref.children, params = $902654ddcf2304ad$var$_objectWithoutProperties(_ref, $902654ddcf2304ad$var$_excluded);
    var _useDropzone = $902654ddcf2304ad$export$cd49c0ecc5be9f36(params), open = _useDropzone.open, props = $902654ddcf2304ad$var$_objectWithoutProperties(_useDropzone, $902654ddcf2304ad$var$_excluded2);
    (0, $eeH7J.useImperativeHandle)(ref, function() {
        return {
            open: open
        };
    }, [
        open
    ]); // TODO: Figure out why react-styleguidist cannot create docs if we don't return a jsx element
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $eeH7J.Fragment), null, children($902654ddcf2304ad$var$_objectSpread($902654ddcf2304ad$var$_objectSpread({}, props), {}, {
        open: open
    })));
});
$902654ddcf2304ad$var$Dropzone.displayName = "Dropzone"; // Add default props for react-docgen
var $902654ddcf2304ad$var$defaultProps = {
    disabled: false,
    getFilesFromEvent: (0, $aBrdc.fromEvent),
    maxSize: Infinity,
    minSize: 0,
    multiple: true,
    maxFiles: 0,
    preventDropOnDocument: true,
    noClick: false,
    noKeyboard: false,
    noDrag: false,
    noDragEventsBubbling: false,
    validator: null
};
$902654ddcf2304ad$var$Dropzone.defaultProps = $902654ddcf2304ad$var$defaultProps;
$902654ddcf2304ad$var$Dropzone.propTypes = {
    /**
   * Render function that exposes the dropzone state and prop getter fns
   *
   * @param {object} params
   * @param {Function} params.getRootProps Returns the props you should apply to the root drop container you render
   * @param {Function} params.getInputProps Returns the props you should apply to hidden file input you render
   * @param {Function} params.open Open the native file selection dialog
   * @param {boolean} params.isFocused Dropzone area is in focus
   * @param {boolean} params.isFileDialogActive File dialog is opened
   * @param {boolean} params.isDragActive Active drag is in progress
   * @param {boolean} params.isDragAccept Dragged files are accepted
   * @param {boolean} params.isDragReject Some dragged files are rejected
   * @param {File[]} params.draggedFiles Files in active drag
   * @param {File[]} params.acceptedFiles Accepted files
   * @param {FileRejection[]} params.fileRejections Rejected files and why they were rejected
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
    /**
   * Set accepted file types.
   * See https://github.com/okonet/attr-accept for more information.
   * Keep in mind that mime type determination is not reliable across platforms. CSV files,
   * for example, are reported as text/plain under macOS but as application/vnd.ms-excel under
   * Windows. In some cases there might not be a mime type set at all.
   * See: https://github.com/react-dropzone/react-dropzone/issues/276
   */ accept: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string)
    ]),
    /**
   * Allow drag 'n' drop (or selection from the file dialog) of multiple files
   */ multiple: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * If false, allow dropped items to take over the current browser window
   */ preventDropOnDocument: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * If true, disables click to open the native file selection dialog
   */ noClick: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * If true, disables SPACE/ENTER to open the native file selection dialog.
   * Note that it also stops tracking the focus state.
   */ noKeyboard: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * If true, disables drag 'n' drop
   */ noDrag: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * If true, stops drag event propagation to parents
   */ noDragEventsBubbling: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * Minimum file size (in bytes)
   */ minSize: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).number,
    /**
   * Maximum file size (in bytes)
   */ maxSize: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).number,
    /**
   * Maximum accepted number of files
   * The default value is 0 which means there is no limitation to how many files are accepted.
   */ maxFiles: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).number,
    /**
   * Enable/disable the dropzone
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    /**
   * Use this to provide a custom file aggregator
   *
   * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
   */ getFilesFromEvent: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
    /**
   * Cb for when closing the file dialog with no selection
   */ onFileDialogCancel: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
    /**
   * Cb for when the `dragenter` event occurs.
   *
   * @param {DragEvent} event
   */ onDragEnter: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
    /**
   * Cb for when the `dragleave` event occurs
   *
   * @param {DragEvent} event
   */ onDragLeave: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
    /**
   * Cb for when the `dragover` event occurs
   *
   * @param {DragEvent} event
   */ onDragOver: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
    /**
   * Cb for when the `drop` event occurs.
   * Note that this callback is invoked after the `getFilesFromEvent` callback is done.
   *
   * Files are accepted or rejected based on the `accept`, `multiple`, `minSize` and `maxSize` props.
   * `accept` must be a valid [MIME type](http://www.iana.org/assignments/media-types/media-types.xhtml) according to [input element specification](https://www.w3.org/wiki/HTML/Elements/input/file) or a valid file extension.
   * If `multiple` is set to false and additional files are dropped,
   * all files besides the first will be rejected.
   * Any file which does not have a size in the [`minSize`, `maxSize`] range, will be rejected as well.
   *
   * Note that the `onDrop` callback will always be invoked regardless if the dropped files were accepted or rejected.
   * If you'd like to react to a specific scenario, use the `onDropAccepted`/`onDropRejected` props.
   *
   * `onDrop` will provide you with an array of [File](https://developer.mozilla.org/en-US/docs/Web/API/File) objects which you can then process and send to a server.
   * For example, with [SuperAgent](https://github.com/visionmedia/superagent) as a http/ajax library:
   *
   * ```js
   * function onDrop(acceptedFiles) {
   *   const req = request.post('/upload')
   *   acceptedFiles.forEach(file => {
   *     req.attach(file.name, file)
   *   })
   *   req.end(callback)
   * }
   * ```
   *
   * @param {File[]} acceptedFiles
   * @param {FileRejection[]} fileRejections
   * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
   */ onDrop: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
    /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are accepted, this callback is not invoked.
   *
   * @param {File[]} files
   * @param {(DragEvent|Event)} event
   */ onDropAccepted: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
    /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are rejected, this callback is not invoked.
   *
   * @param {FileRejection[]} fileRejections
   * @param {(DragEvent|Event)} event
   */ onDropRejected: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func,
    /**
   * Custom validation function 
   * @param {File} file
   * @returns {FileError|FileError[]}
   */ validator: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).func
};
var $902654ddcf2304ad$export$2e2bcd8739ae039 = $902654ddcf2304ad$var$Dropzone;
/**
 * A function that is invoked for the `dragenter`,
 * `dragover` and `dragleave` events.
 * It is not invoked if the items are not files (such as link, text, etc.).
 *
 * @callback dragCb
 * @param {DragEvent} event
 */ /**
 * A function that is invoked for the `drop` or input change event.
 * It is not invoked if the items are not files (such as link, text, etc.).
 *
 * @callback dropCb
 * @param {File[]} acceptedFiles List of accepted files
 * @param {FileRejection[]} fileRejections List of rejected files and why they were rejected
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 */ /**
 * A function that is invoked for the `drop` or input change event.
 * It is not invoked if the items are files (such as link, text, etc.).
 *
 * @callback dropAcceptedCb
 * @param {File[]} files List of accepted files that meet the given criteria
 * (`accept`, `multiple`, `minSize`, `maxSize`)
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 */ /**
 * A function that is invoked for the `drop` or input change event.
 *
 * @callback dropRejectedCb
 * @param {File[]} files List of rejected files that do not meet the given criteria
 * (`accept`, `multiple`, `minSize`, `maxSize`)
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 */ /**
 * A function that is used aggregate files,
 * in a asynchronous fashion, from drag or input change events.
 *
 * @callback getFilesFromEvent
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 * @returns {(File[]|Promise<File[]>)}
 */ /**
 * An object with the current dropzone state and some helper functions.
 *
 * @typedef {object} DropzoneState
 * @property {Function} getRootProps Returns the props you should apply to the root drop container you render
 * @property {Function} getInputProps Returns the props you should apply to hidden file input you render
 * @property {Function} open Open the native file selection dialog
 * @property {boolean} isFocused Dropzone area is in focus
 * @property {boolean} isFileDialogActive File dialog is opened
 * @property {boolean} isDragActive Active drag is in progress
 * @property {boolean} isDragAccept Dragged files are accepted
 * @property {boolean} isDragReject Some dragged files are rejected
 * @property {File[]} draggedFiles Files in active drag
 * @property {File[]} acceptedFiles Accepted files
 * @property {FileRejection[]} fileRejections Rejected files and why they were rejected
 */ var $902654ddcf2304ad$var$initialState = {
    isFocused: false,
    isFileDialogActive: false,
    isDragActive: false,
    isDragAccept: false,
    isDragReject: false,
    draggedFiles: [],
    acceptedFiles: [],
    fileRejections: []
};
function $902654ddcf2304ad$export$cd49c0ecc5be9f36() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _defaultProps$options = $902654ddcf2304ad$var$_objectSpread($902654ddcf2304ad$var$_objectSpread({}, $902654ddcf2304ad$var$defaultProps), options), accept = _defaultProps$options.accept, disabled = _defaultProps$options.disabled, getFilesFromEvent = _defaultProps$options.getFilesFromEvent, maxSize = _defaultProps$options.maxSize, minSize = _defaultProps$options.minSize, multiple = _defaultProps$options.multiple, maxFiles = _defaultProps$options.maxFiles, onDragEnter = _defaultProps$options.onDragEnter, onDragLeave = _defaultProps$options.onDragLeave, onDragOver = _defaultProps$options.onDragOver, onDrop = _defaultProps$options.onDrop, onDropAccepted = _defaultProps$options.onDropAccepted, onDropRejected = _defaultProps$options.onDropRejected, onFileDialogCancel = _defaultProps$options.onFileDialogCancel, preventDropOnDocument = _defaultProps$options.preventDropOnDocument, noClick = _defaultProps$options.noClick, noKeyboard = _defaultProps$options.noKeyboard, noDrag = _defaultProps$options.noDrag, noDragEventsBubbling = _defaultProps$options.noDragEventsBubbling, validator = _defaultProps$options.validator;
    var rootRef = (0, $eeH7J.useRef)(null);
    var inputRef = (0, $eeH7J.useRef)(null);
    var _useReducer = (0, $eeH7J.useReducer)($902654ddcf2304ad$var$reducer, $902654ddcf2304ad$var$initialState), _useReducer2 = $902654ddcf2304ad$var$_slicedToArray(_useReducer, 2), state = _useReducer2[0], dispatch = _useReducer2[1];
    var isFocused = state.isFocused, isFileDialogActive = state.isFileDialogActive, draggedFiles = state.draggedFiles; // Fn for opening the file dialog programmatically
    var openFileDialog = (0, $eeH7J.useCallback)(function() {
        if (inputRef.current) {
            dispatch({
                type: "openDialog"
            });
            inputRef.current.value = null;
            inputRef.current.click();
        }
    }, [
        dispatch
    ]); // Update file dialog active state when the window is focused on
    var onWindowFocus = function onWindowFocus() {
        // Execute the timeout only if the file dialog is opened in the browser
        if (isFileDialogActive) setTimeout(function() {
            if (inputRef.current) {
                var files = inputRef.current.files;
                if (!files.length) {
                    dispatch({
                        type: "closeDialog"
                    });
                    if (typeof onFileDialogCancel === "function") onFileDialogCancel();
                }
            }
        }, 300);
    };
    (0, $eeH7J.useEffect)(function() {
        window.addEventListener("focus", onWindowFocus, false);
        return function() {
            window.removeEventListener("focus", onWindowFocus, false);
        };
    }, [
        inputRef,
        isFileDialogActive,
        onFileDialogCancel
    ]); // Cb to open the file dialog when SPACE/ENTER occurs on the dropzone
    var onKeyDownCb = (0, $eeH7J.useCallback)(function(event) {
        // Ignore keyboard events bubbling up the DOM tree
        if (!rootRef.current || !rootRef.current.isEqualNode(event.target)) return;
        if (event.keyCode === 32 || event.keyCode === 13) {
            event.preventDefault();
            openFileDialog();
        }
    }, [
        rootRef,
        inputRef
    ]); // Update focus state for the dropzone
    var onFocusCb = (0, $eeH7J.useCallback)(function() {
        dispatch({
            type: "focus"
        });
    }, []);
    var onBlurCb = (0, $eeH7J.useCallback)(function() {
        dispatch({
            type: "blur"
        });
    }, []); // Cb to open the file dialog when click occurs on the dropzone
    var onClickCb = (0, $eeH7J.useCallback)(function() {
        if (noClick) return;
         // In IE11/Edge the file-browser dialog is blocking, therefore, use setTimeout()
        // to ensure React can handle state changes
        // See: https://github.com/react-dropzone/react-dropzone/issues/450
        if ((0, $1V0AZ.isIeOrEdge)()) setTimeout(openFileDialog, 0);
        else openFileDialog();
    }, [
        inputRef,
        noClick
    ]);
    var dragTargetsRef = (0, $eeH7J.useRef)([]);
    var onDocumentDrop = function onDocumentDrop(event) {
        if (rootRef.current && rootRef.current.contains(event.target)) // If we intercepted an event for our instance, let it propagate down to the instance's onDrop handler
        return;
        event.preventDefault();
        dragTargetsRef.current = [];
    };
    (0, $eeH7J.useEffect)(function() {
        if (preventDropOnDocument) {
            document.addEventListener("dragover", (0, $1V0AZ.onDocumentDragOver), false);
            document.addEventListener("drop", onDocumentDrop, false);
        }
        return function() {
            if (preventDropOnDocument) {
                document.removeEventListener("dragover", (0, $1V0AZ.onDocumentDragOver));
                document.removeEventListener("drop", onDocumentDrop);
            }
        };
    }, [
        rootRef,
        preventDropOnDocument
    ]);
    var onDragEnterCb = (0, $eeH7J.useCallback)(function(event) {
        event.preventDefault(); // Persist here because we need the event later after getFilesFromEvent() is done
        event.persist();
        stopPropagation(event);
        dragTargetsRef.current = [].concat($902654ddcf2304ad$var$_toConsumableArray(dragTargetsRef.current), [
            event.target
        ]);
        if ((0, $1V0AZ.isEvtWithFiles)(event)) Promise.resolve(getFilesFromEvent(event)).then(function(draggedFiles) {
            if ((0, $1V0AZ.isPropagationStopped)(event) && !noDragEventsBubbling) return;
            dispatch({
                draggedFiles: draggedFiles,
                isDragActive: true,
                type: "setDraggedFiles"
            });
            if (onDragEnter) onDragEnter(event);
        });
    }, [
        getFilesFromEvent,
        onDragEnter,
        noDragEventsBubbling
    ]);
    var onDragOverCb = (0, $eeH7J.useCallback)(function(event) {
        event.preventDefault();
        event.persist();
        stopPropagation(event);
        var hasFiles = (0, $1V0AZ.isEvtWithFiles)(event);
        if (hasFiles && event.dataTransfer) try {
            event.dataTransfer.dropEffect = "copy";
        } catch (_unused) {}
        if (hasFiles && onDragOver) onDragOver(event);
        return false;
    }, [
        onDragOver,
        noDragEventsBubbling
    ]);
    var onDragLeaveCb = (0, $eeH7J.useCallback)(function(event) {
        event.preventDefault();
        event.persist();
        stopPropagation(event); // Only deactivate once the dropzone and all children have been left
        var targets = dragTargetsRef.current.filter(function(target) {
            return rootRef.current && rootRef.current.contains(target);
        }); // Make sure to remove a target present multiple times only once
        // (Firefox may fire dragenter/dragleave multiple times on the same element)
        var targetIdx = targets.indexOf(event.target);
        if (targetIdx !== -1) targets.splice(targetIdx, 1);
        dragTargetsRef.current = targets;
        if (targets.length > 0) return;
        dispatch({
            isDragActive: false,
            type: "setDraggedFiles",
            draggedFiles: []
        });
        if ((0, $1V0AZ.isEvtWithFiles)(event) && onDragLeave) onDragLeave(event);
    }, [
        rootRef,
        onDragLeave,
        noDragEventsBubbling
    ]);
    var onDropCb = (0, $eeH7J.useCallback)(function(event) {
        event.preventDefault(); // Persist here because we need the event later after getFilesFromEvent() is done
        event.persist();
        stopPropagation(event);
        dragTargetsRef.current = [];
        if ((0, $1V0AZ.isEvtWithFiles)(event)) Promise.resolve(getFilesFromEvent(event)).then(function(files) {
            if ((0, $1V0AZ.isPropagationStopped)(event) && !noDragEventsBubbling) return;
            var acceptedFiles = [];
            var fileRejections = [];
            files.forEach(function(file) {
                var _fileAccepted = (0, $1V0AZ.fileAccepted)(file, accept), _fileAccepted2 = $902654ddcf2304ad$var$_slicedToArray(_fileAccepted, 2), accepted = _fileAccepted2[0], acceptError = _fileAccepted2[1];
                var _fileMatchSize = (0, $1V0AZ.fileMatchSize)(file, minSize, maxSize), _fileMatchSize2 = $902654ddcf2304ad$var$_slicedToArray(_fileMatchSize, 2), sizeMatch = _fileMatchSize2[0], sizeError = _fileMatchSize2[1];
                var customErrors = validator ? validator(file) : null;
                if (accepted && sizeMatch && !customErrors) acceptedFiles.push(file);
                else {
                    var errors = [
                        acceptError,
                        sizeError
                    ];
                    if (customErrors) errors = errors.concat(customErrors);
                    fileRejections.push({
                        file: file,
                        errors: errors.filter(function(e) {
                            return e;
                        })
                    });
                }
            });
            if (!multiple && acceptedFiles.length > 1 || multiple && maxFiles >= 1 && acceptedFiles.length > maxFiles) {
                // Reject everything and empty accepted files
                acceptedFiles.forEach(function(file) {
                    fileRejections.push({
                        file: file,
                        errors: [
                            (0, $1V0AZ.TOO_MANY_FILES_REJECTION)
                        ]
                    });
                });
                acceptedFiles.splice(0);
            }
            dispatch({
                acceptedFiles: acceptedFiles,
                fileRejections: fileRejections,
                type: "setFiles"
            });
            if (onDrop) onDrop(acceptedFiles, fileRejections, event);
            if (fileRejections.length > 0 && onDropRejected) onDropRejected(fileRejections, event);
            if (acceptedFiles.length > 0 && onDropAccepted) onDropAccepted(acceptedFiles, event);
        });
        dispatch({
            type: "reset"
        });
    }, [
        multiple,
        accept,
        minSize,
        maxSize,
        maxFiles,
        getFilesFromEvent,
        onDrop,
        onDropAccepted,
        onDropRejected,
        noDragEventsBubbling,
        validator
    ]);
    var composeHandler = function composeHandler(fn) {
        return disabled ? null : fn;
    };
    var composeKeyboardHandler = function composeKeyboardHandler(fn) {
        return noKeyboard ? null : composeHandler(fn);
    };
    var composeDragHandler = function composeDragHandler(fn) {
        return noDrag ? null : composeHandler(fn);
    };
    var stopPropagation = function stopPropagation(event) {
        if (noDragEventsBubbling) event.stopPropagation();
    };
    var getRootProps = (0, $eeH7J.useMemo)(function() {
        return function() {
            var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref2$refKey = _ref2.refKey, refKey = _ref2$refKey === void 0 ? "ref" : _ref2$refKey, onKeyDown = _ref2.onKeyDown, onFocus = _ref2.onFocus, onBlur = _ref2.onBlur, onClick = _ref2.onClick, onDragEnter = _ref2.onDragEnter, onDragOver = _ref2.onDragOver, onDragLeave = _ref2.onDragLeave, onDrop = _ref2.onDrop, rest = $902654ddcf2304ad$var$_objectWithoutProperties(_ref2, $902654ddcf2304ad$var$_excluded3);
            return $902654ddcf2304ad$var$_objectSpread($902654ddcf2304ad$var$_objectSpread($902654ddcf2304ad$var$_defineProperty({
                onKeyDown: composeKeyboardHandler((0, $1V0AZ.composeEventHandlers)(onKeyDown, onKeyDownCb)),
                onFocus: composeKeyboardHandler((0, $1V0AZ.composeEventHandlers)(onFocus, onFocusCb)),
                onBlur: composeKeyboardHandler((0, $1V0AZ.composeEventHandlers)(onBlur, onBlurCb)),
                onClick: composeHandler((0, $1V0AZ.composeEventHandlers)(onClick, onClickCb)),
                onDragEnter: composeDragHandler((0, $1V0AZ.composeEventHandlers)(onDragEnter, onDragEnterCb)),
                onDragOver: composeDragHandler((0, $1V0AZ.composeEventHandlers)(onDragOver, onDragOverCb)),
                onDragLeave: composeDragHandler((0, $1V0AZ.composeEventHandlers)(onDragLeave, onDragLeaveCb)),
                onDrop: composeDragHandler((0, $1V0AZ.composeEventHandlers)(onDrop, onDropCb))
            }, refKey, rootRef), !disabled && !noKeyboard ? {
                tabIndex: 0
            } : {}), rest);
        };
    }, [
        rootRef,
        onKeyDownCb,
        onFocusCb,
        onBlurCb,
        onClickCb,
        onDragEnterCb,
        onDragOverCb,
        onDragLeaveCb,
        onDropCb,
        noKeyboard,
        noDrag,
        disabled
    ]);
    var onInputElementClick = (0, $eeH7J.useCallback)(function(event) {
        event.stopPropagation();
    }, []);
    var getInputProps = (0, $eeH7J.useMemo)(function() {
        return function() {
            var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref3$refKey = _ref3.refKey, refKey = _ref3$refKey === void 0 ? "ref" : _ref3$refKey, onChange = _ref3.onChange, onClick = _ref3.onClick, rest = $902654ddcf2304ad$var$_objectWithoutProperties(_ref3, $902654ddcf2304ad$var$_excluded4);
            var inputProps = $902654ddcf2304ad$var$_defineProperty({
                accept: accept,
                multiple: multiple,
                type: "file",
                style: {
                    display: "none"
                },
                onChange: composeHandler((0, $1V0AZ.composeEventHandlers)(onChange, onDropCb)),
                onClick: composeHandler((0, $1V0AZ.composeEventHandlers)(onClick, onInputElementClick)),
                autoComplete: "off",
                tabIndex: -1
            }, refKey, inputRef);
            return $902654ddcf2304ad$var$_objectSpread($902654ddcf2304ad$var$_objectSpread({}, inputProps), rest);
        };
    }, [
        inputRef,
        accept,
        multiple,
        onDropCb,
        disabled
    ]);
    var fileCount = draggedFiles.length;
    var isDragAccept = fileCount > 0 && (0, $1V0AZ.allFilesAccepted)({
        files: draggedFiles,
        accept: accept,
        minSize: minSize,
        maxSize: maxSize,
        multiple: multiple,
        maxFiles: maxFiles
    });
    var isDragReject = fileCount > 0 && !isDragAccept;
    return $902654ddcf2304ad$var$_objectSpread($902654ddcf2304ad$var$_objectSpread({}, state), {}, {
        isDragAccept: isDragAccept,
        isDragReject: isDragReject,
        isFocused: isFocused && !disabled,
        getRootProps: getRootProps,
        getInputProps: getInputProps,
        rootRef: rootRef,
        inputRef: inputRef,
        open: composeHandler(openFileDialog)
    });
}
function $902654ddcf2304ad$var$reducer(state, action) {
    /* istanbul ignore next */ switch(action.type){
        case "focus":
            return $902654ddcf2304ad$var$_objectSpread($902654ddcf2304ad$var$_objectSpread({}, state), {}, {
                isFocused: true
            });
        case "blur":
            return $902654ddcf2304ad$var$_objectSpread($902654ddcf2304ad$var$_objectSpread({}, state), {}, {
                isFocused: false
            });
        case "openDialog":
            return $902654ddcf2304ad$var$_objectSpread($902654ddcf2304ad$var$_objectSpread({}, state), {}, {
                isFileDialogActive: true
            });
        case "closeDialog":
            return $902654ddcf2304ad$var$_objectSpread($902654ddcf2304ad$var$_objectSpread({}, state), {}, {
                isFileDialogActive: false
            });
        case "setDraggedFiles":
            /* eslint no-case-declarations: 0 */ var isDragActive = action.isDragActive, draggedFiles = action.draggedFiles;
            return $902654ddcf2304ad$var$_objectSpread($902654ddcf2304ad$var$_objectSpread({}, state), {}, {
                draggedFiles: draggedFiles,
                isDragActive: isDragActive
            });
        case "setFiles":
            return $902654ddcf2304ad$var$_objectSpread($902654ddcf2304ad$var$_objectSpread({}, state), {}, {
                acceptedFiles: action.acceptedFiles,
                fileRejections: action.fileRejections
            });
        case "reset":
            return $902654ddcf2304ad$var$_objectSpread({}, $902654ddcf2304ad$var$initialState);
        default:
            return state;
    }
}

});
parcelRegister("5CMEY", function(module, exports) {

$parcel$export(module.exports, "fromEvent", function () { return (parcelRequire("aBrdc")).fromEvent; });

var $aBrdc = parcelRequire("aBrdc");

});
parcelRegister("aBrdc", function(module, exports) {

$parcel$export(module.exports, "fromEvent", function () { return $7b8277cf3e8d1c5f$export$a36e16046ae8f1bb; });

var $843Fa = parcelRequire("843Fa");

var $fn59F = parcelRequire("fn59F");
var $7b8277cf3e8d1c5f$var$FILES_TO_IGNORE = [
    // Thumbnail cache files for macOS and Windows
    ".DS_Store",
    "Thumbs.db" // Windows
];
function $7b8277cf3e8d1c5f$export$a36e16046ae8f1bb(evt) {
    return (0, $843Fa.__awaiter)(this, void 0, void 0, function() {
        return (0, $843Fa.__generator)(this, function(_a) {
            return [
                2 /*return*/ ,
                $7b8277cf3e8d1c5f$var$isDragEvt(evt) && evt.dataTransfer ? $7b8277cf3e8d1c5f$var$getDataTransferFiles(evt.dataTransfer, evt.type) : $7b8277cf3e8d1c5f$var$getInputFiles(evt)
            ];
        });
    });
}
function $7b8277cf3e8d1c5f$var$isDragEvt(value) {
    return !!value.dataTransfer;
}
function $7b8277cf3e8d1c5f$var$getInputFiles(evt) {
    var files = $7b8277cf3e8d1c5f$var$isInput(evt.target) ? evt.target.files ? $7b8277cf3e8d1c5f$var$fromList(evt.target.files) : [] : [];
    return files.map(function(file) {
        return (0, $fn59F.toFileWithPath)(file);
    });
}
function $7b8277cf3e8d1c5f$var$isInput(value) {
    return value !== null;
}
function $7b8277cf3e8d1c5f$var$getDataTransferFiles(dt, type) {
    return (0, $843Fa.__awaiter)(this, void 0, void 0, function() {
        var items, files;
        return (0, $843Fa.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (!dt.items) return [
                        3 /*break*/ ,
                        2
                    ];
                    items = $7b8277cf3e8d1c5f$var$fromList(dt.items).filter(function(item) {
                        return item.kind === "file";
                    });
                    // According to https://html.spec.whatwg.org/multipage/dnd.html#dndevents,
                    // only 'dragstart' and 'drop' has access to the data (source node)
                    if (type !== "drop") return [
                        2 /*return*/ ,
                        items
                    ];
                    return [
                        4 /*yield*/ ,
                        Promise.all(items.map($7b8277cf3e8d1c5f$var$toFilePromises))
                    ];
                case 1:
                    files = _a.sent();
                    return [
                        2 /*return*/ ,
                        $7b8277cf3e8d1c5f$var$noIgnoredFiles($7b8277cf3e8d1c5f$var$flatten(files))
                    ];
                case 2:
                    return [
                        2 /*return*/ ,
                        $7b8277cf3e8d1c5f$var$noIgnoredFiles($7b8277cf3e8d1c5f$var$fromList(dt.files).map(function(file) {
                            return (0, $fn59F.toFileWithPath)(file);
                        }))
                    ];
            }
        });
    });
}
function $7b8277cf3e8d1c5f$var$noIgnoredFiles(files) {
    return files.filter(function(file) {
        return $7b8277cf3e8d1c5f$var$FILES_TO_IGNORE.indexOf(file.name) === -1;
    });
}
// IE11 does not support Array.from()
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/from#Browser_compatibility
// https://developer.mozilla.org/en-US/docs/Web/API/FileList
// https://developer.mozilla.org/en-US/docs/Web/API/DataTransferItemList
function $7b8277cf3e8d1c5f$var$fromList(items) {
    var files = [];
    // tslint:disable: prefer-for-of
    for(var i = 0; i < items.length; i++){
        var file = items[i];
        files.push(file);
    }
    return files;
}
// https://developer.mozilla.org/en-US/docs/Web/API/DataTransferItem
function $7b8277cf3e8d1c5f$var$toFilePromises(item) {
    if (typeof item.webkitGetAsEntry !== "function") return $7b8277cf3e8d1c5f$var$fromDataTransferItem(item);
    var entry = item.webkitGetAsEntry();
    // Safari supports dropping an image node from a different window and can be retrieved using
    // the DataTransferItem.getAsFile() API
    // NOTE: FileSystemEntry.file() throws if trying to get the file
    if (entry && entry.isDirectory) return $7b8277cf3e8d1c5f$var$fromDirEntry(entry);
    return $7b8277cf3e8d1c5f$var$fromDataTransferItem(item);
}
function $7b8277cf3e8d1c5f$var$flatten(items) {
    return items.reduce(function(acc, files) {
        return (0, $843Fa.__spread)(acc, Array.isArray(files) ? $7b8277cf3e8d1c5f$var$flatten(files) : [
            files
        ]);
    }, []);
}
function $7b8277cf3e8d1c5f$var$fromDataTransferItem(item) {
    var file = item.getAsFile();
    if (!file) return Promise.reject(item + " is not a File");
    var fwp = (0, $fn59F.toFileWithPath)(file);
    return Promise.resolve(fwp);
}
// https://developer.mozilla.org/en-US/docs/Web/API/FileSystemEntry
function $7b8277cf3e8d1c5f$var$fromEntry(entry) {
    return (0, $843Fa.__awaiter)(this, void 0, void 0, function() {
        return (0, $843Fa.__generator)(this, function(_a) {
            return [
                2 /*return*/ ,
                entry.isDirectory ? $7b8277cf3e8d1c5f$var$fromDirEntry(entry) : $7b8277cf3e8d1c5f$var$fromFileEntry(entry)
            ];
        });
    });
}
// https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryEntry
function $7b8277cf3e8d1c5f$var$fromDirEntry(entry) {
    var reader = entry.createReader();
    return new Promise(function(resolve, reject) {
        var entries = [];
        function readEntries() {
            var _this = this;
            // https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryEntry/createReader
            // https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryReader/readEntries
            reader.readEntries(function(batch) {
                return (0, $843Fa.__awaiter)(_this, void 0, void 0, function() {
                    var files, err_1, items;
                    return (0, $843Fa.__generator)(this, function(_a) {
                        switch(_a.label){
                            case 0:
                                if (!!batch.length) return [
                                    3 /*break*/ ,
                                    5
                                ];
                                _a.label = 1;
                            case 1:
                                _a.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4 /*yield*/ ,
                                    Promise.all(entries)
                                ];
                            case 2:
                                files = _a.sent();
                                resolve(files);
                                return [
                                    3 /*break*/ ,
                                    4
                                ];
                            case 3:
                                err_1 = _a.sent();
                                reject(err_1);
                                return [
                                    3 /*break*/ ,
                                    4
                                ];
                            case 4:
                                return [
                                    3 /*break*/ ,
                                    6
                                ];
                            case 5:
                                items = Promise.all(batch.map($7b8277cf3e8d1c5f$var$fromEntry));
                                entries.push(items);
                                // Continue reading
                                readEntries();
                                _a.label = 6;
                            case 6:
                                return [
                                    2 /*return*/ 
                                ];
                        }
                    });
                });
            }, function(err) {
                reject(err);
            });
        }
        readEntries();
    });
}
// https://developer.mozilla.org/en-US/docs/Web/API/FileSystemFileEntry
function $7b8277cf3e8d1c5f$var$fromFileEntry(entry) {
    return (0, $843Fa.__awaiter)(this, void 0, void 0, function() {
        return (0, $843Fa.__generator)(this, function(_a) {
            return [
                2 /*return*/ ,
                new Promise(function(resolve, reject) {
                    entry.file(function(file) {
                        var fwp = (0, $fn59F.toFileWithPath)(file, entry.fullPath);
                        resolve(fwp);
                    }, function(err) {
                        reject(err);
                    });
                })
            ];
        });
    });
}

});
parcelRegister("843Fa", function(module, exports) {

$parcel$export(module.exports, "__awaiter", function () { return $5df189dad2b9134b$export$1050f835b63b671e; });
$parcel$export(module.exports, "__generator", function () { return $5df189dad2b9134b$export$67ebef60e6f28a6; });
$parcel$export(module.exports, "__spread", function () { return $5df189dad2b9134b$export$afc72e2116322959; });
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var $5df189dad2b9134b$var$extendStatics = function(d, b) {
    $5df189dad2b9134b$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $5df189dad2b9134b$var$extendStatics(d, b);
};
function $5df189dad2b9134b$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $5df189dad2b9134b$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $5df189dad2b9134b$export$18ce0697a983be9b = function() {
    $5df189dad2b9134b$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $5df189dad2b9134b$export$18ce0697a983be9b.apply(this, arguments);
};
function $5df189dad2b9134b$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $5df189dad2b9134b$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $5df189dad2b9134b$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $5df189dad2b9134b$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $5df189dad2b9134b$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $5df189dad2b9134b$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $5df189dad2b9134b$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $5df189dad2b9134b$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $5df189dad2b9134b$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $5df189dad2b9134b$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $5df189dad2b9134b$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $5df189dad2b9134b$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $5df189dad2b9134b$export$45d3717a4c69092e(o, m, p);
}
function $5df189dad2b9134b$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $5df189dad2b9134b$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $5df189dad2b9134b$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($5df189dad2b9134b$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $5df189dad2b9134b$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $5df189dad2b9134b$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $5df189dad2b9134b$export$10c90e4f7922046c(v) {
    return this instanceof $5df189dad2b9134b$export$10c90e4f7922046c ? (this.v = v, this) : new $5df189dad2b9134b$export$10c90e4f7922046c(v);
}
function $5df189dad2b9134b$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $5df189dad2b9134b$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $5df189dad2b9134b$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $5df189dad2b9134b$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $5df189dad2b9134b$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $5df189dad2b9134b$export$19a8beecd37a4c45 === "function" ? $5df189dad2b9134b$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $5df189dad2b9134b$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $5df189dad2b9134b$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $5df189dad2b9134b$var$ownKeys = function(o) {
    $5df189dad2b9134b$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $5df189dad2b9134b$var$ownKeys(o);
};
function $5df189dad2b9134b$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $5df189dad2b9134b$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $5df189dad2b9134b$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $5df189dad2b9134b$var$__setModuleDefault(result, mod);
    return result;
}
function $5df189dad2b9134b$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $5df189dad2b9134b$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $5df189dad2b9134b$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $5df189dad2b9134b$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $5df189dad2b9134b$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $5df189dad2b9134b$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $5df189dad2b9134b$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $5df189dad2b9134b$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $5df189dad2b9134b$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $5df189dad2b9134b$export$2e2bcd8739ae039 = {
    __extends: $5df189dad2b9134b$export$a8ba968b8961cb8a,
    __assign: $5df189dad2b9134b$export$18ce0697a983be9b,
    __rest: $5df189dad2b9134b$export$3c9a16f847548506,
    __decorate: $5df189dad2b9134b$export$29e00dfd3077644b,
    __param: $5df189dad2b9134b$export$d5ad3fd78186038f,
    __esDecorate: $5df189dad2b9134b$export$3a84e1ae4e97e9b0,
    __runInitializers: $5df189dad2b9134b$export$d831c04e792af3d,
    __propKey: $5df189dad2b9134b$export$6a2a36740a146cb8,
    __setFunctionName: $5df189dad2b9134b$export$d1a06452d3489bc7,
    __metadata: $5df189dad2b9134b$export$f1db080c865becb9,
    __awaiter: $5df189dad2b9134b$export$1050f835b63b671e,
    __generator: $5df189dad2b9134b$export$67ebef60e6f28a6,
    __createBinding: $5df189dad2b9134b$export$45d3717a4c69092e,
    __exportStar: $5df189dad2b9134b$export$f33643c0debef087,
    __values: $5df189dad2b9134b$export$19a8beecd37a4c45,
    __read: $5df189dad2b9134b$export$8d051b38c9118094,
    __spread: $5df189dad2b9134b$export$afc72e2116322959,
    __spreadArrays: $5df189dad2b9134b$export$6388937ca91ccae8,
    __spreadArray: $5df189dad2b9134b$export$1216008129fb82ed,
    __await: $5df189dad2b9134b$export$10c90e4f7922046c,
    __asyncGenerator: $5df189dad2b9134b$export$e427f37a30a4de9b,
    __asyncDelegator: $5df189dad2b9134b$export$bbd80228419bb833,
    __asyncValues: $5df189dad2b9134b$export$e3b29a3d6162315f,
    __makeTemplateObject: $5df189dad2b9134b$export$4fb47efe1390b86f,
    __importStar: $5df189dad2b9134b$export$c21735bcef00d192,
    __importDefault: $5df189dad2b9134b$export$da59b14a69baef04,
    __classPrivateFieldGet: $5df189dad2b9134b$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $5df189dad2b9134b$export$d40a35129aaff81f,
    __classPrivateFieldIn: $5df189dad2b9134b$export$81fdc39f203e4e04,
    __addDisposableResource: $5df189dad2b9134b$export$88ac25d8e944e405,
    __disposeResources: $5df189dad2b9134b$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $5df189dad2b9134b$export$889dfb5d17574b0b
};

});

parcelRegister("fn59F", function(module, exports) {

$parcel$export(module.exports, "toFileWithPath", function () { return $b30d00ad0325b85b$export$8cc09085015f0dc7; });
var $b30d00ad0325b85b$export$db0345794bfc14ed = new Map([
    [
        "avi",
        "video/avi"
    ],
    [
        "gif",
        "image/gif"
    ],
    [
        "ico",
        "image/x-icon"
    ],
    [
        "jpeg",
        "image/jpeg"
    ],
    [
        "jpg",
        "image/jpeg"
    ],
    [
        "mkv",
        "video/x-matroska"
    ],
    [
        "mov",
        "video/quicktime"
    ],
    [
        "mp4",
        "video/mp4"
    ],
    [
        "pdf",
        "application/pdf"
    ],
    [
        "png",
        "image/png"
    ],
    [
        "zip",
        "application/zip"
    ],
    [
        "doc",
        "application/msword"
    ],
    [
        "docx",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
    ]
]);
function $b30d00ad0325b85b$export$8cc09085015f0dc7(file, path) {
    var f = $b30d00ad0325b85b$var$withMimeType(file);
    if (typeof f.path !== "string") {
        var webkitRelativePath = file.webkitRelativePath;
        Object.defineProperty(f, "path", {
            value: typeof path === "string" ? path : typeof webkitRelativePath === "string" && webkitRelativePath.length > 0 ? webkitRelativePath : file.name,
            writable: false,
            configurable: false,
            enumerable: true
        });
    }
    return f;
}
function $b30d00ad0325b85b$var$withMimeType(file) {
    var name = file.name;
    var hasExtension = name && name.lastIndexOf(".") !== -1;
    if (hasExtension && !file.type) {
        var ext = name.split(".").pop().toLowerCase();
        var type = $b30d00ad0325b85b$export$db0345794bfc14ed.get(ext);
        if (type) Object.defineProperty(file, "type", {
            value: type,
            writable: false,
            configurable: false,
            enumerable: true
        });
    }
    return file;
}

});



parcelRegister("1V0AZ", function(module, exports) {

$parcel$export(module.exports, "TOO_MANY_FILES_REJECTION", function () { return $165b93986d353951$export$1e1e1b6120329fe; });
$parcel$export(module.exports, "fileAccepted", function () { return $165b93986d353951$export$b511db3632effe58; });
$parcel$export(module.exports, "fileMatchSize", function () { return $165b93986d353951$export$860631d45ba43fd9; });
$parcel$export(module.exports, "allFilesAccepted", function () { return $165b93986d353951$export$6a0bb4322c81a197; });
$parcel$export(module.exports, "isPropagationStopped", function () { return $165b93986d353951$export$8d6d6472146de265; });
$parcel$export(module.exports, "isEvtWithFiles", function () { return $165b93986d353951$export$52f1fc875a1e5986; });
$parcel$export(module.exports, "onDocumentDragOver", function () { return $165b93986d353951$export$2ead263d6635cecc; });
$parcel$export(module.exports, "isIeOrEdge", function () { return $165b93986d353951$export$d3498e653911f962; });
$parcel$export(module.exports, "composeEventHandlers", function () { return $165b93986d353951$export$b9ecd428b558ff10; });

var $aEM59 = parcelRequire("aEM59");
function $165b93986d353951$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $165b93986d353951$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $165b93986d353951$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $165b93986d353951$var$_typeof(obj);
}
function $165b93986d353951$var$_slicedToArray(arr, i) {
    return $165b93986d353951$var$_arrayWithHoles(arr) || $165b93986d353951$var$_iterableToArrayLimit(arr, i) || $165b93986d353951$var$_unsupportedIterableToArray(arr, i) || $165b93986d353951$var$_nonIterableRest();
}
function $165b93986d353951$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $165b93986d353951$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $165b93986d353951$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $165b93986d353951$var$_arrayLikeToArray(o, minLen);
}
function $165b93986d353951$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $165b93986d353951$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $165b93986d353951$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $165b93986d353951$export$d2c35cc369247232 = "file-invalid-type";
var $165b93986d353951$export$d7bd1185abe1e87c = "file-too-large";
var $165b93986d353951$export$8bd5ec6ed990dc9 = "file-too-small";
var $165b93986d353951$export$3271ef1d2dd155f9 = "too-many-files";
var $165b93986d353951$export$d4e71bc0b80dc0fb = {
    FileInvalidType: $165b93986d353951$export$d2c35cc369247232,
    FileTooLarge: $165b93986d353951$export$d7bd1185abe1e87c,
    FileTooSmall: $165b93986d353951$export$8bd5ec6ed990dc9,
    TooManyFiles: $165b93986d353951$export$3271ef1d2dd155f9
}; // File Errors
var $165b93986d353951$export$bc0bbda045f09b5a = function getInvalidTypeRejectionErr(accept) {
    accept = Array.isArray(accept) && accept.length === 1 ? accept[0] : accept;
    var messageSuffix = Array.isArray(accept) ? "one of ".concat(accept.join(", ")) : accept;
    return {
        code: $165b93986d353951$export$d2c35cc369247232,
        message: "File type must be ".concat(messageSuffix)
    };
};
var $165b93986d353951$export$b70c322af07b9d49 = function getTooLargeRejectionErr(maxSize) {
    return {
        code: $165b93986d353951$export$d7bd1185abe1e87c,
        message: "File is larger than ".concat(maxSize, " bytes")
    };
};
var $165b93986d353951$export$d61cfd6dff5a3e22 = function getTooSmallRejectionErr(minSize) {
    return {
        code: $165b93986d353951$export$8bd5ec6ed990dc9,
        message: "File is smaller than ".concat(minSize, " bytes")
    };
};
var $165b93986d353951$export$1e1e1b6120329fe = {
    code: $165b93986d353951$export$3271ef1d2dd155f9,
    message: "Too many files"
}; // Firefox versions prior to 53 return a bogus MIME type for every file drag, so dragovers with
function $165b93986d353951$export$b511db3632effe58(file, accept) {
    var isAcceptable = file.type === "application/x-moz-file" || (0, $aEM59.default)(file, accept);
    return [
        isAcceptable,
        isAcceptable ? null : $165b93986d353951$export$bc0bbda045f09b5a(accept)
    ];
}
function $165b93986d353951$export$860631d45ba43fd9(file, minSize, maxSize) {
    if ($165b93986d353951$var$isDefined(file.size)) {
        if ($165b93986d353951$var$isDefined(minSize) && $165b93986d353951$var$isDefined(maxSize)) {
            if (file.size > maxSize) return [
                false,
                $165b93986d353951$export$b70c322af07b9d49(maxSize)
            ];
            if (file.size < minSize) return [
                false,
                $165b93986d353951$export$d61cfd6dff5a3e22(minSize)
            ];
        } else if ($165b93986d353951$var$isDefined(minSize) && file.size < minSize) return [
            false,
            $165b93986d353951$export$d61cfd6dff5a3e22(minSize)
        ];
        else if ($165b93986d353951$var$isDefined(maxSize) && file.size > maxSize) return [
            false,
            $165b93986d353951$export$b70c322af07b9d49(maxSize)
        ];
    }
    return [
        true,
        null
    ];
}
function $165b93986d353951$var$isDefined(value) {
    return value !== undefined && value !== null;
}
function $165b93986d353951$export$6a0bb4322c81a197(_ref) {
    var files = _ref.files, accept = _ref.accept, minSize = _ref.minSize, maxSize = _ref.maxSize, multiple = _ref.multiple, maxFiles = _ref.maxFiles;
    if (!multiple && files.length > 1 || multiple && maxFiles >= 1 && files.length > maxFiles) return false;
    return files.every(function(file) {
        var _fileAccepted = $165b93986d353951$export$b511db3632effe58(file, accept), _fileAccepted2 = $165b93986d353951$var$_slicedToArray(_fileAccepted, 1), accepted = _fileAccepted2[0];
        var _fileMatchSize = $165b93986d353951$export$860631d45ba43fd9(file, minSize, maxSize), _fileMatchSize2 = $165b93986d353951$var$_slicedToArray(_fileMatchSize, 1), sizeMatch = _fileMatchSize2[0];
        return accepted && sizeMatch;
    });
} // React's synthetic events has event.isPropagationStopped,
function $165b93986d353951$export$8d6d6472146de265(event) {
    if (typeof event.isPropagationStopped === "function") return event.isPropagationStopped();
    else if (typeof event.cancelBubble !== "undefined") return event.cancelBubble;
    return false;
}
function $165b93986d353951$export$52f1fc875a1e5986(event) {
    if (!event.dataTransfer) return !!event.target && !!event.target.files;
     // https://developer.mozilla.org/en-US/docs/Web/API/DataTransfer/types
    // https://developer.mozilla.org/en-US/docs/Web/API/HTML_Drag_and_Drop_API/Recommended_drag_types#file
    return Array.prototype.some.call(event.dataTransfer.types, function(type) {
        return type === "Files" || type === "application/x-moz-file";
    });
}
function $165b93986d353951$export$f9006bf02b243736(item) {
    return $165b93986d353951$var$_typeof(item) === "object" && item !== null && item.kind === "file";
} // allow the entire document to be a drag target
function $165b93986d353951$export$2ead263d6635cecc(event) {
    event.preventDefault();
}
function $165b93986d353951$var$isIe(userAgent) {
    return userAgent.indexOf("MSIE") !== -1 || userAgent.indexOf("Trident/") !== -1;
}
function $165b93986d353951$var$isEdge(userAgent) {
    return userAgent.indexOf("Edge/") !== -1;
}
function $165b93986d353951$export$d3498e653911f962() {
    var userAgent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.navigator.userAgent;
    return $165b93986d353951$var$isIe(userAgent) || $165b93986d353951$var$isEdge(userAgent);
}
function $165b93986d353951$export$b9ecd428b558ff10() {
    for(var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++)fns[_key] = arguments[_key];
    return function(event) {
        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
        return fns.some(function(fn) {
            if (!$165b93986d353951$export$8d6d6472146de265(event) && fn) fn.apply(void 0, [
                event
            ].concat(args));
            return $165b93986d353951$export$8d6d6472146de265(event);
        });
    };
}

});
parcelRegister("aEM59", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7c22efe499fb7e9c$export$2e2bcd8739ae039; }, function (v) { return $7c22efe499fb7e9c$export$2e2bcd8739ae039 = v; });
var $7c22efe499fb7e9c$export$1e511d4a378977f5;
var $7c22efe499fb7e9c$export$2e2bcd8739ae039;
"use strict";
$7c22efe499fb7e9c$export$1e511d4a378977f5 = true;
$7c22efe499fb7e9c$export$2e2bcd8739ae039 = function(file, acceptedFiles) {
    if (file && acceptedFiles) {
        var acceptedFilesArray = Array.isArray(acceptedFiles) ? acceptedFiles : acceptedFiles.split(",");
        var fileName = file.name || "";
        var mimeType = (file.type || "").toLowerCase();
        var baseMimeType = mimeType.replace(/\/.*$/, "");
        return acceptedFilesArray.some(function(type) {
            var validType = type.trim().toLowerCase();
            if (validType.charAt(0) === ".") return fileName.toLowerCase().endsWith(validType);
            else if (validType.endsWith("/*")) // This is something like a image/* mime type
            return baseMimeType === validType.replace(/\/.*$/, "");
            return mimeType === validType;
        });
    }
    return true;
};

});



parcelRegister("3aX8U", function(module, exports) {

$parcel$export(module.exports, "ButtonWidget", function () { return $25002ecc5e8e6f6a$export$847e7b2f507a231c; });

var $4vwom = parcelRequire("4vwom");
parcelRequire("eeH7J");

var $fT6Pt = parcelRequire("fT6Pt");

var $hV5w0 = parcelRequire("hV5w0");

var $4rY0U = parcelRequire("4rY0U");

var $9Q5xE = parcelRequire("9Q5xE");
(0, $4rY0U.RegisterWidget)("Button", ({ value: value })=>(0, $4vwom.jsx)($25002ecc5e8e6f6a$export$847e7b2f507a231c, Object.assign({}, value)));
function $25002ecc5e8e6f6a$export$847e7b2f507a231c({ widgetKey: widgetKey, prompt: prompt, text: text, action: action, dropdown: dropdown, disabled: disabled, icon: icon, chevron: chevron, style: style, link: link, openLinkInNewTab: openLinkInNewTab }) {
    const performAction = (0, $hV5w0.usePerformWidgetAction)();
    const special = style === "download" || style === "print";
    return (0, $4vwom.jsx)((0, $fT6Pt.RButton), {
        variant: style === "primary" ? "primary" : special ? undefined : "secondary",
        disabled: disabled,
        link: link,
        openLinkInNewTab: openLinkInNewTab,
        popup: dropdown ? ()=>(0, $4vwom.jsx)("div", {
                children: dropdown.map((d, i)=>(0, $4vwom.jsx)((0, $4rY0U.WidgetView), {
                        value: d
                    }, d && typeof d === "object" && "widgetKey" in d ? d.widgetKey : i))
            }) : undefined,
        style: special ? {
            color: (0, $9Q5xE.ColorStyles).gray[700]
        } : style === "filters" ? {
            maxWidth: 120,
            color: "black"
        } : style === "filters-active" ? (hover)=>({
                maxWidth: 120,
                backgroundColor: hover ? "#107569" : "#125D56",
                color: "white"
            }) : undefined,
        color: style === "filters" ? "#344053" : style === "filters-active" ? "white" : undefined,
        borderColor: style === "filters" ? "#D2D7DE" : undefined,
        icon: icon !== null && icon !== void 0 ? icon : style === "download" ? "ui-download-cloud-02" : style === "print" ? "ui-printer" : undefined,
        chevron: chevron !== null && chevron !== void 0 ? chevron : dropdown && !special ? "ellipsis-v" : undefined,
        hideChevron: style === "filters" || style === "filters-active" || special,
        onClick: async ()=>{
            try {
                if (link) return;
                if (dropdown) // This is a dropdown button, not an action button
                return;
                if (prompt && !confirm(prompt)) return;
                if (action instanceof Function) action();
                else if (widgetKey) await performAction(widgetKey);
                else console.log("No action specified");
            } catch (e) {
                alert("detail" in e ? e.detail : "message" in e ? e.message : JSON.stringify(e));
            }
        },
        children: special ? undefined : text
    }, widgetKey);
}

});

parcelRegister("8IeBr", function(module, exports) {

$parcel$export(module.exports, "DirectionContext", function () { return $657dc2a50c73b630$export$46f936cc30cb9075; });

var $4vwom = parcelRequire("4vwom");

var $eeH7J = parcelRequire("eeH7J");

var $bUDfc = parcelRequire("bUDfc");

var $4rY0U = parcelRequire("4rY0U");
const $657dc2a50c73b630$export$46f936cc30cb9075 = /*#__PURE__*/ (0, $eeH7J.createContext)("column");
/** Dashboard layout is made using arrays.
 *
 *  By default, layout is column-wise flexbox, and it alternates between row and column flexing with
 *  each nested array.
 *
 *  For more control, use the Layout() widget (or the Row() and Column() shortcuts
 */ (0, $4rY0U.RegisterWidget)(({ value: value })=>value instanceof Array, ({ value: value, isRoot: isRoot })=>{
    const flexDirection = (0, $eeH7J.useContext)($657dc2a50c73b630$export$46f936cc30cb9075);
    return (0, $4vwom.jsx)($657dc2a50c73b630$var$LayoutWidget, {
        value: {
            type: "Layout",
            direction: flexDirection,
            children: value
        },
        isRoot: isRoot
    });
});
(0, $4rY0U.RegisterWidget)("Layout", $657dc2a50c73b630$var$LayoutWidget);
function $657dc2a50c73b630$var$LayoutWidget({ value: value, isRoot: isRoot }) {
    var _a;
    const contextDirection = (0, $eeH7J.useContext)($657dc2a50c73b630$export$46f936cc30cb9075);
    const flexDirection = (_a = value.direction) !== null && _a !== void 0 ? _a : contextDirection;
    function isHero(w) {
        return w && typeof w === "object" && "isHero" in w && w.isHero;
    }
    const anyHeroes = !!isRoot && value.children.some(isHero);
    return (0, $4vwom.jsx)("div", {
        className: value.className,
        style: Object.assign({
            width: flexDirection === "row" ? "100%" : undefined,
            display: "flex",
            flexDirection: flexDirection,
            marginLeft: anyHeroes ? undefined : isRoot ? 8 : undefined,
            marginRight: anyHeroes ? undefined : isRoot ? 8 : undefined
        }, value.style),
        children: (0, $4vwom.jsx)($657dc2a50c73b630$export$46f936cc30cb9075.Provider, {
            value: flexDirection === "row" ? "column" : "row",
            children: value.children.map((w)=>{
                // Skip `null`'s in the layout instead of displaying `null` (which is rarely
                // the desired effect). This allows server side rendering to use logical
                // operators to conditionaly render things inline in a list.
                if (w === null) return undefined;
                const key = typeof w === "object" && "widgetKey" in w ? w.widgetKey : undefined;
                const widget = (0, $4vwom.jsx)((0, $4rY0U.WidgetView), {
                    value: w,
                    isRoot: false
                }, key);
                if (flexDirection === "row") {
                    const flex = (0, $bUDfc.IsWidgetBase)(w) ? w.flex : undefined;
                    return (0, $4vwom.jsx)("div", {
                        style: {
                            flex: flex === null ? undefined : flex !== null && flex !== void 0 ? flex : 1,
                            display: "flex",
                            flexDirection: "column"
                        },
                        children: widget
                    }, key);
                }
                if (!anyHeroes || isHero(w)) return widget;
                return (0, $4vwom.jsx)("div", {
                    style: {
                        marginLeft: 8,
                        marginRight: 8,
                        display: "flex",
                        flexDirection: flexDirection
                    },
                    children: widget
                }, key);
            })
        })
    });
}

});

parcelRegister("9AQ2B", function(module, exports) {

$parcel$export(module.exports, "TitleWidget", function () { return $6fbfd81e281a4777$export$db5aa76567374c39; });

var $4vwom = parcelRequire("4vwom");

var $kxVwU = parcelRequire("kxVwU");

var $l079f = parcelRequire("l079f");

var $6kZET = parcelRequire("6kZET");

var $ht6im = parcelRequire("ht6im");

var $4rY0U = parcelRequire("4rY0U");

var $6sp4J = parcelRequire("6sp4J");

var $i863C = parcelRequire("i863C");
parcelRequire("2LTO8");
var $8h5s0 = parcelRequire("8h5s0");
(0, $4rY0U.RegisterWidget)("Title", ({ value: value })=>(0, $4vwom.jsx)($6fbfd81e281a4777$export$db5aa76567374c39, Object.assign({}, value)));
function $6fbfd81e281a4777$export$db5aa76567374c39(props) {
    var _a;
    const imageBase64 = (0, $i863C.useImageWithAuth)(props.imageUrl);
    const color = (_a = props.color) !== null && _a !== void 0 ? _a : (0, $l079f.UntitledUI).randomSecondaryColor(props.title);
    const heroAvatar = props.heroImageUrl ? {
        marginLeft: 8,
        marginTop: -48,
        width: 164,
        height: 164
    } : undefined;
    const avatar = (props.imageUrl || props.icon) && (0, $4vwom.jsx)("div", {
        id: heroAvatar ? "studio-title-hero-avatar" : "studio-title-avatar",
        className: "studio-title-widget-avatar",
        style: Object.assign({
            width: 84,
            height: 84,
            marginRight: 24,
            borderRadius: 82,
            display: "flex",
            flexDirection: "column",
            textAlign: "center",
            alignItems: "center",
            justifyContent: "center",
            boxShadow: "0px -4px 6px -2px #10182810, 0px 8px 16px -4px #10182814",
            border: "4px solid white",
            color: color[800],
            fontSize: 32,
            lineHeight: 2.5,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundColor: color[100],
            backgroundImage: imageBase64 ? `url(${imageBase64})` : props.imageUrl ? `url(${props.imageUrl})` : undefined
        }, heroAvatar),
        children: !props.imageUrl && props.icon && (0, $4vwom.jsx)((0, $6sp4J.Icon), {
            icon: props.icon,
            color: color[800],
            size: 32
        })
    });
    const buttons = (0, $4vwom.jsxs)("div", {
        style: {
            display: "flex",
            flexDirection: "row",
            marginTop: 16,
            marginRight: 16
        },
        children: [
            props.buttons,
            props.widget && (0, $4vwom.jsx)((0, $4rY0U.WidgetView), {
                value: props.widget
            })
        ]
    });
    const body = (0, $4vwom.jsxs)((0, $4vwom.Fragment), {
        children: [
            props.breadcrumbs && (0, $4vwom.jsx)((0, $6kZET.BreadcrumbsWidget), {
                type: "Breadcrumbs",
                crumbs: props.breadcrumbs
            }),
            (0, $4vwom.jsxs)("div", {
                className: "studio-title-widget-body",
                style: {
                    paddingLeft: 16,
                    paddingBottom: 16,
                    paddingTop: heroAvatar || props.level === 2 ? 0 : 16,
                    display: "flex"
                },
                children: [
                    avatar,
                    (0, $4vwom.jsxs)("div", {
                        id: props.heroImageUrl ? "studio-title-hero" : "studio-title",
                        style: {
                            display: "flex",
                            flexDirection: "column",
                            flex: 1,
                            justifyContent: "center"
                        },
                        children: [
                            (0, $4vwom.jsxs)("div", {
                                style: {
                                    fontSize: props.level === 2 ? 18 : 30,
                                    fontWeight: 500,
                                    lineHeight: props.level === 2 ? "20px" : "38px",
                                    marginTop: props.level === 2 ? 8 : 4,
                                    marginBottom: 4,
                                    display: "flex",
                                    flexDirection: "row",
                                    alignItems: "center"
                                },
                                children: [
                                    (0, $8h5s0.ellipsize)(props.title, 300),
                                    (0, $4vwom.jsx)("div", {
                                        style: {
                                            width: 16
                                        }
                                    }),
                                    props.chips ? (props.chips instanceof Array ? props.chips : [
                                        props.chips
                                    ]).map((chip)=>(0, $4vwom.jsx)((0, $ht6im.ChipWidget), {
                                            value: chip
                                        })) : undefined
                                ]
                            }),
                            (0, $4vwom.jsx)("div", {
                                style: {
                                    fontSize: props.level === 2 ? 14 : 16,
                                    fontWeight: 400,
                                    color: (0, $l079f.UntitledUI).colorStyles.gray[500]
                                },
                                children: props.subTitle ? (0, $8h5s0.ellipsize)(props.subTitle, 300) : undefined
                            })
                        ]
                    }),
                    buttons
                ]
            })
        ]
    });
    if (props.heroImageUrl) return (0, $4vwom.jsxs)("div", {
        style: {
            display: "flex",
            flexDirection: "column",
            marginBottom: 32
        },
        children: [
            (0, $4vwom.jsx)("div", {
                id: "studio-title-hero-image",
                style: {
                    backgroundImage: `url(${props.heroImageUrl})`
                },
                children: (0, $4vwom.jsx)("div", {
                    style: {
                        flex: 1
                    }
                })
            }),
            body
        ]
    });
    if (props.sticky) return (0, $4vwom.jsx)((0, $kxVwU.StickyHeader), {
        children: body
    });
    return body;
}

});
parcelRegister("kxVwU", function(module, exports) {

$parcel$export(module.exports, "StickyHeader", function () { return $ef5383ed4b63cdcb$export$6ccfe534fa2728ed; });

var $4vwom = parcelRequire("4vwom");
parcelRequire("eeH7J");
function $ef5383ed4b63cdcb$export$6ccfe534fa2728ed({ children: children }) {
    return (0, $4vwom.jsx)("div", {
        style: {
            position: "sticky",
            zIndex: 9,
            top: 0,
            backgroundColor: "#ffffffe8",
            backdropFilter: "blur(10px)",
            WebkitBackdropFilter: "blur(10px)"
        },
        children: children
    });
}

});

parcelRegister("6kZET", function(module, exports) {

$parcel$export(module.exports, "BreadcrumbsWidget", function () { return $49d47070e574ed94$export$62fd15cbabe75efd; });

var $4vwom = parcelRequire("4vwom");
parcelRequire("eeH7J");

var $5K1mb = parcelRequire("5K1mb");

var $4rY0U = parcelRequire("4rY0U");

var $9Q5xE = parcelRequire("9Q5xE");
(0, $4rY0U.RegisterWidget)("Breadcrumbs", ({ value: value })=>(0, $4vwom.jsx)($49d47070e574ed94$export$62fd15cbabe75efd, Object.assign({}, value)));
function $49d47070e574ed94$export$62fd15cbabe75efd({ crumbs: crumbs }) {
    return (0, $4vwom.jsx)("div", {
        style: {
            display: "flex",
            flexDirection: "row",
            color: (0, $9Q5xE.ColorStyles).gray[600],
            marginTop: 16,
            marginLeft: 16
        },
        children: crumbs.map((c, i)=>(0, $4vwom.jsxs)("div", {
                style: {
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    marginRight: 12
                },
                children: [
                    c.icon && (0, $4vwom.jsx)("i", {
                        className: `fas fa-${c.icon}`,
                        style: {
                            marginRight: 8
                        }
                    }),
                    c.link ? (0, $4vwom.jsx)((0, $5K1mb.Link), {
                        style: {
                            color: (0, $9Q5xE.ColorStyles).primary[600],
                            textDecoration: "none"
                        },
                        to: c.link,
                        children: c.text
                    }) : (0, $4vwom.jsx)("div", {
                        children: c.text
                    }),
                    i < crumbs.length - 1 && (0, $4vwom.jsx)("i", {
                        className: "fas fa-chevron-right",
                        style: {
                            marginLeft: 16,
                            marginTop: 2,
                            color: (0, $9Q5xE.ColorStyles).gray[400]
                        }
                    })
                ]
            }))
    });
}

});

parcelRegister("i863C", function(module, exports) {

$parcel$export(module.exports, "useImageWithAuth", function () { return $d32dac3a0736a613$export$ec73bf429956a3f6; });

var $eeH7J = parcelRequire("eeH7J");

var $dUDPg = parcelRequire("dUDPg");
function $d32dac3a0736a613$export$ec73bf429956a3f6(imageUrl) {
    const [image, setImage] = (0, $eeH7J.useState)();
    (0, $eeH7J.useEffect)(()=>{
        async function fetchBlob() {
            try {
                if (imageUrl) {
                    const response = await fetch(imageUrl, {
                        headers: (0, $dUDPg.defaults).headers
                    });
                    const blob = await response.blob();
                    const base64 = await $d32dac3a0736a613$var$blobToBase64(blob);
                    setImage(base64);
                }
            } catch (e) {}
        }
        fetchBlob();
    }, [
        imageUrl
    ]);
    return image;
}
// Source: https://stackoverflow.com/a/18650249
function $d32dac3a0736a613$var$blobToBase64(blob) {
    return new Promise((resolve, _)=>{
        const reader = new FileReader();
        reader.onloadend = ()=>resolve(reader.result);
        reader.readAsDataURL(blob);
    });
}

});


parcelRegister("7iytm", function(module, exports) {

$parcel$export(module.exports, "UploadFile", function () { return $5504f45d02854992$export$48030d8a30a8103a; });

var $7m9cQ = parcelRequire("7m9cQ");

var $dUDPg = parcelRequire("dUDPg");
async function $5504f45d02854992$export$48030d8a30a8103a(/** The ID or name of the target folder.
 *
 *  Folder names can only be used for top-level folders, e.g. "Media". If
 *  the folder name is ambiguous, an error will be thrown.
 */ folder, /** The file to upload, or string contents of the file. If a string is
 *  provided, it will be uploaded as a text/plain file by default. Set the
 *  mimetype parameter to override
 */ file, /** The mimetype of the file. If not provided, `file.type` will be used.
 *
 *  For string uploads, this defaults to `text/plain`.
 */ mimetype = typeof file === "string" ? "text/plain" : file.type, /**
 * Whether the file should be temporary. If `true`, the file
 * will be deleted by an interval job as long as it is not associated with a collection entity.
 */ temporaryFile = false, share, fileName) {
    const data = new FormData();
    if (typeof file === "string") data.append("file", new Blob([
        file
    ], {
        type: mimetype
    }), fileName);
    else data.append("file", file, fileName);
    try {
        const query = {
            mimetype: mimetype,
            temporaryFile: temporaryFile.toString(),
            share: share,
            originalFileName: fileName
        };
        const r = await fetch(`${(0, $7m9cQ.server)()}/api/folders/${folder}/files?${Object.keys(query).map((key)=>query[key] ? `${key}=${encodeURIComponent(query[key])}` : undefined).filter((x)=>!!x).join("&")}`, {
            method: "POST",
            body: data,
            headers: {
                Authorization: (0, $dUDPg.defaults).headers.Authorization
            }
        });
        if (r.status !== 200) throw await r.json();
        const j = await r.json();
        return j.files[0].id;
    } catch (e) {
        if ("message" in e) alert(e.message);
        if ("detail" in e) alert(e.detail);
        else alert(JSON.stringify(e));
    }
}

});

parcelRegister("aIeEI", function(module, exports) {

$parcel$export(module.exports, "useCurrentLocale", function () { return $7cc961c72a2c0f12$export$d9e9761b61d7319b; });
$parcel$export(module.exports, "useLocalize", function () { return $7cc961c72a2c0f12$export$917bfb70a1457f2; });

var $cSf8f = parcelRequire("cSf8f");

var $eeH7J = parcelRequire("eeH7J");

var $7FrRx = parcelRequire("7FrRx");
function $7cc961c72a2c0f12$export$d9e9761b61d7319b() {
    return (0, $eeH7J.useContext)((0, $7FrRx.CurrentLocaleContext)).locale;
}
function $7cc961c72a2c0f12$export$917bfb70a1457f2() {
    const locale = $7cc961c72a2c0f12$export$d9e9761b61d7319b();
    return (value, overrideLocale)=>(0, $cSf8f.ClientSideLocalize)(value, overrideLocale !== null && overrideLocale !== void 0 ? overrideLocale : locale);
}

});
parcelRegister("7FrRx", function(module, exports) {

$parcel$export(module.exports, "CurrentLocaleContext", function () { return $5951f9a34f46838c$export$51408e13a5fe5fdf; });
$parcel$export(module.exports, "CurrentLocaleProvider", function () { return $5951f9a34f46838c$export$ebf98238f79ad6b9; });

var $4vwom = parcelRequire("4vwom");

var $eeH7J = parcelRequire("eeH7J");

var $eK8Q4 = parcelRequire("eK8Q4");

var $dUDPg = parcelRequire("dUDPg");
const $5951f9a34f46838c$export$51408e13a5fe5fdf = /*#__PURE__*/ (0, $eeH7J.createContext)({
    locale: "en"
});
function $5951f9a34f46838c$export$ebf98238f79ad6b9(props) {
    const locales = (0, $dUDPg.useLocales)();
    const [locale, setLocale] = (0, $eK8Q4.usePreference)("editing-locale", "en");
    if (locales.data && !locales.data.some((x)=>x.key === locale)) setLocale(locales.data[0].key);
    return (0, $4vwom.jsx)($5951f9a34f46838c$export$51408e13a5fe5fdf.Provider, {
        value: {
            locale: locale,
            setLocale: setLocale
        },
        children: props.children
    });
}

});


parcelRegister("kHZ99", function(module, exports) {

$parcel$export(module.exports, "TableWidgetFilters", function () { return $f137413f1b2da15a$export$5c7c2351d4f8b9e; });

var $4vwom = parcelRequire("4vwom");

var $fT6Pt = parcelRequire("fT6Pt");

var $9Q5xE = parcelRequire("9Q5xE");

var $6sp4J = parcelRequire("6sp4J");

var $dUDPg = parcelRequire("dUDPg");

var $ikBJm = parcelRequire("ikBJm");

var $ch3mo = parcelRequire("ch3mo");
const $f137413f1b2da15a$var$buttonStyle = {
    border: `1px solid ${(0, $9Q5xE.ColorStyles).gray[300]}`,
    fontSize: 14,
    boxShadow: "0px 1px 2px 0px #1018280D"
};
function $f137413f1b2da15a$export$5c7c2351d4f8b9e(localize, propsfilters, filters, setFilters, collectionName, refresh) {
    return (0, $4vwom.jsxs)((0, $fT6Pt.RButton), {
        style: Object.assign(Object.assign({}, $f137413f1b2da15a$var$buttonStyle), {
            marginLeft: 12,
            fontSize: 14
        }),
        active: filters.length > 0,
        popup: (close)=>{
            return (0, $4vwom.jsxs)("div", {
                children: [
                    propsfilters === null || propsfilters === void 0 ? void 0 : propsfilters.map((f)=>{
                        const existing = filters.find((x)=>x.id === f.id);
                        const include = existing && existing.mode === "include";
                        const exclude = existing && existing.mode === "exclude";
                        const tickButtonStyle = (active, color = "success")=>({
                                width: 32,
                                height: 32,
                                paddingLeft: 5,
                                paddingRight: 5,
                                alignItems: "center",
                                justifyContent: "center",
                                paddingTop: 2,
                                paddingBottom: 2,
                                borderRadius: 6,
                                fontSize: 14,
                                color: (0, $9Q5xE.ColorStyles)[color][600],
                                background: (0, $9Q5xE.ColorStyles)[color][active ? 400 : 50],
                                border: "1px solid " + (0, $9Q5xE.ColorStyles)[color][300]
                            });
                        return (0, $4vwom.jsxs)("div", {
                            style: {
                                display: "flex",
                                flexDirection: "row",
                                alignItems: "center",
                                paddingTop: 2,
                                paddingLeft: 6,
                                paddingRight: 6,
                                paddingBottom: 2,
                                borderRadius: 6,
                                border: "1px solid " + (0, $9Q5xE.ColorStyles).gray[300]
                            },
                            children: [
                                (0, $4vwom.jsx)("div", {
                                    style: {
                                        marginRight: 24,
                                        fontSize: 14
                                    },
                                    children: localize(f.description)
                                }),
                                (0, $4vwom.jsx)("button", {
                                    style: tickButtonStyle(!!include),
                                    onClick: ()=>{
                                        if (existing) {
                                            if (existing.mode === "include") setFilters(filters.filter((x)=>x.id !== f.id));
                                            else setFilters(filters.map((x)=>x.id === f.id ? Object.assign(Object.assign({}, f), {
                                                    mode: "include"
                                                }) : x));
                                        } else setFilters([
                                            ...filters,
                                            Object.assign(Object.assign({}, f), {
                                                mode: "include"
                                            })
                                        ]);
                                    },
                                    children: (0, $4vwom.jsx)((0, $6sp4J.Icon), {
                                        icon: "ui-plus"
                                    })
                                }),
                                (0, $4vwom.jsx)("button", {
                                    style: tickButtonStyle(!!exclude),
                                    onClick: ()=>{
                                        if (existing) {
                                            if (existing.mode === "exclude") setFilters(filters.filter((x)=>x.id !== f.id));
                                            else setFilters(filters.map((x)=>x.id === f.id ? Object.assign(Object.assign({}, f), {
                                                    mode: "exclude"
                                                }) : x));
                                        } else setFilters([
                                            ...filters,
                                            Object.assign(Object.assign({}, f), {
                                                mode: "exclude"
                                            })
                                        ]);
                                    },
                                    children: (0, $4vwom.jsx)((0, $6sp4J.Icon), {
                                        icon: "ui-minus"
                                    })
                                }),
                                (0, $4vwom.jsx)("button", {
                                    style: Object.assign(Object.assign({}, tickButtonStyle(false, "error")), {
                                        marginLeft: 6
                                    }),
                                    onClick: async ()=>{
                                        if (confirm("Are you sure you want to delete this filter?")) {
                                            await (0, $dUDPg.deleteStudioTableFilter)(f.id);
                                            refresh();
                                        }
                                    },
                                    children: (0, $4vwom.jsx)((0, $6sp4J.Icon), {
                                        icon: "ui-trash-01"
                                    })
                                }),
                                (0, $4vwom.jsx)("button", {
                                    style: Object.assign(Object.assign({}, tickButtonStyle(false, "blue")), {
                                        marginLeft: 6
                                    }),
                                    onClick: async ()=>{
                                        await (0, $ikBJm.Modal)((close)=>{
                                            return (0, $4vwom.jsx)((0, $ch3mo.FilterEditor), {
                                                title: localize({
                                                    en: "Edit filter",
                                                    no: "Rediger filter",
                                                    sv: "Redigera filter",
                                                    da: "Rediger filter"
                                                }),
                                                id: f.id,
                                                code: f.filterCode,
                                                description: f.description,
                                                collectionName: collectionName,
                                                onSave: async (desc, code)=>{
                                                    await (0, $dUDPg.putStudioTableFilter)(f.id, {
                                                        description: desc,
                                                        filterCode: code,
                                                        private: false
                                                    });
                                                    await refresh();
                                                    close(undefined);
                                                },
                                                onCancel: ()=>close(undefined)
                                            });
                                        });
                                    },
                                    children: (0, $4vwom.jsx)((0, $6sp4J.Icon), {
                                        icon: "ui-pencil-01"
                                    })
                                })
                            ]
                        }, f.id.valueOf());
                    }),
                    (0, $4vwom.jsx)((0, $fT6Pt.RButton), {
                        icon: "ui-plus",
                        variant: "secondary",
                        style: {
                            marginTop: 8
                        },
                        onClick: async ()=>{
                            await (0, $ikBJm.Modal)((close)=>{
                                return (0, $4vwom.jsx)((0, $ch3mo.FilterEditor), {
                                    title: localize({
                                        en: "New filter",
                                        no: "Nytt filter",
                                        sv: "Nytt filter",
                                        da: "Nyt filter"
                                    }),
                                    collectionName: collectionName,
                                    onSave: async (desc, code)=>{
                                        await (0, $dUDPg.postStudioTableFilter)({
                                            collectionName: collectionName,
                                            description: desc,
                                            filterCode: code
                                        });
                                        await refresh();
                                        close(undefined);
                                    },
                                    onCancel: ()=>close(undefined)
                                });
                            });
                        },
                        children: "Add"
                    })
                ]
            });
        },
        children: [
            filters.length === 0 ? localize({
                en: "No filters",
                no: "Ingen filter",
                sv: "Inga filter",
                da: "Ingen"
            }) : "",
            (0, $4vwom.jsx)("div", {
                style: {
                    display: "flex",
                    flexDirection: "row",
                    flexWrap: "wrap"
                },
                children: filters.map((f)=>{
                    var _a, _b;
                    return (0, $4vwom.jsxs)("div", {
                        style: {
                            padding: 2,
                            paddingRight: 6,
                            paddingLeft: 6,
                            borderRadius: 6,
                            color: (0, $9Q5xE.ColorStyles)[f.mode === "include" ? "success" : "error"][600],
                            border: "1px solid " + (0, $9Q5xE.ColorStyles)[f.mode === "include" ? "success" : "error"][300]
                        },
                        children: [
                            (0, $4vwom.jsx)("span", {
                                style: {
                                    marginRight: 4
                                },
                                children: f.mode === "include" ? "+" : "-"
                            }),
                            localize((_b = (_a = propsfilters === null || propsfilters === void 0 ? void 0 : propsfilters.find((x)=>x.id === f.id)) === null || _a === void 0 ? void 0 : _a.description) !== null && _b !== void 0 ? _b : {
                                en: "(unknown filter)"
                            })
                        ]
                    }, f.id.valueOf());
                })
            })
        ]
    });
}

});
parcelRegister("ch3mo", function(module, exports) {

$parcel$export(module.exports, "FilterEditor", function () { return $8ef9adda404ac3d4$export$b790cb7d3d448cad; });

var $4vwom = parcelRequire("4vwom");

var $fT6Pt = parcelRequire("fT6Pt");

var $koJkl = parcelRequire("koJkl");

var $6cx8r = parcelRequire("6cx8r");

var $hRViu = parcelRequire("hRViu");

var $gssTr = parcelRequire("gssTr");

var $i9Kqs = parcelRequire("i9Kqs");

var $dUDPg = parcelRequire("dUDPg");

var $8vTN8 = parcelRequire("8vTN8");

var $9ArIY = parcelRequire("9ArIY");
function $8ef9adda404ac3d4$export$b790cb7d3d448cad(props) {
    var _a, _b, _c;
    const decls = (0, $dUDPg.useStudioTableFilterDeclarationsEndpoint)(props.collectionName);
    const editor = (0, $9ArIY.useYStaticEditor)({
        description: props.description ? Object.assign({}, props.description) : {
            en: ""
        },
        code: (_a = props.code) !== null && _a !== void 0 ? _a : (0, $i9Kqs.TypeScript)("")
    });
    const data = editor.proxy;
    const navigate = (0, $8vTN8.useNavigate)();
    return (0, $4vwom.jsx)((0, $gssTr.LocalesProvider), {
        children: (0, $4vwom.jsxs)("div", {
            style: {
                padding: 16,
                backgroundColor: "white",
                borderRadius: 16,
                width: 600,
                maxWidth: "100%"
            },
            children: [
                (0, $4vwom.jsx)("h2", {
                    children: props.title
                }),
                (0, $4vwom.jsx)((0, $6cx8r.PropView), {
                    obj: editor.root,
                    mode: "inline",
                    buttons: [],
                    property: {
                        name: "description",
                        type: {
                            alias: "Localized",
                            typeArgs: [
                                "string"
                            ],
                            additionalProps: "string",
                            props: [],
                            tags: {
                                multiline: true
                            }
                        }
                    }
                }),
                (0, $4vwom.jsx)((0, $hRViu.PropRow), {
                    buttons: [],
                    label: "Expression",
                    children: (0, $4vwom.jsx)((0, $koJkl.CodeEdit), {
                        language: "typescript",
                        declarations: (_c = (_b = decls.data) === null || _b === void 0 ? void 0 : _b.code) !== null && _c !== void 0 ? _c : "",
                        text: data.code.valueOf(),
                        onEdited: (text)=>data.code = text
                    })
                }),
                (0, $4vwom.jsxs)("div", {
                    style: {
                        display: "flex",
                        flexDirection: "row"
                    },
                    children: [
                        (0, $4vwom.jsx)((0, $fT6Pt.RButton), {
                            onClick: ()=>props.onCancel(),
                            children: "Cancel"
                        }),
                        (0, $4vwom.jsx)((0, $fT6Pt.RButton), {
                            variant: "primary",
                            onClick: ()=>props.onSave(data.description, data.code),
                            children: "Save"
                        }),
                        (0, $4vwom.jsx)("div", {
                            style: {
                                flex: 1
                            }
                        }),
                        props.id ? (0, $4vwom.jsx)((0, $fT6Pt.RButton), {
                            onClick: ()=>{
                                if (props.code !== data.code || JSON.stringify(props.description) !== JSON.stringify(data.description)) {
                                    if (!confirm("You have unsaved changes. Are you sure you want to discard them?")) return;
                                }
                                props.onCancel();
                                navigate(`/studio/studiotablefilters/${props.id}`);
                            },
                            children: "Sharing settings"
                        }) : null
                    ]
                })
            ]
        })
    });
}

});
parcelRegister("gssTr", function(module, exports) {

$parcel$export(module.exports, "LocalesContext", function () { return $bfb5ac729b0000a2$export$106919b855e045f7; });
$parcel$export(module.exports, "useLocalesContext", function () { return $bfb5ac729b0000a2$export$f4bfbb366fc3bb33; });
$parcel$export(module.exports, "LocalesProvider", function () { return $bfb5ac729b0000a2$export$af5ff3ef761dd229; });

var $4vwom = parcelRequire("4vwom");

var $eeH7J = parcelRequire("eeH7J");

var $dUDPg = parcelRequire("dUDPg");
const $bfb5ac729b0000a2$export$106919b855e045f7 = /*#__PURE__*/ (0, $eeH7J.createContext)("not set");
function $bfb5ac729b0000a2$export$f4bfbb366fc3bb33() {
    const locales = (0, $eeH7J.useContext)($bfb5ac729b0000a2$export$106919b855e045f7);
    if (locales === "not set") throw new Error("Missing LocalesProvider - Did you forget to wrap your app in <LocalesProvider>?");
    if (locales === "loading") return undefined;
    return locales;
}
function $bfb5ac729b0000a2$export$af5ff3ef761dd229({ children: children }) {
    const { data: locales } = (0, $dUDPg.useLocales)();
    return (0, $4vwom.jsx)($bfb5ac729b0000a2$export$106919b855e045f7.Provider, {
        value: locales !== null && locales !== void 0 ? locales : "loading",
        children: children
    });
}

});

parcelRegister("i9Kqs", function(module, exports) {

$parcel$export(module.exports, "TypeScript", function () { return $d37d1475a3bdff60$export$c4f459b49f1c6583; });
function $d37d1475a3bdff60$export$c4f459b49f1c6583(source) {
    return source;
}
function $d37d1475a3bdff60$export$aabe954ae25ef123(func) {
    $d37d1475a3bdff60$export$aabe954ae25ef123.functions.push(func);
}
$d37d1475a3bdff60$export$aabe954ae25ef123.functions = [];

});



parcelRegister("5fzQ8", function(module, exports) {

$parcel$export(module.exports, "TableWidgetColumns", function () { return $3d2a2786520b389f$export$c6ced553397753b5; });

var $4vwom = parcelRequire("4vwom");

var $aIeEI = parcelRequire("aIeEI");

var $9Q5xE = parcelRequire("9Q5xE");
function $3d2a2786520b389f$export$c6ced553397753b5(collectionName, colProps, nonPanelColumns, rawColumns, setRawColumns, hiddenColumns, setHiddenColumns) {
    function toggleRawColumn(name) {
        if (rawColumns.includes(name)) setRawColumns(rawColumns.filter((c)=>c !== name));
        else setRawColumns([
            ...rawColumns,
            name
        ]);
    }
    const widgetColumns = nonPanelColumns.filter((x)=>!rawColumns.includes(typeof x === "string" ? x : x.name));
    return (0, $4vwom.jsxs)("div", {
        style: {
            backgroundColor: "white",
            padding: 8,
            fontSize: 14
        },
        children: [
            (0, $4vwom.jsx)("b", {
                children: "Visible Columns"
            }),
            (0, $4vwom.jsx)("div", {
                style: {
                    fontSize: 12,
                    color: (0, $9Q5xE.ColorStyles)["gray-cool"][500],
                    marginTop: 8
                },
                children: "WIDGET COLUMNS"
            }),
            widgetColumns.map((c, i)=>{
                const cp = typeof c === "string" ? {
                    name: c,
                    displayName: {
                        en: c
                    }
                } : c;
                return (0, $4vwom.jsx)($3d2a2786520b389f$var$CheckRow, Object.assign({}, cp, {
                    checked: !hiddenColumns.includes(cp.name),
                    onChange: (e)=>{
                        if (hiddenColumns.includes(cp.name)) setHiddenColumns(hiddenColumns.filter((c)=>c !== cp.name));
                        else setHiddenColumns([
                            ...hiddenColumns,
                            cp.name
                        ]);
                    }
                }), cp.name);
            }),
            collectionName ? (0, $4vwom.jsx)("a", {
                style: {
                    color: (0, $9Q5xE.ColorStyles).primary[600]
                },
                href: `/studio/studiotablecolumns/new?collectionName=${encodeURIComponent(collectionName)}&everyone=true`,
                children: "+ Add new column..."
            }) : undefined,
            (0, $4vwom.jsx)("div", {
                style: {
                    fontSize: 12,
                    color: (0, $9Q5xE.ColorStyles)["gray-cool"][500],
                    marginTop: 8
                },
                children: "RAW COLUMNS"
            }),
            colProps.filter((cp)=>!widgetColumns.some((x)=>typeof x === "string" ? x === cp.name : x.name === cp.name)).map((cp)=>(0, $4vwom.jsx)($3d2a2786520b389f$var$CheckRow, {
                    name: cp.name,
                    displayName: cp.displayName,
                    checked: rawColumns.includes(cp.name),
                    onChange: (e)=>toggleRawColumn(cp.name)
                }, cp.name))
        ]
    });
}
function $3d2a2786520b389f$var$CheckRow({ name: name, displayName: displayName, checked: checked, onChange: onChange }) {
    const localize = (0, $aIeEI.useLocalize)();
    const display = localize(displayName);
    return (0, $4vwom.jsxs)("div", {
        style: {
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center"
        },
        children: [
            (0, $4vwom.jsxs)("div", {
                style: {
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center"
                },
                children: [
                    (0, $4vwom.jsx)("input", {
                        type: "checkbox",
                        checked: checked,
                        onChange: onChange,
                        style: {
                            marginRight: 8,
                            accentColor: (0, $9Q5xE.ColorStyles).primary[600],
                            width: 22,
                            height: 22,
                            margin: 4
                        }
                    }),
                    (0, $4vwom.jsx)("div", {
                        style: {
                            marginLeft: 4
                        },
                        children: display.trim() || (0, $4vwom.jsx)("em", {
                            children: "Dropdown menu"
                        })
                    })
                ]
            }),
            (0, $4vwom.jsx)("code", {
                style: {
                    color: (0, $9Q5xE.ColorStyles)["gray-cool"][500],
                    marginLeft: 32
                },
                children: name
            })
        ]
    }, name);
}

});

parcelRegister("1Elc1", function(module, exports) {

$parcel$export(module.exports, "TableSelectFilter", function () { return $1339f7536696da9a$export$7f1d0d4806bb5494; });

var $4vwom = parcelRequire("4vwom");

var $eeH7J = parcelRequire("eeH7J");

var $dUDPg = parcelRequire("dUDPg");

var $9Q5xE = parcelRequire("9Q5xE");

var $4rY0U = parcelRequire("4rY0U");

var $1rVia = parcelRequire("1rVia");
function $1339f7536696da9a$export$7f1d0d4806bb5494({ collectionName: collectionName, columnName: columnName, selection: selection, onChange: onChange }) {
    var _a;
    const [search, setSearch] = (0, $eeH7J.useState)("");
    const options = (0, $dUDPg.useStudioTableColumnFilterOptions)(collectionName, columnName, search, 0, 50);
    return (0, $4vwom.jsxs)("div", {
        style: {
            minWidth: "200px",
            fontSize: 14,
            color: (0, $9Q5xE.ColorStyles).gray[700]
        },
        children: [
            (0, $4vwom.jsx)("input", {
                className: "form-control",
                placeholder: "Search",
                type: "text",
                value: search,
                onChange: (e)=>setSearch(e.target.value),
                style: {
                    marginBottom: 8,
                    position: "sticky"
                }
            }),
            (0, $4vwom.jsxs)("div", {
                style: {
                    maxHeight: "300px",
                    minHeight: 100,
                    overflowY: "auto",
                    display: "flex",
                    flexDirection: "column"
                },
                children: [
                    options.loading && (0, $4vwom.jsx)((0, $1rVia.default), {
                        animation: "border",
                        style: {
                            alignSelf: "center",
                            justifySelf: "center",
                            marginTop: 32
                        }
                    }),
                    (_a = options.data) === null || _a === void 0 ? void 0 : _a.rows.map((opt)=>(0, $4vwom.jsxs)("div", {
                            style: {
                                display: "flex",
                                flexDirection: "row",
                                alignItems: "center",
                                minWidth: "200px"
                            },
                            children: [
                                (0, $4vwom.jsx)("input", {
                                    style: {
                                        width: "20px",
                                        height: "20px",
                                        accentColor: (0, $9Q5xE.ColorStyles).primary[500]
                                    },
                                    type: "checkbox",
                                    checked: selection === null || selection === void 0 ? void 0 : selection.includes(opt.value),
                                    onChange: ()=>{
                                        const newSelection = (selection === null || selection === void 0 ? void 0 : selection.includes(opt.value)) ? selection.filter((v)=>v !== opt.value) : [
                                            ...selection !== null && selection !== void 0 ? selection : [],
                                            opt.value
                                        ];
                                        const newWidgets = newSelection.map((v)=>{
                                            var _a, _b;
                                            return (_b = (_a = options.data) === null || _a === void 0 ? void 0 : _a.rows.find((r)=>r.value === v)) === null || _b === void 0 ? void 0 : _b.widget;
                                        });
                                        onChange(newSelection.length > 0 ? newSelection : undefined, newWidgets);
                                    }
                                }),
                                (0, $4vwom.jsx)((0, $4rY0U.WidgetView), {
                                    value: typeof opt.widget === "object" ? Object.assign({
                                        width: "100%"
                                    }, opt.widget) : opt.widget
                                })
                            ]
                        }, opt.value.toString()))
                ]
            })
        ]
    });
}

});

parcelRegister("efVcO", function(module, exports) {

$parcel$export(module.exports, "DragDropContext", function () { return $a60ed7403450fe58$export$237bd83162c14364; });
$parcel$export(module.exports, "Draggable", function () { return $a60ed7403450fe58$export$f2a139e5d18b9882; });
$parcel$export(module.exports, "Droppable", function () { return $a60ed7403450fe58$export$423ec2075359570a; });

var $eeH7J = parcelRequire("eeH7J");

var $ltdWF = parcelRequire("ltdWF");

var $h4XE0 = parcelRequire("h4XE0");

var $jkmOZ = parcelRequire("jkmOZ");
parcelRequire("e6UIf");
var $9DfAu = parcelRequire("9DfAu");
var $fUBYE = parcelRequire("fUBYE");

var $3PiUj = parcelRequire("3PiUj");

var $4J1sD = parcelRequire("4J1sD");

var $kQ1m2 = parcelRequire("kQ1m2");

var $lqlwE = parcelRequire("lqlwE");

var $iMJCh = parcelRequire("iMJCh");
var $a60ed7403450fe58$var$isProduction = true;
var $a60ed7403450fe58$var$spacesAndTabs = /[ \t]{2,}/g;
var $a60ed7403450fe58$var$lineStartWithSpaces = /^[ \t]*/gm;
var $a60ed7403450fe58$var$clean = function clean(value) {
    return value.replace($a60ed7403450fe58$var$spacesAndTabs, " ").replace($a60ed7403450fe58$var$lineStartWithSpaces, "").trim();
};
var $a60ed7403450fe58$var$getDevMessage = function getDevMessage(message) {
    return $a60ed7403450fe58$var$clean("\n  %creact-beautiful-dnd\n\n  %c" + $a60ed7403450fe58$var$clean(message) + "\n\n  %c\uD83D\uDC77\u200D This is a development only message. It will be removed in production builds.\n");
};
var $a60ed7403450fe58$var$getFormattedMessage = function getFormattedMessage(message) {
    return [
        $a60ed7403450fe58$var$getDevMessage(message),
        "color: #00C584; font-size: 1.2em; font-weight: bold;",
        "line-height: 1.5",
        "color: #723874;"
    ];
};
var $a60ed7403450fe58$var$isDisabledFlag = "__react-beautiful-dnd-disable-dev-warnings";
function $a60ed7403450fe58$var$log(type, message) {
    var _console;
    if ($a60ed7403450fe58$var$isProduction) return;
    if (typeof window !== "undefined" && window[$a60ed7403450fe58$var$isDisabledFlag]) return;
    (_console = console)[type].apply(_console, $a60ed7403450fe58$var$getFormattedMessage(message));
}
var $a60ed7403450fe58$var$warning = $a60ed7403450fe58$var$log.bind(null, "warn");
var $a60ed7403450fe58$var$error = $a60ed7403450fe58$var$log.bind(null, "error");
function $a60ed7403450fe58$var$noop() {}
function $a60ed7403450fe58$var$getOptions(shared, fromBinding) {
    return (0, $h4XE0.default)({}, shared, {}, fromBinding);
}
function $a60ed7403450fe58$var$bindEvents(el, bindings, sharedOptions) {
    var unbindings = bindings.map(function(binding) {
        var options = $a60ed7403450fe58$var$getOptions(sharedOptions, binding.options);
        el.addEventListener(binding.eventName, binding.fn, options);
        return function unbind() {
            el.removeEventListener(binding.eventName, binding.fn, options);
        };
    });
    return function unbindAll() {
        unbindings.forEach(function(unbind) {
            unbind();
        });
    };
}
var $a60ed7403450fe58$var$isProduction$1 = true;
var $a60ed7403450fe58$var$prefix = "Invariant failed";
function $a60ed7403450fe58$var$RbdInvariant(message) {
    this.message = message;
}
$a60ed7403450fe58$var$RbdInvariant.prototype.toString = function toString() {
    return this.message;
};
function $a60ed7403450fe58$var$invariant(condition, message) {
    if (condition) return;
    if ($a60ed7403450fe58$var$isProduction$1) throw new $a60ed7403450fe58$var$RbdInvariant($a60ed7403450fe58$var$prefix);
    else throw new $a60ed7403450fe58$var$RbdInvariant($a60ed7403450fe58$var$prefix + ": " + (message || ""));
}
var $a60ed7403450fe58$var$ErrorBoundary = function(_React$Component) {
    (0, $ltdWF.default)(ErrorBoundary, _React$Component);
    function ErrorBoundary() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.callbacks = null;
        _this.unbind = $a60ed7403450fe58$var$noop;
        _this.onWindowError = function(event) {
            var callbacks = _this.getCallbacks();
            if (callbacks.isDragging()) callbacks.tryAbort();
            var err = event.error;
            if (err instanceof $a60ed7403450fe58$var$RbdInvariant) event.preventDefault();
        };
        _this.getCallbacks = function() {
            if (!_this.callbacks) throw new Error("Unable to find AppCallbacks in <ErrorBoundary/>");
            return _this.callbacks;
        };
        _this.setCallbacks = function(callbacks) {
            _this.callbacks = callbacks;
        };
        return _this;
    }
    var _proto = ErrorBoundary.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.unbind = $a60ed7403450fe58$var$bindEvents(window, [
            {
                eventName: "error",
                fn: this.onWindowError
            }
        ]);
    };
    _proto.componentDidCatch = function componentDidCatch(err) {
        if (err instanceof $a60ed7403450fe58$var$RbdInvariant) {
            this.setState({});
            return;
        }
        throw err;
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.unbind();
    };
    _proto.render = function render() {
        return this.props.children(this.setCallbacks);
    };
    return ErrorBoundary;
}((0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).Component);
var $a60ed7403450fe58$var$dragHandleUsageInstructions = "\n  Press space bar to start a drag.\n  When dragging you can use the arrow keys to move the item around and escape to cancel.\n  Some screen readers may require you to be in focus mode or to use your pass through key\n";
var $a60ed7403450fe58$var$position = function position(index) {
    return index + 1;
};
var $a60ed7403450fe58$var$onDragStart = function onDragStart(start) {
    return "\n  You have lifted an item in position " + $a60ed7403450fe58$var$position(start.source.index) + "\n";
};
var $a60ed7403450fe58$var$withLocation = function withLocation(source, destination) {
    var isInHomeList = source.droppableId === destination.droppableId;
    var startPosition = $a60ed7403450fe58$var$position(source.index);
    var endPosition = $a60ed7403450fe58$var$position(destination.index);
    if (isInHomeList) return "\n      You have moved the item from position " + startPosition + "\n      to position " + endPosition + "\n    ";
    return "\n    You have moved the item from position " + startPosition + "\n    in list " + source.droppableId + "\n    to list " + destination.droppableId + "\n    in position " + endPosition + "\n  ";
};
var $a60ed7403450fe58$var$withCombine = function withCombine(id, source, combine) {
    var inHomeList = source.droppableId === combine.droppableId;
    if (inHomeList) return "\n      The item " + id + "\n      has been combined with " + combine.draggableId;
    return "\n      The item " + id + "\n      in list " + source.droppableId + "\n      has been combined with " + combine.draggableId + "\n      in list " + combine.droppableId + "\n    ";
};
var $a60ed7403450fe58$var$onDragUpdate = function onDragUpdate(update) {
    var location = update.destination;
    if (location) return $a60ed7403450fe58$var$withLocation(update.source, location);
    var combine = update.combine;
    if (combine) return $a60ed7403450fe58$var$withCombine(update.draggableId, update.source, combine);
    return "You are over an area that cannot be dropped on";
};
var $a60ed7403450fe58$var$returnedToStart = function returnedToStart(source) {
    return "\n  The item has returned to its starting position\n  of " + $a60ed7403450fe58$var$position(source.index) + "\n";
};
var $a60ed7403450fe58$var$onDragEnd = function onDragEnd(result) {
    if (result.reason === "CANCEL") return "\n      Movement cancelled.\n      " + $a60ed7403450fe58$var$returnedToStart(result.source) + "\n    ";
    var location = result.destination;
    var combine = result.combine;
    if (location) return "\n      You have dropped the item.\n      " + $a60ed7403450fe58$var$withLocation(result.source, location) + "\n    ";
    if (combine) return "\n      You have dropped the item.\n      " + $a60ed7403450fe58$var$withCombine(result.draggableId, result.source, combine) + "\n    ";
    return "\n    The item has been dropped while not over a drop area.\n    " + $a60ed7403450fe58$var$returnedToStart(result.source) + "\n  ";
};
var $a60ed7403450fe58$var$preset = {
    dragHandleUsageInstructions: $a60ed7403450fe58$var$dragHandleUsageInstructions,
    onDragStart: $a60ed7403450fe58$var$onDragStart,
    onDragUpdate: $a60ed7403450fe58$var$onDragUpdate,
    onDragEnd: $a60ed7403450fe58$var$onDragEnd
};
var $a60ed7403450fe58$var$origin = {
    x: 0,
    y: 0
};
var $a60ed7403450fe58$var$add = function add(point1, point2) {
    return {
        x: point1.x + point2.x,
        y: point1.y + point2.y
    };
};
var $a60ed7403450fe58$var$subtract = function subtract(point1, point2) {
    return {
        x: point1.x - point2.x,
        y: point1.y - point2.y
    };
};
var $a60ed7403450fe58$var$isEqual = function isEqual(point1, point2) {
    return point1.x === point2.x && point1.y === point2.y;
};
var $a60ed7403450fe58$var$negate = function negate(point) {
    return {
        x: point.x !== 0 ? -point.x : 0,
        y: point.y !== 0 ? -point.y : 0
    };
};
var $a60ed7403450fe58$var$patch = function patch(line, value, otherValue) {
    var _ref;
    if (otherValue === void 0) otherValue = 0;
    return _ref = {}, _ref[line] = value, _ref[line === "x" ? "y" : "x"] = otherValue, _ref;
};
var $a60ed7403450fe58$var$distance = function distance(point1, point2) {
    return Math.sqrt(Math.pow(point2.x - point1.x, 2) + Math.pow(point2.y - point1.y, 2));
};
var $a60ed7403450fe58$var$closest = function closest(target, points) {
    return Math.min.apply(Math, points.map(function(point) {
        return $a60ed7403450fe58$var$distance(target, point);
    }));
};
var $a60ed7403450fe58$var$apply = function apply(fn) {
    return function(point) {
        return {
            x: fn(point.x),
            y: fn(point.y)
        };
    };
};
var $a60ed7403450fe58$var$executeClip = function(frame, subject) {
    var result = (0, $4J1sD.getRect)({
        top: Math.max(subject.top, frame.top),
        right: Math.min(subject.right, frame.right),
        bottom: Math.min(subject.bottom, frame.bottom),
        left: Math.max(subject.left, frame.left)
    });
    if (result.width <= 0 || result.height <= 0) return null;
    return result;
};
var $a60ed7403450fe58$var$offsetByPosition = function offsetByPosition(spacing, point) {
    return {
        top: spacing.top + point.y,
        left: spacing.left + point.x,
        bottom: spacing.bottom + point.y,
        right: spacing.right + point.x
    };
};
var $a60ed7403450fe58$var$getCorners = function getCorners(spacing) {
    return [
        {
            x: spacing.left,
            y: spacing.top
        },
        {
            x: spacing.right,
            y: spacing.top
        },
        {
            x: spacing.left,
            y: spacing.bottom
        },
        {
            x: spacing.right,
            y: spacing.bottom
        }
    ];
};
var $a60ed7403450fe58$var$noSpacing = {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
};
var $a60ed7403450fe58$var$scroll = function scroll(target, frame) {
    if (!frame) return target;
    return $a60ed7403450fe58$var$offsetByPosition(target, frame.scroll.diff.displacement);
};
var $a60ed7403450fe58$var$increase = function increase(target, axis, withPlaceholder) {
    if (withPlaceholder && withPlaceholder.increasedBy) {
        var _extends2;
        return (0, $h4XE0.default)({}, target, (_extends2 = {}, _extends2[axis.end] = target[axis.end] + withPlaceholder.increasedBy[axis.line], _extends2));
    }
    return target;
};
var $a60ed7403450fe58$var$clip = function clip(target, frame) {
    if (frame && frame.shouldClipSubject) return $a60ed7403450fe58$var$executeClip(frame.pageMarginBox, target);
    return (0, $4J1sD.getRect)(target);
};
var $a60ed7403450fe58$var$getSubject = function(_ref) {
    var page = _ref.page, withPlaceholder = _ref.withPlaceholder, axis = _ref.axis, frame = _ref.frame;
    var scrolled = $a60ed7403450fe58$var$scroll(page.marginBox, frame);
    var increased = $a60ed7403450fe58$var$increase(scrolled, axis, withPlaceholder);
    var clipped = $a60ed7403450fe58$var$clip(increased, frame);
    return {
        page: page,
        withPlaceholder: withPlaceholder,
        active: clipped
    };
};
var $a60ed7403450fe58$var$scrollDroppable = function(droppable, newScroll) {
    !droppable.frame && $a60ed7403450fe58$var$invariant(false);
    var scrollable = droppable.frame;
    var scrollDiff = $a60ed7403450fe58$var$subtract(newScroll, scrollable.scroll.initial);
    var scrollDisplacement = $a60ed7403450fe58$var$negate(scrollDiff);
    var frame = (0, $h4XE0.default)({}, scrollable, {
        scroll: {
            initial: scrollable.scroll.initial,
            current: newScroll,
            diff: {
                value: scrollDiff,
                displacement: scrollDisplacement
            },
            max: scrollable.scroll.max
        }
    });
    var subject = $a60ed7403450fe58$var$getSubject({
        page: droppable.subject.page,
        withPlaceholder: droppable.subject.withPlaceholder,
        axis: droppable.axis,
        frame: frame
    });
    var result = (0, $h4XE0.default)({}, droppable, {
        frame: frame,
        subject: subject
    });
    return result;
};
function $a60ed7403450fe58$var$isInteger(value) {
    if (Number.isInteger) return Number.isInteger(value);
    return typeof value === "number" && isFinite(value) && Math.floor(value) === value;
}
function $a60ed7403450fe58$var$values(map) {
    if (Object.values) return Object.values(map);
    return Object.keys(map).map(function(key) {
        return map[key];
    });
}
function $a60ed7403450fe58$var$findIndex(list, predicate) {
    if (list.findIndex) return list.findIndex(predicate);
    for(var i = 0; i < list.length; i++){
        if (predicate(list[i])) return i;
    }
    return -1;
}
function $a60ed7403450fe58$var$find(list, predicate) {
    if (list.find) return list.find(predicate);
    var index = $a60ed7403450fe58$var$findIndex(list, predicate);
    if (index !== -1) return list[index];
    return undefined;
}
function $a60ed7403450fe58$var$toArray(list) {
    return Array.prototype.slice.call(list);
}
var $a60ed7403450fe58$var$toDroppableMap = (0, $kQ1m2.default)(function(droppables) {
    return droppables.reduce(function(previous, current) {
        previous[current.descriptor.id] = current;
        return previous;
    }, {});
});
var $a60ed7403450fe58$var$toDraggableMap = (0, $kQ1m2.default)(function(draggables) {
    return draggables.reduce(function(previous, current) {
        previous[current.descriptor.id] = current;
        return previous;
    }, {});
});
var $a60ed7403450fe58$var$toDroppableList = (0, $kQ1m2.default)(function(droppables) {
    return $a60ed7403450fe58$var$values(droppables);
});
var $a60ed7403450fe58$var$toDraggableList = (0, $kQ1m2.default)(function(draggables) {
    return $a60ed7403450fe58$var$values(draggables);
});
var $a60ed7403450fe58$var$getDraggablesInsideDroppable = (0, $kQ1m2.default)(function(droppableId, draggables) {
    var result = $a60ed7403450fe58$var$toDraggableList(draggables).filter(function(draggable) {
        return droppableId === draggable.descriptor.droppableId;
    }).sort(function(a, b) {
        return a.descriptor.index - b.descriptor.index;
    });
    return result;
});
function $a60ed7403450fe58$var$tryGetDestination(impact) {
    if (impact.at && impact.at.type === "REORDER") return impact.at.destination;
    return null;
}
function $a60ed7403450fe58$var$tryGetCombine(impact) {
    if (impact.at && impact.at.type === "COMBINE") return impact.at.combine;
    return null;
}
var $a60ed7403450fe58$var$removeDraggableFromList = (0, $kQ1m2.default)(function(remove, list) {
    return list.filter(function(item) {
        return item.descriptor.id !== remove.descriptor.id;
    });
});
var $a60ed7403450fe58$var$moveToNextCombine = function(_ref) {
    var isMovingForward = _ref.isMovingForward, draggable = _ref.draggable, destination = _ref.destination, insideDestination = _ref.insideDestination, previousImpact = _ref.previousImpact;
    if (!destination.isCombineEnabled) return null;
    var location = $a60ed7403450fe58$var$tryGetDestination(previousImpact);
    if (!location) return null;
    function getImpact(target) {
        var at = {
            type: "COMBINE",
            combine: {
                draggableId: target,
                droppableId: destination.descriptor.id
            }
        };
        return (0, $h4XE0.default)({}, previousImpact, {
            at: at
        });
    }
    var all = previousImpact.displaced.all;
    var closestId = all.length ? all[0] : null;
    if (isMovingForward) return closestId ? getImpact(closestId) : null;
    var withoutDraggable = $a60ed7403450fe58$var$removeDraggableFromList(draggable, insideDestination);
    if (!closestId) {
        if (!withoutDraggable.length) return null;
        var last = withoutDraggable[withoutDraggable.length - 1];
        return getImpact(last.descriptor.id);
    }
    var indexOfClosest = $a60ed7403450fe58$var$findIndex(withoutDraggable, function(d) {
        return d.descriptor.id === closestId;
    });
    !(indexOfClosest !== -1) && $a60ed7403450fe58$var$invariant(false);
    var proposedIndex = indexOfClosest - 1;
    if (proposedIndex < 0) return null;
    var before = withoutDraggable[proposedIndex];
    return getImpact(before.descriptor.id);
};
var $a60ed7403450fe58$var$isHomeOf = function(draggable, destination) {
    return draggable.descriptor.droppableId === destination.descriptor.id;
};
var $a60ed7403450fe58$var$noDisplacedBy = {
    point: $a60ed7403450fe58$var$origin,
    value: 0
};
var $a60ed7403450fe58$var$emptyGroups = {
    invisible: {},
    visible: {},
    all: []
};
var $a60ed7403450fe58$var$noImpact = {
    displaced: $a60ed7403450fe58$var$emptyGroups,
    displacedBy: $a60ed7403450fe58$var$noDisplacedBy,
    at: null
};
var $a60ed7403450fe58$var$isWithin = function(lowerBound, upperBound) {
    return function(value) {
        return lowerBound <= value && value <= upperBound;
    };
};
var $a60ed7403450fe58$var$isPartiallyVisibleThroughFrame = function(frame) {
    var isWithinVertical = $a60ed7403450fe58$var$isWithin(frame.top, frame.bottom);
    var isWithinHorizontal = $a60ed7403450fe58$var$isWithin(frame.left, frame.right);
    return function(subject) {
        var isContained = isWithinVertical(subject.top) && isWithinVertical(subject.bottom) && isWithinHorizontal(subject.left) && isWithinHorizontal(subject.right);
        if (isContained) return true;
        var isPartiallyVisibleVertically = isWithinVertical(subject.top) || isWithinVertical(subject.bottom);
        var isPartiallyVisibleHorizontally = isWithinHorizontal(subject.left) || isWithinHorizontal(subject.right);
        var isPartiallyContained = isPartiallyVisibleVertically && isPartiallyVisibleHorizontally;
        if (isPartiallyContained) return true;
        var isBiggerVertically = subject.top < frame.top && subject.bottom > frame.bottom;
        var isBiggerHorizontally = subject.left < frame.left && subject.right > frame.right;
        var isTargetBiggerThanFrame = isBiggerVertically && isBiggerHorizontally;
        if (isTargetBiggerThanFrame) return true;
        var isTargetBiggerOnOneAxis = isBiggerVertically && isPartiallyVisibleHorizontally || isBiggerHorizontally && isPartiallyVisibleVertically;
        return isTargetBiggerOnOneAxis;
    };
};
var $a60ed7403450fe58$var$isTotallyVisibleThroughFrame = function(frame) {
    var isWithinVertical = $a60ed7403450fe58$var$isWithin(frame.top, frame.bottom);
    var isWithinHorizontal = $a60ed7403450fe58$var$isWithin(frame.left, frame.right);
    return function(subject) {
        var isContained = isWithinVertical(subject.top) && isWithinVertical(subject.bottom) && isWithinHorizontal(subject.left) && isWithinHorizontal(subject.right);
        return isContained;
    };
};
var $a60ed7403450fe58$var$vertical = {
    direction: "vertical",
    line: "y",
    crossAxisLine: "x",
    start: "top",
    end: "bottom",
    size: "height",
    crossAxisStart: "left",
    crossAxisEnd: "right",
    crossAxisSize: "width"
};
var $a60ed7403450fe58$var$horizontal = {
    direction: "horizontal",
    line: "x",
    crossAxisLine: "y",
    start: "left",
    end: "right",
    size: "width",
    crossAxisStart: "top",
    crossAxisEnd: "bottom",
    crossAxisSize: "height"
};
var $a60ed7403450fe58$var$isTotallyVisibleThroughFrameOnAxis = function(axis) {
    return function(frame) {
        var isWithinVertical = $a60ed7403450fe58$var$isWithin(frame.top, frame.bottom);
        var isWithinHorizontal = $a60ed7403450fe58$var$isWithin(frame.left, frame.right);
        return function(subject) {
            if (axis === $a60ed7403450fe58$var$vertical) return isWithinVertical(subject.top) && isWithinVertical(subject.bottom);
            return isWithinHorizontal(subject.left) && isWithinHorizontal(subject.right);
        };
    };
};
var $a60ed7403450fe58$var$getDroppableDisplaced = function getDroppableDisplaced(target, destination) {
    var displacement = destination.frame ? destination.frame.scroll.diff.displacement : $a60ed7403450fe58$var$origin;
    return $a60ed7403450fe58$var$offsetByPosition(target, displacement);
};
var $a60ed7403450fe58$var$isVisibleInDroppable = function isVisibleInDroppable(target, destination, isVisibleThroughFrameFn) {
    if (!destination.subject.active) return false;
    return isVisibleThroughFrameFn(destination.subject.active)(target);
};
var $a60ed7403450fe58$var$isVisibleInViewport = function isVisibleInViewport(target, viewport, isVisibleThroughFrameFn) {
    return isVisibleThroughFrameFn(viewport)(target);
};
var $a60ed7403450fe58$var$isVisible = function isVisible(_ref) {
    var toBeDisplaced = _ref.target, destination = _ref.destination, viewport = _ref.viewport, withDroppableDisplacement = _ref.withDroppableDisplacement, isVisibleThroughFrameFn = _ref.isVisibleThroughFrameFn;
    var displacedTarget = withDroppableDisplacement ? $a60ed7403450fe58$var$getDroppableDisplaced(toBeDisplaced, destination) : toBeDisplaced;
    return $a60ed7403450fe58$var$isVisibleInDroppable(displacedTarget, destination, isVisibleThroughFrameFn) && $a60ed7403450fe58$var$isVisibleInViewport(displacedTarget, viewport, isVisibleThroughFrameFn);
};
var $a60ed7403450fe58$var$isPartiallyVisible = function isPartiallyVisible(args) {
    return $a60ed7403450fe58$var$isVisible((0, $h4XE0.default)({}, args, {
        isVisibleThroughFrameFn: $a60ed7403450fe58$var$isPartiallyVisibleThroughFrame
    }));
};
var $a60ed7403450fe58$var$isTotallyVisible = function isTotallyVisible(args) {
    return $a60ed7403450fe58$var$isVisible((0, $h4XE0.default)({}, args, {
        isVisibleThroughFrameFn: $a60ed7403450fe58$var$isTotallyVisibleThroughFrame
    }));
};
var $a60ed7403450fe58$var$isTotallyVisibleOnAxis = function isTotallyVisibleOnAxis(args) {
    return $a60ed7403450fe58$var$isVisible((0, $h4XE0.default)({}, args, {
        isVisibleThroughFrameFn: $a60ed7403450fe58$var$isTotallyVisibleThroughFrameOnAxis(args.destination.axis)
    }));
};
var $a60ed7403450fe58$var$getShouldAnimate = function getShouldAnimate(id, last, forceShouldAnimate) {
    if (typeof forceShouldAnimate === "boolean") return forceShouldAnimate;
    if (!last) return true;
    var invisible = last.invisible, visible = last.visible;
    if (invisible[id]) return false;
    var previous = visible[id];
    return previous ? previous.shouldAnimate : true;
};
function $a60ed7403450fe58$var$getTarget(draggable, displacedBy) {
    var marginBox = draggable.page.marginBox;
    var expandBy = {
        top: displacedBy.point.y,
        right: 0,
        bottom: 0,
        left: displacedBy.point.x
    };
    return (0, $4J1sD.getRect)((0, $4J1sD.expand)(marginBox, expandBy));
}
function $a60ed7403450fe58$var$getDisplacementGroups(_ref) {
    var afterDragging = _ref.afterDragging, destination = _ref.destination, displacedBy = _ref.displacedBy, viewport = _ref.viewport, forceShouldAnimate = _ref.forceShouldAnimate, last = _ref.last;
    return afterDragging.reduce(function process(groups, draggable) {
        var target = $a60ed7403450fe58$var$getTarget(draggable, displacedBy);
        var id = draggable.descriptor.id;
        groups.all.push(id);
        var isVisible = $a60ed7403450fe58$var$isPartiallyVisible({
            target: target,
            destination: destination,
            viewport: viewport,
            withDroppableDisplacement: true
        });
        if (!isVisible) {
            groups.invisible[draggable.descriptor.id] = true;
            return groups;
        }
        var shouldAnimate = $a60ed7403450fe58$var$getShouldAnimate(id, last, forceShouldAnimate);
        var displacement = {
            draggableId: id,
            shouldAnimate: shouldAnimate
        };
        groups.visible[id] = displacement;
        return groups;
    }, {
        all: [],
        visible: {},
        invisible: {}
    });
}
function $a60ed7403450fe58$var$getIndexOfLastItem(draggables, options) {
    if (!draggables.length) return 0;
    var indexOfLastItem = draggables[draggables.length - 1].descriptor.index;
    return options.inHomeList ? indexOfLastItem : indexOfLastItem + 1;
}
function $a60ed7403450fe58$var$goAtEnd(_ref) {
    var insideDestination = _ref.insideDestination, inHomeList = _ref.inHomeList, displacedBy = _ref.displacedBy, destination = _ref.destination;
    var newIndex = $a60ed7403450fe58$var$getIndexOfLastItem(insideDestination, {
        inHomeList: inHomeList
    });
    return {
        displaced: $a60ed7403450fe58$var$emptyGroups,
        displacedBy: displacedBy,
        at: {
            type: "REORDER",
            destination: {
                droppableId: destination.descriptor.id,
                index: newIndex
            }
        }
    };
}
function $a60ed7403450fe58$var$calculateReorderImpact(_ref2) {
    var draggable = _ref2.draggable, insideDestination = _ref2.insideDestination, destination = _ref2.destination, viewport = _ref2.viewport, displacedBy = _ref2.displacedBy, last = _ref2.last, index = _ref2.index, forceShouldAnimate = _ref2.forceShouldAnimate;
    var inHomeList = $a60ed7403450fe58$var$isHomeOf(draggable, destination);
    if (index == null) return $a60ed7403450fe58$var$goAtEnd({
        insideDestination: insideDestination,
        inHomeList: inHomeList,
        displacedBy: displacedBy,
        destination: destination
    });
    var match = $a60ed7403450fe58$var$find(insideDestination, function(item) {
        return item.descriptor.index === index;
    });
    if (!match) return $a60ed7403450fe58$var$goAtEnd({
        insideDestination: insideDestination,
        inHomeList: inHomeList,
        displacedBy: displacedBy,
        destination: destination
    });
    var withoutDragging = $a60ed7403450fe58$var$removeDraggableFromList(draggable, insideDestination);
    var sliceFrom = insideDestination.indexOf(match);
    var impacted = withoutDragging.slice(sliceFrom);
    var displaced = $a60ed7403450fe58$var$getDisplacementGroups({
        afterDragging: impacted,
        destination: destination,
        displacedBy: displacedBy,
        last: last,
        viewport: viewport.frame,
        forceShouldAnimate: forceShouldAnimate
    });
    return {
        displaced: displaced,
        displacedBy: displacedBy,
        at: {
            type: "REORDER",
            destination: {
                droppableId: destination.descriptor.id,
                index: index
            }
        }
    };
}
function $a60ed7403450fe58$var$didStartAfterCritical(draggableId, afterCritical) {
    return Boolean(afterCritical.effected[draggableId]);
}
var $a60ed7403450fe58$var$fromCombine = function(_ref) {
    var isMovingForward = _ref.isMovingForward, destination = _ref.destination, draggables = _ref.draggables, combine = _ref.combine, afterCritical = _ref.afterCritical;
    if (!destination.isCombineEnabled) return null;
    var combineId = combine.draggableId;
    var combineWith = draggables[combineId];
    var combineWithIndex = combineWith.descriptor.index;
    var didCombineWithStartAfterCritical = $a60ed7403450fe58$var$didStartAfterCritical(combineId, afterCritical);
    if (didCombineWithStartAfterCritical) {
        if (isMovingForward) return combineWithIndex;
        return combineWithIndex - 1;
    }
    if (isMovingForward) return combineWithIndex + 1;
    return combineWithIndex;
};
var $a60ed7403450fe58$var$fromReorder = function(_ref) {
    var isMovingForward = _ref.isMovingForward, isInHomeList = _ref.isInHomeList, insideDestination = _ref.insideDestination, location = _ref.location;
    if (!insideDestination.length) return null;
    var currentIndex = location.index;
    var proposedIndex = isMovingForward ? currentIndex + 1 : currentIndex - 1;
    var firstIndex = insideDestination[0].descriptor.index;
    var lastIndex = insideDestination[insideDestination.length - 1].descriptor.index;
    var upperBound = isInHomeList ? lastIndex : lastIndex + 1;
    if (proposedIndex < firstIndex) return null;
    if (proposedIndex > upperBound) return null;
    return proposedIndex;
};
var $a60ed7403450fe58$var$moveToNextIndex = function(_ref) {
    var isMovingForward = _ref.isMovingForward, isInHomeList = _ref.isInHomeList, draggable = _ref.draggable, draggables = _ref.draggables, destination = _ref.destination, insideDestination = _ref.insideDestination, previousImpact = _ref.previousImpact, viewport = _ref.viewport, afterCritical = _ref.afterCritical;
    var wasAt = previousImpact.at;
    !wasAt && $a60ed7403450fe58$var$invariant(false);
    if (wasAt.type === "REORDER") {
        var _newIndex = $a60ed7403450fe58$var$fromReorder({
            isMovingForward: isMovingForward,
            isInHomeList: isInHomeList,
            location: wasAt.destination,
            insideDestination: insideDestination
        });
        if (_newIndex == null) return null;
        return $a60ed7403450fe58$var$calculateReorderImpact({
            draggable: draggable,
            insideDestination: insideDestination,
            destination: destination,
            viewport: viewport,
            last: previousImpact.displaced,
            displacedBy: previousImpact.displacedBy,
            index: _newIndex
        });
    }
    var newIndex = $a60ed7403450fe58$var$fromCombine({
        isMovingForward: isMovingForward,
        destination: destination,
        displaced: previousImpact.displaced,
        draggables: draggables,
        combine: wasAt.combine,
        afterCritical: afterCritical
    });
    if (newIndex == null) return null;
    return $a60ed7403450fe58$var$calculateReorderImpact({
        draggable: draggable,
        insideDestination: insideDestination,
        destination: destination,
        viewport: viewport,
        last: previousImpact.displaced,
        displacedBy: previousImpact.displacedBy,
        index: newIndex
    });
};
var $a60ed7403450fe58$var$getCombinedItemDisplacement = function(_ref) {
    var displaced = _ref.displaced, afterCritical = _ref.afterCritical, combineWith = _ref.combineWith, displacedBy = _ref.displacedBy;
    var isDisplaced = Boolean(displaced.visible[combineWith] || displaced.invisible[combineWith]);
    if ($a60ed7403450fe58$var$didStartAfterCritical(combineWith, afterCritical)) return isDisplaced ? $a60ed7403450fe58$var$origin : $a60ed7403450fe58$var$negate(displacedBy.point);
    return isDisplaced ? displacedBy.point : $a60ed7403450fe58$var$origin;
};
var $a60ed7403450fe58$var$whenCombining = function(_ref) {
    var afterCritical = _ref.afterCritical, impact = _ref.impact, draggables = _ref.draggables;
    var combine = $a60ed7403450fe58$var$tryGetCombine(impact);
    !combine && $a60ed7403450fe58$var$invariant(false);
    var combineWith = combine.draggableId;
    var center = draggables[combineWith].page.borderBox.center;
    var displaceBy = $a60ed7403450fe58$var$getCombinedItemDisplacement({
        displaced: impact.displaced,
        afterCritical: afterCritical,
        combineWith: combineWith,
        displacedBy: impact.displacedBy
    });
    return $a60ed7403450fe58$var$add(center, displaceBy);
};
var $a60ed7403450fe58$var$distanceFromStartToBorderBoxCenter = function distanceFromStartToBorderBoxCenter(axis, box) {
    return box.margin[axis.start] + box.borderBox[axis.size] / 2;
};
var $a60ed7403450fe58$var$distanceFromEndToBorderBoxCenter = function distanceFromEndToBorderBoxCenter(axis, box) {
    return box.margin[axis.end] + box.borderBox[axis.size] / 2;
};
var $a60ed7403450fe58$var$getCrossAxisBorderBoxCenter = function getCrossAxisBorderBoxCenter(axis, target, isMoving) {
    return target[axis.crossAxisStart] + isMoving.margin[axis.crossAxisStart] + isMoving.borderBox[axis.crossAxisSize] / 2;
};
var $a60ed7403450fe58$var$goAfter = function goAfter(_ref) {
    var axis = _ref.axis, moveRelativeTo = _ref.moveRelativeTo, isMoving = _ref.isMoving;
    return $a60ed7403450fe58$var$patch(axis.line, moveRelativeTo.marginBox[axis.end] + $a60ed7403450fe58$var$distanceFromStartToBorderBoxCenter(axis, isMoving), $a60ed7403450fe58$var$getCrossAxisBorderBoxCenter(axis, moveRelativeTo.marginBox, isMoving));
};
var $a60ed7403450fe58$var$goBefore = function goBefore(_ref2) {
    var axis = _ref2.axis, moveRelativeTo = _ref2.moveRelativeTo, isMoving = _ref2.isMoving;
    return $a60ed7403450fe58$var$patch(axis.line, moveRelativeTo.marginBox[axis.start] - $a60ed7403450fe58$var$distanceFromEndToBorderBoxCenter(axis, isMoving), $a60ed7403450fe58$var$getCrossAxisBorderBoxCenter(axis, moveRelativeTo.marginBox, isMoving));
};
var $a60ed7403450fe58$var$goIntoStart = function goIntoStart(_ref3) {
    var axis = _ref3.axis, moveInto = _ref3.moveInto, isMoving = _ref3.isMoving;
    return $a60ed7403450fe58$var$patch(axis.line, moveInto.contentBox[axis.start] + $a60ed7403450fe58$var$distanceFromStartToBorderBoxCenter(axis, isMoving), $a60ed7403450fe58$var$getCrossAxisBorderBoxCenter(axis, moveInto.contentBox, isMoving));
};
var $a60ed7403450fe58$var$whenReordering = function(_ref) {
    var impact = _ref.impact, draggable = _ref.draggable, draggables = _ref.draggables, droppable = _ref.droppable, afterCritical = _ref.afterCritical;
    var insideDestination = $a60ed7403450fe58$var$getDraggablesInsideDroppable(droppable.descriptor.id, draggables);
    var draggablePage = draggable.page;
    var axis = droppable.axis;
    if (!insideDestination.length) return $a60ed7403450fe58$var$goIntoStart({
        axis: axis,
        moveInto: droppable.page,
        isMoving: draggablePage
    });
    var displaced = impact.displaced, displacedBy = impact.displacedBy;
    var closestAfter = displaced.all[0];
    if (closestAfter) {
        var closest = draggables[closestAfter];
        if ($a60ed7403450fe58$var$didStartAfterCritical(closestAfter, afterCritical)) return $a60ed7403450fe58$var$goBefore({
            axis: axis,
            moveRelativeTo: closest.page,
            isMoving: draggablePage
        });
        var withDisplacement = (0, $4J1sD.offset)(closest.page, displacedBy.point);
        return $a60ed7403450fe58$var$goBefore({
            axis: axis,
            moveRelativeTo: withDisplacement,
            isMoving: draggablePage
        });
    }
    var last = insideDestination[insideDestination.length - 1];
    if (last.descriptor.id === draggable.descriptor.id) return draggablePage.borderBox.center;
    if ($a60ed7403450fe58$var$didStartAfterCritical(last.descriptor.id, afterCritical)) {
        var page = (0, $4J1sD.offset)(last.page, $a60ed7403450fe58$var$negate(afterCritical.displacedBy.point));
        return $a60ed7403450fe58$var$goAfter({
            axis: axis,
            moveRelativeTo: page,
            isMoving: draggablePage
        });
    }
    return $a60ed7403450fe58$var$goAfter({
        axis: axis,
        moveRelativeTo: last.page,
        isMoving: draggablePage
    });
};
var $a60ed7403450fe58$var$withDroppableDisplacement = function(droppable, point) {
    var frame = droppable.frame;
    if (!frame) return point;
    return $a60ed7403450fe58$var$add(point, frame.scroll.diff.displacement);
};
var $a60ed7403450fe58$var$getResultWithoutDroppableDisplacement = function getResultWithoutDroppableDisplacement(_ref) {
    var impact = _ref.impact, draggable = _ref.draggable, droppable = _ref.droppable, draggables = _ref.draggables, afterCritical = _ref.afterCritical;
    var original = draggable.page.borderBox.center;
    var at = impact.at;
    if (!droppable) return original;
    if (!at) return original;
    if (at.type === "REORDER") return $a60ed7403450fe58$var$whenReordering({
        impact: impact,
        draggable: draggable,
        draggables: draggables,
        droppable: droppable,
        afterCritical: afterCritical
    });
    return $a60ed7403450fe58$var$whenCombining({
        impact: impact,
        draggables: draggables,
        afterCritical: afterCritical
    });
};
var $a60ed7403450fe58$var$getPageBorderBoxCenterFromImpact = function(args) {
    var withoutDisplacement = $a60ed7403450fe58$var$getResultWithoutDroppableDisplacement(args);
    var droppable = args.droppable;
    var withDisplacement = droppable ? $a60ed7403450fe58$var$withDroppableDisplacement(droppable, withoutDisplacement) : withoutDisplacement;
    return withDisplacement;
};
var $a60ed7403450fe58$var$scrollViewport = function(viewport, newScroll) {
    var diff = $a60ed7403450fe58$var$subtract(newScroll, viewport.scroll.initial);
    var displacement = $a60ed7403450fe58$var$negate(diff);
    var frame = (0, $4J1sD.getRect)({
        top: newScroll.y,
        bottom: newScroll.y + viewport.frame.height,
        left: newScroll.x,
        right: newScroll.x + viewport.frame.width
    });
    var updated = {
        frame: frame,
        scroll: {
            initial: viewport.scroll.initial,
            max: viewport.scroll.max,
            current: newScroll,
            diff: {
                value: diff,
                displacement: displacement
            }
        }
    };
    return updated;
};
function $a60ed7403450fe58$var$getDraggables(ids, draggables) {
    return ids.map(function(id) {
        return draggables[id];
    });
}
function $a60ed7403450fe58$var$tryGetVisible(id, groups) {
    for(var i = 0; i < groups.length; i++){
        var displacement = groups[i].visible[id];
        if (displacement) return displacement;
    }
    return null;
}
var $a60ed7403450fe58$var$speculativelyIncrease = function(_ref) {
    var impact = _ref.impact, viewport = _ref.viewport, destination = _ref.destination, draggables = _ref.draggables, maxScrollChange = _ref.maxScrollChange;
    var scrolledViewport = $a60ed7403450fe58$var$scrollViewport(viewport, $a60ed7403450fe58$var$add(viewport.scroll.current, maxScrollChange));
    var scrolledDroppable = destination.frame ? $a60ed7403450fe58$var$scrollDroppable(destination, $a60ed7403450fe58$var$add(destination.frame.scroll.current, maxScrollChange)) : destination;
    var last = impact.displaced;
    var withViewportScroll = $a60ed7403450fe58$var$getDisplacementGroups({
        afterDragging: $a60ed7403450fe58$var$getDraggables(last.all, draggables),
        destination: destination,
        displacedBy: impact.displacedBy,
        viewport: scrolledViewport.frame,
        last: last,
        forceShouldAnimate: false
    });
    var withDroppableScroll = $a60ed7403450fe58$var$getDisplacementGroups({
        afterDragging: $a60ed7403450fe58$var$getDraggables(last.all, draggables),
        destination: scrolledDroppable,
        displacedBy: impact.displacedBy,
        viewport: viewport.frame,
        last: last,
        forceShouldAnimate: false
    });
    var invisible = {};
    var visible = {};
    var groups = [
        last,
        withViewportScroll,
        withDroppableScroll
    ];
    last.all.forEach(function(id) {
        var displacement = $a60ed7403450fe58$var$tryGetVisible(id, groups);
        if (displacement) {
            visible[id] = displacement;
            return;
        }
        invisible[id] = true;
    });
    var newImpact = (0, $h4XE0.default)({}, impact, {
        displaced: {
            all: last.all,
            invisible: invisible,
            visible: visible
        }
    });
    return newImpact;
};
var $a60ed7403450fe58$var$withViewportDisplacement = function(viewport, point) {
    return $a60ed7403450fe58$var$add(viewport.scroll.diff.displacement, point);
};
var $a60ed7403450fe58$var$getClientFromPageBorderBoxCenter = function(_ref) {
    var pageBorderBoxCenter = _ref.pageBorderBoxCenter, draggable = _ref.draggable, viewport = _ref.viewport;
    var withoutPageScrollChange = $a60ed7403450fe58$var$withViewportDisplacement(viewport, pageBorderBoxCenter);
    var offset = $a60ed7403450fe58$var$subtract(withoutPageScrollChange, draggable.page.borderBox.center);
    return $a60ed7403450fe58$var$add(draggable.client.borderBox.center, offset);
};
var $a60ed7403450fe58$var$isTotallyVisibleInNewLocation = function(_ref) {
    var draggable = _ref.draggable, destination = _ref.destination, newPageBorderBoxCenter = _ref.newPageBorderBoxCenter, viewport = _ref.viewport, withDroppableDisplacement = _ref.withDroppableDisplacement, _ref$onlyOnMainAxis = _ref.onlyOnMainAxis, onlyOnMainAxis = _ref$onlyOnMainAxis === void 0 ? false : _ref$onlyOnMainAxis;
    var changeNeeded = $a60ed7403450fe58$var$subtract(newPageBorderBoxCenter, draggable.page.borderBox.center);
    var shifted = $a60ed7403450fe58$var$offsetByPosition(draggable.page.borderBox, changeNeeded);
    var args = {
        target: shifted,
        destination: destination,
        withDroppableDisplacement: withDroppableDisplacement,
        viewport: viewport
    };
    return onlyOnMainAxis ? $a60ed7403450fe58$var$isTotallyVisibleOnAxis(args) : $a60ed7403450fe58$var$isTotallyVisible(args);
};
var $a60ed7403450fe58$var$moveToNextPlace = function(_ref) {
    var isMovingForward = _ref.isMovingForward, draggable = _ref.draggable, destination = _ref.destination, draggables = _ref.draggables, previousImpact = _ref.previousImpact, viewport = _ref.viewport, previousPageBorderBoxCenter = _ref.previousPageBorderBoxCenter, previousClientSelection = _ref.previousClientSelection, afterCritical = _ref.afterCritical;
    if (!destination.isEnabled) return null;
    var insideDestination = $a60ed7403450fe58$var$getDraggablesInsideDroppable(destination.descriptor.id, draggables);
    var isInHomeList = $a60ed7403450fe58$var$isHomeOf(draggable, destination);
    var impact = $a60ed7403450fe58$var$moveToNextCombine({
        isMovingForward: isMovingForward,
        draggable: draggable,
        destination: destination,
        insideDestination: insideDestination,
        previousImpact: previousImpact
    }) || $a60ed7403450fe58$var$moveToNextIndex({
        isMovingForward: isMovingForward,
        isInHomeList: isInHomeList,
        draggable: draggable,
        draggables: draggables,
        destination: destination,
        insideDestination: insideDestination,
        previousImpact: previousImpact,
        viewport: viewport,
        afterCritical: afterCritical
    });
    if (!impact) return null;
    var pageBorderBoxCenter = $a60ed7403450fe58$var$getPageBorderBoxCenterFromImpact({
        impact: impact,
        draggable: draggable,
        droppable: destination,
        draggables: draggables,
        afterCritical: afterCritical
    });
    var isVisibleInNewLocation = $a60ed7403450fe58$var$isTotallyVisibleInNewLocation({
        draggable: draggable,
        destination: destination,
        newPageBorderBoxCenter: pageBorderBoxCenter,
        viewport: viewport.frame,
        withDroppableDisplacement: false,
        onlyOnMainAxis: true
    });
    if (isVisibleInNewLocation) {
        var clientSelection = $a60ed7403450fe58$var$getClientFromPageBorderBoxCenter({
            pageBorderBoxCenter: pageBorderBoxCenter,
            draggable: draggable,
            viewport: viewport
        });
        return {
            clientSelection: clientSelection,
            impact: impact,
            scrollJumpRequest: null
        };
    }
    var distance = $a60ed7403450fe58$var$subtract(pageBorderBoxCenter, previousPageBorderBoxCenter);
    var cautious = $a60ed7403450fe58$var$speculativelyIncrease({
        impact: impact,
        viewport: viewport,
        destination: destination,
        draggables: draggables,
        maxScrollChange: distance
    });
    return {
        clientSelection: previousClientSelection,
        impact: cautious,
        scrollJumpRequest: distance
    };
};
var $a60ed7403450fe58$var$getKnownActive = function getKnownActive(droppable) {
    var rect = droppable.subject.active;
    !rect && $a60ed7403450fe58$var$invariant(false);
    return rect;
};
var $a60ed7403450fe58$var$getBestCrossAxisDroppable = function(_ref) {
    var isMovingForward = _ref.isMovingForward, pageBorderBoxCenter = _ref.pageBorderBoxCenter, source = _ref.source, droppables = _ref.droppables, viewport = _ref.viewport;
    var active = source.subject.active;
    if (!active) return null;
    var axis = source.axis;
    var isBetweenSourceClipped = $a60ed7403450fe58$var$isWithin(active[axis.start], active[axis.end]);
    var candidates = $a60ed7403450fe58$var$toDroppableList(droppables).filter(function(droppable) {
        return droppable !== source;
    }).filter(function(droppable) {
        return droppable.isEnabled;
    }).filter(function(droppable) {
        return Boolean(droppable.subject.active);
    }).filter(function(droppable) {
        return $a60ed7403450fe58$var$isPartiallyVisibleThroughFrame(viewport.frame)($a60ed7403450fe58$var$getKnownActive(droppable));
    }).filter(function(droppable) {
        var activeOfTarget = $a60ed7403450fe58$var$getKnownActive(droppable);
        if (isMovingForward) return active[axis.crossAxisEnd] < activeOfTarget[axis.crossAxisEnd];
        return activeOfTarget[axis.crossAxisStart] < active[axis.crossAxisStart];
    }).filter(function(droppable) {
        var activeOfTarget = $a60ed7403450fe58$var$getKnownActive(droppable);
        var isBetweenDestinationClipped = $a60ed7403450fe58$var$isWithin(activeOfTarget[axis.start], activeOfTarget[axis.end]);
        return isBetweenSourceClipped(activeOfTarget[axis.start]) || isBetweenSourceClipped(activeOfTarget[axis.end]) || isBetweenDestinationClipped(active[axis.start]) || isBetweenDestinationClipped(active[axis.end]);
    }).sort(function(a, b) {
        var first = $a60ed7403450fe58$var$getKnownActive(a)[axis.crossAxisStart];
        var second = $a60ed7403450fe58$var$getKnownActive(b)[axis.crossAxisStart];
        if (isMovingForward) return first - second;
        return second - first;
    }).filter(function(droppable, index, array) {
        return $a60ed7403450fe58$var$getKnownActive(droppable)[axis.crossAxisStart] === $a60ed7403450fe58$var$getKnownActive(array[0])[axis.crossAxisStart];
    });
    if (!candidates.length) return null;
    if (candidates.length === 1) return candidates[0];
    var contains = candidates.filter(function(droppable) {
        var isWithinDroppable = $a60ed7403450fe58$var$isWithin($a60ed7403450fe58$var$getKnownActive(droppable)[axis.start], $a60ed7403450fe58$var$getKnownActive(droppable)[axis.end]);
        return isWithinDroppable(pageBorderBoxCenter[axis.line]);
    });
    if (contains.length === 1) return contains[0];
    if (contains.length > 1) return contains.sort(function(a, b) {
        return $a60ed7403450fe58$var$getKnownActive(a)[axis.start] - $a60ed7403450fe58$var$getKnownActive(b)[axis.start];
    })[0];
    return candidates.sort(function(a, b) {
        var first = $a60ed7403450fe58$var$closest(pageBorderBoxCenter, $a60ed7403450fe58$var$getCorners($a60ed7403450fe58$var$getKnownActive(a)));
        var second = $a60ed7403450fe58$var$closest(pageBorderBoxCenter, $a60ed7403450fe58$var$getCorners($a60ed7403450fe58$var$getKnownActive(b)));
        if (first !== second) return first - second;
        return $a60ed7403450fe58$var$getKnownActive(a)[axis.start] - $a60ed7403450fe58$var$getKnownActive(b)[axis.start];
    })[0];
};
var $a60ed7403450fe58$var$getCurrentPageBorderBoxCenter = function getCurrentPageBorderBoxCenter(draggable, afterCritical) {
    var original = draggable.page.borderBox.center;
    return $a60ed7403450fe58$var$didStartAfterCritical(draggable.descriptor.id, afterCritical) ? $a60ed7403450fe58$var$subtract(original, afterCritical.displacedBy.point) : original;
};
var $a60ed7403450fe58$var$getCurrentPageBorderBox = function getCurrentPageBorderBox(draggable, afterCritical) {
    var original = draggable.page.borderBox;
    return $a60ed7403450fe58$var$didStartAfterCritical(draggable.descriptor.id, afterCritical) ? $a60ed7403450fe58$var$offsetByPosition(original, $a60ed7403450fe58$var$negate(afterCritical.displacedBy.point)) : original;
};
var $a60ed7403450fe58$var$getClosestDraggable = function(_ref) {
    var pageBorderBoxCenter = _ref.pageBorderBoxCenter, viewport = _ref.viewport, destination = _ref.destination, insideDestination = _ref.insideDestination, afterCritical = _ref.afterCritical;
    var sorted = insideDestination.filter(function(draggable) {
        return $a60ed7403450fe58$var$isTotallyVisible({
            target: $a60ed7403450fe58$var$getCurrentPageBorderBox(draggable, afterCritical),
            destination: destination,
            viewport: viewport.frame,
            withDroppableDisplacement: true
        });
    }).sort(function(a, b) {
        var distanceToA = $a60ed7403450fe58$var$distance(pageBorderBoxCenter, $a60ed7403450fe58$var$withDroppableDisplacement(destination, $a60ed7403450fe58$var$getCurrentPageBorderBoxCenter(a, afterCritical)));
        var distanceToB = $a60ed7403450fe58$var$distance(pageBorderBoxCenter, $a60ed7403450fe58$var$withDroppableDisplacement(destination, $a60ed7403450fe58$var$getCurrentPageBorderBoxCenter(b, afterCritical)));
        if (distanceToA < distanceToB) return -1;
        if (distanceToB < distanceToA) return 1;
        return a.descriptor.index - b.descriptor.index;
    });
    return sorted[0] || null;
};
var $a60ed7403450fe58$var$getDisplacedBy = (0, $kQ1m2.default)(function getDisplacedBy(axis, displaceBy) {
    var displacement = displaceBy[axis.line];
    return {
        value: displacement,
        point: $a60ed7403450fe58$var$patch(axis.line, displacement)
    };
});
var $a60ed7403450fe58$var$getRequiredGrowthForPlaceholder = function getRequiredGrowthForPlaceholder(droppable, placeholderSize, draggables) {
    var axis = droppable.axis;
    if (droppable.descriptor.mode === "virtual") return $a60ed7403450fe58$var$patch(axis.line, placeholderSize[axis.line]);
    var availableSpace = droppable.subject.page.contentBox[axis.size];
    var insideDroppable = $a60ed7403450fe58$var$getDraggablesInsideDroppable(droppable.descriptor.id, draggables);
    var spaceUsed = insideDroppable.reduce(function(sum, dimension) {
        return sum + dimension.client.marginBox[axis.size];
    }, 0);
    var requiredSpace = spaceUsed + placeholderSize[axis.line];
    var needsToGrowBy = requiredSpace - availableSpace;
    if (needsToGrowBy <= 0) return null;
    return $a60ed7403450fe58$var$patch(axis.line, needsToGrowBy);
};
var $a60ed7403450fe58$var$withMaxScroll = function withMaxScroll(frame, max) {
    return (0, $h4XE0.default)({}, frame, {
        scroll: (0, $h4XE0.default)({}, frame.scroll, {
            max: max
        })
    });
};
var $a60ed7403450fe58$var$addPlaceholder = function addPlaceholder(droppable, draggable, draggables) {
    var frame = droppable.frame;
    !!$a60ed7403450fe58$var$isHomeOf(draggable, droppable) && $a60ed7403450fe58$var$invariant(false);
    !!droppable.subject.withPlaceholder && $a60ed7403450fe58$var$invariant(false);
    var placeholderSize = $a60ed7403450fe58$var$getDisplacedBy(droppable.axis, draggable.displaceBy).point;
    var requiredGrowth = $a60ed7403450fe58$var$getRequiredGrowthForPlaceholder(droppable, placeholderSize, draggables);
    var added = {
        placeholderSize: placeholderSize,
        increasedBy: requiredGrowth,
        oldFrameMaxScroll: droppable.frame ? droppable.frame.scroll.max : null
    };
    if (!frame) {
        var _subject = $a60ed7403450fe58$var$getSubject({
            page: droppable.subject.page,
            withPlaceholder: added,
            axis: droppable.axis,
            frame: droppable.frame
        });
        return (0, $h4XE0.default)({}, droppable, {
            subject: _subject
        });
    }
    var maxScroll = requiredGrowth ? $a60ed7403450fe58$var$add(frame.scroll.max, requiredGrowth) : frame.scroll.max;
    var newFrame = $a60ed7403450fe58$var$withMaxScroll(frame, maxScroll);
    var subject = $a60ed7403450fe58$var$getSubject({
        page: droppable.subject.page,
        withPlaceholder: added,
        axis: droppable.axis,
        frame: newFrame
    });
    return (0, $h4XE0.default)({}, droppable, {
        subject: subject,
        frame: newFrame
    });
};
var $a60ed7403450fe58$var$removePlaceholder = function removePlaceholder(droppable) {
    var added = droppable.subject.withPlaceholder;
    !added && $a60ed7403450fe58$var$invariant(false);
    var frame = droppable.frame;
    if (!frame) {
        var _subject2 = $a60ed7403450fe58$var$getSubject({
            page: droppable.subject.page,
            axis: droppable.axis,
            frame: null,
            withPlaceholder: null
        });
        return (0, $h4XE0.default)({}, droppable, {
            subject: _subject2
        });
    }
    var oldMaxScroll = added.oldFrameMaxScroll;
    !oldMaxScroll && $a60ed7403450fe58$var$invariant(false);
    var newFrame = $a60ed7403450fe58$var$withMaxScroll(frame, oldMaxScroll);
    var subject = $a60ed7403450fe58$var$getSubject({
        page: droppable.subject.page,
        axis: droppable.axis,
        frame: newFrame,
        withPlaceholder: null
    });
    return (0, $h4XE0.default)({}, droppable, {
        subject: subject,
        frame: newFrame
    });
};
var $a60ed7403450fe58$var$moveToNewDroppable = function(_ref) {
    var previousPageBorderBoxCenter = _ref.previousPageBorderBoxCenter, moveRelativeTo = _ref.moveRelativeTo, insideDestination = _ref.insideDestination, draggable = _ref.draggable, draggables = _ref.draggables, destination = _ref.destination, viewport = _ref.viewport, afterCritical = _ref.afterCritical;
    if (!moveRelativeTo) {
        if (insideDestination.length) return null;
        var proposed = {
            displaced: $a60ed7403450fe58$var$emptyGroups,
            displacedBy: $a60ed7403450fe58$var$noDisplacedBy,
            at: {
                type: "REORDER",
                destination: {
                    droppableId: destination.descriptor.id,
                    index: 0
                }
            }
        };
        var proposedPageBorderBoxCenter = $a60ed7403450fe58$var$getPageBorderBoxCenterFromImpact({
            impact: proposed,
            draggable: draggable,
            droppable: destination,
            draggables: draggables,
            afterCritical: afterCritical
        });
        var withPlaceholder = $a60ed7403450fe58$var$isHomeOf(draggable, destination) ? destination : $a60ed7403450fe58$var$addPlaceholder(destination, draggable, draggables);
        var isVisibleInNewLocation = $a60ed7403450fe58$var$isTotallyVisibleInNewLocation({
            draggable: draggable,
            destination: withPlaceholder,
            newPageBorderBoxCenter: proposedPageBorderBoxCenter,
            viewport: viewport.frame,
            withDroppableDisplacement: false,
            onlyOnMainAxis: true
        });
        return isVisibleInNewLocation ? proposed : null;
    }
    var isGoingBeforeTarget = Boolean(previousPageBorderBoxCenter[destination.axis.line] <= moveRelativeTo.page.borderBox.center[destination.axis.line]);
    var proposedIndex = function() {
        var relativeTo = moveRelativeTo.descriptor.index;
        if (moveRelativeTo.descriptor.id === draggable.descriptor.id) return relativeTo;
        if (isGoingBeforeTarget) return relativeTo;
        return relativeTo + 1;
    }();
    var displacedBy = $a60ed7403450fe58$var$getDisplacedBy(destination.axis, draggable.displaceBy);
    return $a60ed7403450fe58$var$calculateReorderImpact({
        draggable: draggable,
        insideDestination: insideDestination,
        destination: destination,
        viewport: viewport,
        displacedBy: displacedBy,
        last: $a60ed7403450fe58$var$emptyGroups,
        index: proposedIndex
    });
};
var $a60ed7403450fe58$var$moveCrossAxis = function(_ref) {
    var isMovingForward = _ref.isMovingForward, previousPageBorderBoxCenter = _ref.previousPageBorderBoxCenter, draggable = _ref.draggable, isOver = _ref.isOver, draggables = _ref.draggables, droppables = _ref.droppables, viewport = _ref.viewport, afterCritical = _ref.afterCritical;
    var destination = $a60ed7403450fe58$var$getBestCrossAxisDroppable({
        isMovingForward: isMovingForward,
        pageBorderBoxCenter: previousPageBorderBoxCenter,
        source: isOver,
        droppables: droppables,
        viewport: viewport
    });
    if (!destination) return null;
    var insideDestination = $a60ed7403450fe58$var$getDraggablesInsideDroppable(destination.descriptor.id, draggables);
    var moveRelativeTo = $a60ed7403450fe58$var$getClosestDraggable({
        pageBorderBoxCenter: previousPageBorderBoxCenter,
        viewport: viewport,
        destination: destination,
        insideDestination: insideDestination,
        afterCritical: afterCritical
    });
    var impact = $a60ed7403450fe58$var$moveToNewDroppable({
        previousPageBorderBoxCenter: previousPageBorderBoxCenter,
        destination: destination,
        draggable: draggable,
        draggables: draggables,
        moveRelativeTo: moveRelativeTo,
        insideDestination: insideDestination,
        viewport: viewport,
        afterCritical: afterCritical
    });
    if (!impact) return null;
    var pageBorderBoxCenter = $a60ed7403450fe58$var$getPageBorderBoxCenterFromImpact({
        impact: impact,
        draggable: draggable,
        droppable: destination,
        draggables: draggables,
        afterCritical: afterCritical
    });
    var clientSelection = $a60ed7403450fe58$var$getClientFromPageBorderBoxCenter({
        pageBorderBoxCenter: pageBorderBoxCenter,
        draggable: draggable,
        viewport: viewport
    });
    return {
        clientSelection: clientSelection,
        impact: impact,
        scrollJumpRequest: null
    };
};
var $a60ed7403450fe58$var$whatIsDraggedOver = function(impact) {
    var at = impact.at;
    if (!at) return null;
    if (at.type === "REORDER") return at.destination.droppableId;
    return at.combine.droppableId;
};
var $a60ed7403450fe58$var$getDroppableOver = function getDroppableOver(impact, droppables) {
    var id = $a60ed7403450fe58$var$whatIsDraggedOver(impact);
    return id ? droppables[id] : null;
};
var $a60ed7403450fe58$var$moveInDirection = function(_ref) {
    var state = _ref.state, type = _ref.type;
    var isActuallyOver = $a60ed7403450fe58$var$getDroppableOver(state.impact, state.dimensions.droppables);
    var isMainAxisMovementAllowed = Boolean(isActuallyOver);
    var home = state.dimensions.droppables[state.critical.droppable.id];
    var isOver = isActuallyOver || home;
    var direction = isOver.axis.direction;
    var isMovingOnMainAxis = direction === "vertical" && (type === "MOVE_UP" || type === "MOVE_DOWN") || direction === "horizontal" && (type === "MOVE_LEFT" || type === "MOVE_RIGHT");
    if (isMovingOnMainAxis && !isMainAxisMovementAllowed) return null;
    var isMovingForward = type === "MOVE_DOWN" || type === "MOVE_RIGHT";
    var draggable = state.dimensions.draggables[state.critical.draggable.id];
    var previousPageBorderBoxCenter = state.current.page.borderBoxCenter;
    var _state$dimensions = state.dimensions, draggables = _state$dimensions.draggables, droppables = _state$dimensions.droppables;
    return isMovingOnMainAxis ? $a60ed7403450fe58$var$moveToNextPlace({
        isMovingForward: isMovingForward,
        previousPageBorderBoxCenter: previousPageBorderBoxCenter,
        draggable: draggable,
        destination: isOver,
        draggables: draggables,
        viewport: state.viewport,
        previousClientSelection: state.current.client.selection,
        previousImpact: state.impact,
        afterCritical: state.afterCritical
    }) : $a60ed7403450fe58$var$moveCrossAxis({
        isMovingForward: isMovingForward,
        previousPageBorderBoxCenter: previousPageBorderBoxCenter,
        draggable: draggable,
        isOver: isOver,
        draggables: draggables,
        droppables: droppables,
        viewport: state.viewport,
        afterCritical: state.afterCritical
    });
};
function $a60ed7403450fe58$var$isMovementAllowed(state) {
    return state.phase === "DRAGGING" || state.phase === "COLLECTING";
}
function $a60ed7403450fe58$var$isPositionInFrame(frame) {
    var isWithinVertical = $a60ed7403450fe58$var$isWithin(frame.top, frame.bottom);
    var isWithinHorizontal = $a60ed7403450fe58$var$isWithin(frame.left, frame.right);
    return function run(point) {
        return isWithinVertical(point.y) && isWithinHorizontal(point.x);
    };
}
function $a60ed7403450fe58$var$getHasOverlap(first, second) {
    return first.left < second.right && first.right > second.left && first.top < second.bottom && first.bottom > second.top;
}
function $a60ed7403450fe58$var$getFurthestAway(_ref) {
    var pageBorderBox = _ref.pageBorderBox, draggable = _ref.draggable, candidates = _ref.candidates;
    var startCenter = draggable.page.borderBox.center;
    var sorted = candidates.map(function(candidate) {
        var axis = candidate.axis;
        var target = $a60ed7403450fe58$var$patch(candidate.axis.line, pageBorderBox.center[axis.line], candidate.page.borderBox.center[axis.crossAxisLine]);
        return {
            id: candidate.descriptor.id,
            distance: $a60ed7403450fe58$var$distance(startCenter, target)
        };
    }).sort(function(a, b) {
        return b.distance - a.distance;
    });
    return sorted[0] ? sorted[0].id : null;
}
function $a60ed7403450fe58$var$getDroppableOver$1(_ref2) {
    var pageBorderBox = _ref2.pageBorderBox, draggable = _ref2.draggable, droppables = _ref2.droppables;
    var candidates = $a60ed7403450fe58$var$toDroppableList(droppables).filter(function(item) {
        if (!item.isEnabled) return false;
        var active = item.subject.active;
        if (!active) return false;
        if (!$a60ed7403450fe58$var$getHasOverlap(pageBorderBox, active)) return false;
        if ($a60ed7403450fe58$var$isPositionInFrame(active)(pageBorderBox.center)) return true;
        var axis = item.axis;
        var childCenter = active.center[axis.crossAxisLine];
        var crossAxisStart = pageBorderBox[axis.crossAxisStart];
        var crossAxisEnd = pageBorderBox[axis.crossAxisEnd];
        var isContained = $a60ed7403450fe58$var$isWithin(active[axis.crossAxisStart], active[axis.crossAxisEnd]);
        var isStartContained = isContained(crossAxisStart);
        var isEndContained = isContained(crossAxisEnd);
        if (!isStartContained && !isEndContained) return true;
        if (isStartContained) return crossAxisStart < childCenter;
        return crossAxisEnd > childCenter;
    });
    if (!candidates.length) return null;
    if (candidates.length === 1) return candidates[0].descriptor.id;
    return $a60ed7403450fe58$var$getFurthestAway({
        pageBorderBox: pageBorderBox,
        draggable: draggable,
        candidates: candidates
    });
}
var $a60ed7403450fe58$var$offsetRectByPosition = function offsetRectByPosition(rect, point) {
    return (0, $4J1sD.getRect)($a60ed7403450fe58$var$offsetByPosition(rect, point));
};
var $a60ed7403450fe58$var$withDroppableScroll = function(droppable, area) {
    var frame = droppable.frame;
    if (!frame) return area;
    return $a60ed7403450fe58$var$offsetRectByPosition(area, frame.scroll.diff.value);
};
function $a60ed7403450fe58$var$getIsDisplaced(_ref) {
    var displaced = _ref.displaced, id = _ref.id;
    return Boolean(displaced.visible[id] || displaced.invisible[id]);
}
function $a60ed7403450fe58$var$atIndex(_ref) {
    var draggable = _ref.draggable, closest = _ref.closest, inHomeList = _ref.inHomeList;
    if (!closest) return null;
    if (!inHomeList) return closest.descriptor.index;
    if (closest.descriptor.index > draggable.descriptor.index) return closest.descriptor.index - 1;
    return closest.descriptor.index;
}
var $a60ed7403450fe58$var$getReorderImpact = function(_ref2) {
    var targetRect = _ref2.pageBorderBoxWithDroppableScroll, draggable = _ref2.draggable, destination = _ref2.destination, insideDestination = _ref2.insideDestination, last = _ref2.last, viewport = _ref2.viewport, afterCritical = _ref2.afterCritical;
    var axis = destination.axis;
    var displacedBy = $a60ed7403450fe58$var$getDisplacedBy(destination.axis, draggable.displaceBy);
    var displacement = displacedBy.value;
    var targetStart = targetRect[axis.start];
    var targetEnd = targetRect[axis.end];
    var withoutDragging = $a60ed7403450fe58$var$removeDraggableFromList(draggable, insideDestination);
    var closest = $a60ed7403450fe58$var$find(withoutDragging, function(child) {
        var id = child.descriptor.id;
        var childCenter = child.page.borderBox.center[axis.line];
        var didStartAfterCritical$1 = $a60ed7403450fe58$var$didStartAfterCritical(id, afterCritical);
        var isDisplaced = $a60ed7403450fe58$var$getIsDisplaced({
            displaced: last,
            id: id
        });
        if (didStartAfterCritical$1) {
            if (isDisplaced) return targetEnd <= childCenter;
            return targetStart < childCenter - displacement;
        }
        if (isDisplaced) return targetEnd <= childCenter + displacement;
        return targetStart < childCenter;
    });
    var newIndex = $a60ed7403450fe58$var$atIndex({
        draggable: draggable,
        closest: closest,
        inHomeList: $a60ed7403450fe58$var$isHomeOf(draggable, destination)
    });
    return $a60ed7403450fe58$var$calculateReorderImpact({
        draggable: draggable,
        insideDestination: insideDestination,
        destination: destination,
        viewport: viewport,
        last: last,
        displacedBy: displacedBy,
        index: newIndex
    });
};
var $a60ed7403450fe58$var$combineThresholdDivisor = 4;
var $a60ed7403450fe58$var$getCombineImpact = function(_ref) {
    var draggable = _ref.draggable, targetRect = _ref.pageBorderBoxWithDroppableScroll, previousImpact = _ref.previousImpact, destination = _ref.destination, insideDestination = _ref.insideDestination, afterCritical = _ref.afterCritical;
    if (!destination.isCombineEnabled) return null;
    var axis = destination.axis;
    var displacedBy = $a60ed7403450fe58$var$getDisplacedBy(destination.axis, draggable.displaceBy);
    var displacement = displacedBy.value;
    var targetStart = targetRect[axis.start];
    var targetEnd = targetRect[axis.end];
    var withoutDragging = $a60ed7403450fe58$var$removeDraggableFromList(draggable, insideDestination);
    var combineWith = $a60ed7403450fe58$var$find(withoutDragging, function(child) {
        var id = child.descriptor.id;
        var childRect = child.page.borderBox;
        var childSize = childRect[axis.size];
        var threshold = childSize / $a60ed7403450fe58$var$combineThresholdDivisor;
        var didStartAfterCritical$1 = $a60ed7403450fe58$var$didStartAfterCritical(id, afterCritical);
        var isDisplaced = $a60ed7403450fe58$var$getIsDisplaced({
            displaced: previousImpact.displaced,
            id: id
        });
        if (didStartAfterCritical$1) {
            if (isDisplaced) return targetEnd > childRect[axis.start] + threshold && targetEnd < childRect[axis.end] - threshold;
            return targetStart > childRect[axis.start] - displacement + threshold && targetStart < childRect[axis.end] - displacement - threshold;
        }
        if (isDisplaced) return targetEnd > childRect[axis.start] + displacement + threshold && targetEnd < childRect[axis.end] + displacement - threshold;
        return targetStart > childRect[axis.start] + threshold && targetStart < childRect[axis.end] - threshold;
    });
    if (!combineWith) return null;
    var impact = {
        displacedBy: displacedBy,
        displaced: previousImpact.displaced,
        at: {
            type: "COMBINE",
            combine: {
                draggableId: combineWith.descriptor.id,
                droppableId: destination.descriptor.id
            }
        }
    };
    return impact;
};
var $a60ed7403450fe58$var$getDragImpact = function(_ref) {
    var pageOffset = _ref.pageOffset, draggable = _ref.draggable, draggables = _ref.draggables, droppables = _ref.droppables, previousImpact = _ref.previousImpact, viewport = _ref.viewport, afterCritical = _ref.afterCritical;
    var pageBorderBox = $a60ed7403450fe58$var$offsetRectByPosition(draggable.page.borderBox, pageOffset);
    var destinationId = $a60ed7403450fe58$var$getDroppableOver$1({
        pageBorderBox: pageBorderBox,
        draggable: draggable,
        droppables: droppables
    });
    if (!destinationId) return $a60ed7403450fe58$var$noImpact;
    var destination = droppables[destinationId];
    var insideDestination = $a60ed7403450fe58$var$getDraggablesInsideDroppable(destination.descriptor.id, draggables);
    var pageBorderBoxWithDroppableScroll = $a60ed7403450fe58$var$withDroppableScroll(destination, pageBorderBox);
    return $a60ed7403450fe58$var$getCombineImpact({
        pageBorderBoxWithDroppableScroll: pageBorderBoxWithDroppableScroll,
        draggable: draggable,
        previousImpact: previousImpact,
        destination: destination,
        insideDestination: insideDestination,
        afterCritical: afterCritical
    }) || $a60ed7403450fe58$var$getReorderImpact({
        pageBorderBoxWithDroppableScroll: pageBorderBoxWithDroppableScroll,
        draggable: draggable,
        destination: destination,
        insideDestination: insideDestination,
        last: previousImpact.displaced,
        viewport: viewport,
        afterCritical: afterCritical
    });
};
var $a60ed7403450fe58$var$patchDroppableMap = function(droppables, updated) {
    var _extends2;
    return (0, $h4XE0.default)({}, droppables, (_extends2 = {}, _extends2[updated.descriptor.id] = updated, _extends2));
};
var $a60ed7403450fe58$var$clearUnusedPlaceholder = function clearUnusedPlaceholder(_ref) {
    var previousImpact = _ref.previousImpact, impact = _ref.impact, droppables = _ref.droppables;
    var last = $a60ed7403450fe58$var$whatIsDraggedOver(previousImpact);
    var now = $a60ed7403450fe58$var$whatIsDraggedOver(impact);
    if (!last) return droppables;
    if (last === now) return droppables;
    var lastDroppable = droppables[last];
    if (!lastDroppable.subject.withPlaceholder) return droppables;
    var updated = $a60ed7403450fe58$var$removePlaceholder(lastDroppable);
    return $a60ed7403450fe58$var$patchDroppableMap(droppables, updated);
};
var $a60ed7403450fe58$var$recomputePlaceholders = function(_ref2) {
    var draggable = _ref2.draggable, draggables = _ref2.draggables, droppables = _ref2.droppables, previousImpact = _ref2.previousImpact, impact = _ref2.impact;
    var cleaned = $a60ed7403450fe58$var$clearUnusedPlaceholder({
        previousImpact: previousImpact,
        impact: impact,
        droppables: droppables
    });
    var isOver = $a60ed7403450fe58$var$whatIsDraggedOver(impact);
    if (!isOver) return cleaned;
    var droppable = droppables[isOver];
    if ($a60ed7403450fe58$var$isHomeOf(draggable, droppable)) return cleaned;
    if (droppable.subject.withPlaceholder) return cleaned;
    var patched = $a60ed7403450fe58$var$addPlaceholder(droppable, draggable, draggables);
    return $a60ed7403450fe58$var$patchDroppableMap(cleaned, patched);
};
var $a60ed7403450fe58$var$update = function(_ref) {
    var state = _ref.state, forcedClientSelection = _ref.clientSelection, forcedDimensions = _ref.dimensions, forcedViewport = _ref.viewport, forcedImpact = _ref.impact, scrollJumpRequest = _ref.scrollJumpRequest;
    var viewport = forcedViewport || state.viewport;
    var dimensions = forcedDimensions || state.dimensions;
    var clientSelection = forcedClientSelection || state.current.client.selection;
    var offset = $a60ed7403450fe58$var$subtract(clientSelection, state.initial.client.selection);
    var client = {
        offset: offset,
        selection: clientSelection,
        borderBoxCenter: $a60ed7403450fe58$var$add(state.initial.client.borderBoxCenter, offset)
    };
    var page = {
        selection: $a60ed7403450fe58$var$add(client.selection, viewport.scroll.current),
        borderBoxCenter: $a60ed7403450fe58$var$add(client.borderBoxCenter, viewport.scroll.current),
        offset: $a60ed7403450fe58$var$add(client.offset, viewport.scroll.diff.value)
    };
    var current = {
        client: client,
        page: page
    };
    if (state.phase === "COLLECTING") return (0, $h4XE0.default)({
        phase: "COLLECTING"
    }, state, {
        dimensions: dimensions,
        viewport: viewport,
        current: current
    });
    var draggable = dimensions.draggables[state.critical.draggable.id];
    var newImpact = forcedImpact || $a60ed7403450fe58$var$getDragImpact({
        pageOffset: page.offset,
        draggable: draggable,
        draggables: dimensions.draggables,
        droppables: dimensions.droppables,
        previousImpact: state.impact,
        viewport: viewport,
        afterCritical: state.afterCritical
    });
    var withUpdatedPlaceholders = $a60ed7403450fe58$var$recomputePlaceholders({
        draggable: draggable,
        impact: newImpact,
        previousImpact: state.impact,
        draggables: dimensions.draggables,
        droppables: dimensions.droppables
    });
    var result = (0, $h4XE0.default)({}, state, {
        current: current,
        dimensions: {
            draggables: dimensions.draggables,
            droppables: withUpdatedPlaceholders
        },
        impact: newImpact,
        viewport: viewport,
        scrollJumpRequest: scrollJumpRequest || null,
        forceShouldAnimate: scrollJumpRequest ? false : null
    });
    return result;
};
function $a60ed7403450fe58$var$getDraggables$1(ids, draggables) {
    return ids.map(function(id) {
        return draggables[id];
    });
}
var $a60ed7403450fe58$var$recompute = function(_ref) {
    var impact = _ref.impact, viewport = _ref.viewport, draggables = _ref.draggables, destination = _ref.destination, forceShouldAnimate = _ref.forceShouldAnimate;
    var last = impact.displaced;
    var afterDragging = $a60ed7403450fe58$var$getDraggables$1(last.all, draggables);
    var displaced = $a60ed7403450fe58$var$getDisplacementGroups({
        afterDragging: afterDragging,
        destination: destination,
        displacedBy: impact.displacedBy,
        viewport: viewport.frame,
        forceShouldAnimate: forceShouldAnimate,
        last: last
    });
    return (0, $h4XE0.default)({}, impact, {
        displaced: displaced
    });
};
var $a60ed7403450fe58$var$getClientBorderBoxCenter = function(_ref) {
    var impact = _ref.impact, draggable = _ref.draggable, droppable = _ref.droppable, draggables = _ref.draggables, viewport = _ref.viewport, afterCritical = _ref.afterCritical;
    var pageBorderBoxCenter = $a60ed7403450fe58$var$getPageBorderBoxCenterFromImpact({
        impact: impact,
        draggable: draggable,
        draggables: draggables,
        droppable: droppable,
        afterCritical: afterCritical
    });
    return $a60ed7403450fe58$var$getClientFromPageBorderBoxCenter({
        pageBorderBoxCenter: pageBorderBoxCenter,
        draggable: draggable,
        viewport: viewport
    });
};
var $a60ed7403450fe58$var$refreshSnap = function(_ref) {
    var state = _ref.state, forcedDimensions = _ref.dimensions, forcedViewport = _ref.viewport;
    !(state.movementMode === "SNAP") && $a60ed7403450fe58$var$invariant(false);
    var needsVisibilityCheck = state.impact;
    var viewport = forcedViewport || state.viewport;
    var dimensions = forcedDimensions || state.dimensions;
    var draggables = dimensions.draggables, droppables = dimensions.droppables;
    var draggable = draggables[state.critical.draggable.id];
    var isOver = $a60ed7403450fe58$var$whatIsDraggedOver(needsVisibilityCheck);
    !isOver && $a60ed7403450fe58$var$invariant(false);
    var destination = droppables[isOver];
    var impact = $a60ed7403450fe58$var$recompute({
        impact: needsVisibilityCheck,
        viewport: viewport,
        destination: destination,
        draggables: draggables
    });
    var clientSelection = $a60ed7403450fe58$var$getClientBorderBoxCenter({
        impact: impact,
        draggable: draggable,
        droppable: destination,
        draggables: draggables,
        viewport: viewport,
        afterCritical: state.afterCritical
    });
    return $a60ed7403450fe58$var$update({
        impact: impact,
        clientSelection: clientSelection,
        state: state,
        dimensions: dimensions,
        viewport: viewport
    });
};
var $a60ed7403450fe58$var$getHomeLocation = function(descriptor) {
    return {
        index: descriptor.index,
        droppableId: descriptor.droppableId
    };
};
var $a60ed7403450fe58$var$getLiftEffect = function(_ref) {
    var draggable = _ref.draggable, home = _ref.home, draggables = _ref.draggables, viewport = _ref.viewport;
    var displacedBy = $a60ed7403450fe58$var$getDisplacedBy(home.axis, draggable.displaceBy);
    var insideHome = $a60ed7403450fe58$var$getDraggablesInsideDroppable(home.descriptor.id, draggables);
    var rawIndex = insideHome.indexOf(draggable);
    !(rawIndex !== -1) && $a60ed7403450fe58$var$invariant(false);
    var afterDragging = insideHome.slice(rawIndex + 1);
    var effected = afterDragging.reduce(function(previous, item) {
        previous[item.descriptor.id] = true;
        return previous;
    }, {});
    var afterCritical = {
        inVirtualList: home.descriptor.mode === "virtual",
        displacedBy: displacedBy,
        effected: effected
    };
    var displaced = $a60ed7403450fe58$var$getDisplacementGroups({
        afterDragging: afterDragging,
        destination: home,
        displacedBy: displacedBy,
        last: null,
        viewport: viewport.frame,
        forceShouldAnimate: false
    });
    var impact = {
        displaced: displaced,
        displacedBy: displacedBy,
        at: {
            type: "REORDER",
            destination: $a60ed7403450fe58$var$getHomeLocation(draggable.descriptor)
        }
    };
    return {
        impact: impact,
        afterCritical: afterCritical
    };
};
var $a60ed7403450fe58$var$patchDimensionMap = function(dimensions, updated) {
    return {
        draggables: dimensions.draggables,
        droppables: $a60ed7403450fe58$var$patchDroppableMap(dimensions.droppables, updated)
    };
};
var $a60ed7403450fe58$var$start = function start(key) {};
var $a60ed7403450fe58$var$finish = function finish(key) {};
var $a60ed7403450fe58$var$offsetDraggable = function(_ref) {
    var draggable = _ref.draggable, offset$1 = _ref.offset, initialWindowScroll = _ref.initialWindowScroll;
    var client = (0, $4J1sD.offset)(draggable.client, offset$1);
    var page = (0, $4J1sD.withScroll)(client, initialWindowScroll);
    var moved = (0, $h4XE0.default)({}, draggable, {
        placeholder: (0, $h4XE0.default)({}, draggable.placeholder, {
            client: client
        }),
        client: client,
        page: page
    });
    return moved;
};
var $a60ed7403450fe58$var$getFrame = function(droppable) {
    var frame = droppable.frame;
    !frame && $a60ed7403450fe58$var$invariant(false);
    return frame;
};
var $a60ed7403450fe58$var$adjustAdditionsForScrollChanges = function(_ref) {
    var additions = _ref.additions, updatedDroppables = _ref.updatedDroppables, viewport = _ref.viewport;
    var windowScrollChange = viewport.scroll.diff.value;
    return additions.map(function(draggable) {
        var droppableId = draggable.descriptor.droppableId;
        var modified = updatedDroppables[droppableId];
        var frame = $a60ed7403450fe58$var$getFrame(modified);
        var droppableScrollChange = frame.scroll.diff.value;
        var totalChange = $a60ed7403450fe58$var$add(windowScrollChange, droppableScrollChange);
        var moved = $a60ed7403450fe58$var$offsetDraggable({
            draggable: draggable,
            offset: totalChange,
            initialWindowScroll: viewport.scroll.initial
        });
        return moved;
    });
};
var $a60ed7403450fe58$var$publishWhileDraggingInVirtual = function(_ref) {
    var state = _ref.state, published = _ref.published;
    $a60ed7403450fe58$var$start();
    var withScrollChange = published.modified.map(function(update) {
        var existing = state.dimensions.droppables[update.droppableId];
        var scrolled = $a60ed7403450fe58$var$scrollDroppable(existing, update.scroll);
        return scrolled;
    });
    var droppables = (0, $h4XE0.default)({}, state.dimensions.droppables, {}, $a60ed7403450fe58$var$toDroppableMap(withScrollChange));
    var updatedAdditions = $a60ed7403450fe58$var$toDraggableMap($a60ed7403450fe58$var$adjustAdditionsForScrollChanges({
        additions: published.additions,
        updatedDroppables: droppables,
        viewport: state.viewport
    }));
    var draggables = (0, $h4XE0.default)({}, state.dimensions.draggables, {}, updatedAdditions);
    published.removals.forEach(function(id) {
        delete draggables[id];
    });
    var dimensions = {
        droppables: droppables,
        draggables: draggables
    };
    var wasOverId = $a60ed7403450fe58$var$whatIsDraggedOver(state.impact);
    var wasOver = wasOverId ? dimensions.droppables[wasOverId] : null;
    var draggable = dimensions.draggables[state.critical.draggable.id];
    var home = dimensions.droppables[state.critical.droppable.id];
    var _getLiftEffect = $a60ed7403450fe58$var$getLiftEffect({
        draggable: draggable,
        home: home,
        draggables: draggables,
        viewport: state.viewport
    }), onLiftImpact = _getLiftEffect.impact, afterCritical = _getLiftEffect.afterCritical;
    var previousImpact = wasOver && wasOver.isCombineEnabled ? state.impact : onLiftImpact;
    var impact = $a60ed7403450fe58$var$getDragImpact({
        pageOffset: state.current.page.offset,
        draggable: dimensions.draggables[state.critical.draggable.id],
        draggables: dimensions.draggables,
        droppables: dimensions.droppables,
        previousImpact: previousImpact,
        viewport: state.viewport,
        afterCritical: afterCritical
    });
    $a60ed7403450fe58$var$finish();
    var draggingState = (0, $h4XE0.default)({
        phase: "DRAGGING"
    }, state, {
        phase: "DRAGGING",
        impact: impact,
        onLiftImpact: onLiftImpact,
        dimensions: dimensions,
        afterCritical: afterCritical,
        forceShouldAnimate: false
    });
    if (state.phase === "COLLECTING") return draggingState;
    var dropPending = (0, $h4XE0.default)({
        phase: "DROP_PENDING"
    }, draggingState, {
        phase: "DROP_PENDING",
        reason: state.reason,
        isWaiting: false
    });
    return dropPending;
};
var $a60ed7403450fe58$var$isSnapping = function isSnapping(state) {
    return state.movementMode === "SNAP";
};
var $a60ed7403450fe58$var$postDroppableChange = function postDroppableChange(state, updated, isEnabledChanging) {
    var dimensions = $a60ed7403450fe58$var$patchDimensionMap(state.dimensions, updated);
    if (!$a60ed7403450fe58$var$isSnapping(state) || isEnabledChanging) return $a60ed7403450fe58$var$update({
        state: state,
        dimensions: dimensions
    });
    return $a60ed7403450fe58$var$refreshSnap({
        state: state,
        dimensions: dimensions
    });
};
function $a60ed7403450fe58$var$removeScrollJumpRequest(state) {
    if (state.isDragging && state.movementMode === "SNAP") return (0, $h4XE0.default)({
        phase: "DRAGGING"
    }, state, {
        scrollJumpRequest: null
    });
    return state;
}
var $a60ed7403450fe58$var$idle = {
    phase: "IDLE",
    completed: null,
    shouldFlush: false
};
var $a60ed7403450fe58$var$reducer = function(state, action) {
    if (state === void 0) state = $a60ed7403450fe58$var$idle;
    if (action.type === "FLUSH") return (0, $h4XE0.default)({}, $a60ed7403450fe58$var$idle, {
        shouldFlush: true
    });
    if (action.type === "INITIAL_PUBLISH") {
        !(state.phase === "IDLE") && $a60ed7403450fe58$var$invariant(false);
        var _action$payload = action.payload, critical = _action$payload.critical, clientSelection = _action$payload.clientSelection, viewport = _action$payload.viewport, dimensions = _action$payload.dimensions, movementMode = _action$payload.movementMode;
        var draggable = dimensions.draggables[critical.draggable.id];
        var home = dimensions.droppables[critical.droppable.id];
        var client = {
            selection: clientSelection,
            borderBoxCenter: draggable.client.borderBox.center,
            offset: $a60ed7403450fe58$var$origin
        };
        var initial = {
            client: client,
            page: {
                selection: $a60ed7403450fe58$var$add(client.selection, viewport.scroll.initial),
                borderBoxCenter: $a60ed7403450fe58$var$add(client.selection, viewport.scroll.initial),
                offset: $a60ed7403450fe58$var$add(client.selection, viewport.scroll.diff.value)
            }
        };
        var isWindowScrollAllowed = $a60ed7403450fe58$var$toDroppableList(dimensions.droppables).every(function(item) {
            return !item.isFixedOnPage;
        });
        var _getLiftEffect = $a60ed7403450fe58$var$getLiftEffect({
            draggable: draggable,
            home: home,
            draggables: dimensions.draggables,
            viewport: viewport
        }), impact = _getLiftEffect.impact, afterCritical = _getLiftEffect.afterCritical;
        var result = {
            phase: "DRAGGING",
            isDragging: true,
            critical: critical,
            movementMode: movementMode,
            dimensions: dimensions,
            initial: initial,
            current: initial,
            isWindowScrollAllowed: isWindowScrollAllowed,
            impact: impact,
            afterCritical: afterCritical,
            onLiftImpact: impact,
            viewport: viewport,
            scrollJumpRequest: null,
            forceShouldAnimate: null
        };
        return result;
    }
    if (action.type === "COLLECTION_STARTING") {
        if (state.phase === "COLLECTING" || state.phase === "DROP_PENDING") return state;
        !(state.phase === "DRAGGING") && $a60ed7403450fe58$var$invariant(false);
        var _result = (0, $h4XE0.default)({
            phase: "COLLECTING"
        }, state, {
            phase: "COLLECTING"
        });
        return _result;
    }
    if (action.type === "PUBLISH_WHILE_DRAGGING") {
        !(state.phase === "COLLECTING" || state.phase === "DROP_PENDING") && $a60ed7403450fe58$var$invariant(false);
        return $a60ed7403450fe58$var$publishWhileDraggingInVirtual({
            state: state,
            published: action.payload
        });
    }
    if (action.type === "MOVE") {
        if (state.phase === "DROP_PENDING") return state;
        !$a60ed7403450fe58$var$isMovementAllowed(state) && $a60ed7403450fe58$var$invariant(false);
        var _clientSelection = action.payload.client;
        if ($a60ed7403450fe58$var$isEqual(_clientSelection, state.current.client.selection)) return state;
        return $a60ed7403450fe58$var$update({
            state: state,
            clientSelection: _clientSelection,
            impact: $a60ed7403450fe58$var$isSnapping(state) ? state.impact : null
        });
    }
    if (action.type === "UPDATE_DROPPABLE_SCROLL") {
        if (state.phase === "DROP_PENDING") return $a60ed7403450fe58$var$removeScrollJumpRequest(state);
        if (state.phase === "COLLECTING") return $a60ed7403450fe58$var$removeScrollJumpRequest(state);
        !$a60ed7403450fe58$var$isMovementAllowed(state) && $a60ed7403450fe58$var$invariant(false);
        var _action$payload2 = action.payload, id = _action$payload2.id, newScroll = _action$payload2.newScroll;
        var target = state.dimensions.droppables[id];
        if (!target) return state;
        var scrolled = $a60ed7403450fe58$var$scrollDroppable(target, newScroll);
        return $a60ed7403450fe58$var$postDroppableChange(state, scrolled, false);
    }
    if (action.type === "UPDATE_DROPPABLE_IS_ENABLED") {
        if (state.phase === "DROP_PENDING") return state;
        !$a60ed7403450fe58$var$isMovementAllowed(state) && $a60ed7403450fe58$var$invariant(false);
        var _action$payload3 = action.payload, _id = _action$payload3.id, isEnabled = _action$payload3.isEnabled;
        var _target = state.dimensions.droppables[_id];
        !_target && $a60ed7403450fe58$var$invariant(false);
        !(_target.isEnabled !== isEnabled) && $a60ed7403450fe58$var$invariant(false);
        var updated = (0, $h4XE0.default)({}, _target, {
            isEnabled: isEnabled
        });
        return $a60ed7403450fe58$var$postDroppableChange(state, updated, true);
    }
    if (action.type === "UPDATE_DROPPABLE_IS_COMBINE_ENABLED") {
        if (state.phase === "DROP_PENDING") return state;
        !$a60ed7403450fe58$var$isMovementAllowed(state) && $a60ed7403450fe58$var$invariant(false);
        var _action$payload4 = action.payload, _id2 = _action$payload4.id, isCombineEnabled = _action$payload4.isCombineEnabled;
        var _target2 = state.dimensions.droppables[_id2];
        !_target2 && $a60ed7403450fe58$var$invariant(false);
        !(_target2.isCombineEnabled !== isCombineEnabled) && $a60ed7403450fe58$var$invariant(false);
        var _updated = (0, $h4XE0.default)({}, _target2, {
            isCombineEnabled: isCombineEnabled
        });
        return $a60ed7403450fe58$var$postDroppableChange(state, _updated, true);
    }
    if (action.type === "MOVE_BY_WINDOW_SCROLL") {
        if (state.phase === "DROP_PENDING" || state.phase === "DROP_ANIMATING") return state;
        !$a60ed7403450fe58$var$isMovementAllowed(state) && $a60ed7403450fe58$var$invariant(false);
        !state.isWindowScrollAllowed && $a60ed7403450fe58$var$invariant(false);
        var _newScroll = action.payload.newScroll;
        if ($a60ed7403450fe58$var$isEqual(state.viewport.scroll.current, _newScroll)) return $a60ed7403450fe58$var$removeScrollJumpRequest(state);
        var _viewport = $a60ed7403450fe58$var$scrollViewport(state.viewport, _newScroll);
        if ($a60ed7403450fe58$var$isSnapping(state)) return $a60ed7403450fe58$var$refreshSnap({
            state: state,
            viewport: _viewport
        });
        return $a60ed7403450fe58$var$update({
            state: state,
            viewport: _viewport
        });
    }
    if (action.type === "UPDATE_VIEWPORT_MAX_SCROLL") {
        if (!$a60ed7403450fe58$var$isMovementAllowed(state)) return state;
        var maxScroll = action.payload.maxScroll;
        if ($a60ed7403450fe58$var$isEqual(maxScroll, state.viewport.scroll.max)) return state;
        var withMaxScroll = (0, $h4XE0.default)({}, state.viewport, {
            scroll: (0, $h4XE0.default)({}, state.viewport.scroll, {
                max: maxScroll
            })
        });
        return (0, $h4XE0.default)({
            phase: "DRAGGING"
        }, state, {
            viewport: withMaxScroll
        });
    }
    if (action.type === "MOVE_UP" || action.type === "MOVE_DOWN" || action.type === "MOVE_LEFT" || action.type === "MOVE_RIGHT") {
        if (state.phase === "COLLECTING" || state.phase === "DROP_PENDING") return state;
        !(state.phase === "DRAGGING") && $a60ed7403450fe58$var$invariant(false);
        var _result2 = $a60ed7403450fe58$var$moveInDirection({
            state: state,
            type: action.type
        });
        if (!_result2) return state;
        return $a60ed7403450fe58$var$update({
            state: state,
            impact: _result2.impact,
            clientSelection: _result2.clientSelection,
            scrollJumpRequest: _result2.scrollJumpRequest
        });
    }
    if (action.type === "DROP_PENDING") {
        var reason = action.payload.reason;
        !(state.phase === "COLLECTING") && $a60ed7403450fe58$var$invariant(false);
        var newState = (0, $h4XE0.default)({
            phase: "DROP_PENDING"
        }, state, {
            phase: "DROP_PENDING",
            isWaiting: true,
            reason: reason
        });
        return newState;
    }
    if (action.type === "DROP_ANIMATE") {
        var _action$payload5 = action.payload, completed = _action$payload5.completed, dropDuration = _action$payload5.dropDuration, newHomeClientOffset = _action$payload5.newHomeClientOffset;
        !(state.phase === "DRAGGING" || state.phase === "DROP_PENDING") && $a60ed7403450fe58$var$invariant(false);
        var _result3 = {
            phase: "DROP_ANIMATING",
            completed: completed,
            dropDuration: dropDuration,
            newHomeClientOffset: newHomeClientOffset,
            dimensions: state.dimensions
        };
        return _result3;
    }
    if (action.type === "DROP_COMPLETE") {
        var _completed = action.payload.completed;
        return {
            phase: "IDLE",
            completed: _completed,
            shouldFlush: false
        };
    }
    return state;
};
var $a60ed7403450fe58$var$beforeInitialCapture = function beforeInitialCapture(args) {
    return {
        type: "BEFORE_INITIAL_CAPTURE",
        payload: args
    };
};
var $a60ed7403450fe58$var$lift = function lift(args) {
    return {
        type: "LIFT",
        payload: args
    };
};
var $a60ed7403450fe58$var$initialPublish = function initialPublish(args) {
    return {
        type: "INITIAL_PUBLISH",
        payload: args
    };
};
var $a60ed7403450fe58$var$publishWhileDragging = function publishWhileDragging(args) {
    return {
        type: "PUBLISH_WHILE_DRAGGING",
        payload: args
    };
};
var $a60ed7403450fe58$var$collectionStarting = function collectionStarting() {
    return {
        type: "COLLECTION_STARTING",
        payload: null
    };
};
var $a60ed7403450fe58$var$updateDroppableScroll = function updateDroppableScroll(args) {
    return {
        type: "UPDATE_DROPPABLE_SCROLL",
        payload: args
    };
};
var $a60ed7403450fe58$var$updateDroppableIsEnabled = function updateDroppableIsEnabled(args) {
    return {
        type: "UPDATE_DROPPABLE_IS_ENABLED",
        payload: args
    };
};
var $a60ed7403450fe58$var$updateDroppableIsCombineEnabled = function updateDroppableIsCombineEnabled(args) {
    return {
        type: "UPDATE_DROPPABLE_IS_COMBINE_ENABLED",
        payload: args
    };
};
var $a60ed7403450fe58$var$move = function move(args) {
    return {
        type: "MOVE",
        payload: args
    };
};
var $a60ed7403450fe58$var$moveByWindowScroll = function moveByWindowScroll(args) {
    return {
        type: "MOVE_BY_WINDOW_SCROLL",
        payload: args
    };
};
var $a60ed7403450fe58$var$updateViewportMaxScroll = function updateViewportMaxScroll(args) {
    return {
        type: "UPDATE_VIEWPORT_MAX_SCROLL",
        payload: args
    };
};
var $a60ed7403450fe58$var$moveUp = function moveUp() {
    return {
        type: "MOVE_UP",
        payload: null
    };
};
var $a60ed7403450fe58$var$moveDown = function moveDown() {
    return {
        type: "MOVE_DOWN",
        payload: null
    };
};
var $a60ed7403450fe58$var$moveRight = function moveRight() {
    return {
        type: "MOVE_RIGHT",
        payload: null
    };
};
var $a60ed7403450fe58$var$moveLeft = function moveLeft() {
    return {
        type: "MOVE_LEFT",
        payload: null
    };
};
var $a60ed7403450fe58$var$flush = function flush() {
    return {
        type: "FLUSH",
        payload: null
    };
};
var $a60ed7403450fe58$var$animateDrop = function animateDrop(args) {
    return {
        type: "DROP_ANIMATE",
        payload: args
    };
};
var $a60ed7403450fe58$var$completeDrop = function completeDrop(args) {
    return {
        type: "DROP_COMPLETE",
        payload: args
    };
};
var $a60ed7403450fe58$var$drop = function drop(args) {
    return {
        type: "DROP",
        payload: args
    };
};
var $a60ed7403450fe58$var$dropPending = function dropPending(args) {
    return {
        type: "DROP_PENDING",
        payload: args
    };
};
var $a60ed7403450fe58$var$dropAnimationFinished = function dropAnimationFinished() {
    return {
        type: "DROP_ANIMATION_FINISHED",
        payload: null
    };
};
function $a60ed7403450fe58$var$checkIndexes(insideDestination) {
    if (insideDestination.length <= 1) return;
    var indexes = insideDestination.map(function(d) {
        return d.descriptor.index;
    });
    var errors = {};
    for(var i = 1; i < indexes.length; i++){
        var current = indexes[i];
        var previous = indexes[i - 1];
        if (current !== previous + 1) errors[current] = true;
    }
    if (!Object.keys(errors).length) return;
    var formatted = indexes.map(function(index) {
        var hasError = Boolean(errors[index]);
        return hasError ? "[\uD83D\uDD25" + index + "]" : "" + index;
    }).join(", ");
}
function $a60ed7403450fe58$var$validateDimensions(critical, dimensions) {
    var insideDestination;
}
var $a60ed7403450fe58$var$lift$1 = function(marshal) {
    return function(_ref) {
        var getState = _ref.getState, dispatch = _ref.dispatch;
        return function(next) {
            return function(action) {
                if (action.type !== "LIFT") {
                    next(action);
                    return;
                }
                var _action$payload = action.payload, id = _action$payload.id, clientSelection = _action$payload.clientSelection, movementMode = _action$payload.movementMode;
                var initial = getState();
                if (initial.phase === "DROP_ANIMATING") dispatch($a60ed7403450fe58$var$completeDrop({
                    completed: initial.completed
                }));
                !(getState().phase === "IDLE") && $a60ed7403450fe58$var$invariant(false);
                dispatch($a60ed7403450fe58$var$flush());
                dispatch($a60ed7403450fe58$var$beforeInitialCapture({
                    draggableId: id,
                    movementMode: movementMode
                }));
                var scrollOptions = {
                    shouldPublishImmediately: movementMode === "SNAP"
                };
                var request = {
                    draggableId: id,
                    scrollOptions: scrollOptions
                };
                var _marshal$startPublish = marshal.startPublishing(request), critical = _marshal$startPublish.critical, dimensions = _marshal$startPublish.dimensions, viewport = _marshal$startPublish.viewport;
                $a60ed7403450fe58$var$validateDimensions(critical, dimensions);
                dispatch($a60ed7403450fe58$var$initialPublish({
                    critical: critical,
                    dimensions: dimensions,
                    clientSelection: clientSelection,
                    movementMode: movementMode,
                    viewport: viewport
                }));
            };
        };
    };
};
var $a60ed7403450fe58$var$style = function(marshal) {
    return function() {
        return function(next) {
            return function(action) {
                if (action.type === "INITIAL_PUBLISH") marshal.dragging();
                if (action.type === "DROP_ANIMATE") marshal.dropping(action.payload.completed.result.reason);
                if (action.type === "FLUSH" || action.type === "DROP_COMPLETE") marshal.resting();
                next(action);
            };
        };
    };
};
var $a60ed7403450fe58$var$curves = {
    outOfTheWay: "cubic-bezier(0.2, 0, 0, 1)",
    drop: "cubic-bezier(.2,1,.1,1)"
};
var $a60ed7403450fe58$var$combine = {
    opacity: {
        drop: 0,
        combining: 0.7
    },
    scale: {
        drop: 0.75
    }
};
var $a60ed7403450fe58$var$timings = {
    outOfTheWay: 0.2,
    minDropTime: 0.33,
    maxDropTime: 0.55
};
var $a60ed7403450fe58$var$outOfTheWayTiming = $a60ed7403450fe58$var$timings.outOfTheWay + "s " + $a60ed7403450fe58$var$curves.outOfTheWay;
var $a60ed7403450fe58$var$transitions = {
    fluid: "opacity " + $a60ed7403450fe58$var$outOfTheWayTiming,
    snap: "transform " + $a60ed7403450fe58$var$outOfTheWayTiming + ", opacity " + $a60ed7403450fe58$var$outOfTheWayTiming,
    drop: function drop(duration) {
        var timing = duration + "s " + $a60ed7403450fe58$var$curves.drop;
        return "transform " + timing + ", opacity " + timing;
    },
    outOfTheWay: "transform " + $a60ed7403450fe58$var$outOfTheWayTiming,
    placeholder: "height " + $a60ed7403450fe58$var$outOfTheWayTiming + ", width " + $a60ed7403450fe58$var$outOfTheWayTiming + ", margin " + $a60ed7403450fe58$var$outOfTheWayTiming
};
var $a60ed7403450fe58$var$moveTo = function moveTo(offset) {
    return $a60ed7403450fe58$var$isEqual(offset, $a60ed7403450fe58$var$origin) ? null : "translate(" + offset.x + "px, " + offset.y + "px)";
};
var $a60ed7403450fe58$var$transforms = {
    moveTo: $a60ed7403450fe58$var$moveTo,
    drop: function drop(offset, isCombining) {
        var translate = $a60ed7403450fe58$var$moveTo(offset);
        if (!translate) return null;
        if (!isCombining) return translate;
        return translate + " scale(" + $a60ed7403450fe58$var$combine.scale.drop + ")";
    }
};
var $a60ed7403450fe58$var$minDropTime = $a60ed7403450fe58$var$timings.minDropTime, $a60ed7403450fe58$var$maxDropTime = $a60ed7403450fe58$var$timings.maxDropTime;
var $a60ed7403450fe58$var$dropTimeRange = $a60ed7403450fe58$var$maxDropTime - $a60ed7403450fe58$var$minDropTime;
var $a60ed7403450fe58$var$maxDropTimeAtDistance = 1500;
var $a60ed7403450fe58$var$cancelDropModifier = 0.6;
var $a60ed7403450fe58$var$getDropDuration = function(_ref) {
    var current = _ref.current, destination = _ref.destination, reason = _ref.reason;
    var distance$1 = $a60ed7403450fe58$var$distance(current, destination);
    if (distance$1 <= 0) return $a60ed7403450fe58$var$minDropTime;
    if (distance$1 >= $a60ed7403450fe58$var$maxDropTimeAtDistance) return $a60ed7403450fe58$var$maxDropTime;
    var percentage = distance$1 / $a60ed7403450fe58$var$maxDropTimeAtDistance;
    var duration = $a60ed7403450fe58$var$minDropTime + $a60ed7403450fe58$var$dropTimeRange * percentage;
    var withDuration = reason === "CANCEL" ? duration * $a60ed7403450fe58$var$cancelDropModifier : duration;
    return Number(withDuration.toFixed(2));
};
var $a60ed7403450fe58$var$getNewHomeClientOffset = function(_ref) {
    var impact = _ref.impact, draggable = _ref.draggable, dimensions = _ref.dimensions, viewport = _ref.viewport, afterCritical = _ref.afterCritical;
    var draggables = dimensions.draggables, droppables = dimensions.droppables;
    var droppableId = $a60ed7403450fe58$var$whatIsDraggedOver(impact);
    var destination = droppableId ? droppables[droppableId] : null;
    var home = droppables[draggable.descriptor.droppableId];
    var newClientCenter = $a60ed7403450fe58$var$getClientBorderBoxCenter({
        impact: impact,
        draggable: draggable,
        draggables: draggables,
        afterCritical: afterCritical,
        droppable: destination || home,
        viewport: viewport
    });
    var offset = $a60ed7403450fe58$var$subtract(newClientCenter, draggable.client.borderBox.center);
    return offset;
};
var $a60ed7403450fe58$var$getDropImpact = function(_ref) {
    var draggables = _ref.draggables, reason = _ref.reason, lastImpact = _ref.lastImpact, home = _ref.home, viewport = _ref.viewport, onLiftImpact = _ref.onLiftImpact;
    if (!lastImpact.at || reason !== "DROP") {
        var recomputedHomeImpact = $a60ed7403450fe58$var$recompute({
            draggables: draggables,
            impact: onLiftImpact,
            destination: home,
            viewport: viewport,
            forceShouldAnimate: true
        });
        return {
            impact: recomputedHomeImpact,
            didDropInsideDroppable: false
        };
    }
    if (lastImpact.at.type === "REORDER") return {
        impact: lastImpact,
        didDropInsideDroppable: true
    };
    var withoutMovement = (0, $h4XE0.default)({}, lastImpact, {
        displaced: $a60ed7403450fe58$var$emptyGroups
    });
    return {
        impact: withoutMovement,
        didDropInsideDroppable: true
    };
};
var $a60ed7403450fe58$var$drop$1 = function(_ref) {
    var getState = _ref.getState, dispatch = _ref.dispatch;
    return function(next) {
        return function(action) {
            if (action.type !== "DROP") {
                next(action);
                return;
            }
            var state = getState();
            var reason = action.payload.reason;
            if (state.phase === "COLLECTING") {
                dispatch($a60ed7403450fe58$var$dropPending({
                    reason: reason
                }));
                return;
            }
            if (state.phase === "IDLE") return;
            var isWaitingForDrop = state.phase === "DROP_PENDING" && state.isWaiting;
            !!isWaitingForDrop && $a60ed7403450fe58$var$invariant(false);
            !(state.phase === "DRAGGING" || state.phase === "DROP_PENDING") && $a60ed7403450fe58$var$invariant(false);
            var critical = state.critical;
            var dimensions = state.dimensions;
            var draggable = dimensions.draggables[state.critical.draggable.id];
            var _getDropImpact = $a60ed7403450fe58$var$getDropImpact({
                reason: reason,
                lastImpact: state.impact,
                afterCritical: state.afterCritical,
                onLiftImpact: state.onLiftImpact,
                home: state.dimensions.droppables[state.critical.droppable.id],
                viewport: state.viewport,
                draggables: state.dimensions.draggables
            }), impact = _getDropImpact.impact, didDropInsideDroppable = _getDropImpact.didDropInsideDroppable;
            var destination = didDropInsideDroppable ? $a60ed7403450fe58$var$tryGetDestination(impact) : null;
            var combine = didDropInsideDroppable ? $a60ed7403450fe58$var$tryGetCombine(impact) : null;
            var source = {
                index: critical.draggable.index,
                droppableId: critical.droppable.id
            };
            var result = {
                draggableId: draggable.descriptor.id,
                type: draggable.descriptor.type,
                source: source,
                reason: reason,
                mode: state.movementMode,
                destination: destination,
                combine: combine
            };
            var newHomeClientOffset = $a60ed7403450fe58$var$getNewHomeClientOffset({
                impact: impact,
                draggable: draggable,
                dimensions: dimensions,
                viewport: state.viewport,
                afterCritical: state.afterCritical
            });
            var completed = {
                critical: state.critical,
                afterCritical: state.afterCritical,
                result: result,
                impact: impact
            };
            var isAnimationRequired = !$a60ed7403450fe58$var$isEqual(state.current.client.offset, newHomeClientOffset) || Boolean(result.combine);
            if (!isAnimationRequired) {
                dispatch($a60ed7403450fe58$var$completeDrop({
                    completed: completed
                }));
                return;
            }
            var dropDuration = $a60ed7403450fe58$var$getDropDuration({
                current: state.current.client.offset,
                destination: newHomeClientOffset,
                reason: reason
            });
            var args = {
                newHomeClientOffset: newHomeClientOffset,
                dropDuration: dropDuration,
                completed: completed
            };
            dispatch($a60ed7403450fe58$var$animateDrop(args));
        };
    };
};
var $a60ed7403450fe58$var$getWindowScroll = function() {
    return {
        x: window.pageXOffset,
        y: window.pageYOffset
    };
};
function $a60ed7403450fe58$var$getWindowScrollBinding(update) {
    return {
        eventName: "scroll",
        options: {
            passive: true,
            capture: false
        },
        fn: function fn(event) {
            if (event.target !== window && event.target !== window.document) return;
            update();
        }
    };
}
function $a60ed7403450fe58$var$getScrollListener(_ref) {
    var onWindowScroll = _ref.onWindowScroll;
    function updateScroll() {
        onWindowScroll($a60ed7403450fe58$var$getWindowScroll());
    }
    var scheduled = (0, $lqlwE.default)(updateScroll);
    var binding = $a60ed7403450fe58$var$getWindowScrollBinding(scheduled);
    var unbind = $a60ed7403450fe58$var$noop;
    function isActive() {
        return unbind !== $a60ed7403450fe58$var$noop;
    }
    function start() {
        !!isActive() && $a60ed7403450fe58$var$invariant(false);
        unbind = $a60ed7403450fe58$var$bindEvents(window, [
            binding
        ]);
    }
    function stop() {
        !isActive() && $a60ed7403450fe58$var$invariant(false);
        scheduled.cancel();
        unbind();
        unbind = $a60ed7403450fe58$var$noop;
    }
    return {
        start: start,
        stop: stop,
        isActive: isActive
    };
}
var $a60ed7403450fe58$var$shouldEnd = function shouldEnd(action) {
    return action.type === "DROP_COMPLETE" || action.type === "DROP_ANIMATE" || action.type === "FLUSH";
};
var $a60ed7403450fe58$var$scrollListener = function(store) {
    var listener = $a60ed7403450fe58$var$getScrollListener({
        onWindowScroll: function onWindowScroll(newScroll) {
            store.dispatch($a60ed7403450fe58$var$moveByWindowScroll({
                newScroll: newScroll
            }));
        }
    });
    return function(next) {
        return function(action) {
            if (!listener.isActive() && action.type === "INITIAL_PUBLISH") listener.start();
            if (listener.isActive() && $a60ed7403450fe58$var$shouldEnd(action)) listener.stop();
            next(action);
        };
    };
};
var $a60ed7403450fe58$var$getExpiringAnnounce = function(announce) {
    var wasCalled = false;
    var isExpired = false;
    var timeoutId = setTimeout(function() {
        isExpired = true;
    });
    var result = function result(message) {
        if (wasCalled) return;
        if (isExpired) return;
        wasCalled = true;
        announce(message);
        clearTimeout(timeoutId);
    };
    result.wasCalled = function() {
        return wasCalled;
    };
    return result;
};
var $a60ed7403450fe58$var$getAsyncMarshal = function() {
    var entries = [];
    var execute = function execute(timerId) {
        var index = $a60ed7403450fe58$var$findIndex(entries, function(item) {
            return item.timerId === timerId;
        });
        !(index !== -1) && $a60ed7403450fe58$var$invariant(false);
        var _entries$splice = entries.splice(index, 1), entry = _entries$splice[0];
        entry.callback();
    };
    var add = function add(fn) {
        var timerId = setTimeout(function() {
            return execute(timerId);
        });
        var entry = {
            timerId: timerId,
            callback: fn
        };
        entries.push(entry);
    };
    var flush = function flush() {
        if (!entries.length) return;
        var shallow = [].concat(entries);
        entries.length = 0;
        shallow.forEach(function(entry) {
            clearTimeout(entry.timerId);
            entry.callback();
        });
    };
    return {
        add: add,
        flush: flush
    };
};
var $a60ed7403450fe58$var$areLocationsEqual = function areLocationsEqual(first, second) {
    if (first == null && second == null) return true;
    if (first == null || second == null) return false;
    return first.droppableId === second.droppableId && first.index === second.index;
};
var $a60ed7403450fe58$var$isCombineEqual = function isCombineEqual(first, second) {
    if (first == null && second == null) return true;
    if (first == null || second == null) return false;
    return first.draggableId === second.draggableId && first.droppableId === second.droppableId;
};
var $a60ed7403450fe58$var$isCriticalEqual = function isCriticalEqual(first, second) {
    if (first === second) return true;
    var isDraggableEqual = first.draggable.id === second.draggable.id && first.draggable.droppableId === second.draggable.droppableId && first.draggable.type === second.draggable.type && first.draggable.index === second.draggable.index;
    var isDroppableEqual = first.droppable.id === second.droppable.id && first.droppable.type === second.droppable.type;
    return isDraggableEqual && isDroppableEqual;
};
var $a60ed7403450fe58$var$withTimings = function withTimings(key, fn) {
    $a60ed7403450fe58$var$start();
    fn();
    $a60ed7403450fe58$var$finish();
};
var $a60ed7403450fe58$var$getDragStart = function getDragStart(critical, mode) {
    return {
        draggableId: critical.draggable.id,
        type: critical.droppable.type,
        source: {
            droppableId: critical.droppable.id,
            index: critical.draggable.index
        },
        mode: mode
    };
};
var $a60ed7403450fe58$var$execute = function execute(responder, data, announce, getDefaultMessage) {
    if (!responder) {
        announce(getDefaultMessage(data));
        return;
    }
    var willExpire = $a60ed7403450fe58$var$getExpiringAnnounce(announce);
    var provided = {
        announce: willExpire
    };
    responder(data, provided);
    if (!willExpire.wasCalled()) announce(getDefaultMessage(data));
};
var $a60ed7403450fe58$var$getPublisher = function(getResponders, announce) {
    var asyncMarshal = $a60ed7403450fe58$var$getAsyncMarshal();
    var dragging = null;
    var beforeCapture = function beforeCapture(draggableId, mode) {
        !!dragging && $a60ed7403450fe58$var$invariant(false);
        $a60ed7403450fe58$var$withTimings("onBeforeCapture", function() {
            var fn = getResponders().onBeforeCapture;
            if (fn) {
                var before = {
                    draggableId: draggableId,
                    mode: mode
                };
                fn(before);
            }
        });
    };
    var beforeStart = function beforeStart(critical, mode) {
        !!dragging && $a60ed7403450fe58$var$invariant(false);
        $a60ed7403450fe58$var$withTimings("onBeforeDragStart", function() {
            var fn = getResponders().onBeforeDragStart;
            if (fn) fn($a60ed7403450fe58$var$getDragStart(critical, mode));
        });
    };
    var start = function start(critical, mode) {
        !!dragging && $a60ed7403450fe58$var$invariant(false);
        var data = $a60ed7403450fe58$var$getDragStart(critical, mode);
        dragging = {
            mode: mode,
            lastCritical: critical,
            lastLocation: data.source,
            lastCombine: null
        };
        asyncMarshal.add(function() {
            $a60ed7403450fe58$var$withTimings("onDragStart", function() {
                return $a60ed7403450fe58$var$execute(getResponders().onDragStart, data, announce, $a60ed7403450fe58$var$preset.onDragStart);
            });
        });
    };
    var update = function update(critical, impact) {
        var location = $a60ed7403450fe58$var$tryGetDestination(impact);
        var combine = $a60ed7403450fe58$var$tryGetCombine(impact);
        !dragging && $a60ed7403450fe58$var$invariant(false);
        var hasCriticalChanged = !$a60ed7403450fe58$var$isCriticalEqual(critical, dragging.lastCritical);
        if (hasCriticalChanged) dragging.lastCritical = critical;
        var hasLocationChanged = !$a60ed7403450fe58$var$areLocationsEqual(dragging.lastLocation, location);
        if (hasLocationChanged) dragging.lastLocation = location;
        var hasGroupingChanged = !$a60ed7403450fe58$var$isCombineEqual(dragging.lastCombine, combine);
        if (hasGroupingChanged) dragging.lastCombine = combine;
        if (!hasCriticalChanged && !hasLocationChanged && !hasGroupingChanged) return;
        var data = (0, $h4XE0.default)({}, $a60ed7403450fe58$var$getDragStart(critical, dragging.mode), {
            combine: combine,
            destination: location
        });
        asyncMarshal.add(function() {
            $a60ed7403450fe58$var$withTimings("onDragUpdate", function() {
                return $a60ed7403450fe58$var$execute(getResponders().onDragUpdate, data, announce, $a60ed7403450fe58$var$preset.onDragUpdate);
            });
        });
    };
    var flush = function flush() {
        !dragging && $a60ed7403450fe58$var$invariant(false);
        asyncMarshal.flush();
    };
    var drop = function drop(result) {
        !dragging && $a60ed7403450fe58$var$invariant(false);
        dragging = null;
        $a60ed7403450fe58$var$withTimings("onDragEnd", function() {
            return $a60ed7403450fe58$var$execute(getResponders().onDragEnd, result, announce, $a60ed7403450fe58$var$preset.onDragEnd);
        });
    };
    var abort = function abort() {
        if (!dragging) return;
        var result = (0, $h4XE0.default)({}, $a60ed7403450fe58$var$getDragStart(dragging.lastCritical, dragging.mode), {
            combine: null,
            destination: null,
            reason: "CANCEL"
        });
        drop(result);
    };
    return {
        beforeCapture: beforeCapture,
        beforeStart: beforeStart,
        start: start,
        update: update,
        flush: flush,
        drop: drop,
        abort: abort
    };
};
var $a60ed7403450fe58$var$responders = function(getResponders, announce) {
    var publisher = $a60ed7403450fe58$var$getPublisher(getResponders, announce);
    return function(store) {
        return function(next) {
            return function(action) {
                if (action.type === "BEFORE_INITIAL_CAPTURE") {
                    publisher.beforeCapture(action.payload.draggableId, action.payload.movementMode);
                    return;
                }
                if (action.type === "INITIAL_PUBLISH") {
                    var critical = action.payload.critical;
                    publisher.beforeStart(critical, action.payload.movementMode);
                    next(action);
                    publisher.start(critical, action.payload.movementMode);
                    return;
                }
                if (action.type === "DROP_COMPLETE") {
                    var result = action.payload.completed.result;
                    publisher.flush();
                    next(action);
                    publisher.drop(result);
                    return;
                }
                next(action);
                if (action.type === "FLUSH") {
                    publisher.abort();
                    return;
                }
                var state = store.getState();
                if (state.phase === "DRAGGING") publisher.update(state.critical, state.impact);
            };
        };
    };
};
var $a60ed7403450fe58$var$dropAnimationFinish = function(store) {
    return function(next) {
        return function(action) {
            if (action.type !== "DROP_ANIMATION_FINISHED") {
                next(action);
                return;
            }
            var state = store.getState();
            !(state.phase === "DROP_ANIMATING") && $a60ed7403450fe58$var$invariant(false);
            store.dispatch($a60ed7403450fe58$var$completeDrop({
                completed: state.completed
            }));
        };
    };
};
var $a60ed7403450fe58$var$dropAnimationFlushOnScroll = function(store) {
    var unbind = null;
    var frameId = null;
    function clear() {
        if (frameId) {
            cancelAnimationFrame(frameId);
            frameId = null;
        }
        if (unbind) {
            unbind();
            unbind = null;
        }
    }
    return function(next) {
        return function(action) {
            if (action.type === "FLUSH" || action.type === "DROP_COMPLETE" || action.type === "DROP_ANIMATION_FINISHED") clear();
            next(action);
            if (action.type !== "DROP_ANIMATE") return;
            var binding = {
                eventName: "scroll",
                options: {
                    capture: true,
                    passive: false,
                    once: true
                },
                fn: function flushDropAnimation() {
                    var state = store.getState();
                    if (state.phase === "DROP_ANIMATING") store.dispatch($a60ed7403450fe58$var$dropAnimationFinished());
                }
            };
            frameId = requestAnimationFrame(function() {
                frameId = null;
                unbind = $a60ed7403450fe58$var$bindEvents(window, [
                    binding
                ]);
            });
        };
    };
};
var $a60ed7403450fe58$var$dimensionMarshalStopper = function(marshal) {
    return function() {
        return function(next) {
            return function(action) {
                if (action.type === "DROP_COMPLETE" || action.type === "FLUSH" || action.type === "DROP_ANIMATE") marshal.stopPublishing();
                next(action);
            };
        };
    };
};
var $a60ed7403450fe58$var$focus = function(marshal) {
    var isWatching = false;
    return function() {
        return function(next) {
            return function(action) {
                if (action.type === "INITIAL_PUBLISH") {
                    isWatching = true;
                    marshal.tryRecordFocus(action.payload.critical.draggable.id);
                    next(action);
                    marshal.tryRestoreFocusRecorded();
                    return;
                }
                next(action);
                if (!isWatching) return;
                if (action.type === "FLUSH") {
                    isWatching = false;
                    marshal.tryRestoreFocusRecorded();
                    return;
                }
                if (action.type === "DROP_COMPLETE") {
                    isWatching = false;
                    var result = action.payload.completed.result;
                    if (result.combine) marshal.tryShiftRecord(result.draggableId, result.combine.draggableId);
                    marshal.tryRestoreFocusRecorded();
                }
            };
        };
    };
};
var $a60ed7403450fe58$var$shouldStop = function shouldStop(action) {
    return action.type === "DROP_COMPLETE" || action.type === "DROP_ANIMATE" || action.type === "FLUSH";
};
var $a60ed7403450fe58$var$autoScroll = function(autoScroller) {
    return function(store) {
        return function(next) {
            return function(action) {
                if ($a60ed7403450fe58$var$shouldStop(action)) {
                    autoScroller.stop();
                    next(action);
                    return;
                }
                if (action.type === "INITIAL_PUBLISH") {
                    next(action);
                    var state = store.getState();
                    !(state.phase === "DRAGGING") && $a60ed7403450fe58$var$invariant(false);
                    autoScroller.start(state);
                    return;
                }
                next(action);
                autoScroller.scroll(store.getState());
            };
        };
    };
};
var $a60ed7403450fe58$var$pendingDrop = function(store) {
    return function(next) {
        return function(action) {
            next(action);
            if (action.type !== "PUBLISH_WHILE_DRAGGING") return;
            var postActionState = store.getState();
            if (postActionState.phase !== "DROP_PENDING") return;
            if (postActionState.isWaiting) return;
            store.dispatch($a60ed7403450fe58$var$drop({
                reason: postActionState.reason
            }));
        };
    };
};
var $a60ed7403450fe58$var$composeEnhancers = (0, $jkmOZ.compose);
var $a60ed7403450fe58$var$createStore = function(_ref) {
    var dimensionMarshal = _ref.dimensionMarshal, focusMarshal = _ref.focusMarshal, styleMarshal = _ref.styleMarshal, getResponders = _ref.getResponders, announce = _ref.announce, autoScroller = _ref.autoScroller;
    return (0, $jkmOZ.createStore)($a60ed7403450fe58$var$reducer, $a60ed7403450fe58$var$composeEnhancers((0, $jkmOZ.applyMiddleware)($a60ed7403450fe58$var$style(styleMarshal), $a60ed7403450fe58$var$dimensionMarshalStopper(dimensionMarshal), $a60ed7403450fe58$var$lift$1(dimensionMarshal), $a60ed7403450fe58$var$drop$1, $a60ed7403450fe58$var$dropAnimationFinish, $a60ed7403450fe58$var$dropAnimationFlushOnScroll, $a60ed7403450fe58$var$pendingDrop, $a60ed7403450fe58$var$autoScroll(autoScroller), $a60ed7403450fe58$var$scrollListener, $a60ed7403450fe58$var$focus(focusMarshal), $a60ed7403450fe58$var$responders(getResponders, announce))));
};
var $a60ed7403450fe58$var$clean$1 = function clean() {
    return {
        additions: {},
        removals: {},
        modified: {}
    };
};
function $a60ed7403450fe58$var$createPublisher(_ref) {
    var registry = _ref.registry, callbacks = _ref.callbacks;
    var staging = $a60ed7403450fe58$var$clean$1();
    var frameId = null;
    var collect = function collect() {
        if (frameId) return;
        callbacks.collectionStarting();
        frameId = requestAnimationFrame(function() {
            frameId = null;
            $a60ed7403450fe58$var$start();
            var _staging = staging, additions = _staging.additions, removals = _staging.removals, modified = _staging.modified;
            var added = Object.keys(additions).map(function(id) {
                return registry.draggable.getById(id).getDimension($a60ed7403450fe58$var$origin);
            }).sort(function(a, b) {
                return a.descriptor.index - b.descriptor.index;
            });
            var updated = Object.keys(modified).map(function(id) {
                var entry = registry.droppable.getById(id);
                var scroll = entry.callbacks.getScrollWhileDragging();
                return {
                    droppableId: id,
                    scroll: scroll
                };
            });
            var result = {
                additions: added,
                removals: Object.keys(removals),
                modified: updated
            };
            staging = $a60ed7403450fe58$var$clean$1();
            $a60ed7403450fe58$var$finish();
            callbacks.publish(result);
        });
    };
    var add = function add(entry) {
        var id = entry.descriptor.id;
        staging.additions[id] = entry;
        staging.modified[entry.descriptor.droppableId] = true;
        if (staging.removals[id]) delete staging.removals[id];
        collect();
    };
    var remove = function remove(entry) {
        var descriptor = entry.descriptor;
        staging.removals[descriptor.id] = true;
        staging.modified[descriptor.droppableId] = true;
        if (staging.additions[descriptor.id]) delete staging.additions[descriptor.id];
        collect();
    };
    var stop = function stop() {
        if (!frameId) return;
        cancelAnimationFrame(frameId);
        frameId = null;
        staging = $a60ed7403450fe58$var$clean$1();
    };
    return {
        add: add,
        remove: remove,
        stop: stop
    };
}
var $a60ed7403450fe58$var$getMaxScroll = function(_ref) {
    var scrollHeight = _ref.scrollHeight, scrollWidth = _ref.scrollWidth, height = _ref.height, width = _ref.width;
    var maxScroll = $a60ed7403450fe58$var$subtract({
        x: scrollWidth,
        y: scrollHeight
    }, {
        x: width,
        y: height
    });
    var adjustedMaxScroll = {
        x: Math.max(0, maxScroll.x),
        y: Math.max(0, maxScroll.y)
    };
    return adjustedMaxScroll;
};
var $a60ed7403450fe58$var$getDocumentElement = function() {
    var doc = document.documentElement;
    !doc && $a60ed7403450fe58$var$invariant(false);
    return doc;
};
var $a60ed7403450fe58$var$getMaxWindowScroll = function() {
    var doc = $a60ed7403450fe58$var$getDocumentElement();
    var maxScroll = $a60ed7403450fe58$var$getMaxScroll({
        scrollHeight: doc.scrollHeight,
        scrollWidth: doc.scrollWidth,
        width: doc.clientWidth,
        height: doc.clientHeight
    });
    return maxScroll;
};
var $a60ed7403450fe58$var$getViewport = function() {
    var scroll = $a60ed7403450fe58$var$getWindowScroll();
    var maxScroll = $a60ed7403450fe58$var$getMaxWindowScroll();
    var top = scroll.y;
    var left = scroll.x;
    var doc = $a60ed7403450fe58$var$getDocumentElement();
    var width = doc.clientWidth;
    var height = doc.clientHeight;
    var right = left + width;
    var bottom = top + height;
    var frame = (0, $4J1sD.getRect)({
        top: top,
        left: left,
        right: right,
        bottom: bottom
    });
    var viewport = {
        frame: frame,
        scroll: {
            initial: scroll,
            current: scroll,
            max: maxScroll,
            diff: {
                value: $a60ed7403450fe58$var$origin,
                displacement: $a60ed7403450fe58$var$origin
            }
        }
    };
    return viewport;
};
var $a60ed7403450fe58$var$getInitialPublish = function(_ref) {
    var critical = _ref.critical, scrollOptions = _ref.scrollOptions, registry = _ref.registry;
    $a60ed7403450fe58$var$start();
    var viewport = $a60ed7403450fe58$var$getViewport();
    var windowScroll = viewport.scroll.current;
    var home = critical.droppable;
    var droppables = registry.droppable.getAllByType(home.type).map(function(entry) {
        return entry.callbacks.getDimensionAndWatchScroll(windowScroll, scrollOptions);
    });
    var draggables = registry.draggable.getAllByType(critical.draggable.type).map(function(entry) {
        return entry.getDimension(windowScroll);
    });
    var dimensions = {
        draggables: $a60ed7403450fe58$var$toDraggableMap(draggables),
        droppables: $a60ed7403450fe58$var$toDroppableMap(droppables)
    };
    $a60ed7403450fe58$var$finish();
    var result = {
        dimensions: dimensions,
        critical: critical,
        viewport: viewport
    };
    return result;
};
function $a60ed7403450fe58$var$shouldPublishUpdate(registry, dragging, entry) {
    if (entry.descriptor.id === dragging.id) return false;
    if (entry.descriptor.type !== dragging.type) return false;
    var home = registry.droppable.getById(entry.descriptor.droppableId);
    if (home.descriptor.mode !== "virtual") return false;
    return true;
}
var $a60ed7403450fe58$var$createDimensionMarshal = function(registry, callbacks) {
    var collection = null;
    var publisher = $a60ed7403450fe58$var$createPublisher({
        callbacks: {
            publish: callbacks.publishWhileDragging,
            collectionStarting: callbacks.collectionStarting
        },
        registry: registry
    });
    var updateDroppableIsEnabled = function updateDroppableIsEnabled(id, isEnabled) {
        !registry.droppable.exists(id) && $a60ed7403450fe58$var$invariant(false);
        if (!collection) return;
        callbacks.updateDroppableIsEnabled({
            id: id,
            isEnabled: isEnabled
        });
    };
    var updateDroppableIsCombineEnabled = function updateDroppableIsCombineEnabled(id, isCombineEnabled) {
        if (!collection) return;
        !registry.droppable.exists(id) && $a60ed7403450fe58$var$invariant(false);
        callbacks.updateDroppableIsCombineEnabled({
            id: id,
            isCombineEnabled: isCombineEnabled
        });
    };
    var updateDroppableScroll = function updateDroppableScroll(id, newScroll) {
        if (!collection) return;
        !registry.droppable.exists(id) && $a60ed7403450fe58$var$invariant(false);
        callbacks.updateDroppableScroll({
            id: id,
            newScroll: newScroll
        });
    };
    var scrollDroppable = function scrollDroppable(id, change) {
        if (!collection) return;
        registry.droppable.getById(id).callbacks.scroll(change);
    };
    var stopPublishing = function stopPublishing() {
        if (!collection) return;
        publisher.stop();
        var home = collection.critical.droppable;
        registry.droppable.getAllByType(home.type).forEach(function(entry) {
            return entry.callbacks.dragStopped();
        });
        collection.unsubscribe();
        collection = null;
    };
    var subscriber = function subscriber(event) {
        !collection && $a60ed7403450fe58$var$invariant(false);
        var dragging = collection.critical.draggable;
        if (event.type === "ADDITION") {
            if ($a60ed7403450fe58$var$shouldPublishUpdate(registry, dragging, event.value)) publisher.add(event.value);
        }
        if (event.type === "REMOVAL") {
            if ($a60ed7403450fe58$var$shouldPublishUpdate(registry, dragging, event.value)) publisher.remove(event.value);
        }
    };
    var startPublishing = function startPublishing(request) {
        !!collection && $a60ed7403450fe58$var$invariant(false);
        var entry = registry.draggable.getById(request.draggableId);
        var home = registry.droppable.getById(entry.descriptor.droppableId);
        var critical = {
            draggable: entry.descriptor,
            droppable: home.descriptor
        };
        var unsubscribe = registry.subscribe(subscriber);
        collection = {
            critical: critical,
            unsubscribe: unsubscribe
        };
        return $a60ed7403450fe58$var$getInitialPublish({
            critical: critical,
            registry: registry,
            scrollOptions: request.scrollOptions
        });
    };
    var marshal = {
        updateDroppableIsEnabled: updateDroppableIsEnabled,
        updateDroppableIsCombineEnabled: updateDroppableIsCombineEnabled,
        scrollDroppable: scrollDroppable,
        updateDroppableScroll: updateDroppableScroll,
        startPublishing: startPublishing,
        stopPublishing: stopPublishing
    };
    return marshal;
};
var $a60ed7403450fe58$var$canStartDrag = function(state, id) {
    if (state.phase === "IDLE") return true;
    if (state.phase !== "DROP_ANIMATING") return false;
    if (state.completed.result.draggableId === id) return false;
    return state.completed.result.reason === "DROP";
};
var $a60ed7403450fe58$var$scrollWindow = function(change) {
    window.scrollBy(change.x, change.y);
};
var $a60ed7403450fe58$var$getScrollableDroppables = (0, $kQ1m2.default)(function(droppables) {
    return $a60ed7403450fe58$var$toDroppableList(droppables).filter(function(droppable) {
        if (!droppable.isEnabled) return false;
        if (!droppable.frame) return false;
        return true;
    });
});
var $a60ed7403450fe58$var$getScrollableDroppableOver = function getScrollableDroppableOver(target, droppables) {
    var maybe = $a60ed7403450fe58$var$find($a60ed7403450fe58$var$getScrollableDroppables(droppables), function(droppable) {
        !droppable.frame && $a60ed7403450fe58$var$invariant(false);
        return $a60ed7403450fe58$var$isPositionInFrame(droppable.frame.pageMarginBox)(target);
    });
    return maybe;
};
var $a60ed7403450fe58$var$getBestScrollableDroppable = function(_ref) {
    var center = _ref.center, destination = _ref.destination, droppables = _ref.droppables;
    if (destination) {
        var _dimension = droppables[destination];
        if (!_dimension.frame) return null;
        return _dimension;
    }
    var dimension = $a60ed7403450fe58$var$getScrollableDroppableOver(center, droppables);
    return dimension;
};
var $a60ed7403450fe58$var$config = {
    startFromPercentage: 0.25,
    maxScrollAtPercentage: 0.05,
    maxPixelScroll: 28,
    ease: function ease(percentage) {
        return Math.pow(percentage, 2);
    },
    durationDampening: {
        stopDampeningAt: 1200,
        accelerateAt: 360
    }
};
var $a60ed7403450fe58$var$getDistanceThresholds = function(container, axis) {
    var startScrollingFrom = container[axis.size] * $a60ed7403450fe58$var$config.startFromPercentage;
    var maxScrollValueAt = container[axis.size] * $a60ed7403450fe58$var$config.maxScrollAtPercentage;
    var thresholds = {
        startScrollingFrom: startScrollingFrom,
        maxScrollValueAt: maxScrollValueAt
    };
    return thresholds;
};
var $a60ed7403450fe58$var$getPercentage = function(_ref) {
    var startOfRange = _ref.startOfRange, endOfRange = _ref.endOfRange, current = _ref.current;
    var range = endOfRange - startOfRange;
    if (range === 0) return 0;
    var currentInRange = current - startOfRange;
    var percentage = currentInRange / range;
    return percentage;
};
var $a60ed7403450fe58$var$minScroll = 1;
var $a60ed7403450fe58$var$getValueFromDistance = function(distanceToEdge, thresholds) {
    if (distanceToEdge > thresholds.startScrollingFrom) return 0;
    if (distanceToEdge <= thresholds.maxScrollValueAt) return $a60ed7403450fe58$var$config.maxPixelScroll;
    if (distanceToEdge === thresholds.startScrollingFrom) return $a60ed7403450fe58$var$minScroll;
    var percentageFromMaxScrollValueAt = $a60ed7403450fe58$var$getPercentage({
        startOfRange: thresholds.maxScrollValueAt,
        endOfRange: thresholds.startScrollingFrom,
        current: distanceToEdge
    });
    var percentageFromStartScrollingFrom = 1 - percentageFromMaxScrollValueAt;
    var scroll = $a60ed7403450fe58$var$config.maxPixelScroll * $a60ed7403450fe58$var$config.ease(percentageFromStartScrollingFrom);
    return Math.ceil(scroll);
};
var $a60ed7403450fe58$var$accelerateAt = $a60ed7403450fe58$var$config.durationDampening.accelerateAt;
var $a60ed7403450fe58$var$stopAt = $a60ed7403450fe58$var$config.durationDampening.stopDampeningAt;
var $a60ed7403450fe58$var$dampenValueByTime = function(proposedScroll, dragStartTime) {
    var startOfRange = dragStartTime;
    var endOfRange = $a60ed7403450fe58$var$stopAt;
    var now = Date.now();
    var runTime = now - startOfRange;
    if (runTime >= $a60ed7403450fe58$var$stopAt) return proposedScroll;
    if (runTime < $a60ed7403450fe58$var$accelerateAt) return $a60ed7403450fe58$var$minScroll;
    var betweenAccelerateAtAndStopAtPercentage = $a60ed7403450fe58$var$getPercentage({
        startOfRange: $a60ed7403450fe58$var$accelerateAt,
        endOfRange: endOfRange,
        current: runTime
    });
    var scroll = proposedScroll * $a60ed7403450fe58$var$config.ease(betweenAccelerateAtAndStopAtPercentage);
    return Math.ceil(scroll);
};
var $a60ed7403450fe58$var$getValue = function(_ref) {
    var distanceToEdge = _ref.distanceToEdge, thresholds = _ref.thresholds, dragStartTime = _ref.dragStartTime, shouldUseTimeDampening = _ref.shouldUseTimeDampening;
    var scroll = $a60ed7403450fe58$var$getValueFromDistance(distanceToEdge, thresholds);
    if (scroll === 0) return 0;
    if (!shouldUseTimeDampening) return scroll;
    return Math.max($a60ed7403450fe58$var$dampenValueByTime(scroll, dragStartTime), $a60ed7403450fe58$var$minScroll);
};
var $a60ed7403450fe58$var$getScrollOnAxis = function(_ref) {
    var container = _ref.container, distanceToEdges = _ref.distanceToEdges, dragStartTime = _ref.dragStartTime, axis = _ref.axis, shouldUseTimeDampening = _ref.shouldUseTimeDampening;
    var thresholds = $a60ed7403450fe58$var$getDistanceThresholds(container, axis);
    var isCloserToEnd = distanceToEdges[axis.end] < distanceToEdges[axis.start];
    if (isCloserToEnd) return $a60ed7403450fe58$var$getValue({
        distanceToEdge: distanceToEdges[axis.end],
        thresholds: thresholds,
        dragStartTime: dragStartTime,
        shouldUseTimeDampening: shouldUseTimeDampening
    });
    return -1 * $a60ed7403450fe58$var$getValue({
        distanceToEdge: distanceToEdges[axis.start],
        thresholds: thresholds,
        dragStartTime: dragStartTime,
        shouldUseTimeDampening: shouldUseTimeDampening
    });
};
var $a60ed7403450fe58$var$adjustForSizeLimits = function(_ref) {
    var container = _ref.container, subject = _ref.subject, proposedScroll = _ref.proposedScroll;
    var isTooBigVertically = subject.height > container.height;
    var isTooBigHorizontally = subject.width > container.width;
    if (!isTooBigHorizontally && !isTooBigVertically) return proposedScroll;
    if (isTooBigHorizontally && isTooBigVertically) return null;
    return {
        x: isTooBigHorizontally ? 0 : proposedScroll.x,
        y: isTooBigVertically ? 0 : proposedScroll.y
    };
};
var $a60ed7403450fe58$var$clean$2 = $a60ed7403450fe58$var$apply(function(value) {
    return value === 0 ? 0 : value;
});
var $a60ed7403450fe58$var$getScroll = function(_ref) {
    var dragStartTime = _ref.dragStartTime, container = _ref.container, subject = _ref.subject, center = _ref.center, shouldUseTimeDampening = _ref.shouldUseTimeDampening;
    var distanceToEdges = {
        top: center.y - container.top,
        right: container.right - center.x,
        bottom: container.bottom - center.y,
        left: center.x - container.left
    };
    var y = $a60ed7403450fe58$var$getScrollOnAxis({
        container: container,
        distanceToEdges: distanceToEdges,
        dragStartTime: dragStartTime,
        axis: $a60ed7403450fe58$var$vertical,
        shouldUseTimeDampening: shouldUseTimeDampening
    });
    var x = $a60ed7403450fe58$var$getScrollOnAxis({
        container: container,
        distanceToEdges: distanceToEdges,
        dragStartTime: dragStartTime,
        axis: $a60ed7403450fe58$var$horizontal,
        shouldUseTimeDampening: shouldUseTimeDampening
    });
    var required = $a60ed7403450fe58$var$clean$2({
        x: x,
        y: y
    });
    if ($a60ed7403450fe58$var$isEqual(required, $a60ed7403450fe58$var$origin)) return null;
    var limited = $a60ed7403450fe58$var$adjustForSizeLimits({
        container: container,
        subject: subject,
        proposedScroll: required
    });
    if (!limited) return null;
    return $a60ed7403450fe58$var$isEqual(limited, $a60ed7403450fe58$var$origin) ? null : limited;
};
var $a60ed7403450fe58$var$smallestSigned = $a60ed7403450fe58$var$apply(function(value) {
    if (value === 0) return 0;
    return value > 0 ? 1 : -1;
});
var $a60ed7403450fe58$var$getOverlap = function() {
    var getRemainder = function getRemainder(target, max) {
        if (target < 0) return target;
        if (target > max) return target - max;
        return 0;
    };
    return function(_ref) {
        var current = _ref.current, max = _ref.max, change = _ref.change;
        var targetScroll = $a60ed7403450fe58$var$add(current, change);
        var overlap = {
            x: getRemainder(targetScroll.x, max.x),
            y: getRemainder(targetScroll.y, max.y)
        };
        if ($a60ed7403450fe58$var$isEqual(overlap, $a60ed7403450fe58$var$origin)) return null;
        return overlap;
    };
}();
var $a60ed7403450fe58$var$canPartiallyScroll = function canPartiallyScroll(_ref2) {
    var rawMax = _ref2.max, current = _ref2.current, change = _ref2.change;
    var max = {
        x: Math.max(current.x, rawMax.x),
        y: Math.max(current.y, rawMax.y)
    };
    var smallestChange = $a60ed7403450fe58$var$smallestSigned(change);
    var overlap = $a60ed7403450fe58$var$getOverlap({
        max: max,
        current: current,
        change: smallestChange
    });
    if (!overlap) return true;
    if (smallestChange.x !== 0 && overlap.x === 0) return true;
    if (smallestChange.y !== 0 && overlap.y === 0) return true;
    return false;
};
var $a60ed7403450fe58$var$canScrollWindow = function canScrollWindow(viewport, change) {
    return $a60ed7403450fe58$var$canPartiallyScroll({
        current: viewport.scroll.current,
        max: viewport.scroll.max,
        change: change
    });
};
var $a60ed7403450fe58$var$getWindowOverlap = function getWindowOverlap(viewport, change) {
    if (!$a60ed7403450fe58$var$canScrollWindow(viewport, change)) return null;
    var max = viewport.scroll.max;
    var current = viewport.scroll.current;
    return $a60ed7403450fe58$var$getOverlap({
        current: current,
        max: max,
        change: change
    });
};
var $a60ed7403450fe58$var$canScrollDroppable = function canScrollDroppable(droppable, change) {
    var frame = droppable.frame;
    if (!frame) return false;
    return $a60ed7403450fe58$var$canPartiallyScroll({
        current: frame.scroll.current,
        max: frame.scroll.max,
        change: change
    });
};
var $a60ed7403450fe58$var$getDroppableOverlap = function getDroppableOverlap(droppable, change) {
    var frame = droppable.frame;
    if (!frame) return null;
    if (!$a60ed7403450fe58$var$canScrollDroppable(droppable, change)) return null;
    return $a60ed7403450fe58$var$getOverlap({
        current: frame.scroll.current,
        max: frame.scroll.max,
        change: change
    });
};
var $a60ed7403450fe58$var$getWindowScrollChange = function(_ref) {
    var viewport = _ref.viewport, subject = _ref.subject, center = _ref.center, dragStartTime = _ref.dragStartTime, shouldUseTimeDampening = _ref.shouldUseTimeDampening;
    var scroll = $a60ed7403450fe58$var$getScroll({
        dragStartTime: dragStartTime,
        container: viewport.frame,
        subject: subject,
        center: center,
        shouldUseTimeDampening: shouldUseTimeDampening
    });
    return scroll && $a60ed7403450fe58$var$canScrollWindow(viewport, scroll) ? scroll : null;
};
var $a60ed7403450fe58$var$getDroppableScrollChange = function(_ref) {
    var droppable = _ref.droppable, subject = _ref.subject, center = _ref.center, dragStartTime = _ref.dragStartTime, shouldUseTimeDampening = _ref.shouldUseTimeDampening;
    var frame = droppable.frame;
    if (!frame) return null;
    var scroll = $a60ed7403450fe58$var$getScroll({
        dragStartTime: dragStartTime,
        container: frame.pageMarginBox,
        subject: subject,
        center: center,
        shouldUseTimeDampening: shouldUseTimeDampening
    });
    return scroll && $a60ed7403450fe58$var$canScrollDroppable(droppable, scroll) ? scroll : null;
};
var $a60ed7403450fe58$var$scroll$1 = function(_ref) {
    var state = _ref.state, dragStartTime = _ref.dragStartTime, shouldUseTimeDampening = _ref.shouldUseTimeDampening, scrollWindow = _ref.scrollWindow, scrollDroppable = _ref.scrollDroppable;
    var center = state.current.page.borderBoxCenter;
    var draggable = state.dimensions.draggables[state.critical.draggable.id];
    var subject = draggable.page.marginBox;
    if (state.isWindowScrollAllowed) {
        var viewport = state.viewport;
        var _change = $a60ed7403450fe58$var$getWindowScrollChange({
            dragStartTime: dragStartTime,
            viewport: viewport,
            subject: subject,
            center: center,
            shouldUseTimeDampening: shouldUseTimeDampening
        });
        if (_change) {
            scrollWindow(_change);
            return;
        }
    }
    var droppable = $a60ed7403450fe58$var$getBestScrollableDroppable({
        center: center,
        destination: $a60ed7403450fe58$var$whatIsDraggedOver(state.impact),
        droppables: state.dimensions.droppables
    });
    if (!droppable) return;
    var change = $a60ed7403450fe58$var$getDroppableScrollChange({
        dragStartTime: dragStartTime,
        droppable: droppable,
        subject: subject,
        center: center,
        shouldUseTimeDampening: shouldUseTimeDampening
    });
    if (change) scrollDroppable(droppable.descriptor.id, change);
};
var $a60ed7403450fe58$var$createFluidScroller = function(_ref) {
    var scrollWindow = _ref.scrollWindow, scrollDroppable = _ref.scrollDroppable;
    var scheduleWindowScroll = (0, $lqlwE.default)(scrollWindow);
    var scheduleDroppableScroll = (0, $lqlwE.default)(scrollDroppable);
    var dragging = null;
    var tryScroll = function tryScroll(state) {
        !dragging && $a60ed7403450fe58$var$invariant(false);
        var _dragging = dragging, shouldUseTimeDampening = _dragging.shouldUseTimeDampening, dragStartTime = _dragging.dragStartTime;
        $a60ed7403450fe58$var$scroll$1({
            state: state,
            scrollWindow: scheduleWindowScroll,
            scrollDroppable: scheduleDroppableScroll,
            dragStartTime: dragStartTime,
            shouldUseTimeDampening: shouldUseTimeDampening
        });
    };
    var start$1 = function start$1(state) {
        $a60ed7403450fe58$var$start();
        !!dragging && $a60ed7403450fe58$var$invariant(false);
        var dragStartTime = Date.now();
        var wasScrollNeeded = false;
        var fakeScrollCallback = function fakeScrollCallback() {
            wasScrollNeeded = true;
        };
        $a60ed7403450fe58$var$scroll$1({
            state: state,
            dragStartTime: 0,
            shouldUseTimeDampening: false,
            scrollWindow: fakeScrollCallback,
            scrollDroppable: fakeScrollCallback
        });
        dragging = {
            dragStartTime: dragStartTime,
            shouldUseTimeDampening: wasScrollNeeded
        };
        $a60ed7403450fe58$var$finish();
        if (wasScrollNeeded) tryScroll(state);
    };
    var stop = function stop() {
        if (!dragging) return;
        scheduleWindowScroll.cancel();
        scheduleDroppableScroll.cancel();
        dragging = null;
    };
    return {
        start: start$1,
        stop: stop,
        scroll: tryScroll
    };
};
var $a60ed7403450fe58$var$createJumpScroller = function(_ref) {
    var move = _ref.move, scrollDroppable = _ref.scrollDroppable, scrollWindow = _ref.scrollWindow;
    var moveByOffset = function moveByOffset(state, offset) {
        var client = $a60ed7403450fe58$var$add(state.current.client.selection, offset);
        move({
            client: client
        });
    };
    var scrollDroppableAsMuchAsItCan = function scrollDroppableAsMuchAsItCan(droppable, change) {
        if (!$a60ed7403450fe58$var$canScrollDroppable(droppable, change)) return change;
        var overlap = $a60ed7403450fe58$var$getDroppableOverlap(droppable, change);
        if (!overlap) {
            scrollDroppable(droppable.descriptor.id, change);
            return null;
        }
        var whatTheDroppableCanScroll = $a60ed7403450fe58$var$subtract(change, overlap);
        scrollDroppable(droppable.descriptor.id, whatTheDroppableCanScroll);
        var remainder = $a60ed7403450fe58$var$subtract(change, whatTheDroppableCanScroll);
        return remainder;
    };
    var scrollWindowAsMuchAsItCan = function scrollWindowAsMuchAsItCan(isWindowScrollAllowed, viewport, change) {
        if (!isWindowScrollAllowed) return change;
        if (!$a60ed7403450fe58$var$canScrollWindow(viewport, change)) return change;
        var overlap = $a60ed7403450fe58$var$getWindowOverlap(viewport, change);
        if (!overlap) {
            scrollWindow(change);
            return null;
        }
        var whatTheWindowCanScroll = $a60ed7403450fe58$var$subtract(change, overlap);
        scrollWindow(whatTheWindowCanScroll);
        var remainder = $a60ed7403450fe58$var$subtract(change, whatTheWindowCanScroll);
        return remainder;
    };
    var jumpScroller = function jumpScroller(state) {
        var request = state.scrollJumpRequest;
        if (!request) return;
        var destination = $a60ed7403450fe58$var$whatIsDraggedOver(state.impact);
        !destination && $a60ed7403450fe58$var$invariant(false);
        var droppableRemainder = scrollDroppableAsMuchAsItCan(state.dimensions.droppables[destination], request);
        if (!droppableRemainder) return;
        var viewport = state.viewport;
        var windowRemainder = scrollWindowAsMuchAsItCan(state.isWindowScrollAllowed, viewport, droppableRemainder);
        if (!windowRemainder) return;
        moveByOffset(state, windowRemainder);
    };
    return jumpScroller;
};
var $a60ed7403450fe58$var$createAutoScroller = function(_ref) {
    var scrollDroppable = _ref.scrollDroppable, scrollWindow = _ref.scrollWindow, move = _ref.move;
    var fluidScroller = $a60ed7403450fe58$var$createFluidScroller({
        scrollWindow: scrollWindow,
        scrollDroppable: scrollDroppable
    });
    var jumpScroll = $a60ed7403450fe58$var$createJumpScroller({
        move: move,
        scrollWindow: scrollWindow,
        scrollDroppable: scrollDroppable
    });
    var scroll = function scroll(state) {
        if (state.phase !== "DRAGGING") return;
        if (state.movementMode === "FLUID") {
            fluidScroller.scroll(state);
            return;
        }
        if (!state.scrollJumpRequest) return;
        jumpScroll(state);
    };
    var scroller = {
        scroll: scroll,
        start: fluidScroller.start,
        stop: fluidScroller.stop
    };
    return scroller;
};
var $a60ed7403450fe58$var$prefix$1 = "data-rbd";
var $a60ed7403450fe58$var$dragHandle = function() {
    var base = $a60ed7403450fe58$var$prefix$1 + "-drag-handle";
    return {
        base: base,
        draggableId: base + "-draggable-id",
        contextId: base + "-context-id"
    };
}();
var $a60ed7403450fe58$var$draggable = function() {
    var base = $a60ed7403450fe58$var$prefix$1 + "-draggable";
    return {
        base: base,
        contextId: base + "-context-id",
        id: base + "-id"
    };
}();
var $a60ed7403450fe58$var$droppable = function() {
    var base = $a60ed7403450fe58$var$prefix$1 + "-droppable";
    return {
        base: base,
        contextId: base + "-context-id",
        id: base + "-id"
    };
}();
var $a60ed7403450fe58$var$scrollContainer = {
    contextId: $a60ed7403450fe58$var$prefix$1 + "-scroll-container-context-id"
};
var $a60ed7403450fe58$var$makeGetSelector = function makeGetSelector(context) {
    return function(attribute) {
        return "[" + attribute + '="' + context + '"]';
    };
};
var $a60ed7403450fe58$var$getStyles = function getStyles(rules, property) {
    return rules.map(function(rule) {
        var value = rule.styles[property];
        if (!value) return "";
        return rule.selector + " { " + value + " }";
    }).join(" ");
};
var $a60ed7403450fe58$var$noPointerEvents = "pointer-events: none;";
var $a60ed7403450fe58$var$getStyles$1 = function(contextId) {
    var getSelector = $a60ed7403450fe58$var$makeGetSelector(contextId);
    var dragHandle$1 = function() {
        var grabCursor = "\n      cursor: -webkit-grab;\n      cursor: grab;\n    ";
        return {
            selector: getSelector($a60ed7403450fe58$var$dragHandle.contextId),
            styles: {
                always: "\n          -webkit-touch-callout: none;\n          -webkit-tap-highlight-color: rgba(0,0,0,0);\n          touch-action: manipulation;\n        ",
                resting: grabCursor,
                dragging: $a60ed7403450fe58$var$noPointerEvents,
                dropAnimating: grabCursor
            }
        };
    }();
    var draggable$1 = function() {
        var transition = "\n      transition: " + $a60ed7403450fe58$var$transitions.outOfTheWay + ";\n    ";
        return {
            selector: getSelector($a60ed7403450fe58$var$draggable.contextId),
            styles: {
                dragging: transition,
                dropAnimating: transition,
                userCancel: transition
            }
        };
    }();
    var droppable$1 = {
        selector: getSelector($a60ed7403450fe58$var$droppable.contextId),
        styles: {
            always: "overflow-anchor: none;"
        }
    };
    var body = {
        selector: "body",
        styles: {
            dragging: "\n        cursor: grabbing;\n        cursor: -webkit-grabbing;\n        user-select: none;\n        -webkit-user-select: none;\n        -moz-user-select: none;\n        -ms-user-select: none;\n        overflow-anchor: none;\n      "
        }
    };
    var rules = [
        draggable$1,
        dragHandle$1,
        droppable$1,
        body
    ];
    return {
        always: $a60ed7403450fe58$var$getStyles(rules, "always"),
        resting: $a60ed7403450fe58$var$getStyles(rules, "resting"),
        dragging: $a60ed7403450fe58$var$getStyles(rules, "dragging"),
        dropAnimating: $a60ed7403450fe58$var$getStyles(rules, "dropAnimating"),
        userCancel: $a60ed7403450fe58$var$getStyles(rules, "userCancel")
    };
};
var $a60ed7403450fe58$var$useIsomorphicLayoutEffect = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined" ? (0, $eeH7J.useLayoutEffect) : (0, $eeH7J.useEffect);
var $a60ed7403450fe58$var$getHead = function getHead() {
    var head = document.querySelector("head");
    !head && $a60ed7403450fe58$var$invariant(false);
    return head;
};
var $a60ed7403450fe58$var$createStyleEl = function createStyleEl(nonce) {
    var el = document.createElement("style");
    if (nonce) el.setAttribute("nonce", nonce);
    el.type = "text/css";
    return el;
};
function $a60ed7403450fe58$var$useStyleMarshal(contextId, nonce) {
    var styles = (0, $3PiUj.useMemo)(function() {
        return $a60ed7403450fe58$var$getStyles$1(contextId);
    }, [
        contextId
    ]);
    var alwaysRef = (0, $eeH7J.useRef)(null);
    var dynamicRef = (0, $eeH7J.useRef)(null);
    var setDynamicStyle = (0, $3PiUj.useCallback)((0, $kQ1m2.default)(function(proposed) {
        var el = dynamicRef.current;
        !el && $a60ed7403450fe58$var$invariant(false);
        el.textContent = proposed;
    }), []);
    var setAlwaysStyle = (0, $3PiUj.useCallback)(function(proposed) {
        var el = alwaysRef.current;
        !el && $a60ed7403450fe58$var$invariant(false);
        el.textContent = proposed;
    }, []);
    $a60ed7403450fe58$var$useIsomorphicLayoutEffect(function() {
        !(!alwaysRef.current && !dynamicRef.current) && $a60ed7403450fe58$var$invariant(false);
        var always = $a60ed7403450fe58$var$createStyleEl(nonce);
        var dynamic = $a60ed7403450fe58$var$createStyleEl(nonce);
        alwaysRef.current = always;
        dynamicRef.current = dynamic;
        always.setAttribute($a60ed7403450fe58$var$prefix$1 + "-always", contextId);
        dynamic.setAttribute($a60ed7403450fe58$var$prefix$1 + "-dynamic", contextId);
        $a60ed7403450fe58$var$getHead().appendChild(always);
        $a60ed7403450fe58$var$getHead().appendChild(dynamic);
        setAlwaysStyle(styles.always);
        setDynamicStyle(styles.resting);
        return function() {
            var remove = function remove(ref) {
                var current = ref.current;
                !current && $a60ed7403450fe58$var$invariant(false);
                $a60ed7403450fe58$var$getHead().removeChild(current);
                ref.current = null;
            };
            remove(alwaysRef);
            remove(dynamicRef);
        };
    }, [
        nonce,
        setAlwaysStyle,
        setDynamicStyle,
        styles.always,
        styles.resting,
        contextId
    ]);
    var dragging = (0, $3PiUj.useCallback)(function() {
        return setDynamicStyle(styles.dragging);
    }, [
        setDynamicStyle,
        styles.dragging
    ]);
    var dropping = (0, $3PiUj.useCallback)(function(reason) {
        if (reason === "DROP") {
            setDynamicStyle(styles.dropAnimating);
            return;
        }
        setDynamicStyle(styles.userCancel);
    }, [
        setDynamicStyle,
        styles.dropAnimating,
        styles.userCancel
    ]);
    var resting = (0, $3PiUj.useCallback)(function() {
        if (!dynamicRef.current) return;
        setDynamicStyle(styles.resting);
    }, [
        setDynamicStyle,
        styles.resting
    ]);
    var marshal = (0, $3PiUj.useMemo)(function() {
        return {
            dragging: dragging,
            dropping: dropping,
            resting: resting
        };
    }, [
        dragging,
        dropping,
        resting
    ]);
    return marshal;
}
var $a60ed7403450fe58$var$getWindowFromEl = function(el) {
    return el && el.ownerDocument ? el.ownerDocument.defaultView : window;
};
function $a60ed7403450fe58$var$isHtmlElement(el) {
    return el instanceof $a60ed7403450fe58$var$getWindowFromEl(el).HTMLElement;
}
function $a60ed7403450fe58$var$findDragHandle(contextId, draggableId) {
    var selector = "[" + $a60ed7403450fe58$var$dragHandle.contextId + '="' + contextId + '"]';
    var possible = $a60ed7403450fe58$var$toArray(document.querySelectorAll(selector));
    if (!possible.length) return null;
    var handle = $a60ed7403450fe58$var$find(possible, function(el) {
        return el.getAttribute($a60ed7403450fe58$var$dragHandle.draggableId) === draggableId;
    });
    if (!handle) return null;
    if (!$a60ed7403450fe58$var$isHtmlElement(handle)) return null;
    return handle;
}
function $a60ed7403450fe58$var$useFocusMarshal(contextId) {
    var entriesRef = (0, $eeH7J.useRef)({});
    var recordRef = (0, $eeH7J.useRef)(null);
    var restoreFocusFrameRef = (0, $eeH7J.useRef)(null);
    var isMountedRef = (0, $eeH7J.useRef)(false);
    var register = (0, $3PiUj.useCallback)(function register(id, focus) {
        var entry = {
            id: id,
            focus: focus
        };
        entriesRef.current[id] = entry;
        return function unregister() {
            var entries = entriesRef.current;
            var current = entries[id];
            if (current !== entry) delete entries[id];
        };
    }, []);
    var tryGiveFocus = (0, $3PiUj.useCallback)(function tryGiveFocus(tryGiveFocusTo) {
        var handle = $a60ed7403450fe58$var$findDragHandle(contextId, tryGiveFocusTo);
        if (handle && handle !== document.activeElement) handle.focus();
    }, [
        contextId
    ]);
    var tryShiftRecord = (0, $3PiUj.useCallback)(function tryShiftRecord(previous, redirectTo) {
        if (recordRef.current === previous) recordRef.current = redirectTo;
    }, []);
    var tryRestoreFocusRecorded = (0, $3PiUj.useCallback)(function tryRestoreFocusRecorded() {
        if (restoreFocusFrameRef.current) return;
        if (!isMountedRef.current) return;
        restoreFocusFrameRef.current = requestAnimationFrame(function() {
            restoreFocusFrameRef.current = null;
            var record = recordRef.current;
            if (record) tryGiveFocus(record);
        });
    }, [
        tryGiveFocus
    ]);
    var tryRecordFocus = (0, $3PiUj.useCallback)(function tryRecordFocus(id) {
        recordRef.current = null;
        var focused = document.activeElement;
        if (!focused) return;
        if (focused.getAttribute($a60ed7403450fe58$var$dragHandle.draggableId) !== id) return;
        recordRef.current = id;
    }, []);
    $a60ed7403450fe58$var$useIsomorphicLayoutEffect(function() {
        isMountedRef.current = true;
        return function clearFrameOnUnmount() {
            isMountedRef.current = false;
            var frameId = restoreFocusFrameRef.current;
            if (frameId) cancelAnimationFrame(frameId);
        };
    }, []);
    var marshal = (0, $3PiUj.useMemo)(function() {
        return {
            register: register,
            tryRecordFocus: tryRecordFocus,
            tryRestoreFocusRecorded: tryRestoreFocusRecorded,
            tryShiftRecord: tryShiftRecord
        };
    }, [
        register,
        tryRecordFocus,
        tryRestoreFocusRecorded,
        tryShiftRecord
    ]);
    return marshal;
}
function $a60ed7403450fe58$var$createRegistry() {
    var entries = {
        draggables: {},
        droppables: {}
    };
    var subscribers = [];
    function subscribe(cb) {
        subscribers.push(cb);
        return function unsubscribe() {
            var index = subscribers.indexOf(cb);
            if (index === -1) return;
            subscribers.splice(index, 1);
        };
    }
    function notify(event) {
        if (subscribers.length) subscribers.forEach(function(cb) {
            return cb(event);
        });
    }
    function findDraggableById(id) {
        return entries.draggables[id] || null;
    }
    function getDraggableById(id) {
        var entry = findDraggableById(id);
        !entry && $a60ed7403450fe58$var$invariant(false);
        return entry;
    }
    var draggableAPI = {
        register: function register(entry) {
            entries.draggables[entry.descriptor.id] = entry;
            notify({
                type: "ADDITION",
                value: entry
            });
        },
        update: function update(entry, last) {
            var current = entries.draggables[last.descriptor.id];
            if (!current) return;
            if (current.uniqueId !== entry.uniqueId) return;
            delete entries.draggables[last.descriptor.id];
            entries.draggables[entry.descriptor.id] = entry;
        },
        unregister: function unregister(entry) {
            var draggableId = entry.descriptor.id;
            var current = findDraggableById(draggableId);
            if (!current) return;
            if (entry.uniqueId !== current.uniqueId) return;
            delete entries.draggables[draggableId];
            notify({
                type: "REMOVAL",
                value: entry
            });
        },
        getById: getDraggableById,
        findById: findDraggableById,
        exists: function exists(id) {
            return Boolean(findDraggableById(id));
        },
        getAllByType: function getAllByType(type) {
            return $a60ed7403450fe58$var$values(entries.draggables).filter(function(entry) {
                return entry.descriptor.type === type;
            });
        }
    };
    function findDroppableById(id) {
        return entries.droppables[id] || null;
    }
    function getDroppableById(id) {
        var entry = findDroppableById(id);
        !entry && $a60ed7403450fe58$var$invariant(false);
        return entry;
    }
    var droppableAPI = {
        register: function register(entry) {
            entries.droppables[entry.descriptor.id] = entry;
        },
        unregister: function unregister(entry) {
            var current = findDroppableById(entry.descriptor.id);
            if (!current) return;
            if (entry.uniqueId !== current.uniqueId) return;
            delete entries.droppables[entry.descriptor.id];
        },
        getById: getDroppableById,
        findById: findDroppableById,
        exists: function exists(id) {
            return Boolean(findDroppableById(id));
        },
        getAllByType: function getAllByType(type) {
            return $a60ed7403450fe58$var$values(entries.droppables).filter(function(entry) {
                return entry.descriptor.type === type;
            });
        }
    };
    function clean() {
        entries.draggables = {};
        entries.droppables = {};
        subscribers.length = 0;
    }
    return {
        draggable: draggableAPI,
        droppable: droppableAPI,
        subscribe: subscribe,
        clean: clean
    };
}
function $a60ed7403450fe58$var$useRegistry() {
    var registry = (0, $3PiUj.useMemo)($a60ed7403450fe58$var$createRegistry, []);
    (0, $eeH7J.useEffect)(function() {
        return function unmount() {
            requestAnimationFrame(registry.clean);
        };
    }, [
        registry
    ]);
    return registry;
}
var $a60ed7403450fe58$var$StoreContext = (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createContext(null);
var $a60ed7403450fe58$var$getBodyElement = function() {
    var body = document.body;
    !body && $a60ed7403450fe58$var$invariant(false);
    return body;
};
var $a60ed7403450fe58$var$visuallyHidden = {
    position: "absolute",
    width: "1px",
    height: "1px",
    margin: "-1px",
    border: "0",
    padding: "0",
    overflow: "hidden",
    clip: "rect(0 0 0 0)",
    "clip-path": "inset(100%)"
};
var $a60ed7403450fe58$var$getId = function getId(contextId) {
    return "rbd-announcement-" + contextId;
};
function $a60ed7403450fe58$var$useAnnouncer(contextId) {
    var id = (0, $3PiUj.useMemo)(function() {
        return $a60ed7403450fe58$var$getId(contextId);
    }, [
        contextId
    ]);
    var ref = (0, $eeH7J.useRef)(null);
    (0, $eeH7J.useEffect)(function setup() {
        var el = document.createElement("div");
        ref.current = el;
        el.id = id;
        el.setAttribute("aria-live", "assertive");
        el.setAttribute("aria-atomic", "true");
        (0, $h4XE0.default)(el.style, $a60ed7403450fe58$var$visuallyHidden);
        $a60ed7403450fe58$var$getBodyElement().appendChild(el);
        return function cleanup() {
            setTimeout(function remove() {
                var body = $a60ed7403450fe58$var$getBodyElement();
                if (body.contains(el)) body.removeChild(el);
                if (el === ref.current) ref.current = null;
            });
        };
    }, [
        id
    ]);
    var announce = (0, $3PiUj.useCallback)(function(message) {
        var el = ref.current;
        if (el) {
            el.textContent = message;
            return;
        }
    }, []);
    return announce;
}
var $a60ed7403450fe58$var$count = 0;
var $a60ed7403450fe58$var$defaults = {
    separator: "::"
};
function $a60ed7403450fe58$var$reset() {
    $a60ed7403450fe58$var$count = 0;
}
function $a60ed7403450fe58$var$useUniqueId(prefix, options) {
    if (options === void 0) options = $a60ed7403450fe58$var$defaults;
    return (0, $3PiUj.useMemo)(function() {
        return "" + prefix + options.separator + $a60ed7403450fe58$var$count++;
    }, [
        options.separator,
        prefix
    ]);
}
function $a60ed7403450fe58$var$getElementId(_ref) {
    var contextId = _ref.contextId, uniqueId = _ref.uniqueId;
    return "rbd-hidden-text-" + contextId + "-" + uniqueId;
}
function $a60ed7403450fe58$var$useHiddenTextElement(_ref2) {
    var contextId = _ref2.contextId, text = _ref2.text;
    var uniqueId = $a60ed7403450fe58$var$useUniqueId("hidden-text", {
        separator: "-"
    });
    var id = (0, $3PiUj.useMemo)(function() {
        return $a60ed7403450fe58$var$getElementId({
            contextId: contextId,
            uniqueId: uniqueId
        });
    }, [
        uniqueId,
        contextId
    ]);
    (0, $eeH7J.useEffect)(function mount() {
        var el = document.createElement("div");
        el.id = id;
        el.textContent = text;
        el.style.display = "none";
        $a60ed7403450fe58$var$getBodyElement().appendChild(el);
        return function unmount() {
            var body = $a60ed7403450fe58$var$getBodyElement();
            if (body.contains(el)) body.removeChild(el);
        };
    }, [
        id,
        text
    ]);
    return id;
}
var $a60ed7403450fe58$var$AppContext = (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createContext(null);
var $a60ed7403450fe58$var$peerDependencies = {
    react: "^16.8.5 || ^17.0.0 || ^18.0.0",
    "react-dom": "^16.8.5 || ^17.0.0 || ^18.0.0"
};
var $a60ed7403450fe58$var$semver = /(\d+)\.(\d+)\.(\d+)/;
var $a60ed7403450fe58$var$getVersion = function getVersion(value) {
    var result = $a60ed7403450fe58$var$semver.exec(value);
    !(result != null) && $a60ed7403450fe58$var$invariant(false);
    var major = Number(result[1]);
    var minor = Number(result[2]);
    var patch = Number(result[3]);
    return {
        major: major,
        minor: minor,
        patch: patch,
        raw: value
    };
};
var $a60ed7403450fe58$var$isSatisfied = function isSatisfied(expected, actual) {
    if (actual.major > expected.major) return true;
    if (actual.major < expected.major) return false;
    if (actual.minor > expected.minor) return true;
    if (actual.minor < expected.minor) return false;
    return actual.patch >= expected.patch;
};
var $a60ed7403450fe58$var$checkReactVersion = function(peerDepValue, actualValue) {
    var peerDep = $a60ed7403450fe58$var$getVersion(peerDepValue);
    var actual = $a60ed7403450fe58$var$getVersion(actualValue);
    if ($a60ed7403450fe58$var$isSatisfied(peerDep, actual)) return;
};
var $a60ed7403450fe58$var$suffix = "\n  We expect a html5 doctype: <!doctype html>\n  This is to ensure consistent browser layout and measurement\n\n  More information: https://github.com/atlassian/react-beautiful-dnd/blob/master/docs/guides/doctype.md\n";
var $a60ed7403450fe58$var$checkDoctype = function(doc) {
    var doctype = doc.doctype;
    if (!doctype) return;
    doctype.name.toLowerCase();
    doctype.publicId;
};
function $a60ed7403450fe58$var$useDev(useHook) {}
function $a60ed7403450fe58$var$useDevSetupWarning(fn, inputs) {
    $a60ed7403450fe58$var$useDev(function() {
        (0, $eeH7J.useEffect)(function() {
            try {
                fn();
            } catch (e) {
                $a60ed7403450fe58$var$error("\n          A setup problem was encountered.\n\n          > " + e.message + "\n        ");
            }
        }, inputs);
    });
}
function $a60ed7403450fe58$var$useStartupValidation() {
    $a60ed7403450fe58$var$useDevSetupWarning(function() {
        $a60ed7403450fe58$var$checkReactVersion($a60ed7403450fe58$var$peerDependencies.react, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).version);
        $a60ed7403450fe58$var$checkDoctype(document);
    }, []);
}
function $a60ed7403450fe58$var$usePrevious(current) {
    var ref = (0, $eeH7J.useRef)(current);
    (0, $eeH7J.useEffect)(function() {
        ref.current = current;
    });
    return ref;
}
function $a60ed7403450fe58$var$create() {
    var lock = null;
    function isClaimed() {
        return Boolean(lock);
    }
    function isActive(value) {
        return value === lock;
    }
    function claim(abandon) {
        !!lock && $a60ed7403450fe58$var$invariant(false);
        var newLock = {
            abandon: abandon
        };
        lock = newLock;
        return newLock;
    }
    function release() {
        !lock && $a60ed7403450fe58$var$invariant(false);
        lock = null;
    }
    function tryAbandon() {
        if (lock) {
            lock.abandon();
            release();
        }
    }
    return {
        isClaimed: isClaimed,
        isActive: isActive,
        claim: claim,
        release: release,
        tryAbandon: tryAbandon
    };
}
var $a60ed7403450fe58$var$tab = 9;
var $a60ed7403450fe58$var$enter = 13;
var $a60ed7403450fe58$var$escape = 27;
var $a60ed7403450fe58$var$space = 32;
var $a60ed7403450fe58$var$pageUp = 33;
var $a60ed7403450fe58$var$pageDown = 34;
var $a60ed7403450fe58$var$end = 35;
var $a60ed7403450fe58$var$home = 36;
var $a60ed7403450fe58$var$arrowLeft = 37;
var $a60ed7403450fe58$var$arrowUp = 38;
var $a60ed7403450fe58$var$arrowRight = 39;
var $a60ed7403450fe58$var$arrowDown = 40;
var $a60ed7403450fe58$var$_preventedKeys;
var $a60ed7403450fe58$var$preventedKeys = ($a60ed7403450fe58$var$_preventedKeys = {}, $a60ed7403450fe58$var$_preventedKeys[$a60ed7403450fe58$var$enter] = true, $a60ed7403450fe58$var$_preventedKeys[$a60ed7403450fe58$var$tab] = true, $a60ed7403450fe58$var$_preventedKeys);
var $a60ed7403450fe58$var$preventStandardKeyEvents = function(event) {
    if ($a60ed7403450fe58$var$preventedKeys[event.keyCode]) event.preventDefault();
};
var $a60ed7403450fe58$var$supportedEventName = function() {
    var base = "visibilitychange";
    if (typeof document === "undefined") return base;
    var candidates = [
        base,
        "ms" + base,
        "webkit" + base,
        "moz" + base,
        "o" + base
    ];
    var supported = $a60ed7403450fe58$var$find(candidates, function(eventName) {
        return "on" + eventName in document;
    });
    return supported || base;
}();
var $a60ed7403450fe58$var$primaryButton = 0;
var $a60ed7403450fe58$var$sloppyClickThreshold = 5;
function $a60ed7403450fe58$var$isSloppyClickThresholdExceeded(original, current) {
    return Math.abs(current.x - original.x) >= $a60ed7403450fe58$var$sloppyClickThreshold || Math.abs(current.y - original.y) >= $a60ed7403450fe58$var$sloppyClickThreshold;
}
var $a60ed7403450fe58$var$idle$1 = {
    type: "IDLE"
};
function $a60ed7403450fe58$var$getCaptureBindings(_ref) {
    var cancel = _ref.cancel, completed = _ref.completed, getPhase = _ref.getPhase, setPhase = _ref.setPhase;
    return [
        {
            eventName: "mousemove",
            fn: function fn(event) {
                var button = event.button, clientX = event.clientX, clientY = event.clientY;
                if (button !== $a60ed7403450fe58$var$primaryButton) return;
                var point = {
                    x: clientX,
                    y: clientY
                };
                var phase = getPhase();
                if (phase.type === "DRAGGING") {
                    event.preventDefault();
                    phase.actions.move(point);
                    return;
                }
                !(phase.type === "PENDING") && $a60ed7403450fe58$var$invariant(false);
                var pending = phase.point;
                if (!$a60ed7403450fe58$var$isSloppyClickThresholdExceeded(pending, point)) return;
                event.preventDefault();
                var actions = phase.actions.fluidLift(point);
                setPhase({
                    type: "DRAGGING",
                    actions: actions
                });
            }
        },
        {
            eventName: "mouseup",
            fn: function fn(event) {
                var phase = getPhase();
                if (phase.type !== "DRAGGING") {
                    cancel();
                    return;
                }
                event.preventDefault();
                phase.actions.drop({
                    shouldBlockNextClick: true
                });
                completed();
            }
        },
        {
            eventName: "mousedown",
            fn: function fn(event) {
                if (getPhase().type === "DRAGGING") event.preventDefault();
                cancel();
            }
        },
        {
            eventName: "keydown",
            fn: function fn(event) {
                var phase = getPhase();
                if (phase.type === "PENDING") {
                    cancel();
                    return;
                }
                if (event.keyCode === $a60ed7403450fe58$var$escape) {
                    event.preventDefault();
                    cancel();
                    return;
                }
                $a60ed7403450fe58$var$preventStandardKeyEvents(event);
            }
        },
        {
            eventName: "resize",
            fn: cancel
        },
        {
            eventName: "scroll",
            options: {
                passive: true,
                capture: false
            },
            fn: function fn() {
                if (getPhase().type === "PENDING") cancel();
            }
        },
        {
            eventName: "webkitmouseforcedown",
            fn: function fn(event) {
                var phase = getPhase();
                !(phase.type !== "IDLE") && $a60ed7403450fe58$var$invariant(false);
                if (phase.actions.shouldRespectForcePress()) {
                    cancel();
                    return;
                }
                event.preventDefault();
            }
        },
        {
            eventName: $a60ed7403450fe58$var$supportedEventName,
            fn: cancel
        }
    ];
}
function $a60ed7403450fe58$export$2f59cd992b42195a(api) {
    var phaseRef = (0, $eeH7J.useRef)($a60ed7403450fe58$var$idle$1);
    var unbindEventsRef = (0, $eeH7J.useRef)($a60ed7403450fe58$var$noop);
    var startCaptureBinding = (0, $3PiUj.useMemo)(function() {
        return {
            eventName: "mousedown",
            fn: function onMouseDown(event) {
                if (event.defaultPrevented) return;
                if (event.button !== $a60ed7403450fe58$var$primaryButton) return;
                if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
                var draggableId = api.findClosestDraggableId(event);
                if (!draggableId) return;
                var actions = api.tryGetLock(draggableId, stop, {
                    sourceEvent: event
                });
                if (!actions) return;
                event.preventDefault();
                var point = {
                    x: event.clientX,
                    y: event.clientY
                };
                unbindEventsRef.current();
                startPendingDrag(actions, point);
            }
        };
    }, [
        api
    ]);
    var preventForcePressBinding = (0, $3PiUj.useMemo)(function() {
        return {
            eventName: "webkitmouseforcewillbegin",
            fn: function fn(event) {
                if (event.defaultPrevented) return;
                var id = api.findClosestDraggableId(event);
                if (!id) return;
                var options = api.findOptionsForDraggable(id);
                if (!options) return;
                if (options.shouldRespectForcePress) return;
                if (!api.canGetLock(id)) return;
                event.preventDefault();
            }
        };
    }, [
        api
    ]);
    var listenForCapture = (0, $3PiUj.useCallback)(function listenForCapture() {
        var options = {
            passive: false,
            capture: true
        };
        unbindEventsRef.current = $a60ed7403450fe58$var$bindEvents(window, [
            preventForcePressBinding,
            startCaptureBinding
        ], options);
    }, [
        preventForcePressBinding,
        startCaptureBinding
    ]);
    var stop = (0, $3PiUj.useCallback)(function() {
        var current = phaseRef.current;
        if (current.type === "IDLE") return;
        phaseRef.current = $a60ed7403450fe58$var$idle$1;
        unbindEventsRef.current();
        listenForCapture();
    }, [
        listenForCapture
    ]);
    var cancel = (0, $3PiUj.useCallback)(function() {
        var phase = phaseRef.current;
        stop();
        if (phase.type === "DRAGGING") phase.actions.cancel({
            shouldBlockNextClick: true
        });
        if (phase.type === "PENDING") phase.actions.abort();
    }, [
        stop
    ]);
    var bindCapturingEvents = (0, $3PiUj.useCallback)(function bindCapturingEvents() {
        var options = {
            capture: true,
            passive: false
        };
        var bindings = $a60ed7403450fe58$var$getCaptureBindings({
            cancel: cancel,
            completed: stop,
            getPhase: function getPhase() {
                return phaseRef.current;
            },
            setPhase: function setPhase(phase) {
                phaseRef.current = phase;
            }
        });
        unbindEventsRef.current = $a60ed7403450fe58$var$bindEvents(window, bindings, options);
    }, [
        cancel,
        stop
    ]);
    var startPendingDrag = (0, $3PiUj.useCallback)(function startPendingDrag(actions, point) {
        !(phaseRef.current.type === "IDLE") && $a60ed7403450fe58$var$invariant(false);
        phaseRef.current = {
            type: "PENDING",
            point: point,
            actions: actions
        };
        bindCapturingEvents();
    }, [
        bindCapturingEvents
    ]);
    $a60ed7403450fe58$var$useIsomorphicLayoutEffect(function mount() {
        listenForCapture();
        return function unmount() {
            unbindEventsRef.current();
        };
    }, [
        listenForCapture
    ]);
}
var $a60ed7403450fe58$var$_scrollJumpKeys;
function $a60ed7403450fe58$var$noop$1() {}
var $a60ed7403450fe58$var$scrollJumpKeys = ($a60ed7403450fe58$var$_scrollJumpKeys = {}, $a60ed7403450fe58$var$_scrollJumpKeys[$a60ed7403450fe58$var$pageDown] = true, $a60ed7403450fe58$var$_scrollJumpKeys[$a60ed7403450fe58$var$pageUp] = true, $a60ed7403450fe58$var$_scrollJumpKeys[$a60ed7403450fe58$var$home] = true, $a60ed7403450fe58$var$_scrollJumpKeys[$a60ed7403450fe58$var$end] = true, $a60ed7403450fe58$var$_scrollJumpKeys);
function $a60ed7403450fe58$var$getDraggingBindings(actions, stop) {
    function cancel() {
        stop();
        actions.cancel();
    }
    function drop() {
        stop();
        actions.drop();
    }
    return [
        {
            eventName: "keydown",
            fn: function fn(event) {
                if (event.keyCode === $a60ed7403450fe58$var$escape) {
                    event.preventDefault();
                    cancel();
                    return;
                }
                if (event.keyCode === $a60ed7403450fe58$var$space) {
                    event.preventDefault();
                    drop();
                    return;
                }
                if (event.keyCode === $a60ed7403450fe58$var$arrowDown) {
                    event.preventDefault();
                    actions.moveDown();
                    return;
                }
                if (event.keyCode === $a60ed7403450fe58$var$arrowUp) {
                    event.preventDefault();
                    actions.moveUp();
                    return;
                }
                if (event.keyCode === $a60ed7403450fe58$var$arrowRight) {
                    event.preventDefault();
                    actions.moveRight();
                    return;
                }
                if (event.keyCode === $a60ed7403450fe58$var$arrowLeft) {
                    event.preventDefault();
                    actions.moveLeft();
                    return;
                }
                if ($a60ed7403450fe58$var$scrollJumpKeys[event.keyCode]) {
                    event.preventDefault();
                    return;
                }
                $a60ed7403450fe58$var$preventStandardKeyEvents(event);
            }
        },
        {
            eventName: "mousedown",
            fn: cancel
        },
        {
            eventName: "mouseup",
            fn: cancel
        },
        {
            eventName: "click",
            fn: cancel
        },
        {
            eventName: "touchstart",
            fn: cancel
        },
        {
            eventName: "resize",
            fn: cancel
        },
        {
            eventName: "wheel",
            fn: cancel,
            options: {
                passive: true
            }
        },
        {
            eventName: $a60ed7403450fe58$var$supportedEventName,
            fn: cancel
        }
    ];
}
function $a60ed7403450fe58$export$42b74264faad0714(api) {
    var unbindEventsRef = (0, $eeH7J.useRef)($a60ed7403450fe58$var$noop$1);
    var startCaptureBinding = (0, $3PiUj.useMemo)(function() {
        return {
            eventName: "keydown",
            fn: function onKeyDown(event) {
                if (event.defaultPrevented) return;
                if (event.keyCode !== $a60ed7403450fe58$var$space) return;
                var draggableId = api.findClosestDraggableId(event);
                if (!draggableId) return;
                var preDrag = api.tryGetLock(draggableId, stop, {
                    sourceEvent: event
                });
                if (!preDrag) return;
                event.preventDefault();
                var isCapturing = true;
                var actions = preDrag.snapLift();
                unbindEventsRef.current();
                function stop() {
                    !isCapturing && $a60ed7403450fe58$var$invariant(false);
                    isCapturing = false;
                    unbindEventsRef.current();
                    listenForCapture();
                }
                unbindEventsRef.current = $a60ed7403450fe58$var$bindEvents(window, $a60ed7403450fe58$var$getDraggingBindings(actions, stop), {
                    capture: true,
                    passive: false
                });
            }
        };
    }, [
        api
    ]);
    var listenForCapture = (0, $3PiUj.useCallback)(function tryStartCapture() {
        var options = {
            passive: false,
            capture: true
        };
        unbindEventsRef.current = $a60ed7403450fe58$var$bindEvents(window, [
            startCaptureBinding
        ], options);
    }, [
        startCaptureBinding
    ]);
    $a60ed7403450fe58$var$useIsomorphicLayoutEffect(function mount() {
        listenForCapture();
        return function unmount() {
            unbindEventsRef.current();
        };
    }, [
        listenForCapture
    ]);
}
var $a60ed7403450fe58$var$idle$2 = {
    type: "IDLE"
};
var $a60ed7403450fe58$var$timeForLongPress = 120;
var $a60ed7403450fe58$var$forcePressThreshold = 0.15;
function $a60ed7403450fe58$var$getWindowBindings(_ref) {
    var cancel = _ref.cancel, getPhase = _ref.getPhase;
    return [
        {
            eventName: "orientationchange",
            fn: cancel
        },
        {
            eventName: "resize",
            fn: cancel
        },
        {
            eventName: "contextmenu",
            fn: function fn(event) {
                event.preventDefault();
            }
        },
        {
            eventName: "keydown",
            fn: function fn(event) {
                if (getPhase().type !== "DRAGGING") {
                    cancel();
                    return;
                }
                if (event.keyCode === $a60ed7403450fe58$var$escape) event.preventDefault();
                cancel();
            }
        },
        {
            eventName: $a60ed7403450fe58$var$supportedEventName,
            fn: cancel
        }
    ];
}
function $a60ed7403450fe58$var$getHandleBindings(_ref2) {
    var cancel = _ref2.cancel, completed = _ref2.completed, getPhase = _ref2.getPhase;
    return [
        {
            eventName: "touchmove",
            options: {
                capture: false
            },
            fn: function fn(event) {
                var phase = getPhase();
                if (phase.type !== "DRAGGING") {
                    cancel();
                    return;
                }
                phase.hasMoved = true;
                var _event$touches$ = event.touches[0], clientX = _event$touches$.clientX, clientY = _event$touches$.clientY;
                var point = {
                    x: clientX,
                    y: clientY
                };
                event.preventDefault();
                phase.actions.move(point);
            }
        },
        {
            eventName: "touchend",
            fn: function fn(event) {
                var phase = getPhase();
                if (phase.type !== "DRAGGING") {
                    cancel();
                    return;
                }
                event.preventDefault();
                phase.actions.drop({
                    shouldBlockNextClick: true
                });
                completed();
            }
        },
        {
            eventName: "touchcancel",
            fn: function fn(event) {
                if (getPhase().type !== "DRAGGING") {
                    cancel();
                    return;
                }
                event.preventDefault();
                cancel();
            }
        },
        {
            eventName: "touchforcechange",
            fn: function fn(event) {
                var phase = getPhase();
                !(phase.type !== "IDLE") && $a60ed7403450fe58$var$invariant(false);
                var touch = event.touches[0];
                if (!touch) return;
                var isForcePress = touch.force >= $a60ed7403450fe58$var$forcePressThreshold;
                if (!isForcePress) return;
                var shouldRespect = phase.actions.shouldRespectForcePress();
                if (phase.type === "PENDING") {
                    if (shouldRespect) cancel();
                    return;
                }
                if (shouldRespect) {
                    if (phase.hasMoved) {
                        event.preventDefault();
                        return;
                    }
                    cancel();
                    return;
                }
                event.preventDefault();
            }
        },
        {
            eventName: $a60ed7403450fe58$var$supportedEventName,
            fn: cancel
        }
    ];
}
function $a60ed7403450fe58$export$ac235fd3a7bcf7b4(api) {
    var phaseRef = (0, $eeH7J.useRef)($a60ed7403450fe58$var$idle$2);
    var unbindEventsRef = (0, $eeH7J.useRef)($a60ed7403450fe58$var$noop);
    var getPhase = (0, $3PiUj.useCallback)(function getPhase() {
        return phaseRef.current;
    }, []);
    var setPhase = (0, $3PiUj.useCallback)(function setPhase(phase) {
        phaseRef.current = phase;
    }, []);
    var startCaptureBinding = (0, $3PiUj.useMemo)(function() {
        return {
            eventName: "touchstart",
            fn: function onTouchStart(event) {
                if (event.defaultPrevented) return;
                var draggableId = api.findClosestDraggableId(event);
                if (!draggableId) return;
                var actions = api.tryGetLock(draggableId, stop, {
                    sourceEvent: event
                });
                if (!actions) return;
                var touch = event.touches[0];
                var clientX = touch.clientX, clientY = touch.clientY;
                var point = {
                    x: clientX,
                    y: clientY
                };
                unbindEventsRef.current();
                startPendingDrag(actions, point);
            }
        };
    }, [
        api
    ]);
    var listenForCapture = (0, $3PiUj.useCallback)(function listenForCapture() {
        var options = {
            capture: true,
            passive: false
        };
        unbindEventsRef.current = $a60ed7403450fe58$var$bindEvents(window, [
            startCaptureBinding
        ], options);
    }, [
        startCaptureBinding
    ]);
    var stop = (0, $3PiUj.useCallback)(function() {
        var current = phaseRef.current;
        if (current.type === "IDLE") return;
        if (current.type === "PENDING") clearTimeout(current.longPressTimerId);
        setPhase($a60ed7403450fe58$var$idle$2);
        unbindEventsRef.current();
        listenForCapture();
    }, [
        listenForCapture,
        setPhase
    ]);
    var cancel = (0, $3PiUj.useCallback)(function() {
        var phase = phaseRef.current;
        stop();
        if (phase.type === "DRAGGING") phase.actions.cancel({
            shouldBlockNextClick: true
        });
        if (phase.type === "PENDING") phase.actions.abort();
    }, [
        stop
    ]);
    var bindCapturingEvents = (0, $3PiUj.useCallback)(function bindCapturingEvents() {
        var options = {
            capture: true,
            passive: false
        };
        var args = {
            cancel: cancel,
            completed: stop,
            getPhase: getPhase
        };
        var unbindTarget = $a60ed7403450fe58$var$bindEvents(window, $a60ed7403450fe58$var$getHandleBindings(args), options);
        var unbindWindow = $a60ed7403450fe58$var$bindEvents(window, $a60ed7403450fe58$var$getWindowBindings(args), options);
        unbindEventsRef.current = function unbindAll() {
            unbindTarget();
            unbindWindow();
        };
    }, [
        cancel,
        getPhase,
        stop
    ]);
    var startDragging = (0, $3PiUj.useCallback)(function startDragging() {
        var phase = getPhase();
        !(phase.type === "PENDING") && $a60ed7403450fe58$var$invariant(false);
        var actions = phase.actions.fluidLift(phase.point);
        setPhase({
            type: "DRAGGING",
            actions: actions,
            hasMoved: false
        });
    }, [
        getPhase,
        setPhase
    ]);
    var startPendingDrag = (0, $3PiUj.useCallback)(function startPendingDrag(actions, point) {
        !(getPhase().type === "IDLE") && $a60ed7403450fe58$var$invariant(false);
        var longPressTimerId = setTimeout(startDragging, $a60ed7403450fe58$var$timeForLongPress);
        setPhase({
            type: "PENDING",
            point: point,
            actions: actions,
            longPressTimerId: longPressTimerId
        });
        bindCapturingEvents();
    }, [
        bindCapturingEvents,
        getPhase,
        setPhase,
        startDragging
    ]);
    $a60ed7403450fe58$var$useIsomorphicLayoutEffect(function mount() {
        listenForCapture();
        return function unmount() {
            unbindEventsRef.current();
            var phase = getPhase();
            if (phase.type === "PENDING") {
                clearTimeout(phase.longPressTimerId);
                setPhase($a60ed7403450fe58$var$idle$2);
            }
        };
    }, [
        getPhase,
        listenForCapture,
        setPhase
    ]);
    $a60ed7403450fe58$var$useIsomorphicLayoutEffect(function webkitHack() {
        var unbind = $a60ed7403450fe58$var$bindEvents(window, [
            {
                eventName: "touchmove",
                fn: function fn() {},
                options: {
                    capture: false,
                    passive: false
                }
            }
        ]);
        return unbind;
    }, []);
}
function $a60ed7403450fe58$var$useValidateSensorHooks(sensorHooks) {
    $a60ed7403450fe58$var$useDev(function() {
        var previousRef = $a60ed7403450fe58$var$usePrevious(sensorHooks);
        $a60ed7403450fe58$var$useDevSetupWarning(function() {
            !(previousRef.current.length === sensorHooks.length) && $a60ed7403450fe58$var$invariant(false);
        });
    });
}
var $a60ed7403450fe58$var$interactiveTagNames = {
    input: true,
    button: true,
    textarea: true,
    select: true,
    option: true,
    optgroup: true,
    video: true,
    audio: true
};
function $a60ed7403450fe58$var$isAnInteractiveElement(parent, current) {
    if (current == null) return false;
    var hasAnInteractiveTag = Boolean($a60ed7403450fe58$var$interactiveTagNames[current.tagName.toLowerCase()]);
    if (hasAnInteractiveTag) return true;
    var attribute = current.getAttribute("contenteditable");
    if (attribute === "true" || attribute === "") return true;
    if (current === parent) return false;
    return $a60ed7403450fe58$var$isAnInteractiveElement(parent, current.parentElement);
}
function $a60ed7403450fe58$var$isEventInInteractiveElement(draggable, event) {
    var target = event.target;
    if (!$a60ed7403450fe58$var$isHtmlElement(target)) return false;
    return $a60ed7403450fe58$var$isAnInteractiveElement(draggable, target);
}
var $a60ed7403450fe58$var$getBorderBoxCenterPosition = function(el) {
    return (0, $4J1sD.getRect)(el.getBoundingClientRect()).center;
};
function $a60ed7403450fe58$var$isElement(el) {
    return el instanceof $a60ed7403450fe58$var$getWindowFromEl(el).Element;
}
var $a60ed7403450fe58$var$supportedMatchesName = function() {
    var base = "matches";
    if (typeof document === "undefined") return base;
    var candidates = [
        base,
        "msMatchesSelector",
        "webkitMatchesSelector"
    ];
    var value = $a60ed7403450fe58$var$find(candidates, function(name) {
        return name in Element.prototype;
    });
    return value || base;
}();
function $a60ed7403450fe58$var$closestPonyfill(el, selector) {
    if (el == null) return null;
    if (el[$a60ed7403450fe58$var$supportedMatchesName](selector)) return el;
    return $a60ed7403450fe58$var$closestPonyfill(el.parentElement, selector);
}
function $a60ed7403450fe58$var$closest$1(el, selector) {
    if (el.closest) return el.closest(selector);
    return $a60ed7403450fe58$var$closestPonyfill(el, selector);
}
function $a60ed7403450fe58$var$getSelector(contextId) {
    return "[" + $a60ed7403450fe58$var$dragHandle.contextId + '="' + contextId + '"]';
}
function $a60ed7403450fe58$var$findClosestDragHandleFromEvent(contextId, event) {
    var target = event.target;
    if (!$a60ed7403450fe58$var$isElement(target)) return null;
    var selector = $a60ed7403450fe58$var$getSelector(contextId);
    var handle = $a60ed7403450fe58$var$closest$1(target, selector);
    if (!handle) return null;
    if (!$a60ed7403450fe58$var$isHtmlElement(handle)) return null;
    return handle;
}
function $a60ed7403450fe58$var$tryGetClosestDraggableIdFromEvent(contextId, event) {
    var handle = $a60ed7403450fe58$var$findClosestDragHandleFromEvent(contextId, event);
    if (!handle) return null;
    return handle.getAttribute($a60ed7403450fe58$var$dragHandle.draggableId);
}
function $a60ed7403450fe58$var$findDraggable(contextId, draggableId) {
    var selector = "[" + $a60ed7403450fe58$var$draggable.contextId + '="' + contextId + '"]';
    var possible = $a60ed7403450fe58$var$toArray(document.querySelectorAll(selector));
    var draggable$1 = $a60ed7403450fe58$var$find(possible, function(el) {
        return el.getAttribute($a60ed7403450fe58$var$draggable.id) === draggableId;
    });
    if (!draggable$1) return null;
    if (!$a60ed7403450fe58$var$isHtmlElement(draggable$1)) return null;
    return draggable$1;
}
function $a60ed7403450fe58$var$preventDefault(event) {
    event.preventDefault();
}
function $a60ed7403450fe58$var$_isActive(_ref) {
    var expected = _ref.expected, phase = _ref.phase, isLockActive = _ref.isLockActive, shouldWarn = _ref.shouldWarn;
    if (!isLockActive()) {
        shouldWarn;
        return false;
    }
    if (expected !== phase) {
        shouldWarn;
        return false;
    }
    return true;
}
function $a60ed7403450fe58$var$canStart(_ref2) {
    var lockAPI = _ref2.lockAPI, store = _ref2.store, registry = _ref2.registry, draggableId = _ref2.draggableId;
    if (lockAPI.isClaimed()) return false;
    var entry = registry.draggable.findById(draggableId);
    if (!entry) return false;
    if (!entry.options.isEnabled) return false;
    if (!$a60ed7403450fe58$var$canStartDrag(store.getState(), draggableId)) return false;
    return true;
}
function $a60ed7403450fe58$var$tryStart(_ref3) {
    var lockAPI = _ref3.lockAPI, contextId = _ref3.contextId, store = _ref3.store, registry = _ref3.registry, draggableId = _ref3.draggableId, forceSensorStop = _ref3.forceSensorStop, sourceEvent = _ref3.sourceEvent;
    var shouldStart = $a60ed7403450fe58$var$canStart({
        lockAPI: lockAPI,
        store: store,
        registry: registry,
        draggableId: draggableId
    });
    if (!shouldStart) return null;
    var entry = registry.draggable.getById(draggableId);
    var el = $a60ed7403450fe58$var$findDraggable(contextId, entry.descriptor.id);
    if (!el) return null;
    if (sourceEvent && !entry.options.canDragInteractiveElements && $a60ed7403450fe58$var$isEventInInteractiveElement(el, sourceEvent)) return null;
    var lock = lockAPI.claim(forceSensorStop || $a60ed7403450fe58$var$noop);
    var phase = "PRE_DRAG";
    function getShouldRespectForcePress() {
        return entry.options.shouldRespectForcePress;
    }
    function isLockActive() {
        return lockAPI.isActive(lock);
    }
    function tryDispatch(expected, getAction) {
        if ($a60ed7403450fe58$var$_isActive({
            expected: expected,
            phase: phase,
            isLockActive: isLockActive,
            shouldWarn: true
        })) store.dispatch(getAction());
    }
    var tryDispatchWhenDragging = tryDispatch.bind(null, "DRAGGING");
    function lift$1(args) {
        function completed() {
            lockAPI.release();
            phase = "COMPLETED";
        }
        if (phase !== "PRE_DRAG") {
            completed();
            !(phase === "PRE_DRAG") && $a60ed7403450fe58$var$invariant(false);
        }
        store.dispatch($a60ed7403450fe58$var$lift(args.liftActionArgs));
        phase = "DRAGGING";
        function finish(reason, options) {
            if (options === void 0) options = {
                shouldBlockNextClick: false
            };
            args.cleanup();
            if (options.shouldBlockNextClick) {
                var unbind = $a60ed7403450fe58$var$bindEvents(window, [
                    {
                        eventName: "click",
                        fn: $a60ed7403450fe58$var$preventDefault,
                        options: {
                            once: true,
                            passive: false,
                            capture: true
                        }
                    }
                ]);
                setTimeout(unbind);
            }
            completed();
            store.dispatch($a60ed7403450fe58$var$drop({
                reason: reason
            }));
        }
        return (0, $h4XE0.default)({
            isActive: function isActive() {
                return $a60ed7403450fe58$var$_isActive({
                    expected: "DRAGGING",
                    phase: phase,
                    isLockActive: isLockActive,
                    shouldWarn: false
                });
            },
            shouldRespectForcePress: getShouldRespectForcePress,
            drop: function drop(options) {
                return finish("DROP", options);
            },
            cancel: function cancel(options) {
                return finish("CANCEL", options);
            }
        }, args.actions);
    }
    function fluidLift(clientSelection) {
        var move$1 = (0, $lqlwE.default)(function(client) {
            tryDispatchWhenDragging(function() {
                return $a60ed7403450fe58$var$move({
                    client: client
                });
            });
        });
        var api = lift$1({
            liftActionArgs: {
                id: draggableId,
                clientSelection: clientSelection,
                movementMode: "FLUID"
            },
            cleanup: function cleanup() {
                return move$1.cancel();
            },
            actions: {
                move: move$1
            }
        });
        return (0, $h4XE0.default)({}, api, {
            move: move$1
        });
    }
    function snapLift() {
        var actions = {
            moveUp: function moveUp$1() {
                return tryDispatchWhenDragging($a60ed7403450fe58$var$moveUp);
            },
            moveRight: function moveRight$1() {
                return tryDispatchWhenDragging($a60ed7403450fe58$var$moveRight);
            },
            moveDown: function moveDown$1() {
                return tryDispatchWhenDragging($a60ed7403450fe58$var$moveDown);
            },
            moveLeft: function moveLeft$1() {
                return tryDispatchWhenDragging($a60ed7403450fe58$var$moveLeft);
            }
        };
        return lift$1({
            liftActionArgs: {
                id: draggableId,
                clientSelection: $a60ed7403450fe58$var$getBorderBoxCenterPosition(el),
                movementMode: "SNAP"
            },
            cleanup: $a60ed7403450fe58$var$noop,
            actions: actions
        });
    }
    function abortPreDrag() {
        var shouldRelease = $a60ed7403450fe58$var$_isActive({
            expected: "PRE_DRAG",
            phase: phase,
            isLockActive: isLockActive,
            shouldWarn: true
        });
        if (shouldRelease) lockAPI.release();
    }
    var preDrag = {
        isActive: function isActive() {
            return $a60ed7403450fe58$var$_isActive({
                expected: "PRE_DRAG",
                phase: phase,
                isLockActive: isLockActive,
                shouldWarn: false
            });
        },
        shouldRespectForcePress: getShouldRespectForcePress,
        fluidLift: fluidLift,
        snapLift: snapLift,
        abort: abortPreDrag
    };
    return preDrag;
}
var $a60ed7403450fe58$var$defaultSensors = [
    $a60ed7403450fe58$export$2f59cd992b42195a,
    $a60ed7403450fe58$export$42b74264faad0714,
    $a60ed7403450fe58$export$ac235fd3a7bcf7b4
];
function $a60ed7403450fe58$var$useSensorMarshal(_ref4) {
    var contextId = _ref4.contextId, store = _ref4.store, registry = _ref4.registry, customSensors = _ref4.customSensors, enableDefaultSensors = _ref4.enableDefaultSensors;
    var useSensors = [].concat(enableDefaultSensors ? $a60ed7403450fe58$var$defaultSensors : [], customSensors || []);
    var lockAPI = (0, $eeH7J.useState)(function() {
        return $a60ed7403450fe58$var$create();
    })[0];
    var tryAbandonLock = (0, $3PiUj.useCallback)(function tryAbandonLock(previous, current) {
        if (previous.isDragging && !current.isDragging) lockAPI.tryAbandon();
    }, [
        lockAPI
    ]);
    $a60ed7403450fe58$var$useIsomorphicLayoutEffect(function listenToStore() {
        var previous = store.getState();
        var unsubscribe = store.subscribe(function() {
            var current = store.getState();
            tryAbandonLock(previous, current);
            previous = current;
        });
        return unsubscribe;
    }, [
        lockAPI,
        store,
        tryAbandonLock
    ]);
    $a60ed7403450fe58$var$useIsomorphicLayoutEffect(function() {
        return lockAPI.tryAbandon;
    }, [
        lockAPI.tryAbandon
    ]);
    var canGetLock = (0, $3PiUj.useCallback)(function(draggableId) {
        return $a60ed7403450fe58$var$canStart({
            lockAPI: lockAPI,
            registry: registry,
            store: store,
            draggableId: draggableId
        });
    }, [
        lockAPI,
        registry,
        store
    ]);
    var tryGetLock = (0, $3PiUj.useCallback)(function(draggableId, forceStop, options) {
        return $a60ed7403450fe58$var$tryStart({
            lockAPI: lockAPI,
            registry: registry,
            contextId: contextId,
            store: store,
            draggableId: draggableId,
            forceSensorStop: forceStop,
            sourceEvent: options && options.sourceEvent ? options.sourceEvent : null
        });
    }, [
        contextId,
        lockAPI,
        registry,
        store
    ]);
    var findClosestDraggableId = (0, $3PiUj.useCallback)(function(event) {
        return $a60ed7403450fe58$var$tryGetClosestDraggableIdFromEvent(contextId, event);
    }, [
        contextId
    ]);
    var findOptionsForDraggable = (0, $3PiUj.useCallback)(function(id) {
        var entry = registry.draggable.findById(id);
        return entry ? entry.options : null;
    }, [
        registry.draggable
    ]);
    var tryReleaseLock = (0, $3PiUj.useCallback)(function tryReleaseLock() {
        if (!lockAPI.isClaimed()) return;
        lockAPI.tryAbandon();
        if (store.getState().phase !== "IDLE") store.dispatch($a60ed7403450fe58$var$flush());
    }, [
        lockAPI,
        store
    ]);
    var isLockClaimed = (0, $3PiUj.useCallback)(lockAPI.isClaimed, [
        lockAPI
    ]);
    var api = (0, $3PiUj.useMemo)(function() {
        return {
            canGetLock: canGetLock,
            tryGetLock: tryGetLock,
            findClosestDraggableId: findClosestDraggableId,
            findOptionsForDraggable: findOptionsForDraggable,
            tryReleaseLock: tryReleaseLock,
            isLockClaimed: isLockClaimed
        };
    }, [
        canGetLock,
        tryGetLock,
        findClosestDraggableId,
        findOptionsForDraggable,
        tryReleaseLock,
        isLockClaimed
    ]);
    $a60ed7403450fe58$var$useValidateSensorHooks(useSensors);
    for(var i = 0; i < useSensors.length; i++)useSensors[i](api);
}
var $a60ed7403450fe58$var$createResponders = function createResponders(props) {
    return {
        onBeforeCapture: props.onBeforeCapture,
        onBeforeDragStart: props.onBeforeDragStart,
        onDragStart: props.onDragStart,
        onDragEnd: props.onDragEnd,
        onDragUpdate: props.onDragUpdate
    };
};
function $a60ed7403450fe58$var$getStore(lazyRef) {
    !lazyRef.current && $a60ed7403450fe58$var$invariant(false);
    return lazyRef.current;
}
function $a60ed7403450fe58$var$App(props) {
    var contextId = props.contextId, setCallbacks = props.setCallbacks, sensors = props.sensors, nonce = props.nonce, dragHandleUsageInstructions = props.dragHandleUsageInstructions;
    var lazyStoreRef = (0, $eeH7J.useRef)(null);
    $a60ed7403450fe58$var$useStartupValidation();
    var lastPropsRef = $a60ed7403450fe58$var$usePrevious(props);
    var getResponders = (0, $3PiUj.useCallback)(function() {
        return $a60ed7403450fe58$var$createResponders(lastPropsRef.current);
    }, [
        lastPropsRef
    ]);
    var announce = $a60ed7403450fe58$var$useAnnouncer(contextId);
    var dragHandleUsageInstructionsId = $a60ed7403450fe58$var$useHiddenTextElement({
        contextId: contextId,
        text: dragHandleUsageInstructions
    });
    var styleMarshal = $a60ed7403450fe58$var$useStyleMarshal(contextId, nonce);
    var lazyDispatch = (0, $3PiUj.useCallback)(function(action) {
        $a60ed7403450fe58$var$getStore(lazyStoreRef).dispatch(action);
    }, []);
    var marshalCallbacks = (0, $3PiUj.useMemo)(function() {
        return (0, $jkmOZ.bindActionCreators)({
            publishWhileDragging: $a60ed7403450fe58$var$publishWhileDragging,
            updateDroppableScroll: $a60ed7403450fe58$var$updateDroppableScroll,
            updateDroppableIsEnabled: $a60ed7403450fe58$var$updateDroppableIsEnabled,
            updateDroppableIsCombineEnabled: $a60ed7403450fe58$var$updateDroppableIsCombineEnabled,
            collectionStarting: $a60ed7403450fe58$var$collectionStarting
        }, lazyDispatch);
    }, [
        lazyDispatch
    ]);
    var registry = $a60ed7403450fe58$var$useRegistry();
    var dimensionMarshal = (0, $3PiUj.useMemo)(function() {
        return $a60ed7403450fe58$var$createDimensionMarshal(registry, marshalCallbacks);
    }, [
        registry,
        marshalCallbacks
    ]);
    var autoScroller = (0, $3PiUj.useMemo)(function() {
        return $a60ed7403450fe58$var$createAutoScroller((0, $h4XE0.default)({
            scrollWindow: $a60ed7403450fe58$var$scrollWindow,
            scrollDroppable: dimensionMarshal.scrollDroppable
        }, (0, $jkmOZ.bindActionCreators)({
            move: $a60ed7403450fe58$var$move
        }, lazyDispatch)));
    }, [
        dimensionMarshal.scrollDroppable,
        lazyDispatch
    ]);
    var focusMarshal = $a60ed7403450fe58$var$useFocusMarshal(contextId);
    var store = (0, $3PiUj.useMemo)(function() {
        return $a60ed7403450fe58$var$createStore({
            announce: announce,
            autoScroller: autoScroller,
            dimensionMarshal: dimensionMarshal,
            focusMarshal: focusMarshal,
            getResponders: getResponders,
            styleMarshal: styleMarshal
        });
    }, [
        announce,
        autoScroller,
        dimensionMarshal,
        focusMarshal,
        getResponders,
        styleMarshal
    ]);
    lazyStoreRef.current = store;
    var tryResetStore = (0, $3PiUj.useCallback)(function() {
        var current = $a60ed7403450fe58$var$getStore(lazyStoreRef);
        var state = current.getState();
        if (state.phase !== "IDLE") current.dispatch($a60ed7403450fe58$var$flush());
    }, []);
    var isDragging = (0, $3PiUj.useCallback)(function() {
        var state = $a60ed7403450fe58$var$getStore(lazyStoreRef).getState();
        return state.isDragging || state.phase === "DROP_ANIMATING";
    }, []);
    var appCallbacks = (0, $3PiUj.useMemo)(function() {
        return {
            isDragging: isDragging,
            tryAbort: tryResetStore
        };
    }, [
        isDragging,
        tryResetStore
    ]);
    setCallbacks(appCallbacks);
    var getCanLift = (0, $3PiUj.useCallback)(function(id) {
        return $a60ed7403450fe58$var$canStartDrag($a60ed7403450fe58$var$getStore(lazyStoreRef).getState(), id);
    }, []);
    var getIsMovementAllowed = (0, $3PiUj.useCallback)(function() {
        return $a60ed7403450fe58$var$isMovementAllowed($a60ed7403450fe58$var$getStore(lazyStoreRef).getState());
    }, []);
    var appContext = (0, $3PiUj.useMemo)(function() {
        return {
            marshal: dimensionMarshal,
            focus: focusMarshal,
            contextId: contextId,
            canLift: getCanLift,
            isMovementAllowed: getIsMovementAllowed,
            dragHandleUsageInstructionsId: dragHandleUsageInstructionsId,
            registry: registry
        };
    }, [
        contextId,
        dimensionMarshal,
        dragHandleUsageInstructionsId,
        focusMarshal,
        getCanLift,
        getIsMovementAllowed,
        registry
    ]);
    $a60ed7403450fe58$var$useSensorMarshal({
        contextId: contextId,
        store: store,
        registry: registry,
        customSensors: sensors,
        enableDefaultSensors: props.enableDefaultSensors !== false
    });
    (0, $eeH7J.useEffect)(function() {
        return tryResetStore;
    }, [
        tryResetStore
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement($a60ed7403450fe58$var$AppContext.Provider, {
        value: appContext
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $fUBYE.default), {
        context: $a60ed7403450fe58$var$StoreContext,
        store: store
    }, props.children));
}
var $a60ed7403450fe58$var$count$1 = 0;
function $a60ed7403450fe58$var$reset$1() {
    $a60ed7403450fe58$var$count$1 = 0;
}
function $a60ed7403450fe58$var$useInstanceCount() {
    return (0, $3PiUj.useMemo)(function() {
        return "" + $a60ed7403450fe58$var$count$1++;
    }, []);
}
function $a60ed7403450fe58$export$2bfe52350fc0150d() {
    $a60ed7403450fe58$var$reset$1();
    $a60ed7403450fe58$var$reset();
}
function $a60ed7403450fe58$export$237bd83162c14364(props) {
    var contextId = $a60ed7403450fe58$var$useInstanceCount();
    var dragHandleUsageInstructions = props.dragHandleUsageInstructions || $a60ed7403450fe58$var$preset.dragHandleUsageInstructions;
    return (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement($a60ed7403450fe58$var$ErrorBoundary, null, function(setCallbacks) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement($a60ed7403450fe58$var$App, {
            nonce: props.nonce,
            contextId: contextId,
            setCallbacks: setCallbacks,
            dragHandleUsageInstructions: dragHandleUsageInstructions,
            enableDefaultSensors: props.enableDefaultSensors,
            sensors: props.sensors,
            onBeforeCapture: props.onBeforeCapture,
            onBeforeDragStart: props.onBeforeDragStart,
            onDragStart: props.onDragStart,
            onDragUpdate: props.onDragUpdate,
            onDragEnd: props.onDragEnd
        }, props.children);
    });
}
var $a60ed7403450fe58$var$isEqual$1 = function isEqual(base) {
    return function(value) {
        return base === value;
    };
};
var $a60ed7403450fe58$var$isScroll = $a60ed7403450fe58$var$isEqual$1("scroll");
var $a60ed7403450fe58$var$isAuto = $a60ed7403450fe58$var$isEqual$1("auto");
var $a60ed7403450fe58$var$isVisible$1 = $a60ed7403450fe58$var$isEqual$1("visible");
var $a60ed7403450fe58$var$isEither = function isEither(overflow, fn) {
    return fn(overflow.overflowX) || fn(overflow.overflowY);
};
var $a60ed7403450fe58$var$isBoth = function isBoth(overflow, fn) {
    return fn(overflow.overflowX) && fn(overflow.overflowY);
};
var $a60ed7403450fe58$var$isElementScrollable = function isElementScrollable(el) {
    var style = window.getComputedStyle(el);
    var overflow = {
        overflowX: style.overflowX,
        overflowY: style.overflowY
    };
    return $a60ed7403450fe58$var$isEither(overflow, $a60ed7403450fe58$var$isScroll) || $a60ed7403450fe58$var$isEither(overflow, $a60ed7403450fe58$var$isAuto);
};
var $a60ed7403450fe58$var$isBodyScrollable = function isBodyScrollable() {
    var body, html, htmlStyle, htmlOverflow;
    return false;
};
var $a60ed7403450fe58$var$getClosestScrollable = function getClosestScrollable(el) {
    if (el == null) return null;
    if (el === document.body) return $a60ed7403450fe58$var$isBodyScrollable() ? el : null;
    if (el === document.documentElement) return null;
    if (!$a60ed7403450fe58$var$isElementScrollable(el)) return getClosestScrollable(el.parentElement);
    return el;
};
var $a60ed7403450fe58$var$checkForNestedScrollContainers = function(scrollable) {
    if (!scrollable) return;
    var anotherScrollParent = $a60ed7403450fe58$var$getClosestScrollable(scrollable.parentElement);
    if (!anotherScrollParent) return;
};
var $a60ed7403450fe58$var$getScroll$1 = function(el) {
    return {
        x: el.scrollLeft,
        y: el.scrollTop
    };
};
var $a60ed7403450fe58$var$getIsFixed = function getIsFixed(el) {
    if (!el) return false;
    var style = window.getComputedStyle(el);
    if (style.position === "fixed") return true;
    return getIsFixed(el.parentElement);
};
var $a60ed7403450fe58$var$getEnv = function(start) {
    var closestScrollable = $a60ed7403450fe58$var$getClosestScrollable(start);
    var isFixedOnPage = $a60ed7403450fe58$var$getIsFixed(start);
    return {
        closestScrollable: closestScrollable,
        isFixedOnPage: isFixedOnPage
    };
};
var $a60ed7403450fe58$var$getDroppableDimension = function(_ref) {
    var descriptor = _ref.descriptor, isEnabled = _ref.isEnabled, isCombineEnabled = _ref.isCombineEnabled, isFixedOnPage = _ref.isFixedOnPage, direction = _ref.direction, client = _ref.client, page = _ref.page, closest = _ref.closest;
    var frame = function() {
        if (!closest) return null;
        var scrollSize = closest.scrollSize, frameClient = closest.client;
        var maxScroll = $a60ed7403450fe58$var$getMaxScroll({
            scrollHeight: scrollSize.scrollHeight,
            scrollWidth: scrollSize.scrollWidth,
            height: frameClient.paddingBox.height,
            width: frameClient.paddingBox.width
        });
        return {
            pageMarginBox: closest.page.marginBox,
            frameClient: frameClient,
            scrollSize: scrollSize,
            shouldClipSubject: closest.shouldClipSubject,
            scroll: {
                initial: closest.scroll,
                current: closest.scroll,
                max: maxScroll,
                diff: {
                    value: $a60ed7403450fe58$var$origin,
                    displacement: $a60ed7403450fe58$var$origin
                }
            }
        };
    }();
    var axis = direction === "vertical" ? $a60ed7403450fe58$var$vertical : $a60ed7403450fe58$var$horizontal;
    var subject = $a60ed7403450fe58$var$getSubject({
        page: page,
        withPlaceholder: null,
        axis: axis,
        frame: frame
    });
    var dimension = {
        descriptor: descriptor,
        isCombineEnabled: isCombineEnabled,
        isFixedOnPage: isFixedOnPage,
        axis: axis,
        isEnabled: isEnabled,
        client: client,
        page: page,
        frame: frame,
        subject: subject
    };
    return dimension;
};
var $a60ed7403450fe58$var$getClient = function getClient(targetRef, closestScrollable) {
    var base = (0, $4J1sD.getBox)(targetRef);
    if (!closestScrollable) return base;
    if (targetRef !== closestScrollable) return base;
    var top = base.paddingBox.top - closestScrollable.scrollTop;
    var left = base.paddingBox.left - closestScrollable.scrollLeft;
    var bottom = top + closestScrollable.scrollHeight;
    var right = left + closestScrollable.scrollWidth;
    var paddingBox = {
        top: top,
        right: right,
        bottom: bottom,
        left: left
    };
    var borderBox = (0, $4J1sD.expand)(paddingBox, base.border);
    var client = (0, $4J1sD.createBox)({
        borderBox: borderBox,
        margin: base.margin,
        border: base.border,
        padding: base.padding
    });
    return client;
};
var $a60ed7403450fe58$var$getDimension = function(_ref) {
    var ref = _ref.ref, descriptor = _ref.descriptor, env = _ref.env, windowScroll = _ref.windowScroll, direction = _ref.direction, isDropDisabled = _ref.isDropDisabled, isCombineEnabled = _ref.isCombineEnabled, shouldClipSubject = _ref.shouldClipSubject;
    var closestScrollable = env.closestScrollable;
    var client = $a60ed7403450fe58$var$getClient(ref, closestScrollable);
    var page = (0, $4J1sD.withScroll)(client, windowScroll);
    var closest = function() {
        if (!closestScrollable) return null;
        var frameClient = (0, $4J1sD.getBox)(closestScrollable);
        var scrollSize = {
            scrollHeight: closestScrollable.scrollHeight,
            scrollWidth: closestScrollable.scrollWidth
        };
        return {
            client: frameClient,
            page: (0, $4J1sD.withScroll)(frameClient, windowScroll),
            scroll: $a60ed7403450fe58$var$getScroll$1(closestScrollable),
            scrollSize: scrollSize,
            shouldClipSubject: shouldClipSubject
        };
    }();
    var dimension = $a60ed7403450fe58$var$getDroppableDimension({
        descriptor: descriptor,
        isEnabled: !isDropDisabled,
        isCombineEnabled: isCombineEnabled,
        isFixedOnPage: env.isFixedOnPage,
        direction: direction,
        client: client,
        page: page,
        closest: closest
    });
    return dimension;
};
var $a60ed7403450fe58$var$immediate = {
    passive: false
};
var $a60ed7403450fe58$var$delayed = {
    passive: true
};
var $a60ed7403450fe58$var$getListenerOptions = function(options) {
    return options.shouldPublishImmediately ? $a60ed7403450fe58$var$immediate : $a60ed7403450fe58$var$delayed;
};
function $a60ed7403450fe58$var$useRequiredContext(Context) {
    var result = (0, $eeH7J.useContext)(Context);
    !result && $a60ed7403450fe58$var$invariant(false);
    return result;
}
var $a60ed7403450fe58$var$getClosestScrollableFromDrag = function getClosestScrollableFromDrag(dragging) {
    return dragging && dragging.env.closestScrollable || null;
};
function $a60ed7403450fe58$var$useDroppablePublisher(args) {
    var whileDraggingRef = (0, $eeH7J.useRef)(null);
    var appContext = $a60ed7403450fe58$var$useRequiredContext($a60ed7403450fe58$var$AppContext);
    var uniqueId = $a60ed7403450fe58$var$useUniqueId("droppable");
    var registry = appContext.registry, marshal = appContext.marshal;
    var previousRef = $a60ed7403450fe58$var$usePrevious(args);
    var descriptor = (0, $3PiUj.useMemo)(function() {
        return {
            id: args.droppableId,
            type: args.type,
            mode: args.mode
        };
    }, [
        args.droppableId,
        args.mode,
        args.type
    ]);
    var publishedDescriptorRef = (0, $eeH7J.useRef)(descriptor);
    var memoizedUpdateScroll = (0, $3PiUj.useMemo)(function() {
        return (0, $kQ1m2.default)(function(x, y) {
            !whileDraggingRef.current && $a60ed7403450fe58$var$invariant(false);
            var scroll = {
                x: x,
                y: y
            };
            marshal.updateDroppableScroll(descriptor.id, scroll);
        });
    }, [
        descriptor.id,
        marshal
    ]);
    var getClosestScroll = (0, $3PiUj.useCallback)(function() {
        var dragging = whileDraggingRef.current;
        if (!dragging || !dragging.env.closestScrollable) return $a60ed7403450fe58$var$origin;
        return $a60ed7403450fe58$var$getScroll$1(dragging.env.closestScrollable);
    }, []);
    var updateScroll = (0, $3PiUj.useCallback)(function() {
        var scroll = getClosestScroll();
        memoizedUpdateScroll(scroll.x, scroll.y);
    }, [
        getClosestScroll,
        memoizedUpdateScroll
    ]);
    var scheduleScrollUpdate = (0, $3PiUj.useMemo)(function() {
        return (0, $lqlwE.default)(updateScroll);
    }, [
        updateScroll
    ]);
    var onClosestScroll = (0, $3PiUj.useCallback)(function() {
        var dragging = whileDraggingRef.current;
        var closest = $a60ed7403450fe58$var$getClosestScrollableFromDrag(dragging);
        !(dragging && closest) && $a60ed7403450fe58$var$invariant(false);
        var options = dragging.scrollOptions;
        if (options.shouldPublishImmediately) {
            updateScroll();
            return;
        }
        scheduleScrollUpdate();
    }, [
        scheduleScrollUpdate,
        updateScroll
    ]);
    var getDimensionAndWatchScroll = (0, $3PiUj.useCallback)(function(windowScroll, options) {
        !!whileDraggingRef.current && $a60ed7403450fe58$var$invariant(false);
        var previous = previousRef.current;
        var ref = previous.getDroppableRef();
        !ref && $a60ed7403450fe58$var$invariant(false);
        var env = $a60ed7403450fe58$var$getEnv(ref);
        var dragging = {
            ref: ref,
            descriptor: descriptor,
            env: env,
            scrollOptions: options
        };
        whileDraggingRef.current = dragging;
        var dimension = $a60ed7403450fe58$var$getDimension({
            ref: ref,
            descriptor: descriptor,
            env: env,
            windowScroll: windowScroll,
            direction: previous.direction,
            isDropDisabled: previous.isDropDisabled,
            isCombineEnabled: previous.isCombineEnabled,
            shouldClipSubject: !previous.ignoreContainerClipping
        });
        var scrollable = env.closestScrollable;
        if (scrollable) {
            scrollable.setAttribute($a60ed7403450fe58$var$scrollContainer.contextId, appContext.contextId);
            scrollable.addEventListener("scroll", onClosestScroll, $a60ed7403450fe58$var$getListenerOptions(dragging.scrollOptions));
        }
        return dimension;
    }, [
        appContext.contextId,
        descriptor,
        onClosestScroll,
        previousRef
    ]);
    var getScrollWhileDragging = (0, $3PiUj.useCallback)(function() {
        var dragging = whileDraggingRef.current;
        var closest = $a60ed7403450fe58$var$getClosestScrollableFromDrag(dragging);
        !(dragging && closest) && $a60ed7403450fe58$var$invariant(false);
        return $a60ed7403450fe58$var$getScroll$1(closest);
    }, []);
    var dragStopped = (0, $3PiUj.useCallback)(function() {
        var dragging = whileDraggingRef.current;
        !dragging && $a60ed7403450fe58$var$invariant(false);
        var closest = $a60ed7403450fe58$var$getClosestScrollableFromDrag(dragging);
        whileDraggingRef.current = null;
        if (!closest) return;
        scheduleScrollUpdate.cancel();
        closest.removeAttribute($a60ed7403450fe58$var$scrollContainer.contextId);
        closest.removeEventListener("scroll", onClosestScroll, $a60ed7403450fe58$var$getListenerOptions(dragging.scrollOptions));
    }, [
        onClosestScroll,
        scheduleScrollUpdate
    ]);
    var scroll = (0, $3PiUj.useCallback)(function(change) {
        var dragging = whileDraggingRef.current;
        !dragging && $a60ed7403450fe58$var$invariant(false);
        var closest = $a60ed7403450fe58$var$getClosestScrollableFromDrag(dragging);
        !closest && $a60ed7403450fe58$var$invariant(false);
        closest.scrollTop += change.y;
        closest.scrollLeft += change.x;
    }, []);
    var callbacks = (0, $3PiUj.useMemo)(function() {
        return {
            getDimensionAndWatchScroll: getDimensionAndWatchScroll,
            getScrollWhileDragging: getScrollWhileDragging,
            dragStopped: dragStopped,
            scroll: scroll
        };
    }, [
        dragStopped,
        getDimensionAndWatchScroll,
        getScrollWhileDragging,
        scroll
    ]);
    var entry = (0, $3PiUj.useMemo)(function() {
        return {
            uniqueId: uniqueId,
            descriptor: descriptor,
            callbacks: callbacks
        };
    }, [
        callbacks,
        descriptor,
        uniqueId
    ]);
    $a60ed7403450fe58$var$useIsomorphicLayoutEffect(function() {
        publishedDescriptorRef.current = entry.descriptor;
        registry.droppable.register(entry);
        return function() {
            if (whileDraggingRef.current) dragStopped();
            registry.droppable.unregister(entry);
        };
    }, [
        callbacks,
        descriptor,
        dragStopped,
        entry,
        marshal,
        registry.droppable
    ]);
    $a60ed7403450fe58$var$useIsomorphicLayoutEffect(function() {
        if (!whileDraggingRef.current) return;
        marshal.updateDroppableIsEnabled(publishedDescriptorRef.current.id, !args.isDropDisabled);
    }, [
        args.isDropDisabled,
        marshal
    ]);
    $a60ed7403450fe58$var$useIsomorphicLayoutEffect(function() {
        if (!whileDraggingRef.current) return;
        marshal.updateDroppableIsCombineEnabled(publishedDescriptorRef.current.id, args.isCombineEnabled);
    }, [
        args.isCombineEnabled,
        marshal
    ]);
}
function $a60ed7403450fe58$var$noop$2() {}
var $a60ed7403450fe58$var$empty = {
    width: 0,
    height: 0,
    margin: $a60ed7403450fe58$var$noSpacing
};
var $a60ed7403450fe58$var$getSize = function getSize(_ref) {
    var isAnimatingOpenOnMount = _ref.isAnimatingOpenOnMount, placeholder = _ref.placeholder, animate = _ref.animate;
    if (isAnimatingOpenOnMount) return $a60ed7403450fe58$var$empty;
    if (animate === "close") return $a60ed7403450fe58$var$empty;
    return {
        height: placeholder.client.borderBox.height,
        width: placeholder.client.borderBox.width,
        margin: placeholder.client.margin
    };
};
var $a60ed7403450fe58$var$getStyle = function getStyle(_ref2) {
    var isAnimatingOpenOnMount = _ref2.isAnimatingOpenOnMount, placeholder = _ref2.placeholder, animate = _ref2.animate;
    var size = $a60ed7403450fe58$var$getSize({
        isAnimatingOpenOnMount: isAnimatingOpenOnMount,
        placeholder: placeholder,
        animate: animate
    });
    return {
        display: placeholder.display,
        boxSizing: "border-box",
        width: size.width,
        height: size.height,
        marginTop: size.margin.top,
        marginRight: size.margin.right,
        marginBottom: size.margin.bottom,
        marginLeft: size.margin.left,
        flexShrink: "0",
        flexGrow: "0",
        pointerEvents: "none",
        transition: animate !== "none" ? $a60ed7403450fe58$var$transitions.placeholder : null
    };
};
function $a60ed7403450fe58$var$Placeholder(props) {
    var animateOpenTimerRef = (0, $eeH7J.useRef)(null);
    var tryClearAnimateOpenTimer = (0, $3PiUj.useCallback)(function() {
        if (!animateOpenTimerRef.current) return;
        clearTimeout(animateOpenTimerRef.current);
        animateOpenTimerRef.current = null;
    }, []);
    var animate = props.animate, onTransitionEnd = props.onTransitionEnd, onClose = props.onClose, contextId = props.contextId;
    var _useState = (0, $eeH7J.useState)(props.animate === "open"), isAnimatingOpenOnMount = _useState[0], setIsAnimatingOpenOnMount = _useState[1];
    (0, $eeH7J.useEffect)(function() {
        if (!isAnimatingOpenOnMount) return $a60ed7403450fe58$var$noop$2;
        if (animate !== "open") {
            tryClearAnimateOpenTimer();
            setIsAnimatingOpenOnMount(false);
            return $a60ed7403450fe58$var$noop$2;
        }
        if (animateOpenTimerRef.current) return $a60ed7403450fe58$var$noop$2;
        animateOpenTimerRef.current = setTimeout(function() {
            animateOpenTimerRef.current = null;
            setIsAnimatingOpenOnMount(false);
        });
        return tryClearAnimateOpenTimer;
    }, [
        animate,
        isAnimatingOpenOnMount,
        tryClearAnimateOpenTimer
    ]);
    var onSizeChangeEnd = (0, $3PiUj.useCallback)(function(event) {
        if (event.propertyName !== "height") return;
        onTransitionEnd();
        if (animate === "close") onClose();
    }, [
        animate,
        onClose,
        onTransitionEnd
    ]);
    var style = $a60ed7403450fe58$var$getStyle({
        isAnimatingOpenOnMount: isAnimatingOpenOnMount,
        animate: props.animate,
        placeholder: props.placeholder
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement(props.placeholder.tagName, {
        style: style,
        "data-rbd-placeholder-context-id": contextId,
        onTransitionEnd: onSizeChangeEnd,
        ref: props.innerRef
    });
}
var $a60ed7403450fe58$var$Placeholder$1 = (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).memo($a60ed7403450fe58$var$Placeholder);
var $a60ed7403450fe58$var$DroppableContext = (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createContext(null);
function $a60ed7403450fe58$var$checkIsValidInnerRef(el) {
    !(el && $a60ed7403450fe58$var$isHtmlElement(el)) && $a60ed7403450fe58$var$invariant(false);
}
function $a60ed7403450fe58$var$isBoolean(value) {
    return typeof value === "boolean";
}
function $a60ed7403450fe58$var$runChecks(args, checks) {
    checks.forEach(function(check) {
        return check(args);
    });
}
var $a60ed7403450fe58$var$shared = [
    function required(_ref) {
        var props = _ref.props;
        !props.droppableId && $a60ed7403450fe58$var$invariant(false);
        !(typeof props.droppableId === "string") && $a60ed7403450fe58$var$invariant(false);
    },
    function _boolean(_ref2) {
        var props = _ref2.props;
        !$a60ed7403450fe58$var$isBoolean(props.isDropDisabled) && $a60ed7403450fe58$var$invariant(false);
        !$a60ed7403450fe58$var$isBoolean(props.isCombineEnabled) && $a60ed7403450fe58$var$invariant(false);
        !$a60ed7403450fe58$var$isBoolean(props.ignoreContainerClipping) && $a60ed7403450fe58$var$invariant(false);
    },
    function ref(_ref3) {
        var getDroppableRef = _ref3.getDroppableRef;
        $a60ed7403450fe58$var$checkIsValidInnerRef(getDroppableRef());
    }
];
var $a60ed7403450fe58$var$standard = [
    function placeholder(_ref4) {
        var props = _ref4.props, getPlaceholderRef = _ref4.getPlaceholderRef;
        if (!props.placeholder) return;
        var ref = getPlaceholderRef();
        if (ref) return;
    }
];
var $a60ed7403450fe58$var$virtual = [
    function hasClone(_ref5) {
        var props = _ref5.props;
        !props.renderClone && $a60ed7403450fe58$var$invariant(false);
    },
    function hasNoPlaceholder(_ref6) {
        var getPlaceholderRef = _ref6.getPlaceholderRef;
        !!getPlaceholderRef() && $a60ed7403450fe58$var$invariant(false);
    }
];
function $a60ed7403450fe58$var$useValidation(args) {
    $a60ed7403450fe58$var$useDevSetupWarning(function() {
        $a60ed7403450fe58$var$runChecks(args, $a60ed7403450fe58$var$shared);
        if (args.props.mode === "standard") $a60ed7403450fe58$var$runChecks(args, $a60ed7403450fe58$var$standard);
        if (args.props.mode === "virtual") $a60ed7403450fe58$var$runChecks(args, $a60ed7403450fe58$var$virtual);
    });
}
var $a60ed7403450fe58$var$AnimateInOut = function(_React$PureComponent) {
    (0, $ltdWF.default)(AnimateInOut, _React$PureComponent);
    function AnimateInOut() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$PureComponent.call.apply(_React$PureComponent, [
            this
        ].concat(args)) || this;
        _this.state = {
            isVisible: Boolean(_this.props.on),
            data: _this.props.on,
            animate: _this.props.shouldAnimate && _this.props.on ? "open" : "none"
        };
        _this.onClose = function() {
            if (_this.state.animate !== "close") return;
            _this.setState({
                isVisible: false
            });
        };
        return _this;
    }
    AnimateInOut.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
        if (!props.shouldAnimate) return {
            isVisible: Boolean(props.on),
            data: props.on,
            animate: "none"
        };
        if (props.on) return {
            isVisible: true,
            data: props.on,
            animate: "open"
        };
        if (state.isVisible) return {
            isVisible: true,
            data: state.data,
            animate: "close"
        };
        return {
            isVisible: false,
            animate: "close",
            data: null
        };
    };
    var _proto = AnimateInOut.prototype;
    _proto.render = function render() {
        if (!this.state.isVisible) return null;
        var provided = {
            onClose: this.onClose,
            data: this.state.data,
            animate: this.state.animate
        };
        return this.props.children(provided);
    };
    return AnimateInOut;
}((0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).PureComponent);
var $a60ed7403450fe58$var$zIndexOptions = {
    dragging: 5000,
    dropAnimating: 4500
};
var $a60ed7403450fe58$var$getDraggingTransition = function getDraggingTransition(shouldAnimateDragMovement, dropping) {
    if (dropping) return $a60ed7403450fe58$var$transitions.drop(dropping.duration);
    if (shouldAnimateDragMovement) return $a60ed7403450fe58$var$transitions.snap;
    return $a60ed7403450fe58$var$transitions.fluid;
};
var $a60ed7403450fe58$var$getDraggingOpacity = function getDraggingOpacity(isCombining, isDropAnimating) {
    if (!isCombining) return null;
    return isDropAnimating ? $a60ed7403450fe58$var$combine.opacity.drop : $a60ed7403450fe58$var$combine.opacity.combining;
};
var $a60ed7403450fe58$var$getShouldDraggingAnimate = function getShouldDraggingAnimate(dragging) {
    if (dragging.forceShouldAnimate != null) return dragging.forceShouldAnimate;
    return dragging.mode === "SNAP";
};
function $a60ed7403450fe58$var$getDraggingStyle(dragging) {
    var dimension = dragging.dimension;
    var box = dimension.client;
    var offset = dragging.offset, combineWith = dragging.combineWith, dropping = dragging.dropping;
    var isCombining = Boolean(combineWith);
    var shouldAnimate = $a60ed7403450fe58$var$getShouldDraggingAnimate(dragging);
    var isDropAnimating = Boolean(dropping);
    var transform = isDropAnimating ? $a60ed7403450fe58$var$transforms.drop(offset, isCombining) : $a60ed7403450fe58$var$transforms.moveTo(offset);
    var style = {
        position: "fixed",
        top: box.marginBox.top,
        left: box.marginBox.left,
        boxSizing: "border-box",
        width: box.borderBox.width,
        height: box.borderBox.height,
        transition: $a60ed7403450fe58$var$getDraggingTransition(shouldAnimate, dropping),
        transform: transform,
        opacity: $a60ed7403450fe58$var$getDraggingOpacity(isCombining, isDropAnimating),
        zIndex: isDropAnimating ? $a60ed7403450fe58$var$zIndexOptions.dropAnimating : $a60ed7403450fe58$var$zIndexOptions.dragging,
        pointerEvents: "none"
    };
    return style;
}
function $a60ed7403450fe58$var$getSecondaryStyle(secondary) {
    return {
        transform: $a60ed7403450fe58$var$transforms.moveTo(secondary.offset),
        transition: secondary.shouldAnimateDisplacement ? null : "none"
    };
}
function $a60ed7403450fe58$var$getStyle$1(mapped) {
    return mapped.type === "DRAGGING" ? $a60ed7403450fe58$var$getDraggingStyle(mapped) : $a60ed7403450fe58$var$getSecondaryStyle(mapped);
}
function $a60ed7403450fe58$var$getDimension$1(descriptor, el, windowScroll) {
    if (windowScroll === void 0) windowScroll = $a60ed7403450fe58$var$origin;
    var computedStyles = window.getComputedStyle(el);
    var borderBox = el.getBoundingClientRect();
    var client = (0, $4J1sD.calculateBox)(borderBox, computedStyles);
    var page = (0, $4J1sD.withScroll)(client, windowScroll);
    var placeholder = {
        client: client,
        tagName: el.tagName.toLowerCase(),
        display: computedStyles.display
    };
    var displaceBy = {
        x: client.marginBox.width,
        y: client.marginBox.height
    };
    var dimension = {
        descriptor: descriptor,
        placeholder: placeholder,
        displaceBy: displaceBy,
        client: client,
        page: page
    };
    return dimension;
}
function $a60ed7403450fe58$var$useDraggablePublisher(args) {
    var uniqueId = $a60ed7403450fe58$var$useUniqueId("draggable");
    var descriptor = args.descriptor, registry = args.registry, getDraggableRef = args.getDraggableRef, canDragInteractiveElements = args.canDragInteractiveElements, shouldRespectForcePress = args.shouldRespectForcePress, isEnabled = args.isEnabled;
    var options = (0, $3PiUj.useMemo)(function() {
        return {
            canDragInteractiveElements: canDragInteractiveElements,
            shouldRespectForcePress: shouldRespectForcePress,
            isEnabled: isEnabled
        };
    }, [
        canDragInteractiveElements,
        isEnabled,
        shouldRespectForcePress
    ]);
    var getDimension = (0, $3PiUj.useCallback)(function(windowScroll) {
        var el = getDraggableRef();
        !el && $a60ed7403450fe58$var$invariant(false);
        return $a60ed7403450fe58$var$getDimension$1(descriptor, el, windowScroll);
    }, [
        descriptor,
        getDraggableRef
    ]);
    var entry = (0, $3PiUj.useMemo)(function() {
        return {
            uniqueId: uniqueId,
            descriptor: descriptor,
            options: options,
            getDimension: getDimension
        };
    }, [
        descriptor,
        getDimension,
        options,
        uniqueId
    ]);
    var publishedRef = (0, $eeH7J.useRef)(entry);
    var isFirstPublishRef = (0, $eeH7J.useRef)(true);
    $a60ed7403450fe58$var$useIsomorphicLayoutEffect(function() {
        registry.draggable.register(publishedRef.current);
        return function() {
            return registry.draggable.unregister(publishedRef.current);
        };
    }, [
        registry.draggable
    ]);
    $a60ed7403450fe58$var$useIsomorphicLayoutEffect(function() {
        if (isFirstPublishRef.current) {
            isFirstPublishRef.current = false;
            return;
        }
        var last = publishedRef.current;
        publishedRef.current = entry;
        registry.draggable.update(entry, last);
    }, [
        entry,
        registry.draggable
    ]);
}
function $a60ed7403450fe58$var$useValidation$1(props, contextId, getRef) {
    $a60ed7403450fe58$var$useDevSetupWarning(function() {
        function prefix(id) {
            return "Draggable[id: " + id + "]: ";
        }
        var id = props.draggableId;
        !id && $a60ed7403450fe58$var$invariant(false);
        !(typeof id === "string") && $a60ed7403450fe58$var$invariant(false);
        !$a60ed7403450fe58$var$isInteger(props.index) && $a60ed7403450fe58$var$invariant(false);
        if (props.mapped.type === "DRAGGING") return;
        $a60ed7403450fe58$var$checkIsValidInnerRef(getRef());
        if (props.isEnabled) !$a60ed7403450fe58$var$findDragHandle(contextId, id) && $a60ed7403450fe58$var$invariant(false);
    });
}
function $a60ed7403450fe58$var$useClonePropValidation(isClone) {
    $a60ed7403450fe58$var$useDev(function() {
        var initialRef = (0, $eeH7J.useRef)(isClone);
        $a60ed7403450fe58$var$useDevSetupWarning(function() {
            !(isClone === initialRef.current) && $a60ed7403450fe58$var$invariant(false);
        }, [
            isClone
        ]);
    });
}
function $a60ed7403450fe58$var$preventHtml5Dnd(event) {
    event.preventDefault();
}
function $a60ed7403450fe58$var$Draggable(props) {
    var ref = (0, $eeH7J.useRef)(null);
    var setRef = (0, $3PiUj.useCallback)(function(el) {
        ref.current = el;
    }, []);
    var getRef = (0, $3PiUj.useCallback)(function() {
        return ref.current;
    }, []);
    var _useRequiredContext = $a60ed7403450fe58$var$useRequiredContext($a60ed7403450fe58$var$AppContext), contextId = _useRequiredContext.contextId, dragHandleUsageInstructionsId = _useRequiredContext.dragHandleUsageInstructionsId, registry = _useRequiredContext.registry;
    var _useRequiredContext2 = $a60ed7403450fe58$var$useRequiredContext($a60ed7403450fe58$var$DroppableContext), type = _useRequiredContext2.type, droppableId = _useRequiredContext2.droppableId;
    var descriptor = (0, $3PiUj.useMemo)(function() {
        return {
            id: props.draggableId,
            index: props.index,
            type: type,
            droppableId: droppableId
        };
    }, [
        props.draggableId,
        props.index,
        type,
        droppableId
    ]);
    var children = props.children, draggableId = props.draggableId, isEnabled = props.isEnabled, shouldRespectForcePress = props.shouldRespectForcePress, canDragInteractiveElements = props.canDragInteractiveElements, isClone = props.isClone, mapped = props.mapped, dropAnimationFinishedAction = props.dropAnimationFinished;
    $a60ed7403450fe58$var$useValidation$1(props, contextId, getRef);
    $a60ed7403450fe58$var$useClonePropValidation(isClone);
    if (!isClone) {
        var forPublisher = (0, $3PiUj.useMemo)(function() {
            return {
                descriptor: descriptor,
                registry: registry,
                getDraggableRef: getRef,
                canDragInteractiveElements: canDragInteractiveElements,
                shouldRespectForcePress: shouldRespectForcePress,
                isEnabled: isEnabled
            };
        }, [
            descriptor,
            registry,
            getRef,
            canDragInteractiveElements,
            shouldRespectForcePress,
            isEnabled
        ]);
        $a60ed7403450fe58$var$useDraggablePublisher(forPublisher);
    }
    var dragHandleProps = (0, $3PiUj.useMemo)(function() {
        return isEnabled ? {
            tabIndex: 0,
            role: "button",
            "aria-describedby": dragHandleUsageInstructionsId,
            "data-rbd-drag-handle-draggable-id": draggableId,
            "data-rbd-drag-handle-context-id": contextId,
            draggable: false,
            onDragStart: $a60ed7403450fe58$var$preventHtml5Dnd
        } : null;
    }, [
        contextId,
        dragHandleUsageInstructionsId,
        draggableId,
        isEnabled
    ]);
    var onMoveEnd = (0, $3PiUj.useCallback)(function(event) {
        if (mapped.type !== "DRAGGING") return;
        if (!mapped.dropping) return;
        if (event.propertyName !== "transform") return;
        dropAnimationFinishedAction();
    }, [
        dropAnimationFinishedAction,
        mapped
    ]);
    var provided = (0, $3PiUj.useMemo)(function() {
        var style = $a60ed7403450fe58$var$getStyle$1(mapped);
        var onTransitionEnd = mapped.type === "DRAGGING" && mapped.dropping ? onMoveEnd : null;
        var result = {
            innerRef: setRef,
            draggableProps: {
                "data-rbd-draggable-context-id": contextId,
                "data-rbd-draggable-id": draggableId,
                style: style,
                onTransitionEnd: onTransitionEnd
            },
            dragHandleProps: dragHandleProps
        };
        return result;
    }, [
        contextId,
        dragHandleProps,
        draggableId,
        mapped,
        onMoveEnd,
        setRef
    ]);
    var rubric = (0, $3PiUj.useMemo)(function() {
        return {
            draggableId: descriptor.id,
            type: descriptor.type,
            source: {
                index: descriptor.index,
                droppableId: descriptor.droppableId
            }
        };
    }, [
        descriptor.droppableId,
        descriptor.id,
        descriptor.index,
        descriptor.type
    ]);
    return children(provided, mapped.snapshot, rubric);
}
var $a60ed7403450fe58$var$isStrictEqual = function(a, b) {
    return a === b;
};
var $a60ed7403450fe58$var$whatIsDraggedOverFromResult = function(result) {
    var combine = result.combine, destination = result.destination;
    if (destination) return destination.droppableId;
    if (combine) return combine.droppableId;
    return null;
};
var $a60ed7403450fe58$var$getCombineWithFromResult = function getCombineWithFromResult(result) {
    return result.combine ? result.combine.draggableId : null;
};
var $a60ed7403450fe58$var$getCombineWithFromImpact = function getCombineWithFromImpact(impact) {
    return impact.at && impact.at.type === "COMBINE" ? impact.at.combine.draggableId : null;
};
function $a60ed7403450fe58$var$getDraggableSelector() {
    var memoizedOffset = (0, $kQ1m2.default)(function(x, y) {
        return {
            x: x,
            y: y
        };
    });
    var getMemoizedSnapshot = (0, $kQ1m2.default)(function(mode, isClone, draggingOver, combineWith, dropping) {
        return {
            isDragging: true,
            isClone: isClone,
            isDropAnimating: Boolean(dropping),
            dropAnimation: dropping,
            mode: mode,
            draggingOver: draggingOver,
            combineWith: combineWith,
            combineTargetFor: null
        };
    });
    var getMemoizedProps = (0, $kQ1m2.default)(function(offset, mode, dimension, isClone, draggingOver, combineWith, forceShouldAnimate) {
        return {
            mapped: {
                type: "DRAGGING",
                dropping: null,
                draggingOver: draggingOver,
                combineWith: combineWith,
                mode: mode,
                offset: offset,
                dimension: dimension,
                forceShouldAnimate: forceShouldAnimate,
                snapshot: getMemoizedSnapshot(mode, isClone, draggingOver, combineWith, null)
            }
        };
    });
    var selector = function selector(state, ownProps) {
        if (state.isDragging) {
            if (state.critical.draggable.id !== ownProps.draggableId) return null;
            var offset = state.current.client.offset;
            var dimension = state.dimensions.draggables[ownProps.draggableId];
            var draggingOver = $a60ed7403450fe58$var$whatIsDraggedOver(state.impact);
            var combineWith = $a60ed7403450fe58$var$getCombineWithFromImpact(state.impact);
            var forceShouldAnimate = state.forceShouldAnimate;
            return getMemoizedProps(memoizedOffset(offset.x, offset.y), state.movementMode, dimension, ownProps.isClone, draggingOver, combineWith, forceShouldAnimate);
        }
        if (state.phase === "DROP_ANIMATING") {
            var completed = state.completed;
            if (completed.result.draggableId !== ownProps.draggableId) return null;
            var isClone = ownProps.isClone;
            var _dimension = state.dimensions.draggables[ownProps.draggableId];
            var result = completed.result;
            var mode = result.mode;
            var _draggingOver = $a60ed7403450fe58$var$whatIsDraggedOverFromResult(result);
            var _combineWith = $a60ed7403450fe58$var$getCombineWithFromResult(result);
            var duration = state.dropDuration;
            var dropping = {
                duration: duration,
                curve: $a60ed7403450fe58$var$curves.drop,
                moveTo: state.newHomeClientOffset,
                opacity: _combineWith ? $a60ed7403450fe58$var$combine.opacity.drop : null,
                scale: _combineWith ? $a60ed7403450fe58$var$combine.scale.drop : null
            };
            return {
                mapped: {
                    type: "DRAGGING",
                    offset: state.newHomeClientOffset,
                    dimension: _dimension,
                    dropping: dropping,
                    draggingOver: _draggingOver,
                    combineWith: _combineWith,
                    mode: mode,
                    forceShouldAnimate: null,
                    snapshot: getMemoizedSnapshot(mode, isClone, _draggingOver, _combineWith, dropping)
                }
            };
        }
        return null;
    };
    return selector;
}
function $a60ed7403450fe58$var$getSecondarySnapshot(combineTargetFor) {
    return {
        isDragging: false,
        isDropAnimating: false,
        isClone: false,
        dropAnimation: null,
        mode: null,
        draggingOver: null,
        combineTargetFor: combineTargetFor,
        combineWith: null
    };
}
var $a60ed7403450fe58$var$atRest = {
    mapped: {
        type: "SECONDARY",
        offset: $a60ed7403450fe58$var$origin,
        combineTargetFor: null,
        shouldAnimateDisplacement: true,
        snapshot: $a60ed7403450fe58$var$getSecondarySnapshot(null)
    }
};
function $a60ed7403450fe58$var$getSecondarySelector() {
    var memoizedOffset = (0, $kQ1m2.default)(function(x, y) {
        return {
            x: x,
            y: y
        };
    });
    var getMemoizedSnapshot = (0, $kQ1m2.default)($a60ed7403450fe58$var$getSecondarySnapshot);
    var getMemoizedProps = (0, $kQ1m2.default)(function(offset, combineTargetFor, shouldAnimateDisplacement) {
        if (combineTargetFor === void 0) combineTargetFor = null;
        return {
            mapped: {
                type: "SECONDARY",
                offset: offset,
                combineTargetFor: combineTargetFor,
                shouldAnimateDisplacement: shouldAnimateDisplacement,
                snapshot: getMemoizedSnapshot(combineTargetFor)
            }
        };
    });
    var getFallback = function getFallback(combineTargetFor) {
        return combineTargetFor ? getMemoizedProps($a60ed7403450fe58$var$origin, combineTargetFor, true) : null;
    };
    var getProps = function getProps(ownId, draggingId, impact, afterCritical) {
        var visualDisplacement = impact.displaced.visible[ownId];
        var isAfterCriticalInVirtualList = Boolean(afterCritical.inVirtualList && afterCritical.effected[ownId]);
        var combine = $a60ed7403450fe58$var$tryGetCombine(impact);
        var combineTargetFor = combine && combine.draggableId === ownId ? draggingId : null;
        if (!visualDisplacement) {
            if (!isAfterCriticalInVirtualList) return getFallback(combineTargetFor);
            if (impact.displaced.invisible[ownId]) return null;
            var change = $a60ed7403450fe58$var$negate(afterCritical.displacedBy.point);
            var _offset = memoizedOffset(change.x, change.y);
            return getMemoizedProps(_offset, combineTargetFor, true);
        }
        if (isAfterCriticalInVirtualList) return getFallback(combineTargetFor);
        var displaceBy = impact.displacedBy.point;
        var offset = memoizedOffset(displaceBy.x, displaceBy.y);
        return getMemoizedProps(offset, combineTargetFor, visualDisplacement.shouldAnimate);
    };
    var selector = function selector(state, ownProps) {
        if (state.isDragging) {
            if (state.critical.draggable.id === ownProps.draggableId) return null;
            return getProps(ownProps.draggableId, state.critical.draggable.id, state.impact, state.afterCritical);
        }
        if (state.phase === "DROP_ANIMATING") {
            var completed = state.completed;
            if (completed.result.draggableId === ownProps.draggableId) return null;
            return getProps(ownProps.draggableId, completed.result.draggableId, completed.impact, completed.afterCritical);
        }
        return null;
    };
    return selector;
}
var $a60ed7403450fe58$var$makeMapStateToProps = function makeMapStateToProps() {
    var draggingSelector = $a60ed7403450fe58$var$getDraggableSelector();
    var secondarySelector = $a60ed7403450fe58$var$getSecondarySelector();
    var selector = function selector(state, ownProps) {
        return draggingSelector(state, ownProps) || secondarySelector(state, ownProps) || $a60ed7403450fe58$var$atRest;
    };
    return selector;
};
var $a60ed7403450fe58$var$mapDispatchToProps = {
    dropAnimationFinished: $a60ed7403450fe58$var$dropAnimationFinished
};
var $a60ed7403450fe58$var$ConnectedDraggable = (0, $9DfAu.default)($a60ed7403450fe58$var$makeMapStateToProps, $a60ed7403450fe58$var$mapDispatchToProps, null, {
    context: $a60ed7403450fe58$var$StoreContext,
    pure: true,
    areStatePropsEqual: $a60ed7403450fe58$var$isStrictEqual
})($a60ed7403450fe58$var$Draggable);
function $a60ed7403450fe58$var$PrivateDraggable(props) {
    var droppableContext = $a60ed7403450fe58$var$useRequiredContext($a60ed7403450fe58$var$DroppableContext);
    var isUsingCloneFor = droppableContext.isUsingCloneFor;
    if (isUsingCloneFor === props.draggableId && !props.isClone) return null;
    return (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement($a60ed7403450fe58$var$ConnectedDraggable, props);
}
function $a60ed7403450fe58$export$f2a139e5d18b9882(props) {
    var isEnabled = typeof props.isDragDisabled === "boolean" ? !props.isDragDisabled : true;
    var canDragInteractiveElements = Boolean(props.disableInteractiveElementBlocking);
    var shouldRespectForcePress = Boolean(props.shouldRespectForcePress);
    return (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement($a60ed7403450fe58$var$PrivateDraggable, (0, $h4XE0.default)({}, props, {
        isClone: false,
        isEnabled: isEnabled,
        canDragInteractiveElements: canDragInteractiveElements,
        shouldRespectForcePress: shouldRespectForcePress
    }));
}
function $a60ed7403450fe58$var$Droppable(props) {
    var appContext = (0, $eeH7J.useContext)($a60ed7403450fe58$var$AppContext);
    !appContext && $a60ed7403450fe58$var$invariant(false);
    var contextId = appContext.contextId, isMovementAllowed = appContext.isMovementAllowed;
    var droppableRef = (0, $eeH7J.useRef)(null);
    var placeholderRef = (0, $eeH7J.useRef)(null);
    var children = props.children, droppableId = props.droppableId, type = props.type, mode = props.mode, direction = props.direction, ignoreContainerClipping = props.ignoreContainerClipping, isDropDisabled = props.isDropDisabled, isCombineEnabled = props.isCombineEnabled, snapshot = props.snapshot, useClone = props.useClone, updateViewportMaxScroll = props.updateViewportMaxScroll, getContainerForClone = props.getContainerForClone;
    var getDroppableRef = (0, $3PiUj.useCallback)(function() {
        return droppableRef.current;
    }, []);
    var setDroppableRef = (0, $3PiUj.useCallback)(function(value) {
        droppableRef.current = value;
    }, []);
    var getPlaceholderRef = (0, $3PiUj.useCallback)(function() {
        return placeholderRef.current;
    }, []);
    var setPlaceholderRef = (0, $3PiUj.useCallback)(function(value) {
        placeholderRef.current = value;
    }, []);
    $a60ed7403450fe58$var$useValidation({
        props: props,
        getDroppableRef: getDroppableRef,
        getPlaceholderRef: getPlaceholderRef
    });
    var onPlaceholderTransitionEnd = (0, $3PiUj.useCallback)(function() {
        if (isMovementAllowed()) updateViewportMaxScroll({
            maxScroll: $a60ed7403450fe58$var$getMaxWindowScroll()
        });
    }, [
        isMovementAllowed,
        updateViewportMaxScroll
    ]);
    $a60ed7403450fe58$var$useDroppablePublisher({
        droppableId: droppableId,
        type: type,
        mode: mode,
        direction: direction,
        isDropDisabled: isDropDisabled,
        isCombineEnabled: isCombineEnabled,
        ignoreContainerClipping: ignoreContainerClipping,
        getDroppableRef: getDroppableRef
    });
    var placeholder = (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement($a60ed7403450fe58$var$AnimateInOut, {
        on: props.placeholder,
        shouldAnimate: props.shouldAnimatePlaceholder
    }, function(_ref) {
        var onClose = _ref.onClose, data = _ref.data, animate = _ref.animate;
        return (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement($a60ed7403450fe58$var$Placeholder$1, {
            placeholder: data,
            onClose: onClose,
            innerRef: setPlaceholderRef,
            animate: animate,
            contextId: contextId,
            onTransitionEnd: onPlaceholderTransitionEnd
        });
    });
    var provided = (0, $3PiUj.useMemo)(function() {
        return {
            innerRef: setDroppableRef,
            placeholder: placeholder,
            droppableProps: {
                "data-rbd-droppable-id": droppableId,
                "data-rbd-droppable-context-id": contextId
            }
        };
    }, [
        contextId,
        droppableId,
        placeholder,
        setDroppableRef
    ]);
    var isUsingCloneFor = useClone ? useClone.dragging.draggableId : null;
    var droppableContext = (0, $3PiUj.useMemo)(function() {
        return {
            droppableId: droppableId,
            type: type,
            isUsingCloneFor: isUsingCloneFor
        };
    }, [
        droppableId,
        isUsingCloneFor,
        type
    ]);
    function getClone() {
        if (!useClone) return null;
        var dragging = useClone.dragging, render = useClone.render;
        var node = (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement($a60ed7403450fe58$var$PrivateDraggable, {
            draggableId: dragging.draggableId,
            index: dragging.source.index,
            isClone: true,
            isEnabled: true,
            shouldRespectForcePress: false,
            canDragInteractiveElements: true
        }, function(draggableProvided, draggableSnapshot) {
            return render(draggableProvided, draggableSnapshot, dragging);
        });
        return (0, (/*@__PURE__*/$parcel$interopDefault($iMJCh))).createPortal(node, getContainerForClone());
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement($a60ed7403450fe58$var$DroppableContext.Provider, {
        value: droppableContext
    }, children(provided, snapshot), getClone());
}
var $a60ed7403450fe58$var$isMatchingType = function isMatchingType(type, critical) {
    return type === critical.droppable.type;
};
var $a60ed7403450fe58$var$getDraggable = function getDraggable(critical, dimensions) {
    return dimensions.draggables[critical.draggable.id];
};
var $a60ed7403450fe58$var$makeMapStateToProps$1 = function makeMapStateToProps() {
    var idleWithAnimation = {
        placeholder: null,
        shouldAnimatePlaceholder: true,
        snapshot: {
            isDraggingOver: false,
            draggingOverWith: null,
            draggingFromThisWith: null,
            isUsingPlaceholder: false
        },
        useClone: null
    };
    var idleWithoutAnimation = (0, $h4XE0.default)({}, idleWithAnimation, {
        shouldAnimatePlaceholder: false
    });
    var getDraggableRubric = (0, $kQ1m2.default)(function(descriptor) {
        return {
            draggableId: descriptor.id,
            type: descriptor.type,
            source: {
                index: descriptor.index,
                droppableId: descriptor.droppableId
            }
        };
    });
    var getMapProps = (0, $kQ1m2.default)(function(id, isEnabled, isDraggingOverForConsumer, isDraggingOverForImpact, dragging, renderClone) {
        var draggableId = dragging.descriptor.id;
        var isHome = dragging.descriptor.droppableId === id;
        if (isHome) {
            var useClone = renderClone ? {
                render: renderClone,
                dragging: getDraggableRubric(dragging.descriptor)
            } : null;
            var _snapshot = {
                isDraggingOver: isDraggingOverForConsumer,
                draggingOverWith: isDraggingOverForConsumer ? draggableId : null,
                draggingFromThisWith: draggableId,
                isUsingPlaceholder: true
            };
            return {
                placeholder: dragging.placeholder,
                shouldAnimatePlaceholder: false,
                snapshot: _snapshot,
                useClone: useClone
            };
        }
        if (!isEnabled) return idleWithoutAnimation;
        if (!isDraggingOverForImpact) return idleWithAnimation;
        var snapshot = {
            isDraggingOver: isDraggingOverForConsumer,
            draggingOverWith: draggableId,
            draggingFromThisWith: null,
            isUsingPlaceholder: true
        };
        return {
            placeholder: dragging.placeholder,
            shouldAnimatePlaceholder: true,
            snapshot: snapshot,
            useClone: null
        };
    });
    var selector = function selector(state, ownProps) {
        var id = ownProps.droppableId;
        var type = ownProps.type;
        var isEnabled = !ownProps.isDropDisabled;
        var renderClone = ownProps.renderClone;
        if (state.isDragging) {
            var critical = state.critical;
            if (!$a60ed7403450fe58$var$isMatchingType(type, critical)) return idleWithoutAnimation;
            var dragging = $a60ed7403450fe58$var$getDraggable(critical, state.dimensions);
            var isDraggingOver = $a60ed7403450fe58$var$whatIsDraggedOver(state.impact) === id;
            return getMapProps(id, isEnabled, isDraggingOver, isDraggingOver, dragging, renderClone);
        }
        if (state.phase === "DROP_ANIMATING") {
            var completed = state.completed;
            if (!$a60ed7403450fe58$var$isMatchingType(type, completed.critical)) return idleWithoutAnimation;
            var _dragging = $a60ed7403450fe58$var$getDraggable(completed.critical, state.dimensions);
            return getMapProps(id, isEnabled, $a60ed7403450fe58$var$whatIsDraggedOverFromResult(completed.result) === id, $a60ed7403450fe58$var$whatIsDraggedOver(completed.impact) === id, _dragging, renderClone);
        }
        if (state.phase === "IDLE" && state.completed && !state.shouldFlush) {
            var _completed = state.completed;
            if (!$a60ed7403450fe58$var$isMatchingType(type, _completed.critical)) return idleWithoutAnimation;
            var wasOver = $a60ed7403450fe58$var$whatIsDraggedOver(_completed.impact) === id;
            var wasCombining = Boolean(_completed.impact.at && _completed.impact.at.type === "COMBINE");
            var isHome = _completed.critical.droppable.id === id;
            if (wasOver) return wasCombining ? idleWithAnimation : idleWithoutAnimation;
            if (isHome) return idleWithAnimation;
            return idleWithoutAnimation;
        }
        return idleWithoutAnimation;
    };
    return selector;
};
var $a60ed7403450fe58$var$mapDispatchToProps$1 = {
    updateViewportMaxScroll: $a60ed7403450fe58$var$updateViewportMaxScroll
};
function $a60ed7403450fe58$var$getBody() {
    !document.body && $a60ed7403450fe58$var$invariant(false);
    return document.body;
}
var $a60ed7403450fe58$var$defaultProps = {
    mode: "standard",
    type: "DEFAULT",
    direction: "vertical",
    isDropDisabled: false,
    isCombineEnabled: false,
    ignoreContainerClipping: false,
    renderClone: null,
    getContainerForClone: $a60ed7403450fe58$var$getBody
};
var $a60ed7403450fe58$export$423ec2075359570a = (0, $9DfAu.default)($a60ed7403450fe58$var$makeMapStateToProps$1, $a60ed7403450fe58$var$mapDispatchToProps$1, null, {
    context: $a60ed7403450fe58$var$StoreContext,
    pure: true,
    areStatePropsEqual: $a60ed7403450fe58$var$isStrictEqual
})($a60ed7403450fe58$var$Droppable);
$a60ed7403450fe58$export$423ec2075359570a.defaultProps = $a60ed7403450fe58$var$defaultProps;

});
parcelRegister("jkmOZ", function(module, exports) {

$parcel$export(module.exports, "createStore", function () { return $e1219671f5307c35$export$f51a9068ac82ea43; });
$parcel$export(module.exports, "bindActionCreators", function () { return $e1219671f5307c35$export$aea084d96e84da92; });
$parcel$export(module.exports, "compose", function () { return $e1219671f5307c35$export$f672e0b6f7222cd7; });
$parcel$export(module.exports, "applyMiddleware", function () { return $e1219671f5307c35$export$9ff26e0402cc7b7; });

var $izHwz = parcelRequire("izHwz");
/**
 * Adapted from React: https://github.com/facebook/react/blob/master/packages/shared/formatProdErrorMessage.js
 *
 * Do not require this module directly! Use normal throw error calls. These messages will be replaced with error codes
 * during build.
 * @param {number} code
 */ function $e1219671f5307c35$var$formatProdErrorMessage(code) {
    return "Minified Redux error #" + code + "; visit https://redux.js.org/Errors?code=" + code + " for the full message or " + "use the non-minified dev environment for full errors. ";
}
// Inlined version of the `symbol-observable` polyfill
var $e1219671f5307c35$var$$$observable = function() {
    return typeof Symbol === "function" && Symbol.observable || "@@observable";
}();
/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */ var $e1219671f5307c35$var$randomString = function randomString() {
    return Math.random().toString(36).substring(7).split("").join(".");
};
var $e1219671f5307c35$export$4219e499db7ca678 = {
    INIT: "@@redux/INIT" + $e1219671f5307c35$var$randomString(),
    REPLACE: "@@redux/REPLACE" + $e1219671f5307c35$var$randomString(),
    PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
        return "@@redux/PROBE_UNKNOWN_ACTION" + $e1219671f5307c35$var$randomString();
    }
};
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function $e1219671f5307c35$var$isPlainObject(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    var proto = obj;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(obj) === proto;
}
// Inlined / shortened version of `kindOf` from https://github.com/jonschlinkert/kind-of
function $e1219671f5307c35$var$miniKindOf(val) {
    if (val === void 0) return "undefined";
    if (val === null) return "null";
    var type = typeof val;
    switch(type){
        case "boolean":
        case "string":
        case "number":
        case "symbol":
        case "function":
            return type;
    }
    if (Array.isArray(val)) return "array";
    if ($e1219671f5307c35$var$isDate(val)) return "date";
    if ($e1219671f5307c35$var$isError(val)) return "error";
    var constructorName = $e1219671f5307c35$var$ctorName(val);
    switch(constructorName){
        case "Symbol":
        case "Promise":
        case "WeakMap":
        case "WeakSet":
        case "Map":
        case "Set":
            return constructorName;
    } // other
    return type.slice(8, -1).toLowerCase().replace(/\s/g, "");
}
function $e1219671f5307c35$var$ctorName(val) {
    return typeof val.constructor === "function" ? val.constructor.name : null;
}
function $e1219671f5307c35$var$isError(val) {
    return val instanceof Error || typeof val.message === "string" && val.constructor && typeof val.constructor.stackTraceLimit === "number";
}
function $e1219671f5307c35$var$isDate(val) {
    if (val instanceof Date) return true;
    return typeof val.toDateString === "function" && typeof val.getDate === "function" && typeof val.setDate === "function";
}
function $e1219671f5307c35$var$kindOf(val) {
    var typeOfVal = typeof val;
    return typeOfVal;
}
/**
 * Creates a Redux store that holds the state tree.
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */ function $e1219671f5307c35$export$f51a9068ac82ea43(reducer, preloadedState, enhancer) {
    var _ref2;
    if (typeof preloadedState === "function" && typeof enhancer === "function" || typeof enhancer === "function" && typeof arguments[3] === "function") throw new Error($e1219671f5307c35$var$formatProdErrorMessage(0));
    if (typeof preloadedState === "function" && typeof enhancer === "undefined") {
        enhancer = preloadedState;
        preloadedState = undefined;
    }
    if (typeof enhancer !== "undefined") {
        if (typeof enhancer !== "function") throw new Error($e1219671f5307c35$var$formatProdErrorMessage(1));
        return enhancer($e1219671f5307c35$export$f51a9068ac82ea43)(reducer, preloadedState);
    }
    if (typeof reducer !== "function") throw new Error($e1219671f5307c35$var$formatProdErrorMessage(2));
    var currentReducer = reducer;
    var currentState = preloadedState;
    var currentListeners = [];
    var nextListeners = currentListeners;
    var isDispatching = false;
    /**
   * This makes a shallow copy of currentListeners so we can use
   * nextListeners as a temporary list while dispatching.
   *
   * This prevents any bugs around consumers calling
   * subscribe/unsubscribe in the middle of a dispatch.
   */ function ensureCanMutateNextListeners() {
        if (nextListeners === currentListeners) nextListeners = currentListeners.slice();
    }
    /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */ function getState() {
        if (isDispatching) throw new Error($e1219671f5307c35$var$formatProdErrorMessage(3));
        return currentState;
    }
    /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */ function subscribe(listener) {
        if (typeof listener !== "function") throw new Error($e1219671f5307c35$var$formatProdErrorMessage(4));
        if (isDispatching) throw new Error($e1219671f5307c35$var$formatProdErrorMessage(5));
        var isSubscribed = true;
        ensureCanMutateNextListeners();
        nextListeners.push(listener);
        return function unsubscribe() {
            if (!isSubscribed) return;
            if (isDispatching) throw new Error($e1219671f5307c35$var$formatProdErrorMessage(6));
            isSubscribed = false;
            ensureCanMutateNextListeners();
            var index = nextListeners.indexOf(listener);
            nextListeners.splice(index, 1);
            currentListeners = null;
        };
    }
    /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */ function dispatch(action) {
        if (!$e1219671f5307c35$var$isPlainObject(action)) throw new Error($e1219671f5307c35$var$formatProdErrorMessage(7));
        if (typeof action.type === "undefined") throw new Error($e1219671f5307c35$var$formatProdErrorMessage(8));
        if (isDispatching) throw new Error($e1219671f5307c35$var$formatProdErrorMessage(9));
        try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
        } finally{
            isDispatching = false;
        }
        var listeners = currentListeners = nextListeners;
        for(var i = 0; i < listeners.length; i++){
            var listener = listeners[i];
            listener();
        }
        return action;
    }
    /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */ function replaceReducer(nextReducer) {
        if (typeof nextReducer !== "function") throw new Error($e1219671f5307c35$var$formatProdErrorMessage(10));
        currentReducer = nextReducer; // This action has a similiar effect to ActionTypes.INIT.
        // Any reducers that existed in both the new and old rootReducer
        // will receive the previous state. This effectively populates
        // the new state tree with any relevant data from the old one.
        dispatch({
            type: $e1219671f5307c35$export$4219e499db7ca678.REPLACE
        });
    }
    /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */ function observable() {
        var _ref;
        var outerSubscribe = subscribe;
        return _ref = {
            /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe: function subscribe(observer) {
                if (typeof observer !== "object" || observer === null) throw new Error($e1219671f5307c35$var$formatProdErrorMessage(11));
                function observeState() {
                    if (observer.next) observer.next(getState());
                }
                observeState();
                var unsubscribe = outerSubscribe(observeState);
                return {
                    unsubscribe: unsubscribe
                };
            }
        }, _ref[$e1219671f5307c35$var$$$observable] = function() {
            return this;
        }, _ref;
    } // When a store is created, an "INIT" action is dispatched so that every
    // reducer returns their initial state. This effectively populates
    // the initial state tree.
    dispatch({
        type: $e1219671f5307c35$export$4219e499db7ca678.INIT
    });
    return _ref2 = {
        dispatch: dispatch,
        subscribe: subscribe,
        getState: getState,
        replaceReducer: replaceReducer
    }, _ref2[$e1219671f5307c35$var$$$observable] = observable, _ref2;
}
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function $e1219671f5307c35$var$warning(message) {
    /* eslint-disable no-console */ if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    } catch (e) {} // eslint-disable-line no-empty
}
function $e1219671f5307c35$var$getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
    var reducerKeys = Object.keys(reducers);
    var argumentName = action && action.type === $e1219671f5307c35$export$4219e499db7ca678.INIT ? "preloadedState argument passed to createStore" : "previous state received by the reducer";
    if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
    if (!$e1219671f5307c35$var$isPlainObject(inputState)) return "The " + argumentName + ' has unexpected type of "' + $e1219671f5307c35$var$kindOf(inputState) + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
    var unexpectedKeys = Object.keys(inputState).filter(function(key) {
        return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
    });
    unexpectedKeys.forEach(function(key) {
        unexpectedKeyCache[key] = true;
    });
    if (action && action.type === $e1219671f5307c35$export$4219e499db7ca678.REPLACE) return;
    if (unexpectedKeys.length > 0) return "Unexpected " + (unexpectedKeys.length > 1 ? "keys" : "key") + " " + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + ". ") + "Expected to find one of the known reducer keys instead: " + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
}
function $e1219671f5307c35$var$assertReducerShape(reducers) {
    Object.keys(reducers).forEach(function(key) {
        var reducer = reducers[key];
        var initialState = reducer(undefined, {
            type: $e1219671f5307c35$export$4219e499db7ca678.INIT
        });
        if (typeof initialState === "undefined") throw new Error($e1219671f5307c35$var$formatProdErrorMessage(12));
        if (typeof reducer(undefined, {
            type: $e1219671f5307c35$export$4219e499db7ca678.PROBE_UNKNOWN_ACTION()
        }) === "undefined") throw new Error($e1219671f5307c35$var$formatProdErrorMessage(13));
    });
}
/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */ function $e1219671f5307c35$export$66e4520cdb265d18(reducers) {
    var reducerKeys = Object.keys(reducers);
    var finalReducers = {};
    for(var i = 0; i < reducerKeys.length; i++){
        var key = reducerKeys[i];
        if (typeof reducers[key] === "function") finalReducers[key] = reducers[key];
    }
    var finalReducerKeys = Object.keys(finalReducers); // This is used to make sure we don't warn about the same
    // keys multiple times.
    var unexpectedKeyCache;
    var shapeAssertionError;
    try {
        $e1219671f5307c35$var$assertReducerShape(finalReducers);
    } catch (e) {
        shapeAssertionError = e;
    }
    return function combination(state, action) {
        if (state === void 0) state = {};
        if (shapeAssertionError) throw shapeAssertionError;
        var warningMessage;
        var hasChanged = false;
        var nextState = {};
        for(var _i = 0; _i < finalReducerKeys.length; _i++){
            var _key = finalReducerKeys[_i];
            var reducer = finalReducers[_key];
            var previousStateForKey = state[_key];
            var nextStateForKey = reducer(previousStateForKey, action);
            if (typeof nextStateForKey === "undefined") {
                var actionType = action && action.type;
                throw new Error($e1219671f5307c35$var$formatProdErrorMessage(14));
            }
            nextState[_key] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
        }
        hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
        return hasChanged ? nextState : state;
    };
}
function $e1219671f5307c35$var$bindActionCreator(actionCreator, dispatch) {
    return function() {
        return dispatch(actionCreator.apply(this, arguments));
    };
}
/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass an action creator as the first argument,
 * and get a dispatch wrapped function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */ function $e1219671f5307c35$export$aea084d96e84da92(actionCreators, dispatch) {
    if (typeof actionCreators === "function") return $e1219671f5307c35$var$bindActionCreator(actionCreators, dispatch);
    if (typeof actionCreators !== "object" || actionCreators === null) throw new Error($e1219671f5307c35$var$formatProdErrorMessage(16));
    var boundActionCreators = {};
    for(var key in actionCreators){
        var actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = $e1219671f5307c35$var$bindActionCreator(actionCreator, dispatch);
    }
    return boundActionCreators;
}
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */ function $e1219671f5307c35$export$f672e0b6f7222cd7() {
    for(var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++)funcs[_key] = arguments[_key];
    if (funcs.length === 0) return function(arg) {
        return arg;
    };
    if (funcs.length === 1) return funcs[0];
    return funcs.reduce(function(a, b) {
        return function() {
            return a(b.apply(void 0, arguments));
        };
    });
}
/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */ function $e1219671f5307c35$export$9ff26e0402cc7b7() {
    for(var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++)middlewares[_key] = arguments[_key];
    return function(createStore) {
        return function() {
            var store = createStore.apply(void 0, arguments);
            var _dispatch = function dispatch() {
                throw new Error($e1219671f5307c35$var$formatProdErrorMessage(15));
            };
            var middlewareAPI = {
                getState: store.getState,
                dispatch: function dispatch() {
                    return _dispatch.apply(void 0, arguments);
                }
            };
            var chain = middlewares.map(function(middleware) {
                return middleware(middlewareAPI);
            });
            _dispatch = $e1219671f5307c35$export$f672e0b6f7222cd7.apply(void 0, chain)(store.dispatch);
            return (0, $izHwz.default)((0, $izHwz.default)({}, store), {}, {
                dispatch: _dispatch
            });
        };
    };
}
/*
 * This is a dummy function to check if the function name has been altered by minification.
 * If the function has been minified and NODE_ENV !== 'production', warn the user.
 */ function $e1219671f5307c35$var$isCrushed() {}

});
parcelRegister("izHwz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d85d41e31d8eed39$export$2e2bcd8739ae039; });

var $skSrz = parcelRequire("skSrz");
function $d85d41e31d8eed39$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d85d41e31d8eed39$export$2e2bcd8739ae039(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d85d41e31d8eed39$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $skSrz.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d85d41e31d8eed39$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}

});
parcelRegister("skSrz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0552cf66e0756fd1$export$2e2bcd8739ae039; });

var $bpmGF = parcelRequire("bpmGF");
function $0552cf66e0756fd1$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $bpmGF.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

});
parcelRegister("bpmGF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $84e3a0b073125e1c$export$2e2bcd8739ae039; });

var $jlJVZ = parcelRequire("jlJVZ");

var $eXrcW = parcelRequire("eXrcW");
function $84e3a0b073125e1c$export$2e2bcd8739ae039(t) {
    var i = (0, $eXrcW.default)(t, "string");
    return "symbol" == (0, $jlJVZ.default)(i) ? i : i + "";
}

});
parcelRegister("jlJVZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e1639c0ff1f9ce99$export$2e2bcd8739ae039; });
function $e1639c0ff1f9ce99$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $e1639c0ff1f9ce99$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $e1639c0ff1f9ce99$export$2e2bcd8739ae039(o);
}

});

parcelRegister("eXrcW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ae3bae47684c252e$export$2e2bcd8739ae039; });

var $jlJVZ = parcelRequire("jlJVZ");
function $ae3bae47684c252e$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $jlJVZ.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $jlJVZ.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});





parcelRegister("e6UIf", function(module, exports) {
$parcel$export(module.exports, "connect", function () { return (parcelRequire("9DfAu")).default; });
$parcel$export(module.exports, "Provider", function () { return (parcelRequire("fUBYE")).default; });
parcelRequire("4HdsE");
parcelRequire("9Kd04");
var $iMJCh = parcelRequire("iMJCh");

var $khe55 = parcelRequire("khe55");
// with standard React renderers (ReactDOM, React Native)
(0, $khe55.setBatch)((0, $iMJCh.unstable_batchedUpdates));

});
parcelRegister("4HdsE", function(module, exports) {

$parcel$export(module.exports, "Provider", function () { return (parcelRequire("fUBYE")).default; });
$parcel$export(module.exports, "connect", function () { return (parcelRequire("9DfAu")).default; });

var $fUBYE = parcelRequire("fUBYE");

var $cM73r = parcelRequire("cM73r");

var $le5xt = parcelRequire("le5xt");

var $9DfAu = parcelRequire("9DfAu");

var $6Yjff = parcelRequire("6Yjff");

var $5CrgA = parcelRequire("5CrgA");

var $gUrb9 = parcelRequire("gUrb9");

var $acikI = parcelRequire("acikI");

});
parcelRegister("fUBYE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b9598b78ee622c8d$export$2e2bcd8739ae039; });

var $eeH7J = parcelRequire("eeH7J");


var $le5xt = parcelRequire("le5xt");

var $hpfzm = parcelRequire("hpfzm");

var $i9Y2u = parcelRequire("i9Y2u");
function $b9598b78ee622c8d$var$Provider(_ref) {
    var store = _ref.store, context = _ref.context, children = _ref.children;
    var contextValue = (0, $eeH7J.useMemo)(function() {
        var subscription = (0, $hpfzm.createSubscription)(store);
        return {
            store: store,
            subscription: subscription
        };
    }, [
        store
    ]);
    var previousState = (0, $eeH7J.useMemo)(function() {
        return store.getState();
    }, [
        store
    ]);
    (0, $i9Y2u.useIsomorphicLayoutEffect)(function() {
        var subscription = contextValue.subscription;
        subscription.onStateChange = subscription.notifyNestedSubs;
        subscription.trySubscribe();
        if (previousState !== store.getState()) subscription.notifyNestedSubs();
        return function() {
            subscription.tryUnsubscribe();
            subscription.onStateChange = null;
        };
    }, [
        contextValue,
        previousState
    ]);
    var Context = context || (0, $le5xt.ReactReduxContext);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement(Context.Provider, {
        value: contextValue
    }, children);
}
var $b9598b78ee622c8d$export$2e2bcd8739ae039 = $b9598b78ee622c8d$var$Provider;

});
parcelRegister("le5xt", function(module, exports) {

$parcel$export(module.exports, "ReactReduxContext", function () { return $f73f33b42dc96611$export$cc80c08dc91f1c00; });

var $eeH7J = parcelRequire("eeH7J");
var $f73f33b42dc96611$export$cc80c08dc91f1c00 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createContext(null);
var $f73f33b42dc96611$export$2e2bcd8739ae039 = $f73f33b42dc96611$export$cc80c08dc91f1c00;

});

parcelRegister("hpfzm", function(module, exports) {

$parcel$export(module.exports, "createSubscription", function () { return $cac0d93782b73965$export$d567d2b9af322f8f; });

var $khe55 = parcelRequire("khe55");
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants
function $cac0d93782b73965$var$createListenerCollection() {
    var batch = (0, $khe55.getBatch)();
    var first = null;
    var last = null;
    return {
        clear: function clear() {
            first = null;
            last = null;
        },
        notify: function notify() {
            batch(function() {
                var listener = first;
                while(listener){
                    listener.callback();
                    listener = listener.next;
                }
            });
        },
        get: function get() {
            var listeners = [];
            var listener = first;
            while(listener){
                listeners.push(listener);
                listener = listener.next;
            }
            return listeners;
        },
        subscribe: function subscribe(callback) {
            var isSubscribed = true;
            var listener = last = {
                callback: callback,
                next: null,
                prev: last
            };
            if (listener.prev) listener.prev.next = listener;
            else first = listener;
            return function unsubscribe() {
                if (!isSubscribed || first === null) return;
                isSubscribed = false;
                if (listener.next) listener.next.prev = listener.prev;
                else last = listener.prev;
                if (listener.prev) listener.prev.next = listener.next;
                else first = listener.next;
            };
        }
    };
}
var $cac0d93782b73965$var$nullListeners = {
    notify: function notify() {},
    get: function get() {
        return [];
    }
};
function $cac0d93782b73965$export$d567d2b9af322f8f(store, parentSub) {
    var unsubscribe;
    var listeners = $cac0d93782b73965$var$nullListeners;
    function addNestedSub(listener) {
        trySubscribe();
        return listeners.subscribe(listener);
    }
    function notifyNestedSubs() {
        listeners.notify();
    }
    function handleChangeWrapper() {
        if (subscription.onStateChange) subscription.onStateChange();
    }
    function isSubscribed() {
        return Boolean(unsubscribe);
    }
    function trySubscribe() {
        if (!unsubscribe) {
            unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
            listeners = $cac0d93782b73965$var$createListenerCollection();
        }
    }
    function tryUnsubscribe() {
        if (unsubscribe) {
            unsubscribe();
            unsubscribe = undefined;
            listeners.clear();
            listeners = $cac0d93782b73965$var$nullListeners;
        }
    }
    var subscription = {
        addNestedSub: addNestedSub,
        notifyNestedSubs: notifyNestedSubs,
        handleChangeWrapper: handleChangeWrapper,
        isSubscribed: isSubscribed,
        trySubscribe: trySubscribe,
        tryUnsubscribe: tryUnsubscribe,
        getListeners: function getListeners() {
            return listeners;
        }
    };
    return subscription;
}

});
parcelRegister("khe55", function(module, exports) {

$parcel$export(module.exports, "setBatch", function () { return $ec30515e37dd61e3$export$4b9874722d0da7bc; });
$parcel$export(module.exports, "getBatch", function () { return $ec30515e37dd61e3$export$fc47d4c0ba3bd2c6; });
// Default to a dummy "batch" implementation that just runs the callback
function $ec30515e37dd61e3$var$defaultNoopBatch(callback) {
    callback();
}
var $ec30515e37dd61e3$var$batch = $ec30515e37dd61e3$var$defaultNoopBatch; // Allow injecting another batching function later
var $ec30515e37dd61e3$export$4b9874722d0da7bc = function setBatch(newBatch) {
    return $ec30515e37dd61e3$var$batch = newBatch;
}; // Supply a getter just to skip dealing with ESM bindings
var $ec30515e37dd61e3$export$fc47d4c0ba3bd2c6 = function getBatch() {
    return $ec30515e37dd61e3$var$batch;
};

});


parcelRegister("i9Y2u", function(module, exports) {

$parcel$export(module.exports, "useIsomorphicLayoutEffect", function () { return $d387a3c83ae5cfb9$export$700979bc83e7db82; });

var $eeH7J = parcelRequire("eeH7J");
var $d387a3c83ae5cfb9$export$700979bc83e7db82 = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined" ? (0, $eeH7J.useLayoutEffect) : (0, $eeH7J.useEffect);

});


parcelRegister("cM73r", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $94cf709edd69639d$export$2e2bcd8739ae039; });

var $h4XE0 = parcelRequire("h4XE0");

var $fbOaB = parcelRequire("fbOaB");

var $3ojZ1 = parcelRequire("3ojZ1");

var $eeH7J = parcelRequire("eeH7J");

var $ittWF = parcelRequire("ittWF");

var $hpfzm = parcelRequire("hpfzm");

var $i9Y2u = parcelRequire("i9Y2u");

var $le5xt = parcelRequire("le5xt");
var $94cf709edd69639d$var$_excluded = [
    "getDisplayName",
    "methodName",
    "renderCountProp",
    "shouldHandleStateChanges",
    "storeKey",
    "withRef",
    "forwardRef",
    "context"
], $94cf709edd69639d$var$_excluded2 = [
    "reactReduxForwardedRef"
];
var $94cf709edd69639d$var$EMPTY_ARRAY = [];
var $94cf709edd69639d$var$NO_SUBSCRIPTION_ARRAY = [
    null,
    null
];
var $94cf709edd69639d$var$stringifyComponent = function stringifyComponent(Comp) {
    try {
        return JSON.stringify(Comp);
    } catch (err) {
        return String(Comp);
    }
};
function $94cf709edd69639d$var$storeStateUpdatesReducer(state, action) {
    var updateCount = state[1];
    return [
        action.payload,
        updateCount + 1
    ];
}
function $94cf709edd69639d$var$useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
    (0, $i9Y2u.useIsomorphicLayoutEffect)(function() {
        return effectFunc.apply(void 0, effectArgs);
    }, dependencies);
}
function $94cf709edd69639d$var$captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, actualChildProps, childPropsFromStoreUpdate, notifyNestedSubs) {
    // We want to capture the wrapper props and child props we used for later comparisons
    lastWrapperProps.current = wrapperProps;
    lastChildProps.current = actualChildProps;
    renderIsScheduled.current = false; // If the render was from a store update, clear out that reference and cascade the subscriber update
    if (childPropsFromStoreUpdate.current) {
        childPropsFromStoreUpdate.current = null;
        notifyNestedSubs();
    }
}
function $94cf709edd69639d$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, childPropsFromStoreUpdate, notifyNestedSubs, forceComponentUpdateDispatch) {
    // If we're not subscribed to the store, nothing to do here
    if (!shouldHandleStateChanges) return; // Capture values for checking if and when this component unmounts
    var didUnsubscribe = false;
    var lastThrownError = null; // We'll run this callback every time a store subscription update propagates to this component
    var checkForUpdates = function checkForUpdates() {
        if (didUnsubscribe) // Don't run stale listeners.
        // Redux doesn't guarantee unsubscriptions happen until next dispatch.
        return;
        var latestStoreState = store.getState();
        var newChildProps, error;
        try {
            // Actually run the selector with the most recent store state and wrapper props
            // to determine what the child props should be
            newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
        } catch (e) {
            error = e;
            lastThrownError = e;
        }
        if (!error) lastThrownError = null;
         // If the child props haven't changed, nothing to do here - cascade the subscription update
        if (newChildProps === lastChildProps.current) {
            if (!renderIsScheduled.current) notifyNestedSubs();
        } else {
            // Save references to the new child props.  Note that we track the "child props from store update"
            // as a ref instead of a useState/useReducer because we need a way to determine if that value has
            // been processed.  If this went into useState/useReducer, we couldn't clear out the value without
            // forcing another re-render, which we don't want.
            lastChildProps.current = newChildProps;
            childPropsFromStoreUpdate.current = newChildProps;
            renderIsScheduled.current = true; // If the child props _did_ change (or we caught an error), this wrapper component needs to re-render
            forceComponentUpdateDispatch({
                type: "STORE_UPDATED",
                payload: {
                    error: error
                }
            });
        }
    }; // Actually subscribe to the nearest connected ancestor (or store)
    subscription.onStateChange = checkForUpdates;
    subscription.trySubscribe(); // Pull data from the store after first render in case the store has
    // changed since we began.
    checkForUpdates();
    var unsubscribeWrapper = function unsubscribeWrapper() {
        didUnsubscribe = true;
        subscription.tryUnsubscribe();
        subscription.onStateChange = null;
        if (lastThrownError) // It's possible that we caught an error due to a bad mapState function, but the
        // parent re-rendered without this component and we're about to unmount.
        // This shouldn't happen as long as we do top-down subscriptions correctly, but
        // if we ever do those wrong, this throw will surface the error in our tests.
        // In that case, throw the error from here so it doesn't get lost.
        throw lastThrownError;
    };
    return unsubscribeWrapper;
}
var $94cf709edd69639d$var$initStateUpdates = function initStateUpdates() {
    return [
        null,
        0
    ];
};
function $94cf709edd69639d$export$2e2bcd8739ae039(/*
  selectorFactory is a func that is responsible for returning the selector function used to
  compute new props from state, props, and dispatch. For example:
      export default connectAdvanced((dispatch, options) => (state, props) => ({
      thing: state.things[props.thingId],
      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
    }))(YourComponent)
    Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
    Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
  props. Do not use connectAdvanced directly without memoizing results between calls to your
  selector, otherwise the Connect component will re-render on every state or props change.
*/ selectorFactory, _ref) {
    if (_ref === void 0) _ref = {};
    var _ref2 = _ref, _ref2$getDisplayName = _ref2.getDisplayName, getDisplayName = _ref2$getDisplayName === void 0 ? function(name) {
        return "ConnectAdvanced(" + name + ")";
    } : _ref2$getDisplayName, _ref2$methodName = _ref2.methodName, methodName = _ref2$methodName === void 0 ? "connectAdvanced" : _ref2$methodName, _ref2$renderCountProp = _ref2.renderCountProp, renderCountProp = _ref2$renderCountProp === void 0 ? undefined : _ref2$renderCountProp, _ref2$shouldHandleSta = _ref2.shouldHandleStateChanges, shouldHandleStateChanges = _ref2$shouldHandleSta === void 0 ? true : _ref2$shouldHandleSta, _ref2$storeKey = _ref2.storeKey, storeKey = _ref2$storeKey === void 0 ? "store" : _ref2$storeKey, _ref2$withRef = _ref2.withRef, withRef = _ref2$withRef === void 0 ? false : _ref2$withRef, _ref2$forwardRef = _ref2.forwardRef, forwardRef = _ref2$forwardRef === void 0 ? false : _ref2$forwardRef, _ref2$context = _ref2.context, context = _ref2$context === void 0 ? (0, $le5xt.ReactReduxContext) : _ref2$context, connectOptions = (0, $fbOaB.default)(_ref2, $94cf709edd69639d$var$_excluded);
    var customStoreWarningMessage;
    var Context = context;
    return function wrapWithConnect(WrappedComponent) {
        var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || "Component";
        var displayName = getDisplayName(wrappedComponentName);
        var selectorFactoryOptions = (0, $h4XE0.default)({}, connectOptions, {
            getDisplayName: getDisplayName,
            methodName: methodName,
            renderCountProp: renderCountProp,
            shouldHandleStateChanges: shouldHandleStateChanges,
            storeKey: storeKey,
            displayName: displayName,
            wrappedComponentName: wrappedComponentName,
            WrappedComponent: WrappedComponent
        });
        var pure = connectOptions.pure;
        function createChildSelector(store) {
            return selectorFactory(store.dispatch, selectorFactoryOptions);
        } // If we aren't running in "pure" mode, we don't want to memoize values.
        // To avoid conditionally calling hooks, we fall back to a tiny wrapper
        // that just executes the given callback immediately.
        var usePureOnlyMemo = pure ? (0, $eeH7J.useMemo) : function(callback) {
            return callback();
        };
        function ConnectFunction(props) {
            var _useMemo = (0, $eeH7J.useMemo)(function() {
                // Distinguish between actual "data" props that were passed to the wrapper component,
                // and values needed to control behavior (forwarded refs, alternate context instances).
                // To maintain the wrapperProps object reference, memoize this destructuring.
                var reactReduxForwardedRef = props.reactReduxForwardedRef, wrapperProps = (0, $fbOaB.default)(props, $94cf709edd69639d$var$_excluded2);
                return [
                    props.context,
                    reactReduxForwardedRef,
                    wrapperProps
                ];
            }, [
                props
            ]), propsContext = _useMemo[0], reactReduxForwardedRef = _useMemo[1], wrapperProps = _useMemo[2];
            var ContextToUse = (0, $eeH7J.useMemo)(function() {
                // Users may optionally pass in a custom context instance to use instead of our ReactReduxContext.
                // Memoize the check that determines which context instance we should use.
                return propsContext && propsContext.Consumer && (0, $ittWF.isContextConsumer)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement(propsContext.Consumer, null)) ? propsContext : Context;
            }, [
                propsContext,
                Context
            ]); // Retrieve the store and ancestor subscription via context, if available
            var contextValue = (0, $eeH7J.useContext)(ContextToUse); // The store _must_ exist as either a prop or in context.
            // We'll check to see if it _looks_ like a Redux store first.
            // This allows us to pass through a `store` prop that is just a plain value.
            var didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
            var didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);
            var store = didStoreComeFromProps ? props.store : contextValue.store;
            var childPropsSelector = (0, $eeH7J.useMemo)(function() {
                // The child props selector needs the store reference as an input.
                // Re-create this selector whenever the store changes.
                return createChildSelector(store);
            }, [
                store
            ]);
            var _useMemo2 = (0, $eeH7J.useMemo)(function() {
                if (!shouldHandleStateChanges) return $94cf709edd69639d$var$NO_SUBSCRIPTION_ARRAY; // This Subscription's source should match where store came from: props vs. context. A component
                // connected to the store via props shouldn't use subscription from context, or vice versa.
                // This Subscription's source should match where store came from: props vs. context. A component
                // connected to the store via props shouldn't use subscription from context, or vice versa.
                var subscription = (0, $hpfzm.createSubscription)(store, didStoreComeFromProps ? null : contextValue.subscription); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
                // the middle of the notification loop, where `subscription` will then be null. This can
                // probably be avoided if Subscription's listeners logic is changed to not call listeners
                // that have been unsubscribed in the  middle of the notification loop.
                // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
                // the middle of the notification loop, where `subscription` will then be null. This can
                // probably be avoided if Subscription's listeners logic is changed to not call listeners
                // that have been unsubscribed in the  middle of the notification loop.
                var notifyNestedSubs = subscription.notifyNestedSubs.bind(subscription);
                return [
                    subscription,
                    notifyNestedSubs
                ];
            }, [
                store,
                didStoreComeFromProps,
                contextValue
            ]), subscription = _useMemo2[0], notifyNestedSubs = _useMemo2[1]; // Determine what {store, subscription} value should be put into nested context, if necessary,
            // and memoize that value to avoid unnecessary context updates.
            var overriddenContextValue = (0, $eeH7J.useMemo)(function() {
                if (didStoreComeFromProps) // This component is directly subscribed to a store from props.
                // We don't want descendants reading from this store - pass down whatever
                // the existing context value is from the nearest connected ancestor.
                return contextValue;
                 // Otherwise, put this component's subscription instance into context, so that
                // connected descendants won't update until after this component is done
                return (0, $h4XE0.default)({}, contextValue, {
                    subscription: subscription
                });
            }, [
                didStoreComeFromProps,
                contextValue,
                subscription
            ]); // We need to force this wrapper component to re-render whenever a Redux store update
            // causes a change to the calculated child component props (or we caught an error in mapState)
            var _useReducer = (0, $eeH7J.useReducer)($94cf709edd69639d$var$storeStateUpdatesReducer, $94cf709edd69639d$var$EMPTY_ARRAY, $94cf709edd69639d$var$initStateUpdates), _useReducer$ = _useReducer[0], previousStateUpdateResult = _useReducer$[0], forceComponentUpdateDispatch = _useReducer[1]; // Propagate any mapState/mapDispatch errors upwards
            if (previousStateUpdateResult && previousStateUpdateResult.error) throw previousStateUpdateResult.error;
             // Set up refs to coordinate values between the subscription effect and the render logic
            var lastChildProps = (0, $eeH7J.useRef)();
            var lastWrapperProps = (0, $eeH7J.useRef)(wrapperProps);
            var childPropsFromStoreUpdate = (0, $eeH7J.useRef)();
            var renderIsScheduled = (0, $eeH7J.useRef)(false);
            var actualChildProps = usePureOnlyMemo(function() {
                // Tricky logic here:
                // - This render may have been triggered by a Redux store update that produced new child props
                // - However, we may have gotten new wrapper props after that
                // If we have new child props, and the same wrapper props, we know we should use the new child props as-is.
                // But, if we have new wrapper props, those might change the child props, so we have to recalculate things.
                // So, we'll use the child props from store update only if the wrapper props are the same as last time.
                if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) return childPropsFromStoreUpdate.current;
                 // TODO We're reading the store directly in render() here. Bad idea?
                // This will likely cause Bad Things (TM) to happen in Concurrent Mode.
                // Note that we do this because on renders _not_ caused by store updates, we need the latest store state
                // to determine what the child props should be.
                return childPropsSelector(store.getState(), wrapperProps);
            }, [
                store,
                previousStateUpdateResult,
                wrapperProps
            ]); // We need this to execute synchronously every time we re-render. However, React warns
            // about useLayoutEffect in SSR, so we try to detect environment and fall back to
            // just useEffect instead to avoid the warning, since neither will run anyway.
            $94cf709edd69639d$var$useIsomorphicLayoutEffectWithArgs($94cf709edd69639d$var$captureWrapperProps, [
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                wrapperProps,
                actualChildProps,
                childPropsFromStoreUpdate,
                notifyNestedSubs
            ]); // Our re-subscribe logic only runs when the store/subscription setup changes
            $94cf709edd69639d$var$useIsomorphicLayoutEffectWithArgs($94cf709edd69639d$var$subscribeUpdates, [
                shouldHandleStateChanges,
                store,
                subscription,
                childPropsSelector,
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                childPropsFromStoreUpdate,
                notifyNestedSubs,
                forceComponentUpdateDispatch
            ], [
                store,
                subscription,
                childPropsSelector
            ]); // Now that all that's done, we can finally try to actually render the child component.
            // We memoize the elements for the rendered child component as an optimization.
            var renderedWrappedComponent = (0, $eeH7J.useMemo)(function() {
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement(WrappedComponent, (0, $h4XE0.default)({}, actualChildProps, {
                    ref: reactReduxForwardedRef
                }));
            }, [
                reactReduxForwardedRef,
                WrappedComponent,
                actualChildProps
            ]); // If React sees the exact same element reference as last time, it bails out of re-rendering
            // that child, same as if it was wrapped in React.memo() or returned false from shouldComponentUpdate.
            var renderedChild = (0, $eeH7J.useMemo)(function() {
                if (shouldHandleStateChanges) // If this component is subscribed to store updates, we need to pass its own
                // subscription instance down to our descendants. That means rendering the same
                // Context instance, and putting a different value into the context.
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement(ContextToUse.Provider, {
                    value: overriddenContextValue
                }, renderedWrappedComponent);
                return renderedWrappedComponent;
            }, [
                ContextToUse,
                renderedWrappedComponent,
                overriddenContextValue
            ]);
            return renderedChild;
        } // If we're in "pure" mode, ensure our wrapper component only re-renders when incoming props have changed.
        var Connect = pure ? (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).memo(ConnectFunction) : ConnectFunction;
        Connect.WrappedComponent = WrappedComponent;
        Connect.displayName = ConnectFunction.displayName = displayName;
        if (forwardRef) {
            var forwarded = (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).forwardRef(function forwardConnectRef(props, ref) {
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement(Connect, (0, $h4XE0.default)({}, props, {
                    reactReduxForwardedRef: ref
                }));
            });
            forwarded.displayName = displayName;
            forwarded.WrappedComponent = WrappedComponent;
            return (0, (/*@__PURE__*/$parcel$interopDefault($3ojZ1)))(forwarded, WrappedComponent);
        }
        return (0, (/*@__PURE__*/$parcel$interopDefault($3ojZ1)))(Connect, WrappedComponent);
    };
}

});
parcelRegister("ittWF", function(module, exports) {
"use strict";

module.exports = (parcelRequire("9Olrf"));

});
parcelRegister("9Olrf", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", function () { return $724969c810e6fb10$export$a7c73072b1a182ae; }, function (v) { return $724969c810e6fb10$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $724969c810e6fb10$export$9f27bc3417b4524d; }, function (v) { return $724969c810e6fb10$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $724969c810e6fb10$export$db77ccec0bb4ccac; }, function (v) { return $724969c810e6fb10$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $724969c810e6fb10$export$8392c0c9d3dcbd35; }, function (v) { return $724969c810e6fb10$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $724969c810e6fb10$export$ffb0004e005737fa; }, function (v) { return $724969c810e6fb10$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $724969c810e6fb10$export$b624eff549462981; }, function (v) { return $724969c810e6fb10$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $724969c810e6fb10$export$7897aa7841a5380c; }, function (v) { return $724969c810e6fb10$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $724969c810e6fb10$export$602eac185826482c; }, function (v) { return $724969c810e6fb10$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $724969c810e6fb10$export$e2c29f18771995cb; }, function (v) { return $724969c810e6fb10$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $724969c810e6fb10$export$5f8d39834fd61797; }, function (v) { return $724969c810e6fb10$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $724969c810e6fb10$export$74bf444e3cd11ea5; }, function (v) { return $724969c810e6fb10$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $724969c810e6fb10$export$92387174baf9b227; }, function (v) { return $724969c810e6fb10$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $724969c810e6fb10$export$ec112efeb987d9c6; }, function (v) { return $724969c810e6fb10$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $724969c810e6fb10$export$b706b080d889d2c9; }, function (v) { return $724969c810e6fb10$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $724969c810e6fb10$export$5be5a87408f70ddc; }, function (v) { return $724969c810e6fb10$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $724969c810e6fb10$export$45a5e7f76e0caa8d; }, function (v) { return $724969c810e6fb10$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $724969c810e6fb10$export$455c2e768291efa6; }, function (v) { return $724969c810e6fb10$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $724969c810e6fb10$export$9522e17588c12572; }, function (v) { return $724969c810e6fb10$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $724969c810e6fb10$export$2110ac352bb060b9; }, function (v) { return $724969c810e6fb10$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $724969c810e6fb10$export$56885ab8b9c456ab; }, function (v) { return $724969c810e6fb10$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $724969c810e6fb10$export$d927fcb6adf8f9de; }, function (v) { return $724969c810e6fb10$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $724969c810e6fb10$export$b82d16f27459e05a; }, function (v) { return $724969c810e6fb10$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $724969c810e6fb10$export$522c17b4f5e123e8; }, function (v) { return $724969c810e6fb10$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $724969c810e6fb10$export$1aabd8a0274ecfd6; }, function (v) { return $724969c810e6fb10$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $724969c810e6fb10$export$9b621391a187a31a; }, function (v) { return $724969c810e6fb10$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $724969c810e6fb10$export$f5bbd400c2f4426f; }, function (v) { return $724969c810e6fb10$export$f5bbd400c2f4426f = v; });
/** @license React v17.0.2
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $724969c810e6fb10$export$a7c73072b1a182ae;
var $724969c810e6fb10$export$9f27bc3417b4524d;
var $724969c810e6fb10$export$db77ccec0bb4ccac;
var $724969c810e6fb10$export$8392c0c9d3dcbd35;
var $724969c810e6fb10$export$ffb0004e005737fa;
var $724969c810e6fb10$export$b624eff549462981;
var $724969c810e6fb10$export$7897aa7841a5380c;
var $724969c810e6fb10$export$602eac185826482c;
var $724969c810e6fb10$export$e2c29f18771995cb;
var $724969c810e6fb10$export$5f8d39834fd61797;
var $724969c810e6fb10$export$74bf444e3cd11ea5;
var $724969c810e6fb10$export$92387174baf9b227;
var $724969c810e6fb10$export$ec112efeb987d9c6;
var $724969c810e6fb10$export$b706b080d889d2c9;
var $724969c810e6fb10$export$5be5a87408f70ddc;
var $724969c810e6fb10$export$45a5e7f76e0caa8d;
var $724969c810e6fb10$export$455c2e768291efa6;
var $724969c810e6fb10$export$9522e17588c12572;
var $724969c810e6fb10$export$2110ac352bb060b9;
var $724969c810e6fb10$export$56885ab8b9c456ab;
var $724969c810e6fb10$export$d927fcb6adf8f9de;
var $724969c810e6fb10$export$b82d16f27459e05a;
var $724969c810e6fb10$export$522c17b4f5e123e8;
var $724969c810e6fb10$export$1aabd8a0274ecfd6;
var $724969c810e6fb10$export$9b621391a187a31a;
var $724969c810e6fb10$export$f5bbd400c2f4426f;
"use strict";
var $724969c810e6fb10$var$b = 60103, $724969c810e6fb10$var$c = 60106, $724969c810e6fb10$var$d = 60107, $724969c810e6fb10$var$e = 60108, $724969c810e6fb10$var$f = 60114, $724969c810e6fb10$var$g = 60109, $724969c810e6fb10$var$h = 60110, $724969c810e6fb10$var$k = 60112, $724969c810e6fb10$var$l = 60113, $724969c810e6fb10$var$m = 60120, $724969c810e6fb10$var$n = 60115, $724969c810e6fb10$var$p = 60116, $724969c810e6fb10$var$q = 60121, $724969c810e6fb10$var$r = 60122, $724969c810e6fb10$var$u = 60117, $724969c810e6fb10$var$v = 60129, $724969c810e6fb10$var$w = 60131;
if ("function" === typeof Symbol && Symbol.for) {
    var $724969c810e6fb10$var$x = Symbol.for;
    $724969c810e6fb10$var$b = $724969c810e6fb10$var$x("react.element");
    $724969c810e6fb10$var$c = $724969c810e6fb10$var$x("react.portal");
    $724969c810e6fb10$var$d = $724969c810e6fb10$var$x("react.fragment");
    $724969c810e6fb10$var$e = $724969c810e6fb10$var$x("react.strict_mode");
    $724969c810e6fb10$var$f = $724969c810e6fb10$var$x("react.profiler");
    $724969c810e6fb10$var$g = $724969c810e6fb10$var$x("react.provider");
    $724969c810e6fb10$var$h = $724969c810e6fb10$var$x("react.context");
    $724969c810e6fb10$var$k = $724969c810e6fb10$var$x("react.forward_ref");
    $724969c810e6fb10$var$l = $724969c810e6fb10$var$x("react.suspense");
    $724969c810e6fb10$var$m = $724969c810e6fb10$var$x("react.suspense_list");
    $724969c810e6fb10$var$n = $724969c810e6fb10$var$x("react.memo");
    $724969c810e6fb10$var$p = $724969c810e6fb10$var$x("react.lazy");
    $724969c810e6fb10$var$q = $724969c810e6fb10$var$x("react.block");
    $724969c810e6fb10$var$r = $724969c810e6fb10$var$x("react.server.block");
    $724969c810e6fb10$var$u = $724969c810e6fb10$var$x("react.fundamental");
    $724969c810e6fb10$var$v = $724969c810e6fb10$var$x("react.debug_trace_mode");
    $724969c810e6fb10$var$w = $724969c810e6fb10$var$x("react.legacy_hidden");
}
function $724969c810e6fb10$var$y(a) {
    if ("object" === typeof a && null !== a) {
        var t = a.$$typeof;
        switch(t){
            case $724969c810e6fb10$var$b:
                switch(a = a.type, a){
                    case $724969c810e6fb10$var$d:
                    case $724969c810e6fb10$var$f:
                    case $724969c810e6fb10$var$e:
                    case $724969c810e6fb10$var$l:
                    case $724969c810e6fb10$var$m:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $724969c810e6fb10$var$h:
                            case $724969c810e6fb10$var$k:
                            case $724969c810e6fb10$var$p:
                            case $724969c810e6fb10$var$n:
                            case $724969c810e6fb10$var$g:
                                return a;
                            default:
                                return t;
                        }
                }
            case $724969c810e6fb10$var$c:
                return t;
        }
    }
}
var $724969c810e6fb10$var$z = $724969c810e6fb10$var$g, $724969c810e6fb10$var$A = $724969c810e6fb10$var$b, $724969c810e6fb10$var$B = $724969c810e6fb10$var$k, $724969c810e6fb10$var$C = $724969c810e6fb10$var$d, $724969c810e6fb10$var$D = $724969c810e6fb10$var$p, $724969c810e6fb10$var$E = $724969c810e6fb10$var$n, $724969c810e6fb10$var$F = $724969c810e6fb10$var$c, $724969c810e6fb10$var$G = $724969c810e6fb10$var$f, $724969c810e6fb10$var$H = $724969c810e6fb10$var$e, $724969c810e6fb10$var$I = $724969c810e6fb10$var$l;
$724969c810e6fb10$export$a7c73072b1a182ae = $724969c810e6fb10$var$h;
$724969c810e6fb10$export$9f27bc3417b4524d = $724969c810e6fb10$var$z;
$724969c810e6fb10$export$db77ccec0bb4ccac = $724969c810e6fb10$var$A;
$724969c810e6fb10$export$8392c0c9d3dcbd35 = $724969c810e6fb10$var$B;
$724969c810e6fb10$export$ffb0004e005737fa = $724969c810e6fb10$var$C;
$724969c810e6fb10$export$b624eff549462981 = $724969c810e6fb10$var$D;
$724969c810e6fb10$export$7897aa7841a5380c = $724969c810e6fb10$var$E;
$724969c810e6fb10$export$602eac185826482c = $724969c810e6fb10$var$F;
$724969c810e6fb10$export$e2c29f18771995cb = $724969c810e6fb10$var$G;
$724969c810e6fb10$export$5f8d39834fd61797 = $724969c810e6fb10$var$H;
$724969c810e6fb10$export$74bf444e3cd11ea5 = $724969c810e6fb10$var$I;
$724969c810e6fb10$export$92387174baf9b227 = function() {
    return !1;
};
$724969c810e6fb10$export$ec112efeb987d9c6 = function() {
    return !1;
};
$724969c810e6fb10$export$b706b080d889d2c9 = function(a) {
    return $724969c810e6fb10$var$y(a) === $724969c810e6fb10$var$h;
};
$724969c810e6fb10$export$5be5a87408f70ddc = function(a) {
    return $724969c810e6fb10$var$y(a) === $724969c810e6fb10$var$g;
};
$724969c810e6fb10$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $724969c810e6fb10$var$b;
};
$724969c810e6fb10$export$455c2e768291efa6 = function(a) {
    return $724969c810e6fb10$var$y(a) === $724969c810e6fb10$var$k;
};
$724969c810e6fb10$export$9522e17588c12572 = function(a) {
    return $724969c810e6fb10$var$y(a) === $724969c810e6fb10$var$d;
};
$724969c810e6fb10$export$2110ac352bb060b9 = function(a) {
    return $724969c810e6fb10$var$y(a) === $724969c810e6fb10$var$p;
};
$724969c810e6fb10$export$56885ab8b9c456ab = function(a) {
    return $724969c810e6fb10$var$y(a) === $724969c810e6fb10$var$n;
};
$724969c810e6fb10$export$d927fcb6adf8f9de = function(a) {
    return $724969c810e6fb10$var$y(a) === $724969c810e6fb10$var$c;
};
$724969c810e6fb10$export$b82d16f27459e05a = function(a) {
    return $724969c810e6fb10$var$y(a) === $724969c810e6fb10$var$f;
};
$724969c810e6fb10$export$522c17b4f5e123e8 = function(a) {
    return $724969c810e6fb10$var$y(a) === $724969c810e6fb10$var$e;
};
$724969c810e6fb10$export$1aabd8a0274ecfd6 = function(a) {
    return $724969c810e6fb10$var$y(a) === $724969c810e6fb10$var$l;
};
$724969c810e6fb10$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $724969c810e6fb10$var$d || a === $724969c810e6fb10$var$f || a === $724969c810e6fb10$var$v || a === $724969c810e6fb10$var$e || a === $724969c810e6fb10$var$l || a === $724969c810e6fb10$var$m || a === $724969c810e6fb10$var$w || "object" === typeof a && null !== a && (a.$$typeof === $724969c810e6fb10$var$p || a.$$typeof === $724969c810e6fb10$var$n || a.$$typeof === $724969c810e6fb10$var$g || a.$$typeof === $724969c810e6fb10$var$h || a.$$typeof === $724969c810e6fb10$var$k || a.$$typeof === $724969c810e6fb10$var$u || a.$$typeof === $724969c810e6fb10$var$q || a[0] === $724969c810e6fb10$var$r) ? !0 : !1;
};
$724969c810e6fb10$export$f5bbd400c2f4426f = $724969c810e6fb10$var$y;

});



parcelRegister("9DfAu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7033d8f439e85478$export$2e2bcd8739ae039; });

var $h4XE0 = parcelRequire("h4XE0");

var $fbOaB = parcelRequire("fbOaB");

var $cM73r = parcelRequire("cM73r");

var $acikI = parcelRequire("acikI");

var $bPOpP = parcelRequire("bPOpP");

var $2rvOv = parcelRequire("2rvOv");

var $gF2bi = parcelRequire("gF2bi");

var $aVfzV = parcelRequire("aVfzV");
var $7033d8f439e85478$var$_excluded = [
    "pure",
    "areStatesEqual",
    "areOwnPropsEqual",
    "areStatePropsEqual",
    "areMergedPropsEqual"
];
/*
  connect is a facade over connectAdvanced. It turns its args into a compatible
  selectorFactory, which has the signature:

    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
  
  connect passes its args to connectAdvanced as options, which will in turn pass them to
  selectorFactory each time a Connect component instance is instantiated or hot reloaded.

  selectorFactory returns a final props selector from its mapStateToProps,
  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
  mergePropsFactories, and pure args.

  The resulting final props selector is called by the Connect component instance whenever
  it receives new props or store state.
 */ function $7033d8f439e85478$var$match(arg, factories, name) {
    for(var i = factories.length - 1; i >= 0; i--){
        var result = factories[i](arg);
        if (result) return result;
    }
    return function(dispatch, options) {
        throw new Error("Invalid value of type " + typeof arg + " for " + name + " argument when connecting component " + options.wrappedComponentName + ".");
    };
}
function $7033d8f439e85478$var$strictEqual(a, b) {
    return a === b;
} // createConnect with default args builds the 'official' connect behavior. Calling it with
function $7033d8f439e85478$export$9f9feb656dec1fc4(_temp) {
    var _ref = _temp === void 0 ? {} : _temp, _ref$connectHOC = _ref.connectHOC, connectHOC = _ref$connectHOC === void 0 ? (0, $cM73r.default) : _ref$connectHOC, _ref$mapStateToPropsF = _ref.mapStateToPropsFactories, mapStateToPropsFactories = _ref$mapStateToPropsF === void 0 ? (0, $2rvOv.default) : _ref$mapStateToPropsF, _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories, mapDispatchToPropsFactories = _ref$mapDispatchToPro === void 0 ? (0, $bPOpP.default) : _ref$mapDispatchToPro, _ref$mergePropsFactor = _ref.mergePropsFactories, mergePropsFactories = _ref$mergePropsFactor === void 0 ? (0, $gF2bi.default) : _ref$mergePropsFactor, _ref$selectorFactory = _ref.selectorFactory, selectorFactory = _ref$selectorFactory === void 0 ? (0, $aVfzV.default) : _ref$selectorFactory;
    return function connect(mapStateToProps, mapDispatchToProps, mergeProps, _ref2) {
        if (_ref2 === void 0) _ref2 = {};
        var _ref3 = _ref2, _ref3$pure = _ref3.pure, pure = _ref3$pure === void 0 ? true : _ref3$pure, _ref3$areStatesEqual = _ref3.areStatesEqual, areStatesEqual = _ref3$areStatesEqual === void 0 ? $7033d8f439e85478$var$strictEqual : _ref3$areStatesEqual, _ref3$areOwnPropsEqua = _ref3.areOwnPropsEqual, areOwnPropsEqual = _ref3$areOwnPropsEqua === void 0 ? (0, $acikI.default) : _ref3$areOwnPropsEqua, _ref3$areStatePropsEq = _ref3.areStatePropsEqual, areStatePropsEqual = _ref3$areStatePropsEq === void 0 ? (0, $acikI.default) : _ref3$areStatePropsEq, _ref3$areMergedPropsE = _ref3.areMergedPropsEqual, areMergedPropsEqual = _ref3$areMergedPropsE === void 0 ? (0, $acikI.default) : _ref3$areMergedPropsE, extraOptions = (0, $fbOaB.default)(_ref3, $7033d8f439e85478$var$_excluded);
        var initMapStateToProps = $7033d8f439e85478$var$match(mapStateToProps, mapStateToPropsFactories, "mapStateToProps");
        var initMapDispatchToProps = $7033d8f439e85478$var$match(mapDispatchToProps, mapDispatchToPropsFactories, "mapDispatchToProps");
        var initMergeProps = $7033d8f439e85478$var$match(mergeProps, mergePropsFactories, "mergeProps");
        return connectHOC(selectorFactory, (0, $h4XE0.default)({
            // used in error messages
            methodName: "connect",
            // used to compute Connect's displayName from the wrapped component's displayName.
            getDisplayName: function getDisplayName(name) {
                return "Connect(" + name + ")";
            },
            // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
            shouldHandleStateChanges: Boolean(mapStateToProps),
            // passed through to selectorFactory
            initMapStateToProps: initMapStateToProps,
            initMapDispatchToProps: initMapDispatchToProps,
            initMergeProps: initMergeProps,
            pure: pure,
            areStatesEqual: areStatesEqual,
            areOwnPropsEqual: areOwnPropsEqual,
            areStatePropsEqual: areStatePropsEqual,
            areMergedPropsEqual: areMergedPropsEqual
        }, extraOptions));
    };
}
var $7033d8f439e85478$export$2e2bcd8739ae039 = /*#__PURE__*/ $7033d8f439e85478$export$9f9feb656dec1fc4();

});
parcelRegister("acikI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $76c93ef6be55aca0$export$2e2bcd8739ae039; });
function $76c93ef6be55aca0$var$is(x, y) {
    if (x === y) return x !== 0 || y !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $76c93ef6be55aca0$export$2e2bcd8739ae039(objA, objB) {
    if ($76c93ef6be55aca0$var$is(objA, objB)) return true;
    if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(var i = 0; i < keysA.length; i++){
        if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !$76c93ef6be55aca0$var$is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}

});

parcelRegister("bPOpP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $89db909be5e86047$export$2e2bcd8739ae039; });

var $FA926 = parcelRequire("FA926");

var $5UcXS = parcelRequire("5UcXS");
function $89db909be5e86047$export$a9f27b4b187c1166(mapDispatchToProps) {
    return typeof mapDispatchToProps === "function" ? (0, $5UcXS.wrapMapToPropsFunc)(mapDispatchToProps, "mapDispatchToProps") : undefined;
}
function $89db909be5e86047$export$ba20d1a7aa0c4a90(mapDispatchToProps) {
    return !mapDispatchToProps ? (0, $5UcXS.wrapMapToPropsConstant)(function(dispatch) {
        return {
            dispatch: dispatch
        };
    }) : undefined;
}
function $89db909be5e86047$export$94a6e55709d4d961(mapDispatchToProps) {
    return mapDispatchToProps && typeof mapDispatchToProps === "object" ? (0, $5UcXS.wrapMapToPropsConstant)(function(dispatch) {
        return (0, $FA926.default)(mapDispatchToProps, dispatch);
    }) : undefined;
}
var $89db909be5e86047$export$2e2bcd8739ae039 = [
    $89db909be5e86047$export$a9f27b4b187c1166,
    $89db909be5e86047$export$ba20d1a7aa0c4a90,
    $89db909be5e86047$export$94a6e55709d4d961
];

});
parcelRegister("FA926", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $07cfde0870ec42ed$export$2e2bcd8739ae039; });
function $07cfde0870ec42ed$export$2e2bcd8739ae039(actionCreators, dispatch) {
    var boundActionCreators = {};
    var _loop = function _loop(key) {
        var actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = function() {
            return dispatch(actionCreator.apply(void 0, arguments));
        };
    };
    for(var key in actionCreators)_loop(key);
    return boundActionCreators;
}

});

parcelRegister("5UcXS", function(module, exports) {

$parcel$export(module.exports, "wrapMapToPropsConstant", function () { return $44cc3d3b961270c1$export$710f7c60f68acd3e; });
$parcel$export(module.exports, "wrapMapToPropsFunc", function () { return $44cc3d3b961270c1$export$8d46c7f53c8c602f; });
parcelRequire("dYEwb");
function $44cc3d3b961270c1$export$710f7c60f68acd3e(getConstant) {
    return function initConstantSelector(dispatch, options) {
        var constant = getConstant(dispatch, options);
        function constantSelector() {
            return constant;
        }
        constantSelector.dependsOnOwnProps = false;
        return constantSelector;
    };
} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
function $44cc3d3b961270c1$export$e561b938df936d57(mapToProps) {
    return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
function $44cc3d3b961270c1$export$8d46c7f53c8c602f(mapToProps, methodName) {
    return function initProxySelector(dispatch, _ref) {
        var displayName = _ref.displayName;
        var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
            return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
        }; // allow detectFactoryAndVerify to get ownProps
        proxy.dependsOnOwnProps = true;
        proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
            proxy.mapToProps = mapToProps;
            proxy.dependsOnOwnProps = $44cc3d3b961270c1$export$e561b938df936d57(mapToProps);
            var props = proxy(stateOrDispatch, ownProps);
            if (typeof props === "function") {
                proxy.mapToProps = props;
                proxy.dependsOnOwnProps = $44cc3d3b961270c1$export$e561b938df936d57(props);
                props = proxy(stateOrDispatch, ownProps);
            }
            return props;
        };
        return proxy;
    };
}

});
parcelRegister("dYEwb", function(module, exports) {

var $bMfYu = parcelRequire("bMfYu");

var $7M4Ij = parcelRequire("7M4Ij");
function $a2d04f061f1f78fa$export$2e2bcd8739ae039(value, displayName, methodName) {
    if (!(0, $bMfYu.default)(value)) (0, $7M4Ij.default)(methodName + "() in " + displayName + " must return a plain object. Instead received " + value + ".");
}

});
parcelRegister("bMfYu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $893091a7fbf66eb4$export$2e2bcd8739ae039; });
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function $893091a7fbf66eb4$export$2e2bcd8739ae039(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    var proto = Object.getPrototypeOf(obj);
    if (proto === null) return true;
    var baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}

});

parcelRegister("7M4Ij", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5a90ac1fe16ea1e4$export$2e2bcd8739ae039; });
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function $5a90ac1fe16ea1e4$export$2e2bcd8739ae039(message) {
    /* eslint-disable no-console */ if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    /* eslint-disable no-empty */ } catch (e) {}
/* eslint-enable no-empty */ }

});




parcelRegister("2rvOv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1c76c7edd70ecdae$export$2e2bcd8739ae039; });

var $5UcXS = parcelRequire("5UcXS");
function $1c76c7edd70ecdae$export$23fc470827b14aa(mapStateToProps) {
    return typeof mapStateToProps === "function" ? (0, $5UcXS.wrapMapToPropsFunc)(mapStateToProps, "mapStateToProps") : undefined;
}
function $1c76c7edd70ecdae$export$514bc8c1a53c1d66(mapStateToProps) {
    return !mapStateToProps ? (0, $5UcXS.wrapMapToPropsConstant)(function() {
        return {};
    }) : undefined;
}
var $1c76c7edd70ecdae$export$2e2bcd8739ae039 = [
    $1c76c7edd70ecdae$export$23fc470827b14aa,
    $1c76c7edd70ecdae$export$514bc8c1a53c1d66
];

});

parcelRegister("gF2bi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c2122acbd7276226$export$2e2bcd8739ae039; });

var $h4XE0 = parcelRequire("h4XE0");
parcelRequire("dYEwb");
function $c2122acbd7276226$export$691c327fc30bc857(stateProps, dispatchProps, ownProps) {
    return (0, $h4XE0.default)({}, ownProps, stateProps, dispatchProps);
}
function $c2122acbd7276226$export$5b105939c84b5234(mergeProps) {
    return function initMergePropsProxy(dispatch, _ref) {
        var displayName = _ref.displayName, pure = _ref.pure, areMergedPropsEqual = _ref.areMergedPropsEqual;
        var hasRunOnce = false;
        var mergedProps;
        return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
            var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
            if (hasRunOnce) {
                if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
            } else {
                hasRunOnce = true;
                mergedProps = nextMergedProps;
            }
            return mergedProps;
        };
    };
}
function $c2122acbd7276226$export$d61b680184bc3f00(mergeProps) {
    return typeof mergeProps === "function" ? $c2122acbd7276226$export$5b105939c84b5234(mergeProps) : undefined;
}
function $c2122acbd7276226$export$a13ba70ef50dda6d(mergeProps) {
    return !mergeProps ? function() {
        return $c2122acbd7276226$export$691c327fc30bc857;
    } : undefined;
}
var $c2122acbd7276226$export$2e2bcd8739ae039 = [
    $c2122acbd7276226$export$d61b680184bc3f00,
    $c2122acbd7276226$export$a13ba70ef50dda6d
];

});

parcelRegister("aVfzV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7f3b4fd4c5f4c467$export$2e2bcd8739ae039; });

var $fbOaB = parcelRequire("fbOaB");
parcelRequire("6fX8O");
var $7f3b4fd4c5f4c467$var$_excluded = [
    "initMapStateToProps",
    "initMapDispatchToProps",
    "initMergeProps"
];
function $7f3b4fd4c5f4c467$export$68c2c73bda6aa4b0(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
    return function impureFinalPropsSelector(state, ownProps) {
        return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
    };
}
function $7f3b4fd4c5f4c467$export$d20c0c2ca6eb2b6f(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
    var areStatesEqual = _ref.areStatesEqual, areOwnPropsEqual = _ref.areOwnPropsEqual, areStatePropsEqual = _ref.areStatePropsEqual;
    var hasRunAtLeastOnce = false;
    var state;
    var ownProps;
    var stateProps;
    var dispatchProps;
    var mergedProps;
    function handleFirstCall(firstState, firstOwnProps) {
        state = firstState;
        ownProps = firstOwnProps;
        stateProps = mapStateToProps(state, ownProps);
        dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        hasRunAtLeastOnce = true;
        return mergedProps;
    }
    function handleNewPropsAndNewState() {
        stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewProps() {
        if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewState() {
        var nextStateProps = mapStateToProps(state, ownProps);
        var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
        stateProps = nextStateProps;
        if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleSubsequentCalls(nextState, nextOwnProps) {
        var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
        var stateChanged = !areStatesEqual(nextState, state, nextOwnProps, ownProps);
        state = nextState;
        ownProps = nextOwnProps;
        if (propsChanged && stateChanged) return handleNewPropsAndNewState();
        if (propsChanged) return handleNewProps();
        if (stateChanged) return handleNewState();
        return mergedProps;
    }
    return function pureFinalPropsSelector(nextState, nextOwnProps) {
        return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
    };
} // TODO: Add more comments
function $7f3b4fd4c5f4c467$export$2e2bcd8739ae039(dispatch, _ref2) {
    var initMapStateToProps = _ref2.initMapStateToProps, initMapDispatchToProps = _ref2.initMapDispatchToProps, initMergeProps = _ref2.initMergeProps, options = (0, $fbOaB.default)(_ref2, $7f3b4fd4c5f4c467$var$_excluded);
    var mapStateToProps = initMapStateToProps(dispatch, options);
    var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
    var mergeProps = initMergeProps(dispatch, options);
    var selectorFactory = options.pure ? $7f3b4fd4c5f4c467$export$d20c0c2ca6eb2b6f : $7f3b4fd4c5f4c467$export$68c2c73bda6aa4b0;
    return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}

});
parcelRegister("6fX8O", function(module, exports) {

var $7M4Ij = parcelRequire("7M4Ij");
function $48e204fd7aa3fb83$var$verify(selector, methodName, displayName) {
    if (!selector) throw new Error("Unexpected value for " + methodName + " in " + displayName + ".");
    else if (methodName === "mapStateToProps" || methodName === "mapDispatchToProps") {
        if (!Object.prototype.hasOwnProperty.call(selector, "dependsOnOwnProps")) (0, $7M4Ij.default)("The selector for " + methodName + " of " + displayName + " did not specify a value for dependsOnOwnProps.");
    }
}
function $48e204fd7aa3fb83$export$2e2bcd8739ae039(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
    $48e204fd7aa3fb83$var$verify(mapStateToProps, "mapStateToProps", displayName);
    $48e204fd7aa3fb83$var$verify(mapDispatchToProps, "mapDispatchToProps", displayName);
    $48e204fd7aa3fb83$var$verify(mergeProps, "mergeProps", displayName);
}

});



parcelRegister("6Yjff", function(module, exports) {

var $le5xt = parcelRequire("le5xt");

var $gUrb9 = parcelRequire("gUrb9");
function $5137464f71e9225a$export$bc9b55530897c558(context) {
    if (context === void 0) context = (0, $le5xt.ReactReduxContext);
    var useStore = context === (0, $le5xt.ReactReduxContext) ? (0, $gUrb9.useStore) : (0, $gUrb9.createStoreHook)(context);
    return function useDispatch() {
        var store = useStore();
        return store.dispatch;
    };
}
var $5137464f71e9225a$export$8ad76b76a4c905f8 = /*#__PURE__*/ $5137464f71e9225a$export$bc9b55530897c558();

});
parcelRegister("gUrb9", function(module, exports) {

$parcel$export(module.exports, "createStoreHook", function () { return $c4f6f5767201d6c3$export$671dba69185d0304; });
$parcel$export(module.exports, "useStore", function () { return $c4f6f5767201d6c3$export$6ccbb43953eebf8; });

var $eeH7J = parcelRequire("eeH7J");

var $le5xt = parcelRequire("le5xt");

var $1JpJn = parcelRequire("1JpJn");
function $c4f6f5767201d6c3$export$671dba69185d0304(context) {
    if (context === void 0) context = (0, $le5xt.ReactReduxContext);
    var useReduxContext = context === (0, $le5xt.ReactReduxContext) ? (0, $1JpJn.useReduxContext) : function() {
        return (0, $eeH7J.useContext)(context);
    };
    return function useStore() {
        var _useReduxContext = useReduxContext(), store = _useReduxContext.store;
        return store;
    };
}
var $c4f6f5767201d6c3$export$6ccbb43953eebf8 = /*#__PURE__*/ $c4f6f5767201d6c3$export$671dba69185d0304();

});
parcelRegister("1JpJn", function(module, exports) {

$parcel$export(module.exports, "useReduxContext", function () { return $142df40832892c13$export$c1275ca9a6fd3ec5; });

var $eeH7J = parcelRequire("eeH7J");

var $le5xt = parcelRequire("le5xt");
function $142df40832892c13$export$c1275ca9a6fd3ec5() {
    var contextValue = (0, $eeH7J.useContext)((0, $le5xt.ReactReduxContext));
    return contextValue;
}

});



parcelRegister("5CrgA", function(module, exports) {

var $eeH7J = parcelRequire("eeH7J");

var $1JpJn = parcelRequire("1JpJn");

var $hpfzm = parcelRequire("hpfzm");

var $i9Y2u = parcelRequire("i9Y2u");

var $le5xt = parcelRequire("le5xt");
var $4175a6f1a4737057$var$refEquality = function refEquality(a, b) {
    return a === b;
};
function $4175a6f1a4737057$var$useSelectorWithStoreAndSubscription(selector, equalityFn, store, contextSub) {
    var _useReducer = (0, $eeH7J.useReducer)(function(s) {
        return s + 1;
    }, 0), forceRender = _useReducer[1];
    var subscription = (0, $eeH7J.useMemo)(function() {
        return (0, $hpfzm.createSubscription)(store, contextSub);
    }, [
        store,
        contextSub
    ]);
    var latestSubscriptionCallbackError = (0, $eeH7J.useRef)();
    var latestSelector = (0, $eeH7J.useRef)();
    var latestStoreState = (0, $eeH7J.useRef)();
    var latestSelectedState = (0, $eeH7J.useRef)();
    var storeState = store.getState();
    var selectedState;
    try {
        if (selector !== latestSelector.current || storeState !== latestStoreState.current || latestSubscriptionCallbackError.current) {
            var newSelectedState = selector(storeState); // ensure latest selected state is reused so that a custom equality function can result in identical references
            if (latestSelectedState.current === undefined || !equalityFn(newSelectedState, latestSelectedState.current)) selectedState = newSelectedState;
            else selectedState = latestSelectedState.current;
        } else selectedState = latestSelectedState.current;
    } catch (err) {
        if (latestSubscriptionCallbackError.current) err.message += "\nThe error may be correlated with this previous error:\n" + latestSubscriptionCallbackError.current.stack + "\n\n";
        throw err;
    }
    (0, $i9Y2u.useIsomorphicLayoutEffect)(function() {
        latestSelector.current = selector;
        latestStoreState.current = storeState;
        latestSelectedState.current = selectedState;
        latestSubscriptionCallbackError.current = undefined;
    });
    (0, $i9Y2u.useIsomorphicLayoutEffect)(function() {
        function checkForUpdates() {
            try {
                var newStoreState = store.getState(); // Avoid calling selector multiple times if the store's state has not changed
                if (newStoreState === latestStoreState.current) return;
                var _newSelectedState = latestSelector.current(newStoreState);
                if (equalityFn(_newSelectedState, latestSelectedState.current)) return;
                latestSelectedState.current = _newSelectedState;
                latestStoreState.current = newStoreState;
            } catch (err) {
                // we ignore all errors here, since when the component
                // is re-rendered, the selectors are called again, and
                // will throw again, if neither props nor store state
                // changed
                latestSubscriptionCallbackError.current = err;
            }
            forceRender();
        }
        subscription.onStateChange = checkForUpdates;
        subscription.trySubscribe();
        checkForUpdates();
        return function() {
            return subscription.tryUnsubscribe();
        };
    }, [
        store,
        subscription
    ]);
    return selectedState;
}
function $4175a6f1a4737057$export$2b53f90d2bd1cbfb(context) {
    if (context === void 0) context = (0, $le5xt.ReactReduxContext);
    var useReduxContext = context === (0, $le5xt.ReactReduxContext) ? (0, $1JpJn.useReduxContext) : function() {
        return (0, $eeH7J.useContext)(context);
    };
    return function useSelector(selector, equalityFn) {
        if (equalityFn === void 0) equalityFn = $4175a6f1a4737057$var$refEquality;
        var _useReduxContext = useReduxContext(), store = _useReduxContext.store, contextSub = _useReduxContext.subscription;
        var selectedState = $4175a6f1a4737057$var$useSelectorWithStoreAndSubscription(selector, equalityFn, store, contextSub);
        (0, $eeH7J.useDebugValue)(selectedState);
        return selectedState;
    };
}
var $4175a6f1a4737057$export$2105062e25df4afe = /*#__PURE__*/ $4175a6f1a4737057$export$2b53f90d2bd1cbfb();

});


parcelRegister("9Kd04", function(module, exports) {

$parcel$export(module.exports, "unstable_batchedUpdates", function () { return (parcelRequire("iMJCh")).unstable_batchedUpdates; });
/* eslint-disable import/no-unresolved */ 
var $iMJCh = parcelRequire("iMJCh");

});


parcelRegister("3PiUj", function(module, exports) {

$parcel$export(module.exports, "useMemo", function () { return $2c94cd194b91c65d$export$1538c33de8887b59; });
$parcel$export(module.exports, "useCallback", function () { return $2c94cd194b91c65d$export$35808ee640e87ca7; });

var $eeH7J = parcelRequire("eeH7J");
function $2c94cd194b91c65d$var$areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(var i = 0; i < newInputs.length; i++){
        if (newInputs[i] !== lastInputs[i]) return false;
    }
    return true;
}
function $2c94cd194b91c65d$export$b6feb8998cd9b342(getResult, inputs) {
    var initial = (0, $eeH7J.useState)(function() {
        return {
            inputs: inputs,
            result: getResult()
        };
    })[0];
    var isFirstRun = (0, $eeH7J.useRef)(true);
    var committed = (0, $eeH7J.useRef)(initial);
    var useCache = isFirstRun.current || Boolean(inputs && committed.current.inputs && $2c94cd194b91c65d$var$areInputsEqual(inputs, committed.current.inputs));
    var cache = useCache ? committed.current : {
        inputs: inputs,
        result: getResult()
    };
    (0, $eeH7J.useEffect)(function() {
        isFirstRun.current = false;
        committed.current = cache;
    }, [
        cache
    ]);
    return cache.result;
}
function $2c94cd194b91c65d$export$33752cf3ee811995(callback, inputs) {
    return $2c94cd194b91c65d$export$b6feb8998cd9b342(function() {
        return callback;
    }, inputs);
}
var $2c94cd194b91c65d$export$1538c33de8887b59 = $2c94cd194b91c65d$export$b6feb8998cd9b342;
var $2c94cd194b91c65d$export$35808ee640e87ca7 = $2c94cd194b91c65d$export$33752cf3ee811995;

});

parcelRegister("4J1sD", function(module, exports) {

$parcel$export(module.exports, "getRect", function () { return $370c7f7f7e65d7c8$export$4b834cebd9e5cebe; });
$parcel$export(module.exports, "expand", function () { return $370c7f7f7e65d7c8$export$9f77e0932fb78f72; });
$parcel$export(module.exports, "createBox", function () { return $370c7f7f7e65d7c8$export$6459fc9e86be362e; });
$parcel$export(module.exports, "offset", function () { return $370c7f7f7e65d7c8$export$cc800923e997bb8; });
$parcel$export(module.exports, "withScroll", function () { return $370c7f7f7e65d7c8$export$1d0caec378d7d0ae; });
$parcel$export(module.exports, "calculateBox", function () { return $370c7f7f7e65d7c8$export$b8dfc5d4e552b8e1; });
$parcel$export(module.exports, "getBox", function () { return $370c7f7f7e65d7c8$export$34928e660d2a8702; });

var $k1HSa = parcelRequire("k1HSa");
var $370c7f7f7e65d7c8$export$4b834cebd9e5cebe = function getRect(_ref) {
    var top = _ref.top, right = _ref.right, bottom = _ref.bottom, left = _ref.left;
    var width = right - left;
    var height = bottom - top;
    var rect = {
        top: top,
        right: right,
        bottom: bottom,
        left: left,
        width: width,
        height: height,
        x: left,
        y: top,
        center: {
            x: (right + left) / 2,
            y: (bottom + top) / 2
        }
    };
    return rect;
};
var $370c7f7f7e65d7c8$export$9f77e0932fb78f72 = function expand(target, expandBy) {
    return {
        top: target.top - expandBy.top,
        left: target.left - expandBy.left,
        bottom: target.bottom + expandBy.bottom,
        right: target.right + expandBy.right
    };
};
var $370c7f7f7e65d7c8$export$8b1f3092f5e28575 = function shrink(target, shrinkBy) {
    return {
        top: target.top + shrinkBy.top,
        left: target.left + shrinkBy.left,
        bottom: target.bottom - shrinkBy.bottom,
        right: target.right - shrinkBy.right
    };
};
var $370c7f7f7e65d7c8$var$shift = function shift(target, shiftBy) {
    return {
        top: target.top + shiftBy.y,
        left: target.left + shiftBy.x,
        bottom: target.bottom + shiftBy.y,
        right: target.right + shiftBy.x
    };
};
var $370c7f7f7e65d7c8$var$noSpacing = {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
};
var $370c7f7f7e65d7c8$export$6459fc9e86be362e = function createBox(_ref2) {
    var borderBox = _ref2.borderBox, _ref2$margin = _ref2.margin, margin = _ref2$margin === void 0 ? $370c7f7f7e65d7c8$var$noSpacing : _ref2$margin, _ref2$border = _ref2.border, border = _ref2$border === void 0 ? $370c7f7f7e65d7c8$var$noSpacing : _ref2$border, _ref2$padding = _ref2.padding, padding = _ref2$padding === void 0 ? $370c7f7f7e65d7c8$var$noSpacing : _ref2$padding;
    var marginBox = $370c7f7f7e65d7c8$export$4b834cebd9e5cebe($370c7f7f7e65d7c8$export$9f77e0932fb78f72(borderBox, margin));
    var paddingBox = $370c7f7f7e65d7c8$export$4b834cebd9e5cebe($370c7f7f7e65d7c8$export$8b1f3092f5e28575(borderBox, border));
    var contentBox = $370c7f7f7e65d7c8$export$4b834cebd9e5cebe($370c7f7f7e65d7c8$export$8b1f3092f5e28575(paddingBox, padding));
    return {
        marginBox: marginBox,
        borderBox: $370c7f7f7e65d7c8$export$4b834cebd9e5cebe(borderBox),
        paddingBox: paddingBox,
        contentBox: contentBox,
        margin: margin,
        border: border,
        padding: padding
    };
};
var $370c7f7f7e65d7c8$var$parse = function parse(raw) {
    var value = raw.slice(0, -2);
    var suffix = raw.slice(-2);
    if (suffix !== "px") return 0;
    var result = Number(value);
    !!isNaN(result) && (0, $k1HSa.default)(false);
    return result;
};
var $370c7f7f7e65d7c8$var$getWindowScroll = function getWindowScroll() {
    return {
        x: window.pageXOffset,
        y: window.pageYOffset
    };
};
var $370c7f7f7e65d7c8$export$cc800923e997bb8 = function offset(original, change) {
    var borderBox = original.borderBox, border = original.border, margin = original.margin, padding = original.padding;
    var shifted = $370c7f7f7e65d7c8$var$shift(borderBox, change);
    return $370c7f7f7e65d7c8$export$6459fc9e86be362e({
        borderBox: shifted,
        border: border,
        margin: margin,
        padding: padding
    });
};
var $370c7f7f7e65d7c8$export$1d0caec378d7d0ae = function withScroll(original, scroll) {
    if (scroll === void 0) scroll = $370c7f7f7e65d7c8$var$getWindowScroll();
    return $370c7f7f7e65d7c8$export$cc800923e997bb8(original, scroll);
};
var $370c7f7f7e65d7c8$export$b8dfc5d4e552b8e1 = function calculateBox(borderBox, styles) {
    var margin = {
        top: $370c7f7f7e65d7c8$var$parse(styles.marginTop),
        right: $370c7f7f7e65d7c8$var$parse(styles.marginRight),
        bottom: $370c7f7f7e65d7c8$var$parse(styles.marginBottom),
        left: $370c7f7f7e65d7c8$var$parse(styles.marginLeft)
    };
    var padding = {
        top: $370c7f7f7e65d7c8$var$parse(styles.paddingTop),
        right: $370c7f7f7e65d7c8$var$parse(styles.paddingRight),
        bottom: $370c7f7f7e65d7c8$var$parse(styles.paddingBottom),
        left: $370c7f7f7e65d7c8$var$parse(styles.paddingLeft)
    };
    var border = {
        top: $370c7f7f7e65d7c8$var$parse(styles.borderTopWidth),
        right: $370c7f7f7e65d7c8$var$parse(styles.borderRightWidth),
        bottom: $370c7f7f7e65d7c8$var$parse(styles.borderBottomWidth),
        left: $370c7f7f7e65d7c8$var$parse(styles.borderLeftWidth)
    };
    return $370c7f7f7e65d7c8$export$6459fc9e86be362e({
        borderBox: borderBox,
        margin: margin,
        padding: padding,
        border: border
    });
};
var $370c7f7f7e65d7c8$export$34928e660d2a8702 = function getBox(el) {
    var borderBox = el.getBoundingClientRect();
    var styles = window.getComputedStyle(el);
    return $370c7f7f7e65d7c8$export$b8dfc5d4e552b8e1(borderBox, styles);
};

});
parcelRegister("k1HSa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e945eed970c4e833$export$2e2bcd8739ae039; });
var $e945eed970c4e833$var$isProduction = true;
var $e945eed970c4e833$var$prefix = "Invariant failed";
function $e945eed970c4e833$export$2e2bcd8739ae039(condition, message) {
    if (condition) return;
    if ($e945eed970c4e833$var$isProduction) throw new Error($e945eed970c4e833$var$prefix);
    var provided = typeof message === "function" ? message() : message;
    var value = provided ? "".concat($e945eed970c4e833$var$prefix, ": ").concat(provided) : $e945eed970c4e833$var$prefix;
    throw new Error(value);
}

});


parcelRegister("kQ1m2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f2b9b6ecb890a642$export$2e2bcd8739ae039; });
var $f2b9b6ecb890a642$var$safeIsNaN = Number.isNaN || function ponyfill(value) {
    return typeof value === "number" && value !== value;
};
function $f2b9b6ecb890a642$var$isEqual(first, second) {
    if (first === second) return true;
    if ($f2b9b6ecb890a642$var$safeIsNaN(first) && $f2b9b6ecb890a642$var$safeIsNaN(second)) return true;
    return false;
}
function $f2b9b6ecb890a642$var$areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(var i = 0; i < newInputs.length; i++){
        if (!$f2b9b6ecb890a642$var$isEqual(newInputs[i], lastInputs[i])) return false;
    }
    return true;
}
function $f2b9b6ecb890a642$var$memoizeOne(resultFn, isEqual) {
    if (isEqual === void 0) isEqual = $f2b9b6ecb890a642$var$areInputsEqual;
    var lastThis;
    var lastArgs = [];
    var lastResult;
    var calledOnce = false;
    function memoized() {
        var newArgs = [];
        for(var _i = 0; _i < arguments.length; _i++)newArgs[_i] = arguments[_i];
        if (calledOnce && lastThis === this && isEqual(newArgs, lastArgs)) return lastResult;
        lastResult = resultFn.apply(this, newArgs);
        calledOnce = true;
        lastThis = this;
        lastArgs = newArgs;
        return lastResult;
    }
    return memoized;
}
var $f2b9b6ecb890a642$export$2e2bcd8739ae039 = $f2b9b6ecb890a642$var$memoizeOne;

});

parcelRegister("lqlwE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f98cb93819e90452$export$2e2bcd8739ae039; });
var $f98cb93819e90452$var$rafSchd = function rafSchd(fn) {
    var lastArgs = [];
    var frameId = null;
    var wrapperFn = function wrapperFn() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        lastArgs = args;
        if (frameId) return;
        frameId = requestAnimationFrame(function() {
            frameId = null;
            fn.apply(void 0, lastArgs);
        });
    };
    wrapperFn.cancel = function() {
        if (!frameId) return;
        cancelAnimationFrame(frameId);
        frameId = null;
    };
    return wrapperFn;
};
var $f98cb93819e90452$export$2e2bcd8739ae039 = $f98cb93819e90452$var$rafSchd;

});





parcelRegister("8MAXm", function(module, exports) {

$parcel$export(module.exports, "MarkdownView", function () { return $664f7939f52bdd5d$export$d5163f1ce1e6a5f9; });

var $4vwom = parcelRequire("4vwom");

var $f2yFo = parcelRequire("f2yFo");

var $hjid1 = parcelRequire("hjid1");

var $aIeEI = parcelRequire("aIeEI");

var $dUDPg = parcelRequire("dUDPg");
function $664f7939f52bdd5d$export$d5163f1ce1e6a5f9({ value: markdown, renderers: additionalRenderers = {} }) {
    const localize = (0, $aIeEI.useLocalize)();
    if (markdown && typeof markdown === "object") markdown = localize(markdown);
    return (0, $4vwom.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($f2yFo))), {
        renderers: Object.assign(Object.assign({}, $664f7939f52bdd5d$var$renderers), additionalRenderers),
        plugins: [
            (0, (/*@__PURE__*/$parcel$interopDefault($hjid1)))
        ],
        children: markdown
    });
}
// Make images in Markdown not render outside their container
const $664f7939f52bdd5d$var$renderers = {
    image: ({ alt: alt, src: src, title: title })=>{
        if (alt && alt.startsWith("#MARKDOWN_SNIPPET")) {
            const id = src;
            return (0, $4vwom.jsx)($664f7939f52bdd5d$var$MarkdownSnippetView, {
                id: id
            });
        }
        if (alt && alt.startsWith("#IFRAME")) {
            // Styles are encoded like this: #IFRAME{"width":100,"height":400}
            const iframeStyle = alt.length > 7 ? JSON.parse(alt.slice(7)) : {};
            return (0, $4vwom.jsx)("iframe", {
                src: src,
                style: Object.assign({
                    width: "100%",
                    maxWidth: 480,
                    height: 500
                }, iframeStyle)
            });
        }
        return (0, $4vwom.jsx)("img", {
            alt: alt,
            src: src,
            title: title,
            style: {
                maxWidth: "100%"
            }
        });
    },
    link (props) {
        const href = props.href;
        if (href.startsWith("new-tab/")) return (0, $4vwom.jsx)("a", {
            href: "https://" + href.substr(8),
            target: "_blank",
            children: props.children
        });
        if (href.startsWith("new-tab-local/")) return (0, $4vwom.jsx)("a", {
            href: href.substr(14),
            target: "_blank",
            children: props.children
        });
        return (0, $4vwom.jsx)("a", Object.assign({}, props));
    }
};
function $664f7939f52bdd5d$var$MarkdownSnippetView({ id: id }) {
    const { data: snippet } = (0, $dUDPg.useMarkdownSnippet)(id);
    return (0, $4vwom.jsx)($664f7939f52bdd5d$export$d5163f1ce1e6a5f9, {
        value: snippet === null || snippet === void 0 ? void 0 : snippet.hydratedSnippet
    });
}

});
parcelRegister("hjid1", function(module, exports) {
"use strict";

var $eomYt = parcelRequire("eomYt");

var $1sn4o = parcelRequire("1sn4o");

var $29uTM = parcelRequire("29uTM");
var $c9a255f05f3396ab$var$warningIssued;
module.exports = $c9a255f05f3396ab$var$gfm;
function $c9a255f05f3396ab$var$gfm(options) {
    var data = this.data();
    /* istanbul ignore next - old remark. */ if (!$c9a255f05f3396ab$var$warningIssued && (this.Parser && this.Parser.prototype && this.Parser.prototype.blockTokenizers || this.Compiler && this.Compiler.prototype && this.Compiler.prototype.visitors)) {
        $c9a255f05f3396ab$var$warningIssued = true;
        console.warn("[remark-gfm] Warning: please upgrade to remark 13 to use this plugin");
    }
    add("micromarkExtensions", $eomYt(options));
    add("fromMarkdownExtensions", $1sn4o);
    add("toMarkdownExtensions", $29uTM(options));
    function add(field, value) {
        /* istanbul ignore if - other extensions. */ if (data[field]) data[field].push(value);
        else data[field] = [
            value
        ];
    }
}

});
parcelRegister("eomYt", function(module, exports) {

module.exports = (parcelRequire("3dDsR"));

});
parcelRegister("3dDsR", function(module, exports) {

var $jL26E = parcelRequire("jL26E");

var $cBdJZ = parcelRequire("cBdJZ");

var $hyn7t = parcelRequire("hyn7t");

var $4Sxls = parcelRequire("4Sxls");

var $ljA2K = parcelRequire("ljA2K");
module.exports = $258132cc1f8b076c$var$create;
function $258132cc1f8b076c$var$create(options) {
    return $jL26E([
        $cBdJZ,
        $hyn7t(options),
        $4Sxls,
        $ljA2K
    ]);
}

});
parcelRegister("cBdJZ", function(module, exports) {

module.exports = (parcelRequire("agBAc"));

});
parcelRegister("agBAc", function(module, exports) {

$parcel$export(module.exports, "text", function () { return $77988d2c8a5d74ba$export$6f093cfa640b7166; }, function (v) { return $77988d2c8a5d74ba$export$6f093cfa640b7166 = v; });
// Export hooked constructs.
var $77988d2c8a5d74ba$export$6f093cfa640b7166;

var $gMacN = parcelRequire("gMacN");

var $ja7BD = parcelRequire("ja7BD");

var $glVfv = parcelRequire("glVfv");

var $bl5Ae = parcelRequire("bl5Ae");

var $eavH7 = parcelRequire("eavH7");

var $1mH0l = parcelRequire("1mH0l");
var $77988d2c8a5d74ba$var$www = {
    tokenize: $77988d2c8a5d74ba$var$tokenizeWww,
    partial: true
};
var $77988d2c8a5d74ba$var$domain = {
    tokenize: $77988d2c8a5d74ba$var$tokenizeDomain,
    partial: true
};
var $77988d2c8a5d74ba$var$path = {
    tokenize: $77988d2c8a5d74ba$var$tokenizePath,
    partial: true
};
var $77988d2c8a5d74ba$var$punctuation = {
    tokenize: $77988d2c8a5d74ba$var$tokenizePunctuation,
    partial: true
};
var $77988d2c8a5d74ba$var$namedCharacterReference = {
    tokenize: $77988d2c8a5d74ba$var$tokenizeNamedCharacterReference,
    partial: true
};
var $77988d2c8a5d74ba$var$wwwAutolink = {
    tokenize: $77988d2c8a5d74ba$var$tokenizeWwwAutolink,
    previous: $77988d2c8a5d74ba$var$previousWww
};
var $77988d2c8a5d74ba$var$httpAutolink = {
    tokenize: $77988d2c8a5d74ba$var$tokenizeHttpAutolink,
    previous: $77988d2c8a5d74ba$var$previousHttp
};
var $77988d2c8a5d74ba$var$emailAutolink = {
    tokenize: $77988d2c8a5d74ba$var$tokenizeEmailAutolink,
    previous: $77988d2c8a5d74ba$var$previousEmail
};
var $77988d2c8a5d74ba$var$text = {};
$77988d2c8a5d74ba$export$6f093cfa640b7166 = $77988d2c8a5d74ba$var$text;
// `0`
var $77988d2c8a5d74ba$var$code = 48;
// While the code is smaller than `{`.
while($77988d2c8a5d74ba$var$code < 123){
    $77988d2c8a5d74ba$var$text[$77988d2c8a5d74ba$var$code] = $77988d2c8a5d74ba$var$emailAutolink;
    $77988d2c8a5d74ba$var$code++;
    // Jump from `:` -> `A`
    if ($77988d2c8a5d74ba$var$code === 58) $77988d2c8a5d74ba$var$code = 65;
    else if ($77988d2c8a5d74ba$var$code === 91) $77988d2c8a5d74ba$var$code = 97;
}
// `+`
$77988d2c8a5d74ba$var$text[43] = $77988d2c8a5d74ba$var$emailAutolink;
// `-`
$77988d2c8a5d74ba$var$text[45] = $77988d2c8a5d74ba$var$emailAutolink;
// `.`
$77988d2c8a5d74ba$var$text[46] = $77988d2c8a5d74ba$var$emailAutolink;
// `_`
$77988d2c8a5d74ba$var$text[95] = $77988d2c8a5d74ba$var$emailAutolink;
// `h`.
$77988d2c8a5d74ba$var$text[72] = [
    $77988d2c8a5d74ba$var$emailAutolink,
    $77988d2c8a5d74ba$var$httpAutolink
];
$77988d2c8a5d74ba$var$text[104] = [
    $77988d2c8a5d74ba$var$emailAutolink,
    $77988d2c8a5d74ba$var$httpAutolink
];
// `w`.
$77988d2c8a5d74ba$var$text[87] = [
    $77988d2c8a5d74ba$var$emailAutolink,
    $77988d2c8a5d74ba$var$wwwAutolink
];
$77988d2c8a5d74ba$var$text[119] = [
    $77988d2c8a5d74ba$var$emailAutolink,
    $77988d2c8a5d74ba$var$wwwAutolink
];
function $77988d2c8a5d74ba$var$tokenizeEmailAutolink(effects, ok, nok) {
    var self = this;
    var hasDot;
    return start;
    function start(code) {
        /* istanbul ignore next - hooks. */ if (!$77988d2c8a5d74ba$var$gfmAtext(code) || !$77988d2c8a5d74ba$var$previousEmail(self.previous) || $77988d2c8a5d74ba$var$previous(self.events)) return nok(code);
        effects.enter("literalAutolink");
        effects.enter("literalAutolinkEmail");
        return atext(code);
    }
    function atext(code) {
        if ($77988d2c8a5d74ba$var$gfmAtext(code)) {
            effects.consume(code);
            return atext;
        }
        // `@`
        if (code === 64) {
            effects.consume(code);
            return label;
        }
        return nok(code);
    }
    function label(code) {
        // `.`
        if (code === 46) return effects.check($77988d2c8a5d74ba$var$punctuation, done, dotContinuation)(code);
        if (// `-`
        code === 45 || // `_`
        code === 95) return effects.check($77988d2c8a5d74ba$var$punctuation, nok, dashOrUnderscoreContinuation)(code);
        if ($ja7BD(code)) {
            effects.consume(code);
            return label;
        }
        return done(code);
    }
    function dotContinuation(code) {
        effects.consume(code);
        hasDot = true;
        return label;
    }
    function dashOrUnderscoreContinuation(code) {
        effects.consume(code);
        return afterDashOrUnderscore;
    }
    function afterDashOrUnderscore(code) {
        // `.`
        if (code === 46) return effects.check($77988d2c8a5d74ba$var$punctuation, nok, dotContinuation)(code);
        return label(code);
    }
    function done(code) {
        if (hasDot) {
            effects.exit("literalAutolinkEmail");
            effects.exit("literalAutolink");
            return ok(code);
        }
        return nok(code);
    }
}
function $77988d2c8a5d74ba$var$tokenizeWwwAutolink(effects, ok, nok) {
    var self = this;
    return start;
    function start(code) {
        /* istanbul ignore next - hooks. */ if (code !== 87 && code - 32 !== 87 || !$77988d2c8a5d74ba$var$previousWww(self.previous) || $77988d2c8a5d74ba$var$previous(self.events)) return nok(code);
        effects.enter("literalAutolink");
        effects.enter("literalAutolinkWww");
        // For `www.` we check instead of attempt, because when it matches, GH
        // treats it as part of a domain (yes, it says a valid domain must come
        // after `www.`, but that’s not how it’s implemented by them).
        return effects.check($77988d2c8a5d74ba$var$www, effects.attempt($77988d2c8a5d74ba$var$domain, effects.attempt($77988d2c8a5d74ba$var$path, done), nok), nok)(code);
    }
    function done(code) {
        effects.exit("literalAutolinkWww");
        effects.exit("literalAutolink");
        return ok(code);
    }
}
function $77988d2c8a5d74ba$var$tokenizeHttpAutolink(effects, ok, nok) {
    var self = this;
    return start;
    function start(code) {
        /* istanbul ignore next - hooks. */ if (code !== 72 && code - 32 !== 72 || !$77988d2c8a5d74ba$var$previousHttp(self.previous) || $77988d2c8a5d74ba$var$previous(self.events)) return nok(code);
        effects.enter("literalAutolink");
        effects.enter("literalAutolinkHttp");
        effects.consume(code);
        return t1;
    }
    function t1(code) {
        // `t`
        if (code === 84 || code - 32 === 84) {
            effects.consume(code);
            return t2;
        }
        return nok(code);
    }
    function t2(code) {
        // `t`
        if (code === 84 || code - 32 === 84) {
            effects.consume(code);
            return p;
        }
        return nok(code);
    }
    function p(code) {
        // `p`
        if (code === 80 || code - 32 === 80) {
            effects.consume(code);
            return s;
        }
        return nok(code);
    }
    function s(code) {
        // `s`
        if (code === 83 || code - 32 === 83) {
            effects.consume(code);
            return colon;
        }
        return colon(code);
    }
    function colon(code) {
        // `:`
        if (code === 58) {
            effects.consume(code);
            return slash1;
        }
        return nok(code);
    }
    function slash1(code) {
        // `/`
        if (code === 47) {
            effects.consume(code);
            return slash2;
        }
        return nok(code);
    }
    function slash2(code) {
        // `/`
        if (code === 47) {
            effects.consume(code);
            return after;
        }
        return nok(code);
    }
    function after(code) {
        return $glVfv(code) || $1mH0l(code) || $eavH7(code) ? nok(code) : effects.attempt($77988d2c8a5d74ba$var$domain, effects.attempt($77988d2c8a5d74ba$var$path, done), nok)(code);
    }
    function done(code) {
        effects.exit("literalAutolinkHttp");
        effects.exit("literalAutolink");
        return ok(code);
    }
}
function $77988d2c8a5d74ba$var$tokenizeWww(effects, ok, nok) {
    return start;
    function start(code) {
        // Assume a `w`.
        effects.consume(code);
        return w2;
    }
    function w2(code) {
        // `w`
        if (code === 87 || code - 32 === 87) {
            effects.consume(code);
            return w3;
        }
        return nok(code);
    }
    function w3(code) {
        // `w`
        if (code === 87 || code - 32 === 87) {
            effects.consume(code);
            return dot;
        }
        return nok(code);
    }
    function dot(code) {
        // `.`
        if (code === 46) {
            effects.consume(code);
            return after;
        }
        return nok(code);
    }
    function after(code) {
        return code === null || $bl5Ae(code) ? nok(code) : ok(code);
    }
}
function $77988d2c8a5d74ba$var$tokenizeDomain(effects, ok, nok) {
    var hasUnderscoreInLastSegment;
    var hasUnderscoreInLastLastSegment;
    return domain;
    function domain(code) {
        // `&`
        if (code === 38) return effects.check($77988d2c8a5d74ba$var$namedCharacterReference, done, punctuationContinuation)(code);
        if (code === 46 /* `.` */  || code === 95 /* `_` */ ) return effects.check($77988d2c8a5d74ba$var$punctuation, done, punctuationContinuation)(code);
        // GH documents that only alphanumerics (other than `-`, `.`, and `_`) can
        // occur, which sounds like ASCII only, but they also support `www.點看.com`,
        // so that’s Unicode.
        // Instead of some new production for Unicode alphanumerics, markdown
        // already has that for Unicode punctuation and whitespace, so use those.
        if ($glVfv(code) || $1mH0l(code) || code !== 45 /* `-` */  && $eavH7(code)) return done(code);
        effects.consume(code);
        return domain;
    }
    function punctuationContinuation(code) {
        // `.`
        if (code === 46) {
            hasUnderscoreInLastLastSegment = hasUnderscoreInLastSegment;
            hasUnderscoreInLastSegment = undefined;
            effects.consume(code);
            return domain;
        }
        // `_`
        if (code === 95) hasUnderscoreInLastSegment = true;
        effects.consume(code);
        return domain;
    }
    function done(code) {
        if (!hasUnderscoreInLastLastSegment && !hasUnderscoreInLastSegment) return ok(code);
        return nok(code);
    }
}
function $77988d2c8a5d74ba$var$tokenizePath(effects, ok) {
    var balance = 0;
    return inPath;
    function inPath(code) {
        // `&`
        if (code === 38) return effects.check($77988d2c8a5d74ba$var$namedCharacterReference, ok, continuedPunctuation)(code);
        // `(`
        if (code === 40) balance++;
        // `)`
        if (code === 41) return effects.check($77988d2c8a5d74ba$var$punctuation, parenAtPathEnd, continuedPunctuation)(code);
        if ($77988d2c8a5d74ba$var$pathEnd(code)) return ok(code);
        if ($77988d2c8a5d74ba$var$trailingPunctuation(code)) return effects.check($77988d2c8a5d74ba$var$punctuation, ok, continuedPunctuation)(code);
        effects.consume(code);
        return inPath;
    }
    function continuedPunctuation(code) {
        effects.consume(code);
        return inPath;
    }
    function parenAtPathEnd(code) {
        balance--;
        return balance < 0 ? ok(code) : continuedPunctuation(code);
    }
}
function $77988d2c8a5d74ba$var$tokenizeNamedCharacterReference(effects, ok, nok) {
    return start;
    function start(code) {
        // Assume an ampersand.
        effects.consume(code);
        return inside;
    }
    function inside(code) {
        if ($gMacN(code)) {
            effects.consume(code);
            return inside;
        }
        // `;`
        if (code === 59) {
            effects.consume(code);
            return after;
        }
        return nok(code);
    }
    function after(code) {
        // If the named character reference is followed by the end of the path, it’s
        // not continued punctuation.
        return $77988d2c8a5d74ba$var$pathEnd(code) ? ok(code) : nok(code);
    }
}
function $77988d2c8a5d74ba$var$tokenizePunctuation(effects, ok, nok) {
    return start;
    function start(code) {
        // Always a valid trailing punctuation marker.
        effects.consume(code);
        return after;
    }
    function after(code) {
        // Check the next.
        if ($77988d2c8a5d74ba$var$trailingPunctuation(code)) {
            effects.consume(code);
            return after;
        }
        // If the punctuation marker is followed by the end of the path, it’s not
        // continued punctuation.
        return $77988d2c8a5d74ba$var$pathEnd(code) ? ok(code) : nok(code);
    }
}
function $77988d2c8a5d74ba$var$trailingPunctuation(code) {
    return(// `!`
    code === 33 || // `"`
    code === 34 || // `'`
    code === 39 || // `)`
    code === 41 || // `*`
    code === 42 || // `,`
    code === 44 || // `.`
    code === 46 || // `:`
    code === 58 || // `;`
    code === 59 || // `<`
    code === 60 || // `?`
    code === 63 || // `_`.
    code === 95 || // `~`
    code === 126);
}
function $77988d2c8a5d74ba$var$pathEnd(code) {
    return(// EOF.
    code === null || // CR, LF, CRLF, HT, VS.
    code < 0 || // Space.
    code === 32 || // `<`
    code === 60);
}
function $77988d2c8a5d74ba$var$gfmAtext(code) {
    return code === 43 /* `+` */  || code === 45 /* `-` */  || code === 46 /* `.` */  || code === 95 /* `_` */  || $ja7BD(code);
}
function $77988d2c8a5d74ba$var$previousWww(code) {
    return code === null || code < 0 || code === 32 /* ` ` */  || code === 40 /* `(` */  || code === 42 /* `*` */  || code === 95 /* `_` */  || code === 126 /* `~` */ ;
}
function $77988d2c8a5d74ba$var$previousHttp(code) {
    return code === null || !$gMacN(code);
}
function $77988d2c8a5d74ba$var$previousEmail(code) {
    return code !== 47 /* `/` */  && $77988d2c8a5d74ba$var$previousHttp(code);
}
function $77988d2c8a5d74ba$var$previous(events) {
    var index = events.length;
    while(index--){
        if ((events[index][1].type === "labelLink" || events[index][1].type === "labelImage") && !events[index][1]._balanced) return true;
    }
}

});


parcelRegister("hyn7t", function(module, exports) {
module.exports = $cc778bb6820bed29$var$create;

var $372dT = parcelRequire("372dT");

var $9Q1oe = parcelRequire("9Q1oe");

var $5ZU3u = parcelRequire("5ZU3u");

var $1Gh3S = parcelRequire("1Gh3S");
function $cc778bb6820bed29$var$create(options) {
    var settings = options || {};
    var single = settings.singleTilde;
    var tokenizer = {
        tokenize: tokenizeStrikethrough,
        resolveAll: resolveAllStrikethrough
    };
    if (single === null || single === undefined) single = true;
    return {
        text: {
            126: tokenizer
        },
        insideSpan: {
            null: tokenizer
        }
    };
    // Take events and resolve strikethrough.
    function resolveAllStrikethrough(events, context) {
        var index = -1;
        var strikethrough;
        var text;
        var open;
        var nextEvents;
        // Walk through all events.
        while(++index < events.length)// Find a token that can close.
        if (events[index][0] === "enter" && events[index][1].type === "strikethroughSequenceTemporary" && events[index][1]._close) {
            open = index;
            // Now walk back to find an opener.
            while(open--)// Find a token that can open the closer.
            if (events[open][0] === "exit" && events[open][1].type === "strikethroughSequenceTemporary" && events[open][1]._open && // If the sizes are the same:
            events[index][1].end.offset - events[index][1].start.offset === events[open][1].end.offset - events[open][1].start.offset) {
                events[index][1].type = "strikethroughSequence";
                events[open][1].type = "strikethroughSequence";
                strikethrough = {
                    type: "strikethrough",
                    start: $1Gh3S(events[open][1].start),
                    end: $1Gh3S(events[index][1].end)
                };
                text = {
                    type: "strikethroughText",
                    start: $1Gh3S(events[open][1].end),
                    end: $1Gh3S(events[index][1].start)
                };
                // Opening.
                nextEvents = [
                    [
                        "enter",
                        strikethrough,
                        context
                    ],
                    [
                        "enter",
                        events[open][1],
                        context
                    ],
                    [
                        "exit",
                        events[open][1],
                        context
                    ],
                    [
                        "enter",
                        text,
                        context
                    ]
                ];
                // Between.
                $9Q1oe(nextEvents, nextEvents.length, 0, $5ZU3u(context.parser.constructs.insideSpan.null, events.slice(open + 1, index), context));
                // Closing.
                $9Q1oe(nextEvents, nextEvents.length, 0, [
                    [
                        "exit",
                        text,
                        context
                    ],
                    [
                        "enter",
                        events[index][1],
                        context
                    ],
                    [
                        "exit",
                        events[index][1],
                        context
                    ],
                    [
                        "exit",
                        strikethrough,
                        context
                    ]
                ]);
                $9Q1oe(events, open - 1, index - open + 3, nextEvents);
                index = open + nextEvents.length - 2;
                break;
            }
        }
        return removeRemainingSequences(events);
    }
    function removeRemainingSequences(events) {
        var index = -1;
        var length = events.length;
        while(++index < length)if (events[index][1].type === "strikethroughSequenceTemporary") events[index][1].type = "data";
        return events;
    }
    function tokenizeStrikethrough(effects, ok, nok) {
        var previous = this.previous;
        var events = this.events;
        var size = 0;
        return start;
        function start(code) {
            if (code !== 126 || previous === 126 && events[events.length - 1][1].type !== "characterEscape") return nok(code);
            effects.enter("strikethroughSequenceTemporary");
            return more(code);
        }
        function more(code) {
            var before = $372dT(previous);
            var token;
            var after;
            if (code === 126) {
                // If this is the third marker, exit.
                if (size > 1) return nok(code);
                effects.consume(code);
                size++;
                return more;
            }
            if (size < 2 && !single) return nok(code);
            token = effects.exit("strikethroughSequenceTemporary");
            after = $372dT(code);
            token._open = !after || after === 2 && before;
            token._close = !before || before === 2 && after;
            return ok(code);
        }
    }
}

});

parcelRegister("4Sxls", function(module, exports) {

module.exports = (parcelRequire("sBlC2"));

});
parcelRegister("sBlC2", function(module, exports) {

$parcel$export(module.exports, "flow", function () { return $055f9617ca75eeb3$export$ccc7b0636abaffc3; }, function (v) { return $055f9617ca75eeb3$export$ccc7b0636abaffc3 = v; });
var $055f9617ca75eeb3$export$ccc7b0636abaffc3;
$055f9617ca75eeb3$export$ccc7b0636abaffc3 = {
    null: {
        tokenize: $055f9617ca75eeb3$var$tokenizeTable,
        resolve: $055f9617ca75eeb3$var$resolveTable,
        interruptible: true
    }
};

var $10n72 = parcelRequire("10n72");
var $055f9617ca75eeb3$var$setextUnderlineMini = {
    tokenize: $055f9617ca75eeb3$var$tokenizeSetextUnderlineMini,
    partial: true
};
var $055f9617ca75eeb3$var$nextPrefixedOrBlank = {
    tokenize: $055f9617ca75eeb3$var$tokenizeNextPrefixedOrBlank,
    partial: true
};
function $055f9617ca75eeb3$var$resolveTable(events, context) {
    var length = events.length;
    var index = -1;
    var token;
    var inHead;
    var inDelimiterRow;
    var inRow;
    var cell;
    var content;
    var text;
    var contentStart;
    var contentEnd;
    var cellStart;
    while(++index < length){
        token = events[index][1];
        if (inRow) {
            if (token.type === "temporaryTableCellContent") {
                contentStart = contentStart || index;
                contentEnd = index;
            }
            if (// Combine separate content parts into one.
            (token.type === "tableCellDivider" || token.type === "tableRow") && contentEnd) {
                content = {
                    type: "tableContent",
                    start: events[contentStart][1].start,
                    end: events[contentEnd][1].end
                };
                text = {
                    type: "chunkText",
                    start: content.start,
                    end: content.end,
                    contentType: "text"
                };
                events.splice(contentStart, contentEnd - contentStart + 1, [
                    "enter",
                    content,
                    context
                ], [
                    "enter",
                    text,
                    context
                ], [
                    "exit",
                    text,
                    context
                ], [
                    "exit",
                    content,
                    context
                ]);
                index -= contentEnd - contentStart - 3;
                length = events.length;
                contentStart = undefined;
                contentEnd = undefined;
            }
        }
        if (events[index][0] === "exit" && cellStart && cellStart + 1 < index && (token.type === "tableCellDivider" || token.type === "tableRow" && (cellStart + 3 < index || events[cellStart][1].type !== "whitespace"))) {
            cell = {
                type: inDelimiterRow ? "tableDelimiter" : inHead ? "tableHeader" : "tableData",
                start: events[cellStart][1].start,
                end: events[index][1].end
            };
            events.splice(index + (token.type === "tableCellDivider" ? 1 : 0), 0, [
                "exit",
                cell,
                context
            ]);
            events.splice(cellStart, 0, [
                "enter",
                cell,
                context
            ]);
            index += 2;
            length = events.length;
            cellStart = index + 1;
        }
        if (token.type === "tableRow") {
            inRow = events[index][0] === "enter";
            if (inRow) cellStart = index + 1;
        }
        if (token.type === "tableDelimiterRow") {
            inDelimiterRow = events[index][0] === "enter";
            if (inDelimiterRow) cellStart = index + 1;
        }
        if (token.type === "tableHead") inHead = events[index][0] === "enter";
    }
    return events;
}
function $055f9617ca75eeb3$var$tokenizeTable(effects, ok, nok) {
    var align = [];
    var tableHeaderCount = 0;
    var seenDelimiter;
    var hasDash;
    return start;
    function start(code) {
        /* istanbul ignore if - used to be passed in beta micromark versions. */ if (code === null || code === -5 || code === -4 || code === -3) return nok(code);
        effects.enter("table")._align = align;
        effects.enter("tableHead");
        effects.enter("tableRow");
        // If we start with a pipe, we open a cell marker.
        if (code === 124) return cellDividerHead(code);
        tableHeaderCount++;
        effects.enter("temporaryTableCellContent");
        // Can’t be space or eols at the start of a construct, so we’re in a cell.
        return inCellContentHead(code);
    }
    function cellDividerHead(code) {
        // Always a pipe.
        effects.enter("tableCellDivider");
        effects.consume(code);
        effects.exit("tableCellDivider");
        seenDelimiter = true;
        return cellBreakHead;
    }
    function cellBreakHead(code) {
        // EOF, CR, LF, CRLF.
        if (code === null || code === -5 || code === -4 || code === -3) return atRowEndHead(code);
        // HT, VS, SP.
        if (code === -2 || code === -1 || code === 32) {
            effects.enter("whitespace");
            effects.consume(code);
            return inWhitespaceHead;
        }
        if (seenDelimiter) {
            seenDelimiter = undefined;
            tableHeaderCount++;
        }
        // `|`
        if (code === 124) return cellDividerHead(code);
        // Anything else is cell content.
        effects.enter("temporaryTableCellContent");
        return inCellContentHead(code);
    }
    function inWhitespaceHead(code) {
        // HT, VS, SP.
        if (code === -2 || code === -1 || code === 32) {
            effects.consume(code);
            return inWhitespaceHead;
        }
        effects.exit("whitespace");
        return cellBreakHead(code);
    }
    function inCellContentHead(code) {
        // EOF, whitespace, pipe
        if (code === null || code < 0 || code === 32 || code === 124) {
            effects.exit("temporaryTableCellContent");
            return cellBreakHead(code);
        }
        effects.consume(code);
        // `\`
        return code === 92 ? inCellContentEscapeHead : inCellContentHead;
    }
    function inCellContentEscapeHead(code) {
        // `\` or `|`
        if (code === 92 || code === 124) {
            effects.consume(code);
            return inCellContentHead;
        }
        // Anything else.
        return inCellContentHead(code);
    }
    function atRowEndHead(code) {
        if (code === null) return nok(code);
        effects.exit("tableRow");
        effects.exit("tableHead");
        // Always a line ending.
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        // If a setext heading, exit.
        return effects.check($055f9617ca75eeb3$var$setextUnderlineMini, nok, // Support an indent before the delimiter row.
        $10n72(effects, rowStartDelimiter, "linePrefix", 4));
    }
    function rowStartDelimiter(code) {
        // If there’s another space, or we’re at the EOL/EOF, exit.
        if (code === null || code < 0 || code === 32) return nok(code);
        effects.enter("tableDelimiterRow");
        return atDelimiterRowBreak(code);
    }
    function atDelimiterRowBreak(code) {
        // EOF, CR, LF, CRLF.
        if (code === null || code === -5 || code === -4 || code === -3) return rowEndDelimiter(code);
        // HT, VS, SP.
        if (code === -2 || code === -1 || code === 32) {
            effects.enter("whitespace");
            effects.consume(code);
            return inWhitespaceDelimiter;
        }
        // `-`
        if (code === 45) {
            effects.enter("tableDelimiterFiller");
            effects.consume(code);
            hasDash = true;
            align.push(null);
            return inFillerDelimiter;
        }
        // `:`
        if (code === 58) {
            effects.enter("tableDelimiterAlignment");
            effects.consume(code);
            effects.exit("tableDelimiterAlignment");
            align.push("left");
            return afterLeftAlignment;
        }
        // If we start with a pipe, we open a cell marker.
        if (code === 124) {
            effects.enter("tableCellDivider");
            effects.consume(code);
            effects.exit("tableCellDivider");
            return atDelimiterRowBreak;
        }
        return nok(code);
    }
    function inWhitespaceDelimiter(code) {
        // HT, VS, SP.
        if (code === -2 || code === -1 || code === 32) {
            effects.consume(code);
            return inWhitespaceDelimiter;
        }
        effects.exit("whitespace");
        return atDelimiterRowBreak(code);
    }
    function inFillerDelimiter(code) {
        // `-`
        if (code === 45) {
            effects.consume(code);
            return inFillerDelimiter;
        }
        effects.exit("tableDelimiterFiller");
        // `:`
        if (code === 58) {
            effects.enter("tableDelimiterAlignment");
            effects.consume(code);
            effects.exit("tableDelimiterAlignment");
            align[align.length - 1] = align[align.length - 1] === "left" ? "center" : "right";
            return afterRightAlignment;
        }
        return atDelimiterRowBreak(code);
    }
    function afterLeftAlignment(code) {
        // `-`
        if (code === 45) {
            effects.enter("tableDelimiterFiller");
            effects.consume(code);
            hasDash = true;
            return inFillerDelimiter;
        }
        // Anything else is not ok.
        return nok(code);
    }
    function afterRightAlignment(code) {
        // EOF, CR, LF, CRLF.
        if (code === null || code === -5 || code === -4 || code === -3) return rowEndDelimiter(code);
        // HT, VS, SP.
        if (code === -2 || code === -1 || code === 32) {
            effects.enter("whitespace");
            effects.consume(code);
            return inWhitespaceDelimiter;
        }
        // `|`
        if (code === 124) {
            effects.enter("tableCellDivider");
            effects.consume(code);
            effects.exit("tableCellDivider");
            return atDelimiterRowBreak;
        }
        return nok(code);
    }
    function rowEndDelimiter(code) {
        effects.exit("tableDelimiterRow");
        // Exit if there was no dash at all, or if the header cell count is not the
        // delimiter cell count.
        if (!hasDash || tableHeaderCount !== align.length) return nok(code);
        if (code === null) return tableClose(code);
        return effects.check($055f9617ca75eeb3$var$nextPrefixedOrBlank, tableClose, tableContinue)(code);
    }
    function tableClose(code) {
        effects.exit("table");
        return ok(code);
    }
    function tableContinue(code) {
        // Always a line ending.
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        // We checked that it’s not a prefixed or blank line, so we’re certain a
        // body is coming, though it may be indented.
        return $10n72(effects, bodyStart, "linePrefix", 4);
    }
    function bodyStart(code) {
        effects.enter("tableBody");
        return rowStartBody(code);
    }
    function rowStartBody(code) {
        effects.enter("tableRow");
        // If we start with a pipe, we open a cell marker.
        if (code === 124) return cellDividerBody(code);
        effects.enter("temporaryTableCellContent");
        // Can’t be space or eols at the start of a construct, so we’re in a cell.
        return inCellContentBody(code);
    }
    function cellDividerBody(code) {
        // Always a pipe.
        effects.enter("tableCellDivider");
        effects.consume(code);
        effects.exit("tableCellDivider");
        return cellBreakBody;
    }
    function cellBreakBody(code) {
        // EOF, CR, LF, CRLF.
        if (code === null || code === -5 || code === -4 || code === -3) return atRowEndBody(code);
        // HT, VS, SP.
        if (code === -2 || code === -1 || code === 32) {
            effects.enter("whitespace");
            effects.consume(code);
            return inWhitespaceBody;
        }
        // `|`
        if (code === 124) return cellDividerBody(code);
        // Anything else is cell content.
        effects.enter("temporaryTableCellContent");
        return inCellContentBody(code);
    }
    function inWhitespaceBody(code) {
        // HT, VS, SP.
        if (code === -2 || code === -1 || code === 32) {
            effects.consume(code);
            return inWhitespaceBody;
        }
        effects.exit("whitespace");
        return cellBreakBody(code);
    }
    function inCellContentBody(code) {
        // EOF, whitespace, pipe
        if (code === null || code < 0 || code === 32 || code === 124) {
            effects.exit("temporaryTableCellContent");
            return cellBreakBody(code);
        }
        effects.consume(code);
        // `\`
        return code === 92 ? inCellContentEscapeBody : inCellContentBody;
    }
    function inCellContentEscapeBody(code) {
        // `\` or `|`
        if (code === 92 || code === 124) {
            effects.consume(code);
            return inCellContentBody;
        }
        // Anything else.
        return inCellContentBody(code);
    }
    function atRowEndBody(code) {
        effects.exit("tableRow");
        if (code === null) return tableBodyClose(code);
        return effects.check($055f9617ca75eeb3$var$nextPrefixedOrBlank, tableBodyClose, tableBodyContinue)(code);
    }
    function tableBodyClose(code) {
        effects.exit("tableBody");
        return tableClose(code);
    }
    function tableBodyContinue(code) {
        // Always a line ending.
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        // Support an optional prefix, then start a body row.
        return $10n72(effects, rowStartBody, "linePrefix", 4);
    }
}
// Based on micromark, but that won’t work as we’re in a table, and that expects
// content.
// <https://github.com/micromark/micromark/blob/main/lib/tokenize/setext-underline.js>
function $055f9617ca75eeb3$var$tokenizeSetextUnderlineMini(effects, ok, nok) {
    return start;
    function start(code) {
        // `-`
        if (code !== 45) return nok(code);
        effects.enter("setextUnderline");
        return sequence(code);
    }
    function sequence(code) {
        if (code === 45) {
            effects.consume(code);
            return sequence;
        }
        return whitespace(code);
    }
    function whitespace(code) {
        if (code === -2 || code === -1 || code === 32) {
            effects.consume(code);
            return whitespace;
        }
        if (code === null || code === -5 || code === -4 || code === -3) return ok(code);
        return nok(code);
    }
}
function $055f9617ca75eeb3$var$tokenizeNextPrefixedOrBlank(effects, ok, nok) {
    var size = 0;
    return start;
    function start(code) {
        // This is a check, so we don’t care about tokens, but we open a bogus one
        // so we’re valid.
        effects.enter("check");
        // EOL.
        effects.consume(code);
        return whitespace;
    }
    function whitespace(code) {
        // VS or SP.
        if (code === -1 || code === 32) {
            effects.consume(code);
            size++;
            return size === 4 ? ok : whitespace;
        }
        // EOF or whitespace
        if (code === null || code < 0) return ok(code);
        // Anything else.
        return nok(code);
    }
}

});


parcelRegister("ljA2K", function(module, exports) {

module.exports = (parcelRequire("l5ckF"));

});
parcelRegister("l5ckF", function(module, exports) {

$parcel$export(module.exports, "text", function () { return $f593a18e09975456$export$6f093cfa640b7166; }, function (v) { return $f593a18e09975456$export$6f093cfa640b7166 = v; });
var $f593a18e09975456$export$6f093cfa640b7166;

var $5zMHo = parcelRequire("5zMHo");

var $10n72 = parcelRequire("10n72");

var $bUBdZ = parcelRequire("bUBdZ");
var $f593a18e09975456$var$tasklistCheck = {
    tokenize: $f593a18e09975456$var$tokenizeTasklistCheck
};
$f593a18e09975456$export$6f093cfa640b7166 = {
    91: $f593a18e09975456$var$tasklistCheck
};
function $f593a18e09975456$var$tokenizeTasklistCheck(effects, ok, nok) {
    var self = this;
    return open;
    function open(code) {
        if (// Exit if not `[`.
        code !== 91 || // Exit if there’s stuff before.
        self.previous !== null || // Exit if not in the first content that is the first child of a list
        // item.
        !self._gfmTasklistFirstContentOfListItem) return nok(code);
        effects.enter("taskListCheck");
        effects.enter("taskListCheckMarker");
        effects.consume(code);
        effects.exit("taskListCheckMarker");
        return inside;
    }
    function inside(code) {
        // Tab or space.
        if (code === -2 || code === 32) {
            effects.enter("taskListCheckValueUnchecked");
            effects.consume(code);
            effects.exit("taskListCheckValueUnchecked");
            return close;
        }
        // Upper- and lower `x`.
        if (code === 88 || code === 120) {
            effects.enter("taskListCheckValueChecked");
            effects.consume(code);
            effects.exit("taskListCheckValueChecked");
            return close;
        }
        return nok(code);
    }
    function close(code) {
        // `]`
        if (code === 93) {
            effects.enter("taskListCheckMarker");
            effects.consume(code);
            effects.exit("taskListCheckMarker");
            effects.exit("taskListCheck");
            return effects.check({
                tokenize: $f593a18e09975456$var$spaceThenNonSpace
            }, ok, nok);
        }
        return nok(code);
    }
}
function $f593a18e09975456$var$spaceThenNonSpace(effects, ok, nok) {
    var self = this;
    return $10n72(effects, after, "whitespace");
    function after(code) {
        return $bUBdZ(self.events, "whitespace") && code !== null && !$5zMHo(code) ? ok(code) : nok(code);
    }
}

});




parcelRegister("1sn4o", function(module, exports) {

var $9MVet = parcelRequire("9MVet");

var $dq6Cs = parcelRequire("dq6Cs");

var $4XvDl = parcelRequire("4XvDl");

var $jQVtx = parcelRequire("jQVtx");
var $10fa4d2841b41a6a$var$own = {}.hasOwnProperty;
module.exports = $10fa4d2841b41a6a$var$configure([
    $9MVet,
    $dq6Cs,
    $4XvDl,
    $jQVtx
]);
function $10fa4d2841b41a6a$var$configure(extensions) {
    var config = {
        transforms: [],
        canContainEols: []
    };
    var length = extensions.length;
    var index = -1;
    while(++index < length)$10fa4d2841b41a6a$var$extension(config, extensions[index]);
    return config;
}
function $10fa4d2841b41a6a$var$extension(config, extension) {
    var key;
    var left;
    var right;
    for(key in extension){
        left = $10fa4d2841b41a6a$var$own.call(config, key) ? config[key] : config[key] = {};
        right = extension[key];
        if (key === "canContainEols" || key === "transforms") config[key] = [].concat(left, right);
        else Object.assign(left, right);
    }
}

});
parcelRegister("9MVet", function(module, exports) {

var $5SUaO = parcelRequire("5SUaO");

var $2rIvq = parcelRequire("2rIvq");

var $eavH7 = parcelRequire("eavH7");

var $1mH0l = parcelRequire("1mH0l");
exports.transforms = [
    transformGfmAutolinkLiterals
];
exports.enter = {
    literalAutolink: enterLiteralAutolink,
    literalAutolinkEmail: enterLiteralAutolinkValue,
    literalAutolinkHttp: enterLiteralAutolinkValue,
    literalAutolinkWww: enterLiteralAutolinkValue
};
exports.exit = {
    literalAutolink: exitLiteralAutolink,
    literalAutolinkEmail: exitLiteralAutolinkEmail,
    literalAutolinkHttp: exitLiteralAutolinkHttp,
    literalAutolinkWww: exitLiteralAutolinkWww
};
function enterLiteralAutolink(token) {
    this.enter({
        type: "link",
        title: null,
        url: "",
        children: []
    }, token);
}
function enterLiteralAutolinkValue(token) {
    this.config.enter.autolinkProtocol.call(this, token);
}
function exitLiteralAutolinkHttp(token) {
    this.config.exit.autolinkProtocol.call(this, token);
}
function exitLiteralAutolinkWww(token) {
    this.config.exit.data.call(this, token);
    this.stack[this.stack.length - 1].url = "http://" + this.sliceSerialize(token);
}
function exitLiteralAutolinkEmail(token) {
    this.config.exit.autolinkEmail.call(this, token);
}
function exitLiteralAutolink(token) {
    this.exit(token);
}
function transformGfmAutolinkLiterals(tree) {
    $2rIvq(tree, [
        [
            /(https?:\/\/|www(?=\.))([-.\w]+)([^ \t\r\n]*)/i,
            findUrl
        ],
        [
            /([-.\w+]+)@([-\w]+(?:\.[-\w]+)+)/,
            findEmail
        ]
    ], {
        ignore: [
            "link",
            "linkReference"
        ]
    });
}
function findUrl($0, protocol, domain, path, match) {
    var prefix = "";
    var parts;
    var result;
    // Not an expected previous character.
    if (!previous(match)) return false;
    // Treat `www` as part of the domain.
    if (/^w/i.test(protocol)) {
        domain = protocol + domain;
        protocol = "";
        prefix = "http://";
    }
    if (!isCorrectDomain(domain)) return false;
    parts = splitUrl(domain + path);
    if (!parts[0]) return false;
    result = {
        type: "link",
        title: null,
        url: prefix + protocol + parts[0],
        children: [
            {
                type: "text",
                value: protocol + parts[0]
            }
        ]
    };
    if (parts[1]) result = [
        result,
        {
            type: "text",
            value: parts[1]
        }
    ];
    return result;
}
function findEmail($0, atext, label, match) {
    // Not an expected previous character.
    if (!previous(match, true) || /[_-]$/.test(label)) return false;
    return {
        type: "link",
        title: null,
        url: "mailto:" + atext + "@" + label,
        children: [
            {
                type: "text",
                value: atext + "@" + label
            }
        ]
    };
}
function isCorrectDomain(domain) {
    var parts = domain.split(".");
    if (parts.length < 2 || parts[parts.length - 1] && (/_/.test(parts[parts.length - 1]) || !/[a-zA-Z\d]/.test(parts[parts.length - 1])) || parts[parts.length - 2] && (/_/.test(parts[parts.length - 2]) || !/[a-zA-Z\d]/.test(parts[parts.length - 2]))) return false;
    return true;
}
function splitUrl(url) {
    var trail = /[!"&'),.:;<>?\]}]+$/.exec(url);
    var closingParenIndex;
    var openingParens;
    var closingParens;
    if (trail) {
        url = url.slice(0, trail.index);
        trail = trail[0];
        closingParenIndex = trail.indexOf(")");
        openingParens = $5SUaO(url, "(");
        closingParens = $5SUaO(url, ")");
        while(closingParenIndex !== -1 && openingParens > closingParens){
            url += trail.slice(0, closingParenIndex + 1);
            trail = trail.slice(closingParenIndex + 1);
            closingParenIndex = trail.indexOf(")");
            closingParens++;
        }
    }
    return [
        url,
        trail
    ];
}
function previous(match, email) {
    var code = match.input.charCodeAt(match.index - 1);
    return (code !== code || $1mH0l(code) || $eavH7(code)) && (!email || code !== 47);
}

});
parcelRegister("5SUaO", function(module, exports) {
"use strict";
module.exports = $448d91beea0a8d5d$var$ccount;
function $448d91beea0a8d5d$var$ccount(source, character) {
    var value = String(source);
    var count = 0;
    var index;
    if (typeof character !== "string") throw new Error("Expected character");
    index = value.indexOf(character);
    while(index !== -1){
        count++;
        index = value.indexOf(character, index + character.length);
    }
    return count;
}

});

parcelRegister("2rIvq", function(module, exports) {
"use strict";
module.exports = $1c80a056a5dc9d82$var$findAndReplace;

var $98N75 = parcelRequire("98N75");

var $bSiTt = parcelRequire("bSiTt");

var $fPH5C = parcelRequire("fPH5C");
var $1c80a056a5dc9d82$var$splice = [].splice;
function $1c80a056a5dc9d82$var$findAndReplace(tree, find, replace, options) {
    var settings;
    var schema;
    if (typeof find === "string" || find && typeof find.exec === "function") schema = [
        [
            find,
            replace
        ]
    ];
    else {
        schema = find;
        options = replace;
    }
    settings = options || {};
    $1c80a056a5dc9d82$var$search(tree, settings, handlerFactory($1c80a056a5dc9d82$var$toPairs(schema)));
    return tree;
    function handlerFactory(pairs) {
        var pair = pairs[0];
        return handler;
        function handler(node, parent) {
            var find = pair[0];
            var replace = pair[1];
            var nodes = [];
            var start = 0;
            var index = parent.children.indexOf(node);
            var position;
            var match;
            var subhandler;
            var value;
            find.lastIndex = 0;
            match = find.exec(node.value);
            while(match){
                position = match.index;
                value = replace.apply(null, [].concat(match, {
                    index: match.index,
                    input: match.input
                }));
                if (value !== false) {
                    if (start !== position) nodes.push({
                        type: "text",
                        value: node.value.slice(start, position)
                    });
                    if (typeof value === "string" && value.length > 0) value = {
                        type: "text",
                        value: value
                    };
                    if (value) nodes = [].concat(nodes, value);
                    start = position + match[0].length;
                }
                if (!find.global) break;
                match = find.exec(node.value);
            }
            if (position === undefined) {
                nodes = [
                    node
                ];
                index--;
            } else {
                if (start < node.value.length) nodes.push({
                    type: "text",
                    value: node.value.slice(start)
                });
                nodes.unshift(index, 1);
                $1c80a056a5dc9d82$var$splice.apply(parent.children, nodes);
            }
            if (pairs.length > 1) {
                subhandler = handlerFactory(pairs.slice(1));
                position = -1;
                while(++position < nodes.length){
                    node = nodes[position];
                    if (node.type === "text") subhandler(node, parent);
                    else $1c80a056a5dc9d82$var$search(node, settings, subhandler);
                }
            }
            return index + nodes.length + 1;
        }
    }
}
function $1c80a056a5dc9d82$var$search(tree, settings, handler) {
    var ignored = $bSiTt(settings.ignore || []);
    var result = [];
    $98N75(tree, "text", visitor);
    return result;
    function visitor(node, parents) {
        var index = -1;
        var parent;
        var grandparent;
        while(++index < parents.length){
            parent = parents[index];
            if (ignored(parent, grandparent ? grandparent.children.indexOf(parent) : undefined, grandparent)) return;
            grandparent = parent;
        }
        return handler(node, grandparent);
    }
}
function $1c80a056a5dc9d82$var$toPairs(schema) {
    var result = [];
    var key;
    var index;
    if (typeof schema !== "object") throw new Error("Expected array or object as schema");
    if ("length" in schema) {
        index = -1;
        while(++index < schema.length)result.push([
            $1c80a056a5dc9d82$var$toExpression(schema[index][0]),
            $1c80a056a5dc9d82$var$toFunction(schema[index][1])
        ]);
    } else for(key in schema)result.push([
        $1c80a056a5dc9d82$var$toExpression(key),
        $1c80a056a5dc9d82$var$toFunction(schema[key])
    ]);
    return result;
}
function $1c80a056a5dc9d82$var$toExpression(find) {
    return typeof find === "string" ? new RegExp($fPH5C(find), "g") : find;
}
function $1c80a056a5dc9d82$var$toFunction(replace) {
    return typeof replace === "function" ? replace : returner;
    function returner() {
        return replace;
    }
}

});
parcelRegister("98N75", function(module, exports) {
"use strict";
module.exports = $6a7af54f30181eb9$var$visitParents;

var $bSiTt = parcelRequire("bSiTt");

var $jCloK = parcelRequire("jCloK");
var $6a7af54f30181eb9$var$CONTINUE = true;
var $6a7af54f30181eb9$var$SKIP = "skip";
var $6a7af54f30181eb9$var$EXIT = false;
$6a7af54f30181eb9$var$visitParents.CONTINUE = $6a7af54f30181eb9$var$CONTINUE;
$6a7af54f30181eb9$var$visitParents.SKIP = $6a7af54f30181eb9$var$SKIP;
$6a7af54f30181eb9$var$visitParents.EXIT = $6a7af54f30181eb9$var$EXIT;
function $6a7af54f30181eb9$var$visitParents(tree, test, visitor, reverse) {
    var step;
    var is;
    if (typeof test === "function" && typeof visitor !== "function") {
        reverse = visitor;
        visitor = test;
        test = null;
    }
    is = $bSiTt(test);
    step = reverse ? -1 : 1;
    factory(tree, null, [])();
    function factory(node, index, parents) {
        var value = typeof node === "object" && node !== null ? node : {};
        var name;
        if (typeof value.type === "string") {
            name = typeof value.tagName === "string" ? value.tagName : typeof value.name === "string" ? value.name : undefined;
            visit.displayName = "node (" + $jCloK(value.type + (name ? "<" + name + ">" : "")) + ")";
        }
        return visit;
        function visit() {
            var grandparents = parents.concat(node);
            var result = [];
            var subresult;
            var offset;
            if (!test || is(node, index, parents[parents.length - 1] || null)) {
                result = $6a7af54f30181eb9$var$toResult(visitor(node, parents));
                if (result[0] === $6a7af54f30181eb9$var$EXIT) return result;
            }
            if (node.children && result[0] !== $6a7af54f30181eb9$var$SKIP) {
                offset = (reverse ? node.children.length : -1) + step;
                while(offset > -1 && offset < node.children.length){
                    subresult = factory(node.children[offset], offset, grandparents)();
                    if (subresult[0] === $6a7af54f30181eb9$var$EXIT) return subresult;
                    offset = typeof subresult[1] === "number" ? subresult[1] : offset + step;
                }
            }
            return result;
        }
    }
}
function $6a7af54f30181eb9$var$toResult(value) {
    if (value !== null && typeof value === "object" && "length" in value) return value;
    if (typeof value === "number") return [
        $6a7af54f30181eb9$var$CONTINUE,
        value
    ];
    return [
        value
    ];
}

});
parcelRegister("jCloK", function(module, exports) {
module.exports = $e4822a2ac7d40dfe$var$identity;
function $e4822a2ac7d40dfe$var$identity(d) {
    return d;
}

});


parcelRegister("fPH5C", function(module, exports) {
"use strict";
module.exports = (string)=>{
    if (typeof string !== "string") throw new TypeError("Expected a string");
    // Escape characters with special meaning either inside or outside character sets.
    // Use a simple backslash escape when it’s always valid, and a \unnnn escape when the simpler form would be disallowed by Unicode patterns’ stricter grammar.
    return string.replace(/[|\\{}()[\]^$+*?.]/g, "\\$&").replace(/-/g, "\\x2d");
};

});



parcelRegister("dq6Cs", function(module, exports) {
exports.canContainEols = [
    "delete"
];
exports.enter = {
    strikethrough: enterStrikethrough
};
exports.exit = {
    strikethrough: exitStrikethrough
};
function enterStrikethrough(token) {
    this.enter({
        type: "delete",
        children: []
    }, token);
}
function exitStrikethrough(token) {
    this.exit(token);
}

});

parcelRegister("4XvDl", function(module, exports) {
exports.enter = {
    table: enterTable,
    tableData: enterCell,
    tableHeader: enterCell,
    tableRow: enterRow
};
exports.exit = {
    codeText: exitCodeText,
    table: exitTable,
    tableData: exit,
    tableHeader: exit,
    tableRow: exit
};
function enterTable(token) {
    this.enter({
        type: "table",
        align: token._align,
        children: []
    }, token);
    this.setData("inTable", true);
}
function exitTable(token) {
    this.exit(token);
    this.setData("inTable");
}
function enterRow(token) {
    this.enter({
        type: "tableRow",
        children: []
    }, token);
}
function exit(token) {
    this.exit(token);
}
function enterCell(token) {
    this.enter({
        type: "tableCell",
        children: []
    }, token);
}
// Overwrite the default code text data handler to unescape escaped pipes when
// they are in tables.
function exitCodeText(token) {
    var value = this.resume();
    if (this.getData("inTable")) value = value.replace(/\\([\\|])/g, replace);
    this.stack[this.stack.length - 1].value = value;
    this.exit(token);
}
function replace($0, $1) {
    // Pipes work, backslashes don’t (but can’t escape pipes).
    return $1 === "|" ? $1 : $0;
}

});

parcelRegister("jQVtx", function(module, exports) {
exports.exit = {
    taskListCheckValueChecked: exitCheck,
    taskListCheckValueUnchecked: exitCheck,
    paragraph: exitParagraphWithTaskListItem
};
function exitCheck(token) {
    // We’re always in a paragraph, in a list item.
    this.stack[this.stack.length - 2].checked = token.type === "taskListCheckValueChecked";
}
function exitParagraphWithTaskListItem(token) {
    var parent = this.stack[this.stack.length - 2];
    var node = this.stack[this.stack.length - 1];
    var siblings = parent.children;
    var head = node.children[0];
    var index = -1;
    var firstParaghraph;
    if (parent && parent.type === "listItem" && typeof parent.checked === "boolean" && head && head.type === "text") {
        while(++index < siblings.length)if (siblings[index].type === "paragraph") {
            firstParaghraph = siblings[index];
            break;
        }
        if (firstParaghraph === node) {
            // Must start with a space or a tab.
            head.value = head.value.slice(1);
            if (head.value.length === 0) node.children.shift();
            else {
                head.position.start.column++;
                head.position.start.offset++;
                node.position.start = Object.assign({}, head.position.start);
            }
        }
    }
    this.exit(token);
}

});


parcelRegister("29uTM", function(module, exports) {

var $866so = parcelRequire("866so");

var $e1dSi = parcelRequire("e1dSi");

var $gnFm6 = parcelRequire("gnFm6");

var $bXqDO = parcelRequire("bXqDO");

var $37Ars = parcelRequire("37Ars");
module.exports = $191463da3c1b9a4b$var$toMarkdown;
function $191463da3c1b9a4b$var$toMarkdown(options) {
    var config = $37Ars({
        handlers: {},
        join: [],
        unsafe: [],
        options: {}
    }, {
        extensions: [
            $866so,
            $e1dSi,
            $gnFm6(options),
            $bXqDO
        ]
    });
    return Object.assign(config.options, {
        handlers: config.handlers,
        join: config.join,
        unsafe: config.unsafe
    });
}

});
parcelRegister("866so", function(module, exports) {

$parcel$export(module.exports, "unsafe", function () { return $5e53e476fb3c530e$export$aa1c11b655786597; }, function (v) { return $5e53e476fb3c530e$export$aa1c11b655786597 = v; });
var $5e53e476fb3c530e$export$aa1c11b655786597;
var $5e53e476fb3c530e$var$inConstruct = "phrasing";
var $5e53e476fb3c530e$var$notInConstruct = [
    "autolink",
    "link",
    "image",
    "label"
];
$5e53e476fb3c530e$export$aa1c11b655786597 = [
    {
        character: "@",
        before: "[+\\-.\\w]",
        after: "[\\-.\\w]",
        inConstruct: $5e53e476fb3c530e$var$inConstruct,
        notInConstruct: $5e53e476fb3c530e$var$notInConstruct
    },
    {
        character: ".",
        before: "[Ww]",
        after: "[\\-.\\w]",
        inConstruct: $5e53e476fb3c530e$var$inConstruct,
        notInConstruct: $5e53e476fb3c530e$var$notInConstruct
    },
    {
        character: ":",
        before: "[ps]",
        after: "\\/",
        inConstruct: $5e53e476fb3c530e$var$inConstruct,
        notInConstruct: $5e53e476fb3c530e$var$notInConstruct
    }
];

});

parcelRegister("e1dSi", function(module, exports) {

$parcel$export(module.exports, "unsafe", function () { return $a34bebe5a54cf49c$export$aa1c11b655786597; }, function (v) { return $a34bebe5a54cf49c$export$aa1c11b655786597 = v; });
$parcel$export(module.exports, "handlers", function () { return $a34bebe5a54cf49c$export$455ce229eb3d2472; }, function (v) { return $a34bebe5a54cf49c$export$455ce229eb3d2472 = v; });
var $a34bebe5a54cf49c$export$aa1c11b655786597;
var $a34bebe5a54cf49c$export$455ce229eb3d2472;

var $3xOye = parcelRequire("3xOye");
$a34bebe5a54cf49c$export$aa1c11b655786597 = [
    {
        character: "~",
        inConstruct: "phrasing"
    }
];
$a34bebe5a54cf49c$export$455ce229eb3d2472 = {
    delete: $a34bebe5a54cf49c$var$handleDelete
};
$a34bebe5a54cf49c$var$handleDelete.peek = $a34bebe5a54cf49c$var$peekDelete;
function $a34bebe5a54cf49c$var$handleDelete(node, _, context) {
    var exit = context.enter("emphasis");
    var value = $3xOye(node, context, {
        before: "~",
        after: "~"
    });
    exit();
    return "~~" + value + "~~";
}
function $a34bebe5a54cf49c$var$peekDelete() {
    return "~";
}

});
parcelRegister("3xOye", function(module, exports) {
module.exports = $294baa9378c72607$var$phrasing;
function $294baa9378c72607$var$phrasing(parent, context, safeOptions) {
    var children = parent.children || [];
    var results = [];
    var index = -1;
    var before = safeOptions.before;
    var after;
    var handle;
    var child;
    while(++index < children.length){
        child = children[index];
        if (index + 1 < children.length) {
            handle = context.handle.handlers[children[index + 1].type];
            if (handle && handle.peek) handle = handle.peek;
            after = handle ? handle(children[index + 1], parent, context, {
                before: "",
                after: ""
            }).charAt(0) : "";
        } else after = safeOptions.after;
        // In some cases, html (text) can be found in phrasing right after an eol.
        // When we’d serialize that, in most cases that would be seen as html
        // (flow).
        // As we can’t escape or so to prevent it from happening, we take a somewhat
        // reasonable approach: replace that eol with a space.
        // See: <https://github.com/syntax-tree/mdast-util-to-markdown/issues/15>
        if (results.length > 0 && (before === "\r" || before === "\n") && child.type === "html") {
            results[results.length - 1] = results[results.length - 1].replace(/(\r?\n|\r)$/, " ");
            before = " ";
        }
        results.push(context.handle(child, parent, context, {
            before: before,
            after: after
        }));
        before = results[results.length - 1].slice(-1);
    }
    return results.join("");
}

});


parcelRegister("gnFm6", function(module, exports) {

var $3xOye = parcelRequire("3xOye");

var $dxHLu = parcelRequire("dxHLu");

var $4rE2d = parcelRequire("4rE2d");
module.exports = $becedfaa20db30e7$var$toMarkdown;
function $becedfaa20db30e7$var$toMarkdown(options) {
    var settings = options || {};
    var padding = settings.tableCellPadding;
    var alignDelimiters = settings.tablePipeAlign;
    var stringLength = settings.stringLength;
    var around = padding ? " " : "|";
    return {
        unsafe: [
            {
                character: "\r",
                inConstruct: "tableCell"
            },
            {
                character: "\n",
                inConstruct: "tableCell"
            },
            // A pipe, when followed by a tab or space (padding), or a dash or colon
            // (unpadded delimiter row), could result in a table.
            {
                atBreak: true,
                character: "|",
                after: "[	 :-]"
            },
            // A pipe in a cell must be encoded.
            {
                character: "|",
                inConstruct: "tableCell"
            },
            // A colon must be followed by a dash, in which case it could start a
            // delimiter row.
            {
                atBreak: true,
                character: ":",
                after: "-"
            },
            // A delimiter row can also start with a dash, when followed by more
            // dashes, a colon, or a pipe.
            // This is a stricter version than the built in check for lists, thematic
            // breaks, and setex heading underlines though:
            // <https://github.com/syntax-tree/mdast-util-to-markdown/blob/51a2038/lib/unsafe.js#L57>
            {
                atBreak: true,
                character: "-",
                after: "[:|-]"
            }
        ],
        handlers: {
            table: handleTable,
            tableRow: handleTableRow,
            tableCell: handleTableCell,
            inlineCode: inlineCodeWithTable
        }
    };
    function handleTable(node, _, context) {
        return serializeData(handleTableAsData(node, context), node.align);
    }
    // This function isn’t really used normally, because we handle rows at the
    // table level.
    // But, if someone passes in a table row, this ensures we make somewhat sense.
    function handleTableRow(node, _, context) {
        var row = handleTableRowAsData(node, context);
        // `markdown-table` will always add an align row
        var value = serializeData([
            row
        ]);
        return value.slice(0, value.indexOf("\n"));
    }
    function handleTableCell(node, _, context) {
        var exit = context.enter("tableCell");
        var value = $3xOye(node, context, {
            before: around,
            after: around
        });
        exit();
        return value;
    }
    function serializeData(matrix, align) {
        return $4rE2d(matrix, {
            align: align,
            alignDelimiters: alignDelimiters,
            padding: padding,
            stringLength: stringLength
        });
    }
    function handleTableAsData(node, context) {
        var children = node.children;
        var index = -1;
        var length = children.length;
        var result = [];
        var subexit = context.enter("table");
        while(++index < length)result[index] = handleTableRowAsData(children[index], context);
        subexit();
        return result;
    }
    function handleTableRowAsData(node, context) {
        var children = node.children;
        var index = -1;
        var length = children.length;
        var result = [];
        var subexit = context.enter("tableRow");
        while(++index < length)result[index] = handleTableCell(children[index], node, context);
        subexit();
        return result;
    }
    function inlineCodeWithTable(node, parent, context) {
        var value = $dxHLu(node, parent, context);
        if (context.stack.indexOf("tableCell") !== -1) value = value.replace(/\|/g, "\\$&");
        return value;
    }
}

});
parcelRegister("dxHLu", function(module, exports) {
module.exports = $9dc04e3a808d2eea$var$inlineCode;
$9dc04e3a808d2eea$var$inlineCode.peek = $9dc04e3a808d2eea$var$inlineCodePeek;

var $hCaIb = parcelRequire("hCaIb");
function $9dc04e3a808d2eea$var$inlineCode(node, parent, context) {
    var value = node.value || "";
    var sequence = "`";
    var index = -1;
    var pattern;
    var expression;
    var match;
    var position;
    // If there is a single grave accent on its own in the code, use a fence of
    // two.
    // If there are two in a row, use one.
    while(new RegExp("(^|[^`])" + sequence + "([^`]|$)").test(value))sequence += "`";
    // If this is not just spaces or eols (tabs don’t count), and either the
    // first or last character are a space, eol, or tick, then pad with spaces.
    if (/[^ \r\n]/.test(value) && (/[ \r\n`]/.test(value.charAt(0)) || /[ \r\n`]/.test(value.charAt(value.length - 1)))) value = " " + value + " ";
    // We have a potential problem: certain characters after eols could result in
    // blocks being seen.
    // For example, if someone injected the string `'\n# b'`, then that would
    // result in an ATX heading.
    // We can’t escape characters in `inlineCode`, but because eols are
    // transformed to spaces when going from markdown to HTML anyway, we can swap
    // them out.
    while(++index < context.unsafe.length){
        pattern = context.unsafe[index];
        // Only look for `atBreak`s.
        // Btw: note that `atBreak` patterns will always start the regex at LF or
        // CR.
        if (!pattern.atBreak) continue;
        expression = $hCaIb(pattern);
        while(match = expression.exec(value)){
            position = match.index;
            // Support CRLF (patterns only look for one of the characters).
            if (value.charCodeAt(position) === 10 /* `\n` */  && value.charCodeAt(position - 1) === 13 /* `\r` */ ) position--;
            value = value.slice(0, position) + " " + value.slice(match.index + 1);
        }
    }
    return sequence + value + sequence;
}
function $9dc04e3a808d2eea$var$inlineCodePeek() {
    return "`";
}

});
parcelRegister("hCaIb", function(module, exports) {
module.exports = $cd2e4b652c94a62e$var$patternCompile;
function $cd2e4b652c94a62e$var$patternCompile(pattern) {
    var before;
    var after;
    if (!pattern._compiled) {
        before = pattern.before ? "(?:" + pattern.before + ")" : "";
        after = pattern.after ? "(?:" + pattern.after + ")" : "";
        if (pattern.atBreak) before = "[\\r\\n][\\t ]*" + before;
        pattern._compiled = new RegExp((before ? "(" + before + ")" : "") + (/[|\\{}()[\]^$+*?.-]/.test(pattern.character) ? "\\" : "") + pattern.character + (after || ""), "g");
    }
    return pattern._compiled;
}

});


parcelRegister("4rE2d", function(module, exports) {
"use strict";

var $5VIIE = parcelRequire("5VIIE");
module.exports = $33c8bd16d642ae78$var$markdownTable;
var $33c8bd16d642ae78$var$trailingWhitespace = / +$/;
// Characters.
var $33c8bd16d642ae78$var$space = " ";
var $33c8bd16d642ae78$var$lineFeed = "\n";
var $33c8bd16d642ae78$var$dash = "-";
var $33c8bd16d642ae78$var$colon = ":";
var $33c8bd16d642ae78$var$verticalBar = "|";
var $33c8bd16d642ae78$var$x = 0;
var $33c8bd16d642ae78$var$C = 67;
var $33c8bd16d642ae78$var$L = 76;
var $33c8bd16d642ae78$var$R = 82;
var $33c8bd16d642ae78$var$c = 99;
var $33c8bd16d642ae78$var$l = 108;
var $33c8bd16d642ae78$var$r = 114;
// Create a table from a matrix of strings.
function $33c8bd16d642ae78$var$markdownTable(table, options) {
    var settings = options || {};
    var padding = settings.padding !== false;
    var start = settings.delimiterStart !== false;
    var end = settings.delimiterEnd !== false;
    var align = (settings.align || []).concat();
    var alignDelimiters = settings.alignDelimiters !== false;
    var alignments = [];
    var stringLength = settings.stringLength || $33c8bd16d642ae78$var$defaultStringLength;
    var rowIndex = -1;
    var rowLength = table.length;
    var cellMatrix = [];
    var sizeMatrix = [];
    var row = [];
    var sizes = [];
    var longestCellByColumn = [];
    var mostCellsPerRow = 0;
    var cells;
    var columnIndex;
    var columnLength;
    var largest;
    var size;
    var cell;
    var lines;
    var line;
    var before;
    var after;
    var code;
    // This is a superfluous loop if we don’t align delimiters, but otherwise we’d
    // do superfluous work when aligning, so optimize for aligning.
    while(++rowIndex < rowLength){
        cells = table[rowIndex];
        columnIndex = -1;
        columnLength = cells.length;
        row = [];
        sizes = [];
        if (columnLength > mostCellsPerRow) mostCellsPerRow = columnLength;
        while(++columnIndex < columnLength){
            cell = $33c8bd16d642ae78$var$serialize(cells[columnIndex]);
            if (alignDelimiters === true) {
                size = stringLength(cell);
                sizes[columnIndex] = size;
                largest = longestCellByColumn[columnIndex];
                if (largest === undefined || size > largest) longestCellByColumn[columnIndex] = size;
            }
            row.push(cell);
        }
        cellMatrix[rowIndex] = row;
        sizeMatrix[rowIndex] = sizes;
    }
    // Figure out which alignments to use.
    columnIndex = -1;
    columnLength = mostCellsPerRow;
    if (typeof align === "object" && "length" in align) while(++columnIndex < columnLength)alignments[columnIndex] = $33c8bd16d642ae78$var$toAlignment(align[columnIndex]);
    else {
        code = $33c8bd16d642ae78$var$toAlignment(align);
        while(++columnIndex < columnLength)alignments[columnIndex] = code;
    }
    // Inject the alignment row.
    columnIndex = -1;
    columnLength = mostCellsPerRow;
    row = [];
    sizes = [];
    while(++columnIndex < columnLength){
        code = alignments[columnIndex];
        before = "";
        after = "";
        if (code === $33c8bd16d642ae78$var$l) before = $33c8bd16d642ae78$var$colon;
        else if (code === $33c8bd16d642ae78$var$r) after = $33c8bd16d642ae78$var$colon;
        else if (code === $33c8bd16d642ae78$var$c) {
            before = $33c8bd16d642ae78$var$colon;
            after = $33c8bd16d642ae78$var$colon;
        }
        // There *must* be at least one hyphen-minus in each alignment cell.
        size = alignDelimiters ? Math.max(1, longestCellByColumn[columnIndex] - before.length - after.length) : 1;
        cell = before + $5VIIE($33c8bd16d642ae78$var$dash, size) + after;
        if (alignDelimiters === true) {
            size = before.length + size + after.length;
            if (size > longestCellByColumn[columnIndex]) longestCellByColumn[columnIndex] = size;
            sizes[columnIndex] = size;
        }
        row[columnIndex] = cell;
    }
    // Inject the alignment row.
    cellMatrix.splice(1, 0, row);
    sizeMatrix.splice(1, 0, sizes);
    rowIndex = -1;
    rowLength = cellMatrix.length;
    lines = [];
    while(++rowIndex < rowLength){
        row = cellMatrix[rowIndex];
        sizes = sizeMatrix[rowIndex];
        columnIndex = -1;
        columnLength = mostCellsPerRow;
        line = [];
        while(++columnIndex < columnLength){
            cell = row[columnIndex] || "";
            before = "";
            after = "";
            if (alignDelimiters === true) {
                size = longestCellByColumn[columnIndex] - (sizes[columnIndex] || 0);
                code = alignments[columnIndex];
                if (code === $33c8bd16d642ae78$var$r) before = $5VIIE($33c8bd16d642ae78$var$space, size);
                else if (code === $33c8bd16d642ae78$var$c) {
                    if (size % 2 === 0) {
                        before = $5VIIE($33c8bd16d642ae78$var$space, size / 2);
                        after = before;
                    } else {
                        before = $5VIIE($33c8bd16d642ae78$var$space, size / 2 + 0.5);
                        after = $5VIIE($33c8bd16d642ae78$var$space, size / 2 - 0.5);
                    }
                } else after = $5VIIE($33c8bd16d642ae78$var$space, size);
            }
            if (start === true && columnIndex === 0) line.push($33c8bd16d642ae78$var$verticalBar);
            if (padding === true && // Don’t add the opening space if we’re not aligning and the cell is
            // empty: there will be a closing space.
            !(alignDelimiters === false && cell === "") && (start === true || columnIndex !== 0)) line.push($33c8bd16d642ae78$var$space);
            if (alignDelimiters === true) line.push(before);
            line.push(cell);
            if (alignDelimiters === true) line.push(after);
            if (padding === true) line.push($33c8bd16d642ae78$var$space);
            if (end === true || columnIndex !== columnLength - 1) line.push($33c8bd16d642ae78$var$verticalBar);
        }
        line = line.join("");
        if (end === false) line = line.replace($33c8bd16d642ae78$var$trailingWhitespace, "");
        lines.push(line);
    }
    return lines.join($33c8bd16d642ae78$var$lineFeed);
}
function $33c8bd16d642ae78$var$serialize(value) {
    return value === null || value === undefined ? "" : String(value);
}
function $33c8bd16d642ae78$var$defaultStringLength(value) {
    return value.length;
}
function $33c8bd16d642ae78$var$toAlignment(value) {
    var code = typeof value === "string" ? value.charCodeAt(0) : $33c8bd16d642ae78$var$x;
    return code === $33c8bd16d642ae78$var$L || code === $33c8bd16d642ae78$var$l ? $33c8bd16d642ae78$var$l : code === $33c8bd16d642ae78$var$R || code === $33c8bd16d642ae78$var$r ? $33c8bd16d642ae78$var$r : code === $33c8bd16d642ae78$var$C || code === $33c8bd16d642ae78$var$c ? $33c8bd16d642ae78$var$c : $33c8bd16d642ae78$var$x;
}

});
parcelRegister("5VIIE", function(module, exports) {
/*!
 * repeat-string <https://github.com/jonschlinkert/repeat-string>
 *
 * Copyright (c) 2014-2015, Jon Schlinkert.
 * Licensed under the MIT License.
 */ "use strict";
/**
 * Results cache
 */ var $4514f6e71694d187$var$res = "";
var $4514f6e71694d187$var$cache;
/**
 * Expose `repeat`
 */ module.exports = $4514f6e71694d187$var$repeat;
/**
 * Repeat the given `string` the specified `number`
 * of times.
 *
 * **Example:**
 *
 * ```js
 * var repeat = require('repeat-string');
 * repeat('A', 5);
 * //=> AAAAA
 * ```
 *
 * @param {String} `string` The string to repeat
 * @param {Number} `number` The number of times to repeat the string
 * @return {String} Repeated string
 * @api public
 */ function $4514f6e71694d187$var$repeat(str, num) {
    if (typeof str !== "string") throw new TypeError("expected a string");
    // cover common, quick use cases
    if (num === 1) return str;
    if (num === 2) return str + str;
    var max = str.length * num;
    if ($4514f6e71694d187$var$cache !== str || typeof $4514f6e71694d187$var$cache === "undefined") {
        $4514f6e71694d187$var$cache = str;
        $4514f6e71694d187$var$res = "";
    } else if ($4514f6e71694d187$var$res.length >= max) return $4514f6e71694d187$var$res.substr(0, max);
    while(max > $4514f6e71694d187$var$res.length && num > 1){
        if (num & 1) $4514f6e71694d187$var$res += str;
        num >>= 1;
        str += str;
    }
    $4514f6e71694d187$var$res += str;
    $4514f6e71694d187$var$res = $4514f6e71694d187$var$res.substr(0, max);
    return $4514f6e71694d187$var$res;
}

});



parcelRegister("bXqDO", function(module, exports) {

$parcel$export(module.exports, "unsafe", function () { return $8b49debf51c2f7dc$export$aa1c11b655786597; }, function (v) { return $8b49debf51c2f7dc$export$aa1c11b655786597 = v; });
$parcel$export(module.exports, "handlers", function () { return $8b49debf51c2f7dc$export$455ce229eb3d2472; }, function (v) { return $8b49debf51c2f7dc$export$455ce229eb3d2472 = v; });
var $8b49debf51c2f7dc$export$aa1c11b655786597;
var $8b49debf51c2f7dc$export$455ce229eb3d2472;

var $1aLjY = parcelRequire("1aLjY");
$8b49debf51c2f7dc$export$aa1c11b655786597 = [
    {
        atBreak: true,
        character: "-",
        after: "[:|-]"
    }
];
$8b49debf51c2f7dc$export$455ce229eb3d2472 = {
    listItem: $8b49debf51c2f7dc$var$listItemWithTaskListItem
};
function $8b49debf51c2f7dc$var$listItemWithTaskListItem(node, parent, context) {
    var value = $1aLjY(node, parent, context);
    var head = node.children[0];
    if (typeof node.checked === "boolean" && head && head.type === "paragraph") value = value.replace(/^(?:[*+-]|\d+\.)([\r\n]| {1,3})/, check);
    return value;
    function check($0) {
        return $0 + "[" + (node.checked ? "x" : " ") + "] ";
    }
}

});
parcelRegister("1aLjY", function(module, exports) {
module.exports = $0dab6e9a06227ea4$var$listItem;

var $5VIIE = parcelRequire("5VIIE");

var $dZoOx = parcelRequire("dZoOx");

var $e1H89 = parcelRequire("e1H89");

var $hEHW2 = parcelRequire("hEHW2");

var $2vwHk = parcelRequire("2vwHk");
function $0dab6e9a06227ea4$var$listItem(node, parent, context) {
    var bullet = $dZoOx(context);
    var listItemIndent = $e1H89(context);
    var size;
    var value;
    var exit;
    if (parent && parent.ordered) bullet = (parent.start > -1 ? parent.start : 1) + (context.options.incrementListMarker === false ? 0 : parent.children.indexOf(node)) + ".";
    size = bullet.length + 1;
    if (listItemIndent === "tab" || listItemIndent === "mixed" && (parent && parent.spread || node.spread)) size = Math.ceil(size / 4) * 4;
    exit = context.enter("listItem");
    value = $2vwHk($hEHW2(node, context), map);
    exit();
    return value;
    function map(line, index, blank) {
        if (index) return (blank ? "" : $5VIIE(" ", size)) + line;
        return (blank ? bullet : bullet + $5VIIE(" ", size - bullet.length)) + line;
    }
}

});
parcelRegister("dZoOx", function(module, exports) {
module.exports = $a2f4386965b488b3$var$checkBullet;
function $a2f4386965b488b3$var$checkBullet(context) {
    var marker = context.options.bullet || "*";
    if (marker !== "*" && marker !== "+" && marker !== "-") throw new Error("Cannot serialize items with `" + marker + "` for `options.bullet`, expected `*`, `+`, or `-`");
    return marker;
}

});

parcelRegister("e1H89", function(module, exports) {
module.exports = $a3629d823c402b87$var$checkListItemIndent;
function $a3629d823c402b87$var$checkListItemIndent(context) {
    var style = context.options.listItemIndent || "tab";
    if (style === 1 || style === "1") return "one";
    if (style !== "tab" && style !== "one" && style !== "mixed") throw new Error("Cannot serialize items with `" + style + "` for `options.listItemIndent`, expected `tab`, `one`, or `mixed`");
    return style;
}

});

parcelRegister("hEHW2", function(module, exports) {
module.exports = $cda840b21d39d156$var$flow;

var $5VIIE = parcelRequire("5VIIE");
function $cda840b21d39d156$var$flow(parent, context) {
    var children = parent.children || [];
    var results = [];
    var index = -1;
    var child;
    while(++index < children.length){
        child = children[index];
        results.push(context.handle(child, parent, context, {
            before: "\n",
            after: "\n"
        }));
        if (index + 1 < children.length) results.push(between(child, children[index + 1]));
    }
    return results.join("");
    function between(left, right) {
        var index = -1;
        var result;
        while(++index < context.join.length){
            result = context.join[index](left, right, parent, context);
            if (result === true || result === 1) break;
            if (typeof result === "number") return $5VIIE("\n", 1 + Number(result));
            if (result === false) return "\n\n<!---->\n\n";
        }
        return "\n\n";
    }
}

});

parcelRegister("2vwHk", function(module, exports) {
module.exports = $1d37d7237b62dbb7$var$indentLines;
var $1d37d7237b62dbb7$var$eol = /\r?\n|\r/g;
function $1d37d7237b62dbb7$var$indentLines(value, map) {
    var result = [];
    var start = 0;
    var line = 0;
    var match;
    while(match = $1d37d7237b62dbb7$var$eol.exec(value)){
        one(value.slice(start, match.index));
        result.push(match[0]);
        start = match.index + match[0].length;
        line++;
    }
    one(value.slice(start));
    return result.join("");
    function one(value) {
        result.push(map(value, line, !value));
    }
}

});



parcelRegister("37Ars", function(module, exports) {
module.exports = $245e4b21843bd8d7$var$configure;
function $245e4b21843bd8d7$var$configure(base, extension) {
    var index = -1;
    var key;
    // First do subextensions.
    if (extension.extensions) while(++index < extension.extensions.length)$245e4b21843bd8d7$var$configure(base, extension.extensions[index]);
    for(key in extension){
        if (key === "extensions") ;
        else if (key === "unsafe" || key === "join") base[key] = base[key].concat(extension[key] || []);
        else if (key === "handlers") base[key] = Object.assign(base[key], extension[key] || {});
        else base.options[key] = extension[key];
    }
    return base;
}

});




parcelRegister("2chu2", function(module, exports) {

$parcel$export(module.exports, "Lazy", function () { return $199a43a1a56c24a6$export$b624eff549462981; });

var $4vwom = parcelRequire("4vwom");

var $eeH7J = parcelRequire("eeH7J");
function $199a43a1a56c24a6$export$b624eff549462981(props) {
    const [comp, setComponent] = (0, $eeH7J.useState)();
    (0, $eeH7J.useEffect)(()=>{
        if (props.load !== false) {
            const res = props.target();
            res.then((comp)=>{
                setComponent({
                    comp: comp
                });
            });
        }
    }, [
        props.load
    ]);
    if (comp) return (0, $4vwom.jsx)(comp.comp, {});
    else if (props.fallback) return (0, $4vwom.jsx)(props.fallback, {});
    else return (0, $4vwom.jsx)("div", {
        children: "Loading..."
    });
}

});

parcelRegister("cUDOr", function(module, exports) {

var $Ks0wJ = parcelRequire("Ks0wJ");
module.exports = $Ks0wJ("5xFdn").then(()=>parcelRequire("a7Voa"));

});
parcelRegister("Ks0wJ", function(module, exports) {
"use strict";

function $08ba05b2dae8864c$var$load(id) {
    // eslint-disable-next-line no-undef
    return import((parcelRequire("3ueMA")).resolve(id));
}
module.exports = $08ba05b2dae8864c$var$load;

});


parcelRegister("hPh1J", function(module, exports) {

var $Ks0wJ = parcelRequire("Ks0wJ");
module.exports = $Ks0wJ("1veE1").then(()=>parcelRequire("latBp"));

});

parcelRegister("2vh9S", function(module, exports) {

$parcel$export(module.exports, "Lottie", function () { return $1d2bc9472f2f182b$export$eeef939529b18d03; });

var $4vwom = parcelRequire("4vwom");

var $eeH7J = parcelRequire("eeH7J");

var $7m9cQ = parcelRequire("7m9cQ");

var $f4ybe = parcelRequire("f4ybe");
function $1d2bc9472f2f182b$export$eeef939529b18d03({ file: file, style: style }) {
    const [animationData, setData] = (0, $eeH7J.useState)();
    (0, $eeH7J.useEffect)(()=>{
        async function go() {
            const res = await fetch(`${(0, $7m9cQ.server)()}/api/files/${file}`);
            if (res.status !== 200) throw new Error();
            return setData(await res.json());
        }
        go();
    }, [
        file
    ]);
    const element = (0, $eeH7J.useRef)(null);
    const lottieInstance = (0, $eeH7J.useRef)();
    (0, $eeH7J.useEffect)(()=>{
        if (element.current && animationData) lottieInstance.current = (0, (/*@__PURE__*/$parcel$interopDefault($f4ybe))).loadAnimation({
            animationData: animationData,
            container: element.current
        });
    }, [
        animationData
    ]);
    return (0, $4vwom.jsx)("div", {
        children: (0, $4vwom.jsx)("div", {
            style: style,
            ref: element
        })
    });
}

});
parcelRegister("f4ybe", function(module, exports) {
typeof navigator !== "undefined" && function(global, factory) {
    module.exports = factory();
}(this, function() {
    "use strict";
    var svgNS = "http://www.w3.org/2000/svg";
    var locationHref = "";
    var _useWebWorker = false;
    var initialDefaultFrame = -999999;
    var setWebWorker = function setWebWorker(flag) {
        _useWebWorker = !!flag;
    };
    var getWebWorker = function getWebWorker() {
        return _useWebWorker;
    };
    var setLocationHref = function setLocationHref(value) {
        locationHref = value;
    };
    var getLocationHref = function getLocationHref() {
        return locationHref;
    };
    function createTag(type) {
        // return {appendChild:function(){},setAttribute:function(){},style:{}}
        return document.createElement(type);
    }
    function extendPrototype(sources, destination) {
        var i;
        var len = sources.length;
        var sourcePrototype;
        for(i = 0; i < len; i += 1){
            sourcePrototype = sources[i].prototype;
            for(var attr in sourcePrototype)if (Object.prototype.hasOwnProperty.call(sourcePrototype, attr)) destination.prototype[attr] = sourcePrototype[attr];
        }
    }
    function getDescriptor(object, prop) {
        return Object.getOwnPropertyDescriptor(object, prop);
    }
    function createProxyFunction(prototype) {
        function ProxyFunction() {}
        ProxyFunction.prototype = prototype;
        return ProxyFunction;
    }
    // import Howl from '../../3rd_party/howler';
    var audioControllerFactory = function() {
        function AudioController(audioFactory) {
            this.audios = [];
            this.audioFactory = audioFactory;
            this._volume = 1;
            this._isMuted = false;
        }
        AudioController.prototype = {
            addAudio: function addAudio(audio) {
                this.audios.push(audio);
            },
            pause: function pause() {
                var i;
                var len = this.audios.length;
                for(i = 0; i < len; i += 1)this.audios[i].pause();
            },
            resume: function resume() {
                var i;
                var len = this.audios.length;
                for(i = 0; i < len; i += 1)this.audios[i].resume();
            },
            setRate: function setRate(rateValue) {
                var i;
                var len = this.audios.length;
                for(i = 0; i < len; i += 1)this.audios[i].setRate(rateValue);
            },
            createAudio: function createAudio(assetPath) {
                if (this.audioFactory) return this.audioFactory(assetPath);
                if (window.Howl) return new window.Howl({
                    src: [
                        assetPath
                    ]
                });
                return {
                    isPlaying: false,
                    play: function play() {
                        this.isPlaying = true;
                    },
                    seek: function seek() {
                        this.isPlaying = false;
                    },
                    playing: function playing() {},
                    rate: function rate() {},
                    setVolume: function setVolume() {}
                };
            },
            setAudioFactory: function setAudioFactory(audioFactory) {
                this.audioFactory = audioFactory;
            },
            setVolume: function setVolume(value) {
                this._volume = value;
                this._updateVolume();
            },
            mute: function mute() {
                this._isMuted = true;
                this._updateVolume();
            },
            unmute: function unmute() {
                this._isMuted = false;
                this._updateVolume();
            },
            getVolume: function getVolume() {
                return this._volume;
            },
            _updateVolume: function _updateVolume() {
                var i;
                var len = this.audios.length;
                for(i = 0; i < len; i += 1)this.audios[i].volume(this._volume * (this._isMuted ? 0 : 1));
            }
        };
        return function() {
            return new AudioController();
        };
    }();
    var createTypedArray = function() {
        function createRegularArray(type, len) {
            var i = 0;
            var arr = [];
            var value;
            switch(type){
                case "int16":
                case "uint8c":
                    value = 1;
                    break;
                default:
                    value = 1.1;
                    break;
            }
            for(i = 0; i < len; i += 1)arr.push(value);
            return arr;
        }
        function createTypedArrayFactory(type, len) {
            if (type === "float32") return new Float32Array(len);
            if (type === "int16") return new Int16Array(len);
            if (type === "uint8c") return new Uint8ClampedArray(len);
            return createRegularArray(type, len);
        }
        if (typeof Uint8ClampedArray === "function" && typeof Float32Array === "function") return createTypedArrayFactory;
        return createRegularArray;
    }();
    function createSizedArray(len) {
        return Array.apply(null, {
            length: len
        });
    }
    function _typeof$6(obj) {
        "@babel/helpers - typeof";
        if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof$6 = function _typeof(obj) {
            return typeof obj;
        };
        else _typeof$6 = function _typeof(obj) {
            return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        };
        return _typeof$6(obj);
    }
    var subframeEnabled = true;
    var expressionsPlugin = null;
    var expressionsInterfaces = null;
    var idPrefix$1 = "";
    var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    var _shouldRoundValues = false;
    var bmPow = Math.pow;
    var bmSqrt = Math.sqrt;
    var bmFloor = Math.floor;
    var bmMax = Math.max;
    var bmMin = Math.min;
    var BMMath = {};
    (function() {
        var propertyNames = [
            "abs",
            "acos",
            "acosh",
            "asin",
            "asinh",
            "atan",
            "atanh",
            "atan2",
            "ceil",
            "cbrt",
            "expm1",
            "clz32",
            "cos",
            "cosh",
            "exp",
            "floor",
            "fround",
            "hypot",
            "imul",
            "log",
            "log1p",
            "log2",
            "log10",
            "max",
            "min",
            "pow",
            "random",
            "round",
            "sign",
            "sin",
            "sinh",
            "sqrt",
            "tan",
            "tanh",
            "trunc",
            "E",
            "LN10",
            "LN2",
            "LOG10E",
            "LOG2E",
            "PI",
            "SQRT1_2",
            "SQRT2"
        ];
        var i;
        var len = propertyNames.length;
        for(i = 0; i < len; i += 1)BMMath[propertyNames[i]] = Math[propertyNames[i]];
    })();
    function ProjectInterface$1() {
        return {};
    }
    BMMath.random = Math.random;
    BMMath.abs = function(val) {
        var tOfVal = _typeof$6(val);
        if (tOfVal === "object" && val.length) {
            var absArr = createSizedArray(val.length);
            var i;
            var len = val.length;
            for(i = 0; i < len; i += 1)absArr[i] = Math.abs(val[i]);
            return absArr;
        }
        return Math.abs(val);
    };
    var defaultCurveSegments = 150;
    var degToRads = Math.PI / 180;
    var roundCorner = 0.5519;
    function roundValues(flag) {
        _shouldRoundValues = !!flag;
    }
    function bmRnd(value) {
        if (_shouldRoundValues) return Math.round(value);
        return value;
    }
    function styleDiv(element) {
        element.style.position = "absolute";
        element.style.top = 0;
        element.style.left = 0;
        element.style.display = "block";
        element.style.transformOrigin = "0 0";
        element.style.webkitTransformOrigin = "0 0";
        element.style.backfaceVisibility = "visible";
        element.style.webkitBackfaceVisibility = "visible";
        element.style.transformStyle = "preserve-3d";
        element.style.webkitTransformStyle = "preserve-3d";
        element.style.mozTransformStyle = "preserve-3d";
    }
    function BMEnterFrameEvent(type, currentTime, totalTime, frameMultiplier) {
        this.type = type;
        this.currentTime = currentTime;
        this.totalTime = totalTime;
        this.direction = frameMultiplier < 0 ? -1 : 1;
    }
    function BMCompleteEvent(type, frameMultiplier) {
        this.type = type;
        this.direction = frameMultiplier < 0 ? -1 : 1;
    }
    function BMCompleteLoopEvent(type, totalLoops, currentLoop, frameMultiplier) {
        this.type = type;
        this.currentLoop = currentLoop;
        this.totalLoops = totalLoops;
        this.direction = frameMultiplier < 0 ? -1 : 1;
    }
    function BMSegmentStartEvent(type, firstFrame, totalFrames) {
        this.type = type;
        this.firstFrame = firstFrame;
        this.totalFrames = totalFrames;
    }
    function BMDestroyEvent(type, target) {
        this.type = type;
        this.target = target;
    }
    function BMRenderFrameErrorEvent(nativeError, currentTime) {
        this.type = "renderFrameError";
        this.nativeError = nativeError;
        this.currentTime = currentTime;
    }
    function BMConfigErrorEvent(nativeError) {
        this.type = "configError";
        this.nativeError = nativeError;
    }
    function BMAnimationConfigErrorEvent(type, nativeError) {
        this.type = type;
        this.nativeError = nativeError;
    }
    var createElementID = function() {
        var _count = 0;
        return function createID() {
            _count += 1;
            return idPrefix$1 + "__lottie_element_" + _count;
        };
    }();
    function HSVtoRGB(h, s, v) {
        var r;
        var g;
        var b;
        var i;
        var f;
        var p;
        var q;
        var t;
        i = Math.floor(h * 6);
        f = h * 6 - i;
        p = v * (1 - s);
        q = v * (1 - f * s);
        t = v * (1 - (1 - f) * s);
        switch(i % 6){
            case 0:
                r = v;
                g = t;
                b = p;
                break;
            case 1:
                r = q;
                g = v;
                b = p;
                break;
            case 2:
                r = p;
                g = v;
                b = t;
                break;
            case 3:
                r = p;
                g = q;
                b = v;
                break;
            case 4:
                r = t;
                g = p;
                b = v;
                break;
            case 5:
                r = v;
                g = p;
                b = q;
                break;
            default:
                break;
        }
        return [
            r,
            g,
            b
        ];
    }
    function RGBtoHSV(r, g, b) {
        var max = Math.max(r, g, b);
        var min = Math.min(r, g, b);
        var d = max - min;
        var h;
        var s = max === 0 ? 0 : d / max;
        var v = max / 255;
        switch(max){
            case min:
                h = 0;
                break;
            case r:
                h = g - b + d * (g < b ? 6 : 0);
                h /= 6 * d;
                break;
            case g:
                h = b - r + d * 2;
                h /= 6 * d;
                break;
            case b:
                h = r - g + d * 4;
                h /= 6 * d;
                break;
            default:
                break;
        }
        return [
            h,
            s,
            v
        ];
    }
    function addSaturationToRGB(color, offset) {
        var hsv = RGBtoHSV(color[0] * 255, color[1] * 255, color[2] * 255);
        hsv[1] += offset;
        if (hsv[1] > 1) hsv[1] = 1;
        else if (hsv[1] <= 0) hsv[1] = 0;
        return HSVtoRGB(hsv[0], hsv[1], hsv[2]);
    }
    function addBrightnessToRGB(color, offset) {
        var hsv = RGBtoHSV(color[0] * 255, color[1] * 255, color[2] * 255);
        hsv[2] += offset;
        if (hsv[2] > 1) hsv[2] = 1;
        else if (hsv[2] < 0) hsv[2] = 0;
        return HSVtoRGB(hsv[0], hsv[1], hsv[2]);
    }
    function addHueToRGB(color, offset) {
        var hsv = RGBtoHSV(color[0] * 255, color[1] * 255, color[2] * 255);
        hsv[0] += offset / 360;
        if (hsv[0] > 1) hsv[0] -= 1;
        else if (hsv[0] < 0) hsv[0] += 1;
        return HSVtoRGB(hsv[0], hsv[1], hsv[2]);
    }
    var rgbToHex = function() {
        var colorMap = [];
        var i;
        var hex;
        for(i = 0; i < 256; i += 1){
            hex = i.toString(16);
            colorMap[i] = hex.length === 1 ? "0" + hex : hex;
        }
        return function(r, g, b) {
            if (r < 0) r = 0;
            if (g < 0) g = 0;
            if (b < 0) b = 0;
            return "#" + colorMap[r] + colorMap[g] + colorMap[b];
        };
    }();
    var setSubframeEnabled = function setSubframeEnabled(flag) {
        subframeEnabled = !!flag;
    };
    var getSubframeEnabled = function getSubframeEnabled() {
        return subframeEnabled;
    };
    var setExpressionsPlugin = function setExpressionsPlugin(value) {
        expressionsPlugin = value;
    };
    var getExpressionsPlugin = function getExpressionsPlugin() {
        return expressionsPlugin;
    };
    var setExpressionInterfaces = function setExpressionInterfaces(value) {
        expressionsInterfaces = value;
    };
    var getExpressionInterfaces = function getExpressionInterfaces() {
        return expressionsInterfaces;
    };
    var setDefaultCurveSegments = function setDefaultCurveSegments(value) {
        defaultCurveSegments = value;
    };
    var getDefaultCurveSegments = function getDefaultCurveSegments() {
        return defaultCurveSegments;
    };
    var setIdPrefix = function setIdPrefix(value) {
        idPrefix$1 = value;
    };
    var getIdPrefix = function getIdPrefix() {
        return idPrefix$1;
    };
    function createNS(type) {
        // return {appendChild:function(){},setAttribute:function(){},style:{}}
        return document.createElementNS(svgNS, type);
    }
    function _typeof$5(obj) {
        "@babel/helpers - typeof";
        if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof$5 = function _typeof(obj) {
            return typeof obj;
        };
        else _typeof$5 = function _typeof(obj) {
            return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        };
        return _typeof$5(obj);
    }
    var dataManager = function() {
        var _counterId = 1;
        var processes = [];
        var workerFn;
        var workerInstance;
        var workerProxy = {
            onmessage: function onmessage() {},
            postMessage: function postMessage(path) {
                workerFn({
                    data: path
                });
            }
        };
        var _workerSelf = {
            postMessage: function postMessage(data) {
                workerProxy.onmessage({
                    data: data
                });
            }
        };
        function createWorker(fn) {
            if (window.Worker && window.Blob && getWebWorker()) {
                var blob = new Blob([
                    "var _workerSelf = self; self.onmessage = ",
                    fn.toString()
                ], {
                    type: "text/javascript"
                }); // var blob = new Blob(['self.onmessage = ', fn.toString()], { type: 'text/javascript' });
                var url = URL.createObjectURL(blob);
                return new Worker(url);
            }
            workerFn = fn;
            return workerProxy;
        }
        function setupWorker() {
            if (!workerInstance) {
                workerInstance = createWorker(function workerStart(e) {
                    function dataFunctionManager() {
                        function completeLayers(layers, comps) {
                            var layerData;
                            var i;
                            var len = layers.length;
                            var j;
                            var jLen;
                            var k;
                            var kLen;
                            for(i = 0; i < len; i += 1){
                                layerData = layers[i];
                                if ("ks" in layerData && !layerData.completed) {
                                    layerData.completed = true;
                                    if (layerData.hasMask) {
                                        var maskProps = layerData.masksProperties;
                                        jLen = maskProps.length;
                                        for(j = 0; j < jLen; j += 1)if (maskProps[j].pt.k.i) convertPathsToAbsoluteValues(maskProps[j].pt.k);
                                        else {
                                            kLen = maskProps[j].pt.k.length;
                                            for(k = 0; k < kLen; k += 1){
                                                if (maskProps[j].pt.k[k].s) convertPathsToAbsoluteValues(maskProps[j].pt.k[k].s[0]);
                                                if (maskProps[j].pt.k[k].e) convertPathsToAbsoluteValues(maskProps[j].pt.k[k].e[0]);
                                            }
                                        }
                                    }
                                    if (layerData.ty === 0) {
                                        layerData.layers = findCompLayers(layerData.refId, comps);
                                        completeLayers(layerData.layers, comps);
                                    } else if (layerData.ty === 4) completeShapes(layerData.shapes);
                                    else if (layerData.ty === 5) completeText(layerData);
                                }
                            }
                        }
                        function completeChars(chars, assets) {
                            if (chars) {
                                var i = 0;
                                var len = chars.length;
                                for(i = 0; i < len; i += 1)if (chars[i].t === 1) {
                                    // var compData = findComp(chars[i].data.refId, assets);
                                    chars[i].data.layers = findCompLayers(chars[i].data.refId, assets); // chars[i].data.ip = 0;
                                    // chars[i].data.op = 99999;
                                    // chars[i].data.st = 0;
                                    // chars[i].data.sr = 1;
                                    // chars[i].w = compData.w;
                                    // chars[i].data.ks = {
                                    //   a: { k: [0, 0, 0], a: 0 },
                                    //   p: { k: [0, -compData.h, 0], a: 0 },
                                    //   r: { k: 0, a: 0 },
                                    //   s: { k: [100, 100], a: 0 },
                                    //   o: { k: 100, a: 0 },
                                    // };
                                    completeLayers(chars[i].data.layers, assets);
                                }
                            }
                        }
                        function findComp(id, comps) {
                            var i = 0;
                            var len = comps.length;
                            while(i < len){
                                if (comps[i].id === id) return comps[i];
                                i += 1;
                            }
                            return null;
                        }
                        function findCompLayers(id, comps) {
                            var comp = findComp(id, comps);
                            if (comp) {
                                if (!comp.layers.__used) {
                                    comp.layers.__used = true;
                                    return comp.layers;
                                }
                                return JSON.parse(JSON.stringify(comp.layers));
                            }
                            return null;
                        }
                        function completeShapes(arr) {
                            var i;
                            var len = arr.length;
                            var j;
                            var jLen;
                            for(i = len - 1; i >= 0; i -= 1){
                                if (arr[i].ty === "sh") {
                                    if (arr[i].ks.k.i) convertPathsToAbsoluteValues(arr[i].ks.k);
                                    else {
                                        jLen = arr[i].ks.k.length;
                                        for(j = 0; j < jLen; j += 1){
                                            if (arr[i].ks.k[j].s) convertPathsToAbsoluteValues(arr[i].ks.k[j].s[0]);
                                            if (arr[i].ks.k[j].e) convertPathsToAbsoluteValues(arr[i].ks.k[j].e[0]);
                                        }
                                    }
                                } else if (arr[i].ty === "gr") completeShapes(arr[i].it);
                            }
                        }
                        function convertPathsToAbsoluteValues(path) {
                            var i;
                            var len = path.i.length;
                            for(i = 0; i < len; i += 1){
                                path.i[i][0] += path.v[i][0];
                                path.i[i][1] += path.v[i][1];
                                path.o[i][0] += path.v[i][0];
                                path.o[i][1] += path.v[i][1];
                            }
                        }
                        function checkVersion(minimum, animVersionString) {
                            var animVersion = animVersionString ? animVersionString.split(".") : [
                                100,
                                100,
                                100
                            ];
                            if (minimum[0] > animVersion[0]) return true;
                            if (animVersion[0] > minimum[0]) return false;
                            if (minimum[1] > animVersion[1]) return true;
                            if (animVersion[1] > minimum[1]) return false;
                            if (minimum[2] > animVersion[2]) return true;
                            if (animVersion[2] > minimum[2]) return false;
                            return null;
                        }
                        var checkText = function() {
                            var minimumVersion = [
                                4,
                                4,
                                14
                            ];
                            function updateTextLayer(textLayer) {
                                var documentData = textLayer.t.d;
                                textLayer.t.d = {
                                    k: [
                                        {
                                            s: documentData,
                                            t: 0
                                        }
                                    ]
                                };
                            }
                            function iterateLayers(layers) {
                                var i;
                                var len = layers.length;
                                for(i = 0; i < len; i += 1)if (layers[i].ty === 5) updateTextLayer(layers[i]);
                            }
                            return function(animationData) {
                                if (checkVersion(minimumVersion, animationData.v)) {
                                    iterateLayers(animationData.layers);
                                    if (animationData.assets) {
                                        var i;
                                        var len = animationData.assets.length;
                                        for(i = 0; i < len; i += 1)if (animationData.assets[i].layers) iterateLayers(animationData.assets[i].layers);
                                    }
                                }
                            };
                        }();
                        var checkChars = function() {
                            var minimumVersion = [
                                4,
                                7,
                                99
                            ];
                            return function(animationData) {
                                if (animationData.chars && !checkVersion(minimumVersion, animationData.v)) {
                                    var i;
                                    var len = animationData.chars.length;
                                    for(i = 0; i < len; i += 1){
                                        var charData = animationData.chars[i];
                                        if (charData.data && charData.data.shapes) {
                                            completeShapes(charData.data.shapes);
                                            charData.data.ip = 0;
                                            charData.data.op = 99999;
                                            charData.data.st = 0;
                                            charData.data.sr = 1;
                                            charData.data.ks = {
                                                p: {
                                                    k: [
                                                        0,
                                                        0
                                                    ],
                                                    a: 0
                                                },
                                                s: {
                                                    k: [
                                                        100,
                                                        100
                                                    ],
                                                    a: 0
                                                },
                                                a: {
                                                    k: [
                                                        0,
                                                        0
                                                    ],
                                                    a: 0
                                                },
                                                r: {
                                                    k: 0,
                                                    a: 0
                                                },
                                                o: {
                                                    k: 100,
                                                    a: 0
                                                }
                                            };
                                            if (!animationData.chars[i].t) {
                                                charData.data.shapes.push({
                                                    ty: "no"
                                                });
                                                charData.data.shapes[0].it.push({
                                                    p: {
                                                        k: [
                                                            0,
                                                            0
                                                        ],
                                                        a: 0
                                                    },
                                                    s: {
                                                        k: [
                                                            100,
                                                            100
                                                        ],
                                                        a: 0
                                                    },
                                                    a: {
                                                        k: [
                                                            0,
                                                            0
                                                        ],
                                                        a: 0
                                                    },
                                                    r: {
                                                        k: 0,
                                                        a: 0
                                                    },
                                                    o: {
                                                        k: 100,
                                                        a: 0
                                                    },
                                                    sk: {
                                                        k: 0,
                                                        a: 0
                                                    },
                                                    sa: {
                                                        k: 0,
                                                        a: 0
                                                    },
                                                    ty: "tr"
                                                });
                                            }
                                        }
                                    }
                                }
                            };
                        }();
                        var checkPathProperties = function() {
                            var minimumVersion = [
                                5,
                                7,
                                15
                            ];
                            function updateTextLayer(textLayer) {
                                var pathData = textLayer.t.p;
                                if (typeof pathData.a === "number") pathData.a = {
                                    a: 0,
                                    k: pathData.a
                                };
                                if (typeof pathData.p === "number") pathData.p = {
                                    a: 0,
                                    k: pathData.p
                                };
                                if (typeof pathData.r === "number") pathData.r = {
                                    a: 0,
                                    k: pathData.r
                                };
                            }
                            function iterateLayers(layers) {
                                var i;
                                var len = layers.length;
                                for(i = 0; i < len; i += 1)if (layers[i].ty === 5) updateTextLayer(layers[i]);
                            }
                            return function(animationData) {
                                if (checkVersion(minimumVersion, animationData.v)) {
                                    iterateLayers(animationData.layers);
                                    if (animationData.assets) {
                                        var i;
                                        var len = animationData.assets.length;
                                        for(i = 0; i < len; i += 1)if (animationData.assets[i].layers) iterateLayers(animationData.assets[i].layers);
                                    }
                                }
                            };
                        }();
                        var checkColors = function() {
                            var minimumVersion = [
                                4,
                                1,
                                9
                            ];
                            function iterateShapes(shapes) {
                                var i;
                                var len = shapes.length;
                                var j;
                                var jLen;
                                for(i = 0; i < len; i += 1){
                                    if (shapes[i].ty === "gr") iterateShapes(shapes[i].it);
                                    else if (shapes[i].ty === "fl" || shapes[i].ty === "st") {
                                        if (shapes[i].c.k && shapes[i].c.k[0].i) {
                                            jLen = shapes[i].c.k.length;
                                            for(j = 0; j < jLen; j += 1){
                                                if (shapes[i].c.k[j].s) {
                                                    shapes[i].c.k[j].s[0] /= 255;
                                                    shapes[i].c.k[j].s[1] /= 255;
                                                    shapes[i].c.k[j].s[2] /= 255;
                                                    shapes[i].c.k[j].s[3] /= 255;
                                                }
                                                if (shapes[i].c.k[j].e) {
                                                    shapes[i].c.k[j].e[0] /= 255;
                                                    shapes[i].c.k[j].e[1] /= 255;
                                                    shapes[i].c.k[j].e[2] /= 255;
                                                    shapes[i].c.k[j].e[3] /= 255;
                                                }
                                            }
                                        } else {
                                            shapes[i].c.k[0] /= 255;
                                            shapes[i].c.k[1] /= 255;
                                            shapes[i].c.k[2] /= 255;
                                            shapes[i].c.k[3] /= 255;
                                        }
                                    }
                                }
                            }
                            function iterateLayers(layers) {
                                var i;
                                var len = layers.length;
                                for(i = 0; i < len; i += 1)if (layers[i].ty === 4) iterateShapes(layers[i].shapes);
                            }
                            return function(animationData) {
                                if (checkVersion(minimumVersion, animationData.v)) {
                                    iterateLayers(animationData.layers);
                                    if (animationData.assets) {
                                        var i;
                                        var len = animationData.assets.length;
                                        for(i = 0; i < len; i += 1)if (animationData.assets[i].layers) iterateLayers(animationData.assets[i].layers);
                                    }
                                }
                            };
                        }();
                        var checkShapes = function() {
                            var minimumVersion = [
                                4,
                                4,
                                18
                            ];
                            function completeClosingShapes(arr) {
                                var i;
                                var len = arr.length;
                                var j;
                                var jLen;
                                for(i = len - 1; i >= 0; i -= 1){
                                    if (arr[i].ty === "sh") {
                                        if (arr[i].ks.k.i) arr[i].ks.k.c = arr[i].closed;
                                        else {
                                            jLen = arr[i].ks.k.length;
                                            for(j = 0; j < jLen; j += 1){
                                                if (arr[i].ks.k[j].s) arr[i].ks.k[j].s[0].c = arr[i].closed;
                                                if (arr[i].ks.k[j].e) arr[i].ks.k[j].e[0].c = arr[i].closed;
                                            }
                                        }
                                    } else if (arr[i].ty === "gr") completeClosingShapes(arr[i].it);
                                }
                            }
                            function iterateLayers(layers) {
                                var layerData;
                                var i;
                                var len = layers.length;
                                var j;
                                var jLen;
                                var k;
                                var kLen;
                                for(i = 0; i < len; i += 1){
                                    layerData = layers[i];
                                    if (layerData.hasMask) {
                                        var maskProps = layerData.masksProperties;
                                        jLen = maskProps.length;
                                        for(j = 0; j < jLen; j += 1)if (maskProps[j].pt.k.i) maskProps[j].pt.k.c = maskProps[j].cl;
                                        else {
                                            kLen = maskProps[j].pt.k.length;
                                            for(k = 0; k < kLen; k += 1){
                                                if (maskProps[j].pt.k[k].s) maskProps[j].pt.k[k].s[0].c = maskProps[j].cl;
                                                if (maskProps[j].pt.k[k].e) maskProps[j].pt.k[k].e[0].c = maskProps[j].cl;
                                            }
                                        }
                                    }
                                    if (layerData.ty === 4) completeClosingShapes(layerData.shapes);
                                }
                            }
                            return function(animationData) {
                                if (checkVersion(minimumVersion, animationData.v)) {
                                    iterateLayers(animationData.layers);
                                    if (animationData.assets) {
                                        var i;
                                        var len = animationData.assets.length;
                                        for(i = 0; i < len; i += 1)if (animationData.assets[i].layers) iterateLayers(animationData.assets[i].layers);
                                    }
                                }
                            };
                        }();
                        function completeData(animationData) {
                            if (animationData.__complete) return;
                            checkColors(animationData);
                            checkText(animationData);
                            checkChars(animationData);
                            checkPathProperties(animationData);
                            checkShapes(animationData);
                            completeLayers(animationData.layers, animationData.assets);
                            completeChars(animationData.chars, animationData.assets);
                            animationData.__complete = true;
                        }
                        function completeText(data) {
                            data.t.a.length === 0 && data.t.p;
                        }
                        var moduleOb = {};
                        moduleOb.completeData = completeData;
                        moduleOb.checkColors = checkColors;
                        moduleOb.checkChars = checkChars;
                        moduleOb.checkPathProperties = checkPathProperties;
                        moduleOb.checkShapes = checkShapes;
                        moduleOb.completeLayers = completeLayers;
                        return moduleOb;
                    }
                    if (!_workerSelf.dataManager) _workerSelf.dataManager = dataFunctionManager();
                    if (!_workerSelf.assetLoader) _workerSelf.assetLoader = function() {
                        function formatResponse(xhr) {
                            // using typeof doubles the time of execution of this method,
                            // so if available, it's better to use the header to validate the type
                            var contentTypeHeader = xhr.getResponseHeader("content-type");
                            if (contentTypeHeader && xhr.responseType === "json" && contentTypeHeader.indexOf("json") !== -1) return xhr.response;
                            if (xhr.response && _typeof$5(xhr.response) === "object") return xhr.response;
                            if (xhr.response && typeof xhr.response === "string") return JSON.parse(xhr.response);
                            if (xhr.responseText) return JSON.parse(xhr.responseText);
                            return null;
                        }
                        function loadAsset(path, fullPath, callback, errorCallback) {
                            var response;
                            var xhr = new XMLHttpRequest(); // set responseType after calling open or IE will break.
                            try {
                                // This crashes on Android WebView prior to KitKat
                                xhr.responseType = "json";
                            } catch (err) {} // eslint-disable-line no-empty
                            xhr.onreadystatechange = function() {
                                if (xhr.readyState === 4) {
                                    if (xhr.status === 200) {
                                        response = formatResponse(xhr);
                                        callback(response);
                                    } else try {
                                        response = formatResponse(xhr);
                                        callback(response);
                                    } catch (err) {
                                        if (errorCallback) errorCallback(err);
                                    }
                                }
                            };
                            try {
                                // Hack to workaround banner validation
                                xhr.open([
                                    "G",
                                    "E",
                                    "T"
                                ].join(""), path, true);
                            } catch (error) {
                                // Hack to workaround banner validation
                                xhr.open([
                                    "G",
                                    "E",
                                    "T"
                                ].join(""), fullPath + "/" + path, true);
                            }
                            xhr.send();
                        }
                        return {
                            load: loadAsset
                        };
                    }();
                    if (e.data.type === "loadAnimation") _workerSelf.assetLoader.load(e.data.path, e.data.fullPath, function(data) {
                        _workerSelf.dataManager.completeData(data);
                        _workerSelf.postMessage({
                            id: e.data.id,
                            payload: data,
                            status: "success"
                        });
                    }, function() {
                        _workerSelf.postMessage({
                            id: e.data.id,
                            status: "error"
                        });
                    });
                    else if (e.data.type === "complete") {
                        var animation = e.data.animation;
                        _workerSelf.dataManager.completeData(animation);
                        _workerSelf.postMessage({
                            id: e.data.id,
                            payload: animation,
                            status: "success"
                        });
                    } else if (e.data.type === "loadData") _workerSelf.assetLoader.load(e.data.path, e.data.fullPath, function(data) {
                        _workerSelf.postMessage({
                            id: e.data.id,
                            payload: data,
                            status: "success"
                        });
                    }, function() {
                        _workerSelf.postMessage({
                            id: e.data.id,
                            status: "error"
                        });
                    });
                });
                workerInstance.onmessage = function(event) {
                    var data = event.data;
                    var id = data.id;
                    var process = processes[id];
                    processes[id] = null;
                    if (data.status === "success") process.onComplete(data.payload);
                    else if (process.onError) process.onError();
                };
            }
        }
        function createProcess(onComplete, onError) {
            _counterId += 1;
            var id = "processId_" + _counterId;
            processes[id] = {
                onComplete: onComplete,
                onError: onError
            };
            return id;
        }
        function loadAnimation(path, onComplete, onError) {
            setupWorker();
            var processId = createProcess(onComplete, onError);
            workerInstance.postMessage({
                type: "loadAnimation",
                path: path,
                fullPath: window.location.origin + window.location.pathname,
                id: processId
            });
        }
        function loadData(path, onComplete, onError) {
            setupWorker();
            var processId = createProcess(onComplete, onError);
            workerInstance.postMessage({
                type: "loadData",
                path: path,
                fullPath: window.location.origin + window.location.pathname,
                id: processId
            });
        }
        function completeAnimation(anim, onComplete, onError) {
            setupWorker();
            var processId = createProcess(onComplete, onError);
            workerInstance.postMessage({
                type: "complete",
                animation: anim,
                id: processId
            });
        }
        return {
            loadAnimation: loadAnimation,
            loadData: loadData,
            completeAnimation: completeAnimation
        };
    }();
    var ImagePreloader = function() {
        var proxyImage = function() {
            var canvas = createTag("canvas");
            canvas.width = 1;
            canvas.height = 1;
            var ctx = canvas.getContext("2d");
            ctx.fillStyle = "rgba(0,0,0,0)";
            ctx.fillRect(0, 0, 1, 1);
            return canvas;
        }();
        function imageLoaded() {
            this.loadedAssets += 1;
            if (this.loadedAssets === this.totalImages && this.loadedFootagesCount === this.totalFootages) {
                if (this.imagesLoadedCb) this.imagesLoadedCb(null);
            }
        }
        function footageLoaded() {
            this.loadedFootagesCount += 1;
            if (this.loadedAssets === this.totalImages && this.loadedFootagesCount === this.totalFootages) {
                if (this.imagesLoadedCb) this.imagesLoadedCb(null);
            }
        }
        function getAssetsPath(assetData, assetsPath, originalPath) {
            var path = "";
            if (assetData.e) path = assetData.p;
            else if (assetsPath) {
                var imagePath = assetData.p;
                if (imagePath.indexOf("images/") !== -1) imagePath = imagePath.split("/")[1];
                path = assetsPath + imagePath;
            } else {
                path = originalPath;
                path += assetData.u ? assetData.u : "";
                path += assetData.p;
            }
            return path;
        }
        function testImageLoaded(img) {
            var _count = 0;
            var intervalId = setInterval((function() {
                var box = img.getBBox();
                if (box.width || _count > 500) {
                    this._imageLoaded();
                    clearInterval(intervalId);
                }
                _count += 1;
            }).bind(this), 50);
        }
        function createImageData(assetData) {
            var path = getAssetsPath(assetData, this.assetsPath, this.path);
            var img = createNS("image");
            if (isSafari) this.testImageLoaded(img);
            else img.addEventListener("load", this._imageLoaded, false);
            img.addEventListener("error", (function() {
                ob.img = proxyImage;
                this._imageLoaded();
            }).bind(this), false);
            img.setAttributeNS("http://www.w3.org/1999/xlink", "href", path);
            if (this._elementHelper.append) this._elementHelper.append(img);
            else this._elementHelper.appendChild(img);
            var ob = {
                img: img,
                assetData: assetData
            };
            return ob;
        }
        function createImgData(assetData) {
            var path = getAssetsPath(assetData, this.assetsPath, this.path);
            var img = createTag("img");
            img.crossOrigin = "anonymous";
            img.addEventListener("load", this._imageLoaded, false);
            img.addEventListener("error", (function() {
                ob.img = proxyImage;
                this._imageLoaded();
            }).bind(this), false);
            img.src = path;
            var ob = {
                img: img,
                assetData: assetData
            };
            return ob;
        }
        function createFootageData(data) {
            var ob = {
                assetData: data
            };
            var path = getAssetsPath(data, this.assetsPath, this.path);
            dataManager.loadData(path, (function(footageData) {
                ob.img = footageData;
                this._footageLoaded();
            }).bind(this), (function() {
                ob.img = {};
                this._footageLoaded();
            }).bind(this));
            return ob;
        }
        function loadAssets(assets, cb) {
            this.imagesLoadedCb = cb;
            var i;
            var len = assets.length;
            for(i = 0; i < len; i += 1)if (!assets[i].layers) {
                if (!assets[i].t || assets[i].t === "seq") {
                    this.totalImages += 1;
                    this.images.push(this._createImageData(assets[i]));
                } else if (assets[i].t === 3) {
                    this.totalFootages += 1;
                    this.images.push(this.createFootageData(assets[i]));
                }
            }
        }
        function setPath(path) {
            this.path = path || "";
        }
        function setAssetsPath(path) {
            this.assetsPath = path || "";
        }
        function getAsset(assetData) {
            var i = 0;
            var len = this.images.length;
            while(i < len){
                if (this.images[i].assetData === assetData) return this.images[i].img;
                i += 1;
            }
            return null;
        }
        function destroy() {
            this.imagesLoadedCb = null;
            this.images.length = 0;
        }
        function loadedImages() {
            return this.totalImages === this.loadedAssets;
        }
        function loadedFootages() {
            return this.totalFootages === this.loadedFootagesCount;
        }
        function setCacheType(type, elementHelper) {
            if (type === "svg") {
                this._elementHelper = elementHelper;
                this._createImageData = this.createImageData.bind(this);
            } else this._createImageData = this.createImgData.bind(this);
        }
        function ImagePreloaderFactory() {
            this._imageLoaded = imageLoaded.bind(this);
            this._footageLoaded = footageLoaded.bind(this);
            this.testImageLoaded = testImageLoaded.bind(this);
            this.createFootageData = createFootageData.bind(this);
            this.assetsPath = "";
            this.path = "";
            this.totalImages = 0;
            this.totalFootages = 0;
            this.loadedAssets = 0;
            this.loadedFootagesCount = 0;
            this.imagesLoadedCb = null;
            this.images = [];
        }
        ImagePreloaderFactory.prototype = {
            loadAssets: loadAssets,
            setAssetsPath: setAssetsPath,
            setPath: setPath,
            loadedImages: loadedImages,
            loadedFootages: loadedFootages,
            destroy: destroy,
            getAsset: getAsset,
            createImgData: createImgData,
            createImageData: createImageData,
            imageLoaded: imageLoaded,
            footageLoaded: footageLoaded,
            setCacheType: setCacheType
        };
        return ImagePreloaderFactory;
    }();
    function BaseEvent() {}
    BaseEvent.prototype = {
        triggerEvent: function triggerEvent(eventName, args) {
            if (this._cbs[eventName]) {
                var callbacks = this._cbs[eventName];
                for(var i = 0; i < callbacks.length; i += 1)callbacks[i](args);
            }
        },
        addEventListener: function addEventListener(eventName, callback) {
            if (!this._cbs[eventName]) this._cbs[eventName] = [];
            this._cbs[eventName].push(callback);
            return (function() {
                this.removeEventListener(eventName, callback);
            }).bind(this);
        },
        removeEventListener: function removeEventListener(eventName, callback) {
            if (!callback) this._cbs[eventName] = null;
            else if (this._cbs[eventName]) {
                var i = 0;
                var len = this._cbs[eventName].length;
                while(i < len){
                    if (this._cbs[eventName][i] === callback) {
                        this._cbs[eventName].splice(i, 1);
                        i -= 1;
                        len -= 1;
                    }
                    i += 1;
                }
                if (!this._cbs[eventName].length) this._cbs[eventName] = null;
            }
        }
    };
    var markerParser = function() {
        function parsePayloadLines(payload) {
            var lines = payload.split("\r\n");
            var keys = {};
            var line;
            var keysCount = 0;
            for(var i = 0; i < lines.length; i += 1){
                line = lines[i].split(":");
                if (line.length === 2) {
                    keys[line[0]] = line[1].trim();
                    keysCount += 1;
                }
            }
            if (keysCount === 0) throw new Error();
            return keys;
        }
        return function(_markers) {
            var markers = [];
            for(var i = 0; i < _markers.length; i += 1){
                var _marker = _markers[i];
                var markerData = {
                    time: _marker.tm,
                    duration: _marker.dr
                };
                try {
                    markerData.payload = JSON.parse(_markers[i].cm);
                } catch (_) {
                    try {
                        markerData.payload = parsePayloadLines(_markers[i].cm);
                    } catch (__) {
                        markerData.payload = {
                            name: _markers[i].cm
                        };
                    }
                }
                markers.push(markerData);
            }
            return markers;
        };
    }();
    var ProjectInterface = function() {
        function registerComposition(comp) {
            this.compositions.push(comp);
        }
        return function() {
            function _thisProjectFunction(name) {
                var i = 0;
                var len = this.compositions.length;
                while(i < len){
                    if (this.compositions[i].data && this.compositions[i].data.nm === name) {
                        if (this.compositions[i].prepareFrame && this.compositions[i].data.xt) this.compositions[i].prepareFrame(this.currentFrame);
                        return this.compositions[i].compInterface;
                    }
                    i += 1;
                }
                return null;
            }
            _thisProjectFunction.compositions = [];
            _thisProjectFunction.currentFrame = 0;
            _thisProjectFunction.registerComposition = registerComposition;
            return _thisProjectFunction;
        };
    }();
    var renderers = {};
    var registerRenderer = function registerRenderer(key, value) {
        renderers[key] = value;
    };
    function getRenderer(key) {
        return renderers[key];
    }
    function getRegisteredRenderer() {
        // Returns canvas by default for compatibility
        if (renderers.canvas) return "canvas";
         // Returns any renderer that is registered
        for(var key in renderers){
            if (renderers[key]) return key;
        }
        return "";
    }
    function _typeof$4(obj) {
        "@babel/helpers - typeof";
        if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof$4 = function _typeof(obj) {
            return typeof obj;
        };
        else _typeof$4 = function _typeof(obj) {
            return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        };
        return _typeof$4(obj);
    }
    var AnimationItem = function AnimationItem() {
        this._cbs = [];
        this.name = "";
        this.path = "";
        this.isLoaded = false;
        this.currentFrame = 0;
        this.currentRawFrame = 0;
        this.firstFrame = 0;
        this.totalFrames = 0;
        this.frameRate = 0;
        this.frameMult = 0;
        this.playSpeed = 1;
        this.playDirection = 1;
        this.playCount = 0;
        this.animationData = {};
        this.assets = [];
        this.isPaused = true;
        this.autoplay = false;
        this.loop = true;
        this.renderer = null;
        this.animationID = createElementID();
        this.assetsPath = "";
        this.timeCompleted = 0;
        this.segmentPos = 0;
        this.isSubframeEnabled = getSubframeEnabled();
        this.segments = [];
        this._idle = true;
        this._completedLoop = false;
        this.projectInterface = ProjectInterface();
        this.imagePreloader = new ImagePreloader();
        this.audioController = audioControllerFactory();
        this.markers = [];
        this.configAnimation = this.configAnimation.bind(this);
        this.onSetupError = this.onSetupError.bind(this);
        this.onSegmentComplete = this.onSegmentComplete.bind(this);
        this.drawnFrameEvent = new BMEnterFrameEvent("drawnFrame", 0, 0, 0);
        this.expressionsPlugin = getExpressionsPlugin();
    };
    extendPrototype([
        BaseEvent
    ], AnimationItem);
    AnimationItem.prototype.setParams = function(params) {
        if (params.wrapper || params.container) this.wrapper = params.wrapper || params.container;
        var animType = "svg";
        if (params.animType) animType = params.animType;
        else if (params.renderer) animType = params.renderer;
        var RendererClass = getRenderer(animType);
        this.renderer = new RendererClass(this, params.rendererSettings);
        this.imagePreloader.setCacheType(animType, this.renderer.globalData.defs);
        this.renderer.setProjectInterface(this.projectInterface);
        this.animType = animType;
        if (params.loop === "" || params.loop === null || params.loop === undefined || params.loop === true) this.loop = true;
        else if (params.loop === false) this.loop = false;
        else this.loop = parseInt(params.loop, 10);
        this.autoplay = "autoplay" in params ? params.autoplay : true;
        this.name = params.name ? params.name : "";
        this.autoloadSegments = Object.prototype.hasOwnProperty.call(params, "autoloadSegments") ? params.autoloadSegments : true;
        this.assetsPath = params.assetsPath;
        this.initialSegment = params.initialSegment;
        if (params.audioFactory) this.audioController.setAudioFactory(params.audioFactory);
        if (params.animationData) this.setupAnimation(params.animationData);
        else if (params.path) {
            if (params.path.lastIndexOf("\\") !== -1) this.path = params.path.substr(0, params.path.lastIndexOf("\\") + 1);
            else this.path = params.path.substr(0, params.path.lastIndexOf("/") + 1);
            this.fileName = params.path.substr(params.path.lastIndexOf("/") + 1);
            this.fileName = this.fileName.substr(0, this.fileName.lastIndexOf(".json"));
            dataManager.loadAnimation(params.path, this.configAnimation, this.onSetupError);
        }
    };
    AnimationItem.prototype.onSetupError = function() {
        this.trigger("data_failed");
    };
    AnimationItem.prototype.setupAnimation = function(data) {
        dataManager.completeAnimation(data, this.configAnimation);
    };
    AnimationItem.prototype.setData = function(wrapper, animationData) {
        if (animationData) {
            if (_typeof$4(animationData) !== "object") animationData = JSON.parse(animationData);
        }
        var params = {
            wrapper: wrapper,
            animationData: animationData
        };
        var wrapperAttributes = wrapper.attributes;
        params.path = wrapperAttributes.getNamedItem("data-animation-path") // eslint-disable-line no-nested-ternary
         ? wrapperAttributes.getNamedItem("data-animation-path").value : wrapperAttributes.getNamedItem("data-bm-path") // eslint-disable-line no-nested-ternary
         ? wrapperAttributes.getNamedItem("data-bm-path").value : wrapperAttributes.getNamedItem("bm-path") ? wrapperAttributes.getNamedItem("bm-path").value : "";
        params.animType = wrapperAttributes.getNamedItem("data-anim-type") // eslint-disable-line no-nested-ternary
         ? wrapperAttributes.getNamedItem("data-anim-type").value : wrapperAttributes.getNamedItem("data-bm-type") // eslint-disable-line no-nested-ternary
         ? wrapperAttributes.getNamedItem("data-bm-type").value : wrapperAttributes.getNamedItem("bm-type") // eslint-disable-line no-nested-ternary
         ? wrapperAttributes.getNamedItem("bm-type").value : wrapperAttributes.getNamedItem("data-bm-renderer") // eslint-disable-line no-nested-ternary
         ? wrapperAttributes.getNamedItem("data-bm-renderer").value : wrapperAttributes.getNamedItem("bm-renderer") ? wrapperAttributes.getNamedItem("bm-renderer").value : getRegisteredRenderer() || "canvas";
        var loop = wrapperAttributes.getNamedItem("data-anim-loop") // eslint-disable-line no-nested-ternary
         ? wrapperAttributes.getNamedItem("data-anim-loop").value : wrapperAttributes.getNamedItem("data-bm-loop") // eslint-disable-line no-nested-ternary
         ? wrapperAttributes.getNamedItem("data-bm-loop").value : wrapperAttributes.getNamedItem("bm-loop") ? wrapperAttributes.getNamedItem("bm-loop").value : "";
        if (loop === "false") params.loop = false;
        else if (loop === "true") params.loop = true;
        else if (loop !== "") params.loop = parseInt(loop, 10);
        var autoplay = wrapperAttributes.getNamedItem("data-anim-autoplay") // eslint-disable-line no-nested-ternary
         ? wrapperAttributes.getNamedItem("data-anim-autoplay").value : wrapperAttributes.getNamedItem("data-bm-autoplay") // eslint-disable-line no-nested-ternary
         ? wrapperAttributes.getNamedItem("data-bm-autoplay").value : wrapperAttributes.getNamedItem("bm-autoplay") ? wrapperAttributes.getNamedItem("bm-autoplay").value : true;
        params.autoplay = autoplay !== "false";
        params.name = wrapperAttributes.getNamedItem("data-name") // eslint-disable-line no-nested-ternary
         ? wrapperAttributes.getNamedItem("data-name").value : wrapperAttributes.getNamedItem("data-bm-name") // eslint-disable-line no-nested-ternary
         ? wrapperAttributes.getNamedItem("data-bm-name").value : wrapperAttributes.getNamedItem("bm-name") ? wrapperAttributes.getNamedItem("bm-name").value : "";
        var prerender = wrapperAttributes.getNamedItem("data-anim-prerender") // eslint-disable-line no-nested-ternary
         ? wrapperAttributes.getNamedItem("data-anim-prerender").value : wrapperAttributes.getNamedItem("data-bm-prerender") // eslint-disable-line no-nested-ternary
         ? wrapperAttributes.getNamedItem("data-bm-prerender").value : wrapperAttributes.getNamedItem("bm-prerender") ? wrapperAttributes.getNamedItem("bm-prerender").value : "";
        if (prerender === "false") params.prerender = false;
        if (!params.path) this.trigger("destroy");
        else this.setParams(params);
    };
    AnimationItem.prototype.includeLayers = function(data) {
        if (data.op > this.animationData.op) {
            this.animationData.op = data.op;
            this.totalFrames = Math.floor(data.op - this.animationData.ip);
        }
        var layers = this.animationData.layers;
        var i;
        var len = layers.length;
        var newLayers = data.layers;
        var j;
        var jLen = newLayers.length;
        for(j = 0; j < jLen; j += 1){
            i = 0;
            while(i < len){
                if (layers[i].id === newLayers[j].id) {
                    layers[i] = newLayers[j];
                    break;
                }
                i += 1;
            }
        }
        if (data.chars || data.fonts) {
            this.renderer.globalData.fontManager.addChars(data.chars);
            this.renderer.globalData.fontManager.addFonts(data.fonts, this.renderer.globalData.defs);
        }
        if (data.assets) {
            len = data.assets.length;
            for(i = 0; i < len; i += 1)this.animationData.assets.push(data.assets[i]);
        }
        this.animationData.__complete = false;
        dataManager.completeAnimation(this.animationData, this.onSegmentComplete);
    };
    AnimationItem.prototype.onSegmentComplete = function(data) {
        this.animationData = data;
        var expressionsPlugin = getExpressionsPlugin();
        if (expressionsPlugin) expressionsPlugin.initExpressions(this);
        this.loadNextSegment();
    };
    AnimationItem.prototype.loadNextSegment = function() {
        var segments = this.animationData.segments;
        if (!segments || segments.length === 0 || !this.autoloadSegments) {
            this.trigger("data_ready");
            this.timeCompleted = this.totalFrames;
            return;
        }
        var segment = segments.shift();
        this.timeCompleted = segment.time * this.frameRate;
        var segmentPath = this.path + this.fileName + "_" + this.segmentPos + ".json";
        this.segmentPos += 1;
        dataManager.loadData(segmentPath, this.includeLayers.bind(this), (function() {
            this.trigger("data_failed");
        }).bind(this));
    };
    AnimationItem.prototype.loadSegments = function() {
        var segments = this.animationData.segments;
        if (!segments) this.timeCompleted = this.totalFrames;
        this.loadNextSegment();
    };
    AnimationItem.prototype.imagesLoaded = function() {
        this.trigger("loaded_images");
        this.checkLoaded();
    };
    AnimationItem.prototype.preloadImages = function() {
        this.imagePreloader.setAssetsPath(this.assetsPath);
        this.imagePreloader.setPath(this.path);
        this.imagePreloader.loadAssets(this.animationData.assets, this.imagesLoaded.bind(this));
    };
    AnimationItem.prototype.configAnimation = function(animData) {
        if (!this.renderer) return;
        try {
            this.animationData = animData;
            if (this.initialSegment) {
                this.totalFrames = Math.floor(this.initialSegment[1] - this.initialSegment[0]);
                this.firstFrame = Math.round(this.initialSegment[0]);
            } else {
                this.totalFrames = Math.floor(this.animationData.op - this.animationData.ip);
                this.firstFrame = Math.round(this.animationData.ip);
            }
            this.renderer.configAnimation(animData);
            if (!animData.assets) animData.assets = [];
            this.assets = this.animationData.assets;
            this.frameRate = this.animationData.fr;
            this.frameMult = this.animationData.fr / 1000;
            this.renderer.searchExtraCompositions(animData.assets);
            this.markers = markerParser(animData.markers || []);
            this.trigger("config_ready");
            this.preloadImages();
            this.loadSegments();
            this.updaFrameModifier();
            this.waitForFontsLoaded();
            if (this.isPaused) this.audioController.pause();
        } catch (error) {
            this.triggerConfigError(error);
        }
    };
    AnimationItem.prototype.waitForFontsLoaded = function() {
        if (!this.renderer) return;
        if (this.renderer.globalData.fontManager.isLoaded) this.checkLoaded();
        else setTimeout(this.waitForFontsLoaded.bind(this), 20);
    };
    AnimationItem.prototype.checkLoaded = function() {
        if (!this.isLoaded && this.renderer.globalData.fontManager.isLoaded && (this.imagePreloader.loadedImages() || this.renderer.rendererType !== "canvas") && this.imagePreloader.loadedFootages()) {
            this.isLoaded = true;
            var expressionsPlugin = getExpressionsPlugin();
            if (expressionsPlugin) expressionsPlugin.initExpressions(this);
            this.renderer.initItems();
            setTimeout((function() {
                this.trigger("DOMLoaded");
            }).bind(this), 0);
            this.gotoFrame();
            if (this.autoplay) this.play();
        }
    };
    AnimationItem.prototype.resize = function(width, height) {
        // Adding this validation for backwards compatibility in case an event object was being passed down
        var _width = typeof width === "number" ? width : undefined;
        var _height = typeof height === "number" ? height : undefined;
        this.renderer.updateContainerSize(_width, _height);
    };
    AnimationItem.prototype.setSubframe = function(flag) {
        this.isSubframeEnabled = !!flag;
    };
    AnimationItem.prototype.gotoFrame = function() {
        this.currentFrame = this.isSubframeEnabled ? this.currentRawFrame : ~~this.currentRawFrame; // eslint-disable-line no-bitwise
        if (this.timeCompleted !== this.totalFrames && this.currentFrame > this.timeCompleted) this.currentFrame = this.timeCompleted;
        this.trigger("enterFrame");
        this.renderFrame();
        this.trigger("drawnFrame");
    };
    AnimationItem.prototype.renderFrame = function() {
        if (this.isLoaded === false || !this.renderer) return;
        try {
            if (this.expressionsPlugin) this.expressionsPlugin.resetFrame();
            this.renderer.renderFrame(this.currentFrame + this.firstFrame);
        } catch (error) {
            this.triggerRenderFrameError(error);
        }
    };
    AnimationItem.prototype.play = function(name) {
        if (name && this.name !== name) return;
        if (this.isPaused === true) {
            this.isPaused = false;
            this.trigger("_play");
            this.audioController.resume();
            if (this._idle) {
                this._idle = false;
                this.trigger("_active");
            }
        }
    };
    AnimationItem.prototype.pause = function(name) {
        if (name && this.name !== name) return;
        if (this.isPaused === false) {
            this.isPaused = true;
            this.trigger("_pause");
            this._idle = true;
            this.trigger("_idle");
            this.audioController.pause();
        }
    };
    AnimationItem.prototype.togglePause = function(name) {
        if (name && this.name !== name) return;
        if (this.isPaused === true) this.play();
        else this.pause();
    };
    AnimationItem.prototype.stop = function(name) {
        if (name && this.name !== name) return;
        this.pause();
        this.playCount = 0;
        this._completedLoop = false;
        this.setCurrentRawFrameValue(0);
    };
    AnimationItem.prototype.getMarkerData = function(markerName) {
        var marker;
        for(var i = 0; i < this.markers.length; i += 1){
            marker = this.markers[i];
            if (marker.payload && marker.payload.name === markerName) return marker;
        }
        return null;
    };
    AnimationItem.prototype.goToAndStop = function(value, isFrame, name) {
        if (name && this.name !== name) return;
        var numValue = Number(value);
        if (isNaN(numValue)) {
            var marker = this.getMarkerData(value);
            if (marker) this.goToAndStop(marker.time, true);
        } else if (isFrame) this.setCurrentRawFrameValue(value);
        else this.setCurrentRawFrameValue(value * this.frameModifier);
        this.pause();
    };
    AnimationItem.prototype.goToAndPlay = function(value, isFrame, name) {
        if (name && this.name !== name) return;
        var numValue = Number(value);
        if (isNaN(numValue)) {
            var marker = this.getMarkerData(value);
            if (marker) {
                if (!marker.duration) this.goToAndStop(marker.time, true);
                else this.playSegments([
                    marker.time,
                    marker.time + marker.duration
                ], true);
            }
        } else this.goToAndStop(numValue, isFrame, name);
        this.play();
    };
    AnimationItem.prototype.advanceTime = function(value) {
        if (this.isPaused === true || this.isLoaded === false) return;
        var nextValue = this.currentRawFrame + value * this.frameModifier;
        var _isComplete = false; // Checking if nextValue > totalFrames - 1 for addressing non looping and looping animations.
        // If animation won't loop, it should stop at totalFrames - 1. If it will loop it should complete the last frame and then loop.
        if (nextValue >= this.totalFrames - 1 && this.frameModifier > 0) {
            if (!this.loop || this.playCount === this.loop) {
                if (!this.checkSegments(nextValue > this.totalFrames ? nextValue % this.totalFrames : 0)) {
                    _isComplete = true;
                    nextValue = this.totalFrames - 1;
                }
            } else if (nextValue >= this.totalFrames) {
                this.playCount += 1;
                if (!this.checkSegments(nextValue % this.totalFrames)) {
                    this.setCurrentRawFrameValue(nextValue % this.totalFrames);
                    this._completedLoop = true;
                    this.trigger("loopComplete");
                }
            } else this.setCurrentRawFrameValue(nextValue);
        } else if (nextValue < 0) {
            if (!this.checkSegments(nextValue % this.totalFrames)) {
                if (this.loop && !(this.playCount-- <= 0 && this.loop !== true)) {
                    // eslint-disable-line no-plusplus
                    this.setCurrentRawFrameValue(this.totalFrames + nextValue % this.totalFrames);
                    if (!this._completedLoop) this._completedLoop = true;
                    else this.trigger("loopComplete");
                } else {
                    _isComplete = true;
                    nextValue = 0;
                }
            }
        } else this.setCurrentRawFrameValue(nextValue);
        if (_isComplete) {
            this.setCurrentRawFrameValue(nextValue);
            this.pause();
            this.trigger("complete");
        }
    };
    AnimationItem.prototype.adjustSegment = function(arr, offset) {
        this.playCount = 0;
        if (arr[1] < arr[0]) {
            if (this.frameModifier > 0) {
                if (this.playSpeed < 0) this.setSpeed(-this.playSpeed);
                else this.setDirection(-1);
            }
            this.totalFrames = arr[0] - arr[1];
            this.timeCompleted = this.totalFrames;
            this.firstFrame = arr[1];
            this.setCurrentRawFrameValue(this.totalFrames - 0.001 - offset);
        } else if (arr[1] > arr[0]) {
            if (this.frameModifier < 0) {
                if (this.playSpeed < 0) this.setSpeed(-this.playSpeed);
                else this.setDirection(1);
            }
            this.totalFrames = arr[1] - arr[0];
            this.timeCompleted = this.totalFrames;
            this.firstFrame = arr[0];
            this.setCurrentRawFrameValue(0.001 + offset);
        }
        this.trigger("segmentStart");
    };
    AnimationItem.prototype.setSegment = function(init, end) {
        var pendingFrame = -1;
        if (this.isPaused) {
            if (this.currentRawFrame + this.firstFrame < init) pendingFrame = init;
            else if (this.currentRawFrame + this.firstFrame > end) pendingFrame = end - init;
        }
        this.firstFrame = init;
        this.totalFrames = end - init;
        this.timeCompleted = this.totalFrames;
        if (pendingFrame !== -1) this.goToAndStop(pendingFrame, true);
    };
    AnimationItem.prototype.playSegments = function(arr, forceFlag) {
        if (forceFlag) this.segments.length = 0;
        if (_typeof$4(arr[0]) === "object") {
            var i;
            var len = arr.length;
            for(i = 0; i < len; i += 1)this.segments.push(arr[i]);
        } else this.segments.push(arr);
        if (this.segments.length && forceFlag) this.adjustSegment(this.segments.shift(), 0);
        if (this.isPaused) this.play();
    };
    AnimationItem.prototype.resetSegments = function(forceFlag) {
        this.segments.length = 0;
        this.segments.push([
            this.animationData.ip,
            this.animationData.op
        ]);
        if (forceFlag) this.checkSegments(0);
    };
    AnimationItem.prototype.checkSegments = function(offset) {
        if (this.segments.length) {
            this.adjustSegment(this.segments.shift(), offset);
            return true;
        }
        return false;
    };
    AnimationItem.prototype.destroy = function(name) {
        if (name && this.name !== name || !this.renderer) return;
        this.renderer.destroy();
        this.imagePreloader.destroy();
        this.trigger("destroy");
        this._cbs = null;
        this.onEnterFrame = null;
        this.onLoopComplete = null;
        this.onComplete = null;
        this.onSegmentStart = null;
        this.onDestroy = null;
        this.renderer = null;
        this.expressionsPlugin = null;
        this.imagePreloader = null;
        this.projectInterface = null;
    };
    AnimationItem.prototype.setCurrentRawFrameValue = function(value) {
        this.currentRawFrame = value;
        this.gotoFrame();
    };
    AnimationItem.prototype.setSpeed = function(val) {
        this.playSpeed = val;
        this.updaFrameModifier();
    };
    AnimationItem.prototype.setDirection = function(val) {
        this.playDirection = val < 0 ? -1 : 1;
        this.updaFrameModifier();
    };
    AnimationItem.prototype.setLoop = function(isLooping) {
        this.loop = isLooping;
    };
    AnimationItem.prototype.setVolume = function(val, name) {
        if (name && this.name !== name) return;
        this.audioController.setVolume(val);
    };
    AnimationItem.prototype.getVolume = function() {
        return this.audioController.getVolume();
    };
    AnimationItem.prototype.mute = function(name) {
        if (name && this.name !== name) return;
        this.audioController.mute();
    };
    AnimationItem.prototype.unmute = function(name) {
        if (name && this.name !== name) return;
        this.audioController.unmute();
    };
    AnimationItem.prototype.updaFrameModifier = function() {
        this.frameModifier = this.frameMult * this.playSpeed * this.playDirection;
        this.audioController.setRate(this.playSpeed * this.playDirection);
    };
    AnimationItem.prototype.getPath = function() {
        return this.path;
    };
    AnimationItem.prototype.getAssetsPath = function(assetData) {
        var path = "";
        if (assetData.e) path = assetData.p;
        else if (this.assetsPath) {
            var imagePath = assetData.p;
            if (imagePath.indexOf("images/") !== -1) imagePath = imagePath.split("/")[1];
            path = this.assetsPath + imagePath;
        } else {
            path = this.path;
            path += assetData.u ? assetData.u : "";
            path += assetData.p;
        }
        return path;
    };
    AnimationItem.prototype.getAssetData = function(id) {
        var i = 0;
        var len = this.assets.length;
        while(i < len){
            if (id === this.assets[i].id) return this.assets[i];
            i += 1;
        }
        return null;
    };
    AnimationItem.prototype.hide = function() {
        this.renderer.hide();
    };
    AnimationItem.prototype.show = function() {
        this.renderer.show();
    };
    AnimationItem.prototype.getDuration = function(isFrame) {
        return isFrame ? this.totalFrames : this.totalFrames / this.frameRate;
    };
    AnimationItem.prototype.updateDocumentData = function(path, documentData, index) {
        try {
            var element = this.renderer.getElementByPath(path);
            element.updateDocumentData(documentData, index);
        } catch (error) {}
    };
    AnimationItem.prototype.trigger = function(name) {
        if (this._cbs && this._cbs[name]) switch(name){
            case "enterFrame":
                this.triggerEvent(name, new BMEnterFrameEvent(name, this.currentFrame, this.totalFrames, this.frameModifier));
                break;
            case "drawnFrame":
                this.drawnFrameEvent.currentTime = this.currentFrame;
                this.drawnFrameEvent.totalTime = this.totalFrames;
                this.drawnFrameEvent.direction = this.frameModifier;
                this.triggerEvent(name, this.drawnFrameEvent);
                break;
            case "loopComplete":
                this.triggerEvent(name, new BMCompleteLoopEvent(name, this.loop, this.playCount, this.frameMult));
                break;
            case "complete":
                this.triggerEvent(name, new BMCompleteEvent(name, this.frameMult));
                break;
            case "segmentStart":
                this.triggerEvent(name, new BMSegmentStartEvent(name, this.firstFrame, this.totalFrames));
                break;
            case "destroy":
                this.triggerEvent(name, new BMDestroyEvent(name, this));
                break;
            default:
                this.triggerEvent(name);
        }
        if (name === "enterFrame" && this.onEnterFrame) this.onEnterFrame.call(this, new BMEnterFrameEvent(name, this.currentFrame, this.totalFrames, this.frameMult));
        if (name === "loopComplete" && this.onLoopComplete) this.onLoopComplete.call(this, new BMCompleteLoopEvent(name, this.loop, this.playCount, this.frameMult));
        if (name === "complete" && this.onComplete) this.onComplete.call(this, new BMCompleteEvent(name, this.frameMult));
        if (name === "segmentStart" && this.onSegmentStart) this.onSegmentStart.call(this, new BMSegmentStartEvent(name, this.firstFrame, this.totalFrames));
        if (name === "destroy" && this.onDestroy) this.onDestroy.call(this, new BMDestroyEvent(name, this));
    };
    AnimationItem.prototype.triggerRenderFrameError = function(nativeError) {
        var error = new BMRenderFrameErrorEvent(nativeError, this.currentFrame);
        this.triggerEvent("error", error);
        if (this.onError) this.onError.call(this, error);
    };
    AnimationItem.prototype.triggerConfigError = function(nativeError) {
        var error = new BMConfigErrorEvent(nativeError, this.currentFrame);
        this.triggerEvent("error", error);
        if (this.onError) this.onError.call(this, error);
    };
    var animationManager = function() {
        var moduleOb = {};
        var registeredAnimations = [];
        var initTime = 0;
        var len = 0;
        var playingAnimationsNum = 0;
        var _stopped = true;
        var _isFrozen = false;
        function removeElement(ev) {
            var i = 0;
            var animItem = ev.target;
            while(i < len){
                if (registeredAnimations[i].animation === animItem) {
                    registeredAnimations.splice(i, 1);
                    i -= 1;
                    len -= 1;
                    if (!animItem.isPaused) subtractPlayingCount();
                }
                i += 1;
            }
        }
        function registerAnimation(element, animationData) {
            if (!element) return null;
            var i = 0;
            while(i < len){
                if (registeredAnimations[i].elem === element && registeredAnimations[i].elem !== null) return registeredAnimations[i].animation;
                i += 1;
            }
            var animItem = new AnimationItem();
            setupAnimation(animItem, element);
            animItem.setData(element, animationData);
            return animItem;
        }
        function getRegisteredAnimations() {
            var i;
            var lenAnims = registeredAnimations.length;
            var animations = [];
            for(i = 0; i < lenAnims; i += 1)animations.push(registeredAnimations[i].animation);
            return animations;
        }
        function addPlayingCount() {
            playingAnimationsNum += 1;
            activate();
        }
        function subtractPlayingCount() {
            playingAnimationsNum -= 1;
        }
        function setupAnimation(animItem, element) {
            animItem.addEventListener("destroy", removeElement);
            animItem.addEventListener("_active", addPlayingCount);
            animItem.addEventListener("_idle", subtractPlayingCount);
            registeredAnimations.push({
                elem: element,
                animation: animItem
            });
            len += 1;
        }
        function loadAnimation(params) {
            var animItem = new AnimationItem();
            setupAnimation(animItem, null);
            animItem.setParams(params);
            return animItem;
        }
        function setSpeed(val, animation) {
            var i;
            for(i = 0; i < len; i += 1)registeredAnimations[i].animation.setSpeed(val, animation);
        }
        function setDirection(val, animation) {
            var i;
            for(i = 0; i < len; i += 1)registeredAnimations[i].animation.setDirection(val, animation);
        }
        function play(animation) {
            var i;
            for(i = 0; i < len; i += 1)registeredAnimations[i].animation.play(animation);
        }
        function resume(nowTime) {
            var elapsedTime = nowTime - initTime;
            var i;
            for(i = 0; i < len; i += 1)registeredAnimations[i].animation.advanceTime(elapsedTime);
            initTime = nowTime;
            if (playingAnimationsNum && !_isFrozen) window.requestAnimationFrame(resume);
            else _stopped = true;
        }
        function first(nowTime) {
            initTime = nowTime;
            window.requestAnimationFrame(resume);
        }
        function pause(animation) {
            var i;
            for(i = 0; i < len; i += 1)registeredAnimations[i].animation.pause(animation);
        }
        function goToAndStop(value, isFrame, animation) {
            var i;
            for(i = 0; i < len; i += 1)registeredAnimations[i].animation.goToAndStop(value, isFrame, animation);
        }
        function stop(animation) {
            var i;
            for(i = 0; i < len; i += 1)registeredAnimations[i].animation.stop(animation);
        }
        function togglePause(animation) {
            var i;
            for(i = 0; i < len; i += 1)registeredAnimations[i].animation.togglePause(animation);
        }
        function destroy(animation) {
            var i;
            for(i = len - 1; i >= 0; i -= 1)registeredAnimations[i].animation.destroy(animation);
        }
        function searchAnimations(animationData, standalone, renderer) {
            var animElements = [].concat([].slice.call(document.getElementsByClassName("lottie")), [].slice.call(document.getElementsByClassName("bodymovin")));
            var i;
            var lenAnims = animElements.length;
            for(i = 0; i < lenAnims; i += 1){
                if (renderer) animElements[i].setAttribute("data-bm-type", renderer);
                registerAnimation(animElements[i], animationData);
            }
            if (standalone && lenAnims === 0) {
                if (!renderer) renderer = "svg";
                var body = document.getElementsByTagName("body")[0];
                body.innerText = "";
                var div = createTag("div");
                div.style.width = "100%";
                div.style.height = "100%";
                div.setAttribute("data-bm-type", renderer);
                body.appendChild(div);
                registerAnimation(div, animationData);
            }
        }
        function resize() {
            var i;
            for(i = 0; i < len; i += 1)registeredAnimations[i].animation.resize();
        }
        function activate() {
            if (!_isFrozen && playingAnimationsNum) {
                if (_stopped) {
                    window.requestAnimationFrame(first);
                    _stopped = false;
                }
            }
        }
        function freeze() {
            _isFrozen = true;
        }
        function unfreeze() {
            _isFrozen = false;
            activate();
        }
        function setVolume(val, animation) {
            var i;
            for(i = 0; i < len; i += 1)registeredAnimations[i].animation.setVolume(val, animation);
        }
        function mute(animation) {
            var i;
            for(i = 0; i < len; i += 1)registeredAnimations[i].animation.mute(animation);
        }
        function unmute(animation) {
            var i;
            for(i = 0; i < len; i += 1)registeredAnimations[i].animation.unmute(animation);
        }
        moduleOb.registerAnimation = registerAnimation;
        moduleOb.loadAnimation = loadAnimation;
        moduleOb.setSpeed = setSpeed;
        moduleOb.setDirection = setDirection;
        moduleOb.play = play;
        moduleOb.pause = pause;
        moduleOb.stop = stop;
        moduleOb.togglePause = togglePause;
        moduleOb.searchAnimations = searchAnimations;
        moduleOb.resize = resize; // moduleOb.start = start;
        moduleOb.goToAndStop = goToAndStop;
        moduleOb.destroy = destroy;
        moduleOb.freeze = freeze;
        moduleOb.unfreeze = unfreeze;
        moduleOb.setVolume = setVolume;
        moduleOb.mute = mute;
        moduleOb.unmute = unmute;
        moduleOb.getRegisteredAnimations = getRegisteredAnimations;
        return moduleOb;
    }();
    /* eslint-disable */ var BezierFactory = function() {
        /**
       * BezierEasing - use bezier curve for transition easing function
       * by Gaëtan Renaudeau 2014 - 2015 – MIT License
       *
       * Credits: is based on Firefox's nsSMILKeySpline.cpp
       * Usage:
       * var spline = BezierEasing([ 0.25, 0.1, 0.25, 1.0 ])
       * spline.get(x) => returns the easing value | x must be in [0, 1] range
       *
       */ var ob = {};
        ob.getBezierEasing = getBezierEasing;
        var beziers = {};
        function getBezierEasing(a, b, c, d, nm) {
            var str = nm || ("bez_" + a + "_" + b + "_" + c + "_" + d).replace(/\./g, "p");
            if (beziers[str]) return beziers[str];
            var bezEasing = new BezierEasing([
                a,
                b,
                c,
                d
            ]);
            beziers[str] = bezEasing;
            return bezEasing;
        } // These values are established by empiricism with tests (tradeoff: performance VS precision)
        var NEWTON_ITERATIONS = 4;
        var NEWTON_MIN_SLOPE = 0.001;
        var SUBDIVISION_PRECISION = 0.0000001;
        var SUBDIVISION_MAX_ITERATIONS = 10;
        var kSplineTableSize = 11;
        var kSampleStepSize = 1.0 / (kSplineTableSize - 1.0);
        var float32ArraySupported = typeof Float32Array === "function";
        function A(aA1, aA2) {
            return 1.0 - 3.0 * aA2 + 3.0 * aA1;
        }
        function B(aA1, aA2) {
            return 3.0 * aA2 - 6.0 * aA1;
        }
        function C(aA1) {
            return 3.0 * aA1;
        } // Returns x(t) given t, x1, and x2, or y(t) given t, y1, and y2.
        function calcBezier(aT, aA1, aA2) {
            return ((A(aA1, aA2) * aT + B(aA1, aA2)) * aT + C(aA1)) * aT;
        } // Returns dx/dt given t, x1, and x2, or dy/dt given t, y1, and y2.
        function getSlope(aT, aA1, aA2) {
            return 3.0 * A(aA1, aA2) * aT * aT + 2.0 * B(aA1, aA2) * aT + C(aA1);
        }
        function binarySubdivide(aX, aA, aB, mX1, mX2) {
            var currentX, currentT, i = 0;
            do {
                currentT = aA + (aB - aA) / 2.0;
                currentX = calcBezier(currentT, mX1, mX2) - aX;
                if (currentX > 0.0) aB = currentT;
                else aA = currentT;
            }while (Math.abs(currentX) > SUBDIVISION_PRECISION && ++i < SUBDIVISION_MAX_ITERATIONS);
            return currentT;
        }
        function newtonRaphsonIterate(aX, aGuessT, mX1, mX2) {
            for(var i = 0; i < NEWTON_ITERATIONS; ++i){
                var currentSlope = getSlope(aGuessT, mX1, mX2);
                if (currentSlope === 0.0) return aGuessT;
                var currentX = calcBezier(aGuessT, mX1, mX2) - aX;
                aGuessT -= currentX / currentSlope;
            }
            return aGuessT;
        }
        /**
       * points is an array of [ mX1, mY1, mX2, mY2 ]
       */ function BezierEasing(points) {
            this._p = points;
            this._mSampleValues = float32ArraySupported ? new Float32Array(kSplineTableSize) : new Array(kSplineTableSize);
            this._precomputed = false;
            this.get = this.get.bind(this);
        }
        BezierEasing.prototype = {
            get: function get(x) {
                var mX1 = this._p[0], mY1 = this._p[1], mX2 = this._p[2], mY2 = this._p[3];
                if (!this._precomputed) this._precompute();
                if (mX1 === mY1 && mX2 === mY2) return x; // linear
                // Because JavaScript number are imprecise, we should guarantee the extremes are right.
                if (x === 0) return 0;
                if (x === 1) return 1;
                return calcBezier(this._getTForX(x), mY1, mY2);
            },
            // Private part
            _precompute: function _precompute() {
                var mX1 = this._p[0], mY1 = this._p[1], mX2 = this._p[2], mY2 = this._p[3];
                this._precomputed = true;
                if (mX1 !== mY1 || mX2 !== mY2) this._calcSampleValues();
            },
            _calcSampleValues: function _calcSampleValues() {
                var mX1 = this._p[0], mX2 = this._p[2];
                for(var i = 0; i < kSplineTableSize; ++i)this._mSampleValues[i] = calcBezier(i * kSampleStepSize, mX1, mX2);
            },
            /**
           * getTForX chose the fastest heuristic to determine the percentage value precisely from a given X projection.
           */ _getTForX: function _getTForX(aX) {
                var mX1 = this._p[0], mX2 = this._p[2], mSampleValues = this._mSampleValues;
                var intervalStart = 0.0;
                var currentSample = 1;
                var lastSample = kSplineTableSize - 1;
                for(; currentSample !== lastSample && mSampleValues[currentSample] <= aX; ++currentSample)intervalStart += kSampleStepSize;
                --currentSample; // Interpolate to provide an initial guess for t
                var dist = (aX - mSampleValues[currentSample]) / (mSampleValues[currentSample + 1] - mSampleValues[currentSample]);
                var guessForT = intervalStart + dist * kSampleStepSize;
                var initialSlope = getSlope(guessForT, mX1, mX2);
                if (initialSlope >= NEWTON_MIN_SLOPE) return newtonRaphsonIterate(aX, guessForT, mX1, mX2);
                if (initialSlope === 0.0) return guessForT;
                return binarySubdivide(aX, intervalStart, intervalStart + kSampleStepSize, mX1, mX2);
            }
        };
        return ob;
    }();
    var pooling = function() {
        function _double(arr) {
            return arr.concat(createSizedArray(arr.length));
        }
        return {
            "double": _double
        };
    }();
    var poolFactory = function() {
        return function(initialLength, _create, _release) {
            var _length = 0;
            var _maxLength = initialLength;
            var pool = createSizedArray(_maxLength);
            var ob = {
                newElement: newElement,
                release: release
            };
            function newElement() {
                var element;
                if (_length) {
                    _length -= 1;
                    element = pool[_length];
                } else element = _create();
                return element;
            }
            function release(element) {
                if (_length === _maxLength) {
                    pool = pooling["double"](pool);
                    _maxLength *= 2;
                }
                if (_release) _release(element);
                pool[_length] = element;
                _length += 1;
            }
            return ob;
        };
    }();
    var bezierLengthPool = function() {
        function create() {
            return {
                addedLength: 0,
                percents: createTypedArray("float32", getDefaultCurveSegments()),
                lengths: createTypedArray("float32", getDefaultCurveSegments())
            };
        }
        return poolFactory(8, create);
    }();
    var segmentsLengthPool = function() {
        function create() {
            return {
                lengths: [],
                totalLength: 0
            };
        }
        function release(element) {
            var i;
            var len = element.lengths.length;
            for(i = 0; i < len; i += 1)bezierLengthPool.release(element.lengths[i]);
            element.lengths.length = 0;
        }
        return poolFactory(8, create, release);
    }();
    function bezFunction() {
        var math = Math;
        function pointOnLine2D(x1, y1, x2, y2, x3, y3) {
            var det1 = x1 * y2 + y1 * x3 + x2 * y3 - x3 * y2 - y3 * x1 - x2 * y1;
            return det1 > -0.001 && det1 < 0.001;
        }
        function pointOnLine3D(x1, y1, z1, x2, y2, z2, x3, y3, z3) {
            if (z1 === 0 && z2 === 0 && z3 === 0) return pointOnLine2D(x1, y1, x2, y2, x3, y3);
            var dist1 = math.sqrt(math.pow(x2 - x1, 2) + math.pow(y2 - y1, 2) + math.pow(z2 - z1, 2));
            var dist2 = math.sqrt(math.pow(x3 - x1, 2) + math.pow(y3 - y1, 2) + math.pow(z3 - z1, 2));
            var dist3 = math.sqrt(math.pow(x3 - x2, 2) + math.pow(y3 - y2, 2) + math.pow(z3 - z2, 2));
            var diffDist;
            if (dist1 > dist2) {
                if (dist1 > dist3) diffDist = dist1 - dist2 - dist3;
                else diffDist = dist3 - dist2 - dist1;
            } else if (dist3 > dist2) diffDist = dist3 - dist2 - dist1;
            else diffDist = dist2 - dist1 - dist3;
            return diffDist > -0.0001 && diffDist < 0.0001;
        }
        var getBezierLength = function() {
            return function(pt1, pt2, pt3, pt4) {
                var curveSegments = getDefaultCurveSegments();
                var k;
                var i;
                var len;
                var ptCoord;
                var perc;
                var addedLength = 0;
                var ptDistance;
                var point = [];
                var lastPoint = [];
                var lengthData = bezierLengthPool.newElement();
                len = pt3.length;
                for(k = 0; k < curveSegments; k += 1){
                    perc = k / (curveSegments - 1);
                    ptDistance = 0;
                    for(i = 0; i < len; i += 1){
                        ptCoord = bmPow(1 - perc, 3) * pt1[i] + 3 * bmPow(1 - perc, 2) * perc * pt3[i] + 3 * (1 - perc) * bmPow(perc, 2) * pt4[i] + bmPow(perc, 3) * pt2[i];
                        point[i] = ptCoord;
                        if (lastPoint[i] !== null) ptDistance += bmPow(point[i] - lastPoint[i], 2);
                        lastPoint[i] = point[i];
                    }
                    if (ptDistance) {
                        ptDistance = bmSqrt(ptDistance);
                        addedLength += ptDistance;
                    }
                    lengthData.percents[k] = perc;
                    lengthData.lengths[k] = addedLength;
                }
                lengthData.addedLength = addedLength;
                return lengthData;
            };
        }();
        function getSegmentsLength(shapeData) {
            var segmentsLength = segmentsLengthPool.newElement();
            var closed = shapeData.c;
            var pathV = shapeData.v;
            var pathO = shapeData.o;
            var pathI = shapeData.i;
            var i;
            var len = shapeData._length;
            var lengths = segmentsLength.lengths;
            var totalLength = 0;
            for(i = 0; i < len - 1; i += 1){
                lengths[i] = getBezierLength(pathV[i], pathV[i + 1], pathO[i], pathI[i + 1]);
                totalLength += lengths[i].addedLength;
            }
            if (closed && len) {
                lengths[i] = getBezierLength(pathV[i], pathV[0], pathO[i], pathI[0]);
                totalLength += lengths[i].addedLength;
            }
            segmentsLength.totalLength = totalLength;
            return segmentsLength;
        }
        function BezierData(length) {
            this.segmentLength = 0;
            this.points = new Array(length);
        }
        function PointData(partial, point) {
            this.partialLength = partial;
            this.point = point;
        }
        var buildBezierData = function() {
            var storedData = {};
            return function(pt1, pt2, pt3, pt4) {
                var bezierName = (pt1[0] + "_" + pt1[1] + "_" + pt2[0] + "_" + pt2[1] + "_" + pt3[0] + "_" + pt3[1] + "_" + pt4[0] + "_" + pt4[1]).replace(/\./g, "p");
                if (!storedData[bezierName]) {
                    var curveSegments = getDefaultCurveSegments();
                    var k;
                    var i;
                    var len;
                    var ptCoord;
                    var perc;
                    var addedLength = 0;
                    var ptDistance;
                    var point;
                    var lastPoint = null;
                    if (pt1.length === 2 && (pt1[0] !== pt2[0] || pt1[1] !== pt2[1]) && pointOnLine2D(pt1[0], pt1[1], pt2[0], pt2[1], pt1[0] + pt3[0], pt1[1] + pt3[1]) && pointOnLine2D(pt1[0], pt1[1], pt2[0], pt2[1], pt2[0] + pt4[0], pt2[1] + pt4[1])) curveSegments = 2;
                    var bezierData = new BezierData(curveSegments);
                    len = pt3.length;
                    for(k = 0; k < curveSegments; k += 1){
                        point = createSizedArray(len);
                        perc = k / (curveSegments - 1);
                        ptDistance = 0;
                        for(i = 0; i < len; i += 1){
                            ptCoord = bmPow(1 - perc, 3) * pt1[i] + 3 * bmPow(1 - perc, 2) * perc * (pt1[i] + pt3[i]) + 3 * (1 - perc) * bmPow(perc, 2) * (pt2[i] + pt4[i]) + bmPow(perc, 3) * pt2[i];
                            point[i] = ptCoord;
                            if (lastPoint !== null) ptDistance += bmPow(point[i] - lastPoint[i], 2);
                        }
                        ptDistance = bmSqrt(ptDistance);
                        addedLength += ptDistance;
                        bezierData.points[k] = new PointData(ptDistance, point);
                        lastPoint = point;
                    }
                    bezierData.segmentLength = addedLength;
                    storedData[bezierName] = bezierData;
                }
                return storedData[bezierName];
            };
        }();
        function getDistancePerc(perc, bezierData) {
            var percents = bezierData.percents;
            var lengths = bezierData.lengths;
            var len = percents.length;
            var initPos = bmFloor((len - 1) * perc);
            var lengthPos = perc * bezierData.addedLength;
            var lPerc = 0;
            if (initPos === len - 1 || initPos === 0 || lengthPos === lengths[initPos]) return percents[initPos];
            var dir = lengths[initPos] > lengthPos ? -1 : 1;
            var flag = true;
            while(flag){
                if (lengths[initPos] <= lengthPos && lengths[initPos + 1] > lengthPos) {
                    lPerc = (lengthPos - lengths[initPos]) / (lengths[initPos + 1] - lengths[initPos]);
                    flag = false;
                } else initPos += dir;
                if (initPos < 0 || initPos >= len - 1) {
                    // FIX for TypedArrays that don't store floating point values with enough accuracy
                    if (initPos === len - 1) return percents[initPos];
                    flag = false;
                }
            }
            return percents[initPos] + (percents[initPos + 1] - percents[initPos]) * lPerc;
        }
        function getPointInSegment(pt1, pt2, pt3, pt4, percent, bezierData) {
            var t1 = getDistancePerc(percent, bezierData);
            var u1 = 1 - t1;
            var ptX = math.round((u1 * u1 * u1 * pt1[0] + (t1 * u1 * u1 + u1 * t1 * u1 + u1 * u1 * t1) * pt3[0] + (t1 * t1 * u1 + u1 * t1 * t1 + t1 * u1 * t1) * pt4[0] + t1 * t1 * t1 * pt2[0]) * 1000) / 1000;
            var ptY = math.round((u1 * u1 * u1 * pt1[1] + (t1 * u1 * u1 + u1 * t1 * u1 + u1 * u1 * t1) * pt3[1] + (t1 * t1 * u1 + u1 * t1 * t1 + t1 * u1 * t1) * pt4[1] + t1 * t1 * t1 * pt2[1]) * 1000) / 1000;
            return [
                ptX,
                ptY
            ];
        }
        var bezierSegmentPoints = createTypedArray("float32", 8);
        function getNewSegment(pt1, pt2, pt3, pt4, startPerc, endPerc, bezierData) {
            if (startPerc < 0) startPerc = 0;
            else if (startPerc > 1) startPerc = 1;
            var t0 = getDistancePerc(startPerc, bezierData);
            endPerc = endPerc > 1 ? 1 : endPerc;
            var t1 = getDistancePerc(endPerc, bezierData);
            var i;
            var len = pt1.length;
            var u0 = 1 - t0;
            var u1 = 1 - t1;
            var u0u0u0 = u0 * u0 * u0;
            var t0u0u0_3 = t0 * u0 * u0 * 3; // eslint-disable-line camelcase
            var t0t0u0_3 = t0 * t0 * u0 * 3; // eslint-disable-line camelcase
            var t0t0t0 = t0 * t0 * t0; //
            var u0u0u1 = u0 * u0 * u1;
            var t0u0u1_3 = t0 * u0 * u1 + u0 * t0 * u1 + u0 * u0 * t1; // eslint-disable-line camelcase
            var t0t0u1_3 = t0 * t0 * u1 + u0 * t0 * t1 + t0 * u0 * t1; // eslint-disable-line camelcase
            var t0t0t1 = t0 * t0 * t1; //
            var u0u1u1 = u0 * u1 * u1;
            var t0u1u1_3 = t0 * u1 * u1 + u0 * t1 * u1 + u0 * u1 * t1; // eslint-disable-line camelcase
            var t0t1u1_3 = t0 * t1 * u1 + u0 * t1 * t1 + t0 * u1 * t1; // eslint-disable-line camelcase
            var t0t1t1 = t0 * t1 * t1; //
            var u1u1u1 = u1 * u1 * u1;
            var t1u1u1_3 = t1 * u1 * u1 + u1 * t1 * u1 + u1 * u1 * t1; // eslint-disable-line camelcase
            var t1t1u1_3 = t1 * t1 * u1 + u1 * t1 * t1 + t1 * u1 * t1; // eslint-disable-line camelcase
            var t1t1t1 = t1 * t1 * t1;
            for(i = 0; i < len; i += 1){
                bezierSegmentPoints[i * 4] = math.round((u0u0u0 * pt1[i] + t0u0u0_3 * pt3[i] + t0t0u0_3 * pt4[i] + t0t0t0 * pt2[i]) * 1000) / 1000; // eslint-disable-line camelcase
                bezierSegmentPoints[i * 4 + 1] = math.round((u0u0u1 * pt1[i] + t0u0u1_3 * pt3[i] + t0t0u1_3 * pt4[i] + t0t0t1 * pt2[i]) * 1000) / 1000; // eslint-disable-line camelcase
                bezierSegmentPoints[i * 4 + 2] = math.round((u0u1u1 * pt1[i] + t0u1u1_3 * pt3[i] + t0t1u1_3 * pt4[i] + t0t1t1 * pt2[i]) * 1000) / 1000; // eslint-disable-line camelcase
                bezierSegmentPoints[i * 4 + 3] = math.round((u1u1u1 * pt1[i] + t1u1u1_3 * pt3[i] + t1t1u1_3 * pt4[i] + t1t1t1 * pt2[i]) * 1000) / 1000; // eslint-disable-line camelcase
            }
            return bezierSegmentPoints;
        }
        return {
            getSegmentsLength: getSegmentsLength,
            getNewSegment: getNewSegment,
            getPointInSegment: getPointInSegment,
            buildBezierData: buildBezierData,
            pointOnLine2D: pointOnLine2D,
            pointOnLine3D: pointOnLine3D
        };
    }
    var bez = bezFunction();
    var initFrame = initialDefaultFrame;
    var mathAbs = Math.abs;
    function interpolateValue(frameNum, caching) {
        var offsetTime = this.offsetTime;
        var newValue;
        if (this.propType === "multidimensional") newValue = createTypedArray("float32", this.pv.length);
        var iterationIndex = caching.lastIndex;
        var i = iterationIndex;
        var len = this.keyframes.length - 1;
        var flag = true;
        var keyData;
        var nextKeyData;
        var keyframeMetadata;
        while(flag){
            keyData = this.keyframes[i];
            nextKeyData = this.keyframes[i + 1];
            if (i === len - 1 && frameNum >= nextKeyData.t - offsetTime) {
                if (keyData.h) keyData = nextKeyData;
                iterationIndex = 0;
                break;
            }
            if (nextKeyData.t - offsetTime > frameNum) {
                iterationIndex = i;
                break;
            }
            if (i < len - 1) i += 1;
            else {
                iterationIndex = 0;
                flag = false;
            }
        }
        keyframeMetadata = this.keyframesMetadata[i] || {};
        var k;
        var kLen;
        var perc;
        var jLen;
        var j;
        var fnc;
        var nextKeyTime = nextKeyData.t - offsetTime;
        var keyTime = keyData.t - offsetTime;
        var endValue;
        if (keyData.to) {
            if (!keyframeMetadata.bezierData) keyframeMetadata.bezierData = bez.buildBezierData(keyData.s, nextKeyData.s || keyData.e, keyData.to, keyData.ti);
            var bezierData = keyframeMetadata.bezierData;
            if (frameNum >= nextKeyTime || frameNum < keyTime) {
                var ind = frameNum >= nextKeyTime ? bezierData.points.length - 1 : 0;
                kLen = bezierData.points[ind].point.length;
                for(k = 0; k < kLen; k += 1)newValue[k] = bezierData.points[ind].point[k];
                 // caching._lastKeyframeIndex = -1;
            } else {
                if (keyframeMetadata.__fnct) fnc = keyframeMetadata.__fnct;
                else {
                    fnc = BezierFactory.getBezierEasing(keyData.o.x, keyData.o.y, keyData.i.x, keyData.i.y, keyData.n).get;
                    keyframeMetadata.__fnct = fnc;
                }
                perc = fnc((frameNum - keyTime) / (nextKeyTime - keyTime));
                var distanceInLine = bezierData.segmentLength * perc;
                var segmentPerc;
                var addedLength = caching.lastFrame < frameNum && caching._lastKeyframeIndex === i ? caching._lastAddedLength : 0;
                j = caching.lastFrame < frameNum && caching._lastKeyframeIndex === i ? caching._lastPoint : 0;
                flag = true;
                jLen = bezierData.points.length;
                while(flag){
                    addedLength += bezierData.points[j].partialLength;
                    if (distanceInLine === 0 || perc === 0 || j === bezierData.points.length - 1) {
                        kLen = bezierData.points[j].point.length;
                        for(k = 0; k < kLen; k += 1)newValue[k] = bezierData.points[j].point[k];
                        break;
                    } else if (distanceInLine >= addedLength && distanceInLine < addedLength + bezierData.points[j + 1].partialLength) {
                        segmentPerc = (distanceInLine - addedLength) / bezierData.points[j + 1].partialLength;
                        kLen = bezierData.points[j].point.length;
                        for(k = 0; k < kLen; k += 1)newValue[k] = bezierData.points[j].point[k] + (bezierData.points[j + 1].point[k] - bezierData.points[j].point[k]) * segmentPerc;
                        break;
                    }
                    if (j < jLen - 1) j += 1;
                    else flag = false;
                }
                caching._lastPoint = j;
                caching._lastAddedLength = addedLength - bezierData.points[j].partialLength;
                caching._lastKeyframeIndex = i;
            }
        } else {
            var outX;
            var outY;
            var inX;
            var inY;
            var keyValue;
            len = keyData.s.length;
            endValue = nextKeyData.s || keyData.e;
            if (this.sh && keyData.h !== 1) {
                if (frameNum >= nextKeyTime) {
                    newValue[0] = endValue[0];
                    newValue[1] = endValue[1];
                    newValue[2] = endValue[2];
                } else if (frameNum <= keyTime) {
                    newValue[0] = keyData.s[0];
                    newValue[1] = keyData.s[1];
                    newValue[2] = keyData.s[2];
                } else {
                    var quatStart = createQuaternion(keyData.s);
                    var quatEnd = createQuaternion(endValue);
                    var time = (frameNum - keyTime) / (nextKeyTime - keyTime);
                    quaternionToEuler(newValue, slerp(quatStart, quatEnd, time));
                }
            } else for(i = 0; i < len; i += 1){
                if (keyData.h !== 1) {
                    if (frameNum >= nextKeyTime) perc = 1;
                    else if (frameNum < keyTime) perc = 0;
                    else {
                        if (keyData.o.x.constructor === Array) {
                            if (!keyframeMetadata.__fnct) keyframeMetadata.__fnct = [];
                            if (!keyframeMetadata.__fnct[i]) {
                                outX = keyData.o.x[i] === undefined ? keyData.o.x[0] : keyData.o.x[i];
                                outY = keyData.o.y[i] === undefined ? keyData.o.y[0] : keyData.o.y[i];
                                inX = keyData.i.x[i] === undefined ? keyData.i.x[0] : keyData.i.x[i];
                                inY = keyData.i.y[i] === undefined ? keyData.i.y[0] : keyData.i.y[i];
                                fnc = BezierFactory.getBezierEasing(outX, outY, inX, inY).get;
                                keyframeMetadata.__fnct[i] = fnc;
                            } else fnc = keyframeMetadata.__fnct[i];
                        } else if (!keyframeMetadata.__fnct) {
                            outX = keyData.o.x;
                            outY = keyData.o.y;
                            inX = keyData.i.x;
                            inY = keyData.i.y;
                            fnc = BezierFactory.getBezierEasing(outX, outY, inX, inY).get;
                            keyData.keyframeMetadata = fnc;
                        } else fnc = keyframeMetadata.__fnct;
                        perc = fnc((frameNum - keyTime) / (nextKeyTime - keyTime));
                    }
                }
                endValue = nextKeyData.s || keyData.e;
                keyValue = keyData.h === 1 ? keyData.s[i] : keyData.s[i] + (endValue[i] - keyData.s[i]) * perc;
                if (this.propType === "multidimensional") newValue[i] = keyValue;
                else newValue = keyValue;
            }
        }
        caching.lastIndex = iterationIndex;
        return newValue;
    } // based on @Toji's https://github.com/toji/gl-matrix/
    function slerp(a, b, t) {
        var out = [];
        var ax = a[0];
        var ay = a[1];
        var az = a[2];
        var aw = a[3];
        var bx = b[0];
        var by = b[1];
        var bz = b[2];
        var bw = b[3];
        var omega;
        var cosom;
        var sinom;
        var scale0;
        var scale1;
        cosom = ax * bx + ay * by + az * bz + aw * bw;
        if (cosom < 0.0) {
            cosom = -cosom;
            bx = -bx;
            by = -by;
            bz = -bz;
            bw = -bw;
        }
        if (1.0 - cosom > 0.000001) {
            omega = Math.acos(cosom);
            sinom = Math.sin(omega);
            scale0 = Math.sin((1.0 - t) * omega) / sinom;
            scale1 = Math.sin(t * omega) / sinom;
        } else {
            scale0 = 1.0 - t;
            scale1 = t;
        }
        out[0] = scale0 * ax + scale1 * bx;
        out[1] = scale0 * ay + scale1 * by;
        out[2] = scale0 * az + scale1 * bz;
        out[3] = scale0 * aw + scale1 * bw;
        return out;
    }
    function quaternionToEuler(out, quat) {
        var qx = quat[0];
        var qy = quat[1];
        var qz = quat[2];
        var qw = quat[3];
        var heading = Math.atan2(2 * qy * qw - 2 * qx * qz, 1 - 2 * qy * qy - 2 * qz * qz);
        var attitude = Math.asin(2 * qx * qy + 2 * qz * qw);
        var bank = Math.atan2(2 * qx * qw - 2 * qy * qz, 1 - 2 * qx * qx - 2 * qz * qz);
        out[0] = heading / degToRads;
        out[1] = attitude / degToRads;
        out[2] = bank / degToRads;
    }
    function createQuaternion(values) {
        var heading = values[0] * degToRads;
        var attitude = values[1] * degToRads;
        var bank = values[2] * degToRads;
        var c1 = Math.cos(heading / 2);
        var c2 = Math.cos(attitude / 2);
        var c3 = Math.cos(bank / 2);
        var s1 = Math.sin(heading / 2);
        var s2 = Math.sin(attitude / 2);
        var s3 = Math.sin(bank / 2);
        var w = c1 * c2 * c3 - s1 * s2 * s3;
        var x = s1 * s2 * c3 + c1 * c2 * s3;
        var y = s1 * c2 * c3 + c1 * s2 * s3;
        var z = c1 * s2 * c3 - s1 * c2 * s3;
        return [
            x,
            y,
            z,
            w
        ];
    }
    function getValueAtCurrentTime() {
        var frameNum = this.comp.renderedFrame - this.offsetTime;
        var initTime = this.keyframes[0].t - this.offsetTime;
        var endTime = this.keyframes[this.keyframes.length - 1].t - this.offsetTime;
        if (!(frameNum === this._caching.lastFrame || this._caching.lastFrame !== initFrame && (this._caching.lastFrame >= endTime && frameNum >= endTime || this._caching.lastFrame < initTime && frameNum < initTime))) {
            if (this._caching.lastFrame >= frameNum) {
                this._caching._lastKeyframeIndex = -1;
                this._caching.lastIndex = 0;
            }
            var renderResult = this.interpolateValue(frameNum, this._caching);
            this.pv = renderResult;
        }
        this._caching.lastFrame = frameNum;
        return this.pv;
    }
    function setVValue(val) {
        var multipliedValue;
        if (this.propType === "unidimensional") {
            multipliedValue = val * this.mult;
            if (mathAbs(this.v - multipliedValue) > 0.00001) {
                this.v = multipliedValue;
                this._mdf = true;
            }
        } else {
            var i = 0;
            var len = this.v.length;
            while(i < len){
                multipliedValue = val[i] * this.mult;
                if (mathAbs(this.v[i] - multipliedValue) > 0.00001) {
                    this.v[i] = multipliedValue;
                    this._mdf = true;
                }
                i += 1;
            }
        }
    }
    function processEffectsSequence() {
        if (this.elem.globalData.frameId === this.frameId || !this.effectsSequence.length) return;
        if (this.lock) {
            this.setVValue(this.pv);
            return;
        }
        this.lock = true;
        this._mdf = this._isFirstFrame;
        var i;
        var len = this.effectsSequence.length;
        var finalValue = this.kf ? this.pv : this.data.k;
        for(i = 0; i < len; i += 1)finalValue = this.effectsSequence[i](finalValue);
        this.setVValue(finalValue);
        this._isFirstFrame = false;
        this.lock = false;
        this.frameId = this.elem.globalData.frameId;
    }
    function addEffect(effectFunction) {
        this.effectsSequence.push(effectFunction);
        this.container.addDynamicProperty(this);
    }
    function ValueProperty(elem, data, mult, container) {
        this.propType = "unidimensional";
        this.mult = mult || 1;
        this.data = data;
        this.v = mult ? data.k * mult : data.k;
        this.pv = data.k;
        this._mdf = false;
        this.elem = elem;
        this.container = container;
        this.comp = elem.comp;
        this.k = false;
        this.kf = false;
        this.vel = 0;
        this.effectsSequence = [];
        this._isFirstFrame = true;
        this.getValue = processEffectsSequence;
        this.setVValue = setVValue;
        this.addEffect = addEffect;
    }
    function MultiDimensionalProperty(elem, data, mult, container) {
        this.propType = "multidimensional";
        this.mult = mult || 1;
        this.data = data;
        this._mdf = false;
        this.elem = elem;
        this.container = container;
        this.comp = elem.comp;
        this.k = false;
        this.kf = false;
        this.frameId = -1;
        var i;
        var len = data.k.length;
        this.v = createTypedArray("float32", len);
        this.pv = createTypedArray("float32", len);
        this.vel = createTypedArray("float32", len);
        for(i = 0; i < len; i += 1){
            this.v[i] = data.k[i] * this.mult;
            this.pv[i] = data.k[i];
        }
        this._isFirstFrame = true;
        this.effectsSequence = [];
        this.getValue = processEffectsSequence;
        this.setVValue = setVValue;
        this.addEffect = addEffect;
    }
    function KeyframedValueProperty(elem, data, mult, container) {
        this.propType = "unidimensional";
        this.keyframes = data.k;
        this.keyframesMetadata = [];
        this.offsetTime = elem.data.st;
        this.frameId = -1;
        this._caching = {
            lastFrame: initFrame,
            lastIndex: 0,
            value: 0,
            _lastKeyframeIndex: -1
        };
        this.k = true;
        this.kf = true;
        this.data = data;
        this.mult = mult || 1;
        this.elem = elem;
        this.container = container;
        this.comp = elem.comp;
        this.v = initFrame;
        this.pv = initFrame;
        this._isFirstFrame = true;
        this.getValue = processEffectsSequence;
        this.setVValue = setVValue;
        this.interpolateValue = interpolateValue;
        this.effectsSequence = [
            getValueAtCurrentTime.bind(this)
        ];
        this.addEffect = addEffect;
    }
    function KeyframedMultidimensionalProperty(elem, data, mult, container) {
        this.propType = "multidimensional";
        var i;
        var len = data.k.length;
        var s;
        var e;
        var to;
        var ti;
        for(i = 0; i < len - 1; i += 1)if (data.k[i].to && data.k[i].s && data.k[i + 1] && data.k[i + 1].s) {
            s = data.k[i].s;
            e = data.k[i + 1].s;
            to = data.k[i].to;
            ti = data.k[i].ti;
            if (s.length === 2 && !(s[0] === e[0] && s[1] === e[1]) && bez.pointOnLine2D(s[0], s[1], e[0], e[1], s[0] + to[0], s[1] + to[1]) && bez.pointOnLine2D(s[0], s[1], e[0], e[1], e[0] + ti[0], e[1] + ti[1]) || s.length === 3 && !(s[0] === e[0] && s[1] === e[1] && s[2] === e[2]) && bez.pointOnLine3D(s[0], s[1], s[2], e[0], e[1], e[2], s[0] + to[0], s[1] + to[1], s[2] + to[2]) && bez.pointOnLine3D(s[0], s[1], s[2], e[0], e[1], e[2], e[0] + ti[0], e[1] + ti[1], e[2] + ti[2])) {
                data.k[i].to = null;
                data.k[i].ti = null;
            }
            if (s[0] === e[0] && s[1] === e[1] && to[0] === 0 && to[1] === 0 && ti[0] === 0 && ti[1] === 0) {
                if (s.length === 2 || s[2] === e[2] && to[2] === 0 && ti[2] === 0) {
                    data.k[i].to = null;
                    data.k[i].ti = null;
                }
            }
        }
        this.effectsSequence = [
            getValueAtCurrentTime.bind(this)
        ];
        this.data = data;
        this.keyframes = data.k;
        this.keyframesMetadata = [];
        this.offsetTime = elem.data.st;
        this.k = true;
        this.kf = true;
        this._isFirstFrame = true;
        this.mult = mult || 1;
        this.elem = elem;
        this.container = container;
        this.comp = elem.comp;
        this.getValue = processEffectsSequence;
        this.setVValue = setVValue;
        this.interpolateValue = interpolateValue;
        this.frameId = -1;
        var arrLen = data.k[0].s.length;
        this.v = createTypedArray("float32", arrLen);
        this.pv = createTypedArray("float32", arrLen);
        for(i = 0; i < arrLen; i += 1){
            this.v[i] = initFrame;
            this.pv[i] = initFrame;
        }
        this._caching = {
            lastFrame: initFrame,
            lastIndex: 0,
            value: createTypedArray("float32", arrLen)
        };
        this.addEffect = addEffect;
    }
    var PropertyFactory = function() {
        function getProp(elem, data, type, mult, container) {
            if (data.sid) data = elem.globalData.slotManager.getProp(data);
            var p;
            if (!data.k.length) p = new ValueProperty(elem, data, mult, container);
            else if (typeof data.k[0] === "number") p = new MultiDimensionalProperty(elem, data, mult, container);
            else switch(type){
                case 0:
                    p = new KeyframedValueProperty(elem, data, mult, container);
                    break;
                case 1:
                    p = new KeyframedMultidimensionalProperty(elem, data, mult, container);
                    break;
                default:
                    break;
            }
            if (p.effectsSequence.length) container.addDynamicProperty(p);
            return p;
        }
        var ob = {
            getProp: getProp
        };
        return ob;
    }();
    function DynamicPropertyContainer() {}
    DynamicPropertyContainer.prototype = {
        addDynamicProperty: function addDynamicProperty(prop) {
            if (this.dynamicProperties.indexOf(prop) === -1) {
                this.dynamicProperties.push(prop);
                this.container.addDynamicProperty(this);
                this._isAnimated = true;
            }
        },
        iterateDynamicProperties: function iterateDynamicProperties() {
            this._mdf = false;
            var i;
            var len = this.dynamicProperties.length;
            for(i = 0; i < len; i += 1){
                this.dynamicProperties[i].getValue();
                if (this.dynamicProperties[i]._mdf) this._mdf = true;
            }
        },
        initDynamicPropertyContainer: function initDynamicPropertyContainer(container) {
            this.container = container;
            this.dynamicProperties = [];
            this._mdf = false;
            this._isAnimated = false;
        }
    };
    var pointPool = function() {
        function create() {
            return createTypedArray("float32", 2);
        }
        return poolFactory(8, create);
    }();
    function ShapePath() {
        this.c = false;
        this._length = 0;
        this._maxLength = 8;
        this.v = createSizedArray(this._maxLength);
        this.o = createSizedArray(this._maxLength);
        this.i = createSizedArray(this._maxLength);
    }
    ShapePath.prototype.setPathData = function(closed, len) {
        this.c = closed;
        this.setLength(len);
        var i = 0;
        while(i < len){
            this.v[i] = pointPool.newElement();
            this.o[i] = pointPool.newElement();
            this.i[i] = pointPool.newElement();
            i += 1;
        }
    };
    ShapePath.prototype.setLength = function(len) {
        while(this._maxLength < len)this.doubleArrayLength();
        this._length = len;
    };
    ShapePath.prototype.doubleArrayLength = function() {
        this.v = this.v.concat(createSizedArray(this._maxLength));
        this.i = this.i.concat(createSizedArray(this._maxLength));
        this.o = this.o.concat(createSizedArray(this._maxLength));
        this._maxLength *= 2;
    };
    ShapePath.prototype.setXYAt = function(x, y, type, pos, replace) {
        var arr;
        this._length = Math.max(this._length, pos + 1);
        if (this._length >= this._maxLength) this.doubleArrayLength();
        switch(type){
            case "v":
                arr = this.v;
                break;
            case "i":
                arr = this.i;
                break;
            case "o":
                arr = this.o;
                break;
            default:
                arr = [];
                break;
        }
        if (!arr[pos] || arr[pos] && !replace) arr[pos] = pointPool.newElement();
        arr[pos][0] = x;
        arr[pos][1] = y;
    };
    ShapePath.prototype.setTripleAt = function(vX, vY, oX, oY, iX, iY, pos, replace) {
        this.setXYAt(vX, vY, "v", pos, replace);
        this.setXYAt(oX, oY, "o", pos, replace);
        this.setXYAt(iX, iY, "i", pos, replace);
    };
    ShapePath.prototype.reverse = function() {
        var newPath = new ShapePath();
        newPath.setPathData(this.c, this._length);
        var vertices = this.v;
        var outPoints = this.o;
        var inPoints = this.i;
        var init = 0;
        if (this.c) {
            newPath.setTripleAt(vertices[0][0], vertices[0][1], inPoints[0][0], inPoints[0][1], outPoints[0][0], outPoints[0][1], 0, false);
            init = 1;
        }
        var cnt = this._length - 1;
        var len = this._length;
        var i;
        for(i = init; i < len; i += 1){
            newPath.setTripleAt(vertices[cnt][0], vertices[cnt][1], inPoints[cnt][0], inPoints[cnt][1], outPoints[cnt][0], outPoints[cnt][1], i, false);
            cnt -= 1;
        }
        return newPath;
    };
    ShapePath.prototype.length = function() {
        return this._length;
    };
    var shapePool = function() {
        function create() {
            return new ShapePath();
        }
        function release(shapePath) {
            var len = shapePath._length;
            var i;
            for(i = 0; i < len; i += 1){
                pointPool.release(shapePath.v[i]);
                pointPool.release(shapePath.i[i]);
                pointPool.release(shapePath.o[i]);
                shapePath.v[i] = null;
                shapePath.i[i] = null;
                shapePath.o[i] = null;
            }
            shapePath._length = 0;
            shapePath.c = false;
        }
        function clone(shape) {
            var cloned = factory.newElement();
            var i;
            var len = shape._length === undefined ? shape.v.length : shape._length;
            cloned.setLength(len);
            cloned.c = shape.c;
            for(i = 0; i < len; i += 1)cloned.setTripleAt(shape.v[i][0], shape.v[i][1], shape.o[i][0], shape.o[i][1], shape.i[i][0], shape.i[i][1], i);
            return cloned;
        }
        var factory = poolFactory(4, create, release);
        factory.clone = clone;
        return factory;
    }();
    function ShapeCollection() {
        this._length = 0;
        this._maxLength = 4;
        this.shapes = createSizedArray(this._maxLength);
    }
    ShapeCollection.prototype.addShape = function(shapeData) {
        if (this._length === this._maxLength) {
            this.shapes = this.shapes.concat(createSizedArray(this._maxLength));
            this._maxLength *= 2;
        }
        this.shapes[this._length] = shapeData;
        this._length += 1;
    };
    ShapeCollection.prototype.releaseShapes = function() {
        var i;
        for(i = 0; i < this._length; i += 1)shapePool.release(this.shapes[i]);
        this._length = 0;
    };
    var shapeCollectionPool = function() {
        var ob = {
            newShapeCollection: newShapeCollection,
            release: release
        };
        var _length = 0;
        var _maxLength = 4;
        var pool = createSizedArray(_maxLength);
        function newShapeCollection() {
            var shapeCollection;
            if (_length) {
                _length -= 1;
                shapeCollection = pool[_length];
            } else shapeCollection = new ShapeCollection();
            return shapeCollection;
        }
        function release(shapeCollection) {
            var i;
            var len = shapeCollection._length;
            for(i = 0; i < len; i += 1)shapePool.release(shapeCollection.shapes[i]);
            shapeCollection._length = 0;
            if (_length === _maxLength) {
                pool = pooling["double"](pool);
                _maxLength *= 2;
            }
            pool[_length] = shapeCollection;
            _length += 1;
        }
        return ob;
    }();
    var ShapePropertyFactory = function() {
        var initFrame = -999999;
        function interpolateShape(frameNum, previousValue, caching) {
            var iterationIndex = caching.lastIndex;
            var keyPropS;
            var keyPropE;
            var isHold;
            var j;
            var k;
            var jLen;
            var kLen;
            var perc;
            var vertexValue;
            var kf = this.keyframes;
            if (frameNum < kf[0].t - this.offsetTime) {
                keyPropS = kf[0].s[0];
                isHold = true;
                iterationIndex = 0;
            } else if (frameNum >= kf[kf.length - 1].t - this.offsetTime) {
                keyPropS = kf[kf.length - 1].s ? kf[kf.length - 1].s[0] : kf[kf.length - 2].e[0];
                /* if(kf[kf.length - 1].s){
                  keyPropS = kf[kf.length - 1].s[0];
              }else{
                  keyPropS = kf[kf.length - 2].e[0];
              } */ isHold = true;
            } else {
                var i = iterationIndex;
                var len = kf.length - 1;
                var flag = true;
                var keyData;
                var nextKeyData;
                var keyframeMetadata;
                while(flag){
                    keyData = kf[i];
                    nextKeyData = kf[i + 1];
                    if (nextKeyData.t - this.offsetTime > frameNum) break;
                    if (i < len - 1) i += 1;
                    else flag = false;
                }
                keyframeMetadata = this.keyframesMetadata[i] || {};
                isHold = keyData.h === 1;
                iterationIndex = i;
                if (!isHold) {
                    if (frameNum >= nextKeyData.t - this.offsetTime) perc = 1;
                    else if (frameNum < keyData.t - this.offsetTime) perc = 0;
                    else {
                        var fnc;
                        if (keyframeMetadata.__fnct) fnc = keyframeMetadata.__fnct;
                        else {
                            fnc = BezierFactory.getBezierEasing(keyData.o.x, keyData.o.y, keyData.i.x, keyData.i.y).get;
                            keyframeMetadata.__fnct = fnc;
                        }
                        perc = fnc((frameNum - (keyData.t - this.offsetTime)) / (nextKeyData.t - this.offsetTime - (keyData.t - this.offsetTime)));
                    }
                    keyPropE = nextKeyData.s ? nextKeyData.s[0] : keyData.e[0];
                }
                keyPropS = keyData.s[0];
            }
            jLen = previousValue._length;
            kLen = keyPropS.i[0].length;
            caching.lastIndex = iterationIndex;
            for(j = 0; j < jLen; j += 1)for(k = 0; k < kLen; k += 1){
                vertexValue = isHold ? keyPropS.i[j][k] : keyPropS.i[j][k] + (keyPropE.i[j][k] - keyPropS.i[j][k]) * perc;
                previousValue.i[j][k] = vertexValue;
                vertexValue = isHold ? keyPropS.o[j][k] : keyPropS.o[j][k] + (keyPropE.o[j][k] - keyPropS.o[j][k]) * perc;
                previousValue.o[j][k] = vertexValue;
                vertexValue = isHold ? keyPropS.v[j][k] : keyPropS.v[j][k] + (keyPropE.v[j][k] - keyPropS.v[j][k]) * perc;
                previousValue.v[j][k] = vertexValue;
            }
        }
        function interpolateShapeCurrentTime() {
            var frameNum = this.comp.renderedFrame - this.offsetTime;
            var initTime = this.keyframes[0].t - this.offsetTime;
            var endTime = this.keyframes[this.keyframes.length - 1].t - this.offsetTime;
            var lastFrame = this._caching.lastFrame;
            if (!(lastFrame !== initFrame && (lastFrame < initTime && frameNum < initTime || lastFrame > endTime && frameNum > endTime))) {
                /// /
                this._caching.lastIndex = lastFrame < frameNum ? this._caching.lastIndex : 0;
                this.interpolateShape(frameNum, this.pv, this._caching); /// /
            }
            this._caching.lastFrame = frameNum;
            return this.pv;
        }
        function resetShape() {
            this.paths = this.localShapeCollection;
        }
        function shapesEqual(shape1, shape2) {
            if (shape1._length !== shape2._length || shape1.c !== shape2.c) return false;
            var i;
            var len = shape1._length;
            for(i = 0; i < len; i += 1){
                if (shape1.v[i][0] !== shape2.v[i][0] || shape1.v[i][1] !== shape2.v[i][1] || shape1.o[i][0] !== shape2.o[i][0] || shape1.o[i][1] !== shape2.o[i][1] || shape1.i[i][0] !== shape2.i[i][0] || shape1.i[i][1] !== shape2.i[i][1]) return false;
            }
            return true;
        }
        function setVValue(newPath) {
            if (!shapesEqual(this.v, newPath)) {
                this.v = shapePool.clone(newPath);
                this.localShapeCollection.releaseShapes();
                this.localShapeCollection.addShape(this.v);
                this._mdf = true;
                this.paths = this.localShapeCollection;
            }
        }
        function processEffectsSequence() {
            if (this.elem.globalData.frameId === this.frameId) return;
            if (!this.effectsSequence.length) {
                this._mdf = false;
                return;
            }
            if (this.lock) {
                this.setVValue(this.pv);
                return;
            }
            this.lock = true;
            this._mdf = false;
            var finalValue;
            if (this.kf) finalValue = this.pv;
            else if (this.data.ks) finalValue = this.data.ks.k;
            else finalValue = this.data.pt.k;
            var i;
            var len = this.effectsSequence.length;
            for(i = 0; i < len; i += 1)finalValue = this.effectsSequence[i](finalValue);
            this.setVValue(finalValue);
            this.lock = false;
            this.frameId = this.elem.globalData.frameId;
        }
        function ShapeProperty(elem, data, type) {
            this.propType = "shape";
            this.comp = elem.comp;
            this.container = elem;
            this.elem = elem;
            this.data = data;
            this.k = false;
            this.kf = false;
            this._mdf = false;
            var pathData = type === 3 ? data.pt.k : data.ks.k;
            this.v = shapePool.clone(pathData);
            this.pv = shapePool.clone(this.v);
            this.localShapeCollection = shapeCollectionPool.newShapeCollection();
            this.paths = this.localShapeCollection;
            this.paths.addShape(this.v);
            this.reset = resetShape;
            this.effectsSequence = [];
        }
        function addEffect(effectFunction) {
            this.effectsSequence.push(effectFunction);
            this.container.addDynamicProperty(this);
        }
        ShapeProperty.prototype.interpolateShape = interpolateShape;
        ShapeProperty.prototype.getValue = processEffectsSequence;
        ShapeProperty.prototype.setVValue = setVValue;
        ShapeProperty.prototype.addEffect = addEffect;
        function KeyframedShapeProperty(elem, data, type) {
            this.propType = "shape";
            this.comp = elem.comp;
            this.elem = elem;
            this.container = elem;
            this.offsetTime = elem.data.st;
            this.keyframes = type === 3 ? data.pt.k : data.ks.k;
            this.keyframesMetadata = [];
            this.k = true;
            this.kf = true;
            var len = this.keyframes[0].s[0].i.length;
            this.v = shapePool.newElement();
            this.v.setPathData(this.keyframes[0].s[0].c, len);
            this.pv = shapePool.clone(this.v);
            this.localShapeCollection = shapeCollectionPool.newShapeCollection();
            this.paths = this.localShapeCollection;
            this.paths.addShape(this.v);
            this.lastFrame = initFrame;
            this.reset = resetShape;
            this._caching = {
                lastFrame: initFrame,
                lastIndex: 0
            };
            this.effectsSequence = [
                interpolateShapeCurrentTime.bind(this)
            ];
        }
        KeyframedShapeProperty.prototype.getValue = processEffectsSequence;
        KeyframedShapeProperty.prototype.interpolateShape = interpolateShape;
        KeyframedShapeProperty.prototype.setVValue = setVValue;
        KeyframedShapeProperty.prototype.addEffect = addEffect;
        var EllShapeProperty = function() {
            var cPoint = roundCorner;
            function EllShapePropertyFactory(elem, data) {
                this.v = shapePool.newElement();
                this.v.setPathData(true, 4);
                this.localShapeCollection = shapeCollectionPool.newShapeCollection();
                this.paths = this.localShapeCollection;
                this.localShapeCollection.addShape(this.v);
                this.d = data.d;
                this.elem = elem;
                this.comp = elem.comp;
                this.frameId = -1;
                this.initDynamicPropertyContainer(elem);
                this.p = PropertyFactory.getProp(elem, data.p, 1, 0, this);
                this.s = PropertyFactory.getProp(elem, data.s, 1, 0, this);
                if (this.dynamicProperties.length) this.k = true;
                else {
                    this.k = false;
                    this.convertEllToPath();
                }
            }
            EllShapePropertyFactory.prototype = {
                reset: resetShape,
                getValue: function getValue() {
                    if (this.elem.globalData.frameId === this.frameId) return;
                    this.frameId = this.elem.globalData.frameId;
                    this.iterateDynamicProperties();
                    if (this._mdf) this.convertEllToPath();
                },
                convertEllToPath: function convertEllToPath() {
                    var p0 = this.p.v[0];
                    var p1 = this.p.v[1];
                    var s0 = this.s.v[0] / 2;
                    var s1 = this.s.v[1] / 2;
                    var _cw = this.d !== 3;
                    var _v = this.v;
                    _v.v[0][0] = p0;
                    _v.v[0][1] = p1 - s1;
                    _v.v[1][0] = _cw ? p0 + s0 : p0 - s0;
                    _v.v[1][1] = p1;
                    _v.v[2][0] = p0;
                    _v.v[2][1] = p1 + s1;
                    _v.v[3][0] = _cw ? p0 - s0 : p0 + s0;
                    _v.v[3][1] = p1;
                    _v.i[0][0] = _cw ? p0 - s0 * cPoint : p0 + s0 * cPoint;
                    _v.i[0][1] = p1 - s1;
                    _v.i[1][0] = _cw ? p0 + s0 : p0 - s0;
                    _v.i[1][1] = p1 - s1 * cPoint;
                    _v.i[2][0] = _cw ? p0 + s0 * cPoint : p0 - s0 * cPoint;
                    _v.i[2][1] = p1 + s1;
                    _v.i[3][0] = _cw ? p0 - s0 : p0 + s0;
                    _v.i[3][1] = p1 + s1 * cPoint;
                    _v.o[0][0] = _cw ? p0 + s0 * cPoint : p0 - s0 * cPoint;
                    _v.o[0][1] = p1 - s1;
                    _v.o[1][0] = _cw ? p0 + s0 : p0 - s0;
                    _v.o[1][1] = p1 + s1 * cPoint;
                    _v.o[2][0] = _cw ? p0 - s0 * cPoint : p0 + s0 * cPoint;
                    _v.o[2][1] = p1 + s1;
                    _v.o[3][0] = _cw ? p0 - s0 : p0 + s0;
                    _v.o[3][1] = p1 - s1 * cPoint;
                }
            };
            extendPrototype([
                DynamicPropertyContainer
            ], EllShapePropertyFactory);
            return EllShapePropertyFactory;
        }();
        var StarShapeProperty = function() {
            function StarShapePropertyFactory(elem, data) {
                this.v = shapePool.newElement();
                this.v.setPathData(true, 0);
                this.elem = elem;
                this.comp = elem.comp;
                this.data = data;
                this.frameId = -1;
                this.d = data.d;
                this.initDynamicPropertyContainer(elem);
                if (data.sy === 1) {
                    this.ir = PropertyFactory.getProp(elem, data.ir, 0, 0, this);
                    this.is = PropertyFactory.getProp(elem, data.is, 0, 0.01, this);
                    this.convertToPath = this.convertStarToPath;
                } else this.convertToPath = this.convertPolygonToPath;
                this.pt = PropertyFactory.getProp(elem, data.pt, 0, 0, this);
                this.p = PropertyFactory.getProp(elem, data.p, 1, 0, this);
                this.r = PropertyFactory.getProp(elem, data.r, 0, degToRads, this);
                this.or = PropertyFactory.getProp(elem, data.or, 0, 0, this);
                this.os = PropertyFactory.getProp(elem, data.os, 0, 0.01, this);
                this.localShapeCollection = shapeCollectionPool.newShapeCollection();
                this.localShapeCollection.addShape(this.v);
                this.paths = this.localShapeCollection;
                if (this.dynamicProperties.length) this.k = true;
                else {
                    this.k = false;
                    this.convertToPath();
                }
            }
            StarShapePropertyFactory.prototype = {
                reset: resetShape,
                getValue: function getValue() {
                    if (this.elem.globalData.frameId === this.frameId) return;
                    this.frameId = this.elem.globalData.frameId;
                    this.iterateDynamicProperties();
                    if (this._mdf) this.convertToPath();
                },
                convertStarToPath: function convertStarToPath() {
                    var numPts = Math.floor(this.pt.v) * 2;
                    var angle = Math.PI * 2 / numPts;
                    /* this.v.v.length = numPts;
                  this.v.i.length = numPts;
                  this.v.o.length = numPts; */ var longFlag = true;
                    var longRad = this.or.v;
                    var shortRad = this.ir.v;
                    var longRound = this.os.v;
                    var shortRound = this.is.v;
                    var longPerimSegment = 2 * Math.PI * longRad / (numPts * 2);
                    var shortPerimSegment = 2 * Math.PI * shortRad / (numPts * 2);
                    var i;
                    var rad;
                    var roundness;
                    var perimSegment;
                    var currentAng = -Math.PI / 2;
                    currentAng += this.r.v;
                    var dir = this.data.d === 3 ? -1 : 1;
                    this.v._length = 0;
                    for(i = 0; i < numPts; i += 1){
                        rad = longFlag ? longRad : shortRad;
                        roundness = longFlag ? longRound : shortRound;
                        perimSegment = longFlag ? longPerimSegment : shortPerimSegment;
                        var x = rad * Math.cos(currentAng);
                        var y = rad * Math.sin(currentAng);
                        var ox = x === 0 && y === 0 ? 0 : y / Math.sqrt(x * x + y * y);
                        var oy = x === 0 && y === 0 ? 0 : -x / Math.sqrt(x * x + y * y);
                        x += +this.p.v[0];
                        y += +this.p.v[1];
                        this.v.setTripleAt(x, y, x - ox * perimSegment * roundness * dir, y - oy * perimSegment * roundness * dir, x + ox * perimSegment * roundness * dir, y + oy * perimSegment * roundness * dir, i, true);
                        /* this.v.v[i] = [x,y];
                      this.v.i[i] = [x+ox*perimSegment*roundness*dir,y+oy*perimSegment*roundness*dir];
                      this.v.o[i] = [x-ox*perimSegment*roundness*dir,y-oy*perimSegment*roundness*dir];
                      this.v._length = numPts; */ longFlag = !longFlag;
                        currentAng += angle * dir;
                    }
                },
                convertPolygonToPath: function convertPolygonToPath() {
                    var numPts = Math.floor(this.pt.v);
                    var angle = Math.PI * 2 / numPts;
                    var rad = this.or.v;
                    var roundness = this.os.v;
                    var perimSegment = 2 * Math.PI * rad / (numPts * 4);
                    var i;
                    var currentAng = -Math.PI * 0.5;
                    var dir = this.data.d === 3 ? -1 : 1;
                    currentAng += this.r.v;
                    this.v._length = 0;
                    for(i = 0; i < numPts; i += 1){
                        var x = rad * Math.cos(currentAng);
                        var y = rad * Math.sin(currentAng);
                        var ox = x === 0 && y === 0 ? 0 : y / Math.sqrt(x * x + y * y);
                        var oy = x === 0 && y === 0 ? 0 : -x / Math.sqrt(x * x + y * y);
                        x += +this.p.v[0];
                        y += +this.p.v[1];
                        this.v.setTripleAt(x, y, x - ox * perimSegment * roundness * dir, y - oy * perimSegment * roundness * dir, x + ox * perimSegment * roundness * dir, y + oy * perimSegment * roundness * dir, i, true);
                        currentAng += angle * dir;
                    }
                    this.paths.length = 0;
                    this.paths[0] = this.v;
                }
            };
            extendPrototype([
                DynamicPropertyContainer
            ], StarShapePropertyFactory);
            return StarShapePropertyFactory;
        }();
        var RectShapeProperty = function() {
            function RectShapePropertyFactory(elem, data) {
                this.v = shapePool.newElement();
                this.v.c = true;
                this.localShapeCollection = shapeCollectionPool.newShapeCollection();
                this.localShapeCollection.addShape(this.v);
                this.paths = this.localShapeCollection;
                this.elem = elem;
                this.comp = elem.comp;
                this.frameId = -1;
                this.d = data.d;
                this.initDynamicPropertyContainer(elem);
                this.p = PropertyFactory.getProp(elem, data.p, 1, 0, this);
                this.s = PropertyFactory.getProp(elem, data.s, 1, 0, this);
                this.r = PropertyFactory.getProp(elem, data.r, 0, 0, this);
                if (this.dynamicProperties.length) this.k = true;
                else {
                    this.k = false;
                    this.convertRectToPath();
                }
            }
            RectShapePropertyFactory.prototype = {
                convertRectToPath: function convertRectToPath() {
                    var p0 = this.p.v[0];
                    var p1 = this.p.v[1];
                    var v0 = this.s.v[0] / 2;
                    var v1 = this.s.v[1] / 2;
                    var round = bmMin(v0, v1, this.r.v);
                    var cPoint = round * (1 - roundCorner);
                    this.v._length = 0;
                    if (this.d === 2 || this.d === 1) {
                        this.v.setTripleAt(p0 + v0, p1 - v1 + round, p0 + v0, p1 - v1 + round, p0 + v0, p1 - v1 + cPoint, 0, true);
                        this.v.setTripleAt(p0 + v0, p1 + v1 - round, p0 + v0, p1 + v1 - cPoint, p0 + v0, p1 + v1 - round, 1, true);
                        if (round !== 0) {
                            this.v.setTripleAt(p0 + v0 - round, p1 + v1, p0 + v0 - round, p1 + v1, p0 + v0 - cPoint, p1 + v1, 2, true);
                            this.v.setTripleAt(p0 - v0 + round, p1 + v1, p0 - v0 + cPoint, p1 + v1, p0 - v0 + round, p1 + v1, 3, true);
                            this.v.setTripleAt(p0 - v0, p1 + v1 - round, p0 - v0, p1 + v1 - round, p0 - v0, p1 + v1 - cPoint, 4, true);
                            this.v.setTripleAt(p0 - v0, p1 - v1 + round, p0 - v0, p1 - v1 + cPoint, p0 - v0, p1 - v1 + round, 5, true);
                            this.v.setTripleAt(p0 - v0 + round, p1 - v1, p0 - v0 + round, p1 - v1, p0 - v0 + cPoint, p1 - v1, 6, true);
                            this.v.setTripleAt(p0 + v0 - round, p1 - v1, p0 + v0 - cPoint, p1 - v1, p0 + v0 - round, p1 - v1, 7, true);
                        } else {
                            this.v.setTripleAt(p0 - v0, p1 + v1, p0 - v0 + cPoint, p1 + v1, p0 - v0, p1 + v1, 2);
                            this.v.setTripleAt(p0 - v0, p1 - v1, p0 - v0, p1 - v1 + cPoint, p0 - v0, p1 - v1, 3);
                        }
                    } else {
                        this.v.setTripleAt(p0 + v0, p1 - v1 + round, p0 + v0, p1 - v1 + cPoint, p0 + v0, p1 - v1 + round, 0, true);
                        if (round !== 0) {
                            this.v.setTripleAt(p0 + v0 - round, p1 - v1, p0 + v0 - round, p1 - v1, p0 + v0 - cPoint, p1 - v1, 1, true);
                            this.v.setTripleAt(p0 - v0 + round, p1 - v1, p0 - v0 + cPoint, p1 - v1, p0 - v0 + round, p1 - v1, 2, true);
                            this.v.setTripleAt(p0 - v0, p1 - v1 + round, p0 - v0, p1 - v1 + round, p0 - v0, p1 - v1 + cPoint, 3, true);
                            this.v.setTripleAt(p0 - v0, p1 + v1 - round, p0 - v0, p1 + v1 - cPoint, p0 - v0, p1 + v1 - round, 4, true);
                            this.v.setTripleAt(p0 - v0 + round, p1 + v1, p0 - v0 + round, p1 + v1, p0 - v0 + cPoint, p1 + v1, 5, true);
                            this.v.setTripleAt(p0 + v0 - round, p1 + v1, p0 + v0 - cPoint, p1 + v1, p0 + v0 - round, p1 + v1, 6, true);
                            this.v.setTripleAt(p0 + v0, p1 + v1 - round, p0 + v0, p1 + v1 - round, p0 + v0, p1 + v1 - cPoint, 7, true);
                        } else {
                            this.v.setTripleAt(p0 - v0, p1 - v1, p0 - v0 + cPoint, p1 - v1, p0 - v0, p1 - v1, 1, true);
                            this.v.setTripleAt(p0 - v0, p1 + v1, p0 - v0, p1 + v1 - cPoint, p0 - v0, p1 + v1, 2, true);
                            this.v.setTripleAt(p0 + v0, p1 + v1, p0 + v0 - cPoint, p1 + v1, p0 + v0, p1 + v1, 3, true);
                        }
                    }
                },
                getValue: function getValue() {
                    if (this.elem.globalData.frameId === this.frameId) return;
                    this.frameId = this.elem.globalData.frameId;
                    this.iterateDynamicProperties();
                    if (this._mdf) this.convertRectToPath();
                },
                reset: resetShape
            };
            extendPrototype([
                DynamicPropertyContainer
            ], RectShapePropertyFactory);
            return RectShapePropertyFactory;
        }();
        function getShapeProp(elem, data, type) {
            var prop;
            if (type === 3 || type === 4) {
                var dataProp = type === 3 ? data.pt : data.ks;
                var keys = dataProp.k;
                if (keys.length) prop = new KeyframedShapeProperty(elem, data, type);
                else prop = new ShapeProperty(elem, data, type);
            } else if (type === 5) prop = new RectShapeProperty(elem, data);
            else if (type === 6) prop = new EllShapeProperty(elem, data);
            else if (type === 7) prop = new StarShapeProperty(elem, data);
            if (prop.k) elem.addDynamicProperty(prop);
            return prop;
        }
        function getConstructorFunction() {
            return ShapeProperty;
        }
        function getKeyframedConstructorFunction() {
            return KeyframedShapeProperty;
        }
        var ob = {};
        ob.getShapeProp = getShapeProp;
        ob.getConstructorFunction = getConstructorFunction;
        ob.getKeyframedConstructorFunction = getKeyframedConstructorFunction;
        return ob;
    }();
    /*!
   Transformation Matrix v2.0
   (c) Epistemex 2014-2015
   www.epistemex.com
   By Ken Fyrstenberg
   Contributions by leeoniya.
   License: MIT, header required.
   */ /**
   * 2D transformation matrix object initialized with identity matrix.
   *
   * The matrix can synchronize a canvas context by supplying the context
   * as an argument, or later apply current absolute transform to an
   * existing context.
   *
   * All values are handled as floating point values.
   *
   * @param {CanvasRenderingContext2D} [context] - Optional context to sync with Matrix
   * @prop {number} a - scale x
   * @prop {number} b - shear y
   * @prop {number} c - shear x
   * @prop {number} d - scale y
   * @prop {number} e - translate x
   * @prop {number} f - translate y
   * @prop {CanvasRenderingContext2D|null} [context=null] - set or get current canvas context
   * @constructor
   */ var Matrix = function() {
        var _cos = Math.cos;
        var _sin = Math.sin;
        var _tan = Math.tan;
        var _rnd = Math.round;
        function reset() {
            this.props[0] = 1;
            this.props[1] = 0;
            this.props[2] = 0;
            this.props[3] = 0;
            this.props[4] = 0;
            this.props[5] = 1;
            this.props[6] = 0;
            this.props[7] = 0;
            this.props[8] = 0;
            this.props[9] = 0;
            this.props[10] = 1;
            this.props[11] = 0;
            this.props[12] = 0;
            this.props[13] = 0;
            this.props[14] = 0;
            this.props[15] = 1;
            return this;
        }
        function rotate(angle) {
            if (angle === 0) return this;
            var mCos = _cos(angle);
            var mSin = _sin(angle);
            return this._t(mCos, -mSin, 0, 0, mSin, mCos, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
        }
        function rotateX(angle) {
            if (angle === 0) return this;
            var mCos = _cos(angle);
            var mSin = _sin(angle);
            return this._t(1, 0, 0, 0, 0, mCos, -mSin, 0, 0, mSin, mCos, 0, 0, 0, 0, 1);
        }
        function rotateY(angle) {
            if (angle === 0) return this;
            var mCos = _cos(angle);
            var mSin = _sin(angle);
            return this._t(mCos, 0, mSin, 0, 0, 1, 0, 0, -mSin, 0, mCos, 0, 0, 0, 0, 1);
        }
        function rotateZ(angle) {
            if (angle === 0) return this;
            var mCos = _cos(angle);
            var mSin = _sin(angle);
            return this._t(mCos, -mSin, 0, 0, mSin, mCos, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
        }
        function shear(sx, sy) {
            return this._t(1, sy, sx, 1, 0, 0);
        }
        function skew(ax, ay) {
            return this.shear(_tan(ax), _tan(ay));
        }
        function skewFromAxis(ax, angle) {
            var mCos = _cos(angle);
            var mSin = _sin(angle);
            return this._t(mCos, mSin, 0, 0, -mSin, mCos, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1)._t(1, 0, 0, 0, _tan(ax), 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1)._t(mCos, -mSin, 0, 0, mSin, mCos, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); // return this._t(mCos, mSin, -mSin, mCos, 0, 0)._t(1, 0, _tan(ax), 1, 0, 0)._t(mCos, -mSin, mSin, mCos, 0, 0);
        }
        function scale(sx, sy, sz) {
            if (!sz && sz !== 0) sz = 1;
            if (sx === 1 && sy === 1 && sz === 1) return this;
            return this._t(sx, 0, 0, 0, 0, sy, 0, 0, 0, 0, sz, 0, 0, 0, 0, 1);
        }
        function setTransform(a, b, c, d, e, f, g, h, i, j, k, l, m, n, o, p) {
            this.props[0] = a;
            this.props[1] = b;
            this.props[2] = c;
            this.props[3] = d;
            this.props[4] = e;
            this.props[5] = f;
            this.props[6] = g;
            this.props[7] = h;
            this.props[8] = i;
            this.props[9] = j;
            this.props[10] = k;
            this.props[11] = l;
            this.props[12] = m;
            this.props[13] = n;
            this.props[14] = o;
            this.props[15] = p;
            return this;
        }
        function translate(tx, ty, tz) {
            tz = tz || 0;
            if (tx !== 0 || ty !== 0 || tz !== 0) return this._t(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, tx, ty, tz, 1);
            return this;
        }
        function transform(a2, b2, c2, d2, e2, f2, g2, h2, i2, j2, k2, l2, m2, n2, o2, p2) {
            var _p = this.props;
            if (a2 === 1 && b2 === 0 && c2 === 0 && d2 === 0 && e2 === 0 && f2 === 1 && g2 === 0 && h2 === 0 && i2 === 0 && j2 === 0 && k2 === 1 && l2 === 0) {
                // NOTE: commenting this condition because TurboFan deoptimizes code when present
                // if(m2 !== 0 || n2 !== 0 || o2 !== 0){
                _p[12] = _p[12] * a2 + _p[15] * m2;
                _p[13] = _p[13] * f2 + _p[15] * n2;
                _p[14] = _p[14] * k2 + _p[15] * o2;
                _p[15] *= p2; // }
                this._identityCalculated = false;
                return this;
            }
            var a1 = _p[0];
            var b1 = _p[1];
            var c1 = _p[2];
            var d1 = _p[3];
            var e1 = _p[4];
            var f1 = _p[5];
            var g1 = _p[6];
            var h1 = _p[7];
            var i1 = _p[8];
            var j1 = _p[9];
            var k1 = _p[10];
            var l1 = _p[11];
            var m1 = _p[12];
            var n1 = _p[13];
            var o1 = _p[14];
            var p1 = _p[15];
            /* matrix order (canvas compatible):
           * ace
           * bdf
           * 001
           */ _p[0] = a1 * a2 + b1 * e2 + c1 * i2 + d1 * m2;
            _p[1] = a1 * b2 + b1 * f2 + c1 * j2 + d1 * n2;
            _p[2] = a1 * c2 + b1 * g2 + c1 * k2 + d1 * o2;
            _p[3] = a1 * d2 + b1 * h2 + c1 * l2 + d1 * p2;
            _p[4] = e1 * a2 + f1 * e2 + g1 * i2 + h1 * m2;
            _p[5] = e1 * b2 + f1 * f2 + g1 * j2 + h1 * n2;
            _p[6] = e1 * c2 + f1 * g2 + g1 * k2 + h1 * o2;
            _p[7] = e1 * d2 + f1 * h2 + g1 * l2 + h1 * p2;
            _p[8] = i1 * a2 + j1 * e2 + k1 * i2 + l1 * m2;
            _p[9] = i1 * b2 + j1 * f2 + k1 * j2 + l1 * n2;
            _p[10] = i1 * c2 + j1 * g2 + k1 * k2 + l1 * o2;
            _p[11] = i1 * d2 + j1 * h2 + k1 * l2 + l1 * p2;
            _p[12] = m1 * a2 + n1 * e2 + o1 * i2 + p1 * m2;
            _p[13] = m1 * b2 + n1 * f2 + o1 * j2 + p1 * n2;
            _p[14] = m1 * c2 + n1 * g2 + o1 * k2 + p1 * o2;
            _p[15] = m1 * d2 + n1 * h2 + o1 * l2 + p1 * p2;
            this._identityCalculated = false;
            return this;
        }
        function multiply(matrix) {
            var matrixProps = matrix.props;
            return this.transform(matrixProps[0], matrixProps[1], matrixProps[2], matrixProps[3], matrixProps[4], matrixProps[5], matrixProps[6], matrixProps[7], matrixProps[8], matrixProps[9], matrixProps[10], matrixProps[11], matrixProps[12], matrixProps[13], matrixProps[14], matrixProps[15]);
        }
        function isIdentity() {
            if (!this._identityCalculated) {
                this._identity = !(this.props[0] !== 1 || this.props[1] !== 0 || this.props[2] !== 0 || this.props[3] !== 0 || this.props[4] !== 0 || this.props[5] !== 1 || this.props[6] !== 0 || this.props[7] !== 0 || this.props[8] !== 0 || this.props[9] !== 0 || this.props[10] !== 1 || this.props[11] !== 0 || this.props[12] !== 0 || this.props[13] !== 0 || this.props[14] !== 0 || this.props[15] !== 1);
                this._identityCalculated = true;
            }
            return this._identity;
        }
        function equals(matr) {
            var i = 0;
            while(i < 16){
                if (matr.props[i] !== this.props[i]) return false;
                i += 1;
            }
            return true;
        }
        function clone(matr) {
            var i;
            for(i = 0; i < 16; i += 1)matr.props[i] = this.props[i];
            return matr;
        }
        function cloneFromProps(props) {
            var i;
            for(i = 0; i < 16; i += 1)this.props[i] = props[i];
        }
        function applyToPoint(x, y, z) {
            return {
                x: x * this.props[0] + y * this.props[4] + z * this.props[8] + this.props[12],
                y: x * this.props[1] + y * this.props[5] + z * this.props[9] + this.props[13],
                z: x * this.props[2] + y * this.props[6] + z * this.props[10] + this.props[14]
            };
        /* return {
           x: x * me.a + y * me.c + me.e,
           y: x * me.b + y * me.d + me.f
           }; */ }
        function applyToX(x, y, z) {
            return x * this.props[0] + y * this.props[4] + z * this.props[8] + this.props[12];
        }
        function applyToY(x, y, z) {
            return x * this.props[1] + y * this.props[5] + z * this.props[9] + this.props[13];
        }
        function applyToZ(x, y, z) {
            return x * this.props[2] + y * this.props[6] + z * this.props[10] + this.props[14];
        }
        function getInverseMatrix() {
            var determinant = this.props[0] * this.props[5] - this.props[1] * this.props[4];
            var a = this.props[5] / determinant;
            var b = -this.props[1] / determinant;
            var c = -this.props[4] / determinant;
            var d = this.props[0] / determinant;
            var e = (this.props[4] * this.props[13] - this.props[5] * this.props[12]) / determinant;
            var f = -(this.props[0] * this.props[13] - this.props[1] * this.props[12]) / determinant;
            var inverseMatrix = new Matrix();
            inverseMatrix.props[0] = a;
            inverseMatrix.props[1] = b;
            inverseMatrix.props[4] = c;
            inverseMatrix.props[5] = d;
            inverseMatrix.props[12] = e;
            inverseMatrix.props[13] = f;
            return inverseMatrix;
        }
        function inversePoint(pt) {
            var inverseMatrix = this.getInverseMatrix();
            return inverseMatrix.applyToPointArray(pt[0], pt[1], pt[2] || 0);
        }
        function inversePoints(pts) {
            var i;
            var len = pts.length;
            var retPts = [];
            for(i = 0; i < len; i += 1)retPts[i] = inversePoint(pts[i]);
            return retPts;
        }
        function applyToTriplePoints(pt1, pt2, pt3) {
            var arr = createTypedArray("float32", 6);
            if (this.isIdentity()) {
                arr[0] = pt1[0];
                arr[1] = pt1[1];
                arr[2] = pt2[0];
                arr[3] = pt2[1];
                arr[4] = pt3[0];
                arr[5] = pt3[1];
            } else {
                var p0 = this.props[0];
                var p1 = this.props[1];
                var p4 = this.props[4];
                var p5 = this.props[5];
                var p12 = this.props[12];
                var p13 = this.props[13];
                arr[0] = pt1[0] * p0 + pt1[1] * p4 + p12;
                arr[1] = pt1[0] * p1 + pt1[1] * p5 + p13;
                arr[2] = pt2[0] * p0 + pt2[1] * p4 + p12;
                arr[3] = pt2[0] * p1 + pt2[1] * p5 + p13;
                arr[4] = pt3[0] * p0 + pt3[1] * p4 + p12;
                arr[5] = pt3[0] * p1 + pt3[1] * p5 + p13;
            }
            return arr;
        }
        function applyToPointArray(x, y, z) {
            var arr;
            if (this.isIdentity()) arr = [
                x,
                y,
                z
            ];
            else arr = [
                x * this.props[0] + y * this.props[4] + z * this.props[8] + this.props[12],
                x * this.props[1] + y * this.props[5] + z * this.props[9] + this.props[13],
                x * this.props[2] + y * this.props[6] + z * this.props[10] + this.props[14]
            ];
            return arr;
        }
        function applyToPointStringified(x, y) {
            if (this.isIdentity()) return x + "," + y;
            var _p = this.props;
            return Math.round((x * _p[0] + y * _p[4] + _p[12]) * 100) / 100 + "," + Math.round((x * _p[1] + y * _p[5] + _p[13]) * 100) / 100;
        }
        function toCSS() {
            // Doesn't make much sense to add this optimization. If it is an identity matrix, it's very likely this will get called only once since it won't be keyframed.
            /* if(this.isIdentity()) {
              return '';
          } */ var i = 0;
            var props = this.props;
            var cssValue = "matrix3d(";
            var v = 10000;
            while(i < 16){
                cssValue += _rnd(props[i] * v) / v;
                cssValue += i === 15 ? ")" : ",";
                i += 1;
            }
            return cssValue;
        }
        function roundMatrixProperty(val) {
            var v = 10000;
            if (val < 0.000001 && val > 0 || val > -0.000001 && val < 0) return _rnd(val * v) / v;
            return val;
        }
        function to2dCSS() {
            // Doesn't make much sense to add this optimization. If it is an identity matrix, it's very likely this will get called only once since it won't be keyframed.
            /* if(this.isIdentity()) {
              return '';
          } */ var props = this.props;
            var _a = roundMatrixProperty(props[0]);
            var _b = roundMatrixProperty(props[1]);
            var _c = roundMatrixProperty(props[4]);
            var _d = roundMatrixProperty(props[5]);
            var _e = roundMatrixProperty(props[12]);
            var _f = roundMatrixProperty(props[13]);
            return "matrix(" + _a + "," + _b + "," + _c + "," + _d + "," + _e + "," + _f + ")";
        }
        return function() {
            this.reset = reset;
            this.rotate = rotate;
            this.rotateX = rotateX;
            this.rotateY = rotateY;
            this.rotateZ = rotateZ;
            this.skew = skew;
            this.skewFromAxis = skewFromAxis;
            this.shear = shear;
            this.scale = scale;
            this.setTransform = setTransform;
            this.translate = translate;
            this.transform = transform;
            this.multiply = multiply;
            this.applyToPoint = applyToPoint;
            this.applyToX = applyToX;
            this.applyToY = applyToY;
            this.applyToZ = applyToZ;
            this.applyToPointArray = applyToPointArray;
            this.applyToTriplePoints = applyToTriplePoints;
            this.applyToPointStringified = applyToPointStringified;
            this.toCSS = toCSS;
            this.to2dCSS = to2dCSS;
            this.clone = clone;
            this.cloneFromProps = cloneFromProps;
            this.equals = equals;
            this.inversePoints = inversePoints;
            this.inversePoint = inversePoint;
            this.getInverseMatrix = getInverseMatrix;
            this._t = this.transform;
            this.isIdentity = isIdentity;
            this._identity = true;
            this._identityCalculated = false;
            this.props = createTypedArray("float32", 16);
            this.reset();
        };
    }();
    function _typeof$3(obj) {
        "@babel/helpers - typeof";
        if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof$3 = function _typeof(obj) {
            return typeof obj;
        };
        else _typeof$3 = function _typeof(obj) {
            return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        };
        return _typeof$3(obj);
    }
    var lottie = {};
    var standalone = "__[STANDALONE]__";
    var animationData = "__[ANIMATIONDATA]__";
    var renderer = "";
    function setLocation(href) {
        setLocationHref(href);
    }
    function searchAnimations() {
        if (standalone === true) animationManager.searchAnimations(animationData, standalone, renderer);
        else animationManager.searchAnimations();
    }
    function setSubframeRendering(flag) {
        setSubframeEnabled(flag);
    }
    function setPrefix(prefix) {
        setIdPrefix(prefix);
    }
    function loadAnimation(params) {
        if (standalone === true) params.animationData = JSON.parse(animationData);
        return animationManager.loadAnimation(params);
    }
    function setQuality(value) {
        if (typeof value === "string") switch(value){
            case "high":
                setDefaultCurveSegments(200);
                break;
            default:
            case "medium":
                setDefaultCurveSegments(50);
                break;
            case "low":
                setDefaultCurveSegments(10);
                break;
        }
        else if (!isNaN(value) && value > 1) setDefaultCurveSegments(value);
        if (getDefaultCurveSegments() >= 50) roundValues(false);
        else roundValues(true);
    }
    function inBrowser() {
        return typeof navigator !== "undefined";
    }
    function installPlugin(type, plugin) {
        if (type === "expressions") setExpressionsPlugin(plugin);
    }
    function getFactory(name) {
        switch(name){
            case "propertyFactory":
                return PropertyFactory;
            case "shapePropertyFactory":
                return ShapePropertyFactory;
            case "matrix":
                return Matrix;
            default:
                return null;
        }
    }
    lottie.play = animationManager.play;
    lottie.pause = animationManager.pause;
    lottie.setLocationHref = setLocation;
    lottie.togglePause = animationManager.togglePause;
    lottie.setSpeed = animationManager.setSpeed;
    lottie.setDirection = animationManager.setDirection;
    lottie.stop = animationManager.stop;
    lottie.searchAnimations = searchAnimations;
    lottie.registerAnimation = animationManager.registerAnimation;
    lottie.loadAnimation = loadAnimation;
    lottie.setSubframeRendering = setSubframeRendering;
    lottie.resize = animationManager.resize; // lottie.start = start;
    lottie.goToAndStop = animationManager.goToAndStop;
    lottie.destroy = animationManager.destroy;
    lottie.setQuality = setQuality;
    lottie.inBrowser = inBrowser;
    lottie.installPlugin = installPlugin;
    lottie.freeze = animationManager.freeze;
    lottie.unfreeze = animationManager.unfreeze;
    lottie.setVolume = animationManager.setVolume;
    lottie.mute = animationManager.mute;
    lottie.unmute = animationManager.unmute;
    lottie.getRegisteredAnimations = animationManager.getRegisteredAnimations;
    lottie.useWebWorker = setWebWorker;
    lottie.setIDPrefix = setPrefix;
    lottie.__getFactory = getFactory;
    lottie.version = "5.12.2";
    function checkReady() {
        if (document.readyState === "complete") {
            clearInterval(readyStateCheckInterval);
            searchAnimations();
        }
    }
    function getQueryVariable(variable) {
        var vars = queryString.split("&");
        for(var i = 0; i < vars.length; i += 1){
            var pair = vars[i].split("=");
            if (decodeURIComponent(pair[0]) == variable) // eslint-disable-line eqeqeq
            return decodeURIComponent(pair[1]);
        }
        return null;
    }
    var queryString = "";
    if (standalone) {
        var scripts = document.getElementsByTagName("script");
        var index = scripts.length - 1;
        var myScript = scripts[index] || {
            src: ""
        };
        queryString = myScript.src ? myScript.src.replace(/^[^\?]+\??/, "") : ""; // eslint-disable-line no-useless-escape
        renderer = getQueryVariable("renderer");
    }
    var readyStateCheckInterval = setInterval(checkReady, 100); // this adds bodymovin to the window object for backwards compatibility
    try {
        if (!(_typeof$3(exports) === "object" && true) && !(typeof define === "function" && define.amd // eslint-disable-line no-undef
        )) window.bodymovin = lottie;
    } catch (err) {}
    var ShapeModifiers = function() {
        var ob = {};
        var modifiers = {};
        ob.registerModifier = registerModifier;
        ob.getModifier = getModifier;
        function registerModifier(nm, factory) {
            if (!modifiers[nm]) modifiers[nm] = factory;
        }
        function getModifier(nm, elem, data) {
            return new modifiers[nm](elem, data);
        }
        return ob;
    }();
    function ShapeModifier() {}
    ShapeModifier.prototype.initModifierProperties = function() {};
    ShapeModifier.prototype.addShapeToModifier = function() {};
    ShapeModifier.prototype.addShape = function(data) {
        if (!this.closed) {
            // Adding shape to dynamic properties. It covers the case where a shape has no effects applied, to reset it's _mdf state on every tick.
            data.sh.container.addDynamicProperty(data.sh);
            var shapeData = {
                shape: data.sh,
                data: data,
                localShapeCollection: shapeCollectionPool.newShapeCollection()
            };
            this.shapes.push(shapeData);
            this.addShapeToModifier(shapeData);
            if (this._isAnimated) data.setAsAnimated();
        }
    };
    ShapeModifier.prototype.init = function(elem, data) {
        this.shapes = [];
        this.elem = elem;
        this.initDynamicPropertyContainer(elem);
        this.initModifierProperties(elem, data);
        this.frameId = initialDefaultFrame;
        this.closed = false;
        this.k = false;
        if (this.dynamicProperties.length) this.k = true;
        else this.getValue(true);
    };
    ShapeModifier.prototype.processKeys = function() {
        if (this.elem.globalData.frameId === this.frameId) return;
        this.frameId = this.elem.globalData.frameId;
        this.iterateDynamicProperties();
    };
    extendPrototype([
        DynamicPropertyContainer
    ], ShapeModifier);
    function TrimModifier() {}
    extendPrototype([
        ShapeModifier
    ], TrimModifier);
    TrimModifier.prototype.initModifierProperties = function(elem, data) {
        this.s = PropertyFactory.getProp(elem, data.s, 0, 0.01, this);
        this.e = PropertyFactory.getProp(elem, data.e, 0, 0.01, this);
        this.o = PropertyFactory.getProp(elem, data.o, 0, 0, this);
        this.sValue = 0;
        this.eValue = 0;
        this.getValue = this.processKeys;
        this.m = data.m;
        this._isAnimated = !!this.s.effectsSequence.length || !!this.e.effectsSequence.length || !!this.o.effectsSequence.length;
    };
    TrimModifier.prototype.addShapeToModifier = function(shapeData) {
        shapeData.pathsData = [];
    };
    TrimModifier.prototype.calculateShapeEdges = function(s, e, shapeLength, addedLength, totalModifierLength) {
        var segments = [];
        if (e <= 1) segments.push({
            s: s,
            e: e
        });
        else if (s >= 1) segments.push({
            s: s - 1,
            e: e - 1
        });
        else {
            segments.push({
                s: s,
                e: 1
            });
            segments.push({
                s: 0,
                e: e - 1
            });
        }
        var shapeSegments = [];
        var i;
        var len = segments.length;
        var segmentOb;
        for(i = 0; i < len; i += 1){
            segmentOb = segments[i];
            if (!(segmentOb.e * totalModifierLength < addedLength || segmentOb.s * totalModifierLength > addedLength + shapeLength)) {
                var shapeS;
                var shapeE;
                if (segmentOb.s * totalModifierLength <= addedLength) shapeS = 0;
                else shapeS = (segmentOb.s * totalModifierLength - addedLength) / shapeLength;
                if (segmentOb.e * totalModifierLength >= addedLength + shapeLength) shapeE = 1;
                else shapeE = (segmentOb.e * totalModifierLength - addedLength) / shapeLength;
                shapeSegments.push([
                    shapeS,
                    shapeE
                ]);
            }
        }
        if (!shapeSegments.length) shapeSegments.push([
            0,
            0
        ]);
        return shapeSegments;
    };
    TrimModifier.prototype.releasePathsData = function(pathsData) {
        var i;
        var len = pathsData.length;
        for(i = 0; i < len; i += 1)segmentsLengthPool.release(pathsData[i]);
        pathsData.length = 0;
        return pathsData;
    };
    TrimModifier.prototype.processShapes = function(_isFirstFrame) {
        var s;
        var e;
        if (this._mdf || _isFirstFrame) {
            var o = this.o.v % 360 / 360;
            if (o < 0) o += 1;
            if (this.s.v > 1) s = 1 + o;
            else if (this.s.v < 0) s = 0 + o;
            else s = this.s.v + o;
            if (this.e.v > 1) e = 1 + o;
            else if (this.e.v < 0) e = 0 + o;
            else e = this.e.v + o;
            if (s > e) {
                var _s = s;
                s = e;
                e = _s;
            }
            s = Math.round(s * 10000) * 0.0001;
            e = Math.round(e * 10000) * 0.0001;
            this.sValue = s;
            this.eValue = e;
        } else {
            s = this.sValue;
            e = this.eValue;
        }
        var shapePaths;
        var i;
        var len = this.shapes.length;
        var j;
        var jLen;
        var pathsData;
        var pathData;
        var totalShapeLength;
        var totalModifierLength = 0;
        if (e === s) for(i = 0; i < len; i += 1){
            this.shapes[i].localShapeCollection.releaseShapes();
            this.shapes[i].shape._mdf = true;
            this.shapes[i].shape.paths = this.shapes[i].localShapeCollection;
            if (this._mdf) this.shapes[i].pathsData.length = 0;
        }
        else if (!(e === 1 && s === 0 || e === 0 && s === 1)) {
            var segments = [];
            var shapeData;
            var localShapeCollection;
            for(i = 0; i < len; i += 1){
                shapeData = this.shapes[i]; // if shape hasn't changed and trim properties haven't changed, cached previous path can be used
                if (!shapeData.shape._mdf && !this._mdf && !_isFirstFrame && this.m !== 2) shapeData.shape.paths = shapeData.localShapeCollection;
                else {
                    shapePaths = shapeData.shape.paths;
                    jLen = shapePaths._length;
                    totalShapeLength = 0;
                    if (!shapeData.shape._mdf && shapeData.pathsData.length) totalShapeLength = shapeData.totalShapeLength;
                    else {
                        pathsData = this.releasePathsData(shapeData.pathsData);
                        for(j = 0; j < jLen; j += 1){
                            pathData = bez.getSegmentsLength(shapePaths.shapes[j]);
                            pathsData.push(pathData);
                            totalShapeLength += pathData.totalLength;
                        }
                        shapeData.totalShapeLength = totalShapeLength;
                        shapeData.pathsData = pathsData;
                    }
                    totalModifierLength += totalShapeLength;
                    shapeData.shape._mdf = true;
                }
            }
            var shapeS = s;
            var shapeE = e;
            var addedLength = 0;
            var edges;
            for(i = len - 1; i >= 0; i -= 1){
                shapeData = this.shapes[i];
                if (shapeData.shape._mdf) {
                    localShapeCollection = shapeData.localShapeCollection;
                    localShapeCollection.releaseShapes(); // if m === 2 means paths are trimmed individually so edges need to be found for this specific shape relative to whoel group
                    if (this.m === 2 && len > 1) {
                        edges = this.calculateShapeEdges(s, e, shapeData.totalShapeLength, addedLength, totalModifierLength);
                        addedLength += shapeData.totalShapeLength;
                    } else edges = [
                        [
                            shapeS,
                            shapeE
                        ]
                    ];
                    jLen = edges.length;
                    for(j = 0; j < jLen; j += 1){
                        shapeS = edges[j][0];
                        shapeE = edges[j][1];
                        segments.length = 0;
                        if (shapeE <= 1) segments.push({
                            s: shapeData.totalShapeLength * shapeS,
                            e: shapeData.totalShapeLength * shapeE
                        });
                        else if (shapeS >= 1) segments.push({
                            s: shapeData.totalShapeLength * (shapeS - 1),
                            e: shapeData.totalShapeLength * (shapeE - 1)
                        });
                        else {
                            segments.push({
                                s: shapeData.totalShapeLength * shapeS,
                                e: shapeData.totalShapeLength
                            });
                            segments.push({
                                s: 0,
                                e: shapeData.totalShapeLength * (shapeE - 1)
                            });
                        }
                        var newShapesData = this.addShapes(shapeData, segments[0]);
                        if (segments[0].s !== segments[0].e) {
                            if (segments.length > 1) {
                                var lastShapeInCollection = shapeData.shape.paths.shapes[shapeData.shape.paths._length - 1];
                                if (lastShapeInCollection.c) {
                                    var lastShape = newShapesData.pop();
                                    this.addPaths(newShapesData, localShapeCollection);
                                    newShapesData = this.addShapes(shapeData, segments[1], lastShape);
                                } else {
                                    this.addPaths(newShapesData, localShapeCollection);
                                    newShapesData = this.addShapes(shapeData, segments[1]);
                                }
                            }
                            this.addPaths(newShapesData, localShapeCollection);
                        }
                    }
                    shapeData.shape.paths = localShapeCollection;
                }
            }
        } else if (this._mdf) for(i = 0; i < len; i += 1){
            // Releasign Trim Cached paths data when no trim applied in case shapes are modified inbetween.
            // Don't remove this even if it's losing cached info.
            this.shapes[i].pathsData.length = 0;
            this.shapes[i].shape._mdf = true;
        }
    };
    TrimModifier.prototype.addPaths = function(newPaths, localShapeCollection) {
        var i;
        var len = newPaths.length;
        for(i = 0; i < len; i += 1)localShapeCollection.addShape(newPaths[i]);
    };
    TrimModifier.prototype.addSegment = function(pt1, pt2, pt3, pt4, shapePath, pos, newShape) {
        shapePath.setXYAt(pt2[0], pt2[1], "o", pos);
        shapePath.setXYAt(pt3[0], pt3[1], "i", pos + 1);
        if (newShape) shapePath.setXYAt(pt1[0], pt1[1], "v", pos);
        shapePath.setXYAt(pt4[0], pt4[1], "v", pos + 1);
    };
    TrimModifier.prototype.addSegmentFromArray = function(points, shapePath, pos, newShape) {
        shapePath.setXYAt(points[1], points[5], "o", pos);
        shapePath.setXYAt(points[2], points[6], "i", pos + 1);
        if (newShape) shapePath.setXYAt(points[0], points[4], "v", pos);
        shapePath.setXYAt(points[3], points[7], "v", pos + 1);
    };
    TrimModifier.prototype.addShapes = function(shapeData, shapeSegment, shapePath) {
        var pathsData = shapeData.pathsData;
        var shapePaths = shapeData.shape.paths.shapes;
        var i;
        var len = shapeData.shape.paths._length;
        var j;
        var jLen;
        var addedLength = 0;
        var currentLengthData;
        var segmentCount;
        var lengths;
        var segment;
        var shapes = [];
        var initPos;
        var newShape = true;
        if (!shapePath) {
            shapePath = shapePool.newElement();
            segmentCount = 0;
            initPos = 0;
        } else {
            segmentCount = shapePath._length;
            initPos = shapePath._length;
        }
        shapes.push(shapePath);
        for(i = 0; i < len; i += 1){
            lengths = pathsData[i].lengths;
            shapePath.c = shapePaths[i].c;
            jLen = shapePaths[i].c ? lengths.length : lengths.length + 1;
            for(j = 1; j < jLen; j += 1){
                currentLengthData = lengths[j - 1];
                if (addedLength + currentLengthData.addedLength < shapeSegment.s) {
                    addedLength += currentLengthData.addedLength;
                    shapePath.c = false;
                } else if (addedLength > shapeSegment.e) {
                    shapePath.c = false;
                    break;
                } else {
                    if (shapeSegment.s <= addedLength && shapeSegment.e >= addedLength + currentLengthData.addedLength) {
                        this.addSegment(shapePaths[i].v[j - 1], shapePaths[i].o[j - 1], shapePaths[i].i[j], shapePaths[i].v[j], shapePath, segmentCount, newShape);
                        newShape = false;
                    } else {
                        segment = bez.getNewSegment(shapePaths[i].v[j - 1], shapePaths[i].v[j], shapePaths[i].o[j - 1], shapePaths[i].i[j], (shapeSegment.s - addedLength) / currentLengthData.addedLength, (shapeSegment.e - addedLength) / currentLengthData.addedLength, lengths[j - 1]);
                        this.addSegmentFromArray(segment, shapePath, segmentCount, newShape); // this.addSegment(segment.pt1, segment.pt3, segment.pt4, segment.pt2, shapePath, segmentCount, newShape);
                        newShape = false;
                        shapePath.c = false;
                    }
                    addedLength += currentLengthData.addedLength;
                    segmentCount += 1;
                }
            }
            if (shapePaths[i].c && lengths.length) {
                currentLengthData = lengths[j - 1];
                if (addedLength <= shapeSegment.e) {
                    var segmentLength = lengths[j - 1].addedLength;
                    if (shapeSegment.s <= addedLength && shapeSegment.e >= addedLength + segmentLength) {
                        this.addSegment(shapePaths[i].v[j - 1], shapePaths[i].o[j - 1], shapePaths[i].i[0], shapePaths[i].v[0], shapePath, segmentCount, newShape);
                        newShape = false;
                    } else {
                        segment = bez.getNewSegment(shapePaths[i].v[j - 1], shapePaths[i].v[0], shapePaths[i].o[j - 1], shapePaths[i].i[0], (shapeSegment.s - addedLength) / segmentLength, (shapeSegment.e - addedLength) / segmentLength, lengths[j - 1]);
                        this.addSegmentFromArray(segment, shapePath, segmentCount, newShape); // this.addSegment(segment.pt1, segment.pt3, segment.pt4, segment.pt2, shapePath, segmentCount, newShape);
                        newShape = false;
                        shapePath.c = false;
                    }
                } else shapePath.c = false;
                addedLength += currentLengthData.addedLength;
                segmentCount += 1;
            }
            if (shapePath._length) {
                shapePath.setXYAt(shapePath.v[initPos][0], shapePath.v[initPos][1], "i", initPos);
                shapePath.setXYAt(shapePath.v[shapePath._length - 1][0], shapePath.v[shapePath._length - 1][1], "o", shapePath._length - 1);
            }
            if (addedLength > shapeSegment.e) break;
            if (i < len - 1) {
                shapePath = shapePool.newElement();
                newShape = true;
                shapes.push(shapePath);
                segmentCount = 0;
            }
        }
        return shapes;
    };
    function PuckerAndBloatModifier() {}
    extendPrototype([
        ShapeModifier
    ], PuckerAndBloatModifier);
    PuckerAndBloatModifier.prototype.initModifierProperties = function(elem, data) {
        this.getValue = this.processKeys;
        this.amount = PropertyFactory.getProp(elem, data.a, 0, null, this);
        this._isAnimated = !!this.amount.effectsSequence.length;
    };
    PuckerAndBloatModifier.prototype.processPath = function(path, amount) {
        var percent = amount / 100;
        var centerPoint = [
            0,
            0
        ];
        var pathLength = path._length;
        var i = 0;
        for(i = 0; i < pathLength; i += 1){
            centerPoint[0] += path.v[i][0];
            centerPoint[1] += path.v[i][1];
        }
        centerPoint[0] /= pathLength;
        centerPoint[1] /= pathLength;
        var clonedPath = shapePool.newElement();
        clonedPath.c = path.c;
        var vX;
        var vY;
        var oX;
        var oY;
        var iX;
        var iY;
        for(i = 0; i < pathLength; i += 1){
            vX = path.v[i][0] + (centerPoint[0] - path.v[i][0]) * percent;
            vY = path.v[i][1] + (centerPoint[1] - path.v[i][1]) * percent;
            oX = path.o[i][0] + (centerPoint[0] - path.o[i][0]) * -percent;
            oY = path.o[i][1] + (centerPoint[1] - path.o[i][1]) * -percent;
            iX = path.i[i][0] + (centerPoint[0] - path.i[i][0]) * -percent;
            iY = path.i[i][1] + (centerPoint[1] - path.i[i][1]) * -percent;
            clonedPath.setTripleAt(vX, vY, oX, oY, iX, iY, i);
        }
        return clonedPath;
    };
    PuckerAndBloatModifier.prototype.processShapes = function(_isFirstFrame) {
        var shapePaths;
        var i;
        var len = this.shapes.length;
        var j;
        var jLen;
        var amount = this.amount.v;
        if (amount !== 0) {
            var shapeData;
            var localShapeCollection;
            for(i = 0; i < len; i += 1){
                shapeData = this.shapes[i];
                localShapeCollection = shapeData.localShapeCollection;
                if (!(!shapeData.shape._mdf && !this._mdf && !_isFirstFrame)) {
                    localShapeCollection.releaseShapes();
                    shapeData.shape._mdf = true;
                    shapePaths = shapeData.shape.paths.shapes;
                    jLen = shapeData.shape.paths._length;
                    for(j = 0; j < jLen; j += 1)localShapeCollection.addShape(this.processPath(shapePaths[j], amount));
                }
                shapeData.shape.paths = shapeData.localShapeCollection;
            }
        }
        if (!this.dynamicProperties.length) this._mdf = false;
    };
    var TransformPropertyFactory = function() {
        var defaultVector = [
            0,
            0
        ];
        function applyToMatrix(mat) {
            var _mdf = this._mdf;
            this.iterateDynamicProperties();
            this._mdf = this._mdf || _mdf;
            if (this.a) mat.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]);
            if (this.s) mat.scale(this.s.v[0], this.s.v[1], this.s.v[2]);
            if (this.sk) mat.skewFromAxis(-this.sk.v, this.sa.v);
            if (this.r) mat.rotate(-this.r.v);
            else mat.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]);
            if (this.data.p.s) {
                if (this.data.p.z) mat.translate(this.px.v, this.py.v, -this.pz.v);
                else mat.translate(this.px.v, this.py.v, 0);
            } else mat.translate(this.p.v[0], this.p.v[1], -this.p.v[2]);
        }
        function processKeys(forceRender) {
            if (this.elem.globalData.frameId === this.frameId) return;
            if (this._isDirty) {
                this.precalculateMatrix();
                this._isDirty = false;
            }
            this.iterateDynamicProperties();
            if (this._mdf || forceRender) {
                var frameRate;
                this.v.cloneFromProps(this.pre.props);
                if (this.appliedTransformations < 1) this.v.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]);
                if (this.appliedTransformations < 2) this.v.scale(this.s.v[0], this.s.v[1], this.s.v[2]);
                if (this.sk && this.appliedTransformations < 3) this.v.skewFromAxis(-this.sk.v, this.sa.v);
                if (this.r && this.appliedTransformations < 4) this.v.rotate(-this.r.v);
                else if (!this.r && this.appliedTransformations < 4) this.v.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]);
                if (this.autoOriented) {
                    var v1;
                    var v2;
                    frameRate = this.elem.globalData.frameRate;
                    if (this.p && this.p.keyframes && this.p.getValueAtTime) {
                        if (this.p._caching.lastFrame + this.p.offsetTime <= this.p.keyframes[0].t) {
                            v1 = this.p.getValueAtTime((this.p.keyframes[0].t + 0.01) / frameRate, 0);
                            v2 = this.p.getValueAtTime(this.p.keyframes[0].t / frameRate, 0);
                        } else if (this.p._caching.lastFrame + this.p.offsetTime >= this.p.keyframes[this.p.keyframes.length - 1].t) {
                            v1 = this.p.getValueAtTime(this.p.keyframes[this.p.keyframes.length - 1].t / frameRate, 0);
                            v2 = this.p.getValueAtTime((this.p.keyframes[this.p.keyframes.length - 1].t - 0.05) / frameRate, 0);
                        } else {
                            v1 = this.p.pv;
                            v2 = this.p.getValueAtTime((this.p._caching.lastFrame + this.p.offsetTime - 0.01) / frameRate, this.p.offsetTime);
                        }
                    } else if (this.px && this.px.keyframes && this.py.keyframes && this.px.getValueAtTime && this.py.getValueAtTime) {
                        v1 = [];
                        v2 = [];
                        var px = this.px;
                        var py = this.py;
                        if (px._caching.lastFrame + px.offsetTime <= px.keyframes[0].t) {
                            v1[0] = px.getValueAtTime((px.keyframes[0].t + 0.01) / frameRate, 0);
                            v1[1] = py.getValueAtTime((py.keyframes[0].t + 0.01) / frameRate, 0);
                            v2[0] = px.getValueAtTime(px.keyframes[0].t / frameRate, 0);
                            v2[1] = py.getValueAtTime(py.keyframes[0].t / frameRate, 0);
                        } else if (px._caching.lastFrame + px.offsetTime >= px.keyframes[px.keyframes.length - 1].t) {
                            v1[0] = px.getValueAtTime(px.keyframes[px.keyframes.length - 1].t / frameRate, 0);
                            v1[1] = py.getValueAtTime(py.keyframes[py.keyframes.length - 1].t / frameRate, 0);
                            v2[0] = px.getValueAtTime((px.keyframes[px.keyframes.length - 1].t - 0.01) / frameRate, 0);
                            v2[1] = py.getValueAtTime((py.keyframes[py.keyframes.length - 1].t - 0.01) / frameRate, 0);
                        } else {
                            v1 = [
                                px.pv,
                                py.pv
                            ];
                            v2[0] = px.getValueAtTime((px._caching.lastFrame + px.offsetTime - 0.01) / frameRate, px.offsetTime);
                            v2[1] = py.getValueAtTime((py._caching.lastFrame + py.offsetTime - 0.01) / frameRate, py.offsetTime);
                        }
                    } else {
                        v2 = defaultVector;
                        v1 = v2;
                    }
                    this.v.rotate(-Math.atan2(v1[1] - v2[1], v1[0] - v2[0]));
                }
                if (this.data.p && this.data.p.s) {
                    if (this.data.p.z) this.v.translate(this.px.v, this.py.v, -this.pz.v);
                    else this.v.translate(this.px.v, this.py.v, 0);
                } else this.v.translate(this.p.v[0], this.p.v[1], -this.p.v[2]);
            }
            this.frameId = this.elem.globalData.frameId;
        }
        function precalculateMatrix() {
            this.appliedTransformations = 0;
            this.pre.reset();
            if (!this.a.effectsSequence.length) {
                this.pre.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]);
                this.appliedTransformations = 1;
            } else return;
            if (!this.s.effectsSequence.length) {
                this.pre.scale(this.s.v[0], this.s.v[1], this.s.v[2]);
                this.appliedTransformations = 2;
            } else return;
            if (this.sk) {
                if (!this.sk.effectsSequence.length && !this.sa.effectsSequence.length) {
                    this.pre.skewFromAxis(-this.sk.v, this.sa.v);
                    this.appliedTransformations = 3;
                } else return;
            }
            if (this.r) {
                if (!this.r.effectsSequence.length) {
                    this.pre.rotate(-this.r.v);
                    this.appliedTransformations = 4;
                }
            } else if (!this.rz.effectsSequence.length && !this.ry.effectsSequence.length && !this.rx.effectsSequence.length && !this.or.effectsSequence.length) {
                this.pre.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]);
                this.appliedTransformations = 4;
            }
        }
        function autoOrient() {
        // var prevP = this.getValueAtTime();
        }
        function addDynamicProperty(prop) {
            this._addDynamicProperty(prop);
            this.elem.addDynamicProperty(prop);
            this._isDirty = true;
        }
        function TransformProperty(elem, data, container) {
            this.elem = elem;
            this.frameId = -1;
            this.propType = "transform";
            this.data = data;
            this.v = new Matrix(); // Precalculated matrix with non animated properties
            this.pre = new Matrix();
            this.appliedTransformations = 0;
            this.initDynamicPropertyContainer(container || elem);
            if (data.p && data.p.s) {
                this.px = PropertyFactory.getProp(elem, data.p.x, 0, 0, this);
                this.py = PropertyFactory.getProp(elem, data.p.y, 0, 0, this);
                if (data.p.z) this.pz = PropertyFactory.getProp(elem, data.p.z, 0, 0, this);
            } else this.p = PropertyFactory.getProp(elem, data.p || {
                k: [
                    0,
                    0,
                    0
                ]
            }, 1, 0, this);
            if (data.rx) {
                this.rx = PropertyFactory.getProp(elem, data.rx, 0, degToRads, this);
                this.ry = PropertyFactory.getProp(elem, data.ry, 0, degToRads, this);
                this.rz = PropertyFactory.getProp(elem, data.rz, 0, degToRads, this);
                if (data.or.k[0].ti) {
                    var i;
                    var len = data.or.k.length;
                    for(i = 0; i < len; i += 1){
                        data.or.k[i].to = null;
                        data.or.k[i].ti = null;
                    }
                }
                this.or = PropertyFactory.getProp(elem, data.or, 1, degToRads, this); // sh Indicates it needs to be capped between -180 and 180
                this.or.sh = true;
            } else this.r = PropertyFactory.getProp(elem, data.r || {
                k: 0
            }, 0, degToRads, this);
            if (data.sk) {
                this.sk = PropertyFactory.getProp(elem, data.sk, 0, degToRads, this);
                this.sa = PropertyFactory.getProp(elem, data.sa, 0, degToRads, this);
            }
            this.a = PropertyFactory.getProp(elem, data.a || {
                k: [
                    0,
                    0,
                    0
                ]
            }, 1, 0, this);
            this.s = PropertyFactory.getProp(elem, data.s || {
                k: [
                    100,
                    100,
                    100
                ]
            }, 1, 0.01, this); // Opacity is not part of the transform properties, that's why it won't use this.dynamicProperties. That way transforms won't get updated if opacity changes.
            if (data.o) this.o = PropertyFactory.getProp(elem, data.o, 0, 0.01, elem);
            else this.o = {
                _mdf: false,
                v: 1
            };
            this._isDirty = true;
            if (!this.dynamicProperties.length) this.getValue(true);
        }
        TransformProperty.prototype = {
            applyToMatrix: applyToMatrix,
            getValue: processKeys,
            precalculateMatrix: precalculateMatrix,
            autoOrient: autoOrient
        };
        extendPrototype([
            DynamicPropertyContainer
        ], TransformProperty);
        TransformProperty.prototype.addDynamicProperty = addDynamicProperty;
        TransformProperty.prototype._addDynamicProperty = DynamicPropertyContainer.prototype.addDynamicProperty;
        function getTransformProperty(elem, data, container) {
            return new TransformProperty(elem, data, container);
        }
        return {
            getTransformProperty: getTransformProperty
        };
    }();
    function RepeaterModifier() {}
    extendPrototype([
        ShapeModifier
    ], RepeaterModifier);
    RepeaterModifier.prototype.initModifierProperties = function(elem, data) {
        this.getValue = this.processKeys;
        this.c = PropertyFactory.getProp(elem, data.c, 0, null, this);
        this.o = PropertyFactory.getProp(elem, data.o, 0, null, this);
        this.tr = TransformPropertyFactory.getTransformProperty(elem, data.tr, this);
        this.so = PropertyFactory.getProp(elem, data.tr.so, 0, 0.01, this);
        this.eo = PropertyFactory.getProp(elem, data.tr.eo, 0, 0.01, this);
        this.data = data;
        if (!this.dynamicProperties.length) this.getValue(true);
        this._isAnimated = !!this.dynamicProperties.length;
        this.pMatrix = new Matrix();
        this.rMatrix = new Matrix();
        this.sMatrix = new Matrix();
        this.tMatrix = new Matrix();
        this.matrix = new Matrix();
    };
    RepeaterModifier.prototype.applyTransforms = function(pMatrix, rMatrix, sMatrix, transform, perc, inv) {
        var dir = inv ? -1 : 1;
        var scaleX = transform.s.v[0] + (1 - transform.s.v[0]) * (1 - perc);
        var scaleY = transform.s.v[1] + (1 - transform.s.v[1]) * (1 - perc);
        pMatrix.translate(transform.p.v[0] * dir * perc, transform.p.v[1] * dir * perc, transform.p.v[2]);
        rMatrix.translate(-transform.a.v[0], -transform.a.v[1], transform.a.v[2]);
        rMatrix.rotate(-transform.r.v * dir * perc);
        rMatrix.translate(transform.a.v[0], transform.a.v[1], transform.a.v[2]);
        sMatrix.translate(-transform.a.v[0], -transform.a.v[1], transform.a.v[2]);
        sMatrix.scale(inv ? 1 / scaleX : scaleX, inv ? 1 / scaleY : scaleY);
        sMatrix.translate(transform.a.v[0], transform.a.v[1], transform.a.v[2]);
    };
    RepeaterModifier.prototype.init = function(elem, arr, pos, elemsData) {
        this.elem = elem;
        this.arr = arr;
        this.pos = pos;
        this.elemsData = elemsData;
        this._currentCopies = 0;
        this._elements = [];
        this._groups = [];
        this.frameId = -1;
        this.initDynamicPropertyContainer(elem);
        this.initModifierProperties(elem, arr[pos]);
        while(pos > 0){
            pos -= 1; // this._elements.unshift(arr.splice(pos,1)[0]);
            this._elements.unshift(arr[pos]);
        }
        if (this.dynamicProperties.length) this.k = true;
        else this.getValue(true);
    };
    RepeaterModifier.prototype.resetElements = function(elements) {
        var i;
        var len = elements.length;
        for(i = 0; i < len; i += 1){
            elements[i]._processed = false;
            if (elements[i].ty === "gr") this.resetElements(elements[i].it);
        }
    };
    RepeaterModifier.prototype.cloneElements = function(elements) {
        var newElements = JSON.parse(JSON.stringify(elements));
        this.resetElements(newElements);
        return newElements;
    };
    RepeaterModifier.prototype.changeGroupRender = function(elements, renderFlag) {
        var i;
        var len = elements.length;
        for(i = 0; i < len; i += 1){
            elements[i]._render = renderFlag;
            if (elements[i].ty === "gr") this.changeGroupRender(elements[i].it, renderFlag);
        }
    };
    RepeaterModifier.prototype.processShapes = function(_isFirstFrame) {
        var items;
        var itemsTransform;
        var i;
        var dir;
        var cont;
        var hasReloaded = false;
        if (this._mdf || _isFirstFrame) {
            var copies = Math.ceil(this.c.v);
            if (this._groups.length < copies) {
                while(this._groups.length < copies){
                    var group = {
                        it: this.cloneElements(this._elements),
                        ty: "gr"
                    };
                    group.it.push({
                        a: {
                            a: 0,
                            ix: 1,
                            k: [
                                0,
                                0
                            ]
                        },
                        nm: "Transform",
                        o: {
                            a: 0,
                            ix: 7,
                            k: 100
                        },
                        p: {
                            a: 0,
                            ix: 2,
                            k: [
                                0,
                                0
                            ]
                        },
                        r: {
                            a: 1,
                            ix: 6,
                            k: [
                                {
                                    s: 0,
                                    e: 0,
                                    t: 0
                                },
                                {
                                    s: 0,
                                    e: 0,
                                    t: 1
                                }
                            ]
                        },
                        s: {
                            a: 0,
                            ix: 3,
                            k: [
                                100,
                                100
                            ]
                        },
                        sa: {
                            a: 0,
                            ix: 5,
                            k: 0
                        },
                        sk: {
                            a: 0,
                            ix: 4,
                            k: 0
                        },
                        ty: "tr"
                    });
                    this.arr.splice(0, 0, group);
                    this._groups.splice(0, 0, group);
                    this._currentCopies += 1;
                }
                this.elem.reloadShapes();
                hasReloaded = true;
            }
            cont = 0;
            var renderFlag;
            for(i = 0; i <= this._groups.length - 1; i += 1){
                renderFlag = cont < copies;
                this._groups[i]._render = renderFlag;
                this.changeGroupRender(this._groups[i].it, renderFlag);
                if (!renderFlag) {
                    var elems = this.elemsData[i].it;
                    var transformData = elems[elems.length - 1];
                    if (transformData.transform.op.v !== 0) {
                        transformData.transform.op._mdf = true;
                        transformData.transform.op.v = 0;
                    } else transformData.transform.op._mdf = false;
                }
                cont += 1;
            }
            this._currentCopies = copies; /// /
            var offset = this.o.v;
            var offsetModulo = offset % 1;
            var roundOffset = offset > 0 ? Math.floor(offset) : Math.ceil(offset);
            var pProps = this.pMatrix.props;
            var rProps = this.rMatrix.props;
            var sProps = this.sMatrix.props;
            this.pMatrix.reset();
            this.rMatrix.reset();
            this.sMatrix.reset();
            this.tMatrix.reset();
            this.matrix.reset();
            var iteration = 0;
            if (offset > 0) {
                while(iteration < roundOffset){
                    this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, false);
                    iteration += 1;
                }
                if (offsetModulo) {
                    this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, offsetModulo, false);
                    iteration += offsetModulo;
                }
            } else if (offset < 0) {
                while(iteration > roundOffset){
                    this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, true);
                    iteration -= 1;
                }
                if (offsetModulo) {
                    this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, -offsetModulo, true);
                    iteration -= offsetModulo;
                }
            }
            i = this.data.m === 1 ? 0 : this._currentCopies - 1;
            dir = this.data.m === 1 ? 1 : -1;
            cont = this._currentCopies;
            var j;
            var jLen;
            while(cont){
                items = this.elemsData[i].it;
                itemsTransform = items[items.length - 1].transform.mProps.v.props;
                jLen = itemsTransform.length;
                items[items.length - 1].transform.mProps._mdf = true;
                items[items.length - 1].transform.op._mdf = true;
                items[items.length - 1].transform.op.v = this._currentCopies === 1 ? this.so.v : this.so.v + (this.eo.v - this.so.v) * (i / (this._currentCopies - 1));
                if (iteration !== 0) {
                    if (i !== 0 && dir === 1 || i !== this._currentCopies - 1 && dir === -1) this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, false);
                    this.matrix.transform(rProps[0], rProps[1], rProps[2], rProps[3], rProps[4], rProps[5], rProps[6], rProps[7], rProps[8], rProps[9], rProps[10], rProps[11], rProps[12], rProps[13], rProps[14], rProps[15]);
                    this.matrix.transform(sProps[0], sProps[1], sProps[2], sProps[3], sProps[4], sProps[5], sProps[6], sProps[7], sProps[8], sProps[9], sProps[10], sProps[11], sProps[12], sProps[13], sProps[14], sProps[15]);
                    this.matrix.transform(pProps[0], pProps[1], pProps[2], pProps[3], pProps[4], pProps[5], pProps[6], pProps[7], pProps[8], pProps[9], pProps[10], pProps[11], pProps[12], pProps[13], pProps[14], pProps[15]);
                    for(j = 0; j < jLen; j += 1)itemsTransform[j] = this.matrix.props[j];
                    this.matrix.reset();
                } else {
                    this.matrix.reset();
                    for(j = 0; j < jLen; j += 1)itemsTransform[j] = this.matrix.props[j];
                }
                iteration += 1;
                cont -= 1;
                i += dir;
            }
        } else {
            cont = this._currentCopies;
            i = 0;
            dir = 1;
            while(cont){
                items = this.elemsData[i].it;
                itemsTransform = items[items.length - 1].transform.mProps.v.props;
                items[items.length - 1].transform.mProps._mdf = false;
                items[items.length - 1].transform.op._mdf = false;
                cont -= 1;
                i += dir;
            }
        }
        return hasReloaded;
    };
    RepeaterModifier.prototype.addShape = function() {};
    function RoundCornersModifier() {}
    extendPrototype([
        ShapeModifier
    ], RoundCornersModifier);
    RoundCornersModifier.prototype.initModifierProperties = function(elem, data) {
        this.getValue = this.processKeys;
        this.rd = PropertyFactory.getProp(elem, data.r, 0, null, this);
        this._isAnimated = !!this.rd.effectsSequence.length;
    };
    RoundCornersModifier.prototype.processPath = function(path, round) {
        var clonedPath = shapePool.newElement();
        clonedPath.c = path.c;
        var i;
        var len = path._length;
        var currentV;
        var currentI;
        var currentO;
        var closerV;
        var distance;
        var newPosPerc;
        var index = 0;
        var vX;
        var vY;
        var oX;
        var oY;
        var iX;
        var iY;
        for(i = 0; i < len; i += 1){
            currentV = path.v[i];
            currentO = path.o[i];
            currentI = path.i[i];
            if (currentV[0] === currentO[0] && currentV[1] === currentO[1] && currentV[0] === currentI[0] && currentV[1] === currentI[1]) {
                if ((i === 0 || i === len - 1) && !path.c) {
                    clonedPath.setTripleAt(currentV[0], currentV[1], currentO[0], currentO[1], currentI[0], currentI[1], index);
                    /* clonedPath.v[index] = currentV;
                  clonedPath.o[index] = currentO;
                  clonedPath.i[index] = currentI; */ index += 1;
                } else {
                    if (i === 0) closerV = path.v[len - 1];
                    else closerV = path.v[i - 1];
                    distance = Math.sqrt(Math.pow(currentV[0] - closerV[0], 2) + Math.pow(currentV[1] - closerV[1], 2));
                    newPosPerc = distance ? Math.min(distance / 2, round) / distance : 0;
                    iX = currentV[0] + (closerV[0] - currentV[0]) * newPosPerc;
                    vX = iX;
                    iY = currentV[1] - (currentV[1] - closerV[1]) * newPosPerc;
                    vY = iY;
                    oX = vX - (vX - currentV[0]) * roundCorner;
                    oY = vY - (vY - currentV[1]) * roundCorner;
                    clonedPath.setTripleAt(vX, vY, oX, oY, iX, iY, index);
                    index += 1;
                    if (i === len - 1) closerV = path.v[0];
                    else closerV = path.v[i + 1];
                    distance = Math.sqrt(Math.pow(currentV[0] - closerV[0], 2) + Math.pow(currentV[1] - closerV[1], 2));
                    newPosPerc = distance ? Math.min(distance / 2, round) / distance : 0;
                    oX = currentV[0] + (closerV[0] - currentV[0]) * newPosPerc;
                    vX = oX;
                    oY = currentV[1] + (closerV[1] - currentV[1]) * newPosPerc;
                    vY = oY;
                    iX = vX - (vX - currentV[0]) * roundCorner;
                    iY = vY - (vY - currentV[1]) * roundCorner;
                    clonedPath.setTripleAt(vX, vY, oX, oY, iX, iY, index);
                    index += 1;
                }
            } else {
                clonedPath.setTripleAt(path.v[i][0], path.v[i][1], path.o[i][0], path.o[i][1], path.i[i][0], path.i[i][1], index);
                index += 1;
            }
        }
        return clonedPath;
    };
    RoundCornersModifier.prototype.processShapes = function(_isFirstFrame) {
        var shapePaths;
        var i;
        var len = this.shapes.length;
        var j;
        var jLen;
        var rd = this.rd.v;
        if (rd !== 0) {
            var shapeData;
            var localShapeCollection;
            for(i = 0; i < len; i += 1){
                shapeData = this.shapes[i];
                localShapeCollection = shapeData.localShapeCollection;
                if (!(!shapeData.shape._mdf && !this._mdf && !_isFirstFrame)) {
                    localShapeCollection.releaseShapes();
                    shapeData.shape._mdf = true;
                    shapePaths = shapeData.shape.paths.shapes;
                    jLen = shapeData.shape.paths._length;
                    for(j = 0; j < jLen; j += 1)localShapeCollection.addShape(this.processPath(shapePaths[j], rd));
                }
                shapeData.shape.paths = shapeData.localShapeCollection;
            }
        }
        if (!this.dynamicProperties.length) this._mdf = false;
    };
    function floatEqual(a, b) {
        return Math.abs(a - b) * 100000 <= Math.min(Math.abs(a), Math.abs(b));
    }
    function floatZero(f) {
        return Math.abs(f) <= 0.00001;
    }
    function lerp(p0, p1, amount) {
        return p0 * (1 - amount) + p1 * amount;
    }
    function lerpPoint(p0, p1, amount) {
        return [
            lerp(p0[0], p1[0], amount),
            lerp(p0[1], p1[1], amount)
        ];
    }
    function quadRoots(a, b, c) {
        // no root
        if (a === 0) return [];
        var s = b * b - 4 * a * c; // Complex roots
        if (s < 0) return [];
        var singleRoot = -b / (2 * a); // 1 root
        if (s === 0) return [
            singleRoot
        ];
        var delta = Math.sqrt(s) / (2 * a); // 2 roots
        return [
            singleRoot - delta,
            singleRoot + delta
        ];
    }
    function polynomialCoefficients(p0, p1, p2, p3) {
        return [
            -p0 + 3 * p1 - 3 * p2 + p3,
            3 * p0 - 6 * p1 + 3 * p2,
            -3 * p0 + 3 * p1,
            p0
        ];
    }
    function singlePoint(p) {
        return new PolynomialBezier(p, p, p, p, false);
    }
    function PolynomialBezier(p0, p1, p2, p3, linearize) {
        if (linearize && pointEqual(p0, p1)) p1 = lerpPoint(p0, p3, 1 / 3);
        if (linearize && pointEqual(p2, p3)) p2 = lerpPoint(p0, p3, 2 / 3);
        var coeffx = polynomialCoefficients(p0[0], p1[0], p2[0], p3[0]);
        var coeffy = polynomialCoefficients(p0[1], p1[1], p2[1], p3[1]);
        this.a = [
            coeffx[0],
            coeffy[0]
        ];
        this.b = [
            coeffx[1],
            coeffy[1]
        ];
        this.c = [
            coeffx[2],
            coeffy[2]
        ];
        this.d = [
            coeffx[3],
            coeffy[3]
        ];
        this.points = [
            p0,
            p1,
            p2,
            p3
        ];
    }
    PolynomialBezier.prototype.point = function(t) {
        return [
            ((this.a[0] * t + this.b[0]) * t + this.c[0]) * t + this.d[0],
            ((this.a[1] * t + this.b[1]) * t + this.c[1]) * t + this.d[1]
        ];
    };
    PolynomialBezier.prototype.derivative = function(t) {
        return [
            (3 * t * this.a[0] + 2 * this.b[0]) * t + this.c[0],
            (3 * t * this.a[1] + 2 * this.b[1]) * t + this.c[1]
        ];
    };
    PolynomialBezier.prototype.tangentAngle = function(t) {
        var p = this.derivative(t);
        return Math.atan2(p[1], p[0]);
    };
    PolynomialBezier.prototype.normalAngle = function(t) {
        var p = this.derivative(t);
        return Math.atan2(p[0], p[1]);
    };
    PolynomialBezier.prototype.inflectionPoints = function() {
        var denom = this.a[1] * this.b[0] - this.a[0] * this.b[1];
        if (floatZero(denom)) return [];
        var tcusp = -0.5 * (this.a[1] * this.c[0] - this.a[0] * this.c[1]) / denom;
        var square = tcusp * tcusp - 1 / 3 * (this.b[1] * this.c[0] - this.b[0] * this.c[1]) / denom;
        if (square < 0) return [];
        var root = Math.sqrt(square);
        if (floatZero(root)) {
            if (root > 0 && root < 1) return [
                tcusp
            ];
            return [];
        }
        return [
            tcusp - root,
            tcusp + root
        ].filter(function(r) {
            return r > 0 && r < 1;
        });
    };
    PolynomialBezier.prototype.split = function(t) {
        if (t <= 0) return [
            singlePoint(this.points[0]),
            this
        ];
        if (t >= 1) return [
            this,
            singlePoint(this.points[this.points.length - 1])
        ];
        var p10 = lerpPoint(this.points[0], this.points[1], t);
        var p11 = lerpPoint(this.points[1], this.points[2], t);
        var p12 = lerpPoint(this.points[2], this.points[3], t);
        var p20 = lerpPoint(p10, p11, t);
        var p21 = lerpPoint(p11, p12, t);
        var p3 = lerpPoint(p20, p21, t);
        return [
            new PolynomialBezier(this.points[0], p10, p20, p3, true),
            new PolynomialBezier(p3, p21, p12, this.points[3], true)
        ];
    };
    function extrema(bez, comp) {
        var min = bez.points[0][comp];
        var max = bez.points[bez.points.length - 1][comp];
        if (min > max) {
            var e = max;
            max = min;
            min = e;
        } // Derivative roots to find min/max
        var f = quadRoots(3 * bez.a[comp], 2 * bez.b[comp], bez.c[comp]);
        for(var i = 0; i < f.length; i += 1)if (f[i] > 0 && f[i] < 1) {
            var val = bez.point(f[i])[comp];
            if (val < min) min = val;
            else if (val > max) max = val;
        }
        return {
            min: min,
            max: max
        };
    }
    PolynomialBezier.prototype.bounds = function() {
        return {
            x: extrema(this, 0),
            y: extrema(this, 1)
        };
    };
    PolynomialBezier.prototype.boundingBox = function() {
        var bounds = this.bounds();
        return {
            left: bounds.x.min,
            right: bounds.x.max,
            top: bounds.y.min,
            bottom: bounds.y.max,
            width: bounds.x.max - bounds.x.min,
            height: bounds.y.max - bounds.y.min,
            cx: (bounds.x.max + bounds.x.min) / 2,
            cy: (bounds.y.max + bounds.y.min) / 2
        };
    };
    function intersectData(bez, t1, t2) {
        var box = bez.boundingBox();
        return {
            cx: box.cx,
            cy: box.cy,
            width: box.width,
            height: box.height,
            bez: bez,
            t: (t1 + t2) / 2,
            t1: t1,
            t2: t2
        };
    }
    function splitData(data) {
        var split = data.bez.split(0.5);
        return [
            intersectData(split[0], data.t1, data.t),
            intersectData(split[1], data.t, data.t2)
        ];
    }
    function boxIntersect(b1, b2) {
        return Math.abs(b1.cx - b2.cx) * 2 < b1.width + b2.width && Math.abs(b1.cy - b2.cy) * 2 < b1.height + b2.height;
    }
    function intersectsImpl(d1, d2, depth, tolerance, intersections, maxRecursion) {
        if (!boxIntersect(d1, d2)) return;
        if (depth >= maxRecursion || d1.width <= tolerance && d1.height <= tolerance && d2.width <= tolerance && d2.height <= tolerance) {
            intersections.push([
                d1.t,
                d2.t
            ]);
            return;
        }
        var d1s = splitData(d1);
        var d2s = splitData(d2);
        intersectsImpl(d1s[0], d2s[0], depth + 1, tolerance, intersections, maxRecursion);
        intersectsImpl(d1s[0], d2s[1], depth + 1, tolerance, intersections, maxRecursion);
        intersectsImpl(d1s[1], d2s[0], depth + 1, tolerance, intersections, maxRecursion);
        intersectsImpl(d1s[1], d2s[1], depth + 1, tolerance, intersections, maxRecursion);
    }
    PolynomialBezier.prototype.intersections = function(other, tolerance, maxRecursion) {
        if (tolerance === undefined) tolerance = 2;
        if (maxRecursion === undefined) maxRecursion = 7;
        var intersections = [];
        intersectsImpl(intersectData(this, 0, 1), intersectData(other, 0, 1), 0, tolerance, intersections, maxRecursion);
        return intersections;
    };
    PolynomialBezier.shapeSegment = function(shapePath, index) {
        var nextIndex = (index + 1) % shapePath.length();
        return new PolynomialBezier(shapePath.v[index], shapePath.o[index], shapePath.i[nextIndex], shapePath.v[nextIndex], true);
    };
    PolynomialBezier.shapeSegmentInverted = function(shapePath, index) {
        var nextIndex = (index + 1) % shapePath.length();
        return new PolynomialBezier(shapePath.v[nextIndex], shapePath.i[nextIndex], shapePath.o[index], shapePath.v[index], true);
    };
    function crossProduct(a, b) {
        return [
            a[1] * b[2] - a[2] * b[1],
            a[2] * b[0] - a[0] * b[2],
            a[0] * b[1] - a[1] * b[0]
        ];
    }
    function lineIntersection(start1, end1, start2, end2) {
        var v1 = [
            start1[0],
            start1[1],
            1
        ];
        var v2 = [
            end1[0],
            end1[1],
            1
        ];
        var v3 = [
            start2[0],
            start2[1],
            1
        ];
        var v4 = [
            end2[0],
            end2[1],
            1
        ];
        var r = crossProduct(crossProduct(v1, v2), crossProduct(v3, v4));
        if (floatZero(r[2])) return null;
        return [
            r[0] / r[2],
            r[1] / r[2]
        ];
    }
    function polarOffset(p, angle, length) {
        return [
            p[0] + Math.cos(angle) * length,
            p[1] - Math.sin(angle) * length
        ];
    }
    function pointDistance(p1, p2) {
        return Math.hypot(p1[0] - p2[0], p1[1] - p2[1]);
    }
    function pointEqual(p1, p2) {
        return floatEqual(p1[0], p2[0]) && floatEqual(p1[1], p2[1]);
    }
    function ZigZagModifier() {}
    extendPrototype([
        ShapeModifier
    ], ZigZagModifier);
    ZigZagModifier.prototype.initModifierProperties = function(elem, data) {
        this.getValue = this.processKeys;
        this.amplitude = PropertyFactory.getProp(elem, data.s, 0, null, this);
        this.frequency = PropertyFactory.getProp(elem, data.r, 0, null, this);
        this.pointsType = PropertyFactory.getProp(elem, data.pt, 0, null, this);
        this._isAnimated = this.amplitude.effectsSequence.length !== 0 || this.frequency.effectsSequence.length !== 0 || this.pointsType.effectsSequence.length !== 0;
    };
    function setPoint(outputBezier, point, angle, direction, amplitude, outAmplitude, inAmplitude) {
        var angO = angle - Math.PI / 2;
        var angI = angle + Math.PI / 2;
        var px = point[0] + Math.cos(angle) * direction * amplitude;
        var py = point[1] - Math.sin(angle) * direction * amplitude;
        outputBezier.setTripleAt(px, py, px + Math.cos(angO) * outAmplitude, py - Math.sin(angO) * outAmplitude, px + Math.cos(angI) * inAmplitude, py - Math.sin(angI) * inAmplitude, outputBezier.length());
    }
    function getPerpendicularVector(pt1, pt2) {
        var vector = [
            pt2[0] - pt1[0],
            pt2[1] - pt1[1]
        ];
        var rot = -Math.PI * 0.5;
        var rotatedVector = [
            Math.cos(rot) * vector[0] - Math.sin(rot) * vector[1],
            Math.sin(rot) * vector[0] + Math.cos(rot) * vector[1]
        ];
        return rotatedVector;
    }
    function getProjectingAngle(path, cur) {
        var prevIndex = cur === 0 ? path.length() - 1 : cur - 1;
        var nextIndex = (cur + 1) % path.length();
        var prevPoint = path.v[prevIndex];
        var nextPoint = path.v[nextIndex];
        var pVector = getPerpendicularVector(prevPoint, nextPoint);
        return Math.atan2(0, 1) - Math.atan2(pVector[1], pVector[0]);
    }
    function zigZagCorner(outputBezier, path, cur, amplitude, frequency, pointType, direction) {
        var angle = getProjectingAngle(path, cur);
        var point = path.v[cur % path._length];
        var prevPoint = path.v[cur === 0 ? path._length - 1 : cur - 1];
        var nextPoint = path.v[(cur + 1) % path._length];
        var prevDist = pointType === 2 ? Math.sqrt(Math.pow(point[0] - prevPoint[0], 2) + Math.pow(point[1] - prevPoint[1], 2)) : 0;
        var nextDist = pointType === 2 ? Math.sqrt(Math.pow(point[0] - nextPoint[0], 2) + Math.pow(point[1] - nextPoint[1], 2)) : 0;
        setPoint(outputBezier, path.v[cur % path._length], angle, direction, amplitude, nextDist / ((frequency + 1) * 2), prevDist / ((frequency + 1) * 2), pointType);
    }
    function zigZagSegment(outputBezier, segment, amplitude, frequency, pointType, direction) {
        for(var i = 0; i < frequency; i += 1){
            var t = (i + 1) / (frequency + 1);
            var dist = pointType === 2 ? Math.sqrt(Math.pow(segment.points[3][0] - segment.points[0][0], 2) + Math.pow(segment.points[3][1] - segment.points[0][1], 2)) : 0;
            var angle = segment.normalAngle(t);
            var point = segment.point(t);
            setPoint(outputBezier, point, angle, direction, amplitude, dist / ((frequency + 1) * 2), dist / ((frequency + 1) * 2), pointType);
            direction = -direction;
        }
        return direction;
    }
    ZigZagModifier.prototype.processPath = function(path, amplitude, frequency, pointType) {
        var count = path._length;
        var clonedPath = shapePool.newElement();
        clonedPath.c = path.c;
        if (!path.c) count -= 1;
        if (count === 0) return clonedPath;
        var direction = -1;
        var segment = PolynomialBezier.shapeSegment(path, 0);
        zigZagCorner(clonedPath, path, 0, amplitude, frequency, pointType, direction);
        for(var i = 0; i < count; i += 1){
            direction = zigZagSegment(clonedPath, segment, amplitude, frequency, pointType, -direction);
            if (i === count - 1 && !path.c) segment = null;
            else segment = PolynomialBezier.shapeSegment(path, (i + 1) % count);
            zigZagCorner(clonedPath, path, i + 1, amplitude, frequency, pointType, direction);
        }
        return clonedPath;
    };
    ZigZagModifier.prototype.processShapes = function(_isFirstFrame) {
        var shapePaths;
        var i;
        var len = this.shapes.length;
        var j;
        var jLen;
        var amplitude = this.amplitude.v;
        var frequency = Math.max(0, Math.round(this.frequency.v));
        var pointType = this.pointsType.v;
        if (amplitude !== 0) {
            var shapeData;
            var localShapeCollection;
            for(i = 0; i < len; i += 1){
                shapeData = this.shapes[i];
                localShapeCollection = shapeData.localShapeCollection;
                if (!(!shapeData.shape._mdf && !this._mdf && !_isFirstFrame)) {
                    localShapeCollection.releaseShapes();
                    shapeData.shape._mdf = true;
                    shapePaths = shapeData.shape.paths.shapes;
                    jLen = shapeData.shape.paths._length;
                    for(j = 0; j < jLen; j += 1)localShapeCollection.addShape(this.processPath(shapePaths[j], amplitude, frequency, pointType));
                }
                shapeData.shape.paths = shapeData.localShapeCollection;
            }
        }
        if (!this.dynamicProperties.length) this._mdf = false;
    };
    function linearOffset(p1, p2, amount) {
        var angle = Math.atan2(p2[0] - p1[0], p2[1] - p1[1]);
        return [
            polarOffset(p1, angle, amount),
            polarOffset(p2, angle, amount)
        ];
    }
    function offsetSegment(segment, amount) {
        var p0;
        var p1a;
        var p1b;
        var p2b;
        var p2a;
        var p3;
        var e;
        e = linearOffset(segment.points[0], segment.points[1], amount);
        p0 = e[0];
        p1a = e[1];
        e = linearOffset(segment.points[1], segment.points[2], amount);
        p1b = e[0];
        p2b = e[1];
        e = linearOffset(segment.points[2], segment.points[3], amount);
        p2a = e[0];
        p3 = e[1];
        var p1 = lineIntersection(p0, p1a, p1b, p2b);
        if (p1 === null) p1 = p1a;
        var p2 = lineIntersection(p2a, p3, p1b, p2b);
        if (p2 === null) p2 = p2a;
        return new PolynomialBezier(p0, p1, p2, p3);
    }
    function joinLines(outputBezier, seg1, seg2, lineJoin, miterLimit) {
        var p0 = seg1.points[3];
        var p1 = seg2.points[0]; // Bevel
        if (lineJoin === 3) return p0; // Connected, they don't need a joint
        if (pointEqual(p0, p1)) return p0; // Round
        if (lineJoin === 2) {
            var angleOut = -seg1.tangentAngle(1);
            var angleIn = -seg2.tangentAngle(0) + Math.PI;
            var center = lineIntersection(p0, polarOffset(p0, angleOut + Math.PI / 2, 100), p1, polarOffset(p1, angleOut + Math.PI / 2, 100));
            var radius = center ? pointDistance(center, p0) : pointDistance(p0, p1) / 2;
            var tan = polarOffset(p0, angleOut, 2 * radius * roundCorner);
            outputBezier.setXYAt(tan[0], tan[1], "o", outputBezier.length() - 1);
            tan = polarOffset(p1, angleIn, 2 * radius * roundCorner);
            outputBezier.setTripleAt(p1[0], p1[1], p1[0], p1[1], tan[0], tan[1], outputBezier.length());
            return p1;
        } // Miter
        var t0 = pointEqual(p0, seg1.points[2]) ? seg1.points[0] : seg1.points[2];
        var t1 = pointEqual(p1, seg2.points[1]) ? seg2.points[3] : seg2.points[1];
        var intersection = lineIntersection(t0, p0, p1, t1);
        if (intersection && pointDistance(intersection, p0) < miterLimit) {
            outputBezier.setTripleAt(intersection[0], intersection[1], intersection[0], intersection[1], intersection[0], intersection[1], outputBezier.length());
            return intersection;
        }
        return p0;
    }
    function getIntersection(a, b) {
        var intersect = a.intersections(b);
        if (intersect.length && floatEqual(intersect[0][0], 1)) intersect.shift();
        if (intersect.length) return intersect[0];
        return null;
    }
    function pruneSegmentIntersection(a, b) {
        var outa = a.slice();
        var outb = b.slice();
        var intersect = getIntersection(a[a.length - 1], b[0]);
        if (intersect) {
            outa[a.length - 1] = a[a.length - 1].split(intersect[0])[0];
            outb[0] = b[0].split(intersect[1])[1];
        }
        if (a.length > 1 && b.length > 1) {
            intersect = getIntersection(a[0], b[b.length - 1]);
            if (intersect) return [
                [
                    a[0].split(intersect[0])[0]
                ],
                [
                    b[b.length - 1].split(intersect[1])[1]
                ]
            ];
        }
        return [
            outa,
            outb
        ];
    }
    function pruneIntersections(segments) {
        var e;
        for(var i = 1; i < segments.length; i += 1){
            e = pruneSegmentIntersection(segments[i - 1], segments[i]);
            segments[i - 1] = e[0];
            segments[i] = e[1];
        }
        if (segments.length > 1) {
            e = pruneSegmentIntersection(segments[segments.length - 1], segments[0]);
            segments[segments.length - 1] = e[0];
            segments[0] = e[1];
        }
        return segments;
    }
    function offsetSegmentSplit(segment, amount) {
        /*
      We split each bezier segment into smaller pieces based
      on inflection points, this ensures the control point
      polygon is convex.
        (A cubic bezier can have none, one, or two inflection points)
    */ var flex = segment.inflectionPoints();
        var left;
        var right;
        var split;
        var mid;
        if (flex.length === 0) return [
            offsetSegment(segment, amount)
        ];
        if (flex.length === 1 || floatEqual(flex[1], 1)) {
            split = segment.split(flex[0]);
            left = split[0];
            right = split[1];
            return [
                offsetSegment(left, amount),
                offsetSegment(right, amount)
            ];
        }
        split = segment.split(flex[0]);
        left = split[0];
        var t = (flex[1] - flex[0]) / (1 - flex[0]);
        split = split[1].split(t);
        mid = split[0];
        right = split[1];
        return [
            offsetSegment(left, amount),
            offsetSegment(mid, amount),
            offsetSegment(right, amount)
        ];
    }
    function OffsetPathModifier() {}
    extendPrototype([
        ShapeModifier
    ], OffsetPathModifier);
    OffsetPathModifier.prototype.initModifierProperties = function(elem, data) {
        this.getValue = this.processKeys;
        this.amount = PropertyFactory.getProp(elem, data.a, 0, null, this);
        this.miterLimit = PropertyFactory.getProp(elem, data.ml, 0, null, this);
        this.lineJoin = data.lj;
        this._isAnimated = this.amount.effectsSequence.length !== 0;
    };
    OffsetPathModifier.prototype.processPath = function(inputBezier, amount, lineJoin, miterLimit) {
        var outputBezier = shapePool.newElement();
        outputBezier.c = inputBezier.c;
        var count = inputBezier.length();
        if (!inputBezier.c) count -= 1;
        var i;
        var j;
        var segment;
        var multiSegments = [];
        for(i = 0; i < count; i += 1){
            segment = PolynomialBezier.shapeSegment(inputBezier, i);
            multiSegments.push(offsetSegmentSplit(segment, amount));
        }
        if (!inputBezier.c) for(i = count - 1; i >= 0; i -= 1){
            segment = PolynomialBezier.shapeSegmentInverted(inputBezier, i);
            multiSegments.push(offsetSegmentSplit(segment, amount));
        }
        multiSegments = pruneIntersections(multiSegments); // Add bezier segments to the output and apply line joints
        var lastPoint = null;
        var lastSeg = null;
        for(i = 0; i < multiSegments.length; i += 1){
            var multiSegment = multiSegments[i];
            if (lastSeg) lastPoint = joinLines(outputBezier, lastSeg, multiSegment[0], lineJoin, miterLimit);
            lastSeg = multiSegment[multiSegment.length - 1];
            for(j = 0; j < multiSegment.length; j += 1){
                segment = multiSegment[j];
                if (lastPoint && pointEqual(segment.points[0], lastPoint)) outputBezier.setXYAt(segment.points[1][0], segment.points[1][1], "o", outputBezier.length() - 1);
                else outputBezier.setTripleAt(segment.points[0][0], segment.points[0][1], segment.points[1][0], segment.points[1][1], segment.points[0][0], segment.points[0][1], outputBezier.length());
                outputBezier.setTripleAt(segment.points[3][0], segment.points[3][1], segment.points[3][0], segment.points[3][1], segment.points[2][0], segment.points[2][1], outputBezier.length());
                lastPoint = segment.points[3];
            }
        }
        if (multiSegments.length) joinLines(outputBezier, lastSeg, multiSegments[0][0], lineJoin, miterLimit);
        return outputBezier;
    };
    OffsetPathModifier.prototype.processShapes = function(_isFirstFrame) {
        var shapePaths;
        var i;
        var len = this.shapes.length;
        var j;
        var jLen;
        var amount = this.amount.v;
        var miterLimit = this.miterLimit.v;
        var lineJoin = this.lineJoin;
        if (amount !== 0) {
            var shapeData;
            var localShapeCollection;
            for(i = 0; i < len; i += 1){
                shapeData = this.shapes[i];
                localShapeCollection = shapeData.localShapeCollection;
                if (!(!shapeData.shape._mdf && !this._mdf && !_isFirstFrame)) {
                    localShapeCollection.releaseShapes();
                    shapeData.shape._mdf = true;
                    shapePaths = shapeData.shape.paths.shapes;
                    jLen = shapeData.shape.paths._length;
                    for(j = 0; j < jLen; j += 1)localShapeCollection.addShape(this.processPath(shapePaths[j], amount, lineJoin, miterLimit));
                }
                shapeData.shape.paths = shapeData.localShapeCollection;
            }
        }
        if (!this.dynamicProperties.length) this._mdf = false;
    };
    function getFontProperties(fontData) {
        var styles = fontData.fStyle ? fontData.fStyle.split(" ") : [];
        var fWeight = "normal";
        var fStyle = "normal";
        var len = styles.length;
        var styleName;
        for(var i = 0; i < len; i += 1){
            styleName = styles[i].toLowerCase();
            switch(styleName){
                case "italic":
                    fStyle = "italic";
                    break;
                case "bold":
                    fWeight = "700";
                    break;
                case "black":
                    fWeight = "900";
                    break;
                case "medium":
                    fWeight = "500";
                    break;
                case "regular":
                case "normal":
                    fWeight = "400";
                    break;
                case "light":
                case "thin":
                    fWeight = "200";
                    break;
                default:
                    break;
            }
        }
        return {
            style: fStyle,
            weight: fontData.fWeight || fWeight
        };
    }
    var FontManager = function() {
        var maxWaitingTime = 5000;
        var emptyChar = {
            w: 0,
            size: 0,
            shapes: [],
            data: {
                shapes: []
            }
        };
        var combinedCharacters = []; // Hindi characters
        combinedCharacters = combinedCharacters.concat([
            2304,
            2305,
            2306,
            2307,
            2362,
            2363,
            2364,
            2364,
            2366,
            2367,
            2368,
            2369,
            2370,
            2371,
            2372,
            2373,
            2374,
            2375,
            2376,
            2377,
            2378,
            2379,
            2380,
            2381,
            2382,
            2383,
            2387,
            2388,
            2389,
            2390,
            2391,
            2402,
            2403
        ]);
        var BLACK_FLAG_CODE_POINT = 127988;
        var CANCEL_TAG_CODE_POINT = 917631;
        var A_TAG_CODE_POINT = 917601;
        var Z_TAG_CODE_POINT = 917626;
        var VARIATION_SELECTOR_16_CODE_POINT = 65039;
        var ZERO_WIDTH_JOINER_CODE_POINT = 8205;
        var REGIONAL_CHARACTER_A_CODE_POINT = 127462;
        var REGIONAL_CHARACTER_Z_CODE_POINT = 127487;
        var surrogateModifiers = [
            "d83cdffb",
            "d83cdffc",
            "d83cdffd",
            "d83cdffe",
            "d83cdfff"
        ];
        function trimFontOptions(font) {
            var familyArray = font.split(",");
            var i;
            var len = familyArray.length;
            var enabledFamilies = [];
            for(i = 0; i < len; i += 1)if (familyArray[i] !== "sans-serif" && familyArray[i] !== "monospace") enabledFamilies.push(familyArray[i]);
            return enabledFamilies.join(",");
        }
        function setUpNode(font, family) {
            var parentNode = createTag("span"); // Node is invisible to screen readers.
            parentNode.setAttribute("aria-hidden", true);
            parentNode.style.fontFamily = family;
            var node = createTag("span"); // Characters that vary significantly among different fonts
            node.innerText = "giItT1WQy@!-/#"; // Visible - so we can measure it - but not on the screen
            parentNode.style.position = "absolute";
            parentNode.style.left = "-10000px";
            parentNode.style.top = "-10000px"; // Large font size makes even subtle changes obvious
            parentNode.style.fontSize = "300px"; // Reset any font properties
            parentNode.style.fontVariant = "normal";
            parentNode.style.fontStyle = "normal";
            parentNode.style.fontWeight = "normal";
            parentNode.style.letterSpacing = "0";
            parentNode.appendChild(node);
            document.body.appendChild(parentNode); // Remember width with no applied web font
            var width = node.offsetWidth;
            node.style.fontFamily = trimFontOptions(font) + ", " + family;
            return {
                node: node,
                w: width,
                parent: parentNode
            };
        }
        function checkLoadedFonts() {
            var i;
            var len = this.fonts.length;
            var node;
            var w;
            var loadedCount = len;
            for(i = 0; i < len; i += 1){
                if (this.fonts[i].loaded) loadedCount -= 1;
                else if (this.fonts[i].fOrigin === "n" || this.fonts[i].origin === 0) this.fonts[i].loaded = true;
                else {
                    node = this.fonts[i].monoCase.node;
                    w = this.fonts[i].monoCase.w;
                    if (node.offsetWidth !== w) {
                        loadedCount -= 1;
                        this.fonts[i].loaded = true;
                    } else {
                        node = this.fonts[i].sansCase.node;
                        w = this.fonts[i].sansCase.w;
                        if (node.offsetWidth !== w) {
                            loadedCount -= 1;
                            this.fonts[i].loaded = true;
                        }
                    }
                    if (this.fonts[i].loaded) {
                        this.fonts[i].sansCase.parent.parentNode.removeChild(this.fonts[i].sansCase.parent);
                        this.fonts[i].monoCase.parent.parentNode.removeChild(this.fonts[i].monoCase.parent);
                    }
                }
            }
            if (loadedCount !== 0 && Date.now() - this.initTime < maxWaitingTime) setTimeout(this.checkLoadedFontsBinded, 20);
            else setTimeout(this.setIsLoadedBinded, 10);
        }
        function createHelper(fontData, def) {
            var engine = document.body && def ? "svg" : "canvas";
            var helper;
            var fontProps = getFontProperties(fontData);
            if (engine === "svg") {
                var tHelper = createNS("text");
                tHelper.style.fontSize = "100px"; // tHelper.style.fontFamily = fontData.fFamily;
                tHelper.setAttribute("font-family", fontData.fFamily);
                tHelper.setAttribute("font-style", fontProps.style);
                tHelper.setAttribute("font-weight", fontProps.weight);
                tHelper.textContent = "1";
                if (fontData.fClass) {
                    tHelper.style.fontFamily = "inherit";
                    tHelper.setAttribute("class", fontData.fClass);
                } else tHelper.style.fontFamily = fontData.fFamily;
                def.appendChild(tHelper);
                helper = tHelper;
            } else {
                var tCanvasHelper = new OffscreenCanvas(500, 500).getContext("2d");
                tCanvasHelper.font = fontProps.style + " " + fontProps.weight + " 100px " + fontData.fFamily;
                helper = tCanvasHelper;
            }
            function measure(text) {
                if (engine === "svg") {
                    helper.textContent = text;
                    return helper.getComputedTextLength();
                }
                return helper.measureText(text).width;
            }
            return {
                measureText: measure
            };
        }
        function addFonts(fontData, defs) {
            if (!fontData) {
                this.isLoaded = true;
                return;
            }
            if (this.chars) {
                this.isLoaded = true;
                this.fonts = fontData.list;
                return;
            }
            if (!document.body) {
                this.isLoaded = true;
                fontData.list.forEach(function(data) {
                    data.helper = createHelper(data);
                    data.cache = {};
                });
                this.fonts = fontData.list;
                return;
            }
            var fontArr = fontData.list;
            var i;
            var len = fontArr.length;
            var _pendingFonts = len;
            for(i = 0; i < len; i += 1){
                var shouldLoadFont = true;
                var loadedSelector;
                var j;
                fontArr[i].loaded = false;
                fontArr[i].monoCase = setUpNode(fontArr[i].fFamily, "monospace");
                fontArr[i].sansCase = setUpNode(fontArr[i].fFamily, "sans-serif");
                if (!fontArr[i].fPath) {
                    fontArr[i].loaded = true;
                    _pendingFonts -= 1;
                } else if (fontArr[i].fOrigin === "p" || fontArr[i].origin === 3) {
                    loadedSelector = document.querySelectorAll('style[f-forigin="p"][f-family="' + fontArr[i].fFamily + '"], style[f-origin="3"][f-family="' + fontArr[i].fFamily + '"]');
                    if (loadedSelector.length > 0) shouldLoadFont = false;
                    if (shouldLoadFont) {
                        var s = createTag("style");
                        s.setAttribute("f-forigin", fontArr[i].fOrigin);
                        s.setAttribute("f-origin", fontArr[i].origin);
                        s.setAttribute("f-family", fontArr[i].fFamily);
                        s.type = "text/css";
                        s.innerText = "@font-face {font-family: " + fontArr[i].fFamily + "; font-style: normal; src: url('" + fontArr[i].fPath + "');}";
                        defs.appendChild(s);
                    }
                } else if (fontArr[i].fOrigin === "g" || fontArr[i].origin === 1) {
                    loadedSelector = document.querySelectorAll('link[f-forigin="g"], link[f-origin="1"]');
                    for(j = 0; j < loadedSelector.length; j += 1)if (loadedSelector[j].href.indexOf(fontArr[i].fPath) !== -1) // Font is already loaded
                    shouldLoadFont = false;
                    if (shouldLoadFont) {
                        var l = createTag("link");
                        l.setAttribute("f-forigin", fontArr[i].fOrigin);
                        l.setAttribute("f-origin", fontArr[i].origin);
                        l.type = "text/css";
                        l.rel = "stylesheet";
                        l.href = fontArr[i].fPath;
                        document.body.appendChild(l);
                    }
                } else if (fontArr[i].fOrigin === "t" || fontArr[i].origin === 2) {
                    loadedSelector = document.querySelectorAll('script[f-forigin="t"], script[f-origin="2"]');
                    for(j = 0; j < loadedSelector.length; j += 1)if (fontArr[i].fPath === loadedSelector[j].src) // Font is already loaded
                    shouldLoadFont = false;
                    if (shouldLoadFont) {
                        var sc = createTag("link");
                        sc.setAttribute("f-forigin", fontArr[i].fOrigin);
                        sc.setAttribute("f-origin", fontArr[i].origin);
                        sc.setAttribute("rel", "stylesheet");
                        sc.setAttribute("href", fontArr[i].fPath);
                        defs.appendChild(sc);
                    }
                }
                fontArr[i].helper = createHelper(fontArr[i], defs);
                fontArr[i].cache = {};
                this.fonts.push(fontArr[i]);
            }
            if (_pendingFonts === 0) this.isLoaded = true;
            else // On some cases even if the font is loaded, it won't load correctly when measuring text on canvas.
            // Adding this timeout seems to fix it
            setTimeout(this.checkLoadedFonts.bind(this), 100);
        }
        function addChars(chars) {
            if (!chars) return;
            if (!this.chars) this.chars = [];
            var i;
            var len = chars.length;
            var j;
            var jLen = this.chars.length;
            var found;
            for(i = 0; i < len; i += 1){
                j = 0;
                found = false;
                while(j < jLen){
                    if (this.chars[j].style === chars[i].style && this.chars[j].fFamily === chars[i].fFamily && this.chars[j].ch === chars[i].ch) found = true;
                    j += 1;
                }
                if (!found) {
                    this.chars.push(chars[i]);
                    jLen += 1;
                }
            }
        }
        function getCharData(_char, style, font) {
            var i = 0;
            var len = this.chars.length;
            while(i < len){
                if (this.chars[i].ch === _char && this.chars[i].style === style && this.chars[i].fFamily === font) return this.chars[i];
                i += 1;
            }
            if ((typeof _char === "string" && _char.charCodeAt(0) !== 13 || !_char) && console && console.warn // eslint-disable-line no-console
             && !this._warned) {
                this._warned = true;
                console.warn("Missing character from exported characters list: ", _char, style, font); // eslint-disable-line no-console
            }
            return emptyChar;
        }
        function measureText(_char2, fontName, size) {
            var fontData = this.getFontByName(fontName); // Using the char instead of char.charCodeAt(0)
            // to avoid collisions between equal chars
            var index = _char2;
            if (!fontData.cache[index]) {
                var tHelper = fontData.helper;
                if (_char2 === " ") {
                    var doubleSize = tHelper.measureText("|" + _char2 + "|");
                    var singleSize = tHelper.measureText("||");
                    fontData.cache[index] = (doubleSize - singleSize) / 100;
                } else fontData.cache[index] = tHelper.measureText(_char2) / 100;
            }
            return fontData.cache[index] * size;
        }
        function getFontByName(name) {
            var i = 0;
            var len = this.fonts.length;
            while(i < len){
                if (this.fonts[i].fName === name) return this.fonts[i];
                i += 1;
            }
            return this.fonts[0];
        }
        function getCodePoint(string) {
            var codePoint = 0;
            var first = string.charCodeAt(0);
            if (first >= 0xD800 && first <= 0xDBFF) {
                var second = string.charCodeAt(1);
                if (second >= 0xDC00 && second <= 0xDFFF) codePoint = (first - 0xD800) * 0x400 + second - 0xDC00 + 0x10000;
            }
            return codePoint;
        } // Skin tone modifiers
        function isModifier(firstCharCode, secondCharCode) {
            var sum = firstCharCode.toString(16) + secondCharCode.toString(16);
            return surrogateModifiers.indexOf(sum) !== -1;
        }
        function isZeroWidthJoiner(charCode) {
            return charCode === ZERO_WIDTH_JOINER_CODE_POINT;
        } // This codepoint may change the appearance of the preceding character.
        // If that is a symbol, dingbat or emoji, U+FE0F forces it to be rendered
        // as a colorful image as compared to a monochrome text variant.
        function isVariationSelector(charCode) {
            return charCode === VARIATION_SELECTOR_16_CODE_POINT;
        } // The regional indicator symbols are a set of 26 alphabetic Unicode
        /// characters (A–Z) intended to be used to encode ISO 3166-1 alpha-2
        // two-letter country codes in a way that allows optional special treatment.
        function isRegionalCode(string) {
            var codePoint = getCodePoint(string);
            if (codePoint >= REGIONAL_CHARACTER_A_CODE_POINT && codePoint <= REGIONAL_CHARACTER_Z_CODE_POINT) return true;
            return false;
        } // Some Emoji implementations represent combinations of
        // two “regional indicator” letters as a single flag symbol.
        function isFlagEmoji(string) {
            return isRegionalCode(string.substr(0, 2)) && isRegionalCode(string.substr(2, 2));
        }
        function isCombinedCharacter(_char3) {
            return combinedCharacters.indexOf(_char3) !== -1;
        } // Regional flags start with a BLACK_FLAG_CODE_POINT
        // folowed by 5 chars in the TAG range
        // and end with a CANCEL_TAG_CODE_POINT
        function isRegionalFlag(text, index) {
            var codePoint = getCodePoint(text.substr(index, 2));
            if (codePoint !== BLACK_FLAG_CODE_POINT) return false;
            var count = 0;
            index += 2;
            while(count < 5){
                codePoint = getCodePoint(text.substr(index, 2));
                if (codePoint < A_TAG_CODE_POINT || codePoint > Z_TAG_CODE_POINT) return false;
                count += 1;
                index += 2;
            }
            return getCodePoint(text.substr(index, 2)) === CANCEL_TAG_CODE_POINT;
        }
        function setIsLoaded() {
            this.isLoaded = true;
        }
        var Font = function Font() {
            this.fonts = [];
            this.chars = null;
            this.typekitLoaded = 0;
            this.isLoaded = false;
            this._warned = false;
            this.initTime = Date.now();
            this.setIsLoadedBinded = this.setIsLoaded.bind(this);
            this.checkLoadedFontsBinded = this.checkLoadedFonts.bind(this);
        };
        Font.isModifier = isModifier;
        Font.isZeroWidthJoiner = isZeroWidthJoiner;
        Font.isFlagEmoji = isFlagEmoji;
        Font.isRegionalCode = isRegionalCode;
        Font.isCombinedCharacter = isCombinedCharacter;
        Font.isRegionalFlag = isRegionalFlag;
        Font.isVariationSelector = isVariationSelector;
        Font.BLACK_FLAG_CODE_POINT = BLACK_FLAG_CODE_POINT;
        var fontPrototype = {
            addChars: addChars,
            addFonts: addFonts,
            getCharData: getCharData,
            getFontByName: getFontByName,
            measureText: measureText,
            checkLoadedFonts: checkLoadedFonts,
            setIsLoaded: setIsLoaded
        };
        Font.prototype = fontPrototype;
        return Font;
    }();
    function SlotManager(animationData) {
        this.animationData = animationData;
    }
    SlotManager.prototype.getProp = function(data) {
        if (this.animationData.slots && this.animationData.slots[data.sid]) return Object.assign(data, this.animationData.slots[data.sid].p);
        return data;
    };
    function slotFactory(animationData) {
        return new SlotManager(animationData);
    }
    function RenderableElement() {}
    RenderableElement.prototype = {
        initRenderable: function initRenderable() {
            // layer's visibility related to inpoint and outpoint. Rename isVisible to isInRange
            this.isInRange = false; // layer's display state
            this.hidden = false; // If layer's transparency equals 0, it can be hidden
            this.isTransparent = false; // list of animated components
            this.renderableComponents = [];
        },
        addRenderableComponent: function addRenderableComponent(component) {
            if (this.renderableComponents.indexOf(component) === -1) this.renderableComponents.push(component);
        },
        removeRenderableComponent: function removeRenderableComponent(component) {
            if (this.renderableComponents.indexOf(component) !== -1) this.renderableComponents.splice(this.renderableComponents.indexOf(component), 1);
        },
        prepareRenderableFrame: function prepareRenderableFrame(num) {
            this.checkLayerLimits(num);
        },
        checkTransparency: function checkTransparency() {
            if (this.finalTransform.mProp.o.v <= 0) {
                if (!this.isTransparent && this.globalData.renderConfig.hideOnTransparent) {
                    this.isTransparent = true;
                    this.hide();
                }
            } else if (this.isTransparent) {
                this.isTransparent = false;
                this.show();
            }
        },
        /**
       * @function
       * Initializes frame related properties.
       *
       * @param {number} num
       * current frame number in Layer's time
       *
       */ checkLayerLimits: function checkLayerLimits(num) {
            if (this.data.ip - this.data.st <= num && this.data.op - this.data.st > num) {
                if (this.isInRange !== true) {
                    this.globalData._mdf = true;
                    this._mdf = true;
                    this.isInRange = true;
                    this.show();
                }
            } else if (this.isInRange !== false) {
                this.globalData._mdf = true;
                this.isInRange = false;
                this.hide();
            }
        },
        renderRenderable: function renderRenderable() {
            var i;
            var len = this.renderableComponents.length;
            for(i = 0; i < len; i += 1)this.renderableComponents[i].renderFrame(this._isFirstFrame);
        /* this.maskManager.renderFrame(this.finalTransform.mat);
          this.renderableEffectsManager.renderFrame(this._isFirstFrame); */ },
        sourceRectAtTime: function sourceRectAtTime() {
            return {
                top: 0,
                left: 0,
                width: 100,
                height: 100
            };
        },
        getLayerSize: function getLayerSize() {
            if (this.data.ty === 5) return {
                w: this.data.textData.width,
                h: this.data.textData.height
            };
            return {
                w: this.data.width,
                h: this.data.height
            };
        }
    };
    var getBlendMode = function() {
        var blendModeEnums = {
            0: "source-over",
            1: "multiply",
            2: "screen",
            3: "overlay",
            4: "darken",
            5: "lighten",
            6: "color-dodge",
            7: "color-burn",
            8: "hard-light",
            9: "soft-light",
            10: "difference",
            11: "exclusion",
            12: "hue",
            13: "saturation",
            14: "color",
            15: "luminosity"
        };
        return function(mode) {
            return blendModeEnums[mode] || "";
        };
    }();
    function SliderEffect(data, elem, container) {
        this.p = PropertyFactory.getProp(elem, data.v, 0, 0, container);
    }
    function AngleEffect(data, elem, container) {
        this.p = PropertyFactory.getProp(elem, data.v, 0, 0, container);
    }
    function ColorEffect(data, elem, container) {
        this.p = PropertyFactory.getProp(elem, data.v, 1, 0, container);
    }
    function PointEffect(data, elem, container) {
        this.p = PropertyFactory.getProp(elem, data.v, 1, 0, container);
    }
    function LayerIndexEffect(data, elem, container) {
        this.p = PropertyFactory.getProp(elem, data.v, 0, 0, container);
    }
    function MaskIndexEffect(data, elem, container) {
        this.p = PropertyFactory.getProp(elem, data.v, 0, 0, container);
    }
    function CheckboxEffect(data, elem, container) {
        this.p = PropertyFactory.getProp(elem, data.v, 0, 0, container);
    }
    function NoValueEffect() {
        this.p = {};
    }
    function EffectsManager(data, element) {
        var effects = data.ef || [];
        this.effectElements = [];
        var i;
        var len = effects.length;
        var effectItem;
        for(i = 0; i < len; i += 1){
            effectItem = new GroupEffect(effects[i], element);
            this.effectElements.push(effectItem);
        }
    }
    function GroupEffect(data, element) {
        this.init(data, element);
    }
    extendPrototype([
        DynamicPropertyContainer
    ], GroupEffect);
    GroupEffect.prototype.getValue = GroupEffect.prototype.iterateDynamicProperties;
    GroupEffect.prototype.init = function(data, element) {
        this.data = data;
        this.effectElements = [];
        this.initDynamicPropertyContainer(element);
        var i;
        var len = this.data.ef.length;
        var eff;
        var effects = this.data.ef;
        for(i = 0; i < len; i += 1){
            eff = null;
            switch(effects[i].ty){
                case 0:
                    eff = new SliderEffect(effects[i], element, this);
                    break;
                case 1:
                    eff = new AngleEffect(effects[i], element, this);
                    break;
                case 2:
                    eff = new ColorEffect(effects[i], element, this);
                    break;
                case 3:
                    eff = new PointEffect(effects[i], element, this);
                    break;
                case 4:
                case 7:
                    eff = new CheckboxEffect(effects[i], element, this);
                    break;
                case 10:
                    eff = new LayerIndexEffect(effects[i], element, this);
                    break;
                case 11:
                    eff = new MaskIndexEffect(effects[i], element, this);
                    break;
                case 5:
                    eff = new EffectsManager(effects[i], element, this);
                    break;
                // case 6:
                default:
                    eff = new NoValueEffect(effects[i], element, this);
                    break;
            }
            if (eff) this.effectElements.push(eff);
        }
    };
    function BaseElement() {}
    BaseElement.prototype = {
        checkMasks: function checkMasks() {
            if (!this.data.hasMask) return false;
            var i = 0;
            var len = this.data.masksProperties.length;
            while(i < len){
                if (this.data.masksProperties[i].mode !== "n" && this.data.masksProperties[i].cl !== false) return true;
                i += 1;
            }
            return false;
        },
        initExpressions: function initExpressions() {
            var expressionsInterfaces = getExpressionInterfaces();
            if (!expressionsInterfaces) return;
            var LayerExpressionInterface = expressionsInterfaces("layer");
            var EffectsExpressionInterface = expressionsInterfaces("effects");
            var ShapeExpressionInterface = expressionsInterfaces("shape");
            var TextExpressionInterface = expressionsInterfaces("text");
            var CompExpressionInterface = expressionsInterfaces("comp");
            this.layerInterface = LayerExpressionInterface(this);
            if (this.data.hasMask && this.maskManager) this.layerInterface.registerMaskInterface(this.maskManager);
            var effectsInterface = EffectsExpressionInterface.createEffectsInterface(this, this.layerInterface);
            this.layerInterface.registerEffectsInterface(effectsInterface);
            if (this.data.ty === 0 || this.data.xt) this.compInterface = CompExpressionInterface(this);
            else if (this.data.ty === 4) {
                this.layerInterface.shapeInterface = ShapeExpressionInterface(this.shapesData, this.itemsData, this.layerInterface);
                this.layerInterface.content = this.layerInterface.shapeInterface;
            } else if (this.data.ty === 5) {
                this.layerInterface.textInterface = TextExpressionInterface(this);
                this.layerInterface.text = this.layerInterface.textInterface;
            }
        },
        setBlendMode: function setBlendMode() {
            var blendModeValue = getBlendMode(this.data.bm);
            var elem = this.baseElement || this.layerElement;
            elem.style["mix-blend-mode"] = blendModeValue;
        },
        initBaseData: function initBaseData(data, globalData, comp) {
            this.globalData = globalData;
            this.comp = comp;
            this.data = data;
            this.layerId = createElementID(); // Stretch factor for old animations missing this property.
            if (!this.data.sr) this.data.sr = 1;
             // effects manager
            this.effectsManager = new EffectsManager(this.data, this, this.dynamicProperties);
        },
        getType: function getType() {
            return this.type;
        },
        sourceRectAtTime: function sourceRectAtTime() {}
    };
    /**
   * @file
   * Handles element's layer frame update.
   * Checks layer in point and out point
   *
   */ function FrameElement() {}
    FrameElement.prototype = {
        /**
       * @function
       * Initializes frame related properties.
       *
       */ initFrame: function initFrame() {
            // set to true when inpoint is rendered
            this._isFirstFrame = false; // list of animated properties
            this.dynamicProperties = []; // If layer has been modified in current tick this will be true
            this._mdf = false;
        },
        /**
       * @function
       * Calculates all dynamic values
       *
       * @param {number} num
       * current frame number in Layer's time
       * @param {boolean} isVisible
       * if layers is currently in range
       *
       */ prepareProperties: function prepareProperties(num, isVisible) {
            var i;
            var len = this.dynamicProperties.length;
            for(i = 0; i < len; i += 1)if (isVisible || this._isParent && this.dynamicProperties[i].propType === "transform") {
                this.dynamicProperties[i].getValue();
                if (this.dynamicProperties[i]._mdf) {
                    this.globalData._mdf = true;
                    this._mdf = true;
                }
            }
        },
        addDynamicProperty: function addDynamicProperty(prop) {
            if (this.dynamicProperties.indexOf(prop) === -1) this.dynamicProperties.push(prop);
        }
    };
    function FootageElement(data, globalData, comp) {
        this.initFrame();
        this.initRenderable();
        this.assetData = globalData.getAssetData(data.refId);
        this.footageData = globalData.imageLoader.getAsset(this.assetData);
        this.initBaseData(data, globalData, comp);
    }
    FootageElement.prototype.prepareFrame = function() {};
    extendPrototype([
        RenderableElement,
        BaseElement,
        FrameElement
    ], FootageElement);
    FootageElement.prototype.getBaseElement = function() {
        return null;
    };
    FootageElement.prototype.renderFrame = function() {};
    FootageElement.prototype.destroy = function() {};
    FootageElement.prototype.initExpressions = function() {
        var expressionsInterfaces = getExpressionInterfaces();
        if (!expressionsInterfaces) return;
        var FootageInterface = expressionsInterfaces("footage");
        this.layerInterface = FootageInterface(this);
    };
    FootageElement.prototype.getFootageData = function() {
        return this.footageData;
    };
    function AudioElement(data, globalData, comp) {
        this.initFrame();
        this.initRenderable();
        this.assetData = globalData.getAssetData(data.refId);
        this.initBaseData(data, globalData, comp);
        this._isPlaying = false;
        this._canPlay = false;
        var assetPath = this.globalData.getAssetsPath(this.assetData);
        this.audio = this.globalData.audioController.createAudio(assetPath);
        this._currentTime = 0;
        this.globalData.audioController.addAudio(this);
        this._volumeMultiplier = 1;
        this._volume = 1;
        this._previousVolume = null;
        this.tm = data.tm ? PropertyFactory.getProp(this, data.tm, 0, globalData.frameRate, this) : {
            _placeholder: true
        };
        this.lv = PropertyFactory.getProp(this, data.au && data.au.lv ? data.au.lv : {
            k: [
                100
            ]
        }, 1, 0.01, this);
    }
    AudioElement.prototype.prepareFrame = function(num) {
        this.prepareRenderableFrame(num, true);
        this.prepareProperties(num, true);
        if (!this.tm._placeholder) {
            var timeRemapped = this.tm.v;
            this._currentTime = timeRemapped;
        } else this._currentTime = num / this.data.sr;
        this._volume = this.lv.v[0];
        var totalVolume = this._volume * this._volumeMultiplier;
        if (this._previousVolume !== totalVolume) {
            this._previousVolume = totalVolume;
            this.audio.volume(totalVolume);
        }
    };
    extendPrototype([
        RenderableElement,
        BaseElement,
        FrameElement
    ], AudioElement);
    AudioElement.prototype.renderFrame = function() {
        if (this.isInRange && this._canPlay) {
            if (!this._isPlaying) {
                this.audio.play();
                this.audio.seek(this._currentTime / this.globalData.frameRate);
                this._isPlaying = true;
            } else if (!this.audio.playing() || Math.abs(this._currentTime / this.globalData.frameRate - this.audio.seek()) > 0.1) this.audio.seek(this._currentTime / this.globalData.frameRate);
        }
    };
    AudioElement.prototype.show = function() {};
    AudioElement.prototype.hide = function() {
        this.audio.pause();
        this._isPlaying = false;
    };
    AudioElement.prototype.pause = function() {
        this.audio.pause();
        this._isPlaying = false;
        this._canPlay = false;
    };
    AudioElement.prototype.resume = function() {
        this._canPlay = true;
    };
    AudioElement.prototype.setRate = function(rateValue) {
        this.audio.rate(rateValue);
    };
    AudioElement.prototype.volume = function(volumeValue) {
        this._volumeMultiplier = volumeValue;
        this._previousVolume = volumeValue * this._volume;
        this.audio.volume(this._previousVolume);
    };
    AudioElement.prototype.getBaseElement = function() {
        return null;
    };
    AudioElement.prototype.destroy = function() {};
    AudioElement.prototype.sourceRectAtTime = function() {};
    AudioElement.prototype.initExpressions = function() {};
    function BaseRenderer() {}
    BaseRenderer.prototype.checkLayers = function(num) {
        var i;
        var len = this.layers.length;
        var data;
        this.completeLayers = true;
        for(i = len - 1; i >= 0; i -= 1){
            if (!this.elements[i]) {
                data = this.layers[i];
                if (data.ip - data.st <= num - this.layers[i].st && data.op - data.st > num - this.layers[i].st) this.buildItem(i);
            }
            this.completeLayers = this.elements[i] ? this.completeLayers : false;
        }
        this.checkPendingElements();
    };
    BaseRenderer.prototype.createItem = function(layer) {
        switch(layer.ty){
            case 2:
                return this.createImage(layer);
            case 0:
                return this.createComp(layer);
            case 1:
                return this.createSolid(layer);
            case 3:
                return this.createNull(layer);
            case 4:
                return this.createShape(layer);
            case 5:
                return this.createText(layer);
            case 6:
                return this.createAudio(layer);
            case 13:
                return this.createCamera(layer);
            case 15:
                return this.createFootage(layer);
            default:
                return this.createNull(layer);
        }
    };
    BaseRenderer.prototype.createCamera = function() {
        throw new Error("You're using a 3d camera. Try the html renderer.");
    };
    BaseRenderer.prototype.createAudio = function(data) {
        return new AudioElement(data, this.globalData, this);
    };
    BaseRenderer.prototype.createFootage = function(data) {
        return new FootageElement(data, this.globalData, this);
    };
    BaseRenderer.prototype.buildAllItems = function() {
        var i;
        var len = this.layers.length;
        for(i = 0; i < len; i += 1)this.buildItem(i);
        this.checkPendingElements();
    };
    BaseRenderer.prototype.includeLayers = function(newLayers) {
        this.completeLayers = false;
        var i;
        var len = newLayers.length;
        var j;
        var jLen = this.layers.length;
        for(i = 0; i < len; i += 1){
            j = 0;
            while(j < jLen){
                if (this.layers[j].id === newLayers[i].id) {
                    this.layers[j] = newLayers[i];
                    break;
                }
                j += 1;
            }
        }
    };
    BaseRenderer.prototype.setProjectInterface = function(pInterface) {
        this.globalData.projectInterface = pInterface;
    };
    BaseRenderer.prototype.initItems = function() {
        if (!this.globalData.progressiveLoad) this.buildAllItems();
    };
    BaseRenderer.prototype.buildElementParenting = function(element, parentName, hierarchy) {
        var elements = this.elements;
        var layers = this.layers;
        var i = 0;
        var len = layers.length;
        while(i < len){
            if (layers[i].ind == parentName) {
                // eslint-disable-line eqeqeq
                if (!elements[i] || elements[i] === true) {
                    this.buildItem(i);
                    this.addPendingElement(element);
                } else {
                    hierarchy.push(elements[i]);
                    elements[i].setAsParent();
                    if (layers[i].parent !== undefined) this.buildElementParenting(element, layers[i].parent, hierarchy);
                    else element.setHierarchy(hierarchy);
                }
            }
            i += 1;
        }
    };
    BaseRenderer.prototype.addPendingElement = function(element) {
        this.pendingElements.push(element);
    };
    BaseRenderer.prototype.searchExtraCompositions = function(assets) {
        var i;
        var len = assets.length;
        for(i = 0; i < len; i += 1)if (assets[i].xt) {
            var comp = this.createComp(assets[i]);
            comp.initExpressions();
            this.globalData.projectInterface.registerComposition(comp);
        }
    };
    BaseRenderer.prototype.getElementById = function(ind) {
        var i;
        var len = this.elements.length;
        for(i = 0; i < len; i += 1){
            if (this.elements[i].data.ind === ind) return this.elements[i];
        }
        return null;
    };
    BaseRenderer.prototype.getElementByPath = function(path) {
        var pathValue = path.shift();
        var element;
        if (typeof pathValue === "number") element = this.elements[pathValue];
        else {
            var i;
            var len = this.elements.length;
            for(i = 0; i < len; i += 1)if (this.elements[i].data.nm === pathValue) {
                element = this.elements[i];
                break;
            }
        }
        if (path.length === 0) return element;
        return element.getElementByPath(path);
    };
    BaseRenderer.prototype.setupGlobalData = function(animData, fontsContainer) {
        this.globalData.fontManager = new FontManager();
        this.globalData.slotManager = slotFactory(animData);
        this.globalData.fontManager.addChars(animData.chars);
        this.globalData.fontManager.addFonts(animData.fonts, fontsContainer);
        this.globalData.getAssetData = this.animationItem.getAssetData.bind(this.animationItem);
        this.globalData.getAssetsPath = this.animationItem.getAssetsPath.bind(this.animationItem);
        this.globalData.imageLoader = this.animationItem.imagePreloader;
        this.globalData.audioController = this.animationItem.audioController;
        this.globalData.frameId = 0;
        this.globalData.frameRate = animData.fr;
        this.globalData.nm = animData.nm;
        this.globalData.compSize = {
            w: animData.w,
            h: animData.h
        };
    };
    var effectTypes = {
        TRANSFORM_EFFECT: "transformEFfect"
    };
    function TransformElement() {}
    TransformElement.prototype = {
        initTransform: function initTransform() {
            var mat = new Matrix();
            this.finalTransform = {
                mProp: this.data.ks ? TransformPropertyFactory.getTransformProperty(this, this.data.ks, this) : {
                    o: 0
                },
                _matMdf: false,
                _localMatMdf: false,
                _opMdf: false,
                mat: mat,
                localMat: mat,
                localOpacity: 1
            };
            if (this.data.ao) this.finalTransform.mProp.autoOriented = true;
             // TODO: check TYPE 11: Guided elements
            this.data.ty;
        },
        renderTransform: function renderTransform() {
            this.finalTransform._opMdf = this.finalTransform.mProp.o._mdf || this._isFirstFrame;
            this.finalTransform._matMdf = this.finalTransform.mProp._mdf || this._isFirstFrame;
            if (this.hierarchy) {
                var mat;
                var finalMat = this.finalTransform.mat;
                var i = 0;
                var len = this.hierarchy.length; // Checking if any of the transformation matrices in the hierarchy chain has changed.
                if (!this.finalTransform._matMdf) while(i < len){
                    if (this.hierarchy[i].finalTransform.mProp._mdf) {
                        this.finalTransform._matMdf = true;
                        break;
                    }
                    i += 1;
                }
                if (this.finalTransform._matMdf) {
                    mat = this.finalTransform.mProp.v.props;
                    finalMat.cloneFromProps(mat);
                    for(i = 0; i < len; i += 1)finalMat.multiply(this.hierarchy[i].finalTransform.mProp.v);
                }
            }
            if (this.finalTransform._matMdf) this.finalTransform._localMatMdf = this.finalTransform._matMdf;
            if (this.finalTransform._opMdf) this.finalTransform.localOpacity = this.finalTransform.mProp.o.v;
        },
        renderLocalTransform: function renderLocalTransform() {
            if (this.localTransforms) {
                var i = 0;
                var len = this.localTransforms.length;
                this.finalTransform._localMatMdf = this.finalTransform._matMdf;
                if (!this.finalTransform._localMatMdf || !this.finalTransform._opMdf) while(i < len){
                    if (this.localTransforms[i]._mdf) this.finalTransform._localMatMdf = true;
                    if (this.localTransforms[i]._opMdf && !this.finalTransform._opMdf) {
                        this.finalTransform.localOpacity = this.finalTransform.mProp.o.v;
                        this.finalTransform._opMdf = true;
                    }
                    i += 1;
                }
                if (this.finalTransform._localMatMdf) {
                    var localMat = this.finalTransform.localMat;
                    this.localTransforms[0].matrix.clone(localMat);
                    for(i = 1; i < len; i += 1){
                        var lmat = this.localTransforms[i].matrix;
                        localMat.multiply(lmat);
                    }
                    localMat.multiply(this.finalTransform.mat);
                }
                if (this.finalTransform._opMdf) {
                    var localOp = this.finalTransform.localOpacity;
                    for(i = 0; i < len; i += 1)localOp *= this.localTransforms[i].opacity * 0.01;
                    this.finalTransform.localOpacity = localOp;
                }
            }
        },
        searchEffectTransforms: function searchEffectTransforms() {
            if (this.renderableEffectsManager) {
                var transformEffects = this.renderableEffectsManager.getEffects(effectTypes.TRANSFORM_EFFECT);
                if (transformEffects.length) {
                    this.localTransforms = [];
                    this.finalTransform.localMat = new Matrix();
                    var i = 0;
                    var len = transformEffects.length;
                    for(i = 0; i < len; i += 1)this.localTransforms.push(transformEffects[i]);
                }
            }
        },
        globalToLocal: function globalToLocal(pt) {
            var transforms = [];
            transforms.push(this.finalTransform);
            var flag = true;
            var comp = this.comp;
            while(flag)if (comp.finalTransform) {
                if (comp.data.hasMask) transforms.splice(0, 0, comp.finalTransform);
                comp = comp.comp;
            } else flag = false;
            var i;
            var len = transforms.length;
            var ptNew;
            for(i = 0; i < len; i += 1){
                ptNew = transforms[i].mat.applyToPointArray(0, 0, 0); // ptNew = transforms[i].mat.applyToPointArray(pt[0],pt[1],pt[2]);
                pt = [
                    pt[0] - ptNew[0],
                    pt[1] - ptNew[1],
                    0
                ];
            }
            return pt;
        },
        mHelper: new Matrix()
    };
    function MaskElement(data, element, globalData) {
        this.data = data;
        this.element = element;
        this.globalData = globalData;
        this.storedData = [];
        this.masksProperties = this.data.masksProperties || [];
        this.maskElement = null;
        var defs = this.globalData.defs;
        var i;
        var len = this.masksProperties ? this.masksProperties.length : 0;
        this.viewData = createSizedArray(len);
        this.solidPath = "";
        var path;
        var properties = this.masksProperties;
        var count = 0;
        var currentMasks = [];
        var j;
        var jLen;
        var layerId = createElementID();
        var rect;
        var expansor;
        var feMorph;
        var x;
        var maskType = "clipPath";
        var maskRef = "clip-path";
        for(i = 0; i < len; i += 1){
            if (properties[i].mode !== "a" && properties[i].mode !== "n" || properties[i].inv || properties[i].o.k !== 100 || properties[i].o.x) {
                maskType = "mask";
                maskRef = "mask";
            }
            if ((properties[i].mode === "s" || properties[i].mode === "i") && count === 0) {
                rect = createNS("rect");
                rect.setAttribute("fill", "#ffffff");
                rect.setAttribute("width", this.element.comp.data.w || 0);
                rect.setAttribute("height", this.element.comp.data.h || 0);
                currentMasks.push(rect);
            } else rect = null;
            path = createNS("path");
            if (properties[i].mode === "n") {
                // TODO move this to a factory or to a constructor
                this.viewData[i] = {
                    op: PropertyFactory.getProp(this.element, properties[i].o, 0, 0.01, this.element),
                    prop: ShapePropertyFactory.getShapeProp(this.element, properties[i], 3),
                    elem: path,
                    lastPath: ""
                };
                defs.appendChild(path);
            } else {
                count += 1;
                path.setAttribute("fill", properties[i].mode === "s" ? "#000000" : "#ffffff");
                path.setAttribute("clip-rule", "nonzero");
                var filterID;
                if (properties[i].x.k !== 0) {
                    maskType = "mask";
                    maskRef = "mask";
                    x = PropertyFactory.getProp(this.element, properties[i].x, 0, null, this.element);
                    filterID = createElementID();
                    expansor = createNS("filter");
                    expansor.setAttribute("id", filterID);
                    feMorph = createNS("feMorphology");
                    feMorph.setAttribute("operator", "erode");
                    feMorph.setAttribute("in", "SourceGraphic");
                    feMorph.setAttribute("radius", "0");
                    expansor.appendChild(feMorph);
                    defs.appendChild(expansor);
                    path.setAttribute("stroke", properties[i].mode === "s" ? "#000000" : "#ffffff");
                } else {
                    feMorph = null;
                    x = null;
                } // TODO move this to a factory or to a constructor
                this.storedData[i] = {
                    elem: path,
                    x: x,
                    expan: feMorph,
                    lastPath: "",
                    lastOperator: "",
                    filterId: filterID,
                    lastRadius: 0
                };
                if (properties[i].mode === "i") {
                    jLen = currentMasks.length;
                    var g = createNS("g");
                    for(j = 0; j < jLen; j += 1)g.appendChild(currentMasks[j]);
                    var mask = createNS("mask");
                    mask.setAttribute("mask-type", "alpha");
                    mask.setAttribute("id", layerId + "_" + count);
                    mask.appendChild(path);
                    defs.appendChild(mask);
                    g.setAttribute("mask", "url(" + getLocationHref() + "#" + layerId + "_" + count + ")");
                    currentMasks.length = 0;
                    currentMasks.push(g);
                } else currentMasks.push(path);
                if (properties[i].inv && !this.solidPath) this.solidPath = this.createLayerSolidPath();
                 // TODO move this to a factory or to a constructor
                this.viewData[i] = {
                    elem: path,
                    lastPath: "",
                    op: PropertyFactory.getProp(this.element, properties[i].o, 0, 0.01, this.element),
                    prop: ShapePropertyFactory.getShapeProp(this.element, properties[i], 3),
                    invRect: rect
                };
                if (!this.viewData[i].prop.k) this.drawPath(properties[i], this.viewData[i].prop.v, this.viewData[i]);
            }
        }
        this.maskElement = createNS(maskType);
        len = currentMasks.length;
        for(i = 0; i < len; i += 1)this.maskElement.appendChild(currentMasks[i]);
        if (count > 0) {
            this.maskElement.setAttribute("id", layerId);
            this.element.maskedElement.setAttribute(maskRef, "url(" + getLocationHref() + "#" + layerId + ")");
            defs.appendChild(this.maskElement);
        }
        if (this.viewData.length) this.element.addRenderableComponent(this);
    }
    MaskElement.prototype.getMaskProperty = function(pos) {
        return this.viewData[pos].prop;
    };
    MaskElement.prototype.renderFrame = function(isFirstFrame) {
        var finalMat = this.element.finalTransform.mat;
        var i;
        var len = this.masksProperties.length;
        for(i = 0; i < len; i += 1){
            if (this.viewData[i].prop._mdf || isFirstFrame) this.drawPath(this.masksProperties[i], this.viewData[i].prop.v, this.viewData[i]);
            if (this.viewData[i].op._mdf || isFirstFrame) this.viewData[i].elem.setAttribute("fill-opacity", this.viewData[i].op.v);
            if (this.masksProperties[i].mode !== "n") {
                if (this.viewData[i].invRect && (this.element.finalTransform.mProp._mdf || isFirstFrame)) this.viewData[i].invRect.setAttribute("transform", finalMat.getInverseMatrix().to2dCSS());
                if (this.storedData[i].x && (this.storedData[i].x._mdf || isFirstFrame)) {
                    var feMorph = this.storedData[i].expan;
                    if (this.storedData[i].x.v < 0) {
                        if (this.storedData[i].lastOperator !== "erode") {
                            this.storedData[i].lastOperator = "erode";
                            this.storedData[i].elem.setAttribute("filter", "url(" + getLocationHref() + "#" + this.storedData[i].filterId + ")");
                        }
                        feMorph.setAttribute("radius", -this.storedData[i].x.v);
                    } else {
                        if (this.storedData[i].lastOperator !== "dilate") {
                            this.storedData[i].lastOperator = "dilate";
                            this.storedData[i].elem.setAttribute("filter", null);
                        }
                        this.storedData[i].elem.setAttribute("stroke-width", this.storedData[i].x.v * 2);
                    }
                }
            }
        }
    };
    MaskElement.prototype.getMaskelement = function() {
        return this.maskElement;
    };
    MaskElement.prototype.createLayerSolidPath = function() {
        var path = "M0,0 ";
        path += " h" + this.globalData.compSize.w;
        path += " v" + this.globalData.compSize.h;
        path += " h-" + this.globalData.compSize.w;
        path += " v-" + this.globalData.compSize.h + " ";
        return path;
    };
    MaskElement.prototype.drawPath = function(pathData, pathNodes, viewData) {
        var pathString = " M" + pathNodes.v[0][0] + "," + pathNodes.v[0][1];
        var i;
        var len;
        len = pathNodes._length;
        for(i = 1; i < len; i += 1)// pathString += " C"+pathNodes.o[i-1][0]+','+pathNodes.o[i-1][1] + " "+pathNodes.i[i][0]+','+pathNodes.i[i][1] + " "+pathNodes.v[i][0]+','+pathNodes.v[i][1];
        pathString += " C" + pathNodes.o[i - 1][0] + "," + pathNodes.o[i - 1][1] + " " + pathNodes.i[i][0] + "," + pathNodes.i[i][1] + " " + pathNodes.v[i][0] + "," + pathNodes.v[i][1];
         // pathString += " C"+pathNodes.o[i-1][0]+','+pathNodes.o[i-1][1] + " "+pathNodes.i[0][0]+','+pathNodes.i[0][1] + " "+pathNodes.v[0][0]+','+pathNodes.v[0][1];
        if (pathNodes.c && len > 1) pathString += " C" + pathNodes.o[i - 1][0] + "," + pathNodes.o[i - 1][1] + " " + pathNodes.i[0][0] + "," + pathNodes.i[0][1] + " " + pathNodes.v[0][0] + "," + pathNodes.v[0][1];
         // pathNodes.__renderedString = pathString;
        if (viewData.lastPath !== pathString) {
            var pathShapeValue = "";
            if (viewData.elem) {
                if (pathNodes.c) pathShapeValue = pathData.inv ? this.solidPath + pathString : pathString;
                viewData.elem.setAttribute("d", pathShapeValue);
            }
            viewData.lastPath = pathString;
        }
    };
    MaskElement.prototype.destroy = function() {
        this.element = null;
        this.globalData = null;
        this.maskElement = null;
        this.data = null;
        this.masksProperties = null;
    };
    var filtersFactory = function() {
        var ob = {};
        ob.createFilter = createFilter;
        ob.createAlphaToLuminanceFilter = createAlphaToLuminanceFilter;
        function createFilter(filId, skipCoordinates) {
            var fil = createNS("filter");
            fil.setAttribute("id", filId);
            if (skipCoordinates !== true) {
                fil.setAttribute("filterUnits", "objectBoundingBox");
                fil.setAttribute("x", "0%");
                fil.setAttribute("y", "0%");
                fil.setAttribute("width", "100%");
                fil.setAttribute("height", "100%");
            }
            return fil;
        }
        function createAlphaToLuminanceFilter() {
            var feColorMatrix = createNS("feColorMatrix");
            feColorMatrix.setAttribute("type", "matrix");
            feColorMatrix.setAttribute("color-interpolation-filters", "sRGB");
            feColorMatrix.setAttribute("values", "0 0 0 1 0  0 0 0 1 0  0 0 0 1 0  0 0 0 1 1");
            return feColorMatrix;
        }
        return ob;
    }();
    var featureSupport = function() {
        var ob = {
            maskType: true,
            svgLumaHidden: true,
            offscreenCanvas: typeof OffscreenCanvas !== "undefined"
        };
        if (/MSIE 10/i.test(navigator.userAgent) || /MSIE 9/i.test(navigator.userAgent) || /rv:11.0/i.test(navigator.userAgent) || /Edge\/\d./i.test(navigator.userAgent)) ob.maskType = false;
        if (/firefox/i.test(navigator.userAgent)) ob.svgLumaHidden = false;
        return ob;
    }();
    var registeredEffects$1 = {};
    var idPrefix = "filter_result_";
    function SVGEffects(elem) {
        var i;
        var source = "SourceGraphic";
        var len = elem.data.ef ? elem.data.ef.length : 0;
        var filId = createElementID();
        var fil = filtersFactory.createFilter(filId, true);
        var count = 0;
        this.filters = [];
        var filterManager;
        for(i = 0; i < len; i += 1){
            filterManager = null;
            var type = elem.data.ef[i].ty;
            if (registeredEffects$1[type]) {
                var Effect = registeredEffects$1[type].effect;
                filterManager = new Effect(fil, elem.effectsManager.effectElements[i], elem, idPrefix + count, source);
                source = idPrefix + count;
                if (registeredEffects$1[type].countsAsEffect) count += 1;
            }
            if (filterManager) this.filters.push(filterManager);
        }
        if (count) {
            elem.globalData.defs.appendChild(fil);
            elem.layerElement.setAttribute("filter", "url(" + getLocationHref() + "#" + filId + ")");
        }
        if (this.filters.length) elem.addRenderableComponent(this);
    }
    SVGEffects.prototype.renderFrame = function(_isFirstFrame) {
        var i;
        var len = this.filters.length;
        for(i = 0; i < len; i += 1)this.filters[i].renderFrame(_isFirstFrame);
    };
    SVGEffects.prototype.getEffects = function(type) {
        var i;
        var len = this.filters.length;
        var effects = [];
        for(i = 0; i < len; i += 1)if (this.filters[i].type === type) effects.push(this.filters[i]);
        return effects;
    };
    function registerEffect$1(id, effect, countsAsEffect) {
        registeredEffects$1[id] = {
            effect: effect,
            countsAsEffect: countsAsEffect
        };
    }
    function SVGBaseElement() {}
    SVGBaseElement.prototype = {
        initRendererElement: function initRendererElement() {
            this.layerElement = createNS("g");
        },
        createContainerElements: function createContainerElements() {
            this.matteElement = createNS("g");
            this.transformedElement = this.layerElement;
            this.maskedElement = this.layerElement;
            this._sizeChanged = false;
            var layerElementParent = null; // If this layer acts as a mask for the following layer
            if (this.data.td) {
                this.matteMasks = {};
                var gg = createNS("g");
                gg.setAttribute("id", this.layerId);
                gg.appendChild(this.layerElement);
                layerElementParent = gg;
                this.globalData.defs.appendChild(gg);
            } else if (this.data.tt) {
                this.matteElement.appendChild(this.layerElement);
                layerElementParent = this.matteElement;
                this.baseElement = this.matteElement;
            } else this.baseElement = this.layerElement;
            if (this.data.ln) this.layerElement.setAttribute("id", this.data.ln);
            if (this.data.cl) this.layerElement.setAttribute("class", this.data.cl);
             // Clipping compositions to hide content that exceeds boundaries. If collapsed transformations is on, component should not be clipped
            if (this.data.ty === 0 && !this.data.hd) {
                var cp = createNS("clipPath");
                var pt = createNS("path");
                pt.setAttribute("d", "M0,0 L" + this.data.w + ",0 L" + this.data.w + "," + this.data.h + " L0," + this.data.h + "z");
                var clipId = createElementID();
                cp.setAttribute("id", clipId);
                cp.appendChild(pt);
                this.globalData.defs.appendChild(cp);
                if (this.checkMasks()) {
                    var cpGroup = createNS("g");
                    cpGroup.setAttribute("clip-path", "url(" + getLocationHref() + "#" + clipId + ")");
                    cpGroup.appendChild(this.layerElement);
                    this.transformedElement = cpGroup;
                    if (layerElementParent) layerElementParent.appendChild(this.transformedElement);
                    else this.baseElement = this.transformedElement;
                } else this.layerElement.setAttribute("clip-path", "url(" + getLocationHref() + "#" + clipId + ")");
            }
            if (this.data.bm !== 0) this.setBlendMode();
        },
        renderElement: function renderElement() {
            if (this.finalTransform._localMatMdf) this.transformedElement.setAttribute("transform", this.finalTransform.localMat.to2dCSS());
            if (this.finalTransform._opMdf) this.transformedElement.setAttribute("opacity", this.finalTransform.localOpacity);
        },
        destroyBaseElement: function destroyBaseElement() {
            this.layerElement = null;
            this.matteElement = null;
            this.maskManager.destroy();
        },
        getBaseElement: function getBaseElement() {
            if (this.data.hd) return null;
            return this.baseElement;
        },
        createRenderableComponents: function createRenderableComponents() {
            this.maskManager = new MaskElement(this.data, this, this.globalData);
            this.renderableEffectsManager = new SVGEffects(this);
            this.searchEffectTransforms();
        },
        getMatte: function getMatte(matteType) {
            // This should not be a common case. But for backward compatibility, we'll create the matte object.
            // It solves animations that have two consecutive layers marked as matte masks.
            // Which is an undefined behavior in AE.
            if (!this.matteMasks) this.matteMasks = {};
            if (!this.matteMasks[matteType]) {
                var id = this.layerId + "_" + matteType;
                var filId;
                var fil;
                var useElement;
                var gg;
                if (matteType === 1 || matteType === 3) {
                    var masker = createNS("mask");
                    masker.setAttribute("id", id);
                    masker.setAttribute("mask-type", matteType === 3 ? "luminance" : "alpha");
                    useElement = createNS("use");
                    useElement.setAttributeNS("http://www.w3.org/1999/xlink", "href", "#" + this.layerId);
                    masker.appendChild(useElement);
                    this.globalData.defs.appendChild(masker);
                    if (!featureSupport.maskType && matteType === 1) {
                        masker.setAttribute("mask-type", "luminance");
                        filId = createElementID();
                        fil = filtersFactory.createFilter(filId);
                        this.globalData.defs.appendChild(fil);
                        fil.appendChild(filtersFactory.createAlphaToLuminanceFilter());
                        gg = createNS("g");
                        gg.appendChild(useElement);
                        masker.appendChild(gg);
                        gg.setAttribute("filter", "url(" + getLocationHref() + "#" + filId + ")");
                    }
                } else if (matteType === 2) {
                    var maskGroup = createNS("mask");
                    maskGroup.setAttribute("id", id);
                    maskGroup.setAttribute("mask-type", "alpha");
                    var maskGrouper = createNS("g");
                    maskGroup.appendChild(maskGrouper);
                    filId = createElementID();
                    fil = filtersFactory.createFilter(filId); /// /
                    var feCTr = createNS("feComponentTransfer");
                    feCTr.setAttribute("in", "SourceGraphic");
                    fil.appendChild(feCTr);
                    var feFunc = createNS("feFuncA");
                    feFunc.setAttribute("type", "table");
                    feFunc.setAttribute("tableValues", "1.0 0.0");
                    feCTr.appendChild(feFunc); /// /
                    this.globalData.defs.appendChild(fil);
                    var alphaRect = createNS("rect");
                    alphaRect.setAttribute("width", this.comp.data.w);
                    alphaRect.setAttribute("height", this.comp.data.h);
                    alphaRect.setAttribute("x", "0");
                    alphaRect.setAttribute("y", "0");
                    alphaRect.setAttribute("fill", "#ffffff");
                    alphaRect.setAttribute("opacity", "0");
                    maskGrouper.setAttribute("filter", "url(" + getLocationHref() + "#" + filId + ")");
                    maskGrouper.appendChild(alphaRect);
                    useElement = createNS("use");
                    useElement.setAttributeNS("http://www.w3.org/1999/xlink", "href", "#" + this.layerId);
                    maskGrouper.appendChild(useElement);
                    if (!featureSupport.maskType) {
                        maskGroup.setAttribute("mask-type", "luminance");
                        fil.appendChild(filtersFactory.createAlphaToLuminanceFilter());
                        gg = createNS("g");
                        maskGrouper.appendChild(alphaRect);
                        gg.appendChild(this.layerElement);
                        maskGrouper.appendChild(gg);
                    }
                    this.globalData.defs.appendChild(maskGroup);
                }
                this.matteMasks[matteType] = id;
            }
            return this.matteMasks[matteType];
        },
        setMatte: function setMatte(id) {
            if (!this.matteElement) return;
            this.matteElement.setAttribute("mask", "url(" + getLocationHref() + "#" + id + ")");
        }
    };
    /**
   * @file
   * Handles AE's layer parenting property.
   *
   */ function HierarchyElement() {}
    HierarchyElement.prototype = {
        /**
       * @function
       * Initializes hierarchy properties
       *
       */ initHierarchy: function initHierarchy() {
            // element's parent list
            this.hierarchy = []; // if element is parent of another layer _isParent will be true
            this._isParent = false;
            this.checkParenting();
        },
        /**
       * @function
       * Sets layer's hierarchy.
       * @param {array} hierarch
       * layer's parent list
       *
       */ setHierarchy: function setHierarchy(hierarchy) {
            this.hierarchy = hierarchy;
        },
        /**
       * @function
       * Sets layer as parent.
       *
       */ setAsParent: function setAsParent() {
            this._isParent = true;
        },
        /**
       * @function
       * Searches layer's parenting chain
       *
       */ checkParenting: function checkParenting() {
            if (this.data.parent !== undefined) this.comp.buildElementParenting(this, this.data.parent, []);
        }
    };
    function RenderableDOMElement() {}
    (function() {
        var _prototype = {
            initElement: function initElement(data, globalData, comp) {
                this.initFrame();
                this.initBaseData(data, globalData, comp);
                this.initTransform(data, globalData, comp);
                this.initHierarchy();
                this.initRenderable();
                this.initRendererElement();
                this.createContainerElements();
                this.createRenderableComponents();
                this.createContent();
                this.hide();
            },
            hide: function hide() {
                // console.log('HIDE', this);
                if (!this.hidden && (!this.isInRange || this.isTransparent)) {
                    var elem = this.baseElement || this.layerElement;
                    elem.style.display = "none";
                    this.hidden = true;
                }
            },
            show: function show() {
                // console.log('SHOW', this);
                if (this.isInRange && !this.isTransparent) {
                    if (!this.data.hd) {
                        var elem = this.baseElement || this.layerElement;
                        elem.style.display = "block";
                    }
                    this.hidden = false;
                    this._isFirstFrame = true;
                }
            },
            renderFrame: function renderFrame() {
                // If it is exported as hidden (data.hd === true) no need to render
                // If it is not visible no need to render
                if (this.data.hd || this.hidden) return;
                this.renderTransform();
                this.renderRenderable();
                this.renderLocalTransform();
                this.renderElement();
                this.renderInnerContent();
                if (this._isFirstFrame) this._isFirstFrame = false;
            },
            renderInnerContent: function renderInnerContent() {},
            prepareFrame: function prepareFrame(num) {
                this._mdf = false;
                this.prepareRenderableFrame(num);
                this.prepareProperties(num, this.isInRange);
                this.checkTransparency();
            },
            destroy: function destroy() {
                this.innerElem = null;
                this.destroyBaseElement();
            }
        };
        extendPrototype([
            RenderableElement,
            createProxyFunction(_prototype)
        ], RenderableDOMElement);
    })();
    function IImageElement(data, globalData, comp) {
        this.assetData = globalData.getAssetData(data.refId);
        if (this.assetData && this.assetData.sid) this.assetData = globalData.slotManager.getProp(this.assetData);
        this.initElement(data, globalData, comp);
        this.sourceRect = {
            top: 0,
            left: 0,
            width: this.assetData.w,
            height: this.assetData.h
        };
    }
    extendPrototype([
        BaseElement,
        TransformElement,
        SVGBaseElement,
        HierarchyElement,
        FrameElement,
        RenderableDOMElement
    ], IImageElement);
    IImageElement.prototype.createContent = function() {
        var assetPath = this.globalData.getAssetsPath(this.assetData);
        this.innerElem = createNS("image");
        this.innerElem.setAttribute("width", this.assetData.w + "px");
        this.innerElem.setAttribute("height", this.assetData.h + "px");
        this.innerElem.setAttribute("preserveAspectRatio", this.assetData.pr || this.globalData.renderConfig.imagePreserveAspectRatio);
        this.innerElem.setAttributeNS("http://www.w3.org/1999/xlink", "href", assetPath);
        this.layerElement.appendChild(this.innerElem);
    };
    IImageElement.prototype.sourceRectAtTime = function() {
        return this.sourceRect;
    };
    function ProcessedElement(element, position) {
        this.elem = element;
        this.pos = position;
    }
    function IShapeElement() {}
    IShapeElement.prototype = {
        addShapeToModifiers: function addShapeToModifiers(data) {
            var i;
            var len = this.shapeModifiers.length;
            for(i = 0; i < len; i += 1)this.shapeModifiers[i].addShape(data);
        },
        isShapeInAnimatedModifiers: function isShapeInAnimatedModifiers(data) {
            var i = 0;
            var len = this.shapeModifiers.length;
            while(i < len){
                if (this.shapeModifiers[i].isAnimatedWithShape(data)) return true;
            }
            return false;
        },
        renderModifiers: function renderModifiers() {
            if (!this.shapeModifiers.length) return;
            var i;
            var len = this.shapes.length;
            for(i = 0; i < len; i += 1)this.shapes[i].sh.reset();
            len = this.shapeModifiers.length;
            var shouldBreakProcess;
            for(i = len - 1; i >= 0; i -= 1){
                shouldBreakProcess = this.shapeModifiers[i].processShapes(this._isFirstFrame); // workaround to fix cases where a repeater resets the shape so the following processes get called twice
                // TODO: find a better solution for this
                if (shouldBreakProcess) break;
            }
        },
        searchProcessedElement: function searchProcessedElement(elem) {
            var elements = this.processedElements;
            var i = 0;
            var len = elements.length;
            while(i < len){
                if (elements[i].elem === elem) return elements[i].pos;
                i += 1;
            }
            return 0;
        },
        addProcessedElement: function addProcessedElement(elem, pos) {
            var elements = this.processedElements;
            var i = elements.length;
            while(i){
                i -= 1;
                if (elements[i].elem === elem) {
                    elements[i].pos = pos;
                    return;
                }
            }
            elements.push(new ProcessedElement(elem, pos));
        },
        prepareFrame: function prepareFrame(num) {
            this.prepareRenderableFrame(num);
            this.prepareProperties(num, this.isInRange);
        }
    };
    var lineCapEnum = {
        1: "butt",
        2: "round",
        3: "square"
    };
    var lineJoinEnum = {
        1: "miter",
        2: "round",
        3: "bevel"
    };
    function SVGShapeData(transformers, level, shape) {
        this.caches = [];
        this.styles = [];
        this.transformers = transformers;
        this.lStr = "";
        this.sh = shape;
        this.lvl = level; // TODO find if there are some cases where _isAnimated can be false.
        // For now, since shapes add up with other shapes. They have to be calculated every time.
        // One way of finding out is checking if all styles associated to this shape depend only of this shape
        this._isAnimated = !!shape.k; // TODO: commenting this for now since all shapes are animated
        var i = 0;
        var len = transformers.length;
        while(i < len){
            if (transformers[i].mProps.dynamicProperties.length) {
                this._isAnimated = true;
                break;
            }
            i += 1;
        }
    }
    SVGShapeData.prototype.setAsAnimated = function() {
        this._isAnimated = true;
    };
    function SVGStyleData(data, level) {
        this.data = data;
        this.type = data.ty;
        this.d = "";
        this.lvl = level;
        this._mdf = false;
        this.closed = data.hd === true;
        this.pElem = createNS("path");
        this.msElem = null;
    }
    SVGStyleData.prototype.reset = function() {
        this.d = "";
        this._mdf = false;
    };
    function DashProperty(elem, data, renderer, container) {
        this.elem = elem;
        this.frameId = -1;
        this.dataProps = createSizedArray(data.length);
        this.renderer = renderer;
        this.k = false;
        this.dashStr = "";
        this.dashArray = createTypedArray("float32", data.length ? data.length - 1 : 0);
        this.dashoffset = createTypedArray("float32", 1);
        this.initDynamicPropertyContainer(container);
        var i;
        var len = data.length || 0;
        var prop;
        for(i = 0; i < len; i += 1){
            prop = PropertyFactory.getProp(elem, data[i].v, 0, 0, this);
            this.k = prop.k || this.k;
            this.dataProps[i] = {
                n: data[i].n,
                p: prop
            };
        }
        if (!this.k) this.getValue(true);
        this._isAnimated = this.k;
    }
    DashProperty.prototype.getValue = function(forceRender) {
        if (this.elem.globalData.frameId === this.frameId && !forceRender) return;
        this.frameId = this.elem.globalData.frameId;
        this.iterateDynamicProperties();
        this._mdf = this._mdf || forceRender;
        if (this._mdf) {
            var i = 0;
            var len = this.dataProps.length;
            if (this.renderer === "svg") this.dashStr = "";
            for(i = 0; i < len; i += 1)if (this.dataProps[i].n !== "o") {
                if (this.renderer === "svg") this.dashStr += " " + this.dataProps[i].p.v;
                else this.dashArray[i] = this.dataProps[i].p.v;
            } else this.dashoffset[0] = this.dataProps[i].p.v;
        }
    };
    extendPrototype([
        DynamicPropertyContainer
    ], DashProperty);
    function SVGStrokeStyleData(elem, data, styleOb) {
        this.initDynamicPropertyContainer(elem);
        this.getValue = this.iterateDynamicProperties;
        this.o = PropertyFactory.getProp(elem, data.o, 0, 0.01, this);
        this.w = PropertyFactory.getProp(elem, data.w, 0, null, this);
        this.d = new DashProperty(elem, data.d || {}, "svg", this);
        this.c = PropertyFactory.getProp(elem, data.c, 1, 255, this);
        this.style = styleOb;
        this._isAnimated = !!this._isAnimated;
    }
    extendPrototype([
        DynamicPropertyContainer
    ], SVGStrokeStyleData);
    function SVGFillStyleData(elem, data, styleOb) {
        this.initDynamicPropertyContainer(elem);
        this.getValue = this.iterateDynamicProperties;
        this.o = PropertyFactory.getProp(elem, data.o, 0, 0.01, this);
        this.c = PropertyFactory.getProp(elem, data.c, 1, 255, this);
        this.style = styleOb;
    }
    extendPrototype([
        DynamicPropertyContainer
    ], SVGFillStyleData);
    function SVGNoStyleData(elem, data, styleOb) {
        this.initDynamicPropertyContainer(elem);
        this.getValue = this.iterateDynamicProperties;
        this.style = styleOb;
    }
    extendPrototype([
        DynamicPropertyContainer
    ], SVGNoStyleData);
    function GradientProperty(elem, data, container) {
        this.data = data;
        this.c = createTypedArray("uint8c", data.p * 4);
        var cLength = data.k.k[0].s ? data.k.k[0].s.length - data.p * 4 : data.k.k.length - data.p * 4;
        this.o = createTypedArray("float32", cLength);
        this._cmdf = false;
        this._omdf = false;
        this._collapsable = this.checkCollapsable();
        this._hasOpacity = cLength;
        this.initDynamicPropertyContainer(container);
        this.prop = PropertyFactory.getProp(elem, data.k, 1, null, this);
        this.k = this.prop.k;
        this.getValue(true);
    }
    GradientProperty.prototype.comparePoints = function(values, points) {
        var i = 0;
        var len = this.o.length / 2;
        var diff;
        while(i < len){
            diff = Math.abs(values[i * 4] - values[points * 4 + i * 2]);
            if (diff > 0.01) return false;
            i += 1;
        }
        return true;
    };
    GradientProperty.prototype.checkCollapsable = function() {
        if (this.o.length / 2 !== this.c.length / 4) return false;
        if (this.data.k.k[0].s) {
            var i = 0;
            var len = this.data.k.k.length;
            while(i < len){
                if (!this.comparePoints(this.data.k.k[i].s, this.data.p)) return false;
                i += 1;
            }
        } else if (!this.comparePoints(this.data.k.k, this.data.p)) return false;
        return true;
    };
    GradientProperty.prototype.getValue = function(forceRender) {
        this.prop.getValue();
        this._mdf = false;
        this._cmdf = false;
        this._omdf = false;
        if (this.prop._mdf || forceRender) {
            var i;
            var len = this.data.p * 4;
            var mult;
            var val;
            for(i = 0; i < len; i += 1){
                mult = i % 4 === 0 ? 100 : 255;
                val = Math.round(this.prop.v[i] * mult);
                if (this.c[i] !== val) {
                    this.c[i] = val;
                    this._cmdf = !forceRender;
                }
            }
            if (this.o.length) {
                len = this.prop.v.length;
                for(i = this.data.p * 4; i < len; i += 1){
                    mult = i % 2 === 0 ? 100 : 1;
                    val = i % 2 === 0 ? Math.round(this.prop.v[i] * 100) : this.prop.v[i];
                    if (this.o[i - this.data.p * 4] !== val) {
                        this.o[i - this.data.p * 4] = val;
                        this._omdf = !forceRender;
                    }
                }
            }
            this._mdf = !forceRender;
        }
    };
    extendPrototype([
        DynamicPropertyContainer
    ], GradientProperty);
    function SVGGradientFillStyleData(elem, data, styleOb) {
        this.initDynamicPropertyContainer(elem);
        this.getValue = this.iterateDynamicProperties;
        this.initGradientData(elem, data, styleOb);
    }
    SVGGradientFillStyleData.prototype.initGradientData = function(elem, data, styleOb) {
        this.o = PropertyFactory.getProp(elem, data.o, 0, 0.01, this);
        this.s = PropertyFactory.getProp(elem, data.s, 1, null, this);
        this.e = PropertyFactory.getProp(elem, data.e, 1, null, this);
        this.h = PropertyFactory.getProp(elem, data.h || {
            k: 0
        }, 0, 0.01, this);
        this.a = PropertyFactory.getProp(elem, data.a || {
            k: 0
        }, 0, degToRads, this);
        this.g = new GradientProperty(elem, data.g, this);
        this.style = styleOb;
        this.stops = [];
        this.setGradientData(styleOb.pElem, data);
        this.setGradientOpacity(data, styleOb);
        this._isAnimated = !!this._isAnimated;
    };
    SVGGradientFillStyleData.prototype.setGradientData = function(pathElement, data) {
        var gradientId = createElementID();
        var gfill = createNS(data.t === 1 ? "linearGradient" : "radialGradient");
        gfill.setAttribute("id", gradientId);
        gfill.setAttribute("spreadMethod", "pad");
        gfill.setAttribute("gradientUnits", "userSpaceOnUse");
        var stops = [];
        var stop;
        var j;
        var jLen;
        jLen = data.g.p * 4;
        for(j = 0; j < jLen; j += 4){
            stop = createNS("stop");
            gfill.appendChild(stop);
            stops.push(stop);
        }
        pathElement.setAttribute(data.ty === "gf" ? "fill" : "stroke", "url(" + getLocationHref() + "#" + gradientId + ")");
        this.gf = gfill;
        this.cst = stops;
    };
    SVGGradientFillStyleData.prototype.setGradientOpacity = function(data, styleOb) {
        if (this.g._hasOpacity && !this.g._collapsable) {
            var stop;
            var j;
            var jLen;
            var mask = createNS("mask");
            var maskElement = createNS("path");
            mask.appendChild(maskElement);
            var opacityId = createElementID();
            var maskId = createElementID();
            mask.setAttribute("id", maskId);
            var opFill = createNS(data.t === 1 ? "linearGradient" : "radialGradient");
            opFill.setAttribute("id", opacityId);
            opFill.setAttribute("spreadMethod", "pad");
            opFill.setAttribute("gradientUnits", "userSpaceOnUse");
            jLen = data.g.k.k[0].s ? data.g.k.k[0].s.length : data.g.k.k.length;
            var stops = this.stops;
            for(j = data.g.p * 4; j < jLen; j += 2){
                stop = createNS("stop");
                stop.setAttribute("stop-color", "rgb(255,255,255)");
                opFill.appendChild(stop);
                stops.push(stop);
            }
            maskElement.setAttribute(data.ty === "gf" ? "fill" : "stroke", "url(" + getLocationHref() + "#" + opacityId + ")");
            if (data.ty === "gs") {
                maskElement.setAttribute("stroke-linecap", lineCapEnum[data.lc || 2]);
                maskElement.setAttribute("stroke-linejoin", lineJoinEnum[data.lj || 2]);
                if (data.lj === 1) maskElement.setAttribute("stroke-miterlimit", data.ml);
            }
            this.of = opFill;
            this.ms = mask;
            this.ost = stops;
            this.maskId = maskId;
            styleOb.msElem = maskElement;
        }
    };
    extendPrototype([
        DynamicPropertyContainer
    ], SVGGradientFillStyleData);
    function SVGGradientStrokeStyleData(elem, data, styleOb) {
        this.initDynamicPropertyContainer(elem);
        this.getValue = this.iterateDynamicProperties;
        this.w = PropertyFactory.getProp(elem, data.w, 0, null, this);
        this.d = new DashProperty(elem, data.d || {}, "svg", this);
        this.initGradientData(elem, data, styleOb);
        this._isAnimated = !!this._isAnimated;
    }
    extendPrototype([
        SVGGradientFillStyleData,
        DynamicPropertyContainer
    ], SVGGradientStrokeStyleData);
    function ShapeGroupData() {
        this.it = [];
        this.prevViewData = [];
        this.gr = createNS("g");
    }
    function SVGTransformData(mProps, op, container) {
        this.transform = {
            mProps: mProps,
            op: op,
            container: container
        };
        this.elements = [];
        this._isAnimated = this.transform.mProps.dynamicProperties.length || this.transform.op.effectsSequence.length;
    }
    var buildShapeString = function buildShapeString(pathNodes, length, closed, mat) {
        if (length === 0) return "";
        var _o = pathNodes.o;
        var _i = pathNodes.i;
        var _v = pathNodes.v;
        var i;
        var shapeString = " M" + mat.applyToPointStringified(_v[0][0], _v[0][1]);
        for(i = 1; i < length; i += 1)shapeString += " C" + mat.applyToPointStringified(_o[i - 1][0], _o[i - 1][1]) + " " + mat.applyToPointStringified(_i[i][0], _i[i][1]) + " " + mat.applyToPointStringified(_v[i][0], _v[i][1]);
        if (closed && length) {
            shapeString += " C" + mat.applyToPointStringified(_o[i - 1][0], _o[i - 1][1]) + " " + mat.applyToPointStringified(_i[0][0], _i[0][1]) + " " + mat.applyToPointStringified(_v[0][0], _v[0][1]);
            shapeString += "z";
        }
        return shapeString;
    };
    var SVGElementsRenderer = function() {
        var _identityMatrix = new Matrix();
        var _matrixHelper = new Matrix();
        var ob = {
            createRenderFunction: createRenderFunction
        };
        function createRenderFunction(data) {
            switch(data.ty){
                case "fl":
                    return renderFill;
                case "gf":
                    return renderGradient;
                case "gs":
                    return renderGradientStroke;
                case "st":
                    return renderStroke;
                case "sh":
                case "el":
                case "rc":
                case "sr":
                    return renderPath;
                case "tr":
                    return renderContentTransform;
                case "no":
                    return renderNoop;
                default:
                    return null;
            }
        }
        function renderContentTransform(styleData, itemData, isFirstFrame) {
            if (isFirstFrame || itemData.transform.op._mdf) itemData.transform.container.setAttribute("opacity", itemData.transform.op.v);
            if (isFirstFrame || itemData.transform.mProps._mdf) itemData.transform.container.setAttribute("transform", itemData.transform.mProps.v.to2dCSS());
        }
        function renderNoop() {}
        function renderPath(styleData, itemData, isFirstFrame) {
            var j;
            var jLen;
            var pathStringTransformed;
            var redraw;
            var pathNodes;
            var l;
            var lLen = itemData.styles.length;
            var lvl = itemData.lvl;
            var paths;
            var mat;
            var iterations;
            var k;
            for(l = 0; l < lLen; l += 1){
                redraw = itemData.sh._mdf || isFirstFrame;
                if (itemData.styles[l].lvl < lvl) {
                    mat = _matrixHelper.reset();
                    iterations = lvl - itemData.styles[l].lvl;
                    k = itemData.transformers.length - 1;
                    while(!redraw && iterations > 0){
                        redraw = itemData.transformers[k].mProps._mdf || redraw;
                        iterations -= 1;
                        k -= 1;
                    }
                    if (redraw) {
                        iterations = lvl - itemData.styles[l].lvl;
                        k = itemData.transformers.length - 1;
                        while(iterations > 0){
                            mat.multiply(itemData.transformers[k].mProps.v);
                            iterations -= 1;
                            k -= 1;
                        }
                    }
                } else mat = _identityMatrix;
                paths = itemData.sh.paths;
                jLen = paths._length;
                if (redraw) {
                    pathStringTransformed = "";
                    for(j = 0; j < jLen; j += 1){
                        pathNodes = paths.shapes[j];
                        if (pathNodes && pathNodes._length) pathStringTransformed += buildShapeString(pathNodes, pathNodes._length, pathNodes.c, mat);
                    }
                    itemData.caches[l] = pathStringTransformed;
                } else pathStringTransformed = itemData.caches[l];
                itemData.styles[l].d += styleData.hd === true ? "" : pathStringTransformed;
                itemData.styles[l]._mdf = redraw || itemData.styles[l]._mdf;
            }
        }
        function renderFill(styleData, itemData, isFirstFrame) {
            var styleElem = itemData.style;
            if (itemData.c._mdf || isFirstFrame) styleElem.pElem.setAttribute("fill", "rgb(" + bmFloor(itemData.c.v[0]) + "," + bmFloor(itemData.c.v[1]) + "," + bmFloor(itemData.c.v[2]) + ")");
            if (itemData.o._mdf || isFirstFrame) styleElem.pElem.setAttribute("fill-opacity", itemData.o.v);
        }
        function renderGradientStroke(styleData, itemData, isFirstFrame) {
            renderGradient(styleData, itemData, isFirstFrame);
            renderStroke(styleData, itemData, isFirstFrame);
        }
        function renderGradient(styleData, itemData, isFirstFrame) {
            var gfill = itemData.gf;
            var hasOpacity = itemData.g._hasOpacity;
            var pt1 = itemData.s.v;
            var pt2 = itemData.e.v;
            if (itemData.o._mdf || isFirstFrame) {
                var attr = styleData.ty === "gf" ? "fill-opacity" : "stroke-opacity";
                itemData.style.pElem.setAttribute(attr, itemData.o.v);
            }
            if (itemData.s._mdf || isFirstFrame) {
                var attr1 = styleData.t === 1 ? "x1" : "cx";
                var attr2 = attr1 === "x1" ? "y1" : "cy";
                gfill.setAttribute(attr1, pt1[0]);
                gfill.setAttribute(attr2, pt1[1]);
                if (hasOpacity && !itemData.g._collapsable) {
                    itemData.of.setAttribute(attr1, pt1[0]);
                    itemData.of.setAttribute(attr2, pt1[1]);
                }
            }
            var stops;
            var i;
            var len;
            var stop;
            if (itemData.g._cmdf || isFirstFrame) {
                stops = itemData.cst;
                var cValues = itemData.g.c;
                len = stops.length;
                for(i = 0; i < len; i += 1){
                    stop = stops[i];
                    stop.setAttribute("offset", cValues[i * 4] + "%");
                    stop.setAttribute("stop-color", "rgb(" + cValues[i * 4 + 1] + "," + cValues[i * 4 + 2] + "," + cValues[i * 4 + 3] + ")");
                }
            }
            if (hasOpacity && (itemData.g._omdf || isFirstFrame)) {
                var oValues = itemData.g.o;
                if (itemData.g._collapsable) stops = itemData.cst;
                else stops = itemData.ost;
                len = stops.length;
                for(i = 0; i < len; i += 1){
                    stop = stops[i];
                    if (!itemData.g._collapsable) stop.setAttribute("offset", oValues[i * 2] + "%");
                    stop.setAttribute("stop-opacity", oValues[i * 2 + 1]);
                }
            }
            if (styleData.t === 1) {
                if (itemData.e._mdf || isFirstFrame) {
                    gfill.setAttribute("x2", pt2[0]);
                    gfill.setAttribute("y2", pt2[1]);
                    if (hasOpacity && !itemData.g._collapsable) {
                        itemData.of.setAttribute("x2", pt2[0]);
                        itemData.of.setAttribute("y2", pt2[1]);
                    }
                }
            } else {
                var rad;
                if (itemData.s._mdf || itemData.e._mdf || isFirstFrame) {
                    rad = Math.sqrt(Math.pow(pt1[0] - pt2[0], 2) + Math.pow(pt1[1] - pt2[1], 2));
                    gfill.setAttribute("r", rad);
                    if (hasOpacity && !itemData.g._collapsable) itemData.of.setAttribute("r", rad);
                }
                if (itemData.e._mdf || itemData.h._mdf || itemData.a._mdf || isFirstFrame) {
                    if (!rad) rad = Math.sqrt(Math.pow(pt1[0] - pt2[0], 2) + Math.pow(pt1[1] - pt2[1], 2));
                    var ang = Math.atan2(pt2[1] - pt1[1], pt2[0] - pt1[0]);
                    var percent = itemData.h.v;
                    if (percent >= 1) percent = 0.99;
                    else if (percent <= -1) percent = -0.99;
                    var dist = rad * percent;
                    var x = Math.cos(ang + itemData.a.v) * dist + pt1[0];
                    var y = Math.sin(ang + itemData.a.v) * dist + pt1[1];
                    gfill.setAttribute("fx", x);
                    gfill.setAttribute("fy", y);
                    if (hasOpacity && !itemData.g._collapsable) {
                        itemData.of.setAttribute("fx", x);
                        itemData.of.setAttribute("fy", y);
                    }
                } // gfill.setAttribute('fy','200');
            }
        }
        function renderStroke(styleData, itemData, isFirstFrame) {
            var styleElem = itemData.style;
            var d = itemData.d;
            if (d && (d._mdf || isFirstFrame) && d.dashStr) {
                styleElem.pElem.setAttribute("stroke-dasharray", d.dashStr);
                styleElem.pElem.setAttribute("stroke-dashoffset", d.dashoffset[0]);
            }
            if (itemData.c && (itemData.c._mdf || isFirstFrame)) styleElem.pElem.setAttribute("stroke", "rgb(" + bmFloor(itemData.c.v[0]) + "," + bmFloor(itemData.c.v[1]) + "," + bmFloor(itemData.c.v[2]) + ")");
            if (itemData.o._mdf || isFirstFrame) styleElem.pElem.setAttribute("stroke-opacity", itemData.o.v);
            if (itemData.w._mdf || isFirstFrame) {
                styleElem.pElem.setAttribute("stroke-width", itemData.w.v);
                if (styleElem.msElem) styleElem.msElem.setAttribute("stroke-width", itemData.w.v);
            }
        }
        return ob;
    }();
    function SVGShapeElement(data, globalData, comp) {
        // List of drawable elements
        this.shapes = []; // Full shape data
        this.shapesData = data.shapes; // List of styles that will be applied to shapes
        this.stylesList = []; // List of modifiers that will be applied to shapes
        this.shapeModifiers = []; // List of items in shape tree
        this.itemsData = []; // List of items in previous shape tree
        this.processedElements = []; // List of animated components
        this.animatedContents = [];
        this.initElement(data, globalData, comp); // Moving any property that doesn't get too much access after initialization because of v8 way of handling more than 10 properties.
        // List of elements that have been created
        this.prevViewData = []; // Moving any property that doesn't get too much access after initialization because of v8 way of handling more than 10 properties.
    }
    extendPrototype([
        BaseElement,
        TransformElement,
        SVGBaseElement,
        IShapeElement,
        HierarchyElement,
        FrameElement,
        RenderableDOMElement
    ], SVGShapeElement);
    SVGShapeElement.prototype.initSecondaryElement = function() {};
    SVGShapeElement.prototype.identityMatrix = new Matrix();
    SVGShapeElement.prototype.buildExpressionInterface = function() {};
    SVGShapeElement.prototype.createContent = function() {
        this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, this.layerElement, 0, [], true);
        this.filterUniqueShapes();
    };
    /*
  This method searches for multiple shapes that affect a single element and one of them is animated
  */ SVGShapeElement.prototype.filterUniqueShapes = function() {
        var i;
        var len = this.shapes.length;
        var shape;
        var j;
        var jLen = this.stylesList.length;
        var style;
        var tempShapes = [];
        var areAnimated = false;
        for(j = 0; j < jLen; j += 1){
            style = this.stylesList[j];
            areAnimated = false;
            tempShapes.length = 0;
            for(i = 0; i < len; i += 1){
                shape = this.shapes[i];
                if (shape.styles.indexOf(style) !== -1) {
                    tempShapes.push(shape);
                    areAnimated = shape._isAnimated || areAnimated;
                }
            }
            if (tempShapes.length > 1 && areAnimated) this.setShapesAsAnimated(tempShapes);
        }
    };
    SVGShapeElement.prototype.setShapesAsAnimated = function(shapes) {
        var i;
        var len = shapes.length;
        for(i = 0; i < len; i += 1)shapes[i].setAsAnimated();
    };
    SVGShapeElement.prototype.createStyleElement = function(data, level) {
        // TODO: prevent drawing of hidden styles
        var elementData;
        var styleOb = new SVGStyleData(data, level);
        var pathElement = styleOb.pElem;
        if (data.ty === "st") elementData = new SVGStrokeStyleData(this, data, styleOb);
        else if (data.ty === "fl") elementData = new SVGFillStyleData(this, data, styleOb);
        else if (data.ty === "gf" || data.ty === "gs") {
            var GradientConstructor = data.ty === "gf" ? SVGGradientFillStyleData : SVGGradientStrokeStyleData;
            elementData = new GradientConstructor(this, data, styleOb);
            this.globalData.defs.appendChild(elementData.gf);
            if (elementData.maskId) {
                this.globalData.defs.appendChild(elementData.ms);
                this.globalData.defs.appendChild(elementData.of);
                pathElement.setAttribute("mask", "url(" + getLocationHref() + "#" + elementData.maskId + ")");
            }
        } else if (data.ty === "no") elementData = new SVGNoStyleData(this, data, styleOb);
        if (data.ty === "st" || data.ty === "gs") {
            pathElement.setAttribute("stroke-linecap", lineCapEnum[data.lc || 2]);
            pathElement.setAttribute("stroke-linejoin", lineJoinEnum[data.lj || 2]);
            pathElement.setAttribute("fill-opacity", "0");
            if (data.lj === 1) pathElement.setAttribute("stroke-miterlimit", data.ml);
        }
        if (data.r === 2) pathElement.setAttribute("fill-rule", "evenodd");
        if (data.ln) pathElement.setAttribute("id", data.ln);
        if (data.cl) pathElement.setAttribute("class", data.cl);
        if (data.bm) pathElement.style["mix-blend-mode"] = getBlendMode(data.bm);
        this.stylesList.push(styleOb);
        this.addToAnimatedContents(data, elementData);
        return elementData;
    };
    SVGShapeElement.prototype.createGroupElement = function(data) {
        var elementData = new ShapeGroupData();
        if (data.ln) elementData.gr.setAttribute("id", data.ln);
        if (data.cl) elementData.gr.setAttribute("class", data.cl);
        if (data.bm) elementData.gr.style["mix-blend-mode"] = getBlendMode(data.bm);
        return elementData;
    };
    SVGShapeElement.prototype.createTransformElement = function(data, container) {
        var transformProperty = TransformPropertyFactory.getTransformProperty(this, data, this);
        var elementData = new SVGTransformData(transformProperty, transformProperty.o, container);
        this.addToAnimatedContents(data, elementData);
        return elementData;
    };
    SVGShapeElement.prototype.createShapeElement = function(data, ownTransformers, level) {
        var ty = 4;
        if (data.ty === "rc") ty = 5;
        else if (data.ty === "el") ty = 6;
        else if (data.ty === "sr") ty = 7;
        var shapeProperty = ShapePropertyFactory.getShapeProp(this, data, ty, this);
        var elementData = new SVGShapeData(ownTransformers, level, shapeProperty);
        this.shapes.push(elementData);
        this.addShapeToModifiers(elementData);
        this.addToAnimatedContents(data, elementData);
        return elementData;
    };
    SVGShapeElement.prototype.addToAnimatedContents = function(data, element) {
        var i = 0;
        var len = this.animatedContents.length;
        while(i < len){
            if (this.animatedContents[i].element === element) return;
            i += 1;
        }
        this.animatedContents.push({
            fn: SVGElementsRenderer.createRenderFunction(data),
            element: element,
            data: data
        });
    };
    SVGShapeElement.prototype.setElementStyles = function(elementData) {
        var arr = elementData.styles;
        var j;
        var jLen = this.stylesList.length;
        for(j = 0; j < jLen; j += 1)if (!this.stylesList[j].closed) arr.push(this.stylesList[j]);
    };
    SVGShapeElement.prototype.reloadShapes = function() {
        this._isFirstFrame = true;
        var i;
        var len = this.itemsData.length;
        for(i = 0; i < len; i += 1)this.prevViewData[i] = this.itemsData[i];
        this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, this.layerElement, 0, [], true);
        this.filterUniqueShapes();
        len = this.dynamicProperties.length;
        for(i = 0; i < len; i += 1)this.dynamicProperties[i].getValue();
        this.renderModifiers();
    };
    SVGShapeElement.prototype.searchShapes = function(arr, itemsData, prevViewData, container, level, transformers, render) {
        var ownTransformers = [].concat(transformers);
        var i;
        var len = arr.length - 1;
        var j;
        var jLen;
        var ownStyles = [];
        var ownModifiers = [];
        var currentTransform;
        var modifier;
        var processedPos;
        for(i = len; i >= 0; i -= 1){
            processedPos = this.searchProcessedElement(arr[i]);
            if (!processedPos) arr[i]._render = render;
            else itemsData[i] = prevViewData[processedPos - 1];
            if (arr[i].ty === "fl" || arr[i].ty === "st" || arr[i].ty === "gf" || arr[i].ty === "gs" || arr[i].ty === "no") {
                if (!processedPos) itemsData[i] = this.createStyleElement(arr[i], level);
                else itemsData[i].style.closed = false;
                if (arr[i]._render) {
                    if (itemsData[i].style.pElem.parentNode !== container) container.appendChild(itemsData[i].style.pElem);
                }
                ownStyles.push(itemsData[i].style);
            } else if (arr[i].ty === "gr") {
                if (!processedPos) itemsData[i] = this.createGroupElement(arr[i]);
                else {
                    jLen = itemsData[i].it.length;
                    for(j = 0; j < jLen; j += 1)itemsData[i].prevViewData[j] = itemsData[i].it[j];
                }
                this.searchShapes(arr[i].it, itemsData[i].it, itemsData[i].prevViewData, itemsData[i].gr, level + 1, ownTransformers, render);
                if (arr[i]._render) {
                    if (itemsData[i].gr.parentNode !== container) container.appendChild(itemsData[i].gr);
                }
            } else if (arr[i].ty === "tr") {
                if (!processedPos) itemsData[i] = this.createTransformElement(arr[i], container);
                currentTransform = itemsData[i].transform;
                ownTransformers.push(currentTransform);
            } else if (arr[i].ty === "sh" || arr[i].ty === "rc" || arr[i].ty === "el" || arr[i].ty === "sr") {
                if (!processedPos) itemsData[i] = this.createShapeElement(arr[i], ownTransformers, level);
                this.setElementStyles(itemsData[i]);
            } else if (arr[i].ty === "tm" || arr[i].ty === "rd" || arr[i].ty === "ms" || arr[i].ty === "pb" || arr[i].ty === "zz" || arr[i].ty === "op") {
                if (!processedPos) {
                    modifier = ShapeModifiers.getModifier(arr[i].ty);
                    modifier.init(this, arr[i]);
                    itemsData[i] = modifier;
                    this.shapeModifiers.push(modifier);
                } else {
                    modifier = itemsData[i];
                    modifier.closed = false;
                }
                ownModifiers.push(modifier);
            } else if (arr[i].ty === "rp") {
                if (!processedPos) {
                    modifier = ShapeModifiers.getModifier(arr[i].ty);
                    itemsData[i] = modifier;
                    modifier.init(this, arr, i, itemsData);
                    this.shapeModifiers.push(modifier);
                    render = false;
                } else {
                    modifier = itemsData[i];
                    modifier.closed = true;
                }
                ownModifiers.push(modifier);
            }
            this.addProcessedElement(arr[i], i + 1);
        }
        len = ownStyles.length;
        for(i = 0; i < len; i += 1)ownStyles[i].closed = true;
        len = ownModifiers.length;
        for(i = 0; i < len; i += 1)ownModifiers[i].closed = true;
    };
    SVGShapeElement.prototype.renderInnerContent = function() {
        this.renderModifiers();
        var i;
        var len = this.stylesList.length;
        for(i = 0; i < len; i += 1)this.stylesList[i].reset();
        this.renderShape();
        for(i = 0; i < len; i += 1)if (this.stylesList[i]._mdf || this._isFirstFrame) {
            if (this.stylesList[i].msElem) {
                this.stylesList[i].msElem.setAttribute("d", this.stylesList[i].d); // Adding M0 0 fixes same mask bug on all browsers
                this.stylesList[i].d = "M0 0" + this.stylesList[i].d;
            }
            this.stylesList[i].pElem.setAttribute("d", this.stylesList[i].d || "M0 0");
        }
    };
    SVGShapeElement.prototype.renderShape = function() {
        var i;
        var len = this.animatedContents.length;
        var animatedContent;
        for(i = 0; i < len; i += 1){
            animatedContent = this.animatedContents[i];
            if ((this._isFirstFrame || animatedContent.element._isAnimated) && animatedContent.data !== true) animatedContent.fn(animatedContent.data, animatedContent.element, this._isFirstFrame);
        }
    };
    SVGShapeElement.prototype.destroy = function() {
        this.destroyBaseElement();
        this.shapesData = null;
        this.itemsData = null;
    };
    function LetterProps(o, sw, sc, fc, m, p) {
        this.o = o;
        this.sw = sw;
        this.sc = sc;
        this.fc = fc;
        this.m = m;
        this.p = p;
        this._mdf = {
            o: true,
            sw: !!sw,
            sc: !!sc,
            fc: !!fc,
            m: true,
            p: true
        };
    }
    LetterProps.prototype.update = function(o, sw, sc, fc, m, p) {
        this._mdf.o = false;
        this._mdf.sw = false;
        this._mdf.sc = false;
        this._mdf.fc = false;
        this._mdf.m = false;
        this._mdf.p = false;
        var updated = false;
        if (this.o !== o) {
            this.o = o;
            this._mdf.o = true;
            updated = true;
        }
        if (this.sw !== sw) {
            this.sw = sw;
            this._mdf.sw = true;
            updated = true;
        }
        if (this.sc !== sc) {
            this.sc = sc;
            this._mdf.sc = true;
            updated = true;
        }
        if (this.fc !== fc) {
            this.fc = fc;
            this._mdf.fc = true;
            updated = true;
        }
        if (this.m !== m) {
            this.m = m;
            this._mdf.m = true;
            updated = true;
        }
        if (p.length && (this.p[0] !== p[0] || this.p[1] !== p[1] || this.p[4] !== p[4] || this.p[5] !== p[5] || this.p[12] !== p[12] || this.p[13] !== p[13])) {
            this.p = p;
            this._mdf.p = true;
            updated = true;
        }
        return updated;
    };
    function TextProperty(elem, data) {
        this._frameId = initialDefaultFrame;
        this.pv = "";
        this.v = "";
        this.kf = false;
        this._isFirstFrame = true;
        this._mdf = false;
        if (data.d && data.d.sid) data.d = elem.globalData.slotManager.getProp(data.d);
        this.data = data;
        this.elem = elem;
        this.comp = this.elem.comp;
        this.keysIndex = 0;
        this.canResize = false;
        this.minimumFontSize = 1;
        this.effectsSequence = [];
        this.currentData = {
            ascent: 0,
            boxWidth: this.defaultBoxWidth,
            f: "",
            fStyle: "",
            fWeight: "",
            fc: "",
            j: "",
            justifyOffset: "",
            l: [],
            lh: 0,
            lineWidths: [],
            ls: "",
            of: "",
            s: "",
            sc: "",
            sw: 0,
            t: 0,
            tr: 0,
            sz: 0,
            ps: null,
            fillColorAnim: false,
            strokeColorAnim: false,
            strokeWidthAnim: false,
            yOffset: 0,
            finalSize: 0,
            finalText: [],
            finalLineHeight: 0,
            __complete: false
        };
        this.copyData(this.currentData, this.data.d.k[0].s);
        if (!this.searchProperty()) this.completeTextData(this.currentData);
    }
    TextProperty.prototype.defaultBoxWidth = [
        0,
        0
    ];
    TextProperty.prototype.copyData = function(obj, data) {
        for(var s in data)if (Object.prototype.hasOwnProperty.call(data, s)) obj[s] = data[s];
        return obj;
    };
    TextProperty.prototype.setCurrentData = function(data) {
        if (!data.__complete) this.completeTextData(data);
        this.currentData = data;
        this.currentData.boxWidth = this.currentData.boxWidth || this.defaultBoxWidth;
        this._mdf = true;
    };
    TextProperty.prototype.searchProperty = function() {
        return this.searchKeyframes();
    };
    TextProperty.prototype.searchKeyframes = function() {
        this.kf = this.data.d.k.length > 1;
        if (this.kf) this.addEffect(this.getKeyframeValue.bind(this));
        return this.kf;
    };
    TextProperty.prototype.addEffect = function(effectFunction) {
        this.effectsSequence.push(effectFunction);
        this.elem.addDynamicProperty(this);
    };
    TextProperty.prototype.getValue = function(_finalValue) {
        if ((this.elem.globalData.frameId === this.frameId || !this.effectsSequence.length) && !_finalValue) return;
        this.currentData.t = this.data.d.k[this.keysIndex].s.t;
        var currentValue = this.currentData;
        var currentIndex = this.keysIndex;
        if (this.lock) {
            this.setCurrentData(this.currentData);
            return;
        }
        this.lock = true;
        this._mdf = false;
        var i;
        var len = this.effectsSequence.length;
        var finalValue = _finalValue || this.data.d.k[this.keysIndex].s;
        for(i = 0; i < len; i += 1)// Checking if index changed to prevent creating a new object every time the expression updates.
        if (currentIndex !== this.keysIndex) finalValue = this.effectsSequence[i](finalValue, finalValue.t);
        else finalValue = this.effectsSequence[i](this.currentData, finalValue.t);
        if (currentValue !== finalValue) this.setCurrentData(finalValue);
        this.v = this.currentData;
        this.pv = this.v;
        this.lock = false;
        this.frameId = this.elem.globalData.frameId;
    };
    TextProperty.prototype.getKeyframeValue = function() {
        var textKeys = this.data.d.k;
        var frameNum = this.elem.comp.renderedFrame;
        var i = 0;
        var len = textKeys.length;
        while(i <= len - 1){
            if (i === len - 1 || textKeys[i + 1].t > frameNum) break;
            i += 1;
        }
        if (this.keysIndex !== i) this.keysIndex = i;
        return this.data.d.k[this.keysIndex].s;
    };
    TextProperty.prototype.buildFinalText = function(text) {
        var charactersArray = [];
        var i = 0;
        var len = text.length;
        var charCode;
        var secondCharCode;
        var shouldCombine = false;
        var shouldCombineNext = false;
        var currentChars = "";
        while(i < len){
            shouldCombine = shouldCombineNext;
            shouldCombineNext = false;
            charCode = text.charCodeAt(i);
            currentChars = text.charAt(i);
            if (FontManager.isCombinedCharacter(charCode)) shouldCombine = true; // It's a potential surrogate pair (this is the High surrogate)
            else if (charCode >= 0xD800 && charCode <= 0xDBFF) {
                if (FontManager.isRegionalFlag(text, i)) currentChars = text.substr(i, 14);
                else {
                    secondCharCode = text.charCodeAt(i + 1); // It's a surrogate pair (this is the Low surrogate)
                    if (secondCharCode >= 0xDC00 && secondCharCode <= 0xDFFF) {
                        if (FontManager.isModifier(charCode, secondCharCode)) {
                            currentChars = text.substr(i, 2);
                            shouldCombine = true;
                        } else if (FontManager.isFlagEmoji(text.substr(i, 4))) currentChars = text.substr(i, 4);
                        else currentChars = text.substr(i, 2);
                    }
                }
            } else if (charCode > 0xDBFF) {
                secondCharCode = text.charCodeAt(i + 1);
                if (FontManager.isVariationSelector(charCode)) shouldCombine = true;
            } else if (FontManager.isZeroWidthJoiner(charCode)) {
                shouldCombine = true;
                shouldCombineNext = true;
            }
            if (shouldCombine) {
                charactersArray[charactersArray.length - 1] += currentChars;
                shouldCombine = false;
            } else charactersArray.push(currentChars);
            i += currentChars.length;
        }
        return charactersArray;
    };
    TextProperty.prototype.completeTextData = function(documentData) {
        documentData.__complete = true;
        var fontManager = this.elem.globalData.fontManager;
        var data = this.data;
        var letters = [];
        var i;
        var len;
        var newLineFlag;
        var index = 0;
        var val;
        var anchorGrouping = data.m.g;
        var currentSize = 0;
        var currentPos = 0;
        var currentLine = 0;
        var lineWidths = [];
        var lineWidth = 0;
        var maxLineWidth = 0;
        var j;
        var jLen;
        var fontData = fontManager.getFontByName(documentData.f);
        var charData;
        var cLength = 0;
        var fontProps = getFontProperties(fontData);
        documentData.fWeight = fontProps.weight;
        documentData.fStyle = fontProps.style;
        documentData.finalSize = documentData.s;
        documentData.finalText = this.buildFinalText(documentData.t);
        len = documentData.finalText.length;
        documentData.finalLineHeight = documentData.lh;
        var trackingOffset = documentData.tr / 1000 * documentData.finalSize;
        var charCode;
        if (documentData.sz) {
            var flag = true;
            var boxWidth = documentData.sz[0];
            var boxHeight = documentData.sz[1];
            var currentHeight;
            var finalText;
            while(flag){
                finalText = this.buildFinalText(documentData.t);
                currentHeight = 0;
                lineWidth = 0;
                len = finalText.length;
                trackingOffset = documentData.tr / 1000 * documentData.finalSize;
                var lastSpaceIndex = -1;
                for(i = 0; i < len; i += 1){
                    charCode = finalText[i].charCodeAt(0);
                    newLineFlag = false;
                    if (finalText[i] === " ") lastSpaceIndex = i;
                    else if (charCode === 13 || charCode === 3) {
                        lineWidth = 0;
                        newLineFlag = true;
                        currentHeight += documentData.finalLineHeight || documentData.finalSize * 1.2;
                    }
                    if (fontManager.chars) {
                        charData = fontManager.getCharData(finalText[i], fontData.fStyle, fontData.fFamily);
                        cLength = newLineFlag ? 0 : charData.w * documentData.finalSize / 100;
                    } else // tCanvasHelper.font = documentData.s + 'px '+ fontData.fFamily;
                    cLength = fontManager.measureText(finalText[i], documentData.f, documentData.finalSize);
                    if (lineWidth + cLength > boxWidth && finalText[i] !== " ") {
                        if (lastSpaceIndex === -1) len += 1;
                        else i = lastSpaceIndex;
                        currentHeight += documentData.finalLineHeight || documentData.finalSize * 1.2;
                        finalText.splice(i, lastSpaceIndex === i ? 1 : 0, "\r"); // finalText = finalText.substr(0,i) + "\r" + finalText.substr(i === lastSpaceIndex ? i + 1 : i);
                        lastSpaceIndex = -1;
                        lineWidth = 0;
                    } else {
                        lineWidth += cLength;
                        lineWidth += trackingOffset;
                    }
                }
                currentHeight += fontData.ascent * documentData.finalSize / 100;
                if (this.canResize && documentData.finalSize > this.minimumFontSize && boxHeight < currentHeight) {
                    documentData.finalSize -= 1;
                    documentData.finalLineHeight = documentData.finalSize * documentData.lh / documentData.s;
                } else {
                    documentData.finalText = finalText;
                    len = documentData.finalText.length;
                    flag = false;
                }
            }
        }
        lineWidth = -trackingOffset;
        cLength = 0;
        var uncollapsedSpaces = 0;
        var currentChar;
        for(i = 0; i < len; i += 1){
            newLineFlag = false;
            currentChar = documentData.finalText[i];
            charCode = currentChar.charCodeAt(0);
            if (charCode === 13 || charCode === 3) {
                uncollapsedSpaces = 0;
                lineWidths.push(lineWidth);
                maxLineWidth = lineWidth > maxLineWidth ? lineWidth : maxLineWidth;
                lineWidth = -2 * trackingOffset;
                val = "";
                newLineFlag = true;
                currentLine += 1;
            } else val = currentChar;
            if (fontManager.chars) {
                charData = fontManager.getCharData(currentChar, fontData.fStyle, fontManager.getFontByName(documentData.f).fFamily);
                cLength = newLineFlag ? 0 : charData.w * documentData.finalSize / 100;
            } else // var charWidth = fontManager.measureText(val, documentData.f, documentData.finalSize);
            // tCanvasHelper.font = documentData.finalSize + 'px '+ fontManager.getFontByName(documentData.f).fFamily;
            cLength = fontManager.measureText(val, documentData.f, documentData.finalSize);
             //
            if (currentChar === " ") uncollapsedSpaces += cLength + trackingOffset;
            else {
                lineWidth += cLength + trackingOffset + uncollapsedSpaces;
                uncollapsedSpaces = 0;
            }
            letters.push({
                l: cLength,
                an: cLength,
                add: currentSize,
                n: newLineFlag,
                anIndexes: [],
                val: val,
                line: currentLine,
                animatorJustifyOffset: 0
            });
            if (anchorGrouping == 2) {
                // eslint-disable-line eqeqeq
                currentSize += cLength;
                if (val === "" || val === " " || i === len - 1) {
                    if (val === "" || val === " ") currentSize -= cLength;
                    while(currentPos <= i){
                        letters[currentPos].an = currentSize;
                        letters[currentPos].ind = index;
                        letters[currentPos].extra = cLength;
                        currentPos += 1;
                    }
                    index += 1;
                    currentSize = 0;
                }
            } else if (anchorGrouping == 3) {
                // eslint-disable-line eqeqeq
                currentSize += cLength;
                if (val === "" || i === len - 1) {
                    if (val === "") currentSize -= cLength;
                    while(currentPos <= i){
                        letters[currentPos].an = currentSize;
                        letters[currentPos].ind = index;
                        letters[currentPos].extra = cLength;
                        currentPos += 1;
                    }
                    currentSize = 0;
                    index += 1;
                }
            } else {
                letters[index].ind = index;
                letters[index].extra = 0;
                index += 1;
            }
        }
        documentData.l = letters;
        maxLineWidth = lineWidth > maxLineWidth ? lineWidth : maxLineWidth;
        lineWidths.push(lineWidth);
        if (documentData.sz) {
            documentData.boxWidth = documentData.sz[0];
            documentData.justifyOffset = 0;
        } else {
            documentData.boxWidth = maxLineWidth;
            switch(documentData.j){
                case 1:
                    documentData.justifyOffset = -documentData.boxWidth;
                    break;
                case 2:
                    documentData.justifyOffset = -documentData.boxWidth / 2;
                    break;
                default:
                    documentData.justifyOffset = 0;
            }
        }
        documentData.lineWidths = lineWidths;
        var animators = data.a;
        var animatorData;
        var letterData;
        jLen = animators.length;
        var based;
        var ind;
        var indexes = [];
        for(j = 0; j < jLen; j += 1){
            animatorData = animators[j];
            if (animatorData.a.sc) documentData.strokeColorAnim = true;
            if (animatorData.a.sw) documentData.strokeWidthAnim = true;
            if (animatorData.a.fc || animatorData.a.fh || animatorData.a.fs || animatorData.a.fb) documentData.fillColorAnim = true;
            ind = 0;
            based = animatorData.s.b;
            for(i = 0; i < len; i += 1){
                letterData = letters[i];
                letterData.anIndexes[j] = ind;
                if (based == 1 && letterData.val !== "" || based == 2 && letterData.val !== "" && letterData.val !== " " || based == 3 && (letterData.n || letterData.val == " " || i == len - 1) || based == 4 && (letterData.n || i == len - 1)) {
                    // eslint-disable-line eqeqeq
                    if (animatorData.s.rn === 1) indexes.push(ind);
                    ind += 1;
                }
            }
            data.a[j].s.totalChars = ind;
            var currentInd = -1;
            var newInd;
            if (animatorData.s.rn === 1) for(i = 0; i < len; i += 1){
                letterData = letters[i];
                if (currentInd != letterData.anIndexes[j]) {
                    // eslint-disable-line eqeqeq
                    currentInd = letterData.anIndexes[j];
                    newInd = indexes.splice(Math.floor(Math.random() * indexes.length), 1)[0];
                }
                letterData.anIndexes[j] = newInd;
            }
        }
        documentData.yOffset = documentData.finalLineHeight || documentData.finalSize * 1.2;
        documentData.ls = documentData.ls || 0;
        documentData.ascent = fontData.ascent * documentData.finalSize / 100;
    };
    TextProperty.prototype.updateDocumentData = function(newData, index) {
        index = index === undefined ? this.keysIndex : index;
        var dData = this.copyData({}, this.data.d.k[index].s);
        dData = this.copyData(dData, newData);
        this.data.d.k[index].s = dData;
        this.recalculate(index);
        this.setCurrentData(dData);
        this.elem.addDynamicProperty(this);
    };
    TextProperty.prototype.recalculate = function(index) {
        var dData = this.data.d.k[index].s;
        dData.__complete = false;
        this.keysIndex = 0;
        this._isFirstFrame = true;
        this.getValue(dData);
    };
    TextProperty.prototype.canResizeFont = function(_canResize) {
        this.canResize = _canResize;
        this.recalculate(this.keysIndex);
        this.elem.addDynamicProperty(this);
    };
    TextProperty.prototype.setMinimumFontSize = function(_fontValue) {
        this.minimumFontSize = Math.floor(_fontValue) || 1;
        this.recalculate(this.keysIndex);
        this.elem.addDynamicProperty(this);
    };
    var TextSelectorProp = function() {
        var max = Math.max;
        var min = Math.min;
        var floor = Math.floor;
        function TextSelectorPropFactory(elem, data) {
            this._currentTextLength = -1;
            this.k = false;
            this.data = data;
            this.elem = elem;
            this.comp = elem.comp;
            this.finalS = 0;
            this.finalE = 0;
            this.initDynamicPropertyContainer(elem);
            this.s = PropertyFactory.getProp(elem, data.s || {
                k: 0
            }, 0, 0, this);
            if ("e" in data) this.e = PropertyFactory.getProp(elem, data.e, 0, 0, this);
            else this.e = {
                v: 100
            };
            this.o = PropertyFactory.getProp(elem, data.o || {
                k: 0
            }, 0, 0, this);
            this.xe = PropertyFactory.getProp(elem, data.xe || {
                k: 0
            }, 0, 0, this);
            this.ne = PropertyFactory.getProp(elem, data.ne || {
                k: 0
            }, 0, 0, this);
            this.sm = PropertyFactory.getProp(elem, data.sm || {
                k: 100
            }, 0, 0, this);
            this.a = PropertyFactory.getProp(elem, data.a, 0, 0.01, this);
            if (!this.dynamicProperties.length) this.getValue();
        }
        TextSelectorPropFactory.prototype = {
            getMult: function getMult(ind) {
                if (this._currentTextLength !== this.elem.textProperty.currentData.l.length) this.getValue();
                var x1 = 0;
                var y1 = 0;
                var x2 = 1;
                var y2 = 1;
                if (this.ne.v > 0) x1 = this.ne.v / 100.0;
                else y1 = -this.ne.v / 100.0;
                if (this.xe.v > 0) x2 = 1.0 - this.xe.v / 100.0;
                else y2 = 1.0 + this.xe.v / 100.0;
                var easer = BezierFactory.getBezierEasing(x1, y1, x2, y2).get;
                var mult = 0;
                var s = this.finalS;
                var e = this.finalE;
                var type = this.data.sh;
                if (type === 2) {
                    if (e === s) mult = ind >= e ? 1 : 0;
                    else mult = max(0, min(0.5 / (e - s) + (ind - s) / (e - s), 1));
                    mult = easer(mult);
                } else if (type === 3) {
                    if (e === s) mult = ind >= e ? 0 : 1;
                    else mult = 1 - max(0, min(0.5 / (e - s) + (ind - s) / (e - s), 1));
                    mult = easer(mult);
                } else if (type === 4) {
                    if (e === s) mult = 0;
                    else {
                        mult = max(0, min(0.5 / (e - s) + (ind - s) / (e - s), 1));
                        if (mult < 0.5) mult *= 2;
                        else mult = 1 - 2 * (mult - 0.5);
                    }
                    mult = easer(mult);
                } else if (type === 5) {
                    if (e === s) mult = 0;
                    else {
                        var tot = e - s;
                        /* ind += 0.5;
                      mult = -4/(tot*tot)*(ind*ind)+(4/tot)*ind; */ ind = min(max(0, ind + 0.5 - s), e - s);
                        var x = -tot / 2 + ind;
                        var a = tot / 2;
                        mult = Math.sqrt(1 - x * x / (a * a));
                    }
                    mult = easer(mult);
                } else if (type === 6) {
                    if (e === s) mult = 0;
                    else {
                        ind = min(max(0, ind + 0.5 - s), e - s);
                        mult = (1 + Math.cos(Math.PI + Math.PI * 2 * ind / (e - s))) / 2; // eslint-disable-line
                    }
                    mult = easer(mult);
                } else {
                    if (ind >= floor(s)) {
                        if (ind - s < 0) mult = max(0, min(min(e, 1) - (s - ind), 1));
                        else mult = max(0, min(e - ind, 1));
                    }
                    mult = easer(mult);
                } // Smoothness implementation.
                // The smoothness represents a reduced range of the original [0; 1] range.
                // if smoothness is 25%, the new range will be [0.375; 0.625]
                // Steps are:
                // - find the lower value of the new range (threshold)
                // - if multiplier is smaller than that value, floor it to 0
                // - if it is larger,
                //     - subtract the threshold
                //     - divide it by the smoothness (this will return the range to [0; 1])
                // Note: If it doesn't work on some scenarios, consider applying it before the easer.
                if (this.sm.v !== 100) {
                    var smoothness = this.sm.v * 0.01;
                    if (smoothness === 0) smoothness = 0.00000001;
                    var threshold = 0.5 - smoothness * 0.5;
                    if (mult < threshold) mult = 0;
                    else {
                        mult = (mult - threshold) / smoothness;
                        if (mult > 1) mult = 1;
                    }
                }
                return mult * this.a.v;
            },
            getValue: function getValue(newCharsFlag) {
                this.iterateDynamicProperties();
                this._mdf = newCharsFlag || this._mdf;
                this._currentTextLength = this.elem.textProperty.currentData.l.length || 0;
                if (newCharsFlag && this.data.r === 2) this.e.v = this._currentTextLength;
                var divisor = this.data.r === 2 ? 1 : 100 / this.data.totalChars;
                var o = this.o.v / divisor;
                var s = this.s.v / divisor + o;
                var e = this.e.v / divisor + o;
                if (s > e) {
                    var _s = s;
                    s = e;
                    e = _s;
                }
                this.finalS = s;
                this.finalE = e;
            }
        };
        extendPrototype([
            DynamicPropertyContainer
        ], TextSelectorPropFactory);
        function getTextSelectorProp(elem, data, arr) {
            return new TextSelectorPropFactory(elem, data, arr);
        }
        return {
            getTextSelectorProp: getTextSelectorProp
        };
    }();
    function TextAnimatorDataProperty(elem, animatorProps, container) {
        var defaultData = {
            propType: false
        };
        var getProp = PropertyFactory.getProp;
        var textAnimatorAnimatables = animatorProps.a;
        this.a = {
            r: textAnimatorAnimatables.r ? getProp(elem, textAnimatorAnimatables.r, 0, degToRads, container) : defaultData,
            rx: textAnimatorAnimatables.rx ? getProp(elem, textAnimatorAnimatables.rx, 0, degToRads, container) : defaultData,
            ry: textAnimatorAnimatables.ry ? getProp(elem, textAnimatorAnimatables.ry, 0, degToRads, container) : defaultData,
            sk: textAnimatorAnimatables.sk ? getProp(elem, textAnimatorAnimatables.sk, 0, degToRads, container) : defaultData,
            sa: textAnimatorAnimatables.sa ? getProp(elem, textAnimatorAnimatables.sa, 0, degToRads, container) : defaultData,
            s: textAnimatorAnimatables.s ? getProp(elem, textAnimatorAnimatables.s, 1, 0.01, container) : defaultData,
            a: textAnimatorAnimatables.a ? getProp(elem, textAnimatorAnimatables.a, 1, 0, container) : defaultData,
            o: textAnimatorAnimatables.o ? getProp(elem, textAnimatorAnimatables.o, 0, 0.01, container) : defaultData,
            p: textAnimatorAnimatables.p ? getProp(elem, textAnimatorAnimatables.p, 1, 0, container) : defaultData,
            sw: textAnimatorAnimatables.sw ? getProp(elem, textAnimatorAnimatables.sw, 0, 0, container) : defaultData,
            sc: textAnimatorAnimatables.sc ? getProp(elem, textAnimatorAnimatables.sc, 1, 0, container) : defaultData,
            fc: textAnimatorAnimatables.fc ? getProp(elem, textAnimatorAnimatables.fc, 1, 0, container) : defaultData,
            fh: textAnimatorAnimatables.fh ? getProp(elem, textAnimatorAnimatables.fh, 0, 0, container) : defaultData,
            fs: textAnimatorAnimatables.fs ? getProp(elem, textAnimatorAnimatables.fs, 0, 0.01, container) : defaultData,
            fb: textAnimatorAnimatables.fb ? getProp(elem, textAnimatorAnimatables.fb, 0, 0.01, container) : defaultData,
            t: textAnimatorAnimatables.t ? getProp(elem, textAnimatorAnimatables.t, 0, 0, container) : defaultData
        };
        this.s = TextSelectorProp.getTextSelectorProp(elem, animatorProps.s, container);
        this.s.t = animatorProps.s.t;
    }
    function TextAnimatorProperty(textData, renderType, elem) {
        this._isFirstFrame = true;
        this._hasMaskedPath = false;
        this._frameId = -1;
        this._textData = textData;
        this._renderType = renderType;
        this._elem = elem;
        this._animatorsData = createSizedArray(this._textData.a.length);
        this._pathData = {};
        this._moreOptions = {
            alignment: {}
        };
        this.renderedLetters = [];
        this.lettersChangedFlag = false;
        this.initDynamicPropertyContainer(elem);
    }
    TextAnimatorProperty.prototype.searchProperties = function() {
        var i;
        var len = this._textData.a.length;
        var animatorProps;
        var getProp = PropertyFactory.getProp;
        for(i = 0; i < len; i += 1){
            animatorProps = this._textData.a[i];
            this._animatorsData[i] = new TextAnimatorDataProperty(this._elem, animatorProps, this);
        }
        if (this._textData.p && "m" in this._textData.p) {
            this._pathData = {
                a: getProp(this._elem, this._textData.p.a, 0, 0, this),
                f: getProp(this._elem, this._textData.p.f, 0, 0, this),
                l: getProp(this._elem, this._textData.p.l, 0, 0, this),
                r: getProp(this._elem, this._textData.p.r, 0, 0, this),
                p: getProp(this._elem, this._textData.p.p, 0, 0, this),
                m: this._elem.maskManager.getMaskProperty(this._textData.p.m)
            };
            this._hasMaskedPath = true;
        } else this._hasMaskedPath = false;
        this._moreOptions.alignment = getProp(this._elem, this._textData.m.a, 1, 0, this);
    };
    TextAnimatorProperty.prototype.getMeasures = function(documentData, lettersChangedFlag) {
        this.lettersChangedFlag = lettersChangedFlag;
        if (!this._mdf && !this._isFirstFrame && !lettersChangedFlag && (!this._hasMaskedPath || !this._pathData.m._mdf)) return;
        this._isFirstFrame = false;
        var alignment = this._moreOptions.alignment.v;
        var animators = this._animatorsData;
        var textData = this._textData;
        var matrixHelper = this.mHelper;
        var renderType = this._renderType;
        var renderedLettersCount = this.renderedLetters.length;
        var xPos;
        var yPos;
        var i;
        var len;
        var letters = documentData.l;
        var pathInfo;
        var currentLength;
        var currentPoint;
        var segmentLength;
        var flag;
        var pointInd;
        var segmentInd;
        var prevPoint;
        var points;
        var segments;
        var partialLength;
        var totalLength;
        var perc;
        var tanAngle;
        var mask;
        if (this._hasMaskedPath) {
            mask = this._pathData.m;
            if (!this._pathData.n || this._pathData._mdf) {
                var paths = mask.v;
                if (this._pathData.r.v) paths = paths.reverse();
                 // TODO: release bezier data cached from previous pathInfo: this._pathData.pi
                pathInfo = {
                    tLength: 0,
                    segments: []
                };
                len = paths._length - 1;
                var bezierData;
                totalLength = 0;
                for(i = 0; i < len; i += 1){
                    bezierData = bez.buildBezierData(paths.v[i], paths.v[i + 1], [
                        paths.o[i][0] - paths.v[i][0],
                        paths.o[i][1] - paths.v[i][1]
                    ], [
                        paths.i[i + 1][0] - paths.v[i + 1][0],
                        paths.i[i + 1][1] - paths.v[i + 1][1]
                    ]);
                    pathInfo.tLength += bezierData.segmentLength;
                    pathInfo.segments.push(bezierData);
                    totalLength += bezierData.segmentLength;
                }
                i = len;
                if (mask.v.c) {
                    bezierData = bez.buildBezierData(paths.v[i], paths.v[0], [
                        paths.o[i][0] - paths.v[i][0],
                        paths.o[i][1] - paths.v[i][1]
                    ], [
                        paths.i[0][0] - paths.v[0][0],
                        paths.i[0][1] - paths.v[0][1]
                    ]);
                    pathInfo.tLength += bezierData.segmentLength;
                    pathInfo.segments.push(bezierData);
                    totalLength += bezierData.segmentLength;
                }
                this._pathData.pi = pathInfo;
            }
            pathInfo = this._pathData.pi;
            currentLength = this._pathData.f.v;
            segmentInd = 0;
            pointInd = 1;
            segmentLength = 0;
            flag = true;
            segments = pathInfo.segments;
            if (currentLength < 0 && mask.v.c) {
                if (pathInfo.tLength < Math.abs(currentLength)) currentLength = -Math.abs(currentLength) % pathInfo.tLength;
                segmentInd = segments.length - 1;
                points = segments[segmentInd].points;
                pointInd = points.length - 1;
                while(currentLength < 0){
                    currentLength += points[pointInd].partialLength;
                    pointInd -= 1;
                    if (pointInd < 0) {
                        segmentInd -= 1;
                        points = segments[segmentInd].points;
                        pointInd = points.length - 1;
                    }
                }
            }
            points = segments[segmentInd].points;
            prevPoint = points[pointInd - 1];
            currentPoint = points[pointInd];
            partialLength = currentPoint.partialLength;
        }
        len = letters.length;
        xPos = 0;
        yPos = 0;
        var yOff = documentData.finalSize * 1.2 * 0.714;
        var firstLine = true;
        var animatorProps;
        var animatorSelector;
        var j;
        var jLen;
        var letterValue;
        jLen = animators.length;
        var mult;
        var ind = -1;
        var offf;
        var xPathPos;
        var yPathPos;
        var initPathPos = currentLength;
        var initSegmentInd = segmentInd;
        var initPointInd = pointInd;
        var currentLine = -1;
        var elemOpacity;
        var sc;
        var sw;
        var fc;
        var k;
        var letterSw;
        var letterSc;
        var letterFc;
        var letterM = "";
        var letterP = this.defaultPropsArray;
        var letterO; //
        if (documentData.j === 2 || documentData.j === 1) {
            var animatorJustifyOffset = 0;
            var animatorFirstCharOffset = 0;
            var justifyOffsetMult = documentData.j === 2 ? -0.5 : -1;
            var lastIndex = 0;
            var isNewLine = true;
            for(i = 0; i < len; i += 1)if (letters[i].n) {
                if (animatorJustifyOffset) animatorJustifyOffset += animatorFirstCharOffset;
                while(lastIndex < i){
                    letters[lastIndex].animatorJustifyOffset = animatorJustifyOffset;
                    lastIndex += 1;
                }
                animatorJustifyOffset = 0;
                isNewLine = true;
            } else {
                for(j = 0; j < jLen; j += 1){
                    animatorProps = animators[j].a;
                    if (animatorProps.t.propType) {
                        if (isNewLine && documentData.j === 2) animatorFirstCharOffset += animatorProps.t.v * justifyOffsetMult;
                        animatorSelector = animators[j].s;
                        mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars);
                        if (mult.length) animatorJustifyOffset += animatorProps.t.v * mult[0] * justifyOffsetMult;
                        else animatorJustifyOffset += animatorProps.t.v * mult * justifyOffsetMult;
                    }
                }
                isNewLine = false;
            }
            if (animatorJustifyOffset) animatorJustifyOffset += animatorFirstCharOffset;
            while(lastIndex < i){
                letters[lastIndex].animatorJustifyOffset = animatorJustifyOffset;
                lastIndex += 1;
            }
        } //
        for(i = 0; i < len; i += 1){
            matrixHelper.reset();
            elemOpacity = 1;
            if (letters[i].n) {
                xPos = 0;
                yPos += documentData.yOffset;
                yPos += firstLine ? 1 : 0;
                currentLength = initPathPos;
                firstLine = false;
                if (this._hasMaskedPath) {
                    segmentInd = initSegmentInd;
                    pointInd = initPointInd;
                    points = segments[segmentInd].points;
                    prevPoint = points[pointInd - 1];
                    currentPoint = points[pointInd];
                    partialLength = currentPoint.partialLength;
                    segmentLength = 0;
                }
                letterM = "";
                letterFc = "";
                letterSw = "";
                letterO = "";
                letterP = this.defaultPropsArray;
            } else {
                if (this._hasMaskedPath) {
                    if (currentLine !== letters[i].line) {
                        switch(documentData.j){
                            case 1:
                                currentLength += totalLength - documentData.lineWidths[letters[i].line];
                                break;
                            case 2:
                                currentLength += (totalLength - documentData.lineWidths[letters[i].line]) / 2;
                                break;
                            default:
                                break;
                        }
                        currentLine = letters[i].line;
                    }
                    if (ind !== letters[i].ind) {
                        if (letters[ind]) currentLength += letters[ind].extra;
                        currentLength += letters[i].an / 2;
                        ind = letters[i].ind;
                    }
                    currentLength += alignment[0] * letters[i].an * 0.005;
                    var animatorOffset = 0;
                    for(j = 0; j < jLen; j += 1){
                        animatorProps = animators[j].a;
                        if (animatorProps.p.propType) {
                            animatorSelector = animators[j].s;
                            mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars);
                            if (mult.length) animatorOffset += animatorProps.p.v[0] * mult[0];
                            else animatorOffset += animatorProps.p.v[0] * mult;
                        }
                        if (animatorProps.a.propType) {
                            animatorSelector = animators[j].s;
                            mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars);
                            if (mult.length) animatorOffset += animatorProps.a.v[0] * mult[0];
                            else animatorOffset += animatorProps.a.v[0] * mult;
                        }
                    }
                    flag = true; // Force alignment only works with a single line for now
                    if (this._pathData.a.v) {
                        currentLength = letters[0].an * 0.5 + (totalLength - this._pathData.f.v - letters[0].an * 0.5 - letters[letters.length - 1].an * 0.5) * ind / (len - 1);
                        currentLength += this._pathData.f.v;
                    }
                    while(flag){
                        if (segmentLength + partialLength >= currentLength + animatorOffset || !points) {
                            perc = (currentLength + animatorOffset - segmentLength) / currentPoint.partialLength;
                            xPathPos = prevPoint.point[0] + (currentPoint.point[0] - prevPoint.point[0]) * perc;
                            yPathPos = prevPoint.point[1] + (currentPoint.point[1] - prevPoint.point[1]) * perc;
                            matrixHelper.translate(-alignment[0] * letters[i].an * 0.005, -(alignment[1] * yOff) * 0.01);
                            flag = false;
                        } else if (points) {
                            segmentLength += currentPoint.partialLength;
                            pointInd += 1;
                            if (pointInd >= points.length) {
                                pointInd = 0;
                                segmentInd += 1;
                                if (!segments[segmentInd]) {
                                    if (mask.v.c) {
                                        pointInd = 0;
                                        segmentInd = 0;
                                        points = segments[segmentInd].points;
                                    } else {
                                        segmentLength -= currentPoint.partialLength;
                                        points = null;
                                    }
                                } else points = segments[segmentInd].points;
                            }
                            if (points) {
                                prevPoint = currentPoint;
                                currentPoint = points[pointInd];
                                partialLength = currentPoint.partialLength;
                            }
                        }
                    }
                    offf = letters[i].an / 2 - letters[i].add;
                    matrixHelper.translate(-offf, 0, 0);
                } else {
                    offf = letters[i].an / 2 - letters[i].add;
                    matrixHelper.translate(-offf, 0, 0); // Grouping alignment
                    matrixHelper.translate(-alignment[0] * letters[i].an * 0.005, -alignment[1] * yOff * 0.01, 0);
                }
                for(j = 0; j < jLen; j += 1){
                    animatorProps = animators[j].a;
                    if (animatorProps.t.propType) {
                        animatorSelector = animators[j].s;
                        mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars); // This condition is to prevent applying tracking to first character in each line. Might be better to use a boolean "isNewLine"
                        if (xPos !== 0 || documentData.j !== 0) {
                            if (this._hasMaskedPath) {
                                if (mult.length) currentLength += animatorProps.t.v * mult[0];
                                else currentLength += animatorProps.t.v * mult;
                            } else if (mult.length) xPos += animatorProps.t.v * mult[0];
                            else xPos += animatorProps.t.v * mult;
                        }
                    }
                }
                if (documentData.strokeWidthAnim) sw = documentData.sw || 0;
                if (documentData.strokeColorAnim) {
                    if (documentData.sc) sc = [
                        documentData.sc[0],
                        documentData.sc[1],
                        documentData.sc[2]
                    ];
                    else sc = [
                        0,
                        0,
                        0
                    ];
                }
                if (documentData.fillColorAnim && documentData.fc) fc = [
                    documentData.fc[0],
                    documentData.fc[1],
                    documentData.fc[2]
                ];
                for(j = 0; j < jLen; j += 1){
                    animatorProps = animators[j].a;
                    if (animatorProps.a.propType) {
                        animatorSelector = animators[j].s;
                        mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars);
                        if (mult.length) matrixHelper.translate(-animatorProps.a.v[0] * mult[0], -animatorProps.a.v[1] * mult[1], animatorProps.a.v[2] * mult[2]);
                        else matrixHelper.translate(-animatorProps.a.v[0] * mult, -animatorProps.a.v[1] * mult, animatorProps.a.v[2] * mult);
                    }
                }
                for(j = 0; j < jLen; j += 1){
                    animatorProps = animators[j].a;
                    if (animatorProps.s.propType) {
                        animatorSelector = animators[j].s;
                        mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars);
                        if (mult.length) matrixHelper.scale(1 + (animatorProps.s.v[0] - 1) * mult[0], 1 + (animatorProps.s.v[1] - 1) * mult[1], 1);
                        else matrixHelper.scale(1 + (animatorProps.s.v[0] - 1) * mult, 1 + (animatorProps.s.v[1] - 1) * mult, 1);
                    }
                }
                for(j = 0; j < jLen; j += 1){
                    animatorProps = animators[j].a;
                    animatorSelector = animators[j].s;
                    mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars);
                    if (animatorProps.sk.propType) {
                        if (mult.length) matrixHelper.skewFromAxis(-animatorProps.sk.v * mult[0], animatorProps.sa.v * mult[1]);
                        else matrixHelper.skewFromAxis(-animatorProps.sk.v * mult, animatorProps.sa.v * mult);
                    }
                    if (animatorProps.r.propType) {
                        if (mult.length) matrixHelper.rotateZ(-animatorProps.r.v * mult[2]);
                        else matrixHelper.rotateZ(-animatorProps.r.v * mult);
                    }
                    if (animatorProps.ry.propType) {
                        if (mult.length) matrixHelper.rotateY(animatorProps.ry.v * mult[1]);
                        else matrixHelper.rotateY(animatorProps.ry.v * mult);
                    }
                    if (animatorProps.rx.propType) {
                        if (mult.length) matrixHelper.rotateX(animatorProps.rx.v * mult[0]);
                        else matrixHelper.rotateX(animatorProps.rx.v * mult);
                    }
                    if (animatorProps.o.propType) {
                        if (mult.length) elemOpacity += (animatorProps.o.v * mult[0] - elemOpacity) * mult[0];
                        else elemOpacity += (animatorProps.o.v * mult - elemOpacity) * mult;
                    }
                    if (documentData.strokeWidthAnim && animatorProps.sw.propType) {
                        if (mult.length) sw += animatorProps.sw.v * mult[0];
                        else sw += animatorProps.sw.v * mult;
                    }
                    if (documentData.strokeColorAnim && animatorProps.sc.propType) {
                        for(k = 0; k < 3; k += 1)if (mult.length) sc[k] += (animatorProps.sc.v[k] - sc[k]) * mult[0];
                        else sc[k] += (animatorProps.sc.v[k] - sc[k]) * mult;
                    }
                    if (documentData.fillColorAnim && documentData.fc) {
                        if (animatorProps.fc.propType) {
                            for(k = 0; k < 3; k += 1)if (mult.length) fc[k] += (animatorProps.fc.v[k] - fc[k]) * mult[0];
                            else fc[k] += (animatorProps.fc.v[k] - fc[k]) * mult;
                        }
                        if (animatorProps.fh.propType) {
                            if (mult.length) fc = addHueToRGB(fc, animatorProps.fh.v * mult[0]);
                            else fc = addHueToRGB(fc, animatorProps.fh.v * mult);
                        }
                        if (animatorProps.fs.propType) {
                            if (mult.length) fc = addSaturationToRGB(fc, animatorProps.fs.v * mult[0]);
                            else fc = addSaturationToRGB(fc, animatorProps.fs.v * mult);
                        }
                        if (animatorProps.fb.propType) {
                            if (mult.length) fc = addBrightnessToRGB(fc, animatorProps.fb.v * mult[0]);
                            else fc = addBrightnessToRGB(fc, animatorProps.fb.v * mult);
                        }
                    }
                }
                for(j = 0; j < jLen; j += 1){
                    animatorProps = animators[j].a;
                    if (animatorProps.p.propType) {
                        animatorSelector = animators[j].s;
                        mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars);
                        if (this._hasMaskedPath) {
                            if (mult.length) matrixHelper.translate(0, animatorProps.p.v[1] * mult[0], -animatorProps.p.v[2] * mult[1]);
                            else matrixHelper.translate(0, animatorProps.p.v[1] * mult, -animatorProps.p.v[2] * mult);
                        } else if (mult.length) matrixHelper.translate(animatorProps.p.v[0] * mult[0], animatorProps.p.v[1] * mult[1], -animatorProps.p.v[2] * mult[2]);
                        else matrixHelper.translate(animatorProps.p.v[0] * mult, animatorProps.p.v[1] * mult, -animatorProps.p.v[2] * mult);
                    }
                }
                if (documentData.strokeWidthAnim) letterSw = sw < 0 ? 0 : sw;
                if (documentData.strokeColorAnim) letterSc = "rgb(" + Math.round(sc[0] * 255) + "," + Math.round(sc[1] * 255) + "," + Math.round(sc[2] * 255) + ")";
                if (documentData.fillColorAnim && documentData.fc) letterFc = "rgb(" + Math.round(fc[0] * 255) + "," + Math.round(fc[1] * 255) + "," + Math.round(fc[2] * 255) + ")";
                if (this._hasMaskedPath) {
                    matrixHelper.translate(0, -documentData.ls);
                    matrixHelper.translate(0, alignment[1] * yOff * 0.01 + yPos, 0);
                    if (this._pathData.p.v) {
                        tanAngle = (currentPoint.point[1] - prevPoint.point[1]) / (currentPoint.point[0] - prevPoint.point[0]);
                        var rot = Math.atan(tanAngle) * 180 / Math.PI;
                        if (currentPoint.point[0] < prevPoint.point[0]) rot += 180;
                        matrixHelper.rotate(-rot * Math.PI / 180);
                    }
                    matrixHelper.translate(xPathPos, yPathPos, 0);
                    currentLength -= alignment[0] * letters[i].an * 0.005;
                    if (letters[i + 1] && ind !== letters[i + 1].ind) {
                        currentLength += letters[i].an / 2;
                        currentLength += documentData.tr * 0.001 * documentData.finalSize;
                    }
                } else {
                    matrixHelper.translate(xPos, yPos, 0);
                    if (documentData.ps) // matrixHelper.translate(documentData.ps[0],documentData.ps[1],0);
                    matrixHelper.translate(documentData.ps[0], documentData.ps[1] + documentData.ascent, 0);
                    switch(documentData.j){
                        case 1:
                            matrixHelper.translate(letters[i].animatorJustifyOffset + documentData.justifyOffset + (documentData.boxWidth - documentData.lineWidths[letters[i].line]), 0, 0);
                            break;
                        case 2:
                            matrixHelper.translate(letters[i].animatorJustifyOffset + documentData.justifyOffset + (documentData.boxWidth - documentData.lineWidths[letters[i].line]) / 2, 0, 0);
                            break;
                        default:
                            break;
                    }
                    matrixHelper.translate(0, -documentData.ls);
                    matrixHelper.translate(offf, 0, 0);
                    matrixHelper.translate(alignment[0] * letters[i].an * 0.005, alignment[1] * yOff * 0.01, 0);
                    xPos += letters[i].l + documentData.tr * 0.001 * documentData.finalSize;
                }
                if (renderType === "html") letterM = matrixHelper.toCSS();
                else if (renderType === "svg") letterM = matrixHelper.to2dCSS();
                else letterP = [
                    matrixHelper.props[0],
                    matrixHelper.props[1],
                    matrixHelper.props[2],
                    matrixHelper.props[3],
                    matrixHelper.props[4],
                    matrixHelper.props[5],
                    matrixHelper.props[6],
                    matrixHelper.props[7],
                    matrixHelper.props[8],
                    matrixHelper.props[9],
                    matrixHelper.props[10],
                    matrixHelper.props[11],
                    matrixHelper.props[12],
                    matrixHelper.props[13],
                    matrixHelper.props[14],
                    matrixHelper.props[15]
                ];
                letterO = elemOpacity;
            }
            if (renderedLettersCount <= i) {
                letterValue = new LetterProps(letterO, letterSw, letterSc, letterFc, letterM, letterP);
                this.renderedLetters.push(letterValue);
                renderedLettersCount += 1;
                this.lettersChangedFlag = true;
            } else {
                letterValue = this.renderedLetters[i];
                this.lettersChangedFlag = letterValue.update(letterO, letterSw, letterSc, letterFc, letterM, letterP) || this.lettersChangedFlag;
            }
        }
    };
    TextAnimatorProperty.prototype.getValue = function() {
        if (this._elem.globalData.frameId === this._frameId) return;
        this._frameId = this._elem.globalData.frameId;
        this.iterateDynamicProperties();
    };
    TextAnimatorProperty.prototype.mHelper = new Matrix();
    TextAnimatorProperty.prototype.defaultPropsArray = [];
    extendPrototype([
        DynamicPropertyContainer
    ], TextAnimatorProperty);
    function ITextElement() {}
    ITextElement.prototype.initElement = function(data, globalData, comp) {
        this.lettersChangedFlag = true;
        this.initFrame();
        this.initBaseData(data, globalData, comp);
        this.textProperty = new TextProperty(this, data.t, this.dynamicProperties);
        this.textAnimator = new TextAnimatorProperty(data.t, this.renderType, this);
        this.initTransform(data, globalData, comp);
        this.initHierarchy();
        this.initRenderable();
        this.initRendererElement();
        this.createContainerElements();
        this.createRenderableComponents();
        this.createContent();
        this.hide();
        this.textAnimator.searchProperties(this.dynamicProperties);
    };
    ITextElement.prototype.prepareFrame = function(num) {
        this._mdf = false;
        this.prepareRenderableFrame(num);
        this.prepareProperties(num, this.isInRange);
    };
    ITextElement.prototype.createPathShape = function(matrixHelper, shapes) {
        var j;
        var jLen = shapes.length;
        var pathNodes;
        var shapeStr = "";
        for(j = 0; j < jLen; j += 1)if (shapes[j].ty === "sh") {
            pathNodes = shapes[j].ks.k;
            shapeStr += buildShapeString(pathNodes, pathNodes.i.length, true, matrixHelper);
        }
        return shapeStr;
    };
    ITextElement.prototype.updateDocumentData = function(newData, index) {
        this.textProperty.updateDocumentData(newData, index);
    };
    ITextElement.prototype.canResizeFont = function(_canResize) {
        this.textProperty.canResizeFont(_canResize);
    };
    ITextElement.prototype.setMinimumFontSize = function(_fontSize) {
        this.textProperty.setMinimumFontSize(_fontSize);
    };
    ITextElement.prototype.applyTextPropertiesToMatrix = function(documentData, matrixHelper, lineNumber, xPos, yPos) {
        if (documentData.ps) matrixHelper.translate(documentData.ps[0], documentData.ps[1] + documentData.ascent, 0);
        matrixHelper.translate(0, -documentData.ls, 0);
        switch(documentData.j){
            case 1:
                matrixHelper.translate(documentData.justifyOffset + (documentData.boxWidth - documentData.lineWidths[lineNumber]), 0, 0);
                break;
            case 2:
                matrixHelper.translate(documentData.justifyOffset + (documentData.boxWidth - documentData.lineWidths[lineNumber]) / 2, 0, 0);
                break;
            default:
                break;
        }
        matrixHelper.translate(xPos, yPos, 0);
    };
    ITextElement.prototype.buildColor = function(colorData) {
        return "rgb(" + Math.round(colorData[0] * 255) + "," + Math.round(colorData[1] * 255) + "," + Math.round(colorData[2] * 255) + ")";
    };
    ITextElement.prototype.emptyProp = new LetterProps();
    ITextElement.prototype.destroy = function() {};
    ITextElement.prototype.validateText = function() {
        if (this.textProperty._mdf || this.textProperty._isFirstFrame) {
            this.buildNewText();
            this.textProperty._isFirstFrame = false;
            this.textProperty._mdf = false;
        }
    };
    var emptyShapeData = {
        shapes: []
    };
    function SVGTextLottieElement(data, globalData, comp) {
        this.textSpans = [];
        this.renderType = "svg";
        this.initElement(data, globalData, comp);
    }
    extendPrototype([
        BaseElement,
        TransformElement,
        SVGBaseElement,
        HierarchyElement,
        FrameElement,
        RenderableDOMElement,
        ITextElement
    ], SVGTextLottieElement);
    SVGTextLottieElement.prototype.createContent = function() {
        if (this.data.singleShape && !this.globalData.fontManager.chars) this.textContainer = createNS("text");
    };
    SVGTextLottieElement.prototype.buildTextContents = function(textArray) {
        var i = 0;
        var len = textArray.length;
        var textContents = [];
        var currentTextContent = "";
        while(i < len){
            if (textArray[i] === String.fromCharCode(13) || textArray[i] === String.fromCharCode(3)) {
                textContents.push(currentTextContent);
                currentTextContent = "";
            } else currentTextContent += textArray[i];
            i += 1;
        }
        textContents.push(currentTextContent);
        return textContents;
    };
    SVGTextLottieElement.prototype.buildShapeData = function(data, scale) {
        // data should probably be cloned to apply scale separately to each instance of a text on different layers
        // but since text internal content gets only rendered once and then it's never rerendered,
        // it's probably safe not to clone data and reuse always the same instance even if the object is mutated.
        // Avoiding cloning is preferred since cloning each character shape data is expensive
        if (data.shapes && data.shapes.length) {
            var shape = data.shapes[0];
            if (shape.it) {
                var shapeItem = shape.it[shape.it.length - 1];
                if (shapeItem.s) {
                    shapeItem.s.k[0] = scale;
                    shapeItem.s.k[1] = scale;
                }
            }
        }
        return data;
    };
    SVGTextLottieElement.prototype.buildNewText = function() {
        this.addDynamicProperty(this);
        var i;
        var len;
        var documentData = this.textProperty.currentData;
        this.renderedLetters = createSizedArray(documentData ? documentData.l.length : 0);
        if (documentData.fc) this.layerElement.setAttribute("fill", this.buildColor(documentData.fc));
        else this.layerElement.setAttribute("fill", "rgba(0,0,0,0)");
        if (documentData.sc) {
            this.layerElement.setAttribute("stroke", this.buildColor(documentData.sc));
            this.layerElement.setAttribute("stroke-width", documentData.sw);
        }
        this.layerElement.setAttribute("font-size", documentData.finalSize);
        var fontData = this.globalData.fontManager.getFontByName(documentData.f);
        if (fontData.fClass) this.layerElement.setAttribute("class", fontData.fClass);
        else {
            this.layerElement.setAttribute("font-family", fontData.fFamily);
            var fWeight = documentData.fWeight;
            var fStyle = documentData.fStyle;
            this.layerElement.setAttribute("font-style", fStyle);
            this.layerElement.setAttribute("font-weight", fWeight);
        }
        this.layerElement.setAttribute("aria-label", documentData.t);
        var letters = documentData.l || [];
        var usesGlyphs = !!this.globalData.fontManager.chars;
        len = letters.length;
        var tSpan;
        var matrixHelper = this.mHelper;
        var shapeStr = "";
        var singleShape = this.data.singleShape;
        var xPos = 0;
        var yPos = 0;
        var firstLine = true;
        var trackingOffset = documentData.tr * 0.001 * documentData.finalSize;
        if (singleShape && !usesGlyphs && !documentData.sz) {
            var tElement = this.textContainer;
            var justify = "start";
            switch(documentData.j){
                case 1:
                    justify = "end";
                    break;
                case 2:
                    justify = "middle";
                    break;
                default:
                    justify = "start";
                    break;
            }
            tElement.setAttribute("text-anchor", justify);
            tElement.setAttribute("letter-spacing", trackingOffset);
            var textContent = this.buildTextContents(documentData.finalText);
            len = textContent.length;
            yPos = documentData.ps ? documentData.ps[1] + documentData.ascent : 0;
            for(i = 0; i < len; i += 1){
                tSpan = this.textSpans[i].span || createNS("tspan");
                tSpan.textContent = textContent[i];
                tSpan.setAttribute("x", 0);
                tSpan.setAttribute("y", yPos);
                tSpan.style.display = "inherit";
                tElement.appendChild(tSpan);
                if (!this.textSpans[i]) this.textSpans[i] = {
                    span: null,
                    glyph: null
                };
                this.textSpans[i].span = tSpan;
                yPos += documentData.finalLineHeight;
            }
            this.layerElement.appendChild(tElement);
        } else {
            var cachedSpansLength = this.textSpans.length;
            var charData;
            for(i = 0; i < len; i += 1){
                if (!this.textSpans[i]) this.textSpans[i] = {
                    span: null,
                    childSpan: null,
                    glyph: null
                };
                if (!usesGlyphs || !singleShape || i === 0) {
                    tSpan = cachedSpansLength > i ? this.textSpans[i].span : createNS(usesGlyphs ? "g" : "text");
                    if (cachedSpansLength <= i) {
                        tSpan.setAttribute("stroke-linecap", "butt");
                        tSpan.setAttribute("stroke-linejoin", "round");
                        tSpan.setAttribute("stroke-miterlimit", "4");
                        this.textSpans[i].span = tSpan;
                        if (usesGlyphs) {
                            var childSpan = createNS("g");
                            tSpan.appendChild(childSpan);
                            this.textSpans[i].childSpan = childSpan;
                        }
                        this.textSpans[i].span = tSpan;
                        this.layerElement.appendChild(tSpan);
                    }
                    tSpan.style.display = "inherit";
                }
                matrixHelper.reset();
                if (singleShape) {
                    if (letters[i].n) {
                        xPos = -trackingOffset;
                        yPos += documentData.yOffset;
                        yPos += firstLine ? 1 : 0;
                        firstLine = false;
                    }
                    this.applyTextPropertiesToMatrix(documentData, matrixHelper, letters[i].line, xPos, yPos);
                    xPos += letters[i].l || 0; // xPos += letters[i].val === ' ' ? 0 : trackingOffset;
                    xPos += trackingOffset;
                }
                if (usesGlyphs) {
                    charData = this.globalData.fontManager.getCharData(documentData.finalText[i], fontData.fStyle, this.globalData.fontManager.getFontByName(documentData.f).fFamily);
                    var glyphElement; // t === 1 means the character has been replaced with an animated shaped
                    if (charData.t === 1) glyphElement = new SVGCompElement(charData.data, this.globalData, this);
                    else {
                        var data = emptyShapeData;
                        if (charData.data && charData.data.shapes) data = this.buildShapeData(charData.data, documentData.finalSize);
                        glyphElement = new SVGShapeElement(data, this.globalData, this);
                    }
                    if (this.textSpans[i].glyph) {
                        var glyph = this.textSpans[i].glyph;
                        this.textSpans[i].childSpan.removeChild(glyph.layerElement);
                        glyph.destroy();
                    }
                    this.textSpans[i].glyph = glyphElement;
                    glyphElement._debug = true;
                    glyphElement.prepareFrame(0);
                    glyphElement.renderFrame();
                    this.textSpans[i].childSpan.appendChild(glyphElement.layerElement); // when using animated shapes, the layer will be scaled instead of replacing the internal scale
                    // this might have issues with strokes and might need a different solution
                    if (charData.t === 1) this.textSpans[i].childSpan.setAttribute("transform", "scale(" + documentData.finalSize / 100 + "," + documentData.finalSize / 100 + ")");
                } else {
                    if (singleShape) tSpan.setAttribute("transform", "translate(" + matrixHelper.props[12] + "," + matrixHelper.props[13] + ")");
                    tSpan.textContent = letters[i].val;
                    tSpan.setAttributeNS("http://www.w3.org/XML/1998/namespace", "xml:space", "preserve");
                } //
            }
            if (singleShape && tSpan) tSpan.setAttribute("d", shapeStr);
        }
        while(i < this.textSpans.length){
            this.textSpans[i].span.style.display = "none";
            i += 1;
        }
        this._sizeChanged = true;
    };
    SVGTextLottieElement.prototype.sourceRectAtTime = function() {
        this.prepareFrame(this.comp.renderedFrame - this.data.st);
        this.renderInnerContent();
        if (this._sizeChanged) {
            this._sizeChanged = false;
            var textBox = this.layerElement.getBBox();
            this.bbox = {
                top: textBox.y,
                left: textBox.x,
                width: textBox.width,
                height: textBox.height
            };
        }
        return this.bbox;
    };
    SVGTextLottieElement.prototype.getValue = function() {
        var i;
        var len = this.textSpans.length;
        var glyphElement;
        this.renderedFrame = this.comp.renderedFrame;
        for(i = 0; i < len; i += 1){
            glyphElement = this.textSpans[i].glyph;
            if (glyphElement) {
                glyphElement.prepareFrame(this.comp.renderedFrame - this.data.st);
                if (glyphElement._mdf) this._mdf = true;
            }
        }
    };
    SVGTextLottieElement.prototype.renderInnerContent = function() {
        this.validateText();
        if (!this.data.singleShape || this._mdf) {
            this.textAnimator.getMeasures(this.textProperty.currentData, this.lettersChangedFlag);
            if (this.lettersChangedFlag || this.textAnimator.lettersChangedFlag) {
                this._sizeChanged = true;
                var i;
                var len;
                var renderedLetters = this.textAnimator.renderedLetters;
                var letters = this.textProperty.currentData.l;
                len = letters.length;
                var renderedLetter;
                var textSpan;
                var glyphElement;
                for(i = 0; i < len; i += 1)if (!letters[i].n) {
                    renderedLetter = renderedLetters[i];
                    textSpan = this.textSpans[i].span;
                    glyphElement = this.textSpans[i].glyph;
                    if (glyphElement) glyphElement.renderFrame();
                    if (renderedLetter._mdf.m) textSpan.setAttribute("transform", renderedLetter.m);
                    if (renderedLetter._mdf.o) textSpan.setAttribute("opacity", renderedLetter.o);
                    if (renderedLetter._mdf.sw) textSpan.setAttribute("stroke-width", renderedLetter.sw);
                    if (renderedLetter._mdf.sc) textSpan.setAttribute("stroke", renderedLetter.sc);
                    if (renderedLetter._mdf.fc) textSpan.setAttribute("fill", renderedLetter.fc);
                }
            }
        }
    };
    function ISolidElement(data, globalData, comp) {
        this.initElement(data, globalData, comp);
    }
    extendPrototype([
        IImageElement
    ], ISolidElement);
    ISolidElement.prototype.createContent = function() {
        var rect = createNS("rect"); /// /rect.style.width = this.data.sw;
        /// /rect.style.height = this.data.sh;
        /// /rect.style.fill = this.data.sc;
        rect.setAttribute("width", this.data.sw);
        rect.setAttribute("height", this.data.sh);
        rect.setAttribute("fill", this.data.sc);
        this.layerElement.appendChild(rect);
    };
    function NullElement(data, globalData, comp) {
        this.initFrame();
        this.initBaseData(data, globalData, comp);
        this.initFrame();
        this.initTransform(data, globalData, comp);
        this.initHierarchy();
    }
    NullElement.prototype.prepareFrame = function(num) {
        this.prepareProperties(num, true);
    };
    NullElement.prototype.renderFrame = function() {};
    NullElement.prototype.getBaseElement = function() {
        return null;
    };
    NullElement.prototype.destroy = function() {};
    NullElement.prototype.sourceRectAtTime = function() {};
    NullElement.prototype.hide = function() {};
    extendPrototype([
        BaseElement,
        TransformElement,
        HierarchyElement,
        FrameElement
    ], NullElement);
    function SVGRendererBase() {}
    extendPrototype([
        BaseRenderer
    ], SVGRendererBase);
    SVGRendererBase.prototype.createNull = function(data) {
        return new NullElement(data, this.globalData, this);
    };
    SVGRendererBase.prototype.createShape = function(data) {
        return new SVGShapeElement(data, this.globalData, this);
    };
    SVGRendererBase.prototype.createText = function(data) {
        return new SVGTextLottieElement(data, this.globalData, this);
    };
    SVGRendererBase.prototype.createImage = function(data) {
        return new IImageElement(data, this.globalData, this);
    };
    SVGRendererBase.prototype.createSolid = function(data) {
        return new ISolidElement(data, this.globalData, this);
    };
    SVGRendererBase.prototype.configAnimation = function(animData) {
        this.svgElement.setAttribute("xmlns", "http://www.w3.org/2000/svg");
        this.svgElement.setAttribute("xmlns:xlink", "http://www.w3.org/1999/xlink");
        if (this.renderConfig.viewBoxSize) this.svgElement.setAttribute("viewBox", this.renderConfig.viewBoxSize);
        else this.svgElement.setAttribute("viewBox", "0 0 " + animData.w + " " + animData.h);
        if (!this.renderConfig.viewBoxOnly) {
            this.svgElement.setAttribute("width", animData.w);
            this.svgElement.setAttribute("height", animData.h);
            this.svgElement.style.width = "100%";
            this.svgElement.style.height = "100%";
            this.svgElement.style.transform = "translate3d(0,0,0)";
            this.svgElement.style.contentVisibility = this.renderConfig.contentVisibility;
        }
        if (this.renderConfig.width) this.svgElement.setAttribute("width", this.renderConfig.width);
        if (this.renderConfig.height) this.svgElement.setAttribute("height", this.renderConfig.height);
        if (this.renderConfig.className) this.svgElement.setAttribute("class", this.renderConfig.className);
        if (this.renderConfig.id) this.svgElement.setAttribute("id", this.renderConfig.id);
        if (this.renderConfig.focusable !== undefined) this.svgElement.setAttribute("focusable", this.renderConfig.focusable);
        this.svgElement.setAttribute("preserveAspectRatio", this.renderConfig.preserveAspectRatio); // this.layerElement.style.transform = 'translate3d(0,0,0)';
        // this.layerElement.style.transformOrigin = this.layerElement.style.mozTransformOrigin = this.layerElement.style.webkitTransformOrigin = this.layerElement.style['-webkit-transform'] = "0px 0px 0px";
        this.animationItem.wrapper.appendChild(this.svgElement); // Mask animation
        var defs = this.globalData.defs;
        this.setupGlobalData(animData, defs);
        this.globalData.progressiveLoad = this.renderConfig.progressiveLoad;
        this.data = animData;
        var maskElement = createNS("clipPath");
        var rect = createNS("rect");
        rect.setAttribute("width", animData.w);
        rect.setAttribute("height", animData.h);
        rect.setAttribute("x", 0);
        rect.setAttribute("y", 0);
        var maskId = createElementID();
        maskElement.setAttribute("id", maskId);
        maskElement.appendChild(rect);
        this.layerElement.setAttribute("clip-path", "url(" + getLocationHref() + "#" + maskId + ")");
        defs.appendChild(maskElement);
        this.layers = animData.layers;
        this.elements = createSizedArray(animData.layers.length);
    };
    SVGRendererBase.prototype.destroy = function() {
        if (this.animationItem.wrapper) this.animationItem.wrapper.innerText = "";
        this.layerElement = null;
        this.globalData.defs = null;
        var i;
        var len = this.layers ? this.layers.length : 0;
        for(i = 0; i < len; i += 1)if (this.elements[i] && this.elements[i].destroy) this.elements[i].destroy();
        this.elements.length = 0;
        this.destroyed = true;
        this.animationItem = null;
    };
    SVGRendererBase.prototype.updateContainerSize = function() {};
    SVGRendererBase.prototype.findIndexByInd = function(ind) {
        var i = 0;
        var len = this.layers.length;
        for(i = 0; i < len; i += 1){
            if (this.layers[i].ind === ind) return i;
        }
        return -1;
    };
    SVGRendererBase.prototype.buildItem = function(pos) {
        var elements = this.elements;
        if (elements[pos] || this.layers[pos].ty === 99) return;
        elements[pos] = true;
        var element = this.createItem(this.layers[pos]);
        elements[pos] = element;
        if (getExpressionsPlugin()) {
            if (this.layers[pos].ty === 0) this.globalData.projectInterface.registerComposition(element);
            element.initExpressions();
        }
        this.appendElementInPos(element, pos);
        if (this.layers[pos].tt) {
            var elementIndex = "tp" in this.layers[pos] ? this.findIndexByInd(this.layers[pos].tp) : pos - 1;
            if (elementIndex === -1) return;
            if (!this.elements[elementIndex] || this.elements[elementIndex] === true) {
                this.buildItem(elementIndex);
                this.addPendingElement(element);
            } else {
                var matteElement = elements[elementIndex];
                var matteMask = matteElement.getMatte(this.layers[pos].tt);
                element.setMatte(matteMask);
            }
        }
    };
    SVGRendererBase.prototype.checkPendingElements = function() {
        while(this.pendingElements.length){
            var element = this.pendingElements.pop();
            element.checkParenting();
            if (element.data.tt) {
                var i = 0;
                var len = this.elements.length;
                while(i < len){
                    if (this.elements[i] === element) {
                        var elementIndex = "tp" in element.data ? this.findIndexByInd(element.data.tp) : i - 1;
                        var matteElement = this.elements[elementIndex];
                        var matteMask = matteElement.getMatte(this.layers[i].tt);
                        element.setMatte(matteMask);
                        break;
                    }
                    i += 1;
                }
            }
        }
    };
    SVGRendererBase.prototype.renderFrame = function(num) {
        if (this.renderedFrame === num || this.destroyed) return;
        if (num === null) num = this.renderedFrame;
        else this.renderedFrame = num;
         // console.log('-------');
        // console.log('FRAME ',num);
        this.globalData.frameNum = num;
        this.globalData.frameId += 1;
        this.globalData.projectInterface.currentFrame = num;
        this.globalData._mdf = false;
        var i;
        var len = this.layers.length;
        if (!this.completeLayers) this.checkLayers(num);
        for(i = len - 1; i >= 0; i -= 1)if (this.completeLayers || this.elements[i]) this.elements[i].prepareFrame(num - this.layers[i].st);
        if (this.globalData._mdf) {
            for(i = 0; i < len; i += 1)if (this.completeLayers || this.elements[i]) this.elements[i].renderFrame();
        }
    };
    SVGRendererBase.prototype.appendElementInPos = function(element, pos) {
        var newElement = element.getBaseElement();
        if (!newElement) return;
        var i = 0;
        var nextElement;
        while(i < pos){
            if (this.elements[i] && this.elements[i] !== true && this.elements[i].getBaseElement()) nextElement = this.elements[i].getBaseElement();
            i += 1;
        }
        if (nextElement) this.layerElement.insertBefore(newElement, nextElement);
        else this.layerElement.appendChild(newElement);
    };
    SVGRendererBase.prototype.hide = function() {
        this.layerElement.style.display = "none";
    };
    SVGRendererBase.prototype.show = function() {
        this.layerElement.style.display = "block";
    };
    function ICompElement() {}
    extendPrototype([
        BaseElement,
        TransformElement,
        HierarchyElement,
        FrameElement,
        RenderableDOMElement
    ], ICompElement);
    ICompElement.prototype.initElement = function(data, globalData, comp) {
        this.initFrame();
        this.initBaseData(data, globalData, comp);
        this.initTransform(data, globalData, comp);
        this.initRenderable();
        this.initHierarchy();
        this.initRendererElement();
        this.createContainerElements();
        this.createRenderableComponents();
        if (this.data.xt || !globalData.progressiveLoad) this.buildAllItems();
        this.hide();
    };
    /* ICompElement.prototype.hide = function(){
      if(!this.hidden){
          this.hideElement();
          var i,len = this.elements.length;
          for( i = 0; i < len; i+=1 ){
              if(this.elements[i]){
                  this.elements[i].hide();
              }
          }
      }
  }; */ ICompElement.prototype.prepareFrame = function(num) {
        this._mdf = false;
        this.prepareRenderableFrame(num);
        this.prepareProperties(num, this.isInRange);
        if (!this.isInRange && !this.data.xt) return;
        if (!this.tm._placeholder) {
            var timeRemapped = this.tm.v;
            if (timeRemapped === this.data.op) timeRemapped = this.data.op - 1;
            this.renderedFrame = timeRemapped;
        } else this.renderedFrame = num / this.data.sr;
        var i;
        var len = this.elements.length;
        if (!this.completeLayers) this.checkLayers(this.renderedFrame);
         // This iteration needs to be backwards because of how expressions connect between each other
        for(i = len - 1; i >= 0; i -= 1)if (this.completeLayers || this.elements[i]) {
            this.elements[i].prepareFrame(this.renderedFrame - this.layers[i].st);
            if (this.elements[i]._mdf) this._mdf = true;
        }
    };
    ICompElement.prototype.renderInnerContent = function() {
        var i;
        var len = this.layers.length;
        for(i = 0; i < len; i += 1)if (this.completeLayers || this.elements[i]) this.elements[i].renderFrame();
    };
    ICompElement.prototype.setElements = function(elems) {
        this.elements = elems;
    };
    ICompElement.prototype.getElements = function() {
        return this.elements;
    };
    ICompElement.prototype.destroyElements = function() {
        var i;
        var len = this.layers.length;
        for(i = 0; i < len; i += 1)if (this.elements[i]) this.elements[i].destroy();
    };
    ICompElement.prototype.destroy = function() {
        this.destroyElements();
        this.destroyBaseElement();
    };
    function SVGCompElement(data, globalData, comp) {
        this.layers = data.layers;
        this.supports3d = true;
        this.completeLayers = false;
        this.pendingElements = [];
        this.elements = this.layers ? createSizedArray(this.layers.length) : [];
        this.initElement(data, globalData, comp);
        this.tm = data.tm ? PropertyFactory.getProp(this, data.tm, 0, globalData.frameRate, this) : {
            _placeholder: true
        };
    }
    extendPrototype([
        SVGRendererBase,
        ICompElement,
        SVGBaseElement
    ], SVGCompElement);
    SVGCompElement.prototype.createComp = function(data) {
        return new SVGCompElement(data, this.globalData, this);
    };
    function SVGRenderer(animationItem, config) {
        this.animationItem = animationItem;
        this.layers = null;
        this.renderedFrame = -1;
        this.svgElement = createNS("svg");
        var ariaLabel = "";
        if (config && config.title) {
            var titleElement = createNS("title");
            var titleId = createElementID();
            titleElement.setAttribute("id", titleId);
            titleElement.textContent = config.title;
            this.svgElement.appendChild(titleElement);
            ariaLabel += titleId;
        }
        if (config && config.description) {
            var descElement = createNS("desc");
            var descId = createElementID();
            descElement.setAttribute("id", descId);
            descElement.textContent = config.description;
            this.svgElement.appendChild(descElement);
            ariaLabel += " " + descId;
        }
        if (ariaLabel) this.svgElement.setAttribute("aria-labelledby", ariaLabel);
        var defs = createNS("defs");
        this.svgElement.appendChild(defs);
        var maskElement = createNS("g");
        this.svgElement.appendChild(maskElement);
        this.layerElement = maskElement;
        this.renderConfig = {
            preserveAspectRatio: config && config.preserveAspectRatio || "xMidYMid meet",
            imagePreserveAspectRatio: config && config.imagePreserveAspectRatio || "xMidYMid slice",
            contentVisibility: config && config.contentVisibility || "visible",
            progressiveLoad: config && config.progressiveLoad || false,
            hideOnTransparent: !(config && config.hideOnTransparent === false),
            viewBoxOnly: config && config.viewBoxOnly || false,
            viewBoxSize: config && config.viewBoxSize || false,
            className: config && config.className || "",
            id: config && config.id || "",
            focusable: config && config.focusable,
            filterSize: {
                width: config && config.filterSize && config.filterSize.width || "100%",
                height: config && config.filterSize && config.filterSize.height || "100%",
                x: config && config.filterSize && config.filterSize.x || "0%",
                y: config && config.filterSize && config.filterSize.y || "0%"
            },
            width: config && config.width,
            height: config && config.height,
            runExpressions: !config || config.runExpressions === undefined || config.runExpressions
        };
        this.globalData = {
            _mdf: false,
            frameNum: -1,
            defs: defs,
            renderConfig: this.renderConfig
        };
        this.elements = [];
        this.pendingElements = [];
        this.destroyed = false;
        this.rendererType = "svg";
    }
    extendPrototype([
        SVGRendererBase
    ], SVGRenderer);
    SVGRenderer.prototype.createComp = function(data) {
        return new SVGCompElement(data, this.globalData, this);
    };
    function ShapeTransformManager() {
        this.sequences = {};
        this.sequenceList = [];
        this.transform_key_count = 0;
    }
    ShapeTransformManager.prototype = {
        addTransformSequence: function addTransformSequence(transforms) {
            var i;
            var len = transforms.length;
            var key = "_";
            for(i = 0; i < len; i += 1)key += transforms[i].transform.key + "_";
            var sequence = this.sequences[key];
            if (!sequence) {
                sequence = {
                    transforms: [].concat(transforms),
                    finalTransform: new Matrix(),
                    _mdf: false
                };
                this.sequences[key] = sequence;
                this.sequenceList.push(sequence);
            }
            return sequence;
        },
        processSequence: function processSequence(sequence, isFirstFrame) {
            var i = 0;
            var len = sequence.transforms.length;
            var _mdf = isFirstFrame;
            while(i < len && !isFirstFrame){
                if (sequence.transforms[i].transform.mProps._mdf) {
                    _mdf = true;
                    break;
                }
                i += 1;
            }
            if (_mdf) {
                sequence.finalTransform.reset();
                for(i = len - 1; i >= 0; i -= 1)sequence.finalTransform.multiply(sequence.transforms[i].transform.mProps.v);
            }
            sequence._mdf = _mdf;
        },
        processSequences: function processSequences(isFirstFrame) {
            var i;
            var len = this.sequenceList.length;
            for(i = 0; i < len; i += 1)this.processSequence(this.sequenceList[i], isFirstFrame);
        },
        getNewKey: function getNewKey() {
            this.transform_key_count += 1;
            return "_" + this.transform_key_count;
        }
    };
    var lumaLoader = function lumaLoader() {
        var id = "__lottie_element_luma_buffer";
        var lumaBuffer = null;
        var lumaBufferCtx = null;
        var svg = null; // This alternate solution has a slight delay before the filter is applied, resulting in a flicker on the first frame.
        // Keeping this here for reference, and in the future, if offscreen canvas supports url filters, this can be used.
        // For now, neither of them work for offscreen canvas, so canvas workers can't support the luma track matte mask.
        // Naming it solution 2 to mark the extra comment lines.
        /*
    var svgString = [
      '<svg xmlns="http://www.w3.org/2000/svg">',
      '<filter id="' + id + '">',
      '<feColorMatrix type="matrix" color-interpolation-filters="sRGB" values="',
      '0.3, 0.3, 0.3, 0, 0, ',
      '0.3, 0.3, 0.3, 0, 0, ',
      '0.3, 0.3, 0.3, 0, 0, ',
      '0.3, 0.3, 0.3, 0, 0',
      '"/>',
      '</filter>',
      '</svg>',
    ].join('');
    var blob = new Blob([svgString], { type: 'image/svg+xml' });
    var url = URL.createObjectURL(blob);
    */ function createLumaSvgFilter() {
            var _svg = createNS("svg");
            var fil = createNS("filter");
            var matrix = createNS("feColorMatrix");
            fil.setAttribute("id", id);
            matrix.setAttribute("type", "matrix");
            matrix.setAttribute("color-interpolation-filters", "sRGB");
            matrix.setAttribute("values", "0.3, 0.3, 0.3, 0, 0, 0.3, 0.3, 0.3, 0, 0, 0.3, 0.3, 0.3, 0, 0, 0.3, 0.3, 0.3, 0, 0");
            fil.appendChild(matrix);
            _svg.appendChild(fil);
            _svg.setAttribute("id", id + "_svg");
            if (featureSupport.svgLumaHidden) _svg.style.display = "none";
            return _svg;
        }
        function loadLuma() {
            if (!lumaBuffer) {
                svg = createLumaSvgFilter();
                document.body.appendChild(svg);
                lumaBuffer = createTag("canvas");
                lumaBufferCtx = lumaBuffer.getContext("2d"); // lumaBufferCtx.filter = `url('${url}#__lottie_element_luma_buffer')`; // part of solution 2
                lumaBufferCtx.filter = "url(#" + id + ")";
                lumaBufferCtx.fillStyle = "rgba(0,0,0,0)";
                lumaBufferCtx.fillRect(0, 0, 1, 1);
            }
        }
        function getLuma(canvas) {
            if (!lumaBuffer) loadLuma();
            lumaBuffer.width = canvas.width;
            lumaBuffer.height = canvas.height; // lumaBufferCtx.filter = `url('${url}#__lottie_element_luma_buffer')`; // part of solution 2
            lumaBufferCtx.filter = "url(#" + id + ")";
            return lumaBuffer;
        }
        return {
            load: loadLuma,
            get: getLuma
        };
    };
    function createCanvas(width, height) {
        if (featureSupport.offscreenCanvas) return new OffscreenCanvas(width, height);
        var canvas = createTag("canvas");
        canvas.width = width;
        canvas.height = height;
        return canvas;
    }
    var assetLoader = function() {
        return {
            loadLumaCanvas: lumaLoader.load,
            getLumaCanvas: lumaLoader.get,
            createCanvas: createCanvas
        };
    }();
    var registeredEffects = {};
    function CVEffects(elem) {
        var i;
        var len = elem.data.ef ? elem.data.ef.length : 0;
        this.filters = [];
        var filterManager;
        for(i = 0; i < len; i += 1){
            filterManager = null;
            var type = elem.data.ef[i].ty;
            if (registeredEffects[type]) {
                var Effect = registeredEffects[type].effect;
                filterManager = new Effect(elem.effectsManager.effectElements[i], elem);
            }
            if (filterManager) this.filters.push(filterManager);
        }
        if (this.filters.length) elem.addRenderableComponent(this);
    }
    CVEffects.prototype.renderFrame = function(_isFirstFrame) {
        var i;
        var len = this.filters.length;
        for(i = 0; i < len; i += 1)this.filters[i].renderFrame(_isFirstFrame);
    };
    CVEffects.prototype.getEffects = function(type) {
        var i;
        var len = this.filters.length;
        var effects = [];
        for(i = 0; i < len; i += 1)if (this.filters[i].type === type) effects.push(this.filters[i]);
        return effects;
    };
    function registerEffect(id, effect) {
        registeredEffects[id] = {
            effect: effect
        };
    }
    function CVMaskElement(data, element) {
        this.data = data;
        this.element = element;
        this.masksProperties = this.data.masksProperties || [];
        this.viewData = createSizedArray(this.masksProperties.length);
        var i;
        var len = this.masksProperties.length;
        var hasMasks = false;
        for(i = 0; i < len; i += 1){
            if (this.masksProperties[i].mode !== "n") hasMasks = true;
            this.viewData[i] = ShapePropertyFactory.getShapeProp(this.element, this.masksProperties[i], 3);
        }
        this.hasMasks = hasMasks;
        if (hasMasks) this.element.addRenderableComponent(this);
    }
    CVMaskElement.prototype.renderFrame = function() {
        if (!this.hasMasks) return;
        var transform = this.element.finalTransform.mat;
        var ctx = this.element.canvasContext;
        var i;
        var len = this.masksProperties.length;
        var pt;
        var pts;
        var data;
        ctx.beginPath();
        for(i = 0; i < len; i += 1)if (this.masksProperties[i].mode !== "n") {
            if (this.masksProperties[i].inv) {
                ctx.moveTo(0, 0);
                ctx.lineTo(this.element.globalData.compSize.w, 0);
                ctx.lineTo(this.element.globalData.compSize.w, this.element.globalData.compSize.h);
                ctx.lineTo(0, this.element.globalData.compSize.h);
                ctx.lineTo(0, 0);
            }
            data = this.viewData[i].v;
            pt = transform.applyToPointArray(data.v[0][0], data.v[0][1], 0);
            ctx.moveTo(pt[0], pt[1]);
            var j;
            var jLen = data._length;
            for(j = 1; j < jLen; j += 1){
                pts = transform.applyToTriplePoints(data.o[j - 1], data.i[j], data.v[j]);
                ctx.bezierCurveTo(pts[0], pts[1], pts[2], pts[3], pts[4], pts[5]);
            }
            pts = transform.applyToTriplePoints(data.o[j - 1], data.i[0], data.v[0]);
            ctx.bezierCurveTo(pts[0], pts[1], pts[2], pts[3], pts[4], pts[5]);
        }
        this.element.globalData.renderer.save(true);
        ctx.clip();
    };
    CVMaskElement.prototype.getMaskProperty = MaskElement.prototype.getMaskProperty;
    CVMaskElement.prototype.destroy = function() {
        this.element = null;
    };
    function CVBaseElement() {}
    var operationsMap = {
        1: "source-in",
        2: "source-out",
        3: "source-in",
        4: "source-out"
    };
    CVBaseElement.prototype = {
        createElements: function createElements() {},
        initRendererElement: function initRendererElement() {},
        createContainerElements: function createContainerElements() {
            // If the layer is masked we will use two buffers to store each different states of the drawing
            // This solution is not ideal for several reason. But unfortunately, because of the recursive
            // nature of the render tree, it's the only simple way to make sure one inner mask doesn't override an outer mask.
            // TODO: try to reduce the size of these buffers to the size of the composition contaning the layer
            // It might be challenging because the layer most likely is transformed in some way
            if (this.data.tt >= 1) {
                this.buffers = [];
                var canvasContext = this.globalData.canvasContext;
                var bufferCanvas = assetLoader.createCanvas(canvasContext.canvas.width, canvasContext.canvas.height);
                this.buffers.push(bufferCanvas);
                var bufferCanvas2 = assetLoader.createCanvas(canvasContext.canvas.width, canvasContext.canvas.height);
                this.buffers.push(bufferCanvas2);
                if (this.data.tt >= 3 && !document._isProxy) assetLoader.loadLumaCanvas();
            }
            this.canvasContext = this.globalData.canvasContext;
            this.transformCanvas = this.globalData.transformCanvas;
            this.renderableEffectsManager = new CVEffects(this);
            this.searchEffectTransforms();
        },
        createContent: function createContent() {},
        setBlendMode: function setBlendMode() {
            var globalData = this.globalData;
            if (globalData.blendMode !== this.data.bm) {
                globalData.blendMode = this.data.bm;
                var blendModeValue = getBlendMode(this.data.bm);
                globalData.canvasContext.globalCompositeOperation = blendModeValue;
            }
        },
        createRenderableComponents: function createRenderableComponents() {
            this.maskManager = new CVMaskElement(this.data, this);
            this.transformEffects = this.renderableEffectsManager.getEffects(effectTypes.TRANSFORM_EFFECT);
        },
        hideElement: function hideElement() {
            if (!this.hidden && (!this.isInRange || this.isTransparent)) this.hidden = true;
        },
        showElement: function showElement() {
            if (this.isInRange && !this.isTransparent) {
                this.hidden = false;
                this._isFirstFrame = true;
                this.maskManager._isFirstFrame = true;
            }
        },
        clearCanvas: function clearCanvas(canvasContext) {
            canvasContext.clearRect(this.transformCanvas.tx, this.transformCanvas.ty, this.transformCanvas.w * this.transformCanvas.sx, this.transformCanvas.h * this.transformCanvas.sy);
        },
        prepareLayer: function prepareLayer() {
            if (this.data.tt >= 1) {
                var buffer = this.buffers[0];
                var bufferCtx = buffer.getContext("2d");
                this.clearCanvas(bufferCtx); // on the first buffer we store the current state of the global drawing
                bufferCtx.drawImage(this.canvasContext.canvas, 0, 0); // The next four lines are to clear the canvas
                // TODO: Check if there is a way to clear the canvas without resetting the transform
                this.currentTransform = this.canvasContext.getTransform();
                this.canvasContext.setTransform(1, 0, 0, 1, 0, 0);
                this.clearCanvas(this.canvasContext);
                this.canvasContext.setTransform(this.currentTransform);
            }
        },
        exitLayer: function exitLayer() {
            if (this.data.tt >= 1) {
                var buffer = this.buffers[1]; // On the second buffer we store the current state of the global drawing
                // that only contains the content of this layer
                // (if it is a composition, it also includes the nested layers)
                var bufferCtx = buffer.getContext("2d");
                this.clearCanvas(bufferCtx);
                bufferCtx.drawImage(this.canvasContext.canvas, 0, 0); // We clear the canvas again
                this.canvasContext.setTransform(1, 0, 0, 1, 0, 0);
                this.clearCanvas(this.canvasContext);
                this.canvasContext.setTransform(this.currentTransform); // We draw the mask
                var mask = this.comp.getElementById("tp" in this.data ? this.data.tp : this.data.ind - 1);
                mask.renderFrame(true); // We draw the second buffer (that contains the content of this layer)
                this.canvasContext.setTransform(1, 0, 0, 1, 0, 0); // If the mask is a Luma matte, we need to do two extra painting operations
                // the _isProxy check is to avoid drawing a fake canvas in workers that will throw an error
                if (this.data.tt >= 3 && !document._isProxy) {
                    // We copy the painted mask to a buffer that has a color matrix filter applied to it
                    // that applies the rgb values to the alpha channel
                    var lumaBuffer = assetLoader.getLumaCanvas(this.canvasContext.canvas);
                    var lumaBufferCtx = lumaBuffer.getContext("2d");
                    lumaBufferCtx.drawImage(this.canvasContext.canvas, 0, 0);
                    this.clearCanvas(this.canvasContext); // we repaint the context with the mask applied to it
                    this.canvasContext.drawImage(lumaBuffer, 0, 0);
                }
                this.canvasContext.globalCompositeOperation = operationsMap[this.data.tt];
                this.canvasContext.drawImage(buffer, 0, 0); // We finally draw the first buffer (that contains the content of the global drawing)
                // We use destination-over to draw the global drawing below the current layer
                this.canvasContext.globalCompositeOperation = "destination-over";
                this.canvasContext.drawImage(this.buffers[0], 0, 0);
                this.canvasContext.setTransform(this.currentTransform); // We reset the globalCompositeOperation to source-over, the standard type of operation
                this.canvasContext.globalCompositeOperation = "source-over";
            }
        },
        renderFrame: function renderFrame(forceRender) {
            if (this.hidden || this.data.hd) return;
            if (this.data.td === 1 && !forceRender) return;
            this.renderTransform();
            this.renderRenderable();
            this.renderLocalTransform();
            this.setBlendMode();
            var forceRealStack = this.data.ty === 0;
            this.prepareLayer();
            this.globalData.renderer.save(forceRealStack);
            this.globalData.renderer.ctxTransform(this.finalTransform.localMat.props);
            this.globalData.renderer.ctxOpacity(this.finalTransform.localOpacity);
            this.renderInnerContent();
            this.globalData.renderer.restore(forceRealStack);
            this.exitLayer();
            if (this.maskManager.hasMasks) this.globalData.renderer.restore(true);
            if (this._isFirstFrame) this._isFirstFrame = false;
        },
        destroy: function destroy() {
            this.canvasContext = null;
            this.data = null;
            this.globalData = null;
            this.maskManager.destroy();
        },
        mHelper: new Matrix()
    };
    CVBaseElement.prototype.hide = CVBaseElement.prototype.hideElement;
    CVBaseElement.prototype.show = CVBaseElement.prototype.showElement;
    function CVShapeData(element, data, styles, transformsManager) {
        this.styledShapes = [];
        this.tr = [
            0,
            0,
            0,
            0,
            0,
            0
        ];
        var ty = 4;
        if (data.ty === "rc") ty = 5;
        else if (data.ty === "el") ty = 6;
        else if (data.ty === "sr") ty = 7;
        this.sh = ShapePropertyFactory.getShapeProp(element, data, ty, element);
        var i;
        var len = styles.length;
        var styledShape;
        for(i = 0; i < len; i += 1)if (!styles[i].closed) {
            styledShape = {
                transforms: transformsManager.addTransformSequence(styles[i].transforms),
                trNodes: []
            };
            this.styledShapes.push(styledShape);
            styles[i].elements.push(styledShape);
        }
    }
    CVShapeData.prototype.setAsAnimated = SVGShapeData.prototype.setAsAnimated;
    function CVShapeElement(data, globalData, comp) {
        this.shapes = [];
        this.shapesData = data.shapes;
        this.stylesList = [];
        this.itemsData = [];
        this.prevViewData = [];
        this.shapeModifiers = [];
        this.processedElements = [];
        this.transformsManager = new ShapeTransformManager();
        this.initElement(data, globalData, comp);
    }
    extendPrototype([
        BaseElement,
        TransformElement,
        CVBaseElement,
        IShapeElement,
        HierarchyElement,
        FrameElement,
        RenderableElement
    ], CVShapeElement);
    CVShapeElement.prototype.initElement = RenderableDOMElement.prototype.initElement;
    CVShapeElement.prototype.transformHelper = {
        opacity: 1,
        _opMdf: false
    };
    CVShapeElement.prototype.dashResetter = [];
    CVShapeElement.prototype.createContent = function() {
        this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, true, []);
    };
    CVShapeElement.prototype.createStyleElement = function(data, transforms) {
        var styleElem = {
            data: data,
            type: data.ty,
            preTransforms: this.transformsManager.addTransformSequence(transforms),
            transforms: [],
            elements: [],
            closed: data.hd === true
        };
        var elementData = {};
        if (data.ty === "fl" || data.ty === "st") {
            elementData.c = PropertyFactory.getProp(this, data.c, 1, 255, this);
            if (!elementData.c.k) styleElem.co = "rgb(" + bmFloor(elementData.c.v[0]) + "," + bmFloor(elementData.c.v[1]) + "," + bmFloor(elementData.c.v[2]) + ")";
        } else if (data.ty === "gf" || data.ty === "gs") {
            elementData.s = PropertyFactory.getProp(this, data.s, 1, null, this);
            elementData.e = PropertyFactory.getProp(this, data.e, 1, null, this);
            elementData.h = PropertyFactory.getProp(this, data.h || {
                k: 0
            }, 0, 0.01, this);
            elementData.a = PropertyFactory.getProp(this, data.a || {
                k: 0
            }, 0, degToRads, this);
            elementData.g = new GradientProperty(this, data.g, this);
        }
        elementData.o = PropertyFactory.getProp(this, data.o, 0, 0.01, this);
        if (data.ty === "st" || data.ty === "gs") {
            styleElem.lc = lineCapEnum[data.lc || 2];
            styleElem.lj = lineJoinEnum[data.lj || 2];
            if (data.lj == 1) // eslint-disable-line eqeqeq
            styleElem.ml = data.ml;
            elementData.w = PropertyFactory.getProp(this, data.w, 0, null, this);
            if (!elementData.w.k) styleElem.wi = elementData.w.v;
            if (data.d) {
                var d = new DashProperty(this, data.d, "canvas", this);
                elementData.d = d;
                if (!elementData.d.k) {
                    styleElem.da = elementData.d.dashArray;
                    styleElem["do"] = elementData.d.dashoffset[0];
                }
            }
        } else styleElem.r = data.r === 2 ? "evenodd" : "nonzero";
        this.stylesList.push(styleElem);
        elementData.style = styleElem;
        return elementData;
    };
    CVShapeElement.prototype.createGroupElement = function() {
        var elementData = {
            it: [],
            prevViewData: []
        };
        return elementData;
    };
    CVShapeElement.prototype.createTransformElement = function(data) {
        var elementData = {
            transform: {
                opacity: 1,
                _opMdf: false,
                key: this.transformsManager.getNewKey(),
                op: PropertyFactory.getProp(this, data.o, 0, 0.01, this),
                mProps: TransformPropertyFactory.getTransformProperty(this, data, this)
            }
        };
        return elementData;
    };
    CVShapeElement.prototype.createShapeElement = function(data) {
        var elementData = new CVShapeData(this, data, this.stylesList, this.transformsManager);
        this.shapes.push(elementData);
        this.addShapeToModifiers(elementData);
        return elementData;
    };
    CVShapeElement.prototype.reloadShapes = function() {
        this._isFirstFrame = true;
        var i;
        var len = this.itemsData.length;
        for(i = 0; i < len; i += 1)this.prevViewData[i] = this.itemsData[i];
        this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, true, []);
        len = this.dynamicProperties.length;
        for(i = 0; i < len; i += 1)this.dynamicProperties[i].getValue();
        this.renderModifiers();
        this.transformsManager.processSequences(this._isFirstFrame);
    };
    CVShapeElement.prototype.addTransformToStyleList = function(transform) {
        var i;
        var len = this.stylesList.length;
        for(i = 0; i < len; i += 1)if (!this.stylesList[i].closed) this.stylesList[i].transforms.push(transform);
    };
    CVShapeElement.prototype.removeTransformFromStyleList = function() {
        var i;
        var len = this.stylesList.length;
        for(i = 0; i < len; i += 1)if (!this.stylesList[i].closed) this.stylesList[i].transforms.pop();
    };
    CVShapeElement.prototype.closeStyles = function(styles) {
        var i;
        var len = styles.length;
        for(i = 0; i < len; i += 1)styles[i].closed = true;
    };
    CVShapeElement.prototype.searchShapes = function(arr, itemsData, prevViewData, shouldRender, transforms) {
        var i;
        var len = arr.length - 1;
        var j;
        var jLen;
        var ownStyles = [];
        var ownModifiers = [];
        var processedPos;
        var modifier;
        var currentTransform;
        var ownTransforms = [].concat(transforms);
        for(i = len; i >= 0; i -= 1){
            processedPos = this.searchProcessedElement(arr[i]);
            if (!processedPos) arr[i]._shouldRender = shouldRender;
            else itemsData[i] = prevViewData[processedPos - 1];
            if (arr[i].ty === "fl" || arr[i].ty === "st" || arr[i].ty === "gf" || arr[i].ty === "gs") {
                if (!processedPos) itemsData[i] = this.createStyleElement(arr[i], ownTransforms);
                else itemsData[i].style.closed = false;
                ownStyles.push(itemsData[i].style);
            } else if (arr[i].ty === "gr") {
                if (!processedPos) itemsData[i] = this.createGroupElement(arr[i]);
                else {
                    jLen = itemsData[i].it.length;
                    for(j = 0; j < jLen; j += 1)itemsData[i].prevViewData[j] = itemsData[i].it[j];
                }
                this.searchShapes(arr[i].it, itemsData[i].it, itemsData[i].prevViewData, shouldRender, ownTransforms);
            } else if (arr[i].ty === "tr") {
                if (!processedPos) {
                    currentTransform = this.createTransformElement(arr[i]);
                    itemsData[i] = currentTransform;
                }
                ownTransforms.push(itemsData[i]);
                this.addTransformToStyleList(itemsData[i]);
            } else if (arr[i].ty === "sh" || arr[i].ty === "rc" || arr[i].ty === "el" || arr[i].ty === "sr") {
                if (!processedPos) itemsData[i] = this.createShapeElement(arr[i]);
            } else if (arr[i].ty === "tm" || arr[i].ty === "rd" || arr[i].ty === "pb" || arr[i].ty === "zz" || arr[i].ty === "op") {
                if (!processedPos) {
                    modifier = ShapeModifiers.getModifier(arr[i].ty);
                    modifier.init(this, arr[i]);
                    itemsData[i] = modifier;
                    this.shapeModifiers.push(modifier);
                } else {
                    modifier = itemsData[i];
                    modifier.closed = false;
                }
                ownModifiers.push(modifier);
            } else if (arr[i].ty === "rp") {
                if (!processedPos) {
                    modifier = ShapeModifiers.getModifier(arr[i].ty);
                    itemsData[i] = modifier;
                    modifier.init(this, arr, i, itemsData);
                    this.shapeModifiers.push(modifier);
                    shouldRender = false;
                } else {
                    modifier = itemsData[i];
                    modifier.closed = true;
                }
                ownModifiers.push(modifier);
            }
            this.addProcessedElement(arr[i], i + 1);
        }
        this.removeTransformFromStyleList();
        this.closeStyles(ownStyles);
        len = ownModifiers.length;
        for(i = 0; i < len; i += 1)ownModifiers[i].closed = true;
    };
    CVShapeElement.prototype.renderInnerContent = function() {
        this.transformHelper.opacity = 1;
        this.transformHelper._opMdf = false;
        this.renderModifiers();
        this.transformsManager.processSequences(this._isFirstFrame);
        this.renderShape(this.transformHelper, this.shapesData, this.itemsData, true);
    };
    CVShapeElement.prototype.renderShapeTransform = function(parentTransform, groupTransform) {
        if (parentTransform._opMdf || groupTransform.op._mdf || this._isFirstFrame) {
            groupTransform.opacity = parentTransform.opacity;
            groupTransform.opacity *= groupTransform.op.v;
            groupTransform._opMdf = true;
        }
    };
    CVShapeElement.prototype.drawLayer = function() {
        var i;
        var len = this.stylesList.length;
        var j;
        var jLen;
        var k;
        var kLen;
        var elems;
        var nodes;
        var renderer = this.globalData.renderer;
        var ctx = this.globalData.canvasContext;
        var type;
        var currentStyle;
        for(i = 0; i < len; i += 1){
            currentStyle = this.stylesList[i];
            type = currentStyle.type; // Skipping style when
            // Stroke width equals 0
            // style should not be rendered (extra unused repeaters)
            // current opacity equals 0
            // global opacity equals 0
            if (!((type === "st" || type === "gs") && currentStyle.wi === 0 || !currentStyle.data._shouldRender || currentStyle.coOp === 0 || this.globalData.currentGlobalAlpha === 0)) {
                renderer.save();
                elems = currentStyle.elements;
                if (type === "st" || type === "gs") {
                    renderer.ctxStrokeStyle(type === "st" ? currentStyle.co : currentStyle.grd); // ctx.strokeStyle = type === 'st' ? currentStyle.co : currentStyle.grd;
                    renderer.ctxLineWidth(currentStyle.wi); // ctx.lineWidth = currentStyle.wi;
                    renderer.ctxLineCap(currentStyle.lc); // ctx.lineCap = currentStyle.lc;
                    renderer.ctxLineJoin(currentStyle.lj); // ctx.lineJoin = currentStyle.lj;
                    renderer.ctxMiterLimit(currentStyle.ml || 0); // ctx.miterLimit = currentStyle.ml || 0;
                } else renderer.ctxFillStyle(type === "fl" ? currentStyle.co : currentStyle.grd); // ctx.fillStyle = type === 'fl' ? currentStyle.co : currentStyle.grd;
                renderer.ctxOpacity(currentStyle.coOp);
                if (type !== "st" && type !== "gs") ctx.beginPath();
                renderer.ctxTransform(currentStyle.preTransforms.finalTransform.props);
                jLen = elems.length;
                for(j = 0; j < jLen; j += 1){
                    if (type === "st" || type === "gs") {
                        ctx.beginPath();
                        if (currentStyle.da) {
                            ctx.setLineDash(currentStyle.da);
                            ctx.lineDashOffset = currentStyle["do"];
                        }
                    }
                    nodes = elems[j].trNodes;
                    kLen = nodes.length;
                    for(k = 0; k < kLen; k += 1){
                        if (nodes[k].t === "m") ctx.moveTo(nodes[k].p[0], nodes[k].p[1]);
                        else if (nodes[k].t === "c") ctx.bezierCurveTo(nodes[k].pts[0], nodes[k].pts[1], nodes[k].pts[2], nodes[k].pts[3], nodes[k].pts[4], nodes[k].pts[5]);
                        else ctx.closePath();
                    }
                    if (type === "st" || type === "gs") {
                        // ctx.stroke();
                        renderer.ctxStroke();
                        if (currentStyle.da) ctx.setLineDash(this.dashResetter);
                    }
                }
                if (type !== "st" && type !== "gs") // ctx.fill(currentStyle.r);
                this.globalData.renderer.ctxFill(currentStyle.r);
                renderer.restore();
            }
        }
    };
    CVShapeElement.prototype.renderShape = function(parentTransform, items, data, isMain) {
        var i;
        var len = items.length - 1;
        var groupTransform;
        groupTransform = parentTransform;
        for(i = len; i >= 0; i -= 1){
            if (items[i].ty === "tr") {
                groupTransform = data[i].transform;
                this.renderShapeTransform(parentTransform, groupTransform);
            } else if (items[i].ty === "sh" || items[i].ty === "el" || items[i].ty === "rc" || items[i].ty === "sr") this.renderPath(items[i], data[i]);
            else if (items[i].ty === "fl") this.renderFill(items[i], data[i], groupTransform);
            else if (items[i].ty === "st") this.renderStroke(items[i], data[i], groupTransform);
            else if (items[i].ty === "gf" || items[i].ty === "gs") this.renderGradientFill(items[i], data[i], groupTransform);
            else if (items[i].ty === "gr") this.renderShape(groupTransform, items[i].it, data[i].it);
            else items[i].ty;
        }
        if (isMain) this.drawLayer();
    };
    CVShapeElement.prototype.renderStyledShape = function(styledShape, shape) {
        if (this._isFirstFrame || shape._mdf || styledShape.transforms._mdf) {
            var shapeNodes = styledShape.trNodes;
            var paths = shape.paths;
            var i;
            var len;
            var j;
            var jLen = paths._length;
            shapeNodes.length = 0;
            var groupTransformMat = styledShape.transforms.finalTransform;
            for(j = 0; j < jLen; j += 1){
                var pathNodes = paths.shapes[j];
                if (pathNodes && pathNodes.v) {
                    len = pathNodes._length;
                    for(i = 1; i < len; i += 1){
                        if (i === 1) shapeNodes.push({
                            t: "m",
                            p: groupTransformMat.applyToPointArray(pathNodes.v[0][0], pathNodes.v[0][1], 0)
                        });
                        shapeNodes.push({
                            t: "c",
                            pts: groupTransformMat.applyToTriplePoints(pathNodes.o[i - 1], pathNodes.i[i], pathNodes.v[i])
                        });
                    }
                    if (len === 1) shapeNodes.push({
                        t: "m",
                        p: groupTransformMat.applyToPointArray(pathNodes.v[0][0], pathNodes.v[0][1], 0)
                    });
                    if (pathNodes.c && len) {
                        shapeNodes.push({
                            t: "c",
                            pts: groupTransformMat.applyToTriplePoints(pathNodes.o[i - 1], pathNodes.i[0], pathNodes.v[0])
                        });
                        shapeNodes.push({
                            t: "z"
                        });
                    }
                }
            }
            styledShape.trNodes = shapeNodes;
        }
    };
    CVShapeElement.prototype.renderPath = function(pathData, itemData) {
        if (pathData.hd !== true && pathData._shouldRender) {
            var i;
            var len = itemData.styledShapes.length;
            for(i = 0; i < len; i += 1)this.renderStyledShape(itemData.styledShapes[i], itemData.sh);
        }
    };
    CVShapeElement.prototype.renderFill = function(styleData, itemData, groupTransform) {
        var styleElem = itemData.style;
        if (itemData.c._mdf || this._isFirstFrame) styleElem.co = "rgb(" + bmFloor(itemData.c.v[0]) + "," + bmFloor(itemData.c.v[1]) + "," + bmFloor(itemData.c.v[2]) + ")";
        if (itemData.o._mdf || groupTransform._opMdf || this._isFirstFrame) styleElem.coOp = itemData.o.v * groupTransform.opacity;
    };
    CVShapeElement.prototype.renderGradientFill = function(styleData, itemData, groupTransform) {
        var styleElem = itemData.style;
        var grd;
        if (!styleElem.grd || itemData.g._mdf || itemData.s._mdf || itemData.e._mdf || styleData.t !== 1 && (itemData.h._mdf || itemData.a._mdf)) {
            var ctx = this.globalData.canvasContext;
            var pt1 = itemData.s.v;
            var pt2 = itemData.e.v;
            if (styleData.t === 1) grd = ctx.createLinearGradient(pt1[0], pt1[1], pt2[0], pt2[1]);
            else {
                var rad = Math.sqrt(Math.pow(pt1[0] - pt2[0], 2) + Math.pow(pt1[1] - pt2[1], 2));
                var ang = Math.atan2(pt2[1] - pt1[1], pt2[0] - pt1[0]);
                var percent = itemData.h.v;
                if (percent >= 1) percent = 0.99;
                else if (percent <= -1) percent = -0.99;
                var dist = rad * percent;
                var x = Math.cos(ang + itemData.a.v) * dist + pt1[0];
                var y = Math.sin(ang + itemData.a.v) * dist + pt1[1];
                grd = ctx.createRadialGradient(x, y, 0, pt1[0], pt1[1], rad);
            }
            var i;
            var len = styleData.g.p;
            var cValues = itemData.g.c;
            var opacity = 1;
            for(i = 0; i < len; i += 1){
                if (itemData.g._hasOpacity && itemData.g._collapsable) opacity = itemData.g.o[i * 2 + 1];
                grd.addColorStop(cValues[i * 4] / 100, "rgba(" + cValues[i * 4 + 1] + "," + cValues[i * 4 + 2] + "," + cValues[i * 4 + 3] + "," + opacity + ")");
            }
            styleElem.grd = grd;
        }
        styleElem.coOp = itemData.o.v * groupTransform.opacity;
    };
    CVShapeElement.prototype.renderStroke = function(styleData, itemData, groupTransform) {
        var styleElem = itemData.style;
        var d = itemData.d;
        if (d && (d._mdf || this._isFirstFrame)) {
            styleElem.da = d.dashArray;
            styleElem["do"] = d.dashoffset[0];
        }
        if (itemData.c._mdf || this._isFirstFrame) styleElem.co = "rgb(" + bmFloor(itemData.c.v[0]) + "," + bmFloor(itemData.c.v[1]) + "," + bmFloor(itemData.c.v[2]) + ")";
        if (itemData.o._mdf || groupTransform._opMdf || this._isFirstFrame) styleElem.coOp = itemData.o.v * groupTransform.opacity;
        if (itemData.w._mdf || this._isFirstFrame) styleElem.wi = itemData.w.v;
    };
    CVShapeElement.prototype.destroy = function() {
        this.shapesData = null;
        this.globalData = null;
        this.canvasContext = null;
        this.stylesList.length = 0;
        this.itemsData.length = 0;
    };
    function CVTextElement(data, globalData, comp) {
        this.textSpans = [];
        this.yOffset = 0;
        this.fillColorAnim = false;
        this.strokeColorAnim = false;
        this.strokeWidthAnim = false;
        this.stroke = false;
        this.fill = false;
        this.justifyOffset = 0;
        this.currentRender = null;
        this.renderType = "canvas";
        this.values = {
            fill: "rgba(0,0,0,0)",
            stroke: "rgba(0,0,0,0)",
            sWidth: 0,
            fValue: ""
        };
        this.initElement(data, globalData, comp);
    }
    extendPrototype([
        BaseElement,
        TransformElement,
        CVBaseElement,
        HierarchyElement,
        FrameElement,
        RenderableElement,
        ITextElement
    ], CVTextElement);
    CVTextElement.prototype.tHelper = createTag("canvas").getContext("2d");
    CVTextElement.prototype.buildNewText = function() {
        var documentData = this.textProperty.currentData;
        this.renderedLetters = createSizedArray(documentData.l ? documentData.l.length : 0);
        var hasFill = false;
        if (documentData.fc) {
            hasFill = true;
            this.values.fill = this.buildColor(documentData.fc);
        } else this.values.fill = "rgba(0,0,0,0)";
        this.fill = hasFill;
        var hasStroke = false;
        if (documentData.sc) {
            hasStroke = true;
            this.values.stroke = this.buildColor(documentData.sc);
            this.values.sWidth = documentData.sw;
        }
        var fontData = this.globalData.fontManager.getFontByName(documentData.f);
        var i;
        var len;
        var letters = documentData.l;
        var matrixHelper = this.mHelper;
        this.stroke = hasStroke;
        this.values.fValue = documentData.finalSize + "px " + this.globalData.fontManager.getFontByName(documentData.f).fFamily;
        len = documentData.finalText.length; // this.tHelper.font = this.values.fValue;
        var charData;
        var shapeData;
        var k;
        var kLen;
        var shapes;
        var j;
        var jLen;
        var pathNodes;
        var commands;
        var pathArr;
        var singleShape = this.data.singleShape;
        var trackingOffset = documentData.tr * 0.001 * documentData.finalSize;
        var xPos = 0;
        var yPos = 0;
        var firstLine = true;
        var cnt = 0;
        for(i = 0; i < len; i += 1){
            charData = this.globalData.fontManager.getCharData(documentData.finalText[i], fontData.fStyle, this.globalData.fontManager.getFontByName(documentData.f).fFamily);
            shapeData = charData && charData.data || {};
            matrixHelper.reset();
            if (singleShape && letters[i].n) {
                xPos = -trackingOffset;
                yPos += documentData.yOffset;
                yPos += firstLine ? 1 : 0;
                firstLine = false;
            }
            shapes = shapeData.shapes ? shapeData.shapes[0].it : [];
            jLen = shapes.length;
            matrixHelper.scale(documentData.finalSize / 100, documentData.finalSize / 100);
            if (singleShape) this.applyTextPropertiesToMatrix(documentData, matrixHelper, letters[i].line, xPos, yPos);
            commands = createSizedArray(jLen - 1);
            var commandsCounter = 0;
            for(j = 0; j < jLen; j += 1)if (shapes[j].ty === "sh") {
                kLen = shapes[j].ks.k.i.length;
                pathNodes = shapes[j].ks.k;
                pathArr = [];
                for(k = 1; k < kLen; k += 1){
                    if (k === 1) pathArr.push(matrixHelper.applyToX(pathNodes.v[0][0], pathNodes.v[0][1], 0), matrixHelper.applyToY(pathNodes.v[0][0], pathNodes.v[0][1], 0));
                    pathArr.push(matrixHelper.applyToX(pathNodes.o[k - 1][0], pathNodes.o[k - 1][1], 0), matrixHelper.applyToY(pathNodes.o[k - 1][0], pathNodes.o[k - 1][1], 0), matrixHelper.applyToX(pathNodes.i[k][0], pathNodes.i[k][1], 0), matrixHelper.applyToY(pathNodes.i[k][0], pathNodes.i[k][1], 0), matrixHelper.applyToX(pathNodes.v[k][0], pathNodes.v[k][1], 0), matrixHelper.applyToY(pathNodes.v[k][0], pathNodes.v[k][1], 0));
                }
                pathArr.push(matrixHelper.applyToX(pathNodes.o[k - 1][0], pathNodes.o[k - 1][1], 0), matrixHelper.applyToY(pathNodes.o[k - 1][0], pathNodes.o[k - 1][1], 0), matrixHelper.applyToX(pathNodes.i[0][0], pathNodes.i[0][1], 0), matrixHelper.applyToY(pathNodes.i[0][0], pathNodes.i[0][1], 0), matrixHelper.applyToX(pathNodes.v[0][0], pathNodes.v[0][1], 0), matrixHelper.applyToY(pathNodes.v[0][0], pathNodes.v[0][1], 0));
                commands[commandsCounter] = pathArr;
                commandsCounter += 1;
            }
            if (singleShape) {
                xPos += letters[i].l;
                xPos += trackingOffset;
            }
            if (this.textSpans[cnt]) this.textSpans[cnt].elem = commands;
            else this.textSpans[cnt] = {
                elem: commands
            };
            cnt += 1;
        }
    };
    CVTextElement.prototype.renderInnerContent = function() {
        this.validateText();
        var ctx = this.canvasContext;
        ctx.font = this.values.fValue;
        this.globalData.renderer.ctxLineCap("butt"); // ctx.lineCap = 'butt';
        this.globalData.renderer.ctxLineJoin("miter"); // ctx.lineJoin = 'miter';
        this.globalData.renderer.ctxMiterLimit(4); // ctx.miterLimit = 4;
        if (!this.data.singleShape) this.textAnimator.getMeasures(this.textProperty.currentData, this.lettersChangedFlag);
        var i;
        var len;
        var j;
        var jLen;
        var k;
        var kLen;
        var renderedLetters = this.textAnimator.renderedLetters;
        var letters = this.textProperty.currentData.l;
        len = letters.length;
        var renderedLetter;
        var lastFill = null;
        var lastStroke = null;
        var lastStrokeW = null;
        var commands;
        var pathArr;
        var renderer = this.globalData.renderer;
        for(i = 0; i < len; i += 1)if (!letters[i].n) {
            renderedLetter = renderedLetters[i];
            if (renderedLetter) {
                renderer.save();
                renderer.ctxTransform(renderedLetter.p);
                renderer.ctxOpacity(renderedLetter.o);
            }
            if (this.fill) {
                if (renderedLetter && renderedLetter.fc) {
                    if (lastFill !== renderedLetter.fc) {
                        renderer.ctxFillStyle(renderedLetter.fc);
                        lastFill = renderedLetter.fc; // ctx.fillStyle = renderedLetter.fc;
                    }
                } else if (lastFill !== this.values.fill) {
                    lastFill = this.values.fill;
                    renderer.ctxFillStyle(this.values.fill); // ctx.fillStyle = this.values.fill;
                }
                commands = this.textSpans[i].elem;
                jLen = commands.length;
                this.globalData.canvasContext.beginPath();
                for(j = 0; j < jLen; j += 1){
                    pathArr = commands[j];
                    kLen = pathArr.length;
                    this.globalData.canvasContext.moveTo(pathArr[0], pathArr[1]);
                    for(k = 2; k < kLen; k += 6)this.globalData.canvasContext.bezierCurveTo(pathArr[k], pathArr[k + 1], pathArr[k + 2], pathArr[k + 3], pathArr[k + 4], pathArr[k + 5]);
                }
                this.globalData.canvasContext.closePath();
                renderer.ctxFill(); // this.globalData.canvasContext.fill();
            /// ctx.fillText(this.textSpans[i].val,0,0);
            }
            if (this.stroke) {
                if (renderedLetter && renderedLetter.sw) {
                    if (lastStrokeW !== renderedLetter.sw) {
                        lastStrokeW = renderedLetter.sw;
                        renderer.ctxLineWidth(renderedLetter.sw); // ctx.lineWidth = renderedLetter.sw;
                    }
                } else if (lastStrokeW !== this.values.sWidth) {
                    lastStrokeW = this.values.sWidth;
                    renderer.ctxLineWidth(this.values.sWidth); // ctx.lineWidth = this.values.sWidth;
                }
                if (renderedLetter && renderedLetter.sc) {
                    if (lastStroke !== renderedLetter.sc) {
                        lastStroke = renderedLetter.sc;
                        renderer.ctxStrokeStyle(renderedLetter.sc); // ctx.strokeStyle = renderedLetter.sc;
                    }
                } else if (lastStroke !== this.values.stroke) {
                    lastStroke = this.values.stroke;
                    renderer.ctxStrokeStyle(this.values.stroke); // ctx.strokeStyle = this.values.stroke;
                }
                commands = this.textSpans[i].elem;
                jLen = commands.length;
                this.globalData.canvasContext.beginPath();
                for(j = 0; j < jLen; j += 1){
                    pathArr = commands[j];
                    kLen = pathArr.length;
                    this.globalData.canvasContext.moveTo(pathArr[0], pathArr[1]);
                    for(k = 2; k < kLen; k += 6)this.globalData.canvasContext.bezierCurveTo(pathArr[k], pathArr[k + 1], pathArr[k + 2], pathArr[k + 3], pathArr[k + 4], pathArr[k + 5]);
                }
                this.globalData.canvasContext.closePath();
                renderer.ctxStroke(); // this.globalData.canvasContext.stroke();
            /// ctx.strokeText(letters[i].val,0,0);
            }
            if (renderedLetter) this.globalData.renderer.restore();
        }
    };
    function CVImageElement(data, globalData, comp) {
        this.assetData = globalData.getAssetData(data.refId);
        this.img = globalData.imageLoader.getAsset(this.assetData);
        this.initElement(data, globalData, comp);
    }
    extendPrototype([
        BaseElement,
        TransformElement,
        CVBaseElement,
        HierarchyElement,
        FrameElement,
        RenderableElement
    ], CVImageElement);
    CVImageElement.prototype.initElement = SVGShapeElement.prototype.initElement;
    CVImageElement.prototype.prepareFrame = IImageElement.prototype.prepareFrame;
    CVImageElement.prototype.createContent = function() {
        if (this.img.width && (this.assetData.w !== this.img.width || this.assetData.h !== this.img.height)) {
            var canvas = createTag("canvas");
            canvas.width = this.assetData.w;
            canvas.height = this.assetData.h;
            var ctx = canvas.getContext("2d");
            var imgW = this.img.width;
            var imgH = this.img.height;
            var imgRel = imgW / imgH;
            var canvasRel = this.assetData.w / this.assetData.h;
            var widthCrop;
            var heightCrop;
            var par = this.assetData.pr || this.globalData.renderConfig.imagePreserveAspectRatio;
            if (imgRel > canvasRel && par === "xMidYMid slice" || imgRel < canvasRel && par !== "xMidYMid slice") {
                heightCrop = imgH;
                widthCrop = heightCrop * canvasRel;
            } else {
                widthCrop = imgW;
                heightCrop = widthCrop / canvasRel;
            }
            ctx.drawImage(this.img, (imgW - widthCrop) / 2, (imgH - heightCrop) / 2, widthCrop, heightCrop, 0, 0, this.assetData.w, this.assetData.h);
            this.img = canvas;
        }
    };
    CVImageElement.prototype.renderInnerContent = function() {
        this.canvasContext.drawImage(this.img, 0, 0);
    };
    CVImageElement.prototype.destroy = function() {
        this.img = null;
    };
    function CVSolidElement(data, globalData, comp) {
        this.initElement(data, globalData, comp);
    }
    extendPrototype([
        BaseElement,
        TransformElement,
        CVBaseElement,
        HierarchyElement,
        FrameElement,
        RenderableElement
    ], CVSolidElement);
    CVSolidElement.prototype.initElement = SVGShapeElement.prototype.initElement;
    CVSolidElement.prototype.prepareFrame = IImageElement.prototype.prepareFrame;
    CVSolidElement.prototype.renderInnerContent = function() {
        // var ctx = this.canvasContext;
        this.globalData.renderer.ctxFillStyle(this.data.sc); // ctx.fillStyle = this.data.sc;
        this.globalData.renderer.ctxFillRect(0, 0, this.data.sw, this.data.sh); // ctx.fillRect(0, 0, this.data.sw, this.data.sh);
    //
    };
    function CanvasRendererBase() {}
    extendPrototype([
        BaseRenderer
    ], CanvasRendererBase);
    CanvasRendererBase.prototype.createShape = function(data) {
        return new CVShapeElement(data, this.globalData, this);
    };
    CanvasRendererBase.prototype.createText = function(data) {
        return new CVTextElement(data, this.globalData, this);
    };
    CanvasRendererBase.prototype.createImage = function(data) {
        return new CVImageElement(data, this.globalData, this);
    };
    CanvasRendererBase.prototype.createSolid = function(data) {
        return new CVSolidElement(data, this.globalData, this);
    };
    CanvasRendererBase.prototype.createNull = SVGRenderer.prototype.createNull;
    CanvasRendererBase.prototype.ctxTransform = function(props) {
        if (props[0] === 1 && props[1] === 0 && props[4] === 0 && props[5] === 1 && props[12] === 0 && props[13] === 0) return;
        this.canvasContext.transform(props[0], props[1], props[4], props[5], props[12], props[13]);
    };
    CanvasRendererBase.prototype.ctxOpacity = function(op) {
        this.canvasContext.globalAlpha *= op < 0 ? 0 : op;
    };
    CanvasRendererBase.prototype.ctxFillStyle = function(value) {
        this.canvasContext.fillStyle = value;
    };
    CanvasRendererBase.prototype.ctxStrokeStyle = function(value) {
        this.canvasContext.strokeStyle = value;
    };
    CanvasRendererBase.prototype.ctxLineWidth = function(value) {
        this.canvasContext.lineWidth = value;
    };
    CanvasRendererBase.prototype.ctxLineCap = function(value) {
        this.canvasContext.lineCap = value;
    };
    CanvasRendererBase.prototype.ctxLineJoin = function(value) {
        this.canvasContext.lineJoin = value;
    };
    CanvasRendererBase.prototype.ctxMiterLimit = function(value) {
        this.canvasContext.miterLimit = value;
    };
    CanvasRendererBase.prototype.ctxFill = function(rule) {
        this.canvasContext.fill(rule);
    };
    CanvasRendererBase.prototype.ctxFillRect = function(x, y, w, h) {
        this.canvasContext.fillRect(x, y, w, h);
    };
    CanvasRendererBase.prototype.ctxStroke = function() {
        this.canvasContext.stroke();
    };
    CanvasRendererBase.prototype.reset = function() {
        if (!this.renderConfig.clearCanvas) {
            this.canvasContext.restore();
            return;
        }
        this.contextData.reset();
    };
    CanvasRendererBase.prototype.save = function() {
        this.canvasContext.save();
    };
    CanvasRendererBase.prototype.restore = function(actionFlag) {
        if (!this.renderConfig.clearCanvas) {
            this.canvasContext.restore();
            return;
        }
        if (actionFlag) this.globalData.blendMode = "source-over";
        this.contextData.restore(actionFlag);
    };
    CanvasRendererBase.prototype.configAnimation = function(animData) {
        if (this.animationItem.wrapper) {
            this.animationItem.container = createTag("canvas");
            var containerStyle = this.animationItem.container.style;
            containerStyle.width = "100%";
            containerStyle.height = "100%";
            var origin = "0px 0px 0px";
            containerStyle.transformOrigin = origin;
            containerStyle.mozTransformOrigin = origin;
            containerStyle.webkitTransformOrigin = origin;
            containerStyle["-webkit-transform"] = origin;
            containerStyle.contentVisibility = this.renderConfig.contentVisibility;
            this.animationItem.wrapper.appendChild(this.animationItem.container);
            this.canvasContext = this.animationItem.container.getContext("2d");
            if (this.renderConfig.className) this.animationItem.container.setAttribute("class", this.renderConfig.className);
            if (this.renderConfig.id) this.animationItem.container.setAttribute("id", this.renderConfig.id);
        } else this.canvasContext = this.renderConfig.context;
        this.contextData.setContext(this.canvasContext);
        this.data = animData;
        this.layers = animData.layers;
        this.transformCanvas = {
            w: animData.w,
            h: animData.h,
            sx: 0,
            sy: 0,
            tx: 0,
            ty: 0
        };
        this.setupGlobalData(animData, document.body);
        this.globalData.canvasContext = this.canvasContext;
        this.globalData.renderer = this;
        this.globalData.isDashed = false;
        this.globalData.progressiveLoad = this.renderConfig.progressiveLoad;
        this.globalData.transformCanvas = this.transformCanvas;
        this.elements = createSizedArray(animData.layers.length);
        this.updateContainerSize();
    };
    CanvasRendererBase.prototype.updateContainerSize = function(width, height) {
        this.reset();
        var elementWidth;
        var elementHeight;
        if (width) {
            elementWidth = width;
            elementHeight = height;
            this.canvasContext.canvas.width = elementWidth;
            this.canvasContext.canvas.height = elementHeight;
        } else {
            if (this.animationItem.wrapper && this.animationItem.container) {
                elementWidth = this.animationItem.wrapper.offsetWidth;
                elementHeight = this.animationItem.wrapper.offsetHeight;
            } else {
                elementWidth = this.canvasContext.canvas.width;
                elementHeight = this.canvasContext.canvas.height;
            }
            this.canvasContext.canvas.width = elementWidth * this.renderConfig.dpr;
            this.canvasContext.canvas.height = elementHeight * this.renderConfig.dpr;
        }
        var elementRel;
        var animationRel;
        if (this.renderConfig.preserveAspectRatio.indexOf("meet") !== -1 || this.renderConfig.preserveAspectRatio.indexOf("slice") !== -1) {
            var par = this.renderConfig.preserveAspectRatio.split(" ");
            var fillType = par[1] || "meet";
            var pos = par[0] || "xMidYMid";
            var xPos = pos.substr(0, 4);
            var yPos = pos.substr(4);
            elementRel = elementWidth / elementHeight;
            animationRel = this.transformCanvas.w / this.transformCanvas.h;
            if (animationRel > elementRel && fillType === "meet" || animationRel < elementRel && fillType === "slice") {
                this.transformCanvas.sx = elementWidth / (this.transformCanvas.w / this.renderConfig.dpr);
                this.transformCanvas.sy = elementWidth / (this.transformCanvas.w / this.renderConfig.dpr);
            } else {
                this.transformCanvas.sx = elementHeight / (this.transformCanvas.h / this.renderConfig.dpr);
                this.transformCanvas.sy = elementHeight / (this.transformCanvas.h / this.renderConfig.dpr);
            }
            if (xPos === "xMid" && (animationRel < elementRel && fillType === "meet" || animationRel > elementRel && fillType === "slice")) this.transformCanvas.tx = (elementWidth - this.transformCanvas.w * (elementHeight / this.transformCanvas.h)) / 2 * this.renderConfig.dpr;
            else if (xPos === "xMax" && (animationRel < elementRel && fillType === "meet" || animationRel > elementRel && fillType === "slice")) this.transformCanvas.tx = (elementWidth - this.transformCanvas.w * (elementHeight / this.transformCanvas.h)) * this.renderConfig.dpr;
            else this.transformCanvas.tx = 0;
            if (yPos === "YMid" && (animationRel > elementRel && fillType === "meet" || animationRel < elementRel && fillType === "slice")) this.transformCanvas.ty = (elementHeight - this.transformCanvas.h * (elementWidth / this.transformCanvas.w)) / 2 * this.renderConfig.dpr;
            else if (yPos === "YMax" && (animationRel > elementRel && fillType === "meet" || animationRel < elementRel && fillType === "slice")) this.transformCanvas.ty = (elementHeight - this.transformCanvas.h * (elementWidth / this.transformCanvas.w)) * this.renderConfig.dpr;
            else this.transformCanvas.ty = 0;
        } else if (this.renderConfig.preserveAspectRatio === "none") {
            this.transformCanvas.sx = elementWidth / (this.transformCanvas.w / this.renderConfig.dpr);
            this.transformCanvas.sy = elementHeight / (this.transformCanvas.h / this.renderConfig.dpr);
            this.transformCanvas.tx = 0;
            this.transformCanvas.ty = 0;
        } else {
            this.transformCanvas.sx = this.renderConfig.dpr;
            this.transformCanvas.sy = this.renderConfig.dpr;
            this.transformCanvas.tx = 0;
            this.transformCanvas.ty = 0;
        }
        this.transformCanvas.props = [
            this.transformCanvas.sx,
            0,
            0,
            0,
            0,
            this.transformCanvas.sy,
            0,
            0,
            0,
            0,
            1,
            0,
            this.transformCanvas.tx,
            this.transformCanvas.ty,
            0,
            1
        ];
        /* var i, len = this.elements.length;
      for(i=0;i<len;i+=1){
          if(this.elements[i] && this.elements[i].data.ty === 0){
              this.elements[i].resize(this.globalData.transformCanvas);
          }
      } */ this.ctxTransform(this.transformCanvas.props);
        this.canvasContext.beginPath();
        this.canvasContext.rect(0, 0, this.transformCanvas.w, this.transformCanvas.h);
        this.canvasContext.closePath();
        this.canvasContext.clip();
        this.renderFrame(this.renderedFrame, true);
    };
    CanvasRendererBase.prototype.destroy = function() {
        if (this.renderConfig.clearCanvas && this.animationItem.wrapper) this.animationItem.wrapper.innerText = "";
        var i;
        var len = this.layers ? this.layers.length : 0;
        for(i = len - 1; i >= 0; i -= 1)if (this.elements[i] && this.elements[i].destroy) this.elements[i].destroy();
        this.elements.length = 0;
        this.globalData.canvasContext = null;
        this.animationItem.container = null;
        this.destroyed = true;
    };
    CanvasRendererBase.prototype.renderFrame = function(num, forceRender) {
        if (this.renderedFrame === num && this.renderConfig.clearCanvas === true && !forceRender || this.destroyed || num === -1) return;
        this.renderedFrame = num;
        this.globalData.frameNum = num - this.animationItem._isFirstFrame;
        this.globalData.frameId += 1;
        this.globalData._mdf = !this.renderConfig.clearCanvas || forceRender;
        this.globalData.projectInterface.currentFrame = num; // console.log('--------');
        // console.log('NEW: ',num);
        var i;
        var len = this.layers.length;
        if (!this.completeLayers) this.checkLayers(num);
        for(i = len - 1; i >= 0; i -= 1)if (this.completeLayers || this.elements[i]) this.elements[i].prepareFrame(num - this.layers[i].st);
        if (this.globalData._mdf) {
            if (this.renderConfig.clearCanvas === true) this.canvasContext.clearRect(0, 0, this.transformCanvas.w, this.transformCanvas.h);
            else this.save();
            for(i = len - 1; i >= 0; i -= 1)if (this.completeLayers || this.elements[i]) this.elements[i].renderFrame();
            if (this.renderConfig.clearCanvas !== true) this.restore();
        }
    };
    CanvasRendererBase.prototype.buildItem = function(pos) {
        var elements = this.elements;
        if (elements[pos] || this.layers[pos].ty === 99) return;
        var element = this.createItem(this.layers[pos], this, this.globalData);
        elements[pos] = element;
        element.initExpressions();
    /* if(this.layers[pos].ty === 0){
          element.resize(this.globalData.transformCanvas);
      } */ };
    CanvasRendererBase.prototype.checkPendingElements = function() {
        while(this.pendingElements.length){
            var element = this.pendingElements.pop();
            element.checkParenting();
        }
    };
    CanvasRendererBase.prototype.hide = function() {
        this.animationItem.container.style.display = "none";
    };
    CanvasRendererBase.prototype.show = function() {
        this.animationItem.container.style.display = "block";
    };
    function CanvasContext() {
        this.opacity = -1;
        this.transform = createTypedArray("float32", 16);
        this.fillStyle = "";
        this.strokeStyle = "";
        this.lineWidth = "";
        this.lineCap = "";
        this.lineJoin = "";
        this.miterLimit = "";
        this.id = Math.random();
    }
    function CVContextData() {
        this.stack = [];
        this.cArrPos = 0;
        this.cTr = new Matrix();
        var i;
        var len = 15;
        for(i = 0; i < len; i += 1){
            var canvasContext = new CanvasContext();
            this.stack[i] = canvasContext;
        }
        this._length = len;
        this.nativeContext = null;
        this.transformMat = new Matrix();
        this.currentOpacity = 1; //
        this.currentFillStyle = "";
        this.appliedFillStyle = ""; //
        this.currentStrokeStyle = "";
        this.appliedStrokeStyle = ""; //
        this.currentLineWidth = "";
        this.appliedLineWidth = ""; //
        this.currentLineCap = "";
        this.appliedLineCap = ""; //
        this.currentLineJoin = "";
        this.appliedLineJoin = ""; //
        this.appliedMiterLimit = "";
        this.currentMiterLimit = "";
    }
    CVContextData.prototype.duplicate = function() {
        var newLength = this._length * 2;
        var i = 0;
        for(i = this._length; i < newLength; i += 1)this.stack[i] = new CanvasContext();
        this._length = newLength;
    };
    CVContextData.prototype.reset = function() {
        this.cArrPos = 0;
        this.cTr.reset();
        this.stack[this.cArrPos].opacity = 1;
    };
    CVContextData.prototype.restore = function(forceRestore) {
        this.cArrPos -= 1;
        var currentContext = this.stack[this.cArrPos];
        var transform = currentContext.transform;
        var i;
        var arr = this.cTr.props;
        for(i = 0; i < 16; i += 1)arr[i] = transform[i];
        if (forceRestore) {
            this.nativeContext.restore();
            var prevStack = this.stack[this.cArrPos + 1];
            this.appliedFillStyle = prevStack.fillStyle;
            this.appliedStrokeStyle = prevStack.strokeStyle;
            this.appliedLineWidth = prevStack.lineWidth;
            this.appliedLineCap = prevStack.lineCap;
            this.appliedLineJoin = prevStack.lineJoin;
            this.appliedMiterLimit = prevStack.miterLimit;
        }
        this.nativeContext.setTransform(transform[0], transform[1], transform[4], transform[5], transform[12], transform[13]);
        if (forceRestore || currentContext.opacity !== -1 && this.currentOpacity !== currentContext.opacity) {
            this.nativeContext.globalAlpha = currentContext.opacity;
            this.currentOpacity = currentContext.opacity;
        }
        this.currentFillStyle = currentContext.fillStyle;
        this.currentStrokeStyle = currentContext.strokeStyle;
        this.currentLineWidth = currentContext.lineWidth;
        this.currentLineCap = currentContext.lineCap;
        this.currentLineJoin = currentContext.lineJoin;
        this.currentMiterLimit = currentContext.miterLimit;
    };
    CVContextData.prototype.save = function(saveOnNativeFlag) {
        if (saveOnNativeFlag) this.nativeContext.save();
        var props = this.cTr.props;
        if (this._length <= this.cArrPos) this.duplicate();
        var currentStack = this.stack[this.cArrPos];
        var i;
        for(i = 0; i < 16; i += 1)currentStack.transform[i] = props[i];
        this.cArrPos += 1;
        var newStack = this.stack[this.cArrPos];
        newStack.opacity = currentStack.opacity;
        newStack.fillStyle = currentStack.fillStyle;
        newStack.strokeStyle = currentStack.strokeStyle;
        newStack.lineWidth = currentStack.lineWidth;
        newStack.lineCap = currentStack.lineCap;
        newStack.lineJoin = currentStack.lineJoin;
        newStack.miterLimit = currentStack.miterLimit;
    };
    CVContextData.prototype.setOpacity = function(value) {
        this.stack[this.cArrPos].opacity = value;
    };
    CVContextData.prototype.setContext = function(value) {
        this.nativeContext = value;
    };
    CVContextData.prototype.fillStyle = function(value) {
        if (this.stack[this.cArrPos].fillStyle !== value) {
            this.currentFillStyle = value;
            this.stack[this.cArrPos].fillStyle = value;
        }
    };
    CVContextData.prototype.strokeStyle = function(value) {
        if (this.stack[this.cArrPos].strokeStyle !== value) {
            this.currentStrokeStyle = value;
            this.stack[this.cArrPos].strokeStyle = value;
        }
    };
    CVContextData.prototype.lineWidth = function(value) {
        if (this.stack[this.cArrPos].lineWidth !== value) {
            this.currentLineWidth = value;
            this.stack[this.cArrPos].lineWidth = value;
        }
    };
    CVContextData.prototype.lineCap = function(value) {
        if (this.stack[this.cArrPos].lineCap !== value) {
            this.currentLineCap = value;
            this.stack[this.cArrPos].lineCap = value;
        }
    };
    CVContextData.prototype.lineJoin = function(value) {
        if (this.stack[this.cArrPos].lineJoin !== value) {
            this.currentLineJoin = value;
            this.stack[this.cArrPos].lineJoin = value;
        }
    };
    CVContextData.prototype.miterLimit = function(value) {
        if (this.stack[this.cArrPos].miterLimit !== value) {
            this.currentMiterLimit = value;
            this.stack[this.cArrPos].miterLimit = value;
        }
    };
    CVContextData.prototype.transform = function(props) {
        this.transformMat.cloneFromProps(props); // Taking the last transform value from the stored stack of transforms
        var currentTransform = this.cTr; // Applying the last transform value after the new transform to respect the order of transformations
        this.transformMat.multiply(currentTransform); // Storing the new transformed value in the stored transform
        currentTransform.cloneFromProps(this.transformMat.props);
        var trProps = currentTransform.props; // Applying the new transform to the canvas
        this.nativeContext.setTransform(trProps[0], trProps[1], trProps[4], trProps[5], trProps[12], trProps[13]);
    };
    CVContextData.prototype.opacity = function(op) {
        var currentOpacity = this.stack[this.cArrPos].opacity;
        currentOpacity *= op < 0 ? 0 : op;
        if (this.stack[this.cArrPos].opacity !== currentOpacity) {
            if (this.currentOpacity !== op) {
                this.nativeContext.globalAlpha = op;
                this.currentOpacity = op;
            }
            this.stack[this.cArrPos].opacity = currentOpacity;
        }
    };
    CVContextData.prototype.fill = function(rule) {
        if (this.appliedFillStyle !== this.currentFillStyle) {
            this.appliedFillStyle = this.currentFillStyle;
            this.nativeContext.fillStyle = this.appliedFillStyle;
        }
        this.nativeContext.fill(rule);
    };
    CVContextData.prototype.fillRect = function(x, y, w, h) {
        if (this.appliedFillStyle !== this.currentFillStyle) {
            this.appliedFillStyle = this.currentFillStyle;
            this.nativeContext.fillStyle = this.appliedFillStyle;
        }
        this.nativeContext.fillRect(x, y, w, h);
    };
    CVContextData.prototype.stroke = function() {
        if (this.appliedStrokeStyle !== this.currentStrokeStyle) {
            this.appliedStrokeStyle = this.currentStrokeStyle;
            this.nativeContext.strokeStyle = this.appliedStrokeStyle;
        }
        if (this.appliedLineWidth !== this.currentLineWidth) {
            this.appliedLineWidth = this.currentLineWidth;
            this.nativeContext.lineWidth = this.appliedLineWidth;
        }
        if (this.appliedLineCap !== this.currentLineCap) {
            this.appliedLineCap = this.currentLineCap;
            this.nativeContext.lineCap = this.appliedLineCap;
        }
        if (this.appliedLineJoin !== this.currentLineJoin) {
            this.appliedLineJoin = this.currentLineJoin;
            this.nativeContext.lineJoin = this.appliedLineJoin;
        }
        if (this.appliedMiterLimit !== this.currentMiterLimit) {
            this.appliedMiterLimit = this.currentMiterLimit;
            this.nativeContext.miterLimit = this.appliedMiterLimit;
        }
        this.nativeContext.stroke();
    };
    function CVCompElement(data, globalData, comp) {
        this.completeLayers = false;
        this.layers = data.layers;
        this.pendingElements = [];
        this.elements = createSizedArray(this.layers.length);
        this.initElement(data, globalData, comp);
        this.tm = data.tm ? PropertyFactory.getProp(this, data.tm, 0, globalData.frameRate, this) : {
            _placeholder: true
        };
    }
    extendPrototype([
        CanvasRendererBase,
        ICompElement,
        CVBaseElement
    ], CVCompElement);
    CVCompElement.prototype.renderInnerContent = function() {
        var ctx = this.canvasContext;
        ctx.beginPath();
        ctx.moveTo(0, 0);
        ctx.lineTo(this.data.w, 0);
        ctx.lineTo(this.data.w, this.data.h);
        ctx.lineTo(0, this.data.h);
        ctx.lineTo(0, 0);
        ctx.clip();
        var i;
        var len = this.layers.length;
        for(i = len - 1; i >= 0; i -= 1)if (this.completeLayers || this.elements[i]) this.elements[i].renderFrame();
    };
    CVCompElement.prototype.destroy = function() {
        var i;
        var len = this.layers.length;
        for(i = len - 1; i >= 0; i -= 1)if (this.elements[i]) this.elements[i].destroy();
        this.layers = null;
        this.elements = null;
    };
    CVCompElement.prototype.createComp = function(data) {
        return new CVCompElement(data, this.globalData, this);
    };
    function CanvasRenderer(animationItem, config) {
        this.animationItem = animationItem;
        this.renderConfig = {
            clearCanvas: config && config.clearCanvas !== undefined ? config.clearCanvas : true,
            context: config && config.context || null,
            progressiveLoad: config && config.progressiveLoad || false,
            preserveAspectRatio: config && config.preserveAspectRatio || "xMidYMid meet",
            imagePreserveAspectRatio: config && config.imagePreserveAspectRatio || "xMidYMid slice",
            contentVisibility: config && config.contentVisibility || "visible",
            className: config && config.className || "",
            id: config && config.id || "",
            runExpressions: !config || config.runExpressions === undefined || config.runExpressions
        };
        this.renderConfig.dpr = config && config.dpr || 1;
        if (this.animationItem.wrapper) this.renderConfig.dpr = config && config.dpr || window.devicePixelRatio || 1;
        this.renderedFrame = -1;
        this.globalData = {
            frameNum: -1,
            _mdf: false,
            renderConfig: this.renderConfig,
            currentGlobalAlpha: -1
        };
        this.contextData = new CVContextData();
        this.elements = [];
        this.pendingElements = [];
        this.transformMat = new Matrix();
        this.completeLayers = false;
        this.rendererType = "canvas";
        if (this.renderConfig.clearCanvas) {
            this.ctxTransform = this.contextData.transform.bind(this.contextData);
            this.ctxOpacity = this.contextData.opacity.bind(this.contextData);
            this.ctxFillStyle = this.contextData.fillStyle.bind(this.contextData);
            this.ctxStrokeStyle = this.contextData.strokeStyle.bind(this.contextData);
            this.ctxLineWidth = this.contextData.lineWidth.bind(this.contextData);
            this.ctxLineCap = this.contextData.lineCap.bind(this.contextData);
            this.ctxLineJoin = this.contextData.lineJoin.bind(this.contextData);
            this.ctxMiterLimit = this.contextData.miterLimit.bind(this.contextData);
            this.ctxFill = this.contextData.fill.bind(this.contextData);
            this.ctxFillRect = this.contextData.fillRect.bind(this.contextData);
            this.ctxStroke = this.contextData.stroke.bind(this.contextData);
            this.save = this.contextData.save.bind(this.contextData);
        }
    }
    extendPrototype([
        CanvasRendererBase
    ], CanvasRenderer);
    CanvasRenderer.prototype.createComp = function(data) {
        return new CVCompElement(data, this.globalData, this);
    };
    function HBaseElement() {}
    HBaseElement.prototype = {
        checkBlendMode: function checkBlendMode() {},
        initRendererElement: function initRendererElement() {
            this.baseElement = createTag(this.data.tg || "div");
            if (this.data.hasMask) {
                this.svgElement = createNS("svg");
                this.layerElement = createNS("g");
                this.maskedElement = this.layerElement;
                this.svgElement.appendChild(this.layerElement);
                this.baseElement.appendChild(this.svgElement);
            } else this.layerElement = this.baseElement;
            styleDiv(this.baseElement);
        },
        createContainerElements: function createContainerElements() {
            this.renderableEffectsManager = new CVEffects(this);
            this.transformedElement = this.baseElement;
            this.maskedElement = this.layerElement;
            if (this.data.ln) this.layerElement.setAttribute("id", this.data.ln);
            if (this.data.cl) this.layerElement.setAttribute("class", this.data.cl);
            if (this.data.bm !== 0) this.setBlendMode();
        },
        renderElement: function renderElement() {
            var transformedElementStyle = this.transformedElement ? this.transformedElement.style : {};
            if (this.finalTransform._matMdf) {
                var matrixValue = this.finalTransform.mat.toCSS();
                transformedElementStyle.transform = matrixValue;
                transformedElementStyle.webkitTransform = matrixValue;
            }
            if (this.finalTransform._opMdf) transformedElementStyle.opacity = this.finalTransform.mProp.o.v;
        },
        renderFrame: function renderFrame() {
            // If it is exported as hidden (data.hd === true) no need to render
            // If it is not visible no need to render
            if (this.data.hd || this.hidden) return;
            this.renderTransform();
            this.renderRenderable();
            this.renderElement();
            this.renderInnerContent();
            if (this._isFirstFrame) this._isFirstFrame = false;
        },
        destroy: function destroy() {
            this.layerElement = null;
            this.transformedElement = null;
            if (this.matteElement) this.matteElement = null;
            if (this.maskManager) {
                this.maskManager.destroy();
                this.maskManager = null;
            }
        },
        createRenderableComponents: function createRenderableComponents() {
            this.maskManager = new MaskElement(this.data, this, this.globalData);
        },
        addEffects: function addEffects() {},
        setMatte: function setMatte() {}
    };
    HBaseElement.prototype.getBaseElement = SVGBaseElement.prototype.getBaseElement;
    HBaseElement.prototype.destroyBaseElement = HBaseElement.prototype.destroy;
    HBaseElement.prototype.buildElementParenting = BaseRenderer.prototype.buildElementParenting;
    function HSolidElement(data, globalData, comp) {
        this.initElement(data, globalData, comp);
    }
    extendPrototype([
        BaseElement,
        TransformElement,
        HBaseElement,
        HierarchyElement,
        FrameElement,
        RenderableDOMElement
    ], HSolidElement);
    HSolidElement.prototype.createContent = function() {
        var rect;
        if (this.data.hasMask) {
            rect = createNS("rect");
            rect.setAttribute("width", this.data.sw);
            rect.setAttribute("height", this.data.sh);
            rect.setAttribute("fill", this.data.sc);
            this.svgElement.setAttribute("width", this.data.sw);
            this.svgElement.setAttribute("height", this.data.sh);
        } else {
            rect = createTag("div");
            rect.style.width = this.data.sw + "px";
            rect.style.height = this.data.sh + "px";
            rect.style.backgroundColor = this.data.sc;
        }
        this.layerElement.appendChild(rect);
    };
    function HShapeElement(data, globalData, comp) {
        // List of drawable elements
        this.shapes = []; // Full shape data
        this.shapesData = data.shapes; // List of styles that will be applied to shapes
        this.stylesList = []; // List of modifiers that will be applied to shapes
        this.shapeModifiers = []; // List of items in shape tree
        this.itemsData = []; // List of items in previous shape tree
        this.processedElements = []; // List of animated components
        this.animatedContents = [];
        this.shapesContainer = createNS("g");
        this.initElement(data, globalData, comp); // Moving any property that doesn't get too much access after initialization because of v8 way of handling more than 10 properties.
        // List of elements that have been created
        this.prevViewData = [];
        this.currentBBox = {
            x: 999999,
            y: -999999,
            h: 0,
            w: 0
        };
    }
    extendPrototype([
        BaseElement,
        TransformElement,
        HSolidElement,
        SVGShapeElement,
        HBaseElement,
        HierarchyElement,
        FrameElement,
        RenderableElement
    ], HShapeElement);
    HShapeElement.prototype._renderShapeFrame = HShapeElement.prototype.renderInnerContent;
    HShapeElement.prototype.createContent = function() {
        var cont;
        this.baseElement.style.fontSize = 0;
        if (this.data.hasMask) {
            this.layerElement.appendChild(this.shapesContainer);
            cont = this.svgElement;
        } else {
            cont = createNS("svg");
            var size = this.comp.data ? this.comp.data : this.globalData.compSize;
            cont.setAttribute("width", size.w);
            cont.setAttribute("height", size.h);
            cont.appendChild(this.shapesContainer);
            this.layerElement.appendChild(cont);
        }
        this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, this.shapesContainer, 0, [], true);
        this.filterUniqueShapes();
        this.shapeCont = cont;
    };
    HShapeElement.prototype.getTransformedPoint = function(transformers, point) {
        var i;
        var len = transformers.length;
        for(i = 0; i < len; i += 1)point = transformers[i].mProps.v.applyToPointArray(point[0], point[1], 0);
        return point;
    };
    HShapeElement.prototype.calculateShapeBoundingBox = function(item, boundingBox) {
        var shape = item.sh.v;
        var transformers = item.transformers;
        var i;
        var len = shape._length;
        var vPoint;
        var oPoint;
        var nextIPoint;
        var nextVPoint;
        if (len <= 1) return;
        for(i = 0; i < len - 1; i += 1){
            vPoint = this.getTransformedPoint(transformers, shape.v[i]);
            oPoint = this.getTransformedPoint(transformers, shape.o[i]);
            nextIPoint = this.getTransformedPoint(transformers, shape.i[i + 1]);
            nextVPoint = this.getTransformedPoint(transformers, shape.v[i + 1]);
            this.checkBounds(vPoint, oPoint, nextIPoint, nextVPoint, boundingBox);
        }
        if (shape.c) {
            vPoint = this.getTransformedPoint(transformers, shape.v[i]);
            oPoint = this.getTransformedPoint(transformers, shape.o[i]);
            nextIPoint = this.getTransformedPoint(transformers, shape.i[0]);
            nextVPoint = this.getTransformedPoint(transformers, shape.v[0]);
            this.checkBounds(vPoint, oPoint, nextIPoint, nextVPoint, boundingBox);
        }
    };
    HShapeElement.prototype.checkBounds = function(vPoint, oPoint, nextIPoint, nextVPoint, boundingBox) {
        this.getBoundsOfCurve(vPoint, oPoint, nextIPoint, nextVPoint);
        var bounds = this.shapeBoundingBox;
        boundingBox.x = bmMin(bounds.left, boundingBox.x);
        boundingBox.xMax = bmMax(bounds.right, boundingBox.xMax);
        boundingBox.y = bmMin(bounds.top, boundingBox.y);
        boundingBox.yMax = bmMax(bounds.bottom, boundingBox.yMax);
    };
    HShapeElement.prototype.shapeBoundingBox = {
        left: 0,
        right: 0,
        top: 0,
        bottom: 0
    };
    HShapeElement.prototype.tempBoundingBox = {
        x: 0,
        xMax: 0,
        y: 0,
        yMax: 0,
        width: 0,
        height: 0
    };
    HShapeElement.prototype.getBoundsOfCurve = function(p0, p1, p2, p3) {
        var bounds = [
            [
                p0[0],
                p3[0]
            ],
            [
                p0[1],
                p3[1]
            ]
        ];
        for(var a, b, c, t, b2ac, t1, t2, i = 0; i < 2; ++i){
            // eslint-disable-line no-plusplus
            b = 6 * p0[i] - 12 * p1[i] + 6 * p2[i];
            a = -3 * p0[i] + 9 * p1[i] - 9 * p2[i] + 3 * p3[i];
            c = 3 * p1[i] - 3 * p0[i];
            b |= 0; // eslint-disable-line no-bitwise
            a |= 0; // eslint-disable-line no-bitwise
            c |= 0; // eslint-disable-line no-bitwise
            if (a === 0 && b === 0) ;
            else if (a === 0) {
                t = -c / b;
                if (t > 0 && t < 1) bounds[i].push(this.calculateF(t, p0, p1, p2, p3, i));
            } else {
                b2ac = b * b - 4 * c * a;
                if (b2ac >= 0) {
                    t1 = (-b + bmSqrt(b2ac)) / (2 * a);
                    if (t1 > 0 && t1 < 1) bounds[i].push(this.calculateF(t1, p0, p1, p2, p3, i));
                    t2 = (-b - bmSqrt(b2ac)) / (2 * a);
                    if (t2 > 0 && t2 < 1) bounds[i].push(this.calculateF(t2, p0, p1, p2, p3, i));
                }
            }
        }
        this.shapeBoundingBox.left = bmMin.apply(null, bounds[0]);
        this.shapeBoundingBox.top = bmMin.apply(null, bounds[1]);
        this.shapeBoundingBox.right = bmMax.apply(null, bounds[0]);
        this.shapeBoundingBox.bottom = bmMax.apply(null, bounds[1]);
    };
    HShapeElement.prototype.calculateF = function(t, p0, p1, p2, p3, i) {
        return bmPow(1 - t, 3) * p0[i] + 3 * bmPow(1 - t, 2) * t * p1[i] + 3 * (1 - t) * bmPow(t, 2) * p2[i] + bmPow(t, 3) * p3[i];
    };
    HShapeElement.prototype.calculateBoundingBox = function(itemsData, boundingBox) {
        var i;
        var len = itemsData.length;
        for(i = 0; i < len; i += 1){
            if (itemsData[i] && itemsData[i].sh) this.calculateShapeBoundingBox(itemsData[i], boundingBox);
            else if (itemsData[i] && itemsData[i].it) this.calculateBoundingBox(itemsData[i].it, boundingBox);
            else if (itemsData[i] && itemsData[i].style && itemsData[i].w) this.expandStrokeBoundingBox(itemsData[i].w, boundingBox);
        }
    };
    HShapeElement.prototype.expandStrokeBoundingBox = function(widthProperty, boundingBox) {
        var width = 0;
        if (widthProperty.keyframes) {
            for(var i = 0; i < widthProperty.keyframes.length; i += 1){
                var kfw = widthProperty.keyframes[i].s;
                if (kfw > width) width = kfw;
            }
            width *= widthProperty.mult;
        } else width = widthProperty.v * widthProperty.mult;
        boundingBox.x -= width;
        boundingBox.xMax += width;
        boundingBox.y -= width;
        boundingBox.yMax += width;
    };
    HShapeElement.prototype.currentBoxContains = function(box) {
        return this.currentBBox.x <= box.x && this.currentBBox.y <= box.y && this.currentBBox.width + this.currentBBox.x >= box.x + box.width && this.currentBBox.height + this.currentBBox.y >= box.y + box.height;
    };
    HShapeElement.prototype.renderInnerContent = function() {
        this._renderShapeFrame();
        if (!this.hidden && (this._isFirstFrame || this._mdf)) {
            var tempBoundingBox = this.tempBoundingBox;
            var max = 999999;
            tempBoundingBox.x = max;
            tempBoundingBox.xMax = -max;
            tempBoundingBox.y = max;
            tempBoundingBox.yMax = -max;
            this.calculateBoundingBox(this.itemsData, tempBoundingBox);
            tempBoundingBox.width = tempBoundingBox.xMax < tempBoundingBox.x ? 0 : tempBoundingBox.xMax - tempBoundingBox.x;
            tempBoundingBox.height = tempBoundingBox.yMax < tempBoundingBox.y ? 0 : tempBoundingBox.yMax - tempBoundingBox.y; // var tempBoundingBox = this.shapeCont.getBBox();
            if (this.currentBoxContains(tempBoundingBox)) return;
            var changed = false;
            if (this.currentBBox.w !== tempBoundingBox.width) {
                this.currentBBox.w = tempBoundingBox.width;
                this.shapeCont.setAttribute("width", tempBoundingBox.width);
                changed = true;
            }
            if (this.currentBBox.h !== tempBoundingBox.height) {
                this.currentBBox.h = tempBoundingBox.height;
                this.shapeCont.setAttribute("height", tempBoundingBox.height);
                changed = true;
            }
            if (changed || this.currentBBox.x !== tempBoundingBox.x || this.currentBBox.y !== tempBoundingBox.y) {
                this.currentBBox.w = tempBoundingBox.width;
                this.currentBBox.h = tempBoundingBox.height;
                this.currentBBox.x = tempBoundingBox.x;
                this.currentBBox.y = tempBoundingBox.y;
                this.shapeCont.setAttribute("viewBox", this.currentBBox.x + " " + this.currentBBox.y + " " + this.currentBBox.w + " " + this.currentBBox.h);
                var shapeStyle = this.shapeCont.style;
                var shapeTransform = "translate(" + this.currentBBox.x + "px," + this.currentBBox.y + "px)";
                shapeStyle.transform = shapeTransform;
                shapeStyle.webkitTransform = shapeTransform;
            }
        }
    };
    function HTextElement(data, globalData, comp) {
        this.textSpans = [];
        this.textPaths = [];
        this.currentBBox = {
            x: 999999,
            y: -999999,
            h: 0,
            w: 0
        };
        this.renderType = "svg";
        this.isMasked = false;
        this.initElement(data, globalData, comp);
    }
    extendPrototype([
        BaseElement,
        TransformElement,
        HBaseElement,
        HierarchyElement,
        FrameElement,
        RenderableDOMElement,
        ITextElement
    ], HTextElement);
    HTextElement.prototype.createContent = function() {
        this.isMasked = this.checkMasks();
        if (this.isMasked) {
            this.renderType = "svg";
            this.compW = this.comp.data.w;
            this.compH = this.comp.data.h;
            this.svgElement.setAttribute("width", this.compW);
            this.svgElement.setAttribute("height", this.compH);
            var g = createNS("g");
            this.maskedElement.appendChild(g);
            this.innerElem = g;
        } else {
            this.renderType = "html";
            this.innerElem = this.layerElement;
        }
        this.checkParenting();
    };
    HTextElement.prototype.buildNewText = function() {
        var documentData = this.textProperty.currentData;
        this.renderedLetters = createSizedArray(documentData.l ? documentData.l.length : 0);
        var innerElemStyle = this.innerElem.style;
        var textColor = documentData.fc ? this.buildColor(documentData.fc) : "rgba(0,0,0,0)";
        innerElemStyle.fill = textColor;
        innerElemStyle.color = textColor;
        if (documentData.sc) {
            innerElemStyle.stroke = this.buildColor(documentData.sc);
            innerElemStyle.strokeWidth = documentData.sw + "px";
        }
        var fontData = this.globalData.fontManager.getFontByName(documentData.f);
        if (!this.globalData.fontManager.chars) {
            innerElemStyle.fontSize = documentData.finalSize + "px";
            innerElemStyle.lineHeight = documentData.finalSize + "px";
            if (fontData.fClass) this.innerElem.className = fontData.fClass;
            else {
                innerElemStyle.fontFamily = fontData.fFamily;
                var fWeight = documentData.fWeight;
                var fStyle = documentData.fStyle;
                innerElemStyle.fontStyle = fStyle;
                innerElemStyle.fontWeight = fWeight;
            }
        }
        var i;
        var len;
        var letters = documentData.l;
        len = letters.length;
        var tSpan;
        var tParent;
        var tCont;
        var matrixHelper = this.mHelper;
        var shapes;
        var shapeStr = "";
        var cnt = 0;
        for(i = 0; i < len; i += 1){
            if (this.globalData.fontManager.chars) {
                if (!this.textPaths[cnt]) {
                    tSpan = createNS("path");
                    tSpan.setAttribute("stroke-linecap", lineCapEnum[1]);
                    tSpan.setAttribute("stroke-linejoin", lineJoinEnum[2]);
                    tSpan.setAttribute("stroke-miterlimit", "4");
                } else tSpan = this.textPaths[cnt];
                if (!this.isMasked) {
                    if (this.textSpans[cnt]) {
                        tParent = this.textSpans[cnt];
                        tCont = tParent.children[0];
                    } else {
                        tParent = createTag("div");
                        tParent.style.lineHeight = 0;
                        tCont = createNS("svg");
                        tCont.appendChild(tSpan);
                        styleDiv(tParent);
                    }
                }
            } else if (!this.isMasked) {
                if (this.textSpans[cnt]) {
                    tParent = this.textSpans[cnt];
                    tSpan = this.textPaths[cnt];
                } else {
                    tParent = createTag("span");
                    styleDiv(tParent);
                    tSpan = createTag("span");
                    styleDiv(tSpan);
                    tParent.appendChild(tSpan);
                }
            } else tSpan = this.textPaths[cnt] ? this.textPaths[cnt] : createNS("text");
             // tSpan.setAttribute('visibility', 'hidden');
            if (this.globalData.fontManager.chars) {
                var charData = this.globalData.fontManager.getCharData(documentData.finalText[i], fontData.fStyle, this.globalData.fontManager.getFontByName(documentData.f).fFamily);
                var shapeData;
                if (charData) shapeData = charData.data;
                else shapeData = null;
                matrixHelper.reset();
                if (shapeData && shapeData.shapes && shapeData.shapes.length) {
                    shapes = shapeData.shapes[0].it;
                    matrixHelper.scale(documentData.finalSize / 100, documentData.finalSize / 100);
                    shapeStr = this.createPathShape(matrixHelper, shapes);
                    tSpan.setAttribute("d", shapeStr);
                }
                if (!this.isMasked) {
                    this.innerElem.appendChild(tParent);
                    if (shapeData && shapeData.shapes) {
                        // document.body.appendChild is needed to get exact measure of shape
                        document.body.appendChild(tCont);
                        var boundingBox = tCont.getBBox();
                        tCont.setAttribute("width", boundingBox.width + 2);
                        tCont.setAttribute("height", boundingBox.height + 2);
                        tCont.setAttribute("viewBox", boundingBox.x - 1 + " " + (boundingBox.y - 1) + " " + (boundingBox.width + 2) + " " + (boundingBox.height + 2));
                        var tContStyle = tCont.style;
                        var tContTranslation = "translate(" + (boundingBox.x - 1) + "px," + (boundingBox.y - 1) + "px)";
                        tContStyle.transform = tContTranslation;
                        tContStyle.webkitTransform = tContTranslation;
                        letters[i].yOffset = boundingBox.y - 1;
                    } else {
                        tCont.setAttribute("width", 1);
                        tCont.setAttribute("height", 1);
                    }
                    tParent.appendChild(tCont);
                } else this.innerElem.appendChild(tSpan);
            } else {
                tSpan.textContent = letters[i].val;
                tSpan.setAttributeNS("http://www.w3.org/XML/1998/namespace", "xml:space", "preserve");
                if (!this.isMasked) {
                    this.innerElem.appendChild(tParent); //
                    var tStyle = tSpan.style;
                    var tSpanTranslation = "translate3d(0," + -documentData.finalSize / 1.2 + "px,0)";
                    tStyle.transform = tSpanTranslation;
                    tStyle.webkitTransform = tSpanTranslation;
                } else this.innerElem.appendChild(tSpan);
            } //
            if (!this.isMasked) this.textSpans[cnt] = tParent;
            else this.textSpans[cnt] = tSpan;
            this.textSpans[cnt].style.display = "block";
            this.textPaths[cnt] = tSpan;
            cnt += 1;
        }
        while(cnt < this.textSpans.length){
            this.textSpans[cnt].style.display = "none";
            cnt += 1;
        }
    };
    HTextElement.prototype.renderInnerContent = function() {
        this.validateText();
        var svgStyle;
        if (this.data.singleShape) {
            if (!this._isFirstFrame && !this.lettersChangedFlag) return;
            if (this.isMasked && this.finalTransform._matMdf) {
                // Todo Benchmark if using this is better than getBBox
                this.svgElement.setAttribute("viewBox", -this.finalTransform.mProp.p.v[0] + " " + -this.finalTransform.mProp.p.v[1] + " " + this.compW + " " + this.compH);
                svgStyle = this.svgElement.style;
                var translation = "translate(" + -this.finalTransform.mProp.p.v[0] + "px," + -this.finalTransform.mProp.p.v[1] + "px)";
                svgStyle.transform = translation;
                svgStyle.webkitTransform = translation;
            }
        }
        this.textAnimator.getMeasures(this.textProperty.currentData, this.lettersChangedFlag);
        if (!this.lettersChangedFlag && !this.textAnimator.lettersChangedFlag) return;
        var i;
        var len;
        var count = 0;
        var renderedLetters = this.textAnimator.renderedLetters;
        var letters = this.textProperty.currentData.l;
        len = letters.length;
        var renderedLetter;
        var textSpan;
        var textPath;
        for(i = 0; i < len; i += 1)if (letters[i].n) count += 1;
        else {
            textSpan = this.textSpans[i];
            textPath = this.textPaths[i];
            renderedLetter = renderedLetters[count];
            count += 1;
            if (renderedLetter._mdf.m) {
                if (!this.isMasked) {
                    textSpan.style.webkitTransform = renderedLetter.m;
                    textSpan.style.transform = renderedLetter.m;
                } else textSpan.setAttribute("transform", renderedLetter.m);
            } /// /textSpan.setAttribute('opacity',renderedLetter.o);
            textSpan.style.opacity = renderedLetter.o;
            if (renderedLetter.sw && renderedLetter._mdf.sw) textPath.setAttribute("stroke-width", renderedLetter.sw);
            if (renderedLetter.sc && renderedLetter._mdf.sc) textPath.setAttribute("stroke", renderedLetter.sc);
            if (renderedLetter.fc && renderedLetter._mdf.fc) {
                textPath.setAttribute("fill", renderedLetter.fc);
                textPath.style.color = renderedLetter.fc;
            }
        }
        if (this.innerElem.getBBox && !this.hidden && (this._isFirstFrame || this._mdf)) {
            var boundingBox = this.innerElem.getBBox();
            if (this.currentBBox.w !== boundingBox.width) {
                this.currentBBox.w = boundingBox.width;
                this.svgElement.setAttribute("width", boundingBox.width);
            }
            if (this.currentBBox.h !== boundingBox.height) {
                this.currentBBox.h = boundingBox.height;
                this.svgElement.setAttribute("height", boundingBox.height);
            }
            var margin = 1;
            if (this.currentBBox.w !== boundingBox.width + margin * 2 || this.currentBBox.h !== boundingBox.height + margin * 2 || this.currentBBox.x !== boundingBox.x - margin || this.currentBBox.y !== boundingBox.y - margin) {
                this.currentBBox.w = boundingBox.width + margin * 2;
                this.currentBBox.h = boundingBox.height + margin * 2;
                this.currentBBox.x = boundingBox.x - margin;
                this.currentBBox.y = boundingBox.y - margin;
                this.svgElement.setAttribute("viewBox", this.currentBBox.x + " " + this.currentBBox.y + " " + this.currentBBox.w + " " + this.currentBBox.h);
                svgStyle = this.svgElement.style;
                var svgTransform = "translate(" + this.currentBBox.x + "px," + this.currentBBox.y + "px)";
                svgStyle.transform = svgTransform;
                svgStyle.webkitTransform = svgTransform;
            }
        }
    };
    function HCameraElement(data, globalData, comp) {
        this.initFrame();
        this.initBaseData(data, globalData, comp);
        this.initHierarchy();
        var getProp = PropertyFactory.getProp;
        this.pe = getProp(this, data.pe, 0, 0, this);
        if (data.ks.p.s) {
            this.px = getProp(this, data.ks.p.x, 1, 0, this);
            this.py = getProp(this, data.ks.p.y, 1, 0, this);
            this.pz = getProp(this, data.ks.p.z, 1, 0, this);
        } else this.p = getProp(this, data.ks.p, 1, 0, this);
        if (data.ks.a) this.a = getProp(this, data.ks.a, 1, 0, this);
        if (data.ks.or.k.length && data.ks.or.k[0].to) {
            var i;
            var len = data.ks.or.k.length;
            for(i = 0; i < len; i += 1){
                data.ks.or.k[i].to = null;
                data.ks.or.k[i].ti = null;
            }
        }
        this.or = getProp(this, data.ks.or, 1, degToRads, this);
        this.or.sh = true;
        this.rx = getProp(this, data.ks.rx, 0, degToRads, this);
        this.ry = getProp(this, data.ks.ry, 0, degToRads, this);
        this.rz = getProp(this, data.ks.rz, 0, degToRads, this);
        this.mat = new Matrix();
        this._prevMat = new Matrix();
        this._isFirstFrame = true; // TODO: find a better way to make the HCamera element to be compatible with the LayerInterface and TransformInterface.
        this.finalTransform = {
            mProp: this
        };
    }
    extendPrototype([
        BaseElement,
        FrameElement,
        HierarchyElement
    ], HCameraElement);
    HCameraElement.prototype.setup = function() {
        var i;
        var len = this.comp.threeDElements.length;
        var comp;
        var perspectiveStyle;
        var containerStyle;
        for(i = 0; i < len; i += 1){
            // [perspectiveElem,container]
            comp = this.comp.threeDElements[i];
            if (comp.type === "3d") {
                perspectiveStyle = comp.perspectiveElem.style;
                containerStyle = comp.container.style;
                var perspective = this.pe.v + "px";
                var origin = "0px 0px 0px";
                var matrix = "matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1)";
                perspectiveStyle.perspective = perspective;
                perspectiveStyle.webkitPerspective = perspective;
                containerStyle.transformOrigin = origin;
                containerStyle.mozTransformOrigin = origin;
                containerStyle.webkitTransformOrigin = origin;
                perspectiveStyle.transform = matrix;
                perspectiveStyle.webkitTransform = matrix;
            }
        }
    };
    HCameraElement.prototype.createElements = function() {};
    HCameraElement.prototype.hide = function() {};
    HCameraElement.prototype.renderFrame = function() {
        var _mdf = this._isFirstFrame;
        var i;
        var len;
        if (this.hierarchy) {
            len = this.hierarchy.length;
            for(i = 0; i < len; i += 1)_mdf = this.hierarchy[i].finalTransform.mProp._mdf || _mdf;
        }
        if (_mdf || this.pe._mdf || this.p && this.p._mdf || this.px && (this.px._mdf || this.py._mdf || this.pz._mdf) || this.rx._mdf || this.ry._mdf || this.rz._mdf || this.or._mdf || this.a && this.a._mdf) {
            this.mat.reset();
            if (this.hierarchy) {
                len = this.hierarchy.length - 1;
                for(i = len; i >= 0; i -= 1){
                    var mTransf = this.hierarchy[i].finalTransform.mProp;
                    this.mat.translate(-mTransf.p.v[0], -mTransf.p.v[1], mTransf.p.v[2]);
                    this.mat.rotateX(-mTransf.or.v[0]).rotateY(-mTransf.or.v[1]).rotateZ(mTransf.or.v[2]);
                    this.mat.rotateX(-mTransf.rx.v).rotateY(-mTransf.ry.v).rotateZ(mTransf.rz.v);
                    this.mat.scale(1 / mTransf.s.v[0], 1 / mTransf.s.v[1], 1 / mTransf.s.v[2]);
                    this.mat.translate(mTransf.a.v[0], mTransf.a.v[1], mTransf.a.v[2]);
                }
            }
            if (this.p) this.mat.translate(-this.p.v[0], -this.p.v[1], this.p.v[2]);
            else this.mat.translate(-this.px.v, -this.py.v, this.pz.v);
            if (this.a) {
                var diffVector;
                if (this.p) diffVector = [
                    this.p.v[0] - this.a.v[0],
                    this.p.v[1] - this.a.v[1],
                    this.p.v[2] - this.a.v[2]
                ];
                else diffVector = [
                    this.px.v - this.a.v[0],
                    this.py.v - this.a.v[1],
                    this.pz.v - this.a.v[2]
                ];
                var mag = Math.sqrt(Math.pow(diffVector[0], 2) + Math.pow(diffVector[1], 2) + Math.pow(diffVector[2], 2)); // var lookDir = getNormalizedPoint(getDiffVector(this.a.v,this.p.v));
                var lookDir = [
                    diffVector[0] / mag,
                    diffVector[1] / mag,
                    diffVector[2] / mag
                ];
                var lookLengthOnXZ = Math.sqrt(lookDir[2] * lookDir[2] + lookDir[0] * lookDir[0]);
                var mRotationX = Math.atan2(lookDir[1], lookLengthOnXZ);
                var mRotationY = Math.atan2(lookDir[0], -lookDir[2]);
                this.mat.rotateY(mRotationY).rotateX(-mRotationX);
            }
            this.mat.rotateX(-this.rx.v).rotateY(-this.ry.v).rotateZ(this.rz.v);
            this.mat.rotateX(-this.or.v[0]).rotateY(-this.or.v[1]).rotateZ(this.or.v[2]);
            this.mat.translate(this.globalData.compSize.w / 2, this.globalData.compSize.h / 2, 0);
            this.mat.translate(0, 0, this.pe.v);
            var hasMatrixChanged = !this._prevMat.equals(this.mat);
            if ((hasMatrixChanged || this.pe._mdf) && this.comp.threeDElements) {
                len = this.comp.threeDElements.length;
                var comp;
                var perspectiveStyle;
                var containerStyle;
                for(i = 0; i < len; i += 1){
                    comp = this.comp.threeDElements[i];
                    if (comp.type === "3d") {
                        if (hasMatrixChanged) {
                            var matValue = this.mat.toCSS();
                            containerStyle = comp.container.style;
                            containerStyle.transform = matValue;
                            containerStyle.webkitTransform = matValue;
                        }
                        if (this.pe._mdf) {
                            perspectiveStyle = comp.perspectiveElem.style;
                            perspectiveStyle.perspective = this.pe.v + "px";
                            perspectiveStyle.webkitPerspective = this.pe.v + "px";
                        }
                    }
                }
                this.mat.clone(this._prevMat);
            }
        }
        this._isFirstFrame = false;
    };
    HCameraElement.prototype.prepareFrame = function(num) {
        this.prepareProperties(num, true);
    };
    HCameraElement.prototype.destroy = function() {};
    HCameraElement.prototype.getBaseElement = function() {
        return null;
    };
    function HImageElement(data, globalData, comp) {
        this.assetData = globalData.getAssetData(data.refId);
        this.initElement(data, globalData, comp);
    }
    extendPrototype([
        BaseElement,
        TransformElement,
        HBaseElement,
        HSolidElement,
        HierarchyElement,
        FrameElement,
        RenderableElement
    ], HImageElement);
    HImageElement.prototype.createContent = function() {
        var assetPath = this.globalData.getAssetsPath(this.assetData);
        var img = new Image();
        if (this.data.hasMask) {
            this.imageElem = createNS("image");
            this.imageElem.setAttribute("width", this.assetData.w + "px");
            this.imageElem.setAttribute("height", this.assetData.h + "px");
            this.imageElem.setAttributeNS("http://www.w3.org/1999/xlink", "href", assetPath);
            this.layerElement.appendChild(this.imageElem);
            this.baseElement.setAttribute("width", this.assetData.w);
            this.baseElement.setAttribute("height", this.assetData.h);
        } else this.layerElement.appendChild(img);
        img.crossOrigin = "anonymous";
        img.src = assetPath;
        if (this.data.ln) this.baseElement.setAttribute("id", this.data.ln);
    };
    function HybridRendererBase(animationItem, config) {
        this.animationItem = animationItem;
        this.layers = null;
        this.renderedFrame = -1;
        this.renderConfig = {
            className: config && config.className || "",
            imagePreserveAspectRatio: config && config.imagePreserveAspectRatio || "xMidYMid slice",
            hideOnTransparent: !(config && config.hideOnTransparent === false),
            filterSize: {
                width: config && config.filterSize && config.filterSize.width || "400%",
                height: config && config.filterSize && config.filterSize.height || "400%",
                x: config && config.filterSize && config.filterSize.x || "-100%",
                y: config && config.filterSize && config.filterSize.y || "-100%"
            }
        };
        this.globalData = {
            _mdf: false,
            frameNum: -1,
            renderConfig: this.renderConfig
        };
        this.pendingElements = [];
        this.elements = [];
        this.threeDElements = [];
        this.destroyed = false;
        this.camera = null;
        this.supports3d = true;
        this.rendererType = "html";
    }
    extendPrototype([
        BaseRenderer
    ], HybridRendererBase);
    HybridRendererBase.prototype.buildItem = SVGRenderer.prototype.buildItem;
    HybridRendererBase.prototype.checkPendingElements = function() {
        while(this.pendingElements.length){
            var element = this.pendingElements.pop();
            element.checkParenting();
        }
    };
    HybridRendererBase.prototype.appendElementInPos = function(element, pos) {
        var newDOMElement = element.getBaseElement();
        if (!newDOMElement) return;
        var layer = this.layers[pos];
        if (!layer.ddd || !this.supports3d) {
            if (this.threeDElements) this.addTo3dContainer(newDOMElement, pos);
            else {
                var i = 0;
                var nextDOMElement;
                var nextLayer;
                var tmpDOMElement;
                while(i < pos){
                    if (this.elements[i] && this.elements[i] !== true && this.elements[i].getBaseElement) {
                        nextLayer = this.elements[i];
                        tmpDOMElement = this.layers[i].ddd ? this.getThreeDContainerByPos(i) : nextLayer.getBaseElement();
                        nextDOMElement = tmpDOMElement || nextDOMElement;
                    }
                    i += 1;
                }
                if (nextDOMElement) {
                    if (!layer.ddd || !this.supports3d) this.layerElement.insertBefore(newDOMElement, nextDOMElement);
                } else if (!layer.ddd || !this.supports3d) this.layerElement.appendChild(newDOMElement);
            }
        } else this.addTo3dContainer(newDOMElement, pos);
    };
    HybridRendererBase.prototype.createShape = function(data) {
        if (!this.supports3d) return new SVGShapeElement(data, this.globalData, this);
        return new HShapeElement(data, this.globalData, this);
    };
    HybridRendererBase.prototype.createText = function(data) {
        if (!this.supports3d) return new SVGTextLottieElement(data, this.globalData, this);
        return new HTextElement(data, this.globalData, this);
    };
    HybridRendererBase.prototype.createCamera = function(data) {
        this.camera = new HCameraElement(data, this.globalData, this);
        return this.camera;
    };
    HybridRendererBase.prototype.createImage = function(data) {
        if (!this.supports3d) return new IImageElement(data, this.globalData, this);
        return new HImageElement(data, this.globalData, this);
    };
    HybridRendererBase.prototype.createSolid = function(data) {
        if (!this.supports3d) return new ISolidElement(data, this.globalData, this);
        return new HSolidElement(data, this.globalData, this);
    };
    HybridRendererBase.prototype.createNull = SVGRenderer.prototype.createNull;
    HybridRendererBase.prototype.getThreeDContainerByPos = function(pos) {
        var i = 0;
        var len = this.threeDElements.length;
        while(i < len){
            if (this.threeDElements[i].startPos <= pos && this.threeDElements[i].endPos >= pos) return this.threeDElements[i].perspectiveElem;
            i += 1;
        }
        return null;
    };
    HybridRendererBase.prototype.createThreeDContainer = function(pos, type) {
        var perspectiveElem = createTag("div");
        var style;
        var containerStyle;
        styleDiv(perspectiveElem);
        var container = createTag("div");
        styleDiv(container);
        if (type === "3d") {
            style = perspectiveElem.style;
            style.width = this.globalData.compSize.w + "px";
            style.height = this.globalData.compSize.h + "px";
            var center = "50% 50%";
            style.webkitTransformOrigin = center;
            style.mozTransformOrigin = center;
            style.transformOrigin = center;
            containerStyle = container.style;
            var matrix = "matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1)";
            containerStyle.transform = matrix;
            containerStyle.webkitTransform = matrix;
        }
        perspectiveElem.appendChild(container); // this.resizerElem.appendChild(perspectiveElem);
        var threeDContainerData = {
            container: container,
            perspectiveElem: perspectiveElem,
            startPos: pos,
            endPos: pos,
            type: type
        };
        this.threeDElements.push(threeDContainerData);
        return threeDContainerData;
    };
    HybridRendererBase.prototype.build3dContainers = function() {
        var i;
        var len = this.layers.length;
        var lastThreeDContainerData;
        var currentContainer = "";
        for(i = 0; i < len; i += 1)if (this.layers[i].ddd && this.layers[i].ty !== 3) {
            if (currentContainer !== "3d") {
                currentContainer = "3d";
                lastThreeDContainerData = this.createThreeDContainer(i, "3d");
            }
            lastThreeDContainerData.endPos = Math.max(lastThreeDContainerData.endPos, i);
        } else {
            if (currentContainer !== "2d") {
                currentContainer = "2d";
                lastThreeDContainerData = this.createThreeDContainer(i, "2d");
            }
            lastThreeDContainerData.endPos = Math.max(lastThreeDContainerData.endPos, i);
        }
        len = this.threeDElements.length;
        for(i = len - 1; i >= 0; i -= 1)this.resizerElem.appendChild(this.threeDElements[i].perspectiveElem);
    };
    HybridRendererBase.prototype.addTo3dContainer = function(elem, pos) {
        var i = 0;
        var len = this.threeDElements.length;
        while(i < len){
            if (pos <= this.threeDElements[i].endPos) {
                var j = this.threeDElements[i].startPos;
                var nextElement;
                while(j < pos){
                    if (this.elements[j] && this.elements[j].getBaseElement) nextElement = this.elements[j].getBaseElement();
                    j += 1;
                }
                if (nextElement) this.threeDElements[i].container.insertBefore(elem, nextElement);
                else this.threeDElements[i].container.appendChild(elem);
                break;
            }
            i += 1;
        }
    };
    HybridRendererBase.prototype.configAnimation = function(animData) {
        var resizerElem = createTag("div");
        var wrapper = this.animationItem.wrapper;
        var style = resizerElem.style;
        style.width = animData.w + "px";
        style.height = animData.h + "px";
        this.resizerElem = resizerElem;
        styleDiv(resizerElem);
        style.transformStyle = "flat";
        style.mozTransformStyle = "flat";
        style.webkitTransformStyle = "flat";
        if (this.renderConfig.className) resizerElem.setAttribute("class", this.renderConfig.className);
        wrapper.appendChild(resizerElem);
        style.overflow = "hidden";
        var svg = createNS("svg");
        svg.setAttribute("width", "1");
        svg.setAttribute("height", "1");
        styleDiv(svg);
        this.resizerElem.appendChild(svg);
        var defs = createNS("defs");
        svg.appendChild(defs);
        this.data = animData; // Mask animation
        this.setupGlobalData(animData, svg);
        this.globalData.defs = defs;
        this.layers = animData.layers;
        this.layerElement = this.resizerElem;
        this.build3dContainers();
        this.updateContainerSize();
    };
    HybridRendererBase.prototype.destroy = function() {
        if (this.animationItem.wrapper) this.animationItem.wrapper.innerText = "";
        this.animationItem.container = null;
        this.globalData.defs = null;
        var i;
        var len = this.layers ? this.layers.length : 0;
        for(i = 0; i < len; i += 1)if (this.elements[i] && this.elements[i].destroy) this.elements[i].destroy();
        this.elements.length = 0;
        this.destroyed = true;
        this.animationItem = null;
    };
    HybridRendererBase.prototype.updateContainerSize = function() {
        var elementWidth = this.animationItem.wrapper.offsetWidth;
        var elementHeight = this.animationItem.wrapper.offsetHeight;
        var elementRel = elementWidth / elementHeight;
        var animationRel = this.globalData.compSize.w / this.globalData.compSize.h;
        var sx;
        var sy;
        var tx;
        var ty;
        if (animationRel > elementRel) {
            sx = elementWidth / this.globalData.compSize.w;
            sy = elementWidth / this.globalData.compSize.w;
            tx = 0;
            ty = (elementHeight - this.globalData.compSize.h * (elementWidth / this.globalData.compSize.w)) / 2;
        } else {
            sx = elementHeight / this.globalData.compSize.h;
            sy = elementHeight / this.globalData.compSize.h;
            tx = (elementWidth - this.globalData.compSize.w * (elementHeight / this.globalData.compSize.h)) / 2;
            ty = 0;
        }
        var style = this.resizerElem.style;
        style.webkitTransform = "matrix3d(" + sx + ",0,0,0,0," + sy + ",0,0,0,0,1,0," + tx + "," + ty + ",0,1)";
        style.transform = style.webkitTransform;
    };
    HybridRendererBase.prototype.renderFrame = SVGRenderer.prototype.renderFrame;
    HybridRendererBase.prototype.hide = function() {
        this.resizerElem.style.display = "none";
    };
    HybridRendererBase.prototype.show = function() {
        this.resizerElem.style.display = "block";
    };
    HybridRendererBase.prototype.initItems = function() {
        this.buildAllItems();
        if (this.camera) this.camera.setup();
        else {
            var cWidth = this.globalData.compSize.w;
            var cHeight = this.globalData.compSize.h;
            var i;
            var len = this.threeDElements.length;
            for(i = 0; i < len; i += 1){
                var style = this.threeDElements[i].perspectiveElem.style;
                style.webkitPerspective = Math.sqrt(Math.pow(cWidth, 2) + Math.pow(cHeight, 2)) + "px";
                style.perspective = style.webkitPerspective;
            }
        }
    };
    HybridRendererBase.prototype.searchExtraCompositions = function(assets) {
        var i;
        var len = assets.length;
        var floatingContainer = createTag("div");
        for(i = 0; i < len; i += 1)if (assets[i].xt) {
            var comp = this.createComp(assets[i], floatingContainer, this.globalData.comp, null);
            comp.initExpressions();
            this.globalData.projectInterface.registerComposition(comp);
        }
    };
    function HCompElement(data, globalData, comp) {
        this.layers = data.layers;
        this.supports3d = !data.hasMask;
        this.completeLayers = false;
        this.pendingElements = [];
        this.elements = this.layers ? createSizedArray(this.layers.length) : [];
        this.initElement(data, globalData, comp);
        this.tm = data.tm ? PropertyFactory.getProp(this, data.tm, 0, globalData.frameRate, this) : {
            _placeholder: true
        };
    }
    extendPrototype([
        HybridRendererBase,
        ICompElement,
        HBaseElement
    ], HCompElement);
    HCompElement.prototype._createBaseContainerElements = HCompElement.prototype.createContainerElements;
    HCompElement.prototype.createContainerElements = function() {
        this._createBaseContainerElements(); // divElement.style.clip = 'rect(0px, '+this.data.w+'px, '+this.data.h+'px, 0px)';
        if (this.data.hasMask) {
            this.svgElement.setAttribute("width", this.data.w);
            this.svgElement.setAttribute("height", this.data.h);
            this.transformedElement = this.baseElement;
        } else this.transformedElement = this.layerElement;
    };
    HCompElement.prototype.addTo3dContainer = function(elem, pos) {
        var j = 0;
        var nextElement;
        while(j < pos){
            if (this.elements[j] && this.elements[j].getBaseElement) nextElement = this.elements[j].getBaseElement();
            j += 1;
        }
        if (nextElement) this.layerElement.insertBefore(elem, nextElement);
        else this.layerElement.appendChild(elem);
    };
    HCompElement.prototype.createComp = function(data) {
        if (!this.supports3d) return new SVGCompElement(data, this.globalData, this);
        return new HCompElement(data, this.globalData, this);
    };
    function HybridRenderer(animationItem, config) {
        this.animationItem = animationItem;
        this.layers = null;
        this.renderedFrame = -1;
        this.renderConfig = {
            className: config && config.className || "",
            imagePreserveAspectRatio: config && config.imagePreserveAspectRatio || "xMidYMid slice",
            hideOnTransparent: !(config && config.hideOnTransparent === false),
            filterSize: {
                width: config && config.filterSize && config.filterSize.width || "400%",
                height: config && config.filterSize && config.filterSize.height || "400%",
                x: config && config.filterSize && config.filterSize.x || "-100%",
                y: config && config.filterSize && config.filterSize.y || "-100%"
            },
            runExpressions: !config || config.runExpressions === undefined || config.runExpressions
        };
        this.globalData = {
            _mdf: false,
            frameNum: -1,
            renderConfig: this.renderConfig
        };
        this.pendingElements = [];
        this.elements = [];
        this.threeDElements = [];
        this.destroyed = false;
        this.camera = null;
        this.supports3d = true;
        this.rendererType = "html";
    }
    extendPrototype([
        HybridRendererBase
    ], HybridRenderer);
    HybridRenderer.prototype.createComp = function(data) {
        if (!this.supports3d) return new SVGCompElement(data, this.globalData, this);
        return new HCompElement(data, this.globalData, this);
    };
    var CompExpressionInterface = function() {
        return function(comp) {
            function _thisLayerFunction(name) {
                var i = 0;
                var len = comp.layers.length;
                while(i < len){
                    if (comp.layers[i].nm === name || comp.layers[i].ind === name) return comp.elements[i].layerInterface;
                    i += 1;
                }
                return null; // return {active:false};
            }
            Object.defineProperty(_thisLayerFunction, "_name", {
                value: comp.data.nm
            });
            _thisLayerFunction.layer = _thisLayerFunction;
            _thisLayerFunction.pixelAspect = 1;
            _thisLayerFunction.height = comp.data.h || comp.globalData.compSize.h;
            _thisLayerFunction.width = comp.data.w || comp.globalData.compSize.w;
            _thisLayerFunction.pixelAspect = 1;
            _thisLayerFunction.frameDuration = 1 / comp.globalData.frameRate;
            _thisLayerFunction.displayStartTime = 0;
            _thisLayerFunction.numLayers = comp.layers.length;
            return _thisLayerFunction;
        };
    }();
    function _typeof$2(obj) {
        "@babel/helpers - typeof";
        if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof$2 = function _typeof(obj) {
            return typeof obj;
        };
        else _typeof$2 = function _typeof(obj) {
            return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        };
        return _typeof$2(obj);
    }
    /* eslint-disable */ /*
   Copyright 2014 David Bau.

   Permission is hereby granted, free of charge, to any person obtaining
   a copy of this software and associated documentation files (the
   "Software"), to deal in the Software without restriction, including
   without limitation the rights to use, copy, modify, merge, publish,
   distribute, sublicense, and/or sell copies of the Software, and to
   permit persons to whom the Software is furnished to do so, subject to
   the following conditions:

   The above copyright notice and this permission notice shall be
   included in all copies or substantial portions of the Software.

   THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
   EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
   MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
   IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
   CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
   TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
   SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

   */ function seedRandom(pool, math) {
        //
        // The following constants are related to IEEE 754 limits.
        //
        var global = this, width = 256, // each RC4 output is 0 <= x < 256
        chunks = 6, // at least six RC4 outputs for each double
        digits = 52, // there are 52 significant digits in a double
        rngname = "random", // rngname: name for Math.random and Math.seedrandom
        startdenom = math.pow(width, chunks), significance = math.pow(2, digits), overflow = significance * 2, mask = width - 1, nodecrypto; // node.js crypto module, initialized at the bottom.
        //
        // seedrandom()
        // This is the seedrandom function described above.
        //
        function seedrandom(seed, options, callback) {
            var key = [];
            options = options === true ? {
                entropy: true
            } : options || {}; // Flatten the seed string or build one from local entropy if needed.
            var shortseed = mixkey(flatten(options.entropy ? [
                seed,
                tostring(pool)
            ] : seed === null ? autoseed() : seed, 3), key); // Use the seed to initialize an ARC4 generator.
            var arc4 = new ARC4(key); // This function returns a random double in [0, 1) that contains
            // randomness in every bit of the mantissa of the IEEE 754 value.
            var prng = function prng() {
                var n = arc4.g(chunks), // Start with a numerator n < 2 ^ 48
                d = startdenom, //   and denominator d = 2 ^ 48.
                x = 0; //   and no 'extra last byte'.
                while(n < significance){
                    // Fill up all significant digits by
                    n = (n + x) * width; //   shifting numerator and
                    d *= width; //   denominator and generating a
                    x = arc4.g(1); //   new least-significant-byte.
                }
                while(n >= overflow){
                    // To avoid rounding up, before adding
                    n /= 2; //   last byte, shift everything
                    d /= 2; //   right using integer math until
                    x >>>= 1; //   we have exactly the desired bits.
                }
                return (n + x) / d; // Form the number within [0, 1).
            };
            prng.int32 = function() {
                return arc4.g(4) | 0;
            };
            prng.quick = function() {
                return arc4.g(4) / 0x100000000;
            };
            prng["double"] = prng; // Mix the randomness into accumulated entropy.
            mixkey(tostring(arc4.S), pool); // Calling convention: what to return as a function of prng, seed, is_math.
            return (options.pass || callback || function(prng, seed, is_math_call, state) {
                if (state) {
                    // Load the arc4 state from the given state if it has an S array.
                    if (state.S) copy(state, arc4);
                     // Only provide the .state method if requested via options.state.
                    prng.state = function() {
                        return copy(arc4, {});
                    };
                } // If called as a method of Math (Math.seedrandom()), mutate
                // Math.random because that is how seedrandom.js has worked since v1.0.
                if (is_math_call) {
                    math[rngname] = prng;
                    return seed;
                } else return prng;
            })(prng, shortseed, "global" in options ? options.global : this == math, options.state);
        }
        math["seed" + rngname] = seedrandom; //
        // ARC4
        //
        // An ARC4 implementation.  The constructor takes a key in the form of
        // an array of at most (width) integers that should be 0 <= x < (width).
        //
        // The g(count) method returns a pseudorandom integer that concatenates
        // the next (count) outputs from ARC4.  Its return value is a number x
        // that is in the range 0 <= x < (width ^ count).
        //
        function ARC4(key) {
            var t, keylen = key.length, me = this, i = 0, j = me.i = me.j = 0, s = me.S = []; // The empty key [] is treated as [0].
            if (!keylen) key = [
                keylen++
            ];
             // Set up S using the standard key scheduling algorithm.
            while(i < width)s[i] = i++;
            for(i = 0; i < width; i++){
                s[i] = s[j = mask & j + key[i % keylen] + (t = s[i])];
                s[j] = t;
            } // The "g" method returns the next (count) outputs as one number.
            me.g = function(count) {
                // Using instance members instead of closure state nearly doubles speed.
                var t, r = 0, i = me.i, j = me.j, s = me.S;
                while(count--){
                    t = s[i = mask & i + 1];
                    r = r * width + s[mask & (s[i] = s[j = mask & j + t]) + (s[j] = t)];
                }
                me.i = i;
                me.j = j;
                return r; // For robust unpredictability, the function call below automatically
            // discards an initial batch of values.  This is called RC4-drop[256].
            // See http://google.com/search?q=rsa+fluhrer+response&btnI
            };
        } //
        // copy()
        // Copies internal state of ARC4 to or from a plain object.
        //
        function copy(f, t) {
            t.i = f.i;
            t.j = f.j;
            t.S = f.S.slice();
            return t;
        } //
        // flatten()
        // Converts an object tree to nested arrays of strings.
        //
        function flatten(obj, depth) {
            var result = [], typ = _typeof$2(obj), prop;
            if (depth && typ == "object") {
                for(prop in obj)try {
                    result.push(flatten(obj[prop], depth - 1));
                } catch (e) {}
            }
            return result.length ? result : typ == "string" ? obj : obj + "\0";
        } //
        // mixkey()
        // Mixes a string seed into a key that is an array of integers, and
        // returns a shortened string seed that is equivalent to the result key.
        //
        function mixkey(seed, key) {
            var stringseed = seed + "", smear, j = 0;
            while(j < stringseed.length)key[mask & j] = mask & (smear ^= key[mask & j] * 19) + stringseed.charCodeAt(j++);
            return tostring(key);
        } //
        // autoseed()
        // Returns an object for autoseeding, using window.crypto and Node crypto
        // module if available.
        //
        function autoseed() {
            try {
                if (nodecrypto) return tostring(nodecrypto.randomBytes(width));
                var out = new Uint8Array(width);
                (global.crypto || global.msCrypto).getRandomValues(out);
                return tostring(out);
            } catch (e) {
                var browser = global.navigator, plugins = browser && browser.plugins;
                return [
                    +new Date(),
                    global,
                    plugins,
                    global.screen,
                    tostring(pool)
                ];
            }
        } //
        // tostring()
        // Converts an array of charcodes to a string
        //
        function tostring(a) {
            return String.fromCharCode.apply(0, a);
        } //
        // When seedrandom.js is loaded, we immediately mix a few bits
        // from the built-in RNG into the entropy pool.  Because we do
        // not want to interfere with deterministic PRNG state later,
        // seedrandom will not call math.random on its own again after
        // initialization.
        //
        mixkey(math.random(), pool); //
    // Nodejs and AMD support: export the implementation as a module using
    // either convention.
    //
    // End anonymous scope, and pass initial values.
    }
    function initialize$2(BMMath) {
        seedRandom([], BMMath);
    }
    var propTypes = {
        SHAPE: "shape"
    };
    function _typeof$1(obj) {
        "@babel/helpers - typeof";
        if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof$1 = function _typeof(obj) {
            return typeof obj;
        };
        else _typeof$1 = function _typeof(obj) {
            return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        };
        return _typeof$1(obj);
    }
    var ExpressionManager = function() {
        "use strict";
        var ob = {};
        var Math1 = BMMath;
        var window1 = null;
        var document1 = null;
        var XMLHttpRequest1 = null;
        var fetch = null;
        var frames = null;
        var _lottieGlobal = {};
        initialize$2(BMMath);
        function resetFrame() {
            _lottieGlobal = {};
        }
        function $bm_isInstanceOfArray(arr) {
            return arr.constructor === Array || arr.constructor === Float32Array;
        }
        function isNumerable(tOfV, v) {
            return tOfV === "number" || v instanceof Number || tOfV === "boolean" || tOfV === "string";
        }
        function $bm_neg(a) {
            var tOfA = _typeof$1(a);
            if (tOfA === "number" || a instanceof Number || tOfA === "boolean") return -a;
            if ($bm_isInstanceOfArray(a)) {
                var i;
                var lenA = a.length;
                var retArr = [];
                for(i = 0; i < lenA; i += 1)retArr[i] = -a[i];
                return retArr;
            }
            if (a.propType) return a.v;
            return -a;
        }
        var easeInBez = BezierFactory.getBezierEasing(0.333, 0, 0.833, 0.833, "easeIn").get;
        var easeOutBez = BezierFactory.getBezierEasing(0.167, 0.167, 0.667, 1, "easeOut").get;
        var easeInOutBez = BezierFactory.getBezierEasing(0.33, 0, 0.667, 1, "easeInOut").get;
        function sum(a, b) {
            var tOfA = _typeof$1(a);
            var tOfB = _typeof$1(b);
            if (isNumerable(tOfA, a) && isNumerable(tOfB, b) || tOfA === "string" || tOfB === "string") return a + b;
            if ($bm_isInstanceOfArray(a) && isNumerable(tOfB, b)) {
                a = a.slice(0);
                a[0] += b;
                return a;
            }
            if (isNumerable(tOfA, a) && $bm_isInstanceOfArray(b)) {
                b = b.slice(0);
                b[0] = a + b[0];
                return b;
            }
            if ($bm_isInstanceOfArray(a) && $bm_isInstanceOfArray(b)) {
                var i = 0;
                var lenA = a.length;
                var lenB = b.length;
                var retArr = [];
                while(i < lenA || i < lenB){
                    if ((typeof a[i] === "number" || a[i] instanceof Number) && (typeof b[i] === "number" || b[i] instanceof Number)) retArr[i] = a[i] + b[i];
                    else retArr[i] = b[i] === undefined ? a[i] : a[i] || b[i];
                    i += 1;
                }
                return retArr;
            }
            return 0;
        }
        var add = sum;
        function sub(a, b) {
            var tOfA = _typeof$1(a);
            var tOfB = _typeof$1(b);
            if (isNumerable(tOfA, a) && isNumerable(tOfB, b)) {
                if (tOfA === "string") a = parseInt(a, 10);
                if (tOfB === "string") b = parseInt(b, 10);
                return a - b;
            }
            if ($bm_isInstanceOfArray(a) && isNumerable(tOfB, b)) {
                a = a.slice(0);
                a[0] -= b;
                return a;
            }
            if (isNumerable(tOfA, a) && $bm_isInstanceOfArray(b)) {
                b = b.slice(0);
                b[0] = a - b[0];
                return b;
            }
            if ($bm_isInstanceOfArray(a) && $bm_isInstanceOfArray(b)) {
                var i = 0;
                var lenA = a.length;
                var lenB = b.length;
                var retArr = [];
                while(i < lenA || i < lenB){
                    if ((typeof a[i] === "number" || a[i] instanceof Number) && (typeof b[i] === "number" || b[i] instanceof Number)) retArr[i] = a[i] - b[i];
                    else retArr[i] = b[i] === undefined ? a[i] : a[i] || b[i];
                    i += 1;
                }
                return retArr;
            }
            return 0;
        }
        function mul(a, b) {
            var tOfA = _typeof$1(a);
            var tOfB = _typeof$1(b);
            var arr;
            if (isNumerable(tOfA, a) && isNumerable(tOfB, b)) return a * b;
            var i;
            var len;
            if ($bm_isInstanceOfArray(a) && isNumerable(tOfB, b)) {
                len = a.length;
                arr = createTypedArray("float32", len);
                for(i = 0; i < len; i += 1)arr[i] = a[i] * b;
                return arr;
            }
            if (isNumerable(tOfA, a) && $bm_isInstanceOfArray(b)) {
                len = b.length;
                arr = createTypedArray("float32", len);
                for(i = 0; i < len; i += 1)arr[i] = a * b[i];
                return arr;
            }
            return 0;
        }
        function div(a, b) {
            var tOfA = _typeof$1(a);
            var tOfB = _typeof$1(b);
            var arr;
            if (isNumerable(tOfA, a) && isNumerable(tOfB, b)) return a / b;
            var i;
            var len;
            if ($bm_isInstanceOfArray(a) && isNumerable(tOfB, b)) {
                len = a.length;
                arr = createTypedArray("float32", len);
                for(i = 0; i < len; i += 1)arr[i] = a[i] / b;
                return arr;
            }
            if (isNumerable(tOfA, a) && $bm_isInstanceOfArray(b)) {
                len = b.length;
                arr = createTypedArray("float32", len);
                for(i = 0; i < len; i += 1)arr[i] = a / b[i];
                return arr;
            }
            return 0;
        }
        function mod(a, b) {
            if (typeof a === "string") a = parseInt(a, 10);
            if (typeof b === "string") b = parseInt(b, 10);
            return a % b;
        }
        var $bm_sum = sum;
        var $bm_sub = sub;
        var $bm_mul = mul;
        var $bm_div = div;
        var $bm_mod = mod;
        function clamp(num, min, max) {
            if (min > max) {
                var mm = max;
                max = min;
                min = mm;
            }
            return Math1.min(Math1.max(num, min), max);
        }
        function radiansToDegrees(val) {
            return val / degToRads;
        }
        var radians_to_degrees = radiansToDegrees;
        function degreesToRadians(val) {
            return val * degToRads;
        }
        var degrees_to_radians = radiansToDegrees;
        var helperLengthArray = [
            0,
            0,
            0,
            0,
            0,
            0
        ];
        function length(arr1, arr2) {
            if (typeof arr1 === "number" || arr1 instanceof Number) {
                arr2 = arr2 || 0;
                return Math1.abs(arr1 - arr2);
            }
            if (!arr2) arr2 = helperLengthArray;
            var i;
            var len = Math1.min(arr1.length, arr2.length);
            var addedLength = 0;
            for(i = 0; i < len; i += 1)addedLength += Math1.pow(arr2[i] - arr1[i], 2);
            return Math1.sqrt(addedLength);
        }
        function normalize(vec) {
            return div(vec, length(vec));
        }
        function rgbToHsl(val) {
            var r = val[0];
            var g = val[1];
            var b = val[2];
            var max = Math1.max(r, g, b);
            var min = Math1.min(r, g, b);
            var h;
            var s;
            var l = (max + min) / 2;
            if (max === min) {
                h = 0; // achromatic
                s = 0; // achromatic
            } else {
                var d = max - min;
                s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
                switch(max){
                    case r:
                        h = (g - b) / d + (g < b ? 6 : 0);
                        break;
                    case g:
                        h = (b - r) / d + 2;
                        break;
                    case b:
                        h = (r - g) / d + 4;
                        break;
                    default:
                        break;
                }
                h /= 6;
            }
            return [
                h,
                s,
                l,
                val[3]
            ];
        }
        function hue2rgb(p, q, t) {
            if (t < 0) t += 1;
            if (t > 1) t -= 1;
            if (t < 1 / 6) return p + (q - p) * 6 * t;
            if (t < 0.5) return q;
            if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
            return p;
        }
        function hslToRgb(val) {
            var h = val[0];
            var s = val[1];
            var l = val[2];
            var r;
            var g;
            var b;
            if (s === 0) {
                r = l; // achromatic
                b = l; // achromatic
                g = l; // achromatic
            } else {
                var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
                var p = 2 * l - q;
                r = hue2rgb(p, q, h + 1 / 3);
                g = hue2rgb(p, q, h);
                b = hue2rgb(p, q, h - 1 / 3);
            }
            return [
                r,
                g,
                b,
                val[3]
            ];
        }
        function linear(t, tMin, tMax, value1, value2) {
            if (value1 === undefined || value2 === undefined) {
                value1 = tMin;
                value2 = tMax;
                tMin = 0;
                tMax = 1;
            }
            if (tMax < tMin) {
                var _tMin = tMax;
                tMax = tMin;
                tMin = _tMin;
            }
            if (t <= tMin) return value1;
            if (t >= tMax) return value2;
            var perc = tMax === tMin ? 0 : (t - tMin) / (tMax - tMin);
            if (!value1.length) return value1 + (value2 - value1) * perc;
            var i;
            var len = value1.length;
            var arr = createTypedArray("float32", len);
            for(i = 0; i < len; i += 1)arr[i] = value1[i] + (value2[i] - value1[i]) * perc;
            return arr;
        }
        function random(min, max) {
            if (max === undefined) {
                if (min === undefined) {
                    min = 0;
                    max = 1;
                } else {
                    max = min;
                    min = undefined;
                }
            }
            if (max.length) {
                var i;
                var len = max.length;
                if (!min) min = createTypedArray("float32", len);
                var arr = createTypedArray("float32", len);
                var rnd = BMMath.random();
                for(i = 0; i < len; i += 1)arr[i] = min[i] + rnd * (max[i] - min[i]);
                return arr;
            }
            if (min === undefined) min = 0;
            var rndm = BMMath.random();
            return min + rndm * (max - min);
        }
        function createPath(points, inTangents, outTangents, closed) {
            var i;
            var len = points.length;
            var path = shapePool.newElement();
            path.setPathData(!!closed, len);
            var arrPlaceholder = [
                0,
                0
            ];
            var inVertexPoint;
            var outVertexPoint;
            for(i = 0; i < len; i += 1){
                inVertexPoint = inTangents && inTangents[i] ? inTangents[i] : arrPlaceholder;
                outVertexPoint = outTangents && outTangents[i] ? outTangents[i] : arrPlaceholder;
                path.setTripleAt(points[i][0], points[i][1], outVertexPoint[0] + points[i][0], outVertexPoint[1] + points[i][1], inVertexPoint[0] + points[i][0], inVertexPoint[1] + points[i][1], i, true);
            }
            return path;
        }
        function initiateExpression(elem, data, property) {
            // Bail out if we don't want expressions
            function noOp(_value) {
                return _value;
            }
            if (!elem.globalData.renderConfig.runExpressions) return noOp;
            var val = data.x;
            var needsVelocity = /velocity(?![\w\d])/.test(val);
            var _needsRandom = val.indexOf("random") !== -1;
            var elemType = elem.data.ty;
            var transform;
            var $bm_transform;
            var content;
            var effect;
            var thisProperty = property;
            thisProperty.valueAtTime = thisProperty.getValueAtTime;
            Object.defineProperty(thisProperty, "value", {
                get: function get() {
                    return thisProperty.v;
                }
            });
            elem.comp.frameDuration = 1 / elem.comp.globalData.frameRate;
            elem.comp.displayStartTime = 0;
            var inPoint = elem.data.ip / elem.comp.globalData.frameRate;
            var outPoint = elem.data.op / elem.comp.globalData.frameRate;
            var width = elem.data.sw ? elem.data.sw : 0;
            var height = elem.data.sh ? elem.data.sh : 0;
            var name = elem.data.nm;
            var loopIn;
            var loop_in;
            var loopOut;
            var loop_out;
            var smooth;
            var toWorld;
            var fromWorld;
            var fromComp;
            var toComp;
            var fromCompToSurface;
            var position;
            var rotation;
            var anchorPoint;
            var scale;
            var thisLayer;
            var thisComp;
            var mask;
            var valueAtTime;
            var velocityAtTime;
            var scoped_bm_rt; // val = val.replace(/(\\?"|')((http)(s)?(:\/))?\/.*?(\\?"|')/g, "\"\""); // deter potential network calls
            var expression_function = eval("[function _expression_function(){" + val + ";scoped_bm_rt=$bm_rt}]")[0]; // eslint-disable-line no-eval
            var numKeys = property.kf ? data.k.length : 0;
            var active = !this.data || this.data.hd !== true;
            var wiggle = (function wiggle(freq, amp) {
                var iWiggle;
                var j;
                var lenWiggle = this.pv.length ? this.pv.length : 1;
                var addedAmps = createTypedArray("float32", lenWiggle);
                freq = 5;
                var iterations = Math1.floor(time * freq);
                iWiggle = 0;
                j = 0;
                while(iWiggle < iterations){
                    // var rnd = BMMath.random();
                    for(j = 0; j < lenWiggle; j += 1)addedAmps[j] += -amp + amp * 2 * BMMath.random(); // addedAmps[j] += -amp + amp*2*rnd;
                    iWiggle += 1;
                } // var rnd2 = BMMath.random();
                var periods = time * freq;
                var perc = periods - Math1.floor(periods);
                var arr = createTypedArray("float32", lenWiggle);
                if (lenWiggle > 1) {
                    for(j = 0; j < lenWiggle; j += 1)arr[j] = this.pv[j] + addedAmps[j] + (-amp + amp * 2 * BMMath.random()) * perc; // arr[j] = this.pv[j] + addedAmps[j] + (-amp + amp*2*rnd)*perc;
                    return arr;
                }
                return this.pv + addedAmps[0] + (-amp + amp * 2 * BMMath.random()) * perc;
            }).bind(this);
            if (thisProperty.loopIn) {
                loopIn = thisProperty.loopIn.bind(thisProperty);
                loop_in = loopIn;
            }
            if (thisProperty.loopOut) {
                loopOut = thisProperty.loopOut.bind(thisProperty);
                loop_out = loopOut;
            }
            if (thisProperty.smooth) smooth = thisProperty.smooth.bind(thisProperty);
            function loopInDuration(type, duration) {
                return loopIn(type, duration, true);
            }
            function loopOutDuration(type, duration) {
                return loopOut(type, duration, true);
            }
            if (this.getValueAtTime) valueAtTime = this.getValueAtTime.bind(this);
            if (this.getVelocityAtTime) velocityAtTime = this.getVelocityAtTime.bind(this);
            var comp = elem.comp.globalData.projectInterface.bind(elem.comp.globalData.projectInterface);
            function lookAt(elem1, elem2) {
                var fVec = [
                    elem2[0] - elem1[0],
                    elem2[1] - elem1[1],
                    elem2[2] - elem1[2]
                ];
                var pitch = Math1.atan2(fVec[0], Math1.sqrt(fVec[1] * fVec[1] + fVec[2] * fVec[2])) / degToRads;
                var yaw = -Math1.atan2(fVec[1], fVec[2]) / degToRads;
                return [
                    yaw,
                    pitch,
                    0
                ];
            }
            function easeOut(t, tMin, tMax, val1, val2) {
                return applyEase(easeOutBez, t, tMin, tMax, val1, val2);
            }
            function easeIn(t, tMin, tMax, val1, val2) {
                return applyEase(easeInBez, t, tMin, tMax, val1, val2);
            }
            function ease(t, tMin, tMax, val1, val2) {
                return applyEase(easeInOutBez, t, tMin, tMax, val1, val2);
            }
            function applyEase(fn, t, tMin, tMax, val1, val2) {
                if (val1 === undefined) {
                    val1 = tMin;
                    val2 = tMax;
                } else t = (t - tMin) / (tMax - tMin);
                if (t > 1) t = 1;
                else if (t < 0) t = 0;
                var mult = fn(t);
                if ($bm_isInstanceOfArray(val1)) {
                    var iKey;
                    var lenKey = val1.length;
                    var arr = createTypedArray("float32", lenKey);
                    for(iKey = 0; iKey < lenKey; iKey += 1)arr[iKey] = (val2[iKey] - val1[iKey]) * mult + val1[iKey];
                    return arr;
                }
                return (val2 - val1) * mult + val1;
            }
            function nearestKey(time) {
                var iKey;
                var lenKey = data.k.length;
                var index;
                var keyTime;
                if (!data.k.length || typeof data.k[0] === "number") {
                    index = 0;
                    keyTime = 0;
                } else {
                    index = -1;
                    time *= elem.comp.globalData.frameRate;
                    if (time < data.k[0].t) {
                        index = 1;
                        keyTime = data.k[0].t;
                    } else {
                        for(iKey = 0; iKey < lenKey - 1; iKey += 1){
                            if (time === data.k[iKey].t) {
                                index = iKey + 1;
                                keyTime = data.k[iKey].t;
                                break;
                            } else if (time > data.k[iKey].t && time < data.k[iKey + 1].t) {
                                if (time - data.k[iKey].t > data.k[iKey + 1].t - time) {
                                    index = iKey + 2;
                                    keyTime = data.k[iKey + 1].t;
                                } else {
                                    index = iKey + 1;
                                    keyTime = data.k[iKey].t;
                                }
                                break;
                            }
                        }
                        if (index === -1) {
                            index = iKey + 1;
                            keyTime = data.k[iKey].t;
                        }
                    }
                }
                var obKey = {};
                obKey.index = index;
                obKey.time = keyTime / elem.comp.globalData.frameRate;
                return obKey;
            }
            function key(ind) {
                var obKey;
                var iKey;
                var lenKey;
                if (!data.k.length || typeof data.k[0] === "number") throw new Error("The property has no keyframe at index " + ind);
                ind -= 1;
                obKey = {
                    time: data.k[ind].t / elem.comp.globalData.frameRate,
                    value: []
                };
                var arr = Object.prototype.hasOwnProperty.call(data.k[ind], "s") ? data.k[ind].s : data.k[ind - 1].e;
                lenKey = arr.length;
                for(iKey = 0; iKey < lenKey; iKey += 1){
                    obKey[iKey] = arr[iKey];
                    obKey.value[iKey] = arr[iKey];
                }
                return obKey;
            }
            function framesToTime(fr, fps) {
                if (!fps) fps = elem.comp.globalData.frameRate;
                return fr / fps;
            }
            function timeToFrames(t, fps) {
                if (!t && t !== 0) t = time;
                if (!fps) fps = elem.comp.globalData.frameRate;
                return t * fps;
            }
            function seedRandom(seed) {
                BMMath.seedrandom(randSeed + seed);
            }
            function sourceRectAtTime() {
                return elem.sourceRectAtTime();
            }
            function substring(init, end) {
                if (typeof value === "string") {
                    if (end === undefined) return value.substring(init);
                    return value.substring(init, end);
                }
                return "";
            }
            function substr(init, end) {
                if (typeof value === "string") {
                    if (end === undefined) return value.substr(init);
                    return value.substr(init, end);
                }
                return "";
            }
            function posterizeTime(framesPerSecond) {
                time = framesPerSecond === 0 ? 0 : Math1.floor(time * framesPerSecond) / framesPerSecond;
                value = valueAtTime(time);
            }
            var time;
            var velocity;
            var value;
            var text;
            var textIndex;
            var textTotal;
            var selectorValue;
            var index = elem.data.ind;
            var hasParent = !!(elem.hierarchy && elem.hierarchy.length);
            var parent;
            var randSeed = Math1.floor(Math1.random() * 1000000);
            var globalData = elem.globalData;
            function executeExpression(_value) {
                // globalData.pushExpression();
                value = _value;
                if (this.frameExpressionId === elem.globalData.frameId && this.propType !== "textSelector") return value;
                if (this.propType === "textSelector") {
                    textIndex = this.textIndex;
                    textTotal = this.textTotal;
                    selectorValue = this.selectorValue;
                }
                if (!thisLayer) {
                    text = elem.layerInterface.text;
                    thisLayer = elem.layerInterface;
                    thisComp = elem.comp.compInterface;
                    toWorld = thisLayer.toWorld.bind(thisLayer);
                    fromWorld = thisLayer.fromWorld.bind(thisLayer);
                    fromComp = thisLayer.fromComp.bind(thisLayer);
                    toComp = thisLayer.toComp.bind(thisLayer);
                    mask = thisLayer.mask ? thisLayer.mask.bind(thisLayer) : null;
                    fromCompToSurface = fromComp;
                }
                if (!transform) {
                    transform = elem.layerInterface("ADBE Transform Group");
                    $bm_transform = transform;
                    if (transform) anchorPoint = transform.anchorPoint;
                }
                if (elemType === 4 && !content) content = thisLayer("ADBE Root Vectors Group");
                if (!effect) effect = thisLayer(4);
                hasParent = !!(elem.hierarchy && elem.hierarchy.length);
                if (hasParent && !parent) parent = elem.hierarchy[0].layerInterface;
                time = this.comp.renderedFrame / this.comp.globalData.frameRate;
                if (_needsRandom) seedRandom(randSeed + time);
                if (needsVelocity) velocity = velocityAtTime(time);
                expression_function();
                this.frameExpressionId = elem.globalData.frameId; // TODO: Check if it's possible to return on ShapeInterface the .v value
                // Changed this to a ternary operation because Rollup failed compiling it correctly
                scoped_bm_rt = scoped_bm_rt.propType === propTypes.SHAPE ? scoped_bm_rt.v : scoped_bm_rt;
                return scoped_bm_rt;
            } // Bundlers will see these as dead code and unless we reference them
            executeExpression.__preventDeadCodeRemoval = [
                $bm_transform,
                anchorPoint,
                time,
                velocity,
                inPoint,
                outPoint,
                width,
                height,
                name,
                loop_in,
                loop_out,
                smooth,
                toComp,
                fromCompToSurface,
                toWorld,
                fromWorld,
                mask,
                position,
                rotation,
                scale,
                thisComp,
                numKeys,
                active,
                wiggle,
                loopInDuration,
                loopOutDuration,
                comp,
                lookAt,
                easeOut,
                easeIn,
                ease,
                nearestKey,
                key,
                text,
                textIndex,
                textTotal,
                selectorValue,
                framesToTime,
                timeToFrames,
                sourceRectAtTime,
                substring,
                substr,
                posterizeTime,
                index,
                globalData
            ];
            return executeExpression;
        }
        ob.initiateExpression = initiateExpression;
        ob.__preventDeadCodeRemoval = [
            window1,
            document1,
            XMLHttpRequest1,
            fetch,
            frames,
            $bm_neg,
            add,
            $bm_sum,
            $bm_sub,
            $bm_mul,
            $bm_div,
            $bm_mod,
            clamp,
            radians_to_degrees,
            degreesToRadians,
            degrees_to_radians,
            normalize,
            rgbToHsl,
            hslToRgb,
            linear,
            random,
            createPath,
            _lottieGlobal
        ];
        ob.resetFrame = resetFrame;
        return ob;
    }();
    var Expressions = function() {
        var ob = {};
        ob.initExpressions = initExpressions;
        ob.resetFrame = ExpressionManager.resetFrame;
        function initExpressions(animation) {
            var stackCount = 0;
            var registers = [];
            function pushExpression() {
                stackCount += 1;
            }
            function popExpression() {
                stackCount -= 1;
                if (stackCount === 0) releaseInstances();
            }
            function registerExpressionProperty(expression) {
                if (registers.indexOf(expression) === -1) registers.push(expression);
            }
            function releaseInstances() {
                var i;
                var len = registers.length;
                for(i = 0; i < len; i += 1)registers[i].release();
                registers.length = 0;
            }
            animation.renderer.compInterface = CompExpressionInterface(animation.renderer);
            animation.renderer.globalData.projectInterface.registerComposition(animation.renderer);
            animation.renderer.globalData.pushExpression = pushExpression;
            animation.renderer.globalData.popExpression = popExpression;
            animation.renderer.globalData.registerExpressionProperty = registerExpressionProperty;
        }
        return ob;
    }();
    var MaskManagerInterface = function() {
        function MaskInterface(mask, data) {
            this._mask = mask;
            this._data = data;
        }
        Object.defineProperty(MaskInterface.prototype, "maskPath", {
            get: function get() {
                if (this._mask.prop.k) this._mask.prop.getValue();
                return this._mask.prop;
            }
        });
        Object.defineProperty(MaskInterface.prototype, "maskOpacity", {
            get: function get() {
                if (this._mask.op.k) this._mask.op.getValue();
                return this._mask.op.v * 100;
            }
        });
        var MaskManager = function MaskManager(maskManager) {
            var _masksInterfaces = createSizedArray(maskManager.viewData.length);
            var i;
            var len = maskManager.viewData.length;
            for(i = 0; i < len; i += 1)_masksInterfaces[i] = new MaskInterface(maskManager.viewData[i], maskManager.masksProperties[i]);
            var maskFunction = function maskFunction(name) {
                i = 0;
                while(i < len){
                    if (maskManager.masksProperties[i].nm === name) return _masksInterfaces[i];
                    i += 1;
                }
                return null;
            };
            return maskFunction;
        };
        return MaskManager;
    }();
    var ExpressionPropertyInterface = function() {
        var defaultUnidimensionalValue = {
            pv: 0,
            v: 0,
            mult: 1
        };
        var defaultMultidimensionalValue = {
            pv: [
                0,
                0,
                0
            ],
            v: [
                0,
                0,
                0
            ],
            mult: 1
        };
        function completeProperty(expressionValue, property, type) {
            Object.defineProperty(expressionValue, "velocity", {
                get: function get() {
                    return property.getVelocityAtTime(property.comp.currentFrame);
                }
            });
            expressionValue.numKeys = property.keyframes ? property.keyframes.length : 0;
            expressionValue.key = function(pos) {
                if (!expressionValue.numKeys) return 0;
                var value = "";
                if ("s" in property.keyframes[pos - 1]) value = property.keyframes[pos - 1].s;
                else if ("e" in property.keyframes[pos - 2]) value = property.keyframes[pos - 2].e;
                else value = property.keyframes[pos - 2].s;
                var valueProp = type === "unidimensional" ? new Number(value) : Object.assign({}, value); // eslint-disable-line no-new-wrappers
                valueProp.time = property.keyframes[pos - 1].t / property.elem.comp.globalData.frameRate;
                valueProp.value = type === "unidimensional" ? value[0] : value;
                return valueProp;
            };
            expressionValue.valueAtTime = property.getValueAtTime;
            expressionValue.speedAtTime = property.getSpeedAtTime;
            expressionValue.velocityAtTime = property.getVelocityAtTime;
            expressionValue.propertyGroup = property.propertyGroup;
        }
        function UnidimensionalPropertyInterface(property) {
            if (!property || !("pv" in property)) property = defaultUnidimensionalValue;
            var mult = 1 / property.mult;
            var val = property.pv * mult;
            var expressionValue = new Number(val); // eslint-disable-line no-new-wrappers
            expressionValue.value = val;
            completeProperty(expressionValue, property, "unidimensional");
            return function() {
                if (property.k) property.getValue();
                val = property.v * mult;
                if (expressionValue.value !== val) {
                    expressionValue = new Number(val); // eslint-disable-line no-new-wrappers
                    expressionValue.value = val;
                    completeProperty(expressionValue, property, "unidimensional");
                }
                return expressionValue;
            };
        }
        function MultidimensionalPropertyInterface(property) {
            if (!property || !("pv" in property)) property = defaultMultidimensionalValue;
            var mult = 1 / property.mult;
            var len = property.data && property.data.l || property.pv.length;
            var expressionValue = createTypedArray("float32", len);
            var arrValue = createTypedArray("float32", len);
            expressionValue.value = arrValue;
            completeProperty(expressionValue, property, "multidimensional");
            return function() {
                if (property.k) property.getValue();
                for(var i = 0; i < len; i += 1){
                    arrValue[i] = property.v[i] * mult;
                    expressionValue[i] = arrValue[i];
                }
                return expressionValue;
            };
        } // TODO: try to avoid using this getter
        function defaultGetter() {
            return defaultUnidimensionalValue;
        }
        return function(property) {
            if (!property) return defaultGetter;
            if (property.propType === "unidimensional") return UnidimensionalPropertyInterface(property);
            return MultidimensionalPropertyInterface(property);
        };
    }();
    var TransformExpressionInterface = function() {
        return function(transform) {
            function _thisFunction(name) {
                switch(name){
                    case "scale":
                    case "Scale":
                    case "ADBE Scale":
                    case 6:
                        return _thisFunction.scale;
                    case "rotation":
                    case "Rotation":
                    case "ADBE Rotation":
                    case "ADBE Rotate Z":
                    case 10:
                        return _thisFunction.rotation;
                    case "ADBE Rotate X":
                        return _thisFunction.xRotation;
                    case "ADBE Rotate Y":
                        return _thisFunction.yRotation;
                    case "position":
                    case "Position":
                    case "ADBE Position":
                    case 2:
                        return _thisFunction.position;
                    case "ADBE Position_0":
                        return _thisFunction.xPosition;
                    case "ADBE Position_1":
                        return _thisFunction.yPosition;
                    case "ADBE Position_2":
                        return _thisFunction.zPosition;
                    case "anchorPoint":
                    case "AnchorPoint":
                    case "Anchor Point":
                    case "ADBE AnchorPoint":
                    case 1:
                        return _thisFunction.anchorPoint;
                    case "opacity":
                    case "Opacity":
                    case 11:
                        return _thisFunction.opacity;
                    default:
                        return null;
                }
            }
            Object.defineProperty(_thisFunction, "rotation", {
                get: ExpressionPropertyInterface(transform.r || transform.rz)
            });
            Object.defineProperty(_thisFunction, "zRotation", {
                get: ExpressionPropertyInterface(transform.rz || transform.r)
            });
            Object.defineProperty(_thisFunction, "xRotation", {
                get: ExpressionPropertyInterface(transform.rx)
            });
            Object.defineProperty(_thisFunction, "yRotation", {
                get: ExpressionPropertyInterface(transform.ry)
            });
            Object.defineProperty(_thisFunction, "scale", {
                get: ExpressionPropertyInterface(transform.s)
            });
            var _px;
            var _py;
            var _pz;
            var _transformFactory;
            if (transform.p) _transformFactory = ExpressionPropertyInterface(transform.p);
            else {
                _px = ExpressionPropertyInterface(transform.px);
                _py = ExpressionPropertyInterface(transform.py);
                if (transform.pz) _pz = ExpressionPropertyInterface(transform.pz);
            }
            Object.defineProperty(_thisFunction, "position", {
                get: function get() {
                    if (transform.p) return _transformFactory();
                    return [
                        _px(),
                        _py(),
                        _pz ? _pz() : 0
                    ];
                }
            });
            Object.defineProperty(_thisFunction, "xPosition", {
                get: ExpressionPropertyInterface(transform.px)
            });
            Object.defineProperty(_thisFunction, "yPosition", {
                get: ExpressionPropertyInterface(transform.py)
            });
            Object.defineProperty(_thisFunction, "zPosition", {
                get: ExpressionPropertyInterface(transform.pz)
            });
            Object.defineProperty(_thisFunction, "anchorPoint", {
                get: ExpressionPropertyInterface(transform.a)
            });
            Object.defineProperty(_thisFunction, "opacity", {
                get: ExpressionPropertyInterface(transform.o)
            });
            Object.defineProperty(_thisFunction, "skew", {
                get: ExpressionPropertyInterface(transform.sk)
            });
            Object.defineProperty(_thisFunction, "skewAxis", {
                get: ExpressionPropertyInterface(transform.sa)
            });
            Object.defineProperty(_thisFunction, "orientation", {
                get: ExpressionPropertyInterface(transform.or)
            });
            return _thisFunction;
        };
    }();
    var LayerExpressionInterface = function() {
        function getMatrix(time) {
            var toWorldMat = new Matrix();
            if (time !== undefined) {
                var propMatrix = this._elem.finalTransform.mProp.getValueAtTime(time);
                propMatrix.clone(toWorldMat);
            } else {
                var transformMat = this._elem.finalTransform.mProp;
                transformMat.applyToMatrix(toWorldMat);
            }
            return toWorldMat;
        }
        function toWorldVec(arr, time) {
            var toWorldMat = this.getMatrix(time);
            toWorldMat.props[12] = 0;
            toWorldMat.props[13] = 0;
            toWorldMat.props[14] = 0;
            return this.applyPoint(toWorldMat, arr);
        }
        function toWorld(arr, time) {
            var toWorldMat = this.getMatrix(time);
            return this.applyPoint(toWorldMat, arr);
        }
        function fromWorldVec(arr, time) {
            var toWorldMat = this.getMatrix(time);
            toWorldMat.props[12] = 0;
            toWorldMat.props[13] = 0;
            toWorldMat.props[14] = 0;
            return this.invertPoint(toWorldMat, arr);
        }
        function fromWorld(arr, time) {
            var toWorldMat = this.getMatrix(time);
            return this.invertPoint(toWorldMat, arr);
        }
        function applyPoint(matrix, arr) {
            if (this._elem.hierarchy && this._elem.hierarchy.length) {
                var i;
                var len = this._elem.hierarchy.length;
                for(i = 0; i < len; i += 1)this._elem.hierarchy[i].finalTransform.mProp.applyToMatrix(matrix);
            }
            return matrix.applyToPointArray(arr[0], arr[1], arr[2] || 0);
        }
        function invertPoint(matrix, arr) {
            if (this._elem.hierarchy && this._elem.hierarchy.length) {
                var i;
                var len = this._elem.hierarchy.length;
                for(i = 0; i < len; i += 1)this._elem.hierarchy[i].finalTransform.mProp.applyToMatrix(matrix);
            }
            return matrix.inversePoint(arr);
        }
        function fromComp(arr) {
            var toWorldMat = new Matrix();
            toWorldMat.reset();
            this._elem.finalTransform.mProp.applyToMatrix(toWorldMat);
            if (this._elem.hierarchy && this._elem.hierarchy.length) {
                var i;
                var len = this._elem.hierarchy.length;
                for(i = 0; i < len; i += 1)this._elem.hierarchy[i].finalTransform.mProp.applyToMatrix(toWorldMat);
                return toWorldMat.inversePoint(arr);
            }
            return toWorldMat.inversePoint(arr);
        }
        function sampleImage() {
            return [
                1,
                1,
                1,
                1
            ];
        }
        return function(elem) {
            var transformInterface;
            function _registerMaskInterface(maskManager) {
                _thisLayerFunction.mask = new MaskManagerInterface(maskManager, elem);
            }
            function _registerEffectsInterface(effects) {
                _thisLayerFunction.effect = effects;
            }
            function _thisLayerFunction(name) {
                switch(name){
                    case "ADBE Root Vectors Group":
                    case "Contents":
                    case 2:
                        return _thisLayerFunction.shapeInterface;
                    case 1:
                    case 6:
                    case "Transform":
                    case "transform":
                    case "ADBE Transform Group":
                        return transformInterface;
                    case 4:
                    case "ADBE Effect Parade":
                    case "effects":
                    case "Effects":
                        return _thisLayerFunction.effect;
                    case "ADBE Text Properties":
                        return _thisLayerFunction.textInterface;
                    default:
                        return null;
                }
            }
            _thisLayerFunction.getMatrix = getMatrix;
            _thisLayerFunction.invertPoint = invertPoint;
            _thisLayerFunction.applyPoint = applyPoint;
            _thisLayerFunction.toWorld = toWorld;
            _thisLayerFunction.toWorldVec = toWorldVec;
            _thisLayerFunction.fromWorld = fromWorld;
            _thisLayerFunction.fromWorldVec = fromWorldVec;
            _thisLayerFunction.toComp = toWorld;
            _thisLayerFunction.fromComp = fromComp;
            _thisLayerFunction.sampleImage = sampleImage;
            _thisLayerFunction.sourceRectAtTime = elem.sourceRectAtTime.bind(elem);
            _thisLayerFunction._elem = elem;
            transformInterface = TransformExpressionInterface(elem.finalTransform.mProp);
            var anchorPointDescriptor = getDescriptor(transformInterface, "anchorPoint");
            Object.defineProperties(_thisLayerFunction, {
                hasParent: {
                    get: function get() {
                        return elem.hierarchy.length;
                    }
                },
                parent: {
                    get: function get() {
                        return elem.hierarchy[0].layerInterface;
                    }
                },
                rotation: getDescriptor(transformInterface, "rotation"),
                scale: getDescriptor(transformInterface, "scale"),
                position: getDescriptor(transformInterface, "position"),
                opacity: getDescriptor(transformInterface, "opacity"),
                anchorPoint: anchorPointDescriptor,
                anchor_point: anchorPointDescriptor,
                transform: {
                    get: function get() {
                        return transformInterface;
                    }
                },
                active: {
                    get: function get() {
                        return elem.isInRange;
                    }
                }
            });
            _thisLayerFunction.startTime = elem.data.st;
            _thisLayerFunction.index = elem.data.ind;
            _thisLayerFunction.source = elem.data.refId;
            _thisLayerFunction.height = elem.data.ty === 0 ? elem.data.h : 100;
            _thisLayerFunction.width = elem.data.ty === 0 ? elem.data.w : 100;
            _thisLayerFunction.inPoint = elem.data.ip / elem.comp.globalData.frameRate;
            _thisLayerFunction.outPoint = elem.data.op / elem.comp.globalData.frameRate;
            _thisLayerFunction._name = elem.data.nm;
            _thisLayerFunction.registerMaskInterface = _registerMaskInterface;
            _thisLayerFunction.registerEffectsInterface = _registerEffectsInterface;
            return _thisLayerFunction;
        };
    }();
    var propertyGroupFactory = function() {
        return function(interfaceFunction, parentPropertyGroup) {
            return function(val) {
                val = val === undefined ? 1 : val;
                if (val <= 0) return interfaceFunction;
                return parentPropertyGroup(val - 1);
            };
        };
    }();
    var PropertyInterface = function() {
        return function(propertyName, propertyGroup) {
            var interfaceFunction = {
                _name: propertyName
            };
            function _propertyGroup(val) {
                val = val === undefined ? 1 : val;
                if (val <= 0) return interfaceFunction;
                return propertyGroup(val - 1);
            }
            return _propertyGroup;
        };
    }();
    var EffectsExpressionInterface = function() {
        var ob = {
            createEffectsInterface: createEffectsInterface
        };
        function createEffectsInterface(elem, propertyGroup) {
            if (elem.effectsManager) {
                var effectElements = [];
                var effectsData = elem.data.ef;
                var i;
                var len = elem.effectsManager.effectElements.length;
                for(i = 0; i < len; i += 1)effectElements.push(createGroupInterface(effectsData[i], elem.effectsManager.effectElements[i], propertyGroup, elem));
                var effects = elem.data.ef || [];
                var groupInterface = function groupInterface(name) {
                    i = 0;
                    len = effects.length;
                    while(i < len){
                        if (name === effects[i].nm || name === effects[i].mn || name === effects[i].ix) return effectElements[i];
                        i += 1;
                    }
                    return null;
                };
                Object.defineProperty(groupInterface, "numProperties", {
                    get: function get() {
                        return effects.length;
                    }
                });
                return groupInterface;
            }
            return null;
        }
        function createGroupInterface(data, elements, propertyGroup, elem) {
            function groupInterface(name) {
                var effects = data.ef;
                var i = 0;
                var len = effects.length;
                while(i < len){
                    if (name === effects[i].nm || name === effects[i].mn || name === effects[i].ix) {
                        if (effects[i].ty === 5) return effectElements[i];
                        return effectElements[i]();
                    }
                    i += 1;
                }
                throw new Error();
            }
            var _propertyGroup = propertyGroupFactory(groupInterface, propertyGroup);
            var effectElements = [];
            var i;
            var len = data.ef.length;
            for(i = 0; i < len; i += 1)if (data.ef[i].ty === 5) effectElements.push(createGroupInterface(data.ef[i], elements.effectElements[i], elements.effectElements[i].propertyGroup, elem));
            else effectElements.push(createValueInterface(elements.effectElements[i], data.ef[i].ty, elem, _propertyGroup));
            if (data.mn === "ADBE Color Control") Object.defineProperty(groupInterface, "color", {
                get: function get() {
                    return effectElements[0]();
                }
            });
            Object.defineProperties(groupInterface, {
                numProperties: {
                    get: function get() {
                        return data.np;
                    }
                },
                _name: {
                    value: data.nm
                },
                propertyGroup: {
                    value: _propertyGroup
                }
            });
            groupInterface.enabled = data.en !== 0;
            groupInterface.active = groupInterface.enabled;
            return groupInterface;
        }
        function createValueInterface(element, type, elem, propertyGroup) {
            var expressionProperty = ExpressionPropertyInterface(element.p);
            function interfaceFunction() {
                if (type === 10) return elem.comp.compInterface(element.p.v);
                return expressionProperty();
            }
            if (element.p.setGroupProperty) element.p.setGroupProperty(PropertyInterface("", propertyGroup));
            return interfaceFunction;
        }
        return ob;
    }();
    var ShapePathInterface = function() {
        return function pathInterfaceFactory(shape, view, propertyGroup) {
            var prop = view.sh;
            function interfaceFunction(val) {
                if (val === "Shape" || val === "shape" || val === "Path" || val === "path" || val === "ADBE Vector Shape" || val === 2) return interfaceFunction.path;
                return null;
            }
            var _propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
            prop.setGroupProperty(PropertyInterface("Path", _propertyGroup));
            Object.defineProperties(interfaceFunction, {
                path: {
                    get: function get() {
                        if (prop.k) prop.getValue();
                        return prop;
                    }
                },
                shape: {
                    get: function get() {
                        if (prop.k) prop.getValue();
                        return prop;
                    }
                },
                _name: {
                    value: shape.nm
                },
                ix: {
                    value: shape.ix
                },
                propertyIndex: {
                    value: shape.ix
                },
                mn: {
                    value: shape.mn
                },
                propertyGroup: {
                    value: propertyGroup
                }
            });
            return interfaceFunction;
        };
    }();
    var ShapeExpressionInterface = function() {
        function iterateElements(shapes, view, propertyGroup) {
            var arr = [];
            var i;
            var len = shapes ? shapes.length : 0;
            for(i = 0; i < len; i += 1){
                if (shapes[i].ty === "gr") arr.push(groupInterfaceFactory(shapes[i], view[i], propertyGroup));
                else if (shapes[i].ty === "fl") arr.push(fillInterfaceFactory(shapes[i], view[i], propertyGroup));
                else if (shapes[i].ty === "st") arr.push(strokeInterfaceFactory(shapes[i], view[i], propertyGroup));
                else if (shapes[i].ty === "tm") arr.push(trimInterfaceFactory(shapes[i], view[i], propertyGroup));
                else if (shapes[i].ty === "tr") ;
                else if (shapes[i].ty === "el") arr.push(ellipseInterfaceFactory(shapes[i], view[i], propertyGroup));
                else if (shapes[i].ty === "sr") arr.push(starInterfaceFactory(shapes[i], view[i], propertyGroup));
                else if (shapes[i].ty === "sh") arr.push(ShapePathInterface(shapes[i], view[i], propertyGroup));
                else if (shapes[i].ty === "rc") arr.push(rectInterfaceFactory(shapes[i], view[i], propertyGroup));
                else if (shapes[i].ty === "rd") arr.push(roundedInterfaceFactory(shapes[i], view[i], propertyGroup));
                else if (shapes[i].ty === "rp") arr.push(repeaterInterfaceFactory(shapes[i], view[i], propertyGroup));
                else if (shapes[i].ty === "gf") arr.push(gradientFillInterfaceFactory(shapes[i], view[i], propertyGroup));
                else arr.push(defaultInterfaceFactory(shapes[i], view[i], propertyGroup));
            }
            return arr;
        }
        function contentsInterfaceFactory(shape, view, propertyGroup) {
            var interfaces;
            var interfaceFunction = function _interfaceFunction(value) {
                var i = 0;
                var len = interfaces.length;
                while(i < len){
                    if (interfaces[i]._name === value || interfaces[i].mn === value || interfaces[i].propertyIndex === value || interfaces[i].ix === value || interfaces[i].ind === value) return interfaces[i];
                    i += 1;
                }
                if (typeof value === "number") return interfaces[value - 1];
                return null;
            };
            interfaceFunction.propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
            interfaces = iterateElements(shape.it, view.it, interfaceFunction.propertyGroup);
            interfaceFunction.numProperties = interfaces.length;
            var transformInterface = transformInterfaceFactory(shape.it[shape.it.length - 1], view.it[view.it.length - 1], interfaceFunction.propertyGroup);
            interfaceFunction.transform = transformInterface;
            interfaceFunction.propertyIndex = shape.cix;
            interfaceFunction._name = shape.nm;
            return interfaceFunction;
        }
        function groupInterfaceFactory(shape, view, propertyGroup) {
            var interfaceFunction = function _interfaceFunction(value) {
                switch(value){
                    case "ADBE Vectors Group":
                    case "Contents":
                    case 2:
                        return interfaceFunction.content;
                    // Not necessary for now. Keeping them here in case a new case appears
                    // case 'ADBE Vector Transform Group':
                    // case 3:
                    default:
                        return interfaceFunction.transform;
                }
            };
            interfaceFunction.propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
            var content = contentsInterfaceFactory(shape, view, interfaceFunction.propertyGroup);
            var transformInterface = transformInterfaceFactory(shape.it[shape.it.length - 1], view.it[view.it.length - 1], interfaceFunction.propertyGroup);
            interfaceFunction.content = content;
            interfaceFunction.transform = transformInterface;
            Object.defineProperty(interfaceFunction, "_name", {
                get: function get() {
                    return shape.nm;
                }
            }); // interfaceFunction.content = interfaceFunction;
            interfaceFunction.numProperties = shape.np;
            interfaceFunction.propertyIndex = shape.ix;
            interfaceFunction.nm = shape.nm;
            interfaceFunction.mn = shape.mn;
            return interfaceFunction;
        }
        function fillInterfaceFactory(shape, view, propertyGroup) {
            function interfaceFunction(val) {
                if (val === "Color" || val === "color") return interfaceFunction.color;
                if (val === "Opacity" || val === "opacity") return interfaceFunction.opacity;
                return null;
            }
            Object.defineProperties(interfaceFunction, {
                color: {
                    get: ExpressionPropertyInterface(view.c)
                },
                opacity: {
                    get: ExpressionPropertyInterface(view.o)
                },
                _name: {
                    value: shape.nm
                },
                mn: {
                    value: shape.mn
                }
            });
            view.c.setGroupProperty(PropertyInterface("Color", propertyGroup));
            view.o.setGroupProperty(PropertyInterface("Opacity", propertyGroup));
            return interfaceFunction;
        }
        function gradientFillInterfaceFactory(shape, view, propertyGroup) {
            function interfaceFunction(val) {
                if (val === "Start Point" || val === "start point") return interfaceFunction.startPoint;
                if (val === "End Point" || val === "end point") return interfaceFunction.endPoint;
                if (val === "Opacity" || val === "opacity") return interfaceFunction.opacity;
                return null;
            }
            Object.defineProperties(interfaceFunction, {
                startPoint: {
                    get: ExpressionPropertyInterface(view.s)
                },
                endPoint: {
                    get: ExpressionPropertyInterface(view.e)
                },
                opacity: {
                    get: ExpressionPropertyInterface(view.o)
                },
                type: {
                    get: function get() {
                        return "a";
                    }
                },
                _name: {
                    value: shape.nm
                },
                mn: {
                    value: shape.mn
                }
            });
            view.s.setGroupProperty(PropertyInterface("Start Point", propertyGroup));
            view.e.setGroupProperty(PropertyInterface("End Point", propertyGroup));
            view.o.setGroupProperty(PropertyInterface("Opacity", propertyGroup));
            return interfaceFunction;
        }
        function defaultInterfaceFactory() {
            function interfaceFunction() {
                return null;
            }
            return interfaceFunction;
        }
        function strokeInterfaceFactory(shape, view, propertyGroup) {
            var _propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
            var _dashPropertyGroup = propertyGroupFactory(dashOb, _propertyGroup);
            function addPropertyToDashOb(i) {
                Object.defineProperty(dashOb, shape.d[i].nm, {
                    get: ExpressionPropertyInterface(view.d.dataProps[i].p)
                });
            }
            var i;
            var len = shape.d ? shape.d.length : 0;
            var dashOb = {};
            for(i = 0; i < len; i += 1){
                addPropertyToDashOb(i);
                view.d.dataProps[i].p.setGroupProperty(_dashPropertyGroup);
            }
            function interfaceFunction(val) {
                if (val === "Color" || val === "color") return interfaceFunction.color;
                if (val === "Opacity" || val === "opacity") return interfaceFunction.opacity;
                if (val === "Stroke Width" || val === "stroke width") return interfaceFunction.strokeWidth;
                return null;
            }
            Object.defineProperties(interfaceFunction, {
                color: {
                    get: ExpressionPropertyInterface(view.c)
                },
                opacity: {
                    get: ExpressionPropertyInterface(view.o)
                },
                strokeWidth: {
                    get: ExpressionPropertyInterface(view.w)
                },
                dash: {
                    get: function get() {
                        return dashOb;
                    }
                },
                _name: {
                    value: shape.nm
                },
                mn: {
                    value: shape.mn
                }
            });
            view.c.setGroupProperty(PropertyInterface("Color", _propertyGroup));
            view.o.setGroupProperty(PropertyInterface("Opacity", _propertyGroup));
            view.w.setGroupProperty(PropertyInterface("Stroke Width", _propertyGroup));
            return interfaceFunction;
        }
        function trimInterfaceFactory(shape, view, propertyGroup) {
            function interfaceFunction(val) {
                if (val === shape.e.ix || val === "End" || val === "end") return interfaceFunction.end;
                if (val === shape.s.ix) return interfaceFunction.start;
                if (val === shape.o.ix) return interfaceFunction.offset;
                return null;
            }
            var _propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
            interfaceFunction.propertyIndex = shape.ix;
            view.s.setGroupProperty(PropertyInterface("Start", _propertyGroup));
            view.e.setGroupProperty(PropertyInterface("End", _propertyGroup));
            view.o.setGroupProperty(PropertyInterface("Offset", _propertyGroup));
            interfaceFunction.propertyIndex = shape.ix;
            interfaceFunction.propertyGroup = propertyGroup;
            Object.defineProperties(interfaceFunction, {
                start: {
                    get: ExpressionPropertyInterface(view.s)
                },
                end: {
                    get: ExpressionPropertyInterface(view.e)
                },
                offset: {
                    get: ExpressionPropertyInterface(view.o)
                },
                _name: {
                    value: shape.nm
                }
            });
            interfaceFunction.mn = shape.mn;
            return interfaceFunction;
        }
        function transformInterfaceFactory(shape, view, propertyGroup) {
            function interfaceFunction(value) {
                if (shape.a.ix === value || value === "Anchor Point") return interfaceFunction.anchorPoint;
                if (shape.o.ix === value || value === "Opacity") return interfaceFunction.opacity;
                if (shape.p.ix === value || value === "Position") return interfaceFunction.position;
                if (shape.r.ix === value || value === "Rotation" || value === "ADBE Vector Rotation") return interfaceFunction.rotation;
                if (shape.s.ix === value || value === "Scale") return interfaceFunction.scale;
                if (shape.sk && shape.sk.ix === value || value === "Skew") return interfaceFunction.skew;
                if (shape.sa && shape.sa.ix === value || value === "Skew Axis") return interfaceFunction.skewAxis;
                return null;
            }
            var _propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
            view.transform.mProps.o.setGroupProperty(PropertyInterface("Opacity", _propertyGroup));
            view.transform.mProps.p.setGroupProperty(PropertyInterface("Position", _propertyGroup));
            view.transform.mProps.a.setGroupProperty(PropertyInterface("Anchor Point", _propertyGroup));
            view.transform.mProps.s.setGroupProperty(PropertyInterface("Scale", _propertyGroup));
            view.transform.mProps.r.setGroupProperty(PropertyInterface("Rotation", _propertyGroup));
            if (view.transform.mProps.sk) {
                view.transform.mProps.sk.setGroupProperty(PropertyInterface("Skew", _propertyGroup));
                view.transform.mProps.sa.setGroupProperty(PropertyInterface("Skew Angle", _propertyGroup));
            }
            view.transform.op.setGroupProperty(PropertyInterface("Opacity", _propertyGroup));
            Object.defineProperties(interfaceFunction, {
                opacity: {
                    get: ExpressionPropertyInterface(view.transform.mProps.o)
                },
                position: {
                    get: ExpressionPropertyInterface(view.transform.mProps.p)
                },
                anchorPoint: {
                    get: ExpressionPropertyInterface(view.transform.mProps.a)
                },
                scale: {
                    get: ExpressionPropertyInterface(view.transform.mProps.s)
                },
                rotation: {
                    get: ExpressionPropertyInterface(view.transform.mProps.r)
                },
                skew: {
                    get: ExpressionPropertyInterface(view.transform.mProps.sk)
                },
                skewAxis: {
                    get: ExpressionPropertyInterface(view.transform.mProps.sa)
                },
                _name: {
                    value: shape.nm
                }
            });
            interfaceFunction.ty = "tr";
            interfaceFunction.mn = shape.mn;
            interfaceFunction.propertyGroup = propertyGroup;
            return interfaceFunction;
        }
        function ellipseInterfaceFactory(shape, view, propertyGroup) {
            function interfaceFunction(value) {
                if (shape.p.ix === value) return interfaceFunction.position;
                if (shape.s.ix === value) return interfaceFunction.size;
                return null;
            }
            var _propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
            interfaceFunction.propertyIndex = shape.ix;
            var prop = view.sh.ty === "tm" ? view.sh.prop : view.sh;
            prop.s.setGroupProperty(PropertyInterface("Size", _propertyGroup));
            prop.p.setGroupProperty(PropertyInterface("Position", _propertyGroup));
            Object.defineProperties(interfaceFunction, {
                size: {
                    get: ExpressionPropertyInterface(prop.s)
                },
                position: {
                    get: ExpressionPropertyInterface(prop.p)
                },
                _name: {
                    value: shape.nm
                }
            });
            interfaceFunction.mn = shape.mn;
            return interfaceFunction;
        }
        function starInterfaceFactory(shape, view, propertyGroup) {
            function interfaceFunction(value) {
                if (shape.p.ix === value) return interfaceFunction.position;
                if (shape.r.ix === value) return interfaceFunction.rotation;
                if (shape.pt.ix === value) return interfaceFunction.points;
                if (shape.or.ix === value || value === "ADBE Vector Star Outer Radius") return interfaceFunction.outerRadius;
                if (shape.os.ix === value) return interfaceFunction.outerRoundness;
                if (shape.ir && (shape.ir.ix === value || value === "ADBE Vector Star Inner Radius")) return interfaceFunction.innerRadius;
                if (shape.is && shape.is.ix === value) return interfaceFunction.innerRoundness;
                return null;
            }
            var _propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
            var prop = view.sh.ty === "tm" ? view.sh.prop : view.sh;
            interfaceFunction.propertyIndex = shape.ix;
            prop.or.setGroupProperty(PropertyInterface("Outer Radius", _propertyGroup));
            prop.os.setGroupProperty(PropertyInterface("Outer Roundness", _propertyGroup));
            prop.pt.setGroupProperty(PropertyInterface("Points", _propertyGroup));
            prop.p.setGroupProperty(PropertyInterface("Position", _propertyGroup));
            prop.r.setGroupProperty(PropertyInterface("Rotation", _propertyGroup));
            if (shape.ir) {
                prop.ir.setGroupProperty(PropertyInterface("Inner Radius", _propertyGroup));
                prop.is.setGroupProperty(PropertyInterface("Inner Roundness", _propertyGroup));
            }
            Object.defineProperties(interfaceFunction, {
                position: {
                    get: ExpressionPropertyInterface(prop.p)
                },
                rotation: {
                    get: ExpressionPropertyInterface(prop.r)
                },
                points: {
                    get: ExpressionPropertyInterface(prop.pt)
                },
                outerRadius: {
                    get: ExpressionPropertyInterface(prop.or)
                },
                outerRoundness: {
                    get: ExpressionPropertyInterface(prop.os)
                },
                innerRadius: {
                    get: ExpressionPropertyInterface(prop.ir)
                },
                innerRoundness: {
                    get: ExpressionPropertyInterface(prop.is)
                },
                _name: {
                    value: shape.nm
                }
            });
            interfaceFunction.mn = shape.mn;
            return interfaceFunction;
        }
        function rectInterfaceFactory(shape, view, propertyGroup) {
            function interfaceFunction(value) {
                if (shape.p.ix === value) return interfaceFunction.position;
                if (shape.r.ix === value) return interfaceFunction.roundness;
                if (shape.s.ix === value || value === "Size" || value === "ADBE Vector Rect Size") return interfaceFunction.size;
                return null;
            }
            var _propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
            var prop = view.sh.ty === "tm" ? view.sh.prop : view.sh;
            interfaceFunction.propertyIndex = shape.ix;
            prop.p.setGroupProperty(PropertyInterface("Position", _propertyGroup));
            prop.s.setGroupProperty(PropertyInterface("Size", _propertyGroup));
            prop.r.setGroupProperty(PropertyInterface("Rotation", _propertyGroup));
            Object.defineProperties(interfaceFunction, {
                position: {
                    get: ExpressionPropertyInterface(prop.p)
                },
                roundness: {
                    get: ExpressionPropertyInterface(prop.r)
                },
                size: {
                    get: ExpressionPropertyInterface(prop.s)
                },
                _name: {
                    value: shape.nm
                }
            });
            interfaceFunction.mn = shape.mn;
            return interfaceFunction;
        }
        function roundedInterfaceFactory(shape, view, propertyGroup) {
            function interfaceFunction(value) {
                if (shape.r.ix === value || value === "Round Corners 1") return interfaceFunction.radius;
                return null;
            }
            var _propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
            var prop = view;
            interfaceFunction.propertyIndex = shape.ix;
            prop.rd.setGroupProperty(PropertyInterface("Radius", _propertyGroup));
            Object.defineProperties(interfaceFunction, {
                radius: {
                    get: ExpressionPropertyInterface(prop.rd)
                },
                _name: {
                    value: shape.nm
                }
            });
            interfaceFunction.mn = shape.mn;
            return interfaceFunction;
        }
        function repeaterInterfaceFactory(shape, view, propertyGroup) {
            function interfaceFunction(value) {
                if (shape.c.ix === value || value === "Copies") return interfaceFunction.copies;
                if (shape.o.ix === value || value === "Offset") return interfaceFunction.offset;
                return null;
            }
            var _propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
            var prop = view;
            interfaceFunction.propertyIndex = shape.ix;
            prop.c.setGroupProperty(PropertyInterface("Copies", _propertyGroup));
            prop.o.setGroupProperty(PropertyInterface("Offset", _propertyGroup));
            Object.defineProperties(interfaceFunction, {
                copies: {
                    get: ExpressionPropertyInterface(prop.c)
                },
                offset: {
                    get: ExpressionPropertyInterface(prop.o)
                },
                _name: {
                    value: shape.nm
                }
            });
            interfaceFunction.mn = shape.mn;
            return interfaceFunction;
        }
        return function(shapes, view, propertyGroup) {
            var interfaces;
            function _interfaceFunction(value) {
                if (typeof value === "number") {
                    value = value === undefined ? 1 : value;
                    if (value === 0) return propertyGroup;
                    return interfaces[value - 1];
                }
                var i = 0;
                var len = interfaces.length;
                while(i < len){
                    if (interfaces[i]._name === value) return interfaces[i];
                    i += 1;
                }
                return null;
            }
            function parentGroupWrapper() {
                return propertyGroup;
            }
            _interfaceFunction.propertyGroup = propertyGroupFactory(_interfaceFunction, parentGroupWrapper);
            interfaces = iterateElements(shapes, view, _interfaceFunction.propertyGroup);
            _interfaceFunction.numProperties = interfaces.length;
            _interfaceFunction._name = "Contents";
            return _interfaceFunction;
        };
    }();
    var TextExpressionInterface = function() {
        return function(elem) {
            var _sourceText;
            function _thisLayerFunction(name) {
                switch(name){
                    case "ADBE Text Document":
                        return _thisLayerFunction.sourceText;
                    default:
                        return null;
                }
            }
            Object.defineProperty(_thisLayerFunction, "sourceText", {
                get: function get() {
                    elem.textProperty.getValue();
                    var stringValue = elem.textProperty.currentData.t;
                    if (!_sourceText || stringValue !== _sourceText.value) {
                        _sourceText = new String(stringValue); // eslint-disable-line no-new-wrappers
                        // If stringValue is an empty string, eval returns undefined, so it has to be returned as a String primitive
                        _sourceText.value = stringValue || new String(stringValue); // eslint-disable-line no-new-wrappers
                        Object.defineProperty(_sourceText, "style", {
                            get: function get() {
                                return {
                                    fillColor: elem.textProperty.currentData.fc
                                };
                            }
                        });
                    }
                    return _sourceText;
                }
            });
            return _thisLayerFunction;
        };
    }();
    function _typeof(obj) {
        "@babel/helpers - typeof";
        if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function _typeof(obj) {
            return typeof obj;
        };
        else _typeof = function _typeof(obj) {
            return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        };
        return _typeof(obj);
    }
    var FootageInterface = function() {
        var outlineInterfaceFactory = function outlineInterfaceFactory(elem) {
            var currentPropertyName = "";
            var currentProperty = elem.getFootageData();
            function init() {
                currentPropertyName = "";
                currentProperty = elem.getFootageData();
                return searchProperty;
            }
            function searchProperty(value) {
                if (currentProperty[value]) {
                    currentPropertyName = value;
                    currentProperty = currentProperty[value];
                    if (_typeof(currentProperty) === "object") return searchProperty;
                    return currentProperty;
                }
                var propertyNameIndex = value.indexOf(currentPropertyName);
                if (propertyNameIndex !== -1) {
                    var index = parseInt(value.substr(propertyNameIndex + currentPropertyName.length), 10);
                    currentProperty = currentProperty[index];
                    if (_typeof(currentProperty) === "object") return searchProperty;
                    return currentProperty;
                }
                return "";
            }
            return init;
        };
        var dataInterfaceFactory = function dataInterfaceFactory(elem) {
            function interfaceFunction(value) {
                if (value === "Outline") return interfaceFunction.outlineInterface();
                return null;
            }
            interfaceFunction._name = "Outline";
            interfaceFunction.outlineInterface = outlineInterfaceFactory(elem);
            return interfaceFunction;
        };
        return function(elem) {
            function _interfaceFunction(value) {
                if (value === "Data") return _interfaceFunction.dataInterface;
                return null;
            }
            _interfaceFunction._name = "Data";
            _interfaceFunction.dataInterface = dataInterfaceFactory(elem);
            return _interfaceFunction;
        };
    }();
    var interfaces = {
        layer: LayerExpressionInterface,
        effects: EffectsExpressionInterface,
        comp: CompExpressionInterface,
        shape: ShapeExpressionInterface,
        text: TextExpressionInterface,
        footage: FootageInterface
    };
    function getInterface(type) {
        return interfaces[type] || null;
    }
    var expressionHelpers = function() {
        function searchExpressions(elem, data, prop) {
            if (data.x) {
                prop.k = true;
                prop.x = true;
                prop.initiateExpression = ExpressionManager.initiateExpression;
                prop.effectsSequence.push(prop.initiateExpression(elem, data, prop).bind(prop));
            }
        }
        function getValueAtTime(frameNum) {
            frameNum *= this.elem.globalData.frameRate;
            frameNum -= this.offsetTime;
            if (frameNum !== this._cachingAtTime.lastFrame) {
                this._cachingAtTime.lastIndex = this._cachingAtTime.lastFrame < frameNum ? this._cachingAtTime.lastIndex : 0;
                this._cachingAtTime.value = this.interpolateValue(frameNum, this._cachingAtTime);
                this._cachingAtTime.lastFrame = frameNum;
            }
            return this._cachingAtTime.value;
        }
        function getSpeedAtTime(frameNum) {
            var delta = -0.01;
            var v1 = this.getValueAtTime(frameNum);
            var v2 = this.getValueAtTime(frameNum + delta);
            var speed = 0;
            if (v1.length) {
                var i;
                for(i = 0; i < v1.length; i += 1)speed += Math.pow(v2[i] - v1[i], 2);
                speed = Math.sqrt(speed) * 100;
            } else speed = 0;
            return speed;
        }
        function getVelocityAtTime(frameNum) {
            if (this.vel !== undefined) return this.vel;
            var delta = -0.001; // frameNum += this.elem.data.st;
            var v1 = this.getValueAtTime(frameNum);
            var v2 = this.getValueAtTime(frameNum + delta);
            var velocity;
            if (v1.length) {
                velocity = createTypedArray("float32", v1.length);
                var i;
                for(i = 0; i < v1.length; i += 1)// removing frameRate
                // if needed, don't add it here
                // velocity[i] = this.elem.globalData.frameRate*((v2[i] - v1[i])/delta);
                velocity[i] = (v2[i] - v1[i]) / delta;
            } else velocity = (v2 - v1) / delta;
            return velocity;
        }
        function getStaticValueAtTime() {
            return this.pv;
        }
        function setGroupProperty(propertyGroup) {
            this.propertyGroup = propertyGroup;
        }
        return {
            searchExpressions: searchExpressions,
            getSpeedAtTime: getSpeedAtTime,
            getVelocityAtTime: getVelocityAtTime,
            getValueAtTime: getValueAtTime,
            getStaticValueAtTime: getStaticValueAtTime,
            setGroupProperty: setGroupProperty
        };
    }();
    function addPropertyDecorator() {
        function loopOut(type, duration, durationFlag) {
            if (!this.k || !this.keyframes) return this.pv;
            type = type ? type.toLowerCase() : "";
            var currentFrame = this.comp.renderedFrame;
            var keyframes = this.keyframes;
            var lastKeyFrame = keyframes[keyframes.length - 1].t;
            if (currentFrame <= lastKeyFrame) return this.pv;
            var cycleDuration;
            var firstKeyFrame;
            if (!durationFlag) {
                if (!duration || duration > keyframes.length - 1) duration = keyframes.length - 1;
                firstKeyFrame = keyframes[keyframes.length - 1 - duration].t;
                cycleDuration = lastKeyFrame - firstKeyFrame;
            } else {
                if (!duration) cycleDuration = Math.max(0, lastKeyFrame - this.elem.data.ip);
                else cycleDuration = Math.abs(lastKeyFrame - this.elem.comp.globalData.frameRate * duration);
                firstKeyFrame = lastKeyFrame - cycleDuration;
            }
            var i;
            var len;
            var ret;
            if (type === "pingpong") {
                var iterations = Math.floor((currentFrame - firstKeyFrame) / cycleDuration);
                if (iterations % 2 !== 0) return this.getValueAtTime((cycleDuration - (currentFrame - firstKeyFrame) % cycleDuration + firstKeyFrame) / this.comp.globalData.frameRate, 0); // eslint-disable-line
            } else if (type === "offset") {
                var initV = this.getValueAtTime(firstKeyFrame / this.comp.globalData.frameRate, 0);
                var endV = this.getValueAtTime(lastKeyFrame / this.comp.globalData.frameRate, 0);
                var current = this.getValueAtTime(((currentFrame - firstKeyFrame) % cycleDuration + firstKeyFrame) / this.comp.globalData.frameRate, 0); // eslint-disable-line
                var repeats = Math.floor((currentFrame - firstKeyFrame) / cycleDuration);
                if (this.pv.length) {
                    ret = new Array(initV.length);
                    len = ret.length;
                    for(i = 0; i < len; i += 1)ret[i] = (endV[i] - initV[i]) * repeats + current[i];
                    return ret;
                }
                return (endV - initV) * repeats + current;
            } else if (type === "continue") {
                var lastValue = this.getValueAtTime(lastKeyFrame / this.comp.globalData.frameRate, 0);
                var nextLastValue = this.getValueAtTime((lastKeyFrame - 0.001) / this.comp.globalData.frameRate, 0);
                if (this.pv.length) {
                    ret = new Array(lastValue.length);
                    len = ret.length;
                    for(i = 0; i < len; i += 1)ret[i] = lastValue[i] + (lastValue[i] - nextLastValue[i]) * ((currentFrame - lastKeyFrame) / this.comp.globalData.frameRate) / 0.0005; // eslint-disable-line
                    return ret;
                }
                return lastValue + (lastValue - nextLastValue) * ((currentFrame - lastKeyFrame) / 0.001);
            }
            return this.getValueAtTime(((currentFrame - firstKeyFrame) % cycleDuration + firstKeyFrame) / this.comp.globalData.frameRate, 0); // eslint-disable-line
        }
        function loopIn(type, duration, durationFlag) {
            if (!this.k) return this.pv;
            type = type ? type.toLowerCase() : "";
            var currentFrame = this.comp.renderedFrame;
            var keyframes = this.keyframes;
            var firstKeyFrame = keyframes[0].t;
            if (currentFrame >= firstKeyFrame) return this.pv;
            var cycleDuration;
            var lastKeyFrame;
            if (!durationFlag) {
                if (!duration || duration > keyframes.length - 1) duration = keyframes.length - 1;
                lastKeyFrame = keyframes[duration].t;
                cycleDuration = lastKeyFrame - firstKeyFrame;
            } else {
                if (!duration) cycleDuration = Math.max(0, this.elem.data.op - firstKeyFrame);
                else cycleDuration = Math.abs(this.elem.comp.globalData.frameRate * duration);
                lastKeyFrame = firstKeyFrame + cycleDuration;
            }
            var i;
            var len;
            var ret;
            if (type === "pingpong") {
                var iterations = Math.floor((firstKeyFrame - currentFrame) / cycleDuration);
                if (iterations % 2 === 0) return this.getValueAtTime(((firstKeyFrame - currentFrame) % cycleDuration + firstKeyFrame) / this.comp.globalData.frameRate, 0); // eslint-disable-line
            } else if (type === "offset") {
                var initV = this.getValueAtTime(firstKeyFrame / this.comp.globalData.frameRate, 0);
                var endV = this.getValueAtTime(lastKeyFrame / this.comp.globalData.frameRate, 0);
                var current = this.getValueAtTime((cycleDuration - (firstKeyFrame - currentFrame) % cycleDuration + firstKeyFrame) / this.comp.globalData.frameRate, 0);
                var repeats = Math.floor((firstKeyFrame - currentFrame) / cycleDuration) + 1;
                if (this.pv.length) {
                    ret = new Array(initV.length);
                    len = ret.length;
                    for(i = 0; i < len; i += 1)ret[i] = current[i] - (endV[i] - initV[i]) * repeats;
                    return ret;
                }
                return current - (endV - initV) * repeats;
            } else if (type === "continue") {
                var firstValue = this.getValueAtTime(firstKeyFrame / this.comp.globalData.frameRate, 0);
                var nextFirstValue = this.getValueAtTime((firstKeyFrame + 0.001) / this.comp.globalData.frameRate, 0);
                if (this.pv.length) {
                    ret = new Array(firstValue.length);
                    len = ret.length;
                    for(i = 0; i < len; i += 1)ret[i] = firstValue[i] + (firstValue[i] - nextFirstValue[i]) * (firstKeyFrame - currentFrame) / 0.001;
                    return ret;
                }
                return firstValue + (firstValue - nextFirstValue) * (firstKeyFrame - currentFrame) / 0.001;
            }
            return this.getValueAtTime((cycleDuration - ((firstKeyFrame - currentFrame) % cycleDuration + firstKeyFrame)) / this.comp.globalData.frameRate, 0); // eslint-disable-line
        }
        function smooth(width, samples) {
            if (!this.k) return this.pv;
            width = (width || 0.4) * 0.5;
            samples = Math.floor(samples || 5);
            if (samples <= 1) return this.pv;
            var currentTime = this.comp.renderedFrame / this.comp.globalData.frameRate;
            var initFrame = currentTime - width;
            var endFrame = currentTime + width;
            var sampleFrequency = samples > 1 ? (endFrame - initFrame) / (samples - 1) : 1;
            var i = 0;
            var j = 0;
            var value;
            if (this.pv.length) value = createTypedArray("float32", this.pv.length);
            else value = 0;
            var sampleValue;
            while(i < samples){
                sampleValue = this.getValueAtTime(initFrame + i * sampleFrequency);
                if (this.pv.length) for(j = 0; j < this.pv.length; j += 1)value[j] += sampleValue[j];
                else value += sampleValue;
                i += 1;
            }
            if (this.pv.length) for(j = 0; j < this.pv.length; j += 1)value[j] /= samples;
            else value /= samples;
            return value;
        }
        function getTransformValueAtTime(time) {
            if (!this._transformCachingAtTime) this._transformCachingAtTime = {
                v: new Matrix()
            };
             /// /
            var matrix = this._transformCachingAtTime.v;
            matrix.cloneFromProps(this.pre.props);
            if (this.appliedTransformations < 1) {
                var anchor = this.a.getValueAtTime(time);
                matrix.translate(-anchor[0] * this.a.mult, -anchor[1] * this.a.mult, anchor[2] * this.a.mult);
            }
            if (this.appliedTransformations < 2) {
                var scale = this.s.getValueAtTime(time);
                matrix.scale(scale[0] * this.s.mult, scale[1] * this.s.mult, scale[2] * this.s.mult);
            }
            if (this.sk && this.appliedTransformations < 3) {
                var skew = this.sk.getValueAtTime(time);
                var skewAxis = this.sa.getValueAtTime(time);
                matrix.skewFromAxis(-skew * this.sk.mult, skewAxis * this.sa.mult);
            }
            if (this.r && this.appliedTransformations < 4) {
                var rotation = this.r.getValueAtTime(time);
                matrix.rotate(-rotation * this.r.mult);
            } else if (!this.r && this.appliedTransformations < 4) {
                var rotationZ = this.rz.getValueAtTime(time);
                var rotationY = this.ry.getValueAtTime(time);
                var rotationX = this.rx.getValueAtTime(time);
                var orientation = this.or.getValueAtTime(time);
                matrix.rotateZ(-rotationZ * this.rz.mult).rotateY(rotationY * this.ry.mult).rotateX(rotationX * this.rx.mult).rotateZ(-orientation[2] * this.or.mult).rotateY(orientation[1] * this.or.mult).rotateX(orientation[0] * this.or.mult);
            }
            if (this.data.p && this.data.p.s) {
                var positionX = this.px.getValueAtTime(time);
                var positionY = this.py.getValueAtTime(time);
                if (this.data.p.z) {
                    var positionZ = this.pz.getValueAtTime(time);
                    matrix.translate(positionX * this.px.mult, positionY * this.py.mult, -positionZ * this.pz.mult);
                } else matrix.translate(positionX * this.px.mult, positionY * this.py.mult, 0);
            } else {
                var position = this.p.getValueAtTime(time);
                matrix.translate(position[0] * this.p.mult, position[1] * this.p.mult, -position[2] * this.p.mult);
            }
            return matrix; /// /
        }
        function getTransformStaticValueAtTime() {
            return this.v.clone(new Matrix());
        }
        var getTransformProperty = TransformPropertyFactory.getTransformProperty;
        TransformPropertyFactory.getTransformProperty = function(elem, data, container) {
            var prop = getTransformProperty(elem, data, container);
            if (prop.dynamicProperties.length) prop.getValueAtTime = getTransformValueAtTime.bind(prop);
            else prop.getValueAtTime = getTransformStaticValueAtTime.bind(prop);
            prop.setGroupProperty = expressionHelpers.setGroupProperty;
            return prop;
        };
        var propertyGetProp = PropertyFactory.getProp;
        PropertyFactory.getProp = function(elem, data, type, mult, container) {
            var prop = propertyGetProp(elem, data, type, mult, container); // prop.getVelocityAtTime = getVelocityAtTime;
            // prop.loopOut = loopOut;
            // prop.loopIn = loopIn;
            if (prop.kf) prop.getValueAtTime = expressionHelpers.getValueAtTime.bind(prop);
            else prop.getValueAtTime = expressionHelpers.getStaticValueAtTime.bind(prop);
            prop.setGroupProperty = expressionHelpers.setGroupProperty;
            prop.loopOut = loopOut;
            prop.loopIn = loopIn;
            prop.smooth = smooth;
            prop.getVelocityAtTime = expressionHelpers.getVelocityAtTime.bind(prop);
            prop.getSpeedAtTime = expressionHelpers.getSpeedAtTime.bind(prop);
            prop.numKeys = data.a === 1 ? data.k.length : 0;
            prop.propertyIndex = data.ix;
            var value = 0;
            if (type !== 0) value = createTypedArray("float32", data.a === 1 ? data.k[0].s.length : data.k.length);
            prop._cachingAtTime = {
                lastFrame: initialDefaultFrame,
                lastIndex: 0,
                value: value
            };
            expressionHelpers.searchExpressions(elem, data, prop);
            if (prop.k) container.addDynamicProperty(prop);
            return prop;
        };
        function getShapeValueAtTime(frameNum) {
            // For now this caching object is created only when needed instead of creating it when the shape is initialized.
            if (!this._cachingAtTime) this._cachingAtTime = {
                shapeValue: shapePool.clone(this.pv),
                lastIndex: 0,
                lastTime: initialDefaultFrame
            };
            frameNum *= this.elem.globalData.frameRate;
            frameNum -= this.offsetTime;
            if (frameNum !== this._cachingAtTime.lastTime) {
                this._cachingAtTime.lastIndex = this._cachingAtTime.lastTime < frameNum ? this._caching.lastIndex : 0;
                this._cachingAtTime.lastTime = frameNum;
                this.interpolateShape(frameNum, this._cachingAtTime.shapeValue, this._cachingAtTime);
            }
            return this._cachingAtTime.shapeValue;
        }
        var ShapePropertyConstructorFunction = ShapePropertyFactory.getConstructorFunction();
        var KeyframedShapePropertyConstructorFunction = ShapePropertyFactory.getKeyframedConstructorFunction();
        function ShapeExpressions() {}
        ShapeExpressions.prototype = {
            vertices: function vertices(prop, time) {
                if (this.k) this.getValue();
                var shapePath = this.v;
                if (time !== undefined) shapePath = this.getValueAtTime(time, 0);
                var i;
                var len = shapePath._length;
                var vertices = shapePath[prop];
                var points = shapePath.v;
                var arr = createSizedArray(len);
                for(i = 0; i < len; i += 1)if (prop === "i" || prop === "o") arr[i] = [
                    vertices[i][0] - points[i][0],
                    vertices[i][1] - points[i][1]
                ];
                else arr[i] = [
                    vertices[i][0],
                    vertices[i][1]
                ];
                return arr;
            },
            points: function points(time) {
                return this.vertices("v", time);
            },
            inTangents: function inTangents(time) {
                return this.vertices("i", time);
            },
            outTangents: function outTangents(time) {
                return this.vertices("o", time);
            },
            isClosed: function isClosed() {
                return this.v.c;
            },
            pointOnPath: function pointOnPath(perc, time) {
                var shapePath = this.v;
                if (time !== undefined) shapePath = this.getValueAtTime(time, 0);
                if (!this._segmentsLength) this._segmentsLength = bez.getSegmentsLength(shapePath);
                var segmentsLength = this._segmentsLength;
                var lengths = segmentsLength.lengths;
                var lengthPos = segmentsLength.totalLength * perc;
                var i = 0;
                var len = lengths.length;
                var accumulatedLength = 0;
                var pt;
                while(i < len){
                    if (accumulatedLength + lengths[i].addedLength > lengthPos) {
                        var initIndex = i;
                        var endIndex = shapePath.c && i === len - 1 ? 0 : i + 1;
                        var segmentPerc = (lengthPos - accumulatedLength) / lengths[i].addedLength;
                        pt = bez.getPointInSegment(shapePath.v[initIndex], shapePath.v[endIndex], shapePath.o[initIndex], shapePath.i[endIndex], segmentPerc, lengths[i]);
                        break;
                    } else accumulatedLength += lengths[i].addedLength;
                    i += 1;
                }
                if (!pt) pt = shapePath.c ? [
                    shapePath.v[0][0],
                    shapePath.v[0][1]
                ] : [
                    shapePath.v[shapePath._length - 1][0],
                    shapePath.v[shapePath._length - 1][1]
                ];
                return pt;
            },
            vectorOnPath: function vectorOnPath(perc, time, vectorType) {
                // perc doesn't use triple equality because it can be a Number object as well as a primitive.
                if (perc == 1) // eslint-disable-line eqeqeq
                perc = this.v.c;
                else if (perc == 0) // eslint-disable-line eqeqeq
                perc = 0.999;
                var pt1 = this.pointOnPath(perc, time);
                var pt2 = this.pointOnPath(perc + 0.001, time);
                var xLength = pt2[0] - pt1[0];
                var yLength = pt2[1] - pt1[1];
                var magnitude = Math.sqrt(Math.pow(xLength, 2) + Math.pow(yLength, 2));
                if (magnitude === 0) return [
                    0,
                    0
                ];
                var unitVector = vectorType === "tangent" ? [
                    xLength / magnitude,
                    yLength / magnitude
                ] : [
                    -yLength / magnitude,
                    xLength / magnitude
                ];
                return unitVector;
            },
            tangentOnPath: function tangentOnPath(perc, time) {
                return this.vectorOnPath(perc, time, "tangent");
            },
            normalOnPath: function normalOnPath(perc, time) {
                return this.vectorOnPath(perc, time, "normal");
            },
            setGroupProperty: expressionHelpers.setGroupProperty,
            getValueAtTime: expressionHelpers.getStaticValueAtTime
        };
        extendPrototype([
            ShapeExpressions
        ], ShapePropertyConstructorFunction);
        extendPrototype([
            ShapeExpressions
        ], KeyframedShapePropertyConstructorFunction);
        KeyframedShapePropertyConstructorFunction.prototype.getValueAtTime = getShapeValueAtTime;
        KeyframedShapePropertyConstructorFunction.prototype.initiateExpression = ExpressionManager.initiateExpression;
        var propertyGetShapeProp = ShapePropertyFactory.getShapeProp;
        ShapePropertyFactory.getShapeProp = function(elem, data, type, arr, trims) {
            var prop = propertyGetShapeProp(elem, data, type, arr, trims);
            prop.propertyIndex = data.ix;
            prop.lock = false;
            if (type === 3) expressionHelpers.searchExpressions(elem, data.pt, prop);
            else if (type === 4) expressionHelpers.searchExpressions(elem, data.ks, prop);
            if (prop.k) elem.addDynamicProperty(prop);
            return prop;
        };
    }
    function initialize$1() {
        addPropertyDecorator();
    }
    function addDecorator() {
        function searchExpressions() {
            if (this.data.d.x) {
                this.calculateExpression = ExpressionManager.initiateExpression.bind(this)(this.elem, this.data.d, this);
                this.addEffect(this.getExpressionValue.bind(this));
                return true;
            }
            return null;
        }
        TextProperty.prototype.getExpressionValue = function(currentValue, text) {
            var newValue = this.calculateExpression(text);
            if (currentValue.t !== newValue) {
                var newData = {};
                this.copyData(newData, currentValue);
                newData.t = newValue.toString();
                newData.__complete = false;
                return newData;
            }
            return currentValue;
        };
        TextProperty.prototype.searchProperty = function() {
            var isKeyframed = this.searchKeyframes();
            var hasExpressions = this.searchExpressions();
            this.kf = isKeyframed || hasExpressions;
            return this.kf;
        };
        TextProperty.prototype.searchExpressions = searchExpressions;
    }
    function initialize() {
        addDecorator();
    }
    function SVGComposableEffect() {}
    SVGComposableEffect.prototype = {
        createMergeNode: function createMergeNode(resultId, ins) {
            var feMerge = createNS("feMerge");
            feMerge.setAttribute("result", resultId);
            var feMergeNode;
            var i;
            for(i = 0; i < ins.length; i += 1){
                feMergeNode = createNS("feMergeNode");
                feMergeNode.setAttribute("in", ins[i]);
                feMerge.appendChild(feMergeNode);
                feMerge.appendChild(feMergeNode);
            }
            return feMerge;
        }
    };
    var linearFilterValue = "0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0";
    function SVGTintFilter(filter, filterManager, elem, id, source) {
        this.filterManager = filterManager;
        var feColorMatrix = createNS("feColorMatrix");
        feColorMatrix.setAttribute("type", "matrix");
        feColorMatrix.setAttribute("color-interpolation-filters", "linearRGB");
        feColorMatrix.setAttribute("values", linearFilterValue + " 1 0");
        this.linearFilter = feColorMatrix;
        feColorMatrix.setAttribute("result", id + "_tint_1");
        filter.appendChild(feColorMatrix);
        feColorMatrix = createNS("feColorMatrix");
        feColorMatrix.setAttribute("type", "matrix");
        feColorMatrix.setAttribute("color-interpolation-filters", "sRGB");
        feColorMatrix.setAttribute("values", "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0");
        feColorMatrix.setAttribute("result", id + "_tint_2");
        filter.appendChild(feColorMatrix);
        this.matrixFilter = feColorMatrix;
        var feMerge = this.createMergeNode(id, [
            source,
            id + "_tint_1",
            id + "_tint_2"
        ]);
        filter.appendChild(feMerge);
    }
    extendPrototype([
        SVGComposableEffect
    ], SVGTintFilter);
    SVGTintFilter.prototype.renderFrame = function(forceRender) {
        if (forceRender || this.filterManager._mdf) {
            var colorBlack = this.filterManager.effectElements[0].p.v;
            var colorWhite = this.filterManager.effectElements[1].p.v;
            var opacity = this.filterManager.effectElements[2].p.v / 100;
            this.linearFilter.setAttribute("values", linearFilterValue + " " + opacity + " 0");
            this.matrixFilter.setAttribute("values", colorWhite[0] - colorBlack[0] + " 0 0 0 " + colorBlack[0] + " " + (colorWhite[1] - colorBlack[1]) + " 0 0 0 " + colorBlack[1] + " " + (colorWhite[2] - colorBlack[2]) + " 0 0 0 " + colorBlack[2] + " 0 0 0 1 0");
        }
    };
    function SVGFillFilter(filter, filterManager, elem, id) {
        this.filterManager = filterManager;
        var feColorMatrix = createNS("feColorMatrix");
        feColorMatrix.setAttribute("type", "matrix");
        feColorMatrix.setAttribute("color-interpolation-filters", "sRGB");
        feColorMatrix.setAttribute("values", "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0");
        feColorMatrix.setAttribute("result", id);
        filter.appendChild(feColorMatrix);
        this.matrixFilter = feColorMatrix;
    }
    SVGFillFilter.prototype.renderFrame = function(forceRender) {
        if (forceRender || this.filterManager._mdf) {
            var color = this.filterManager.effectElements[2].p.v;
            var opacity = this.filterManager.effectElements[6].p.v;
            this.matrixFilter.setAttribute("values", "0 0 0 0 " + color[0] + " 0 0 0 0 " + color[1] + " 0 0 0 0 " + color[2] + " 0 0 0 " + opacity + " 0");
        }
    };
    function SVGStrokeEffect(fil, filterManager, elem) {
        this.initialized = false;
        this.filterManager = filterManager;
        this.elem = elem;
        this.paths = [];
    }
    SVGStrokeEffect.prototype.initialize = function() {
        var elemChildren = this.elem.layerElement.children || this.elem.layerElement.childNodes;
        var path;
        var groupPath;
        var i;
        var len;
        if (this.filterManager.effectElements[1].p.v === 1) {
            len = this.elem.maskManager.masksProperties.length;
            i = 0;
        } else {
            i = this.filterManager.effectElements[0].p.v - 1;
            len = i + 1;
        }
        groupPath = createNS("g");
        groupPath.setAttribute("fill", "none");
        groupPath.setAttribute("stroke-linecap", "round");
        groupPath.setAttribute("stroke-dashoffset", 1);
        for(i; i < len; i += 1){
            path = createNS("path");
            groupPath.appendChild(path);
            this.paths.push({
                p: path,
                m: i
            });
        }
        if (this.filterManager.effectElements[10].p.v === 3) {
            var mask = createNS("mask");
            var id = createElementID();
            mask.setAttribute("id", id);
            mask.setAttribute("mask-type", "alpha");
            mask.appendChild(groupPath);
            this.elem.globalData.defs.appendChild(mask);
            var g = createNS("g");
            g.setAttribute("mask", "url(" + getLocationHref() + "#" + id + ")");
            while(elemChildren[0])g.appendChild(elemChildren[0]);
            this.elem.layerElement.appendChild(g);
            this.masker = mask;
            groupPath.setAttribute("stroke", "#fff");
        } else if (this.filterManager.effectElements[10].p.v === 1 || this.filterManager.effectElements[10].p.v === 2) {
            if (this.filterManager.effectElements[10].p.v === 2) {
                elemChildren = this.elem.layerElement.children || this.elem.layerElement.childNodes;
                while(elemChildren.length)this.elem.layerElement.removeChild(elemChildren[0]);
            }
            this.elem.layerElement.appendChild(groupPath);
            this.elem.layerElement.removeAttribute("mask");
            groupPath.setAttribute("stroke", "#fff");
        }
        this.initialized = true;
        this.pathMasker = groupPath;
    };
    SVGStrokeEffect.prototype.renderFrame = function(forceRender) {
        if (!this.initialized) this.initialize();
        var i;
        var len = this.paths.length;
        var mask;
        var path;
        for(i = 0; i < len; i += 1)if (this.paths[i].m !== -1) {
            mask = this.elem.maskManager.viewData[this.paths[i].m];
            path = this.paths[i].p;
            if (forceRender || this.filterManager._mdf || mask.prop._mdf) path.setAttribute("d", mask.lastPath);
            if (forceRender || this.filterManager.effectElements[9].p._mdf || this.filterManager.effectElements[4].p._mdf || this.filterManager.effectElements[7].p._mdf || this.filterManager.effectElements[8].p._mdf || mask.prop._mdf) {
                var dasharrayValue;
                if (this.filterManager.effectElements[7].p.v !== 0 || this.filterManager.effectElements[8].p.v !== 100) {
                    var s = Math.min(this.filterManager.effectElements[7].p.v, this.filterManager.effectElements[8].p.v) * 0.01;
                    var e = Math.max(this.filterManager.effectElements[7].p.v, this.filterManager.effectElements[8].p.v) * 0.01;
                    var l = path.getTotalLength();
                    dasharrayValue = "0 0 0 " + l * s + " ";
                    var lineLength = l * (e - s);
                    var segment = 1 + this.filterManager.effectElements[4].p.v * 2 * this.filterManager.effectElements[9].p.v * 0.01;
                    var units = Math.floor(lineLength / segment);
                    var j;
                    for(j = 0; j < units; j += 1)dasharrayValue += "1 " + this.filterManager.effectElements[4].p.v * 2 * this.filterManager.effectElements[9].p.v * 0.01 + " ";
                    dasharrayValue += "0 " + l * 10 + " 0 0";
                } else dasharrayValue = "1 " + this.filterManager.effectElements[4].p.v * 2 * this.filterManager.effectElements[9].p.v * 0.01;
                path.setAttribute("stroke-dasharray", dasharrayValue);
            }
        }
        if (forceRender || this.filterManager.effectElements[4].p._mdf) this.pathMasker.setAttribute("stroke-width", this.filterManager.effectElements[4].p.v * 2);
        if (forceRender || this.filterManager.effectElements[6].p._mdf) this.pathMasker.setAttribute("opacity", this.filterManager.effectElements[6].p.v);
        if (this.filterManager.effectElements[10].p.v === 1 || this.filterManager.effectElements[10].p.v === 2) {
            if (forceRender || this.filterManager.effectElements[3].p._mdf) {
                var color = this.filterManager.effectElements[3].p.v;
                this.pathMasker.setAttribute("stroke", "rgb(" + bmFloor(color[0] * 255) + "," + bmFloor(color[1] * 255) + "," + bmFloor(color[2] * 255) + ")");
            }
        }
    };
    function SVGTritoneFilter(filter, filterManager, elem, id) {
        this.filterManager = filterManager;
        var feColorMatrix = createNS("feColorMatrix");
        feColorMatrix.setAttribute("type", "matrix");
        feColorMatrix.setAttribute("color-interpolation-filters", "linearRGB");
        feColorMatrix.setAttribute("values", "0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0 1 0");
        filter.appendChild(feColorMatrix);
        var feComponentTransfer = createNS("feComponentTransfer");
        feComponentTransfer.setAttribute("color-interpolation-filters", "sRGB");
        feComponentTransfer.setAttribute("result", id);
        this.matrixFilter = feComponentTransfer;
        var feFuncR = createNS("feFuncR");
        feFuncR.setAttribute("type", "table");
        feComponentTransfer.appendChild(feFuncR);
        this.feFuncR = feFuncR;
        var feFuncG = createNS("feFuncG");
        feFuncG.setAttribute("type", "table");
        feComponentTransfer.appendChild(feFuncG);
        this.feFuncG = feFuncG;
        var feFuncB = createNS("feFuncB");
        feFuncB.setAttribute("type", "table");
        feComponentTransfer.appendChild(feFuncB);
        this.feFuncB = feFuncB;
        filter.appendChild(feComponentTransfer);
    }
    SVGTritoneFilter.prototype.renderFrame = function(forceRender) {
        if (forceRender || this.filterManager._mdf) {
            var color1 = this.filterManager.effectElements[0].p.v;
            var color2 = this.filterManager.effectElements[1].p.v;
            var color3 = this.filterManager.effectElements[2].p.v;
            var tableR = color3[0] + " " + color2[0] + " " + color1[0];
            var tableG = color3[1] + " " + color2[1] + " " + color1[1];
            var tableB = color3[2] + " " + color2[2] + " " + color1[2];
            this.feFuncR.setAttribute("tableValues", tableR);
            this.feFuncG.setAttribute("tableValues", tableG);
            this.feFuncB.setAttribute("tableValues", tableB);
        }
    };
    function SVGProLevelsFilter(filter, filterManager, elem, id) {
        this.filterManager = filterManager;
        var effectElements = this.filterManager.effectElements;
        var feComponentTransfer = createNS("feComponentTransfer"); // Red
        if (effectElements[10].p.k || effectElements[10].p.v !== 0 || effectElements[11].p.k || effectElements[11].p.v !== 1 || effectElements[12].p.k || effectElements[12].p.v !== 1 || effectElements[13].p.k || effectElements[13].p.v !== 0 || effectElements[14].p.k || effectElements[14].p.v !== 1) this.feFuncR = this.createFeFunc("feFuncR", feComponentTransfer);
         // Green
        if (effectElements[17].p.k || effectElements[17].p.v !== 0 || effectElements[18].p.k || effectElements[18].p.v !== 1 || effectElements[19].p.k || effectElements[19].p.v !== 1 || effectElements[20].p.k || effectElements[20].p.v !== 0 || effectElements[21].p.k || effectElements[21].p.v !== 1) this.feFuncG = this.createFeFunc("feFuncG", feComponentTransfer);
         // Blue
        if (effectElements[24].p.k || effectElements[24].p.v !== 0 || effectElements[25].p.k || effectElements[25].p.v !== 1 || effectElements[26].p.k || effectElements[26].p.v !== 1 || effectElements[27].p.k || effectElements[27].p.v !== 0 || effectElements[28].p.k || effectElements[28].p.v !== 1) this.feFuncB = this.createFeFunc("feFuncB", feComponentTransfer);
         // Alpha
        if (effectElements[31].p.k || effectElements[31].p.v !== 0 || effectElements[32].p.k || effectElements[32].p.v !== 1 || effectElements[33].p.k || effectElements[33].p.v !== 1 || effectElements[34].p.k || effectElements[34].p.v !== 0 || effectElements[35].p.k || effectElements[35].p.v !== 1) this.feFuncA = this.createFeFunc("feFuncA", feComponentTransfer);
         // RGB
        if (this.feFuncR || this.feFuncG || this.feFuncB || this.feFuncA) {
            feComponentTransfer.setAttribute("color-interpolation-filters", "sRGB");
            filter.appendChild(feComponentTransfer);
        }
        if (effectElements[3].p.k || effectElements[3].p.v !== 0 || effectElements[4].p.k || effectElements[4].p.v !== 1 || effectElements[5].p.k || effectElements[5].p.v !== 1 || effectElements[6].p.k || effectElements[6].p.v !== 0 || effectElements[7].p.k || effectElements[7].p.v !== 1) {
            feComponentTransfer = createNS("feComponentTransfer");
            feComponentTransfer.setAttribute("color-interpolation-filters", "sRGB");
            feComponentTransfer.setAttribute("result", id);
            filter.appendChild(feComponentTransfer);
            this.feFuncRComposed = this.createFeFunc("feFuncR", feComponentTransfer);
            this.feFuncGComposed = this.createFeFunc("feFuncG", feComponentTransfer);
            this.feFuncBComposed = this.createFeFunc("feFuncB", feComponentTransfer);
        }
    }
    SVGProLevelsFilter.prototype.createFeFunc = function(type, feComponentTransfer) {
        var feFunc = createNS(type);
        feFunc.setAttribute("type", "table");
        feComponentTransfer.appendChild(feFunc);
        return feFunc;
    };
    SVGProLevelsFilter.prototype.getTableValue = function(inputBlack, inputWhite, gamma, outputBlack, outputWhite) {
        var cnt = 0;
        var segments = 256;
        var perc;
        var min = Math.min(inputBlack, inputWhite);
        var max = Math.max(inputBlack, inputWhite);
        var table = Array.call(null, {
            length: segments
        });
        var colorValue;
        var pos = 0;
        var outputDelta = outputWhite - outputBlack;
        var inputDelta = inputWhite - inputBlack;
        while(cnt <= 256){
            perc = cnt / 256;
            if (perc <= min) colorValue = inputDelta < 0 ? outputWhite : outputBlack;
            else if (perc >= max) colorValue = inputDelta < 0 ? outputBlack : outputWhite;
            else colorValue = outputBlack + outputDelta * Math.pow((perc - inputBlack) / inputDelta, 1 / gamma);
            table[pos] = colorValue;
            pos += 1;
            cnt += 256 / (segments - 1);
        }
        return table.join(" ");
    };
    SVGProLevelsFilter.prototype.renderFrame = function(forceRender) {
        if (forceRender || this.filterManager._mdf) {
            var val;
            var effectElements = this.filterManager.effectElements;
            if (this.feFuncRComposed && (forceRender || effectElements[3].p._mdf || effectElements[4].p._mdf || effectElements[5].p._mdf || effectElements[6].p._mdf || effectElements[7].p._mdf)) {
                val = this.getTableValue(effectElements[3].p.v, effectElements[4].p.v, effectElements[5].p.v, effectElements[6].p.v, effectElements[7].p.v);
                this.feFuncRComposed.setAttribute("tableValues", val);
                this.feFuncGComposed.setAttribute("tableValues", val);
                this.feFuncBComposed.setAttribute("tableValues", val);
            }
            if (this.feFuncR && (forceRender || effectElements[10].p._mdf || effectElements[11].p._mdf || effectElements[12].p._mdf || effectElements[13].p._mdf || effectElements[14].p._mdf)) {
                val = this.getTableValue(effectElements[10].p.v, effectElements[11].p.v, effectElements[12].p.v, effectElements[13].p.v, effectElements[14].p.v);
                this.feFuncR.setAttribute("tableValues", val);
            }
            if (this.feFuncG && (forceRender || effectElements[17].p._mdf || effectElements[18].p._mdf || effectElements[19].p._mdf || effectElements[20].p._mdf || effectElements[21].p._mdf)) {
                val = this.getTableValue(effectElements[17].p.v, effectElements[18].p.v, effectElements[19].p.v, effectElements[20].p.v, effectElements[21].p.v);
                this.feFuncG.setAttribute("tableValues", val);
            }
            if (this.feFuncB && (forceRender || effectElements[24].p._mdf || effectElements[25].p._mdf || effectElements[26].p._mdf || effectElements[27].p._mdf || effectElements[28].p._mdf)) {
                val = this.getTableValue(effectElements[24].p.v, effectElements[25].p.v, effectElements[26].p.v, effectElements[27].p.v, effectElements[28].p.v);
                this.feFuncB.setAttribute("tableValues", val);
            }
            if (this.feFuncA && (forceRender || effectElements[31].p._mdf || effectElements[32].p._mdf || effectElements[33].p._mdf || effectElements[34].p._mdf || effectElements[35].p._mdf)) {
                val = this.getTableValue(effectElements[31].p.v, effectElements[32].p.v, effectElements[33].p.v, effectElements[34].p.v, effectElements[35].p.v);
                this.feFuncA.setAttribute("tableValues", val);
            }
        }
    };
    function SVGDropShadowEffect(filter, filterManager, elem, id, source) {
        var globalFilterSize = filterManager.container.globalData.renderConfig.filterSize;
        var filterSize = filterManager.data.fs || globalFilterSize;
        filter.setAttribute("x", filterSize.x || globalFilterSize.x);
        filter.setAttribute("y", filterSize.y || globalFilterSize.y);
        filter.setAttribute("width", filterSize.width || globalFilterSize.width);
        filter.setAttribute("height", filterSize.height || globalFilterSize.height);
        this.filterManager = filterManager;
        var feGaussianBlur = createNS("feGaussianBlur");
        feGaussianBlur.setAttribute("in", "SourceAlpha");
        feGaussianBlur.setAttribute("result", id + "_drop_shadow_1");
        feGaussianBlur.setAttribute("stdDeviation", "0");
        this.feGaussianBlur = feGaussianBlur;
        filter.appendChild(feGaussianBlur);
        var feOffset = createNS("feOffset");
        feOffset.setAttribute("dx", "25");
        feOffset.setAttribute("dy", "0");
        feOffset.setAttribute("in", id + "_drop_shadow_1");
        feOffset.setAttribute("result", id + "_drop_shadow_2");
        this.feOffset = feOffset;
        filter.appendChild(feOffset);
        var feFlood = createNS("feFlood");
        feFlood.setAttribute("flood-color", "#00ff00");
        feFlood.setAttribute("flood-opacity", "1");
        feFlood.setAttribute("result", id + "_drop_shadow_3");
        this.feFlood = feFlood;
        filter.appendChild(feFlood);
        var feComposite = createNS("feComposite");
        feComposite.setAttribute("in", id + "_drop_shadow_3");
        feComposite.setAttribute("in2", id + "_drop_shadow_2");
        feComposite.setAttribute("operator", "in");
        feComposite.setAttribute("result", id + "_drop_shadow_4");
        filter.appendChild(feComposite);
        var feMerge = this.createMergeNode(id, [
            id + "_drop_shadow_4",
            source
        ]);
        filter.appendChild(feMerge); //
    }
    extendPrototype([
        SVGComposableEffect
    ], SVGDropShadowEffect);
    SVGDropShadowEffect.prototype.renderFrame = function(forceRender) {
        if (forceRender || this.filterManager._mdf) {
            if (forceRender || this.filterManager.effectElements[4].p._mdf) this.feGaussianBlur.setAttribute("stdDeviation", this.filterManager.effectElements[4].p.v / 4);
            if (forceRender || this.filterManager.effectElements[0].p._mdf) {
                var col = this.filterManager.effectElements[0].p.v;
                this.feFlood.setAttribute("flood-color", rgbToHex(Math.round(col[0] * 255), Math.round(col[1] * 255), Math.round(col[2] * 255)));
            }
            if (forceRender || this.filterManager.effectElements[1].p._mdf) this.feFlood.setAttribute("flood-opacity", this.filterManager.effectElements[1].p.v / 255);
            if (forceRender || this.filterManager.effectElements[2].p._mdf || this.filterManager.effectElements[3].p._mdf) {
                var distance = this.filterManager.effectElements[3].p.v;
                var angle = (this.filterManager.effectElements[2].p.v - 90) * degToRads;
                var x = distance * Math.cos(angle);
                var y = distance * Math.sin(angle);
                this.feOffset.setAttribute("dx", x);
                this.feOffset.setAttribute("dy", y);
            }
        }
    };
    var _svgMatteSymbols = [];
    function SVGMatte3Effect(filterElem, filterManager, elem) {
        this.initialized = false;
        this.filterManager = filterManager;
        this.filterElem = filterElem;
        this.elem = elem;
        elem.matteElement = createNS("g");
        elem.matteElement.appendChild(elem.layerElement);
        elem.matteElement.appendChild(elem.transformedElement);
        elem.baseElement = elem.matteElement;
    }
    SVGMatte3Effect.prototype.findSymbol = function(mask) {
        var i = 0;
        var len = _svgMatteSymbols.length;
        while(i < len){
            if (_svgMatteSymbols[i] === mask) return _svgMatteSymbols[i];
            i += 1;
        }
        return null;
    };
    SVGMatte3Effect.prototype.replaceInParent = function(mask, symbolId) {
        var parentNode = mask.layerElement.parentNode;
        if (!parentNode) return;
        var children = parentNode.children;
        var i = 0;
        var len = children.length;
        while(i < len){
            if (children[i] === mask.layerElement) break;
            i += 1;
        }
        var nextChild;
        if (i <= len - 2) nextChild = children[i + 1];
        var useElem = createNS("use");
        useElem.setAttribute("href", "#" + symbolId);
        if (nextChild) parentNode.insertBefore(useElem, nextChild);
        else parentNode.appendChild(useElem);
    };
    SVGMatte3Effect.prototype.setElementAsMask = function(elem, mask) {
        if (!this.findSymbol(mask)) {
            var symbolId = createElementID();
            var masker = createNS("mask");
            masker.setAttribute("id", mask.layerId);
            masker.setAttribute("mask-type", "alpha");
            _svgMatteSymbols.push(mask);
            var defs = elem.globalData.defs;
            defs.appendChild(masker);
            var symbol = createNS("symbol");
            symbol.setAttribute("id", symbolId);
            this.replaceInParent(mask, symbolId);
            symbol.appendChild(mask.layerElement);
            defs.appendChild(symbol);
            var useElem = createNS("use");
            useElem.setAttribute("href", "#" + symbolId);
            masker.appendChild(useElem);
            mask.data.hd = false;
            mask.show();
        }
        elem.setMatte(mask.layerId);
    };
    SVGMatte3Effect.prototype.initialize = function() {
        var ind = this.filterManager.effectElements[0].p.v;
        var elements = this.elem.comp.elements;
        var i = 0;
        var len = elements.length;
        while(i < len){
            if (elements[i] && elements[i].data.ind === ind) this.setElementAsMask(this.elem, elements[i]);
            i += 1;
        }
        this.initialized = true;
    };
    SVGMatte3Effect.prototype.renderFrame = function() {
        if (!this.initialized) this.initialize();
    };
    function SVGGaussianBlurEffect(filter, filterManager, elem, id) {
        // Outset the filter region by 100% on all sides to accommodate blur expansion.
        filter.setAttribute("x", "-100%");
        filter.setAttribute("y", "-100%");
        filter.setAttribute("width", "300%");
        filter.setAttribute("height", "300%");
        this.filterManager = filterManager;
        var feGaussianBlur = createNS("feGaussianBlur");
        feGaussianBlur.setAttribute("result", id);
        filter.appendChild(feGaussianBlur);
        this.feGaussianBlur = feGaussianBlur;
    }
    SVGGaussianBlurEffect.prototype.renderFrame = function(forceRender) {
        if (forceRender || this.filterManager._mdf) {
            // Empirical value, matching AE's blur appearance.
            var kBlurrinessToSigma = 0.3;
            var sigma = this.filterManager.effectElements[0].p.v * kBlurrinessToSigma; // Dimensions mapping:
            //
            //   1 -> horizontal & vertical
            //   2 -> horizontal only
            //   3 -> vertical only
            //
            var dimensions = this.filterManager.effectElements[1].p.v;
            var sigmaX = dimensions == 3 ? 0 : sigma; // eslint-disable-line eqeqeq
            var sigmaY = dimensions == 2 ? 0 : sigma; // eslint-disable-line eqeqeq
            this.feGaussianBlur.setAttribute("stdDeviation", sigmaX + " " + sigmaY); // Repeat edges mapping:
            //
            //   0 -> off -> duplicate
            //   1 -> on  -> wrap
            var edgeMode = this.filterManager.effectElements[2].p.v == 1 ? "wrap" : "duplicate"; // eslint-disable-line eqeqeq
            this.feGaussianBlur.setAttribute("edgeMode", edgeMode);
        }
    };
    function TransformEffect() {}
    TransformEffect.prototype.init = function(effectsManager) {
        this.effectsManager = effectsManager;
        this.type = effectTypes.TRANSFORM_EFFECT;
        this.matrix = new Matrix();
        this.opacity = -1;
        this._mdf = false;
        this._opMdf = false;
    };
    TransformEffect.prototype.renderFrame = function(forceFrame) {
        this._opMdf = false;
        this._mdf = false;
        if (forceFrame || this.effectsManager._mdf) {
            var effectElements = this.effectsManager.effectElements;
            var anchor = effectElements[0].p.v;
            var position = effectElements[1].p.v;
            var isUniformScale = effectElements[2].p.v === 1;
            var scaleHeight = effectElements[3].p.v;
            var scaleWidth = isUniformScale ? scaleHeight : effectElements[4].p.v;
            var skew = effectElements[5].p.v;
            var skewAxis = effectElements[6].p.v;
            var rotation = effectElements[7].p.v;
            this.matrix.reset();
            this.matrix.translate(-anchor[0], -anchor[1], anchor[2]);
            this.matrix.scale(scaleWidth * 0.01, scaleHeight * 0.01, 1);
            this.matrix.rotate(-rotation * degToRads);
            this.matrix.skewFromAxis(-skew * degToRads, (skewAxis + 90) * degToRads);
            this.matrix.translate(position[0], position[1], 0);
            this._mdf = true;
            if (this.opacity !== effectElements[8].p.v) {
                this.opacity = effectElements[8].p.v;
                this._opMdf = true;
            }
        }
    };
    function SVGTransformEffect(_, filterManager) {
        this.init(filterManager);
    }
    extendPrototype([
        TransformEffect
    ], SVGTransformEffect);
    function CVTransformEffect(effectsManager) {
        this.init(effectsManager);
    }
    extendPrototype([
        TransformEffect
    ], CVTransformEffect);
    registerRenderer("canvas", CanvasRenderer);
    registerRenderer("html", HybridRenderer);
    registerRenderer("svg", SVGRenderer); // Registering shape modifiers
    ShapeModifiers.registerModifier("tm", TrimModifier);
    ShapeModifiers.registerModifier("pb", PuckerAndBloatModifier);
    ShapeModifiers.registerModifier("rp", RepeaterModifier);
    ShapeModifiers.registerModifier("rd", RoundCornersModifier);
    ShapeModifiers.registerModifier("zz", ZigZagModifier);
    ShapeModifiers.registerModifier("op", OffsetPathModifier); // Registering expression plugin
    setExpressionsPlugin(Expressions);
    setExpressionInterfaces(getInterface);
    initialize$1();
    initialize(); // Registering svg effects
    registerEffect$1(20, SVGTintFilter, true);
    registerEffect$1(21, SVGFillFilter, true);
    registerEffect$1(22, SVGStrokeEffect, false);
    registerEffect$1(23, SVGTritoneFilter, true);
    registerEffect$1(24, SVGProLevelsFilter, true);
    registerEffect$1(25, SVGDropShadowEffect, true);
    registerEffect$1(28, SVGMatte3Effect, false);
    registerEffect$1(29, SVGGaussianBlurEffect, true);
    registerEffect$1(35, SVGTransformEffect, false);
    registerEffect(35, CVTransformEffect);
    return lottie;
});

});




parcelRegister("1y435", function(module, exports) {

$parcel$export(module.exports, "RefView", function () { return $120c1b6701a10e38$export$f2332e7a93e14147; });

var $4vwom = parcelRequire("4vwom");

var $eeH7J = parcelRequire("eeH7J");
parcelRequire("2LTO8");
var $8h5s0 = parcelRequire("8h5s0");
var $cwhCA = parcelRequire("cwhCA");
var $43jhg = parcelRequire("43jhg");

var $9HOw2 = parcelRequire("9HOw2");

var $hRViu = parcelRequire("hRViu");

var $9SFXB = parcelRequire("9SFXB");

var $4rY0U = parcelRequire("4rY0U");

var $3aX8U = parcelRequire("3aX8U");

var $7c6pE = parcelRequire("7c6pE");

var $aCefG = parcelRequire("aCefG");

var $hV5w0 = parcelRequire("hV5w0");

var $eBaY3 = parcelRequire("eBaY3");

var $fz3r9 = parcelRequire("fz3r9");

var $8vTN8 = parcelRequire("8vTN8");

var $ikBJm = parcelRequire("ikBJm");

var $cSf8f = parcelRequire("cSf8f");

var $9Q5xE = parcelRequire("9Q5xE");

var $dUDPg = parcelRequire("dUDPg");

var $1TOtF = parcelRequire("1TOtF");

var $1aVVn = parcelRequire("1aVVn");

var $1nizI = parcelRequire("1nizI");
function $120c1b6701a10e38$export$f2332e7a93e14147(props) {
    var _a;
    const value = (0, $1aVVn.YTools).valueToJSON((0, $1aVVn.YTools).get(props.obj, props.property.name));
    const validationError = (0, $43jhg.MatchesType)(value, props.property.type) !== true;
    const isReadonly = (0, $eBaY3.useIsReadonlyField)(props.property, validationError);
    return (0, $4vwom.jsx)((0, $hRViu.PropRow), {
        isReadonly: isReadonly,
        label: (_a = props.label) !== null && _a !== void 0 ? _a : !isNaN(parseInt(props.property.name)) ? undefined : (0, $8h5s0.prettyCamel)(props.property.name),
        buttons: props.buttons,
        description: props.property.description,
        badge: (0, $4vwom.jsx)((0, $9HOw2.DiagnosticView), {
            value: value,
            property: props.property
        }),
        isEmbedded: props.isEmbedded,
        children: (0, $4vwom.jsx)($120c1b6701a10e38$export$f514d6bf7f50c773, Object.assign({
            isReadonly: isReadonly
        }, props))
    });
}
function $120c1b6701a10e38$export$f514d6bf7f50c773({ obj: obj, property: property, isEmbedded: isEmbedded, isReadonly: isReadonly }) {
    var _a, _b, _c, _d, _e, _f, _g;
    const [value, setValue] = (0, $1aVVn.useYState)(obj, property.name);
    const { hover: hover, hoverProps: hoverProps } = (0, $fz3r9.useHover)();
    const navigate = (0, $8vTN8.useNavigate)();
    const listContext = (0, $eeH7J.useContext)((0, $aCefG.ListContext));
    const wc = (0, $eeH7J.useContext)((0, $hV5w0.WidgetContext));
    const doc = (0, $1TOtF.useDocument)();
    const docRefs = (0, $1TOtF.useDocumentRefs)();
    const docType = (0, $1TOtF.useDocumentType)();
    const reference = typeof property.type === "object" ? property.type.reference : undefined;
    if (!reference) return (0, $4vwom.jsx)("div", {
        children: "No reference info available"
    });
    /** References picked from picker */ const [refCache] = (0, $eeH7J.useState)({});
    const itemType = (0, $cwhCA.GetType)(reference.typeName);
    const itemName = typeof itemType === "object" ? (_b = (_a = itemType.tags) === null || _a === void 0 ? void 0 : _a.translation) !== null && _b !== void 0 ? _b : {
        en: (_c = itemType.alias) !== null && _c !== void 0 ? _c : reference.typeName
    } : {
        en: reference.typeName
    };
    const refCollection = (0, $cwhCA.GetReflectionInfo)().collections.find((c)=>(0, $43jhg.GetTypeAlias)(c.type.typeArgs[0]) === reference.typeName);
    const optionsFunc = ((_d = property.tags) === null || _d === void 0 ? void 0 : _d.options) || (listContext === null || listContext === void 0 ? void 0 : listContext.optionsFunc);
    function tryGetWidgetFromDocumentContext() {
        if (!reference) return undefined;
        const refs = docRefs !== null && docRefs !== void 0 ? docRefs : {};
        if (!refCollection && !optionsFunc) return (0, $4vwom.jsx)("div", {
            children: "No valid source collection or options specified"
        });
        let refType = refs[reference.typeName];
        if (!refType) refType = refs[reference.typeName] = {};
        let refField = refType ? refType[reference.fieldName] : undefined;
        if (!refField) refField = refType[reference.fieldName] = {};
        const refWidget = (refField ? refField[value] : undefined) || refCache[value];
        return refWidget ? (0, $9SFXB.ExtractPrimaryItemFromWidget)(refWidget) : value;
    }
    let widget = tryGetWidgetFromDocumentContext();
    // If there is no document context to get a pre-rendered widget from, let's
    // do a fallback rendering of the widget with an extra API call.
    // This is not the default since there is potentially hundreds of references
    // in a document, and we don't want to make hundreds of API calls.
    const fallbackWidget = (0, $dUDPg.useDocumentObjectView)(typeof widget === "object" || !value || typeof value !== "string" ? null // Don't call if we don't have to, disable the hook by passing null
     : {
        objects: [
            {
                obj: value,
                typeAlias: reference.typeName
            }
        ]
    });
    if ((_e = fallbackWidget.data) === null || _e === void 0 ? void 0 : _e.views[0]) widget = (_f = fallbackWidget.data) === null || _f === void 0 ? void 0 : _f.views[0];
    const isInternalRef = !refCollection;
    const undefinedPlaceholder = ((_g = property.tags) === null || _g === void 0 ? void 0 : _g.placeholder) || "";
    return (0, $4vwom.jsxs)("div", Object.assign({}, hoverProps, {
        className: isEmbedded ? undefined : "form-control",
        style: {
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            paddingTop: 8,
            paddingBottom: 8,
            paddingLeft: isEmbedded ? 12 : undefined
        },
        children: [
            widget && (0, $4vwom.jsxs)("div", {
                style: {
                    flex: 1,
                    position: "relative"
                },
                title: isInternalRef ? `This is a reference to a ${(0, $8h5s0.prettyCamel)(reference.typeName, false)} inside this ${(0, $8h5s0.prettyCamel)(docType && (0, $43jhg.GetTypeAlias)(docType) || "document", false)}.` : undefined,
                children: [
                    isInternalRef && (0, $4vwom.jsx)("i", {
                        className: "fas fa-external-link-square",
                        style: {
                            position: "absolute",
                            color: (0, $9Q5xE.ColorStyles)["gray-cool"][600],
                            fontSize: 12,
                            bottom: 0,
                            top: 28,
                            height: 12,
                            borderRadius: 2,
                            backgroundColor: (0, $9Q5xE.ColorStyles)["gray-cool"][100]
                        }
                    }),
                    (0, $4vwom.jsx)((0, $4rY0U.WidgetView), {
                        value: widget
                    })
                ]
            }),
            value === undefined && undefinedPlaceholder && (0, $4vwom.jsx)("div", {
                style: {
                    marginRight: 16
                },
                children: undefinedPlaceholder
            }),
            (!value || hover) && !isReadonly && (0, $4vwom.jsx)((0, $3aX8U.ButtonWidget), {
                action: ChangeOrSpecify,
                text: value ? (0, $cSf8f.Translations).Change() : (0, $cSf8f.Translations).Specify()
            }),
            value && hover && refCollection && (0, $4vwom.jsx)((0, $3aX8U.ButtonWidget), {
                action: ()=>navigate(`/studio/${refCollection.name}/${value}`),
                text: (0, $cSf8f.Translations).Open()
            })
        ]
    }));
    function ChangeOrSpecify() {
        if (!reference) return;
        return (0, $ikBJm.Modal)((close)=>(0, $4vwom.jsx)((0, $7c6pE.DocumentPicker), {
                collection: optionsFunc !== null && optionsFunc !== void 0 ? optionsFunc : (0, $8h5s0.Assert)(refCollection).name,
                obj: obj,
                document: doc,
                current: widget,
                refKey: reference.fieldName,
                itemName: itemName,
                itemSelected: (row, scope)=>{
                    const fieldValue = row._refKey;
                    // Put the new row in the widget cache
                    refCache[fieldValue] = row;
                    // Update the document
                    if (scope === "only-this") {
                        if (value !== fieldValue) {
                            setValue(fieldValue);
                            // Changing a reference tend to affect available options, so
                            // let's refresh the document metadata
                            wc === null || wc === void 0 || wc.refresh();
                        }
                    } else if (scope === "all-in-document") {
                        if (!doc) throw new Error("No document!");
                        if (!docType) throw new Error("No type!");
                        let count = 0;
                        (0, $1nizI.ReplaceValuesByTypeYTools)(doc, docType, (v, type)=>{
                            if (typeof type === "object" && "reference" in type) {
                                if (v === value) {
                                    count++;
                                    return fieldValue;
                                }
                            }
                            return v;
                        });
                        if (count > 0) wc === null || wc === void 0 || wc.refresh();
                        alert((0, $cSf8f.Translations).ReplacedXReferences(count));
                    } else throw new Error("Unknown scope: " + scope);
                    close();
                },
                cancel: close
            }));
    }
}

});
parcelRegister("aCefG", function(module, exports) {

$parcel$export(module.exports, "CollapseContext", function () { return $7ba8821ee95b3438$export$e8c4ae7c9501d8d2; });
$parcel$export(module.exports, "ListContext", function () { return $7ba8821ee95b3438$export$52411773e0d6f15d; });

var $eeH7J = parcelRequire("eeH7J");
const $7ba8821ee95b3438$export$e8c4ae7c9501d8d2 = /*#__PURE__*/ (0, $eeH7J.createContext)({
    collapse () {}
});
const $7ba8821ee95b3438$export$52411773e0d6f15d = /*#__PURE__*/ (0, $eeH7J.createContext)(null);

});

parcelRegister("1nizI", function(module, exports) {

$parcel$export(module.exports, "ReplaceValuesByTypeYTools", function () { return $10065909718cc628$export$c1af5d9706f682da; });

var $43jhg = parcelRequire("43jhg");

var $cwhCA = parcelRequire("cwhCA");

var $1aVVn = parcelRequire("1aVVn");

var $aw3rr = parcelRequire("aw3rr");
function $10065909718cc628$export$c1af5d9706f682da(value, type, /** Returns the new value to replace the existing one with.
 *  Return the incoming `value` to leave it unchanged.
 */ replacer, visitedObjects = new Set(), path = []) {
    // Fallback to the original implementation if value isn't from Y.js.
    if (!(value instanceof $aw3rr.Array || value instanceof $aw3rr.Map)) return (0, $43jhg.ReplaceValuesByType)(value, type, replacer, visitedObjects, path);
    const dt = (0, $cwhCA.SubstituteAndDiscriminate)((0, $1aVVn.YTools).valueToJSON(value), type);
    if (dt !== type) return $10065909718cc628$export$c1af5d9706f682da(value, dt, replacer, visitedObjects, path);
    value = replacer(value, type, path);
    if ((0, $43jhg.IsObjectType)(type) || (0, $43jhg.IsIntersectionType)(type)) {
        if (visitedObjects.has(value)) return value;
        visitedObjects.add(value);
        const props = (0, $43jhg.GetTypeProps)(type);
        props.forEach((x)=>{
            const oldValue = (0, $1aVVn.YTools).get(value, x.name);
            const newValue = $10065909718cc628$export$c1af5d9706f682da(oldValue, x.type, replacer, visitedObjects, [
                ...path,
                x.name
            ]);
            if (newValue !== oldValue) (0, $1aVVn.YTools).set(value, x.name, newValue);
        });
        if ((0, $43jhg.IsObjectType)(type)) {
            const { additionalProps: additionalProps } = type;
            if (additionalProps) {
                for (const key of value.keys())if (!type.props.some((x)=>x.name === key)) {
                    const oldValue = (0, $1aVVn.YTools).get(value, key);
                    const newValue = $10065909718cc628$export$c1af5d9706f682da(oldValue, additionalProps, replacer, visitedObjects, [
                        ...path,
                        key
                    ]);
                    if (newValue !== oldValue) (0, $1aVVn.YTools).set(value, key, newValue);
                }
            }
        }
    } else if ((0, $43jhg.IsArrayType)(type)) {
        if (visitedObjects.has(value)) return value;
        visitedObjects.add(value);
        for(let i = 0; i < value.length; i++){
            const oldValue = (0, $1aVVn.YTools).get(value, i);
            const newValue = $10065909718cc628$export$c1af5d9706f682da(oldValue, type.array, replacer, visitedObjects, [
                ...path,
                i
            ]);
            if (newValue !== oldValue) (0, $1aVVn.YTools).set(value, i, newValue);
        }
    }
    return value;
}

});


parcelRegister("eXq7x", function(module, exports) {

$parcel$export(module.exports, "BooleanView", function () { return $ae3ad6675e1a9607$export$9389491219a7c749; });

var $4vwom = parcelRequire("4vwom");

var $eeH7J = parcelRequire("eeH7J");

var $9HOw2 = parcelRequire("9HOw2");

var $hRViu = parcelRequire("hRViu");

var $eF5Lx = parcelRequire("eF5Lx");

var $eBaY3 = parcelRequire("eBaY3");

var $djnHd = parcelRequire("djnHd");

var $1aVVn = parcelRequire("1aVVn");
function $ae3ad6675e1a9607$export$9389491219a7c749({ obj: obj, buttons: buttons, property: property, label: label }) {
    const { error: error } = (0, $eeH7J.useContext)((0, $eF5Lx.ErrorContext));
    const [value, setValue] = (0, $1aVVn.useYState)(obj, property.name);
    const isReadonly = (0, $eBaY3.useIsReadonlyField)(property);
    return (0, $4vwom.jsx)((0, $hRViu.PropRow), {
        isReadonly: isReadonly,
        label: label,
        buttons: buttons,
        description: property.description,
        childrenInBadge: true,
        children: (0, $4vwom.jsxs)("div", {
            style: {
                flex: 1,
                backgroundColor: error ? "#f004" : undefined,
                marginTop: 4
            },
            children: [
                !isReadonly && (0, $4vwom.jsx)((0, $djnHd.ToggleWidget), {
                    value: value,
                    onChanged: (v)=>{
                        setValue(v);
                    }
                }),
                isReadonly && (0, $4vwom.jsx)("div", {
                    children: JSON.stringify(value)
                }),
                (0, $4vwom.jsx)((0, $9HOw2.DiagnosticView), {
                    value: value,
                    property: property
                })
            ]
        })
    });
}

});
parcelRegister("djnHd", function(module, exports) {

$parcel$export(module.exports, "ToggleWidget", function () { return $9b0f6e417139d240$export$625d12976a9324fa; });

var $4vwom = parcelRequire("4vwom");

var $eeH7J = parcelRequire("eeH7J");

var $fz3r9 = parcelRequire("fz3r9");

var $hV5w0 = parcelRequire("hV5w0");

var $4rY0U = parcelRequire("4rY0U");

var $9Q5xE = parcelRequire("9Q5xE");
(0, $4rY0U.RegisterWidget)("Toggle", ({ value: value })=>(0, $4vwom.jsx)($9b0f6e417139d240$export$625d12976a9324fa, Object.assign({}, value)));
function $9b0f6e417139d240$export$625d12976a9324fa({ value: value, onChanged: onChanged, style: style, label: label, widgetKey: widgetKey }) {
    const performAction = (0, $hV5w0.usePerformWidgetAction)();
    const { hover: hover, hoverProps: hoverProps } = (0, $fz3r9.useHover)();
    const [busy, setBusy] = (0, $eeH7J.useState)(false);
    const color = !value ? hover ? (0, $9Q5xE.ColorStyles).primary[900] : (0, $9Q5xE.ColorStyles).gray[100] : hover ? (0, $9Q5xE.ColorStyles).primary[900] : (0, $9Q5xE.ColorStyles).primary[700];
    return (0, $4vwom.jsxs)("div", Object.assign({
        className: "hide-in-print"
    }, hoverProps, {
        onClick: async (e)=>{
            e.stopPropagation();
            try {
                if (onChanged instanceof Function) onChanged(!value);
                else if (widgetKey) {
                    setBusy(true);
                    await performAction(widgetKey, "onChanged", [
                        !value
                    ], ()=>setBusy(false));
                } else console.log("No action specified");
            } catch (error) {
                alert("detail" in error ? error.detail : JSON.stringify(error));
            } finally{
                setBusy(false);
            }
        },
        style: Object.assign({
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            color: hover ? color : undefined
        }, style),
        children: [
            label && (0, $4vwom.jsx)("span", {
                style: {
                    fontSize: 11,
                    marginRight: "1rem"
                },
                children: label
            }),
            (0, $4vwom.jsx)("div", {
                children: (0, $4vwom.jsx)("div", {
                    style: {
                        width: 44,
                        maxWidth: 44,
                        maxHeight: 24,
                        borderRadius: 12,
                        boxSizing: "border-box",
                        padding: 2,
                        backgroundColor: color
                    },
                    children: (0, $4vwom.jsx)("div", {
                        style: {
                            marginLeft: value ? 20 : 0,
                            width: 20,
                            height: 20,
                            borderRadius: 10,
                            boxSizing: "border-box",
                            backgroundColor: "white",
                            boxShadow: "0px 1px 2px 0px #1018280F"
                        }
                    })
                })
            })
        ]
    }));
}

});


parcelRegister("6sxDY", function(module, exports) {

$parcel$export(module.exports, "UnionView", function () { return $4b3f748fa94a0710$export$9cc4561ecf1f931d; });

var $4vwom = parcelRequire("4vwom");

var $eeH7J = parcelRequire("eeH7J");

var $43jhg = parcelRequire("43jhg");

var $5c9Ym = parcelRequire("5c9Ym");

var $6cx8r = parcelRequire("6cx8r");

var $hRViu = parcelRequire("hRViu");

var $fT6Pt = parcelRequire("fT6Pt");

var $8h5s0 = parcelRequire("8h5s0");

var $9HOw2 = parcelRequire("9HOw2");

var $eF5Lx = parcelRequire("eF5Lx");

var $eBaY3 = parcelRequire("eBaY3");

var $cwhCA = parcelRequire("cwhCA");

var $2tM8G = parcelRequire("2tM8G");

var $cSf8f = parcelRequire("cSf8f");

var $9Q5xE = parcelRequire("9Q5xE");

var $1TOtF = parcelRequire("1TOtF");

var $1aVVn = parcelRequire("1aVVn");

var $dUDPg = parcelRequire("dUDPg");
function $4b3f748fa94a0710$export$9cc4561ecf1f931d({ obj: obj, property: property, label: label, buttons: buttons, mode: mode, isEmbedded: isEmbedded }) {
    var _a, _b, _c;
    const optionsAttr = (_a = property.tags) === null || _a === void 0 ? void 0 : _a.options;
    if (optionsAttr) return (0, $2tM8G.StringView)({
        obj: obj,
        property: property,
        label: label,
        buttons: buttons
    });
    const refresh = (0, $1TOtF.useDocumentRefresh)();
    const [show, setShow] = (0, $eeH7J.useState)(!label || ((_b = property.tags) === null || _b === void 0 ? void 0 : _b.expand));
    const [value, setValue] = (0, $1aVVn.useYState)(obj, property.name);
    const { error: error } = (0, $eeH7J.useContext)((0, $eF5Lx.ErrorContext));
    const optional = !!property.optional;
    let type = property.type;
    if (!(0, $43jhg.IsUnionType)(type)) throw new Error("UnionView must have union type property");
    if (optional && !(0, $43jhg.AreTypesAssignable)(type, (0, $43jhg.UndefinedType))) type = (0, $43jhg.UnionType)(type, (0, $43jhg.UndefinedType));
    const options = [];
    function findOptions(u) {
        if ((0, $43jhg.IsUnionType)(u)) u.union.forEach(findOptions);
        else options.push(u);
    }
    findOptions(type);
    const valueJson = (0, $1aVVn.YTools).valueToJSON(value);
    const matches = options.map((x)=>(0, $43jhg.MatchesType)(valueJson, x, true, false, false));
    // Score matches so more specific types win over less specific types
    let bestMatch = -1;
    let bestScore = 0;
    for(let i = 0; i < matches.length; i++)if (matches[i] === true) {
        let score = 1;
        if ((0, $43jhg.IsStringLiteral)(options[i])) score = 2;
        if ((0, $43jhg.IsNumberLiteral)(options[i])) score = 2;
        if ((0, $43jhg.IsBooleanLiteral)(options[i])) score = 2;
        if (score > bestScore) {
            bestScore = score;
            bestMatch = i;
        }
    }
    let valueIndex = bestMatch;
    if (valueIndex === -1) {
        const dt = (0, $cwhCA.SubstituteAndDiscriminate)(valueJson, type);
        if (dt !== type) {
            valueIndex = options.indexOf(dt);
            if (valueIndex === -1) valueIndex = options.findIndex((opt)=>(0, $43jhg.AreTypesAssignable)(opt, dt));
        }
    }
    const [explicitTypeIndex, setExplicitTypeIndex] = (0, $eeH7J.useState)(undefined);
    const typeIndex = explicitTypeIndex !== undefined ? explicitTypeIndex : valueIndex;
    const guessedType = explicitTypeIndex !== -1 ? options[typeIndex] : undefined;
    const undefinedPlaceholder = ((_c = property.tags) === null || _c === void 0 ? void 0 : _c.placeholder) || "";
    const niceOptions = options.map((x)=>{
        var _a;
        if (typeof x === "object" && x.tags) {
            const trans = x.tags.translation;
            if (trans) {
                (_a = trans.en) !== null && _a !== void 0 ? _a : trans.en = (0, $43jhg.TypeToString)(x)// remove leading and trailing quotes
                .replace(/^"(.*)"$/, "$1");
                return (0, $8h5s0.prettyCamel)((0, $cSf8f.ClientSideLocalize)(trans));
            }
        }
        return typeof x === "object" && "string" in x && x.string !== null ? (0, $8h5s0.prettyCamel)(x.string) : (0, $8h5s0.prettyCamel)(x === "undefined" ? undefinedPlaceholder : (0, $43jhg.TypeToString)(x));
    });
    const isReadonly = (0, $eBaY3.useIsReadonlyField)(property);
    const optionIndex = typeIndex === -1 ? niceOptions.length : typeIndex;
    const selector = isReadonly ? (0, $4vwom.jsx)("div", {
        style: {
            color: (0, $9Q5xE.ColorStyles).gray[900],
            padding: 8,
            paddingLeft: 12,
            width: "100%",
            borderColor: (0, $9Q5xE.ColorStyles).gray[300],
            borderStyle: "solid",
            borderWidth: 1,
            borderRadius: 8
        },
        children: typeof valueJson === "object" ? niceOptions[optionIndex] : (0, $8h5s0.prettyCamel)(valueJson)
    }) : (0, $4vwom.jsxs)("select", {
        className: "form-select",
        style: {
            backgroundColor: error ? (0, $9Q5xE.ColorStyles).error[300] : "white",
            borderWidth: 1,
            borderColor: (0, $9Q5xE.ColorStyles).gray[300],
            color: (0, $9Q5xE.ColorStyles).gray[700],
            flex: 1,
            margin: 0
        },
        disabled: isReadonly,
        onChange: (x)=>{
            const i = parseInt(x.target.value);
            const def = (0, $5c9Ym.CreateDefault)(options[i]);
            setValue((0, $1aVVn.YTools).valueToYValue(def));
            setExplicitTypeIndex(i);
            setShow(true);
            if (refresh) refresh();
            const alias = (0, $43jhg.GetTypeAlias)(options[i]);
            if (alias) (0, $dUDPg.postDocumentDefaults)({
                typeName: alias
            }).then((res)=>{
                setValue((0, $1aVVn.YTools).valueToYValue(res));
                if (refresh) setTimeout(refresh, 100);
            });
        },
        value: typeIndex === -1 ? niceOptions.length : typeIndex,
        children: [
            niceOptions.map((x, i)=>(0, $4vwom.jsx)("option", {
                    value: i,
                    children: x
                }, i)),
            typeIndex === -1 ? (0, $4vwom.jsx)("option", {
                value: niceOptions.length,
                children: "Please select..."
            }, "undefined") : (0, $4vwom.jsx)((0, $4vwom.Fragment), {})
        ]
    });
    const isBinary = (0, $43jhg.IsTypeOrUndefined)(type, (x)=>!(0, $43jhg.IsUnionType)(x));
    isBinary;
    const diagnostic = (0, $4vwom.jsx)((0, $9HOw2.DiagnosticView), {
        property: property,
        value: valueJson,
        noSubtree: !guessedType,
        overrideText: !guessedType ? "Required." : undefined
    });
    return !guessedType || (0, $43jhg.IsLiteralType)(guessedType) ? (0, $4vwom.jsx)((0, $hRViu.PropRow), {
        label: label,
        description: property.description,
        buttons: buttons,
        isEmbedded: isEmbedded,
        badge: diagnostic,
        children: selector
    }) : (0, $4vwom.jsxs)("div", {
        children: [
            !isBinary && (0, $4vwom.jsx)((0, $hRViu.PropRow), {
                label: label,
                description: property.description,
                isEmbedded: isEmbedded,
                buttons: buttons,
                children: (0, $4vwom.jsxs)("div", {
                    style: {
                        display: "flex",
                        flexDirection: "row"
                    },
                    children: [
                        selector,
                        (0, $4vwom.jsx)((0, $fT6Pt.RButton), {
                            active: show,
                            variant: "secondary",
                            onClick: ()=>setShow(!show),
                            children: !show ? (0, $cSf8f.Strings).Show : (0, $cSf8f.Strings).Hide
                        })
                    ]
                })
            }),
            (isBinary || show) && (0, $4vwom.jsx)((0, $6cx8r.PropView), {
                mode: mode,
                obj: obj,
                property: Object.assign(Object.assign({}, property), {
                    optional: false,
                    type: guessedType,
                    description: undefined
                }),
                buttons: [],
                isEmbedded: true
            }),
            diagnostic
        ]
    });
}

});

parcelRegister("KiyG5", function(module, exports) {

$parcel$export(module.exports, "FileView", function () { return $08b2b149dc41d983$export$72e4c5c1c0102f6d; });

var $4vwom = parcelRequire("4vwom");

var $eeH7J = parcelRequire("eeH7J");

var $14q7s = parcelRequire("14q7s");

var $hRViu = parcelRequire("hRViu");

var $cniWT = parcelRequire("cniWT");

var $9HOw2 = parcelRequire("9HOw2");

var $6sp4J = parcelRequire("6sp4J");

var $7c6pE = parcelRequire("7c6pE");

var $2vh9S = parcelRequire("2vh9S");

var $eBaY3 = parcelRequire("eBaY3");

var $fz3r9 = parcelRequire("fz3r9");

var $dUDPg = parcelRequire("dUDPg");

var $ikBJm = parcelRequire("ikBJm");

var $fN1K5 = parcelRequire("fN1K5");

var $7iytm = parcelRequire("7iytm");

var $7m9cQ = parcelRequire("7m9cQ");

var $9Q5xE = parcelRequire("9Q5xE");

var $i863C = parcelRequire("i863C");

var $8h5s0 = parcelRequire("8h5s0");

var $cSf8f = parcelRequire("cSf8f");

var $fT6Pt = parcelRequire("fT6Pt");

var $1TOtF = parcelRequire("1TOtF");

var $1aVVn = parcelRequire("1aVVn");

var $PFMNC = parcelRequire("PFMNC");
function $08b2b149dc41d983$export$72e4c5c1c0102f6d({ obj: obj, property: property, buttons: buttons, icon: icon, isEmbedded: isEmbedded, label: label }) {
    var _a, _b, _c, _d;
    const [state, setState] = (0, $eeH7J.useState)("show");
    const { hoverProps: hoverProps } = (0, $fz3r9.useHover)();
    const isReadonly = (0, $eBaY3.useIsReadonlyField)(property);
    const acceptedMimeTypes = (0, $14q7s.GetFileTypeMimeTypes)(property.type);
    const privateFile = !!((_a = property.tags) === null || _a === void 0 ? void 0 : _a.privateFile);
    const temporaryFile = !!((_b = property.tags) === null || _b === void 0 ? void 0 : _b.temporaryFile);
    // Files are uploaded to the "Media" folder by default, but can be
    // overridden with a `@folder` tag on the property
    const folder = ((_c = property.tags) === null || _c === void 0 ? void 0 : _c.folder) || "Media";
    const locked = (_d = property.tags) === null || _d === void 0 ? void 0 : _d.locked;
    const refresh = (0, $1TOtF.useDocumentRefresh)();
    const uploadFileInfo = (0, $eeH7J.useRef)({
        folder: folder,
        acceptedMimeTypes: acceptedMimeTypes,
        share: privateFile ? undefined : "FolderDefault",
        temporaryFile: temporaryFile,
        refresh: refresh,
        obj: obj,
        property: property,
        setState: setState
    });
    // The obj might change, but we need to reuse the same
    // uploadFileInfo.current object as it sits in a closure
    uploadFileInfo.current.obj = obj;
    const onDrop = (acceptedFiles)=>{
        const file = acceptedFiles[0];
        const data = new FormData();
        data.append("file", file, file.name);
        $08b2b149dc41d983$var$uploadFile(file, uploadFileInfo.current);
    };
    const { getRootProps: getRootProps, getInputProps: getInputProps, isDragActive: isDragActive } = (0, $cniWT.useDropzone)({
        onDrop: onDrop,
        noClick: true
    });
    const dropzoneRootProps = locked ? {} : getRootProps();
    const [value] = (0, $1aVVn.useYState)(obj, property.name);
    const acceptsImage = acceptedMimeTypes.includes("image");
    const fileViewButtons = $08b2b149dc41d983$var$createButtons(state, obj, property, acceptsImage, setState);
    const uploadFileFunc = $08b2b149dc41d983$var$createUploadFileFunc(uploadFileInfo.current);
    const noFileText = locked ? (0, $cSf8f.Translations).LockedField() : (0, $cSf8f.Translations).DragAndDropAFileHereToInsert();
    return (0, $4vwom.jsx)((0, $hRViu.PropRow), {
        isReadonly: isReadonly,
        label: label !== null && label !== void 0 ? label : (0, $8h5s0.prettyCamel)(property.name),
        badge: (0, $4vwom.jsx)($08b2b149dc41d983$var$ButtonRow, {
            property: property,
            value: value
        }),
        description: property.description,
        descriptionAbove: true,
        isEmbedded: isEmbedded,
        buttons: [
            ...buttons,
            ...fileViewButtons
        ],
        children: (0, $4vwom.jsxs)("div", {
            style: {
                display: "flex",
                flexDirection: "column"
            },
            children: [
                state === "upload" && (0, $4vwom.jsx)($08b2b149dc41d983$var$UploadView, {
                    uploadFileInfo: uploadFileInfo.current
                }),
                state === "capture" && (0, $4vwom.jsx)((0, $fN1K5.Camera), {
                    uploadFile: uploadFileFunc
                }),
                state === "show" ? (0, $4vwom.jsxs)("div", Object.assign({}, dropzoneRootProps, hoverProps, {
                    style: {
                        minHeight: 60,
                        maxHeight: 400,
                        backgroundColor: value ? undefined : (0, $9Q5xE.ColorStyles).gray[50],
                        color: (0, $9Q5xE.ColorStyles).gray[500],
                        padding: value ? 0 : "2rem",
                        display: "flex",
                        flexDirection: "row",
                        alignItems: value ? "flex-start" : "center"
                    },
                    children: [
                        (0, $4vwom.jsx)("input", Object.assign({}, getInputProps())),
                        value === undefined && noFileText,
                        value !== undefined && (0, $4vwom.jsx)($08b2b149dc41d983$var$FilePreviewWrapper, {
                            value: value,
                            icon: icon,
                            dragNDrop: isDragActive
                        }),
                        (0, $4vwom.jsxs)("div", {
                            style: {
                                display: "flex",
                                flexDirection: "column"
                            },
                            children: [
                                acceptsImage ? (0, $4vwom.jsx)((0, $fT6Pt.RButton), {
                                    icon: "ui-camera-01",
                                    onClick: ()=>setState("capture")
                                }) : undefined,
                                (0, $4vwom.jsx)((0, $fT6Pt.RButton), {
                                    icon: "ui-upload-01",
                                    onClick: ()=>setState("upload")
                                })
                            ]
                        })
                    ]
                })) : (0, $4vwom.jsx)((0, $fT6Pt.RButton), {
                    onClick: ()=>setState("show"),
                    children: "Cancel"
                })
            ]
        })
    });
}
function $08b2b149dc41d983$var$createUploadFileFunc(uploadFileInfo) {
    return async (file)=>await $08b2b149dc41d983$var$uploadFile(file, uploadFileInfo);
}
async function $08b2b149dc41d983$var$uploadFile(file, uploadFileInfo) {
    const { folder: folder, acceptedMimeTypes: acceptedMimeTypes, share: share, temporaryFile: temporaryFile, obj: obj, property: property, refresh: refresh, setState: setState } = uploadFileInfo;
    const data = new FormData();
    data.append("file", file);
    // Determine the mime type of JSON files based on what the model accepts for the target
    // property
    let mimetype;
    if (file.type === "application/json") {
        if (!acceptedMimeTypes.includes("application/json") && acceptedMimeTypes.includes("application/lottie+json")) mimetype = "application/lottie+json";
    }
    if ($08b2b149dc41d983$var$acceptsType(mimetype || file.type, acceptedMimeTypes)) {
        const res = await (0, $7iytm.UploadFile)(folder, file, mimetype, temporaryFile, share);
        if (res) {
            (0, $1aVVn.YTools).set(obj, property.name, res);
            if (refresh) await refresh();
            setState("show");
        }
    }
}
function $08b2b149dc41d983$var$acceptsType(mimetype, acceptedMimeTypes) {
    if (acceptedMimeTypes.some((x)=>x === "application/octet-stream")) return true;
    const accepts = acceptedMimeTypes.some((x)=>mimetype.startsWith(x));
    if (!accepts) alert("Unsupported file type: " + mimetype + ". This property only accepts " + acceptedMimeTypes.reduce((a, b)=>a + " or " + b));
    return accepts;
}
function $08b2b149dc41d983$var$ButtonRow({ property: property, value: value }) {
    return (0, $4vwom.jsx)("div", {
        style: {
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            marginTop: 4
        },
        children: (0, $4vwom.jsx)((0, $9HOw2.DiagnosticView), {
            property: property,
            value: value
        })
    });
}
function $08b2b149dc41d983$var$createButtons(state, obj, property, acceptsImage, setState) {
    var _a, _b;
    // Files are uploaded to the "Media" folder by default, but can be
    // overridden with a `@folder` tag on the property
    const folder = ((_a = property.tags) === null || _a === void 0 ? void 0 : _a.folder) || "Media";
    const locked = (_b = property.tags) === null || _b === void 0 ? void 0 : _b.locked;
    const buttons = [
        {
            text: "Upload",
            onClick: ()=>state === "upload" ? setState("show") : setState("upload")
        },
        {
            text: "Browse",
            onClick: async ()=>{
                const pk = await $08b2b149dc41d983$var$BrowseModal(obj, property.name, folder);
                if (pk) (0, $1aVVn.YTools).set(obj, property.name, pk);
            }
        },
        {
            text: "Camera",
            onClick: ()=>state === "capture" ? setState("show") : setState("capture"),
            disabled: !acceptsImage
        }
    ];
    return locked ? [] : buttons;
}
function $08b2b149dc41d983$var$UploadView({ uploadFileInfo: uploadFileInfo }) {
    return (0, $4vwom.jsx)("input", {
        type: "file",
        style: {
            marginTop: "1rem",
            marginBottom: "1rem"
        },
        onChange: (e)=>{
            const file = e.target.files && e.target.files[0];
            if (file) $08b2b149dc41d983$var$uploadFile(file, uploadFileInfo);
            else e.target.value = "";
        }
    });
}
function $08b2b149dc41d983$var$FilePreviewWrapper({ value: value, icon: icon, dragNDrop: dragNDrop }) {
    return (0, $4vwom.jsx)("div", {
        style: dragNDrop ? {
            opacity: 0.5,
            flex: 1
        } : {
            flex: 1
        },
        children: (0, $4vwom.jsx)($08b2b149dc41d983$export$a127194569a41afb, {
            id: value,
            imageOptions: {
                height: 400,
                width: 800
            },
            objectFit: "contain",
            icon: icon
        })
    });
}
function $08b2b149dc41d983$export$a127194569a41afb({ id: id, imageOptions: imageOptions, objectFit: objectFit, icon: icon }) {
    const contextFiles = (0, $1TOtF.useDocumentFiles)();
    const contextFile = contextFiles !== undefined && id ? contextFiles[id.toString()] : undefined;
    const contextMimeType = contextFile !== undefined ? contextFile.mimetype : undefined;
    // Fetch file info if we didn't find file mimetype in document context
    const { data: fetchedFile } = (0, $dUDPg.useFileInfo)(contextMimeType ? null : id);
    const fetchedMimeType = fetchedFile !== undefined ? fetchedFile.mimetype : undefined;
    const fileInfo = contextFile !== undefined ? contextFile : fetchedFile;
    const mimetype = contextMimeType !== undefined ? contextMimeType : fetchedMimeType;
    const protectedFile = fileInfo !== undefined ? fileInfo.share !== "AnyoneWithLink" : false;
    // If the image is private, fetch it with auth headers
    const image = (0, $i863C.useImageWithAuth)(protectedFile && (mimetype === null || mimetype === void 0 ? void 0 : mimetype.startsWith("image/")) ? (0, $14q7s.ImageToUrl)(id, imageOptions) : undefined);
    const maxWidth = (0, $PFMNC.useIsInsideEditingPanel)() ? 200 : 400;
    if (!mimetype) {
        if (!id) return (0, $4vwom.jsx)("div", {
            children: "Please specify a file or drag-and-drop here"
        });
        return (0, $4vwom.jsxs)("div", {
            children: [
                "Unknown mime type for ",
                id
            ]
        });
    }
    if (!id || id === "undefined") return(// Missing images from tableView come in as `$FILE:undefined`
    (0, $4vwom.jsx)("div", {
        style: {
            maxWidth: 80,
            height: "100%",
            borderRadius: 48,
            backgroundColor: "#ddd",
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
        },
        children: (0, $4vwom.jsx)("i", {
            className: `fas fa-${icon}`,
            style: {
                color: "#444"
            }
        })
    }));
    //PDF preview
    if (mimetype.startsWith("application/pdf")) return (0, $4vwom.jsx)("iframe", {
        style: {
            width: "100%",
            height: "75vh"
        },
        src: `https://mozilla.github.io/pdf.js/web/viewer.html?file=${(0, $7m9cQ.server)()}/api/files/${id}`
    });
    if (mimetype.startsWith("application/lottie+json")) return (0, $4vwom.jsx)((0, $2vh9S.Lottie), {
        file: id,
        style: {
            width: maxWidth,
            height: 400
        }
    });
    if (mimetype.startsWith("audio/")) return (0, $4vwom.jsx)("audio", {
        controls: true,
        src: (0, $14q7s.FileToUrl)(id)
    });
    if (mimetype.startsWith("video/")) return (0, $4vwom.jsx)("video", {
        controls: true,
        style: {
            width: "100%",
            maxWidth: maxWidth,
            maxHeight: 400
        },
        src: (0, $14q7s.FileToUrl)(id),
        preload: "metadata"
    });
    if (mimetype.startsWith("image/") && !protectedFile) return (0, $4vwom.jsx)("div", {
        style: {
            width: 400,
            maxWidth: maxWidth,
            aspectRatio: "16 / 9",
            backgroundImage: (0, $14q7s.ImageToCSS)(id, imageOptions),
            backgroundSize: "contain",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center"
        }
    });
    if (mimetype.startsWith("image/") && protectedFile) return (0, $4vwom.jsx)("img", {
        src: image,
        style: {
            width: "100%",
            maxWidth: maxWidth,
            aspectRatio: "16 / 9",
            objectFit: "contain",
            objectPosition: "left"
        }
    });
    return (0, $4vwom.jsx)("div", {
        style: {
            display: "flex",
            flexDirection: "row",
            alignItems: "center"
        },
        children: (0, $4vwom.jsx)((0, $6sp4J.Icon), {
            icon: "file",
            style: {
                width: 32,
                height: 32,
                margin: "1rem"
            }
        })
    });
}
function $08b2b149dc41d983$var$BrowseModal(obj, propertyName, folder) {
    return (0, $ikBJm.Modal)((close)=>(0, $4vwom.jsx)((0, $7c6pE.DocumentPicker), {
            collection: folder,
            obj: obj,
            refKey: "id",
            current: obj[propertyName],
            itemName: {
                en: "File",
                no: "Fil",
                sv: "Fil"
            },
            itemSelected: function(row) {
                close(row._primaryKey);
            },
            cancel: ()=>close(undefined)
        }));
}

});
parcelRegister("fN1K5", function(module, exports) {

$parcel$export(module.exports, "Camera", function () { return $b7ecc8a0922e8fd0$export$79f141de891a5fed; });

var $4vwom = parcelRequire("4vwom");

var $eeH7J = parcelRequire("eeH7J");

var $dius9 = parcelRequire("dius9");

var $fT6Pt = parcelRequire("fT6Pt");
parcelRequire("dbwyW");
var $4vUfp = parcelRequire("4vUfp");
const $b7ecc8a0922e8fd0$export$66ab11279ebf11d2 = 640;
const $b7ecc8a0922e8fd0$export$adfa613fb614d750 = 360;
const $b7ecc8a0922e8fd0$export$f36c64333cee2f6e = {
    width: $b7ecc8a0922e8fd0$export$66ab11279ebf11d2,
    height: $b7ecc8a0922e8fd0$export$adfa613fb614d750,
    facingMode: "environment"
};
function $b7ecc8a0922e8fd0$export$79f141de891a5fed({ setImage: setImage, uploadFile: uploadFile, fileName: fileName, imageType: imageType, webcamProps: webcamProps }) {
    if (imageType === undefined) imageType = "image/png";
    const fileEnding = imageType ? imageType.split("/")[1] : "png";
    const webcamRef = (0, $eeH7J.useRef)(null);
    const capture = (0, $eeH7J.useCallback)(async ()=>{
        var _a;
        const image = (_a = webcamRef.current) === null || _a === void 0 ? void 0 : _a.getScreenshot();
        if (!image) return;
        if (setImage && image !== null) setImage(image);
        if (uploadFile && image !== null) {
            const timeNow = (0, $4vUfp.Timestamp).toLocal((0, $4vUfp.Timestamp)(), "minute");
            if (fileName !== undefined) fileName = `${fileName}.${fileEnding}`;
            else fileName = `image_captured_${timeNow}.${fileEnding}`;
            const b64Data = image.split(",")[1];
            const blob = $b7ecc8a0922e8fd0$var$b64toBlob(b64Data, imageType);
            const file = new File([
                blob
            ], fileName, {
                type: imageType
            });
            await uploadFile(file);
        }
    }, []);
    return (0, $4vwom.jsxs)((0, $4vwom.Fragment), {
        children: [
            (0, $4vwom.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dius9))), Object.assign({
                ref: webcamRef,
                audio: false,
                height: $b7ecc8a0922e8fd0$export$adfa613fb614d750,
                screenshotFormat: imageType,
                width: "100%",
                videoConstraints: $b7ecc8a0922e8fd0$export$f36c64333cee2f6e,
                style: {
                    objectPosition: "left"
                }
            }, webcamProps)),
            (0, $4vwom.jsx)((0, $fT6Pt.RButton), {
                variant: "primary",
                style: {
                    width: 200,
                    marginTop: 16
                },
                onClick: capture,
                children: "Capture photo"
            })
        ]
    });
}
// Source: https://stackoverflow.com/a/16245768
function $b7ecc8a0922e8fd0$var$b64toBlob(b64Data, contentType = "", sliceSize = 512) {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];
    for(let offset = 0; offset < byteCharacters.length; offset += sliceSize){
        const slice = byteCharacters.slice(offset, offset + sliceSize);
        const byteNumbers = new Array(slice.length);
        for(let i = 0; i < slice.length; i++)byteNumbers[i] = slice.charCodeAt(i);
        const byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
    }
    const blob = new Blob(byteArrays, {
        type: contentType
    });
    return blob;
}

});
parcelRegister("dius9", function(module, exports) {

(function webpackUniversalModuleDefinition(root, factory) {
    module.exports = factory((parcelRequire("eeH7J")));
})(module.exports, function(__WEBPACK_EXTERNAL_MODULE_react__) {
    return /******/ function(modules) {
        /******/ // The module cache
        /******/ var installedModules = {};
        /******/ /******/ // The require function
        /******/ function __webpack_require__(moduleId) {
            /******/ /******/ // Check if module is in cache
            /******/ if (installedModules[moduleId]) /******/ return installedModules[moduleId].exports;
            /******/ // Create a new module (and put it into the cache)
            /******/ var module1 = installedModules[moduleId] = {
                /******/ i: moduleId,
                /******/ l: false,
                /******/ exports: {}
            };
            /******/ /******/ // Execute the module function
            /******/ modules[moduleId].call(module1.exports, module1, module1.exports, __webpack_require__);
            /******/ /******/ // Flag the module as loaded
            /******/ module1.l = true;
            /******/ /******/ // Return the exports of the module
            /******/ return module1.exports;
        /******/ }
        /******/ /******/ /******/ // expose the modules object (__webpack_modules__)
        /******/ __webpack_require__.m = modules;
        /******/ /******/ // expose the module cache
        /******/ __webpack_require__.c = installedModules;
        /******/ /******/ // define getter function for harmony exports
        /******/ __webpack_require__.d = function(exports, name, getter) {
            /******/ if (!__webpack_require__.o(exports, name)) /******/ Object.defineProperty(exports, name, {
                enumerable: true,
                get: getter
            });
        /******/ };
        /******/ /******/ // define __esModule on exports
        /******/ __webpack_require__.r = function(exports) {
            /******/ if (typeof Symbol !== "undefined" && Symbol.toStringTag) /******/ Object.defineProperty(exports, Symbol.toStringTag, {
                value: "Module"
            });
            /******/ Object.defineProperty(exports, "__esModule", {
                value: true
            });
        /******/ };
        /******/ /******/ // create a fake namespace object
        /******/ // mode & 1: value is a module id, require it
        /******/ // mode & 2: merge all properties of value into the ns
        /******/ // mode & 4: return value when already ns object
        /******/ // mode & 8|1: behave like require
        /******/ __webpack_require__.t = function(value, mode) {
            /******/ if (mode & 1) value = __webpack_require__(value);
            /******/ if (mode & 8) return value;
            /******/ if (mode & 4 && typeof value === "object" && value && value.__esModule) return value;
            /******/ var ns = Object.create(null);
            /******/ __webpack_require__.r(ns);
            /******/ Object.defineProperty(ns, "default", {
                enumerable: true,
                value: value
            });
            /******/ if (mode & 2 && typeof value != "string") for(var key in value)__webpack_require__.d(ns, key, (function(key) {
                return value[key];
            }).bind(null, key));
            /******/ return ns;
        /******/ };
        /******/ /******/ // getDefaultExport function for compatibility with non-harmony modules
        /******/ __webpack_require__.n = function(module1) {
            /******/ var getter = module1 && module1.__esModule ? /******/ function getDefault() {
                return module1["default"];
            } : /******/ function getModuleExports() {
                return module1;
            };
            /******/ __webpack_require__.d(getter, "a", getter);
            /******/ return getter;
        /******/ };
        /******/ /******/ // Object.prototype.hasOwnProperty.call
        /******/ __webpack_require__.o = function(object, property) {
            return Object.prototype.hasOwnProperty.call(object, property);
        };
        /******/ /******/ // __webpack_public_path__
        /******/ __webpack_require__.p = "";
        /******/ /******/ /******/ // Load entry module and return exports
        /******/ return __webpack_require__(__webpack_require__.s = "./src/react-webcam.tsx");
    /******/ }({
        /***/ "./src/react-webcam.tsx": /*!******************************!*\
  !*** ./src/react-webcam.tsx ***!
  \******************************/ /*! exports provided: default */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
            var __extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var __assign = function() {
                __assign = Object.assign || function(t) {
                    for(var s, i = 1, n = arguments.length; i < n; i++){
                        s = arguments[i];
                        for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                    }
                    return t;
                };
                return __assign.apply(this, arguments);
            };
            var __rest = function(s, e) {
                var t = {};
                for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
                if (s != null && typeof Object.getOwnPropertySymbols === "function") {
                    for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
                }
                return t;
            };
            // polyfill based on https://developer.mozilla.org/en-US/docs/Web/API/MediaDevices/getUserMedia
            (function polyfillGetUserMedia() {
                if (typeof window === "undefined") return;
                // Older browsers might not implement mediaDevices at all, so we set an empty object first
                if (navigator.mediaDevices === undefined) navigator.mediaDevices = {};
                // Some browsers partially implement mediaDevices. We can't just assign an object
                // with getUserMedia as it would overwrite existing properties.
                // Here, we will just add the getUserMedia property if it's missing.
                if (navigator.mediaDevices.getUserMedia === undefined) navigator.mediaDevices.getUserMedia = function(constraints) {
                    // First get ahold of the legacy getUserMedia, if present
                    var getUserMedia = navigator.getUserMedia || navigator.webkitGetUserMedia || navigator.mozGetUserMedia || navigator.msGetUserMedia;
                    // Some browsers just don't implement it - return a rejected promise with an error
                    // to keep a consistent interface
                    if (!getUserMedia) return Promise.reject(new Error("getUserMedia is not implemented in this browser"));
                    // Otherwise, wrap the call to the old navigator.getUserMedia with a Promise
                    return new Promise(function(resolve, reject) {
                        getUserMedia.call(navigator, constraints, resolve, reject);
                    });
                };
            })();
            function hasGetUserMedia() {
                return !!(navigator.mediaDevices && navigator.mediaDevices.getUserMedia);
            }
            var Webcam = /** @class */ function(_super) {
                __extends(Webcam, _super);
                function Webcam(props) {
                    var _this = _super.call(this, props) || this;
                    _this.canvas = null;
                    _this.ctx = null;
                    _this.requestUserMediaId = 0;
                    _this.unmounted = false;
                    _this.state = {
                        hasUserMedia: false
                    };
                    return _this;
                }
                Webcam.prototype.componentDidMount = function() {
                    var _a = this, state = _a.state, props = _a.props;
                    this.unmounted = false;
                    if (!hasGetUserMedia()) {
                        props.onUserMediaError("getUserMedia not supported");
                        return;
                    }
                    if (!state.hasUserMedia) this.requestUserMedia();
                    if (props.children && typeof props.children != "function") console.warn("children must be a function");
                };
                Webcam.prototype.componentDidUpdate = function(nextProps) {
                    var props = this.props;
                    if (!hasGetUserMedia()) {
                        props.onUserMediaError("getUserMedia not supported");
                        return;
                    }
                    var audioConstraintsChanged = JSON.stringify(nextProps.audioConstraints) !== JSON.stringify(props.audioConstraints);
                    var videoConstraintsChanged = JSON.stringify(nextProps.videoConstraints) !== JSON.stringify(props.videoConstraints);
                    var minScreenshotWidthChanged = nextProps.minScreenshotWidth !== props.minScreenshotWidth;
                    var minScreenshotHeightChanged = nextProps.minScreenshotHeight !== props.minScreenshotHeight;
                    if (videoConstraintsChanged || minScreenshotWidthChanged || minScreenshotHeightChanged) {
                        this.canvas = null;
                        this.ctx = null;
                    }
                    if (audioConstraintsChanged || videoConstraintsChanged) {
                        this.stopAndCleanup();
                        this.requestUserMedia();
                    }
                };
                Webcam.prototype.componentWillUnmount = function() {
                    this.unmounted = true;
                    this.stopAndCleanup();
                };
                Webcam.stopMediaStream = function(stream) {
                    if (stream) {
                        if (stream.getVideoTracks && stream.getAudioTracks) {
                            stream.getVideoTracks().map(function(track) {
                                stream.removeTrack(track);
                                track.stop();
                            });
                            stream.getAudioTracks().map(function(track) {
                                stream.removeTrack(track);
                                track.stop();
                            });
                        } else stream.stop();
                    }
                };
                Webcam.prototype.stopAndCleanup = function() {
                    var state = this.state;
                    if (state.hasUserMedia) {
                        Webcam.stopMediaStream(this.stream);
                        if (state.src) window.URL.revokeObjectURL(state.src);
                    }
                };
                Webcam.prototype.getScreenshot = function(screenshotDimensions) {
                    var _a = this, state = _a.state, props = _a.props;
                    if (!state.hasUserMedia) return null;
                    var canvas = this.getCanvas(screenshotDimensions);
                    return canvas && canvas.toDataURL(props.screenshotFormat, props.screenshotQuality);
                };
                Webcam.prototype.getCanvas = function(screenshotDimensions) {
                    var _a = this, state = _a.state, props = _a.props;
                    if (!this.video) return null;
                    if (!state.hasUserMedia || !this.video.videoHeight) return null;
                    if (!this.ctx) {
                        var canvasWidth = this.video.videoWidth;
                        var canvasHeight = this.video.videoHeight;
                        if (!this.props.forceScreenshotSourceSize) {
                            var aspectRatio = canvasWidth / canvasHeight;
                            canvasWidth = props.minScreenshotWidth || this.video.clientWidth;
                            canvasHeight = canvasWidth / aspectRatio;
                            if (props.minScreenshotHeight && canvasHeight < props.minScreenshotHeight) {
                                canvasHeight = props.minScreenshotHeight;
                                canvasWidth = canvasHeight * aspectRatio;
                            }
                        }
                        this.canvas = document.createElement("canvas");
                        this.canvas.width = (screenshotDimensions === null || screenshotDimensions === void 0 ? void 0 : screenshotDimensions.width) || canvasWidth;
                        this.canvas.height = (screenshotDimensions === null || screenshotDimensions === void 0 ? void 0 : screenshotDimensions.height) || canvasHeight;
                        this.ctx = this.canvas.getContext("2d");
                    }
                    var _b = this, ctx = _b.ctx, canvas = _b.canvas;
                    if (ctx && canvas) {
                        // adjust the height and width of the canvas to the given dimensions
                        canvas.width = (screenshotDimensions === null || screenshotDimensions === void 0 ? void 0 : screenshotDimensions.width) || canvas.width;
                        canvas.height = (screenshotDimensions === null || screenshotDimensions === void 0 ? void 0 : screenshotDimensions.height) || canvas.height;
                        // mirror the screenshot
                        if (props.mirrored) {
                            ctx.translate(canvas.width, 0);
                            ctx.scale(-1, 1);
                        }
                        ctx.imageSmoothingEnabled = props.imageSmoothing;
                        ctx.drawImage(this.video, 0, 0, (screenshotDimensions === null || screenshotDimensions === void 0 ? void 0 : screenshotDimensions.width) || canvas.width, (screenshotDimensions === null || screenshotDimensions === void 0 ? void 0 : screenshotDimensions.height) || canvas.height);
                        // invert mirroring
                        if (props.mirrored) {
                            ctx.scale(-1, 1);
                            ctx.translate(-canvas.width, 0);
                        }
                    }
                    return canvas;
                };
                Webcam.prototype.requestUserMedia = function() {
                    var _this = this;
                    var props = this.props;
                    var sourceSelected = function(audioConstraints, videoConstraints) {
                        var constraints = {
                            video: typeof videoConstraints !== "undefined" ? videoConstraints : true
                        };
                        if (props.audio) constraints.audio = typeof audioConstraints !== "undefined" ? audioConstraints : true;
                        _this.requestUserMediaId++;
                        var myRequestUserMediaId = _this.requestUserMediaId;
                        navigator.mediaDevices.getUserMedia(constraints).then(function(stream) {
                            if (_this.unmounted || myRequestUserMediaId !== _this.requestUserMediaId) Webcam.stopMediaStream(stream);
                            else _this.handleUserMedia(null, stream);
                        }).catch(function(e) {
                            _this.handleUserMedia(e);
                        });
                    };
                    if ("mediaDevices" in navigator) sourceSelected(props.audioConstraints, props.videoConstraints);
                    else {
                        var optionalSource_1 = function(id) {
                            return {
                                optional: [
                                    {
                                        sourceId: id
                                    }
                                ]
                            };
                        };
                        var constraintToSourceId_1 = function(constraint) {
                            var deviceId = constraint.deviceId;
                            if (typeof deviceId === "string") return deviceId;
                            if (Array.isArray(deviceId) && deviceId.length > 0) return deviceId[0];
                            if (typeof deviceId === "object" && deviceId.ideal) return deviceId.ideal;
                            return null;
                        };
                        // @ts-ignore: deprecated api
                        MediaStreamTrack.getSources(function(sources) {
                            var audioSource = null;
                            var videoSource = null;
                            sources.forEach(function(source) {
                                if (source.kind === "audio") audioSource = source.id;
                                else if (source.kind === "video") videoSource = source.id;
                            });
                            var audioSourceId = constraintToSourceId_1(props.audioConstraints);
                            if (audioSourceId) audioSource = audioSourceId;
                            var videoSourceId = constraintToSourceId_1(props.videoConstraints);
                            if (videoSourceId) videoSource = videoSourceId;
                            sourceSelected(optionalSource_1(audioSource), optionalSource_1(videoSource));
                        });
                    }
                };
                Webcam.prototype.handleUserMedia = function(err, stream) {
                    var props = this.props;
                    if (err || !stream) {
                        this.setState({
                            hasUserMedia: false
                        });
                        props.onUserMediaError(err);
                        return;
                    }
                    this.stream = stream;
                    try {
                        if (this.video) this.video.srcObject = stream;
                        this.setState({
                            hasUserMedia: true
                        });
                    } catch (error) {
                        this.setState({
                            hasUserMedia: true,
                            src: window.URL.createObjectURL(stream)
                        });
                    }
                    props.onUserMedia(stream);
                };
                Webcam.prototype.render = function() {
                    var _this = this;
                    var _a = this, state = _a.state, props = _a.props;
                    var audio = props.audio, forceScreenshotSourceSize = props.forceScreenshotSourceSize, disablePictureInPicture = props.disablePictureInPicture, onUserMedia = props.onUserMedia, onUserMediaError = props.onUserMediaError, screenshotFormat = props.screenshotFormat, screenshotQuality = props.screenshotQuality, minScreenshotWidth = props.minScreenshotWidth, minScreenshotHeight = props.minScreenshotHeight, audioConstraints = props.audioConstraints, videoConstraints = props.videoConstraints, imageSmoothing = props.imageSmoothing, mirrored = props.mirrored, _b = props.style, style = _b === void 0 ? {} : _b, children = props.children, rest = __rest(props, [
                        "audio",
                        "forceScreenshotSourceSize",
                        "disablePictureInPicture",
                        "onUserMedia",
                        "onUserMediaError",
                        "screenshotFormat",
                        "screenshotQuality",
                        "minScreenshotWidth",
                        "minScreenshotHeight",
                        "audioConstraints",
                        "videoConstraints",
                        "imageSmoothing",
                        "mirrored",
                        "style",
                        "children"
                    ]);
                    var videoStyle = mirrored ? __assign(__assign({}, style), {
                        transform: (style.transform || "") + " scaleX(-1)"
                    }) : style;
                    var childrenProps = {
                        getScreenshot: this.getScreenshot.bind(this)
                    };
                    return react__WEBPACK_IMPORTED_MODULE_0__["createElement"](react__WEBPACK_IMPORTED_MODULE_0__["Fragment"], null, react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("video", __assign({
                        autoPlay: true,
                        disablePictureInPicture: disablePictureInPicture,
                        src: state.src,
                        muted: !audio,
                        playsInline: true,
                        ref: function(ref) {
                            _this.video = ref;
                        },
                        style: videoStyle
                    }, rest)), children && children(childrenProps));
                };
                Webcam.defaultProps = {
                    audio: false,
                    disablePictureInPicture: false,
                    forceScreenshotSourceSize: false,
                    imageSmoothing: true,
                    mirrored: false,
                    onUserMedia: function() {
                        return undefined;
                    },
                    onUserMediaError: function() {
                        return undefined;
                    },
                    screenshotFormat: "image/webp",
                    screenshotQuality: 0.92
                };
                return Webcam;
            }(react__WEBPACK_IMPORTED_MODULE_0__["Component"]);
            /* harmony default export */ __webpack_exports__["default"] = Webcam;
        /***/ },
        /***/ "react": /*!**************************************************************************************!*\
  !*** external {"root":"React","commonjs2":"react","commonjs":"react","amd":"react"} ***!
  \**************************************************************************************/ /*! no static exports found */ /***/ function(module1, exports) {
            module1.exports = __WEBPACK_EXTERNAL_MODULE_react__;
        /***/ }
    })["default"];
});

});


parcelRegister("PFMNC", function(module, exports) {

$parcel$export(module.exports, "EditingPanel", function () { return $09b52d6197d8f0e5$export$da71845f15a7045e; });
$parcel$export(module.exports, "useIsInsideEditingPanel", function () { return $09b52d6197d8f0e5$export$eef6dfc87f136776; });

var $4vwom = parcelRequire("4vwom");

var $cNfXq = parcelRequire("cNfXq");

var $5JGam = parcelRequire("5JGam");

var $kVtSC = parcelRequire("kVtSC");

var $lWmEE = parcelRequire("lWmEE");

var $knIBr = parcelRequire("knIBr");

var $dOFTp = parcelRequire("dOFTp");

var $eeH7J = parcelRequire("eeH7J");
function $09b52d6197d8f0e5$export$da71845f15a7045e(props) {
    const editing = (0, $5JGam.useIsEditing)();
    const { selectedObject: selectedObject, selectedObjectType: selectedObjectType, selectedObjectPutType: selectedObjectPutType } = (0, $knIBr.useSelectionContext)();
    const reflection = (0, $cNfXq.useReflectionReady)(editing);
    (0, $dOFTp.useObserveYProxy)(selectedObject);
    (0, $lWmEE.useFullHeight)();
    if (!reflection || !editing) return (0, $4vwom.jsx)((0, $4vwom.Fragment), {});
    return (0, $4vwom.jsx)($09b52d6197d8f0e5$export$30312abb4b7aa3a5.Provider, {
        value: true,
        children: (0, $4vwom.jsx)("div", {
            style: {
                fontSize: 12,
                height: "100%",
                borderRight: "1px solid #ddd",
                display: "flex",
                flexDirection: "column",
                overflowY: "auto",
                width: 350,
                maxWidth: "40%",
                position: "sticky",
                top: 0
            },
            children: selectedObject && selectedObjectType && (0, $4vwom.jsx)((0, $kVtSC.ObjectEditor), {
                obj: selectedObject,
                type: selectedObjectType,
                putType: selectedObjectPutType,
                skipAncestors: props.skipAncestors,
                declarations: props.declarations
            })
        })
    });
}
const $09b52d6197d8f0e5$export$30312abb4b7aa3a5 = /*#__PURE__*/ (0, $eeH7J.createContext)(false);
function $09b52d6197d8f0e5$export$eef6dfc87f136776() {
    return (0, $eeH7J.useContext)($09b52d6197d8f0e5$export$30312abb4b7aa3a5);
}

});
parcelRegister("cNfXq", function(module, exports) {

$parcel$export(module.exports, "whenReflectionReady", function () { return $02675464fd8036f3$export$2b581c707b8786ee; });
$parcel$export(module.exports, "useReflectionReady", function () { return $02675464fd8036f3$export$1b57c3a8ac2e4ca; });

var $eeH7J = parcelRequire("eeH7J");

var $3oicm = parcelRequire("3oicm");

var $cwhCA = parcelRequire("cwhCA");
let $02675464fd8036f3$var$reflectionPromise;

function $02675464fd8036f3$export$2b581c707b8786ee(callback) {
    if ((0, $cwhCA.IsReflectionInfoReady)()) {
        callback((0, $cwhCA.GetReflectionInfo)());
        return;
    }
    if (!$02675464fd8036f3$var$reflectionPromise) {
        async function loadReflection() {
            const { getReflection: getReflection } = await Promise.resolve((parcelRequire("dUDPg")));
            // Could have been initialized while we were waiting for the import
            if (!$02675464fd8036f3$var$reflectionPromise) $02675464fd8036f3$var$reflectionPromise = getReflection();
            const ref = await $02675464fd8036f3$var$reflectionPromise;
            const info = (0, $3oicm.DeserializeGraph)(ref);
            (0, $cwhCA.SetReflectionInfo)(info);
            callback(info);
        }
        loadReflection();
    } else $02675464fd8036f3$var$reflectionPromise.then(()=>callback((0, $cwhCA.GetReflectionInfo)()));
}
function $02675464fd8036f3$export$1b57c3a8ac2e4ca(/** Whether the caller needs the reflection info now, or just want to
 * reserve the hook for later.
 *
 * Passing `false` will not download the reflection info yet.
 * */ needItYet) {
    const [ready, setReady] = (0, $eeH7J.useState)((0, $cwhCA.IsReflectionInfoReady)());
    if (!ready && needItYet) $02675464fd8036f3$export$2b581c707b8786ee(()=>setReady(true));
    if (!(0, $cwhCA.IsReflectionInfoReady)()) return undefined;
    return (0, $cwhCA.GetReflectionInfo)();
}

});

parcelRegister("kVtSC", function(module, exports) {

$parcel$export(module.exports, "ObjectEditor", function () { return $f3c04f0e2ef6de69$export$ec7da929f39d97c8; });

var $4vwom = parcelRequire("4vwom");

var $eeH7J = parcelRequire("eeH7J");

var $knIBr = parcelRequire("knIBr");

var $43jhg = parcelRequire("43jhg");

var $21l71 = parcelRequire("21l71");

var $cwhCA = parcelRequire("cwhCA");

var $eCMxQ = parcelRequire("eCMxQ");

var $8h5s0 = parcelRequire("8h5s0");

var $5iV0P = parcelRequire("5iV0P");

var $eBaY3 = parcelRequire("eBaY3");

var $fT6Pt = parcelRequire("fT6Pt");

var $kMyqA = parcelRequire("kMyqA");

var $9ArIY = parcelRequire("9ArIY");

var $4FdkC = parcelRequire("4FdkC");

var $1aVVn = parcelRequire("1aVVn");
function $f3c04f0e2ef6de69$export$ec7da929f39d97c8({ obj: obj, type: type, putType: putType, skipAncestors: skipAncestors, declarations: declarations }) {
    var _a;
    const resources = (0, $9ArIY.YEditor).editors;
    const { setSelectedObject: setSelectedObject } = (0, $knIBr.useSelectionContext)();
    const { arr: arr } = (0, $eeH7J.useContext)((0, $21l71.ArrayContext));
    const index = arr === null || arr === void 0 ? void 0 : arr.indexOf(obj);
    const target = (0, $4FdkC.GetYProxyTarget)(obj);
    type = (0, $cwhCA.SubstituteAndDiscriminate)(target ? (0, $1aVVn.YTools).valueToJSON(target) : obj, type);
    const icon = typeof type === "object" && ((_a = type.tags) === null || _a === void 0 ? void 0 : _a.icon) || "box";
    const ancestors = (0, $eCMxQ.GetAncestors)(resources, obj).filter((x)=>!(0, $43jhg.IsArrayType)(x.type));
    const isRoot = resources.some((r)=>r.proxy === obj);
    const display = isRoot || ancestors.length > 0;
    const rootResource = Array.from(resources).find((r)=>r.proxy === obj);
    const titleProp = (0, $43jhg.GetTypeProps)(type).find((p)=>{
        var _a;
        return (_a = p.tags) === null || _a === void 0 ? void 0 : _a.title;
    });
    const titleFromProp = titleProp ? obj[titleProp.name] : undefined;
    let title = rootResource ? rootResource.res : typeof titleFromProp === "string" ? titleFromProp : (0, $8h5s0.prettyCamel)(type && (0, $43jhg.GetTypeAlias)(type) || "Item");
    if (title.startsWith("get")) title = title.substr(3);
    if (title.endsWith("section")) title = title.substr(0, title.length - 7);
    const actions = (0, $5iV0P.GetEditableActions)(obj);
    const getterProps = (0, $43jhg.GetTypeProps)(type);
    const putterProps = putType ? (0, $43jhg.GetTypeProps)(putType) : getterProps;
    if (!type || typeof type !== "object") throw new Error("This type cannot be edited");
    const editType = putType ? Object.assign(Object.assign({}, type), {
        props: getterProps.filter((p)=>putterProps.some((pp)=>pp.name === p.name))
    }) : type;
    return (0, $4vwom.jsx)((0, $eBaY3.ReadonlyContext).Provider, {
        value: {
            mode: "edit"
        },
        children: (0, $4vwom.jsxs)("div", {
            style: {
                display: "flex",
                flexDirection: "column",
                width: "100%"
            },
            children: [
                ancestors.slice(skipAncestors !== null && skipAncestors !== void 0 ? skipAncestors : 0).map((a, i)=>{
                    var _a;
                    let name = a.name;
                    if (name.startsWith("get")) name = name.substr(3);
                    const display = (0, $8h5s0.prettyCamel)(name, true);
                    const icon = typeof a.type === "object" && ((_a = a.type.tags) === null || _a === void 0 ? void 0 : _a.icon) || "box";
                    return (0, $4vwom.jsxs)("div", {
                        onClick: ()=>setSelectedObject(a.obj, a.type, a.putType),
                        style: {
                            cursor: "pointer",
                            backgroundColor: "#eee",
                            padding: 8,
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                            paddingLeft: 8 + 4 * i,
                            borderBottom: "1px solid #ddd"
                        },
                        children: [
                            icon && (0, $4vwom.jsx)("div", {
                                style: {
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    marginRight: 8
                                },
                                children: (0, $4vwom.jsx)("i", {
                                    className: "fas fa-" + icon
                                })
                            }),
                            display
                        ]
                    });
                }),
                display ? (0, $4vwom.jsxs)("div", {
                    style: {
                        backgroundColor: "#eee",
                        padding: 8,
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        paddingLeft: 8 + 4 * ancestors.length
                    },
                    children: [
                        icon && (0, $4vwom.jsx)("div", {
                            style: {
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center"
                            },
                            children: (0, $4vwom.jsx)("i", {
                                className: "fas fa-" + icon
                            })
                        }),
                        type && (0, $4vwom.jsx)("span", {
                            style: {
                                marginLeft: 8,
                                marginRight: 32
                            },
                            children: title
                        }),
                        (0, $4vwom.jsx)("div", {
                            style: {
                                flex: 1
                            }
                        }),
                        (actions === null || actions === void 0 ? void 0 : actions.saveAsTemplate) && (0, $4vwom.jsx)((0, $fT6Pt.RButton), {
                            icon: "save",
                            tooltip: "Save as template",
                            iconSize: 14,
                            style: {
                                fontSize: 14
                            },
                            onClick: actions.saveAsTemplate
                        }),
                        (actions === null || actions === void 0 ? void 0 : actions.deleteThis) && (0, $4vwom.jsx)((0, $fT6Pt.RButton), {
                            icon: "ui-trash-01",
                            tooltip: "Delete",
                            iconSize: 14,
                            style: {
                                fontSize: 14
                            },
                            onClick: actions.deleteThis
                        }),
                        index !== -1 && (0, $4vwom.jsx)((0, $4vwom.Fragment), {
                            children: (0, $4vwom.jsx)((0, $fT6Pt.RButton), {
                                icon: "ui-trash-01",
                                iconSize: 14,
                                onClick: ()=>{
                                    arr.splice(index, 1);
                                }
                            })
                        }),
                        index !== -1 && index > 0 && (0, $4vwom.jsx)((0, $fT6Pt.RButton), {
                            icon: "chevron-up",
                            iconSize: 14,
                            onClick: ()=>{
                                const [item] = arr.splice(index, 1);
                                arr.splice(index - 1, 0, item);
                            }
                        }),
                        index !== -1 && arr && index < arr.length - 1 && (0, $4vwom.jsx)((0, $fT6Pt.RButton), {
                            icon: "chevron-down",
                            iconSize: 14,
                            onClick: ()=>{
                                const [item] = arr.splice(index, 1);
                                arr.splice(index + 1, 0, item);
                            }
                        })
                    ]
                }) : undefined,
                display && (0, $4vwom.jsx)("div", {
                    style: {
                        paddingLeft: 16,
                        paddingRight: 16,
                        flex: 1,
                        marginBottom: 128
                    },
                    children: (0, $4vwom.jsx)((0, $kMyqA.ObjectView), {
                        obj: (0, $4FdkC.GetYProxyTarget)(obj),
                        buttons: [],
                        property: {
                            name: "editable",
                            type: editType
                        },
                        mode: "root",
                        replaceObj: ()=>{},
                        declarations: declarations
                    })
                })
            ]
        })
    });
}

});
parcelRegister("21l71", function(module, exports) {

$parcel$export(module.exports, "ArrayContext", function () { return $178c0d38bf9b310d$export$935d8dc970c35362; });
$parcel$export(module.exports, "EditableArray", function () { return $178c0d38bf9b310d$export$9bef545abb0cd5cc; });

var $4vwom = parcelRequire("4vwom");

var $eeH7J = parcelRequire("eeH7J");

var $5c9Ym = parcelRequire("5c9Ym");

var $5JGam = parcelRequire("5JGam");

var $fz3r9 = parcelRequire("fz3r9");

var $cwhCA = parcelRequire("cwhCA");

var $cNfXq = parcelRequire("cNfXq");

var $8h5s0 = parcelRequire("8h5s0");

var $43jhg = parcelRequire("43jhg");

var $ikBJm = parcelRequire("ikBJm");

var $5iV0P = parcelRequire("5iV0P");

var $9Q5xE = parcelRequire("9Q5xE");

var $knIBr = parcelRequire("knIBr");

var $dOFTp = parcelRequire("dOFTp");
const $178c0d38bf9b310d$export$935d8dc970c35362 = /*#__PURE__*/ (0, $eeH7J.createContext)({
    arr: []
});

function $178c0d38bf9b310d$export$9bef545abb0cd5cc({ arr: arr, direction: direction, children: children, itemTypeName: itemTypeName, itemStyle: itemStyle, itemClassName: itemClassName, itemCss: itemCss, createInstance: createInstance }) {
    var _a;
    const sc = (0, $knIBr.useSelectionContext)();
    (0, $dOFTp.useObserveYProxy)(arr);
    const editing = (0, $5JGam.useIsEditing)();
    const reflectionReady = (0, $cNfXq.useReflectionReady)(editing);
    const type = (_a = editing && reflectionReady && (0, $cwhCA.GetType)(itemTypeName)) !== null && _a !== void 0 ? _a : undefined;
    async function deleteAt(index) {
        arr.splice(index, 1);
    }
    const createNew = createInstance !== null && createInstance !== void 0 ? createInstance : async ()=>{
        async function findInstanceType() {
            if (type && (0, $43jhg.IsUnionType)(type)) {
                const union = (0, $43jhg.GetTypeAlias)(type);
                if (union) {
                    const { DocumentPicker: DocumentPicker } = await Promise.resolve((parcelRequire("7c6pE")));
                    const res = await (0, $ikBJm.Modal)((close)=>(0, $4vwom.jsx)(DocumentPicker, {
                            collection: union,
                            current: undefined,
                            cancel: ()=>close(undefined),
                            itemName: {
                                en: (0, $8h5s0.prettyCamel)(union, false) + " type"
                            },
                            itemSelected: (row)=>close(row)
                        }));
                    if (res === undefined) return; // User cancelled
                    const alias = res === null || res === void 0 ? void 0 : res._primaryKey;
                    if (typeof alias === "string") return (0, $cwhCA.GetType)(alias);
                }
            }
            return type;
        }
        const newType = await findInstanceType();
        if (newType) return (0, $5c9Ym.CreateDefault)(newType);
    };
    async function addAt(index) {
        const obj = await createNew();
        if (obj !== undefined && type) {
            arr.splice(index, 0, obj);
            sc.setSelectedObject(obj, type);
            (0, $5iV0P.SetEditableActions)(obj, {
                deleteThis () {
                    deleteAt(index);
                }
            });
        }
    }
    return (0, $4vwom.jsx)($178c0d38bf9b310d$export$935d8dc970c35362.Provider, {
        value: {
            arr: arr
        },
        children: (0, $4vwom.jsxs)((0, $4vwom.Fragment), {
            children: [
                arr.map((item, index)=>{
                    var _a;
                    return (0, $4vwom.jsx)($178c0d38bf9b310d$var$ArrayItem, {
                        itemClassName: typeof itemClassName === "string" ? itemClassName : itemClassName === null || itemClassName === void 0 ? void 0 : itemClassName(index),
                        itemStyle: itemStyle === null || itemStyle === void 0 ? void 0 : itemStyle(index),
                        itemCss: itemCss === null || itemCss === void 0 ? void 0 : itemCss(index),
                        sectionId: (_a = item === null || item === void 0 ? void 0 : item.id) === null || _a === void 0 ? void 0 : _a.valueOf(),
                        insertAfter: ()=>addAt(index + 1),
                        insertBefore: ()=>addAt(index),
                        editing: editing,
                        direction: direction,
                        isLast: index === arr.length - 1,
                        children: children(item, index)
                    }, index);
                }),
                arr.length === 0 && editing && type ? (0, $4vwom.jsxs)("button", {
                    onClick: ()=>addAt(0),
                    children: [
                        "Add first ",
                        (0, $8h5s0.prettyCamel)(itemTypeName, false)
                    ]
                }) : undefined
            ]
        })
    });
}
function $178c0d38bf9b310d$var$ArrayItem(props) {
    const ref = (0, $eeH7J.useRef)(null);
    const { hover: hover, hoverProps: hoverProps } = (0, $fz3r9.useHover)();
    const [showA, setShowA] = (0, $eeH7J.useState)(false);
    const [showB, setShowB] = (0, $eeH7J.useState)(false);
    return (0, $4vwom.jsxs)("div", Object.assign({
        id: props.sectionId,
        ref: ref,
        className: props.itemClassName,
        onMouseMove: (e)=>{
            e.stopPropagation();
            if (!ref.current) return;
            if (e.currentTarget !== ref.current) return;
            const rect = ref.current.getBoundingClientRect();
            const x = e.clientX - rect.left;
            const y = e.clientY - rect.top;
            let a = false;
            let b = false;
            if (props.direction === "row") {
                if (x < 40) a = true;
                if (ref.current && x > rect.width - 40) b = true;
                if (y < -20 || y > rect.height + 20) {
                    a = false;
                    b = false;
                }
            }
            if (props.direction === "column") {
                if (y < 40) a = true;
                if (ref.current && y > rect.height - 40) b = true;
                if (x < -20 || x > rect.width + 20) {
                    a = false;
                    b = false;
                }
            }
            setShowA(a);
            setShowB(b);
        }
    }, hoverProps, {
        style: Object.assign({
            display: "flex",
            flexDirection: props.direction,
            position: "relative"
        }, props.itemStyle),
        css: props.itemCss,
        children: [
            props.editing && (0, $4vwom.jsx)($178c0d38bf9b310d$var$AddBar, {
                direction: props.direction,
                position: "before",
                show: hover && showA,
                onClick: props.insertBefore
            }),
            props.children,
            props.editing && hover && props.isLast && (0, $4vwom.jsx)($178c0d38bf9b310d$var$AddBar, {
                direction: props.direction,
                position: "after",
                show: hover && showB,
                onClick: props.insertAfter
            })
        ]
    }));
}
function $178c0d38bf9b310d$var$AddBar(props) {
    const { hover: hover, hoverProps: hoverProps } = (0, $fz3r9.useHover)();
    return (0, $4vwom.jsx)("div", Object.assign({
        onClick: (e)=>{
            e.stopPropagation();
            props.onClick();
        }
    }, hoverProps, {
        style: {
            position: "absolute",
            zIndex: 20,
            display: "flex",
            flexDirection: props.direction === "row" ? "column" : "row",
            justifyContent: "center",
            alignItems: "center",
            opacity: props.show ? 0.9 : 0,
            transition: "opacity 0.2s",
            top: props.direction === "column" && props.position === "before" ? -1.5 : undefined,
            bottom: props.direction === "column" && props.position === "after" ? -1.5 : undefined,
            left: props.direction === "row" && props.position === "before" ? -1.5 : undefined,
            right: props.direction === "row" && props.position === "after" ? -1.5 : undefined,
            width: props.direction === "column" ? "100%" : 2,
            height: props.direction === "row" ? "100%" : 2,
            backgroundColor: hover ? (0, $9Q5xE.ColorStyles).primary[500] : (0, $9Q5xE.ColorStyles).primary[600],
            fontFamily: "Arial"
        },
        children: (0, $4vwom.jsx)("div", {
            style: {
                width: 24,
                height: 24,
                backgroundColor: hover ? (0, $9Q5xE.ColorStyles).primary[500] : (0, $9Q5xE.ColorStyles).primary[600],
                borderRadius: 16,
                fontSize: 24,
                color: "white",
                display: "flex",
                flexDirection: props.direction === "row" ? "column" : "row",
                justifyContent: "center",
                alignItems: "center",
                textAlign: "center",
                cursor: "pointer"
            },
            children: (0, $4vwom.jsx)("div", {
                style: {
                    marginLeft: 1.25,
                    marginTop: 0.25
                },
                children: "+"
            })
        })
    }));
}

});
parcelRegister("5iV0P", function(module, exports) {

$parcel$export(module.exports, "SetEditableActions", function () { return $3dcadba765062a82$export$40511102a539d165; });
$parcel$export(module.exports, "GetEditableActions", function () { return $3dcadba765062a82$export$d9ce39e30c4ca3d2; });
const $3dcadba765062a82$var$actionHooks = new WeakMap();
function $3dcadba765062a82$export$40511102a539d165(obj, actions) {
    try {
        $3dcadba765062a82$var$actionHooks.set(obj, actions);
    } catch (error) {
        // This happens sometimes when navigating back (#2418)
        console.error("SetEditableActions", error);
    }
}
function $3dcadba765062a82$export$d9ce39e30c4ca3d2(obj) {
    return $3dcadba765062a82$var$actionHooks.get(obj);
}

});

parcelRegister("dOFTp", function(module, exports) {

$parcel$export(module.exports, "useObserveYProxy", function () { return $a0f070ded9e41b96$export$8f19772320aefea7; });
$parcel$export(module.exports, "useObserveYObject", function () { return $a0f070ded9e41b96$export$511fc6e9270ba89; });

var $eeH7J = parcelRequire("eeH7J");

var $4FdkC = parcelRequire("4FdkC");
function $a0f070ded9e41b96$export$8f19772320aefea7(proxy, deep = false) {
    const target = (0, $4FdkC.GetYProxyTarget)(proxy);
    $a0f070ded9e41b96$export$511fc6e9270ba89(target, deep);
    return target;
}

function $a0f070ded9e41b96$export$511fc6e9270ba89(target, deep = false) {
    const [, setVersion] = (0, $eeH7J.useState)({});
    const editing = !!target;
    (0, $eeH7J.useEffect)(()=>{
        if (!target) return;
        let unmounted = false;
        let observing = false;
        function onChange() {
            setVersion({});
        }
        async function observe() {
            const Y = await Promise.resolve((parcelRequire("aw3rr")));
            if (target instanceof Y.Array || target instanceof Y.Map) {
                if (!unmounted && !observing) {
                    if (deep) target.observeDeep(onChange);
                    else target.observe(onChange);
                    observing = true;
                }
            }
        }
        observe();
        onChange();
        return ()=>{
            var _a;
            unmounted = true;
            if (observing && !((_a = target.doc) === null || _a === void 0 ? void 0 : _a.isDestroyed)) target.unobserve(onChange);
        };
    }, [
        editing,
        target,
        deep
    ]);
    return target;
}

});


parcelRegister("eCMxQ", function(module, exports) {

$parcel$export(module.exports, "GetAncestors", function () { return $aa5a454aeb82e829$export$8c0c7123c7d4ff8; });

var $cwhCA = parcelRequire("cwhCA");

var $43jhg = parcelRequire("43jhg");

var $4FdkC = parcelRequire("4FdkC");

var $aw3rr = parcelRequire("aw3rr");

var $1aVVn = parcelRequire("1aVVn");
function $aa5a454aeb82e829$export$b9fe6ae6245f98f4(resources, obj) {
    function search(name, type, n, putType) {
        var _a, _b;
        type = (0, $cwhCA.SubstituteAndDiscriminate)((0, $1aVVn.YTools).valueToJSON((0, $4FdkC.GetYProxyTarget)(n)), type);
        if (typeof name === "number") {
            const titleProp = (0, $43jhg.GetTypeProps)(type).find((p)=>{
                var _a;
                return (_a = p.tags) === null || _a === void 0 ? void 0 : _a.title;
            });
            if (titleProp) {
                const title = n[titleProp.name];
                if (typeof title === "string") name = title;
            }
        }
        if (typeof name === "number") name = (_a = (0, $43jhg.GetTypeAlias)(type)) !== null && _a !== void 0 ? _a : name.toString();
        const target = (_b = typeof n === "object" ? (0, $4FdkC.GetYProxyTarget)(n) : undefined) !== null && _b !== void 0 ? _b : n;
        if (target instanceof $aw3rr.Array) {
            if (!(0, $43jhg.IsArrayType)(type)) return;
            for(let i = 0; i < n.length; i++){
                if (n[i] === obj) return {
                    name: name,
                    obj: n,
                    type: type,
                    putType: putType
                };
                const parent = search(i, type.array, n[i]);
                if (parent) return parent;
            }
        } else if (target instanceof $aw3rr.Map) {
            const props = (0, $43jhg.GetTypeProps)(type);
            for (const prop of props){
                const value = n[prop.name];
                if (value === obj) return {
                    name: name,
                    obj: n,
                    type: type,
                    putType: putType
                };
                if (value) {
                    const parent = search(prop.name, prop.type, value);
                    if (parent) return parent;
                }
            }
        }
    }
    for (const resource of resources){
        const result = search(resource.res, (0, $cwhCA.GetType)(resource.typeName), resource.proxy, resource.putTypeName ? (0, $cwhCA.GetType)(resource.putTypeName) : undefined);
        if (result) return result;
    }
}
function $aa5a454aeb82e829$export$8c0c7123c7d4ff8(resources, obj) {
    const ancestors = [];
    let current = obj;
    while(current){
        const res = $aa5a454aeb82e829$export$b9fe6ae6245f98f4(resources, current);
        if (res) ancestors.unshift(res);
        current = res === null || res === void 0 ? void 0 : res.obj;
    }
    return ancestors;
}

});


parcelRegister("lWmEE", function(module, exports) {

$parcel$export(module.exports, "useFullHeight", function () { return $ff90967a73e16412$export$23460a878eb8d0be; });
$parcel$export(module.exports, "useHeightLockProvider", function () { return $ff90967a73e16412$export$72e07b1f5997f59f; });

var $4vwom = parcelRequire("4vwom");

var $eeH7J = parcelRequire("eeH7J");
const $ff90967a73e16412$export$f34ed16a558d913a = /*#__PURE__*/ (0, $eeH7J.createContext)(undefined);
function $ff90967a73e16412$export$23460a878eb8d0be() {
    const ctx = (0, $eeH7J.useContext)($ff90967a73e16412$export$f34ed16a558d913a);
    if (!ctx) throw new Error("useFullHeight must be used within a HeightLockContext");
    const { addHeightLock: addFullHeightLock, removeHeightLock: removeFullHeightLock } = ctx;
    (0, $eeH7J.useEffect)(()=>{
        addFullHeightLock();
        return ()=>removeFullHeightLock();
    }, [
        addFullHeightLock,
        removeFullHeightLock
    ]);
}
function $ff90967a73e16412$export$72e07b1f5997f59f() {
    const [heightLockVersion, setHeightLockVersion] = (0, $eeH7J.useState)({});
    const heightLocks = (0, $eeH7J.useRef)(0);
    const height = heightLocks.current ? "100%" : undefined;
    // This weirdness is to force a re-render when the heightLocks change
    // without invalidating the callbacks.
    const addHeightLock = (0, $eeH7J.useCallback)(()=>{
        setHeightLockVersion({});
        heightLocks.current++;
    }, []);
    const removeHeightLock = (0, $eeH7J.useCallback)(()=>{
        setHeightLockVersion({});
        heightLocks.current--;
    }, []);
    return {
        height: height,
        /** A function that renders the context provider with the provided content. */ heightLockProvider: (content)=>(0, $4vwom.jsx)($ff90967a73e16412$export$f34ed16a558d913a.Provider, {
                value: {
                    addHeightLock: addHeightLock,
                    removeHeightLock: removeHeightLock
                },
                children: content
            })
    };
}

});



parcelRegister("xSO5T", function(module, exports) {

$parcel$export(module.exports, "ColorView", function () { return $065d98b442821304$export$52b9401b37c1381e; });

var $4vwom = parcelRequire("4vwom");

var $9HOw2 = parcelRequire("9HOw2");

var $hRViu = parcelRequire("hRViu");
parcelRequire("f5JT9");
var $1qgBp = parcelRequire("1qgBp");

var $eBaY3 = parcelRequire("eBaY3");

var $1aVVn = parcelRequire("1aVVn");
function $065d98b442821304$export$52b9401b37c1381e({ obj: obj, property: property, buttons: buttons, label: label, isEmbedded: isEmbedded }) {
    const [value, setValue] = (0, $1aVVn.useYState)(obj, property.name);
    const isReadonly = (0, $eBaY3.useIsReadonlyField)(property);
    return (0, $4vwom.jsx)((0, $hRViu.PropRow), {
        isReadonly: isReadonly,
        label: label,
        buttons: buttons,
        description: property.description,
        isEmbedded: isEmbedded,
        badge: (0, $4vwom.jsx)((0, $9HOw2.DiagnosticView), {
            property: property,
            value: value
        }),
        children: (0, $4vwom.jsx)((0, $1qgBp.default), {
            color: value || "#000",
            onChangeComplete: (v)=>{
                if (!isReadonly) setValue(v.hex);
            }
        })
    });
}

});
parcelRegister("f5JT9", function(module, exports) {

$parcel$export(module.exports, "ChromePicker", function () { return (parcelRequire("1qgBp")).default; });

var $3TXMZ = parcelRequire("3TXMZ");

var $dJMuE = parcelRequire("dJMuE");

var $gkeQO = parcelRequire("gkeQO");

var $1qgBp = parcelRequire("1qgBp");

var $49RSn = parcelRequire("49RSn");

var $edUUL = parcelRequire("edUUL");

var $8J2Et = parcelRequire("8J2Et");

var $h5WZD = parcelRequire("h5WZD");

var $6T8Ze = parcelRequire("6T8Ze");

var $hWfXp = parcelRequire("hWfXp");

var $aj0NK = parcelRequire("aj0NK");

var $6j91N = parcelRequire("6j91N");

var $l9lNT = parcelRequire("l9lNT");

var $bxThk = parcelRequire("bxThk");

var $8bUgk = parcelRequire("8bUgk");

});
parcelRegister("3TXMZ", function(module, exports) {

var $eeH7J = parcelRequire("eeH7J");

var $bJBxw = parcelRequire("bJBxw");
parcelRequire("isDZf");
var $cydcQ = parcelRequire("cydcQ");
var $8bUgk = parcelRequire("8bUgk");

var $9eoS3 = parcelRequire("9eoS3");
var $2d74e30868c902ed$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $2d74e30868c902ed$export$421d2c1bdabf8a68 = function AlphaPicker(_ref) {
    var rgb = _ref.rgb, hsl = _ref.hsl, width = _ref.width, height = _ref.height, onChange = _ref.onChange, direction = _ref.direction, style = _ref.style, renderers = _ref.renderers, pointer = _ref.pointer, _ref$className = _ref.className, className = _ref$className === undefined ? "" : _ref$className;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($bJBxw)))({
        "default": {
            picker: {
                position: "relative",
                width: width,
                height: height
            },
            alpha: {
                radius: "2px",
                style: style
            }
        }
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        style: styles.picker,
        className: "alpha-picker " + className
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $cydcQ.default), $2d74e30868c902ed$var$_extends({}, styles.alpha, {
        rgb: rgb,
        hsl: hsl,
        pointer: pointer,
        renderers: renderers,
        onChange: onChange,
        direction: direction
    })));
};
$2d74e30868c902ed$export$421d2c1bdabf8a68.defaultProps = {
    width: "316px",
    height: "16px",
    direction: "horizontal",
    pointer: (0, $9eoS3.default)
};
var $2d74e30868c902ed$export$2e2bcd8739ae039 = (0, $8bUgk.default)($2d74e30868c902ed$export$421d2c1bdabf8a68);

});
parcelRegister("bJBxw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ReactCSS = module.exports.loop = module.exports.handleActive = module.exports.handleHover = module.exports.hover = undefined;

var $1G2v7 = parcelRequire("1G2v7");
var $88b1044c55714645$var$_flattenNames2 = $88b1044c55714645$var$_interopRequireDefault($1G2v7);

var $4oNrH = parcelRequire("4oNrH");
var $88b1044c55714645$var$_mergeClasses2 = $88b1044c55714645$var$_interopRequireDefault($4oNrH);

var $j2V18 = parcelRequire("j2V18");
var $88b1044c55714645$var$_autoprefix2 = $88b1044c55714645$var$_interopRequireDefault($j2V18);

var $1wroF = parcelRequire("1wroF");
var $88b1044c55714645$var$_hover3 = $88b1044c55714645$var$_interopRequireDefault($1wroF);

var $5Gg55 = parcelRequire("5Gg55");
var $88b1044c55714645$var$_active2 = $88b1044c55714645$var$_interopRequireDefault($5Gg55);

var $23o4j = parcelRequire("23o4j");
var $88b1044c55714645$var$_loop3 = $88b1044c55714645$var$_interopRequireDefault($23o4j);
function $88b1044c55714645$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
module.exports.hover = $88b1044c55714645$var$_hover3.default;
module.exports.handleHover = $88b1044c55714645$var$_hover3.default;
module.exports.handleActive = $88b1044c55714645$var$_active2.default;
module.exports.loop = $88b1044c55714645$var$_loop3.default;
var $88b1044c55714645$var$ReactCSS = module.exports.ReactCSS = function ReactCSS(classes) {
    for(var _len = arguments.length, activations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)activations[_key - 1] = arguments[_key];
    var activeNames = (0, $88b1044c55714645$var$_flattenNames2.default)(activations);
    var merged = (0, $88b1044c55714645$var$_mergeClasses2.default)(classes, activeNames);
    return (0, $88b1044c55714645$var$_autoprefix2.default)(merged);
};
module.exports.default = $88b1044c55714645$var$ReactCSS;

});
parcelRegister("1G2v7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.flattenNames = undefined;

var $l9xkH = parcelRequire("l9xkH");
var $138ba754b5438268$var$_isString3 = $138ba754b5438268$var$_interopRequireDefault($l9xkH);

var $4fDmP = parcelRequire("4fDmP");
var $138ba754b5438268$var$_forOwn3 = $138ba754b5438268$var$_interopRequireDefault($4fDmP);

var $b4tHN = parcelRequire("b4tHN");
var $138ba754b5438268$var$_isPlainObject3 = $138ba754b5438268$var$_interopRequireDefault($b4tHN);

var $7gF3Q = parcelRequire("7gF3Q");
var $138ba754b5438268$var$_map3 = $138ba754b5438268$var$_interopRequireDefault($7gF3Q);
function $138ba754b5438268$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $138ba754b5438268$var$flattenNames = module.exports.flattenNames = function flattenNames() {
    var things = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var names = [];
    (0, $138ba754b5438268$var$_map3.default)(things, function(thing) {
        if (Array.isArray(thing)) flattenNames(thing).map(function(name) {
            return names.push(name);
        });
        else if ((0, $138ba754b5438268$var$_isPlainObject3.default)(thing)) (0, $138ba754b5438268$var$_forOwn3.default)(thing, function(value, key) {
            value === true && names.push(key);
            names.push(key + "-" + value);
        });
        else if ((0, $138ba754b5438268$var$_isString3.default)(thing)) names.push(thing);
    });
    return names;
};
module.exports.default = $138ba754b5438268$var$flattenNames;

});
parcelRegister("l9xkH", function(module, exports) {

var $2po4Z = parcelRequire("2po4Z");

var $9yJoF = parcelRequire("9yJoF");

var $7004H = parcelRequire("7004H");
/** `Object#toString` result references. */ var $f6644b72543b25d0$var$stringTag = "[object String]";
/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */ function $f6644b72543b25d0$var$isString(value) {
    return typeof value == "string" || !$9yJoF(value) && $7004H(value) && $2po4Z(value) == $f6644b72543b25d0$var$stringTag;
}
module.exports = $f6644b72543b25d0$var$isString;

});
parcelRegister("2po4Z", function(module, exports) {

var $4PsDw = parcelRequire("4PsDw");

var $ih87j = parcelRequire("ih87j");

var $1Re2y = parcelRequire("1Re2y");
/** `Object#toString` result references. */ var $1c109846e1422af5$var$nullTag = "[object Null]", $1c109846e1422af5$var$undefinedTag = "[object Undefined]";
/** Built-in value references. */ var $1c109846e1422af5$var$symToStringTag = $4PsDw ? $4PsDw.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $1c109846e1422af5$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $1c109846e1422af5$var$undefinedTag : $1c109846e1422af5$var$nullTag;
    return $1c109846e1422af5$var$symToStringTag && $1c109846e1422af5$var$symToStringTag in Object(value) ? $ih87j(value) : $1Re2y(value);
}
module.exports = $1c109846e1422af5$var$baseGetTag;

});
parcelRegister("4PsDw", function(module, exports) {

var $670gj = parcelRequire("670gj");
/** Built-in value references. */ var $38422377e4b90883$var$Symbol = $670gj.Symbol;
module.exports = $38422377e4b90883$var$Symbol;

});
parcelRegister("670gj", function(module, exports) {

var $gGfQ8 = parcelRequire("gGfQ8");
/** Detect free variable `self`. */ var $47339993295539c2$var$freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $47339993295539c2$var$root = $gGfQ8 || $47339993295539c2$var$freeSelf || Function("return this")();
module.exports = $47339993295539c2$var$root;

});
parcelRegister("gGfQ8", function(module, exports) {
/** Detect free variable `global` from Node.js. */ var $c24cdb0aeff4a641$var$freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
module.exports = $c24cdb0aeff4a641$var$freeGlobal;

});



parcelRegister("ih87j", function(module, exports) {

var $4PsDw = parcelRequire("4PsDw");
/** Used for built-in method references. */ var $d4e01c5f2715a11b$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $d4e01c5f2715a11b$var$hasOwnProperty = $d4e01c5f2715a11b$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $d4e01c5f2715a11b$var$nativeObjectToString = $d4e01c5f2715a11b$var$objectProto.toString;
/** Built-in value references. */ var $d4e01c5f2715a11b$var$symToStringTag = $4PsDw ? $4PsDw.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $d4e01c5f2715a11b$var$getRawTag(value) {
    var isOwn = $d4e01c5f2715a11b$var$hasOwnProperty.call(value, $d4e01c5f2715a11b$var$symToStringTag), tag = value[$d4e01c5f2715a11b$var$symToStringTag];
    try {
        value[$d4e01c5f2715a11b$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $d4e01c5f2715a11b$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$d4e01c5f2715a11b$var$symToStringTag] = tag;
        else delete value[$d4e01c5f2715a11b$var$symToStringTag];
    }
    return result;
}
module.exports = $d4e01c5f2715a11b$var$getRawTag;

});

parcelRegister("1Re2y", function(module, exports) {
/** Used for built-in method references. */ var $15a5a1cc40a73b6d$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $15a5a1cc40a73b6d$var$nativeObjectToString = $15a5a1cc40a73b6d$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $15a5a1cc40a73b6d$var$objectToString(value) {
    return $15a5a1cc40a73b6d$var$nativeObjectToString.call(value);
}
module.exports = $15a5a1cc40a73b6d$var$objectToString;

});


parcelRegister("9yJoF", function(module, exports) {
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $6f5a80e798063325$var$isArray = Array.isArray;
module.exports = $6f5a80e798063325$var$isArray;

});

parcelRegister("7004H", function(module, exports) {
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $5188975b7cad44c5$var$isObjectLike(value) {
    return value != null && typeof value == "object";
}
module.exports = $5188975b7cad44c5$var$isObjectLike;

});


parcelRegister("4fDmP", function(module, exports) {

var $1X6t4 = parcelRequire("1X6t4");

var $hLgAl = parcelRequire("hLgAl");
/**
 * Iterates over own enumerable string keyed properties of an object and
 * invokes `iteratee` for each property. The iteratee is invoked with three
 * arguments: (value, key, object). Iteratee functions may exit iteration
 * early by explicitly returning `false`.
 *
 * @static
 * @memberOf _
 * @since 0.3.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns `object`.
 * @see _.forOwnRight
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.forOwn(new Foo, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
 */ function $318719a69d0cc713$var$forOwn(object, iteratee) {
    return object && $1X6t4(object, $hLgAl(iteratee));
}
module.exports = $318719a69d0cc713$var$forOwn;

});
parcelRegister("1X6t4", function(module, exports) {

var $89Xvf = parcelRequire("89Xvf");

var $lOxik = parcelRequire("lOxik");
/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */ function $16c0518aee3073d2$var$baseForOwn(object, iteratee) {
    return object && $89Xvf(object, iteratee, $lOxik);
}
module.exports = $16c0518aee3073d2$var$baseForOwn;

});
parcelRegister("89Xvf", function(module, exports) {

var $9vAha = parcelRequire("9vAha");
/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var $5f0d520ab670c24a$var$baseFor = $9vAha();
module.exports = $5f0d520ab670c24a$var$baseFor;

});
parcelRegister("9vAha", function(module, exports) {
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $6ec325f5078fe83b$var$createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
module.exports = $6ec325f5078fe83b$var$createBaseFor;

});


parcelRegister("lOxik", function(module, exports) {

var $k6jBh = parcelRequire("k6jBh");

var $k8u1K = parcelRequire("k8u1K");

var $3XgiU = parcelRequire("3XgiU");
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function $fe18181eec9f466e$var$keys(object) {
    return $3XgiU(object) ? $k6jBh(object) : $k8u1K(object);
}
module.exports = $fe18181eec9f466e$var$keys;

});
parcelRegister("k6jBh", function(module, exports) {

var $iDm5E = parcelRequire("iDm5E");

var $cO2KF = parcelRequire("cO2KF");

var $9yJoF = parcelRequire("9yJoF");

var $etvPu = parcelRequire("etvPu");

var $hlpVF = parcelRequire("hlpVF");

var $hmt8h = parcelRequire("hmt8h");
/** Used for built-in method references. */ var $ea23925fdf992f08$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $ea23925fdf992f08$var$hasOwnProperty = $ea23925fdf992f08$var$objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $ea23925fdf992f08$var$arrayLikeKeys(value, inherited) {
    var isArr = $9yJoF(value), isArg = !isArr && $cO2KF(value), isBuff = !isArr && !isArg && $etvPu(value), isType = !isArr && !isArg && !isBuff && $hmt8h(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? $iDm5E(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || $ea23925fdf992f08$var$hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
    $hlpVF(key, length)))) result.push(key);
    return result;
}
module.exports = $ea23925fdf992f08$var$arrayLikeKeys;

});
parcelRegister("iDm5E", function(module, exports) {
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $d90d012d66ab3f11$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
module.exports = $d90d012d66ab3f11$var$baseTimes;

});

parcelRegister("cO2KF", function(module, exports) {

var $7mVEM = parcelRequire("7mVEM");

var $7004H = parcelRequire("7004H");
/** Used for built-in method references. */ var $952c49f88874830d$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $952c49f88874830d$var$hasOwnProperty = $952c49f88874830d$var$objectProto.hasOwnProperty;
/** Built-in value references. */ var $952c49f88874830d$var$propertyIsEnumerable = $952c49f88874830d$var$objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var $952c49f88874830d$var$isArguments = $7mVEM(function() {
    return arguments;
}()) ? $7mVEM : function(value) {
    return $7004H(value) && $952c49f88874830d$var$hasOwnProperty.call(value, "callee") && !$952c49f88874830d$var$propertyIsEnumerable.call(value, "callee");
};
module.exports = $952c49f88874830d$var$isArguments;

});
parcelRegister("7mVEM", function(module, exports) {

var $2po4Z = parcelRequire("2po4Z");

var $7004H = parcelRequire("7004H");
/** `Object#toString` result references. */ var $55d74fe6ea74b14c$var$argsTag = "[object Arguments]";
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function $55d74fe6ea74b14c$var$baseIsArguments(value) {
    return $7004H(value) && $2po4Z(value) == $55d74fe6ea74b14c$var$argsTag;
}
module.exports = $55d74fe6ea74b14c$var$baseIsArguments;

});


parcelRegister("etvPu", function(module, exports) {

var $670gj = parcelRequire("670gj");

var $4P2kA = parcelRequire("4P2kA");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? $670gj.Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || $4P2kA;
module.exports = isBuffer;

});
parcelRegister("4P2kA", function(module, exports) {
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function $382dbbc404564a2c$var$stubFalse() {
    return false;
}
module.exports = $382dbbc404564a2c$var$stubFalse;

});


parcelRegister("hlpVF", function(module, exports) {
/** Used as references for various `Number` constants. */ var $ca0882ca61ffd0f9$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var $ca0882ca61ffd0f9$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $ca0882ca61ffd0f9$var$isIndex(value, length) {
    var type = typeof value;
    length = length == null ? $ca0882ca61ffd0f9$var$MAX_SAFE_INTEGER : length;
    return !!length && (type == "number" || type != "symbol" && $ca0882ca61ffd0f9$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
module.exports = $ca0882ca61ffd0f9$var$isIndex;

});

parcelRegister("hmt8h", function(module, exports) {

var $kRQza = parcelRequire("kRQza");

var $gouRh = parcelRequire("gouRh");

var $jCPbW = parcelRequire("jCPbW");
/* Node.js helper references. */ var $ca3b16e2adebd851$var$nodeIsTypedArray = $jCPbW && $jCPbW.isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var $ca3b16e2adebd851$var$isTypedArray = $ca3b16e2adebd851$var$nodeIsTypedArray ? $gouRh($ca3b16e2adebd851$var$nodeIsTypedArray) : $kRQza;
module.exports = $ca3b16e2adebd851$var$isTypedArray;

});
parcelRegister("kRQza", function(module, exports) {

var $2po4Z = parcelRequire("2po4Z");

var $8MgsQ = parcelRequire("8MgsQ");

var $7004H = parcelRequire("7004H");
/** `Object#toString` result references. */ var $03eba33bba5373f8$var$argsTag = "[object Arguments]", $03eba33bba5373f8$var$arrayTag = "[object Array]", $03eba33bba5373f8$var$boolTag = "[object Boolean]", $03eba33bba5373f8$var$dateTag = "[object Date]", $03eba33bba5373f8$var$errorTag = "[object Error]", $03eba33bba5373f8$var$funcTag = "[object Function]", $03eba33bba5373f8$var$mapTag = "[object Map]", $03eba33bba5373f8$var$numberTag = "[object Number]", $03eba33bba5373f8$var$objectTag = "[object Object]", $03eba33bba5373f8$var$regexpTag = "[object RegExp]", $03eba33bba5373f8$var$setTag = "[object Set]", $03eba33bba5373f8$var$stringTag = "[object String]", $03eba33bba5373f8$var$weakMapTag = "[object WeakMap]";
var $03eba33bba5373f8$var$arrayBufferTag = "[object ArrayBuffer]", $03eba33bba5373f8$var$dataViewTag = "[object DataView]", $03eba33bba5373f8$var$float32Tag = "[object Float32Array]", $03eba33bba5373f8$var$float64Tag = "[object Float64Array]", $03eba33bba5373f8$var$int8Tag = "[object Int8Array]", $03eba33bba5373f8$var$int16Tag = "[object Int16Array]", $03eba33bba5373f8$var$int32Tag = "[object Int32Array]", $03eba33bba5373f8$var$uint8Tag = "[object Uint8Array]", $03eba33bba5373f8$var$uint8ClampedTag = "[object Uint8ClampedArray]", $03eba33bba5373f8$var$uint16Tag = "[object Uint16Array]", $03eba33bba5373f8$var$uint32Tag = "[object Uint32Array]";
/** Used to identify `toStringTag` values of typed arrays. */ var $03eba33bba5373f8$var$typedArrayTags = {};
$03eba33bba5373f8$var$typedArrayTags[$03eba33bba5373f8$var$float32Tag] = $03eba33bba5373f8$var$typedArrayTags[$03eba33bba5373f8$var$float64Tag] = $03eba33bba5373f8$var$typedArrayTags[$03eba33bba5373f8$var$int8Tag] = $03eba33bba5373f8$var$typedArrayTags[$03eba33bba5373f8$var$int16Tag] = $03eba33bba5373f8$var$typedArrayTags[$03eba33bba5373f8$var$int32Tag] = $03eba33bba5373f8$var$typedArrayTags[$03eba33bba5373f8$var$uint8Tag] = $03eba33bba5373f8$var$typedArrayTags[$03eba33bba5373f8$var$uint8ClampedTag] = $03eba33bba5373f8$var$typedArrayTags[$03eba33bba5373f8$var$uint16Tag] = $03eba33bba5373f8$var$typedArrayTags[$03eba33bba5373f8$var$uint32Tag] = true;
$03eba33bba5373f8$var$typedArrayTags[$03eba33bba5373f8$var$argsTag] = $03eba33bba5373f8$var$typedArrayTags[$03eba33bba5373f8$var$arrayTag] = $03eba33bba5373f8$var$typedArrayTags[$03eba33bba5373f8$var$arrayBufferTag] = $03eba33bba5373f8$var$typedArrayTags[$03eba33bba5373f8$var$boolTag] = $03eba33bba5373f8$var$typedArrayTags[$03eba33bba5373f8$var$dataViewTag] = $03eba33bba5373f8$var$typedArrayTags[$03eba33bba5373f8$var$dateTag] = $03eba33bba5373f8$var$typedArrayTags[$03eba33bba5373f8$var$errorTag] = $03eba33bba5373f8$var$typedArrayTags[$03eba33bba5373f8$var$funcTag] = $03eba33bba5373f8$var$typedArrayTags[$03eba33bba5373f8$var$mapTag] = $03eba33bba5373f8$var$typedArrayTags[$03eba33bba5373f8$var$numberTag] = $03eba33bba5373f8$var$typedArrayTags[$03eba33bba5373f8$var$objectTag] = $03eba33bba5373f8$var$typedArrayTags[$03eba33bba5373f8$var$regexpTag] = $03eba33bba5373f8$var$typedArrayTags[$03eba33bba5373f8$var$setTag] = $03eba33bba5373f8$var$typedArrayTags[$03eba33bba5373f8$var$stringTag] = $03eba33bba5373f8$var$typedArrayTags[$03eba33bba5373f8$var$weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function $03eba33bba5373f8$var$baseIsTypedArray(value) {
    return $7004H(value) && $8MgsQ(value.length) && !!$03eba33bba5373f8$var$typedArrayTags[$2po4Z(value)];
}
module.exports = $03eba33bba5373f8$var$baseIsTypedArray;

});
parcelRegister("8MgsQ", function(module, exports) {
/** Used as references for various `Number` constants. */ var $663f93e59223648f$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $663f93e59223648f$var$isLength(value) {
    return typeof value == "number" && value > -1 && value % 1 == 0 && value <= $663f93e59223648f$var$MAX_SAFE_INTEGER;
}
module.exports = $663f93e59223648f$var$isLength;

});


parcelRegister("gouRh", function(module, exports) {
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function $bef6d3131c47d6d8$var$baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
module.exports = $bef6d3131c47d6d8$var$baseUnary;

});

parcelRegister("jCPbW", function(module, exports) {

var $gGfQ8 = parcelRequire("gGfQ8");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && $gGfQ8.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require("util").types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding("util");
    } catch (e) {}
}();
module.exports = nodeUtil;

});



parcelRegister("k8u1K", function(module, exports) {

var $3zB9f = parcelRequire("3zB9f");

var $gnk7d = parcelRequire("gnk7d");
/** Used for built-in method references. */ var $ea8bd8c8494576f4$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $ea8bd8c8494576f4$var$hasOwnProperty = $ea8bd8c8494576f4$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $ea8bd8c8494576f4$var$baseKeys(object) {
    if (!$3zB9f(object)) return $gnk7d(object);
    var result = [];
    for(var key in Object(object))if ($ea8bd8c8494576f4$var$hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
    return result;
}
module.exports = $ea8bd8c8494576f4$var$baseKeys;

});
parcelRegister("3zB9f", function(module, exports) {
/** Used for built-in method references. */ var $29a174d19294d445$var$objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $29a174d19294d445$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || $29a174d19294d445$var$objectProto;
    return value === proto;
}
module.exports = $29a174d19294d445$var$isPrototype;

});

parcelRegister("gnk7d", function(module, exports) {

var $ju5Lo = parcelRequire("ju5Lo");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $bebe65d1d360c955$var$nativeKeys = $ju5Lo(Object.keys, Object);
module.exports = $bebe65d1d360c955$var$nativeKeys;

});
parcelRegister("ju5Lo", function(module, exports) {
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $e2f54a2af776f5e8$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
module.exports = $e2f54a2af776f5e8$var$overArg;

});



parcelRegister("3XgiU", function(module, exports) {

var $7MWZE = parcelRequire("7MWZE");

var $8MgsQ = parcelRequire("8MgsQ");
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $2e138769f56eb023$var$isArrayLike(value) {
    return value != null && $8MgsQ(value.length) && !$7MWZE(value);
}
module.exports = $2e138769f56eb023$var$isArrayLike;

});
parcelRegister("7MWZE", function(module, exports) {

var $2po4Z = parcelRequire("2po4Z");

var $6AOrv = parcelRequire("6AOrv");
/** `Object#toString` result references. */ var $5abac6f2b484f64d$var$asyncTag = "[object AsyncFunction]", $5abac6f2b484f64d$var$funcTag = "[object Function]", $5abac6f2b484f64d$var$genTag = "[object GeneratorFunction]", $5abac6f2b484f64d$var$proxyTag = "[object Proxy]";
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $5abac6f2b484f64d$var$isFunction(value) {
    if (!$6AOrv(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = $2po4Z(value);
    return tag == $5abac6f2b484f64d$var$funcTag || tag == $5abac6f2b484f64d$var$genTag || tag == $5abac6f2b484f64d$var$asyncTag || tag == $5abac6f2b484f64d$var$proxyTag;
}
module.exports = $5abac6f2b484f64d$var$isFunction;

});
parcelRegister("6AOrv", function(module, exports) {
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $4ccd3bc08bae62d6$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == "object" || type == "function");
}
module.exports = $4ccd3bc08bae62d6$var$isObject;

});





parcelRegister("hLgAl", function(module, exports) {

var $inEtH = parcelRequire("inEtH");
/**
 * Casts `value` to `identity` if it's not a function.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Function} Returns cast function.
 */ function $cee3b0ec74822e7e$var$castFunction(value) {
    return typeof value == "function" ? value : $inEtH;
}
module.exports = $cee3b0ec74822e7e$var$castFunction;

});
parcelRegister("inEtH", function(module, exports) {
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function $d619c6166c2f293d$var$identity(value) {
    return value;
}
module.exports = $d619c6166c2f293d$var$identity;

});



parcelRegister("b4tHN", function(module, exports) {

var $2po4Z = parcelRequire("2po4Z");

var $10UPr = parcelRequire("10UPr");

var $7004H = parcelRequire("7004H");
/** `Object#toString` result references. */ var $80f71c47c5545146$var$objectTag = "[object Object]";
/** Used for built-in method references. */ var $80f71c47c5545146$var$funcProto = Function.prototype, $80f71c47c5545146$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $80f71c47c5545146$var$funcToString = $80f71c47c5545146$var$funcProto.toString;
/** Used to check objects for own properties. */ var $80f71c47c5545146$var$hasOwnProperty = $80f71c47c5545146$var$objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var $80f71c47c5545146$var$objectCtorString = $80f71c47c5545146$var$funcToString.call(Object);
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function $80f71c47c5545146$var$isPlainObject(value) {
    if (!$7004H(value) || $2po4Z(value) != $80f71c47c5545146$var$objectTag) return false;
    var proto = $10UPr(value);
    if (proto === null) return true;
    var Ctor = $80f71c47c5545146$var$hasOwnProperty.call(proto, "constructor") && proto.constructor;
    return typeof Ctor == "function" && Ctor instanceof Ctor && $80f71c47c5545146$var$funcToString.call(Ctor) == $80f71c47c5545146$var$objectCtorString;
}
module.exports = $80f71c47c5545146$var$isPlainObject;

});
parcelRegister("10UPr", function(module, exports) {

var $ju5Lo = parcelRequire("ju5Lo");
/** Built-in value references. */ var $0bd1df8323fb0fd5$var$getPrototype = $ju5Lo(Object.getPrototypeOf, Object);
module.exports = $0bd1df8323fb0fd5$var$getPrototype;

});


parcelRegister("7gF3Q", function(module, exports) {

var $dolrh = parcelRequire("dolrh");

var $kh42Y = parcelRequire("kh42Y");

var $eKMqi = parcelRequire("eKMqi");

var $9yJoF = parcelRequire("9yJoF");
/**
 * Creates an array of values by running each element in `collection` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
 *
 * The guarded methods are:
 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * _.map([4, 8], square);
 * // => [16, 64]
 *
 * _.map({ 'a': 4, 'b': 8 }, square);
 * // => [16, 64] (iteration order is not guaranteed)
 *
 * var users = [
 *   { 'user': 'barney' },
 *   { 'user': 'fred' }
 * ];
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, 'user');
 * // => ['barney', 'fred']
 */ function $54a9e0e05c5ff4f1$var$map(collection, iteratee) {
    var func = $9yJoF(collection) ? $dolrh : $eKMqi;
    return func(collection, $kh42Y(iteratee, 3));
}
module.exports = $54a9e0e05c5ff4f1$var$map;

});
parcelRegister("dolrh", function(module, exports) {
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $9bfe25932a8249eb$var$arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
module.exports = $9bfe25932a8249eb$var$arrayMap;

});

parcelRegister("kh42Y", function(module, exports) {

var $difor = parcelRequire("difor");

var $9AH7n = parcelRequire("9AH7n");

var $inEtH = parcelRequire("inEtH");

var $9yJoF = parcelRequire("9yJoF");

var $9J7TY = parcelRequire("9J7TY");
/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */ function $ec2888ce0234c423$var$baseIteratee(value) {
    // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
    // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
    if (typeof value == "function") return value;
    if (value == null) return $inEtH;
    if (typeof value == "object") return $9yJoF(value) ? $9AH7n(value[0], value[1]) : $difor(value);
    return $9J7TY(value);
}
module.exports = $ec2888ce0234c423$var$baseIteratee;

});
parcelRegister("difor", function(module, exports) {

var $bE3HI = parcelRequire("bE3HI");

var $8QUEF = parcelRequire("8QUEF");

var $8RCdL = parcelRequire("8RCdL");
/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */ function $9ad8e58dc4f40f76$var$baseMatches(source) {
    var matchData = $8QUEF(source);
    if (matchData.length == 1 && matchData[0][2]) return $8RCdL(matchData[0][0], matchData[0][1]);
    return function(object) {
        return object === source || $bE3HI(object, source, matchData);
    };
}
module.exports = $9ad8e58dc4f40f76$var$baseMatches;

});
parcelRegister("bE3HI", function(module, exports) {

var $lEQph = parcelRequire("lEQph");

var $aik8Q = parcelRequire("aik8Q");
/** Used to compose bitmasks for value comparisons. */ var $87a64dadef47d73e$var$COMPARE_PARTIAL_FLAG = 1, $87a64dadef47d73e$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */ function $87a64dadef47d73e$var$baseIsMatch(object, source, matchData, customizer) {
    var index = matchData.length, length = index, noCustomizer = !customizer;
    if (object == null) return !length;
    object = Object(object);
    while(index--){
        var data = matchData[index];
        if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
    }
    while(++index < length){
        data = matchData[index];
        var key = data[0], objValue = object[key], srcValue = data[1];
        if (noCustomizer && data[2]) {
            if (objValue === undefined && !(key in object)) return false;
        } else {
            var stack = new $lEQph;
            if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
            if (!(result === undefined ? $aik8Q(srcValue, objValue, $87a64dadef47d73e$var$COMPARE_PARTIAL_FLAG | $87a64dadef47d73e$var$COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
        }
    }
    return true;
}
module.exports = $87a64dadef47d73e$var$baseIsMatch;

});
parcelRegister("lEQph", function(module, exports) {

var $qmQfH = parcelRequire("qmQfH");

var $woc0P = parcelRequire("woc0P");

var $jPdvu = parcelRequire("jPdvu");

var $eAOtt = parcelRequire("eAOtt");

var $sYBGG = parcelRequire("sYBGG");

var $98v8V = parcelRequire("98v8V");
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $fc45fc460db7b739$var$Stack(entries) {
    var data = this.__data__ = new $qmQfH(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
$fc45fc460db7b739$var$Stack.prototype.clear = $woc0P;
$fc45fc460db7b739$var$Stack.prototype["delete"] = $jPdvu;
$fc45fc460db7b739$var$Stack.prototype.get = $eAOtt;
$fc45fc460db7b739$var$Stack.prototype.has = $sYBGG;
$fc45fc460db7b739$var$Stack.prototype.set = $98v8V;
module.exports = $fc45fc460db7b739$var$Stack;

});
parcelRegister("qmQfH", function(module, exports) {

var $aM2pX = parcelRequire("aM2pX");

var $h1PRL = parcelRequire("h1PRL");

var $ehW0V = parcelRequire("ehW0V");

var $9Av9f = parcelRequire("9Av9f");

var $r1YCR = parcelRequire("r1YCR");
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $04f425b956ac809b$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$04f425b956ac809b$var$ListCache.prototype.clear = $aM2pX;
$04f425b956ac809b$var$ListCache.prototype["delete"] = $h1PRL;
$04f425b956ac809b$var$ListCache.prototype.get = $ehW0V;
$04f425b956ac809b$var$ListCache.prototype.has = $9Av9f;
$04f425b956ac809b$var$ListCache.prototype.set = $r1YCR;
module.exports = $04f425b956ac809b$var$ListCache;

});
parcelRegister("aM2pX", function(module, exports) {
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $7d80433245292a2c$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
module.exports = $7d80433245292a2c$var$listCacheClear;

});

parcelRegister("h1PRL", function(module, exports) {

var $hsKjl = parcelRequire("hsKjl");
/** Used for built-in method references. */ var $c65ac335cf242164$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $c65ac335cf242164$var$splice = $c65ac335cf242164$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $c65ac335cf242164$var$listCacheDelete(key) {
    var data = this.__data__, index = $hsKjl(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $c65ac335cf242164$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
module.exports = $c65ac335cf242164$var$listCacheDelete;

});
parcelRegister("hsKjl", function(module, exports) {

var $jKXSh = parcelRequire("jKXSh");
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $cb68f99bcd12729f$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ($jKXSh(array[length][0], key)) return length;
    }
    return -1;
}
module.exports = $cb68f99bcd12729f$var$assocIndexOf;

});
parcelRegister("jKXSh", function(module, exports) {
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $e620c205668af378$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
module.exports = $e620c205668af378$var$eq;

});



parcelRegister("ehW0V", function(module, exports) {

var $hsKjl = parcelRequire("hsKjl");
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $a66fa7978e0ce50b$var$listCacheGet(key) {
    var data = this.__data__, index = $hsKjl(data, key);
    return index < 0 ? undefined : data[index][1];
}
module.exports = $a66fa7978e0ce50b$var$listCacheGet;

});

parcelRegister("9Av9f", function(module, exports) {

var $hsKjl = parcelRequire("hsKjl");
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $6fafa33856d519ec$var$listCacheHas(key) {
    return $hsKjl(this.__data__, key) > -1;
}
module.exports = $6fafa33856d519ec$var$listCacheHas;

});

parcelRegister("r1YCR", function(module, exports) {

var $hsKjl = parcelRequire("hsKjl");
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $05140e4a1368b0c7$var$listCacheSet(key, value) {
    var data = this.__data__, index = $hsKjl(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
module.exports = $05140e4a1368b0c7$var$listCacheSet;

});


parcelRegister("woc0P", function(module, exports) {

var $qmQfH = parcelRequire("qmQfH");
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function $0615c172f35e1194$var$stackClear() {
    this.__data__ = new $qmQfH;
    this.size = 0;
}
module.exports = $0615c172f35e1194$var$stackClear;

});

parcelRegister("jPdvu", function(module, exports) {
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $e6ed41f1677f9012$var$stackDelete(key) {
    var data = this.__data__, result = data["delete"](key);
    this.size = data.size;
    return result;
}
module.exports = $e6ed41f1677f9012$var$stackDelete;

});

parcelRegister("eAOtt", function(module, exports) {
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $a9fb94a03986c3dd$var$stackGet(key) {
    return this.__data__.get(key);
}
module.exports = $a9fb94a03986c3dd$var$stackGet;

});

parcelRegister("sYBGG", function(module, exports) {
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $0571a0e676afa454$var$stackHas(key) {
    return this.__data__.has(key);
}
module.exports = $0571a0e676afa454$var$stackHas;

});

parcelRegister("98v8V", function(module, exports) {

var $qmQfH = parcelRequire("qmQfH");

var $jv3pw = parcelRequire("jv3pw");

var $bHcIK = parcelRequire("bHcIK");
/** Used as the size to enable large array optimizations. */ var $6a6d04c47550ce38$var$LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function $6a6d04c47550ce38$var$stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof $qmQfH) {
        var pairs = data.__data__;
        if (!$jv3pw || pairs.length < $6a6d04c47550ce38$var$LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new $bHcIK(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
module.exports = $6a6d04c47550ce38$var$stackSet;

});
parcelRegister("jv3pw", function(module, exports) {

var $lmk4C = parcelRequire("lmk4C");

var $670gj = parcelRequire("670gj");
/* Built-in method references that are verified to be native. */ var $e3238ee12913649c$var$Map = $lmk4C($670gj, "Map");
module.exports = $e3238ee12913649c$var$Map;

});
parcelRegister("lmk4C", function(module, exports) {

var $kyl5M = parcelRequire("kyl5M");

var $9NzUI = parcelRequire("9NzUI");
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $f8cb39379728d11c$var$getNative(object, key) {
    var value = $9NzUI(object, key);
    return $kyl5M(value) ? value : undefined;
}
module.exports = $f8cb39379728d11c$var$getNative;

});
parcelRegister("kyl5M", function(module, exports) {

var $7MWZE = parcelRequire("7MWZE");

var $jpVN2 = parcelRequire("jpVN2");

var $6AOrv = parcelRequire("6AOrv");

var $azAeT = parcelRequire("azAeT");
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $ef675819d7dd35e8$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $ef675819d7dd35e8$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $ef675819d7dd35e8$var$funcProto = Function.prototype, $ef675819d7dd35e8$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $ef675819d7dd35e8$var$funcToString = $ef675819d7dd35e8$var$funcProto.toString;
/** Used to check objects for own properties. */ var $ef675819d7dd35e8$var$hasOwnProperty = $ef675819d7dd35e8$var$objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var $ef675819d7dd35e8$var$reIsNative = RegExp("^" + $ef675819d7dd35e8$var$funcToString.call($ef675819d7dd35e8$var$hasOwnProperty).replace($ef675819d7dd35e8$var$reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $ef675819d7dd35e8$var$baseIsNative(value) {
    if (!$6AOrv(value) || $jpVN2(value)) return false;
    var pattern = $7MWZE(value) ? $ef675819d7dd35e8$var$reIsNative : $ef675819d7dd35e8$var$reIsHostCtor;
    return pattern.test($azAeT(value));
}
module.exports = $ef675819d7dd35e8$var$baseIsNative;

});
parcelRegister("jpVN2", function(module, exports) {

var $wWCnf = parcelRequire("wWCnf");
/** Used to detect methods masquerading as native. */ var $e22d2e0563e9381f$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec($wWCnf && $wWCnf.keys && $wWCnf.keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $e22d2e0563e9381f$var$isMasked(func) {
    return !!$e22d2e0563e9381f$var$maskSrcKey && $e22d2e0563e9381f$var$maskSrcKey in func;
}
module.exports = $e22d2e0563e9381f$var$isMasked;

});
parcelRegister("wWCnf", function(module, exports) {

var $670gj = parcelRequire("670gj");
/** Used to detect overreaching core-js shims. */ var $0630759302876204$var$coreJsData = $670gj["__core-js_shared__"];
module.exports = $0630759302876204$var$coreJsData;

});


parcelRegister("azAeT", function(module, exports) {
/** Used for built-in method references. */ var $7b29489b8a37a7d5$var$funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $7b29489b8a37a7d5$var$funcToString = $7b29489b8a37a7d5$var$funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $7b29489b8a37a7d5$var$toSource(func) {
    if (func != null) {
        try {
            return $7b29489b8a37a7d5$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + "";
        } catch (e) {}
    }
    return "";
}
module.exports = $7b29489b8a37a7d5$var$toSource;

});


parcelRegister("9NzUI", function(module, exports) {
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $72248c65eb0b86ac$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
module.exports = $72248c65eb0b86ac$var$getValue;

});



parcelRegister("bHcIK", function(module, exports) {

var $a4vtA = parcelRequire("a4vtA");

var $5zMUD = parcelRequire("5zMUD");

var $kNk1w = parcelRequire("kNk1w");

var $juGFN = parcelRequire("juGFN");

var $dQbM2 = parcelRequire("dQbM2");
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $883d93f394a42c19$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$883d93f394a42c19$var$MapCache.prototype.clear = $a4vtA;
$883d93f394a42c19$var$MapCache.prototype["delete"] = $5zMUD;
$883d93f394a42c19$var$MapCache.prototype.get = $kNk1w;
$883d93f394a42c19$var$MapCache.prototype.has = $juGFN;
$883d93f394a42c19$var$MapCache.prototype.set = $dQbM2;
module.exports = $883d93f394a42c19$var$MapCache;

});
parcelRegister("a4vtA", function(module, exports) {

var $6tBR0 = parcelRequire("6tBR0");

var $qmQfH = parcelRequire("qmQfH");

var $jv3pw = parcelRequire("jv3pw");
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $7552b19c1d2ee879$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        "hash": new $6tBR0,
        "map": new ($jv3pw || $qmQfH),
        "string": new $6tBR0
    };
}
module.exports = $7552b19c1d2ee879$var$mapCacheClear;

});
parcelRegister("6tBR0", function(module, exports) {

var $bQtJI = parcelRequire("bQtJI");

var $4sEbK = parcelRequire("4sEbK");

var $57rNa = parcelRequire("57rNa");

var $gid9M = parcelRequire("gid9M");

var $8XqRP = parcelRequire("8XqRP");
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $4b72d07d396ab763$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$4b72d07d396ab763$var$Hash.prototype.clear = $bQtJI;
$4b72d07d396ab763$var$Hash.prototype["delete"] = $4sEbK;
$4b72d07d396ab763$var$Hash.prototype.get = $57rNa;
$4b72d07d396ab763$var$Hash.prototype.has = $gid9M;
$4b72d07d396ab763$var$Hash.prototype.set = $8XqRP;
module.exports = $4b72d07d396ab763$var$Hash;

});
parcelRegister("bQtJI", function(module, exports) {

var $h8dTY = parcelRequire("h8dTY");
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $89fb9e08e3af02a2$var$hashClear() {
    this.__data__ = $h8dTY ? $h8dTY(null) : {};
    this.size = 0;
}
module.exports = $89fb9e08e3af02a2$var$hashClear;

});
parcelRegister("h8dTY", function(module, exports) {

var $lmk4C = parcelRequire("lmk4C");
/* Built-in method references that are verified to be native. */ var $c78df7a648626f9a$var$nativeCreate = $lmk4C(Object, "create");
module.exports = $c78df7a648626f9a$var$nativeCreate;

});


parcelRegister("4sEbK", function(module, exports) {
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $33f8f386bd4a39f2$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = $33f8f386bd4a39f2$var$hashDelete;

});

parcelRegister("57rNa", function(module, exports) {

var $h8dTY = parcelRequire("h8dTY");
/** Used to stand-in for `undefined` hash values. */ var $3ba32a1b80aa5c29$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/** Used for built-in method references. */ var $3ba32a1b80aa5c29$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $3ba32a1b80aa5c29$var$hasOwnProperty = $3ba32a1b80aa5c29$var$objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $3ba32a1b80aa5c29$var$hashGet(key) {
    var data = this.__data__;
    if ($h8dTY) {
        var result = data[key];
        return result === $3ba32a1b80aa5c29$var$HASH_UNDEFINED ? undefined : result;
    }
    return $3ba32a1b80aa5c29$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
module.exports = $3ba32a1b80aa5c29$var$hashGet;

});

parcelRegister("gid9M", function(module, exports) {

var $h8dTY = parcelRequire("h8dTY");
/** Used for built-in method references. */ var $bdc8887343d202c0$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $bdc8887343d202c0$var$hasOwnProperty = $bdc8887343d202c0$var$objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $bdc8887343d202c0$var$hashHas(key) {
    var data = this.__data__;
    return $h8dTY ? data[key] !== undefined : $bdc8887343d202c0$var$hasOwnProperty.call(data, key);
}
module.exports = $bdc8887343d202c0$var$hashHas;

});

parcelRegister("8XqRP", function(module, exports) {

var $h8dTY = parcelRequire("h8dTY");
/** Used to stand-in for `undefined` hash values. */ var $6858acb0871b463e$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $6858acb0871b463e$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = $h8dTY && value === undefined ? $6858acb0871b463e$var$HASH_UNDEFINED : value;
    return this;
}
module.exports = $6858acb0871b463e$var$hashSet;

});



parcelRegister("5zMUD", function(module, exports) {

var $cohnt = parcelRequire("cohnt");
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $40f6299cb2e1de05$var$mapCacheDelete(key) {
    var result = $cohnt(this, key)["delete"](key);
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = $40f6299cb2e1de05$var$mapCacheDelete;

});
parcelRegister("cohnt", function(module, exports) {

var $cPTA9 = parcelRequire("cPTA9");
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $905534c65ab3482f$var$getMapData(map, key) {
    var data = map.__data__;
    return $cPTA9(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
module.exports = $905534c65ab3482f$var$getMapData;

});
parcelRegister("cPTA9", function(module, exports) {
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $95855cec243bad3c$var$isKeyable(value) {
    var type = typeof value;
    return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
module.exports = $95855cec243bad3c$var$isKeyable;

});



parcelRegister("kNk1w", function(module, exports) {

var $cohnt = parcelRequire("cohnt");
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $f237ea7d386d73f3$var$mapCacheGet(key) {
    return $cohnt(this, key).get(key);
}
module.exports = $f237ea7d386d73f3$var$mapCacheGet;

});

parcelRegister("juGFN", function(module, exports) {

var $cohnt = parcelRequire("cohnt");
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $e311eba61a544757$var$mapCacheHas(key) {
    return $cohnt(this, key).has(key);
}
module.exports = $e311eba61a544757$var$mapCacheHas;

});

parcelRegister("dQbM2", function(module, exports) {

var $cohnt = parcelRequire("cohnt");
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $a13943b341499e94$var$mapCacheSet(key, value) {
    var data = $cohnt(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
module.exports = $a13943b341499e94$var$mapCacheSet;

});




parcelRegister("aik8Q", function(module, exports) {

var $e57tb = parcelRequire("e57tb");

var $7004H = parcelRequire("7004H");
/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function $77eb358af26f84f5$var$baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !$7004H(value) && !$7004H(other)) return value !== value && other !== other;
    return $e57tb(value, other, bitmask, customizer, $77eb358af26f84f5$var$baseIsEqual, stack);
}
module.exports = $77eb358af26f84f5$var$baseIsEqual;

});
parcelRegister("e57tb", function(module, exports) {

var $lEQph = parcelRequire("lEQph");

var $2A5vY = parcelRequire("2A5vY");

var $hS0Yg = parcelRequire("hS0Yg");

var $bsDXS = parcelRequire("bsDXS");

var $h21lV = parcelRequire("h21lV");

var $9yJoF = parcelRequire("9yJoF");

var $etvPu = parcelRequire("etvPu");

var $hmt8h = parcelRequire("hmt8h");
/** Used to compose bitmasks for value comparisons. */ var $a40753a635b3d091$var$COMPARE_PARTIAL_FLAG = 1;
/** `Object#toString` result references. */ var $a40753a635b3d091$var$argsTag = "[object Arguments]", $a40753a635b3d091$var$arrayTag = "[object Array]", $a40753a635b3d091$var$objectTag = "[object Object]";
/** Used for built-in method references. */ var $a40753a635b3d091$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $a40753a635b3d091$var$hasOwnProperty = $a40753a635b3d091$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $a40753a635b3d091$var$baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = $9yJoF(object), othIsArr = $9yJoF(other), objTag = objIsArr ? $a40753a635b3d091$var$arrayTag : $h21lV(object), othTag = othIsArr ? $a40753a635b3d091$var$arrayTag : $h21lV(other);
    objTag = objTag == $a40753a635b3d091$var$argsTag ? $a40753a635b3d091$var$objectTag : objTag;
    othTag = othTag == $a40753a635b3d091$var$argsTag ? $a40753a635b3d091$var$objectTag : othTag;
    var objIsObj = objTag == $a40753a635b3d091$var$objectTag, othIsObj = othTag == $a40753a635b3d091$var$objectTag, isSameTag = objTag == othTag;
    if (isSameTag && $etvPu(object)) {
        if (!$etvPu(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new $lEQph);
        return objIsArr || $hmt8h(object) ? $2A5vY(object, other, bitmask, customizer, equalFunc, stack) : $hS0Yg(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & $a40753a635b3d091$var$COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && $a40753a635b3d091$var$hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && $a40753a635b3d091$var$hasOwnProperty.call(other, "__wrapped__");
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new $lEQph);
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new $lEQph);
    return $bsDXS(object, other, bitmask, customizer, equalFunc, stack);
}
module.exports = $a40753a635b3d091$var$baseIsEqualDeep;

});
parcelRegister("2A5vY", function(module, exports) {

var $4HSwZ = parcelRequire("4HSwZ");

var $kR0Co = parcelRequire("kR0Co");

var $h6nXY = parcelRequire("h6nXY");
/** Used to compose bitmasks for value comparisons. */ var $1e1338a6f6abc879$var$COMPARE_PARTIAL_FLAG = 1, $1e1338a6f6abc879$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function $1e1338a6f6abc879$var$equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $1e1338a6f6abc879$var$COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Check that cyclic values are equal.
    var arrStacked = stack.get(array);
    var othStacked = stack.get(other);
    if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
    var index = -1, result = true, seen = bitmask & $1e1338a6f6abc879$var$COMPARE_UNORDERED_FLAG ? new $4HSwZ : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!$kR0Co(other, function(othValue, othIndex) {
                if (!$h6nXY(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack["delete"](array);
    stack["delete"](other);
    return result;
}
module.exports = $1e1338a6f6abc879$var$equalArrays;

});
parcelRegister("4HSwZ", function(module, exports) {

var $bHcIK = parcelRequire("bHcIK");

var $ixw9U = parcelRequire("ixw9U");

var $sUHHw = parcelRequire("sUHHw");
/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function $36d57a53c6b2d352$var$SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new $bHcIK;
    while(++index < length)this.add(values[index]);
}
// Add methods to `SetCache`.
$36d57a53c6b2d352$var$SetCache.prototype.add = $36d57a53c6b2d352$var$SetCache.prototype.push = $ixw9U;
$36d57a53c6b2d352$var$SetCache.prototype.has = $sUHHw;
module.exports = $36d57a53c6b2d352$var$SetCache;

});
parcelRegister("ixw9U", function(module, exports) {
/** Used to stand-in for `undefined` hash values. */ var $d7f4411c64491e7f$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function $d7f4411c64491e7f$var$setCacheAdd(value) {
    this.__data__.set(value, $d7f4411c64491e7f$var$HASH_UNDEFINED);
    return this;
}
module.exports = $d7f4411c64491e7f$var$setCacheAdd;

});

parcelRegister("sUHHw", function(module, exports) {
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function $056e99d810bb2b21$var$setCacheHas(value) {
    return this.__data__.has(value);
}
module.exports = $056e99d810bb2b21$var$setCacheHas;

});


parcelRegister("kR0Co", function(module, exports) {
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function $f2e93ca7651c4308$var$arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
module.exports = $f2e93ca7651c4308$var$arraySome;

});

parcelRegister("h6nXY", function(module, exports) {
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $c735966c5af6027f$var$cacheHas(cache, key) {
    return cache.has(key);
}
module.exports = $c735966c5af6027f$var$cacheHas;

});


parcelRegister("hS0Yg", function(module, exports) {

var $4PsDw = parcelRequire("4PsDw");

var $hmhYV = parcelRequire("hmhYV");

var $jKXSh = parcelRequire("jKXSh");

var $2A5vY = parcelRequire("2A5vY");

var $778de = parcelRequire("778de");

var $6BGl3 = parcelRequire("6BGl3");
/** Used to compose bitmasks for value comparisons. */ var $d0283ba6febeb8e3$var$COMPARE_PARTIAL_FLAG = 1, $d0283ba6febeb8e3$var$COMPARE_UNORDERED_FLAG = 2;
/** `Object#toString` result references. */ var $d0283ba6febeb8e3$var$boolTag = "[object Boolean]", $d0283ba6febeb8e3$var$dateTag = "[object Date]", $d0283ba6febeb8e3$var$errorTag = "[object Error]", $d0283ba6febeb8e3$var$mapTag = "[object Map]", $d0283ba6febeb8e3$var$numberTag = "[object Number]", $d0283ba6febeb8e3$var$regexpTag = "[object RegExp]", $d0283ba6febeb8e3$var$setTag = "[object Set]", $d0283ba6febeb8e3$var$stringTag = "[object String]", $d0283ba6febeb8e3$var$symbolTag = "[object Symbol]";
var $d0283ba6febeb8e3$var$arrayBufferTag = "[object ArrayBuffer]", $d0283ba6febeb8e3$var$dataViewTag = "[object DataView]";
/** Used to convert symbols to primitives and strings. */ var $d0283ba6febeb8e3$var$symbolProto = $4PsDw ? $4PsDw.prototype : undefined, $d0283ba6febeb8e3$var$symbolValueOf = $d0283ba6febeb8e3$var$symbolProto ? $d0283ba6febeb8e3$var$symbolProto.valueOf : undefined;
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $d0283ba6febeb8e3$var$equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case $d0283ba6febeb8e3$var$dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case $d0283ba6febeb8e3$var$arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new $hmhYV(object), new $hmhYV(other))) return false;
            return true;
        case $d0283ba6febeb8e3$var$boolTag:
        case $d0283ba6febeb8e3$var$dateTag:
        case $d0283ba6febeb8e3$var$numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return $jKXSh(+object, +other);
        case $d0283ba6febeb8e3$var$errorTag:
            return object.name == other.name && object.message == other.message;
        case $d0283ba6febeb8e3$var$regexpTag:
        case $d0283ba6febeb8e3$var$stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + "";
        case $d0283ba6febeb8e3$var$mapTag:
            var convert = $778de;
        case $d0283ba6febeb8e3$var$setTag:
            var isPartial = bitmask & $d0283ba6febeb8e3$var$COMPARE_PARTIAL_FLAG;
            convert || (convert = $6BGl3);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= $d0283ba6febeb8e3$var$COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = $2A5vY(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack["delete"](object);
            return result;
        case $d0283ba6febeb8e3$var$symbolTag:
            if ($d0283ba6febeb8e3$var$symbolValueOf) return $d0283ba6febeb8e3$var$symbolValueOf.call(object) == $d0283ba6febeb8e3$var$symbolValueOf.call(other);
    }
    return false;
}
module.exports = $d0283ba6febeb8e3$var$equalByTag;

});
parcelRegister("hmhYV", function(module, exports) {

var $670gj = parcelRequire("670gj");
/** Built-in value references. */ var $ca327083cdd4be51$var$Uint8Array = $670gj.Uint8Array;
module.exports = $ca327083cdd4be51$var$Uint8Array;

});

parcelRegister("778de", function(module, exports) {
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function $52df8ead90e90dce$var$mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
module.exports = $52df8ead90e90dce$var$mapToArray;

});

parcelRegister("6BGl3", function(module, exports) {
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function $4cf70a545bf15f76$var$setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
module.exports = $4cf70a545bf15f76$var$setToArray;

});


parcelRegister("bsDXS", function(module, exports) {

var $6nQ6p = parcelRequire("6nQ6p");
/** Used to compose bitmasks for value comparisons. */ var $85814f6475ddec07$var$COMPARE_PARTIAL_FLAG = 1;
/** Used for built-in method references. */ var $85814f6475ddec07$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $85814f6475ddec07$var$hasOwnProperty = $85814f6475ddec07$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $85814f6475ddec07$var$equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $85814f6475ddec07$var$COMPARE_PARTIAL_FLAG, objProps = $6nQ6p(object), objLength = objProps.length, othProps = $6nQ6p(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : $85814f6475ddec07$var$hasOwnProperty.call(other, key))) return false;
    }
    // Check that cyclic values are equal.
    var objStacked = stack.get(object);
    var othStacked = stack.get(other);
    if (objStacked && othStacked) return objStacked == other && othStacked == object;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == "constructor");
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && "constructor" in object && "constructor" in other && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) result = false;
    }
    stack["delete"](object);
    stack["delete"](other);
    return result;
}
module.exports = $85814f6475ddec07$var$equalObjects;

});
parcelRegister("6nQ6p", function(module, exports) {

var $8Kmz4 = parcelRequire("8Kmz4");

var $5HbgL = parcelRequire("5HbgL");

var $lOxik = parcelRequire("lOxik");
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $4a5d4e8672052dd8$var$getAllKeys(object) {
    return $8Kmz4(object, $lOxik, $5HbgL);
}
module.exports = $4a5d4e8672052dd8$var$getAllKeys;

});
parcelRegister("8Kmz4", function(module, exports) {

var $3rL3Z = parcelRequire("3rL3Z");

var $9yJoF = parcelRequire("9yJoF");
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $65e41f7def8bea4c$var$baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return $9yJoF(object) ? result : $3rL3Z(result, symbolsFunc(object));
}
module.exports = $65e41f7def8bea4c$var$baseGetAllKeys;

});
parcelRegister("3rL3Z", function(module, exports) {
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function $2828668373b7e86b$var$arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
module.exports = $2828668373b7e86b$var$arrayPush;

});


parcelRegister("5HbgL", function(module, exports) {

var $jfCg4 = parcelRequire("jfCg4");

var $cwivT = parcelRequire("cwivT");
/** Used for built-in method references. */ var $4259b5c48eed3385$var$objectProto = Object.prototype;
/** Built-in value references. */ var $4259b5c48eed3385$var$propertyIsEnumerable = $4259b5c48eed3385$var$objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $4259b5c48eed3385$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $4259b5c48eed3385$var$getSymbols = !$4259b5c48eed3385$var$nativeGetSymbols ? $cwivT : function(object) {
    if (object == null) return [];
    object = Object(object);
    return $jfCg4($4259b5c48eed3385$var$nativeGetSymbols(object), function(symbol) {
        return $4259b5c48eed3385$var$propertyIsEnumerable.call(object, symbol);
    });
};
module.exports = $4259b5c48eed3385$var$getSymbols;

});
parcelRegister("jfCg4", function(module, exports) {
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $e03d1852dfb1db75$var$arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
module.exports = $e03d1852dfb1db75$var$arrayFilter;

});

parcelRegister("cwivT", function(module, exports) {
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function $91d6d593b6c2242e$var$stubArray() {
    return [];
}
module.exports = $91d6d593b6c2242e$var$stubArray;

});




parcelRegister("h21lV", function(module, exports) {

var $3Rl6i = parcelRequire("3Rl6i");

var $jv3pw = parcelRequire("jv3pw");

var $6jFjr = parcelRequire("6jFjr");

var $MxoDX = parcelRequire("MxoDX");

var $l2p1x = parcelRequire("l2p1x");

var $2po4Z = parcelRequire("2po4Z");

var $azAeT = parcelRequire("azAeT");
/** `Object#toString` result references. */ var $c663ac3340ae323c$var$mapTag = "[object Map]", $c663ac3340ae323c$var$objectTag = "[object Object]", $c663ac3340ae323c$var$promiseTag = "[object Promise]", $c663ac3340ae323c$var$setTag = "[object Set]", $c663ac3340ae323c$var$weakMapTag = "[object WeakMap]";
var $c663ac3340ae323c$var$dataViewTag = "[object DataView]";
/** Used to detect maps, sets, and weakmaps. */ var $c663ac3340ae323c$var$dataViewCtorString = $azAeT($3Rl6i), $c663ac3340ae323c$var$mapCtorString = $azAeT($jv3pw), $c663ac3340ae323c$var$promiseCtorString = $azAeT($6jFjr), $c663ac3340ae323c$var$setCtorString = $azAeT($MxoDX), $c663ac3340ae323c$var$weakMapCtorString = $azAeT($l2p1x);
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var $c663ac3340ae323c$var$getTag = $2po4Z;
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ($3Rl6i && $c663ac3340ae323c$var$getTag(new $3Rl6i(new ArrayBuffer(1))) != $c663ac3340ae323c$var$dataViewTag || $jv3pw && $c663ac3340ae323c$var$getTag(new $jv3pw) != $c663ac3340ae323c$var$mapTag || $6jFjr && $c663ac3340ae323c$var$getTag($6jFjr.resolve()) != $c663ac3340ae323c$var$promiseTag || $MxoDX && $c663ac3340ae323c$var$getTag(new $MxoDX) != $c663ac3340ae323c$var$setTag || $l2p1x && $c663ac3340ae323c$var$getTag(new $l2p1x) != $c663ac3340ae323c$var$weakMapTag) $c663ac3340ae323c$var$getTag = function(value) {
    var result = $2po4Z(value), Ctor = result == $c663ac3340ae323c$var$objectTag ? value.constructor : undefined, ctorString = Ctor ? $azAeT(Ctor) : "";
    if (ctorString) switch(ctorString){
        case $c663ac3340ae323c$var$dataViewCtorString:
            return $c663ac3340ae323c$var$dataViewTag;
        case $c663ac3340ae323c$var$mapCtorString:
            return $c663ac3340ae323c$var$mapTag;
        case $c663ac3340ae323c$var$promiseCtorString:
            return $c663ac3340ae323c$var$promiseTag;
        case $c663ac3340ae323c$var$setCtorString:
            return $c663ac3340ae323c$var$setTag;
        case $c663ac3340ae323c$var$weakMapCtorString:
            return $c663ac3340ae323c$var$weakMapTag;
    }
    return result;
};
module.exports = $c663ac3340ae323c$var$getTag;

});
parcelRegister("3Rl6i", function(module, exports) {

var $lmk4C = parcelRequire("lmk4C");

var $670gj = parcelRequire("670gj");
/* Built-in method references that are verified to be native. */ var $2cf6b07cf380d1dc$var$DataView = $lmk4C($670gj, "DataView");
module.exports = $2cf6b07cf380d1dc$var$DataView;

});

parcelRegister("6jFjr", function(module, exports) {

var $lmk4C = parcelRequire("lmk4C");

var $670gj = parcelRequire("670gj");
/* Built-in method references that are verified to be native. */ var $49949043198d0f76$var$Promise = $lmk4C($670gj, "Promise");
module.exports = $49949043198d0f76$var$Promise;

});

parcelRegister("MxoDX", function(module, exports) {

var $lmk4C = parcelRequire("lmk4C");

var $670gj = parcelRequire("670gj");
/* Built-in method references that are verified to be native. */ var $091e63a778593cff$var$Set = $lmk4C($670gj, "Set");
module.exports = $091e63a778593cff$var$Set;

});

parcelRegister("l2p1x", function(module, exports) {

var $lmk4C = parcelRequire("lmk4C");

var $670gj = parcelRequire("670gj");
/* Built-in method references that are verified to be native. */ var $f50d32193ef56417$var$WeakMap = $lmk4C($670gj, "WeakMap");
module.exports = $f50d32193ef56417$var$WeakMap;

});





parcelRegister("8QUEF", function(module, exports) {

var $5uweQ = parcelRequire("5uweQ");

var $lOxik = parcelRequire("lOxik");
/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */ function $671f2090ea009f2e$var$getMatchData(object) {
    var result = $lOxik(object), length = result.length;
    while(length--){
        var key = result[length], value = object[key];
        result[length] = [
            key,
            value,
            $5uweQ(value)
        ];
    }
    return result;
}
module.exports = $671f2090ea009f2e$var$getMatchData;

});
parcelRegister("5uweQ", function(module, exports) {

var $6AOrv = parcelRequire("6AOrv");
/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */ function $3ff8c2f3f8cbc61f$var$isStrictComparable(value) {
    return value === value && !$6AOrv(value);
}
module.exports = $3ff8c2f3f8cbc61f$var$isStrictComparable;

});


parcelRegister("8RCdL", function(module, exports) {
/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $6740ebdd8fcf04e8$var$matchesStrictComparable(key, srcValue) {
    return function(object) {
        if (object == null) return false;
        return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
    };
}
module.exports = $6740ebdd8fcf04e8$var$matchesStrictComparable;

});


parcelRegister("9AH7n", function(module, exports) {

var $aik8Q = parcelRequire("aik8Q");

var $bLgSP = parcelRequire("bLgSP");

var $eXq9K = parcelRequire("eXq9K");

var $2zeMC = parcelRequire("2zeMC");

var $5uweQ = parcelRequire("5uweQ");

var $8RCdL = parcelRequire("8RCdL");

var $8KACs = parcelRequire("8KACs");
/** Used to compose bitmasks for value comparisons. */ var $6fb8ec29129ca398$var$COMPARE_PARTIAL_FLAG = 1, $6fb8ec29129ca398$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $6fb8ec29129ca398$var$baseMatchesProperty(path, srcValue) {
    if ($2zeMC(path) && $5uweQ(srcValue)) return $8RCdL($8KACs(path), srcValue);
    return function(object) {
        var objValue = $bLgSP(object, path);
        return objValue === undefined && objValue === srcValue ? $eXq9K(object, path) : $aik8Q(srcValue, objValue, $6fb8ec29129ca398$var$COMPARE_PARTIAL_FLAG | $6fb8ec29129ca398$var$COMPARE_UNORDERED_FLAG);
    };
}
module.exports = $6fb8ec29129ca398$var$baseMatchesProperty;

});
parcelRegister("bLgSP", function(module, exports) {

var $7Q5zN = parcelRequire("7Q5zN");
/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function $0235b24b0dbd4897$var$get(object, path, defaultValue) {
    var result = object == null ? undefined : $7Q5zN(object, path);
    return result === undefined ? defaultValue : result;
}
module.exports = $0235b24b0dbd4897$var$get;

});
parcelRegister("7Q5zN", function(module, exports) {

var $gCKFj = parcelRequire("gCKFj");

var $8KACs = parcelRequire("8KACs");
/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function $5b51b70f75b94aaa$var$baseGet(object, path) {
    path = $gCKFj(path, object);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[$8KACs(path[index++])];
    return index && index == length ? object : undefined;
}
module.exports = $5b51b70f75b94aaa$var$baseGet;

});
parcelRegister("gCKFj", function(module, exports) {

var $9yJoF = parcelRequire("9yJoF");

var $2zeMC = parcelRequire("2zeMC");

var $7WZ0A = parcelRequire("7WZ0A");

var $jlmBT = parcelRequire("jlmBT");
/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */ function $c1a464b29c4b94e9$var$castPath(value, object) {
    if ($9yJoF(value)) return value;
    return $2zeMC(value, object) ? [
        value
    ] : $7WZ0A($jlmBT(value));
}
module.exports = $c1a464b29c4b94e9$var$castPath;

});
parcelRegister("2zeMC", function(module, exports) {

var $9yJoF = parcelRequire("9yJoF");

var $ecbje = parcelRequire("ecbje");
/** Used to match property names within property paths. */ var $1dea514531de1ce0$var$reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, $1dea514531de1ce0$var$reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function $1dea514531de1ce0$var$isKey(value, object) {
    if ($9yJoF(value)) return false;
    var type = typeof value;
    if (type == "number" || type == "symbol" || type == "boolean" || value == null || $ecbje(value)) return true;
    return $1dea514531de1ce0$var$reIsPlainProp.test(value) || !$1dea514531de1ce0$var$reIsDeepProp.test(value) || object != null && value in Object(object);
}
module.exports = $1dea514531de1ce0$var$isKey;

});
parcelRegister("ecbje", function(module, exports) {

var $2po4Z = parcelRequire("2po4Z");

var $7004H = parcelRequire("7004H");
/** `Object#toString` result references. */ var $a55af577c3525046$var$symbolTag = "[object Symbol]";
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $a55af577c3525046$var$isSymbol(value) {
    return typeof value == "symbol" || $7004H(value) && $2po4Z(value) == $a55af577c3525046$var$symbolTag;
}
module.exports = $a55af577c3525046$var$isSymbol;

});


parcelRegister("7WZ0A", function(module, exports) {

var $xaqxR = parcelRequire("xaqxR");
/** Used to match property names within property paths. */ var $5c9d4634a80bbc90$var$rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var $5c9d4634a80bbc90$var$reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $5c9d4634a80bbc90$var$stringToPath = $xaqxR(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push("");
    string.replace($5c9d4634a80bbc90$var$rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace($5c9d4634a80bbc90$var$reEscapeChar, "$1") : number || match);
    });
    return result;
});
module.exports = $5c9d4634a80bbc90$var$stringToPath;

});
parcelRegister("xaqxR", function(module, exports) {

var $kExAe = parcelRequire("kExAe");
/** Used as the maximum memoize cache size. */ var $063b2bcbf12fef93$var$MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function $063b2bcbf12fef93$var$memoizeCapped(func) {
    var result = $kExAe(func, function(key) {
        if (cache.size === $063b2bcbf12fef93$var$MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
module.exports = $063b2bcbf12fef93$var$memoizeCapped;

});
parcelRegister("kExAe", function(module, exports) {

var $bHcIK = parcelRequire("bHcIK");
/** Error message constants. */ var $f0919805c233e0e4$var$FUNC_ERROR_TEXT = "Expected a function";
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function $f0919805c233e0e4$var$memoize(func, resolver) {
    if (typeof func != "function" || resolver != null && typeof resolver != "function") throw new TypeError($f0919805c233e0e4$var$FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new ($f0919805c233e0e4$var$memoize.Cache || $bHcIK);
    return memoized;
}
// Expose `MapCache`.
$f0919805c233e0e4$var$memoize.Cache = $bHcIK;
module.exports = $f0919805c233e0e4$var$memoize;

});



parcelRegister("jlmBT", function(module, exports) {

var $8rmnm = parcelRequire("8rmnm");
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $e151845f0d26f5dd$var$toString(value) {
    return value == null ? "" : $8rmnm(value);
}
module.exports = $e151845f0d26f5dd$var$toString;

});
parcelRegister("8rmnm", function(module, exports) {

var $4PsDw = parcelRequire("4PsDw");

var $dolrh = parcelRequire("dolrh");

var $9yJoF = parcelRequire("9yJoF");

var $ecbje = parcelRequire("ecbje");
/** Used as references for various `Number` constants. */ var $625233b1a89b29f8$var$INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var $625233b1a89b29f8$var$symbolProto = $4PsDw ? $4PsDw.prototype : undefined, $625233b1a89b29f8$var$symbolToString = $625233b1a89b29f8$var$symbolProto ? $625233b1a89b29f8$var$symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $625233b1a89b29f8$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == "string") return value;
    if ($9yJoF(value)) // Recursively convert values (susceptible to call stack limits).
    return $dolrh(value, $625233b1a89b29f8$var$baseToString) + "";
    if ($ecbje(value)) return $625233b1a89b29f8$var$symbolToString ? $625233b1a89b29f8$var$symbolToString.call(value) : "";
    var result = value + "";
    return result == "0" && 1 / value == -$625233b1a89b29f8$var$INFINITY ? "-0" : result;
}
module.exports = $625233b1a89b29f8$var$baseToString;

});



parcelRegister("8KACs", function(module, exports) {

var $ecbje = parcelRequire("ecbje");
/** Used as references for various `Number` constants. */ var $65ef066dd8d9fb30$var$INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function $65ef066dd8d9fb30$var$toKey(value) {
    if (typeof value == "string" || $ecbje(value)) return value;
    var result = value + "";
    return result == "0" && 1 / value == -$65ef066dd8d9fb30$var$INFINITY ? "-0" : result;
}
module.exports = $65ef066dd8d9fb30$var$toKey;

});



parcelRegister("eXq9K", function(module, exports) {

var $1AdJK = parcelRequire("1AdJK");

var $59g4e = parcelRequire("59g4e");
/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */ function $ae3add7078329b6b$var$hasIn(object, path) {
    return object != null && $59g4e(object, path, $1AdJK);
}
module.exports = $ae3add7078329b6b$var$hasIn;

});
parcelRegister("1AdJK", function(module, exports) {
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function $1273cf1cd84c38eb$var$baseHasIn(object, key) {
    return object != null && key in Object(object);
}
module.exports = $1273cf1cd84c38eb$var$baseHasIn;

});

parcelRegister("59g4e", function(module, exports) {

var $gCKFj = parcelRequire("gCKFj");

var $cO2KF = parcelRequire("cO2KF");

var $9yJoF = parcelRequire("9yJoF");

var $hlpVF = parcelRequire("hlpVF");

var $8MgsQ = parcelRequire("8MgsQ");

var $8KACs = parcelRequire("8KACs");
/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */ function $3bfa41a4606ac4ec$var$hasPath(object, path, hasFunc) {
    path = $gCKFj(path, object);
    var index = -1, length = path.length, result = false;
    while(++index < length){
        var key = $8KACs(path[index]);
        if (!(result = object != null && hasFunc(object, key))) break;
        object = object[key];
    }
    if (result || ++index != length) return result;
    length = object == null ? 0 : object.length;
    return !!length && $8MgsQ(length) && $hlpVF(key, length) && ($9yJoF(object) || $cO2KF(object));
}
module.exports = $3bfa41a4606ac4ec$var$hasPath;

});



parcelRegister("9J7TY", function(module, exports) {

var $iLrJx = parcelRequire("iLrJx");

var $gIMHV = parcelRequire("gIMHV");

var $2zeMC = parcelRequire("2zeMC");

var $8KACs = parcelRequire("8KACs");
/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */ function $714e7229fba84c40$var$property(path) {
    return $2zeMC(path) ? $iLrJx($8KACs(path)) : $gIMHV(path);
}
module.exports = $714e7229fba84c40$var$property;

});
parcelRegister("iLrJx", function(module, exports) {
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $da922114e5dcb314$var$baseProperty(key) {
    return function(object) {
        return object == null ? undefined : object[key];
    };
}
module.exports = $da922114e5dcb314$var$baseProperty;

});

parcelRegister("gIMHV", function(module, exports) {

var $7Q5zN = parcelRequire("7Q5zN");
/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $c2c689b3a0e9c45f$var$basePropertyDeep(path) {
    return function(object) {
        return $7Q5zN(object, path);
    };
}
module.exports = $c2c689b3a0e9c45f$var$basePropertyDeep;

});



parcelRegister("eKMqi", function(module, exports) {

var $h60nt = parcelRequire("h60nt");

var $3XgiU = parcelRequire("3XgiU");
/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $abdaec661b8f1f5a$var$baseMap(collection, iteratee) {
    var index = -1, result = $3XgiU(collection) ? Array(collection.length) : [];
    $h60nt(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
    });
    return result;
}
module.exports = $abdaec661b8f1f5a$var$baseMap;

});
parcelRegister("h60nt", function(module, exports) {

var $1X6t4 = parcelRequire("1X6t4");

var $fxuxR = parcelRequire("fxuxR");
/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */ var $c7234a3490286f20$var$baseEach = $fxuxR($1X6t4);
module.exports = $c7234a3490286f20$var$baseEach;

});
parcelRegister("fxuxR", function(module, exports) {

var $3XgiU = parcelRequire("3XgiU");
/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $b501a1b045f70104$var$createBaseEach(eachFunc, fromRight) {
    return function(collection, iteratee) {
        if (collection == null) return collection;
        if (!$3XgiU(collection)) return eachFunc(collection, iteratee);
        var length = collection.length, index = fromRight ? length : -1, iterable = Object(collection);
        while(fromRight ? index-- : ++index < length){
            if (iteratee(iterable[index], index, iterable) === false) break;
        }
        return collection;
    };
}
module.exports = $b501a1b045f70104$var$createBaseEach;

});





parcelRegister("4oNrH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.mergeClasses = undefined;

var $4fDmP = parcelRequire("4fDmP");
var $333fc2326c264bcb$var$_forOwn3 = $333fc2326c264bcb$var$_interopRequireDefault($4fDmP);

var $c13ES = parcelRequire("c13ES");
var $333fc2326c264bcb$var$_cloneDeep3 = $333fc2326c264bcb$var$_interopRequireDefault($c13ES);
var $333fc2326c264bcb$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
function $333fc2326c264bcb$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $333fc2326c264bcb$var$mergeClasses = module.exports.mergeClasses = function mergeClasses(classes) {
    var activeNames = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var styles = classes.default && (0, $333fc2326c264bcb$var$_cloneDeep3.default)(classes.default) || {};
    activeNames.map(function(name) {
        var toMerge = classes[name];
        if (toMerge) (0, $333fc2326c264bcb$var$_forOwn3.default)(toMerge, function(value, key) {
            if (!styles[key]) styles[key] = {};
            styles[key] = $333fc2326c264bcb$var$_extends({}, styles[key], toMerge[key]);
        });
        return name;
    });
    return styles;
};
module.exports.default = $333fc2326c264bcb$var$mergeClasses;

});
parcelRegister("c13ES", function(module, exports) {

var $9DvYa = parcelRequire("9DvYa");
/** Used to compose bitmasks for cloning. */ var $8bf86a7a9e6c9e94$var$CLONE_DEEP_FLAG = 1, $8bf86a7a9e6c9e94$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */ function $8bf86a7a9e6c9e94$var$cloneDeep(value) {
    return $9DvYa(value, $8bf86a7a9e6c9e94$var$CLONE_DEEP_FLAG | $8bf86a7a9e6c9e94$var$CLONE_SYMBOLS_FLAG);
}
module.exports = $8bf86a7a9e6c9e94$var$cloneDeep;

});
parcelRegister("9DvYa", function(module, exports) {

var $lEQph = parcelRequire("lEQph");

var $e9hza = parcelRequire("e9hza");

var $3cps7 = parcelRequire("3cps7");

var $68krr = parcelRequire("68krr");

var $7ILxG = parcelRequire("7ILxG");

var $bl8CU = parcelRequire("bl8CU");

var $7tyhn = parcelRequire("7tyhn");

var $aAFDr = parcelRequire("aAFDr");

var $fH9zC = parcelRequire("fH9zC");

var $6nQ6p = parcelRequire("6nQ6p");

var $f1hxb = parcelRequire("f1hxb");

var $h21lV = parcelRequire("h21lV");

var $3a1Oy = parcelRequire("3a1Oy");

var $a3PW3 = parcelRequire("a3PW3");

var $4aWvt = parcelRequire("4aWvt");

var $9yJoF = parcelRequire("9yJoF");

var $etvPu = parcelRequire("etvPu");

var $a5LDi = parcelRequire("a5LDi");

var $6AOrv = parcelRequire("6AOrv");

var $3B8sD = parcelRequire("3B8sD");

var $lOxik = parcelRequire("lOxik");

var $ctHzO = parcelRequire("ctHzO");
/** Used to compose bitmasks for cloning. */ var $70408e0ac85f94f3$var$CLONE_DEEP_FLAG = 1, $70408e0ac85f94f3$var$CLONE_FLAT_FLAG = 2, $70408e0ac85f94f3$var$CLONE_SYMBOLS_FLAG = 4;
/** `Object#toString` result references. */ var $70408e0ac85f94f3$var$argsTag = "[object Arguments]", $70408e0ac85f94f3$var$arrayTag = "[object Array]", $70408e0ac85f94f3$var$boolTag = "[object Boolean]", $70408e0ac85f94f3$var$dateTag = "[object Date]", $70408e0ac85f94f3$var$errorTag = "[object Error]", $70408e0ac85f94f3$var$funcTag = "[object Function]", $70408e0ac85f94f3$var$genTag = "[object GeneratorFunction]", $70408e0ac85f94f3$var$mapTag = "[object Map]", $70408e0ac85f94f3$var$numberTag = "[object Number]", $70408e0ac85f94f3$var$objectTag = "[object Object]", $70408e0ac85f94f3$var$regexpTag = "[object RegExp]", $70408e0ac85f94f3$var$setTag = "[object Set]", $70408e0ac85f94f3$var$stringTag = "[object String]", $70408e0ac85f94f3$var$symbolTag = "[object Symbol]", $70408e0ac85f94f3$var$weakMapTag = "[object WeakMap]";
var $70408e0ac85f94f3$var$arrayBufferTag = "[object ArrayBuffer]", $70408e0ac85f94f3$var$dataViewTag = "[object DataView]", $70408e0ac85f94f3$var$float32Tag = "[object Float32Array]", $70408e0ac85f94f3$var$float64Tag = "[object Float64Array]", $70408e0ac85f94f3$var$int8Tag = "[object Int8Array]", $70408e0ac85f94f3$var$int16Tag = "[object Int16Array]", $70408e0ac85f94f3$var$int32Tag = "[object Int32Array]", $70408e0ac85f94f3$var$uint8Tag = "[object Uint8Array]", $70408e0ac85f94f3$var$uint8ClampedTag = "[object Uint8ClampedArray]", $70408e0ac85f94f3$var$uint16Tag = "[object Uint16Array]", $70408e0ac85f94f3$var$uint32Tag = "[object Uint32Array]";
/** Used to identify `toStringTag` values supported by `_.clone`. */ var $70408e0ac85f94f3$var$cloneableTags = {};
$70408e0ac85f94f3$var$cloneableTags[$70408e0ac85f94f3$var$argsTag] = $70408e0ac85f94f3$var$cloneableTags[$70408e0ac85f94f3$var$arrayTag] = $70408e0ac85f94f3$var$cloneableTags[$70408e0ac85f94f3$var$arrayBufferTag] = $70408e0ac85f94f3$var$cloneableTags[$70408e0ac85f94f3$var$dataViewTag] = $70408e0ac85f94f3$var$cloneableTags[$70408e0ac85f94f3$var$boolTag] = $70408e0ac85f94f3$var$cloneableTags[$70408e0ac85f94f3$var$dateTag] = $70408e0ac85f94f3$var$cloneableTags[$70408e0ac85f94f3$var$float32Tag] = $70408e0ac85f94f3$var$cloneableTags[$70408e0ac85f94f3$var$float64Tag] = $70408e0ac85f94f3$var$cloneableTags[$70408e0ac85f94f3$var$int8Tag] = $70408e0ac85f94f3$var$cloneableTags[$70408e0ac85f94f3$var$int16Tag] = $70408e0ac85f94f3$var$cloneableTags[$70408e0ac85f94f3$var$int32Tag] = $70408e0ac85f94f3$var$cloneableTags[$70408e0ac85f94f3$var$mapTag] = $70408e0ac85f94f3$var$cloneableTags[$70408e0ac85f94f3$var$numberTag] = $70408e0ac85f94f3$var$cloneableTags[$70408e0ac85f94f3$var$objectTag] = $70408e0ac85f94f3$var$cloneableTags[$70408e0ac85f94f3$var$regexpTag] = $70408e0ac85f94f3$var$cloneableTags[$70408e0ac85f94f3$var$setTag] = $70408e0ac85f94f3$var$cloneableTags[$70408e0ac85f94f3$var$stringTag] = $70408e0ac85f94f3$var$cloneableTags[$70408e0ac85f94f3$var$symbolTag] = $70408e0ac85f94f3$var$cloneableTags[$70408e0ac85f94f3$var$uint8Tag] = $70408e0ac85f94f3$var$cloneableTags[$70408e0ac85f94f3$var$uint8ClampedTag] = $70408e0ac85f94f3$var$cloneableTags[$70408e0ac85f94f3$var$uint16Tag] = $70408e0ac85f94f3$var$cloneableTags[$70408e0ac85f94f3$var$uint32Tag] = true;
$70408e0ac85f94f3$var$cloneableTags[$70408e0ac85f94f3$var$errorTag] = $70408e0ac85f94f3$var$cloneableTags[$70408e0ac85f94f3$var$funcTag] = $70408e0ac85f94f3$var$cloneableTags[$70408e0ac85f94f3$var$weakMapTag] = false;
/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */ function $70408e0ac85f94f3$var$baseClone(value, bitmask, customizer, key, object, stack) {
    var result, isDeep = bitmask & $70408e0ac85f94f3$var$CLONE_DEEP_FLAG, isFlat = bitmask & $70408e0ac85f94f3$var$CLONE_FLAT_FLAG, isFull = bitmask & $70408e0ac85f94f3$var$CLONE_SYMBOLS_FLAG;
    if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
    if (result !== undefined) return result;
    if (!$6AOrv(value)) return value;
    var isArr = $9yJoF(value);
    if (isArr) {
        result = $3a1Oy(value);
        if (!isDeep) return $7tyhn(value, result);
    } else {
        var tag = $h21lV(value), isFunc = tag == $70408e0ac85f94f3$var$funcTag || tag == $70408e0ac85f94f3$var$genTag;
        if ($etvPu(value)) return $bl8CU(value, isDeep);
        if (tag == $70408e0ac85f94f3$var$objectTag || tag == $70408e0ac85f94f3$var$argsTag || isFunc && !object) {
            result = isFlat || isFunc ? {} : $4aWvt(value);
            if (!isDeep) return isFlat ? $fH9zC(value, $7ILxG(result, value)) : $aAFDr(value, $68krr(result, value));
        } else {
            if (!$70408e0ac85f94f3$var$cloneableTags[tag]) return object ? value : {};
            result = $a3PW3(value, tag, isDeep);
        }
    }
    // Check for circular references and return its corresponding clone.
    stack || (stack = new $lEQph);
    var stacked = stack.get(value);
    if (stacked) return stacked;
    stack.set(value, result);
    if ($3B8sD(value)) value.forEach(function(subValue) {
        result.add($70408e0ac85f94f3$var$baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
    else if ($a5LDi(value)) value.forEach(function(subValue, key) {
        result.set(key, $70408e0ac85f94f3$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    var keysFunc = isFull ? isFlat ? $f1hxb : $6nQ6p : isFlat ? $ctHzO : $lOxik;
    var props = isArr ? undefined : keysFunc(value);
    $e9hza(props || value, function(subValue, key) {
        if (props) {
            key = subValue;
            subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        $3cps7(result, key, $70408e0ac85f94f3$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    return result;
}
module.exports = $70408e0ac85f94f3$var$baseClone;

});
parcelRegister("e9hza", function(module, exports) {
/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */ function $a4cf88419f5d3598$var$arrayEach(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (iteratee(array[index], index, array) === false) break;
    }
    return array;
}
module.exports = $a4cf88419f5d3598$var$arrayEach;

});

parcelRegister("3cps7", function(module, exports) {

var $l36fI = parcelRequire("l36fI");

var $jKXSh = parcelRequire("jKXSh");
/** Used for built-in method references. */ var $25463c6f03af6701$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $25463c6f03af6701$var$hasOwnProperty = $25463c6f03af6701$var$objectProto.hasOwnProperty;
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $25463c6f03af6701$var$assignValue(object, key, value) {
    var objValue = object[key];
    if (!($25463c6f03af6701$var$hasOwnProperty.call(object, key) && $jKXSh(objValue, value)) || value === undefined && !(key in object)) $l36fI(object, key, value);
}
module.exports = $25463c6f03af6701$var$assignValue;

});
parcelRegister("l36fI", function(module, exports) {

var $gSJNE = parcelRequire("gSJNE");
/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $f52eba647ed2dfde$var$baseAssignValue(object, key, value) {
    if (key == "__proto__" && $gSJNE) $gSJNE(object, key, {
        "configurable": true,
        "enumerable": true,
        "value": value,
        "writable": true
    });
    else object[key] = value;
}
module.exports = $f52eba647ed2dfde$var$baseAssignValue;

});
parcelRegister("gSJNE", function(module, exports) {

var $lmk4C = parcelRequire("lmk4C");
var $c4a5375f1fd6ad5b$var$defineProperty = function() {
    try {
        var func = $lmk4C(Object, "defineProperty");
        func({}, "", {});
        return func;
    } catch (e) {}
}();
module.exports = $c4a5375f1fd6ad5b$var$defineProperty;

});



parcelRegister("68krr", function(module, exports) {

var $e9jeR = parcelRequire("e9jeR");

var $lOxik = parcelRequire("lOxik");
/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $477358bae285d241$var$baseAssign(object, source) {
    return object && $e9jeR(source, $lOxik(source), object);
}
module.exports = $477358bae285d241$var$baseAssign;

});
parcelRegister("e9jeR", function(module, exports) {

var $3cps7 = parcelRequire("3cps7");

var $l36fI = parcelRequire("l36fI");
/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */ function $a4d0d461080f0a9c$var$copyObject(source, props, object, customizer) {
    var isNew = !object;
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        if (newValue === undefined) newValue = source[key];
        if (isNew) $l36fI(object, key, newValue);
        else $3cps7(object, key, newValue);
    }
    return object;
}
module.exports = $a4d0d461080f0a9c$var$copyObject;

});


parcelRegister("7ILxG", function(module, exports) {

var $e9jeR = parcelRequire("e9jeR");

var $ctHzO = parcelRequire("ctHzO");
/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $59f1855ca64dea68$var$baseAssignIn(object, source) {
    return object && $e9jeR(source, $ctHzO(source), object);
}
module.exports = $59f1855ca64dea68$var$baseAssignIn;

});
parcelRegister("ctHzO", function(module, exports) {

var $k6jBh = parcelRequire("k6jBh");

var $fQ63A = parcelRequire("fQ63A");

var $3XgiU = parcelRequire("3XgiU");
/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */ function $9159fee14d98f593$var$keysIn(object) {
    return $3XgiU(object) ? $k6jBh(object, true) : $fQ63A(object);
}
module.exports = $9159fee14d98f593$var$keysIn;

});
parcelRegister("fQ63A", function(module, exports) {

var $6AOrv = parcelRequire("6AOrv");

var $3zB9f = parcelRequire("3zB9f");

var $cVEmC = parcelRequire("cVEmC");
/** Used for built-in method references. */ var $b880691ba9b7a1b1$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $b880691ba9b7a1b1$var$hasOwnProperty = $b880691ba9b7a1b1$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $b880691ba9b7a1b1$var$baseKeysIn(object) {
    if (!$6AOrv(object)) return $cVEmC(object);
    var isProto = $3zB9f(object), result = [];
    for(var key in object)if (!(key == "constructor" && (isProto || !$b880691ba9b7a1b1$var$hasOwnProperty.call(object, key)))) result.push(key);
    return result;
}
module.exports = $b880691ba9b7a1b1$var$baseKeysIn;

});
parcelRegister("cVEmC", function(module, exports) {
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $969a1e4c3cd2a5a7$var$nativeKeysIn(object) {
    var result = [];
    if (object != null) for(var key in Object(object))result.push(key);
    return result;
}
module.exports = $969a1e4c3cd2a5a7$var$nativeKeysIn;

});




parcelRegister("bl8CU", function(module, exports) {

var $670gj = parcelRequire("670gj");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? $670gj.Buffer : undefined, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */ function cloneBuffer(buffer, isDeep) {
    if (isDeep) return buffer.slice();
    var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result);
    return result;
}
module.exports = cloneBuffer;

});

parcelRegister("7tyhn", function(module, exports) {
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ function $5715d4f68e9aeaa7$var$copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
module.exports = $5715d4f68e9aeaa7$var$copyArray;

});

parcelRegister("aAFDr", function(module, exports) {

var $e9jeR = parcelRequire("e9jeR");

var $5HbgL = parcelRequire("5HbgL");
/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $7b5d9007d57c682d$var$copySymbols(source, object) {
    return $e9jeR(source, $5HbgL(source), object);
}
module.exports = $7b5d9007d57c682d$var$copySymbols;

});

parcelRegister("fH9zC", function(module, exports) {

var $e9jeR = parcelRequire("e9jeR");

var $fMB9Q = parcelRequire("fMB9Q");
/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $b6d24c404eeaf6a0$var$copySymbolsIn(source, object) {
    return $e9jeR(source, $fMB9Q(source), object);
}
module.exports = $b6d24c404eeaf6a0$var$copySymbolsIn;

});
parcelRegister("fMB9Q", function(module, exports) {

var $3rL3Z = parcelRequire("3rL3Z");

var $10UPr = parcelRequire("10UPr");

var $5HbgL = parcelRequire("5HbgL");

var $cwivT = parcelRequire("cwivT");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $b7d8297ccef06bfe$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $b7d8297ccef06bfe$var$getSymbolsIn = !$b7d8297ccef06bfe$var$nativeGetSymbols ? $cwivT : function(object) {
    var result = [];
    while(object){
        $3rL3Z(result, $5HbgL(object));
        object = $10UPr(object);
    }
    return result;
};
module.exports = $b7d8297ccef06bfe$var$getSymbolsIn;

});


parcelRegister("f1hxb", function(module, exports) {

var $8Kmz4 = parcelRequire("8Kmz4");

var $fMB9Q = parcelRequire("fMB9Q");

var $ctHzO = parcelRequire("ctHzO");
/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $aef48cf6f55bb946$var$getAllKeysIn(object) {
    return $8Kmz4(object, $ctHzO, $fMB9Q);
}
module.exports = $aef48cf6f55bb946$var$getAllKeysIn;

});

parcelRegister("3a1Oy", function(module, exports) {
/** Used for built-in method references. */ var $24d3b690f7d7d218$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $24d3b690f7d7d218$var$hasOwnProperty = $24d3b690f7d7d218$var$objectProto.hasOwnProperty;
/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */ function $24d3b690f7d7d218$var$initCloneArray(array) {
    var length = array.length, result = new array.constructor(length);
    // Add properties assigned by `RegExp#exec`.
    if (length && typeof array[0] == "string" && $24d3b690f7d7d218$var$hasOwnProperty.call(array, "index")) {
        result.index = array.index;
        result.input = array.input;
    }
    return result;
}
module.exports = $24d3b690f7d7d218$var$initCloneArray;

});

parcelRegister("a3PW3", function(module, exports) {

var $jQ6Mj = parcelRequire("jQ6Mj");

var $3PaKg = parcelRequire("3PaKg");

var $hwZc1 = parcelRequire("hwZc1");

var $hc4j4 = parcelRequire("hc4j4");

var $5asQz = parcelRequire("5asQz");
/** `Object#toString` result references. */ var $7532787a934cf479$var$boolTag = "[object Boolean]", $7532787a934cf479$var$dateTag = "[object Date]", $7532787a934cf479$var$mapTag = "[object Map]", $7532787a934cf479$var$numberTag = "[object Number]", $7532787a934cf479$var$regexpTag = "[object RegExp]", $7532787a934cf479$var$setTag = "[object Set]", $7532787a934cf479$var$stringTag = "[object String]", $7532787a934cf479$var$symbolTag = "[object Symbol]";
var $7532787a934cf479$var$arrayBufferTag = "[object ArrayBuffer]", $7532787a934cf479$var$dataViewTag = "[object DataView]", $7532787a934cf479$var$float32Tag = "[object Float32Array]", $7532787a934cf479$var$float64Tag = "[object Float64Array]", $7532787a934cf479$var$int8Tag = "[object Int8Array]", $7532787a934cf479$var$int16Tag = "[object Int16Array]", $7532787a934cf479$var$int32Tag = "[object Int32Array]", $7532787a934cf479$var$uint8Tag = "[object Uint8Array]", $7532787a934cf479$var$uint8ClampedTag = "[object Uint8ClampedArray]", $7532787a934cf479$var$uint16Tag = "[object Uint16Array]", $7532787a934cf479$var$uint32Tag = "[object Uint32Array]";
/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */ function $7532787a934cf479$var$initCloneByTag(object, tag, isDeep) {
    var Ctor = object.constructor;
    switch(tag){
        case $7532787a934cf479$var$arrayBufferTag:
            return $jQ6Mj(object);
        case $7532787a934cf479$var$boolTag:
        case $7532787a934cf479$var$dateTag:
            return new Ctor(+object);
        case $7532787a934cf479$var$dataViewTag:
            return $3PaKg(object, isDeep);
        case $7532787a934cf479$var$float32Tag:
        case $7532787a934cf479$var$float64Tag:
        case $7532787a934cf479$var$int8Tag:
        case $7532787a934cf479$var$int16Tag:
        case $7532787a934cf479$var$int32Tag:
        case $7532787a934cf479$var$uint8Tag:
        case $7532787a934cf479$var$uint8ClampedTag:
        case $7532787a934cf479$var$uint16Tag:
        case $7532787a934cf479$var$uint32Tag:
            return $5asQz(object, isDeep);
        case $7532787a934cf479$var$mapTag:
            return new Ctor;
        case $7532787a934cf479$var$numberTag:
        case $7532787a934cf479$var$stringTag:
            return new Ctor(object);
        case $7532787a934cf479$var$regexpTag:
            return $hwZc1(object);
        case $7532787a934cf479$var$setTag:
            return new Ctor;
        case $7532787a934cf479$var$symbolTag:
            return $hc4j4(object);
    }
}
module.exports = $7532787a934cf479$var$initCloneByTag;

});
parcelRegister("jQ6Mj", function(module, exports) {

var $hmhYV = parcelRequire("hmhYV");
/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */ function $e71821ad86a68f84$var$cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new $hmhYV(result).set(new $hmhYV(arrayBuffer));
    return result;
}
module.exports = $e71821ad86a68f84$var$cloneArrayBuffer;

});

parcelRegister("3PaKg", function(module, exports) {

var $jQ6Mj = parcelRequire("jQ6Mj");
/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */ function $2c8e78442e765490$var$cloneDataView(dataView, isDeep) {
    var buffer = isDeep ? $jQ6Mj(dataView.buffer) : dataView.buffer;
    return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}
module.exports = $2c8e78442e765490$var$cloneDataView;

});

parcelRegister("hwZc1", function(module, exports) {
/** Used to match `RegExp` flags from their coerced string values. */ var $cc34e479ff39f879$var$reFlags = /\w*$/;
/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */ function $cc34e479ff39f879$var$cloneRegExp(regexp) {
    var result = new regexp.constructor(regexp.source, $cc34e479ff39f879$var$reFlags.exec(regexp));
    result.lastIndex = regexp.lastIndex;
    return result;
}
module.exports = $cc34e479ff39f879$var$cloneRegExp;

});

parcelRegister("hc4j4", function(module, exports) {

var $4PsDw = parcelRequire("4PsDw");
/** Used to convert symbols to primitives and strings. */ var $c846e5daee9b64e4$var$symbolProto = $4PsDw ? $4PsDw.prototype : undefined, $c846e5daee9b64e4$var$symbolValueOf = $c846e5daee9b64e4$var$symbolProto ? $c846e5daee9b64e4$var$symbolProto.valueOf : undefined;
/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */ function $c846e5daee9b64e4$var$cloneSymbol(symbol) {
    return $c846e5daee9b64e4$var$symbolValueOf ? Object($c846e5daee9b64e4$var$symbolValueOf.call(symbol)) : {};
}
module.exports = $c846e5daee9b64e4$var$cloneSymbol;

});

parcelRegister("5asQz", function(module, exports) {

var $jQ6Mj = parcelRequire("jQ6Mj");
/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */ function $3c34435280c2c437$var$cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? $jQ6Mj(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
module.exports = $3c34435280c2c437$var$cloneTypedArray;

});


parcelRegister("4aWvt", function(module, exports) {

var $etP2a = parcelRequire("etP2a");

var $10UPr = parcelRequire("10UPr");

var $3zB9f = parcelRequire("3zB9f");
/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */ function $30a57accd224e5d6$var$initCloneObject(object) {
    return typeof object.constructor == "function" && !$3zB9f(object) ? $etP2a($10UPr(object)) : {};
}
module.exports = $30a57accd224e5d6$var$initCloneObject;

});
parcelRegister("etP2a", function(module, exports) {

var $6AOrv = parcelRequire("6AOrv");
/** Built-in value references. */ var $a8ab5c6b4bf9eae4$var$objectCreate = Object.create;
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */ var $a8ab5c6b4bf9eae4$var$baseCreate = function() {
    function object() {}
    return function(proto) {
        if (!$6AOrv(proto)) return {};
        if ($a8ab5c6b4bf9eae4$var$objectCreate) return $a8ab5c6b4bf9eae4$var$objectCreate(proto);
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
    };
}();
module.exports = $a8ab5c6b4bf9eae4$var$baseCreate;

});


parcelRegister("a5LDi", function(module, exports) {

var $b8CL3 = parcelRequire("b8CL3");

var $gouRh = parcelRequire("gouRh");

var $jCPbW = parcelRequire("jCPbW");
/* Node.js helper references. */ var $758f51e75cb905c8$var$nodeIsMap = $jCPbW && $jCPbW.isMap;
/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */ var $758f51e75cb905c8$var$isMap = $758f51e75cb905c8$var$nodeIsMap ? $gouRh($758f51e75cb905c8$var$nodeIsMap) : $b8CL3;
module.exports = $758f51e75cb905c8$var$isMap;

});
parcelRegister("b8CL3", function(module, exports) {

var $h21lV = parcelRequire("h21lV");

var $7004H = parcelRequire("7004H");
/** `Object#toString` result references. */ var $81be819596944f12$var$mapTag = "[object Map]";
/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */ function $81be819596944f12$var$baseIsMap(value) {
    return $7004H(value) && $h21lV(value) == $81be819596944f12$var$mapTag;
}
module.exports = $81be819596944f12$var$baseIsMap;

});


parcelRegister("3B8sD", function(module, exports) {

var $60nFs = parcelRequire("60nFs");

var $gouRh = parcelRequire("gouRh");

var $jCPbW = parcelRequire("jCPbW");
/* Node.js helper references. */ var $29eb63f13ff96864$var$nodeIsSet = $jCPbW && $jCPbW.isSet;
/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */ var $29eb63f13ff96864$var$isSet = $29eb63f13ff96864$var$nodeIsSet ? $gouRh($29eb63f13ff96864$var$nodeIsSet) : $60nFs;
module.exports = $29eb63f13ff96864$var$isSet;

});
parcelRegister("60nFs", function(module, exports) {

var $h21lV = parcelRequire("h21lV");

var $7004H = parcelRequire("7004H");
/** `Object#toString` result references. */ var $45f51a0c30e5ab9c$var$setTag = "[object Set]";
/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */ function $45f51a0c30e5ab9c$var$baseIsSet(value) {
    return $7004H(value) && $h21lV(value) == $45f51a0c30e5ab9c$var$setTag;
}
module.exports = $45f51a0c30e5ab9c$var$baseIsSet;

});





parcelRegister("j2V18", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.autoprefix = undefined;

var $4fDmP = parcelRequire("4fDmP");
var $ddda6ea7d03b65fb$var$_forOwn3 = $ddda6ea7d03b65fb$var$_interopRequireDefault($4fDmP);
var $ddda6ea7d03b65fb$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
function $ddda6ea7d03b65fb$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $ddda6ea7d03b65fb$var$transforms = {
    borderRadius: function borderRadius(value) {
        return {
            msBorderRadius: value,
            MozBorderRadius: value,
            OBorderRadius: value,
            WebkitBorderRadius: value,
            borderRadius: value
        };
    },
    boxShadow: function boxShadow(value) {
        return {
            msBoxShadow: value,
            MozBoxShadow: value,
            OBoxShadow: value,
            WebkitBoxShadow: value,
            boxShadow: value
        };
    },
    userSelect: function userSelect(value) {
        return {
            WebkitTouchCallout: value,
            KhtmlUserSelect: value,
            MozUserSelect: value,
            msUserSelect: value,
            WebkitUserSelect: value,
            userSelect: value
        };
    },
    flex: function flex(value) {
        return {
            WebkitBoxFlex: value,
            MozBoxFlex: value,
            WebkitFlex: value,
            msFlex: value,
            flex: value
        };
    },
    flexBasis: function flexBasis(value) {
        return {
            WebkitFlexBasis: value,
            flexBasis: value
        };
    },
    justifyContent: function justifyContent(value) {
        return {
            WebkitJustifyContent: value,
            justifyContent: value
        };
    },
    transition: function transition(value) {
        return {
            msTransition: value,
            MozTransition: value,
            OTransition: value,
            WebkitTransition: value,
            transition: value
        };
    },
    transform: function transform(value) {
        return {
            msTransform: value,
            MozTransform: value,
            OTransform: value,
            WebkitTransform: value,
            transform: value
        };
    },
    absolute: function absolute(value) {
        var direction = value && value.split(" ");
        return {
            position: "absolute",
            top: direction && direction[0],
            right: direction && direction[1],
            bottom: direction && direction[2],
            left: direction && direction[3]
        };
    },
    extend: function extend(name, otherElementStyles) {
        var otherStyle = otherElementStyles[name];
        if (otherStyle) return otherStyle;
        return {
            "extend": name
        };
    }
};
var $ddda6ea7d03b65fb$var$autoprefix = module.exports.autoprefix = function autoprefix(elements) {
    var prefixed = {};
    (0, $ddda6ea7d03b65fb$var$_forOwn3.default)(elements, function(styles, element) {
        var expanded = {};
        (0, $ddda6ea7d03b65fb$var$_forOwn3.default)(styles, function(value, key) {
            var transform = $ddda6ea7d03b65fb$var$transforms[key];
            if (transform) expanded = $ddda6ea7d03b65fb$var$_extends({}, expanded, transform(value));
            else expanded[key] = value;
        });
        prefixed[element] = expanded;
    });
    return prefixed;
};
module.exports.default = $ddda6ea7d03b65fb$var$autoprefix;

});

parcelRegister("1wroF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.hover = undefined;
var $11be081181caf551$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};

var $eeH7J = parcelRequire("eeH7J");
var $11be081181caf551$var$_react2 = $11be081181caf551$var$_interopRequireDefault($eeH7J);
function $11be081181caf551$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $11be081181caf551$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $11be081181caf551$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $11be081181caf551$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $11be081181caf551$var$hover = module.exports.hover = function hover(Component) {
    var Span = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "span";
    return function(_React$Component) {
        $11be081181caf551$var$_inherits(Hover, _React$Component);
        function Hover() {
            var _ref;
            var _temp, _this, _ret;
            $11be081181caf551$var$_classCallCheck(this, Hover);
            for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return _ret = (_temp = (_this = $11be081181caf551$var$_possibleConstructorReturn(this, (_ref = Hover.__proto__ || Object.getPrototypeOf(Hover)).call.apply(_ref, [
                this
            ].concat(args))), _this), _this.state = {
                hover: false
            }, _this.handleMouseOver = function() {
                return _this.setState({
                    hover: true
                });
            }, _this.handleMouseOut = function() {
                return _this.setState({
                    hover: false
                });
            }, _this.render = function() {
                return $11be081181caf551$var$_react2.default.createElement(Span, {
                    onMouseOver: _this.handleMouseOver,
                    onMouseOut: _this.handleMouseOut
                }, $11be081181caf551$var$_react2.default.createElement(Component, $11be081181caf551$var$_extends({}, _this.props, _this.state)));
            }, _temp), $11be081181caf551$var$_possibleConstructorReturn(_this, _ret);
        }
        return Hover;
    }($11be081181caf551$var$_react2.default.Component);
};
module.exports.default = $11be081181caf551$var$hover;

});

parcelRegister("5Gg55", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.active = undefined;
var $422d59563359ba56$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};

var $eeH7J = parcelRequire("eeH7J");
var $422d59563359ba56$var$_react2 = $422d59563359ba56$var$_interopRequireDefault($eeH7J);
function $422d59563359ba56$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $422d59563359ba56$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $422d59563359ba56$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $422d59563359ba56$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $422d59563359ba56$var$active = module.exports.active = function active(Component) {
    var Span = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "span";
    return function(_React$Component) {
        $422d59563359ba56$var$_inherits(Active, _React$Component);
        function Active() {
            var _ref;
            var _temp, _this, _ret;
            $422d59563359ba56$var$_classCallCheck(this, Active);
            for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return _ret = (_temp = (_this = $422d59563359ba56$var$_possibleConstructorReturn(this, (_ref = Active.__proto__ || Object.getPrototypeOf(Active)).call.apply(_ref, [
                this
            ].concat(args))), _this), _this.state = {
                active: false
            }, _this.handleMouseDown = function() {
                return _this.setState({
                    active: true
                });
            }, _this.handleMouseUp = function() {
                return _this.setState({
                    active: false
                });
            }, _this.render = function() {
                return $422d59563359ba56$var$_react2.default.createElement(Span, {
                    onMouseDown: _this.handleMouseDown,
                    onMouseUp: _this.handleMouseUp
                }, $422d59563359ba56$var$_react2.default.createElement(Component, $422d59563359ba56$var$_extends({}, _this.props, _this.state)));
            }, _temp), $422d59563359ba56$var$_possibleConstructorReturn(_this, _ret);
        }
        return Active;
    }($422d59563359ba56$var$_react2.default.Component);
};
module.exports.default = $422d59563359ba56$var$active;

});

parcelRegister("23o4j", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $17ee8816aab573d4$var$loopable = function loopable(i, length) {
    var props = {};
    var setProp = function setProp(name) {
        var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
        props[name] = value;
    };
    i === 0 && setProp("first-child");
    i === length - 1 && setProp("last-child");
    (i === 0 || i % 2 === 0) && setProp("even");
    Math.abs(i % 2) === 1 && setProp("odd");
    setProp("nth-child", i);
    return props;
};
module.exports.default = $17ee8816aab573d4$var$loopable;

});


parcelRegister("isDZf", function(module, exports) {

$parcel$export(module.exports, "Alpha", function () { return (parcelRequire("cydcQ")).default; });
$parcel$export(module.exports, "Checkboard", function () { return (parcelRequire("dZU3X")).default; });
$parcel$export(module.exports, "EditableInput", function () { return (parcelRequire("a5dMh")).default; });
$parcel$export(module.exports, "Hue", function () { return (parcelRequire("gnp1P")).default; });
$parcel$export(module.exports, "Raised", function () { return (parcelRequire("2oAlV")).default; });
$parcel$export(module.exports, "Saturation", function () { return (parcelRequire("ejwzz")).default; });
$parcel$export(module.exports, "ColorWrap", function () { return (parcelRequire("8bUgk")).default; });
$parcel$export(module.exports, "Swatch", function () { return (parcelRequire("2DBoi")).default; });

var $cydcQ = parcelRequire("cydcQ");

var $dZU3X = parcelRequire("dZU3X");

var $a5dMh = parcelRequire("a5dMh");

var $gnp1P = parcelRequire("gnp1P");

var $2oAlV = parcelRequire("2oAlV");

var $ejwzz = parcelRequire("ejwzz");

var $8bUgk = parcelRequire("8bUgk");

var $2DBoi = parcelRequire("2DBoi");

});
parcelRegister("cydcQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9232e77ca409a344$export$2e2bcd8739ae039; });

var $eeH7J = parcelRequire("eeH7J");

var $bJBxw = parcelRequire("bJBxw");

var $9kNel = parcelRequire("9kNel");

var $dZU3X = parcelRequire("dZU3X");
var $9232e77ca409a344$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $9232e77ca409a344$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function $9232e77ca409a344$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $9232e77ca409a344$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $9232e77ca409a344$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $9232e77ca409a344$export$b3d0ceb706f8af43 = function(_ref) {
    $9232e77ca409a344$var$_inherits(Alpha, _ref);
    function Alpha() {
        var _ref2;
        var _temp, _this, _ret;
        $9232e77ca409a344$var$_classCallCheck(this, Alpha);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $9232e77ca409a344$var$_possibleConstructorReturn(this, (_ref2 = Alpha.__proto__ || Object.getPrototypeOf(Alpha)).call.apply(_ref2, [
            this
        ].concat(args))), _this), _this.handleChange = function(e) {
            var change = $9kNel.calculateChange(e, _this.props.hsl, _this.props.direction, _this.props.a, _this.container);
            change && typeof _this.props.onChange === "function" && _this.props.onChange(change, e);
        }, _this.handleMouseDown = function(e) {
            _this.handleChange(e);
            window.addEventListener("mousemove", _this.handleChange);
            window.addEventListener("mouseup", _this.handleMouseUp);
        }, _this.handleMouseUp = function() {
            _this.unbindEventListeners();
        }, _this.unbindEventListeners = function() {
            window.removeEventListener("mousemove", _this.handleChange);
            window.removeEventListener("mouseup", _this.handleMouseUp);
        }, _temp), $9232e77ca409a344$var$_possibleConstructorReturn(_this, _ret);
    }
    $9232e77ca409a344$var$_createClass(Alpha, [
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.unbindEventListeners();
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var rgb = this.props.rgb;
                var styles = (0, (/*@__PURE__*/$parcel$interopDefault($bJBxw)))({
                    "default": {
                        alpha: {
                            absolute: "0px 0px 0px 0px",
                            borderRadius: this.props.radius
                        },
                        checkboard: {
                            absolute: "0px 0px 0px 0px",
                            overflow: "hidden",
                            borderRadius: this.props.radius
                        },
                        gradient: {
                            absolute: "0px 0px 0px 0px",
                            background: "linear-gradient(to right, rgba(" + rgb.r + "," + rgb.g + "," + rgb.b + ", 0) 0%,\n           rgba(" + rgb.r + "," + rgb.g + "," + rgb.b + ", 1) 100%)",
                            boxShadow: this.props.shadow,
                            borderRadius: this.props.radius
                        },
                        container: {
                            position: "relative",
                            height: "100%",
                            margin: "0 3px"
                        },
                        pointer: {
                            position: "absolute",
                            left: rgb.a * 100 + "%"
                        },
                        slider: {
                            width: "4px",
                            borderRadius: "1px",
                            height: "8px",
                            boxShadow: "0 0 2px rgba(0, 0, 0, .6)",
                            background: "#fff",
                            marginTop: "1px",
                            transform: "translateX(-2px)"
                        }
                    },
                    "vertical": {
                        gradient: {
                            background: "linear-gradient(to bottom, rgba(" + rgb.r + "," + rgb.g + "," + rgb.b + ", 0) 0%,\n           rgba(" + rgb.r + "," + rgb.g + "," + rgb.b + ", 1) 100%)"
                        },
                        pointer: {
                            left: 0,
                            top: rgb.a * 100 + "%"
                        }
                    },
                    "overwrite": $9232e77ca409a344$var$_extends({}, this.props.style)
                }, {
                    vertical: this.props.direction === "vertical",
                    overwrite: true
                });
                return (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
                    style: styles.alpha
                }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
                    style: styles.checkboard
                }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $dZU3X.default), {
                    renderers: this.props.renderers
                })), (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
                    style: styles.gradient
                }), (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
                    style: styles.container,
                    ref: function ref(container) {
                        return _this2.container = container;
                    },
                    onMouseDown: this.handleMouseDown,
                    onTouchMove: this.handleChange,
                    onTouchStart: this.handleChange
                }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
                    style: styles.pointer
                }, this.props.pointer ? (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement(this.props.pointer, this.props) : (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
                    style: styles.slider
                }))));
            }
        }
    ]);
    return Alpha;
}((0, $eeH7J.PureComponent) || (0, $eeH7J.Component));
var $9232e77ca409a344$export$2e2bcd8739ae039 = $9232e77ca409a344$export$b3d0ceb706f8af43;

});
parcelRegister("9kNel", function(module, exports) {

$parcel$export(module.exports, "calculateChange", function () { return $6cbc2b6dc50c7381$export$a056a977bf6a9a3c; });
var $6cbc2b6dc50c7381$export$a056a977bf6a9a3c = function calculateChange(e, hsl, direction, initialA, container) {
    var containerWidth = container.clientWidth;
    var containerHeight = container.clientHeight;
    var x = typeof e.pageX === "number" ? e.pageX : e.touches[0].pageX;
    var y = typeof e.pageY === "number" ? e.pageY : e.touches[0].pageY;
    var left = x - (container.getBoundingClientRect().left + window.pageXOffset);
    var top = y - (container.getBoundingClientRect().top + window.pageYOffset);
    if (direction === "vertical") {
        var a = void 0;
        if (top < 0) a = 0;
        else if (top > containerHeight) a = 1;
        else a = Math.round(top * 100 / containerHeight) / 100;
        if (hsl.a !== a) return {
            h: hsl.h,
            s: hsl.s,
            l: hsl.l,
            a: a,
            source: "rgb"
        };
    } else {
        var _a = void 0;
        if (left < 0) _a = 0;
        else if (left > containerWidth) _a = 1;
        else _a = Math.round(left * 100 / containerWidth) / 100;
        if (initialA !== _a) return {
            h: hsl.h,
            s: hsl.s,
            l: hsl.l,
            a: _a,
            source: "rgb"
        };
    }
    return null;
};

});

parcelRegister("dZU3X", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a30c75ca5a20b075$export$2e2bcd8739ae039; });

var $eeH7J = parcelRequire("eeH7J");

var $bJBxw = parcelRequire("bJBxw");

var $1EXrN = parcelRequire("1EXrN");
var $a30c75ca5a20b075$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $a30c75ca5a20b075$export$457ff74489f64b4a = function Checkboard(_ref) {
    var white = _ref.white, grey = _ref.grey, size = _ref.size, renderers = _ref.renderers, borderRadius = _ref.borderRadius, boxShadow = _ref.boxShadow, children = _ref.children;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($bJBxw)))({
        "default": {
            grid: {
                borderRadius: borderRadius,
                boxShadow: boxShadow,
                absolute: "0px 0px 0px 0px",
                background: "url(" + $1EXrN.get(white, grey, size, renderers.canvas) + ") center left"
            }
        }
    });
    return (0, $eeH7J.isValidElement)(children) ? (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).cloneElement(children, $a30c75ca5a20b075$var$_extends({}, children.props, {
        style: $a30c75ca5a20b075$var$_extends({}, children.props.style, styles.grid)
    })) : (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        style: styles.grid
    });
};
$a30c75ca5a20b075$export$457ff74489f64b4a.defaultProps = {
    size: 8,
    white: "transparent",
    grey: "rgba(0,0,0,.08)",
    renderers: {}
};
var $a30c75ca5a20b075$export$2e2bcd8739ae039 = $a30c75ca5a20b075$export$457ff74489f64b4a;

});
parcelRegister("1EXrN", function(module, exports) {

$parcel$export(module.exports, "get", function () { return $1357a3e0e7266dc9$export$3988ae62b71be9a3; });
var $1357a3e0e7266dc9$var$checkboardCache = {};
var $1357a3e0e7266dc9$export$b3890eb0ae9dca99 = function render(c1, c2, size, serverCanvas) {
    if (typeof document === "undefined" && !serverCanvas) return null;
    var canvas = serverCanvas ? new serverCanvas() : document.createElement("canvas");
    canvas.width = size * 2;
    canvas.height = size * 2;
    var ctx = canvas.getContext("2d");
    if (!ctx) return null;
     // If no context can be found, return early.
    ctx.fillStyle = c1;
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    ctx.fillStyle = c2;
    ctx.fillRect(0, 0, size, size);
    ctx.translate(size, size);
    ctx.fillRect(0, 0, size, size);
    return canvas.toDataURL();
};
var $1357a3e0e7266dc9$export$3988ae62b71be9a3 = function get(c1, c2, size, serverCanvas) {
    var key = c1 + "-" + c2 + "-" + size + (serverCanvas ? "-server" : "");
    if ($1357a3e0e7266dc9$var$checkboardCache[key]) return $1357a3e0e7266dc9$var$checkboardCache[key];
    var checkboard = $1357a3e0e7266dc9$export$b3890eb0ae9dca99(c1, c2, size, serverCanvas);
    $1357a3e0e7266dc9$var$checkboardCache[key] = checkboard;
    return checkboard;
};

});



parcelRegister("a5dMh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $75750ef8547f0a1f$export$2e2bcd8739ae039; });

var $eeH7J = parcelRequire("eeH7J");

var $bJBxw = parcelRequire("bJBxw");
var $75750ef8547f0a1f$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function $75750ef8547f0a1f$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $75750ef8547f0a1f$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $75750ef8547f0a1f$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $75750ef8547f0a1f$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $75750ef8547f0a1f$var$DEFAULT_ARROW_OFFSET = 1;
var $75750ef8547f0a1f$var$UP_KEY_CODE = 38;
var $75750ef8547f0a1f$var$DOWN_KEY_CODE = 40;
var $75750ef8547f0a1f$var$VALID_KEY_CODES = [
    $75750ef8547f0a1f$var$UP_KEY_CODE,
    $75750ef8547f0a1f$var$DOWN_KEY_CODE
];
var $75750ef8547f0a1f$var$isValidKeyCode = function isValidKeyCode(keyCode) {
    return $75750ef8547f0a1f$var$VALID_KEY_CODES.indexOf(keyCode) > -1;
};
var $75750ef8547f0a1f$var$getNumberValue = function getNumberValue(value) {
    return Number(String(value).replace(/%/g, ""));
};
var $75750ef8547f0a1f$var$idCounter = 1;
var $75750ef8547f0a1f$export$bfb3cbb78d3c298 = function(_ref) {
    $75750ef8547f0a1f$var$_inherits(EditableInput, _ref);
    function EditableInput(props) {
        $75750ef8547f0a1f$var$_classCallCheck(this, EditableInput);
        var _this = $75750ef8547f0a1f$var$_possibleConstructorReturn(this, (EditableInput.__proto__ || Object.getPrototypeOf(EditableInput)).call(this));
        _this.handleBlur = function() {
            if (_this.state.blurValue) _this.setState({
                value: _this.state.blurValue,
                blurValue: null
            });
        };
        _this.handleChange = function(e) {
            _this.setUpdatedValue(e.target.value, e);
        };
        _this.handleKeyDown = function(e) {
            // In case `e.target.value` is a percentage remove the `%` character
            // and update accordingly with a percentage
            // https://github.com/casesandberg/react-color/issues/383
            var value = $75750ef8547f0a1f$var$getNumberValue(e.target.value);
            if (!isNaN(value) && $75750ef8547f0a1f$var$isValidKeyCode(e.keyCode)) {
                var offset = _this.getArrowOffset();
                var updatedValue = e.keyCode === $75750ef8547f0a1f$var$UP_KEY_CODE ? value + offset : value - offset;
                _this.setUpdatedValue(updatedValue, e);
            }
        };
        _this.handleDrag = function(e) {
            if (_this.props.dragLabel) {
                var newValue = Math.round(_this.props.value + e.movementX);
                if (newValue >= 0 && newValue <= _this.props.dragMax) _this.props.onChange && _this.props.onChange(_this.getValueObjectWithLabel(newValue), e);
            }
        };
        _this.handleMouseDown = function(e) {
            if (_this.props.dragLabel) {
                e.preventDefault();
                _this.handleDrag(e);
                window.addEventListener("mousemove", _this.handleDrag);
                window.addEventListener("mouseup", _this.handleMouseUp);
            }
        };
        _this.handleMouseUp = function() {
            _this.unbindEventListeners();
        };
        _this.unbindEventListeners = function() {
            window.removeEventListener("mousemove", _this.handleDrag);
            window.removeEventListener("mouseup", _this.handleMouseUp);
        };
        _this.state = {
            value: String(props.value).toUpperCase(),
            blurValue: String(props.value).toUpperCase()
        };
        _this.inputId = "rc-editable-input-" + $75750ef8547f0a1f$var$idCounter++;
        return _this;
    }
    $75750ef8547f0a1f$var$_createClass(EditableInput, [
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps, prevState) {
                if (this.props.value !== this.state.value && (prevProps.value !== this.props.value || prevState.value !== this.state.value)) {
                    if (this.input === document.activeElement) this.setState({
                        blurValue: String(this.props.value).toUpperCase()
                    });
                    else this.setState({
                        value: String(this.props.value).toUpperCase(),
                        blurValue: !this.state.blurValue && String(this.props.value).toUpperCase()
                    });
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.unbindEventListeners();
            }
        },
        {
            key: "getValueObjectWithLabel",
            value: function getValueObjectWithLabel(value) {
                return $75750ef8547f0a1f$var$_defineProperty({}, this.props.label, value);
            }
        },
        {
            key: "getArrowOffset",
            value: function getArrowOffset() {
                return this.props.arrowOffset || $75750ef8547f0a1f$var$DEFAULT_ARROW_OFFSET;
            }
        },
        {
            key: "setUpdatedValue",
            value: function setUpdatedValue(value, e) {
                var onChangeValue = this.props.label ? this.getValueObjectWithLabel(value) : value;
                this.props.onChange && this.props.onChange(onChangeValue, e);
                this.setState({
                    value: value
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var styles = (0, (/*@__PURE__*/$parcel$interopDefault($bJBxw)))({
                    "default": {
                        wrap: {
                            position: "relative"
                        }
                    },
                    "user-override": {
                        wrap: this.props.style && this.props.style.wrap ? this.props.style.wrap : {},
                        input: this.props.style && this.props.style.input ? this.props.style.input : {},
                        label: this.props.style && this.props.style.label ? this.props.style.label : {}
                    },
                    "dragLabel-true": {
                        label: {
                            cursor: "ew-resize"
                        }
                    }
                }, {
                    "user-override": true
                }, this.props);
                return (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
                    style: styles.wrap
                }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("input", {
                    id: this.inputId,
                    style: styles.input,
                    ref: function ref(input) {
                        return _this2.input = input;
                    },
                    value: this.state.value,
                    onKeyDown: this.handleKeyDown,
                    onChange: this.handleChange,
                    onBlur: this.handleBlur,
                    placeholder: this.props.placeholder,
                    spellCheck: "false"
                }), this.props.label && !this.props.hideLabel ? (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("label", {
                    htmlFor: this.inputId,
                    style: styles.label,
                    onMouseDown: this.handleMouseDown
                }, this.props.label) : null);
            }
        }
    ]);
    return EditableInput;
}((0, $eeH7J.PureComponent) || (0, $eeH7J.Component));
var $75750ef8547f0a1f$export$2e2bcd8739ae039 = $75750ef8547f0a1f$export$bfb3cbb78d3c298;

});

parcelRegister("gnp1P", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bec2357555e376de$export$2e2bcd8739ae039; });

var $eeH7J = parcelRequire("eeH7J");

var $bJBxw = parcelRequire("bJBxw");

var $iWJaY = parcelRequire("iWJaY");
var $bec2357555e376de$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function $bec2357555e376de$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $bec2357555e376de$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $bec2357555e376de$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $bec2357555e376de$export$3e22a96a58989a47 = function(_ref) {
    $bec2357555e376de$var$_inherits(Hue, _ref);
    function Hue() {
        var _ref2;
        var _temp, _this, _ret;
        $bec2357555e376de$var$_classCallCheck(this, Hue);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $bec2357555e376de$var$_possibleConstructorReturn(this, (_ref2 = Hue.__proto__ || Object.getPrototypeOf(Hue)).call.apply(_ref2, [
            this
        ].concat(args))), _this), _this.handleChange = function(e) {
            var change = $iWJaY.calculateChange(e, _this.props.direction, _this.props.hsl, _this.container);
            change && typeof _this.props.onChange === "function" && _this.props.onChange(change, e);
        }, _this.handleMouseDown = function(e) {
            _this.handleChange(e);
            window.addEventListener("mousemove", _this.handleChange);
            window.addEventListener("mouseup", _this.handleMouseUp);
        }, _this.handleMouseUp = function() {
            _this.unbindEventListeners();
        }, _temp), $bec2357555e376de$var$_possibleConstructorReturn(_this, _ret);
    }
    $bec2357555e376de$var$_createClass(Hue, [
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.unbindEventListeners();
            }
        },
        {
            key: "unbindEventListeners",
            value: function unbindEventListeners() {
                window.removeEventListener("mousemove", this.handleChange);
                window.removeEventListener("mouseup", this.handleMouseUp);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var _props$direction = this.props.direction, direction = _props$direction === undefined ? "horizontal" : _props$direction;
                var styles = (0, (/*@__PURE__*/$parcel$interopDefault($bJBxw)))({
                    "default": {
                        hue: {
                            absolute: "0px 0px 0px 0px",
                            borderRadius: this.props.radius,
                            boxShadow: this.props.shadow
                        },
                        container: {
                            padding: "0 2px",
                            position: "relative",
                            height: "100%",
                            borderRadius: this.props.radius
                        },
                        pointer: {
                            position: "absolute",
                            left: this.props.hsl.h * 100 / 360 + "%"
                        },
                        slider: {
                            marginTop: "1px",
                            width: "4px",
                            borderRadius: "1px",
                            height: "8px",
                            boxShadow: "0 0 2px rgba(0, 0, 0, .6)",
                            background: "#fff",
                            transform: "translateX(-2px)"
                        }
                    },
                    "vertical": {
                        pointer: {
                            left: "0px",
                            top: -(this.props.hsl.h * 100 / 360) + 100 + "%"
                        }
                    }
                }, {
                    vertical: direction === "vertical"
                });
                return (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
                    style: styles.hue
                }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
                    className: "hue-" + direction,
                    style: styles.container,
                    ref: function ref(container) {
                        return _this2.container = container;
                    },
                    onMouseDown: this.handleMouseDown,
                    onTouchMove: this.handleChange,
                    onTouchStart: this.handleChange
                }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("style", null, "\n            .hue-horizontal {\n              background: linear-gradient(to right, #f00 0%, #ff0 17%, #0f0\n                33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n              background: -webkit-linear-gradient(to right, #f00 0%, #ff0\n                17%, #0f0 33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n            }\n\n            .hue-vertical {\n              background: linear-gradient(to top, #f00 0%, #ff0 17%, #0f0 33%,\n                #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n              background: -webkit-linear-gradient(to top, #f00 0%, #ff0 17%,\n                #0f0 33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n            }\n          "), (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
                    style: styles.pointer
                }, this.props.pointer ? (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement(this.props.pointer, this.props) : (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
                    style: styles.slider
                }))));
            }
        }
    ]);
    return Hue;
}((0, $eeH7J.PureComponent) || (0, $eeH7J.Component));
var $bec2357555e376de$export$2e2bcd8739ae039 = $bec2357555e376de$export$3e22a96a58989a47;

});
parcelRegister("iWJaY", function(module, exports) {

$parcel$export(module.exports, "calculateChange", function () { return $dcb0afcec562769f$export$a056a977bf6a9a3c; });
var $dcb0afcec562769f$export$a056a977bf6a9a3c = function calculateChange(e, direction, hsl, container) {
    var containerWidth = container.clientWidth;
    var containerHeight = container.clientHeight;
    var x = typeof e.pageX === "number" ? e.pageX : e.touches[0].pageX;
    var y = typeof e.pageY === "number" ? e.pageY : e.touches[0].pageY;
    var left = x - (container.getBoundingClientRect().left + window.pageXOffset);
    var top = y - (container.getBoundingClientRect().top + window.pageYOffset);
    if (direction === "vertical") {
        var h = void 0;
        if (top < 0) h = 359;
        else if (top > containerHeight) h = 0;
        else {
            var percent = -(top * 100 / containerHeight) + 100;
            h = 360 * percent / 100;
        }
        if (hsl.h !== h) return {
            h: h,
            s: hsl.s,
            l: hsl.l,
            a: hsl.a,
            source: "hsl"
        };
    } else {
        var _h = void 0;
        if (left < 0) _h = 0;
        else if (left > containerWidth) _h = 359;
        else {
            var _percent = left * 100 / containerWidth;
            _h = 360 * _percent / 100;
        }
        if (hsl.h !== _h) return {
            h: _h,
            s: hsl.s,
            l: hsl.l,
            a: hsl.a,
            source: "hsl"
        };
    }
    return null;
};

});


parcelRegister("2oAlV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1bea058f31f647d1$export$2e2bcd8739ae039; });

var $eeH7J = parcelRequire("eeH7J");

var $4yBem = parcelRequire("4yBem");

var $bJBxw = parcelRequire("bJBxw");

var $5VQgV = parcelRequire("5VQgV");
var $1bea058f31f647d1$export$5eec0980ed568dae = function Raised(_ref) {
    var zDepth = _ref.zDepth, radius = _ref.radius, background = _ref.background, children = _ref.children, _ref$styles = _ref.styles, passedStyles = _ref$styles === undefined ? {} : _ref$styles;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($bJBxw)))((0, $5VQgV.default)({
        "default": {
            wrap: {
                position: "relative",
                display: "inline-block"
            },
            content: {
                position: "relative"
            },
            bg: {
                absolute: "0px 0px 0px 0px",
                boxShadow: "0 " + zDepth + "px " + zDepth * 4 + "px rgba(0,0,0,.24)",
                borderRadius: radius,
                background: background
            }
        },
        "zDepth-0": {
            bg: {
                boxShadow: "none"
            }
        },
        "zDepth-1": {
            bg: {
                boxShadow: "0 2px 10px rgba(0,0,0,.12), 0 2px 5px rgba(0,0,0,.16)"
            }
        },
        "zDepth-2": {
            bg: {
                boxShadow: "0 6px 20px rgba(0,0,0,.19), 0 8px 17px rgba(0,0,0,.2)"
            }
        },
        "zDepth-3": {
            bg: {
                boxShadow: "0 17px 50px rgba(0,0,0,.19), 0 12px 15px rgba(0,0,0,.24)"
            }
        },
        "zDepth-4": {
            bg: {
                boxShadow: "0 25px 55px rgba(0,0,0,.21), 0 16px 28px rgba(0,0,0,.22)"
            }
        },
        "zDepth-5": {
            bg: {
                boxShadow: "0 40px 77px rgba(0,0,0,.22), 0 27px 24px rgba(0,0,0,.2)"
            }
        },
        "square": {
            bg: {
                borderRadius: "0"
            }
        },
        "circle": {
            bg: {
                borderRadius: "50%"
            }
        }
    }, passedStyles), {
        "zDepth-1": zDepth === 1
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        style: styles.wrap
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        style: styles.bg
    }), (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        style: styles.content
    }, children));
};
$1bea058f31f647d1$export$5eec0980ed568dae.propTypes = {
    background: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string,
    zDepth: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOf([
        0,
        1,
        2,
        3,
        4,
        5
    ]),
    radius: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).number,
    styles: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object
};
$1bea058f31f647d1$export$5eec0980ed568dae.defaultProps = {
    background: "#fff",
    zDepth: 1,
    radius: 2,
    styles: {}
};
var $1bea058f31f647d1$export$2e2bcd8739ae039 = $1bea058f31f647d1$export$5eec0980ed568dae;

});
parcelRegister("5VQgV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $451ad2baa4201321$export$2e2bcd8739ae039; });

var $84Zyn = parcelRequire("84Zyn");

var $51t52 = parcelRequire("51t52");
/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */ var $451ad2baa4201321$var$merge = (0, $51t52.default)(function(object, source, srcIndex) {
    (0, $84Zyn.default)(object, source, srcIndex);
});
var $451ad2baa4201321$export$2e2bcd8739ae039 = $451ad2baa4201321$var$merge;

});
parcelRegister("84Zyn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5e1e71aba0a953c9$export$2e2bcd8739ae039; });

var $iH3Fz = parcelRequire("iH3Fz");

var $hrfbV = parcelRequire("hrfbV");

var $bpjCU = parcelRequire("bpjCU");

var $bHw9b = parcelRequire("bHw9b");

var $3dn92 = parcelRequire("3dn92");

var $fUXoR = parcelRequire("fUXoR");

var $1Abx0 = parcelRequire("1Abx0");
/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function $5e1e71aba0a953c9$var$baseMerge(object, source, srcIndex, customizer, stack) {
    if (object === source) return;
    (0, $bpjCU.default)(source, function(srcValue, key) {
        stack || (stack = new (0, $iH3Fz.default));
        if ((0, $3dn92.default)(srcValue)) (0, $bHw9b.default)(object, source, key, srcIndex, $5e1e71aba0a953c9$var$baseMerge, customizer, stack);
        else {
            var newValue = customizer ? customizer((0, $1Abx0.default)(object, key), srcValue, key + "", object, source, stack) : undefined;
            if (newValue === undefined) newValue = srcValue;
            (0, $hrfbV.default)(object, key, newValue);
        }
    }, (0, $fUXoR.default));
}
var $5e1e71aba0a953c9$export$2e2bcd8739ae039 = $5e1e71aba0a953c9$var$baseMerge;

});
parcelRegister("iH3Fz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d9bf16d4d84249b6$export$2e2bcd8739ae039; });

var $3XhQ8 = parcelRequire("3XhQ8");

var $bJtHo = parcelRequire("bJtHo");

var $inttw = parcelRequire("inttw");

var $fT3ht = parcelRequire("fT3ht");

var $lTLjm = parcelRequire("lTLjm");

var $2xuLV = parcelRequire("2xuLV");
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $d9bf16d4d84249b6$var$Stack(entries) {
    var data = this.__data__ = new (0, $3XhQ8.default)(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
$d9bf16d4d84249b6$var$Stack.prototype.clear = (0, $bJtHo.default);
$d9bf16d4d84249b6$var$Stack.prototype["delete"] = (0, $inttw.default);
$d9bf16d4d84249b6$var$Stack.prototype.get = (0, $fT3ht.default);
$d9bf16d4d84249b6$var$Stack.prototype.has = (0, $lTLjm.default);
$d9bf16d4d84249b6$var$Stack.prototype.set = (0, $2xuLV.default);
var $d9bf16d4d84249b6$export$2e2bcd8739ae039 = $d9bf16d4d84249b6$var$Stack;

});
parcelRegister("3XhQ8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2e14b868b1672986$export$2e2bcd8739ae039; });

var $exEWR = parcelRequire("exEWR");

var $j47aa = parcelRequire("j47aa");

var $5NSJ8 = parcelRequire("5NSJ8");

var $cgBv1 = parcelRequire("cgBv1");

var $2BJRe = parcelRequire("2BJRe");
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $2e14b868b1672986$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$2e14b868b1672986$var$ListCache.prototype.clear = (0, $exEWR.default);
$2e14b868b1672986$var$ListCache.prototype["delete"] = (0, $j47aa.default);
$2e14b868b1672986$var$ListCache.prototype.get = (0, $5NSJ8.default);
$2e14b868b1672986$var$ListCache.prototype.has = (0, $cgBv1.default);
$2e14b868b1672986$var$ListCache.prototype.set = (0, $2BJRe.default);
var $2e14b868b1672986$export$2e2bcd8739ae039 = $2e14b868b1672986$var$ListCache;

});
parcelRegister("exEWR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a963e94352234617$export$2e2bcd8739ae039; });
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $a963e94352234617$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
var $a963e94352234617$export$2e2bcd8739ae039 = $a963e94352234617$var$listCacheClear;

});

parcelRegister("j47aa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $de13f2741e96eeaa$export$2e2bcd8739ae039; });

var $ef8G2 = parcelRequire("ef8G2");
/** Used for built-in method references. */ var $de13f2741e96eeaa$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $de13f2741e96eeaa$var$splice = $de13f2741e96eeaa$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $de13f2741e96eeaa$var$listCacheDelete(key) {
    var data = this.__data__, index = (0, $ef8G2.default)(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $de13f2741e96eeaa$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
var $de13f2741e96eeaa$export$2e2bcd8739ae039 = $de13f2741e96eeaa$var$listCacheDelete;

});
parcelRegister("ef8G2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a5e932794ccc5943$export$2e2bcd8739ae039; });

var $kuJus = parcelRequire("kuJus");
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $a5e932794ccc5943$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ((0, $kuJus.default)(array[length][0], key)) return length;
    }
    return -1;
}
var $a5e932794ccc5943$export$2e2bcd8739ae039 = $a5e932794ccc5943$var$assocIndexOf;

});
parcelRegister("kuJus", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $eeb9e562c601df3d$export$2e2bcd8739ae039; });
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $eeb9e562c601df3d$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
var $eeb9e562c601df3d$export$2e2bcd8739ae039 = $eeb9e562c601df3d$var$eq;

});



parcelRegister("5NSJ8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $439bfafb0d4013cb$export$2e2bcd8739ae039; });

var $ef8G2 = parcelRequire("ef8G2");
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $439bfafb0d4013cb$var$listCacheGet(key) {
    var data = this.__data__, index = (0, $ef8G2.default)(data, key);
    return index < 0 ? undefined : data[index][1];
}
var $439bfafb0d4013cb$export$2e2bcd8739ae039 = $439bfafb0d4013cb$var$listCacheGet;

});

parcelRegister("cgBv1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8ee4113c4ab76748$export$2e2bcd8739ae039; });

var $ef8G2 = parcelRequire("ef8G2");
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $8ee4113c4ab76748$var$listCacheHas(key) {
    return (0, $ef8G2.default)(this.__data__, key) > -1;
}
var $8ee4113c4ab76748$export$2e2bcd8739ae039 = $8ee4113c4ab76748$var$listCacheHas;

});

parcelRegister("2BJRe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1e629bd60b5fcf66$export$2e2bcd8739ae039; });

var $ef8G2 = parcelRequire("ef8G2");
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $1e629bd60b5fcf66$var$listCacheSet(key, value) {
    var data = this.__data__, index = (0, $ef8G2.default)(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
var $1e629bd60b5fcf66$export$2e2bcd8739ae039 = $1e629bd60b5fcf66$var$listCacheSet;

});


parcelRegister("bJtHo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $88aaef4666839ddf$export$2e2bcd8739ae039; });

var $3XhQ8 = parcelRequire("3XhQ8");
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function $88aaef4666839ddf$var$stackClear() {
    this.__data__ = new (0, $3XhQ8.default);
    this.size = 0;
}
var $88aaef4666839ddf$export$2e2bcd8739ae039 = $88aaef4666839ddf$var$stackClear;

});

parcelRegister("inttw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d6113d1b0d6dd432$export$2e2bcd8739ae039; });
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $d6113d1b0d6dd432$var$stackDelete(key) {
    var data = this.__data__, result = data["delete"](key);
    this.size = data.size;
    return result;
}
var $d6113d1b0d6dd432$export$2e2bcd8739ae039 = $d6113d1b0d6dd432$var$stackDelete;

});

parcelRegister("fT3ht", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b90e898f852a6ab8$export$2e2bcd8739ae039; });
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $b90e898f852a6ab8$var$stackGet(key) {
    return this.__data__.get(key);
}
var $b90e898f852a6ab8$export$2e2bcd8739ae039 = $b90e898f852a6ab8$var$stackGet;

});

parcelRegister("lTLjm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ff136f11dbc7024b$export$2e2bcd8739ae039; });
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $ff136f11dbc7024b$var$stackHas(key) {
    return this.__data__.has(key);
}
var $ff136f11dbc7024b$export$2e2bcd8739ae039 = $ff136f11dbc7024b$var$stackHas;

});

parcelRegister("2xuLV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1d96887e2aab365e$export$2e2bcd8739ae039; });

var $3XhQ8 = parcelRequire("3XhQ8");

var $3dqC1 = parcelRequire("3dqC1");

var $5bIkI = parcelRequire("5bIkI");
/** Used as the size to enable large array optimizations. */ var $1d96887e2aab365e$var$LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function $1d96887e2aab365e$var$stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof (0, $3XhQ8.default)) {
        var pairs = data.__data__;
        if (!(0, $3dqC1.default) || pairs.length < $1d96887e2aab365e$var$LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new (0, $5bIkI.default)(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
var $1d96887e2aab365e$export$2e2bcd8739ae039 = $1d96887e2aab365e$var$stackSet;

});
parcelRegister("3dqC1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $25773aa5940e7b4c$export$2e2bcd8739ae039; });

var $1aTGj = parcelRequire("1aTGj");

var $ier4x = parcelRequire("ier4x");
/* Built-in method references that are verified to be native. */ var $25773aa5940e7b4c$var$Map = (0, $1aTGj.default)((0, $ier4x.default), "Map");
var $25773aa5940e7b4c$export$2e2bcd8739ae039 = $25773aa5940e7b4c$var$Map;

});
parcelRegister("1aTGj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0db1eac8602cea00$export$2e2bcd8739ae039; });

var $5Lyj3 = parcelRequire("5Lyj3");

var $vFal2 = parcelRequire("vFal2");
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $0db1eac8602cea00$var$getNative(object, key) {
    var value = (0, $vFal2.default)(object, key);
    return (0, $5Lyj3.default)(value) ? value : undefined;
}
var $0db1eac8602cea00$export$2e2bcd8739ae039 = $0db1eac8602cea00$var$getNative;

});
parcelRegister("5Lyj3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $432bf4158c16bc46$export$2e2bcd8739ae039; });

var $iU2Nc = parcelRequire("iU2Nc");

var $evzVY = parcelRequire("evzVY");

var $3dn92 = parcelRequire("3dn92");

var $4yWcy = parcelRequire("4yWcy");
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $432bf4158c16bc46$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $432bf4158c16bc46$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $432bf4158c16bc46$var$funcProto = Function.prototype, $432bf4158c16bc46$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $432bf4158c16bc46$var$funcToString = $432bf4158c16bc46$var$funcProto.toString;
/** Used to check objects for own properties. */ var $432bf4158c16bc46$var$hasOwnProperty = $432bf4158c16bc46$var$objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var $432bf4158c16bc46$var$reIsNative = RegExp("^" + $432bf4158c16bc46$var$funcToString.call($432bf4158c16bc46$var$hasOwnProperty).replace($432bf4158c16bc46$var$reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $432bf4158c16bc46$var$baseIsNative(value) {
    if (!(0, $3dn92.default)(value) || (0, $evzVY.default)(value)) return false;
    var pattern = (0, $iU2Nc.default)(value) ? $432bf4158c16bc46$var$reIsNative : $432bf4158c16bc46$var$reIsHostCtor;
    return pattern.test((0, $4yWcy.default)(value));
}
var $432bf4158c16bc46$export$2e2bcd8739ae039 = $432bf4158c16bc46$var$baseIsNative;

});
parcelRegister("iU2Nc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dc2f9f78d9753304$export$2e2bcd8739ae039; });

var $e8qHT = parcelRequire("e8qHT");

var $3dn92 = parcelRequire("3dn92");
/** `Object#toString` result references. */ var $dc2f9f78d9753304$var$asyncTag = "[object AsyncFunction]", $dc2f9f78d9753304$var$funcTag = "[object Function]", $dc2f9f78d9753304$var$genTag = "[object GeneratorFunction]", $dc2f9f78d9753304$var$proxyTag = "[object Proxy]";
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $dc2f9f78d9753304$var$isFunction(value) {
    if (!(0, $3dn92.default)(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = (0, $e8qHT.default)(value);
    return tag == $dc2f9f78d9753304$var$funcTag || tag == $dc2f9f78d9753304$var$genTag || tag == $dc2f9f78d9753304$var$asyncTag || tag == $dc2f9f78d9753304$var$proxyTag;
}
var $dc2f9f78d9753304$export$2e2bcd8739ae039 = $dc2f9f78d9753304$var$isFunction;

});
parcelRegister("e8qHT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a4a68779135a927a$export$2e2bcd8739ae039; });

var $7Kr41 = parcelRequire("7Kr41");

var $cVCtw = parcelRequire("cVCtw");

var $ilBhm = parcelRequire("ilBhm");
/** `Object#toString` result references. */ var $a4a68779135a927a$var$nullTag = "[object Null]", $a4a68779135a927a$var$undefinedTag = "[object Undefined]";
/** Built-in value references. */ var $a4a68779135a927a$var$symToStringTag = (0, $7Kr41.default) ? (0, $7Kr41.default).toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $a4a68779135a927a$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $a4a68779135a927a$var$undefinedTag : $a4a68779135a927a$var$nullTag;
    return $a4a68779135a927a$var$symToStringTag && $a4a68779135a927a$var$symToStringTag in Object(value) ? (0, $cVCtw.default)(value) : (0, $ilBhm.default)(value);
}
var $a4a68779135a927a$export$2e2bcd8739ae039 = $a4a68779135a927a$var$baseGetTag;

});
parcelRegister("7Kr41", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5a41d29b535fbda9$export$2e2bcd8739ae039; });

var $ier4x = parcelRequire("ier4x");
/** Built-in value references. */ var $5a41d29b535fbda9$var$Symbol = (0, $ier4x.default).Symbol;
var $5a41d29b535fbda9$export$2e2bcd8739ae039 = $5a41d29b535fbda9$var$Symbol;

});
parcelRegister("ier4x", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d45e88c10410afd4$export$2e2bcd8739ae039; });

var $iFBbo = parcelRequire("iFBbo");
/** Detect free variable `self`. */ var $d45e88c10410afd4$var$freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $d45e88c10410afd4$var$root = (0, $iFBbo.default) || $d45e88c10410afd4$var$freeSelf || Function("return this")();
var $d45e88c10410afd4$export$2e2bcd8739ae039 = $d45e88c10410afd4$var$root;

});
parcelRegister("iFBbo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d978e60cc59c038b$export$2e2bcd8739ae039; });
/** Detect free variable `global` from Node.js. */ var $d978e60cc59c038b$var$freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
var $d978e60cc59c038b$export$2e2bcd8739ae039 = $d978e60cc59c038b$var$freeGlobal;

});



parcelRegister("cVCtw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9698a749e3adeb0b$export$2e2bcd8739ae039; });

var $7Kr41 = parcelRequire("7Kr41");
/** Used for built-in method references. */ var $9698a749e3adeb0b$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $9698a749e3adeb0b$var$hasOwnProperty = $9698a749e3adeb0b$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $9698a749e3adeb0b$var$nativeObjectToString = $9698a749e3adeb0b$var$objectProto.toString;
/** Built-in value references. */ var $9698a749e3adeb0b$var$symToStringTag = (0, $7Kr41.default) ? (0, $7Kr41.default).toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $9698a749e3adeb0b$var$getRawTag(value) {
    var isOwn = $9698a749e3adeb0b$var$hasOwnProperty.call(value, $9698a749e3adeb0b$var$symToStringTag), tag = value[$9698a749e3adeb0b$var$symToStringTag];
    try {
        value[$9698a749e3adeb0b$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $9698a749e3adeb0b$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$9698a749e3adeb0b$var$symToStringTag] = tag;
        else delete value[$9698a749e3adeb0b$var$symToStringTag];
    }
    return result;
}
var $9698a749e3adeb0b$export$2e2bcd8739ae039 = $9698a749e3adeb0b$var$getRawTag;

});

parcelRegister("ilBhm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d5b71aff0f880d1b$export$2e2bcd8739ae039; });
/** Used for built-in method references. */ var $d5b71aff0f880d1b$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $d5b71aff0f880d1b$var$nativeObjectToString = $d5b71aff0f880d1b$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $d5b71aff0f880d1b$var$objectToString(value) {
    return $d5b71aff0f880d1b$var$nativeObjectToString.call(value);
}
var $d5b71aff0f880d1b$export$2e2bcd8739ae039 = $d5b71aff0f880d1b$var$objectToString;

});


parcelRegister("3dn92", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $25748a0d7cbe14c0$export$2e2bcd8739ae039; });
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $25748a0d7cbe14c0$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == "object" || type == "function");
}
var $25748a0d7cbe14c0$export$2e2bcd8739ae039 = $25748a0d7cbe14c0$var$isObject;

});


parcelRegister("evzVY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a8ffd5b6435114d2$export$2e2bcd8739ae039; });

var $7O6Fk = parcelRequire("7O6Fk");
/** Used to detect methods masquerading as native. */ var $a8ffd5b6435114d2$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec((0, $7O6Fk.default) && (0, $7O6Fk.default).keys && (0, $7O6Fk.default).keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $a8ffd5b6435114d2$var$isMasked(func) {
    return !!$a8ffd5b6435114d2$var$maskSrcKey && $a8ffd5b6435114d2$var$maskSrcKey in func;
}
var $a8ffd5b6435114d2$export$2e2bcd8739ae039 = $a8ffd5b6435114d2$var$isMasked;

});
parcelRegister("7O6Fk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5af25f95eb06a072$export$2e2bcd8739ae039; });

var $ier4x = parcelRequire("ier4x");
/** Used to detect overreaching core-js shims. */ var $5af25f95eb06a072$var$coreJsData = (0, $ier4x.default)["__core-js_shared__"];
var $5af25f95eb06a072$export$2e2bcd8739ae039 = $5af25f95eb06a072$var$coreJsData;

});


parcelRegister("4yWcy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $35277c0394d92823$export$2e2bcd8739ae039; });
/** Used for built-in method references. */ var $35277c0394d92823$var$funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $35277c0394d92823$var$funcToString = $35277c0394d92823$var$funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $35277c0394d92823$var$toSource(func) {
    if (func != null) {
        try {
            return $35277c0394d92823$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + "";
        } catch (e) {}
    }
    return "";
}
var $35277c0394d92823$export$2e2bcd8739ae039 = $35277c0394d92823$var$toSource;

});


parcelRegister("vFal2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $05f2d406672c2a96$export$2e2bcd8739ae039; });
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $05f2d406672c2a96$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
var $05f2d406672c2a96$export$2e2bcd8739ae039 = $05f2d406672c2a96$var$getValue;

});



parcelRegister("5bIkI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3c705e7737702eab$export$2e2bcd8739ae039; });

var $boKtZ = parcelRequire("boKtZ");

var $lNDMf = parcelRequire("lNDMf");

var $4LUsR = parcelRequire("4LUsR");

var $1JOhi = parcelRequire("1JOhi");

var $2hJnY = parcelRequire("2hJnY");
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $3c705e7737702eab$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$3c705e7737702eab$var$MapCache.prototype.clear = (0, $boKtZ.default);
$3c705e7737702eab$var$MapCache.prototype["delete"] = (0, $lNDMf.default);
$3c705e7737702eab$var$MapCache.prototype.get = (0, $4LUsR.default);
$3c705e7737702eab$var$MapCache.prototype.has = (0, $1JOhi.default);
$3c705e7737702eab$var$MapCache.prototype.set = (0, $2hJnY.default);
var $3c705e7737702eab$export$2e2bcd8739ae039 = $3c705e7737702eab$var$MapCache;

});
parcelRegister("boKtZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $84c5fe143b0f805f$export$2e2bcd8739ae039; });

var $eO9B6 = parcelRequire("eO9B6");

var $3XhQ8 = parcelRequire("3XhQ8");

var $3dqC1 = parcelRequire("3dqC1");
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $84c5fe143b0f805f$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        "hash": new (0, $eO9B6.default),
        "map": new ((0, $3dqC1.default) || (0, $3XhQ8.default)),
        "string": new (0, $eO9B6.default)
    };
}
var $84c5fe143b0f805f$export$2e2bcd8739ae039 = $84c5fe143b0f805f$var$mapCacheClear;

});
parcelRegister("eO9B6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ac7d2e0b5c1c445f$export$2e2bcd8739ae039; });

var $ncVNZ = parcelRequire("ncVNZ");

var $82cjB = parcelRequire("82cjB");

var $4cT1S = parcelRequire("4cT1S");

var $fts3J = parcelRequire("fts3J");

var $h2bR4 = parcelRequire("h2bR4");
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $ac7d2e0b5c1c445f$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$ac7d2e0b5c1c445f$var$Hash.prototype.clear = (0, $ncVNZ.default);
$ac7d2e0b5c1c445f$var$Hash.prototype["delete"] = (0, $82cjB.default);
$ac7d2e0b5c1c445f$var$Hash.prototype.get = (0, $4cT1S.default);
$ac7d2e0b5c1c445f$var$Hash.prototype.has = (0, $fts3J.default);
$ac7d2e0b5c1c445f$var$Hash.prototype.set = (0, $h2bR4.default);
var $ac7d2e0b5c1c445f$export$2e2bcd8739ae039 = $ac7d2e0b5c1c445f$var$Hash;

});
parcelRegister("ncVNZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $045c2dfe2bd671f4$export$2e2bcd8739ae039; });

var $bhg8X = parcelRequire("bhg8X");
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $045c2dfe2bd671f4$var$hashClear() {
    this.__data__ = (0, $bhg8X.default) ? (0, $bhg8X.default)(null) : {};
    this.size = 0;
}
var $045c2dfe2bd671f4$export$2e2bcd8739ae039 = $045c2dfe2bd671f4$var$hashClear;

});
parcelRegister("bhg8X", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $835dcdfabf22e39b$export$2e2bcd8739ae039; });

var $1aTGj = parcelRequire("1aTGj");
/* Built-in method references that are verified to be native. */ var $835dcdfabf22e39b$var$nativeCreate = (0, $1aTGj.default)(Object, "create");
var $835dcdfabf22e39b$export$2e2bcd8739ae039 = $835dcdfabf22e39b$var$nativeCreate;

});


parcelRegister("82cjB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5d98102cf28b1901$export$2e2bcd8739ae039; });
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $5d98102cf28b1901$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
var $5d98102cf28b1901$export$2e2bcd8739ae039 = $5d98102cf28b1901$var$hashDelete;

});

parcelRegister("4cT1S", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3102f812a723a943$export$2e2bcd8739ae039; });

var $bhg8X = parcelRequire("bhg8X");
/** Used to stand-in for `undefined` hash values. */ var $3102f812a723a943$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/** Used for built-in method references. */ var $3102f812a723a943$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $3102f812a723a943$var$hasOwnProperty = $3102f812a723a943$var$objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $3102f812a723a943$var$hashGet(key) {
    var data = this.__data__;
    if (0, $bhg8X.default) {
        var result = data[key];
        return result === $3102f812a723a943$var$HASH_UNDEFINED ? undefined : result;
    }
    return $3102f812a723a943$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
var $3102f812a723a943$export$2e2bcd8739ae039 = $3102f812a723a943$var$hashGet;

});

parcelRegister("fts3J", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b43f54681c6dab3a$export$2e2bcd8739ae039; });

var $bhg8X = parcelRequire("bhg8X");
/** Used for built-in method references. */ var $b43f54681c6dab3a$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $b43f54681c6dab3a$var$hasOwnProperty = $b43f54681c6dab3a$var$objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $b43f54681c6dab3a$var$hashHas(key) {
    var data = this.__data__;
    return (0, $bhg8X.default) ? data[key] !== undefined : $b43f54681c6dab3a$var$hasOwnProperty.call(data, key);
}
var $b43f54681c6dab3a$export$2e2bcd8739ae039 = $b43f54681c6dab3a$var$hashHas;

});

parcelRegister("h2bR4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c66bd1b800da54ad$export$2e2bcd8739ae039; });

var $bhg8X = parcelRequire("bhg8X");
/** Used to stand-in for `undefined` hash values. */ var $c66bd1b800da54ad$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $c66bd1b800da54ad$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = (0, $bhg8X.default) && value === undefined ? $c66bd1b800da54ad$var$HASH_UNDEFINED : value;
    return this;
}
var $c66bd1b800da54ad$export$2e2bcd8739ae039 = $c66bd1b800da54ad$var$hashSet;

});



parcelRegister("lNDMf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fded07795f582f2e$export$2e2bcd8739ae039; });

var $eTCzK = parcelRequire("eTCzK");
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $fded07795f582f2e$var$mapCacheDelete(key) {
    var result = (0, $eTCzK.default)(this, key)["delete"](key);
    this.size -= result ? 1 : 0;
    return result;
}
var $fded07795f582f2e$export$2e2bcd8739ae039 = $fded07795f582f2e$var$mapCacheDelete;

});
parcelRegister("eTCzK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ad842007ed75dbc7$export$2e2bcd8739ae039; });

var $khhqY = parcelRequire("khhqY");
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $ad842007ed75dbc7$var$getMapData(map, key) {
    var data = map.__data__;
    return (0, $khhqY.default)(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
var $ad842007ed75dbc7$export$2e2bcd8739ae039 = $ad842007ed75dbc7$var$getMapData;

});
parcelRegister("khhqY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ec32eb3b35ab32ec$export$2e2bcd8739ae039; });
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $ec32eb3b35ab32ec$var$isKeyable(value) {
    var type = typeof value;
    return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
var $ec32eb3b35ab32ec$export$2e2bcd8739ae039 = $ec32eb3b35ab32ec$var$isKeyable;

});



parcelRegister("4LUsR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $379759e530f16f4c$export$2e2bcd8739ae039; });

var $eTCzK = parcelRequire("eTCzK");
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $379759e530f16f4c$var$mapCacheGet(key) {
    return (0, $eTCzK.default)(this, key).get(key);
}
var $379759e530f16f4c$export$2e2bcd8739ae039 = $379759e530f16f4c$var$mapCacheGet;

});

parcelRegister("1JOhi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1440fe90d804fbe0$export$2e2bcd8739ae039; });

var $eTCzK = parcelRequire("eTCzK");
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $1440fe90d804fbe0$var$mapCacheHas(key) {
    return (0, $eTCzK.default)(this, key).has(key);
}
var $1440fe90d804fbe0$export$2e2bcd8739ae039 = $1440fe90d804fbe0$var$mapCacheHas;

});

parcelRegister("2hJnY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1aa05ff4308d8b18$export$2e2bcd8739ae039; });

var $eTCzK = parcelRequire("eTCzK");
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $1aa05ff4308d8b18$var$mapCacheSet(key, value) {
    var data = (0, $eTCzK.default)(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
var $1aa05ff4308d8b18$export$2e2bcd8739ae039 = $1aa05ff4308d8b18$var$mapCacheSet;

});




parcelRegister("hrfbV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cb20bdf7805c2c76$export$2e2bcd8739ae039; });

var $dDl9K = parcelRequire("dDl9K");

var $kuJus = parcelRequire("kuJus");
/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $cb20bdf7805c2c76$var$assignMergeValue(object, key, value) {
    if (value !== undefined && !(0, $kuJus.default)(object[key], value) || value === undefined && !(key in object)) (0, $dDl9K.default)(object, key, value);
}
var $cb20bdf7805c2c76$export$2e2bcd8739ae039 = $cb20bdf7805c2c76$var$assignMergeValue;

});
parcelRegister("dDl9K", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9ecf54100ca47aba$export$2e2bcd8739ae039; });

var $1goHH = parcelRequire("1goHH");
/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $9ecf54100ca47aba$var$baseAssignValue(object, key, value) {
    if (key == "__proto__" && (0, $1goHH.default)) (0, $1goHH.default)(object, key, {
        "configurable": true,
        "enumerable": true,
        "value": value,
        "writable": true
    });
    else object[key] = value;
}
var $9ecf54100ca47aba$export$2e2bcd8739ae039 = $9ecf54100ca47aba$var$baseAssignValue;

});
parcelRegister("1goHH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0eba72c26ca3c12e$export$2e2bcd8739ae039; });

var $1aTGj = parcelRequire("1aTGj");
var $0eba72c26ca3c12e$var$defineProperty = function() {
    try {
        var func = (0, $1aTGj.default)(Object, "defineProperty");
        func({}, "", {});
        return func;
    } catch (e) {}
}();
var $0eba72c26ca3c12e$export$2e2bcd8739ae039 = $0eba72c26ca3c12e$var$defineProperty;

});



parcelRegister("bpjCU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $84e140eb0a34aa86$export$2e2bcd8739ae039; });

var $1KDdS = parcelRequire("1KDdS");
/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var $84e140eb0a34aa86$var$baseFor = (0, $1KDdS.default)();
var $84e140eb0a34aa86$export$2e2bcd8739ae039 = $84e140eb0a34aa86$var$baseFor;

});
parcelRegister("1KDdS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1468832735f89d21$export$2e2bcd8739ae039; });
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $1468832735f89d21$var$createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
var $1468832735f89d21$export$2e2bcd8739ae039 = $1468832735f89d21$var$createBaseFor;

});


parcelRegister("bHw9b", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0232c8dd76261eb5$export$2e2bcd8739ae039; });

var $hrfbV = parcelRequire("hrfbV");

var $i04Md = parcelRequire("i04Md");

var $1GJfb = parcelRequire("1GJfb");

var $1fu56 = parcelRequire("1fu56");

var $jQZjO = parcelRequire("jQZjO");

var $lRAEc = parcelRequire("lRAEc");

var $o0x3M = parcelRequire("o0x3M");

var $avEH3 = parcelRequire("avEH3");

var $igoKr = parcelRequire("igoKr");

var $iU2Nc = parcelRequire("iU2Nc");

var $3dn92 = parcelRequire("3dn92");

var $cFeTV = parcelRequire("cFeTV");

var $9kZhJ = parcelRequire("9kZhJ");

var $1Abx0 = parcelRequire("1Abx0");

var $44J71 = parcelRequire("44J71");
/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function $0232c8dd76261eb5$var$baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
    var objValue = (0, $1Abx0.default)(object, key), srcValue = (0, $1Abx0.default)(source, key), stacked = stack.get(srcValue);
    if (stacked) {
        (0, $hrfbV.default)(object, key, stacked);
        return;
    }
    var newValue = customizer ? customizer(objValue, srcValue, key + "", object, source, stack) : undefined;
    var isCommon = newValue === undefined;
    if (isCommon) {
        var isArr = (0, $o0x3M.default)(srcValue), isBuff = !isArr && (0, $igoKr.default)(srcValue), isTyped = !isArr && !isBuff && (0, $9kZhJ.default)(srcValue);
        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
            if ((0, $o0x3M.default)(objValue)) newValue = objValue;
            else if ((0, $avEH3.default)(objValue)) newValue = (0, $1fu56.default)(objValue);
            else if (isBuff) {
                isCommon = false;
                newValue = (0, $i04Md.default)(srcValue, true);
            } else if (isTyped) {
                isCommon = false;
                newValue = (0, $1GJfb.default)(srcValue, true);
            } else newValue = [];
        } else if ((0, $cFeTV.default)(srcValue) || (0, $lRAEc.default)(srcValue)) {
            newValue = objValue;
            if ((0, $lRAEc.default)(objValue)) newValue = (0, $44J71.default)(objValue);
            else if (!(0, $3dn92.default)(objValue) || (0, $iU2Nc.default)(objValue)) newValue = (0, $jQZjO.default)(srcValue);
        } else isCommon = false;
    }
    if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack["delete"](srcValue);
    }
    (0, $hrfbV.default)(object, key, newValue);
}
var $0232c8dd76261eb5$export$2e2bcd8739ae039 = $0232c8dd76261eb5$var$baseMergeDeep;

});
parcelRegister("i04Md", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d1abeea3a395a578$export$2e2bcd8739ae039; });

var $ier4x = parcelRequire("ier4x");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? (0, $ier4x.default).Buffer : undefined, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */ function cloneBuffer(buffer, isDeep) {
    if (isDeep) return buffer.slice();
    var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result);
    return result;
}
var $d1abeea3a395a578$export$2e2bcd8739ae039 = cloneBuffer;

});

parcelRegister("1GJfb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $13accf28b5781771$export$2e2bcd8739ae039; });

var $l6hFG = parcelRequire("l6hFG");
/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */ function $13accf28b5781771$var$cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? (0, $l6hFG.default)(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
var $13accf28b5781771$export$2e2bcd8739ae039 = $13accf28b5781771$var$cloneTypedArray;

});
parcelRegister("l6hFG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f5c7dda80d34a02a$export$2e2bcd8739ae039; });

var $h4O8Z = parcelRequire("h4O8Z");
/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */ function $f5c7dda80d34a02a$var$cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new (0, $h4O8Z.default)(result).set(new (0, $h4O8Z.default)(arrayBuffer));
    return result;
}
var $f5c7dda80d34a02a$export$2e2bcd8739ae039 = $f5c7dda80d34a02a$var$cloneArrayBuffer;

});
parcelRegister("h4O8Z", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c6e9b4ec73f542b2$export$2e2bcd8739ae039; });

var $ier4x = parcelRequire("ier4x");
/** Built-in value references. */ var $c6e9b4ec73f542b2$var$Uint8Array = (0, $ier4x.default).Uint8Array;
var $c6e9b4ec73f542b2$export$2e2bcd8739ae039 = $c6e9b4ec73f542b2$var$Uint8Array;

});



parcelRegister("1fu56", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0e8e86ab14c0a404$export$2e2bcd8739ae039; });
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ function $0e8e86ab14c0a404$var$copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
var $0e8e86ab14c0a404$export$2e2bcd8739ae039 = $0e8e86ab14c0a404$var$copyArray;

});

parcelRegister("jQZjO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e74270428480da5e$export$2e2bcd8739ae039; });

var $4xg64 = parcelRequire("4xg64");

var $hFotT = parcelRequire("hFotT");

var $Iv4Ln = parcelRequire("Iv4Ln");
/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */ function $e74270428480da5e$var$initCloneObject(object) {
    return typeof object.constructor == "function" && !(0, $Iv4Ln.default)(object) ? (0, $4xg64.default)((0, $hFotT.default)(object)) : {};
}
var $e74270428480da5e$export$2e2bcd8739ae039 = $e74270428480da5e$var$initCloneObject;

});
parcelRegister("4xg64", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $34d6bb04b10f8aea$export$2e2bcd8739ae039; });

var $3dn92 = parcelRequire("3dn92");
/** Built-in value references. */ var $34d6bb04b10f8aea$var$objectCreate = Object.create;
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */ var $34d6bb04b10f8aea$var$baseCreate = function() {
    function object() {}
    return function(proto) {
        if (!(0, $3dn92.default)(proto)) return {};
        if ($34d6bb04b10f8aea$var$objectCreate) return $34d6bb04b10f8aea$var$objectCreate(proto);
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
    };
}();
var $34d6bb04b10f8aea$export$2e2bcd8739ae039 = $34d6bb04b10f8aea$var$baseCreate;

});

parcelRegister("hFotT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cdc9416ec3a0264b$export$2e2bcd8739ae039; });

var $69m2l = parcelRequire("69m2l");
/** Built-in value references. */ var $cdc9416ec3a0264b$var$getPrototype = (0, $69m2l.default)(Object.getPrototypeOf, Object);
var $cdc9416ec3a0264b$export$2e2bcd8739ae039 = $cdc9416ec3a0264b$var$getPrototype;

});
parcelRegister("69m2l", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $47a4ad607c69fe3a$export$2e2bcd8739ae039; });
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $47a4ad607c69fe3a$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
var $47a4ad607c69fe3a$export$2e2bcd8739ae039 = $47a4ad607c69fe3a$var$overArg;

});


parcelRegister("Iv4Ln", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $085c372fceab446a$export$2e2bcd8739ae039; });
/** Used for built-in method references. */ var $085c372fceab446a$var$objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $085c372fceab446a$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || $085c372fceab446a$var$objectProto;
    return value === proto;
}
var $085c372fceab446a$export$2e2bcd8739ae039 = $085c372fceab446a$var$isPrototype;

});


parcelRegister("lRAEc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $feaaf99b892a2807$export$2e2bcd8739ae039; });

var $a0a85 = parcelRequire("a0a85");

var $BOPtQ = parcelRequire("BOPtQ");
/** Used for built-in method references. */ var $feaaf99b892a2807$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $feaaf99b892a2807$var$hasOwnProperty = $feaaf99b892a2807$var$objectProto.hasOwnProperty;
/** Built-in value references. */ var $feaaf99b892a2807$var$propertyIsEnumerable = $feaaf99b892a2807$var$objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var $feaaf99b892a2807$var$isArguments = (0, $a0a85.default)(function() {
    return arguments;
}()) ? (0, $a0a85.default) : function(value) {
    return (0, $BOPtQ.default)(value) && $feaaf99b892a2807$var$hasOwnProperty.call(value, "callee") && !$feaaf99b892a2807$var$propertyIsEnumerable.call(value, "callee");
};
var $feaaf99b892a2807$export$2e2bcd8739ae039 = $feaaf99b892a2807$var$isArguments;

});
parcelRegister("a0a85", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7481c2f94683e9a0$export$2e2bcd8739ae039; });

var $e8qHT = parcelRequire("e8qHT");

var $BOPtQ = parcelRequire("BOPtQ");
/** `Object#toString` result references. */ var $7481c2f94683e9a0$var$argsTag = "[object Arguments]";
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function $7481c2f94683e9a0$var$baseIsArguments(value) {
    return (0, $BOPtQ.default)(value) && (0, $e8qHT.default)(value) == $7481c2f94683e9a0$var$argsTag;
}
var $7481c2f94683e9a0$export$2e2bcd8739ae039 = $7481c2f94683e9a0$var$baseIsArguments;

});
parcelRegister("BOPtQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $071ae2763fad6b0a$export$2e2bcd8739ae039; });
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $071ae2763fad6b0a$var$isObjectLike(value) {
    return value != null && typeof value == "object";
}
var $071ae2763fad6b0a$export$2e2bcd8739ae039 = $071ae2763fad6b0a$var$isObjectLike;

});



parcelRegister("o0x3M", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0482a7b1c37d82c4$export$2e2bcd8739ae039; });
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $0482a7b1c37d82c4$var$isArray = Array.isArray;
var $0482a7b1c37d82c4$export$2e2bcd8739ae039 = $0482a7b1c37d82c4$var$isArray;

});

parcelRegister("avEH3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7a6c5d83033800e1$export$2e2bcd8739ae039; });

var $dHPlr = parcelRequire("dHPlr");

var $BOPtQ = parcelRequire("BOPtQ");
/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function $7a6c5d83033800e1$var$isArrayLikeObject(value) {
    return (0, $BOPtQ.default)(value) && (0, $dHPlr.default)(value);
}
var $7a6c5d83033800e1$export$2e2bcd8739ae039 = $7a6c5d83033800e1$var$isArrayLikeObject;

});
parcelRegister("dHPlr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9fa71e83b98fbb84$export$2e2bcd8739ae039; });

var $iU2Nc = parcelRequire("iU2Nc");

var $ealNX = parcelRequire("ealNX");
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $9fa71e83b98fbb84$var$isArrayLike(value) {
    return value != null && (0, $ealNX.default)(value.length) && !(0, $iU2Nc.default)(value);
}
var $9fa71e83b98fbb84$export$2e2bcd8739ae039 = $9fa71e83b98fbb84$var$isArrayLike;

});
parcelRegister("ealNX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a502e9cfca20b420$export$2e2bcd8739ae039; });
/** Used as references for various `Number` constants. */ var $a502e9cfca20b420$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $a502e9cfca20b420$var$isLength(value) {
    return typeof value == "number" && value > -1 && value % 1 == 0 && value <= $a502e9cfca20b420$var$MAX_SAFE_INTEGER;
}
var $a502e9cfca20b420$export$2e2bcd8739ae039 = $a502e9cfca20b420$var$isLength;

});



parcelRegister("igoKr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d4bceb13546a335b$export$2e2bcd8739ae039; });

var $ier4x = parcelRequire("ier4x");

var $k1Fw9 = parcelRequire("k1Fw9");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? (0, $ier4x.default).Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || (0, $k1Fw9.default);
var $d4bceb13546a335b$export$2e2bcd8739ae039 = isBuffer;

});
parcelRegister("k1Fw9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e9441b24891bd46f$export$2e2bcd8739ae039; });
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function $e9441b24891bd46f$var$stubFalse() {
    return false;
}
var $e9441b24891bd46f$export$2e2bcd8739ae039 = $e9441b24891bd46f$var$stubFalse;

});


parcelRegister("cFeTV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9384df634da96665$export$2e2bcd8739ae039; });

var $e8qHT = parcelRequire("e8qHT");

var $hFotT = parcelRequire("hFotT");

var $BOPtQ = parcelRequire("BOPtQ");
/** `Object#toString` result references. */ var $9384df634da96665$var$objectTag = "[object Object]";
/** Used for built-in method references. */ var $9384df634da96665$var$funcProto = Function.prototype, $9384df634da96665$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $9384df634da96665$var$funcToString = $9384df634da96665$var$funcProto.toString;
/** Used to check objects for own properties. */ var $9384df634da96665$var$hasOwnProperty = $9384df634da96665$var$objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var $9384df634da96665$var$objectCtorString = $9384df634da96665$var$funcToString.call(Object);
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function $9384df634da96665$var$isPlainObject(value) {
    if (!(0, $BOPtQ.default)(value) || (0, $e8qHT.default)(value) != $9384df634da96665$var$objectTag) return false;
    var proto = (0, $hFotT.default)(value);
    if (proto === null) return true;
    var Ctor = $9384df634da96665$var$hasOwnProperty.call(proto, "constructor") && proto.constructor;
    return typeof Ctor == "function" && Ctor instanceof Ctor && $9384df634da96665$var$funcToString.call(Ctor) == $9384df634da96665$var$objectCtorString;
}
var $9384df634da96665$export$2e2bcd8739ae039 = $9384df634da96665$var$isPlainObject;

});

parcelRegister("9kZhJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6cc58537eccc3ef4$export$2e2bcd8739ae039; });

var $lwH8J = parcelRequire("lwH8J");

var $iWSqN = parcelRequire("iWSqN");

var $85lyy = parcelRequire("85lyy");
/* Node.js helper references. */ var $6cc58537eccc3ef4$var$nodeIsTypedArray = (0, $85lyy.default) && (0, $85lyy.default).isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var $6cc58537eccc3ef4$var$isTypedArray = $6cc58537eccc3ef4$var$nodeIsTypedArray ? (0, $iWSqN.default)($6cc58537eccc3ef4$var$nodeIsTypedArray) : (0, $lwH8J.default);
var $6cc58537eccc3ef4$export$2e2bcd8739ae039 = $6cc58537eccc3ef4$var$isTypedArray;

});
parcelRegister("lwH8J", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fabe0cce3f5d5b01$export$2e2bcd8739ae039; });

var $e8qHT = parcelRequire("e8qHT");

var $ealNX = parcelRequire("ealNX");

var $BOPtQ = parcelRequire("BOPtQ");
/** `Object#toString` result references. */ var $fabe0cce3f5d5b01$var$argsTag = "[object Arguments]", $fabe0cce3f5d5b01$var$arrayTag = "[object Array]", $fabe0cce3f5d5b01$var$boolTag = "[object Boolean]", $fabe0cce3f5d5b01$var$dateTag = "[object Date]", $fabe0cce3f5d5b01$var$errorTag = "[object Error]", $fabe0cce3f5d5b01$var$funcTag = "[object Function]", $fabe0cce3f5d5b01$var$mapTag = "[object Map]", $fabe0cce3f5d5b01$var$numberTag = "[object Number]", $fabe0cce3f5d5b01$var$objectTag = "[object Object]", $fabe0cce3f5d5b01$var$regexpTag = "[object RegExp]", $fabe0cce3f5d5b01$var$setTag = "[object Set]", $fabe0cce3f5d5b01$var$stringTag = "[object String]", $fabe0cce3f5d5b01$var$weakMapTag = "[object WeakMap]";
var $fabe0cce3f5d5b01$var$arrayBufferTag = "[object ArrayBuffer]", $fabe0cce3f5d5b01$var$dataViewTag = "[object DataView]", $fabe0cce3f5d5b01$var$float32Tag = "[object Float32Array]", $fabe0cce3f5d5b01$var$float64Tag = "[object Float64Array]", $fabe0cce3f5d5b01$var$int8Tag = "[object Int8Array]", $fabe0cce3f5d5b01$var$int16Tag = "[object Int16Array]", $fabe0cce3f5d5b01$var$int32Tag = "[object Int32Array]", $fabe0cce3f5d5b01$var$uint8Tag = "[object Uint8Array]", $fabe0cce3f5d5b01$var$uint8ClampedTag = "[object Uint8ClampedArray]", $fabe0cce3f5d5b01$var$uint16Tag = "[object Uint16Array]", $fabe0cce3f5d5b01$var$uint32Tag = "[object Uint32Array]";
/** Used to identify `toStringTag` values of typed arrays. */ var $fabe0cce3f5d5b01$var$typedArrayTags = {};
$fabe0cce3f5d5b01$var$typedArrayTags[$fabe0cce3f5d5b01$var$float32Tag] = $fabe0cce3f5d5b01$var$typedArrayTags[$fabe0cce3f5d5b01$var$float64Tag] = $fabe0cce3f5d5b01$var$typedArrayTags[$fabe0cce3f5d5b01$var$int8Tag] = $fabe0cce3f5d5b01$var$typedArrayTags[$fabe0cce3f5d5b01$var$int16Tag] = $fabe0cce3f5d5b01$var$typedArrayTags[$fabe0cce3f5d5b01$var$int32Tag] = $fabe0cce3f5d5b01$var$typedArrayTags[$fabe0cce3f5d5b01$var$uint8Tag] = $fabe0cce3f5d5b01$var$typedArrayTags[$fabe0cce3f5d5b01$var$uint8ClampedTag] = $fabe0cce3f5d5b01$var$typedArrayTags[$fabe0cce3f5d5b01$var$uint16Tag] = $fabe0cce3f5d5b01$var$typedArrayTags[$fabe0cce3f5d5b01$var$uint32Tag] = true;
$fabe0cce3f5d5b01$var$typedArrayTags[$fabe0cce3f5d5b01$var$argsTag] = $fabe0cce3f5d5b01$var$typedArrayTags[$fabe0cce3f5d5b01$var$arrayTag] = $fabe0cce3f5d5b01$var$typedArrayTags[$fabe0cce3f5d5b01$var$arrayBufferTag] = $fabe0cce3f5d5b01$var$typedArrayTags[$fabe0cce3f5d5b01$var$boolTag] = $fabe0cce3f5d5b01$var$typedArrayTags[$fabe0cce3f5d5b01$var$dataViewTag] = $fabe0cce3f5d5b01$var$typedArrayTags[$fabe0cce3f5d5b01$var$dateTag] = $fabe0cce3f5d5b01$var$typedArrayTags[$fabe0cce3f5d5b01$var$errorTag] = $fabe0cce3f5d5b01$var$typedArrayTags[$fabe0cce3f5d5b01$var$funcTag] = $fabe0cce3f5d5b01$var$typedArrayTags[$fabe0cce3f5d5b01$var$mapTag] = $fabe0cce3f5d5b01$var$typedArrayTags[$fabe0cce3f5d5b01$var$numberTag] = $fabe0cce3f5d5b01$var$typedArrayTags[$fabe0cce3f5d5b01$var$objectTag] = $fabe0cce3f5d5b01$var$typedArrayTags[$fabe0cce3f5d5b01$var$regexpTag] = $fabe0cce3f5d5b01$var$typedArrayTags[$fabe0cce3f5d5b01$var$setTag] = $fabe0cce3f5d5b01$var$typedArrayTags[$fabe0cce3f5d5b01$var$stringTag] = $fabe0cce3f5d5b01$var$typedArrayTags[$fabe0cce3f5d5b01$var$weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function $fabe0cce3f5d5b01$var$baseIsTypedArray(value) {
    return (0, $BOPtQ.default)(value) && (0, $ealNX.default)(value.length) && !!$fabe0cce3f5d5b01$var$typedArrayTags[(0, $e8qHT.default)(value)];
}
var $fabe0cce3f5d5b01$export$2e2bcd8739ae039 = $fabe0cce3f5d5b01$var$baseIsTypedArray;

});

parcelRegister("iWSqN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dcb7ddab35a86b1b$export$2e2bcd8739ae039; });
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function $dcb7ddab35a86b1b$var$baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
var $dcb7ddab35a86b1b$export$2e2bcd8739ae039 = $dcb7ddab35a86b1b$var$baseUnary;

});

parcelRegister("85lyy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5e2f83048239daf1$export$2e2bcd8739ae039; });

var $iFBbo = parcelRequire("iFBbo");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && (0, $iFBbo.default).process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require("util").types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding("util");
    } catch (e) {}
}();
var $5e2f83048239daf1$export$2e2bcd8739ae039 = nodeUtil;

});


parcelRegister("1Abx0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1272191af27ff4d6$export$2e2bcd8739ae039; });
/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $1272191af27ff4d6$var$safeGet(object, key) {
    if (key === "constructor" && typeof object[key] === "function") return;
    if (key == "__proto__") return;
    return object[key];
}
var $1272191af27ff4d6$export$2e2bcd8739ae039 = $1272191af27ff4d6$var$safeGet;

});

parcelRegister("44J71", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2f7a877accc13af9$export$2e2bcd8739ae039; });

var $kNKwo = parcelRequire("kNKwo");

var $fUXoR = parcelRequire("fUXoR");
/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */ function $2f7a877accc13af9$var$toPlainObject(value) {
    return (0, $kNKwo.default)(value, (0, $fUXoR.default)(value));
}
var $2f7a877accc13af9$export$2e2bcd8739ae039 = $2f7a877accc13af9$var$toPlainObject;

});
parcelRegister("kNKwo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f24c78760842e746$export$2e2bcd8739ae039; });

var $3AJyv = parcelRequire("3AJyv");

var $dDl9K = parcelRequire("dDl9K");
/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */ function $f24c78760842e746$var$copyObject(source, props, object, customizer) {
    var isNew = !object;
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        if (newValue === undefined) newValue = source[key];
        if (isNew) (0, $dDl9K.default)(object, key, newValue);
        else (0, $3AJyv.default)(object, key, newValue);
    }
    return object;
}
var $f24c78760842e746$export$2e2bcd8739ae039 = $f24c78760842e746$var$copyObject;

});
parcelRegister("3AJyv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $29d812442ab2ad15$export$2e2bcd8739ae039; });

var $dDl9K = parcelRequire("dDl9K");

var $kuJus = parcelRequire("kuJus");
/** Used for built-in method references. */ var $29d812442ab2ad15$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $29d812442ab2ad15$var$hasOwnProperty = $29d812442ab2ad15$var$objectProto.hasOwnProperty;
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $29d812442ab2ad15$var$assignValue(object, key, value) {
    var objValue = object[key];
    if (!($29d812442ab2ad15$var$hasOwnProperty.call(object, key) && (0, $kuJus.default)(objValue, value)) || value === undefined && !(key in object)) (0, $dDl9K.default)(object, key, value);
}
var $29d812442ab2ad15$export$2e2bcd8739ae039 = $29d812442ab2ad15$var$assignValue;

});


parcelRegister("fUXoR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b96a2990172eaa9c$export$2e2bcd8739ae039; });

var $33Ztr = parcelRequire("33Ztr");

var $87FJl = parcelRequire("87FJl");

var $dHPlr = parcelRequire("dHPlr");
/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */ function $b96a2990172eaa9c$var$keysIn(object) {
    return (0, $dHPlr.default)(object) ? (0, $33Ztr.default)(object, true) : (0, $87FJl.default)(object);
}
var $b96a2990172eaa9c$export$2e2bcd8739ae039 = $b96a2990172eaa9c$var$keysIn;

});
parcelRegister("33Ztr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $23b1565ad7fdac35$export$2e2bcd8739ae039; });

var $fACgF = parcelRequire("fACgF");

var $lRAEc = parcelRequire("lRAEc");

var $o0x3M = parcelRequire("o0x3M");

var $igoKr = parcelRequire("igoKr");

var $FEUHH = parcelRequire("FEUHH");

var $9kZhJ = parcelRequire("9kZhJ");
/** Used for built-in method references. */ var $23b1565ad7fdac35$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $23b1565ad7fdac35$var$hasOwnProperty = $23b1565ad7fdac35$var$objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $23b1565ad7fdac35$var$arrayLikeKeys(value, inherited) {
    var isArr = (0, $o0x3M.default)(value), isArg = !isArr && (0, $lRAEc.default)(value), isBuff = !isArr && !isArg && (0, $igoKr.default)(value), isType = !isArr && !isArg && !isBuff && (0, $9kZhJ.default)(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? (0, $fACgF.default)(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || $23b1565ad7fdac35$var$hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
    (0, $FEUHH.default)(key, length)))) result.push(key);
    return result;
}
var $23b1565ad7fdac35$export$2e2bcd8739ae039 = $23b1565ad7fdac35$var$arrayLikeKeys;

});
parcelRegister("fACgF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b597e704417ae8ed$export$2e2bcd8739ae039; });
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $b597e704417ae8ed$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
var $b597e704417ae8ed$export$2e2bcd8739ae039 = $b597e704417ae8ed$var$baseTimes;

});

parcelRegister("FEUHH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $07d39108da3cbde2$export$2e2bcd8739ae039; });
/** Used as references for various `Number` constants. */ var $07d39108da3cbde2$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var $07d39108da3cbde2$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $07d39108da3cbde2$var$isIndex(value, length) {
    var type = typeof value;
    length = length == null ? $07d39108da3cbde2$var$MAX_SAFE_INTEGER : length;
    return !!length && (type == "number" || type != "symbol" && $07d39108da3cbde2$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
var $07d39108da3cbde2$export$2e2bcd8739ae039 = $07d39108da3cbde2$var$isIndex;

});


parcelRegister("87FJl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5e9f58ef4d9efe26$export$2e2bcd8739ae039; });

var $3dn92 = parcelRequire("3dn92");

var $Iv4Ln = parcelRequire("Iv4Ln");

var $gt7Xk = parcelRequire("gt7Xk");
/** Used for built-in method references. */ var $5e9f58ef4d9efe26$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $5e9f58ef4d9efe26$var$hasOwnProperty = $5e9f58ef4d9efe26$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $5e9f58ef4d9efe26$var$baseKeysIn(object) {
    if (!(0, $3dn92.default)(object)) return (0, $gt7Xk.default)(object);
    var isProto = (0, $Iv4Ln.default)(object), result = [];
    for(var key in object)if (!(key == "constructor" && (isProto || !$5e9f58ef4d9efe26$var$hasOwnProperty.call(object, key)))) result.push(key);
    return result;
}
var $5e9f58ef4d9efe26$export$2e2bcd8739ae039 = $5e9f58ef4d9efe26$var$baseKeysIn;

});
parcelRegister("gt7Xk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bfd586a8a9957928$export$2e2bcd8739ae039; });
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $bfd586a8a9957928$var$nativeKeysIn(object) {
    var result = [];
    if (object != null) for(var key in Object(object))result.push(key);
    return result;
}
var $bfd586a8a9957928$export$2e2bcd8739ae039 = $bfd586a8a9957928$var$nativeKeysIn;

});






parcelRegister("51t52", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3a839a7985f8c7d7$export$2e2bcd8739ae039; });

var $kTEXe = parcelRequire("kTEXe");

var $hVCck = parcelRequire("hVCck");
/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */ function $3a839a7985f8c7d7$var$createAssigner(assigner) {
    return (0, $kTEXe.default)(function(object, sources) {
        var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
        customizer = assigner.length > 3 && typeof customizer == "function" ? (length--, customizer) : undefined;
        if (guard && (0, $hVCck.default)(sources[0], sources[1], guard)) {
            customizer = length < 3 ? undefined : customizer;
            length = 1;
        }
        object = Object(object);
        while(++index < length){
            var source = sources[index];
            if (source) assigner(object, source, index, customizer);
        }
        return object;
    });
}
var $3a839a7985f8c7d7$export$2e2bcd8739ae039 = $3a839a7985f8c7d7$var$createAssigner;

});
parcelRegister("kTEXe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f368b662e65c065d$export$2e2bcd8739ae039; });

var $2719y = parcelRequire("2719y");

var $5dD5X = parcelRequire("5dD5X");

var $2fhdh = parcelRequire("2fhdh");
/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */ function $f368b662e65c065d$var$baseRest(func, start) {
    return (0, $2fhdh.default)((0, $5dD5X.default)(func, start, (0, $2719y.default)), func + "");
}
var $f368b662e65c065d$export$2e2bcd8739ae039 = $f368b662e65c065d$var$baseRest;

});
parcelRegister("2719y", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $189d21307abb93f3$export$2e2bcd8739ae039; });
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function $189d21307abb93f3$var$identity(value) {
    return value;
}
var $189d21307abb93f3$export$2e2bcd8739ae039 = $189d21307abb93f3$var$identity;

});

parcelRegister("5dD5X", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3ccc7e18edddfab7$export$2e2bcd8739ae039; });

var $7lOr2 = parcelRequire("7lOr2");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $3ccc7e18edddfab7$var$nativeMax = Math.max;
/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */ function $3ccc7e18edddfab7$var$overRest(func, start, transform) {
    start = $3ccc7e18edddfab7$var$nativeMax(start === undefined ? func.length - 1 : start, 0);
    return function() {
        var args = arguments, index = -1, length = $3ccc7e18edddfab7$var$nativeMax(args.length - start, 0), array = Array(length);
        while(++index < length)array[index] = args[start + index];
        index = -1;
        var otherArgs = Array(start + 1);
        while(++index < start)otherArgs[index] = args[index];
        otherArgs[start] = transform(array);
        return (0, $7lOr2.default)(func, this, otherArgs);
    };
}
var $3ccc7e18edddfab7$export$2e2bcd8739ae039 = $3ccc7e18edddfab7$var$overRest;

});
parcelRegister("7lOr2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $55a19dee0554f46f$export$2e2bcd8739ae039; });
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */ function $55a19dee0554f46f$var$apply(func, thisArg, args) {
    switch(args.length){
        case 0:
            return func.call(thisArg);
        case 1:
            return func.call(thisArg, args[0]);
        case 2:
            return func.call(thisArg, args[0], args[1]);
        case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
}
var $55a19dee0554f46f$export$2e2bcd8739ae039 = $55a19dee0554f46f$var$apply;

});


parcelRegister("2fhdh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1a2a55af2d995f7f$export$2e2bcd8739ae039; });

var $74teE = parcelRequire("74teE");

var $eipmF = parcelRequire("eipmF");
/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $1a2a55af2d995f7f$var$setToString = (0, $eipmF.default)((0, $74teE.default));
var $1a2a55af2d995f7f$export$2e2bcd8739ae039 = $1a2a55af2d995f7f$var$setToString;

});
parcelRegister("74teE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $525f95a0c78b3d5d$export$2e2bcd8739ae039; });

var $1ERf0 = parcelRequire("1ERf0");

var $1goHH = parcelRequire("1goHH");

var $2719y = parcelRequire("2719y");
/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $525f95a0c78b3d5d$var$baseSetToString = !(0, $1goHH.default) ? (0, $2719y.default) : function(func, string) {
    return (0, $1goHH.default)(func, "toString", {
        "configurable": true,
        "enumerable": false,
        "value": (0, $1ERf0.default)(string),
        "writable": true
    });
};
var $525f95a0c78b3d5d$export$2e2bcd8739ae039 = $525f95a0c78b3d5d$var$baseSetToString;

});
parcelRegister("1ERf0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1352d369f3eedffd$export$2e2bcd8739ae039; });
/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */ function $1352d369f3eedffd$var$constant(value) {
    return function() {
        return value;
    };
}
var $1352d369f3eedffd$export$2e2bcd8739ae039 = $1352d369f3eedffd$var$constant;

});


parcelRegister("eipmF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a6866c0708382a66$export$2e2bcd8739ae039; });
/** Used to detect hot functions by number of calls within a span of milliseconds. */ var $a6866c0708382a66$var$HOT_COUNT = 800, $a6866c0708382a66$var$HOT_SPAN = 16;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $a6866c0708382a66$var$nativeNow = Date.now;
/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */ function $a6866c0708382a66$var$shortOut(func) {
    var count = 0, lastCalled = 0;
    return function() {
        var stamp = $a6866c0708382a66$var$nativeNow(), remaining = $a6866c0708382a66$var$HOT_SPAN - (stamp - lastCalled);
        lastCalled = stamp;
        if (remaining > 0) {
            if (++count >= $a6866c0708382a66$var$HOT_COUNT) return arguments[0];
        } else count = 0;
        return func.apply(undefined, arguments);
    };
}
var $a6866c0708382a66$export$2e2bcd8739ae039 = $a6866c0708382a66$var$shortOut;

});



parcelRegister("hVCck", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d0d563dc551cd5da$export$2e2bcd8739ae039; });

var $kuJus = parcelRequire("kuJus");

var $dHPlr = parcelRequire("dHPlr");

var $FEUHH = parcelRequire("FEUHH");

var $3dn92 = parcelRequire("3dn92");
/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */ function $d0d563dc551cd5da$var$isIterateeCall(value, index, object) {
    if (!(0, $3dn92.default)(object)) return false;
    var type = typeof index;
    if (type == "number" ? (0, $dHPlr.default)(object) && (0, $FEUHH.default)(index, object.length) : type == "string" && index in object) return (0, $kuJus.default)(object[index], value);
    return false;
}
var $d0d563dc551cd5da$export$2e2bcd8739ae039 = $d0d563dc551cd5da$var$isIterateeCall;

});




parcelRegister("ejwzz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a6bc1b50f0230709$export$2e2bcd8739ae039; });

var $eeH7J = parcelRequire("eeH7J");

var $bJBxw = parcelRequire("bJBxw");

var $iAcjl = parcelRequire("iAcjl");

var $3m6Bx = parcelRequire("3m6Bx");
var $a6bc1b50f0230709$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function $a6bc1b50f0230709$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $a6bc1b50f0230709$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $a6bc1b50f0230709$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $a6bc1b50f0230709$export$c4dbe12ffaee3c8e = function(_ref) {
    $a6bc1b50f0230709$var$_inherits(Saturation, _ref);
    function Saturation(props) {
        $a6bc1b50f0230709$var$_classCallCheck(this, Saturation);
        var _this = $a6bc1b50f0230709$var$_possibleConstructorReturn(this, (Saturation.__proto__ || Object.getPrototypeOf(Saturation)).call(this, props));
        _this.handleChange = function(e) {
            typeof _this.props.onChange === "function" && _this.throttle(_this.props.onChange, $3m6Bx.calculateChange(e, _this.props.hsl, _this.container), e);
        };
        _this.handleMouseDown = function(e) {
            _this.handleChange(e);
            var renderWindow = _this.getContainerRenderWindow();
            renderWindow.addEventListener("mousemove", _this.handleChange);
            renderWindow.addEventListener("mouseup", _this.handleMouseUp);
        };
        _this.handleMouseUp = function() {
            _this.unbindEventListeners();
        };
        _this.throttle = (0, $iAcjl.default)(function(fn, data, e) {
            fn(data, e);
        }, 50);
        return _this;
    }
    $a6bc1b50f0230709$var$_createClass(Saturation, [
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.throttle.cancel();
                this.unbindEventListeners();
            }
        },
        {
            key: "getContainerRenderWindow",
            value: function getContainerRenderWindow() {
                var container = this.container;
                var renderWindow = window;
                while(!renderWindow.document.contains(container) && renderWindow.parent !== renderWindow)renderWindow = renderWindow.parent;
                return renderWindow;
            }
        },
        {
            key: "unbindEventListeners",
            value: function unbindEventListeners() {
                var renderWindow = this.getContainerRenderWindow();
                renderWindow.removeEventListener("mousemove", this.handleChange);
                renderWindow.removeEventListener("mouseup", this.handleMouseUp);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var _ref2 = this.props.style || {}, color = _ref2.color, white = _ref2.white, black = _ref2.black, pointer = _ref2.pointer, circle = _ref2.circle;
                var styles = (0, (/*@__PURE__*/$parcel$interopDefault($bJBxw)))({
                    "default": {
                        color: {
                            absolute: "0px 0px 0px 0px",
                            background: "hsl(" + this.props.hsl.h + ",100%, 50%)",
                            borderRadius: this.props.radius
                        },
                        white: {
                            absolute: "0px 0px 0px 0px",
                            borderRadius: this.props.radius
                        },
                        black: {
                            absolute: "0px 0px 0px 0px",
                            boxShadow: this.props.shadow,
                            borderRadius: this.props.radius
                        },
                        pointer: {
                            position: "absolute",
                            top: -(this.props.hsv.v * 100) + 100 + "%",
                            left: this.props.hsv.s * 100 + "%",
                            cursor: "default"
                        },
                        circle: {
                            width: "4px",
                            height: "4px",
                            boxShadow: "0 0 0 1.5px #fff, inset 0 0 1px 1px rgba(0,0,0,.3),\n            0 0 1px 2px rgba(0,0,0,.4)",
                            borderRadius: "50%",
                            cursor: "hand",
                            transform: "translate(-2px, -2px)"
                        }
                    },
                    "custom": {
                        color: color,
                        white: white,
                        black: black,
                        pointer: pointer,
                        circle: circle
                    }
                }, {
                    "custom": !!this.props.style
                });
                return (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
                    style: styles.color,
                    ref: function ref(container) {
                        return _this2.container = container;
                    },
                    onMouseDown: this.handleMouseDown,
                    onTouchMove: this.handleChange,
                    onTouchStart: this.handleChange
                }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("style", null, "\n          .saturation-white {\n            background: -webkit-linear-gradient(to right, #fff, rgba(255,255,255,0));\n            background: linear-gradient(to right, #fff, rgba(255,255,255,0));\n          }\n          .saturation-black {\n            background: -webkit-linear-gradient(to top, #000, rgba(0,0,0,0));\n            background: linear-gradient(to top, #000, rgba(0,0,0,0));\n          }\n        "), (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
                    style: styles.white,
                    className: "saturation-white"
                }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
                    style: styles.black,
                    className: "saturation-black"
                }), (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
                    style: styles.pointer
                }, this.props.pointer ? (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement(this.props.pointer, this.props) : (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
                    style: styles.circle
                }))));
            }
        }
    ]);
    return Saturation;
}((0, $eeH7J.PureComponent) || (0, $eeH7J.Component));
var $a6bc1b50f0230709$export$2e2bcd8739ae039 = $a6bc1b50f0230709$export$c4dbe12ffaee3c8e;

});
parcelRegister("iAcjl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d8752382aa1e49e3$export$2e2bcd8739ae039; });

var $eFrun = parcelRequire("eFrun");

var $3dn92 = parcelRequire("3dn92");
/** Error message constants. */ var $d8752382aa1e49e3$var$FUNC_ERROR_TEXT = "Expected a function";
/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */ function $d8752382aa1e49e3$var$throttle(func, wait, options) {
    var leading = true, trailing = true;
    if (typeof func != "function") throw new TypeError($d8752382aa1e49e3$var$FUNC_ERROR_TEXT);
    if ((0, $3dn92.default)(options)) {
        leading = "leading" in options ? !!options.leading : leading;
        trailing = "trailing" in options ? !!options.trailing : trailing;
    }
    return (0, $eFrun.default)(func, wait, {
        "leading": leading,
        "maxWait": wait,
        "trailing": trailing
    });
}
var $d8752382aa1e49e3$export$2e2bcd8739ae039 = $d8752382aa1e49e3$var$throttle;

});
parcelRegister("eFrun", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $aada37bdadcad455$export$2e2bcd8739ae039; });

var $3dn92 = parcelRequire("3dn92");

var $ddY1B = parcelRequire("ddY1B");

var $gFSQa = parcelRequire("gFSQa");
/** Error message constants. */ var $aada37bdadcad455$var$FUNC_ERROR_TEXT = "Expected a function";
/* Built-in method references for those with the same name as other `lodash` methods. */ var $aada37bdadcad455$var$nativeMax = Math.max, $aada37bdadcad455$var$nativeMin = Math.min;
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $aada37bdadcad455$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != "function") throw new TypeError($aada37bdadcad455$var$FUNC_ERROR_TEXT);
    wait = (0, $gFSQa.default)(wait) || 0;
    if ((0, $3dn92.default)(options)) {
        leading = !!options.leading;
        maxing = "maxWait" in options;
        maxWait = maxing ? $aada37bdadcad455$var$nativeMax((0, $gFSQa.default)(options.maxWait) || 0, wait) : maxWait;
        trailing = "trailing" in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
        return maxing ? $aada37bdadcad455$var$nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = (0, $ddY1B.default)();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge((0, $ddY1B.default)());
    }
    function debounced() {
        var time = (0, $ddY1B.default)(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                clearTimeout(timerId);
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
var $aada37bdadcad455$export$2e2bcd8739ae039 = $aada37bdadcad455$var$debounce;

});
parcelRegister("ddY1B", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9a0b0cf4e533013c$export$2e2bcd8739ae039; });

var $ier4x = parcelRequire("ier4x");
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $9a0b0cf4e533013c$var$now = function() {
    return (0, $ier4x.default).Date.now();
};
var $9a0b0cf4e533013c$export$2e2bcd8739ae039 = $9a0b0cf4e533013c$var$now;

});

parcelRegister("gFSQa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c23b03dc8b8f2d2e$export$2e2bcd8739ae039; });

var $1778I = parcelRequire("1778I");

var $3dn92 = parcelRequire("3dn92");

var $9XbCp = parcelRequire("9XbCp");
/** Used as references for various `Number` constants. */ var $c23b03dc8b8f2d2e$var$NAN = 0 / 0;
/** Used to detect bad signed hexadecimal string values. */ var $c23b03dc8b8f2d2e$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $c23b03dc8b8f2d2e$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $c23b03dc8b8f2d2e$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $c23b03dc8b8f2d2e$var$freeParseInt = parseInt;
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $c23b03dc8b8f2d2e$var$toNumber(value) {
    if (typeof value == "number") return value;
    if ((0, $9XbCp.default)(value)) return $c23b03dc8b8f2d2e$var$NAN;
    if ((0, $3dn92.default)(value)) {
        var other = typeof value.valueOf == "function" ? value.valueOf() : value;
        value = (0, $3dn92.default)(other) ? other + "" : other;
    }
    if (typeof value != "string") return value === 0 ? value : +value;
    value = (0, $1778I.default)(value);
    var isBinary = $c23b03dc8b8f2d2e$var$reIsBinary.test(value);
    return isBinary || $c23b03dc8b8f2d2e$var$reIsOctal.test(value) ? $c23b03dc8b8f2d2e$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $c23b03dc8b8f2d2e$var$reIsBadHex.test(value) ? $c23b03dc8b8f2d2e$var$NAN : +value;
}
var $c23b03dc8b8f2d2e$export$2e2bcd8739ae039 = $c23b03dc8b8f2d2e$var$toNumber;

});
parcelRegister("1778I", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0cfbfbab64539034$export$2e2bcd8739ae039; });

var $3XXV6 = parcelRequire("3XXV6");
/** Used to match leading whitespace. */ var $0cfbfbab64539034$var$reTrimStart = /^\s+/;
/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */ function $0cfbfbab64539034$var$baseTrim(string) {
    return string ? string.slice(0, (0, $3XXV6.default)(string) + 1).replace($0cfbfbab64539034$var$reTrimStart, "") : string;
}
var $0cfbfbab64539034$export$2e2bcd8739ae039 = $0cfbfbab64539034$var$baseTrim;

});
parcelRegister("3XXV6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2e355ca75638a323$export$2e2bcd8739ae039; });
/** Used to match a single whitespace character. */ var $2e355ca75638a323$var$reWhitespace = /\s/;
/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */ function $2e355ca75638a323$var$trimmedEndIndex(string) {
    var index = string.length;
    while(index-- && $2e355ca75638a323$var$reWhitespace.test(string.charAt(index)));
    return index;
}
var $2e355ca75638a323$export$2e2bcd8739ae039 = $2e355ca75638a323$var$trimmedEndIndex;

});


parcelRegister("9XbCp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $73f2a2efa770cd29$export$2e2bcd8739ae039; });

var $e8qHT = parcelRequire("e8qHT");

var $BOPtQ = parcelRequire("BOPtQ");
/** `Object#toString` result references. */ var $73f2a2efa770cd29$var$symbolTag = "[object Symbol]";
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $73f2a2efa770cd29$var$isSymbol(value) {
    return typeof value == "symbol" || (0, $BOPtQ.default)(value) && (0, $e8qHT.default)(value) == $73f2a2efa770cd29$var$symbolTag;
}
var $73f2a2efa770cd29$export$2e2bcd8739ae039 = $73f2a2efa770cd29$var$isSymbol;

});




parcelRegister("3m6Bx", function(module, exports) {

$parcel$export(module.exports, "calculateChange", function () { return $27188cb07d1da1f0$export$a056a977bf6a9a3c; });
var $27188cb07d1da1f0$export$a056a977bf6a9a3c = function calculateChange(e, hsl, container) {
    var _container$getBoundin = container.getBoundingClientRect(), containerWidth = _container$getBoundin.width, containerHeight = _container$getBoundin.height;
    var x = typeof e.pageX === "number" ? e.pageX : e.touches[0].pageX;
    var y = typeof e.pageY === "number" ? e.pageY : e.touches[0].pageY;
    var left = x - (container.getBoundingClientRect().left + window.pageXOffset);
    var top = y - (container.getBoundingClientRect().top + window.pageYOffset);
    if (left < 0) left = 0;
    else if (left > containerWidth) left = containerWidth;
    if (top < 0) top = 0;
    else if (top > containerHeight) top = containerHeight;
    var saturation = left / containerWidth;
    var bright = 1 - top / containerHeight;
    return {
        h: hsl.h,
        s: saturation,
        v: bright,
        a: hsl.a,
        source: "hsv"
    };
};

});


parcelRegister("8bUgk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5f6afe5189f8d29a$export$2e2bcd8739ae039; });

var $eeH7J = parcelRequire("eeH7J");

var $eFrun = parcelRequire("eFrun");

var $7Zkko = parcelRequire("7Zkko");
var $5f6afe5189f8d29a$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $5f6afe5189f8d29a$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function $5f6afe5189f8d29a$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $5f6afe5189f8d29a$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $5f6afe5189f8d29a$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $5f6afe5189f8d29a$export$68265aef2e61bec7 = function ColorWrap(Picker) {
    var ColorPicker = function(_ref) {
        $5f6afe5189f8d29a$var$_inherits(ColorPicker, _ref);
        function ColorPicker(props) {
            $5f6afe5189f8d29a$var$_classCallCheck(this, ColorPicker);
            var _this = $5f6afe5189f8d29a$var$_possibleConstructorReturn(this, (ColorPicker.__proto__ || Object.getPrototypeOf(ColorPicker)).call(this));
            _this.handleChange = function(data, event) {
                var isValidColor = $7Zkko.simpleCheckForValidColor(data);
                if (isValidColor) {
                    var colors = $7Zkko.toState(data, data.h || _this.state.oldHue);
                    _this.setState(colors);
                    _this.props.onChangeComplete && _this.debounce(_this.props.onChangeComplete, colors, event);
                    _this.props.onChange && _this.props.onChange(colors, event);
                }
            };
            _this.handleSwatchHover = function(data, event) {
                var isValidColor = $7Zkko.simpleCheckForValidColor(data);
                if (isValidColor) {
                    var colors = $7Zkko.toState(data, data.h || _this.state.oldHue);
                    _this.props.onSwatchHover && _this.props.onSwatchHover(colors, event);
                }
            };
            _this.state = $5f6afe5189f8d29a$var$_extends({}, $7Zkko.toState(props.color, 0));
            _this.debounce = (0, $eFrun.default)(function(fn, data, event) {
                fn(data, event);
            }, 100);
            return _this;
        }
        $5f6afe5189f8d29a$var$_createClass(ColorPicker, [
            {
                key: "render",
                value: function render() {
                    var optionalEvents = {};
                    if (this.props.onSwatchHover) optionalEvents.onSwatchHover = this.handleSwatchHover;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement(Picker, $5f6afe5189f8d29a$var$_extends({}, this.props, this.state, {
                        onChange: this.handleChange
                    }, optionalEvents));
                }
            }
        ], [
            {
                key: "getDerivedStateFromProps",
                value: function getDerivedStateFromProps(nextProps, state) {
                    return $5f6afe5189f8d29a$var$_extends({}, $7Zkko.toState(nextProps.color, state.oldHue));
                }
            }
        ]);
        return ColorPicker;
    }((0, $eeH7J.PureComponent) || (0, $eeH7J.Component));
    ColorPicker.propTypes = $5f6afe5189f8d29a$var$_extends({}, Picker.propTypes);
    ColorPicker.defaultProps = $5f6afe5189f8d29a$var$_extends({}, Picker.defaultProps, {
        color: {
            h: 250,
            s: 0.50,
            l: 0.20,
            a: 1
        }
    });
    return ColorPicker;
};
var $5f6afe5189f8d29a$export$2e2bcd8739ae039 = $5f6afe5189f8d29a$export$68265aef2e61bec7;

});
parcelRegister("7Zkko", function(module, exports) {

$parcel$export(module.exports, "simpleCheckForValidColor", function () { return $5d0dff9fa57aef75$export$4837207a530c7f21; });
$parcel$export(module.exports, "toState", function () { return $5d0dff9fa57aef75$export$6bed283375899438; });
$parcel$export(module.exports, "isValidHex", function () { return $5d0dff9fa57aef75$export$944f75ec5697b362; });
$parcel$export(module.exports, "getContrastingColor", function () { return $5d0dff9fa57aef75$export$3609eb1d7e55dec; });
$parcel$export(module.exports, "isvalidColorString", function () { return $5d0dff9fa57aef75$export$e76ec4c5b3cadd73; });

var $iaQL9 = parcelRequire("iaQL9");

var $n2zFR = parcelRequire("n2zFR");
var $5d0dff9fa57aef75$export$4837207a530c7f21 = function simpleCheckForValidColor(data) {
    var keysToCheck = [
        "r",
        "g",
        "b",
        "a",
        "h",
        "s",
        "l",
        "v"
    ];
    var checked = 0;
    var passed = 0;
    (0, $iaQL9.default)(keysToCheck, function(letter) {
        if (data[letter]) {
            checked += 1;
            if (!isNaN(data[letter])) passed += 1;
            if (letter === "s" || letter === "l") {
                var percentPatt = /^\d+%$/;
                if (percentPatt.test(data[letter])) passed += 1;
            }
        }
    });
    return checked === passed ? data : false;
};
var $5d0dff9fa57aef75$export$6bed283375899438 = function toState(data, oldHue) {
    var color = data.hex ? (0, (/*@__PURE__*/$parcel$interopDefault($n2zFR)))(data.hex) : (0, (/*@__PURE__*/$parcel$interopDefault($n2zFR)))(data);
    var hsl = color.toHsl();
    var hsv = color.toHsv();
    var rgb = color.toRgb();
    var hex = color.toHex();
    if (hsl.s === 0) {
        hsl.h = oldHue || 0;
        hsv.h = oldHue || 0;
    }
    var transparent = hex === "000000" && rgb.a === 0;
    return {
        hsl: hsl,
        hex: transparent ? "transparent" : "#" + hex,
        rgb: rgb,
        hsv: hsv,
        oldHue: data.h || oldHue || hsl.h,
        source: data.source
    };
};
var $5d0dff9fa57aef75$export$944f75ec5697b362 = function isValidHex(hex) {
    if (hex === "transparent") return true;
    // disable hex4 and hex8
    var lh = String(hex).charAt(0) === "#" ? 1 : 0;
    return hex.length !== 4 + lh && hex.length < 7 + lh && (0, (/*@__PURE__*/$parcel$interopDefault($n2zFR)))(hex).isValid();
};
var $5d0dff9fa57aef75$export$3609eb1d7e55dec = function getContrastingColor(data) {
    if (!data) return "#fff";
    var col = $5d0dff9fa57aef75$export$6bed283375899438(data);
    if (col.hex === "transparent") return "rgba(0,0,0,0.4)";
    var yiq = (col.rgb.r * 299 + col.rgb.g * 587 + col.rgb.b * 114) / 1000;
    return yiq >= 128 ? "#000" : "#fff";
};
var $5d0dff9fa57aef75$export$a90204d1394caf30 = {
    hsl: {
        a: 1,
        h: 0,
        l: 0.5,
        s: 1
    },
    hex: "#ff0000",
    rgb: {
        r: 255,
        g: 0,
        b: 0,
        a: 1
    },
    hsv: {
        h: 0,
        s: 1,
        v: 1,
        a: 1
    }
};
var $5d0dff9fa57aef75$export$e76ec4c5b3cadd73 = function isvalidColorString(string, type) {
    var stringWithoutDegree = string.replace("\xb0", "");
    return (0, (/*@__PURE__*/$parcel$interopDefault($n2zFR)))(type + " (" + stringWithoutDegree + ")")._ok;
};

});
parcelRegister("iaQL9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d3b2161cb880b56e$export$2e2bcd8739ae039; });

var $g87ty = parcelRequire("g87ty");

var $PDHVi = parcelRequire("PDHVi");

var $kDS5b = parcelRequire("kDS5b");

var $o0x3M = parcelRequire("o0x3M");
/**
 * Iterates over elements of `collection` and invokes `iteratee` for each element.
 * The iteratee is invoked with three arguments: (value, index|key, collection).
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * **Note:** As with other "Collections" methods, objects with a "length"
 * property are iterated like arrays. To avoid this behavior use `_.forIn`
 * or `_.forOwn` for object iteration.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias each
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 * @see _.forEachRight
 * @example
 *
 * _.forEach([1, 2], function(value) {
 *   console.log(value);
 * });
 * // => Logs `1` then `2`.
 *
 * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
 */ function $d3b2161cb880b56e$var$forEach(collection, iteratee) {
    var func = (0, $o0x3M.default)(collection) ? (0, $g87ty.default) : (0, $PDHVi.default);
    return func(collection, (0, $kDS5b.default)(iteratee));
}
var $d3b2161cb880b56e$export$2e2bcd8739ae039 = $d3b2161cb880b56e$var$forEach;

});
parcelRegister("g87ty", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bbe33133fd3ce979$export$2e2bcd8739ae039; });
/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */ function $bbe33133fd3ce979$var$arrayEach(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (iteratee(array[index], index, array) === false) break;
    }
    return array;
}
var $bbe33133fd3ce979$export$2e2bcd8739ae039 = $bbe33133fd3ce979$var$arrayEach;

});

parcelRegister("PDHVi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $09b3909ad9877cfc$export$2e2bcd8739ae039; });

var $boVT0 = parcelRequire("boVT0");

var $B958J = parcelRequire("B958J");
/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */ var $09b3909ad9877cfc$var$baseEach = (0, $B958J.default)((0, $boVT0.default));
var $09b3909ad9877cfc$export$2e2bcd8739ae039 = $09b3909ad9877cfc$var$baseEach;

});
parcelRegister("boVT0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $84ced69bcc11b73b$export$2e2bcd8739ae039; });

var $bpjCU = parcelRequire("bpjCU");

var $4WqMj = parcelRequire("4WqMj");
/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */ function $84ced69bcc11b73b$var$baseForOwn(object, iteratee) {
    return object && (0, $bpjCU.default)(object, iteratee, (0, $4WqMj.default));
}
var $84ced69bcc11b73b$export$2e2bcd8739ae039 = $84ced69bcc11b73b$var$baseForOwn;

});
parcelRegister("4WqMj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $399159d0b86c4de3$export$2e2bcd8739ae039; });

var $33Ztr = parcelRequire("33Ztr");

var $jkS7g = parcelRequire("jkS7g");

var $dHPlr = parcelRequire("dHPlr");
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function $399159d0b86c4de3$var$keys(object) {
    return (0, $dHPlr.default)(object) ? (0, $33Ztr.default)(object) : (0, $jkS7g.default)(object);
}
var $399159d0b86c4de3$export$2e2bcd8739ae039 = $399159d0b86c4de3$var$keys;

});
parcelRegister("jkS7g", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e139dce7c96b603b$export$2e2bcd8739ae039; });

var $Iv4Ln = parcelRequire("Iv4Ln");

var $kE1ZN = parcelRequire("kE1ZN");
/** Used for built-in method references. */ var $e139dce7c96b603b$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $e139dce7c96b603b$var$hasOwnProperty = $e139dce7c96b603b$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $e139dce7c96b603b$var$baseKeys(object) {
    if (!(0, $Iv4Ln.default)(object)) return (0, $kE1ZN.default)(object);
    var result = [];
    for(var key in Object(object))if ($e139dce7c96b603b$var$hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
    return result;
}
var $e139dce7c96b603b$export$2e2bcd8739ae039 = $e139dce7c96b603b$var$baseKeys;

});
parcelRegister("kE1ZN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f079176491e590a5$export$2e2bcd8739ae039; });

var $69m2l = parcelRequire("69m2l");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $f079176491e590a5$var$nativeKeys = (0, $69m2l.default)(Object.keys, Object);
var $f079176491e590a5$export$2e2bcd8739ae039 = $f079176491e590a5$var$nativeKeys;

});




parcelRegister("B958J", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $06fa804ad653500a$export$2e2bcd8739ae039; });

var $dHPlr = parcelRequire("dHPlr");
/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $06fa804ad653500a$var$createBaseEach(eachFunc, fromRight) {
    return function(collection, iteratee) {
        if (collection == null) return collection;
        if (!(0, $dHPlr.default)(collection)) return eachFunc(collection, iteratee);
        var length = collection.length, index = fromRight ? length : -1, iterable = Object(collection);
        while(fromRight ? index-- : ++index < length){
            if (iteratee(iterable[index], index, iterable) === false) break;
        }
        return collection;
    };
}
var $06fa804ad653500a$export$2e2bcd8739ae039 = $06fa804ad653500a$var$createBaseEach;

});


parcelRegister("kDS5b", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f07166d29730fb14$export$2e2bcd8739ae039; });

var $2719y = parcelRequire("2719y");
/**
 * Casts `value` to `identity` if it's not a function.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Function} Returns cast function.
 */ function $f07166d29730fb14$var$castFunction(value) {
    return typeof value == "function" ? value : (0, $2719y.default);
}
var $f07166d29730fb14$export$2e2bcd8739ae039 = $f07166d29730fb14$var$castFunction;

});


parcelRegister("n2zFR", function(module, exports) {
// TinyColor v1.4.2
// https://github.com/bgrins/TinyColor
// Brian Grinstead, MIT License
(function(Math1) {
    var trimLeft = /^\s+/, trimRight = /\s+$/, tinyCounter = 0, mathRound = Math1.round, mathMin = Math1.min, mathMax = Math1.max, mathRandom = Math1.random;
    function tinycolor(color, opts) {
        color = color ? color : "";
        opts = opts || {};
        // If input is already a tinycolor, return itself
        if (color instanceof tinycolor) return color;
        // If we are called as a function, call using new instead
        if (!(this instanceof tinycolor)) return new tinycolor(color, opts);
        var rgb = inputToRGB(color);
        this._originalInput = color, this._r = rgb.r, this._g = rgb.g, this._b = rgb.b, this._a = rgb.a, this._roundA = mathRound(100 * this._a) / 100, this._format = opts.format || rgb.format;
        this._gradientType = opts.gradientType;
        // Don't let the range of [0,255] come back in [0,1].
        // Potentially lose a little bit of precision here, but will fix issues where
        // .5 gets interpreted as half of the total, instead of half of 1
        // If it was supposed to be 128, this was already taken care of by `inputToRgb`
        if (this._r < 1) this._r = mathRound(this._r);
        if (this._g < 1) this._g = mathRound(this._g);
        if (this._b < 1) this._b = mathRound(this._b);
        this._ok = rgb.ok;
        this._tc_id = tinyCounter++;
    }
    tinycolor.prototype = {
        isDark: function() {
            return this.getBrightness() < 128;
        },
        isLight: function() {
            return !this.isDark();
        },
        isValid: function() {
            return this._ok;
        },
        getOriginalInput: function() {
            return this._originalInput;
        },
        getFormat: function() {
            return this._format;
        },
        getAlpha: function() {
            return this._a;
        },
        getBrightness: function() {
            //http://www.w3.org/TR/AERT#color-contrast
            var rgb = this.toRgb();
            return (rgb.r * 299 + rgb.g * 587 + rgb.b * 114) / 1000;
        },
        getLuminance: function() {
            //http://www.w3.org/TR/2008/REC-WCAG20-20081211/#relativeluminancedef
            var rgb = this.toRgb();
            var RsRGB, GsRGB, BsRGB, R, G, B;
            RsRGB = rgb.r / 255;
            GsRGB = rgb.g / 255;
            BsRGB = rgb.b / 255;
            if (RsRGB <= 0.03928) R = RsRGB / 12.92;
            else R = Math1.pow((RsRGB + 0.055) / 1.055, 2.4);
            if (GsRGB <= 0.03928) G = GsRGB / 12.92;
            else G = Math1.pow((GsRGB + 0.055) / 1.055, 2.4);
            if (BsRGB <= 0.03928) B = BsRGB / 12.92;
            else B = Math1.pow((BsRGB + 0.055) / 1.055, 2.4);
            return 0.2126 * R + 0.7152 * G + 0.0722 * B;
        },
        setAlpha: function(value) {
            this._a = boundAlpha(value);
            this._roundA = mathRound(100 * this._a) / 100;
            return this;
        },
        toHsv: function() {
            var hsv = rgbToHsv(this._r, this._g, this._b);
            return {
                h: hsv.h * 360,
                s: hsv.s,
                v: hsv.v,
                a: this._a
            };
        },
        toHsvString: function() {
            var hsv = rgbToHsv(this._r, this._g, this._b);
            var h = mathRound(hsv.h * 360), s = mathRound(hsv.s * 100), v = mathRound(hsv.v * 100);
            return this._a == 1 ? "hsv(" + h + ", " + s + "%, " + v + "%)" : "hsva(" + h + ", " + s + "%, " + v + "%, " + this._roundA + ")";
        },
        toHsl: function() {
            var hsl = rgbToHsl(this._r, this._g, this._b);
            return {
                h: hsl.h * 360,
                s: hsl.s,
                l: hsl.l,
                a: this._a
            };
        },
        toHslString: function() {
            var hsl = rgbToHsl(this._r, this._g, this._b);
            var h = mathRound(hsl.h * 360), s = mathRound(hsl.s * 100), l = mathRound(hsl.l * 100);
            return this._a == 1 ? "hsl(" + h + ", " + s + "%, " + l + "%)" : "hsla(" + h + ", " + s + "%, " + l + "%, " + this._roundA + ")";
        },
        toHex: function(allow3Char) {
            return rgbToHex(this._r, this._g, this._b, allow3Char);
        },
        toHexString: function(allow3Char) {
            return "#" + this.toHex(allow3Char);
        },
        toHex8: function(allow4Char) {
            return rgbaToHex(this._r, this._g, this._b, this._a, allow4Char);
        },
        toHex8String: function(allow4Char) {
            return "#" + this.toHex8(allow4Char);
        },
        toRgb: function() {
            return {
                r: mathRound(this._r),
                g: mathRound(this._g),
                b: mathRound(this._b),
                a: this._a
            };
        },
        toRgbString: function() {
            return this._a == 1 ? "rgb(" + mathRound(this._r) + ", " + mathRound(this._g) + ", " + mathRound(this._b) + ")" : "rgba(" + mathRound(this._r) + ", " + mathRound(this._g) + ", " + mathRound(this._b) + ", " + this._roundA + ")";
        },
        toPercentageRgb: function() {
            return {
                r: mathRound(bound01(this._r, 255) * 100) + "%",
                g: mathRound(bound01(this._g, 255) * 100) + "%",
                b: mathRound(bound01(this._b, 255) * 100) + "%",
                a: this._a
            };
        },
        toPercentageRgbString: function() {
            return this._a == 1 ? "rgb(" + mathRound(bound01(this._r, 255) * 100) + "%, " + mathRound(bound01(this._g, 255) * 100) + "%, " + mathRound(bound01(this._b, 255) * 100) + "%)" : "rgba(" + mathRound(bound01(this._r, 255) * 100) + "%, " + mathRound(bound01(this._g, 255) * 100) + "%, " + mathRound(bound01(this._b, 255) * 100) + "%, " + this._roundA + ")";
        },
        toName: function() {
            if (this._a === 0) return "transparent";
            if (this._a < 1) return false;
            return hexNames[rgbToHex(this._r, this._g, this._b, true)] || false;
        },
        toFilter: function(secondColor) {
            var hex8String = "#" + rgbaToArgbHex(this._r, this._g, this._b, this._a);
            var secondHex8String = hex8String;
            var gradientType = this._gradientType ? "GradientType = 1, " : "";
            if (secondColor) {
                var s = tinycolor(secondColor);
                secondHex8String = "#" + rgbaToArgbHex(s._r, s._g, s._b, s._a);
            }
            return "progid:DXImageTransform.Microsoft.gradient(" + gradientType + "startColorstr=" + hex8String + ",endColorstr=" + secondHex8String + ")";
        },
        toString: function(format) {
            var formatSet = !!format;
            format = format || this._format;
            var formattedString = false;
            var hasAlpha = this._a < 1 && this._a >= 0;
            var needsAlphaFormat = !formatSet && hasAlpha && (format === "hex" || format === "hex6" || format === "hex3" || format === "hex4" || format === "hex8" || format === "name");
            if (needsAlphaFormat) {
                // Special case for "transparent", all other non-alpha formats
                // will return rgba when there is transparency.
                if (format === "name" && this._a === 0) return this.toName();
                return this.toRgbString();
            }
            if (format === "rgb") formattedString = this.toRgbString();
            if (format === "prgb") formattedString = this.toPercentageRgbString();
            if (format === "hex" || format === "hex6") formattedString = this.toHexString();
            if (format === "hex3") formattedString = this.toHexString(true);
            if (format === "hex4") formattedString = this.toHex8String(true);
            if (format === "hex8") formattedString = this.toHex8String();
            if (format === "name") formattedString = this.toName();
            if (format === "hsl") formattedString = this.toHslString();
            if (format === "hsv") formattedString = this.toHsvString();
            return formattedString || this.toHexString();
        },
        clone: function() {
            return tinycolor(this.toString());
        },
        _applyModification: function(fn, args) {
            var color = fn.apply(null, [
                this
            ].concat([].slice.call(args)));
            this._r = color._r;
            this._g = color._g;
            this._b = color._b;
            this.setAlpha(color._a);
            return this;
        },
        lighten: function() {
            return this._applyModification(lighten, arguments);
        },
        brighten: function() {
            return this._applyModification(brighten, arguments);
        },
        darken: function() {
            return this._applyModification(darken, arguments);
        },
        desaturate: function() {
            return this._applyModification(desaturate, arguments);
        },
        saturate: function() {
            return this._applyModification(saturate, arguments);
        },
        greyscale: function() {
            return this._applyModification(greyscale, arguments);
        },
        spin: function() {
            return this._applyModification(spin, arguments);
        },
        _applyCombination: function(fn, args) {
            return fn.apply(null, [
                this
            ].concat([].slice.call(args)));
        },
        analogous: function() {
            return this._applyCombination(analogous, arguments);
        },
        complement: function() {
            return this._applyCombination(complement, arguments);
        },
        monochromatic: function() {
            return this._applyCombination(monochromatic, arguments);
        },
        splitcomplement: function() {
            return this._applyCombination(splitcomplement, arguments);
        },
        triad: function() {
            return this._applyCombination(triad, arguments);
        },
        tetrad: function() {
            return this._applyCombination(tetrad, arguments);
        }
    };
    // If input is an object, force 1 into "1.0" to handle ratios properly
    // String input requires "1.0" as input, so 1 will be treated as 1
    tinycolor.fromRatio = function(color, opts) {
        if (typeof color == "object") {
            var newColor = {};
            for(var i in color)if (color.hasOwnProperty(i)) {
                if (i === "a") newColor[i] = color[i];
                else newColor[i] = convertToPercentage(color[i]);
            }
            color = newColor;
        }
        return tinycolor(color, opts);
    };
    // Given a string or object, convert that input to RGB
    // Possible string inputs:
    //
    //     "red"
    //     "#f00" or "f00"
    //     "#ff0000" or "ff0000"
    //     "#ff000000" or "ff000000"
    //     "rgb 255 0 0" or "rgb (255, 0, 0)"
    //     "rgb 1.0 0 0" or "rgb (1, 0, 0)"
    //     "rgba (255, 0, 0, 1)" or "rgba 255, 0, 0, 1"
    //     "rgba (1.0, 0, 0, 1)" or "rgba 1.0, 0, 0, 1"
    //     "hsl(0, 100%, 50%)" or "hsl 0 100% 50%"
    //     "hsla(0, 100%, 50%, 1)" or "hsla 0 100% 50%, 1"
    //     "hsv(0, 100%, 100%)" or "hsv 0 100% 100%"
    //
    function inputToRGB(color) {
        var rgb = {
            r: 0,
            g: 0,
            b: 0
        };
        var a = 1;
        var s = null;
        var v = null;
        var l = null;
        var ok = false;
        var format = false;
        if (typeof color == "string") color = stringInputToObject(color);
        if (typeof color == "object") {
            if (isValidCSSUnit(color.r) && isValidCSSUnit(color.g) && isValidCSSUnit(color.b)) {
                rgb = rgbToRgb(color.r, color.g, color.b);
                ok = true;
                format = String(color.r).substr(-1) === "%" ? "prgb" : "rgb";
            } else if (isValidCSSUnit(color.h) && isValidCSSUnit(color.s) && isValidCSSUnit(color.v)) {
                s = convertToPercentage(color.s);
                v = convertToPercentage(color.v);
                rgb = hsvToRgb(color.h, s, v);
                ok = true;
                format = "hsv";
            } else if (isValidCSSUnit(color.h) && isValidCSSUnit(color.s) && isValidCSSUnit(color.l)) {
                s = convertToPercentage(color.s);
                l = convertToPercentage(color.l);
                rgb = hslToRgb(color.h, s, l);
                ok = true;
                format = "hsl";
            }
            if (color.hasOwnProperty("a")) a = color.a;
        }
        a = boundAlpha(a);
        return {
            ok: ok,
            format: color.format || format,
            r: mathMin(255, mathMax(rgb.r, 0)),
            g: mathMin(255, mathMax(rgb.g, 0)),
            b: mathMin(255, mathMax(rgb.b, 0)),
            a: a
        };
    }
    // Conversion Functions
    // --------------------
    // `rgbToHsl`, `rgbToHsv`, `hslToRgb`, `hsvToRgb` modified from:
    // <http://mjijackson.com/2008/02/rgb-to-hsl-and-rgb-to-hsv-color-model-conversion-algorithms-in-javascript>
    // `rgbToRgb`
    // Handle bounds / percentage checking to conform to CSS color spec
    // <http://www.w3.org/TR/css3-color/>
    // *Assumes:* r, g, b in [0, 255] or [0, 1]
    // *Returns:* { r, g, b } in [0, 255]
    function rgbToRgb(r, g, b) {
        return {
            r: bound01(r, 255) * 255,
            g: bound01(g, 255) * 255,
            b: bound01(b, 255) * 255
        };
    }
    // `rgbToHsl`
    // Converts an RGB color value to HSL.
    // *Assumes:* r, g, and b are contained in [0, 255] or [0, 1]
    // *Returns:* { h, s, l } in [0,1]
    function rgbToHsl(r, g, b) {
        r = bound01(r, 255);
        g = bound01(g, 255);
        b = bound01(b, 255);
        var max = mathMax(r, g, b), min = mathMin(r, g, b);
        var h, s, l = (max + min) / 2;
        if (max == min) h = s = 0; // achromatic
        else {
            var d = max - min;
            s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
            switch(max){
                case r:
                    h = (g - b) / d + (g < b ? 6 : 0);
                    break;
                case g:
                    h = (b - r) / d + 2;
                    break;
                case b:
                    h = (r - g) / d + 4;
                    break;
            }
            h /= 6;
        }
        return {
            h: h,
            s: s,
            l: l
        };
    }
    // `hslToRgb`
    // Converts an HSL color value to RGB.
    // *Assumes:* h is contained in [0, 1] or [0, 360] and s and l are contained [0, 1] or [0, 100]
    // *Returns:* { r, g, b } in the set [0, 255]
    function hslToRgb(h, s, l) {
        var r, g, b;
        h = bound01(h, 360);
        s = bound01(s, 100);
        l = bound01(l, 100);
        function hue2rgb(p, q, t) {
            if (t < 0) t += 1;
            if (t > 1) t -= 1;
            if (t < 1 / 6) return p + (q - p) * 6 * t;
            if (t < 0.5) return q;
            if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
            return p;
        }
        if (s === 0) r = g = b = l; // achromatic
        else {
            var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
            var p = 2 * l - q;
            r = hue2rgb(p, q, h + 1 / 3);
            g = hue2rgb(p, q, h);
            b = hue2rgb(p, q, h - 1 / 3);
        }
        return {
            r: r * 255,
            g: g * 255,
            b: b * 255
        };
    }
    // `rgbToHsv`
    // Converts an RGB color value to HSV
    // *Assumes:* r, g, and b are contained in the set [0, 255] or [0, 1]
    // *Returns:* { h, s, v } in [0,1]
    function rgbToHsv(r, g, b) {
        r = bound01(r, 255);
        g = bound01(g, 255);
        b = bound01(b, 255);
        var max = mathMax(r, g, b), min = mathMin(r, g, b);
        var h, s, v = max;
        var d = max - min;
        s = max === 0 ? 0 : d / max;
        if (max == min) h = 0; // achromatic
        else {
            switch(max){
                case r:
                    h = (g - b) / d + (g < b ? 6 : 0);
                    break;
                case g:
                    h = (b - r) / d + 2;
                    break;
                case b:
                    h = (r - g) / d + 4;
                    break;
            }
            h /= 6;
        }
        return {
            h: h,
            s: s,
            v: v
        };
    }
    // `hsvToRgb`
    // Converts an HSV color value to RGB.
    // *Assumes:* h is contained in [0, 1] or [0, 360] and s and v are contained in [0, 1] or [0, 100]
    // *Returns:* { r, g, b } in the set [0, 255]
    function hsvToRgb(h, s, v) {
        h = bound01(h, 360) * 6;
        s = bound01(s, 100);
        v = bound01(v, 100);
        var i = Math1.floor(h), f = h - i, p = v * (1 - s), q = v * (1 - f * s), t = v * (1 - (1 - f) * s), mod = i % 6, r = [
            v,
            q,
            p,
            p,
            t,
            v
        ][mod], g = [
            t,
            v,
            v,
            q,
            p,
            p
        ][mod], b = [
            p,
            p,
            t,
            v,
            v,
            q
        ][mod];
        return {
            r: r * 255,
            g: g * 255,
            b: b * 255
        };
    }
    // `rgbToHex`
    // Converts an RGB color to hex
    // Assumes r, g, and b are contained in the set [0, 255]
    // Returns a 3 or 6 character hex
    function rgbToHex(r, g, b, allow3Char) {
        var hex = [
            pad2(mathRound(r).toString(16)),
            pad2(mathRound(g).toString(16)),
            pad2(mathRound(b).toString(16))
        ];
        // Return a 3 character hex if possible
        if (allow3Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1)) return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0);
        return hex.join("");
    }
    // `rgbaToHex`
    // Converts an RGBA color plus alpha transparency to hex
    // Assumes r, g, b are contained in the set [0, 255] and
    // a in [0, 1]. Returns a 4 or 8 character rgba hex
    function rgbaToHex(r, g, b, a, allow4Char) {
        var hex = [
            pad2(mathRound(r).toString(16)),
            pad2(mathRound(g).toString(16)),
            pad2(mathRound(b).toString(16)),
            pad2(convertDecimalToHex(a))
        ];
        // Return a 4 character hex if possible
        if (allow4Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1) && hex[3].charAt(0) == hex[3].charAt(1)) return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0) + hex[3].charAt(0);
        return hex.join("");
    }
    // `rgbaToArgbHex`
    // Converts an RGBA color to an ARGB Hex8 string
    // Rarely used, but required for "toFilter()"
    function rgbaToArgbHex(r, g, b, a) {
        var hex = [
            pad2(convertDecimalToHex(a)),
            pad2(mathRound(r).toString(16)),
            pad2(mathRound(g).toString(16)),
            pad2(mathRound(b).toString(16))
        ];
        return hex.join("");
    }
    // `equals`
    // Can be called with any tinycolor input
    tinycolor.equals = function(color1, color2) {
        if (!color1 || !color2) return false;
        return tinycolor(color1).toRgbString() == tinycolor(color2).toRgbString();
    };
    tinycolor.random = function() {
        return tinycolor.fromRatio({
            r: mathRandom(),
            g: mathRandom(),
            b: mathRandom()
        });
    };
    // Modification Functions
    // ----------------------
    // Thanks to less.js for some of the basics here
    // <https://github.com/cloudhead/less.js/blob/master/lib/less/functions.js>
    function desaturate(color, amount) {
        amount = amount === 0 ? 0 : amount || 10;
        var hsl = tinycolor(color).toHsl();
        hsl.s -= amount / 100;
        hsl.s = clamp01(hsl.s);
        return tinycolor(hsl);
    }
    function saturate(color, amount) {
        amount = amount === 0 ? 0 : amount || 10;
        var hsl = tinycolor(color).toHsl();
        hsl.s += amount / 100;
        hsl.s = clamp01(hsl.s);
        return tinycolor(hsl);
    }
    function greyscale(color) {
        return tinycolor(color).desaturate(100);
    }
    function lighten(color, amount) {
        amount = amount === 0 ? 0 : amount || 10;
        var hsl = tinycolor(color).toHsl();
        hsl.l += amount / 100;
        hsl.l = clamp01(hsl.l);
        return tinycolor(hsl);
    }
    function brighten(color, amount) {
        amount = amount === 0 ? 0 : amount || 10;
        var rgb = tinycolor(color).toRgb();
        rgb.r = mathMax(0, mathMin(255, rgb.r - mathRound(255 * -(amount / 100))));
        rgb.g = mathMax(0, mathMin(255, rgb.g - mathRound(255 * -(amount / 100))));
        rgb.b = mathMax(0, mathMin(255, rgb.b - mathRound(255 * -(amount / 100))));
        return tinycolor(rgb);
    }
    function darken(color, amount) {
        amount = amount === 0 ? 0 : amount || 10;
        var hsl = tinycolor(color).toHsl();
        hsl.l -= amount / 100;
        hsl.l = clamp01(hsl.l);
        return tinycolor(hsl);
    }
    // Spin takes a positive or negative amount within [-360, 360] indicating the change of hue.
    // Values outside of this range will be wrapped into this range.
    function spin(color, amount) {
        var hsl = tinycolor(color).toHsl();
        var hue = (hsl.h + amount) % 360;
        hsl.h = hue < 0 ? 360 + hue : hue;
        return tinycolor(hsl);
    }
    // Combination Functions
    // ---------------------
    // Thanks to jQuery xColor for some of the ideas behind these
    // <https://github.com/infusion/jQuery-xcolor/blob/master/jquery.xcolor.js>
    function complement(color) {
        var hsl = tinycolor(color).toHsl();
        hsl.h = (hsl.h + 180) % 360;
        return tinycolor(hsl);
    }
    function triad(color) {
        var hsl = tinycolor(color).toHsl();
        var h = hsl.h;
        return [
            tinycolor(color),
            tinycolor({
                h: (h + 120) % 360,
                s: hsl.s,
                l: hsl.l
            }),
            tinycolor({
                h: (h + 240) % 360,
                s: hsl.s,
                l: hsl.l
            })
        ];
    }
    function tetrad(color) {
        var hsl = tinycolor(color).toHsl();
        var h = hsl.h;
        return [
            tinycolor(color),
            tinycolor({
                h: (h + 90) % 360,
                s: hsl.s,
                l: hsl.l
            }),
            tinycolor({
                h: (h + 180) % 360,
                s: hsl.s,
                l: hsl.l
            }),
            tinycolor({
                h: (h + 270) % 360,
                s: hsl.s,
                l: hsl.l
            })
        ];
    }
    function splitcomplement(color) {
        var hsl = tinycolor(color).toHsl();
        var h = hsl.h;
        return [
            tinycolor(color),
            tinycolor({
                h: (h + 72) % 360,
                s: hsl.s,
                l: hsl.l
            }),
            tinycolor({
                h: (h + 216) % 360,
                s: hsl.s,
                l: hsl.l
            })
        ];
    }
    function analogous(color, results, slices) {
        results = results || 6;
        slices = slices || 30;
        var hsl = tinycolor(color).toHsl();
        var part = 360 / slices;
        var ret = [
            tinycolor(color)
        ];
        for(hsl.h = (hsl.h - (part * results >> 1) + 720) % 360; --results;){
            hsl.h = (hsl.h + part) % 360;
            ret.push(tinycolor(hsl));
        }
        return ret;
    }
    function monochromatic(color, results) {
        results = results || 6;
        var hsv = tinycolor(color).toHsv();
        var h = hsv.h, s = hsv.s, v = hsv.v;
        var ret = [];
        var modification = 1 / results;
        while(results--){
            ret.push(tinycolor({
                h: h,
                s: s,
                v: v
            }));
            v = (v + modification) % 1;
        }
        return ret;
    }
    // Utility Functions
    // ---------------------
    tinycolor.mix = function(color1, color2, amount) {
        amount = amount === 0 ? 0 : amount || 50;
        var rgb1 = tinycolor(color1).toRgb();
        var rgb2 = tinycolor(color2).toRgb();
        var p = amount / 100;
        var rgba = {
            r: (rgb2.r - rgb1.r) * p + rgb1.r,
            g: (rgb2.g - rgb1.g) * p + rgb1.g,
            b: (rgb2.b - rgb1.b) * p + rgb1.b,
            a: (rgb2.a - rgb1.a) * p + rgb1.a
        };
        return tinycolor(rgba);
    };
    // Readability Functions
    // ---------------------
    // <http://www.w3.org/TR/2008/REC-WCAG20-20081211/#contrast-ratiodef (WCAG Version 2)
    // `contrast`
    // Analyze the 2 colors and returns the color contrast defined by (WCAG Version 2)
    tinycolor.readability = function(color1, color2) {
        var c1 = tinycolor(color1);
        var c2 = tinycolor(color2);
        return (Math1.max(c1.getLuminance(), c2.getLuminance()) + 0.05) / (Math1.min(c1.getLuminance(), c2.getLuminance()) + 0.05);
    };
    // `isReadable`
    // Ensure that foreground and background color combinations meet WCAG2 guidelines.
    // The third argument is an optional Object.
    //      the 'level' property states 'AA' or 'AAA' - if missing or invalid, it defaults to 'AA';
    //      the 'size' property states 'large' or 'small' - if missing or invalid, it defaults to 'small'.
    // If the entire object is absent, isReadable defaults to {level:"AA",size:"small"}.
    // *Example*
    //    tinycolor.isReadable("#000", "#111") => false
    //    tinycolor.isReadable("#000", "#111",{level:"AA",size:"large"}) => false
    tinycolor.isReadable = function(color1, color2, wcag2) {
        var readability = tinycolor.readability(color1, color2);
        var wcag2Parms, out;
        out = false;
        wcag2Parms = validateWCAG2Parms(wcag2);
        switch(wcag2Parms.level + wcag2Parms.size){
            case "AAsmall":
            case "AAAlarge":
                out = readability >= 4.5;
                break;
            case "AAlarge":
                out = readability >= 3;
                break;
            case "AAAsmall":
                out = readability >= 7;
                break;
        }
        return out;
    };
    // `mostReadable`
    // Given a base color and a list of possible foreground or background
    // colors for that base, returns the most readable color.
    // Optionally returns Black or White if the most readable color is unreadable.
    // *Example*
    //    tinycolor.mostReadable(tinycolor.mostReadable("#123", ["#124", "#125"],{includeFallbackColors:false}).toHexString(); // "#112255"
    //    tinycolor.mostReadable(tinycolor.mostReadable("#123", ["#124", "#125"],{includeFallbackColors:true}).toHexString();  // "#ffffff"
    //    tinycolor.mostReadable("#a8015a", ["#faf3f3"],{includeFallbackColors:true,level:"AAA",size:"large"}).toHexString(); // "#faf3f3"
    //    tinycolor.mostReadable("#a8015a", ["#faf3f3"],{includeFallbackColors:true,level:"AAA",size:"small"}).toHexString(); // "#ffffff"
    tinycolor.mostReadable = function(baseColor, colorList, args) {
        var bestColor = null;
        var bestScore = 0;
        var readability;
        var includeFallbackColors, level, size;
        args = args || {};
        includeFallbackColors = args.includeFallbackColors;
        level = args.level;
        size = args.size;
        for(var i = 0; i < colorList.length; i++){
            readability = tinycolor.readability(baseColor, colorList[i]);
            if (readability > bestScore) {
                bestScore = readability;
                bestColor = tinycolor(colorList[i]);
            }
        }
        if (tinycolor.isReadable(baseColor, bestColor, {
            "level": level,
            "size": size
        }) || !includeFallbackColors) return bestColor;
        else {
            args.includeFallbackColors = false;
            return tinycolor.mostReadable(baseColor, [
                "#fff",
                "#000"
            ], args);
        }
    };
    // Big List of Colors
    // ------------------
    // <http://www.w3.org/TR/css3-color/#svg-color>
    var names = tinycolor.names = {
        aliceblue: "f0f8ff",
        antiquewhite: "faebd7",
        aqua: "0ff",
        aquamarine: "7fffd4",
        azure: "f0ffff",
        beige: "f5f5dc",
        bisque: "ffe4c4",
        black: "000",
        blanchedalmond: "ffebcd",
        blue: "00f",
        blueviolet: "8a2be2",
        brown: "a52a2a",
        burlywood: "deb887",
        burntsienna: "ea7e5d",
        cadetblue: "5f9ea0",
        chartreuse: "7fff00",
        chocolate: "d2691e",
        coral: "ff7f50",
        cornflowerblue: "6495ed",
        cornsilk: "fff8dc",
        crimson: "dc143c",
        cyan: "0ff",
        darkblue: "00008b",
        darkcyan: "008b8b",
        darkgoldenrod: "b8860b",
        darkgray: "a9a9a9",
        darkgreen: "006400",
        darkgrey: "a9a9a9",
        darkkhaki: "bdb76b",
        darkmagenta: "8b008b",
        darkolivegreen: "556b2f",
        darkorange: "ff8c00",
        darkorchid: "9932cc",
        darkred: "8b0000",
        darksalmon: "e9967a",
        darkseagreen: "8fbc8f",
        darkslateblue: "483d8b",
        darkslategray: "2f4f4f",
        darkslategrey: "2f4f4f",
        darkturquoise: "00ced1",
        darkviolet: "9400d3",
        deeppink: "ff1493",
        deepskyblue: "00bfff",
        dimgray: "696969",
        dimgrey: "696969",
        dodgerblue: "1e90ff",
        firebrick: "b22222",
        floralwhite: "fffaf0",
        forestgreen: "228b22",
        fuchsia: "f0f",
        gainsboro: "dcdcdc",
        ghostwhite: "f8f8ff",
        gold: "ffd700",
        goldenrod: "daa520",
        gray: "808080",
        green: "008000",
        greenyellow: "adff2f",
        grey: "808080",
        honeydew: "f0fff0",
        hotpink: "ff69b4",
        indianred: "cd5c5c",
        indigo: "4b0082",
        ivory: "fffff0",
        khaki: "f0e68c",
        lavender: "e6e6fa",
        lavenderblush: "fff0f5",
        lawngreen: "7cfc00",
        lemonchiffon: "fffacd",
        lightblue: "add8e6",
        lightcoral: "f08080",
        lightcyan: "e0ffff",
        lightgoldenrodyellow: "fafad2",
        lightgray: "d3d3d3",
        lightgreen: "90ee90",
        lightgrey: "d3d3d3",
        lightpink: "ffb6c1",
        lightsalmon: "ffa07a",
        lightseagreen: "20b2aa",
        lightskyblue: "87cefa",
        lightslategray: "789",
        lightslategrey: "789",
        lightsteelblue: "b0c4de",
        lightyellow: "ffffe0",
        lime: "0f0",
        limegreen: "32cd32",
        linen: "faf0e6",
        magenta: "f0f",
        maroon: "800000",
        mediumaquamarine: "66cdaa",
        mediumblue: "0000cd",
        mediumorchid: "ba55d3",
        mediumpurple: "9370db",
        mediumseagreen: "3cb371",
        mediumslateblue: "7b68ee",
        mediumspringgreen: "00fa9a",
        mediumturquoise: "48d1cc",
        mediumvioletred: "c71585",
        midnightblue: "191970",
        mintcream: "f5fffa",
        mistyrose: "ffe4e1",
        moccasin: "ffe4b5",
        navajowhite: "ffdead",
        navy: "000080",
        oldlace: "fdf5e6",
        olive: "808000",
        olivedrab: "6b8e23",
        orange: "ffa500",
        orangered: "ff4500",
        orchid: "da70d6",
        palegoldenrod: "eee8aa",
        palegreen: "98fb98",
        paleturquoise: "afeeee",
        palevioletred: "db7093",
        papayawhip: "ffefd5",
        peachpuff: "ffdab9",
        peru: "cd853f",
        pink: "ffc0cb",
        plum: "dda0dd",
        powderblue: "b0e0e6",
        purple: "800080",
        rebeccapurple: "663399",
        red: "f00",
        rosybrown: "bc8f8f",
        royalblue: "4169e1",
        saddlebrown: "8b4513",
        salmon: "fa8072",
        sandybrown: "f4a460",
        seagreen: "2e8b57",
        seashell: "fff5ee",
        sienna: "a0522d",
        silver: "c0c0c0",
        skyblue: "87ceeb",
        slateblue: "6a5acd",
        slategray: "708090",
        slategrey: "708090",
        snow: "fffafa",
        springgreen: "00ff7f",
        steelblue: "4682b4",
        tan: "d2b48c",
        teal: "008080",
        thistle: "d8bfd8",
        tomato: "ff6347",
        turquoise: "40e0d0",
        violet: "ee82ee",
        wheat: "f5deb3",
        white: "fff",
        whitesmoke: "f5f5f5",
        yellow: "ff0",
        yellowgreen: "9acd32"
    };
    // Make it easy to access colors via `hexNames[hex]`
    var hexNames = tinycolor.hexNames = flip(names);
    // Utilities
    // ---------
    // `{ 'name1': 'val1' }` becomes `{ 'val1': 'name1' }`
    function flip(o) {
        var flipped = {};
        for(var i in o)if (o.hasOwnProperty(i)) flipped[o[i]] = i;
        return flipped;
    }
    // Return a valid alpha value [0,1] with all invalid values being set to 1
    function boundAlpha(a) {
        a = parseFloat(a);
        if (isNaN(a) || a < 0 || a > 1) a = 1;
        return a;
    }
    // Take input from [0, n] and return it as [0, 1]
    function bound01(n, max) {
        if (isOnePointZero(n)) n = "100%";
        var processPercent = isPercentage(n);
        n = mathMin(max, mathMax(0, parseFloat(n)));
        // Automatically convert percentage into number
        if (processPercent) n = parseInt(n * max, 10) / 100;
        // Handle floating point rounding errors
        if (Math1.abs(n - max) < 0.000001) return 1;
        // Convert into [0, 1] range if it isn't already
        return n % max / parseFloat(max);
    }
    // Force a number between 0 and 1
    function clamp01(val) {
        return mathMin(1, mathMax(0, val));
    }
    // Parse a base-16 hex value into a base-10 integer
    function parseIntFromHex(val) {
        return parseInt(val, 16);
    }
    // Need to handle 1.0 as 100%, since once it is a number, there is no difference between it and 1
    // <http://stackoverflow.com/questions/7422072/javascript-how-to-detect-number-as-a-decimal-including-1-0>
    function isOnePointZero(n) {
        return typeof n == "string" && n.indexOf(".") != -1 && parseFloat(n) === 1;
    }
    // Check to see if string passed in is a percentage
    function isPercentage(n) {
        return typeof n === "string" && n.indexOf("%") != -1;
    }
    // Force a hex value to have 2 characters
    function pad2(c) {
        return c.length == 1 ? "0" + c : "" + c;
    }
    // Replace a decimal with it's percentage value
    function convertToPercentage(n) {
        if (n <= 1) n = n * 100 + "%";
        return n;
    }
    // Converts a decimal to a hex value
    function convertDecimalToHex(d) {
        return Math1.round(parseFloat(d) * 255).toString(16);
    }
    // Converts a hex value to a decimal
    function convertHexToDecimal(h) {
        return parseIntFromHex(h) / 255;
    }
    var matchers = function() {
        // <http://www.w3.org/TR/css3-values/#integers>
        var CSS_INTEGER = "[-\\+]?\\d+%?";
        // <http://www.w3.org/TR/css3-values/#number-value>
        var CSS_NUMBER = "[-\\+]?\\d*\\.\\d+%?";
        // Allow positive/negative integer/number.  Don't capture the either/or, just the entire outcome.
        var CSS_UNIT = "(?:" + CSS_NUMBER + ")|(?:" + CSS_INTEGER + ")";
        // Actual matching.
        // Parentheses and commas are optional, but not required.
        // Whitespace can take the place of commas or opening paren
        var PERMISSIVE_MATCH3 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";
        var PERMISSIVE_MATCH4 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";
        return {
            CSS_UNIT: new RegExp(CSS_UNIT),
            rgb: new RegExp("rgb" + PERMISSIVE_MATCH3),
            rgba: new RegExp("rgba" + PERMISSIVE_MATCH4),
            hsl: new RegExp("hsl" + PERMISSIVE_MATCH3),
            hsla: new RegExp("hsla" + PERMISSIVE_MATCH4),
            hsv: new RegExp("hsv" + PERMISSIVE_MATCH3),
            hsva: new RegExp("hsva" + PERMISSIVE_MATCH4),
            hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
            hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
            hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
            hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
        };
    }();
    // `isValidCSSUnit`
    // Take in a single string / number and check to see if it looks like a CSS unit
    // (see `matchers` above for definition).
    function isValidCSSUnit(color) {
        return !!matchers.CSS_UNIT.exec(color);
    }
    // `stringInputToObject`
    // Permissive string parsing.  Take in a number of formats, and output an object
    // based on detected format.  Returns `{ r, g, b }` or `{ h, s, l }` or `{ h, s, v}`
    function stringInputToObject(color) {
        color = color.replace(trimLeft, "").replace(trimRight, "").toLowerCase();
        var named = false;
        if (names[color]) {
            color = names[color];
            named = true;
        } else if (color == "transparent") return {
            r: 0,
            g: 0,
            b: 0,
            a: 0,
            format: "name"
        };
        // Try to match string input using regular expressions.
        // Keep most of the number bounding out of this function - don't worry about [0,1] or [0,100] or [0,360]
        // Just return an object and let the conversion functions handle that.
        // This way the result will be the same whether the tinycolor is initialized with string or object.
        var match;
        if (match = matchers.rgb.exec(color)) return {
            r: match[1],
            g: match[2],
            b: match[3]
        };
        if (match = matchers.rgba.exec(color)) return {
            r: match[1],
            g: match[2],
            b: match[3],
            a: match[4]
        };
        if (match = matchers.hsl.exec(color)) return {
            h: match[1],
            s: match[2],
            l: match[3]
        };
        if (match = matchers.hsla.exec(color)) return {
            h: match[1],
            s: match[2],
            l: match[3],
            a: match[4]
        };
        if (match = matchers.hsv.exec(color)) return {
            h: match[1],
            s: match[2],
            v: match[3]
        };
        if (match = matchers.hsva.exec(color)) return {
            h: match[1],
            s: match[2],
            v: match[3],
            a: match[4]
        };
        if (match = matchers.hex8.exec(color)) return {
            r: parseIntFromHex(match[1]),
            g: parseIntFromHex(match[2]),
            b: parseIntFromHex(match[3]),
            a: convertHexToDecimal(match[4]),
            format: named ? "name" : "hex8"
        };
        if (match = matchers.hex6.exec(color)) return {
            r: parseIntFromHex(match[1]),
            g: parseIntFromHex(match[2]),
            b: parseIntFromHex(match[3]),
            format: named ? "name" : "hex"
        };
        if (match = matchers.hex4.exec(color)) return {
            r: parseIntFromHex(match[1] + "" + match[1]),
            g: parseIntFromHex(match[2] + "" + match[2]),
            b: parseIntFromHex(match[3] + "" + match[3]),
            a: convertHexToDecimal(match[4] + "" + match[4]),
            format: named ? "name" : "hex8"
        };
        if (match = matchers.hex3.exec(color)) return {
            r: parseIntFromHex(match[1] + "" + match[1]),
            g: parseIntFromHex(match[2] + "" + match[2]),
            b: parseIntFromHex(match[3] + "" + match[3]),
            format: named ? "name" : "hex"
        };
        return false;
    }
    function validateWCAG2Parms(parms) {
        // return valid WCAG2 parms for isReadable.
        // If input parms are invalid, return {"level":"AA", "size":"small"}
        var level, size;
        parms = parms || {
            "level": "AA",
            "size": "small"
        };
        level = (parms.level || "AA").toUpperCase();
        size = (parms.size || "small").toLowerCase();
        if (level !== "AA" && level !== "AAA") level = "AA";
        if (size !== "small" && size !== "large") size = "small";
        return {
            "level": level,
            "size": size
        };
    }
    // Node: Export function
    if (0, module.exports) module.exports = tinycolor;
    else if (typeof define === "function" && define.amd) define(function() {
        return tinycolor;
    });
    else window.tinycolor = tinycolor;
})(Math);

});



parcelRegister("2DBoi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1ebc3a59bc6291c3$export$2e2bcd8739ae039; });

var $eeH7J = parcelRequire("eeH7J");

var $bJBxw = parcelRequire("bJBxw");

var $jyeBD = parcelRequire("jyeBD");

var $dZU3X = parcelRequire("dZU3X");
var $1ebc3a59bc6291c3$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $1ebc3a59bc6291c3$var$ENTER = 13;
var $1ebc3a59bc6291c3$export$c463048d6131b309 = function Swatch(_ref) {
    var color = _ref.color, style = _ref.style, _ref$onClick = _ref.onClick, onClick = _ref$onClick === undefined ? function() {} : _ref$onClick, onHover = _ref.onHover, _ref$title = _ref.title, title = _ref$title === undefined ? color : _ref$title, children = _ref.children, focus = _ref.focus, _ref$focusStyle = _ref.focusStyle, focusStyle = _ref$focusStyle === undefined ? {} : _ref$focusStyle;
    var transparent = color === "transparent";
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($bJBxw)))({
        default: {
            swatch: $1ebc3a59bc6291c3$var$_extends({
                background: color,
                height: "100%",
                width: "100%",
                cursor: "pointer",
                position: "relative",
                outline: "none"
            }, style, focus ? focusStyle : {})
        }
    });
    var handleClick = function handleClick(e) {
        return onClick(color, e);
    };
    var handleKeyDown = function handleKeyDown(e) {
        return e.keyCode === $1ebc3a59bc6291c3$var$ENTER && onClick(color, e);
    };
    var handleHover = function handleHover(e) {
        return onHover(color, e);
    };
    var optionalEvents = {};
    if (onHover) optionalEvents.onMouseOver = handleHover;
    return (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", $1ebc3a59bc6291c3$var$_extends({
        style: styles.swatch,
        onClick: handleClick,
        title: title,
        tabIndex: 0,
        onKeyDown: handleKeyDown
    }, optionalEvents), children, transparent && (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $dZU3X.default), {
        borderRadius: styles.swatch.borderRadius,
        boxShadow: "inset 0 0 0 1px rgba(0,0,0,0.1)"
    }));
};
var $1ebc3a59bc6291c3$export$2e2bcd8739ae039 = (0, $jyeBD.handleFocus)($1ebc3a59bc6291c3$export$c463048d6131b309);

});
parcelRegister("jyeBD", function(module, exports) {

$parcel$export(module.exports, "handleFocus", function () { return handleFocus; });

var $eeH7J = parcelRequire("eeH7J");
var _extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var _createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var handleFocus = function handleFocus(Component) {
    var Span = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "span";
    return function(_React$Component) {
        _inherits(Focus, _React$Component);
        function Focus() {
            var _ref;
            var _temp, _this, _ret;
            _classCallCheck(this, Focus);
            for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Focus.__proto__ || Object.getPrototypeOf(Focus)).call.apply(_ref, [
                this
            ].concat(args))), _this), _this.state = {
                focus: false
            }, _this.handleFocus = function() {
                return _this.setState({
                    focus: true
                });
            }, _this.handleBlur = function() {
                return _this.setState({
                    focus: false
                });
            }, _temp), _possibleConstructorReturn(_this, _ret);
        }
        _createClass(Focus, [
            {
                key: "render",
                value: function render() {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement(Span, {
                        onFocus: this.handleFocus,
                        onBlur: this.handleBlur
                    }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement(Component, _extends({}, this.props, this.state)));
                }
            }
        ]);
        return Focus;
    }((0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).Component);
};

});



parcelRegister("9eoS3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6b88b6adb17a79e1$export$2e2bcd8739ae039; });

var $eeH7J = parcelRequire("eeH7J");

var $bJBxw = parcelRequire("bJBxw");
var $6b88b6adb17a79e1$export$5bbd8091d1d0e224 = function AlphaPointer(_ref) {
    var direction = _ref.direction;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($bJBxw)))({
        "default": {
            picker: {
                width: "18px",
                height: "18px",
                borderRadius: "50%",
                transform: "translate(-9px, -1px)",
                backgroundColor: "rgb(248, 248, 248)",
                boxShadow: "0 1px 4px 0 rgba(0, 0, 0, 0.37)"
            }
        },
        "vertical": {
            picker: {
                transform: "translate(-3px, -9px)"
            }
        }
    }, {
        vertical: direction === "vertical"
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        style: styles.picker
    });
};
var $6b88b6adb17a79e1$export$2e2bcd8739ae039 = $6b88b6adb17a79e1$export$5bbd8091d1d0e224;

});


parcelRegister("dJMuE", function(module, exports) {

var $eeH7J = parcelRequire("eeH7J");

var $4yBem = parcelRequire("4yBem");

var $bJBxw = parcelRequire("bJBxw");

var $5VQgV = parcelRequire("5VQgV");

var $7Zkko = parcelRequire("7Zkko");
parcelRequire("isDZf");
var $dZU3X = parcelRequire("dZU3X");
var $8bUgk = parcelRequire("8bUgk");
var $a5dMh = parcelRequire("a5dMh");

var $2EtHd = parcelRequire("2EtHd");
var $a005181c6dc3949e$export$d96a8827a60d6b69 = function Block(_ref) {
    var onChange = _ref.onChange, onSwatchHover = _ref.onSwatchHover, hex = _ref.hex, colors = _ref.colors, width = _ref.width, triangle = _ref.triangle, _ref$styles = _ref.styles, passedStyles = _ref$styles === undefined ? {} : _ref$styles, _ref$className = _ref.className, className = _ref$className === undefined ? "" : _ref$className;
    var transparent = hex === "transparent";
    var handleChange = function handleChange(hexCode, e) {
        $7Zkko.isValidHex(hexCode) && onChange({
            hex: hexCode,
            source: "hex"
        }, e);
    };
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($bJBxw)))((0, $5VQgV.default)({
        "default": {
            card: {
                width: width,
                background: "#fff",
                boxShadow: "0 1px rgba(0,0,0,.1)",
                borderRadius: "6px",
                position: "relative"
            },
            head: {
                height: "110px",
                background: hex,
                borderRadius: "6px 6px 0 0",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                position: "relative"
            },
            body: {
                padding: "10px"
            },
            label: {
                fontSize: "18px",
                color: $7Zkko.getContrastingColor(hex),
                position: "relative"
            },
            triangle: {
                width: "0px",
                height: "0px",
                borderStyle: "solid",
                borderWidth: "0 10px 10px 10px",
                borderColor: "transparent transparent " + hex + " transparent",
                position: "absolute",
                top: "-10px",
                left: "50%",
                marginLeft: "-10px"
            },
            input: {
                width: "100%",
                fontSize: "12px",
                color: "#666",
                border: "0px",
                outline: "none",
                height: "22px",
                boxShadow: "inset 0 0 0 1px #ddd",
                borderRadius: "4px",
                padding: "0 7px",
                boxSizing: "border-box"
            }
        },
        "hide-triangle": {
            triangle: {
                display: "none"
            }
        }
    }, passedStyles), {
        "hide-triangle": triangle === "hide"
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        style: styles.card,
        className: "block-picker " + className
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        style: styles.triangle
    }), (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        style: styles.head
    }, transparent && (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $dZU3X.default), {
        borderRadius: "6px 6px 0 0"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        style: styles.label
    }, hex)), (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        style: styles.body
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $2EtHd.default), {
        colors: colors,
        onClick: handleChange,
        onSwatchHover: onSwatchHover
    }), (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $a5dMh.default), {
        style: {
            input: styles.input
        },
        value: hex,
        onChange: handleChange
    })));
};
$a005181c6dc3949e$export$d96a8827a60d6b69.propTypes = {
    width: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).number
    ]),
    colors: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string),
    triangle: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOf([
        "top",
        "hide"
    ]),
    styles: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object
};
$a005181c6dc3949e$export$d96a8827a60d6b69.defaultProps = {
    width: 170,
    colors: [
        "#D9E3F0",
        "#F47373",
        "#697689",
        "#37D67A",
        "#2CCCE4",
        "#555555",
        "#dce775",
        "#ff8a65",
        "#ba68c8"
    ],
    triangle: "top",
    styles: {}
};
var $a005181c6dc3949e$export$2e2bcd8739ae039 = (0, $8bUgk.default)($a005181c6dc3949e$export$d96a8827a60d6b69);

});
parcelRegister("2EtHd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1ee65a3ac93838c3$export$2e2bcd8739ae039; });

var $eeH7J = parcelRequire("eeH7J");

var $bJBxw = parcelRequire("bJBxw");

var $5UnTd = parcelRequire("5UnTd");
parcelRequire("isDZf");
var $2DBoi = parcelRequire("2DBoi");
var $1ee65a3ac93838c3$export$2ce88c5250e54734 = function BlockSwatches(_ref) {
    var colors = _ref.colors, onClick = _ref.onClick, onSwatchHover = _ref.onSwatchHover;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($bJBxw)))({
        "default": {
            swatches: {
                marginRight: "-10px"
            },
            swatch: {
                width: "22px",
                height: "22px",
                float: "left",
                marginRight: "10px",
                marginBottom: "10px",
                borderRadius: "4px"
            },
            clear: {
                clear: "both"
            }
        }
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        style: styles.swatches
    }, (0, $5UnTd.default)(colors, function(c) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $2DBoi.default), {
            key: c,
            color: c,
            style: styles.swatch,
            onClick: onClick,
            onHover: onSwatchHover,
            focusStyle: {
                boxShadow: "0 0 4px " + c
            }
        });
    }), (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        style: styles.clear
    }));
};
var $1ee65a3ac93838c3$export$2e2bcd8739ae039 = $1ee65a3ac93838c3$export$2ce88c5250e54734;

});
parcelRegister("5UnTd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $44d4b6b3f15b91cd$export$2e2bcd8739ae039; });

var $899UF = parcelRequire("899UF");

var $8AeLl = parcelRequire("8AeLl");

var $8M4V7 = parcelRequire("8M4V7");

var $o0x3M = parcelRequire("o0x3M");
/**
 * Creates an array of values by running each element in `collection` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
 *
 * The guarded methods are:
 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * _.map([4, 8], square);
 * // => [16, 64]
 *
 * _.map({ 'a': 4, 'b': 8 }, square);
 * // => [16, 64] (iteration order is not guaranteed)
 *
 * var users = [
 *   { 'user': 'barney' },
 *   { 'user': 'fred' }
 * ];
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, 'user');
 * // => ['barney', 'fred']
 */ function $44d4b6b3f15b91cd$var$map(collection, iteratee) {
    var func = (0, $o0x3M.default)(collection) ? (0, $899UF.default) : (0, $8M4V7.default);
    return func(collection, (0, $8AeLl.default)(iteratee, 3));
}
var $44d4b6b3f15b91cd$export$2e2bcd8739ae039 = $44d4b6b3f15b91cd$var$map;

});
parcelRegister("899UF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5ee6da836cd5603d$export$2e2bcd8739ae039; });
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $5ee6da836cd5603d$var$arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
var $5ee6da836cd5603d$export$2e2bcd8739ae039 = $5ee6da836cd5603d$var$arrayMap;

});

parcelRegister("8AeLl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $63fd23164343c22d$export$2e2bcd8739ae039; });

var $5BtAh = parcelRequire("5BtAh");

var $3z11V = parcelRequire("3z11V");

var $2719y = parcelRequire("2719y");

var $o0x3M = parcelRequire("o0x3M");

var $ejCIm = parcelRequire("ejCIm");
/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */ function $63fd23164343c22d$var$baseIteratee(value) {
    // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
    // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
    if (typeof value == "function") return value;
    if (value == null) return 0, $2719y.default;
    if (typeof value == "object") return (0, $o0x3M.default)(value) ? (0, $3z11V.default)(value[0], value[1]) : (0, $5BtAh.default)(value);
    return (0, $ejCIm.default)(value);
}
var $63fd23164343c22d$export$2e2bcd8739ae039 = $63fd23164343c22d$var$baseIteratee;

});
parcelRegister("5BtAh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $41475b3dfe71cb50$export$2e2bcd8739ae039; });

var $39GQV = parcelRequire("39GQV");

var $7q21S = parcelRequire("7q21S");

var $aPy9x = parcelRequire("aPy9x");
/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */ function $41475b3dfe71cb50$var$baseMatches(source) {
    var matchData = (0, $7q21S.default)(source);
    if (matchData.length == 1 && matchData[0][2]) return (0, $aPy9x.default)(matchData[0][0], matchData[0][1]);
    return function(object) {
        return object === source || (0, $39GQV.default)(object, source, matchData);
    };
}
var $41475b3dfe71cb50$export$2e2bcd8739ae039 = $41475b3dfe71cb50$var$baseMatches;

});
parcelRegister("39GQV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $24c37403d0c02e08$export$2e2bcd8739ae039; });

var $iH3Fz = parcelRequire("iH3Fz");

var $94D7E = parcelRequire("94D7E");
/** Used to compose bitmasks for value comparisons. */ var $24c37403d0c02e08$var$COMPARE_PARTIAL_FLAG = 1, $24c37403d0c02e08$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */ function $24c37403d0c02e08$var$baseIsMatch(object, source, matchData, customizer) {
    var index = matchData.length, length = index, noCustomizer = !customizer;
    if (object == null) return !length;
    object = Object(object);
    while(index--){
        var data = matchData[index];
        if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
    }
    while(++index < length){
        data = matchData[index];
        var key = data[0], objValue = object[key], srcValue = data[1];
        if (noCustomizer && data[2]) {
            if (objValue === undefined && !(key in object)) return false;
        } else {
            var stack = new (0, $iH3Fz.default);
            if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
            if (!(result === undefined ? (0, $94D7E.default)(srcValue, objValue, $24c37403d0c02e08$var$COMPARE_PARTIAL_FLAG | $24c37403d0c02e08$var$COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
        }
    }
    return true;
}
var $24c37403d0c02e08$export$2e2bcd8739ae039 = $24c37403d0c02e08$var$baseIsMatch;

});
parcelRegister("94D7E", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $69b2d5aed7356a78$export$2e2bcd8739ae039; });

var $agv05 = parcelRequire("agv05");

var $BOPtQ = parcelRequire("BOPtQ");
/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function $69b2d5aed7356a78$var$baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !(0, $BOPtQ.default)(value) && !(0, $BOPtQ.default)(other)) return value !== value && other !== other;
    return (0, $agv05.default)(value, other, bitmask, customizer, $69b2d5aed7356a78$var$baseIsEqual, stack);
}
var $69b2d5aed7356a78$export$2e2bcd8739ae039 = $69b2d5aed7356a78$var$baseIsEqual;

});
parcelRegister("agv05", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7793720dd23d8d83$export$2e2bcd8739ae039; });

var $iH3Fz = parcelRequire("iH3Fz");

var $8IXLZ = parcelRequire("8IXLZ");

var $71oSu = parcelRequire("71oSu");

var $99Ql6 = parcelRequire("99Ql6");

var $4lAdM = parcelRequire("4lAdM");

var $o0x3M = parcelRequire("o0x3M");

var $igoKr = parcelRequire("igoKr");

var $9kZhJ = parcelRequire("9kZhJ");
/** Used to compose bitmasks for value comparisons. */ var $7793720dd23d8d83$var$COMPARE_PARTIAL_FLAG = 1;
/** `Object#toString` result references. */ var $7793720dd23d8d83$var$argsTag = "[object Arguments]", $7793720dd23d8d83$var$arrayTag = "[object Array]", $7793720dd23d8d83$var$objectTag = "[object Object]";
/** Used for built-in method references. */ var $7793720dd23d8d83$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $7793720dd23d8d83$var$hasOwnProperty = $7793720dd23d8d83$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $7793720dd23d8d83$var$baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = (0, $o0x3M.default)(object), othIsArr = (0, $o0x3M.default)(other), objTag = objIsArr ? $7793720dd23d8d83$var$arrayTag : (0, $4lAdM.default)(object), othTag = othIsArr ? $7793720dd23d8d83$var$arrayTag : (0, $4lAdM.default)(other);
    objTag = objTag == $7793720dd23d8d83$var$argsTag ? $7793720dd23d8d83$var$objectTag : objTag;
    othTag = othTag == $7793720dd23d8d83$var$argsTag ? $7793720dd23d8d83$var$objectTag : othTag;
    var objIsObj = objTag == $7793720dd23d8d83$var$objectTag, othIsObj = othTag == $7793720dd23d8d83$var$objectTag, isSameTag = objTag == othTag;
    if (isSameTag && (0, $igoKr.default)(object)) {
        if (!(0, $igoKr.default)(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new (0, $iH3Fz.default));
        return objIsArr || (0, $9kZhJ.default)(object) ? (0, $8IXLZ.default)(object, other, bitmask, customizer, equalFunc, stack) : (0, $71oSu.default)(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & $7793720dd23d8d83$var$COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && $7793720dd23d8d83$var$hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && $7793720dd23d8d83$var$hasOwnProperty.call(other, "__wrapped__");
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new (0, $iH3Fz.default));
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new (0, $iH3Fz.default));
    return (0, $99Ql6.default)(object, other, bitmask, customizer, equalFunc, stack);
}
var $7793720dd23d8d83$export$2e2bcd8739ae039 = $7793720dd23d8d83$var$baseIsEqualDeep;

});
parcelRegister("8IXLZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $65a0cc7c3ac9f810$export$2e2bcd8739ae039; });

var $j55fP = parcelRequire("j55fP");

var $haVNW = parcelRequire("haVNW");

var $kmd2P = parcelRequire("kmd2P");
/** Used to compose bitmasks for value comparisons. */ var $65a0cc7c3ac9f810$var$COMPARE_PARTIAL_FLAG = 1, $65a0cc7c3ac9f810$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function $65a0cc7c3ac9f810$var$equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $65a0cc7c3ac9f810$var$COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Check that cyclic values are equal.
    var arrStacked = stack.get(array);
    var othStacked = stack.get(other);
    if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
    var index = -1, result = true, seen = bitmask & $65a0cc7c3ac9f810$var$COMPARE_UNORDERED_FLAG ? new (0, $j55fP.default) : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!(0, $haVNW.default)(other, function(othValue, othIndex) {
                if (!(0, $kmd2P.default)(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack["delete"](array);
    stack["delete"](other);
    return result;
}
var $65a0cc7c3ac9f810$export$2e2bcd8739ae039 = $65a0cc7c3ac9f810$var$equalArrays;

});
parcelRegister("j55fP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $de428f5920c73ad5$export$2e2bcd8739ae039; });

var $5bIkI = parcelRequire("5bIkI");

var $duFnj = parcelRequire("duFnj");

var $1mFmf = parcelRequire("1mFmf");
/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function $de428f5920c73ad5$var$SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new (0, $5bIkI.default);
    while(++index < length)this.add(values[index]);
}
// Add methods to `SetCache`.
$de428f5920c73ad5$var$SetCache.prototype.add = $de428f5920c73ad5$var$SetCache.prototype.push = (0, $duFnj.default);
$de428f5920c73ad5$var$SetCache.prototype.has = (0, $1mFmf.default);
var $de428f5920c73ad5$export$2e2bcd8739ae039 = $de428f5920c73ad5$var$SetCache;

});
parcelRegister("duFnj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9d2e2beb86dbb305$export$2e2bcd8739ae039; });
/** Used to stand-in for `undefined` hash values. */ var $9d2e2beb86dbb305$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function $9d2e2beb86dbb305$var$setCacheAdd(value) {
    this.__data__.set(value, $9d2e2beb86dbb305$var$HASH_UNDEFINED);
    return this;
}
var $9d2e2beb86dbb305$export$2e2bcd8739ae039 = $9d2e2beb86dbb305$var$setCacheAdd;

});

parcelRegister("1mFmf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0fe7ed53f2bb963c$export$2e2bcd8739ae039; });
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function $0fe7ed53f2bb963c$var$setCacheHas(value) {
    return this.__data__.has(value);
}
var $0fe7ed53f2bb963c$export$2e2bcd8739ae039 = $0fe7ed53f2bb963c$var$setCacheHas;

});


parcelRegister("haVNW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c8103599476381de$export$2e2bcd8739ae039; });
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function $c8103599476381de$var$arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
var $c8103599476381de$export$2e2bcd8739ae039 = $c8103599476381de$var$arraySome;

});

parcelRegister("kmd2P", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ed1ffb1940a13b0a$export$2e2bcd8739ae039; });
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $ed1ffb1940a13b0a$var$cacheHas(cache, key) {
    return cache.has(key);
}
var $ed1ffb1940a13b0a$export$2e2bcd8739ae039 = $ed1ffb1940a13b0a$var$cacheHas;

});


parcelRegister("71oSu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $51cbeca4e50a3c8e$export$2e2bcd8739ae039; });

var $7Kr41 = parcelRequire("7Kr41");

var $h4O8Z = parcelRequire("h4O8Z");

var $kuJus = parcelRequire("kuJus");

var $8IXLZ = parcelRequire("8IXLZ");

var $4040W = parcelRequire("4040W");

var $ixgtc = parcelRequire("ixgtc");
/** Used to compose bitmasks for value comparisons. */ var $51cbeca4e50a3c8e$var$COMPARE_PARTIAL_FLAG = 1, $51cbeca4e50a3c8e$var$COMPARE_UNORDERED_FLAG = 2;
/** `Object#toString` result references. */ var $51cbeca4e50a3c8e$var$boolTag = "[object Boolean]", $51cbeca4e50a3c8e$var$dateTag = "[object Date]", $51cbeca4e50a3c8e$var$errorTag = "[object Error]", $51cbeca4e50a3c8e$var$mapTag = "[object Map]", $51cbeca4e50a3c8e$var$numberTag = "[object Number]", $51cbeca4e50a3c8e$var$regexpTag = "[object RegExp]", $51cbeca4e50a3c8e$var$setTag = "[object Set]", $51cbeca4e50a3c8e$var$stringTag = "[object String]", $51cbeca4e50a3c8e$var$symbolTag = "[object Symbol]";
var $51cbeca4e50a3c8e$var$arrayBufferTag = "[object ArrayBuffer]", $51cbeca4e50a3c8e$var$dataViewTag = "[object DataView]";
/** Used to convert symbols to primitives and strings. */ var $51cbeca4e50a3c8e$var$symbolProto = (0, $7Kr41.default) ? (0, $7Kr41.default).prototype : undefined, $51cbeca4e50a3c8e$var$symbolValueOf = $51cbeca4e50a3c8e$var$symbolProto ? $51cbeca4e50a3c8e$var$symbolProto.valueOf : undefined;
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $51cbeca4e50a3c8e$var$equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case $51cbeca4e50a3c8e$var$dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case $51cbeca4e50a3c8e$var$arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new (0, $h4O8Z.default)(object), new (0, $h4O8Z.default)(other))) return false;
            return true;
        case $51cbeca4e50a3c8e$var$boolTag:
        case $51cbeca4e50a3c8e$var$dateTag:
        case $51cbeca4e50a3c8e$var$numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return (0, $kuJus.default)(+object, +other);
        case $51cbeca4e50a3c8e$var$errorTag:
            return object.name == other.name && object.message == other.message;
        case $51cbeca4e50a3c8e$var$regexpTag:
        case $51cbeca4e50a3c8e$var$stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + "";
        case $51cbeca4e50a3c8e$var$mapTag:
            var convert = (0, $4040W.default);
        case $51cbeca4e50a3c8e$var$setTag:
            var isPartial = bitmask & $51cbeca4e50a3c8e$var$COMPARE_PARTIAL_FLAG;
            convert || (convert = (0, $ixgtc.default));
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= $51cbeca4e50a3c8e$var$COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = (0, $8IXLZ.default)(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack["delete"](object);
            return result;
        case $51cbeca4e50a3c8e$var$symbolTag:
            if ($51cbeca4e50a3c8e$var$symbolValueOf) return $51cbeca4e50a3c8e$var$symbolValueOf.call(object) == $51cbeca4e50a3c8e$var$symbolValueOf.call(other);
    }
    return false;
}
var $51cbeca4e50a3c8e$export$2e2bcd8739ae039 = $51cbeca4e50a3c8e$var$equalByTag;

});
parcelRegister("4040W", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2e9a469ffc51ef28$export$2e2bcd8739ae039; });
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function $2e9a469ffc51ef28$var$mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
var $2e9a469ffc51ef28$export$2e2bcd8739ae039 = $2e9a469ffc51ef28$var$mapToArray;

});

parcelRegister("ixgtc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d7e815a53300e7ef$export$2e2bcd8739ae039; });
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function $d7e815a53300e7ef$var$setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
var $d7e815a53300e7ef$export$2e2bcd8739ae039 = $d7e815a53300e7ef$var$setToArray;

});


parcelRegister("99Ql6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6aad8dd5844a80b2$export$2e2bcd8739ae039; });

var $5RdOE = parcelRequire("5RdOE");
/** Used to compose bitmasks for value comparisons. */ var $6aad8dd5844a80b2$var$COMPARE_PARTIAL_FLAG = 1;
/** Used for built-in method references. */ var $6aad8dd5844a80b2$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $6aad8dd5844a80b2$var$hasOwnProperty = $6aad8dd5844a80b2$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $6aad8dd5844a80b2$var$equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $6aad8dd5844a80b2$var$COMPARE_PARTIAL_FLAG, objProps = (0, $5RdOE.default)(object), objLength = objProps.length, othProps = (0, $5RdOE.default)(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : $6aad8dd5844a80b2$var$hasOwnProperty.call(other, key))) return false;
    }
    // Check that cyclic values are equal.
    var objStacked = stack.get(object);
    var othStacked = stack.get(other);
    if (objStacked && othStacked) return objStacked == other && othStacked == object;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == "constructor");
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && "constructor" in object && "constructor" in other && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) result = false;
    }
    stack["delete"](object);
    stack["delete"](other);
    return result;
}
var $6aad8dd5844a80b2$export$2e2bcd8739ae039 = $6aad8dd5844a80b2$var$equalObjects;

});
parcelRegister("5RdOE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $443c9e920004bef7$export$2e2bcd8739ae039; });

var $gMqPm = parcelRequire("gMqPm");

var $f2cuc = parcelRequire("f2cuc");

var $4WqMj = parcelRequire("4WqMj");
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $443c9e920004bef7$var$getAllKeys(object) {
    return (0, $gMqPm.default)(object, (0, $4WqMj.default), (0, $f2cuc.default));
}
var $443c9e920004bef7$export$2e2bcd8739ae039 = $443c9e920004bef7$var$getAllKeys;

});
parcelRegister("gMqPm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c375f0615d6af45e$export$2e2bcd8739ae039; });

var $ayQ85 = parcelRequire("ayQ85");

var $o0x3M = parcelRequire("o0x3M");
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $c375f0615d6af45e$var$baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return (0, $o0x3M.default)(object) ? result : (0, $ayQ85.default)(result, symbolsFunc(object));
}
var $c375f0615d6af45e$export$2e2bcd8739ae039 = $c375f0615d6af45e$var$baseGetAllKeys;

});
parcelRegister("ayQ85", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $01fbf5bea9de21d8$export$2e2bcd8739ae039; });
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function $01fbf5bea9de21d8$var$arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
var $01fbf5bea9de21d8$export$2e2bcd8739ae039 = $01fbf5bea9de21d8$var$arrayPush;

});


parcelRegister("f2cuc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $af20ba618912d99a$export$2e2bcd8739ae039; });

var $52hkV = parcelRequire("52hkV");

var $e6rP6 = parcelRequire("e6rP6");
/** Used for built-in method references. */ var $af20ba618912d99a$var$objectProto = Object.prototype;
/** Built-in value references. */ var $af20ba618912d99a$var$propertyIsEnumerable = $af20ba618912d99a$var$objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $af20ba618912d99a$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $af20ba618912d99a$var$getSymbols = !$af20ba618912d99a$var$nativeGetSymbols ? (0, $e6rP6.default) : function(object) {
    if (object == null) return [];
    object = Object(object);
    return (0, $52hkV.default)($af20ba618912d99a$var$nativeGetSymbols(object), function(symbol) {
        return $af20ba618912d99a$var$propertyIsEnumerable.call(object, symbol);
    });
};
var $af20ba618912d99a$export$2e2bcd8739ae039 = $af20ba618912d99a$var$getSymbols;

});
parcelRegister("52hkV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3aaa964ec501a7d3$export$2e2bcd8739ae039; });
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $3aaa964ec501a7d3$var$arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
var $3aaa964ec501a7d3$export$2e2bcd8739ae039 = $3aaa964ec501a7d3$var$arrayFilter;

});

parcelRegister("e6rP6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a447355209f603cc$export$2e2bcd8739ae039; });
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function $a447355209f603cc$var$stubArray() {
    return [];
}
var $a447355209f603cc$export$2e2bcd8739ae039 = $a447355209f603cc$var$stubArray;

});




parcelRegister("4lAdM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $32a53861144c518f$export$2e2bcd8739ae039; });

var $iscIj = parcelRequire("iscIj");

var $3dqC1 = parcelRequire("3dqC1");

var $20Mw1 = parcelRequire("20Mw1");

var $hXLai = parcelRequire("hXLai");

var $7bXiO = parcelRequire("7bXiO");

var $e8qHT = parcelRequire("e8qHT");

var $4yWcy = parcelRequire("4yWcy");
/** `Object#toString` result references. */ var $32a53861144c518f$var$mapTag = "[object Map]", $32a53861144c518f$var$objectTag = "[object Object]", $32a53861144c518f$var$promiseTag = "[object Promise]", $32a53861144c518f$var$setTag = "[object Set]", $32a53861144c518f$var$weakMapTag = "[object WeakMap]";
var $32a53861144c518f$var$dataViewTag = "[object DataView]";
/** Used to detect maps, sets, and weakmaps. */ var $32a53861144c518f$var$dataViewCtorString = (0, $4yWcy.default)((0, $iscIj.default)), $32a53861144c518f$var$mapCtorString = (0, $4yWcy.default)((0, $3dqC1.default)), $32a53861144c518f$var$promiseCtorString = (0, $4yWcy.default)((0, $20Mw1.default)), $32a53861144c518f$var$setCtorString = (0, $4yWcy.default)((0, $hXLai.default)), $32a53861144c518f$var$weakMapCtorString = (0, $4yWcy.default)((0, $7bXiO.default));
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var $32a53861144c518f$var$getTag = (0, $e8qHT.default);
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((0, $iscIj.default) && $32a53861144c518f$var$getTag(new (0, $iscIj.default)(new ArrayBuffer(1))) != $32a53861144c518f$var$dataViewTag || (0, $3dqC1.default) && $32a53861144c518f$var$getTag(new (0, $3dqC1.default)) != $32a53861144c518f$var$mapTag || (0, $20Mw1.default) && $32a53861144c518f$var$getTag((0, $20Mw1.default).resolve()) != $32a53861144c518f$var$promiseTag || (0, $hXLai.default) && $32a53861144c518f$var$getTag(new (0, $hXLai.default)) != $32a53861144c518f$var$setTag || (0, $7bXiO.default) && $32a53861144c518f$var$getTag(new (0, $7bXiO.default)) != $32a53861144c518f$var$weakMapTag) $32a53861144c518f$var$getTag = function(value) {
    var result = (0, $e8qHT.default)(value), Ctor = result == $32a53861144c518f$var$objectTag ? value.constructor : undefined, ctorString = Ctor ? (0, $4yWcy.default)(Ctor) : "";
    if (ctorString) switch(ctorString){
        case $32a53861144c518f$var$dataViewCtorString:
            return $32a53861144c518f$var$dataViewTag;
        case $32a53861144c518f$var$mapCtorString:
            return $32a53861144c518f$var$mapTag;
        case $32a53861144c518f$var$promiseCtorString:
            return $32a53861144c518f$var$promiseTag;
        case $32a53861144c518f$var$setCtorString:
            return $32a53861144c518f$var$setTag;
        case $32a53861144c518f$var$weakMapCtorString:
            return $32a53861144c518f$var$weakMapTag;
    }
    return result;
};
var $32a53861144c518f$export$2e2bcd8739ae039 = $32a53861144c518f$var$getTag;

});
parcelRegister("iscIj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d6f4b42f12b91728$export$2e2bcd8739ae039; });

var $1aTGj = parcelRequire("1aTGj");

var $ier4x = parcelRequire("ier4x");
/* Built-in method references that are verified to be native. */ var $d6f4b42f12b91728$var$DataView = (0, $1aTGj.default)((0, $ier4x.default), "DataView");
var $d6f4b42f12b91728$export$2e2bcd8739ae039 = $d6f4b42f12b91728$var$DataView;

});

parcelRegister("20Mw1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $17713701cee9027b$export$2e2bcd8739ae039; });

var $1aTGj = parcelRequire("1aTGj");

var $ier4x = parcelRequire("ier4x");
/* Built-in method references that are verified to be native. */ var $17713701cee9027b$var$Promise = (0, $1aTGj.default)((0, $ier4x.default), "Promise");
var $17713701cee9027b$export$2e2bcd8739ae039 = $17713701cee9027b$var$Promise;

});

parcelRegister("hXLai", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d13c8861af0aab68$export$2e2bcd8739ae039; });

var $1aTGj = parcelRequire("1aTGj");

var $ier4x = parcelRequire("ier4x");
/* Built-in method references that are verified to be native. */ var $d13c8861af0aab68$var$Set = (0, $1aTGj.default)((0, $ier4x.default), "Set");
var $d13c8861af0aab68$export$2e2bcd8739ae039 = $d13c8861af0aab68$var$Set;

});

parcelRegister("7bXiO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $53c78fb67aa34365$export$2e2bcd8739ae039; });

var $1aTGj = parcelRequire("1aTGj");

var $ier4x = parcelRequire("ier4x");
/* Built-in method references that are verified to be native. */ var $53c78fb67aa34365$var$WeakMap = (0, $1aTGj.default)((0, $ier4x.default), "WeakMap");
var $53c78fb67aa34365$export$2e2bcd8739ae039 = $53c78fb67aa34365$var$WeakMap;

});





parcelRegister("7q21S", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $566c891b79b6828a$export$2e2bcd8739ae039; });

var $5V8mN = parcelRequire("5V8mN");

var $4WqMj = parcelRequire("4WqMj");
/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */ function $566c891b79b6828a$var$getMatchData(object) {
    var result = (0, $4WqMj.default)(object), length = result.length;
    while(length--){
        var key = result[length], value = object[key];
        result[length] = [
            key,
            value,
            (0, $5V8mN.default)(value)
        ];
    }
    return result;
}
var $566c891b79b6828a$export$2e2bcd8739ae039 = $566c891b79b6828a$var$getMatchData;

});
parcelRegister("5V8mN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $44f8c4132346397a$export$2e2bcd8739ae039; });

var $3dn92 = parcelRequire("3dn92");
/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */ function $44f8c4132346397a$var$isStrictComparable(value) {
    return value === value && !(0, $3dn92.default)(value);
}
var $44f8c4132346397a$export$2e2bcd8739ae039 = $44f8c4132346397a$var$isStrictComparable;

});


parcelRegister("aPy9x", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7e2928d27c1c6b04$export$2e2bcd8739ae039; });
/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $7e2928d27c1c6b04$var$matchesStrictComparable(key, srcValue) {
    return function(object) {
        if (object == null) return false;
        return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
    };
}
var $7e2928d27c1c6b04$export$2e2bcd8739ae039 = $7e2928d27c1c6b04$var$matchesStrictComparable;

});


parcelRegister("3z11V", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $29857086473d0bac$export$2e2bcd8739ae039; });

var $94D7E = parcelRequire("94D7E");

var $6vWnn = parcelRequire("6vWnn");

var $7kipD = parcelRequire("7kipD");

var $9ydwM = parcelRequire("9ydwM");

var $5V8mN = parcelRequire("5V8mN");

var $aPy9x = parcelRequire("aPy9x");

var $d1wfx = parcelRequire("d1wfx");
/** Used to compose bitmasks for value comparisons. */ var $29857086473d0bac$var$COMPARE_PARTIAL_FLAG = 1, $29857086473d0bac$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $29857086473d0bac$var$baseMatchesProperty(path, srcValue) {
    if ((0, $9ydwM.default)(path) && (0, $5V8mN.default)(srcValue)) return (0, $aPy9x.default)((0, $d1wfx.default)(path), srcValue);
    return function(object) {
        var objValue = (0, $6vWnn.default)(object, path);
        return objValue === undefined && objValue === srcValue ? (0, $7kipD.default)(object, path) : (0, $94D7E.default)(srcValue, objValue, $29857086473d0bac$var$COMPARE_PARTIAL_FLAG | $29857086473d0bac$var$COMPARE_UNORDERED_FLAG);
    };
}
var $29857086473d0bac$export$2e2bcd8739ae039 = $29857086473d0bac$var$baseMatchesProperty;

});
parcelRegister("6vWnn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4be2eb93a1c90874$export$2e2bcd8739ae039; });

var $lW0BI = parcelRequire("lW0BI");
/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function $4be2eb93a1c90874$var$get(object, path, defaultValue) {
    var result = object == null ? undefined : (0, $lW0BI.default)(object, path);
    return result === undefined ? defaultValue : result;
}
var $4be2eb93a1c90874$export$2e2bcd8739ae039 = $4be2eb93a1c90874$var$get;

});
parcelRegister("lW0BI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ff7f7c54696f3270$export$2e2bcd8739ae039; });

var $iYV2i = parcelRequire("iYV2i");

var $d1wfx = parcelRequire("d1wfx");
/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function $ff7f7c54696f3270$var$baseGet(object, path) {
    path = (0, $iYV2i.default)(path, object);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[(0, $d1wfx.default)(path[index++])];
    return index && index == length ? object : undefined;
}
var $ff7f7c54696f3270$export$2e2bcd8739ae039 = $ff7f7c54696f3270$var$baseGet;

});
parcelRegister("iYV2i", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dd1a12c381fa2ff6$export$2e2bcd8739ae039; });

var $o0x3M = parcelRequire("o0x3M");

var $9ydwM = parcelRequire("9ydwM");

var $cRICQ = parcelRequire("cRICQ");

var $5iOkf = parcelRequire("5iOkf");
/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */ function $dd1a12c381fa2ff6$var$castPath(value, object) {
    if ((0, $o0x3M.default)(value)) return value;
    return (0, $9ydwM.default)(value, object) ? [
        value
    ] : (0, $cRICQ.default)((0, $5iOkf.default)(value));
}
var $dd1a12c381fa2ff6$export$2e2bcd8739ae039 = $dd1a12c381fa2ff6$var$castPath;

});
parcelRegister("9ydwM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6f41c85803132900$export$2e2bcd8739ae039; });

var $o0x3M = parcelRequire("o0x3M");

var $9XbCp = parcelRequire("9XbCp");
/** Used to match property names within property paths. */ var $6f41c85803132900$var$reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, $6f41c85803132900$var$reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function $6f41c85803132900$var$isKey(value, object) {
    if ((0, $o0x3M.default)(value)) return false;
    var type = typeof value;
    if (type == "number" || type == "symbol" || type == "boolean" || value == null || (0, $9XbCp.default)(value)) return true;
    return $6f41c85803132900$var$reIsPlainProp.test(value) || !$6f41c85803132900$var$reIsDeepProp.test(value) || object != null && value in Object(object);
}
var $6f41c85803132900$export$2e2bcd8739ae039 = $6f41c85803132900$var$isKey;

});

parcelRegister("cRICQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $95dd0cfd74ae7e61$export$2e2bcd8739ae039; });

var $5rdNy = parcelRequire("5rdNy");
/** Used to match property names within property paths. */ var $95dd0cfd74ae7e61$var$rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var $95dd0cfd74ae7e61$var$reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $95dd0cfd74ae7e61$var$stringToPath = (0, $5rdNy.default)(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push("");
    string.replace($95dd0cfd74ae7e61$var$rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace($95dd0cfd74ae7e61$var$reEscapeChar, "$1") : number || match);
    });
    return result;
});
var $95dd0cfd74ae7e61$export$2e2bcd8739ae039 = $95dd0cfd74ae7e61$var$stringToPath;

});
parcelRegister("5rdNy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3f5a2d6b19ac800f$export$2e2bcd8739ae039; });

var $kh5yB = parcelRequire("kh5yB");
/** Used as the maximum memoize cache size. */ var $3f5a2d6b19ac800f$var$MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function $3f5a2d6b19ac800f$var$memoizeCapped(func) {
    var result = (0, $kh5yB.default)(func, function(key) {
        if (cache.size === $3f5a2d6b19ac800f$var$MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
var $3f5a2d6b19ac800f$export$2e2bcd8739ae039 = $3f5a2d6b19ac800f$var$memoizeCapped;

});
parcelRegister("kh5yB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ec29b4b25185964a$export$2e2bcd8739ae039; });

var $5bIkI = parcelRequire("5bIkI");
/** Error message constants. */ var $ec29b4b25185964a$var$FUNC_ERROR_TEXT = "Expected a function";
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function $ec29b4b25185964a$var$memoize(func, resolver) {
    if (typeof func != "function" || resolver != null && typeof resolver != "function") throw new TypeError($ec29b4b25185964a$var$FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new ($ec29b4b25185964a$var$memoize.Cache || (0, $5bIkI.default));
    return memoized;
}
// Expose `MapCache`.
$ec29b4b25185964a$var$memoize.Cache = (0, $5bIkI.default);
var $ec29b4b25185964a$export$2e2bcd8739ae039 = $ec29b4b25185964a$var$memoize;

});



parcelRegister("5iOkf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3dc5abcda995063b$export$2e2bcd8739ae039; });

var $gdOgq = parcelRequire("gdOgq");
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $3dc5abcda995063b$var$toString(value) {
    return value == null ? "" : (0, $gdOgq.default)(value);
}
var $3dc5abcda995063b$export$2e2bcd8739ae039 = $3dc5abcda995063b$var$toString;

});
parcelRegister("gdOgq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bcf4d99f1e71c34d$export$2e2bcd8739ae039; });

var $7Kr41 = parcelRequire("7Kr41");

var $899UF = parcelRequire("899UF");

var $o0x3M = parcelRequire("o0x3M");

var $9XbCp = parcelRequire("9XbCp");
/** Used as references for various `Number` constants. */ var $bcf4d99f1e71c34d$var$INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var $bcf4d99f1e71c34d$var$symbolProto = (0, $7Kr41.default) ? (0, $7Kr41.default).prototype : undefined, $bcf4d99f1e71c34d$var$symbolToString = $bcf4d99f1e71c34d$var$symbolProto ? $bcf4d99f1e71c34d$var$symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $bcf4d99f1e71c34d$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == "string") return value;
    if ((0, $o0x3M.default)(value)) // Recursively convert values (susceptible to call stack limits).
    return (0, $899UF.default)(value, $bcf4d99f1e71c34d$var$baseToString) + "";
    if ((0, $9XbCp.default)(value)) return $bcf4d99f1e71c34d$var$symbolToString ? $bcf4d99f1e71c34d$var$symbolToString.call(value) : "";
    var result = value + "";
    return result == "0" && 1 / value == -$bcf4d99f1e71c34d$var$INFINITY ? "-0" : result;
}
var $bcf4d99f1e71c34d$export$2e2bcd8739ae039 = $bcf4d99f1e71c34d$var$baseToString;

});



parcelRegister("d1wfx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $97b4626f534b31ab$export$2e2bcd8739ae039; });

var $9XbCp = parcelRequire("9XbCp");
/** Used as references for various `Number` constants. */ var $97b4626f534b31ab$var$INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function $97b4626f534b31ab$var$toKey(value) {
    if (typeof value == "string" || (0, $9XbCp.default)(value)) return value;
    var result = value + "";
    return result == "0" && 1 / value == -$97b4626f534b31ab$var$INFINITY ? "-0" : result;
}
var $97b4626f534b31ab$export$2e2bcd8739ae039 = $97b4626f534b31ab$var$toKey;

});



parcelRegister("7kipD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5558af032a8e9bb9$export$2e2bcd8739ae039; });

var $eonoW = parcelRequire("eonoW");

var $iVmbK = parcelRequire("iVmbK");
/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */ function $5558af032a8e9bb9$var$hasIn(object, path) {
    return object != null && (0, $iVmbK.default)(object, path, (0, $eonoW.default));
}
var $5558af032a8e9bb9$export$2e2bcd8739ae039 = $5558af032a8e9bb9$var$hasIn;

});
parcelRegister("eonoW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a7a5759331ec2de2$export$2e2bcd8739ae039; });
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function $a7a5759331ec2de2$var$baseHasIn(object, key) {
    return object != null && key in Object(object);
}
var $a7a5759331ec2de2$export$2e2bcd8739ae039 = $a7a5759331ec2de2$var$baseHasIn;

});

parcelRegister("iVmbK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dc6ec30dfc7e0e95$export$2e2bcd8739ae039; });

var $iYV2i = parcelRequire("iYV2i");

var $lRAEc = parcelRequire("lRAEc");

var $o0x3M = parcelRequire("o0x3M");

var $FEUHH = parcelRequire("FEUHH");

var $ealNX = parcelRequire("ealNX");

var $d1wfx = parcelRequire("d1wfx");
/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */ function $dc6ec30dfc7e0e95$var$hasPath(object, path, hasFunc) {
    path = (0, $iYV2i.default)(path, object);
    var index = -1, length = path.length, result = false;
    while(++index < length){
        var key = (0, $d1wfx.default)(path[index]);
        if (!(result = object != null && hasFunc(object, key))) break;
        object = object[key];
    }
    if (result || ++index != length) return result;
    length = object == null ? 0 : object.length;
    return !!length && (0, $ealNX.default)(length) && (0, $FEUHH.default)(key, length) && ((0, $o0x3M.default)(object) || (0, $lRAEc.default)(object));
}
var $dc6ec30dfc7e0e95$export$2e2bcd8739ae039 = $dc6ec30dfc7e0e95$var$hasPath;

});



parcelRegister("ejCIm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a6c0deee1099fb08$export$2e2bcd8739ae039; });

var $dNu9P = parcelRequire("dNu9P");

var $iQa6G = parcelRequire("iQa6G");

var $9ydwM = parcelRequire("9ydwM");

var $d1wfx = parcelRequire("d1wfx");
/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */ function $a6c0deee1099fb08$var$property(path) {
    return (0, $9ydwM.default)(path) ? (0, $dNu9P.default)((0, $d1wfx.default)(path)) : (0, $iQa6G.default)(path);
}
var $a6c0deee1099fb08$export$2e2bcd8739ae039 = $a6c0deee1099fb08$var$property;

});
parcelRegister("dNu9P", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a0b73e9a0ae139ea$export$2e2bcd8739ae039; });
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $a0b73e9a0ae139ea$var$baseProperty(key) {
    return function(object) {
        return object == null ? undefined : object[key];
    };
}
var $a0b73e9a0ae139ea$export$2e2bcd8739ae039 = $a0b73e9a0ae139ea$var$baseProperty;

});

parcelRegister("iQa6G", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $db74ec5683d6f882$export$2e2bcd8739ae039; });

var $lW0BI = parcelRequire("lW0BI");
/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $db74ec5683d6f882$var$basePropertyDeep(path) {
    return function(object) {
        return (0, $lW0BI.default)(object, path);
    };
}
var $db74ec5683d6f882$export$2e2bcd8739ae039 = $db74ec5683d6f882$var$basePropertyDeep;

});



parcelRegister("8M4V7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $66369f7bb6447a18$export$2e2bcd8739ae039; });

var $PDHVi = parcelRequire("PDHVi");

var $dHPlr = parcelRequire("dHPlr");
/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $66369f7bb6447a18$var$baseMap(collection, iteratee) {
    var index = -1, result = (0, $dHPlr.default)(collection) ? Array(collection.length) : [];
    (0, $PDHVi.default)(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
    });
    return result;
}
var $66369f7bb6447a18$export$2e2bcd8739ae039 = $66369f7bb6447a18$var$baseMap;

});




parcelRegister("gkeQO", function(module, exports) {

var $eeH7J = parcelRequire("eeH7J");

var $4yBem = parcelRequire("4yBem");

var $bJBxw = parcelRequire("bJBxw");

var $5UnTd = parcelRequire("5UnTd");

var $5VQgV = parcelRequire("5VQgV");

var $1tumo = parcelRequire("1tumo");
parcelRequire("isDZf");
var $8bUgk = parcelRequire("8bUgk");

var $d82Dn = parcelRequire("d82Dn");
var $be2a08abfb8069f9$export$c89a927ffc67e6fa = function Circle(_ref) {
    var width = _ref.width, onChange = _ref.onChange, onSwatchHover = _ref.onSwatchHover, colors = _ref.colors, hex = _ref.hex, circleSize = _ref.circleSize, _ref$styles = _ref.styles, passedStyles = _ref$styles === undefined ? {} : _ref$styles, circleSpacing = _ref.circleSpacing, _ref$className = _ref.className, className = _ref$className === undefined ? "" : _ref$className;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($bJBxw)))((0, $5VQgV.default)({
        "default": {
            card: {
                width: width,
                display: "flex",
                flexWrap: "wrap",
                marginRight: -circleSpacing,
                marginBottom: -circleSpacing
            }
        }
    }, passedStyles));
    var handleChange = function handleChange(hexCode, e) {
        return onChange({
            hex: hexCode,
            source: "hex"
        }, e);
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        style: styles.card,
        className: "circle-picker " + className
    }, (0, $5UnTd.default)(colors, function(c) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $d82Dn.default), {
            key: c,
            color: c,
            onClick: handleChange,
            onSwatchHover: onSwatchHover,
            active: hex === c.toLowerCase(),
            circleSize: circleSize,
            circleSpacing: circleSpacing
        });
    }));
};
$be2a08abfb8069f9$export$c89a927ffc67e6fa.propTypes = {
    width: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).number
    ]),
    circleSize: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).number,
    circleSpacing: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).number,
    styles: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object
};
$be2a08abfb8069f9$export$c89a927ffc67e6fa.defaultProps = {
    width: 252,
    circleSize: 28,
    circleSpacing: 14,
    colors: [
        $1tumo.red["500"],
        $1tumo.pink["500"],
        $1tumo.purple["500"],
        $1tumo.deepPurple["500"],
        $1tumo.indigo["500"],
        $1tumo.blue["500"],
        $1tumo.lightBlue["500"],
        $1tumo.cyan["500"],
        $1tumo.teal["500"],
        $1tumo.green["500"],
        $1tumo.lightGreen["500"],
        $1tumo.lime["500"],
        $1tumo.yellow["500"],
        $1tumo.amber["500"],
        $1tumo.orange["500"],
        $1tumo.deepOrange["500"],
        $1tumo.brown["500"],
        $1tumo.blueGrey["500"]
    ],
    styles: {}
};
var $be2a08abfb8069f9$export$2e2bcd8739ae039 = (0, $8bUgk.default)($be2a08abfb8069f9$export$c89a927ffc67e6fa);

});
parcelRegister("1tumo", function(module, exports) {

$parcel$export(module.exports, "red", function () { return $11300cc8beffd7e4$export$a90204d1394caf30; });
$parcel$export(module.exports, "pink", function () { return $11300cc8beffd7e4$export$47853bc718611763; });
$parcel$export(module.exports, "purple", function () { return $11300cc8beffd7e4$export$e13cce2a2d16a9d4; });
$parcel$export(module.exports, "deepPurple", function () { return $11300cc8beffd7e4$export$51ef95b19086af57; });
$parcel$export(module.exports, "indigo", function () { return $11300cc8beffd7e4$export$3e6ccc7b8562d453; });
$parcel$export(module.exports, "blue", function () { return $11300cc8beffd7e4$export$2aa0182783e7e9de; });
$parcel$export(module.exports, "lightBlue", function () { return $11300cc8beffd7e4$export$7b0d29b70b435c21; });
$parcel$export(module.exports, "cyan", function () { return $11300cc8beffd7e4$export$7474046f446842ee; });
$parcel$export(module.exports, "teal", function () { return $11300cc8beffd7e4$export$8bf7dff220b82b4a; });
$parcel$export(module.exports, "green", function () { return $11300cc8beffd7e4$export$955a2ebd2fb142ae; });
$parcel$export(module.exports, "lightGreen", function () { return $11300cc8beffd7e4$export$559a8c00376dc936; });
$parcel$export(module.exports, "lime", function () { return $11300cc8beffd7e4$export$221d31baf2636aad; });
$parcel$export(module.exports, "yellow", function () { return $11300cc8beffd7e4$export$594c5a8758200c32; });
$parcel$export(module.exports, "amber", function () { return $11300cc8beffd7e4$export$7c1ecc66643fdbd6; });
$parcel$export(module.exports, "orange", function () { return $11300cc8beffd7e4$export$ad766f34ace1cafd; });
$parcel$export(module.exports, "deepOrange", function () { return $11300cc8beffd7e4$export$1ceed3dd9ec11704; });
$parcel$export(module.exports, "brown", function () { return $11300cc8beffd7e4$export$b6e6178d3f565007; });
$parcel$export(module.exports, "blueGrey", function () { return $11300cc8beffd7e4$export$7c2da42d08c019c9; });
var $11300cc8beffd7e4$export$a90204d1394caf30 = {
    "50": "#ffebee",
    "100": "#ffcdd2",
    "200": "#ef9a9a",
    "300": "#e57373",
    "400": "#ef5350",
    "500": "#f44336",
    "600": "#e53935",
    "700": "#d32f2f",
    "800": "#c62828",
    "900": "#b71c1c",
    "a100": "#ff8a80",
    "a200": "#ff5252",
    "a400": "#ff1744",
    "a700": "#d50000"
};
var $11300cc8beffd7e4$export$47853bc718611763 = {
    "50": "#fce4ec",
    "100": "#f8bbd0",
    "200": "#f48fb1",
    "300": "#f06292",
    "400": "#ec407a",
    "500": "#e91e63",
    "600": "#d81b60",
    "700": "#c2185b",
    "800": "#ad1457",
    "900": "#880e4f",
    "a100": "#ff80ab",
    "a200": "#ff4081",
    "a400": "#f50057",
    "a700": "#c51162"
};
var $11300cc8beffd7e4$export$e13cce2a2d16a9d4 = {
    "50": "#f3e5f5",
    "100": "#e1bee7",
    "200": "#ce93d8",
    "300": "#ba68c8",
    "400": "#ab47bc",
    "500": "#9c27b0",
    "600": "#8e24aa",
    "700": "#7b1fa2",
    "800": "#6a1b9a",
    "900": "#4a148c",
    "a100": "#ea80fc",
    "a200": "#e040fb",
    "a400": "#d500f9",
    "a700": "#aa00ff"
};
var $11300cc8beffd7e4$export$51ef95b19086af57 = {
    "50": "#ede7f6",
    "100": "#d1c4e9",
    "200": "#b39ddb",
    "300": "#9575cd",
    "400": "#7e57c2",
    "500": "#673ab7",
    "600": "#5e35b1",
    "700": "#512da8",
    "800": "#4527a0",
    "900": "#311b92",
    "a100": "#b388ff",
    "a200": "#7c4dff",
    "a400": "#651fff",
    "a700": "#6200ea"
};
var $11300cc8beffd7e4$export$3e6ccc7b8562d453 = {
    "50": "#e8eaf6",
    "100": "#c5cae9",
    "200": "#9fa8da",
    "300": "#7986cb",
    "400": "#5c6bc0",
    "500": "#3f51b5",
    "600": "#3949ab",
    "700": "#303f9f",
    "800": "#283593",
    "900": "#1a237e",
    "a100": "#8c9eff",
    "a200": "#536dfe",
    "a400": "#3d5afe",
    "a700": "#304ffe"
};
var $11300cc8beffd7e4$export$2aa0182783e7e9de = {
    "50": "#e3f2fd",
    "100": "#bbdefb",
    "200": "#90caf9",
    "300": "#64b5f6",
    "400": "#42a5f5",
    "500": "#2196f3",
    "600": "#1e88e5",
    "700": "#1976d2",
    "800": "#1565c0",
    "900": "#0d47a1",
    "a100": "#82b1ff",
    "a200": "#448aff",
    "a400": "#2979ff",
    "a700": "#2962ff"
};
var $11300cc8beffd7e4$export$7b0d29b70b435c21 = {
    "50": "#e1f5fe",
    "100": "#b3e5fc",
    "200": "#81d4fa",
    "300": "#4fc3f7",
    "400": "#29b6f6",
    "500": "#03a9f4",
    "600": "#039be5",
    "700": "#0288d1",
    "800": "#0277bd",
    "900": "#01579b",
    "a100": "#80d8ff",
    "a200": "#40c4ff",
    "a400": "#00b0ff",
    "a700": "#0091ea"
};
var $11300cc8beffd7e4$export$7474046f446842ee = {
    "50": "#e0f7fa",
    "100": "#b2ebf2",
    "200": "#80deea",
    "300": "#4dd0e1",
    "400": "#26c6da",
    "500": "#00bcd4",
    "600": "#00acc1",
    "700": "#0097a7",
    "800": "#00838f",
    "900": "#006064",
    "a100": "#84ffff",
    "a200": "#18ffff",
    "a400": "#00e5ff",
    "a700": "#00b8d4"
};
var $11300cc8beffd7e4$export$8bf7dff220b82b4a = {
    "50": "#e0f2f1",
    "100": "#b2dfdb",
    "200": "#80cbc4",
    "300": "#4db6ac",
    "400": "#26a69a",
    "500": "#009688",
    "600": "#00897b",
    "700": "#00796b",
    "800": "#00695c",
    "900": "#004d40",
    "a100": "#a7ffeb",
    "a200": "#64ffda",
    "a400": "#1de9b6",
    "a700": "#00bfa5"
};
var $11300cc8beffd7e4$export$955a2ebd2fb142ae = {
    "50": "#e8f5e9",
    "100": "#c8e6c9",
    "200": "#a5d6a7",
    "300": "#81c784",
    "400": "#66bb6a",
    "500": "#4caf50",
    "600": "#43a047",
    "700": "#388e3c",
    "800": "#2e7d32",
    "900": "#1b5e20",
    "a100": "#b9f6ca",
    "a200": "#69f0ae",
    "a400": "#00e676",
    "a700": "#00c853"
};
var $11300cc8beffd7e4$export$559a8c00376dc936 = {
    "50": "#f1f8e9",
    "100": "#dcedc8",
    "200": "#c5e1a5",
    "300": "#aed581",
    "400": "#9ccc65",
    "500": "#8bc34a",
    "600": "#7cb342",
    "700": "#689f38",
    "800": "#558b2f",
    "900": "#33691e",
    "a100": "#ccff90",
    "a200": "#b2ff59",
    "a400": "#76ff03",
    "a700": "#64dd17"
};
var $11300cc8beffd7e4$export$221d31baf2636aad = {
    "50": "#f9fbe7",
    "100": "#f0f4c3",
    "200": "#e6ee9c",
    "300": "#dce775",
    "400": "#d4e157",
    "500": "#cddc39",
    "600": "#c0ca33",
    "700": "#afb42b",
    "800": "#9e9d24",
    "900": "#827717",
    "a100": "#f4ff81",
    "a200": "#eeff41",
    "a400": "#c6ff00",
    "a700": "#aeea00"
};
var $11300cc8beffd7e4$export$594c5a8758200c32 = {
    "50": "#fffde7",
    "100": "#fff9c4",
    "200": "#fff59d",
    "300": "#fff176",
    "400": "#ffee58",
    "500": "#ffeb3b",
    "600": "#fdd835",
    "700": "#fbc02d",
    "800": "#f9a825",
    "900": "#f57f17",
    "a100": "#ffff8d",
    "a200": "#ffff00",
    "a400": "#ffea00",
    "a700": "#ffd600"
};
var $11300cc8beffd7e4$export$7c1ecc66643fdbd6 = {
    "50": "#fff8e1",
    "100": "#ffecb3",
    "200": "#ffe082",
    "300": "#ffd54f",
    "400": "#ffca28",
    "500": "#ffc107",
    "600": "#ffb300",
    "700": "#ffa000",
    "800": "#ff8f00",
    "900": "#ff6f00",
    "a100": "#ffe57f",
    "a200": "#ffd740",
    "a400": "#ffc400",
    "a700": "#ffab00"
};
var $11300cc8beffd7e4$export$ad766f34ace1cafd = {
    "50": "#fff3e0",
    "100": "#ffe0b2",
    "200": "#ffcc80",
    "300": "#ffb74d",
    "400": "#ffa726",
    "500": "#ff9800",
    "600": "#fb8c00",
    "700": "#f57c00",
    "800": "#ef6c00",
    "900": "#e65100",
    "a100": "#ffd180",
    "a200": "#ffab40",
    "a400": "#ff9100",
    "a700": "#ff6d00"
};
var $11300cc8beffd7e4$export$1ceed3dd9ec11704 = {
    "50": "#fbe9e7",
    "100": "#ffccbc",
    "200": "#ffab91",
    "300": "#ff8a65",
    "400": "#ff7043",
    "500": "#ff5722",
    "600": "#f4511e",
    "700": "#e64a19",
    "800": "#d84315",
    "900": "#bf360c",
    "a100": "#ff9e80",
    "a200": "#ff6e40",
    "a400": "#ff3d00",
    "a700": "#dd2c00"
};
var $11300cc8beffd7e4$export$b6e6178d3f565007 = {
    "50": "#efebe9",
    "100": "#d7ccc8",
    "200": "#bcaaa4",
    "300": "#a1887f",
    "400": "#8d6e63",
    "500": "#795548",
    "600": "#6d4c41",
    "700": "#5d4037",
    "800": "#4e342e",
    "900": "#3e2723"
};
var $11300cc8beffd7e4$export$e4c89085febbc618 = {
    "50": "#fafafa",
    "100": "#f5f5f5",
    "200": "#eeeeee",
    "300": "#e0e0e0",
    "400": "#bdbdbd",
    "500": "#9e9e9e",
    "600": "#757575",
    "700": "#616161",
    "800": "#424242",
    "900": "#212121"
};
var $11300cc8beffd7e4$export$7c2da42d08c019c9 = {
    "50": "#eceff1",
    "100": "#cfd8dc",
    "200": "#b0bec5",
    "300": "#90a4ae",
    "400": "#78909c",
    "500": "#607d8b",
    "600": "#546e7a",
    "700": "#455a64",
    "800": "#37474f",
    "900": "#263238"
};
var $11300cc8beffd7e4$export$b413907788b50267 = {
    "primary": "rgba(0, 0, 0, 0.87)",
    "secondary": "rgba(0, 0, 0, 0.54)",
    "disabled": "rgba(0, 0, 0, 0.38)",
    "dividers": "rgba(0, 0, 0, 0.12)"
};
var $11300cc8beffd7e4$export$c962f8177a273028 = {
    "primary": "rgba(255, 255, 255, 1)",
    "secondary": "rgba(255, 255, 255, 0.7)",
    "disabled": "rgba(255, 255, 255, 0.5)",
    "dividers": "rgba(255, 255, 255, 0.12)"
};
var $11300cc8beffd7e4$export$969f6c634341b5cf = {
    "active": "rgba(0, 0, 0, 0.54)",
    "inactive": "rgba(0, 0, 0, 0.38)"
};
var $11300cc8beffd7e4$export$6b4a43519c60f4b1 = {
    "active": "rgba(255, 255, 255, 1)",
    "inactive": "rgba(255, 255, 255, 0.5)"
};
var $11300cc8beffd7e4$export$8fa4e5556fd77a60 = "#ffffff";
var $11300cc8beffd7e4$export$c073df10e766abfa = "#000000";
var $11300cc8beffd7e4$export$2e2bcd8739ae039 = {
    red: $11300cc8beffd7e4$export$a90204d1394caf30,
    pink: $11300cc8beffd7e4$export$47853bc718611763,
    purple: $11300cc8beffd7e4$export$e13cce2a2d16a9d4,
    deepPurple: $11300cc8beffd7e4$export$51ef95b19086af57,
    indigo: $11300cc8beffd7e4$export$3e6ccc7b8562d453,
    blue: $11300cc8beffd7e4$export$2aa0182783e7e9de,
    lightBlue: $11300cc8beffd7e4$export$7b0d29b70b435c21,
    cyan: $11300cc8beffd7e4$export$7474046f446842ee,
    teal: $11300cc8beffd7e4$export$8bf7dff220b82b4a,
    green: $11300cc8beffd7e4$export$955a2ebd2fb142ae,
    lightGreen: $11300cc8beffd7e4$export$559a8c00376dc936,
    lime: $11300cc8beffd7e4$export$221d31baf2636aad,
    yellow: $11300cc8beffd7e4$export$594c5a8758200c32,
    amber: $11300cc8beffd7e4$export$7c1ecc66643fdbd6,
    orange: $11300cc8beffd7e4$export$ad766f34ace1cafd,
    deepOrange: $11300cc8beffd7e4$export$1ceed3dd9ec11704,
    brown: $11300cc8beffd7e4$export$b6e6178d3f565007,
    grey: $11300cc8beffd7e4$export$e4c89085febbc618,
    blueGrey: $11300cc8beffd7e4$export$7c2da42d08c019c9,
    darkText: $11300cc8beffd7e4$export$b413907788b50267,
    lightText: $11300cc8beffd7e4$export$c962f8177a273028,
    darkIcons: $11300cc8beffd7e4$export$969f6c634341b5cf,
    lightIcons: $11300cc8beffd7e4$export$6b4a43519c60f4b1,
    white: $11300cc8beffd7e4$export$8fa4e5556fd77a60,
    black: $11300cc8beffd7e4$export$c073df10e766abfa
};

});

parcelRegister("d82Dn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $98ee10d15c5d76c7$export$2e2bcd8739ae039; });

var $eeH7J = parcelRequire("eeH7J");

var $bJBxw = parcelRequire("bJBxw");
parcelRequire("isDZf");
var $2DBoi = parcelRequire("2DBoi");
var $98ee10d15c5d76c7$export$945d5c8ebb42b0ff = function CircleSwatch(_ref) {
    var color = _ref.color, onClick = _ref.onClick, onSwatchHover = _ref.onSwatchHover, hover = _ref.hover, active = _ref.active, circleSize = _ref.circleSize, circleSpacing = _ref.circleSpacing;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($bJBxw)))({
        "default": {
            swatch: {
                width: circleSize,
                height: circleSize,
                marginRight: circleSpacing,
                marginBottom: circleSpacing,
                transform: "scale(1)",
                transition: "100ms transform ease"
            },
            Swatch: {
                borderRadius: "50%",
                background: "transparent",
                boxShadow: "inset 0 0 0 " + (circleSize / 2 + 1) + "px " + color,
                transition: "100ms box-shadow ease"
            }
        },
        "hover": {
            swatch: {
                transform: "scale(1.2)"
            }
        },
        "active": {
            Swatch: {
                boxShadow: "inset 0 0 0 3px " + color
            }
        }
    }, {
        hover: hover,
        active: active
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        style: styles.swatch
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $2DBoi.default), {
        style: styles.Swatch,
        color: color,
        onClick: onClick,
        onHover: onSwatchHover,
        focusStyle: {
            boxShadow: styles.Swatch.boxShadow + ", 0 0 5px " + color
        }
    }));
};
$98ee10d15c5d76c7$export$945d5c8ebb42b0ff.defaultProps = {
    circleSize: 28,
    circleSpacing: 14
};
var $98ee10d15c5d76c7$export$2e2bcd8739ae039 = (0, $bJBxw.handleHover)($98ee10d15c5d76c7$export$945d5c8ebb42b0ff);

});


parcelRegister("1qgBp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1095190821273845$export$2e2bcd8739ae039; });

var $eeH7J = parcelRequire("eeH7J");

var $4yBem = parcelRequire("4yBem");

var $bJBxw = parcelRequire("bJBxw");

var $5VQgV = parcelRequire("5VQgV");
parcelRequire("isDZf");
var $cydcQ = parcelRequire("cydcQ");
var $dZU3X = parcelRequire("dZU3X");
var $8bUgk = parcelRequire("8bUgk");
var $gnp1P = parcelRequire("gnp1P");
var $ejwzz = parcelRequire("ejwzz");

var $iG5Xd = parcelRequire("iG5Xd");

var $Rb7Sq = parcelRequire("Rb7Sq");

var $7O6D8 = parcelRequire("7O6D8");
var $1095190821273845$export$31a305e9779b48b4 = function Chrome(_ref) {
    var width = _ref.width, onChange = _ref.onChange, disableAlpha = _ref.disableAlpha, rgb = _ref.rgb, hsl = _ref.hsl, hsv = _ref.hsv, hex = _ref.hex, renderers = _ref.renderers, _ref$styles = _ref.styles, passedStyles = _ref$styles === undefined ? {} : _ref$styles, _ref$className = _ref.className, className = _ref$className === undefined ? "" : _ref$className, defaultView = _ref.defaultView;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($bJBxw)))((0, $5VQgV.default)({
        "default": {
            picker: {
                width: width,
                background: "#fff",
                borderRadius: "2px",
                boxShadow: "0 0 2px rgba(0,0,0,.3), 0 4px 8px rgba(0,0,0,.3)",
                boxSizing: "initial",
                fontFamily: "Menlo"
            },
            saturation: {
                width: "100%",
                paddingBottom: "55%",
                position: "relative",
                borderRadius: "2px 2px 0 0",
                overflow: "hidden"
            },
            Saturation: {
                radius: "2px 2px 0 0"
            },
            body: {
                padding: "16px 16px 12px"
            },
            controls: {
                display: "flex"
            },
            color: {
                width: "32px"
            },
            swatch: {
                marginTop: "6px",
                width: "16px",
                height: "16px",
                borderRadius: "8px",
                position: "relative",
                overflow: "hidden"
            },
            active: {
                absolute: "0px 0px 0px 0px",
                borderRadius: "8px",
                boxShadow: "inset 0 0 0 1px rgba(0,0,0,.1)",
                background: "rgba(" + rgb.r + ", " + rgb.g + ", " + rgb.b + ", " + rgb.a + ")",
                zIndex: "2"
            },
            toggles: {
                flex: "1"
            },
            hue: {
                height: "10px",
                position: "relative",
                marginBottom: "8px"
            },
            Hue: {
                radius: "2px"
            },
            alpha: {
                height: "10px",
                position: "relative"
            },
            Alpha: {
                radius: "2px"
            }
        },
        "disableAlpha": {
            color: {
                width: "22px"
            },
            alpha: {
                display: "none"
            },
            hue: {
                marginBottom: "0px"
            },
            swatch: {
                width: "10px",
                height: "10px",
                marginTop: "0px"
            }
        }
    }, passedStyles), {
        disableAlpha: disableAlpha
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        style: styles.picker,
        className: "chrome-picker " + className
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        style: styles.saturation
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $ejwzz.default), {
        style: styles.Saturation,
        hsl: hsl,
        hsv: hsv,
        pointer: (0, $7O6D8.default),
        onChange: onChange
    })), (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        style: styles.body
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        style: styles.controls,
        className: "flexbox-fix"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        style: styles.color
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        style: styles.swatch
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        style: styles.active
    }), (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $dZU3X.default), {
        renderers: renderers
    }))), (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        style: styles.toggles
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        style: styles.hue
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $gnp1P.default), {
        style: styles.Hue,
        hsl: hsl,
        pointer: (0, $Rb7Sq.default),
        onChange: onChange
    })), (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        style: styles.alpha
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $cydcQ.default), {
        style: styles.Alpha,
        rgb: rgb,
        hsl: hsl,
        pointer: (0, $Rb7Sq.default),
        renderers: renderers,
        onChange: onChange
    })))), (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $iG5Xd.default), {
        rgb: rgb,
        hsl: hsl,
        hex: hex,
        view: defaultView,
        onChange: onChange,
        disableAlpha: disableAlpha
    })));
};
$1095190821273845$export$31a305e9779b48b4.propTypes = {
    width: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).number
    ]),
    disableAlpha: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    styles: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
    defaultView: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOf([
        "hex",
        "rgb",
        "hsl"
    ])
};
$1095190821273845$export$31a305e9779b48b4.defaultProps = {
    width: 225,
    disableAlpha: false,
    styles: {}
};
var $1095190821273845$export$2e2bcd8739ae039 = (0, $8bUgk.default)($1095190821273845$export$31a305e9779b48b4);

});
parcelRegister("iG5Xd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d990c4981d985c8e$export$2e2bcd8739ae039; });

var $eeH7J = parcelRequire("eeH7J");

var $bJBxw = parcelRequire("bJBxw");

var $7Zkko = parcelRequire("7Zkko");

var $ezBMu = parcelRequire("ezBMu");
parcelRequire("isDZf");
var $a5dMh = parcelRequire("a5dMh");

var $5KLTU = parcelRequire("5KLTU");
var $d990c4981d985c8e$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function $d990c4981d985c8e$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $d990c4981d985c8e$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $d990c4981d985c8e$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $d990c4981d985c8e$export$71685d48a2432635 = function(_React$Component) {
    $d990c4981d985c8e$var$_inherits(ChromeFields, _React$Component);
    function ChromeFields(props) {
        $d990c4981d985c8e$var$_classCallCheck(this, ChromeFields);
        var _this = $d990c4981d985c8e$var$_possibleConstructorReturn(this, (ChromeFields.__proto__ || Object.getPrototypeOf(ChromeFields)).call(this));
        _this.toggleViews = function() {
            if (_this.state.view === "hex") _this.setState({
                view: "rgb"
            });
            else if (_this.state.view === "rgb") _this.setState({
                view: "hsl"
            });
            else if (_this.state.view === "hsl") {
                if (_this.props.hsl.a === 1) _this.setState({
                    view: "hex"
                });
                else _this.setState({
                    view: "rgb"
                });
            }
        };
        _this.handleChange = function(data, e) {
            if (data.hex) $7Zkko.isValidHex(data.hex) && _this.props.onChange({
                hex: data.hex,
                source: "hex"
            }, e);
            else if (data.r || data.g || data.b) _this.props.onChange({
                r: data.r || _this.props.rgb.r,
                g: data.g || _this.props.rgb.g,
                b: data.b || _this.props.rgb.b,
                source: "rgb"
            }, e);
            else if (data.a) {
                if (data.a < 0) data.a = 0;
                else if (data.a > 1) data.a = 1;
                _this.props.onChange({
                    h: _this.props.hsl.h,
                    s: _this.props.hsl.s,
                    l: _this.props.hsl.l,
                    a: Math.round(data.a * 100) / 100,
                    source: "rgb"
                }, e);
            } else if (data.h || data.s || data.l) {
                // Remove any occurances of '%'.
                if (typeof data.s === "string" && data.s.includes("%")) data.s = data.s.replace("%", "");
                if (typeof data.l === "string" && data.l.includes("%")) data.l = data.l.replace("%", "");
                // We store HSL as a unit interval so we need to override the 1 input to 0.01
                if (data.s == 1) data.s = 0.01;
                else if (data.l == 1) data.l = 0.01;
                _this.props.onChange({
                    h: data.h || _this.props.hsl.h,
                    s: Number(!(0, $ezBMu.default)(data.s) ? data.s : _this.props.hsl.s),
                    l: Number(!(0, $ezBMu.default)(data.l) ? data.l : _this.props.hsl.l),
                    source: "hsl"
                }, e);
            }
        };
        _this.showHighlight = function(e) {
            e.currentTarget.style.background = "#eee";
        };
        _this.hideHighlight = function(e) {
            e.currentTarget.style.background = "transparent";
        };
        if (props.hsl.a !== 1 && props.view === "hex") _this.state = {
            view: "rgb"
        };
        else _this.state = {
            view: props.view
        };
        return _this;
    }
    $d990c4981d985c8e$var$_createClass(ChromeFields, [
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var styles = (0, (/*@__PURE__*/$parcel$interopDefault($bJBxw)))({
                    "default": {
                        wrap: {
                            paddingTop: "16px",
                            display: "flex"
                        },
                        fields: {
                            flex: "1",
                            display: "flex",
                            marginLeft: "-6px"
                        },
                        field: {
                            paddingLeft: "6px",
                            width: "100%"
                        },
                        alpha: {
                            paddingLeft: "6px",
                            width: "100%"
                        },
                        toggle: {
                            width: "32px",
                            textAlign: "right",
                            position: "relative"
                        },
                        icon: {
                            marginRight: "-4px",
                            marginTop: "12px",
                            cursor: "pointer",
                            position: "relative"
                        },
                        iconHighlight: {
                            position: "absolute",
                            width: "24px",
                            height: "28px",
                            background: "#eee",
                            borderRadius: "4px",
                            top: "10px",
                            left: "12px",
                            display: "none"
                        },
                        input: {
                            fontSize: "11px",
                            color: "#333",
                            width: "100%",
                            borderRadius: "2px",
                            border: "none",
                            boxShadow: "inset 0 0 0 1px #dadada",
                            height: "21px",
                            textAlign: "center"
                        },
                        label: {
                            textTransform: "uppercase",
                            fontSize: "11px",
                            lineHeight: "11px",
                            color: "#969696",
                            textAlign: "center",
                            display: "block",
                            marginTop: "12px"
                        },
                        svg: {
                            fill: "#333",
                            width: "24px",
                            height: "24px",
                            border: "1px transparent solid",
                            borderRadius: "5px"
                        }
                    },
                    "disableAlpha": {
                        alpha: {
                            display: "none"
                        }
                    }
                }, this.props, this.state);
                var fields = void 0;
                if (this.state.view === "hex") fields = (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
                    style: styles.fields,
                    className: "flexbox-fix"
                }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
                    style: styles.field
                }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $a5dMh.default), {
                    style: {
                        input: styles.input,
                        label: styles.label
                    },
                    label: "hex",
                    value: this.props.hex,
                    onChange: this.handleChange
                })));
                else if (this.state.view === "rgb") fields = (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
                    style: styles.fields,
                    className: "flexbox-fix"
                }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
                    style: styles.field
                }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $a5dMh.default), {
                    style: {
                        input: styles.input,
                        label: styles.label
                    },
                    label: "r",
                    value: this.props.rgb.r,
                    onChange: this.handleChange
                })), (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
                    style: styles.field
                }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $a5dMh.default), {
                    style: {
                        input: styles.input,
                        label: styles.label
                    },
                    label: "g",
                    value: this.props.rgb.g,
                    onChange: this.handleChange
                })), (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
                    style: styles.field
                }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $a5dMh.default), {
                    style: {
                        input: styles.input,
                        label: styles.label
                    },
                    label: "b",
                    value: this.props.rgb.b,
                    onChange: this.handleChange
                })), (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
                    style: styles.alpha
                }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $a5dMh.default), {
                    style: {
                        input: styles.input,
                        label: styles.label
                    },
                    label: "a",
                    value: this.props.rgb.a,
                    arrowOffset: 0.01,
                    onChange: this.handleChange
                })));
                else if (this.state.view === "hsl") fields = (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
                    style: styles.fields,
                    className: "flexbox-fix"
                }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
                    style: styles.field
                }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $a5dMh.default), {
                    style: {
                        input: styles.input,
                        label: styles.label
                    },
                    label: "h",
                    value: Math.round(this.props.hsl.h),
                    onChange: this.handleChange
                })), (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
                    style: styles.field
                }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $a5dMh.default), {
                    style: {
                        input: styles.input,
                        label: styles.label
                    },
                    label: "s",
                    value: Math.round(this.props.hsl.s * 100) + "%",
                    onChange: this.handleChange
                })), (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
                    style: styles.field
                }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $a5dMh.default), {
                    style: {
                        input: styles.input,
                        label: styles.label
                    },
                    label: "l",
                    value: Math.round(this.props.hsl.l * 100) + "%",
                    onChange: this.handleChange
                })), (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
                    style: styles.alpha
                }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $a5dMh.default), {
                    style: {
                        input: styles.input,
                        label: styles.label
                    },
                    label: "a",
                    value: this.props.hsl.a,
                    arrowOffset: 0.01,
                    onChange: this.handleChange
                })));
                return (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
                    style: styles.wrap,
                    className: "flexbox-fix"
                }, fields, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
                    style: styles.toggle
                }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
                    style: styles.icon,
                    onClick: this.toggleViews,
                    ref: function ref(icon) {
                        return _this2.icon = icon;
                    }
                }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5KLTU))), {
                    style: styles.svg,
                    onMouseOver: this.showHighlight,
                    onMouseEnter: this.showHighlight,
                    onMouseOut: this.hideHighlight
                }))));
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(nextProps, state) {
                if (nextProps.hsl.a !== 1 && state.view === "hex") return {
                    view: "rgb"
                };
                return null;
            }
        }
    ]);
    return ChromeFields;
}((0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).Component);
$d990c4981d985c8e$export$71685d48a2432635.defaultProps = {
    view: "hex"
};
var $d990c4981d985c8e$export$2e2bcd8739ae039 = $d990c4981d985c8e$export$71685d48a2432635;

});
parcelRegister("ezBMu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a9c1a41f4206cc13$export$2e2bcd8739ae039; });
/**
 * Checks if `value` is `undefined`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
 * @example
 *
 * _.isUndefined(void 0);
 * // => true
 *
 * _.isUndefined(null);
 * // => false
 */ function $a9c1a41f4206cc13$var$isUndefined(value) {
    return value === undefined;
}
var $a9c1a41f4206cc13$export$2e2bcd8739ae039 = $a9c1a41f4206cc13$var$isUndefined;

});

parcelRegister("5KLTU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $430667b819e6d99a$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};

var $eeH7J = parcelRequire("eeH7J");
var $430667b819e6d99a$var$_react2 = $430667b819e6d99a$var$_interopRequireDefault($eeH7J);
function $430667b819e6d99a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $430667b819e6d99a$var$_objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
var $430667b819e6d99a$var$DEFAULT_SIZE = 24;
module.exports.default = function(_ref) {
    var _ref$fill = _ref.fill, fill = _ref$fill === undefined ? "currentColor" : _ref$fill, _ref$width = _ref.width, width = _ref$width === undefined ? $430667b819e6d99a$var$DEFAULT_SIZE : _ref$width, _ref$height = _ref.height, height = _ref$height === undefined ? $430667b819e6d99a$var$DEFAULT_SIZE : _ref$height, _ref$style = _ref.style, style = _ref$style === undefined ? {} : _ref$style, props = $430667b819e6d99a$var$_objectWithoutProperties(_ref, [
        "fill",
        "width",
        "height",
        "style"
    ]);
    return $430667b819e6d99a$var$_react2.default.createElement("svg", $430667b819e6d99a$var$_extends({
        viewBox: "0 0 " + $430667b819e6d99a$var$DEFAULT_SIZE + " " + $430667b819e6d99a$var$DEFAULT_SIZE,
        style: $430667b819e6d99a$var$_extends({
            fill: fill,
            width: width,
            height: height
        }, style)
    }, props), $430667b819e6d99a$var$_react2.default.createElement("path", {
        d: "M12,18.17L8.83,15L7.42,16.41L12,21L16.59,16.41L15.17,15M12,5.83L15.17,9L16.58,7.59L12,3L7.41,7.59L8.83,9L12,5.83Z"
    }));
};

});


parcelRegister("Rb7Sq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $09fd94c0d2994a2d$export$2e2bcd8739ae039; });

var $eeH7J = parcelRequire("eeH7J");

var $bJBxw = parcelRequire("bJBxw");
var $09fd94c0d2994a2d$export$a632586f9a957100 = function ChromePointer() {
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($bJBxw)))({
        "default": {
            picker: {
                width: "12px",
                height: "12px",
                borderRadius: "6px",
                transform: "translate(-6px, -1px)",
                backgroundColor: "rgb(248, 248, 248)",
                boxShadow: "0 1px 4px 0 rgba(0, 0, 0, 0.37)"
            }
        }
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        style: styles.picker
    });
};
var $09fd94c0d2994a2d$export$2e2bcd8739ae039 = $09fd94c0d2994a2d$export$a632586f9a957100;

});

parcelRegister("7O6D8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5af25887fe0e0d5d$export$2e2bcd8739ae039; });

var $eeH7J = parcelRequire("eeH7J");

var $bJBxw = parcelRequire("bJBxw");
var $5af25887fe0e0d5d$export$190c1afe887f7ef7 = function ChromePointerCircle() {
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($bJBxw)))({
        "default": {
            picker: {
                width: "12px",
                height: "12px",
                borderRadius: "6px",
                boxShadow: "inset 0 0 0 1px #fff",
                transform: "translate(-6px, -6px)"
            }
        }
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        style: styles.picker
    });
};
var $5af25887fe0e0d5d$export$2e2bcd8739ae039 = $5af25887fe0e0d5d$export$190c1afe887f7ef7;

});


parcelRegister("49RSn", function(module, exports) {

var $eeH7J = parcelRequire("eeH7J");

var $4yBem = parcelRequire("4yBem");

var $bJBxw = parcelRequire("bJBxw");

var $5UnTd = parcelRequire("5UnTd");

var $5VQgV = parcelRequire("5VQgV");

var $7Zkko = parcelRequire("7Zkko");
parcelRequire("isDZf");
var $8bUgk = parcelRequire("8bUgk");
var $2oAlV = parcelRequire("2oAlV");

var $9LSgx = parcelRequire("9LSgx");

var $8sDSX = parcelRequire("8sDSX");
var $3071cb5ed1b8597a$export$6479582a9c9e50ce = function Compact(_ref) {
    var onChange = _ref.onChange, onSwatchHover = _ref.onSwatchHover, colors = _ref.colors, hex = _ref.hex, rgb = _ref.rgb, _ref$styles = _ref.styles, passedStyles = _ref$styles === undefined ? {} : _ref$styles, _ref$className = _ref.className, className = _ref$className === undefined ? "" : _ref$className;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($bJBxw)))((0, $5VQgV.default)({
        "default": {
            Compact: {
                background: "#f6f6f6",
                radius: "4px"
            },
            compact: {
                paddingTop: "5px",
                paddingLeft: "5px",
                boxSizing: "initial",
                width: "240px"
            },
            clear: {
                clear: "both"
            }
        }
    }, passedStyles));
    var handleChange = function handleChange(data, e) {
        if (data.hex) $7Zkko.isValidHex(data.hex) && onChange({
            hex: data.hex,
            source: "hex"
        }, e);
        else onChange(data, e);
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $2oAlV.default), {
        style: styles.Compact,
        styles: passedStyles
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        style: styles.compact,
        className: "compact-picker " + className
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", null, (0, $5UnTd.default)(colors, function(c) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $9LSgx.default), {
            key: c,
            color: c,
            active: c.toLowerCase() === hex,
            onClick: handleChange,
            onSwatchHover: onSwatchHover
        });
    }), (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        style: styles.clear
    })), (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $8sDSX.default), {
        hex: hex,
        rgb: rgb,
        onChange: handleChange
    })));
};
$3071cb5ed1b8597a$export$6479582a9c9e50ce.propTypes = {
    colors: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string),
    styles: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object
};
$3071cb5ed1b8597a$export$6479582a9c9e50ce.defaultProps = {
    colors: [
        "#4D4D4D",
        "#999999",
        "#FFFFFF",
        "#F44E3B",
        "#FE9200",
        "#FCDC00",
        "#DBDF00",
        "#A4DD00",
        "#68CCCA",
        "#73D8FF",
        "#AEA1FF",
        "#FDA1FF",
        "#333333",
        "#808080",
        "#cccccc",
        "#D33115",
        "#E27300",
        "#FCC400",
        "#B0BC00",
        "#68BC00",
        "#16A5A5",
        "#009CE0",
        "#7B64FF",
        "#FA28FF",
        "#000000",
        "#666666",
        "#B3B3B3",
        "#9F0500",
        "#C45100",
        "#FB9E00",
        "#808900",
        "#194D33",
        "#0C797D",
        "#0062B1",
        "#653294",
        "#AB149E"
    ],
    styles: {}
};
var $3071cb5ed1b8597a$export$2e2bcd8739ae039 = (0, $8bUgk.default)($3071cb5ed1b8597a$export$6479582a9c9e50ce);

});
parcelRegister("9LSgx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $71d298e93093fb86$export$2e2bcd8739ae039; });

var $eeH7J = parcelRequire("eeH7J");

var $bJBxw = parcelRequire("bJBxw");

var $7Zkko = parcelRequire("7Zkko");
parcelRequire("isDZf");
var $2DBoi = parcelRequire("2DBoi");
var $71d298e93093fb86$export$df654652e5203306 = function CompactColor(_ref) {
    var color = _ref.color, _ref$onClick = _ref.onClick, onClick = _ref$onClick === undefined ? function() {} : _ref$onClick, onSwatchHover = _ref.onSwatchHover, active = _ref.active;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($bJBxw)))({
        "default": {
            color: {
                background: color,
                width: "15px",
                height: "15px",
                float: "left",
                marginRight: "5px",
                marginBottom: "5px",
                position: "relative",
                cursor: "pointer"
            },
            dot: {
                absolute: "5px 5px 5px 5px",
                background: $7Zkko.getContrastingColor(color),
                borderRadius: "50%",
                opacity: "0"
            }
        },
        "active": {
            dot: {
                opacity: "1"
            }
        },
        "color-#FFFFFF": {
            color: {
                boxShadow: "inset 0 0 0 1px #ddd"
            },
            dot: {
                background: "#000"
            }
        },
        "transparent": {
            dot: {
                background: "#000"
            }
        }
    }, {
        active: active,
        "color-#FFFFFF": color === "#FFFFFF",
        "transparent": color === "transparent"
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $2DBoi.default), {
        style: styles.color,
        color: color,
        onClick: onClick,
        onHover: onSwatchHover,
        focusStyle: {
            boxShadow: "0 0 4px " + color
        }
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        style: styles.dot
    }));
};
var $71d298e93093fb86$export$2e2bcd8739ae039 = $71d298e93093fb86$export$df654652e5203306;

});

parcelRegister("8sDSX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $628fe0a663fbccae$export$2e2bcd8739ae039; });

var $eeH7J = parcelRequire("eeH7J");

var $bJBxw = parcelRequire("bJBxw");
parcelRequire("isDZf");
var $a5dMh = parcelRequire("a5dMh");
var $628fe0a663fbccae$export$11cdb14a03223d9c = function CompactFields(_ref) {
    var hex = _ref.hex, rgb = _ref.rgb, onChange = _ref.onChange;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($bJBxw)))({
        "default": {
            fields: {
                display: "flex",
                paddingBottom: "6px",
                paddingRight: "5px",
                position: "relative"
            },
            active: {
                position: "absolute",
                top: "6px",
                left: "5px",
                height: "9px",
                width: "9px",
                background: hex
            },
            HEXwrap: {
                flex: "6",
                position: "relative"
            },
            HEXinput: {
                width: "80%",
                padding: "0px",
                paddingLeft: "20%",
                border: "none",
                outline: "none",
                background: "none",
                fontSize: "12px",
                color: "#333",
                height: "16px"
            },
            HEXlabel: {
                display: "none"
            },
            RGBwrap: {
                flex: "3",
                position: "relative"
            },
            RGBinput: {
                width: "70%",
                padding: "0px",
                paddingLeft: "30%",
                border: "none",
                outline: "none",
                background: "none",
                fontSize: "12px",
                color: "#333",
                height: "16px"
            },
            RGBlabel: {
                position: "absolute",
                top: "3px",
                left: "0px",
                lineHeight: "16px",
                textTransform: "uppercase",
                fontSize: "12px",
                color: "#999"
            }
        }
    });
    var handleChange = function handleChange(data, e) {
        if (data.r || data.g || data.b) onChange({
            r: data.r || rgb.r,
            g: data.g || rgb.g,
            b: data.b || rgb.b,
            source: "rgb"
        }, e);
        else onChange({
            hex: data.hex,
            source: "hex"
        }, e);
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        style: styles.fields,
        className: "flexbox-fix"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        style: styles.active
    }), (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $a5dMh.default), {
        style: {
            wrap: styles.HEXwrap,
            input: styles.HEXinput,
            label: styles.HEXlabel
        },
        label: "hex",
        value: hex,
        onChange: handleChange
    }), (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $a5dMh.default), {
        style: {
            wrap: styles.RGBwrap,
            input: styles.RGBinput,
            label: styles.RGBlabel
        },
        label: "r",
        value: rgb.r,
        onChange: handleChange
    }), (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $a5dMh.default), {
        style: {
            wrap: styles.RGBwrap,
            input: styles.RGBinput,
            label: styles.RGBlabel
        },
        label: "g",
        value: rgb.g,
        onChange: handleChange
    }), (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $a5dMh.default), {
        style: {
            wrap: styles.RGBwrap,
            input: styles.RGBinput,
            label: styles.RGBlabel
        },
        label: "b",
        value: rgb.b,
        onChange: handleChange
    }));
};
var $628fe0a663fbccae$export$2e2bcd8739ae039 = $628fe0a663fbccae$export$11cdb14a03223d9c;

});


parcelRegister("edUUL", function(module, exports) {

var $eeH7J = parcelRequire("eeH7J");

var $4yBem = parcelRequire("4yBem");

var $bJBxw = parcelRequire("bJBxw");

var $5UnTd = parcelRequire("5UnTd");

var $5VQgV = parcelRequire("5VQgV");
parcelRequire("isDZf");
var $8bUgk = parcelRequire("8bUgk");

var $eJnHe = parcelRequire("eJnHe");
var $a5ae6da4efe90fee$export$61d478c2aba5d9a5 = function Github(_ref) {
    var width = _ref.width, colors = _ref.colors, onChange = _ref.onChange, onSwatchHover = _ref.onSwatchHover, triangle = _ref.triangle, _ref$styles = _ref.styles, passedStyles = _ref$styles === undefined ? {} : _ref$styles, _ref$className = _ref.className, className = _ref$className === undefined ? "" : _ref$className;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($bJBxw)))((0, $5VQgV.default)({
        "default": {
            card: {
                width: width,
                background: "#fff",
                border: "1px solid rgba(0,0,0,0.2)",
                boxShadow: "0 3px 12px rgba(0,0,0,0.15)",
                borderRadius: "4px",
                position: "relative",
                padding: "5px",
                display: "flex",
                flexWrap: "wrap"
            },
            triangle: {
                position: "absolute",
                border: "7px solid transparent",
                borderBottomColor: "#fff"
            },
            triangleShadow: {
                position: "absolute",
                border: "8px solid transparent",
                borderBottomColor: "rgba(0,0,0,0.15)"
            }
        },
        "hide-triangle": {
            triangle: {
                display: "none"
            },
            triangleShadow: {
                display: "none"
            }
        },
        "top-left-triangle": {
            triangle: {
                top: "-14px",
                left: "10px"
            },
            triangleShadow: {
                top: "-16px",
                left: "9px"
            }
        },
        "top-right-triangle": {
            triangle: {
                top: "-14px",
                right: "10px"
            },
            triangleShadow: {
                top: "-16px",
                right: "9px"
            }
        },
        "bottom-left-triangle": {
            triangle: {
                top: "35px",
                left: "10px",
                transform: "rotate(180deg)"
            },
            triangleShadow: {
                top: "37px",
                left: "9px",
                transform: "rotate(180deg)"
            }
        },
        "bottom-right-triangle": {
            triangle: {
                top: "35px",
                right: "10px",
                transform: "rotate(180deg)"
            },
            triangleShadow: {
                top: "37px",
                right: "9px",
                transform: "rotate(180deg)"
            }
        }
    }, passedStyles), {
        "hide-triangle": triangle === "hide",
        "top-left-triangle": triangle === "top-left",
        "top-right-triangle": triangle === "top-right",
        "bottom-left-triangle": triangle === "bottom-left",
        "bottom-right-triangle": triangle === "bottom-right"
    });
    var handleChange = function handleChange(hex, e) {
        return onChange({
            hex: hex,
            source: "hex"
        }, e);
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        style: styles.card,
        className: "github-picker " + className
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        style: styles.triangleShadow
    }), (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        style: styles.triangle
    }), (0, $5UnTd.default)(colors, function(c) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $eJnHe.default), {
            color: c,
            key: c,
            onClick: handleChange,
            onSwatchHover: onSwatchHover
        });
    }));
};
$a5ae6da4efe90fee$export$61d478c2aba5d9a5.propTypes = {
    width: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).number
    ]),
    colors: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string),
    triangle: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOf([
        "hide",
        "top-left",
        "top-right",
        "bottom-left",
        "bottom-right"
    ]),
    styles: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object
};
$a5ae6da4efe90fee$export$61d478c2aba5d9a5.defaultProps = {
    width: 200,
    colors: [
        "#B80000",
        "#DB3E00",
        "#FCCB00",
        "#008B02",
        "#006B76",
        "#1273DE",
        "#004DCF",
        "#5300EB",
        "#EB9694",
        "#FAD0C3",
        "#FEF3BD",
        "#C1E1C5",
        "#BEDADC",
        "#C4DEF6",
        "#BED3F3",
        "#D4C4FB"
    ],
    triangle: "top-left",
    styles: {}
};
var $a5ae6da4efe90fee$export$2e2bcd8739ae039 = (0, $8bUgk.default)($a5ae6da4efe90fee$export$61d478c2aba5d9a5);

});
parcelRegister("eJnHe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ab97a63f7134dce2$export$2e2bcd8739ae039; });

var $eeH7J = parcelRequire("eeH7J");

var $bJBxw = parcelRequire("bJBxw");
parcelRequire("isDZf");
var $2DBoi = parcelRequire("2DBoi");
var $ab97a63f7134dce2$export$d653c538b92bb84f = function GithubSwatch(_ref) {
    var hover = _ref.hover, color = _ref.color, onClick = _ref.onClick, onSwatchHover = _ref.onSwatchHover;
    var hoverSwatch = {
        position: "relative",
        zIndex: "2",
        outline: "2px solid #fff",
        boxShadow: "0 0 5px 2px rgba(0,0,0,0.25)"
    };
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($bJBxw)))({
        "default": {
            swatch: {
                width: "25px",
                height: "25px",
                fontSize: "0"
            }
        },
        "hover": {
            swatch: hoverSwatch
        }
    }, {
        hover: hover
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        style: styles.swatch
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $2DBoi.default), {
        color: color,
        onClick: onClick,
        onHover: onSwatchHover,
        focusStyle: hoverSwatch
    }));
};
var $ab97a63f7134dce2$export$2e2bcd8739ae039 = (0, $bJBxw.handleHover)($ab97a63f7134dce2$export$d653c538b92bb84f);

});


parcelRegister("8J2Et", function(module, exports) {

var $eeH7J = parcelRequire("eeH7J");

var $4yBem = parcelRequire("4yBem");

var $bJBxw = parcelRequire("bJBxw");

var $5VQgV = parcelRequire("5VQgV");
parcelRequire("isDZf");
var $8bUgk = parcelRequire("8bUgk");
var $gnp1P = parcelRequire("gnp1P");

var $79gyr = parcelRequire("79gyr");
var $65a49550568f735f$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $65a49550568f735f$export$f176087feb20230e = function HuePicker(_ref) {
    var width = _ref.width, height = _ref.height, onChange = _ref.onChange, hsl = _ref.hsl, direction = _ref.direction, pointer = _ref.pointer, _ref$styles = _ref.styles, passedStyles = _ref$styles === undefined ? {} : _ref$styles, _ref$className = _ref.className, className = _ref$className === undefined ? "" : _ref$className;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($bJBxw)))((0, $5VQgV.default)({
        "default": {
            picker: {
                position: "relative",
                width: width,
                height: height
            },
            hue: {
                radius: "2px"
            }
        }
    }, passedStyles));
    // Overwrite to provide pure hue color
    var handleChange = function handleChange(data) {
        return onChange({
            a: 1,
            h: data.h,
            l: 0.5,
            s: 1
        });
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        style: styles.picker,
        className: "hue-picker " + className
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $gnp1P.default), $65a49550568f735f$var$_extends({}, styles.hue, {
        hsl: hsl,
        pointer: pointer,
        onChange: handleChange,
        direction: direction
    })));
};
$65a49550568f735f$export$f176087feb20230e.propTypes = {
    styles: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object
};
$65a49550568f735f$export$f176087feb20230e.defaultProps = {
    width: "316px",
    height: "16px",
    direction: "horizontal",
    pointer: (0, $79gyr.default),
    styles: {}
};
var $65a49550568f735f$export$2e2bcd8739ae039 = (0, $8bUgk.default)($65a49550568f735f$export$f176087feb20230e);

});
parcelRegister("79gyr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $534637106ab7e47c$export$2e2bcd8739ae039; });

var $eeH7J = parcelRequire("eeH7J");

var $bJBxw = parcelRequire("bJBxw");
var $534637106ab7e47c$export$9c10b52c64965f67 = function SliderPointer(_ref) {
    var direction = _ref.direction;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($bJBxw)))({
        "default": {
            picker: {
                width: "18px",
                height: "18px",
                borderRadius: "50%",
                transform: "translate(-9px, -1px)",
                backgroundColor: "rgb(248, 248, 248)",
                boxShadow: "0 1px 4px 0 rgba(0, 0, 0, 0.37)"
            }
        },
        "vertical": {
            picker: {
                transform: "translate(-3px, -9px)"
            }
        }
    }, {
        vertical: direction === "vertical"
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        style: styles.picker
    });
};
var $534637106ab7e47c$export$2e2bcd8739ae039 = $534637106ab7e47c$export$9c10b52c64965f67;

});


parcelRegister("h5WZD", function(module, exports) {

var $eeH7J = parcelRequire("eeH7J");

var $bJBxw = parcelRequire("bJBxw");

var $5VQgV = parcelRequire("5VQgV");

var $7Zkko = parcelRequire("7Zkko");
parcelRequire("isDZf");
var $8bUgk = parcelRequire("8bUgk");
var $a5dMh = parcelRequire("a5dMh");
var $2oAlV = parcelRequire("2oAlV");
var $c720aa1e4fccba52$export$a2d8b23205c25948 = function Material(_ref) {
    var onChange = _ref.onChange, hex = _ref.hex, rgb = _ref.rgb, _ref$styles = _ref.styles, passedStyles = _ref$styles === undefined ? {} : _ref$styles, _ref$className = _ref.className, className = _ref$className === undefined ? "" : _ref$className;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($bJBxw)))((0, $5VQgV.default)({
        "default": {
            material: {
                width: "98px",
                height: "98px",
                padding: "16px",
                fontFamily: "Roboto"
            },
            HEXwrap: {
                position: "relative"
            },
            HEXinput: {
                width: "100%",
                marginTop: "12px",
                fontSize: "15px",
                color: "#333",
                padding: "0px",
                border: "0px",
                borderBottom: "2px solid " + hex,
                outline: "none",
                height: "30px"
            },
            HEXlabel: {
                position: "absolute",
                top: "0px",
                left: "0px",
                fontSize: "11px",
                color: "#999999",
                textTransform: "capitalize"
            },
            Hex: {
                style: {}
            },
            RGBwrap: {
                position: "relative"
            },
            RGBinput: {
                width: "100%",
                marginTop: "12px",
                fontSize: "15px",
                color: "#333",
                padding: "0px",
                border: "0px",
                borderBottom: "1px solid #eee",
                outline: "none",
                height: "30px"
            },
            RGBlabel: {
                position: "absolute",
                top: "0px",
                left: "0px",
                fontSize: "11px",
                color: "#999999",
                textTransform: "capitalize"
            },
            split: {
                display: "flex",
                marginRight: "-10px",
                paddingTop: "11px"
            },
            third: {
                flex: "1",
                paddingRight: "10px"
            }
        }
    }, passedStyles));
    var handleChange = function handleChange(data, e) {
        if (data.hex) $7Zkko.isValidHex(data.hex) && onChange({
            hex: data.hex,
            source: "hex"
        }, e);
        else if (data.r || data.g || data.b) onChange({
            r: data.r || rgb.r,
            g: data.g || rgb.g,
            b: data.b || rgb.b,
            source: "rgb"
        }, e);
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $2oAlV.default), {
        styles: passedStyles
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        style: styles.material,
        className: "material-picker " + className
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $a5dMh.default), {
        style: {
            wrap: styles.HEXwrap,
            input: styles.HEXinput,
            label: styles.HEXlabel
        },
        label: "hex",
        value: hex,
        onChange: handleChange
    }), (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        style: styles.split,
        className: "flexbox-fix"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        style: styles.third
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $a5dMh.default), {
        style: {
            wrap: styles.RGBwrap,
            input: styles.RGBinput,
            label: styles.RGBlabel
        },
        label: "r",
        value: rgb.r,
        onChange: handleChange
    })), (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        style: styles.third
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $a5dMh.default), {
        style: {
            wrap: styles.RGBwrap,
            input: styles.RGBinput,
            label: styles.RGBlabel
        },
        label: "g",
        value: rgb.g,
        onChange: handleChange
    })), (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        style: styles.third
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $a5dMh.default), {
        style: {
            wrap: styles.RGBwrap,
            input: styles.RGBinput,
            label: styles.RGBlabel
        },
        label: "b",
        value: rgb.b,
        onChange: handleChange
    })))));
};
var $c720aa1e4fccba52$export$2e2bcd8739ae039 = (0, $8bUgk.default)($c720aa1e4fccba52$export$a2d8b23205c25948);

});

parcelRegister("6T8Ze", function(module, exports) {

var $eeH7J = parcelRequire("eeH7J");

var $4yBem = parcelRequire("4yBem");

var $bJBxw = parcelRequire("bJBxw");

var $5VQgV = parcelRequire("5VQgV");
parcelRequire("isDZf");
var $8bUgk = parcelRequire("8bUgk");
var $gnp1P = parcelRequire("gnp1P");
var $ejwzz = parcelRequire("ejwzz");

var $4qrkz = parcelRequire("4qrkz");

var $5Q9U5 = parcelRequire("5Q9U5");

var $9q5nx = parcelRequire("9q5nx");

var $eDpjX = parcelRequire("eDpjX");

var $1pv8S = parcelRequire("1pv8S");
var $503ed9a93574dbce$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function $503ed9a93574dbce$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $503ed9a93574dbce$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $503ed9a93574dbce$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $503ed9a93574dbce$export$4ed116dea8ad5956 = function(_React$Component) {
    $503ed9a93574dbce$var$_inherits(Photoshop, _React$Component);
    function Photoshop(props) {
        $503ed9a93574dbce$var$_classCallCheck(this, Photoshop);
        var _this = $503ed9a93574dbce$var$_possibleConstructorReturn(this, (Photoshop.__proto__ || Object.getPrototypeOf(Photoshop)).call(this));
        _this.state = {
            currentColor: props.hex
        };
        return _this;
    }
    $503ed9a93574dbce$var$_createClass(Photoshop, [
        {
            key: "render",
            value: function render() {
                var _props = this.props, _props$styles = _props.styles, passedStyles = _props$styles === undefined ? {} : _props$styles, _props$className = _props.className, className = _props$className === undefined ? "" : _props$className;
                var styles = (0, (/*@__PURE__*/$parcel$interopDefault($bJBxw)))((0, $5VQgV.default)({
                    "default": {
                        picker: {
                            background: "#DCDCDC",
                            borderRadius: "4px",
                            boxShadow: "0 0 0 1px rgba(0,0,0,.25), 0 8px 16px rgba(0,0,0,.15)",
                            boxSizing: "initial",
                            width: "513px"
                        },
                        head: {
                            backgroundImage: "linear-gradient(-180deg, #F0F0F0 0%, #D4D4D4 100%)",
                            borderBottom: "1px solid #B1B1B1",
                            boxShadow: "inset 0 1px 0 0 rgba(255,255,255,.2), inset 0 -1px 0 0 rgba(0,0,0,.02)",
                            height: "23px",
                            lineHeight: "24px",
                            borderRadius: "4px 4px 0 0",
                            fontSize: "13px",
                            color: "#4D4D4D",
                            textAlign: "center"
                        },
                        body: {
                            padding: "15px 15px 0",
                            display: "flex"
                        },
                        saturation: {
                            width: "256px",
                            height: "256px",
                            position: "relative",
                            border: "2px solid #B3B3B3",
                            borderBottom: "2px solid #F0F0F0",
                            overflow: "hidden"
                        },
                        hue: {
                            position: "relative",
                            height: "256px",
                            width: "19px",
                            marginLeft: "10px",
                            border: "2px solid #B3B3B3",
                            borderBottom: "2px solid #F0F0F0"
                        },
                        controls: {
                            width: "180px",
                            marginLeft: "10px"
                        },
                        top: {
                            display: "flex"
                        },
                        previews: {
                            width: "60px"
                        },
                        actions: {
                            flex: "1",
                            marginLeft: "20px"
                        }
                    }
                }, passedStyles));
                return (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
                    style: styles.picker,
                    className: "photoshop-picker " + className
                }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
                    style: styles.head
                }, this.props.header), (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
                    style: styles.body,
                    className: "flexbox-fix"
                }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
                    style: styles.saturation
                }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $ejwzz.default), {
                    hsl: this.props.hsl,
                    hsv: this.props.hsv,
                    pointer: (0, $5Q9U5.default),
                    onChange: this.props.onChange
                })), (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
                    style: styles.hue
                }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $gnp1P.default), {
                    direction: "vertical",
                    hsl: this.props.hsl,
                    pointer: (0, $9q5nx.default),
                    onChange: this.props.onChange
                })), (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
                    style: styles.controls
                }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
                    style: styles.top,
                    className: "flexbox-fix"
                }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
                    style: styles.previews
                }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $1pv8S.default), {
                    rgb: this.props.rgb,
                    currentColor: this.state.currentColor
                })), (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
                    style: styles.actions
                }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $eDpjX.default), {
                    label: "OK",
                    onClick: this.props.onAccept,
                    active: true
                }), (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $eDpjX.default), {
                    label: "Cancel",
                    onClick: this.props.onCancel
                }), (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $4qrkz.default), {
                    onChange: this.props.onChange,
                    rgb: this.props.rgb,
                    hsv: this.props.hsv,
                    hex: this.props.hex
                }))))));
            }
        }
    ]);
    return Photoshop;
}((0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).Component);
$503ed9a93574dbce$export$4ed116dea8ad5956.propTypes = {
    header: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string,
    styles: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object
};
$503ed9a93574dbce$export$4ed116dea8ad5956.defaultProps = {
    header: "Color Picker",
    styles: {}
};
var $503ed9a93574dbce$export$2e2bcd8739ae039 = (0, $8bUgk.default)($503ed9a93574dbce$export$4ed116dea8ad5956);

});
parcelRegister("4qrkz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $338eca795ded3eb7$export$2e2bcd8739ae039; });

var $eeH7J = parcelRequire("eeH7J");

var $bJBxw = parcelRequire("bJBxw");

var $7Zkko = parcelRequire("7Zkko");
parcelRequire("isDZf");
var $a5dMh = parcelRequire("a5dMh");
var $338eca795ded3eb7$export$b1808ee9bfa8f4d0 = function PhotoshopPicker(_ref) {
    var onChange = _ref.onChange, rgb = _ref.rgb, hsv = _ref.hsv, hex = _ref.hex;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($bJBxw)))({
        "default": {
            fields: {
                paddingTop: "5px",
                paddingBottom: "9px",
                width: "80px",
                position: "relative"
            },
            divider: {
                height: "5px"
            },
            RGBwrap: {
                position: "relative"
            },
            RGBinput: {
                marginLeft: "40%",
                width: "40%",
                height: "18px",
                border: "1px solid #888888",
                boxShadow: "inset 0 1px 1px rgba(0,0,0,.1), 0 1px 0 0 #ECECEC",
                marginBottom: "5px",
                fontSize: "13px",
                paddingLeft: "3px",
                marginRight: "10px"
            },
            RGBlabel: {
                left: "0px",
                top: "0px",
                width: "34px",
                textTransform: "uppercase",
                fontSize: "13px",
                height: "18px",
                lineHeight: "22px",
                position: "absolute"
            },
            HEXwrap: {
                position: "relative"
            },
            HEXinput: {
                marginLeft: "20%",
                width: "80%",
                height: "18px",
                border: "1px solid #888888",
                boxShadow: "inset 0 1px 1px rgba(0,0,0,.1), 0 1px 0 0 #ECECEC",
                marginBottom: "6px",
                fontSize: "13px",
                paddingLeft: "3px"
            },
            HEXlabel: {
                position: "absolute",
                top: "0px",
                left: "0px",
                width: "14px",
                textTransform: "uppercase",
                fontSize: "13px",
                height: "18px",
                lineHeight: "22px"
            },
            fieldSymbols: {
                position: "absolute",
                top: "5px",
                right: "-7px",
                fontSize: "13px"
            },
            symbol: {
                height: "20px",
                lineHeight: "22px",
                paddingBottom: "7px"
            }
        }
    });
    var handleChange = function handleChange(data, e) {
        if (data["#"]) $7Zkko.isValidHex(data["#"]) && onChange({
            hex: data["#"],
            source: "hex"
        }, e);
        else if (data.r || data.g || data.b) onChange({
            r: data.r || rgb.r,
            g: data.g || rgb.g,
            b: data.b || rgb.b,
            source: "rgb"
        }, e);
        else if (data.h || data.s || data.v) onChange({
            h: data.h || hsv.h,
            s: data.s || hsv.s,
            v: data.v || hsv.v,
            source: "hsv"
        }, e);
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        style: styles.fields
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $a5dMh.default), {
        style: {
            wrap: styles.RGBwrap,
            input: styles.RGBinput,
            label: styles.RGBlabel
        },
        label: "h",
        value: Math.round(hsv.h),
        onChange: handleChange
    }), (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $a5dMh.default), {
        style: {
            wrap: styles.RGBwrap,
            input: styles.RGBinput,
            label: styles.RGBlabel
        },
        label: "s",
        value: Math.round(hsv.s * 100),
        onChange: handleChange
    }), (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $a5dMh.default), {
        style: {
            wrap: styles.RGBwrap,
            input: styles.RGBinput,
            label: styles.RGBlabel
        },
        label: "v",
        value: Math.round(hsv.v * 100),
        onChange: handleChange
    }), (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        style: styles.divider
    }), (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $a5dMh.default), {
        style: {
            wrap: styles.RGBwrap,
            input: styles.RGBinput,
            label: styles.RGBlabel
        },
        label: "r",
        value: rgb.r,
        onChange: handleChange
    }), (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $a5dMh.default), {
        style: {
            wrap: styles.RGBwrap,
            input: styles.RGBinput,
            label: styles.RGBlabel
        },
        label: "g",
        value: rgb.g,
        onChange: handleChange
    }), (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $a5dMh.default), {
        style: {
            wrap: styles.RGBwrap,
            input: styles.RGBinput,
            label: styles.RGBlabel
        },
        label: "b",
        value: rgb.b,
        onChange: handleChange
    }), (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        style: styles.divider
    }), (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $a5dMh.default), {
        style: {
            wrap: styles.HEXwrap,
            input: styles.HEXinput,
            label: styles.HEXlabel
        },
        label: "#",
        value: hex.replace("#", ""),
        onChange: handleChange
    }), (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        style: styles.fieldSymbols
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        style: styles.symbol
    }, "\xb0"), (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        style: styles.symbol
    }, "%"), (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        style: styles.symbol
    }, "%")));
};
var $338eca795ded3eb7$export$2e2bcd8739ae039 = $338eca795ded3eb7$export$b1808ee9bfa8f4d0;

});

parcelRegister("5Q9U5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $44097db7cf08fc15$export$2e2bcd8739ae039; });

var $eeH7J = parcelRequire("eeH7J");

var $bJBxw = parcelRequire("bJBxw");
var $44097db7cf08fc15$export$123b96ff8455915 = function PhotoshopPointerCircle(_ref) {
    var hsl = _ref.hsl;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($bJBxw)))({
        "default": {
            picker: {
                width: "12px",
                height: "12px",
                borderRadius: "6px",
                boxShadow: "inset 0 0 0 1px #fff",
                transform: "translate(-6px, -6px)"
            }
        },
        "black-outline": {
            picker: {
                boxShadow: "inset 0 0 0 1px #000"
            }
        }
    }, {
        "black-outline": hsl.l > 0.5
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        style: styles.picker
    });
};
var $44097db7cf08fc15$export$2e2bcd8739ae039 = $44097db7cf08fc15$export$123b96ff8455915;

});

parcelRegister("9q5nx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6dbab6da23f0a762$export$2e2bcd8739ae039; });

var $eeH7J = parcelRequire("eeH7J");

var $bJBxw = parcelRequire("bJBxw");
var $6dbab6da23f0a762$export$123b96ff8455915 = function PhotoshopPointerCircle() {
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($bJBxw)))({
        "default": {
            triangle: {
                width: 0,
                height: 0,
                borderStyle: "solid",
                borderWidth: "4px 0 4px 6px",
                borderColor: "transparent transparent transparent #fff",
                position: "absolute",
                top: "1px",
                left: "1px"
            },
            triangleBorder: {
                width: 0,
                height: 0,
                borderStyle: "solid",
                borderWidth: "5px 0 5px 8px",
                borderColor: "transparent transparent transparent #555"
            },
            left: {
                Extend: "triangleBorder",
                transform: "translate(-13px, -4px)"
            },
            leftInside: {
                Extend: "triangle",
                transform: "translate(-8px, -5px)"
            },
            right: {
                Extend: "triangleBorder",
                transform: "translate(20px, -14px) rotate(180deg)"
            },
            rightInside: {
                Extend: "triangle",
                transform: "translate(-8px, -5px)"
            }
        }
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        style: styles.pointer
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        style: styles.left
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        style: styles.leftInside
    })), (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        style: styles.right
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        style: styles.rightInside
    })));
};
var $6dbab6da23f0a762$export$2e2bcd8739ae039 = $6dbab6da23f0a762$export$123b96ff8455915;

});

parcelRegister("eDpjX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $aa785966637bcbc4$export$2e2bcd8739ae039; });

var $eeH7J = parcelRequire("eeH7J");

var $bJBxw = parcelRequire("bJBxw");
var $aa785966637bcbc4$export$f7d38a0bd3b98717 = function PhotoshopButton(_ref) {
    var onClick = _ref.onClick, label = _ref.label, children = _ref.children, active = _ref.active;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($bJBxw)))({
        "default": {
            button: {
                backgroundImage: "linear-gradient(-180deg, #FFFFFF 0%, #E6E6E6 100%)",
                border: "1px solid #878787",
                borderRadius: "2px",
                height: "20px",
                boxShadow: "0 1px 0 0 #EAEAEA",
                fontSize: "14px",
                color: "#000",
                lineHeight: "20px",
                textAlign: "center",
                marginBottom: "10px",
                cursor: "pointer"
            }
        },
        "active": {
            button: {
                boxShadow: "0 0 0 1px #878787"
            }
        }
    }, {
        active: active
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        style: styles.button,
        onClick: onClick
    }, label || children);
};
var $aa785966637bcbc4$export$2e2bcd8739ae039 = $aa785966637bcbc4$export$f7d38a0bd3b98717;

});

parcelRegister("1pv8S", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $10704874a9b8e800$export$2e2bcd8739ae039; });

var $eeH7J = parcelRequire("eeH7J");

var $bJBxw = parcelRequire("bJBxw");
var $10704874a9b8e800$export$ce0d7acd66f46f2b = function PhotoshopPreviews(_ref) {
    var rgb = _ref.rgb, currentColor = _ref.currentColor;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($bJBxw)))({
        "default": {
            swatches: {
                border: "1px solid #B3B3B3",
                borderBottom: "1px solid #F0F0F0",
                marginBottom: "2px",
                marginTop: "1px"
            },
            new: {
                height: "34px",
                background: "rgb(" + rgb.r + "," + rgb.g + ", " + rgb.b + ")",
                boxShadow: "inset 1px 0 0 #000, inset -1px 0 0 #000, inset 0 1px 0 #000"
            },
            current: {
                height: "34px",
                background: currentColor,
                boxShadow: "inset 1px 0 0 #000, inset -1px 0 0 #000, inset 0 -1px 0 #000"
            },
            label: {
                fontSize: "14px",
                color: "#000",
                textAlign: "center"
            }
        }
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", null, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        style: styles.label
    }, "new"), (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        style: styles.swatches
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        style: styles.new
    }), (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        style: styles.current
    })), (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        style: styles.label
    }, "current"));
};
var $10704874a9b8e800$export$2e2bcd8739ae039 = $10704874a9b8e800$export$ce0d7acd66f46f2b;

});


parcelRegister("hWfXp", function(module, exports) {

var $eeH7J = parcelRequire("eeH7J");

var $4yBem = parcelRequire("4yBem");

var $bJBxw = parcelRequire("bJBxw");

var $5VQgV = parcelRequire("5VQgV");
parcelRequire("isDZf");
var $cydcQ = parcelRequire("cydcQ");
var $dZU3X = parcelRequire("dZU3X");
var $8bUgk = parcelRequire("8bUgk");
var $gnp1P = parcelRequire("gnp1P");
var $ejwzz = parcelRequire("ejwzz");

var $7F5oC = parcelRequire("7F5oC");

var $gUd1I = parcelRequire("gUd1I");
var $d0f43b3245f5dd9d$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $d0f43b3245f5dd9d$export$361fce2090be193f = function Sketch(_ref) {
    var width = _ref.width, rgb = _ref.rgb, hex = _ref.hex, hsv = _ref.hsv, hsl = _ref.hsl, onChange = _ref.onChange, onSwatchHover = _ref.onSwatchHover, disableAlpha = _ref.disableAlpha, presetColors = _ref.presetColors, renderers = _ref.renderers, _ref$styles = _ref.styles, passedStyles = _ref$styles === undefined ? {} : _ref$styles, _ref$className = _ref.className, className = _ref$className === undefined ? "" : _ref$className;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($bJBxw)))((0, $5VQgV.default)({
        "default": $d0f43b3245f5dd9d$var$_extends({
            picker: {
                width: width,
                padding: "10px 10px 0",
                boxSizing: "initial",
                background: "#fff",
                borderRadius: "4px",
                boxShadow: "0 0 0 1px rgba(0,0,0,.15), 0 8px 16px rgba(0,0,0,.15)"
            },
            saturation: {
                width: "100%",
                paddingBottom: "75%",
                position: "relative",
                overflow: "hidden"
            },
            Saturation: {
                radius: "3px",
                shadow: "inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)"
            },
            controls: {
                display: "flex"
            },
            sliders: {
                padding: "4px 0",
                flex: "1"
            },
            color: {
                width: "24px",
                height: "24px",
                position: "relative",
                marginTop: "4px",
                marginLeft: "4px",
                borderRadius: "3px"
            },
            activeColor: {
                absolute: "0px 0px 0px 0px",
                borderRadius: "2px",
                background: "rgba(" + rgb.r + "," + rgb.g + "," + rgb.b + "," + rgb.a + ")",
                boxShadow: "inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)"
            },
            hue: {
                position: "relative",
                height: "10px",
                overflow: "hidden"
            },
            Hue: {
                radius: "2px",
                shadow: "inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)"
            },
            alpha: {
                position: "relative",
                height: "10px",
                marginTop: "4px",
                overflow: "hidden"
            },
            Alpha: {
                radius: "2px",
                shadow: "inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)"
            }
        }, passedStyles),
        "disableAlpha": {
            color: {
                height: "10px"
            },
            hue: {
                height: "10px"
            },
            alpha: {
                display: "none"
            }
        }
    }, passedStyles), {
        disableAlpha: disableAlpha
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        style: styles.picker,
        className: "sketch-picker " + className
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        style: styles.saturation
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $ejwzz.default), {
        style: styles.Saturation,
        hsl: hsl,
        hsv: hsv,
        onChange: onChange
    })), (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        style: styles.controls,
        className: "flexbox-fix"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        style: styles.sliders
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        style: styles.hue
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $gnp1P.default), {
        style: styles.Hue,
        hsl: hsl,
        onChange: onChange
    })), (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        style: styles.alpha
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $cydcQ.default), {
        style: styles.Alpha,
        rgb: rgb,
        hsl: hsl,
        renderers: renderers,
        onChange: onChange
    }))), (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        style: styles.color
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $dZU3X.default), null), (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        style: styles.activeColor
    }))), (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $7F5oC.default), {
        rgb: rgb,
        hsl: hsl,
        hex: hex,
        onChange: onChange,
        disableAlpha: disableAlpha
    }), (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $gUd1I.default), {
        colors: presetColors,
        onClick: onChange,
        onSwatchHover: onSwatchHover
    }));
};
$d0f43b3245f5dd9d$export$361fce2090be193f.propTypes = {
    disableAlpha: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).bool,
    width: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).number
    ]),
    styles: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object
};
$d0f43b3245f5dd9d$export$361fce2090be193f.defaultProps = {
    disableAlpha: false,
    width: 200,
    styles: {},
    presetColors: [
        "#D0021B",
        "#F5A623",
        "#F8E71C",
        "#8B572A",
        "#7ED321",
        "#417505",
        "#BD10E0",
        "#9013FE",
        "#4A90E2",
        "#50E3C2",
        "#B8E986",
        "#000000",
        "#4A4A4A",
        "#9B9B9B",
        "#FFFFFF"
    ]
};
var $d0f43b3245f5dd9d$export$2e2bcd8739ae039 = (0, $8bUgk.default)($d0f43b3245f5dd9d$export$361fce2090be193f);

});
parcelRegister("7F5oC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $59408c4348026e80$export$2e2bcd8739ae039; });
/* eslint-disable no-param-reassign */ 
var $eeH7J = parcelRequire("eeH7J");

var $bJBxw = parcelRequire("bJBxw");

var $7Zkko = parcelRequire("7Zkko");
parcelRequire("isDZf");
var $a5dMh = parcelRequire("a5dMh");
var $59408c4348026e80$export$a9bdb1170868e062 = function SketchFields(_ref) {
    var onChange = _ref.onChange, rgb = _ref.rgb, hsl = _ref.hsl, hex = _ref.hex, disableAlpha = _ref.disableAlpha;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($bJBxw)))({
        "default": {
            fields: {
                display: "flex",
                paddingTop: "4px"
            },
            single: {
                flex: "1",
                paddingLeft: "6px"
            },
            alpha: {
                flex: "1",
                paddingLeft: "6px"
            },
            double: {
                flex: "2"
            },
            input: {
                width: "80%",
                padding: "4px 10% 3px",
                border: "none",
                boxShadow: "inset 0 0 0 1px #ccc",
                fontSize: "11px"
            },
            label: {
                display: "block",
                textAlign: "center",
                fontSize: "11px",
                color: "#222",
                paddingTop: "3px",
                paddingBottom: "4px",
                textTransform: "capitalize"
            }
        },
        "disableAlpha": {
            alpha: {
                display: "none"
            }
        }
    }, {
        disableAlpha: disableAlpha
    });
    var handleChange = function handleChange(data, e) {
        if (data.hex) $7Zkko.isValidHex(data.hex) && onChange({
            hex: data.hex,
            source: "hex"
        }, e);
        else if (data.r || data.g || data.b) onChange({
            r: data.r || rgb.r,
            g: data.g || rgb.g,
            b: data.b || rgb.b,
            a: rgb.a,
            source: "rgb"
        }, e);
        else if (data.a) {
            if (data.a < 0) data.a = 0;
            else if (data.a > 100) data.a = 100;
            data.a /= 100;
            onChange({
                h: hsl.h,
                s: hsl.s,
                l: hsl.l,
                a: data.a,
                source: "rgb"
            }, e);
        }
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        style: styles.fields,
        className: "flexbox-fix"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        style: styles.double
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $a5dMh.default), {
        style: {
            input: styles.input,
            label: styles.label
        },
        label: "hex",
        value: hex.replace("#", ""),
        onChange: handleChange
    })), (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        style: styles.single
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $a5dMh.default), {
        style: {
            input: styles.input,
            label: styles.label
        },
        label: "r",
        value: rgb.r,
        onChange: handleChange,
        dragLabel: "true",
        dragMax: "255"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        style: styles.single
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $a5dMh.default), {
        style: {
            input: styles.input,
            label: styles.label
        },
        label: "g",
        value: rgb.g,
        onChange: handleChange,
        dragLabel: "true",
        dragMax: "255"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        style: styles.single
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $a5dMh.default), {
        style: {
            input: styles.input,
            label: styles.label
        },
        label: "b",
        value: rgb.b,
        onChange: handleChange,
        dragLabel: "true",
        dragMax: "255"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        style: styles.alpha
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $a5dMh.default), {
        style: {
            input: styles.input,
            label: styles.label
        },
        label: "a",
        value: Math.round(rgb.a * 100),
        onChange: handleChange,
        dragLabel: "true",
        dragMax: "100"
    })));
};
var $59408c4348026e80$export$2e2bcd8739ae039 = $59408c4348026e80$export$a9bdb1170868e062;

});

parcelRegister("gUd1I", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c4ebfb2288cdf6f9$export$2e2bcd8739ae039; });

var $eeH7J = parcelRequire("eeH7J");

var $4yBem = parcelRequire("4yBem");

var $bJBxw = parcelRequire("bJBxw");
parcelRequire("isDZf");
var $2DBoi = parcelRequire("2DBoi");
var $c4ebfb2288cdf6f9$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $c4ebfb2288cdf6f9$export$cc78acae6744db3b = function SketchPresetColors(_ref) {
    var colors = _ref.colors, _ref$onClick = _ref.onClick, onClick = _ref$onClick === undefined ? function() {} : _ref$onClick, onSwatchHover = _ref.onSwatchHover;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($bJBxw)))({
        "default": {
            colors: {
                margin: "0 -10px",
                padding: "10px 0 0 10px",
                borderTop: "1px solid #eee",
                display: "flex",
                flexWrap: "wrap",
                position: "relative"
            },
            swatchWrap: {
                width: "16px",
                height: "16px",
                margin: "0 10px 10px 0"
            },
            swatch: {
                borderRadius: "3px",
                boxShadow: "inset 0 0 0 1px rgba(0,0,0,.15)"
            }
        },
        "no-presets": {
            colors: {
                display: "none"
            }
        }
    }, {
        "no-presets": !colors || !colors.length
    });
    var handleClick = function handleClick(hex, e) {
        onClick({
            hex: hex,
            source: "hex"
        }, e);
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        style: styles.colors,
        className: "flexbox-fix"
    }, colors.map(function(colorObjOrString) {
        var c = typeof colorObjOrString === "string" ? {
            color: colorObjOrString
        } : colorObjOrString;
        var key = "" + c.color + (c.title || "");
        return (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
            key: key,
            style: styles.swatchWrap
        }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $2DBoi.default), $c4ebfb2288cdf6f9$var$_extends({}, c, {
            style: styles.swatch,
            onClick: handleClick,
            onHover: onSwatchHover,
            focusStyle: {
                boxShadow: "inset 0 0 0 1px rgba(0,0,0,.15), 0 0 4px " + c.color
            }
        })));
    }));
};
$c4ebfb2288cdf6f9$export$cc78acae6744db3b.propTypes = {
    colors: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).shape({
            color: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string,
            title: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string
        })
    ])).isRequired
};
var $c4ebfb2288cdf6f9$export$2e2bcd8739ae039 = $c4ebfb2288cdf6f9$export$cc78acae6744db3b;

});


parcelRegister("aj0NK", function(module, exports) {

var $eeH7J = parcelRequire("eeH7J");

var $4yBem = parcelRequire("4yBem");

var $bJBxw = parcelRequire("bJBxw");

var $5VQgV = parcelRequire("5VQgV");
parcelRequire("isDZf");
var $8bUgk = parcelRequire("8bUgk");
var $gnp1P = parcelRequire("gnp1P");

var $3iW1c = parcelRequire("3iW1c");

var $aY3hQ = parcelRequire("aY3hQ");
var $780c4ce08e08f432$export$472062a354075cee = function Slider(_ref) {
    var hsl = _ref.hsl, onChange = _ref.onChange, pointer = _ref.pointer, _ref$styles = _ref.styles, passedStyles = _ref$styles === undefined ? {} : _ref$styles, _ref$className = _ref.className, className = _ref$className === undefined ? "" : _ref$className;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($bJBxw)))((0, $5VQgV.default)({
        "default": {
            hue: {
                height: "12px",
                position: "relative"
            },
            Hue: {
                radius: "2px"
            }
        }
    }, passedStyles));
    return (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        style: styles.wrap || {},
        className: "slider-picker " + className
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        style: styles.hue
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $gnp1P.default), {
        style: styles.Hue,
        hsl: hsl,
        pointer: pointer,
        onChange: onChange
    })), (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        style: styles.swatches
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $3iW1c.default), {
        hsl: hsl,
        onClick: onChange
    })));
};
$780c4ce08e08f432$export$472062a354075cee.propTypes = {
    styles: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object
};
$780c4ce08e08f432$export$472062a354075cee.defaultProps = {
    pointer: (0, $aY3hQ.default),
    styles: {}
};
var $780c4ce08e08f432$export$2e2bcd8739ae039 = (0, $8bUgk.default)($780c4ce08e08f432$export$472062a354075cee);

});
parcelRegister("3iW1c", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $26800ec7003bb469$export$2e2bcd8739ae039; });

var $eeH7J = parcelRequire("eeH7J");

var $bJBxw = parcelRequire("bJBxw");

var $d21CU = parcelRequire("d21CU");
var $26800ec7003bb469$export$48f49e32c66cdd61 = function SliderSwatches(_ref) {
    var onClick = _ref.onClick, hsl = _ref.hsl;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($bJBxw)))({
        "default": {
            swatches: {
                marginTop: "20px"
            },
            swatch: {
                boxSizing: "border-box",
                width: "20%",
                paddingRight: "1px",
                float: "left"
            },
            clear: {
                clear: "both"
            }
        }
    });
    // Acceptible difference in floating point equality
    var epsilon = 0.1;
    return (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        style: styles.swatches
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        style: styles.swatch
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $d21CU.default), {
        hsl: hsl,
        offset: ".80",
        active: Math.abs(hsl.l - 0.80) < epsilon && Math.abs(hsl.s - 0.50) < epsilon,
        onClick: onClick,
        first: true
    })), (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        style: styles.swatch
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $d21CU.default), {
        hsl: hsl,
        offset: ".65",
        active: Math.abs(hsl.l - 0.65) < epsilon && Math.abs(hsl.s - 0.50) < epsilon,
        onClick: onClick
    })), (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        style: styles.swatch
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $d21CU.default), {
        hsl: hsl,
        offset: ".50",
        active: Math.abs(hsl.l - 0.50) < epsilon && Math.abs(hsl.s - 0.50) < epsilon,
        onClick: onClick
    })), (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        style: styles.swatch
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $d21CU.default), {
        hsl: hsl,
        offset: ".35",
        active: Math.abs(hsl.l - 0.35) < epsilon && Math.abs(hsl.s - 0.50) < epsilon,
        onClick: onClick
    })), (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        style: styles.swatch
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $d21CU.default), {
        hsl: hsl,
        offset: ".20",
        active: Math.abs(hsl.l - 0.20) < epsilon && Math.abs(hsl.s - 0.50) < epsilon,
        onClick: onClick,
        last: true
    })), (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        style: styles.clear
    }));
};
var $26800ec7003bb469$export$2e2bcd8739ae039 = $26800ec7003bb469$export$48f49e32c66cdd61;

});
parcelRegister("d21CU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $97ccb948e72df062$export$2e2bcd8739ae039; });

var $eeH7J = parcelRequire("eeH7J");

var $bJBxw = parcelRequire("bJBxw");
var $97ccb948e72df062$export$5c11afa672411de4 = function SliderSwatch(_ref) {
    var hsl = _ref.hsl, offset = _ref.offset, _ref$onClick = _ref.onClick, onClick = _ref$onClick === undefined ? function() {} : _ref$onClick, active = _ref.active, first = _ref.first, last = _ref.last;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($bJBxw)))({
        "default": {
            swatch: {
                height: "12px",
                background: "hsl(" + hsl.h + ", 50%, " + offset * 100 + "%)",
                cursor: "pointer"
            }
        },
        "first": {
            swatch: {
                borderRadius: "2px 0 0 2px"
            }
        },
        "last": {
            swatch: {
                borderRadius: "0 2px 2px 0"
            }
        },
        "active": {
            swatch: {
                transform: "scaleY(1.8)",
                borderRadius: "3.6px/2px"
            }
        }
    }, {
        active: active,
        first: first,
        last: last
    });
    var handleClick = function handleClick(e) {
        return onClick({
            h: hsl.h,
            s: 0.5,
            l: offset,
            source: "hsl"
        }, e);
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        style: styles.swatch,
        onClick: handleClick
    });
};
var $97ccb948e72df062$export$2e2bcd8739ae039 = $97ccb948e72df062$export$5c11afa672411de4;

});


parcelRegister("aY3hQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7fc20eaea7bd60dc$export$2e2bcd8739ae039; });

var $eeH7J = parcelRequire("eeH7J");

var $bJBxw = parcelRequire("bJBxw");
var $7fc20eaea7bd60dc$export$9c10b52c64965f67 = function SliderPointer() {
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($bJBxw)))({
        "default": {
            picker: {
                width: "14px",
                height: "14px",
                borderRadius: "6px",
                transform: "translate(-7px, -1px)",
                backgroundColor: "rgb(248, 248, 248)",
                boxShadow: "0 1px 4px 0 rgba(0, 0, 0, 0.37)"
            }
        }
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        style: styles.picker
    });
};
var $7fc20eaea7bd60dc$export$2e2bcd8739ae039 = $7fc20eaea7bd60dc$export$9c10b52c64965f67;

});


parcelRegister("6j91N", function(module, exports) {

var $eeH7J = parcelRequire("eeH7J");

var $4yBem = parcelRequire("4yBem");

var $bJBxw = parcelRequire("bJBxw");

var $5UnTd = parcelRequire("5UnTd");

var $5VQgV = parcelRequire("5VQgV");

var $1tumo = parcelRequire("1tumo");
parcelRequire("isDZf");
var $8bUgk = parcelRequire("8bUgk");
var $2oAlV = parcelRequire("2oAlV");

var $k6R7g = parcelRequire("k6R7g");
var $497b852eb3cf0034$export$81ebbfd13e06b049 = function Swatches(_ref) {
    var width = _ref.width, height = _ref.height, onChange = _ref.onChange, onSwatchHover = _ref.onSwatchHover, colors = _ref.colors, hex = _ref.hex, _ref$styles = _ref.styles, passedStyles = _ref$styles === undefined ? {} : _ref$styles, _ref$className = _ref.className, className = _ref$className === undefined ? "" : _ref$className;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($bJBxw)))((0, $5VQgV.default)({
        "default": {
            picker: {
                width: width,
                height: height
            },
            overflow: {
                height: height,
                overflowY: "scroll"
            },
            body: {
                padding: "16px 0 6px 16px"
            },
            clear: {
                clear: "both"
            }
        }
    }, passedStyles));
    var handleChange = function handleChange(data, e) {
        return onChange({
            hex: data,
            source: "hex"
        }, e);
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        style: styles.picker,
        className: "swatches-picker " + className
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $2oAlV.default), null, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        style: styles.overflow
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        style: styles.body
    }, (0, $5UnTd.default)(colors, function(group) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $k6R7g.default), {
            key: group.toString(),
            group: group,
            active: hex,
            onClick: handleChange,
            onSwatchHover: onSwatchHover
        });
    }), (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        style: styles.clear
    })))));
};
$497b852eb3cf0034$export$81ebbfd13e06b049.propTypes = {
    width: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).number
    ]),
    height: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).number
    ]),
    colors: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string)),
    styles: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object
};
$497b852eb3cf0034$export$81ebbfd13e06b049.defaultProps = {
    width: 320,
    height: 240,
    colors: [
        [
            $1tumo.red["900"],
            $1tumo.red["700"],
            $1tumo.red["500"],
            $1tumo.red["300"],
            $1tumo.red["100"]
        ],
        [
            $1tumo.pink["900"],
            $1tumo.pink["700"],
            $1tumo.pink["500"],
            $1tumo.pink["300"],
            $1tumo.pink["100"]
        ],
        [
            $1tumo.purple["900"],
            $1tumo.purple["700"],
            $1tumo.purple["500"],
            $1tumo.purple["300"],
            $1tumo.purple["100"]
        ],
        [
            $1tumo.deepPurple["900"],
            $1tumo.deepPurple["700"],
            $1tumo.deepPurple["500"],
            $1tumo.deepPurple["300"],
            $1tumo.deepPurple["100"]
        ],
        [
            $1tumo.indigo["900"],
            $1tumo.indigo["700"],
            $1tumo.indigo["500"],
            $1tumo.indigo["300"],
            $1tumo.indigo["100"]
        ],
        [
            $1tumo.blue["900"],
            $1tumo.blue["700"],
            $1tumo.blue["500"],
            $1tumo.blue["300"],
            $1tumo.blue["100"]
        ],
        [
            $1tumo.lightBlue["900"],
            $1tumo.lightBlue["700"],
            $1tumo.lightBlue["500"],
            $1tumo.lightBlue["300"],
            $1tumo.lightBlue["100"]
        ],
        [
            $1tumo.cyan["900"],
            $1tumo.cyan["700"],
            $1tumo.cyan["500"],
            $1tumo.cyan["300"],
            $1tumo.cyan["100"]
        ],
        [
            $1tumo.teal["900"],
            $1tumo.teal["700"],
            $1tumo.teal["500"],
            $1tumo.teal["300"],
            $1tumo.teal["100"]
        ],
        [
            "#194D33",
            $1tumo.green["700"],
            $1tumo.green["500"],
            $1tumo.green["300"],
            $1tumo.green["100"]
        ],
        [
            $1tumo.lightGreen["900"],
            $1tumo.lightGreen["700"],
            $1tumo.lightGreen["500"],
            $1tumo.lightGreen["300"],
            $1tumo.lightGreen["100"]
        ],
        [
            $1tumo.lime["900"],
            $1tumo.lime["700"],
            $1tumo.lime["500"],
            $1tumo.lime["300"],
            $1tumo.lime["100"]
        ],
        [
            $1tumo.yellow["900"],
            $1tumo.yellow["700"],
            $1tumo.yellow["500"],
            $1tumo.yellow["300"],
            $1tumo.yellow["100"]
        ],
        [
            $1tumo.amber["900"],
            $1tumo.amber["700"],
            $1tumo.amber["500"],
            $1tumo.amber["300"],
            $1tumo.amber["100"]
        ],
        [
            $1tumo.orange["900"],
            $1tumo.orange["700"],
            $1tumo.orange["500"],
            $1tumo.orange["300"],
            $1tumo.orange["100"]
        ],
        [
            $1tumo.deepOrange["900"],
            $1tumo.deepOrange["700"],
            $1tumo.deepOrange["500"],
            $1tumo.deepOrange["300"],
            $1tumo.deepOrange["100"]
        ],
        [
            $1tumo.brown["900"],
            $1tumo.brown["700"],
            $1tumo.brown["500"],
            $1tumo.brown["300"],
            $1tumo.brown["100"]
        ],
        [
            $1tumo.blueGrey["900"],
            $1tumo.blueGrey["700"],
            $1tumo.blueGrey["500"],
            $1tumo.blueGrey["300"],
            $1tumo.blueGrey["100"]
        ],
        [
            "#000000",
            "#525252",
            "#969696",
            "#D9D9D9",
            "#FFFFFF"
        ]
    ],
    styles: {}
};
var $497b852eb3cf0034$export$2e2bcd8739ae039 = (0, $8bUgk.default)($497b852eb3cf0034$export$81ebbfd13e06b049);

});
parcelRegister("k6R7g", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ea3d91f1e98d14d2$export$2e2bcd8739ae039; });

var $eeH7J = parcelRequire("eeH7J");

var $bJBxw = parcelRequire("bJBxw");

var $5UnTd = parcelRequire("5UnTd");

var $fTYss = parcelRequire("fTYss");
var $ea3d91f1e98d14d2$export$354a0399ec1ad469 = function SwatchesGroup(_ref) {
    var onClick = _ref.onClick, onSwatchHover = _ref.onSwatchHover, group = _ref.group, active = _ref.active;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($bJBxw)))({
        "default": {
            group: {
                paddingBottom: "10px",
                width: "40px",
                float: "left",
                marginRight: "10px"
            }
        }
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        style: styles.group
    }, (0, $5UnTd.default)(group, function(color, i) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $fTYss.default), {
            key: color,
            color: color,
            active: color.toLowerCase() === active,
            first: i === 0,
            last: i === group.length - 1,
            onClick: onClick,
            onSwatchHover: onSwatchHover
        });
    }));
};
var $ea3d91f1e98d14d2$export$2e2bcd8739ae039 = $ea3d91f1e98d14d2$export$354a0399ec1ad469;

});
parcelRegister("fTYss", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b93ae3c48b46815d$export$2e2bcd8739ae039; });

var $eeH7J = parcelRequire("eeH7J");

var $bJBxw = parcelRequire("bJBxw");

var $7Zkko = parcelRequire("7Zkko");
parcelRequire("isDZf");
var $2DBoi = parcelRequire("2DBoi");

var $67mcX = parcelRequire("67mcX");
var $b93ae3c48b46815d$export$af5303fde6798b43 = function SwatchesColor(_ref) {
    var color = _ref.color, _ref$onClick = _ref.onClick, onClick = _ref$onClick === undefined ? function() {} : _ref$onClick, onSwatchHover = _ref.onSwatchHover, first = _ref.first, last = _ref.last, active = _ref.active;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($bJBxw)))({
        "default": {
            color: {
                width: "40px",
                height: "24px",
                cursor: "pointer",
                background: color,
                marginBottom: "1px"
            },
            check: {
                color: $7Zkko.getContrastingColor(color),
                marginLeft: "8px",
                display: "none"
            }
        },
        "first": {
            color: {
                overflow: "hidden",
                borderRadius: "2px 2px 0 0"
            }
        },
        "last": {
            color: {
                overflow: "hidden",
                borderRadius: "0 0 2px 2px"
            }
        },
        "active": {
            check: {
                display: "block"
            }
        },
        "color-#FFFFFF": {
            color: {
                boxShadow: "inset 0 0 0 1px #ddd"
            },
            check: {
                color: "#333"
            }
        },
        "transparent": {
            check: {
                color: "#333"
            }
        }
    }, {
        first: first,
        last: last,
        active: active,
        "color-#FFFFFF": color === "#FFFFFF",
        "transparent": color === "transparent"
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $2DBoi.default), {
        color: color,
        style: styles.color,
        onClick: onClick,
        onHover: onSwatchHover,
        focusStyle: {
            boxShadow: "0 0 4px " + color
        }
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        style: styles.check
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($67mcX))), null)));
};
var $b93ae3c48b46815d$export$2e2bcd8739ae039 = $b93ae3c48b46815d$export$af5303fde6798b43;

});
parcelRegister("67mcX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $47449f912eb49cb2$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};

var $eeH7J = parcelRequire("eeH7J");
var $47449f912eb49cb2$var$_react2 = $47449f912eb49cb2$var$_interopRequireDefault($eeH7J);
function $47449f912eb49cb2$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $47449f912eb49cb2$var$_objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
var $47449f912eb49cb2$var$DEFAULT_SIZE = 24;
module.exports.default = function(_ref) {
    var _ref$fill = _ref.fill, fill = _ref$fill === undefined ? "currentColor" : _ref$fill, _ref$width = _ref.width, width = _ref$width === undefined ? $47449f912eb49cb2$var$DEFAULT_SIZE : _ref$width, _ref$height = _ref.height, height = _ref$height === undefined ? $47449f912eb49cb2$var$DEFAULT_SIZE : _ref$height, _ref$style = _ref.style, style = _ref$style === undefined ? {} : _ref$style, props = $47449f912eb49cb2$var$_objectWithoutProperties(_ref, [
        "fill",
        "width",
        "height",
        "style"
    ]);
    return $47449f912eb49cb2$var$_react2.default.createElement("svg", $47449f912eb49cb2$var$_extends({
        viewBox: "0 0 " + $47449f912eb49cb2$var$DEFAULT_SIZE + " " + $47449f912eb49cb2$var$DEFAULT_SIZE,
        style: $47449f912eb49cb2$var$_extends({
            fill: fill,
            width: width,
            height: height
        }, style)
    }, props), $47449f912eb49cb2$var$_react2.default.createElement("path", {
        d: "M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z"
    }));
};

});




parcelRegister("l9lNT", function(module, exports) {

var $eeH7J = parcelRequire("eeH7J");

var $4yBem = parcelRequire("4yBem");

var $bJBxw = parcelRequire("bJBxw");

var $5UnTd = parcelRequire("5UnTd");

var $5VQgV = parcelRequire("5VQgV");

var $7Zkko = parcelRequire("7Zkko");
parcelRequire("isDZf");
var $8bUgk = parcelRequire("8bUgk");
var $a5dMh = parcelRequire("a5dMh");
var $2DBoi = parcelRequire("2DBoi");
var $f65b5a01cf2d6872$export$9e389cdad32a5b7a = function Twitter(_ref) {
    var onChange = _ref.onChange, onSwatchHover = _ref.onSwatchHover, hex = _ref.hex, colors = _ref.colors, width = _ref.width, triangle = _ref.triangle, _ref$styles = _ref.styles, passedStyles = _ref$styles === undefined ? {} : _ref$styles, _ref$className = _ref.className, className = _ref$className === undefined ? "" : _ref$className;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($bJBxw)))((0, $5VQgV.default)({
        "default": {
            card: {
                width: width,
                background: "#fff",
                border: "0 solid rgba(0,0,0,0.25)",
                boxShadow: "0 1px 4px rgba(0,0,0,0.25)",
                borderRadius: "4px",
                position: "relative"
            },
            body: {
                padding: "15px 9px 9px 15px"
            },
            label: {
                fontSize: "18px",
                color: "#fff"
            },
            triangle: {
                width: "0px",
                height: "0px",
                borderStyle: "solid",
                borderWidth: "0 9px 10px 9px",
                borderColor: "transparent transparent #fff transparent",
                position: "absolute"
            },
            triangleShadow: {
                width: "0px",
                height: "0px",
                borderStyle: "solid",
                borderWidth: "0 9px 10px 9px",
                borderColor: "transparent transparent rgba(0,0,0,.1) transparent",
                position: "absolute"
            },
            hash: {
                background: "#F0F0F0",
                height: "30px",
                width: "30px",
                borderRadius: "4px 0 0 4px",
                float: "left",
                color: "#98A1A4",
                display: "flex",
                alignItems: "center",
                justifyContent: "center"
            },
            input: {
                width: "100px",
                fontSize: "14px",
                color: "#666",
                border: "0px",
                outline: "none",
                height: "28px",
                boxShadow: "inset 0 0 0 1px #F0F0F0",
                boxSizing: "content-box",
                borderRadius: "0 4px 4px 0",
                float: "left",
                paddingLeft: "8px"
            },
            swatch: {
                width: "30px",
                height: "30px",
                float: "left",
                borderRadius: "4px",
                margin: "0 6px 6px 0"
            },
            clear: {
                clear: "both"
            }
        },
        "hide-triangle": {
            triangle: {
                display: "none"
            },
            triangleShadow: {
                display: "none"
            }
        },
        "top-left-triangle": {
            triangle: {
                top: "-10px",
                left: "12px"
            },
            triangleShadow: {
                top: "-11px",
                left: "12px"
            }
        },
        "top-right-triangle": {
            triangle: {
                top: "-10px",
                right: "12px"
            },
            triangleShadow: {
                top: "-11px",
                right: "12px"
            }
        }
    }, passedStyles), {
        "hide-triangle": triangle === "hide",
        "top-left-triangle": triangle === "top-left",
        "top-right-triangle": triangle === "top-right"
    });
    var handleChange = function handleChange(hexcode, e) {
        $7Zkko.isValidHex(hexcode) && onChange({
            hex: hexcode,
            source: "hex"
        }, e);
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        style: styles.card,
        className: "twitter-picker " + className
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        style: styles.triangleShadow
    }), (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        style: styles.triangle
    }), (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        style: styles.body
    }, (0, $5UnTd.default)(colors, function(c, i) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $2DBoi.default), {
            key: i,
            color: c,
            hex: c,
            style: styles.swatch,
            onClick: handleChange,
            onHover: onSwatchHover,
            focusStyle: {
                boxShadow: "0 0 4px " + c
            }
        });
    }), (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        style: styles.hash
    }, "#"), (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $a5dMh.default), {
        label: null,
        style: {
            input: styles.input
        },
        value: hex.replace("#", ""),
        onChange: handleChange
    }), (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        style: styles.clear
    })));
};
$f65b5a01cf2d6872$export$9e389cdad32a5b7a.propTypes = {
    width: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).number
    ]),
    triangle: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOf([
        "hide",
        "top-left",
        "top-right"
    ]),
    colors: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string),
    styles: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object
};
$f65b5a01cf2d6872$export$9e389cdad32a5b7a.defaultProps = {
    width: 276,
    colors: [
        "#FF6900",
        "#FCB900",
        "#7BDCB5",
        "#00D084",
        "#8ED1FC",
        "#0693E3",
        "#ABB8C3",
        "#EB144C",
        "#F78DA7",
        "#9900EF"
    ],
    triangle: "top-left",
    styles: {}
};
var $f65b5a01cf2d6872$export$2e2bcd8739ae039 = (0, $8bUgk.default)($f65b5a01cf2d6872$export$9e389cdad32a5b7a);

});

parcelRegister("bxThk", function(module, exports) {

var $eeH7J = parcelRequire("eeH7J");

var $4yBem = parcelRequire("4yBem");

var $bJBxw = parcelRequire("bJBxw");

var $5VQgV = parcelRequire("5VQgV");
parcelRequire("isDZf");
var $8bUgk = parcelRequire("8bUgk");
var $gnp1P = parcelRequire("gnp1P");
var $ejwzz = parcelRequire("ejwzz");

var $nNOy7 = parcelRequire("nNOy7");

var $lsoJC = parcelRequire("lsoJC");

var $5O3aA = parcelRequire("5O3aA");
var $867da7f194b7f614$export$347eee6e8bf67997 = function Google(_ref) {
    var width = _ref.width, onChange = _ref.onChange, rgb = _ref.rgb, hsl = _ref.hsl, hsv = _ref.hsv, hex = _ref.hex, header = _ref.header, _ref$styles = _ref.styles, passedStyles = _ref$styles === undefined ? {} : _ref$styles, _ref$className = _ref.className, className = _ref$className === undefined ? "" : _ref$className;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($bJBxw)))((0, $5VQgV.default)({
        "default": {
            picker: {
                width: width,
                background: "#fff",
                border: "1px solid #dfe1e5",
                boxSizing: "initial",
                display: "flex",
                flexWrap: "wrap",
                borderRadius: "8px 8px 0px 0px"
            },
            head: {
                height: "57px",
                width: "100%",
                paddingTop: "16px",
                paddingBottom: "16px",
                paddingLeft: "16px",
                fontSize: "20px",
                boxSizing: "border-box",
                fontFamily: "Roboto-Regular,HelveticaNeue,Arial,sans-serif"
            },
            saturation: {
                width: "70%",
                padding: "0px",
                position: "relative",
                overflow: "hidden"
            },
            swatch: {
                width: "30%",
                height: "228px",
                padding: "0px",
                background: "rgba(" + rgb.r + ", " + rgb.g + ", " + rgb.b + ", 1)",
                position: "relative",
                overflow: "hidden"
            },
            body: {
                margin: "auto",
                width: "95%"
            },
            controls: {
                display: "flex",
                boxSizing: "border-box",
                height: "52px",
                paddingTop: "22px"
            },
            color: {
                width: "32px"
            },
            hue: {
                height: "8px",
                position: "relative",
                margin: "0px 16px 0px 16px",
                width: "100%"
            },
            Hue: {
                radius: "2px"
            }
        }
    }, passedStyles));
    return (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        style: styles.picker,
        className: "google-picker " + className
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        style: styles.head
    }, header), (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        style: styles.swatch
    }), (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        style: styles.saturation
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $ejwzz.default), {
        hsl: hsl,
        hsv: hsv,
        pointer: (0, $nNOy7.default),
        onChange: onChange
    })), (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        style: styles.body
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        style: styles.controls,
        className: "flexbox-fix"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        style: styles.hue
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $gnp1P.default), {
        style: styles.Hue,
        hsl: hsl,
        radius: "4px",
        pointer: (0, $lsoJC.default),
        onChange: onChange
    }))), (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $5O3aA.default), {
        rgb: rgb,
        hsl: hsl,
        hex: hex,
        hsv: hsv,
        onChange: onChange
    })));
};
$867da7f194b7f614$export$347eee6e8bf67997.propTypes = {
    width: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).number
    ]),
    styles: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).object,
    header: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).string
};
$867da7f194b7f614$export$347eee6e8bf67997.defaultProps = {
    width: 652,
    styles: {},
    header: "Color picker"
};
var $867da7f194b7f614$export$2e2bcd8739ae039 = (0, $8bUgk.default)($867da7f194b7f614$export$347eee6e8bf67997);

});
parcelRegister("nNOy7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0478ca2e91807913$export$2e2bcd8739ae039; });

var $eeH7J = parcelRequire("eeH7J");

var $bJBxw = parcelRequire("bJBxw");

var $4yBem = parcelRequire("4yBem");
var $0478ca2e91807913$export$a928e0fe8b70765d = function GooglePointerCircle(props) {
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($bJBxw)))({
        "default": {
            picker: {
                width: "20px",
                height: "20px",
                borderRadius: "22px",
                border: "2px #fff solid",
                transform: "translate(-12px, -13px)",
                background: "hsl(" + Math.round(props.hsl.h) + ", " + Math.round(props.hsl.s * 100) + "%, " + Math.round(props.hsl.l * 100) + "%)"
            }
        }
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        style: styles.picker
    });
};
$0478ca2e91807913$export$a928e0fe8b70765d.propTypes = {
    hsl: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).shape({
        h: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).number,
        s: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).number,
        l: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).number,
        a: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).number
    })
};
$0478ca2e91807913$export$a928e0fe8b70765d.defaultProps = {
    hsl: {
        a: 1,
        h: 249.94,
        l: 0.2,
        s: 0.50
    }
};
var $0478ca2e91807913$export$2e2bcd8739ae039 = $0478ca2e91807913$export$a928e0fe8b70765d;

});

parcelRegister("lsoJC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f9ef6655b7cdc44f$export$2e2bcd8739ae039; });

var $eeH7J = parcelRequire("eeH7J");

var $bJBxw = parcelRequire("bJBxw");

var $4yBem = parcelRequire("4yBem");
var $f9ef6655b7cdc44f$export$9de61b9626feed9a = function GooglePointer(props) {
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($bJBxw)))({
        "default": {
            picker: {
                width: "20px",
                height: "20px",
                borderRadius: "22px",
                transform: "translate(-10px, -7px)",
                background: "hsl(" + Math.round(props.hsl.h) + ", 100%, 50%)",
                border: "2px white solid"
            }
        }
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        style: styles.picker
    });
};
$f9ef6655b7cdc44f$export$9de61b9626feed9a.propTypes = {
    hsl: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).shape({
        h: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).number,
        s: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).number,
        l: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).number,
        a: (0, (/*@__PURE__*/$parcel$interopDefault($4yBem))).number
    })
};
$f9ef6655b7cdc44f$export$9de61b9626feed9a.defaultProps = {
    hsl: {
        a: 1,
        h: 249.94,
        l: 0.2,
        s: 0.50
    }
};
var $f9ef6655b7cdc44f$export$2e2bcd8739ae039 = $f9ef6655b7cdc44f$export$9de61b9626feed9a;

});

parcelRegister("5O3aA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $43a414bbd8f3d0f8$export$2e2bcd8739ae039; });

var $eeH7J = parcelRequire("eeH7J");

var $bJBxw = parcelRequire("bJBxw");

var $7Zkko = parcelRequire("7Zkko");
parcelRequire("isDZf");
var $a5dMh = parcelRequire("a5dMh");
var $43a414bbd8f3d0f8$export$e50902ed332e5599 = function GoogleFields(_ref) {
    var onChange = _ref.onChange, rgb = _ref.rgb, hsl = _ref.hsl, hex = _ref.hex, hsv = _ref.hsv;
    var handleChange = function handleChange(data, e) {
        if (data.hex) $7Zkko.isValidHex(data.hex) && onChange({
            hex: data.hex,
            source: "hex"
        }, e);
        else if (data.rgb) {
            var values = data.rgb.split(",");
            $7Zkko.isvalidColorString(data.rgb, "rgb") && onChange({
                r: values[0],
                g: values[1],
                b: values[2],
                a: 1,
                source: "rgb"
            }, e);
        } else if (data.hsv) {
            var _values = data.hsv.split(",");
            if ($7Zkko.isvalidColorString(data.hsv, "hsv")) {
                _values[2] = _values[2].replace("%", "");
                _values[1] = _values[1].replace("%", "");
                _values[0] = _values[0].replace("\xb0", "");
                if (_values[1] == 1) _values[1] = 0.01;
                else if (_values[2] == 1) _values[2] = 0.01;
                onChange({
                    h: Number(_values[0]),
                    s: Number(_values[1]),
                    v: Number(_values[2]),
                    source: "hsv"
                }, e);
            }
        } else if (data.hsl) {
            var _values2 = data.hsl.split(",");
            if ($7Zkko.isvalidColorString(data.hsl, "hsl")) {
                _values2[2] = _values2[2].replace("%", "");
                _values2[1] = _values2[1].replace("%", "");
                _values2[0] = _values2[0].replace("\xb0", "");
                if (hsvValue[1] == 1) hsvValue[1] = 0.01;
                else if (hsvValue[2] == 1) hsvValue[2] = 0.01;
                onChange({
                    h: Number(_values2[0]),
                    s: Number(_values2[1]),
                    v: Number(_values2[2]),
                    source: "hsl"
                }, e);
            }
        }
    };
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($bJBxw)))({
        "default": {
            wrap: {
                display: "flex",
                height: "100px",
                marginTop: "4px"
            },
            fields: {
                width: "100%"
            },
            column: {
                paddingTop: "10px",
                display: "flex",
                justifyContent: "space-between"
            },
            double: {
                padding: "0px 4.4px",
                boxSizing: "border-box"
            },
            input: {
                width: "100%",
                height: "38px",
                boxSizing: "border-box",
                padding: "4px 10% 3px",
                textAlign: "center",
                border: "1px solid #dadce0",
                fontSize: "11px",
                textTransform: "lowercase",
                borderRadius: "5px",
                outline: "none",
                fontFamily: "Roboto,Arial,sans-serif"
            },
            input2: {
                height: "38px",
                width: "100%",
                border: "1px solid #dadce0",
                boxSizing: "border-box",
                fontSize: "11px",
                textTransform: "lowercase",
                borderRadius: "5px",
                outline: "none",
                paddingLeft: "10px",
                fontFamily: "Roboto,Arial,sans-serif"
            },
            label: {
                textAlign: "center",
                fontSize: "12px",
                background: "#fff",
                position: "absolute",
                textTransform: "uppercase",
                color: "#3c4043",
                width: "35px",
                top: "-6px",
                left: "0",
                right: "0",
                marginLeft: "auto",
                marginRight: "auto",
                fontFamily: "Roboto,Arial,sans-serif"
            },
            label2: {
                left: "10px",
                textAlign: "center",
                fontSize: "12px",
                background: "#fff",
                position: "absolute",
                textTransform: "uppercase",
                color: "#3c4043",
                width: "32px",
                top: "-6px",
                fontFamily: "Roboto,Arial,sans-serif"
            },
            single: {
                flexGrow: "1",
                margin: "0px 4.4px"
            }
        }
    });
    var rgbValue = rgb.r + ", " + rgb.g + ", " + rgb.b;
    var hslValue = Math.round(hsl.h) + "\xb0, " + Math.round(hsl.s * 100) + "%, " + Math.round(hsl.l * 100) + "%";
    var hsvValue = Math.round(hsv.h) + "\xb0, " + Math.round(hsv.s * 100) + "%, " + Math.round(hsv.v * 100) + "%";
    return (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        style: styles.wrap,
        className: "flexbox-fix"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        style: styles.fields
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        style: styles.double
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $a5dMh.default), {
        style: {
            input: styles.input,
            label: styles.label
        },
        label: "hex",
        value: hex,
        onChange: handleChange
    })), (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        style: styles.column
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        style: styles.single
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $a5dMh.default), {
        style: {
            input: styles.input2,
            label: styles.label2
        },
        label: "rgb",
        value: rgbValue,
        onChange: handleChange
    })), (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        style: styles.single
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $a5dMh.default), {
        style: {
            input: styles.input2,
            label: styles.label2
        },
        label: "hsv",
        value: hsvValue,
        onChange: handleChange
    })), (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("div", {
        style: styles.single
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, $a5dMh.default), {
        style: {
            input: styles.input2,
            label: styles.label2
        },
        label: "hsl",
        value: hslValue,
        onChange: handleChange
    })))));
};
var $43a414bbd8f3d0f8$export$2e2bcd8739ae039 = $43a414bbd8f3d0f8$export$e50902ed332e5599;

});




parcelRegister("ft2ED", function(module, exports) {

$parcel$export(module.exports, "ListPropView", function () { return $b42b9f90e20abc9c$export$b039e7395e9f45bf; });

var $4vwom = parcelRequire("4vwom");
parcelRequire("2LTO8");
var $8h5s0 = parcelRequire("8h5s0");
var $5c9Ym = parcelRequire("5c9Ym");
var $3LK53 = parcelRequire("3LK53");
var $cwhCA = parcelRequire("cwhCA");
var $43jhg = parcelRequire("43jhg");
var $dAwef = parcelRequire("dAwef");

var $le0UN = parcelRequire("le0UN");

var $eeH7J = parcelRequire("eeH7J");
parcelRequire("jniej");
var $gaj8U = parcelRequire("gaj8U");
var $eK8Q4 = parcelRequire("eK8Q4");

var $fT6Pt = parcelRequire("fT6Pt");

var $efVcO = parcelRequire("efVcO");

var $6cx8r = parcelRequire("6cx8r");

var $hRViu = parcelRequire("hRViu");

var $eBaY3 = parcelRequire("eBaY3");

var $aCefG = parcelRequire("aCefG");

var $6sp4J = parcelRequire("6sp4J");

var $jJ9YT = parcelRequire("jJ9YT");

var $9SFXB = parcelRequire("9SFXB");

var $4rY0U = parcelRequire("4rY0U");

var $lUciB = parcelRequire("lUciB");

var $7c6pE = parcelRequire("7c6pE");

var $hXi3j = parcelRequire("hXi3j");

var $fz3r9 = parcelRequire("fz3r9");

var $dUDPg = parcelRequire("dUDPg");

var $ikBJm = parcelRequire("ikBJm");

var $knIBr = parcelRequire("knIBr");

var $lWmEE = parcelRequire("lWmEE");

var $5Dc48 = parcelRequire("5Dc48");

var $9Q5xE = parcelRequire("9Q5xE");

var $cSf8f = parcelRequire("cSf8f");

var $aIeEI = parcelRequire("aIeEI");

var $1TOtF = parcelRequire("1TOtF");

var $cXoc2 = parcelRequire("cXoc2");

var $aw3rr = parcelRequire("aw3rr");

var $1aVVn = parcelRequire("1aVVn");

var $f8cmx = parcelRequire("f8cmx");
function $b42b9f90e20abc9c$var$canInline(t) {
    return (0, $43jhg.IsStringType)(t) || (0, $43jhg.IsNumberType)(t) || (0, $43jhg.IsFileType)(t) || (0, $43jhg.IsUnionType)(t) && t.union.every($b42b9f90e20abc9c$var$canInline);
}
function $b42b9f90e20abc9c$export$b039e7395e9f45bf({ buttons: buttons, label: label, property: property, obj: obj, hideBadge: hideBadge, isRoot: isRoot }) {
    var _a, _b, _c;
    const { type: type, name: name, tags: tags, description: description } = property;
    const arr = (0, $1aVVn.YTools).get(obj, property.name);
    if (arr && !(arr instanceof $aw3rr.Array)) throw new Error("Expected Y.Array");
    if (!(0, $43jhg.IsArrayType)(type)) throw new Error();
    const expand = tags === null || tags === void 0 ? void 0 : tags.expand;
    const [show, setShow] = (0, $eeH7J.useState)(expand);
    /** Objects that have been newly created and should therefore have readonly
     * fields editable until saved. */ const [newlyCreated, setNewlyCreated] = (0, $eeH7J.useState)([]);
    const locale = (0, $aIeEI.useCurrentLocale)();
    const { updateableSubtree: updateableSubtree } = (0, $eeH7J.useContext)((0, $eBaY3.ReadonlyContext));
    const isReadonly = (0, $eBaY3.useIsReadonlyField)(property);
    const [mode, setMode] = (0, $eK8Q4.usePreference)(`listmode-${(0, $43jhg.TypeToString)(type.array)}`, ((_a = property.tags) === null || _a === void 0 ? void 0 : _a.grid) ? "grid" : "regular");
    const shallowLocked = (_b = property.tags) === null || _b === void 0 ? void 0 : _b.shallowLocked;
    const hasValues = !!arr;
    const isLocked = isReadonly || shallowLocked;
    const addButton = !hasValues && !isLocked && (0, $4vwom.jsx)((0, $fT6Pt.RButton), {
        variant: "secondary",
        onClick: ()=>{
            const newObj = (0, $5c9Ym.CreateDefault)(type.array, (0, $5c9Ym.UninitializedDefaults), locale);
            setNewlyCreated([
                ...newlyCreated,
                newObj
            ]);
            (0, $1aVVn.YTools).set(obj, property.name, (0, $1aVVn.YTools).valueToYValue([
                newObj
            ]));
        },
        children: (0, $cSf8f.Translations).Add()
    });
    let content = isReadonly && !arr ? (0, $4vwom.jsx)((0, $hXi3j.None), {}) : (0, $4vwom.jsx)((0, $eBaY3.ReadonlyContext).Provider, {
        value: {
            mode: isReadonly ? "readonly" : "edit",
            updateableSubtree: updateableSubtree
        },
        children: (hideBadge || show) && arr && (0, $4vwom.jsx)($b42b9f90e20abc9c$var$MasterDetailView, {
            propName: name,
            arr: arr,
            inline: $b42b9f90e20abc9c$var$canInline(type.array),
            newlyCreated: newlyCreated,
            isReadonly: isReadonly,
            isRoot: isRoot,
            itemType: type.array,
            children: (0, $4vwom.jsx)($b42b9f90e20abc9c$export$84d0dd190d551cd1, {
                path: [],
                newlyCreated: newlyCreated,
                setNewlyCreated: setNewlyCreated,
                property: property,
                obj: obj,
                isReadonly: isReadonly,
                isRoot: isRoot,
                itemIcon: ((_c = property.tags) === null || _c === void 0 ? void 0 : _c.icon) || undefined
            })
        })
    });
    if (mode === "grid") content = (0, $4vwom.jsx)((0, $5Dc48.GridView), {
        property: property,
        obj: obj
    });
    return (0, $4vwom.jsx)((0, $eBaY3.ObjectPathProvider), {
        name: property.name,
        obj: obj,
        type: property.type,
        children: (0, $4vwom.jsx)((0, $aCefG.CollapseContext).Provider, {
            value: {
                collapse () {
                    setShow(false);
                }
            },
            children: isRoot ? (0, $4vwom.jsxs)((0, $4vwom.Fragment), {
                children: [
                    addButton,
                    content
                ]
            }) : (0, $4vwom.jsx)((0, $hRViu.PropRow), {
                isReadonly: isReadonly,
                buttons: [
                    ...buttons,
                    {
                        text: mode === "regular" ? "Grid mode" : "Disable grid mode",
                        onClick: ()=>setMode(mode === "regular" ? "grid" : "regular")
                    }
                ],
                description: description,
                descriptionAbove: true,
                label: label,
                badge: !hideBadge && (0, $4vwom.jsxs)((0, $4vwom.Fragment), {
                    children: [
                        arr && !expand && (0, $4vwom.jsx)((0, $fT6Pt.RButton), {
                            style: {
                                marginTop: 8
                            },
                            chevron: !show ? "chevron-down" : "chevron-up",
                            onClick: ()=>setShow(!show),
                            children: arr.length
                        }),
                        addButton
                    ]
                }),
                children: content
            })
        })
    });
}
const $b42b9f90e20abc9c$var$masterDetailContext = /*#__PURE__*/ (0, $eeH7J.createContext)(null);
const $b42b9f90e20abc9c$var$uniqueKeyMap = new WeakMap();
function $b42b9f90e20abc9c$var$MasterDetailView({ itemType: itemType, arr: arr, children: children, inline: inline, propName: propName, isRoot: isRoot, isReadonly: isReadonly, newlyCreated: newlyCreated }) {
    // Conditional hook should be safe, since `isRoot` is constant
    if (isRoot) (0, $lWmEE.useFullHeight)();
    const listRef = (0, $eeH7J.useRef)(null);
    const settingsNamespace = (0, $jJ9YT.useSettingsNamespace)();
    const [width, setWidth] = (0, $eK8Q4.usePreference)(`${settingsNamespace}-${propName}-width`, 400);
    const { hover: hover, hoverProps: hoverProps } = (0, $fz3r9.useHover)();
    const { drawBorders: drawBorders } = (0, $eeH7J.useContext)((0, $lUciB.BorderContext));
    const selectionContext = (0, $eeH7J.useContext)((0, $knIBr.SelectionContext));
    const [selectedPath, select] = (0, $eeH7J.useState)([]);
    const selectedObject = (0, $cXoc2.ResolveObjectPath)(arr, selectedPath);
    const selectedObjectParent = selectedPath.length === 0 ? undefined : (0, $cXoc2.ResolveObjectPath)(arr, selectedPath.slice(0, -1));
    if (selectedObjectParent && !(selectedObjectParent instanceof $aw3rr.Array || selectedObjectParent instanceof $aw3rr.Map)) throw new Error("Expected Y.Array or Y.Map");
    const selectedIndex = selectedPath.length ? selectedPath.slice(-1)[0].toString() : undefined;
    const selectedObjectType = (0, $cXoc2.ResolveObjectPathType)({
        array: itemType
    }, arr, selectedPath);
    return (0, $4vwom.jsx)($b42b9f90e20abc9c$var$masterDetailContext.Provider, {
        value: {
            selectedPath: selectedPath,
            selectedObject: selectedObject,
            select (path, wasDragDrop) {
                if (selectionContext) {
                    if (wasDragDrop) return; // Don't select when drag-dropping in selection context
                    const obj = (0, $cXoc2.ResolveObjectPath)(arr, path);
                    const type = (0, $cXoc2.ResolveObjectPathType)({
                        array: itemType
                    }, arr, path);
                    if (type) selectionContext.setSelectedObject((0, $f8cmx.YProxy)(obj), type);
                } else select(path);
            }
        },
        children: (0, $4vwom.jsxs)("div", {
            style: {
                color: (0, $9Q5xE.ColorStyles).gray[600],
                display: "flex",
                flexDirection: "row",
                width: "100%",
                height: "100%"
            },
            children: [
                (0, $4vwom.jsx)((0, $lUciB.BorderContext).Provider, {
                    value: {
                        drawBorders: false
                    },
                    children: (0, $4vwom.jsx)("div", {
                        ref: listRef,
                        style: {
                            width: selectedPath.length && !inline ? width : "100%",
                            height: isRoot ? "100%" : undefined,
                            overflowX: "clip",
                            overflowY: "auto",
                            border: !isRoot && drawBorders ? `1px solid ${(0, $9Q5xE.ColorStyles).gray[200]}` : undefined,
                            borderRadius: !isRoot ? 8 : undefined
                        },
                        children: children
                    })
                }),
                selectedPath.length > 0 && !inline && (0, $4vwom.jsx)("div", Object.assign({}, hoverProps, {
                    onPointerDown: (e)=>{
                        e.target.setPointerCapture(e.pointerId);
                    },
                    onPointerUp: (e)=>{
                        e.target.releasePointerCapture(e.pointerId);
                    },
                    onMouseMove: (e)=>{
                        if (e.buttons && typeof width === "number") setWidth(width + e.movementX);
                    },
                    style: {
                        width: 12,
                        borderLeft: hover ? "1px solid " + (0, $9Q5xE.ColorStyles).primary[500] : undefined,
                        cursor: "ew-resize"
                    }
                })),
                selectedIndex && selectedObjectType && !inline && selectedObjectParent && (0, $4vwom.jsx)("div", {
                    style: {
                        flex: 1,
                        display: "flex",
                        flexDirection: "column",
                        // Some padding at the bottom makes it more pleasant to scroll to the bottom
                        paddingBottom: isRoot ? 256 : 0,
                        height: isRoot ? "100%" : undefined,
                        overflowY: isRoot ? "scroll" : undefined
                    },
                    children: (0, $4vwom.jsx)((0, $eBaY3.ReadonlyContext).Provider, {
                        value: {
                            mode: isReadonly ? "readonly" : newlyCreated.includes(arr[selectedIndex]) ? "create" : "edit"
                        },
                        children: (0, $4vwom.jsx)($b42b9f90e20abc9c$var$NestedPathProvider, {
                            path: selectedPath.slice(0, selectedPath.length - 1),
                            obj: arr,
                            children: (0, $4vwom.jsx)((0, $6cx8r.PropView), {
                                obj: selectedObjectParent,
                                mode: "inline",
                                isEmbedded: true,
                                property: {
                                    name: selectedIndex,
                                    type: (0, $cwhCA.SubstituteAndDiscriminate)(selectedObject instanceof $aw3rr.Array || selectedObject instanceof $aw3rr.Map ? (0, $1aVVn.YTools).valueToJSON(selectedObject) : selectedObject, selectedObjectType),
                                    isReadonly: false
                                },
                                buttons: []
                            })
                        })
                    })
                }, (()=>{
                    // If we have an "id" field, use that directly to avoid glitches
                    if (selectedObject && typeof selectedObject === "object" && "id" in selectedObject && typeof selectedObject.id === "string" && selectedObject.id // avoid empty strings
                    ) return selectedObject.id;
                    let res = $b42b9f90e20abc9c$var$uniqueKeyMap.get(selectedObjectParent);
                    if (res === undefined) $b42b9f90e20abc9c$var$uniqueKeyMap.set(selectedObjectParent, res = `${Math.random()}`);
                    return res + selectedIndex;
                })())
            ]
        })
    });
}
function $b42b9f90e20abc9c$var$NestedPathProvider({ path: path, obj: obj, children: children }) {
    if (path.length === 0) return (0, $4vwom.jsx)((0, $4vwom.Fragment), {
        children: children
    });
    const p = path[0];
    return (0, $4vwom.jsx)((0, $eBaY3.ObjectPathProvider), {
        obj: obj,
        name: path[0],
        type: "unknown",
        children: (0, $4vwom.jsx)($b42b9f90e20abc9c$var$NestedPathProvider, {
            path: path.slice(1),
            obj: obj instanceof $aw3rr.Array ? obj.get(typeof p === "number" ? p : parseInt(p)) : obj ? obj[p] : undefined,
            children: children
        })
    });
}
function $b42b9f90e20abc9c$export$84d0dd190d551cd1({ property: property, obj: obj, itemIcon: itemIcon, path: path, isReadonly: isReadonly, isRoot: isRoot, newlyCreated: newlyCreated, setNewlyCreated: setNewlyCreated }) {
    var _a, _b, _c, _d;
    const arr = (0, $1aVVn.YTools).getArray(obj, property.name);
    const arrType = property.type;
    const itemType = arrType.array;
    const props = (0, $43jhg.GetTypeProps)(itemType);
    const titleProp = props.find((p)=>{
        var _a;
        return (_a = p.tags) === null || _a === void 0 ? void 0 : _a.title;
    });
    const { select: select, selectedObject: selectedObject } = (0, $8h5s0.Assert)((0, $eeH7J.useContext)($b42b9f90e20abc9c$var$masterDetailContext));
    const locale = (0, $aIeEI.useCurrentLocale)();
    const doc = (0, $1TOtF.useDocument)();
    const refresh = (0, $1TOtF.useDocumentRefresh)();
    const listRef = (0, $eeH7J.useRef)(null);
    const typeAlias = (0, $43jhg.GetTypeAlias)(itemType);
    const debouncedViewProps = (0, $gaj8U.useDebounceContent)(arr.length && typeAlias ? {
        objects: arr.map((o)=>({
                obj: (0, $1aVVn.YTools).valueToJSON(o),
                typeAlias: typeAlias
            })),
        document: doc ? (0, $1aVVn.YTools).valueToJSON(doc) : undefined
    } : null, 500, // Don' fetch while we are editing a field, as this will make the editor
    // sluggish for large documents.
    typeof document !== "undefined" ? (_a = listRef.current) === null || _a === void 0 ? void 0 : _a.contains(document.activeElement) : false);
    const { data: views } = (0, $dUDPg.useDocumentObjectView)(debouncedViewProps);
    const isShallowLocked = (_b = property.tags) === null || _b === void 0 ? void 0 : _b.shallowLocked;
    const inline = $b42b9f90e20abc9c$var$canInline(itemType);
    const [objectKeys] = (0, $eeH7J.useState)(new Map());
    const optionsFunc = ((_c = property.tags) === null || _c === void 0 ? void 0 : _c.options) || undefined;
    const showIndex = !!((_d = property.tags) === null || _d === void 0 ? void 0 : _d.showIndex);
    const getEntityKey = (0, $eeH7J.useCallback)((entity)=>{
        const existing = objectKeys.get(entity);
        if (existing) return existing;
        let key;
        if (entity instanceof $aw3rr.Map) key = entity.get("id");
        else if (typeof entity === "string" && (0, $dAwef.Uuid).pattern.test(entity)) key = entity;
        key !== null && key !== void 0 ? key : key = (0, $dAwef.Uuid)().valueOf();
        objectKeys.set(entity, key);
        return key;
    }, [
        objectKeys
    ]);
    async function addNew() {
        var _a, _b, _c;
        async function findInstanceType() {
            const alias = (0, $43jhg.GetTypeAlias)(arrType.array);
            if (alias === "Section" || alias === "EmailSection" || (0, $43jhg.IsUnionType)(arrType.array)) {
                if (alias) {
                    const res = await (0, $ikBJm.Modal)((close)=>(0, $4vwom.jsx)((0, $7c6pE.DocumentPicker), {
                            collection: alias,
                            current: undefined,
                            cancel: ()=>close(undefined),
                            itemName: {
                                en: (0, $8h5s0.prettyCamel)(alias, false) + " type"
                            },
                            itemSelected: (row)=>close(row)
                        }));
                    if (res === undefined) return; // User cancelled
                    const pk = res === null || res === void 0 ? void 0 : res._primaryKey;
                    if (typeof pk === "string") return (0, $cwhCA.GetType)(pk);
                }
            }
            return itemType;
        }
        const instanceType = await findInstanceType();
        if (!instanceType) return;
        if (typeof instanceType === "object" && instanceType.reference) {
            const collectionOrOptions = (_b = (_a = property.tags) === null || _a === void 0 ? void 0 : _a.options) !== null && _b !== void 0 ? _b : (_c = (0, $cwhCA.GetReflectionInfo)().collections.find((c)=>{
                var _a;
                return (0, $43jhg.GetTypeAlias)(c.type.typeArgs[0]) === ((_a = instanceType.reference) === null || _a === void 0 ? void 0 : _a.typeName);
            })) === null || _c === void 0 ? void 0 : _c.name;
            if (!collectionOrOptions) throw new Error("Collection or options function for reference not found: " + JSON.stringify(instanceType.reference));
            const picked = await (0, $ikBJm.Modal)((close)=>{
                var _a;
                return (0, $4vwom.jsx)((0, $7c6pE.DocumentPicker), {
                    collection: collectionOrOptions,
                    current: "value goes here",
                    document: doc,
                    itemSelected: (row)=>close(row),
                    cancel: ()=>close(undefined),
                    obj: obj,
                    refKey: (_a = instanceType.reference) === null || _a === void 0 ? void 0 : _a.fieldName
                });
            });
            if (picked) {
                if (!picked._primaryKey) alert("No primary key");
                const pos = arr.length;
                arr.insert(pos, [
                    picked._primaryKey
                ]);
                select([
                    ...path,
                    pos
                ]);
                if (refresh) refresh();
            }
            return;
        }
        const newObj = (0, $1aVVn.YTools).valueToYValue((0, $5c9Ym.CreateDefault)(instanceType, (0, $5c9Ym.UninitializedArrayValue), locale));
        setNewlyCreated([
            ...newlyCreated,
            newObj
        ]);
        const pos = arr.length;
        // Y.js does not support inserting `undefined` into an array, so we
        // represent that as `null`, if it happens to be the `undefined` due to
        // tweaked defaults.
        arr.insert(pos, [
            newObj === undefined ? null : newObj
        ]);
        select([
            ...path,
            pos
        ]);
        if (refresh) refresh();
    }
    return (0, $4vwom.jsx)((0, $aCefG.ListContext).Provider, {
        value: {
            optionsFunc: optionsFunc,
            showIndex: showIndex
        },
        children: (0, $4vwom.jsx)((0, $efVcO.DragDropContext), {
            onDragEnd: (result)=>{
                if (!result.destination) return;
                const src = result.source.index;
                const dst = result.destination.index;
                if (arr.doc) $aw3rr.transact(arr.doc, ()=>{
                    // Y.js does not support move semantics
                    // https://discuss.yjs.dev/t/moving-elements-in-lists/92/19
                    // So we have to copy the item, delete the original
                    // and insert the copy at the new position
                    const item = (0, $1aVVn.YTools).valueToYValue((0, $1aVVn.YTools).valueToJSON(arr.get(src)));
                    arr.delete(src, 1);
                    arr.insert(dst, [
                        item
                    ]);
                });
                // Since views take some time to re-calculate, let's predict it locally to avoid
                // popping
                if (views) {
                    const [removedView] = views.views.splice(src, 1);
                    views.views.splice(dst, 0, removedView);
                }
                if (selectedObject) select([
                    ...path,
                    result.destination.index
                ], true);
                if (refresh) refresh();
            },
            children: (0, $4vwom.jsx)("div", {
                ref: listRef,
                style: {
                    width: "100%"
                },
                children: (0, $4vwom.jsx)((0, $efVcO.Droppable), {
                    droppableId: "droppable",
                    children: (provided, snapshot)=>{
                        var _a, _b, _c;
                        return (0, $4vwom.jsxs)("div", Object.assign({}, provided.droppableProps, {
                            ref: provided.innerRef,
                            children: [
                                arr.map((entity, i)=>{
                                    let widget = (views ? views.views[i] : titleProp ? entity instanceof $aw3rr.Map || entity instanceof $aw3rr.Array ? (0, $1aVVn.YTools).get(entity, titleProp.name) : entity[titleProp.name] : undefined) || `${typeAlias || "Item"} ${i + 1}`;
                                    if (widget instanceof $aw3rr.Map) widget = (0, $1aVVn.YTools).valueToJSON(widget);
                                    const key = entity === null || typeof entity === "string" ? i.toString() : getEntityKey(entity);
                                    return (0, $4vwom.jsx)($b42b9f90e20abc9c$var$ListItem, {
                                        id: key,
                                        path: [
                                            ...path,
                                            i
                                        ],
                                        index: i,
                                        icon: itemIcon,
                                        type: arrType,
                                        arr: arr,
                                        newlyCreated: newlyCreated,
                                        setNewlyCreated: setNewlyCreated,
                                        inline: inline ? {
                                            arr: arr,
                                            type: itemType
                                        } : undefined,
                                        widget: (0, $9SFXB.ExtractPrimaryItemFromWidget)(widget),
                                        containsErrors: (0, $43jhg.MatchesType)((0, $1aVVn.YTools).valueToJSON(entity), arrType.array) !== true,
                                        duplicate: ()=>{
                                            const newObj = (0, $1aVVn.YTools).valueToYValue((0, $le0UN.Duplicate)((0, $1aVVn.YTools).valueToJSON(entity), arrType.array));
                                            arr.insert(i + 1, [
                                                newObj
                                            ]);
                                            if (refresh) refresh();
                                        },
                                        remove: ()=>{
                                            arr.delete(i, 1);
                                            if (i - 1 < 0) select(path);
                                            else select([
                                                ...path,
                                                i - 1
                                            ]);
                                            if (refresh) refresh();
                                        },
                                        isReadonly: isReadonly,
                                        isRoot: isRoot,
                                        isShallowLocked: !!isShallowLocked
                                    }, key);
                                }),
                                provided.placeholder,
                                !isReadonly && !isShallowLocked && (0, $4vwom.jsx)((0, $fT6Pt.RButton), {
                                    style: {
                                        borderTopLeftRadius: 0,
                                        borderTopRightRadius: 0
                                    },
                                    variant: "secondary",
                                    disabled: property.isReadonly,
                                    onClick: addNew,
                                    children: property.isReadonly ? "None" : (0, $cSf8f.Translations).Add() + " " + ((_a = typeof itemType === "object" && "reference" in itemType && itemType.reference ? (0, $8h5s0.prettyCamel)($b42b9f90e20abc9c$var$localizeReference(itemType.reference), false) : undefined) !== null && _a !== void 0 ? _a : (0, $8h5s0.prettyCamel)((_c = (0, $cSf8f.ClientSideLocalize)(Object.assign({
                                        en: (0, $43jhg.GetTypeAlias)(itemType)
                                    }, typeof itemType === "object" ? (_b = itemType.tags) === null || _b === void 0 ? void 0 : _b.translation : undefined))) !== null && _c !== void 0 ? _c : (0, $43jhg.GetTypeAlias)(itemType) || "item", false))
                                })
                            ]
                        }));
                    }
                })
            })
        })
    });
}
function $b42b9f90e20abc9c$var$localizeReference(ref) {
    var _a;
    const type = (0, $cwhCA.GetType)(ref.typeName);
    if (typeof type === "object") return (0, $cSf8f.ClientSideLocalize)(Object.assign({
        en: ref.typeName
    }, ((_a = type.tags) === null || _a === void 0 ? void 0 : _a.translation) || {}));
    return ref.typeName;
}
function $b42b9f90e20abc9c$var$ListItem({ id: id, inline: inline, arr: arr, widget: widget, index: index, containsErrors: containsErrors, icon: icon, remove: remove, duplicate: duplicate, path: path, type: type, isReadonly: isReadonly, isRoot: isRoot, newlyCreated: newlyCreated, setNewlyCreated: setNewlyCreated, isShallowLocked: isShallowLocked }) {
    const mdc = (0, $eeH7J.useContext)($b42b9f90e20abc9c$var$masterDetailContext);
    if (!mdc) throw new Error("No master-detail context");
    const { selectedPath: selectedPath, select: select } = mdc;
    const selected = (0, $cXoc2.ObjectPathsEqual)(path, selectedPath);
    const editor = inline && (0, $4vwom.jsx)((0, $6cx8r.PropView), {
        obj: inline.arr,
        property: {
            optional: false,
            name: index.toString(),
            type: inline.type,
            isReadonly: false
        },
        mode: "inline",
        buttons: [],
        isEmbedded: true
    });
    const { hover: hover, hoverProps: hoverProps } = (0, $fz3r9.useHover)();
    const { collapse: collapse } = (0, $eeH7J.useContext)((0, $aCefG.CollapseContext));
    const listContext = (0, $eeH7J.useContext)((0, $aCefG.ListContext));
    const showIndex = listContext === null || listContext === void 0 ? void 0 : listContext.showIndex;
    const discriminatedType = (0, $43jhg.IsUnionType)(type.array) ? (0, $cwhCA.SubstituteAndDiscriminate)((0, $1aVVn.YTools).valueToJSON(arr.get(index)), type.array) : type.array;
    const subLists = (0, $43jhg.GetTypeProps)(discriminatedType).filter((x)=>{
        var _a;
        return (0, $43jhg.IsArrayType)(x.type) && ((_a = x.tags) === null || _a === void 0 ? void 0 : _a.subtree);
    });
    icon || (icon = typeof widget === "object" ? undefined : (0, $3LK53.GetIconForTypedValue)(arr.get(index), type.array));
    const settingsNamespace = (0, $jJ9YT.useSettingsNamespace)();
    const [expanded, setExpanded] = (0, $eK8Q4.usePreference)(`${settingsNamespace}-${path}-expanded`, false);
    const showSeparator = !(index === arr.length - 1 && (isReadonly || isShallowLocked));
    return (0, $4vwom.jsx)((0, $efVcO.Draggable), {
        draggableId: id,
        index: index,
        isDragDisabled: isReadonly || isShallowLocked,
        children: (provided, snapshot)=>(0, $4vwom.jsxs)("div", Object.assign({
                ref: provided.innerRef,
                style: Object.assign({
                    flexDirection: "column",
                    display: "flex"
                }, provided.draggableProps.style)
            }, provided.draggableProps, {
                children: [
                    (0, $4vwom.jsxs)("div", Object.assign({
                        onClick: ()=>{
                            if (inline) return;
                            if (selected) select([]);
                            else select(path);
                        }
                    }, provided.dragHandleProps, hoverProps, {
                        style: {
                            cursor: inline ? undefined : "pointer",
                            borderColor: snapshot.isDragging ? (0, $9Q5xE.ColorStyles).primary[500] + "22" : selected ? (0, $9Q5xE.ColorStyles).primary[500] + 33 : undefined,
                            border: selected ? `1px solid ${(0, $9Q5xE.ColorStyles).primary}99` : undefined,
                            borderTopLeftRadius: !isRoot && index === 0 ? 8 : 0,
                            borderTopRightRadius: !isRoot && index === 0 ? 8 : 0,
                            backgroundColor: selected ? (0, $9Q5xE.ColorStyles).primary + "11" : hover ? (0, $9Q5xE.ColorStyles).primary[500] + "11" : undefined,
                            fontWeight: selected ? "bold" : undefined,
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center"
                        },
                        children: [
                            showIndex && (0, $4vwom.jsx)("div", {
                                style: {
                                    paddingLeft: 16
                                },
                                children: index
                            }),
                            icon && (0, $4vwom.jsx)((0, $6sp4J.Icon), {
                                icon: icon,
                                style: {
                                    marginLeft: 8,
                                    marginRight: 8
                                },
                                color: (0, $9Q5xE.ColorStyles).gray[300]
                            }),
                            subLists.length > 0 && (0, $4vwom.jsx)((0, $fT6Pt.RButton), {
                                style: {
                                    marginLeft: 8,
                                    paddingLeft: 4,
                                    paddingRight: 4
                                },
                                icon: expanded ? "chevron-down" : "chevron-right",
                                onClick: ()=>setExpanded(!expanded)
                            }, "sublist-button"),
                            (0, $4vwom.jsx)("div", {
                                style: {
                                    flex: 1,
                                    opacity: inline || widget ? 1 : 0.5
                                },
                                children: editor || (0, $4vwom.jsx)("div", {
                                    style: {
                                        padding: 8
                                    },
                                    children: (0, $4vwom.jsx)((0, $4rY0U.WidgetView), {
                                        value: widget,
                                        hideDetails: !!selectedPath.length
                                    })
                                })
                            }),
                            containsErrors && !inline && (0, $4vwom.jsx)("span", {
                                style: {
                                    color: (0, $9Q5xE.ColorStyles).error[500]
                                },
                                children: (0, $cSf8f.Translations).Incomplete()
                            }, "incomplete-label"),
                            !isReadonly && !isShallowLocked && (0, $4vwom.jsx)((0, $fT6Pt.RButton), {
                                icon: "ui-dots-vertical",
                                hideChevron: true,
                                iconSize: 16,
                                style: {
                                    marginRight: 8
                                },
                                popup: (close)=>(0, $4vwom.jsxs)("div", {
                                        style: {
                                            display: "flex",
                                            flexDirection: "column"
                                        },
                                        children: [
                                            (0, $4vwom.jsx)((0, $4rY0U.WidgetView), {
                                                value: {
                                                    type: "Button",
                                                    icon: "ui-trash-01",
                                                    text: "Remove",
                                                    action: remove
                                                }
                                            }),
                                            (0, $4vwom.jsx)((0, $4rY0U.WidgetView), {
                                                value: {
                                                    type: "Button",
                                                    icon: "ui-copy-01",
                                                    text: "Duplicate",
                                                    action: duplicate
                                                }
                                            })
                                        ]
                                    })
                            })
                        ]
                    })),
                    expanded && (0, $4vwom.jsx)("div", {
                        style: {
                            paddingLeft: 36
                        },
                        children: subLists.map((lp)=>{
                            const obj = (0, $1aVVn.YTools).getMap(arr, index).get(lp.name);
                            if (obj) return (0, $4vwom.jsx)($b42b9f90e20abc9c$export$84d0dd190d551cd1, {
                                isReadonly: isReadonly,
                                obj: (0, $1aVVn.YTools).getNode(arr, index),
                                property: lp,
                                path: [
                                    ...path,
                                    lp.name
                                ],
                                isRoot: false,
                                setNewlyCreated: setNewlyCreated,
                                newlyCreated: newlyCreated
                            }, lp.name);
                            return null;
                        })
                    }),
                    showSeparator && (0, $4vwom.jsx)("div", {
                        style: {
                            height: 1,
                            backgroundColor: "#eee"
                        }
                    })
                ]
            }))
    });
}

});
parcelRegister("le0UN", function(module, exports) {

$parcel$export(module.exports, "Duplicate", function () { return $f73b9d818bf28766$export$4a82481d9e63c9e1; });

var $43jhg = parcelRequire("43jhg");

var $823Kn = parcelRequire("823Kn");

var $dAwef = parcelRequire("dAwef");
function $f73b9d818bf28766$export$4a82481d9e63c9e1(item, itemType) {
    var _a;
    const remappings = new Map();
    const isNonReferenceUuid = (type)=>(0, $dAwef.IsUuidType)(type) && !(typeof type === "object" && type.reference);
    // Replace all Uuid's that are not references with new Uuid's
    const newItem = (0, $823Kn.Reconstruct)(item, itemType, (value, type)=>isNonReferenceUuid(type), (value, type)=>{
        const newValue = (0, $dAwef.Uuid)();
        // Keep a mapping of old Uuid's to new Uuid's
        remappings.set(value, newValue);
        return newValue;
    });
    const isReference = (type)=>(0, $dAwef.IsUuidType)(type) && typeof type === "object" && !!type.reference;
    // Replace all Uuid's that are references with the new Uuid's, if they exist
    // in the remappings table
    const newItem2 = (0, $823Kn.Reconstruct)(newItem, itemType, (value, type)=>isReference(type), (value, type)=>{
        var _a;
        // Use the remapped value if it exists
        return (_a = remappings.get(value)) !== null && _a !== void 0 ? _a : // Otherwise, return the original value
        value;
    });
    // Clear all @unique props, if possible. Unless it is also a @title
    // prop, which will get `(Copy)` appended to it below.
    let newItem3 = (0, $823Kn.Reconstruct)(newItem2, itemType, (value, type, prop)=>{
        var _a;
        return !!((_a = prop === null || prop === void 0 ? void 0 : prop.tags) === null || _a === void 0 ? void 0 : _a.unique) && !prop.optional && !(prop.tags.title && type === "string");
    }, (value, type)=>{
        if (!(0, $43jhg.AreTypesAssignable)(type, "undefined")) throw new Error("Cannot clear @unique properties that are not optional");
        return undefined;
    });
    const props = (0, $43jhg.GetTypeProps)(itemType);
    const titleProp = (_a = props.find((p)=>{
        var _a;
        return (_a = p.tags) === null || _a === void 0 ? void 0 : _a.title;
    })) === null || _a === void 0 ? void 0 : _a.name;
    if (titleProp) {
        if (typeof newItem3[titleProp] === "string") newItem3[titleProp] = newItem3[titleProp] + " (Copy)";
        else if (typeof newItem3[titleProp] === "object") // Localized value
        for (const key of Object.keys(newItem3[titleProp]))newItem3[titleProp][key] = newItem3[titleProp][key] + " (Copy)";
    } else {
        // If no @title prop is found, append " (Copy)" to an
        // appropriate-looking string value
        let foundString = false;
        newItem3 = (0, $823Kn.Reconstruct)(newItem3, itemType, (value, type)=>{
            const isString = !foundString && typeof value === "string" && type === "string";
            if (isString) foundString = true;
            return isString;
        }, (value, type)=>value + " (Copy)");
    }
    return newItem3;
}

});
parcelRegister("823Kn", function(module, exports) {

$parcel$export(module.exports, "Reconstruct", function () { return $5d916ab116bba751$export$193526a451ec3fe9; });

var $dIDCa = parcelRequire("dIDCa");

var $cwhCA = parcelRequire("cwhCA");

var $43jhg = parcelRequire("43jhg");
function $5d916ab116bba751$export$193526a451ec3fe9(rootObj, rootType, /** A predicate for whether a value needs to be reconstructed. If this function returns true,
 *  the `reconstructor` will be called to produce the value that should replace this one.
 */ needsReconstruction, /** A function that replaces the provided value. Will only be called if the
 * `needsReconstruction` predicate returns `true`. */ reconstructor, visitUndefined = false) {
    const visit = (value, type, property)=>{
        var _a;
        type = (0, $cwhCA.SubstituteType)(value, type);
        if (needsReconstruction(value, type, property)) return reconstructor(value, type, property);
        if ((0, $43jhg.IsAnyType)(type) || (0, $43jhg.IsUnknownType)(type)) return value;
        if ((0, $43jhg.IsUnionType)(type)) {
            const discType = (0, $43jhg.Discriminate)(value, type);
            if (type === discType) // Unable to discriminate
            // We cannot traverse further with type safety
            return value;
            else {
                type = discType;
                // Check if reconstruction is necessary again now that we know the discriminated
                // type
                if (needsReconstruction(value, type, property)) return reconstructor(value, type, property);
            }
        }
        if (value === null) return null;
        if (typeof value === "object") {
            if (value instanceof Array) {
                const itemType = (0, $43jhg.IsArrayType)(type) ? type.array : "any";
                return value.map((v, i)=>visit(v, itemType));
            } else {
                const res = {};
                const props = (0, $dIDCa.GetTypePropsWithExtensions)(type, value);
                for (const prop of props){
                    const v = value[prop.name];
                    if (visitUndefined || v !== undefined) res[prop.name] = visit(v, prop.type, prop);
                    else // Preserve explicit undefined values
                    if (prop.name in value) res[prop.name] = undefined;
                }
                if ((0, $43jhg.IsObjectType)(type) && type.additionalProps) for (const addProp of Object.keys(value).filter((p)=>!props.some((r)=>r.name === p))){
                    const v = value[addProp];
                    if (v !== undefined) res[addProp] = visit(v, type.additionalProps);
                }
                if ((0, $43jhg.IsObjectType)(type) && type.alias === "Record" && ((_a = type.typeArgs) === null || _a === void 0 ? void 0 : _a.length) === 2) {
                    const valueType = type.typeArgs[1];
                    if (typeof value === "object" && value) {
                        for (const key of Object.keys(value))if (key in value) res[key] = visit(value[key], valueType);
                    }
                }
                return res;
            }
        }
        // Atomic type, safe to return without cloning
        return value;
    };
    return visit(rootObj, rootType);
}
function $5d916ab116bba751$export$2f0c990471e0f00(value, type) {
    return $5d916ab116bba751$export$193526a451ec3fe9(value, type, (v, t)=>v !== null && v !== undefined && typeof t === "object" && !!t.validator, (v, t)=>{
        const validator = (0, $43jhg.GetTypeValidator)(t);
        if (validator) return validator(v);
        return v;
    });
}

});


parcelRegister("jJ9YT", function(module, exports) {

$parcel$export(module.exports, "SettingsContext", function () { return $e5c9f65302d61de6$export$8fa45c82eddfe270; });
$parcel$export(module.exports, "useSettingsNamespace", function () { return $e5c9f65302d61de6$export$58c8be36956edfe5; });

var $eeH7J = parcelRequire("eeH7J");
const $e5c9f65302d61de6$export$8fa45c82eddfe270 = /*#__PURE__*/ (0, $eeH7J.createContext)({
    namespace: "settings"
});
function $e5c9f65302d61de6$export$58c8be36956edfe5() {
    const ctx = (0, $eeH7J.useContext)($e5c9f65302d61de6$export$8fa45c82eddfe270);
    if (!ctx) throw new Error("No active settings namespace");
    return ctx.namespace;
}

});

parcelRegister("lUciB", function(module, exports) {

$parcel$export(module.exports, "BorderContext", function () { return $ff285e46c0802fb7$export$e4629c505385cc34; });

var $eeH7J = parcelRequire("eeH7J");
const $ff285e46c0802fb7$export$e4629c505385cc34 = /*#__PURE__*/ (0, $eeH7J.createContext)({
    drawBorders: true
});

});

parcelRegister("5Dc48", function(module, exports) {

$parcel$export(module.exports, "GridView", function () { return $4199f448ae78fbbf$export$5a87d90ca5d04034; });

var $4vwom = parcelRequire("4vwom");

var $geOdl = parcelRequire("geOdl");

var $34lt5 = parcelRequire("34lt5");

var $gDYj4 = parcelRequire("gDYj4");

var $9Q5xE = parcelRequire("9Q5xE");
parcelRequire("2LTO8");
var $5c9Ym = parcelRequire("5c9Ym");

var $8h5s0 = parcelRequire("8h5s0");

var $43jhg = parcelRequire("43jhg");

var $fT6Pt = parcelRequire("fT6Pt");

var $1aVVn = parcelRequire("1aVVn");
function $4199f448ae78fbbf$export$5a87d90ca5d04034({ property: property, obj: obj }) {
    const value = (0, $1aVVn.YTools).getArray(obj, property.name);
    const arrayType = property.type;
    if (!(0, $43jhg.IsArrayType)(arrayType)) return (0, $4vwom.jsxs)("div", {
        children: [
            "Expected array type, got ",
            JSON.stringify(arrayType)
        ]
    });
    const itemType = arrayType.array;
    const columns = (0, $43jhg.GetTypeProps)(itemType).filter((prop)=>{
        var _a;
        if ((0, $43jhg.GetTypeAlias)(prop.type) === "Uuid") return false;
        const type = (_a = (0, $gDYj4.IsLocalized)(prop.type)) !== null && _a !== void 0 ? _a : prop.type;
        if ((0, $43jhg.IsStringType)(type)) return true;
        return false;
    });
    return (0, $4vwom.jsxs)("div", {
        style: {
            display: "grid",
            gridTemplateColumns: "repeat(" + columns.length + ", 1fr) auto",
            border: "1px solid " + (0, $9Q5xE.ColorStyles).gray[200],
            borderRadius: 8
        },
        children: [
            columns.map((column)=>(0, $4vwom.jsx)("div", {
                    style: {
                        borderBottom: "1px solid " + (0, $9Q5xE.ColorStyles).gray[200],
                        padding: 8,
                        backgroundColor: (0, $9Q5xE.ColorStyles).gray[100]
                    },
                    children: (0, $8h5s0.prettyCamel)(column.name, true)
                }, column.name)),
            (0, $4vwom.jsx)("div", {
                style: {
                    borderBottom: "1px solid " + (0, $9Q5xE.ColorStyles).gray[200],
                    padding: 8,
                    backgroundColor: (0, $9Q5xE.ColorStyles).gray[100]
                }
            }, "deletebutton-placeholder"),
            value.map((row)=>(0, $4vwom.jsxs)((0, $4vwom.Fragment), {
                    children: [
                        columns.map((column)=>(0, $4vwom.jsx)("div", {
                                style: {
                                    borderBottom: "1px solid " + (0, $9Q5xE.ColorStyles).gray[200],
                                    paddingRight: 2
                                },
                                children: (0, $4vwom.jsx)($4199f448ae78fbbf$var$Cell, {
                                    obj: row,
                                    property: column
                                })
                            }, column.name)),
                        (0, $4vwom.jsx)("div", {
                            style: {
                                borderBottom: "1px solid " + (0, $9Q5xE.ColorStyles).gray[200]
                            },
                            children: (0, $4vwom.jsx)((0, $fT6Pt.RButton), {
                                icon: "ui-minus",
                                variant: "secondary",
                                onClick: ()=>{
                                    const index = value.toArray().indexOf(row);
                                    value.delete(index);
                                }
                            })
                        }, "deletebutton")
                    ]
                })),
            (0, $4vwom.jsx)((0, $fT6Pt.RButton), {
                style: {
                    gridColumn: "span " + (columns.length + 1)
                },
                icon: "ui-plus",
                variant: "secondary",
                onClick: ()=>{
                    value.push((0, $5c9Ym.CreateDefault)(itemType));
                },
                children: "Add"
            })
        ]
    });
}
function $4199f448ae78fbbf$var$Cell({ property: property, obj: obj }) {
    const locale = (0, $geOdl.useStudioLocale)();
    function getLocale(v) {
        if (locale.valueOf() in v) return locale;
        if ("en" in v) return (0, $34lt5.LocaleKey).en;
        return Object.keys(v)[0];
    }
    function getValue() {
        const v = obj.get(property.name);
        if ((0, $gDYj4.IsLocalized)(property.type)) return v[getLocale(v).valueOf()];
        return v;
    }
    function setValue(newValue) {
        if ((0, $gDYj4.IsLocalized)(property.type)) {
            const v = obj.get(property.name);
            v[getLocale(v).valueOf()] = newValue;
            return;
        }
        obj.set(property.name, newValue);
    }
    return (0, $4vwom.jsx)("input", {
        type: "text",
        style: {
            padding: 8,
            width: "100%",
            boxSizing: "border-box"
        },
        value: getValue(),
        onChange: (e)=>{
            setValue(e.target.value);
        }
    });
}

});

parcelRegister("cXoc2", function(module, exports) {

$parcel$export(module.exports, "ResolveObjectPath", function () { return $96edc2f9935cf595$export$68467db6d380b9ea; });
$parcel$export(module.exports, "ResolveObjectPathType", function () { return $96edc2f9935cf595$export$6460277d6c93b41a; });
$parcel$export(module.exports, "ObjectPathsEqual", function () { return $96edc2f9935cf595$export$639a53ed417041bb; });

var $aw3rr = parcelRequire("aw3rr");

var $1aVVn = parcelRequire("1aVVn");

var $43jhg = parcelRequire("43jhg");
function $96edc2f9935cf595$export$68467db6d380b9ea(root, path) {
    for (const segment of path)if (root && (root instanceof $aw3rr.Array || root instanceof $aw3rr.Map)) root = root instanceof $aw3rr.Array ? root.get(typeof segment === "string" ? parseInt(segment) : segment) : root.get(typeof segment === "number" ? segment.toString() : segment);
    return root;
}
function $96edc2f9935cf595$export$6460277d6c93b41a(type, root, path) {
    for (const segment of path){
        if ((0, $43jhg.IsArrayType)(type)) type = type.array;
        else {
            const props = (0, $43jhg.GetTypeProps)(type, (0, $1aVVn.YTools).valueToJSON(root));
            const prop = props.find((p)=>p.name === segment);
            if (!(prop === null || prop === void 0 ? void 0 : prop.type)) return undefined;
            type = prop === null || prop === void 0 ? void 0 : prop.type;
        }
        if (root && typeof root === "object") root = (0, $1aVVn.YTools).get(root, segment);
    }
    return type;
}
function $96edc2f9935cf595$export$639a53ed417041bb(a, b) {
    return a.length === b.length && a.every((x, i)=>b[i] === x);
}

});


parcelRegister("4W8fY", function(module, exports) {

$parcel$export(module.exports, "RecordView", function () { return $3982fbc838e03577$export$767e4b1128064a9b; });

var $4vwom = parcelRequire("4vwom");

var $9Q5xE = parcelRequire("9Q5xE");

var $1aVVn = parcelRequire("1aVVn");

var $fT6Pt = parcelRequire("fT6Pt");

var $hRViu = parcelRequire("hRViu");

var $6cx8r = parcelRequire("6cx8r");
function $3982fbc838e03577$export$767e4b1128064a9b({ label: label, buttons: buttons, property: property, obj: obj }) {
    const [value, setValue] = (0, $1aVVn.useYState)(obj, property.name);
    if (value === null || typeof value !== "object") return (0, $4vwom.jsx)((0, $hRViu.PropRow), {
        label: label,
        buttons: buttons,
        description: property.description,
        children: (0, $4vwom.jsx)((0, $fT6Pt.RButton), {
            onClick: ()=>{
                setValue({});
            },
            children: "Specify"
        })
    });
    const type = property.type;
    if (typeof type !== "object") throw new Error("Expected object type");
    const typeArgs = type.typeArgs;
    if (!typeArgs) throw new Error("Expected typeArgs");
    const keys = Object.keys(value);
    const [keyType, valueType] = typeArgs;
    return (0, $4vwom.jsx)((0, $hRViu.PropRow), {
        label: label,
        buttons: buttons,
        description: property.description,
        children: (0, $4vwom.jsxs)("div", {
            style: {
                padding: 12,
                border: "1px solid " + (0, $9Q5xE.ColorStyles).gray[200],
                borderRadius: 8
            },
            children: [
                keys.map((key)=>(0, $4vwom.jsx)("div", {
                        style: {
                            marginBottom: 16
                        },
                        children: (0, $4vwom.jsx)((0, $6cx8r.PropView), {
                            obj: value,
                            label: key,
                            property: {
                                name: key,
                                type: valueType
                            },
                            isEmbedded: true,
                            mode: "inline",
                            buttons: [
                                {
                                    text: "Delete",
                                    onClick: ()=>{
                                        delete value[key];
                                        setValue(Object.assign({}, value));
                                    }
                                }
                            ]
                        }, key)
                    })),
                (0, $4vwom.jsx)((0, $fT6Pt.RButton), {
                    icon: "ui-plus",
                    variant: "secondary",
                    onClick: ()=>{
                        const newKey = prompt("Enter the key");
                        if (newKey) {
                            value[newKey] = null;
                            setValue(Object.assign({}, value));
                        }
                    },
                    children: "Add"
                })
            ]
        })
    });
}

});

parcelRegister("hQ8BL", function(module, exports) {

$parcel$export(module.exports, "Editors", function () { return $cfcdf8644cb72c2a$export$21a3af9d052cc974; });
$parcel$export(module.exports, "Editor", function () { return $cfcdf8644cb72c2a$export$7cda8d932e2f33c0; });
/**
 * A list of functions that can be used to launch a custom editor for a
 * TypeScript property. Use the `@editor FunctionName` attribute to point to a
 * function.
 */ const $cfcdf8644cb72c2a$export$21a3af9d052cc974 = new Map();
function $cfcdf8644cb72c2a$export$7cda8d932e2f33c0(name, editor) {
    $cfcdf8644cb72c2a$export$21a3af9d052cc974.set(name, editor);
}

});

parcelRegister("4bhEs", function(module, exports) {

$parcel$export(module.exports, "RichTextView", function () { return $30b5e1bb415fdcbe$export$3304c1ac943a577b; });

var $4vwom = parcelRequire("4vwom");

var $hRViu = parcelRequire("hRViu");

var $eeECL = parcelRequire("eeECL");
function $30b5e1bb415fdcbe$export$3304c1ac943a577b({ obj: obj, property: property, label: label, buttons: buttons, isEmbedded: isEmbedded }) {
    return (0, $4vwom.jsx)((0, $hRViu.PropRow), {
        label: label,
        buttons: buttons,
        isEmbedded: isEmbedded,
        children: (0, $4vwom.jsx)((0, $eeECL.RichTextEditor), {
            obj: obj,
            property: property,
            className: "form-control",
            style: {
                width: "100%",
                margin: isEmbedded ? 2 : undefined,
                resize: "vertical",
                overflow: "auto"
            }
        })
    });
}

});
parcelRegister("eeECL", function(module, exports) {

$parcel$export(module.exports, "RichTextEditor", function () { return $a5d1e2981d6ce812$export$a4ff4468fa943a6c; });

var $4vwom = parcelRequire("4vwom");

var $4H8rR = parcelRequire("4H8rR");

var $aw3rr = parcelRequire("aw3rr");

var $iB3QS = parcelRequire("iB3QS");

var $eeH7J = parcelRequire("eeH7J");

var $akZf2 = parcelRequire("akZf2");

var $062bh = parcelRequire("062bh");
parcelRequire("2LTO8");
var $5c9Ym = parcelRequire("5c9Ym");

var $9Q5xE = parcelRequire("9Q5xE");

var $1aVVn = parcelRequire("1aVVn");
function $a5d1e2981d6ce812$export$a4ff4468fa943a6c({ obj: obj, property: property, className: className, style: style, dataBindings: dataBindings }) {
    var _a;
    const value = (_a = (0, $1aVVn.YTools).get(obj, property.name)) !== null && _a !== void 0 ? _a : (0, $1aVVn.YTools).set(obj, property.name, (0, $1aVVn.YTools).valueToYValue((0, $5c9Ym.CreateDefault)(property.type, (0, $5c9Ym.UninitializedDefaults))));
    const editor = (0, $eeH7J.useMemo)(()=>(0, $4H8rR.withYHistory)((0, $4H8rR.withYjs)((0, $062bh.withReact)((0, $akZf2.createEditor)()), value)), [
        value
    ]);
    const editorRef = /*#__PURE__*/ (0, $eeH7J.createRef)();
    const [focused, setFocused] = (0, $eeH7J.useState)(false);
    (0, $eeH7J.useEffect)(()=>{
        if (value) {
            (0, $4H8rR.YjsEditor).connect(editor);
            return ()=>{
                (0, $4H8rR.YjsEditor).disconnect(editor);
            };
        }
    }, [
        editor,
        value
    ]);
    const onKeyDown = (0, $eeH7J.useCallback)((event)=>{
        const { selection: selection } = editor;
        if (event.key === "Enter" && event.shiftKey) {
            editor.insertText("\n");
            event.preventDefault();
            return;
        }
        // Default left/right behavior is unit:'character'.
        // This fails to distinguish between two cursor positions, such as
        // <inline>foo<cursor/></inline> vs <inline>foo</inline><cursor/>.
        // Here we modify the behavior to unit:'offset'.
        // This lets the user step into and out of the inline without stepping over characters.
        // You may wish to customize this further to only use unit:'offset' in specific cases.
        if (selection && (0, $akZf2.Range).isCollapsed(selection)) {
            const { nativeEvent: nativeEvent } = event;
            if ((0, $iB3QS.isKeyHotkey)("left", nativeEvent)) {
                event.preventDefault();
                (0, $akZf2.Transforms).move(editor, {
                    unit: "offset",
                    reverse: true
                });
                return;
            }
            if ((0, $iB3QS.isKeyHotkey)("right", nativeEvent)) {
                event.preventDefault();
                (0, $akZf2.Transforms).move(editor, {
                    unit: "offset"
                });
                return;
            }
        }
    }, [
        editor
    ]);
    return (0, $4vwom.jsx)((0, $062bh.Slate), {
        editor: editor,
        initialValue: [],
        children: (0, $4vwom.jsxs)("div", {
            ref: editorRef,
            style: {
                position: "relative"
            },
            children: [
                focused && (0, $4vwom.jsxs)("div", {
                    style: {
                        position: "absolute",
                        top: -42,
                        height: 48,
                        left: 150,
                        borderRadius: 2,
                        padding: 4,
                        display: "flex",
                        flexDirection: "row"
                    },
                    children: [
                        (0, $4vwom.jsx)($a5d1e2981d6ce812$var$MarkButton, {
                            format: "bold",
                            icon: "\uD835\uDC01"
                        }),
                        (0, $4vwom.jsx)($a5d1e2981d6ce812$var$MarkButton, {
                            format: "italic",
                            icon: "\uD835\uDC3C"
                        }),
                        (0, $4vwom.jsx)($a5d1e2981d6ce812$var$MarkButton, {
                            format: "underline",
                            icon: "\uD835\uDC48"
                        }),
                        (0, $4vwom.jsx)($a5d1e2981d6ce812$var$MarkButton, {
                            format: "code",
                            icon: "\uD835\uDE72"
                        }),
                        (0, $4vwom.jsx)($a5d1e2981d6ce812$var$MarkButton, {
                            format: "link",
                            icon: "\uD83D\uDD17"
                        }),
                        (0, $4vwom.jsx)($a5d1e2981d6ce812$var$Spacer, {}),
                        (0, $4vwom.jsx)($a5d1e2981d6ce812$var$BlockButton, {
                            format: "UnorderedList",
                            icon: "\u2022"
                        }),
                        (0, $4vwom.jsx)($a5d1e2981d6ce812$var$BlockButton, {
                            format: "OrderedList",
                            icon: "1."
                        }),
                        (0, $4vwom.jsx)($a5d1e2981d6ce812$var$Spacer, {}),
                        (0, $4vwom.jsx)($a5d1e2981d6ce812$var$BlockButton, {
                            format: "Heading1",
                            icon: "H1"
                        }),
                        (0, $4vwom.jsx)($a5d1e2981d6ce812$var$BlockButton, {
                            format: "Heading2",
                            icon: "H2"
                        }),
                        dataBindings && (0, $4vwom.jsxs)((0, $4vwom.Fragment), {
                            children: [
                                (0, $4vwom.jsx)($a5d1e2981d6ce812$var$Spacer, {}),
                                (0, $4vwom.jsx)($a5d1e2981d6ce812$var$BindingButton, {})
                            ]
                        })
                    ]
                }),
                (0, $4vwom.jsx)((0, $062bh.Editable), {
                    className: className,
                    style: style,
                    renderElement: $a5d1e2981d6ce812$var$renderElement,
                    renderLeaf: $a5d1e2981d6ce812$var$renderLeaf,
                    onKeyDown: onKeyDown,
                    onFocus: ()=>{
                        if (value === undefined) {
                            const text = (0, $1aVVn.YTools).set(obj, property.name, new $aw3rr.XmlText());
                            text.applyDelta((0, $4H8rR.slateNodesToInsertDelta)([
                                {
                                    type: "Paragraph",
                                    children: [
                                        {
                                            text: ""
                                        }
                                    ]
                                }
                            ]));
                        }
                        setFocused(true);
                    },
                    onBlur: ()=>{
                        setFocused(false);
                    }
                })
            ]
        })
    });
}
function $a5d1e2981d6ce812$var$Spacer() {
    return (0, $4vwom.jsx)("div", {
        style: {
            width: 16
        }
    });
}
const $a5d1e2981d6ce812$var$Button = ({ active: active, icon: icon, onClick: onClick })=>{
    return (0, $4vwom.jsx)("button", {
        style: {
            border: "1px solid " + (0, $9Q5xE.ColorStyles).gray[100],
            padding: 2,
            borderRadius: 4,
            margin: 2,
            width: 28,
            height: 28,
            color: active ? (0, $9Q5xE.ColorStyles).primary[900] : (0, $9Q5xE.ColorStyles).primary[700],
            backgroundColor: active ? (0, $9Q5xE.ColorStyles).primary[200] : undefined
        },
        onMouseDown: onClick,
        children: icon
    });
};
function $a5d1e2981d6ce812$var$BindingButton() {
    const editor = (0, $062bh.useSlate)();
    const marks = (0, $akZf2.Editor).marks(editor);
    const binding = marks && "$Bind" in marks ? marks.$Bind : undefined;
    return (0, $4vwom.jsx)($a5d1e2981d6ce812$var$Button, {
        active: !!binding,
        icon: "{}",
        onClick: ()=>{
            const text = prompt("Enter binding expression", binding === null || binding === void 0 ? void 0 : binding.text);
            (0, $akZf2.Editor).removeMark(editor, "$Bind");
            if (text) (0, $akZf2.Editor).addMark(editor, "$Bind", {
                text: text
            });
        }
    });
}
const $a5d1e2981d6ce812$var$MarkButton = ({ format: format, icon: icon })=>{
    const editor = (0, $062bh.useSlate)();
    return (0, $4vwom.jsx)($a5d1e2981d6ce812$var$Button, {
        active: $a5d1e2981d6ce812$var$isMarkActive(editor, format),
        icon: icon,
        onClick: ()=>$a5d1e2981d6ce812$var$toggleMark(editor, format)
    });
};
const $a5d1e2981d6ce812$var$BlockButton = ({ format: format, icon: icon })=>{
    const editor = (0, $062bh.useSlate)();
    return (0, $4vwom.jsx)($a5d1e2981d6ce812$var$Button, {
        active: $a5d1e2981d6ce812$var$isBlockActive(editor, format),
        icon: icon,
        onClick: ()=>$a5d1e2981d6ce812$var$toggleBlock(editor, format)
    });
};
const $a5d1e2981d6ce812$var$isBlockActive = (editor, format)=>{
    const { selection: selection } = editor;
    if (!selection) return false;
    const [match] = Array.from((0, $akZf2.Editor).nodes(editor, {
        at: (0, $akZf2.Editor).unhangRange(editor, selection),
        match: (n)=>!(0, $akZf2.Editor).isEditor(n) && (0, $akZf2.Element).isElement(n) && n.type === format
    }));
    return !!match;
};
const $a5d1e2981d6ce812$var$listTypes = [
    "UnorderedList",
    "OrderedList"
];
const $a5d1e2981d6ce812$var$toggleBlock = (editor, format)=>{
    const isActive = $a5d1e2981d6ce812$var$isBlockActive(editor, format);
    const isList = $a5d1e2981d6ce812$var$listTypes.includes(format);
    (0, $akZf2.Transforms).unwrapNodes(editor, {
        match: (n)=>!(0, $akZf2.Editor).isEditor(n) && (0, $akZf2.Element).isElement(n) && $a5d1e2981d6ce812$var$listTypes.includes(n.type),
        split: true
    });
    const newProperties = {
        type: isActive ? "Paragraph" : isList ? "ListItem" : format
    };
    (0, $akZf2.Transforms).setNodes(editor, newProperties);
    if (!isActive && isList) {
        const block = {
            type: format,
            children: []
        };
        (0, $akZf2.Transforms).wrapNodes(editor, block);
    }
};
const $a5d1e2981d6ce812$var$isMarkActive = (editor, format)=>{
    const marks = (0, $akZf2.Editor).marks(editor);
    if (format === "link") return typeof (marks === null || marks === void 0 ? void 0 : marks.link) === "string";
    return marks ? marks[format] === true : false;
};
const $a5d1e2981d6ce812$var$toggleMark = (editor, format)=>{
    const isActive = $a5d1e2981d6ce812$var$isMarkActive(editor, format);
    if (isActive) (0, $akZf2.Editor).removeMark(editor, format);
    else if (format === "link") {
        const url = prompt("Which URL should the link point to?");
        if (typeof url === "string" && url.length > 0) (0, $akZf2.Editor).addMark(editor, format, url);
    } else (0, $akZf2.Editor).addMark(editor, format, true);
};
const $a5d1e2981d6ce812$var$renderElement = ({ attributes: attributes, children: children, element: element })=>{
    if (!("type" in element)) // This should not happen, Slate should not consider this an element
    return (0, $4vwom.jsxs)("div", Object.assign({}, attributes, {
        children: [
            "ERROR: ",
            children
        ]
    }));
    switch(element.type){
        case "Paragraph":
            return (0, $4vwom.jsx)("p", Object.assign({}, attributes, {
                children: children
            }));
        case "Heading1":
            return (0, $4vwom.jsx)("h1", Object.assign({}, attributes, {
                children: children
            }));
        case "Heading2":
            return (0, $4vwom.jsx)("h2", Object.assign({}, attributes, {
                children: children
            }));
        case "UnorderedList":
            return (0, $4vwom.jsx)("ul", Object.assign({}, attributes, {
                children: children
            }));
        case "OrderedList":
            return (0, $4vwom.jsx)("ol", Object.assign({}, attributes, {
                children: children
            }));
        case "ListItem":
            return (0, $4vwom.jsx)("li", Object.assign({}, attributes, {
                children: children
            }));
        default:
            throw new Error("Unknown element type");
    }
};
const $a5d1e2981d6ce812$var$renderLeaf = ({ attributes: attributes, children: children, leaf: leaf })=>{
    if (leaf.bold) children = (0, $4vwom.jsx)("strong", {
        children: children
    });
    if (leaf.code) children = (0, $4vwom.jsx)("code", {
        children: children
    });
    if (leaf.italic) children = (0, $4vwom.jsx)("em", {
        children: children
    });
    if (leaf.underline) children = (0, $4vwom.jsx)("u", {
        children: children
    });
    if ("$Bind" in leaf) children = (0, $4vwom.jsx)("span", {
        style: {
            backgroundColor: (0, $9Q5xE.ColorStyles)["blue-light"][50],
            border: "1px dashed " + (0, $9Q5xE.ColorStyles)["blue-light"][300],
            boxSizing: "border-box",
            borderRadius: 4
        },
        children: children
    });
    return (0, $4vwom.jsx)("span", Object.assign({}, attributes, {
        children: children
    }));
};
function $a5d1e2981d6ce812$export$239d04f876b48f5b(hexColor, opacity) {
    const normalized = Math.round(Math.min(Math.max(opacity, 0), 1) * 255);
    return hexColor + normalized.toString(16).toUpperCase();
}

});
parcelRegister("iB3QS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
/**
 * Constants.
 */ var $d89eab9cef8aa081$var$IS_MAC = typeof window != "undefined" && /Mac|iPod|iPhone|iPad/.test(window.navigator.platform);
var $d89eab9cef8aa081$var$MODIFIERS = {
    alt: "altKey",
    control: "ctrlKey",
    meta: "metaKey",
    shift: "shiftKey"
};
var $d89eab9cef8aa081$var$ALIASES = {
    add: "+",
    break: "pause",
    cmd: "meta",
    command: "meta",
    ctl: "control",
    ctrl: "control",
    del: "delete",
    down: "arrowdown",
    esc: "escape",
    ins: "insert",
    left: "arrowleft",
    mod: $d89eab9cef8aa081$var$IS_MAC ? "meta" : "control",
    opt: "alt",
    option: "alt",
    return: "enter",
    right: "arrowright",
    space: " ",
    spacebar: " ",
    up: "arrowup",
    win: "meta",
    windows: "meta"
};
var $d89eab9cef8aa081$var$CODES = {
    backspace: 8,
    tab: 9,
    enter: 13,
    shift: 16,
    control: 17,
    alt: 18,
    pause: 19,
    capslock: 20,
    escape: 27,
    " ": 32,
    pageup: 33,
    pagedown: 34,
    end: 35,
    home: 36,
    arrowleft: 37,
    arrowup: 38,
    arrowright: 39,
    arrowdown: 40,
    insert: 45,
    delete: 46,
    meta: 91,
    numlock: 144,
    scrolllock: 145,
    ";": 186,
    "=": 187,
    ",": 188,
    "-": 189,
    ".": 190,
    "/": 191,
    "`": 192,
    "[": 219,
    "\\": 220,
    "]": 221,
    "'": 222
};
for(var $d89eab9cef8aa081$var$f = 1; $d89eab9cef8aa081$var$f < 20; $d89eab9cef8aa081$var$f++)$d89eab9cef8aa081$var$CODES["f" + $d89eab9cef8aa081$var$f] = 111 + $d89eab9cef8aa081$var$f;
/**
 * Is hotkey?
 */ function $d89eab9cef8aa081$var$isHotkey(hotkey, options, event) {
    if (options && !("byKey" in options)) {
        event = options;
        options = null;
    }
    if (!Array.isArray(hotkey)) hotkey = [
        hotkey
    ];
    var array = hotkey.map(function(string) {
        return $d89eab9cef8aa081$var$parseHotkey(string, options);
    });
    var check = function check(e) {
        return array.some(function(object) {
            return $d89eab9cef8aa081$var$compareHotkey(object, e);
        });
    };
    var ret = event == null ? check : check(event);
    return ret;
}
function $d89eab9cef8aa081$var$isCodeHotkey(hotkey, event) {
    return $d89eab9cef8aa081$var$isHotkey(hotkey, event);
}
function $d89eab9cef8aa081$var$isKeyHotkey(hotkey, event) {
    return $d89eab9cef8aa081$var$isHotkey(hotkey, {
        byKey: true
    }, event);
}
/**
 * Parse.
 */ function $d89eab9cef8aa081$var$parseHotkey(hotkey, options) {
    var byKey = options && options.byKey;
    var ret = {};
    // Special case to handle the `+` key since we use it as a separator.
    hotkey = hotkey.replace("++", "+add");
    var values = hotkey.split("+");
    var length = values.length;
    // Ensure that all the modifiers are set to false unless the hotkey has them.
    for(var k in $d89eab9cef8aa081$var$MODIFIERS)ret[$d89eab9cef8aa081$var$MODIFIERS[k]] = false;
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;
    try {
        for(var _iterator = values[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var value = _step.value;
            var optional = value.endsWith("?") && value.length > 1;
            if (optional) value = value.slice(0, -1);
            var name = $d89eab9cef8aa081$var$toKeyName(value);
            var modifier = $d89eab9cef8aa081$var$MODIFIERS[name];
            if (value.length > 1 && !modifier && !$d89eab9cef8aa081$var$ALIASES[value] && !$d89eab9cef8aa081$var$CODES[name]) throw new TypeError('Unknown modifier: "' + value + '"');
            if (length === 1 || !modifier) {
                if (byKey) ret.key = name;
                else ret.which = $d89eab9cef8aa081$var$toKeyCode(value);
            }
            if (modifier) ret[modifier] = optional ? null : true;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return) _iterator.return();
        } finally{
            if (_didIteratorError) throw _iteratorError;
        }
    }
    return ret;
}
/**
 * Compare.
 */ function $d89eab9cef8aa081$var$compareHotkey(object, event) {
    for(var key in object){
        var expected = object[key];
        var actual = void 0;
        if (expected == null) continue;
        if (key === "key" && event.key != null) actual = event.key.toLowerCase();
        else if (key === "which") actual = expected === 91 && event.which === 93 ? 91 : event.which;
        else actual = event[key];
        if (actual == null && expected === false) continue;
        if (actual !== expected) return false;
    }
    return true;
}
/**
 * Utils.
 */ function $d89eab9cef8aa081$var$toKeyCode(name) {
    name = $d89eab9cef8aa081$var$toKeyName(name);
    var code = $d89eab9cef8aa081$var$CODES[name] || name.toUpperCase().charCodeAt(0);
    return code;
}
function $d89eab9cef8aa081$var$toKeyName(name) {
    name = name.toLowerCase();
    name = $d89eab9cef8aa081$var$ALIASES[name] || name;
    return name;
}
/**
 * Export.
 */ module.exports.default = $d89eab9cef8aa081$var$isHotkey;
module.exports.isHotkey = $d89eab9cef8aa081$var$isHotkey;
module.exports.isCodeHotkey = $d89eab9cef8aa081$var$isCodeHotkey;
module.exports.isKeyHotkey = $d89eab9cef8aa081$var$isKeyHotkey;
module.exports.parseHotkey = $d89eab9cef8aa081$var$parseHotkey;
module.exports.compareHotkey = $d89eab9cef8aa081$var$compareHotkey;
module.exports.toKeyCode = $d89eab9cef8aa081$var$toKeyCode;
module.exports.toKeyName = $d89eab9cef8aa081$var$toKeyName;

});

parcelRegister("062bh", function(module, exports) {

$parcel$export(module.exports, "useSlate", function () { return $0004ae769ccea2eb$export$654ff9b132e304a3; });
$parcel$export(module.exports, "Editable", function () { return $0004ae769ccea2eb$export$b1c809d287d72650; });
$parcel$export(module.exports, "Slate", function () { return $0004ae769ccea2eb$export$790e405fc529efaf; });
$parcel$export(module.exports, "withReact", function () { return $0004ae769ccea2eb$export$f67e6da052b725a3; });

var $hA1QH = parcelRequire("hA1QH");

var $5lUJY = parcelRequire("5lUJY");

var $824Mz = parcelRequire("824Mz");

var $eeH7J = parcelRequire("eeH7J");

var $dtPKc = parcelRequire("dtPKc");

var $akZf2 = parcelRequire("akZf2");

var $aWQx3 = parcelRequire("aWQx3");
parcelRequire("iRMZg");
var $bkU1H = parcelRequire("bkU1H");

var $iMJCh = parcelRequire("iMJCh");
function $0004ae769ccea2eb$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $0004ae769ccea2eb$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $0004ae769ccea2eb$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $0004ae769ccea2eb$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $0004ae769ccea2eb$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $0004ae769ccea2eb$var$_typeof(o);
}
function $0004ae769ccea2eb$var$_toPrimitive(input, hint) {
    if ($0004ae769ccea2eb$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($0004ae769ccea2eb$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $0004ae769ccea2eb$var$_toPropertyKey(arg) {
    var key = $0004ae769ccea2eb$var$_toPrimitive(arg, "string");
    return $0004ae769ccea2eb$var$_typeof(key) === "symbol" ? key : String(key);
}
function $0004ae769ccea2eb$var$_defineProperty(obj, key, value) {
    key = $0004ae769ccea2eb$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
/**
 * A React context for sharing the editor object.
 */ var $0004ae769ccea2eb$var$EditorContext = /*#__PURE__*/ (0, $eeH7J.createContext)(null);
/**
 * Get the current editor object from the React context.
 */ var $0004ae769ccea2eb$export$b4a4dff812101bed = ()=>{
    var editor = (0, $eeH7J.useContext)($0004ae769ccea2eb$var$EditorContext);
    if (!editor) throw new Error("The `useSlateStatic` hook must be used inside the <Slate> component's context.");
    return editor;
};
// eslint-disable-next-line no-redeclare
var $0004ae769ccea2eb$export$a55741a99bf22636 = (0, $aWQx3.DOMEditor);
function $0004ae769ccea2eb$var$ownKeys$5(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $0004ae769ccea2eb$var$_objectSpread$5(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $0004ae769ccea2eb$var$ownKeys$5(Object(t), !0).forEach(function(r) {
            $0004ae769ccea2eb$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $0004ae769ccea2eb$var$ownKeys$5(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
// https://github.com/facebook/draft-js/blob/main/src/component/handlers/composition/DraftEditorCompositionHandler.js#L41
// When using keyboard English association function, conpositionEnd triggered too fast, resulting in after `insertText` still maintain association state.
var $0004ae769ccea2eb$var$RESOLVE_DELAY = 25;
// Time with no user interaction before the current user action is considered as done.
var $0004ae769ccea2eb$var$FLUSH_DELAY = 200;
// Replace with `const debug = console.log` to debug
var $0004ae769ccea2eb$var$debug = function debug() {};
// Type guard to check if a value is a DataTransfer
var $0004ae769ccea2eb$var$isDataTransfer = (value)=>(value === null || value === void 0 ? void 0 : value.constructor.name) === "DataTransfer";
function $0004ae769ccea2eb$var$createAndroidInputManager(_ref) {
    var { editor: editor, scheduleOnDOMSelectionChange: scheduleOnDOMSelectionChange, onDOMSelectionChange: onDOMSelectionChange } = _ref;
    var flushing = false;
    var compositionEndTimeoutId = null;
    var flushTimeoutId = null;
    var actionTimeoutId = null;
    var idCounter = 0;
    var insertPositionHint = false;
    var applyPendingSelection = ()=>{
        var pendingSelection = (0, $aWQx3.EDITOR_TO_PENDING_SELECTION).get(editor);
        (0, $aWQx3.EDITOR_TO_PENDING_SELECTION).delete(editor);
        if (pendingSelection) {
            var { selection: selection } = editor;
            var normalized = (0, $aWQx3.normalizeRange)(editor, pendingSelection);
            if (normalized && (!selection || !(0, $akZf2.Range).equals(normalized, selection))) (0, $akZf2.Transforms).select(editor, normalized);
        }
    };
    var performAction = ()=>{
        var action = (0, $aWQx3.EDITOR_TO_PENDING_ACTION).get(editor);
        (0, $aWQx3.EDITOR_TO_PENDING_ACTION).delete(editor);
        if (!action) return;
        if (action.at) {
            var target = (0, $akZf2.Point).isPoint(action.at) ? (0, $aWQx3.normalizePoint)(editor, action.at) : (0, $aWQx3.normalizeRange)(editor, action.at);
            if (!target) return;
            var _targetRange = (0, $akZf2.Editor).range(editor, target);
            if (!editor.selection || !(0, $akZf2.Range).equals(editor.selection, _targetRange)) (0, $akZf2.Transforms).select(editor, target);
        }
        action.run();
    };
    var flush = ()=>{
        if (flushTimeoutId) {
            clearTimeout(flushTimeoutId);
            flushTimeoutId = null;
        }
        if (actionTimeoutId) {
            clearTimeout(actionTimeoutId);
            actionTimeoutId = null;
        }
        if (!hasPendingDiffs() && !hasPendingAction()) {
            applyPendingSelection();
            return;
        }
        if (!flushing) {
            flushing = true;
            setTimeout(()=>flushing = false);
        }
        if (hasPendingAction()) flushing = "action";
        var selectionRef = editor.selection && (0, $akZf2.Editor).rangeRef(editor, editor.selection, {
            affinity: "forward"
        });
        (0, $aWQx3.EDITOR_TO_USER_MARKS).set(editor, editor.marks);
        $0004ae769ccea2eb$var$debug("flush", (0, $aWQx3.EDITOR_TO_PENDING_ACTION).get(editor), (0, $aWQx3.EDITOR_TO_PENDING_DIFFS).get(editor));
        var scheduleSelectionChange = hasPendingDiffs();
        var diff;
        while(diff = (_EDITOR_TO_PENDING_DI = (0, $aWQx3.EDITOR_TO_PENDING_DIFFS).get(editor)) === null || _EDITOR_TO_PENDING_DI === void 0 ? void 0 : _EDITOR_TO_PENDING_DI[0]){
            var _EDITOR_TO_PENDING_DI, _EDITOR_TO_PENDING_DI2;
            var pendingMarks = (0, $aWQx3.EDITOR_TO_PENDING_INSERTION_MARKS).get(editor);
            if (pendingMarks !== undefined) {
                (0, $aWQx3.EDITOR_TO_PENDING_INSERTION_MARKS).delete(editor);
                editor.marks = pendingMarks;
            }
            if (pendingMarks && insertPositionHint === false) insertPositionHint = null;
            var range = (0, $aWQx3.targetRange)(diff);
            if (!editor.selection || !(0, $akZf2.Range).equals(editor.selection, range)) (0, $akZf2.Transforms).select(editor, range);
            if (diff.diff.text) (0, $akZf2.Editor).insertText(editor, diff.diff.text);
            else (0, $akZf2.Editor).deleteFragment(editor);
            // Remove diff only after we have applied it to account for it when transforming
            // pending ranges.
            (0, $aWQx3.EDITOR_TO_PENDING_DIFFS).set(editor, (_EDITOR_TO_PENDING_DI2 = (0, $aWQx3.EDITOR_TO_PENDING_DIFFS).get(editor)) === null || _EDITOR_TO_PENDING_DI2 === void 0 ? void 0 : _EDITOR_TO_PENDING_DI2.filter((_ref2)=>{
                var { id: id } = _ref2;
                return id !== diff.id;
            }));
            if (!(0, $aWQx3.verifyDiffState)(editor, diff)) {
                scheduleSelectionChange = false;
                (0, $aWQx3.EDITOR_TO_PENDING_ACTION).delete(editor);
                (0, $aWQx3.EDITOR_TO_USER_MARKS).delete(editor);
                flushing = "action";
                // Ensure we don't restore the pending user (dom) selection
                // since the document and dom state do not match.
                (0, $aWQx3.EDITOR_TO_PENDING_SELECTION).delete(editor);
                scheduleOnDOMSelectionChange.cancel();
                onDOMSelectionChange.cancel();
                selectionRef === null || selectionRef === void 0 || selectionRef.unref();
            }
        }
        var selection = selectionRef === null || selectionRef === void 0 ? void 0 : selectionRef.unref();
        if (selection && !(0, $aWQx3.EDITOR_TO_PENDING_SELECTION).get(editor) && (!editor.selection || !(0, $akZf2.Range).equals(selection, editor.selection))) (0, $akZf2.Transforms).select(editor, selection);
        if (hasPendingAction()) {
            performAction();
            return;
        }
        // COMPAT: The selectionChange event is fired after the action is performed,
        // so we have to manually schedule it to ensure we don't 'throw away' the selection
        // while rendering if we have pending changes.
        if (scheduleSelectionChange) scheduleOnDOMSelectionChange();
        scheduleOnDOMSelectionChange.flush();
        onDOMSelectionChange.flush();
        applyPendingSelection();
        var userMarks = (0, $aWQx3.EDITOR_TO_USER_MARKS).get(editor);
        (0, $aWQx3.EDITOR_TO_USER_MARKS).delete(editor);
        if (userMarks !== undefined) {
            editor.marks = userMarks;
            editor.onChange();
        }
    };
    var handleCompositionEnd = (_event)=>{
        if (compositionEndTimeoutId) clearTimeout(compositionEndTimeoutId);
        compositionEndTimeoutId = setTimeout(()=>{
            (0, $aWQx3.IS_COMPOSING).set(editor, false);
            flush();
        }, $0004ae769ccea2eb$var$RESOLVE_DELAY);
    };
    var handleCompositionStart = (_event)=>{
        (0, $aWQx3.IS_COMPOSING).set(editor, true);
        if (compositionEndTimeoutId) {
            clearTimeout(compositionEndTimeoutId);
            compositionEndTimeoutId = null;
        }
    };
    var updatePlaceholderVisibility = function updatePlaceholderVisibility() {
        var forceHide = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        var placeholderElement = (0, $aWQx3.EDITOR_TO_PLACEHOLDER_ELEMENT).get(editor);
        if (!placeholderElement) return;
        if (hasPendingDiffs() || forceHide) {
            placeholderElement.style.display = "none";
            return;
        }
        placeholderElement.style.removeProperty("display");
    };
    var storeDiff = (path, diff)=>{
        var _EDITOR_TO_PENDING_DI3;
        var pendingDiffs = (_EDITOR_TO_PENDING_DI3 = (0, $aWQx3.EDITOR_TO_PENDING_DIFFS).get(editor)) !== null && _EDITOR_TO_PENDING_DI3 !== void 0 ? _EDITOR_TO_PENDING_DI3 : [];
        (0, $aWQx3.EDITOR_TO_PENDING_DIFFS).set(editor, pendingDiffs);
        var target = (0, $akZf2.Node).leaf(editor, path);
        var idx = pendingDiffs.findIndex((change)=>(0, $akZf2.Path).equals(change.path, path));
        if (idx < 0) {
            var normalized = (0, $aWQx3.normalizeStringDiff)(target.text, diff);
            if (normalized) pendingDiffs.push({
                path: path,
                diff: diff,
                id: idCounter++
            });
            updatePlaceholderVisibility();
            return;
        }
        var merged = (0, $aWQx3.mergeStringDiffs)(target.text, pendingDiffs[idx].diff, diff);
        if (!merged) {
            pendingDiffs.splice(idx, 1);
            updatePlaceholderVisibility();
            return;
        }
        pendingDiffs[idx] = $0004ae769ccea2eb$var$_objectSpread$5($0004ae769ccea2eb$var$_objectSpread$5({}, pendingDiffs[idx]), {}, {
            diff: merged
        });
    };
    var scheduleAction = function scheduleAction(run) {
        var { at: at } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        insertPositionHint = false;
        (0, $aWQx3.EDITOR_TO_PENDING_SELECTION).delete(editor);
        scheduleOnDOMSelectionChange.cancel();
        onDOMSelectionChange.cancel();
        if (hasPendingAction()) flush();
        (0, $aWQx3.EDITOR_TO_PENDING_ACTION).set(editor, {
            at: at,
            run: run
        });
        // COMPAT: When deleting before a non-contenteditable element chrome only fires a beforeinput,
        // (no input) and doesn't perform any dom mutations. Without a flush timeout we would never flush
        // in this case and thus never actually perform the action.
        actionTimeoutId = setTimeout(flush);
    };
    var handleDOMBeforeInput = (event)=>{
        var _targetRange2;
        if (flushTimeoutId) {
            clearTimeout(flushTimeoutId);
            flushTimeoutId = null;
        }
        if ((0, $aWQx3.IS_NODE_MAP_DIRTY).get(editor)) return;
        var { inputType: type } = event;
        var targetRange = null;
        var data = event.dataTransfer || event.data || undefined;
        if (insertPositionHint !== false && type !== "insertText" && type !== "insertCompositionText") insertPositionHint = false;
        var [nativeTargetRange] = event.getTargetRanges();
        if (nativeTargetRange) targetRange = $0004ae769ccea2eb$export$a55741a99bf22636.toSlateRange(editor, nativeTargetRange, {
            exactMatch: false,
            suppressThrow: true
        });
        // COMPAT: SelectionChange event is fired after the action is performed, so we
        // have to manually get the selection here to ensure it's up-to-date.
        var window1 = $0004ae769ccea2eb$export$a55741a99bf22636.getWindow(editor);
        var domSelection = window1.getSelection();
        if (!targetRange && domSelection) {
            nativeTargetRange = domSelection;
            targetRange = $0004ae769ccea2eb$export$a55741a99bf22636.toSlateRange(editor, domSelection, {
                exactMatch: false,
                suppressThrow: true
            });
        }
        targetRange = (_targetRange2 = targetRange) !== null && _targetRange2 !== void 0 ? _targetRange2 : editor.selection;
        if (!targetRange) return;
        // By default, the input manager tries to store text diffs so that we can
        // defer flushing them at a later point in time. We don't want to flush
        // for every input event as this can be expensive. However, there are some
        // scenarios where we cannot safely store the text diff and must instead
        // schedule an action to let Slate normalize the editor state.
        var canStoreDiff = true;
        if (type.startsWith("delete")) {
            if ((0, $akZf2.Range).isExpanded(targetRange)) {
                var [_start, _end] = (0, $akZf2.Range).edges(targetRange);
                var _leaf = (0, $akZf2.Node).leaf(editor, _start.path);
                if (_leaf.text.length === _start.offset && _end.offset === 0) {
                    var next = (0, $akZf2.Editor).next(editor, {
                        at: _start.path,
                        match: (0, $akZf2.Text).isText
                    });
                    if (next && (0, $akZf2.Path).equals(next[1], _end.path)) targetRange = {
                        anchor: _end,
                        focus: _end
                    };
                }
            }
            var direction = type.endsWith("Backward") ? "backward" : "forward";
            var [start, end] = (0, $akZf2.Range).edges(targetRange);
            var [leaf, path] = (0, $akZf2.Editor).leaf(editor, start.path);
            var diff = {
                text: "",
                start: start.offset,
                end: end.offset
            };
            var pendingDiffs = (0, $aWQx3.EDITOR_TO_PENDING_DIFFS).get(editor);
            var relevantPendingDiffs = pendingDiffs === null || pendingDiffs === void 0 ? void 0 : pendingDiffs.find((change)=>(0, $akZf2.Path).equals(change.path, path));
            var diffs = relevantPendingDiffs ? [
                relevantPendingDiffs.diff,
                diff
            ] : [
                diff
            ];
            var text = (0, $aWQx3.applyStringDiff)(leaf.text, ...diffs);
            if (text.length === 0) // Text leaf will be removed, so we need to schedule an
            // action to remove it so that Slate can normalize instead
            // of storing as a diff
            canStoreDiff = false;
            if ((0, $akZf2.Range).isExpanded(targetRange)) {
                if (canStoreDiff && (0, $akZf2.Path).equals(targetRange.anchor.path, targetRange.focus.path)) {
                    var point = {
                        path: targetRange.anchor.path,
                        offset: start.offset
                    };
                    var range = (0, $akZf2.Editor).range(editor, point, point);
                    handleUserSelect(range);
                    return storeDiff(targetRange.anchor.path, {
                        text: "",
                        end: end.offset,
                        start: start.offset
                    });
                }
                return scheduleAction(()=>(0, $akZf2.Editor).deleteFragment(editor, {
                        direction: direction
                    }), {
                    at: targetRange
                });
            }
        }
        switch(type){
            case "deleteByComposition":
            case "deleteByCut":
            case "deleteByDrag":
                return scheduleAction(()=>(0, $akZf2.Editor).deleteFragment(editor), {
                    at: targetRange
                });
            case "deleteContent":
            case "deleteContentForward":
                var { anchor: anchor } = targetRange;
                if (canStoreDiff && (0, $akZf2.Range).isCollapsed(targetRange)) {
                    var targetNode = (0, $akZf2.Node).leaf(editor, anchor.path);
                    if (anchor.offset < targetNode.text.length) return storeDiff(anchor.path, {
                        text: "",
                        start: anchor.offset,
                        end: anchor.offset + 1
                    });
                }
                return scheduleAction(()=>(0, $akZf2.Editor).deleteForward(editor), {
                    at: targetRange
                });
            case "deleteContentBackward":
                var _nativeTargetRange;
                var { anchor: _anchor } = targetRange;
                // If we have a mismatch between the native and slate selection being collapsed
                // we are most likely deleting a zero-width placeholder and thus should perform it
                // as an action to ensure correct behavior (mostly happens with mark placeholders)
                var nativeCollapsed = (0, $aWQx3.isDOMSelection)(nativeTargetRange) ? nativeTargetRange.isCollapsed : !!((_nativeTargetRange = nativeTargetRange) !== null && _nativeTargetRange !== void 0 && _nativeTargetRange.collapsed);
                if (canStoreDiff && nativeCollapsed && (0, $akZf2.Range).isCollapsed(targetRange) && _anchor.offset > 0) return storeDiff(_anchor.path, {
                    text: "",
                    start: _anchor.offset - 1,
                    end: _anchor.offset
                });
                return scheduleAction(()=>(0, $akZf2.Editor).deleteBackward(editor), {
                    at: targetRange
                });
            case "deleteEntireSoftLine":
                return scheduleAction(()=>{
                    (0, $akZf2.Editor).deleteBackward(editor, {
                        unit: "line"
                    });
                    (0, $akZf2.Editor).deleteForward(editor, {
                        unit: "line"
                    });
                }, {
                    at: targetRange
                });
            case "deleteHardLineBackward":
                return scheduleAction(()=>(0, $akZf2.Editor).deleteBackward(editor, {
                        unit: "block"
                    }), {
                    at: targetRange
                });
            case "deleteSoftLineBackward":
                return scheduleAction(()=>(0, $akZf2.Editor).deleteBackward(editor, {
                        unit: "line"
                    }), {
                    at: targetRange
                });
            case "deleteHardLineForward":
                return scheduleAction(()=>(0, $akZf2.Editor).deleteForward(editor, {
                        unit: "block"
                    }), {
                    at: targetRange
                });
            case "deleteSoftLineForward":
                return scheduleAction(()=>(0, $akZf2.Editor).deleteForward(editor, {
                        unit: "line"
                    }), {
                    at: targetRange
                });
            case "deleteWordBackward":
                return scheduleAction(()=>(0, $akZf2.Editor).deleteBackward(editor, {
                        unit: "word"
                    }), {
                    at: targetRange
                });
            case "deleteWordForward":
                return scheduleAction(()=>(0, $akZf2.Editor).deleteForward(editor, {
                        unit: "word"
                    }), {
                    at: targetRange
                });
            case "insertLineBreak":
                return scheduleAction(()=>(0, $akZf2.Editor).insertSoftBreak(editor), {
                    at: targetRange
                });
            case "insertParagraph":
                return scheduleAction(()=>(0, $akZf2.Editor).insertBreak(editor), {
                    at: targetRange
                });
            case "insertCompositionText":
            case "deleteCompositionText":
            case "insertFromComposition":
            case "insertFromDrop":
            case "insertFromPaste":
            case "insertFromYank":
            case "insertReplacementText":
            case "insertText":
                if ($0004ae769ccea2eb$var$isDataTransfer(data)) return scheduleAction(()=>$0004ae769ccea2eb$export$a55741a99bf22636.insertData(editor, data), {
                    at: targetRange
                });
                var _text = data !== null && data !== void 0 ? data : "";
                // COMPAT: If we are writing inside a placeholder, the ime inserts the text inside
                // the placeholder itself and thus includes the zero-width space inside edit events.
                if ((0, $aWQx3.EDITOR_TO_PENDING_INSERTION_MARKS).get(editor)) _text = _text.replace("\uFEFF", "");
                // Pastes from the Android clipboard will generate `insertText` events.
                // If the copied text contains any newlines, Android will append an
                // extra newline to the end of the copied text.
                if (type === "insertText" && /.*\n.*\n$/.test(_text)) _text = _text.slice(0, -1);
                // If the text includes a newline, split it at newlines and paste each component
                // string, with soft breaks in between each.
                if (_text.includes("\n")) return scheduleAction(()=>{
                    var parts = _text.split("\n");
                    parts.forEach((line, i)=>{
                        if (line) (0, $akZf2.Editor).insertText(editor, line);
                        if (i !== parts.length - 1) (0, $akZf2.Editor).insertSoftBreak(editor);
                    });
                }, {
                    at: targetRange
                });
                if ((0, $akZf2.Path).equals(targetRange.anchor.path, targetRange.focus.path)) {
                    var [_start2, _end2] = (0, $akZf2.Range).edges(targetRange);
                    var _diff = {
                        start: _start2.offset,
                        end: _end2.offset,
                        text: _text
                    };
                    // COMPAT: Swiftkey has a weird bug where the target range of the 2nd word
                    // inserted after a mark placeholder is inserted with an anchor offset off by 1.
                    // So writing 'some text' will result in 'some ttext'. Luckily all 'normal' insert
                    // text events are fired with the correct target ranges, only the final 'insertComposition'
                    // isn't, so we can adjust the target range start offset if we are confident this is the
                    // swiftkey insert causing the issue.
                    if (_text && insertPositionHint && type === "insertCompositionText") {
                        var hintPosition = insertPositionHint.start + insertPositionHint.text.search(/\S|$/);
                        var diffPosition = _diff.start + _diff.text.search(/\S|$/);
                        if (diffPosition === hintPosition + 1 && _diff.end === insertPositionHint.start + insertPositionHint.text.length) {
                            _diff.start -= 1;
                            insertPositionHint = null;
                            scheduleFlush();
                        } else insertPositionHint = false;
                    } else if (type === "insertText") {
                        if (insertPositionHint === null) insertPositionHint = _diff;
                        else if (insertPositionHint && (0, $akZf2.Range).isCollapsed(targetRange) && insertPositionHint.end + insertPositionHint.text.length === _start2.offset) insertPositionHint = $0004ae769ccea2eb$var$_objectSpread$5($0004ae769ccea2eb$var$_objectSpread$5({}, insertPositionHint), {}, {
                            text: insertPositionHint.text + _text
                        });
                        else insertPositionHint = false;
                    } else insertPositionHint = false;
                    if (canStoreDiff) {
                        storeDiff(_start2.path, _diff);
                        return;
                    }
                }
                return scheduleAction(()=>(0, $akZf2.Editor).insertText(editor, _text), {
                    at: targetRange
                });
        }
    };
    var hasPendingAction = ()=>{
        return !!(0, $aWQx3.EDITOR_TO_PENDING_ACTION).get(editor);
    };
    var hasPendingDiffs = ()=>{
        var _EDITOR_TO_PENDING_DI4;
        return !!((_EDITOR_TO_PENDING_DI4 = (0, $aWQx3.EDITOR_TO_PENDING_DIFFS).get(editor)) !== null && _EDITOR_TO_PENDING_DI4 !== void 0 && _EDITOR_TO_PENDING_DI4.length);
    };
    var hasPendingChanges = ()=>{
        return hasPendingAction() || hasPendingDiffs();
    };
    var isFlushing = ()=>{
        return flushing;
    };
    var handleUserSelect = (range)=>{
        (0, $aWQx3.EDITOR_TO_PENDING_SELECTION).set(editor, range);
        if (flushTimeoutId) {
            clearTimeout(flushTimeoutId);
            flushTimeoutId = null;
        }
        var { selection: selection } = editor;
        if (!range) return;
        var pathChanged = !selection || !(0, $akZf2.Path).equals(selection.anchor.path, range.anchor.path);
        var parentPathChanged = !selection || !(0, $akZf2.Path).equals(selection.anchor.path.slice(0, -1), range.anchor.path.slice(0, -1));
        if (pathChanged && insertPositionHint || parentPathChanged) insertPositionHint = false;
        if (pathChanged || hasPendingDiffs()) flushTimeoutId = setTimeout(flush, $0004ae769ccea2eb$var$FLUSH_DELAY);
    };
    var handleInput = ()=>{
        if (hasPendingAction() || !hasPendingDiffs()) flush();
    };
    var handleKeyDown = (_)=>{
        // COMPAT: Swiftkey closes the keyboard when typing inside a empty node
        // directly next to a non-contenteditable element (= the placeholder).
        // The only event fired soon enough for us to allow hiding the placeholder
        // without swiftkey picking it up is the keydown event, so we have to hide it
        // here. See https://github.com/ianstormtaylor/slate/pull/4988#issuecomment-1201050535
        if (!hasPendingDiffs()) {
            updatePlaceholderVisibility(true);
            setTimeout(updatePlaceholderVisibility);
        }
    };
    var scheduleFlush = ()=>{
        if (!hasPendingAction()) actionTimeoutId = setTimeout(flush);
    };
    var handleDomMutations = (mutations)=>{
        if (hasPendingDiffs() || hasPendingAction()) return;
        if (mutations.some((mutation)=>(0, $aWQx3.isTrackedMutation)(editor, mutation, mutations))) {
            var _EDITOR_TO_FORCE_REND;
            // Cause a re-render to restore the dom state if we encounter tracked mutations without
            // a corresponding pending action.
            (_EDITOR_TO_FORCE_REND = (0, $aWQx3.EDITOR_TO_FORCE_RENDER).get(editor)) === null || _EDITOR_TO_FORCE_REND === void 0 || _EDITOR_TO_FORCE_REND();
        }
    };
    return {
        flush: flush,
        scheduleFlush: scheduleFlush,
        hasPendingDiffs: hasPendingDiffs,
        hasPendingAction: hasPendingAction,
        hasPendingChanges: hasPendingChanges,
        isFlushing: isFlushing,
        handleUserSelect: handleUserSelect,
        handleCompositionEnd: handleCompositionEnd,
        handleCompositionStart: handleCompositionStart,
        handleDOMBeforeInput: handleDOMBeforeInput,
        handleKeyDown: handleKeyDown,
        handleDomMutations: handleDomMutations,
        handleInput: handleInput
    };
}
function $0004ae769ccea2eb$var$useIsMounted() {
    var isMountedRef = (0, $eeH7J.useRef)(false);
    (0, $eeH7J.useEffect)(()=>{
        isMountedRef.current = true;
        return ()=>{
            isMountedRef.current = false;
        };
    }, []);
    return isMountedRef.current;
}
/**
 * Prevent warning on SSR by falling back to useEffect when DOM isn't available
 */ var $0004ae769ccea2eb$var$useIsomorphicLayoutEffect = (0, $aWQx3.CAN_USE_DOM) ? (0, $eeH7J.useLayoutEffect) : (0, $eeH7J.useEffect);
function $0004ae769ccea2eb$var$useMutationObserver(node, callback, options) {
    var [mutationObserver] = (0, $eeH7J.useState)(()=>new MutationObserver(callback));
    $0004ae769ccea2eb$var$useIsomorphicLayoutEffect(()=>{
        // Discard mutations caused during render phase. This works due to react calling
        // useLayoutEffect synchronously after the render phase before the next tick.
        mutationObserver.takeRecords();
    });
    (0, $eeH7J.useEffect)(()=>{
        if (!node.current) throw new Error("Failed to attach MutationObserver, `node` is undefined");
        mutationObserver.observe(node.current, options);
        return ()=>mutationObserver.disconnect();
    }, [
        mutationObserver,
        node,
        options
    ]);
}
var $0004ae769ccea2eb$var$_excluded$2 = [
    "node"
];
function $0004ae769ccea2eb$var$ownKeys$4(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $0004ae769ccea2eb$var$_objectSpread$4(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $0004ae769ccea2eb$var$ownKeys$4(Object(t), !0).forEach(function(r) {
            $0004ae769ccea2eb$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $0004ae769ccea2eb$var$ownKeys$4(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $0004ae769ccea2eb$var$MUTATION_OBSERVER_CONFIG$1 = {
    subtree: true,
    childList: true,
    characterData: true
};
var $0004ae769ccea2eb$var$useAndroidInputManager = !(0, $aWQx3.IS_ANDROID) ? ()=>null : (_ref)=>{
    var { node: node } = _ref, options = $0004ae769ccea2eb$var$_objectWithoutProperties(_ref, $0004ae769ccea2eb$var$_excluded$2);
    if (!(0, $aWQx3.IS_ANDROID)) return null;
    var editor = $0004ae769ccea2eb$export$b4a4dff812101bed();
    var isMounted = $0004ae769ccea2eb$var$useIsMounted();
    var [inputManager] = (0, $eeH7J.useState)(()=>$0004ae769ccea2eb$var$createAndroidInputManager($0004ae769ccea2eb$var$_objectSpread$4({
            editor: editor
        }, options)));
    $0004ae769ccea2eb$var$useMutationObserver(node, inputManager.handleDomMutations, $0004ae769ccea2eb$var$MUTATION_OBSERVER_CONFIG$1);
    (0, $aWQx3.EDITOR_TO_SCHEDULE_FLUSH).set(editor, inputManager.scheduleFlush);
    if (isMounted) inputManager.flush();
    return inputManager;
};
function $0004ae769ccea2eb$var$ownKeys$3(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $0004ae769ccea2eb$var$_objectSpread$3(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $0004ae769ccea2eb$var$ownKeys$3(Object(t), !0).forEach(function(r) {
            $0004ae769ccea2eb$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $0004ae769ccea2eb$var$ownKeys$3(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * Leaf content strings.
 */ var $0004ae769ccea2eb$var$String$1 = (props)=>{
    var { isLast: isLast, leaf: leaf, parent: parent, text: text } = props;
    var editor = $0004ae769ccea2eb$export$b4a4dff812101bed();
    var path = $0004ae769ccea2eb$export$a55741a99bf22636.findPath(editor, text);
    var parentPath = (0, $akZf2.Path).parent(path);
    var isMarkPlaceholder = Boolean(leaf[0, $aWQx3.MARK_PLACEHOLDER_SYMBOL]);
    // COMPAT: Render text inside void nodes with a zero-width space.
    // So the node can contain selection but the text is not visible.
    if (editor.isVoid(parent)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement($0004ae769ccea2eb$var$ZeroWidthString, {
        length: (0, $akZf2.Node).string(parent).length
    });
    // COMPAT: If this is the last text node in an empty block, render a zero-
    // width space that will convert into a line break when copying and pasting
    // to support expected plain text.
    if (leaf.text === "" && parent.children[parent.children.length - 1] === text && !editor.isInline(parent) && (0, $akZf2.Editor).string(editor, parentPath) === "") return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement($0004ae769ccea2eb$var$ZeroWidthString, {
        isLineBreak: true,
        isMarkPlaceholder: isMarkPlaceholder
    });
    // COMPAT: If the text is empty, it's because it's on the edge of an inline
    // node, so we render a zero-width space so that the selection can be
    // inserted next to it still.
    if (leaf.text === "") return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement($0004ae769ccea2eb$var$ZeroWidthString, {
        isMarkPlaceholder: isMarkPlaceholder
    });
    // COMPAT: Browsers will collapse trailing new lines at the end of blocks,
    // so we need to add an extra trailing new lines to prevent that.
    if (isLast && leaf.text.slice(-1) === "\n") return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement($0004ae769ccea2eb$var$TextString, {
        isTrailing: true,
        text: leaf.text
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement($0004ae769ccea2eb$var$TextString, {
        text: leaf.text
    });
};
/**
 * Leaf strings with text in them.
 */ var $0004ae769ccea2eb$var$TextString = (props)=>{
    var { text: text, isTrailing: isTrailing = false } = props;
    var ref = (0, $eeH7J.useRef)(null);
    var getTextContent = ()=>{
        return "".concat(text !== null && text !== void 0 ? text : "").concat(isTrailing ? "\n" : "");
    };
    var [initialText] = (0, $eeH7J.useState)(getTextContent);
    // This is the actual text rendering boundary where we interface with the DOM
    // The text is not rendered as part of the virtual DOM, as since we handle basic character insertions natively,
    // updating the DOM is not a one way dataflow anymore. What we need here is not reconciliation and diffing
    // with previous version of the virtual DOM, but rather diffing with the actual DOM element, and replace the DOM <span> content
    // exactly if and only if its current content does not match our current virtual DOM.
    // Otherwise the DOM TextNode would always be replaced by React as the user types, which interferes with native text features,
    // eg makes native spellcheck opt out from checking the text node.
    // useLayoutEffect: updating our span before browser paint
    $0004ae769ccea2eb$var$useIsomorphicLayoutEffect(()=>{
        // null coalescing text to make sure we're not outputing "null" as a string in the extreme case it is nullish at runtime
        var textWithTrailing = getTextContent();
        if (ref.current && ref.current.textContent !== textWithTrailing) ref.current.textContent = textWithTrailing;
    // intentionally not specifying dependencies, so that this effect runs on every render
    // as this effectively replaces "specifying the text in the virtual DOM under the <span> below" on each render
    });
    // We intentionally render a memoized <span> that only receives the initial text content when the component is mounted.
    // We defer to the layout effect above to update the `textContent` of the span element when needed.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement($0004ae769ccea2eb$var$MemoizedText$1, {
        ref: ref
    }, initialText);
};
var $0004ae769ccea2eb$var$MemoizedText$1 = /*#__PURE__*/ (0, $eeH7J.memo)(/*#__PURE__*/ (0, $eeH7J.forwardRef)((props, ref)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("span", {
        "data-slate-string": true,
        ref: ref
    }, props.children);
}));
/**
 * Leaf strings without text, render as zero-width strings.
 */ var $0004ae769ccea2eb$var$ZeroWidthString = (props)=>{
    var { length: length = 0, isLineBreak: isLineBreak = false, isMarkPlaceholder: isMarkPlaceholder = false } = props;
    var attributes = {
        "data-slate-zero-width": isLineBreak ? "n" : "z",
        "data-slate-length": length
    };
    if (isMarkPlaceholder) attributes["data-slate-mark-placeholder"] = true;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("span", $0004ae769ccea2eb$var$_objectSpread$3({}, attributes), !((0, $aWQx3.IS_ANDROID) || (0, $aWQx3.IS_IOS)) || !isLineBreak ? "\uFEFF" : null, isLineBreak ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("br", null) : null);
};
function $0004ae769ccea2eb$var$ownKeys$2(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $0004ae769ccea2eb$var$_objectSpread$2(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $0004ae769ccea2eb$var$ownKeys$2(Object(t), !0).forEach(function(r) {
            $0004ae769ccea2eb$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $0004ae769ccea2eb$var$ownKeys$2(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
// Delay the placeholder on Android to prevent the keyboard from closing.
// (https://github.com/ianstormtaylor/slate/pull/5368)
var $0004ae769ccea2eb$var$PLACEHOLDER_DELAY = (0, $aWQx3.IS_ANDROID) ? 300 : 0;
function $0004ae769ccea2eb$var$disconnectPlaceholderResizeObserver(placeholderResizeObserver, releaseObserver) {
    if (placeholderResizeObserver.current) {
        placeholderResizeObserver.current.disconnect();
        if (releaseObserver) placeholderResizeObserver.current = null;
    }
}
function $0004ae769ccea2eb$var$clearTimeoutRef(timeoutRef) {
    if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
        timeoutRef.current = null;
    }
}
/**
 * Individual leaves in a text node with unique formatting.
 */ var $0004ae769ccea2eb$var$Leaf = (props)=>{
    var { leaf: leaf, isLast: isLast, text: text, parent: parent, renderPlaceholder: renderPlaceholder, renderLeaf: renderLeaf = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement($0004ae769ccea2eb$export$6dc0db481a64ef2, $0004ae769ccea2eb$var$_objectSpread$2({}, props)) } = props;
    var editor = $0004ae769ccea2eb$export$b4a4dff812101bed();
    var placeholderResizeObserver = (0, $eeH7J.useRef)(null);
    var placeholderRef = (0, $eeH7J.useRef)(null);
    var [showPlaceholder, setShowPlaceholder] = (0, $eeH7J.useState)(false);
    var showPlaceholderTimeoutRef = (0, $eeH7J.useRef)(null);
    var callbackPlaceholderRef = (0, $eeH7J.useCallback)((placeholderEl)=>{
        $0004ae769ccea2eb$var$disconnectPlaceholderResizeObserver(placeholderResizeObserver, placeholderEl == null);
        if (placeholderEl == null) {
            var _leaf$onPlaceholderRe;
            (0, $aWQx3.EDITOR_TO_PLACEHOLDER_ELEMENT).delete(editor);
            (_leaf$onPlaceholderRe = leaf.onPlaceholderResize) === null || _leaf$onPlaceholderRe === void 0 || _leaf$onPlaceholderRe.call(leaf, null);
        } else {
            (0, $aWQx3.EDITOR_TO_PLACEHOLDER_ELEMENT).set(editor, placeholderEl);
            if (!placeholderResizeObserver.current) {
                // Create a new observer and observe the placeholder element.
                var ResizeObserver$1 = window.ResizeObserver || (0, $bkU1H.ResizeObserver);
                placeholderResizeObserver.current = new ResizeObserver$1(()=>{
                    var _leaf$onPlaceholderRe2;
                    (_leaf$onPlaceholderRe2 = leaf.onPlaceholderResize) === null || _leaf$onPlaceholderRe2 === void 0 || _leaf$onPlaceholderRe2.call(leaf, placeholderEl);
                });
            }
            placeholderResizeObserver.current.observe(placeholderEl);
            placeholderRef.current = placeholderEl;
        }
    }, [
        placeholderRef,
        leaf,
        editor
    ]);
    var children = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement($0004ae769ccea2eb$var$String$1, {
        isLast: isLast,
        leaf: leaf,
        parent: parent,
        text: text
    });
    var leafIsPlaceholder = Boolean(leaf[0, $aWQx3.PLACEHOLDER_SYMBOL]);
    (0, $eeH7J.useEffect)(()=>{
        if (leafIsPlaceholder) {
            if (!showPlaceholderTimeoutRef.current) // Delay the placeholder, so it will not render in a selection
            showPlaceholderTimeoutRef.current = setTimeout(()=>{
                setShowPlaceholder(true);
                showPlaceholderTimeoutRef.current = null;
            }, $0004ae769ccea2eb$var$PLACEHOLDER_DELAY);
        } else {
            $0004ae769ccea2eb$var$clearTimeoutRef(showPlaceholderTimeoutRef);
            setShowPlaceholder(false);
        }
        return ()=>$0004ae769ccea2eb$var$clearTimeoutRef(showPlaceholderTimeoutRef);
    }, [
        leafIsPlaceholder,
        setShowPlaceholder
    ]);
    if (leafIsPlaceholder && showPlaceholder) {
        var placeholderProps = {
            children: leaf.placeholder,
            attributes: {
                "data-slate-placeholder": true,
                style: {
                    position: "absolute",
                    top: 0,
                    pointerEvents: "none",
                    width: "100%",
                    maxWidth: "100%",
                    display: "block",
                    opacity: "0.333",
                    userSelect: "none",
                    textDecoration: "none",
                    // Fixes https://github.com/udecode/plate/issues/2315
                    WebkitUserModify: (0, $aWQx3.IS_WEBKIT) ? "inherit" : undefined
                },
                contentEditable: false,
                ref: callbackPlaceholderRef
            }
        };
        children = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).Fragment, null, renderPlaceholder(placeholderProps), children);
    }
    // COMPAT: Having the `data-` attributes on these leaf elements ensures that
    // in certain misbehaving browsers they aren't weirdly cloned/destroyed by
    // contenteditable behaviors. (2019/05/08)
    var attributes = {
        "data-slate-leaf": true
    };
    return renderLeaf({
        attributes: attributes,
        children: children,
        leaf: leaf,
        text: text
    });
};
var $0004ae769ccea2eb$var$MemoizedLeaf = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).memo($0004ae769ccea2eb$var$Leaf, (prev, next)=>{
    return next.parent === prev.parent && next.isLast === prev.isLast && next.renderLeaf === prev.renderLeaf && next.renderPlaceholder === prev.renderPlaceholder && next.text === prev.text && (0, $akZf2.Text).equals(next.leaf, prev.leaf) && next.leaf[0, $aWQx3.PLACEHOLDER_SYMBOL] === prev.leaf[0, $aWQx3.PLACEHOLDER_SYMBOL];
});
var $0004ae769ccea2eb$export$6dc0db481a64ef2 = (props)=>{
    var { attributes: attributes, children: children } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("span", $0004ae769ccea2eb$var$_objectSpread$2({}, attributes), children);
};
/**
 * Text.
 */ var $0004ae769ccea2eb$var$Text = (props)=>{
    var { decorations: decorations, isLast: isLast, parent: parent, renderPlaceholder: renderPlaceholder, renderLeaf: renderLeaf, text: text } = props;
    var editor = $0004ae769ccea2eb$export$b4a4dff812101bed();
    var ref = (0, $eeH7J.useRef)(null);
    var leaves = (0, $akZf2.Text).decorations(text, decorations);
    var key = $0004ae769ccea2eb$export$a55741a99bf22636.findKey(editor, text);
    var children = [];
    for(var i = 0; i < leaves.length; i++){
        var leaf = leaves[i];
        children.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement($0004ae769ccea2eb$var$MemoizedLeaf, {
            isLast: isLast && i === leaves.length - 1,
            key: "".concat(key.id, "-").concat(i),
            renderPlaceholder: renderPlaceholder,
            leaf: leaf,
            text: text,
            parent: parent,
            renderLeaf: renderLeaf
        }));
    }
    // Update element-related weak maps with the DOM element ref.
    var callbackRef = (0, $eeH7J.useCallback)((span)=>{
        var KEY_TO_ELEMENT = (0, $aWQx3.EDITOR_TO_KEY_TO_ELEMENT).get(editor);
        if (span) {
            KEY_TO_ELEMENT === null || KEY_TO_ELEMENT === void 0 || KEY_TO_ELEMENT.set(key, span);
            (0, $aWQx3.NODE_TO_ELEMENT).set(text, span);
            (0, $aWQx3.ELEMENT_TO_NODE).set(span, text);
        } else {
            KEY_TO_ELEMENT === null || KEY_TO_ELEMENT === void 0 || KEY_TO_ELEMENT.delete(key);
            (0, $aWQx3.NODE_TO_ELEMENT).delete(text);
            if (ref.current) (0, $aWQx3.ELEMENT_TO_NODE).delete(ref.current);
        }
        ref.current = span;
    }, [
        ref,
        editor,
        key,
        text
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("span", {
        "data-slate-node": "text",
        ref: callbackRef
    }, children);
};
var $0004ae769ccea2eb$var$MemoizedText = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).memo($0004ae769ccea2eb$var$Text, (prev, next)=>{
    return next.parent === prev.parent && next.isLast === prev.isLast && next.renderLeaf === prev.renderLeaf && next.renderPlaceholder === prev.renderPlaceholder && next.text === prev.text && (0, $aWQx3.isTextDecorationsEqual)(next.decorations, prev.decorations);
});
function $0004ae769ccea2eb$var$ownKeys$1(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $0004ae769ccea2eb$var$_objectSpread$1(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $0004ae769ccea2eb$var$ownKeys$1(Object(t), !0).forEach(function(r) {
            $0004ae769ccea2eb$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $0004ae769ccea2eb$var$ownKeys$1(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * Element.
 */ var $0004ae769ccea2eb$var$Element = (props)=>{
    var { decorations: decorations, element: element, renderElement: renderElement = (p)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement($0004ae769ccea2eb$export$dc23ec1715ec12f8, $0004ae769ccea2eb$var$_objectSpread$1({}, p)), renderPlaceholder: renderPlaceholder, renderLeaf: renderLeaf, selection: selection } = props;
    var editor = $0004ae769ccea2eb$export$b4a4dff812101bed();
    var readOnly = $0004ae769ccea2eb$export$ba4c632f2a3941d2();
    var isInline = editor.isInline(element);
    var key = $0004ae769ccea2eb$export$a55741a99bf22636.findKey(editor, element);
    var ref = (0, $eeH7J.useCallback)((ref)=>{
        // Update element-related weak maps with the DOM element ref.
        var KEY_TO_ELEMENT = (0, $aWQx3.EDITOR_TO_KEY_TO_ELEMENT).get(editor);
        if (ref) {
            KEY_TO_ELEMENT === null || KEY_TO_ELEMENT === void 0 || KEY_TO_ELEMENT.set(key, ref);
            (0, $aWQx3.NODE_TO_ELEMENT).set(element, ref);
            (0, $aWQx3.ELEMENT_TO_NODE).set(ref, element);
        } else {
            KEY_TO_ELEMENT === null || KEY_TO_ELEMENT === void 0 || KEY_TO_ELEMENT.delete(key);
            (0, $aWQx3.NODE_TO_ELEMENT).delete(element);
        }
    }, [
        editor,
        key,
        element
    ]);
    var children = $0004ae769ccea2eb$var$useChildren({
        decorations: decorations,
        node: element,
        renderElement: renderElement,
        renderPlaceholder: renderPlaceholder,
        renderLeaf: renderLeaf,
        selection: selection
    });
    // Attributes that the developer must mix into the element in their
    // custom node renderer component.
    var attributes = {
        "data-slate-node": "element",
        ref: ref
    };
    if (isInline) attributes["data-slate-inline"] = true;
    // If it's a block node with inline children, add the proper `dir` attribute
    // for text direction.
    if (!isInline && (0, $akZf2.Editor).hasInlines(editor, element)) {
        var text = (0, $akZf2.Node).string(element);
        var dir = (0, (/*@__PURE__*/$parcel$interopDefault($hA1QH)))(text);
        if (dir === "rtl") attributes.dir = dir;
    }
    // If it's a void node, wrap the children in extra void-specific elements.
    if ((0, $akZf2.Editor).isVoid(editor, element)) {
        attributes["data-slate-void"] = true;
        if (!readOnly && isInline) attributes.contentEditable = false;
        var Tag = isInline ? "span" : "div";
        var [[_text]] = (0, $akZf2.Node).texts(element);
        children = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement(Tag, {
            "data-slate-spacer": true,
            style: {
                height: "0",
                color: "transparent",
                outline: "none",
                position: "absolute"
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement($0004ae769ccea2eb$var$MemoizedText, {
            renderPlaceholder: renderPlaceholder,
            decorations: [],
            isLast: false,
            parent: element,
            text: _text
        }));
        (0, $aWQx3.NODE_TO_INDEX).set(_text, 0);
        (0, $aWQx3.NODE_TO_PARENT).set(_text, element);
    }
    return renderElement({
        attributes: attributes,
        children: children,
        element: element
    });
};
var $0004ae769ccea2eb$var$MemoizedElement = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).memo($0004ae769ccea2eb$var$Element, (prev, next)=>{
    return prev.element === next.element && prev.renderElement === next.renderElement && prev.renderLeaf === next.renderLeaf && prev.renderPlaceholder === next.renderPlaceholder && (0, $aWQx3.isElementDecorationsEqual)(prev.decorations, next.decorations) && (prev.selection === next.selection || !!prev.selection && !!next.selection && (0, $akZf2.Range).equals(prev.selection, next.selection));
});
/**
 * The default element renderer.
 */ var $0004ae769ccea2eb$export$dc23ec1715ec12f8 = (props)=>{
    var { attributes: attributes, children: children, element: element } = props;
    var editor = $0004ae769ccea2eb$export$b4a4dff812101bed();
    var Tag = editor.isInline(element) ? "span" : "div";
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement(Tag, $0004ae769ccea2eb$var$_objectSpread$1($0004ae769ccea2eb$var$_objectSpread$1({}, attributes), {}, {
        style: {
            position: "relative"
        }
    }), children);
};
/**
 * A React context for sharing the `decorate` prop of the editable.
 */ var $0004ae769ccea2eb$var$DecorateContext = /*#__PURE__*/ (0, $eeH7J.createContext)(()=>[]);
/**
 * Get the current `decorate` prop of the editable.
 */ var $0004ae769ccea2eb$var$useDecorate = ()=>{
    return (0, $eeH7J.useContext)($0004ae769ccea2eb$var$DecorateContext);
};
/**
 * A React context for sharing the `selected` state of an element.
 */ var $0004ae769ccea2eb$var$SelectedContext = /*#__PURE__*/ (0, $eeH7J.createContext)(false);
/**
 * Get the current `selected` state of an element.
 */ var $0004ae769ccea2eb$export$37c02c2c66380263 = ()=>{
    return (0, $eeH7J.useContext)($0004ae769ccea2eb$var$SelectedContext);
};
/**
 * Children.
 */ var $0004ae769ccea2eb$var$useChildren = (props)=>{
    var { decorations: decorations, node: node, renderElement: renderElement, renderPlaceholder: renderPlaceholder, renderLeaf: renderLeaf, selection: selection } = props;
    var decorate = $0004ae769ccea2eb$var$useDecorate();
    var editor = $0004ae769ccea2eb$export$b4a4dff812101bed();
    (0, $aWQx3.IS_NODE_MAP_DIRTY).set(editor, false);
    var path = $0004ae769ccea2eb$export$a55741a99bf22636.findPath(editor, node);
    var children = [];
    var isLeafBlock = (0, $akZf2.Element).isElement(node) && !editor.isInline(node) && (0, $akZf2.Editor).hasInlines(editor, node);
    for(var i = 0; i < node.children.length; i++){
        var p = path.concat(i);
        var n = node.children[i];
        var key = $0004ae769ccea2eb$export$a55741a99bf22636.findKey(editor, n);
        var range = (0, $akZf2.Editor).range(editor, p);
        var sel = selection && (0, $akZf2.Range).intersection(range, selection);
        var ds = decorate([
            n,
            p
        ]);
        for (var dec of decorations){
            var d = (0, $akZf2.Range).intersection(dec, range);
            if (d) ds.push(d);
        }
        if ((0, $akZf2.Element).isElement(n)) children.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement($0004ae769ccea2eb$var$SelectedContext.Provider, {
            key: "provider-".concat(key.id),
            value: !!sel
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement($0004ae769ccea2eb$var$MemoizedElement, {
            decorations: ds,
            element: n,
            key: key.id,
            renderElement: renderElement,
            renderPlaceholder: renderPlaceholder,
            renderLeaf: renderLeaf,
            selection: sel
        })));
        else children.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement($0004ae769ccea2eb$var$MemoizedText, {
            decorations: ds,
            key: key.id,
            isLast: isLeafBlock && i === node.children.length - 1,
            parent: node,
            renderPlaceholder: renderPlaceholder,
            renderLeaf: renderLeaf,
            text: n
        }));
        (0, $aWQx3.NODE_TO_INDEX).set(n, i);
        (0, $aWQx3.NODE_TO_PARENT).set(n, node);
    }
    return children;
};
/**
 * A React context for sharing the `readOnly` state of the editor.
 */ var $0004ae769ccea2eb$var$ReadOnlyContext = /*#__PURE__*/ (0, $eeH7J.createContext)(false);
/**
 * Get the current `readOnly` state of the editor.
 */ var $0004ae769ccea2eb$export$ba4c632f2a3941d2 = ()=>{
    return (0, $eeH7J.useContext)($0004ae769ccea2eb$var$ReadOnlyContext);
};
var $0004ae769ccea2eb$var$SlateContext = /*#__PURE__*/ (0, $eeH7J.createContext)(null);
/**
 * Get the current editor object from the React context.
 */ var $0004ae769ccea2eb$export$654ff9b132e304a3 = ()=>{
    var context = (0, $eeH7J.useContext)($0004ae769ccea2eb$var$SlateContext);
    if (!context) throw new Error("The `useSlate` hook must be used inside the <Slate> component's context.");
    var { editor: editor } = context;
    return editor;
};
var $0004ae769ccea2eb$export$83f2788db79c8bd9 = ()=>{
    var context = (0, $eeH7J.useContext)($0004ae769ccea2eb$var$SlateContext);
    if (!context) throw new Error("The `useSlate` hook must be used inside the <Slate> component's context.");
    return context;
};
function $0004ae769ccea2eb$var$useTrackUserInput() {
    var editor = $0004ae769ccea2eb$export$b4a4dff812101bed();
    var receivedUserInput = (0, $eeH7J.useRef)(false);
    var animationFrameIdRef = (0, $eeH7J.useRef)(0);
    var onUserInput = (0, $eeH7J.useCallback)(()=>{
        if (receivedUserInput.current) return;
        receivedUserInput.current = true;
        var window1 = $0004ae769ccea2eb$export$a55741a99bf22636.getWindow(editor);
        window1.cancelAnimationFrame(animationFrameIdRef.current);
        animationFrameIdRef.current = window1.requestAnimationFrame(()=>{
            receivedUserInput.current = false;
        });
    }, [
        editor
    ]);
    (0, $eeH7J.useEffect)(()=>()=>cancelAnimationFrame(animationFrameIdRef.current), []);
    return {
        receivedUserInput: receivedUserInput,
        onUserInput: onUserInput
    };
}
var $0004ae769ccea2eb$var$createRestoreDomManager = (editor, receivedUserInput)=>{
    var bufferedMutations = [];
    var clear = ()=>{
        bufferedMutations = [];
    };
    var registerMutations = (mutations)=>{
        if (!receivedUserInput.current) return;
        var trackedMutations = mutations.filter((mutation)=>(0, $aWQx3.isTrackedMutation)(editor, mutation, mutations));
        bufferedMutations.push(...trackedMutations);
    };
    function restoreDOM() {
        if (bufferedMutations.length > 0) {
            bufferedMutations.reverse().forEach((mutation)=>{
                if (mutation.type === "characterData") // We don't want to restore the DOM for characterData mutations
                // because this interrupts the composition.
                return;
                mutation.removedNodes.forEach((node)=>{
                    mutation.target.insertBefore(node, mutation.nextSibling);
                });
                mutation.addedNodes.forEach((node)=>{
                    mutation.target.removeChild(node);
                });
            });
            // Clear buffered mutations to ensure we don't undo them twice
            clear();
        }
    }
    return {
        registerMutations: registerMutations,
        restoreDOM: restoreDOM,
        clear: clear
    };
};
var $0004ae769ccea2eb$var$MUTATION_OBSERVER_CONFIG = {
    subtree: true,
    childList: true,
    characterData: true,
    characterDataOldValue: true
};
// We have to use a class component here since we rely on `getSnapshotBeforeUpdate` which has no FC equivalent
// to run code synchronously immediately before react commits the component update to the DOM.
class $0004ae769ccea2eb$var$RestoreDOMComponent extends (0, $eeH7J.Component) {
    constructor(){
        super(...arguments);
        $0004ae769ccea2eb$var$_defineProperty(this, "context", null);
        $0004ae769ccea2eb$var$_defineProperty(this, "manager", null);
        $0004ae769ccea2eb$var$_defineProperty(this, "mutationObserver", null);
    }
    observe() {
        var _this$mutationObserve;
        var { node: node } = this.props;
        if (!node.current) throw new Error("Failed to attach MutationObserver, `node` is undefined");
        (_this$mutationObserve = this.mutationObserver) === null || _this$mutationObserve === void 0 || _this$mutationObserve.observe(node.current, $0004ae769ccea2eb$var$MUTATION_OBSERVER_CONFIG);
    }
    componentDidMount() {
        var { receivedUserInput: receivedUserInput } = this.props;
        var editor = this.context;
        this.manager = $0004ae769ccea2eb$var$createRestoreDomManager(editor, receivedUserInput);
        this.mutationObserver = new MutationObserver(this.manager.registerMutations);
        this.observe();
    }
    getSnapshotBeforeUpdate() {
        var _this$mutationObserve2, _this$mutationObserve3, _this$manager2;
        var pendingMutations = (_this$mutationObserve2 = this.mutationObserver) === null || _this$mutationObserve2 === void 0 ? void 0 : _this$mutationObserve2.takeRecords();
        if (pendingMutations !== null && pendingMutations !== void 0 && pendingMutations.length) {
            var _this$manager;
            (_this$manager = this.manager) === null || _this$manager === void 0 || _this$manager.registerMutations(pendingMutations);
        }
        (_this$mutationObserve3 = this.mutationObserver) === null || _this$mutationObserve3 === void 0 || _this$mutationObserve3.disconnect();
        (_this$manager2 = this.manager) === null || _this$manager2 === void 0 || _this$manager2.restoreDOM();
        return null;
    }
    componentDidUpdate() {
        var _this$manager3;
        (_this$manager3 = this.manager) === null || _this$manager3 === void 0 || _this$manager3.clear();
        this.observe();
    }
    componentWillUnmount() {
        var _this$mutationObserve4;
        (_this$mutationObserve4 = this.mutationObserver) === null || _this$mutationObserve4 === void 0 || _this$mutationObserve4.disconnect();
    }
    render() {
        return this.props.children;
    }
}
$0004ae769ccea2eb$var$_defineProperty($0004ae769ccea2eb$var$RestoreDOMComponent, "contextType", $0004ae769ccea2eb$var$EditorContext);
var $0004ae769ccea2eb$var$RestoreDOM = (0, $aWQx3.IS_ANDROID) ? $0004ae769ccea2eb$var$RestoreDOMComponent : (_ref)=>{
    var { children: children } = _ref;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).Fragment, null, children);
};
/**
 * A React context for sharing the `composing` state of the editor.
 */ var $0004ae769ccea2eb$var$ComposingContext = /*#__PURE__*/ (0, $eeH7J.createContext)(false);
/**
 * Get the current `composing` state of the editor.
 */ var $0004ae769ccea2eb$export$39ef3e334f8d6f3f = ()=>{
    return (0, $eeH7J.useContext)($0004ae769ccea2eb$var$ComposingContext);
};
var $0004ae769ccea2eb$var$_excluded$1 = [
    "autoFocus",
    "decorate",
    "onDOMBeforeInput",
    "placeholder",
    "readOnly",
    "renderElement",
    "renderLeaf",
    "renderPlaceholder",
    "scrollSelectionIntoView",
    "style",
    "as",
    "disableDefaultStyles"
], $0004ae769ccea2eb$var$_excluded2 = [
    "text"
];
function $0004ae769ccea2eb$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $0004ae769ccea2eb$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $0004ae769ccea2eb$var$ownKeys(Object(t), !0).forEach(function(r) {
            $0004ae769ccea2eb$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $0004ae769ccea2eb$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $0004ae769ccea2eb$var$Children = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).Fragment, null, $0004ae769ccea2eb$var$useChildren(props));
/**
 * Editable.
 */ var $0004ae769ccea2eb$export$b1c809d287d72650 = /*#__PURE__*/ (0, $eeH7J.forwardRef)((props, forwardedRef)=>{
    var defaultRenderPlaceholder = (0, $eeH7J.useCallback)((props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement($0004ae769ccea2eb$export$c78d47e2f8812af9, $0004ae769ccea2eb$var$_objectSpread({}, props)), []);
    var { autoFocus: autoFocus, decorate: decorate = $0004ae769ccea2eb$var$defaultDecorate, onDOMBeforeInput: propsOnDOMBeforeInput, placeholder: placeholder, readOnly: readOnly = false, renderElement: renderElement, renderLeaf: renderLeaf, renderPlaceholder: renderPlaceholder = defaultRenderPlaceholder, scrollSelectionIntoView: scrollSelectionIntoView = $0004ae769ccea2eb$var$defaultScrollSelectionIntoView, style: userStyle = {}, as: Component = "div", disableDefaultStyles: disableDefaultStyles = false } = props, attributes = $0004ae769ccea2eb$var$_objectWithoutProperties(props, $0004ae769ccea2eb$var$_excluded$1);
    var editor = $0004ae769ccea2eb$export$654ff9b132e304a3();
    // Rerender editor when composition status changed
    var [isComposing, setIsComposing] = (0, $eeH7J.useState)(false);
    var ref = (0, $eeH7J.useRef)(null);
    var deferredOperations = (0, $eeH7J.useRef)([]);
    var [placeholderHeight, setPlaceholderHeight] = (0, $eeH7J.useState)();
    var processing = (0, $eeH7J.useRef)(false);
    var { onUserInput: onUserInput, receivedUserInput: receivedUserInput } = $0004ae769ccea2eb$var$useTrackUserInput();
    var [, forceRender] = (0, $eeH7J.useReducer)((s)=>s + 1, 0);
    (0, $aWQx3.EDITOR_TO_FORCE_RENDER).set(editor, forceRender);
    // Update internal state on each render.
    (0, $aWQx3.IS_READ_ONLY).set(editor, readOnly);
    // Keep track of some state for the event handler logic.
    var state = (0, $eeH7J.useMemo)(()=>({
            isDraggingInternally: false,
            isUpdatingSelection: false,
            latestElement: null,
            hasMarkPlaceholder: false
        }), []);
    // The autoFocus TextareaHTMLAttribute doesn't do anything on a div, so it
    // needs to be manually focused.
    (0, $eeH7J.useEffect)(()=>{
        if (ref.current && autoFocus) ref.current.focus();
    }, [
        autoFocus
    ]);
    /**
   * The AndroidInputManager object has a cyclical dependency on onDOMSelectionChange
   *
   * It is defined as a reference to simplify hook dependencies and clarify that
   * it needs to be initialized.
   */ var androidInputManagerRef = (0, $eeH7J.useRef)();
    // Listen on the native `selectionchange` event to be able to update any time
    // the selection changes. This is required because React's `onSelect` is leaky
    // and non-standard so it doesn't fire until after a selection has been
    // released. This causes issues in situations where another change happens
    // while a selection is being dragged.
    var onDOMSelectionChange = (0, $eeH7J.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($824Mz)))(()=>{
            if ((0, $aWQx3.IS_NODE_MAP_DIRTY).get(editor)) {
                onDOMSelectionChange();
                return;
            }
            var el = $0004ae769ccea2eb$export$a55741a99bf22636.toDOMNode(editor, editor);
            var root = el.getRootNode();
            if (!processing.current && (0, $aWQx3.IS_WEBKIT) && root instanceof ShadowRoot) {
                processing.current = true;
                var active = (0, $aWQx3.getActiveElement)();
                if (active) document.execCommand("indent");
                else (0, $akZf2.Transforms).deselect(editor);
                processing.current = false;
                return;
            }
            var androidInputManager = androidInputManagerRef.current;
            if (((0, $aWQx3.IS_ANDROID) || !$0004ae769ccea2eb$export$a55741a99bf22636.isComposing(editor)) && (!state.isUpdatingSelection || androidInputManager !== null && androidInputManager !== void 0 && androidInputManager.isFlushing()) && !state.isDraggingInternally) {
                var _root = $0004ae769ccea2eb$export$a55741a99bf22636.findDocumentOrShadowRoot(editor);
                var { activeElement: activeElement } = _root;
                var _el = $0004ae769ccea2eb$export$a55741a99bf22636.toDOMNode(editor, editor);
                var domSelection = (0, $aWQx3.getSelection)(_root);
                if (activeElement === _el) {
                    state.latestElement = activeElement;
                    (0, $aWQx3.IS_FOCUSED).set(editor, true);
                } else (0, $aWQx3.IS_FOCUSED).delete(editor);
                if (!domSelection) return (0, $akZf2.Transforms).deselect(editor);
                var { anchorNode: anchorNode, focusNode: focusNode } = domSelection;
                var anchorNodeSelectable = $0004ae769ccea2eb$export$a55741a99bf22636.hasEditableTarget(editor, anchorNode) || $0004ae769ccea2eb$export$a55741a99bf22636.isTargetInsideNonReadonlyVoid(editor, anchorNode);
                var focusNodeInEditor = $0004ae769ccea2eb$export$a55741a99bf22636.hasTarget(editor, focusNode);
                if (anchorNodeSelectable && focusNodeInEditor) {
                    var range = $0004ae769ccea2eb$export$a55741a99bf22636.toSlateRange(editor, domSelection, {
                        exactMatch: false,
                        suppressThrow: true
                    });
                    if (range) {
                        if (!$0004ae769ccea2eb$export$a55741a99bf22636.isComposing(editor) && !(androidInputManager !== null && androidInputManager !== void 0 && androidInputManager.hasPendingChanges()) && !(androidInputManager !== null && androidInputManager !== void 0 && androidInputManager.isFlushing())) (0, $akZf2.Transforms).select(editor, range);
                        else androidInputManager === null || androidInputManager === void 0 || androidInputManager.handleUserSelect(range);
                    }
                }
                // Deselect the editor if the dom selection is not selectable in readonly mode
                if (readOnly && (!anchorNodeSelectable || !focusNodeInEditor)) (0, $akZf2.Transforms).deselect(editor);
            }
        }, 100), [
        editor,
        readOnly,
        state
    ]);
    var scheduleOnDOMSelectionChange = (0, $eeH7J.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($5lUJY)))(onDOMSelectionChange, 0), [
        onDOMSelectionChange
    ]);
    androidInputManagerRef.current = $0004ae769ccea2eb$var$useAndroidInputManager({
        node: ref,
        onDOMSelectionChange: onDOMSelectionChange,
        scheduleOnDOMSelectionChange: scheduleOnDOMSelectionChange
    });
    $0004ae769ccea2eb$var$useIsomorphicLayoutEffect(()=>{
        var _androidInputManagerR, _androidInputManagerR2;
        // Update element-related weak maps with the DOM element ref.
        var window1;
        if (ref.current && (window1 = (0, $aWQx3.getDefaultView)(ref.current))) {
            (0, $aWQx3.EDITOR_TO_WINDOW).set(editor, window1);
            (0, $aWQx3.EDITOR_TO_ELEMENT).set(editor, ref.current);
            (0, $aWQx3.NODE_TO_ELEMENT).set(editor, ref.current);
            (0, $aWQx3.ELEMENT_TO_NODE).set(ref.current, editor);
        } else (0, $aWQx3.NODE_TO_ELEMENT).delete(editor);
        // Make sure the DOM selection state is in sync.
        var { selection: selection } = editor;
        var root = $0004ae769ccea2eb$export$a55741a99bf22636.findDocumentOrShadowRoot(editor);
        var domSelection = (0, $aWQx3.getSelection)(root);
        if (!domSelection || !$0004ae769ccea2eb$export$a55741a99bf22636.isFocused(editor) || (_androidInputManagerR = androidInputManagerRef.current) !== null && _androidInputManagerR !== void 0 && _androidInputManagerR.hasPendingAction()) return;
        var setDomSelection = (forceChange)=>{
            var hasDomSelection = domSelection.type !== "None";
            // If the DOM selection is properly unset, we're done.
            if (!selection && !hasDomSelection) return;
            // Get anchorNode and focusNode
            var focusNode = domSelection.focusNode;
            var anchorNode;
            // COMPAT: In firefox the normal seletion way does not work
            // (https://github.com/ianstormtaylor/slate/pull/5486#issue-1820720223)
            if ((0, $aWQx3.IS_FIREFOX) && domSelection.rangeCount > 1) {
                var firstRange = domSelection.getRangeAt(0);
                var lastRange = domSelection.getRangeAt(domSelection.rangeCount - 1);
                // Right to left
                if (firstRange.startContainer === focusNode) anchorNode = lastRange.endContainer;
                else // Left to right
                anchorNode = firstRange.startContainer;
            } else anchorNode = domSelection.anchorNode;
            // verify that the dom selection is in the editor
            var editorElement = (0, $aWQx3.EDITOR_TO_ELEMENT).get(editor);
            var hasDomSelectionInEditor = false;
            if (editorElement.contains(anchorNode) && editorElement.contains(focusNode)) hasDomSelectionInEditor = true;
            // If the DOM selection is in the editor and the editor selection is already correct, we're done.
            if (hasDomSelection && hasDomSelectionInEditor && selection && !forceChange) {
                var slateRange = $0004ae769ccea2eb$export$a55741a99bf22636.toSlateRange(editor, domSelection, {
                    exactMatch: true,
                    // domSelection is not necessarily a valid Slate range
                    // (e.g. when clicking on contentEditable:false element)
                    suppressThrow: true
                });
                if (slateRange && (0, $akZf2.Range).equals(slateRange, selection)) {
                    var _anchorNode;
                    if (!state.hasMarkPlaceholder) return;
                    // Ensure selection is inside the mark placeholder
                    if ((_anchorNode = anchorNode) !== null && _anchorNode !== void 0 && (_anchorNode = _anchorNode.parentElement) !== null && _anchorNode !== void 0 && _anchorNode.hasAttribute("data-slate-mark-placeholder")) return;
                }
            }
            // when <Editable/> is being controlled through external value
            // then its children might just change - DOM responds to it on its own
            // but Slate's value is not being updated through any operation
            // and thus it doesn't transform selection on its own
            if (selection && !$0004ae769ccea2eb$export$a55741a99bf22636.hasRange(editor, selection)) {
                editor.selection = $0004ae769ccea2eb$export$a55741a99bf22636.toSlateRange(editor, domSelection, {
                    exactMatch: false,
                    suppressThrow: true
                });
                return;
            }
            // Otherwise the DOM selection is out of sync, so update it.
            state.isUpdatingSelection = true;
            var newDomRange = selection && $0004ae769ccea2eb$export$a55741a99bf22636.toDOMRange(editor, selection);
            if (newDomRange) {
                if ($0004ae769ccea2eb$export$a55741a99bf22636.isComposing(editor) && !(0, $aWQx3.IS_ANDROID)) domSelection.collapseToEnd();
                else if ((0, $akZf2.Range).isBackward(selection)) domSelection.setBaseAndExtent(newDomRange.endContainer, newDomRange.endOffset, newDomRange.startContainer, newDomRange.startOffset);
                else domSelection.setBaseAndExtent(newDomRange.startContainer, newDomRange.startOffset, newDomRange.endContainer, newDomRange.endOffset);
                scrollSelectionIntoView(editor, newDomRange);
            } else domSelection.removeAllRanges();
            return newDomRange;
        };
        // In firefox if there is more then 1 range and we call setDomSelection we remove the ability to select more cells in a table
        if (domSelection.rangeCount <= 1) setDomSelection();
        var ensureSelection = ((_androidInputManagerR2 = androidInputManagerRef.current) === null || _androidInputManagerR2 === void 0 ? void 0 : _androidInputManagerR2.isFlushing()) === "action";
        if (!(0, $aWQx3.IS_ANDROID) || !ensureSelection) {
            setTimeout(()=>{
                state.isUpdatingSelection = false;
            });
            return;
        }
        var timeoutId = null;
        var animationFrameId = requestAnimationFrame(()=>{
            if (ensureSelection) {
                var ensureDomSelection = (forceChange)=>{
                    try {
                        var el = $0004ae769ccea2eb$export$a55741a99bf22636.toDOMNode(editor, editor);
                        el.focus();
                        setDomSelection(forceChange);
                    } catch (e) {
                    // Ignore, dom and state might be out of sync
                    }
                };
                // Compat: Android IMEs try to force their selection by manually re-applying it even after we set it.
                // This essentially would make setting the slate selection during an update meaningless, so we force it
                // again here. We can't only do it in the setTimeout after the animation frame since that would cause a
                // visible flicker.
                ensureDomSelection();
                timeoutId = setTimeout(()=>{
                    // COMPAT: While setting the selection in an animation frame visually correctly sets the selection,
                    // it doesn't update GBoards spellchecker state. We have to manually trigger a selection change after
                    // the animation frame to ensure it displays the correct state.
                    ensureDomSelection(true);
                    state.isUpdatingSelection = false;
                });
            }
        });
        return ()=>{
            cancelAnimationFrame(animationFrameId);
            if (timeoutId) clearTimeout(timeoutId);
        };
    });
    // Listen on the native `beforeinput` event to get real "Level 2" events. This
    // is required because React's `beforeinput` is fake and never really attaches
    // to the real event sadly. (2019/11/01)
    // https://github.com/facebook/react/issues/11211
    var onDOMBeforeInput = (0, $eeH7J.useCallback)((event)=>{
        var el = $0004ae769ccea2eb$export$a55741a99bf22636.toDOMNode(editor, editor);
        var root = el.getRootNode();
        if (processing !== null && processing !== void 0 && processing.current && (0, $aWQx3.IS_WEBKIT) && root instanceof ShadowRoot) {
            var ranges = event.getTargetRanges();
            var range = ranges[0];
            var newRange = new window.Range();
            newRange.setStart(range.startContainer, range.startOffset);
            newRange.setEnd(range.endContainer, range.endOffset);
            // Translate the DOM Range into a Slate Range
            var slateRange = $0004ae769ccea2eb$export$a55741a99bf22636.toSlateRange(editor, newRange, {
                exactMatch: false,
                suppressThrow: false
            });
            (0, $akZf2.Transforms).select(editor, slateRange);
            event.preventDefault();
            event.stopImmediatePropagation();
            return;
        }
        onUserInput();
        if (!readOnly && $0004ae769ccea2eb$export$a55741a99bf22636.hasEditableTarget(editor, event.target) && !$0004ae769ccea2eb$var$isDOMEventHandled(event, propsOnDOMBeforeInput)) {
            var _EDITOR_TO_USER_SELEC;
            // COMPAT: BeforeInput events aren't cancelable on android, so we have to handle them differently using the android input manager.
            if (androidInputManagerRef.current) return androidInputManagerRef.current.handleDOMBeforeInput(event);
            // Some IMEs/Chrome extensions like e.g. Grammarly set the selection immediately before
            // triggering a `beforeinput` expecting the change to be applied to the immediately before
            // set selection.
            scheduleOnDOMSelectionChange.flush();
            onDOMSelectionChange.flush();
            var { selection: selection } = editor;
            var { inputType: type } = event;
            var data = event.dataTransfer || event.data || undefined;
            var isCompositionChange = type === "insertCompositionText" || type === "deleteCompositionText";
            // COMPAT: use composition change events as a hint to where we should insert
            // composition text if we aren't composing to work around https://github.com/ianstormtaylor/slate/issues/5038
            if (isCompositionChange && $0004ae769ccea2eb$export$a55741a99bf22636.isComposing(editor)) return;
            var native = false;
            if (type === "insertText" && selection && (0, $akZf2.Range).isCollapsed(selection) && // Only use native character insertion for single characters a-z or space for now.
            // Long-press events (hold a + press 4 = ä) to choose a special character otherwise
            // causes duplicate inserts.
            event.data && event.data.length === 1 && /[a-z ]/i.test(event.data) && // Chrome has issues correctly editing the start of nodes: https://bugs.chromium.org/p/chromium/issues/detail?id=1249405
            // When there is an inline element, e.g. a link, and you select
            // right after it (the start of the next node).
            selection.anchor.offset !== 0) {
                native = true;
                // Skip native if there are marks, as
                // `insertText` will insert a node, not just text.
                if (editor.marks) native = false;
                // If the NODE_MAP is dirty, we can't trust the selection anchor (eg ReactEditor.toDOMPoint)
                if (!(0, $aWQx3.IS_NODE_MAP_DIRTY).get(editor)) {
                    var _node$parentElement, _window$getComputedSt;
                    // Chrome also has issues correctly editing the end of anchor elements: https://bugs.chromium.org/p/chromium/issues/detail?id=1259100
                    // Therefore we don't allow native events to insert text at the end of anchor nodes.
                    var { anchor: anchor } = selection;
                    var [node, offset] = $0004ae769ccea2eb$export$a55741a99bf22636.toDOMPoint(editor, anchor);
                    var anchorNode = (_node$parentElement = node.parentElement) === null || _node$parentElement === void 0 ? void 0 : _node$parentElement.closest("a");
                    var _window = $0004ae769ccea2eb$export$a55741a99bf22636.getWindow(editor);
                    if (native && anchorNode && $0004ae769ccea2eb$export$a55741a99bf22636.hasDOMNode(editor, anchorNode)) {
                        var _lastText$textContent;
                        // Find the last text node inside the anchor.
                        var lastText = _window === null || _window === void 0 ? void 0 : _window.document.createTreeWalker(anchorNode, NodeFilter.SHOW_TEXT).lastChild();
                        if (lastText === node && ((_lastText$textContent = lastText.textContent) === null || _lastText$textContent === void 0 ? void 0 : _lastText$textContent.length) === offset) native = false;
                    }
                    // Chrome has issues with the presence of tab characters inside elements with whiteSpace = 'pre'
                    // causing abnormal insert behavior: https://bugs.chromium.org/p/chromium/issues/detail?id=1219139
                    if (native && node.parentElement && (_window === null || _window === void 0 || (_window$getComputedSt = _window.getComputedStyle(node.parentElement)) === null || _window$getComputedSt === void 0 ? void 0 : _window$getComputedSt.whiteSpace) === "pre") {
                        var block = (0, $akZf2.Editor).above(editor, {
                            at: anchor.path,
                            match: (n)=>(0, $akZf2.Element).isElement(n) && (0, $akZf2.Editor).isBlock(editor, n)
                        });
                        if (block && (0, $akZf2.Node).string(block[0]).includes("	")) native = false;
                    }
                }
            }
            // COMPAT: For the deleting forward/backward input types we don't want
            // to change the selection because it is the range that will be deleted,
            // and those commands determine that for themselves.
            // If the NODE_MAP is dirty, we can't trust the selection anchor (eg ReactEditor.toDOMPoint via ReactEditor.toSlateRange)
            if ((!type.startsWith("delete") || type.startsWith("deleteBy")) && !(0, $aWQx3.IS_NODE_MAP_DIRTY).get(editor)) {
                var [targetRange] = event.getTargetRanges();
                if (targetRange) {
                    var _range = $0004ae769ccea2eb$export$a55741a99bf22636.toSlateRange(editor, targetRange, {
                        exactMatch: false,
                        suppressThrow: false
                    });
                    if (!selection || !(0, $akZf2.Range).equals(selection, _range)) {
                        native = false;
                        var selectionRef = !isCompositionChange && editor.selection && (0, $akZf2.Editor).rangeRef(editor, editor.selection);
                        (0, $akZf2.Transforms).select(editor, _range);
                        if (selectionRef) (0, $aWQx3.EDITOR_TO_USER_SELECTION).set(editor, selectionRef);
                    }
                }
            }
            // Composition change types occur while a user is composing text and can't be
            // cancelled. Let them through and wait for the composition to end.
            if (isCompositionChange) return;
            if (!native) event.preventDefault();
            // COMPAT: If the selection is expanded, even if the command seems like
            // a delete forward/backward command it should delete the selection.
            if (selection && (0, $akZf2.Range).isExpanded(selection) && type.startsWith("delete")) {
                var direction = type.endsWith("Backward") ? "backward" : "forward";
                (0, $akZf2.Editor).deleteFragment(editor, {
                    direction: direction
                });
                return;
            }
            switch(type){
                case "deleteByComposition":
                case "deleteByCut":
                case "deleteByDrag":
                    (0, $akZf2.Editor).deleteFragment(editor);
                    break;
                case "deleteContent":
                case "deleteContentForward":
                    (0, $akZf2.Editor).deleteForward(editor);
                    break;
                case "deleteContentBackward":
                    (0, $akZf2.Editor).deleteBackward(editor);
                    break;
                case "deleteEntireSoftLine":
                    (0, $akZf2.Editor).deleteBackward(editor, {
                        unit: "line"
                    });
                    (0, $akZf2.Editor).deleteForward(editor, {
                        unit: "line"
                    });
                    break;
                case "deleteHardLineBackward":
                    (0, $akZf2.Editor).deleteBackward(editor, {
                        unit: "block"
                    });
                    break;
                case "deleteSoftLineBackward":
                    (0, $akZf2.Editor).deleteBackward(editor, {
                        unit: "line"
                    });
                    break;
                case "deleteHardLineForward":
                    (0, $akZf2.Editor).deleteForward(editor, {
                        unit: "block"
                    });
                    break;
                case "deleteSoftLineForward":
                    (0, $akZf2.Editor).deleteForward(editor, {
                        unit: "line"
                    });
                    break;
                case "deleteWordBackward":
                    (0, $akZf2.Editor).deleteBackward(editor, {
                        unit: "word"
                    });
                    break;
                case "deleteWordForward":
                    (0, $akZf2.Editor).deleteForward(editor, {
                        unit: "word"
                    });
                    break;
                case "insertLineBreak":
                    (0, $akZf2.Editor).insertSoftBreak(editor);
                    break;
                case "insertParagraph":
                    (0, $akZf2.Editor).insertBreak(editor);
                    break;
                case "insertFromComposition":
                case "insertFromDrop":
                case "insertFromPaste":
                case "insertFromYank":
                case "insertReplacementText":
                case "insertText":
                    if (type === "insertFromComposition") // COMPAT: in Safari, `compositionend` is dispatched after the
                    // `beforeinput` for "insertFromComposition". But if we wait for it
                    // then we will abort because we're still composing and the selection
                    // won't be updated properly.
                    // https://www.w3.org/TR/input-events-2/
                    {
                        if ($0004ae769ccea2eb$export$a55741a99bf22636.isComposing(editor)) {
                            setIsComposing(false);
                            (0, $aWQx3.IS_COMPOSING).set(editor, false);
                        }
                    }
                    // use a weak comparison instead of 'instanceof' to allow
                    // programmatic access of paste events coming from external windows
                    // like cypress where cy.window does not work realibly
                    if ((data === null || data === void 0 ? void 0 : data.constructor.name) === "DataTransfer") $0004ae769ccea2eb$export$a55741a99bf22636.insertData(editor, data);
                    else if (typeof data === "string") {
                        // Only insertText operations use the native functionality, for now.
                        // Potentially expand to single character deletes, as well.
                        if (native) deferredOperations.current.push(()=>(0, $akZf2.Editor).insertText(editor, data));
                        else (0, $akZf2.Editor).insertText(editor, data);
                    }
                    break;
            }
            // Restore the actual user section if nothing manually set it.
            var toRestore = (_EDITOR_TO_USER_SELEC = (0, $aWQx3.EDITOR_TO_USER_SELECTION).get(editor)) === null || _EDITOR_TO_USER_SELEC === void 0 ? void 0 : _EDITOR_TO_USER_SELEC.unref();
            (0, $aWQx3.EDITOR_TO_USER_SELECTION).delete(editor);
            if (toRestore && (!editor.selection || !(0, $akZf2.Range).equals(editor.selection, toRestore))) (0, $akZf2.Transforms).select(editor, toRestore);
        }
    }, [
        editor,
        onDOMSelectionChange,
        onUserInput,
        propsOnDOMBeforeInput,
        readOnly,
        scheduleOnDOMSelectionChange
    ]);
    var callbackRef = (0, $eeH7J.useCallback)((node)=>{
        if (node == null) {
            onDOMSelectionChange.cancel();
            scheduleOnDOMSelectionChange.cancel();
            (0, $aWQx3.EDITOR_TO_ELEMENT).delete(editor);
            (0, $aWQx3.NODE_TO_ELEMENT).delete(editor);
            if (ref.current && (0, $aWQx3.HAS_BEFORE_INPUT_SUPPORT)) // @ts-ignore The `beforeinput` event isn't recognized.
            ref.current.removeEventListener("beforeinput", onDOMBeforeInput);
        } else // Attach a native DOM event handler for `beforeinput` events, because React's
        // built-in `onBeforeInput` is actually a leaky polyfill that doesn't expose
        // real `beforeinput` events sadly... (2019/11/04)
        // https://github.com/facebook/react/issues/11211
        if (0, $aWQx3.HAS_BEFORE_INPUT_SUPPORT) // @ts-ignore The `beforeinput` event isn't recognized.
        node.addEventListener("beforeinput", onDOMBeforeInput);
        ref.current = node;
        if (typeof forwardedRef === "function") forwardedRef(node);
        else if (forwardedRef) forwardedRef.current = node;
    }, [
        onDOMSelectionChange,
        scheduleOnDOMSelectionChange,
        editor,
        onDOMBeforeInput,
        forwardedRef
    ]);
    $0004ae769ccea2eb$var$useIsomorphicLayoutEffect(()=>{
        var window1 = $0004ae769ccea2eb$export$a55741a99bf22636.getWindow(editor);
        // Attach a native DOM event handler for `selectionchange`, because React's
        // built-in `onSelect` handler doesn't fire for all selection changes. It's
        // a leaky polyfill that only fires on keypresses or clicks. Instead, we
        // want to fire for any change to the selection inside the editor.
        // (2019/11/04) https://github.com/facebook/react/issues/5785
        window1.document.addEventListener("selectionchange", scheduleOnDOMSelectionChange);
        // Listen for dragend and drop globally. In Firefox, if a drop handler
        // initiates an operation that causes the originally dragged element to
        // unmount, that element will not emit a dragend event. (2024/06/21)
        var stoppedDragging = ()=>{
            state.isDraggingInternally = false;
        };
        window1.document.addEventListener("dragend", stoppedDragging);
        window1.document.addEventListener("drop", stoppedDragging);
        return ()=>{
            window1.document.removeEventListener("selectionchange", scheduleOnDOMSelectionChange);
            window1.document.removeEventListener("dragend", stoppedDragging);
            window1.document.removeEventListener("drop", stoppedDragging);
        };
    }, [
        scheduleOnDOMSelectionChange,
        state
    ]);
    var decorations = decorate([
        editor,
        []
    ]);
    var showPlaceholder = placeholder && editor.children.length === 1 && Array.from((0, $akZf2.Node).texts(editor)).length === 1 && (0, $akZf2.Node).string(editor) === "" && !isComposing;
    var placeHolderResizeHandler = (0, $eeH7J.useCallback)((placeholderEl)=>{
        if (placeholderEl && showPlaceholder) {
            var _placeholderEl$getBou;
            setPlaceholderHeight((_placeholderEl$getBou = placeholderEl.getBoundingClientRect()) === null || _placeholderEl$getBou === void 0 ? void 0 : _placeholderEl$getBou.height);
        } else setPlaceholderHeight(undefined);
    }, [
        showPlaceholder
    ]);
    if (showPlaceholder) {
        var start = (0, $akZf2.Editor).start(editor, []);
        decorations.push({
            [(0, $aWQx3.PLACEHOLDER_SYMBOL)]: true,
            placeholder: placeholder,
            onPlaceholderResize: placeHolderResizeHandler,
            anchor: start,
            focus: start
        });
    }
    var { marks: marks } = editor;
    state.hasMarkPlaceholder = false;
    if (editor.selection && (0, $akZf2.Range).isCollapsed(editor.selection) && marks) {
        var { anchor: anchor } = editor.selection;
        var leaf = (0, $akZf2.Node).leaf(editor, anchor.path);
        var rest = $0004ae769ccea2eb$var$_objectWithoutProperties(leaf, $0004ae769ccea2eb$var$_excluded2);
        // While marks isn't a 'complete' text, we can still use loose Text.equals
        // here which only compares marks anyway.
        if (!(0, $akZf2.Text).equals(leaf, marks, {
            loose: true
        })) {
            state.hasMarkPlaceholder = true;
            var unset = Object.fromEntries(Object.keys(rest).map((mark)=>[
                    mark,
                    null
                ]));
            decorations.push($0004ae769ccea2eb$var$_objectSpread($0004ae769ccea2eb$var$_objectSpread($0004ae769ccea2eb$var$_objectSpread({
                [(0, $aWQx3.MARK_PLACEHOLDER_SYMBOL)]: true
            }, unset), marks), {}, {
                anchor: anchor,
                focus: anchor
            }));
        }
    }
    // Update EDITOR_TO_MARK_PLACEHOLDER_MARKS in setTimeout useEffect to ensure we don't set it
    // before we receive the composition end event.
    (0, $eeH7J.useEffect)(()=>{
        setTimeout(()=>{
            var { selection: selection } = editor;
            if (selection) {
                var { anchor: _anchor } = selection;
                var _text = (0, $akZf2.Node).leaf(editor, _anchor.path);
                // While marks isn't a 'complete' text, we can still use loose Text.equals
                // here which only compares marks anyway.
                if (marks && !(0, $akZf2.Text).equals(_text, marks, {
                    loose: true
                })) {
                    (0, $aWQx3.EDITOR_TO_PENDING_INSERTION_MARKS).set(editor, marks);
                    return;
                }
            }
            (0, $aWQx3.EDITOR_TO_PENDING_INSERTION_MARKS).delete(editor);
        });
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement($0004ae769ccea2eb$var$ReadOnlyContext.Provider, {
        value: readOnly
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement($0004ae769ccea2eb$var$ComposingContext.Provider, {
        value: isComposing
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement($0004ae769ccea2eb$var$DecorateContext.Provider, {
        value: decorate
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement($0004ae769ccea2eb$var$RestoreDOM, {
        node: ref,
        receivedUserInput: receivedUserInput
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement(Component, $0004ae769ccea2eb$var$_objectSpread($0004ae769ccea2eb$var$_objectSpread({
        role: readOnly ? undefined : "textbox",
        "aria-multiline": readOnly ? undefined : true
    }, attributes), {}, {
        // COMPAT: Certain browsers don't support the `beforeinput` event, so we'd
        // have to use hacks to make these replacement-based features work.
        // For SSR situations HAS_BEFORE_INPUT_SUPPORT is false and results in prop
        // mismatch warning app moves to browser. Pass-through consumer props when
        // not CAN_USE_DOM (SSR) and default to falsy value
        spellCheck: (0, $aWQx3.HAS_BEFORE_INPUT_SUPPORT) || !(0, $aWQx3.CAN_USE_DOM) ? attributes.spellCheck : false,
        autoCorrect: (0, $aWQx3.HAS_BEFORE_INPUT_SUPPORT) || !(0, $aWQx3.CAN_USE_DOM) ? attributes.autoCorrect : "false",
        autoCapitalize: (0, $aWQx3.HAS_BEFORE_INPUT_SUPPORT) || !(0, $aWQx3.CAN_USE_DOM) ? attributes.autoCapitalize : "false",
        "data-slate-editor": true,
        "data-slate-node": "value",
        // explicitly set this
        contentEditable: !readOnly,
        // in some cases, a decoration needs access to the range / selection to decorate a text node,
        // then you will select the whole text node when you select part the of text
        // this magic zIndex="-1" will fix it
        zindex: -1,
        suppressContentEditableWarning: true,
        ref: callbackRef,
        style: $0004ae769ccea2eb$var$_objectSpread($0004ae769ccea2eb$var$_objectSpread({}, disableDefaultStyles ? {} : $0004ae769ccea2eb$var$_objectSpread({
            // Allow positioning relative to the editable element.
            position: "relative",
            // Preserve adjacent whitespace and new lines.
            whiteSpace: "pre-wrap",
            // Allow words to break if they are too long.
            wordWrap: "break-word"
        }, placeholderHeight ? {
            minHeight: placeholderHeight
        } : {})), userStyle),
        onBeforeInput: (0, $eeH7J.useCallback)((event)=>{
            // COMPAT: Certain browsers don't support the `beforeinput` event, so we
            // fall back to React's leaky polyfill instead just for it. It
            // only works for the `insertText` input type.
            if (!(0, $aWQx3.HAS_BEFORE_INPUT_SUPPORT) && !readOnly && !$0004ae769ccea2eb$var$isEventHandled(event, attributes.onBeforeInput) && $0004ae769ccea2eb$export$a55741a99bf22636.hasSelectableTarget(editor, event.target)) {
                event.preventDefault();
                if (!$0004ae769ccea2eb$export$a55741a99bf22636.isComposing(editor)) {
                    var _text2 = event.data;
                    (0, $akZf2.Editor).insertText(editor, _text2);
                }
            }
        }, [
            attributes.onBeforeInput,
            editor,
            readOnly
        ]),
        onInput: (0, $eeH7J.useCallback)((event)=>{
            if ($0004ae769ccea2eb$var$isEventHandled(event, attributes.onInput)) return;
            if (androidInputManagerRef.current) {
                androidInputManagerRef.current.handleInput();
                return;
            }
            // Flush native operations, as native events will have propogated
            // and we can correctly compare DOM text values in components
            // to stop rendering, so that browser functions like autocorrect
            // and spellcheck work as expected.
            for (var op of deferredOperations.current)op();
            deferredOperations.current = [];
            // COMPAT: Since `beforeinput` doesn't fully `preventDefault`,
            // there's a chance that content might be placed in the browser's undo stack.
            // This means undo can be triggered even when the div is not focused,
            // and it only triggers the input event for the node. (2024/10/09)
            if (!$0004ae769ccea2eb$export$a55741a99bf22636.isFocused(editor)) {
                var native = event.nativeEvent;
                var maybeHistoryEditor = editor;
                if (native.inputType === "historyUndo" && typeof maybeHistoryEditor.undo === "function") {
                    maybeHistoryEditor.undo();
                    return;
                }
                if (native.inputType === "historyRedo" && typeof maybeHistoryEditor.redo === "function") {
                    maybeHistoryEditor.redo();
                    return;
                }
            }
        }, [
            attributes.onInput,
            editor
        ]),
        onBlur: (0, $eeH7J.useCallback)((event)=>{
            if (readOnly || state.isUpdatingSelection || !$0004ae769ccea2eb$export$a55741a99bf22636.hasSelectableTarget(editor, event.target) || $0004ae769ccea2eb$var$isEventHandled(event, attributes.onBlur)) return;
            // COMPAT: If the current `activeElement` is still the previous
            // one, this is due to the window being blurred when the tab
            // itself becomes unfocused, so we want to abort early to allow to
            // editor to stay focused when the tab becomes focused again.
            var root = $0004ae769ccea2eb$export$a55741a99bf22636.findDocumentOrShadowRoot(editor);
            if (state.latestElement === root.activeElement) return;
            var { relatedTarget: relatedTarget } = event;
            var el = $0004ae769ccea2eb$export$a55741a99bf22636.toDOMNode(editor, editor);
            // COMPAT: The event should be ignored if the focus is returning
            // to the editor from an embedded editable element (eg. an <input>
            // element inside a void node).
            if (relatedTarget === el) return;
            // COMPAT: The event should be ignored if the focus is moving from
            // the editor to inside a void node's spacer element.
            if ((0, $aWQx3.isDOMElement)(relatedTarget) && relatedTarget.hasAttribute("data-slate-spacer")) return;
            // COMPAT: The event should be ignored if the focus is moving to a
            // non- editable section of an element that isn't a void node (eg.
            // a list item of the check list example).
            if (relatedTarget != null && (0, $aWQx3.isDOMNode)(relatedTarget) && $0004ae769ccea2eb$export$a55741a99bf22636.hasDOMNode(editor, relatedTarget)) {
                var node = $0004ae769ccea2eb$export$a55741a99bf22636.toSlateNode(editor, relatedTarget);
                if ((0, $akZf2.Element).isElement(node) && !editor.isVoid(node)) return;
            }
            // COMPAT: Safari doesn't always remove the selection even if the content-
            // editable element no longer has focus. Refer to:
            // https://stackoverflow.com/questions/12353247/force-contenteditable-div-to-stop-accepting-input-after-it-loses-focus-under-web
            if (0, $aWQx3.IS_WEBKIT) {
                var domSelection = (0, $aWQx3.getSelection)(root);
                domSelection === null || domSelection === void 0 || domSelection.removeAllRanges();
            }
            (0, $aWQx3.IS_FOCUSED).delete(editor);
        }, [
            readOnly,
            state.isUpdatingSelection,
            state.latestElement,
            editor,
            attributes.onBlur
        ]),
        onClick: (0, $eeH7J.useCallback)((event)=>{
            if ($0004ae769ccea2eb$export$a55741a99bf22636.hasTarget(editor, event.target) && !$0004ae769ccea2eb$var$isEventHandled(event, attributes.onClick) && (0, $aWQx3.isDOMNode)(event.target)) {
                var node = $0004ae769ccea2eb$export$a55741a99bf22636.toSlateNode(editor, event.target);
                var path = $0004ae769ccea2eb$export$a55741a99bf22636.findPath(editor, node);
                // At this time, the Slate document may be arbitrarily different,
                // because onClick handlers can change the document before we get here.
                // Therefore we must check that this path actually exists,
                // and that it still refers to the same node.
                if (!(0, $akZf2.Editor).hasPath(editor, path) || (0, $akZf2.Node).get(editor, path) !== node) return;
                if (event.detail === (0, $aWQx3.TRIPLE_CLICK) && path.length >= 1) {
                    var blockPath = path;
                    if (!((0, $akZf2.Element).isElement(node) && (0, $akZf2.Editor).isBlock(editor, node))) {
                        var _block$;
                        var block = (0, $akZf2.Editor).above(editor, {
                            match: (n)=>(0, $akZf2.Element).isElement(n) && (0, $akZf2.Editor).isBlock(editor, n),
                            at: path
                        });
                        blockPath = (_block$ = block === null || block === void 0 ? void 0 : block[1]) !== null && _block$ !== void 0 ? _block$ : path.slice(0, 1);
                    }
                    var range = (0, $akZf2.Editor).range(editor, blockPath);
                    (0, $akZf2.Transforms).select(editor, range);
                    return;
                }
                if (readOnly) return;
                var _start = (0, $akZf2.Editor).start(editor, path);
                var end = (0, $akZf2.Editor).end(editor, path);
                var startVoid = (0, $akZf2.Editor).void(editor, {
                    at: _start
                });
                var endVoid = (0, $akZf2.Editor).void(editor, {
                    at: end
                });
                if (startVoid && endVoid && (0, $akZf2.Path).equals(startVoid[1], endVoid[1])) {
                    var _range2 = (0, $akZf2.Editor).range(editor, _start);
                    (0, $akZf2.Transforms).select(editor, _range2);
                }
            }
        }, [
            editor,
            attributes.onClick,
            readOnly
        ]),
        onCompositionEnd: (0, $eeH7J.useCallback)((event)=>{
            if ($0004ae769ccea2eb$export$a55741a99bf22636.hasSelectableTarget(editor, event.target)) {
                var _androidInputManagerR3;
                if ($0004ae769ccea2eb$export$a55741a99bf22636.isComposing(editor)) Promise.resolve().then(()=>{
                    setIsComposing(false);
                    (0, $aWQx3.IS_COMPOSING).set(editor, false);
                });
                (_androidInputManagerR3 = androidInputManagerRef.current) === null || _androidInputManagerR3 === void 0 || _androidInputManagerR3.handleCompositionEnd(event);
                if ($0004ae769ccea2eb$var$isEventHandled(event, attributes.onCompositionEnd) || (0, $aWQx3.IS_ANDROID)) return;
                // COMPAT: In Chrome, `beforeinput` events for compositions
                // aren't correct and never fire the "insertFromComposition"
                // type that we need. So instead, insert whenever a composition
                // ends since it will already have been committed to the DOM.
                if (!(0, $aWQx3.IS_WEBKIT) && !(0, $aWQx3.IS_FIREFOX_LEGACY) && !(0, $aWQx3.IS_IOS) && !(0, $aWQx3.IS_WECHATBROWSER) && !(0, $aWQx3.IS_UC_MOBILE) && event.data) {
                    var placeholderMarks = (0, $aWQx3.EDITOR_TO_PENDING_INSERTION_MARKS).get(editor);
                    (0, $aWQx3.EDITOR_TO_PENDING_INSERTION_MARKS).delete(editor);
                    // Ensure we insert text with the marks the user was actually seeing
                    if (placeholderMarks !== undefined) {
                        (0, $aWQx3.EDITOR_TO_USER_MARKS).set(editor, editor.marks);
                        editor.marks = placeholderMarks;
                    }
                    (0, $akZf2.Editor).insertText(editor, event.data);
                    var userMarks = (0, $aWQx3.EDITOR_TO_USER_MARKS).get(editor);
                    (0, $aWQx3.EDITOR_TO_USER_MARKS).delete(editor);
                    if (userMarks !== undefined) editor.marks = userMarks;
                }
            }
        }, [
            attributes.onCompositionEnd,
            editor
        ]),
        onCompositionUpdate: (0, $eeH7J.useCallback)((event)=>{
            if ($0004ae769ccea2eb$export$a55741a99bf22636.hasSelectableTarget(editor, event.target) && !$0004ae769ccea2eb$var$isEventHandled(event, attributes.onCompositionUpdate)) {
                if (!$0004ae769ccea2eb$export$a55741a99bf22636.isComposing(editor)) {
                    setIsComposing(true);
                    (0, $aWQx3.IS_COMPOSING).set(editor, true);
                }
            }
        }, [
            attributes.onCompositionUpdate,
            editor
        ]),
        onCompositionStart: (0, $eeH7J.useCallback)((event)=>{
            if ($0004ae769ccea2eb$export$a55741a99bf22636.hasSelectableTarget(editor, event.target)) {
                var _androidInputManagerR4;
                (_androidInputManagerR4 = androidInputManagerRef.current) === null || _androidInputManagerR4 === void 0 || _androidInputManagerR4.handleCompositionStart(event);
                if ($0004ae769ccea2eb$var$isEventHandled(event, attributes.onCompositionStart) || (0, $aWQx3.IS_ANDROID)) return;
                setIsComposing(true);
                var { selection: selection } = editor;
                if (selection && (0, $akZf2.Range).isExpanded(selection)) {
                    (0, $akZf2.Editor).deleteFragment(editor);
                    return;
                }
            }
        }, [
            attributes.onCompositionStart,
            editor
        ]),
        onCopy: (0, $eeH7J.useCallback)((event)=>{
            if ($0004ae769ccea2eb$export$a55741a99bf22636.hasSelectableTarget(editor, event.target) && !$0004ae769ccea2eb$var$isEventHandled(event, attributes.onCopy) && !$0004ae769ccea2eb$var$isDOMEventTargetInput(event)) {
                event.preventDefault();
                $0004ae769ccea2eb$export$a55741a99bf22636.setFragmentData(editor, event.clipboardData, "copy");
            }
        }, [
            attributes.onCopy,
            editor
        ]),
        onCut: (0, $eeH7J.useCallback)((event)=>{
            if (!readOnly && $0004ae769ccea2eb$export$a55741a99bf22636.hasSelectableTarget(editor, event.target) && !$0004ae769ccea2eb$var$isEventHandled(event, attributes.onCut) && !$0004ae769ccea2eb$var$isDOMEventTargetInput(event)) {
                event.preventDefault();
                $0004ae769ccea2eb$export$a55741a99bf22636.setFragmentData(editor, event.clipboardData, "cut");
                var { selection: selection } = editor;
                if (selection) {
                    if ((0, $akZf2.Range).isExpanded(selection)) (0, $akZf2.Editor).deleteFragment(editor);
                    else {
                        var node = (0, $akZf2.Node).parent(editor, selection.anchor.path);
                        if ((0, $akZf2.Editor).isVoid(editor, node)) (0, $akZf2.Transforms).delete(editor);
                    }
                }
            }
        }, [
            readOnly,
            editor,
            attributes.onCut
        ]),
        onDragOver: (0, $eeH7J.useCallback)((event)=>{
            if ($0004ae769ccea2eb$export$a55741a99bf22636.hasTarget(editor, event.target) && !$0004ae769ccea2eb$var$isEventHandled(event, attributes.onDragOver)) {
                // Only when the target is void, call `preventDefault` to signal
                // that drops are allowed. Editable content is droppable by
                // default, and calling `preventDefault` hides the cursor.
                var node = $0004ae769ccea2eb$export$a55741a99bf22636.toSlateNode(editor, event.target);
                if ((0, $akZf2.Element).isElement(node) && (0, $akZf2.Editor).isVoid(editor, node)) event.preventDefault();
            }
        }, [
            attributes.onDragOver,
            editor
        ]),
        onDragStart: (0, $eeH7J.useCallback)((event)=>{
            if (!readOnly && $0004ae769ccea2eb$export$a55741a99bf22636.hasTarget(editor, event.target) && !$0004ae769ccea2eb$var$isEventHandled(event, attributes.onDragStart)) {
                var node = $0004ae769ccea2eb$export$a55741a99bf22636.toSlateNode(editor, event.target);
                var path = $0004ae769ccea2eb$export$a55741a99bf22636.findPath(editor, node);
                var voidMatch = (0, $akZf2.Element).isElement(node) && (0, $akZf2.Editor).isVoid(editor, node) || (0, $akZf2.Editor).void(editor, {
                    at: path,
                    voids: true
                });
                // If starting a drag on a void node, make sure it is selected
                // so that it shows up in the selection's fragment.
                if (voidMatch) {
                    var range = (0, $akZf2.Editor).range(editor, path);
                    (0, $akZf2.Transforms).select(editor, range);
                }
                state.isDraggingInternally = true;
                $0004ae769ccea2eb$export$a55741a99bf22636.setFragmentData(editor, event.dataTransfer, "drag");
            }
        }, [
            readOnly,
            editor,
            attributes.onDragStart,
            state
        ]),
        onDrop: (0, $eeH7J.useCallback)((event)=>{
            if (!readOnly && $0004ae769ccea2eb$export$a55741a99bf22636.hasTarget(editor, event.target) && !$0004ae769ccea2eb$var$isEventHandled(event, attributes.onDrop)) {
                event.preventDefault();
                // Keep a reference to the dragged range before updating selection
                var draggedRange = editor.selection;
                // Find the range where the drop happened
                var range = $0004ae769ccea2eb$export$a55741a99bf22636.findEventRange(editor, event);
                var data = event.dataTransfer;
                (0, $akZf2.Transforms).select(editor, range);
                if (state.isDraggingInternally) {
                    if (draggedRange && !(0, $akZf2.Range).equals(draggedRange, range) && !(0, $akZf2.Editor).void(editor, {
                        at: range,
                        voids: true
                    })) (0, $akZf2.Transforms).delete(editor, {
                        at: draggedRange
                    });
                }
                $0004ae769ccea2eb$export$a55741a99bf22636.insertData(editor, data);
                // When dragging from another source into the editor, it's possible
                // that the current editor does not have focus.
                if (!$0004ae769ccea2eb$export$a55741a99bf22636.isFocused(editor)) $0004ae769ccea2eb$export$a55741a99bf22636.focus(editor);
            }
        }, [
            readOnly,
            editor,
            attributes.onDrop,
            state
        ]),
        onDragEnd: (0, $eeH7J.useCallback)((event)=>{
            if (!readOnly && state.isDraggingInternally && attributes.onDragEnd && $0004ae769ccea2eb$export$a55741a99bf22636.hasTarget(editor, event.target)) attributes.onDragEnd(event);
        }, [
            readOnly,
            state,
            attributes,
            editor
        ]),
        onFocus: (0, $eeH7J.useCallback)((event)=>{
            if (!readOnly && !state.isUpdatingSelection && $0004ae769ccea2eb$export$a55741a99bf22636.hasEditableTarget(editor, event.target) && !$0004ae769ccea2eb$var$isEventHandled(event, attributes.onFocus)) {
                var el = $0004ae769ccea2eb$export$a55741a99bf22636.toDOMNode(editor, editor);
                var root = $0004ae769ccea2eb$export$a55741a99bf22636.findDocumentOrShadowRoot(editor);
                state.latestElement = root.activeElement;
                // COMPAT: If the editor has nested editable elements, the focus
                // can go to them. In Firefox, this must be prevented because it
                // results in issues with keyboard navigation. (2017/03/30)
                if ((0, $aWQx3.IS_FIREFOX) && event.target !== el) {
                    el.focus();
                    return;
                }
                (0, $aWQx3.IS_FOCUSED).set(editor, true);
            }
        }, [
            readOnly,
            state,
            editor,
            attributes.onFocus
        ]),
        onKeyDown: (0, $eeH7J.useCallback)((event)=>{
            if (!readOnly && $0004ae769ccea2eb$export$a55741a99bf22636.hasEditableTarget(editor, event.target)) {
                var _androidInputManagerR5;
                (_androidInputManagerR5 = androidInputManagerRef.current) === null || _androidInputManagerR5 === void 0 || _androidInputManagerR5.handleKeyDown(event);
                var { nativeEvent: nativeEvent } = event;
                // COMPAT: The composition end event isn't fired reliably in all browsers,
                // so we sometimes might end up stuck in a composition state even though we
                // aren't composing any more.
                if ($0004ae769ccea2eb$export$a55741a99bf22636.isComposing(editor) && nativeEvent.isComposing === false) {
                    (0, $aWQx3.IS_COMPOSING).set(editor, false);
                    setIsComposing(false);
                }
                if ($0004ae769ccea2eb$var$isEventHandled(event, attributes.onKeyDown) || $0004ae769ccea2eb$export$a55741a99bf22636.isComposing(editor)) return;
                var { selection: selection } = editor;
                var element = editor.children[selection !== null ? selection.focus.path[0] : 0];
                var isRTL = (0, (/*@__PURE__*/$parcel$interopDefault($hA1QH)))((0, $akZf2.Node).string(element)) === "rtl";
                // COMPAT: Since we prevent the default behavior on
                // `beforeinput` events, the browser doesn't think there's ever
                // any history stack to undo or redo, so we have to manage these
                // hotkeys ourselves. (2019/11/06)
                if ((0, $aWQx3.Hotkeys).isRedo(nativeEvent)) {
                    event.preventDefault();
                    var maybeHistoryEditor = editor;
                    if (typeof maybeHistoryEditor.redo === "function") maybeHistoryEditor.redo();
                    return;
                }
                if ((0, $aWQx3.Hotkeys).isUndo(nativeEvent)) {
                    event.preventDefault();
                    var _maybeHistoryEditor = editor;
                    if (typeof _maybeHistoryEditor.undo === "function") _maybeHistoryEditor.undo();
                    return;
                }
                // COMPAT: Certain browsers don't handle the selection updates
                // properly. In Chrome, the selection isn't properly extended.
                // And in Firefox, the selection isn't properly collapsed.
                // (2017/10/17)
                if ((0, $aWQx3.Hotkeys).isMoveLineBackward(nativeEvent)) {
                    event.preventDefault();
                    (0, $akZf2.Transforms).move(editor, {
                        unit: "line",
                        reverse: true
                    });
                    return;
                }
                if ((0, $aWQx3.Hotkeys).isMoveLineForward(nativeEvent)) {
                    event.preventDefault();
                    (0, $akZf2.Transforms).move(editor, {
                        unit: "line"
                    });
                    return;
                }
                if ((0, $aWQx3.Hotkeys).isExtendLineBackward(nativeEvent)) {
                    event.preventDefault();
                    (0, $akZf2.Transforms).move(editor, {
                        unit: "line",
                        edge: "focus",
                        reverse: true
                    });
                    return;
                }
                if ((0, $aWQx3.Hotkeys).isExtendLineForward(nativeEvent)) {
                    event.preventDefault();
                    (0, $akZf2.Transforms).move(editor, {
                        unit: "line",
                        edge: "focus"
                    });
                    return;
                }
                // COMPAT: If a void node is selected, or a zero-width text node
                // adjacent to an inline is selected, we need to handle these
                // hotkeys manually because browsers won't be able to skip over
                // the void node with the zero-width space not being an empty
                // string.
                if ((0, $aWQx3.Hotkeys).isMoveBackward(nativeEvent)) {
                    event.preventDefault();
                    if (selection && (0, $akZf2.Range).isCollapsed(selection)) (0, $akZf2.Transforms).move(editor, {
                        reverse: !isRTL
                    });
                    else (0, $akZf2.Transforms).collapse(editor, {
                        edge: isRTL ? "end" : "start"
                    });
                    return;
                }
                if ((0, $aWQx3.Hotkeys).isMoveForward(nativeEvent)) {
                    event.preventDefault();
                    if (selection && (0, $akZf2.Range).isCollapsed(selection)) (0, $akZf2.Transforms).move(editor, {
                        reverse: isRTL
                    });
                    else (0, $akZf2.Transforms).collapse(editor, {
                        edge: isRTL ? "start" : "end"
                    });
                    return;
                }
                if ((0, $aWQx3.Hotkeys).isMoveWordBackward(nativeEvent)) {
                    event.preventDefault();
                    if (selection && (0, $akZf2.Range).isExpanded(selection)) (0, $akZf2.Transforms).collapse(editor, {
                        edge: "focus"
                    });
                    (0, $akZf2.Transforms).move(editor, {
                        unit: "word",
                        reverse: !isRTL
                    });
                    return;
                }
                if ((0, $aWQx3.Hotkeys).isMoveWordForward(nativeEvent)) {
                    event.preventDefault();
                    if (selection && (0, $akZf2.Range).isExpanded(selection)) (0, $akZf2.Transforms).collapse(editor, {
                        edge: "focus"
                    });
                    (0, $akZf2.Transforms).move(editor, {
                        unit: "word",
                        reverse: isRTL
                    });
                    return;
                }
                // COMPAT: Certain browsers don't support the `beforeinput` event, so we
                // fall back to guessing at the input intention for hotkeys.
                // COMPAT: In iOS, some of these hotkeys are handled in the
                if (!(0, $aWQx3.HAS_BEFORE_INPUT_SUPPORT)) {
                    // We don't have a core behavior for these, but they change the
                    // DOM if we don't prevent them, so we have to.
                    if ((0, $aWQx3.Hotkeys).isBold(nativeEvent) || (0, $aWQx3.Hotkeys).isItalic(nativeEvent) || (0, $aWQx3.Hotkeys).isTransposeCharacter(nativeEvent)) {
                        event.preventDefault();
                        return;
                    }
                    if ((0, $aWQx3.Hotkeys).isSoftBreak(nativeEvent)) {
                        event.preventDefault();
                        (0, $akZf2.Editor).insertSoftBreak(editor);
                        return;
                    }
                    if ((0, $aWQx3.Hotkeys).isSplitBlock(nativeEvent)) {
                        event.preventDefault();
                        (0, $akZf2.Editor).insertBreak(editor);
                        return;
                    }
                    if ((0, $aWQx3.Hotkeys).isDeleteBackward(nativeEvent)) {
                        event.preventDefault();
                        if (selection && (0, $akZf2.Range).isExpanded(selection)) (0, $akZf2.Editor).deleteFragment(editor, {
                            direction: "backward"
                        });
                        else (0, $akZf2.Editor).deleteBackward(editor);
                        return;
                    }
                    if ((0, $aWQx3.Hotkeys).isDeleteForward(nativeEvent)) {
                        event.preventDefault();
                        if (selection && (0, $akZf2.Range).isExpanded(selection)) (0, $akZf2.Editor).deleteFragment(editor, {
                            direction: "forward"
                        });
                        else (0, $akZf2.Editor).deleteForward(editor);
                        return;
                    }
                    if ((0, $aWQx3.Hotkeys).isDeleteLineBackward(nativeEvent)) {
                        event.preventDefault();
                        if (selection && (0, $akZf2.Range).isExpanded(selection)) (0, $akZf2.Editor).deleteFragment(editor, {
                            direction: "backward"
                        });
                        else (0, $akZf2.Editor).deleteBackward(editor, {
                            unit: "line"
                        });
                        return;
                    }
                    if ((0, $aWQx3.Hotkeys).isDeleteLineForward(nativeEvent)) {
                        event.preventDefault();
                        if (selection && (0, $akZf2.Range).isExpanded(selection)) (0, $akZf2.Editor).deleteFragment(editor, {
                            direction: "forward"
                        });
                        else (0, $akZf2.Editor).deleteForward(editor, {
                            unit: "line"
                        });
                        return;
                    }
                    if ((0, $aWQx3.Hotkeys).isDeleteWordBackward(nativeEvent)) {
                        event.preventDefault();
                        if (selection && (0, $akZf2.Range).isExpanded(selection)) (0, $akZf2.Editor).deleteFragment(editor, {
                            direction: "backward"
                        });
                        else (0, $akZf2.Editor).deleteBackward(editor, {
                            unit: "word"
                        });
                        return;
                    }
                    if ((0, $aWQx3.Hotkeys).isDeleteWordForward(nativeEvent)) {
                        event.preventDefault();
                        if (selection && (0, $akZf2.Range).isExpanded(selection)) (0, $akZf2.Editor).deleteFragment(editor, {
                            direction: "forward"
                        });
                        else (0, $akZf2.Editor).deleteForward(editor, {
                            unit: "word"
                        });
                        return;
                    }
                } else {
                    if ((0, $aWQx3.IS_CHROME) || (0, $aWQx3.IS_WEBKIT)) // COMPAT: Chrome and Safari support `beforeinput` event but do not fire
                    // an event when deleting backwards in a selected void inline node
                    {
                        if (selection && ((0, $aWQx3.Hotkeys).isDeleteBackward(nativeEvent) || (0, $aWQx3.Hotkeys).isDeleteForward(nativeEvent)) && (0, $akZf2.Range).isCollapsed(selection)) {
                            var currentNode = (0, $akZf2.Node).parent(editor, selection.anchor.path);
                            if ((0, $akZf2.Element).isElement(currentNode) && (0, $akZf2.Editor).isVoid(editor, currentNode) && ((0, $akZf2.Editor).isInline(editor, currentNode) || (0, $akZf2.Editor).isBlock(editor, currentNode))) {
                                event.preventDefault();
                                (0, $akZf2.Editor).deleteBackward(editor, {
                                    unit: "block"
                                });
                                return;
                            }
                        }
                    }
                }
            }
        }, [
            readOnly,
            editor,
            attributes.onKeyDown
        ]),
        onPaste: (0, $eeH7J.useCallback)((event)=>{
            if (!readOnly && $0004ae769ccea2eb$export$a55741a99bf22636.hasEditableTarget(editor, event.target) && !$0004ae769ccea2eb$var$isEventHandled(event, attributes.onPaste)) // COMPAT: Certain browsers don't support the `beforeinput` event, so we
            // fall back to React's `onPaste` here instead.
            // COMPAT: Firefox, Chrome and Safari don't emit `beforeinput` events
            // when "paste without formatting" is used, so fallback. (2020/02/20)
            // COMPAT: Safari InputEvents generated by pasting won't include
            // application/x-slate-fragment items, so use the
            // ClipboardEvent here. (2023/03/15)
            {
                if (!(0, $aWQx3.HAS_BEFORE_INPUT_SUPPORT) || (0, $aWQx3.isPlainTextOnlyPaste)(event.nativeEvent) || (0, $aWQx3.IS_WEBKIT)) {
                    event.preventDefault();
                    $0004ae769ccea2eb$export$a55741a99bf22636.insertData(editor, event.clipboardData);
                }
            }
        }, [
            readOnly,
            editor,
            attributes.onPaste
        ])
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement($0004ae769ccea2eb$var$Children, {
        decorations: decorations,
        node: editor,
        renderElement: renderElement,
        renderPlaceholder: renderPlaceholder,
        renderLeaf: renderLeaf,
        selection: editor.selection
    }))))));
});
/**
 * The default placeholder element
 */ var $0004ae769ccea2eb$export$c78d47e2f8812af9 = (_ref)=>{
    var { attributes: attributes, children: children } = _ref;
    return(/*#__PURE__*/ // COMPAT: Artificially add a line-break to the end on the placeholder element
    // to prevent Android IMEs to pick up its content in autocorrect and to auto-capitalize the first letter
    (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("span", $0004ae769ccea2eb$var$_objectSpread({}, attributes), children, (0, $aWQx3.IS_ANDROID) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("br", null)));
};
/**
 * A default memoized decorate function.
 */ var $0004ae769ccea2eb$var$defaultDecorate = ()=>[];
/**
 * A default implement to scroll dom range into view.
 */ var $0004ae769ccea2eb$var$defaultScrollSelectionIntoView = (editor, domRange)=>{
    // This was affecting the selection of multiple blocks and dragging behavior,
    // so enabled only if the selection has been collapsed.
    if (domRange.getBoundingClientRect && (!editor.selection || editor.selection && (0, $akZf2.Range).isCollapsed(editor.selection))) {
        var leafEl = domRange.startContainer.parentElement;
        leafEl.getBoundingClientRect = domRange.getBoundingClientRect.bind(domRange);
        (0, $dtPKc.default)(leafEl, {
            scrollMode: "if-needed"
        });
        // @ts-expect-error an unorthodox delete D:
        delete leafEl.getBoundingClientRect;
    }
};
/**
 * Check if an event is overrided by a handler.
 */ var $0004ae769ccea2eb$var$isEventHandled = (event, handler)=>{
    if (!handler) return false;
    // The custom event handler may return a boolean to specify whether the event
    // shall be treated as being handled or not.
    var shouldTreatEventAsHandled = handler(event);
    if (shouldTreatEventAsHandled != null) return shouldTreatEventAsHandled;
    return event.isDefaultPrevented() || event.isPropagationStopped();
};
/**
 * Check if the event's target is an input element
 */ var $0004ae769ccea2eb$var$isDOMEventTargetInput = (event)=>{
    return (0, $aWQx3.isDOMNode)(event.target) && (event.target instanceof HTMLInputElement || event.target instanceof HTMLTextAreaElement);
};
/**
 * Check if a DOM event is overrided by a handler.
 */ var $0004ae769ccea2eb$var$isDOMEventHandled = (event, handler)=>{
    if (!handler) return false;
    // The custom event handler may return a boolean to specify whether the event
    // shall be treated as being handled or not.
    var shouldTreatEventAsHandled = handler(event);
    if (shouldTreatEventAsHandled != null) return shouldTreatEventAsHandled;
    return event.defaultPrevented;
};
/**
 * A React context for sharing the `focused` state of the editor.
 */ var $0004ae769ccea2eb$var$FocusedContext = /*#__PURE__*/ (0, $eeH7J.createContext)(false);
/**
 * Get the current `focused` state of the editor.
 */ var $0004ae769ccea2eb$export$c3a4b10ff8619b82 = ()=>{
    return (0, $eeH7J.useContext)($0004ae769ccea2eb$var$FocusedContext);
};
function $0004ae769ccea2eb$var$isError(error) {
    return error instanceof Error;
}
/**
 * A React context for sharing the editor selector context in a way to control rerenders
 */ var $0004ae769ccea2eb$var$SlateSelectorContext = /*#__PURE__*/ (0, $eeH7J.createContext)({});
var $0004ae769ccea2eb$var$refEquality = (a, b)=>a === b;
/**
 * use redux style selectors to prevent rerendering on every keystroke.
 * Bear in mind rerendering can only prevented if the returned value is a value type or for reference types (e.g. objects and arrays) add a custom equality function.
 *
 * Example:
 * ```
 *  const isSelectionActive = useSlateSelector(editor => Boolean(editor.selection));
 * ```
 */ function $0004ae769ccea2eb$export$20ad795e98fe149e(selector) {
    var equalityFn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $0004ae769ccea2eb$var$refEquality;
    var [, forceRender] = (0, $eeH7J.useReducer)((s)=>s + 1, 0);
    var context = (0, $eeH7J.useContext)($0004ae769ccea2eb$var$SlateSelectorContext);
    if (!context) throw new Error("The `useSlateSelector` hook must be used inside the <Slate> component's context.");
    var { getSlate: getSlate, addEventListener: addEventListener } = context;
    var latestSubscriptionCallbackError = (0, $eeH7J.useRef)();
    var latestSelector = (0, $eeH7J.useRef)(()=>null);
    var latestSelectedState = (0, $eeH7J.useRef)(null);
    var selectedState;
    try {
        if (selector !== latestSelector.current || latestSubscriptionCallbackError.current) selectedState = selector(getSlate());
        else selectedState = latestSelectedState.current;
    } catch (err) {
        if (latestSubscriptionCallbackError.current && $0004ae769ccea2eb$var$isError(err)) err.message += "\nThe error may be correlated with this previous error:\n".concat(latestSubscriptionCallbackError.current.stack, "\n\n");
        throw err;
    }
    $0004ae769ccea2eb$var$useIsomorphicLayoutEffect(()=>{
        latestSelector.current = selector;
        latestSelectedState.current = selectedState;
        latestSubscriptionCallbackError.current = undefined;
    });
    $0004ae769ccea2eb$var$useIsomorphicLayoutEffect(()=>{
        function checkForUpdates() {
            try {
                var newSelectedState = latestSelector.current(getSlate());
                if (equalityFn(newSelectedState, latestSelectedState.current)) return;
                latestSelectedState.current = newSelectedState;
            } catch (err) {
                // we ignore all errors here, since when the component
                // is re-rendered, the selectors are called again, and
                // will throw again, if neither props nor store state
                // changed
                if (err instanceof Error) latestSubscriptionCallbackError.current = err;
                else latestSubscriptionCallbackError.current = new Error(String(err));
            }
            forceRender();
        }
        var unsubscribe = addEventListener(checkForUpdates);
        checkForUpdates();
        return ()=>unsubscribe();
    }, // don't rerender on equalityFn change since we want to be able to define it inline
    [
        addEventListener,
        getSlate
    ]);
    return selectedState;
}
/**
 * Create selector context with editor updating on every editor change
 */ function $0004ae769ccea2eb$var$useSelectorContext(editor) {
    var eventListeners = (0, $eeH7J.useRef)([]).current;
    var slateRef = (0, $eeH7J.useRef)({
        editor: editor
    }).current;
    var onChange = (0, $eeH7J.useCallback)((editor)=>{
        slateRef.editor = editor;
        eventListeners.forEach((listener)=>listener(editor));
    }, [
        eventListeners,
        slateRef
    ]);
    var selectorContext = (0, $eeH7J.useMemo)(()=>{
        return {
            getSlate: ()=>slateRef.editor,
            addEventListener: (callback)=>{
                eventListeners.push(callback);
                return ()=>{
                    eventListeners.splice(eventListeners.indexOf(callback), 1);
                };
            }
        };
    }, [
        eventListeners,
        slateRef
    ]);
    return {
        selectorContext: selectorContext,
        onChange: onChange
    };
}
var $0004ae769ccea2eb$var$REACT_MAJOR_VERSION = parseInt((0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).version.split(".")[0], 10);
var $0004ae769ccea2eb$var$_excluded = [
    "editor",
    "children",
    "onChange",
    "onSelectionChange",
    "onValueChange",
    "initialValue"
];
/**
 * A wrapper around the provider to handle `onChange` events, because the editor
 * is a mutable singleton so it won't ever register as "changed" otherwise.
 */ var $0004ae769ccea2eb$export$790e405fc529efaf = (props)=>{
    var { editor: editor, children: children, onChange: onChange, onSelectionChange: onSelectionChange, onValueChange: onValueChange, initialValue: initialValue } = props, rest = $0004ae769ccea2eb$var$_objectWithoutProperties(props, $0004ae769ccea2eb$var$_excluded);
    var [context, setContext] = (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).useState(()=>{
        if (!(0, $akZf2.Node).isNodeList(initialValue)) throw new Error("[Slate] initialValue is invalid! Expected a list of elements but got: ".concat((0, $akZf2.Scrubber).stringify(initialValue)));
        if (!(0, $akZf2.Editor).isEditor(editor)) throw new Error("[Slate] editor is invalid! You passed: ".concat((0, $akZf2.Scrubber).stringify(editor)));
        editor.children = initialValue;
        Object.assign(editor, rest);
        return {
            v: 0,
            editor: editor
        };
    });
    var { selectorContext: selectorContext, onChange: handleSelectorChange } = $0004ae769ccea2eb$var$useSelectorContext(editor);
    var onContextChange = (0, $eeH7J.useCallback)((options)=>{
        var _options$operation;
        if (onChange) onChange(editor.children);
        switch(options === null || options === void 0 || (_options$operation = options.operation) === null || _options$operation === void 0 ? void 0 : _options$operation.type){
            case "set_selection":
                onSelectionChange === null || onSelectionChange === void 0 || onSelectionChange(editor.selection);
                break;
            default:
                onValueChange === null || onValueChange === void 0 || onValueChange(editor.children);
        }
        setContext((prevContext)=>({
                v: prevContext.v + 1,
                editor: editor
            }));
        handleSelectorChange(editor);
    }, [
        editor,
        handleSelectorChange,
        onChange,
        onSelectionChange,
        onValueChange
    ]);
    (0, $eeH7J.useEffect)(()=>{
        (0, $aWQx3.EDITOR_TO_ON_CHANGE).set(editor, onContextChange);
        return ()=>{
            (0, $aWQx3.EDITOR_TO_ON_CHANGE).set(editor, ()=>{});
        };
    }, [
        editor,
        onContextChange
    ]);
    var [isFocused, setIsFocused] = (0, $eeH7J.useState)($0004ae769ccea2eb$export$a55741a99bf22636.isFocused(editor));
    (0, $eeH7J.useEffect)(()=>{
        setIsFocused($0004ae769ccea2eb$export$a55741a99bf22636.isFocused(editor));
    }, [
        editor
    ]);
    $0004ae769ccea2eb$var$useIsomorphicLayoutEffect(()=>{
        var fn = ()=>setIsFocused($0004ae769ccea2eb$export$a55741a99bf22636.isFocused(editor));
        if ($0004ae769ccea2eb$var$REACT_MAJOR_VERSION >= 17) {
            // In React >= 17 onFocus and onBlur listen to the focusin and focusout events during the bubbling phase.
            // Therefore in order for <Editable />'s handlers to run first, which is necessary for ReactEditor.isFocused(editor)
            // to return the correct value, we have to listen to the focusin and focusout events without useCapture here.
            document.addEventListener("focusin", fn);
            document.addEventListener("focusout", fn);
            return ()=>{
                document.removeEventListener("focusin", fn);
                document.removeEventListener("focusout", fn);
            };
        } else {
            document.addEventListener("focus", fn, true);
            document.addEventListener("blur", fn, true);
            return ()=>{
                document.removeEventListener("focus", fn, true);
                document.removeEventListener("blur", fn, true);
            };
        }
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement($0004ae769ccea2eb$var$SlateSelectorContext.Provider, {
        value: selectorContext
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement($0004ae769ccea2eb$var$SlateContext.Provider, {
        value: context
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement($0004ae769ccea2eb$var$EditorContext.Provider, {
        value: context.editor
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement($0004ae769ccea2eb$var$FocusedContext.Provider, {
        value: isFocused
    }, children))));
};
/**
 * Get the current editor object from the React context.
 * @deprecated Use useSlateStatic instead.
 */ var $0004ae769ccea2eb$export$43711a1418203bbc = ()=>{
    var editor = (0, $eeH7J.useContext)($0004ae769ccea2eb$var$EditorContext);
    if (!editor) throw new Error("The `useEditor` hook must be used inside the <Slate> component's context.");
    return editor;
};
/**
 * Get the current slate selection.
 * Only triggers a rerender when the selection actually changes
 */ var $0004ae769ccea2eb$export$8244597ba7053681 = ()=>{
    return $0004ae769ccea2eb$export$20ad795e98fe149e((editor)=>editor.selection, $0004ae769ccea2eb$var$isSelectionEqual);
};
var $0004ae769ccea2eb$var$isSelectionEqual = (a, b)=>{
    if (!a && !b) return true;
    if (!a || !b) return false;
    return (0, $akZf2.Range).equals(a, b);
};
/**
 * `withReact` adds React and DOM specific behaviors to the editor.
 *
 * If you are using TypeScript, you must extend Slate's CustomTypes to use
 * this plugin.
 *
 * See https://docs.slatejs.org/concepts/11-typescript to learn how.
 */ var $0004ae769ccea2eb$export$f67e6da052b725a3 = function withReact(editor) {
    var clipboardFormatKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "x-slate-fragment";
    var e = editor;
    e = (0, $aWQx3.withDOM)(e, clipboardFormatKey);
    var { onChange: onChange } = e;
    e.onChange = (options)=>{
        // COMPAT: React < 18 doesn't batch `setState` hook calls, which means
        // that the children and selection can get out of sync for one render
        // pass. So we have to use this unstable API to ensure it batches them.
        // (2019/12/03)
        // https://github.com/facebook/react/issues/14259#issuecomment-439702367
        var maybeBatchUpdates = $0004ae769ccea2eb$var$REACT_MAJOR_VERSION < 18 ? (0, (/*@__PURE__*/$parcel$interopDefault($iMJCh))).unstable_batchedUpdates : (callback)=>callback();
        maybeBatchUpdates(()=>{
            onChange(options);
        });
    };
    return e;
};

});
parcelRegister("hA1QH", function(module, exports) {
"use strict";
module.exports = $ccc73b9d83f3c498$var$direction;
var $ccc73b9d83f3c498$var$RTL = "\u0591-\u07FF\uFB1D-\uFDFD\uFE70-\uFEFC";
var $ccc73b9d83f3c498$var$LTR = "A-Za-z\xc0-\xd6\xd8-\xf6\xf8-\u02B8\u0300-\u0590\u0800-\u1FFF\u200E\u2C00-\uFB1C\uFE00-\uFE6F\uFEFD-\uFFFF";
var $ccc73b9d83f3c498$var$rtl = new RegExp("^[^" + $ccc73b9d83f3c498$var$LTR + "]*[" + $ccc73b9d83f3c498$var$RTL + "]");
var $ccc73b9d83f3c498$var$ltr = new RegExp("^[^" + $ccc73b9d83f3c498$var$RTL + "]*[" + $ccc73b9d83f3c498$var$LTR + "]");
function $ccc73b9d83f3c498$var$direction(value) {
    value = String(value || "");
    if ($ccc73b9d83f3c498$var$rtl.test(value)) return "rtl";
    if ($ccc73b9d83f3c498$var$ltr.test(value)) return "ltr";
    return "neutral";
}

});

parcelRegister("5lUJY", function(module, exports) {

var $6AOrv = parcelRequire("6AOrv");

var $3Oxuf = parcelRequire("3Oxuf");

var $duCiU = parcelRequire("duCiU");
/** Error message constants. */ var $3e5aed669d617ee3$var$FUNC_ERROR_TEXT = "Expected a function";
/* Built-in method references for those with the same name as other `lodash` methods. */ var $3e5aed669d617ee3$var$nativeMax = Math.max, $3e5aed669d617ee3$var$nativeMin = Math.min;
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $3e5aed669d617ee3$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != "function") throw new TypeError($3e5aed669d617ee3$var$FUNC_ERROR_TEXT);
    wait = $duCiU(wait) || 0;
    if ($6AOrv(options)) {
        leading = !!options.leading;
        maxing = "maxWait" in options;
        maxWait = maxing ? $3e5aed669d617ee3$var$nativeMax($duCiU(options.maxWait) || 0, wait) : maxWait;
        trailing = "trailing" in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
        return maxing ? $3e5aed669d617ee3$var$nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = $3Oxuf();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge($3Oxuf());
    }
    function debounced() {
        var time = $3Oxuf(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                clearTimeout(timerId);
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
module.exports = $3e5aed669d617ee3$var$debounce;

});
parcelRegister("3Oxuf", function(module, exports) {

var $670gj = parcelRequire("670gj");
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $2c70046b1fe14733$var$now = function() {
    return $670gj.Date.now();
};
module.exports = $2c70046b1fe14733$var$now;

});

parcelRegister("duCiU", function(module, exports) {

var $cVZ3e = parcelRequire("cVZ3e");

var $6AOrv = parcelRequire("6AOrv");

var $ecbje = parcelRequire("ecbje");
/** Used as references for various `Number` constants. */ var $9d2bca12134aa7a7$var$NAN = 0 / 0;
/** Used to detect bad signed hexadecimal string values. */ var $9d2bca12134aa7a7$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $9d2bca12134aa7a7$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $9d2bca12134aa7a7$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $9d2bca12134aa7a7$var$freeParseInt = parseInt;
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $9d2bca12134aa7a7$var$toNumber(value) {
    if (typeof value == "number") return value;
    if ($ecbje(value)) return $9d2bca12134aa7a7$var$NAN;
    if ($6AOrv(value)) {
        var other = typeof value.valueOf == "function" ? value.valueOf() : value;
        value = $6AOrv(other) ? other + "" : other;
    }
    if (typeof value != "string") return value === 0 ? value : +value;
    value = $cVZ3e(value);
    var isBinary = $9d2bca12134aa7a7$var$reIsBinary.test(value);
    return isBinary || $9d2bca12134aa7a7$var$reIsOctal.test(value) ? $9d2bca12134aa7a7$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $9d2bca12134aa7a7$var$reIsBadHex.test(value) ? $9d2bca12134aa7a7$var$NAN : +value;
}
module.exports = $9d2bca12134aa7a7$var$toNumber;

});
parcelRegister("cVZ3e", function(module, exports) {

var $5po0Z = parcelRequire("5po0Z");
/** Used to match leading whitespace. */ var $96aa2a5d2bd080d1$var$reTrimStart = /^\s+/;
/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */ function $96aa2a5d2bd080d1$var$baseTrim(string) {
    return string ? string.slice(0, $5po0Z(string) + 1).replace($96aa2a5d2bd080d1$var$reTrimStart, "") : string;
}
module.exports = $96aa2a5d2bd080d1$var$baseTrim;

});
parcelRegister("5po0Z", function(module, exports) {
/** Used to match a single whitespace character. */ var $3f01ea7104459285$var$reWhitespace = /\s/;
/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */ function $3f01ea7104459285$var$trimmedEndIndex(string) {
    var index = string.length;
    while(index-- && $3f01ea7104459285$var$reWhitespace.test(string.charAt(index)));
    return index;
}
module.exports = $3f01ea7104459285$var$trimmedEndIndex;

});




parcelRegister("824Mz", function(module, exports) {

var $5lUJY = parcelRequire("5lUJY");

var $6AOrv = parcelRequire("6AOrv");
/** Error message constants. */ var $5d92385171ec6a60$var$FUNC_ERROR_TEXT = "Expected a function";
/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */ function $5d92385171ec6a60$var$throttle(func, wait, options) {
    var leading = true, trailing = true;
    if (typeof func != "function") throw new TypeError($5d92385171ec6a60$var$FUNC_ERROR_TEXT);
    if ($6AOrv(options)) {
        leading = "leading" in options ? !!options.leading : leading;
        trailing = "trailing" in options ? !!options.trailing : trailing;
    }
    return $5lUJY(func, wait, {
        "leading": leading,
        "maxWait": wait,
        "trailing": trailing
    });
}
module.exports = $5d92385171ec6a60$var$throttle;

});

parcelRegister("dtPKc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9d061f1b6b82a010$export$2e2bcd8739ae039; });

var $3PyEA = parcelRequire("3PyEA");
const $9d061f1b6b82a010$var$o = (t)=>!1 === t ? {
        block: "end",
        inline: "nearest"
    } : ((t)=>t === Object(t) && 0 !== Object.keys(t).length)(t) ? t : {
        block: "start",
        inline: "nearest"
    };
function $9d061f1b6b82a010$export$2e2bcd8739ae039(e, r) {
    if (!e.isConnected || !((t)=>{
        let o = t;
        for(; o && o.parentNode;){
            if (o.parentNode === document) return !0;
            o = o.parentNode instanceof ShadowRoot ? o.parentNode.host : o.parentNode;
        }
        return !1;
    })(e)) return;
    const n = ((t)=>{
        const o = window.getComputedStyle(t);
        return {
            top: parseFloat(o.scrollMarginTop) || 0,
            right: parseFloat(o.scrollMarginRight) || 0,
            bottom: parseFloat(o.scrollMarginBottom) || 0,
            left: parseFloat(o.scrollMarginLeft) || 0
        };
    })(e);
    if (((t)=>"object" == typeof t && "function" == typeof t.behavior)(r)) return r.behavior((0, $3PyEA.compute)(e, r));
    const l = "boolean" == typeof r || null == r ? void 0 : r.behavior;
    for (const { el: a, top: i, left: s } of (0, $3PyEA.compute)(e, $9d061f1b6b82a010$var$o(r))){
        const t = i - n.top + n.bottom, o = s - n.left + n.right;
        a.scroll({
            top: t,
            left: o,
            behavior: l
        });
    }
}

});
parcelRegister("3PyEA", function(module, exports) {

$parcel$export(module.exports, "compute", function () { return $2ca103fe4fcd6aae$export$3b12cb22b12b954b; });
const $2ca103fe4fcd6aae$var$t = (t)=>"object" == typeof t && null != t && 1 === t.nodeType, $2ca103fe4fcd6aae$var$e = (t, e)=>(!e || "hidden" !== t) && "visible" !== t && "clip" !== t, $2ca103fe4fcd6aae$var$n = (t, n)=>{
    if (t.clientHeight < t.scrollHeight || t.clientWidth < t.scrollWidth) {
        const o = getComputedStyle(t, null);
        return $2ca103fe4fcd6aae$var$e(o.overflowY, n) || $2ca103fe4fcd6aae$var$e(o.overflowX, n) || ((t)=>{
            const e = ((t)=>{
                if (!t.ownerDocument || !t.ownerDocument.defaultView) return null;
                try {
                    return t.ownerDocument.defaultView.frameElement;
                } catch (t) {
                    return null;
                }
            })(t);
            return !!e && (e.clientHeight < t.scrollHeight || e.clientWidth < t.scrollWidth);
        })(t);
    }
    return !1;
}, $2ca103fe4fcd6aae$var$o = (t, e, n, o, l, r, i, s)=>r < t && i > e || r > t && i < e ? 0 : r <= t && s <= n || i >= e && s >= n ? r - t - o : i > e && s < n || r < t && s > n ? i - e + l : 0, $2ca103fe4fcd6aae$var$l = (t)=>{
    const e = t.parentElement;
    return null == e ? t.getRootNode().host || null : e;
}, $2ca103fe4fcd6aae$export$3b12cb22b12b954b = (e, r)=>{
    var i, s, d, h;
    if ("undefined" == typeof document) return [];
    const { scrollMode: c, block: f, inline: u, boundary: a, skipOverflowHiddenElements: g } = r, p = "function" == typeof a ? a : (t)=>t !== a;
    if (!$2ca103fe4fcd6aae$var$t(e)) throw new TypeError("Invalid target");
    const m = document.scrollingElement || document.documentElement, w = [];
    let W = e;
    for(; $2ca103fe4fcd6aae$var$t(W) && p(W);){
        if (W = $2ca103fe4fcd6aae$var$l(W), W === m) {
            w.push(W);
            break;
        }
        null != W && W === document.body && $2ca103fe4fcd6aae$var$n(W) && !$2ca103fe4fcd6aae$var$n(document.documentElement) || null != W && $2ca103fe4fcd6aae$var$n(W, g) && w.push(W);
    }
    const b = null != (s = null == (i = window.visualViewport) ? void 0 : i.width) ? s : innerWidth, H = null != (h = null == (d = window.visualViewport) ? void 0 : d.height) ? h : innerHeight, { scrollX: y, scrollY: M } = window, { height: v, width: E, top: x, right: C, bottom: I, left: R } = e.getBoundingClientRect(), { top: T, right: B, bottom: F, left: V } = ((t)=>{
        const e = window.getComputedStyle(t);
        return {
            top: parseFloat(e.scrollMarginTop) || 0,
            right: parseFloat(e.scrollMarginRight) || 0,
            bottom: parseFloat(e.scrollMarginBottom) || 0,
            left: parseFloat(e.scrollMarginLeft) || 0
        };
    })(e);
    let k = "start" === f || "nearest" === f ? x - T : "end" === f ? I + F : x + v / 2 - T + F, D = "center" === u ? R + E / 2 - V + B : "end" === u ? C + B : R - V;
    const L = [];
    for(let t = 0; t < w.length; t++){
        const e = w[t], { height: n, width: l, top: r, right: i, bottom: s, left: d } = e.getBoundingClientRect();
        if ("if-needed" === c && x >= 0 && R >= 0 && I <= H && C <= b && x >= r && I <= s && R >= d && C <= i) return L;
        const h = getComputedStyle(e), a = parseInt(h.borderLeftWidth, 10), g = parseInt(h.borderTopWidth, 10), p = parseInt(h.borderRightWidth, 10), W = parseInt(h.borderBottomWidth, 10);
        let T = 0, B = 0;
        const F = "offsetWidth" in e ? e.offsetWidth - e.clientWidth - a - p : 0, V = "offsetHeight" in e ? e.offsetHeight - e.clientHeight - g - W : 0, S = "offsetWidth" in e ? 0 === e.offsetWidth ? 0 : l / e.offsetWidth : 0, X = "offsetHeight" in e ? 0 === e.offsetHeight ? 0 : n / e.offsetHeight : 0;
        if (m === e) T = "start" === f ? k : "end" === f ? k - H : "nearest" === f ? $2ca103fe4fcd6aae$var$o(M, M + H, H, g, W, M + k, M + k + v, v) : k - H / 2, B = "start" === u ? D : "center" === u ? D - b / 2 : "end" === u ? D - b : $2ca103fe4fcd6aae$var$o(y, y + b, b, a, p, y + D, y + D + E, E), T = Math.max(0, T + M), B = Math.max(0, B + y);
        else {
            T = "start" === f ? k - r - g : "end" === f ? k - s + W + V : "nearest" === f ? $2ca103fe4fcd6aae$var$o(r, s, n, g, W + V, k, k + v, v) : k - (r + n / 2) + V / 2, B = "start" === u ? D - d - a : "center" === u ? D - (d + l / 2) + F / 2 : "end" === u ? D - i + p + F : $2ca103fe4fcd6aae$var$o(d, i, l, a, p + F, D, D + E, E);
            const { scrollLeft: t, scrollTop: h } = e;
            T = 0 === X ? 0 : Math.max(0, Math.min(h + T / X, e.scrollHeight - n / X + V)), B = 0 === S ? 0 : Math.max(0, Math.min(t + B / S, e.scrollWidth - l / S + F)), k += h - T, D += t - B;
        }
        L.push({
            el: e,
            top: T,
            left: B
        });
    }
    return L;
};

});


parcelRegister("aWQx3", function(module, exports) {

$parcel$export(module.exports, "getDefaultView", function () { return $7f8811f69e78b396$export$29c7e3796b1cc2e7; });
$parcel$export(module.exports, "isDOMNode", function () { return $7f8811f69e78b396$export$b8eb4d3b76e486c2; });
$parcel$export(module.exports, "isDOMElement", function () { return $7f8811f69e78b396$export$c296e2d4365c37a5; });
$parcel$export(module.exports, "isDOMSelection", function () { return $7f8811f69e78b396$export$e2bc0f5f415c8287; });
$parcel$export(module.exports, "isPlainTextOnlyPaste", function () { return $7f8811f69e78b396$export$6d8e4215dbf54cb2; });
$parcel$export(module.exports, "getSelection", function () { return $7f8811f69e78b396$export$ca798a7e6e94638c; });
$parcel$export(module.exports, "isTrackedMutation", function () { return $7f8811f69e78b396$export$8df784999205b901; });
$parcel$export(module.exports, "DOMEditor", function () { return $7f8811f69e78b396$export$c297831efceeff81; });
$parcel$export(module.exports, "getActiveElement", function () { return $7f8811f69e78b396$export$cd4e5573fbe2b576; });
$parcel$export(module.exports, "IS_IOS", function () { return $7f8811f69e78b396$export$9135b5fce2a2854d; });
$parcel$export(module.exports, "IS_ANDROID", function () { return $7f8811f69e78b396$export$2760ddee6a71ee7d; });
$parcel$export(module.exports, "IS_FIREFOX", function () { return $7f8811f69e78b396$export$fa35291248be714f; });
$parcel$export(module.exports, "IS_WEBKIT", function () { return $7f8811f69e78b396$export$66896917a270587a; });
$parcel$export(module.exports, "IS_CHROME", function () { return $7f8811f69e78b396$export$265e05392e08df49; });
$parcel$export(module.exports, "IS_FIREFOX_LEGACY", function () { return $7f8811f69e78b396$export$dfe303d2109f395c; });
$parcel$export(module.exports, "IS_UC_MOBILE", function () { return $7f8811f69e78b396$export$bffdb6943b2cc527; });
$parcel$export(module.exports, "IS_WECHATBROWSER", function () { return $7f8811f69e78b396$export$7b88ccb0e0be1d59; });
$parcel$export(module.exports, "CAN_USE_DOM", function () { return $7f8811f69e78b396$export$37d2f1e98a187e61; });
$parcel$export(module.exports, "HAS_BEFORE_INPUT_SUPPORT", function () { return $7f8811f69e78b396$export$99a818ccd5c3f279; });
$parcel$export(module.exports, "IS_NODE_MAP_DIRTY", function () { return $7f8811f69e78b396$export$a3ff80a600e5b91c; });
$parcel$export(module.exports, "NODE_TO_INDEX", function () { return $7f8811f69e78b396$export$ad37d8527ff8298; });
$parcel$export(module.exports, "NODE_TO_PARENT", function () { return $7f8811f69e78b396$export$5fb08fb525a1cae4; });
$parcel$export(module.exports, "EDITOR_TO_WINDOW", function () { return $7f8811f69e78b396$export$768455e9a8854239; });
$parcel$export(module.exports, "EDITOR_TO_ELEMENT", function () { return $7f8811f69e78b396$export$75a4d6a7d5533237; });
$parcel$export(module.exports, "EDITOR_TO_PLACEHOLDER_ELEMENT", function () { return $7f8811f69e78b396$export$aa76a6ea0fc9dffc; });
$parcel$export(module.exports, "ELEMENT_TO_NODE", function () { return $7f8811f69e78b396$export$68c25f314154811b; });
$parcel$export(module.exports, "NODE_TO_ELEMENT", function () { return $7f8811f69e78b396$export$10a3cb60e9968041; });
$parcel$export(module.exports, "EDITOR_TO_KEY_TO_ELEMENT", function () { return $7f8811f69e78b396$export$c5006f1f28dfee1d; });
$parcel$export(module.exports, "IS_READ_ONLY", function () { return $7f8811f69e78b396$export$e0ce804510945358; });
$parcel$export(module.exports, "IS_FOCUSED", function () { return $7f8811f69e78b396$export$6b6823d61e2d5285; });
$parcel$export(module.exports, "IS_COMPOSING", function () { return $7f8811f69e78b396$export$775832fe60c7ce3a; });
$parcel$export(module.exports, "EDITOR_TO_USER_SELECTION", function () { return $7f8811f69e78b396$export$da49e689445bc1c4; });
$parcel$export(module.exports, "EDITOR_TO_ON_CHANGE", function () { return $7f8811f69e78b396$export$7762db2211c85722; });
$parcel$export(module.exports, "EDITOR_TO_SCHEDULE_FLUSH", function () { return $7f8811f69e78b396$export$65bceb8dab583f5d; });
$parcel$export(module.exports, "EDITOR_TO_PENDING_INSERTION_MARKS", function () { return $7f8811f69e78b396$export$33a2b5790e995f59; });
$parcel$export(module.exports, "EDITOR_TO_USER_MARKS", function () { return $7f8811f69e78b396$export$70fe56ef2d7c7d65; });
$parcel$export(module.exports, "EDITOR_TO_PENDING_DIFFS", function () { return $7f8811f69e78b396$export$58e2f29bf18516fe; });
$parcel$export(module.exports, "EDITOR_TO_PENDING_ACTION", function () { return $7f8811f69e78b396$export$aac12b7391d2d38e; });
$parcel$export(module.exports, "EDITOR_TO_PENDING_SELECTION", function () { return $7f8811f69e78b396$export$e1514adea009c29d; });
$parcel$export(module.exports, "EDITOR_TO_FORCE_RENDER", function () { return $7f8811f69e78b396$export$36f6800a6332a3da; });
$parcel$export(module.exports, "PLACEHOLDER_SYMBOL", function () { return $7f8811f69e78b396$export$9c71e74b36ebffc8; });
$parcel$export(module.exports, "MARK_PLACEHOLDER_SYMBOL", function () { return $7f8811f69e78b396$export$f1c2c81cf0fedc80; });
$parcel$export(module.exports, "verifyDiffState", function () { return $7f8811f69e78b396$export$742d614dde193cc2; });
$parcel$export(module.exports, "applyStringDiff", function () { return $7f8811f69e78b396$export$c79c04494e753239; });
$parcel$export(module.exports, "normalizeStringDiff", function () { return $7f8811f69e78b396$export$9fa85984a86e4a3e; });
$parcel$export(module.exports, "mergeStringDiffs", function () { return $7f8811f69e78b396$export$624495bf472ee903; });
$parcel$export(module.exports, "targetRange", function () { return $7f8811f69e78b396$export$5203edf5b0645097; });
$parcel$export(module.exports, "normalizePoint", function () { return $7f8811f69e78b396$export$9184b12b6269bcdd; });
$parcel$export(module.exports, "normalizeRange", function () { return $7f8811f69e78b396$export$769559576d90a89c; });
$parcel$export(module.exports, "withDOM", function () { return $7f8811f69e78b396$export$13156d13f3e996d2; });
$parcel$export(module.exports, "TRIPLE_CLICK", function () { return $7f8811f69e78b396$export$d8adef02c0251575; });
$parcel$export(module.exports, "Hotkeys", function () { return $7f8811f69e78b396$export$6f11581bd9b4598b; });
$parcel$export(module.exports, "isElementDecorationsEqual", function () { return $7f8811f69e78b396$export$305c26ace256f1f0; });
$parcel$export(module.exports, "isTextDecorationsEqual", function () { return $7f8811f69e78b396$export$8e95df7b6f278996; });

var $akZf2 = parcelRequire("akZf2");

var $iB3QS = parcelRequire("iB3QS");
/**
 * Types.
 */ // COMPAT: This is required to prevent TypeScript aliases from doing some very
// weird things for Slate's types with the same name as globals. (2019/11/27)
// https://github.com/microsoft/TypeScript/issues/35002
var $7f8811f69e78b396$export$913ca0ecb04f4c72 = globalThis.Node;
var $7f8811f69e78b396$export$97d587dc2049b818 = globalThis.Element;
var $7f8811f69e78b396$export$4de5d8b895f417b5 = globalThis.Text;
var $7f8811f69e78b396$export$16174e2a0bede5b2 = globalThis.Range;
var $7f8811f69e78b396$export$4b5a88244c9e30ab = globalThis.Selection;
var $7f8811f69e78b396$export$6f3f3b86ab0d71e1 = globalThis.StaticRange;
/**
 * Returns the host window of a DOM node
 */ var $7f8811f69e78b396$export$29c7e3796b1cc2e7 = (value)=>{
    return value && value.ownerDocument && value.ownerDocument.defaultView || null;
};
/**
 * Check if a DOM node is a comment node.
 */ var $7f8811f69e78b396$var$isDOMComment = (value)=>{
    return $7f8811f69e78b396$export$b8eb4d3b76e486c2(value) && value.nodeType === 8;
};
/**
 * Check if a DOM node is an element node.
 */ var $7f8811f69e78b396$export$c296e2d4365c37a5 = (value)=>{
    return $7f8811f69e78b396$export$b8eb4d3b76e486c2(value) && value.nodeType === 1;
};
/**
 * Check if a value is a DOM node.
 */ var $7f8811f69e78b396$export$b8eb4d3b76e486c2 = (value)=>{
    var window1 = $7f8811f69e78b396$export$29c7e3796b1cc2e7(value);
    return !!window1 && value instanceof window1.Node;
};
/**
 * Check if a value is a DOM selection.
 */ var $7f8811f69e78b396$export$e2bc0f5f415c8287 = (value)=>{
    var window1 = value && value.anchorNode && $7f8811f69e78b396$export$29c7e3796b1cc2e7(value.anchorNode);
    return !!window1 && value instanceof window1.Selection;
};
/**
 * Check if a DOM node is an element node.
 */ var $7f8811f69e78b396$var$isDOMText = (value)=>{
    return $7f8811f69e78b396$export$b8eb4d3b76e486c2(value) && value.nodeType === 3;
};
/**
 * Checks whether a paste event is a plaintext-only event.
 */ var $7f8811f69e78b396$export$6d8e4215dbf54cb2 = (event)=>{
    return event.clipboardData && event.clipboardData.getData("text/plain") !== "" && event.clipboardData.types.length === 1;
};
/**
 * Normalize a DOM point so that it always refers to a text node.
 */ var $7f8811f69e78b396$export$c4a53afe769889a0 = (domPoint)=>{
    var [node, offset] = domPoint;
    // If it's an element node, its offset refers to the index of its children
    // including comment nodes, so try to find the right text child node.
    if ($7f8811f69e78b396$export$c296e2d4365c37a5(node) && node.childNodes.length) {
        var isLast = offset === node.childNodes.length;
        var index = isLast ? offset - 1 : offset;
        [node, index] = $7f8811f69e78b396$var$getEditableChildAndIndex(node, index, isLast ? "backward" : "forward");
        // If the editable child found is in front of input offset, we instead seek to its end
        isLast = index < offset;
        // If the node has children, traverse until we have a leaf node. Leaf nodes
        // can be either text nodes, or other void DOM nodes.
        while($7f8811f69e78b396$export$c296e2d4365c37a5(node) && node.childNodes.length){
            var i = isLast ? node.childNodes.length - 1 : 0;
            node = $7f8811f69e78b396$var$getEditableChild(node, i, isLast ? "backward" : "forward");
        }
        // Determine the new offset inside the text node.
        offset = isLast && node.textContent != null ? node.textContent.length : 0;
    }
    // Return the node and offset.
    return [
        node,
        offset
    ];
};
/**
 * Determines whether the active element is nested within a shadowRoot
 */ var $7f8811f69e78b396$export$e4bead7f22725bce = (node)=>{
    var parent = node && node.parentNode;
    while(parent){
        if (parent.toString() === "[object ShadowRoot]") return true;
        parent = parent.parentNode;
    }
    return false;
};
/**
 * Get the nearest editable child and index at `index` in a `parent`, preferring
 * `direction`.
 */ var $7f8811f69e78b396$var$getEditableChildAndIndex = (parent, index, direction)=>{
    var { childNodes: childNodes } = parent;
    var child = childNodes[index];
    var i = index;
    var triedForward = false;
    var triedBackward = false;
    // While the child is a comment node, or an element node with no children,
    // keep iterating to find a sibling non-void, non-comment node.
    while($7f8811f69e78b396$var$isDOMComment(child) || $7f8811f69e78b396$export$c296e2d4365c37a5(child) && child.childNodes.length === 0 || $7f8811f69e78b396$export$c296e2d4365c37a5(child) && child.getAttribute("contenteditable") === "false"){
        if (triedForward && triedBackward) break;
        if (i >= childNodes.length) {
            triedForward = true;
            i = index - 1;
            direction = "backward";
            continue;
        }
        if (i < 0) {
            triedBackward = true;
            i = index + 1;
            direction = "forward";
            continue;
        }
        child = childNodes[i];
        index = i;
        i += direction === "forward" ? 1 : -1;
    }
    return [
        child,
        index
    ];
};
/**
 * Get the nearest editable child at `index` in a `parent`, preferring
 * `direction`.
 */ var $7f8811f69e78b396$var$getEditableChild = (parent, index, direction)=>{
    var [child] = $7f8811f69e78b396$var$getEditableChildAndIndex(parent, index, direction);
    return child;
};
/**
 * Get a plaintext representation of the content of a node, accounting for block
 * elements which get a newline appended.
 *
 * The domNode must be attached to the DOM.
 */ var $7f8811f69e78b396$var$getPlainText = (domNode)=>{
    var text = "";
    if ($7f8811f69e78b396$var$isDOMText(domNode) && domNode.nodeValue) return domNode.nodeValue;
    if ($7f8811f69e78b396$export$c296e2d4365c37a5(domNode)) {
        for (var childNode of Array.from(domNode.childNodes))text += $7f8811f69e78b396$var$getPlainText(childNode);
        var display = getComputedStyle(domNode).getPropertyValue("display");
        if (display === "block" || display === "list" || domNode.tagName === "BR") text += "\n";
    }
    return text;
};
/**
 * Get x-slate-fragment attribute from data-slate-fragment
 */ var $7f8811f69e78b396$var$catchSlateFragment = /data-slate-fragment="(.+?)"/m;
var $7f8811f69e78b396$var$getSlateFragmentAttribute = (dataTransfer)=>{
    var htmlData = dataTransfer.getData("text/html");
    var [, fragment] = htmlData.match($7f8811f69e78b396$var$catchSlateFragment) || [];
    return fragment;
};
/**
 * Get the dom selection from Shadow Root if possible, otherwise from the document
 */ var $7f8811f69e78b396$export$ca798a7e6e94638c = (root)=>{
    if (root.getSelection != null) return root.getSelection();
    return document.getSelection();
};
/**
 * Check whether a mutation originates from a editable element inside the editor.
 */ var $7f8811f69e78b396$export$8df784999205b901 = (editor, mutation, batch)=>{
    var { target: target } = mutation;
    if ($7f8811f69e78b396$export$c296e2d4365c37a5(target) && target.matches('[contentEditable="false"]')) return false;
    var { document: document1 } = $7f8811f69e78b396$export$c297831efceeff81.getWindow(editor);
    if (document1.contains(target)) return $7f8811f69e78b396$export$c297831efceeff81.hasDOMNode(editor, target, {
        editable: true
    });
    var parentMutation = batch.find((_ref)=>{
        var { addedNodes: addedNodes, removedNodes: removedNodes } = _ref;
        for (var node of addedNodes){
            if (node === target || node.contains(target)) return true;
        }
        for (var _node of removedNodes){
            if (_node === target || _node.contains(target)) return true;
        }
    });
    if (!parentMutation || parentMutation === mutation) return false;
    // Target add/remove is tracked. Track the mutation if we track the parent mutation.
    return $7f8811f69e78b396$export$8df784999205b901(editor, parentMutation, batch);
};
/**
 * Retrieves the deepest active element in the DOM, considering nested shadow DOMs.
 */ var $7f8811f69e78b396$export$cd4e5573fbe2b576 = ()=>{
    var activeElement = document.activeElement;
    while((_activeElement = activeElement) !== null && _activeElement !== void 0 && _activeElement.shadowRoot && (_activeElement$shadow = activeElement.shadowRoot) !== null && _activeElement$shadow !== void 0 && _activeElement$shadow.activeElement){
        var _activeElement, _activeElement$shadow, _activeElement2;
        activeElement = (_activeElement2 = activeElement) === null || _activeElement2 === void 0 || (_activeElement2 = _activeElement2.shadowRoot) === null || _activeElement2 === void 0 ? void 0 : _activeElement2.activeElement;
    }
    return activeElement;
};
/**
 * @returns `true` if `otherNode` is before `node` in the document; otherwise, `false`.
 */ var $7f8811f69e78b396$export$5c007e10c6929c95 = (node, otherNode)=>Boolean(node.compareDocumentPosition(otherNode) & $7f8811f69e78b396$export$913ca0ecb04f4c72.DOCUMENT_POSITION_PRECEDING);
/**
 * @returns `true` if `otherNode` is after `node` in the document; otherwise, `false`.
 */ var $7f8811f69e78b396$export$e4de839670987035 = (node, otherNode)=>Boolean(node.compareDocumentPosition(otherNode) & $7f8811f69e78b396$export$913ca0ecb04f4c72.DOCUMENT_POSITION_FOLLOWING);
var $7f8811f69e78b396$var$_navigator$userAgent$, $7f8811f69e78b396$var$_navigator$userAgent$2;
var $7f8811f69e78b396$export$9135b5fce2a2854d = typeof navigator !== "undefined" && typeof window !== "undefined" && /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
var $7f8811f69e78b396$var$IS_APPLE = typeof navigator !== "undefined" && /Mac OS X/.test(navigator.userAgent);
var $7f8811f69e78b396$export$2760ddee6a71ee7d = typeof navigator !== "undefined" && /Android/.test(navigator.userAgent);
var $7f8811f69e78b396$export$fa35291248be714f = typeof navigator !== "undefined" && /^(?!.*Seamonkey)(?=.*Firefox).*/i.test(navigator.userAgent);
var $7f8811f69e78b396$export$66896917a270587a = typeof navigator !== "undefined" && /AppleWebKit(?!.*Chrome)/i.test(navigator.userAgent);
// "modern" Edge was released at 79.x
var $7f8811f69e78b396$var$IS_EDGE_LEGACY = typeof navigator !== "undefined" && /Edge?\/(?:[0-6][0-9]|[0-7][0-8])(?:\.)/i.test(navigator.userAgent);
var $7f8811f69e78b396$export$265e05392e08df49 = typeof navigator !== "undefined" && /Chrome/i.test(navigator.userAgent);
// Native `beforeInput` events don't work well with react on Chrome 75
// and older, Chrome 76+ can use `beforeInput` though.
var $7f8811f69e78b396$var$IS_CHROME_LEGACY = typeof navigator !== "undefined" && /Chrome?\/(?:[0-7][0-5]|[0-6][0-9])(?:\.)/i.test(navigator.userAgent);
var $7f8811f69e78b396$var$IS_ANDROID_CHROME_LEGACY = $7f8811f69e78b396$export$2760ddee6a71ee7d && typeof navigator !== "undefined" && /Chrome?\/(?:[0-5]?\d)(?:\.)/i.test(navigator.userAgent);
// Firefox did not support `beforeInput` until `v87`.
var $7f8811f69e78b396$export$dfe303d2109f395c = typeof navigator !== "undefined" && /^(?!.*Seamonkey)(?=.*Firefox\/(?:[0-7][0-9]|[0-8][0-6])(?:\.)).*/i.test(navigator.userAgent);
// UC mobile browser
var $7f8811f69e78b396$export$bffdb6943b2cc527 = typeof navigator !== "undefined" && /.*UCBrowser/.test(navigator.userAgent);
// Wechat browser (not including mac wechat)
var $7f8811f69e78b396$export$7b88ccb0e0be1d59 = typeof navigator !== "undefined" && /.*Wechat/.test(navigator.userAgent) && !/.*MacWechat/.test(navigator.userAgent); // avoid lookbehind (buggy in safari < 16.4)
// Check if DOM is available as React does internally.
// https://github.com/facebook/react/blob/master/packages/shared/ExecutionEnvironment.js
var $7f8811f69e78b396$export$37d2f1e98a187e61 = !!(typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined");
// Check if the browser is Safari and older than 17
typeof navigator !== "undefined" && /Safari/.test(navigator.userAgent) && /Version\/(\d+)/.test(navigator.userAgent) && ($7f8811f69e78b396$var$_navigator$userAgent$ = navigator.userAgent.match(/Version\/(\d+)/)) !== null && $7f8811f69e78b396$var$_navigator$userAgent$ !== void 0 && $7f8811f69e78b396$var$_navigator$userAgent$[1] && parseInt(($7f8811f69e78b396$var$_navigator$userAgent$2 = navigator.userAgent.match(/Version\/(\d+)/)) === null || $7f8811f69e78b396$var$_navigator$userAgent$2 === void 0 ? void 0 : $7f8811f69e78b396$var$_navigator$userAgent$2[1], 10);
// COMPAT: Firefox/Edge Legacy don't support the `beforeinput` event
// Chrome Legacy doesn't support `beforeinput` correctly
var $7f8811f69e78b396$export$99a818ccd5c3f279 = (!$7f8811f69e78b396$var$IS_CHROME_LEGACY || !$7f8811f69e78b396$var$IS_ANDROID_CHROME_LEGACY) && !$7f8811f69e78b396$var$IS_EDGE_LEGACY && // globalThis is undefined in older browsers
typeof globalThis !== "undefined" && globalThis.InputEvent && // @ts-ignore The `getTargetRanges` property isn't recognized.
typeof globalThis.InputEvent.prototype.getTargetRanges === "function";
function $7f8811f69e78b396$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $7f8811f69e78b396$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $7f8811f69e78b396$var$_typeof(o);
}
function $7f8811f69e78b396$var$_toPrimitive(input, hint) {
    if ($7f8811f69e78b396$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($7f8811f69e78b396$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $7f8811f69e78b396$var$_toPropertyKey(arg) {
    var key = $7f8811f69e78b396$var$_toPrimitive(arg, "string");
    return $7f8811f69e78b396$var$_typeof(key) === "symbol" ? key : String(key);
}
function $7f8811f69e78b396$var$_defineProperty(obj, key, value) {
    key = $7f8811f69e78b396$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
/**
 * An auto-incrementing identifier for keys.
 */ var $7f8811f69e78b396$var$n = 0;
/**
 * A class that keeps track of a key string. We use a full class here because we
 * want to be able to use them as keys in `WeakMap` objects.
 */ class $7f8811f69e78b396$export$cd0f44441c3b7719 {
    constructor(){
        $7f8811f69e78b396$var$_defineProperty(this, "id", void 0);
        this.id = "".concat($7f8811f69e78b396$var$n++);
    }
}
/**
 * Two weak maps that allow us rebuild a path given a node. They are populated
 * at render time such that after a render occurs we can always backtrack.
 */ var $7f8811f69e78b396$export$a3ff80a600e5b91c = new WeakMap();
var $7f8811f69e78b396$export$ad37d8527ff8298 = new WeakMap();
var $7f8811f69e78b396$export$5fb08fb525a1cae4 = new WeakMap();
/**
 * Weak maps that allow us to go between Slate nodes and DOM nodes. These
 * are used to resolve DOM event-related logic into Slate actions.
 */ var $7f8811f69e78b396$export$768455e9a8854239 = new WeakMap();
var $7f8811f69e78b396$export$75a4d6a7d5533237 = new WeakMap();
var $7f8811f69e78b396$export$aa76a6ea0fc9dffc = new WeakMap();
var $7f8811f69e78b396$export$68c25f314154811b = new WeakMap();
var $7f8811f69e78b396$export$10a3cb60e9968041 = new WeakMap();
var $7f8811f69e78b396$export$aaebb0c3422a1215 = new WeakMap();
var $7f8811f69e78b396$export$c5006f1f28dfee1d = new WeakMap();
/**
 * Weak maps for storing editor-related state.
 */ var $7f8811f69e78b396$export$e0ce804510945358 = new WeakMap();
var $7f8811f69e78b396$export$6b6823d61e2d5285 = new WeakMap();
var $7f8811f69e78b396$export$775832fe60c7ce3a = new WeakMap();
var $7f8811f69e78b396$export$da49e689445bc1c4 = new WeakMap();
/**
 * Weak map for associating the context `onChange` context with the plugin.
 */ var $7f8811f69e78b396$export$7762db2211c85722 = new WeakMap();
/**
 * Weak maps for saving pending state on composition stage.
 */ var $7f8811f69e78b396$export$65bceb8dab583f5d = new WeakMap();
var $7f8811f69e78b396$export$33a2b5790e995f59 = new WeakMap();
var $7f8811f69e78b396$export$70fe56ef2d7c7d65 = new WeakMap();
/**
 * Android input handling specific weak-maps
 */ var $7f8811f69e78b396$export$58e2f29bf18516fe = new WeakMap();
var $7f8811f69e78b396$export$aac12b7391d2d38e = new WeakMap();
var $7f8811f69e78b396$export$e1514adea009c29d = new WeakMap();
var $7f8811f69e78b396$export$36f6800a6332a3da = new WeakMap();
/**
 * Symbols.
 */ var $7f8811f69e78b396$export$9c71e74b36ebffc8 = Symbol("placeholder");
var $7f8811f69e78b396$export$f1c2c81cf0fedc80 = Symbol("mark-placeholder");
// eslint-disable-next-line no-redeclare
var $7f8811f69e78b396$export$c297831efceeff81 = {
    androidPendingDiffs: (editor)=>$7f8811f69e78b396$export$58e2f29bf18516fe.get(editor),
    androidScheduleFlush: (editor)=>{
        var _EDITOR_TO_SCHEDULE_F;
        (_EDITOR_TO_SCHEDULE_F = $7f8811f69e78b396$export$65bceb8dab583f5d.get(editor)) === null || _EDITOR_TO_SCHEDULE_F === void 0 || _EDITOR_TO_SCHEDULE_F();
    },
    blur: (editor)=>{
        var el = $7f8811f69e78b396$export$c297831efceeff81.toDOMNode(editor, editor);
        var root = $7f8811f69e78b396$export$c297831efceeff81.findDocumentOrShadowRoot(editor);
        $7f8811f69e78b396$export$6b6823d61e2d5285.set(editor, false);
        if (root.activeElement === el) el.blur();
    },
    deselect: (editor)=>{
        var { selection: selection } = editor;
        var root = $7f8811f69e78b396$export$c297831efceeff81.findDocumentOrShadowRoot(editor);
        var domSelection = $7f8811f69e78b396$export$ca798a7e6e94638c(root);
        if (domSelection && domSelection.rangeCount > 0) domSelection.removeAllRanges();
        if (selection) (0, $akZf2.Transforms).deselect(editor);
    },
    findDocumentOrShadowRoot: (editor)=>{
        var el = $7f8811f69e78b396$export$c297831efceeff81.toDOMNode(editor, editor);
        var root = el.getRootNode();
        if (root instanceof Document || root instanceof ShadowRoot) return root;
        return el.ownerDocument;
    },
    findEventRange: (editor, event)=>{
        if ("nativeEvent" in event) event = event.nativeEvent;
        var { clientX: x, clientY: y, target: target } = event;
        if (x == null || y == null) throw new Error("Cannot resolve a Slate range from a DOM event: ".concat(event));
        var node = $7f8811f69e78b396$export$c297831efceeff81.toSlateNode(editor, event.target);
        var path = $7f8811f69e78b396$export$c297831efceeff81.findPath(editor, node);
        // If the drop target is inside a void node, move it into either the
        // next or previous node, depending on which side the `x` and `y`
        // coordinates are closest to.
        if ((0, $akZf2.Element).isElement(node) && (0, $akZf2.Editor).isVoid(editor, node)) {
            var rect = target.getBoundingClientRect();
            var isPrev = editor.isInline(node) ? x - rect.left < rect.left + rect.width - x : y - rect.top < rect.top + rect.height - y;
            var edge = (0, $akZf2.Editor).point(editor, path, {
                edge: isPrev ? "start" : "end"
            });
            var point = isPrev ? (0, $akZf2.Editor).before(editor, edge) : (0, $akZf2.Editor).after(editor, edge);
            if (point) {
                var _range = (0, $akZf2.Editor).range(editor, point);
                return _range;
            }
        }
        // Else resolve a range from the caret position where the drop occured.
        var domRange;
        var { document: document1 } = $7f8811f69e78b396$export$c297831efceeff81.getWindow(editor);
        // COMPAT: In Firefox, `caretRangeFromPoint` doesn't exist. (2016/07/25)
        if (document1.caretRangeFromPoint) domRange = document1.caretRangeFromPoint(x, y);
        else {
            var position = document1.caretPositionFromPoint(x, y);
            if (position) {
                domRange = document1.createRange();
                domRange.setStart(position.offsetNode, position.offset);
                domRange.setEnd(position.offsetNode, position.offset);
            }
        }
        if (!domRange) throw new Error("Cannot resolve a Slate range from a DOM event: ".concat(event));
        // Resolve a Slate range from the DOM range.
        var range = $7f8811f69e78b396$export$c297831efceeff81.toSlateRange(editor, domRange, {
            exactMatch: false,
            suppressThrow: false
        });
        return range;
    },
    findKey: (editor, node)=>{
        var key = $7f8811f69e78b396$export$aaebb0c3422a1215.get(node);
        if (!key) {
            key = new $7f8811f69e78b396$export$cd0f44441c3b7719();
            $7f8811f69e78b396$export$aaebb0c3422a1215.set(node, key);
        }
        return key;
    },
    findPath: (editor, node)=>{
        var path = [];
        var child = node;
        while(true){
            var parent = $7f8811f69e78b396$export$5fb08fb525a1cae4.get(child);
            if (parent == null) {
                if ((0, $akZf2.Editor).isEditor(child)) return path;
                else break;
            }
            var i = $7f8811f69e78b396$export$ad37d8527ff8298.get(child);
            if (i == null) break;
            path.unshift(i);
            child = parent;
        }
        throw new Error("Unable to find the path for Slate node: ".concat((0, $akZf2.Scrubber).stringify(node)));
    },
    focus: function focus(editor) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
            retries: 5
        };
        // Return if already focused
        if ($7f8811f69e78b396$export$6b6823d61e2d5285.get(editor)) return;
        // Retry setting focus if the editor has pending operations.
        // The DOM (selection) is unstable while changes are applied.
        // Retry until retries are exhausted or editor is focused.
        if (options.retries <= 0) throw new Error("Could not set focus, editor seems stuck with pending operations");
        if (editor.operations.length > 0) {
            setTimeout(()=>{
                $7f8811f69e78b396$export$c297831efceeff81.focus(editor, {
                    retries: options.retries - 1
                });
            }, 10);
            return;
        }
        var el = $7f8811f69e78b396$export$c297831efceeff81.toDOMNode(editor, editor);
        var root = $7f8811f69e78b396$export$c297831efceeff81.findDocumentOrShadowRoot(editor);
        if (root.activeElement !== el) {
            // Ensure that the DOM selection state is set to the editor's selection
            if (editor.selection && root instanceof Document) {
                var domSelection = $7f8811f69e78b396$export$ca798a7e6e94638c(root);
                var domRange = $7f8811f69e78b396$export$c297831efceeff81.toDOMRange(editor, editor.selection);
                domSelection === null || domSelection === void 0 || domSelection.removeAllRanges();
                domSelection === null || domSelection === void 0 || domSelection.addRange(domRange);
            }
            // Create a new selection in the top of the document if missing
            if (!editor.selection) (0, $akZf2.Transforms).select(editor, (0, $akZf2.Editor).start(editor, []));
            // IS_FOCUSED should be set before calling el.focus() to ensure that
            // FocusedContext is updated to the correct value
            $7f8811f69e78b396$export$6b6823d61e2d5285.set(editor, true);
            el.focus({
                preventScroll: true
            });
        }
    },
    getWindow: (editor)=>{
        var window1 = $7f8811f69e78b396$export$768455e9a8854239.get(editor);
        if (!window1) throw new Error("Unable to find a host window element for this editor");
        return window1;
    },
    hasDOMNode: function hasDOMNode(editor, target) {
        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var { editable: editable = false } = options;
        var editorEl = $7f8811f69e78b396$export$c297831efceeff81.toDOMNode(editor, editor);
        var targetEl;
        // COMPAT: In Firefox, reading `target.nodeType` will throw an error if
        // target is originating from an internal "restricted" element (e.g. a
        // stepper arrow on a number input). (2018/05/04)
        // https://github.com/ianstormtaylor/slate/issues/1819
        try {
            targetEl = $7f8811f69e78b396$export$c296e2d4365c37a5(target) ? target : target.parentElement;
        } catch (err) {
            if (err instanceof Error && !err.message.includes('Permission denied to access property "nodeType"')) throw err;
        }
        if (!targetEl) return false;
        return targetEl.closest("[data-slate-editor]") === editorEl && (!editable || targetEl.isContentEditable ? true : typeof targetEl.isContentEditable === "boolean" && // isContentEditable exists only on HTMLElement, and on other nodes it will be undefined
        // this is the core logic that lets you know you got the right editor.selection instead of null when editor is contenteditable="false"(readOnly)
        targetEl.closest('[contenteditable="false"]') === editorEl || !!targetEl.getAttribute("data-slate-zero-width"));
    },
    hasEditableTarget: (editor, target)=>$7f8811f69e78b396$export$b8eb4d3b76e486c2(target) && $7f8811f69e78b396$export$c297831efceeff81.hasDOMNode(editor, target, {
            editable: true
        }),
    hasRange: (editor, range)=>{
        var { anchor: anchor, focus: focus } = range;
        return (0, $akZf2.Editor).hasPath(editor, anchor.path) && (0, $akZf2.Editor).hasPath(editor, focus.path);
    },
    hasSelectableTarget: (editor, target)=>$7f8811f69e78b396$export$c297831efceeff81.hasEditableTarget(editor, target) || $7f8811f69e78b396$export$c297831efceeff81.isTargetInsideNonReadonlyVoid(editor, target),
    hasTarget: (editor, target)=>$7f8811f69e78b396$export$b8eb4d3b76e486c2(target) && $7f8811f69e78b396$export$c297831efceeff81.hasDOMNode(editor, target),
    insertData: (editor, data)=>{
        editor.insertData(data);
    },
    insertFragmentData: (editor, data)=>editor.insertFragmentData(data),
    insertTextData: (editor, data)=>editor.insertTextData(data),
    isComposing: (editor)=>{
        return !!$7f8811f69e78b396$export$775832fe60c7ce3a.get(editor);
    },
    isFocused: (editor)=>!!$7f8811f69e78b396$export$6b6823d61e2d5285.get(editor),
    isReadOnly: (editor)=>!!$7f8811f69e78b396$export$e0ce804510945358.get(editor),
    isTargetInsideNonReadonlyVoid: (editor, target)=>{
        if ($7f8811f69e78b396$export$e0ce804510945358.get(editor)) return false;
        var slateNode = $7f8811f69e78b396$export$c297831efceeff81.hasTarget(editor, target) && $7f8811f69e78b396$export$c297831efceeff81.toSlateNode(editor, target);
        return (0, $akZf2.Element).isElement(slateNode) && (0, $akZf2.Editor).isVoid(editor, slateNode);
    },
    setFragmentData: (editor, data, originEvent)=>editor.setFragmentData(data, originEvent),
    toDOMNode: (editor, node)=>{
        var KEY_TO_ELEMENT = $7f8811f69e78b396$export$c5006f1f28dfee1d.get(editor);
        var domNode = (0, $akZf2.Editor).isEditor(node) ? $7f8811f69e78b396$export$75a4d6a7d5533237.get(editor) : KEY_TO_ELEMENT === null || KEY_TO_ELEMENT === void 0 ? void 0 : KEY_TO_ELEMENT.get($7f8811f69e78b396$export$c297831efceeff81.findKey(editor, node));
        if (!domNode) throw new Error("Cannot resolve a DOM node from Slate node: ".concat((0, $akZf2.Scrubber).stringify(node)));
        return domNode;
    },
    toDOMPoint: (editor, point)=>{
        var [node] = (0, $akZf2.Editor).node(editor, point.path);
        var el = $7f8811f69e78b396$export$c297831efceeff81.toDOMNode(editor, node);
        var domPoint;
        // If we're inside a void node, force the offset to 0, otherwise the zero
        // width spacing character will result in an incorrect offset of 1
        if ((0, $akZf2.Editor).void(editor, {
            at: point
        })) point = {
            path: point.path,
            offset: 0
        };
        // For each leaf, we need to isolate its content, which means filtering
        // to its direct text and zero-width spans. (We have to filter out any
        // other siblings that may have been rendered alongside them.)
        var selector = "[data-slate-string], [data-slate-zero-width]";
        var texts = Array.from(el.querySelectorAll(selector));
        var start = 0;
        for(var i = 0; i < texts.length; i++){
            var text = texts[i];
            var domNode = text.childNodes[0];
            if (domNode == null || domNode.textContent == null) continue;
            var { length: length } = domNode.textContent;
            var attr = text.getAttribute("data-slate-length");
            var trueLength = attr == null ? length : parseInt(attr, 10);
            var end = start + trueLength;
            // Prefer putting the selection inside the mark placeholder to ensure
            // composed text is displayed with the correct marks.
            var nextText = texts[i + 1];
            if (point.offset === end && nextText !== null && nextText !== void 0 && nextText.hasAttribute("data-slate-mark-placeholder")) {
                var _nextText$textContent;
                var domText = nextText.childNodes[0];
                domPoint = [
                    // COMPAT: If we don't explicity set the dom point to be on the actual
                    // dom text element, chrome will put the selection behind the actual dom
                    // text element, causing domRange.getBoundingClientRect() calls on a collapsed
                    // selection to return incorrect zero values (https://bugs.chromium.org/p/chromium/issues/detail?id=435438)
                    // which will cause issues when scrolling to it.
                    domText instanceof $7f8811f69e78b396$export$4de5d8b895f417b5 ? domText : nextText,
                    (_nextText$textContent = nextText.textContent) !== null && _nextText$textContent !== void 0 && _nextText$textContent.startsWith("\uFEFF") ? 1 : 0
                ];
                break;
            }
            if (point.offset <= end) {
                var offset = Math.min(length, Math.max(0, point.offset - start));
                domPoint = [
                    domNode,
                    offset
                ];
                break;
            }
            start = end;
        }
        if (!domPoint) throw new Error("Cannot resolve a DOM point from Slate point: ".concat((0, $akZf2.Scrubber).stringify(point)));
        return domPoint;
    },
    toDOMRange: (editor, range)=>{
        var { anchor: anchor, focus: focus } = range;
        var isBackward = (0, $akZf2.Range).isBackward(range);
        var domAnchor = $7f8811f69e78b396$export$c297831efceeff81.toDOMPoint(editor, anchor);
        var domFocus = (0, $akZf2.Range).isCollapsed(range) ? domAnchor : $7f8811f69e78b396$export$c297831efceeff81.toDOMPoint(editor, focus);
        var window1 = $7f8811f69e78b396$export$c297831efceeff81.getWindow(editor);
        var domRange = window1.document.createRange();
        var [startNode, startOffset] = isBackward ? domFocus : domAnchor;
        var [endNode, endOffset] = isBackward ? domAnchor : domFocus;
        // A slate Point at zero-width Leaf always has an offset of 0 but a native DOM selection at
        // zero-width node has an offset of 1 so we have to check if we are in a zero-width node and
        // adjust the offset accordingly.
        var startEl = $7f8811f69e78b396$export$c296e2d4365c37a5(startNode) ? startNode : startNode.parentElement;
        var isStartAtZeroWidth = !!startEl.getAttribute("data-slate-zero-width");
        var endEl = $7f8811f69e78b396$export$c296e2d4365c37a5(endNode) ? endNode : endNode.parentElement;
        var isEndAtZeroWidth = !!endEl.getAttribute("data-slate-zero-width");
        domRange.setStart(startNode, isStartAtZeroWidth ? 1 : startOffset);
        domRange.setEnd(endNode, isEndAtZeroWidth ? 1 : endOffset);
        return domRange;
    },
    toSlateNode: (editor, domNode)=>{
        var domEl = $7f8811f69e78b396$export$c296e2d4365c37a5(domNode) ? domNode : domNode.parentElement;
        if (domEl && !domEl.hasAttribute("data-slate-node")) domEl = domEl.closest("[data-slate-node]");
        var node = domEl ? $7f8811f69e78b396$export$68c25f314154811b.get(domEl) : null;
        if (!node) throw new Error("Cannot resolve a Slate node from DOM node: ".concat(domEl));
        return node;
    },
    toSlatePoint: (editor, domPoint, options)=>{
        var { exactMatch: exactMatch, suppressThrow: suppressThrow, searchDirection: searchDirection = "backward" } = options;
        var [nearestNode, nearestOffset] = exactMatch ? domPoint : $7f8811f69e78b396$export$c4a53afe769889a0(domPoint);
        var parentNode = nearestNode.parentNode;
        var textNode = null;
        var offset = 0;
        if (parentNode) {
            var _domNode$textContent, _domNode$textContent2;
            var editorEl = $7f8811f69e78b396$export$c297831efceeff81.toDOMNode(editor, editor);
            var potentialVoidNode = parentNode.closest('[data-slate-void="true"]');
            // Need to ensure that the closest void node is actually a void node
            // within this editor, and not a void node within some parent editor. This can happen
            // if this editor is within a void node of another editor ("nested editors", like in
            // the "Editable Voids" example on the docs site).
            var voidNode = potentialVoidNode && editorEl.contains(potentialVoidNode) ? potentialVoidNode : null;
            var potentialNonEditableNode = parentNode.closest('[contenteditable="false"]');
            var nonEditableNode = potentialNonEditableNode && editorEl.contains(potentialNonEditableNode) ? potentialNonEditableNode : null;
            var leafNode = parentNode.closest("[data-slate-leaf]");
            var domNode = null;
            // Calculate how far into the text node the `nearestNode` is, so that we
            // can determine what the offset relative to the text node is.
            if (leafNode) {
                textNode = leafNode.closest('[data-slate-node="text"]');
                if (textNode) {
                    var window1 = $7f8811f69e78b396$export$c297831efceeff81.getWindow(editor);
                    var range = window1.document.createRange();
                    range.setStart(textNode, 0);
                    range.setEnd(nearestNode, nearestOffset);
                    var contents = range.cloneContents();
                    var removals = [
                        ...Array.prototype.slice.call(contents.querySelectorAll("[data-slate-zero-width]")),
                        ...Array.prototype.slice.call(contents.querySelectorAll("[contenteditable=false]"))
                    ];
                    removals.forEach((el)=>{
                        // COMPAT: While composing at the start of a text node, some keyboards put
                        // the text content inside the zero width space.
                        if ($7f8811f69e78b396$export$2760ddee6a71ee7d && !exactMatch && el.hasAttribute("data-slate-zero-width") && el.textContent.length > 0 && el.textContext !== "\uFEFF") {
                            if (el.textContent.startsWith("\uFEFF")) el.textContent = el.textContent.slice(1);
                            return;
                        }
                        el.parentNode.removeChild(el);
                    });
                    // COMPAT: Edge has a bug where Range.prototype.toString() will
                    // convert \n into \r\n. The bug causes a loop when slate-dom
                    // attempts to reposition its cursor to match the native position. Use
                    // textContent.length instead.
                    // https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/10291116/
                    offset = contents.textContent.length;
                    domNode = textNode;
                }
            } else if (voidNode) {
                // For void nodes, the element with the offset key will be a cousin, not an
                // ancestor, so find it by going down from the nearest void parent and taking the
                // first one that isn't inside a nested editor.
                var leafNodes = voidNode.querySelectorAll("[data-slate-leaf]");
                for(var index = 0; index < leafNodes.length; index++){
                    var current = leafNodes[index];
                    if ($7f8811f69e78b396$export$c297831efceeff81.hasDOMNode(editor, current)) {
                        leafNode = current;
                        break;
                    }
                }
                // COMPAT: In read-only editors the leaf is not rendered.
                if (!leafNode) offset = 1;
                else {
                    textNode = leafNode.closest('[data-slate-node="text"]');
                    domNode = leafNode;
                    offset = domNode.textContent.length;
                    domNode.querySelectorAll("[data-slate-zero-width]").forEach((el)=>{
                        offset -= el.textContent.length;
                    });
                }
            } else if (nonEditableNode) {
                // Find the edge of the nearest leaf in `searchDirection`
                var getLeafNodes = (node)=>node ? node.querySelectorAll(// Exclude leaf nodes in nested editors
                    "[data-slate-leaf]:not(:scope [data-slate-editor] [data-slate-leaf])") : [];
                var elementNode = nonEditableNode.closest('[data-slate-node="element"]');
                if (searchDirection === "forward") {
                    var _leafNodes$find;
                    var _leafNodes = [
                        ...getLeafNodes(elementNode),
                        ...getLeafNodes(elementNode === null || elementNode === void 0 ? void 0 : elementNode.nextElementSibling)
                    ];
                    leafNode = (_leafNodes$find = _leafNodes.find((leaf)=>$7f8811f69e78b396$export$e4de839670987035(nonEditableNode, leaf))) !== null && _leafNodes$find !== void 0 ? _leafNodes$find : null;
                } else {
                    var _leafNodes2$findLast;
                    var _leafNodes2 = [
                        ...getLeafNodes(elementNode === null || elementNode === void 0 ? void 0 : elementNode.previousElementSibling),
                        ...getLeafNodes(elementNode)
                    ];
                    leafNode = (_leafNodes2$findLast = _leafNodes2.findLast((leaf)=>$7f8811f69e78b396$export$5c007e10c6929c95(nonEditableNode, leaf))) !== null && _leafNodes2$findLast !== void 0 ? _leafNodes2$findLast : null;
                }
                if (leafNode) {
                    textNode = leafNode.closest('[data-slate-node="text"]');
                    domNode = leafNode;
                    if (searchDirection === "forward") offset = 0;
                    else {
                        offset = domNode.textContent.length;
                        domNode.querySelectorAll("[data-slate-zero-width]").forEach((el)=>{
                            offset -= el.textContent.length;
                        });
                    }
                }
            }
            if (domNode && offset === domNode.textContent.length && // COMPAT: Android IMEs might remove the zero width space while composing,
            // and we don't add it for line-breaks.
            $7f8811f69e78b396$export$2760ddee6a71ee7d && domNode.getAttribute("data-slate-zero-width") === "z" && (_domNode$textContent = domNode.textContent) !== null && _domNode$textContent !== void 0 && _domNode$textContent.startsWith("\uFEFF") && // COMPAT: If the parent node is a Slate zero-width space, editor is
            // because the text node should have no characters. However, during IME
            // composition the ASCII characters will be prepended to the zero-width
            // space, so subtract 1 from the offset to account for the zero-width
            // space character.
            (parentNode.hasAttribute("data-slate-zero-width") || // COMPAT: In Firefox, `range.cloneContents()` returns an extra trailing '\n'
            // when the document ends with a new-line character. This results in the offset
            // length being off by one, so we need to subtract one to account for this.
            $7f8811f69e78b396$export$fa35291248be714f && (_domNode$textContent2 = domNode.textContent) !== null && _domNode$textContent2 !== void 0 && _domNode$textContent2.endsWith("\n\n"))) offset--;
        }
        if ($7f8811f69e78b396$export$2760ddee6a71ee7d && !textNode && !exactMatch) {
            var node = parentNode.hasAttribute("data-slate-node") ? parentNode : parentNode.closest("[data-slate-node]");
            if (node && $7f8811f69e78b396$export$c297831efceeff81.hasDOMNode(editor, node, {
                editable: true
            })) {
                var _slateNode = $7f8811f69e78b396$export$c297831efceeff81.toSlateNode(editor, node);
                var { path: _path, offset: _offset } = (0, $akZf2.Editor).start(editor, $7f8811f69e78b396$export$c297831efceeff81.findPath(editor, _slateNode));
                if (!node.querySelector("[data-slate-leaf]")) _offset = nearestOffset;
                return {
                    path: _path,
                    offset: _offset
                };
            }
        }
        if (!textNode) {
            if (suppressThrow) return null;
            throw new Error("Cannot resolve a Slate point from DOM point: ".concat(domPoint));
        }
        // COMPAT: If someone is clicking from one Slate editor into another,
        // the select event fires twice, once for the old editor's `element`
        // first, and then afterwards for the correct `element`. (2017/03/03)
        var slateNode = $7f8811f69e78b396$export$c297831efceeff81.toSlateNode(editor, textNode);
        var path = $7f8811f69e78b396$export$c297831efceeff81.findPath(editor, slateNode);
        return {
            path: path,
            offset: offset
        };
    },
    toSlateRange: (editor, domRange, options)=>{
        var _focusNode$textConten;
        var { exactMatch: exactMatch, suppressThrow: suppressThrow } = options;
        var el = $7f8811f69e78b396$export$e2bc0f5f415c8287(domRange) ? domRange.anchorNode : domRange.startContainer;
        var anchorNode;
        var anchorOffset;
        var focusNode;
        var focusOffset;
        var isCollapsed;
        if (el) {
            if ($7f8811f69e78b396$export$e2bc0f5f415c8287(domRange)) {
                // COMPAT: In firefox the normal seletion way does not work
                // (https://github.com/ianstormtaylor/slate/pull/5486#issue-1820720223)
                if ($7f8811f69e78b396$export$fa35291248be714f && domRange.rangeCount > 1) {
                    focusNode = domRange.focusNode; // Focus node works fine
                    var firstRange = domRange.getRangeAt(0);
                    var lastRange = domRange.getRangeAt(domRange.rangeCount - 1);
                    // Here we are in the contenteditable mode of a table in firefox
                    if (focusNode instanceof HTMLTableRowElement && firstRange.startContainer instanceof HTMLTableRowElement && lastRange.startContainer instanceof HTMLTableRowElement) {
                        // HTMLElement, becouse Element is a slate element
                        function getLastChildren(element) {
                            if (element.childElementCount > 0) return getLastChildren(element.children[0]);
                            else return element;
                        }
                        var firstNodeRow = firstRange.startContainer;
                        var lastNodeRow = lastRange.startContainer;
                        // This should never fail as "The HTMLElement interface represents any HTML element."
                        var firstNode = getLastChildren(firstNodeRow.children[firstRange.startOffset]);
                        var lastNode = getLastChildren(lastNodeRow.children[lastRange.startOffset]);
                        // Zero, as we allways take the right one as the anchor point
                        focusOffset = 0;
                        if (lastNode.childNodes.length > 0) anchorNode = lastNode.childNodes[0];
                        else anchorNode = lastNode;
                        if (firstNode.childNodes.length > 0) focusNode = firstNode.childNodes[0];
                        else focusNode = firstNode;
                        if (lastNode instanceof HTMLElement) anchorOffset = lastNode.innerHTML.length;
                        else // Fallback option
                        anchorOffset = 0;
                    } else // This is the read only mode of a firefox table
                    // Right to left
                    if (firstRange.startContainer === focusNode) {
                        anchorNode = lastRange.endContainer;
                        anchorOffset = lastRange.endOffset;
                        focusOffset = firstRange.startOffset;
                    } else {
                        // Left to right
                        anchorNode = firstRange.startContainer;
                        anchorOffset = firstRange.endOffset;
                        focusOffset = lastRange.startOffset;
                    }
                } else {
                    anchorNode = domRange.anchorNode;
                    anchorOffset = domRange.anchorOffset;
                    focusNode = domRange.focusNode;
                    focusOffset = domRange.focusOffset;
                }
                // COMPAT: There's a bug in chrome that always returns `true` for
                // `isCollapsed` for a Selection that comes from a ShadowRoot.
                // (2020/08/08)
                // https://bugs.chromium.org/p/chromium/issues/detail?id=447523
                // IsCollapsed might not work in firefox, but this will
                if ($7f8811f69e78b396$export$265e05392e08df49 && $7f8811f69e78b396$export$e4bead7f22725bce(anchorNode) || $7f8811f69e78b396$export$fa35291248be714f) isCollapsed = domRange.anchorNode === domRange.focusNode && domRange.anchorOffset === domRange.focusOffset;
                else isCollapsed = domRange.isCollapsed;
            } else {
                anchorNode = domRange.startContainer;
                anchorOffset = domRange.startOffset;
                focusNode = domRange.endContainer;
                focusOffset = domRange.endOffset;
                isCollapsed = domRange.collapsed;
            }
        }
        if (anchorNode == null || focusNode == null || anchorOffset == null || focusOffset == null) throw new Error("Cannot resolve a Slate range from DOM range: ".concat(domRange));
        // COMPAT: Firefox sometimes includes an extra \n (rendered by TextString
        // when isTrailing is true) in the focusOffset, resulting in an invalid
        // Slate point. (2023/11/01)
        if ($7f8811f69e78b396$export$fa35291248be714f && (_focusNode$textConten = focusNode.textContent) !== null && _focusNode$textConten !== void 0 && _focusNode$textConten.endsWith("\n\n") && focusOffset === focusNode.textContent.length) focusOffset--;
        var anchor = $7f8811f69e78b396$export$c297831efceeff81.toSlatePoint(editor, [
            anchorNode,
            anchorOffset
        ], {
            exactMatch: exactMatch,
            suppressThrow: suppressThrow
        });
        if (!anchor) return null;
        var focusBeforeAnchor = $7f8811f69e78b396$export$5c007e10c6929c95(anchorNode, focusNode) || anchorNode === focusNode && focusOffset < anchorOffset;
        var focus = isCollapsed ? anchor : $7f8811f69e78b396$export$c297831efceeff81.toSlatePoint(editor, [
            focusNode,
            focusOffset
        ], {
            exactMatch: exactMatch,
            suppressThrow: suppressThrow,
            searchDirection: focusBeforeAnchor ? "forward" : "backward"
        });
        if (!focus) return null;
        var range = {
            anchor: anchor,
            focus: focus
        };
        // if the selection is a hanging range that ends in a void
        // and the DOM focus is an Element
        // (meaning that the selection ends before the element)
        // unhang the range to avoid mistakenly including the void
        if ((0, $akZf2.Range).isExpanded(range) && (0, $akZf2.Range).isForward(range) && $7f8811f69e78b396$export$c296e2d4365c37a5(focusNode) && (0, $akZf2.Editor).void(editor, {
            at: range.focus,
            mode: "highest"
        })) range = (0, $akZf2.Editor).unhangRange(editor, range, {
            voids: true
        });
        return range;
    }
};
/**
 * Check whether a text diff was applied in a way we can perform the pending action on /
 * recover the pending selection.
 */ function $7f8811f69e78b396$export$742d614dde193cc2(editor, textDiff) {
    var { path: path, diff: diff } = textDiff;
    if (!(0, $akZf2.Editor).hasPath(editor, path)) return false;
    var node = (0, $akZf2.Node).get(editor, path);
    if (!(0, $akZf2.Text).isText(node)) return false;
    if (diff.start !== node.text.length || diff.text.length === 0) return node.text.slice(diff.start, diff.start + diff.text.length) === diff.text;
    var nextPath = (0, $akZf2.Path).next(path);
    if (!(0, $akZf2.Editor).hasPath(editor, nextPath)) return false;
    var nextNode = (0, $akZf2.Node).get(editor, nextPath);
    return (0, $akZf2.Text).isText(nextNode) && nextNode.text.startsWith(diff.text);
}
function $7f8811f69e78b396$export$c79c04494e753239(text) {
    for(var _len = arguments.length, diffs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)diffs[_key - 1] = arguments[_key];
    return diffs.reduce((text, diff)=>text.slice(0, diff.start) + diff.text + text.slice(diff.end), text);
}
function $7f8811f69e78b396$var$longestCommonPrefixLength(str, another) {
    var length = Math.min(str.length, another.length);
    for(var i = 0; i < length; i++){
        if (str.charAt(i) !== another.charAt(i)) return i;
    }
    return length;
}
function $7f8811f69e78b396$var$longestCommonSuffixLength(str, another, max) {
    var length = Math.min(str.length, another.length, max);
    for(var i = 0; i < length; i++){
        if (str.charAt(str.length - i - 1) !== another.charAt(another.length - i - 1)) return i;
    }
    return length;
}
/**
 * Remove redundant changes from the diff so that it spans the minimal possible range
 */ function $7f8811f69e78b396$export$9fa85984a86e4a3e(targetText, diff) {
    var { start: start, end: end, text: text } = diff;
    var removedText = targetText.slice(start, end);
    var prefixLength = $7f8811f69e78b396$var$longestCommonPrefixLength(removedText, text);
    var max = Math.min(removedText.length - prefixLength, text.length - prefixLength);
    var suffixLength = $7f8811f69e78b396$var$longestCommonSuffixLength(removedText, text, max);
    var normalized = {
        start: start + prefixLength,
        end: end - suffixLength,
        text: text.slice(prefixLength, text.length - suffixLength)
    };
    if (normalized.start === normalized.end && normalized.text.length === 0) return null;
    return normalized;
}
/**
 * Return a string diff that is equivalent to applying b after a spanning the range of
 * both changes
 */ function $7f8811f69e78b396$export$624495bf472ee903(targetText, a, b) {
    var start = Math.min(a.start, b.start);
    var overlap = Math.max(0, Math.min(a.start + a.text.length, b.end) - b.start);
    var applied = $7f8811f69e78b396$export$c79c04494e753239(targetText, a, b);
    var sliceEnd = Math.max(b.start + b.text.length, a.start + a.text.length + (a.start + a.text.length > b.start ? b.text.length : 0) - overlap);
    var text = applied.slice(start, sliceEnd);
    var end = Math.max(a.end, b.end - a.text.length + (a.end - a.start));
    return $7f8811f69e78b396$export$9fa85984a86e4a3e(targetText, {
        start: start,
        end: end,
        text: text
    });
}
/**
 * Get the slate range the text diff spans.
 */ function $7f8811f69e78b396$export$5203edf5b0645097(textDiff) {
    var { path: path, diff: diff } = textDiff;
    return {
        anchor: {
            path: path,
            offset: diff.start
        },
        focus: {
            path: path,
            offset: diff.end
        }
    };
}
/**
 * Normalize a 'pending point' a.k.a a point based on the dom state before applying
 * the pending diffs. Since the pending diffs might have been inserted with different
 * marks we have to 'walk' the offset from the starting position to ensure we still
 * have a valid point inside the document
 */ function $7f8811f69e78b396$export$9184b12b6269bcdd(editor, point) {
    var { path: path, offset: offset } = point;
    if (!(0, $akZf2.Editor).hasPath(editor, path)) return null;
    var leaf = (0, $akZf2.Node).get(editor, path);
    if (!(0, $akZf2.Text).isText(leaf)) return null;
    var parentBlock = (0, $akZf2.Editor).above(editor, {
        match: (n)=>(0, $akZf2.Element).isElement(n) && (0, $akZf2.Editor).isBlock(editor, n),
        at: path
    });
    if (!parentBlock) return null;
    while(offset > leaf.text.length){
        var entry = (0, $akZf2.Editor).next(editor, {
            at: path,
            match: (0, $akZf2.Text).isText
        });
        if (!entry || !(0, $akZf2.Path).isDescendant(entry[1], parentBlock[1])) return null;
        offset -= leaf.text.length;
        leaf = entry[0];
        path = entry[1];
    }
    return {
        path: path,
        offset: offset
    };
}
/**
 * Normalize a 'pending selection' to ensure it's valid in the current document state.
 */ function $7f8811f69e78b396$export$769559576d90a89c(editor, range) {
    var anchor = $7f8811f69e78b396$export$9184b12b6269bcdd(editor, range.anchor);
    if (!anchor) return null;
    if ((0, $akZf2.Range).isCollapsed(range)) return {
        anchor: anchor,
        focus: anchor
    };
    var focus = $7f8811f69e78b396$export$9184b12b6269bcdd(editor, range.focus);
    if (!focus) return null;
    return {
        anchor: anchor,
        focus: focus
    };
}
function $7f8811f69e78b396$var$transformPendingPoint(editor, point, op) {
    var pendingDiffs = $7f8811f69e78b396$export$58e2f29bf18516fe.get(editor);
    var textDiff = pendingDiffs === null || pendingDiffs === void 0 ? void 0 : pendingDiffs.find((_ref)=>{
        var { path: path } = _ref;
        return (0, $akZf2.Path).equals(path, point.path);
    });
    if (!textDiff || point.offset <= textDiff.diff.start) return (0, $akZf2.Point).transform(point, op, {
        affinity: "backward"
    });
    var { diff: diff } = textDiff;
    // Point references location inside the diff => transform the point based on the location
    // the diff will be applied to and add the offset inside the diff.
    if (point.offset <= diff.start + diff.text.length) {
        var _anchor = {
            path: point.path,
            offset: diff.start
        };
        var _transformed = (0, $akZf2.Point).transform(_anchor, op, {
            affinity: "backward"
        });
        if (!_transformed) return null;
        return {
            path: _transformed.path,
            offset: _transformed.offset + point.offset - diff.start
        };
    }
    // Point references location after the diff
    var anchor = {
        path: point.path,
        offset: point.offset - diff.text.length + diff.end - diff.start
    };
    var transformed = (0, $akZf2.Point).transform(anchor, op, {
        affinity: "backward"
    });
    if (!transformed) return null;
    if (op.type === "split_node" && (0, $akZf2.Path).equals(op.path, point.path) && anchor.offset < op.position && diff.start < op.position) return transformed;
    return {
        path: transformed.path,
        offset: transformed.offset + diff.text.length - diff.end + diff.start
    };
}
function $7f8811f69e78b396$var$transformPendingRange(editor, range, op) {
    var anchor = $7f8811f69e78b396$var$transformPendingPoint(editor, range.anchor, op);
    if (!anchor) return null;
    if ((0, $akZf2.Range).isCollapsed(range)) return {
        anchor: anchor,
        focus: anchor
    };
    var focus = $7f8811f69e78b396$var$transformPendingPoint(editor, range.focus, op);
    if (!focus) return null;
    return {
        anchor: anchor,
        focus: focus
    };
}
function $7f8811f69e78b396$var$transformTextDiff(textDiff, op) {
    var { path: path, diff: diff, id: id } = textDiff;
    switch(op.type){
        case "insert_text":
            if (!(0, $akZf2.Path).equals(op.path, path) || op.offset >= diff.end) return textDiff;
            if (op.offset <= diff.start) return {
                diff: {
                    start: op.text.length + diff.start,
                    end: op.text.length + diff.end,
                    text: diff.text
                },
                id: id,
                path: path
            };
            return {
                diff: {
                    start: diff.start,
                    end: diff.end + op.text.length,
                    text: diff.text
                },
                id: id,
                path: path
            };
        case "remove_text":
            if (!(0, $akZf2.Path).equals(op.path, path) || op.offset >= diff.end) return textDiff;
            if (op.offset + op.text.length <= diff.start) return {
                diff: {
                    start: diff.start - op.text.length,
                    end: diff.end - op.text.length,
                    text: diff.text
                },
                id: id,
                path: path
            };
            return {
                diff: {
                    start: diff.start,
                    end: diff.end - op.text.length,
                    text: diff.text
                },
                id: id,
                path: path
            };
        case "split_node":
            if (!(0, $akZf2.Path).equals(op.path, path) || op.position >= diff.end) return {
                diff: diff,
                id: id,
                path: (0, $akZf2.Path).transform(path, op, {
                    affinity: "backward"
                })
            };
            if (op.position > diff.start) return {
                diff: {
                    start: diff.start,
                    end: Math.min(op.position, diff.end),
                    text: diff.text
                },
                id: id,
                path: path
            };
            return {
                diff: {
                    start: diff.start - op.position,
                    end: diff.end - op.position,
                    text: diff.text
                },
                id: id,
                path: (0, $akZf2.Path).transform(path, op, {
                    affinity: "forward"
                })
            };
        case "merge_node":
            if (!(0, $akZf2.Path).equals(op.path, path)) return {
                diff: diff,
                id: id,
                path: (0, $akZf2.Path).transform(path, op)
            };
            return {
                diff: {
                    start: diff.start + op.position,
                    end: diff.end + op.position,
                    text: diff.text
                },
                id: id,
                path: (0, $akZf2.Path).transform(path, op)
            };
    }
    var newPath = (0, $akZf2.Path).transform(path, op);
    if (!newPath) return null;
    return {
        diff: diff,
        path: newPath,
        id: id
    };
}
/**
 * Utilities for single-line deletion
 */ var $7f8811f69e78b396$var$doRectsIntersect = (rect, compareRect)=>{
    var middle = (compareRect.top + compareRect.bottom) / 2;
    return rect.top <= middle && rect.bottom >= middle;
};
var $7f8811f69e78b396$var$areRangesSameLine = (editor, range1, range2)=>{
    var rect1 = $7f8811f69e78b396$export$c297831efceeff81.toDOMRange(editor, range1).getBoundingClientRect();
    var rect2 = $7f8811f69e78b396$export$c297831efceeff81.toDOMRange(editor, range2).getBoundingClientRect();
    return $7f8811f69e78b396$var$doRectsIntersect(rect1, rect2) && $7f8811f69e78b396$var$doRectsIntersect(rect2, rect1);
};
/**
 * A helper utility that returns the end portion of a `Range`
 * which is located on a single line.
 *
 * @param {Editor} editor The editor object to compare against
 * @param {Range} parentRange The parent range to compare against
 * @returns {Range} A valid portion of the parentRange which is one a single line
 */ var $7f8811f69e78b396$var$findCurrentLineRange = (editor, parentRange)=>{
    var parentRangeBoundary = (0, $akZf2.Editor).range(editor, (0, $akZf2.Range).end(parentRange));
    var positions = Array.from((0, $akZf2.Editor).positions(editor, {
        at: parentRange
    }));
    var left = 0;
    var right = positions.length;
    var middle = Math.floor(right / 2);
    if ($7f8811f69e78b396$var$areRangesSameLine(editor, (0, $akZf2.Editor).range(editor, positions[left]), parentRangeBoundary)) return (0, $akZf2.Editor).range(editor, positions[left], parentRangeBoundary);
    if (positions.length < 2) return (0, $akZf2.Editor).range(editor, positions[positions.length - 1], parentRangeBoundary);
    while(middle !== positions.length && middle !== left){
        if ($7f8811f69e78b396$var$areRangesSameLine(editor, (0, $akZf2.Editor).range(editor, positions[middle]), parentRangeBoundary)) right = middle;
        else left = middle;
        middle = Math.floor((left + right) / 2);
    }
    return (0, $akZf2.Editor).range(editor, positions[right], parentRangeBoundary);
};
function $7f8811f69e78b396$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $7f8811f69e78b396$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $7f8811f69e78b396$var$ownKeys(Object(t), !0).forEach(function(r) {
            $7f8811f69e78b396$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $7f8811f69e78b396$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * `withDOM` adds DOM specific behaviors to the editor.
 *
 * If you are using TypeScript, you must extend Slate's CustomTypes to use
 * this plugin.
 *
 * See https://docs.slatejs.org/concepts/11-typescript to learn how.
 */ var $7f8811f69e78b396$export$13156d13f3e996d2 = function withDOM(editor) {
    var clipboardFormatKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "x-slate-fragment";
    var e = editor;
    var { apply: apply, onChange: onChange, deleteBackward: deleteBackward, addMark: addMark, removeMark: removeMark } = e;
    // The WeakMap which maps a key to a specific HTMLElement must be scoped to the editor instance to
    // avoid collisions between editors in the DOM that share the same value.
    $7f8811f69e78b396$export$c5006f1f28dfee1d.set(e, new WeakMap());
    e.addMark = (key, value)=>{
        var _EDITOR_TO_SCHEDULE_F, _EDITOR_TO_PENDING_DI;
        (_EDITOR_TO_SCHEDULE_F = $7f8811f69e78b396$export$65bceb8dab583f5d.get(e)) === null || _EDITOR_TO_SCHEDULE_F === void 0 || _EDITOR_TO_SCHEDULE_F();
        if (!$7f8811f69e78b396$export$33a2b5790e995f59.get(e) && (_EDITOR_TO_PENDING_DI = $7f8811f69e78b396$export$58e2f29bf18516fe.get(e)) !== null && _EDITOR_TO_PENDING_DI !== void 0 && _EDITOR_TO_PENDING_DI.length) // Ensure the current pending diffs originating from changes before the addMark
        // are applied with the current formatting
        $7f8811f69e78b396$export$33a2b5790e995f59.set(e, null);
        $7f8811f69e78b396$export$70fe56ef2d7c7d65.delete(e);
        addMark(key, value);
    };
    e.removeMark = (key)=>{
        var _EDITOR_TO_PENDING_DI2;
        if (!$7f8811f69e78b396$export$33a2b5790e995f59.get(e) && (_EDITOR_TO_PENDING_DI2 = $7f8811f69e78b396$export$58e2f29bf18516fe.get(e)) !== null && _EDITOR_TO_PENDING_DI2 !== void 0 && _EDITOR_TO_PENDING_DI2.length) // Ensure the current pending diffs originating from changes before the addMark
        // are applied with the current formatting
        $7f8811f69e78b396$export$33a2b5790e995f59.set(e, null);
        $7f8811f69e78b396$export$70fe56ef2d7c7d65.delete(e);
        removeMark(key);
    };
    e.deleteBackward = (unit)=>{
        if (unit !== "line") return deleteBackward(unit);
        if (e.selection && (0, $akZf2.Range).isCollapsed(e.selection)) {
            var parentBlockEntry = (0, $akZf2.Editor).above(e, {
                match: (n)=>(0, $akZf2.Element).isElement(n) && (0, $akZf2.Editor).isBlock(e, n),
                at: e.selection
            });
            if (parentBlockEntry) {
                var [, parentBlockPath] = parentBlockEntry;
                var parentElementRange = (0, $akZf2.Editor).range(e, parentBlockPath, e.selection.anchor);
                var currentLineRange = $7f8811f69e78b396$var$findCurrentLineRange(e, parentElementRange);
                if (!(0, $akZf2.Range).isCollapsed(currentLineRange)) (0, $akZf2.Transforms).delete(e, {
                    at: currentLineRange
                });
            }
        }
    };
    // This attempts to reset the NODE_TO_KEY entry to the correct value
    // as apply() changes the object reference and hence invalidates the NODE_TO_KEY entry
    e.apply = (op)=>{
        var matches = [];
        var pathRefMatches = [];
        var pendingDiffs = $7f8811f69e78b396$export$58e2f29bf18516fe.get(e);
        if (pendingDiffs !== null && pendingDiffs !== void 0 && pendingDiffs.length) {
            var transformed = pendingDiffs.map((textDiff)=>$7f8811f69e78b396$var$transformTextDiff(textDiff, op)).filter(Boolean);
            $7f8811f69e78b396$export$58e2f29bf18516fe.set(e, transformed);
        }
        var pendingSelection = $7f8811f69e78b396$export$e1514adea009c29d.get(e);
        if (pendingSelection) $7f8811f69e78b396$export$e1514adea009c29d.set(e, $7f8811f69e78b396$var$transformPendingRange(e, pendingSelection, op));
        var pendingAction = $7f8811f69e78b396$export$aac12b7391d2d38e.get(e);
        if (pendingAction !== null && pendingAction !== void 0 && pendingAction.at) {
            var at = (0, $akZf2.Point).isPoint(pendingAction === null || pendingAction === void 0 ? void 0 : pendingAction.at) ? $7f8811f69e78b396$var$transformPendingPoint(e, pendingAction.at, op) : $7f8811f69e78b396$var$transformPendingRange(e, pendingAction.at, op);
            $7f8811f69e78b396$export$aac12b7391d2d38e.set(e, at ? $7f8811f69e78b396$var$_objectSpread($7f8811f69e78b396$var$_objectSpread({}, pendingAction), {}, {
                at: at
            }) : null);
        }
        switch(op.type){
            case "insert_text":
            case "remove_text":
            case "set_node":
            case "split_node":
                matches.push(...$7f8811f69e78b396$var$getMatches(e, op.path));
                break;
            case "set_selection":
                var _EDITOR_TO_USER_SELEC;
                // Selection was manually set, don't restore the user selection after the change.
                (_EDITOR_TO_USER_SELEC = $7f8811f69e78b396$export$da49e689445bc1c4.get(e)) === null || _EDITOR_TO_USER_SELEC === void 0 || _EDITOR_TO_USER_SELEC.unref();
                $7f8811f69e78b396$export$da49e689445bc1c4.delete(e);
                break;
            case "insert_node":
            case "remove_node":
                matches.push(...$7f8811f69e78b396$var$getMatches(e, (0, $akZf2.Path).parent(op.path)));
                break;
            case "merge_node":
                var prevPath = (0, $akZf2.Path).previous(op.path);
                matches.push(...$7f8811f69e78b396$var$getMatches(e, prevPath));
                break;
            case "move_node":
                var commonPath = (0, $akZf2.Path).common((0, $akZf2.Path).parent(op.path), (0, $akZf2.Path).parent(op.newPath));
                matches.push(...$7f8811f69e78b396$var$getMatches(e, commonPath));
                var changedPath;
                if ((0, $akZf2.Path).isBefore(op.path, op.newPath)) {
                    matches.push(...$7f8811f69e78b396$var$getMatches(e, (0, $akZf2.Path).parent(op.path)));
                    changedPath = op.newPath;
                } else {
                    matches.push(...$7f8811f69e78b396$var$getMatches(e, (0, $akZf2.Path).parent(op.newPath)));
                    changedPath = op.path;
                }
                var changedNode = (0, $akZf2.Node).get(editor, (0, $akZf2.Path).parent(changedPath));
                var changedNodeKey = $7f8811f69e78b396$export$c297831efceeff81.findKey(e, changedNode);
                var changedPathRef = (0, $akZf2.Editor).pathRef(e, (0, $akZf2.Path).parent(changedPath));
                pathRefMatches.push([
                    changedPathRef,
                    changedNodeKey
                ]);
                break;
        }
        apply(op);
        switch(op.type){
            case "insert_node":
            case "remove_node":
            case "merge_node":
            case "move_node":
            case "split_node":
                $7f8811f69e78b396$export$a3ff80a600e5b91c.set(e, true);
        }
        for (var [path, key] of matches){
            var [node] = (0, $akZf2.Editor).node(e, path);
            $7f8811f69e78b396$export$aaebb0c3422a1215.set(node, key);
        }
        for (var [pathRef, _key] of pathRefMatches){
            if (pathRef.current) {
                var [_node] = (0, $akZf2.Editor).node(e, pathRef.current);
                $7f8811f69e78b396$export$aaebb0c3422a1215.set(_node, _key);
            }
            pathRef.unref();
        }
    };
    e.setFragmentData = (data)=>{
        var { selection: selection } = e;
        if (!selection) return;
        var [start, end] = (0, $akZf2.Range).edges(selection);
        var startVoid = (0, $akZf2.Editor).void(e, {
            at: start.path
        });
        var endVoid = (0, $akZf2.Editor).void(e, {
            at: end.path
        });
        if ((0, $akZf2.Range).isCollapsed(selection) && !startVoid) return;
        // Create a fake selection so that we can add a Base64-encoded copy of the
        // fragment to the HTML, to decode on future pastes.
        var domRange = $7f8811f69e78b396$export$c297831efceeff81.toDOMRange(e, selection);
        var contents = domRange.cloneContents();
        var attach = contents.childNodes[0];
        // Make sure attach is non-empty, since empty nodes will not get copied.
        contents.childNodes.forEach((node)=>{
            if (node.textContent && node.textContent.trim() !== "") attach = node;
        });
        // COMPAT: If the end node is a void node, we need to move the end of the
        // range from the void node's spacer span, to the end of the void node's
        // content, since the spacer is before void's content in the DOM.
        if (endVoid) {
            var [voidNode] = endVoid;
            var r = domRange.cloneRange();
            var domNode = $7f8811f69e78b396$export$c297831efceeff81.toDOMNode(e, voidNode);
            r.setEndAfter(domNode);
            contents = r.cloneContents();
        }
        // COMPAT: If the start node is a void node, we need to attach the encoded
        // fragment to the void node's content node instead of the spacer, because
        // attaching it to empty `<div>/<span>` nodes will end up having it erased by
        // most browsers. (2018/04/27)
        if (startVoid) attach = contents.querySelector("[data-slate-spacer]");
        // Remove any zero-width space spans from the cloned DOM so that they don't
        // show up elsewhere when pasted.
        Array.from(contents.querySelectorAll("[data-slate-zero-width]")).forEach((zw)=>{
            var isNewline = zw.getAttribute("data-slate-zero-width") === "n";
            zw.textContent = isNewline ? "\n" : "";
        });
        // Set a `data-slate-fragment` attribute on a non-empty node, so it shows up
        // in the HTML, and can be used for intra-Slate pasting. If it's a text
        // node, wrap it in a `<span>` so we have something to set an attribute on.
        if ($7f8811f69e78b396$var$isDOMText(attach)) {
            var span = attach.ownerDocument.createElement("span");
            // COMPAT: In Chrome and Safari, if we don't add the `white-space` style
            // then leading and trailing spaces will be ignored. (2017/09/21)
            span.style.whiteSpace = "pre";
            span.appendChild(attach);
            contents.appendChild(span);
            attach = span;
        }
        var fragment = e.getFragment();
        var string = JSON.stringify(fragment);
        var encoded = window.btoa(encodeURIComponent(string));
        attach.setAttribute("data-slate-fragment", encoded);
        data.setData("application/".concat(clipboardFormatKey), encoded);
        // Add the content to a <div> so that we can get its inner HTML.
        var div = contents.ownerDocument.createElement("div");
        div.appendChild(contents);
        div.setAttribute("hidden", "true");
        contents.ownerDocument.body.appendChild(div);
        data.setData("text/html", div.innerHTML);
        data.setData("text/plain", $7f8811f69e78b396$var$getPlainText(div));
        contents.ownerDocument.body.removeChild(div);
        return data;
    };
    e.insertData = (data)=>{
        if (!e.insertFragmentData(data)) e.insertTextData(data);
    };
    e.insertFragmentData = (data)=>{
        /**
     * Checking copied fragment from application/x-slate-fragment or data-slate-fragment
     */ var fragment = data.getData("application/".concat(clipboardFormatKey)) || $7f8811f69e78b396$var$getSlateFragmentAttribute(data);
        if (fragment) {
            var decoded = decodeURIComponent(window.atob(fragment));
            var parsed = JSON.parse(decoded);
            e.insertFragment(parsed);
            return true;
        }
        return false;
    };
    e.insertTextData = (data)=>{
        var text = data.getData("text/plain");
        if (text) {
            var lines = text.split(/\r\n|\r|\n/);
            var split = false;
            for (var line of lines){
                if (split) (0, $akZf2.Transforms).splitNodes(e, {
                    always: true
                });
                e.insertText(line);
                split = true;
            }
            return true;
        }
        return false;
    };
    e.onChange = (options)=>{
        var onContextChange = $7f8811f69e78b396$export$7762db2211c85722.get(e);
        if (onContextChange) onContextChange(options);
        onChange(options);
    };
    return e;
};
var $7f8811f69e78b396$var$getMatches = (e, path)=>{
    var matches = [];
    for (var [n, p] of (0, $akZf2.Editor).levels(e, {
        at: path
    })){
        var key = $7f8811f69e78b396$export$c297831efceeff81.findKey(e, n);
        matches.push([
            p,
            key
        ]);
    }
    return matches;
};
var $7f8811f69e78b396$export$d8adef02c0251575 = 3;
/**
 * Hotkey mappings for each platform.
 */ var $7f8811f69e78b396$var$HOTKEYS = {
    bold: "mod+b",
    compose: [
        "down",
        "left",
        "right",
        "up",
        "backspace",
        "enter"
    ],
    moveBackward: "left",
    moveForward: "right",
    moveWordBackward: "ctrl+left",
    moveWordForward: "ctrl+right",
    deleteBackward: "shift?+backspace",
    deleteForward: "shift?+delete",
    extendBackward: "shift+left",
    extendForward: "shift+right",
    italic: "mod+i",
    insertSoftBreak: "shift+enter",
    splitBlock: "enter",
    undo: "mod+z"
};
var $7f8811f69e78b396$var$APPLE_HOTKEYS = {
    moveLineBackward: "opt+up",
    moveLineForward: "opt+down",
    moveWordBackward: "opt+left",
    moveWordForward: "opt+right",
    deleteBackward: [
        "ctrl+backspace",
        "ctrl+h"
    ],
    deleteForward: [
        "ctrl+delete",
        "ctrl+d"
    ],
    deleteLineBackward: "cmd+shift?+backspace",
    deleteLineForward: [
        "cmd+shift?+delete",
        "ctrl+k"
    ],
    deleteWordBackward: "opt+shift?+backspace",
    deleteWordForward: "opt+shift?+delete",
    extendLineBackward: "opt+shift+up",
    extendLineForward: "opt+shift+down",
    redo: "cmd+shift+z",
    transposeCharacter: "ctrl+t"
};
var $7f8811f69e78b396$var$WINDOWS_HOTKEYS = {
    deleteWordBackward: "ctrl+shift?+backspace",
    deleteWordForward: "ctrl+shift?+delete",
    redo: [
        "ctrl+y",
        "ctrl+shift+z"
    ]
};
/**
 * Create a platform-aware hotkey checker.
 */ var $7f8811f69e78b396$var$create = (key)=>{
    var generic = $7f8811f69e78b396$var$HOTKEYS[key];
    var apple = $7f8811f69e78b396$var$APPLE_HOTKEYS[key];
    var windows = $7f8811f69e78b396$var$WINDOWS_HOTKEYS[key];
    var isGeneric = generic && (0, $iB3QS.isHotkey)(generic);
    var isApple = apple && (0, $iB3QS.isHotkey)(apple);
    var isWindows = windows && (0, $iB3QS.isHotkey)(windows);
    return (event)=>{
        if (isGeneric && isGeneric(event)) return true;
        if ($7f8811f69e78b396$var$IS_APPLE && isApple && isApple(event)) return true;
        if (!$7f8811f69e78b396$var$IS_APPLE && isWindows && isWindows(event)) return true;
        return false;
    };
};
/**
 * Hotkeys.
 */ var $7f8811f69e78b396$export$6f11581bd9b4598b = {
    isBold: $7f8811f69e78b396$var$create("bold"),
    isCompose: $7f8811f69e78b396$var$create("compose"),
    isMoveBackward: $7f8811f69e78b396$var$create("moveBackward"),
    isMoveForward: $7f8811f69e78b396$var$create("moveForward"),
    isDeleteBackward: $7f8811f69e78b396$var$create("deleteBackward"),
    isDeleteForward: $7f8811f69e78b396$var$create("deleteForward"),
    isDeleteLineBackward: $7f8811f69e78b396$var$create("deleteLineBackward"),
    isDeleteLineForward: $7f8811f69e78b396$var$create("deleteLineForward"),
    isDeleteWordBackward: $7f8811f69e78b396$var$create("deleteWordBackward"),
    isDeleteWordForward: $7f8811f69e78b396$var$create("deleteWordForward"),
    isExtendBackward: $7f8811f69e78b396$var$create("extendBackward"),
    isExtendForward: $7f8811f69e78b396$var$create("extendForward"),
    isExtendLineBackward: $7f8811f69e78b396$var$create("extendLineBackward"),
    isExtendLineForward: $7f8811f69e78b396$var$create("extendLineForward"),
    isItalic: $7f8811f69e78b396$var$create("italic"),
    isMoveLineBackward: $7f8811f69e78b396$var$create("moveLineBackward"),
    isMoveLineForward: $7f8811f69e78b396$var$create("moveLineForward"),
    isMoveWordBackward: $7f8811f69e78b396$var$create("moveWordBackward"),
    isMoveWordForward: $7f8811f69e78b396$var$create("moveWordForward"),
    isRedo: $7f8811f69e78b396$var$create("redo"),
    isSoftBreak: $7f8811f69e78b396$var$create("insertSoftBreak"),
    isSplitBlock: $7f8811f69e78b396$var$create("splitBlock"),
    isTransposeCharacter: $7f8811f69e78b396$var$create("transposeCharacter"),
    isUndo: $7f8811f69e78b396$var$create("undo")
};
function $7f8811f69e78b396$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $7f8811f69e78b396$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $7f8811f69e78b396$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
var $7f8811f69e78b396$var$_excluded = [
    "anchor",
    "focus"
], $7f8811f69e78b396$var$_excluded2 = [
    "anchor",
    "focus"
];
var $7f8811f69e78b396$var$shallowCompare = (obj1, obj2)=>Object.keys(obj1).length === Object.keys(obj2).length && Object.keys(obj1).every((key)=>obj2.hasOwnProperty(key) && obj1[key] === obj2[key]);
var $7f8811f69e78b396$var$isDecorationFlagsEqual = (range, other)=>{
    var rangeOwnProps = $7f8811f69e78b396$var$_objectWithoutProperties(range, $7f8811f69e78b396$var$_excluded);
    var otherOwnProps = $7f8811f69e78b396$var$_objectWithoutProperties(other, $7f8811f69e78b396$var$_excluded2);
    return range[$7f8811f69e78b396$export$9c71e74b36ebffc8] === other[$7f8811f69e78b396$export$9c71e74b36ebffc8] && $7f8811f69e78b396$var$shallowCompare(rangeOwnProps, otherOwnProps);
};
/**
 * Check if a list of decorator ranges are equal to another.
 *
 * PERF: this requires the two lists to also have the ranges inside them in the
 * same order, but this is an okay constraint for us since decorations are
 * kept in order, and the odd case where they aren't is okay to re-render for.
 */ var $7f8811f69e78b396$export$305c26ace256f1f0 = (list, another)=>{
    if (list.length !== another.length) return false;
    for(var i = 0; i < list.length; i++){
        var range = list[i];
        var other = another[i];
        if (!(0, $akZf2.Range).equals(range, other) || !$7f8811f69e78b396$var$isDecorationFlagsEqual(range, other)) return false;
    }
    return true;
};
/**
 * Check if a list of decorator ranges are equal to another.
 *
 * PERF: this requires the two lists to also have the ranges inside them in the
 * same order, but this is an okay constraint for us since decorations are
 * kept in order, and the odd case where they aren't is okay to re-render for.
 */ var $7f8811f69e78b396$export$8e95df7b6f278996 = (list, another)=>{
    if (list.length !== another.length) return false;
    for(var i = 0; i < list.length; i++){
        var range = list[i];
        var other = another[i];
        // compare only offsets because paths doesn't matter for text
        if (range.anchor.offset !== other.anchor.offset || range.focus.offset !== other.focus.offset || !$7f8811f69e78b396$var$isDecorationFlagsEqual(range, other)) return false;
    }
    return true;
};

});

parcelRegister("iRMZg", function(module, exports) {

$parcel$export(module.exports, "ResizeObserver", function () { return (parcelRequire("bkU1H")).ResizeObserver; });

var $bkU1H = parcelRequire("bkU1H");

var $8TtPB = parcelRequire("8TtPB");

var $1iuMj = parcelRequire("1iuMj");

});
parcelRegister("bkU1H", function(module, exports) {

$parcel$export(module.exports, "ResizeObserver", function () { return $840d05a8119ed802$export$9caf76241ca21a11; });

var $8ljA0 = parcelRequire("8ljA0");

var $9LXW9 = parcelRequire("9LXW9");
var $840d05a8119ed802$export$9caf76241ca21a11 = function() {
    function ResizeObserver(callback) {
        if (arguments.length === 0) throw new TypeError("Failed to construct 'ResizeObserver': 1 argument required, but only 0 present.");
        if (typeof callback !== "function") throw new TypeError("Failed to construct 'ResizeObserver': The callback provided as parameter 1 is not a function.");
        (0, $8ljA0.ResizeObserverController).connect(this, callback);
    }
    ResizeObserver.prototype.observe = function(target, options) {
        if (arguments.length === 0) throw new TypeError("Failed to execute 'observe' on 'ResizeObserver': 1 argument required, but only 0 present.");
        if (!(0, $9LXW9.isElement)(target)) throw new TypeError("Failed to execute 'observe' on 'ResizeObserver': parameter 1 is not of type 'Element");
        (0, $8ljA0.ResizeObserverController).observe(this, target, options);
    };
    ResizeObserver.prototype.unobserve = function(target) {
        if (arguments.length === 0) throw new TypeError("Failed to execute 'unobserve' on 'ResizeObserver': 1 argument required, but only 0 present.");
        if (!(0, $9LXW9.isElement)(target)) throw new TypeError("Failed to execute 'unobserve' on 'ResizeObserver': parameter 1 is not of type 'Element");
        (0, $8ljA0.ResizeObserverController).unobserve(this, target);
    };
    ResizeObserver.prototype.disconnect = function() {
        (0, $8ljA0.ResizeObserverController).disconnect(this);
    };
    ResizeObserver.toString = function() {
        return "function ResizeObserver () { [polyfill code] }";
    };
    return ResizeObserver;
}();

});
parcelRegister("8ljA0", function(module, exports) {

$parcel$export(module.exports, "ResizeObserverController", function () { return $612f7901edf89c2a$export$ed99c5bafbaf8300; });

var $a2m9W = parcelRequire("a2m9W");

var $5eFoL = parcelRequire("5eFoL");

var $jlo7L = parcelRequire("jlo7L");

var $2avI5 = parcelRequire("2avI5");
var $612f7901edf89c2a$var$observerMap = new WeakMap();
var $612f7901edf89c2a$var$getObservationIndex = function(observationTargets, target) {
    for(var i = 0; i < observationTargets.length; i += 1){
        if (observationTargets[i].target === target) return i;
    }
    return -1;
};
var $612f7901edf89c2a$export$ed99c5bafbaf8300 = function() {
    function ResizeObserverController() {}
    ResizeObserverController.connect = function(resizeObserver, callback) {
        var detail = new (0, $jlo7L.ResizeObserverDetail)(resizeObserver, callback);
        $612f7901edf89c2a$var$observerMap.set(resizeObserver, detail);
    };
    ResizeObserverController.observe = function(resizeObserver, target, options) {
        var detail = $612f7901edf89c2a$var$observerMap.get(resizeObserver);
        var firstObservation = detail.observationTargets.length === 0;
        if ($612f7901edf89c2a$var$getObservationIndex(detail.observationTargets, target) < 0) {
            firstObservation && (0, $2avI5.resizeObservers).push(detail);
            detail.observationTargets.push(new (0, $5eFoL.ResizeObservation)(target, options && options.box));
            (0, $a2m9W.updateCount)(1);
            (0, $a2m9W.scheduler).schedule();
        }
    };
    ResizeObserverController.unobserve = function(resizeObserver, target) {
        var detail = $612f7901edf89c2a$var$observerMap.get(resizeObserver);
        var index = $612f7901edf89c2a$var$getObservationIndex(detail.observationTargets, target);
        var lastObservation = detail.observationTargets.length === 1;
        if (index >= 0) {
            lastObservation && (0, $2avI5.resizeObservers).splice((0, $2avI5.resizeObservers).indexOf(detail), 1);
            detail.observationTargets.splice(index, 1);
            (0, $a2m9W.updateCount)(-1);
        }
    };
    ResizeObserverController.disconnect = function(resizeObserver) {
        var _this = this;
        var detail = $612f7901edf89c2a$var$observerMap.get(resizeObserver);
        detail.observationTargets.slice().forEach(function(ot) {
            return _this.unobserve(resizeObserver, ot.target);
        });
        detail.activeTargets.splice(0, detail.activeTargets.length);
    };
    return ResizeObserverController;
}();

});
parcelRegister("a2m9W", function(module, exports) {

$parcel$export(module.exports, "scheduler", function () { return $74eb47ae3fbca89b$export$d30788f2c20241cd; });
$parcel$export(module.exports, "updateCount", function () { return $74eb47ae3fbca89b$export$1f18a74d42722835; });

var $fgswf = parcelRequire("fgswf");

var $7cl9W = parcelRequire("7cl9W");

var $bOlvY = parcelRequire("bOlvY");
var $74eb47ae3fbca89b$var$watching = 0;
var $74eb47ae3fbca89b$var$isWatching = function() {
    return !!$74eb47ae3fbca89b$var$watching;
};
var $74eb47ae3fbca89b$var$CATCH_PERIOD = 250;
var $74eb47ae3fbca89b$var$observerConfig = {
    attributes: true,
    characterData: true,
    childList: true,
    subtree: true
};
var $74eb47ae3fbca89b$var$events = [
    "resize",
    "load",
    "transitionend",
    "animationend",
    "animationstart",
    "animationiteration",
    "keyup",
    "keydown",
    "mouseup",
    "mousedown",
    "mouseover",
    "mouseout",
    "blur",
    "focus"
];
var $74eb47ae3fbca89b$var$time = function(timeout) {
    if (timeout === void 0) timeout = 0;
    return Date.now() + timeout;
};
var $74eb47ae3fbca89b$var$scheduled = false;
var $74eb47ae3fbca89b$var$Scheduler = function() {
    function Scheduler() {
        var _this = this;
        this.stopped = true;
        this.listener = function() {
            return _this.schedule();
        };
    }
    Scheduler.prototype.run = function(timeout) {
        var _this = this;
        if (timeout === void 0) timeout = $74eb47ae3fbca89b$var$CATCH_PERIOD;
        if ($74eb47ae3fbca89b$var$scheduled) return;
        $74eb47ae3fbca89b$var$scheduled = true;
        var until = $74eb47ae3fbca89b$var$time(timeout);
        (0, $bOlvY.queueResizeObserver)(function() {
            var elementsHaveResized = false;
            try {
                elementsHaveResized = (0, $fgswf.process)();
            } finally{
                $74eb47ae3fbca89b$var$scheduled = false;
                timeout = until - $74eb47ae3fbca89b$var$time();
                if (!$74eb47ae3fbca89b$var$isWatching()) return;
                if (elementsHaveResized) _this.run(1000);
                else if (timeout > 0) _this.run(timeout);
                else _this.start();
            }
        });
    };
    Scheduler.prototype.schedule = function() {
        this.stop();
        this.run();
    };
    Scheduler.prototype.observe = function() {
        var _this = this;
        var cb = function() {
            return _this.observer && _this.observer.observe(document.body, $74eb47ae3fbca89b$var$observerConfig);
        };
        document.body ? cb() : (0, $7cl9W.global).addEventListener("DOMContentLoaded", cb);
    };
    Scheduler.prototype.start = function() {
        var _this = this;
        if (this.stopped) {
            this.stopped = false;
            this.observer = new MutationObserver(this.listener);
            this.observe();
            $74eb47ae3fbca89b$var$events.forEach(function(name) {
                return (0, $7cl9W.global).addEventListener(name, _this.listener, true);
            });
        }
    };
    Scheduler.prototype.stop = function() {
        var _this = this;
        if (!this.stopped) {
            this.observer && this.observer.disconnect();
            $74eb47ae3fbca89b$var$events.forEach(function(name) {
                return (0, $7cl9W.global).removeEventListener(name, _this.listener, true);
            });
            this.stopped = true;
        }
    };
    return Scheduler;
}();
var $74eb47ae3fbca89b$export$d30788f2c20241cd = new $74eb47ae3fbca89b$var$Scheduler();
var $74eb47ae3fbca89b$export$1f18a74d42722835 = function(n) {
    !$74eb47ae3fbca89b$var$watching && n > 0 && $74eb47ae3fbca89b$export$d30788f2c20241cd.start();
    $74eb47ae3fbca89b$var$watching += n;
    !$74eb47ae3fbca89b$var$watching && $74eb47ae3fbca89b$export$d30788f2c20241cd.stop();
};

});
parcelRegister("fgswf", function(module, exports) {

$parcel$export(module.exports, "process", function () { return $b1ce78eb48ef0c3e$export$e54fe5b0f43758f7; });

var $7ho75 = parcelRequire("7ho75");

var $d3ouV = parcelRequire("d3ouV");

var $cXRcN = parcelRequire("cXRcN");

var $inmsw = parcelRequire("inmsw");

var $jEuFD = parcelRequire("jEuFD");
var $b1ce78eb48ef0c3e$export$e54fe5b0f43758f7 = function() {
    var depth = 0;
    (0, $jEuFD.gatherActiveObservationsAtDepth)(depth);
    while((0, $7ho75.hasActiveObservations)()){
        depth = (0, $inmsw.broadcastActiveObservations)();
        (0, $jEuFD.gatherActiveObservationsAtDepth)(depth);
    }
    if ((0, $d3ouV.hasSkippedObservations)()) (0, $cXRcN.deliverResizeLoopError)();
    return depth > 0;
};

});
parcelRegister("7ho75", function(module, exports) {

$parcel$export(module.exports, "hasActiveObservations", function () { return $54ccd35bfb46ad48$export$63c81bd924f89474; });

var $2avI5 = parcelRequire("2avI5");
var $54ccd35bfb46ad48$export$63c81bd924f89474 = function() {
    return (0, $2avI5.resizeObservers).some(function(ro) {
        return ro.activeTargets.length > 0;
    });
};

});
parcelRegister("2avI5", function(module, exports) {

$parcel$export(module.exports, "resizeObservers", function () { return $19451ce642b52b92$export$402e76927ebf6a24; });
var $19451ce642b52b92$export$402e76927ebf6a24 = [];

});


parcelRegister("d3ouV", function(module, exports) {

$parcel$export(module.exports, "hasSkippedObservations", function () { return $980e8ef38b22b024$export$8ca35300535e324d; });

var $2avI5 = parcelRequire("2avI5");
var $980e8ef38b22b024$export$8ca35300535e324d = function() {
    return (0, $2avI5.resizeObservers).some(function(ro) {
        return ro.skippedTargets.length > 0;
    });
};

});

parcelRegister("cXRcN", function(module, exports) {

$parcel$export(module.exports, "deliverResizeLoopError", function () { return $9704442eea5128d7$export$888cb69481582149; });
var $9704442eea5128d7$var$msg = "ResizeObserver loop completed with undelivered notifications.";
var $9704442eea5128d7$export$888cb69481582149 = function() {
    var event;
    if (typeof ErrorEvent === "function") event = new ErrorEvent("error", {
        message: $9704442eea5128d7$var$msg
    });
    else {
        event = document.createEvent("Event");
        event.initEvent("error", false, false);
        event.message = $9704442eea5128d7$var$msg;
    }
    window.dispatchEvent(event);
};

});

parcelRegister("inmsw", function(module, exports) {

$parcel$export(module.exports, "broadcastActiveObservations", function () { return $d60bcbdbee9bab8c$export$9cac928141e5443b; });

var $2avI5 = parcelRequire("2avI5");

var $8TtPB = parcelRequire("8TtPB");

var $5HUq2 = parcelRequire("5HUq2");

var $fgYX2 = parcelRequire("fgYX2");
var $d60bcbdbee9bab8c$export$9cac928141e5443b = function() {
    var shallowestDepth = Infinity;
    var callbacks = [];
    (0, $2avI5.resizeObservers).forEach(function processObserver(ro) {
        if (ro.activeTargets.length === 0) return;
        var entries = [];
        ro.activeTargets.forEach(function processTarget(ot) {
            var entry = new (0, $8TtPB.ResizeObserverEntry)(ot.target);
            var targetDepth = (0, $5HUq2.calculateDepthForNode)(ot.target);
            entries.push(entry);
            ot.lastReportedSize = (0, $fgYX2.calculateBoxSize)(ot.target, ot.observedBox);
            if (targetDepth < shallowestDepth) shallowestDepth = targetDepth;
        });
        callbacks.push(function resizeObserverCallback() {
            ro.callback.call(ro.observer, entries, ro.observer);
        });
        ro.activeTargets.splice(0, ro.activeTargets.length);
    });
    for(var _i = 0, callbacks_1 = callbacks; _i < callbacks_1.length; _i++){
        var callback = callbacks_1[_i];
        callback();
    }
    return shallowestDepth;
};

});
parcelRegister("8TtPB", function(module, exports) {

$parcel$export(module.exports, "ResizeObserverEntry", function () { return $679a99a870bbcf3d$export$226159b441fc89f8; });

var $fgYX2 = parcelRequire("fgYX2");

var $eyoNq = parcelRequire("eyoNq");
var $679a99a870bbcf3d$export$226159b441fc89f8 = function() {
    function ResizeObserverEntry(target) {
        var boxes = (0, $fgYX2.calculateBoxSizes)(target);
        this.target = target;
        this.contentRect = boxes.contentRect;
        this.borderBoxSize = (0, $eyoNq.freeze)([
            boxes.borderBoxSize
        ]);
        this.contentBoxSize = (0, $eyoNq.freeze)([
            boxes.contentBoxSize
        ]);
        this.devicePixelContentBoxSize = (0, $eyoNq.freeze)([
            boxes.devicePixelContentBoxSize
        ]);
    }
    return ResizeObserverEntry;
}();

});
parcelRegister("fgYX2", function(module, exports) {

$parcel$export(module.exports, "calculateBoxSizes", function () { return $b1e7a146a5183a97$export$504d039a9c501c94; });
$parcel$export(module.exports, "calculateBoxSize", function () { return $b1e7a146a5183a97$export$1a78030b04106bdb; });

var $f0A1V = parcelRequire("f0A1V");

var $1iuMj = parcelRequire("1iuMj");

var $jrHyc = parcelRequire("jrHyc");

var $9LXW9 = parcelRequire("9LXW9");

var $eyoNq = parcelRequire("eyoNq");

var $7cl9W = parcelRequire("7cl9W");
var $b1e7a146a5183a97$var$cache = new WeakMap();
var $b1e7a146a5183a97$var$scrollRegexp = /auto|scroll/;
var $b1e7a146a5183a97$var$verticalRegexp = /^tb|vertical/;
var $b1e7a146a5183a97$var$IE = /msie|trident/i.test((0, $7cl9W.global).navigator && (0, $7cl9W.global).navigator.userAgent);
var $b1e7a146a5183a97$var$parseDimension = function(pixel) {
    return parseFloat(pixel || "0");
};
var $b1e7a146a5183a97$var$size = function(inlineSize, blockSize, switchSizes) {
    if (inlineSize === void 0) inlineSize = 0;
    if (blockSize === void 0) blockSize = 0;
    if (switchSizes === void 0) switchSizes = false;
    return new (0, $1iuMj.ResizeObserverSize)((switchSizes ? blockSize : inlineSize) || 0, (switchSizes ? inlineSize : blockSize) || 0);
};
var $b1e7a146a5183a97$var$zeroBoxes = (0, $eyoNq.freeze)({
    devicePixelContentBoxSize: $b1e7a146a5183a97$var$size(),
    borderBoxSize: $b1e7a146a5183a97$var$size(),
    contentBoxSize: $b1e7a146a5183a97$var$size(),
    contentRect: new (0, $jrHyc.DOMRectReadOnly)(0, 0, 0, 0)
});
var $b1e7a146a5183a97$export$504d039a9c501c94 = function(target, forceRecalculation) {
    if (forceRecalculation === void 0) forceRecalculation = false;
    if ($b1e7a146a5183a97$var$cache.has(target) && !forceRecalculation) return $b1e7a146a5183a97$var$cache.get(target);
    if ((0, $9LXW9.isHidden)(target)) {
        $b1e7a146a5183a97$var$cache.set(target, $b1e7a146a5183a97$var$zeroBoxes);
        return $b1e7a146a5183a97$var$zeroBoxes;
    }
    var cs = getComputedStyle(target);
    var svg = (0, $9LXW9.isSVG)(target) && target.ownerSVGElement && target.getBBox();
    var removePadding = !$b1e7a146a5183a97$var$IE && cs.boxSizing === "border-box";
    var switchSizes = $b1e7a146a5183a97$var$verticalRegexp.test(cs.writingMode || "");
    var canScrollVertically = !svg && $b1e7a146a5183a97$var$scrollRegexp.test(cs.overflowY || "");
    var canScrollHorizontally = !svg && $b1e7a146a5183a97$var$scrollRegexp.test(cs.overflowX || "");
    var paddingTop = svg ? 0 : $b1e7a146a5183a97$var$parseDimension(cs.paddingTop);
    var paddingRight = svg ? 0 : $b1e7a146a5183a97$var$parseDimension(cs.paddingRight);
    var paddingBottom = svg ? 0 : $b1e7a146a5183a97$var$parseDimension(cs.paddingBottom);
    var paddingLeft = svg ? 0 : $b1e7a146a5183a97$var$parseDimension(cs.paddingLeft);
    var borderTop = svg ? 0 : $b1e7a146a5183a97$var$parseDimension(cs.borderTopWidth);
    var borderRight = svg ? 0 : $b1e7a146a5183a97$var$parseDimension(cs.borderRightWidth);
    var borderBottom = svg ? 0 : $b1e7a146a5183a97$var$parseDimension(cs.borderBottomWidth);
    var borderLeft = svg ? 0 : $b1e7a146a5183a97$var$parseDimension(cs.borderLeftWidth);
    var horizontalPadding = paddingLeft + paddingRight;
    var verticalPadding = paddingTop + paddingBottom;
    var horizontalBorderArea = borderLeft + borderRight;
    var verticalBorderArea = borderTop + borderBottom;
    var horizontalScrollbarThickness = !canScrollHorizontally ? 0 : target.offsetHeight - verticalBorderArea - target.clientHeight;
    var verticalScrollbarThickness = !canScrollVertically ? 0 : target.offsetWidth - horizontalBorderArea - target.clientWidth;
    var widthReduction = removePadding ? horizontalPadding + horizontalBorderArea : 0;
    var heightReduction = removePadding ? verticalPadding + verticalBorderArea : 0;
    var contentWidth = svg ? svg.width : $b1e7a146a5183a97$var$parseDimension(cs.width) - widthReduction - verticalScrollbarThickness;
    var contentHeight = svg ? svg.height : $b1e7a146a5183a97$var$parseDimension(cs.height) - heightReduction - horizontalScrollbarThickness;
    var borderBoxWidth = contentWidth + horizontalPadding + verticalScrollbarThickness + horizontalBorderArea;
    var borderBoxHeight = contentHeight + verticalPadding + horizontalScrollbarThickness + verticalBorderArea;
    var boxes = (0, $eyoNq.freeze)({
        devicePixelContentBoxSize: $b1e7a146a5183a97$var$size(Math.round(contentWidth * devicePixelRatio), Math.round(contentHeight * devicePixelRatio), switchSizes),
        borderBoxSize: $b1e7a146a5183a97$var$size(borderBoxWidth, borderBoxHeight, switchSizes),
        contentBoxSize: $b1e7a146a5183a97$var$size(contentWidth, contentHeight, switchSizes),
        contentRect: new (0, $jrHyc.DOMRectReadOnly)(paddingLeft, paddingTop, contentWidth, contentHeight)
    });
    $b1e7a146a5183a97$var$cache.set(target, boxes);
    return boxes;
};
var $b1e7a146a5183a97$export$1a78030b04106bdb = function(target, observedBox, forceRecalculation) {
    var _a = $b1e7a146a5183a97$export$504d039a9c501c94(target, forceRecalculation), borderBoxSize = _a.borderBoxSize, contentBoxSize = _a.contentBoxSize, devicePixelContentBoxSize = _a.devicePixelContentBoxSize;
    switch(observedBox){
        case (0, $f0A1V.ResizeObserverBoxOptions).DEVICE_PIXEL_CONTENT_BOX:
            return devicePixelContentBoxSize;
        case (0, $f0A1V.ResizeObserverBoxOptions).BORDER_BOX:
            return borderBoxSize;
        default:
            return contentBoxSize;
    }
};

});
parcelRegister("f0A1V", function(module, exports) {

$parcel$export(module.exports, "ResizeObserverBoxOptions", function () { return $aed2cde9a4bce1e7$export$416d111b83cd1483; });
var $aed2cde9a4bce1e7$export$416d111b83cd1483;
(function(ResizeObserverBoxOptions) {
    ResizeObserverBoxOptions["BORDER_BOX"] = "border-box";
    ResizeObserverBoxOptions["CONTENT_BOX"] = "content-box";
    ResizeObserverBoxOptions["DEVICE_PIXEL_CONTENT_BOX"] = "device-pixel-content-box";
})($aed2cde9a4bce1e7$export$416d111b83cd1483 || ($aed2cde9a4bce1e7$export$416d111b83cd1483 = {}));

});

parcelRegister("1iuMj", function(module, exports) {

$parcel$export(module.exports, "ResizeObserverSize", function () { return $0f1f58cd6751e058$export$c9ad8cdf6bbd331c; });

var $eyoNq = parcelRequire("eyoNq");
var $0f1f58cd6751e058$export$c9ad8cdf6bbd331c = function() {
    function ResizeObserverSize(inlineSize, blockSize) {
        this.inlineSize = inlineSize;
        this.blockSize = blockSize;
        (0, $eyoNq.freeze)(this);
    }
    return ResizeObserverSize;
}();

});
parcelRegister("eyoNq", function(module, exports) {

$parcel$export(module.exports, "freeze", function () { return $a98779a9d003ba6e$export$792f3d81ea979f55; });
var $a98779a9d003ba6e$export$792f3d81ea979f55 = function(obj) {
    return Object.freeze(obj);
};

});


parcelRegister("jrHyc", function(module, exports) {

$parcel$export(module.exports, "DOMRectReadOnly", function () { return $e282522c82cd9cab$export$51d7a67026f4e0b7; });

var $eyoNq = parcelRequire("eyoNq");
var $e282522c82cd9cab$export$51d7a67026f4e0b7 = function() {
    function DOMRectReadOnly(x, y, width, height) {
        this.x = x;
        this.y = y;
        this.width = width;
        this.height = height;
        this.top = this.y;
        this.left = this.x;
        this.bottom = this.top + this.height;
        this.right = this.left + this.width;
        return (0, $eyoNq.freeze)(this);
    }
    DOMRectReadOnly.prototype.toJSON = function() {
        var _a = this, x = _a.x, y = _a.y, top = _a.top, right = _a.right, bottom = _a.bottom, left = _a.left, width = _a.width, height = _a.height;
        return {
            x: x,
            y: y,
            top: top,
            right: right,
            bottom: bottom,
            left: left,
            width: width,
            height: height
        };
    };
    DOMRectReadOnly.fromRect = function(rectangle) {
        return new DOMRectReadOnly(rectangle.x, rectangle.y, rectangle.width, rectangle.height);
    };
    return DOMRectReadOnly;
}();

});

parcelRegister("9LXW9", function(module, exports) {

$parcel$export(module.exports, "isSVG", function () { return $71d6ff1156aa863f$export$165b39ed277223c2; });
$parcel$export(module.exports, "isHidden", function () { return $71d6ff1156aa863f$export$ee695c13482bb5dd; });
$parcel$export(module.exports, "isElement", function () { return $71d6ff1156aa863f$export$45a5e7f76e0caa8d; });
$parcel$export(module.exports, "isReplacedElement", function () { return $71d6ff1156aa863f$export$a6eb60f7e7c182ba; });
var $71d6ff1156aa863f$export$165b39ed277223c2 = function(target) {
    return target instanceof SVGElement && "getBBox" in target;
};
var $71d6ff1156aa863f$export$ee695c13482bb5dd = function(target) {
    if ($71d6ff1156aa863f$export$165b39ed277223c2(target)) {
        var _a = target.getBBox(), width = _a.width, height = _a.height;
        return !width && !height;
    }
    var _b = target, offsetWidth = _b.offsetWidth, offsetHeight = _b.offsetHeight;
    return !(offsetWidth || offsetHeight || target.getClientRects().length);
};
var $71d6ff1156aa863f$export$45a5e7f76e0caa8d = function(obj) {
    var _a;
    if (obj instanceof Element) return true;
    var scope = (_a = obj === null || obj === void 0 ? void 0 : obj.ownerDocument) === null || _a === void 0 ? void 0 : _a.defaultView;
    return !!(scope && obj instanceof scope.Element);
};
var $71d6ff1156aa863f$export$a6eb60f7e7c182ba = function(target) {
    switch(target.tagName){
        case "INPUT":
            if (target.type !== "image") break;
        case "VIDEO":
        case "AUDIO":
        case "EMBED":
        case "OBJECT":
        case "CANVAS":
        case "IFRAME":
        case "IMG":
            return true;
    }
    return false;
};

});

parcelRegister("7cl9W", function(module, exports) {

$parcel$export(module.exports, "global", function () { return $53da112f222d8132$export$90b4d2ff6acb88af; });
var $53da112f222d8132$export$90b4d2ff6acb88af = typeof window !== "undefined" ? window : {};

});



parcelRegister("5HUq2", function(module, exports) {

$parcel$export(module.exports, "calculateDepthForNode", function () { return $427cbb8574d7ee1c$export$f8c8e3b5da1f41d2; });

var $9LXW9 = parcelRequire("9LXW9");
var $427cbb8574d7ee1c$export$f8c8e3b5da1f41d2 = function(node) {
    if ((0, $9LXW9.isHidden)(node)) return Infinity;
    var depth = 0;
    var parent = node.parentNode;
    while(parent){
        depth += 1;
        parent = parent.parentNode;
    }
    return depth;
};

});


parcelRegister("jEuFD", function(module, exports) {

$parcel$export(module.exports, "gatherActiveObservationsAtDepth", function () { return $e4e98b46309a8bac$export$9c17b8913a2a3572; });

var $2avI5 = parcelRequire("2avI5");

var $5HUq2 = parcelRequire("5HUq2");
var $e4e98b46309a8bac$export$9c17b8913a2a3572 = function(depth) {
    (0, $2avI5.resizeObservers).forEach(function processObserver(ro) {
        ro.activeTargets.splice(0, ro.activeTargets.length);
        ro.skippedTargets.splice(0, ro.skippedTargets.length);
        ro.observationTargets.forEach(function processTarget(ot) {
            if (ot.isActive()) {
                if ((0, $5HUq2.calculateDepthForNode)(ot.target) > depth) ro.activeTargets.push(ot);
                else ro.skippedTargets.push(ot);
            }
        });
    });
};

});


parcelRegister("bOlvY", function(module, exports) {

$parcel$export(module.exports, "queueResizeObserver", function () { return $89950d9510f5bedf$export$5755c7b572e34c6; });

var $6NTDj = parcelRequire("6NTDj");
var $89950d9510f5bedf$export$5755c7b572e34c6 = function(cb) {
    (0, $6NTDj.queueMicroTask)(function ResizeObserver() {
        requestAnimationFrame(cb);
    });
};

});
parcelRegister("6NTDj", function(module, exports) {

$parcel$export(module.exports, "queueMicroTask", function () { return $4f427939f3062a02$export$4c995d4933c4abb; });
var $4f427939f3062a02$var$trigger;
var $4f427939f3062a02$var$callbacks = [];
var $4f427939f3062a02$var$notify = function() {
    return $4f427939f3062a02$var$callbacks.splice(0).forEach(function(cb) {
        return cb();
    });
};
var $4f427939f3062a02$export$4c995d4933c4abb = function(callback) {
    if (!$4f427939f3062a02$var$trigger) {
        var toggle_1 = 0;
        var el_1 = document.createTextNode("");
        var config = {
            characterData: true
        };
        new MutationObserver(function() {
            return $4f427939f3062a02$var$notify();
        }).observe(el_1, config);
        $4f427939f3062a02$var$trigger = function() {
            el_1.textContent = "".concat(toggle_1 ? toggle_1-- : toggle_1++);
        };
    }
    $4f427939f3062a02$var$callbacks.push(callback);
    $4f427939f3062a02$var$trigger();
};

});



parcelRegister("5eFoL", function(module, exports) {

$parcel$export(module.exports, "ResizeObservation", function () { return $3cfe5f6b3fc58040$export$fea412043713122; });

var $f0A1V = parcelRequire("f0A1V");

var $fgYX2 = parcelRequire("fgYX2");

var $9LXW9 = parcelRequire("9LXW9");
var $3cfe5f6b3fc58040$var$skipNotifyOnElement = function(target) {
    return !(0, $9LXW9.isSVG)(target) && !(0, $9LXW9.isReplacedElement)(target) && getComputedStyle(target).display === "inline";
};
var $3cfe5f6b3fc58040$export$fea412043713122 = function() {
    function ResizeObservation(target, observedBox) {
        this.target = target;
        this.observedBox = observedBox || (0, $f0A1V.ResizeObserverBoxOptions).CONTENT_BOX;
        this.lastReportedSize = {
            inlineSize: 0,
            blockSize: 0
        };
    }
    ResizeObservation.prototype.isActive = function() {
        var size = (0, $fgYX2.calculateBoxSize)(this.target, this.observedBox, true);
        if ($3cfe5f6b3fc58040$var$skipNotifyOnElement(this.target)) this.lastReportedSize = size;
        if (this.lastReportedSize.inlineSize !== size.inlineSize || this.lastReportedSize.blockSize !== size.blockSize) return true;
        return false;
    };
    return ResizeObservation;
}();

});

parcelRegister("jlo7L", function(module, exports) {

$parcel$export(module.exports, "ResizeObserverDetail", function () { return $e152b1091ba0bf56$export$d86966e6e4bc97e1; });
var $e152b1091ba0bf56$export$d86966e6e4bc97e1 = function() {
    function ResizeObserverDetail(resizeObserver, callback) {
        this.activeTargets = [];
        this.skippedTargets = [];
        this.observationTargets = [];
        this.observer = resizeObserver;
        this.callback = callback;
    }
    return ResizeObserverDetail;
}();

});







parcelRegister("6woBW", function(module, exports) {

$parcel$export(module.exports, "SecretHashView", function () { return $0139b0d05198554f$export$94d854c4b6d0b94e; });

var $4vwom = parcelRequire("4vwom");

var $eeH7J = parcelRequire("eeH7J");

var $1aVVn = parcelRequire("1aVVn");

var $8KyPb = parcelRequire("8KyPb");

var $fT6Pt = parcelRequire("fT6Pt");

var $hRViu = parcelRequire("hRViu");

var $9Q5xE = parcelRequire("9Q5xE");
function $0139b0d05198554f$export$94d854c4b6d0b94e({ obj: obj, property: property, label: label, buttons: buttons, isEmbedded: isEmbedded }) {
    const [secret, setSecret] = (0, $eeH7J.useState)();
    const [copied, setCopied] = (0, $eeH7J.useState)(false);
    const [reveal, setReveal] = (0, $eeH7J.useState)(false);
    async function generate() {
        const { secret: newSecret, hash: hash } = await (0, $8KyPb.GenerateSecretAndHash)();
        // Copy the secret to the clipboard
        setSecret(newSecret);
        (0, $1aVVn.YTools).set(obj, property.name, hash);
    }
    const hash = (0, $1aVVn.YTools).get(obj, property.name);
    const canGenerate = property.isReadonly ? !hash : false;
    return (0, $4vwom.jsxs)((0, $hRViu.PropRow), {
        buttons: [],
        badge: canGenerate ? (0, $4vwom.jsx)("div", {
            style: {
                display: "flex",
                flexDirection: "row"
            },
            children: (0, $4vwom.jsx)((0, $fT6Pt.RButton), {
                variant: "secondary",
                icon: "ui-dice-5",
                onClick: generate,
                children: "Generate"
            })
        }) : undefined,
        description: property.description,
        label: label,
        children: [
            secret ? (0, $4vwom.jsxs)("div", {
                style: {
                    backgroundColor: (0, $9Q5xE.ColorStyles).warning[200],
                    padding: 16
                },
                children: [
                    "Please copy this secret, it is the last time you will see it:",
                    (0, $4vwom.jsxs)("div", {
                        style: {
                            display: "flex",
                            flexDirection: "row"
                        },
                        children: [
                            (0, $4vwom.jsx)((0, $fT6Pt.RButton), {
                                icon: "ui-eye",
                                onClick: ()=>setReveal(!reveal),
                                children: reveal ? "Hide" : "Reveal"
                            }),
                            (0, $4vwom.jsx)("pre", {
                                style: {
                                    padding: 16,
                                    filter: reveal ? undefined : `blur(10px)`,
                                    transition: "filter 0.3s ease"
                                },
                                children: secret
                            })
                        ]
                    }),
                    (0, $4vwom.jsx)((0, $fT6Pt.RButton), {
                        variant: "secondary",
                        icon: copied ? "ui-check" : "ui-clipboard",
                        style: {
                            marginTop: 0,
                            marginBottom: 16
                        },
                        onClick: ()=>{
                            navigator.clipboard.writeText(secret || "");
                            setCopied(true);
                            setTimeout(()=>setCopied(false), 2000);
                        },
                        children: !copied ? "Copy to clipboard" : "Copied!"
                    })
                ]
            }) : undefined,
            hash ? (0, $4vwom.jsx)("input", {
                type: "text",
                className: "form-control",
                value: hash.substring(0, 30) + "...",
                readOnly: true
            }) : undefined
        ]
    });
}

});
parcelRegister("8KyPb", function(module, exports) {

$parcel$export(module.exports, "GenerateSecretAndHash", function () { return $65eda20c48f85e7d$export$91e84faaf8652731; });
function $65eda20c48f85e7d$var$arrayBufferToHex(buffer) {
    return Array.from(new Uint8Array(buffer)).map((b)=>b.toString(16).padStart(2, "0")).join("");
}
async function $65eda20c48f85e7d$export$91e84faaf8652731() {
    const secretBytes = new Uint8Array(32);
    crypto.getRandomValues(secretBytes);
    const secret = Array.from(secretBytes).map((b)=>b.toString(16).padStart(2, "0")).join("");
    const hashBuffer = await crypto.subtle.digest("SHA-256", new TextEncoder().encode(secret));
    const hash = $65eda20c48f85e7d$var$arrayBufferToHex(hashBuffer);
    return {
        secret: secret,
        hash: hash
    };
}

});


parcelRegister("8z9Wu", function(module, exports) {

$parcel$export(module.exports, "ThumbHashView", function () { return $63c94df7b99348f5$export$c341d08abf1fa7d0; });

var $4vwom = parcelRequire("4vwom");

var $eeH7J = parcelRequire("eeH7J");

var $9Q5xE = parcelRequire("9Q5xE");
function $63c94df7b99348f5$var$base64ToUint8Array(base64) {
    const binary = atob(base64);
    const len = binary.length;
    const bytes = new Uint8Array(len);
    for(let i = 0; i < len; i++)bytes[i] = binary.charCodeAt(i);
    return bytes;
}

async function $63c94df7b99348f5$var$thumbHashToDataUrl(base64Hash) {
    const { thumbHashToRGBA: thumbHashToRGBA } = await (parcelRequire("5HWRM"));
    const hash = $63c94df7b99348f5$var$base64ToUint8Array(base64Hash);
    const { w: w, h: h, rgba: rgba } = thumbHashToRGBA(hash);
    const canvas = document.createElement("canvas");
    canvas.width = w;
    canvas.height = h;
    const ctx = canvas.getContext("2d");
    if (!ctx) throw new Error("No 2D context");
    const imageData = ctx.createImageData(w, h);
    imageData.data.set(rgba);
    ctx.putImageData(imageData, 0, 0);
    return canvas.toDataURL();
}
function $63c94df7b99348f5$export$c341d08abf1fa7d0({ base64: base64 }) {
    const [dataUrl, setDataUrl] = (0, $eeH7J.useState)();
    (0, $eeH7J.useEffect)(()=>{
        if (base64) $63c94df7b99348f5$var$thumbHashToDataUrl(base64).then(setDataUrl).catch((error)=>console.error("Error converting ThumbHash to Data URL:", error));
    }, [
        base64
    ]);
    return (0, $4vwom.jsxs)("div", {
        style: {
            display: "flex",
            flexDirection: "row",
            alignItems: "center"
        },
        children: [
            (0, $4vwom.jsx)("img", {
                src: dataUrl,
                alt: "ThumbHash preview",
                style: {
                    width: 128,
                    height: 128
                }
            }),
            (0, $4vwom.jsx)("div", {
                style: {
                    padding: 16,
                    margin: 16,
                    backgroundColor: (0, $9Q5xE.ColorStyles)["gray-cool"][100]
                },
                children: (0, $4vwom.jsx)("code", {
                    children: base64
                })
            })
        ]
    });
}

});
parcelRegister("5HWRM", function(module, exports) {

var $Ks0wJ = parcelRequire("Ks0wJ");
module.exports = $Ks0wJ("8nLsI").then(()=>parcelRequire("81PTE"));

});













parcelRegister("eSiQ2", function(module, exports) {

$parcel$export(module.exports, "Component", function () { return $ad44b8bb0b5618ee$export$16fa2f45be04daa8; });
/**
 * Registers a component.
 *
 * Use the type `Component` to represent any of the registered component types. This avoids having
 * to declare a union type of all component types.
 *
 * @param type The type of component to render.
 * @param render A function component that renders the component.
 */ function $ad44b8bb0b5618ee$export$16fa2f45be04daa8(render, options) {
    let name = typeof options.name === "string" ? options.name : render.name;
    if (!render) throw new Error("Component render must be a function");
    if (name.includes("$")) {
        // This name has been changed by Parcel's scope hoisting. We need to extract the original
        // name.
        const parts = name.split("$");
        if (parts.includes("export")) throw new Error("Exported component function must specify name (the name is lost due to Parcel's scope hoisting)");
        name = parts[parts.length - 1];
    }
    const componentAlreadyRegistered = $ad44b8bb0b5618ee$export$16fa2f45be04daa8.all.has(name);
    $ad44b8bb0b5618ee$export$16fa2f45be04daa8.all.set(name, {
        render: render,
        options: options
    });
    const invalidateFuncs = $ad44b8bb0b5618ee$export$16fa2f45be04daa8.invalidators.get(name);
    if (componentAlreadyRegistered && invalidateFuncs) setTimeout(()=>{
        for (const invalidate of invalidateFuncs)invalidate();
    }, 1);
}
$ad44b8bb0b5618ee$export$16fa2f45be04daa8.all = new Map();
/**
 * Hot reload callbacks.
 *
 * Since component types are not components directly, their wrappers need to be
 * invalidated. This is done by calling the invalidate function when a component
 * type is re-registered.
 */ $ad44b8bb0b5618ee$export$16fa2f45be04daa8.invalidators = new Map();

});

parcelRegister("5qU69", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $3f4ae55ee36fed82$export$83d89fbfd8236492; }, function (v) { return $3f4ae55ee36fed82$export$83d89fbfd8236492 = v; });
$parcel$export(module.exports, "renderToString", function () { return $3f4ae55ee36fed82$export$80e7718417253a51; }, function (v) { return $3f4ae55ee36fed82$export$80e7718417253a51 = v; });
$parcel$export(module.exports, "renderToStaticMarkup", function () { return $3f4ae55ee36fed82$export$eb3a06aef9e6ee51; }, function (v) { return $3f4ae55ee36fed82$export$eb3a06aef9e6ee51 = v; });
$parcel$export(module.exports, "renderToNodeStream", function () { return $3f4ae55ee36fed82$export$307591e98609eddd; }, function (v) { return $3f4ae55ee36fed82$export$307591e98609eddd = v; });
$parcel$export(module.exports, "renderToStaticNodeStream", function () { return $3f4ae55ee36fed82$export$b23711c915539651; }, function (v) { return $3f4ae55ee36fed82$export$b23711c915539651 = v; });
$parcel$export(module.exports, "renderToReadableStream", function () { return $3f4ae55ee36fed82$export$7020a3240b287705; }, function (v) { return $3f4ae55ee36fed82$export$7020a3240b287705 = v; });
var $3f4ae55ee36fed82$export$83d89fbfd8236492;
var $3f4ae55ee36fed82$export$80e7718417253a51;
var $3f4ae55ee36fed82$export$eb3a06aef9e6ee51;
var $3f4ae55ee36fed82$export$307591e98609eddd;
var $3f4ae55ee36fed82$export$b23711c915539651;
var $3f4ae55ee36fed82$export$7020a3240b287705;
"use strict";
var $3f4ae55ee36fed82$var$l, $3f4ae55ee36fed82$var$s;

$3f4ae55ee36fed82$var$l = (parcelRequire("5tUvF"));

$3f4ae55ee36fed82$var$s = (parcelRequire("4UUdh"));
$3f4ae55ee36fed82$export$83d89fbfd8236492 = $3f4ae55ee36fed82$var$l.version;
$3f4ae55ee36fed82$export$80e7718417253a51 = $3f4ae55ee36fed82$var$l.renderToString;
$3f4ae55ee36fed82$export$eb3a06aef9e6ee51 = $3f4ae55ee36fed82$var$l.renderToStaticMarkup;
$3f4ae55ee36fed82$export$307591e98609eddd = $3f4ae55ee36fed82$var$l.renderToNodeStream;
$3f4ae55ee36fed82$export$b23711c915539651 = $3f4ae55ee36fed82$var$l.renderToStaticNodeStream;
$3f4ae55ee36fed82$export$7020a3240b287705 = $3f4ae55ee36fed82$var$s.renderToReadableStream;

});
parcelRegister("5tUvF", function(module, exports) {

$parcel$export(module.exports, "renderToNodeStream", function () { return $3fdb7eddda9a9ee5$export$307591e98609eddd; }, function (v) { return $3fdb7eddda9a9ee5$export$307591e98609eddd = v; });
$parcel$export(module.exports, "renderToStaticMarkup", function () { return $3fdb7eddda9a9ee5$export$eb3a06aef9e6ee51; }, function (v) { return $3fdb7eddda9a9ee5$export$eb3a06aef9e6ee51 = v; });
$parcel$export(module.exports, "renderToStaticNodeStream", function () { return $3fdb7eddda9a9ee5$export$b23711c915539651; }, function (v) { return $3fdb7eddda9a9ee5$export$b23711c915539651 = v; });
$parcel$export(module.exports, "renderToString", function () { return $3fdb7eddda9a9ee5$export$80e7718417253a51; }, function (v) { return $3fdb7eddda9a9ee5$export$80e7718417253a51 = v; });
$parcel$export(module.exports, "version", function () { return $3fdb7eddda9a9ee5$export$83d89fbfd8236492; }, function (v) { return $3fdb7eddda9a9ee5$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom-server-legacy.browser.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $3fdb7eddda9a9ee5$export$307591e98609eddd;
var $3fdb7eddda9a9ee5$export$eb3a06aef9e6ee51;
var $3fdb7eddda9a9ee5$export$b23711c915539651;
var $3fdb7eddda9a9ee5$export$80e7718417253a51;
var $3fdb7eddda9a9ee5$export$83d89fbfd8236492;
"use strict";

var $eeH7J = parcelRequire("eeH7J");
function $3fdb7eddda9a9ee5$var$l(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $3fdb7eddda9a9ee5$var$p = Object.prototype.hasOwnProperty, $3fdb7eddda9a9ee5$var$fa = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $3fdb7eddda9a9ee5$var$ha = {}, $3fdb7eddda9a9ee5$var$ia = {};
function $3fdb7eddda9a9ee5$var$ja(a) {
    if ($3fdb7eddda9a9ee5$var$p.call($3fdb7eddda9a9ee5$var$ia, a)) return !0;
    if ($3fdb7eddda9a9ee5$var$p.call($3fdb7eddda9a9ee5$var$ha, a)) return !1;
    if ($3fdb7eddda9a9ee5$var$fa.test(a)) return $3fdb7eddda9a9ee5$var$ia[a] = !0;
    $3fdb7eddda9a9ee5$var$ha[a] = !0;
    return !1;
}
function $3fdb7eddda9a9ee5$var$r(a, b, c, d, f, e, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = f;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = e;
    this.removeEmptyString = g;
}
var $3fdb7eddda9a9ee5$var$t = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $3fdb7eddda9a9ee5$var$t[a] = new $3fdb7eddda9a9ee5$var$r(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $3fdb7eddda9a9ee5$var$t[b] = new $3fdb7eddda9a9ee5$var$r(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $3fdb7eddda9a9ee5$var$t[a] = new $3fdb7eddda9a9ee5$var$r(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $3fdb7eddda9a9ee5$var$t[a] = new $3fdb7eddda9a9ee5$var$r(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $3fdb7eddda9a9ee5$var$t[a] = new $3fdb7eddda9a9ee5$var$r(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $3fdb7eddda9a9ee5$var$t[a] = new $3fdb7eddda9a9ee5$var$r(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $3fdb7eddda9a9ee5$var$t[a] = new $3fdb7eddda9a9ee5$var$r(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $3fdb7eddda9a9ee5$var$t[a] = new $3fdb7eddda9a9ee5$var$r(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $3fdb7eddda9a9ee5$var$t[a] = new $3fdb7eddda9a9ee5$var$r(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $3fdb7eddda9a9ee5$var$ka = /[\-:]([a-z])/g;
function $3fdb7eddda9a9ee5$var$la(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($3fdb7eddda9a9ee5$var$ka, $3fdb7eddda9a9ee5$var$la);
    $3fdb7eddda9a9ee5$var$t[b] = new $3fdb7eddda9a9ee5$var$r(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($3fdb7eddda9a9ee5$var$ka, $3fdb7eddda9a9ee5$var$la);
    $3fdb7eddda9a9ee5$var$t[b] = new $3fdb7eddda9a9ee5$var$r(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($3fdb7eddda9a9ee5$var$ka, $3fdb7eddda9a9ee5$var$la);
    $3fdb7eddda9a9ee5$var$t[b] = new $3fdb7eddda9a9ee5$var$r(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $3fdb7eddda9a9ee5$var$t[a] = new $3fdb7eddda9a9ee5$var$r(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$3fdb7eddda9a9ee5$var$t.xlinkHref = new $3fdb7eddda9a9ee5$var$r("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $3fdb7eddda9a9ee5$var$t[a] = new $3fdb7eddda9a9ee5$var$r(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
var $3fdb7eddda9a9ee5$var$u = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $3fdb7eddda9a9ee5$var$ma = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($3fdb7eddda9a9ee5$var$u).forEach(function(a) {
    $3fdb7eddda9a9ee5$var$ma.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $3fdb7eddda9a9ee5$var$u[b] = $3fdb7eddda9a9ee5$var$u[a];
    });
});
var $3fdb7eddda9a9ee5$var$na = /["'&<>]/;
function $3fdb7eddda9a9ee5$var$v(a) {
    if ("boolean" === typeof a || "number" === typeof a) return "" + a;
    a = "" + a;
    var b = $3fdb7eddda9a9ee5$var$na.exec(a);
    if (b) {
        var c = "", d, f = 0;
        for(d = b.index; d < a.length; d++){
            switch(a.charCodeAt(d)){
                case 34:
                    b = "&quot;";
                    break;
                case 38:
                    b = "&amp;";
                    break;
                case 39:
                    b = "&#x27;";
                    break;
                case 60:
                    b = "&lt;";
                    break;
                case 62:
                    b = "&gt;";
                    break;
                default:
                    continue;
            }
            f !== d && (c += a.substring(f, d));
            f = d + 1;
            c += b;
        }
        a = f !== d ? c + a.substring(f, d) : c;
    }
    return a;
}
var $3fdb7eddda9a9ee5$var$oa = /([A-Z])/g, $3fdb7eddda9a9ee5$var$pa = /^ms-/, $3fdb7eddda9a9ee5$var$qa = Array.isArray;
function $3fdb7eddda9a9ee5$var$w(a, b) {
    return {
        insertionMode: a,
        selectedValue: b
    };
}
function $3fdb7eddda9a9ee5$var$ra(a, b, c) {
    switch(b){
        case "select":
            return $3fdb7eddda9a9ee5$var$w(1, null != c.value ? c.value : c.defaultValue);
        case "svg":
            return $3fdb7eddda9a9ee5$var$w(2, null);
        case "math":
            return $3fdb7eddda9a9ee5$var$w(3, null);
        case "foreignObject":
            return $3fdb7eddda9a9ee5$var$w(1, null);
        case "table":
            return $3fdb7eddda9a9ee5$var$w(4, null);
        case "thead":
        case "tbody":
        case "tfoot":
            return $3fdb7eddda9a9ee5$var$w(5, null);
        case "colgroup":
            return $3fdb7eddda9a9ee5$var$w(7, null);
        case "tr":
            return $3fdb7eddda9a9ee5$var$w(6, null);
    }
    return 4 <= a.insertionMode || 0 === a.insertionMode ? $3fdb7eddda9a9ee5$var$w(1, null) : a;
}
var $3fdb7eddda9a9ee5$var$sa = new Map;
function $3fdb7eddda9a9ee5$var$ta(a, b, c) {
    if ("object" !== typeof c) throw Error($3fdb7eddda9a9ee5$var$l(62));
    b = !0;
    for(var d in c)if ($3fdb7eddda9a9ee5$var$p.call(c, d)) {
        var f = c[d];
        if (null != f && "boolean" !== typeof f && "" !== f) {
            if (0 === d.indexOf("--")) {
                var e = $3fdb7eddda9a9ee5$var$v(d);
                f = $3fdb7eddda9a9ee5$var$v(("" + f).trim());
            } else {
                e = d;
                var g = $3fdb7eddda9a9ee5$var$sa.get(e);
                void 0 !== g ? e = g : (g = $3fdb7eddda9a9ee5$var$v(e.replace($3fdb7eddda9a9ee5$var$oa, "-$1").toLowerCase().replace($3fdb7eddda9a9ee5$var$pa, "-ms-")), $3fdb7eddda9a9ee5$var$sa.set(e, g), e = g);
                f = "number" === typeof f ? 0 === f || $3fdb7eddda9a9ee5$var$p.call($3fdb7eddda9a9ee5$var$u, d) ? "" + f : f + "px" : $3fdb7eddda9a9ee5$var$v(("" + f).trim());
            }
            b ? (b = !1, a.push(' style="', e, ":", f)) : a.push(";", e, ":", f);
        }
    }
    b || a.push('"');
}
function $3fdb7eddda9a9ee5$var$x(a, b, c, d) {
    switch(c){
        case "style":
            $3fdb7eddda9a9ee5$var$ta(a, b, d);
            return;
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
            return;
    }
    if (!(2 < c.length) || "o" !== c[0] && "O" !== c[0] || "n" !== c[1] && "N" !== c[1]) {
        if (b = $3fdb7eddda9a9ee5$var$t.hasOwnProperty(c) ? $3fdb7eddda9a9ee5$var$t[c] : null, null !== b) {
            switch(typeof d){
                case "function":
                case "symbol":
                    return;
                case "boolean":
                    if (!b.acceptsBooleans) return;
            }
            c = b.attributeName;
            switch(b.type){
                case 3:
                    d && a.push(" ", c, '=""');
                    break;
                case 4:
                    !0 === d ? a.push(" ", c, '=""') : !1 !== d && a.push(" ", c, '="', $3fdb7eddda9a9ee5$var$v(d), '"');
                    break;
                case 5:
                    isNaN(d) || a.push(" ", c, '="', $3fdb7eddda9a9ee5$var$v(d), '"');
                    break;
                case 6:
                    !isNaN(d) && 1 <= d && a.push(" ", c, '="', $3fdb7eddda9a9ee5$var$v(d), '"');
                    break;
                default:
                    b.sanitizeURL && (d = "" + d), a.push(" ", c, '="', $3fdb7eddda9a9ee5$var$v(d), '"');
            }
        } else if ($3fdb7eddda9a9ee5$var$ja(c)) {
            switch(typeof d){
                case "function":
                case "symbol":
                    return;
                case "boolean":
                    if (b = c.toLowerCase().slice(0, 5), "data-" !== b && "aria-" !== b) return;
            }
            a.push(" ", c, '="', $3fdb7eddda9a9ee5$var$v(d), '"');
        }
    }
}
function $3fdb7eddda9a9ee5$var$y(a, b, c) {
    if (null != b) {
        if (null != c) throw Error($3fdb7eddda9a9ee5$var$l(60));
        if ("object" !== typeof b || !("__html" in b)) throw Error($3fdb7eddda9a9ee5$var$l(61));
        b = b.__html;
        null !== b && void 0 !== b && a.push("" + b);
    }
}
function $3fdb7eddda9a9ee5$var$ua(a) {
    var b = "";
    $eeH7J.Children.forEach(a, function(a) {
        null != a && (b += a);
    });
    return b;
}
function $3fdb7eddda9a9ee5$var$va(a, b, c, d) {
    a.push($3fdb7eddda9a9ee5$var$A(c));
    var f = c = null, e;
    for(e in b)if ($3fdb7eddda9a9ee5$var$p.call(b, e)) {
        var g = b[e];
        if (null != g) switch(e){
            case "children":
                c = g;
                break;
            case "dangerouslySetInnerHTML":
                f = g;
                break;
            default:
                $3fdb7eddda9a9ee5$var$x(a, d, e, g);
        }
    }
    a.push(">");
    $3fdb7eddda9a9ee5$var$y(a, f, c);
    return "string" === typeof c ? (a.push($3fdb7eddda9a9ee5$var$v(c)), null) : c;
}
var $3fdb7eddda9a9ee5$var$wa = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/, $3fdb7eddda9a9ee5$var$xa = new Map;
function $3fdb7eddda9a9ee5$var$A(a) {
    var b = $3fdb7eddda9a9ee5$var$xa.get(a);
    if (void 0 === b) {
        if (!$3fdb7eddda9a9ee5$var$wa.test(a)) throw Error($3fdb7eddda9a9ee5$var$l(65, a));
        b = "<" + a;
        $3fdb7eddda9a9ee5$var$xa.set(a, b);
    }
    return b;
}
function $3fdb7eddda9a9ee5$var$ya(a, b, c, d, f) {
    switch(b){
        case "select":
            a.push($3fdb7eddda9a9ee5$var$A("select"));
            var e = null, g = null;
            for(n in c)if ($3fdb7eddda9a9ee5$var$p.call(c, n)) {
                var h = c[n];
                if (null != h) switch(n){
                    case "children":
                        e = h;
                        break;
                    case "dangerouslySetInnerHTML":
                        g = h;
                        break;
                    case "defaultValue":
                    case "value":
                        break;
                    default:
                        $3fdb7eddda9a9ee5$var$x(a, d, n, h);
                }
            }
            a.push(">");
            $3fdb7eddda9a9ee5$var$y(a, g, e);
            return e;
        case "option":
            g = f.selectedValue;
            a.push($3fdb7eddda9a9ee5$var$A("option"));
            var k = h = null, m = null;
            var n = null;
            for(e in c)if ($3fdb7eddda9a9ee5$var$p.call(c, e)) {
                var q = c[e];
                if (null != q) switch(e){
                    case "children":
                        h = q;
                        break;
                    case "selected":
                        m = q;
                        break;
                    case "dangerouslySetInnerHTML":
                        n = q;
                        break;
                    case "value":
                        k = q;
                    default:
                        $3fdb7eddda9a9ee5$var$x(a, d, e, q);
                }
            }
            if (null != g) {
                if (c = null !== k ? "" + k : $3fdb7eddda9a9ee5$var$ua(h), $3fdb7eddda9a9ee5$var$qa(g)) {
                    for(d = 0; d < g.length; d++)if ("" + g[d] === c) {
                        a.push(' selected=""');
                        break;
                    }
                } else "" + g === c && a.push(' selected=""');
            } else m && a.push(' selected=""');
            a.push(">");
            $3fdb7eddda9a9ee5$var$y(a, n, h);
            return h;
        case "textarea":
            a.push($3fdb7eddda9a9ee5$var$A("textarea"));
            n = g = e = null;
            for(h in c)if ($3fdb7eddda9a9ee5$var$p.call(c, h) && (k = c[h], null != k)) switch(h){
                case "children":
                    n = k;
                    break;
                case "value":
                    e = k;
                    break;
                case "defaultValue":
                    g = k;
                    break;
                case "dangerouslySetInnerHTML":
                    throw Error($3fdb7eddda9a9ee5$var$l(91));
                default:
                    $3fdb7eddda9a9ee5$var$x(a, d, h, k);
            }
            null === e && null !== g && (e = g);
            a.push(">");
            if (null != n) {
                if (null != e) throw Error($3fdb7eddda9a9ee5$var$l(92));
                if ($3fdb7eddda9a9ee5$var$qa(n) && 1 < n.length) throw Error($3fdb7eddda9a9ee5$var$l(93));
                e = "" + n;
            }
            "string" === typeof e && "\n" === e[0] && a.push("\n");
            null !== e && a.push($3fdb7eddda9a9ee5$var$v("" + e));
            return null;
        case "input":
            a.push($3fdb7eddda9a9ee5$var$A("input"));
            k = n = h = e = null;
            for(g in c)if ($3fdb7eddda9a9ee5$var$p.call(c, g) && (m = c[g], null != m)) switch(g){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($3fdb7eddda9a9ee5$var$l(399, "input"));
                case "defaultChecked":
                    k = m;
                    break;
                case "defaultValue":
                    h = m;
                    break;
                case "checked":
                    n = m;
                    break;
                case "value":
                    e = m;
                    break;
                default:
                    $3fdb7eddda9a9ee5$var$x(a, d, g, m);
            }
            null !== n ? $3fdb7eddda9a9ee5$var$x(a, d, "checked", n) : null !== k && $3fdb7eddda9a9ee5$var$x(a, d, "checked", k);
            null !== e ? $3fdb7eddda9a9ee5$var$x(a, d, "value", e) : null !== h && $3fdb7eddda9a9ee5$var$x(a, d, "value", h);
            a.push("/>");
            return null;
        case "menuitem":
            a.push($3fdb7eddda9a9ee5$var$A("menuitem"));
            for(var C in c)if ($3fdb7eddda9a9ee5$var$p.call(c, C) && (e = c[C], null != e)) switch(C){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($3fdb7eddda9a9ee5$var$l(400));
                default:
                    $3fdb7eddda9a9ee5$var$x(a, d, C, e);
            }
            a.push(">");
            return null;
        case "title":
            a.push($3fdb7eddda9a9ee5$var$A("title"));
            e = null;
            for(q in c)if ($3fdb7eddda9a9ee5$var$p.call(c, q) && (g = c[q], null != g)) switch(q){
                case "children":
                    e = g;
                    break;
                case "dangerouslySetInnerHTML":
                    throw Error($3fdb7eddda9a9ee5$var$l(434));
                default:
                    $3fdb7eddda9a9ee5$var$x(a, d, q, g);
            }
            a.push(">");
            return e;
        case "listing":
        case "pre":
            a.push($3fdb7eddda9a9ee5$var$A(b));
            g = e = null;
            for(k in c)if ($3fdb7eddda9a9ee5$var$p.call(c, k) && (h = c[k], null != h)) switch(k){
                case "children":
                    e = h;
                    break;
                case "dangerouslySetInnerHTML":
                    g = h;
                    break;
                default:
                    $3fdb7eddda9a9ee5$var$x(a, d, k, h);
            }
            a.push(">");
            if (null != g) {
                if (null != e) throw Error($3fdb7eddda9a9ee5$var$l(60));
                if ("object" !== typeof g || !("__html" in g)) throw Error($3fdb7eddda9a9ee5$var$l(61));
                c = g.__html;
                null !== c && void 0 !== c && ("string" === typeof c && 0 < c.length && "\n" === c[0] ? a.push("\n", c) : a.push("" + c));
            }
            "string" === typeof e && "\n" === e[0] && a.push("\n");
            return e;
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "img":
        case "keygen":
        case "link":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
            a.push($3fdb7eddda9a9ee5$var$A(b));
            for(var D in c)if ($3fdb7eddda9a9ee5$var$p.call(c, D) && (e = c[D], null != e)) switch(D){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($3fdb7eddda9a9ee5$var$l(399, b));
                default:
                    $3fdb7eddda9a9ee5$var$x(a, d, D, e);
            }
            a.push("/>");
            return null;
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return $3fdb7eddda9a9ee5$var$va(a, c, b, d);
        case "html":
            return 0 === f.insertionMode && a.push("<!DOCTYPE html>"), $3fdb7eddda9a9ee5$var$va(a, c, b, d);
        default:
            if (-1 === b.indexOf("-") && "string" !== typeof c.is) return $3fdb7eddda9a9ee5$var$va(a, c, b, d);
            a.push($3fdb7eddda9a9ee5$var$A(b));
            g = e = null;
            for(m in c)if ($3fdb7eddda9a9ee5$var$p.call(c, m) && (h = c[m], null != h)) switch(m){
                case "children":
                    e = h;
                    break;
                case "dangerouslySetInnerHTML":
                    g = h;
                    break;
                case "style":
                    $3fdb7eddda9a9ee5$var$ta(a, d, h);
                    break;
                case "suppressContentEditableWarning":
                case "suppressHydrationWarning":
                    break;
                default:
                    $3fdb7eddda9a9ee5$var$ja(m) && "function" !== typeof h && "symbol" !== typeof h && a.push(" ", m, '="', $3fdb7eddda9a9ee5$var$v(h), '"');
            }
            a.push(">");
            $3fdb7eddda9a9ee5$var$y(a, g, e);
            return e;
    }
}
function $3fdb7eddda9a9ee5$var$za(a, b, c) {
    a.push('<!--$?--><template id="');
    if (null === c) throw Error($3fdb7eddda9a9ee5$var$l(395));
    a.push(c);
    return a.push('"></template>');
}
function $3fdb7eddda9a9ee5$var$Aa(a, b, c, d) {
    switch(c.insertionMode){
        case 0:
        case 1:
            return a.push('<div hidden id="'), a.push(b.segmentPrefix), b = d.toString(16), a.push(b), a.push('">');
        case 2:
            return a.push('<svg aria-hidden="true" style="display:none" id="'), a.push(b.segmentPrefix), b = d.toString(16), a.push(b), a.push('">');
        case 3:
            return a.push('<math aria-hidden="true" style="display:none" id="'), a.push(b.segmentPrefix), b = d.toString(16), a.push(b), a.push('">');
        case 4:
            return a.push('<table hidden id="'), a.push(b.segmentPrefix), b = d.toString(16), a.push(b), a.push('">');
        case 5:
            return a.push('<table hidden><tbody id="'), a.push(b.segmentPrefix), b = d.toString(16), a.push(b), a.push('">');
        case 6:
            return a.push('<table hidden><tr id="'), a.push(b.segmentPrefix), b = d.toString(16), a.push(b), a.push('">');
        case 7:
            return a.push('<table hidden><colgroup id="'), a.push(b.segmentPrefix), b = d.toString(16), a.push(b), a.push('">');
        default:
            throw Error($3fdb7eddda9a9ee5$var$l(397));
    }
}
function $3fdb7eddda9a9ee5$var$Ba(a, b) {
    switch(b.insertionMode){
        case 0:
        case 1:
            return a.push("</div>");
        case 2:
            return a.push("</svg>");
        case 3:
            return a.push("</math>");
        case 4:
            return a.push("</table>");
        case 5:
            return a.push("</tbody></table>");
        case 6:
            return a.push("</tr></table>");
        case 7:
            return a.push("</colgroup></table>");
        default:
            throw Error($3fdb7eddda9a9ee5$var$l(397));
    }
}
var $3fdb7eddda9a9ee5$var$Ca = /[<\u2028\u2029]/g;
function $3fdb7eddda9a9ee5$var$Da(a) {
    return JSON.stringify(a).replace($3fdb7eddda9a9ee5$var$Ca, function(a) {
        switch(a){
            case "<":
                return "\\u003c";
            case "\u2028":
                return "\\u2028";
            case "\u2029":
                return "\\u2029";
            default:
                throw Error("escapeJSStringsForInstructionScripts encountered a match it does not know how to replace. this means the match regex and the replacement characters are no longer in sync. This is a bug in React");
        }
    });
}
function $3fdb7eddda9a9ee5$var$Ea(a, b) {
    b = void 0 === b ? "" : b;
    return {
        bootstrapChunks: [],
        startInlineScript: "<script>",
        placeholderPrefix: b + "P:",
        segmentPrefix: b + "S:",
        boundaryPrefix: b + "B:",
        idPrefix: b,
        nextSuspenseID: 0,
        sentCompleteSegmentFunction: !1,
        sentCompleteBoundaryFunction: !1,
        sentClientRenderFunction: !1,
        generateStaticMarkup: a
    };
}
function $3fdb7eddda9a9ee5$var$Fa(a, b, c, d) {
    if (c.generateStaticMarkup) return a.push($3fdb7eddda9a9ee5$var$v(b)), !1;
    "" === b ? a = d : (d && a.push("<!-- -->"), a.push($3fdb7eddda9a9ee5$var$v(b)), a = !0);
    return a;
}
var $3fdb7eddda9a9ee5$var$B = Object.assign, $3fdb7eddda9a9ee5$var$Ga = Symbol.for("react.element"), $3fdb7eddda9a9ee5$var$Ha = Symbol.for("react.portal"), $3fdb7eddda9a9ee5$var$Ia = Symbol.for("react.fragment"), $3fdb7eddda9a9ee5$var$Ja = Symbol.for("react.strict_mode"), $3fdb7eddda9a9ee5$var$Ka = Symbol.for("react.profiler"), $3fdb7eddda9a9ee5$var$La = Symbol.for("react.provider"), $3fdb7eddda9a9ee5$var$Ma = Symbol.for("react.context"), $3fdb7eddda9a9ee5$var$Na = Symbol.for("react.forward_ref"), $3fdb7eddda9a9ee5$var$Oa = Symbol.for("react.suspense"), $3fdb7eddda9a9ee5$var$Pa = Symbol.for("react.suspense_list"), $3fdb7eddda9a9ee5$var$Qa = Symbol.for("react.memo"), $3fdb7eddda9a9ee5$var$Ra = Symbol.for("react.lazy"), $3fdb7eddda9a9ee5$var$Sa = Symbol.for("react.scope"), $3fdb7eddda9a9ee5$var$Ta = Symbol.for("react.debug_trace_mode"), $3fdb7eddda9a9ee5$var$Ua = Symbol.for("react.legacy_hidden"), $3fdb7eddda9a9ee5$var$Va = Symbol.for("react.default_value"), $3fdb7eddda9a9ee5$var$Wa = Symbol.iterator;
function $3fdb7eddda9a9ee5$var$Xa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $3fdb7eddda9a9ee5$var$Ia:
            return "Fragment";
        case $3fdb7eddda9a9ee5$var$Ha:
            return "Portal";
        case $3fdb7eddda9a9ee5$var$Ka:
            return "Profiler";
        case $3fdb7eddda9a9ee5$var$Ja:
            return "StrictMode";
        case $3fdb7eddda9a9ee5$var$Oa:
            return "Suspense";
        case $3fdb7eddda9a9ee5$var$Pa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $3fdb7eddda9a9ee5$var$Ma:
            return (a.displayName || "Context") + ".Consumer";
        case $3fdb7eddda9a9ee5$var$La:
            return (a._context.displayName || "Context") + ".Provider";
        case $3fdb7eddda9a9ee5$var$Na:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $3fdb7eddda9a9ee5$var$Qa:
            return b = a.displayName || null, null !== b ? b : $3fdb7eddda9a9ee5$var$Xa(a.type) || "Memo";
        case $3fdb7eddda9a9ee5$var$Ra:
            b = a._payload;
            a = a._init;
            try {
                return $3fdb7eddda9a9ee5$var$Xa(a(b));
            } catch (c) {}
    }
    return null;
}
var $3fdb7eddda9a9ee5$var$Ya = {};
function $3fdb7eddda9a9ee5$var$Za(a, b) {
    a = a.contextTypes;
    if (!a) return $3fdb7eddda9a9ee5$var$Ya;
    var c = {}, d;
    for(d in a)c[d] = b[d];
    return c;
}
var $3fdb7eddda9a9ee5$var$E = null;
function $3fdb7eddda9a9ee5$var$F(a, b) {
    if (a !== b) {
        a.context._currentValue2 = a.parentValue;
        a = a.parent;
        var c = b.parent;
        if (null === a) {
            if (null !== c) throw Error($3fdb7eddda9a9ee5$var$l(401));
        } else {
            if (null === c) throw Error($3fdb7eddda9a9ee5$var$l(401));
            $3fdb7eddda9a9ee5$var$F(a, c);
        }
        b.context._currentValue2 = b.value;
    }
}
function $3fdb7eddda9a9ee5$var$$a(a) {
    a.context._currentValue2 = a.parentValue;
    a = a.parent;
    null !== a && $3fdb7eddda9a9ee5$var$$a(a);
}
function $3fdb7eddda9a9ee5$var$ab(a) {
    var b = a.parent;
    null !== b && $3fdb7eddda9a9ee5$var$ab(b);
    a.context._currentValue2 = a.value;
}
function $3fdb7eddda9a9ee5$var$bb(a, b) {
    a.context._currentValue2 = a.parentValue;
    a = a.parent;
    if (null === a) throw Error($3fdb7eddda9a9ee5$var$l(402));
    a.depth === b.depth ? $3fdb7eddda9a9ee5$var$F(a, b) : $3fdb7eddda9a9ee5$var$bb(a, b);
}
function $3fdb7eddda9a9ee5$var$cb(a, b) {
    var c = b.parent;
    if (null === c) throw Error($3fdb7eddda9a9ee5$var$l(402));
    a.depth === c.depth ? $3fdb7eddda9a9ee5$var$F(a, c) : $3fdb7eddda9a9ee5$var$cb(a, c);
    b.context._currentValue2 = b.value;
}
function $3fdb7eddda9a9ee5$var$G(a) {
    var b = $3fdb7eddda9a9ee5$var$E;
    b !== a && (null === b ? $3fdb7eddda9a9ee5$var$ab(a) : null === a ? $3fdb7eddda9a9ee5$var$$a(b) : b.depth === a.depth ? $3fdb7eddda9a9ee5$var$F(b, a) : b.depth > a.depth ? $3fdb7eddda9a9ee5$var$bb(b, a) : $3fdb7eddda9a9ee5$var$cb(b, a), $3fdb7eddda9a9ee5$var$E = a);
}
var $3fdb7eddda9a9ee5$var$db = {
    isMounted: function() {
        return !1;
    },
    enqueueSetState: function(a, b) {
        a = a._reactInternals;
        null !== a.queue && a.queue.push(b);
    },
    enqueueReplaceState: function(a, b) {
        a = a._reactInternals;
        a.replace = !0;
        a.queue = [
            b
        ];
    },
    enqueueForceUpdate: function() {}
};
function $3fdb7eddda9a9ee5$var$eb(a, b, c, d) {
    var f = void 0 !== a.state ? a.state : null;
    a.updater = $3fdb7eddda9a9ee5$var$db;
    a.props = c;
    a.state = f;
    var e = {
        queue: [],
        replace: !1
    };
    a._reactInternals = e;
    var g = b.contextType;
    a.context = "object" === typeof g && null !== g ? g._currentValue2 : d;
    g = b.getDerivedStateFromProps;
    "function" === typeof g && (g = g(c, f), f = null === g || void 0 === g ? f : $3fdb7eddda9a9ee5$var$B({}, f, g), a.state = f);
    if ("function" !== typeof b.getDerivedStateFromProps && "function" !== typeof a.getSnapshotBeforeUpdate && ("function" === typeof a.UNSAFE_componentWillMount || "function" === typeof a.componentWillMount)) {
        if (b = a.state, "function" === typeof a.componentWillMount && a.componentWillMount(), "function" === typeof a.UNSAFE_componentWillMount && a.UNSAFE_componentWillMount(), b !== a.state && $3fdb7eddda9a9ee5$var$db.enqueueReplaceState(a, a.state, null), null !== e.queue && 0 < e.queue.length) {
            if (b = e.queue, g = e.replace, e.queue = null, e.replace = !1, g && 1 === b.length) a.state = b[0];
            else {
                e = g ? b[0] : a.state;
                f = !0;
                for(g = g ? 1 : 0; g < b.length; g++){
                    var h = b[g];
                    h = "function" === typeof h ? h.call(a, e, c, d) : h;
                    null != h && (f ? (f = !1, e = $3fdb7eddda9a9ee5$var$B({}, e, h)) : $3fdb7eddda9a9ee5$var$B(e, h));
                }
                a.state = e;
            }
        } else e.queue = null;
    }
}
var $3fdb7eddda9a9ee5$var$fb = {
    id: 1,
    overflow: ""
};
function $3fdb7eddda9a9ee5$var$gb(a, b, c) {
    var d = a.id;
    a = a.overflow;
    var f = 32 - $3fdb7eddda9a9ee5$var$H(d) - 1;
    d &= ~(1 << f);
    c += 1;
    var e = 32 - $3fdb7eddda9a9ee5$var$H(b) + f;
    if (30 < e) {
        var g = f - f % 5;
        e = (d & (1 << g) - 1).toString(32);
        d >>= g;
        f -= g;
        return {
            id: 1 << 32 - $3fdb7eddda9a9ee5$var$H(b) + f | c << f | d,
            overflow: e + a
        };
    }
    return {
        id: 1 << e | c << f | d,
        overflow: a
    };
}
var $3fdb7eddda9a9ee5$var$H = Math.clz32 ? Math.clz32 : $3fdb7eddda9a9ee5$var$hb, $3fdb7eddda9a9ee5$var$ib = Math.log, $3fdb7eddda9a9ee5$var$jb = Math.LN2;
function $3fdb7eddda9a9ee5$var$hb(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($3fdb7eddda9a9ee5$var$ib(a) / $3fdb7eddda9a9ee5$var$jb | 0) | 0;
}
function $3fdb7eddda9a9ee5$var$kb(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $3fdb7eddda9a9ee5$var$lb = "function" === typeof Object.is ? Object.is : $3fdb7eddda9a9ee5$var$kb, $3fdb7eddda9a9ee5$var$I = null, $3fdb7eddda9a9ee5$var$ob = null, $3fdb7eddda9a9ee5$var$J = null, $3fdb7eddda9a9ee5$var$K = null, $3fdb7eddda9a9ee5$var$L = !1, $3fdb7eddda9a9ee5$var$M = !1, $3fdb7eddda9a9ee5$var$N = 0, $3fdb7eddda9a9ee5$var$O = null, $3fdb7eddda9a9ee5$var$P = 0;
function $3fdb7eddda9a9ee5$var$Q() {
    if (null === $3fdb7eddda9a9ee5$var$I) throw Error($3fdb7eddda9a9ee5$var$l(321));
    return $3fdb7eddda9a9ee5$var$I;
}
function $3fdb7eddda9a9ee5$var$pb() {
    if (0 < $3fdb7eddda9a9ee5$var$P) throw Error($3fdb7eddda9a9ee5$var$l(312));
    return {
        memoizedState: null,
        queue: null,
        next: null
    };
}
function $3fdb7eddda9a9ee5$var$qb() {
    null === $3fdb7eddda9a9ee5$var$K ? null === $3fdb7eddda9a9ee5$var$J ? ($3fdb7eddda9a9ee5$var$L = !1, $3fdb7eddda9a9ee5$var$J = $3fdb7eddda9a9ee5$var$K = $3fdb7eddda9a9ee5$var$pb()) : ($3fdb7eddda9a9ee5$var$L = !0, $3fdb7eddda9a9ee5$var$K = $3fdb7eddda9a9ee5$var$J) : null === $3fdb7eddda9a9ee5$var$K.next ? ($3fdb7eddda9a9ee5$var$L = !1, $3fdb7eddda9a9ee5$var$K = $3fdb7eddda9a9ee5$var$K.next = $3fdb7eddda9a9ee5$var$pb()) : ($3fdb7eddda9a9ee5$var$L = !0, $3fdb7eddda9a9ee5$var$K = $3fdb7eddda9a9ee5$var$K.next);
    return $3fdb7eddda9a9ee5$var$K;
}
function $3fdb7eddda9a9ee5$var$rb() {
    $3fdb7eddda9a9ee5$var$ob = $3fdb7eddda9a9ee5$var$I = null;
    $3fdb7eddda9a9ee5$var$M = !1;
    $3fdb7eddda9a9ee5$var$J = null;
    $3fdb7eddda9a9ee5$var$P = 0;
    $3fdb7eddda9a9ee5$var$K = $3fdb7eddda9a9ee5$var$O = null;
}
function $3fdb7eddda9a9ee5$var$sb(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $3fdb7eddda9a9ee5$var$tb(a, b, c) {
    $3fdb7eddda9a9ee5$var$I = $3fdb7eddda9a9ee5$var$Q();
    $3fdb7eddda9a9ee5$var$K = $3fdb7eddda9a9ee5$var$qb();
    if ($3fdb7eddda9a9ee5$var$L) {
        var d = $3fdb7eddda9a9ee5$var$K.queue;
        b = d.dispatch;
        if (null !== $3fdb7eddda9a9ee5$var$O && (c = $3fdb7eddda9a9ee5$var$O.get(d), void 0 !== c)) {
            $3fdb7eddda9a9ee5$var$O.delete(d);
            d = $3fdb7eddda9a9ee5$var$K.memoizedState;
            do d = a(d, c.action), c = c.next;
            while (null !== c);
            $3fdb7eddda9a9ee5$var$K.memoizedState = d;
            return [
                d,
                b
            ];
        }
        return [
            $3fdb7eddda9a9ee5$var$K.memoizedState,
            b
        ];
    }
    a = a === $3fdb7eddda9a9ee5$var$sb ? "function" === typeof b ? b() : b : void 0 !== c ? c(b) : b;
    $3fdb7eddda9a9ee5$var$K.memoizedState = a;
    a = $3fdb7eddda9a9ee5$var$K.queue = {
        last: null,
        dispatch: null
    };
    a = a.dispatch = $3fdb7eddda9a9ee5$var$ub.bind(null, $3fdb7eddda9a9ee5$var$I, a);
    return [
        $3fdb7eddda9a9ee5$var$K.memoizedState,
        a
    ];
}
function $3fdb7eddda9a9ee5$var$vb(a, b) {
    $3fdb7eddda9a9ee5$var$I = $3fdb7eddda9a9ee5$var$Q();
    $3fdb7eddda9a9ee5$var$K = $3fdb7eddda9a9ee5$var$qb();
    b = void 0 === b ? null : b;
    if (null !== $3fdb7eddda9a9ee5$var$K) {
        var c = $3fdb7eddda9a9ee5$var$K.memoizedState;
        if (null !== c && null !== b) {
            var d = c[1];
            a: if (null === d) d = !1;
            else {
                for(var f = 0; f < d.length && f < b.length; f++)if (!$3fdb7eddda9a9ee5$var$lb(b[f], d[f])) {
                    d = !1;
                    break a;
                }
                d = !0;
            }
            if (d) return c[0];
        }
    }
    a = a();
    $3fdb7eddda9a9ee5$var$K.memoizedState = [
        a,
        b
    ];
    return a;
}
function $3fdb7eddda9a9ee5$var$ub(a, b, c) {
    if (25 <= $3fdb7eddda9a9ee5$var$P) throw Error($3fdb7eddda9a9ee5$var$l(301));
    if (a === $3fdb7eddda9a9ee5$var$I) {
        if ($3fdb7eddda9a9ee5$var$M = !0, a = {
            action: c,
            next: null
        }, null === $3fdb7eddda9a9ee5$var$O && ($3fdb7eddda9a9ee5$var$O = new Map), c = $3fdb7eddda9a9ee5$var$O.get(b), void 0 === c) $3fdb7eddda9a9ee5$var$O.set(b, a);
        else {
            for(b = c; null !== b.next;)b = b.next;
            b.next = a;
        }
    }
}
function $3fdb7eddda9a9ee5$var$wb() {
    throw Error($3fdb7eddda9a9ee5$var$l(394));
}
function $3fdb7eddda9a9ee5$var$R() {}
var $3fdb7eddda9a9ee5$var$xb = {
    readContext: function(a) {
        return a._currentValue2;
    },
    useContext: function(a) {
        $3fdb7eddda9a9ee5$var$Q();
        return a._currentValue2;
    },
    useMemo: $3fdb7eddda9a9ee5$var$vb,
    useReducer: $3fdb7eddda9a9ee5$var$tb,
    useRef: function(a) {
        $3fdb7eddda9a9ee5$var$I = $3fdb7eddda9a9ee5$var$Q();
        $3fdb7eddda9a9ee5$var$K = $3fdb7eddda9a9ee5$var$qb();
        var b = $3fdb7eddda9a9ee5$var$K.memoizedState;
        return null === b ? (a = {
            current: a
        }, $3fdb7eddda9a9ee5$var$K.memoizedState = a) : b;
    },
    useState: function(a) {
        return $3fdb7eddda9a9ee5$var$tb($3fdb7eddda9a9ee5$var$sb, a);
    },
    useInsertionEffect: $3fdb7eddda9a9ee5$var$R,
    useLayoutEffect: function() {},
    useCallback: function(a, b) {
        return $3fdb7eddda9a9ee5$var$vb(function() {
            return a;
        }, b);
    },
    useImperativeHandle: $3fdb7eddda9a9ee5$var$R,
    useEffect: $3fdb7eddda9a9ee5$var$R,
    useDebugValue: $3fdb7eddda9a9ee5$var$R,
    useDeferredValue: function(a) {
        $3fdb7eddda9a9ee5$var$Q();
        return a;
    },
    useTransition: function() {
        $3fdb7eddda9a9ee5$var$Q();
        return [
            !1,
            $3fdb7eddda9a9ee5$var$wb
        ];
    },
    useId: function() {
        var a = $3fdb7eddda9a9ee5$var$ob.treeContext;
        var b = a.overflow;
        a = a.id;
        a = (a & ~(1 << 32 - $3fdb7eddda9a9ee5$var$H(a) - 1)).toString(32) + b;
        var c = $3fdb7eddda9a9ee5$var$S;
        if (null === c) throw Error($3fdb7eddda9a9ee5$var$l(404));
        b = $3fdb7eddda9a9ee5$var$N++;
        a = ":" + c.idPrefix + "R" + a;
        0 < b && (a += "H" + b.toString(32));
        return a + ":";
    },
    useMutableSource: function(a, b) {
        $3fdb7eddda9a9ee5$var$Q();
        return b(a._source);
    },
    useSyncExternalStore: function(a, b, c) {
        if (void 0 === c) throw Error($3fdb7eddda9a9ee5$var$l(407));
        return c();
    }
}, $3fdb7eddda9a9ee5$var$S = null, $3fdb7eddda9a9ee5$var$yb = $eeH7J.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentDispatcher;
function $3fdb7eddda9a9ee5$var$zb(a) {
    console.error(a);
    return null;
}
function $3fdb7eddda9a9ee5$var$T() {}
function $3fdb7eddda9a9ee5$var$Ab(a, b, c, d, f, e, g, h, k) {
    var m = [], n = new Set;
    b = {
        destination: null,
        responseState: b,
        progressiveChunkSize: void 0 === d ? 12800 : d,
        status: 0,
        fatalError: null,
        nextSegmentId: 0,
        allPendingTasks: 0,
        pendingRootTasks: 0,
        completedRootSegment: null,
        abortableTasks: n,
        pingedTasks: m,
        clientRenderedBoundaries: [],
        completedBoundaries: [],
        partialBoundaries: [],
        onError: void 0 === f ? $3fdb7eddda9a9ee5$var$zb : f,
        onAllReady: void 0 === e ? $3fdb7eddda9a9ee5$var$T : e,
        onShellReady: void 0 === g ? $3fdb7eddda9a9ee5$var$T : g,
        onShellError: void 0 === h ? $3fdb7eddda9a9ee5$var$T : h,
        onFatalError: void 0 === k ? $3fdb7eddda9a9ee5$var$T : k
    };
    c = $3fdb7eddda9a9ee5$var$U(b, 0, null, c, !1, !1);
    c.parentFlushed = !0;
    a = $3fdb7eddda9a9ee5$var$Bb(b, a, null, c, n, $3fdb7eddda9a9ee5$var$Ya, null, $3fdb7eddda9a9ee5$var$fb);
    m.push(a);
    return b;
}
function $3fdb7eddda9a9ee5$var$Bb(a, b, c, d, f, e, g, h) {
    a.allPendingTasks++;
    null === c ? a.pendingRootTasks++ : c.pendingTasks++;
    var k = {
        node: b,
        ping: function() {
            var b = a.pingedTasks;
            b.push(k);
            1 === b.length && $3fdb7eddda9a9ee5$var$Cb(a);
        },
        blockedBoundary: c,
        blockedSegment: d,
        abortSet: f,
        legacyContext: e,
        context: g,
        treeContext: h
    };
    f.add(k);
    return k;
}
function $3fdb7eddda9a9ee5$var$U(a, b, c, d, f, e) {
    return {
        status: 0,
        id: -1,
        index: b,
        parentFlushed: !1,
        chunks: [],
        children: [],
        formatContext: d,
        boundary: c,
        lastPushedText: f,
        textEmbedded: e
    };
}
function $3fdb7eddda9a9ee5$var$V(a, b) {
    a = a.onError(b);
    if (null != a && "string" !== typeof a) throw Error('onError returned something with a type other than "string". onError should return a string and may return null or undefined but must not return anything else. It received something of type "' + typeof a + '" instead');
    return a;
}
function $3fdb7eddda9a9ee5$var$W(a, b) {
    var c = a.onShellError;
    c(b);
    c = a.onFatalError;
    c(b);
    null !== a.destination ? (a.status = 2, a.destination.destroy(b)) : (a.status = 1, a.fatalError = b);
}
function $3fdb7eddda9a9ee5$var$Db(a, b, c, d, f) {
    $3fdb7eddda9a9ee5$var$I = {};
    $3fdb7eddda9a9ee5$var$ob = b;
    $3fdb7eddda9a9ee5$var$N = 0;
    for(a = c(d, f); $3fdb7eddda9a9ee5$var$M;)$3fdb7eddda9a9ee5$var$M = !1, $3fdb7eddda9a9ee5$var$N = 0, $3fdb7eddda9a9ee5$var$P += 1, $3fdb7eddda9a9ee5$var$K = null, a = c(d, f);
    $3fdb7eddda9a9ee5$var$rb();
    return a;
}
function $3fdb7eddda9a9ee5$var$Eb(a, b, c, d) {
    var f = c.render(), e = d.childContextTypes;
    if (null !== e && void 0 !== e) {
        var g = b.legacyContext;
        if ("function" !== typeof c.getChildContext) d = g;
        else {
            c = c.getChildContext();
            for(var h in c)if (!(h in e)) throw Error($3fdb7eddda9a9ee5$var$l(108, $3fdb7eddda9a9ee5$var$Xa(d) || "Unknown", h));
            d = $3fdb7eddda9a9ee5$var$B({}, g, c);
        }
        b.legacyContext = d;
        $3fdb7eddda9a9ee5$var$X(a, b, f);
        b.legacyContext = g;
    } else $3fdb7eddda9a9ee5$var$X(a, b, f);
}
function $3fdb7eddda9a9ee5$var$Fb(a, b) {
    if (a && a.defaultProps) {
        b = $3fdb7eddda9a9ee5$var$B({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $3fdb7eddda9a9ee5$var$Gb(a, b, c, d, f) {
    if ("function" === typeof c) {
        if (c.prototype && c.prototype.isReactComponent) {
            f = $3fdb7eddda9a9ee5$var$Za(c, b.legacyContext);
            var e = c.contextType;
            e = new c(d, "object" === typeof e && null !== e ? e._currentValue2 : f);
            $3fdb7eddda9a9ee5$var$eb(e, c, d, f);
            $3fdb7eddda9a9ee5$var$Eb(a, b, e, c);
        } else {
            e = $3fdb7eddda9a9ee5$var$Za(c, b.legacyContext);
            f = $3fdb7eddda9a9ee5$var$Db(a, b, c, d, e);
            var g = 0 !== $3fdb7eddda9a9ee5$var$N;
            if ("object" === typeof f && null !== f && "function" === typeof f.render && void 0 === f.$$typeof) $3fdb7eddda9a9ee5$var$eb(f, c, d, e), $3fdb7eddda9a9ee5$var$Eb(a, b, f, c);
            else if (g) {
                d = b.treeContext;
                b.treeContext = $3fdb7eddda9a9ee5$var$gb(d, 1, 0);
                try {
                    $3fdb7eddda9a9ee5$var$X(a, b, f);
                } finally{
                    b.treeContext = d;
                }
            } else $3fdb7eddda9a9ee5$var$X(a, b, f);
        }
    } else if ("string" === typeof c) {
        f = b.blockedSegment;
        e = $3fdb7eddda9a9ee5$var$ya(f.chunks, c, d, a.responseState, f.formatContext);
        f.lastPushedText = !1;
        g = f.formatContext;
        f.formatContext = $3fdb7eddda9a9ee5$var$ra(g, c, d);
        $3fdb7eddda9a9ee5$var$Hb(a, b, e);
        f.formatContext = g;
        switch(c){
            case "area":
            case "base":
            case "br":
            case "col":
            case "embed":
            case "hr":
            case "img":
            case "input":
            case "keygen":
            case "link":
            case "meta":
            case "param":
            case "source":
            case "track":
            case "wbr":
                break;
            default:
                f.chunks.push("</", c, ">");
        }
        f.lastPushedText = !1;
    } else {
        switch(c){
            case $3fdb7eddda9a9ee5$var$Ua:
            case $3fdb7eddda9a9ee5$var$Ta:
            case $3fdb7eddda9a9ee5$var$Ja:
            case $3fdb7eddda9a9ee5$var$Ka:
            case $3fdb7eddda9a9ee5$var$Ia:
                $3fdb7eddda9a9ee5$var$X(a, b, d.children);
                return;
            case $3fdb7eddda9a9ee5$var$Pa:
                $3fdb7eddda9a9ee5$var$X(a, b, d.children);
                return;
            case $3fdb7eddda9a9ee5$var$Sa:
                throw Error($3fdb7eddda9a9ee5$var$l(343));
            case $3fdb7eddda9a9ee5$var$Oa:
                a: {
                    c = b.blockedBoundary;
                    f = b.blockedSegment;
                    e = d.fallback;
                    d = d.children;
                    g = new Set;
                    var h = {
                        id: null,
                        rootSegmentID: -1,
                        parentFlushed: !1,
                        pendingTasks: 0,
                        forceClientRender: !1,
                        completedSegments: [],
                        byteSize: 0,
                        fallbackAbortableTasks: g,
                        errorDigest: null
                    }, k = $3fdb7eddda9a9ee5$var$U(a, f.chunks.length, h, f.formatContext, !1, !1);
                    f.children.push(k);
                    f.lastPushedText = !1;
                    var m = $3fdb7eddda9a9ee5$var$U(a, 0, null, f.formatContext, !1, !1);
                    m.parentFlushed = !0;
                    b.blockedBoundary = h;
                    b.blockedSegment = m;
                    try {
                        if ($3fdb7eddda9a9ee5$var$Hb(a, b, d), a.responseState.generateStaticMarkup || m.lastPushedText && m.textEmbedded && m.chunks.push("<!-- -->"), m.status = 1, $3fdb7eddda9a9ee5$var$Y(h, m), 0 === h.pendingTasks) break a;
                    } catch (n) {
                        m.status = 4, h.forceClientRender = !0, h.errorDigest = $3fdb7eddda9a9ee5$var$V(a, n);
                    } finally{
                        b.blockedBoundary = c, b.blockedSegment = f;
                    }
                    b = $3fdb7eddda9a9ee5$var$Bb(a, e, c, k, g, b.legacyContext, b.context, b.treeContext);
                    a.pingedTasks.push(b);
                }
                return;
        }
        if ("object" === typeof c && null !== c) switch(c.$$typeof){
            case $3fdb7eddda9a9ee5$var$Na:
                d = $3fdb7eddda9a9ee5$var$Db(a, b, c.render, d, f);
                if (0 !== $3fdb7eddda9a9ee5$var$N) {
                    c = b.treeContext;
                    b.treeContext = $3fdb7eddda9a9ee5$var$gb(c, 1, 0);
                    try {
                        $3fdb7eddda9a9ee5$var$X(a, b, d);
                    } finally{
                        b.treeContext = c;
                    }
                } else $3fdb7eddda9a9ee5$var$X(a, b, d);
                return;
            case $3fdb7eddda9a9ee5$var$Qa:
                c = c.type;
                d = $3fdb7eddda9a9ee5$var$Fb(c, d);
                $3fdb7eddda9a9ee5$var$Gb(a, b, c, d, f);
                return;
            case $3fdb7eddda9a9ee5$var$La:
                f = d.children;
                c = c._context;
                d = d.value;
                e = c._currentValue2;
                c._currentValue2 = d;
                g = $3fdb7eddda9a9ee5$var$E;
                $3fdb7eddda9a9ee5$var$E = d = {
                    parent: g,
                    depth: null === g ? 0 : g.depth + 1,
                    context: c,
                    parentValue: e,
                    value: d
                };
                b.context = d;
                $3fdb7eddda9a9ee5$var$X(a, b, f);
                a = $3fdb7eddda9a9ee5$var$E;
                if (null === a) throw Error($3fdb7eddda9a9ee5$var$l(403));
                d = a.parentValue;
                a.context._currentValue2 = d === $3fdb7eddda9a9ee5$var$Va ? a.context._defaultValue : d;
                a = $3fdb7eddda9a9ee5$var$E = a.parent;
                b.context = a;
                return;
            case $3fdb7eddda9a9ee5$var$Ma:
                d = d.children;
                d = d(c._currentValue2);
                $3fdb7eddda9a9ee5$var$X(a, b, d);
                return;
            case $3fdb7eddda9a9ee5$var$Ra:
                f = c._init;
                c = f(c._payload);
                d = $3fdb7eddda9a9ee5$var$Fb(c, d);
                $3fdb7eddda9a9ee5$var$Gb(a, b, c, d, void 0);
                return;
        }
        throw Error($3fdb7eddda9a9ee5$var$l(130, null == c ? c : typeof c, ""));
    }
}
function $3fdb7eddda9a9ee5$var$X(a, b, c) {
    b.node = c;
    if ("object" === typeof c && null !== c) {
        switch(c.$$typeof){
            case $3fdb7eddda9a9ee5$var$Ga:
                $3fdb7eddda9a9ee5$var$Gb(a, b, c.type, c.props, c.ref);
                return;
            case $3fdb7eddda9a9ee5$var$Ha:
                throw Error($3fdb7eddda9a9ee5$var$l(257));
            case $3fdb7eddda9a9ee5$var$Ra:
                var d = c._init;
                c = d(c._payload);
                $3fdb7eddda9a9ee5$var$X(a, b, c);
                return;
        }
        if ($3fdb7eddda9a9ee5$var$qa(c)) {
            $3fdb7eddda9a9ee5$var$Ib(a, b, c);
            return;
        }
        null === c || "object" !== typeof c ? d = null : (d = $3fdb7eddda9a9ee5$var$Wa && c[$3fdb7eddda9a9ee5$var$Wa] || c["@@iterator"], d = "function" === typeof d ? d : null);
        if (d && (d = d.call(c))) {
            c = d.next();
            if (!c.done) {
                var f = [];
                do f.push(c.value), c = d.next();
                while (!c.done);
                $3fdb7eddda9a9ee5$var$Ib(a, b, f);
            }
            return;
        }
        a = Object.prototype.toString.call(c);
        throw Error($3fdb7eddda9a9ee5$var$l(31, "[object Object]" === a ? "object with keys {" + Object.keys(c).join(", ") + "}" : a));
    }
    "string" === typeof c ? (d = b.blockedSegment, d.lastPushedText = $3fdb7eddda9a9ee5$var$Fa(b.blockedSegment.chunks, c, a.responseState, d.lastPushedText)) : "number" === typeof c && (d = b.blockedSegment, d.lastPushedText = $3fdb7eddda9a9ee5$var$Fa(b.blockedSegment.chunks, "" + c, a.responseState, d.lastPushedText));
}
function $3fdb7eddda9a9ee5$var$Ib(a, b, c) {
    for(var d = c.length, f = 0; f < d; f++){
        var e = b.treeContext;
        b.treeContext = $3fdb7eddda9a9ee5$var$gb(e, d, f);
        try {
            $3fdb7eddda9a9ee5$var$Hb(a, b, c[f]);
        } finally{
            b.treeContext = e;
        }
    }
}
function $3fdb7eddda9a9ee5$var$Hb(a, b, c) {
    var d = b.blockedSegment.formatContext, f = b.legacyContext, e = b.context;
    try {
        return $3fdb7eddda9a9ee5$var$X(a, b, c);
    } catch (k) {
        if ($3fdb7eddda9a9ee5$var$rb(), "object" === typeof k && null !== k && "function" === typeof k.then) {
            c = k;
            var g = b.blockedSegment, h = $3fdb7eddda9a9ee5$var$U(a, g.chunks.length, null, g.formatContext, g.lastPushedText, !0);
            g.children.push(h);
            g.lastPushedText = !1;
            a = $3fdb7eddda9a9ee5$var$Bb(a, b.node, b.blockedBoundary, h, b.abortSet, b.legacyContext, b.context, b.treeContext).ping;
            c.then(a, a);
            b.blockedSegment.formatContext = d;
            b.legacyContext = f;
            b.context = e;
            $3fdb7eddda9a9ee5$var$G(e);
        } else throw b.blockedSegment.formatContext = d, b.legacyContext = f, b.context = e, $3fdb7eddda9a9ee5$var$G(e), k;
    }
}
function $3fdb7eddda9a9ee5$var$Jb(a) {
    var b = a.blockedBoundary;
    a = a.blockedSegment;
    a.status = 3;
    $3fdb7eddda9a9ee5$var$Kb(this, b, a);
}
function $3fdb7eddda9a9ee5$var$Lb(a, b, c) {
    var d = a.blockedBoundary;
    a.blockedSegment.status = 3;
    null === d ? (b.allPendingTasks--, 2 !== b.status && (b.status = 2, null !== b.destination && b.destination.push(null))) : (d.pendingTasks--, d.forceClientRender || (d.forceClientRender = !0, a = void 0 === c ? Error($3fdb7eddda9a9ee5$var$l(432)) : c, d.errorDigest = b.onError(a), d.parentFlushed && b.clientRenderedBoundaries.push(d)), d.fallbackAbortableTasks.forEach(function(a) {
        return $3fdb7eddda9a9ee5$var$Lb(a, b, c);
    }), d.fallbackAbortableTasks.clear(), b.allPendingTasks--, 0 === b.allPendingTasks && (d = b.onAllReady, d()));
}
function $3fdb7eddda9a9ee5$var$Y(a, b) {
    if (0 === b.chunks.length && 1 === b.children.length && null === b.children[0].boundary) {
        var c = b.children[0];
        c.id = b.id;
        c.parentFlushed = !0;
        1 === c.status && $3fdb7eddda9a9ee5$var$Y(a, c);
    } else a.completedSegments.push(b);
}
function $3fdb7eddda9a9ee5$var$Kb(a, b, c) {
    if (null === b) {
        if (c.parentFlushed) {
            if (null !== a.completedRootSegment) throw Error($3fdb7eddda9a9ee5$var$l(389));
            a.completedRootSegment = c;
        }
        a.pendingRootTasks--;
        0 === a.pendingRootTasks && (a.onShellError = $3fdb7eddda9a9ee5$var$T, b = a.onShellReady, b());
    } else b.pendingTasks--, b.forceClientRender || (0 === b.pendingTasks ? (c.parentFlushed && 1 === c.status && $3fdb7eddda9a9ee5$var$Y(b, c), b.parentFlushed && a.completedBoundaries.push(b), b.fallbackAbortableTasks.forEach($3fdb7eddda9a9ee5$var$Jb, a), b.fallbackAbortableTasks.clear()) : c.parentFlushed && 1 === c.status && ($3fdb7eddda9a9ee5$var$Y(b, c), 1 === b.completedSegments.length && b.parentFlushed && a.partialBoundaries.push(b)));
    a.allPendingTasks--;
    0 === a.allPendingTasks && (a = a.onAllReady, a());
}
function $3fdb7eddda9a9ee5$var$Cb(a) {
    if (2 !== a.status) {
        var b = $3fdb7eddda9a9ee5$var$E, c = $3fdb7eddda9a9ee5$var$yb.current;
        $3fdb7eddda9a9ee5$var$yb.current = $3fdb7eddda9a9ee5$var$xb;
        var d = $3fdb7eddda9a9ee5$var$S;
        $3fdb7eddda9a9ee5$var$S = a.responseState;
        try {
            var f = a.pingedTasks, e;
            for(e = 0; e < f.length; e++){
                var g = f[e];
                var h = a, k = g.blockedSegment;
                if (0 === k.status) {
                    $3fdb7eddda9a9ee5$var$G(g.context);
                    try {
                        $3fdb7eddda9a9ee5$var$X(h, g, g.node), h.responseState.generateStaticMarkup || k.lastPushedText && k.textEmbedded && k.chunks.push("<!-- -->"), g.abortSet.delete(g), k.status = 1, $3fdb7eddda9a9ee5$var$Kb(h, g.blockedBoundary, k);
                    } catch (z) {
                        if ($3fdb7eddda9a9ee5$var$rb(), "object" === typeof z && null !== z && "function" === typeof z.then) {
                            var m = g.ping;
                            z.then(m, m);
                        } else {
                            g.abortSet.delete(g);
                            k.status = 4;
                            var n = g.blockedBoundary, q = z, C = $3fdb7eddda9a9ee5$var$V(h, q);
                            null === n ? $3fdb7eddda9a9ee5$var$W(h, q) : (n.pendingTasks--, n.forceClientRender || (n.forceClientRender = !0, n.errorDigest = C, n.parentFlushed && h.clientRenderedBoundaries.push(n)));
                            h.allPendingTasks--;
                            if (0 === h.allPendingTasks) {
                                var D = h.onAllReady;
                                D();
                            }
                        }
                    } finally{}
                }
            }
            f.splice(0, e);
            null !== a.destination && $3fdb7eddda9a9ee5$var$Mb(a, a.destination);
        } catch (z) {
            $3fdb7eddda9a9ee5$var$V(a, z), $3fdb7eddda9a9ee5$var$W(a, z);
        } finally{
            $3fdb7eddda9a9ee5$var$S = d, $3fdb7eddda9a9ee5$var$yb.current = c, c === $3fdb7eddda9a9ee5$var$xb && $3fdb7eddda9a9ee5$var$G(b);
        }
    }
}
function $3fdb7eddda9a9ee5$var$Z(a, b, c) {
    c.parentFlushed = !0;
    switch(c.status){
        case 0:
            var d = c.id = a.nextSegmentId++;
            c.lastPushedText = !1;
            c.textEmbedded = !1;
            a = a.responseState;
            b.push('<template id="');
            b.push(a.placeholderPrefix);
            a = d.toString(16);
            b.push(a);
            return b.push('"></template>');
        case 1:
            c.status = 2;
            var f = !0;
            d = c.chunks;
            var e = 0;
            c = c.children;
            for(var g = 0; g < c.length; g++){
                for(f = c[g]; e < f.index; e++)b.push(d[e]);
                f = $3fdb7eddda9a9ee5$var$Nb(a, b, f);
            }
            for(; e < d.length - 1; e++)b.push(d[e]);
            e < d.length && (f = b.push(d[e]));
            return f;
        default:
            throw Error($3fdb7eddda9a9ee5$var$l(390));
    }
}
function $3fdb7eddda9a9ee5$var$Nb(a, b, c) {
    var d = c.boundary;
    if (null === d) return $3fdb7eddda9a9ee5$var$Z(a, b, c);
    d.parentFlushed = !0;
    if (d.forceClientRender) return a.responseState.generateStaticMarkup || (d = d.errorDigest, b.push("<!--$!-->"), b.push("<template"), d && (b.push(' data-dgst="'), d = $3fdb7eddda9a9ee5$var$v(d), b.push(d), b.push('"')), b.push("></template>")), $3fdb7eddda9a9ee5$var$Z(a, b, c), a = a.responseState.generateStaticMarkup ? !0 : b.push("<!--/$-->"), a;
    if (0 < d.pendingTasks) {
        d.rootSegmentID = a.nextSegmentId++;
        0 < d.completedSegments.length && a.partialBoundaries.push(d);
        var f = a.responseState;
        var e = f.nextSuspenseID++;
        f = f.boundaryPrefix + e.toString(16);
        d = d.id = f;
        $3fdb7eddda9a9ee5$var$za(b, a.responseState, d);
        $3fdb7eddda9a9ee5$var$Z(a, b, c);
        return b.push("<!--/$-->");
    }
    if (d.byteSize > a.progressiveChunkSize) return d.rootSegmentID = a.nextSegmentId++, a.completedBoundaries.push(d), $3fdb7eddda9a9ee5$var$za(b, a.responseState, d.id), $3fdb7eddda9a9ee5$var$Z(a, b, c), b.push("<!--/$-->");
    a.responseState.generateStaticMarkup || b.push("<!--$-->");
    c = d.completedSegments;
    if (1 !== c.length) throw Error($3fdb7eddda9a9ee5$var$l(391));
    $3fdb7eddda9a9ee5$var$Nb(a, b, c[0]);
    a = a.responseState.generateStaticMarkup ? !0 : b.push("<!--/$-->");
    return a;
}
function $3fdb7eddda9a9ee5$var$Ob(a, b, c) {
    $3fdb7eddda9a9ee5$var$Aa(b, a.responseState, c.formatContext, c.id);
    $3fdb7eddda9a9ee5$var$Nb(a, b, c);
    return $3fdb7eddda9a9ee5$var$Ba(b, c.formatContext);
}
function $3fdb7eddda9a9ee5$var$Pb(a, b, c) {
    for(var d = c.completedSegments, f = 0; f < d.length; f++)$3fdb7eddda9a9ee5$var$Qb(a, b, c, d[f]);
    d.length = 0;
    a = a.responseState;
    d = c.id;
    c = c.rootSegmentID;
    b.push(a.startInlineScript);
    a.sentCompleteBoundaryFunction ? b.push('$RC("') : (a.sentCompleteBoundaryFunction = !0, b.push('function $RC(a,b){a=document.getElementById(a);b=document.getElementById(b);b.parentNode.removeChild(b);if(a){a=a.previousSibling;var f=a.parentNode,c=a.nextSibling,e=0;do{if(c&&8===c.nodeType){var d=c.data;if("/$"===d)if(0===e)break;else e--;else"$"!==d&&"$?"!==d&&"$!"!==d||e++}d=c.nextSibling;f.removeChild(c);c=d}while(c);for(;b.firstChild;)f.insertBefore(b.firstChild,c);a.data="$";a._reactRetry&&a._reactRetry()}};$RC("'));
    if (null === d) throw Error($3fdb7eddda9a9ee5$var$l(395));
    c = c.toString(16);
    b.push(d);
    b.push('","');
    b.push(a.segmentPrefix);
    b.push(c);
    return b.push('")</script>');
}
function $3fdb7eddda9a9ee5$var$Qb(a, b, c, d) {
    if (2 === d.status) return !0;
    var f = d.id;
    if (-1 === f) {
        if (-1 === (d.id = c.rootSegmentID)) throw Error($3fdb7eddda9a9ee5$var$l(392));
        return $3fdb7eddda9a9ee5$var$Ob(a, b, d);
    }
    $3fdb7eddda9a9ee5$var$Ob(a, b, d);
    a = a.responseState;
    b.push(a.startInlineScript);
    a.sentCompleteSegmentFunction ? b.push('$RS("') : (a.sentCompleteSegmentFunction = !0, b.push('function $RS(a,b){a=document.getElementById(a);b=document.getElementById(b);for(a.parentNode.removeChild(a);a.firstChild;)b.parentNode.insertBefore(a.firstChild,b);b.parentNode.removeChild(b)};$RS("'));
    b.push(a.segmentPrefix);
    f = f.toString(16);
    b.push(f);
    b.push('","');
    b.push(a.placeholderPrefix);
    b.push(f);
    return b.push('")</script>');
}
function $3fdb7eddda9a9ee5$var$Mb(a, b) {
    try {
        var c = a.completedRootSegment;
        if (null !== c && 0 === a.pendingRootTasks) {
            $3fdb7eddda9a9ee5$var$Nb(a, b, c);
            a.completedRootSegment = null;
            var d = a.responseState.bootstrapChunks;
            for(c = 0; c < d.length - 1; c++)b.push(d[c]);
            c < d.length && b.push(d[c]);
        }
        var f = a.clientRenderedBoundaries, e;
        for(e = 0; e < f.length; e++){
            var g = f[e];
            d = b;
            var h = a.responseState, k = g.id, m = g.errorDigest, n = g.errorMessage, q = g.errorComponentStack;
            d.push(h.startInlineScript);
            h.sentClientRenderFunction ? d.push('$RX("') : (h.sentClientRenderFunction = !0, d.push('function $RX(b,c,d,e){var a=document.getElementById(b);a&&(b=a.previousSibling,b.data="$!",a=a.dataset,c&&(a.dgst=c),d&&(a.msg=d),e&&(a.stck=e),b._reactRetry&&b._reactRetry())};$RX("'));
            if (null === k) throw Error($3fdb7eddda9a9ee5$var$l(395));
            d.push(k);
            d.push('"');
            if (m || n || q) {
                d.push(",");
                var C = $3fdb7eddda9a9ee5$var$Da(m || "");
                d.push(C);
            }
            if (n || q) {
                d.push(",");
                var D = $3fdb7eddda9a9ee5$var$Da(n || "");
                d.push(D);
            }
            if (q) {
                d.push(",");
                var z = $3fdb7eddda9a9ee5$var$Da(q);
                d.push(z);
            }
            if (!d.push(")</script>")) {
                a.destination = null;
                e++;
                f.splice(0, e);
                return;
            }
        }
        f.splice(0, e);
        var ba = a.completedBoundaries;
        for(e = 0; e < ba.length; e++)if (!$3fdb7eddda9a9ee5$var$Pb(a, b, ba[e])) {
            a.destination = null;
            e++;
            ba.splice(0, e);
            return;
        }
        ba.splice(0, e);
        var ca = a.partialBoundaries;
        for(e = 0; e < ca.length; e++){
            var mb = ca[e];
            a: {
                f = a;
                g = b;
                var da = mb.completedSegments;
                for(h = 0; h < da.length; h++)if (!$3fdb7eddda9a9ee5$var$Qb(f, g, mb, da[h])) {
                    h++;
                    da.splice(0, h);
                    var nb = !1;
                    break a;
                }
                da.splice(0, h);
                nb = !0;
            }
            if (!nb) {
                a.destination = null;
                e++;
                ca.splice(0, e);
                return;
            }
        }
        ca.splice(0, e);
        var ea = a.completedBoundaries;
        for(e = 0; e < ea.length; e++)if (!$3fdb7eddda9a9ee5$var$Pb(a, b, ea[e])) {
            a.destination = null;
            e++;
            ea.splice(0, e);
            return;
        }
        ea.splice(0, e);
    } finally{
        0 === a.allPendingTasks && 0 === a.pingedTasks.length && 0 === a.clientRenderedBoundaries.length && 0 === a.completedBoundaries.length && b.push(null);
    }
}
function $3fdb7eddda9a9ee5$var$Rb(a, b) {
    try {
        var c = a.abortableTasks;
        c.forEach(function(c) {
            return $3fdb7eddda9a9ee5$var$Lb(c, a, b);
        });
        c.clear();
        null !== a.destination && $3fdb7eddda9a9ee5$var$Mb(a, a.destination);
    } catch (d) {
        $3fdb7eddda9a9ee5$var$V(a, d), $3fdb7eddda9a9ee5$var$W(a, d);
    }
}
function $3fdb7eddda9a9ee5$var$Sb() {}
function $3fdb7eddda9a9ee5$var$Tb(a, b, c, d) {
    var f = !1, e = null, g = "", h = {
        push: function(a) {
            null !== a && (g += a);
            return !0;
        },
        destroy: function(a) {
            f = !0;
            e = a;
        }
    }, k = !1;
    a = $3fdb7eddda9a9ee5$var$Ab(a, $3fdb7eddda9a9ee5$var$Ea(c, b ? b.identifierPrefix : void 0), {
        insertionMode: 1,
        selectedValue: null
    }, Infinity, $3fdb7eddda9a9ee5$var$Sb, void 0, function() {
        k = !0;
    }, void 0, void 0);
    $3fdb7eddda9a9ee5$var$Cb(a);
    $3fdb7eddda9a9ee5$var$Rb(a, d);
    if (1 === a.status) a.status = 2, h.destroy(a.fatalError);
    else if (2 !== a.status && null === a.destination) {
        a.destination = h;
        try {
            $3fdb7eddda9a9ee5$var$Mb(a, h);
        } catch (m) {
            $3fdb7eddda9a9ee5$var$V(a, m), $3fdb7eddda9a9ee5$var$W(a, m);
        }
    }
    if (f) throw e;
    if (!k) throw Error($3fdb7eddda9a9ee5$var$l(426));
    return g;
}
$3fdb7eddda9a9ee5$export$307591e98609eddd = function() {
    throw Error($3fdb7eddda9a9ee5$var$l(207));
};
$3fdb7eddda9a9ee5$export$eb3a06aef9e6ee51 = function(a, b) {
    return $3fdb7eddda9a9ee5$var$Tb(a, b, !0, 'The server used "renderToStaticMarkup" which does not support Suspense. If you intended to have the server wait for the suspended component please switch to "renderToReadableStream" which supports Suspense on the server');
};
$3fdb7eddda9a9ee5$export$b23711c915539651 = function() {
    throw Error($3fdb7eddda9a9ee5$var$l(208));
};
$3fdb7eddda9a9ee5$export$80e7718417253a51 = function(a, b) {
    return $3fdb7eddda9a9ee5$var$Tb(a, b, !1, 'The server used "renderToString" which does not support Suspense. If you intended for this Suspense boundary to render the fallback content on the server consider throwing an Error somewhere within the Suspense boundary. If you intended to have the server wait for the suspended component please switch to "renderToReadableStream" which supports Suspense on the server');
};
$3fdb7eddda9a9ee5$export$83d89fbfd8236492 = "18.3.1";

});

parcelRegister("4UUdh", function(module, exports) {

$parcel$export(module.exports, "renderToReadableStream", function () { return $3947ff2ea3645b8c$export$7020a3240b287705; }, function (v) { return $3947ff2ea3645b8c$export$7020a3240b287705 = v; });
$parcel$export(module.exports, "version", function () { return $3947ff2ea3645b8c$export$83d89fbfd8236492; }, function (v) { return $3947ff2ea3645b8c$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom-server.browser.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $3947ff2ea3645b8c$export$7020a3240b287705;
var $3947ff2ea3645b8c$export$83d89fbfd8236492;
"use strict";

var $eeH7J = parcelRequire("eeH7J");
function $3947ff2ea3645b8c$var$k(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $3947ff2ea3645b8c$var$l = null, $3947ff2ea3645b8c$var$n = 0;
function $3947ff2ea3645b8c$var$p(a, b) {
    if (0 !== b.length) {
        if (512 < b.length) 0 < $3947ff2ea3645b8c$var$n && (a.enqueue(new Uint8Array($3947ff2ea3645b8c$var$l.buffer, 0, $3947ff2ea3645b8c$var$n)), $3947ff2ea3645b8c$var$l = new Uint8Array(512), $3947ff2ea3645b8c$var$n = 0), a.enqueue(b);
        else {
            var c = $3947ff2ea3645b8c$var$l.length - $3947ff2ea3645b8c$var$n;
            c < b.length && (0 === c ? a.enqueue($3947ff2ea3645b8c$var$l) : ($3947ff2ea3645b8c$var$l.set(b.subarray(0, c), $3947ff2ea3645b8c$var$n), a.enqueue($3947ff2ea3645b8c$var$l), b = b.subarray(c)), $3947ff2ea3645b8c$var$l = new Uint8Array(512), $3947ff2ea3645b8c$var$n = 0);
            $3947ff2ea3645b8c$var$l.set(b, $3947ff2ea3645b8c$var$n);
            $3947ff2ea3645b8c$var$n += b.length;
        }
    }
}
function $3947ff2ea3645b8c$var$t(a, b) {
    $3947ff2ea3645b8c$var$p(a, b);
    return !0;
}
function $3947ff2ea3645b8c$var$ba(a) {
    $3947ff2ea3645b8c$var$l && 0 < $3947ff2ea3645b8c$var$n && (a.enqueue(new Uint8Array($3947ff2ea3645b8c$var$l.buffer, 0, $3947ff2ea3645b8c$var$n)), $3947ff2ea3645b8c$var$l = null, $3947ff2ea3645b8c$var$n = 0);
}
var $3947ff2ea3645b8c$var$ca = new TextEncoder;
function $3947ff2ea3645b8c$var$u(a) {
    return $3947ff2ea3645b8c$var$ca.encode(a);
}
function $3947ff2ea3645b8c$var$w(a) {
    return $3947ff2ea3645b8c$var$ca.encode(a);
}
function $3947ff2ea3645b8c$var$da(a, b) {
    "function" === typeof a.error ? a.error(b) : a.close();
}
var $3947ff2ea3645b8c$var$x = Object.prototype.hasOwnProperty, $3947ff2ea3645b8c$var$ea = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $3947ff2ea3645b8c$var$fa = {}, $3947ff2ea3645b8c$var$ha = {};
function $3947ff2ea3645b8c$var$ia(a) {
    if ($3947ff2ea3645b8c$var$x.call($3947ff2ea3645b8c$var$ha, a)) return !0;
    if ($3947ff2ea3645b8c$var$x.call($3947ff2ea3645b8c$var$fa, a)) return !1;
    if ($3947ff2ea3645b8c$var$ea.test(a)) return $3947ff2ea3645b8c$var$ha[a] = !0;
    $3947ff2ea3645b8c$var$fa[a] = !0;
    return !1;
}
function $3947ff2ea3645b8c$var$y(a, b, c, d, f, e, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = f;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = e;
    this.removeEmptyString = g;
}
var $3947ff2ea3645b8c$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $3947ff2ea3645b8c$var$z[a] = new $3947ff2ea3645b8c$var$y(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $3947ff2ea3645b8c$var$z[b] = new $3947ff2ea3645b8c$var$y(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $3947ff2ea3645b8c$var$z[a] = new $3947ff2ea3645b8c$var$y(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $3947ff2ea3645b8c$var$z[a] = new $3947ff2ea3645b8c$var$y(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $3947ff2ea3645b8c$var$z[a] = new $3947ff2ea3645b8c$var$y(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $3947ff2ea3645b8c$var$z[a] = new $3947ff2ea3645b8c$var$y(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $3947ff2ea3645b8c$var$z[a] = new $3947ff2ea3645b8c$var$y(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $3947ff2ea3645b8c$var$z[a] = new $3947ff2ea3645b8c$var$y(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $3947ff2ea3645b8c$var$z[a] = new $3947ff2ea3645b8c$var$y(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $3947ff2ea3645b8c$var$ja = /[\-:]([a-z])/g;
function $3947ff2ea3645b8c$var$ka(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($3947ff2ea3645b8c$var$ja, $3947ff2ea3645b8c$var$ka);
    $3947ff2ea3645b8c$var$z[b] = new $3947ff2ea3645b8c$var$y(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($3947ff2ea3645b8c$var$ja, $3947ff2ea3645b8c$var$ka);
    $3947ff2ea3645b8c$var$z[b] = new $3947ff2ea3645b8c$var$y(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($3947ff2ea3645b8c$var$ja, $3947ff2ea3645b8c$var$ka);
    $3947ff2ea3645b8c$var$z[b] = new $3947ff2ea3645b8c$var$y(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $3947ff2ea3645b8c$var$z[a] = new $3947ff2ea3645b8c$var$y(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$3947ff2ea3645b8c$var$z.xlinkHref = new $3947ff2ea3645b8c$var$y("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $3947ff2ea3645b8c$var$z[a] = new $3947ff2ea3645b8c$var$y(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
var $3947ff2ea3645b8c$var$B = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $3947ff2ea3645b8c$var$la = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($3947ff2ea3645b8c$var$B).forEach(function(a) {
    $3947ff2ea3645b8c$var$la.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $3947ff2ea3645b8c$var$B[b] = $3947ff2ea3645b8c$var$B[a];
    });
});
var $3947ff2ea3645b8c$var$oa = /["'&<>]/;
function $3947ff2ea3645b8c$var$C(a) {
    if ("boolean" === typeof a || "number" === typeof a) return "" + a;
    a = "" + a;
    var b = $3947ff2ea3645b8c$var$oa.exec(a);
    if (b) {
        var c = "", d, f = 0;
        for(d = b.index; d < a.length; d++){
            switch(a.charCodeAt(d)){
                case 34:
                    b = "&quot;";
                    break;
                case 38:
                    b = "&amp;";
                    break;
                case 39:
                    b = "&#x27;";
                    break;
                case 60:
                    b = "&lt;";
                    break;
                case 62:
                    b = "&gt;";
                    break;
                default:
                    continue;
            }
            f !== d && (c += a.substring(f, d));
            f = d + 1;
            c += b;
        }
        a = f !== d ? c + a.substring(f, d) : c;
    }
    return a;
}
var $3947ff2ea3645b8c$var$pa = /([A-Z])/g, $3947ff2ea3645b8c$var$qa = /^ms-/, $3947ff2ea3645b8c$var$ra = Array.isArray, $3947ff2ea3645b8c$var$sa = $3947ff2ea3645b8c$var$w("<script>"), $3947ff2ea3645b8c$var$ta = $3947ff2ea3645b8c$var$w("</script>"), $3947ff2ea3645b8c$var$ua = $3947ff2ea3645b8c$var$w('<script src="'), $3947ff2ea3645b8c$var$va = $3947ff2ea3645b8c$var$w('<script type="module" src="'), $3947ff2ea3645b8c$var$wa = $3947ff2ea3645b8c$var$w('" async=""></script>'), $3947ff2ea3645b8c$var$xa = /(<\/|<)(s)(cript)/gi;
function $3947ff2ea3645b8c$var$ya(a, b, c, d) {
    return "" + b + ("s" === c ? "\\u0073" : "\\u0053") + d;
}
function $3947ff2ea3645b8c$var$za(a, b, c, d, f) {
    a = void 0 === a ? "" : a;
    b = void 0 === b ? $3947ff2ea3645b8c$var$sa : $3947ff2ea3645b8c$var$w('<script nonce="' + $3947ff2ea3645b8c$var$C(b) + '">');
    var e = [];
    void 0 !== c && e.push(b, $3947ff2ea3645b8c$var$u(("" + c).replace($3947ff2ea3645b8c$var$xa, $3947ff2ea3645b8c$var$ya)), $3947ff2ea3645b8c$var$ta);
    if (void 0 !== d) for(c = 0; c < d.length; c++)e.push($3947ff2ea3645b8c$var$ua, $3947ff2ea3645b8c$var$u($3947ff2ea3645b8c$var$C(d[c])), $3947ff2ea3645b8c$var$wa);
    if (void 0 !== f) for(d = 0; d < f.length; d++)e.push($3947ff2ea3645b8c$var$va, $3947ff2ea3645b8c$var$u($3947ff2ea3645b8c$var$C(f[d])), $3947ff2ea3645b8c$var$wa);
    return {
        bootstrapChunks: e,
        startInlineScript: b,
        placeholderPrefix: $3947ff2ea3645b8c$var$w(a + "P:"),
        segmentPrefix: $3947ff2ea3645b8c$var$w(a + "S:"),
        boundaryPrefix: a + "B:",
        idPrefix: a,
        nextSuspenseID: 0,
        sentCompleteSegmentFunction: !1,
        sentCompleteBoundaryFunction: !1,
        sentClientRenderFunction: !1
    };
}
function $3947ff2ea3645b8c$var$D(a, b) {
    return {
        insertionMode: a,
        selectedValue: b
    };
}
function $3947ff2ea3645b8c$var$Aa(a) {
    return $3947ff2ea3645b8c$var$D("http://www.w3.org/2000/svg" === a ? 2 : "http://www.w3.org/1998/Math/MathML" === a ? 3 : 0, null);
}
function $3947ff2ea3645b8c$var$Ba(a, b, c) {
    switch(b){
        case "select":
            return $3947ff2ea3645b8c$var$D(1, null != c.value ? c.value : c.defaultValue);
        case "svg":
            return $3947ff2ea3645b8c$var$D(2, null);
        case "math":
            return $3947ff2ea3645b8c$var$D(3, null);
        case "foreignObject":
            return $3947ff2ea3645b8c$var$D(1, null);
        case "table":
            return $3947ff2ea3645b8c$var$D(4, null);
        case "thead":
        case "tbody":
        case "tfoot":
            return $3947ff2ea3645b8c$var$D(5, null);
        case "colgroup":
            return $3947ff2ea3645b8c$var$D(7, null);
        case "tr":
            return $3947ff2ea3645b8c$var$D(6, null);
    }
    return 4 <= a.insertionMode || 0 === a.insertionMode ? $3947ff2ea3645b8c$var$D(1, null) : a;
}
var $3947ff2ea3645b8c$var$Ca = $3947ff2ea3645b8c$var$w("<!-- -->");
function $3947ff2ea3645b8c$var$Da(a, b, c, d) {
    if ("" === b) return d;
    d && a.push($3947ff2ea3645b8c$var$Ca);
    a.push($3947ff2ea3645b8c$var$u($3947ff2ea3645b8c$var$C(b)));
    return !0;
}
var $3947ff2ea3645b8c$var$Ea = new Map, $3947ff2ea3645b8c$var$Fa = $3947ff2ea3645b8c$var$w(' style="'), $3947ff2ea3645b8c$var$Ga = $3947ff2ea3645b8c$var$w(":"), $3947ff2ea3645b8c$var$Ha = $3947ff2ea3645b8c$var$w(";");
function $3947ff2ea3645b8c$var$Ia(a, b, c) {
    if ("object" !== typeof c) throw Error($3947ff2ea3645b8c$var$k(62));
    b = !0;
    for(var d in c)if ($3947ff2ea3645b8c$var$x.call(c, d)) {
        var f = c[d];
        if (null != f && "boolean" !== typeof f && "" !== f) {
            if (0 === d.indexOf("--")) {
                var e = $3947ff2ea3645b8c$var$u($3947ff2ea3645b8c$var$C(d));
                f = $3947ff2ea3645b8c$var$u($3947ff2ea3645b8c$var$C(("" + f).trim()));
            } else {
                e = d;
                var g = $3947ff2ea3645b8c$var$Ea.get(e);
                void 0 !== g ? e = g : (g = $3947ff2ea3645b8c$var$w($3947ff2ea3645b8c$var$C(e.replace($3947ff2ea3645b8c$var$pa, "-$1").toLowerCase().replace($3947ff2ea3645b8c$var$qa, "-ms-"))), $3947ff2ea3645b8c$var$Ea.set(e, g), e = g);
                f = "number" === typeof f ? 0 === f || $3947ff2ea3645b8c$var$x.call($3947ff2ea3645b8c$var$B, d) ? $3947ff2ea3645b8c$var$u("" + f) : $3947ff2ea3645b8c$var$u(f + "px") : $3947ff2ea3645b8c$var$u($3947ff2ea3645b8c$var$C(("" + f).trim()));
            }
            b ? (b = !1, a.push($3947ff2ea3645b8c$var$Fa, e, $3947ff2ea3645b8c$var$Ga, f)) : a.push($3947ff2ea3645b8c$var$Ha, e, $3947ff2ea3645b8c$var$Ga, f);
        }
    }
    b || a.push($3947ff2ea3645b8c$var$E);
}
var $3947ff2ea3645b8c$var$H = $3947ff2ea3645b8c$var$w(" "), $3947ff2ea3645b8c$var$I = $3947ff2ea3645b8c$var$w('="'), $3947ff2ea3645b8c$var$E = $3947ff2ea3645b8c$var$w('"'), $3947ff2ea3645b8c$var$Ja = $3947ff2ea3645b8c$var$w('=""');
function $3947ff2ea3645b8c$var$J(a, b, c, d) {
    switch(c){
        case "style":
            $3947ff2ea3645b8c$var$Ia(a, b, d);
            return;
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
            return;
    }
    if (!(2 < c.length) || "o" !== c[0] && "O" !== c[0] || "n" !== c[1] && "N" !== c[1]) {
        if (b = $3947ff2ea3645b8c$var$z.hasOwnProperty(c) ? $3947ff2ea3645b8c$var$z[c] : null, null !== b) {
            switch(typeof d){
                case "function":
                case "symbol":
                    return;
                case "boolean":
                    if (!b.acceptsBooleans) return;
            }
            c = $3947ff2ea3645b8c$var$u(b.attributeName);
            switch(b.type){
                case 3:
                    d && a.push($3947ff2ea3645b8c$var$H, c, $3947ff2ea3645b8c$var$Ja);
                    break;
                case 4:
                    !0 === d ? a.push($3947ff2ea3645b8c$var$H, c, $3947ff2ea3645b8c$var$Ja) : !1 !== d && a.push($3947ff2ea3645b8c$var$H, c, $3947ff2ea3645b8c$var$I, $3947ff2ea3645b8c$var$u($3947ff2ea3645b8c$var$C(d)), $3947ff2ea3645b8c$var$E);
                    break;
                case 5:
                    isNaN(d) || a.push($3947ff2ea3645b8c$var$H, c, $3947ff2ea3645b8c$var$I, $3947ff2ea3645b8c$var$u($3947ff2ea3645b8c$var$C(d)), $3947ff2ea3645b8c$var$E);
                    break;
                case 6:
                    !isNaN(d) && 1 <= d && a.push($3947ff2ea3645b8c$var$H, c, $3947ff2ea3645b8c$var$I, $3947ff2ea3645b8c$var$u($3947ff2ea3645b8c$var$C(d)), $3947ff2ea3645b8c$var$E);
                    break;
                default:
                    b.sanitizeURL && (d = "" + d), a.push($3947ff2ea3645b8c$var$H, c, $3947ff2ea3645b8c$var$I, $3947ff2ea3645b8c$var$u($3947ff2ea3645b8c$var$C(d)), $3947ff2ea3645b8c$var$E);
            }
        } else if ($3947ff2ea3645b8c$var$ia(c)) {
            switch(typeof d){
                case "function":
                case "symbol":
                    return;
                case "boolean":
                    if (b = c.toLowerCase().slice(0, 5), "data-" !== b && "aria-" !== b) return;
            }
            a.push($3947ff2ea3645b8c$var$H, $3947ff2ea3645b8c$var$u(c), $3947ff2ea3645b8c$var$I, $3947ff2ea3645b8c$var$u($3947ff2ea3645b8c$var$C(d)), $3947ff2ea3645b8c$var$E);
        }
    }
}
var $3947ff2ea3645b8c$var$K = $3947ff2ea3645b8c$var$w(">"), $3947ff2ea3645b8c$var$Ka = $3947ff2ea3645b8c$var$w("/>");
function $3947ff2ea3645b8c$var$L(a, b, c) {
    if (null != b) {
        if (null != c) throw Error($3947ff2ea3645b8c$var$k(60));
        if ("object" !== typeof b || !("__html" in b)) throw Error($3947ff2ea3645b8c$var$k(61));
        b = b.__html;
        null !== b && void 0 !== b && a.push($3947ff2ea3645b8c$var$u("" + b));
    }
}
function $3947ff2ea3645b8c$var$La(a) {
    var b = "";
    $eeH7J.Children.forEach(a, function(a) {
        null != a && (b += a);
    });
    return b;
}
var $3947ff2ea3645b8c$var$Ma = $3947ff2ea3645b8c$var$w(' selected=""');
function $3947ff2ea3645b8c$var$Na(a, b, c, d) {
    a.push($3947ff2ea3645b8c$var$M(c));
    var f = c = null, e;
    for(e in b)if ($3947ff2ea3645b8c$var$x.call(b, e)) {
        var g = b[e];
        if (null != g) switch(e){
            case "children":
                c = g;
                break;
            case "dangerouslySetInnerHTML":
                f = g;
                break;
            default:
                $3947ff2ea3645b8c$var$J(a, d, e, g);
        }
    }
    a.push($3947ff2ea3645b8c$var$K);
    $3947ff2ea3645b8c$var$L(a, f, c);
    return "string" === typeof c ? (a.push($3947ff2ea3645b8c$var$u($3947ff2ea3645b8c$var$C(c))), null) : c;
}
var $3947ff2ea3645b8c$var$Oa = $3947ff2ea3645b8c$var$w("\n"), $3947ff2ea3645b8c$var$Pa = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/, $3947ff2ea3645b8c$var$Qa = new Map;
function $3947ff2ea3645b8c$var$M(a) {
    var b = $3947ff2ea3645b8c$var$Qa.get(a);
    if (void 0 === b) {
        if (!$3947ff2ea3645b8c$var$Pa.test(a)) throw Error($3947ff2ea3645b8c$var$k(65, a));
        b = $3947ff2ea3645b8c$var$w("<" + a);
        $3947ff2ea3645b8c$var$Qa.set(a, b);
    }
    return b;
}
var $3947ff2ea3645b8c$var$Ra = $3947ff2ea3645b8c$var$w("<!DOCTYPE html>");
function $3947ff2ea3645b8c$var$Sa(a, b, c, d, f) {
    switch(b){
        case "select":
            a.push($3947ff2ea3645b8c$var$M("select"));
            var e = null, g = null;
            for(r in c)if ($3947ff2ea3645b8c$var$x.call(c, r)) {
                var h = c[r];
                if (null != h) switch(r){
                    case "children":
                        e = h;
                        break;
                    case "dangerouslySetInnerHTML":
                        g = h;
                        break;
                    case "defaultValue":
                    case "value":
                        break;
                    default:
                        $3947ff2ea3645b8c$var$J(a, d, r, h);
                }
            }
            a.push($3947ff2ea3645b8c$var$K);
            $3947ff2ea3645b8c$var$L(a, g, e);
            return e;
        case "option":
            g = f.selectedValue;
            a.push($3947ff2ea3645b8c$var$M("option"));
            var m = h = null, q = null;
            var r = null;
            for(e in c)if ($3947ff2ea3645b8c$var$x.call(c, e)) {
                var v = c[e];
                if (null != v) switch(e){
                    case "children":
                        h = v;
                        break;
                    case "selected":
                        q = v;
                        break;
                    case "dangerouslySetInnerHTML":
                        r = v;
                        break;
                    case "value":
                        m = v;
                    default:
                        $3947ff2ea3645b8c$var$J(a, d, e, v);
                }
            }
            if (null != g) {
                if (c = null !== m ? "" + m : $3947ff2ea3645b8c$var$La(h), $3947ff2ea3645b8c$var$ra(g)) {
                    for(d = 0; d < g.length; d++)if ("" + g[d] === c) {
                        a.push($3947ff2ea3645b8c$var$Ma);
                        break;
                    }
                } else "" + g === c && a.push($3947ff2ea3645b8c$var$Ma);
            } else q && a.push($3947ff2ea3645b8c$var$Ma);
            a.push($3947ff2ea3645b8c$var$K);
            $3947ff2ea3645b8c$var$L(a, r, h);
            return h;
        case "textarea":
            a.push($3947ff2ea3645b8c$var$M("textarea"));
            r = g = e = null;
            for(h in c)if ($3947ff2ea3645b8c$var$x.call(c, h) && (m = c[h], null != m)) switch(h){
                case "children":
                    r = m;
                    break;
                case "value":
                    e = m;
                    break;
                case "defaultValue":
                    g = m;
                    break;
                case "dangerouslySetInnerHTML":
                    throw Error($3947ff2ea3645b8c$var$k(91));
                default:
                    $3947ff2ea3645b8c$var$J(a, d, h, m);
            }
            null === e && null !== g && (e = g);
            a.push($3947ff2ea3645b8c$var$K);
            if (null != r) {
                if (null != e) throw Error($3947ff2ea3645b8c$var$k(92));
                if ($3947ff2ea3645b8c$var$ra(r) && 1 < r.length) throw Error($3947ff2ea3645b8c$var$k(93));
                e = "" + r;
            }
            "string" === typeof e && "\n" === e[0] && a.push($3947ff2ea3645b8c$var$Oa);
            null !== e && a.push($3947ff2ea3645b8c$var$u($3947ff2ea3645b8c$var$C("" + e)));
            return null;
        case "input":
            a.push($3947ff2ea3645b8c$var$M("input"));
            m = r = h = e = null;
            for(g in c)if ($3947ff2ea3645b8c$var$x.call(c, g) && (q = c[g], null != q)) switch(g){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($3947ff2ea3645b8c$var$k(399, "input"));
                case "defaultChecked":
                    m = q;
                    break;
                case "defaultValue":
                    h = q;
                    break;
                case "checked":
                    r = q;
                    break;
                case "value":
                    e = q;
                    break;
                default:
                    $3947ff2ea3645b8c$var$J(a, d, g, q);
            }
            null !== r ? $3947ff2ea3645b8c$var$J(a, d, "checked", r) : null !== m && $3947ff2ea3645b8c$var$J(a, d, "checked", m);
            null !== e ? $3947ff2ea3645b8c$var$J(a, d, "value", e) : null !== h && $3947ff2ea3645b8c$var$J(a, d, "value", h);
            a.push($3947ff2ea3645b8c$var$Ka);
            return null;
        case "menuitem":
            a.push($3947ff2ea3645b8c$var$M("menuitem"));
            for(var A in c)if ($3947ff2ea3645b8c$var$x.call(c, A) && (e = c[A], null != e)) switch(A){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($3947ff2ea3645b8c$var$k(400));
                default:
                    $3947ff2ea3645b8c$var$J(a, d, A, e);
            }
            a.push($3947ff2ea3645b8c$var$K);
            return null;
        case "title":
            a.push($3947ff2ea3645b8c$var$M("title"));
            e = null;
            for(v in c)if ($3947ff2ea3645b8c$var$x.call(c, v) && (g = c[v], null != g)) switch(v){
                case "children":
                    e = g;
                    break;
                case "dangerouslySetInnerHTML":
                    throw Error($3947ff2ea3645b8c$var$k(434));
                default:
                    $3947ff2ea3645b8c$var$J(a, d, v, g);
            }
            a.push($3947ff2ea3645b8c$var$K);
            return e;
        case "listing":
        case "pre":
            a.push($3947ff2ea3645b8c$var$M(b));
            g = e = null;
            for(m in c)if ($3947ff2ea3645b8c$var$x.call(c, m) && (h = c[m], null != h)) switch(m){
                case "children":
                    e = h;
                    break;
                case "dangerouslySetInnerHTML":
                    g = h;
                    break;
                default:
                    $3947ff2ea3645b8c$var$J(a, d, m, h);
            }
            a.push($3947ff2ea3645b8c$var$K);
            if (null != g) {
                if (null != e) throw Error($3947ff2ea3645b8c$var$k(60));
                if ("object" !== typeof g || !("__html" in g)) throw Error($3947ff2ea3645b8c$var$k(61));
                c = g.__html;
                null !== c && void 0 !== c && ("string" === typeof c && 0 < c.length && "\n" === c[0] ? a.push($3947ff2ea3645b8c$var$Oa, $3947ff2ea3645b8c$var$u(c)) : a.push($3947ff2ea3645b8c$var$u("" + c)));
            }
            "string" === typeof e && "\n" === e[0] && a.push($3947ff2ea3645b8c$var$Oa);
            return e;
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "img":
        case "keygen":
        case "link":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
            a.push($3947ff2ea3645b8c$var$M(b));
            for(var F in c)if ($3947ff2ea3645b8c$var$x.call(c, F) && (e = c[F], null != e)) switch(F){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($3947ff2ea3645b8c$var$k(399, b));
                default:
                    $3947ff2ea3645b8c$var$J(a, d, F, e);
            }
            a.push($3947ff2ea3645b8c$var$Ka);
            return null;
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return $3947ff2ea3645b8c$var$Na(a, c, b, d);
        case "html":
            return 0 === f.insertionMode && a.push($3947ff2ea3645b8c$var$Ra), $3947ff2ea3645b8c$var$Na(a, c, b, d);
        default:
            if (-1 === b.indexOf("-") && "string" !== typeof c.is) return $3947ff2ea3645b8c$var$Na(a, c, b, d);
            a.push($3947ff2ea3645b8c$var$M(b));
            g = e = null;
            for(q in c)if ($3947ff2ea3645b8c$var$x.call(c, q) && (h = c[q], null != h)) switch(q){
                case "children":
                    e = h;
                    break;
                case "dangerouslySetInnerHTML":
                    g = h;
                    break;
                case "style":
                    $3947ff2ea3645b8c$var$Ia(a, d, h);
                    break;
                case "suppressContentEditableWarning":
                case "suppressHydrationWarning":
                    break;
                default:
                    $3947ff2ea3645b8c$var$ia(q) && "function" !== typeof h && "symbol" !== typeof h && a.push($3947ff2ea3645b8c$var$H, $3947ff2ea3645b8c$var$u(q), $3947ff2ea3645b8c$var$I, $3947ff2ea3645b8c$var$u($3947ff2ea3645b8c$var$C(h)), $3947ff2ea3645b8c$var$E);
            }
            a.push($3947ff2ea3645b8c$var$K);
            $3947ff2ea3645b8c$var$L(a, g, e);
            return e;
    }
}
var $3947ff2ea3645b8c$var$Ta = $3947ff2ea3645b8c$var$w("</"), $3947ff2ea3645b8c$var$Ua = $3947ff2ea3645b8c$var$w(">"), $3947ff2ea3645b8c$var$Va = $3947ff2ea3645b8c$var$w('<template id="'), $3947ff2ea3645b8c$var$Wa = $3947ff2ea3645b8c$var$w('"></template>'), $3947ff2ea3645b8c$var$Xa = $3947ff2ea3645b8c$var$w("<!--$-->"), $3947ff2ea3645b8c$var$Ya = $3947ff2ea3645b8c$var$w('<!--$?--><template id="'), $3947ff2ea3645b8c$var$Za = $3947ff2ea3645b8c$var$w('"></template>'), $3947ff2ea3645b8c$var$$a = $3947ff2ea3645b8c$var$w("<!--$!-->"), $3947ff2ea3645b8c$var$ab = $3947ff2ea3645b8c$var$w("<!--/$-->"), $3947ff2ea3645b8c$var$bb = $3947ff2ea3645b8c$var$w("<template"), $3947ff2ea3645b8c$var$cb = $3947ff2ea3645b8c$var$w('"'), $3947ff2ea3645b8c$var$db = $3947ff2ea3645b8c$var$w(' data-dgst="');
$3947ff2ea3645b8c$var$w(' data-msg="');
$3947ff2ea3645b8c$var$w(' data-stck="');
var $3947ff2ea3645b8c$var$eb = $3947ff2ea3645b8c$var$w("></template>");
function $3947ff2ea3645b8c$var$fb(a, b, c) {
    $3947ff2ea3645b8c$var$p(a, $3947ff2ea3645b8c$var$Ya);
    if (null === c) throw Error($3947ff2ea3645b8c$var$k(395));
    $3947ff2ea3645b8c$var$p(a, c);
    return $3947ff2ea3645b8c$var$t(a, $3947ff2ea3645b8c$var$Za);
}
var $3947ff2ea3645b8c$var$gb = $3947ff2ea3645b8c$var$w('<div hidden id="'), $3947ff2ea3645b8c$var$hb = $3947ff2ea3645b8c$var$w('">'), $3947ff2ea3645b8c$var$ib = $3947ff2ea3645b8c$var$w("</div>"), $3947ff2ea3645b8c$var$jb = $3947ff2ea3645b8c$var$w('<svg aria-hidden="true" style="display:none" id="'), $3947ff2ea3645b8c$var$kb = $3947ff2ea3645b8c$var$w('">'), $3947ff2ea3645b8c$var$lb = $3947ff2ea3645b8c$var$w("</svg>"), $3947ff2ea3645b8c$var$mb = $3947ff2ea3645b8c$var$w('<math aria-hidden="true" style="display:none" id="'), $3947ff2ea3645b8c$var$nb = $3947ff2ea3645b8c$var$w('">'), $3947ff2ea3645b8c$var$ob = $3947ff2ea3645b8c$var$w("</math>"), $3947ff2ea3645b8c$var$pb = $3947ff2ea3645b8c$var$w('<table hidden id="'), $3947ff2ea3645b8c$var$qb = $3947ff2ea3645b8c$var$w('">'), $3947ff2ea3645b8c$var$rb = $3947ff2ea3645b8c$var$w("</table>"), $3947ff2ea3645b8c$var$sb = $3947ff2ea3645b8c$var$w('<table hidden><tbody id="'), $3947ff2ea3645b8c$var$tb = $3947ff2ea3645b8c$var$w('">'), $3947ff2ea3645b8c$var$ub = $3947ff2ea3645b8c$var$w("</tbody></table>"), $3947ff2ea3645b8c$var$vb = $3947ff2ea3645b8c$var$w('<table hidden><tr id="'), $3947ff2ea3645b8c$var$wb = $3947ff2ea3645b8c$var$w('">'), $3947ff2ea3645b8c$var$xb = $3947ff2ea3645b8c$var$w("</tr></table>"), $3947ff2ea3645b8c$var$yb = $3947ff2ea3645b8c$var$w('<table hidden><colgroup id="'), $3947ff2ea3645b8c$var$zb = $3947ff2ea3645b8c$var$w('">'), $3947ff2ea3645b8c$var$Ab = $3947ff2ea3645b8c$var$w("</colgroup></table>");
function $3947ff2ea3645b8c$var$Bb(a, b, c, d) {
    switch(c.insertionMode){
        case 0:
        case 1:
            return $3947ff2ea3645b8c$var$p(a, $3947ff2ea3645b8c$var$gb), $3947ff2ea3645b8c$var$p(a, b.segmentPrefix), $3947ff2ea3645b8c$var$p(a, $3947ff2ea3645b8c$var$u(d.toString(16))), $3947ff2ea3645b8c$var$t(a, $3947ff2ea3645b8c$var$hb);
        case 2:
            return $3947ff2ea3645b8c$var$p(a, $3947ff2ea3645b8c$var$jb), $3947ff2ea3645b8c$var$p(a, b.segmentPrefix), $3947ff2ea3645b8c$var$p(a, $3947ff2ea3645b8c$var$u(d.toString(16))), $3947ff2ea3645b8c$var$t(a, $3947ff2ea3645b8c$var$kb);
        case 3:
            return $3947ff2ea3645b8c$var$p(a, $3947ff2ea3645b8c$var$mb), $3947ff2ea3645b8c$var$p(a, b.segmentPrefix), $3947ff2ea3645b8c$var$p(a, $3947ff2ea3645b8c$var$u(d.toString(16))), $3947ff2ea3645b8c$var$t(a, $3947ff2ea3645b8c$var$nb);
        case 4:
            return $3947ff2ea3645b8c$var$p(a, $3947ff2ea3645b8c$var$pb), $3947ff2ea3645b8c$var$p(a, b.segmentPrefix), $3947ff2ea3645b8c$var$p(a, $3947ff2ea3645b8c$var$u(d.toString(16))), $3947ff2ea3645b8c$var$t(a, $3947ff2ea3645b8c$var$qb);
        case 5:
            return $3947ff2ea3645b8c$var$p(a, $3947ff2ea3645b8c$var$sb), $3947ff2ea3645b8c$var$p(a, b.segmentPrefix), $3947ff2ea3645b8c$var$p(a, $3947ff2ea3645b8c$var$u(d.toString(16))), $3947ff2ea3645b8c$var$t(a, $3947ff2ea3645b8c$var$tb);
        case 6:
            return $3947ff2ea3645b8c$var$p(a, $3947ff2ea3645b8c$var$vb), $3947ff2ea3645b8c$var$p(a, b.segmentPrefix), $3947ff2ea3645b8c$var$p(a, $3947ff2ea3645b8c$var$u(d.toString(16))), $3947ff2ea3645b8c$var$t(a, $3947ff2ea3645b8c$var$wb);
        case 7:
            return $3947ff2ea3645b8c$var$p(a, $3947ff2ea3645b8c$var$yb), $3947ff2ea3645b8c$var$p(a, b.segmentPrefix), $3947ff2ea3645b8c$var$p(a, $3947ff2ea3645b8c$var$u(d.toString(16))), $3947ff2ea3645b8c$var$t(a, $3947ff2ea3645b8c$var$zb);
        default:
            throw Error($3947ff2ea3645b8c$var$k(397));
    }
}
function $3947ff2ea3645b8c$var$Cb(a, b) {
    switch(b.insertionMode){
        case 0:
        case 1:
            return $3947ff2ea3645b8c$var$t(a, $3947ff2ea3645b8c$var$ib);
        case 2:
            return $3947ff2ea3645b8c$var$t(a, $3947ff2ea3645b8c$var$lb);
        case 3:
            return $3947ff2ea3645b8c$var$t(a, $3947ff2ea3645b8c$var$ob);
        case 4:
            return $3947ff2ea3645b8c$var$t(a, $3947ff2ea3645b8c$var$rb);
        case 5:
            return $3947ff2ea3645b8c$var$t(a, $3947ff2ea3645b8c$var$ub);
        case 6:
            return $3947ff2ea3645b8c$var$t(a, $3947ff2ea3645b8c$var$xb);
        case 7:
            return $3947ff2ea3645b8c$var$t(a, $3947ff2ea3645b8c$var$Ab);
        default:
            throw Error($3947ff2ea3645b8c$var$k(397));
    }
}
var $3947ff2ea3645b8c$var$Db = $3947ff2ea3645b8c$var$w('function $RS(a,b){a=document.getElementById(a);b=document.getElementById(b);for(a.parentNode.removeChild(a);a.firstChild;)b.parentNode.insertBefore(a.firstChild,b);b.parentNode.removeChild(b)};$RS("'), $3947ff2ea3645b8c$var$Eb = $3947ff2ea3645b8c$var$w('$RS("'), $3947ff2ea3645b8c$var$Gb = $3947ff2ea3645b8c$var$w('","'), $3947ff2ea3645b8c$var$Hb = $3947ff2ea3645b8c$var$w('")</script>'), $3947ff2ea3645b8c$var$Ib = $3947ff2ea3645b8c$var$w('function $RC(a,b){a=document.getElementById(a);b=document.getElementById(b);b.parentNode.removeChild(b);if(a){a=a.previousSibling;var f=a.parentNode,c=a.nextSibling,e=0;do{if(c&&8===c.nodeType){var d=c.data;if("/$"===d)if(0===e)break;else e--;else"$"!==d&&"$?"!==d&&"$!"!==d||e++}d=c.nextSibling;f.removeChild(c);c=d}while(c);for(;b.firstChild;)f.insertBefore(b.firstChild,c);a.data="$";a._reactRetry&&a._reactRetry()}};$RC("'), $3947ff2ea3645b8c$var$Jb = $3947ff2ea3645b8c$var$w('$RC("'), $3947ff2ea3645b8c$var$Kb = $3947ff2ea3645b8c$var$w('","'), $3947ff2ea3645b8c$var$Lb = $3947ff2ea3645b8c$var$w('")</script>'), $3947ff2ea3645b8c$var$Mb = $3947ff2ea3645b8c$var$w('function $RX(b,c,d,e){var a=document.getElementById(b);a&&(b=a.previousSibling,b.data="$!",a=a.dataset,c&&(a.dgst=c),d&&(a.msg=d),e&&(a.stck=e),b._reactRetry&&b._reactRetry())};$RX("'), $3947ff2ea3645b8c$var$Nb = $3947ff2ea3645b8c$var$w('$RX("'), $3947ff2ea3645b8c$var$Ob = $3947ff2ea3645b8c$var$w('"'), $3947ff2ea3645b8c$var$Pb = $3947ff2ea3645b8c$var$w(")</script>"), $3947ff2ea3645b8c$var$Qb = $3947ff2ea3645b8c$var$w(","), $3947ff2ea3645b8c$var$Rb = /[<\u2028\u2029]/g;
function $3947ff2ea3645b8c$var$Sb(a) {
    return JSON.stringify(a).replace($3947ff2ea3645b8c$var$Rb, function(a) {
        switch(a){
            case "<":
                return "\\u003c";
            case "\u2028":
                return "\\u2028";
            case "\u2029":
                return "\\u2029";
            default:
                throw Error("escapeJSStringsForInstructionScripts encountered a match it does not know how to replace. this means the match regex and the replacement characters are no longer in sync. This is a bug in React");
        }
    });
}
var $3947ff2ea3645b8c$var$N = Object.assign, $3947ff2ea3645b8c$var$Tb = Symbol.for("react.element"), $3947ff2ea3645b8c$var$Ub = Symbol.for("react.portal"), $3947ff2ea3645b8c$var$Vb = Symbol.for("react.fragment"), $3947ff2ea3645b8c$var$Wb = Symbol.for("react.strict_mode"), $3947ff2ea3645b8c$var$Xb = Symbol.for("react.profiler"), $3947ff2ea3645b8c$var$Yb = Symbol.for("react.provider"), $3947ff2ea3645b8c$var$Zb = Symbol.for("react.context"), $3947ff2ea3645b8c$var$$b = Symbol.for("react.forward_ref"), $3947ff2ea3645b8c$var$ac = Symbol.for("react.suspense"), $3947ff2ea3645b8c$var$bc = Symbol.for("react.suspense_list"), $3947ff2ea3645b8c$var$cc = Symbol.for("react.memo"), $3947ff2ea3645b8c$var$dc = Symbol.for("react.lazy"), $3947ff2ea3645b8c$var$ec = Symbol.for("react.scope"), $3947ff2ea3645b8c$var$fc = Symbol.for("react.debug_trace_mode"), $3947ff2ea3645b8c$var$gc = Symbol.for("react.legacy_hidden"), $3947ff2ea3645b8c$var$hc = Symbol.for("react.default_value"), $3947ff2ea3645b8c$var$ic = Symbol.iterator;
function $3947ff2ea3645b8c$var$jc(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $3947ff2ea3645b8c$var$Vb:
            return "Fragment";
        case $3947ff2ea3645b8c$var$Ub:
            return "Portal";
        case $3947ff2ea3645b8c$var$Xb:
            return "Profiler";
        case $3947ff2ea3645b8c$var$Wb:
            return "StrictMode";
        case $3947ff2ea3645b8c$var$ac:
            return "Suspense";
        case $3947ff2ea3645b8c$var$bc:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $3947ff2ea3645b8c$var$Zb:
            return (a.displayName || "Context") + ".Consumer";
        case $3947ff2ea3645b8c$var$Yb:
            return (a._context.displayName || "Context") + ".Provider";
        case $3947ff2ea3645b8c$var$$b:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $3947ff2ea3645b8c$var$cc:
            return b = a.displayName || null, null !== b ? b : $3947ff2ea3645b8c$var$jc(a.type) || "Memo";
        case $3947ff2ea3645b8c$var$dc:
            b = a._payload;
            a = a._init;
            try {
                return $3947ff2ea3645b8c$var$jc(a(b));
            } catch (c) {}
    }
    return null;
}
var $3947ff2ea3645b8c$var$kc = {};
function $3947ff2ea3645b8c$var$lc(a, b) {
    a = a.contextTypes;
    if (!a) return $3947ff2ea3645b8c$var$kc;
    var c = {}, d;
    for(d in a)c[d] = b[d];
    return c;
}
var $3947ff2ea3645b8c$var$O = null;
function $3947ff2ea3645b8c$var$P(a, b) {
    if (a !== b) {
        a.context._currentValue = a.parentValue;
        a = a.parent;
        var c = b.parent;
        if (null === a) {
            if (null !== c) throw Error($3947ff2ea3645b8c$var$k(401));
        } else {
            if (null === c) throw Error($3947ff2ea3645b8c$var$k(401));
            $3947ff2ea3645b8c$var$P(a, c);
        }
        b.context._currentValue = b.value;
    }
}
function $3947ff2ea3645b8c$var$mc(a) {
    a.context._currentValue = a.parentValue;
    a = a.parent;
    null !== a && $3947ff2ea3645b8c$var$mc(a);
}
function $3947ff2ea3645b8c$var$nc(a) {
    var b = a.parent;
    null !== b && $3947ff2ea3645b8c$var$nc(b);
    a.context._currentValue = a.value;
}
function $3947ff2ea3645b8c$var$oc(a, b) {
    a.context._currentValue = a.parentValue;
    a = a.parent;
    if (null === a) throw Error($3947ff2ea3645b8c$var$k(402));
    a.depth === b.depth ? $3947ff2ea3645b8c$var$P(a, b) : $3947ff2ea3645b8c$var$oc(a, b);
}
function $3947ff2ea3645b8c$var$pc(a, b) {
    var c = b.parent;
    if (null === c) throw Error($3947ff2ea3645b8c$var$k(402));
    a.depth === c.depth ? $3947ff2ea3645b8c$var$P(a, c) : $3947ff2ea3645b8c$var$pc(a, c);
    b.context._currentValue = b.value;
}
function $3947ff2ea3645b8c$var$Q(a) {
    var b = $3947ff2ea3645b8c$var$O;
    b !== a && (null === b ? $3947ff2ea3645b8c$var$nc(a) : null === a ? $3947ff2ea3645b8c$var$mc(b) : b.depth === a.depth ? $3947ff2ea3645b8c$var$P(b, a) : b.depth > a.depth ? $3947ff2ea3645b8c$var$oc(b, a) : $3947ff2ea3645b8c$var$pc(b, a), $3947ff2ea3645b8c$var$O = a);
}
var $3947ff2ea3645b8c$var$qc = {
    isMounted: function() {
        return !1;
    },
    enqueueSetState: function(a, b) {
        a = a._reactInternals;
        null !== a.queue && a.queue.push(b);
    },
    enqueueReplaceState: function(a, b) {
        a = a._reactInternals;
        a.replace = !0;
        a.queue = [
            b
        ];
    },
    enqueueForceUpdate: function() {}
};
function $3947ff2ea3645b8c$var$rc(a, b, c, d) {
    var f = void 0 !== a.state ? a.state : null;
    a.updater = $3947ff2ea3645b8c$var$qc;
    a.props = c;
    a.state = f;
    var e = {
        queue: [],
        replace: !1
    };
    a._reactInternals = e;
    var g = b.contextType;
    a.context = "object" === typeof g && null !== g ? g._currentValue : d;
    g = b.getDerivedStateFromProps;
    "function" === typeof g && (g = g(c, f), f = null === g || void 0 === g ? f : $3947ff2ea3645b8c$var$N({}, f, g), a.state = f);
    if ("function" !== typeof b.getDerivedStateFromProps && "function" !== typeof a.getSnapshotBeforeUpdate && ("function" === typeof a.UNSAFE_componentWillMount || "function" === typeof a.componentWillMount)) {
        if (b = a.state, "function" === typeof a.componentWillMount && a.componentWillMount(), "function" === typeof a.UNSAFE_componentWillMount && a.UNSAFE_componentWillMount(), b !== a.state && $3947ff2ea3645b8c$var$qc.enqueueReplaceState(a, a.state, null), null !== e.queue && 0 < e.queue.length) {
            if (b = e.queue, g = e.replace, e.queue = null, e.replace = !1, g && 1 === b.length) a.state = b[0];
            else {
                e = g ? b[0] : a.state;
                f = !0;
                for(g = g ? 1 : 0; g < b.length; g++){
                    var h = b[g];
                    h = "function" === typeof h ? h.call(a, e, c, d) : h;
                    null != h && (f ? (f = !1, e = $3947ff2ea3645b8c$var$N({}, e, h)) : $3947ff2ea3645b8c$var$N(e, h));
                }
                a.state = e;
            }
        } else e.queue = null;
    }
}
var $3947ff2ea3645b8c$var$sc = {
    id: 1,
    overflow: ""
};
function $3947ff2ea3645b8c$var$tc(a, b, c) {
    var d = a.id;
    a = a.overflow;
    var f = 32 - $3947ff2ea3645b8c$var$uc(d) - 1;
    d &= ~(1 << f);
    c += 1;
    var e = 32 - $3947ff2ea3645b8c$var$uc(b) + f;
    if (30 < e) {
        var g = f - f % 5;
        e = (d & (1 << g) - 1).toString(32);
        d >>= g;
        f -= g;
        return {
            id: 1 << 32 - $3947ff2ea3645b8c$var$uc(b) + f | c << f | d,
            overflow: e + a
        };
    }
    return {
        id: 1 << e | c << f | d,
        overflow: a
    };
}
var $3947ff2ea3645b8c$var$uc = Math.clz32 ? Math.clz32 : $3947ff2ea3645b8c$var$vc, $3947ff2ea3645b8c$var$wc = Math.log, $3947ff2ea3645b8c$var$xc = Math.LN2;
function $3947ff2ea3645b8c$var$vc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($3947ff2ea3645b8c$var$wc(a) / $3947ff2ea3645b8c$var$xc | 0) | 0;
}
function $3947ff2ea3645b8c$var$yc(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $3947ff2ea3645b8c$var$zc = "function" === typeof Object.is ? Object.is : $3947ff2ea3645b8c$var$yc, $3947ff2ea3645b8c$var$R = null, $3947ff2ea3645b8c$var$Ac = null, $3947ff2ea3645b8c$var$Bc = null, $3947ff2ea3645b8c$var$S = null, $3947ff2ea3645b8c$var$T = !1, $3947ff2ea3645b8c$var$Cc = !1, $3947ff2ea3645b8c$var$U = 0, $3947ff2ea3645b8c$var$V = null, $3947ff2ea3645b8c$var$Dc = 0;
function $3947ff2ea3645b8c$var$W() {
    if (null === $3947ff2ea3645b8c$var$R) throw Error($3947ff2ea3645b8c$var$k(321));
    return $3947ff2ea3645b8c$var$R;
}
function $3947ff2ea3645b8c$var$Ec() {
    if (0 < $3947ff2ea3645b8c$var$Dc) throw Error($3947ff2ea3645b8c$var$k(312));
    return {
        memoizedState: null,
        queue: null,
        next: null
    };
}
function $3947ff2ea3645b8c$var$Fc() {
    null === $3947ff2ea3645b8c$var$S ? null === $3947ff2ea3645b8c$var$Bc ? ($3947ff2ea3645b8c$var$T = !1, $3947ff2ea3645b8c$var$Bc = $3947ff2ea3645b8c$var$S = $3947ff2ea3645b8c$var$Ec()) : ($3947ff2ea3645b8c$var$T = !0, $3947ff2ea3645b8c$var$S = $3947ff2ea3645b8c$var$Bc) : null === $3947ff2ea3645b8c$var$S.next ? ($3947ff2ea3645b8c$var$T = !1, $3947ff2ea3645b8c$var$S = $3947ff2ea3645b8c$var$S.next = $3947ff2ea3645b8c$var$Ec()) : ($3947ff2ea3645b8c$var$T = !0, $3947ff2ea3645b8c$var$S = $3947ff2ea3645b8c$var$S.next);
    return $3947ff2ea3645b8c$var$S;
}
function $3947ff2ea3645b8c$var$Gc() {
    $3947ff2ea3645b8c$var$Ac = $3947ff2ea3645b8c$var$R = null;
    $3947ff2ea3645b8c$var$Cc = !1;
    $3947ff2ea3645b8c$var$Bc = null;
    $3947ff2ea3645b8c$var$Dc = 0;
    $3947ff2ea3645b8c$var$S = $3947ff2ea3645b8c$var$V = null;
}
function $3947ff2ea3645b8c$var$Hc(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $3947ff2ea3645b8c$var$Ic(a, b, c) {
    $3947ff2ea3645b8c$var$R = $3947ff2ea3645b8c$var$W();
    $3947ff2ea3645b8c$var$S = $3947ff2ea3645b8c$var$Fc();
    if ($3947ff2ea3645b8c$var$T) {
        var d = $3947ff2ea3645b8c$var$S.queue;
        b = d.dispatch;
        if (null !== $3947ff2ea3645b8c$var$V && (c = $3947ff2ea3645b8c$var$V.get(d), void 0 !== c)) {
            $3947ff2ea3645b8c$var$V.delete(d);
            d = $3947ff2ea3645b8c$var$S.memoizedState;
            do d = a(d, c.action), c = c.next;
            while (null !== c);
            $3947ff2ea3645b8c$var$S.memoizedState = d;
            return [
                d,
                b
            ];
        }
        return [
            $3947ff2ea3645b8c$var$S.memoizedState,
            b
        ];
    }
    a = a === $3947ff2ea3645b8c$var$Hc ? "function" === typeof b ? b() : b : void 0 !== c ? c(b) : b;
    $3947ff2ea3645b8c$var$S.memoizedState = a;
    a = $3947ff2ea3645b8c$var$S.queue = {
        last: null,
        dispatch: null
    };
    a = a.dispatch = $3947ff2ea3645b8c$var$Jc.bind(null, $3947ff2ea3645b8c$var$R, a);
    return [
        $3947ff2ea3645b8c$var$S.memoizedState,
        a
    ];
}
function $3947ff2ea3645b8c$var$Kc(a, b) {
    $3947ff2ea3645b8c$var$R = $3947ff2ea3645b8c$var$W();
    $3947ff2ea3645b8c$var$S = $3947ff2ea3645b8c$var$Fc();
    b = void 0 === b ? null : b;
    if (null !== $3947ff2ea3645b8c$var$S) {
        var c = $3947ff2ea3645b8c$var$S.memoizedState;
        if (null !== c && null !== b) {
            var d = c[1];
            a: if (null === d) d = !1;
            else {
                for(var f = 0; f < d.length && f < b.length; f++)if (!$3947ff2ea3645b8c$var$zc(b[f], d[f])) {
                    d = !1;
                    break a;
                }
                d = !0;
            }
            if (d) return c[0];
        }
    }
    a = a();
    $3947ff2ea3645b8c$var$S.memoizedState = [
        a,
        b
    ];
    return a;
}
function $3947ff2ea3645b8c$var$Jc(a, b, c) {
    if (25 <= $3947ff2ea3645b8c$var$Dc) throw Error($3947ff2ea3645b8c$var$k(301));
    if (a === $3947ff2ea3645b8c$var$R) {
        if ($3947ff2ea3645b8c$var$Cc = !0, a = {
            action: c,
            next: null
        }, null === $3947ff2ea3645b8c$var$V && ($3947ff2ea3645b8c$var$V = new Map), c = $3947ff2ea3645b8c$var$V.get(b), void 0 === c) $3947ff2ea3645b8c$var$V.set(b, a);
        else {
            for(b = c; null !== b.next;)b = b.next;
            b.next = a;
        }
    }
}
function $3947ff2ea3645b8c$var$Lc() {
    throw Error($3947ff2ea3645b8c$var$k(394));
}
function $3947ff2ea3645b8c$var$Mc() {}
var $3947ff2ea3645b8c$var$Oc = {
    readContext: function(a) {
        return a._currentValue;
    },
    useContext: function(a) {
        $3947ff2ea3645b8c$var$W();
        return a._currentValue;
    },
    useMemo: $3947ff2ea3645b8c$var$Kc,
    useReducer: $3947ff2ea3645b8c$var$Ic,
    useRef: function(a) {
        $3947ff2ea3645b8c$var$R = $3947ff2ea3645b8c$var$W();
        $3947ff2ea3645b8c$var$S = $3947ff2ea3645b8c$var$Fc();
        var b = $3947ff2ea3645b8c$var$S.memoizedState;
        return null === b ? (a = {
            current: a
        }, $3947ff2ea3645b8c$var$S.memoizedState = a) : b;
    },
    useState: function(a) {
        return $3947ff2ea3645b8c$var$Ic($3947ff2ea3645b8c$var$Hc, a);
    },
    useInsertionEffect: $3947ff2ea3645b8c$var$Mc,
    useLayoutEffect: function() {},
    useCallback: function(a, b) {
        return $3947ff2ea3645b8c$var$Kc(function() {
            return a;
        }, b);
    },
    useImperativeHandle: $3947ff2ea3645b8c$var$Mc,
    useEffect: $3947ff2ea3645b8c$var$Mc,
    useDebugValue: $3947ff2ea3645b8c$var$Mc,
    useDeferredValue: function(a) {
        $3947ff2ea3645b8c$var$W();
        return a;
    },
    useTransition: function() {
        $3947ff2ea3645b8c$var$W();
        return [
            !1,
            $3947ff2ea3645b8c$var$Lc
        ];
    },
    useId: function() {
        var a = $3947ff2ea3645b8c$var$Ac.treeContext;
        var b = a.overflow;
        a = a.id;
        a = (a & ~(1 << 32 - $3947ff2ea3645b8c$var$uc(a) - 1)).toString(32) + b;
        var c = $3947ff2ea3645b8c$var$Nc;
        if (null === c) throw Error($3947ff2ea3645b8c$var$k(404));
        b = $3947ff2ea3645b8c$var$U++;
        a = ":" + c.idPrefix + "R" + a;
        0 < b && (a += "H" + b.toString(32));
        return a + ":";
    },
    useMutableSource: function(a, b) {
        $3947ff2ea3645b8c$var$W();
        return b(a._source);
    },
    useSyncExternalStore: function(a, b, c) {
        if (void 0 === c) throw Error($3947ff2ea3645b8c$var$k(407));
        return c();
    }
}, $3947ff2ea3645b8c$var$Nc = null, $3947ff2ea3645b8c$var$Pc = $eeH7J.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentDispatcher;
function $3947ff2ea3645b8c$var$Qc(a) {
    console.error(a);
    return null;
}
function $3947ff2ea3645b8c$var$X() {}
function $3947ff2ea3645b8c$var$Rc(a, b, c, d, f, e, g, h, m) {
    var q = [], r = new Set;
    b = {
        destination: null,
        responseState: b,
        progressiveChunkSize: void 0 === d ? 12800 : d,
        status: 0,
        fatalError: null,
        nextSegmentId: 0,
        allPendingTasks: 0,
        pendingRootTasks: 0,
        completedRootSegment: null,
        abortableTasks: r,
        pingedTasks: q,
        clientRenderedBoundaries: [],
        completedBoundaries: [],
        partialBoundaries: [],
        onError: void 0 === f ? $3947ff2ea3645b8c$var$Qc : f,
        onAllReady: void 0 === e ? $3947ff2ea3645b8c$var$X : e,
        onShellReady: void 0 === g ? $3947ff2ea3645b8c$var$X : g,
        onShellError: void 0 === h ? $3947ff2ea3645b8c$var$X : h,
        onFatalError: void 0 === m ? $3947ff2ea3645b8c$var$X : m
    };
    c = $3947ff2ea3645b8c$var$Sc(b, 0, null, c, !1, !1);
    c.parentFlushed = !0;
    a = $3947ff2ea3645b8c$var$Tc(b, a, null, c, r, $3947ff2ea3645b8c$var$kc, null, $3947ff2ea3645b8c$var$sc);
    q.push(a);
    return b;
}
function $3947ff2ea3645b8c$var$Tc(a, b, c, d, f, e, g, h) {
    a.allPendingTasks++;
    null === c ? a.pendingRootTasks++ : c.pendingTasks++;
    var m = {
        node: b,
        ping: function() {
            var b = a.pingedTasks;
            b.push(m);
            1 === b.length && $3947ff2ea3645b8c$var$Uc(a);
        },
        blockedBoundary: c,
        blockedSegment: d,
        abortSet: f,
        legacyContext: e,
        context: g,
        treeContext: h
    };
    f.add(m);
    return m;
}
function $3947ff2ea3645b8c$var$Sc(a, b, c, d, f, e) {
    return {
        status: 0,
        id: -1,
        index: b,
        parentFlushed: !1,
        chunks: [],
        children: [],
        formatContext: d,
        boundary: c,
        lastPushedText: f,
        textEmbedded: e
    };
}
function $3947ff2ea3645b8c$var$Y(a, b) {
    a = a.onError(b);
    if (null != a && "string" !== typeof a) throw Error('onError returned something with a type other than "string". onError should return a string and may return null or undefined but must not return anything else. It received something of type "' + typeof a + '" instead');
    return a;
}
function $3947ff2ea3645b8c$var$Vc(a, b) {
    var c = a.onShellError;
    c(b);
    c = a.onFatalError;
    c(b);
    null !== a.destination ? (a.status = 2, $3947ff2ea3645b8c$var$da(a.destination, b)) : (a.status = 1, a.fatalError = b);
}
function $3947ff2ea3645b8c$var$Wc(a, b, c, d, f) {
    $3947ff2ea3645b8c$var$R = {};
    $3947ff2ea3645b8c$var$Ac = b;
    $3947ff2ea3645b8c$var$U = 0;
    for(a = c(d, f); $3947ff2ea3645b8c$var$Cc;)$3947ff2ea3645b8c$var$Cc = !1, $3947ff2ea3645b8c$var$U = 0, $3947ff2ea3645b8c$var$Dc += 1, $3947ff2ea3645b8c$var$S = null, a = c(d, f);
    $3947ff2ea3645b8c$var$Gc();
    return a;
}
function $3947ff2ea3645b8c$var$Xc(a, b, c, d) {
    var f = c.render(), e = d.childContextTypes;
    if (null !== e && void 0 !== e) {
        var g = b.legacyContext;
        if ("function" !== typeof c.getChildContext) d = g;
        else {
            c = c.getChildContext();
            for(var h in c)if (!(h in e)) throw Error($3947ff2ea3645b8c$var$k(108, $3947ff2ea3645b8c$var$jc(d) || "Unknown", h));
            d = $3947ff2ea3645b8c$var$N({}, g, c);
        }
        b.legacyContext = d;
        $3947ff2ea3645b8c$var$Z(a, b, f);
        b.legacyContext = g;
    } else $3947ff2ea3645b8c$var$Z(a, b, f);
}
function $3947ff2ea3645b8c$var$Yc(a, b) {
    if (a && a.defaultProps) {
        b = $3947ff2ea3645b8c$var$N({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $3947ff2ea3645b8c$var$Zc(a, b, c, d, f) {
    if ("function" === typeof c) {
        if (c.prototype && c.prototype.isReactComponent) {
            f = $3947ff2ea3645b8c$var$lc(c, b.legacyContext);
            var e = c.contextType;
            e = new c(d, "object" === typeof e && null !== e ? e._currentValue : f);
            $3947ff2ea3645b8c$var$rc(e, c, d, f);
            $3947ff2ea3645b8c$var$Xc(a, b, e, c);
        } else {
            e = $3947ff2ea3645b8c$var$lc(c, b.legacyContext);
            f = $3947ff2ea3645b8c$var$Wc(a, b, c, d, e);
            var g = 0 !== $3947ff2ea3645b8c$var$U;
            if ("object" === typeof f && null !== f && "function" === typeof f.render && void 0 === f.$$typeof) $3947ff2ea3645b8c$var$rc(f, c, d, e), $3947ff2ea3645b8c$var$Xc(a, b, f, c);
            else if (g) {
                d = b.treeContext;
                b.treeContext = $3947ff2ea3645b8c$var$tc(d, 1, 0);
                try {
                    $3947ff2ea3645b8c$var$Z(a, b, f);
                } finally{
                    b.treeContext = d;
                }
            } else $3947ff2ea3645b8c$var$Z(a, b, f);
        }
    } else if ("string" === typeof c) {
        f = b.blockedSegment;
        e = $3947ff2ea3645b8c$var$Sa(f.chunks, c, d, a.responseState, f.formatContext);
        f.lastPushedText = !1;
        g = f.formatContext;
        f.formatContext = $3947ff2ea3645b8c$var$Ba(g, c, d);
        $3947ff2ea3645b8c$var$$c(a, b, e);
        f.formatContext = g;
        switch(c){
            case "area":
            case "base":
            case "br":
            case "col":
            case "embed":
            case "hr":
            case "img":
            case "input":
            case "keygen":
            case "link":
            case "meta":
            case "param":
            case "source":
            case "track":
            case "wbr":
                break;
            default:
                f.chunks.push($3947ff2ea3645b8c$var$Ta, $3947ff2ea3645b8c$var$u(c), $3947ff2ea3645b8c$var$Ua);
        }
        f.lastPushedText = !1;
    } else {
        switch(c){
            case $3947ff2ea3645b8c$var$gc:
            case $3947ff2ea3645b8c$var$fc:
            case $3947ff2ea3645b8c$var$Wb:
            case $3947ff2ea3645b8c$var$Xb:
            case $3947ff2ea3645b8c$var$Vb:
                $3947ff2ea3645b8c$var$Z(a, b, d.children);
                return;
            case $3947ff2ea3645b8c$var$bc:
                $3947ff2ea3645b8c$var$Z(a, b, d.children);
                return;
            case $3947ff2ea3645b8c$var$ec:
                throw Error($3947ff2ea3645b8c$var$k(343));
            case $3947ff2ea3645b8c$var$ac:
                a: {
                    c = b.blockedBoundary;
                    f = b.blockedSegment;
                    e = d.fallback;
                    d = d.children;
                    g = new Set;
                    var h = {
                        id: null,
                        rootSegmentID: -1,
                        parentFlushed: !1,
                        pendingTasks: 0,
                        forceClientRender: !1,
                        completedSegments: [],
                        byteSize: 0,
                        fallbackAbortableTasks: g,
                        errorDigest: null
                    }, m = $3947ff2ea3645b8c$var$Sc(a, f.chunks.length, h, f.formatContext, !1, !1);
                    f.children.push(m);
                    f.lastPushedText = !1;
                    var q = $3947ff2ea3645b8c$var$Sc(a, 0, null, f.formatContext, !1, !1);
                    q.parentFlushed = !0;
                    b.blockedBoundary = h;
                    b.blockedSegment = q;
                    try {
                        if ($3947ff2ea3645b8c$var$$c(a, b, d), q.lastPushedText && q.textEmbedded && q.chunks.push($3947ff2ea3645b8c$var$Ca), q.status = 1, $3947ff2ea3645b8c$var$ad(h, q), 0 === h.pendingTasks) break a;
                    } catch (r) {
                        q.status = 4, h.forceClientRender = !0, h.errorDigest = $3947ff2ea3645b8c$var$Y(a, r);
                    } finally{
                        b.blockedBoundary = c, b.blockedSegment = f;
                    }
                    b = $3947ff2ea3645b8c$var$Tc(a, e, c, m, g, b.legacyContext, b.context, b.treeContext);
                    a.pingedTasks.push(b);
                }
                return;
        }
        if ("object" === typeof c && null !== c) switch(c.$$typeof){
            case $3947ff2ea3645b8c$var$$b:
                d = $3947ff2ea3645b8c$var$Wc(a, b, c.render, d, f);
                if (0 !== $3947ff2ea3645b8c$var$U) {
                    c = b.treeContext;
                    b.treeContext = $3947ff2ea3645b8c$var$tc(c, 1, 0);
                    try {
                        $3947ff2ea3645b8c$var$Z(a, b, d);
                    } finally{
                        b.treeContext = c;
                    }
                } else $3947ff2ea3645b8c$var$Z(a, b, d);
                return;
            case $3947ff2ea3645b8c$var$cc:
                c = c.type;
                d = $3947ff2ea3645b8c$var$Yc(c, d);
                $3947ff2ea3645b8c$var$Zc(a, b, c, d, f);
                return;
            case $3947ff2ea3645b8c$var$Yb:
                f = d.children;
                c = c._context;
                d = d.value;
                e = c._currentValue;
                c._currentValue = d;
                g = $3947ff2ea3645b8c$var$O;
                $3947ff2ea3645b8c$var$O = d = {
                    parent: g,
                    depth: null === g ? 0 : g.depth + 1,
                    context: c,
                    parentValue: e,
                    value: d
                };
                b.context = d;
                $3947ff2ea3645b8c$var$Z(a, b, f);
                a = $3947ff2ea3645b8c$var$O;
                if (null === a) throw Error($3947ff2ea3645b8c$var$k(403));
                d = a.parentValue;
                a.context._currentValue = d === $3947ff2ea3645b8c$var$hc ? a.context._defaultValue : d;
                a = $3947ff2ea3645b8c$var$O = a.parent;
                b.context = a;
                return;
            case $3947ff2ea3645b8c$var$Zb:
                d = d.children;
                d = d(c._currentValue);
                $3947ff2ea3645b8c$var$Z(a, b, d);
                return;
            case $3947ff2ea3645b8c$var$dc:
                f = c._init;
                c = f(c._payload);
                d = $3947ff2ea3645b8c$var$Yc(c, d);
                $3947ff2ea3645b8c$var$Zc(a, b, c, d, void 0);
                return;
        }
        throw Error($3947ff2ea3645b8c$var$k(130, null == c ? c : typeof c, ""));
    }
}
function $3947ff2ea3645b8c$var$Z(a, b, c) {
    b.node = c;
    if ("object" === typeof c && null !== c) {
        switch(c.$$typeof){
            case $3947ff2ea3645b8c$var$Tb:
                $3947ff2ea3645b8c$var$Zc(a, b, c.type, c.props, c.ref);
                return;
            case $3947ff2ea3645b8c$var$Ub:
                throw Error($3947ff2ea3645b8c$var$k(257));
            case $3947ff2ea3645b8c$var$dc:
                var d = c._init;
                c = d(c._payload);
                $3947ff2ea3645b8c$var$Z(a, b, c);
                return;
        }
        if ($3947ff2ea3645b8c$var$ra(c)) {
            $3947ff2ea3645b8c$var$bd(a, b, c);
            return;
        }
        null === c || "object" !== typeof c ? d = null : (d = $3947ff2ea3645b8c$var$ic && c[$3947ff2ea3645b8c$var$ic] || c["@@iterator"], d = "function" === typeof d ? d : null);
        if (d && (d = d.call(c))) {
            c = d.next();
            if (!c.done) {
                var f = [];
                do f.push(c.value), c = d.next();
                while (!c.done);
                $3947ff2ea3645b8c$var$bd(a, b, f);
            }
            return;
        }
        a = Object.prototype.toString.call(c);
        throw Error($3947ff2ea3645b8c$var$k(31, "[object Object]" === a ? "object with keys {" + Object.keys(c).join(", ") + "}" : a));
    }
    "string" === typeof c ? (d = b.blockedSegment, d.lastPushedText = $3947ff2ea3645b8c$var$Da(b.blockedSegment.chunks, c, a.responseState, d.lastPushedText)) : "number" === typeof c && (d = b.blockedSegment, d.lastPushedText = $3947ff2ea3645b8c$var$Da(b.blockedSegment.chunks, "" + c, a.responseState, d.lastPushedText));
}
function $3947ff2ea3645b8c$var$bd(a, b, c) {
    for(var d = c.length, f = 0; f < d; f++){
        var e = b.treeContext;
        b.treeContext = $3947ff2ea3645b8c$var$tc(e, d, f);
        try {
            $3947ff2ea3645b8c$var$$c(a, b, c[f]);
        } finally{
            b.treeContext = e;
        }
    }
}
function $3947ff2ea3645b8c$var$$c(a, b, c) {
    var d = b.blockedSegment.formatContext, f = b.legacyContext, e = b.context;
    try {
        return $3947ff2ea3645b8c$var$Z(a, b, c);
    } catch (m) {
        if ($3947ff2ea3645b8c$var$Gc(), "object" === typeof m && null !== m && "function" === typeof m.then) {
            c = m;
            var g = b.blockedSegment, h = $3947ff2ea3645b8c$var$Sc(a, g.chunks.length, null, g.formatContext, g.lastPushedText, !0);
            g.children.push(h);
            g.lastPushedText = !1;
            a = $3947ff2ea3645b8c$var$Tc(a, b.node, b.blockedBoundary, h, b.abortSet, b.legacyContext, b.context, b.treeContext).ping;
            c.then(a, a);
            b.blockedSegment.formatContext = d;
            b.legacyContext = f;
            b.context = e;
            $3947ff2ea3645b8c$var$Q(e);
        } else throw b.blockedSegment.formatContext = d, b.legacyContext = f, b.context = e, $3947ff2ea3645b8c$var$Q(e), m;
    }
}
function $3947ff2ea3645b8c$var$cd(a) {
    var b = a.blockedBoundary;
    a = a.blockedSegment;
    a.status = 3;
    $3947ff2ea3645b8c$var$dd(this, b, a);
}
function $3947ff2ea3645b8c$var$ed(a, b, c) {
    var d = a.blockedBoundary;
    a.blockedSegment.status = 3;
    null === d ? (b.allPendingTasks--, 2 !== b.status && (b.status = 2, null !== b.destination && b.destination.close())) : (d.pendingTasks--, d.forceClientRender || (d.forceClientRender = !0, a = void 0 === c ? Error($3947ff2ea3645b8c$var$k(432)) : c, d.errorDigest = b.onError(a), d.parentFlushed && b.clientRenderedBoundaries.push(d)), d.fallbackAbortableTasks.forEach(function(a) {
        return $3947ff2ea3645b8c$var$ed(a, b, c);
    }), d.fallbackAbortableTasks.clear(), b.allPendingTasks--, 0 === b.allPendingTasks && (d = b.onAllReady, d()));
}
function $3947ff2ea3645b8c$var$ad(a, b) {
    if (0 === b.chunks.length && 1 === b.children.length && null === b.children[0].boundary) {
        var c = b.children[0];
        c.id = b.id;
        c.parentFlushed = !0;
        1 === c.status && $3947ff2ea3645b8c$var$ad(a, c);
    } else a.completedSegments.push(b);
}
function $3947ff2ea3645b8c$var$dd(a, b, c) {
    if (null === b) {
        if (c.parentFlushed) {
            if (null !== a.completedRootSegment) throw Error($3947ff2ea3645b8c$var$k(389));
            a.completedRootSegment = c;
        }
        a.pendingRootTasks--;
        0 === a.pendingRootTasks && (a.onShellError = $3947ff2ea3645b8c$var$X, b = a.onShellReady, b());
    } else b.pendingTasks--, b.forceClientRender || (0 === b.pendingTasks ? (c.parentFlushed && 1 === c.status && $3947ff2ea3645b8c$var$ad(b, c), b.parentFlushed && a.completedBoundaries.push(b), b.fallbackAbortableTasks.forEach($3947ff2ea3645b8c$var$cd, a), b.fallbackAbortableTasks.clear()) : c.parentFlushed && 1 === c.status && ($3947ff2ea3645b8c$var$ad(b, c), 1 === b.completedSegments.length && b.parentFlushed && a.partialBoundaries.push(b)));
    a.allPendingTasks--;
    0 === a.allPendingTasks && (a = a.onAllReady, a());
}
function $3947ff2ea3645b8c$var$Uc(a) {
    if (2 !== a.status) {
        var b = $3947ff2ea3645b8c$var$O, c = $3947ff2ea3645b8c$var$Pc.current;
        $3947ff2ea3645b8c$var$Pc.current = $3947ff2ea3645b8c$var$Oc;
        var d = $3947ff2ea3645b8c$var$Nc;
        $3947ff2ea3645b8c$var$Nc = a.responseState;
        try {
            var f = a.pingedTasks, e;
            for(e = 0; e < f.length; e++){
                var g = f[e];
                var h = a, m = g.blockedSegment;
                if (0 === m.status) {
                    $3947ff2ea3645b8c$var$Q(g.context);
                    try {
                        $3947ff2ea3645b8c$var$Z(h, g, g.node), m.lastPushedText && m.textEmbedded && m.chunks.push($3947ff2ea3645b8c$var$Ca), g.abortSet.delete(g), m.status = 1, $3947ff2ea3645b8c$var$dd(h, g.blockedBoundary, m);
                    } catch (G) {
                        if ($3947ff2ea3645b8c$var$Gc(), "object" === typeof G && null !== G && "function" === typeof G.then) {
                            var q = g.ping;
                            G.then(q, q);
                        } else {
                            g.abortSet.delete(g);
                            m.status = 4;
                            var r = g.blockedBoundary, v = G, A = $3947ff2ea3645b8c$var$Y(h, v);
                            null === r ? $3947ff2ea3645b8c$var$Vc(h, v) : (r.pendingTasks--, r.forceClientRender || (r.forceClientRender = !0, r.errorDigest = A, r.parentFlushed && h.clientRenderedBoundaries.push(r)));
                            h.allPendingTasks--;
                            if (0 === h.allPendingTasks) {
                                var F = h.onAllReady;
                                F();
                            }
                        }
                    } finally{}
                }
            }
            f.splice(0, e);
            null !== a.destination && $3947ff2ea3645b8c$var$fd(a, a.destination);
        } catch (G) {
            $3947ff2ea3645b8c$var$Y(a, G), $3947ff2ea3645b8c$var$Vc(a, G);
        } finally{
            $3947ff2ea3645b8c$var$Nc = d, $3947ff2ea3645b8c$var$Pc.current = c, c === $3947ff2ea3645b8c$var$Oc && $3947ff2ea3645b8c$var$Q(b);
        }
    }
}
function $3947ff2ea3645b8c$var$gd(a, b, c) {
    c.parentFlushed = !0;
    switch(c.status){
        case 0:
            var d = c.id = a.nextSegmentId++;
            c.lastPushedText = !1;
            c.textEmbedded = !1;
            a = a.responseState;
            $3947ff2ea3645b8c$var$p(b, $3947ff2ea3645b8c$var$Va);
            $3947ff2ea3645b8c$var$p(b, a.placeholderPrefix);
            a = $3947ff2ea3645b8c$var$u(d.toString(16));
            $3947ff2ea3645b8c$var$p(b, a);
            return $3947ff2ea3645b8c$var$t(b, $3947ff2ea3645b8c$var$Wa);
        case 1:
            c.status = 2;
            var f = !0;
            d = c.chunks;
            var e = 0;
            c = c.children;
            for(var g = 0; g < c.length; g++){
                for(f = c[g]; e < f.index; e++)$3947ff2ea3645b8c$var$p(b, d[e]);
                f = $3947ff2ea3645b8c$var$hd(a, b, f);
            }
            for(; e < d.length - 1; e++)$3947ff2ea3645b8c$var$p(b, d[e]);
            e < d.length && (f = $3947ff2ea3645b8c$var$t(b, d[e]));
            return f;
        default:
            throw Error($3947ff2ea3645b8c$var$k(390));
    }
}
function $3947ff2ea3645b8c$var$hd(a, b, c) {
    var d = c.boundary;
    if (null === d) return $3947ff2ea3645b8c$var$gd(a, b, c);
    d.parentFlushed = !0;
    if (d.forceClientRender) d = d.errorDigest, $3947ff2ea3645b8c$var$t(b, $3947ff2ea3645b8c$var$$a), $3947ff2ea3645b8c$var$p(b, $3947ff2ea3645b8c$var$bb), d && ($3947ff2ea3645b8c$var$p(b, $3947ff2ea3645b8c$var$db), $3947ff2ea3645b8c$var$p(b, $3947ff2ea3645b8c$var$u($3947ff2ea3645b8c$var$C(d))), $3947ff2ea3645b8c$var$p(b, $3947ff2ea3645b8c$var$cb)), $3947ff2ea3645b8c$var$t(b, $3947ff2ea3645b8c$var$eb), $3947ff2ea3645b8c$var$gd(a, b, c);
    else if (0 < d.pendingTasks) {
        d.rootSegmentID = a.nextSegmentId++;
        0 < d.completedSegments.length && a.partialBoundaries.push(d);
        var f = a.responseState;
        var e = f.nextSuspenseID++;
        f = $3947ff2ea3645b8c$var$w(f.boundaryPrefix + e.toString(16));
        d = d.id = f;
        $3947ff2ea3645b8c$var$fb(b, a.responseState, d);
        $3947ff2ea3645b8c$var$gd(a, b, c);
    } else if (d.byteSize > a.progressiveChunkSize) d.rootSegmentID = a.nextSegmentId++, a.completedBoundaries.push(d), $3947ff2ea3645b8c$var$fb(b, a.responseState, d.id), $3947ff2ea3645b8c$var$gd(a, b, c);
    else {
        $3947ff2ea3645b8c$var$t(b, $3947ff2ea3645b8c$var$Xa);
        c = d.completedSegments;
        if (1 !== c.length) throw Error($3947ff2ea3645b8c$var$k(391));
        $3947ff2ea3645b8c$var$hd(a, b, c[0]);
    }
    return $3947ff2ea3645b8c$var$t(b, $3947ff2ea3645b8c$var$ab);
}
function $3947ff2ea3645b8c$var$id(a, b, c) {
    $3947ff2ea3645b8c$var$Bb(b, a.responseState, c.formatContext, c.id);
    $3947ff2ea3645b8c$var$hd(a, b, c);
    return $3947ff2ea3645b8c$var$Cb(b, c.formatContext);
}
function $3947ff2ea3645b8c$var$jd(a, b, c) {
    for(var d = c.completedSegments, f = 0; f < d.length; f++)$3947ff2ea3645b8c$var$kd(a, b, c, d[f]);
    d.length = 0;
    a = a.responseState;
    d = c.id;
    c = c.rootSegmentID;
    $3947ff2ea3645b8c$var$p(b, a.startInlineScript);
    a.sentCompleteBoundaryFunction ? $3947ff2ea3645b8c$var$p(b, $3947ff2ea3645b8c$var$Jb) : (a.sentCompleteBoundaryFunction = !0, $3947ff2ea3645b8c$var$p(b, $3947ff2ea3645b8c$var$Ib));
    if (null === d) throw Error($3947ff2ea3645b8c$var$k(395));
    c = $3947ff2ea3645b8c$var$u(c.toString(16));
    $3947ff2ea3645b8c$var$p(b, d);
    $3947ff2ea3645b8c$var$p(b, $3947ff2ea3645b8c$var$Kb);
    $3947ff2ea3645b8c$var$p(b, a.segmentPrefix);
    $3947ff2ea3645b8c$var$p(b, c);
    return $3947ff2ea3645b8c$var$t(b, $3947ff2ea3645b8c$var$Lb);
}
function $3947ff2ea3645b8c$var$kd(a, b, c, d) {
    if (2 === d.status) return !0;
    var f = d.id;
    if (-1 === f) {
        if (-1 === (d.id = c.rootSegmentID)) throw Error($3947ff2ea3645b8c$var$k(392));
        return $3947ff2ea3645b8c$var$id(a, b, d);
    }
    $3947ff2ea3645b8c$var$id(a, b, d);
    a = a.responseState;
    $3947ff2ea3645b8c$var$p(b, a.startInlineScript);
    a.sentCompleteSegmentFunction ? $3947ff2ea3645b8c$var$p(b, $3947ff2ea3645b8c$var$Eb) : (a.sentCompleteSegmentFunction = !0, $3947ff2ea3645b8c$var$p(b, $3947ff2ea3645b8c$var$Db));
    $3947ff2ea3645b8c$var$p(b, a.segmentPrefix);
    f = $3947ff2ea3645b8c$var$u(f.toString(16));
    $3947ff2ea3645b8c$var$p(b, f);
    $3947ff2ea3645b8c$var$p(b, $3947ff2ea3645b8c$var$Gb);
    $3947ff2ea3645b8c$var$p(b, a.placeholderPrefix);
    $3947ff2ea3645b8c$var$p(b, f);
    return $3947ff2ea3645b8c$var$t(b, $3947ff2ea3645b8c$var$Hb);
}
function $3947ff2ea3645b8c$var$fd(a, b) {
    $3947ff2ea3645b8c$var$l = new Uint8Array(512);
    $3947ff2ea3645b8c$var$n = 0;
    try {
        var c = a.completedRootSegment;
        if (null !== c && 0 === a.pendingRootTasks) {
            $3947ff2ea3645b8c$var$hd(a, b, c);
            a.completedRootSegment = null;
            var d = a.responseState.bootstrapChunks;
            for(c = 0; c < d.length - 1; c++)$3947ff2ea3645b8c$var$p(b, d[c]);
            c < d.length && $3947ff2ea3645b8c$var$t(b, d[c]);
        }
        var f = a.clientRenderedBoundaries, e;
        for(e = 0; e < f.length; e++){
            var g = f[e];
            d = b;
            var h = a.responseState, m = g.id, q = g.errorDigest, r = g.errorMessage, v = g.errorComponentStack;
            $3947ff2ea3645b8c$var$p(d, h.startInlineScript);
            h.sentClientRenderFunction ? $3947ff2ea3645b8c$var$p(d, $3947ff2ea3645b8c$var$Nb) : (h.sentClientRenderFunction = !0, $3947ff2ea3645b8c$var$p(d, $3947ff2ea3645b8c$var$Mb));
            if (null === m) throw Error($3947ff2ea3645b8c$var$k(395));
            $3947ff2ea3645b8c$var$p(d, m);
            $3947ff2ea3645b8c$var$p(d, $3947ff2ea3645b8c$var$Ob);
            if (q || r || v) $3947ff2ea3645b8c$var$p(d, $3947ff2ea3645b8c$var$Qb), $3947ff2ea3645b8c$var$p(d, $3947ff2ea3645b8c$var$u($3947ff2ea3645b8c$var$Sb(q || "")));
            if (r || v) $3947ff2ea3645b8c$var$p(d, $3947ff2ea3645b8c$var$Qb), $3947ff2ea3645b8c$var$p(d, $3947ff2ea3645b8c$var$u($3947ff2ea3645b8c$var$Sb(r || "")));
            v && ($3947ff2ea3645b8c$var$p(d, $3947ff2ea3645b8c$var$Qb), $3947ff2ea3645b8c$var$p(d, $3947ff2ea3645b8c$var$u($3947ff2ea3645b8c$var$Sb(v))));
            if (!$3947ff2ea3645b8c$var$t(d, $3947ff2ea3645b8c$var$Pb)) {
                a.destination = null;
                e++;
                f.splice(0, e);
                return;
            }
        }
        f.splice(0, e);
        var A = a.completedBoundaries;
        for(e = 0; e < A.length; e++)if (!$3947ff2ea3645b8c$var$jd(a, b, A[e])) {
            a.destination = null;
            e++;
            A.splice(0, e);
            return;
        }
        A.splice(0, e);
        $3947ff2ea3645b8c$var$ba(b);
        $3947ff2ea3645b8c$var$l = new Uint8Array(512);
        $3947ff2ea3645b8c$var$n = 0;
        var F = a.partialBoundaries;
        for(e = 0; e < F.length; e++){
            var G = F[e];
            a: {
                f = a;
                g = b;
                var ma = G.completedSegments;
                for(h = 0; h < ma.length; h++)if (!$3947ff2ea3645b8c$var$kd(f, g, G, ma[h])) {
                    h++;
                    ma.splice(0, h);
                    var Fb = !1;
                    break a;
                }
                ma.splice(0, h);
                Fb = !0;
            }
            if (!Fb) {
                a.destination = null;
                e++;
                F.splice(0, e);
                return;
            }
        }
        F.splice(0, e);
        var na = a.completedBoundaries;
        for(e = 0; e < na.length; e++)if (!$3947ff2ea3645b8c$var$jd(a, b, na[e])) {
            a.destination = null;
            e++;
            na.splice(0, e);
            return;
        }
        na.splice(0, e);
    } finally{
        $3947ff2ea3645b8c$var$ba(b), 0 === a.allPendingTasks && 0 === a.pingedTasks.length && 0 === a.clientRenderedBoundaries.length && 0 === a.completedBoundaries.length && b.close();
    }
}
function $3947ff2ea3645b8c$var$ld(a, b) {
    try {
        var c = a.abortableTasks;
        c.forEach(function(c) {
            return $3947ff2ea3645b8c$var$ed(c, a, b);
        });
        c.clear();
        null !== a.destination && $3947ff2ea3645b8c$var$fd(a, a.destination);
    } catch (d) {
        $3947ff2ea3645b8c$var$Y(a, d), $3947ff2ea3645b8c$var$Vc(a, d);
    }
}
$3947ff2ea3645b8c$export$7020a3240b287705 = function(a, b) {
    return new Promise(function(c, d) {
        var f, e, g = new Promise(function(a, b) {
            e = a;
            f = b;
        }), h = $3947ff2ea3645b8c$var$Rc(a, $3947ff2ea3645b8c$var$za(b ? b.identifierPrefix : void 0, b ? b.nonce : void 0, b ? b.bootstrapScriptContent : void 0, b ? b.bootstrapScripts : void 0, b ? b.bootstrapModules : void 0), $3947ff2ea3645b8c$var$Aa(b ? b.namespaceURI : void 0), b ? b.progressiveChunkSize : void 0, b ? b.onError : void 0, e, function() {
            var a = new ReadableStream({
                type: "bytes",
                pull: function(a) {
                    if (1 === h.status) h.status = 2, $3947ff2ea3645b8c$var$da(a, h.fatalError);
                    else if (2 !== h.status && null === h.destination) {
                        h.destination = a;
                        try {
                            $3947ff2ea3645b8c$var$fd(h, a);
                        } catch (A) {
                            $3947ff2ea3645b8c$var$Y(h, A), $3947ff2ea3645b8c$var$Vc(h, A);
                        }
                    }
                },
                cancel: function() {
                    $3947ff2ea3645b8c$var$ld(h);
                }
            }, {
                highWaterMark: 0
            });
            a.allReady = g;
            c(a);
        }, function(a) {
            g.catch(function() {});
            d(a);
        }, f);
        if (b && b.signal) {
            var m = b.signal, q = function() {
                $3947ff2ea3645b8c$var$ld(h, m.reason);
                m.removeEventListener("abort", q);
            };
            m.addEventListener("abort", q);
        }
        $3947ff2ea3645b8c$var$Uc(h);
    });
};
$3947ff2ea3645b8c$export$83d89fbfd8236492 = "18.3.1";

});


parcelRegister("alVaN", function(module, exports) {
!function(t, e) {
    module.exports = e();
}(module.exports, function() {
    "use strict";
    var t = 1e3, e = 6e4, n = 36e5, r = "millisecond", i = "second", s = "minute", u = "hour", a = "day", o = "week", c = "month", f = "quarter", h = "year", d = "date", l = "Invalid Date", $ = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, y = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, M = {
        name: "en",
        weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
        months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
        ordinal: function(t) {
            var e = [
                "th",
                "st",
                "nd",
                "rd"
            ], n = t % 100;
            return "[" + t + (e[(n - 20) % 10] || e[n] || e[0]) + "]";
        }
    }, m = function(t, e, n) {
        var r = String(t);
        return !r || r.length >= e ? t : "" + Array(e + 1 - r.length).join(n) + t;
    }, v = {
        s: m,
        z: function(t) {
            var e = -t.utcOffset(), n = Math.abs(e), r = Math.floor(n / 60), i = n % 60;
            return (e <= 0 ? "+" : "-") + m(r, 2, "0") + ":" + m(i, 2, "0");
        },
        m: function t(e, n) {
            if (e.date() < n.date()) return -t(n, e);
            var r = 12 * (n.year() - e.year()) + (n.month() - e.month()), i = e.clone().add(r, c), s = n - i < 0, u = e.clone().add(r + (s ? -1 : 1), c);
            return +(-(r + (n - i) / (s ? i - u : u - i)) || 0);
        },
        a: function(t) {
            return t < 0 ? Math.ceil(t) || 0 : Math.floor(t);
        },
        p: function(t) {
            return ({
                M: c,
                y: h,
                w: o,
                d: a,
                D: d,
                h: u,
                m: s,
                s: i,
                ms: r,
                Q: f
            })[t] || String(t || "").toLowerCase().replace(/s$/, "");
        },
        u: function(t) {
            return void 0 === t;
        }
    }, g = "en", D = {};
    D[g] = M;
    var p = "$isDayjsObject", S = function(t) {
        return t instanceof _ || !(!t || !t[p]);
    }, w = function t(e, n, r) {
        var i;
        if (!e) return g;
        if ("string" == typeof e) {
            var s = e.toLowerCase();
            D[s] && (i = s), n && (D[s] = n, i = s);
            var u = e.split("-");
            if (!i && u.length > 1) return t(u[0]);
        } else {
            var a = e.name;
            D[a] = e, i = a;
        }
        return !r && i && (g = i), i || !r && g;
    }, O = function(t, e) {
        if (S(t)) return t.clone();
        var n = "object" == typeof e ? e : {};
        return n.date = t, n.args = arguments, new _(n);
    }, b = v;
    b.l = w, b.i = S, b.w = function(t, e) {
        return O(t, {
            locale: e.$L,
            utc: e.$u,
            x: e.$x,
            $offset: e.$offset
        });
    };
    var _ = function() {
        function M(t) {
            this.$L = w(t.locale, null, !0), this.parse(t), this.$x = this.$x || t.x || {}, this[p] = !0;
        }
        var m = M.prototype;
        return m.parse = function(t) {
            this.$d = function(t) {
                var e = t.date, n = t.utc;
                if (null === e) return new Date(NaN);
                if (b.u(e)) return new Date;
                if (e instanceof Date) return new Date(e);
                if ("string" == typeof e && !/Z$/i.test(e)) {
                    var r = e.match($);
                    if (r) {
                        var i = r[2] - 1 || 0, s = (r[7] || "0").substring(0, 3);
                        return n ? new Date(Date.UTC(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, s)) : new Date(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, s);
                    }
                }
                return new Date(e);
            }(t), this.init();
        }, m.init = function() {
            var t = this.$d;
            this.$y = t.getFullYear(), this.$M = t.getMonth(), this.$D = t.getDate(), this.$W = t.getDay(), this.$H = t.getHours(), this.$m = t.getMinutes(), this.$s = t.getSeconds(), this.$ms = t.getMilliseconds();
        }, m.$utils = function() {
            return b;
        }, m.isValid = function() {
            return !(this.$d.toString() === l);
        }, m.isSame = function(t, e) {
            var n = O(t);
            return this.startOf(e) <= n && n <= this.endOf(e);
        }, m.isAfter = function(t, e) {
            return O(t) < this.startOf(e);
        }, m.isBefore = function(t, e) {
            return this.endOf(e) < O(t);
        }, m.$g = function(t, e, n) {
            return b.u(t) ? this[e] : this.set(n, t);
        }, m.unix = function() {
            return Math.floor(this.valueOf() / 1e3);
        }, m.valueOf = function() {
            return this.$d.getTime();
        }, m.startOf = function(t, e) {
            var n = this, r = !!b.u(e) || e, f = b.p(t), l = function(t, e) {
                var i = b.w(n.$u ? Date.UTC(n.$y, e, t) : new Date(n.$y, e, t), n);
                return r ? i : i.endOf(a);
            }, $ = function(t, e) {
                return b.w(n.toDate()[t].apply(n.toDate("s"), (r ? [
                    0,
                    0,
                    0,
                    0
                ] : [
                    23,
                    59,
                    59,
                    999
                ]).slice(e)), n);
            }, y = this.$W, M = this.$M, m = this.$D, v = "set" + (this.$u ? "UTC" : "");
            switch(f){
                case h:
                    return r ? l(1, 0) : l(31, 11);
                case c:
                    return r ? l(1, M) : l(0, M + 1);
                case o:
                    var g = this.$locale().weekStart || 0, D = (y < g ? y + 7 : y) - g;
                    return l(r ? m - D : m + (6 - D), M);
                case a:
                case d:
                    return $(v + "Hours", 0);
                case u:
                    return $(v + "Minutes", 1);
                case s:
                    return $(v + "Seconds", 2);
                case i:
                    return $(v + "Milliseconds", 3);
                default:
                    return this.clone();
            }
        }, m.endOf = function(t) {
            return this.startOf(t, !1);
        }, m.$set = function(t, e) {
            var n, o = b.p(t), f = "set" + (this.$u ? "UTC" : ""), l = (n = {}, n[a] = f + "Date", n[d] = f + "Date", n[c] = f + "Month", n[h] = f + "FullYear", n[u] = f + "Hours", n[s] = f + "Minutes", n[i] = f + "Seconds", n[r] = f + "Milliseconds", n)[o], $ = o === a ? this.$D + (e - this.$W) : e;
            if (o === c || o === h) {
                var y = this.clone().set(d, 1);
                y.$d[l]($), y.init(), this.$d = y.set(d, Math.min(this.$D, y.daysInMonth())).$d;
            } else l && this.$d[l]($);
            return this.init(), this;
        }, m.set = function(t, e) {
            return this.clone().$set(t, e);
        }, m.get = function(t) {
            return this[b.p(t)]();
        }, m.add = function(r, f) {
            var d, l = this;
            r = Number(r);
            var $ = b.p(f), y = function(t) {
                var e = O(l);
                return b.w(e.date(e.date() + Math.round(t * r)), l);
            };
            if ($ === c) return this.set(c, this.$M + r);
            if ($ === h) return this.set(h, this.$y + r);
            if ($ === a) return y(1);
            if ($ === o) return y(7);
            var M = (d = {}, d[s] = e, d[u] = n, d[i] = t, d)[$] || 1, m = this.$d.getTime() + r * M;
            return b.w(m, this);
        }, m.subtract = function(t, e) {
            return this.add(-1 * t, e);
        }, m.format = function(t) {
            var e = this, n = this.$locale();
            if (!this.isValid()) return n.invalidDate || l;
            var r = t || "YYYY-MM-DDTHH:mm:ssZ", i = b.z(this), s = this.$H, u = this.$m, a = this.$M, o = n.weekdays, c = n.months, f = n.meridiem, h = function(t, n, i, s) {
                return t && (t[n] || t(e, r)) || i[n].slice(0, s);
            }, d = function(t) {
                return b.s(s % 12 || 12, t, "0");
            }, $ = f || function(t, e, n) {
                var r = t < 12 ? "AM" : "PM";
                return n ? r.toLowerCase() : r;
            };
            return r.replace(y, function(t, r) {
                return r || function(t) {
                    switch(t){
                        case "YY":
                            return String(e.$y).slice(-2);
                        case "YYYY":
                            return b.s(e.$y, 4, "0");
                        case "M":
                            return a + 1;
                        case "MM":
                            return b.s(a + 1, 2, "0");
                        case "MMM":
                            return h(n.monthsShort, a, c, 3);
                        case "MMMM":
                            return h(c, a);
                        case "D":
                            return e.$D;
                        case "DD":
                            return b.s(e.$D, 2, "0");
                        case "d":
                            return String(e.$W);
                        case "dd":
                            return h(n.weekdaysMin, e.$W, o, 2);
                        case "ddd":
                            return h(n.weekdaysShort, e.$W, o, 3);
                        case "dddd":
                            return o[e.$W];
                        case "H":
                            return String(s);
                        case "HH":
                            return b.s(s, 2, "0");
                        case "h":
                            return d(1);
                        case "hh":
                            return d(2);
                        case "a":
                            return $(s, u, !0);
                        case "A":
                            return $(s, u, !1);
                        case "m":
                            return String(u);
                        case "mm":
                            return b.s(u, 2, "0");
                        case "s":
                            return String(e.$s);
                        case "ss":
                            return b.s(e.$s, 2, "0");
                        case "SSS":
                            return b.s(e.$ms, 3, "0");
                        case "Z":
                            return i;
                    }
                    return null;
                }(t) || i.replace(":", "");
            });
        }, m.utcOffset = function() {
            return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
        }, m.diff = function(r, d, l) {
            var $, y = this, M = b.p(d), m = O(r), v = (m.utcOffset() - this.utcOffset()) * e, g = this - m, D = function() {
                return b.m(y, m);
            };
            switch(M){
                case h:
                    $ = D() / 12;
                    break;
                case c:
                    $ = D();
                    break;
                case f:
                    $ = D() / 3;
                    break;
                case o:
                    $ = (g - v) / 6048e5;
                    break;
                case a:
                    $ = (g - v) / 864e5;
                    break;
                case u:
                    $ = g / n;
                    break;
                case s:
                    $ = g / e;
                    break;
                case i:
                    $ = g / t;
                    break;
                default:
                    $ = g;
            }
            return l ? $ : b.a($);
        }, m.daysInMonth = function() {
            return this.endOf(c).$D;
        }, m.$locale = function() {
            return D[this.$L];
        }, m.locale = function(t, e) {
            if (!t) return this.$L;
            var n = this.clone(), r = w(t, e, !0);
            return r && (n.$L = r), n;
        }, m.clone = function() {
            return b.w(this.$d, this);
        }, m.toDate = function() {
            return new Date(this.valueOf());
        }, m.toJSON = function() {
            return this.isValid() ? this.toISOString() : null;
        }, m.toISOString = function() {
            return this.$d.toISOString();
        }, m.toString = function() {
            return this.$d.toUTCString();
        }, M;
    }(), k = _.prototype;
    return O.prototype = k, [
        [
            "$ms",
            r
        ],
        [
            "$s",
            i
        ],
        [
            "$m",
            s
        ],
        [
            "$H",
            u
        ],
        [
            "$W",
            a
        ],
        [
            "$M",
            c
        ],
        [
            "$y",
            h
        ],
        [
            "$D",
            d
        ]
    ].forEach(function(t) {
        k[t[1]] = function(e) {
            return this.$g(e, t[0], t[1]);
        };
    }), O.extend = function(t, e) {
        return t.$i || (t(e, _, O), t.$i = !0), O;
    }, O.locale = w, O.isDayjs = S, O.unix = function(t) {
        return O(1e3 * t);
    }, O.en = D[g], O.Ls = D, O.p = {}, O;
});

});

parcelRegister("7KZCj", function(module, exports) {

$parcel$export(module.exports, "SectionView", function () { return SectionView; });
$parcel$export(module.exports, "EditableSections", function () { return EditableSections; });

var $4vwom = parcelRequire("4vwom");

var $eeH7J = parcelRequire("eeH7J");

var $ikBJm = parcelRequire("ikBJm");

var $21l71 = parcelRequire("21l71");

var $2uIvI = parcelRequire("2uIvI");

var $9G56J = parcelRequire("9G56J");
function SectionView({ section, index, totalCount }) {
    const [state, setState] = (0, $eeH7J.useState)({});
    (0, $eeH7J.useEffect)(()=>{
        const invalidate = ()=>{
            componentFuncs.delete(section.type);
            setState({});
        };
        let funcs = (0, $9G56J.Section).invalidators.get(section.type);
        if (!funcs) {
            funcs = [
                invalidate
            ];
            (0, $9G56J.Section).invalidators.set(section.type, funcs);
        } else funcs.push(invalidate);
        return ()=>{
            funcs.splice(funcs.indexOf(invalidate), 1);
        };
    }, [
        section.type
    ]);
    const func = (0, $9G56J.Section).types.get(section.type);
    if (func) {
        let ComponentFunc = componentFuncs.get(section.type);
        if (!ComponentFunc) {
            // Dynamically create a function that has the right name, for debugging purposes
            // eslint-disable-next-line no-eval
            ComponentFunc = eval(`((impl) => function ${section.type}(props) { 
                    return impl(props.section, props.index, props.totalCount) 
                })`)(func);
            componentFuncs.set(section.type, ComponentFunc);
        }
        return (0, $4vwom.jsx)(ComponentFunc, {
            section: section,
            index: index,
            totalCount: totalCount,
            state: state
        });
    }
    return (0, $4vwom.jsxs)("div", {
        children: [
            "Unknown section type: ",
            section.type
        ]
    });
}
const componentFuncs = new Map();


function EditableSections(props) {
    var _a, _b;
    const typeName = (_a = props.sectionTypeName) !== null && _a !== void 0 ? _a : "Section";
    const { modal, showModal } = (0, $ikBJm.useContextualModal)();
    return (0, $4vwom.jsxs)((0, $4vwom.Fragment), {
        children: [
            modal,
            (0, $4vwom.jsx)((0, $21l71.EditableArray), {
                arr: props.sections,
                direction: (_b = props.direction) !== null && _b !== void 0 ? _b : "column",
                itemClassName: props.itemClassName,
                itemStyle: props.itemStyle,
                itemCss: props.itemCss,
                itemTypeName: typeName,
                createInstance: async ()=>{
                    const { PickEditingTemplate } = await (parcelRequire("gmjuA"));
                    return PickEditingTemplate(typeName, showModal);
                },
                children: (section, index)=>{
                    var _a;
                    return (0, $4vwom.jsx)((0, $2uIvI.EditableObject), {
                        obj: section,
                        typeName: typeName,
                        style: (_a = props.innerItemStyle) === null || _a === void 0 ? void 0 : _a.call(props, index),
                        actions: {
                            deleteThis () {
                                props.sections.splice(index, 1);
                            },
                            async saveAsTemplate () {
                                const { SaveAsEditingTemplate } = await (parcelRequire("gmjuA"));
                                await SaveAsEditingTemplate(typeName, section, showModal);
                            }
                        },
                        children: (0, $4vwom.jsx)(SectionView, {
                            section: section,
                            index: index,
                            totalCount: props.sections.length
                        })
                    }, index);
                }
            })
        ]
    });
}

});
parcelRegister("2uIvI", function(module, exports) {

$parcel$export(module.exports, "EditableObject", function () { return $1d10e900091f309a$export$83a1fac83827d11a; });

var $4vwom = parcelRequire("4vwom");

var $eeH7J = parcelRequire("eeH7J");

var $fz3r9 = parcelRequire("fz3r9");

var $dOFTp = parcelRequire("dOFTp");

var $5JGam = parcelRequire("5JGam");

var $cwhCA = parcelRequire("cwhCA");

var $5iV0P = parcelRequire("5iV0P");

var $knIBr = parcelRequire("knIBr");
function $1d10e900091f309a$export$83a1fac83827d11a({ obj: obj, children: children, typeName: typeName, putType: putType, style: style, actions: actions, className: className }) {
    const { hoverProps: hoverProps } = (0, $fz3r9.useHover)();
    const { selectedObject: selectedObject, setSelectedObject: setSelectedObject } = (0, $knIBr.useSelectionContext)();
    const editing = (0, $5JGam.useIsEditing)();
    (0, $dOFTp.useObserveYProxy)(obj);
    const active = selectedObject === obj;
    const elementTarget = (0, $eeH7J.useRef)(null);
    (0, $5iV0P.SetEditableActions)(obj, actions);
    if (editing) return (0, $4vwom.jsx)("div", Object.assign({
        ref: elementTarget
    }, hoverProps, {
        onClick: (e)=>{
            setSelectedObject(obj, (0, $cwhCA.GetType)(typeName), putType ? (0, $cwhCA.GetType)(putType) : undefined);
            e.stopPropagation();
        },
        className: className,
        style: Object.assign({
            outline: active ? "1px solid #007bff" : "none"
        }, style),
        children: children
    }));
    else {
        if (style || className) return (0, $4vwom.jsx)("div", {
            style: style,
            className: className,
            children: children
        });
        else return (0, $4vwom.jsx)((0, $4vwom.Fragment), {
            children: children
        });
    }
}

});

parcelRegister("9G56J", function(module, exports) {

$parcel$export(module.exports, "Section", function () { return $70bbff91a6fc8d69$export$6e2c8f0811a474ce; });
function $70bbff91a6fc8d69$export$6e2c8f0811a474ce(arg0, arg1) {
    const renderer = typeof arg1 === "function" ? arg1 : typeof arg0 === "function" ? arg0 : undefined;
    if (!renderer) throw new Error("Section renderer must be a function");
    let name = typeof arg0 === "string" ? arg0 : renderer.name;
    if (!renderer) throw new Error("Section renderer must be a function");
    if (name.includes("$")) {
        // This name has been changed by Parcel's scope hoisting. We need to
        // extract the original name.
        const parts = name.split("$");
        if (parts.includes("export")) throw new Error("Exported section function must specify name (the name is lost due to Parcel's scope hoisting)");
        name = parts[parts.length - 1];
    }
    const hadSection = $70bbff91a6fc8d69$export$6e2c8f0811a474ce.types.has(name);
    $70bbff91a6fc8d69$export$6e2c8f0811a474ce.types.set(name, renderer);
    const invalidateFuncs = $70bbff91a6fc8d69$export$6e2c8f0811a474ce.invalidators.get(name);
    if (hadSection && invalidateFuncs) setTimeout(()=>{
        for (const invalidate of invalidateFuncs)invalidate();
    }, 1);
}
$70bbff91a6fc8d69$export$6e2c8f0811a474ce.types = new Map();
/** Hot reload callbacks.
 *
 *  Since section types are not components directly, their wrappers need to be
 *  invalidated. This is done by calling the invalidate function when a section
 *  type is re-registered.
 */ $70bbff91a6fc8d69$export$6e2c8f0811a474ce.invalidators = new Map();

});

parcelRegister("gmjuA", function(module, exports) {

var $Ks0wJ = parcelRequire("Ks0wJ");
module.exports = $Ks0wJ("izP8j").then(()=>parcelRequire("i9xRR"));

});


parcelRegister("jzNZd", function(module, exports) {

var $Ks0wJ = parcelRequire("Ks0wJ");
module.exports = $Ks0wJ("hWXli").then(()=>parcelRequire("7YxHT"));

});

parcelRegister("8Xuux", function(module, exports) {

var $Ks0wJ = parcelRequire("Ks0wJ");
module.exports = $Ks0wJ("bC65B").then(()=>parcelRequire("rpHX0"));

});

parcelRegister("hiCoo", function(module, exports) {

var $Ks0wJ = parcelRequire("Ks0wJ");
module.exports = $Ks0wJ("i7Ut5").then(()=>parcelRequire("2WG1z"));

});

parcelRegister("hFOwS", function(module, exports) {
!function(e, t) {
    module.exports = t();
}(module.exports, function() {
    "use strict";
    return function(e, t) {
        var r = t.prototype, n = r.format;
        r.format = function(e) {
            var t = this, r = this.$locale();
            if (!this.isValid()) return n.bind(this)(e);
            var s = this.$utils(), a = (e || "YYYY-MM-DDTHH:mm:ssZ").replace(/\[([^\]]+)]|Q|wo|ww|w|WW|W|zzz|z|gggg|GGGG|Do|X|x|k{1,2}|S/g, function(e) {
                switch(e){
                    case "Q":
                        return Math.ceil((t.$M + 1) / 3);
                    case "Do":
                        return r.ordinal(t.$D);
                    case "gggg":
                        return t.weekYear();
                    case "GGGG":
                        return t.isoWeekYear();
                    case "wo":
                        return r.ordinal(t.week(), "W");
                    case "w":
                    case "ww":
                        return s.s(t.week(), "w" === e ? 1 : 2, "0");
                    case "W":
                    case "WW":
                        return s.s(t.isoWeek(), "W" === e ? 1 : 2, "0");
                    case "k":
                    case "kk":
                        return s.s(String(0 === t.$H ? 24 : t.$H), "k" === e ? 1 : 2, "0");
                    case "X":
                        return Math.floor(t.$d.getTime() / 1e3);
                    case "x":
                        return t.$d.getTime();
                    case "z":
                        return "[" + t.offsetName() + "]";
                    case "zzz":
                        return "[" + t.offsetName("long") + "]";
                    default:
                        return e;
                }
            });
            return n.bind(this)(a);
        };
    };
});

});

parcelRegister("lPiLr", function(module, exports) {


module.exports = (parcelRequire("hYRbp"))((parcelRequire("3ueMA")).resolve("gTjXO"));

});
parcelRegister("hYRbp", function(module, exports) {
"use strict";

var $1BYLw = parcelRequire("1BYLw");
module.exports = $1BYLw(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same link element twice (e.g. if it was already in the HTML)
        var existingLinks = document.getElementsByTagName("link");
        if ([].concat(existingLinks).some(function isCurrentBundle(link) {
            return link.href === bundle && link.rel.indexOf("stylesheet") > -1;
        })) {
            resolve();
            return;
        }
        var link = document.createElement("link");
        link.rel = "stylesheet";
        link.href = bundle;
        link.onerror = function(e) {
            link.onerror = link.onload = null;
            link.remove();
            reject(e);
        };
        link.onload = function() {
            link.onerror = link.onload = null;
            resolve();
        };
        document.getElementsByTagName("head")[0].appendChild(link);
    });
});

});
parcelRegister("1BYLw", function(module, exports) {
"use strict";
var $12c861ed33d66216$var$cachedBundles = {};
var $12c861ed33d66216$var$cachedPreloads = {};
var $12c861ed33d66216$var$cachedPrefetches = {};
function $12c861ed33d66216$var$getCache(type) {
    switch(type){
        case "preload":
            return $12c861ed33d66216$var$cachedPreloads;
        case "prefetch":
            return $12c861ed33d66216$var$cachedPrefetches;
        default:
            return $12c861ed33d66216$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $12c861ed33d66216$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});



parcelRegister("iz9uZ", function(module, exports) {


module.exports = (parcelRequire("hYRbp"))((parcelRequire("3ueMA")).resolve("2pb92"));

});

parcelRegister("2ewgS", function(module, exports) {

var $Ks0wJ = parcelRequire("Ks0wJ");
module.exports = $Ks0wJ("baOZu").then(()=>parcelRequire("jRYEP"));

});

parcelRegister("btSzs", function(module, exports) {

var $Ks0wJ = parcelRequire("Ks0wJ");
module.exports = $Ks0wJ("jixPX").then(()=>parcelRequire("epaGf"));

});

parcelRegister("jwy4G", function(module, exports) {

var $Ks0wJ = parcelRequire("Ks0wJ");
module.exports = $Ks0wJ("fkdgT").then(()=>parcelRequire("55M9p"));

});

parcelRegister("lCPdv", function(module, exports) {

var $Ks0wJ = parcelRequire("Ks0wJ");
module.exports = $Ks0wJ("8Crgg").then(()=>parcelRequire("3ZE9P"));

});

parcelRegister("gOSPg", function(module, exports) {

var $Ks0wJ = parcelRequire("Ks0wJ");
module.exports = Promise.all([
    $Ks0wJ("cxVmz"),
    $Ks0wJ("i7Ut5"),
    $Ks0wJ("bC65B"),
    $Ks0wJ("hWXli"),
    $Ks0wJ("3J0uB")
]).then(()=>parcelRequire("5Wt7y"));

});

parcelRegister("3HqLx", function(module, exports) {

var $Ks0wJ = parcelRequire("Ks0wJ");
module.exports = $Ks0wJ("5fZO2").then(()=>parcelRequire("aRRkE"));

});

parcelRegister("cxmpT", function(module, exports) {

var $Ks0wJ = parcelRequire("Ks0wJ");
module.exports = $Ks0wJ("6gAYS").then(()=>parcelRequire("jhIQl"));

});

parcelRegister("ii2We", function(module, exports) {

var $Ks0wJ = parcelRequire("Ks0wJ");
module.exports = $Ks0wJ("bsxF7").then(()=>parcelRequire("c4Sut"));

});

parcelRegister("2g57I", function(module, exports) {

var $Ks0wJ = parcelRequire("Ks0wJ");
module.exports = $Ks0wJ("ayYuL").then(()=>parcelRequire("6Sp7a"));

});

parcelRegister("hTPrL", function(module, exports) {

var $Ks0wJ = parcelRequire("Ks0wJ");
module.exports = $Ks0wJ("kXikT").then(()=>parcelRequire("4FbLI"));

});

parcelRegister("fCOl2", function(module, exports) {

var $Ks0wJ = parcelRequire("Ks0wJ");
module.exports = Promise.all([
    $Ks0wJ("cxVmz"),
    $Ks0wJ("i7Ut5"),
    $Ks0wJ("bC65B"),
    $Ks0wJ("hWXli"),
    $Ks0wJ("39fzk")
]).then(()=>parcelRequire("5tTvz"));

});

parcelRegister("4DSuQ", function(module, exports) {

var $Ks0wJ = parcelRequire("Ks0wJ");
module.exports = Promise.all([
    $Ks0wJ("cxVmz"),
    $Ks0wJ("i7Ut5"),
    $Ks0wJ("bC65B"),
    $Ks0wJ("hWXli"),
    $Ks0wJ("lOOBd")
]).then(()=>parcelRequire("7Fezt"));

});

parcelRegister("98lGN", function(module, exports) {

var $Ks0wJ = parcelRequire("Ks0wJ");
module.exports = Promise.all([
    $Ks0wJ("izP8j"),
    $Ks0wJ("f7hWB")
]).then(()=>parcelRequire("alItr"));

});

parcelRegister("5gIPd", function(module, exports) {

$parcel$export(module.exports, "SidebarTheme", function () { return $3d6137b067c87476$export$54af0ae22283becb; });

var $lDBHC = parcelRequire("lDBHC");
let $3d6137b067c87476$var$light = true;
const $3d6137b067c87476$export$54af0ae22283becb = {
    get light () {
        return $3d6137b067c87476$var$light;
    },
    set light (value){
        if (!(0, $lDBHC.IsNode)() && value) document.head.insertAdjacentHTML("beforeend", `<style>::-webkit-calendar-picker-indicator {
            filter: invert(1);
        }</style>`);
        $3d6137b067c87476$var$light = value;
    },
    /** A CSS background string.
     *
     *  Any combination of CSS backgrounds is supported, for example:
     *
     *  `"linear-gradient(rgba(0, 0, 0, 0.75), rgba(0, 0, 0, 0.75)), url('/static/bg.png") no-repeat center center/cover"`
     */ background: undefined
};

});


var $4vwom = parcelRequire("4vwom");

var $5K1mb = parcelRequire("5K1mb");
"use strict";
globalThis.ssrTransaction = {};



var $4DHNO = parcelRequire("4DHNO");

var $8jB4x = parcelRequire("8jB4x");

var $7m9cQ = parcelRequire("7m9cQ");
var $e18f565b44c7bc7d$var$__await = undefined && undefined.__await || function(v) {
    return this instanceof $e18f565b44c7bc7d$var$__await ? (this.v = v, this) : new $e18f565b44c7bc7d$var$__await(v);
};
var $e18f565b44c7bc7d$var$__asyncGenerator = undefined && undefined.__asyncGenerator || function(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $e18f565b44c7bc7d$var$__await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
};
const $e18f565b44c7bc7d$export$ebe90cb607ad99e = {
    baseUrl: (0, $7m9cQ.server)(),
    fetch (input, init) {
        // fetch() really wants to be called like this, treating it as a
        // value won't work
        return fetch(input, init);
    },
    headers: {
        "Content-Type": "application/json"
    }
};
// Creates an adapter so browser and node streams can be used interchangeably
function $e18f565b44c7bc7d$var$readStream(stream) {
    return $e18f565b44c7bc7d$var$__asyncGenerator(this, arguments, function* readStream_1() {
        const reader = stream.getReader();
        while(true){
            const { done: done, value: value } = yield $e18f565b44c7bc7d$var$__await(reader.read());
            if (done) break;
            yield yield $e18f565b44c7bc7d$var$__await(value);
        }
    });
}
/** Registers a link in the email system and returns a URL that can be used to
access the link with tracking. */ (0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "getEmailLinkRegister",
    func: $e18f565b44c7bc7d$export$f41793ac729e4ee9
});
async function $e18f565b44c7bc7d$export$f41793ac729e4ee9(link, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const queryArgs = [];
        if (link !== undefined) queryArgs.push("link=" + encodeURIComponent(link.valueOf()));
        const headers = Object.assign(Object.assign({}, $e18f565b44c7bc7d$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $e18f565b44c7bc7d$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $e18f565b44c7bc7d$export$ebe90cb607ad99e.baseUrl) + `/api/email/link-register${queryArgs.length ? "?" + queryArgs.join("&") : ""}`, {
            method: "get",
            headers: headers
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
const $e18f565b44c7bc7d$export$bacd462009012de5 = (0, $8jB4x.SSRHook)("getEmailLinkRegister", undefined, undefined, $e18f565b44c7bc7d$export$f41793ac729e4ee9, [
    "link"
], undefined);
(0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "getAnalyticsCachePerformanceStats",
    func: $e18f565b44c7bc7d$export$ceb54ea1fc375c3a
});
async function $e18f565b44c7bc7d$export$ceb54ea1fc375c3a(customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $e18f565b44c7bc7d$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $e18f565b44c7bc7d$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $e18f565b44c7bc7d$export$ebe90cb607ad99e.baseUrl) + `/api/analytics-cache-monitor/stats`, {
            method: "get",
            headers: headers
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
const $e18f565b44c7bc7d$export$3492893e85f47f53 = (0, $8jB4x.SSRHook)("getAnalyticsCachePerformanceStats", undefined, undefined, $e18f565b44c7bc7d$export$ceb54ea1fc375c3a, [], undefined);
(0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "getShippingOptions",
    func: $e18f565b44c7bc7d$export$5472db18491ba3b8
});
async function $e18f565b44c7bc7d$export$5472db18491ba3b8(countryCode, zipCode, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const queryArgs = [];
        if (countryCode !== undefined) queryArgs.push("countryCode=" + encodeURIComponent(countryCode.valueOf()));
        if (zipCode !== undefined) queryArgs.push("zipCode=" + encodeURIComponent(zipCode.valueOf()));
        const headers = Object.assign(Object.assign({}, $e18f565b44c7bc7d$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $e18f565b44c7bc7d$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $e18f565b44c7bc7d$export$ebe90cb607ad99e.baseUrl) + `/api/shipping-options${queryArgs.length ? "?" + queryArgs.join("&") : ""}`, {
            method: "get",
            headers: headers
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
const $e18f565b44c7bc7d$export$2019485bfe6f9ed5 = (0, $8jB4x.SSRHook)("getShippingOptions", "GetShippingOptionsDto", undefined, $e18f565b44c7bc7d$export$5472db18491ba3b8, [
    "countryCode",
    "zipCode"
], undefined);
(0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "postValidateDiscountCode",
    func: $e18f565b44c7bc7d$export$d76bb2fa6025fa2e
});
async function $e18f565b44c7bc7d$export$d76bb2fa6025fa2e(body, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $e18f565b44c7bc7d$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $e18f565b44c7bc7d$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $e18f565b44c7bc7d$export$ebe90cb607ad99e.baseUrl) + `/api/validate/discount/code`, {
            method: "post",
            headers: headers,
            body: JSON.stringify(body)
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
function $e18f565b44c7bc7d$export$e4cad50a45d5955d(e) {
    return e && typeof e === "object" && "type" in e && (e.type === "BadRequest" || e.type === "TooManyRequests" || e.type === "Unauthorized" || e.type === "JWTPropertyMissing" || e.type === "DiscountCodeInvalid" || e.type === "DiscountCodeDisabled" || e.type === "DiscountCodeNotValidYet" || e.type === "DiscountCodeExpired" || e.type === "DiscountCodeUsageLimitReached");
}
(0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "getPhoneOrders",
    func: $e18f565b44c7bc7d$export$cb8b42d135ef9214
});
async function $e18f565b44c7bc7d$export$cb8b42d135ef9214(customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $e18f565b44c7bc7d$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $e18f565b44c7bc7d$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $e18f565b44c7bc7d$export$ebe90cb607ad99e.baseUrl) + `/api/phone-orders`, {
            method: "get",
            headers: headers
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
function $e18f565b44c7bc7d$export$5b6bce39f9daa63f(e) {
    return e && typeof e === "object" && "type" in e && e.type === "UnauthorizedWithVipps";
}
const $e18f565b44c7bc7d$export$25a35ae850463813 = (0, $8jB4x.SSRHook)("getPhoneOrders", "GetPhoneOrdersDto", undefined, $e18f565b44c7bc7d$export$cb8b42d135ef9214, [], undefined);
(0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "getPhoneOrder",
    func: $e18f565b44c7bc7d$export$b2d4561583563d44
});
async function $e18f565b44c7bc7d$export$b2d4561583563d44(id, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $e18f565b44c7bc7d$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $e18f565b44c7bc7d$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $e18f565b44c7bc7d$export$ebe90cb607ad99e.baseUrl) + `/api/phone-orders/${id}`, {
            method: "get",
            headers: headers
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
const $e18f565b44c7bc7d$export$42d4e273b2226793 = (0, $8jB4x.SSRHook)("getPhoneOrder", "GetPhoneOrderDto", undefined, $e18f565b44c7bc7d$export$b2d4561583563d44, [
    "id"
], undefined);
/** Validates, checks availability and calculates the price of a phone order. */ (0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "postPhoneOrderPrice",
    func: $e18f565b44c7bc7d$export$3645f875e233981
});
async function $e18f565b44c7bc7d$export$3645f875e233981(body, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $e18f565b44c7bc7d$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $e18f565b44c7bc7d$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $e18f565b44c7bc7d$export$ebe90cb607ad99e.baseUrl) + `/api/phone-order/price`, {
            method: "post",
            headers: headers,
            body: JSON.stringify(body)
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
function $e18f565b44c7bc7d$export$ddc48e3763c09f34(e) {
    return e && typeof e === "object" && "type" in e && (e.type === "BadRequest" || e.type === "Conflict" || e.type === "NoPhoneWithSpecifiedProperties" || e.type === "NotFound" || e.type === "BadTradeInResponse" || e.type === "DiscountCodeInvalid" || e.type === "DiscountCodeDisabled" || e.type === "DiscountCodeNotValidYet" || e.type === "DiscountCodeExpired" || e.type === "DiscountCodeUsageLimitReached");
}
const $e18f565b44c7bc7d$export$541c7c1cebe5b937 = (0, $8jB4x.SSRHook)("postPhoneOrderPrice", "PhoneOrderPrice", undefined, $e18f565b44c7bc7d$export$3645f875e233981, [
    "body"
], undefined);
(0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "postPhoneReservationDiscount",
    func: $e18f565b44c7bc7d$export$49b90017145ffe19
});
async function $e18f565b44c7bc7d$export$49b90017145ffe19(body, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $e18f565b44c7bc7d$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $e18f565b44c7bc7d$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $e18f565b44c7bc7d$export$ebe90cb607ad99e.baseUrl) + `/api/phone/reservation/discount`, {
            method: "post",
            headers: headers,
            body: JSON.stringify(body)
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
function $e18f565b44c7bc7d$export$992d025e60a19ceb(e) {
    return e && typeof e === "object" && "type" in e && (e.type === "BadRequest" || e.type === "TooManyRequests" || e.type === "Unauthorized" || e.type === "JWTPropertyMissing" || e.type === "DiscountCodeInvalid" || e.type === "DiscountCodeDisabled" || e.type === "DiscountCodeNotValidYet" || e.type === "DiscountCodeExpired" || e.type === "DiscountCodeUsageLimitReached");
}
/** Places a phone order for the current user. This implies consent to the terms
and conditions. */ (0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "postPhoneOrder",
    func: $e18f565b44c7bc7d$export$6cb3fb5ed3274c4c
});
async function $e18f565b44c7bc7d$export$6cb3fb5ed3274c4c(body, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $e18f565b44c7bc7d$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $e18f565b44c7bc7d$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $e18f565b44c7bc7d$export$ebe90cb607ad99e.baseUrl) + `/api/phone-order`, {
            method: "post",
            headers: headers,
            body: JSON.stringify(body)
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
function $e18f565b44c7bc7d$export$3a3bb931e8cd5a6f(e) {
    return e && typeof e === "object" && "type" in e && (e.type === "Forbidden" || e.type === "BadRequest" || e.type === "TooManyRequests" || e.type === "Unauthorized" || e.type === "JWTPropertyMissing" || e.type === "UnauthorizedWithVipps" || e.type === "Conflict" || e.type === "NoPhoneWithSpecifiedProperties" || e.type === "NotFound" || e.type === "BadTradeInResponse" || e.type === "DiscountCodeInvalid" || e.type === "DiscountCodeDisabled" || e.type === "DiscountCodeNotValidYet" || e.type === "DiscountCodeExpired" || e.type === "DiscountCodeUsageLimitReached");
}
(0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "postOrderTradeIn",
    func: $e18f565b44c7bc7d$export$6b2bf9023d89c7d6
});
async function $e18f565b44c7bc7d$export$6b2bf9023d89c7d6(id, body, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $e18f565b44c7bc7d$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $e18f565b44c7bc7d$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $e18f565b44c7bc7d$export$ebe90cb607ad99e.baseUrl) + `/api/phone-order/${id}/trade-in`, {
            method: "post",
            headers: headers,
            body: JSON.stringify(body)
        });
        if (_res.status >= 200 && _res.status <= 299) return;
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
function $e18f565b44c7bc7d$export$26b6f4574ce244f6(e) {
    return e && typeof e === "object" && "type" in e && (e.type === "NotFound" || e.type === "BadRequest" || e.type === "BadTradeInResponse");
}
(0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "postExpirePhoneReservationOrder",
    func: $e18f565b44c7bc7d$export$a2c4756bb6719a7
});
async function $e18f565b44c7bc7d$export$a2c4756bb6719a7(id, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const queryArgs = [];
        if (id !== undefined) queryArgs.push("id=" + encodeURIComponent(id.valueOf()));
        const headers = Object.assign(Object.assign({}, $e18f565b44c7bc7d$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $e18f565b44c7bc7d$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $e18f565b44c7bc7d$export$ebe90cb607ad99e.baseUrl) + `/api/expire/phone/reservation/order${queryArgs.length ? "?" + queryArgs.join("&") : ""}`, {
            method: "post",
            headers: headers
        });
        if (_res.status >= 200 && _res.status <= 299) return;
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
function $e18f565b44c7bc7d$export$c3abc700d4edc9c9(e) {
    return e && typeof e === "object" && "type" in e && (e.type === "NotFound" || e.type === "BadRequest" || e.type === "Unauthorized" || e.type === "UnauthorizedWithVipps");
}
/** Returns offers for the phones available for sale.
Pass models argument to limit which models to get offers for. */ (0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "getPhoneOffers",
    func: $e18f565b44c7bc7d$export$aa261a0b4ba6dd2c
});
async function $e18f565b44c7bc7d$export$aa261a0b4ba6dd2c(models, sizes, colors, rentalPeriod, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const queryArgs = [];
        if (models !== undefined) queryArgs.push(...models.map((x)=>"models=" + encodeURIComponent(x.valueOf())));
        if (sizes !== undefined) queryArgs.push(...sizes.map((x)=>"sizes=" + encodeURIComponent(x.valueOf())));
        if (colors !== undefined) queryArgs.push(...colors.map((x)=>"colors=" + encodeURIComponent(x.valueOf())));
        if (rentalPeriod !== undefined) queryArgs.push("rentalPeriod=" + encodeURIComponent(rentalPeriod.valueOf()));
        const headers = Object.assign(Object.assign({}, $e18f565b44c7bc7d$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $e18f565b44c7bc7d$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $e18f565b44c7bc7d$export$ebe90cb607ad99e.baseUrl) + `/api/phone-offers${queryArgs.length ? "?" + queryArgs.join("&") : ""}`, {
            method: "get",
            headers: headers
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
function $e18f565b44c7bc7d$export$7d28afe3114a6582(e) {
    return e && typeof e === "object" && "type" in e && e.type === "BadRequest";
}
const $e18f565b44c7bc7d$export$88e20cfc122b8557 = (0, $8jB4x.SSRHook)("getPhoneOffers", undefined, undefined, $e18f565b44c7bc7d$export$aa261a0b4ba6dd2c, [
    "models",
    "sizes",
    "colors",
    "rentalPeriod"
], undefined);
(0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "getPhoneColors",
    func: $e18f565b44c7bc7d$export$f2c7748945d71cf1
});
async function $e18f565b44c7bc7d$export$f2c7748945d71cf1(customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $e18f565b44c7bc7d$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $e18f565b44c7bc7d$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $e18f565b44c7bc7d$export$ebe90cb607ad99e.baseUrl) + `/api/phone-colors`, {
            method: "get",
            headers: headers
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
const $e18f565b44c7bc7d$export$b75b9022126d533b = (0, $8jB4x.SSRHook)("getPhoneColors", undefined, undefined, $e18f565b44c7bc7d$export$f2c7748945d71cf1, [], undefined);
(0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "getPhoneStorageSizes",
    func: $e18f565b44c7bc7d$export$21629c2e15e3054f
});
async function $e18f565b44c7bc7d$export$21629c2e15e3054f(customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $e18f565b44c7bc7d$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $e18f565b44c7bc7d$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $e18f565b44c7bc7d$export$ebe90cb607ad99e.baseUrl) + `/api/phone-storage-sizes`, {
            method: "get",
            headers: headers
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
const $e18f565b44c7bc7d$export$4df04d41a3cf32b1 = (0, $8jB4x.SSRHook)("getPhoneStorageSizes", undefined, undefined, $e18f565b44c7bc7d$export$21629c2e15e3054f, [], undefined);
(0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "getPhonesPriceHistogram",
    func: $e18f565b44c7bc7d$export$12862f047242a8bf
});
async function $e18f565b44c7bc7d$export$12862f047242a8bf(customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $e18f565b44c7bc7d$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $e18f565b44c7bc7d$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $e18f565b44c7bc7d$export$ebe90cb607ad99e.baseUrl) + `/api/phone-price-histogram`, {
            method: "get",
            headers: headers
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
function $e18f565b44c7bc7d$export$fb6a4d4f8fc41d21(e) {
    return e && typeof e === "object" && "type" in e && (e.type === "NotFound" || e.type === "PhoneModelSoldOut" || e.type === "BadRequest");
}
const $e18f565b44c7bc7d$export$ada9abdd52b4cf46 = (0, $8jB4x.SSRHook)("getPhonesPriceHistogram", "GetPhonesPriceHistogramDto", undefined, $e18f565b44c7bc7d$export$12862f047242a8bf, [], undefined);
/** Returns a particular phone offer, including the available model specific configuration
options. */ (0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "getPhoneOffer",
    func: $e18f565b44c7bc7d$export$3cb82d8424b9fdf6
});
async function $e18f565b44c7bc7d$export$3cb82d8424b9fdf6(id, rentalPeriod, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const queryArgs = [];
        if (rentalPeriod !== undefined) queryArgs.push("rentalPeriod=" + encodeURIComponent(rentalPeriod.valueOf()));
        const headers = Object.assign(Object.assign({}, $e18f565b44c7bc7d$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $e18f565b44c7bc7d$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $e18f565b44c7bc7d$export$ebe90cb607ad99e.baseUrl) + `/api/phone-offers/${id}${queryArgs.length ? "?" + queryArgs.join("&") : ""}`, {
            method: "get",
            headers: headers
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
function $e18f565b44c7bc7d$export$b41bea5887a2cdec(e) {
    return e && typeof e === "object" && "type" in e && (e.type === "NotFound" || e.type === "PhoneModelSoldOut" || e.type === "BadRequest");
}
const $e18f565b44c7bc7d$export$b1c43cd413897984 = (0, $8jB4x.SSRHook)("getPhoneOffer", "GetPhoneOfferDto", undefined, $e18f565b44c7bc7d$export$3cb82d8424b9fdf6, [
    "id",
    "rentalPeriod"
], undefined);
/** Requests an updated phone offer after a user has modified it, e.g. selected a
different color or storage size. */ (0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "postPhoneOffer",
    func: $e18f565b44c7bc7d$export$a5ae59f6dafb10b4
});
async function $e18f565b44c7bc7d$export$a5ae59f6dafb10b4(prop, body, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const queryArgs = [];
        if (prop !== undefined) queryArgs.push("prop=" + encodeURIComponent(prop.valueOf()));
        const headers = Object.assign(Object.assign({}, $e18f565b44c7bc7d$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $e18f565b44c7bc7d$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $e18f565b44c7bc7d$export$ebe90cb607ad99e.baseUrl) + `/api/phone-offers${queryArgs.length ? "?" + queryArgs.join("&") : ""}`, {
            method: "post",
            headers: headers,
            body: JSON.stringify(body)
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
function $e18f565b44c7bc7d$export$201f3ad37fbc711f(e) {
    return e && typeof e === "object" && "type" in e && (e.type === "NoPhoneWithSpecifiedProperties" || e.type === "NotFound" || e.type === "BadRequest");
}
/** Returns information about a phone model, including the different attributes
and their possible values. */ (0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "getPhoneModel",
    func: $e18f565b44c7bc7d$export$b3b8a99f0257f07b
});
async function $e18f565b44c7bc7d$export$b3b8a99f0257f07b(modelId, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $e18f565b44c7bc7d$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $e18f565b44c7bc7d$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $e18f565b44c7bc7d$export$ebe90cb607ad99e.baseUrl) + `/api/phone-models/${modelId}`, {
            method: "get",
            headers: headers
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
const $e18f565b44c7bc7d$export$c59e944d78f7ce56 = (0, $8jB4x.SSRHook)("getPhoneModel", "GetPhoneModelDto", undefined, $e18f565b44c7bc7d$export$b3b8a99f0257f07b, [
    "modelId"
], undefined);
(0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "getPhoneModels",
    func: $e18f565b44c7bc7d$export$7eea0acc64eabf2c
});
async function $e18f565b44c7bc7d$export$7eea0acc64eabf2c(modelIds, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const queryArgs = [];
        if (modelIds !== undefined) queryArgs.push(...modelIds.map((x)=>"modelIds=" + encodeURIComponent(x.valueOf())));
        const headers = Object.assign(Object.assign({}, $e18f565b44c7bc7d$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $e18f565b44c7bc7d$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $e18f565b44c7bc7d$export$ebe90cb607ad99e.baseUrl) + `/api/phone-models${queryArgs.length ? "?" + queryArgs.join("&") : ""}`, {
            method: "get",
            headers: headers
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
const $e18f565b44c7bc7d$export$b99855a9ac1ee5b2 = (0, $8jB4x.SSRHook)("getPhoneModels", undefined, undefined, $e18f565b44c7bc7d$export$7eea0acc64eabf2c, [
    "modelIds"
], undefined);
(0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "getCountries",
    func: $e18f565b44c7bc7d$export$44f7508c6c352cc6
});
async function $e18f565b44c7bc7d$export$44f7508c6c352cc6(customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $e18f565b44c7bc7d$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $e18f565b44c7bc7d$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $e18f565b44c7bc7d$export$ebe90cb607ad99e.baseUrl) + `/api/countries`, {
            method: "get",
            headers: headers
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
const $e18f565b44c7bc7d$export$1984d0199e312f12 = (0, $8jB4x.SSRHook)("getCountries", undefined, undefined, $e18f565b44c7bc7d$export$44f7508c6c352cc6, [], undefined);
(0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "getConditionGrades",
    func: $e18f565b44c7bc7d$export$e84835c21140fc65
});
async function $e18f565b44c7bc7d$export$e84835c21140fc65(customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $e18f565b44c7bc7d$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $e18f565b44c7bc7d$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $e18f565b44c7bc7d$export$ebe90cb607ad99e.baseUrl) + `/api/condition/grades`, {
            method: "get",
            headers: headers
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
const $e18f565b44c7bc7d$export$713f13fb69b50c52 = (0, $8jB4x.SSRHook)("getConditionGrades", undefined, undefined, $e18f565b44c7bc7d$export$e84835c21140fc65, [], undefined);
(0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "getTradeInForm",
    func: $e18f565b44c7bc7d$export$54cccb78c371bb41
});
async function $e18f565b44c7bc7d$export$54cccb78c371bb41(type, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $e18f565b44c7bc7d$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $e18f565b44c7bc7d$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $e18f565b44c7bc7d$export$ebe90cb607ad99e.baseUrl) + `/api/trade-in-forms/${type}`, {
            method: "get",
            headers: headers
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
const $e18f565b44c7bc7d$export$f8778ca18805596d = (0, $8jB4x.SSRHook)("getTradeInForm", "GetTradeInFormDto", undefined, $e18f565b44c7bc7d$export$54cccb78c371bb41, [
    "type"
], undefined);
/** Computes the value of your trade-in device. */ (0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "postTradeInFormsValue",
    func: $e18f565b44c7bc7d$export$8f2b94717249315f
});
async function $e18f565b44c7bc7d$export$8f2b94717249315f(type, body, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $e18f565b44c7bc7d$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $e18f565b44c7bc7d$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $e18f565b44c7bc7d$export$ebe90cb607ad99e.baseUrl) + `/api/trade-in-forms/${type}/value`, {
            method: "post",
            headers: headers,
            body: JSON.stringify(body)
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
function $e18f565b44c7bc7d$export$e802dabdf78fb12f(e) {
    return e && typeof e === "object" && "type" in e && (e.type === "BadTradeInResponse" || e.type === "BadRequest");
}
(0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "getInsuranceOptions",
    func: $e18f565b44c7bc7d$export$633da977d987cf8f
});
async function $e18f565b44c7bc7d$export$633da977d987cf8f(model, storageSize, color, rentalPeriod, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const queryArgs = [];
        if (model !== undefined) queryArgs.push("model=" + encodeURIComponent(model.valueOf()));
        if (storageSize !== undefined) queryArgs.push("storageSize=" + encodeURIComponent(storageSize.valueOf()));
        if (color !== undefined) queryArgs.push("color=" + encodeURIComponent(color.valueOf()));
        if (rentalPeriod !== undefined) queryArgs.push("rentalPeriod=" + encodeURIComponent(rentalPeriod.valueOf()));
        const headers = Object.assign(Object.assign({}, $e18f565b44c7bc7d$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $e18f565b44c7bc7d$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $e18f565b44c7bc7d$export$ebe90cb607ad99e.baseUrl) + `/api/insurance-options${queryArgs.length ? "?" + queryArgs.join("&") : ""}`, {
            method: "get",
            headers: headers
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
function $e18f565b44c7bc7d$export$efd5e43623a258fb(e) {
    return e && typeof e === "object" && "type" in e && e.type === "BadRequest";
}
const $e18f565b44c7bc7d$export$fd8b73cd610fc548 = (0, $8jB4x.SSRHook)("getInsuranceOptions", undefined, undefined, $e18f565b44c7bc7d$export$633da977d987cf8f, [
    "model",
    "storageSize",
    "color",
    "rentalPeriod"
], undefined);
(0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "getMe",
    func: $e18f565b44c7bc7d$export$dd7946daa6163e94
});
async function $e18f565b44c7bc7d$export$dd7946daa6163e94(customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $e18f565b44c7bc7d$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $e18f565b44c7bc7d$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $e18f565b44c7bc7d$export$ebe90cb607ad99e.baseUrl) + `/api/me`, {
            method: "get",
            headers: headers
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
const $e18f565b44c7bc7d$export$f637e1cf42d15a62 = (0, $8jB4x.SSRHook)("getMe", "GetMeDto", undefined, $e18f565b44c7bc7d$export$dd7946daa6163e94, [], undefined);
(0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "getStoredPaymentMethods",
    func: $e18f565b44c7bc7d$export$1b242df43ef46728
});
async function $e18f565b44c7bc7d$export$1b242df43ef46728(customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $e18f565b44c7bc7d$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $e18f565b44c7bc7d$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $e18f565b44c7bc7d$export$ebe90cb607ad99e.baseUrl) + `/api/me/payment-methods`, {
            method: "get",
            headers: headers
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
function $e18f565b44c7bc7d$export$4dab25304feab9ac(e) {
    return e && typeof e === "object" && "type" in e && (e.type === "InternalServerError" || e.type === "UnauthorizedWithVipps");
}
const $e18f565b44c7bc7d$export$b66da2e92981394 = (0, $8jB4x.SSRHook)("getStoredPaymentMethods", undefined, undefined, $e18f565b44c7bc7d$export$1b242df43ef46728, [], undefined);
(0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "putMarketingConsent",
    func: $e18f565b44c7bc7d$export$97519be7b2793f54
});
async function $e18f565b44c7bc7d$export$97519be7b2793f54(body, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $e18f565b44c7bc7d$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $e18f565b44c7bc7d$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $e18f565b44c7bc7d$export$ebe90cb607ad99e.baseUrl) + `/api/me/marketing-consent`, {
            method: "put",
            headers: headers,
            body: JSON.stringify(body)
        });
        if (_res.status >= 200 && _res.status <= 299) return;
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
function $e18f565b44c7bc7d$export$6ee92823d5224d38(e) {
    return e && typeof e === "object" && "type" in e && e.type === "UnauthorizedWithVipps";
}
(0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "putPreferredStoredPaymentMethod",
    func: $e18f565b44c7bc7d$export$d1167dfb180ea832
});
async function $e18f565b44c7bc7d$export$d1167dfb180ea832(body, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $e18f565b44c7bc7d$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $e18f565b44c7bc7d$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $e18f565b44c7bc7d$export$ebe90cb607ad99e.baseUrl) + `/api/me/preferred-stored-payment-method`, {
            method: "put",
            headers: headers,
            body: JSON.stringify(body)
        });
        if (_res.status >= 200 && _res.status <= 299) return;
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
function $e18f565b44c7bc7d$export$19f075e049d800cd(e) {
    return e && typeof e === "object" && "type" in e && e.type === "UnauthorizedWithVipps";
}
(0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "getRenewalOptions",
    func: $e18f565b44c7bc7d$export$1fda0dbbcc42bfdc
});
async function $e18f565b44c7bc7d$export$1fda0dbbcc42bfdc(id, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $e18f565b44c7bc7d$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $e18f565b44c7bc7d$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $e18f565b44c7bc7d$export$ebe90cb607ad99e.baseUrl) + `/api/phone-orders/${id}/renewal-options`, {
            method: "get",
            headers: headers
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
function $e18f565b44c7bc7d$export$7a27aaf538106e3e(e) {
    return e && typeof e === "object" && "type" in e && (e.type === "BadRequest" || e.type === "Forbidden" || e.type === "UnauthorizedWithVipps");
}
const $e18f565b44c7bc7d$export$cd3361f95bba4719 = (0, $8jB4x.SSRHook)("getRenewalOptions", "GetRenewalOptionsDto", undefined, $e18f565b44c7bc7d$export$1fda0dbbcc42bfdc, [
    "id"
], undefined);
/** Renews a phone order with the given number of months.

The months must be one of the renewal options available for the phone model,
returned by `getRenewalOptions`. */ (0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "postRenewal",
    func: $e18f565b44c7bc7d$export$e88ba7c9a7cf1f6
});
async function $e18f565b44c7bc7d$export$e88ba7c9a7cf1f6(id, months, tnc, tncInsurance, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const queryArgs = [];
        if (months !== undefined) queryArgs.push("months=" + encodeURIComponent(months.valueOf()));
        if (tnc !== undefined) queryArgs.push("tnc=" + encodeURIComponent(tnc.valueOf()));
        if (tncInsurance !== undefined) queryArgs.push("tncInsurance=" + encodeURIComponent(tncInsurance.valueOf()));
        const headers = Object.assign(Object.assign({}, $e18f565b44c7bc7d$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $e18f565b44c7bc7d$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $e18f565b44c7bc7d$export$ebe90cb607ad99e.baseUrl) + `/api/phone-orders/${id}/renewal${queryArgs.length ? "?" + queryArgs.join("&") : ""}`, {
            method: "post",
            headers: headers
        });
        if (_res.status >= 200 && _res.status <= 299) return;
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
function $e18f565b44c7bc7d$export$ff1ce19ba9dc49ae(e) {
    return e && typeof e === "object" && "type" in e && (e.type === "BadRequest" || e.type === "Forbidden" || e.type === "UnauthorizedWithVipps");
}
(0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "getFrequentlyAskedQuestions",
    func: $e18f565b44c7bc7d$export$c2e4b7ca62d48533
});
async function $e18f565b44c7bc7d$export$c2e4b7ca62d48533(customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $e18f565b44c7bc7d$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $e18f565b44c7bc7d$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $e18f565b44c7bc7d$export$ebe90cb607ad99e.baseUrl) + `/api/frequently/asked/questions`, {
            method: "get",
            headers: headers
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
const $e18f565b44c7bc7d$export$6eb271ef04c4063b = (0, $8jB4x.SSRHook)("getFrequentlyAskedQuestions", "FrequentlyAskedQuestions", undefined, $e18f565b44c7bc7d$export$c2e4b7ca62d48533, [], undefined);
(0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "getNewsletterUnsubscribePage",
    func: $e18f565b44c7bc7d$export$60549a259bcd51fc
});
async function $e18f565b44c7bc7d$export$60549a259bcd51fc(customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $e18f565b44c7bc7d$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $e18f565b44c7bc7d$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $e18f565b44c7bc7d$export$ebe90cb607ad99e.baseUrl) + `/api/newsletter/unsubscribe-page`, {
            method: "get",
            headers: headers
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
const $e18f565b44c7bc7d$export$61180300cc91551d = (0, $8jB4x.SSRHook)("getNewsletterUnsubscribePage", "NewsletterUnsubscribePage", undefined, $e18f565b44c7bc7d$export$60549a259bcd51fc, [], undefined);
(0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "postNewsletterUnsubscribe",
    func: $e18f565b44c7bc7d$export$bc4051c7d3b69526
});
async function $e18f565b44c7bc7d$export$bc4051c7d3b69526(body, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $e18f565b44c7bc7d$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $e18f565b44c7bc7d$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $e18f565b44c7bc7d$export$ebe90cb607ad99e.baseUrl) + `/api/newsletter/unsubscribe`, {
            method: "post",
            headers: headers,
            body: JSON.stringify(body)
        });
        if (_res.status >= 200 && _res.status <= 299) return;
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
(0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "getReviews",
    func: $e18f565b44c7bc7d$export$cf31305e89293b23
});
async function $e18f565b44c7bc7d$export$cf31305e89293b23(customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $e18f565b44c7bc7d$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $e18f565b44c7bc7d$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $e18f565b44c7bc7d$export$ebe90cb607ad99e.baseUrl) + `/api/reviews`, {
            method: "get",
            headers: headers
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
const $e18f565b44c7bc7d$export$dfd0f591c1636cc4 = (0, $8jB4x.SSRHook)("getReviews", "Reviews", undefined, $e18f565b44c7bc7d$export$cf31305e89293b23, [], undefined);
(0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "getMoreReasonsToRedoit",
    func: $e18f565b44c7bc7d$export$16c7d461b2b40264
});
async function $e18f565b44c7bc7d$export$16c7d461b2b40264(customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $e18f565b44c7bc7d$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $e18f565b44c7bc7d$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $e18f565b44c7bc7d$export$ebe90cb607ad99e.baseUrl) + `/api/more/reasons/to/redoit`, {
            method: "get",
            headers: headers
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
const $e18f565b44c7bc7d$export$3b68074ea3526841 = (0, $8jB4x.SSRHook)("getMoreReasonsToRedoit", "MoreReasonsToRedoit", undefined, $e18f565b44c7bc7d$export$16c7d461b2b40264, [], undefined);
(0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "getNotificationsClosed",
    func: $e18f565b44c7bc7d$export$afb894a8ae834f5b
});
async function $e18f565b44c7bc7d$export$afb894a8ae834f5b(customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $e18f565b44c7bc7d$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $e18f565b44c7bc7d$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $e18f565b44c7bc7d$export$ebe90cb607ad99e.baseUrl) + `/api/notifications/closed`, {
            method: "get",
            headers: headers
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
const $e18f565b44c7bc7d$export$b1798547582b81c2 = (0, $8jB4x.SSRHook)("getNotificationsClosed", undefined, undefined, $e18f565b44c7bc7d$export$afb894a8ae834f5b, [], undefined);
(0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "postNotificationsClosed",
    func: $e18f565b44c7bc7d$export$87c93287defb9514
});
async function $e18f565b44c7bc7d$export$87c93287defb9514(body, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $e18f565b44c7bc7d$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $e18f565b44c7bc7d$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $e18f565b44c7bc7d$export$ebe90cb607ad99e.baseUrl) + `/api/notifications/closed`, {
            method: "post",
            headers: headers,
            body: JSON.stringify(body)
        });
        if (_res.status >= 200 && _res.status <= 299) return;
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
(0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "getHeader",
    func: $e18f565b44c7bc7d$export$47ed31abc613cf55
});
async function $e18f565b44c7bc7d$export$47ed31abc613cf55(pageId, sectionId, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const queryArgs = [];
        if (pageId !== undefined) queryArgs.push("pageId=" + encodeURIComponent(pageId.valueOf()));
        if (sectionId !== undefined) queryArgs.push("sectionId=" + encodeURIComponent(sectionId.valueOf()));
        const headers = Object.assign(Object.assign({}, $e18f565b44c7bc7d$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $e18f565b44c7bc7d$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $e18f565b44c7bc7d$export$ebe90cb607ad99e.baseUrl) + `/api/header${queryArgs.length ? "?" + queryArgs.join("&") : ""}`, {
            method: "get",
            headers: headers
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
const $e18f565b44c7bc7d$export$ae602290ebd82f8e = (0, $8jB4x.SSRHook)("getHeader", "GetHeaderDto", undefined, $e18f565b44c7bc7d$export$47ed31abc613cf55, [
    "pageId",
    "sectionId"
], undefined);
(0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "getFooter",
    func: $e18f565b44c7bc7d$export$d65aa1cbf7afefff
});
async function $e18f565b44c7bc7d$export$d65aa1cbf7afefff(customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $e18f565b44c7bc7d$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $e18f565b44c7bc7d$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $e18f565b44c7bc7d$export$ebe90cb607ad99e.baseUrl) + `/api/footer`, {
            method: "get",
            headers: headers
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
const $e18f565b44c7bc7d$export$d07da6ac6fc160b0 = (0, $8jB4x.SSRHook)("getFooter", "GetFooterDto", undefined, $e18f565b44c7bc7d$export$d65aa1cbf7afefff, [], undefined);
(0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "getCancellationTerms",
    func: $e18f565b44c7bc7d$export$2818e468f9045037
});
async function $e18f565b44c7bc7d$export$2818e468f9045037(id, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $e18f565b44c7bc7d$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $e18f565b44c7bc7d$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $e18f565b44c7bc7d$export$ebe90cb607ad99e.baseUrl) + `/api/phone-orders/${id}/cancellation-terms`, {
            method: "get",
            headers: headers
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
function $e18f565b44c7bc7d$export$faccc0828c028929(e) {
    return e && typeof e === "object" && "type" in e && e.type === "BadRequest";
}
const $e18f565b44c7bc7d$export$7a4a3d03ee7c067f = (0, $8jB4x.SSRHook)("getCancellationTerms", "GetCancellationTermsDto", undefined, $e18f565b44c7bc7d$export$2818e468f9045037, [
    "id"
], undefined);
(0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "cancelSubscription",
    func: $e18f565b44c7bc7d$export$8061bbc383a29848
});
async function $e18f565b44c7bc7d$export$8061bbc383a29848(id, body, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $e18f565b44c7bc7d$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $e18f565b44c7bc7d$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $e18f565b44c7bc7d$export$ebe90cb607ad99e.baseUrl) + `/api/phone-orders/${id}`, {
            method: "delete",
            headers: headers,
            body: JSON.stringify(body)
        });
        if (_res.status >= 200 && _res.status <= 299) return;
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
function $e18f565b44c7bc7d$export$d25d32ed4f0ae875(e) {
    return e && typeof e === "object" && "type" in e && (e.type === "Forbidden" || e.type === "BadRequest" || e.type === "UnauthorizedWithVipps");
}
/** Previews the terms and conditions for a phone order. */ (0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "getGeneralPhoneOrderTermsAndConditions",
    func: $e18f565b44c7bc7d$export$60ebb89cc4bc9755
});
async function $e18f565b44c7bc7d$export$60ebb89cc4bc9755(customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $e18f565b44c7bc7d$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $e18f565b44c7bc7d$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $e18f565b44c7bc7d$export$ebe90cb607ad99e.baseUrl) + `/api/terms-and-conditions/phone-order`, {
            method: "get",
            headers: headers
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
const $e18f565b44c7bc7d$export$23e8c26267d65867 = (0, $8jB4x.SSRHook)("getGeneralPhoneOrderTermsAndConditions", "GetGeneralPhoneOrderTermsAndConditionsDto", undefined, $e18f565b44c7bc7d$export$60ebb89cc4bc9755, [], undefined);
(0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "getTermsAndConditions",
    func: $e18f565b44c7bc7d$export$e9c540bc402f485f
});
async function $e18f565b44c7bc7d$export$e9c540bc402f485f(id, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $e18f565b44c7bc7d$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $e18f565b44c7bc7d$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $e18f565b44c7bc7d$export$ebe90cb607ad99e.baseUrl) + `/api/terms-and-conditions/${id}`, {
            method: "get",
            headers: headers
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.json();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
const $e18f565b44c7bc7d$export$8a333b178941277 = (0, $8jB4x.SSRHook)("getTermsAndConditions", "Localized", undefined, $e18f565b44c7bc7d$export$e9c540bc402f485f, [
    "id"
], undefined);
(0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "getWellKnownAppleDeveloperMerchantidDomainAssociation",
    func: $e18f565b44c7bc7d$export$3dfbf19357781ac
});
async function $e18f565b44c7bc7d$export$3dfbf19357781ac(customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $e18f565b44c7bc7d$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $e18f565b44c7bc7d$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $e18f565b44c7bc7d$export$ebe90cb607ad99e.baseUrl) + `/api/well/known/apple/developer/merchantid/domain/association`, {
            method: "get",
            headers: headers
        });
        if (_res.status >= 200 && _res.status <= 299) return await _res.text();
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
function $e18f565b44c7bc7d$export$3eca391ca641a01(e) {
    return e && typeof e === "object" && "type" in e && e.type === "NotFound";
}
const $e18f565b44c7bc7d$export$b0856adccc7071a9 = (0, $8jB4x.SSRHook)("getWellKnownAppleDeveloperMerchantidDomainAssociation", undefined, undefined, $e18f565b44c7bc7d$export$3dfbf19357781ac, [], undefined);
(0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "postWaitingListModalOpen",
    func: $e18f565b44c7bc7d$export$a5a1f41fba9e8ed4
});
async function $e18f565b44c7bc7d$export$a5a1f41fba9e8ed4(source, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const queryArgs = [];
        if (source !== undefined) queryArgs.push("source=" + encodeURIComponent(source.valueOf()));
        const headers = Object.assign(Object.assign({}, $e18f565b44c7bc7d$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $e18f565b44c7bc7d$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $e18f565b44c7bc7d$export$ebe90cb607ad99e.baseUrl) + `/api/waiting-list/modal-open${queryArgs.length ? "?" + queryArgs.join("&") : ""}`, {
            method: "post",
            headers: headers
        });
        if (_res.status >= 200 && _res.status <= 299) return;
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
(0, $8jB4x.SSRHook).clientEndpoints.push({
    name: "postWaitingListSignup",
    func: $e18f565b44c7bc7d$export$2884e3ad03eef48
});
async function $e18f565b44c7bc7d$export$2884e3ad03eef48(body, customHeaders, callOptions) {
    var _a;
    const { maxRetries: maxRetries = 1 } = callOptions || {};
    for(let i = 0; i <= maxRetries; i++){
        const headers = Object.assign(Object.assign({}, $e18f565b44c7bc7d$export$ebe90cb607ad99e.headers), customHeaders);
        const _res = await $e18f565b44c7bc7d$export$ebe90cb607ad99e.fetch(((_a = callOptions === null || callOptions === void 0 ? void 0 : callOptions.baseUrl) !== null && _a !== void 0 ? _a : $e18f565b44c7bc7d$export$ebe90cb607ad99e.baseUrl) + `/api/waiting-list/signup`, {
            method: "post",
            headers: headers,
            body: JSON.stringify(body)
        });
        if (_res.status >= 200 && _res.status <= 299) return;
        else {
            const { retry: retry } = await (0, $8jB4x.SSRHook).handleError(_res);
            if (retry) continue;
            else break;
        }
    }
    throw new Error("Unhandled failed request");
}
function $e18f565b44c7bc7d$export$efd52de24b0e5de0(e) {
    return e && typeof e === "object" && "type" in e && (e.type === "BadRequest" || e.type === "Unauthorized" || e.type === "JWTPropertyMissing");
}



var $dUDPg = parcelRequire("dUDPg");

var $4vwom = parcelRequire("4vwom");
parcelRequire("eeH7J");
var $edca1cc69f99f492$exports = {};

$parcel$export($edca1cc69f99f492$exports, "createRoot", function () { return $edca1cc69f99f492$export$882461b6382ed46c; }, function (v) { return $edca1cc69f99f492$export$882461b6382ed46c = v; });
$parcel$export($edca1cc69f99f492$exports, "hydrateRoot", function () { return $edca1cc69f99f492$export$757ceba2d55c277e; }, function (v) { return $edca1cc69f99f492$export$757ceba2d55c277e = v; });
var $edca1cc69f99f492$export$882461b6382ed46c;
var $edca1cc69f99f492$export$757ceba2d55c277e;
"use strict";

var $iMJCh = parcelRequire("iMJCh");
var $edca1cc69f99f492$var$i;
$edca1cc69f99f492$export$882461b6382ed46c = $iMJCh.createRoot;
$edca1cc69f99f492$export$757ceba2d55c277e = $iMJCh.hydrateRoot;



var $gc3M0 = parcelRequire("gc3M0");

var $8ZuUP = parcelRequire("8ZuUP");
const $19ea5142dc1f8ebf$var$cache = (0, $gc3M0.default)({
    key: "emotion-cache"
});
function $19ea5142dc1f8ebf$export$e547c4fd78449aad(RootComponent, /** ID of the DOM root element */ rootId = "root") {
    const rootEl = document.getElementById(rootId);
    if (rootEl) (0, (/*@__PURE__*/$parcel$interopDefault($edca1cc69f99f492$exports))).hydrateRoot(rootEl, (0, $4vwom.jsx)((0, $8ZuUP.C), {
        value: $19ea5142dc1f8ebf$var$cache,
        children: (0, $4vwom.jsx)(RootComponent, {})
    }));
}



var $4vwom = parcelRequire("4vwom");

var $18Pjr = parcelRequire("18Pjr");
var $5K1mb = parcelRequire("5K1mb");

var $lhaLc = parcelRequire("lhaLc");

var $4vwom = parcelRequire("4vwom");

var $9G56J = parcelRequire("9G56J");

var $aIeEI = parcelRequire("aIeEI");
parcelRequire("2LTO8");
var $fR074 = parcelRequire("fR074");

var $4vwom = parcelRequire("4vwom");

var $eeH7J = parcelRequire("eeH7J");

var $dRzna = parcelRequire("dRzna");

var $eeH7J = parcelRequire("eeH7J");

var $eeH7J = parcelRequire("eeH7J");
"use client";
const $7e832de67499b416$export$a3579ca508007a95 = (0, $eeH7J.createContext)({});



var $eeH7J = parcelRequire("eeH7J");
/**
 * Note: Still used by components generated by old versions of Framer
 *
 * @deprecated
 */ const $d668ee93a17394d4$export$f3b8df5418bf8d44 = (0, $eeH7J.createContext)(null);



var $eeH7J = parcelRequire("eeH7J");

var $eeH7J = parcelRequire("eeH7J");

var $eeH7J = parcelRequire("eeH7J");
const $8cf061ae720cd83e$export$4e09c449d6c407f7 = typeof window !== "undefined";


const $17cc282998a57b95$export$700979bc83e7db82 = (0, $8cf061ae720cd83e$export$4e09c449d6c407f7) ? (0, $eeH7J.useLayoutEffect) : (0, $eeH7J.useEffect);


function $aa149596850bdc81$export$80c2a3957bcb42ea() {
    const isMounted = (0, $eeH7J.useRef)(false);
    (0, $17cc282998a57b95$export$700979bc83e7db82)(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
        };
    }, []);
    return isMounted;
}


const $c90734627ed96e3f$export$8793edee2d425525 = (any)=>any;


const $d3f03766da854ace$export$dd826089e3c5e502 = {
    skipAnimations: false,
    useManualTiming: false
};


function $9e4d57345f27c35c$export$b995e5e85f5c8289(runNextFrame) {
    /**
     * We create and reuse two queues, one to queue jobs for the current frame
     * and one for the next. We reuse to avoid triggering GC after x frames.
     */ let thisFrame = new Set();
    let nextFrame = new Set();
    /**
     * Track whether we're currently processing jobs in this step. This way
     * we can decide whether to schedule new jobs for this frame or next.
     */ let isProcessing = false;
    let flushNextFrame = false;
    /**
     * A set of processes which were marked keepAlive when scheduled.
     */ const toKeepAlive = new WeakSet();
    let latestFrameData = {
        delta: 0.0,
        timestamp: 0.0,
        isProcessing: false
    };
    function triggerCallback(callback) {
        if (toKeepAlive.has(callback)) {
            step.schedule(callback);
            runNextFrame();
        }
        callback(latestFrameData);
    }
    const step = {
        /**
         * Schedule a process to run on the next frame.
         */ schedule: (callback, keepAlive = false, immediate = false)=>{
            const addToCurrentFrame = immediate && isProcessing;
            const queue = addToCurrentFrame ? thisFrame : nextFrame;
            if (keepAlive) toKeepAlive.add(callback);
            if (!queue.has(callback)) queue.add(callback);
            return callback;
        },
        /**
         * Cancel the provided callback from running on the next frame.
         */ cancel: (callback)=>{
            nextFrame.delete(callback);
            toKeepAlive.delete(callback);
        },
        /**
         * Execute all schedule callbacks.
         */ process: (frameData)=>{
            latestFrameData = frameData;
            /**
             * If we're already processing we've probably been triggered by a flushSync
             * inside an existing process. Instead of executing, mark flushNextFrame
             * as true and ensure we flush the following frame at the end of this one.
             */ if (isProcessing) {
                flushNextFrame = true;
                return;
            }
            isProcessing = true;
            [thisFrame, nextFrame] = [
                nextFrame,
                thisFrame
            ];
            // Clear the next frame queue
            nextFrame.clear();
            // Execute this frame
            thisFrame.forEach(triggerCallback);
            isProcessing = false;
            if (flushNextFrame) {
                flushNextFrame = false;
                step.process(frameData);
            }
        }
    };
    return step;
}


const $3e80ba1fbbf06577$export$71ecace0a033b35a = [
    "read",
    "resolveKeyframes",
    "update",
    "preRender",
    "render",
    "postRender"
];
const $3e80ba1fbbf06577$var$maxElapsed = 40;
function $3e80ba1fbbf06577$export$510b0596a933801a(scheduleNextBatch, allowKeepAlive) {
    let runNextFrame = false;
    let useDefaultElapsed = true;
    const state = {
        delta: 0.0,
        timestamp: 0.0,
        isProcessing: false
    };
    const flagRunNextFrame = ()=>runNextFrame = true;
    const steps = $3e80ba1fbbf06577$export$71ecace0a033b35a.reduce((acc, key)=>{
        acc[key] = (0, $9e4d57345f27c35c$export$b995e5e85f5c8289)(flagRunNextFrame);
        return acc;
    }, {});
    const { read: read, resolveKeyframes: resolveKeyframes, update: update, preRender: preRender, render: render, postRender: postRender } = steps;
    const processBatch = ()=>{
        const timestamp = (0, $d3f03766da854ace$export$dd826089e3c5e502).useManualTiming ? state.timestamp : performance.now();
        runNextFrame = false;
        state.delta = useDefaultElapsed ? 1000 / 60 : Math.max(Math.min(timestamp - state.timestamp, $3e80ba1fbbf06577$var$maxElapsed), 1);
        state.timestamp = timestamp;
        state.isProcessing = true;
        // Unrolled render loop for better per-frame performance
        read.process(state);
        resolveKeyframes.process(state);
        update.process(state);
        preRender.process(state);
        render.process(state);
        postRender.process(state);
        state.isProcessing = false;
        if (runNextFrame && allowKeepAlive) {
            useDefaultElapsed = false;
            scheduleNextBatch(processBatch);
        }
    };
    const wake = ()=>{
        runNextFrame = true;
        useDefaultElapsed = true;
        if (!state.isProcessing) scheduleNextBatch(processBatch);
    };
    const schedule = $3e80ba1fbbf06577$export$71ecace0a033b35a.reduce((acc, key)=>{
        const step = steps[key];
        acc[key] = (process, keepAlive = false, immediate = false)=>{
            if (!runNextFrame) wake();
            return step.schedule(process, keepAlive, immediate);
        };
        return acc;
    }, {});
    const cancel = (process)=>{
        for(let i = 0; i < $3e80ba1fbbf06577$export$71ecace0a033b35a.length; i++)steps[$3e80ba1fbbf06577$export$71ecace0a033b35a[i]].cancel(process);
    };
    return {
        schedule: schedule,
        cancel: cancel,
        state: state,
        steps: steps
    };
}


const { schedule: $2668c8a722676613$export$2cef06c20297c17d, cancel: $2668c8a722676613$export$ec99c0ef4978dccb, state: $2668c8a722676613$export$fff89137e9e818ce, steps: $2668c8a722676613$export$be3f796aed065412 } = (0, $3e80ba1fbbf06577$export$510b0596a933801a)(typeof requestAnimationFrame !== "undefined" ? requestAnimationFrame : (0, $c90734627ed96e3f$export$8793edee2d425525), true);


function $d4efb7ad8dfd4b3f$export$91db9bc4f8ac944a() {
    const isMounted = (0, $aa149596850bdc81$export$80c2a3957bcb42ea)();
    const [forcedRenderCount, setForcedRenderCount] = (0, $eeH7J.useState)(0);
    const forceRender = (0, $eeH7J.useCallback)(()=>{
        isMounted.current && setForcedRenderCount(forcedRenderCount + 1);
    }, [
        forcedRenderCount
    ]);
    /**
     * Defer this to the end of the next animation frame in case there are multiple
     * synchronous calls.
     */ const deferredForceRender = (0, $eeH7J.useCallback)(()=>(0, $2668c8a722676613$export$2cef06c20297c17d).postRender(forceRender), [
        forceRender
    ]);
    return [
        deferredForceRender,
        forcedRenderCount
    ];
}


const $09145c077538a501$var$notify = (node)=>!node.isLayoutDirty && node.willUpdate(false);
function $09145c077538a501$export$df39f9da6f278ce7() {
    const nodes = new Set();
    const subscriptions = new WeakMap();
    const dirtyAll = ()=>nodes.forEach($09145c077538a501$var$notify);
    return {
        add: (node)=>{
            nodes.add(node);
            subscriptions.set(node, node.addEventListener("willUpdate", dirtyAll));
        },
        remove: (node)=>{
            nodes.delete(node);
            const unsubscribe = subscriptions.get(node);
            if (unsubscribe) {
                unsubscribe();
                subscriptions.delete(node);
            }
            dirtyAll();
        },
        dirty: dirtyAll
    };
}


"use client";
const $5358b7a8389876c7$var$shouldInheritGroup = (inherit)=>inherit === true;
const $5358b7a8389876c7$var$shouldInheritId = (inherit)=>$5358b7a8389876c7$var$shouldInheritGroup(inherit === true) || inherit === "id";
const $5358b7a8389876c7$export$7fe0cbe305f29bb4 = ({ children: children, id: id, inherit: inherit = true })=>{
    const layoutGroupContext = (0, $eeH7J.useContext)((0, $7e832de67499b416$export$a3579ca508007a95));
    const deprecatedLayoutGroupContext = (0, $eeH7J.useContext)((0, $d668ee93a17394d4$export$f3b8df5418bf8d44));
    const [forceRender, key] = (0, $d4efb7ad8dfd4b3f$export$91db9bc4f8ac944a)();
    const context = (0, $eeH7J.useRef)(null);
    const upstreamId = layoutGroupContext.id || deprecatedLayoutGroupContext;
    if (context.current === null) {
        if ($5358b7a8389876c7$var$shouldInheritId(inherit) && upstreamId) id = id ? upstreamId + "-" + id : upstreamId;
        context.current = {
            id: id,
            group: $5358b7a8389876c7$var$shouldInheritGroup(inherit) ? layoutGroupContext.group || (0, $09145c077538a501$export$df39f9da6f278ce7)() : (0, $09145c077538a501$export$df39f9da6f278ce7)()
        };
    }
    const memoizedContext = (0, $eeH7J.useMemo)(()=>({
            ...context.current,
            forceRender: forceRender
        }), [
        key
    ]);
    return (0, $dRzna.jsx)((0, $7e832de67499b416$export$a3579ca508007a95).Provider, {
        value: memoizedContext,
        children: children
    });
};


function $56c547a84798143f$export$3af29c0efb268f04(componentFactory) {
    if (typeof Proxy === "undefined") return componentFactory;
    /**
     * A cache of generated `motion` components, e.g `motion.div`, `motion.input` etc.
     * Rather than generating them anew every render.
     */ const componentCache = new Map();
    const deprecatedFactoryFunction = (...args)=>{
        return componentFactory(...args);
    };
    return new Proxy(deprecatedFactoryFunction, {
        /**
         * Called when `motion` is referenced with a prop: `motion.div`, `motion.input` etc.
         * The prop name is passed through as `key` and we can use that to generate a `motion`
         * DOM component with that name.
         */ get: (_target, key)=>{
            if (key === "create") return componentFactory;
            /**
             * If this element doesn't exist in the component cache, create it and cache.
             */ if (!componentCache.has(key)) componentCache.set(key, componentFactory(key));
            return componentCache.get(key);
        }
    });
}


function $f29cdb74f4d8f17d$export$aa71198ceeaf53ce(v) {
    return v !== null && typeof v === "object" && typeof v.start === "function";
}



const $854bd2f427254747$export$9153ad4c4999f4a0 = (v)=>{
    return Array.isArray(v);
};


function $618fd2d39a7e62c4$export$90e866afbd6b9f1a(next, prev) {
    if (!Array.isArray(prev)) return false;
    const prevLength = prev.length;
    if (prevLength !== next.length) return false;
    for(let i = 0; i < prevLength; i++){
        if (prev[i] !== next[i]) return false;
    }
    return true;
}


/**
 * Decides if the supplied variable is variant label
 */ function $bfdcb20e850e14f7$export$720b90e312cea233(v) {
    return typeof v === "string" || Array.isArray(v);
}


function $195eed3b69cf8a61$var$getValueState(visualElement) {
    const state = [
        {},
        {}
    ];
    visualElement === null || visualElement === void 0 || visualElement.values.forEach((value, key)=>{
        state[0][key] = value.get();
        state[1][key] = value.getVelocity();
    });
    return state;
}
function $195eed3b69cf8a61$export$d68f140c4d9b48bc(props, definition, custom, visualElement) {
    /**
     * If the variant definition is a function, resolve.
     */ if (typeof definition === "function") {
        const [current, velocity] = $195eed3b69cf8a61$var$getValueState(visualElement);
        definition = definition(custom !== undefined ? custom : props.custom, current, velocity);
    }
    /**
     * If the variant definition is a variant label, or
     * the function returned a variant label, resolve.
     */ if (typeof definition === "string") definition = props.variants && props.variants[definition];
    /**
     * At this point we've resolved both functions and variant labels,
     * but the resolved variant label might itself have been a function.
     * If so, resolve. This can only have returned a valid target object.
     */ if (typeof definition === "function") {
        const [current, velocity] = $195eed3b69cf8a61$var$getValueState(visualElement);
        definition = definition(custom !== undefined ? custom : props.custom, current, velocity);
    }
    return definition;
}


function $e92cd1cec7066d98$export$7b1b1c981f4f0558(visualElement, definition, custom) {
    const props = visualElement.getProps();
    return (0, $195eed3b69cf8a61$export$d68f140c4d9b48bc)(props, definition, custom !== undefined ? custom : props.custom, visualElement);
}


const $7526b0a811789693$export$16e45afcc206d3a8 = [
    "animate",
    "whileInView",
    "whileFocus",
    "whileHover",
    "whileTap",
    "whileDrag",
    "exit"
];
const $7526b0a811789693$export$1405a65085f40b9 = [
    "initial",
    ...$7526b0a811789693$export$16e45afcc206d3a8
];



/**
 * Generate a list of every possible transform key.
 */ const $ea8236087cf451dc$export$280dc01950909d86 = [
    "transformPerspective",
    "x",
    "y",
    "z",
    "translateX",
    "translateY",
    "translateZ",
    "scale",
    "scaleX",
    "scaleY",
    "rotate",
    "rotateX",
    "rotateY",
    "rotateZ",
    "skew",
    "skewX",
    "skewY"
];
/**
 * A quick lookup for transform props.
 */ const $ea8236087cf451dc$export$7b42a0094fb00b6e = new Set($ea8236087cf451dc$export$280dc01950909d86);


/**
 * Converts seconds to milliseconds
 *
 * @param seconds - Time in seconds.
 * @return milliseconds - Converted time in milliseconds.
 */ const $64e5667fa478a387$export$fc3e7e8557f8c8c7 = (seconds)=>seconds * 1000;
const $64e5667fa478a387$export$f64c3bfbc58eec0f = (milliseconds)=>milliseconds / 1000;



const $a714041f9b68b288$var$underDampedSpring = {
    type: "spring",
    stiffness: 500,
    damping: 25,
    restSpeed: 10
};
const $a714041f9b68b288$var$criticallyDampedSpring = (target)=>({
        type: "spring",
        stiffness: 550,
        damping: target === 0 ? 2 * Math.sqrt(550) : 30,
        restSpeed: 10
    });
const $a714041f9b68b288$var$keyframesTransition = {
    type: "keyframes",
    duration: 0.8
};
/**
 * Default easing curve is a slightly shallower version of
 * the default browser easing curve.
 */ const $a714041f9b68b288$var$ease = {
    type: "keyframes",
    ease: [
        0.25,
        0.1,
        0.35,
        1
    ],
    duration: 0.3
};
const $a714041f9b68b288$export$262124b154b9f1c0 = (valueKey, { keyframes: keyframes })=>{
    if (keyframes.length > 2) return $a714041f9b68b288$var$keyframesTransition;
    else if ((0, $ea8236087cf451dc$export$7b42a0094fb00b6e).has(valueKey)) return valueKey.startsWith("scale") ? $a714041f9b68b288$var$criticallyDampedSpring(keyframes[1]) : $a714041f9b68b288$var$underDampedSpring;
    return $a714041f9b68b288$var$ease;
};


/**
 * Decide whether a transition is defined on a given Transition.
 * This filters out orchestration options and returns true
 * if any options are left.
 */ function $453e5e72c39cf7c2$export$ca8e47dc8ed5a9d7({ when: when, delay: _delay, delayChildren: delayChildren, staggerChildren: staggerChildren, staggerDirection: staggerDirection, repeat: repeat, repeatType: repeatType, repeatDelay: repeatDelay, from: from, elapsed: elapsed, ...transition }) {
    return !!Object.keys(transition).length;
}
function $453e5e72c39cf7c2$export$7c1391340308742e(transition, key) {
    return transition[key] || transition["default"] || transition;
}



const $4f333d9188f46157$export$888a3d84909f9e3d = {
    current: false
};


const $3ca01ac9e8cf1f66$var$isNotNull = (value)=>value !== null;
function $3ca01ac9e8cf1f66$export$14de59408fad90b(keyframes, { repeat: repeat, repeatType: repeatType = "loop" }, finalKeyframe) {
    const resolvedKeyframes = keyframes.filter($3ca01ac9e8cf1f66$var$isNotNull);
    const index = repeat && repeatType !== "loop" && repeat % 2 === 1 ? 0 : resolvedKeyframes.length - 1;
    return !index || finalKeyframe === undefined ? resolvedKeyframes[index] : finalKeyframe;
}



/**
 * Check if the value is a zero value string like "0px" or "0%"
 */ const $ad0677d01318a032$export$ade84c85e44a6cb1 = (v)=>/^0[^.\s]+$/u.test(v);


function $17feb55ffe87f155$export$e56af863d5645d5f(value) {
    if (typeof value === "number") return value === 0;
    else if (value !== null) return value === "none" || value === "0" || (0, $ad0677d01318a032$export$ade84c85e44a6cb1)(value);
    else return true;
}



let $2b9100c03bd61cb5$export$491112666e282270 = (0, $c90734627ed96e3f$export$8793edee2d425525);
let $2b9100c03bd61cb5$export$f5708dca728d7177 = (0, $c90734627ed96e3f$export$8793edee2d425525);
var $2b9100c03bd61cb5$var$check, $2b9100c03bd61cb5$var$message, $2b9100c03bd61cb5$var$check1, $2b9100c03bd61cb5$var$message1;


/**
 * Check if value is a numerical string, ie a string that is purely a number eg "100" or "-100.1"
 */ const $a9d0c51dad3a3292$export$65583ed5a868f2d9 = (v)=>/^-?(?:\d+(?:\.\d+)?|\.\d+)$/u.test(v);


const $7b632f63647c186c$var$checkStringStartsWith = (token)=>(key)=>typeof key === "string" && key.startsWith(token);
const $7b632f63647c186c$export$9de1236619d9e756 = $7b632f63647c186c$var$checkStringStartsWith("--");
const $7b632f63647c186c$var$startsAsVariableToken = $7b632f63647c186c$var$checkStringStartsWith("var(--");
const $7b632f63647c186c$export$31f9caa2600b5723 = (value)=>{
    const startsWithToken = $7b632f63647c186c$var$startsAsVariableToken(value);
    if (!startsWithToken) return false;
    // Ensure any comments are stripped from the value as this can harm performance of the regex.
    return $7b632f63647c186c$var$singleCssVariableRegex.test(value.split("/*")[0].trim());
};
const $7b632f63647c186c$var$singleCssVariableRegex = /var\(--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)$/iu;


/**
 * Parse Framer's special CSS variable format into a CSS token and a fallback.
 *
 * ```
 * `var(--foo, #fff)` => [`--foo`, '#fff']
 * ```
 *
 * @param current
 */ const $a5eac11b2abb9c45$var$splitCSSVariableRegex = // eslint-disable-next-line redos-detector/no-unsafe-regex -- false positive, as it can match a lot of words
/^var\(--(?:([\w-]+)|([\w-]+), ?([a-zA-Z\d ()%#.,-]+))\)/u;
function $a5eac11b2abb9c45$export$b9f0c1f373aee2b0(current) {
    const match = $a5eac11b2abb9c45$var$splitCSSVariableRegex.exec(current);
    if (!match) return [
        , 
    ];
    const [, token1, token2, fallback] = match;
    return [
        `--${token1 !== null && token1 !== void 0 ? token1 : token2}`,
        fallback
    ];
}
const $a5eac11b2abb9c45$var$maxDepth = 4;
function $a5eac11b2abb9c45$export$289398774300c991(current, element, depth = 1) {
    (0, $2b9100c03bd61cb5$export$f5708dca728d7177)(depth <= $a5eac11b2abb9c45$var$maxDepth, `Max CSS variable fallback depth detected in property "${current}". This may indicate a circular fallback dependency.`);
    const [token, fallback] = $a5eac11b2abb9c45$export$b9f0c1f373aee2b0(current);
    // No CSS variable detected
    if (!token) return;
    // Attempt to read this CSS variable off the element
    const resolved = window.getComputedStyle(element).getPropertyValue(token);
    if (resolved) {
        const trimmed = resolved.trim();
        return (0, $a9d0c51dad3a3292$export$65583ed5a868f2d9)(trimmed) ? parseFloat(trimmed) : trimmed;
    }
    return (0, $7b632f63647c186c$export$31f9caa2600b5723)(fallback) ? $a5eac11b2abb9c45$export$289398774300c991(fallback, element, depth + 1) : fallback;
}




const $b64a5fb8aaa910d9$export$7d15b64cf5a3a4c4 = (min, max, v)=>{
    if (v > max) return max;
    if (v < min) return min;
    return v;
};


const $2a216475fc6839a7$export$98e628dec113755e = {
    test: (v)=>typeof v === "number",
    parse: parseFloat,
    transform: (v)=>v
};
const $2a216475fc6839a7$export$58f0f39f63f3cf42 = {
    ...$2a216475fc6839a7$export$98e628dec113755e,
    transform: (v)=>(0, $b64a5fb8aaa910d9$export$7d15b64cf5a3a4c4)(0, 1, v)
};
const $2a216475fc6839a7$export$dcdf75081b88279d = {
    ...$2a216475fc6839a7$export$98e628dec113755e,
    default: 1
};


/**
 * TODO: When we move from string as a source of truth to data models
 * everything in this folder should probably be referred to as models vs types
 */ // If this number is a decimal, make it just five decimal places
// to avoid exponents
const $08c2e9dc5cfbd69e$export$83d2e9e3e4ee39ed = (v)=>Math.round(v * 100000) / 100000;
const $08c2e9dc5cfbd69e$export$2444ca58c08448e4 = /-?(?:\d+(?:\.\d+)?|\.\d+)/gu;
const $08c2e9dc5cfbd69e$export$740b69c5fad25dba = /(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))/giu;
const $08c2e9dc5cfbd69e$export$ed808ff6ecd39e8d = /^(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))$/iu;
function $08c2e9dc5cfbd69e$export$844ec244b1367d54(v) {
    return typeof v === "string";
}
function $08c2e9dc5cfbd69e$export$b931b78cbb3caf86(v) {
    return v == null;
}


const $2e2cc09c72ffc0aa$var$createUnitType = (unit)=>({
        test: (v)=>(0, $08c2e9dc5cfbd69e$export$844ec244b1367d54)(v) && v.endsWith(unit) && v.split(" ").length === 1,
        parse: parseFloat,
        transform: (v)=>`${v}${unit}`
    });
const $2e2cc09c72ffc0aa$export$41fc368e1a942b97 = /*@__PURE__*/ $2e2cc09c72ffc0aa$var$createUnitType("deg");
const $2e2cc09c72ffc0aa$export$626336c2cd4b14de = /*@__PURE__*/ $2e2cc09c72ffc0aa$var$createUnitType("%");
const $2e2cc09c72ffc0aa$export$91c0eda1d06bf008 = /*@__PURE__*/ $2e2cc09c72ffc0aa$var$createUnitType("px");
const $2e2cc09c72ffc0aa$export$f91e8c45a95a32f2 = /*@__PURE__*/ $2e2cc09c72ffc0aa$var$createUnitType("vh");
const $2e2cc09c72ffc0aa$export$aed3d7b7d206c196 = /*@__PURE__*/ $2e2cc09c72ffc0aa$var$createUnitType("vw");
const $2e2cc09c72ffc0aa$export$44e2e1705876d7ed = {
    ...$2e2cc09c72ffc0aa$export$626336c2cd4b14de,
    parse: (v)=>$2e2cc09c72ffc0aa$export$626336c2cd4b14de.parse(v) / 100,
    transform: (v)=>$2e2cc09c72ffc0aa$export$626336c2cd4b14de.transform(v * 100)
};


const $dc5c7ac2258c6333$export$c66c0d5db2a205d = new Set([
    "width",
    "height",
    "top",
    "left",
    "right",
    "bottom",
    "x",
    "y",
    "translateX",
    "translateY"
]);
const $dc5c7ac2258c6333$export$8e5250d1aa9bf370 = (v)=>v === (0, $2a216475fc6839a7$export$98e628dec113755e) || v === (0, $2e2cc09c72ffc0aa$export$91c0eda1d06bf008);
const $dc5c7ac2258c6333$var$getPosFromMatrix = (matrix, pos)=>parseFloat(matrix.split(", ")[pos]);
const $dc5c7ac2258c6333$var$getTranslateFromMatrix = (pos2, pos3)=>(_bbox, { transform: transform })=>{
        if (transform === "none" || !transform) return 0;
        const matrix3d = transform.match(/^matrix3d\((.+)\)$/u);
        if (matrix3d) return $dc5c7ac2258c6333$var$getPosFromMatrix(matrix3d[1], pos3);
        else {
            const matrix = transform.match(/^matrix\((.+)\)$/u);
            if (matrix) return $dc5c7ac2258c6333$var$getPosFromMatrix(matrix[1], pos2);
            else return 0;
        }
    };
const $dc5c7ac2258c6333$var$transformKeys = new Set([
    "x",
    "y",
    "z"
]);
const $dc5c7ac2258c6333$var$nonTranslationalTransformKeys = (0, $ea8236087cf451dc$export$280dc01950909d86).filter((key)=>!$dc5c7ac2258c6333$var$transformKeys.has(key));
function $dc5c7ac2258c6333$export$39d4bc9655f3f632(visualElement) {
    const removedTransforms = [];
    $dc5c7ac2258c6333$var$nonTranslationalTransformKeys.forEach((key)=>{
        const value = visualElement.getValue(key);
        if (value !== undefined) {
            removedTransforms.push([
                key,
                value.get()
            ]);
            value.set(key.startsWith("scale") ? 1 : 0);
        }
    });
    return removedTransforms;
}
const $dc5c7ac2258c6333$export$781d46a8aa670d52 = {
    // Dimensions
    width: ({ x: x }, { paddingLeft: paddingLeft = "0", paddingRight: paddingRight = "0" })=>x.max - x.min - parseFloat(paddingLeft) - parseFloat(paddingRight),
    height: ({ y: y }, { paddingTop: paddingTop = "0", paddingBottom: paddingBottom = "0" })=>y.max - y.min - parseFloat(paddingTop) - parseFloat(paddingBottom),
    top: (_bbox, { top: top })=>parseFloat(top),
    left: (_bbox, { left: left })=>parseFloat(left),
    bottom: ({ y: y }, { top: top })=>parseFloat(top) + (y.max - y.min),
    right: ({ x: x }, { left: left })=>parseFloat(left) + (x.max - x.min),
    // Transform
    x: $dc5c7ac2258c6333$var$getTranslateFromMatrix(4, 13),
    y: $dc5c7ac2258c6333$var$getTranslateFromMatrix(5, 14)
};
// Alias translate longform names
$dc5c7ac2258c6333$export$781d46a8aa670d52.translateX = $dc5c7ac2258c6333$export$781d46a8aa670d52.x;
$dc5c7ac2258c6333$export$781d46a8aa670d52.translateY = $dc5c7ac2258c6333$export$781d46a8aa670d52.y;




/**
 * Tests a provided value against a ValueType
 */ const $7da4e5401aa12761$export$6eae4d0a6a7ca7cd = (v)=>(type)=>type.test(v);


/**
 * ValueType for "auto"
 */ const $5bbd82f4ea4afe8a$export$dfb5619354ba860 = {
    test: (v)=>v === "auto",
    parse: (v)=>v
};


/**
 * A list of value types commonly used for dimensions
 */ const $1c32a536829b8c8a$export$d176691c1998a1f5 = [
    (0, $2a216475fc6839a7$export$98e628dec113755e),
    (0, $2e2cc09c72ffc0aa$export$91c0eda1d06bf008),
    (0, $2e2cc09c72ffc0aa$export$626336c2cd4b14de),
    (0, $2e2cc09c72ffc0aa$export$41fc368e1a942b97),
    (0, $2e2cc09c72ffc0aa$export$aed3d7b7d206c196),
    (0, $2e2cc09c72ffc0aa$export$f91e8c45a95a32f2),
    (0, $5bbd82f4ea4afe8a$export$dfb5619354ba860)
];
/**
 * Tests a dimensional value against the list of dimension ValueTypes
 */ const $1c32a536829b8c8a$export$eefdd52e3ccae428 = (v)=>$1c32a536829b8c8a$export$d176691c1998a1f5.find((0, $7da4e5401aa12761$export$6eae4d0a6a7ca7cd)(v));




const $b1026f81549deb9c$var$toResolve = new Set();
let $b1026f81549deb9c$var$isScheduled = false;
let $b1026f81549deb9c$var$anyNeedsMeasurement = false;
function $b1026f81549deb9c$var$measureAllKeyframes() {
    if ($b1026f81549deb9c$var$anyNeedsMeasurement) {
        const resolversToMeasure = Array.from($b1026f81549deb9c$var$toResolve).filter((resolver)=>resolver.needsMeasurement);
        const elementsToMeasure = new Set(resolversToMeasure.map((resolver)=>resolver.element));
        const transformsToRestore = new Map();
        /**
         * Write pass
         * If we're measuring elements we want to remove bounding box-changing transforms.
         */ elementsToMeasure.forEach((element)=>{
            const removedTransforms = (0, $dc5c7ac2258c6333$export$39d4bc9655f3f632)(element);
            if (!removedTransforms.length) return;
            transformsToRestore.set(element, removedTransforms);
            element.render();
        });
        // Read
        resolversToMeasure.forEach((resolver)=>resolver.measureInitialState());
        // Write
        elementsToMeasure.forEach((element)=>{
            element.render();
            const restore = transformsToRestore.get(element);
            if (restore) restore.forEach(([key, value])=>{
                var _a;
                (_a = element.getValue(key)) === null || _a === void 0 || _a.set(value);
            });
        });
        // Read
        resolversToMeasure.forEach((resolver)=>resolver.measureEndState());
        // Write
        resolversToMeasure.forEach((resolver)=>{
            if (resolver.suspendedScrollY !== undefined) window.scrollTo(0, resolver.suspendedScrollY);
        });
    }
    $b1026f81549deb9c$var$anyNeedsMeasurement = false;
    $b1026f81549deb9c$var$isScheduled = false;
    $b1026f81549deb9c$var$toResolve.forEach((resolver)=>resolver.complete());
    $b1026f81549deb9c$var$toResolve.clear();
}
function $b1026f81549deb9c$var$readAllKeyframes() {
    $b1026f81549deb9c$var$toResolve.forEach((resolver)=>{
        resolver.readKeyframes();
        if (resolver.needsMeasurement) $b1026f81549deb9c$var$anyNeedsMeasurement = true;
    });
}
function $b1026f81549deb9c$export$78b96d2a12593b05() {
    $b1026f81549deb9c$var$readAllKeyframes();
    $b1026f81549deb9c$var$measureAllKeyframes();
}
class $b1026f81549deb9c$export$74d34ca3182f1750 {
    constructor(unresolvedKeyframes, onComplete, name, motionValue, element, isAsync = false){
        /**
         * Track whether this resolver has completed. Once complete, it never
         * needs to attempt keyframe resolution again.
         */ this.isComplete = false;
        /**
         * Track whether this resolver is async. If it is, it'll be added to the
         * resolver queue and flushed in the next frame. Resolvers that aren't going
         * to trigger read/write thrashing don't need to be async.
         */ this.isAsync = false;
        /**
         * Track whether this resolver needs to perform a measurement
         * to resolve its keyframes.
         */ this.needsMeasurement = false;
        /**
         * Track whether this resolver is currently scheduled to resolve
         * to allow it to be cancelled and resumed externally.
         */ this.isScheduled = false;
        this.unresolvedKeyframes = [
            ...unresolvedKeyframes
        ];
        this.onComplete = onComplete;
        this.name = name;
        this.motionValue = motionValue;
        this.element = element;
        this.isAsync = isAsync;
    }
    scheduleResolve() {
        this.isScheduled = true;
        if (this.isAsync) {
            $b1026f81549deb9c$var$toResolve.add(this);
            if (!$b1026f81549deb9c$var$isScheduled) {
                $b1026f81549deb9c$var$isScheduled = true;
                (0, $2668c8a722676613$export$2cef06c20297c17d).read($b1026f81549deb9c$var$readAllKeyframes);
                (0, $2668c8a722676613$export$2cef06c20297c17d).resolveKeyframes($b1026f81549deb9c$var$measureAllKeyframes);
            }
        } else {
            this.readKeyframes();
            this.complete();
        }
    }
    readKeyframes() {
        const { unresolvedKeyframes: unresolvedKeyframes, name: name, element: element, motionValue: motionValue } = this;
        /**
         * If a keyframe is null, we hydrate it either by reading it from
         * the instance, or propagating from previous keyframes.
         */ for(let i = 0; i < unresolvedKeyframes.length; i++)if (unresolvedKeyframes[i] === null) {
            /**
                 * If the first keyframe is null, we need to find its value by sampling the element
                 */ if (i === 0) {
                const currentValue = motionValue === null || motionValue === void 0 ? void 0 : motionValue.get();
                const finalKeyframe = unresolvedKeyframes[unresolvedKeyframes.length - 1];
                if (currentValue !== undefined) unresolvedKeyframes[0] = currentValue;
                else if (element && name) {
                    const valueAsRead = element.readValue(name, finalKeyframe);
                    if (valueAsRead !== undefined && valueAsRead !== null) unresolvedKeyframes[0] = valueAsRead;
                }
                if (unresolvedKeyframes[0] === undefined) unresolvedKeyframes[0] = finalKeyframe;
                if (motionValue && currentValue === undefined) motionValue.set(unresolvedKeyframes[0]);
            } else unresolvedKeyframes[i] = unresolvedKeyframes[i - 1];
        }
    }
    setFinalKeyframe() {}
    measureInitialState() {}
    renderEndStyles() {}
    measureEndState() {}
    complete() {
        this.isComplete = true;
        this.onComplete(this.unresolvedKeyframes, this.finalKeyframe);
        $b1026f81549deb9c$var$toResolve.delete(this);
    }
    cancel() {
        if (!this.isComplete) {
            this.isScheduled = false;
            $b1026f81549deb9c$var$toResolve.delete(this);
        }
    }
    resume() {
        if (!this.isComplete) this.scheduleResolve();
    }
}







/**
 * Returns true if the provided string is a color, ie rgba(0,0,0,0) or #000,
 * but false if a number or multiple colors
 */ const $d9f7e69c7de5bbb2$export$2c8400d58aca05e = (type, testProp)=>(v)=>{
        return Boolean((0, $08c2e9dc5cfbd69e$export$844ec244b1367d54)(v) && (0, $08c2e9dc5cfbd69e$export$ed808ff6ecd39e8d).test(v) && v.startsWith(type) || testProp && !(0, $08c2e9dc5cfbd69e$export$b931b78cbb3caf86)(v) && Object.prototype.hasOwnProperty.call(v, testProp));
    };
const $d9f7e69c7de5bbb2$export$73d6f35be992df24 = (aName, bName, cName)=>(v)=>{
        if (!(0, $08c2e9dc5cfbd69e$export$844ec244b1367d54)(v)) return v;
        const [a, b, c, alpha] = v.match((0, $08c2e9dc5cfbd69e$export$2444ca58c08448e4));
        return {
            [aName]: parseFloat(a),
            [bName]: parseFloat(b),
            [cName]: parseFloat(c),
            alpha: alpha !== undefined ? parseFloat(alpha) : 1
        };
    };


const $72a82e60c8da202c$var$clampRgbUnit = (v)=>(0, $b64a5fb8aaa910d9$export$7d15b64cf5a3a4c4)(0, 255, v);
const $72a82e60c8da202c$export$7a99c86b5b1f4c9e = {
    ...(0, $2a216475fc6839a7$export$98e628dec113755e),
    transform: (v)=>Math.round($72a82e60c8da202c$var$clampRgbUnit(v))
};
const $72a82e60c8da202c$export$4e46ac54fc82cf3b = {
    test: /*@__PURE__*/ (0, $d9f7e69c7de5bbb2$export$2c8400d58aca05e)("rgb", "red"),
    parse: /*@__PURE__*/ (0, $d9f7e69c7de5bbb2$export$73d6f35be992df24)("red", "green", "blue"),
    transform: ({ red: red, green: green, blue: blue, alpha: alpha$1 = 1 })=>"rgba(" + $72a82e60c8da202c$export$7a99c86b5b1f4c9e.transform(red) + ", " + $72a82e60c8da202c$export$7a99c86b5b1f4c9e.transform(green) + ", " + $72a82e60c8da202c$export$7a99c86b5b1f4c9e.transform(blue) + ", " + (0, $08c2e9dc5cfbd69e$export$83d2e9e3e4ee39ed)((0, $2a216475fc6839a7$export$58f0f39f63f3cf42).transform(alpha$1)) + ")"
};



function $d72f3ee0fc88882a$var$parseHex(v) {
    let r = "";
    let g = "";
    let b = "";
    let a = "";
    // If we have 6 characters, ie #FF0000
    if (v.length > 5) {
        r = v.substring(1, 3);
        g = v.substring(3, 5);
        b = v.substring(5, 7);
        a = v.substring(7, 9);
    // Or we have 3 characters, ie #F00
    } else {
        r = v.substring(1, 2);
        g = v.substring(2, 3);
        b = v.substring(3, 4);
        a = v.substring(4, 5);
        r += r;
        g += g;
        b += b;
        a += a;
    }
    return {
        red: parseInt(r, 16),
        green: parseInt(g, 16),
        blue: parseInt(b, 16),
        alpha: a ? parseInt(a, 16) / 255 : 1
    };
}
const $d72f3ee0fc88882a$export$834dfc94dde4b3d8 = {
    test: /*@__PURE__*/ (0, $d9f7e69c7de5bbb2$export$2c8400d58aca05e)("#"),
    parse: $d72f3ee0fc88882a$var$parseHex,
    transform: (0, $72a82e60c8da202c$export$4e46ac54fc82cf3b).transform
};






const $62184c9fdaf92bae$export$810b04175080204c = {
    test: /*@__PURE__*/ (0, $d9f7e69c7de5bbb2$export$2c8400d58aca05e)("hsl", "hue"),
    parse: /*@__PURE__*/ (0, $d9f7e69c7de5bbb2$export$73d6f35be992df24)("hue", "saturation", "lightness"),
    transform: ({ hue: hue, saturation: saturation, lightness: lightness, alpha: alpha$1 = 1 })=>{
        return "hsla(" + Math.round(hue) + ", " + (0, $2e2cc09c72ffc0aa$export$626336c2cd4b14de).transform((0, $08c2e9dc5cfbd69e$export$83d2e9e3e4ee39ed)(saturation)) + ", " + (0, $2e2cc09c72ffc0aa$export$626336c2cd4b14de).transform((0, $08c2e9dc5cfbd69e$export$83d2e9e3e4ee39ed)(lightness)) + ", " + (0, $08c2e9dc5cfbd69e$export$83d2e9e3e4ee39ed)((0, $2a216475fc6839a7$export$58f0f39f63f3cf42).transform(alpha$1)) + ")";
    }
};



const $7028c17a7a695b13$export$35e9368ef982300f = {
    test: (v)=>(0, $72a82e60c8da202c$export$4e46ac54fc82cf3b).test(v) || (0, $d72f3ee0fc88882a$export$834dfc94dde4b3d8).test(v) || (0, $62184c9fdaf92bae$export$810b04175080204c).test(v),
    parse: (v)=>{
        if ((0, $72a82e60c8da202c$export$4e46ac54fc82cf3b).test(v)) return (0, $72a82e60c8da202c$export$4e46ac54fc82cf3b).parse(v);
        else if ((0, $62184c9fdaf92bae$export$810b04175080204c).test(v)) return (0, $62184c9fdaf92bae$export$810b04175080204c).parse(v);
        else return (0, $d72f3ee0fc88882a$export$834dfc94dde4b3d8).parse(v);
    },
    transform: (v)=>{
        return (0, $08c2e9dc5cfbd69e$export$844ec244b1367d54)(v) ? v : v.hasOwnProperty("red") ? (0, $72a82e60c8da202c$export$4e46ac54fc82cf3b).transform(v) : (0, $62184c9fdaf92bae$export$810b04175080204c).transform(v);
    }
};



function $4c282419bf833d7f$var$test(v) {
    var _a, _b;
    return isNaN(v) && (0, $08c2e9dc5cfbd69e$export$844ec244b1367d54)(v) && (((_a = v.match((0, $08c2e9dc5cfbd69e$export$2444ca58c08448e4))) === null || _a === void 0 ? void 0 : _a.length) || 0) + (((_b = v.match((0, $08c2e9dc5cfbd69e$export$740b69c5fad25dba))) === null || _b === void 0 ? void 0 : _b.length) || 0) > 0;
}
const $4c282419bf833d7f$var$NUMBER_TOKEN = "number";
const $4c282419bf833d7f$var$COLOR_TOKEN = "color";
const $4c282419bf833d7f$var$VAR_TOKEN = "var";
const $4c282419bf833d7f$var$VAR_FUNCTION_TOKEN = "var(";
const $4c282419bf833d7f$var$SPLIT_TOKEN = "${}";
// this regex consists of the `singleCssVariableRegex|rgbHSLValueRegex|digitRegex`
const $4c282419bf833d7f$var$complexRegex = /var\s*\(\s*--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)|#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\)|-?(?:\d+(?:\.\d+)?|\.\d+)/giu;
function $4c282419bf833d7f$export$b61fc7c44bf646d5(value) {
    const originalValue = value.toString();
    const values = [];
    const indexes = {
        color: [],
        number: [],
        var: []
    };
    const types = [];
    let i = 0;
    const tokenised = originalValue.replace($4c282419bf833d7f$var$complexRegex, (parsedValue)=>{
        if ((0, $7028c17a7a695b13$export$35e9368ef982300f).test(parsedValue)) {
            indexes.color.push(i);
            types.push($4c282419bf833d7f$var$COLOR_TOKEN);
            values.push((0, $7028c17a7a695b13$export$35e9368ef982300f).parse(parsedValue));
        } else if (parsedValue.startsWith($4c282419bf833d7f$var$VAR_FUNCTION_TOKEN)) {
            indexes.var.push(i);
            types.push($4c282419bf833d7f$var$VAR_TOKEN);
            values.push(parsedValue);
        } else {
            indexes.number.push(i);
            types.push($4c282419bf833d7f$var$NUMBER_TOKEN);
            values.push(parseFloat(parsedValue));
        }
        ++i;
        return $4c282419bf833d7f$var$SPLIT_TOKEN;
    });
    const split = tokenised.split($4c282419bf833d7f$var$SPLIT_TOKEN);
    return {
        values: values,
        split: split,
        indexes: indexes,
        types: types
    };
}
function $4c282419bf833d7f$var$parseComplexValue(v) {
    return $4c282419bf833d7f$export$b61fc7c44bf646d5(v).values;
}
function $4c282419bf833d7f$var$createTransformer(source) {
    const { split: split, types: types } = $4c282419bf833d7f$export$b61fc7c44bf646d5(source);
    const numSections = split.length;
    return (v)=>{
        let output = "";
        for(let i = 0; i < numSections; i++){
            output += split[i];
            if (v[i] !== undefined) {
                const type = types[i];
                if (type === $4c282419bf833d7f$var$NUMBER_TOKEN) output += (0, $08c2e9dc5cfbd69e$export$83d2e9e3e4ee39ed)(v[i]);
                else if (type === $4c282419bf833d7f$var$COLOR_TOKEN) output += (0, $7028c17a7a695b13$export$35e9368ef982300f).transform(v[i]);
                else output += v[i];
            }
        }
        return output;
    };
}
const $4c282419bf833d7f$var$convertNumbersToZero = (v)=>typeof v === "number" ? 0 : v;
function $4c282419bf833d7f$var$getAnimatableNone(v) {
    const parsed = $4c282419bf833d7f$var$parseComplexValue(v);
    const transformer = $4c282419bf833d7f$var$createTransformer(v);
    return transformer(parsed.map($4c282419bf833d7f$var$convertNumbersToZero));
}
const $4c282419bf833d7f$export$83a0e34f1302825b = {
    test: $4c282419bf833d7f$var$test,
    parse: $4c282419bf833d7f$var$parseComplexValue,
    createTransformer: $4c282419bf833d7f$var$createTransformer,
    getAnimatableNone: $4c282419bf833d7f$var$getAnimatableNone
};





/**
 * Properties that should default to 1 or 100%
 */ const $86bc5fae81d2f8f7$var$maxDefaults = new Set([
    "brightness",
    "contrast",
    "saturate",
    "opacity"
]);
function $86bc5fae81d2f8f7$var$applyDefaultFilter(v) {
    const [name, value] = v.slice(0, -1).split("(");
    if (name === "drop-shadow") return v;
    const [number] = value.match((0, $08c2e9dc5cfbd69e$export$2444ca58c08448e4)) || [];
    if (!number) return v;
    const unit = value.replace(number, "");
    let defaultValue = $86bc5fae81d2f8f7$var$maxDefaults.has(name) ? 1 : 0;
    if (number !== value) defaultValue *= 100;
    return name + "(" + defaultValue + unit + ")";
}
const $86bc5fae81d2f8f7$var$functionRegex = /\b([a-z-]*)\(.*?\)/gu;
const $86bc5fae81d2f8f7$export$3dea766d36a8935f = {
    ...(0, $4c282419bf833d7f$export$83a0e34f1302825b),
    getAnimatableNone: (v)=>{
        const functions = v.match($86bc5fae81d2f8f7$var$functionRegex);
        return functions ? functions.map($86bc5fae81d2f8f7$var$applyDefaultFilter).join(" ") : v;
    }
};







const $89729b3a34a4860f$export$7d260a2a5f8bc19e = {
    ...(0, $2a216475fc6839a7$export$98e628dec113755e),
    transform: Math.round
};


const $0f29681014396523$export$eec14432cd1cb67b = {
    // Border props
    borderWidth: (0, $2e2cc09c72ffc0aa$export$91c0eda1d06bf008),
    borderTopWidth: (0, $2e2cc09c72ffc0aa$export$91c0eda1d06bf008),
    borderRightWidth: (0, $2e2cc09c72ffc0aa$export$91c0eda1d06bf008),
    borderBottomWidth: (0, $2e2cc09c72ffc0aa$export$91c0eda1d06bf008),
    borderLeftWidth: (0, $2e2cc09c72ffc0aa$export$91c0eda1d06bf008),
    borderRadius: (0, $2e2cc09c72ffc0aa$export$91c0eda1d06bf008),
    radius: (0, $2e2cc09c72ffc0aa$export$91c0eda1d06bf008),
    borderTopLeftRadius: (0, $2e2cc09c72ffc0aa$export$91c0eda1d06bf008),
    borderTopRightRadius: (0, $2e2cc09c72ffc0aa$export$91c0eda1d06bf008),
    borderBottomRightRadius: (0, $2e2cc09c72ffc0aa$export$91c0eda1d06bf008),
    borderBottomLeftRadius: (0, $2e2cc09c72ffc0aa$export$91c0eda1d06bf008),
    // Positioning props
    width: (0, $2e2cc09c72ffc0aa$export$91c0eda1d06bf008),
    maxWidth: (0, $2e2cc09c72ffc0aa$export$91c0eda1d06bf008),
    height: (0, $2e2cc09c72ffc0aa$export$91c0eda1d06bf008),
    maxHeight: (0, $2e2cc09c72ffc0aa$export$91c0eda1d06bf008),
    size: (0, $2e2cc09c72ffc0aa$export$91c0eda1d06bf008),
    top: (0, $2e2cc09c72ffc0aa$export$91c0eda1d06bf008),
    right: (0, $2e2cc09c72ffc0aa$export$91c0eda1d06bf008),
    bottom: (0, $2e2cc09c72ffc0aa$export$91c0eda1d06bf008),
    left: (0, $2e2cc09c72ffc0aa$export$91c0eda1d06bf008),
    // Spacing props
    padding: (0, $2e2cc09c72ffc0aa$export$91c0eda1d06bf008),
    paddingTop: (0, $2e2cc09c72ffc0aa$export$91c0eda1d06bf008),
    paddingRight: (0, $2e2cc09c72ffc0aa$export$91c0eda1d06bf008),
    paddingBottom: (0, $2e2cc09c72ffc0aa$export$91c0eda1d06bf008),
    paddingLeft: (0, $2e2cc09c72ffc0aa$export$91c0eda1d06bf008),
    margin: (0, $2e2cc09c72ffc0aa$export$91c0eda1d06bf008),
    marginTop: (0, $2e2cc09c72ffc0aa$export$91c0eda1d06bf008),
    marginRight: (0, $2e2cc09c72ffc0aa$export$91c0eda1d06bf008),
    marginBottom: (0, $2e2cc09c72ffc0aa$export$91c0eda1d06bf008),
    marginLeft: (0, $2e2cc09c72ffc0aa$export$91c0eda1d06bf008),
    // Transform props
    rotate: (0, $2e2cc09c72ffc0aa$export$41fc368e1a942b97),
    rotateX: (0, $2e2cc09c72ffc0aa$export$41fc368e1a942b97),
    rotateY: (0, $2e2cc09c72ffc0aa$export$41fc368e1a942b97),
    rotateZ: (0, $2e2cc09c72ffc0aa$export$41fc368e1a942b97),
    scale: $2a216475fc6839a7$export$dcdf75081b88279d,
    scaleX: (0, $2a216475fc6839a7$export$dcdf75081b88279d),
    scaleY: (0, $2a216475fc6839a7$export$dcdf75081b88279d),
    scaleZ: (0, $2a216475fc6839a7$export$dcdf75081b88279d),
    skew: (0, $2e2cc09c72ffc0aa$export$41fc368e1a942b97),
    skewX: (0, $2e2cc09c72ffc0aa$export$41fc368e1a942b97),
    skewY: (0, $2e2cc09c72ffc0aa$export$41fc368e1a942b97),
    distance: (0, $2e2cc09c72ffc0aa$export$91c0eda1d06bf008),
    translateX: (0, $2e2cc09c72ffc0aa$export$91c0eda1d06bf008),
    translateY: (0, $2e2cc09c72ffc0aa$export$91c0eda1d06bf008),
    translateZ: (0, $2e2cc09c72ffc0aa$export$91c0eda1d06bf008),
    x: (0, $2e2cc09c72ffc0aa$export$91c0eda1d06bf008),
    y: (0, $2e2cc09c72ffc0aa$export$91c0eda1d06bf008),
    z: (0, $2e2cc09c72ffc0aa$export$91c0eda1d06bf008),
    perspective: (0, $2e2cc09c72ffc0aa$export$91c0eda1d06bf008),
    transformPerspective: (0, $2e2cc09c72ffc0aa$export$91c0eda1d06bf008),
    opacity: (0, $2a216475fc6839a7$export$58f0f39f63f3cf42),
    originX: (0, $2e2cc09c72ffc0aa$export$44e2e1705876d7ed),
    originY: (0, $2e2cc09c72ffc0aa$export$44e2e1705876d7ed),
    originZ: (0, $2e2cc09c72ffc0aa$export$91c0eda1d06bf008),
    // Misc
    zIndex: (0, $89729b3a34a4860f$export$7d260a2a5f8bc19e),
    backgroundPositionX: (0, $2e2cc09c72ffc0aa$export$91c0eda1d06bf008),
    backgroundPositionY: (0, $2e2cc09c72ffc0aa$export$91c0eda1d06bf008),
    // SVG
    fillOpacity: (0, $2a216475fc6839a7$export$58f0f39f63f3cf42),
    strokeOpacity: (0, $2a216475fc6839a7$export$58f0f39f63f3cf42),
    numOctaves: (0, $89729b3a34a4860f$export$7d260a2a5f8bc19e)
};


/**
 * A map of default value types for common values
 */ const $a3e8133ab555f880$export$98cd7c72c5a731fb = {
    ...(0, $0f29681014396523$export$eec14432cd1cb67b),
    color: // Color props
    $7028c17a7a695b13$export$35e9368ef982300f,
    backgroundColor: (0, $7028c17a7a695b13$export$35e9368ef982300f),
    outlineColor: (0, $7028c17a7a695b13$export$35e9368ef982300f),
    fill: (0, $7028c17a7a695b13$export$35e9368ef982300f),
    stroke: (0, $7028c17a7a695b13$export$35e9368ef982300f),
    // Border props
    borderColor: (0, $7028c17a7a695b13$export$35e9368ef982300f),
    borderTopColor: (0, $7028c17a7a695b13$export$35e9368ef982300f),
    borderRightColor: (0, $7028c17a7a695b13$export$35e9368ef982300f),
    borderBottomColor: (0, $7028c17a7a695b13$export$35e9368ef982300f),
    borderLeftColor: (0, $7028c17a7a695b13$export$35e9368ef982300f),
    filter: $86bc5fae81d2f8f7$export$3dea766d36a8935f,
    WebkitFilter: (0, $86bc5fae81d2f8f7$export$3dea766d36a8935f)
};
/**
 * Gets the default ValueType for the provided value key
 */ const $a3e8133ab555f880$export$67d1babe0338d23b = (key)=>$a3e8133ab555f880$export$98cd7c72c5a731fb[key];


function $e50050333fd23e17$export$cea0cedcb94873b5(key, value) {
    let defaultValueType = (0, $a3e8133ab555f880$export$67d1babe0338d23b)(key);
    if (defaultValueType !== (0, $86bc5fae81d2f8f7$export$3dea766d36a8935f)) defaultValueType = (0, $4c282419bf833d7f$export$83a0e34f1302825b);
    // If value is not recognised as animatable, ie "none", create an animatable version origin based on the target
    return defaultValueType.getAnimatableNone ? defaultValueType.getAnimatableNone(value) : undefined;
}


/**
 * If we encounter keyframes like "none" or "0" and we also have keyframes like
 * "#fff" or "200px 200px" we want to find a keyframe to serve as a template for
 * the "none" keyframes. In this case "#fff" or "200px 200px" - then these get turned into
 * zero equivalents, i.e. "#fff0" or "0px 0px".
 */ const $1d575d46915e7d9e$var$invalidTemplates = new Set([
    "auto",
    "none",
    "0"
]);
function $1d575d46915e7d9e$export$8cc4958f8e540f37(unresolvedKeyframes, noneKeyframeIndexes, name) {
    let i = 0;
    let animatableTemplate = undefined;
    while(i < unresolvedKeyframes.length && !animatableTemplate){
        const keyframe = unresolvedKeyframes[i];
        if (typeof keyframe === "string" && !$1d575d46915e7d9e$var$invalidTemplates.has(keyframe) && (0, $4c282419bf833d7f$export$b61fc7c44bf646d5)(keyframe).values.length) animatableTemplate = unresolvedKeyframes[i];
        i++;
    }
    if (animatableTemplate && name) for (const noneIndex of noneKeyframeIndexes)unresolvedKeyframes[noneIndex] = (0, $e50050333fd23e17$export$cea0cedcb94873b5)(name, animatableTemplate);
}


class $7a5a5700acca8750$export$4983792d11b61017 extends (0, $b1026f81549deb9c$export$74d34ca3182f1750) {
    constructor(unresolvedKeyframes, onComplete, name, motionValue, element){
        super(unresolvedKeyframes, onComplete, name, motionValue, element, true);
    }
    readKeyframes() {
        const { unresolvedKeyframes: unresolvedKeyframes, element: element, name: name } = this;
        if (!element || !element.current) return;
        super.readKeyframes();
        /**
         * If any keyframe is a CSS variable, we need to find its value by sampling the element
         */ for(let i = 0; i < unresolvedKeyframes.length; i++){
            let keyframe = unresolvedKeyframes[i];
            if (typeof keyframe === "string") {
                keyframe = keyframe.trim();
                if ((0, $7b632f63647c186c$export$31f9caa2600b5723)(keyframe)) {
                    const resolved = (0, $a5eac11b2abb9c45$export$289398774300c991)(keyframe, element.current);
                    if (resolved !== undefined) unresolvedKeyframes[i] = resolved;
                    if (i === unresolvedKeyframes.length - 1) this.finalKeyframe = keyframe;
                }
            }
        }
        /**
         * Resolve "none" values. We do this potentially twice - once before and once after measuring keyframes.
         * This could be seen as inefficient but it's a trade-off to avoid measurements in more situations, which
         * have a far bigger performance impact.
         */ this.resolveNoneKeyframes();
        /**
         * Check to see if unit type has changed. If so schedule jobs that will
         * temporarily set styles to the destination keyframes.
         * Skip if we have more than two keyframes or this isn't a positional value.
         * TODO: We can throw if there are multiple keyframes and the value type changes.
         */ if (!(0, $dc5c7ac2258c6333$export$c66c0d5db2a205d).has(name) || unresolvedKeyframes.length !== 2) return;
        const [origin, target] = unresolvedKeyframes;
        const originType = (0, $1c32a536829b8c8a$export$eefdd52e3ccae428)(origin);
        const targetType = (0, $1c32a536829b8c8a$export$eefdd52e3ccae428)(target);
        /**
         * Either we don't recognise these value types or we can animate between them.
         */ if (originType === targetType) return;
        /**
         * If both values are numbers or pixels, we can animate between them by
         * converting them to numbers.
         */ if ((0, $dc5c7ac2258c6333$export$8e5250d1aa9bf370)(originType) && (0, $dc5c7ac2258c6333$export$8e5250d1aa9bf370)(targetType)) for(let i = 0; i < unresolvedKeyframes.length; i++){
            const value = unresolvedKeyframes[i];
            if (typeof value === "string") unresolvedKeyframes[i] = parseFloat(value);
        }
        else /**
             * Else, the only way to resolve this is by measuring the element.
             */ this.needsMeasurement = true;
    }
    resolveNoneKeyframes() {
        const { unresolvedKeyframes: unresolvedKeyframes, name: name } = this;
        const noneKeyframeIndexes = [];
        for(let i = 0; i < unresolvedKeyframes.length; i++)if ((0, $17feb55ffe87f155$export$e56af863d5645d5f)(unresolvedKeyframes[i])) noneKeyframeIndexes.push(i);
        if (noneKeyframeIndexes.length) (0, $1d575d46915e7d9e$export$8cc4958f8e540f37)(unresolvedKeyframes, noneKeyframeIndexes, name);
    }
    measureInitialState() {
        const { element: element, unresolvedKeyframes: unresolvedKeyframes, name: name } = this;
        if (!element || !element.current) return;
        if (name === "height") this.suspendedScrollY = window.pageYOffset;
        this.measuredOrigin = (0, $dc5c7ac2258c6333$export$781d46a8aa670d52)[name](element.measureViewportBox(), window.getComputedStyle(element.current));
        unresolvedKeyframes[0] = this.measuredOrigin;
        // Set final key frame to measure after next render
        const measureKeyframe = unresolvedKeyframes[unresolvedKeyframes.length - 1];
        if (measureKeyframe !== undefined) element.getValue(name, measureKeyframe).jump(measureKeyframe, false);
    }
    measureEndState() {
        var _a;
        const { element: element, name: name, unresolvedKeyframes: unresolvedKeyframes } = this;
        if (!element || !element.current) return;
        const value = element.getValue(name);
        value && value.jump(this.measuredOrigin, false);
        const finalKeyframeIndex = unresolvedKeyframes.length - 1;
        const finalKeyframe = unresolvedKeyframes[finalKeyframeIndex];
        unresolvedKeyframes[finalKeyframeIndex] = (0, $dc5c7ac2258c6333$export$781d46a8aa670d52)[name](element.measureViewportBox(), window.getComputedStyle(element.current));
        if (finalKeyframe !== null && this.finalKeyframe === undefined) this.finalKeyframe = finalKeyframe;
        // If we removed transform values, reapply them before the next render
        if ((_a = this.removedTransforms) === null || _a === void 0 ? void 0 : _a.length) this.removedTransforms.forEach(([unsetTransformName, unsetTransformValue])=>{
            element.getValue(unsetTransformName).set(unsetTransformValue);
        });
        this.resolveNoneKeyframes();
    }
}


function $134d1d2e49b301fc$export$7c73462e0d25e514(callback) {
    let result;
    return ()=>{
        if (result === undefined) result = callback();
        return result;
    };
}






let $3a6da39b219d0ac7$var$now;
function $3a6da39b219d0ac7$var$clearTime() {
    $3a6da39b219d0ac7$var$now = undefined;
}
/**
 * An eventloop-synchronous alternative to performance.now().
 *
 * Ensures that time measurements remain consistent within a synchronous context.
 * Usually calling performance.now() twice within the same synchronous context
 * will return different values which isn't useful for animations when we're usually
 * trying to sync animations to the same frame.
 */ const $3a6da39b219d0ac7$export$2da9be4cfdb689b1 = {
    now: ()=>{
        if ($3a6da39b219d0ac7$var$now === undefined) $3a6da39b219d0ac7$export$2da9be4cfdb689b1.set((0, $2668c8a722676613$export$fff89137e9e818ce).isProcessing || (0, $d3f03766da854ace$export$dd826089e3c5e502).useManualTiming ? (0, $2668c8a722676613$export$fff89137e9e818ce).timestamp : performance.now());
        return $3a6da39b219d0ac7$var$now;
    },
    set: (newTime)=>{
        $3a6da39b219d0ac7$var$now = newTime;
        queueMicrotask($3a6da39b219d0ac7$var$clearTime);
    }
};






/**
 * Check if a value is animatable. Examples:
 *
 * ✅: 100, "100px", "#fff"
 * ❌: "block", "url(2.jpg)"
 * @param value
 *
 * @internal
 */ const $07e3a74163131a68$export$65676b58b122bc38 = (value, name)=>{
    // If the list of keys tat might be non-animatable grows, replace with Set
    if (name === "zIndex") return false;
    // If it's a number or a keyframes array, we can animate it. We might at some point
    // need to do a deep isAnimatable check of keyframes, or let Popmotion handle this,
    // but for now lets leave it like this for performance reasons
    if (typeof value === "number" || Array.isArray(value)) return true;
    if (typeof value === "string" && // It's animatable if we have a string
    ((0, $4c282419bf833d7f$export$83a0e34f1302825b).test(value) || value === "0") && // And it contains numbers and/or colors
    !value.startsWith("url(") // Unless it starts with "url("
    ) return true;
    return false;
};


function $c4420626c4434de8$var$hasKeyframesChanged(keyframes) {
    const current = keyframes[0];
    if (keyframes.length === 1) return true;
    for(let i = 0; i < keyframes.length; i++){
        if (keyframes[i] !== current) return true;
    }
}
function $c4420626c4434de8$export$1b109e6c9968df4f(keyframes, name, type, velocity) {
    /**
     * Check if we're able to animate between the start and end keyframes,
     * and throw a warning if we're attempting to animate between one that's
     * animatable and another that isn't.
     */ const originKeyframe = keyframes[0];
    if (originKeyframe === null) return false;
    /**
     * These aren't traditionally animatable but we do support them.
     * In future we could look into making this more generic or replacing
     * this function with mix() === mixImmediate
     */ if (name === "display" || name === "visibility") return true;
    const targetKeyframe = keyframes[keyframes.length - 1];
    const isOriginAnimatable = (0, $07e3a74163131a68$export$65676b58b122bc38)(originKeyframe, name);
    const isTargetAnimatable = (0, $07e3a74163131a68$export$65676b58b122bc38)(targetKeyframe, name);
    (0, $2b9100c03bd61cb5$export$491112666e282270)(isOriginAnimatable === isTargetAnimatable, `You are trying to animate ${name} from "${originKeyframe}" to "${targetKeyframe}". ${originKeyframe} is not an animatable value - to enable this animation set ${originKeyframe} to a value animatable to ${targetKeyframe} via the \`style\` property.`);
    // Always skip if any of these are true
    if (!isOriginAnimatable || !isTargetAnimatable) return false;
    return $c4420626c4434de8$var$hasKeyframesChanged(keyframes) || type === "spring" && velocity;
}



/**
 * Maximum time allowed between an animation being created and it being
 * resolved for us to use the latter as the start time.
 *
 * This is to ensure that while we prefer to "start" an animation as soon
 * as it's triggered, we also want to avoid a visual jump if there's a big delay
 * between these two moments.
 */ const $e933a795f7f32123$var$MAX_RESOLVE_DELAY = 40;
class $e933a795f7f32123$export$d1e4f34b9c2550c1 {
    constructor({ autoplay: autoplay = true, delay: delay = 0, type: type = "keyframes", repeat: repeat = 0, repeatDelay: repeatDelay = 0, repeatType: repeatType = "loop", ...options }){
        // Track whether the animation has been stopped. Stopped animations won't restart.
        this.isStopped = false;
        this.hasAttemptedResolve = false;
        this.createdAt = (0, $3a6da39b219d0ac7$export$2da9be4cfdb689b1).now();
        this.options = {
            autoplay: autoplay,
            delay: delay,
            type: type,
            repeat: repeat,
            repeatDelay: repeatDelay,
            repeatType: repeatType,
            ...options
        };
        this.updateFinishedPromise();
    }
    /**
     * This method uses the createdAt and resolvedAt to calculate the
     * animation startTime. *Ideally*, we would use the createdAt time as t=0
     * as the following frame would then be the first frame of the animation in
     * progress, which would feel snappier.
     *
     * However, if there's a delay (main thread work) between the creation of
     * the animation and the first commited frame, we prefer to use resolvedAt
     * to avoid a sudden jump into the animation.
     */ calcStartTime() {
        if (!this.resolvedAt) return this.createdAt;
        return this.resolvedAt - this.createdAt > $e933a795f7f32123$var$MAX_RESOLVE_DELAY ? this.resolvedAt : this.createdAt;
    }
    /**
     * A getter for resolved data. If keyframes are not yet resolved, accessing
     * this.resolved will synchronously flush all pending keyframe resolvers.
     * This is a deoptimisation, but at its worst still batches read/writes.
     */ get resolved() {
        if (!this._resolved && !this.hasAttemptedResolve) (0, $b1026f81549deb9c$export$78b96d2a12593b05)();
        return this._resolved;
    }
    /**
     * A method to be called when the keyframes resolver completes. This method
     * will check if its possible to run the animation and, if not, skip it.
     * Otherwise, it will call initPlayback on the implementing class.
     */ onKeyframesResolved(keyframes, finalKeyframe) {
        this.resolvedAt = (0, $3a6da39b219d0ac7$export$2da9be4cfdb689b1).now();
        this.hasAttemptedResolve = true;
        const { name: name, type: type, velocity: velocity, delay: delay, onComplete: onComplete, onUpdate: onUpdate, isGenerator: isGenerator } = this.options;
        /**
         * If we can't animate this value with the resolved keyframes
         * then we should complete it immediately.
         */ if (!isGenerator && !(0, $c4420626c4434de8$export$1b109e6c9968df4f)(keyframes, name, type, velocity)) {
            // Finish immediately
            if ((0, $4f333d9188f46157$export$888a3d84909f9e3d).current || !delay) {
                onUpdate === null || onUpdate === void 0 || onUpdate((0, $3ca01ac9e8cf1f66$export$14de59408fad90b)(keyframes, this.options, finalKeyframe));
                onComplete === null || onComplete === void 0 || onComplete();
                this.resolveFinishedPromise();
                return;
            } else this.options.duration = 0;
        }
        const resolvedAnimation = this.initPlayback(keyframes, finalKeyframe);
        if (resolvedAnimation === false) return;
        this._resolved = {
            keyframes: keyframes,
            finalKeyframe: finalKeyframe,
            ...resolvedAnimation
        };
        this.onPostResolved();
    }
    onPostResolved() {}
    /**
     * Allows the returned animation to be awaited or promise-chained. Currently
     * resolves when the animation finishes at all but in a future update could/should
     * reject if its cancels.
     */ then(resolve, reject) {
        return this.currentFinishedPromise.then(resolve, reject);
    }
    updateFinishedPromise() {
        this.currentFinishedPromise = new Promise((resolve)=>{
            this.resolveFinishedPromise = resolve;
        });
    }
}




/*
  Convert velocity into velocity per second

  @param [number]: Unit per frame
  @param [number]: Frame duration in ms
*/ function $01416ecd35dd4fe1$export$eab0632f7ad4f9d7(velocity, frameDuration) {
    return frameDuration ? velocity * (1000 / frameDuration) : 0;
}


const $21bb4a1bea7afdc8$var$velocitySampleDuration = 5; // ms
function $21bb4a1bea7afdc8$export$854187271d233eb5(resolveValue, t, current) {
    const prevT = Math.max(t - $21bb4a1bea7afdc8$var$velocitySampleDuration, 0);
    return (0, $01416ecd35dd4fe1$export$eab0632f7ad4f9d7)(current - resolveValue(prevT), t - prevT);
}





const $b7737875d953277f$var$safeMin = 0.001;
const $b7737875d953277f$export$a3cdb76e84ee608e = 0.01;
const $b7737875d953277f$export$1824b851fad8862b = 10.0;
const $b7737875d953277f$export$ff08f2d53484465 = 0.05;
const $b7737875d953277f$export$201ca48e54038115 = 1;
function $b7737875d953277f$export$b15f158dc6d6f458({ duration: duration = 800, bounce: bounce = 0.25, velocity: velocity = 0, mass: mass = 1 }) {
    let envelope;
    let derivative;
    (0, $2b9100c03bd61cb5$export$491112666e282270)(duration <= (0, $64e5667fa478a387$export$fc3e7e8557f8c8c7)($b7737875d953277f$export$1824b851fad8862b), "Spring duration must be 10 seconds or less");
    let dampingRatio = 1 - bounce;
    /**
     * Restrict dampingRatio and duration to within acceptable ranges.
     */ dampingRatio = (0, $b64a5fb8aaa910d9$export$7d15b64cf5a3a4c4)($b7737875d953277f$export$ff08f2d53484465, $b7737875d953277f$export$201ca48e54038115, dampingRatio);
    duration = (0, $b64a5fb8aaa910d9$export$7d15b64cf5a3a4c4)($b7737875d953277f$export$a3cdb76e84ee608e, $b7737875d953277f$export$1824b851fad8862b, (0, $64e5667fa478a387$export$f64c3bfbc58eec0f)(duration));
    if (dampingRatio < 1) {
        /**
         * Underdamped spring
         */ envelope = (undampedFreq)=>{
            const exponentialDecay = undampedFreq * dampingRatio;
            const delta = exponentialDecay * duration;
            const a = exponentialDecay - velocity;
            const b = $b7737875d953277f$export$5f679887c3a78b15(undampedFreq, dampingRatio);
            const c = Math.exp(-delta);
            return $b7737875d953277f$var$safeMin - a / b * c;
        };
        derivative = (undampedFreq)=>{
            const exponentialDecay = undampedFreq * dampingRatio;
            const delta = exponentialDecay * duration;
            const d = delta * velocity + velocity;
            const e = Math.pow(dampingRatio, 2) * Math.pow(undampedFreq, 2) * duration;
            const f = Math.exp(-delta);
            const g = $b7737875d953277f$export$5f679887c3a78b15(Math.pow(undampedFreq, 2), dampingRatio);
            const factor = -envelope(undampedFreq) + $b7737875d953277f$var$safeMin > 0 ? -1 : 1;
            return factor * ((d - e) * f) / g;
        };
    } else {
        /**
         * Critically-damped spring
         */ envelope = (undampedFreq)=>{
            const a = Math.exp(-undampedFreq * duration);
            const b = (undampedFreq - velocity) * duration + 1;
            return -$b7737875d953277f$var$safeMin + a * b;
        };
        derivative = (undampedFreq)=>{
            const a = Math.exp(-undampedFreq * duration);
            const b = (velocity - undampedFreq) * (duration * duration);
            return a * b;
        };
    }
    const initialGuess = 5 / duration;
    const undampedFreq = $b7737875d953277f$var$approximateRoot(envelope, derivative, initialGuess);
    duration = (0, $64e5667fa478a387$export$fc3e7e8557f8c8c7)(duration);
    if (isNaN(undampedFreq)) return {
        stiffness: 100,
        damping: 10,
        duration: duration
    };
    else {
        const stiffness = Math.pow(undampedFreq, 2) * mass;
        return {
            stiffness: stiffness,
            damping: dampingRatio * 2 * Math.sqrt(mass * stiffness),
            duration: duration
        };
    }
}
const $b7737875d953277f$var$rootIterations = 12;
function $b7737875d953277f$var$approximateRoot(envelope, derivative, initialGuess) {
    let result = initialGuess;
    for(let i = 1; i < $b7737875d953277f$var$rootIterations; i++)result = result - envelope(result) / derivative(result);
    return result;
}
function $b7737875d953277f$export$5f679887c3a78b15(undampedFreq, dampingRatio) {
    return undampedFreq * Math.sqrt(1 - dampingRatio * dampingRatio);
}


const $f2ee4de28e47ead0$var$durationKeys = [
    "duration",
    "bounce"
];
const $f2ee4de28e47ead0$var$physicsKeys = [
    "stiffness",
    "damping",
    "mass"
];
function $f2ee4de28e47ead0$var$isSpringType(options, keys) {
    return keys.some((key)=>options[key] !== undefined);
}
function $f2ee4de28e47ead0$var$getSpringOptions(options) {
    let springOptions = {
        velocity: 0.0,
        stiffness: 100,
        damping: 10,
        mass: 1.0,
        isResolvedFromDuration: false,
        ...options
    };
    // stiffness/damping/mass overrides duration/bounce
    if (!$f2ee4de28e47ead0$var$isSpringType(options, $f2ee4de28e47ead0$var$physicsKeys) && $f2ee4de28e47ead0$var$isSpringType(options, $f2ee4de28e47ead0$var$durationKeys)) {
        const derived = (0, $b7737875d953277f$export$b15f158dc6d6f458)(options);
        springOptions = {
            ...springOptions,
            ...derived,
            mass: 1.0
        };
        springOptions.isResolvedFromDuration = true;
    }
    return springOptions;
}
function $f2ee4de28e47ead0$export$b36281d89752ae66({ keyframes: keyframes, restDelta: restDelta, restSpeed: restSpeed, ...options }) {
    const origin = keyframes[0];
    const target = keyframes[keyframes.length - 1];
    /**
     * This is the Iterator-spec return value. We ensure it's mutable rather than using a generator
     * to reduce GC during animation.
     */ const state = {
        done: false,
        value: origin
    };
    const { stiffness: stiffness, damping: damping, mass: mass, duration: duration, velocity: velocity, isResolvedFromDuration: isResolvedFromDuration } = $f2ee4de28e47ead0$var$getSpringOptions({
        ...options,
        velocity: -(0, $64e5667fa478a387$export$f64c3bfbc58eec0f)(options.velocity || 0)
    });
    const initialVelocity = velocity || 0.0;
    const dampingRatio = damping / (2 * Math.sqrt(stiffness * mass));
    const initialDelta = target - origin;
    const undampedAngularFreq = (0, $64e5667fa478a387$export$f64c3bfbc58eec0f)(Math.sqrt(stiffness / mass));
    /**
     * If we're working on a granular scale, use smaller defaults for determining
     * when the spring is finished.
     *
     * These defaults have been selected emprically based on what strikes a good
     * ratio between feeling good and finishing as soon as changes are imperceptible.
     */ const isGranularScale = Math.abs(initialDelta) < 5;
    restSpeed || (restSpeed = isGranularScale ? 0.01 : 2);
    restDelta || (restDelta = isGranularScale ? 0.005 : 0.5);
    let resolveSpring;
    if (dampingRatio < 1) {
        const angularFreq = (0, $b7737875d953277f$export$5f679887c3a78b15)(undampedAngularFreq, dampingRatio);
        // Underdamped spring
        resolveSpring = (t)=>{
            const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
            return target - envelope * ((initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) / angularFreq * Math.sin(angularFreq * t) + initialDelta * Math.cos(angularFreq * t));
        };
    } else if (dampingRatio === 1) // Critically damped spring
    resolveSpring = (t)=>target - Math.exp(-undampedAngularFreq * t) * (initialDelta + (initialVelocity + undampedAngularFreq * initialDelta) * t);
    else {
        // Overdamped spring
        const dampedAngularFreq = undampedAngularFreq * Math.sqrt(dampingRatio * dampingRatio - 1);
        resolveSpring = (t)=>{
            const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
            // When performing sinh or cosh values can hit Infinity so we cap them here
            const freqForT = Math.min(dampedAngularFreq * t, 300);
            return target - envelope * ((initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) * Math.sinh(freqForT) + dampedAngularFreq * initialDelta * Math.cosh(freqForT)) / dampedAngularFreq;
        };
    }
    return {
        calculatedDuration: isResolvedFromDuration ? duration || null : null,
        next: (t)=>{
            const current = resolveSpring(t);
            if (!isResolvedFromDuration) {
                let currentVelocity = 0.0;
                /**
                 * We only need to calculate velocity for under-damped springs
                 * as over- and critically-damped springs can't overshoot, so
                 * checking only for displacement is enough.
                 */ if (dampingRatio < 1) currentVelocity = t === 0 ? (0, $64e5667fa478a387$export$fc3e7e8557f8c8c7)(initialVelocity) : (0, $21bb4a1bea7afdc8$export$854187271d233eb5)(resolveSpring, t, current);
                const isBelowVelocityThreshold = Math.abs(currentVelocity) <= restSpeed;
                const isBelowDisplacementThreshold = Math.abs(target - current) <= restDelta;
                state.done = isBelowVelocityThreshold && isBelowDisplacementThreshold;
            } else state.done = t >= duration;
            state.value = state.done ? target : current;
            return state;
        }
    };
}




function $d3675ca8f6e28248$export$ee3ff3a17106998({ keyframes: keyframes, velocity: velocity = 0.0, power: power = 0.8, timeConstant: timeConstant = 325, bounceDamping: bounceDamping = 10, bounceStiffness: bounceStiffness = 500, modifyTarget: modifyTarget, min: min, max: max, restDelta: restDelta = 0.5, restSpeed: restSpeed }) {
    const origin = keyframes[0];
    const state = {
        done: false,
        value: origin
    };
    const isOutOfBounds = (v)=>min !== undefined && v < min || max !== undefined && v > max;
    const nearestBoundary = (v)=>{
        if (min === undefined) return max;
        if (max === undefined) return min;
        return Math.abs(min - v) < Math.abs(max - v) ? min : max;
    };
    let amplitude = power * velocity;
    const ideal = origin + amplitude;
    const target = modifyTarget === undefined ? ideal : modifyTarget(ideal);
    /**
     * If the target has changed we need to re-calculate the amplitude, otherwise
     * the animation will start from the wrong position.
     */ if (target !== ideal) amplitude = target - origin;
    const calcDelta = (t)=>-amplitude * Math.exp(-t / timeConstant);
    const calcLatest = (t)=>target + calcDelta(t);
    const applyFriction = (t)=>{
        const delta = calcDelta(t);
        const latest = calcLatest(t);
        state.done = Math.abs(delta) <= restDelta;
        state.value = state.done ? target : latest;
    };
    /**
     * Ideally this would resolve for t in a stateless way, we could
     * do that by always precalculating the animation but as we know
     * this will be done anyway we can assume that spring will
     * be discovered during that.
     */ let timeReachedBoundary;
    let spring$1;
    const checkCatchBoundary = (t)=>{
        if (!isOutOfBounds(state.value)) return;
        timeReachedBoundary = t;
        spring$1 = (0, $f2ee4de28e47ead0$export$b36281d89752ae66)({
            keyframes: [
                state.value,
                nearestBoundary(state.value)
            ],
            velocity: (0, $21bb4a1bea7afdc8$export$854187271d233eb5)(calcLatest, t, state.value),
            damping: bounceDamping,
            stiffness: bounceStiffness,
            restDelta: restDelta,
            restSpeed: restSpeed
        });
    };
    checkCatchBoundary(0);
    return {
        calculatedDuration: null,
        next: (t)=>{
            /**
             * We need to resolve the friction to figure out if we need a
             * spring but we don't want to do this twice per frame. So here
             * we flag if we updated for this frame and later if we did
             * we can skip doing it again.
             */ let hasUpdatedFrame = false;
            if (!spring$1 && timeReachedBoundary === undefined) {
                hasUpdatedFrame = true;
                applyFriction(t);
                checkCatchBoundary(t);
            }
            /**
             * If we have a spring and the provided t is beyond the moment the friction
             * animation crossed the min/max boundary, use the spring.
             */ if (timeReachedBoundary !== undefined && t >= timeReachedBoundary) return spring$1.next(t - timeReachedBoundary);
            else {
                !hasUpdatedFrame && applyFriction(t);
                return state;
            }
        }
    };
}



/*
  Bezier function generator
  This has been modified from Gaëtan Renaudeau's BezierEasing
  https://github.com/gre/bezier-easing/blob/master/src/index.js
  https://github.com/gre/bezier-easing/blob/master/LICENSE
  
  I've removed the newtonRaphsonIterate algo because in benchmarking it
  wasn't noticiably faster than binarySubdivision, indeed removing it
  usually improved times, depending on the curve.
  I also removed the lookup table, as for the added bundle size and loop we're
  only cutting ~4 or so subdivision iterations. I bumped the max iterations up
  to 12 to compensate and this still tended to be faster for no perceivable
  loss in accuracy.
  Usage
    const easeOut = cubicBezier(.17,.67,.83,.67);
    const x = easeOut(0.5); // returns 0.627...
*/ // Returns x(t) given t, x1, and x2, or y(t) given t, y1, and y2.
const $a263c687dd63c6c5$var$calcBezier = (t, a1, a2)=>(((1.0 - 3.0 * a2 + 3.0 * a1) * t + (3.0 * a2 - 6.0 * a1)) * t + 3.0 * a1) * t;
const $a263c687dd63c6c5$var$subdivisionPrecision = 0.0000001;
const $a263c687dd63c6c5$var$subdivisionMaxIterations = 12;
function $a263c687dd63c6c5$var$binarySubdivide(x, lowerBound, upperBound, mX1, mX2) {
    let currentX;
    let currentT;
    let i = 0;
    do {
        currentT = lowerBound + (upperBound - lowerBound) / 2.0;
        currentX = $a263c687dd63c6c5$var$calcBezier(currentT, mX1, mX2) - x;
        if (currentX > 0.0) upperBound = currentT;
        else lowerBound = currentT;
    }while (Math.abs(currentX) > $a263c687dd63c6c5$var$subdivisionPrecision && ++i < $a263c687dd63c6c5$var$subdivisionMaxIterations);
    return currentT;
}
function $a263c687dd63c6c5$export$2c575fa1d20488bd(mX1, mY1, mX2, mY2) {
    // If this is a linear gradient, return linear easing
    if (mX1 === mY1 && mX2 === mY2) return 0, $c90734627ed96e3f$export$8793edee2d425525;
    const getTForX = (aX)=>$a263c687dd63c6c5$var$binarySubdivide(aX, 0, 1, mX1, mX2);
    // If animation is at start/end, return t without easing
    return (t)=>t === 0 || t === 1 ? t : $a263c687dd63c6c5$var$calcBezier(getTForX(t), mY1, mY2);
}


const $a3d2a640a7819290$export$929e5a82286172a6 = /*@__PURE__*/ (0, $a263c687dd63c6c5$export$2c575fa1d20488bd)(0.42, 0, 1, 1);
const $a3d2a640a7819290$export$57636bb43b1ccbb0 = /*@__PURE__*/ (0, $a263c687dd63c6c5$export$2c575fa1d20488bd)(0, 0, 0.58, 1);
const $a3d2a640a7819290$export$c07234257a03d5e9 = /*@__PURE__*/ (0, $a263c687dd63c6c5$export$2c575fa1d20488bd)(0.42, 0, 0.58, 1);


const $cdb960b4abd00d82$export$216948827bbdc797 = (ease)=>{
    return Array.isArray(ease) && typeof ease[0] !== "number";
};






// Accepts an easing function and returns a new one that outputs mirrored values for
// the second half of the animation. Turns easeIn into easeInOut.
const $7570a191f3c94b31$export$f946554fb8aeaf0d = (easing)=>(p)=>p <= 0.5 ? easing(2 * p) / 2 : (2 - easing(2 * (1 - p))) / 2;


// Accepts an easing function and returns a new one that outputs reversed values.
// Turns easeIn into easeOut.
const $00e1a8b2dd3e9bbc$export$2c07eeff45156d4d = (easing)=>(p)=>1 - easing(1 - p);


const $fefb9f2108604c18$export$e444123e42d03385 = (p)=>1 - Math.sin(Math.acos(p));
const $fefb9f2108604c18$export$c8d67a19199d1a50 = (0, $00e1a8b2dd3e9bbc$export$2c07eeff45156d4d)($fefb9f2108604c18$export$e444123e42d03385);
const $fefb9f2108604c18$export$30d3455eee55bed5 = (0, $7570a191f3c94b31$export$f946554fb8aeaf0d)($fefb9f2108604c18$export$e444123e42d03385);





const $1842475697f9ee9b$export$77edfce482316a60 = /*@__PURE__*/ (0, $a263c687dd63c6c5$export$2c575fa1d20488bd)(0.33, 1.53, 0.69, 0.99);
const $1842475697f9ee9b$export$b01116c84cdfe1a2 = /*@__PURE__*/ (0, $00e1a8b2dd3e9bbc$export$2c07eeff45156d4d)($1842475697f9ee9b$export$77edfce482316a60);
const $1842475697f9ee9b$export$ddc5fd596f6c71b2 = /*@__PURE__*/ (0, $7570a191f3c94b31$export$f946554fb8aeaf0d)($1842475697f9ee9b$export$b01116c84cdfe1a2);



const $49ff884946fb36c8$export$6b0af63b873d419e = (p)=>(p *= 2) < 1 ? 0.5 * (0, $1842475697f9ee9b$export$b01116c84cdfe1a2)(p) : 0.5 * (2 - Math.pow(2, -10 * (p - 1)));


const $6fcfc72f21f48ad3$var$easingLookup = {
    linear: (0, $c90734627ed96e3f$export$8793edee2d425525),
    easeIn: $a3d2a640a7819290$export$929e5a82286172a6,
    easeInOut: $a3d2a640a7819290$export$c07234257a03d5e9,
    easeOut: $a3d2a640a7819290$export$57636bb43b1ccbb0,
    circIn: $fefb9f2108604c18$export$e444123e42d03385,
    circInOut: $fefb9f2108604c18$export$30d3455eee55bed5,
    circOut: $fefb9f2108604c18$export$c8d67a19199d1a50,
    backIn: $1842475697f9ee9b$export$b01116c84cdfe1a2,
    backInOut: $1842475697f9ee9b$export$ddc5fd596f6c71b2,
    backOut: $1842475697f9ee9b$export$77edfce482316a60,
    anticipate: $49ff884946fb36c8$export$6b0af63b873d419e
};
const $6fcfc72f21f48ad3$export$ef97fe084f156ca4 = (definition)=>{
    if (Array.isArray(definition)) {
        // If cubic bezier definition, create bezier curve
        (0, $2b9100c03bd61cb5$export$f5708dca728d7177)(definition.length === 4, `Cubic bezier arrays must contain four numerical values.`);
        const [x1, y1, x2, y2] = definition;
        return (0, $a263c687dd63c6c5$export$2c575fa1d20488bd)(x1, y1, x2, y2);
    } else if (typeof definition === "string") {
        // Else lookup from table
        (0, $2b9100c03bd61cb5$export$f5708dca728d7177)($6fcfc72f21f48ad3$var$easingLookup[definition] !== undefined, `Invalid easing type '${definition}'`);
        return $6fcfc72f21f48ad3$var$easingLookup[definition];
    }
    return definition;
};




/**
 * Pipe
 * Compose other transformers to run linearily
 * pipe(min(20), max(40))
 * @param  {...functions} transformers
 * @return {function}
 */ const $a510fe5631c50899$var$combineFunctions = (a, b)=>(v)=>b(a(v));
const $a510fe5631c50899$export$a4627e546088548d = (...transformers)=>transformers.reduce($a510fe5631c50899$var$combineFunctions);


/*
  Progress within given range

  Given a lower limit and an upper limit, we return the progress
  (expressed as a number 0-1) represented by the given value, and
  limit that progress to within 0-1.

  @param [number]: Lower limit
  @param [number]: Upper limit
  @param [number]: Value to find progress within given range
  @return [number]: Progress of value within range as expressed 0-1
*/ const $482d3e1965098f2a$export$504d7abb21fa8c9 = (from, to, value)=>{
    const toFromDifference = to - from;
    return toFromDifference === 0 ? 1 : (value - from) / toFromDifference;
};



/*
  Value in range from progress

  Given a lower limit and an upper limit, we return the value within
  that range as expressed by progress (usually a number from 0 to 1)

  So progress = 0.5 would change

  from -------- to

  to

  from ---- to

  E.g. from = 10, to = 20, progress = 0.5 => 15

  @param [number]: Lower limit of range
  @param [number]: Upper limit of range
  @param [number]: The progress between lower and upper limits expressed 0-1
  @return [number]: Value as calculated from progress within range (not limited within range)
*/ const $4defff8a09cc16c4$export$3bb0b4ff1037b8dd = (from, to, progress)=>{
    return from + (to - from) * progress;
};




// Adapted from https://gist.github.com/mjackson/5311256
function $eab0eb3f5b7dcae9$var$hueToRgb(p, q, t) {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * 6 * t;
    if (t < 0.5) return q;
    if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
    return p;
}
function $eab0eb3f5b7dcae9$export$6ae64dbcd6bfc33e({ hue: hue, saturation: saturation, lightness: lightness, alpha: alpha }) {
    hue /= 360;
    saturation /= 100;
    lightness /= 100;
    let red = 0;
    let green = 0;
    let blue = 0;
    if (!saturation) red = green = blue = lightness;
    else {
        const q = lightness < 0.5 ? lightness * (1 + saturation) : lightness + saturation - lightness * saturation;
        const p = 2 * lightness - q;
        red = $eab0eb3f5b7dcae9$var$hueToRgb(p, q, hue + 1 / 3);
        green = $eab0eb3f5b7dcae9$var$hueToRgb(p, q, hue);
        blue = $eab0eb3f5b7dcae9$var$hueToRgb(p, q, hue - 1 / 3);
    }
    return {
        red: Math.round(red * 255),
        green: Math.round(green * 255),
        blue: Math.round(blue * 255),
        alpha: alpha
    };
}





function $f209ea4761c1391b$export$a6f92d4bae65c0f1(a, b) {
    return (p)=>p > 0 ? b : a;
}


// Linear color space blending
// Explained https://www.youtube.com/watch?v=LKnqECcg6Gw
// Demonstrated http://codepen.io/osublake/pen/xGVVaN
const $386cd07540afa3bb$export$d4ecea248cce73c = (from, to, v)=>{
    const fromExpo = from * from;
    const expo = v * (to * to - fromExpo) + fromExpo;
    return expo < 0 ? 0 : Math.sqrt(expo);
};
const $386cd07540afa3bb$var$colorTypes = [
    (0, $d72f3ee0fc88882a$export$834dfc94dde4b3d8),
    (0, $72a82e60c8da202c$export$4e46ac54fc82cf3b),
    (0, $62184c9fdaf92bae$export$810b04175080204c)
];
const $386cd07540afa3bb$var$getColorType = (v)=>$386cd07540afa3bb$var$colorTypes.find((type)=>type.test(v));
function $386cd07540afa3bb$var$asRGBA(color) {
    const type = $386cd07540afa3bb$var$getColorType(color);
    (0, $2b9100c03bd61cb5$export$491112666e282270)(Boolean(type), `'${color}' is not an animatable color. Use the equivalent color code instead.`);
    if (!Boolean(type)) return false;
    let model = type.parse(color);
    if (type === (0, $62184c9fdaf92bae$export$810b04175080204c)) // TODO Remove this cast - needed since Framer Motion's stricter typing
    model = (0, $eab0eb3f5b7dcae9$export$6ae64dbcd6bfc33e)(model);
    return model;
}
const $386cd07540afa3bb$export$51e568cf5c039bac = (from, to)=>{
    const fromRGBA = $386cd07540afa3bb$var$asRGBA(from);
    const toRGBA = $386cd07540afa3bb$var$asRGBA(to);
    if (!fromRGBA || !toRGBA) return (0, $f209ea4761c1391b$export$a6f92d4bae65c0f1)(from, to);
    const blended = {
        ...fromRGBA
    };
    return (v)=>{
        blended.red = $386cd07540afa3bb$export$d4ecea248cce73c(fromRGBA.red, toRGBA.red, v);
        blended.green = $386cd07540afa3bb$export$d4ecea248cce73c(fromRGBA.green, toRGBA.green, v);
        blended.blue = $386cd07540afa3bb$export$d4ecea248cce73c(fromRGBA.blue, toRGBA.blue, v);
        blended.alpha = (0, $4defff8a09cc16c4$export$3bb0b4ff1037b8dd)(fromRGBA.alpha, toRGBA.alpha, v);
        return (0, $72a82e60c8da202c$export$4e46ac54fc82cf3b).transform(blended);
    };
};







const $f0008624fb6aaa61$export$e5a55ae567dd4ac7 = new Set([
    "none",
    "hidden"
]);
/**
 * Returns a function that, when provided a progress value between 0 and 1,
 * will return the "none" or "hidden" string only when the progress is that of
 * the origin or target.
 */ function $f0008624fb6aaa61$export$fed62ccc3fb1a568(origin, target) {
    if ($f0008624fb6aaa61$export$e5a55ae567dd4ac7.has(origin)) return (p)=>p <= 0 ? origin : target;
    else return (p)=>p >= 1 ? target : origin;
}



function $27c586932f07923b$var$mixNumber(a, b) {
    return (p)=>(0, $4defff8a09cc16c4$export$3bb0b4ff1037b8dd)(a, b, p);
}
function $27c586932f07923b$export$36ec24672cd098e0(a) {
    if (typeof a === "number") return $27c586932f07923b$var$mixNumber;
    else if (typeof a === "string") return (0, $7b632f63647c186c$export$31f9caa2600b5723)(a) ? (0, $f209ea4761c1391b$export$a6f92d4bae65c0f1) : (0, $7028c17a7a695b13$export$35e9368ef982300f).test(a) ? (0, $386cd07540afa3bb$export$51e568cf5c039bac) : $27c586932f07923b$export$65516310a87d8205;
    else if (Array.isArray(a)) return $27c586932f07923b$export$3bbefa2f402845c4;
    else if (typeof a === "object") return (0, $7028c17a7a695b13$export$35e9368ef982300f).test(a) ? (0, $386cd07540afa3bb$export$51e568cf5c039bac) : $27c586932f07923b$export$ebc23b6840c51ba1;
    return 0, $f209ea4761c1391b$export$a6f92d4bae65c0f1;
}
function $27c586932f07923b$export$3bbefa2f402845c4(a, b) {
    const output = [
        ...a
    ];
    const numValues = output.length;
    const blendValue = a.map((v, i)=>$27c586932f07923b$export$36ec24672cd098e0(v)(v, b[i]));
    return (p)=>{
        for(let i = 0; i < numValues; i++)output[i] = blendValue[i](p);
        return output;
    };
}
function $27c586932f07923b$export$ebc23b6840c51ba1(a, b) {
    const output = {
        ...a,
        ...b
    };
    const blendValue = {};
    for(const key in output)if (a[key] !== undefined && b[key] !== undefined) blendValue[key] = $27c586932f07923b$export$36ec24672cd098e0(a[key])(a[key], b[key]);
    return (v)=>{
        for(const key in blendValue)output[key] = blendValue[key](v);
        return output;
    };
}
function $27c586932f07923b$var$matchOrder(origin, target) {
    var _a;
    const orderedOrigin = [];
    const pointers = {
        color: 0,
        var: 0,
        number: 0
    };
    for(let i = 0; i < target.values.length; i++){
        const type = target.types[i];
        const originIndex = origin.indexes[type][pointers[type]];
        const originValue = (_a = origin.values[originIndex]) !== null && _a !== void 0 ? _a : 0;
        orderedOrigin[i] = originValue;
        pointers[type]++;
    }
    return orderedOrigin;
}
const $27c586932f07923b$export$65516310a87d8205 = (origin, target)=>{
    const template = (0, $4c282419bf833d7f$export$83a0e34f1302825b).createTransformer(target);
    const originStats = (0, $4c282419bf833d7f$export$b61fc7c44bf646d5)(origin);
    const targetStats = (0, $4c282419bf833d7f$export$b61fc7c44bf646d5)(target);
    const canInterpolate = originStats.indexes.var.length === targetStats.indexes.var.length && originStats.indexes.color.length === targetStats.indexes.color.length && originStats.indexes.number.length >= targetStats.indexes.number.length;
    if (canInterpolate) {
        if ((0, $f0008624fb6aaa61$export$e5a55ae567dd4ac7).has(origin) && !targetStats.values.length || (0, $f0008624fb6aaa61$export$e5a55ae567dd4ac7).has(target) && !originStats.values.length) return (0, $f0008624fb6aaa61$export$fed62ccc3fb1a568)(origin, target);
        return (0, $a510fe5631c50899$export$a4627e546088548d)($27c586932f07923b$export$3bbefa2f402845c4($27c586932f07923b$var$matchOrder(originStats, targetStats), targetStats.values), template);
    } else {
        (0, $2b9100c03bd61cb5$export$491112666e282270)(true, `Complex values '${origin}' and '${target}' too different to mix. Ensure all colors are of the same type, and that each contains the same quantity of number and color values. Falling back to instant transition.`);
        return (0, $f209ea4761c1391b$export$a6f92d4bae65c0f1)(origin, target);
    }
};



function $272f05917dcf54fe$export$2c9e8a9632a706b2(from, to, p) {
    if (typeof from === "number" && typeof to === "number" && typeof p === "number") return (0, $4defff8a09cc16c4$export$3bb0b4ff1037b8dd)(from, to, p);
    const mixer = (0, $27c586932f07923b$export$36ec24672cd098e0)(from);
    return mixer(from, to);
}


function $5afc3475e21af585$var$createMixers(output, ease, customMixer) {
    const mixers = [];
    const mixerFactory = customMixer || (0, $272f05917dcf54fe$export$2c9e8a9632a706b2);
    const numMixers = output.length - 1;
    for(let i = 0; i < numMixers; i++){
        let mixer = mixerFactory(output[i], output[i + 1]);
        if (ease) {
            const easingFunction = Array.isArray(ease) ? ease[i] || (0, $c90734627ed96e3f$export$8793edee2d425525) : ease;
            mixer = (0, $a510fe5631c50899$export$a4627e546088548d)(easingFunction, mixer);
        }
        mixers.push(mixer);
    }
    return mixers;
}
/**
 * Create a function that maps from a numerical input array to a generic output array.
 *
 * Accepts:
 *   - Numbers
 *   - Colors (hex, hsl, hsla, rgb, rgba)
 *   - Complex (combinations of one or more numbers or strings)
 *
 * ```jsx
 * const mixColor = interpolate([0, 1], ['#fff', '#000'])
 *
 * mixColor(0.5) // 'rgba(128, 128, 128, 1)'
 * ```
 *
 * TODO Revist this approach once we've moved to data models for values,
 * probably not needed to pregenerate mixer functions.
 *
 * @public
 */ function $5afc3475e21af585$export$89e29e4ab65e70a9(input, output, { clamp: isClamp = true, ease: ease, mixer: mixer } = {}) {
    const inputLength = input.length;
    (0, $2b9100c03bd61cb5$export$f5708dca728d7177)(inputLength === output.length, "Both input and output ranges must be the same length");
    /**
     * If we're only provided a single input, we can just make a function
     * that returns the output.
     */ if (inputLength === 1) return ()=>output[0];
    if (inputLength === 2 && input[0] === input[1]) return ()=>output[1];
    // If input runs highest -> lowest, reverse both arrays
    if (input[0] > input[inputLength - 1]) {
        input = [
            ...input
        ].reverse();
        output = [
            ...output
        ].reverse();
    }
    const mixers = $5afc3475e21af585$var$createMixers(output, ease, mixer);
    const numMixers = mixers.length;
    const interpolator = (v)=>{
        let i = 0;
        if (numMixers > 1) for(; i < input.length - 2; i++){
            if (v < input[i + 1]) break;
        }
        const progressInRange = (0, $482d3e1965098f2a$export$504d7abb21fa8c9)(input[i], input[i + 1], v);
        return mixers[i](progressInRange);
    };
    return isClamp ? (v)=>interpolator((0, $b64a5fb8aaa910d9$export$7d15b64cf5a3a4c4)(input[0], input[inputLength - 1], v)) : interpolator;
}




function $90bfe69fb9e7beb2$export$dafee61230cf05c6(offset, remaining) {
    const min = offset[offset.length - 1];
    for(let i = 1; i <= remaining; i++){
        const offsetProgress = (0, $482d3e1965098f2a$export$504d7abb21fa8c9)(0, remaining, i);
        offset.push((0, $4defff8a09cc16c4$export$3bb0b4ff1037b8dd)(min, 1, offsetProgress));
    }
}


function $8866a142868d9f49$export$24dbcec0b26e6d9d(arr) {
    const offset = [
        0
    ];
    (0, $90bfe69fb9e7beb2$export$dafee61230cf05c6)(offset, arr.length - 1);
    return offset;
}


function $a5ba9f2c64b839e4$export$2a91b4e3a4539316(offset, duration) {
    return offset.map((o)=>o * duration);
}


function $d4f03167cf0fe9a0$export$6b60b58e4ea7d715(values, easing) {
    return values.map(()=>easing || (0, $a3d2a640a7819290$export$c07234257a03d5e9)).splice(0, values.length - 1);
}
function $d4f03167cf0fe9a0$export$d25ddfdf17c3ad3e({ duration: duration = 300, keyframes: keyframeValues, times: times, ease: ease = "easeInOut" }) {
    /**
     * Easing functions can be externally defined as strings. Here we convert them
     * into actual functions.
     */ const easingFunctions = (0, $cdb960b4abd00d82$export$216948827bbdc797)(ease) ? ease.map((0, $6fcfc72f21f48ad3$export$ef97fe084f156ca4)) : (0, $6fcfc72f21f48ad3$export$ef97fe084f156ca4)(ease);
    /**
     * This is the Iterator-spec return value. We ensure it's mutable rather than using a generator
     * to reduce GC during animation.
     */ const state = {
        done: false,
        value: keyframeValues[0]
    };
    /**
     * Create a times array based on the provided 0-1 offsets
     */ const absoluteTimes = (0, $a5ba9f2c64b839e4$export$2a91b4e3a4539316)(// Only use the provided offsets if they're the correct length
    // TODO Maybe we should warn here if there's a length mismatch
    times && times.length === keyframeValues.length ? times : (0, $8866a142868d9f49$export$24dbcec0b26e6d9d)(keyframeValues), duration);
    const mapTimeToKeyframe = (0, $5afc3475e21af585$export$89e29e4ab65e70a9)(absoluteTimes, keyframeValues, {
        ease: Array.isArray(easingFunctions) ? easingFunctions : $d4f03167cf0fe9a0$export$6b60b58e4ea7d715(keyframeValues, easingFunctions)
    });
    return {
        calculatedDuration: duration,
        next: (t)=>{
            state.value = mapTimeToKeyframe(t);
            state.done = t >= duration;
            return state;
        }
    };
}





/**
 * Implement a practical max duration for keyframe generation
 * to prevent infinite loops
 */ const $63989eadef3836dd$export$f4ff70a5b4808fd8 = 20000;
function $63989eadef3836dd$export$cbdd6b3d40ea54e2(generator) {
    let duration = 0;
    const timeStep = 50;
    let state = generator.next(duration);
    while(!state.done && duration < $63989eadef3836dd$export$f4ff70a5b4808fd8){
        duration += timeStep;
        state = generator.next(duration);
    }
    return duration >= $63989eadef3836dd$export$f4ff70a5b4808fd8 ? Infinity : duration;
}







const $305de1905df24e19$export$c1033964b5ad7fef = (update)=>{
    const passTimestamp = ({ timestamp: timestamp })=>update(timestamp);
    return {
        start: ()=>(0, $2668c8a722676613$export$2cef06c20297c17d).update(passTimestamp, true),
        stop: ()=>(0, $2668c8a722676613$export$ec99c0ef4978dccb)(passTimestamp),
        /**
         * If we're processing this frame we can use the
         * framelocked timestamp to keep things in sync.
         */ now: ()=>(0, $2668c8a722676613$export$fff89137e9e818ce).isProcessing ? (0, $2668c8a722676613$export$fff89137e9e818ce).timestamp : (0, $3a6da39b219d0ac7$export$2da9be4cfdb689b1).now()
    };
};



const $6a91611bc4894f12$var$generators = {
    decay: (0, $d3675ca8f6e28248$export$ee3ff3a17106998),
    inertia: $d3675ca8f6e28248$export$ee3ff3a17106998,
    tween: (0, $d4f03167cf0fe9a0$export$d25ddfdf17c3ad3e),
    keyframes: (0, $d4f03167cf0fe9a0$export$d25ddfdf17c3ad3e),
    spring: $f2ee4de28e47ead0$export$b36281d89752ae66
};
const $6a91611bc4894f12$var$percentToProgress = (percent)=>percent / 100;
/**
 * Animation that runs on the main thread. Designed to be WAAPI-spec in the subset of
 * features we expose publically. Mostly the compatibility is to ensure visual identity
 * between both WAAPI and main thread animations.
 */ class $6a91611bc4894f12$export$fd98d9cca67a58bc extends (0, $e933a795f7f32123$export$d1e4f34b9c2550c1) {
    constructor(options){
        super(options);
        /**
         * The time at which the animation was paused.
         */ this.holdTime = null;
        /**
         * The time at which the animation was cancelled.
         */ this.cancelTime = null;
        /**
         * The current time of the animation.
         */ this.currentTime = 0;
        /**
         * Playback speed as a factor. 0 would be stopped, -1 reverse and 2 double speed.
         */ this.playbackSpeed = 1;
        /**
         * The state of the animation to apply when the animation is resolved. This
         * allows calls to the public API to control the animation before it is resolved,
         * without us having to resolve it first.
         */ this.pendingPlayState = "running";
        /**
         * The time at which the animation was started.
         */ this.startTime = null;
        this.state = "idle";
        /**
         * This method is bound to the instance to fix a pattern where
         * animation.stop is returned as a reference from a useEffect.
         */ this.stop = ()=>{
            this.resolver.cancel();
            this.isStopped = true;
            if (this.state === "idle") return;
            this.teardown();
            const { onStop: onStop } = this.options;
            onStop && onStop();
        };
        const { name: name, motionValue: motionValue, element: element, keyframes: keyframes } = this.options;
        const KeyframeResolver$1 = (element === null || element === void 0 ? void 0 : element.KeyframeResolver) || (0, $b1026f81549deb9c$export$74d34ca3182f1750);
        const onResolved = (resolvedKeyframes, finalKeyframe)=>this.onKeyframesResolved(resolvedKeyframes, finalKeyframe);
        this.resolver = new KeyframeResolver$1(keyframes, onResolved, name, motionValue, element);
        this.resolver.scheduleResolve();
    }
    initPlayback(keyframes$1) {
        const { type: type = "keyframes", repeat: repeat = 0, repeatDelay: repeatDelay = 0, repeatType: repeatType, velocity: velocity = 0 } = this.options;
        const generatorFactory = $6a91611bc4894f12$var$generators[type] || (0, $d4f03167cf0fe9a0$export$d25ddfdf17c3ad3e);
        /**
         * If our generator doesn't support mixing numbers, we need to replace keyframes with
         * [0, 100] and then make a function that maps that to the actual keyframes.
         *
         * 100 is chosen instead of 1 as it works nicer with spring animations.
         */ let mapPercentToKeyframes;
        let mirroredGenerator;
        if (generatorFactory !== (0, $d4f03167cf0fe9a0$export$d25ddfdf17c3ad3e) && typeof keyframes$1[0] !== "number") {
            mapPercentToKeyframes = (0, $a510fe5631c50899$export$a4627e546088548d)($6a91611bc4894f12$var$percentToProgress, (0, $272f05917dcf54fe$export$2c9e8a9632a706b2)(keyframes$1[0], keyframes$1[1]));
            keyframes$1 = [
                0,
                100
            ];
        }
        const generator = generatorFactory({
            ...this.options,
            keyframes: keyframes$1
        });
        /**
         * If we have a mirror repeat type we need to create a second generator that outputs the
         * mirrored (not reversed) animation and later ping pong between the two generators.
         */ if (repeatType === "mirror") mirroredGenerator = generatorFactory({
            ...this.options,
            keyframes: [
                ...keyframes$1
            ].reverse(),
            velocity: -velocity
        });
        /**
         * If duration is undefined and we have repeat options,
         * we need to calculate a duration from the generator.
         *
         * We set it to the generator itself to cache the duration.
         * Any timeline resolver will need to have already precalculated
         * the duration by this step.
         */ if (generator.calculatedDuration === null) generator.calculatedDuration = (0, $63989eadef3836dd$export$cbdd6b3d40ea54e2)(generator);
        const { calculatedDuration: calculatedDuration } = generator;
        const resolvedDuration = calculatedDuration + repeatDelay;
        const totalDuration = resolvedDuration * (repeat + 1) - repeatDelay;
        return {
            generator: generator,
            mirroredGenerator: mirroredGenerator,
            mapPercentToKeyframes: mapPercentToKeyframes,
            calculatedDuration: calculatedDuration,
            resolvedDuration: resolvedDuration,
            totalDuration: totalDuration
        };
    }
    onPostResolved() {
        const { autoplay: autoplay = true } = this.options;
        this.play();
        if (this.pendingPlayState === "paused" || !autoplay) this.pause();
        else this.state = this.pendingPlayState;
    }
    tick(timestamp, sample = false) {
        const { resolved: resolved } = this;
        // If the animations has failed to resolve, return the final keyframe.
        if (!resolved) {
            const { keyframes: keyframes } = this.options;
            return {
                done: true,
                value: keyframes[keyframes.length - 1]
            };
        }
        const { finalKeyframe: finalKeyframe, generator: generator, mirroredGenerator: mirroredGenerator, mapPercentToKeyframes: mapPercentToKeyframes, keyframes: keyframes, calculatedDuration: calculatedDuration, totalDuration: totalDuration, resolvedDuration: resolvedDuration } = resolved;
        if (this.startTime === null) return generator.next(0);
        const { delay: delay, repeat: repeat, repeatType: repeatType, repeatDelay: repeatDelay, onUpdate: onUpdate } = this.options;
        /**
         * requestAnimationFrame timestamps can come through as lower than
         * the startTime as set by performance.now(). Here we prevent this,
         * though in the future it could be possible to make setting startTime
         * a pending operation that gets resolved here.
         */ if (this.speed > 0) this.startTime = Math.min(this.startTime, timestamp);
        else if (this.speed < 0) this.startTime = Math.min(timestamp - totalDuration / this.speed, this.startTime);
        // Update currentTime
        if (sample) this.currentTime = timestamp;
        else if (this.holdTime !== null) this.currentTime = this.holdTime;
        else // Rounding the time because floating point arithmetic is not always accurate, e.g. 3000.367 - 1000.367 =
        // 2000.0000000000002. This is a problem when we are comparing the currentTime with the duration, for
        // example.
        this.currentTime = Math.round(timestamp - this.startTime) * this.speed;
        // Rebase on delay
        const timeWithoutDelay = this.currentTime - delay * (this.speed >= 0 ? 1 : -1);
        const isInDelayPhase = this.speed >= 0 ? timeWithoutDelay < 0 : timeWithoutDelay > totalDuration;
        this.currentTime = Math.max(timeWithoutDelay, 0);
        // If this animation has finished, set the current time  to the total duration.
        if (this.state === "finished" && this.holdTime === null) this.currentTime = totalDuration;
        let elapsed = this.currentTime;
        let frameGenerator = generator;
        if (repeat) {
            /**
             * Get the current progress (0-1) of the animation. If t is >
             * than duration we'll get values like 2.5 (midway through the
             * third iteration)
             */ const progress = Math.min(this.currentTime, totalDuration) / resolvedDuration;
            /**
             * Get the current iteration (0 indexed). For instance the floor of
             * 2.5 is 2.
             */ let currentIteration = Math.floor(progress);
            /**
             * Get the current progress of the iteration by taking the remainder
             * so 2.5 is 0.5 through iteration 2
             */ let iterationProgress = progress % 1.0;
            /**
             * If iteration progress is 1 we count that as the end
             * of the previous iteration.
             */ if (!iterationProgress && progress >= 1) iterationProgress = 1;
            iterationProgress === 1 && currentIteration--;
            currentIteration = Math.min(currentIteration, repeat + 1);
            /**
             * Reverse progress if we're not running in "normal" direction
             */ const isOddIteration = Boolean(currentIteration % 2);
            if (isOddIteration) {
                if (repeatType === "reverse") {
                    iterationProgress = 1 - iterationProgress;
                    if (repeatDelay) iterationProgress -= repeatDelay / resolvedDuration;
                } else if (repeatType === "mirror") frameGenerator = mirroredGenerator;
            }
            elapsed = (0, $b64a5fb8aaa910d9$export$7d15b64cf5a3a4c4)(0, 1, iterationProgress) * resolvedDuration;
        }
        /**
         * If we're in negative time, set state as the initial keyframe.
         * This prevents delay: x, duration: 0 animations from finishing
         * instantly.
         */ const state = isInDelayPhase ? {
            done: false,
            value: keyframes[0]
        } : frameGenerator.next(elapsed);
        if (mapPercentToKeyframes) state.value = mapPercentToKeyframes(state.value);
        let { done: done } = state;
        if (!isInDelayPhase && calculatedDuration !== null) done = this.speed >= 0 ? this.currentTime >= totalDuration : this.currentTime <= 0;
        const isAnimationFinished = this.holdTime === null && (this.state === "finished" || this.state === "running" && done);
        if (isAnimationFinished && finalKeyframe !== undefined) state.value = (0, $3ca01ac9e8cf1f66$export$14de59408fad90b)(keyframes, this.options, finalKeyframe);
        if (onUpdate) onUpdate(state.value);
        if (isAnimationFinished) this.finish();
        return state;
    }
    get duration() {
        const { resolved: resolved } = this;
        return resolved ? (0, $64e5667fa478a387$export$f64c3bfbc58eec0f)(resolved.calculatedDuration) : 0;
    }
    get time() {
        return (0, $64e5667fa478a387$export$f64c3bfbc58eec0f)(this.currentTime);
    }
    set time(newTime) {
        newTime = (0, $64e5667fa478a387$export$fc3e7e8557f8c8c7)(newTime);
        this.currentTime = newTime;
        if (this.holdTime !== null || this.speed === 0) this.holdTime = newTime;
        else if (this.driver) this.startTime = this.driver.now() - newTime / this.speed;
    }
    get speed() {
        return this.playbackSpeed;
    }
    set speed(newSpeed) {
        const hasChanged = this.playbackSpeed !== newSpeed;
        this.playbackSpeed = newSpeed;
        if (hasChanged) this.time = (0, $64e5667fa478a387$export$f64c3bfbc58eec0f)(this.currentTime);
    }
    play() {
        if (!this.resolver.isScheduled) this.resolver.resume();
        if (!this._resolved) {
            this.pendingPlayState = "running";
            return;
        }
        if (this.isStopped) return;
        const { driver: driver = (0, $305de1905df24e19$export$c1033964b5ad7fef), onPlay: onPlay, startTime: startTime } = this.options;
        if (!this.driver) this.driver = driver((timestamp)=>this.tick(timestamp));
        onPlay && onPlay();
        const now = this.driver.now();
        if (this.holdTime !== null) this.startTime = now - this.holdTime;
        else if (!this.startTime) this.startTime = startTime !== null && startTime !== void 0 ? startTime : this.calcStartTime();
        else if (this.state === "finished") this.startTime = now;
        if (this.state === "finished") this.updateFinishedPromise();
        this.cancelTime = this.startTime;
        this.holdTime = null;
        /**
         * Set playState to running only after we've used it in
         * the previous logic.
         */ this.state = "running";
        this.driver.start();
    }
    pause() {
        var _a;
        if (!this._resolved) {
            this.pendingPlayState = "paused";
            return;
        }
        this.state = "paused";
        this.holdTime = (_a = this.currentTime) !== null && _a !== void 0 ? _a : 0;
    }
    complete() {
        if (this.state !== "running") this.play();
        this.pendingPlayState = this.state = "finished";
        this.holdTime = null;
    }
    finish() {
        this.teardown();
        this.state = "finished";
        const { onComplete: onComplete } = this.options;
        onComplete && onComplete();
    }
    cancel() {
        if (this.cancelTime !== null) this.tick(this.cancelTime);
        this.teardown();
        this.updateFinishedPromise();
    }
    teardown() {
        this.state = "idle";
        this.stopDriver();
        this.resolveFinishedPromise();
        this.updateFinishedPromise();
        this.startTime = this.cancelTime = null;
        this.resolver.cancel();
    }
    stopDriver() {
        if (!this.driver) return;
        this.driver.stop();
        this.driver = undefined;
    }
    sample(time) {
        this.startTime = 0;
        return this.tick(time, true);
    }
}
// Legacy interface
function $6a91611bc4894f12$export$ee9b76de7353d815(options) {
    return new $6a91611bc4894f12$export$fd98d9cca67a58bc(options);
}


/**
 * A list of values that can be hardware-accelerated.
 */ const $172b3a0adea9e962$export$a27eefbd8fb5e404 = new Set([
    "opacity",
    "clipPath",
    "filter",
    "transform"
]);


const $3fcf0b2fb191c4b5$export$ff43f99925d7366b = (easing)=>Array.isArray(easing) && typeof easing[0] === "number";


function $0e0db63839e02520$export$fcdd8f3f2160beda(easing) {
    return Boolean(!easing || typeof easing === "string" && easing in $0e0db63839e02520$export$2cf569f5e2221176 || (0, $3fcf0b2fb191c4b5$export$ff43f99925d7366b)(easing) || Array.isArray(easing) && easing.every($0e0db63839e02520$export$fcdd8f3f2160beda));
}
const $0e0db63839e02520$export$2523b8f0bd8f44cb = ([a, b, c, d])=>`cubic-bezier(${a}, ${b}, ${c}, ${d})`;
const $0e0db63839e02520$export$2cf569f5e2221176 = {
    linear: "linear",
    ease: "ease",
    easeIn: "ease-in",
    easeOut: "ease-out",
    easeInOut: "ease-in-out",
    circIn: /*@__PURE__*/ $0e0db63839e02520$export$2523b8f0bd8f44cb([
        0,
        0.65,
        0.55,
        1
    ]),
    circOut: /*@__PURE__*/ $0e0db63839e02520$export$2523b8f0bd8f44cb([
        0.55,
        0,
        1,
        0.45
    ]),
    backIn: /*@__PURE__*/ $0e0db63839e02520$export$2523b8f0bd8f44cb([
        0.31,
        0.01,
        0.66,
        -0.59
    ]),
    backOut: /*@__PURE__*/ $0e0db63839e02520$export$2523b8f0bd8f44cb([
        0.33,
        1.53,
        0.69,
        0.99
    ])
};
function $0e0db63839e02520$var$mapEasingToNativeEasingWithDefault(easing) {
    return $0e0db63839e02520$export$916ea73bcd3a6030(easing) || $0e0db63839e02520$export$2cf569f5e2221176.easeOut;
}
function $0e0db63839e02520$export$916ea73bcd3a6030(easing) {
    if (!easing) return undefined;
    else if ((0, $3fcf0b2fb191c4b5$export$ff43f99925d7366b)(easing)) return $0e0db63839e02520$export$2523b8f0bd8f44cb(easing);
    else if (Array.isArray(easing)) return easing.map($0e0db63839e02520$var$mapEasingToNativeEasingWithDefault);
    else return $0e0db63839e02520$export$2cf569f5e2221176[easing];
}


function $804e3d24c23afefa$export$c76cd972d26986f9(element, valueName, keyframes, { delay: delay = 0, duration: duration = 300, repeat: repeat = 0, repeatType: repeatType = "loop", ease: ease, times: times } = {}) {
    const keyframeOptions = {
        [valueName]: keyframes
    };
    if (times) keyframeOptions.offset = times;
    const easing = (0, $0e0db63839e02520$export$916ea73bcd3a6030)(ease);
    /**
     * If this is an easing array, apply to keyframes, not animation as a whole
     */ if (Array.isArray(easing)) keyframeOptions.easing = easing;
    return element.animate(keyframeOptions, {
        delay: delay,
        duration: duration,
        easing: !Array.isArray(easing) ? easing : "linear",
        fill: "both",
        iterations: repeat + 1,
        direction: repeatType === "reverse" ? "alternate" : "normal"
    });
}




const $7f14ff9d0367db28$var$supportsWaapi = /*@__PURE__*/ (0, $134d1d2e49b301fc$export$7c73462e0d25e514)(()=>Object.hasOwnProperty.call(Element.prototype, "animate"));
/**
 * 10ms is chosen here as it strikes a balance between smooth
 * results (more than one keyframe per frame at 60fps) and
 * keyframe quantity.
 */ const $7f14ff9d0367db28$var$sampleDelta = 10; //ms
/**
 * Implement a practical max duration for keyframe generation
 * to prevent infinite loops
 */ const $7f14ff9d0367db28$var$maxDuration = 20000;
/**
 * Check if an animation can run natively via WAAPI or requires pregenerated keyframes.
 * WAAPI doesn't support spring or function easings so we run these as JS animation before
 * handing off.
 */ function $7f14ff9d0367db28$var$requiresPregeneratedKeyframes(options) {
    return options.type === "spring" || !(0, $0e0db63839e02520$export$fcdd8f3f2160beda)(options.ease);
}
function $7f14ff9d0367db28$var$pregenerateKeyframes(keyframes, options) {
    /**
     * Create a main-thread animation to pregenerate keyframes.
     * We sample this at regular intervals to generate keyframes that we then
     * linearly interpolate between.
     */ const sampleAnimation = new (0, $6a91611bc4894f12$export$fd98d9cca67a58bc)({
        ...options,
        keyframes: keyframes,
        repeat: 0,
        delay: 0,
        isGenerator: true
    });
    let state = {
        done: false,
        value: keyframes[0]
    };
    const pregeneratedKeyframes = [];
    /**
     * Bail after 20 seconds of pre-generated keyframes as it's likely
     * we're heading for an infinite loop.
     */ let t = 0;
    while(!state.done && t < $7f14ff9d0367db28$var$maxDuration){
        state = sampleAnimation.sample(t);
        pregeneratedKeyframes.push(state.value);
        t += $7f14ff9d0367db28$var$sampleDelta;
    }
    return {
        times: undefined,
        keyframes: pregeneratedKeyframes,
        duration: t - $7f14ff9d0367db28$var$sampleDelta,
        ease: "linear"
    };
}
class $7f14ff9d0367db28$export$2a45abb4e6513325 extends (0, $e933a795f7f32123$export$d1e4f34b9c2550c1) {
    constructor(options){
        super(options);
        const { name: name, motionValue: motionValue, element: element, keyframes: keyframes } = this.options;
        this.resolver = new (0, $7a5a5700acca8750$export$4983792d11b61017)(keyframes, (resolvedKeyframes, finalKeyframe)=>this.onKeyframesResolved(resolvedKeyframes, finalKeyframe), name, motionValue, element);
        this.resolver.scheduleResolve();
    }
    initPlayback(keyframes, finalKeyframe) {
        var _a;
        let { duration: duration = 300, times: times, ease: ease, type: type, motionValue: motionValue, name: name, startTime: startTime } = this.options;
        /**
         * If element has since been unmounted, return false to indicate
         * the animation failed to initialised.
         */ if (!((_a = motionValue.owner) === null || _a === void 0 ? void 0 : _a.current)) return false;
        /**
         * If this animation needs pre-generated keyframes then generate.
         */ if ($7f14ff9d0367db28$var$requiresPregeneratedKeyframes(this.options)) {
            const { onComplete: onComplete, onUpdate: onUpdate, motionValue: motionValue, element: element, ...options } = this.options;
            const pregeneratedAnimation = $7f14ff9d0367db28$var$pregenerateKeyframes(keyframes, options);
            keyframes = pregeneratedAnimation.keyframes;
            // If this is a very short animation, ensure we have
            // at least two keyframes to animate between as older browsers
            // can't animate between a single keyframe.
            if (keyframes.length === 1) keyframes[1] = keyframes[0];
            duration = pregeneratedAnimation.duration;
            times = pregeneratedAnimation.times;
            ease = pregeneratedAnimation.ease;
            type = "keyframes";
        }
        const animation = (0, $804e3d24c23afefa$export$c76cd972d26986f9)(motionValue.owner.current, name, keyframes, {
            ...this.options,
            duration: duration,
            times: times,
            ease: ease
        });
        // Override the browser calculated startTime with one synchronised to other JS
        // and WAAPI animations starting this event loop.
        animation.startTime = startTime !== null && startTime !== void 0 ? startTime : this.calcStartTime();
        if (this.pendingTimeline) {
            animation.timeline = this.pendingTimeline;
            this.pendingTimeline = undefined;
        } else /**
             * Prefer the `onfinish` prop as it's more widely supported than
             * the `finished` promise.
             *
             * Here, we synchronously set the provided MotionValue to the end
             * keyframe. If we didn't, when the WAAPI animation is finished it would
             * be removed from the element which would then revert to its old styles.
             */ animation.onfinish = ()=>{
            const { onComplete: onComplete } = this.options;
            motionValue.set((0, $3ca01ac9e8cf1f66$export$14de59408fad90b)(keyframes, this.options, finalKeyframe));
            onComplete && onComplete();
            this.cancel();
            this.resolveFinishedPromise();
        };
        return {
            animation: animation,
            duration: duration,
            times: times,
            type: type,
            ease: ease,
            keyframes: keyframes
        };
    }
    get duration() {
        const { resolved: resolved } = this;
        if (!resolved) return 0;
        const { duration: duration } = resolved;
        return (0, $64e5667fa478a387$export$f64c3bfbc58eec0f)(duration);
    }
    get time() {
        const { resolved: resolved } = this;
        if (!resolved) return 0;
        const { animation: animation } = resolved;
        return (0, $64e5667fa478a387$export$f64c3bfbc58eec0f)(animation.currentTime || 0);
    }
    set time(newTime) {
        const { resolved: resolved } = this;
        if (!resolved) return;
        const { animation: animation } = resolved;
        animation.currentTime = (0, $64e5667fa478a387$export$fc3e7e8557f8c8c7)(newTime);
    }
    get speed() {
        const { resolved: resolved } = this;
        if (!resolved) return 1;
        const { animation: animation } = resolved;
        return animation.playbackRate;
    }
    set speed(newSpeed) {
        const { resolved: resolved } = this;
        if (!resolved) return;
        const { animation: animation } = resolved;
        animation.playbackRate = newSpeed;
    }
    get state() {
        const { resolved: resolved } = this;
        if (!resolved) return "idle";
        const { animation: animation } = resolved;
        return animation.playState;
    }
    get startTime() {
        const { resolved: resolved } = this;
        if (!resolved) return null;
        const { animation: animation } = resolved;
        // Coerce to number as TypeScript incorrectly types this
        // as CSSNumberish
        return animation.startTime;
    }
    /**
     * Replace the default DocumentTimeline with another AnimationTimeline.
     * Currently used for scroll animations.
     */ attachTimeline(timeline) {
        if (!this._resolved) this.pendingTimeline = timeline;
        else {
            const { resolved: resolved } = this;
            if (!resolved) return 0, $c90734627ed96e3f$export$8793edee2d425525;
            const { animation: animation } = resolved;
            animation.timeline = timeline;
            animation.onfinish = null;
        }
        return 0, $c90734627ed96e3f$export$8793edee2d425525;
    }
    play() {
        if (this.isStopped) return;
        const { resolved: resolved } = this;
        if (!resolved) return;
        const { animation: animation } = resolved;
        if (animation.playState === "finished") this.updateFinishedPromise();
        animation.play();
    }
    pause() {
        const { resolved: resolved } = this;
        if (!resolved) return;
        const { animation: animation } = resolved;
        animation.pause();
    }
    stop() {
        this.resolver.cancel();
        this.isStopped = true;
        if (this.state === "idle") return;
        this.resolveFinishedPromise();
        this.updateFinishedPromise();
        const { resolved: resolved } = this;
        if (!resolved) return;
        const { animation: animation, keyframes: keyframes, duration: duration, type: type, ease: ease, times: times } = resolved;
        if (animation.playState === "idle" || animation.playState === "finished") return;
        /**
         * WAAPI doesn't natively have any interruption capabilities.
         *
         * Rather than read commited styles back out of the DOM, we can
         * create a renderless JS animation and sample it twice to calculate
         * its current value, "previous" value, and therefore allow
         * Motion to calculate velocity for any subsequent animation.
         */ if (this.time) {
            const { motionValue: motionValue, onUpdate: onUpdate, onComplete: onComplete, element: element, ...options } = this.options;
            const sampleAnimation = new (0, $6a91611bc4894f12$export$fd98d9cca67a58bc)({
                ...options,
                keyframes: keyframes,
                duration: duration,
                type: type,
                ease: ease,
                times: times,
                isGenerator: true
            });
            const sampleTime = (0, $64e5667fa478a387$export$fc3e7e8557f8c8c7)(this.time);
            motionValue.setWithVelocity(sampleAnimation.sample(sampleTime - $7f14ff9d0367db28$var$sampleDelta).value, sampleAnimation.sample(sampleTime).value, $7f14ff9d0367db28$var$sampleDelta);
        }
        const { onStop: onStop } = this.options;
        onStop && onStop();
        this.cancel();
    }
    complete() {
        const { resolved: resolved } = this;
        if (!resolved) return;
        resolved.animation.finish();
    }
    cancel() {
        const { resolved: resolved } = this;
        if (!resolved) return;
        resolved.animation.cancel();
    }
    static supports(options) {
        const { motionValue: motionValue, name: name, repeatDelay: repeatDelay, repeatType: repeatType, damping: damping, type: type } = options;
        return $7f14ff9d0367db28$var$supportsWaapi() && name && (0, $172b3a0adea9e962$export$a27eefbd8fb5e404).has(name) && motionValue && motionValue.owner && motionValue.owner.current instanceof HTMLElement && /**
             * If we're outputting values to onUpdate then we can't use WAAPI as there's
             * no way to read the value from WAAPI every frame.
             */ !motionValue.owner.getProps().onUpdate && !repeatDelay && repeatType !== "mirror" && damping !== 0 && type !== "inertia";
    }
}




function $7879bdc6f40836e5$export$b4f1bbab0c442a76(update, timeline) {
    let prevProgress;
    const onFrame = ()=>{
        const { currentTime: currentTime } = timeline;
        const percentage = currentTime === null ? 0 : currentTime.value;
        const progress = percentage / 100;
        if (prevProgress !== progress) update(progress);
        prevProgress = progress;
    };
    (0, $2668c8a722676613$export$2cef06c20297c17d).update(onFrame, true);
    return ()=>(0, $2668c8a722676613$export$ec99c0ef4978dccb)(onFrame);
}



const $b2ad65e0ee9722e6$export$20d68f04f30763a5 = (0, $134d1d2e49b301fc$export$7c73462e0d25e514)(()=>window.ScrollTimeline !== undefined);


class $ea560ce4dcc095f2$export$c1e41718f71efe41 {
    constructor(animations){
        // Bound to accomodate common `return animation.stop` pattern
        this.stop = ()=>this.runAll("stop");
        this.animations = animations.filter(Boolean);
    }
    then(onResolve, onReject) {
        return Promise.all(this.animations).then(onResolve).catch(onReject);
    }
    /**
     * TODO: Filter out cancelled or stopped animations before returning
     */ getAll(propName) {
        return this.animations[0][propName];
    }
    setAll(propName, newValue) {
        for(let i = 0; i < this.animations.length; i++)this.animations[i][propName] = newValue;
    }
    attachTimeline(timeline) {
        const cancelAll = this.animations.map((animation)=>{
            if ((0, $b2ad65e0ee9722e6$export$20d68f04f30763a5)() && animation.attachTimeline) animation.attachTimeline(timeline);
            else {
                animation.pause();
                return (0, $7879bdc6f40836e5$export$b4f1bbab0c442a76)((progress)=>{
                    animation.time = animation.duration * progress;
                }, timeline);
            }
        });
        return ()=>{
            cancelAll.forEach((cancelTimeline, i)=>{
                if (cancelTimeline) cancelTimeline();
                this.animations[i].stop();
            });
        };
    }
    get time() {
        return this.getAll("time");
    }
    set time(time) {
        this.setAll("time", time);
    }
    get speed() {
        return this.getAll("speed");
    }
    set speed(speed) {
        this.setAll("speed", speed);
    }
    get startTime() {
        return this.getAll("startTime");
    }
    get duration() {
        let max = 0;
        for(let i = 0; i < this.animations.length; i++)max = Math.max(max, this.animations[i].duration);
        return max;
    }
    runAll(methodName) {
        this.animations.forEach((controls)=>controls[methodName]());
    }
    play() {
        this.runAll("play");
    }
    pause() {
        this.runAll("pause");
    }
    cancel() {
        this.runAll("cancel");
    }
    complete() {
        this.runAll("complete");
    }
}


const $30c44ca59ad5e77f$export$90b3dfc33ff3548 = (name, value, target, transition = {}, element, isHandoff, /**
 * Currently used to remove values from will-change when an animation ends.
 * Preferably this would be handled by event listeners on the MotionValue
 * but these aren't consistent enough yet when considering the different ways
 * an animation can be cancelled.
 */ onEnd)=>(onComplete)=>{
        const valueTransition = (0, $453e5e72c39cf7c2$export$7c1391340308742e)(transition, name) || {};
        /**
     * Most transition values are currently completely overwritten by value-specific
     * transitions. In the future it'd be nicer to blend these transitions. But for now
     * delay actually does inherit from the root transition if not value-specific.
     */ const delay = valueTransition.delay || transition.delay || 0;
        /**
     * Elapsed isn't a public transition option but can be passed through from
     * optimized appear effects in milliseconds.
     */ let { elapsed: elapsed = 0 } = transition;
        elapsed = elapsed - (0, $64e5667fa478a387$export$fc3e7e8557f8c8c7)(delay);
        let options = {
            keyframes: Array.isArray(target) ? target : [
                null,
                target
            ],
            ease: "easeOut",
            velocity: value.getVelocity(),
            ...valueTransition,
            delay: -elapsed,
            onUpdate: (v)=>{
                value.set(v);
                valueTransition.onUpdate && valueTransition.onUpdate(v);
            },
            onComplete: ()=>{
                onComplete();
                valueTransition.onComplete && valueTransition.onComplete();
                onEnd && onEnd();
            },
            onStop: onEnd,
            name: name,
            motionValue: value,
            element: isHandoff ? undefined : element
        };
        /**
     * If there's no transition defined for this value, we can generate
     * unqiue transition settings for this value.
     */ if (!(0, $453e5e72c39cf7c2$export$ca8e47dc8ed5a9d7)(valueTransition)) options = {
            ...options,
            ...(0, $a714041f9b68b288$export$262124b154b9f1c0)(name, options)
        };
        /**
     * Both WAAPI and our internal animation functions use durations
     * as defined by milliseconds, while our external API defines them
     * as seconds.
     */ if (options.duration) options.duration = (0, $64e5667fa478a387$export$fc3e7e8557f8c8c7)(options.duration);
        if (options.repeatDelay) options.repeatDelay = (0, $64e5667fa478a387$export$fc3e7e8557f8c8c7)(options.repeatDelay);
        if (options.from !== undefined) options.keyframes[0] = options.from;
        let shouldSkip = false;
        if (options.type === false || options.duration === 0 && !options.repeatDelay) {
            options.duration = 0;
            if (options.delay === 0) shouldSkip = true;
        }
        if ((0, $4f333d9188f46157$export$888a3d84909f9e3d).current || (0, $d3f03766da854ace$export$dd826089e3c5e502).skipAnimations) {
            shouldSkip = true;
            options.duration = 0;
            options.delay = 0;
        }
        /**
     * If we can or must skip creating the animation, and apply only
     * the final keyframe, do so. We also check once keyframes are resolved but
     * this early check prevents the need to create an animation at all.
     */ if (shouldSkip && !isHandoff && value.get() !== undefined) {
            const finalKeyframe = (0, $3ca01ac9e8cf1f66$export$14de59408fad90b)(options.keyframes, valueTransition);
            if (finalKeyframe !== undefined) {
                (0, $2668c8a722676613$export$2cef06c20297c17d).update(()=>{
                    options.onUpdate(finalKeyframe);
                    options.onComplete();
                });
                // We still want to return some animation controls here rather
                // than returning undefined
                return new (0, $ea560ce4dcc095f2$export$c1e41718f71efe41)([]);
            }
        }
        /**
     * Animate via WAAPI if possible. If this is a handoff animation, the optimised animation will be running via
     * WAAPI. Therefore, this animation must be JS to ensure it runs "under" the
     * optimised animation.
     */ if (!isHandoff && (0, $7f14ff9d0367db28$export$2a45abb4e6513325).supports(options)) return new (0, $7f14ff9d0367db28$export$2a45abb4e6513325)(options);
        else return new (0, $6a91611bc4894f12$export$fd98d9cca67a58bc)(options);
    };



const $5886206991be4714$export$2f308ad9864b3ac9 = (v)=>{
    return Boolean(v && typeof v === "object" && v.mix && v.toValue);
};
const $5886206991be4714$export$5485128c47bd48bb = (v)=>{
    // TODO maybe throw if v.length - 1 is placeholder token?
    return (0, $854bd2f427254747$export$9153ad4c4999f4a0)(v) ? v[v.length - 1] || 0 : v;
};


function $51a4ba498ba1dae1$export$20e507e47fae79fd(arr, item) {
    if (arr.indexOf(item) === -1) arr.push(item);
}
function $51a4ba498ba1dae1$export$fe2d9b4e03920b4c(arr, item) {
    const index = arr.indexOf(item);
    if (index > -1) arr.splice(index, 1);
}
// Adapted from array-move
function $51a4ba498ba1dae1$export$ec937e64de6c1257([...arr], fromIndex, toIndex) {
    const startIndex = fromIndex < 0 ? arr.length + fromIndex : fromIndex;
    if (startIndex >= 0 && startIndex < arr.length) {
        const endIndex = toIndex < 0 ? arr.length + toIndex : toIndex;
        const [item] = arr.splice(fromIndex, 1);
        arr.splice(endIndex, 0, item);
    }
    return arr;
}


class $f9d7e2b4cbfd436c$export$e7dff9482a5fd23c {
    constructor(){
        this.subscriptions = [];
    }
    add(handler) {
        (0, $51a4ba498ba1dae1$export$20e507e47fae79fd)(this.subscriptions, handler);
        return ()=>(0, $51a4ba498ba1dae1$export$fe2d9b4e03920b4c)(this.subscriptions, handler);
    }
    notify(a, b, c) {
        const numSubscriptions = this.subscriptions.length;
        if (!numSubscriptions) return;
        if (numSubscriptions === 1) /**
             * If there's only a single handler we can just call it without invoking a loop.
             */ this.subscriptions[0](a, b, c);
        else for(let i = 0; i < numSubscriptions; i++){
            /**
                 * Check whether the handler exists before firing as it's possible
                 * the subscriptions were modified during this loop running.
                 */ const handler = this.subscriptions[i];
            handler && handler(a, b, c);
        }
    }
    getSize() {
        return this.subscriptions.length;
    }
    clear() {
        this.subscriptions.length = 0;
    }
}






/**
 * Maximum time between the value of two frames, beyond which we
 * assume the velocity has since been 0.
 */ const $ebb6b8b1a738bf1d$var$MAX_VELOCITY_DELTA = 30;
const $ebb6b8b1a738bf1d$var$isFloat = (value)=>{
    return !isNaN(parseFloat(value));
};
const $ebb6b8b1a738bf1d$export$67fcd818a264039d = {
    current: undefined
};
/**
 * `MotionValue` is used to track the state and velocity of motion values.
 *
 * @public
 */ class $ebb6b8b1a738bf1d$export$8cea36d14ee64562 {
    /**
     * @param init - The initiating value
     * @param config - Optional configuration options
     *
     * -  `transformer`: A function to transform incoming values with.
     *
     * @internal
     */ constructor(init, options = {}){
        /**
         * This will be replaced by the build step with the latest version number.
         * When MotionValues are provided to motion components, warn if versions are mixed.
         */ this.version = "11.5.4";
        /**
         * Tracks whether this value can output a velocity. Currently this is only true
         * if the value is numerical, but we might be able to widen the scope here and support
         * other value types.
         *
         * @internal
         */ this.canTrackVelocity = null;
        /**
         * An object containing a SubscriptionManager for each active event.
         */ this.events = {};
        this.updateAndNotify = (v, render = true)=>{
            const currentTime = (0, $3a6da39b219d0ac7$export$2da9be4cfdb689b1).now();
            /**
             * If we're updating the value during another frame or eventloop
             * than the previous frame, then the we set the previous frame value
             * to current.
             */ if (this.updatedAt !== currentTime) this.setPrevFrameValue();
            this.prev = this.current;
            this.setCurrent(v);
            // Update update subscribers
            if (this.current !== this.prev && this.events.change) this.events.change.notify(this.current);
            // Update render subscribers
            if (render && this.events.renderRequest) this.events.renderRequest.notify(this.current);
        };
        this.hasAnimated = false;
        this.setCurrent(init);
        this.owner = options.owner;
    }
    setCurrent(current) {
        this.current = current;
        this.updatedAt = (0, $3a6da39b219d0ac7$export$2da9be4cfdb689b1).now();
        if (this.canTrackVelocity === null && current !== undefined) this.canTrackVelocity = $ebb6b8b1a738bf1d$var$isFloat(this.current);
    }
    setPrevFrameValue(prevFrameValue = this.current) {
        this.prevFrameValue = prevFrameValue;
        this.prevUpdatedAt = this.updatedAt;
    }
    /**
     * Adds a function that will be notified when the `MotionValue` is updated.
     *
     * It returns a function that, when called, will cancel the subscription.
     *
     * When calling `onChange` inside a React component, it should be wrapped with the
     * `useEffect` hook. As it returns an unsubscribe function, this should be returned
     * from the `useEffect` function to ensure you don't add duplicate subscribers..
     *
     * ```jsx
     * export const MyComponent = () => {
     *   const x = useMotionValue(0)
     *   const y = useMotionValue(0)
     *   const opacity = useMotionValue(1)
     *
     *   useEffect(() => {
     *     function updateOpacity() {
     *       const maxXY = Math.max(x.get(), y.get())
     *       const newOpacity = transform(maxXY, [0, 100], [1, 0])
     *       opacity.set(newOpacity)
     *     }
     *
     *     const unsubscribeX = x.on("change", updateOpacity)
     *     const unsubscribeY = y.on("change", updateOpacity)
     *
     *     return () => {
     *       unsubscribeX()
     *       unsubscribeY()
     *     }
     *   }, [])
     *
     *   return <motion.div style={{ x }} />
     * }
     * ```
     *
     * @param subscriber - A function that receives the latest value.
     * @returns A function that, when called, will cancel this subscription.
     *
     * @deprecated
     */ onChange(subscription) {
        return this.on("change", subscription);
    }
    on(eventName, callback) {
        if (!this.events[eventName]) this.events[eventName] = new (0, $f9d7e2b4cbfd436c$export$e7dff9482a5fd23c)();
        const unsubscribe = this.events[eventName].add(callback);
        if (eventName === "change") return ()=>{
            unsubscribe();
            /**
                 * If we have no more change listeners by the start
                 * of the next frame, stop active animations.
                 */ (0, $2668c8a722676613$export$2cef06c20297c17d).read(()=>{
                if (!this.events.change.getSize()) this.stop();
            });
        };
        return unsubscribe;
    }
    clearListeners() {
        for(const eventManagers in this.events)this.events[eventManagers].clear();
    }
    /**
     * Attaches a passive effect to the `MotionValue`.
     *
     * @internal
     */ attach(passiveEffect, stopPassiveEffect) {
        this.passiveEffect = passiveEffect;
        this.stopPassiveEffect = stopPassiveEffect;
    }
    /**
     * Sets the state of the `MotionValue`.
     *
     * @remarks
     *
     * ```jsx
     * const x = useMotionValue(0)
     * x.set(10)
     * ```
     *
     * @param latest - Latest value to set.
     * @param render - Whether to notify render subscribers. Defaults to `true`
     *
     * @public
     */ set(v, render = true) {
        if (!render || !this.passiveEffect) this.updateAndNotify(v, render);
        else this.passiveEffect(v, this.updateAndNotify);
    }
    setWithVelocity(prev, current, delta) {
        this.set(current);
        this.prev = undefined;
        this.prevFrameValue = prev;
        this.prevUpdatedAt = this.updatedAt - delta;
    }
    /**
     * Set the state of the `MotionValue`, stopping any active animations,
     * effects, and resets velocity to `0`.
     */ jump(v, endAnimation = true) {
        this.updateAndNotify(v);
        this.prev = v;
        this.prevUpdatedAt = this.prevFrameValue = undefined;
        endAnimation && this.stop();
        if (this.stopPassiveEffect) this.stopPassiveEffect();
    }
    /**
     * Returns the latest state of `MotionValue`
     *
     * @returns - The latest state of `MotionValue`
     *
     * @public
     */ get() {
        if ($ebb6b8b1a738bf1d$export$67fcd818a264039d.current) $ebb6b8b1a738bf1d$export$67fcd818a264039d.current.push(this);
        return this.current;
    }
    /**
     * @public
     */ getPrevious() {
        return this.prev;
    }
    /**
     * Returns the latest velocity of `MotionValue`
     *
     * @returns - The latest velocity of `MotionValue`. Returns `0` if the state is non-numerical.
     *
     * @public
     */ getVelocity() {
        const currentTime = (0, $3a6da39b219d0ac7$export$2da9be4cfdb689b1).now();
        if (!this.canTrackVelocity || this.prevFrameValue === undefined || currentTime - this.updatedAt > $ebb6b8b1a738bf1d$var$MAX_VELOCITY_DELTA) return 0;
        const delta = Math.min(this.updatedAt - this.prevUpdatedAt, $ebb6b8b1a738bf1d$var$MAX_VELOCITY_DELTA);
        // Casts because of parseFloat's poor typing
        return (0, $01416ecd35dd4fe1$export$eab0632f7ad4f9d7)(parseFloat(this.current) - parseFloat(this.prevFrameValue), delta);
    }
    /**
     * Registers a new animation to control this `MotionValue`. Only one
     * animation can drive a `MotionValue` at one time.
     *
     * ```jsx
     * value.start()
     * ```
     *
     * @param animation - A function that starts the provided animation
     *
     * @internal
     */ start(startAnimation) {
        this.stop();
        return new Promise((resolve)=>{
            this.hasAnimated = true;
            this.animation = startAnimation(resolve);
            if (this.events.animationStart) this.events.animationStart.notify();
        }).then(()=>{
            if (this.events.animationComplete) this.events.animationComplete.notify();
            this.clearAnimation();
        });
    }
    /**
     * Stop the currently active animation.
     *
     * @public
     */ stop() {
        if (this.animation) {
            this.animation.stop();
            if (this.events.animationCancel) this.events.animationCancel.notify();
        }
        this.clearAnimation();
    }
    /**
     * Returns `true` if this value is currently animating.
     *
     * @public
     */ isAnimating() {
        return !!this.animation;
    }
    clearAnimation() {
        delete this.animation;
    }
    /**
     * Destroy and clean up subscribers to this `MotionValue`.
     *
     * The `MotionValue` hooks like `useMotionValue` and `useTransform` automatically
     * handle the lifecycle of the returned `MotionValue`, so this method is only necessary if you've manually
     * created a `MotionValue` via the `motionValue` function.
     *
     * @public
     */ destroy() {
        this.clearListeners();
        this.stop();
        if (this.stopPassiveEffect) this.stopPassiveEffect();
    }
}
function $ebb6b8b1a738bf1d$export$ce8bdc721e76545f(init, options) {
    return new $ebb6b8b1a738bf1d$export$8cea36d14ee64562(init, options);
}



/**
 * Set VisualElement's MotionValue, creating a new MotionValue for it if
 * it doesn't exist.
 */ function $c0d70cfd424dc995$var$setMotionValue(visualElement, key, value) {
    if (visualElement.hasValue(key)) visualElement.getValue(key).set(value);
    else visualElement.addValue(key, (0, $ebb6b8b1a738bf1d$export$ce8bdc721e76545f)(value));
}
function $c0d70cfd424dc995$export$1f61c53461aff4a5(visualElement, definition) {
    const resolved = (0, $e92cd1cec7066d98$export$7b1b1c981f4f0558)(visualElement, definition);
    let { transitionEnd: transitionEnd = {}, transition: transition = {}, ...target } = resolved || {};
    target = {
        ...target,
        ...transitionEnd
    };
    for(const key in target){
        const value = (0, $5886206991be4714$export$5485128c47bd48bb)(target[key]);
        $c0d70cfd424dc995$var$setMotionValue(visualElement, key, value);
    }
}



/**
 * Convert camelCase to dash-case properties.
 */ const $76d837a31980cd1f$export$9fd24a634729c672 = (str)=>str.replace(/([a-z])([A-Z])/gu, "$1-$2").toLowerCase();


const $bd1f6e057be11122$export$ed7b8fa9dbf0105d = "framerAppearId";
const $bd1f6e057be11122$export$8592e1c077c890a6 = "data-" + (0, $76d837a31980cd1f$export$9fd24a634729c672)($bd1f6e057be11122$export$ed7b8fa9dbf0105d);


function $355e745a41ba8ef0$export$5f8d21e84d1d84fc(visualElement) {
    return visualElement.props[0, $bd1f6e057be11122$export$8592e1c077c890a6];
}






function $747b8e31f6efe634$export$b3f9dd865b560c6(name) {
    if ((0, $ea8236087cf451dc$export$7b42a0094fb00b6e).has(name)) return "transform";
    else if ((0, $172b3a0adea9e962$export$a27eefbd8fb5e404).has(name)) return (0, $76d837a31980cd1f$export$9fd24a634729c672)(name);
}



class $c247f1eb6e965883$export$3fe5fa490af65f85 extends (0, $ebb6b8b1a738bf1d$export$8cea36d14ee64562) {
    constructor(){
        super(...arguments);
        this.output = [];
        this.counts = new Map();
    }
    add(name) {
        const styleName = (0, $747b8e31f6efe634$export$b3f9dd865b560c6)(name);
        if (!styleName) return;
        /**
         * Update counter. Each value has an indepdent counter
         * as multiple sources could be requesting the same value
         * gets added to will-change.
         */ const prevCount = this.counts.get(styleName) || 0;
        this.counts.set(styleName, prevCount + 1);
        if (prevCount === 0) {
            this.output.push(styleName);
            this.update();
        }
        /**
         * Prevents the remove function from being called multiple times.
         */ let hasRemoved = false;
        return ()=>{
            if (hasRemoved) return;
            hasRemoved = true;
            const newCount = this.counts.get(styleName) - 1;
            this.counts.set(styleName, newCount);
            if (newCount === 0) {
                (0, $51a4ba498ba1dae1$export$fe2d9b4e03920b4c)(this.output, styleName);
                this.update();
            }
        };
    }
    update() {
        this.set(this.output.length ? this.output.join(", ") : "auto");
    }
}


const $97dfd46cf2e43daf$export$605d60a2578142d3 = (value)=>Boolean(value && value.getVelocity);


function $bd1b34552c3879fa$export$98397f3adbf6259f(value) {
    return Boolean((0, $97dfd46cf2e43daf$export$605d60a2578142d3)(value) && value.add);
}


function $b79c001af895beaa$export$3ac5aed310be0bee(visualElement, key) {
    var _a;
    if (!visualElement.applyWillChange) return;
    let willChange = visualElement.getValue("willChange");
    /**
     * If we haven't created a willChange MotionValue, and the we haven't been
     * manually provided one, create one.
     */ if (!willChange && !((_a = visualElement.props.style) === null || _a === void 0 ? void 0 : _a.willChange)) {
        willChange = new (0, $c247f1eb6e965883$export$3fe5fa490af65f85)("auto");
        visualElement.addValue("willChange", willChange);
    }
    /**
     * It could be that a user has set willChange to a regular MotionValue,
     * in which case we can't add the value to it.
     */ if ((0, $bd1b34552c3879fa$export$98397f3adbf6259f)(willChange)) return willChange.add(key);
}



/**
 * Decide whether we should block this animation. Previously, we achieved this
 * just by checking whether the key was listed in protectedKeys, but this
 * posed problems if an animation was triggered by afterChildren and protectedKeys
 * had been set to true in the meantime.
 */ function $71617090e716925b$var$shouldBlockAnimation({ protectedKeys: protectedKeys, needsAnimating: needsAnimating }, key) {
    const shouldBlock = protectedKeys.hasOwnProperty(key) && needsAnimating[key] !== true;
    needsAnimating[key] = false;
    return shouldBlock;
}
function $71617090e716925b$export$68cacfeee78d98d2(visualElement, targetAndTransition, { delay: delay = 0, transitionOverride: transitionOverride, type: type } = {}) {
    var _a;
    let { transition: transition = visualElement.getDefaultTransition(), transitionEnd: transitionEnd, ...target } = targetAndTransition;
    if (transitionOverride) transition = transitionOverride;
    const animations = [];
    const animationTypeState = type && visualElement.animationState && visualElement.animationState.getState()[type];
    for(const key in target){
        const value = visualElement.getValue(key, (_a = visualElement.latestValues[key]) !== null && _a !== void 0 ? _a : null);
        const valueTarget = target[key];
        if (valueTarget === undefined || animationTypeState && $71617090e716925b$var$shouldBlockAnimation(animationTypeState, key)) continue;
        const valueTransition = {
            delay: delay,
            ...(0, $453e5e72c39cf7c2$export$7c1391340308742e)(transition || {}, key)
        };
        /**
         * If this is the first time a value is being animated, check
         * to see if we're handling off from an existing animation.
         */ let isHandoff = false;
        if (window.MotionHandoffAnimation) {
            const appearId = (0, $355e745a41ba8ef0$export$5f8d21e84d1d84fc)(visualElement);
            if (appearId) {
                const startTime = window.MotionHandoffAnimation(appearId, key, (0, $2668c8a722676613$export$2cef06c20297c17d));
                if (startTime !== null) {
                    valueTransition.startTime = startTime;
                    isHandoff = true;
                }
            }
        }
        value.start((0, $30c44ca59ad5e77f$export$90b3dfc33ff3548)(key, value, valueTarget, visualElement.shouldReduceMotion && (0, $ea8236087cf451dc$export$7b42a0094fb00b6e).has(key) ? {
            type: false
        } : valueTransition, visualElement, isHandoff, (0, $b79c001af895beaa$export$3ac5aed310be0bee)(visualElement, key)));
        const animation = value.animation;
        if (animation) animations.push(animation);
    }
    if (transitionEnd) Promise.all(animations).then(()=>{
        (0, $2668c8a722676613$export$2cef06c20297c17d).update(()=>{
            transitionEnd && (0, $c0d70cfd424dc995$export$1f61c53461aff4a5)(visualElement, transitionEnd);
        });
    });
    return animations;
}




function $54ae2260007dcfeb$export$4709dc300705b2af(visualElement, variant, options = {}) {
    var _a;
    const resolved = (0, $e92cd1cec7066d98$export$7b1b1c981f4f0558)(visualElement, variant, options.type === "exit" ? (_a = visualElement.presenceContext) === null || _a === void 0 ? void 0 : _a.custom : undefined);
    let { transition: transition = visualElement.getDefaultTransition() || {} } = resolved || {};
    if (options.transitionOverride) transition = options.transitionOverride;
    /**
     * If we have a variant, create a callback that runs it as an animation.
     * Otherwise, we resolve a Promise immediately for a composable no-op.
     */ const getAnimation = resolved ? ()=>Promise.all((0, $71617090e716925b$export$68cacfeee78d98d2)(visualElement, resolved, options)) : ()=>Promise.resolve();
    /**
     * If we have children, create a callback that runs all their animations.
     * Otherwise, we resolve a Promise immediately for a composable no-op.
     */ const getChildAnimations = visualElement.variantChildren && visualElement.variantChildren.size ? (forwardDelay = 0)=>{
        const { delayChildren: delayChildren = 0, staggerChildren: staggerChildren, staggerDirection: staggerDirection } = transition;
        return $54ae2260007dcfeb$var$animateChildren(visualElement, variant, delayChildren + forwardDelay, staggerChildren, staggerDirection, options);
    } : ()=>Promise.resolve();
    /**
     * If the transition explicitly defines a "when" option, we need to resolve either
     * this animation or all children animations before playing the other.
     */ const { when: when } = transition;
    if (when) {
        const [first, last] = when === "beforeChildren" ? [
            getAnimation,
            getChildAnimations
        ] : [
            getChildAnimations,
            getAnimation
        ];
        return first().then(()=>last());
    } else return Promise.all([
        getAnimation(),
        getChildAnimations(options.delay)
    ]);
}
function $54ae2260007dcfeb$var$animateChildren(visualElement, variant, delayChildren = 0, staggerChildren = 0, staggerDirection = 1, options) {
    const animations = [];
    const maxStaggerDuration = (visualElement.variantChildren.size - 1) * staggerChildren;
    const generateStaggerDuration = staggerDirection === 1 ? (i = 0)=>i * staggerChildren : (i = 0)=>maxStaggerDuration - i * staggerChildren;
    Array.from(visualElement.variantChildren).sort($54ae2260007dcfeb$export$523a0bedf33ad781).forEach((child, i)=>{
        child.notify("AnimationStart", variant);
        animations.push($54ae2260007dcfeb$export$4709dc300705b2af(child, variant, {
            ...options,
            delay: delayChildren + generateStaggerDuration(i)
        }).then(()=>child.notify("AnimationComplete", variant)));
    });
    return Promise.all(animations);
}
function $54ae2260007dcfeb$export$523a0bedf33ad781(a, b) {
    return a.sortNodePosition(b);
}


function $b926866dbb79ab9d$export$ff62cf473653f109(visualElement, definition, options = {}) {
    visualElement.notify("AnimationStart", definition);
    let animation;
    if (Array.isArray(definition)) {
        const animations = definition.map((variant)=>(0, $54ae2260007dcfeb$export$4709dc300705b2af)(visualElement, variant, options));
        animation = Promise.all(animations);
    } else if (typeof definition === "string") animation = (0, $54ae2260007dcfeb$export$4709dc300705b2af)(visualElement, definition, options);
    else {
        const resolvedDefinition = typeof definition === "function" ? (0, $e92cd1cec7066d98$export$7b1b1c981f4f0558)(visualElement, definition, options.custom) : definition;
        animation = Promise.all((0, $71617090e716925b$export$68cacfeee78d98d2)(visualElement, resolvedDefinition, options));
    }
    return animation.then(()=>{
        visualElement.notify("AnimationComplete", definition);
    });
}


const $c110d9d5c06f1d5f$var$reversePriorityOrder = [
    ...(0, $7526b0a811789693$export$16e45afcc206d3a8)
].reverse();
const $c110d9d5c06f1d5f$var$numAnimationTypes = (0, $7526b0a811789693$export$16e45afcc206d3a8).length;
function $c110d9d5c06f1d5f$var$animateList(visualElement) {
    return (animations)=>Promise.all(animations.map(({ animation: animation, options: options })=>(0, $b926866dbb79ab9d$export$ff62cf473653f109)(visualElement, animation, options)));
}
function $c110d9d5c06f1d5f$export$bb53502b7a672aa8(visualElement) {
    let animate = $c110d9d5c06f1d5f$var$animateList(visualElement);
    let state = $c110d9d5c06f1d5f$var$createState();
    let isInitialRender = true;
    /**
     * This function will be used to reduce the animation definitions for
     * each active animation type into an object of resolved values for it.
     */ const buildResolvedTypeValues = (type)=>(acc, definition)=>{
            var _a;
            const resolved = (0, $e92cd1cec7066d98$export$7b1b1c981f4f0558)(visualElement, definition, type === "exit" ? (_a = visualElement.presenceContext) === null || _a === void 0 ? void 0 : _a.custom : undefined);
            if (resolved) {
                const { transition: transition, transitionEnd: transitionEnd, ...target } = resolved;
                acc = {
                    ...acc,
                    ...target,
                    ...transitionEnd
                };
            }
            return acc;
        };
    /**
     * This just allows us to inject mocked animation functions
     * @internal
     */ function setAnimateFunction(makeAnimator) {
        animate = makeAnimator(visualElement);
    }
    /**
     * When we receive new props, we need to:
     * 1. Create a list of protected keys for each type. This is a directory of
     *    value keys that are currently being "handled" by types of a higher priority
     *    so that whenever an animation is played of a given type, these values are
     *    protected from being animated.
     * 2. Determine if an animation type needs animating.
     * 3. Determine if any values have been removed from a type and figure out
     *    what to animate those to.
     */ function animateChanges(changedActiveType) {
        const props = visualElement.getProps();
        const context = visualElement.getVariantContext(true) || {};
        /**
         * A list of animations that we'll build into as we iterate through the animation
         * types. This will get executed at the end of the function.
         */ const animations = [];
        /**
         * Keep track of which values have been removed. Then, as we hit lower priority
         * animation types, we can check if they contain removed values and animate to that.
         */ const removedKeys = new Set();
        /**
         * A dictionary of all encountered keys. This is an object to let us build into and
         * copy it without iteration. Each time we hit an animation type we set its protected
         * keys - the keys its not allowed to animate - to the latest version of this object.
         */ let encounteredKeys = {};
        /**
         * If a variant has been removed at a given index, and this component is controlling
         * variant animations, we want to ensure lower-priority variants are forced to animate.
         */ let removedVariantIndex = Infinity;
        /**
         * Iterate through all animation types in reverse priority order. For each, we want to
         * detect which values it's handling and whether or not they've changed (and therefore
         * need to be animated). If any values have been removed, we want to detect those in
         * lower priority props and flag for animation.
         */ for(let i = 0; i < $c110d9d5c06f1d5f$var$numAnimationTypes; i++){
            const type = $c110d9d5c06f1d5f$var$reversePriorityOrder[i];
            const typeState = state[type];
            const prop = props[type] !== undefined ? props[type] : context[type];
            const propIsVariant = (0, $bfdcb20e850e14f7$export$720b90e312cea233)(prop);
            /**
             * If this type has *just* changed isActive status, set activeDelta
             * to that status. Otherwise set to null.
             */ const activeDelta = type === changedActiveType ? typeState.isActive : null;
            if (activeDelta === false) removedVariantIndex = i;
            /**
             * If this prop is an inherited variant, rather than been set directly on the
             * component itself, we want to make sure we allow the parent to trigger animations.
             *
             * TODO: Can probably change this to a !isControllingVariants check
             */ let isInherited = prop === context[type] && prop !== props[type] && propIsVariant;
            /**
             *
             */ if (isInherited && isInitialRender && visualElement.manuallyAnimateOnMount) isInherited = false;
            /**
             * Set all encountered keys so far as the protected keys for this type. This will
             * be any key that has been animated or otherwise handled by active, higher-priortiy types.
             */ typeState.protectedKeys = {
                ...encounteredKeys
            };
            // Check if we can skip analysing this prop early
            if (// If it isn't active and hasn't *just* been set as inactive
            !typeState.isActive && activeDelta === null || // If we didn't and don't have any defined prop for this animation type
            !prop && !typeState.prevProp || // Or if the prop doesn't define an animation
            (0, $f29cdb74f4d8f17d$export$aa71198ceeaf53ce)(prop) || typeof prop === "boolean") continue;
            /**
             * As we go look through the values defined on this type, if we detect
             * a changed value or a value that was removed in a higher priority, we set
             * this to true and add this prop to the animation list.
             */ const variantDidChange = $c110d9d5c06f1d5f$export$68651800594fd43c(typeState.prevProp, prop);
            let shouldAnimateType = variantDidChange || // If we're making this variant active, we want to always make it active
            type === changedActiveType && typeState.isActive && !isInherited && propIsVariant || // If we removed a higher-priority variant (i is in reverse order)
            i > removedVariantIndex && propIsVariant;
            let handledRemovedValues = false;
            /**
             * As animations can be set as variant lists, variants or target objects, we
             * coerce everything to an array if it isn't one already
             */ const definitionList = Array.isArray(prop) ? prop : [
                prop
            ];
            /**
             * Build an object of all the resolved values. We'll use this in the subsequent
             * animateChanges calls to determine whether a value has changed.
             */ let resolvedValues = definitionList.reduce(buildResolvedTypeValues(type), {});
            if (activeDelta === false) resolvedValues = {};
            /**
             * Now we need to loop through all the keys in the prev prop and this prop,
             * and decide:
             * 1. If the value has changed, and needs animating
             * 2. If it has been removed, and needs adding to the removedKeys set
             * 3. If it has been removed in a higher priority type and needs animating
             * 4. If it hasn't been removed in a higher priority but hasn't changed, and
             *    needs adding to the type's protectedKeys list.
             */ const { prevResolvedValues: prevResolvedValues = {} } = typeState;
            const allKeys = {
                ...prevResolvedValues,
                ...resolvedValues
            };
            const markToAnimate = (key)=>{
                shouldAnimateType = true;
                if (removedKeys.has(key)) {
                    handledRemovedValues = true;
                    removedKeys.delete(key);
                }
                typeState.needsAnimating[key] = true;
                const motionValue = visualElement.getValue(key);
                if (motionValue) motionValue.liveStyle = false;
            };
            for(const key in allKeys){
                const next = resolvedValues[key];
                const prev = prevResolvedValues[key];
                // If we've already handled this we can just skip ahead
                if (encounteredKeys.hasOwnProperty(key)) continue;
                /**
                 * If the value has changed, we probably want to animate it.
                 */ let valueHasChanged = false;
                if ((0, $854bd2f427254747$export$9153ad4c4999f4a0)(next) && (0, $854bd2f427254747$export$9153ad4c4999f4a0)(prev)) valueHasChanged = !(0, $618fd2d39a7e62c4$export$90e866afbd6b9f1a)(next, prev);
                else valueHasChanged = next !== prev;
                if (valueHasChanged) {
                    if (next !== undefined && next !== null) // If next is defined and doesn't equal prev, it needs animating
                    markToAnimate(key);
                    else // If it's undefined, it's been removed.
                    removedKeys.add(key);
                } else if (next !== undefined && removedKeys.has(key)) /**
                     * If next hasn't changed and it isn't undefined, we want to check if it's
                     * been removed by a higher priority
                     */ markToAnimate(key);
                else /**
                     * If it hasn't changed, we add it to the list of protected values
                     * to ensure it doesn't get animated.
                     */ typeState.protectedKeys[key] = true;
            }
            /**
             * Update the typeState so next time animateChanges is called we can compare the
             * latest prop and resolvedValues to these.
             */ typeState.prevProp = prop;
            typeState.prevResolvedValues = resolvedValues;
            /**
             *
             */ if (typeState.isActive) encounteredKeys = {
                ...encounteredKeys,
                ...resolvedValues
            };
            if (isInitialRender && visualElement.blockInitialAnimation) shouldAnimateType = false;
            /**
             * If this is an inherited prop we want to hard-block animations
             */ if (shouldAnimateType && (!isInherited || handledRemovedValues)) animations.push(...definitionList.map((animation)=>({
                    animation: animation,
                    options: {
                        type: type
                    }
                })));
        }
        /**
         * If there are some removed value that haven't been dealt with,
         * we need to create a new animation that falls back either to the value
         * defined in the style prop, or the last read value.
         */ if (removedKeys.size) {
            const fallbackAnimation = {};
            removedKeys.forEach((key)=>{
                const fallbackTarget = visualElement.getBaseTarget(key);
                const motionValue = visualElement.getValue(key);
                if (motionValue) motionValue.liveStyle = true;
                // @ts-expect-error - @mattgperry to figure if we should do something here
                fallbackAnimation[key] = fallbackTarget !== null && fallbackTarget !== void 0 ? fallbackTarget : null;
            });
            animations.push({
                animation: fallbackAnimation
            });
        }
        let shouldAnimate = Boolean(animations.length);
        if (isInitialRender && (props.initial === false || props.initial === props.animate) && !visualElement.manuallyAnimateOnMount) shouldAnimate = false;
        isInitialRender = false;
        return shouldAnimate ? animate(animations) : Promise.resolve();
    }
    /**
     * Change whether a certain animation type is active.
     */ function setActive(type, isActive) {
        var _a;
        // If the active state hasn't changed, we can safely do nothing here
        if (state[type].isActive === isActive) return Promise.resolve();
        // Propagate active change to children
        (_a = visualElement.variantChildren) === null || _a === void 0 || _a.forEach((child)=>{
            var _a;
            return (_a = child.animationState) === null || _a === void 0 ? void 0 : _a.setActive(type, isActive);
        });
        state[type].isActive = isActive;
        const animations = animateChanges(type);
        for(const key in state)state[key].protectedKeys = {};
        return animations;
    }
    return {
        animateChanges: animateChanges,
        setActive: setActive,
        setAnimateFunction: setAnimateFunction,
        getState: ()=>state,
        reset: ()=>{
            state = $c110d9d5c06f1d5f$var$createState();
            isInitialRender = true;
        }
    };
}
function $c110d9d5c06f1d5f$export$68651800594fd43c(prev, next) {
    if (typeof next === "string") return next !== prev;
    else if (Array.isArray(next)) return !(0, $618fd2d39a7e62c4$export$90e866afbd6b9f1a)(next, prev);
    return false;
}
function $c110d9d5c06f1d5f$var$createTypeState(isActive = false) {
    return {
        isActive: isActive,
        protectedKeys: {},
        needsAnimating: {},
        prevResolvedValues: {}
    };
}
function $c110d9d5c06f1d5f$var$createState() {
    return {
        animate: $c110d9d5c06f1d5f$var$createTypeState(true),
        whileInView: $c110d9d5c06f1d5f$var$createTypeState(),
        whileHover: $c110d9d5c06f1d5f$var$createTypeState(),
        whileTap: $c110d9d5c06f1d5f$var$createTypeState(),
        whileDrag: $c110d9d5c06f1d5f$var$createTypeState(),
        whileFocus: $c110d9d5c06f1d5f$var$createTypeState(),
        exit: $c110d9d5c06f1d5f$var$createTypeState()
    };
}


class $0e2551b19b8df95b$export$6e91cf7616333d5 {
    constructor(node){
        this.isMounted = false;
        this.node = node;
    }
    update() {}
}


class $e2f22a6aa88b0350$export$b45b3fe5caabdca extends (0, $0e2551b19b8df95b$export$6e91cf7616333d5) {
    /**
     * We dynamically generate the AnimationState manager as it contains a reference
     * to the underlying animation library. We only want to load that if we load this,
     * so people can optionally code split it out using the `m` component.
     */ constructor(node){
        super(node);
        node.animationState || (node.animationState = (0, $c110d9d5c06f1d5f$export$bb53502b7a672aa8)(node));
    }
    updateAnimationControlsSubscription() {
        const { animate: animate } = this.node.getProps();
        if ((0, $f29cdb74f4d8f17d$export$aa71198ceeaf53ce)(animate)) this.unmountControls = animate.subscribe(this.node);
    }
    /**
     * Subscribe any provided AnimationControls to the component's VisualElement
     */ mount() {
        this.updateAnimationControlsSubscription();
    }
    update() {
        const { animate: animate } = this.node.getProps();
        const { animate: prevAnimate } = this.node.prevProps || {};
        if (animate !== prevAnimate) this.updateAnimationControlsSubscription();
    }
    unmount() {
        var _a;
        this.node.animationState.reset();
        (_a = this.unmountControls) === null || _a === void 0 || _a.call(this);
    }
}



let $5bf10a71bd460830$var$id = 0;
class $5bf10a71bd460830$export$4989d1eb6104cc6c extends (0, $0e2551b19b8df95b$export$6e91cf7616333d5) {
    constructor(){
        super(...arguments);
        this.id = $5bf10a71bd460830$var$id++;
    }
    update() {
        if (!this.node.presenceContext) return;
        const { isPresent: isPresent, onExitComplete: onExitComplete } = this.node.presenceContext;
        const { isPresent: prevIsPresent } = this.node.prevPresenceContext || {};
        if (!this.node.animationState || isPresent === prevIsPresent) return;
        const exitAnimation = this.node.animationState.setActive("exit", !isPresent);
        if (onExitComplete && !isPresent) exitAnimation.then(()=>onExitComplete(this.id));
    }
    mount() {
        const { register: register } = this.node.presenceContext || {};
        if (register) this.unmount = register(this.id);
    }
    unmount() {}
}


const $2d0cdac558a97e2e$export$7f9953c70dacfd7f = {
    animation: {
        Feature: (0, $e2f22a6aa88b0350$export$b45b3fe5caabdca)
    },
    exit: {
        Feature: (0, $5bf10a71bd460830$export$4989d1eb6104cc6c)
    }
};





const $d6ded8eb30673083$export$a4cf9c8a4b063a6e = (event)=>{
    if (event.pointerType === "mouse") return typeof event.button !== "number" || event.button <= 0;
    else /**
         * isPrimary is true for all mice buttons, whereas every touch point
         * is regarded as its own input. So subsequent concurrent touch points
         * will be false.
         *
         * Specifically match against false here as incomplete versions of
         * PointerEvents in very old browser might have it set as undefined.
         */ return event.isPrimary !== false;
};


function $bb2968ceabdf7aba$export$12f84bb882d06e1a(event, pointType = "page") {
    return {
        point: {
            x: event[`${pointType}X`],
            y: event[`${pointType}Y`]
        }
    };
}
const $bb2968ceabdf7aba$export$c404e80f92c98d29 = (handler)=>{
    return (event)=>(0, $d6ded8eb30673083$export$a4cf9c8a4b063a6e)(event) && handler(event, $bb2968ceabdf7aba$export$12f84bb882d06e1a(event));
};



function $52bbcc091bf26590$export$b1d829ddf82884aa(target, eventName, handler, options = {
    passive: true
}) {
    target.addEventListener(eventName, handler, options);
    return ()=>target.removeEventListener(eventName, handler);
}



function $a2f9971c4d7d6c59$export$fcff2e64e6676b81(target, eventName, handler, options) {
    return (0, $52bbcc091bf26590$export$b1d829ddf82884aa)(target, eventName, (0, $bb2968ceabdf7aba$export$c404e80f92c98d29)(handler), options);
}



const $25738ceb266d6fb4$export$9f17032d917177de = (a, b)=>Math.abs(a - b);
function $25738ceb266d6fb4$export$503a1d513f12e38b(a, b) {
    // Multi-dimensional
    const xDelta = $25738ceb266d6fb4$export$9f17032d917177de(a.x, b.x);
    const yDelta = $25738ceb266d6fb4$export$9f17032d917177de(a.y, b.y);
    return Math.sqrt(xDelta ** 2 + yDelta ** 2);
}




/**
 * @internal
 */ class $4f540b18fadbcd47$export$d9c66232c9c4689c {
    constructor(event, handlers, { transformPagePoint: transformPagePoint, contextWindow: contextWindow, dragSnapToOrigin: dragSnapToOrigin = false } = {}){
        /**
         * @internal
         */ this.startEvent = null;
        /**
         * @internal
         */ this.lastMoveEvent = null;
        /**
         * @internal
         */ this.lastMoveEventInfo = null;
        /**
         * @internal
         */ this.handlers = {};
        /**
         * @internal
         */ this.contextWindow = window;
        this.updatePoint = ()=>{
            if (!(this.lastMoveEvent && this.lastMoveEventInfo)) return;
            const info = $4f540b18fadbcd47$var$getPanInfo(this.lastMoveEventInfo, this.history);
            const isPanStarted = this.startEvent !== null;
            // Only start panning if the offset is larger than 3 pixels. If we make it
            // any larger than this we'll want to reset the pointer history
            // on the first update to avoid visual snapping to the cursoe.
            const isDistancePastThreshold = (0, $25738ceb266d6fb4$export$503a1d513f12e38b)(info.offset, {
                x: 0,
                y: 0
            }) >= 3;
            if (!isPanStarted && !isDistancePastThreshold) return;
            const { point: point } = info;
            const { timestamp: timestamp } = (0, $2668c8a722676613$export$fff89137e9e818ce);
            this.history.push({
                ...point,
                timestamp: timestamp
            });
            const { onStart: onStart, onMove: onMove } = this.handlers;
            if (!isPanStarted) {
                onStart && onStart(this.lastMoveEvent, info);
                this.startEvent = this.lastMoveEvent;
            }
            onMove && onMove(this.lastMoveEvent, info);
        };
        this.handlePointerMove = (event, info)=>{
            this.lastMoveEvent = event;
            this.lastMoveEventInfo = $4f540b18fadbcd47$var$transformPoint(info, this.transformPagePoint);
            // Throttle mouse move event to once per frame
            (0, $2668c8a722676613$export$2cef06c20297c17d).update(this.updatePoint, true);
        };
        this.handlePointerUp = (event, info)=>{
            this.end();
            const { onEnd: onEnd, onSessionEnd: onSessionEnd, resumeAnimation: resumeAnimation } = this.handlers;
            if (this.dragSnapToOrigin) resumeAnimation && resumeAnimation();
            if (!(this.lastMoveEvent && this.lastMoveEventInfo)) return;
            const panInfo = $4f540b18fadbcd47$var$getPanInfo(event.type === "pointercancel" ? this.lastMoveEventInfo : $4f540b18fadbcd47$var$transformPoint(info, this.transformPagePoint), this.history);
            if (this.startEvent && onEnd) onEnd(event, panInfo);
            onSessionEnd && onSessionEnd(event, panInfo);
        };
        // If we have more than one touch, don't start detecting this gesture
        if (!(0, $d6ded8eb30673083$export$a4cf9c8a4b063a6e)(event)) return;
        this.dragSnapToOrigin = dragSnapToOrigin;
        this.handlers = handlers;
        this.transformPagePoint = transformPagePoint;
        this.contextWindow = contextWindow || window;
        const info = (0, $bb2968ceabdf7aba$export$12f84bb882d06e1a)(event);
        const initialInfo = $4f540b18fadbcd47$var$transformPoint(info, this.transformPagePoint);
        const { point: point } = initialInfo;
        const { timestamp: timestamp } = (0, $2668c8a722676613$export$fff89137e9e818ce);
        this.history = [
            {
                ...point,
                timestamp: timestamp
            }
        ];
        const { onSessionStart: onSessionStart } = handlers;
        onSessionStart && onSessionStart(event, $4f540b18fadbcd47$var$getPanInfo(initialInfo, this.history));
        this.removeListeners = (0, $a510fe5631c50899$export$a4627e546088548d)((0, $a2f9971c4d7d6c59$export$fcff2e64e6676b81)(this.contextWindow, "pointermove", this.handlePointerMove), (0, $a2f9971c4d7d6c59$export$fcff2e64e6676b81)(this.contextWindow, "pointerup", this.handlePointerUp), (0, $a2f9971c4d7d6c59$export$fcff2e64e6676b81)(this.contextWindow, "pointercancel", this.handlePointerUp));
    }
    updateHandlers(handlers) {
        this.handlers = handlers;
    }
    end() {
        this.removeListeners && this.removeListeners();
        (0, $2668c8a722676613$export$ec99c0ef4978dccb)(this.updatePoint);
    }
}
function $4f540b18fadbcd47$var$transformPoint(info, transformPagePoint) {
    return transformPagePoint ? {
        point: transformPagePoint(info.point)
    } : info;
}
function $4f540b18fadbcd47$var$subtractPoint(a, b) {
    return {
        x: a.x - b.x,
        y: a.y - b.y
    };
}
function $4f540b18fadbcd47$var$getPanInfo({ point: point }, history) {
    return {
        point: point,
        delta: $4f540b18fadbcd47$var$subtractPoint(point, $4f540b18fadbcd47$var$lastDevicePoint(history)),
        offset: $4f540b18fadbcd47$var$subtractPoint(point, $4f540b18fadbcd47$var$startDevicePoint(history)),
        velocity: $4f540b18fadbcd47$var$getVelocity(history, 0.1)
    };
}
function $4f540b18fadbcd47$var$startDevicePoint(history) {
    return history[0];
}
function $4f540b18fadbcd47$var$lastDevicePoint(history) {
    return history[history.length - 1];
}
function $4f540b18fadbcd47$var$getVelocity(history, timeDelta) {
    if (history.length < 2) return {
        x: 0,
        y: 0
    };
    let i = history.length - 1;
    let timestampedPoint = null;
    const lastPoint = $4f540b18fadbcd47$var$lastDevicePoint(history);
    while(i >= 0){
        timestampedPoint = history[i];
        if (lastPoint.timestamp - timestampedPoint.timestamp > (0, $64e5667fa478a387$export$fc3e7e8557f8c8c7)(timeDelta)) break;
        i--;
    }
    if (!timestampedPoint) return {
        x: 0,
        y: 0
    };
    const time = (0, $64e5667fa478a387$export$f64c3bfbc58eec0f)(lastPoint.timestamp - timestampedPoint.timestamp);
    if (time === 0) return {
        x: 0,
        y: 0
    };
    const currentVelocity = {
        x: (lastPoint.x - timestampedPoint.x) / time,
        y: (lastPoint.y - timestampedPoint.y) / time
    };
    if (currentVelocity.x === Infinity) currentVelocity.x = 0;
    if (currentVelocity.y === Infinity) currentVelocity.y = 0;
    return currentVelocity;
}


function $b620b19e58064217$export$518c5fc2dcb7974b(name) {
    let lock = null;
    return ()=>{
        const openLock = ()=>{
            lock = null;
        };
        if (lock === null) {
            lock = name;
            return openLock;
        }
        return false;
    };
}
const $b620b19e58064217$var$globalHorizontalLock = $b620b19e58064217$export$518c5fc2dcb7974b("dragHorizontal");
const $b620b19e58064217$var$globalVerticalLock = $b620b19e58064217$export$518c5fc2dcb7974b("dragVertical");
function $b620b19e58064217$export$2b7959ed03c1a3fe(drag) {
    let lock = false;
    if (drag === "y") lock = $b620b19e58064217$var$globalVerticalLock();
    else if (drag === "x") lock = $b620b19e58064217$var$globalHorizontalLock();
    else {
        const openHorizontal = $b620b19e58064217$var$globalHorizontalLock();
        const openVertical = $b620b19e58064217$var$globalVerticalLock();
        if (openHorizontal && openVertical) lock = ()=>{
            openHorizontal();
            openVertical();
        };
        else {
            // Release the locks because we don't use them
            if (openHorizontal) openHorizontal();
            if (openVertical) openVertical();
        }
    }
    return lock;
}
function $b620b19e58064217$export$1b3dd616664938e4() {
    // Check the gesture lock - if we get it, it means no drag gesture is active
    // and we can safely fire the tap gesture.
    const openGestureLock = $b620b19e58064217$export$2b7959ed03c1a3fe(true);
    if (!openGestureLock) return true;
    openGestureLock();
    return false;
}


function $ed6b374e0bfa2f8b$export$dedd81df7bc1307(ref) {
    return ref && typeof ref === "object" && Object.prototype.hasOwnProperty.call(ref, "current");
}





const $85a652ec5cd36319$var$SCALE_PRECISION = 0.0001;
const $85a652ec5cd36319$var$SCALE_MIN = 1 - $85a652ec5cd36319$var$SCALE_PRECISION;
const $85a652ec5cd36319$var$SCALE_MAX = 1 + $85a652ec5cd36319$var$SCALE_PRECISION;
const $85a652ec5cd36319$var$TRANSLATE_PRECISION = 0.01;
const $85a652ec5cd36319$var$TRANSLATE_MIN = 0 - $85a652ec5cd36319$var$TRANSLATE_PRECISION;
const $85a652ec5cd36319$var$TRANSLATE_MAX = 0 + $85a652ec5cd36319$var$TRANSLATE_PRECISION;
function $85a652ec5cd36319$export$c1c127004b72a37(axis) {
    return axis.max - axis.min;
}
function $85a652ec5cd36319$export$28d0384c4b79bde2(value, target, maxDistance) {
    return Math.abs(value - target) <= maxDistance;
}
function $85a652ec5cd36319$export$e90fc1ae5e3e48ed(delta, source, target, origin = 0.5) {
    delta.origin = origin;
    delta.originPoint = (0, $4defff8a09cc16c4$export$3bb0b4ff1037b8dd)(source.min, source.max, delta.origin);
    delta.scale = $85a652ec5cd36319$export$c1c127004b72a37(target) / $85a652ec5cd36319$export$c1c127004b72a37(source);
    delta.translate = (0, $4defff8a09cc16c4$export$3bb0b4ff1037b8dd)(target.min, target.max, delta.origin) - delta.originPoint;
    if (delta.scale >= $85a652ec5cd36319$var$SCALE_MIN && delta.scale <= $85a652ec5cd36319$var$SCALE_MAX || isNaN(delta.scale)) delta.scale = 1.0;
    if (delta.translate >= $85a652ec5cd36319$var$TRANSLATE_MIN && delta.translate <= $85a652ec5cd36319$var$TRANSLATE_MAX || isNaN(delta.translate)) delta.translate = 0.0;
}
function $85a652ec5cd36319$export$c0d25e96fc67d310(delta, source, target, origin) {
    $85a652ec5cd36319$export$e90fc1ae5e3e48ed(delta.x, source.x, target.x, origin ? origin.originX : undefined);
    $85a652ec5cd36319$export$e90fc1ae5e3e48ed(delta.y, source.y, target.y, origin ? origin.originY : undefined);
}
function $85a652ec5cd36319$export$cabef5b392704b41(target, relative, parent) {
    target.min = parent.min + relative.min;
    target.max = target.min + $85a652ec5cd36319$export$c1c127004b72a37(relative);
}
function $85a652ec5cd36319$export$426154f9d100f99(target, relative, parent) {
    $85a652ec5cd36319$export$cabef5b392704b41(target.x, relative.x, parent.x);
    $85a652ec5cd36319$export$cabef5b392704b41(target.y, relative.y, parent.y);
}
function $85a652ec5cd36319$export$ecd3d3bef81102c3(target, layout, parent) {
    target.min = layout.min - parent.min;
    target.max = target.min + $85a652ec5cd36319$export$c1c127004b72a37(layout);
}
function $85a652ec5cd36319$export$2785bfcc929c5650(target, layout, parent) {
    $85a652ec5cd36319$export$ecd3d3bef81102c3(target.x, layout.x, parent.x);
    $85a652ec5cd36319$export$ecd3d3bef81102c3(target.y, layout.y, parent.y);
}




/**
 * Apply constraints to a point. These constraints are both physical along an
 * axis, and an elastic factor that determines how much to constrain the point
 * by if it does lie outside the defined parameters.
 */ function $bd193a823137bfc4$export$b3c764d3fca3ffe3(point, { min: min, max: max }, elastic) {
    if (min !== undefined && point < min) // If we have a min point defined, and this is outside of that, constrain
    point = elastic ? (0, $4defff8a09cc16c4$export$3bb0b4ff1037b8dd)(min, point, elastic.min) : Math.max(point, min);
    else if (max !== undefined && point > max) // If we have a max point defined, and this is outside of that, constrain
    point = elastic ? (0, $4defff8a09cc16c4$export$3bb0b4ff1037b8dd)(max, point, elastic.max) : Math.min(point, max);
    return point;
}
/**
 * Calculate constraints in terms of the viewport when defined relatively to the
 * measured axis. This is measured from the nearest edge, so a max constraint of 200
 * on an axis with a max value of 300 would return a constraint of 500 - axis length
 */ function $bd193a823137bfc4$export$690c180aa5775042(axis, min, max) {
    return {
        min: min !== undefined ? axis.min + min : undefined,
        max: max !== undefined ? axis.max + max - (axis.max - axis.min) : undefined
    };
}
/**
 * Calculate constraints in terms of the viewport when
 * defined relatively to the measured bounding box.
 */ function $bd193a823137bfc4$export$4e9195bf7793bc78(layoutBox, { top: top, left: left, bottom: bottom, right: right }) {
    return {
        x: $bd193a823137bfc4$export$690c180aa5775042(layoutBox.x, left, right),
        y: $bd193a823137bfc4$export$690c180aa5775042(layoutBox.y, top, bottom)
    };
}
/**
 * Calculate viewport constraints when defined as another viewport-relative axis
 */ function $bd193a823137bfc4$export$87abc398c3c7ce27(layoutAxis, constraintsAxis) {
    let min = constraintsAxis.min - layoutAxis.min;
    let max = constraintsAxis.max - layoutAxis.max;
    // If the constraints axis is actually smaller than the layout axis then we can
    // flip the constraints
    if (constraintsAxis.max - constraintsAxis.min < layoutAxis.max - layoutAxis.min) [min, max] = [
        max,
        min
    ];
    return {
        min: min,
        max: max
    };
}
/**
 * Calculate viewport constraints when defined as another viewport-relative box
 */ function $bd193a823137bfc4$export$4228500f19d4cdf7(layoutBox, constraintsBox) {
    return {
        x: $bd193a823137bfc4$export$87abc398c3c7ce27(layoutBox.x, constraintsBox.x),
        y: $bd193a823137bfc4$export$87abc398c3c7ce27(layoutBox.y, constraintsBox.y)
    };
}
/**
 * Calculate a transform origin relative to the source axis, between 0-1, that results
 * in an asthetically pleasing scale/transform needed to project from source to target.
 */ function $bd193a823137bfc4$export$13abbfca044ca46d(source, target) {
    let origin = 0.5;
    const sourceLength = (0, $85a652ec5cd36319$export$c1c127004b72a37)(source);
    const targetLength = (0, $85a652ec5cd36319$export$c1c127004b72a37)(target);
    if (targetLength > sourceLength) origin = (0, $482d3e1965098f2a$export$504d7abb21fa8c9)(target.min, target.max - sourceLength, source.min);
    else if (sourceLength > targetLength) origin = (0, $482d3e1965098f2a$export$504d7abb21fa8c9)(source.min, source.max - targetLength, target.min);
    return (0, $b64a5fb8aaa910d9$export$7d15b64cf5a3a4c4)(0, 1, origin);
}
/**
 * Rebase the calculated viewport constraints relative to the layout.min point.
 */ function $bd193a823137bfc4$export$e9672cc4c36a8b87(layout, constraints) {
    const relativeConstraints = {};
    if (constraints.min !== undefined) relativeConstraints.min = constraints.min - layout.min;
    if (constraints.max !== undefined) relativeConstraints.max = constraints.max - layout.min;
    return relativeConstraints;
}
const $bd193a823137bfc4$export$a3366d3bac43a742 = 0.35;
/**
 * Accepts a dragElastic prop and returns resolved elastic values for each axis.
 */ function $bd193a823137bfc4$export$7c5eaef8f4723d22(dragElastic = $bd193a823137bfc4$export$a3366d3bac43a742) {
    if (dragElastic === false) dragElastic = 0;
    else if (dragElastic === true) dragElastic = $bd193a823137bfc4$export$a3366d3bac43a742;
    return {
        x: $bd193a823137bfc4$export$589076940abb04b5(dragElastic, "left", "right"),
        y: $bd193a823137bfc4$export$589076940abb04b5(dragElastic, "top", "bottom")
    };
}
function $bd193a823137bfc4$export$589076940abb04b5(dragElastic, minLabel, maxLabel) {
    return {
        min: $bd193a823137bfc4$export$bbbc10b82e6c0afb(dragElastic, minLabel),
        max: $bd193a823137bfc4$export$bbbc10b82e6c0afb(dragElastic, maxLabel)
    };
}
function $bd193a823137bfc4$export$bbbc10b82e6c0afb(dragElastic, label) {
    return typeof dragElastic === "number" ? dragElastic : dragElastic[label] || 0;
}


const $a33f96272a0f3ced$export$ff25708b37f72782 = ()=>({
        translate: 0,
        scale: 1,
        origin: 0,
        originPoint: 0
    });
const $a33f96272a0f3ced$export$3d227df54007d73a = ()=>({
        x: $a33f96272a0f3ced$export$ff25708b37f72782(),
        y: $a33f96272a0f3ced$export$ff25708b37f72782()
    });
const $a33f96272a0f3ced$export$6db76765312617ac = ()=>({
        min: 0,
        max: 0
    });
const $a33f96272a0f3ced$export$6459fc9e86be362e = ()=>({
        x: $a33f96272a0f3ced$export$6db76765312617ac(),
        y: $a33f96272a0f3ced$export$6db76765312617ac()
    });


function $80571038c05c2614$export$b789de563eb43b1(callback) {
    return [
        callback("x"),
        callback("y")
    ];
}


/**
 * Bounding boxes tend to be defined as top, left, right, bottom. For various operations
 * it's easier to consider each axis individually. This function returns a bounding box
 * as a map of single-axis min/max values.
 */ function $853b10d6dae64020$export$d3955c6a8f65a36b({ top: top, left: left, right: right, bottom: bottom }) {
    return {
        x: {
            min: left,
            max: right
        },
        y: {
            min: top,
            max: bottom
        }
    };
}
function $853b10d6dae64020$export$b6b9cd4198191a47({ x: x, y: y }) {
    return {
        top: y.min,
        right: x.max,
        bottom: y.max,
        left: x.min
    };
}
/**
 * Applies a TransformPoint function to a bounding box. TransformPoint is usually a function
 * provided by Framer to allow measured points to be corrected for device scaling. This is used
 * when measuring DOM elements and DOM event points.
 */ function $853b10d6dae64020$export$21543fb75483a50(point, transformPoint) {
    if (!transformPoint) return point;
    const topLeft = transformPoint({
        x: point.left,
        y: point.top
    });
    const bottomRight = transformPoint({
        x: point.right,
        y: point.bottom
    });
    return {
        top: topLeft.y,
        left: topLeft.x,
        bottom: bottomRight.y,
        right: bottomRight.x
    };
}



function $d3d101fc7fd68aaf$var$isIdentityScale(scale) {
    return scale === undefined || scale === 1;
}
function $d3d101fc7fd68aaf$export$bdf30dca883ea463({ scale: scale, scaleX: scaleX, scaleY: scaleY }) {
    return !$d3d101fc7fd68aaf$var$isIdentityScale(scale) || !$d3d101fc7fd68aaf$var$isIdentityScale(scaleX) || !$d3d101fc7fd68aaf$var$isIdentityScale(scaleY);
}
function $d3d101fc7fd68aaf$export$a545127cf1fbb600(values) {
    return $d3d101fc7fd68aaf$export$bdf30dca883ea463(values) || $d3d101fc7fd68aaf$export$bf80f5f8f4dc327f(values) || values.z || values.rotate || values.rotateX || values.rotateY || values.skewX || values.skewY;
}
function $d3d101fc7fd68aaf$export$bf80f5f8f4dc327f(values) {
    return $d3d101fc7fd68aaf$var$is2DTranslate(values.x) || $d3d101fc7fd68aaf$var$is2DTranslate(values.y);
}
function $d3d101fc7fd68aaf$var$is2DTranslate(value) {
    return value && value !== "0%";
}


/**
 * Scales a point based on a factor and an originPoint
 */ function $d81381f648f60915$export$2290ec7febe36dd6(point, scale, originPoint) {
    const distanceFromOrigin = point - originPoint;
    const scaled = scale * distanceFromOrigin;
    return originPoint + scaled;
}
/**
 * Applies a translate/scale delta to a point
 */ function $d81381f648f60915$export$4e122ddcc0c61a2e(point, translate, scale, originPoint, boxScale) {
    if (boxScale !== undefined) point = $d81381f648f60915$export$2290ec7febe36dd6(point, boxScale, originPoint);
    return $d81381f648f60915$export$2290ec7febe36dd6(point, scale, originPoint) + translate;
}
/**
 * Applies a translate/scale delta to an axis
 */ function $d81381f648f60915$export$e8e3a712e9ebf422(axis, translate = 0, scale = 1, originPoint, boxScale) {
    axis.min = $d81381f648f60915$export$4e122ddcc0c61a2e(axis.min, translate, scale, originPoint, boxScale);
    axis.max = $d81381f648f60915$export$4e122ddcc0c61a2e(axis.max, translate, scale, originPoint, boxScale);
}
/**
 * Applies a translate/scale delta to a box
 */ function $d81381f648f60915$export$d80074982803af5c(box, { x: x, y: y }) {
    $d81381f648f60915$export$e8e3a712e9ebf422(box.x, x.translate, x.scale, x.originPoint);
    $d81381f648f60915$export$e8e3a712e9ebf422(box.y, y.translate, y.scale, y.originPoint);
}
const $d81381f648f60915$var$TREE_SCALE_SNAP_MIN = 0.999999999999;
const $d81381f648f60915$var$TREE_SCALE_SNAP_MAX = 1.0000000000001;
/**
 * Apply a tree of deltas to a box. We do this to calculate the effect of all the transforms
 * in a tree upon our box before then calculating how to project it into our desired viewport-relative box
 *
 * This is the final nested loop within updateLayoutDelta for future refactoring
 */ function $d81381f648f60915$export$e2a980535c55eabb(box, treeScale, treePath, isSharedTransition = false) {
    const treeLength = treePath.length;
    if (!treeLength) return;
    // Reset the treeScale
    treeScale.x = treeScale.y = 1;
    let node;
    let delta;
    for(let i = 0; i < treeLength; i++){
        node = treePath[i];
        delta = node.projectionDelta;
        /**
         * TODO: Prefer to remove this, but currently we have motion components with
         * display: contents in Framer.
         */ const { visualElement: visualElement } = node.options;
        if (visualElement && visualElement.props.style && visualElement.props.style.display === "contents") continue;
        if (isSharedTransition && node.options.layoutScroll && node.scroll && node !== node.root) $d81381f648f60915$export$58b16271041fbfb(box, {
            x: -node.scroll.offset.x,
            y: -node.scroll.offset.y
        });
        if (delta) {
            // Incoporate each ancestor's scale into a culmulative treeScale for this component
            treeScale.x *= delta.x.scale;
            treeScale.y *= delta.y.scale;
            // Apply each ancestor's calculated delta into this component's recorded layout box
            $d81381f648f60915$export$d80074982803af5c(box, delta);
        }
        if (isSharedTransition && (0, $d3d101fc7fd68aaf$export$a545127cf1fbb600)(node.latestValues)) $d81381f648f60915$export$58b16271041fbfb(box, node.latestValues);
    }
    /**
     * Snap tree scale back to 1 if it's within a non-perceivable threshold.
     * This will help reduce useless scales getting rendered.
     */ if (treeScale.x < $d81381f648f60915$var$TREE_SCALE_SNAP_MAX && treeScale.x > $d81381f648f60915$var$TREE_SCALE_SNAP_MIN) treeScale.x = 1.0;
    if (treeScale.y < $d81381f648f60915$var$TREE_SCALE_SNAP_MAX && treeScale.y > $d81381f648f60915$var$TREE_SCALE_SNAP_MIN) treeScale.y = 1.0;
}
function $d81381f648f60915$export$a807a5ce5ebb3895(axis, distance) {
    axis.min = axis.min + distance;
    axis.max = axis.max + distance;
}
/**
 * Apply a transform to an axis from the latest resolved motion values.
 * This function basically acts as a bridge between a flat motion value map
 * and applyAxisDelta
 */ function $d81381f648f60915$export$625f1dd140a2f5e7(axis, axisTranslate, axisScale, boxScale, axisOrigin = 0.5) {
    const originPoint = (0, $4defff8a09cc16c4$export$3bb0b4ff1037b8dd)(axis.min, axis.max, axisOrigin);
    // Apply the axis delta to the final axis
    $d81381f648f60915$export$e8e3a712e9ebf422(axis, axisTranslate, axisScale, originPoint, boxScale);
}
/**
 * Apply a transform to a box from the latest resolved motion values.
 */ function $d81381f648f60915$export$58b16271041fbfb(box, transform) {
    $d81381f648f60915$export$625f1dd140a2f5e7(box.x, transform.x, transform.scaleX, transform.scale, transform.originX);
    $d81381f648f60915$export$625f1dd140a2f5e7(box.y, transform.y, transform.scaleY, transform.scale, transform.originY);
}


function $d134b85ec35c9730$export$d8718b6a7e5c624e(instance, transformPoint) {
    return (0, $853b10d6dae64020$export$d3955c6a8f65a36b)((0, $853b10d6dae64020$export$21543fb75483a50)(instance.getBoundingClientRect(), transformPoint));
}
function $d134b85ec35c9730$export$6a597be7a7940a96(element, rootProjectionNode, transformPagePoint) {
    const viewportBox = $d134b85ec35c9730$export$d8718b6a7e5c624e(element, transformPagePoint);
    const { scroll: scroll } = rootProjectionNode;
    if (scroll) {
        (0, $d81381f648f60915$export$a807a5ce5ebb3895)(viewportBox.x, scroll.offset.x);
        (0, $d81381f648f60915$export$a807a5ce5ebb3895)(viewportBox.y, scroll.offset.y);
    }
    return viewportBox;
}









// Fixes https://github.com/framer/motion/issues/2270
const $10bda2e49bcd94d9$export$d533d84f9871c879 = ({ current: current })=>{
    return current ? current.ownerDocument.defaultView : null;
};




const $d1b0e1e998c2fee3$export$f0a15892c27dc07c = new WeakMap();
/**
 *
 */ // let latestPointerEvent: PointerEvent
class $d1b0e1e998c2fee3$export$86bff71f18910307 {
    constructor(visualElement){
        // This is a reference to the global drag gesture lock, ensuring only one component
        // can "capture" the drag of one or both axes.
        // TODO: Look into moving this into pansession?
        this.openGlobalLock = null;
        this.isDragging = false;
        this.currentDirection = null;
        this.originPoint = {
            x: 0,
            y: 0
        };
        /**
         * The permitted boundaries of travel, in pixels.
         */ this.constraints = false;
        this.hasMutatedConstraints = false;
        /**
         * The per-axis resolved elastic values.
         */ this.elastic = (0, $a33f96272a0f3ced$export$6459fc9e86be362e)();
        this.visualElement = visualElement;
    }
    start(originEvent, { snapToCursor: snapToCursor = false } = {}) {
        /**
         * Don't start dragging if this component is exiting
         */ const { presenceContext: presenceContext } = this.visualElement;
        if (presenceContext && presenceContext.isPresent === false) return;
        const onSessionStart = (event)=>{
            const { dragSnapToOrigin: dragSnapToOrigin } = this.getProps();
            // Stop or pause any animations on both axis values immediately. This allows the user to throw and catch
            // the component.
            dragSnapToOrigin ? this.pauseAnimation() : this.stopAnimation();
            if (snapToCursor) this.snapToCursor((0, $bb2968ceabdf7aba$export$12f84bb882d06e1a)(event, "page").point);
        };
        const onStart = (event, info)=>{
            var _a;
            // Attempt to grab the global drag gesture lock - maybe make this part of PanSession
            const { drag: drag, dragPropagation: dragPropagation, onDragStart: onDragStart } = this.getProps();
            if (drag && !dragPropagation) {
                if (this.openGlobalLock) this.openGlobalLock();
                this.openGlobalLock = (0, $b620b19e58064217$export$2b7959ed03c1a3fe)(drag);
                // If we don 't have the lock, don't start dragging
                if (!this.openGlobalLock) return;
            }
            this.isDragging = true;
            this.currentDirection = null;
            this.resolveConstraints();
            if (this.visualElement.projection) {
                this.visualElement.projection.isAnimationBlocked = true;
                this.visualElement.projection.target = undefined;
            }
            /**
             * Record gesture origin
             */ (0, $80571038c05c2614$export$b789de563eb43b1)((axis)=>{
                let current = this.getAxisMotionValue(axis).get() || 0;
                /**
                 * If the MotionValue is a percentage value convert to px
                 */ if ((0, $2e2cc09c72ffc0aa$export$626336c2cd4b14de).test(current)) {
                    const { projection: projection } = this.visualElement;
                    if (projection && projection.layout) {
                        const measuredAxis = projection.layout.layoutBox[axis];
                        if (measuredAxis) {
                            const length = (0, $85a652ec5cd36319$export$c1c127004b72a37)(measuredAxis);
                            current = length * (parseFloat(current) / 100);
                        }
                    }
                }
                this.originPoint[axis] = current;
            });
            // Fire onDragStart event
            if (onDragStart) (0, $2668c8a722676613$export$2cef06c20297c17d).postRender(()=>onDragStart(event, info));
            (_a = this.removeWillChange) === null || _a === void 0 || _a.call(this);
            this.removeWillChange = (0, $b79c001af895beaa$export$3ac5aed310be0bee)(this.visualElement, "transform");
            const { animationState: animationState } = this.visualElement;
            animationState && animationState.setActive("whileDrag", true);
        };
        const onMove = (event, info)=>{
            // latestPointerEvent = event
            const { dragPropagation: dragPropagation, dragDirectionLock: dragDirectionLock, onDirectionLock: onDirectionLock, onDrag: onDrag } = this.getProps();
            // If we didn't successfully receive the gesture lock, early return.
            if (!dragPropagation && !this.openGlobalLock) return;
            const { offset: offset } = info;
            // Attempt to detect drag direction if directionLock is true
            if (dragDirectionLock && this.currentDirection === null) {
                this.currentDirection = $d1b0e1e998c2fee3$var$getCurrentDirection(offset);
                // If we've successfully set a direction, notify listener
                if (this.currentDirection !== null) onDirectionLock && onDirectionLock(this.currentDirection);
                return;
            }
            // Update each point with the latest position
            this.updateAxis("x", info.point, offset);
            this.updateAxis("y", info.point, offset);
            /**
             * Ideally we would leave the renderer to fire naturally at the end of
             * this frame but if the element is about to change layout as the result
             * of a re-render we want to ensure the browser can read the latest
             * bounding box to ensure the pointer and element don't fall out of sync.
             */ this.visualElement.render();
            /**
             * This must fire after the render call as it might trigger a state
             * change which itself might trigger a layout update.
             */ onDrag && onDrag(event, info);
        };
        const onSessionEnd = (event, info)=>this.stop(event, info);
        const resumeAnimation = ()=>(0, $80571038c05c2614$export$b789de563eb43b1)((axis)=>{
                var _a;
                return this.getAnimationState(axis) === "paused" && ((_a = this.getAxisMotionValue(axis).animation) === null || _a === void 0 ? void 0 : _a.play());
            });
        const { dragSnapToOrigin: dragSnapToOrigin } = this.getProps();
        this.panSession = new (0, $4f540b18fadbcd47$export$d9c66232c9c4689c)(originEvent, {
            onSessionStart: onSessionStart,
            onStart: onStart,
            onMove: onMove,
            onSessionEnd: onSessionEnd,
            resumeAnimation: resumeAnimation
        }, {
            transformPagePoint: this.visualElement.getTransformPagePoint(),
            dragSnapToOrigin: dragSnapToOrigin,
            contextWindow: (0, $10bda2e49bcd94d9$export$d533d84f9871c879)(this.visualElement)
        });
    }
    stop(event, info) {
        var _a;
        (_a = this.removeWillChange) === null || _a === void 0 || _a.call(this);
        const isDragging = this.isDragging;
        this.cancel();
        if (!isDragging) return;
        const { velocity: velocity } = info;
        this.startAnimation(velocity);
        const { onDragEnd: onDragEnd } = this.getProps();
        if (onDragEnd) (0, $2668c8a722676613$export$2cef06c20297c17d).postRender(()=>onDragEnd(event, info));
    }
    cancel() {
        this.isDragging = false;
        const { projection: projection, animationState: animationState } = this.visualElement;
        if (projection) projection.isAnimationBlocked = false;
        this.panSession && this.panSession.end();
        this.panSession = undefined;
        const { dragPropagation: dragPropagation } = this.getProps();
        if (!dragPropagation && this.openGlobalLock) {
            this.openGlobalLock();
            this.openGlobalLock = null;
        }
        animationState && animationState.setActive("whileDrag", false);
    }
    updateAxis(axis, _point, offset) {
        const { drag: drag } = this.getProps();
        // If we're not dragging this axis, do an early return.
        if (!offset || !$d1b0e1e998c2fee3$var$shouldDrag(axis, drag, this.currentDirection)) return;
        const axisValue = this.getAxisMotionValue(axis);
        let next = this.originPoint[axis] + offset[axis];
        // Apply constraints
        if (this.constraints && this.constraints[axis]) next = (0, $bd193a823137bfc4$export$b3c764d3fca3ffe3)(next, this.constraints[axis], this.elastic[axis]);
        axisValue.set(next);
    }
    resolveConstraints() {
        var _a;
        const { dragConstraints: dragConstraints, dragElastic: dragElastic } = this.getProps();
        const layout = this.visualElement.projection && !this.visualElement.projection.layout ? this.visualElement.projection.measure(false) : (_a = this.visualElement.projection) === null || _a === void 0 ? void 0 : _a.layout;
        const prevConstraints = this.constraints;
        if (dragConstraints && (0, $ed6b374e0bfa2f8b$export$dedd81df7bc1307)(dragConstraints)) {
            if (!this.constraints) this.constraints = this.resolveRefConstraints();
        } else if (dragConstraints && layout) this.constraints = (0, $bd193a823137bfc4$export$4e9195bf7793bc78)(layout.layoutBox, dragConstraints);
        else this.constraints = false;
        this.elastic = (0, $bd193a823137bfc4$export$7c5eaef8f4723d22)(dragElastic);
        /**
         * If we're outputting to external MotionValues, we want to rebase the measured constraints
         * from viewport-relative to component-relative.
         */ if (prevConstraints !== this.constraints && layout && this.constraints && !this.hasMutatedConstraints) (0, $80571038c05c2614$export$b789de563eb43b1)((axis)=>{
            if (this.constraints !== false && this.getAxisMotionValue(axis)) this.constraints[axis] = (0, $bd193a823137bfc4$export$e9672cc4c36a8b87)(layout.layoutBox[axis], this.constraints[axis]);
        });
    }
    resolveRefConstraints() {
        const { dragConstraints: constraints, onMeasureDragConstraints: onMeasureDragConstraints } = this.getProps();
        if (!constraints || !(0, $ed6b374e0bfa2f8b$export$dedd81df7bc1307)(constraints)) return false;
        const constraintsElement = constraints.current;
        (0, $2b9100c03bd61cb5$export$f5708dca728d7177)(constraintsElement !== null, "If `dragConstraints` is set as a React ref, that ref must be passed to another component's `ref` prop.");
        const { projection: projection } = this.visualElement;
        // TODO
        if (!projection || !projection.layout) return false;
        const constraintsBox = (0, $d134b85ec35c9730$export$6a597be7a7940a96)(constraintsElement, projection.root, this.visualElement.getTransformPagePoint());
        let measuredConstraints = (0, $bd193a823137bfc4$export$4228500f19d4cdf7)(projection.layout.layoutBox, constraintsBox);
        /**
         * If there's an onMeasureDragConstraints listener we call it and
         * if different constraints are returned, set constraints to that
         */ if (onMeasureDragConstraints) {
            const userConstraints = onMeasureDragConstraints((0, $853b10d6dae64020$export$b6b9cd4198191a47)(measuredConstraints));
            this.hasMutatedConstraints = !!userConstraints;
            if (userConstraints) measuredConstraints = (0, $853b10d6dae64020$export$d3955c6a8f65a36b)(userConstraints);
        }
        return measuredConstraints;
    }
    startAnimation(velocity) {
        const { drag: drag, dragMomentum: dragMomentum, dragElastic: dragElastic, dragTransition: dragTransition, dragSnapToOrigin: dragSnapToOrigin, onDragTransitionEnd: onDragTransitionEnd } = this.getProps();
        const constraints = this.constraints || {};
        const momentumAnimations = (0, $80571038c05c2614$export$b789de563eb43b1)((axis)=>{
            if (!$d1b0e1e998c2fee3$var$shouldDrag(axis, drag, this.currentDirection)) return;
            let transition = constraints && constraints[axis] || {};
            if (dragSnapToOrigin) transition = {
                min: 0,
                max: 0
            };
            /**
             * Overdamp the boundary spring if `dragElastic` is disabled. There's still a frame
             * of spring animations so we should look into adding a disable spring option to `inertia`.
             * We could do something here where we affect the `bounceStiffness` and `bounceDamping`
             * using the value of `dragElastic`.
             */ const bounceStiffness = dragElastic ? 200 : 1000000;
            const bounceDamping = dragElastic ? 40 : 10000000;
            const inertia = {
                type: "inertia",
                velocity: dragMomentum ? velocity[axis] : 0,
                bounceStiffness: bounceStiffness,
                bounceDamping: bounceDamping,
                timeConstant: 750,
                restDelta: 1,
                restSpeed: 10,
                ...dragTransition,
                ...transition
            };
            // If we're not animating on an externally-provided `MotionValue` we can use the
            // component's animation controls which will handle interactions with whileHover (etc),
            // otherwise we just have to animate the `MotionValue` itself.
            return this.startAxisValueAnimation(axis, inertia);
        });
        // Run all animations and then resolve the new drag constraints.
        return Promise.all(momentumAnimations).then(onDragTransitionEnd);
    }
    startAxisValueAnimation(axis, transition) {
        const axisValue = this.getAxisMotionValue(axis);
        return axisValue.start((0, $30c44ca59ad5e77f$export$90b3dfc33ff3548)(axis, axisValue, 0, transition, this.visualElement, false, (0, $b79c001af895beaa$export$3ac5aed310be0bee)(this.visualElement, axis)));
    }
    stopAnimation() {
        (0, $80571038c05c2614$export$b789de563eb43b1)((axis)=>this.getAxisMotionValue(axis).stop());
    }
    pauseAnimation() {
        (0, $80571038c05c2614$export$b789de563eb43b1)((axis)=>{
            var _a;
            return (_a = this.getAxisMotionValue(axis).animation) === null || _a === void 0 ? void 0 : _a.pause();
        });
    }
    getAnimationState(axis) {
        var _a;
        return (_a = this.getAxisMotionValue(axis).animation) === null || _a === void 0 ? void 0 : _a.state;
    }
    /**
     * Drag works differently depending on which props are provided.
     *
     * - If _dragX and _dragY are provided, we output the gesture delta directly to those motion values.
     * - Otherwise, we apply the delta to the x/y motion values.
     */ getAxisMotionValue(axis) {
        const dragKey = `_drag${axis.toUpperCase()}`;
        const props = this.visualElement.getProps();
        const externalMotionValue = props[dragKey];
        return externalMotionValue ? externalMotionValue : this.visualElement.getValue(axis, (props.initial ? props.initial[axis] : undefined) || 0);
    }
    snapToCursor(point) {
        (0, $80571038c05c2614$export$b789de563eb43b1)((axis)=>{
            const { drag: drag } = this.getProps();
            // If we're not dragging this axis, do an early return.
            if (!$d1b0e1e998c2fee3$var$shouldDrag(axis, drag, this.currentDirection)) return;
            const { projection: projection } = this.visualElement;
            const axisValue = this.getAxisMotionValue(axis);
            if (projection && projection.layout) {
                const { min: min, max: max } = projection.layout.layoutBox[axis];
                axisValue.set(point[axis] - (0, $4defff8a09cc16c4$export$3bb0b4ff1037b8dd)(min, max, 0.5));
            }
        });
    }
    /**
     * When the viewport resizes we want to check if the measured constraints
     * have changed and, if so, reposition the element within those new constraints
     * relative to where it was before the resize.
     */ scalePositionWithinConstraints() {
        if (!this.visualElement.current) return;
        const { drag: drag, dragConstraints: dragConstraints } = this.getProps();
        const { projection: projection } = this.visualElement;
        if (!(0, $ed6b374e0bfa2f8b$export$dedd81df7bc1307)(dragConstraints) || !projection || !this.constraints) return;
        /**
         * Stop current animations as there can be visual glitching if we try to do
         * this mid-animation
         */ this.stopAnimation();
        /**
         * Record the relative position of the dragged element relative to the
         * constraints box and save as a progress value.
         */ const boxProgress = {
            x: 0,
            y: 0
        };
        (0, $80571038c05c2614$export$b789de563eb43b1)((axis)=>{
            const axisValue = this.getAxisMotionValue(axis);
            if (axisValue && this.constraints !== false) {
                const latest = axisValue.get();
                boxProgress[axis] = (0, $bd193a823137bfc4$export$13abbfca044ca46d)({
                    min: latest,
                    max: latest
                }, this.constraints[axis]);
            }
        });
        /**
         * Update the layout of this element and resolve the latest drag constraints
         */ const { transformTemplate: transformTemplate } = this.visualElement.getProps();
        this.visualElement.current.style.transform = transformTemplate ? transformTemplate({}, "") : "none";
        projection.root && projection.root.updateScroll();
        projection.updateLayout();
        this.resolveConstraints();
        /**
         * For each axis, calculate the current progress of the layout axis
         * within the new constraints.
         */ (0, $80571038c05c2614$export$b789de563eb43b1)((axis)=>{
            if (!$d1b0e1e998c2fee3$var$shouldDrag(axis, drag, null)) return;
            /**
             * Calculate a new transform based on the previous box progress
             */ const axisValue = this.getAxisMotionValue(axis);
            const { min: min, max: max } = this.constraints[axis];
            axisValue.set((0, $4defff8a09cc16c4$export$3bb0b4ff1037b8dd)(min, max, boxProgress[axis]));
        });
    }
    addListeners() {
        if (!this.visualElement.current) return;
        $d1b0e1e998c2fee3$export$f0a15892c27dc07c.set(this.visualElement, this);
        const element = this.visualElement.current;
        /**
         * Attach a pointerdown event listener on this DOM element to initiate drag tracking.
         */ const stopPointerListener = (0, $a2f9971c4d7d6c59$export$fcff2e64e6676b81)(element, "pointerdown", (event)=>{
            const { drag: drag, dragListener: dragListener = true } = this.getProps();
            drag && dragListener && this.start(event);
        });
        const measureDragConstraints = ()=>{
            const { dragConstraints: dragConstraints } = this.getProps();
            if ((0, $ed6b374e0bfa2f8b$export$dedd81df7bc1307)(dragConstraints) && dragConstraints.current) this.constraints = this.resolveRefConstraints();
        };
        const { projection: projection } = this.visualElement;
        const stopMeasureLayoutListener = projection.addEventListener("measure", measureDragConstraints);
        if (projection && !projection.layout) {
            projection.root && projection.root.updateScroll();
            projection.updateLayout();
        }
        (0, $2668c8a722676613$export$2cef06c20297c17d).read(measureDragConstraints);
        /**
         * Attach a window resize listener to scale the draggable target within its defined
         * constraints as the window resizes.
         */ const stopResizeListener = (0, $52bbcc091bf26590$export$b1d829ddf82884aa)(window, "resize", ()=>this.scalePositionWithinConstraints());
        /**
         * If the element's layout changes, calculate the delta and apply that to
         * the drag gesture's origin point.
         */ const stopLayoutUpdateListener = projection.addEventListener("didUpdate", ({ delta: delta, hasLayoutChanged: hasLayoutChanged })=>{
            if (this.isDragging && hasLayoutChanged) {
                (0, $80571038c05c2614$export$b789de563eb43b1)((axis)=>{
                    const motionValue = this.getAxisMotionValue(axis);
                    if (!motionValue) return;
                    this.originPoint[axis] += delta[axis].translate;
                    motionValue.set(motionValue.get() + delta[axis].translate);
                });
                this.visualElement.render();
            }
        });
        return ()=>{
            stopResizeListener();
            stopPointerListener();
            stopMeasureLayoutListener();
            stopLayoutUpdateListener && stopLayoutUpdateListener();
        };
    }
    getProps() {
        const props = this.visualElement.getProps();
        const { drag: drag = false, dragDirectionLock: dragDirectionLock = false, dragPropagation: dragPropagation = false, dragConstraints: dragConstraints = false, dragElastic: dragElastic = (0, $bd193a823137bfc4$export$a3366d3bac43a742), dragMomentum: dragMomentum = true } = props;
        return {
            ...props,
            drag: drag,
            dragDirectionLock: dragDirectionLock,
            dragPropagation: dragPropagation,
            dragConstraints: dragConstraints,
            dragElastic: dragElastic,
            dragMomentum: dragMomentum
        };
    }
}
function $d1b0e1e998c2fee3$var$shouldDrag(direction, drag, currentDirection) {
    return (drag === true || drag === direction) && (currentDirection === null || currentDirection === direction);
}
/**
 * Based on an x/y offset determine the current drag direction. If both axis' offsets are lower
 * than the provided threshold, return `null`.
 *
 * @param offset - The x/y offset from origin.
 * @param lockThreshold - (Optional) - the minimum absolute offset before we can determine a drag direction.
 */ function $d1b0e1e998c2fee3$var$getCurrentDirection(offset, lockThreshold = 10) {
    let direction = null;
    if (Math.abs(offset.y) > lockThreshold) direction = "y";
    else if (Math.abs(offset.x) > lockThreshold) direction = "x";
    return direction;
}


class $775cbfbec7f3e7b1$export$5d97dc2872682820 extends (0, $0e2551b19b8df95b$export$6e91cf7616333d5) {
    constructor(node){
        super(node);
        this.removeGroupControls = (0, $c90734627ed96e3f$export$8793edee2d425525);
        this.removeListeners = (0, $c90734627ed96e3f$export$8793edee2d425525);
        this.controls = new (0, $d1b0e1e998c2fee3$export$86bff71f18910307)(node);
    }
    mount() {
        // If we've been provided a DragControls for manual control over the drag gesture,
        // subscribe this component to it on mount.
        const { dragControls: dragControls } = this.node.getProps();
        if (dragControls) this.removeGroupControls = dragControls.subscribe(this.controls);
        this.removeListeners = this.controls.addListeners() || (0, $c90734627ed96e3f$export$8793edee2d425525);
    }
    unmount() {
        this.removeGroupControls();
        this.removeListeners();
    }
}








const $eb5b67e8076eeec3$var$asyncHandler = (handler)=>(event, info)=>{
        if (handler) (0, $2668c8a722676613$export$2cef06c20297c17d).postRender(()=>handler(event, info));
    };
class $eb5b67e8076eeec3$export$b4f8f1ee75ce5859 extends (0, $0e2551b19b8df95b$export$6e91cf7616333d5) {
    constructor(){
        super(...arguments);
        this.removePointerDownListener = (0, $c90734627ed96e3f$export$8793edee2d425525);
    }
    onPointerDown(pointerDownEvent) {
        this.session = new (0, $4f540b18fadbcd47$export$d9c66232c9c4689c)(pointerDownEvent, this.createPanHandlers(), {
            transformPagePoint: this.node.getTransformPagePoint(),
            contextWindow: (0, $10bda2e49bcd94d9$export$d533d84f9871c879)(this.node)
        });
    }
    createPanHandlers() {
        const { onPanSessionStart: onPanSessionStart, onPanStart: onPanStart, onPan: onPan, onPanEnd: onPanEnd } = this.node.getProps();
        return {
            onSessionStart: $eb5b67e8076eeec3$var$asyncHandler(onPanSessionStart),
            onStart: $eb5b67e8076eeec3$var$asyncHandler(onPanStart),
            onMove: onPan,
            onEnd: (event, info)=>{
                delete this.session;
                if (onPanEnd) (0, $2668c8a722676613$export$2cef06c20297c17d).postRender(()=>onPanEnd(event, info));
            }
        };
    }
    mount() {
        this.removePointerDownListener = (0, $a2f9971c4d7d6c59$export$fcff2e64e6676b81)(this.node.current, "pointerdown", (event)=>this.onPointerDown(event));
    }
    update() {
        this.session && this.session.updateHandlers(this.createPanHandlers());
    }
    unmount() {
        this.removePointerDownListener();
        this.session && this.session.end();
    }
}



var $dRzna = parcelRequire("dRzna");

var $eeH7J = parcelRequire("eeH7J");

var $eeH7J = parcelRequire("eeH7J");

var $eeH7J = parcelRequire("eeH7J");
"use client";
/**
 * @public
 */ const $2026c3a36ffa4174$export$f224e4635b6f8ce2 = (0, $eeH7J.createContext)(null);


/**
 * When a component is the child of `AnimatePresence`, it can use `usePresence`
 * to access information about whether it's still present in the React tree.
 *
 * ```jsx
 * import { usePresence } from "framer-motion"
 *
 * export const Component = () => {
 *   const [isPresent, safeToRemove] = usePresence()
 *
 *   useEffect(() => {
 *     !isPresent && setTimeout(safeToRemove, 1000)
 *   }, [isPresent])
 *
 *   return <div />
 * }
 * ```
 *
 * If `isPresent` is `false`, it means that a component has been removed the tree, but
 * `AnimatePresence` won't really remove it until `safeToRemove` has been called.
 *
 * @public
 */ function $d9315986bafdadde$export$2a8c16d82a0a0e26() {
    const context = (0, $eeH7J.useContext)((0, $2026c3a36ffa4174$export$f224e4635b6f8ce2));
    if (context === null) return [
        true,
        null
    ];
    const { isPresent: isPresent, onExitComplete: onExitComplete, register: register } = context;
    // It's safe to call the following hooks conditionally (after an early return) because the context will always
    // either be null or non-null for the lifespan of the component.
    const id = (0, $eeH7J.useId)();
    (0, $eeH7J.useEffect)(()=>register(id), []);
    const safeToRemove = (0, $eeH7J.useCallback)(()=>onExitComplete && onExitComplete(id), [
        id,
        onExitComplete
    ]);
    return !isPresent && onExitComplete ? [
        false,
        safeToRemove
    ] : [
        true
    ];
}
/**
 * Similar to `usePresence`, except `useIsPresent` simply returns whether or not the component is present.
 * There is no `safeToRemove` function.
 *
 * ```jsx
 * import { useIsPresent } from "framer-motion"
 *
 * export const Component = () => {
 *   const isPresent = useIsPresent()
 *
 *   useEffect(() => {
 *     !isPresent && console.log("I've been removed!")
 *   }, [isPresent])
 *
 *   return <div />
 * }
 * ```
 *
 * @public
 */ function $d9315986bafdadde$export$8249053f690ea39a() {
    return $d9315986bafdadde$export$ee27c052bca048fb((0, $eeH7J.useContext)((0, $2026c3a36ffa4174$export$f224e4635b6f8ce2)));
}
function $d9315986bafdadde$export$ee27c052bca048fb(context) {
    return context === null ? true : context.isPresent;
}




var $eeH7J = parcelRequire("eeH7J");
"use client";
/**
 * Internal, exported only for usage in Framer
 */ const $d06770095535cbfe$export$da5f7b802957459a = (0, $eeH7J.createContext)({});


/**
 * This should only ever be modified on the client otherwise it'll
 * persist through server requests. If we need instanced states we
 * could lazy-init via root.
 */ const $dd7235250d7597e1$export$97db156a3ed1593b = {
    /**
     * Global flag as to whether the tree has animated since the last time
     * we resized the window
     */ hasAnimatedSinceResize: true,
    /**
     * We set this to true once, on the first update. Any nodes added to the tree beyond that
     * update will be given a `data-projection-id` attribute.
     */ hasEverUpdated: false
};



function $888b4d29b2b48cec$export$fafff692be55225d(pixels, axis) {
    if (axis.max === axis.min) return 0;
    return pixels / (axis.max - axis.min) * 100;
}
/**
 * We always correct borderRadius as a percentage rather than pixels to reduce paints.
 * For example, if you are projecting a box that is 100px wide with a 10px borderRadius
 * into a box that is 200px wide with a 20px borderRadius, that is actually a 10%
 * borderRadius in both states. If we animate between the two in pixels that will trigger
 * a paint each time. If we animate between the two in percentage we'll avoid a paint.
 */ const $888b4d29b2b48cec$export$5eafb6257a5844c = {
    correct: (latest, node)=>{
        if (!node.target) return latest;
        /**
         * If latest is a string, if it's a percentage we can return immediately as it's
         * going to be stretched appropriately. Otherwise, if it's a pixel, convert it to a number.
         */ if (typeof latest === "string") {
            if ((0, $2e2cc09c72ffc0aa$export$91c0eda1d06bf008).test(latest)) latest = parseFloat(latest);
            else return latest;
        }
        /**
         * If latest is a number, it's a pixel value. We use the current viewportBox to calculate that
         * pixel value as a percentage of each axis
         */ const x = $888b4d29b2b48cec$export$fafff692be55225d(latest, node.target.x);
        const y = $888b4d29b2b48cec$export$fafff692be55225d(latest, node.target.y);
        return `${x}% ${y}%`;
    }
};




const $df3eae19b27a85ae$export$eb0bc629e74dcf8 = {
    correct: (latest, { treeScale: treeScale, projectionDelta: projectionDelta })=>{
        const original = latest;
        const shadow = (0, $4c282419bf833d7f$export$83a0e34f1302825b).parse(latest);
        // TODO: Doesn't support multiple shadows
        if (shadow.length > 5) return original;
        const template = (0, $4c282419bf833d7f$export$83a0e34f1302825b).createTransformer(latest);
        const offset = typeof shadow[0] !== "number" ? 1 : 0;
        // Calculate the overall context scale
        const xScale = projectionDelta.x.scale * treeScale.x;
        const yScale = projectionDelta.y.scale * treeScale.y;
        shadow[0 + offset] /= xScale;
        shadow[1 + offset] /= yScale;
        /**
         * Ideally we'd correct x and y scales individually, but because blur and
         * spread apply to both we have to take a scale average and apply that instead.
         * We could potentially improve the outcome of this by incorporating the ratio between
         * the two scales.
         */ const averageScale = (0, $4defff8a09cc16c4$export$3bb0b4ff1037b8dd)(xScale, yScale, 0.5);
        // Blur
        if (typeof shadow[2 + offset] === "number") shadow[2 + offset] /= averageScale;
        // Spread
        if (typeof shadow[3 + offset] === "number") shadow[3 + offset] /= averageScale;
        return template(shadow);
    }
};


const $5a27ca56288b5194$export$91ddd985b97788d1 = {};
function $5a27ca56288b5194$export$de9e7791c71225fd(correctors) {
    Object.assign($5a27ca56288b5194$export$91ddd985b97788d1, correctors);
}



const { schedule: $56c6f990d38070fe$export$bb76eed83315504c, cancel: $56c6f990d38070fe$export$3252729004b8456e } = (0, $3e80ba1fbbf06577$export$510b0596a933801a)(queueMicrotask, false);



"use client";
class $6d3ffb27b820752c$var$MeasureLayoutWithContext extends (0, $eeH7J.Component) {
    /**
     * This only mounts projection nodes for components that
     * need measuring, we might want to do it for all components
     * in order to incorporate transforms
     */ componentDidMount() {
        const { visualElement: visualElement, layoutGroup: layoutGroup, switchLayoutGroup: switchLayoutGroup, layoutId: layoutId } = this.props;
        const { projection: projection } = visualElement;
        (0, $5a27ca56288b5194$export$de9e7791c71225fd)($6d3ffb27b820752c$var$defaultScaleCorrectors);
        if (projection) {
            if (layoutGroup.group) layoutGroup.group.add(projection);
            if (switchLayoutGroup && switchLayoutGroup.register && layoutId) switchLayoutGroup.register(projection);
            projection.root.didUpdate();
            projection.addEventListener("animationComplete", ()=>{
                this.safeToRemove();
            });
            projection.setOptions({
                ...projection.options,
                onExitComplete: ()=>this.safeToRemove()
            });
        }
        (0, $dd7235250d7597e1$export$97db156a3ed1593b).hasEverUpdated = true;
    }
    getSnapshotBeforeUpdate(prevProps) {
        const { layoutDependency: layoutDependency, visualElement: visualElement, drag: drag, isPresent: isPresent } = this.props;
        const projection = visualElement.projection;
        if (!projection) return null;
        /**
         * TODO: We use this data in relegate to determine whether to
         * promote a previous element. There's no guarantee its presence data
         * will have updated by this point - if a bug like this arises it will
         * have to be that we markForRelegation and then find a new lead some other way,
         * perhaps in didUpdate
         */ projection.isPresent = isPresent;
        if (drag || prevProps.layoutDependency !== layoutDependency || layoutDependency === undefined) projection.willUpdate();
        else this.safeToRemove();
        if (prevProps.isPresent !== isPresent) {
            if (isPresent) projection.promote();
            else if (!projection.relegate()) /**
                 * If there's another stack member taking over from this one,
                 * it's in charge of the exit animation and therefore should
                 * be in charge of the safe to remove. Otherwise we call it here.
                 */ (0, $2668c8a722676613$export$2cef06c20297c17d).postRender(()=>{
                const stack = projection.getStack();
                if (!stack || !stack.members.length) this.safeToRemove();
            });
        }
        return null;
    }
    componentDidUpdate() {
        const { projection: projection } = this.props.visualElement;
        if (projection) {
            projection.root.didUpdate();
            (0, $56c6f990d38070fe$export$bb76eed83315504c).postRender(()=>{
                if (!projection.currentAnimation && projection.isLead()) this.safeToRemove();
            });
        }
    }
    componentWillUnmount() {
        const { visualElement: visualElement, layoutGroup: layoutGroup, switchLayoutGroup: promoteContext } = this.props;
        const { projection: projection } = visualElement;
        if (projection) {
            projection.scheduleCheckAfterUnmount();
            if (layoutGroup && layoutGroup.group) layoutGroup.group.remove(projection);
            if (promoteContext && promoteContext.deregister) promoteContext.deregister(projection);
        }
    }
    safeToRemove() {
        const { safeToRemove: safeToRemove } = this.props;
        safeToRemove && safeToRemove();
    }
    render() {
        return null;
    }
}
function $6d3ffb27b820752c$export$779f5fb01ad751cd(props) {
    const [isPresent, safeToRemove] = (0, $d9315986bafdadde$export$2a8c16d82a0a0e26)();
    const layoutGroup = (0, $eeH7J.useContext)((0, $7e832de67499b416$export$a3579ca508007a95));
    return (0, $dRzna.jsx)($6d3ffb27b820752c$var$MeasureLayoutWithContext, {
        ...props,
        layoutGroup: layoutGroup,
        switchLayoutGroup: (0, $eeH7J.useContext)((0, $d06770095535cbfe$export$da5f7b802957459a)),
        isPresent: isPresent,
        safeToRemove: safeToRemove
    });
}
const $6d3ffb27b820752c$var$defaultScaleCorrectors = {
    borderRadius: {
        ...(0, $888b4d29b2b48cec$export$5eafb6257a5844c),
        applyTo: [
            "borderTopLeftRadius",
            "borderTopRightRadius",
            "borderBottomLeftRadius",
            "borderBottomRightRadius"
        ]
    },
    borderTopLeftRadius: (0, $888b4d29b2b48cec$export$5eafb6257a5844c),
    borderTopRightRadius: (0, $888b4d29b2b48cec$export$5eafb6257a5844c),
    borderBottomLeftRadius: (0, $888b4d29b2b48cec$export$5eafb6257a5844c),
    borderBottomRightRadius: (0, $888b4d29b2b48cec$export$5eafb6257a5844c),
    boxShadow: (0, $df3eae19b27a85ae$export$eb0bc629e74dcf8)
};








const $21f9a46747b133ed$var$borders = [
    "TopLeft",
    "TopRight",
    "BottomLeft",
    "BottomRight"
];
const $21f9a46747b133ed$var$numBorders = $21f9a46747b133ed$var$borders.length;
const $21f9a46747b133ed$var$asNumber = (value)=>typeof value === "string" ? parseFloat(value) : value;
const $21f9a46747b133ed$var$isPx = (value)=>typeof value === "number" || (0, $2e2cc09c72ffc0aa$export$91c0eda1d06bf008).test(value);
function $21f9a46747b133ed$export$739e279c17d51c3d(target, follow, lead, progress, shouldCrossfadeOpacity, isOnlyMember) {
    if (shouldCrossfadeOpacity) {
        target.opacity = (0, $4defff8a09cc16c4$export$3bb0b4ff1037b8dd)(0, // TODO Reinstate this if only child
        lead.opacity !== undefined ? lead.opacity : 1, $21f9a46747b133ed$var$easeCrossfadeIn(progress));
        target.opacityExit = (0, $4defff8a09cc16c4$export$3bb0b4ff1037b8dd)(follow.opacity !== undefined ? follow.opacity : 1, 0, $21f9a46747b133ed$var$easeCrossfadeOut(progress));
    } else if (isOnlyMember) target.opacity = (0, $4defff8a09cc16c4$export$3bb0b4ff1037b8dd)(follow.opacity !== undefined ? follow.opacity : 1, lead.opacity !== undefined ? lead.opacity : 1, progress);
    /**
     * Mix border radius
     */ for(let i = 0; i < $21f9a46747b133ed$var$numBorders; i++){
        const borderLabel = `border${$21f9a46747b133ed$var$borders[i]}Radius`;
        let followRadius = $21f9a46747b133ed$var$getRadius(follow, borderLabel);
        let leadRadius = $21f9a46747b133ed$var$getRadius(lead, borderLabel);
        if (followRadius === undefined && leadRadius === undefined) continue;
        followRadius || (followRadius = 0);
        leadRadius || (leadRadius = 0);
        const canMix = followRadius === 0 || leadRadius === 0 || $21f9a46747b133ed$var$isPx(followRadius) === $21f9a46747b133ed$var$isPx(leadRadius);
        if (canMix) {
            target[borderLabel] = Math.max((0, $4defff8a09cc16c4$export$3bb0b4ff1037b8dd)($21f9a46747b133ed$var$asNumber(followRadius), $21f9a46747b133ed$var$asNumber(leadRadius), progress), 0);
            if ((0, $2e2cc09c72ffc0aa$export$626336c2cd4b14de).test(leadRadius) || (0, $2e2cc09c72ffc0aa$export$626336c2cd4b14de).test(followRadius)) target[borderLabel] += "%";
        } else target[borderLabel] = leadRadius;
    }
    /**
     * Mix rotation
     */ if (follow.rotate || lead.rotate) target.rotate = (0, $4defff8a09cc16c4$export$3bb0b4ff1037b8dd)(follow.rotate || 0, lead.rotate || 0, progress);
}
function $21f9a46747b133ed$var$getRadius(values, radiusName) {
    return values[radiusName] !== undefined ? values[radiusName] : values.borderRadius;
}
// /**
//  * We only want to mix the background color if there's a follow element
//  * that we're not crossfading opacity between. For instance with switch
//  * AnimateSharedLayout animations, this helps the illusion of a continuous
//  * element being animated but also cuts down on the number of paints triggered
//  * for elements where opacity is doing that work for us.
//  */
// if (
//     !hasFollowElement &&
//     latestLeadValues.backgroundColor &&
//     latestFollowValues.backgroundColor
// ) {
//     /**
//      * This isn't ideal performance-wise as mixColor is creating a new function every frame.
//      * We could probably create a mixer that runs at the start of the animation but
//      * the idea behind the crossfader is that it runs dynamically between two potentially
//      * changing targets (ie opacity or borderRadius may be animating independently via variants)
//      */
//     leadState.backgroundColor = followState.backgroundColor = mixColor(
//         latestFollowValues.backgroundColor as string,
//         latestLeadValues.backgroundColor as string
//     )(p)
// }
const $21f9a46747b133ed$var$easeCrossfadeIn = /*@__PURE__*/ $21f9a46747b133ed$var$compress(0, 0.5, (0, $fefb9f2108604c18$export$c8d67a19199d1a50));
const $21f9a46747b133ed$var$easeCrossfadeOut = /*@__PURE__*/ $21f9a46747b133ed$var$compress(0.5, 0.95, (0, $c90734627ed96e3f$export$8793edee2d425525));
function $21f9a46747b133ed$var$compress(min, max, easing) {
    return (p)=>{
        // Could replace ifs with clamp
        if (p < min) return 0;
        if (p > max) return 1;
        return easing((0, $482d3e1965098f2a$export$504d7abb21fa8c9)(min, max, p));
    };
}


/**
 * Reset an axis to the provided origin box.
 *
 * This is a mutative operation.
 */ function $eb323b55846adefd$export$a0230ae482601ae8(axis, originAxis) {
    axis.min = originAxis.min;
    axis.max = originAxis.max;
}
/**
 * Reset a box to the provided origin box.
 *
 * This is a mutative operation.
 */ function $eb323b55846adefd$export$c53fd88f45d77e4b(box, originBox) {
    $eb323b55846adefd$export$a0230ae482601ae8(box.x, originBox.x);
    $eb323b55846adefd$export$a0230ae482601ae8(box.y, originBox.y);
}
/**
 * Reset a delta to the provided origin box.
 *
 * This is a mutative operation.
 */ function $eb323b55846adefd$export$8ead6a7d6b225ef(delta, originDelta) {
    delta.translate = originDelta.translate;
    delta.scale = originDelta.scale;
    delta.originPoint = originDelta.originPoint;
    delta.origin = originDelta.origin;
}







/**
 * Remove a delta from a point. This is essentially the steps of applyPointDelta in reverse
 */ function $3cca3361c07be144$export$691f07066b3be7c5(point, translate, scale, originPoint, boxScale) {
    point -= translate;
    point = (0, $d81381f648f60915$export$2290ec7febe36dd6)(point, 1 / scale, originPoint);
    if (boxScale !== undefined) point = (0, $d81381f648f60915$export$2290ec7febe36dd6)(point, 1 / boxScale, originPoint);
    return point;
}
/**
 * Remove a delta from an axis. This is essentially the steps of applyAxisDelta in reverse
 */ function $3cca3361c07be144$export$cc12a0672fae5b4a(axis, translate = 0, scale = 1, origin = 0.5, boxScale, originAxis = axis, sourceAxis = axis) {
    if ((0, $2e2cc09c72ffc0aa$export$626336c2cd4b14de).test(translate)) {
        translate = parseFloat(translate);
        const relativeProgress = (0, $4defff8a09cc16c4$export$3bb0b4ff1037b8dd)(sourceAxis.min, sourceAxis.max, translate / 100);
        translate = relativeProgress - sourceAxis.min;
    }
    if (typeof translate !== "number") return;
    let originPoint = (0, $4defff8a09cc16c4$export$3bb0b4ff1037b8dd)(originAxis.min, originAxis.max, origin);
    if (axis === originAxis) originPoint -= translate;
    axis.min = $3cca3361c07be144$export$691f07066b3be7c5(axis.min, translate, scale, originPoint, boxScale);
    axis.max = $3cca3361c07be144$export$691f07066b3be7c5(axis.max, translate, scale, originPoint, boxScale);
}
/**
 * Remove a transforms from an axis. This is essentially the steps of applyAxisTransforms in reverse
 * and acts as a bridge between motion values and removeAxisDelta
 */ function $3cca3361c07be144$export$42b76f1d0d16d5b(axis, transforms, [key, scaleKey, originKey], origin, sourceAxis) {
    $3cca3361c07be144$export$cc12a0672fae5b4a(axis, transforms[key], transforms[scaleKey], transforms[originKey], transforms.scale, origin, sourceAxis);
}
/**
 * The names of the motion values we want to apply as translation, scale and origin.
 */ const $3cca3361c07be144$var$xKeys = [
    "x",
    "scaleX",
    "originX"
];
const $3cca3361c07be144$var$yKeys = [
    "y",
    "scaleY",
    "originY"
];
/**
 * Remove a transforms from an box. This is essentially the steps of applyAxisBox in reverse
 * and acts as a bridge between motion values and removeAxisDelta
 */ function $3cca3361c07be144$export$73e1ad0a9694e25c(box, transforms, originBox, sourceBox) {
    $3cca3361c07be144$export$42b76f1d0d16d5b(box.x, transforms, $3cca3361c07be144$var$xKeys, originBox ? originBox.x : undefined, sourceBox ? sourceBox.x : undefined);
    $3cca3361c07be144$export$42b76f1d0d16d5b(box.y, transforms, $3cca3361c07be144$var$yKeys, originBox ? originBox.y : undefined, sourceBox ? sourceBox.y : undefined);
}




function $6ce12b205c4c79ac$var$isAxisDeltaZero(delta) {
    return delta.translate === 0 && delta.scale === 1;
}
function $6ce12b205c4c79ac$export$a7ec7642fe550fb6(delta) {
    return $6ce12b205c4c79ac$var$isAxisDeltaZero(delta.x) && $6ce12b205c4c79ac$var$isAxisDeltaZero(delta.y);
}
function $6ce12b205c4c79ac$export$7a9a6f114ddd0fdb(a, b) {
    return a.min === b.min && a.max === b.max;
}
function $6ce12b205c4c79ac$export$8d5cf76bb7daff09(a, b) {
    return $6ce12b205c4c79ac$export$7a9a6f114ddd0fdb(a.x, b.x) && $6ce12b205c4c79ac$export$7a9a6f114ddd0fdb(a.y, b.y);
}
function $6ce12b205c4c79ac$export$22adf28bfca1c186(a, b) {
    return Math.round(a.min) === Math.round(b.min) && Math.round(a.max) === Math.round(b.max);
}
function $6ce12b205c4c79ac$export$ef641b782d85522(a, b) {
    return $6ce12b205c4c79ac$export$22adf28bfca1c186(a.x, b.x) && $6ce12b205c4c79ac$export$22adf28bfca1c186(a.y, b.y);
}
function $6ce12b205c4c79ac$export$c5706146bc63213(box) {
    return (0, $85a652ec5cd36319$export$c1c127004b72a37)(box.x) / (0, $85a652ec5cd36319$export$c1c127004b72a37)(box.y);
}
function $6ce12b205c4c79ac$export$444620505e28fe92(a, b) {
    return a.translate === b.translate && a.scale === b.scale && a.originPoint === b.originPoint;
}



class $46c35e490a5123a4$export$39be5b2d82fc9dc7 {
    constructor(){
        this.members = [];
    }
    add(node) {
        (0, $51a4ba498ba1dae1$export$20e507e47fae79fd)(this.members, node);
        node.scheduleRender();
    }
    remove(node) {
        (0, $51a4ba498ba1dae1$export$fe2d9b4e03920b4c)(this.members, node);
        if (node === this.prevLead) this.prevLead = undefined;
        if (node === this.lead) {
            const prevLead = this.members[this.members.length - 1];
            if (prevLead) this.promote(prevLead);
        }
    }
    relegate(node) {
        const indexOfNode = this.members.findIndex((member)=>node === member);
        if (indexOfNode === 0) return false;
        /**
         * Find the next projection node that is present
         */ let prevLead;
        for(let i = indexOfNode; i >= 0; i--){
            const member = this.members[i];
            if (member.isPresent !== false) {
                prevLead = member;
                break;
            }
        }
        if (prevLead) {
            this.promote(prevLead);
            return true;
        } else return false;
    }
    promote(node, preserveFollowOpacity) {
        const prevLead = this.lead;
        if (node === prevLead) return;
        this.prevLead = prevLead;
        this.lead = node;
        node.show();
        if (prevLead) {
            prevLead.instance && prevLead.scheduleRender();
            node.scheduleRender();
            node.resumeFrom = prevLead;
            if (preserveFollowOpacity) node.resumeFrom.preserveOpacity = true;
            if (prevLead.snapshot) {
                node.snapshot = prevLead.snapshot;
                node.snapshot.latestValues = prevLead.animationValues || prevLead.latestValues;
            }
            if (node.root && node.root.isUpdating) node.isLayoutDirty = true;
            const { crossfade: crossfade } = node.options;
            if (crossfade === false) prevLead.hide();
        /**
             * TODO:
             *   - Test border radius when previous node was deleted
             *   - boxShadow mixing
             *   - Shared between element A in scrolled container and element B (scroll stays the same or changes)
             *   - Shared between element A in transformed container and element B (transform stays the same or changes)
             *   - Shared between element A in scrolled page and element B (scroll stays the same or changes)
             * ---
             *   - Crossfade opacity of root nodes
             *   - layoutId changes after animation
             *   - layoutId changes mid animation
             */ }
    }
    exitAnimationComplete() {
        this.members.forEach((node)=>{
            const { options: options, resumingFrom: resumingFrom } = node;
            options.onExitComplete && options.onExitComplete();
            if (resumingFrom) resumingFrom.options.onExitComplete && resumingFrom.options.onExitComplete();
        });
    }
    scheduleRender() {
        this.members.forEach((node)=>{
            node.instance && node.scheduleRender(false);
        });
    }
    /**
     * Clear any leads that have been removed this render to prevent them from being
     * used in future animations and to prevent memory leaks
     */ removeLeadSnapshot() {
        if (this.lead && this.lead.snapshot) this.lead.snapshot = undefined;
    }
}



function $262abd317fffbdb0$export$d33653b270fe725c(delta, treeScale, latestTransform) {
    let transform = "";
    /**
     * The translations we use to calculate are always relative to the viewport coordinate space.
     * But when we apply scales, we also scale the coordinate space of an element and its children.
     * For instance if we have a treeScale (the culmination of all parent scales) of 0.5 and we need
     * to move an element 100 pixels, we actually need to move it 200 in within that scaled space.
     */ const xTranslate = delta.x.translate / treeScale.x;
    const yTranslate = delta.y.translate / treeScale.y;
    const zTranslate = (latestTransform === null || latestTransform === void 0 ? void 0 : latestTransform.z) || 0;
    if (xTranslate || yTranslate || zTranslate) transform = `translate3d(${xTranslate}px, ${yTranslate}px, ${zTranslate}px) `;
    /**
     * Apply scale correction for the tree transform.
     * This will apply scale to the screen-orientated axes.
     */ if (treeScale.x !== 1 || treeScale.y !== 1) transform += `scale(${1 / treeScale.x}, ${1 / treeScale.y}) `;
    if (latestTransform) {
        const { transformPerspective: transformPerspective, rotate: rotate, rotateX: rotateX, rotateY: rotateY, skewX: skewX, skewY: skewY } = latestTransform;
        if (transformPerspective) transform = `perspective(${transformPerspective}px) ${transform}`;
        if (rotate) transform += `rotate(${rotate}deg) `;
        if (rotateX) transform += `rotateX(${rotateX}deg) `;
        if (rotateY) transform += `rotateY(${rotateY}deg) `;
        if (skewX) transform += `skewX(${skewX}deg) `;
        if (skewY) transform += `skewY(${skewY}deg) `;
    }
    /**
     * Apply scale to match the size of the element to the size we want it.
     * This will apply scale to the element-orientated axes.
     */ const elementScaleX = delta.x.scale * treeScale.x;
    const elementScaleY = delta.y.scale * treeScale.y;
    if (elementScaleX !== 1 || elementScaleY !== 1) transform += `scale(${elementScaleX}, ${elementScaleY})`;
    return transform || "none";
}





const $c4735a9fd08448c1$export$d689d9dec5ad338 = (a, b)=>a.depth - b.depth;


class $bc96ab5be3a8112a$export$1465d17e3de78a96 {
    constructor(){
        this.children = [];
        this.isDirty = false;
    }
    add(child) {
        (0, $51a4ba498ba1dae1$export$20e507e47fae79fd)(this.children, child);
        this.isDirty = true;
    }
    remove(child) {
        (0, $51a4ba498ba1dae1$export$fe2d9b4e03920b4c)(this.children, child);
        this.isDirty = true;
    }
    forEach(callback) {
        this.isDirty && this.children.sort((0, $c4735a9fd08448c1$export$d689d9dec5ad338));
        this.isDirty = false;
        this.children.forEach(callback);
    }
}




/**
 * If the provided value is a MotionValue, this returns the actual value, otherwise just the value itself
 *
 * TODO: Remove and move to library
 */ function $afcd820fe2a95f42$export$fcc2206ecb6d74b(value) {
    const unwrappedValue = (0, $97dfd46cf2e43daf$export$605d60a2578142d3)(value) ? value.get() : value;
    return (0, $5886206991be4714$export$2f308ad9864b3ac9)(unwrappedValue) ? unwrappedValue.toValue() : unwrappedValue;
}





/**
 * Timeout defined in ms
 */ function $9eaf236b0880c674$export$1391212d75b2ee65(callback, timeout) {
    const start = (0, $3a6da39b219d0ac7$export$2da9be4cfdb689b1).now();
    const checkElapsed = ({ timestamp: timestamp })=>{
        const elapsed = timestamp - start;
        if (elapsed >= timeout) {
            (0, $2668c8a722676613$export$ec99c0ef4978dccb)(checkElapsed);
            callback(elapsed - timeout);
        }
    };
    (0, $2668c8a722676613$export$2cef06c20297c17d).read(checkElapsed, true);
    return ()=>(0, $2668c8a722676613$export$ec99c0ef4978dccb)(checkElapsed);
}



function $cd7f8f0ad0976f3a$export$17eda790a720ec57(element) {
    return element instanceof SVGElement && element.tagName !== "svg";
}





function $0840febc4398c738$export$335a17c977067b99(value, keyframes, options) {
    const motionValue$1 = (0, $97dfd46cf2e43daf$export$605d60a2578142d3)(value) ? value : (0, $ebb6b8b1a738bf1d$export$ce8bdc721e76545f)(value);
    motionValue$1.start((0, $30c44ca59ad5e77f$export$90b3dfc33ff3548)("", motionValue$1, keyframes, options));
    return motionValue$1.animation;
}









const $484678f694ff2da1$var$metrics = {
    type: "projectionFrame",
    totalNodes: 0,
    resolvedTargetDeltas: 0,
    recalculatedProjection: 0
};
const $484678f694ff2da1$var$isDebug = typeof window !== "undefined" && window.MotionDebug !== undefined;
const $484678f694ff2da1$var$transformAxes = [
    "",
    "X",
    "Y",
    "Z"
];
const $484678f694ff2da1$var$hiddenVisibility = {
    visibility: "hidden"
};
/**
 * We use 1000 as the animation target as 0-1000 maps better to pixels than 0-1
 * which has a noticeable difference in spring animations
 */ const $484678f694ff2da1$var$animationTarget = 1000;
let $484678f694ff2da1$var$id = 0;
function $484678f694ff2da1$var$resetDistortingTransform(key, visualElement, values, sharedAnimationValues) {
    const { latestValues: latestValues } = visualElement;
    // Record the distorting transform and then temporarily set it to 0
    if (latestValues[key]) {
        values[key] = latestValues[key];
        visualElement.setStaticValue(key, 0);
        if (sharedAnimationValues) sharedAnimationValues[key] = 0;
    }
}
function $484678f694ff2da1$var$cancelTreeOptimisedTransformAnimations(projectionNode) {
    projectionNode.hasCheckedOptimisedAppear = true;
    if (projectionNode.root === projectionNode) return;
    const { visualElement: visualElement } = projectionNode.options;
    if (!visualElement) return;
    const appearId = (0, $355e745a41ba8ef0$export$5f8d21e84d1d84fc)(visualElement);
    if (window.MotionHasOptimisedAnimation(appearId, "transform")) {
        const { layout: layout, layoutId: layoutId } = projectionNode.options;
        window.MotionCancelOptimisedAnimation(appearId, "transform", (0, $2668c8a722676613$export$2cef06c20297c17d), !(layout || layoutId));
    }
    const { parent: parent } = projectionNode;
    if (parent && !parent.hasCheckedOptimisedAppear) $484678f694ff2da1$var$cancelTreeOptimisedTransformAnimations(parent);
}
function $484678f694ff2da1$export$a84b61f69daa9da0({ attachResizeListener: attachResizeListener, defaultParent: defaultParent, measureScroll: measureScroll, checkIsScrollRoot: checkIsScrollRoot, resetTransform: resetTransform }) {
    return class ProjectionNode {
        constructor(latestValues = {}, parent = defaultParent === null || defaultParent === void 0 ? void 0 : defaultParent()){
            /**
             * A unique ID generated for every projection node.
             */ this.id = $484678f694ff2da1$var$id++;
            /**
             * An id that represents a unique session instigated by startUpdate.
             */ this.animationId = 0;
            /**
             * A Set containing all this component's children. This is used to iterate
             * through the children.
             *
             * TODO: This could be faster to iterate as a flat array stored on the root node.
             */ this.children = new Set();
            /**
             * Options for the node. We use this to configure what kind of layout animations
             * we should perform (if any).
             */ this.options = {};
            /**
             * We use this to detect when its safe to shut down part of a projection tree.
             * We have to keep projecting children for scale correction and relative projection
             * until all their parents stop performing layout animations.
             */ this.isTreeAnimating = false;
            this.isAnimationBlocked = false;
            /**
             * Flag to true if we think this layout has been changed. We can't always know this,
             * currently we set it to true every time a component renders, or if it has a layoutDependency
             * if that has changed between renders. Additionally, components can be grouped by LayoutGroup
             * and if one node is dirtied, they all are.
             */ this.isLayoutDirty = false;
            /**
             * Flag to true if we think the projection calculations for this node needs
             * recalculating as a result of an updated transform or layout animation.
             */ this.isProjectionDirty = false;
            /**
             * Flag to true if the layout *or* transform has changed. This then gets propagated
             * throughout the projection tree, forcing any element below to recalculate on the next frame.
             */ this.isSharedProjectionDirty = false;
            /**
             * Flag transform dirty. This gets propagated throughout the whole tree but is only
             * respected by shared nodes.
             */ this.isTransformDirty = false;
            /**
             * Block layout updates for instant layout transitions throughout the tree.
             */ this.updateManuallyBlocked = false;
            this.updateBlockedByResize = false;
            /**
             * Set to true between the start of the first `willUpdate` call and the end of the `didUpdate`
             * call.
             */ this.isUpdating = false;
            /**
             * If this is an SVG element we currently disable projection transforms
             */ this.isSVG = false;
            /**
             * Flag to true (during promotion) if a node doing an instant layout transition needs to reset
             * its projection styles.
             */ this.needsReset = false;
            /**
             * Flags whether this node should have its transform reset prior to measuring.
             */ this.shouldResetTransform = false;
            /**
             * Store whether this node has been checked for optimised appear animations. As
             * effects fire bottom-up, and we want to look up the tree for appear animations,
             * this makes sure we only check each path once, stopping at nodes that
             * have already been checked.
             */ this.hasCheckedOptimisedAppear = false;
            /**
             * An object representing the calculated contextual/accumulated/tree scale.
             * This will be used to scale calculcated projection transforms, as these are
             * calculated in screen-space but need to be scaled for elements to layoutly
             * make it to their calculated destinations.
             *
             * TODO: Lazy-init
             */ this.treeScale = {
                x: 1,
                y: 1
            };
            /**
             *
             */ this.eventHandlers = new Map();
            this.hasTreeAnimated = false;
            // Note: Currently only running on root node
            this.updateScheduled = false;
            this.scheduleUpdate = ()=>this.update();
            this.projectionUpdateScheduled = false;
            this.checkUpdateFailed = ()=>{
                if (this.isUpdating) {
                    this.isUpdating = false;
                    this.clearAllSnapshots();
                }
            };
            /**
             * This is a multi-step process as shared nodes might be of different depths. Nodes
             * are sorted by depth order, so we need to resolve the entire tree before moving to
             * the next step.
             */ this.updateProjection = ()=>{
                this.projectionUpdateScheduled = false;
                /**
                 * Reset debug counts. Manually resetting rather than creating a new
                 * object each frame.
                 */ if ($484678f694ff2da1$var$isDebug) $484678f694ff2da1$var$metrics.totalNodes = $484678f694ff2da1$var$metrics.resolvedTargetDeltas = $484678f694ff2da1$var$metrics.recalculatedProjection = 0;
                this.nodes.forEach($484678f694ff2da1$export$131f2f0cc5fe9609);
                this.nodes.forEach($484678f694ff2da1$var$resolveTargetDelta);
                this.nodes.forEach($484678f694ff2da1$var$calcProjection);
                this.nodes.forEach($484678f694ff2da1$export$c2664f37bc951031);
                if ($484678f694ff2da1$var$isDebug) window.MotionDebug.record($484678f694ff2da1$var$metrics);
            };
            /**
             * Frame calculations
             */ this.resolvedRelativeTargetAt = 0.0;
            this.hasProjected = false;
            this.isVisible = true;
            this.animationProgress = 0;
            /**
             * Shared layout
             */ // TODO Only running on root node
            this.sharedNodes = new Map();
            this.latestValues = latestValues;
            this.root = parent ? parent.root || parent : this;
            this.path = parent ? [
                ...parent.path,
                parent
            ] : [];
            this.parent = parent;
            this.depth = parent ? parent.depth + 1 : 0;
            for(let i = 0; i < this.path.length; i++)this.path[i].shouldResetTransform = true;
            if (this.root === this) this.nodes = new (0, $bc96ab5be3a8112a$export$1465d17e3de78a96)();
        }
        addEventListener(name, handler) {
            if (!this.eventHandlers.has(name)) this.eventHandlers.set(name, new (0, $f9d7e2b4cbfd436c$export$e7dff9482a5fd23c)());
            return this.eventHandlers.get(name).add(handler);
        }
        notifyListeners(name, ...args) {
            const subscriptionManager = this.eventHandlers.get(name);
            subscriptionManager && subscriptionManager.notify(...args);
        }
        hasListeners(name) {
            return this.eventHandlers.has(name);
        }
        /**
         * Lifecycles
         */ mount(instance, isLayoutDirty = this.root.hasTreeAnimated) {
            if (this.instance) return;
            this.isSVG = (0, $cd7f8f0ad0976f3a$export$17eda790a720ec57)(instance);
            this.instance = instance;
            const { layoutId: layoutId, layout: layout, visualElement: visualElement } = this.options;
            if (visualElement && !visualElement.current) visualElement.mount(instance);
            this.root.nodes.add(this);
            this.parent && this.parent.children.add(this);
            if (isLayoutDirty && (layout || layoutId)) this.isLayoutDirty = true;
            if (attachResizeListener) {
                let cancelDelay;
                const resizeUnblockUpdate = ()=>this.root.updateBlockedByResize = false;
                attachResizeListener(instance, ()=>{
                    this.root.updateBlockedByResize = true;
                    cancelDelay && cancelDelay();
                    cancelDelay = (0, $9eaf236b0880c674$export$1391212d75b2ee65)(resizeUnblockUpdate, 250);
                    if ((0, $dd7235250d7597e1$export$97db156a3ed1593b).hasAnimatedSinceResize) {
                        (0, $dd7235250d7597e1$export$97db156a3ed1593b).hasAnimatedSinceResize = false;
                        this.nodes.forEach($484678f694ff2da1$var$finishAnimation);
                    }
                });
            }
            if (layoutId) this.root.registerSharedNode(layoutId, this);
            // Only register the handler if it requires layout animation
            if (this.options.animate !== false && visualElement && (layoutId || layout)) this.addEventListener("didUpdate", ({ delta: delta, hasLayoutChanged: hasLayoutChanged, hasRelativeTargetChanged: hasRelativeTargetChanged, layout: newLayout })=>{
                if (this.isTreeAnimationBlocked()) {
                    this.target = undefined;
                    this.relativeTarget = undefined;
                    return;
                }
                // TODO: Check here if an animation exists
                const layoutTransition = this.options.transition || visualElement.getDefaultTransition() || $484678f694ff2da1$var$defaultLayoutTransition;
                const { onLayoutAnimationStart: onLayoutAnimationStart, onLayoutAnimationComplete: onLayoutAnimationComplete } = visualElement.getProps();
                /**
                     * The target layout of the element might stay the same,
                     * but its position relative to its parent has changed.
                     */ const targetChanged = !this.targetLayout || !(0, $6ce12b205c4c79ac$export$ef641b782d85522)(this.targetLayout, newLayout) || hasRelativeTargetChanged;
                /**
                     * If the layout hasn't seemed to have changed, it might be that the
                     * element is visually in the same place in the document but its position
                     * relative to its parent has indeed changed. So here we check for that.
                     */ const hasOnlyRelativeTargetChanged = !hasLayoutChanged && hasRelativeTargetChanged;
                if (this.options.layoutRoot || this.resumeFrom && this.resumeFrom.instance || hasOnlyRelativeTargetChanged || hasLayoutChanged && (targetChanged || !this.currentAnimation)) {
                    if (this.resumeFrom) {
                        this.resumingFrom = this.resumeFrom;
                        this.resumingFrom.resumingFrom = undefined;
                    }
                    this.setAnimationOrigin(delta, hasOnlyRelativeTargetChanged);
                    const animationOptions = {
                        ...(0, $453e5e72c39cf7c2$export$7c1391340308742e)(layoutTransition, "layout"),
                        onPlay: onLayoutAnimationStart,
                        onComplete: onLayoutAnimationComplete
                    };
                    if (visualElement.shouldReduceMotion || this.options.layoutRoot) {
                        animationOptions.delay = 0;
                        animationOptions.type = false;
                    }
                    this.startAnimation(animationOptions);
                } else {
                    /**
                         * If the layout hasn't changed and we have an animation that hasn't started yet,
                         * finish it immediately. Otherwise it will be animating from a location
                         * that was probably never commited to screen and look like a jumpy box.
                         */ if (!hasLayoutChanged) $484678f694ff2da1$var$finishAnimation(this);
                    if (this.isLead() && this.options.onExitComplete) this.options.onExitComplete();
                }
                this.targetLayout = newLayout;
            });
        }
        unmount() {
            this.options.layoutId && this.willUpdate();
            this.root.nodes.remove(this);
            const stack = this.getStack();
            stack && stack.remove(this);
            this.parent && this.parent.children.delete(this);
            this.instance = undefined;
            (0, $2668c8a722676613$export$ec99c0ef4978dccb)(this.updateProjection);
        }
        // only on the root
        blockUpdate() {
            this.updateManuallyBlocked = true;
        }
        unblockUpdate() {
            this.updateManuallyBlocked = false;
        }
        isUpdateBlocked() {
            return this.updateManuallyBlocked || this.updateBlockedByResize;
        }
        isTreeAnimationBlocked() {
            return this.isAnimationBlocked || this.parent && this.parent.isTreeAnimationBlocked() || false;
        }
        // Note: currently only running on root node
        startUpdate() {
            if (this.isUpdateBlocked()) return;
            this.isUpdating = true;
            this.nodes && this.nodes.forEach($484678f694ff2da1$var$resetSkewAndRotation);
            this.animationId++;
        }
        getTransformTemplate() {
            const { visualElement: visualElement } = this.options;
            return visualElement && visualElement.getProps().transformTemplate;
        }
        willUpdate(shouldNotifyListeners = true) {
            this.root.hasTreeAnimated = true;
            if (this.root.isUpdateBlocked()) {
                this.options.onExitComplete && this.options.onExitComplete();
                return;
            }
            /**
             * If we're running optimised appear animations then these must be
             * cancelled before measuring the DOM. This is so we can measure
             * the true layout of the element rather than the WAAPI animation
             * which will be unaffected by the resetSkewAndRotate step.
             *
             * Note: This is a DOM write. Worst case scenario is this is sandwiched
             * between other snapshot reads which will cause unnecessary style recalculations.
             * This has to happen here though, as we don't yet know which nodes will need
             * snapshots in startUpdate(), but we only want to cancel optimised animations
             * if a layout animation measurement is actually going to be affected by them.
             */ if (window.MotionCancelOptimisedAnimation && !this.hasCheckedOptimisedAppear) $484678f694ff2da1$var$cancelTreeOptimisedTransformAnimations(this);
            !this.root.isUpdating && this.root.startUpdate();
            if (this.isLayoutDirty) return;
            this.isLayoutDirty = true;
            for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                node.shouldResetTransform = true;
                node.updateScroll("snapshot");
                if (node.options.layoutRoot) node.willUpdate(false);
            }
            const { layoutId: layoutId, layout: layout } = this.options;
            if (layoutId === undefined && !layout) return;
            const transformTemplate = this.getTransformTemplate();
            this.prevTransformTemplateValue = transformTemplate ? transformTemplate(this.latestValues, "") : undefined;
            this.updateSnapshot();
            shouldNotifyListeners && this.notifyListeners("willUpdate");
        }
        update() {
            this.updateScheduled = false;
            const updateWasBlocked = this.isUpdateBlocked();
            // When doing an instant transition, we skip the layout update,
            // but should still clean up the measurements so that the next
            // snapshot could be taken correctly.
            if (updateWasBlocked) {
                this.unblockUpdate();
                this.clearAllSnapshots();
                this.nodes.forEach($484678f694ff2da1$var$clearMeasurements);
                return;
            }
            if (!this.isUpdating) this.nodes.forEach($484678f694ff2da1$var$clearIsLayoutDirty);
            this.isUpdating = false;
            /**
             * Write
             */ this.nodes.forEach($484678f694ff2da1$var$resetTransformStyle);
            /**
             * Read ==================
             */ // Update layout measurements of updated children
            this.nodes.forEach($484678f694ff2da1$var$updateLayout);
            /**
             * Write
             */ // Notify listeners that the layout is updated
            this.nodes.forEach($484678f694ff2da1$var$notifyLayoutUpdate);
            this.clearAllSnapshots();
            /**
             * Manually flush any pending updates. Ideally
             * we could leave this to the following requestAnimationFrame but this seems
             * to leave a flash of incorrectly styled content.
             */ const now = (0, $3a6da39b219d0ac7$export$2da9be4cfdb689b1).now();
            (0, $2668c8a722676613$export$fff89137e9e818ce).delta = (0, $b64a5fb8aaa910d9$export$7d15b64cf5a3a4c4)(0, 1000 / 60, now - (0, $2668c8a722676613$export$fff89137e9e818ce).timestamp);
            (0, $2668c8a722676613$export$fff89137e9e818ce).timestamp = now;
            (0, $2668c8a722676613$export$fff89137e9e818ce).isProcessing = true;
            (0, $2668c8a722676613$export$be3f796aed065412).update.process((0, $2668c8a722676613$export$fff89137e9e818ce));
            (0, $2668c8a722676613$export$be3f796aed065412).preRender.process((0, $2668c8a722676613$export$fff89137e9e818ce));
            (0, $2668c8a722676613$export$be3f796aed065412).render.process((0, $2668c8a722676613$export$fff89137e9e818ce));
            (0, $2668c8a722676613$export$fff89137e9e818ce).isProcessing = false;
        }
        didUpdate() {
            if (!this.updateScheduled) {
                this.updateScheduled = true;
                (0, $56c6f990d38070fe$export$bb76eed83315504c).read(this.scheduleUpdate);
            }
        }
        clearAllSnapshots() {
            this.nodes.forEach($484678f694ff2da1$var$clearSnapshot);
            this.sharedNodes.forEach($484678f694ff2da1$var$removeLeadSnapshots);
        }
        scheduleUpdateProjection() {
            if (!this.projectionUpdateScheduled) {
                this.projectionUpdateScheduled = true;
                (0, $2668c8a722676613$export$2cef06c20297c17d).preRender(this.updateProjection, false, true);
            }
        }
        scheduleCheckAfterUnmount() {
            /**
             * If the unmounting node is in a layoutGroup and did trigger a willUpdate,
             * we manually call didUpdate to give a chance to the siblings to animate.
             * Otherwise, cleanup all snapshots to prevents future nodes from reusing them.
             */ (0, $2668c8a722676613$export$2cef06c20297c17d).postRender(()=>{
                if (this.isLayoutDirty) this.root.didUpdate();
                else this.root.checkUpdateFailed();
            });
        }
        /**
         * Update measurements
         */ updateSnapshot() {
            if (this.snapshot || !this.instance) return;
            this.snapshot = this.measure();
        }
        updateLayout() {
            if (!this.instance) return;
            // TODO: Incorporate into a forwarded scroll offset
            this.updateScroll();
            if (!(this.options.alwaysMeasureLayout && this.isLead()) && !this.isLayoutDirty) return;
            /**
             * When a node is mounted, it simply resumes from the prevLead's
             * snapshot instead of taking a new one, but the ancestors scroll
             * might have updated while the prevLead is unmounted. We need to
             * update the scroll again to make sure the layout we measure is
             * up to date.
             */ if (this.resumeFrom && !this.resumeFrom.instance) for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                node.updateScroll();
            }
            const prevLayout = this.layout;
            this.layout = this.measure(false);
            this.layoutCorrected = (0, $a33f96272a0f3ced$export$6459fc9e86be362e)();
            this.isLayoutDirty = false;
            this.projectionDelta = undefined;
            this.notifyListeners("measure", this.layout.layoutBox);
            const { visualElement: visualElement } = this.options;
            visualElement && visualElement.notify("LayoutMeasure", this.layout.layoutBox, prevLayout ? prevLayout.layoutBox : undefined);
        }
        updateScroll(phase = "measure") {
            let needsMeasurement = Boolean(this.options.layoutScroll && this.instance);
            if (this.scroll && this.scroll.animationId === this.root.animationId && this.scroll.phase === phase) needsMeasurement = false;
            if (needsMeasurement) {
                const isRoot = checkIsScrollRoot(this.instance);
                this.scroll = {
                    animationId: this.root.animationId,
                    phase: phase,
                    isRoot: isRoot,
                    offset: measureScroll(this.instance),
                    wasRoot: this.scroll ? this.scroll.isRoot : isRoot
                };
            }
        }
        resetTransform() {
            if (!resetTransform) return;
            const isResetRequested = this.isLayoutDirty || this.shouldResetTransform || this.options.alwaysMeasureLayout;
            const hasProjection = this.projectionDelta && !(0, $6ce12b205c4c79ac$export$a7ec7642fe550fb6)(this.projectionDelta);
            const transformTemplate = this.getTransformTemplate();
            const transformTemplateValue = transformTemplate ? transformTemplate(this.latestValues, "") : undefined;
            const transformTemplateHasChanged = transformTemplateValue !== this.prevTransformTemplateValue;
            if (isResetRequested && (hasProjection || (0, $d3d101fc7fd68aaf$export$a545127cf1fbb600)(this.latestValues) || transformTemplateHasChanged)) {
                resetTransform(this.instance, transformTemplateValue);
                this.shouldResetTransform = false;
                this.scheduleRender();
            }
        }
        measure(removeTransform = true) {
            const pageBox = this.measurePageBox();
            let layoutBox = this.removeElementScroll(pageBox);
            /**
             * Measurements taken during the pre-render stage
             * still have transforms applied so we remove them
             * via calculation.
             */ if (removeTransform) layoutBox = this.removeTransform(layoutBox);
            $484678f694ff2da1$var$roundBox(layoutBox);
            return {
                animationId: this.root.animationId,
                measuredBox: pageBox,
                layoutBox: layoutBox,
                latestValues: {},
                source: this.id
            };
        }
        measurePageBox() {
            var _a;
            const { visualElement: visualElement } = this.options;
            if (!visualElement) return (0, $a33f96272a0f3ced$export$6459fc9e86be362e)();
            const box = visualElement.measureViewportBox();
            const wasInScrollRoot = ((_a = this.scroll) === null || _a === void 0 ? void 0 : _a.wasRoot) || this.path.some($484678f694ff2da1$var$checkNodeWasScrollRoot);
            if (!wasInScrollRoot) {
                // Remove viewport scroll to give page-relative coordinates
                const { scroll: scroll } = this.root;
                if (scroll) {
                    (0, $d81381f648f60915$export$a807a5ce5ebb3895)(box.x, scroll.offset.x);
                    (0, $d81381f648f60915$export$a807a5ce5ebb3895)(box.y, scroll.offset.y);
                }
            }
            return box;
        }
        removeElementScroll(box) {
            var _a;
            const boxWithoutScroll = (0, $a33f96272a0f3ced$export$6459fc9e86be362e)();
            (0, $eb323b55846adefd$export$c53fd88f45d77e4b)(boxWithoutScroll, box);
            if ((_a = this.scroll) === null || _a === void 0 ? void 0 : _a.wasRoot) return boxWithoutScroll;
            /**
             * Performance TODO: Keep a cumulative scroll offset down the tree
             * rather than loop back up the path.
             */ for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                const { scroll: scroll, options: options } = node;
                if (node !== this.root && scroll && options.layoutScroll) {
                    /**
                     * If this is a new scroll root, we want to remove all previous scrolls
                     * from the viewport box.
                     */ if (scroll.wasRoot) (0, $eb323b55846adefd$export$c53fd88f45d77e4b)(boxWithoutScroll, box);
                    (0, $d81381f648f60915$export$a807a5ce5ebb3895)(boxWithoutScroll.x, scroll.offset.x);
                    (0, $d81381f648f60915$export$a807a5ce5ebb3895)(boxWithoutScroll.y, scroll.offset.y);
                }
            }
            return boxWithoutScroll;
        }
        applyTransform(box, transformOnly = false) {
            const withTransforms = (0, $a33f96272a0f3ced$export$6459fc9e86be362e)();
            (0, $eb323b55846adefd$export$c53fd88f45d77e4b)(withTransforms, box);
            for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                if (!transformOnly && node.options.layoutScroll && node.scroll && node !== node.root) (0, $d81381f648f60915$export$58b16271041fbfb)(withTransforms, {
                    x: -node.scroll.offset.x,
                    y: -node.scroll.offset.y
                });
                if (!(0, $d3d101fc7fd68aaf$export$a545127cf1fbb600)(node.latestValues)) continue;
                (0, $d81381f648f60915$export$58b16271041fbfb)(withTransforms, node.latestValues);
            }
            if ((0, $d3d101fc7fd68aaf$export$a545127cf1fbb600)(this.latestValues)) (0, $d81381f648f60915$export$58b16271041fbfb)(withTransforms, this.latestValues);
            return withTransforms;
        }
        removeTransform(box) {
            const boxWithoutTransform = (0, $a33f96272a0f3ced$export$6459fc9e86be362e)();
            (0, $eb323b55846adefd$export$c53fd88f45d77e4b)(boxWithoutTransform, box);
            for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                if (!node.instance) continue;
                if (!(0, $d3d101fc7fd68aaf$export$a545127cf1fbb600)(node.latestValues)) continue;
                (0, $d3d101fc7fd68aaf$export$bdf30dca883ea463)(node.latestValues) && node.updateSnapshot();
                const sourceBox = (0, $a33f96272a0f3ced$export$6459fc9e86be362e)();
                const nodeBox = node.measurePageBox();
                (0, $eb323b55846adefd$export$c53fd88f45d77e4b)(sourceBox, nodeBox);
                (0, $3cca3361c07be144$export$73e1ad0a9694e25c)(boxWithoutTransform, node.latestValues, node.snapshot ? node.snapshot.layoutBox : undefined, sourceBox);
            }
            if ((0, $d3d101fc7fd68aaf$export$a545127cf1fbb600)(this.latestValues)) (0, $3cca3361c07be144$export$73e1ad0a9694e25c)(boxWithoutTransform, this.latestValues);
            return boxWithoutTransform;
        }
        setTargetDelta(delta) {
            this.targetDelta = delta;
            this.root.scheduleUpdateProjection();
            this.isProjectionDirty = true;
        }
        setOptions(options) {
            this.options = {
                ...this.options,
                ...options,
                crossfade: options.crossfade !== undefined ? options.crossfade : true
            };
        }
        clearMeasurements() {
            this.scroll = undefined;
            this.layout = undefined;
            this.snapshot = undefined;
            this.prevTransformTemplateValue = undefined;
            this.targetDelta = undefined;
            this.target = undefined;
            this.isLayoutDirty = false;
        }
        forceRelativeParentToResolveTarget() {
            if (!this.relativeParent) return;
            /**
             * If the parent target isn't up-to-date, force it to update.
             * This is an unfortunate de-optimisation as it means any updating relative
             * projection will cause all the relative parents to recalculate back
             * up the tree.
             */ if (this.relativeParent.resolvedRelativeTargetAt !== (0, $2668c8a722676613$export$fff89137e9e818ce).timestamp) this.relativeParent.resolveTargetDelta(true);
        }
        resolveTargetDelta(forceRecalculation = false) {
            var _a;
            /**
             * Once the dirty status of nodes has been spread through the tree, we also
             * need to check if we have a shared node of a different depth that has itself
             * been dirtied.
             */ const lead = this.getLead();
            this.isProjectionDirty || (this.isProjectionDirty = lead.isProjectionDirty);
            this.isTransformDirty || (this.isTransformDirty = lead.isTransformDirty);
            this.isSharedProjectionDirty || (this.isSharedProjectionDirty = lead.isSharedProjectionDirty);
            const isShared = Boolean(this.resumingFrom) || this !== lead;
            /**
             * We don't use transform for this step of processing so we don't
             * need to check whether any nodes have changed transform.
             */ const canSkip = !(forceRecalculation || isShared && this.isSharedProjectionDirty || this.isProjectionDirty || ((_a = this.parent) === null || _a === void 0 ? void 0 : _a.isProjectionDirty) || this.attemptToResolveRelativeTarget || this.root.updateBlockedByResize);
            if (canSkip) return;
            const { layout: layout, layoutId: layoutId } = this.options;
            /**
             * If we have no layout, we can't perform projection, so early return
             */ if (!this.layout || !(layout || layoutId)) return;
            this.resolvedRelativeTargetAt = (0, $2668c8a722676613$export$fff89137e9e818ce).timestamp;
            /**
             * If we don't have a targetDelta but do have a layout, we can attempt to resolve
             * a relativeParent. This will allow a component to perform scale correction
             * even if no animation has started.
             */ if (!this.targetDelta && !this.relativeTarget) {
                const relativeParent = this.getClosestProjectingParent();
                if (relativeParent && relativeParent.layout && this.animationProgress !== 1) {
                    this.relativeParent = relativeParent;
                    this.forceRelativeParentToResolveTarget();
                    this.relativeTarget = (0, $a33f96272a0f3ced$export$6459fc9e86be362e)();
                    this.relativeTargetOrigin = (0, $a33f96272a0f3ced$export$6459fc9e86be362e)();
                    (0, $85a652ec5cd36319$export$2785bfcc929c5650)(this.relativeTargetOrigin, this.layout.layoutBox, relativeParent.layout.layoutBox);
                    (0, $eb323b55846adefd$export$c53fd88f45d77e4b)(this.relativeTarget, this.relativeTargetOrigin);
                } else this.relativeParent = this.relativeTarget = undefined;
            }
            /**
             * If we have no relative target or no target delta our target isn't valid
             * for this frame.
             */ if (!this.relativeTarget && !this.targetDelta) return;
            /**
             * Lazy-init target data structure
             */ if (!this.target) {
                this.target = (0, $a33f96272a0f3ced$export$6459fc9e86be362e)();
                this.targetWithTransforms = (0, $a33f96272a0f3ced$export$6459fc9e86be362e)();
            }
            /**
             * If we've got a relative box for this component, resolve it into a target relative to the parent.
             */ if (this.relativeTarget && this.relativeTargetOrigin && this.relativeParent && this.relativeParent.target) {
                this.forceRelativeParentToResolveTarget();
                (0, $85a652ec5cd36319$export$426154f9d100f99)(this.target, this.relativeTarget, this.relativeParent.target);
            /**
                 * If we've only got a targetDelta, resolve it into a target
                 */ } else if (this.targetDelta) {
                if (Boolean(this.resumingFrom)) // TODO: This is creating a new object every frame
                this.target = this.applyTransform(this.layout.layoutBox);
                else (0, $eb323b55846adefd$export$c53fd88f45d77e4b)(this.target, this.layout.layoutBox);
                (0, $d81381f648f60915$export$d80074982803af5c)(this.target, this.targetDelta);
            } else /**
                 * If no target, use own layout as target
                 */ (0, $eb323b55846adefd$export$c53fd88f45d77e4b)(this.target, this.layout.layoutBox);
            /**
             * If we've been told to attempt to resolve a relative target, do so.
             */ if (this.attemptToResolveRelativeTarget) {
                this.attemptToResolveRelativeTarget = false;
                const relativeParent = this.getClosestProjectingParent();
                if (relativeParent && Boolean(relativeParent.resumingFrom) === Boolean(this.resumingFrom) && !relativeParent.options.layoutScroll && relativeParent.target && this.animationProgress !== 1) {
                    this.relativeParent = relativeParent;
                    this.forceRelativeParentToResolveTarget();
                    this.relativeTarget = (0, $a33f96272a0f3ced$export$6459fc9e86be362e)();
                    this.relativeTargetOrigin = (0, $a33f96272a0f3ced$export$6459fc9e86be362e)();
                    (0, $85a652ec5cd36319$export$2785bfcc929c5650)(this.relativeTargetOrigin, this.target, relativeParent.target);
                    (0, $eb323b55846adefd$export$c53fd88f45d77e4b)(this.relativeTarget, this.relativeTargetOrigin);
                } else this.relativeParent = this.relativeTarget = undefined;
            }
            /**
             * Increase debug counter for resolved target deltas
             */ if ($484678f694ff2da1$var$isDebug) $484678f694ff2da1$var$metrics.resolvedTargetDeltas++;
        }
        getClosestProjectingParent() {
            if (!this.parent || (0, $d3d101fc7fd68aaf$export$bdf30dca883ea463)(this.parent.latestValues) || (0, $d3d101fc7fd68aaf$export$bf80f5f8f4dc327f)(this.parent.latestValues)) return undefined;
            if (this.parent.isProjecting()) return this.parent;
            else return this.parent.getClosestProjectingParent();
        }
        isProjecting() {
            return Boolean((this.relativeTarget || this.targetDelta || this.options.layoutRoot) && this.layout);
        }
        calcProjection() {
            var _a;
            const lead = this.getLead();
            const isShared = Boolean(this.resumingFrom) || this !== lead;
            let canSkip = true;
            /**
             * If this is a normal layout animation and neither this node nor its nearest projecting
             * is dirty then we can't skip.
             */ if (this.isProjectionDirty || ((_a = this.parent) === null || _a === void 0 ? void 0 : _a.isProjectionDirty)) canSkip = false;
            /**
             * If this is a shared layout animation and this node's shared projection is dirty then
             * we can't skip.
             */ if (isShared && (this.isSharedProjectionDirty || this.isTransformDirty)) canSkip = false;
            /**
             * If we have resolved the target this frame we must recalculate the
             * projection to ensure it visually represents the internal calculations.
             */ if (this.resolvedRelativeTargetAt === (0, $2668c8a722676613$export$fff89137e9e818ce).timestamp) canSkip = false;
            if (canSkip) return;
            const { layout: layout, layoutId: layoutId } = this.options;
            /**
             * If this section of the tree isn't animating we can
             * delete our target sources for the following frame.
             */ this.isTreeAnimating = Boolean(this.parent && this.parent.isTreeAnimating || this.currentAnimation || this.pendingAnimation);
            if (!this.isTreeAnimating) this.targetDelta = this.relativeTarget = undefined;
            if (!this.layout || !(layout || layoutId)) return;
            /**
             * Reset the corrected box with the latest values from box, as we're then going
             * to perform mutative operations on it.
             */ (0, $eb323b55846adefd$export$c53fd88f45d77e4b)(this.layoutCorrected, this.layout.layoutBox);
            /**
             * Record previous tree scales before updating.
             */ const prevTreeScaleX = this.treeScale.x;
            const prevTreeScaleY = this.treeScale.y;
            /**
             * Apply all the parent deltas to this box to produce the corrected box. This
             * is the layout box, as it will appear on screen as a result of the transforms of its parents.
             */ (0, $d81381f648f60915$export$e2a980535c55eabb)(this.layoutCorrected, this.treeScale, this.path, isShared);
            /**
             * If this layer needs to perform scale correction but doesn't have a target,
             * use the layout as the target.
             */ if (lead.layout && !lead.target && (this.treeScale.x !== 1 || this.treeScale.y !== 1)) {
                lead.target = lead.layout.layoutBox;
                lead.targetWithTransforms = (0, $a33f96272a0f3ced$export$6459fc9e86be362e)();
            }
            const { target: target } = lead;
            if (!target) {
                /**
                 * If we don't have a target to project into, but we were previously
                 * projecting, we want to remove the stored transform and schedule
                 * a render to ensure the elements reflect the removed transform.
                 */ if (this.prevProjectionDelta) {
                    this.createProjectionDeltas();
                    this.scheduleRender();
                }
                return;
            }
            if (!this.projectionDelta || !this.prevProjectionDelta) this.createProjectionDeltas();
            else {
                (0, $eb323b55846adefd$export$8ead6a7d6b225ef)(this.prevProjectionDelta.x, this.projectionDelta.x);
                (0, $eb323b55846adefd$export$8ead6a7d6b225ef)(this.prevProjectionDelta.y, this.projectionDelta.y);
            }
            /**
             * Update the delta between the corrected box and the target box before user-set transforms were applied.
             * This will allow us to calculate the corrected borderRadius and boxShadow to compensate
             * for our layout reprojection, but still allow them to be scaled correctly by the user.
             * It might be that to simplify this we may want to accept that user-set scale is also corrected
             * and we wouldn't have to keep and calc both deltas, OR we could support a user setting
             * to allow people to choose whether these styles are corrected based on just the
             * layout reprojection or the final bounding box.
             */ (0, $85a652ec5cd36319$export$c0d25e96fc67d310)(this.projectionDelta, this.layoutCorrected, target, this.latestValues);
            if (this.treeScale.x !== prevTreeScaleX || this.treeScale.y !== prevTreeScaleY || !(0, $6ce12b205c4c79ac$export$444620505e28fe92)(this.projectionDelta.x, this.prevProjectionDelta.x) || !(0, $6ce12b205c4c79ac$export$444620505e28fe92)(this.projectionDelta.y, this.prevProjectionDelta.y)) {
                this.hasProjected = true;
                this.scheduleRender();
                this.notifyListeners("projectionUpdate", target);
            }
            /**
             * Increase debug counter for recalculated projections
             */ if ($484678f694ff2da1$var$isDebug) $484678f694ff2da1$var$metrics.recalculatedProjection++;
        }
        hide() {
            this.isVisible = false;
        // TODO: Schedule render
        }
        show() {
            this.isVisible = true;
        // TODO: Schedule render
        }
        scheduleRender(notifyAll = true) {
            var _a;
            (_a = this.options.visualElement) === null || _a === void 0 || _a.scheduleRender();
            if (notifyAll) {
                const stack = this.getStack();
                stack && stack.scheduleRender();
            }
            if (this.resumingFrom && !this.resumingFrom.instance) this.resumingFrom = undefined;
        }
        createProjectionDeltas() {
            this.prevProjectionDelta = (0, $a33f96272a0f3ced$export$3d227df54007d73a)();
            this.projectionDelta = (0, $a33f96272a0f3ced$export$3d227df54007d73a)();
            this.projectionDeltaWithTransform = (0, $a33f96272a0f3ced$export$3d227df54007d73a)();
        }
        setAnimationOrigin(delta, hasOnlyRelativeTargetChanged = false) {
            const snapshot = this.snapshot;
            const snapshotLatestValues = snapshot ? snapshot.latestValues : {};
            const mixedValues = {
                ...this.latestValues
            };
            const targetDelta = (0, $a33f96272a0f3ced$export$3d227df54007d73a)();
            if (!this.relativeParent || !this.relativeParent.options.layoutRoot) this.relativeTarget = this.relativeTargetOrigin = undefined;
            this.attemptToResolveRelativeTarget = !hasOnlyRelativeTargetChanged;
            const relativeLayout = (0, $a33f96272a0f3ced$export$6459fc9e86be362e)();
            const snapshotSource = snapshot ? snapshot.source : undefined;
            const layoutSource = this.layout ? this.layout.source : undefined;
            const isSharedLayoutAnimation = snapshotSource !== layoutSource;
            const stack = this.getStack();
            const isOnlyMember = !stack || stack.members.length <= 1;
            const shouldCrossfadeOpacity = Boolean(isSharedLayoutAnimation && !isOnlyMember && this.options.crossfade === true && !this.path.some($484678f694ff2da1$var$hasOpacityCrossfade));
            this.animationProgress = 0;
            let prevRelativeTarget;
            this.mixTargetDelta = (latest)=>{
                const progress = latest / 1000;
                $484678f694ff2da1$export$91dbf443e1bf1de1(targetDelta.x, delta.x, progress);
                $484678f694ff2da1$export$91dbf443e1bf1de1(targetDelta.y, delta.y, progress);
                this.setTargetDelta(targetDelta);
                if (this.relativeTarget && this.relativeTargetOrigin && this.layout && this.relativeParent && this.relativeParent.layout) {
                    (0, $85a652ec5cd36319$export$2785bfcc929c5650)(relativeLayout, this.layout.layoutBox, this.relativeParent.layout.layoutBox);
                    $484678f694ff2da1$export$6ffd3e6ae339a132(this.relativeTarget, this.relativeTargetOrigin, relativeLayout, progress);
                    /**
                     * If this is an unchanged relative target we can consider the
                     * projection not dirty.
                     */ if (prevRelativeTarget && (0, $6ce12b205c4c79ac$export$8d5cf76bb7daff09)(this.relativeTarget, prevRelativeTarget)) this.isProjectionDirty = false;
                    if (!prevRelativeTarget) prevRelativeTarget = (0, $a33f96272a0f3ced$export$6459fc9e86be362e)();
                    (0, $eb323b55846adefd$export$c53fd88f45d77e4b)(prevRelativeTarget, this.relativeTarget);
                }
                if (isSharedLayoutAnimation) {
                    this.animationValues = mixedValues;
                    (0, $21f9a46747b133ed$export$739e279c17d51c3d)(mixedValues, snapshotLatestValues, this.latestValues, progress, shouldCrossfadeOpacity, isOnlyMember);
                }
                this.root.scheduleUpdateProjection();
                this.scheduleRender();
                this.animationProgress = progress;
            };
            this.mixTargetDelta(this.options.layoutRoot ? 1000 : 0);
        }
        startAnimation(options) {
            this.notifyListeners("animationStart");
            this.currentAnimation && this.currentAnimation.stop();
            if (this.resumingFrom && this.resumingFrom.currentAnimation) this.resumingFrom.currentAnimation.stop();
            if (this.pendingAnimation) {
                (0, $2668c8a722676613$export$ec99c0ef4978dccb)(this.pendingAnimation);
                this.pendingAnimation = undefined;
            }
            /**
             * Start the animation in the next frame to have a frame with progress 0,
             * where the target is the same as when the animation started, so we can
             * calculate the relative positions correctly for instant transitions.
             */ this.pendingAnimation = (0, $2668c8a722676613$export$2cef06c20297c17d).update(()=>{
                (0, $dd7235250d7597e1$export$97db156a3ed1593b).hasAnimatedSinceResize = true;
                this.currentAnimation = (0, $0840febc4398c738$export$335a17c977067b99)(0, $484678f694ff2da1$var$animationTarget, {
                    ...options,
                    onUpdate: (latest)=>{
                        this.mixTargetDelta(latest);
                        options.onUpdate && options.onUpdate(latest);
                    },
                    onComplete: ()=>{
                        options.onComplete && options.onComplete();
                        this.completeAnimation();
                    }
                });
                if (this.resumingFrom) this.resumingFrom.currentAnimation = this.currentAnimation;
                this.pendingAnimation = undefined;
            });
        }
        completeAnimation() {
            if (this.resumingFrom) {
                this.resumingFrom.currentAnimation = undefined;
                this.resumingFrom.preserveOpacity = undefined;
            }
            const stack = this.getStack();
            stack && stack.exitAnimationComplete();
            this.resumingFrom = this.currentAnimation = this.animationValues = undefined;
            this.notifyListeners("animationComplete");
        }
        finishAnimation() {
            if (this.currentAnimation) {
                this.mixTargetDelta && this.mixTargetDelta($484678f694ff2da1$var$animationTarget);
                this.currentAnimation.stop();
            }
            this.completeAnimation();
        }
        applyTransformsToTarget() {
            const lead = this.getLead();
            let { targetWithTransforms: targetWithTransforms, target: target, layout: layout, latestValues: latestValues } = lead;
            if (!targetWithTransforms || !target || !layout) return;
            /**
             * If we're only animating position, and this element isn't the lead element,
             * then instead of projecting into the lead box we instead want to calculate
             * a new target that aligns the two boxes but maintains the layout shape.
             */ if (this !== lead && this.layout && layout && $484678f694ff2da1$var$shouldAnimatePositionOnly(this.options.animationType, this.layout.layoutBox, layout.layoutBox)) {
                target = this.target || (0, $a33f96272a0f3ced$export$6459fc9e86be362e)();
                const xLength = (0, $85a652ec5cd36319$export$c1c127004b72a37)(this.layout.layoutBox.x);
                target.x.min = lead.target.x.min;
                target.x.max = target.x.min + xLength;
                const yLength = (0, $85a652ec5cd36319$export$c1c127004b72a37)(this.layout.layoutBox.y);
                target.y.min = lead.target.y.min;
                target.y.max = target.y.min + yLength;
            }
            (0, $eb323b55846adefd$export$c53fd88f45d77e4b)(targetWithTransforms, target);
            /**
             * Apply the latest user-set transforms to the targetBox to produce the targetBoxFinal.
             * This is the final box that we will then project into by calculating a transform delta and
             * applying it to the corrected box.
             */ (0, $d81381f648f60915$export$58b16271041fbfb)(targetWithTransforms, latestValues);
            /**
             * Update the delta between the corrected box and the final target box, after
             * user-set transforms are applied to it. This will be used by the renderer to
             * create a transform style that will reproject the element from its layout layout
             * into the desired bounding box.
             */ (0, $85a652ec5cd36319$export$c0d25e96fc67d310)(this.projectionDeltaWithTransform, this.layoutCorrected, targetWithTransforms, latestValues);
        }
        registerSharedNode(layoutId, node) {
            if (!this.sharedNodes.has(layoutId)) this.sharedNodes.set(layoutId, new (0, $46c35e490a5123a4$export$39be5b2d82fc9dc7)());
            const stack = this.sharedNodes.get(layoutId);
            stack.add(node);
            const config = node.options.initialPromotionConfig;
            node.promote({
                transition: config ? config.transition : undefined,
                preserveFollowOpacity: config && config.shouldPreserveFollowOpacity ? config.shouldPreserveFollowOpacity(node) : undefined
            });
        }
        isLead() {
            const stack = this.getStack();
            return stack ? stack.lead === this : true;
        }
        getLead() {
            var _a;
            const { layoutId: layoutId } = this.options;
            return layoutId ? ((_a = this.getStack()) === null || _a === void 0 ? void 0 : _a.lead) || this : this;
        }
        getPrevLead() {
            var _a;
            const { layoutId: layoutId } = this.options;
            return layoutId ? (_a = this.getStack()) === null || _a === void 0 ? void 0 : _a.prevLead : undefined;
        }
        getStack() {
            const { layoutId: layoutId } = this.options;
            if (layoutId) return this.root.sharedNodes.get(layoutId);
        }
        promote({ needsReset: needsReset, transition: transition, preserveFollowOpacity: preserveFollowOpacity } = {}) {
            const stack = this.getStack();
            if (stack) stack.promote(this, preserveFollowOpacity);
            if (needsReset) {
                this.projectionDelta = undefined;
                this.needsReset = true;
            }
            if (transition) this.setOptions({
                transition: transition
            });
        }
        relegate() {
            const stack = this.getStack();
            if (stack) return stack.relegate(this);
            else return false;
        }
        resetSkewAndRotation() {
            const { visualElement: visualElement } = this.options;
            if (!visualElement) return;
            // If there's no detected skew or rotation values, we can early return without a forced render.
            let hasDistortingTransform = false;
            /**
             * An unrolled check for rotation values. Most elements don't have any rotation and
             * skipping the nested loop and new object creation is 50% faster.
             */ const { latestValues: latestValues } = visualElement;
            if (latestValues.z || latestValues.rotate || latestValues.rotateX || latestValues.rotateY || latestValues.rotateZ || latestValues.skewX || latestValues.skewY) hasDistortingTransform = true;
            // If there's no distorting values, we don't need to do any more.
            if (!hasDistortingTransform) return;
            const resetValues = {};
            if (latestValues.z) $484678f694ff2da1$var$resetDistortingTransform("z", visualElement, resetValues, this.animationValues);
            // Check the skew and rotate value of all axes and reset to 0
            for(let i = 0; i < $484678f694ff2da1$var$transformAxes.length; i++){
                $484678f694ff2da1$var$resetDistortingTransform(`rotate${$484678f694ff2da1$var$transformAxes[i]}`, visualElement, resetValues, this.animationValues);
                $484678f694ff2da1$var$resetDistortingTransform(`skew${$484678f694ff2da1$var$transformAxes[i]}`, visualElement, resetValues, this.animationValues);
            }
            // Force a render of this element to apply the transform with all skews and rotations
            // set to 0.
            visualElement.render();
            // Put back all the values we reset
            for(const key in resetValues){
                visualElement.setStaticValue(key, resetValues[key]);
                if (this.animationValues) this.animationValues[key] = resetValues[key];
            }
            // Schedule a render for the next frame. This ensures we won't visually
            // see the element with the reset rotate value applied.
            visualElement.scheduleRender();
        }
        getProjectionStyles(styleProp) {
            var _a, _b;
            if (!this.instance || this.isSVG) return undefined;
            if (!this.isVisible) return $484678f694ff2da1$var$hiddenVisibility;
            const styles = {
                visibility: ""
            };
            const transformTemplate = this.getTransformTemplate();
            if (this.needsReset) {
                this.needsReset = false;
                styles.opacity = "";
                styles.pointerEvents = (0, $afcd820fe2a95f42$export$fcc2206ecb6d74b)(styleProp === null || styleProp === void 0 ? void 0 : styleProp.pointerEvents) || "";
                styles.transform = transformTemplate ? transformTemplate(this.latestValues, "") : "none";
                return styles;
            }
            const lead = this.getLead();
            if (!this.projectionDelta || !this.layout || !lead.target) {
                const emptyStyles = {};
                if (this.options.layoutId) {
                    emptyStyles.opacity = this.latestValues.opacity !== undefined ? this.latestValues.opacity : 1;
                    emptyStyles.pointerEvents = (0, $afcd820fe2a95f42$export$fcc2206ecb6d74b)(styleProp === null || styleProp === void 0 ? void 0 : styleProp.pointerEvents) || "";
                }
                if (this.hasProjected && !(0, $d3d101fc7fd68aaf$export$a545127cf1fbb600)(this.latestValues)) {
                    emptyStyles.transform = transformTemplate ? transformTemplate({}, "") : "none";
                    this.hasProjected = false;
                }
                return emptyStyles;
            }
            const valuesToRender = lead.animationValues || lead.latestValues;
            this.applyTransformsToTarget();
            styles.transform = (0, $262abd317fffbdb0$export$d33653b270fe725c)(this.projectionDeltaWithTransform, this.treeScale, valuesToRender);
            if (transformTemplate) styles.transform = transformTemplate(valuesToRender, styles.transform);
            const { x: x, y: y } = this.projectionDelta;
            styles.transformOrigin = `${x.origin * 100}% ${y.origin * 100}% 0`;
            if (lead.animationValues) /**
                 * If the lead component is animating, assign this either the entering/leaving
                 * opacity
                 */ styles.opacity = lead === this ? (_b = (_a = valuesToRender.opacity) !== null && _a !== void 0 ? _a : this.latestValues.opacity) !== null && _b !== void 0 ? _b : 1 : this.preserveOpacity ? this.latestValues.opacity : valuesToRender.opacityExit;
            else /**
                 * Or we're not animating at all, set the lead component to its layout
                 * opacity and other components to hidden.
                 */ styles.opacity = lead === this ? valuesToRender.opacity !== undefined ? valuesToRender.opacity : "" : valuesToRender.opacityExit !== undefined ? valuesToRender.opacityExit : 0;
            /**
             * Apply scale correction
             */ for(const key in 0, $5a27ca56288b5194$export$91ddd985b97788d1){
                if (valuesToRender[key] === undefined) continue;
                const { correct: correct, applyTo: applyTo } = (0, $5a27ca56288b5194$export$91ddd985b97788d1)[key];
                /**
                 * Only apply scale correction to the value if we have an
                 * active projection transform. Otherwise these values become
                 * vulnerable to distortion if the element changes size without
                 * a corresponding layout animation.
                 */ const corrected = styles.transform === "none" ? valuesToRender[key] : correct(valuesToRender[key], lead);
                if (applyTo) {
                    const num = applyTo.length;
                    for(let i = 0; i < num; i++)styles[applyTo[i]] = corrected;
                } else styles[key] = corrected;
            }
            /**
             * Disable pointer events on follow components. This is to ensure
             * that if a follow component covers a lead component it doesn't block
             * pointer events on the lead.
             */ if (this.options.layoutId) styles.pointerEvents = lead === this ? (0, $afcd820fe2a95f42$export$fcc2206ecb6d74b)(styleProp === null || styleProp === void 0 ? void 0 : styleProp.pointerEvents) || "" : "none";
            return styles;
        }
        clearSnapshot() {
            this.resumeFrom = this.snapshot = undefined;
        }
        // Only run on root
        resetTree() {
            this.root.nodes.forEach((node)=>{
                var _a;
                return (_a = node.currentAnimation) === null || _a === void 0 ? void 0 : _a.stop();
            });
            this.root.nodes.forEach($484678f694ff2da1$var$clearMeasurements);
            this.root.sharedNodes.clear();
        }
    };
}
function $484678f694ff2da1$var$updateLayout(node) {
    node.updateLayout();
}
function $484678f694ff2da1$var$notifyLayoutUpdate(node) {
    var _a;
    const snapshot = ((_a = node.resumeFrom) === null || _a === void 0 ? void 0 : _a.snapshot) || node.snapshot;
    if (node.isLead() && node.layout && snapshot && node.hasListeners("didUpdate")) {
        const { layoutBox: layout, measuredBox: measuredLayout } = node.layout;
        const { animationType: animationType } = node.options;
        const isShared = snapshot.source !== node.layout.source;
        // TODO Maybe we want to also resize the layout snapshot so we don't trigger
        // animations for instance if layout="size" and an element has only changed position
        if (animationType === "size") (0, $80571038c05c2614$export$b789de563eb43b1)((axis)=>{
            const axisSnapshot = isShared ? snapshot.measuredBox[axis] : snapshot.layoutBox[axis];
            const length = (0, $85a652ec5cd36319$export$c1c127004b72a37)(axisSnapshot);
            axisSnapshot.min = layout[axis].min;
            axisSnapshot.max = axisSnapshot.min + length;
        });
        else if ($484678f694ff2da1$var$shouldAnimatePositionOnly(animationType, snapshot.layoutBox, layout)) (0, $80571038c05c2614$export$b789de563eb43b1)((axis)=>{
            const axisSnapshot = isShared ? snapshot.measuredBox[axis] : snapshot.layoutBox[axis];
            const length = (0, $85a652ec5cd36319$export$c1c127004b72a37)(layout[axis]);
            axisSnapshot.max = axisSnapshot.min + length;
            /**
                 * Ensure relative target gets resized and rerendererd
                 */ if (node.relativeTarget && !node.currentAnimation) {
                node.isProjectionDirty = true;
                node.relativeTarget[axis].max = node.relativeTarget[axis].min + length;
            }
        });
        const layoutDelta = (0, $a33f96272a0f3ced$export$3d227df54007d73a)();
        (0, $85a652ec5cd36319$export$c0d25e96fc67d310)(layoutDelta, layout, snapshot.layoutBox);
        const visualDelta = (0, $a33f96272a0f3ced$export$3d227df54007d73a)();
        if (isShared) (0, $85a652ec5cd36319$export$c0d25e96fc67d310)(visualDelta, node.applyTransform(measuredLayout, true), snapshot.measuredBox);
        else (0, $85a652ec5cd36319$export$c0d25e96fc67d310)(visualDelta, layout, snapshot.layoutBox);
        const hasLayoutChanged = !(0, $6ce12b205c4c79ac$export$a7ec7642fe550fb6)(layoutDelta);
        let hasRelativeTargetChanged = false;
        if (!node.resumeFrom) {
            const relativeParent = node.getClosestProjectingParent();
            /**
             * If the relativeParent is itself resuming from a different element then
             * the relative snapshot is not relavent
             */ if (relativeParent && !relativeParent.resumeFrom) {
                const { snapshot: parentSnapshot, layout: parentLayout } = relativeParent;
                if (parentSnapshot && parentLayout) {
                    const relativeSnapshot = (0, $a33f96272a0f3ced$export$6459fc9e86be362e)();
                    (0, $85a652ec5cd36319$export$2785bfcc929c5650)(relativeSnapshot, snapshot.layoutBox, parentSnapshot.layoutBox);
                    const relativeLayout = (0, $a33f96272a0f3ced$export$6459fc9e86be362e)();
                    (0, $85a652ec5cd36319$export$2785bfcc929c5650)(relativeLayout, layout, parentLayout.layoutBox);
                    if (!(0, $6ce12b205c4c79ac$export$ef641b782d85522)(relativeSnapshot, relativeLayout)) hasRelativeTargetChanged = true;
                    if (relativeParent.options.layoutRoot) {
                        node.relativeTarget = relativeLayout;
                        node.relativeTargetOrigin = relativeSnapshot;
                        node.relativeParent = relativeParent;
                    }
                }
            }
        }
        node.notifyListeners("didUpdate", {
            layout: layout,
            snapshot: snapshot,
            delta: visualDelta,
            layoutDelta: layoutDelta,
            hasLayoutChanged: hasLayoutChanged,
            hasRelativeTargetChanged: hasRelativeTargetChanged
        });
    } else if (node.isLead()) {
        const { onExitComplete: onExitComplete } = node.options;
        onExitComplete && onExitComplete();
    }
    /**
     * Clearing transition
     * TODO: Investigate why this transition is being passed in as {type: false } from Framer
     * and why we need it at all
     */ node.options.transition = undefined;
}
function $484678f694ff2da1$export$131f2f0cc5fe9609(node) {
    /**
     * Increase debug counter for nodes encountered this frame
     */ if ($484678f694ff2da1$var$isDebug) $484678f694ff2da1$var$metrics.totalNodes++;
    if (!node.parent) return;
    /**
     * If this node isn't projecting, propagate isProjectionDirty. It will have
     * no performance impact but it will allow the next child that *is* projecting
     * but *isn't* dirty to just check its parent to see if *any* ancestor needs
     * correcting.
     */ if (!node.isProjecting()) node.isProjectionDirty = node.parent.isProjectionDirty;
    /**
     * Propagate isSharedProjectionDirty and isTransformDirty
     * throughout the whole tree. A future revision can take another look at
     * this but for safety we still recalcualte shared nodes.
     */ node.isSharedProjectionDirty || (node.isSharedProjectionDirty = Boolean(node.isProjectionDirty || node.parent.isProjectionDirty || node.parent.isSharedProjectionDirty));
    node.isTransformDirty || (node.isTransformDirty = node.parent.isTransformDirty);
}
function $484678f694ff2da1$export$c2664f37bc951031(node) {
    node.isProjectionDirty = node.isSharedProjectionDirty = node.isTransformDirty = false;
}
function $484678f694ff2da1$var$clearSnapshot(node) {
    node.clearSnapshot();
}
function $484678f694ff2da1$var$clearMeasurements(node) {
    node.clearMeasurements();
}
function $484678f694ff2da1$var$clearIsLayoutDirty(node) {
    node.isLayoutDirty = false;
}
function $484678f694ff2da1$var$resetTransformStyle(node) {
    const { visualElement: visualElement } = node.options;
    if (visualElement && visualElement.getProps().onBeforeLayoutMeasure) visualElement.notify("BeforeLayoutMeasure");
    node.resetTransform();
}
function $484678f694ff2da1$var$finishAnimation(node) {
    node.finishAnimation();
    node.targetDelta = node.relativeTarget = node.target = undefined;
    node.isProjectionDirty = true;
}
function $484678f694ff2da1$var$resolveTargetDelta(node) {
    node.resolveTargetDelta();
}
function $484678f694ff2da1$var$calcProjection(node) {
    node.calcProjection();
}
function $484678f694ff2da1$var$resetSkewAndRotation(node) {
    node.resetSkewAndRotation();
}
function $484678f694ff2da1$var$removeLeadSnapshots(stack) {
    stack.removeLeadSnapshot();
}
function $484678f694ff2da1$export$91dbf443e1bf1de1(output, delta, p) {
    output.translate = (0, $4defff8a09cc16c4$export$3bb0b4ff1037b8dd)(delta.translate, 0, p);
    output.scale = (0, $4defff8a09cc16c4$export$3bb0b4ff1037b8dd)(delta.scale, 1, p);
    output.origin = delta.origin;
    output.originPoint = delta.originPoint;
}
function $484678f694ff2da1$export$8f9f6b0c76c773c7(output, from, to, p) {
    output.min = (0, $4defff8a09cc16c4$export$3bb0b4ff1037b8dd)(from.min, to.min, p);
    output.max = (0, $4defff8a09cc16c4$export$3bb0b4ff1037b8dd)(from.max, to.max, p);
}
function $484678f694ff2da1$export$6ffd3e6ae339a132(output, from, to, p) {
    $484678f694ff2da1$export$8f9f6b0c76c773c7(output.x, from.x, to.x, p);
    $484678f694ff2da1$export$8f9f6b0c76c773c7(output.y, from.y, to.y, p);
}
function $484678f694ff2da1$var$hasOpacityCrossfade(node) {
    return node.animationValues && node.animationValues.opacityExit !== undefined;
}
const $484678f694ff2da1$var$defaultLayoutTransition = {
    duration: 0.45,
    ease: [
        0.4,
        0,
        0.1,
        1
    ]
};
const $484678f694ff2da1$var$userAgentContains = (string)=>typeof navigator !== "undefined" && navigator.userAgent && navigator.userAgent.toLowerCase().includes(string);
/**
 * Measured bounding boxes must be rounded in Safari and
 * left untouched in Chrome, otherwise non-integer layouts within scaled-up elements
 * can appear to jump.
 */ const $484678f694ff2da1$var$roundPoint = $484678f694ff2da1$var$userAgentContains("applewebkit/") && !$484678f694ff2da1$var$userAgentContains("chrome/") ? Math.round : (0, $c90734627ed96e3f$export$8793edee2d425525);
function $484678f694ff2da1$var$roundAxis(axis) {
    // Round to the nearest .5 pixels to support subpixel layouts
    axis.min = $484678f694ff2da1$var$roundPoint(axis.min);
    axis.max = $484678f694ff2da1$var$roundPoint(axis.max);
}
function $484678f694ff2da1$var$roundBox(box) {
    $484678f694ff2da1$var$roundAxis(box.x);
    $484678f694ff2da1$var$roundAxis(box.y);
}
function $484678f694ff2da1$var$shouldAnimatePositionOnly(animationType, snapshot, layout) {
    return animationType === "position" || animationType === "preserve-aspect" && !(0, $85a652ec5cd36319$export$28d0384c4b79bde2)((0, $6ce12b205c4c79ac$export$c5706146bc63213)(snapshot), (0, $6ce12b205c4c79ac$export$c5706146bc63213)(layout), 0.2);
}
function $484678f694ff2da1$var$checkNodeWasScrollRoot(node) {
    var _a;
    return node !== node.root && ((_a = node.scroll) === null || _a === void 0 ? void 0 : _a.wasRoot);
}




const $2e704cfa3544bdc6$export$2d029a49a09b6177 = (0, $484678f694ff2da1$export$a84b61f69daa9da0)({
    attachResizeListener: (ref, notify)=>(0, $52bbcc091bf26590$export$b1d829ddf82884aa)(ref, "resize", notify),
    measureScroll: ()=>({
            x: document.documentElement.scrollLeft || document.body.scrollLeft,
            y: document.documentElement.scrollTop || document.body.scrollTop
        }),
    checkIsScrollRoot: ()=>true
});


const $9f0cd6e302f97046$export$b91509fcf893b648 = {
    current: undefined
};
const $9f0cd6e302f97046$export$b61a9eb3dbde8858 = (0, $484678f694ff2da1$export$a84b61f69daa9da0)({
    measureScroll: (instance)=>({
            x: instance.scrollLeft,
            y: instance.scrollTop
        }),
    defaultParent: ()=>{
        if (!$9f0cd6e302f97046$export$b91509fcf893b648.current) {
            const documentNode = new (0, $2e704cfa3544bdc6$export$2d029a49a09b6177)({});
            documentNode.mount(window);
            documentNode.setOptions({
                layoutScroll: true
            });
            $9f0cd6e302f97046$export$b91509fcf893b648.current = documentNode;
        }
        return $9f0cd6e302f97046$export$b91509fcf893b648.current;
    },
    resetTransform: (instance, value)=>{
        instance.style.transform = value !== undefined ? value : "none";
    },
    checkIsScrollRoot: (instance)=>Boolean(window.getComputedStyle(instance).position === "fixed")
});


const $4f797dc01d53a48c$export$d7d5d435647ed5a0 = {
    pan: {
        Feature: (0, $eb5b67e8076eeec3$export$b4f8f1ee75ce5859)
    },
    drag: {
        Feature: (0, $775cbfbec7f3e7b1$export$5d97dc2872682820),
        ProjectionNode: (0, $9f0cd6e302f97046$export$b61a9eb3dbde8858),
        MeasureLayout: $6d3ffb27b820752c$export$779f5fb01ad751cd
    }
};







function $11dc5bd2645fc825$var$addHoverEvent(node, isActive) {
    const eventName = isActive ? "pointerenter" : "pointerleave";
    const callbackName = isActive ? "onHoverStart" : "onHoverEnd";
    const handleEvent = (event, info)=>{
        if (event.pointerType === "touch" || (0, $b620b19e58064217$export$1b3dd616664938e4)()) return;
        const props = node.getProps();
        if (node.animationState && props.whileHover) node.animationState.setActive("whileHover", isActive);
        const callback = props[callbackName];
        if (callback) (0, $2668c8a722676613$export$2cef06c20297c17d).postRender(()=>callback(event, info));
    };
    return (0, $a2f9971c4d7d6c59$export$fcff2e64e6676b81)(node.current, eventName, handleEvent, {
        passive: !node.getProps()[callbackName]
    });
}
class $11dc5bd2645fc825$export$93a81ea037eac456 extends (0, $0e2551b19b8df95b$export$6e91cf7616333d5) {
    mount() {
        this.unmount = (0, $a510fe5631c50899$export$a4627e546088548d)($11dc5bd2645fc825$var$addHoverEvent(this.node, true), $11dc5bd2645fc825$var$addHoverEvent(this.node, false));
    }
    unmount() {}
}





class $1ab18cc01ec74d34$export$d4826db40d47595b extends (0, $0e2551b19b8df95b$export$6e91cf7616333d5) {
    constructor(){
        super(...arguments);
        this.isActive = false;
    }
    onFocus() {
        let isFocusVisible = false;
        /**
         * If this element doesn't match focus-visible then don't
         * apply whileHover. But, if matches throws that focus-visible
         * is not a valid selector then in that browser outline styles will be applied
         * to the element by default and we want to match that behaviour with whileFocus.
         */ try {
            isFocusVisible = this.node.current.matches(":focus-visible");
        } catch (e) {
            isFocusVisible = true;
        }
        if (!isFocusVisible || !this.node.animationState) return;
        this.node.animationState.setActive("whileFocus", true);
        this.isActive = true;
    }
    onBlur() {
        if (!this.isActive || !this.node.animationState) return;
        this.node.animationState.setActive("whileFocus", false);
        this.isActive = false;
    }
    mount() {
        this.unmount = (0, $a510fe5631c50899$export$a4627e546088548d)((0, $52bbcc091bf26590$export$b1d829ddf82884aa)(this.node.current, "focus", ()=>this.onFocus()), (0, $52bbcc091bf26590$export$b1d829ddf82884aa)(this.node.current, "blur", ()=>this.onBlur()));
    }
    unmount() {}
}








/**
 * Recursively traverse up the tree to check whether the provided child node
 * is the parent or a descendant of it.
 *
 * @param parent - Element to find
 * @param child - Element to test against parent
 */ const $0f852327d576566c$export$e841ada32ff745b = (parent, child)=>{
    if (!child) return false;
    else if (parent === child) return true;
    else return $0f852327d576566c$export$e841ada32ff745b(parent, child.parentElement);
};




function $9c45cdbc6fb4c44c$var$fireSyntheticPointerEvent(name, handler) {
    if (!handler) return;
    const syntheticPointerEvent = new PointerEvent("pointer" + name);
    handler(syntheticPointerEvent, (0, $bb2968ceabdf7aba$export$12f84bb882d06e1a)(syntheticPointerEvent));
}
class $9c45cdbc6fb4c44c$export$f026abdbba7f0c9e extends (0, $0e2551b19b8df95b$export$6e91cf7616333d5) {
    constructor(){
        super(...arguments);
        this.removeStartListeners = (0, $c90734627ed96e3f$export$8793edee2d425525);
        this.removeEndListeners = (0, $c90734627ed96e3f$export$8793edee2d425525);
        this.removeAccessibleListeners = (0, $c90734627ed96e3f$export$8793edee2d425525);
        this.startPointerPress = (startEvent, startInfo)=>{
            if (this.isPressing) return;
            this.removeEndListeners();
            const props = this.node.getProps();
            const endPointerPress = (endEvent, endInfo)=>{
                if (!this.checkPressEnd()) return;
                const { onTap: onTap, onTapCancel: onTapCancel, globalTapTarget: globalTapTarget } = this.node.getProps();
                /**
                 * We only count this as a tap gesture if the event.target is the same
                 * as, or a child of, this component's element
                 */ const handler = !globalTapTarget && !(0, $0f852327d576566c$export$e841ada32ff745b)(this.node.current, endEvent.target) ? onTapCancel : onTap;
                if (handler) (0, $2668c8a722676613$export$2cef06c20297c17d).update(()=>handler(endEvent, endInfo));
            };
            const removePointerUpListener = (0, $a2f9971c4d7d6c59$export$fcff2e64e6676b81)(window, "pointerup", endPointerPress, {
                passive: !(props.onTap || props["onPointerUp"])
            });
            const removePointerCancelListener = (0, $a2f9971c4d7d6c59$export$fcff2e64e6676b81)(window, "pointercancel", (cancelEvent, cancelInfo)=>this.cancelPress(cancelEvent, cancelInfo), {
                passive: !(props.onTapCancel || props["onPointerCancel"])
            });
            this.removeEndListeners = (0, $a510fe5631c50899$export$a4627e546088548d)(removePointerUpListener, removePointerCancelListener);
            this.startPress(startEvent, startInfo);
        };
        this.startAccessiblePress = ()=>{
            const handleKeydown = (keydownEvent)=>{
                if (keydownEvent.key !== "Enter" || this.isPressing) return;
                const handleKeyup = (keyupEvent)=>{
                    if (keyupEvent.key !== "Enter" || !this.checkPressEnd()) return;
                    $9c45cdbc6fb4c44c$var$fireSyntheticPointerEvent("up", (event, info)=>{
                        const { onTap: onTap } = this.node.getProps();
                        if (onTap) (0, $2668c8a722676613$export$2cef06c20297c17d).postRender(()=>onTap(event, info));
                    });
                };
                this.removeEndListeners();
                this.removeEndListeners = (0, $52bbcc091bf26590$export$b1d829ddf82884aa)(this.node.current, "keyup", handleKeyup);
                $9c45cdbc6fb4c44c$var$fireSyntheticPointerEvent("down", (event, info)=>{
                    this.startPress(event, info);
                });
            };
            const removeKeydownListener = (0, $52bbcc091bf26590$export$b1d829ddf82884aa)(this.node.current, "keydown", handleKeydown);
            const handleBlur = ()=>{
                if (!this.isPressing) return;
                $9c45cdbc6fb4c44c$var$fireSyntheticPointerEvent("cancel", (cancelEvent, cancelInfo)=>this.cancelPress(cancelEvent, cancelInfo));
            };
            const removeBlurListener = (0, $52bbcc091bf26590$export$b1d829ddf82884aa)(this.node.current, "blur", handleBlur);
            this.removeAccessibleListeners = (0, $a510fe5631c50899$export$a4627e546088548d)(removeKeydownListener, removeBlurListener);
        };
    }
    startPress(event, info) {
        this.isPressing = true;
        const { onTapStart: onTapStart, whileTap: whileTap } = this.node.getProps();
        /**
         * Ensure we trigger animations before firing event callback
         */ if (whileTap && this.node.animationState) this.node.animationState.setActive("whileTap", true);
        if (onTapStart) (0, $2668c8a722676613$export$2cef06c20297c17d).postRender(()=>onTapStart(event, info));
    }
    checkPressEnd() {
        this.removeEndListeners();
        this.isPressing = false;
        const props = this.node.getProps();
        if (props.whileTap && this.node.animationState) this.node.animationState.setActive("whileTap", false);
        return !(0, $b620b19e58064217$export$1b3dd616664938e4)();
    }
    cancelPress(event, info) {
        if (!this.checkPressEnd()) return;
        const { onTapCancel: onTapCancel } = this.node.getProps();
        if (onTapCancel) (0, $2668c8a722676613$export$2cef06c20297c17d).postRender(()=>onTapCancel(event, info));
    }
    mount() {
        const props = this.node.getProps();
        const removePointerListener = (0, $a2f9971c4d7d6c59$export$fcff2e64e6676b81)(props.globalTapTarget ? window : this.node.current, "pointerdown", this.startPointerPress, {
            passive: !(props.onTapStart || props["onPointerStart"])
        });
        const removeFocusListener = (0, $52bbcc091bf26590$export$b1d829ddf82884aa)(this.node.current, "focus", this.startAccessiblePress);
        this.removeStartListeners = (0, $a510fe5631c50899$export$a4627e546088548d)(removePointerListener, removeFocusListener);
    }
    unmount() {
        this.removeStartListeners();
        this.removeEndListeners();
        this.removeAccessibleListeners();
    }
}



/**
 * Map an IntersectionHandler callback to an element. We only ever make one handler for one
 * element, so even though these handlers might all be triggered by different
 * observers, we can keep them in the same map.
 */ const $848b825b11da1e75$var$observerCallbacks = new WeakMap();
/**
 * Multiple observers can be created for multiple element/document roots. Each with
 * different settings. So here we store dictionaries of observers to each root,
 * using serialised settings (threshold/margin) as lookup keys.
 */ const $848b825b11da1e75$var$observers = new WeakMap();
const $848b825b11da1e75$var$fireObserverCallback = (entry)=>{
    const callback = $848b825b11da1e75$var$observerCallbacks.get(entry.target);
    callback && callback(entry);
};
const $848b825b11da1e75$var$fireAllObserverCallbacks = (entries)=>{
    entries.forEach($848b825b11da1e75$var$fireObserverCallback);
};
function $848b825b11da1e75$var$initIntersectionObserver({ root: root, ...options }) {
    const lookupRoot = root || document;
    /**
     * If we don't have an observer lookup map for this root, create one.
     */ if (!$848b825b11da1e75$var$observers.has(lookupRoot)) $848b825b11da1e75$var$observers.set(lookupRoot, {});
    const rootObservers = $848b825b11da1e75$var$observers.get(lookupRoot);
    const key = JSON.stringify(options);
    /**
     * If we don't have an observer for this combination of root and settings,
     * create one.
     */ if (!rootObservers[key]) rootObservers[key] = new IntersectionObserver($848b825b11da1e75$var$fireAllObserverCallbacks, {
        root: root,
        ...options
    });
    return rootObservers[key];
}
function $848b825b11da1e75$export$b2bcd62fb7925aa5(element, options, callback) {
    const rootInteresectionObserver = $848b825b11da1e75$var$initIntersectionObserver(options);
    $848b825b11da1e75$var$observerCallbacks.set(element, callback);
    rootInteresectionObserver.observe(element);
    return ()=>{
        $848b825b11da1e75$var$observerCallbacks.delete(element);
        rootInteresectionObserver.unobserve(element);
    };
}


const $fdd2d91840e134f5$var$thresholdNames = {
    some: 0,
    all: 1
};
class $fdd2d91840e134f5$export$150851c8cc2f0c72 extends (0, $0e2551b19b8df95b$export$6e91cf7616333d5) {
    constructor(){
        super(...arguments);
        this.hasEnteredView = false;
        this.isInView = false;
    }
    startObserver() {
        this.unmount();
        const { viewport: viewport = {} } = this.node.getProps();
        const { root: root, margin: rootMargin, amount: amount = "some", once: once } = viewport;
        const options = {
            root: root ? root.current : undefined,
            rootMargin: rootMargin,
            threshold: typeof amount === "number" ? amount : $fdd2d91840e134f5$var$thresholdNames[amount]
        };
        const onIntersectionUpdate = (entry)=>{
            const { isIntersecting: isIntersecting } = entry;
            /**
             * If there's been no change in the viewport state, early return.
             */ if (this.isInView === isIntersecting) return;
            this.isInView = isIntersecting;
            /**
             * Handle hasEnteredView. If this is only meant to run once, and
             * element isn't visible, early return. Otherwise set hasEnteredView to true.
             */ if (once && !isIntersecting && this.hasEnteredView) return;
            else if (isIntersecting) this.hasEnteredView = true;
            if (this.node.animationState) this.node.animationState.setActive("whileInView", isIntersecting);
            /**
             * Use the latest committed props rather than the ones in scope
             * when this observer is created
             */ const { onViewportEnter: onViewportEnter, onViewportLeave: onViewportLeave } = this.node.getProps();
            const callback = isIntersecting ? onViewportEnter : onViewportLeave;
            callback && callback(entry);
        };
        return (0, $848b825b11da1e75$export$b2bcd62fb7925aa5)(this.node.current, options, onIntersectionUpdate);
    }
    mount() {
        this.startObserver();
    }
    update() {
        if (typeof IntersectionObserver === "undefined") return;
        const { props: props, prevProps: prevProps } = this.node;
        const hasOptionsChanged = [
            "amount",
            "margin",
            "root"
        ].some($fdd2d91840e134f5$var$hasViewportOptionChanged(props, prevProps));
        if (hasOptionsChanged) this.startObserver();
    }
    unmount() {}
}
function $fdd2d91840e134f5$var$hasViewportOptionChanged({ viewport: viewport = {} }, { viewport: prevViewport = {} } = {}) {
    return (name)=>viewport[name] !== prevViewport[name];
}


const $977cf784158004df$export$e5b72898e5a201f1 = {
    inView: {
        Feature: (0, $fdd2d91840e134f5$export$150851c8cc2f0c72)
    },
    tap: {
        Feature: (0, $9c45cdbc6fb4c44c$export$f026abdbba7f0c9e)
    },
    focus: {
        Feature: (0, $1ab18cc01ec74d34$export$d4826db40d47595b)
    },
    hover: {
        Feature: (0, $11dc5bd2645fc825$export$93a81ea037eac456)
    }
};




const $b5d3ffa854a4de95$export$b3219800bda33a1f = {
    layout: {
        ProjectionNode: (0, $9f0cd6e302f97046$export$b61a9eb3dbde8858),
        MeasureLayout: $6d3ffb27b820752c$export$779f5fb01ad751cd
    }
};



var $dRzna = parcelRequire("dRzna");

var $eeH7J = parcelRequire("eeH7J");

var $eeH7J = parcelRequire("eeH7J");
"use client";
/**
 * @public
 */ const $f79c9a1bd76bed7c$export$22a697fb29aac98d = (0, $eeH7J.createContext)({
    transformPagePoint: (p)=>p,
    isStatic: false,
    reducedMotion: "never"
});



var $eeH7J = parcelRequire("eeH7J");
"use client";
const $10cb616f5ff4f925$export$2285bbca2c666415 = (0, $eeH7J.createContext)({});



var $eeH7J = parcelRequire("eeH7J");




var $eeH7J = parcelRequire("eeH7J");
"use client";
const $9be1ba1cdd29066b$export$40f10139ecf1f171 = (0, $eeH7J.createContext)({
    strict: false
});







let $b8ea47d48372d11c$var$scheduleHandoffComplete = false;
function $b8ea47d48372d11c$export$dc0335d73ab0b115(Component, visualState, props, createVisualElement, ProjectionNodeConstructor) {
    var _a;
    const { visualElement: parent } = (0, $eeH7J.useContext)((0, $10cb616f5ff4f925$export$2285bbca2c666415));
    const lazyContext = (0, $eeH7J.useContext)((0, $9be1ba1cdd29066b$export$40f10139ecf1f171));
    const presenceContext = (0, $eeH7J.useContext)((0, $2026c3a36ffa4174$export$f224e4635b6f8ce2));
    const reducedMotionConfig = (0, $eeH7J.useContext)((0, $f79c9a1bd76bed7c$export$22a697fb29aac98d)).reducedMotion;
    const visualElementRef = (0, $eeH7J.useRef)();
    /**
     * If we haven't preloaded a renderer, check to see if we have one lazy-loaded
     */ createVisualElement = createVisualElement || lazyContext.renderer;
    if (!visualElementRef.current && createVisualElement) visualElementRef.current = createVisualElement(Component, {
        visualState: visualState,
        parent: parent,
        props: props,
        presenceContext: presenceContext,
        blockInitialAnimation: presenceContext ? presenceContext.initial === false : false,
        reducedMotionConfig: reducedMotionConfig
    });
    const visualElement = visualElementRef.current;
    /**
     * Load Motion gesture and animation features. These are rendered as renderless
     * components so each feature can optionally make use of React lifecycle methods.
     */ const initialLayoutGroupConfig = (0, $eeH7J.useContext)((0, $d06770095535cbfe$export$da5f7b802957459a));
    if (visualElement && !visualElement.projection && ProjectionNodeConstructor && (visualElement.type === "html" || visualElement.type === "svg")) $b8ea47d48372d11c$var$createProjectionNode(visualElementRef.current, props, ProjectionNodeConstructor, initialLayoutGroupConfig);
    (0, $eeH7J.useInsertionEffect)(()=>{
        visualElement && visualElement.update(props, presenceContext);
    });
    /**
     * Cache this value as we want to know whether HandoffAppearAnimations
     * was present on initial render - it will be deleted after this.
     */ const optimisedAppearId = props[0, $bd1f6e057be11122$export$8592e1c077c890a6];
    const wantsHandoff = (0, $eeH7J.useRef)(Boolean(optimisedAppearId) && !window.MotionHandoffIsComplete && ((_a = window.MotionHasOptimisedAnimation) === null || _a === void 0 ? void 0 : _a.call(window, optimisedAppearId)));
    (0, $17cc282998a57b95$export$700979bc83e7db82)(()=>{
        if (!visualElement) return;
        visualElement.updateFeatures();
        (0, $56c6f990d38070fe$export$bb76eed83315504c).render(visualElement.render);
        /**
         * Ideally this function would always run in a useEffect.
         *
         * However, if we have optimised appear animations to handoff from,
         * it needs to happen synchronously to ensure there's no flash of
         * incorrect styles in the event of a hydration error.
         *
         * So if we detect a situtation where optimised appear animations
         * are running, we use useLayoutEffect to trigger animations.
         */ if (wantsHandoff.current && visualElement.animationState) visualElement.animationState.animateChanges();
    });
    (0, $eeH7J.useEffect)(()=>{
        if (!visualElement) return;
        if (!wantsHandoff.current && visualElement.animationState) visualElement.animationState.animateChanges();
        wantsHandoff.current = false;
        // This ensures all future calls to animateChanges() will run in useEffect
        if (!$b8ea47d48372d11c$var$scheduleHandoffComplete) {
            $b8ea47d48372d11c$var$scheduleHandoffComplete = true;
            queueMicrotask($b8ea47d48372d11c$var$completeHandoff);
        }
    });
    return visualElement;
}
function $b8ea47d48372d11c$var$completeHandoff() {
    window.MotionHandoffIsComplete = true;
}
function $b8ea47d48372d11c$var$createProjectionNode(visualElement, props, ProjectionNodeConstructor, initialPromotionConfig) {
    const { layoutId: layoutId, layout: layout, drag: drag, dragConstraints: dragConstraints, layoutScroll: layoutScroll, layoutRoot: layoutRoot } = props;
    visualElement.projection = new ProjectionNodeConstructor(visualElement.latestValues, props["data-framer-portal-id"] ? undefined : $b8ea47d48372d11c$var$getClosestProjectingNode(visualElement.parent));
    visualElement.projection.setOptions({
        layoutId: layoutId,
        layout: layout,
        alwaysMeasureLayout: Boolean(drag) || dragConstraints && (0, $ed6b374e0bfa2f8b$export$dedd81df7bc1307)(dragConstraints),
        visualElement: visualElement,
        /**
         * TODO: Update options in an effect. This could be tricky as it'll be too late
         * to update by the time layout animations run.
         * We also need to fix this safeToRemove by linking it up to the one returned by usePresence,
         * ensuring it gets called if there's no potential layout animations.
         *
         */ animationType: typeof layout === "string" ? layout : "both",
        initialPromotionConfig: initialPromotionConfig,
        layoutScroll: layoutScroll,
        layoutRoot: layoutRoot
    });
}
function $b8ea47d48372d11c$var$getClosestProjectingNode(visualElement) {
    if (!visualElement) return undefined;
    return visualElement.options.allowProjection !== false ? visualElement.projection : $b8ea47d48372d11c$var$getClosestProjectingNode(visualElement.parent);
}



var $eeH7J = parcelRequire("eeH7J");

/**
 * Creates a ref function that, when called, hydrates the provided
 * external ref and VisualElement.
 */ function $8e604e026e1c0cf4$export$c684914703d321fd(visualState, visualElement, externalRef) {
    return (0, $eeH7J.useCallback)((instance)=>{
        instance && visualState.mount && visualState.mount(instance);
        if (visualElement) {
            if (instance) visualElement.mount(instance);
            else visualElement.unmount();
        }
        if (externalRef) {
            if (typeof externalRef === "function") externalRef(instance);
            else if ((0, $ed6b374e0bfa2f8b$export$dedd81df7bc1307)(externalRef)) externalRef.current = instance;
        }
    }, /**
     * Only pass a new ref callback to React if we've received a visual element
     * factory. Otherwise we'll be mounting/remounting every time externalRef
     * or other dependencies change.
     */ [
        visualElement
    ]);
}



var $eeH7J = parcelRequire("eeH7J");





function $db35ba61420c0bc2$export$4b3c3bd8d910d78d(props) {
    return (0, $f29cdb74f4d8f17d$export$aa71198ceeaf53ce)(props.animate) || (0, $7526b0a811789693$export$1405a65085f40b9).some((name)=>(0, $bfdcb20e850e14f7$export$720b90e312cea233)(props[name]));
}
function $db35ba61420c0bc2$export$ce46fa4165cdec40(props) {
    return Boolean($db35ba61420c0bc2$export$4b3c3bd8d910d78d(props) || props.variants);
}


function $e749979db1576994$export$12fc32fc096a04a3(props, context) {
    if ((0, $db35ba61420c0bc2$export$4b3c3bd8d910d78d)(props)) {
        const { initial: initial, animate: animate } = props;
        return {
            initial: initial === false || (0, $bfdcb20e850e14f7$export$720b90e312cea233)(initial) ? initial : undefined,
            animate: (0, $bfdcb20e850e14f7$export$720b90e312cea233)(animate) ? animate : undefined
        };
    }
    return props.inherit !== false ? context : {};
}


function $95feffab0212c423$export$c5638d843b37a176(props) {
    const { initial: initial, animate: animate } = (0, $e749979db1576994$export$12fc32fc096a04a3)(props, (0, $eeH7J.useContext)((0, $10cb616f5ff4f925$export$2285bbca2c666415)));
    return (0, $eeH7J.useMemo)(()=>({
            initial: initial,
            animate: animate
        }), [
        $95feffab0212c423$var$variantLabelsAsDependency(initial),
        $95feffab0212c423$var$variantLabelsAsDependency(animate)
    ]);
}
function $95feffab0212c423$var$variantLabelsAsDependency(prop) {
    return Array.isArray(prop) ? prop.join(" ") : prop;
}


const $217bebd9cdd21726$var$featureProps = {
    animation: [
        "animate",
        "variants",
        "whileHover",
        "whileTap",
        "exit",
        "whileInView",
        "whileFocus",
        "whileDrag"
    ],
    exit: [
        "exit"
    ],
    drag: [
        "drag",
        "dragControls"
    ],
    focus: [
        "whileFocus"
    ],
    hover: [
        "whileHover",
        "onHoverStart",
        "onHoverEnd"
    ],
    tap: [
        "whileTap",
        "onTap",
        "onTapStart",
        "onTapCancel"
    ],
    pan: [
        "onPan",
        "onPanStart",
        "onPanSessionStart",
        "onPanEnd"
    ],
    inView: [
        "whileInView",
        "onViewportEnter",
        "onViewportLeave"
    ],
    layout: [
        "layout",
        "layoutId"
    ]
};
const $217bebd9cdd21726$export$65570e08d843624d = {};
for(const key in $217bebd9cdd21726$var$featureProps)$217bebd9cdd21726$export$65570e08d843624d[key] = {
    isEnabled: (props)=>$217bebd9cdd21726$var$featureProps[key].some((name)=>!!props[name])
};


function $47c02d192793b5df$export$449561ec5703cdc8(features) {
    for(const key in features)(0, $217bebd9cdd21726$export$65570e08d843624d)[key] = {
        ...(0, $217bebd9cdd21726$export$65570e08d843624d)[key],
        ...features[key]
    };
}





const $fc3933eda9c7ed40$export$28e2e4cce424ae23 = Symbol.for("motionComponentSymbol");




"use client";
/**
 * Create a `motion` component.
 *
 * This function accepts a Component argument, which can be either a string (ie "div"
 * for `motion.div`), or an actual React component.
 *
 * Alongside this is a config option which provides a way of rendering the provided
 * component "offline", or outside the React render cycle.
 */ function $dfb7729452da4dad$export$c3ad4a902bccc2d8({ preloadedFeatures: preloadedFeatures, createVisualElement: createVisualElement, useRender: useRender, useVisualState: useVisualState, Component: Component }) {
    preloadedFeatures && (0, $47c02d192793b5df$export$449561ec5703cdc8)(preloadedFeatures);
    function MotionComponent(props, externalRef) {
        /**
         * If we need to measure the element we load this functionality in a
         * separate class component in order to gain access to getSnapshotBeforeUpdate.
         */ let MeasureLayout;
        const configAndProps = {
            ...(0, $eeH7J.useContext)((0, $f79c9a1bd76bed7c$export$22a697fb29aac98d)),
            ...props,
            layoutId: $dfb7729452da4dad$var$useLayoutId(props)
        };
        const { isStatic: isStatic } = configAndProps;
        const context = (0, $95feffab0212c423$export$c5638d843b37a176)(props);
        const visualState = useVisualState(props, isStatic);
        if (!isStatic && (0, $8cf061ae720cd83e$export$4e09c449d6c407f7)) {
            $dfb7729452da4dad$var$useStrictMode(configAndProps, preloadedFeatures);
            const layoutProjection = $dfb7729452da4dad$var$getProjectionFunctionality(configAndProps);
            MeasureLayout = layoutProjection.MeasureLayout;
            /**
             * Create a VisualElement for this component. A VisualElement provides a common
             * interface to renderer-specific APIs (ie DOM/Three.js etc) as well as
             * providing a way of rendering to these APIs outside of the React render loop
             * for more performant animations and interactions
             */ context.visualElement = (0, $b8ea47d48372d11c$export$dc0335d73ab0b115)(Component, visualState, configAndProps, createVisualElement, layoutProjection.ProjectionNode);
        }
        /**
         * The mount order and hierarchy is specific to ensure our element ref
         * is hydrated by the time features fire their effects.
         */ return (0, $dRzna.jsxs)((0, $10cb616f5ff4f925$export$2285bbca2c666415).Provider, {
            value: context,
            children: [
                MeasureLayout && context.visualElement ? (0, $dRzna.jsx)(MeasureLayout, {
                    visualElement: context.visualElement,
                    ...configAndProps
                }) : null,
                useRender(Component, props, (0, $8e604e026e1c0cf4$export$c684914703d321fd)(visualState, context.visualElement, externalRef), visualState, isStatic, context.visualElement)
            ]
        });
    }
    const ForwardRefMotionComponent = (0, $eeH7J.forwardRef)(MotionComponent);
    ForwardRefMotionComponent[0, $fc3933eda9c7ed40$export$28e2e4cce424ae23] = Component;
    return ForwardRefMotionComponent;
}
function $dfb7729452da4dad$var$useLayoutId({ layoutId: layoutId }) {
    const layoutGroupId = (0, $eeH7J.useContext)((0, $7e832de67499b416$export$a3579ca508007a95)).id;
    return layoutGroupId && layoutId !== undefined ? layoutGroupId + "-" + layoutId : layoutId;
}
function $dfb7729452da4dad$var$useStrictMode(configAndProps, preloadedFeatures) {
    const isStrict = (0, $eeH7J.useContext)((0, $9be1ba1cdd29066b$export$40f10139ecf1f171)).strict;
}
function $dfb7729452da4dad$var$getProjectionFunctionality(props) {
    const { drag: drag, layout: layout } = (0, $217bebd9cdd21726$export$65570e08d843624d);
    if (!drag && !layout) return {};
    const combined = {
        ...drag,
        ...layout
    };
    return {
        MeasureLayout: (drag === null || drag === void 0 ? void 0 : drag.isEnabled(props)) || (layout === null || layout === void 0 ? void 0 : layout.isEnabled(props)) ? combined.MeasureLayout : undefined,
        ProjectionNode: combined.ProjectionNode
    };
}


/**
 * We keep these listed separately as we use the lowercase tag names as part
 * of the runtime bundle to detect SVG components
 */ const $a770698d5d6425cb$export$40209c4c512158e6 = [
    "animate",
    "circle",
    "defs",
    "desc",
    "ellipse",
    "g",
    "image",
    "line",
    "filter",
    "marker",
    "mask",
    "metadata",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "rect",
    "stop",
    "switch",
    "symbol",
    "svg",
    "text",
    "tspan",
    "use",
    "view"
];


function $fa075626af2c10ee$export$88f3fc2fd3766989(Component) {
    if (/**
     * If it's not a string, it's a custom React component. Currently we only support
     * HTML custom React components.
     */ typeof Component !== "string" || /**
         * If it contains a dash, the element is a custom HTML webcomponent.
         */ Component.includes("-")) return false;
    else if (/**
     * If it's in our list of lowercase SVG tags, it's an SVG component
     */ (0, $a770698d5d6425cb$export$40209c4c512158e6).indexOf(Component) > -1 || /**
         * If it contains a capital letter, it's an SVG component
         */ /[A-Z]/u.test(Component)) return true;
    return false;
}



function $8731e770a6b2e9fa$export$1a32bf6229c258c0(element, { style: style, vars: vars }, styleProp, projection) {
    Object.assign(element.style, style, projection && projection.getProjectionStyles(styleProp));
    // Loop over any CSS variables and assign those.
    for(const key in vars)element.style.setProperty(key, vars[key]);
}


/**
 * A set of attribute names that are always read/written as camel case.
 */ const $aa386d96766cdbf4$export$28931db5d57958e5 = new Set([
    "baseFrequency",
    "diffuseConstant",
    "kernelMatrix",
    "kernelUnitLength",
    "keySplines",
    "keyTimes",
    "limitingConeAngle",
    "markerHeight",
    "markerWidth",
    "numOctaves",
    "targetX",
    "targetY",
    "surfaceScale",
    "specularConstant",
    "specularExponent",
    "stdDeviation",
    "tableValues",
    "viewBox",
    "gradientTransform",
    "pathLength",
    "startOffset",
    "textLength",
    "lengthAdjust"
]);


function $41e5124bd72f0d4a$export$c5f8399d19a7394b(element, renderState, _styleProp, projection) {
    (0, $8731e770a6b2e9fa$export$1a32bf6229c258c0)(element, renderState, undefined, projection);
    for(const key in renderState.attrs)element.setAttribute(!(0, $aa386d96766cdbf4$export$28931db5d57958e5).has(key) ? (0, $76d837a31980cd1f$export$9fd24a634729c672)(key) : key, renderState.attrs[key]);
}





function $28b30eb12c17b65c$export$6d27ce8e3de1c3cf(key, { layout: layout, layoutId: layoutId }) {
    return (0, $ea8236087cf451dc$export$7b42a0094fb00b6e).has(key) || key.startsWith("origin") || (layout || layoutId !== undefined) && (!!(0, $5a27ca56288b5194$export$91ddd985b97788d1)[key] || key === "opacity");
}



function $ba4595c2b86ce2ce$export$16da615486abaa45(props, prevProps, visualElement) {
    var _a;
    const { style: style } = props;
    const newValues = {};
    for(const key in style)if ((0, $97dfd46cf2e43daf$export$605d60a2578142d3)(style[key]) || prevProps.style && (0, $97dfd46cf2e43daf$export$605d60a2578142d3)(prevProps.style[key]) || (0, $28b30eb12c17b65c$export$6d27ce8e3de1c3cf)(key, props) || ((_a = visualElement === null || visualElement === void 0 ? void 0 : visualElement.getValue(key)) === null || _a === void 0 ? void 0 : _a.liveStyle) !== undefined) newValues[key] = style[key];
    /**
     * If the willChange style has been manually set as a string, set
     * applyWillChange to false to prevent it from automatically being applied.
     */ if (visualElement && style && typeof style.willChange === "string") visualElement.applyWillChange = false;
    return newValues;
}



function $feed3de2ce0df473$export$16da615486abaa45(props, prevProps, visualElement) {
    const newValues = (0, $ba4595c2b86ce2ce$export$16da615486abaa45)(props, prevProps, visualElement);
    for(const key in props)if ((0, $97dfd46cf2e43daf$export$605d60a2578142d3)(props[key]) || (0, $97dfd46cf2e43daf$export$605d60a2578142d3)(prevProps[key])) {
        const targetKey = (0, $ea8236087cf451dc$export$280dc01950909d86).indexOf(key) !== -1 ? "attr" + key.charAt(0).toUpperCase() + key.substring(1) : key;
        newValues[targetKey] = props[key];
    }
    return newValues;
}



var $eeH7J = parcelRequire("eeH7J");




var $eeH7J = parcelRequire("eeH7J");
/**
 * Creates a constant value over the lifecycle of a component.
 *
 * Even if `useMemo` is provided an empty array as its final argument, it doesn't offer
 * a guarantee that it won't re-run for performance reasons later on. By using `useConstant`
 * you can ensure that initialisers don't execute twice or more.
 */ function $450f33b6a8740b8a$export$fe4300aa8eebea86(init) {
    const ref = (0, $eeH7J.useRef)(null);
    if (ref.current === null) ref.current = init();
    return ref.current;
}







function $d16d9c952a878d05$var$makeState({ applyWillChange: applyWillChange = false, scrapeMotionValuesFromProps: scrapeMotionValuesFromProps, createRenderState: createRenderState, onMount: onMount }, props, context, presenceContext, isStatic) {
    const state = {
        latestValues: $d16d9c952a878d05$var$makeLatestValues(props, context, presenceContext, isStatic ? false : applyWillChange, scrapeMotionValuesFromProps),
        renderState: createRenderState()
    };
    if (onMount) state.mount = (instance)=>onMount(props, instance, state);
    return state;
}
const $d16d9c952a878d05$export$e91e107bc6d03a8e = (config)=>(props, isStatic)=>{
        const context = (0, $eeH7J.useContext)((0, $10cb616f5ff4f925$export$2285bbca2c666415));
        const presenceContext = (0, $eeH7J.useContext)((0, $2026c3a36ffa4174$export$f224e4635b6f8ce2));
        const make = ()=>$d16d9c952a878d05$var$makeState(config, props, context, presenceContext, isStatic);
        return isStatic ? make() : (0, $450f33b6a8740b8a$export$fe4300aa8eebea86)(make);
    };
function $d16d9c952a878d05$var$addWillChange(willChange, name) {
    const memberName = (0, $747b8e31f6efe634$export$b3f9dd865b560c6)(name);
    if (memberName) (0, $51a4ba498ba1dae1$export$20e507e47fae79fd)(willChange, memberName);
}
function $d16d9c952a878d05$var$forEachDefinition(props, definition, callback) {
    const list = Array.isArray(definition) ? definition : [
        definition
    ];
    for(let i = 0; i < list.length; i++){
        const resolved = (0, $195eed3b69cf8a61$export$d68f140c4d9b48bc)(props, list[i]);
        if (resolved) {
            const { transitionEnd: transitionEnd, transition: transition, ...target } = resolved;
            callback(target, transitionEnd);
        }
    }
}
function $d16d9c952a878d05$var$makeLatestValues(props, context, presenceContext, shouldApplyWillChange, scrapeMotionValues) {
    var _a;
    const values = {};
    const willChange = [];
    const applyWillChange = shouldApplyWillChange && ((_a = props.style) === null || _a === void 0 ? void 0 : _a.willChange) === undefined;
    const motionValues = scrapeMotionValues(props, {});
    for(const key in motionValues)values[key] = (0, $afcd820fe2a95f42$export$fcc2206ecb6d74b)(motionValues[key]);
    let { initial: initial, animate: animate } = props;
    const isControllingVariants$1 = (0, $db35ba61420c0bc2$export$4b3c3bd8d910d78d)(props);
    const isVariantNode$1 = (0, $db35ba61420c0bc2$export$ce46fa4165cdec40)(props);
    if (context && isVariantNode$1 && !isControllingVariants$1 && props.inherit !== false) {
        if (initial === undefined) initial = context.initial;
        if (animate === undefined) animate = context.animate;
    }
    let isInitialAnimationBlocked = presenceContext ? presenceContext.initial === false : false;
    isInitialAnimationBlocked = isInitialAnimationBlocked || initial === false;
    const variantToSet = isInitialAnimationBlocked ? animate : initial;
    if (variantToSet && typeof variantToSet !== "boolean" && !(0, $f29cdb74f4d8f17d$export$aa71198ceeaf53ce)(variantToSet)) $d16d9c952a878d05$var$forEachDefinition(props, variantToSet, (target, transitionEnd)=>{
        for(const key in target){
            let valueTarget = target[key];
            if (Array.isArray(valueTarget)) {
                /**
                     * Take final keyframe if the initial animation is blocked because
                     * we want to initialise at the end of that blocked animation.
                     */ const index = isInitialAnimationBlocked ? valueTarget.length - 1 : 0;
                valueTarget = valueTarget[index];
            }
            if (valueTarget !== null) values[key] = valueTarget;
        }
        for(const key in transitionEnd)values[key] = transitionEnd[key];
    });
    // Add animating values to will-change
    if (applyWillChange) {
        if (animate && initial !== false && !(0, $f29cdb74f4d8f17d$export$aa71198ceeaf53ce)(animate)) $d16d9c952a878d05$var$forEachDefinition(props, animate, (target)=>{
            for(const key in target)$d16d9c952a878d05$var$addWillChange(willChange, key);
        });
        if (willChange.length) values.willChange = willChange.join(",");
    }
    return values;
}


const $a242b898221e1c57$export$8940b483cf52eeda = ()=>({
        style: {},
        transform: {},
        transformOrigin: {},
        vars: {}
    });


const $cba5405fa7def0ce$export$41be8b43e1c4d4f9 = ()=>({
        ...(0, $a242b898221e1c57$export$8940b483cf52eeda)(),
        attrs: {}
    });



/**
 * Provided a value and a ValueType, returns the value as that value type.
 */ const $6f5fcd0543f6d6f5$export$453ef540a9a1bd6b = (value, type)=>{
    return type && typeof value === "number" ? type.transform(value) : value;
};



const $8d6e9a01f9ac58ef$var$translateAlias = {
    x: "translateX",
    y: "translateY",
    z: "translateZ",
    transformPerspective: "perspective"
};
const $8d6e9a01f9ac58ef$var$numTransforms = (0, $ea8236087cf451dc$export$280dc01950909d86).length;
/**
 * Build a CSS transform style from individual x/y/scale etc properties.
 *
 * This outputs with a default order of transforms/scales/rotations, this can be customised by
 * providing a transformTemplate function.
 */ function $8d6e9a01f9ac58ef$export$bdc96e0d5c8f914(latestValues, transform, transformTemplate) {
    // The transform string we're going to build into.
    let transformString = "";
    let transformIsDefault = true;
    /**
     * Loop over all possible transforms in order, adding the ones that
     * are present to the transform string.
     */ for(let i = 0; i < $8d6e9a01f9ac58ef$var$numTransforms; i++){
        const key = (0, $ea8236087cf451dc$export$280dc01950909d86)[i];
        const value = latestValues[key];
        if (value === undefined) continue;
        let valueIsDefault = true;
        if (typeof value === "number") valueIsDefault = value === (key.startsWith("scale") ? 1 : 0);
        else valueIsDefault = parseFloat(value) === 0;
        if (!valueIsDefault || transformTemplate) {
            const valueAsType = (0, $6f5fcd0543f6d6f5$export$453ef540a9a1bd6b)(value, (0, $0f29681014396523$export$eec14432cd1cb67b)[key]);
            if (!valueIsDefault) {
                transformIsDefault = false;
                const transformName = $8d6e9a01f9ac58ef$var$translateAlias[key] || key;
                transformString += `${transformName}(${valueAsType}) `;
            }
            if (transformTemplate) transform[key] = valueAsType;
        }
    }
    transformString = transformString.trim();
    // If we have a custom `transform` template, pass our transform values and
    // generated transformString to that before returning
    if (transformTemplate) transformString = transformTemplate(transform, transformIsDefault ? "" : transformString);
    else if (transformIsDefault) transformString = "none";
    return transformString;
}






function $6be340daa9519b5b$export$bb517f8b40f8e99d(state, latestValues, transformTemplate) {
    const { style: style, vars: vars, transformOrigin: transformOrigin } = state;
    // Track whether we encounter any transform or transformOrigin values.
    let hasTransform = false;
    let hasTransformOrigin = false;
    /**
     * Loop over all our latest animated values and decide whether to handle them
     * as a style or CSS variable.
     *
     * Transforms and transform origins are kept separately for further processing.
     */ for(const key in latestValues){
        const value = latestValues[key];
        if ((0, $ea8236087cf451dc$export$7b42a0094fb00b6e).has(key)) {
            // If this is a transform, flag to enable further transform processing
            hasTransform = true;
            continue;
        } else if ((0, $7b632f63647c186c$export$9de1236619d9e756)(key)) {
            vars[key] = value;
            continue;
        } else {
            // Convert the value to its default value type, ie 0 -> "0px"
            const valueAsType = (0, $6f5fcd0543f6d6f5$export$453ef540a9a1bd6b)(value, (0, $0f29681014396523$export$eec14432cd1cb67b)[key]);
            if (key.startsWith("origin")) {
                // If this is a transform origin, flag and enable further transform-origin processing
                hasTransformOrigin = true;
                transformOrigin[key] = valueAsType;
            } else style[key] = valueAsType;
        }
    }
    if (!latestValues.transform) {
        if (hasTransform || transformTemplate) style.transform = (0, $8d6e9a01f9ac58ef$export$bdc96e0d5c8f914)(latestValues, state.transform, transformTemplate);
        else if (style.transform) /**
             * If we have previously created a transform but currently don't have any,
             * reset transform style to none.
             */ style.transform = "none";
    }
    /**
     * Build a transformOrigin style. Uses the same defaults as the browser for
     * undefined origins.
     */ if (hasTransformOrigin) {
        const { originX: originX = "50%", originY: originY = "50%", originZ: originZ = 0 } = transformOrigin;
        style.transformOrigin = `${originX} ${originY} ${originZ}`;
    }
}



function $d0dfe8914d333ceb$var$calcOrigin(origin, offset, size) {
    return typeof origin === "string" ? origin : (0, $2e2cc09c72ffc0aa$export$91c0eda1d06bf008).transform(offset + size * origin);
}
/**
 * The SVG transform origin defaults are different to CSS and is less intuitive,
 * so we use the measured dimensions of the SVG to reconcile these.
 */ function $d0dfe8914d333ceb$export$d4fbcfc8e5472155(dimensions, originX, originY) {
    const pxOriginX = $d0dfe8914d333ceb$var$calcOrigin(originX, dimensions.x, dimensions.width);
    const pxOriginY = $d0dfe8914d333ceb$var$calcOrigin(originY, dimensions.y, dimensions.height);
    return `${pxOriginX} ${pxOriginY}`;
}



const $0035c5f0bff34fc0$var$dashKeys = {
    offset: "stroke-dashoffset",
    array: "stroke-dasharray"
};
const $0035c5f0bff34fc0$var$camelKeys = {
    offset: "strokeDashoffset",
    array: "strokeDasharray"
};
/**
 * Build SVG path properties. Uses the path's measured length to convert
 * our custom pathLength, pathSpacing and pathOffset into stroke-dashoffset
 * and stroke-dasharray attributes.
 *
 * This function is mutative to reduce per-frame GC.
 */ function $0035c5f0bff34fc0$export$311b43f666da1d82(attrs, length, spacing = 1, offset = 0, useDashCase = true) {
    // Normalise path length by setting SVG attribute pathLength to 1
    attrs.pathLength = 1;
    // We use dash case when setting attributes directly to the DOM node and camel case
    // when defining props on a React component.
    const keys = useDashCase ? $0035c5f0bff34fc0$var$dashKeys : $0035c5f0bff34fc0$var$camelKeys;
    // Build the dash offset
    attrs[keys.offset] = (0, $2e2cc09c72ffc0aa$export$91c0eda1d06bf008).transform(-offset);
    // Build the dash array
    const pathLength = (0, $2e2cc09c72ffc0aa$export$91c0eda1d06bf008).transform(length);
    const pathSpacing = (0, $2e2cc09c72ffc0aa$export$91c0eda1d06bf008).transform(spacing);
    attrs[keys.array] = `${pathLength} ${pathSpacing}`;
}


/**
 * Build SVG visual attrbutes, like cx and style.transform
 */ function $673009f839505ee8$export$5475d24f125d7053(state, { attrX: attrX, attrY: attrY, attrScale: attrScale, originX: originX, originY: originY, pathLength: pathLength, pathSpacing: pathSpacing = 1, pathOffset: pathOffset = 0, // This is object creation, which we try to avoid per-frame.
...latest }, isSVGTag, transformTemplate) {
    (0, $6be340daa9519b5b$export$bb517f8b40f8e99d)(state, latest, transformTemplate);
    /**
     * For svg tags we just want to make sure viewBox is animatable and treat all the styles
     * as normal HTML tags.
     */ if (isSVGTag) {
        if (state.style.viewBox) state.attrs.viewBox = state.style.viewBox;
        return;
    }
    state.attrs = state.style;
    state.style = {};
    const { attrs: attrs, style: style, dimensions: dimensions } = state;
    /**
     * However, we apply transforms as CSS transforms. So if we detect a transform we take it from attrs
     * and copy it into style.
     */ if (attrs.transform) {
        if (dimensions) style.transform = attrs.transform;
        delete attrs.transform;
    }
    // Parse transformOrigin
    if (dimensions && (originX !== undefined || originY !== undefined || style.transform)) style.transformOrigin = (0, $d0dfe8914d333ceb$export$d4fbcfc8e5472155)(dimensions, originX !== undefined ? originX : 0.5, originY !== undefined ? originY : 0.5);
    // Render attrX/attrY/attrScale as attributes
    if (attrX !== undefined) attrs.x = attrX;
    if (attrY !== undefined) attrs.y = attrY;
    if (attrScale !== undefined) attrs.scale = attrScale;
    // Build SVG path if one has been defined
    if (pathLength !== undefined) (0, $0035c5f0bff34fc0$export$311b43f666da1d82)(attrs, pathLength, pathSpacing, pathOffset, false);
}


const $cd906bb243395b56$export$6328ce7565ea1049 = (tag)=>typeof tag === "string" && tag.toLowerCase() === "svg";



const $8a7257aec4d71f16$export$44dabd3fae512e85 = {
    useVisualState: (0, $d16d9c952a878d05$export$e91e107bc6d03a8e)({
        scrapeMotionValuesFromProps: (0, $feed3de2ce0df473$export$16da615486abaa45),
        createRenderState: (0, $cba5405fa7def0ce$export$41be8b43e1c4d4f9),
        onMount: (props, instance, { renderState: renderState, latestValues: latestValues })=>{
            (0, $2668c8a722676613$export$2cef06c20297c17d).read(()=>{
                try {
                    renderState.dimensions = typeof instance.getBBox === "function" ? instance.getBBox() : instance.getBoundingClientRect();
                } catch (e) {
                    // Most likely trying to measure an unrendered element under Firefox
                    renderState.dimensions = {
                        x: 0,
                        y: 0,
                        width: 0,
                        height: 0
                    };
                }
            });
            (0, $2668c8a722676613$export$2cef06c20297c17d).render(()=>{
                (0, $673009f839505ee8$export$5475d24f125d7053)(renderState, latestValues, (0, $cd906bb243395b56$export$6328ce7565ea1049)(instance.tagName), props.transformTemplate);
                (0, $41e5124bd72f0d4a$export$c5f8399d19a7394b)(instance, renderState);
            });
        }
    })
};





const $e87a55166044f2ec$export$e13ea21d87ea57c8 = {
    useVisualState: (0, $d16d9c952a878d05$export$e91e107bc6d03a8e)({
        applyWillChange: true,
        scrapeMotionValuesFromProps: $ba4595c2b86ce2ce$export$16da615486abaa45,
        createRenderState: (0, $a242b898221e1c57$export$8940b483cf52eeda)
    })
};



var $eeH7J = parcelRequire("eeH7J");

var $eeH7J = parcelRequire("eeH7J");




function $ab4fa5d37ab85604$export$40dafdb8630c956b(target, source, props) {
    for(const key in source)if (!(0, $97dfd46cf2e43daf$export$605d60a2578142d3)(source[key]) && !(0, $28b30eb12c17b65c$export$6d27ce8e3de1c3cf)(key, props)) target[key] = source[key];
}
function $ab4fa5d37ab85604$var$useInitialMotionValues({ transformTemplate: transformTemplate }, visualState) {
    return (0, $eeH7J.useMemo)(()=>{
        const state = (0, $a242b898221e1c57$export$8940b483cf52eeda)();
        (0, $6be340daa9519b5b$export$bb517f8b40f8e99d)(state, visualState, transformTemplate);
        return Object.assign({}, state.vars, state.style);
    }, [
        visualState
    ]);
}
function $ab4fa5d37ab85604$var$useStyle(props, visualState) {
    const styleProp = props.style || {};
    const style = {};
    /**
     * Copy non-Motion Values straight into style
     */ $ab4fa5d37ab85604$export$40dafdb8630c956b(style, styleProp, props);
    Object.assign(style, $ab4fa5d37ab85604$var$useInitialMotionValues(props, visualState));
    return style;
}
function $ab4fa5d37ab85604$export$57be0a314572d87d(props, visualState) {
    // The `any` isn't ideal but it is the type of createElement props argument
    const htmlProps = {};
    const style = $ab4fa5d37ab85604$var$useStyle(props, visualState);
    if (props.drag && props.dragListener !== false) {
        // Disable the ghost element when a user drags
        htmlProps.draggable = false;
        // Disable text selection
        style.userSelect = style.WebkitUserSelect = style.WebkitTouchCallout = "none";
        // Disable scrolling on the draggable direction
        style.touchAction = props.drag === true ? "none" : `pan-${props.drag === "x" ? "y" : "x"}`;
    }
    if (props.tabIndex === undefined && (props.onTap || props.onTapStart || props.whileTap)) htmlProps.tabIndex = 0;
    htmlProps.style = style;
    return htmlProps;
}


/**
 * A list of all valid MotionProps.
 *
 * @privateRemarks
 * This doesn't throw if a `MotionProp` name is missing - it should.
 */ const $9473e8e46bff55a6$var$validMotionProps = new Set([
    "animate",
    "exit",
    "variants",
    "initial",
    "style",
    "values",
    "variants",
    "transition",
    "transformTemplate",
    "custom",
    "inherit",
    "onBeforeLayoutMeasure",
    "onAnimationStart",
    "onAnimationComplete",
    "onUpdate",
    "onDragStart",
    "onDrag",
    "onDragEnd",
    "onMeasureDragConstraints",
    "onDirectionLock",
    "onDragTransitionEnd",
    "_dragX",
    "_dragY",
    "onHoverStart",
    "onHoverEnd",
    "onViewportEnter",
    "onViewportLeave",
    "globalTapTarget",
    "ignoreStrict",
    "viewport"
]);
/**
 * Check whether a prop name is a valid `MotionProp` key.
 *
 * @param key - Name of the property to check
 * @returns `true` is key is a valid `MotionProp`.
 *
 * @public
 */ function $9473e8e46bff55a6$export$2f9c46555243bf04(key) {
    return key.startsWith("while") || key.startsWith("drag") && key !== "draggable" || key.startsWith("layout") || key.startsWith("onTap") || key.startsWith("onPan") || key.startsWith("onLayout") || $9473e8e46bff55a6$var$validMotionProps.has(key);
}


let $d3983d2add71cd91$var$shouldForward = (key)=>!(0, $9473e8e46bff55a6$export$2f9c46555243bf04)(key);
function $d3983d2add71cd91$export$59d6962c470509a5(isValidProp) {
    if (!isValidProp) return;
    // Explicitly filter our events
    $d3983d2add71cd91$var$shouldForward = (key)=>key.startsWith("on") ? !(0, $9473e8e46bff55a6$export$2f9c46555243bf04)(key) : isValidProp(key);
}

/**
 * Emotion and Styled Components both allow users to pass through arbitrary props to their components
 * to dynamically generate CSS. They both use the `@emotion/is-prop-valid` package to determine which
 * of these should be passed to the underlying DOM node.
 *
 * However, when styling a Motion component `styled(motion.div)`, both packages pass through *all* props
 * as it's seen as an arbitrary component rather than a DOM node. Motion only allows arbitrary props
 * passed through the `custom` prop so it doesn't *need* the payload or computational overhead of
 * `@emotion/is-prop-valid`, however to fix this problem we need to use it.
 *
 * By making it an optionalDependency we can offer this functionality only in the situations where it's
 * actually required.
 */ try {
    /**
     * We attempt to import this package but require won't be defined in esm environments, in that case
     * isPropValid will have to be provided via `MotionContext`. In a 6.0.0 this should probably be removed
     * in favour of explicit injection.
     */ $d3983d2add71cd91$export$59d6962c470509a5($d3983d2add71cd91$import$c6bce8c37c642938$2e2bcd8739ae039);
} catch (_a) {
// We don't need to actually do anything here - the fallback is the existing `isPropValid`.
}
function $d3983d2add71cd91$export$d697c39a2985a4c(props, isDom, forwardMotionProps) {
    const filteredProps = {};
    for(const key in props){
        /**
         * values is considered a valid prop by Emotion, so if it's present
         * this will be rendered out to the DOM unless explicitly filtered.
         *
         * We check the type as it could be used with the `feColorMatrix`
         * element, which we support.
         */ if (key === "values" && typeof props.values === "object") continue;
        if ($d3983d2add71cd91$var$shouldForward(key) || forwardMotionProps === true && (0, $9473e8e46bff55a6$export$2f9c46555243bf04)(key) || !isDom && !(0, $9473e8e46bff55a6$export$2f9c46555243bf04)(key) || // If trying to use native HTML drag events, forward drag listeners
        props["draggable"] && key.startsWith("onDrag")) filteredProps[key] = props[key];
    }
    return filteredProps;
}




var $eeH7J = parcelRequire("eeH7J");




function $87d25680db1d6ce7$export$84309c4f53cb1bd5(props, visualState, _isStatic, Component) {
    const visualProps = (0, $eeH7J.useMemo)(()=>{
        const state = (0, $cba5405fa7def0ce$export$41be8b43e1c4d4f9)();
        (0, $673009f839505ee8$export$5475d24f125d7053)(state, visualState, (0, $cd906bb243395b56$export$6328ce7565ea1049)(Component), props.transformTemplate);
        return {
            ...state.attrs,
            style: {
                ...state.style
            }
        };
    }, [
        visualState
    ]);
    if (props.style) {
        const rawStyles = {};
        (0, $ab4fa5d37ab85604$export$40dafdb8630c956b)(rawStyles, props.style, props);
        visualProps.style = {
            ...rawStyles,
            ...visualProps.style
        };
    }
    return visualProps;
}



function $e6261c6903ecedcf$export$5d29104eefd89cc8(forwardMotionProps = false) {
    const useRender = (Component, props, ref, { latestValues: latestValues }, isStatic)=>{
        const useVisualProps = (0, $fa075626af2c10ee$export$88f3fc2fd3766989)(Component) ? (0, $87d25680db1d6ce7$export$84309c4f53cb1bd5) : (0, $ab4fa5d37ab85604$export$57be0a314572d87d);
        const visualProps = useVisualProps(props, latestValues, isStatic, Component);
        const filteredProps = (0, $d3983d2add71cd91$export$d697c39a2985a4c)(props, typeof Component === "string", forwardMotionProps);
        const elementProps = Component !== (0, $eeH7J.Fragment) ? {
            ...filteredProps,
            ...visualProps,
            ref: ref
        } : {};
        /**
         * If component has been handed a motion value as its child,
         * memoise its initial value and render that. Subsequent updates
         * will be handled by the onChange handler
         */ const { children: children } = props;
        const renderedChildren = (0, $eeH7J.useMemo)(()=>(0, $97dfd46cf2e43daf$export$605d60a2578142d3)(children) ? children.get() : children, [
            children
        ]);
        return (0, $eeH7J.createElement)(Component, {
            ...elementProps,
            children: renderedChildren
        });
    };
    return useRender;
}


function $f107d1fb53628652$export$d86feac869a7f0d5(preloadedFeatures, createVisualElement) {
    return function createMotionComponent(Component, { forwardMotionProps: forwardMotionProps } = {
        forwardMotionProps: false
    }) {
        const baseConfig = (0, $fa075626af2c10ee$export$88f3fc2fd3766989)(Component) ? (0, $8a7257aec4d71f16$export$44dabd3fae512e85) : (0, $e87a55166044f2ec$export$e13ea21d87ea57c8);
        const config = {
            ...baseConfig,
            preloadedFeatures: preloadedFeatures,
            useRender: (0, $e6261c6903ecedcf$export$5d29104eefd89cc8)(forwardMotionProps),
            createVisualElement: createVisualElement,
            Component: Component
        };
        return (0, $dfb7729452da4dad$export$c3ad4a902bccc2d8)(config);
    };
}



var $eeH7J = parcelRequire("eeH7J");








// Does this device prefer reduced motion? Returns `null` server-side.
const $64357612add0cc85$export$ff7706047246b98b = {
    current: null
};
const $64357612add0cc85$export$6476d16e2fd2d0db = {
    current: false
};


function $8948a8adab9203a8$export$ca9f41fb23dded3d() {
    (0, $64357612add0cc85$export$6476d16e2fd2d0db).current = true;
    if (!(0, $8cf061ae720cd83e$export$4e09c449d6c407f7)) return;
    if (window.matchMedia) {
        const motionMediaQuery = window.matchMedia("(prefers-reduced-motion)");
        const setReducedMotionPreferences = ()=>(0, $64357612add0cc85$export$ff7706047246b98b).current = motionMediaQuery.matches;
        motionMediaQuery.addListener(setReducedMotionPreferences);
        setReducedMotionPreferences();
    } else (0, $64357612add0cc85$export$ff7706047246b98b).current = false;
}












function $fb79b5c51ae0a68c$export$9a552858d5197f6e(element, next, prev) {
    for(const key in next){
        const nextValue = next[key];
        const prevValue = prev[key];
        if ((0, $97dfd46cf2e43daf$export$605d60a2578142d3)(nextValue)) /**
             * If this is a motion value found in props or style, we want to add it
             * to our visual element's motion value map.
             */ element.addValue(key, nextValue);
        else if ((0, $97dfd46cf2e43daf$export$605d60a2578142d3)(prevValue)) /**
             * If we're swapping from a motion value to a static value,
             * create a new motion value from that
             */ element.addValue(key, (0, $ebb6b8b1a738bf1d$export$ce8bdc721e76545f)(nextValue, {
            owner: element
        }));
        else if (prevValue !== nextValue) {
            /**
             * If this is a flat value that has changed, update the motion value
             * or create one if it doesn't exist. We only want to do this if we're
             * not handling the value with our animation state.
             */ if (element.hasValue(key)) {
                const existingValue = element.getValue(key);
                if (existingValue.liveStyle === true) existingValue.jump(nextValue);
                else if (!existingValue.hasAnimated) existingValue.set(nextValue);
            } else {
                const latestValue = element.getStaticValue(key);
                element.addValue(key, (0, $ebb6b8b1a738bf1d$export$ce8bdc721e76545f)(latestValue !== undefined ? latestValue : nextValue, {
                    owner: element
                }));
            }
        }
    }
    // Handle removed values
    for(const key in prev)if (next[key] === undefined) element.removeValue(key);
    return next;
}






const $64861684472349e0$export$bc2a978a17abfdde = new WeakMap();









/**
 * A list of all ValueTypes
 */ const $f6428ebb310200da$var$valueTypes = [
    ...(0, $1c32a536829b8c8a$export$d176691c1998a1f5),
    (0, $7028c17a7a695b13$export$35e9368ef982300f),
    (0, $4c282419bf833d7f$export$83a0e34f1302825b)
];
/**
 * Tests a value against the list of ValueTypes
 */ const $f6428ebb310200da$export$950e7e59ea1ffed7 = (v)=>$f6428ebb310200da$var$valueTypes.find((0, $7da4e5401aa12761$export$6eae4d0a6a7ca7cd)(v));






const $22752ef207ffd3f4$var$propEventHandlers = [
    "AnimationStart",
    "AnimationComplete",
    "Update",
    "BeforeLayoutMeasure",
    "LayoutMeasure",
    "LayoutAnimationStart",
    "LayoutAnimationComplete"
];
const $22752ef207ffd3f4$var$numVariantProps = (0, $7526b0a811789693$export$1405a65085f40b9).length;
/**
 * A VisualElement is an imperative abstraction around UI elements such as
 * HTMLElement, SVGElement, Three.Object3D etc.
 */ class $22752ef207ffd3f4$export$fa8b653c0f3714e5 {
    /**
     * This method takes React props and returns found MotionValues. For example, HTML
     * MotionValues will be found within the style prop, whereas for Three.js within attribute arrays.
     *
     * This isn't an abstract method as it needs calling in the constructor, but it is
     * intended to be one.
     */ scrapeMotionValuesFromProps(_props, _prevProps, _visualElement) {
        return {};
    }
    constructor({ parent: parent, props: props, presenceContext: presenceContext, reducedMotionConfig: reducedMotionConfig, blockInitialAnimation: blockInitialAnimation, visualState: visualState }, options = {}){
        /**
         * If true, will-change will be applied to the element. Only HTMLVisualElements
         * currently support this.
         */ this.applyWillChange = false;
        /**
         * A reference to the current underlying Instance, e.g. a HTMLElement
         * or Three.Mesh etc.
         */ this.current = null;
        /**
         * A set containing references to this VisualElement's children.
         */ this.children = new Set();
        /**
         * Determine what role this visual element should take in the variant tree.
         */ this.isVariantNode = false;
        this.isControllingVariants = false;
        /**
         * Decides whether this VisualElement should animate in reduced motion
         * mode.
         *
         * TODO: This is currently set on every individual VisualElement but feels
         * like it could be set globally.
         */ this.shouldReduceMotion = null;
        /**
         * A map of all motion values attached to this visual element. Motion
         * values are source of truth for any given animated value. A motion
         * value might be provided externally by the component via props.
         */ this.values = new Map();
        this.KeyframeResolver = (0, $b1026f81549deb9c$export$74d34ca3182f1750);
        /**
         * Cleanup functions for active features (hover/tap/exit etc)
         */ this.features = {};
        /**
         * A map of every subscription that binds the provided or generated
         * motion values onChange listeners to this visual element.
         */ this.valueSubscriptions = new Map();
        /**
         * A reference to the previously-provided motion values as returned
         * from scrapeMotionValuesFromProps. We use the keys in here to determine
         * if any motion values need to be removed after props are updated.
         */ this.prevMotionValues = {};
        /**
         * An object containing a SubscriptionManager for each active event.
         */ this.events = {};
        /**
         * An object containing an unsubscribe function for each prop event subscription.
         * For example, every "Update" event can have multiple subscribers via
         * VisualElement.on(), but only one of those can be defined via the onUpdate prop.
         */ this.propEventSubscriptions = {};
        this.notifyUpdate = ()=>this.notify("Update", this.latestValues);
        this.render = ()=>{
            this.isRenderScheduled = false;
            if (!this.current) return;
            this.triggerBuild();
            this.renderInstance(this.current, this.renderState, this.props.style, this.projection);
        };
        this.isRenderScheduled = false;
        this.scheduleRender = ()=>{
            if (!this.isRenderScheduled) {
                this.isRenderScheduled = true;
                (0, $2668c8a722676613$export$2cef06c20297c17d).render(this.render, false, true);
            }
        };
        const { latestValues: latestValues, renderState: renderState } = visualState;
        this.latestValues = latestValues;
        this.baseTarget = {
            ...latestValues
        };
        this.initialValues = props.initial ? {
            ...latestValues
        } : {};
        this.renderState = renderState;
        this.parent = parent;
        this.props = props;
        this.presenceContext = presenceContext;
        this.depth = parent ? parent.depth + 1 : 0;
        this.reducedMotionConfig = reducedMotionConfig;
        this.options = options;
        this.blockInitialAnimation = Boolean(blockInitialAnimation);
        this.isControllingVariants = (0, $db35ba61420c0bc2$export$4b3c3bd8d910d78d)(props);
        this.isVariantNode = (0, $db35ba61420c0bc2$export$ce46fa4165cdec40)(props);
        if (this.isVariantNode) this.variantChildren = new Set();
        this.manuallyAnimateOnMount = Boolean(parent && parent.current);
        /**
         * Any motion values that are provided to the element when created
         * aren't yet bound to the element, as this would technically be impure.
         * However, we iterate through the motion values and set them to the
         * initial values for this component.
         *
         * TODO: This is impure and we should look at changing this to run on mount.
         * Doing so will break some tests but this isn't necessarily a breaking change,
         * more a reflection of the test.
         */ const { willChange: willChange, ...initialMotionValues } = this.scrapeMotionValuesFromProps(props, {}, this);
        for(const key in initialMotionValues){
            const value = initialMotionValues[key];
            if (latestValues[key] !== undefined && (0, $97dfd46cf2e43daf$export$605d60a2578142d3)(value)) value.set(latestValues[key], false);
        }
    }
    mount(instance) {
        this.current = instance;
        (0, $64861684472349e0$export$bc2a978a17abfdde).set(instance, this);
        if (this.projection && !this.projection.instance) this.projection.mount(instance);
        if (this.parent && this.isVariantNode && !this.isControllingVariants) this.removeFromVariantTree = this.parent.addVariantChild(this);
        this.values.forEach((value, key)=>this.bindToMotionValue(key, value));
        if (!(0, $64357612add0cc85$export$6476d16e2fd2d0db).current) (0, $8948a8adab9203a8$export$ca9f41fb23dded3d)();
        this.shouldReduceMotion = this.reducedMotionConfig === "never" ? false : this.reducedMotionConfig === "always" ? true : (0, $64357612add0cc85$export$ff7706047246b98b).current;
        if (this.parent) this.parent.children.add(this);
        this.update(this.props, this.presenceContext);
    }
    unmount() {
        (0, $64861684472349e0$export$bc2a978a17abfdde).delete(this.current);
        this.projection && this.projection.unmount();
        (0, $2668c8a722676613$export$ec99c0ef4978dccb)(this.notifyUpdate);
        (0, $2668c8a722676613$export$ec99c0ef4978dccb)(this.render);
        this.valueSubscriptions.forEach((remove)=>remove());
        this.valueSubscriptions.clear();
        this.removeFromVariantTree && this.removeFromVariantTree();
        this.parent && this.parent.children.delete(this);
        for(const key in this.events)this.events[key].clear();
        for(const key in this.features){
            const feature = this.features[key];
            if (feature) {
                feature.unmount();
                feature.isMounted = false;
            }
        }
        this.current = null;
    }
    bindToMotionValue(key, value) {
        if (this.valueSubscriptions.has(key)) this.valueSubscriptions.get(key)();
        const valueIsTransform = (0, $ea8236087cf451dc$export$7b42a0094fb00b6e).has(key);
        const removeOnChange = value.on("change", (latestValue)=>{
            this.latestValues[key] = latestValue;
            this.props.onUpdate && (0, $2668c8a722676613$export$2cef06c20297c17d).preRender(this.notifyUpdate);
            if (valueIsTransform && this.projection) this.projection.isTransformDirty = true;
        });
        const removeOnRenderRequest = value.on("renderRequest", this.scheduleRender);
        let removeSyncCheck;
        if (window.MotionCheckAppearSync) removeSyncCheck = window.MotionCheckAppearSync(this, key, value);
        this.valueSubscriptions.set(key, ()=>{
            removeOnChange();
            removeOnRenderRequest();
            if (removeSyncCheck) removeSyncCheck();
            if (value.owner) value.stop();
        });
    }
    sortNodePosition(other) {
        /**
         * If these nodes aren't even of the same type we can't compare their depth.
         */ if (!this.current || !this.sortInstanceNodePosition || this.type !== other.type) return 0;
        return this.sortInstanceNodePosition(this.current, other.current);
    }
    updateFeatures() {
        let key = "animation";
        for(key in 0, $217bebd9cdd21726$export$65570e08d843624d){
            const featureDefinition = (0, $217bebd9cdd21726$export$65570e08d843624d)[key];
            if (!featureDefinition) continue;
            const { isEnabled: isEnabled, Feature: FeatureConstructor } = featureDefinition;
            /**
             * If this feature is enabled but not active, make a new instance.
             */ if (!this.features[key] && FeatureConstructor && isEnabled(this.props)) this.features[key] = new FeatureConstructor(this);
            /**
             * If we have a feature, mount or update it.
             */ if (this.features[key]) {
                const feature = this.features[key];
                if (feature.isMounted) feature.update();
                else {
                    feature.mount();
                    feature.isMounted = true;
                }
            }
        }
    }
    triggerBuild() {
        this.build(this.renderState, this.latestValues, this.props);
    }
    /**
     * Measure the current viewport box with or without transforms.
     * Only measures axis-aligned boxes, rotate and skew must be manually
     * removed with a re-render to work.
     */ measureViewportBox() {
        return this.current ? this.measureInstanceViewportBox(this.current, this.props) : (0, $a33f96272a0f3ced$export$6459fc9e86be362e)();
    }
    getStaticValue(key) {
        return this.latestValues[key];
    }
    setStaticValue(key, value) {
        this.latestValues[key] = value;
    }
    /**
     * Update the provided props. Ensure any newly-added motion values are
     * added to our map, old ones removed, and listeners updated.
     */ update(props, presenceContext) {
        if (props.transformTemplate || this.props.transformTemplate) this.scheduleRender();
        this.prevProps = this.props;
        this.props = props;
        this.prevPresenceContext = this.presenceContext;
        this.presenceContext = presenceContext;
        /**
         * Update prop event handlers ie onAnimationStart, onAnimationComplete
         */ for(let i = 0; i < $22752ef207ffd3f4$var$propEventHandlers.length; i++){
            const key = $22752ef207ffd3f4$var$propEventHandlers[i];
            if (this.propEventSubscriptions[key]) {
                this.propEventSubscriptions[key]();
                delete this.propEventSubscriptions[key];
            }
            const listenerName = "on" + key;
            const listener = props[listenerName];
            if (listener) this.propEventSubscriptions[key] = this.on(key, listener);
        }
        this.prevMotionValues = (0, $fb79b5c51ae0a68c$export$9a552858d5197f6e)(this, this.scrapeMotionValuesFromProps(props, this.prevProps, this), this.prevMotionValues);
        if (this.handleChildMotionValue) this.handleChildMotionValue();
    }
    getProps() {
        return this.props;
    }
    /**
     * Returns the variant definition with a given name.
     */ getVariant(name) {
        return this.props.variants ? this.props.variants[name] : undefined;
    }
    /**
     * Returns the defined default transition on this component.
     */ getDefaultTransition() {
        return this.props.transition;
    }
    getTransformPagePoint() {
        return this.props.transformPagePoint;
    }
    getClosestVariantNode() {
        return this.isVariantNode ? this : this.parent ? this.parent.getClosestVariantNode() : undefined;
    }
    getVariantContext(startAtParent = false) {
        if (startAtParent) return this.parent ? this.parent.getVariantContext() : undefined;
        if (!this.isControllingVariants) {
            const context = this.parent ? this.parent.getVariantContext() || {} : {};
            if (this.props.initial !== undefined) context.initial = this.props.initial;
            return context;
        }
        const context = {};
        for(let i = 0; i < $22752ef207ffd3f4$var$numVariantProps; i++){
            const name = (0, $7526b0a811789693$export$1405a65085f40b9)[i];
            const prop = this.props[name];
            if ((0, $bfdcb20e850e14f7$export$720b90e312cea233)(prop) || prop === false) context[name] = prop;
        }
        return context;
    }
    /**
     * Add a child visual element to our set of children.
     */ addVariantChild(child) {
        const closestVariantNode = this.getClosestVariantNode();
        if (closestVariantNode) {
            closestVariantNode.variantChildren && closestVariantNode.variantChildren.add(child);
            return ()=>closestVariantNode.variantChildren.delete(child);
        }
    }
    /**
     * Add a motion value and bind it to this visual element.
     */ addValue(key, value) {
        // Remove existing value if it exists
        const existingValue = this.values.get(key);
        if (value !== existingValue) {
            if (existingValue) this.removeValue(key);
            this.bindToMotionValue(key, value);
            this.values.set(key, value);
            this.latestValues[key] = value.get();
        }
    }
    /**
     * Remove a motion value and unbind any active subscriptions.
     */ removeValue(key) {
        this.values.delete(key);
        const unsubscribe = this.valueSubscriptions.get(key);
        if (unsubscribe) {
            unsubscribe();
            this.valueSubscriptions.delete(key);
        }
        delete this.latestValues[key];
        this.removeValueFromRenderState(key, this.renderState);
    }
    /**
     * Check whether we have a motion value for this key
     */ hasValue(key) {
        return this.values.has(key);
    }
    getValue(key, defaultValue) {
        if (this.props.values && this.props.values[key]) return this.props.values[key];
        let value = this.values.get(key);
        if (value === undefined && defaultValue !== undefined) {
            value = (0, $ebb6b8b1a738bf1d$export$ce8bdc721e76545f)(defaultValue === null ? undefined : defaultValue, {
                owner: this
            });
            this.addValue(key, value);
        }
        return value;
    }
    /**
     * If we're trying to animate to a previously unencountered value,
     * we need to check for it in our state and as a last resort read it
     * directly from the instance (which might have performance implications).
     */ readValue(key, target) {
        var _a;
        let value = this.latestValues[key] !== undefined || !this.current ? this.latestValues[key] : (_a = this.getBaseTargetFromProps(this.props, key)) !== null && _a !== void 0 ? _a : this.readValueFromInstance(this.current, key, this.options);
        if (value !== undefined && value !== null) {
            if (typeof value === "string" && ((0, $a9d0c51dad3a3292$export$65583ed5a868f2d9)(value) || (0, $ad0677d01318a032$export$ade84c85e44a6cb1)(value))) // If this is a number read as a string, ie "0" or "200", convert it to a number
            value = parseFloat(value);
            else if (!(0, $f6428ebb310200da$export$950e7e59ea1ffed7)(value) && (0, $4c282419bf833d7f$export$83a0e34f1302825b).test(target)) value = (0, $e50050333fd23e17$export$cea0cedcb94873b5)(key, target);
            this.setBaseTarget(key, (0, $97dfd46cf2e43daf$export$605d60a2578142d3)(value) ? value.get() : value);
        }
        return (0, $97dfd46cf2e43daf$export$605d60a2578142d3)(value) ? value.get() : value;
    }
    /**
     * Set the base target to later animate back to. This is currently
     * only hydrated on creation and when we first read a value.
     */ setBaseTarget(key, value) {
        this.baseTarget[key] = value;
    }
    /**
     * Find the base target for a value thats been removed from all animation
     * props.
     */ getBaseTarget(key) {
        var _a;
        const { initial: initial } = this.props;
        let valueFromInitial;
        if (typeof initial === "string" || typeof initial === "object") {
            const variant = (0, $195eed3b69cf8a61$export$d68f140c4d9b48bc)(this.props, initial, (_a = this.presenceContext) === null || _a === void 0 ? void 0 : _a.custom);
            if (variant) valueFromInitial = variant[key];
        }
        /**
         * If this value still exists in the current initial variant, read that.
         */ if (initial && valueFromInitial !== undefined) return valueFromInitial;
        /**
         * Alternatively, if this VisualElement config has defined a getBaseTarget
         * so we can read the value from an alternative source, try that.
         */ const target = this.getBaseTargetFromProps(this.props, key);
        if (target !== undefined && !(0, $97dfd46cf2e43daf$export$605d60a2578142d3)(target)) return target;
        /**
         * If the value was initially defined on initial, but it doesn't any more,
         * return undefined. Otherwise return the value as initially read from the DOM.
         */ return this.initialValues[key] !== undefined && valueFromInitial === undefined ? undefined : this.baseTarget[key];
    }
    on(eventName, callback) {
        if (!this.events[eventName]) this.events[eventName] = new (0, $f9d7e2b4cbfd436c$export$e7dff9482a5fd23c)();
        return this.events[eventName].add(callback);
    }
    notify(eventName, ...args) {
        if (this.events[eventName]) this.events[eventName].notify(...args);
    }
}



class $2391caa4d241ec31$export$e49735c2a366bdc7 extends (0, $22752ef207ffd3f4$export$fa8b653c0f3714e5) {
    constructor(){
        super(...arguments);
        this.KeyframeResolver = (0, $7a5a5700acca8750$export$4983792d11b61017);
    }
    sortInstanceNodePosition(a, b) {
        /**
         * compareDocumentPosition returns a bitmask, by using the bitwise &
         * we're returning true if 2 in that bitmask is set to true. 2 is set
         * to true if b preceeds a.
         */ return a.compareDocumentPosition(b) & 2 ? 1 : -1;
    }
    getBaseTargetFromProps(props, key) {
        return props.style ? props.style[key] : undefined;
    }
    removeValueFromRenderState(key, { vars: vars, style: style }) {
        delete vars[key];
        delete style[key];
    }
}



function $dc98d0848c7498cf$export$3735103072e4a80(element) {
    return window.getComputedStyle(element);
}
class $dc98d0848c7498cf$export$23fea75b03ac16b3 extends (0, $2391caa4d241ec31$export$e49735c2a366bdc7) {
    constructor(){
        super(...arguments);
        this.type = "html";
        this.applyWillChange = true;
        this.renderInstance = (0, $8731e770a6b2e9fa$export$1a32bf6229c258c0);
    }
    readValueFromInstance(instance, key) {
        if ((0, $ea8236087cf451dc$export$7b42a0094fb00b6e).has(key)) {
            const defaultType = (0, $a3e8133ab555f880$export$67d1babe0338d23b)(key);
            return defaultType ? defaultType.default || 0 : 0;
        } else {
            const computedStyle = $dc98d0848c7498cf$export$3735103072e4a80(instance);
            const value = ((0, $7b632f63647c186c$export$9de1236619d9e756)(key) ? computedStyle.getPropertyValue(key) : computedStyle[key]) || 0;
            return typeof value === "string" ? value.trim() : value;
        }
    }
    measureInstanceViewportBox(instance, { transformPagePoint: transformPagePoint }) {
        return (0, $d134b85ec35c9730$export$d8718b6a7e5c624e)(instance, transformPagePoint);
    }
    build(renderState, latestValues, props) {
        (0, $6be340daa9519b5b$export$bb517f8b40f8e99d)(renderState, latestValues, props.transformTemplate);
    }
    scrapeMotionValuesFromProps(props, prevProps, visualElement) {
        return (0, $ba4595c2b86ce2ce$export$16da615486abaa45)(props, prevProps, visualElement);
    }
    handleChildMotionValue() {
        if (this.childSubscription) {
            this.childSubscription();
            delete this.childSubscription;
        }
        const { children: children } = this.props;
        if ((0, $97dfd46cf2e43daf$export$605d60a2578142d3)(children)) this.childSubscription = children.on("change", (latest)=>{
            if (this.current) this.current.textContent = `${latest}`;
        });
    }
}












class $b30b20e17f4658dd$export$86bcdffbaf733d84 extends (0, $2391caa4d241ec31$export$e49735c2a366bdc7) {
    constructor(){
        super(...arguments);
        this.type = "svg";
        this.isSVGTag = false;
        this.measureInstanceViewportBox = (0, $a33f96272a0f3ced$export$6459fc9e86be362e);
    }
    getBaseTargetFromProps(props, key) {
        return props[key];
    }
    readValueFromInstance(instance, key) {
        if ((0, $ea8236087cf451dc$export$7b42a0094fb00b6e).has(key)) {
            const defaultType = (0, $a3e8133ab555f880$export$67d1babe0338d23b)(key);
            return defaultType ? defaultType.default || 0 : 0;
        }
        key = !(0, $aa386d96766cdbf4$export$28931db5d57958e5).has(key) ? (0, $76d837a31980cd1f$export$9fd24a634729c672)(key) : key;
        return instance.getAttribute(key);
    }
    scrapeMotionValuesFromProps(props, prevProps, visualElement) {
        return (0, $feed3de2ce0df473$export$16da615486abaa45)(props, prevProps, visualElement);
    }
    build(renderState, latestValues, props) {
        (0, $673009f839505ee8$export$5475d24f125d7053)(renderState, latestValues, this.isSVGTag, props.transformTemplate);
    }
    renderInstance(instance, renderState, styleProp, projection) {
        (0, $41e5124bd72f0d4a$export$c5f8399d19a7394b)(instance, renderState, styleProp, projection);
    }
    mount(instance) {
        this.isSVGTag = (0, $cd906bb243395b56$export$6328ce7565ea1049)(instance.tagName);
        super.mount(instance);
    }
}



const $d87daa37df3bb6bf$export$56ba0183203348f5 = (Component, options)=>{
    return (0, $fa075626af2c10ee$export$88f3fc2fd3766989)(Component) ? new (0, $b30b20e17f4658dd$export$86bcdffbaf733d84)(options) : new (0, $dc98d0848c7498cf$export$23fea75b03ac16b3)(options, {
        allowProjection: Component !== (0, $eeH7J.Fragment)
    });
};


const $b2ade50ab272b8e8$export$46b7e4b9dc6110c3 = /*@__PURE__*/ (0, $f107d1fb53628652$export$d86feac869a7f0d5)({
    ...(0, $2d0cdac558a97e2e$export$7f9953c70dacfd7f),
    ...(0, $977cf784158004df$export$e5b72898e5a201f1),
    ...(0, $4f797dc01d53a48c$export$d7d5d435647ed5a0),
    ...(0, $b5d3ffa854a4de95$export$b3219800bda33a1f)
}, (0, $d87daa37df3bb6bf$export$56ba0183203348f5));


const $ad7a054f4530c130$export$e25e478948902b8b = /*@__PURE__*/ (0, $56c547a84798143f$export$3af29c0efb268f04)((0, $b2ade50ab272b8e8$export$46b7e4b9dc6110c3));



var $lhaLc = parcelRequire("lhaLc");
parcelRequire("2LTO8");
var $14q7s = parcelRequire("14q7s");
var $gGZ2r = parcelRequire("gGZ2r");
var $fR074 = parcelRequire("fR074");

var $eSiQ2 = parcelRequire("eSiQ2");

var $7m9cQ = parcelRequire("7m9cQ");

var $lhaLc = parcelRequire("lhaLc");


var $lhaLc = parcelRequire("lhaLc");

var $4vwom = parcelRequire("4vwom");

var $eeH7J = parcelRequire("eeH7J");

var $lhaLc = parcelRequire("lhaLc");
/**
 * Defines the set of keywords used to specify the direction or condition for limiting a
 * media query based on the viewport size.
 */ const $dc53c17a4a911fba$var$limitTypes = [
    "min",
    "max",
    "only"
];
function $dc53c17a4a911fba$export$25d302a5b900a763(config) {
    const { screenSizes: screenSizes, spacingSizes: spacingSizes, headingLevels: headingLevels, borderRadiuses: borderRadiuses } = config;
    /**
     * Helper function that returns a media query for a given screen size and limit type.
     *
     * @param limitType The type of limit to apply
     * @param screenSize The screen size to apply the styles to
     * @returns A media query string
     */ function mediaQuery(limitType, screenSize) {
        switch(limitType){
            case "min":
                return `@media (min-width: ${screenSizes[screenSize]}px)`;
            case "max":
                {
                    const sizesKeysArr = Object.keys(screenSizes);
                    const sizeIndex = sizesKeysArr.indexOf(screenSize);
                    if (sizeIndex + 1 === sizesKeysArr.length) return "@media";
                    const nextSize = sizesKeysArr[sizeIndex + 1];
                    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
                    if (!nextSize) return "@media";
                    return `@media (max-width: ${screenSizes[nextSize] - 1}px)`;
                }
            case "only":
                {
                    const sizesKeysArr = Object.keys(screenSizes);
                    const sizeIndex = sizesKeysArr.indexOf(screenSize);
                    if (sizeIndex + 1 === sizesKeysArr.length) return "@media";
                    const nextSize = sizesKeysArr[sizeIndex + 1];
                    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
                    if (!nextSize) return `@media (min-width: ${screenSizes[screenSize]}px)`;
                    return `@media (min-width: ${screenSizes[screenSize]}px and max-width: ${screenSizes[nextSize] - 1}px)`;
                }
            default:
                return "";
        }
    }
    /**
     * A hook that returns a boolean indicating whether the screen matches or not.
     *
     * @param limitType The type of limit to apply
     * @param screenSize The screen size to apply the styles to
     * @returns A media query string
     */ function useMediaQuery(limitType, screenSize) {
        const [matches, setMatches] = (0, $eeH7J.useState)(false);
        const query = mediaQuery(limitType, screenSize).replace("@media", "");
        (0, $eeH7J.useEffect)(()=>{
            const media = window.matchMedia(query);
            if (media.matches !== matches) setMatches(media.matches);
            const listener = ()=>{
                setMatches(media.matches);
            };
            media.addEventListener("change", listener);
            return ()=>{
                media.removeEventListener("change", listener);
            };
        }, [
            matches,
            query
        ]);
        return matches;
    }
    /**
     * Helper function that returns a media query and styles for a given screen size.
     *
     * @param limitType The type of limit to apply
     * @param screenSize The screen size to apply the styles to
     * @param styles The styles to apply to the given screen size limit
     * @returns `SerializedStyles` to be used in an Emotion `css` prop
     */ function responsiveCss(limitType, screenSize, s) {
        return (0, $lhaLc.css)({
            [mediaQuery(limitType, screenSize)]: s
        });
    }
    function isVariantInVariants(variant, variants) {
        return Object.keys(variants).includes(variant);
    }
    function isVariantMediaQuery(variant) {
        return variant instanceof Array && variant.length === 3 && typeof variant[0] === "string" && $dc53c17a4a911fba$var$limitTypes.includes(variant[0]) && typeof variant[1] === "string" && (typeof variant[2] === "string" || typeof variant[2] === "number");
    }
    /**
     * Returns responsive CSS for a responsive variant that does not have a responsive dimension.
     */ function variantCss(variants, variant) {
        if (isVariantInVariants(variant, variants) || typeof variant === "string" || typeof variant === "number") return (0, $lhaLc.css)(variants[variant]);
        else if (isVariantMediaQuery(variant)) {
            const variantMediaQuery = variant;
            const [limitType, screenSize, v] = variantMediaQuery;
            const style = variants[v];
            // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
            if (style) return (0, $lhaLc.css)(responsiveCss(limitType, screenSize, style));
        } else if (variant instanceof Array) return (0, $lhaLc.css)(variant.map((v)=>variantCss(variants, v)));
        return;
    }
    // Helper function to get the screen sizes based on min/max and the provided size
    function getScreenSizes(limitType, screenSize) {
        const order = Object.keys(screenSizes);
        const index = order.indexOf(screenSize);
        if (limitType === "min") return order.slice(index);
        else return order.slice(0, index + 1);
    }
    function getStyleForScreenSize(screenSize, screenSizeStyles) {
        return getScreenSizes("max", screenSize).reduce((acc, curr)=>{
            var _a;
            return Object.assign(acc, (_a = screenSizeStyles[curr]) !== null && _a !== void 0 ? _a : {});
        }, {});
    }
    function getCssForScreenSize(screenSize, screenSizeStyles) {
        const sss = getScreenSizes("max", screenSize);
        return (0, $lhaLc.css)(sss.map((ss)=>screenSizeStyles[ss]));
    }
    /**
     * Type guard for checking if a string is a screen size.
     */ function isScreenSize(screenSize) {
        return Object.keys(screenSizes).includes(screenSize);
    }
    /**
     * Returns responsive CSS for a set of ResponsiveStyles.
     */ function responsiveVariantToCss(variant) {
        const ss = [];
        for(const screenSize in variant)if (variant[screenSize]) ss.push(responsiveCss("min", screenSize, variant[screenSize]));
        return (0, $lhaLc.css)(ss);
    }
    function isMediaQuery(v) {
        if (v instanceof Array === false) return false;
        const [limitType, screenSize, variant] = v;
        if (!$dc53c17a4a911fba$var$limitTypes.includes(limitType)) return false;
        if (!isScreenSize(screenSize)) return false;
        if (typeof variant !== "string" && typeof variant !== "number") return false;
        return true;
    }
    function fixedVariantCss(variants, variant) {
        const baseScreenSize = Object.keys(screenSizes)[0];
        const [, screenSize, variantKey] = variant;
        if (!baseScreenSize || // Allow variantKey of type number as well, to support heading levels being numbers.
        typeof variantKey !== "string" && typeof variantKey !== "number" || typeof screenSize !== "string" || !variants[variantKey]) return;
        return getCssForScreenSize(screenSize, variants[variantKey]);
    }
    /**
     * Returns responsive CSS for a responsive variant that has a responsive dimension.
     */ function responsiveVariantsCss(variants, variant) {
        function isVariant(v) {
            return typeof v === "string" || typeof v === "number";
        }
        if (isVariant(variant) && !!variants[variant]) return responsiveVariantToCss(variants[variant]);
        else if (variant instanceof Array) {
            const [baseVariant, ...rest] = variant.filter(isVariant);
            // Specifying more than one variant without media query does not make sense.
            if (rest.length) // eslint-disable-next-line no-console
            console.warn("Should not use more than one string.", variant);
            const overrides = variant.filter((v)=>isMediaQuery(v));
            // Check if used a combination of min and max which is not advisable.
            if (overrides.find((o)=>o[0] === "min") && overrides.find((o)=>o[0] === "max")) // eslint-disable-next-line no-console
            console.warn("Combining min and max is not recommended. Try a base + min overrides instead for example.");
            if (!(isVariant(baseVariant) && variants[baseVariant])) return;
            const baseSizeStyles = Object.assign({}, variants[baseVariant]);
            overrides.forEach((o)=>{
                if (typeof o === "string" || typeof o === "number") return;
                const [limitType, screenSize, v] = o;
                const screenSizesToOverride = getScreenSizes(limitType, screenSize);
                screenSizesToOverride.forEach((ss)=>{
                    const responsiveStyles = variants[v];
                    if (!responsiveStyles) return;
                    baseSizeStyles[ss] = getStyleForScreenSize(ss, responsiveStyles);
                });
            });
            const ss = [];
            for(const screenSize in baseSizeStyles)if (baseSizeStyles[screenSize]) ss.push(responsiveCss("min", screenSize, baseSizeStyles[screenSize]));
            return (0, $lhaLc.css)(ss);
        }
        return;
    }
    function responsivePropCss(values, prop, responsiveValues) {
        if (typeof responsiveValues === "string") return (0, $lhaLc.css)({
            [prop]: values[responsiveValues]
        });
        return (0, $lhaLc.css)(responsiveValues.map((rv)=>{
            if (typeof rv === "string") return {
                [prop]: values[rv]
            };
            else if (rv) {
                const [limitType, screenSize, value] = rv;
                return responsiveCss(limitType, screenSize, {
                    [prop]: values[value]
                });
            }
        }));
    }
    function responsiveValueCss(prop, responsiveValues) {
        if (typeof responsiveValues === "string" || typeof responsiveValues === "number") return (0, $lhaLc.css)({
            [prop]: responsiveValues
        });
        return (0, $lhaLc.css)(responsiveValues.map((rv)=>{
            if (typeof rv === "string" || typeof rv === "number") return {
                [prop]: rv
            };
            else if (rv) {
                const [limitType, screenSize, value] = rv;
                return responsiveCss(limitType, screenSize, {
                    [prop]: value
                });
            }
        }));
    }
    function responsiveSpacing(variant, type) {
        if (typeof spacingSizes[variant] === "object") return (0, $lhaLc.css)(Object.entries(spacingSizes[variant]).map(([screenSize, val])=>responsiveCss("min", screenSize, type instanceof Array ? Object.fromEntries(type.map((t)=>[
                    t,
                    val
                ])) : {
                [type]: typeof val === "number" ? `${val}px` : val
            })));
    }
    /**
     * Helper function that returns a media query with responsive CSS for a given heading level, based
     * on sizes defined in the `headingLevels` theme config.
     *
     * @param level The border radius variant
     * @returns `SerializedStyles` to be used in an Emotion `css` prop
     */ function responsiveHeadingLevel(level) {
        if (typeof headingLevels[level] === "object") return (0, $lhaLc.css)(Object.entries(headingLevels[level]).map(([screenSize, headingStyle])=>responsiveCss("min", screenSize, headingStyle)));
    }
    /**
     * Determines whether a variant is fixed, i.e. ["fixed", "sm", "md"] – always rendered as
     * medium variant on small screen.
     */ function isFixedVariant(variant) {
        return Array.isArray(variant) && variant.length === 3 && variant[0] === "fixed";
    }
    function responsiveHeadingCss(headingLevel) {
        if (isFixedVariant(headingLevel)) return fixedVariantCss(headingLevels, headingLevel);
        return responsiveVariantsCss(headingLevels, headingLevel);
    }
    function responsiveHidden(mq) {
        return responsiveCss(...mq, {
            display: "none"
        });
    }
    function axisOrSideToProps(axisOrSide, type) {
        const axis = {
            x: [
                `${type}Left`,
                `${type}Right`
            ],
            y: [
                `${type}Top`,
                `${type}Bottom`
            ],
            top: `${type}Top`,
            bottom: `${type}Bottom`,
            left: `${type}Left`,
            right: `${type}Right`
        };
        return axis[axisOrSide];
    }
    function isSpacingSize(val) {
        if (typeof val === "number") return false;
        return Object.keys(spacingSizes).includes(val);
    }
    /**
     * Helper function to convert a Spacing prop to CSS.
     *
     * @param type The type of spacing to return rules for, either margin or padding.
     * @param spacing A valid spacing object or single value. Supports both pixels and SpacingSize.
     *
     * @returns An Emotion SerializedStyles object
     */ function spacingToCss(type, spacing) {
        var _a, _b, _c, _d, _e, _f;
        function spacingVal(axisOrSide, val) {
            if (isSpacingSize(val)) return responsiveSpacing(val, axisOrSideToProps(axisOrSide, type));
        }
        return (0, $lhaLc.css)([
            typeof spacing === "number" || typeof spacing === "string" ? isSpacingSize(spacing) ? responsiveSpacing(spacing, type) : {
                [type]: spacing
            } : [
                spacing.x && ((_a = spacingVal("x", spacing.x)) !== null && _a !== void 0 ? _a : {
                    [`${type}Left`]: spacing.x,
                    [`${type}Right`]: spacing.x
                }),
                spacing.y && ((_b = spacingVal("y", spacing.y)) !== null && _b !== void 0 ? _b : {
                    [`${type}Top`]: spacing.y,
                    [`${type}Bottom`]: spacing.y
                }),
                spacing.top && ((_c = spacingVal("top", spacing.top)) !== null && _c !== void 0 ? _c : {
                    [`${type}Top`]: spacing.top
                }),
                spacing.right && ((_d = spacingVal("right", spacing.right)) !== null && _d !== void 0 ? _d : {
                    [`${type}Right`]: spacing.right
                }),
                spacing.bottom && ((_e = spacingVal("bottom", spacing.bottom)) !== null && _e !== void 0 ? _e : {
                    [`${type}Bottom`]: spacing.bottom
                }),
                spacing.left && ((_f = spacingVal("left", spacing.left)) !== null && _f !== void 0 ? _f : {
                    [`${type}Left`]: spacing.left
                })
            ]
        ]);
    }
    function responsiveBodyCss(size) {
        if (isFixedVariant(size)) return fixedVariantCss(config.bodySizes, size);
        return responsiveVariantsCss(config.bodySizes, size);
    }
    /**
     * Helper function that returns a media query with responsive styles for a given border radius
     * variant for different screen sizes as specified in the border radius variants constant.
     *
     * @param variant The border radius variant
     * @returns `SerializedStyles` to be used in an Emotion `css` prop
     */ function responsiveBorderRadius(variant) {
        const borderRadiusVariant = borderRadiuses[variant];
        // Not always truthy, there might be 0 border radiuses.
        // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
        if (borderRadiusVariant && typeof borderRadiusVariant === "object") return (0, $lhaLc.css)(Object.entries(borderRadiuses[variant]).map(([screenSize, borderRadius])=>responsiveCss("min", screenSize, {
                borderRadius: borderRadius
            })));
    }
    function textCss(variant, size) {
        const textVariant = config.textVariants[variant];
        return isFixedVariant(size) ? fixedVariantCss(textVariant, size) : responsiveVariantsCss(textVariant, size);
    }
    const helpers = {
        fixedVariantCss: fixedVariantCss,
        mediaQuery: mediaQuery,
        responsiveCss: responsiveCss,
        responsiveVariantsCss: responsiveVariantsCss,
        responsiveVariantToCss: responsiveVariantToCss,
        responsiveHidden: responsiveHidden,
        responsivePropCss: responsivePropCss,
        responsiveValueCss: responsiveValueCss,
        responsiveSpacing: responsiveSpacing,
        responsiveBorderRadius: responsiveBorderRadius,
        responsiveHeadingLevel: responsiveHeadingLevel,
        responsiveHeadingCss: responsiveHeadingCss,
        responsiveBodyCss: responsiveBodyCss,
        spacingToCss: spacingToCss,
        useMediaQuery: useMediaQuery,
        variantCss: variantCss,
        textCss: textCss
    };
    return Object.assign(Object.assign({}, config), {
        responsiveCss: responsiveCss,
        helpers: helpers
    });
}
/**
 * `ThemeContext` is a context object used to provide and consume the current theme
 * throughout the application. It holds the theme value, which can be accessed by any
 * component wrapped inside the `ThemeProvider`.
 */ const $dc53c17a4a911fba$var$ThemeContext = /*#__PURE__*/ (0, $eeH7J.createContext)(null);
const $dc53c17a4a911fba$export$d8964aec282183a3 = (props)=>{
    return (0, $4vwom.jsx)($dc53c17a4a911fba$var$ThemeContext.Provider, {
        value: props.theme,
        children: props.children
    });
};
function $dc53c17a4a911fba$export$93d4e7f90805808f() {
    const theme = (0, $eeH7J.useContext)($dc53c17a4a911fba$var$ThemeContext);
    if (!theme) throw new Error("useTheme must be used within a ThemeProvider");
    return theme;
}



var $4vwom = parcelRequire("4vwom");

var $5qU69 = parcelRequire("5qU69");

var $lhaLc = parcelRequire("lhaLc");


var $lhaLc = parcelRequire("lhaLc");
/**
 * A base reset that should be applied to all elements that is reset.
 */ const $e82ba787de72625c$var$baseReset = (0, $lhaLc.css)({
    margin: 0,
    padding: 0,
    border: 0,
    fontSize: "100%",
    font: "inherit",
    verticalAlign: "baseline"
});
function $e82ba787de72625c$export$6b6f359a824920a4(element) {
    switch(element){
        case "button":
            return (0, $lhaLc.css)($e82ba787de72625c$var$baseReset, (0, $lhaLc.css)({
                background: "none",
                border: "none",
                padding: 0,
                font: "inherit",
                cursor: "pointer",
                outline: "inherit"
            }));
        case "input":
            return (0, $lhaLc.css)($e82ba787de72625c$var$baseReset, {
                border: "none",
                background: "none",
                font: "inherit",
                outline: "none",
                webkitAppearance: "none",
                MozAppearance: "none",
                appearance: "none"
            });
        case "ol":
        case "ul":
            return (0, $lhaLc.css)($e82ba787de72625c$var$baseReset, (0, $lhaLc.css)({
                listStyle: "none"
            }));
        default:
            return $e82ba787de72625c$var$baseReset;
    }
}
const $e82ba787de72625c$export$425327af25286e5e = (0, $lhaLc.css)({
    textDecoration: "underline",
    textDecorationSkipInk: "none",
    textUnderlineOffset: "20%"
});
function $e82ba787de72625c$export$2c2533fee2945415(styles) {
    const mq = `@media
        only screen and (-webkit-min-device-pixel-ratio: 2),
        only screen and (min--moz-device-pixel-ratio: 2),
        only screen and (-o-min-device-pixel-ratio: 2/1),
        only screen and (min-device-pixel-ratio: 2),
        only screen and (min-resolution: 192dpi),
        only screen and (min-resolution: 2dppx)
    `;
    return (0, $lhaLc.css)({
        [mq]: styles
    });
}
function $e82ba787de72625c$export$c874afaabcd4d5bc(styles) {
    return (0, $lhaLc.css)({
        "@media (hover: none)": styles
    });
}
function $e82ba787de72625c$export$601469075a80284e(styles) {
    return (0, $lhaLc.css)({
        "@media (hover: hover)": styles
    });
}
const $e82ba787de72625c$var$cssVars = [
    "accent-color",
    "accent-color-light",
    "body-padding"
];
function $e82ba787de72625c$export$f1757f6a9a61f8c6(name) {
    return `--${name}`;
}
function $e82ba787de72625c$export$ac1d356ad2ecf90f(name) {
    return `var(--${name})`;
}



const $1c2a8fb378443a1d$export$f988485815015380 = 1;
const $1c2a8fb378443a1d$export$330a64de1bbc7059 = 0.8;
const $1c2a8fb378443a1d$export$488117a5011aa9e = 0.8;
const $1c2a8fb378443a1d$export$adc5746a202ff4b = 0.9;
const $1c2a8fb378443a1d$export$a9ddfd01863914a9 = {
    xs: {
        width: "100%",
        maxWidth: 1296,
        paddingLeft: 16,
        paddingRight: 16,
        scrollPaddingLeft: 16,
        scrollPaddingRight: 16
    },
    md: {
        paddingLeft: 24,
        paddingRight: 24,
        scrollPaddingLeft: 24,
        scrollPaddingRight: 24
    }
};
const $1c2a8fb378443a1d$export$3a40bd8b0ff0173c = {
    xs: Object.assign(Object.assign({}, $1c2a8fb378443a1d$export$a9ddfd01863914a9.xs), {
        paddingBottom: 16
    }),
    md: Object.assign(Object.assign({}, $1c2a8fb378443a1d$export$a9ddfd01863914a9.md), {
        paddingBottom: 24
    })
};
const $1c2a8fb378443a1d$export$d98ecea1201f13ea = {
    xs: 8,
    sm: 16,
    md: 24,
    lg: 32,
    xl: 40
};
const $1c2a8fb378443a1d$export$dd07c5170cc9e3b1 = {
    xs: (0, $756948b644e82cf2$export$981516ee4691055c)(36),
    md: (0, $756948b644e82cf2$export$981516ee4691055c)(48)
};



var $4vwom = parcelRequire("4vwom");

var $4vwom = parcelRequire("4vwom");

var $lhaLc = parcelRequire("lhaLc");

function $320473f3a1ec63d7$export$274edc73af1ae9c8() {
    return function Icon(props) {
        const theme = (0, $dc53c17a4a911fba$export$93d4e7f90805808f)();
        const fillColor = props.color ? theme.colors[props.color] : "currentColor";
        return (0, $4vwom.jsx)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            fill: "none",
            viewBox: "0 0 24 24",
            className: props.className,
            css: (0, $lhaLc.css)(props.hidden instanceof Array && theme.helpers.responsiveHidden(props.hidden), !!props.margin && theme.helpers.spacingToCss("margin", props.margin), props.onClick && {
                cursor: "pointer"
            }, props.size ? [
                theme.helpers.responsiveValueCss("height", props.size),
                theme.helpers.responsiveValueCss("width", props.size)
            ] : {
                height: 24,
                width: 24
            }),
            style: Object.assign({
                color: fillColor,
                flexShrink: 0,
                display: props.hidden === true ? "none" : undefined
            }, props.style || {}),
            onClick: props.onClick ? props.onClick : undefined,
            children: theme.icons[props.icon]
        });
    };
}


var $f8cdd04128a131cf$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $f8cdd04128a131cf$var$ThemedIcon = (0, $320473f3a1ec63d7$export$274edc73af1ae9c8)();
function $f8cdd04128a131cf$export$f04a61298a47a40f(_a) {
    var { color: color } = _a, rest = $f8cdd04128a131cf$var$__rest(_a, [
        "color"
    ]);
    return (0, $4vwom.jsx)($f8cdd04128a131cf$var$ThemedIcon, Object.assign({
        color: rest.icon === "trustpilot" ? "_trustpilot" : color
    }, rest));
}


const $756948b644e82cf2$var$screenSizes = {
    xs: 0,
    sm: 480,
    md: 840,
    lg: 1200,
    xl: 1600
};
/**
 * The colors in Redoit design system
 *
 * Do not shorten to less than 6 chars, to ensure setting opacity using 2 char hex.
 */ const $756948b644e82cf2$var$colors = {
    // Primary
    brand: "#9b64e1",
    brandLight: "#f4e3ff",
    brandDark: "#7248a8",
    // Grays
    grayWhite: "#ffffff",
    gray100: "#f6f6f6",
    gray200: "#e9e6ea",
    gray300: "#868589",
    // For gray text on gray100 background, use this to satisfy WCAG AA requirements.
    gray350: "#717075",
    gray400: "#4d4852",
    gray500: "#150624",
    // Secondary
    forest: "#155c58",
    forestLight: "#c7d8d7",
    sky: "#347cff",
    skyLight: "#e5e3ff",
    sand: "#b49469",
    sandLight: "#f7f2ef",
    highlight: "#c5ffaa",
    error: "#ff4c34",
    warning: "#ff4c34",
    warningLight: "#ffedeb",
    vippsOrange: "#ff5b24",
    // Colors used in specific components that are not defined in the design system
    _productsSeeAllBg: "#efeae7",
    _trustpilot: "#63d793"
};
const $756948b644e82cf2$var$icons = {
    asterisk: (0, $4vwom.jsx)("path", {
        fill: "currentColor",
        d: "M20.143 16.886a.748.748 0 0 1-1.031.257l-6.362-3.818v6.925a.75.75 0 1 1-1.5 0v-6.925l-6.364 3.818a.749.749 0 1 1-.771-1.286L10.542 12 4.115 8.143a.75.75 0 1 1 .771-1.286l6.364 3.818V3.75a.75.75 0 1 1 1.5 0v6.925l6.364-3.818a.75.75 0 1 1 .771 1.286L13.458 12l6.427 3.857a.749.749 0 0 1 .258 1.03Z"
    }),
    at: (0, $4vwom.jsx)("path", {
        fill: "currentColor",
        d: "M12 2.25a9.75 9.75 0 0 0 0 19.5c2.017 0 4.134-.608 5.665-1.625a.748.748 0 0 0 .003-1.247.751.751 0 0 0-.833-.002c-1.273.847-3.128 1.374-4.835 1.374A8.25 8.25 0 1 1 20.25 12c0 2.48-1.02 3-1.875 3s-1.875-.52-1.875-3V8.25a.75.75 0 0 0-1.5 0v.4a4.5 4.5 0 1 0 .556 6.102c.562 1.125 1.533 1.748 2.819 1.748 2.113 0 3.375-1.682 3.375-4.5A9.76 9.76 0 0 0 12 2.25ZM12 15a3 3 0 1 1 0-6 3 3 0 0 1 0 6Z"
    }),
    arrowUp: (0, $4vwom.jsx)("path", {
        fill: "currentColor",
        d: "M10.295 20.485V7.345l-6.07 6.07-1.42-1.42 8.49-8.48 8.49 8.48-1.42 1.42-6.07-6.07v13.14h-2Z"
    }),
    arrowRight: (0, $4vwom.jsx)("path", {
        fill: "currentColor",
        d: "M2.811 13h13.14l-6.07 6.07 1.42 1.42 8.48-8.49-8.48-8.49-1.42 1.42 6.07 6.07H2.811v2Z"
    }),
    arrowDown: (0, $4vwom.jsx)("path", {
        fill: "currentColor",
        d: "M10.295 3.515v13.14l-6.07-6.07-1.42 1.42 8.49 8.48 8.49-8.48-1.42-1.42-6.07 6.07V3.515h-2Z"
    }),
    arrowLeft: (0, $4vwom.jsx)("path", {
        fill: "currentColor",
        d: "M19.78 13H6.64l6.07 6.07-1.42 1.42L2.81 12l8.48-8.49 1.42 1.42L6.64 11h13.14v2Z"
    }),
    calendar: (0, $4vwom.jsx)("path", {
        fill: "currentColor",
        d: "M19.5 3h-2.25v-.75a.75.75 0 1 0-1.5 0V3h-7.5v-.75a.75.75 0 0 0-1.5 0V3H4.5A1.5 1.5 0 0 0 3 4.5v15A1.5 1.5 0 0 0 4.5 21h15a1.5 1.5 0 0 0 1.5-1.5v-15A1.5 1.5 0 0 0 19.5 3ZM6.75 4.5v.75a.75.75 0 0 0 1.5 0V4.5h7.5v.75a.75.75 0 1 0 1.5 0V4.5h2.25v3h-15v-3h2.25Zm12.75 15h-15V9h15v10.5Z"
    }),
    calendarFilled: (0, $4vwom.jsx)("path", {
        fill: "currentColor",
        d: "M19.5 3h-2.25v-.75a.75.75 0 1 0-1.5 0V3h-7.5v-.75a.75.75 0 0 0-1.5 0V3H4.5A1.5 1.5 0 0 0 3 4.5v15A1.5 1.5 0 0 0 4.5 21h15a1.5 1.5 0 0 0 1.5-1.5v-15A1.5 1.5 0 0 0 19.5 3Zm0 4.5h-15v-3h2.25v.75a.75.75 0 0 0 1.5 0V4.5h7.5v.75a.75.75 0 1 0 1.5 0V4.5h2.25v3Z"
    }),
    check: (0, $4vwom.jsx)("path", {
        fill: "currentColor",
        d: "M9.457 14.293 6.164 11 4.75 12.414l4.707 4.707 9.707-9.707L17.75 6l-8.293 8.293Z"
    }),
    checkBadge: (0, $4vwom.jsx)("path", {
        fill: "currentColor",
        d: "M21.174 9.64c-.353-.37-.719-.75-.857-1.085-.127-.307-.134-.815-.142-1.307-.014-.915-.03-1.952-.75-2.673-.72-.72-1.758-.736-2.673-.75-.492-.008-1-.015-1.307-.143-.333-.137-.715-.503-1.084-.856C13.714 2.204 12.979 1.5 12 1.5c-.979 0-1.713.704-2.36 1.326-.37.353-.75.719-1.085.857-.305.127-.815.135-1.307.142-.915.014-1.952.03-2.673.75-.72.72-.731 1.758-.75 2.673-.008.492-.015 1-.143 1.307-.137.333-.503.715-.856 1.084C2.204 10.286 1.5 11.021 1.5 12c0 .979.704 1.713 1.326 2.36.353.37.719.75.857 1.085.127.307.135.815.142 1.307.014.915.03 1.952.75 2.673.72.72 1.758.736 2.673.75.492.008 1 .015 1.307.142.333.138.715.504 1.084.857.647.622 1.382 1.326 2.361 1.326.979 0 1.713-.704 2.36-1.326.37-.353.75-.719 1.085-.857.307-.127.815-.134 1.307-.142.915-.014 1.952-.03 2.673-.75.72-.72.736-1.758.75-2.673.008-.492.015-1 .142-1.307.138-.333.504-.715.857-1.084.622-.647 1.326-1.382 1.326-2.361 0-.979-.704-1.713-1.326-2.36Zm-1.082 3.683c-.45.469-.915.953-1.161 1.549-.236.571-.247 1.225-.256 1.858-.01.656-.02 1.343-.311 1.634-.292.29-.974.302-1.634.311-.633.01-1.287.02-1.858.256-.596.246-1.08.711-1.55 1.16-.468.45-.947.909-1.322.909-.375 0-.858-.461-1.323-.908-.465-.448-.953-.915-1.549-1.161-.571-.236-1.225-.247-1.858-.256-.656-.01-1.343-.02-1.634-.311-.29-.292-.302-.974-.311-1.634-.01-.633-.02-1.287-.256-1.858-.247-.596-.712-1.08-1.16-1.55C3.458 12.855 3 12.376 3 12c0-.375.461-.858.908-1.323.448-.465.914-.953 1.161-1.549.236-.571.247-1.225.256-1.858.01-.656.02-1.343.311-1.634.292-.29.974-.302 1.634-.311.633-.01 1.287-.02 1.858-.256.596-.247 1.08-.712 1.55-1.16C11.145 3.458 11.624 3 12 3c.375 0 .858.461 1.323.908.465.448.953.914 1.549 1.161.571.236 1.225.247 1.858.256.656.01 1.343.02 1.634.311.29.292.302.974.311 1.634.01.633.02 1.287.256 1.858.246.596.711 1.08 1.16 1.55.45.468.909.947.909 1.322 0 .375-.461.858-.908 1.323ZM16.28 9.219a.748.748 0 0 1 0 1.062l-5.25 5.25a.747.747 0 0 1-1.062 0l-2.25-2.25a.75.75 0 1 1 1.062-1.062l1.719 1.72 4.72-4.72a.749.749 0 0 1 1.06 0Z"
    }),
    checkBadgeFilled: (0, $4vwom.jsx)("path", {
        fill: "currentColor",
        d: "M21.174 9.64c-.353-.37-.719-.75-.857-1.085-.127-.307-.134-.815-.142-1.307-.014-.915-.03-1.952-.75-2.673-.72-.72-1.758-.736-2.673-.75-.492-.008-1-.015-1.307-.143-.333-.137-.715-.503-1.084-.856C13.714 2.204 12.979 1.5 12 1.5c-.979 0-1.713.704-2.36 1.326-.37.353-.75.719-1.085.857-.305.127-.815.135-1.307.142-.915.014-1.952.03-2.673.75-.72.72-.731 1.758-.75 2.673-.008.492-.015 1-.143 1.307-.137.333-.503.715-.856 1.084C2.204 10.286 1.5 11.021 1.5 12c0 .979.704 1.713 1.326 2.36.353.37.719.75.857 1.085.127.307.135.815.142 1.307.014.915.03 1.952.75 2.673.72.72 1.758.736 2.673.75.492.008 1 .015 1.307.142.333.138.715.504 1.084.857.647.622 1.382 1.326 2.361 1.326.979 0 1.713-.704 2.36-1.326.37-.353.75-.719 1.085-.857.307-.127.815-.134 1.307-.142.915-.014 1.952-.03 2.673-.75.72-.72.736-1.758.75-2.673.008-.492.015-1 .142-1.307.138-.333.504-.715.857-1.084.622-.647 1.326-1.382 1.326-2.361 0-.979-.704-1.713-1.326-2.36Zm-4.893.64-5.25 5.25a.747.747 0 0 1-1.062 0l-2.25-2.25a.75.75 0 1 1 1.062-1.06l1.719 1.72 4.72-4.72a.751.751 0 0 1 1.06 1.06Z"
    }),
    checkSquareOffset: (0, $4vwom.jsx)("path", {
        fill: "currentColor",
        d: "M21 4.5v15a1.5 1.5 0 0 1-1.5 1.5h-6.75a.75.75 0 0 1 0-1.5h6.75v-15h-15v9a.75.75 0 1 1-1.5 0v-9A1.5 1.5 0 0 1 4.5 3h15A1.5 1.5 0 0 1 21 4.5Zm-9.22 9.97a.749.749 0 0 0-1.06 0L6 19.19l-1.72-1.72a.75.75 0 1 0-1.06 1.06l2.25 2.25a.748.748 0 0 0 1.06 0l5.25-5.25a.748.748 0 0 0 0-1.06Z"
    }),
    chevronUp: (0, $4vwom.jsx)("path", {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3 15.586 4.414 17l7.293-7.293L19 17l1.414-1.414-8.707-8.707L3 15.586Z",
        clipRule: "evenodd"
    }),
    chevronRight: (0, $4vwom.jsx)("path", {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M9.414 3.3 8 4.714l7.293 7.293L8 19.3l1.414 1.414 8.707-8.707L9.414 3.3Z",
        clipRule: "evenodd"
    }),
    chevronDown: (0, $4vwom.jsx)("path", {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3.3 9.014 4.714 7.6l7.293 7.293L19.3 7.6l1.414 1.414-8.707 8.707L3.3 9.014Z",
        clipRule: "evenodd"
    }),
    chevronLeft: (0, $4vwom.jsx)("path", {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M14.586 3.3 16 4.714l-7.293 7.293L16 19.3l-1.414 1.414-8.707-8.707L14.586 3.3Z",
        clipRule: "evenodd"
    }),
    close: (0, $4vwom.jsx)("path", {
        fill: "currentColor",
        d: "M19.28 18.22a.752.752 0 0 1-.53 1.28.75.75 0 0 1-.53-.22L12 13.06l-6.22 6.22a.75.75 0 1 1-1.06-1.06L10.94 12 4.72 5.78a.75.75 0 0 1 1.06-1.06L12 10.94l6.22-6.22a.75.75 0 1 1 1.06 1.06L13.06 12l6.22 6.22Z"
    }),
    creditCard: (0, $4vwom.jsx)("path", {
        fill: "currentColor",
        d: "M21 4.5H3A1.5 1.5 0 0 0 1.5 6v12A1.5 1.5 0 0 0 3 19.5h18a1.5 1.5 0 0 0 1.5-1.5V6A1.5 1.5 0 0 0 21 4.5ZM21 6v2.25H3V6h18Zm0 12H3V9.75h18V18Zm-1.5-2.25a.75.75 0 0 1-.75.75h-3a.75.75 0 1 1 0-1.5h3a.75.75 0 0 1 .75.75Zm-6 0a.75.75 0 0 1-.75.75h-1.5a.75.75 0 1 1 0-1.5h1.5a.75.75 0 0 1 .75.75Z"
    }),
    data: (0, $4vwom.jsx)("path", {
        fill: "currentColor",
        d: "M12 2.25c-5.047 0-9 2.306-9 5.25v9c0 2.944 3.953 5.25 9 5.25 5.047 0 9-2.306 9-5.25v-9c0-2.944-3.953-5.25-9-5.25ZM19.5 12c0 .902-.739 1.822-2.026 2.524-1.45.79-3.394 1.226-5.474 1.226s-4.025-.436-5.474-1.226C5.239 13.822 4.5 12.902 4.5 12v-1.56c1.6 1.406 4.334 2.31 7.5 2.31 3.166 0 5.9-.908 7.5-2.31V12ZM6.526 4.976C7.976 4.186 9.92 3.75 12 3.75s4.025.436 5.474 1.226C18.761 5.678 19.5 6.598 19.5 7.5c0 .902-.739 1.822-2.026 2.524-1.45.79-3.394 1.226-5.474 1.226s-4.025-.436-5.474-1.226C5.239 9.322 4.5 8.402 4.5 7.5c0-.902.739-1.822 2.026-2.524Zm10.948 14.048c-1.45.79-3.394 1.226-5.474 1.226s-4.025-.436-5.474-1.226C5.239 18.322 4.5 17.402 4.5 16.5v-1.56c1.6 1.406 4.334 2.31 7.5 2.31 3.166 0 5.9-.907 7.5-2.31v1.56c0 .902-.739 1.822-2.026 2.524Z"
    }),
    dataFilled: (0, $4vwom.jsx)("path", {
        fill: "currentColor",
        d: "M12 2.25c-5.047 0-9 2.306-9 5.25v9c0 2.944 3.953 5.25 9 5.25 5.047 0 9-2.306 9-5.25v-9c0-2.944-3.953-5.25-9-5.25ZM19.5 12c0 .902-.739 1.822-2.026 2.524-1.45.79-3.394 1.226-5.474 1.226s-4.025-.436-5.474-1.226C5.239 13.822 4.5 12.902 4.5 12v-1.56c1.6 1.406 4.334 2.31 7.5 2.31 3.166 0 5.9-.908 7.5-2.31V12Zm-2.026 7.024c-1.45.79-3.394 1.226-5.474 1.226s-4.025-.436-5.474-1.226C5.239 18.322 4.5 17.402 4.5 16.5v-1.56c1.6 1.406 4.334 2.31 7.5 2.31 3.166 0 5.9-.907 7.5-2.31v1.56c0 .902-.739 1.822-2.026 2.524Z"
    }),
    desktop: (0, $4vwom.jsx)("path", {
        fill: "currentColor",
        d: "M21 6.938h-1.688V6a2.062 2.062 0 0 0-2.062-2.063H3.75A2.063 2.063 0 0 0 1.687 6v9a2.063 2.063 0 0 0 2.063 2.063h10.688V18a2.062 2.062 0 0 0 2.062 2.063H21A2.062 2.062 0 0 0 23.063 18V9A2.062 2.062 0 0 0 21 6.937Zm-17.25 9A.938.938 0 0 1 2.812 15V6a.937.937 0 0 1 .938-.938h13.5a.937.937 0 0 1 .938.938v.938H16.5A2.063 2.063 0 0 0 14.437 9v6.938H3.75ZM21.938 18a.938.938 0 0 1-.938.938h-4.5a.938.938 0 0 1-.938-.938V9a.938.938 0 0 1 .938-.938H21a.937.937 0 0 1 .938.938v9Zm-9.375 1.5a.562.562 0 0 1-.563.563H8.25a.563.563 0 0 1 0-1.125H12a.562.562 0 0 1 .563.562Zm7.5-9a.562.562 0 0 1-.563.563H18a.562.562 0 1 1 0-1.126h1.5a.562.562 0 0 1 .563.563Z"
    }),
    device: (0, $4vwom.jsx)("path", {
        fill: "currentColor",
        d: "M7.5 22.5h9a2.25 2.25 0 0 0 2.25-2.25V3.75A2.25 2.25 0 0 0 16.5 1.5h-9a2.25 2.25 0 0 0-2.25 2.25v16.5A2.25 2.25 0 0 0 7.5 22.5ZM6.75 3.75A.75.75 0 0 1 7.5 3h9a.75.75 0 0 1 .75.75v16.5a.75.75 0 0 1-.75.75h-9a.75.75 0 0 1-.75-.75V3.75Zm4.125 14.625a1.125 1.125 0 1 1 2.25 0 1.125 1.125 0 0 1-2.25 0Z"
    }),
    deviceFilled: (0, $4vwom.jsx)("path", {
        fill: "currentColor",
        d: "M7.5 22.5h9a2.25 2.25 0 0 0 2.25-2.25V3.75A2.25 2.25 0 0 0 16.5 1.5h-9a2.25 2.25 0 0 0-2.25 2.25v16.5A2.25 2.25 0 0 0 7.5 22.5Zm4.5-5.25a1.125 1.125 0 1 1 0 2.25 1.125 1.125 0 0 1 0-2.25Z"
    }),
    delivery: (0, $4vwom.jsx)("path", {
        fill: "currentColor",
        d: "m20.97 6.202-8.25-4.514a1.489 1.489 0 0 0-1.44 0L3.03 6.202a1.5 1.5 0 0 0-.78 1.313v8.966a1.5 1.5 0 0 0 .78 1.313l8.25 4.516a1.489 1.489 0 0 0 1.44 0l8.25-4.516a1.5 1.5 0 0 0 .78-1.313V7.517a1.5 1.5 0 0 0-.78-1.315ZM12 3l7.532 4.125-2.791 1.528-7.533-4.125L12 3Zm0 8.25L4.468 7.125l3.178-1.74 7.532 4.125L12 11.25ZM3.75 8.437l7.5 4.105v8.043l-7.5-4.102V8.437Zm16.5 8.042-7.5 4.106v-8.04l3-1.64v3.345a.75.75 0 1 0 1.5 0v-4.167l3-1.646v8.042Z"
    }),
    deliveryFilled: (0, $4vwom.jsx)("path", {
        fill: "currentColor",
        d: "m20.97 6.202-8.25-4.514a1.489 1.489 0 0 0-1.44 0L3.03 6.202a1.5 1.5 0 0 0-.78 1.313v8.966a1.5 1.5 0 0 0 .78 1.313l8.25 4.516a1.489 1.489 0 0 0 1.44 0l8.25-4.516a1.5 1.5 0 0 0 .78-1.313V7.517a1.5 1.5 0 0 0-.78-1.315ZM12 3l7.533 4.125-2.792 1.527-7.533-4.125L12 3Zm0 8.25L4.467 7.125l3.18-1.74 7.532 4.124L12 11.25Zm8.25 5.236-7.5 4.105v-8.044l3-1.642v3.345a.75.75 0 1 0 1.5 0v-4.166l3-1.642V16.486Z"
    }),
    eraser: (0, $4vwom.jsx)("path", {
        fill: "currentColor",
        d: "m21.094 7.537-3.882-3.88a2.25 2.25 0 0 0-3.181 0L2.906 14.78a2.25 2.25 0 0 0 0 3.181l2.818 2.819a.75.75 0 0 0 .533.219H20.25a.75.75 0 1 0 0-1.5h-7.94l8.784-8.78a2.25 2.25 0 0 0 0-3.183ZM10.189 19.5H6.567l-2.599-2.599a.75.75 0 0 1 0-1.06L9 10.81l4.94 4.939-3.751 3.75Zm9.843-9.844L15 14.69l-4.94-4.94 5.034-5.03a.749.749 0 0 1 1.061 0l3.88 3.879a.75.75 0 0 1 0 1.06l-.003-.003Z"
    }),
    filter: (0, $4vwom.jsx)("path", {
        fill: "currentColor",
        d: "M18.75 12.25A.75.75 0 0 1 18 13H6a.75.75 0 1 1 0-1.5h12a.75.75 0 0 1 .75.75Zm3-5.25H2.25a.75.75 0 0 0 0 1.5h19.5a.75.75 0 1 0 0-1.5Zm-7.5 9h-4.5a.75.75 0 1 0 0 1.5h4.5a.75.75 0 1 0 0-1.5Z"
    }),
    globe: (0, $4vwom.jsx)("path", {
        fill: "currentColor",
        d: "M12 2.25A9.75 9.75 0 1 0 21.75 12 9.76 9.76 0 0 0 12 2.25ZM20.25 12a8.214 8.214 0 0 1-.6 3.088l-4.19-2.577a1.494 1.494 0 0 0-.586-.21l-2.139-.288a1.51 1.51 0 0 0-1.5.737h-.817l-.357-.737A1.492 1.492 0 0 0 9.03 11.2l-.75-.162.733-1.288h1.567c.253 0 .502-.065.724-.188l1.149-.633c.1-.056.195-.124.281-.2l2.523-2.283a1.494 1.494 0 0 0 .306-1.843l-.034-.06A8.26 8.26 0 0 1 20.25 12Zm-6.815-8.124.815 1.458-2.523 2.282-1.147.634H9.013A1.5 1.5 0 0 0 7.712 9l-.819 1.428-.951-2.535 1.026-2.425a8.238 8.238 0 0 1 6.468-1.594v.002ZM3.75 12a8.206 8.206 0 0 1 .8-3.544l1.064 2.838a1.5 1.5 0 0 0 1.09.938l2.008.432.357.742a1.508 1.508 0 0 0 1.35.844h.14l-.679 1.522a1.5 1.5 0 0 0 .268 1.628l.014.013L12 19.307l-.182.937A8.26 8.26 0 0 1 3.75 12Zm9.617 8.136.106-.545a1.507 1.507 0 0 0-.388-1.316l-1.835-1.893 1.284-2.882 2.14.289 4.286 2.636a8.268 8.268 0 0 1-5.593 3.71Z"
    }),
    globeFilled: (0, $4vwom.jsx)("path", {
        fill: "currentColor",
        d: "M12 2.25A9.75 9.75 0 1 0 21.75 12 9.76 9.76 0 0 0 12 2.25ZM20.25 12a8.214 8.214 0 0 1-.6 3.088l-4.19-2.577a1.494 1.494 0 0 0-.586-.21l-2.139-.288a1.51 1.51 0 0 0-1.5.737h-.817l-.357-.737A1.492 1.492 0 0 0 9.03 11.2l-.75-.162.733-1.288h1.567c.253 0 .502-.065.724-.188l1.149-.633c.1-.056.195-.124.281-.2l2.523-2.283a1.494 1.494 0 0 0 .306-1.843l-.034-.06A8.26 8.26 0 0 1 20.25 12Zm-16.5 0a8.206 8.206 0 0 1 .8-3.544l1.064 2.838a1.5 1.5 0 0 0 1.09.938l2.008.432.357.742a1.508 1.508 0 0 0 1.35.844h.14l-.679 1.522a1.5 1.5 0 0 0 .268 1.628l.014.013L12 19.307l-.182.937A8.26 8.26 0 0 1 3.75 12Z"
    }),
    handCoins: (0, $4vwom.jsx)("path", {
        fill: "currentColor",
        d: "M22.343 13.974a2.29 2.29 0 0 0-1.99-.396l-3.923.902a2.625 2.625 0 0 0-2.555-3.23H9.182a2.982 2.982 0 0 0-2.122.878L4.94 14.25H2.25a1.5 1.5 0 0 0-1.5 1.5v3.75a1.5 1.5 0 0 0 1.5 1.5H12a.744.744 0 0 0 .182-.023l6-1.5a.653.653 0 0 0 .111-.037l3.645-1.55.04-.02a2.306 2.306 0 0 0 .37-3.896h-.005ZM2.25 15.75H4.5v3.75H2.25v-3.75Zm19.072.77-3.563 1.517-5.853 1.463H6v-4.19l2.122-2.12a1.487 1.487 0 0 1 1.06-.44h4.693a1.125 1.125 0 1 1 0 2.25H11.25a.75.75 0 1 0 0 1.5h3a.782.782 0 0 0 .168-.019l6.281-1.444.03-.008a.806.806 0 0 1 .59 1.49h.003Zm-5.197-6.77c.185 0 .37-.015.553-.045a3.376 3.376 0 1 0 2.646-4.406 3.375 3.375 0 1 0-3.199 4.451Zm5.625-1.125a1.875 1.875 0 1 1-3.75 0 1.875 1.875 0 0 1 3.75 0ZM16.125 4.5a1.875 1.875 0 0 1 1.805 1.37 3.376 3.376 0 0 0-1.407 2.337 1.875 1.875 0 1 1-.398-3.707Z"
    }),
    menu: (0, $4vwom.jsx)("path", {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M20.8 14h-16v2h16v-2Zm0-6h-16v2h16V8Z",
        clipRule: "evenodd"
    }),
    more: (0, $4vwom.jsx)("path", {
        fill: "currentColor",
        d: "M13.125 12a1.125 1.125 0 1 1-2.25 0 1.125 1.125 0 0 1 2.25 0Zm5.25-1.125a1.125 1.125 0 1 0 0 2.25 1.125 1.125 0 0 0 0-2.25Zm-12.75 0a1.125 1.125 0 1 0 0 2.25 1.125 1.125 0 0 0 0-2.25Z"
    }),
    navigationArrow: (0, $4vwom.jsx)("path", {
        fill: "currentColor",
        d: "M21.5 9.207 5.007 3.094l-.015-.005A1.5 1.5 0 0 0 3.09 5.007L9.207 21.5a1.478 1.478 0 0 0 1.413 1h.028a1.478 1.478 0 0 0 1.406-1.058l2.21-7.178 7.177-2.209a1.5 1.5 0 0 0 .058-2.848Zm-.5 1.415-7.178 2.209a1.5 1.5 0 0 0-.991.992L10.62 21l-.005-.016L4.5 4.5l16.483 6.114.015.006.002.002Z"
    }),
    placeholder: (0, $4vwom.jsx)("path", {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M16.485 5.515h-8.97a2 2 0 0 0-2 2v8.97a2 2 0 0 0 2 2h8.97a2 2 0 0 0 2-2v-8.97a2 2 0 0 0-2-2Zm-8.97-2a4 4 0 0 0-4 4v8.97a4 4 0 0 0 4 4h8.97a4 4 0 0 0 4-4v-8.97a4 4 0 0 0-4-4h-8.97Z",
        clipRule: "evenodd"
    }),
    plus: (0, $4vwom.jsx)("path", {
        fill: "currentColor",
        d: "M12.75 21.546a.75.75 0 1 1-1.5 0V12.75H2.454a.75.75 0 0 1 0-1.5h8.796V2.454a.75.75 0 1 1 1.5 0v8.796h8.796a.75.75 0 1 1 0 1.5H12.75v8.796Z"
    }),
    piggybank: (0, $4vwom.jsx)("path", {
        fill: "currentColor",
        d: "M18 10.875a1.125 1.125 0 1 1-2.25 0 1.125 1.125 0 0 1 2.25 0ZM14.25 6H10.5a.75.75 0 1 0 0 1.5h3.75a.75.75 0 1 0 0-1.5Zm9 4.5v3A2.25 2.25 0 0 1 21 15.75h-.221l-1.52 4.254a1.5 1.5 0 0 1-1.413.996h-1.192a1.5 1.5 0 0 1-1.413-.996l-.18-.504H9.689l-.18.504A1.5 1.5 0 0 1 8.096 21H6.904a1.5 1.5 0 0 1-1.413-.996l-1.178-3.296a8.22 8.22 0 0 1-2.01-4.535A1.5 1.5 0 0 0 1.5 13.5a.75.75 0 1 1-1.5 0 3 3 0 0 1 2.276-2.906A8.261 8.261 0 0 1 10.5 3h9.75a.75.75 0 1 1 0 1.5h-2.005a8.243 8.243 0 0 1 2.945 3.75 2.25 2.25 0 0 1 2.06 2.25Zm-1.5 0a.75.75 0 0 0-.75-.75h-.343a.75.75 0 0 1-.716-.525A6.74 6.74 0 0 0 13.5 4.5h-3a6.75 6.75 0 0 0-4.977 11.31.75.75 0 0 1 .154.254L6.904 19.5h1.192l.358-1.002A.75.75 0 0 1 9.16 18h6.43a.75.75 0 0 1 .706.498l.358 1.002h1.192l1.698-4.752a.75.75 0 0 1 .706-.498H21a.75.75 0 0 0 .75-.75v-3Z"
    }),
    pin: (0, $4vwom.jsx)("path", {
        fill: "currentColor",
        d: "M12 6a3.75 3.75 0 1 0 0 7.5A3.75 3.75 0 0 0 12 6Zm0 6a2.25 2.25 0 1 1 0-4.5 2.25 2.25 0 0 1 0 4.5Zm0-10.5a8.26 8.26 0 0 0-8.25 8.25c0 2.944 1.36 6.064 3.938 9.023a23.837 23.837 0 0 0 3.885 3.591.75.75 0 0 0 .861 0 23.835 23.835 0 0 0 3.879-3.59c2.573-2.96 3.937-6.08 3.937-9.024A8.26 8.26 0 0 0 12 1.5Zm0 19.313c-1.55-1.22-6.75-5.696-6.75-11.063a6.75 6.75 0 0 1 13.5 0c0 5.365-5.2 9.844-6.75 11.063Z"
    }),
    receipt: (0, $4vwom.jsx)("path", {
        fill: "currentColor",
        d: "M6.75 9.75A.75.75 0 0 1 7.5 9h9a.75.75 0 1 1 0 1.5h-9a.75.75 0 0 1-.75-.75Zm.75 3.75h9a.75.75 0 1 0 0-1.5h-9a.75.75 0 1 0 0 1.5Zm14.25-8.25V19.5a.75.75 0 0 1-1.086.67L18 18.838l-2.664 1.332a.75.75 0 0 1-.672 0L12 18.838 9.336 20.17a.75.75 0 0 1-.672 0L6 18.838 3.336 20.17a.75.75 0 0 1-1.086-.67V5.25a1.5 1.5 0 0 1 1.5-1.5h16.5a1.5 1.5 0 0 1 1.5 1.5Zm-1.5 0H3.75v13.037l1.914-.958a.75.75 0 0 1 .672 0L9 18.662l2.664-1.333a.75.75 0 0 1 .672 0L15 18.662l2.664-1.333a.75.75 0 0 1 .672 0l1.914.958V5.25Z"
    }),
    sealPercent: (0, $4vwom.jsx)("path", {
        fill: "currentColor",
        d: "M21.174 9.64c-.353-.37-.719-.75-.857-1.085-.127-.307-.134-.815-.142-1.307-.014-.915-.03-1.952-.75-2.673-.72-.72-1.758-.736-2.673-.75-.492-.008-1-.015-1.307-.143-.333-.137-.715-.503-1.084-.856C13.714 2.204 12.979 1.5 12 1.5c-.979 0-1.713.704-2.36 1.326-.37.353-.75.719-1.085.857-.305.127-.815.135-1.307.142-.915.014-1.952.03-2.673.75-.72.72-.731 1.758-.75 2.673-.008.492-.015 1-.143 1.307-.137.333-.503.715-.856 1.084C2.204 10.287 1.5 11.021 1.5 12c0 .979.704 1.713 1.326 2.36.353.37.719.75.857 1.085.127.307.135.815.142 1.307.014.915.03 1.952.75 2.673.72.72 1.758.736 2.673.75.492.008 1 .015 1.307.142.333.138.715.504 1.084.857.647.622 1.382 1.326 2.361 1.326.979 0 1.713-.704 2.36-1.326.37-.353.75-.719 1.085-.857.307-.127.815-.134 1.307-.142.915-.014 1.952-.03 2.673-.75.72-.72.736-1.758.75-2.673.008-.492.015-1 .142-1.307.138-.333.504-.715.857-1.084.622-.648 1.326-1.382 1.326-2.361 0-.979-.704-1.713-1.326-2.36Zm-1.082 3.683c-.45.469-.915.953-1.161 1.549-.236.571-.247 1.225-.256 1.858-.01.656-.02 1.343-.311 1.634-.292.29-.974.302-1.634.311-.633.01-1.287.02-1.858.256-.596.246-1.08.711-1.55 1.16-.468.45-.947.909-1.322.909-.375 0-.858-.461-1.323-.908-.465-.448-.953-.915-1.549-1.161-.571-.236-1.225-.247-1.858-.256-.656-.01-1.343-.02-1.634-.311-.29-.292-.302-.974-.311-1.634-.01-.633-.02-1.287-.256-1.858-.247-.596-.712-1.08-1.16-1.55C3.458 12.855 3 12.376 3 12c0-.375.461-.857.908-1.323.448-.466.914-.953 1.161-1.549.236-.571.247-1.225.256-1.858.01-.656.02-1.343.311-1.634.292-.29.974-.302 1.634-.311.633-.01 1.287-.02 1.858-.256.596-.247 1.08-.712 1.55-1.16C11.145 3.458 11.624 3 12 3c.375 0 .858.461 1.323.908.465.448.953.914 1.549 1.161.571.236 1.225.247 1.858.256.656.01 1.343.02 1.634.311.29.292.302.974.311 1.634.01.633.02 1.287.256 1.858.246.596.711 1.08 1.16 1.55.45.468.909.947.909 1.322 0 .375-.461.857-.908 1.323ZM11.25 9a2.25 2.25 0 1 0-4.5 0 2.25 2.25 0 0 0 4.5 0Zm-3 0a.75.75 0 1 1 1.5 0 .75.75 0 0 1-1.5 0ZM15 12.75a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5Zm0 3a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5Zm1.28-6.97-7.5 7.5a.75.75 0 1 1-1.06-1.06l7.5-7.5a.751.751 0 0 1 1.06 1.06Z"
    }),
    shield: (0, $4vwom.jsx)("path", {
        fill: "currentColor",
        d: "M7.553 10.219a.75.75 0 0 1 .978-.416l2.719 1.089V8.25a.75.75 0 1 1 1.5 0v2.642l2.719-1.089a.75.75 0 1 1 .562 1.394l-2.841 1.136 1.66 2.217a.75.75 0 0 1-1.2.9L12 13.25l-1.65 2.2a.75.75 0 1 1-1.2-.9l1.663-2.217-2.844-1.136a.75.75 0 0 1-.416-.978ZM21 4.5v5.51c0 8.402-7.108 11.188-8.531 11.661a1.446 1.446 0 0 1-.938 0C10.106 21.203 3 18.413 3 10.011V4.5A1.5 1.5 0 0 1 4.5 3h15A1.5 1.5 0 0 1 21 4.5Zm-1.5 0h-15v5.512c0 7.359 6.232 9.813 7.5 10.235 1.28-.427 7.5-2.884 7.5-10.235V4.5Z"
    }),
    shuffle: (0, $4vwom.jsx)("path", {
        fill: "currentColor",
        d: "M22.28 16.72a.747.747 0 0 1 0 1.06l-2.25 2.25a.75.75 0 0 1-1.06-1.06l.97-.97h-1.102a6.762 6.762 0 0 1-5.493-2.827l-3.91-5.475A5.26 5.26 0 0 0 5.161 7.5H3A.75.75 0 0 1 3 6h2.162a6.761 6.761 0 0 1 5.493 2.827l3.91 5.475a5.26 5.26 0 0 0 4.273 2.198h1.102l-.97-.97a.75.75 0 1 1 1.06-1.06l2.25 2.25Zm-8.874-6.689a.75.75 0 0 0 1.046-.174l.113-.157a5.26 5.26 0 0 1 4.273-2.2h1.102l-.97.97a.75.75 0 1 0 1.06 1.06l2.25-2.25a.748.748 0 0 0 0-1.06l-2.25-2.25a.75.75 0 1 0-1.06 1.06l.97.97h-1.102a6.762 6.762 0 0 0-5.493 2.827l-.112.156a.749.749 0 0 0 .173 1.048Zm-2.812 3.938a.75.75 0 0 0-1.046.174l-.113.157a5.259 5.259 0 0 1-4.273 2.2H3A.75.75 0 1 0 3 18h2.162a6.762 6.762 0 0 0 5.493-2.827l.112-.156a.75.75 0 0 0-.173-1.048Z"
    }),
    simCard: (0, $4vwom.jsx)("path", {
        fill: "currentColor",
        d: "M7.72 3.97 2.47 9.22a.75.75 0 0 0-.22.53v9a1.5 1.5 0 0 0 1.5 1.5h16.5a1.5 1.5 0 0 0 1.5-1.5V5.25a1.5 1.5 0 0 0-1.5-1.5h-12a.75.75 0 0 0-.53.22Zm12.53 1.28v13.5H3.75v-8.69l4.81-4.81h11.69ZM10.5 7.5v9a.75.75 0 0 0 .75.75H18a.75.75 0 0 0 .75-.75v-9a.75.75 0 0 0-.75-.75h-6.75a.75.75 0 0 0-.75.75Zm6.75.75v1.5h-3a.75.75 0 1 0 0 1.5h3v1.5h-3a.75.75 0 1 0 0 1.5h3v1.5H12v-7.5h5.25Z"
    }),
    star: (0, $4vwom.jsx)("path", {
        fill: "currentColor",
        d: "M22.423 9.118a1.536 1.536 0 0 0-1.337-1.056l-5.53-.446-2.137-5.164a1.533 1.533 0 0 0-2.837 0L8.448 7.615l-5.534.447a1.543 1.543 0 0 0-.879 2.706l4.22 3.64-1.286 5.444a1.536 1.536 0 0 0 2.297 1.67L12 18.608l4.737 2.914a1.537 1.537 0 0 0 2.294-1.67l-1.29-5.444 4.22-3.64a1.541 1.541 0 0 0 .462-1.65Zm-1.438.513-4.566 3.937a.751.751 0 0 0-.24.742l1.395 5.888a.035.035 0 0 1-.016.044c-.016.014-.021.01-.035 0l-5.13-3.154a.75.75 0 0 0-.786 0l-5.13 3.156c-.014.009-.018.012-.035 0a.035.035 0 0 1-.016-.045l1.395-5.887a.75.75 0 0 0-.24-.742L3.015 9.633c-.011-.01-.022-.018-.012-.047.01-.03.017-.025.03-.027l5.993-.484a.75.75 0 0 0 .63-.463l2.308-5.589c.008-.016.01-.023.033-.023s.026.007.033.023l2.314 5.589a.75.75 0 0 0 .633.461l5.992.484c.014 0 .023 0 .031.027.009.027 0 .038-.015.047Z"
    }),
    starFilled: (0, $4vwom.jsx)("path", {
        fill: "currentColor",
        d: "m21.984 10.723-4.228 3.69 1.267 5.494a1.5 1.5 0 0 1-2.235 1.625l-4.792-2.906-4.78 2.906a1.5 1.5 0 0 1-2.236-1.625l1.265-5.488-4.23-3.696a1.5 1.5 0 0 1 .855-2.63l5.574-.483 2.176-5.19a1.495 1.495 0 0 1 2.76 0l2.183 5.19 5.572.482a1.5 1.5 0 0 1 .854 2.631h-.005Z"
    }),
    tablet: (0, $4vwom.jsx)("path", {
        fill: "currentColor",
        d: "M18 2.438H6A2.063 2.063 0 0 0 3.937 4.5v15A2.063 2.063 0 0 0 6 21.563h12a2.062 2.062 0 0 0 2.063-2.063v-15A2.062 2.062 0 0 0 18 2.437ZM5.062 6.561h13.875v10.875H5.063V6.563Zm.938-3h12a.937.937 0 0 1 .938.938v.938H5.063V4.5A.937.937 0 0 1 6 3.562Zm12 16.875H6a.938.938 0 0 1-.938-.937v-.938h13.875v.938a.938.938 0 0 1-.937.938Z"
    }),
    truck: (0, $4vwom.jsx)("path", {
        fill: "currentColor",
        d: "m23.196 10.969-1.313-3.281a1.493 1.493 0 0 0-1.391-.938H17.25V6a.75.75 0 0 0-.75-.75H2.25a1.5 1.5 0 0 0-1.5 1.5v10.5a1.5 1.5 0 0 0 1.5 1.5h1.594a3 3 0 0 0 5.812 0h4.688a3 3 0 0 0 5.812 0h1.594a1.5 1.5 0 0 0 1.5-1.5v-6a.742.742 0 0 0-.054-.281ZM17.25 8.25h3.242l.9 2.25H17.25V8.25Zm-15-1.5h13.5v6H2.25v-6Zm4.5 12.75a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Zm7.594-2.25H9.656a3 3 0 0 0-5.812 0H2.25v-3h13.5v1.154a3.008 3.008 0 0 0-1.406 1.846Zm2.906 2.25a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Zm4.5-2.25h-1.594A3.007 3.007 0 0 0 17.25 15v-3h4.5v5.25Z"
    }),
    trustpilot: (0, $4vwom.jsx)("path", {
        fill: $756948b644e82cf2$var$colors._trustpilot,
        d: "m11.566 17.252 4.591-1.164L18.076 22l-6.51-4.748ZM22.132 9.61H14.05L11.566 2 9.082 9.61H1l6.54 4.717-2.483 7.61 6.54-4.717 4.026-2.893 6.51-4.717Z"
    }),
    vipps: (0, $4vwom.jsx)("path", {
        fill: "currentColor",
        d: "M12.656 16.282c2.97 0 4.656-1.445 6.262-3.532.883-1.124 2.007-1.365 2.81-.723.802.643.882 1.847 0 2.97-2.329 3.051-5.299 4.898-9.072 4.898-4.094 0-7.706-2.248-10.195-6.182-.722-1.043-.562-2.167.241-2.729.803-.562 2.007-.321 2.73.803 1.766 2.649 4.174 4.495 7.224 4.495Zm5.54-9.874c0 1.445-1.125 2.409-2.409 2.409-1.284 0-2.408-.964-2.408-2.409C13.379 4.963 14.503 4 15.787 4c1.284 0 2.408 1.044 2.408 2.408Z"
    }),
    warning: (0, $4vwom.jsx)("path", {
        fill: "currentColor",
        d: "M12 2a9.75 9.75 0 1 0 9.75 9.75A9.76 9.76 0 0 0 12 2Zm-.75 5.25a.75.75 0 1 1 1.5 0v5.25a.75.75 0 1 1-1.5 0V7.25ZM12 17a1.125 1.125 0 1 1 0-2.25A1.125 1.125 0 0 1 12 17Z"
    }),
    watch: (0, $4vwom.jsx)("path", {
        fill: "currentColor",
        d: "M19.312 12a7.306 7.306 0 0 0-3.05-5.935l-.597-3.3a1.312 1.312 0 0 0-1.291-1.078H9.626a1.313 1.313 0 0 0-1.292 1.079l-.597 3.299a7.3 7.3 0 0 0 0 11.87l.597 3.3a1.313 1.313 0 0 0 1.292 1.078h4.748a1.313 1.313 0 0 0 1.291-1.079l.598-3.299A7.306 7.306 0 0 0 19.313 12Zm-9.87-9.034a.187.187 0 0 1 .187-.154h4.748a.187.187 0 0 1 .187.154l.428 2.362a7.283 7.283 0 0 0-5.972 0l.421-2.362Zm5.116 18.068a.188.188 0 0 1-.187.154H9.626a.187.187 0 0 1-.187-.154l-.428-2.362a7.283 7.283 0 0 0 5.972 0l-.425 2.362ZM12 18.188A6.187 6.187 0 1 1 18.187 12 6.195 6.195 0 0 1 12 18.188Z"
    }),
    wave: (0, $4vwom.jsx)("path", {
        fill: "currentColor",
        d: "m20.64 9.375-1.622-2.813a2.625 2.625 0 0 0-3.585-.96 2.596 2.596 0 0 0-.844.781l-1.633-2.82a2.625 2.625 0 0 0-4.545 0 2.625 2.625 0 0 0-3.897 3.374l.15.26a2.625 2.625 0 0 0-2.06 3.928l3.748 6.498a8.2 8.2 0 0 0 5.01 3.844 8.25 8.25 0 0 0 9.28-12.094v.002Zm-.623 5.873a6.75 6.75 0 0 1-12.365 1.627l-3.75-6.499A1.125 1.125 0 0 1 5.85 9.251l1.803 3.124a.75.75 0 1 0 1.298-.75L5.812 6.187a1.125 1.125 0 1 1 1.949-1.125l2.926 5.063a.751.751 0 1 0 1.299-.75L9.71 5.437a1.125 1.125 0 1 1 1.948-1.125l3.133 5.429a4.5 4.5 0 0 0-.52 5.68.75.75 0 1 0 1.242-.843 3 3 0 0 1 .685-4.078.75.75 0 0 0 .2-.975l-.627-1.088a1.126 1.126 0 0 1 1.264-1.676 1.125 1.125 0 0 1 .684.551l1.622 2.813a6.707 6.707 0 0 1 .675 5.12v.003ZM17.273 2.973a.75.75 0 0 1 .914-.536 5.59 5.59 0 0 1 3.425 2.625l.031.054a.75.75 0 1 1-1.298.75l-.031-.054A4.094 4.094 0 0 0 17.8 3.891a.75.75 0 0 1-.528-.918Zm-9.69 19.246a.75.75 0 0 1-1.052.124 11.209 11.209 0 0 1-2.775-3.218.75.75 0 1 1 1.299-.75 9.72 9.72 0 0 0 2.404 2.786.75.75 0 0 1 .124 1.058Z"
    })
};
const $756948b644e82cf2$var$borderRadiuses = {
    xs: {
        xs: 6
    },
    sm: {
        xs: 12
    },
    md: {
        xs: 16,
        md: 24
    },
    lg: {
        xs: 24,
        md: 32
    }
};
const $756948b644e82cf2$var$spacingSizes = {
    xs: {
        xs: 4,
        sm: 12,
        md: 18,
        lg: 24
    },
    sm: {
        xs: 16,
        lg: 22
    },
    md: {
        xs: 16,
        sm: 22,
        md: 24,
        lg: 24,
        xl: 24
    },
    lg: {
        xs: 24,
        sm: 32,
        md: 56,
        lg: 60,
        xl: 64
    },
    xl: {
        xs: 40,
        sm: 56,
        md: 72,
        lg: 80,
        xl: 96
    }
};
const $756948b644e82cf2$var$headingLevels = {
    "1": {
        xs: {
            fontSize: 28 * (0, $1c2a8fb378443a1d$export$adc5746a202ff4b),
            fontWeight: 500,
            lineHeight: "100%",
            letterSpacing: -0.6
        },
        md: {
            fontSize: 40 * (0, $1c2a8fb378443a1d$export$adc5746a202ff4b),
            letterSpacing: -0.8
        },
        lg: {
            fontSize: 54 * (0, $1c2a8fb378443a1d$export$adc5746a202ff4b),
            letterSpacing: -0.8
        }
    },
    "2": {
        xs: {
            fontSize: 24 * (0, $1c2a8fb378443a1d$export$adc5746a202ff4b),
            fontWeight: 400,
            lineHeight: "110%",
            letterSpacing: 0.24
        },
        md: {
            fontSize: 32 * (0, $1c2a8fb378443a1d$export$adc5746a202ff4b),
            letterSpacing: 0.3
        },
        lg: {
            fontSize: 40 * (0, $1c2a8fb378443a1d$export$adc5746a202ff4b),
            letterSpacing: 0.4
        }
    },
    "3": {
        xs: {
            fontSize: 18 * (0, $1c2a8fb378443a1d$export$adc5746a202ff4b),
            fontWeight: 400,
            lineHeight: "130%"
        },
        md: {
            fontSize: 24 * (0, $1c2a8fb378443a1d$export$adc5746a202ff4b)
        },
        lg: {
            fontSize: 28 * (0, $1c2a8fb378443a1d$export$adc5746a202ff4b)
        }
    },
    "4": {
        xs: {
            fontSize: 15,
            fontWeight: 600,
            lineHeight: "120%",
            letterSpacing: -0.15
        },
        md: {
            fontSize: 16 * (0, $1c2a8fb378443a1d$export$adc5746a202ff4b),
            fontWeight: 500
        },
        lg: {
            fontSize: 18 * (0, $1c2a8fb378443a1d$export$adc5746a202ff4b),
            letterSpacing: -0.18
        }
    },
    "5": {
        xs: {
            fontSize: 14,
            fontWeight: 500,
            lineHeight: "110%",
            letterSpacing: -0.14
        },
        md: {
            fontSize: 15 * (0, $1c2a8fb378443a1d$export$adc5746a202ff4b)
        },
        lg: {
            fontSize: 16 * (0, $1c2a8fb378443a1d$export$adc5746a202ff4b),
            letterSpacing: -0.18
        }
    }
};
const $756948b644e82cf2$var$buttonBase = {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    transition: "background-color 0.30s",
    borderStyle: "solid",
    borderColor: "transparent",
    whiteSpace: "nowrap",
    borderRadius: "100vw",
    cursor: "pointer",
    gap: 8
};
const $756948b644e82cf2$var$disabledButton = {
    backgroundColor: $756948b644e82cf2$var$colors.gray100,
    color: $756948b644e82cf2$var$colors.gray300,
    cursor: "default"
};
const $756948b644e82cf2$var$buttonVariants = {
    primary: Object.assign(Object.assign({}, $756948b644e82cf2$var$buttonBase), {
        color: $756948b644e82cf2$var$colors.grayWhite,
        background: $756948b644e82cf2$var$colors.brand,
        "&:hover:not([disabled])": {
            color: $756948b644e82cf2$var$colors.grayWhite,
            backgroundColor: $756948b644e82cf2$var$colors.brandDark
        },
        "&:focus": {
            color: $756948b644e82cf2$var$colors.gray500,
            backgroundColor: $756948b644e82cf2$var$colors.brandLight
        },
        "&:disabled": $756948b644e82cf2$var$disabledButton
    }),
    secondary: Object.assign(Object.assign({}, $756948b644e82cf2$var$buttonBase), {
        color: $756948b644e82cf2$var$colors.gray500,
        backgroundColor: $756948b644e82cf2$var$colors.gray100,
        "&:hover:not([disabled])": {
            backgroundColor: $756948b644e82cf2$var$colors.gray200
        },
        "&:focus": {
            color: $756948b644e82cf2$var$colors.gray500,
            borderWidth: 2,
            borderColor: $756948b644e82cf2$var$colors.gray500
        },
        "&:disabled": $756948b644e82cf2$var$disabledButton
    }),
    dark: Object.assign(Object.assign({}, $756948b644e82cf2$var$buttonBase), {
        color: $756948b644e82cf2$var$colors.grayWhite,
        backgroundColor: $756948b644e82cf2$var$colors.gray500,
        "&:hover:not([disabled])": {
            color: $756948b644e82cf2$var$colors.grayWhite,
            backgroundColor: $756948b644e82cf2$var$colors.gray400
        },
        "&:focus": {
            color: $756948b644e82cf2$var$colors.gray500,
            backgroundColor: $756948b644e82cf2$var$colors.gray200
        },
        "&:disabled": $756948b644e82cf2$var$disabledButton
    }),
    light: Object.assign(Object.assign({}, $756948b644e82cf2$var$buttonBase), {
        color: $756948b644e82cf2$var$colors.gray500,
        backgroundColor: $756948b644e82cf2$var$colors.grayWhite,
        "&:hover:not([disabled])": {
            color: $756948b644e82cf2$var$colors.gray500,
            backgroundColor: $756948b644e82cf2$var$colors.gray100
        },
        "&:focus": {
            color: $756948b644e82cf2$var$colors.gray500,
            backgroundColor: $756948b644e82cf2$var$colors.gray200
        },
        "&:disabled": $756948b644e82cf2$var$disabledButton
    }),
    outlined: Object.assign(Object.assign({}, $756948b644e82cf2$var$buttonBase), {
        color: $756948b644e82cf2$var$colors.gray500,
        borderColor: $756948b644e82cf2$var$colors.gray200,
        "&:hover:not([disabled])": {
            borderColor: $756948b644e82cf2$var$colors.gray400
        },
        "&:focus": {
            borderColor: $756948b644e82cf2$var$colors.gray500
        },
        "&:disabled": $756948b644e82cf2$var$disabledButton
    }),
    select: Object.assign(Object.assign({}, $756948b644e82cf2$var$buttonBase), {
        color: $756948b644e82cf2$var$colors.gray500,
        borderColor: $756948b644e82cf2$var$colors.gray200,
        "&[data-selected=false]": {
            borderWidth: 1
        },
        "&:hover:not([disabled])": {
            borderColor: $756948b644e82cf2$var$colors.brand
        },
        "&:focus": {
            color: $756948b644e82cf2$var$colors.gray500,
            backgroundColor: $756948b644e82cf2$var$colors.gray200
        },
        "&[data-selected=true]": {
            borderWidth: 2,
            borderColor: $756948b644e82cf2$var$colors.brand,
            backgroundColor: $756948b644e82cf2$var$colors.brandLight
        },
        "&:disabled": $756948b644e82cf2$var$disabledButton
    }),
    option: Object.assign(Object.assign({}, $756948b644e82cf2$var$buttonBase), {
        color: $756948b644e82cf2$var$colors.gray400,
        borderColor: $756948b644e82cf2$var$colors.gray200,
        background: $756948b644e82cf2$var$colors.grayWhite,
        paddingLeft: `${$756948b644e82cf2$export$981516ee4691055c(16)} !important`,
        paddingRight: `${$756948b644e82cf2$export$981516ee4691055c(16)} !important`,
        borderRadius: $756948b644e82cf2$export$981516ee4691055c(12),
        "&[data-selected=false]": {
            borderWidth: 1,
            fontWeight: 400
        },
        "&:hover:not([disabled])": {
            borderColor: $756948b644e82cf2$var$colors.brand
        },
        "&:focus": {
            color: $756948b644e82cf2$var$colors.gray400,
            backgroundColor: $756948b644e82cf2$var$colors.gray100
        },
        "&[data-selected=true]": {
            borderColor: $756948b644e82cf2$var$colors.brand,
            backgroundColor: $756948b644e82cf2$var$colors.brandLight
        },
        "&:disabled": $756948b644e82cf2$var$disabledButton
    }),
    profile: Object.assign(Object.assign({}, $756948b644e82cf2$var$buttonBase), {
        color: $756948b644e82cf2$var$colors.brand,
        backgroundColor: $756948b644e82cf2$var$colors.brandLight
    })
};
const $756948b644e82cf2$var$buttonSizes = {
    xs: {
        xs: {
            height: 36 * (0, $1c2a8fb378443a1d$export$adc5746a202ff4b),
            padding: `0 ${12 * (0, $1c2a8fb378443a1d$export$adc5746a202ff4b)}px`
        }
    },
    sm: {
        xs: {
            height: 48 * (0, $1c2a8fb378443a1d$export$adc5746a202ff4b),
            padding: `0 ${24 * (0, $1c2a8fb378443a1d$export$adc5746a202ff4b)}px`
        }
    },
    md: {
        xs: {
            height: 48 * (0, $1c2a8fb378443a1d$export$adc5746a202ff4b),
            padding: `0 ${24 * (0, $1c2a8fb378443a1d$export$adc5746a202ff4b)}px`
        },
        lg: {
            height: 64 * (0, $1c2a8fb378443a1d$export$adc5746a202ff4b),
            padding: `0 ${32 * (0, $1c2a8fb378443a1d$export$adc5746a202ff4b)}px`
        }
    }
};
const $756948b644e82cf2$var$bodySizes = {
    xs: {
        xs: {
            fontSize: 14,
            fontWeight: 400,
            lineHeight: "135%"
        },
        md: {
            fontSize: 15,
            fontWeight: 300
        }
    },
    sm: {
        xs: {
            fontSize: 15,
            fontWeight: 400,
            lineHeight: "135%"
        },
        md: {
            fontSize: 16 * (0, $1c2a8fb378443a1d$export$adc5746a202ff4b),
            fontWeight: 300
        },
        xl: {
            fontSize: 17 * (0, $1c2a8fb378443a1d$export$adc5746a202ff4b)
        }
    },
    md: {
        xs: {
            fontSize: 16,
            fontWeight: 400,
            lineHeight: "135%"
        },
        md: {
            fontSize: 17 * (0, $1c2a8fb378443a1d$export$adc5746a202ff4b),
            fontWeight: 300
        },
        xl: {
            fontSize: 18 * (0, $1c2a8fb378443a1d$export$adc5746a202ff4b)
        }
    },
    lg: {
        xs: {
            fontSize: 17,
            fontWeight: 300,
            lineHeight: "135%"
        },
        md: {
            fontSize: 22 * (0, $1c2a8fb378443a1d$export$488117a5011aa9e)
        },
        xl: {
            fontSize: 22 * (0, $1c2a8fb378443a1d$export$adc5746a202ff4b)
        }
    },
    xl: {
        xs: {
            fontSize: 18,
            fontWeight: 300,
            lineHeight: "130%"
        },
        md: {
            fontSize: 21 * (0, $1c2a8fb378443a1d$export$adc5746a202ff4b)
        },
        lg: {
            fontSize: 28 * (0, $1c2a8fb378443a1d$export$488117a5011aa9e)
        },
        xl: {
            fontSize: 28 * (0, $1c2a8fb378443a1d$export$adc5746a202ff4b)
        }
    }
};
const $756948b644e82cf2$var$textVariants = {
    body: $756948b644e82cf2$var$bodySizes,
    label: {
        md: {
            xs: {
                fontSize: 12,
                fontWeight: 500,
                letterSpacing: 0.96,
                textTransform: "uppercase",
                lineHeight: "115%"
            },
            md: {
                fontSize: 12
            },
            lg: {
                fontSize: 14,
                letterSpacing: 1.28
            },
            xl: {
                fontSize: 16 * (0, $1c2a8fb378443a1d$export$adc5746a202ff4b)
            }
        }
    }
};
const $756948b644e82cf2$export$92c840cda8ec752c = (0, $dc53c17a4a911fba$export$25d302a5b900a763)({
    textVariants: $756948b644e82cf2$var$textVariants,
    screenSizes: $756948b644e82cf2$var$screenSizes,
    bodySizes: $756948b644e82cf2$var$bodySizes,
    borderRadiuses: $756948b644e82cf2$var$borderRadiuses,
    spacingSizes: $756948b644e82cf2$var$spacingSizes,
    headingLevels: $756948b644e82cf2$var$headingLevels,
    iconSizes: [
        16,
        24,
        32,
        40,
        48,
        64,
        96
    ],
    colors: $756948b644e82cf2$var$colors,
    icons: $756948b644e82cf2$var$icons,
    buttonVariants: $756948b644e82cf2$var$buttonVariants,
    buttonSizes: $756948b644e82cf2$var$buttonSizes
});
const $756948b644e82cf2$export$559a0f07c8df6570 = (0, $dc53c17a4a911fba$export$93d4e7f90805808f);
const $756948b644e82cf2$export$aa0e86c7c0d2f400 = (0, $lhaLc.css)({
    html: {
        boxSizing: "border-box"
    },
    "*, *:before, *:after": {
        boxSizing: "inherit",
        margin: 0,
        padding: 0,
        border: 0,
        verticalAlign: "baseline"
    },
    button: {
        background: "none",
        border: "none",
        font: "inherit",
        cursor: "pointer",
        outline: "inherit"
    },
    body: {
        fontFamily: "Catalogue, sans-serif",
        color: $756948b644e82cf2$export$92c840cda8ec752c.colors.gray500,
        fontSize: 18,
        "--scale-factor": (0, $1c2a8fb378443a1d$export$f988485815015380)
    },
    "p a": {
        textDecoration: "underline",
        textDecorationSkipInk: "none",
        textUnderlineOffset: "20%"
    },
    "p:last-child": {
        marginBottom: 0
    },
    strong: {
        fontWeight: 600
    },
    em: {
        fontStyle: "italic"
    },
    a: {
        textDecoration: "none",
        color: "inherit"
    },
    "td, th": {
        verticalAlign: "middle"
    }
}, $756948b644e82cf2$export$92c840cda8ec752c.helpers.responsiveCss("min", "md", {
    body: {
        "--scale-factor": (0, $1c2a8fb378443a1d$export$330a64de1bbc7059)
    }
}), $756948b644e82cf2$export$92c840cda8ec752c.helpers.responsiveCss("min", "lg", {
    body: {
        "--scale-factor": (0, $1c2a8fb378443a1d$export$488117a5011aa9e)
    }
}), $756948b644e82cf2$export$92c840cda8ec752c.helpers.responsiveCss("min", "xl", {
    body: {
        "--scale-factor": (0, $1c2a8fb378443a1d$export$adc5746a202ff4b)
    }
}), (0, $e82ba787de72625c$export$2c2533fee2945415)({
    body: {
        WebkitFontSmoothing: "antialiased",
        MozOsxFontSmoothing: "grayscale",
        fontSmooth: "never"
    }
}));
function $756948b644e82cf2$export$981516ee4691055c(value) {
    return `calc(${typeof value === "number" ? `${value}px` : value} * var(--scale-factor))`;
}
function $756948b644e82cf2$export$65d8eafb3b383037() {
    return $756948b644e82cf2$export$92c840cda8ec752c.helpers.responsiveVariantToCss((0, $1c2a8fb378443a1d$export$3a40bd8b0ff0173c));
}
function $756948b644e82cf2$export$629e292a677297c2() {
    return $756948b644e82cf2$export$92c840cda8ec752c.helpers.responsiveVariantToCss((0, $1c2a8fb378443a1d$export$a9ddfd01863914a9));
}
function $756948b644e82cf2$export$27430441855376b9(prop, responsiveValues) {
    if (typeof responsiveValues === "string" || typeof responsiveValues === "number") return (0, $lhaLc.css)({
        [prop]: $756948b644e82cf2$export$981516ee4691055c(responsiveValues)
    });
    return (0, $lhaLc.css)(responsiveValues.map((rv)=>{
        if (typeof rv === "string" || typeof rv === "number") return {
            [prop]: rv
        };
        else if (rv) {
            const [limitType, screenSize, value] = rv;
            return $756948b644e82cf2$export$92c840cda8ec752c.helpers.responsiveCss(limitType, screenSize, {
                [prop]: $756948b644e82cf2$export$981516ee4691055c(value)
            });
        }
    }));
}
function $756948b644e82cf2$export$88d2c1aa53be97d2(variableName) {
    // eslint-disable-next-line no-console
    if (!variableName.startsWith("--")) console.warn("CSS-variables should start with `--`.");
    return (0, $lhaLc.css)({
        [variableName]: "0px 2px 12px 0px rgba(21, 6, 36, 0.12)"
    }, $756948b644e82cf2$export$92c840cda8ec752c.helpers.responsiveCss("min", "md", {
        [variableName]: "0px 3px 18px 0px rgba(21, 6, 36, 0.12)"
    }), $756948b644e82cf2$export$92c840cda8ec752c.helpers.responsiveCss("min", "lg", {
        [variableName]: "0px 4px 24px 0px rgba(21, 6, 36, 0.12)"
    }), $756948b644e82cf2$export$92c840cda8ec752c.helpers.responsiveCss("min", "xl", {
        [variableName]: "0px 4px 32px 0px rgba(21, 6, 36, 0.12)"
    }));
}
function $756948b644e82cf2$export$4c4a64d4bfa41e73() {
    return (0, $lhaLc.css)({
        boxShadow: "0px 2px 12px 0px rgba(21, 6, 36, 0.12)"
    }, $756948b644e82cf2$export$92c840cda8ec752c.helpers.responsiveCss("min", "md", {
        boxShadow: "0px 3px 18px 0px rgba(21, 6, 36, 0.12)"
    }), $756948b644e82cf2$export$92c840cda8ec752c.helpers.responsiveCss("min", "lg", {
        boxShadow: "0px 4px 24px 0px rgba(21, 6, 36, 0.12)"
    }), $756948b644e82cf2$export$92c840cda8ec752c.helpers.responsiveCss("min", "xl", {
        boxShadow: "0px 4px 32px 0px rgba(21, 6, 36, 0.12)"
    }));
}
const $756948b644e82cf2$var$sectionSpacing = {
    xs: $756948b644e82cf2$export$981516ee4691055c(36),
    md: $756948b644e82cf2$export$981516ee4691055c(48)
};
function $756948b644e82cf2$export$f1cf1885b6bfef23() {
    return Object.entries($756948b644e82cf2$var$sectionSpacing).map(([screenSize, spacing])=>$756948b644e82cf2$export$92c840cda8ec752c.helpers.responsiveCss("min", screenSize, {
            paddingTop: spacing,
            paddingBottom: spacing
        }));
}
const $756948b644e82cf2$export$682f474bed45e419 = (0, $lhaLc.css)({
    ".adyen-checkout-form-instruction": {
        display: "none",
        fontSize: 16,
        color: $756948b644e82cf2$var$colors.gray300
    },
    ".adyen-checkout-input__inline-validation": {
        height: 24,
        width: 24
    },
    ".adyen-checkout-input__inline-validation img": {
        display: "none"
    },
    ".adyen-checkout-input__inline-validation.adyen-checkout-input__inline-validation--valid:after": {
        display: "block",
        content: `url("data:image/svg+xml,${encodeURIComponent((0, (/*@__PURE__*/$parcel$interopDefault($5qU69))).renderToString((0, $4vwom.jsx)((0, $dc53c17a4a911fba$export$d8964aec282183a3), {
            theme: $756948b644e82cf2$export$92c840cda8ec752c,
            children: (0, $4vwom.jsx)((0, $f8cdd04128a131cf$export$f04a61298a47a40f), {
                icon: "check",
                color: "forest"
            })
        })))}")`,
        width: 24,
        height: 24
    },
    ".adyen-checkout__payment-method": {
        backgroundColor: "#fff",
        padding: 0,
        border: 0
    },
    "li.adyen-checkout__payment-method": {
        marginBottom: 16
    },
    "li.adyen-checkout__payment-method:last-of-type": {
        marginBottom: 0
    },
    ".adyen-checkout__payment-method__header": {
        padding: 0,
        marginBottom: 16,
        display: "flex",
        justifyContent: "space-between"
    },
    "li.adyen-checkout__payment-method:last-of-type:not(.adyen-checkout__payment-method--selected) .adyen-checkout__payment-method__header": {
        marginBottom: 0
    },
    ".adyen-checkout__payment-method__details": {
        padding: 0
    },
    "button.adyen-checkout__payment-method__header__title": {
        display: "flex",
        padding: 0,
        alignItems: "stretch"
    },
    ".adyen-checkout__payment-method__name_wrapper": {
        display: "flex",
        alignItems: "stretch",
        justifyContent: "center"
    },
    ".adyen-checkout__payment-method__radio": {
        opacity: 0
    },
    ".adyen-checkout__payment-method__name": {
        lineHeight: "120%"
    },
    ".adyen-checkout__button.adyen-checkout__button--pay": (0, $lhaLc.css)({
        marginTop: 16
    }, // responsiveButtonCss("primary", "md"),
    {
        borderRadius: "100px"
    }),
    ".adyen-checkout__button__icon": {
        display: "none"
    },
    ".adyen-checkout__button__text": {
        lineHeight: "120%"
    },
    [[
        ".adyen-checkout__button:hover",
        ".adyen-checkout__button:focus",
        ".adyen-checkout__button:focus:hover"
    ].join(",")]: {
        boxShadow: "none"
    },
    ".adyen-checkout__payment-method__image__wrapper--outline:after": {
        display: "none"
    },
    ".adyen-checkout__input": {
        borderColor: $756948b644e82cf2$var$colors.gray200,
        borderWidth: 2,
        height: 48 * (0, $1c2a8fb378443a1d$export$adc5746a202ff4b),
        padding: `6px ${20 * (0, $1c2a8fb378443a1d$export$adc5746a202ff4b)}px`,
        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
        fontWeight: "300",
        WebkitFontSmoothing: "auto",
        MozOsxFontSmoothing: "auto",
        fontSmooth: "auto",
        fontSize: "16px"
    },
    "input.adyen-checkout__input::placeholder": {
        fontWeight: "300",
        color: $756948b644e82cf2$var$colors.gray300
    },
    ".adyen-checkout__input:hover": {
        borderColor: $756948b644e82cf2$var$colors.gray200,
        borderWidth: 2,
        boxShadow: "none"
    },
    ".adyen-checkout__input:focus, .adyen-checkout__input--focus": {
        borderColor: $756948b644e82cf2$var$colors.brand,
        borderStyle: "solid",
        borderWidth: 2,
        boxShadow: "none"
    },
    [[
        ".adyen-checkout__input:focus:hover",
        ".adyen-checkout__input:active",
        ".adyen-checkout__input:active:hover",
        ".adyen-checkout__input--focus:hover"
    ].join(",")]: {
        border: `2px solid ${$756948b644e82cf2$var$colors.brand}`,
        borderStyle: "solid",
        borderWidth: 2,
        borderColor: $756948b644e82cf2$var$colors.brand,
        boxShadow: "none"
    },
    ".adyen-checkout__applepay__button": {
        borderRadius: "100px"
    },
    ".adyen-checkout__label, .adyen-checkout__card__brands": {
        display: "none"
    },
    ".adyen-checkout__label__text": {
        fontSize: "16px",
        marginBottom: 8
    },
    ".adyen-checkout__label--focused .adyen-checkout__label__text": {
        color: $756948b644e82cf2$var$colors.gray500
    },
    ".adyen-checkout__card__cardNumber__brandIcon": {
        right: 16
    },
    "img.adyen-checkout__field__exp-date_hint": {
        marginRight: 0
    },
    ".adyen-checkout__field__exp-date_hint_wrapper": {
        marginRight: 0,
        right: 16
    },
    ".adyen-checkout__card__cvc__hint__wrapper": {
        marginRight: 0,
        right: 16
    },
    [[
        ".adyen-checkout__label__text--error",
        ".adyen-checkout__error-text"
    ].join(",")]: {
        color: $756948b644e82cf2$var$colors.error
    },
    ".adyen-checkout__error-text": {
        margin: 0
    },
    ".adyen-checkout__field--error .adyen-checkout__error-text": {
        marginTop: 16,
        marginBottom: 16
    },
    ".adyen-checkout__field--error .adyen-checkout__card__brands": {
        marginTop: 0
    },
    ".adyen-checkout__field--error .adyen-checkout__error-text:before": {
        display: "block",
        content: `url("data:image/svg+xml,${encodeURIComponent((0, (/*@__PURE__*/$parcel$interopDefault($5qU69))).renderToString((0, $4vwom.jsx)((0, $dc53c17a4a911fba$export$d8964aec282183a3), {
            theme: $756948b644e82cf2$export$92c840cda8ec752c,
            children: (0, $4vwom.jsx)((0, $f8cdd04128a131cf$export$f04a61298a47a40f), {
                icon: "warning",
                color: "error"
            })
        })))}")`,
        width: 24,
        height: 24,
        marginRight: 8
    },
    [[
        ".adyen-checkout__input--error",
        ".adyen-checkout__input--error:hover",
        ".adyen-checkout__input--error:active",
        ".adyen-checkout__input--error:active:hover",
        ".adyen-checkout__input--error:focus:hover",
        ".adyen-checkout__input--error--focus:hover",
        ".adyen-checkout__field--error input"
    ].join(",")]: {
        borderColor: $756948b644e82cf2$var$colors.error
    },
    [[
        ".adyen-checkout__input--valid",
        ".adyen-checkout__input--valid:hover",
        ".adyen-checkout__input--valid:active",
        ".adyen-checkout__input--valid:active:hover",
        ".adyen-checkout__input--valid:focus:hover",
        ".adyen-checkout__input--valid--focus:hover"
    ].join(",")]: {
        borderColor: $756948b644e82cf2$var$colors.forest
    },
    ".adyen-checkout__payment-method__details__content": {
        margin: 0
    },
    ".error-description": {
        display: "none"
    }
}, $756948b644e82cf2$export$92c840cda8ec752c.helpers.responsiveCss("min", "md", {
    ".adyen-checkout__input": {
        height: 64 * (0, $1c2a8fb378443a1d$export$adc5746a202ff4b)
    }
}), (0, $lhaLc.css)`
        .adyen-checkout__input {
            ${$756948b644e82cf2$export$92c840cda8ec752c.helpers.responsiveBorderRadius("sm")};
        }
    `);


var $f9a768b134f2a07e$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
function $f9a768b134f2a07e$export$6459fc9e86be362e() {
    return function Box(_a) {
        var { as: as, motion: motion, backgroundColor: backgroundColor, borderColor: borderColor, borderWidth: borderWidth, borderRadius: borderRadius, color: color, elevation: elevation, padding: padding, margin: margin, elementRef: boxRef, children: children } = _a, rest = $f9a768b134f2a07e$var$__rest(_a, [
            "as",
            "motion",
            "backgroundColor",
            "borderColor",
            "borderWidth",
            "borderRadius",
            "color",
            "elevation",
            "padding",
            "margin",
            "elementRef",
            "children"
        ]);
        const { colors: colors, helpers: helpers } = (0, $dc53c17a4a911fba$export$93d4e7f90805808f)();
        const { responsivePropCss: responsivePropCss, responsiveValueCss: responsiveValueCss, responsiveBorderRadius: responsiveBorderRadius, spacingToCss: spacingToCss } = helpers;
        const props = {
            style: rest.style,
            css: (0, $lhaLc.css)(color && {
                color: colors[color]
            }, backgroundColor && responsivePropCss(colors, "backgroundColor", backgroundColor), borderColor && {
                borderStyle: "solid",
                borderWidth: 1
            }, borderWidth && responsiveValueCss("borderWidth", borderWidth), borderColor && responsivePropCss(colors, "borderColor", borderColor), borderRadius && responsiveBorderRadius(borderRadius), padding && spacingToCss("padding", padding), margin && spacingToCss("margin", margin), elevation && (0, $756948b644e82cf2$export$4c4a64d4bfa41e73)(), rest.css)
        };
        const el = as !== null && as !== void 0 ? as : "div";
        if (typeof motion !== "undefined") return (0, $lhaLc.jsx)(typeof motion !== "undefined" ? (0, $ad7a054f4530c130$export$e25e478948902b8b)[el] : el, Object.assign(Object.assign(Object.assign(Object.assign({}, motion), rest), props), {
            ref: boxRef
        }), children);
        return (0, $lhaLc.jsx)(el, Object.assign(Object.assign(Object.assign({}, rest), props), {
            ref: boxRef
        }), children);
    };
}



var $b2ae362371ef43d7$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $b2ae362371ef43d7$var$Box = (0, $f9a768b134f2a07e$export$6459fc9e86be362e)();
function $b2ae362371ef43d7$export$88139892c6e1adf4() {
    return function Flex(_a) {
        var { direction: direction, flex: flex, basis: basis, grow: grow, shrink: shrink, alignItems: alignItems, justifyContent: justifyContent, alignSelf: alignSelf, gap: gap, children: children } = _a, rest = $b2ae362371ef43d7$var$__rest(_a, [
            "direction",
            "flex",
            "basis",
            "grow",
            "shrink",
            "alignItems",
            "justifyContent",
            "alignSelf",
            "gap",
            "children"
        ]);
        const theme = (0, $dc53c17a4a911fba$export$93d4e7f90805808f)();
        return (0, $lhaLc.jsx)($b2ae362371ef43d7$var$Box, Object.assign(Object.assign({}, rest), {
            css: (0, $lhaLc.css)({
                display: "flex",
                flex: flex,
                flexBasis: basis,
                flexGrow: grow,
                flexShrink: shrink,
                flexDirection: direction,
                alignItems: alignItems,
                justifyContent: justifyContent,
                alignSelf: alignSelf
            }, gap && theme.helpers.responsiveValueCss("gap", gap)),
            children: children
        }));
    };
}


const $6aab0c65d5445347$export$f51f4c4ede09e011 = (0, $b2ae362371ef43d7$export$88139892c6e1adf4)();




const { responsiveCss: $aace75a797ac78f1$export$cb4ef526fe7dcbbb, responsiveVariantsCss: $aace75a797ac78f1$export$716706c0ad38c83c, responsiveVariantToCss: $aace75a797ac78f1$export$d8d3ea2a3535365e, responsiveHidden: $aace75a797ac78f1$export$853675f96f4d5cc0, responsivePropCss: $aace75a797ac78f1$export$bd547c6f5ab3c0aa, responsiveValueCss: $aace75a797ac78f1$export$4842074a718b7c, responsiveSpacing: $aace75a797ac78f1$export$9c33585a37942ee0, responsiveBorderRadius: $aace75a797ac78f1$export$ae2d933239aa09a1, responsiveHeadingLevel: $aace75a797ac78f1$export$70aad56e3e56b3f3, responsiveHeadingCss: $aace75a797ac78f1$export$a7ac14f5090840b7, responsiveBodyCss: $aace75a797ac78f1$export$1da95120b6ada65d, spacingToCss: $aace75a797ac78f1$export$e402f9c533b5a526, useMediaQuery: $aace75a797ac78f1$export$32d5543ab307c01, variantCss: $aace75a797ac78f1$export$bb20750b66f96163 } = (0, $756948b644e82cf2$export$92c840cda8ec752c).helpers;


/**
 * The animation defined in the design system in Figma is set with the physical attributes
 * stiffness: 720, damping: 60, and mass: 1. This is roughly translated to the following
 * cubic-bezier function, which probably needs some adjustments, or be replaced by Framer
 * motion, where we can set the intended variables.
 */ const $7f851218870bc850$var$defaultDuration = 200;
const $7f851218870bc850$export$5cc90842f5a0bf76 = "cubic-bezier(0.4, 0, 0.2, 1)";
const $7f851218870bc850$export$c820717c055e5a6 = `all ${$7f851218870bc850$var$defaultDuration}ms ${$7f851218870bc850$export$5cc90842f5a0bf76}`;
function $7f851218870bc850$export$d5639c01d489b0c(props = [
    "all"
], duration = $7f851218870bc850$var$defaultDuration) {
    return `${props.join(" ")} ${duration}ms ${$7f851218870bc850$export$5cc90842f5a0bf76}`;
}
const $7f851218870bc850$export$f1ff28cd2162b6d5 = {
    card: {
        type: "spring",
        stiffness: 1400,
        damping: 100,
        mass: 1
    },
    carousel: {
        type: "spring",
        duration: 0.9,
        bounce: 0,
        velocity: 6
    }
};
const $7f851218870bc850$export$f4e4ad51b471de36 = {
    "200": {
        type: "spring",
        stiffness: 720,
        damping: 60,
        mass: 1
    },
    "400": {
        type: "spring",
        stiffness: 180,
        damping: 30,
        mass: 1
    },
    "600": {
        type: "spring",
        stiffness: 80,
        damping: 20,
        mass: 1
    }
};



var $4vwom = parcelRequire("4vwom");

var $lhaLc = parcelRequire("lhaLc");

var $4vwom = parcelRequire("4vwom");

var $lhaLc = parcelRequire("lhaLc");


function $ac6e084dc3a06362$export$412e0f8c020cec3() {
    return function Text(props) {
        var _a;
        const { helpers: helpers, colors: colors } = (0, $dc53c17a4a911fba$export$93d4e7f90805808f)();
        const { spacingToCss: spacingToCss, responsiveHeadingCss: responsiveHeadingCss, textCss: textCss } = helpers;
        const El = (_a = props.as) !== null && _a !== void 0 ? _a : "div";
        return (0, $4vwom.jsx)(El, {
            ref: props.elementRef,
            onClick: props.onClick,
            style: Object.assign({
                fontSize: props.fontSize
            }, props.style || {}),
            css: (0, $lhaLc.css)({
                "& a": (0, $e82ba787de72625c$export$425327af25286e5e)
            }, props.color && {
                color: colors[props.color]
            }, props.lineHeight && {
                lineHeight: props.lineHeight
            }, !!props.variant && (props.variant === "heading" ? !!props.level && responsiveHeadingCss(props.level) : props.variant && props.size ? textCss(props.variant, props.size) : undefined), typeof props.lineClamp !== "undefined" && {
                overflow: "hidden",
                display: "-webkit-box",
                WebkitLineClamp: `${props.lineClamp}`,
                lineClamp: `${props.lineClamp}`,
                textOverflow: "ellipsis",
                WebkitBoxOrient: "vertical"
            }, props.truncate && {
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                maxWidth: "100%"
            }, props.margin && spacingToCss("margin", props.margin), props.underline && (0, $e82ba787de72625c$export$425327af25286e5e)),
            className: props.className,
            children: props.children
        });
    };
}


var $38bb2c2712b5525d$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $38bb2c2712b5525d$var$RedoitText = (0, $ac6e084dc3a06362$export$412e0f8c020cec3)();
function $38bb2c2712b5525d$export$5f1af8db9871e1d6(_a) {
    var { fontWeight: fontWeight, children: children } = _a, rest = $38bb2c2712b5525d$var$__rest(_a, [
        "fontWeight",
        "children"
    ]);
    return (0, $4vwom.jsx)($38bb2c2712b5525d$var$RedoitText, Object.assign({
        css: !!fontWeight && (0, $lhaLc.css)({
            "&&": {
                fontWeight: fontWeight
            }
        })
    }, rest, {
        children: children
    }));
}



var $4vwom = parcelRequire("4vwom");

var $lhaLc = parcelRequire("lhaLc");

var $8MAXm = parcelRequire("8MAXm");

function $82d66b15b8f4758d$export$d5163f1ce1e6a5f9(props) {
    const { colors: colors, helpers: helpers } = (0, $756948b644e82cf2$export$559a0f07c8df6570)();
    const { responsiveHeadingCss: responsiveHeadingCss } = helpers;
    return (0, $4vwom.jsx)("div", {
        css: (0, $lhaLc.css)({
            "table, tr, td, th": {
                borderColor: colors.gray200,
                borderWidth: 1
            },
            table: {
                marginBottom: 16
            },
            "th, td": {
                padding: 8
            },
            th: {
                fontWeight: 500,
                backgroundColor: colors.gray100
            },
            h1: (0, $lhaLc.css)(responsiveHeadingCss(1), {
                marginTop: ".4em",
                marginBottom: ".4em"
            }),
            h2: (0, $lhaLc.css)(responsiveHeadingCss(2), {
                marginTop: ".4em",
                marginBottom: ".4em"
            }),
            h3: (0, $lhaLc.css)(responsiveHeadingCss(3), {
                marginTop: ".4em",
                marginBottom: ".4em"
            }),
            h4: (0, $lhaLc.css)(responsiveHeadingCss(4), {
                marginTop: ".4em",
                marginBottom: ".4em"
            })
        }),
        children: (0, $4vwom.jsx)((0, $8MAXm.MarkdownView), Object.assign({}, props))
    });
}



function $0273ae0bc8f90076$export$5fbe01e9406810ee(props) {
    const { colors: colors } = (0, $756948b644e82cf2$export$559a0f07c8df6570)();
    const [isOpen, setIsOpen] = (0, $eeH7J.useState)(false);
    const mouseDownX = (0, $eeH7J.useRef)(0);
    const mouseUpX = (0, $eeH7J.useRef)(0);
    const handleMouseDown = (0, $eeH7J.useCallback)((e)=>{
        mouseDownX.current = e.clientX;
    }, []);
    const handleMouseUp = (0, $eeH7J.useCallback)((e)=>{
        mouseUpX.current = e.clientX;
    }, []);
    const toggleOpen = (0, $eeH7J.useCallback)(()=>{
        // Don't open card if the click was a drag event (meaning cursor was moved between
        // mouse down and up events). May want to add some move tolerance.
        if (mouseDownX.current === mouseUpX.current) setIsOpen(!isOpen);
        mouseDownX.current = 0;
        mouseUpX.current = 0;
    }, [
        isOpen
    ]);
    return (0, $4vwom.jsx)((0, $5358b7a8389876c7$export$7fe0cbe305f29bb4), {
        children: (0, $4vwom.jsxs)((0, $ad7a054f4530c130$export$e25e478948902b8b).div, Object.assign({
            onMouseDown: handleMouseDown,
            onMouseUp: handleMouseUp,
            style: {
                overflow: "hidden"
            },
            initial: {
                paddingLeft: "0px",
                paddingRight: "0px"
            },
            animate: isOpen ? "open" : "closed",
            variants: {
                open: {
                    paddingLeft: "var(--spacing)",
                    paddingRight: "var(--spacing)"
                },
                closed: {
                    paddingLeft: "0px",
                    paddingRight: "0px"
                }
            },
            transition: (0, $7f851218870bc850$export$f4e4ad51b471de36)["200"],
            css: (0, $lhaLc.css)({
                "--top-height": "236px",
                "--bottom-height": "94px",
                "--spacing": "20px",
                "--height": "330px",
                minWidth: 240,
                width: "100%",
                height: "var(--height)",
                position: "relative"
            }, (0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("min", "md", {
                minWidth: 264,
                width: "100%",
                "--top-height": "284px",
                "--bottom-height": "94px",
                "--height": "378px"
            }), (0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("min", "xl", {
                "--top-height": "326px",
                "--bottom-height": "98px",
                "--spacing": "21px",
                "--height": "424px"
            }))
        }, isOpen ? {} : {
            onClick: toggleOpen,
            role: "button",
            "aria-label": `${props.readMoreAriaPrefix} ${props.title}`
        }, {
            children: [
                (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                    direction: "column",
                    backgroundColor: "gray100",
                    alignItems: "center",
                    justifyContent: "center",
                    borderRadius: "md",
                    css: (0, $lhaLc.css)({
                        position: "relative",
                        height: "var(--top-height)",
                        overflow: "hidden"
                    }),
                    children: [
                        props.number ? (0, $4vwom.jsx)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                            backgroundColor: "grayWhite",
                            alignItems: "center",
                            justifyContent: "center",
                            css: (0, $lhaLc.css)({
                                position: "absolute",
                                top: "var(--spacing)",
                                left: "var(--spacing)",
                                borderRadius: 24,
                                height: 36,
                                width: 36
                            }, (0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("min", "md", {
                                height: (0, $756948b644e82cf2$export$981516ee4691055c)(48),
                                width: (0, $756948b644e82cf2$export$981516ee4691055c)(48)
                            })),
                            children: (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                variant: "heading",
                                level: 4,
                                children: props.number.valueOf()
                            })
                        }) : null,
                        props.image ? (0, $4vwom.jsx)("img", {
                            draggable: "false",
                            src: (0, $14q7s.FileToUrl)(props.image),
                            style: {
                                height: "100%",
                                width: "100%",
                                objectFit: "cover",
                                objectPosition: "center"
                            }
                        }) : null
                    ]
                }),
                (0, $4vwom.jsx)((0, $ad7a054f4530c130$export$e25e478948902b8b).div, {
                    animate: isOpen ? "open" : "closed",
                    variants: {
                        open: {
                            height: `calc(100% - ${(0, $756948b644e82cf2$export$981516ee4691055c)(20)}`
                        },
                        closed: {
                            height: "var(--bottom-height)"
                        }
                    },
                    transition: (0, $7f851218870bc850$export$f4e4ad51b471de36)["200"],
                    onClick: isOpen ? toggleOpen : undefined,
                    css: (0, $lhaLc.css)({
                        backgroundColor: colors.gray500,
                        display: "flex",
                        flexDirection: "column",
                        position: "absolute",
                        cursor: "pointer",
                        bottom: 0,
                        left: 0,
                        right: 0
                    }, (0, $aace75a797ac78f1$export$ae2d933239aa09a1)("md")),
                    children: (0, $4vwom.jsxs)("div", {
                        css: (0, $lhaLc.css)({
                            padding: "var(--spacing)",
                            height: "var(--bottom-height)"
                        }),
                        children: [
                            (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                                color: "grayWhite",
                                justifyContent: "space-between",
                                alignItems: isOpen ? "flex-start" : "center",
                                flex: `0 0 ${isOpen ? "auto" : 60}px`,
                                css: (0, $lhaLc.css)({
                                    height: isOpen ? "auto" : "100%"
                                }),
                                children: [
                                    (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                        variant: "heading",
                                        level: [
                                            "fixed",
                                            "lg",
                                            4
                                        ],
                                        lineClamp: 3,
                                        children: props.title
                                    }),
                                    (0, $4vwom.jsx)((0, $f8cdd04128a131cf$export$f04a61298a47a40f), {
                                        icon: "plus",
                                        margin: {
                                            left: 12
                                        },
                                        style: {
                                            flex: "0 0 auto",
                                            transform: `rotate(${isOpen ? 45 : 0}deg)`,
                                            transition: (0, $7f851218870bc850$export$c820717c055e5a6)
                                        }
                                    })
                                ]
                            }),
                            (0, $4vwom.jsx)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                                css: (0, $lhaLc.css)({
                                    paddingTop: "var(--spacing)",
                                    opacity: isOpen ? 0.8 : 0,
                                    transition: (0, $7f851218870bc850$export$d5639c01d489b0c)([
                                        "opacity"
                                    ], 200)
                                }),
                                children: (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                    variant: "body",
                                    size: [
                                        "fixed",
                                        "lg",
                                        "md"
                                    ],
                                    color: "grayWhite",
                                    as: "div",
                                    children: (0, $4vwom.jsx)((0, $82d66b15b8f4758d$export$d5163f1ce1e6a5f9), {
                                        value: props.text
                                    })
                                })
                            })
                        ]
                    })
                })
            ]
        }))
    });
}
(0, $eSiQ2.Component)($0273ae0bc8f90076$export$5fbe01e9406810ee, {
    name: "WithOverlayCard",
    gallery: {
        path: "Cards/WithOverlayCard",
        items: [
            {
                title: "Card with overlay",
                variants: [
                    {
                        props: {
                            number: (0, $fR074.NonNegativeInteger)(1),
                            title: "Velg hvilken telefon du vil leie",
                            text: (0, $gGZ2r.Markdown)("Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat."),
                            image: `${(0, $7m9cQ.server)()}/static/redoit/how-it-works-card-illustration-1.svg`,
                            readMoreAriaPrefix: `Read more about`,
                            runningAnimation: true
                        }
                    },
                    {
                        props: {
                            number: (0, $fR074.NonNegativeInteger)(2),
                            title: "Velg hvilken telefon du vil leie",
                            text: (0, $gGZ2r.Markdown)("Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur."),
                            image: `${(0, $7m9cQ.server)()}/static/redoit/how-it-works-card-illustration-2.svg`,
                            readMoreAriaPrefix: `Read more about`
                        }
                    },
                    {
                        props: {
                            number: (0, $fR074.NonNegativeInteger)(3),
                            title: "Velg hvilken telefon du vil leie",
                            text: (0, $gGZ2r.Markdown)("Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum."),
                            image: `${(0, $7m9cQ.server)()}/static/redoit/how-it-works-card-illustration-3.svg`,
                            readMoreAriaPrefix: `Read more about`
                        }
                    }
                ]
            }
        ]
    }
});



var $4vwom = parcelRequire("4vwom");

var $eeH7J = parcelRequire("eeH7J");

var $eeH7J = parcelRequire("eeH7J");

function $b93688f4b1374f47$export$90ceba2564a894f8(elements, scope, selectorCache) {
    var _a;
    if (typeof elements === "string") {
        let root = document;
        if (scope) {
            (0, $2b9100c03bd61cb5$export$f5708dca728d7177)(Boolean(scope.current), "Scope provided, but no element detected.");
            root = scope.current;
        }
        if (selectorCache) {
            (_a = selectorCache[elements]) !== null && _a !== void 0 ? _a : selectorCache[elements] = root.querySelectorAll(elements);
            elements = selectorCache[elements];
        } else elements = root.querySelectorAll(elements);
    } else if (elements instanceof Element) elements = [
        elements
    ];
    /**
     * Return an empty array
     */ return Array.from(elements || []);
}


const $2ffb79a4f9b32f4b$var$thresholds = {
    some: 0,
    all: 1
};
function $2ffb79a4f9b32f4b$export$acb1e9cb9ce4ca56(elementOrSelector, onStart, { root: root, margin: rootMargin, amount: amount = "some" } = {}) {
    const elements = (0, $b93688f4b1374f47$export$90ceba2564a894f8)(elementOrSelector);
    const activeIntersections = new WeakMap();
    const onIntersectionChange = (entries)=>{
        entries.forEach((entry)=>{
            const onEnd = activeIntersections.get(entry.target);
            /**
             * If there's no change to the intersection, we don't need to
             * do anything here.
             */ if (entry.isIntersecting === Boolean(onEnd)) return;
            if (entry.isIntersecting) {
                const newOnEnd = onStart(entry);
                if (typeof newOnEnd === "function") activeIntersections.set(entry.target, newOnEnd);
                else observer.unobserve(entry.target);
            } else if (onEnd) {
                onEnd(entry);
                activeIntersections.delete(entry.target);
            }
        });
    };
    const observer = new IntersectionObserver(onIntersectionChange, {
        root: root,
        rootMargin: rootMargin,
        threshold: typeof amount === "number" ? amount : $2ffb79a4f9b32f4b$var$thresholds[amount]
    });
    elements.forEach((element)=>observer.observe(element));
    return ()=>observer.disconnect();
}


function $3e2475e44b27c8d2$export$2f62ee6831462844(ref, { root: root, margin: margin, amount: amount, once: once = false } = {}) {
    const [isInView, setInView] = (0, $eeH7J.useState)(false);
    (0, $eeH7J.useEffect)(()=>{
        if (!ref.current || once && isInView) return;
        const onEnter = ()=>{
            setInView(true);
            return once ? undefined : ()=>setInView(false);
        };
        const options = {
            root: root && root.current || undefined,
            margin: margin,
            amount: amount
        };
        return (0, $2ffb79a4f9b32f4b$export$acb1e9cb9ce4ca56)(ref.current, onEnter, options);
    }, [
        root,
        ref,
        margin,
        once,
        amount
    ]);
    return isInView;
}



var $lhaLc = parcelRequire("lhaLc");



var $eSiQ2 = parcelRequire("eSiQ2");

var $4vwom = parcelRequire("4vwom");

var $lhaLc = parcelRequire("lhaLc");


var $31d9e20b147e8c7e$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
function $31d9e20b147e8c7e$export$219d2fdcce27358d() {
    return function Heading(_a) {
        var { level: level, color: color, margin: margin, padding: padding, truncate: truncate, children: children } = _a, rest = $31d9e20b147e8c7e$var$__rest(_a, [
            "level",
            "color",
            "margin",
            "padding",
            "truncate",
            "children"
        ]);
        const HeadingTag = `h${level}`;
        const { helpers: helpers, colors: colors } = (0, $dc53c17a4a911fba$export$93d4e7f90805808f)();
        const { spacingToCss: spacingToCss, responsiveHeadingLevel: responsiveHeadingLevel } = helpers;
        return (0, $4vwom.jsx)(HeadingTag, Object.assign({
            css: (0, $lhaLc.css)((0, $e82ba787de72625c$export$6b6f359a824920a4)(HeadingTag), {
                "& a": (0, $e82ba787de72625c$export$425327af25286e5e)
            }, responsiveHeadingLevel(level), truncate && {
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap"
            }, color && {
                color: colors[color]
            }, margin && spacingToCss("margin", margin), padding && spacingToCss("padding", padding))
        }, rest, {
            children: children
        }));
    };
}


const $789b8639be592288$export$a8a3e93435678ff9 = (0, $31d9e20b147e8c7e$export$219d2fdcce27358d)();
(0, $eSiQ2.Component)($789b8639be592288$export$a8a3e93435678ff9, {
    name: "Heading",
    gallery: {
        path: "Typography/Heading",
        about: "Using headers to organize and arrange designs in Figma is a great way to visually group components, while providing space for notes and context.",
        items: [
            {
                title: "Title 1",
                variants: [
                    {
                        props: {
                            level: 1,
                            children: "Hello, world!"
                        }
                    }
                ]
            },
            {
                title: "Title 2",
                variants: [
                    {
                        props: {
                            level: 2,
                            children: "The new wave"
                        }
                    }
                ]
            },
            {
                title: "Title 3",
                variants: [
                    {
                        props: {
                            level: 3,
                            children: "We take on the complexities of leasing"
                        }
                    }
                ]
            }
        ]
    }
});



var $4vwom = parcelRequire("4vwom");

var $lhaLc = parcelRequire("lhaLc");

var $eeH7J = parcelRequire("eeH7J");

var $lhaLc = parcelRequire("lhaLc");

var $f301b516e89c5a3f$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
function $f301b516e89c5a3f$export$9b6d6ca62970729f() {
    return function Button(_a) {
        var { as: as, variant: variant, size: size, onClick: onClick, margin: margin, fullwidth: fullwidth, children: children, elementRef: elementRef, className: className } = _a, rest = $f301b516e89c5a3f$var$__rest(_a, [
            "as",
            "variant",
            "size",
            "onClick",
            "margin",
            "fullwidth",
            "children",
            "elementRef",
            "className"
        ]);
        const { helpers: helpers, buttonSizes: buttonSizes, buttonVariants: buttonVariants } = (0, $dc53c17a4a911fba$export$93d4e7f90805808f)();
        const { variantCss: variantCss, responsiveVariantsCss: responsiveVariantsCss, spacingToCss: spacingToCss } = helpers;
        const buttonCss = (0, $lhaLc.css)([
            variantCss(buttonVariants, variant),
            margin && spacingToCss("margin", margin),
            responsiveVariantsCss(buttonSizes, size),
            {
                width: fullwidth ? "100%" : "auto"
            }
        ]);
        const ref = elementRef !== null && elementRef !== void 0 ? elementRef : /*#__PURE__*/ (0, $eeH7J.createRef)();
        const handleClick = (0, $eeH7J.useCallback)((e)=>{
            var _a;
            onClick === null || onClick === void 0 || onClick(e);
            (_a = ref.current) === null || _a === void 0 || _a.blur();
        }, [
            onClick,
            ref
        ]);
        const commonProps = Object.assign({
            css: buttonCss,
            onClick: handleClick,
            className: className ? className : "",
            disabled: rest.disabled
        }, rest);
        // TODO: Render as <Link to={props.href} /> if as === "a". Only problem is ref type error.
        const El = as !== null && as !== void 0 ? as : "button";
        return (0, $lhaLc.jsx)(El, Object.assign(Object.assign(Object.assign({}, rest), commonProps), {
            ref: ref
        }), children);
    };
}




var $4b4086f8a1c6b2f8$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $4b4086f8a1c6b2f8$export$f67fb575035cc7d0 = (0, $f301b516e89c5a3f$export$9b6d6ca62970729f)();
function $4b4086f8a1c6b2f8$export$353f5b6fc5456de1(_a) {
    var { iconStart: iconStart, iconEnd: iconEnd, selected: selected, children: children, variant: variant, size: size } = _a, rest = $4b4086f8a1c6b2f8$var$__rest(_a, [
        "iconStart",
        "iconEnd",
        "selected",
        "children",
        "variant",
        "size"
    ]);
    const c = (0, $lhaLc.css)({
        borderWidth: size === "md" ? 2 : 1,
        width: rest.fullwidth ? "100%" : "auto"
    }, // Icon only buttons should be circular, so just remove all x padding and ensure
    // width === height using aspect-ratio. && ensures higher specificity than the default
    // styles for the Button.
    // TODO: Auto prefix incoming css to base Button component with &&.
    !children && {
        "&&": {
            paddingLeft: 0,
            paddingRight: 0,
            aspectRatio: "1"
        }
    }, (0, $aace75a797ac78f1$export$70aad56e3e56b3f3)("4"));
    return (0, $4vwom.jsxs)($4b4086f8a1c6b2f8$export$f67fb575035cc7d0, Object.assign({
        css: c,
        "data-selected": !!selected,
        size: size !== null && size !== void 0 ? size : "md",
        variant: variant !== null && variant !== void 0 ? variant : "primary"
    }, rest, {
        children: [
            iconStart && (0, $4vwom.jsx)((0, $f8cdd04128a131cf$export$f04a61298a47a40f), {
                icon: iconStart
            }),
            children,
            iconEnd && (0, $4vwom.jsx)((0, $f8cdd04128a131cf$export$f04a61298a47a40f), {
                icon: iconEnd
            })
        ]
    }));
}



var $4vwom = parcelRequire("4vwom");

var $eeH7J = parcelRequire("eeH7J");

var $7m9cQ = parcelRequire("7m9cQ");
parcelRequire("2LTO8");
var $gGZ2r = parcelRequire("gGZ2r");

var $eSiQ2 = parcelRequire("eSiQ2");


var $lhaLc = parcelRequire("lhaLc");
const $62fa897e2e43b923$export$962d61ddac85577e = /*#__PURE__*/ (0, $eeH7J.forwardRef)(function CardsCarousel(props, ref) {
    const dragContainerRef = (0, $eeH7J.useRef)(null);
    const cardsContainerRef = (0, $eeH7J.useRef)(null);
    const cardsRef = (0, $eeH7J.useRef)(props.items.map(()=>/*#__PURE__*/ (0, $eeH7J.createRef)()));
    const scrollContainerRef = (0, $eeH7J.useRef)(null);
    const [position, setPosition] = (0, $eeH7J.useState)({
        atStart: true,
        atEnd: false
    });
    // Returns a set of DOMRects used frequently in the component.
    function getRects() {
        var _a, _b, _c, _d, _e, _f;
        const container = (_a = dragContainerRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
        const grid = (_b = cardsContainerRef.current) === null || _b === void 0 ? void 0 : _b.getBoundingClientRect();
        const firstCard = (_d = (_c = cardsRef.current[0]) === null || _c === void 0 ? void 0 : _c.current) === null || _d === void 0 ? void 0 : _d.getBoundingClientRect();
        const lastCard = (_f = (_e = cardsRef.current[cardsRef.current.length - 1]) === null || _e === void 0 ? void 0 : _e.current) === null || _f === void 0 ? void 0 : _f.getBoundingClientRect();
        if (!container || !grid || !firstCard || !lastCard) {
            // eslint-disable-next-line no-console
            console.warn("Missing reference to container, card, or grid.");
            return;
        }
        return {
            container: container,
            grid: grid,
            firstCard: firstCard,
            lastCard: lastCard
        };
    }
    const updatePosition = (0, $eeH7J.useCallback)(()=>{
        const rects = getRects();
        if (!rects || !scrollContainerRef.current) return;
        const newPosition = {
            atStart: Math.floor(scrollContainerRef.current.scrollLeft) === 0,
            atEnd: Math.floor(scrollContainerRef.current.scrollWidth - scrollContainerRef.current.scrollLeft - rects.container.width) === 0
        };
        if (newPosition.atStart === position.atStart && newPosition.atEnd === position.atEnd) return;
        setPosition(newPosition);
    }, [
        position,
        setPosition
    ]);
    const handleScrollEnd = (0, $eeH7J.useCallback)(()=>{
        updatePosition();
    }, [
        updatePosition
    ]);
    (0, $eeH7J.useEffect)(()=>{
        const currentScrollContainerRef = scrollContainerRef.current;
        if (currentScrollContainerRef) {
            currentScrollContainerRef.addEventListener("scrollend", handleScrollEnd);
            return ()=>{
                currentScrollContainerRef.removeEventListener("scrollend", handleScrollEnd);
            };
        }
    }, [
        handleScrollEnd
    ]);
    // Call onPositionChange when position changes.
    (0, $eeH7J.useEffect)(()=>{
        var _a;
        (_a = props.onPositionChange) === null || _a === void 0 || _a.call(props, position);
    }, [
        position,
        props
    ]);
    // Ref functions that allow other components consuming this one to trigger next/prev switch.
    (0, $eeH7J.useImperativeHandle)(ref, ()=>({
            next () {
                handleSlideClick("next");
            },
            prev () {
                handleSlideClick("prev");
            }
        }));
    const debouncedUpdatePosition = (0, $eeH7J.useMemo)(()=>$62fa897e2e43b923$var$debounce(updatePosition, 500), [
        updatePosition
    ]);
    (0, $eeH7J.useEffect)(()=>{
        // The intersection observer is used to observe when any of the cards intersect with
        // the container.
        const intersectionObserver = new IntersectionObserver(debouncedUpdatePosition, {
            root: dragContainerRef.current,
            rootMargin: "0px",
            threshold: 1.0
        });
        for (const c of cardsRef.current)if (c.current) intersectionObserver.observe(c.current);
        // We need the mutation observer to observe for changes in position controlled by style
        // attribute of child elements. Because of that it's difficult to trigger in a better way.
        const mutationObserver = new MutationObserver(debouncedUpdatePosition);
        if (cardsContainerRef.current) mutationObserver.observe(cardsContainerRef.current, {
            attributes: true,
            subtree: true
        });
        return ()=>{
            mutationObserver.disconnect();
            intersectionObserver.disconnect();
        };
    }, [
        debouncedUpdatePosition
    ]);
    // Just copied from CardsBlock, probably a good candidate for rafactoring.
    const handleSlideClick = (0, $eeH7J.useCallback)((direction)=>{
        if (!dragContainerRef.current) return;
        // Direction is the direction the cards will slide in, which is the opposite of the way the
        // arrow on the button is pointing.
        const slideDirection = direction === "prev" ? "right" : "left";
        const containerRect = dragContainerRef.current.getBoundingClientRect();
        try {
            // Find first card that is partially on the inside and partially on the outside of
            // container. Or the card before a card that is just inside the container This is
            // the card we'll want to move to the edge of the container.
            const nextCardIndex = cardsRef.current.findIndex((item, index)=>{
                var _a, _b, _c;
                const itemRect = (_a = item.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
                if (!itemRect) throw new Error(`No element for card item at index ${index}.`);
                if (slideDirection === "left") return itemRect.right > containerRect.right;
                else {
                    const nextRect = (_c = (_b = cardsRef.current[index + 1]) === null || _b === void 0 ? void 0 : _b.current) === null || _c === void 0 ? void 0 : _c.getBoundingClientRect();
                    if (!nextRect) return true;
                    return(// If the next card is on the edge of the container, this is the next.
                    itemRect.left < containerRect.left && Math.round(nextRect.left) === Math.round(containerRect.left) || // Left edge of element is outside, but has right edge inside container
                    itemRect.left < containerRect.left && itemRect.right > containerRect.left || // Entire element is outside, but next is inside, return this
                    itemRect.left < containerRect.left && nextRect.left >= containerRect.left);
                }
            });
            const nextCard = cardsRef.current[nextCardIndex];
            // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
            if (nextCard === null || nextCard === void 0 ? void 0 : nextCard.current) nextCard.current.scrollIntoView({
                behavior: "smooth",
                block: "nearest",
                inline: nextCardIndex === props.items.length - 1 ? "end" : "start"
            });
        } catch (err) {
            //eslint-disable-next-line no-console
            console.warn(err);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return (0, $4vwom.jsx)("div", {
        ref: dragContainerRef,
        children: (0, $4vwom.jsx)("div", {
            ref: cardsContainerRef,
            children: props.renderContainer(props.items.map((item, index)=>(0, $4vwom.jsx)("div", {
                    ref: cardsRef.current[index],
                    css: (0, $lhaLc.css)({
                        scrollSnapAlign: index === props.items.length - 1 ? "end" : "start"
                    }),
                    children: props.renderItem(item, index)
                }, index)), scrollContainerRef)
        })
    });
});
const $62fa897e2e43b923$var$arr = [
    ...new Array(3)
].map(()=>"Hello, World!");
(0, $eSiQ2.Component)($62fa897e2e43b923$export$962d61ddac85577e, {
    name: "CardsCarousel",
    gallery: {
        items: [
            {
                variants: [
                    {
                        props: {
                            items: $62fa897e2e43b923$var$arr,
                            renderContainer: (children)=>(0, $4vwom.jsx)("div", {
                                    style: {
                                        display: "grid",
                                        gridAutoFlow: "column",
                                        gap: 16,
                                        gridAutoColumns: "min-content"
                                    },
                                    children: children
                                }),
                            renderItem: (_, index)=>(0, $4vwom.jsx)((0, $0273ae0bc8f90076$export$5fbe01e9406810ee), {
                                    title: `Hello ${index}${index}${index}${index}`,
                                    text: (0, $gGZ2r.Markdown)(`${index}`),
                                    image: `${(0, $7m9cQ.server)()}/static/redoit/how-it-works-card-illustration-3.svg`,
                                    readMoreAriaPrefix: "Read more"
                                })
                        }
                    }
                ]
            }
        ]
    }
});
function $62fa897e2e43b923$var$debounce(callback, wait) {
    let timeoutId;
    return (...args)=>{
        if (typeof window === "undefined") callback(...args);
        window.clearTimeout(timeoutId);
        timeoutId = window.setTimeout(()=>{
            callback(...args);
        }, wait);
    };
}




const $8160ea1f3816c70f$var$GRID_COLUMN_COUNT = 4;
function $8160ea1f3816c70f$export$e0b2a4a0e3a11a62(props) {
    const { responsiveCss: responsiveCss, helpers: helpers, screenSizes: screenSizes } = (0, $756948b644e82cf2$export$559a0f07c8df6570)();
    const { responsiveSpacing: responsiveSpacing } = helpers;
    const containerRef = (0, $eeH7J.useRef)(null);
    const isInView = (0, $3e2475e44b27c8d2$export$2f62ee6831462844)(containerRef, {
        once: true,
        amount: 0.25
    });
    const [position, setPosition] = (0, $eeH7J.useState)({
        atStart: true,
        atEnd: false
    });
    const carouselBaseRef = (0, $eeH7J.useRef)(null);
    return (0, $4vwom.jsxs)("div", {
        ref: containerRef,
        css: (0, $lhaLc.css)({
            display: "flex",
            flexDirection: "column"
        }, (0, $756948b644e82cf2$export$f1cf1885b6bfef23)()),
        children: [
            (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                alignItems: "center",
                justifyContent: "space-between",
                css: (0, $lhaLc.css)({
                    marginBottom: 16
                }, responsiveCss("min", "md", {
                    marginBottom: 24
                })),
                children: [
                    (0, $4vwom.jsx)((0, $789b8639be592288$export$a8a3e93435678ff9), {
                        level: 2,
                        padding: {
                            y: 8
                        },
                        truncate: true,
                        children: props.heading
                    }),
                    props.showSlideButtons && (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                        shrink: 0,
                        margin: {
                            left: 16
                        },
                        children: [
                            (0, $4vwom.jsx)((0, $4b4086f8a1c6b2f8$export$353f5b6fc5456de1), {
                                size: "sm",
                                variant: "secondary",
                                iconStart: "chevronLeft",
                                margin: {
                                    right: 4
                                },
                                disabled: position.atStart,
                                onClick: ()=>{
                                    var _a;
                                    return (_a = carouselBaseRef.current) === null || _a === void 0 ? void 0 : _a.prev();
                                }
                            }),
                            (0, $4vwom.jsx)((0, $4b4086f8a1c6b2f8$export$353f5b6fc5456de1), {
                                size: "sm",
                                variant: "secondary",
                                iconStart: "chevronRight",
                                disabled: position.atEnd,
                                onClick: ()=>{
                                    var _a;
                                    return (_a = carouselBaseRef.current) === null || _a === void 0 ? void 0 : _a.next();
                                }
                            })
                        ]
                    })
                ]
            }),
            (0, $4vwom.jsx)("div", {
                css: responsiveSpacing("sm", "--gap"),
                style: {
                    overflow: "hidden",
                    width: "100vw",
                    marginLeft: "calc(50% - 50vw)"
                },
                children: (0, $4vwom.jsx)((0, $62fa897e2e43b923$export$962d61ddac85577e), {
                    ref: carouselBaseRef,
                    onPositionChange: (p)=>{
                        if (p.atStart !== position.atStart || p.atEnd !== position.atEnd) setPosition(p);
                    },
                    items: props.cards,
                    renderContainer: (children, scrollContainerRef)=>(0, $4vwom.jsx)((0, $ad7a054f4530c130$export$e25e478948902b8b).div, {
                            ref: scrollContainerRef,
                            style: {
                                overflowX: "scroll",
                                scrollSnapType: "x mandatory",
                                scrollbarWidth: "none"
                            },
                            css: (0, $lhaLc.css)((0, $lhaLc.css)`
                                --padding-inline: ${(0, $1c2a8fb378443a1d$export$a9ddfd01863914a9).xs.paddingLeft}px;
                                @media (min-width: ${screenSizes.md}px) {
                                    --padding-inline: ${(0, $1c2a8fb378443a1d$export$a9ddfd01863914a9).md.paddingLeft}px;
                                }
                                @media (min-width: ${(0, $1c2a8fb378443a1d$export$a9ddfd01863914a9).xs.maxWidth}px) {
                                    --padding-inline: calc(
                                        ((100vw - ${(0, $1c2a8fb378443a1d$export$a9ddfd01863914a9).xs.maxWidth}px) / 2) +
                                            ${(0, $1c2a8fb378443a1d$export$a9ddfd01863914a9).md.paddingLeft}px
                                    );
                                }
                                min-width: 100%;
                                padding: 0 var(--padding-inline);
                                scroll-padding: 0 var(--padding-inline);
                                &::-webkit-scrollbar {
                                    display: none;
                                }
                                display: grid;
                                grid-auto-flow: column;
                                grid-auto-columns: minmax(min-content, 1fr);
                                @media (min-width: ${screenSizes.md}px) {
                                    grid-auto-columns: calc(
                                        calc(
                                                ${(0, $1c2a8fb378443a1d$export$a9ddfd01863914a9).xs.maxWidth}px -
                                                    ${(0, $1c2a8fb378443a1d$export$a9ddfd01863914a9).md.paddingLeft}px -
                                                    ${(0, $1c2a8fb378443a1d$export$a9ddfd01863914a9).md.paddingRight}px - calc(
                                                        var(--gap) * ${$8160ea1f3816c70f$var$GRID_COLUMN_COUNT - 1}
                                                    )
                                            ) / ${$8160ea1f3816c70f$var$GRID_COLUMN_COUNT}
                                    );
                                }
                            `),
                            initial: {
                                transform: "translateX(200px)",
                                gap: "64px",
                                opacity: 0
                            },
                            animate: (isInView || !props.enterAnimation) && {
                                transform: "translateX(0px)",
                                gap: "var(--gap)",
                                opacity: 1
                            },
                            transition: props.enterAnimation ? (0, $7f851218870bc850$export$f4e4ad51b471de36)["600"] : {
                                duration: 0
                            },
                            children: children
                        }),
                    renderItem: props.renderCard
                })
            })
        ]
    });
}


/**
 * Shows a set of cards side by side which the user can click to get more info about something.
 *
 * @icon ui-info-square
 */ function $8e58be2eee2f201e$var$CardsWithMoreInfo(section) {
    const localize = (0, $aIeEI.useLocalize)();
    return (0, $4vwom.jsx)((0, $8160ea1f3816c70f$export$e0b2a4a0e3a11a62), {
        heading: localize(section.heading),
        showSlideButtons: true,
        cards: section.cards.map((c)=>Object.assign(Object.assign({}, c), {
                id: c.id.valueOf()
            })),
        enterAnimation: true,
        renderCard: (c, i)=>(0, $4vwom.jsx)((0, $0273ae0bc8f90076$export$5fbe01e9406810ee), {
                title: localize(c.heading),
                text: localize(c.text),
                image: c.image,
                number: section.showCardNumber ? (0, $fR074.NonNegativeInteger)(i + 1) : undefined,
                readMoreAriaPrefix: localize(section.readMoreAriaPrefix),
                runningAnimation: i === 0
            })
    });
}
(0, $9G56J.Section)($8e58be2eee2f201e$var$CardsWithMoreInfo);



var $4vwom = parcelRequire("4vwom");

var $9G56J = parcelRequire("9G56J");

var $aIeEI = parcelRequire("aIeEI");

var $dUDPg = parcelRequire("dUDPg");

var $aIeEI = parcelRequire("aIeEI");
function $2e171bb7176b2346$export$3e75343ff9861e57(pageIds) {
    var _a, _b;
    const pagesInfos = (0, $dUDPg.useWebPagesInfos)({
        ids: pageIds
    });
    const localize = (0, $aIeEI.useLocalize)();
    const currentLocale = (0, $aIeEI.useCurrentLocale)();
    const defaultLocale = (_a = (0, $dUDPg.useDefaultLocale)().data) === null || _a === void 0 ? void 0 : _a.defaultLocale;
    const localePath = currentLocale === defaultLocale ? "" : `/${currentLocale}`;
    const paths = (_b = pagesInfos.data) === null || _b === void 0 ? void 0 : _b.map((item)=>!item ? item : {
            title: localize(item.title),
            path: item.slug ? `${localePath}/${localize(item.slug)}` : "/"
        });
    return paths;
}



var $4vwom = parcelRequire("4vwom");

var $eeH7J = parcelRequire("eeH7J");

var $lhaLc = parcelRequire("lhaLc");


var $7m9cQ = parcelRequire("7m9cQ");

var $eSiQ2 = parcelRequire("eSiQ2");

const $bee1a5e35c892a21$export$e71c4d32a2263218 = (0, $f9a768b134f2a07e$export$6459fc9e86be362e)();




var $eSiQ2 = parcelRequire("eSiQ2");

var $4vwom = parcelRequire("4vwom");

var $lhaLc = parcelRequire("lhaLc");


function $01e320efe3155383$export$1cade971dfb58d96() {
    return function Body(props) {
        const { colors: colors, helpers: helpers } = (0, $dc53c17a4a911fba$export$93d4e7f90805808f)();
        const { responsiveBodyCss: responsiveBodyCss } = helpers;
        return (0, $4vwom.jsx)("p", {
            css: (0, $lhaLc.css)((0, $e82ba787de72625c$export$6b6f359a824920a4)("p"), {
                "& a": (0, $e82ba787de72625c$export$425327af25286e5e)
            }, responsiveBodyCss(props.size), props.color && {
                color: colors[props.color]
            }, props.truncate && {
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                maxWidth: "100%"
            }, props.margin && helpers.spacingToCss("margin", props.margin), props.underline && (0, $e82ba787de72625c$export$425327af25286e5e), typeof props.opacity === "number" && {
                opacity: props.opacity
            }),
            style: Object.assign({}, props.style || {}),
            children: props.children
        });
    };
}


const $72c5ae9e0017e167$export$4b2c32e08f77ff18 = (0, $01e320efe3155383$export$1cade971dfb58d96)();
(0, $eSiQ2.Component)($72c5ae9e0017e167$export$4b2c32e08f77ff18, {
    name: "Body",
    gallery: {
        path: "Typography/Body",
        items: [
            {
                variants: [
                    {
                        props: {
                            size: "md",
                            children: "Hello, world!"
                        }
                    }
                ]
            },
            {
                title: "Fixed size",
                variants: [
                    {
                        props: {
                            size: [
                                "fixed",
                                "md",
                                "md"
                            ],
                            children: "Hello, world!"
                        }
                    }
                ]
            },
            {
                title: "Media Query Responsive Sizes",
                variants: [
                    {
                        props: {
                            size: [
                                "lg",
                                [
                                    "min",
                                    "md",
                                    "xs"
                                ]
                            ],
                            children: "Hello, world!"
                        }
                    }
                ]
            },
            {
                variants: [
                    {
                        props: {
                            size: "lg",
                            children: "Our mission is to accelerate the transition to a circular economy. Consumers and retailers will only make that transition if it is cost effective and simple. That's where we come in. Our technology platform enables the lease-and-reuse of consumer goods, which makes them more sustainable, accessible and affordable."
                        }
                    }
                ]
            }
        ]
    }
});







var $4vwom = parcelRequire("4vwom");

var $lhaLc = parcelRequire("lhaLc");
parcelRequire("2LTO8");
var $14q7s = parcelRequire("14q7s");
var $6a1a23ca93758ec8$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
function $6a1a23ca93758ec8$export$686e15a6b88a698c(props) {
    const { image: image, width: width } = props, rest = $6a1a23ca93758ec8$var$__rest(props, [
        "image",
        "width"
    ]);
    return (0, $4vwom.jsx)("img", Object.assign({
        srcSet: [
            1,
            1.5,
            2,
            3
        ].map((x)=>`${(0, $14q7s.ImageToUrl)(image, {
                width: Math.ceil(width * x),
                format: props.format
            })} ${x}x`).join(", "),
        src: (0, $14q7s.ImageToUrl)(props.image, {
            width: width
        })
    }, rest));
}
function $6a1a23ca93758ec8$export$8b235cefb9710a9e(props) {
    return (0, $lhaLc.css)([
        1,
        1.5,
        2,
        3
    ].map((x)=>({
            [`@media (min-resolution: ${x}dppx)`]: {
                backgroundImage: `url('${(0, $14q7s.ImageToUrl)(props.image, {
                    width: Math.ceil(props.width * x),
                    format: props.format
                })}')`
            }
        })));
}



const $5f9967f24e231168$var$progress = (0, $lhaLc.keyframes)({
    from: {
        width: "0%"
    },
    to: {
        width: "100%"
    }
});
function $5f9967f24e231168$export$df5a8e831e8fbbb0(props) {
    var _a;
    const { colors: colors } = (0, $756948b644e82cf2$export$559a0f07c8df6570)();
    const timePerSlide = props.timePerSlide || 5000;
    const [currentIndex, setCurrentIndex] = (0, $eeH7J.useState)(0);
    const [isPaused, setIsPaused] = (0, $eeH7J.useState)(false);
    const [panned, setPanned] = (0, $eeH7J.useState)(0);
    const [isPanning, setIsPanning] = (0, $eeH7J.useState)(false);
    // Used to temporary disable animations when resetting to index 0 from extra last slide
    const slideAnimationDisabled = (0, $eeH7J.useRef)(false);
    const touchPanStartX = (0, $eeH7J.useRef)(null);
    const carouselRef = (0, $eeH7J.useRef)(null);
    const carouselWidth = (_a = carouselRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect().width;
    const currentTheme = (0, $eeH7J.useMemo)(()=>{
        var _a;
        return (_a = props.slides[currentIndex]) === null || _a === void 0 ? void 0 : _a.theme;
    }, [
        currentIndex,
        props.slides
    ]);
    const xOffset = (0, $eeH7J.useMemo)(()=>{
        return `-${currentIndex * 100}%`;
    }, [
        currentIndex
    ]);
    const goToNext = (0, $eeH7J.useCallback)(()=>{
        slideAnimationDisabled.current = false;
        if (currentIndex + 1 === props.slides.length) setCurrentIndex(0);
        else setCurrentIndex(currentIndex + 1);
    }, [
        currentIndex,
        props.slides.length
    ]);
    const handleTouchStart = (0, $eeH7J.useCallback)((e)=>{
        var _a, _b;
        if (props.slides.length > 1) {
            setIsPanning(true);
            touchPanStartX.current = (_b = (_a = e.touches[0]) === null || _a === void 0 ? void 0 : _a.clientX) !== null && _b !== void 0 ? _b : null;
            e.stopPropagation();
        }
    }, [
        props.slides.length
    ]);
    const handleTouchMove = (0, $eeH7J.useCallback)((e)=>{
        var _a, _b, _c;
        if (touchPanStartX.current) {
            // No need to update for changes < than a pixel, so floor before checking if moved
            const offset = (_c = Math.floor((touchPanStartX.current - ((_b = (_a = e.touches[0]) === null || _a === void 0 ? void 0 : _a.clientX) !== null && _b !== void 0 ? _b : 0)) * -1)) !== null && _c !== void 0 ? _c : null;
            if (panned !== offset) setPanned(offset);
        }
        e.stopPropagation();
    }, [
        panned
    ]);
    const handleTouchEnd = (0, $eeH7J.useCallback)(()=>{
        // If user has panned more than 1/3 of the carousel, switch to the next slide
        // in the direction they've panned towards
        // Reset restart variables
        slideAnimationDisabled.current = false;
        if (carouselWidth && panned < carouselWidth / 3 * -1 && currentIndex < props.slides.length - 1) setCurrentIndex(currentIndex + 1);
        else if (carouselWidth && panned > carouselWidth / 3 && currentIndex > 0) setCurrentIndex(currentIndex - 1);
        // End of panning, reset state and ref variables
        setIsPanning(false);
        setPanned(0);
        touchPanStartX.current = null;
    }, [
        carouselWidth,
        panned,
        currentIndex,
        props.slides.length
    ]);
    const isMobile = (0, $756948b644e82cf2$export$92c840cda8ec752c).helpers.useMediaQuery("max", "sm");
    return (0, $4vwom.jsx)((0, $4vwom.Fragment), {
        children: (0, $4vwom.jsxs)("div", {
            onTouchStart: handleTouchStart,
            onTouchMove: handleTouchMove,
            onTouchEnd: handleTouchEnd,
            onMouseEnter: ()=>{
                setIsPaused(true);
            },
            onMouseLeave: ()=>{
                setIsPaused(false);
            },
            css: (0, $lhaLc.css)({
                display: "flex",
                overflow: "clip",
                width: "100%",
                flexWrap: "nowrap",
                position: "relative",
                touchAction: "pan-y",
                userSelect: "none",
                MozUserSelect: "none",
                msUserSelect: "none",
                WebkitTouchCallout: "none",
                WebkitUserSelect: "none"
            }, (0, $aace75a797ac78f1$export$ae2d933239aa09a1)("lg")),
            ref: carouselRef,
            children: [
                props.slides.map((slide, index)=>(0, $4vwom.jsx)((0, $ad7a054f4530c130$export$e25e478948902b8b).div, {
                        animate: {
                            transform: `translateX(${xOffset}) translateX(${panned}px)`
                        },
                        transition: slideAnimationDisabled.current || isPanning || index < currentIndex - 1 || index > currentIndex + 1 ? {
                            duration: 0
                        } : (0, $7f851218870bc850$export$f1ff28cd2162b6d5).carousel,
                        style: {
                            maxWidth: "100%",
                            flex: "0 0 100%"
                        },
                        children: (0, $4vwom.jsx)($5f9967f24e231168$var$Slide, Object.assign({}, slide))
                    }, slide.id || index)),
                (0, $4vwom.jsx)("div", {
                    css: (0, $lhaLc.css)({
                        position: "absolute",
                        bottom: 10,
                        left: "50%",
                        transform: "translateX(-50%)",
                        display: "flex"
                    }),
                    children: props.slides.length > 1 && props.slides.map((_, index)=>(0, $4vwom.jsx)((0, $ad7a054f4530c130$export$e25e478948902b8b).div, {
                            onClick: ()=>setCurrentIndex(index),
                            animate: {
                                width: props.autoSlide && index === currentIndex ? isMobile ? 16 : 56 : 8
                            },
                            css: (0, $lhaLc.css)({
                                height: 8,
                                backgroundColor: `${currentTheme === "dark" ? colors.grayWhite : colors.gray500}66`,
                                borderRadius: 4,
                                marginRight: 8,
                                overflow: "hidden",
                                ":last-of-type": {
                                    marginRight: 0
                                }
                            }),
                            children: props.autoSlide && index === currentIndex && (0, $4vwom.jsx)("div", {
                                onAnimationEnd: goToNext,
                                css: (0, $lhaLc.css)({
                                    backgroundColor: currentTheme === "dark" ? colors.grayWhite : colors.gray500,
                                    height: "100%"
                                }, (0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("min", "sm", {
                                    animationName: props.autoSlide ? $5f9967f24e231168$var$progress : undefined,
                                    animationDuration: `${timePerSlide}ms`,
                                    animationTimingFunction: "linear",
                                    animationPlayState: isPaused ? "paused" : "playing",
                                    borderTopRightRadius: 4,
                                    borderBottomRightRadius: 4
                                }))
                            })
                        }, index))
                })
            ]
        })
    });
}
function $5f9967f24e231168$var$Slide(props) {
    return (0, $4vwom.jsxs)((0, $bee1a5e35c892a21$export$e71c4d32a2263218), {
        as: "section",
        color: props.theme === "dark" ? "grayWhite" : "gray500",
        backgroundColor: props.theme === "dark" ? "gray500" : "sandLight",
        borderRadius: "lg",
        css: (0, $lhaLc.css)({
            position: "relative",
            flexDirection: "column",
            height: 400,
            maxHeight: "100%",
            overflow: "hidden",
            display: "flex",
            flex: "1 0 100%",
            justifyContent: $5f9967f24e231168$var$alignToFlex(props.textAlign)
        }, (0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("min", "sm", {
            flexDirection: props.textAlign === "right" ? "row-reverse" : "row"
        }), (0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("min", "lg", {
            height: (0, $756948b644e82cf2$export$981516ee4691055c)(600)
        })),
        children: [
            (0, $4vwom.jsx)("div", {
                css: (0, $lhaLc.css)({
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    backgroundPosition: `center ${props.imageSize === "auto" ? "left" : "right"} ${props.imageAlign}%`,
                    backgroundRepeat: "no-repeat",
                    backgroundSize: props.imageSize === "cover" ? "cover" : "auto 100%"
                }, (0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("max", "xs", {
                    top: "40%",
                    backgroundPosition: `bottom left ${props.imageAlign}%`
                }), props.image ? (0, $6a1a23ca93758ec8$export$8b235cefb9710a9e)({
                    image: props.image,
                    width: 1200
                }) : undefined)
            }),
            (0, $4vwom.jsx)((0, $bee1a5e35c892a21$export$e71c4d32a2263218), {
                css: (0, $lhaLc.css)({
                    flex: "1 1 0%",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    textAlign: props.textAlign,
                    zIndex: 1
                }, (0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("min", "sm", {
                    alignItems: $5f9967f24e231168$var$alignToFlex(props.textAlign),
                    justifyContent: "center"
                }), props.textAlign === "center" && {
                    justifyContent: "center"
                }),
                children: (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                    direction: "column",
                    alignItems: $5f9967f24e231168$var$alignToFlex(props.textAlign),
                    css: (0, $lhaLc.css)({
                        textAlign: "center",
                        alignItems: "center",
                        padding: (0, $756948b644e82cf2$export$981516ee4691055c)(56),
                        paddingBottom: 0
                    }, (0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("min", "sm", {
                        padding: "56px 96px",
                        maxWidth: (0, $756948b644e82cf2$export$981516ee4691055c)(540)
                    }), (0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("min", "sm", {
                        textAlign: props.textAlign,
                        alignItems: $5f9967f24e231168$var$alignToFlex(props.textAlign),
                        padding: 0,
                        paddingLeft: props.textAlign === "center" || props.textAlign === "right" ? 0 : 80,
                        paddingRight: props.textAlign === "center" || props.textAlign === "left" ? 0 : 80,
                        maxWidth: (0, $756948b644e82cf2$export$981516ee4691055c)(360)
                    }), (0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("min", "md", {
                        paddingLeft: props.textAlign === "center" || props.textAlign === "right" ? 0 : (0, $756948b644e82cf2$export$981516ee4691055c)(100),
                        paddingRight: props.textAlign === "center" || props.textAlign === "left" ? 0 : (0, $756948b644e82cf2$export$981516ee4691055c)(100),
                        maxWidth: (0, $756948b644e82cf2$export$981516ee4691055c)(props.textAlign === "center" ? 400 : 540)
                    }), (0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("min", "lg", {
                        textAlign: props.textAlign,
                        alignItems: $5f9967f24e231168$var$alignToFlex(props.textAlign),
                        padding: 0,
                        paddingLeft: props.textAlign === "center" || props.textAlign === "right" ? 0 : (0, $756948b644e82cf2$export$981516ee4691055c)(120),
                        paddingRight: props.textAlign === "center" || props.textAlign === "left" ? 0 : (0, $756948b644e82cf2$export$981516ee4691055c)(120),
                        maxWidth: (0, $756948b644e82cf2$export$981516ee4691055c)(540)
                    })),
                    children: [
                        (0, $4vwom.jsx)((0, $789b8639be592288$export$a8a3e93435678ff9), {
                            level: 1,
                            margin: {
                                bottom: (0, $756948b644e82cf2$export$981516ee4691055c)(24)
                            },
                            children: props.heading
                        }),
                        (0, $4vwom.jsx)((0, $72c5ae9e0017e167$export$4b2c32e08f77ff18), {
                            size: "lg",
                            margin: {
                                bottom: (0, $756948b644e82cf2$export$981516ee4691055c)(24)
                            },
                            children: props.text
                        }),
                        props.cta ? (0, $4vwom.jsx)((0, $4b4086f8a1c6b2f8$export$353f5b6fc5456de1), {
                            size: "md",
                            variant: "primary",
                            as: "a",
                            href: props.cta.href,
                            children: props.cta.text
                        }) : null
                    ]
                })
            }),
            props.textAlign !== "center" && (0, $4vwom.jsx)((0, $bee1a5e35c892a21$export$e71c4d32a2263218), {
                css: (0, $lhaLc.css)({
                    flex: "1 1 0%",
                    overflow: "visible",
                    display: "flex",
                    position: "relative",
                    zIndex: 0
                }, (0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("min", "sm", {
                    alignItems: "flex-end",
                    justifyContent: "flex-end"
                }), (0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("max", "xs", {
                    position: "absolute",
                    height: "50%",
                    width: "100%",
                    bottom: 0
                }))
            })
        ]
    });
}
(0, $eSiQ2.Component)($5f9967f24e231168$export$df5a8e831e8fbbb0, {
    name: "HighlightCarousel",
    gallery: {
        items: [
            {
                title: "Two slides, with auto slide",
                variants: [
                    {
                        props: {
                            autoSlide: true,
                            slides: [
                                {
                                    heading: "Eierskap m\xf8ter sirkul\xe6r innovasjon",
                                    text: "Nyt den ultimate fleksibiliteten og lei de nyeste enhetene for s\xe5 lite som 120 kr/md.",
                                    image: `${(0, $7m9cQ.server)()}/static/redoit/carousel-highlight-iphone.png`,
                                    textAlign: "left",
                                    theme: "dark",
                                    cta: {
                                        text: "Begynn \xe5 lease",
                                        href: "/"
                                    },
                                    imageSize: "auto"
                                },
                                {
                                    heading: "Eierskap m\xf8ter sirkul\xe6r innovasjon",
                                    text: "Nyt den ultimate fleksibiliteten og lei de nyeste enhetene for s\xe5 lite som 120 kr/md.",
                                    image: `${(0, $7m9cQ.server)()}/static/redoit/carousel-highlight-light-iphones.png`,
                                    textAlign: "center",
                                    theme: "light",
                                    imageSize: "auto"
                                }
                            ]
                        }
                    }
                ]
            },
            {
                title: "Single slide",
                variants: [
                    {
                        props: {
                            slides: [
                                {
                                    heading: "Eierskap m\xf8ter sirkul\xe6r innovasjon",
                                    text: "Nyt den ultimate fleksibiliteten og lei de nyeste enhetene for s\xe5 lite som 120 kr/md.",
                                    image: `${(0, $7m9cQ.server)()}/static/redoit/carousel-highlight-light-iphones.png`,
                                    textAlign: "center",
                                    theme: "light",
                                    cta: {
                                        text: "Begynn \xe5 lease",
                                        href: "/"
                                    },
                                    imageSize: "auto"
                                }
                            ]
                        }
                    }
                ]
            },
            {
                title: "Background with right side focus",
                variants: [
                    {
                        props: (state = {
                            left: 0
                        }, setState)=>({
                                slides: [
                                    {
                                        heading: "Eierskap m\xf8ter sirkul\xe6r innovasjon",
                                        text: "Nyt den ultimate fleksibiliteten og lei de nyeste enhetene for s\xe5 lite som 120 kr/mnd.",
                                        image: `${(0, $7m9cQ.server)()}/static/redoit/bannerbilde.png`,
                                        textAlign: "left",
                                        imageAlign: state.left,
                                        theme: "light",
                                        cta: {
                                            text: "Begynn \xe5 lease",
                                            url: "/order"
                                        }
                                    }
                                ]
                            }),
                        render: (cmp, state = {
                            left: 0
                        }, setState)=>(0, $4vwom.jsxs)("div", {
                                children: [
                                    (0, $4vwom.jsxs)("div", {
                                        style: {
                                            display: "flex",
                                            marginBottom: 12
                                        },
                                        children: [
                                            (0, $4vwom.jsx)("label", {
                                                style: {
                                                    marginRight: 8
                                                },
                                                children: "Alignment:"
                                            }),
                                            (0, $4vwom.jsx)("input", {
                                                type: "range",
                                                min: "0",
                                                max: "100",
                                                value: state.left,
                                                onChange: (e)=>setState({
                                                        left: parseInt(e.target.value)
                                                    })
                                            })
                                        ]
                                    }),
                                    cmp
                                ]
                            })
                    }
                ]
            },
            {
                title: "Two slides, no auto slide",
                variants: [
                    {
                        props: {
                            slides: [
                                {
                                    heading: "Eierskap m\xf8ter sirkul\xe6r innovasjon",
                                    text: "Nyt den ultimate fleksibiliteten og lei de nyeste enhetene for s\xe5 lite som 120 kr/md.",
                                    image: `${(0, $7m9cQ.server)()}/static/redoit/carousel-highlight-iphone.png`,
                                    textAlign: "left",
                                    theme: "dark",
                                    imageAlign: 90,
                                    cta: {
                                        text: "Begynn \xe5 lease",
                                        href: "/"
                                    },
                                    imageSize: "auto"
                                },
                                {
                                    heading: "Eierskap m\xf8ter sirkul\xe6r innovasjon",
                                    text: "Nyt den ultimate fleksibiliteten og lei de nyeste enhetene for s\xe5 lite som 120 kr/md.",
                                    image: `${(0, $7m9cQ.server)()}/static/redoit/carousel-highlight-light-iphones.png`,
                                    textAlign: "center",
                                    theme: "light",
                                    imageSize: "auto"
                                }
                            ]
                        }
                    }
                ]
            }
        ]
    }
});
function $5f9967f24e231168$var$alignToFlex(align) {
    return align === "left" ? "flex-start" : align === "right" ? "flex-end" : "center";
}


/**
 * @icon ui-arrow-square-right
 */ function $4eef2fa3060ffec2$var$Carousel(section) {
    const localize = (0, $aIeEI.useLocalize)();
    const ctaPageLink = (0, $2e171bb7176b2346$export$3e75343ff9861e57)(section.slides.map((slide)=>{
        var _a, _b;
        return (_b = (_a = slide.cta) === null || _a === void 0 ? void 0 : _a.page) !== null && _b !== void 0 ? _b : null;
    }));
    return (0, $4vwom.jsx)((0, $5f9967f24e231168$export$df5a8e831e8fbbb0), {
        autoSlide: typeof section.timePerSlide !== "undefined",
        timePerSlide: section.timePerSlide ? section.timePerSlide.valueOf() * 1000 : undefined,
        slides: section.slides.map((s, i)=>{
            var _a, _b;
            return {
                id: s.id.valueOf(),
                heading: localize(s.heading),
                text: localize(s.text),
                textAlign: s.textAlign,
                theme: s.theme,
                cta: s.cta ? {
                    text: localize(s.cta.text),
                    href: (_a = ctaPageLink === null || ctaPageLink === void 0 ? void 0 : ctaPageLink[i]) === null || _a === void 0 ? void 0 : _a.path
                } : undefined,
                image: s.image,
                imageSize: s.imageSize,
                imageAlign: (_b = s.imageAlign) === null || _b === void 0 ? void 0 : _b.valueOf()
            };
        })
    });
}
(0, $9G56J.Section)($4eef2fa3060ffec2$var$Carousel);



var $4vwom = parcelRequire("4vwom");

var $lhaLc = parcelRequire("lhaLc");

var $9G56J = parcelRequire("9G56J");

var $aIeEI = parcelRequire("aIeEI");


var $4vwom = parcelRequire("4vwom");

var $67cf5539992d1dd3$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
function $67cf5539992d1dd3$export$e6ff31bff12b7ff4(_a) {
    var { color: color } = _a, rest = $67cf5539992d1dd3$var$__rest(_a, [
        "color"
    ]);
    const { colors: colors } = (0, $756948b644e82cf2$export$559a0f07c8df6570)();
    const fillColor = color ? colors[color] : "#000";
    return (0, $4vwom.jsx)("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 1086 268",
        width: 1086,
        height: 268,
        fill: "none"
    }, rest, {
        children: (0, $4vwom.jsx)("path", {
            fill: fillColor,
            d: "M1036.23 263.837c-12.78 0-22.92-1.677-30.42-5.03-7.35-3.354-12.7-8.784-16.053-16.29-3.354-7.506-5.031-17.726-5.031-30.662V107.172h-37.369V71.24h26.11c2.556 0 4.632-.399 6.229-1.197 1.756-.959 3.034-2.316 3.832-4.073.959-1.757 1.438-3.833 1.438-6.228V27.163h42.404V71.24h57.73v35.932h-57.26v102.767c0 7.506 1.28 12.536 3.84 15.091 2.55 2.555 7.42 3.833 14.61 3.833h38.81v34.974h-48.87ZM880.304 71.238h43.119v192.597h-43.119V71.238Zm21.56-18.924c-6.388 0-11.659-.878-15.811-2.635-3.992-1.916-7.026-4.791-9.102-8.624-1.917-3.833-2.875-8.703-2.875-14.612 0-6.069.958-11.02 2.875-14.852 2.076-3.833 5.11-6.628 9.102-8.384 4.152-1.917 9.423-2.875 15.811-2.875 6.387 0 11.578.958 15.57 2.875 4.152 1.756 7.187 4.551 9.103 8.384 2.076 3.833 3.114 8.783 3.114 14.852 0 5.909-1.038 10.78-3.114 14.612-1.916 3.833-4.951 6.708-9.103 8.624-3.992 1.757-9.183 2.635-15.57 2.635ZM756.652 267.663c-19.483 0-36.571-4.152-51.263-12.456-14.532-8.304-25.791-20.042-33.776-35.214-7.825-15.331-11.738-33.217-11.738-53.659 0-19.962 3.913-37.369 11.738-52.221 7.985-15.012 19.244-26.51 33.776-34.495 14.692-8.145 31.78-12.217 51.263-12.217 19.484 0 36.571 4.072 51.264 12.217 14.692 7.985 25.951 19.483 33.776 34.495 7.985 14.852 11.978 32.259 11.978 52.221 0 20.442-3.993 38.328-11.978 53.659-7.825 15.172-19.084 26.91-33.776 35.214-14.693 8.304-31.78 12.456-51.264 12.456Zm0-35.932c16.929 0 30.104-5.669 39.526-17.008 9.582-11.498 14.373-27.468 14.373-47.909 0-19.963-4.791-35.533-14.373-46.712-9.422-11.179-22.597-16.769-39.526-16.769-16.928 0-30.103 5.59-39.525 16.769-9.422 11.179-14.133 26.749-14.133 46.712 0 20.441 4.711 36.411 14.133 47.909 9.422 11.339 22.597 17.008 39.525 17.008ZM533.521 267.668c-17.087 0-32.179-3.913-45.274-11.738-13.096-7.985-23.316-19.403-30.662-34.255-7.187-14.852-10.78-32.499-10.78-52.94v-.719c0-20.921 3.433-38.887 10.301-53.898 7.026-15.172 17.007-26.75 29.943-34.735 13.095-7.985 28.586-11.977 46.472-11.977 19.484 0 35.214 4.87 47.191 14.612 12.138 9.582 21.32 24.514 27.548 44.796h-13.175V8.237h43.119v255.598l-43.358.24.958-60.606 19.164.24c-6.708 15.171-14.054 27.468-22.039 36.89-7.985 9.422-16.848 16.289-26.589 20.601-9.742 4.312-20.681 6.468-32.819 6.468Zm8.624-35.693c16.449 0 29.225-5.669 38.328-17.008 9.262-11.498 13.894-27.468 13.894-47.909 0-20.122-4.632-35.773-13.894-46.952-9.103-11.179-21.879-16.768-38.328-16.768s-29.225 5.669-38.328 17.008c-9.102 11.179-13.654 26.909-13.654 47.191 0 20.282 4.552 36.092 13.654 47.43 9.103 11.339 21.879 17.008 38.328 17.008ZM336.508 267.663c-19.324 0-36.092-4.152-50.306-12.456-14.213-8.304-25.152-20.042-32.818-35.214-7.506-15.171-11.259-32.738-11.259-52.7 0-20.122 3.913-37.689 11.738-52.701 7.826-15.171 18.925-26.83 33.298-34.974 14.532-8.145 31.46-12.217 50.784-12.217 18.365 0 34.255 3.753 47.67 11.259 13.574 7.346 24.114 18.525 31.62 33.537 7.506 14.852 11.259 33.137 11.259 54.856v12.457H263.445v-29.944h129.356l-4.072 16.529c0-21.4-4.392-37.609-13.175-48.628-8.784-11.179-21.799-16.769-39.046-16.769-16.769 0-29.784 5.19-39.047 15.571-9.262 10.38-13.894 25.152-13.894 44.316l-.239 3.114c0 24.275 5.19 42.001 15.57 53.18 10.541 11.019 24.355 16.529 41.442 16.529 14.533 0 25.233-3.274 32.1-9.822 7.026-6.707 11.817-15.171 14.373-25.392h40.483c-2.395 15.331-7.985 28.187-16.768 38.568-8.784 10.38-19.643 18.125-32.579 23.236-12.776 5.11-26.59 7.665-41.441 7.665ZM.903 5.607H140.8c17.727 0 33.218 3.274 46.473 9.822 13.414 6.548 23.715 15.89 30.901 28.027 7.187 11.977 10.78 26.031 10.78 42.16 0 13.415-2.875 25.153-8.624 35.214-5.589 9.901-13.574 17.567-23.955 22.997-10.38 5.43-22.517 8.144-36.411 8.144v-2.395c16.13 0 28.586 2.076 37.37 6.228 8.943 4.152 15.011 9.502 18.205 16.05 3.194 6.548 4.791 14.053 4.791 22.517v69.469h-43.118v-64.917c0-8.304-1.518-14.852-4.552-19.643-2.874-4.791-7.346-8.225-13.415-10.301-6.068-2.076-14.053-3.114-23.954-3.114h-34.256l5.27-9.103 45.514 56.534h-41.681l-51.742-64.678 51.503-64.678h41.92l-45.514 56.533-5.27-9.582h37.849c14.532 0 26.031-4.072 34.495-12.217 8.624-8.144 12.935-19.084 12.935-32.818 0-14.053-4.711-24.993-14.133-32.818-9.262-7.985-22.278-11.977-39.046-11.977H44.022V263.84H.903V5.607Z",
            style: {
                fill: fillColor,
                fillOpacity: 1
            }
        })
    }));
}






var $eeH7J = parcelRequire("eeH7J");

var $dUDPg = parcelRequire("dUDPg");
parcelRequire("2LTO8");
var $iXeBy = parcelRequire("iXeBy");
/**
 * Section displaying logo and some links on the bottom of the page.
 *
 * @icon ui-flex-align-bottom
 */ function $f25dbc93d677f9bb$var$Footer(section) {
    var _a, _b;
    const localize = (0, $aIeEI.useLocalize)();
    const footer = (0, $e18f565b44c7bc7d$export$d07da6ac6fc160b0)();
    const currentLocale = (0, $aIeEI.useCurrentLocale)();
    const defaultLocale = (_a = (0, $dUDPg.useDefaultLocale)().data) === null || _a === void 0 ? void 0 : _a.defaultLocale;
    const footerItems = (0, $eeH7J.useMemo)(()=>{
        var _a;
        return ((_a = footer.data) === null || _a === void 0 ? void 0 : _a.items.map((item)=>{
            const localePath = currentLocale === defaultLocale ? "" : `/${currentLocale}`;
            const path = item.slug ? `${localePath}/${localize(item.slug)}` : "/";
            const fragment = item.section ? `#${item.section}` : "";
            const href = item.url && !item.slug ? item.url : (0, $iXeBy.Url)(`${path}${fragment}`);
            return {
                id: item.id.valueOf(),
                href: item.slug || item.section || item.url ? href : undefined,
                text: localize(item.text)
            };
        })) || [];
    }, [
        (_b = footer.data) === null || _b === void 0 ? void 0 : _b.items,
        currentLocale,
        defaultLocale,
        localize
    ]);
    if (!footer.data) return (0, $4vwom.jsx)((0, $4vwom.Fragment), {});
    return (0, $4vwom.jsxs)("div", {
        css: (0, $lhaLc.css)({
            paddingTop: (0, $1c2a8fb378443a1d$export$dd07c5170cc9e3b1).xs,
            paddingBottom: (0, $1c2a8fb378443a1d$export$3a40bd8b0ff0173c).xs.paddingBottom
        }, (0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("min", "md", {
            paddingTop: (0, $1c2a8fb378443a1d$export$dd07c5170cc9e3b1).md,
            paddingBottom: (0, $1c2a8fb378443a1d$export$3a40bd8b0ff0173c).md.paddingBottom
        })),
        children: [
            (0, $4vwom.jsx)((0, $67cf5539992d1dd3$export$e6ff31bff12b7ff4), {
                css: (0, $lhaLc.css)({
                    width: "100%",
                    height: "auto"
                })
            }),
            (0, $4vwom.jsxs)("div", {
                css: (0, $lhaLc.css)({
                    display: "flex",
                    marginTop: 32,
                    flexDirection: "column"
                }, (0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("min", "md", {
                    flexDirection: "row",
                    justifyContent: "space-between",
                    marginTop: 24
                })),
                children: [
                    (0, $4vwom.jsx)("div", {
                        css: (0, $lhaLc.css)({
                            display: "grid",
                            gap: 16
                        }, (0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("min", "md", {
                            gridAutoFlow: "column",
                            gap: 24
                        })),
                        children: footerItems.map((item)=>{
                            var _a;
                            return (0, $4vwom.jsx)("a", {
                                href: (_a = item.href) === null || _a === void 0 ? void 0 : _a.valueOf(),
                                style: {
                                    cursor: "pointer"
                                },
                                children: (0, $4vwom.jsx)((0, $72c5ae9e0017e167$export$4b2c32e08f77ff18), {
                                    size: "md",
                                    children: item.text
                                })
                            }, item.id.valueOf());
                        })
                    }),
                    (0, $4vwom.jsx)("div", {
                        css: (0, $lhaLc.css)({
                            opacity: 0.6,
                            textAlign: "right",
                            marginTop: 32
                        }, (0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("min", "md", {
                            marginTop: 0
                        })),
                        children: (0, $4vwom.jsxs)((0, $72c5ae9e0017e167$export$4b2c32e08f77ff18), {
                            size: "md",
                            children: [
                                "\xa9 ",
                                new Date().getFullYear(),
                                " Redoit \xb7 All rights reserved"
                            ]
                        })
                    })
                ]
            })
        ]
    });
}
(0, $9G56J.Section)($f25dbc93d677f9bb$var$Footer);



var $4vwom = parcelRequire("4vwom");

var $lhaLc = parcelRequire("lhaLc");

var $9G56J = parcelRequire("9G56J");

var $aIeEI = parcelRequire("aIeEI");

var $4vwom = parcelRequire("4vwom");



var $eeH7J = parcelRequire("eeH7J");

var $lhaLc = parcelRequire("lhaLc");




var $4vwom = parcelRequire("4vwom");

var $dRzna = parcelRequire("dRzna");

var $eeH7J = parcelRequire("eeH7J");



"use client";
/**
 * `MotionConfig` is used to set configuration options for all children `motion` components.
 *
 * ```jsx
 * import { motion, MotionConfig } from "framer-motion"
 *
 * export function App() {
 *   return (
 *     <MotionConfig transition={{ type: "spring" }}>
 *       <motion.div animate={{ x: 100 }} />
 *     </MotionConfig>
 *   )
 * }
 * ```
 *
 * @public
 */ function $4292e3b361a44985$export$caa69d61d2de10d9({ children: children, isValidProp: isValidProp, ...config }) {
    isValidProp && (0, $d3983d2add71cd91$export$59d6962c470509a5)(isValidProp);
    /**
     * Inherit props from any parent MotionConfig components
     */ config = {
        ...(0, $eeH7J.useContext)((0, $f79c9a1bd76bed7c$export$22a697fb29aac98d)),
        ...config
    };
    /**
     * Don't allow isStatic to change between renders as it affects how many hooks
     * motion components fire.
     */ config.isStatic = (0, $450f33b6a8740b8a$export$fe4300aa8eebea86)(()=>config.isStatic);
    /**
     * Creating a new config context object will re-render every `motion` component
     * every time it renders. So we only want to create a new one sparingly.
     */ const context = (0, $eeH7J.useMemo)(()=>config, [
        JSON.stringify(config.transition),
        config.transformPagePoint,
        config.reducedMotion
    ]);
    return (0, $dRzna.jsx)((0, $f79c9a1bd76bed7c$export$22a697fb29aac98d).Provider, {
        value: context,
        children: children
    });
}



var $lhaLc = parcelRequire("lhaLc");

var $eSiQ2 = parcelRequire("eSiQ2");






parcelRequire("2LTO8");
var $gGZ2r = parcelRequire("gGZ2r");



var $4vwom = parcelRequire("4vwom");

var $lhaLc = parcelRequire("lhaLc");


var $eeH7J = parcelRequire("eeH7J");
function $785176c560affa66$export$f3a192d0cbd30b96(callback) {
    return (0, $eeH7J.useEffect)(()=>()=>callback(), []);
}






function $796736c2678ffd9a$export$d276bfce3b1077ca(keyframes) {
    return typeof keyframes === "object" && !Array.isArray(keyframes);
}







function $5409af5f0cd4392d$export$f2911d8192f464a8(element) {
    const options = {
        presenceContext: null,
        props: {},
        visualState: {
            renderState: {
                transform: {},
                transformOrigin: {},
                style: {},
                vars: {},
                attrs: {}
            },
            latestValues: {}
        }
    };
    const node = (0, $cd7f8f0ad0976f3a$export$17eda790a720ec57)(element) ? new (0, $b30b20e17f4658dd$export$86bcdffbaf733d84)(options) : new (0, $dc98d0848c7498cf$export$23fea75b03ac16b3)(options);
    node.mount(element);
    (0, $64861684472349e0$export$bc2a978a17abfdde).set(element, node);
}






/**
 * Create a progress => progress easing function from a generator.
 */ function $125374a79ac9fd53$export$7f1511d09ee75a99(options, scale = 100) {
    const generator = (0, $f2ee4de28e47ead0$export$b36281d89752ae66)({
        keyframes: [
            0,
            scale
        ],
        ...options
    });
    const duration = Math.min((0, $63989eadef3836dd$export$cbdd6b3d40ea54e2)(generator), (0, $63989eadef3836dd$export$f4ff70a5b4808fd8));
    return {
        type: "keyframes",
        ease: (progress)=>generator.next(duration * progress).value / scale,
        duration: (0, $64e5667fa478a387$export$f64c3bfbc58eec0f)(duration)
    };
}








/**
 * Given a absolute or relative time definition and current/prev time state of the sequence,
 * calculate an absolute time for the next keyframes.
 */ function $55b280437a57388f$export$83ccd85155ba9791(current, next, prev, labels) {
    var _a;
    if (typeof next === "number") return next;
    else if (next.startsWith("-") || next.startsWith("+")) return Math.max(0, current + parseFloat(next));
    else if (next === "<") return prev;
    else return (_a = labels.get(next)) !== null && _a !== void 0 ? _a : current;
}


const $808faea7a4cc1063$export$4997ffc0176396a6 = (min, max, v)=>{
    const rangeSize = max - min;
    return ((v - min) % rangeSize + rangeSize) % rangeSize + min;
};



function $d1ef1ece22d99d8c$export$41c5e731255a462(easing, i) {
    return (0, $cdb960b4abd00d82$export$216948827bbdc797)(easing) ? easing[(0, $808faea7a4cc1063$export$4997ffc0176396a6)(0, easing.length, i)] : easing;
}




function $65b1287f681ccaf3$export$6f93cdbb78924b88(sequence, startTime, endTime) {
    for(let i = 0; i < sequence.length; i++){
        const keyframe = sequence[i];
        if (keyframe.at > startTime && keyframe.at < endTime) {
            (0, $51a4ba498ba1dae1$export$fe2d9b4e03920b4c)(sequence, keyframe);
            // If we remove this item we have to push the pointer back one
            i--;
        }
    }
}
function $65b1287f681ccaf3$export$89dfa6760a9f76e7(sequence, keyframes, easing, offset, startTime, endTime) {
    /**
     * Erase every existing value between currentTime and targetTime,
     * this will essentially splice this timeline into any currently
     * defined ones.
     */ $65b1287f681ccaf3$export$6f93cdbb78924b88(sequence, startTime, endTime);
    for(let i = 0; i < keyframes.length; i++)sequence.push({
        value: keyframes[i],
        at: (0, $4defff8a09cc16c4$export$3bb0b4ff1037b8dd)(startTime, endTime, offset[i]),
        easing: (0, $d1ef1ece22d99d8c$export$41c5e731255a462)(easing, i)
    });
}


function $c7a24a15c230270c$export$66dd3fbf44e05bd9(a, b) {
    if (a.at === b.at) {
        if (a.value === null) return 1;
        if (b.value === null) return -1;
        return 0;
    } else return a.at - b.at;
}


const $463f5e123a487b82$var$defaultSegmentEasing = "easeInOut";
function $463f5e123a487b82$export$1f0f44b51a4b2f73(sequence, { defaultTransition: defaultTransition = {}, ...sequenceTransition } = {}, scope) {
    const defaultDuration = defaultTransition.duration || 0.3;
    const animationDefinitions = new Map();
    const sequences = new Map();
    const elementCache = {};
    const timeLabels = new Map();
    let prevTime = 0;
    let currentTime = 0;
    let totalDuration = 0;
    /**
     * Build the timeline by mapping over the sequence array and converting
     * the definitions into keyframes and offsets with absolute time values.
     * These will later get converted into relative offsets in a second pass.
     */ for(let i = 0; i < sequence.length; i++){
        const segment = sequence[i];
        /**
         * If this is a timeline label, mark it and skip the rest of this iteration.
         */ if (typeof segment === "string") {
            timeLabels.set(segment, currentTime);
            continue;
        } else if (!Array.isArray(segment)) {
            timeLabels.set(segment.name, (0, $55b280437a57388f$export$83ccd85155ba9791)(currentTime, segment.at, prevTime, timeLabels));
            continue;
        }
        let [subject, keyframes, transition = {}] = segment;
        /**
         * If a relative or absolute time value has been specified we need to resolve
         * it in relation to the currentTime.
         */ if (transition.at !== undefined) currentTime = (0, $55b280437a57388f$export$83ccd85155ba9791)(currentTime, transition.at, prevTime, timeLabels);
        /**
         * Keep track of the maximum duration in this definition. This will be
         * applied to currentTime once the definition has been parsed.
         */ let maxDuration = 0;
        const resolveValueSequence = (valueKeyframes, valueTransition, valueSequence, elementIndex = 0, numElements = 0)=>{
            const valueKeyframesAsList = $463f5e123a487b82$var$keyframesAsList(valueKeyframes);
            const { delay: delay = 0, times: times = (0, $8866a142868d9f49$export$24dbcec0b26e6d9d)(valueKeyframesAsList), type: type = "keyframes", ...remainingTransition } = valueTransition;
            let { ease: ease = defaultTransition.ease || "easeOut", duration: duration } = valueTransition;
            /**
             * Resolve stagger() if defined.
             */ const calculatedDelay = typeof delay === "function" ? delay(elementIndex, numElements) : delay;
            /**
             * If this animation should and can use a spring, generate a spring easing function.
             */ const numKeyframes = valueKeyframesAsList.length;
            if (numKeyframes <= 2 && type === "spring") {
                /**
                 * As we're creating an easing function from a spring,
                 * ideally we want to generate it using the real distance
                 * between the two keyframes. However this isn't always
                 * possible - in these situations we use 0-100.
                 */ let absoluteDelta = 100;
                if (numKeyframes === 2 && $463f5e123a487b82$var$isNumberKeyframesArray(valueKeyframesAsList)) {
                    const delta = valueKeyframesAsList[1] - valueKeyframesAsList[0];
                    absoluteDelta = Math.abs(delta);
                }
                const springTransition = {
                    ...remainingTransition
                };
                if (duration !== undefined) springTransition.duration = (0, $64e5667fa478a387$export$fc3e7e8557f8c8c7)(duration);
                const springEasing = (0, $125374a79ac9fd53$export$7f1511d09ee75a99)(springTransition, absoluteDelta);
                ease = springEasing.ease;
                duration = springEasing.duration;
            }
            duration !== null && duration !== void 0 ? duration : duration = defaultDuration;
            const startTime = currentTime + calculatedDelay;
            const targetTime = startTime + duration;
            /**
             * If there's only one time offset of 0, fill in a second with length 1
             */ if (times.length === 1 && times[0] === 0) times[1] = 1;
            /**
             * Fill out if offset if fewer offsets than keyframes
             */ const remainder = times.length - valueKeyframesAsList.length;
            remainder > 0 && (0, $90bfe69fb9e7beb2$export$dafee61230cf05c6)(times, remainder);
            /**
             * If only one value has been set, ie [1], push a null to the start of
             * the keyframe array. This will let us mark a keyframe at this point
             * that will later be hydrated with the previous value.
             */ valueKeyframesAsList.length === 1 && valueKeyframesAsList.unshift(null);
            /**
             * Add keyframes, mapping offsets to absolute time.
             */ (0, $65b1287f681ccaf3$export$89dfa6760a9f76e7)(valueSequence, valueKeyframesAsList, ease, times, startTime, targetTime);
            maxDuration = Math.max(calculatedDelay + duration, maxDuration);
            totalDuration = Math.max(targetTime, totalDuration);
        };
        if ((0, $97dfd46cf2e43daf$export$605d60a2578142d3)(subject)) {
            const subjectSequence = $463f5e123a487b82$var$getSubjectSequence(subject, sequences);
            resolveValueSequence(keyframes, transition, $463f5e123a487b82$var$getValueSequence("default", subjectSequence));
        } else {
            /**
             * Find all the elements specified in the definition and parse value
             * keyframes from their timeline definitions.
             */ const elements = (0, $b93688f4b1374f47$export$90ceba2564a894f8)(subject, scope, elementCache);
            const numElements = elements.length;
            /**
             * For every element in this segment, process the defined values.
             */ for(let elementIndex = 0; elementIndex < numElements; elementIndex++){
                /**
                 * Cast necessary, but we know these are of this type
                 */ keyframes;
                transition;
                const element = elements[elementIndex];
                const subjectSequence = $463f5e123a487b82$var$getSubjectSequence(element, sequences);
                for(const key in keyframes)resolveValueSequence(keyframes[key], $463f5e123a487b82$export$7c1391340308742e(transition, key), $463f5e123a487b82$var$getValueSequence(key, subjectSequence), elementIndex, numElements);
            }
        }
        prevTime = currentTime;
        currentTime += maxDuration;
    }
    /**
     * For every element and value combination create a new animation.
     */ sequences.forEach((valueSequences, element)=>{
        for(const key in valueSequences){
            const valueSequence = valueSequences[key];
            /**
             * Arrange all the keyframes in ascending time order.
             */ valueSequence.sort((0, $c7a24a15c230270c$export$66dd3fbf44e05bd9));
            const keyframes = [];
            const valueOffset = [];
            const valueEasing = [];
            /**
             * For each keyframe, translate absolute times into
             * relative offsets based on the total duration of the timeline.
             */ for(let i = 0; i < valueSequence.length; i++){
                const { at: at, value: value, easing: easing } = valueSequence[i];
                keyframes.push(value);
                valueOffset.push((0, $482d3e1965098f2a$export$504d7abb21fa8c9)(0, totalDuration, at));
                valueEasing.push(easing || "easeOut");
            }
            /**
             * If the first keyframe doesn't land on offset: 0
             * provide one by duplicating the initial keyframe. This ensures
             * it snaps to the first keyframe when the animation starts.
             */ if (valueOffset[0] !== 0) {
                valueOffset.unshift(0);
                keyframes.unshift(keyframes[0]);
                valueEasing.unshift($463f5e123a487b82$var$defaultSegmentEasing);
            }
            /**
             * If the last keyframe doesn't land on offset: 1
             * provide one with a null wildcard value. This will ensure it
             * stays static until the end of the animation.
             */ if (valueOffset[valueOffset.length - 1] !== 1) {
                valueOffset.push(1);
                keyframes.push(null);
            }
            if (!animationDefinitions.has(element)) animationDefinitions.set(element, {
                keyframes: {},
                transition: {}
            });
            const definition = animationDefinitions.get(element);
            definition.keyframes[key] = keyframes;
            definition.transition[key] = {
                ...defaultTransition,
                duration: totalDuration,
                ease: valueEasing,
                times: valueOffset,
                ...sequenceTransition
            };
        }
    });
    return animationDefinitions;
}
function $463f5e123a487b82$var$getSubjectSequence(subject, sequences) {
    !sequences.has(subject) && sequences.set(subject, {});
    return sequences.get(subject);
}
function $463f5e123a487b82$var$getValueSequence(name, sequences) {
    if (!sequences[name]) sequences[name] = [];
    return sequences[name];
}
function $463f5e123a487b82$var$keyframesAsList(keyframes) {
    return Array.isArray(keyframes) ? keyframes : [
        keyframes
    ];
}
function $463f5e123a487b82$export$7c1391340308742e(transition, key) {
    return transition[key] ? {
        ...transition,
        ...transition[key]
    } : {
        ...transition
    };
}
const $463f5e123a487b82$var$isNumber = (keyframe)=>typeof keyframe === "number";
const $463f5e123a487b82$var$isNumberKeyframesArray = (keyframes)=>keyframes.every($463f5e123a487b82$var$isNumber);



function $b53be6a7dd33d25f$var$animateElements(elementOrSelector, keyframes, options, scope) {
    const elements = (0, $b93688f4b1374f47$export$90ceba2564a894f8)(elementOrSelector, scope);
    const numElements = elements.length;
    (0, $2b9100c03bd61cb5$export$f5708dca728d7177)(Boolean(numElements), "No valid element provided.");
    const animations = [];
    for(let i = 0; i < numElements; i++){
        const element = elements[i];
        /**
         * Check each element for an associated VisualElement. If none exists,
         * we need to create one.
         */ if (!(0, $64861684472349e0$export$bc2a978a17abfdde).has(element)) /**
             * TODO: We only need render-specific parts of the VisualElement.
             * With some additional work the size of the animate() function
             * could be reduced significantly.
             */ (0, $5409af5f0cd4392d$export$f2911d8192f464a8)(element);
        const visualElement = (0, $64861684472349e0$export$bc2a978a17abfdde).get(element);
        const transition = {
            ...options
        };
        /**
         * Resolve stagger function if provided.
         */ if (typeof transition.delay === "function") transition.delay = transition.delay(i, numElements);
        animations.push(...(0, $71617090e716925b$export$68cacfeee78d98d2)(visualElement, {
            ...keyframes,
            transition: transition
        }, {}));
    }
    return new (0, $ea560ce4dcc095f2$export$c1e41718f71efe41)(animations);
}
const $b53be6a7dd33d25f$var$isSequence = (value)=>Array.isArray(value) && Array.isArray(value[0]);
function $b53be6a7dd33d25f$var$animateSequence(sequence, options, scope) {
    const animations = [];
    const animationDefinitions = (0, $463f5e123a487b82$export$1f0f44b51a4b2f73)(sequence, options, scope);
    animationDefinitions.forEach(({ keyframes: keyframes, transition: transition }, subject)=>{
        let animation;
        if ((0, $97dfd46cf2e43daf$export$605d60a2578142d3)(subject)) animation = (0, $0840febc4398c738$export$335a17c977067b99)(subject, keyframes.default, transition.default);
        else animation = $b53be6a7dd33d25f$var$animateElements(subject, keyframes, transition);
        animations.push(animation);
    });
    return new (0, $ea560ce4dcc095f2$export$c1e41718f71efe41)(animations);
}
const $b53be6a7dd33d25f$export$c17e592002be9b90 = (scope)=>{
    /**
     * Implementation
     */ function scopedAnimate(valueOrElementOrSequence, keyframes, options) {
        let animation;
        if ($b53be6a7dd33d25f$var$isSequence(valueOrElementOrSequence)) animation = $b53be6a7dd33d25f$var$animateSequence(valueOrElementOrSequence, keyframes, scope);
        else if ((0, $796736c2678ffd9a$export$d276bfce3b1077ca)(keyframes)) animation = $b53be6a7dd33d25f$var$animateElements(valueOrElementOrSequence, keyframes, options, scope);
        else animation = (0, $0840febc4398c738$export$335a17c977067b99)(valueOrElementOrSequence, keyframes, options);
        if (scope) scope.animations.push(animation);
        return animation;
    }
    return scopedAnimate;
};
const $b53be6a7dd33d25f$export$e3607ec2d7a891c4 = $b53be6a7dd33d25f$export$c17e592002be9b90();


function $4c4e7486a769eecb$export$9f387b98a73b1511() {
    const scope = (0, $450f33b6a8740b8a$export$fe4300aa8eebea86)(()=>({
            current: null,
            animations: []
        }));
    const animate = (0, $450f33b6a8740b8a$export$fe4300aa8eebea86)(()=>(0, $b53be6a7dd33d25f$export$c17e592002be9b90)(scope));
    (0, $785176c560affa66$export$f3a192d0cbd30b96)(()=>{
        scope.animations.forEach((animation)=>animation.stop());
    });
    return [
        scope,
        animate
    ];
}



var $eeH7J = parcelRequire("eeH7J");
function $efb0893865373669$export$6eb0f7ddcda6131f({ collapsed: collapsed, children: children }) {
    const containerRef = (0, $eeH7J.useRef)(null);
    const [scope, animate] = (0, $4c4e7486a769eecb$export$9f387b98a73b1511)();
    const [autoHeight, setAutoHeight] = (0, $eeH7J.useState)(false);
    (0, $eeH7J.useEffect)(()=>{
        var _a;
        if (!((_a = containerRef.current) === null || _a === void 0 ? void 0 : _a.clientHeight)) return;
        const height = containerRef.current.clientHeight;
        setAutoHeight(false);
        animate(scope.current, {
            height: collapsed ? 0 : `${height}px`,
            opacity: collapsed ? 0 : 1
        }).then(()=>{
            if (!collapsed) setAutoHeight(true);
        });
    }, [
        animate,
        collapsed,
        scope
    ]);
    return (0, $4vwom.jsx)("div", {
        ref: scope,
        css: (0, $lhaLc.css)({
            overflow: collapsed ? "hidden" : "visible",
            height: autoHeight ? "auto !important" : undefined
        }),
        children: (0, $4vwom.jsx)("div", {
            ref: containerRef,
            children: children
        })
    });
}



function $931621612d6fcf0d$export$eb463a824a473e05(props) {
    const { colors: colors } = (0, $756948b644e82cf2$export$559a0f07c8df6570)();
    return (0, $4vwom.jsx)((0, $4292e3b361a44985$export$caa69d61d2de10d9), {
        transition: (0, $7f851218870bc850$export$f4e4ad51b471de36)["200"],
        children: (0, $4vwom.jsxs)((0, $bee1a5e35c892a21$export$e71c4d32a2263218), {
            onClick: props.onClick,
            borderRadius: "md",
            motion: {
                initial: {
                    backgroundColor: props.isOpen ? colors.gray100 : colors.grayWhite,
                    borderColor: props.isOpen ? colors.gray100 : colors.gray200
                },
                animate: {
                    backgroundColor: props.isOpen ? colors.gray100 : colors.grayWhite,
                    borderColor: props.isOpen ? colors.gray100 : colors.gray200
                }
            },
            css: (0, $lhaLc.css)({
                borderStyle: "solid",
                borderWidth: 1,
                padding: 24,
                cursor: "pointer",
                overflow: "clip",
                transition: (0, $7f851218870bc850$export$d5639c01d489b0c)([
                    "border-color"
                ], 200),
                "&:hover": {
                    borderColor: !props.isOpen ? `${colors.gray300} !important` : "transparent"
                }
            }, (0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("min", "md", {
                paddingTop: "calc(40px * var(--scale-factor))",
                paddingBottom: "calc(40px * var(--scale-factor))"
            })),
            children: [
                (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                    justifyContent: "space-between",
                    children: [
                        (0, $4vwom.jsx)((0, $72c5ae9e0017e167$export$4b2c32e08f77ff18), {
                            size: "lg",
                            children: props.question
                        }),
                        (0, $4vwom.jsx)((0, $f8cdd04128a131cf$export$f04a61298a47a40f), {
                            icon: props.isOpen ? "arrowUp" : "arrowDown",
                            margin: {
                                left: 20
                            }
                        })
                    ]
                }),
                (0, $4vwom.jsx)((0, $ad7a054f4530c130$export$e25e478948902b8b).div, {
                    initial: {
                        marginTop: props.isOpen ? "calc(20px * var(--scale-factor))" : 0
                    },
                    animate: {
                        marginTop: props.isOpen ? "calc(20px * var(--scale-factor))" : 0
                    },
                    children: (0, $4vwom.jsx)((0, $efb0893865373669$export$6eb0f7ddcda6131f), {
                        collapsed: !props.isOpen,
                        children: (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                            variant: "body",
                            size: "md",
                            children: (0, $4vwom.jsx)((0, $82d66b15b8f4758d$export$d5163f1ce1e6a5f9), {
                                value: props.answer
                            })
                        })
                    })
                })
            ]
        })
    });
}
(0, $eSiQ2.Component)($931621612d6fcf0d$export$eb463a824a473e05, {
    name: "FaqItem",
    gallery: {
        path: "Blocks/FAQ",
        items: [
            {
                variants: [
                    {
                        label: "Closed state",
                        props: (state = {
                            isOpen: false
                        }, setState)=>({
                                question: "How does this work?",
                                answer: (0, $gGZ2r.Markdown)("Proin consectetur nunc non augue rhoncus, eget scelerisque massa tempor. Integer tincidunt, leo eget sagittis eleifend, turpis magna vehicula massa, sed pharetra arcu tellus eget tortor."),
                                isOpen: state.isOpen,
                                onClick: ()=>{
                                    setState({
                                        isOpen: !state.isOpen
                                    });
                                }
                            })
                    }
                ]
            },
            {
                variants: [
                    {
                        label: "Open state",
                        props: (state = {
                            isOpen: true
                        }, setState)=>({
                                question: "More questions?",
                                answer: (0, $gGZ2r.Markdown)("Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed porta, magna eu efficitur pretium, nisi tellus gravida mauris, vel venenatis sem magna nec massa. Vivamus laoreet, dui vitae elementum viverra, mauris nisl aliquam erat, in feugiat purus lorem ac odio. Fusce venenatis vel dui at vestibulum. Praesent ut lectus a felis ullamcorper auctor. Etiam non malesuada diam. In hac habitasse platea dictumst. Praesent in dolor rhoncus, euismod sapien nec, rhoncus justo. Duis vitae arcu ligula."),
                                isOpen: state.isOpen,
                                onClick: ()=>{
                                    setState({
                                        isOpen: !state.isOpen
                                    });
                                }
                            })
                    }
                ]
            }
        ]
    }
});


function $27039c694c31ccef$export$91f5553634f65df6(props) {
    var _a;
    const [openQuestions, setOpenQuestions] = (0, $eeH7J.useState)([]);
    const [showAll, setShowAll] = (0, $eeH7J.useState)(false);
    const handleClick = (0, $eeH7J.useCallback)((id)=>()=>{
            const alreadyOpen = openQuestions.includes(id);
            setOpenQuestions(alreadyOpen ? openQuestions.filter((q)=>q !== id) : [
                ...openQuestions,
                id
            ]);
        }, [
        openQuestions
    ]);
    const containerRef = (0, $eeH7J.useRef)(null);
    const [restQuestionsHeight, setRestQuestionsHeight] = (0, $eeH7J.useState)(0);
    const updateHeight = (0, $eeH7J.useCallback)(()=>{
        var _a;
        setRestQuestionsHeight(((_a = containerRef.current) === null || _a === void 0 ? void 0 : _a.clientHeight) || 0);
    }, []);
    (0, $eeH7J.useEffect)(()=>{
        var _a;
        if (showAll && ((_a = containerRef.current) === null || _a === void 0 ? void 0 : _a.clientHeight)) updateHeight();
    }, [
        showAll,
        updateHeight
    ]);
    return (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
        direction: "column",
        children: [
            (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                alignItems: "center",
                justifyContent: "space-between",
                css: (0, $lhaLc.css)({
                    marginBottom: 16
                }, (0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("min", "md", {
                    marginBottom: 24
                })),
                children: [
                    (0, $4vwom.jsx)((0, $789b8639be592288$export$a8a3e93435678ff9), {
                        level: 2,
                        children: props.heading
                    }),
                    (0, $4vwom.jsx)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                        shrink: 0,
                        margin: {
                            left: 16
                        },
                        css: (0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("max", "xs", {
                            display: "none"
                        }),
                        children: typeof props.maxInitialQuestions === "number" && props.questions.length > props.maxInitialQuestions ? (0, $4vwom.jsx)((0, $4b4086f8a1c6b2f8$export$353f5b6fc5456de1), {
                            size: "sm",
                            variant: "secondary",
                            onClick: ()=>setShowAll(true),
                            disabled: showAll,
                            children: props.showAllButtonText
                        }) : null
                    })
                ]
            }),
            props.questions.slice(0, (_a = props.maxInitialQuestions) !== null && _a !== void 0 ? _a : props.questions.length).map((q)=>(0, $4vwom.jsx)("div", {
                    onClick: handleClick(q.id),
                    css: (0, $lhaLc.css)({
                        marginBottom: 8,
                        "&:last-of-type": {
                            marginBottom: 0
                        }
                    }, (0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("min", "md", {
                        marginBottom: (0, $756948b644e82cf2$export$981516ee4691055c)(16)
                    })),
                    children: (0, $4vwom.jsx)((0, $931621612d6fcf0d$export$eb463a824a473e05), {
                        question: q.question,
                        answer: q.answer,
                        isOpen: openQuestions.includes(q.id)
                    })
                }, q.id.valueOf())),
            showAll && (0, $4vwom.jsx)((0, $ad7a054f4530c130$export$e25e478948902b8b).div, {
                initial: {
                    height: 0
                },
                animate: {
                    height: restQuestionsHeight
                },
                onAnimationComplete: ()=>{
                    var _a;
                    // After animation is done, set height to auto, to automatically get the
                    // correct height when opening questions or window is resized.
                    setRestQuestionsHeight("auto");
                    (_a = containerRef.current) === null || _a === void 0 || _a.scrollIntoView({
                        behavior: "smooth",
                        block: "end"
                    });
                },
                children: (0, $4vwom.jsx)("div", {
                    ref: containerRef,
                    style: {
                        scrollMarginBottom: 24
                    },
                    children: props.questions.slice(props.maxInitialQuestions, props.questions.length).map((q, index)=>(0, $4vwom.jsx)((0, $ad7a054f4530c130$export$e25e478948902b8b).div, {
                            initial: {
                                opacity: 0,
                                transform: `translateY(-${index + 80}px)`
                            },
                            animate: {
                                opacity: 1,
                                transform: "translateY(0px)"
                            },
                            onAnimationComplete: ()=>{},
                            onClick: handleClick(q.id),
                            css: (0, $lhaLc.css)({
                                marginBottom: 8,
                                "&:last-of-type": {
                                    marginBottom: 0
                                }
                            }, (0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("min", "md", {
                                marginBottom: (0, $756948b644e82cf2$export$981516ee4691055c)(16)
                            })),
                            children: (0, $4vwom.jsx)((0, $931621612d6fcf0d$export$eb463a824a473e05), {
                                question: q.question,
                                answer: q.answer,
                                isOpen: openQuestions.includes(q.id)
                            })
                        }, q.id.valueOf()))
                })
            }),
            typeof props.maxInitialQuestions === "number" && props.questions.length > props.maxInitialQuestions ? (0, $4vwom.jsx)((0, $4b4086f8a1c6b2f8$export$353f5b6fc5456de1), {
                size: "sm",
                variant: "dark",
                onClick: ()=>setShowAll(true),
                disabled: showAll,
                fullwidth: true,
                margin: {
                    top: 8
                },
                css: (0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("min", "sm", {
                    display: "none"
                }),
                children: props.showAllButtonText
            }) : null
        ]
    });
}




/**
 * @icon ui-message-question-circle
 */ function $d4b0be373b0d3669$var$FrequentlyAskedQuestions(section) {
    var _a;
    const localize = (0, $aIeEI.useLocalize)();
    const frequentlyAskedQuestions = (0, $e18f565b44c7bc7d$export$6eb271ef04c4063b)();
    if (!frequentlyAskedQuestions.loading && !frequentlyAskedQuestions.data) return (0, $4vwom.jsx)((0, $4vwom.Fragment), {});
    return (0, $4vwom.jsx)("div", {
        css: (0, $lhaLc.css)((0, $756948b644e82cf2$export$f1cf1885b6bfef23)()),
        children: ((_a = frequentlyAskedQuestions.data) === null || _a === void 0 ? void 0 : _a.questions.length) && (0, $4vwom.jsx)((0, $27039c694c31ccef$export$91f5553634f65df6), {
            heading: localize(section.heading),
            questions: frequentlyAskedQuestions.data.questions.map((item)=>({
                    id: item.id,
                    question: localize(item.question),
                    answer: localize(item.answer)
                })),
            showAllButtonText: localize(section.showAllButtonText),
            maxInitialQuestions: section.maxInitialQuestions.valueOf()
        })
    });
}
(0, $9G56J.Section)($d4b0be373b0d3669$var$FrequentlyAskedQuestions);



var $4vwom = parcelRequire("4vwom");

var $eeH7J = parcelRequire("eeH7J");

var $9G56J = parcelRequire("9G56J");

var $4vwom = parcelRequire("4vwom");

var $lhaLc = parcelRequire("lhaLc");




const $06eb0d21a8b1f440$var$lightTextColorBackgrounds = [
    "gray350",
    "gray400",
    "gray500",
    "forest",
    "brand",
    "brandDark",
    "vippsOrange",
    "sky",
    "sand",
    "warning",
    "error"
];
const { colors: $06eb0d21a8b1f440$export$8f45430ccf837300 } = (0, $756948b644e82cf2$export$92c840cda8ec752c);
function $06eb0d21a8b1f440$export$ae620eaddefec402(backgroundColor) {
    if ($06eb0d21a8b1f440$var$lightTextColorBackgrounds.includes(backgroundColor)) return "grayWhite";
    return "gray500";
}




function $192171ee7c657b77$export$14834abbfce3b8cd(props) {
    var _a;
    const theme = (0, $756948b644e82cf2$export$559a0f07c8df6570)();
    const { responsiveCss: responsiveCss } = theme.helpers;
    const backgroundColor = (_a = props.color) !== null && _a !== void 0 ? _a : "forest";
    return (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
        backgroundColor: backgroundColor,
        color: (0, $06eb0d21a8b1f440$export$ae620eaddefec402)(backgroundColor),
        alignItems: "center",
        gap: 8,
        style: props.full ? {
            width: "100vw",
            marginLeft: "calc(50% - 50vw)"
        } : {
            borderRadius: 16,
            justifyContent: "flex-start"
        },
        css: (0, $lhaLc.css)({
            padding: `${props.full ? 20 : 16}px 16px`
        }, responsiveCss("min", "md", {
            padding: props.full ? "12px 24px" : 16
        })),
        children: [
            props.icon ? (0, $4vwom.jsx)((0, $f8cdd04128a131cf$export$f04a61298a47a40f), {
                icon: props.icon
            }) : null,
            (0, $4vwom.jsx)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                grow: 1,
                justifyContent: props.full ? "center" : "flex-start",
                style: {
                    textAlign: "left"
                },
                children: (0, $4vwom.jsx)((0, $82d66b15b8f4758d$export$d5163f1ce1e6a5f9), {
                    value: props.text,
                    renderers: {
                        paragraph: (p)=>(0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                variant: "body",
                                size: "md",
                                children: p.children
                            })
                    }
                })
            }),
            props.onClose && (0, $4vwom.jsx)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                justifyContent: "center",
                children: (0, $4vwom.jsx)("button", {
                    style: {
                        marginLeft: 40
                    },
                    onClick: props.onClose,
                    children: (0, $4vwom.jsx)((0, $f8cdd04128a131cf$export$f04a61298a47a40f), {
                        icon: "close",
                        color: "gray100"
                    })
                })
            })
        ]
    });
}




var $aIeEI = parcelRequire("aIeEI");
/**
 * @icon ui-announcement-03
 */ function $671abeb8be446186$var$FullNotification(section) {
    var _a;
    const notificationsClosed = (0, $e18f565b44c7bc7d$export$b1798547582b81c2)();
    const [justClosed, setJustClosed] = (0, $eeH7J.useState)(false);
    const localize = (0, $aIeEI.useLocalize)();
    const handleClose = (0, $eeH7J.useCallback)(async ()=>{
        (0, $e18f565b44c7bc7d$export$87c93287defb9514)({
            id: section.id.valueOf()
        });
        setJustClosed(true);
    }, [
        section.id
    ]);
    return ((_a = notificationsClosed.data) === null || _a === void 0 ? void 0 : _a.includes(section.id.valueOf())) || justClosed ? (0, $4vwom.jsx)((0, $4vwom.Fragment), {}) : (0, $4vwom.jsx)((0, $192171ee7c657b77$export$14834abbfce3b8cd), {
        full: true,
        color: section.color,
        onClose: section.allowClose ? handleClose : undefined,
        text: typeof section.text === "string" ? section.text : localize(section.text)
    });
}
(0, $9G56J.Section)($671abeb8be446186$var$FullNotification);



var $4vwom = parcelRequire("4vwom");

var $eeH7J = parcelRequire("eeH7J");

var $5K1mb = parcelRequire("5K1mb");
var $18Pjr = parcelRequire("18Pjr");

var $lhaLc = parcelRequire("lhaLc");


var $dUDPg = parcelRequire("dUDPg");

var $9G56J = parcelRequire("9G56J");

var $aIeEI = parcelRequire("aIeEI");

var $7FrRx = parcelRequire("7FrRx");






var $4vwom = parcelRequire("4vwom");

var $lhaLc = parcelRequire("lhaLc");

var $4vwom = parcelRequire("4vwom");

var $eSiQ2 = parcelRequire("eSiQ2");

var $34f1974b2dd65db4$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
function $34f1974b2dd65db4$export$7998e98dfdedb157(_a) {
    var { css: css } = _a, rest = $34f1974b2dd65db4$var$__rest(_a, [
        "css"
    ]);
    const { colors: colors } = (0, $756948b644e82cf2$export$559a0f07c8df6570)();
    return (0, $4vwom.jsx)("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 24 24"
    }, rest, {
        children: (0, $4vwom.jsx)("path", {
            fill: colors._trustpilot,
            d: "m11.566 17.252 4.591-1.164L18.076 22l-6.51-4.748ZM22.132 9.61H14.05L11.566 2 9.082 9.61H1l6.54 4.717-2.483 7.61 6.54-4.717 4.026-2.893 6.51-4.717Z"
        })
    }));
}
function $34f1974b2dd65db4$export$681b028df1bc0b68(props) {
    const { colors: colors } = (0, $756948b644e82cf2$export$559a0f07c8df6570)();
    /**
     * Colors for different ratings. 0 is default background color for stars > rating, the rest is for
     * all filled stars for ratings 1-5.
     */ const ratingColors = [
        "#dcdce6",
        "#ff3722",
        "#ff8622",
        "#ffce00",
        "#73cf11",
        colors._trustpilot
    ];
    if (props.rating < 0 || props.rating > 5) // eslint-disable-next-line no-console
    console.warn("Prop `rating` should be between 1 and 5.");
    return (0, $4vwom.jsx)("div", {
        style: {
            display: "grid",
            gap: 2,
            gridAutoFlow: "column"
        },
        children: [
            1,
            2,
            3,
            4,
            5
        ].map((i)=>(0, $4vwom.jsx)("div", {
                style: {
                    display: "flex",
                    height: 20,
                    width: 20,
                    justifyContent: "center",
                    alignItems: "center",
                    backgroundColor: i > props.rating ? ratingColors[0] : ratingColors[props.rating]
                },
                children: (0, $4vwom.jsx)("svg", Object.assign({
                    xmlns: "http://www.w3.org/2000/svg",
                    width: 14,
                    height: 14,
                    viewBox: "0 0 14 14"
                }, props, {
                    children: (0, $4vwom.jsx)("path", {
                        fill: "#fff",
                        d: "m7 10.676 3.042-.814L11.312 14 7 10.676Zm7-5.349H8.646L7 0 5.354 5.327H0l4.333 3.302-1.646 5.327 4.334-3.302L9.688 8.63 14 5.327Z"
                    })
                }))
            }, i))
    });
}
(0, $eSiQ2.Component)($34f1974b2dd65db4$export$681b028df1bc0b68, {
    name: "TrustpilotStars",
    gallery: {
        items: [
            {
                variants: [
                    {
                        props: {
                            rating: 1
                        }
                    },
                    {
                        props: {
                            rating: 2
                        }
                    },
                    {
                        props: {
                            rating: 3
                        }
                    },
                    {
                        props: {
                            rating: 4
                        }
                    },
                    {
                        props: {
                            rating: 5
                        }
                    }
                ]
            }
        ]
    }
});





var $d459a7d0faaadece$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
function $d459a7d0faaadece$export$3f8d6a825279800d(_a) {
    var { as: as, score: score, text: text } = _a, rest = $d459a7d0faaadece$var$__rest(_a, [
        "as",
        "score",
        "text"
    ]);
    const { colors: colors } = (0, $756948b644e82cf2$export$559a0f07c8df6570)();
    const style = {
        default: {
            color: colors.gray500,
            borderColor: colors.gray200
        },
        hover: {
            borderColor: colors.gray400
        },
        focus: {
            borderColor: colors.gray500
        }
    };
    const El = as !== null && as !== void 0 ? as : "div";
    return (0, $4vwom.jsxs)(El, Object.assign({
        css: (0, $lhaLc.css)({
            display: "flex",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: 1,
            height: 48 * (0, $1c2a8fb378443a1d$export$adc5746a202ff4b),
            borderRadius: 24,
            paddingLeft: 16,
            paddingRight: 16,
            paddingBottom: 1,
            backgroundColor: colors.grayWhite
        }, (0, $aace75a797ac78f1$export$70aad56e3e56b3f3)("4"), style.default)
    }, rest, {
        children: [
            score.toString().replace(".", ","),
            (0, $4vwom.jsx)((0, $34f1974b2dd65db4$export$7998e98dfdedb157), {
                css: (0, $lhaLc.css)({
                    marginLeft: 6,
                    marginRight: 6
                })
            }),
            text
        ]
    }));
}




var $4vwom = parcelRequire("4vwom");

var $eeH7J = parcelRequire("eeH7J");

var $eSiQ2 = parcelRequire("eSiQ2");

var $34lt5 = parcelRequire("34lt5");

var $4vwom = parcelRequire("4vwom");
function $7d490944797b9db6$export$48ea269755562084(props) {
    switch(props.flag){
        case "en":
            return (0, $4vwom.jsxs)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                width: 22,
                height: 16,
                fill: "none",
                style: props.style,
                children: [
                    (0, $4vwom.jsxs)("g", {
                        clipPath: "url(#a)",
                        children: [
                            (0, $4vwom.jsx)("rect", {
                                width: 21,
                                height: 15,
                                x: 0.5,
                                y: 0.5,
                                fill: "#1A47B8",
                                rx: 3
                            }),
                            (0, $4vwom.jsx)("path", {
                                fill: "#fff",
                                fillRule: "evenodd",
                                d: "M2.734.5H.5V3l18.754 12.5H21.5V13L2.734.5Z",
                                clipRule: "evenodd"
                            }),
                            (0, $4vwom.jsx)("path", {
                                fill: "#F93939",
                                d: "M1.245.5 21.5 14.035V15.5h-.728L.5 1.95V.5h.745Z"
                            }),
                            (0, $4vwom.jsx)("path", {
                                fill: "#fff",
                                fillRule: "evenodd",
                                d: "M19.5.5h2V3s-12.99 8.328-19 12.5h-2V13L19.5.5Z",
                                clipRule: "evenodd"
                            }),
                            (0, $4vwom.jsx)("path", {
                                fill: "#F93939",
                                d: "M21.5.5h-.678L.5 14.047V15.5h.745L21.5 1.962V.5Z"
                            }),
                            (0, $4vwom.jsx)("path", {
                                fill: "#fff",
                                fillRule: "evenodd",
                                d: "M8.137.5h5.743v4.627h7.62v5.743h-7.62v4.63H8.137v-4.63H.5V5.127h7.637V.5Z",
                                clipRule: "evenodd"
                            }),
                            (0, $4vwom.jsx)("path", {
                                fill: "#F93939",
                                fillRule: "evenodd",
                                d: "M9.342.5h3.316v5.77H21.5v3.46h-8.842v5.77H9.342V9.73H.5V6.27h8.842V.5Z",
                                clipRule: "evenodd"
                            })
                        ]
                    }),
                    (0, $4vwom.jsx)("defs", {
                        children: (0, $4vwom.jsx)("clipPath", {
                            id: "a",
                            children: (0, $4vwom.jsx)("rect", {
                                width: 21,
                                height: 15,
                                x: 0.5,
                                y: 0.5,
                                fill: "#fff",
                                rx: 3
                            })
                        })
                    })
                ]
            });
        case "no":
            return (0, $4vwom.jsxs)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 22 16",
                width: 22,
                height: 16,
                fill: "none",
                style: props.style,
                children: [
                    (0, $4vwom.jsxs)("g", {
                        clipPath: "url(#a)",
                        children: [
                            (0, $4vwom.jsx)("rect", {
                                width: 21,
                                height: 15,
                                x: 0.5,
                                y: 0.5,
                                fill: "#af010d",
                                rx: 3
                            }),
                            (0, $4vwom.jsx)("path", {
                                fill: "#fff",
                                fillRule: "evenodd",
                                d: "M6.5 9.5h-6v-3h6v-6h3v6h12v3h-12v6h-3v-6Z",
                                clipRule: "evenodd",
                                style: {
                                    fill: "#fff",
                                    fillOpacity: 1
                                }
                            }),
                            (0, $4vwom.jsx)("path", {
                                fill: "#1a47b8",
                                fillRule: "evenodd",
                                d: "M7.5 8.5h-7v-1h7v-7h1v7h13v1h-13v7h-1v-7Z",
                                clipRule: "evenodd"
                            })
                        ]
                    }),
                    (0, $4vwom.jsx)("defs", {
                        children: (0, $4vwom.jsx)("clipPath", {
                            id: "a",
                            children: (0, $4vwom.jsx)("rect", {
                                width: 21,
                                height: 15,
                                x: 0.5,
                                y: 0.5,
                                fill: "#fff",
                                rx: 3
                            })
                        })
                    })
                ]
            });
        default:
            return null;
    }
}



var $4vwom = parcelRequire("4vwom");

var $eeH7J = parcelRequire("eeH7J");

var $lhaLc = parcelRequire("lhaLc");


var $eSiQ2 = parcelRequire("eSiQ2");
function $f8bb6ad0e871adee$export$931cbfb6bfb85fc(props) {
    var _a, _b, _c;
    const selectRef = (0, $eeH7J.useRef)(null);
    const handleChange = (0, $eeH7J.useCallback)((e)=>{
        var _a;
        (_a = props.onChange) === null || _a === void 0 || _a.call(props, e, e.target.value);
    }, [
        props
    ]);
    return (0, $4vwom.jsxs)((0, $4b4086f8a1c6b2f8$export$353f5b6fc5456de1), {
        variant: "outlined",
        iconEnd: "chevronDown",
        size: "sm",
        css: $f8bb6ad0e871adee$var$buttonCss,
        children: [
            (_b = (_a = props.renderValue) === null || _a === void 0 ? void 0 : _a.call(props, props.value)) !== null && _b !== void 0 ? _b : (_c = props.options.find((opt)=>opt.value === props.value)) === null || _c === void 0 ? void 0 : _c.text,
            (0, $4vwom.jsx)("select", {
                css: $f8bb6ad0e871adee$var$dropdownCss,
                ref: selectRef,
                value: props.value.valueOf(),
                onChange: handleChange,
                children: props.options.map((o)=>(0, $4vwom.jsx)("option", {
                        value: o.value.valueOf(),
                        children: o.text
                    }, o.value.valueOf()))
            })
        ]
    });
}
const $f8bb6ad0e871adee$var$buttonCss = (0, $lhaLc.css)({
    position: "relative"
});
const $f8bb6ad0e871adee$var$dropdownCss = (0, $lhaLc.css)({
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    minWidth: 0,
    appearance: "none",
    opacity: 0,
    cursor: "pointer"
});
(0, $eSiQ2.Component)($f8bb6ad0e871adee$export$931cbfb6bfb85fc, {
    name: "Dropdown",
    gallery: {
        path: "Buttons/Dropdown",
        items: [
            {
                variants: [
                    {
                        props: {
                            value: "foo",
                            options: [
                                {
                                    value: "foo",
                                    text: "Foo"
                                },
                                {
                                    value: "bar",
                                    text: "Bar"
                                }
                            ]
                        }
                    }
                ]
            }
        ]
    }
});


function $7d8a294407b9f7e2$export$aa53e71df758134e(props) {
    const options = (0, $eeH7J.useMemo)(()=>props.locales.map((l)=>({
                value: l.key.toString(),
                // Is typed as Localized<string> but is already localized in API.
                text: l.displayName
            })), [
        props.locales
    ]);
    const handleSelectChange = (0, $eeH7J.useCallback)((e)=>{
        var _a;
        (_a = props.onLocaleChange) === null || _a === void 0 || _a.call(props, e.target.value);
    }, [
        props
    ]);
    return (0, $4vwom.jsx)((0, $f8bb6ad0e871adee$export$931cbfb6bfb85fc), {
        options: options,
        value: props.currentLocale.toString(),
        onChange: handleSelectChange,
        renderValue: (val)=>val === "en" || val === "no" ? (0, $4vwom.jsx)((0, $7d490944797b9db6$export$48ea269755562084), {
                flag: val
            }) : null
    });
}
(0, $eSiQ2.Component)($7d8a294407b9f7e2$export$aa53e71df758134e, {
    name: "LocaleSelect",
    gallery: {
        path: "Controllers/LocaleSelect",
        items: [
            {
                variants: [
                    {
                        props: {
                            currentLocale: (0, $34lt5.LocaleKey)("no"),
                            onLocaleChange: (l)=>{
                                // eslint-disable-next-line no-console
                                console.log("Changed locale to", l);
                            },
                            locales: [
                                {
                                    flag: "\uD83C\uDDEC\uD83C\uDDE7",
                                    key: (0, $34lt5.LocaleKey)("en"),
                                    displayName: "English",
                                    fallback: (0, $34lt5.LocaleKey)("no")
                                },
                                {
                                    flag: "\uD83C\uDDF3\uD83C\uDDF4",
                                    key: (0, $34lt5.LocaleKey)("no"),
                                    displayName: "Norwegian"
                                }
                            ]
                        }
                    }
                ]
            }
        ]
    }
});



var $4vwom = parcelRequire("4vwom");

var $eeH7J = parcelRequire("eeH7J");

var $iMJCh = parcelRequire("iMJCh");

var $5K1mb = parcelRequire("5K1mb");


var $eSiQ2 = parcelRequire("eSiQ2");



const $e665a5c3bf2ac3f6$export$16e1fc8de5cd9687 = "0px 4px 24px 0px rgba(21, 6, 36, 0.12)";
const $e665a5c3bf2ac3f6$export$e60c3527c0af1c42 = "drop-shadow(0px 4px 18px rgba(21, 6, 36, 0.12))";



var $4vwom = parcelRequire("4vwom");

var $df8c0007eabe8257$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
function $df8c0007eabe8257$export$45c9c5c7ee057bfb(_a) {
    var { color: color } = _a, rest = $df8c0007eabe8257$var$__rest(_a, [
        "color"
    ]);
    const { colors: colors } = (0, $756948b644e82cf2$export$559a0f07c8df6570)();
    const fillColor = color ? colors[color] : "#000";
    return (0, $4vwom.jsx)("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 50 47",
        width: 50,
        height: 47,
        fill: "none"
    }, rest, {
        children: (0, $4vwom.jsxs)("g", {
            fill: fillColor,
            children: [
                (0, $4vwom.jsx)("path", {
                    fillRule: "evenodd",
                    d: "m11.933 44.499-.09-.043c-3.692-1.78-6.565-4.503-8.506-8.101l-.032-.06-.03-.062C1.497 32.666.734 28.4.734 23.648c0-4.846.756-9.18 2.54-12.76l.03-.062.032-.06c1.95-3.616 4.853-6.305 8.598-7.968C15.678 1.071 20.163.321 25.191.321c4.994 0 9.432.739 13.085 2.477 3.828 1.649 6.773 4.34 8.628 8.028 1.927 3.603 2.745 7.962 2.745 12.822 0 4.766-.826 9.058-2.745 12.647-1.853 3.687-4.788 6.423-8.596 8.188l-.034.016-.034.015c-3.63 1.603-8.051 2.286-13.049 2.286-5.007 0-9.457-.686-13.169-2.263l-.09-.038Zm31.282-10.133c1.517-2.811 2.275-6.384 2.275-10.718 0-4.45-.758-8.081-2.275-10.892-1.4-2.811-3.616-4.861-6.649-6.15-2.916-1.405-6.707-2.108-11.374-2.108-4.666 0-8.515.703-11.548 2.108-2.916 1.289-5.133 3.339-6.65 6.15-1.399 2.81-2.099 6.442-2.099 10.892 0 4.334.7 7.907 2.1 10.718 1.516 2.81 3.733 4.919 6.649 6.325 3.033 1.288 6.882 1.932 11.548 1.932 4.667 0 8.458-.644 11.374-1.932 3.033-1.406 5.25-3.514 6.65-6.325Z",
                    clipRule: "evenodd",
                    style: {
                        fill: fillColor,
                        fillOpacity: 1
                    }
                }),
                (0, $4vwom.jsx)("path", {
                    d: "M13.872 10.69h13.889c1.76 0 3.297.326 4.613.979 1.332.653 2.354 1.584 3.068 2.794.713 1.194 1.07 2.595 1.07 4.202 0 1.338-.285 2.508-.856 3.51a5.707 5.707 0 0 1-2.378 2.293c-1.03.541-2.236.812-3.615.812v-.239c1.601 0 2.838.207 3.71.62.888.415 1.49.948 1.807 1.6.317.653.476 1.402.476 2.245v6.925h-4.28V29.96c0-.828-.151-1.48-.453-1.958-.285-.478-.729-.82-1.331-1.027-.603-.207-1.395-.31-2.378-.31h-3.401l.523-.908 4.519 5.636h-4.139l-5.136-6.448 5.113-6.447h4.162l-4.519 5.636-.523-.956h3.757c1.443 0 2.584-.405 3.425-1.217.856-.812 1.284-1.903 1.284-3.272 0-1.4-.468-2.491-1.403-3.271-.92-.796-2.212-1.194-3.877-1.194h-8.846v22.207h-4.28V10.69Z",
                    style: {
                        fill: fillColor,
                        fillOpacity: 1
                    }
                })
            ]
        })
    }));
}





var $lhaLc = parcelRequire("lhaLc");





var $4vwom = parcelRequire("4vwom");

var $lhaLc = parcelRequire("lhaLc");

function $749455cffd38c931$export$36a4adf75fa19dd1(props) {
    const { colors: colors } = (0, $756948b644e82cf2$export$559a0f07c8df6570)();
    const fillColor = props.color ? colors[props.color] : "currentColor";
    return (0, $4vwom.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        css: (0, $lhaLc.css)($749455cffd38c931$var$svgCss, props.state === "close" ? (0, $lhaLc.css)`
                          > rect {
                              transform-origin: center;
                              animation: ${$749455cffd38c931$var$animation} ${props.duration || "400ms"} normal forwards;
                          }
                      ` : {}),
        children: [
            (0, $4vwom.jsx)("rect", {
                className: "top",
                x: "4",
                y: "8",
                width: "16",
                height: "2",
                fill: fillColor
            }),
            (0, $4vwom.jsx)("rect", {
                className: "bottom",
                x: "4",
                y: "14",
                width: "16",
                height: "2",
                fill: fillColor
            })
        ]
    });
}
const $749455cffd38c931$var$animation = (0, $lhaLc.keyframes)`
    0% {
        transform: rotate(0deg) translate(0px);
    }
    40% {
        transform: 
            rotate(0deg)
            translate(0, calc(var(--icon-translation-size) * var(--factor) * 1px));
    }
    100% {
        transform: 
            rotate(calc(45deg * var(--factor)))
            translate(0, calc(var(--icon-translation-size) * var(--factor) * 1px));
    }
`;
const $749455cffd38c931$var$svgCss = (0, $lhaLc.css)`
    --icon-size: 9;
    --icon-bar-size: 3;
    --icon-translation-size: calc((var(--icon-size) - var(--icon-bar-size)) / 2);

    .top {
        --factor: 1;
    }

    .bottom {
        --factor: -1;
    }
`;



var $34lt5 = parcelRequire("34lt5");
parcelRequire("2LTO8");
var $iXeBy = parcelRequire("iXeBy");


function $9333a111b536c412$export$a2e1539ef2c4f956(props) {
    var _a;
    const { colors: colors, helpers: helpers, screenSizes: screenSizes } = (0, $756948b644e82cf2$export$559a0f07c8df6570)();
    const { responsiveCss: responsiveCss } = helpers;
    const [isOpen, setIsOpen] = (0, $eeH7J.useState)(false);
    const [openAnimationComplete, setOpenAnimationComplete] = (0, $eeH7J.useState)(false);
    const [modalContentRef, animateModalContent] = (0, $4c4e7486a769eecb$export$9f387b98a73b1511)();
    const [modalRef, animateModal] = (0, $4c4e7486a769eecb$export$9f387b98a73b1511)();
    const triggerButtonRef = (0, $eeH7J.useRef)(null);
    const getModalWidth = (0, $eeH7J.useCallback)(()=>{
        var _a;
        if (triggerButtonRef.current) {
            const rect = triggerButtonRef.current.getBoundingClientRect();
            const viewportWidth = document.body.clientWidth;
            if (viewportWidth < screenSizes.sm) {
                const marginRight = viewportWidth - rect.right;
                const modalWidth = viewportWidth - marginRight * 2;
                return modalWidth;
            }
        }
        return ((_a = modalContentRef.current) === null || _a === void 0 ? void 0 : _a.clientWidth) || 0;
    }, [
        screenSizes.sm,
        modalContentRef
    ]);
    const toggleOpen = (0, $eeH7J.useCallback)(()=>{
        var _a;
        if (!isOpen) {
            const modalWidth = getModalWidth();
            animateModal(modalRef.current, {
                boxShadow: $e665a5c3bf2ac3f6$export$16e1fc8de5cd9687,
                backgroundColor: colors.grayWhite,
                height: ((_a = modalContentRef.current) === null || _a === void 0 ? void 0 : _a.clientHeight) || 0,
                width: modalWidth
            }, {
                onComplete: ()=>{
                    setOpenAnimationComplete(true);
                    animateModalContent(modalContentRef.current, {
                        opacity: 1
                    });
                }
            });
        } else animateModal(modalRef.current, {
            opacity: 0
        }, {
            onComplete: ()=>{
                setOpenAnimationComplete(false);
                animateModalContent(modalContentRef.current, {
                    opacity: 0
                }, {
                    duration: 0
                });
                animateModal(modalRef.current, {
                    boxShadow: "none",
                    backgroundColor: colors.gray100,
                    height: 48 * (0, $1c2a8fb378443a1d$export$adc5746a202ff4b),
                    width: 48 * (0, $1c2a8fb378443a1d$export$adc5746a202ff4b),
                    opacity: 1
                }, {
                    duration: 0
                });
            }
        });
        setIsOpen(!isOpen);
    }, [
        isOpen,
        getModalWidth,
        animateModal,
        modalRef,
        colors.grayWhite,
        colors.gray100,
        modalContentRef,
        animateModalContent
    ]);
    const handleResize = (0, $eeH7J.useCallback)(()=>{
        if (isOpen && openAnimationComplete) animateModal(modalRef.current, {
            width: getModalWidth()
        }, {
            duration: 0
        });
    }, [
        getModalWidth,
        isOpen,
        animateModal,
        modalRef,
        openAnimationComplete
    ]);
    (0, $eeH7J.useEffect)(()=>{
        const resizeObserver = new ResizeObserver(handleResize);
        resizeObserver.observe(document.body);
        return ()=>{
            resizeObserver.disconnect();
        };
    }, [
        getModalWidth,
        handleResize
    ]);
    (0, $eeH7J.useEffect)(()=>{
        if (typeof window !== "undefined") {
            if (isOpen) document.body.style.overflow = "hidden";
            else document.body.style.overflow = "";
        }
    }, [
        isOpen
    ]);
    return (0, $4vwom.jsx)((0, $4vwom.Fragment), {
        children: (0, $4vwom.jsxs)("div", {
            ref: triggerButtonRef,
            style: {
                position: "relative",
                height: 48 * (0, $1c2a8fb378443a1d$export$adc5746a202ff4b),
                width: 48 * (0, $1c2a8fb378443a1d$export$adc5746a202ff4b)
            },
            children: [
                (0, $4vwom.jsx)("div", {
                    style: {
                        height: 48 * (0, $1c2a8fb378443a1d$export$adc5746a202ff4b),
                        width: 48 * (0, $1c2a8fb378443a1d$export$adc5746a202ff4b),
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        cursor: "pointer",
                        zIndex: 1,
                        position: "relative",
                        backgroundColor: colors.gray100,
                        borderRadius: 24 * (0, $1c2a8fb378443a1d$export$adc5746a202ff4b)
                    },
                    children: (0, $4vwom.jsx)((0, $749455cffd38c931$export$36a4adf75fa19dd1), {
                        state: "menu"
                    })
                }),
                (0, $4vwom.jsx)((0, $4292e3b361a44985$export$caa69d61d2de10d9), {
                    transition: (0, $7f851218870bc850$export$f4e4ad51b471de36)["200"],
                    children: (0, $4vwom.jsxs)("div", {
                        ref: modalRef,
                        style: {
                            boxShadow: "none",
                            backgroundColor: colors.gray100,
                            height: 48 * (0, $1c2a8fb378443a1d$export$adc5746a202ff4b),
                            width: 48 * (0, $1c2a8fb378443a1d$export$adc5746a202ff4b),
                            opacity: 1,
                            overflow: "hidden",
                            display: "flex",
                            position: "absolute",
                            borderRadius: 24 * (0, $1c2a8fb378443a1d$export$adc5746a202ff4b),
                            top: 0,
                            right: 0,
                            zIndex: 10
                        },
                        children: [
                            (0, $4vwom.jsx)("div", {
                                style: {
                                    position: "absolute",
                                    top: 0,
                                    right: 0
                                },
                                children: (0, $4vwom.jsx)("div", {
                                    style: {
                                        height: 48 * (0, $1c2a8fb378443a1d$export$adc5746a202ff4b),
                                        width: 48 * (0, $1c2a8fb378443a1d$export$adc5746a202ff4b),
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        cursor: "pointer",
                                        zIndex: 15,
                                        position: "relative"
                                    },
                                    onClick: toggleOpen,
                                    children: (0, $4vwom.jsx)((0, $749455cffd38c931$export$36a4adf75fa19dd1), {
                                        state: isOpen ? "close" : "menu",
                                        duration: "200ms"
                                    })
                                })
                            }),
                            (0, $4vwom.jsx)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                                direction: "column",
                                style: {
                                    zIndex: 10,
                                    position: "absolute"
                                },
                                css: responsiveCss("max", "xs", {
                                    width: "100%"
                                }),
                                children: (0, $4vwom.jsxs)("div", {
                                    ref: modalContentRef,
                                    style: {
                                        flexDirection: "column",
                                        display: "flex",
                                        padding: (0, $756948b644e82cf2$export$981516ee4691055c)(24),
                                        opacity: 0
                                    },
                                    children: [
                                        (0, $4vwom.jsx)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                                            justifyContent: "space-between",
                                            margin: {
                                                bottom: (0, $756948b644e82cf2$export$981516ee4691055c)(20)
                                            },
                                            children: (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                                                alignItems: "center",
                                                children: [
                                                    (0, $4vwom.jsx)((0, $ad7a054f4530c130$export$e25e478948902b8b).div, {
                                                        animate: openAnimationComplete ? {
                                                            transform: "translateX(0px)"
                                                        } : {
                                                            transform: "translateX(-5px)"
                                                        },
                                                        children: (0, $4vwom.jsx)((0, $5K1mb.Link), {
                                                            to: "/",
                                                            onClick: toggleOpen,
                                                            children: (0, $4vwom.jsx)((0, $df8c0007eabe8257$export$45c9c5c7ee057bfb), {
                                                                width: 40,
                                                                style: {
                                                                    marginRight: 8
                                                                }
                                                            })
                                                        })
                                                    }),
                                                    props.trustpilot ? (0, $4vwom.jsx)((0, $ad7a054f4530c130$export$e25e478948902b8b).div, {
                                                        animate: openAnimationComplete ? {
                                                            transform: "translateX(0px)"
                                                        } : {
                                                            transform: "translateX(-10px)"
                                                        },
                                                        children: (0, $4vwom.jsx)((0, $d459a7d0faaadece$export$3f8d6a825279800d), {
                                                            as: "a",
                                                            href: (_a = props.trustpilot.url) === null || _a === void 0 ? void 0 : _a.valueOf(),
                                                            score: props.trustpilot.score.valueOf(),
                                                            onClick: toggleOpen,
                                                            text: props.trustpilot.text
                                                        })
                                                    }) : null
                                                ]
                                            })
                                        }),
                                        (0, $4vwom.jsx)("div", {
                                            children: props.items.slice(props.isLoggedIn ? 0 : 1, props.items.length).map((item, i)=>{
                                                var _a;
                                                return (0, $4vwom.jsx)((0, $ad7a054f4530c130$export$e25e478948902b8b).a, {
                                                    animate: openAnimationComplete ? {
                                                        transform: `translateX(0px)`
                                                    } : {
                                                        transform: `translateX(-${(props.items.length - i) * 5}px)`
                                                    },
                                                    onClick: ()=>{
                                                        if (!item.href && item.onClick) item.onClick();
                                                        toggleOpen();
                                                    },
                                                    href: (_a = item.href) === null || _a === void 0 ? void 0 : _a.valueOf(),
                                                    style: {
                                                        display: "flex",
                                                        alignItems: "center",
                                                        whiteSpace: "nowrap"
                                                    },
                                                    css: (0, $lhaLc.css)({
                                                        height: (0, $756948b644e82cf2$export$981516ee4691055c)(64)
                                                    }),
                                                    children: (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                                        variant: "heading",
                                                        level: [
                                                            "fixed",
                                                            "xs",
                                                            2
                                                        ],
                                                        children: item.text
                                                    })
                                                }, item.id);
                                            })
                                        }),
                                        (0, $4vwom.jsxs)((0, $bee1a5e35c892a21$export$e71c4d32a2263218), {
                                            motion: {
                                                animate: openAnimationComplete ? {
                                                    transform: "translateX(0px)"
                                                } : {
                                                    transform: "translateX(-5px)"
                                                }
                                            },
                                            padding: {
                                                y: (0, $756948b644e82cf2$export$981516ee4691055c)(20)
                                            },
                                            css: (0, $lhaLc.css)({
                                                borderTop: `1px solid ${colors.gray200}`,
                                                borderBottom: `1px solid ${colors.gray200}`,
                                                display: "grid",
                                                gridAutoFlow: "column",
                                                gridAutoColumns: "minmax(0, 1fr)",
                                                gap: (0, $756948b644e82cf2$export$981516ee4691055c)(20)
                                            }),
                                            children: [
                                                !props.isLoggedIn && props.login && props.account && (0, $4vwom.jsx)((0, $cc8ebb6ca3ee944d$export$235493e82cf65451), {
                                                    account: props.account,
                                                    login: props.login
                                                }),
                                                (0, $4vwom.jsx)((0, $7d8a294407b9f7e2$export$aa53e71df758134e), {
                                                    locales: props.locales || [],
                                                    currentLocale: props.currentLocale,
                                                    onLocaleChange: (l)=>{
                                                        var _a;
                                                        toggleOpen();
                                                        (_a = props.onLocaleChange) === null || _a === void 0 || _a.call(props, l);
                                                    }
                                                })
                                            ]
                                        }),
                                        (0, $4vwom.jsxs)((0, $72c5ae9e0017e167$export$4b2c32e08f77ff18), {
                                            color: "gray500",
                                            size: "md",
                                            margin: {
                                                top: (0, $756948b644e82cf2$export$981516ee4691055c)(20)
                                            },
                                            style: {
                                                opacity: 0.6,
                                                whiteSpace: "nowrap"
                                            },
                                            children: [
                                                "\xa9 ",
                                                new Date().getFullYear(),
                                                " Redoit \u2022 All rights reserved"
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                }),
                isOpen && /*#__PURE__*/ (0, $iMJCh.createPortal)((0, $4vwom.jsx)((0, $ad7a054f4530c130$export$e25e478948902b8b).div, {
                    style: {
                        position: "absolute",
                        top: 0,
                        left: 0,
                        height: "100%",
                        width: "100%",
                        zIndex: 0
                    },
                    animate: {
                        backgroundColor: "rgba(0, 0, 0, 0.32)"
                    }
                }), document.body)
            ]
        })
    });
}
(0, $eSiQ2.Component)($9333a111b536c412$export$a2e1539ef2c4f956, {
    name: "NavigationModal",
    gallery: {
        items: [
            {
                variants: [
                    {
                        props: {
                            items: [
                                {
                                    id: "1",
                                    text: "Skipped",
                                    href: (0, $iXeBy.Url)("")
                                },
                                {
                                    id: "2",
                                    text: "Hvordan det fungerer",
                                    href: (0, $iXeBy.Url)("#")
                                },
                                {
                                    id: "3",
                                    text: "Vanlige sp\xf8rsm\xe5l",
                                    href: (0, $iXeBy.Url)("#")
                                },
                                {
                                    id: "4",
                                    text: "Kontakt oss",
                                    href: (0, $iXeBy.Url)("#")
                                }
                            ],
                            trustpilot: {
                                score: 5,
                                text: "Trustpilot"
                            },
                            currentLocale: (0, $34lt5.LocaleKey)("no"),
                            onLocaleChange: (l)=>{
                                // eslint-disable-next-line no-console
                                console.log("Changed locale to", l);
                            },
                            locales: [
                                {
                                    flag: "\uD83C\uDDEC\uD83C\uDDE7",
                                    key: (0, $34lt5.LocaleKey)("en"),
                                    displayName: "English",
                                    fallback: (0, $34lt5.LocaleKey)("no")
                                },
                                {
                                    flag: "\uD83C\uDDF3\uD83C\uDDF4",
                                    key: (0, $34lt5.LocaleKey)("no"),
                                    displayName: "Norwegian"
                                }
                            ]
                        },
                        render: (cmp)=>(0, $4vwom.jsx)("div", {
                                style: {
                                    display: "flex",
                                    justifyContent: "flex-end"
                                },
                                children: cmp
                            })
                    }
                ]
            }
        ]
    }
});




var $4vwom = parcelRequire("4vwom");

var $eeH7J = parcelRequire("eeH7J");
parcelRequire("5K1mb");
var $18Pjr = parcelRequire("18Pjr");
var $18Pjr = parcelRequire("18Pjr");

var $alVaN = parcelRequire("alVaN");

var $7KZCj = parcelRequire("7KZCj");

var $dUDPg = parcelRequire("dUDPg");

var $34lt5 = parcelRequire("34lt5");

var $7FrRx = parcelRequire("7FrRx");

var $4vwom = parcelRequire("4vwom");
parcelRequire("2LTO8");
var $8h5s0 = parcelRequire("8h5s0");
/** Holds the current status code for the ongoing SSR rendering pass.
 *
 *  Changing this value will cause the current rendering to return the given status code.
 */ const $f3376239f4cdc33f$export$18dc2edb475b04ff = {
    code: 200
};


function $5fb7d8fdb47c7fea$export$38cf3de59bf684f4({ error: error }) {
    var _a, _b;
    (0, $f3376239f4cdc33f$export$18dc2edb475b04ff).code = (_a = error.status) !== null && _a !== void 0 ? _a : 500;
    const emoji = {
        401: "\uD83E\uDEE5",
        403: "\uD83D\uDEAB",
        404: "\uD83E\uDD14",
        500: "\uD83E\uDD15"
    }[(_b = error.status) !== null && _b !== void 0 ? _b : 500];
    return (0, $4vwom.jsxs)("div", {
        style: {
            padding: 64,
            height: "100%",
            width: "100%",
            position: "relative"
        },
        children: [
            (0, $4vwom.jsx)("img", {
                src: "/static/fuse.png",
                style: {
                    position: "absolute",
                    width: 94,
                    height: 42,
                    right: 64,
                    bottom: 64
                }
            }),
            (0, $4vwom.jsxs)("h1", {
                style: {
                    color: "#555"
                },
                children: [
                    emoji,
                    " ",
                    error.status,
                    " ",
                    (0, $8h5s0.prettyCamel)(error.type)
                ]
            }),
            (0, $4vwom.jsx)("p", {
                children: error.detail
            })
        ]
    });
}



var $aIeEI = parcelRequire("aIeEI");



function $9fe8ccb750b589bb$export$32c792df021ab666(props) {
    var _a, _b, _c, _d, _e, _f;
    const navigate = (0, $18Pjr.useNavigate)();
    const params = (0, $18Pjr.useParams)();
    const localize = (0, $aIeEI.useLocalize)();
    const currentLocaleContext = (0, $eeH7J.useContext)((0, $7FrRx.CurrentLocaleContext));
    const defaultLocale = (_a = (0, $dUDPg.useDefaultLocale)().data) === null || _a === void 0 ? void 0 : _a.defaultLocale;
    const page = (0, $dUDPg.useWebPage)((_b = props.locale) !== null && _b !== void 0 ? _b : currentLocaleContext.locale, params.slug);
    const { data: data, error: error } = page;
    const locale = (0, $eeH7J.useMemo)(()=>{
        var _a;
        return (_a = props.locale) !== null && _a !== void 0 ? _a : currentLocaleContext.locale;
    }, [
        currentLocaleContext.locale,
        props.locale
    ]);
    const isNavigating = (0, $eeH7J.useMemo)(()=>{
        var _a, _b;
        return params.slug !== localize((_b = (_a = page.data) === null || _a === void 0 ? void 0 : _a.page.slug) !== null && _b !== void 0 ? _b : {});
    }, [
        localize,
        (_c = page.data) === null || _c === void 0 ? void 0 : _c.page.slug,
        params.slug
    ]);
    const setLocale = (0, $eeH7J.useCallback)((l)=>{
        var _a, _b, _c, _d;
        if (currentLocaleContext.setLocale) currentLocaleContext.setLocale(l);
        if (!data) return;
        // Redirect to new locale specific path.
        const newPath = l === defaultLocale ? `/${(_b = (_a = data.page.slug) === null || _a === void 0 ? void 0 : _a[defaultLocale.toString()]) !== null && _b !== void 0 ? _b : ""}` : `/${l}/${(_d = (_c = data.page.slug) === null || _c === void 0 ? void 0 : _c[l.toString()]) !== null && _d !== void 0 ? _d : ""}`;
        navigate(newPath);
    }, [
        currentLocaleContext,
        data,
        defaultLocale,
        navigate
    ]);
    if ((data === null || data === void 0 ? void 0 : data.page.redirect) && typeof window !== "undefined") window.location.href = data.page.redirect.valueOf();
    (0, $eeH7J.useEffect)(()=>{
        const dayjsLocale = locale === (0, $34lt5.LocaleKey)("no") ? "nb" : locale.valueOf();
        const getDayjsLocale = {
            nb: ()=>(parcelRequire("jzNZd")),
            en: ()=>(parcelRequire("8Xuux")),
            sv: ()=>(parcelRequire("hiCoo"))
        };
        async function updateDayjsLocale() {
            if (typeof getDayjsLocale[dayjsLocale] === "function") {
                await getDayjsLocale[dayjsLocale]();
                (0, (/*@__PURE__*/$parcel$interopDefault($alVaN))).locale(dayjsLocale);
            }
        }
        updateDayjsLocale();
    }, [
        locale
    ]);
    if (error) {
        const ErrorScreen = (_d = props.errorScreen) !== null && _d !== void 0 ? _d : (0, $5fb7d8fdb47c7fea$export$38cf3de59bf684f4);
        return (0, $4vwom.jsx)(ErrorScreen, {
            error: error
        });
    }
    if (!data || data.page.redirect) return (0, $4vwom.jsx)((0, $4vwom.Fragment), {});
    return (0, $4vwom.jsxs)((0, $7FrRx.CurrentLocaleContext).Provider, {
        value: {
            get locale () {
                // In context of a page, always return the locale passed to the WebPage, which
                // should be determined by the URL.
                return locale;
            },
            setLocale: setLocale
        },
        children: [
            (0, $4vwom.jsx)("meta", {
                lang: (_f = (_e = props.locale) === null || _e === void 0 ? void 0 : _e.valueOf()) !== null && _f !== void 0 ? _f : currentLocaleContext.locale.valueOf()
            }),
            (0, $4vwom.jsx)($9fe8ccb750b589bb$export$6245f31671de0b04.Provider, {
                value: {
                    id: data.page.id,
                    breadcrumb: data.breadcrumb,
                    isNavigating: isNavigating
                },
                children: (0, $4vwom.jsx)((0, $7KZCj.EditableSections), Object.assign({
                    sections: data.page.sections
                }, props.EditableSectionsProps || {}))
            })
        ]
    });
}
const $9fe8ccb750b589bb$export$6245f31671de0b04 = /*#__PURE__*/ (0, $eeH7J.createContext)({
    id: undefined,
    breadcrumb: [],
    isNavigating: undefined
});


parcelRequire("2LTO8");
var $iXeBy = parcelRequire("iXeBy");

var $eeH7J = parcelRequire("eeH7J");

var $7m9cQ = parcelRequire("7m9cQ");
let $f2e2333c5543d6d8$var$loggingInWithVipps = false;
async function $f2e2333c5543d6d8$export$5eda4f58d84268b6(redirectUrl, failedRedirectUrl, serviceName = "vipps") {
    var _a;
    // Prevent multiple login attempts at the same time
    if ($f2e2333c5543d6d8$var$loggingInWithVipps) return true;
    $f2e2333c5543d6d8$var$loggingInWithVipps = true;
    try {
        const res = await fetch(`${(0, $7m9cQ.server)()}/api/${serviceName}/auth/url?redirectUrl=${encodeURIComponent(redirectUrl)}&failedRedirectUrl=${encodeURIComponent(failedRedirectUrl)}`);
        if (res.status === 200) {
            const json = await res.json();
            window.location.href = json.authUrl;
        } else {
            const error = await res.json();
            alert("Failed to start Vipps login: " + error.detail);
            return false;
        }
    } catch (e) {
        alert((_a = e.message) !== null && _a !== void 0 ? _a : e.detail);
    } finally{
        $f2e2333c5543d6d8$var$loggingInWithVipps = false;
    }
    // Should be unreachable, as the browser will be redirected to the Vipps login page in
    // the success case above
    throw new Error("Unreachable code reached in loginWithVipps");
}
function $f2e2333c5543d6d8$export$403f2aca3002ba0e(redirectUrl, failedRedirectUrl, /** In case of multiple vipps service instances, this can be used to disambiguate. */ serviceName = "vipps") {
    return (0, $eeH7J.useCallback)(async ()=>$f2e2333c5543d6d8$export$5eda4f58d84268b6(redirectUrl, failedRedirectUrl, serviceName), [
        redirectUrl,
        serviceName
    ]);
}
function $f2e2333c5543d6d8$export$7a6e57dc0a3ed9e2(/** In case of multiple vipps service instances, this can be used to disambiguate. */ serviceName = "vipps") {
    return (0, $eeH7J.useCallback)(async ()=>{
        var _a;
        try {
            const url = `${(0, $7m9cQ.server)()}/api/${serviceName}/auth/session`;
            await fetch(url, {
                method: "DELETE"
            });
        } catch (e) {
            alert((_a = e.message) !== null && _a !== void 0 ? _a : e.detail);
        }
    }, [
        serviceName
    ]);
}



var $4vwom = parcelRequire("4vwom");

var $eeH7J = parcelRequire("eeH7J");
function $87d2193cf0695c20$export$8f2dc74599543279(text, values) {
    return (0, $4vwom.jsx)((0, $4vwom.Fragment), {
        children: typeof text === "string" ? text.split("{{").flatMap((part)=>{
            if (part.includes("}}")) {
                const [key, ...rest] = part.split("}}");
                return [
                    values[key],
                    ...rest
                ];
            } else return (0, $4vwom.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).Fragment, {
                children: part
            }, part);
        }) : undefined
    });
}
function $87d2193cf0695c20$export$4493d2932fe76cf8(text, values, start = "{{", end = "}}") {
    return text.split(start).flatMap((part)=>{
        if (part.includes(end)) {
            const [key, ...rest] = part.split(end);
            return values[key] + rest.join(end);
        } else return part;
    }).join("");
}



/**
 * The header for the site. Renders the first item separate from the rest, as they are
 * to be rendered in a hamburger popup menu on mobile, while the first item should be visible
 * outside of the popup menu.
 *
 * @icon ui-menu-01
 */ function $cc8ebb6ca3ee944d$var$Header(section) {
    var _a, _b, _c, _d;
    const theme = (0, $756948b644e82cf2$export$559a0f07c8df6570)();
    const { responsiveCss: responsiveCss } = theme.helpers;
    const webPageContext = (0, $eeH7J.useContext)((0, $9fe8ccb750b589bb$export$6245f31671de0b04));
    const locales = (0, $dUDPg.useLocales)();
    const localize = (0, $aIeEI.useLocalize)();
    const header = (0, $e18f565b44c7bc7d$export$ae602290ebd82f8e)(webPageContext.id, section.id);
    const { locale: currentLocale, setLocale: setLocale } = (0, $eeH7J.useContext)((0, $7FrRx.CurrentLocaleContext));
    const defaultLocale = (_a = (0, $dUDPg.useDefaultLocale)().data) === null || _a === void 0 ? void 0 : _a.defaultLocale;
    const menuItems = (0, $eeH7J.useMemo)(()=>{
        var _a;
        return ((_a = header.data) === null || _a === void 0 ? void 0 : _a.items.map((item)=>{
            const localePath = currentLocale === defaultLocale ? "" : `/${currentLocale}`;
            const path = item.slug ? `${localePath}/${localize(item.slug)}` : "/";
            const fragment = item.section ? `#${item.section}` : "";
            const href = item.url && !item.slug ? item.url : (0, $iXeBy.Url)(`${path}${fragment}`);
            // During pre launch period, fragments and external links (items with url property)
            // should work as intended, while other links should trigger open waiting list
            // modal.
            return {
                id: item.id.valueOf(),
                // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
                href: (item.slug || item.section || item.url) && href ? href : undefined,
                text: localize(item.text),
                icon: item.icon
            };
        })) || [];
    }, [
        (_b = header.data) === null || _b === void 0 ? void 0 : _b.items,
        currentLocale,
        defaultLocale,
        localize
    ]);
    const handleLocaleChange = (0, $eeH7J.useCallback)((l)=>{
        if (setLocale) setLocale(l);
    }, [
        setLocale
    ]);
    const me = (0, $e18f565b44c7bc7d$export$f637e1cf42d15a62)();
    if (header.loading || !header.data) return (0, $4vwom.jsx)((0, $4vwom.Fragment), {});
    return (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
        as: "nav",
        alignItems: "center",
        css: (0, $lhaLc.css)({
            height: (0, $756948b644e82cf2$export$981516ee4691055c)(100)
        }),
        children: [
            (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                alignItems: "center",
                style: {
                    width: "100%"
                },
                children: [
                    (0, $4vwom.jsx)((0, $5K1mb.Link), {
                        to: `/${currentLocale === defaultLocale ? "" : currentLocale}`,
                        children: (0, $4vwom.jsx)((0, $67cf5539992d1dd3$export$e6ff31bff12b7ff4), {
                            css: (0, $lhaLc.css)({
                                width: (0, $756948b644e82cf2$export$981516ee4691055c)(114),
                                height: "auto",
                                marginRight: (0, $756948b644e82cf2$export$981516ee4691055c)(8)
                            }, responsiveCss("min", "md", {
                                marginRight: $cc8ebb6ca3ee944d$var$scale16
                            }))
                        })
                    }),
                    header.data.trustpilot ? (0, $4vwom.jsx)("div", {
                        css: (0, $lhaLc.css)(responsiveCss("max", "sm", {
                            display: "none"
                        })),
                        children: (0, $4vwom.jsx)((0, $bee1a5e35c892a21$export$e71c4d32a2263218), {
                            margin: {
                                right: $cc8ebb6ca3ee944d$var$scale16
                            },
                            children: (0, $4vwom.jsx)((0, $d459a7d0faaadece$export$3f8d6a825279800d), Object.assign({
                                score: header.data.trustpilot.score.valueOf(),
                                text: localize(header.data.trustpilot.text)
                            }, header.data.trustpilot.url ? {
                                as: "a",
                                href: header.data.trustpilot.url.valueOf(),
                                target: "_blank"
                            } : {}))
                        })
                    }) : null,
                    (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                        css: (0, $lhaLc.css)(responsiveCss("max", "lg", {
                            display: "none"
                        })),
                        children: [
                            !!menuItems[0] && (0, $4vwom.jsx)($cc8ebb6ca3ee944d$var$MenuItem, Object.assign({}, menuItems[0])),
                            menuItems.slice(1, menuItems.length).map((item)=>(0, $4vwom.jsx)($cc8ebb6ca3ee944d$var$MenuItem, Object.assign({}, item), item.id))
                        ]
                    })
                ]
            }),
            (0, $4vwom.jsx)("div", {
                css: (0, $lhaLc.css)(responsiveCss("max", "lg", {
                    display: "none"
                })),
                children: header.data.login && header.data.account ? (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                    gap: 8,
                    children: [
                        (0, $4vwom.jsx)((0, $7d8a294407b9f7e2$export$aa53e71df758134e), {
                            locales: locales.data || [],
                            currentLocale: currentLocale,
                            onLocaleChange: handleLocaleChange
                        }),
                        (0, $4vwom.jsx)($cc8ebb6ca3ee944d$export$235493e82cf65451, {
                            user: me.data,
                            account: header.data.account,
                            login: header.data.login
                        })
                    ]
                }) : null
            }),
            (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                gap: 6,
                css: (0, $lhaLc.css)(responsiveCss("min", "xl", {
                    display: "none"
                })),
                children: [
                    !me.loading && (((_c = me.data) === null || _c === void 0 ? void 0 : _c.anonymous) ? !!menuItems[0] && (0, $4vwom.jsx)($cc8ebb6ca3ee944d$var$MenuItem, Object.assign({}, menuItems[0])) : header.data.account && header.data.login ? (0, $4vwom.jsx)($cc8ebb6ca3ee944d$export$235493e82cf65451, {
                        user: me.data,
                        account: header.data.account,
                        login: header.data.login
                    }) : null),
                    (0, $4vwom.jsx)((0, $9333a111b536c412$export$a2e1539ef2c4f956), {
                        items: menuItems,
                        isLoggedIn: !((_d = me.data) === null || _d === void 0 ? void 0 : _d.anonymous),
                        trustpilot: header.data.trustpilot ? {
                            score: header.data.trustpilot.score,
                            text: localize(header.data.trustpilot.text),
                            url: header.data.trustpilot.url
                        } : undefined,
                        locales: locales.data || [],
                        currentLocale: currentLocale,
                        onLocaleChange: handleLocaleChange,
                        account: header.data.account,
                        login: header.data.login
                    })
                ]
            })
        ]
    });
}
function $cc8ebb6ca3ee944d$var$MenuItem(props) {
    var _a;
    const { colors: colors, helpers: helpers, buttonSizes: buttonSizes, buttonVariants: buttonVariants } = (0, $756948b644e82cf2$export$559a0f07c8df6570)();
    const { responsiveHeadingLevel: responsiveHeadingLevel, responsiveCss: responsiveCss, variantCss: variantCss, responsiveVariantsCss: responsiveVariantsCss } = helpers;
    const { menuItemCss: menuItemCss, spacer: spacer } = (0, $eeH7J.useMemo)(()=>({
            menuItemCss: (0, $lhaLc.css)([
                {
                    cursor: "pointer",
                    height: (0, $756948b644e82cf2$export$981516ee4691055c)(48),
                    textDecoration: "none",
                    whiteSpace: "nowrap"
                },
                responsiveHeadingLevel(4),
                responsiveCss("max", "lg", (0, $lhaLc.css)(variantCss(buttonVariants, "secondary"), responsiveVariantsCss(buttonSizes, "sm")))
            ]),
            spacer: (0, $lhaLc.css)({
                alignItems: "center"
            }, helpers.responsiveCss("min", "xl", {
                ":after": {
                    content: '""',
                    width: 1,
                    height: 20,
                    backgroundColor: colors.gray200,
                    marginLeft: $cc8ebb6ca3ee944d$var$scale16,
                    marginRight: $cc8ebb6ca3ee944d$var$scale16
                },
                ":last-of-type:after": {
                    display: "none"
                }
            }))
        }), [
        responsiveHeadingLevel,
        responsiveCss,
        variantCss,
        buttonVariants,
        responsiveVariantsCss,
        buttonSizes,
        helpers,
        colors.gray200
    ]);
    return (0, $4vwom.jsx)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
        css: (0, $lhaLc.css)(spacer),
        children: (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
            as: "a",
            href: (_a = props.href) === null || _a === void 0 ? void 0 : _a.valueOf(),
            padding: {
                y: (0, $756948b644e82cf2$export$981516ee4691055c)(12),
                x: $cc8ebb6ca3ee944d$var$scale16
            },
            alignItems: "center",
            css: menuItemCss,
            onClick: props.onClick,
            children: [
                props.icon && (0, $4vwom.jsx)((0, $f8cdd04128a131cf$export$f04a61298a47a40f), {
                    icon: props.icon,
                    margin: {
                        right: (0, $756948b644e82cf2$export$981516ee4691055c)(8)
                    }
                }),
                props.text
            ]
        })
    });
}
const $cc8ebb6ca3ee944d$var$scale16 = (0, $756948b644e82cf2$export$981516ee4691055c)(16);
function $cc8ebb6ca3ee944d$export$235493e82cf65451(props) {
    var _a, _b, _c, _d, _e;
    const location = (0, $18Pjr.useLocation)();
    const localize = (0, $aIeEI.useLocalize)();
    const accountPageInfo = (0, $dUDPg.useWebPageInfo)(props.account.page);
    const loginWithVipps = (0, $f2e2333c5543d6d8$export$403f2aca3002ba0e)(((_a = accountPageInfo.data) === null || _a === void 0 ? void 0 : _a.slug) ? "/" + localize(accountPageInfo.data.slug) : "/", location.pathname // Go back where we came from if login fails
    );
    return !!props.user && !props.user.anonymous ? (0, $4vwom.jsx)("div", {
        children: (0, $4vwom.jsx)((0, $4b4086f8a1c6b2f8$export$353f5b6fc5456de1), {
            variant: "profile",
            size: "sm",
            onClick: ((_b = accountPageInfo.data) === null || _b === void 0 ? void 0 : _b.slug) ? undefined : ()=>alert("Missing account page config in header config."),
            as: "a",
            href: ((_c = accountPageInfo.data) === null || _c === void 0 ? void 0 : _c.slug) ? `/${localize(accountPageInfo.data.slug)}` : undefined,
            iconStart: props.account.icon,
            children: (0, $87d2193cf0695c20$export$4493d2932fe76cf8)(localize(props.account.text), {
                givenName: (_d = props.user.givenName) !== null && _d !== void 0 ? _d : "",
                familyName: (_e = props.user.familyName) !== null && _e !== void 0 ? _e : ""
            })
        })
    }) : (0, $4vwom.jsx)((0, $4b4086f8a1c6b2f8$export$353f5b6fc5456de1), {
        variant: "dark",
        size: "sm",
        onClick: ()=>{
            loginWithVipps();
        },
        children: (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
            variant: "heading",
            level: 4,
            children: localize(props.login.text)
        })
    });
}
(0, $9G56J.Section)("Header", $cc8ebb6ca3ee944d$var$Header);



var $4vwom = parcelRequire("4vwom");

var $lhaLc = parcelRequire("lhaLc");

var $9G56J = parcelRequire("9G56J");

var $4vwom = parcelRequire("4vwom");

var $lhaLc = parcelRequire("lhaLc");

var $eSiQ2 = parcelRequire("eSiQ2");
parcelRequire("2LTO8");
var $14q7s = parcelRequire("14q7s");
var $iXeBy = parcelRequire("iXeBy");
var $dAwef = parcelRequire("dAwef");

var $7m9cQ = parcelRequire("7m9cQ");



var $eeH7J = parcelRequire("eeH7J");
const $52a8e4eb4bf14158$var$defaultSpeed = 30;
function $52a8e4eb4bf14158$export$a5e58535c47c4073(props) {
    const ref = (0, $eeH7J.useRef)(null);
    const [width, setWidth] = (0, $eeH7J.useState)(0);
    (0, $eeH7J.useEffect)(()=>{
        var _a;
        setWidth(((_a = ref.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect().width) || 0);
    }, []);
    const animationDuration = (0, $eeH7J.useMemo)(()=>{
        var _a;
        return `${width / ((_a = props.speed) !== null && _a !== void 0 ? _a : $52a8e4eb4bf14158$var$defaultSpeed) * 1000}ms`;
    }, [
        props.speed,
        width
    ]);
    return (0, $4vwom.jsxs)("div", {
        style: {
            position: "relative",
            overflow: "hidden",
            flexWrap: "nowrap",
            display: "flex",
            width: "100%",
            height: "100%",
            maxWidth: "100%",
            maxHeight: "100%"
        },
        css: $52a8e4eb4bf14158$var$containerCss,
        children: [
            (0, $4vwom.jsx)("div", {
                ref: ref,
                style: {
                    animationDuration: animationDuration
                },
                css: [
                    $52a8e4eb4bf14158$var$responsiveGridCss,
                    $52a8e4eb4bf14158$var$animationCss
                ],
                children: props.logos.map((l)=>(0, $4vwom.jsx)((0, $bee1a5e35c892a21$export$e71c4d32a2263218), Object.assign({
                        css: $52a8e4eb4bf14158$var$responsiveItemCss
                    }, l.url ? {
                        as: "a",
                        href: l.url.valueOf(),
                        target: "_blank"
                    } : {}, {
                        children: (0, $4vwom.jsx)("img", {
                            src: (0, $14q7s.ImageToUrl)(l.image, {
                                width: 300
                            }),
                            style: {
                                width: "auto",
                                height: "100%"
                            }
                        })
                    }), l.id.valueOf()))
            }),
            (0, $4vwom.jsx)("div", {
                style: {
                    animationDuration: animationDuration
                },
                css: [
                    $52a8e4eb4bf14158$var$responsiveGridCss,
                    $52a8e4eb4bf14158$var$animationCss
                ],
                children: props.logos.map((l)=>(0, $4vwom.jsx)((0, $bee1a5e35c892a21$export$e71c4d32a2263218), Object.assign({
                        css: $52a8e4eb4bf14158$var$responsiveItemCss
                    }, l.url ? {
                        as: "a",
                        href: l.url.valueOf(),
                        target: "_blank"
                    } : {}, {
                        children: (0, $4vwom.jsx)("img", {
                            src: (0, $14q7s.ImageToUrl)(l.image, {
                                width: 300
                            }),
                            style: {
                                width: "auto",
                                height: "100%"
                            }
                        })
                    }), l.id.valueOf()))
            })
        ]
    });
}
const $52a8e4eb4bf14158$var$marquee = (0, $lhaLc.keyframes)({
    from: {
        transform: "translateX(-100%)"
    },
    to: {
        transform: "translateX(0%)"
    }
});
const $52a8e4eb4bf14158$var$animationCss = (0, $lhaLc.css)({
    animationName: $52a8e4eb4bf14158$var$marquee
});
const $52a8e4eb4bf14158$var$responsiveGridCss = (0, $lhaLc.css)({
    display: "inline-flex",
    alignItems: "center",
    animationIterationCount: "infinite",
    animationTimingFunction: "linear"
});
const $52a8e4eb4bf14158$var$containerCss = (0, $lhaLc.css)({
    maxHeight: 24,
    "&:hover div": {
        animationPlayState: "paused"
    },
    "&:before, &:after": {
        content: '""',
        position: "absolute",
        top: 0,
        bottom: 0,
        width: 50,
        zIndex: 1,
        pointerEvents: "none"
    },
    "&:before": {
        left: 0,
        background: "linear-gradient(270deg, rgba(255, 255,255,0), rgba(255, 255,255,1))"
    },
    "&:after": {
        right: 0,
        background: "linear-gradient(90deg, rgba(255, 255,255,0), rgba(255, 255,255,1))"
    }
}, (0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("min", "md", {
    maxHeight: 80,
    "&:before, &:after": {
        width: 360,
        maxHeight: 80
    }
}));
const $52a8e4eb4bf14158$var$responsiveItemCss = (0, $lhaLc.css)({
    display: "flex",
    justifyContent: "center",
    margin: "0 20px",
    height: "100%",
    maxHeight: "100%"
}, (0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("min", "md", {
    margin: "0 40px"
}));
(0, $eSiQ2.Component)($52a8e4eb4bf14158$export$a5e58535c47c4073, {
    name: "PressLogosCarousel",
    gallery: {
        items: [
            {
                variants: [
                    {
                        props: {
                            logos: [
                                {
                                    id: (0, $dAwef.Uuid)(),
                                    image: `${(0, $7m9cQ.server)()}/static/redoit/press-logo-1.svg`,
                                    url: (0, $iXeBy.Url)("https://www.hollywoodreporter.com")
                                },
                                {
                                    id: (0, $dAwef.Uuid)(),
                                    image: `${(0, $7m9cQ.server)()}/static/redoit/press-logo-2.svg`
                                },
                                {
                                    id: (0, $dAwef.Uuid)(),
                                    image: `${(0, $7m9cQ.server)()}/static/redoit/press-logo-3.svg`
                                },
                                {
                                    id: (0, $dAwef.Uuid)(),
                                    image: `${(0, $7m9cQ.server)()}/static/redoit/press-logo-4.svg`
                                }
                            ]
                        }
                    }
                ]
            }
        ]
    }
});






var $aIeEI = parcelRequire("aIeEI");

function $5604714ee1f91832$var$PressLogos(section) {
    const localize = (0, $aIeEI.useLocalize)();
    return (0, $4vwom.jsxs)("div", {
        css: (0, $lhaLc.css)({
            display: "flex",
            flexDirection: "column"
        }, (0, $756948b644e82cf2$export$f1cf1885b6bfef23)()),
        children: [
            !!section.heading && (0, $4vwom.jsx)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                alignItems: "center",
                justifyContent: "space-between",
                children: (0, $4vwom.jsx)((0, $789b8639be592288$export$a8a3e93435678ff9), {
                    level: 2,
                    padding: {
                        y: 8
                    },
                    truncate: true,
                    children: localize(section.heading)
                })
            }),
            !!section.text && (0, $4vwom.jsx)((0, $72c5ae9e0017e167$export$4b2c32e08f77ff18), {
                size: "lg",
                color: "gray400",
                margin: {
                    bottom: "sm"
                },
                children: localize(section.text)
            }),
            (0, $4vwom.jsx)((0, $52a8e4eb4bf14158$export$a5e58535c47c4073), {
                logos: section.logos,
                speed: section.carouselSpeed
            })
        ]
    });
}
(0, $9G56J.Section)($5604714ee1f91832$var$PressLogos);



var $4vwom = parcelRequire("4vwom");

var $eeH7J = parcelRequire("eeH7J");

var $5K1mb = parcelRequire("5K1mb");

var $lhaLc = parcelRequire("lhaLc");

var $9G56J = parcelRequire("9G56J");


var $aIeEI = parcelRequire("aIeEI");

var $dUDPg = parcelRequire("dUDPg");

var $7FrRx = parcelRequire("7FrRx");

var $aIeEI = parcelRequire("aIeEI");

var $eeH7J = parcelRequire("eeH7J");
function $02ba3a727a0f8ecd$export$32f719dfac03c1cb() {
    var _a;
    const localize = (0, $aIeEI.useLocalize)();
    const defaultLocale = (_a = (0, $dUDPg.useDefaultLocale)().data) === null || _a === void 0 ? void 0 : _a.defaultLocale;
    const { locale: locale } = (0, $eeH7J.useContext)((0, $7FrRx.CurrentLocaleContext));
    const localePath = locale === defaultLocale ? "" : `/${locale}`;
    return (slug)=>slug ? `${localePath}/${localize(slug)}` : "/";
}




var $dUDPg = parcelRequire("dUDPg");


var $4vwom = parcelRequire("4vwom");

var $eeH7J = parcelRequire("eeH7J");

var $5K1mb = parcelRequire("5K1mb");

var $lhaLc = parcelRequire("lhaLc");
parcelRequire("jniej");
var $eK8Q4 = parcelRequire("eK8Q4");
parcelRequire("2LTO8");
var $dAwef = parcelRequire("dAwef");


var $aIeEI = parcelRequire("aIeEI");

var $9G56J = parcelRequire("9G56J");

var $eeH7J = parcelRequire("eeH7J");

var $4vwom = parcelRequire("4vwom");

var $eeH7J = parcelRequire("eeH7J");

var $lhaLc = parcelRequire("lhaLc");

var $aIeEI = parcelRequire("aIeEI");

var $4vwom = parcelRequire("4vwom");

var $lhaLc = parcelRequire("lhaLc");

var $eSiQ2 = parcelRequire("eSiQ2");








function $fc70c197a228049f$export$ecfb84f4ec12058a(props) {
    const { colors: colors } = (0, $756948b644e82cf2$export$559a0f07c8df6570)();
    return (0, $4vwom.jsx)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
        role: "button",
        "aria-label": props.primary,
        onClick: props.onClick,
        backgroundColor: props.selected ? "brandLight" : "grayWhite",
        borderColor: props.selected ? "brand" : "gray200",
        borderRadius: "md",
        padding: "md",
        style: Object.assign({
            cursor: "pointer",
            transitionProperty: "background-color, border-color",
            transitionDuration: "0.30s"
        }, props.style),
        children: (0, $4vwom.jsxs)("div", {
            style: {
                display: "grid",
                width: "100%"
            },
            css: (0, $lhaLc.css)((0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("max", "sm", {
                gap: 8
            }), (0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("min", "md", {
                gridTemplateColumns: "0.56fr 1fr",
                gap: 40
            })),
            children: [
                (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                    gap: 8,
                    justifyContent: "space-between",
                    css: (0, $lhaLc.css)((0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("max", "sm", {
                        flexDirection: "column-reverse"
                    }), (0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("min", "md", {
                        flexDirection: "column"
                    })),
                    children: [
                        typeof props.primary !== "undefined" && (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                            variant: "heading",
                            level: 3,
                            color: "brand",
                            children: props.primary
                        }),
                        typeof props.secondary !== "undefined" && (typeof props.secondary === "string" ? (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                            variant: "body",
                            size: "xl",
                            children: props.secondary
                        }) : (0, $4vwom.jsxs)("span", {
                            css: (0, $lhaLc.css)((0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("max", "sm", {
                                color: colors.brand,
                                fontWeight: 600
                            })),
                            children: [
                                (0, $4vwom.jsxs)("span", {
                                    css: (0, $lhaLc.css)((0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("max", "sm", {
                                        display: "none"
                                    })),
                                    children: [
                                        (0, $4vwom.jsxs)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                            as: "span",
                                            variant: "heading",
                                            level: 3,
                                            children: [
                                                props.secondary.price,
                                                " ",
                                                props.secondary.currency
                                            ]
                                        }),
                                        "/",
                                        props.secondary.period
                                    ]
                                }),
                                (0, $4vwom.jsx)("span", {
                                    css: (0, $lhaLc.css)((0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("min", "md", {
                                        display: "none"
                                    })),
                                    children: (0, $4vwom.jsxs)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                        as: "span",
                                        variant: "heading",
                                        level: 3,
                                        style: {
                                            fontWeight: 600
                                        },
                                        children: [
                                            props.secondary.price,
                                            " ",
                                            props.secondary.currency,
                                            " ",
                                            props.secondary.period,
                                            "."
                                        ]
                                    })
                                })
                            ]
                        }))
                    ]
                }),
                (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                    direction: "column",
                    justifyContent: "space-between",
                    children: [
                        typeof props.list !== "undefined" ? (0, $4vwom.jsx)("ul", {
                            css: (0, $e82ba787de72625c$export$6b6f359a824920a4)("ul"),
                            children: props.list.map((item)=>{
                                var _a;
                                return (0, $4vwom.jsxs)("li", {
                                    style: {
                                        display: "flex",
                                        alignItems: "center",
                                        gap: 8,
                                        marginBottom: 2
                                    },
                                    children: [
                                        (0, $4vwom.jsx)((0, $f8cdd04128a131cf$export$f04a61298a47a40f), {
                                            icon: (_a = item.icon) !== null && _a !== void 0 ? _a : "check",
                                            color: "brand"
                                        }),
                                        (0, $4vwom.jsx)((0, $72c5ae9e0017e167$export$4b2c32e08f77ff18), {
                                            size: "md",
                                            color: "gray400",
                                            children: item.text
                                        })
                                    ]
                                }, item.id);
                            })
                        }) : null,
                        typeof props.text !== "undefined" && (0, $4vwom.jsxs)("div", {
                            css: (0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("min", "md", {
                                display: "flex",
                                alignItems: "center",
                                gap: 8
                            }),
                            children: [
                                (0, $4vwom.jsx)((0, $f8cdd04128a131cf$export$f04a61298a47a40f), {
                                    icon: "check",
                                    css: (0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("max", "sm", {
                                        display: "none"
                                    }),
                                    style: {
                                        opacity: 0
                                    },
                                    "aria-hidden": true
                                }),
                                (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                    variant: "body",
                                    size: "md",
                                    color: "gray400",
                                    children: (0, $4vwom.jsx)((0, $82d66b15b8f4758d$export$d5163f1ce1e6a5f9), {
                                        value: props.text
                                    })
                                })
                            ]
                        }),
                        typeof props.link !== "undefined" && (0, $4vwom.jsx)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                            justifyContent: "flex-end",
                            css: (0, $lhaLc.css)((0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("max", "sm", {
                                marginTop: 8
                            }), (0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("min", "md", {
                                marginTop: (0, $756948b644e82cf2$export$981516ee4691055c)(24)
                            })),
                            children: "onClick" in props.link ? (0, $4vwom.jsx)("button", {
                                onClick: props.link.onClick,
                                css: (0, $lhaLc.css)((0, $e82ba787de72625c$export$6b6f359a824920a4)("button")),
                                children: (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                    variant: "body",
                                    size: "sm",
                                    color: "gray400",
                                    underline: true,
                                    children: props.link.text
                                })
                            }) : (0, $4vwom.jsx)("a", {
                                href: "url" in props.link ? props.link.url : undefined,
                                children: (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                    variant: "body",
                                    size: "sm",
                                    color: "gray400",
                                    underline: true,
                                    children: props.link.text
                                })
                            })
                        })
                    ]
                })
            ]
        })
    });
}
(0, $eSiQ2.Component)($fc70c197a228049f$export$ecfb84f4ec12058a, {
    name: "BoxSelection",
    gallery: {
        path: "Controllers/BoxSelection",
        items: [
            {
                title: "Selected",
                variants: [
                    {
                        props: {
                            primary: "Trygghetspakke",
                            secondary: "50 kr/md",
                            list: [
                                {
                                    id: "abc123",
                                    text: "Erstatning ved tyveri/tap mot egenandel."
                                },
                                {
                                    id: "abc456",
                                    text: "Send mobilen inn gratis."
                                },
                                {
                                    id: "abc789",
                                    text: "Motta direkte betaling til din konto."
                                }
                            ],
                            link: {
                                text: "Vilk\xe5r og betingelser",
                                url: "#"
                            },
                            selected: true
                        }
                    }
                ]
            },
            {
                title: "Not selected",
                variants: [
                    {
                        props: {
                            secondary: "Ingen trygghetspakke",
                            text: "Du er selv ansvarlig for verdien av mobilen, som er 10 000 kr, hvis den blir skadet, mistet eller stj\xe5let."
                        }
                    }
                ]
            }
        ]
    }
});








var $4vwom = parcelRequire("4vwom");

var $eeH7J = parcelRequire("eeH7J");

var $iMJCh = parcelRequire("iMJCh");

var $lhaLc = parcelRequire("lhaLc");


var $eSiQ2 = parcelRequire("eSiQ2");

var $dRzna = parcelRequire("dRzna");

var $eeH7J = parcelRequire("eeH7J");

var $dRzna = parcelRequire("dRzna");

var $eeH7J = parcelRequire("eeH7J");



var $dRzna = parcelRequire("dRzna");

var $eeH7J = parcelRequire("eeH7J");

"use client";
/**
 * Measurement functionality has to be within a separate component
 * to leverage snapshot lifecycle.
 */ class $52e1d3df9689883d$var$PopChildMeasure extends $eeH7J.Component {
    getSnapshotBeforeUpdate(prevProps) {
        const element = this.props.childRef.current;
        if (element && prevProps.isPresent && !this.props.isPresent) {
            const size = this.props.sizeRef.current;
            size.height = element.offsetHeight || 0;
            size.width = element.offsetWidth || 0;
            size.top = element.offsetTop;
            size.left = element.offsetLeft;
        }
        return null;
    }
    /**
     * Required with getSnapshotBeforeUpdate to stop React complaining.
     */ componentDidUpdate() {}
    render() {
        return this.props.children;
    }
}
function $52e1d3df9689883d$export$1d6cdde0c6816c6d({ children: children, isPresent: isPresent }) {
    const id = (0, $eeH7J.useId)();
    const ref = (0, $eeH7J.useRef)(null);
    const size = (0, $eeH7J.useRef)({
        width: 0,
        height: 0,
        top: 0,
        left: 0
    });
    const { nonce: nonce } = (0, $eeH7J.useContext)((0, $f79c9a1bd76bed7c$export$22a697fb29aac98d));
    /**
     * We create and inject a style block so we can apply this explicit
     * sizing in a non-destructive manner by just deleting the style block.
     *
     * We can't apply size via render as the measurement happens
     * in getSnapshotBeforeUpdate (post-render), likewise if we apply the
     * styles directly on the DOM node, we might be overwriting
     * styles set via the style prop.
     */ (0, $eeH7J.useInsertionEffect)(()=>{
        const { width: width, height: height, top: top, left: left } = size.current;
        if (isPresent || !ref.current || !width || !height) return;
        ref.current.dataset.motionPopId = id;
        const style = document.createElement("style");
        if (nonce) style.nonce = nonce;
        document.head.appendChild(style);
        if (style.sheet) style.sheet.insertRule(`
          [data-motion-pop-id="${id}"] {
            position: absolute !important;
            width: ${width}px !important;
            height: ${height}px !important;
            top: ${top}px !important;
            left: ${left}px !important;
          }
        `);
        return ()=>{
            document.head.removeChild(style);
        };
    }, [
        isPresent
    ]);
    return (0, $dRzna.jsx)($52e1d3df9689883d$var$PopChildMeasure, {
        isPresent: isPresent,
        childRef: ref,
        sizeRef: size,
        children: $eeH7J.cloneElement(children, {
            ref: ref
        })
    });
}


"use client";
const $00fc35aff96a3476$export$979daf65881a382a = ({ children: children, initial: initial, isPresent: isPresent, onExitComplete: onExitComplete, custom: custom, presenceAffectsLayout: presenceAffectsLayout, mode: mode })=>{
    const presenceChildren = (0, $450f33b6a8740b8a$export$fe4300aa8eebea86)($00fc35aff96a3476$var$newChildrenMap);
    const id = (0, $eeH7J.useId)();
    const context = (0, $eeH7J.useMemo)(()=>({
            id: id,
            initial: initial,
            isPresent: isPresent,
            custom: custom,
            onExitComplete: (childId)=>{
                presenceChildren.set(childId, true);
                for (const isComplete of presenceChildren.values()){
                    if (!isComplete) return; // can stop searching when any is incomplete
                }
                onExitComplete && onExitComplete();
            },
            register: (childId)=>{
                presenceChildren.set(childId, false);
                return ()=>presenceChildren.delete(childId);
            }
        }), /**
     * If the presence of a child affects the layout of the components around it,
     * we want to make a new context value to ensure they get re-rendered
     * so they can detect that layout change.
     */ presenceAffectsLayout ? [
        Math.random()
    ] : [
        isPresent
    ]);
    (0, $eeH7J.useMemo)(()=>{
        presenceChildren.forEach((_, key)=>presenceChildren.set(key, false));
    }, [
        isPresent
    ]);
    /**
     * If there's no `motion` components to fire exit animations, we want to remove this
     * component immediately.
     */ $eeH7J.useEffect(()=>{
        !isPresent && !presenceChildren.size && onExitComplete && onExitComplete();
    }, [
        isPresent
    ]);
    if (mode === "popLayout") children = (0, $dRzna.jsx)((0, $52e1d3df9689883d$export$1d6cdde0c6816c6d), {
        isPresent: isPresent,
        children: children
    });
    return (0, $dRzna.jsx)((0, $2026c3a36ffa4174$export$f224e4635b6f8ce2).Provider, {
        value: context,
        children: children
    });
};
function $00fc35aff96a3476$var$newChildrenMap() {
    return new Map();
}






var $eeH7J = parcelRequire("eeH7J");
const $33f0c4b420d1e939$export$10e61aed958678dd = (child)=>child.key || "";
function $33f0c4b420d1e939$export$872a3a1281f4b357(children) {
    const filtered = [];
    // We use forEach here instead of map as map mutates the component key by preprending `.$`
    (0, $eeH7J.Children).forEach(children, (child)=>{
        if ((0, $eeH7J.isValidElement)(child)) filtered.push(child);
    });
    return filtered;
}



"use client";
/**
 * `AnimatePresence` enables the animation of components that have been removed from the tree.
 *
 * When adding/removing more than a single child, every child **must** be given a unique `key` prop.
 *
 * Any `motion` components that have an `exit` property defined will animate out when removed from
 * the tree.
 *
 * ```jsx
 * import { motion, AnimatePresence } from 'framer-motion'
 *
 * export const Items = ({ items }) => (
 *   <AnimatePresence>
 *     {items.map(item => (
 *       <motion.div
 *         key={item.id}
 *         initial={{ opacity: 0 }}
 *         animate={{ opacity: 1 }}
 *         exit={{ opacity: 0 }}
 *       />
 *     ))}
 *   </AnimatePresence>
 * )
 * ```
 *
 * You can sequence exit animations throughout a tree using variants.
 *
 * If a child contains multiple `motion` components with `exit` props, it will only unmount the child
 * once all `motion` components have finished animating out. Likewise, any components using
 * `usePresence` all need to call `safeToRemove`.
 *
 * @public
 */ const $0df0f0e5b644e49a$export$3ae376d12526dd6f = ({ children: children, exitBeforeEnter: exitBeforeEnter, custom: custom, initial: initial = true, onExitComplete: onExitComplete, presenceAffectsLayout: presenceAffectsLayout = true, mode: mode = "sync" })=>{
    (0, $2b9100c03bd61cb5$export$f5708dca728d7177)(!exitBeforeEnter, "Replace exitBeforeEnter with mode='wait'");
    /**
     * Filter any children that aren't ReactElements. We can only track components
     * between renders with a props.key.
     */ const presentChildren = (0, $eeH7J.useMemo)(()=>(0, $33f0c4b420d1e939$export$872a3a1281f4b357)(children), [
        children
    ]);
    /**
     * Track the keys of the currently rendered children. This is used to
     * determine which children are exiting.
     */ const presentKeys = presentChildren.map((0, $33f0c4b420d1e939$export$10e61aed958678dd));
    /**
     * If `initial={false}` we only want to pass this to components in the first render.
     */ const isInitialRender = (0, $eeH7J.useRef)(true);
    /**
     * A ref containing the currently present children. When all exit animations
     * are complete, we use this to re-render the component with the latest children
     * *committed* rather than the latest children *rendered*.
     */ const pendingPresentChildren = (0, $eeH7J.useRef)(presentChildren);
    /**
     * Track which exiting children have finished animating out.
     */ const exitComplete = (0, $450f33b6a8740b8a$export$fe4300aa8eebea86)(()=>new Map());
    /**
     * Save children to render as React state. To ensure this component is concurrent-safe,
     * we check for exiting children via an effect.
     */ const [diffedChildren, setDiffedChildren] = (0, $eeH7J.useState)(presentChildren);
    const [renderedChildren, setRenderedChildren] = (0, $eeH7J.useState)(presentChildren);
    (0, $17cc282998a57b95$export$700979bc83e7db82)(()=>{
        isInitialRender.current = false;
        pendingPresentChildren.current = presentChildren;
        /**
         * Update complete status of exiting children.
         */ for(let i = 0; i < renderedChildren.length; i++){
            const key = (0, $33f0c4b420d1e939$export$10e61aed958678dd)(renderedChildren[i]);
            if (!presentKeys.includes(key)) {
                if (exitComplete.get(key) !== true) exitComplete.set(key, false);
            } else exitComplete.delete(key);
        }
    }, [
        renderedChildren,
        presentKeys.length,
        presentKeys.join("-")
    ]);
    const exitingChildren = [];
    if (presentChildren !== diffedChildren) {
        let nextChildren = [
            ...presentChildren
        ];
        /**
         * Loop through all the currently rendered components and decide which
         * are exiting.
         */ for(let i = 0; i < renderedChildren.length; i++){
            const child = renderedChildren[i];
            const key = (0, $33f0c4b420d1e939$export$10e61aed958678dd)(child);
            if (!presentKeys.includes(key)) {
                nextChildren.splice(i, 0, child);
                exitingChildren.push(child);
            }
        }
        /**
         * If we're in "wait" mode, and we have exiting children, we want to
         * only render these until they've all exited.
         */ if (mode === "wait" && exitingChildren.length) nextChildren = exitingChildren;
        setRenderedChildren((0, $33f0c4b420d1e939$export$872a3a1281f4b357)(nextChildren));
        setDiffedChildren(presentChildren);
        /**
         * Early return to ensure once we've set state with the latest diffed
         * children, we can immediately re-render.
         */ return;
    }
    /**
     * If we've been provided a forceRender function by the LayoutGroupContext,
     * we can use it to force a re-render amongst all surrounding components once
     * all components have finished animating out.
     */ const { forceRender: forceRender } = (0, $eeH7J.useContext)((0, $7e832de67499b416$export$a3579ca508007a95));
    return (0, $dRzna.jsx)((0, $dRzna.Fragment), {
        children: renderedChildren.map((child)=>{
            const key = (0, $33f0c4b420d1e939$export$10e61aed958678dd)(child);
            const isPresent = presentChildren === renderedChildren || presentKeys.includes(key);
            const onExit = ()=>{
                if (exitComplete.has(key)) exitComplete.set(key, true);
                else return;
                let isEveryExitComplete = true;
                exitComplete.forEach((isExitComplete)=>{
                    if (!isExitComplete) isEveryExitComplete = false;
                });
                if (isEveryExitComplete) {
                    forceRender === null || forceRender === void 0 || forceRender();
                    setRenderedChildren(pendingPresentChildren.current);
                    onExitComplete && onExitComplete();
                }
            };
            return (0, $dRzna.jsx)((0, $00fc35aff96a3476$export$979daf65881a382a), {
                isPresent: isPresent,
                initial: !isInitialRender.current || initial ? undefined : false,
                custom: isPresent ? undefined : custom,
                presenceAffectsLayout: presenceAffectsLayout,
                mode: mode,
                onExitComplete: isPresent ? undefined : onExit,
                children: child
            }, key);
        })
    });
};







/**
 * Returns a random lorem ipsum string with the specified number of words. Adds a period to the
 * end of the string.
 *
 * @param wc Word count
 * @returns string
 */ function $5b6268f74fe7cc2e$export$69315a173ec7de2f(wc) {
    const arr = $5b6268f74fe7cc2e$var$text.split(" ");
    const rand = Math.max(Math.floor(Math.random() * arr.length) - wc, 0);
    const res = arr.slice(rand, rand + wc);
    const str = res.join(" ");
    return `${str.charAt(0).toUpperCase()}${(str.endsWith(".") ? str : `${str.endsWith(",") ? str.slice(0, str.length) : str}.`).slice(1, str.length + 1)}`;
}
const $5b6268f74fe7cc2e$var$text = "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean iaculis rutrum quam, commodo pulvinar libero ultricies quis. Phasellus sollicitudin mauris nec libero posuere pretium. Donec egestas justo vitae enim aliquet, vel auctor nunc vulputate. Proin scelerisque quis ex ut commodo. Vivamus eleifend erat pretium velit lacinia, sit amet pharetra tellus dignissim. Maecenas pulvinar imperdiet lobortis. Interdum et malesuada fames ac ante ipsum primis in faucibus. Quisque quis vehicula dui. Proin a fringilla enim. Cras id aliquet tellus. Donec sit amet diam eu lorem pulvinar varius at id urna. Integer volutpat dolor eu egestas pharetra. Quisque vehicula aliquam dignissim. Pellentesque ac nisi vitae felis accumsan tristique. Vestibulum a ex id nulla semper posuere. Quisque lobortis nulla nulla, at pharetra nunc pharetra consequat. Nullam dignissim imperdiet dolor sit amet tempor. Nulla feugiat urna hendrerit, maximus dolor id, imperdiet diam. Suspendisse potenti. Aenean et rutrum nunc, vel cursus erat. Praesent vitae consectetur turpis. Quisque mollis vel est non laoreet. Aenean pulvinar nisi vitae velit maximus finibus. Aenean imperdiet vulputate posuere. Maecenas metus tortor, egestas ut ultricies et, aliquet vel arcu. Donec consequat a mauris porttitor ultrices. Donec vel sem non quam luctus dignissim. Morbi accumsan, mi vitae consectetur aliquet, erat tortor congue dolor, consequat venenatis nulla nibh sed lacus. Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. Sed ipsum nisi, vulputate blandit est a, scelerisque posuere orci. Quisque semper tortor quis fermentum pharetra. Proin orci tellus, iaculis in quam quis, ullamcorper pellentesque nisl. Sed viverra, massa ac consectetur convallis, massa tellus venenatis lectus, nec aliquam ligula libero quis ex. Donec a interdum quam, quis consequat mauris. Curabitur lacinia, nulla sed bibendum mattis, elit purus ultricies nibh, id sagittis dolor eros eu quam. Ut at nisi nec erat sollicitudin bibendum nec faucibus metus. Sed lectus metus, semper ac lorem et, bibendum suscipit arcu. Donec mauris lorem, tempor ut accumsan a, finibus non diam. Ut tincidunt malesuada metus, et viverra nisi tristique sit amet. Morbi congue vehicula est, in pretium mi vestibulum vel. Aenean et enim urna. Praesent vel neque a enim ullamcorper fringilla quis et arcu. Phasellus orci augue, posuere sit amet iaculis vitae, bibendum nec lorem. Nulla eu arcu vitae lorem gravida fringilla. Nulla vitae felis ac risus porttitor pellentesque a quis ipsum. Morbi eu vestibulum erat, sit amet semper sem. Donec sit amet magna eget dolor sagittis vulputate in id libero. Ut sagittis interdum nulla vitae viverra. In hac habitasse platea dictumst. Mauris maximus nulla in convallis placerat. Aliquam tempus aliquam magna quis hendrerit. Aliquam at augue aliquam, auctor neque at, scelerisque dolor. Pellentesque lacinia nulla dolor. Suspendisse potenti. Praesent luctus urna ut erat hendrerit pretium. Aliquam non massa quis est euismod maximus a et neque. Integer in consequat tellus. Nulla auctor elit in dui egestas, sed semper eros feugiat. Praesent facilisis nibh sed sem elementum convallis. Maecenas vel vehicula tellus, sed porta ligula. In tempor ac dui eleifend pretium. Nunc sem lorem, elementum vitae imperdiet in, porta in turpis. Nam lorem justo, congue quis nibh hendrerit, aliquet hendrerit felis. Sed dui eros, auctor sed sodales sit amet, blandit nec justo. Suspendisse nibh neque, sodales quis ligula a, dapibus faucibus dolor. In purus enim, bibendum non leo ac, imperdiet eleifend enim. Aenean consectetur tortor ut ex tincidunt luctus.";




var $aIeEI = parcelRequire("aIeEI");

const $2e602d91f6817609$export$dcfd5621ca9623a7 = {
    "100": "FF",
    "99": "FC",
    "98": "FA",
    "97": "F7",
    "96": "F5",
    "95": "F2",
    "94": "F0",
    "93": "ED",
    "92": "EB",
    "91": "E8",
    "90": "E6",
    "89": "E3",
    "88": "E0",
    "87": "DE",
    "86": "DB",
    "85": "D9",
    "84": "D6",
    "83": "D4",
    "82": "D1",
    "81": "CF",
    "80": "CC",
    "79": "C9",
    "78": "C7",
    "77": "C4",
    "76": "C2",
    "75": "BF",
    "74": "BD",
    "73": "BA",
    "72": "B8",
    "71": "B5",
    "70": "B3",
    "69": "B0",
    "68": "AD",
    "67": "AB",
    "66": "A8",
    "65": "A6",
    "64": "A3",
    "63": "A1",
    "62": "9E",
    "61": "9C",
    "60": "99",
    "59": "96",
    "58": "94",
    "57": "91",
    "56": "8F",
    "55": "8C",
    "54": "8A",
    "53": "87",
    "52": "85",
    "51": "82",
    "50": "80",
    "49": "7D",
    "48": "7A",
    "47": "78",
    "46": "75",
    "45": "73",
    "44": "70",
    "43": "6E",
    "42": "6B",
    "41": "69",
    "40": "66",
    "39": "63",
    "38": "61",
    "37": "5E",
    "36": "5C",
    "35": "59",
    "34": "57",
    "33": "54",
    "32": "52",
    "31": "4F",
    "30": "4D",
    "29": "4A",
    "28": "47",
    "27": "45",
    "26": "42",
    "25": "40",
    "24": "3D",
    "23": "3B",
    "22": "38",
    "21": "36",
    "20": "33",
    "19": "30",
    "18": "2E",
    "17": "2B",
    "16": "29",
    "15": "26",
    "14": "24",
    "13": "21",
    "12": "1F",
    "11": "1C",
    "10": "1A",
    "9": "17",
    "8": "14",
    "7": "12",
    "6": "0F",
    "5": "0D",
    "4": "0A",
    "3": "08",
    "2": "05",
    "1": "03",
    "0": "00"
};



function $37d4981a6b4c97c0$export$2b77a92f1a5ad772(props) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x;
    const size = (_a = props.size) !== null && _a !== void 0 ? _a : "md";
    const localize = (0, $aIeEI.useLocalize)();
    const backdropRef = (0, $eeH7J.useRef)(null);
    const { colors: colors, helpers: helpers } = (0, $756948b644e82cf2$export$559a0f07c8df6570)();
    const { responsiveCss: responsiveCss, responsiveSpacing: responsiveSpacing } = helpers;
    const [currentStep, setCurrentStep] = (0, $eeH7J.useState)((_b = props.step) !== null && _b !== void 0 ? _b : 0);
    const [stepTransition, setStepTransition] = (0, $eeH7J.useState)();
    const [promptClose, setPromptClose] = (0, $eeH7J.useState)();
    const containerCss = (0, $eeH7J.useMemo)(()=>(0, $lhaLc.css)({
            "--container-padding": "16px",
            padding: "var(--container-padding)"
        }, responsiveCss("min", "md", {
            "--container-padding": "64px"
        })), [
        responsiveCss
    ]);
    const modalCss = (0, $eeH7J.useMemo)(()=>(0, $lhaLc.css)({
            position: "relative",
            overflow: "hidden",
            backgroundColor: colors.grayWhite,
            maxHeight: "calc(100svh - var(--container-padding) - var(--container-padding))",
            "--modal-padding": "16px",
            padding: "var(--modal-padding)"
        }, responsiveCss("min", "sm", {
            "--modal-padding": "24px"
        }), responsiveCss("min", "md", {
            maxWidth: 960,
            "--modal-padding": "40px"
        })), [
        colors.grayWhite,
        responsiveCss
    ]);
    const handlePrevStep = (0, $eeH7J.useCallback)(()=>{
        var _a;
        setStepTransition("prev");
        setCurrentStep(currentStep - 1);
        (_a = props.onStepChange) === null || _a === void 0 || _a.call(props, currentStep - 1);
    }, [
        currentStep,
        props
    ]);
    const handleNextStep = (0, $eeH7J.useCallback)(()=>{
        var _a;
        setStepTransition("next");
        setCurrentStep(currentStep + 1);
        (_a = props.onStepChange) === null || _a === void 0 || _a.call(props, currentStep + 1);
    }, [
        currentStep,
        props
    ]);
    const handleBack = (0, $eeH7J.useCallback)(()=>{
        handlePrevStep();
        if (typeof props.onBack === "function") props.onBack();
    }, [
        props,
        handlePrevStep
    ]);
    const handleClose = (0, $eeH7J.useCallback)((e, reason)=>{
        var _a;
        if (props.closePrompt && !promptClose) setPromptClose(reason);
        else (_a = props.onClose) === null || _a === void 0 || _a.call(props, e, reason);
    }, [
        props,
        promptClose
    ]);
    const handleKeydown = (0, $eeH7J.useCallback)((e)=>{
        if (e.key === "Escape") {
            if (promptClose) setPromptClose(undefined);
            else handleClose(e, "escapeKeyDown");
        }
    }, [
        promptClose,
        handleClose
    ]);
    (0, $eeH7J.useEffect)(()=>{
        if (typeof window !== "undefined") {
            if (props.isOpen) document.body.style.overflow = "hidden";
            else document.body.style.overflow = "";
        }
    }, [
        props.isOpen
    ]);
    (0, $eeH7J.useEffect)(()=>{
        if (typeof window !== "undefined") {
            window.addEventListener("keydown", handleKeydown);
            return ()=>{
                window.removeEventListener("keydown", handleKeydown);
            };
        }
    }, [
        handleKeydown
    ]);
    (0, $eeH7J.useEffect)(()=>{
        if (!props.isOpen) setPromptClose(undefined);
    }, [
        props.isOpen
    ]);
    const [scrollContainerRef, scrollContainerAnimate] = (0, $4c4e7486a769eecb$export$9f387b98a73b1511)();
    const [overflowTop, setOverflowTop] = (0, $eeH7J.useState)(false);
    const [overflowBottom, setOverflowBottom] = (0, $eeH7J.useState)(false);
    const handleScroll = (0, $eeH7J.useCallback)((e)=>{
        if (e.currentTarget.scrollTop === 0 && overflowTop) setOverflowTop(false);
        else if (e.currentTarget.scrollTop > 0 && !overflowTop) setOverflowTop(true);
        const hasScrolledToBottom = Math.ceil(e.currentTarget.scrollTop + e.currentTarget.clientHeight) === e.currentTarget.scrollHeight;
        if (hasScrolledToBottom && overflowBottom) setOverflowBottom(false);
        else if (!hasScrolledToBottom && !overflowBottom) setOverflowBottom(true);
    }, [
        overflowBottom,
        overflowTop
    ]);
    const icon = (0, $eeH7J.useMemo)(()=>{
        var _a, _b, _c, _d, _e;
        return (_d = (_c = (_b = (_a = props.steps) === null || _a === void 0 ? void 0 : _a[currentStep]) === null || _b === void 0 ? void 0 : _b.header) === null || _c === void 0 ? void 0 : _c.icon) !== null && _d !== void 0 ? _d : (_e = props.header) === null || _e === void 0 ? void 0 : _e.icon;
    }, [
        currentStep,
        (_c = props.header) === null || _c === void 0 ? void 0 : _c.icon,
        props.steps
    ]);
    const closePromptRef = (0, $eeH7J.useRef)(null);
    const minHeightForClosePrompt = (0, $eeH7J.useMemo)(()=>{
        var _a;
        if (promptClose) return (_a = closePromptRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect().height;
    }, [
        promptClose
    ]);
    if (typeof window === "undefined") return (0, $4vwom.jsx)((0, $4vwom.Fragment), {});
    return /*#__PURE__*/ (0, $iMJCh.createPortal)((0, $4vwom.jsx)($37d4981a6b4c97c0$export$ab57792b9b6974a6.Provider, {
        value: {
            scrollContainerRef: scrollContainerRef,
            scrollContainerAnimate: scrollContainerAnimate
        },
        children: (0, $4vwom.jsxs)((0, $0df0f0e5b644e49a$export$3ae376d12526dd6f), {
            children: [
                props.isOpen ? (0, $4vwom.jsx)((0, $ad7a054f4530c130$export$e25e478948902b8b).div, {
                    style: {
                        position: "fixed",
                        top: 0,
                        left: 0,
                        height: "100%",
                        width: "100%",
                        zIndex: 100,
                        opacity: 0,
                        backgroundColor: "rgba(0, 0, 0, 0.32)"
                    },
                    animate: {
                        opacity: 1
                    },
                    exit: {
                        opacity: 0
                    },
                    onClick: (e)=>handleClose(e, "backdropClick")
                }, "backdrop") : null,
                props.isOpen ? (0, $4vwom.jsx)("div", {
                    ref: backdropRef,
                    style: {
                        position: "fixed",
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        zIndex: 200,
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "flex-start"
                    },
                    css: containerCss,
                    onClick: (e)=>{
                        if (e.target === backdropRef.current) handleClose(e, "backdropClick");
                    },
                    children: (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                        motion: {
                            transition: (0, $7f851218870bc850$export$f4e4ad51b471de36)["200"],
                            variants: {
                                open: {
                                    transform: "translateY(0px)",
                                    scale: 1,
                                    opacity: 1
                                },
                                close: {
                                    opacity: 0
                                }
                            },
                            initial: {
                                transform: "translateY(50px)",
                                scale: 0.75,
                                opacity: 0
                            },
                            animate: "open",
                            exit: "close",
                            onAnimationComplete: (definition)=>{
                                var _a;
                                if (definition === "open" && props.onOpenAnimationEnd) props.onOpenAnimationEnd();
                                else if (definition === "close") (_a = props.onCloseAnimationEnd) === null || _a === void 0 || _a.call(props);
                            }
                        },
                        direction: "column",
                        backgroundColor: "grayWhite",
                        borderRadius: "lg",
                        elevation: true,
                        style: {
                            width: (_d = props.width) !== null && _d !== void 0 ? _d : "auto",
                            minHeight: minHeightForClosePrompt
                        },
                        css: modalCss,
                        children: [
                            (0, $4vwom.jsxs)("div", {
                                style: {
                                    position: "absolute",
                                    top: 0,
                                    left: 0,
                                    right: 0,
                                    bottom: 0,
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    opacity: promptClose ? "100" : "0",
                                    zIndex: promptClose ? "100" : "-1"
                                },
                                children: [
                                    (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                                        elementRef: closePromptRef,
                                        direction: "column",
                                        gap: 24,
                                        style: {
                                            zIndex: "10001"
                                        },
                                        css: (0, $lhaLc.css)({
                                            padding: "var(--modal-padding)"
                                        }, responsiveCss("min", "md", {
                                            width: "80%"
                                        })),
                                        motion: {
                                            initial: {
                                                opacity: 0,
                                                translateY: "8px"
                                            },
                                            animate: promptClose ? {
                                                opacity: 1,
                                                translateY: "0px"
                                            } : undefined,
                                            transition: (0, $7f851218870bc850$export$f4e4ad51b471de36)["200"]
                                        },
                                        children: [
                                            (0, $4vwom.jsx)((0, $789b8639be592288$export$a8a3e93435678ff9), {
                                                level: 2,
                                                children: (_e = props.closePrompt) === null || _e === void 0 ? void 0 : _e.heading
                                            }),
                                            (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                                variant: "body",
                                                size: "md",
                                                children: (_f = props.closePrompt) === null || _f === void 0 ? void 0 : _f.text
                                            }),
                                            (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                                                gap: 8,
                                                justifyContent: "flex-end",
                                                css: (0, $lhaLc.css)(responsiveCss("max", "sm", {
                                                    flexDirection: "column",
                                                    justifyContent: "stretch"
                                                })),
                                                children: [
                                                    (0, $4vwom.jsx)((0, $4b4086f8a1c6b2f8$export$353f5b6fc5456de1), {
                                                        variant: "secondary",
                                                        size: "sm",
                                                        onClick: ()=>setPromptClose(undefined),
                                                        children: (_g = props.closePrompt) === null || _g === void 0 ? void 0 : _g.cancelButtonText
                                                    }),
                                                    (0, $4vwom.jsx)((0, $4b4086f8a1c6b2f8$export$353f5b6fc5456de1), {
                                                        variant: "dark",
                                                        size: "sm",
                                                        onClick: (e)=>// Should always be called because close prompt
                                                            // will not be visible unless promptClose is set.
                                                            promptClose ? handleClose(e, promptClose) : undefined,
                                                        children: (_h = props.closePrompt) === null || _h === void 0 ? void 0 : _h.confirmButtonText
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    (0, $4vwom.jsx)((0, $ad7a054f4530c130$export$e25e478948902b8b).div, {
                                        initial: {
                                            opacity: 0,
                                            backdropFilter: "blur(20px)",
                                            WebkitBackdropFilter: "blur(20px)"
                                        },
                                        animate: {
                                            opacity: 1,
                                            backdropFilter: "blur(40px)",
                                            WebkitBackdropFilter: "blur(40px)",
                                            transition: (0, $7f851218870bc850$export$f4e4ad51b471de36)["200"]
                                        },
                                        style: {
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            position: "absolute",
                                            top: 0,
                                            left: 0,
                                            right: 0,
                                            bottom: 0,
                                            backgroundColor: `${colors.grayWhite}${(0, $2e602d91f6817609$export$dcfd5621ca9623a7)["50"]}`,
                                            zIndex: 10000
                                        }
                                    })
                                ]
                            }),
                            props.header ? (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                                justifyContent: "space-between",
                                style: size === "lg" ? {
                                    paddingBottom: 24,
                                    marginBottom: 24,
                                    borderBottom: `1px solid ${colors.gray200}`
                                } : {
                                    marginBottom: 24
                                },
                                css: props.header.divider ? (0, $lhaLc.css)({
                                    borderBottom: `1px solid ${colors.gray200}`
                                }, responsiveSpacing("sm", "padding-bottom")) : undefined,
                                children: [
                                    (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                                        alignItems: "center",
                                        children: [
                                            (0, $4vwom.jsx)((0, $0df0f0e5b644e49a$export$3ae376d12526dd6f), {
                                                mode: "popLayout",
                                                children: ((_m = (_l = (_k = (_j = props.steps) === null || _j === void 0 ? void 0 : _j[currentStep]) === null || _k === void 0 ? void 0 : _k.header) === null || _l === void 0 ? void 0 : _l.backButton) !== null && _m !== void 0 ? _m : props.header.backButton) ? (0, $4vwom.jsx)((0, $ad7a054f4530c130$export$e25e478948902b8b).div, {
                                                    initial: {
                                                        opacity: 0
                                                    },
                                                    animate: {
                                                        opacity: 1
                                                    },
                                                    exit: {
                                                        opacity: 0
                                                    },
                                                    children: (0, $4vwom.jsx)((0, $4b4086f8a1c6b2f8$export$353f5b6fc5456de1), {
                                                        iconStart: "arrowLeft",
                                                        variant: "secondary",
                                                        size: "sm",
                                                        onClick: handleBack,
                                                        margin: {
                                                            right: (0, $756948b644e82cf2$export$981516ee4691055c)(32)
                                                        },
                                                        "aria-label": localize({
                                                            no: "Tilbake",
                                                            en: "Back"
                                                        })
                                                    }, "backButton")
                                                }) : null
                                            }),
                                            (0, $4vwom.jsx)((0, $0df0f0e5b644e49a$export$3ae376d12526dd6f), {
                                                mode: "popLayout",
                                                children: (0, $4vwom.jsx)((0, $ad7a054f4530c130$export$e25e478948902b8b).div, {
                                                    initial: {
                                                        opacity: 0
                                                    },
                                                    animate: {
                                                        opacity: 1
                                                    },
                                                    exit: {
                                                        opacity: 0
                                                    },
                                                    children: (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                                                        alignItems: "center",
                                                        children: [
                                                            icon ? (0, $4vwom.jsx)((0, $f8cdd04128a131cf$export$f04a61298a47a40f), {
                                                                icon: icon,
                                                                size: [
                                                                    24,
                                                                    [
                                                                        "min",
                                                                        "md",
                                                                        32
                                                                    ]
                                                                ],
                                                                css: (0, $lhaLc.css)({
                                                                    marginRight: 8
                                                                }, responsiveCss("min", "md", {
                                                                    marginRight: 12
                                                                }))
                                                            }) : null,
                                                            ((_r = (_q = (_p = (_o = props.steps) === null || _o === void 0 ? void 0 : _o[currentStep]) === null || _p === void 0 ? void 0 : _p.header) === null || _q === void 0 ? void 0 : _q.title) !== null && _r !== void 0 ? _r : props.header.title) ? (0, $4vwom.jsx)((0, $789b8639be592288$export$a8a3e93435678ff9), {
                                                                level: 2,
                                                                children: (_v = (_u = (_t = (_s = props.steps) === null || _s === void 0 ? void 0 : _s[currentStep]) === null || _t === void 0 ? void 0 : _t.header) === null || _u === void 0 ? void 0 : _u.title) !== null && _v !== void 0 ? _v : props.header.title
                                                            }) : null
                                                        ]
                                                    })
                                                })
                                            })
                                        ]
                                    }),
                                    (0, $4vwom.jsx)((0, $0df0f0e5b644e49a$export$3ae376d12526dd6f), {
                                        children: props.header.closeButton ? (0, $4vwom.jsx)((0, $ad7a054f4530c130$export$e25e478948902b8b).div, {
                                            initial: {
                                                opacity: 0
                                            },
                                            animate: {
                                                opacity: 1
                                            },
                                            exit: {
                                                opacity: 0
                                            },
                                            children: (0, $4vwom.jsx)((0, $4b4086f8a1c6b2f8$export$353f5b6fc5456de1), {
                                                iconStart: "close",
                                                variant: "secondary",
                                                size: "sm",
                                                onClick: (e)=>handleClose(e, "closeButton"),
                                                margin: {
                                                    left: (0, $756948b644e82cf2$export$981516ee4691055c)(40)
                                                },
                                                "aria-label": localize({
                                                    no: "Lukk denne popupen",
                                                    en: "Close this popup"
                                                })
                                            }, "closeButton")
                                        }) : null
                                    })
                                ]
                            }) : null,
                            !props.steps && (0, $4vwom.jsx)($37d4981a6b4c97c0$var$OverflowGradient, {
                                top: true,
                                show: overflowTop
                            }),
                            (0, $4vwom.jsx)("div", {
                                style: Object.assign({
                                    overflowY: props.steps ? "hidden" : "auto",
                                    maxHeight: "100%",
                                    flex: "1 1 auto",
                                    display: "flex",
                                    flexDirection: props.steps ? "row" : "column"
                                }, props.steps ? {
                                    width: "calc(100% + calc(var(--modal-padding) * 2))",
                                    transform: "translateX(calc(var(--modal-padding) * -1))"
                                } : {}),
                                ref: props.steps ? null : scrollContainerRef,
                                onScroll: props.steps ? undefined : handleScroll,
                                children: props.steps && props.renderSteps ? (0, $4vwom.jsx)("div", {
                                    style: {
                                        display: "flex",
                                        width: "100%",
                                        paddingLeft: "var(--modal-padding)",
                                        paddingRight: "var(--modal-padding)"
                                    },
                                    children: props.renderSteps((0, $4vwom.jsx)((0, $0df0f0e5b644e49a$export$3ae376d12526dd6f), {
                                        initial: false,
                                        mode: "popLayout",
                                        custom: stepTransition,
                                        children: (0, $4vwom.jsxs)((0, $ad7a054f4530c130$export$e25e478948902b8b).div, {
                                            initial: "initial",
                                            animate: "target",
                                            exit: "exit",
                                            style: {
                                                flex: "1 0 100%"
                                            },
                                            variants: {
                                                initial: (st)=>!st ? {} : {
                                                        opacity: 0,
                                                        translateX: st === "next" ? "100px" : "-100px"
                                                    },
                                                target: (st)=>!st ? {} : {
                                                        opacity: 1,
                                                        translateX: "0px"
                                                    },
                                                exit: (st)=>st ? {
                                                        translateX: st === "next" ? "-100px" : "100px",
                                                        opacity: 0
                                                    } : {}
                                            },
                                            custom: stepTransition,
                                            children: [
                                                (0, $4vwom.jsx)($37d4981a6b4c97c0$var$OverflowGradient, {
                                                    top: true,
                                                    show: overflowTop
                                                }),
                                                (0, $4vwom.jsx)("div", {
                                                    ref: scrollContainerRef,
                                                    onScroll: handleScroll,
                                                    style: {
                                                        overflowY: "scroll",
                                                        maxHeight: "100%",
                                                        overflowX: "visible"
                                                    },
                                                    css: responsiveCss("min", "md", {
                                                        paddingRight: 20
                                                    }),
                                                    children: (_x = props.steps[(_w = props.step) !== null && _w !== void 0 ? _w : currentStep]) === null || _x === void 0 ? void 0 : _x.render(handleNextStep, handlePrevStep)
                                                }),
                                                (0, $4vwom.jsx)($37d4981a6b4c97c0$var$OverflowGradient, {
                                                    bottom: true,
                                                    show: overflowBottom
                                                })
                                            ]
                                        }, `step${currentStep}`)
                                    }), props.children, setCurrentStep)
                                }) : props.children
                            }),
                            !props.steps && (0, $4vwom.jsx)($37d4981a6b4c97c0$var$OverflowGradient, {
                                bottom: true,
                                show: overflowBottom
                            })
                        ]
                    }, "modal")
                }, "container") : (0, $4vwom.jsx)((0, $4vwom.Fragment), {})
            ]
        })
    }), document.body);
}
function $37d4981a6b4c97c0$var$OverflowGradient(props) {
    return (0, $4vwom.jsx)("div", {
        css: (0, $lhaLc.css)({
            position: "relative",
            "&:before": {
                content: '""',
                position: "absolute",
                ["top" in props ? "top" : "bottom"]: 0,
                width: "100%",
                height: 12,
                background: `linear-gradient(${"top" in props ? "0" : "180"}deg, rgba(255, 255,255,0) 10%, rgba(255, 255,255,.8) 80%, rgba(255, 255,255,1))`,
                opacity: props.show ? 1 : 0,
                transition: "all ease-in-out 200ms",
                zIndex: 10,
                pointerEvents: "none"
            }
        })
    });
}
const $37d4981a6b4c97c0$export$ab57792b9b6974a6 = /*#__PURE__*/ (0, $eeH7J.createContext)({});
(0, $eSiQ2.Component)($37d4981a6b4c97c0$export$2b77a92f1a5ad772, {
    name: "Modal",
    gallery: {
        path: "Modal/Modal",
        items: [
            {
                variants: [
                    {
                        props: (state = {
                            isOpen: true
                        }, setState)=>({
                                isOpen: state.isOpen,
                                onClose: ()=>setState({
                                        isOpen: false
                                    }),
                                header: {
                                    title: "Trade-in",
                                    icon: "handCoins",
                                    closeButton: true
                                },
                                children: (0, $4vwom.jsxs)("div", {
                                    children: [
                                        (0, $4vwom.jsx)((0, $789b8639be592288$export$a8a3e93435678ff9), {
                                            level: 4,
                                            margin: {
                                                bottom: 8
                                            },
                                            children: (0, $5b6268f74fe7cc2e$export$69315a173ec7de2f)(3)
                                        }),
                                        (0, $4vwom.jsx)((0, $72c5ae9e0017e167$export$4b2c32e08f77ff18), {
                                            size: "md",
                                            margin: {
                                                bottom: 32
                                            },
                                            children: (0, $5b6268f74fe7cc2e$export$69315a173ec7de2f)(100)
                                        }),
                                        (0, $4vwom.jsxs)((0, $789b8639be592288$export$a8a3e93435678ff9), {
                                            level: 4,
                                            margin: {
                                                bottom: 8
                                            },
                                            children: [
                                                " ",
                                                (0, $5b6268f74fe7cc2e$export$69315a173ec7de2f)(3),
                                                " "
                                            ]
                                        }),
                                        (0, $4vwom.jsxs)((0, $72c5ae9e0017e167$export$4b2c32e08f77ff18), {
                                            size: "md",
                                            margin: {
                                                bottom: 32
                                            },
                                            children: [
                                                " ",
                                                (0, $5b6268f74fe7cc2e$export$69315a173ec7de2f)(100),
                                                " "
                                            ]
                                        }),
                                        (0, $4vwom.jsxs)((0, $789b8639be592288$export$a8a3e93435678ff9), {
                                            level: 4,
                                            margin: {
                                                bottom: 8
                                            },
                                            children: [
                                                " ",
                                                (0, $5b6268f74fe7cc2e$export$69315a173ec7de2f)(3),
                                                " "
                                            ]
                                        }),
                                        (0, $4vwom.jsxs)((0, $72c5ae9e0017e167$export$4b2c32e08f77ff18), {
                                            size: "md",
                                            margin: {
                                                bottom: 32
                                            },
                                            children: [
                                                " ",
                                                (0, $5b6268f74fe7cc2e$export$69315a173ec7de2f)(100),
                                                " "
                                            ]
                                        }),
                                        (0, $4vwom.jsx)((0, $789b8639be592288$export$a8a3e93435678ff9), {
                                            level: 4,
                                            margin: {
                                                bottom: 8
                                            },
                                            children: (0, $5b6268f74fe7cc2e$export$69315a173ec7de2f)(3)
                                        }),
                                        (0, $4vwom.jsx)((0, $72c5ae9e0017e167$export$4b2c32e08f77ff18), {
                                            size: "md",
                                            margin: {
                                                bottom: 32
                                            },
                                            children: (0, $5b6268f74fe7cc2e$export$69315a173ec7de2f)(100)
                                        }),
                                        (0, $4vwom.jsx)((0, $789b8639be592288$export$a8a3e93435678ff9), {
                                            level: 4,
                                            margin: {
                                                bottom: 8
                                            },
                                            children: (0, $5b6268f74fe7cc2e$export$69315a173ec7de2f)(3)
                                        }),
                                        (0, $4vwom.jsxs)((0, $72c5ae9e0017e167$export$4b2c32e08f77ff18), {
                                            size: "md",
                                            children: [
                                                (0, $5b6268f74fe7cc2e$export$69315a173ec7de2f)(100),
                                                " "
                                            ]
                                        })
                                    ]
                                })
                            }),
                        render: (cmp, _, setState)=>(0, $4vwom.jsxs)("div", {
                                children: [
                                    (0, $4vwom.jsx)("button", {
                                        onClick: ()=>{
                                            setState({
                                                isOpen: true
                                            });
                                        },
                                        children: "Open modal"
                                    }),
                                    cmp
                                ]
                            })
                    }
                ]
            }
        ]
    }
});





function $be6bc11d8e8cab8d$export$90b6e87e315e2927(props) {
    var _a;
    const localize = (0, $aIeEI.useLocalize)();
    const { offer: offer, setOffer: setOffer, setStep: setStep, skipAuthStep: skipAuthStep, insuranceOptions: insuranceOptions } = (0, $c90be680bf4410a3$export$b75716bfd8405073)();
    const selected = (0, $eeH7J.useMemo)(()=>{
        var _a;
        return (_a = insuranceOptions.data) === null || _a === void 0 ? void 0 : _a.findIndex((io)=>io.id === offer.insurance);
    }, [
        insuranceOptions.data,
        offer.insurance
    ]);
    const [insuranceTermsMarkdown, setInsuranceTermsMarkdown] = (0, $eeH7J.useState)();
    const next = (0, $eeH7J.useCallback)(()=>{
        if (skipAuthStep) setStep("Shipping");
        else setStep("Login");
    }, [
        setStep,
        skipAuthStep
    ]);
    const handleTermsAndConditionsLinkClick = (0, $eeH7J.useCallback)((id)=>async (e)=>{
            const md = await (0, $e18f565b44c7bc7d$export$e9c540bc402f485f)(id);
            setInsuranceTermsMarkdown(md);
            e.preventDefault();
            e.stopPropagation();
        }, []);
    if (insuranceOptions.loading) return (0, $4vwom.jsx)((0, $4vwom.Fragment), {});
    return (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
        direction: "column",
        gap: [
            16,
            [
                "min",
                "md",
                32
            ]
        ],
        children: [
            (0, $4vwom.jsx)((0, $789b8639be592288$export$a8a3e93435678ff9), {
                level: 2,
                children: localize(props.headline)
            }),
            (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                direction: "column",
                gap: 16,
                children: [
                    (_a = insuranceOptions.data) === null || _a === void 0 ? void 0 : _a.map((option, i)=>{
                        var _a, _b;
                        return (0, $4vwom.jsx)((0, $fc70c197a228049f$export$ecfb84f4ec12058a), {
                            onClick: ()=>setOffer(Object.assign(Object.assign({}, offer), {
                                    insurance: option.id
                                })),
                            selected: selected === i,
                            primary: localize(option.displayName),
                            secondary: {
                                price: (_b = (_a = option.pricePerMonth) === null || _a === void 0 ? void 0 : _a.toString()) !== null && _b !== void 0 ? _b : "",
                                currency: localize({
                                    en: "NOK",
                                    no: "kr"
                                }),
                                period: localize({
                                    en: "month",
                                    no: "m\xe5ned"
                                })
                            },
                            list: option.sellingPoints.map((sp)=>({
                                    id: sp.id.valueOf(),
                                    icon: sp.icon,
                                    text: localize(sp.text)
                                })),
                            link: option.termsAndConditions.id ? {
                                onClick: handleTermsAndConditionsLinkClick(option.termsAndConditions.id),
                                text: localize(props.termsAndConditionsLinkText)
                            } : undefined
                        }, option.id.valueOf());
                    }),
                    (0, $4vwom.jsx)((0, $fc70c197a228049f$export$ecfb84f4ec12058a), {
                        onClick: ()=>setOffer(Object.assign(Object.assign({}, offer), {
                                insurance: undefined
                            })),
                        selected: selected === -1,
                        secondary: localize(props.noInsuranceHeader),
                        text: localize(props.noInsuranceText)
                    })
                ]
            }),
            (0, $4vwom.jsx)((0, $37d4981a6b4c97c0$export$2b77a92f1a5ad772), {
                isOpen: !!insuranceTermsMarkdown,
                header: {
                    title: localize(props.termsAndConditionsLinkText),
                    closeButton: true
                },
                onClose: ()=>setInsuranceTermsMarkdown(undefined),
                children: (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                    variant: "body",
                    size: "sm",
                    children: insuranceTermsMarkdown ? (0, $4vwom.jsx)((0, $82d66b15b8f4758d$export$d5163f1ce1e6a5f9), {
                        value: localize(insuranceTermsMarkdown)
                    }) : null
                })
            }),
            (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                gap: 8,
                css: (0, $lhaLc.css)({
                    flexWrap: "wrap-reverse"
                }, (0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("max", "sm", {
                    flexDirection: "column-reverse"
                })),
                children: [
                    (0, $4vwom.jsx)((0, $4b4086f8a1c6b2f8$export$353f5b6fc5456de1), {
                        css: (0, $lhaLc.css)((0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("max", "sm", {
                            display: "none"
                        })),
                        variant: "secondary",
                        onClick: ()=>{
                            setOffer(Object.assign(Object.assign({}, offer), {
                                insurance: undefined
                            }));
                            next();
                        },
                        children: localize(props.notThisTimeButton)
                    }),
                    (0, $4vwom.jsx)((0, $4b4086f8a1c6b2f8$export$353f5b6fc5456de1), {
                        variant: "primary",
                        onClick: next,
                        children: localize(props.primaryCta)
                    })
                ]
            })
        ]
    });
}



var $4vwom = parcelRequire("4vwom");
parcelRequire("5K1mb");
var $18Pjr = parcelRequire("18Pjr");

var $lhaLc = parcelRequire("lhaLc");


var $aIeEI = parcelRequire("aIeEI");

var $4vwom = parcelRequire("4vwom");

var $eeH7J = parcelRequire("eeH7J");

var $aIeEI = parcelRequire("aIeEI");

function $902f603f96e1e919$export$f01c4f29d500ea93({ onClick: onClick }) {
    const locale = (0, $aIeEI.useCurrentLocale)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eeH7J))).createElement("vipps-mobilepay-button", {
        style: {
            width: "100%"
        },
        onClick: onClick,
        type: "button",
        brand: "vipps",
        language: locale.valueOf(),
        variant: "primary",
        rounded: "true",
        verb: "register",
        stretched: "true",
        branded: "true"
    });
}
function $902f603f96e1e919$export$34e49827c0cd090b({ width: width = 128, height: height = 32, color: color = "vippsOrange" }) {
    const { colors: colors } = (0, $756948b644e82cf2$export$559a0f07c8df6570)();
    return (0, $4vwom.jsx)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 64 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: (0, $4vwom.jsx)("path", {
            fillRule: "evenodd",
            d: "M64 3.83839C63.2798 1.09068 61.5314 0 59.1447 0C57.2111 0 54.7842 1.09068 54.7842 3.71715C54.7842 5.41401 55.9565 6.7476 57.8694 7.09117L59.6797 7.41418C60.9141 7.63629 61.2639 8.1011 61.2639 8.72741C61.2639 9.43447 60.5027 9.83844 59.3713 9.83844C57.8904 9.83844 56.9646 9.31324 56.8205 7.83828L54.2081 8.24247C54.6193 11.0908 57.17 12.2629 59.4739 12.2629C61.6547 12.2629 63.9792 11.0101 63.9792 8.48494C63.9792 6.76751 62.9298 5.51533 60.9756 5.15119L58.9805 4.78792C57.8694 4.58593 57.4993 4.04038 57.4993 3.51517C57.4993 2.84837 58.2191 2.42449 59.2066 2.42449C60.4616 2.42449 61.3461 2.84837 61.3872 4.24236L64 3.83839ZM5.925 8.16128L8.6399 0.302869H11.8283L7.09686 11.9594H4.73146L0 0.303088H3.18843L5.925 8.16128ZM22.6084 3.6364C22.6084 4.56558 21.8678 5.21202 21.0037 5.21202C20.1397 5.21202 19.3994 4.56558 19.3994 3.6364C19.3994 2.70701 20.1397 2.06078 21.0037 2.06078C21.8678 2.06078 22.6086 2.70701 22.6086 3.6364H22.6084ZM23.102 7.75775C22.0321 9.13111 20.9007 10.0806 18.9053 10.0807C16.8693 10.0807 15.2849 8.86856 14.0507 7.09095C13.5568 6.36354 12.7957 6.20204 12.2402 6.58588C11.726 6.94959 11.6028 7.71726 12.0757 8.38406C13.783 10.9497 16.1486 12.4443 18.9051 12.4443C21.4356 12.4443 23.4106 11.2324 24.9532 9.21213C25.5291 8.46481 25.5085 7.69713 24.9532 7.27281C24.4388 6.8684 23.6777 7.01042 23.102 7.75775ZM30.2 6.10094C30.2 8.48494 31.5989 9.73756 33.1625 9.73756C34.6434 9.73756 36.1659 8.56569 36.1659 6.10094C36.1659 3.67645 34.6434 2.50502 33.1828 2.50502C31.5989 2.50502 30.2 3.61605 30.2 6.10094ZM30.2 1.91941V0.323002H27.2996V16H30.2V10.424C31.1669 11.7172 32.4217 12.2629 33.8409 12.2629C36.495 12.2629 39.0868 10.2021 39.0868 5.95979C39.0868 1.89884 36.392 0.000218836 34.0879 0.000218836C32.257 0.000218836 31.0024 0.828296 30.2 1.91941ZM44.1275 6.10094C44.1275 8.48494 45.5262 9.73756 47.0898 9.73756C48.5707 9.73756 50.093 8.56569 50.093 6.10094C50.093 3.67645 48.5707 2.50502 47.1102 2.50502C45.5262 2.50502 44.1273 3.61605 44.1273 6.10094H44.1275ZM44.1275 1.91941V0.323002H44.1273H41.2269V16H44.1273V10.424C45.0943 11.7172 46.349 12.2629 47.7683 12.2629C50.4222 12.2629 53.0142 10.2021 53.0142 5.95979C53.0142 1.89884 50.3194 0.000218836 48.0152 0.000218836C46.1843 0.000218836 44.9298 0.828296 44.1275 1.91941Z",
            fill: colors[color]
        })
    });
}










function $9acc7a9b3b60d30b$export$b14e3cb78859f2c6(props) {
    var _a, _b, _c, _d, _e;
    const { responsiveCss: responsiveCss } = (0, $756948b644e82cf2$export$559a0f07c8df6570)();
    const { setStep: setStep, postAnalyticsCheckoutEvent: postAnalyticsCheckoutEvent } = (0, $c90be680bf4410a3$export$b75716bfd8405073)();
    const localize = (0, $aIeEI.useLocalize)();
    const { pathname: pathname } = (0, $18Pjr.useLocation)();
    const login = (0, $f2e2333c5543d6d8$export$403f2aca3002ba0e)(`${pathname}?auth=success`, `${pathname}?auth=failed`);
    const me = (0, $e18f565b44c7bc7d$export$f637e1cf42d15a62)();
    if (me.loading) return (0, $4vwom.jsx)((0, $4vwom.Fragment), {});
    if (((_a = me.data) === null || _a === void 0 ? void 0 : _a.canSkipLoginInCheckout) && !me.data.anonymous) return (0, $4vwom.jsx)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
        justifyContent: "center",
        style: {
            width: "100%",
            height: "100%"
        },
        children: (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
            direction: "column",
            justifyContent: "center",
            alignItems: "center",
            css: (0, $lhaLc.css)(responsiveCss("max", "sm", {
                padding: "16px 0"
            })),
            children: [
                (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                    direction: "column",
                    alignItems: "center",
                    gap: 12,
                    css: (0, $lhaLc.css)(responsiveCss("max", "sm", {
                        gap: 8,
                        marginBottom: 32
                    }), responsiveCss("min", "md", {
                        padding: "0 40px",
                        gap: 12,
                        marginBottom: 40
                    })),
                    children: [
                        (0, $4vwom.jsx)((0, $789b8639be592288$export$a8a3e93435678ff9), {
                            color: "gray500",
                            level: 2,
                            children: (0, $87d2193cf0695c20$export$4493d2932fe76cf8)(localize(props.loggedIn.headline), {
                                givenName: (_b = me.data.givenName) !== null && _b !== void 0 ? _b : "",
                                familyName: (_c = me.data.familyName) !== null && _c !== void 0 ? _c : ""
                            })
                        }),
                        (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                            color: "gray400",
                            variant: "body",
                            size: "md",
                            children: (0, $87d2193cf0695c20$export$4493d2932fe76cf8)(localize(props.loggedIn.text), {
                                givenName: (_d = me.data.givenName) !== null && _d !== void 0 ? _d : "",
                                familyName: (_e = me.data.familyName) !== null && _e !== void 0 ? _e : ""
                            })
                        })
                    ]
                }),
                (0, $4vwom.jsx)((0, $4b4086f8a1c6b2f8$export$353f5b6fc5456de1), {
                    variant: "primary",
                    size: "md",
                    onClick: ()=>setStep("Shipping"),
                    children: localize(props.loggedIn.nextStepButtonText)
                })
            ]
        })
    });
    return (0, $4vwom.jsx)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
        justifyContent: "center",
        style: {
            width: "100%",
            height: "100%"
        },
        children: (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
            direction: "column",
            justifyContent: "center",
            alignItems: "center",
            css: (0, $lhaLc.css)(responsiveCss("max", "sm", {
                padding: "16px 0"
            })),
            children: [
                (0, $4vwom.jsx)("div", {
                    style: {
                        marginBottom: 24
                    },
                    children: (0, $4vwom.jsx)((0, $902f603f96e1e919$export$34e49827c0cd090b), {
                        width: 80
                    })
                }),
                (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                    direction: "column",
                    alignItems: "center",
                    gap: 12,
                    css: (0, $lhaLc.css)(responsiveCss("max", "sm", {
                        gap: 8,
                        marginBottom: 32
                    }), responsiveCss("min", "md", {
                        padding: "0 40px",
                        gap: 12,
                        marginBottom: 40
                    })),
                    children: [
                        (0, $4vwom.jsx)((0, $789b8639be592288$export$a8a3e93435678ff9), {
                            color: "gray500",
                            level: 2,
                            children: localize(props.headline)
                        }),
                        (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                            color: "gray400",
                            variant: "body",
                            size: "md",
                            children: localize(props.subHeadline)
                        })
                    ]
                }),
                (0, $4vwom.jsx)((0, $902f603f96e1e919$export$f01c4f29d500ea93), {
                    onClick: ()=>{
                        postAnalyticsCheckoutEvent([
                            "step",
                            "login",
                            "init"
                        ]);
                        login();
                    }
                })
            ]
        })
    });
}



var $4vwom = parcelRequire("4vwom");

var $eeH7J = parcelRequire("eeH7J");

var $lhaLc = parcelRequire("lhaLc");

var $alVaN = parcelRequire("alVaN");

var $hFOwS = parcelRequire("hFOwS");

var $aIeEI = parcelRequire("aIeEI");

var $4vwom = parcelRequire("4vwom");

var $eeH7J = parcelRequire("eeH7J");

var $18Pjr = parcelRequire("18Pjr");
var $5K1mb = parcelRequire("5K1mb");

var $8h5s0 = parcelRequire("8h5s0");

var $dUDPg = parcelRequire("dUDPg");

var $aIeEI = parcelRequire("aIeEI");
function $648bbd5693a5c2fa$export$9f60001f130da957(type) {
    const appEnv = type;
    if ($648bbd5693a5c2fa$var$appEnvironments.includes(appEnv)) return appEnv;
    throw new Error(`${type} is not a recognized adyen app environment`);
}
const $648bbd5693a5c2fa$var$appEnvironments = [
    "test",
    "live-eu",
    "live-us",
    "live-au",
    "live-apse",
    "live-in"
];
function $648bbd5693a5c2fa$export$42183f55bf1a9bfb(type) {
    const webEnv = type;
    if ($648bbd5693a5c2fa$var$webEnvironments.includes(webEnv)) return webEnv;
    throw new Error(`${type} is not a recognized adyen web environment`);
}
const $648bbd5693a5c2fa$var$webEnvironments = [
    "test",
    "live",
    "live-us",
    "live-au",
    "live-apse",
    "live-in"
];
function $648bbd5693a5c2fa$export$bbd3602d366ad96a(environment) {
    const appEnv = $648bbd5693a5c2fa$export$9f60001f130da957(environment);
    if (appEnv === "live-eu") return "live";
    return appEnv;
}



var $4vwom = parcelRequire("4vwom");
parcelRequire("eeH7J");

var $ikBJm = parcelRequire("ikBJm");
const $646bd1948001fb7a$export$23ec8986ee72eea6 = (errorText)=>{
    return (0, $ikBJm.Modal)((close)=>{
        return (0, $4vwom.jsx)("div", {
            className: "container",
            style: {
                backgroundColor: "white",
                padding: 20,
                paddingBottom: 30,
                borderRadius: 8,
                maxHeight: 400,
                width: 500
            },
            children: (0, $4vwom.jsxs)("div", {
                className: "row",
                children: [
                    (0, $4vwom.jsx)("div", {
                        className: "col-10",
                        children: errorText.map((t, i)=>{
                            return (0, $4vwom.jsxs)("div", {
                                children: [
                                    t,
                                    (0, $4vwom.jsx)("br", {})
                                ]
                            }, i);
                        })
                    }),
                    (0, $4vwom.jsx)("div", {
                        className: "col-2",
                        children: $646bd1948001fb7a$var$CloseButton(close)
                    })
                ]
            })
        });
    });
};
const $646bd1948001fb7a$var$CloseButton = (close)=>{
    return (0, $4vwom.jsx)("div", {
        className: "row",
        onClick: ()=>{
            close(undefined);
            window.location.reload();
        },
        style: {
            cursor: "pointer"
        },
        children: (0, $4vwom.jsxs)("svg", {
            width: "18",
            height: "18",
            viewBox: "0 0 18 18",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                (0, $4vwom.jsx)("rect", {
                    x: "1",
                    y: "15.1406",
                    width: "20",
                    height: "3",
                    rx: "1.5",
                    transform: "rotate(-45 1 15.1406)",
                    fill: "#2A134E"
                }),
                (0, $4vwom.jsx)("rect", {
                    width: "20",
                    height: "3",
                    rx: "1.5",
                    transform: "matrix(-0.707107 -0.707107 -0.707107 0.707107 17.2617 15.1406)",
                    fill: "#2A134E"
                })
            ]
        })
    });
};


// Adyen result code source: https://docs.adyen.com/online-payments/build-your-integration/payment-result-codes/
const $ceb61c869c7a4551$var$paymentSuccessful = [
    "Authorised"
];
const $ceb61c869c7a4551$var$paymentPending = [
    "Pending",
    "Received",
    "PresentToShopper"
];
const $ceb61c869c7a4551$var$orderStatusPaid = [
    "pending",
    "capturable",
    "complete",
    "refundable",
    "amendable",
    "faulty"
];
const $ceb61c869c7a4551$var$orderStatusSimpleError = [
    "inProgress",
    "refused"
];


function $ceb61c869c7a4551$export$8917e58bffe5ae62({ onSubmitCallback: onSubmitCallback, onSuccess: onSuccess, onError: onError, onActionHandled: onActionHandled, onConfigSuccess: onConfigSuccess, adyenOrder: adyenOrder, adyenOrderId: adyenOrderId, enableStoreDetails: enableStoreDetails, styles: styles, translations: translations, DropinElementProps: DropinElementProps, disableSuccessAnimation: disableSuccessAnimation, filterPaymentMethods: filterPaymentMethods, filterStoredPaymentMethods: filterStoredPaymentMethods }) {
    const [searchParams] = (0, $5K1mb.useSearchParams)();
    const routeAdyenOrder = (0, $18Pjr.useParams)().adyenOrder;
    const routeAdyenOrderId = (0, $18Pjr.useParams)().adyenOrderId;
    adyenOrder = (0, $8h5s0.Assert)(adyenOrder !== null && adyenOrder !== void 0 ? adyenOrder : routeAdyenOrder);
    adyenOrderId = (0, $8h5s0.Assert)(adyenOrderId !== null && adyenOrderId !== void 0 ? adyenOrderId : routeAdyenOrderId);
    const locale = (0, $aIeEI.useCurrentLocale)();
    const { data: paymentStatus } = (0, $dUDPg.usePaymentStatus)(adyenOrder, adyenOrderId);
    const { data: merchantConfig } = (0, $dUDPg.useMerchantConfig)(adyenOrder, adyenOrderId);
    const [errorDescription, setErrorDescription] = (0, $eeH7J.useState)();
    const adyenContainer = (0, $eeH7J.useRef)(null);
    const { auth3ds: auth3ds, testCode: testCode } = $ceb61c869c7a4551$var$getSearchParams(searchParams);
    const [adyenComponent, setComponent] = (0, $eeH7J.useState)(undefined);
    const [complete, setComplete] = (0, $eeH7J.useState)(false);
    const handleError = (0, $eeH7J.useCallback)((err)=>onError ? onError(err) : void (0, $646bd1948001fb7a$export$23ec8986ee72eea6)([
            "We could not process your payment at this time.",
            "Please try again in a few minutes."
        ]), [
        onError
    ]);
    (0, $eeH7J.useEffect)(()=>{
        // This flag counteracts double rendering of the Adyen component, which causes issues.
        // Source: https://github.com/adyen-examples/adyen-react-online-payments/blob/main/src/features/payment/Payment.js#L66
        let renderFlag = true;
        const shouldLoadAdyen = merchantConfig !== undefined && // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
        adyenOrder !== undefined && // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
        adyenOrderId !== undefined;
        if (!shouldLoadAdyen) return;
        const adyenFields = {
            adyenOrder: adyenOrder,
            adyenOrderId: adyenOrderId,
            locale: locale,
            merchantConfig: merchantConfig,
            setComplete: setComplete,
            auth3ds: auth3ds,
            testCode: testCode,
            enableStoreDetails: enableStoreDetails
        };
        (parcelRequire("lPiLr"));
        (parcelRequire("iz9uZ"));
        $ceb61c869c7a4551$var$loadAdyen({
            adyenFields: adyenFields,
            styles: styles,
            onActionHandled: onActionHandled,
            onConfigSuccess: onConfigSuccess,
            onSubmitCallback: onSubmitCallback,
            translations: translations,
            onError: handleError,
            filterPaymentMethods: filterPaymentMethods,
            filterStoredPaymentMethods: filterStoredPaymentMethods
        }).then((adyenObject)=>{
            // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
            if (adyenContainer.current !== null && adyenObject !== undefined && renderFlag) setComponent(adyenObject.create("dropin", Object.assign({}, DropinElementProps !== null && DropinElementProps !== void 0 ? DropinElementProps : {})).mount(adyenContainer.current));
        }).catch(handleError);
        return ()=>{
            renderFlag = false;
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        paymentStatus,
        merchantConfig,
        enableStoreDetails
    ]);
    (0, $eeH7J.useEffect)(()=>{
        var _a, _b;
        const paymentMade = $ceb61c869c7a4551$var$orderStatusPaid.includes((_a = paymentStatus === null || paymentStatus === void 0 ? void 0 : paymentStatus.status) !== null && _a !== void 0 ? _a : "") || complete;
        const paymentFailed = $ceb61c869c7a4551$var$orderStatusSimpleError.includes((_b = paymentStatus === null || paymentStatus === void 0 ? void 0 : paymentStatus.status) !== null && _b !== void 0 ? _b : "");
        if (paymentMade && adyenComponent !== undefined && disableSuccessAnimation) onSuccess();
        else if (paymentMade && adyenComponent !== undefined && !disableSuccessAnimation) {
            adyenComponent.setStatus("success");
            setTimeout(()=>onSuccess(), 2000);
        } else if (paymentFailed) setErrorDescription("There was an error processing your previous payment.");
    }, [
        adyenComponent,
        paymentStatus,
        complete,
        disableSuccessAnimation,
        onSuccess
    ]);
    return (0, $4vwom.jsxs)((0, $4vwom.Fragment), {
        children: [
            errorDescription && (0, $4vwom.jsx)("div", {
                className: "fuse-adyen-package error-description",
                children: errorDescription
            }),
            (0, $4vwom.jsx)("div", {
                className: "fuse-adyen-package dropin-container",
                ref: adyenContainer
            })
        ]
    });
}
function $ceb61c869c7a4551$var$getSearchParams(searchParams) {
    var _a;
    let auth3ds;
    let testCode;
    if (searchParams.get("auth3ds") === "true") auth3ds = true;
    const parsedInt = parseInt((_a = searchParams.get("testCode")) !== null && _a !== void 0 ? _a : "");
    if (!isNaN(parsedInt)) testCode = parsedInt;
    return {
        auth3ds: auth3ds,
        testCode: testCode
    };
}

async function $ceb61c869c7a4551$var$loadAdyen(options) {
    var _a, _b, _c;
    // Seems the typing is wrong in the Adyen NPM package, hence this ugly cast
    const AdyenCheckout = await (parcelRequire("2ewgS"));
    const { adyenOrder: adyenOrder, adyenOrderId: adyenOrderId, locale: locale, merchantConfig: merchantConfig } = options.adyenFields;
    try {
        const response = await (0, $dUDPg.getPaymentMethods)(adyenOrder, adyenOrderId, locale, "Web");
        const paymentMethods = response.result;
        const filteredPaymentMethodsResponse = {
            paymentMethods: options.filterPaymentMethods ? ((_a = paymentMethods.paymentMethods) !== null && _a !== void 0 ? _a : []).filter(options.filterPaymentMethods) : paymentMethods.paymentMethods,
            storedPaymentMethods: options.filterStoredPaymentMethods ? ((_b = paymentMethods.storedPaymentMethods) !== null && _b !== void 0 ? _b : []).filter(options.filterStoredPaymentMethods) : paymentMethods.storedPaymentMethods
        };
        const applePayConfig = ((_c = filteredPaymentMethodsResponse.paymentMethods) === null || _c === void 0 ? void 0 : _c.some((pm)=>pm.type === "applepay")) ? {
            applepay: {
                amount: response.amount,
                countryCode: "NO"
            }
        } : {};
        return AdyenCheckout({
            onActionHandled: options.onActionHandled,
            amount: response.amount,
            paymentMethodsResponse: filteredPaymentMethodsResponse,
            clientKey: merchantConfig.adyenClientKey,
            locale: response.adyenLocale,
            environment: (0, $648bbd5693a5c2fa$export$bbd3602d366ad96a)(merchantConfig.adyenEnvironment),
            onSubmit: $ceb61c869c7a4551$var$onSubmit(options.adyenFields, options.onError),
            onAdditionalDetails: $ceb61c869c7a4551$var$onAdditionalDetails(options.adyenFields, options.onError),
            translations: options.translations,
            paymentMethodsConfiguration: Object.assign({
                card: {
                    styles: options.styles,
                    enableStoreDetails: options.adyenFields.enableStoreDetails,
                    hasHolderName: true,
                    onConfigSuccess: options.onConfigSuccess,
                    holderNameRequired: true
                }
            }, applePayConfig)
        });
    } catch (_error) {
        options.onError(_error);
    }
}
function $ceb61c869c7a4551$var$onSubmit(adyenFields, onError, callback) {
    const { adyenOrder: adyenOrder, adyenOrderId: adyenOrderId, locale: locale, auth3ds: auth3ds, testCode: testCode } = adyenFields;
    return async (state, adyenComponent)=>{
        callback === null || callback === void 0 || callback(state);
        if (!(state === null || state === void 0 ? void 0 : state.isValid)) {
            onError();
            return;
        }
        try {
            const body = {
                locale: locale,
                adyenData: state === null || state === void 0 ? void 0 : state.data,
                channel: "Web",
                auth3ds: auth3ds,
                testCode: testCode
            };
            const response = await (0, $dUDPg.postPayment)(adyenOrder, adyenOrderId, body);
            $ceb61c869c7a4551$var$handleAdyenResponse(adyenComponent, response.result, adyenFields, onError);
        } catch (_error) {
            onError(_error);
        }
    };
}
function $ceb61c869c7a4551$var$onAdditionalDetails(adyenFields, onError) {
    return async (state, adyenComponent)=>{
        try {
            const response = await (0, $dUDPg.postAdditionalDetails)(adyenFields.adyenOrder, adyenFields.adyenOrderId, state === null || state === void 0 ? void 0 : state.data);
            $ceb61c869c7a4551$var$handleAdyenResponse(adyenComponent, response.result, adyenFields, onError);
        } catch (_error) {
            onError(_error);
        }
    };
}
function $ceb61c869c7a4551$var$handleAdyenResponse(adyenComponent, response, adyenFields, onError) {
    const resultCode = response === null || response === void 0 ? void 0 : response.resultCode;
    const paymentMade = $ceb61c869c7a4551$var$paymentSuccessful.includes(resultCode) || $ceb61c869c7a4551$var$paymentPending.includes(resultCode);
    if ((response === null || response === void 0 ? void 0 : response.action) !== undefined) adyenComponent === null || adyenComponent === void 0 || adyenComponent.handleAction(response === null || response === void 0 ? void 0 : response.action);
    else if (paymentMade) adyenFields.setComplete(true);
    else onError(response);
}







var $4vwom = parcelRequire("4vwom");

var $eSiQ2 = parcelRequire("eSiQ2");







var $4vwom = parcelRequire("4vwom");

function $67d1e32b493d1bb5$export$2e0a83ec2e27ecbb({ horizontal: horizontal, weight: weight = 1, spacing: spacing = 8 }) {
    const { colors: colors, helpers: helpers } = (0, $756948b644e82cf2$export$559a0f07c8df6570)();
    return (0, $4vwom.jsx)("div", {
        css: helpers.spacingToCss("padding", {
            [horizontal ? "y" : "x"]: spacing
        }),
        children: (0, $4vwom.jsx)("div", {
            style: {
                [horizontal ? "height" : "width"]: weight,
                backgroundColor: colors.gray200,
                borderRadius: weight
            }
        })
    });
}



var $4vwom = parcelRequire("4vwom");

var $lhaLc = parcelRequire("lhaLc");




const $1c19a55e13f5780a$var$sizes = {
    md: {
        xs: {
            height: 30,
            paddingLeft: 12,
            paddingRight: 12
        },
        lg: {
            height: 32,
            paddingLeft: 14,
            paddingRight: 14
        },
        xl: {
            height: 36 * (0, $1c2a8fb378443a1d$export$adc5746a202ff4b),
            paddingLeft: 16 * (0, $1c2a8fb378443a1d$export$adc5746a202ff4b),
            paddingRight: 16 * (0, $1c2a8fb378443a1d$export$adc5746a202ff4b)
        }
    }
};
const $1c19a55e13f5780a$export$48c441fbee531268 = function LabelNotification(props) {
    var _a;
    const { helpers: helpers } = (0, $756948b644e82cf2$export$559a0f07c8df6570)();
    const { fixedVariantCss: fixedVariantCss, responsiveVariantsCss: responsiveVariantsCss } = helpers;
    return (0, $4vwom.jsx)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
        elementRef: props.elementRef,
        alignItems: "center",
        backgroundColor: props.color,
        color: "grayWhite",
        borderRadius: "md",
        css: (0, $lhaLc.css)({
            display: "inline-flex"
        }, // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
        props.size instanceof Array && props.size[0] === "fixed" ? fixedVariantCss($1c19a55e13f5780a$var$sizes, props.size) : responsiveVariantsCss($1c19a55e13f5780a$var$sizes, "md")),
        children: (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
            variant: "label",
            size: (_a = props.size) !== null && _a !== void 0 ? _a : "md",
            children: props.children
        })
    });
};


function $ad78a5ecb6406b10$export$ac61754cc5f685a7(props) {
    var _a;
    return (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
        borderRadius: "md",
        padding: "md",
        borderColor: "gray200",
        direction: "column",
        gap: 16,
        children: [
            (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                justifyContent: "space-between",
                alignItems: "center",
                children: [
                    (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                        gap: 8,
                        alignItems: "center",
                        children: [
                            (0, $4vwom.jsx)((0, $f8cdd04128a131cf$export$f04a61298a47a40f), {
                                icon: props.icon
                            }),
                            " ",
                            (0, $4vwom.jsx)((0, $789b8639be592288$export$a8a3e93435678ff9), {
                                level: 4,
                                children: props.step
                            })
                        ]
                    }),
                    !!props.label && (0, $4vwom.jsx)((0, $1c19a55e13f5780a$export$48c441fbee531268), {
                        size: [
                            "fixed",
                            "md",
                            "md"
                        ],
                        color: "gray500",
                        children: props.label
                    }),
                    !!props.cta && (0, $4vwom.jsx)((0, $4b4086f8a1c6b2f8$export$353f5b6fc5456de1), {
                        size: "sm",
                        variant: "secondary",
                        onClick: ()=>alert("Not implemented"),
                        children: props.cta.text
                    })
                ]
            }),
            (0, $4vwom.jsxs)("div", {
                children: [
                    !!props.title && (0, $4vwom.jsx)((0, $789b8639be592288$export$a8a3e93435678ff9), {
                        level: 3,
                        children: props.title
                    }),
                    !!props.price && (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                        alignItems: "baseline",
                        gap: 2,
                        children: [
                            !!props.originalPrice && (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                variant: "body",
                                size: "md",
                                color: "gray300",
                                style: {
                                    textDecoration: "underline",
                                    textUnderlineOffset: "-5px",
                                    textDecorationSkipInk: "none"
                                },
                                children: props.originalPrice
                            }),
                            (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                variant: "heading",
                                level: 3,
                                color: "brand",
                                children: props.price
                            })
                        ]
                    }),
                    !!props.subtitle && (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                        variant: "body",
                        size: "md",
                        color: "gray300",
                        margin: {
                            top: 8
                        },
                        children: props.subtitle
                    })
                ]
            }),
            !!((_a = props.list) === null || _a === void 0 ? void 0 : _a.length) && (0, $4vwom.jsxs)((0, $4vwom.Fragment), {
                children: [
                    (0, $4vwom.jsx)((0, $67d1e32b493d1bb5$export$2e0a83ec2e27ecbb), {
                        horizontal: true,
                        spacing: 0
                    }),
                    (0, $4vwom.jsx)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                        direction: "column",
                        gap: (0, $756948b644e82cf2$export$981516ee4691055c)(8),
                        children: props.list.map((li)=>{
                            var _a;
                            return (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                                gap: (0, $756948b644e82cf2$export$981516ee4691055c)(8),
                                children: [
                                    (0, $4vwom.jsx)((0, $f8cdd04128a131cf$export$f04a61298a47a40f), {
                                        icon: (_a = li.icon) !== null && _a !== void 0 ? _a : "check",
                                        color: "forest"
                                    }),
                                    (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                        variant: "body",
                                        size: "md",
                                        children: li.text
                                    })
                                ]
                            }, li.id);
                        })
                    })
                ]
            }),
            !!props.text && (0, $4vwom.jsxs)((0, $4vwom.Fragment), {
                children: [
                    (0, $4vwom.jsx)((0, $67d1e32b493d1bb5$export$2e0a83ec2e27ecbb), {
                        horizontal: true,
                        spacing: 0
                    }),
                    (0, $4vwom.jsx)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                        direction: "column",
                        gap: (0, $756948b644e82cf2$export$981516ee4691055c)(8),
                        children: (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                            variant: "body",
                            size: "md",
                            children: props.text
                        })
                    })
                ]
            })
        ]
    });
}
(0, $eSiQ2.Component)($ad78a5ecb6406b10$export$ac61754cc5f685a7, {
    name: "CheckoutStepSummaryBlock",
    gallery: {
        path: "Other/CheckoutStepSummaryBlock",
        items: [
            {
                variants: [
                    {
                        props: {
                            icon: "device",
                            step: "Telefon",
                            title: "iPhone 15 Pro",
                            price: "96 kr",
                            originalPrice: "180",
                            subtitle: "Some extra info in the subtitle."
                        }
                    },
                    {
                        props: {
                            icon: "device",
                            step: "Telefon",
                            title: "iPhone 15 Pro",
                            price: "100 kr",
                            subtitle: "Some extra info in the subtitle."
                        }
                    }
                ]
            }
        ]
    }
});


parcelRequire("2LTO8");
var $8h5s0 = parcelRequire("8h5s0");
var $97R5C = parcelRequire("97R5C");






var $4vwom = parcelRequire("4vwom");

var $eeH7J = parcelRequire("eeH7J");

var $lhaLc = parcelRequire("lhaLc");

var $eSiQ2 = parcelRequire("eSiQ2");




var $4vwom = parcelRequire("4vwom");

var $eSiQ2 = parcelRequire("eSiQ2");



function $a9f507254d800340$export$fbbf1dbfdbfcef12(props) {
    const { colors: colors } = (0, $756948b644e82cf2$export$559a0f07c8df6570)();
    return (0, $4vwom.jsxs)("div", {
        style: Object.assign(Object.assign({}, typeof props.margin === "undefined" ? {
            marginTop: 12,
            marginBottom: 16
        } : {}), {
            color: colors.warning,
            display: "flex"
        }),
        children: [
            (0, $4vwom.jsx)((0, $f8cdd04128a131cf$export$f04a61298a47a40f), {
                icon: "warning",
                color: "warning",
                margin: {
                    right: 8
                }
            }),
            (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                variant: "body",
                size: "md",
                children: props.children
            })
        ]
    });
}
(0, $eSiQ2.Component)($a9f507254d800340$export$fbbf1dbfdbfcef12, {
    name: "WarningMessage"
});




const $46d788785e7b9d76$var$borderColors = {
    default: "gray200",
    active: "brand",
    error: "error",
    completed: "forestLight"
};
const $46d788785e7b9d76$export$c86715117507e8e5 = /*#__PURE__*/ (0, $eeH7J.forwardRef)(function TextInput(props, ref) {
    var _a;
    const { colors: colors, helpers: helpers } = (0, $756948b644e82cf2$export$559a0f07c8df6570)();
    const { responsiveCss: responsiveCss, responsiveBodyCss: responsiveBodyCss } = helpers;
    const [isActive, setIsActive] = (0, $eeH7J.useState)(false);
    const state = (0, $eeH7J.useMemo)(()=>{
        if (props.state) return props.state;
        if (isActive) return "active";
        return "default";
    }, [
        props.state,
        isActive
    ]);
    const handleChange = (0, $eeH7J.useCallback)((e)=>{
        if (typeof props.onChange === "function") props.onChange(e);
    }, [
        props
    ]);
    const handleBlur = (0, $eeH7J.useCallback)((e)=>{
        var _a;
        setIsActive(false);
        (_a = props.onBlur) === null || _a === void 0 || _a.call(props, e);
    }, [
        setIsActive,
        props
    ]);
    const handleKeyPress = (0, $eeH7J.useCallback)((e)=>{
        var _a;
        // General onKeyPress
        (_a = props.onKeyPress) === null || _a === void 0 || _a.call(props, e);
        // Additionally call onEnter if provided
        if (props.onEnter && e.key === "Enter") {
            props.onEnter(e);
            e.preventDefault();
            return;
        }
    }, [
        props
    ]);
    const inputCss = (0, $eeH7J.useMemo)(()=>(0, $lhaLc.css)((0, $e82ba787de72625c$export$6b6f359a824920a4)("input"), {
            "::placeholder": {
                color: colors.gray300
            }
        }, responsiveBodyCss("md")), [
        colors.gray300,
        responsiveBodyCss
    ]);
    return (0, $4vwom.jsxs)((0, $bee1a5e35c892a21$export$e71c4d32a2263218), {
        style: props.fullwidth ? {
            width: "100%"
        } : {},
        children: [
            (0, $4vwom.jsxs)((0, $bee1a5e35c892a21$export$e71c4d32a2263218), {
                borderColor: $46d788785e7b9d76$var$borderColors[state],
                borderRadius: "sm",
                css: (0, $lhaLc.css)({
                    height: 48 * (0, $1c2a8fb378443a1d$export$adc5746a202ff4b)
                }, responsiveCss("min", "md", {
                    height: 64 * (0, $1c2a8fb378443a1d$export$adc5746a202ff4b)
                })),
                style: {
                    display: "flex",
                    alignItems: "center",
                    paddingLeft: 20 * (0, $1c2a8fb378443a1d$export$adc5746a202ff4b),
                    paddingRight: 20 * (0, $1c2a8fb378443a1d$export$adc5746a202ff4b),
                    borderWidth: 2,
                    backgroundColor: props.disabled ? colors.gray100 : undefined
                },
                children: [
                    !!props.icon && (0, $4vwom.jsx)((0, $f8cdd04128a131cf$export$f04a61298a47a40f), {
                        icon: props.icon,
                        style: {
                            marginRight: 10
                        }
                    }),
                    (0, $4vwom.jsx)("input", {
                        disabled: props.disabled,
                        ref: ref,
                        onFocus: ()=>setIsActive(true),
                        onBlur: handleBlur,
                        type: (_a = props.type) !== null && _a !== void 0 ? _a : "text",
                        autoComplete: props.autoComplete,
                        placeholder: props.label,
                        css: inputCss,
                        size: 2,
                        style: {
                            height: "100%",
                            width: "100%",
                            backgroundColor: "transparent",
                            paddingBottom: 2,
                            color: state === "error" ? colors.error : undefined
                        },
                        value: props.value,
                        onChange: handleChange,
                        onKeyPress: handleKeyPress
                    }),
                    state === "completed" && (0, $4vwom.jsx)((0, $f8cdd04128a131cf$export$f04a61298a47a40f), {
                        icon: "check",
                        color: "forest",
                        style: {
                            marginLeft: 10
                        }
                    })
                ]
            }),
            props.warning ? (0, $4vwom.jsx)((0, $a9f507254d800340$export$fbbf1dbfdbfcef12), {
                children: props.warning
            }) : null
        ]
    });
});
(0, $eSiQ2.Component)($46d788785e7b9d76$export$c86715117507e8e5, {
    name: "TextInput",
    gallery: {
        path: "Controllers/TextInput",
        items: [
            {
                title: "Empty",
                variants: [
                    {
                        props: (state = {
                            value: ""
                        }, setState)=>({
                                value: state.value,
                                label: "First name",
                                onChange: (e)=>setState(e.target.value)
                            })
                    }
                ]
            },
            {
                title: "With value",
                variants: [
                    {
                        props: (state = {
                            value: "Jane"
                        }, setState)=>({
                                value: state.value,
                                onChange: (e)=>setState(e.target.value)
                            })
                    }
                ]
            },
            {
                title: "With icon",
                variants: [
                    {
                        props: (state = {
                            value: "Oslo"
                        }, setState)=>({
                                value: state.value,
                                icon: "navigationArrow",
                                onChange: (e)=>setState(e.target.value)
                            })
                    }
                ]
            },
            {
                title: "Completed",
                variants: [
                    {
                        props: (state = {
                            value: "John Doe"
                        }, setState)=>({
                                value: state.value,
                                state: "completed",
                                onChange: (e)=>setState(e.target.value)
                            })
                    }
                ]
            },
            {
                title: "Error",
                variants: [
                    {
                        props: (state = {
                            value: "John Doe"
                        }, setState)=>({
                                value: state.value,
                                state: "error",
                                onChange: (e)=>setState(e.target.value)
                            })
                    }
                ]
            }
        ]
    }
});



var $34lt5 = parcelRequire("34lt5");


var $4vwom = parcelRequire("4vwom");

var $lhaLc = parcelRequire("lhaLc");





var $aIeEI = parcelRequire("aIeEI");


var $dUDPg = parcelRequire("dUDPg");
function $440c4b5b9e7400e5$export$55aa795759f227b9(props) {
    var _a;
    const localize = (0, $aIeEI.useLocalize)();
    const primaryActionPageInfo = (0, $dUDPg.useWebPageInfo)(props.primaryAction.page);
    return (0, $4vwom.jsx)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
        justifyContent: "center",
        style: {
            width: "100%",
            height: "100%"
        },
        children: (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
            direction: "column",
            justifyContent: "center",
            alignItems: "center",
            css: (0, $lhaLc.css)((0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("max", "sm", {
                padding: "16px 0"
            })),
            children: [
                (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                    direction: "column",
                    alignItems: "center",
                    gap: 12,
                    css: (0, $lhaLc.css)((0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("max", "sm", {
                        gap: 8,
                        marginBottom: 32
                    }), (0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("min", "md", {
                        padding: "0 40px",
                        gap: 12,
                        marginBottom: 40
                    })),
                    children: [
                        (0, $4vwom.jsx)((0, $789b8639be592288$export$a8a3e93435678ff9), {
                            color: "gray500",
                            level: 2,
                            children: localize(props.heading)
                        }),
                        (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                            color: "gray400",
                            variant: "body",
                            size: "md",
                            children: localize(props.text)
                        })
                    ]
                }),
                ((_a = primaryActionPageInfo.data) === null || _a === void 0 ? void 0 : _a.slug) ? (0, $4vwom.jsx)((0, $4b4086f8a1c6b2f8$export$353f5b6fc5456de1), {
                    variant: "primary",
                    size: "md",
                    as: "a",
                    href: `/${localize(primaryActionPageInfo.data.slug)}`,
                    children: localize(props.primaryAction.buttonText)
                }) : null
            ]
        })
    });
}




var $8vTN8 = parcelRequire("8vTN8");

var $dUDPg = parcelRequire("dUDPg");

var $eeH7J = parcelRequire("eeH7J");

var $aIeEI = parcelRequire("aIeEI");
parcelRequire("2LTO8");
var $2zTLn = parcelRequire("2zTLn");
const $b274814d74f89bd0$export$2bb3eb27682a776 = {
    no: "m\xe5neder",
    en: "months"
};
const $b274814d74f89bd0$export$b4b23bfab2f68498 = {
    no: "md",
    en: "mo"
};
const $b274814d74f89bd0$export$91d51a43b638ef12 = {
    [(0, $2zTLn.CurrencyCode)("NOK")]: {
        no: "kr",
        en: "kr"
    }
};
function $b274814d74f89bd0$export$2daf9f30efa60400() {
    const localize = (0, $aIeEI.useLocalize)();
    return (0, $eeH7J.useCallback)((cc)=>{
        var _a;
        return `${localize((_a = $b274814d74f89bd0$export$91d51a43b638ef12[cc]) !== null && _a !== void 0 ? _a : {
            no: cc
        })}`;
    }, [
        localize
    ]);
}
function $b274814d74f89bd0$export$cd05f017078a61a8() {
    const localize = (0, $aIeEI.useLocalize)();
    const currentLocale = (0, $aIeEI.useCurrentLocale)();
    return (0, $eeH7J.useCallback)((a)=>{
        var _a;
        return `${Intl.NumberFormat(currentLocale.valueOf(), {
            minimumFractionDigits: Number.isInteger(a.majorUnits) ? 0 : 2,
            maximumFractionDigits: 2
        }).format(a.majorUnits)} ${localize((_a = $b274814d74f89bd0$export$91d51a43b638ef12[a.currency]) !== null && _a !== void 0 ? _a : {
            no: a.currency
        })}`;
    }, [
        currentLocale,
        localize
    ]);
}






function $f6289446464b7da6$export$20c36f2f8fe0d441(props) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u;
    const me = (0, $e18f565b44c7bc7d$export$f637e1cf42d15a62)();
    const context = (0, $c90be680bf4410a3$export$b75716bfd8405073)();
    const navigate = (0, $8vTN8.useNavigate)();
    const { useOrder: useOrder, applyDiscountCode: applyDiscountCode, clearDiscountCode: clearDiscountCode } = context;
    const localize = (0, $aIeEI.useLocalize)();
    const formatAmount = (0, $b274814d74f89bd0$export$cd05f017078a61a8)();
    const [discount] = (0, $047f6f355e30d7d1$export$745963d6dc3bf932)();
    const [discountCodeInputValue, setDiscountCodeInputValue] = (0, $eeH7J.useState)("");
    const [discountCodeError, setDiscountCodeError] = (0, $eeH7J.useState)();
    const [checkoutShippingState] = (0, $047f6f355e30d7d1$export$4a755370e8335b36)();
    const [checkoutTradeInPriceRequest] = (0, $047f6f355e30d7d1$export$b7eadabbf1e81c9b)();
    const [checkoutTradeInForm] = (0, $047f6f355e30d7d1$export$d42da32bb85d5739)();
    const [checkoutTradeInResult] = (0, $047f6f355e30d7d1$export$db65bad7d1fa5d6f)();
    const { data: tnc, loading: tncIsLoading } = (0, $e18f565b44c7bc7d$export$23e8c26267d65867)();
    const { order: order, ensureOrder: ensureOrder, isLoading: isLoading, errorMessage: errorMessage } = useOrder();
    const [phoneIsNotAvailable, setPhoneIsNotAvailable] = (0, $eeH7J.useState)(undefined);
    const [dropinIsReady, setDropinIsReady] = (0, $eeH7J.useState)(false);
    const [multiplePaymentMethods, setMultiplePaymentMethods] = (0, $eeH7J.useState)(false);
    const adyenDropinContainerRef = (0, $eeH7J.useRef)(null);
    const [paymentError, setPaymentError] = (0, $eeH7J.useState)(false);
    const [creditCheckError, setCreditCheckError] = (0, $eeH7J.useState)(undefined);
    const confirmationPageInfo = (0, $dUDPg.useWebPageInfo)(props.orderConfirmationPage);
    const theme = (0, $756948b644e82cf2$export$559a0f07c8df6570)();
    const { colors: colors } = theme;
    const [calculatedOrderPrice] = (0, $047f6f355e30d7d1$export$aed04c9c9fee3492)();
    const handleDropinReady = (0, $eeH7J.useCallback)(()=>{
        var _a, _b;
        const numberOfPaymentMethods = (_b = (_a = adyenDropinContainerRef.current) === null || _a === void 0 ? void 0 : _a.querySelectorAll(".adyen-checkout__payment-method").length) !== null && _b !== void 0 ? _b : 0;
        setMultiplePaymentMethods(numberOfPaymentMethods > 1);
        setDropinIsReady(true);
        // Height is just set for a consistent height during loading. Reset when done.
        setAdyenContainerHeight(undefined);
    }, []);
    (0, (/*@__PURE__*/$parcel$interopDefault($alVaN))).extend((0, (/*@__PURE__*/$parcel$interopDefault($hFOwS))));
    const postAnalyticsCheckoutPaymentEvent = (0, $eeH7J.useCallback)(async (event, data)=>{
        context.postAnalyticsCheckoutEvent([
            "step",
            "payment",
            event
        ], data);
    }, [
        context
    ]);
    const shippingSlotId = ((_a = checkoutShippingState.selectedOption) === null || _a === void 0 ? void 0 : _a.type) === "Manual" ? (_b = checkoutShippingState.selectedOption.selectedSlot) === null || _b === void 0 ? void 0 : _b.id : undefined;
    const ensureCheckoutOrder = (0, $eeH7J.useCallback)(async ()=>{
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
        ensureOrder({
            phone: context.offer,
            shippingAddress: {
                street: (_b = (_a = context.shipping.form) === null || _a === void 0 ? void 0 : _a.street.value) !== null && _b !== void 0 ? _b : "",
                unit: (_c = context.shipping.form) === null || _c === void 0 ? void 0 : _c.unit.value,
                city: (_e = (_d = context.shipping.form) === null || _d === void 0 ? void 0 : _d.region.value) !== null && _e !== void 0 ? _e : "",
                zip: (_g = (_f = context.shipping.form) === null || _f === void 0 ? void 0 : _f.postalCode.value) !== null && _g !== void 0 ? _g : "",
                country: (0, $97R5C.CountryCode)((_j = (_h = context.shipping.form) === null || _h === void 0 ? void 0 : _h.countryCode.value) !== null && _j !== void 0 ? _j : "")
            },
            shippingType: (0, $8h5s0.Assert)((_k = checkoutShippingState.selectedOption) === null || _k === void 0 ? void 0 : _k.type),
            shippingSlot: ((_l = checkoutShippingState.selectedOption) === null || _l === void 0 ? void 0 : _l.type) === "Manual" ? shippingSlotId : undefined,
            tradeIn: checkoutTradeInPriceRequest,
            termsAndConditions: (0, $8h5s0.Assert)(tnc === null || tnc === void 0 ? void 0 : tnc.phoneOrder.id),
            insuranceTermsAndConditions: (0, $8h5s0.Assert)(tnc === null || tnc === void 0 ? void 0 : tnc.insurance.id),
            discountId: discount === null || discount === void 0 ? void 0 : discount.id
        }).then(()=>{
            setPhoneIsNotAvailable(false);
        }).catch(()=>{
            setPhoneIsNotAvailable(true);
        });
    }, [
        ensureOrder,
        context.offer,
        (_c = context.shipping.form) === null || _c === void 0 ? void 0 : _c.street.value,
        (_d = context.shipping.form) === null || _d === void 0 ? void 0 : _d.unit.value,
        (_e = context.shipping.form) === null || _e === void 0 ? void 0 : _e.region.value,
        (_f = context.shipping.form) === null || _f === void 0 ? void 0 : _f.postalCode.value,
        (_g = context.shipping.form) === null || _g === void 0 ? void 0 : _g.countryCode.value,
        (_h = checkoutShippingState.selectedOption) === null || _h === void 0 ? void 0 : _h.type,
        shippingSlotId,
        checkoutTradeInPriceRequest,
        tnc === null || tnc === void 0 ? void 0 : tnc.phoneOrder.id,
        tnc === null || tnc === void 0 ? void 0 : tnc.insurance.id,
        discount === null || discount === void 0 ? void 0 : discount.id
    ]);
    const handlePaymentError = (0, $eeH7J.useCallback)((err)=>{
        // Check if payment error is due to failed credit check.
        if ((err === null || err === void 0 ? void 0 : err.type) === "CreditCheckBlocked") {
            setCreditCheckError("blocked");
            postAnalyticsCheckoutPaymentEvent("credit-check-blocked");
        } else if ((err === null || err === void 0 ? void 0 : err.type) === "CreditCheckManualProcessing") setCreditCheckError("manual");
        else if ((err === null || err === void 0 ? void 0 : err.type) === "CreditScoreTooLow") setCreditCheckError("tooLow");
        else postAnalyticsCheckoutPaymentEvent("error");
        setPaymentError(true);
        setDropinIsReady(false);
        ensureCheckoutOrder();
    }, [
        ensureCheckoutOrder,
        postAnalyticsCheckoutPaymentEvent
    ]);
    const [adyenIsReloading, setAdyenIsReloading] = (0, $eeH7J.useState)(false);
    const [adyenContainerHeight, setAdyenContainerHeight] = (0, $eeH7J.useState)();
    const reloadAdyen = (0, $eeH7J.useCallback)(()=>{
        var _a;
        const height = (_a = adyenDropinContainerRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect().height;
        if (height !== undefined) {
            setAdyenContainerHeight(height);
            setAdyenIsReloading(true);
            setTimeout(()=>{
                setAdyenIsReloading(false);
            }, 1);
        }
    }, []);
    const handleDiscountCodeInputChange = (0, $eeH7J.useCallback)((e)=>{
        setDiscountCodeInputValue(e.target.value);
        // Clear error message if field is cleared.
        if (!e.target.value) setDiscountCodeError(undefined);
    }, []);
    const validateAndApplyDiscountCode = (0, $eeH7J.useCallback)(async ()=>{
        try {
            await applyDiscountCode(discountCodeInputValue);
            reloadAdyen();
            setDiscountCodeError(undefined);
        } catch (err) {
            if ((err === null || err === void 0 ? void 0 : err.type) === "DiscountCodeInvalid") setDiscountCodeError("invalid");
            else if ((err === null || err === void 0 ? void 0 : err.type) === "DiscountCodeDisabled") setDiscountCodeError("disabled");
            else if ((err === null || err === void 0 ? void 0 : err.type) === "DiscountCodeNotValidYet") setDiscountCodeError("notValidYet");
            else if ((err === null || err === void 0 ? void 0 : err.type) === "DiscountCodeExpired") setDiscountCodeError("expired");
            else if ((err === null || err === void 0 ? void 0 : err.type) === "DiscountCodeUsageLimitReached") setDiscountCodeError("usageLimitReached");
            else setDiscountCodeError("unknown");
        }
    }, [
        applyDiscountCode,
        discountCodeInputValue,
        reloadAdyen
    ]);
    (0, $eeH7J.useEffect)(()=>{
        if (isLoading || tncIsLoading) return;
        if (phoneIsNotAvailable !== undefined) return;
        ensureCheckoutOrder();
    }, [
        isLoading,
        ensureCheckoutOrder,
        phoneIsNotAvailable,
        tncIsLoading
    ]);
    const selectedInsurance = (0, $eeH7J.useMemo)(()=>{
        var _a;
        return (_a = context.insuranceOptions.data) === null || _a === void 0 ? void 0 : _a.find((insurance)=>insurance.id === context.offer.insurance);
    }, [
        context.insuranceOptions.data,
        context.offer.insurance
    ]);
    const creditCheckErrorMessage = (0, $eeH7J.useMemo)(()=>{
        var _a;
        return !!creditCheckError && ((_a = props.creditCheckMessages) === null || _a === void 0 ? void 0 : _a[creditCheckError]) ? localize(props.creditCheckMessages[creditCheckError]) : undefined;
    }, [
        creditCheckError,
        localize,
        props.creditCheckMessages
    ]);
    if (isLoading || tncIsLoading) return (0, $4vwom.jsx)((0, $4vwom.Fragment), {});
    if (!order && ((_j = checkoutShippingState.selectedOption) === null || _j === void 0 ? void 0 : _j.type) === "Manual" && !shippingSlotId) return (0, $4vwom.jsx)((0, $72c5ae9e0017e167$export$4b2c32e08f77ff18), {
        size: "md",
        children: (0, $4vwom.jsx)((0, $82d66b15b8f4758d$export$d5163f1ce1e6a5f9), {
            value: localize(props.payment.missingShippingMethod)
        })
    });
    if (errorMessage) return (0, $4vwom.jsx)((0, $72c5ae9e0017e167$export$4b2c32e08f77ff18), {
        size: "md",
        children: (0, $4vwom.jsx)((0, $82d66b15b8f4758d$export$d5163f1ce1e6a5f9), {
            value: localize(props.payment.orderReservationError)
        })
    });
    if (!order) return (0, $4vwom.jsx)((0, $4vwom.Fragment), {});
    if (phoneIsNotAvailable) return (0, $4vwom.jsx)((0, $440c4b5b9e7400e5$export$55aa795759f227b9), Object.assign({}, context.props.SoldOut));
    return (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
        direction: "column",
        gap: 32,
        children: [
            (0, $4vwom.jsx)((0, $789b8639be592288$export$a8a3e93435678ff9), {
                level: 2,
                children: localize(props.heading)
            }),
            (0, $4vwom.jsxs)("div", {
                style: {
                    position: "relative"
                },
                children: [
                    !dropinIsReady && !paymentError && (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                        gap: 16,
                        direction: "column",
                        alignItems: "stretch",
                        children: [
                            (0, $4vwom.jsx)((0, $46d788785e7b9d76$export$c86715117507e8e5), {
                                disabled: true
                            }),
                            (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                                gap: 16,
                                children: [
                                    (0, $4vwom.jsx)((0, $46d788785e7b9d76$export$c86715117507e8e5), {
                                        fullwidth: true,
                                        disabled: true
                                    }),
                                    (0, $4vwom.jsx)((0, $46d788785e7b9d76$export$c86715117507e8e5), {
                                        fullwidth: true,
                                        disabled: true
                                    })
                                ]
                            }),
                            (0, $4vwom.jsx)((0, $46d788785e7b9d76$export$c86715117507e8e5), {
                                disabled: true
                            }),
                            (0, $4vwom.jsx)((0, $4b4086f8a1c6b2f8$export$353f5b6fc5456de1), {
                                size: "md",
                                variant: "primary",
                                disabled: true
                            })
                        ]
                    }),
                    !!creditCheckErrorMessage && (0, $4vwom.jsx)((0, $82d66b15b8f4758d$export$d5163f1ce1e6a5f9), {
                        value: creditCheckErrorMessage
                    }),
                    paymentError && !creditCheckErrorMessage && (0, $4vwom.jsxs)("div", {
                        children: [
                            (0, $4vwom.jsx)((0, $82d66b15b8f4758d$export$d5163f1ce1e6a5f9), {
                                value: localize(props.payment.paymentErrorMessage)
                            }),
                            (0, $4vwom.jsx)((0, $4b4086f8a1c6b2f8$export$353f5b6fc5456de1), {
                                variant: "dark",
                                margin: {
                                    top: 16
                                },
                                size: "sm",
                                onClick: ()=>setPaymentError(false),
                                children: localize({
                                    no: "Pr\xf8v igjen",
                                    en: "Try again"
                                })
                            })
                        ]
                    }),
                    phoneIsNotAvailable === false && !paymentError && (0, $4vwom.jsx)("div", {
                        ref: adyenDropinContainerRef,
                        css: (0, $lhaLc.css)((0, $756948b644e82cf2$export$682f474bed45e419), !multiplePaymentMethods ? (0, $lhaLc.css)({
                            ".adyen-checkout__payment-method__header": {
                                display: "none"
                            }
                        }) : {}),
                        style: adyenContainerHeight !== undefined ? {
                            height: adyenContainerHeight
                        } : !dropinIsReady ? {
                            position: "absolute",
                            top: 0,
                            right: 0,
                            bottom: 0,
                            left: 0,
                            opacity: 0
                        } : {},
                        children: adyenIsReloading ? (0, $4vwom.jsx)((0, $4vwom.Fragment), {}) : (0, $4vwom.jsx)((0, $ceb61c869c7a4551$export$8917e58bffe5ae62), {
                            onSuccess: ()=>{
                                var _a;
                                postAnalyticsCheckoutPaymentEvent("success");
                                if ((_a = confirmationPageInfo.data) === null || _a === void 0 ? void 0 : _a.slug) navigate(`/${localize(confirmationPageInfo.data.slug)}?o=${order.id}`);
                                else alert("Missing confirmation page configuration.");
                            },
                            onConfigSuccess: ()=>{
                                postAnalyticsCheckoutPaymentEvent("card-form-ready");
                            },
                            onSubmitCallback: (state)=>{
                                postAnalyticsCheckoutPaymentEvent("submit");
                            },
                            onError: handlePaymentError,
                            adyenOrder: "phone-subscription",
                            adyenOrderId: // The Adyen Order ID is encoded as
                            // `${orderId}_${periodIndex}`. We are paying for the
                            // first period (0).
                            `${order.id.valueOf()}_0`,
                            DropinElementProps: {
                                onReady: handleDropinReady,
                                instantPaymentTypes: [
                                    "applepay"
                                ]
                            },
                            onActionHandled: (data)=>{
                                postAnalyticsCheckoutPaymentEvent("action-handled", {
                                    componentType: data.componentType,
                                    actionDescription: data.actionDescription
                                });
                            },
                            translations: {
                                "no-NO": Object.assign({
                                    "creditCard.holderName.placeholder": localize(props.payment.cardholderNamePlaceholder, (0, $34lt5.LocaleKey).no)
                                }, ((_k = props.payment.zeroSumPaymentButton) === null || _k === void 0 ? void 0 : _k.no) ? {
                                    confirmPreauthorization: props.payment.zeroSumPaymentButton.no
                                } : {}),
                                "en-US": Object.assign({
                                    "creditCard.holderName.placeholder": localize(props.payment.cardholderNamePlaceholder, (0, $34lt5.LocaleKey).en)
                                }, ((_l = props.payment.zeroSumPaymentButton) === null || _l === void 0 ? void 0 : _l.en) ? {
                                    confirmPreauthorization: props.payment.zeroSumPaymentButton.en
                                } : {})
                            },
                            filterPaymentMethods: ((_m = me.data) === null || _m === void 0 ? void 0 : _m.disabledPaymentMethods) ? (pm)=>{
                                var _a, _b;
                                return !((_b = (_a = me.data) === null || _a === void 0 ? void 0 : _a.disabledPaymentMethods) === null || _b === void 0 ? void 0 : _b.includes(pm.type));
                            } : undefined,
                            styles: {
                                base: {
                                    color: colors.gray500,
                                    fontWeight: "300",
                                    fontSize: "16px"
                                },
                                placeholder: {
                                    color: colors.gray300,
                                    fontWeight: "300",
                                    fontSize: "16px"
                                }
                            }
                        })
                    })
                ]
            }),
            !creditCheckErrorMessage && (0, $4vwom.jsx)((0, $bee1a5e35c892a21$export$e71c4d32a2263218), {
                backgroundColor: "gray100",
                borderRadius: "md",
                padding: "md",
                children: (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                    variant: "body",
                    size: "md",
                    color: "gray400",
                    children: (0, $4vwom.jsx)((0, $82d66b15b8f4758d$export$d5163f1ce1e6a5f9), {
                        value: localize(props.payment.paymentDetailsWillBeStoredText)
                    })
                })
            }),
            discount ? (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                gap: 24,
                borderRadius: "md",
                padding: "md",
                justifyContent: "space-between",
                alignItems: "center",
                style: {
                    width: "100%"
                },
                backgroundColor: "skyLight",
                children: [
                    (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                        gap: 8,
                        alignItems: "center",
                        children: [
                            (0, $4vwom.jsx)((0, $f8cdd04128a131cf$export$f04a61298a47a40f), {
                                icon: "sealPercent"
                            }),
                            " ",
                            (0, $4vwom.jsxs)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                variant: "body",
                                size: "md",
                                fontWeight: 500,
                                children: [
                                    localize({
                                        no: "Aktiv rabattkode",
                                        en: "Applied discount code"
                                    }),
                                    ":",
                                    " ",
                                    (0, $4vwom.jsx)("span", {
                                        style: {
                                            color: colors.brand
                                        },
                                        children: discount.code
                                    })
                                ]
                            })
                        ]
                    }),
                    (0, $4vwom.jsx)((0, $4b4086f8a1c6b2f8$export$353f5b6fc5456de1), {
                        size: "sm",
                        variant: "dark",
                        onClick: ()=>{
                            setDiscountCodeInputValue("");
                            clearDiscountCode();
                            reloadAdyen();
                        },
                        children: localize({
                            no: "Fjern",
                            en: "Remove"
                        })
                    })
                ]
            }) : (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                css: (0, $lhaLc.css)({
                    gap: 16
                }, (0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("min", "md", {
                    gap: 24
                })),
                children: [
                    (0, $4vwom.jsx)((0, $46d788785e7b9d76$export$c86715117507e8e5), {
                        fullwidth: true,
                        label: localize({
                            no: "Rabattkode",
                            en: "Discount code"
                        }),
                        value: discountCodeInputValue,
                        onChange: handleDiscountCodeInputChange,
                        onEnter: ()=>validateAndApplyDiscountCode(),
                        warning: discountCodeError ? localize(props.discountCodes.errorMessages[discountCodeError]) : undefined
                    }),
                    (0, $4vwom.jsx)((0, $4b4086f8a1c6b2f8$export$353f5b6fc5456de1), {
                        onClick: validateAndApplyDiscountCode,
                        children: localize({
                            no: "Bruk",
                            en: "Apply"
                        })
                    })
                ]
            }),
            (0, $4vwom.jsx)((0, $67d1e32b493d1bb5$export$2e0a83ec2e27ecbb), {
                horizontal: true,
                spacing: 0
            }),
            (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                direction: "column",
                gap: 24,
                children: [
                    (0, $4vwom.jsx)((0, $789b8639be592288$export$a8a3e93435678ff9), {
                        level: 3,
                        children: localize(props.summary.heading)
                    }),
                    (0, $4vwom.jsx)((0, $ad78a5ecb6406b10$export$ac61754cc5f685a7), Object.assign({
                        icon: "device",
                        step: localize((_o = props.summary.device.stepName) !== null && _o !== void 0 ? _o : {}),
                        title: localize(context.offer.name),
                        subtitle: (0, $87d2193cf0695c20$export$4493d2932fe76cf8)(localize(props.summary.device.rentalPeriodTotalPrice), {
                            rentalPeriod: `${context.offer.rentalPeriod.valueOf()} ${localize((0, $b274814d74f89bd0$export$b4b23bfab2f68498))}`,
                            totalPrice: calculatedOrderPrice ? formatAmount(calculatedOrderPrice.rentalPeriodTotalPrice) : ""
                        })
                    }, !context.price ? {} : context.price.monthlyCost.discountedTotal.majorUnits !== context.price.monthlyCost.itemsTotal.majorUnits ? {
                        price: `${formatAmount(context.price.monthlyCost.discountedTotal)}/${localize((0, $b274814d74f89bd0$export$b4b23bfab2f68498))}`,
                        originalPrice: context.price.monthlyCost.phone.majorUnits.toString(),
                        text: (discount === null || discount === void 0 ? void 0 : discount.durationMonths) && discount.durationMonths.valueOf() < order.rentalPeriod.months ? (0, $87d2193cf0695c20$export$4493d2932fe76cf8)(localize(props.summary.device.discountDetailsMonths), {
                            discountPeriod: discount.durationMonths.toString(),
                            priceAfterDiscount: context.price.monthlyCost.totalAfterCodeDiscountPeriod ? `${formatAmount(context.price.monthlyCost.totalAfterCodeDiscountPeriod)}/${localize((0, $b274814d74f89bd0$export$b4b23bfab2f68498))}` : ""
                        }) : undefined
                    } : {
                        price: `${formatAmount(context.price.monthlyCost.phone)}`
                    })),
                    checkoutTradeInForm && checkoutTradeInPriceRequest && typeof (checkoutTradeInResult === null || checkoutTradeInResult === void 0 ? void 0 : checkoutTradeInResult.value) !== "undefined" && ((_p = order.tradeIn) === null || _p === void 0 ? void 0 : _p.discount.amount) && checkoutTradeInResult.deviceName ? (0, $4vwom.jsx)((0, $ad78a5ecb6406b10$export$ac61754cc5f685a7), {
                        icon: "handCoins",
                        step: localize(context.props.TradeIn.name),
                        title: localize(checkoutTradeInResult.deviceName),
                        subtitle: (0, $87d2193cf0695c20$export$4493d2932fe76cf8)(localize(props.summary.tradeIn.text), {
                            monthlyDiscount: formatAmount(checkoutTradeInResult.monthlyDiscount),
                            discountPeriod: `${checkoutTradeInResult.months.valueOf()}`
                        }),
                        price: formatAmount(checkoutTradeInResult.value),
                        list: (_q = props.summary.tradeIn.list) === null || _q === void 0 ? void 0 : _q.map((li)=>({
                                id: li.id.valueOf(),
                                text: localize(li.text)
                            }))
                    }) : null,
                    selectedInsurance && ((_r = context.price) === null || _r === void 0 ? void 0 : _r.monthlyCost.insurance) ? (0, $4vwom.jsx)((0, $ad78a5ecb6406b10$export$ac61754cc5f685a7), {
                        icon: "shield",
                        step: localize(context.props.Insurance.name),
                        title: localize(selectedInsurance.displayName),
                        price: `${formatAmount(context.price.monthlyCost.insurance)}/${localize((0, $b274814d74f89bd0$export$b4b23bfab2f68498))}`,
                        list: selectedInsurance.sellingPoints.map((isp)=>({
                                id: isp.id.valueOf(),
                                text: localize(isp.text)
                            }))
                    }) : null,
                    checkoutShippingState.selectedOption ? (0, $4vwom.jsx)((0, $ad78a5ecb6406b10$export$ac61754cc5f685a7), {
                        icon: "truck",
                        step: localize(context.props.Shipping.name),
                        title: localize(checkoutShippingState.selectedOption.name),
                        subtitle: checkoutShippingState.selectedOption.type === "Manual" && checkoutShippingState.selectedOption.selectedSlot ? (0, $87d2193cf0695c20$export$4493d2932fe76cf8)(localize(props.summary.shipping.deliverySlotText), {
                            deliveryDate: (0, (/*@__PURE__*/$parcel$interopDefault($alVaN)))(checkoutShippingState.selectedOption.selectedSlot.date).format("dddd Do MMMM"),
                            deliverySlotFrom: checkoutShippingState.selectedOption.selectedSlot.from,
                            deliverySlotTo: checkoutShippingState.selectedOption.selectedSlot.to
                        }) : props.summary.shipping.otherDeliveryOptionText ? (0, $87d2193cf0695c20$export$4493d2932fe76cf8)(localize(props.summary.shipping.otherDeliveryOptionText), {
                            deliveryOptionName: localize(checkoutShippingState.selectedOption.name),
                            deliveryOptionDescription: localize(checkoutShippingState.selectedOption.description)
                        }) : localize(checkoutShippingState.selectedOption.description),
                        price: context.price && context.price.shippingCost.majorUnits.valueOf() > 0 ? formatAmount(context.price.shippingCost) : localize({
                            no: "Gratis",
                            en: "Free"
                        }),
                        text: [
                            (_s = checkoutShippingState.form) === null || _s === void 0 ? void 0 : _s.street.value,
                            `${(_t = checkoutShippingState.form) === null || _t === void 0 ? void 0 : _t.postalCode.value} ${(_u = checkoutShippingState.form) === null || _u === void 0 ? void 0 : _u.region.value}`
                        ].filter((t)=>!!t).join(", ")
                    }) : null
                ]
            })
        ]
    });
}



var $4vwom = parcelRequire("4vwom");

var $eeH7J = parcelRequire("eeH7J");

var $lhaLc = parcelRequire("lhaLc");

var $alVaN = parcelRequire("alVaN");

var $hFOwS = parcelRequire("hFOwS");




var $4vwom = parcelRequire("4vwom");

var $eeH7J = parcelRequire("eeH7J");

var $lhaLc = parcelRequire("lhaLc");

var $eSiQ2 = parcelRequire("eSiQ2");





const $5d11cd7f4673d445$var$boxStyle = (0, $lhaLc.css)({
    borderStyle: "solid",
    borderWidth: 2,
    borderRadius: 24,
    height: 24,
    width: 24,
    display: "flex"
});
function $5d11cd7f4673d445$export$f4422ae58352e179(props) {
    const { colors: colors } = (0, $756948b644e82cf2$export$559a0f07c8df6570)();
    const handleClick = (0, $eeH7J.useCallback)((e)=>{
        if (typeof props.onClick === "function") props.onClick(e);
    }, [
        props.checked
    ]);
    return (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
        as: "label",
        alignItems: "center",
        style: {
            cursor: props.disabled ? "default" : "pointer",
            position: "relative"
        },
        padding: props.padding,
        children: [
            (0, $4vwom.jsxs)((0, $bee1a5e35c892a21$export$e71c4d32a2263218), {
                onClick: handleClick,
                backgroundColor: props.disabled ? props.checked ? "gray200" : "gray100" : props.checked ? "brand" : "grayWhite",
                borderColor: props.disabled ? "gray200" : props.checked ? "brand" : "gray200",
                css: (0, $lhaLc.css)($5d11cd7f4673d445$var$boxStyle, {
                    cursor: props.disabled ? "default" : "pointer"
                }),
                children: [
                    (0, $4vwom.jsx)("input", {
                        type: "radio",
                        disabled: props.disabled,
                        style: {
                            opacity: 0,
                            position: "absolute",
                            cursor: "inherit"
                        }
                    }),
                    props.checked && (0, $4vwom.jsx)("div", {
                        css: (0, $lhaLc.css)({
                            height: "100%",
                            width: "100%",
                            borderRadius: 24,
                            border: `2px solid ${colors.grayWhite}`
                        })
                    })
                ]
            }),
            props.label && (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                variant: "body",
                size: "md",
                margin: {
                    left: 16
                },
                children: typeof props.label === "string" ? (0, $4vwom.jsx)((0, $82d66b15b8f4758d$export$d5163f1ce1e6a5f9), {
                    value: props.label,
                    renderers: {
                        paragraph: (p)=>(0, $4vwom.jsx)("div", {
                                children: p.children
                            })
                    }
                }) : props.label
            })
        ]
    });
}
(0, $eSiQ2.Component)($5d11cd7f4673d445$export$f4422ae58352e179, {
    name: "RadioButton",
    gallery: {
        path: "Controllers/RadioButton",
        items: [
            {
                title: "Enabled",
                variants: [
                    {
                        label: "Interactive",
                        props: (state = {
                            checked: false
                        }, setState)=>({
                                checked: state.checked,
                                onClick: ()=>{
                                    setState({
                                        checked: !state.checked
                                    });
                                }
                            })
                    },
                    {
                        label: "Checked",
                        props: {
                            checked: true
                        }
                    }
                ]
            },
            {
                title: "Disabled",
                variants: [
                    {
                        label: "Unchecked",
                        props: {
                            checked: false,
                            disabled: true
                        }
                    },
                    {
                        label: "Checked",
                        props: {
                            checked: true,
                            disabled: true
                        }
                    }
                ]
            }
        ]
    }
});



var $4vwom = parcelRequire("4vwom");

var $lhaLc = parcelRequire("lhaLc");

var $eeH7J = parcelRequire("eeH7J");

var $eSiQ2 = parcelRequire("eSiQ2");




const $06e3a36d2d83b339$var$boxStyle = (0, $lhaLc.css)({
    flexGrow: 0,
    flexShrink: 0,
    borderStyle: "solid",
    borderWidth: 2,
    borderRadius: 6,
    height: 24,
    width: 24,
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
});
function $06e3a36d2d83b339$export$48513f6b9f8ce62d(props) {
    const inputRef = (0, $eeH7J.useRef)(null);
    const handleChange = (0, $eeH7J.useCallback)((e)=>{
        if (typeof props.onChange === "function") props.onChange(e);
    }, [
        props
    ]);
    return (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
        as: "label",
        alignItems: "center",
        style: {
            cursor: props.disabled ? "default" : "pointer",
            position: "relative"
        },
        padding: props.padding,
        children: [
            (0, $4vwom.jsx)((0, $bee1a5e35c892a21$export$e71c4d32a2263218), {
                backgroundColor: props.disabled ? props.checked ? "gray200" : "gray100" : props.checked ? "brand" : "grayWhite",
                borderColor: props.disabled ? "gray200" : props.checked ? "brand" : "gray200",
                css: $06e3a36d2d83b339$var$boxStyle,
                children: props.checked && (0, $4vwom.jsx)($06e3a36d2d83b339$var$Checkmark, {})
            }),
            props.label && (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                variant: "body",
                size: "md",
                margin: {
                    left: 16
                },
                children: typeof props.label === "string" ? (0, $4vwom.jsx)((0, $82d66b15b8f4758d$export$d5163f1ce1e6a5f9), {
                    value: props.label,
                    renderers: {
                        paragraph: (p)=>(0, $4vwom.jsx)("div", {
                                children: p.children
                            })
                    }
                }) : props.label
            }),
            (0, $4vwom.jsx)("input", {
                type: "checkbox",
                ref: inputRef,
                onChange: handleChange,
                disabled: props.disabled,
                style: {
                    opacity: 0,
                    cursor: "inherit",
                    position: "absolute",
                    zIndex: -1
                }
            })
        ]
    });
}
(0, $eSiQ2.Component)($06e3a36d2d83b339$export$48513f6b9f8ce62d, {
    name: "Checkbox",
    gallery: {
        path: "Controllers/Checkbox",
        items: [
            {
                title: "Enabled",
                variants: [
                    {
                        label: "Interactive",
                        props: (state = {
                            checked: false
                        }, setState)=>({
                                checked: state.checked,
                                onChange: (e)=>{
                                    setState({
                                        checked: e.target.checked
                                    });
                                }
                            })
                    },
                    {
                        label: "Checked",
                        props: {
                            checked: true
                        }
                    }
                ]
            },
            {
                title: "Disabled",
                variants: [
                    {
                        label: "Unchecked",
                        props: {
                            checked: false,
                            disabled: true
                        }
                    },
                    {
                        label: "Checked",
                        props: {
                            checked: true,
                            disabled: true
                        }
                    }
                ]
            },
            {
                title: "With label",
                variants: [
                    {
                        props: (state = {
                            checked: false
                        }, setState)=>({
                                checked: state.checked,
                                label: "Jeg vil gjerne vite mer om b\xe6rekraft og Redoits tilbud. [Les vilk\xe5r](https://google.com)",
                                onChange: (e)=>{
                                    setState({
                                        checked: e.target.checked
                                    });
                                }
                            })
                    }
                ]
            }
        ]
    }
});
const $06e3a36d2d83b339$var$Checkmark = (props)=>(0, $4vwom.jsx)("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 12,
        fill: "none"
    }, props, {
        children: (0, $4vwom.jsx)("path", {
            fill: "#fff",
            d: "M5.457 8.293 2.164 5 .75 6.414l4.707 4.707 9.707-9.707L13.75 0 5.457 8.293Z",
            style: {
                fill: "#fff",
                fillOpacity: 1
            }
        })
    }));







parcelRequire("2LTO8");
var $2uVAW = parcelRequire("2uVAW");
var $4QAvl = parcelRequire("4QAvl");

var $aIeEI = parcelRequire("aIeEI");

var $4vwom = parcelRequire("4vwom");






function $e48c64b19d1de698$export$a7c3797c5ed1e851(props) {
    return (0, $4vwom.jsxs)("div", {
        children: [
            !!props.heading && (0, $4vwom.jsx)((0, $789b8639be592288$export$a8a3e93435678ff9), {
                level: 3,
                margin: {
                    bottom: (0, $1c2a8fb378443a1d$export$d98ecea1201f13ea).sm
                },
                children: props.heading
            }),
            (0, $4vwom.jsx)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                direction: "column",
                gap: 12,
                children: props.steps.map((s)=>(0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                        gap: (0, $1c2a8fb378443a1d$export$d98ecea1201f13ea).sm,
                        backgroundColor: "gray100",
                        padding: "md",
                        borderRadius: "md",
                        alignItems: "center",
                        children: [
                            (0, $4vwom.jsx)((0, $f8cdd04128a131cf$export$f04a61298a47a40f), {
                                icon: s.icon,
                                size: 32
                            }),
                            (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                variant: "body",
                                size: "md",
                                children: typeof s.text === "string" ? s.text : (0, $4vwom.jsx)((0, $82d66b15b8f4758d$export$d5163f1ce1e6a5f9), {
                                    value: s.text
                                })
                            })
                        ]
                    }, s.id))
            })
        ]
    });
}






var $4vwom = parcelRequire("4vwom");

var $eeH7J = parcelRequire("eeH7J");

var $iMJCh = parcelRequire("iMJCh");

var $lhaLc = parcelRequire("lhaLc");






// Size (or rather height) of the arrow pointing towards the trigger element. Width is 2x height.
const $cf418bf541887e36$var$ARROW_SIZE = 8;
// Distance from the trigger element to the tooltip (arrow).
const $cf418bf541887e36$var$TOOLTIP_TRIGGER_MARGIN = 4;
// Distance from the trigger element edge to the trigger arrow, for left or right aligned tooltips.
const $cf418bf541887e36$var$TRIGGER_ARROW_OFFSET = 16;
// Distance from tooltip edge to the arrow, for left or right aligned tooltips.
const $cf418bf541887e36$var$TOOLTIP_ARROW_OFFSET = 32;
// Tooltip max width.
const $cf418bf541887e36$var$TOOLTIP_MAX_WIDTH = "400px";
const $cf418bf541887e36$var$DEFAULT_PLACEMENT = "bottom-center";
const $cf418bf541887e36$var$DEFAULT_ALIGNMENT = "right";
const $cf418bf541887e36$export$28c660c63b792dea = (props)=>{
    var _a;
    const { colors: colors } = (0, $756948b644e82cf2$export$559a0f07c8df6570)();
    const preferredPlacement = (0, $eeH7J.useMemo)(()=>{
        var _a, _b;
        return {
            x: ((_a = props.placement) !== null && _a !== void 0 ? _a : $cf418bf541887e36$var$DEFAULT_PLACEMENT).split("-")[1],
            y: ((_b = props.placement) !== null && _b !== void 0 ? _b : $cf418bf541887e36$var$DEFAULT_PLACEMENT).split("-")[0]
        };
    }, [
        props.placement
    ]);
    const preferredAlignment = (_a = props.alignment) !== null && _a !== void 0 ? _a : $cf418bf541887e36$var$DEFAULT_ALIGNMENT;
    const [tooltipPlacement, setTooltipPlacement] = (0, $eeH7J.useState)();
    const [tooltipAlignment, setTooltipAlignment] = (0, $eeH7J.useState)();
    const [tooltipCoordinates, setTooltipCoordinates] = (0, $eeH7J.useState)();
    const [showTooltip, setShowTooltip] = (0, $eeH7J.useState)(false);
    const [enterAnimationComplete, setEnterAnimationComplete] = (0, $eeH7J.useState)(false);
    // This is used in case of fullwidth placement, where the constant arrow offset is not sufficient.
    const [arrowOffsetOverride, setArrowOffsetOverride] = (0, $eeH7J.useState)();
    const tooltipRef = (0, $eeH7J.useRef)(null);
    const tooltipPreRenderRef = (0, $eeH7J.useRef)(null);
    const triggerRef = (0, $eeH7J.useRef)(null);
    const mouseOverRef = (0, $eeH7J.useRef)(false);
    // Returns the relevant DOMRects used in the component if refs are set as expected.
    function getRects() {
        var _a, _b;
        const triggerRect = (_a = triggerRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
        const tooltipRect = (_b = tooltipPreRenderRef.current) === null || _b === void 0 ? void 0 : _b.getBoundingClientRect();
        if (tooltipRect && triggerRect) return {
            triggerRect: triggerRect,
            tooltipRect: tooltipRect
        };
    }
    const getTooltipElementCoordinates = (0, $eeH7J.useCallback)((placement, alignment)=>{
        const { y: y, x: x } = placement;
        const rects = getRects();
        if (rects) {
            const { triggerRect: triggerRect, tooltipRect: tooltipRect } = rects;
            const alignmentOffset = alignment === "right" ? 0 - $cf418bf541887e36$var$TOOLTIP_ARROW_OFFSET : alignment === "center" ? rects.tooltipRect.width / 2 * -1 : alignment === "left" ? rects.tooltipRect.width * -1 + $cf418bf541887e36$var$TOOLTIP_ARROW_OFFSET : alignment === "fullwidth" ? triggerRect.x * -1 - triggerRect.width / 2 + (0, $1c2a8fb378443a1d$export$3a40bd8b0ff0173c).xs.paddingLeft : 0;
            const triggerX = x === "left" ? triggerRect.left + $cf418bf541887e36$var$TRIGGER_ARROW_OFFSET : x === "right" ? triggerRect.right - $cf418bf541887e36$var$TRIGGER_ARROW_OFFSET : Math.round(triggerRect.x + triggerRect.width / 2);
            const triggerY = y === "top" ? triggerRect.top - tooltipRect.height - $cf418bf541887e36$var$ARROW_SIZE - $cf418bf541887e36$var$TOOLTIP_TRIGGER_MARGIN : triggerRect.bottom + $cf418bf541887e36$var$ARROW_SIZE + $cf418bf541887e36$var$TOOLTIP_TRIGGER_MARGIN;
            return {
                x: triggerX + alignmentOffset,
                y: triggerY
            };
        }
    }, []);
    function getTriggerXForPlacement(triggerRect, placement) {
        return placement === "center" ? triggerRect.left + triggerRect.width / 2 : triggerRect[placement];
    }
    function getAlignmentSpanX(tooltipRect, alignment) {
        return alignment === "center" ? [
            (tooltipRect.left + tooltipRect.width / 2) * -1,
            tooltipRect.left + tooltipRect.width / 2
        ] : alignment === "left" ? [
            tooltipRect.width * -1,
            0
        ] : [
            0,
            tooltipRect.width
        ];
    }
    function getTriggerYForPlacement(triggerRect, placement) {
        return placement === "top" ? triggerRect.top : triggerRect.bottom;
    }
    function getPlacementSpanY(tooltipRect, placement) {
        return placement === "top" ? [
            tooltipRect.height * -1,
            0
        ] : [
            0,
            tooltipRect.height
        ];
    }
    const checkCombinationSpaceX = (0, $eeH7J.useCallback)((rects, placement, alignment)=>{
        const x = getTriggerXForPlacement(rects.triggerRect, placement.x);
        const asx = getAlignmentSpanX(rects.tooltipRect, alignment);
        return [
            x + asx[0],
            x + asx[1]
        ];
    }, []);
    const checkCombinationSpaceY = (0, $eeH7J.useCallback)((rects, placement)=>{
        const y = getTriggerYForPlacement(rects.triggerRect, placement);
        const py = getPlacementSpanY(rects.tooltipRect, placement);
        return [
            y + py[0],
            y + py[1]
        ];
    }, []);
    function fitsInViewportX(xx) {
        return xx.filter((x)=>x > 0 && x < window.innerWidth).length === 2;
    }
    function fitsInViewportY(yy) {
        return yy.filter((y)=>y > 0 && y < window.innerHeight).length === 2;
    }
    const updatePosition = (0, $eeH7J.useCallback)(()=>{
        const rects = getRects();
        if (rects) {
            const yPlacements = [
                "top",
                "bottom"
            ];
            const yPlacement = yPlacements.sort((p1)=>p1 === preferredPlacement.y ? -1 : 1).find((p)=>fitsInViewportY(checkCombinationSpaceY(rects, p)));
            const alignments = [
                "left",
                "center",
                "right"
            ];
            const alignment = alignments// Prioritize perferred alignment and center.
            .sort((a1, a2)=>a1 === preferredAlignment ? -1 : a1 === "center" && a2 !== preferredAlignment ? -1 : 1).find((a)=>fitsInViewportX(checkCombinationSpaceX(rects, preferredPlacement, a)));
            if (alignment && yPlacement) {
                const coordinates = getTooltipElementCoordinates({
                    x: preferredPlacement.x,
                    y: yPlacement
                }, alignment);
                if (coordinates) {
                    setTooltipPlacement({
                        x: preferredPlacement.x,
                        y: yPlacement
                    });
                    setTooltipAlignment(alignment);
                    setTooltipCoordinates(coordinates);
                }
            } else if (yPlacement) {
                // If we found an yPlacement but no aligntment, we're assuming it was because the
                // tooltip was placed partially outside of the screen width for all the preferred
                // alignments. So try to get coordinates for a fullwith alignment, where we try to
                // position it around x = 0 + page left padding.
                const coordinates = getTooltipElementCoordinates({
                    x: preferredPlacement.x,
                    y: yPlacement
                }, "fullwidth");
                if (coordinates) {
                    setTooltipPlacement({
                        x: preferredPlacement.x,
                        y: yPlacement
                    });
                    setTooltipAlignment("fullwidth");
                    setTooltipCoordinates(coordinates);
                    setArrowOffsetOverride(rects.triggerRect.x + rects.triggerRect.width / 2 - coordinates.x);
                }
            } else // eslint-disable-next-line no-console
            console.warn("Could not find alignment or placement for tooltip.");
        }
    }, [
        checkCombinationSpaceX,
        checkCombinationSpaceY,
        getTooltipElementCoordinates,
        preferredAlignment,
        preferredPlacement
    ]);
    const handlePointerOver = (0, $eeH7J.useCallback)(()=>{
        mouseOverRef.current = true;
        updatePosition();
        if (!showTooltip) setShowTooltip(true);
    }, [
        showTooltip,
        updatePosition
    ]);
    const handlePointerLeave = (0, $eeH7J.useCallback)(()=>{
        mouseOverRef.current = false;
        if (enterAnimationComplete) setShowTooltip(false);
    }, [
        enterAnimationComplete
    ]);
    const handleScroll = (0, $eeH7J.useCallback)(()=>{
        if (showTooltip) updatePosition();
    }, [
        showTooltip,
        updatePosition
    ]);
    (0, $eeH7J.useEffect)(()=>{
        if (!props.children) return;
        const triggerRefCurrent = triggerRef.current;
        if (triggerRefCurrent) {
            triggerRefCurrent.addEventListener("pointerover", handlePointerOver);
            triggerRefCurrent.addEventListener("pointerleave", handlePointerLeave);
            triggerRefCurrent.addEventListener("click", handlePointerLeave);
            triggerRefCurrent.addEventListener("touchstart", handlePointerOver);
            triggerRefCurrent.addEventListener("touchend", handlePointerLeave);
            if (typeof window !== "undefined") window.addEventListener("scroll", handleScroll);
            return ()=>{
                triggerRefCurrent.removeEventListener("pointerover", handlePointerOver);
                triggerRefCurrent.removeEventListener("pointerleave", handlePointerLeave);
                triggerRefCurrent.removeEventListener("click", handlePointerLeave);
                triggerRefCurrent.removeEventListener("touchstart", handlePointerOver);
                triggerRefCurrent.removeEventListener("touchend", handlePointerLeave);
                if (typeof window !== "undefined") window.removeEventListener("scroll", handleScroll);
            };
        }
    }, [
        props.children,
        handlePointerOver,
        handlePointerLeave,
        handleScroll
    ]);
    return (0, $4vwom.jsxs)((0, $4vwom.Fragment), {
        children: [
            props.renderTrigger(triggerRef),
            showTooltip && (0, $4vwom.jsx)((0, $lhaLc.Global), {
                styles: (0, $lhaLc.css)({
                    "*, *:before, *:after": {
                        userSelect: "none",
                        MozUserSelect: "none",
                        msUserSelect: "none",
                        WebkitTouchCallout: "none",
                        WebkitUserSelect: "none"
                    }
                })
            }),
            props.children && typeof window !== "undefined" && /*#__PURE__*/ (0, $iMJCh.createPortal)((0, $4vwom.jsxs)((0, $4vwom.Fragment), {
                children: [
                    (0, $4vwom.jsx)("div", {
                        "aria-hidden": true,
                        ref: tooltipPreRenderRef,
                        css: (0, $lhaLc.css)({
                            position: "absolute",
                            top: 0,
                            left: 0,
                            opacity: 0,
                            zIndex: -1,
                            maxWidth: `min(calc(100vw - ${(0, $1c2a8fb378443a1d$export$3a40bd8b0ff0173c).xs.paddingLeft}px - ${(0, $1c2a8fb378443a1d$export$3a40bd8b0ff0173c).xs.paddingLeft}px), ${$cf418bf541887e36$var$TOOLTIP_MAX_WIDTH})`,
                            padding: "16px 24px"
                        }),
                        children: props.children
                    }),
                    (0, $4vwom.jsx)((0, $4292e3b361a44985$export$caa69d61d2de10d9), {
                        transition: (0, $7f851218870bc850$export$f4e4ad51b471de36)["200"],
                        children: (0, $4vwom.jsx)((0, $0df0f0e5b644e49a$export$3ae376d12526dd6f), {
                            children: showTooltip && tooltipCoordinates && tooltipPlacement && (0, $4vwom.jsx)((0, $bee1a5e35c892a21$export$e71c4d32a2263218), {
                                motion: {
                                    variants: {
                                        hide: {
                                            opacity: 0,
                                            translateY: tooltipPlacement.y === "top" ? 12 : -12
                                        },
                                        show: {
                                            opacity: 1,
                                            translateY: 0
                                        }
                                    },
                                    initial: "hide",
                                    animate: "show",
                                    exit: "hide",
                                    onAnimationComplete: (variant)=>{
                                        setEnterAnimationComplete(variant === "show" ? true : false);
                                        if (variant === "show" && mouseOverRef.current === false) setShowTooltip(false);
                                    }
                                },
                                elementRef: tooltipRef,
                                css: (0, $lhaLc.css)({
                                    opacity: 1,
                                    top: tooltipCoordinates.y,
                                    left: tooltipCoordinates.x
                                }, {
                                    position: "fixed",
                                    maxWidth: `min(calc(100vw - ${(0, $1c2a8fb378443a1d$export$3a40bd8b0ff0173c).xs.paddingLeft}px - ${(0, $1c2a8fb378443a1d$export$3a40bd8b0ff0173c).xs.paddingLeft}px), ${$cf418bf541887e36$var$TOOLTIP_MAX_WIDTH})`,
                                    backgroundColor: colors.grayWhite,
                                    padding: "16px 24px",
                                    borderRadius: 16,
                                    boxShadow: $e665a5c3bf2ac3f6$export$16e1fc8de5cd9687,
                                    whiteSpace: "normal",
                                    zIndex: 10000,
                                    "::after": {
                                        content: "''",
                                        position: "absolute",
                                        top: tooltipPlacement.y === "top" ? "100%" : $cf418bf541887e36$var$ARROW_SIZE * -2,
                                        left: typeof arrowOffsetOverride !== "undefined" ? arrowOffsetOverride : tooltipAlignment === "right" ? $cf418bf541887e36$var$TOOLTIP_ARROW_OFFSET : tooltipAlignment === "left" ? `calc(100% - ${$cf418bf541887e36$var$TOOLTIP_ARROW_OFFSET}px)` : "50%",
                                        transform: "translateX(-50%)",
                                        borderWidth: $cf418bf541887e36$var$ARROW_SIZE,
                                        borderStyle: "solid",
                                        borderColor: tooltipPlacement.y === "bottom" ? `transparent transparent ${colors.grayWhite} transparent` : `${colors.grayWhite} transparent transparent transparent`
                                    }
                                }),
                                children: props.children
                            }, "tooltip")
                        })
                    })
                ]
            }), document.body)
        ]
    });
};




const $fe97b132bdc7c14c$var$initialState = {
    name: {
        value: ""
    },
    email: {
        value: ""
    },
    phoneNumber: {
        value: ""
    },
    street: {
        value: ""
    },
    unit: {
        value: ""
    },
    region: {
        value: ""
    },
    postalCode: {
        value: ""
    },
    countryCode: {
        value: ""
    }
};
function $fe97b132bdc7c14c$var$formReducer(state, action) {
    if (action.type === "email") try {
        (0, $2uVAW.Email)(action.payload);
        return Object.assign(Object.assign({}, state), {
            email: {
                value: action.payload,
                valid: true,
                dirty: true
            }
        });
    } catch (e) {
        return Object.assign(Object.assign({}, state), {
            email: {
                value: action.payload,
                valid: false,
                dirty: true
            }
        });
    }
    if (action.type === "phoneNumber") try {
        (0, $4QAvl.PhoneNumber)(action.payload);
        return Object.assign(Object.assign({}, state), {
            phoneNumber: {
                value: action.payload,
                valid: true,
                dirty: true
            }
        });
    } catch (e) {
        return Object.assign(Object.assign({}, state), {
            phoneNumber: {
                value: action.payload,
                valid: false,
                dirty: true
            }
        });
    }
    if (action.type === "unit") return Object.assign(Object.assign({}, state), {
        unit: {
            value: action.payload,
            valid: true,
            dirty: true
        }
    });
    if (action.type !== "SET_ALL") return Object.assign(Object.assign({}, state), {
        [action.type]: {
            value: action.payload,
            dirty: true,
            valid: !!action.payload
        }
    });
    else return Object.assign(Object.assign({}, state), Object.keys(action.payload).reduce((acc, key)=>{
        acc[key] = {
            value: action.payload[key],
            valid: true,
            dirty: true
        };
        return acc;
    }, {}));
}
function $fe97b132bdc7c14c$export$f86ab37791746a56({ contactInfo: c, address: a, nextSteps: nextSteps, pageHeading: pageHeading, personalInformationHeading: personalInformationHeading, personalInformationFromVippsNotice: personalInformationFromVippsNotice, addressHeading: addressHeading, deliveryOptionsHeading: deliveryOptionsHeading, noDeliveryOptions: noDeliveryOptions, noDeliverySlots: noDeliverySlots, deliverySlotFull: deliverySlotFull, marketingCheckbox: marketingCheckbox, termsCheckbox: termsCheckbox, nextStep: nextStep, nextStepsHeading: nextStepsHeading }) {
    var _a, _b, _c, _d, _e, _f;
    const { helpers: helpers, colors: colors } = (0, $756948b644e82cf2$export$559a0f07c8df6570)();
    const { responsiveCss: responsiveCss } = helpers;
    const me = (0, $e18f565b44c7bc7d$export$f637e1cf42d15a62)();
    const localize = (0, $aIeEI.useLocalize)();
    const { setStep: setStep, shipping: shipping, setShipping: setShipping, price: price, checkoutState: checkoutState, setCheckoutState: setCheckoutState } = (0, $c90be680bf4410a3$export$b75716bfd8405073)();
    const [consents, setConsents] = (0, $047f6f355e30d7d1$export$5a952ffba9a79dc5)();
    (0, (/*@__PURE__*/$parcel$interopDefault($alVaN))).extend((0, (/*@__PURE__*/$parcel$interopDefault($hFOwS))));
    const [state, dispatch] = (0, $eeH7J.useReducer)($fe97b132bdc7c14c$var$formReducer, Object.assign(Object.assign({}, $fe97b132bdc7c14c$var$initialState), (_a = shipping.form) !== null && _a !== void 0 ? _a : {}));
    const validate = (0, $eeH7J.useCallback)(()=>!Object.keys(state).some((key)=>!state[key].valid || !state[key].dirty), [
        state
    ]);
    const formatAmount = (0, $b274814d74f89bd0$export$cd05f017078a61a8)();
    const contactInfo = $fe97b132bdc7c14c$var$groupAndSort(c);
    const address = $fe97b132bdc7c14c$var$groupAndSort(a);
    // Don't request shipping options unless complete zip code is provided, to avoid unnecessary
    // requests and also the UI from showing "no options" while typing (if switching form one
    // valid zip code to another).
    const shippingOptions = (0, $e18f565b44c7bc7d$export$2019485bfe6f9ed5)("NO", state.postalCode.value.length === 4 ? state.postalCode.value : null);
    (0, $eeH7J.useEffect)(()=>{
        if (typeof fbq !== "undefined") fbq("track", "InitiateCheckout", {
            content_ids: [
                price === null || price === void 0 ? void 0 : price.phoneOffer.id.valueOf()
            ],
            content_name: price === null || price === void 0 ? void 0 : price.phoneOffer.name.en,
            content_type: "product",
            value: price === null || price === void 0 ? void 0 : price.monthlyCost.discountedTotal.majorUnits,
            currency: price === null || price === void 0 ? void 0 : price.monthlyCost.discountedTotal.currency
        });
    }, // Should only trigger once, when the component mounts
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    const availableShippingOptions = (0, $eeH7J.useMemo)(()=>{
        var _a;
        return (_a = shippingOptions.data) === null || _a === void 0 ? void 0 : _a.options.filter((so)=>{
            if (so.type === "Manual") return so.slots.filter((s)=>!s.full).length > 0;
            return true;
        });
    }, [
        (_b = shippingOptions.data) === null || _b === void 0 ? void 0 : _b.options
    ]);
    // When shipping options are ready, update the options and auto-select first
    // option (that is not full).
    (0, $eeH7J.useEffect)(()=>{
        var _a, _b;
        let updatedState;
        if (!availableShippingOptions) // If data?.options is undefined, it means no options have been fetched, which should be
        // because zip code is incomplete. When that's the case, we don't want to change the
        // presented options.
        return;
        else if (!availableShippingOptions.length) // Shipping options are fetched, but came up empty, update state to show
        // "no options available".
        updatedState = Object.assign(Object.assign({}, shipping), {
            options: [],
            selectedOption: undefined
        });
        else {
            // Keep selection, or select first if none was set.
            const selectedOption = (_a = shipping.selectedOption ? availableShippingOptions.find((o)=>{
                var _a;
                return o.type === ((_a = shipping.selectedOption) === null || _a === void 0 ? void 0 : _a.type);
            }) : undefined) !== null && _a !== void 0 ? _a : availableShippingOptions[0];
            // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
            if (!selectedOption) return;
            const previouslySelectedSlot = selectedOption.type === "Manual" ? selectedOption.slots.find((s)=>{
                var _a, _b;
                return ((_a = shipping.selectedOption) === null || _a === void 0 ? void 0 : _a.type) === "Manual" && s.id === ((_b = shipping.selectedOption.selectedSlot) === null || _b === void 0 ? void 0 : _b.id);
            }) : undefined;
            updatedState = Object.assign(Object.assign({}, shipping), {
                options: availableShippingOptions,
                selectedOption: Object.assign(Object.assign({}, selectedOption), ((_b = shipping.selectedOption) === null || _b === void 0 ? void 0 : _b.type) === "Manual" ? {
                    selectedSlot: previouslySelectedSlot !== null && previouslySelectedSlot !== void 0 ? previouslySelectedSlot : selectedOption.type === "Manual" ? selectedOption.slots.find((s)=>!s.full) : undefined
                } : {})
            });
        }
        if (JSON.stringify(updatedState) !== JSON.stringify(shipping.options)) setShipping(updatedState);
    }, [
        availableShippingOptions,
        setShipping,
        shipping
    ]);
    // Ensures the CheckoutShippingState stored on the session is up to date with the form state.
    (0, $eeH7J.useEffect)(()=>{
        if (JSON.stringify(state) === JSON.stringify($fe97b132bdc7c14c$var$initialState)) return;
        const updatedShipping = Object.assign(Object.assign({}, shipping), {
            form: state
        });
        if (JSON.stringify(updatedShipping) !== JSON.stringify(shipping)) setShipping(updatedShipping);
    }, [
        setShipping,
        shipping,
        state
    ]);
    const shippingSlotId = ((_c = shipping.selectedOption) === null || _c === void 0 ? void 0 : _c.type) === "Manual" ? (_d = shipping.selectedOption.selectedSlot) === null || _d === void 0 ? void 0 : _d.id : undefined;
    const shippingIsValid = (0, $eeH7J.useMemo)(()=>{
        var _a;
        if (((_a = shipping.selectedOption) === null || _a === void 0 ? void 0 : _a.type) === "Manual") return !!shippingSlotId;
        return !!shipping.selectedOption;
    }, [
        shipping.selectedOption,
        shippingSlotId
    ]);
    (0, $eeH7J.useEffect)(()=>{
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
        if (!me.data) return;
        if (shipping.form) return;
        dispatch({
            type: "SET_ALL",
            payload: {
                name: `${me.data.givenName} ${me.data.familyName}`,
                email: (_b = (_a = me.data.email) === null || _a === void 0 ? void 0 : _a.valueOf()) !== null && _b !== void 0 ? _b : "",
                phoneNumber: me.data.phoneNumber ? me.data.phoneNumber.valueOf().startsWith("+") ? me.data.phoneNumber.valueOf() : "+" + me.data.phoneNumber.valueOf() : "",
                // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
                street: (_d = (_c = me.data.address) === null || _c === void 0 ? void 0 : _c.street) !== null && _d !== void 0 ? _d : "",
                // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
                unit: (_f = (_e = me.data.address) === null || _e === void 0 ? void 0 : _e.unit) !== null && _f !== void 0 ? _f : "",
                countryCode: (_h = (_g = me.data.address) === null || _g === void 0 ? void 0 : _g.country.valueOf()) !== null && _h !== void 0 ? _h : "",
                postalCode: (_k = (_j = me.data.address) === null || _j === void 0 ? void 0 : _j.zip) !== null && _k !== void 0 ? _k : "",
                region: (_m = (_l = me.data.address) === null || _l === void 0 ? void 0 : _l.city) !== null && _m !== void 0 ? _m : ""
            }
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        JSON.stringify(me.data)
    ]);
    const handleShippingSelect = (0, $eeH7J.useCallback)((shippingType)=>()=>{
            var _a;
            const opt = (_a = shipping.options) === null || _a === void 0 ? void 0 : _a.find((so)=>so.type === shippingType);
            if (opt) setShipping(Object.assign(Object.assign({}, shipping), {
                selectedOption: opt
            }));
        }, [
        setShipping,
        shipping
    ]);
    return (0, $4vwom.jsx)("div", {
        children: (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
            direction: "column",
            css: (0, $lhaLc.css)({
                gap: 32
            }),
            children: [
                (0, $4vwom.jsx)("span", {
                    css: (0, $lhaLc.css)(responsiveCss("max", "sm", {
                        display: "none"
                    })),
                    children: (0, $4vwom.jsx)((0, $789b8639be592288$export$a8a3e93435678ff9), {
                        level: 2,
                        children: localize(pageHeading)
                    })
                }),
                (0, $4vwom.jsxs)($fe97b132bdc7c14c$var$SectionHeading, {
                    title: localize(personalInformationHeading),
                    children: [
                        (0, $4vwom.jsx)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                            direction: "column",
                            gap: 8,
                            children: contactInfo.map((g)=>{
                                if (Array.isArray(g)) return (0, $4vwom.jsx)($fe97b132bdc7c14c$var$InputGroup, {
                                    group: g,
                                    state: state,
                                    localize: localize,
                                    dispatch: dispatch
                                }, g.join(""));
                                else return (0, $4vwom.jsx)((0, $46d788785e7b9d76$export$c86715117507e8e5), {
                                    type: g.type,
                                    label: localize(g.label),
                                    value: state[g.formKey].value,
                                    disabled: [
                                        "name",
                                        "email",
                                        "phoneNumber"
                                    ].includes(g.formKey),
                                    onChange: (e)=>dispatch({
                                            type: g.formKey,
                                            payload: e.target.value
                                        }),
                                    warning: $fe97b132bdc7c14c$var$setFormFieldState(state, g.formKey) === "error" && g.errorMessage ? localize(g.errorMessage) : undefined,
                                    state: $fe97b132bdc7c14c$var$setFormFieldState(state, g.formKey)
                                }, g.formKey);
                            })
                        }),
                        personalInformationFromVippsNotice ? (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                            variant: "body",
                            size: "md",
                            color: "gray300",
                            margin: {
                                top: 16
                            },
                            children: (0, $4vwom.jsx)((0, $82d66b15b8f4758d$export$d5163f1ce1e6a5f9), {
                                value: localize(personalInformationFromVippsNotice)
                            })
                        }) : null
                    ]
                }),
                (0, $4vwom.jsx)($fe97b132bdc7c14c$var$SectionHeading, {
                    title: localize(addressHeading),
                    children: (0, $4vwom.jsx)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                        direction: "column",
                        gap: 8,
                        children: address.map((g)=>{
                            if (Array.isArray(g)) return (0, $4vwom.jsx)($fe97b132bdc7c14c$var$InputGroup, {
                                group: g,
                                state: state,
                                localize: localize,
                                dispatch: dispatch
                            }, g.join(""));
                            else return (0, $4vwom.jsx)((0, $46d788785e7b9d76$export$c86715117507e8e5), {
                                type: g.type,
                                label: localize(g.label),
                                value: state[g.formKey].value,
                                onChange: (e)=>dispatch({
                                        type: g.formKey,
                                        payload: e.target.value
                                    }),
                                state: $fe97b132bdc7c14c$var$setFormFieldState(state, g.formKey)
                            }, g.formKey);
                        })
                    })
                }),
                (0, $4vwom.jsx)($fe97b132bdc7c14c$var$SectionHeading, {
                    title: localize(deliveryOptionsHeading),
                    children: (0, $4vwom.jsx)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                        borderRadius: "md",
                        direction: "column",
                        css: (0, $lhaLc.css)(responsiveCss("min", "md", {
                            padding: (0, $756948b644e82cf2$export$981516ee4691055c)(40),
                            background: colors.gray100,
                            border: "1px solid",
                            borderColor: colors.gray200
                        })),
                        children: ((_e = shipping.options) === null || _e === void 0 ? void 0 : _e.length) === 0 ? (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                            variant: "body",
                            size: "md",
                            children: localize(noDeliveryOptions)
                        }) : (_f = shipping.options) === null || _f === void 0 ? void 0 : _f.map((option, index)=>{
                            var _a, _b;
                            return (0, $4vwom.jsxs)((0, $eeH7J.Fragment), {
                                children: [
                                    index > 0 && (0, $4vwom.jsx)((0, $67d1e32b493d1bb5$export$2e0a83ec2e27ecbb), {
                                        horizontal: true,
                                        spacing: 24
                                    }),
                                    (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                                        direction: "column",
                                        gap: 24,
                                        css: (0, $lhaLc.css)(responsiveCss("max", "sm", {
                                            gap: 16
                                        }), responsiveCss("min", "md", {
                                            gap: 24
                                        })),
                                        children: [
                                            (0, $4vwom.jsx)((0, $5d11cd7f4673d445$export$f4422ae58352e179), {
                                                checked: ((_a = shipping.selectedOption) === null || _a === void 0 ? void 0 : _a.type) === option.type,
                                                onClick: handleShippingSelect(option.type),
                                                label: (0, $4vwom.jsxs)("div", {
                                                    children: [
                                                        (0, $4vwom.jsxs)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                                            variant: "heading",
                                                            level: [
                                                                3,
                                                                [
                                                                    "min",
                                                                    "md",
                                                                    4
                                                                ]
                                                            ],
                                                            color: ((_b = shipping.selectedOption) === null || _b === void 0 ? void 0 : _b.type) === option.type ? "brand" : undefined,
                                                            children: [
                                                                localize(option.name),
                                                                " -",
                                                                " ",
                                                                !option.price.minorUnits.valueOf() ? localize({
                                                                    no: "Gratis",
                                                                    en: "Free"
                                                                }) : formatAmount(option.price)
                                                            ]
                                                        }),
                                                        (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                                            variant: "body",
                                                            size: "sm",
                                                            color: "gray350",
                                                            children: localize(option.description)
                                                        })
                                                    ]
                                                })
                                            }),
                                            option.type === "Manual" ? (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                                                gap: 8,
                                                css: (0, $lhaLc.css)(responsiveCss("max", "sm", {
                                                    flexWrap: "nowrap",
                                                    overflowX: "auto",
                                                    width: "calc(100% + var(--padding-x) + var(--padding-x))",
                                                    transform: "translateX(calc(var(--padding-x) * -1))",
                                                    paddingLeft: "var(--padding-x)",
                                                    paddingRight: "var(--padding-x)",
                                                    minWidth: 0
                                                }), {
                                                    flexWrap: "wrap"
                                                }),
                                                children: [
                                                    option.slots.map((slot)=>(0, $4vwom.jsx)((0, $cf418bf541887e36$export$28c660c63b792dea), {
                                                            placement: "bottom-center",
                                                            renderTrigger: (ref)=>{
                                                                var _a, _b;
                                                                return (0, $4vwom.jsx)("div", {
                                                                    ref: ref,
                                                                    children: (0, $4vwom.jsxs)((0, $4b4086f8a1c6b2f8$export$353f5b6fc5456de1), {
                                                                        size: "sm",
                                                                        variant: "option",
                                                                        selected: ((_a = shipping.selectedOption) === null || _a === void 0 ? void 0 : _a.type) === "Manual" && ((_b = shipping.selectedOption.selectedSlot) === null || _b === void 0 ? void 0 : _b.id) === slot.id,
                                                                        disabled: slot.full,
                                                                        onClick: slot.full ? undefined : ()=>setShipping(Object.assign(Object.assign({}, shipping), {
                                                                                selectedOption: Object.assign(Object.assign({}, option), {
                                                                                    selectedSlot: slot
                                                                                })
                                                                            })),
                                                                        children: [
                                                                            (0, (/*@__PURE__*/$parcel$interopDefault($alVaN)))(slot.date).format("dddd Do MMMM"),
                                                                            ", ",
                                                                            slot.from,
                                                                            " - ",
                                                                            slot.to
                                                                        ]
                                                                    }, slot.id.valueOf())
                                                                });
                                                            },
                                                            children: slot.full ? (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                                                variant: "body",
                                                                size: "sm",
                                                                children: localize(deliverySlotFull)
                                                            }) : null
                                                        }, slot.id.valueOf())),
                                                    option.slots.length === 0 && (0, $4vwom.jsx)("div", {
                                                        style: {
                                                            padding: 32
                                                        },
                                                        children: localize(noDeliverySlots)
                                                    })
                                                ]
                                            }) : null
                                        ]
                                    })
                                ]
                            }, localize(option.name));
                        })
                    })
                }),
                nextSteps.length > 0 && (0, $4vwom.jsx)($fe97b132bdc7c14c$var$SectionHeading, {
                    title: localize(nextStepsHeading),
                    children: (0, $4vwom.jsx)((0, $e48c64b19d1de698$export$a7c3797c5ed1e851), {
                        steps: nextSteps.map((s)=>({
                                id: s.id.valueOf(),
                                icon: s.icon,
                                text: localize(s.text)
                            }))
                    })
                }),
                (0, $4vwom.jsxs)("div", {
                    children: [
                        !consents.marketing.preConsented && (0, $4vwom.jsxs)((0, $4vwom.Fragment), {
                            children: [
                                (0, $4vwom.jsx)((0, $06e3a36d2d83b339$export$48513f6b9f8ce62d), {
                                    checked: consents.marketing.consentGiven,
                                    onChange: ()=>{
                                        setConsents(Object.assign(Object.assign({}, consents), {
                                            marketing: {
                                                consentGiven: !consents.marketing.consentGiven,
                                                preConsented: false
                                            }
                                        }));
                                    },
                                    label: localize(marketingCheckbox)
                                }),
                                (0, $4vwom.jsx)((0, $67d1e32b493d1bb5$export$2e0a83ec2e27ecbb), {
                                    horizontal: true,
                                    spacing: 24
                                })
                            ]
                        }),
                        (0, $4vwom.jsx)((0, $06e3a36d2d83b339$export$48513f6b9f8ce62d), {
                            checked: checkoutState.termsAccepted,
                            onChange: ()=>setCheckoutState(Object.assign(Object.assign({}, checkoutState), {
                                    termsAccepted: !checkoutState.termsAccepted
                                })),
                            label: localize(termsCheckbox)
                        })
                    ]
                }),
                (0, $4vwom.jsx)((0, $4b4086f8a1c6b2f8$export$353f5b6fc5456de1), {
                    variant: "primary",
                    onClick: ()=>{
                        setStep("Payment");
                    },
                    disabled: !validate() || !shippingIsValid || !checkoutState.termsAccepted || !shipping.selectedOption,
                    children: localize(nextStep)
                })
            ]
        })
    });
}
function $fe97b132bdc7c14c$var$SectionHeading({ title: title, children: children }) {
    const { responsiveCss: responsiveCss } = (0, $756948b644e82cf2$export$559a0f07c8df6570)();
    return (0, $4vwom.jsxs)((0, $4vwom.Fragment), {
        children: [
            (0, $4vwom.jsxs)("div", {
                css: (0, $lhaLc.css)(responsiveCss("min", "md", {
                    display: "none"
                })),
                children: [
                    (0, $4vwom.jsx)((0, $789b8639be592288$export$a8a3e93435678ff9), {
                        level: 2,
                        margin: {
                            bottom: 16
                        },
                        children: title
                    }),
                    children
                ]
            }),
            (0, $4vwom.jsxs)("div", {
                css: (0, $lhaLc.css)(responsiveCss("max", "sm", {
                    display: "none"
                })),
                children: [
                    (0, $4vwom.jsx)((0, $789b8639be592288$export$a8a3e93435678ff9), {
                        level: 3,
                        margin: {
                            bottom: 16
                        },
                        children: title
                    }),
                    children
                ]
            })
        ]
    });
}
function $fe97b132bdc7c14c$var$InputGroup({ group: group, state: state, localize: localize, dispatch: dispatch }) {
    const { responsiveCss: responsiveCss } = (0, $756948b644e82cf2$export$559a0f07c8df6570)();
    return (0, $4vwom.jsx)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
        gap: 8,
        css: (0, $lhaLc.css)(responsiveCss("max", "sm", {
            flexDirection: "column"
        })),
        children: group.map((field)=>(0, $4vwom.jsx)("div", {
                style: {
                    flex: 1
                },
                children: (0, $4vwom.jsx)((0, $46d788785e7b9d76$export$c86715117507e8e5), {
                    type: field.type,
                    disabled: [
                        "name",
                        "email",
                        "phoneNumber"
                    ].includes(field.formKey),
                    label: localize(field.label),
                    value: state[field.formKey].value,
                    onChange: (e)=>dispatch({
                            type: field.formKey,
                            payload: e.target.value
                        }),
                    state: $fe97b132bdc7c14c$var$setFormFieldState(state, field.formKey),
                    warning: $fe97b132bdc7c14c$var$setFormFieldState(state, field.formKey) === "error" && field.errorMessage ? localize(field.errorMessage) : undefined
                })
            }, field.formKey))
    });
}
const $fe97b132bdc7c14c$var$setFormFieldState = (state, key)=>{
    return state[key].dirty ? !state[key].valid ? "error" : state[key].value ? "completed" : undefined : undefined;
};
function $fe97b132bdc7c14c$var$groupAndSort(data) {
    const sortedItems = Object.keys(data).map((key)=>{
        var _a, _b;
        const value = data[key];
        // TypeScript claims value is always falsy, but this is not the case.
        // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
        if (!value) return;
        return {
            formKey: key,
            label: value.label,
            group: (_a = value.group) !== null && _a !== void 0 ? _a : 0,
            order: (_b = value.order) !== null && _b !== void 0 ? _b : 0,
            type: value.type,
            errorMessage: value.errorMessage
        };
    }).filter(Boolean).sort((a, b)=>a.order - b.order);
    return sortedItems.reduce((acc, item)=>{
        var _a;
        if (!item.group) acc.push(item);
        else {
            const groupIndex = acc.findIndex((group)=>{
                var _a;
                return Array.isArray(group) && ((_a = group[0]) === null || _a === void 0 ? void 0 : _a.group) === item.group;
            });
            if (groupIndex === -1) acc.push([
                item
            ]);
            else if (Array.isArray(acc[groupIndex])) (_a = acc[groupIndex]) === null || _a === void 0 || _a.push(item);
        }
        return acc;
    }, []);
}



var $4vwom = parcelRequire("4vwom");

var $eeH7J = parcelRequire("eeH7J");

var $lhaLc = parcelRequire("lhaLc");

var $aIeEI = parcelRequire("aIeEI");










var $dAwef = parcelRequire("dAwef");
parcelRequire("2LTO8");
var $8h5s0 = parcelRequire("8h5s0");

var $4vwom = parcelRequire("4vwom");

var $eeH7J = parcelRequire("eeH7J");

var $lhaLc = parcelRequire("lhaLc");

var $eSiQ2 = parcelRequire("eSiQ2");





const $50112aaf62b7ce57$var$borderColors = {
    default: "gray200",
    active: "gray500",
    error: "error",
    completed: "forest"
};
function $50112aaf62b7ce57$export$ef9b1a59e592288f(props) {
    var _a, _b, _c;
    const { colors: colors, helpers: helpers } = (0, $756948b644e82cf2$export$559a0f07c8df6570)();
    const { responsiveBodyCss: responsiveBodyCss, responsiveCss: responsiveCss, responsiveHeadingCss: responsiveHeadingCss } = helpers;
    const selectRef = (0, $eeH7J.useRef)(null);
    const [isActive, setIsActive] = (0, $eeH7J.useState)(false);
    const state = (0, $eeH7J.useMemo)(()=>{
        if (props.state) return props.state;
        if (isActive) return "active";
        return "default";
    }, [
        props.state,
        isActive
    ]);
    const handleChange = (0, $eeH7J.useCallback)((e)=>{
        var _a;
        (_a = props.onChange) === null || _a === void 0 || _a.call(props, e, e.target.value);
    }, [
        props
    ]);
    const handleFocus = (0, $eeH7J.useCallback)(()=>{
        setIsActive(true);
    }, [
        setIsActive
    ]);
    const handleBlur = (0, $eeH7J.useCallback)(()=>{
        setIsActive(false);
    }, [
        setIsActive
    ]);
    const renderPlaceholder = (0, $eeH7J.useMemo)(()=>{
        return props.placeholder && !props.value;
    }, [
        props.placeholder,
        props.value
    ]);
    const valueTextCss = (0, $eeH7J.useMemo)(()=>{
        var _a;
        return (0, $lhaLc.css)(responsiveHeadingCss(5), responsiveCss("min", "md", (_a = responsiveBodyCss("md")) !== null && _a !== void 0 ? _a : {}));
    }, [
        responsiveBodyCss,
        responsiveCss,
        responsiveHeadingCss
    ]);
    return (0, $4vwom.jsxs)("div", {
        children: [
            props.label ? (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                variant: "body",
                size: "md",
                style: {
                    marginBottom: 16 * (0, $1c2a8fb378443a1d$export$adc5746a202ff4b)
                },
                children: props.label
            }) : null,
            (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                borderColor: $50112aaf62b7ce57$var$borderColors[state],
                borderWidth: 2,
                borderRadius: "sm",
                css: $50112aaf62b7ce57$var$selectCss,
                alignItems: "center",
                justifyContent: "space-between",
                children: [
                    (0, $4vwom.jsx)("div", {
                        css: valueTextCss,
                        style: renderPlaceholder ? {
                            color: colors.gray300
                        } : {},
                        children: renderPlaceholder ? props.placeholder : (_b = (_a = props.renderValue) === null || _a === void 0 ? void 0 : _a.call(props, props.value)) !== null && _b !== void 0 ? _b : (_c = props.options.find((opt)=>$50112aaf62b7ce57$var$valueToString(opt.value) === $50112aaf62b7ce57$var$valueToString(props.value))) === null || _c === void 0 ? void 0 : _c.text
                    }),
                    (0, $4vwom.jsxs)("select", {
                        tabIndex: 0,
                        css: $50112aaf62b7ce57$var$dropdownCss,
                        ref: selectRef,
                        value: renderPlaceholder ? props.placeholder : $50112aaf62b7ce57$var$valueToString(props.value),
                        onChange: handleChange,
                        onFocus: handleFocus,
                        onBlur: handleBlur,
                        children: [
                            props.placeholder ? (0, $4vwom.jsx)("option", {
                                disabled: true,
                                value: props.placeholder,
                                children: props.placeholder
                            }) : null,
                            props.options.map((o)=>{
                                var _a;
                                return (0, $4vwom.jsx)("option", {
                                    value: $50112aaf62b7ce57$var$valueToString(o.value),
                                    disabled: (_a = o.disabled) !== null && _a !== void 0 ? _a : false,
                                    children: o.text
                                }, $50112aaf62b7ce57$var$valueToString(o.value));
                            })
                        ]
                    }),
                    (0, $4vwom.jsx)((0, $f8cdd04128a131cf$export$f04a61298a47a40f), {
                        icon: "chevronDown"
                    })
                ]
            })
        ]
    });
}
const $50112aaf62b7ce57$var$selectCss = (0, $lhaLc.css)`
    position: relative;
    height: ${48 * (0, $1c2a8fb378443a1d$export$adc5746a202ff4b)}px;
    padding: ${12 * (0, $1c2a8fb378443a1d$export$adc5746a202ff4b)}px ${20 * (0, $1c2a8fb378443a1d$export$adc5746a202ff4b)}px;
`;
const $50112aaf62b7ce57$var$dropdownCss = (0, $lhaLc.css)({
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    minWidth: 0,
    appearance: "none",
    opacity: 0,
    cursor: "pointer"
});
(0, $eSiQ2.Component)($50112aaf62b7ce57$export$ef9b1a59e592288f, {
    name: "Select",
    gallery: {
        path: "Inputs/Select",
        items: [
            {
                variants: [
                    {
                        props: {
                            value: "foo",
                            options: [
                                {
                                    value: "foo",
                                    text: "Foo"
                                },
                                {
                                    value: "bar",
                                    text: "Bar"
                                }
                            ]
                        }
                    }
                ]
            },
            {
                variants: [
                    {
                        props: {
                            value: "",
                            placeholder: "Select an option",
                            options: [
                                {
                                    value: "foo",
                                    text: "Foo"
                                },
                                {
                                    value: "bar",
                                    text: "Bar"
                                }
                            ]
                        }
                    }
                ]
            }
        ]
    }
});
function $50112aaf62b7ce57$var$valueToString(o) {
    return typeof o === "string" ? o : JSON.stringify(o);
}







var $4vwom = parcelRequire("4vwom");

var $eSiQ2 = parcelRequire("eSiQ2");






var $lhaLc = parcelRequire("lhaLc");
function $aab0dbc639a1af01$export$42100d7f568e8c11(props) {
    return (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
        direction: "column",
        children: [
            (0, $4vwom.jsxs)((0, $bee1a5e35c892a21$export$e71c4d32a2263218), {
                margin: {
                    bottom: (0, $756948b644e82cf2$export$981516ee4691055c)(16)
                },
                children: [
                    (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                        variant: "body",
                        size: "md",
                        children: props.question
                    }),
                    props.description ? (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                        variant: "body",
                        size: "sm",
                        color: "gray300",
                        children: props.description
                    }) : null
                ]
            }),
            (0, $4vwom.jsx)("fieldset", {
                children: (0, $4vwom.jsx)("div", {
                    role: "radiocontainer",
                    style: {
                        display: "grid",
                        gap: 8
                    },
                    css: (0, $lhaLc.css)({
                        gridTemplateColumns: "1fr"
                    }, // If options has texts longer than arbitrary character count 16, leave
                    // them in stacked layout to avoid component becoming too wide. Else,
                    // add grid layout for larger screens.
                    !props.options.find((o)=>o.text.length > 16) && (0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("min", "sm", {
                        gridTemplateColumns: props.options.length % 3 === 0 ? "1fr 1fr 1fr" : "1fr 1fr"
                    })),
                    children: props.options.map((o)=>(0, $4vwom.jsx)("div", {
                            style: {
                                position: "relative"
                            },
                            children: (0, $4vwom.jsxs)("label", {
                                style: {
                                    position: "relative",
                                    width: "100%"
                                },
                                children: [
                                    (0, $4vwom.jsx)((0, $4b4086f8a1c6b2f8$export$353f5b6fc5456de1), {
                                        as: "div",
                                        size: "sm",
                                        variant: "select",
                                        selected: props.value === o.value,
                                        fullwidth: true,
                                        children: o.text
                                    }, o.text),
                                    (0, $4vwom.jsx)("input", {
                                        type: "radio",
                                        name: props.question,
                                        checked: props.value === o.value,
                                        style: {
                                            position: "absolute",
                                            top: 0,
                                            left: 0,
                                            height: "100%",
                                            width: "100%",
                                            opacity: "0",
                                            zIndex: -1
                                        },
                                        onChange: (e)=>{
                                            props.onChange(e, o.value);
                                        }
                                    })
                                ]
                            })
                        }, JSON.stringify(o.value)))
                })
            })
        ]
    });
}
(0, $eSiQ2.Component)($aab0dbc639a1af01$export$42100d7f568e8c11, {
    name: "MultipleChoiceQuestion",
    gallery: {
        path: "Forms/MultipleChoiceQuestion",
        items: [
            {
                variants: [
                    {
                        props: (state = "foo", setState)=>({
                                label: "Which one?",
                                options: [
                                    {
                                        value: "foo",
                                        text: "Foo"
                                    },
                                    {
                                        value: "bar",
                                        text: "Bar"
                                    },
                                    {
                                        value: "baz",
                                        text: "Baz"
                                    }
                                ],
                                value: state,
                                onChange: (e, val)=>{
                                    setState(val);
                                }
                            })
                    }
                ]
            }
        ]
    }
});



var $4vwom = parcelRequire("4vwom");

var $eSiQ2 = parcelRequire("eSiQ2");
parcelRequire("2LTO8");
var $2zTLn = parcelRequire("2zTLn");



function $9ef1a37a4c2e6964$export$161a6b098fcc9bc6(props) {
    return (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
        borderColor: "gray200",
        borderRadius: "md",
        padding: "md",
        direction: "column",
        gap: 8,
        children: [
            (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                justifyContent: "space-between",
                alignItems: "flex-start",
                children: [
                    (0, $4vwom.jsxs)("div", {
                        children: [
                            (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                variant: "heading",
                                level: 4,
                                children: props.itemName
                            }),
                            (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                                alignItems: "baseline",
                                gap: 2,
                                children: [
                                    props.originalPrice === props.discountedPrice ? null : (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                        variant: "body",
                                        size: "md",
                                        color: "gray300",
                                        style: {
                                            textDecoration: "underline",
                                            textUnderlineOffset: "-5px",
                                            textDecorationSkipInk: "none"
                                        },
                                        children: props.originalPrice
                                    }),
                                    (0, $4vwom.jsxs)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                        variant: "heading",
                                        level: 3,
                                        color: "brand",
                                        children: [
                                            props.discountedPrice,
                                            " ",
                                            props.currency,
                                            "/",
                                            props.rentalPeriodUnit
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    (0, $4vwom.jsx)((0, $1c19a55e13f5780a$export$48c441fbee531268), {
                        color: "gray500",
                        size: [
                            "fixed",
                            "xs",
                            "md"
                        ],
                        children: props.label
                    })
                ]
            }),
            (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                variant: "body",
                size: "sm",
                color: "gray300",
                children: props.text
            })
        ]
    });
}
(0, $eSiQ2.Component)($9ef1a37a4c2e6964$export$161a6b098fcc9bc6, {
    name: "PaymentSummary",
    gallery: {
        path: "Forms/PaymentSummary",
        items: [
            {
                variants: [
                    {
                        props: {
                            itemName: "iPhone 15 Pro",
                            label: "Etter innbytte",
                            text: "V\xe5r estimerte telefonverdi er 3 000 NOK. Dette betyr at du vil f\xe5 50 NOK i avslag per m\xe5ned p\xe5 avtalen din de neste 24 m\xe5nedene etter at du har byttet inn enheten din.",
                            originalPrice: 300,
                            discountedPrice: 250,
                            rentalPeriodUnit: "md",
                            currency: (0, $2zTLn.CurrencyCode)("NOK")
                        }
                    }
                ]
            }
        ]
    }
});






parcelRequire("jniej");
var $eK8Q4 = parcelRequire("eK8Q4");




function $0eca38a3f9eebfa7$export$a8febc64537a0214(props) {
    var _a;
    const { helpers: helpers } = (0, $756948b644e82cf2$export$559a0f07c8df6570)();
    const { responsiveCss: responsiveCss } = helpers;
    const localize = (0, $aIeEI.useLocalize)();
    const { setStep: setStep } = (0, $c90be680bf4410a3$export$b75716bfd8405073)();
    const [modalOpen, setModalOpen] = (0, $eK8Q4.useSessionState)("tradein-modal-open", false);
    const [form] = (0, $047f6f355e30d7d1$export$d42da32bb85d5739)();
    const [tradeInId, setTradeInId] = (0, $eK8Q4.useSessionState)("tradein-modal-id", undefined);
    function startTradeIn() {
        setTradeInId((0, $dAwef.Uuid)().valueOf());
        setModalOpen(true);
    }
    const [responses] = (0, $eK8Q4.useSessionState)("tradein-responses", []);
    const [, setCheckoutTradeInPriceRequest] = (0, $047f6f355e30d7d1$export$b7eadabbf1e81c9b)();
    const context = (0, $c90be680bf4410a3$export$b75716bfd8405073)();
    const handleNextClick = (0, $eeH7J.useCallback)(()=>{
        context.setStep("Insurance");
    }, [
        context
    ]);
    const [, setResult] = (0, $047f6f355e30d7d1$export$db65bad7d1fa5d6f)();
    return !!responses.length && responses.filter((r)=>!!r).length === responses.length && form && ((_a = context.price) === null || _a === void 0 ? void 0 : _a.monthlyCost.tradeInDiscount) ? (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
        direction: "column",
        gap: 32,
        children: [
            (0, $4vwom.jsx)((0, $789b8639be592288$export$a8a3e93435678ff9), {
                level: 2,
                children: "Innbytte"
            }),
            (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                direction: "column",
                gap: 16,
                children: [
                    (0, $4vwom.jsx)((0, $789b8639be592288$export$a8a3e93435678ff9), {
                        level: 3,
                        children: localize(props.modal.summary.answersSummaryHeading)
                    }),
                    (0, $4vwom.jsx)((0, $bee1a5e35c892a21$export$e71c4d32a2263218), {
                        borderColor: "gray200",
                        borderRadius: "md",
                        padding: "md",
                        children: form.questions.map((q, qi)=>{
                            var _a, _b;
                            return (0, $4vwom.jsxs)((0, $eeH7J.Fragment), {
                                children: [
                                    qi > 0 ? (0, $4vwom.jsx)((0, $67d1e32b493d1bb5$export$2e0a83ec2e27ecbb), {
                                        horizontal: true,
                                        spacing: "md"
                                    }) : null,
                                    (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                        variant: "body",
                                        size: "sm",
                                        children: localize(q.question)
                                    }),
                                    (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                        variant: "heading",
                                        level: 4,
                                        children: localize((_b = (_a = q.responses.find((r)=>r.id === responses[qi])) === null || _a === void 0 ? void 0 : _a.response) !== null && _b !== void 0 ? _b : {})
                                    })
                                ]
                            }, q.id.valueOf());
                        })
                    })
                ]
            }),
            (0, $4vwom.jsx)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                gap: 8,
                children: (0, $4vwom.jsx)((0, $4b4086f8a1c6b2f8$export$353f5b6fc5456de1), {
                    onClick: handleNextClick,
                    children: localize(props.stepWithTradeInCompleted.nextStepButtonText)
                })
            })
        ]
    }) : (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
        direction: "column",
        justifyContent: "center",
        gap: (0, $756948b644e82cf2$export$981516ee4691055c)(32),
        css: (0, $lhaLc.css)({
            height: "100%"
        }),
        children: [
            (0, $4vwom.jsx)((0, $789b8639be592288$export$a8a3e93435678ff9), {
                level: 2,
                children: localize(props.headline)
            }),
            (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                direction: "column",
                gap: 20,
                children: [
                    (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                        variant: "body",
                        size: "xl",
                        children: localize(props.leadText)
                    }),
                    (0, $4vwom.jsx)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                        direction: "column",
                        gap: [
                            4,
                            [
                                "min",
                                "md",
                                8
                            ]
                        ],
                        children: props.steps.map((item, i)=>(0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                                gap: 8,
                                alignItems: "center",
                                children: [
                                    (0, $4vwom.jsx)((0, $f8cdd04128a131cf$export$f04a61298a47a40f), {
                                        icon: "check",
                                        color: "forest"
                                    }),
                                    (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                        variant: "body",
                                        color: "gray300",
                                        size: "md",
                                        children: localize(item.text)
                                    })
                                ]
                            }, item.id.valueOf()))
                    })
                ]
            }),
            (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                gap: 8,
                css: (0, $lhaLc.css)({
                    flexWrap: "wrap-reverse",
                    justifyContent: "stretch"
                }, responsiveCss("max", "sm", {
                    flexDirection: "column-reverse"
                })),
                children: [
                    (0, $4vwom.jsx)((0, $4b4086f8a1c6b2f8$export$353f5b6fc5456de1), {
                        variant: "secondary",
                        onClick: ()=>{
                            setStep("Insurance");
                        },
                        children: localize(props.notThisTimeButton)
                    }),
                    (0, $4vwom.jsx)((0, $4b4086f8a1c6b2f8$export$353f5b6fc5456de1), {
                        variant: "primary",
                        onClick: startTradeIn,
                        children: localize(props.primaryCta)
                    })
                ]
            }),
            !!form && !!tradeInId && (0, $4vwom.jsx)($0eca38a3f9eebfa7$export$9e5a8dc8aab6dd64, Object.assign({
                id: tradeInId,
                form: form,
                open: modalOpen,
                onClose: ()=>{
                    setModalOpen(false);
                },
                onCloseAnimationEnd: ()=>{
                    context.setStep("Insurance");
                },
                productName: localize(context.offer.name),
                months: context.offer.rentalPeriod,
                originalPrice: context.offer.monthlyPrice,
                onTradeInConfirm: (form2, responses2, result2)=>{
                    setResult(result2);
                    setCheckoutTradeInPriceRequest({
                        form: form2.id,
                        responses: responses2.map((r)=>(0, $8h5s0.Assert)(r)),
                        version: form.version
                    });
                }
            }, props.modal))
        ]
    });
}
function $0eca38a3f9eebfa7$export$9e5a8dc8aab6dd64(props) {
    const { form: form } = props;
    const localize = (0, $aIeEI.useLocalize)();
    const { helpers: helpers } = (0, $756948b644e82cf2$export$559a0f07c8df6570)();
    const { responsiveCss: responsiveCss, responsiveBorderRadius: responsiveBorderRadius } = helpers;
    const [responses, setResponses] = (0, $eK8Q4.useSessionState)(`tradein-${props.id}-responses`, []);
    const [result, setResult] = (0, $eK8Q4.useSessionState)(`tradein-${props.id}-result`, undefined);
    const answerImage = (0, $eeH7J.useMemo)(()=>{
        const rr = [
            ...responses
        ].reverse();
        const qr = [
            ...form.questions
        ].reverse();
        return qr.reduce((acc, curr, index)=>{
            // Question hasn't been answered yet, don't check for image.
            if (!rr[index]) return undefined;
            // We started from the last question, so if already set, keep it.
            if (acc) return acc;
            // Return if selected response for question has an image
            return curr.responses.find((r)=>r.id === rr[index] && r.image);
        }, undefined);
    }, [
        responses,
        form
    ]);
    const localizeCurrency = (0, $b274814d74f89bd0$export$2daf9f30efa60400)();
    const PaymentSummaryRendered = (0, $eeH7J.useMemo)(()=>result ? (0, $4vwom.jsx)((0, $9ef1a37a4c2e6964$export$161a6b098fcc9bc6), {
            itemName: props.productName,
            text: (0, $87d2193cf0695c20$export$4493d2932fe76cf8)(localize(props.summary.priceSummaryText), {
                currency: localizeCurrency(result.value.currency),
                itemValue: result.value.majorUnits.toString(),
                discountAmount: result.monthlyDiscount.majorUnits.toString(),
                discountMonths: result.months.toString(),
                monthsShort: localize((0, $b274814d74f89bd0$export$b4b23bfab2f68498)),
                monthsLong: localize((0, $b274814d74f89bd0$export$2bb3eb27682a776))
            }),
            originalPrice: props.originalPrice.itemsTotal.majorUnits,
            discountedPrice: // Can't use discountedTotal yet, as the trade-in is not added to the order.
            props.originalPrice.itemsTotal.majorUnits - result.monthlyDiscount.majorUnits,
            rentalPeriodUnit: localize((0, $b274814d74f89bd0$export$b4b23bfab2f68498)),
            currency: localizeCurrency(result.value.currency),
            label: localize(props.summary.priceSummaryLabel)
        }) : null, [
        result,
        props.productName,
        props.summary.priceSummaryText,
        props.summary.priceSummaryLabel,
        props.originalPrice.itemsTotal.majorUnits,
        localize,
        localizeCurrency
    ]);
    (0, $eeH7J.useEffect)(()=>{
        if (responses.length !== form.questions.length) setResponses(form.questions.map(()=>undefined));
    }, [
        form.questions,
        responses.length,
        setResponses
    ]);
    const [currentStep, setCurrentStep] = (0, $eK8Q4.useSessionState)(`tradein-${props.id}-modal-step`, undefined);
    return (0, $4vwom.jsx)((0, $37d4981a6b4c97c0$export$2b77a92f1a5ad772), {
        isOpen: props.open,
        onClose: ()=>{
            setResponses([]);
            setCurrentStep(undefined);
            props.onClose();
        },
        width: "100%",
        onCloseAnimationEnd: props.onCloseAnimationEnd,
        header: {
            closeButton: true
        },
        closePrompt: props.closePrompt ? {
            heading: localize(props.closePrompt.heading),
            text: localize(props.closePrompt.text),
            cancelButtonText: localize(props.closePrompt.cancelButtonText),
            confirmButtonText: localize(props.closePrompt.confirmButtonText)
        } : undefined,
        step: currentStep,
        onStepChange: (val)=>setCurrentStep(val),
        steps: [
            {
                header: {
                    title: localize(props.questions.heading)
                },
                render: (next, prev)=>(0, $4vwom.jsx)($0eca38a3f9eebfa7$var$QuestionsStep, Object.assign({}, props, {
                        form: form,
                        responsesState: [
                            responses,
                            setResponses
                        ],
                        onSubmitAnswers: async ()=>{
                            try {
                                const response = await (0, $e18f565b44c7bc7d$export$8f2b94717249315f)("Phones", {
                                    months: props.months,
                                    responses: responses.map((r)=>(0, $8h5s0.Assert)(r))
                                });
                                setResult(response);
                                next();
                            } catch (e) {
                                if ("detail" in e) alert(e.detail);
                                else alert("An error occurred");
                            }
                        }
                    }))
            },
            {
                header: {
                    backButton: true,
                    title: localize(props.summary.heading)
                },
                render: (next, prev)=>(0, $4vwom.jsx)($0eca38a3f9eebfa7$var$SummaryStep, Object.assign({}, props, {
                        form: form,
                        responsesState: [
                            responses,
                            setResponses
                        ],
                        PaymentSummaryRendered: PaymentSummaryRendered,
                        onNextClick: next
                    }))
            },
            {
                header: {
                    backButton: true
                },
                render: (next, prev)=>(0, $4vwom.jsx)($0eca38a3f9eebfa7$var$ConfirmationStep, Object.assign({}, props, {
                        form: form,
                        PaymentSummaryRendered: PaymentSummaryRendered,
                        onTradeInConfirm: ()=>{
                            const rs = responses.filter((r)=>!!r);
                            if (!result || rs.length < responses.length) {
                                // NOTE: At this point, no responses should be undefined,
                                // hence the basic error handling.
                                alert("Could not complete trade-in, as not all questions have been answered.");
                                return;
                            }
                            props.onTradeInConfirm(form, rs, result);
                            props.onClose();
                        }
                    }))
            }
        ],
        renderSteps: (step)=>(0, $4vwom.jsx)((0, $4292e3b361a44985$export$caa69d61d2de10d9), {
                transition: (0, $7f851218870bc850$export$f4e4ad51b471de36)["200"],
                children: (0, $4vwom.jsxs)("div", {
                    style: {
                        display: "flex",
                        gap: 20,
                        width: "100%"
                    },
                    children: [
                        (0, $4vwom.jsx)("div", {
                            css: (0, $lhaLc.css)({
                                display: "flex",
                                flex: "5 0 0",
                                position: "relative"
                            }),
                            children: step
                        }),
                        form.image ? (0, $4vwom.jsx)("div", {
                            css: (0, $lhaLc.css)({
                                flex: "2 0 0"
                            }, responsiveCss("max", "sm", {
                                display: "none"
                            }), responsiveCss("min", "md", {
                                flexGrow: 3
                            }), responsiveCss("min", "lg", {
                                flexGrow: 4
                            })),
                            children: (0, $4vwom.jsx)("div", {
                                style: {
                                    position: "sticky",
                                    top: 0,
                                    right: 0
                                },
                                children: (0, $4vwom.jsxs)("div", {
                                    style: {
                                        position: "relative",
                                        overflow: "hidden",
                                        aspectRatio: "1/1"
                                    },
                                    css: responsiveBorderRadius("md"),
                                    children: [
                                        (answerImage === null || answerImage === void 0 ? void 0 : answerImage.image) && (0, $4vwom.jsx)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                                            motion: {
                                                initial: {
                                                    opacity: 0
                                                },
                                                animate: {
                                                    opacity: 1
                                                }
                                            },
                                            alignItems: "center",
                                            justifyContent: "center",
                                            backgroundColor: "gray100",
                                            style: {
                                                position: "absolute",
                                                height: "100%",
                                                width: "100%"
                                            },
                                            children: (0, $4vwom.jsx)((0, $6a1a23ca93758ec8$export$686e15a6b88a698c), {
                                                width: 400,
                                                image: answerImage.image,
                                                style: {
                                                    width: "50%"
                                                }
                                            })
                                        }),
                                        (0, $4vwom.jsx)((0, $ad7a054f4530c130$export$e25e478948902b8b).div, {
                                            animate: (answerImage === null || answerImage === void 0 ? void 0 : answerImage.image) ? {
                                                opacity: 0
                                            } : {},
                                            children: (0, $4vwom.jsx)((0, $6a1a23ca93758ec8$export$686e15a6b88a698c), {
                                                width: 400,
                                                image: form.image,
                                                style: {
                                                    objectFit: "cover",
                                                    width: "100%",
                                                    aspectRatio: "1/1"
                                                }
                                            })
                                        })
                                    ]
                                })
                            })
                        }) : null
                    ]
                })
            })
    });
}
function $0eca38a3f9eebfa7$var$QuestionsStep(props) {
    const localize = (0, $aIeEI.useLocalize)();
    const questionRefs = (0, $eeH7J.useRef)([]);
    const [responses, setResponses] = props.responsesState;
    questionRefs.current = props.form.questions.map((_, i)=>{
        var _a;
        return (_a = questionRefs.current[i]) !== null && _a !== void 0 ? _a : /*#__PURE__*/ (0, $eeH7J.createRef)();
    });
    const modalContext = (0, $eeH7J.useContext)((0, $37d4981a6b4c97c0$export$ab57792b9b6974a6));
    return (0, $4vwom.jsxs)((0, $4vwom.Fragment), {
        children: [
            props.form.questions.map((q, qi)=>{
                var _a, _b;
                return (0, $4vwom.jsx)((0, $ad7a054f4530c130$export$e25e478948902b8b).div, {
                    style: {
                        overflow: "hidden"
                    },
                    initial: qi > 0 && responses.filter((r)=>r).length < qi ? {
                        height: 0,
                        opacity: 0,
                        translateY: -20
                    } : {
                        height: "auto"
                    },
                    animate: qi > 0 && responses.filter((r)=>r).length >= qi ? {
                        height: (_b = (_a = questionRefs.current[qi]) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.getBoundingClientRect().height,
                        opacity: 1,
                        translateY: 0
                    } : qi > 0 ? {
                        height: 0,
                        opacity: 0,
                        translateY: -20
                    } : {},
                    onAnimationComplete: ()=>{
                        var _a;
                        const scrollContainer = (_a = modalContext.scrollContainerRef) === null || _a === void 0 ? void 0 : _a.current;
                        if (scrollContainer) scrollContainer.scroll({
                            top: scrollContainer.scrollHeight,
                            behavior: "smooth"
                        });
                    },
                    children: (0, $4vwom.jsxs)("div", {
                        ref: questionRefs.current[qi],
                        children: [
                            q.type === "buttons" ? (0, $4vwom.jsx)((0, $aab0dbc639a1af01$export$42100d7f568e8c11), {
                                question: localize(q.question),
                                description: q.description ? localize(q.description) : undefined,
                                options: q.responses.map((r)=>({
                                        value: r.id,
                                        text: localize(r.response)
                                    })),
                                value: responses[qi],
                                onChange: (e, val)=>{
                                    setResponses(responses.map((r, i)=>i === qi ? val : r));
                                }
                            }) : q.type === "dropdown" ? (0, $4vwom.jsxs)("div", {
                                children: [
                                    (0, $4vwom.jsxs)((0, $bee1a5e35c892a21$export$e71c4d32a2263218), {
                                        margin: {
                                            bottom: (0, $756948b644e82cf2$export$981516ee4691055c)(16)
                                        },
                                        children: [
                                            (0, $4vwom.jsx)((0, $72c5ae9e0017e167$export$4b2c32e08f77ff18), {
                                                size: "md",
                                                margin: {
                                                    bottom: 16
                                                },
                                                children: localize(q.question)
                                            }),
                                            q.description ? (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                                variant: "body",
                                                size: "sm",
                                                color: "gray300",
                                                children: localize(q.description)
                                            }) : null
                                        ]
                                    }),
                                    (0, $4vwom.jsx)((0, $50112aaf62b7ce57$export$ef9b1a59e592288f), {
                                        value: responses[qi],
                                        placeholder: localize({
                                            en: "Please select",
                                            no: "Vennligst velg"
                                        }),
                                        onChange: (e, val)=>{
                                            if (qi === 0) setResponses(responses.map((r, ri)=>ri === 0 ? val : undefined));
                                            else setResponses(responses.map((r, i)=>i === qi ? val : r));
                                        },
                                        options: [
                                            ...q.responses.map((r)=>({
                                                    value: r.id,
                                                    text: localize(r.response)
                                                }))
                                        ],
                                        renderValue: (val)=>{
                                            var _a, _b;
                                            return localize((_b = (_a = q.responses.find((x)=>x.id === val)) === null || _a === void 0 ? void 0 : _a.response) !== null && _b !== void 0 ? _b : {});
                                        }
                                    })
                                ]
                            }) : (0, $4vwom.jsxs)("div", {
                                children: [
                                    "Unsupported question type: ",
                                    q.type
                                ]
                            }),
                            (0, $4vwom.jsx)((0, $67d1e32b493d1bb5$export$2e0a83ec2e27ecbb), {
                                horizontal: true,
                                spacing: 32
                            })
                        ]
                    })
                }, q.id.valueOf());
            }),
            (0, $4vwom.jsx)((0, $4b4086f8a1c6b2f8$export$353f5b6fc5456de1), {
                variant: "primary",
                onClick: ()=>{
                    try {
                        props.onSubmitAnswers();
                    } catch (err) {}
                },
                iconEnd: "arrowRight",
                disabled: responses.some((r)=>!r),
                fullwidth: true,
                children: localize({
                    en: "Continue",
                    no: "Fortsett"
                })
            })
        ]
    });
}
function $0eca38a3f9eebfa7$var$SummaryStep(props) {
    const localize = (0, $aIeEI.useLocalize)();
    const [responses] = props.responsesState;
    return (0, $4vwom.jsx)((0, $4vwom.Fragment), {
        children: (0, $4vwom.jsx)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
            gap: 40,
            children: (0, $4vwom.jsxs)("div", {
                css: (0, $lhaLc.css)({
                    flex: "5 0 0"
                }),
                children: [
                    props.PaymentSummaryRendered,
                    (0, $4vwom.jsx)((0, $789b8639be592288$export$a8a3e93435678ff9), {
                        level: 3,
                        margin: {
                            top: (0, $1c2a8fb378443a1d$export$d98ecea1201f13ea).lg,
                            bottom: (0, $1c2a8fb378443a1d$export$d98ecea1201f13ea).sm
                        },
                        children: localize(props.summary.answersSummaryHeading)
                    }),
                    (0, $4vwom.jsx)((0, $bee1a5e35c892a21$export$e71c4d32a2263218), {
                        borderColor: "gray200",
                        borderRadius: "md",
                        padding: "md",
                        margin: {
                            bottom: (0, $1c2a8fb378443a1d$export$d98ecea1201f13ea).lg
                        },
                        children: props.form.questions.map((q, qi)=>{
                            var _a, _b;
                            return (0, $4vwom.jsxs)((0, $eeH7J.Fragment), {
                                children: [
                                    qi > 0 ? (0, $4vwom.jsx)((0, $67d1e32b493d1bb5$export$2e0a83ec2e27ecbb), {
                                        horizontal: true,
                                        spacing: "md"
                                    }) : null,
                                    (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                        variant: "body",
                                        size: "sm",
                                        children: localize(q.question)
                                    }),
                                    (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                        variant: "heading",
                                        level: 4,
                                        children: localize((_b = (_a = q.responses.find((r)=>r.id === responses[qi])) === null || _a === void 0 ? void 0 : _a.response) !== null && _b !== void 0 ? _b : {})
                                    })
                                ]
                            }, q.id.valueOf());
                        })
                    }),
                    (0, $4vwom.jsx)((0, $4b4086f8a1c6b2f8$export$353f5b6fc5456de1), {
                        iconEnd: "arrowRight",
                        onClick: props.onNextClick,
                        fullwidth: true,
                        children: localize(props.summary.continueButtonText)
                    })
                ]
            })
        })
    });
}
function $0eca38a3f9eebfa7$var$ConfirmationStep(props) {
    const localize = (0, $aIeEI.useLocalize)();
    const [checkedAcknowledgements, setCheckedAcknowledgements] = (0, $eeH7J.useState)([]);
    return (0, $4vwom.jsx)((0, $4vwom.Fragment), {
        children: (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
            direction: "column",
            gap: (0, $1c2a8fb378443a1d$export$d98ecea1201f13ea).lg,
            children: [
                props.PaymentSummaryRendered,
                (0, $4vwom.jsxs)("div", {
                    children: [
                        (0, $4vwom.jsx)((0, $789b8639be592288$export$a8a3e93435678ff9), {
                            level: 3,
                            margin: {
                                bottom: (0, $1c2a8fb378443a1d$export$d98ecea1201f13ea).sm
                            },
                            children: localize(props.confirmation.nextStepsHeading)
                        }),
                        (0, $4vwom.jsx)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                            direction: "column",
                            gap: 12,
                            children: props.confirmation.nextSteps.map((ns)=>(0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                                    gap: (0, $1c2a8fb378443a1d$export$d98ecea1201f13ea).sm,
                                    backgroundColor: "gray100",
                                    padding: "md",
                                    borderRadius: "md",
                                    alignItems: "center",
                                    children: [
                                        (0, $4vwom.jsx)((0, $f8cdd04128a131cf$export$f04a61298a47a40f), {
                                            icon: ns.icon,
                                            size: 32
                                        }),
                                        (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                            variant: "body",
                                            size: "md",
                                            children: localize(ns.text)
                                        })
                                    ]
                                }, ns.id.valueOf()))
                        })
                    ]
                }),
                (0, $4vwom.jsx)("div", {
                    children: props.confirmation.acknowledgements.map((a, ai)=>(0, $4vwom.jsxs)((0, $eeH7J.Fragment), {
                            children: [
                                ai > 0 ? (0, $4vwom.jsx)((0, $67d1e32b493d1bb5$export$2e0a83ec2e27ecbb), {
                                    horizontal: true,
                                    spacing: (0, $1c2a8fb378443a1d$export$d98ecea1201f13ea).md
                                }) : null,
                                (0, $4vwom.jsx)((0, $06e3a36d2d83b339$export$48513f6b9f8ce62d), {
                                    label: localize(a.text),
                                    checked: checkedAcknowledgements.includes(a.id),
                                    onChange: ()=>setCheckedAcknowledgements(checkedAcknowledgements.includes(a.id) ? checkedAcknowledgements.filter((ca)=>ca !== a.id) : [
                                            ...checkedAcknowledgements,
                                            a.id
                                        ])
                                })
                            ]
                        }, a.id.valueOf()))
                }),
                (0, $4vwom.jsx)((0, $4b4086f8a1c6b2f8$export$353f5b6fc5456de1), {
                    fullwidth: true,
                    disabled: checkedAcknowledgements.length < props.confirmation.acknowledgements.length,
                    variant: "primary",
                    onClick: props.onTradeInConfirm,
                    children: localize(props.confirmation.continueButtonText)
                })
            ]
        })
    });
}


const $c90be680bf4410a3$export$68c0e99bc234a4d = {
    TradeIn: (0, $0eca38a3f9eebfa7$export$a8febc64537a0214),
    Insurance: (0, $be6bc11d8e8cab8d$export$90b6e87e315e2927),
    Login: (0, $9acc7a9b3b60d30b$export$b14e3cb78859f2c6),
    Shipping: (0, $fe97b132bdc7c14c$export$f86ab37791746a56),
    Payment: (0, $f6289446464b7da6$export$20c36f2f8fe0d441)
};
const $c90be680bf4410a3$export$c81bc4f691c81d42 = [
    {
        id: "TradeIn",
        icon: "handCoins"
    },
    {
        id: "Insurance",
        icon: "shield"
    },
    {
        id: "Login",
        icon: "vipps"
    },
    {
        id: "Shipping",
        icon: "truck"
    },
    {
        id: "Payment",
        icon: "receipt"
    }
];
const $c90be680bf4410a3$export$5558864fbda6a534 = /*#__PURE__*/ (0, $eeH7J.createContext)(undefined);
function $c90be680bf4410a3$export$b75716bfd8405073() {
    const context = (0, $eeH7J.useContext)($c90be680bf4410a3$export$5558864fbda6a534);
    if (!context) throw new Error("CheckoutContext not found");
    return context;
}




var $4vwom = parcelRequire("4vwom");

var $eeH7J = parcelRequire("eeH7J");

var $lhaLc = parcelRequire("lhaLc");







var $eSiQ2 = parcelRequire("eSiQ2");



const $c4ee9fc699106494$var$CURRENT_ICON_DIMENSION = 48;
const $c4ee9fc699106494$var$MOBILE_OUTER_ICON_DIMENSION = 16;
const $c4ee9fc699106494$var$MOBILE_INNER_ICON_DIMENSION = 12;
const $c4ee9fc699106494$var$DESKTOP_OUTER_ICON_DIMENSION = 40;
const $c4ee9fc699106494$var$DESKTOP_INNER_ICON_DIMENSION = 32;
function $c4ee9fc699106494$export$2a0ca3f7657e279({ steps: steps, currentStep: currentStep }) {
    const checkoutContext = (0, $eeH7J.useContext)((0, $c90be680bf4410a3$export$5558864fbda6a534));
    const getStatus = (step, index)=>{
        const currentIndex = steps.findIndex((s)=>s.id === step);
        if (currentIndex === index) return "current";
        if (currentIndex > index) return "completed";
        return "future";
    };
    const getPosition = (index, length)=>{
        if (index === 0) return "first";
        if (index === length) return "last";
        return "middle";
    };
    const handleClick = (0, $eeH7J.useCallback)((s)=>{
        checkoutContext === null || checkoutContext === void 0 || checkoutContext.setStep(s);
    }, [
        checkoutContext
    ]);
    return (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
        flex: "1",
        alignItems: "center",
        justifyContent: "space-between",
        style: {
            position: "relative"
        },
        children: [
            (0, $4vwom.jsx)($c4ee9fc699106494$var$StepSeparator, {
                currentStepIndex: steps.findIndex((s)=>s.id === currentStep),
                totalSteps: steps.length
            }),
            steps.map((step, index)=>{
                const status = getStatus(currentStep, index);
                return (0, $4vwom.jsx)($c4ee9fc699106494$var$StepIcon, {
                    onClick: step.isAvailable ? ()=>handleClick(step.id) : undefined,
                    step: step,
                    status: status,
                    position: getPosition(index, steps.length - 1)
                }, step.id);
            })
        ]
    });
}
const $c4ee9fc699106494$var$stepIndicatorColorMap = {
    completed: "forest",
    current: "grayWhite",
    future: "gray200"
};
function $c4ee9fc699106494$var$StepIcon({ step: step, status: status, position: position, onClick: onClick }) {
    const getDimension = (dimension)=>(0, $756948b644e82cf2$export$981516ee4691055c)(status === "current" ? $c4ee9fc699106494$var$CURRENT_ICON_DIMENSION : dimension);
    const { colors: colors, helpers: helpers } = (0, $756948b644e82cf2$export$559a0f07c8df6570)();
    const { responsiveCss: responsiveCss } = helpers;
    return (0, $4vwom.jsx)((0, $ad7a054f4530c130$export$e25e478948902b8b).div, {
        onClick: onClick,
        css: (0, $lhaLc.css)({
            backgroundColor: colors.gray100,
            cursor: onClick ? "pointer" : "inherit",
            boxShadow: status === "current" ? (0, $e665a5c3bf2ac3f6$export$16e1fc8de5cd9687) : "none",
            height: getDimension($c4ee9fc699106494$var$DESKTOP_OUTER_ICON_DIMENSION),
            width: getDimension($c4ee9fc699106494$var$DESKTOP_OUTER_ICON_DIMENSION),
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            position: "relative",
            borderRadius: "50%"
        }, responsiveCss("max", "sm", {
            height: getDimension($c4ee9fc699106494$var$MOBILE_OUTER_ICON_DIMENSION),
            width: getDimension($c4ee9fc699106494$var$MOBILE_OUTER_ICON_DIMENSION),
            marginRight: status !== "current" && position === "last" ? (0, $756948b644e82cf2$export$981516ee4691055c)(($c4ee9fc699106494$var$CURRENT_ICON_DIMENSION - $c4ee9fc699106494$var$MOBILE_OUTER_ICON_DIMENSION) / 2) : undefined,
            marginLeft: status !== "current" && position === "first" ? (0, $756948b644e82cf2$export$981516ee4691055c)(($c4ee9fc699106494$var$CURRENT_ICON_DIMENSION - $c4ee9fc699106494$var$MOBILE_OUTER_ICON_DIMENSION) / 2) : undefined
        })),
        children: (0, $4vwom.jsx)((0, $cf418bf541887e36$export$28c660c63b792dea), {
            alignment: "center",
            renderTrigger: (ref)=>(0, $4vwom.jsx)((0, $ad7a054f4530c130$export$e25e478948902b8b).div, {
                    whileHover: "hover",
                    variants: {
                        hover: status === "future" ? {
                            backgroundColor: colors.grayWhite,
                            transition: {
                                duration: 0.2
                            }
                        } : {}
                    },
                    ref: ref,
                    css: (0, $lhaLc.css)({
                        backgroundColor: colors[$c4ee9fc699106494$var$stepIndicatorColorMap[status]],
                        height: getDimension($c4ee9fc699106494$var$DESKTOP_INNER_ICON_DIMENSION),
                        width: getDimension($c4ee9fc699106494$var$DESKTOP_INNER_ICON_DIMENSION),
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        borderRadius: "50%"
                    }, responsiveCss("max", "sm", {
                        height: getDimension($c4ee9fc699106494$var$MOBILE_INNER_ICON_DIMENSION),
                        width: getDimension($c4ee9fc699106494$var$MOBILE_INNER_ICON_DIMENSION)
                    })),
                    children: status === "completed" ? (0, $4vwom.jsx)((0, $f8cdd04128a131cf$export$f04a61298a47a40f), {
                        hidden: [
                            "max",
                            "sm"
                        ],
                        icon: "check",
                        color: "grayWhite"
                    }) : status === "current" ? (0, $4vwom.jsx)((0, $f8cdd04128a131cf$export$f04a61298a47a40f), {
                        icon: step.icon
                    }) : (0, $4vwom.jsx)((0, $ad7a054f4530c130$export$e25e478948902b8b).div, {
                        style: {
                            opacity: 0,
                            scale: 0.1
                        },
                        variants: {
                            hover: {
                                opacity: 1,
                                scale: 0.8,
                                transition: {
                                    duration: 0.2
                                }
                            }
                        },
                        children: (0, $4vwom.jsx)((0, $f8cdd04128a131cf$export$f04a61298a47a40f), {
                            icon: step.icon
                        })
                    })
                }),
            children: (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                variant: "heading",
                level: 4,
                children: step.name
            })
        })
    });
}
const $c4ee9fc699106494$var$StepSeparator = ({ currentStepIndex: currentStepIndex, totalSteps: totalSteps })=>{
    const { colors: colors, helpers: helpers } = (0, $756948b644e82cf2$export$559a0f07c8df6570)();
    const { responsiveCss: responsiveCss } = helpers;
    const percentage = currentStepIndex / (totalSteps - 1) * 100;
    const uncompletedBarWidth = `${100 - percentage}%`;
    const completedBarWidth = `${percentage}%`;
    return (0, $4vwom.jsxs)("div", {
        css: (0, $lhaLc.css)({
            height: 4,
            position: "absolute",
            right: `${$c4ee9fc699106494$var$CURRENT_ICON_DIMENSION / 2}px`,
            left: `${$c4ee9fc699106494$var$CURRENT_ICON_DIMENSION / 2}px`,
            display: "flex",
            overflow: "hidden"
        }),
        children: [
            (0, $4vwom.jsx)("div", {
                css: (0, $lhaLc.css)({
                    height: "100%",
                    width: completedBarWidth,
                    backgroundColor: colors.forest,
                    transition: "width 0.8s ease-in-out",
                    borderRadius: "2px"
                }, responsiveCss("min", "md", {
                    width: `calc(${completedBarWidth} + ${2 * $c4ee9fc699106494$var$CURRENT_ICON_DIMENSION / 3}px)`
                }))
            }),
            (0, $4vwom.jsx)("div", {
                css: (0, $lhaLc.css)({
                    height: "100%",
                    width: uncompletedBarWidth,
                    backgroundColor: colors.gray200,
                    transition: "width 0.8s ease-in-out"
                }, responsiveCss("min", "md", {
                    width: `calc(${uncompletedBarWidth} - ${2 * $c4ee9fc699106494$var$CURRENT_ICON_DIMENSION / 3}px)`
                }))
            })
        ]
    });
};
const $c4ee9fc699106494$var$navigationMock = [
    {
        id: "TradeIn",
        name: "TradeIn",
        icon: "handCoins",
        tooltip: "Bytte inn",
        isAvailable: true
    },
    {
        id: "Insurance",
        name: "Insurance",
        icon: "shield",
        tooltip: "Trygghetspakke",
        isAvailable: true
    },
    {
        id: "Login",
        name: "Login",
        icon: "vipps",
        tooltip: "Vipps ID",
        isAvailable: false
    },
    {
        id: "Shipping",
        name: "Shipping",
        icon: "truck",
        tooltip: "Shipping",
        isAvailable: false
    }
];
(0, $eSiQ2.Component)($c4ee9fc699106494$export$2a0ca3f7657e279, {
    name: "Steps",
    gallery: {
        path: "Navigation/Steps",
        items: [
            {
                title: "First Step",
                variants: [
                    {
                        props: {
                            steps: $c4ee9fc699106494$var$navigationMock,
                            currentStep: "TradeIn"
                        }
                    }
                ]
            },
            {
                title: "Second Step",
                variants: [
                    {
                        props: {
                            steps: $c4ee9fc699106494$var$navigationMock,
                            currentStep: "Insurance"
                        }
                    }
                ]
            },
            {
                title: "Third Step",
                variants: [
                    {
                        props: {
                            steps: $c4ee9fc699106494$var$navigationMock,
                            currentStep: "Login"
                        }
                    }
                ]
            },
            {
                title: "Last Step",
                variants: [
                    {
                        props: {
                            steps: $c4ee9fc699106494$var$navigationMock,
                            currentStep: "Shipping"
                        }
                    }
                ]
            }
        ]
    }
});



var $4vwom = parcelRequire("4vwom");

var $eeH7J = parcelRequire("eeH7J");

var $lhaLc = parcelRequire("lhaLc");


var $eSiQ2 = parcelRequire("eSiQ2");
parcelRequire("2LTO8");
var $14q7s = parcelRequire("14q7s");

var $7m9cQ = parcelRequire("7m9cQ");










function $6b5c692995a5ffa5$export$d175a07b9db3024e(props) {
    var _a;
    const { colors: colors } = (0, $756948b644e82cf2$export$559a0f07c8df6570)();
    const isDiscountedPrice = (0, $eeH7J.useMemo)(()=>props.checkout.originalPrice > props.checkout.discountedPrice, [
        props.checkout.originalPrice,
        props.checkout.discountedPrice
    ]);
    return (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
        backgroundColor: "gray500",
        borderRadius: "lg",
        color: "grayWhite",
        css: (0, $lhaLc.css)({
            position: "relative",
            padding: (0, $756948b644e82cf2$export$981516ee4691055c)(24),
            flexDirection: "column-reverse",
            gap: 24
        }, (0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("min", "md", {
            height: (0, $756948b644e82cf2$export$981516ee4691055c)(800),
            gap: 40,
            maxHeight: `calc(100vh - 24px - ${(0, $756948b644e82cf2$export$981516ee4691055c)(48)} - 24px - 24px)`,
            padding: (0, $756948b644e82cf2$export$981516ee4691055c)(40),
            paddingTop: (0, $756948b644e82cf2$export$981516ee4691055c)(60),
            flexDirection: "column"
        })),
        children: [
            props.label && (0, $4vwom.jsx)("div", {
                css: (0, $lhaLc.css)({
                    position: "absolute"
                }, (0, $aace75a797ac78f1$export$9c33585a37942ee0)("lg", [
                    "top",
                    "right"
                ])),
                children: (0, $4vwom.jsx)((0, $1c19a55e13f5780a$export$48c441fbee531268), {
                    color: "brand",
                    children: props.label
                })
            }),
            (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                flex: "1 1 auto",
                alignItems: "center",
                justifyContent: "space-between",
                shrink: 1,
                css: (0, $lhaLc.css)({
                    flexDirection: "column-reverse",
                    gap: 24
                }, (0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("min", "md", {
                    flexDirection: "column",
                    gap: 40
                })),
                children: [
                    (0, $4vwom.jsx)((0, $ad7a054f4530c130$export$e25e478948902b8b).div, {
                        initial: {
                            opacity: 0
                        },
                        animate: {
                            opacity: 1
                        },
                        exit: {
                            opacity: 0
                        },
                        style: {
                            maxHeight: (0, $756948b644e82cf2$export$981516ee4691055c)(416),
                            display: "flex",
                            flex: "1 0 auto",
                            alignItems: "center",
                            justifyContent: "center",
                            width: "100%",
                            scrollSnapAlign: "center"
                        },
                        children: (0, $4vwom.jsx)("div", {
                            css: (0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("max", "sm", {
                                minHeight: 264
                            }),
                            style: {
                                display: "flex",
                                height: "100%",
                                width: "100%",
                                flexDirection: "column",
                                backgroundImage: (0, $14q7s.ImageToCSS)(props.product.image, {
                                    width: 900
                                }),
                                backgroundPosition: "center",
                                objectFit: "contain",
                                backgroundRepeat: "no-repeat",
                                backgroundSize: "auto 100%",
                                maxHeight: (0, $756948b644e82cf2$export$981516ee4691055c)(420)
                            }
                        })
                    }, props.product.image.valueOf()),
                    (0, $4vwom.jsx)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                        direction: "column",
                        gap: 8,
                        style: {
                            width: "100%"
                        },
                        children: (0, $4vwom.jsx)((0, $4292e3b361a44985$export$caa69d61d2de10d9), {
                            transition: (0, $7f851218870bc850$export$f4e4ad51b471de36)["200"],
                            children: (0, $4vwom.jsx)((0, $0df0f0e5b644e49a$export$3ae376d12526dd6f), {
                                initial: false,
                                children: (_a = props.infoItems) === null || _a === void 0 ? void 0 : _a.map((item)=>(0, $4vwom.jsx)($6b5c692995a5ffa5$var$AppearingItem, {
                                        children: (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                                            justifyContent: "flex-start",
                                            alignItems: "center",
                                            style: {
                                                backgroundColor: "#31253f"
                                            },
                                            css: (0, $lhaLc.css)({
                                                borderRadius: 8,
                                                padding: 16
                                            }, (0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("min", "md", {
                                                borderRadius: 20
                                            })),
                                            gap: [
                                                8,
                                                [
                                                    "min",
                                                    "md",
                                                    12
                                                ]
                                            ],
                                            children: [
                                                (0, $4vwom.jsx)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    css: (0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("min", "md", {
                                                        backgroundColor: `${colors.grayWhite}${(0, $2e602d91f6817609$export$dcfd5621ca9623a7)["10"]}`,
                                                        borderRadius: 8,
                                                        height: (0, $756948b644e82cf2$export$981516ee4691055c)(48),
                                                        width: (0, $756948b644e82cf2$export$981516ee4691055c)(48)
                                                    }),
                                                    children: (0, $4vwom.jsx)((0, $f8cdd04128a131cf$export$f04a61298a47a40f), {
                                                        icon: item.icon
                                                    })
                                                }),
                                                (0, $4vwom.jsxs)((0, $bee1a5e35c892a21$export$e71c4d32a2263218), {
                                                    children: [
                                                        (0, $4vwom.jsx)((0, $72c5ae9e0017e167$export$4b2c32e08f77ff18), {
                                                            size: "sm",
                                                            children: item.title
                                                        }),
                                                        (0, $4vwom.jsx)((0, $72c5ae9e0017e167$export$4b2c32e08f77ff18), {
                                                            size: "xs",
                                                            style: {
                                                                opacity: 0.6
                                                            },
                                                            children: item.text
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    }, item.id))
                            })
                        })
                    })
                ]
            }),
            (0, $4vwom.jsx)("div", {
                children: (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                    flex: "0 0 auto",
                    justifyContent: "space-between",
                    alignItems: "flex-end",
                    children: [
                        (0, $4vwom.jsxs)("div", {
                            children: [
                                (0, $4vwom.jsx)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                                    alignItems: "center",
                                    children: (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                        variant: "heading",
                                        level: 3,
                                        children: props.checkout.monthlyTotalPriceLabel
                                    })
                                }),
                                (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                    variant: "body",
                                    size: "xs",
                                    style: {
                                        opacity: 0.6
                                    },
                                    children: props.checkout.rentalPeriodTotalPriceText
                                })
                            ]
                        }),
                        (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                            direction: "column",
                            alignItems: "flex-end",
                            children: [
                                (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                                    alignItems: "baseline",
                                    children: [
                                        isDiscountedPrice && (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                            variant: "body",
                                            size: "md",
                                            color: "gray200",
                                            style: {
                                                textDecoration: "line-through",
                                                marginRight: 4
                                            },
                                            children: props.checkout.originalPrice
                                        }),
                                        (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                            variant: "heading",
                                            level: 2,
                                            color: isDiscountedPrice ? "brand" : undefined,
                                            children: props.checkout.discountedPrice
                                        })
                                    ]
                                }),
                                (0, $4vwom.jsx)((0, $72c5ae9e0017e167$export$4b2c32e08f77ff18), {
                                    size: "sm",
                                    style: {
                                        opacity: 0.6,
                                        textTransform: "lowercase",
                                        textAlign: "right"
                                    },
                                    children: props.checkout.rentalPeriodCurrencyPeriodUnit
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}
function $6b5c692995a5ffa5$var$AppearingItem(props) {
    const [isPresent, safeToRemove] = (0, $d9315986bafdadde$export$2a8c16d82a0a0e26)();
    const [scope, animate] = (0, $4c4e7486a769eecb$export$9f387b98a73b1511)();
    const ref = (0, $eeH7J.useRef)(null);
    const [height, setHeight] = (0, $eeH7J.useState)(0);
    const [autoHeight, setAutoHeight] = (0, $eeH7J.useState)(false);
    const updateHeight = (0, $eeH7J.useCallback)(()=>{
        var _a, _b;
        setHeight((_b = (_a = ref.current) === null || _a === void 0 ? void 0 : _a.clientHeight) !== null && _b !== void 0 ? _b : 0);
    }, [
        setHeight
    ]);
    const heightRef = (0, $eeH7J.useRef)(0);
    (0, $eeH7J.useEffect)(()=>{
        if (isPresent) {
            const enterAnimation = async ()=>{
                var _a, _b;
                await animate(scope.current, {
                    opacity: 1,
                    height: (_b = (_a = ref.current) === null || _a === void 0 ? void 0 : _a.clientHeight) !== null && _b !== void 0 ? _b : 0,
                    transform: `translateY(0px)`
                });
            };
            enterAnimation().then(()=>{
                setAutoHeight(true);
            });
        } else {
            const exitAnimation = async ()=>{
                var _a, _b;
                await animate(scope.current, {
                    opacity: 0,
                    height: 0,
                    transform: `translateY(-${((_b = (_a = ref.current) === null || _a === void 0 ? void 0 : _a.clientHeight) !== null && _b !== void 0 ? _b : 0) - 16}px)`
                });
                safeToRemove();
            };
            setAutoHeight(false);
            exitAnimation();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isPresent
    ]);
    (0, $eeH7J.useEffect)(()=>{
        var _a, _b;
        heightRef.current = (_b = (_a = ref.current) === null || _a === void 0 ? void 0 : _a.clientHeight) !== null && _b !== void 0 ? _b : 0;
        updateHeight();
    }, [
        updateHeight
    ]);
    return (0, $4vwom.jsx)("div", {
        ref: scope,
        style: {
            opacity: 0,
            height: 0,
            transform: `translateY(${height * -1 + 16}px)`
        },
        css: (0, $lhaLc.css)({
            height: autoHeight ? "auto !important" : undefined
        }),
        children: (0, $4vwom.jsx)("div", {
            ref: ref,
            children: props.children
        })
    });
}
(0, $eSiQ2.Component)($6b5c692995a5ffa5$export$d175a07b9db3024e, {
    name: "DeviceCheckoutCard",
    gallery: {
        path: "Cards/DeviceCheckoutCard",
        items: [
            {
                variants: [
                    {
                        props: {
                            product: {
                                image: `${(0, $7m9cQ.server)()}/static/redoit/product-card-product-image3.png`,
                                color: "Midnight",
                                storageSize: "256 GB"
                            },
                            subscription: {
                                duration: 24,
                                unit: "months lease"
                            },
                            checkout: {
                                originalPrice: 320,
                                discountedPrice: 250,
                                rentalPeriodCurrencyPeriodUnit: "kr/md.",
                                monthlyTotalPriceLabel: "Totalt 3400 NOK for leieperiode p\xe5 12 m\xe5neder",
                                rentalPeriodTotalPriceText: "Pris per m\xe5ned"
                            },
                            infoItems: [
                                {
                                    id: "trade-in",
                                    title: "Trade-in cashback",
                                    text: "We will deduct 50 kr. for the next 20 months.",
                                    icon: "device"
                                }
                            ],
                            label: "Trade-in"
                        }
                    }
                ]
            }
        ]
    }
});










var $4vwom = parcelRequire("4vwom");

var $lhaLc = parcelRequire("lhaLc");





var $aIeEI = parcelRequire("aIeEI");


var $dUDPg = parcelRequire("dUDPg");

function $652a00d43f507d25$export$13d90034f51c5979(props) {
    var _a;
    const localize = (0, $aIeEI.useLocalize)();
    const primaryActionPageInfo = (0, $dUDPg.useWebPageInfo)(props.primaryAction.page);
    const localizeSlug = (0, $02ba3a727a0f8ecd$export$32f719dfac03c1cb)();
    return (0, $4vwom.jsx)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
        justifyContent: "center",
        style: {
            width: "100%",
            height: "100%"
        },
        children: (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
            direction: "column",
            justifyContent: "center",
            alignItems: "center",
            css: (0, $lhaLc.css)((0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("max", "sm", {
                padding: "16px 0"
            })),
            children: [
                (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                    direction: "column",
                    alignItems: "center",
                    gap: 12,
                    css: (0, $lhaLc.css)({
                        textAlign: "center"
                    }, (0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("max", "sm", {
                        gap: 8,
                        marginBottom: 32
                    }), (0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("min", "md", {
                        padding: "0 40px",
                        gap: 12,
                        marginBottom: 40
                    })),
                    children: [
                        (0, $4vwom.jsx)((0, $789b8639be592288$export$a8a3e93435678ff9), {
                            color: "gray500",
                            level: 2,
                            children: localize(props.heading)
                        }),
                        (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                            color: "gray400",
                            variant: "body",
                            size: "md",
                            children: localize(props.text)
                        })
                    ]
                }),
                (0, $4vwom.jsx)((0, $4b4086f8a1c6b2f8$export$353f5b6fc5456de1), {
                    variant: "primary",
                    size: "md",
                    as: "a",
                    href: ((_a = primaryActionPageInfo.data) === null || _a === void 0 ? void 0 : _a.slug) ? localizeSlug(primaryActionPageInfo.data.slug) : "/",
                    children: localize(props.primaryAction.buttonText)
                })
            ]
        })
    });
}



var $4vwom = parcelRequire("4vwom");



var $aIeEI = parcelRequire("aIeEI");

function $b97c03a91b0e5a47$export$c120a0e80fd44ca6() {
    const localize = (0, $aIeEI.useLocalize)();
    return (0, $4vwom.jsx)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
        direction: "column",
        alignItems: "center",
        children: (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
            style: {
                width: "100%",
                maxWidth: 640,
                textAlign: "center"
            },
            gap: 32,
            direction: "column",
            alignItems: "center",
            children: [
                (0, $4vwom.jsx)("div", {
                    style: {
                        width: "100%",
                        maxWidth: 480,
                        padding: "40px 32px 0 32px"
                    },
                    children: (0, $4vwom.jsx)($b97c03a91b0e5a47$var$Error404Svg, {
                        width: "100%",
                        height: "auto"
                    })
                }),
                (0, $4vwom.jsx)((0, $72c5ae9e0017e167$export$4b2c32e08f77ff18), {
                    size: "lg",
                    children: localize({
                        no: "Kunne ikke finne siden du lette etter.",
                        en: "Could not find the page you were looking for."
                    })
                }),
                (0, $4vwom.jsx)("div", {
                    children: (0, $4vwom.jsx)((0, $4b4086f8a1c6b2f8$export$353f5b6fc5456de1), {
                        variant: "primary",
                        as: "a",
                        href: "/",
                        children: localize({
                            no: "G\xe5 til forsiden",
                            en: "Go to home page"
                        })
                    })
                })
            ]
        })
    });
}
const $b97c03a91b0e5a47$var$Error404Svg = (props)=>(0, $4vwom.jsxs)("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 1841 1129",
        width: 1841,
        height: 1129,
        fill: "none"
    }, props, {
        children: [
            (0, $4vwom.jsx)("path", {
                fill: "#F6F6F6",
                d: "M927.87 1128.2c311.44 0 563.92-252.476 563.92-563.92C1491.79 252.836 1239.31.36 927.87.36c-311.444 0-563.92 252.476-563.92 563.92 0 311.444 252.476 563.92 563.92 563.92Z"
            }),
            (0, $4vwom.jsx)("path", {
                fill: "url(#a)",
                d: "M1538.64 1023.47c166.99 0 302.37-18.44 302.37-41.18 0-22.743-135.38-41.18-302.37-41.18s-302.37 18.437-302.37 41.18c0 22.74 135.38 41.18 302.37 41.18Z"
            }),
            (0, $4vwom.jsx)("path", {
                fill: "url(#b)",
                d: "M1509.8 988.78c118.22 0 214.05-4.589 214.05-10.25s-95.83-10.25-214.05-10.25c-118.22 0-214.05 4.589-214.05 10.25s95.83 10.25 214.05 10.25Z"
            }),
            (0, $4vwom.jsx)("path", {
                fill: "url(#c)",
                d: "M1509.8 988.78c118.22 0 214.05-4.589 214.05-10.25s-95.83-10.25-214.05-10.25c-118.22 0-214.05 4.589-214.05 10.25s95.83 10.25 214.05 10.25Z"
            }),
            (0, $4vwom.jsx)("path", {
                fill: "url(#d)",
                d: "M932.24 1023.47c237.57 0 430.16-18.44 430.16-41.18 0-22.743-192.59-41.18-430.16-41.18-237.571 0-430.16 18.437-430.16 41.18 0 22.74 192.589 41.18 430.16 41.18Z"
            }),
            (0, $4vwom.jsx)("path", {
                fill: "url(#e)",
                d: "M482.05 1023.47c166.994 0 302.37-18.44 302.37-41.18 0-22.743-135.376-41.18-302.37-41.18s-302.37 18.437-302.37 41.18c0 22.74 135.376 41.18 302.37 41.18Z"
            }),
            (0, $4vwom.jsx)("path", {
                fill: "url(#f)",
                d: "M897.53 1023.02h-80.19l39.83 15.81 40.36-15.81Z"
            }),
            (0, $4vwom.jsx)("path", {
                fill: "url(#g)",
                d: "M762.85 992.79h-41.79l39.82 15.81 1.97-15.81Z"
            }),
            (0, $4vwom.jsx)("path", {
                fill: "url(#h)",
                d: "M1134.71 1002.69h50.82l13.55-13.91h-53.61l-10.76 13.91Z"
            }),
            (0, $4vwom.jsx)("path", {
                fill: "url(#i)",
                d: "M1526.24 1023.57h50.82l-36.14-6.95-58.46-6.96 43.78 13.91Z"
            }),
            (0, $4vwom.jsx)("path", {
                fill: "url(#j)",
                d: "M1204.08 941.7h50.82l-12.52-3.39-13.93-3.56-24.37 6.95Z"
            }),
            (0, $4vwom.jsx)("path", {
                fill: "url(#k)",
                d: "M1386.85 941.7h50.83l-12.53-3.39-13.92-3.56-24.38 6.95Z"
            }),
            (0, $4vwom.jsx)("path", {
                fill: "url(#l)",
                d: "M1628.41 948.66h50.82l-12.52-3.39-30.68-3.57-7.62 6.96Z"
            }),
            (0, $4vwom.jsx)("path", {
                fill: "url(#m)",
                d: "M1770.33 965.74h38.22l-17.28-6.96-26.35 3.48 5.41 3.48Z"
            }),
            (0, $4vwom.jsx)("path", {
                fill: "url(#n)",
                d: "M1042.47 1016.62h16.19l7.91 6.4-21.08 2.63-3.02-9.03Z"
            }),
            (0, $4vwom.jsx)("path", {
                fill: "url(#o)",
                d: "M897.53 1038.83h20.62l-4.81 7.15-19.57-3.57 3.76-3.58Z"
            }),
            (0, $4vwom.jsx)("path", {
                fill: "url(#p)",
                d: "M658.85 930.41h-56.09l11.29 11.29h22.21l22.59-11.29Z"
            }),
            (0, $4vwom.jsx)("path", {
                fill: "url(#q)",
                d: "m232.83 930.41-38.35 5.64-6.45 5.65h22.21l22.59-11.29Z"
            }),
            (0, $4vwom.jsx)("path", {
                fill: "url(#r)",
                d: "M110 1002.41H53.91l-4.42 11.29H71.7l38.3-11.29Z"
            }),
            (0, $4vwom.jsx)("path", {
                fill: "url(#s)",
                d: "M19.39 933.27.78 941.11l15.01.59H38l-18.61-8.43Z"
            }),
            (0, $4vwom.jsx)("path", {
                fill: "url(#t)",
                d: "m352.72 950.45-20.62 1.93 15.32 5.65h22.21l-16.91-7.58Z"
            }),
            (0, $4vwom.jsx)("path", {
                fill: "url(#u)",
                d: "M655.46 911.58h19.96v-4.14l-16.57-4.14-3.39 8.28Z"
            }),
            (0, $4vwom.jsx)("path", {
                fill: "url(#v)",
                d: "M992.53 1004.67h-8.32l4.16 4.23 20.97-2.12-16.81-2.11Z"
            }),
            (0, $4vwom.jsx)("path", {
                fill: "url(#w)",
                d: "M1159.27 959.49h9.89l-2.26-2.92-20.62 1.46 12.99 1.46Z"
            }),
            (0, $4vwom.jsx)("path", {
                fill: "url(#x)",
                d: "M1305.81 938.31h24.29l-4.87 7.91-19.42-3.95v-3.96Z"
            }),
            (0, $4vwom.jsx)("path", {
                fill: "url(#y)",
                d: "M557.58 995.73h24.28l7.34-6.95-31.62 6.95Z"
            }),
            (0, $4vwom.jsx)("path", {
                fill: "url(#z)",
                d: "M1201.34 761.16V629.45l249.5-498.99h134.25v516.72h94.99v113.98h-94.99V975.2h-122.85V761.16h-260.9Zm260.89-424.27-146.91 310.29h146.91V336.89Z"
            }),
            (0, $4vwom.jsx)("path", {
                fill: "#9B64E1",
                d: "M1201.34 761.16V629.45l249.5-498.99h134.25v516.72h94.99v113.98h-94.99V975.2h-122.85V761.16h-260.9Zm260.89-424.27-146.91 310.29h146.91V336.89Z"
            }),
            (0, $4vwom.jsx)("path", {
                fill: "url(#A)",
                d: "M1232.34 761.16V629.45l249.5-498.99h134.25v516.72h94.99v113.98h-94.99V975.2h-122.85V761.16h-260.9Zm260.89-424.27-146.91 310.29h146.91V336.89Z"
            }),
            (0, $4vwom.jsx)("path", {
                fill: "#9B64E1",
                d: "M1232.34 629.45h-31v131.71h31V629.45Z"
            }),
            (0, $4vwom.jsx)("path", {
                fill: "url(#B)",
                d: "M875.69 988.78c118.216 0 214.05-4.589 214.05-10.25s-95.834-10.25-214.05-10.25c-118.217 0-214.05 4.589-214.05 10.25s95.833 10.25 214.05 10.25Z"
            }),
            (0, $4vwom.jsx)("path", {
                fill: "url(#C)",
                d: "M498.98 988.78c118.217 0 214.05-4.589 214.05-10.25s-95.833-10.25-214.05-10.25c-118.217 0-214.05 4.589-214.05 10.25s95.833 10.25 214.05 10.25Z"
            }),
            (0, $4vwom.jsx)("path", {
                fill: "url(#D)",
                d: "M498.98 988.78c118.217 0 214.05-4.589 214.05-10.25s-95.833-10.25-214.05-10.25c-118.217 0-214.05 4.589-214.05 10.25s95.833 10.25 214.05 10.25Z"
            }),
            (0, $4vwom.jsx)("path", {
                fill: "#CCADF2",
                d: "M176.73 761.16V629.45l249.5-498.99h134.25v516.72h94.99v113.98h-94.99V975.2H437.63V761.16h-260.9Zm260.9-424.27L290.72 647.18h146.91V336.89Z"
            }),
            (0, $4vwom.jsx)("path", {
                fill: "#9B64E1",
                d: "M176.73 761.16V629.45l249.5-498.99h134.25v516.72h94.99v113.98h-94.99V975.2H437.63V761.16h-260.9Zm260.9-424.27L290.72 647.18h146.91V336.89Z"
            }),
            (0, $4vwom.jsx)("path", {
                fill: "url(#E)",
                d: "M144.66 761.16V629.45l249.5-498.99h134.25v516.72h94.99v113.98h-94.99V975.2H405.56V761.16h-260.9Zm260.9-424.27L258.65 647.18h146.91V336.89Z"
            }),
            (0, $4vwom.jsx)("path", {
                fill: "#9964DF",
                d: "m908.34 49.33-292.855 98.386c-36.119 12.134-55.562 51.25-43.428 87.369l233.727 695.708c12.134 36.119 51.25 55.562 87.369 43.428l292.857-98.386c36.12-12.134 55.56-51.251 43.42-87.369L995.709 92.757C983.574 56.64 944.458 37.196 908.34 49.33Z"
            }),
            (0, $4vwom.jsx)("path", {
                fill: "#130722",
                d: "M1207.68 808.66c8.95 26.65-5.44 55.62-32.1 64.57l-292.86 98.38c-26.65 8.95-55.62-5.45-64.57-32.1L584.43 243.79c-8.95-26.65 5.44-55.62 32.1-64.57l292.86-98.38c26.65-8.95 55.62 5.44 64.57 32.1l233.72 695.72Z"
            }),
            (0, $4vwom.jsx)("path", {
                fill: "#9B64E1",
                d: "M1186.94 802.27c8.95 26.65-5.44 55.62-32.1 64.57l-292.86 98.38c-26.65 8.95-55.62-5.45-64.57-32.1L563.69 237.4c-8.95-26.65 5.44-55.62 32.1-64.57l292.86-98.38c26.65-8.95 55.62 5.44 64.57 32.1l233.72 695.72Z"
            }),
            (0, $4vwom.jsx)("path", {
                fill: "url(#F)",
                d: "M893.658 53.764 600.803 152.15c-36.118 12.134-55.561 51.25-43.427 87.369l233.726 695.708c12.134 36.119 51.251 55.562 87.369 43.428l292.859-98.386c36.11-12.134 55.56-51.251 43.42-87.369L981.027 97.191c-12.134-36.118-51.251-55.561-87.369-43.427Z"
            }),
            (0, $4vwom.jsx)("path", {
                fill: "#B489EA",
                d: "M893.658 53.764 600.803 152.15c-36.118 12.134-55.561 51.25-43.427 87.369l233.726 695.708c12.134 36.119 51.251 55.562 87.369 43.428l292.859-98.386c36.11-12.134 55.56-51.251 43.42-87.369L981.027 97.191c-12.134-36.118-51.251-55.561-87.369-43.427Z"
            }),
            (0, $4vwom.jsx)("path", {
                fill: "url(#G)",
                d: "m1051.24 393.19 30.45 3.67-1.41-4.2-67.74-8.16 1.86-26.36 30.07-55.51-3.52-1.91-29.1 53.71-.48-3.21-28.48 4.27-7.54-22.45 71.08-41.14-1.3-3.87-73.35 42.46-7.17-2.23 32.14-24.83 30.34-69.11-1.89-5.64-31.7 72.2-33.56 25.93-10.65-3.31 18.24-34.52 11.49 13.42-9.62-16.97 45.76-86.61-1.76-5.24-68.32 129.31-7.67 1.32 29.96-110.75.03-.1 17.61-104.27-.65-1.93-1.01-3.01-41.86 92.35-12.06-.05-2.19 94.61-10.47.24-26.15-147.47 26.2-93.66c-1.39-.02-2.78 0-4.17.06l-26 92.96-.12.44 32.65 184.12-7.44 3.09-67.14-130.96-.11-.22-87.72-99.93-4.11 1.38 88.49 100.82 9.66 18.85-19.42 10.17-55.72-34.56-50.85-85.93-3.88 1.3 94.64 159.92 12.87 5.89-17.6 17.93-68.48-37.84-133.85-108.14-4.5 1.51 19.56 15.8-.76.31L666.51 273l-26.64 67.64-51.01-7.3 1.43 4.24 49.75 7.12 58.89 80.23-73.01 18.7 1.28 3.8 179.7-46.03 54.21-9.89-.24 16.85-65.11 25.35-151.03 65.9 1.28 3.81 87.39-38.13-.38.3 14.71 18.23-89.41 56.26 1.31 3.9 90.62-57.03 28.03 34.75-29.71 29.79-24.42-.09h-.79l-46.61 43.57 1.4 4.17 46.78-43.74 75.7.27-11.94 53.49 7.51 22.36-54.57 156.56 2.08 6.19 56.72-162.73-7.59-22.6 12.78-57.25-51.42-.19 68.21-68.4 25.19 111.4-22.56 69.89 21.35 19.14-37.35 142.96-39.81 43.78 1.46 4.34 40.62-44.68 55.22 27.59-59.2 104.17c.97.98 1.97 1.92 2.99 2.84l60.73-106.86.17-.3 23.03-130.93 41.72 37.4.76-.85 1.14 31.73-28.53 173.51 4.29-1.44 28.21-171.61.03-.2-2.63-72.85 59.56-68.01 21.33-4.26 10.21 46.9-27.94 55.67-1.17 184.92 4.01-1.35 1.16-182.61 24.46-48.74 5.61 103.64.04.76 86.44 87.41 4.22-1.42-86.75-87.72-3.97-73.35 132.92 26.81 43.86 79.88c.67-1.65 1.27-3.32 1.81-5.01l-77.4-140.97-.23-.42L1095 665.6l-91.11-158.11 41.21-20 46.21 54.43-21.93 20.01 24.36-17.15 61.33 70.67-2.56-7.62-100.09-117.89 13.03-24.37-15.55 21.4-36.81-43.36 23.06-18.83 15.03-31.62.06.03Zm-67.56-33.76 27.72-4.16-.73 1.35-.21.38-1.9 27.02-23.06-2.78-1.83-21.81h.01Zm-25.86 141.68-17.66-83.8.6.08 5.99-1.13 36.33 63.04 13.88 63.76-12.97 3.25-12.38-36.86-13.79-8.35v.01Zm-62.65-119.82-2.78-10.32 24.09-4.94-.82 8.46-20.03 7.98-.22-1.23-.23.04-.01.01Zm-28.56-50.38 27.69 15.3-5.96 20.82-27.04-1.65 5.31-34.46v-.01Zm-9.32 34.22-62.7-3.83 33.03-17.44 2.68-33.01 32.58 18-5.59 36.28Zm66.84-8.4 13.79-4.63 10.36 19.46-24.15-14.83Zm23.84 19.33-17.55 8.35 6.5-15.13 11.05 6.78Zm-14.49-8.9-7.22 16.8-6.67-8.65 1.39-14.25.1.12.11-1.56 12.29 7.54Zm-16.6-5.3-24.33 4.98 3.63-12.69 21.09 3.69-.39 4.02Zm-19.59-11.57 1.19-4.17 4.44-6.13 11.37 13.27-17-2.98v.01Zm-1.21-7.67-25.03-13.83-1.51-19.29 30.24 28-3.71 5.12h.01Zm20.78 35.7 7.61 9.88-15.48 18.94-5.07-5.75-6.88-15.17 19.81-7.9h.01Zm10.15 13.09 17.14 21.28-3.49.66-28.35-3.95 14.71-17.99h-.01Zm8.94 25.32 18.31 86.91 14.02 8.49 11.82 35.18-46.67 11.71-5.17-143.36 7.68 1.07h.01Zm14.76-1.6 22.53-12.32 24.21 28.52-23.57 24.01-23.17-40.21Zm-2.17-3.37-18.37-22.81 22.97-10.92 27.53 5.47-6.76 14.4-25.36 13.86h-.01Zm5.66-37.6-.31-.57 21.24-28.6 4.42 13.15 1.79 21.41-27.15-5.39h.01Zm19.39-33.8-21.77 29.31-10.18-19.12 30.44-14.71 1.52 4.52h-.01Zm-28.45-13.4 1.82.96.42-.8 20.42 6.34-29.67 14.34-4.48 1.51 2.71-20.84 8.78-1.51Zm-27.65-31.64 13.67-.32 2.19-94.51 10.73.04 33.07-72.95-13.65 84.96-30.42 112.45-10.02 1.73-5.57-31.39v-.01Zm5.82 35.4 8.93-1.54-2.81 21.54-7.78 2.61 1.66-22.62v.01Zm-4.11 1.39-1.4 19.1-11.7-13.65 13.1-5.45Zm-11.16.31-5.42 2.25-37.91-35.1 15.68-21.1 27.66 53.95h-.01Zm-89.64-63.81-38.31-64.74 51.15 31.72 21.41-11.22 25.7 50.13-16.6 22.34-17.96-16.63-25.39-11.61v.01Zm13.94 10.77 9.21 4.21 23.67 21.91 1.64 20.98-52.35-28.93 17.83-18.17Zm-161.48-6.37-42.09-101.97 111.25 89.88.14.11 86.3 47.69-2.65 32.62-36.9 19.48-10.9-.67-132.03-18.89 26.88-68.25Zm135.28 124.52h-.07l-102.94 26.38-57.52-78.37 129.9 18.59 112.74 6.9 2.96 10.98-85.07 15.52Zm59.01-6.7 27.34-4.99 3.96 8.73-31.52 12.27.23-16.01h-.01Zm32.95 7.39 1.07 2.36-56.51 56.66-22.49-28.68 77.93-30.34ZM781.16 518.89l-44.39-55.02 60.54-26.42 18.96-7.38 23.53 30.02-58.65 58.8h.01Zm44.64-39.09 75.34-75.54 5.81 6.59-15.83 49.04-25.65-14.08 24.47 17.76-39.86 123.51-24.26-107.28h-.02Zm54 28.17c11.08 13.16 22.46 27.23 24.28 30.49-.38 2.03-.33 6.71 0 18.2.18 6.19.46 13.98.84 23.23l-18.21-28.76-24.72 12.02 17.81-55.17v-.01Zm-11.94 345.78-54.61-27.29 16.91-64.7 45.54 47.47-7.83 44.52h-.01Zm8.69-49.4-45.21-47.13 18.46-70.63 41 36.76-14.25 81ZM829.69 663.2l30.6-94.79 24.95-12.13 20.01 31.61c.11 2.54.22 5.16.34 7.88 1.18 26.71 2.56 53.69 2.71 56.46l-12.61 70.15-66-59.17v-.01Zm106.95 95.88-37.45-33.57 13.13-73.03v-.23c-2.24-43.12-5.24-108.79-4.33-112.99-.05.24-.37.94-1.2 1.22l1.35-1.43c.36-1.29.6-2.14-13.79-19.78-5.53-6.77-11.15-13.47-13.1-15.78l29.15-90.32 13.84 1.93 12.4 343.99v-.01Zm58.92-107.19-56.45 64.46-3.35-92.86 28.39 16.56h27.44l3.97 11.83v.01Zm3.59-1.85-4.69-13.97h-29.23l-29.64-17.31-2.01-55.66 64.23-16.12 21.55 99.02-20.21 4.04Zm92.68 18 .23.4 42.37 28.64 32.49 59.17-130.62-26.35-1.78-32.93v-.16l-15.93-73.15 33.13-25.24 40.11 69.61v.01Zm-42.12-73.11-32.05 24.42-28-128.62 60.05 104.2Zm-32.96-140.87-16.32 14.96 18.69-12.16 23.36 27.52-40.54 19.68-26-45.11 24.09-24.55 16.7 19.67.02-.01Zm-6.19-13.47-33.73-39.73.14-.08 7.35-15.65 62.73 7.56-14.07 29.59-22.42 18.31Z"
            }),
            (0, $4vwom.jsx)("path", {
                fill: "url(#H)",
                d: "m797.021 117.589-81.011 27.216c-9.46 3.178-14.552 13.423-11.374 22.883 3.178 9.461 13.423 14.553 22.884 11.375l81.01-27.216c9.46-3.178 14.553-13.423 11.375-22.884-3.179-9.46-13.424-14.552-22.884-11.374Z"
            }),
            (0, $4vwom.jsx)("path", {
                fill: "#9964DF",
                d: "M803.94 139.99a5.65 5.65 0 1 0-.001-11.301 5.65 5.65 0 0 0 .001 11.301Z"
            }),
            (0, $4vwom.jsx)("path", {
                fill: "#fff",
                d: "m921.38 417.41 13.18-26.51 26.51 13.18 17.81-35.82-26.51-13.18 13.18-26.51-35.82-17.8-13.18 26.51-26.51-13.18-17.8 35.82 26.51 13.18-13.18 26.51 35.82 17.8h-.01Zm-162.83 54.7 13.18-26.51 26.51 13.18 17.8-35.82-26.51-13.18 13.18-26.51-35.82-17.8-13.18 26.51-26.51-13.18-17.8 35.82 26.51 13.18-13.18 26.51 35.82 17.8Zm159.83 140.33c-.14.05-.3.1-.45.15-75.92 25.7-109.61 87.75-118.12 106.15l36.3 16.8c6.82-14.75 33.82-64.47 94.65-85.06l.36-.12c61.07-20.52 112.76 2.88 127.16 10.55l18.8-35.31c-17.98-9.57-82.47-38.77-158.7-13.16Z"
            }),
            (0, $4vwom.jsx)("path", {
                fill: "#F6F6F6",
                d: "M1069.93 622.03c-1.88-.88-3.95-1.82-6.23-2.79l8.71 15.11 2.22-4.16-4.7-8.16ZM831.77 670.44l14.67 13.15-13.22 50.61 2.89 1.34c.52-1.13 1.18-2.48 1.94-3.99l11.75-44.95 11.71 10.5c.87-.99 1.76-1.98 2.67-2.98l-29.73-26.65c-.91.99-1.8 1.99-2.67 2.98l-.01-.01ZM1023.82 647.69l-5.23-24.02 18.17-13.84c-1.6-.44-3.24-.87-4.9-1.29l-14.2 10.82-3.14-14.43c-1.39-.23-2.81-.45-4.24-.65l9.08 41.73-1.37.27c1.99.45 3.94.92 5.83 1.41ZM908.3 652.23l-1.56 8.68c1.47-.79 2.96-1.56 4.48-2.31l1.1-6.12v-.23c-.6-11.28-1.23-24.11-1.84-36.97-1.32.51-2.63 1.03-3.92 1.56.87 18.37 1.64 33.37 1.74 35.39ZM937.41 324.23l2.3-8.49-3.65-1.82-2.99 11.05-10.02 1.73-.33-1.86-3.63 7.31.11-.04-1.4 19.1-11.7-13.65 5.99-2.49-4.75-2.36-4.72 1.96-10.06-9.31-2.52-1.25-1.49 2.99 11.24 10.4-3.71 5.12-11.96-6.61-1.78 3.59 11.96 6.61-5.96 20.82-2.08-.13 7.58 3.77 22.64-4.64-.82 8.46-20.03 7.98-.22-1.23-.23.04-.18-.65-2.6 5.22.09-.02 3.96 8.73-10.39 4.04-.49 1 3.94 1.96 8.6-3.35 1.07 2.36-3.86 3.87 3.78 1.88 2.05-2.06 4.83 5.48 7.83 3.89 8.85 1.23 1.88-3.78-12.21-1.7 14.71-17.99 4.51 5.6 1.96-3.94-3.31-4.11 22.97-10.92 19 3.77 1.85-3.71-19.78-3.93-.31-.57 9.62-12.95-3.64-1.81-8.06 10.86-10.18-19.12 17.09-8.26 2.91-5.85-23.49 11.36-4.48 1.51 2.71-20.84 8.78-1.51 1.82.96.42-.8 16.35 5.08 1.8-3.62-.07-.03-.87-.27.13-.1-3.98-1.98-.81.63-10.65-3.31 1.26-2.39-3.58-1.78-1.88 3.56-7.67 1.32-.05-.01Zm-38.93 21.89 4.44-6.13 11.37 13.27-17-2.98 1.19-4.17v.01Zm-5.93 20.73 3.63-12.69 21.09 3.69-.39 4.02-24.33 4.98Zm16.44 40.28-5.07-5.75-6.88-15.17 19.81-7.9 7.61 9.88-15.48 18.94h.01Zm17.27-23.17-6.67-8.65 1.39-14.25.1.12.11-1.56 12.29 7.54-7.22 16.8Zm4.16.44 6.5-15.13 11.05 6.78-17.55 8.35Zm7.5-32.31 10.36 19.46-24.15-14.83 13.79-4.63Zm-8.49-1.36-7.78 2.61 1.66-22.62 8.93-1.54-2.81 21.54v.01ZM936.66 648.6l-.91-25.11 28.39 16.56h27.44l.82 2.47c1.46.1 2.91.22 4.34.35l-2.29-6.81h-29.23l-29.64-17.31-.4-11.16c-1.32.32-2.64.65-3.97 1l1.49 41.25c1.32-.43 2.64-.86 3.96-1.25v.01ZM769.82 449.45l1.91-3.84 3.22 1.6 22.36-9.76 14.29-5.56 2.65-5.32-18.46 7.19-60.92 26.58 4.67 2.32 30.28-13.21ZM794.09 400.61l-74.49 19.08 5.48 2.73 66.66-17.08 2.35-4.73Z"
            }),
            (0, $4vwom.jsxs)("defs", {
                children: [
                    (0, $4vwom.jsxs)("linearGradient", {
                        id: "f",
                        x1: 857.44,
                        x2: 857.44,
                        y1: 911.77,
                        y2: 1040.54,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            (0, $4vwom.jsx)("stop", {
                                stopColor: "#E3D0F9"
                            }),
                            (0, $4vwom.jsx)("stop", {
                                offset: 1,
                                stopColor: "#CAABF0"
                            })
                        ]
                    }),
                    (0, $4vwom.jsxs)("linearGradient", {
                        id: "g",
                        x1: 741.96,
                        x2: 741.96,
                        y1: 881.54,
                        y2: 1010.31,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            (0, $4vwom.jsx)("stop", {
                                stopColor: "#E3D0F9"
                            }),
                            (0, $4vwom.jsx)("stop", {
                                offset: 1,
                                stopColor: "#CAABF0"
                            })
                        ]
                    }),
                    (0, $4vwom.jsxs)("linearGradient", {
                        id: "h",
                        x1: 1166.9,
                        x2: 1166.9,
                        y1: 911.771,
                        y2: 1040.54,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            (0, $4vwom.jsx)("stop", {
                                stopColor: "#E3D0F9"
                            }),
                            (0, $4vwom.jsx)("stop", {
                                offset: 1,
                                stopColor: "#CAABF0"
                            })
                        ]
                    }),
                    (0, $4vwom.jsxs)("linearGradient", {
                        id: "i",
                        x1: 1529.76,
                        x2: 1529.76,
                        y1: 932.661,
                        y2: 1061.42,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            (0, $4vwom.jsx)("stop", {
                                stopColor: "#E3D0F9"
                            }),
                            (0, $4vwom.jsx)("stop", {
                                offset: 1,
                                stopColor: "#CAABF0"
                            })
                        ]
                    }),
                    (0, $4vwom.jsxs)("linearGradient", {
                        id: "j",
                        x1: 1229.49,
                        x2: 1229.49,
                        y1: 896.24,
                        y2: 960.62,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            (0, $4vwom.jsx)("stop", {
                                stopColor: "#E3D0F9"
                            }),
                            (0, $4vwom.jsx)("stop", {
                                offset: 1,
                                stopColor: "#CAABF0"
                            })
                        ]
                    }),
                    (0, $4vwom.jsxs)("linearGradient", {
                        id: "k",
                        x1: 1412.26,
                        x2: 1412.26,
                        y1: 896.24,
                        y2: 960.62,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            (0, $4vwom.jsx)("stop", {
                                stopColor: "#E3D0F9"
                            }),
                            (0, $4vwom.jsx)("stop", {
                                offset: 1,
                                stopColor: "#CAABF0"
                            })
                        ]
                    }),
                    (0, $4vwom.jsxs)("linearGradient", {
                        id: "l",
                        x1: 1653.82,
                        x2: 1653.82,
                        y1: 903.199,
                        y2: 967.58,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            (0, $4vwom.jsx)("stop", {
                                stopColor: "#E3D0F9"
                            }),
                            (0, $4vwom.jsx)("stop", {
                                offset: 1,
                                stopColor: "#CAABF0"
                            })
                        ]
                    }),
                    (0, $4vwom.jsxs)("linearGradient", {
                        id: "m",
                        x1: 1786.73,
                        x2: 1786.73,
                        y1: 920.28,
                        y2: 984.66,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            (0, $4vwom.jsx)("stop", {
                                stopColor: "#E3D0F9"
                            }),
                            (0, $4vwom.jsx)("stop", {
                                offset: 1,
                                stopColor: "#CAABF0"
                            })
                        ]
                    }),
                    (0, $4vwom.jsxs)("linearGradient", {
                        id: "n",
                        x1: 1054.52,
                        x2: 1054.52,
                        y1: 911.77,
                        y2: 1040.54,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            (0, $4vwom.jsx)("stop", {
                                stopColor: "#E3D0F9"
                            }),
                            (0, $4vwom.jsx)("stop", {
                                offset: 1,
                                stopColor: "#CAABF0"
                            })
                        ]
                    }),
                    (0, $4vwom.jsxs)("linearGradient", {
                        id: "o",
                        x1: 905.96,
                        x2: 905.96,
                        y1: 911.77,
                        y2: 1040.54,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            (0, $4vwom.jsx)("stop", {
                                stopColor: "#E3D0F9"
                            }),
                            (0, $4vwom.jsx)("stop", {
                                offset: 1,
                                stopColor: "#CAABF0"
                            })
                        ]
                    }),
                    (0, $4vwom.jsxs)("linearGradient", {
                        id: "p",
                        x1: 630.8,
                        x2: 630.8,
                        y1: 911.77,
                        y2: 1040.54,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            (0, $4vwom.jsx)("stop", {
                                stopColor: "#E3D0F9"
                            }),
                            (0, $4vwom.jsx)("stop", {
                                offset: 1,
                                stopColor: "#CAABF0"
                            })
                        ]
                    }),
                    (0, $4vwom.jsxs)("linearGradient", {
                        id: "q",
                        x1: 210.43,
                        x2: 210.43,
                        y1: 911.77,
                        y2: 1040.54,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            (0, $4vwom.jsx)("stop", {
                                stopColor: "#E3D0F9"
                            }),
                            (0, $4vwom.jsx)("stop", {
                                offset: 1,
                                stopColor: "#CAABF0"
                            })
                        ]
                    }),
                    (0, $4vwom.jsxs)("linearGradient", {
                        id: "r",
                        x1: 79.74,
                        x2: 79.74,
                        y1: 983.77,
                        y2: 1112.54,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            (0, $4vwom.jsx)("stop", {
                                stopColor: "#E3D0F9"
                            }),
                            (0, $4vwom.jsx)("stop", {
                                offset: 1,
                                stopColor: "#CAABF0"
                            })
                        ]
                    }),
                    (0, $4vwom.jsxs)("linearGradient", {
                        id: "s",
                        x1: 19.39,
                        x2: 19.39,
                        y1: 919.36,
                        y2: 1015.47,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            (0, $4vwom.jsx)("stop", {
                                stopColor: "#E3D0F9"
                            }),
                            (0, $4vwom.jsx)("stop", {
                                offset: 1,
                                stopColor: "#CAABF0"
                            })
                        ]
                    }),
                    (0, $4vwom.jsxs)("linearGradient", {
                        id: "t",
                        x1: 350.87,
                        x2: 350.87,
                        y1: 937.93,
                        y2: 1024.4,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            (0, $4vwom.jsx)("stop", {
                                stopColor: "#E3D0F9"
                            }),
                            (0, $4vwom.jsx)("stop", {
                                offset: 1,
                                stopColor: "#CAABF0"
                            })
                        ]
                    }),
                    (0, $4vwom.jsxs)("linearGradient", {
                        id: "u",
                        x1: 665.44,
                        x2: 665.44,
                        y1: 911.77,
                        y2: 1040.54,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            (0, $4vwom.jsx)("stop", {
                                stopColor: "#E3D0F9"
                            }),
                            (0, $4vwom.jsx)("stop", {
                                offset: 1,
                                stopColor: "#CAABF0"
                            })
                        ]
                    }),
                    (0, $4vwom.jsxs)("linearGradient", {
                        id: "v",
                        x1: 996.78,
                        x2: 996.78,
                        y1: 911.77,
                        y2: 1040.54,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            (0, $4vwom.jsx)("stop", {
                                stopColor: "#E3D0F9"
                            }),
                            (0, $4vwom.jsx)("stop", {
                                offset: 1,
                                stopColor: "#CAABF0"
                            })
                        ]
                    }),
                    (0, $4vwom.jsxs)("linearGradient", {
                        id: "w",
                        x1: 1157.72,
                        x2: 1157.72,
                        y1: 911.769,
                        y2: 1040.54,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            (0, $4vwom.jsx)("stop", {
                                stopColor: "#E3D0F9"
                            }),
                            (0, $4vwom.jsx)("stop", {
                                offset: 1,
                                stopColor: "#CAABF0"
                            })
                        ]
                    }),
                    (0, $4vwom.jsxs)("linearGradient", {
                        id: "x",
                        x1: 1317.96,
                        x2: 1317.96,
                        y1: 911.77,
                        y2: 1040.54,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            (0, $4vwom.jsx)("stop", {
                                stopColor: "#E3D0F9"
                            }),
                            (0, $4vwom.jsx)("stop", {
                                offset: 1,
                                stopColor: "#CAABF0"
                            })
                        ]
                    }),
                    (0, $4vwom.jsxs)("linearGradient", {
                        id: "y",
                        x1: 573.39,
                        x2: 573.39,
                        y1: 911.771,
                        y2: 1040.54,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            (0, $4vwom.jsx)("stop", {
                                stopColor: "#E3D0F9"
                            }),
                            (0, $4vwom.jsx)("stop", {
                                offset: 1,
                                stopColor: "#CAABF0"
                            })
                        ]
                    }),
                    (0, $4vwom.jsxs)("linearGradient", {
                        id: "z",
                        x1: 1440.7,
                        x2: 1440.7,
                        y1: -858.58,
                        y2: 472.99,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            (0, $4vwom.jsx)("stop", {
                                stopColor: "#D6BDF4"
                            }),
                            (0, $4vwom.jsx)("stop", {
                                offset: 1,
                                stopColor: "#B087E9"
                            })
                        ]
                    }),
                    (0, $4vwom.jsxs)("linearGradient", {
                        id: "A",
                        x1: 1805.7,
                        x2: 1378.78,
                        y1: 889.87,
                        y2: 392.93,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            (0, $4vwom.jsx)("stop", {
                                stopColor: "#A776E5"
                            }),
                            (0, $4vwom.jsx)("stop", {
                                offset: 1,
                                stopColor: "#B489EA"
                            })
                        ]
                    }),
                    (0, $4vwom.jsxs)("linearGradient", {
                        id: "E",
                        x1: 193.05,
                        x2: 586.09,
                        y1: 259.45,
                        y2: 769.94,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            (0, $4vwom.jsx)("stop", {
                                stopColor: "#D8BFF6"
                            }),
                            (0, $4vwom.jsx)("stop", {
                                offset: 1,
                                stopColor: "#B087E9"
                            })
                        ]
                    }),
                    (0, $4vwom.jsxs)("linearGradient", {
                        id: "F",
                        x1: 971.436,
                        x2: 833.865,
                        y1: 63.871,
                        y2: 792.783,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            (0, $4vwom.jsx)("stop", {
                                stopColor: "#D6BDF4"
                            }),
                            (0, $4vwom.jsx)("stop", {
                                offset: 1,
                                stopColor: "#B087E9"
                            })
                        ]
                    }),
                    (0, $4vwom.jsxs)("linearGradient", {
                        id: "H",
                        x1: 854.248,
                        x2: 667.761,
                        y1: 117.425,
                        y2: 180.077,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            (0, $4vwom.jsx)("stop", {
                                stopColor: "#B489EA"
                            }),
                            (0, $4vwom.jsx)("stop", {
                                offset: 1,
                                stopColor: "#9B64E1"
                            })
                        ]
                    }),
                    (0, $4vwom.jsxs)("radialGradient", {
                        id: "a",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "matrix(302.497 0 0 41.855 1539.79 985.001)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            (0, $4vwom.jsx)("stop", {
                                stopColor: "#E9E4E0"
                            }),
                            (0, $4vwom.jsx)("stop", {
                                offset: 0.7,
                                stopColor: "#E9E4E0",
                                stopOpacity: 0.03
                            }),
                            (0, $4vwom.jsx)("stop", {
                                offset: 1,
                                stopColor: "#E9E4E0",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    (0, $4vwom.jsxs)("radialGradient", {
                        id: "b",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "matrix(213.954 0 0 10.4137 1508.18 979.989)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            (0, $4vwom.jsx)("stop", {
                                stopColor: "#DAD3CF"
                            }),
                            (0, $4vwom.jsx)("stop", {
                                offset: 1,
                                stopColor: "#E9E4E0",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    (0, $4vwom.jsxs)("radialGradient", {
                        id: "c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "matrix(213.954 0 0 10.4137 1508.18 979.989)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            (0, $4vwom.jsx)("stop", {
                                stopColor: "#E9E4E0"
                            }),
                            (0, $4vwom.jsx)("stop", {
                                offset: 0.7,
                                stopColor: "#E9E4E0",
                                stopOpacity: 0.03
                            }),
                            (0, $4vwom.jsx)("stop", {
                                offset: 1,
                                stopColor: "#E9E4E0",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    (0, $4vwom.jsxs)("radialGradient", {
                        id: "d",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "matrix(429.965 0 0 41.855 930.862 817.04)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            (0, $4vwom.jsx)("stop", {
                                stopColor: "#E9E4E0"
                            }),
                            (0, $4vwom.jsx)("stop", {
                                offset: 0.7,
                                stopColor: "#E9E4E0",
                                stopOpacity: 0.03
                            }),
                            (0, $4vwom.jsx)("stop", {
                                offset: 1,
                                stopColor: "#E9E4E0",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    (0, $4vwom.jsxs)("radialGradient", {
                        id: "e",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "matrix(302.498 0 0 41.855 482.756 817.04)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            (0, $4vwom.jsx)("stop", {
                                stopColor: "#E9E4E0"
                            }),
                            (0, $4vwom.jsx)("stop", {
                                offset: 0.7,
                                stopColor: "#E9E4E0",
                                stopOpacity: 0.03
                            }),
                            (0, $4vwom.jsx)("stop", {
                                offset: 1,
                                stopColor: "#E9E4E0",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    (0, $4vwom.jsxs)("radialGradient", {
                        id: "B",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "matrix(213.954 0 0 10.4137 874.339 979.989)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            (0, $4vwom.jsx)("stop", {
                                stopColor: "#DAD3CF"
                            }),
                            (0, $4vwom.jsx)("stop", {
                                offset: 1,
                                stopColor: "#E9E4E0",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    (0, $4vwom.jsxs)("radialGradient", {
                        id: "C",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "matrix(213.954 0 0 10.4137 497.8 979.989)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            (0, $4vwom.jsx)("stop", {
                                stopColor: "#E9E4E0"
                            }),
                            (0, $4vwom.jsx)("stop", {
                                offset: 1,
                                stopColor: "#E9E4E0",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    (0, $4vwom.jsxs)("radialGradient", {
                        id: "D",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "matrix(213.954 0 0 10.4137 497.8 889.415)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            (0, $4vwom.jsx)("stop", {
                                stopColor: "#DAD3CF"
                            }),
                            (0, $4vwom.jsx)("stop", {
                                offset: 1,
                                stopColor: "#E9E4E0",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    (0, $4vwom.jsxs)("radialGradient", {
                        id: "G",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(-18.57 1571.958 -2650.385) scale(304.52)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            (0, $4vwom.jsx)("stop", {
                                stopColor: "#CAABF0"
                            }),
                            (0, $4vwom.jsx)("stop", {
                                offset: 1,
                                stopColor: "#fff",
                                stopOpacity: 0
                            })
                        ]
                    })
                ]
            })
        ]
    }));



var $dUDPg = parcelRequire("dUDPg");

var $4vwom = parcelRequire("4vwom");

var $aIeEI = parcelRequire("aIeEI");

var $34lt5 = parcelRequire("34lt5");
const $b86e57b36afa5734$var$businessUnitId = "672c896cd556aafe9ee4561a";
const $b86e57b36afa5734$var$widgets = {
    microStar: {
        templateId: "5419b732fbfb950b10de65e5",
        token: "271f0e22-8400-4783-bce4-0b6d900f0364",
        height: 24,
        width: "100%"
    },
    microTrustScore: {
        templateId: "5419b637fa0340045cd0c936",
        token: "ffc087ab-6c6f-4141-a447-3d1b97e369ad",
        height: 20,
        width: "100%"
    },
    microCombo: {
        templateId: "5419b6ffb0d04a076446a9af",
        token: "be0db333-f466-4e29-8912-665aad087f0e",
        height: 20,
        width: "100%"
    },
    horizontal: {
        templateId: "5406e65db0d04a09e042d5fc",
        token: "08161f74-8a5d-4e9c-98e5-b718063bf179",
        height: 28,
        width: "100%"
    },
    carousel: {
        templateId: "53aa8912dec7e10d38f59f36",
        token: "21fdcf85-ae85-41af-bd20-a8eb5175590e",
        height: 140,
        width: "100%"
    },
    mini: {
        templateId: "53aa8807dec7e10d38f59f32",
        token: "a234dfee-cbb1-401a-9ae8-c4c5f0bbfe79",
        height: 100,
        width: 150
    },
    grid: {
        templateId: "539adbd6dec7e10e686debee",
        token: "e340a0d0-dbf9-4b88-b26c-7750702a69a9",
        height: 500,
        width: "100%"
    }
};
function $b86e57b36afa5734$export$2ab84a49a8797035(props) {
    var _a, _b;
    const locale = (0, $aIeEI.useCurrentLocale)();
    const widget = $b86e57b36afa5734$var$widgets[props.widget];
    const h = (_a = props.height) !== null && _a !== void 0 ? _a : widget.height;
    const w = (_b = props.width) !== null && _b !== void 0 ? _b : widget.width;
    return (0, $4vwom.jsx)("div", {
        style: props.style,
        className: "trustpilot-widget",
        "data-locale": locale === (0, $34lt5.LocaleKey)("no") ? "nb-NO" : "en-GB",
        "data-businessunit-id": $b86e57b36afa5734$var$businessUnitId,
        "data-style-height": typeof h === "number" ? `${h}px` : h,
        "data-style-width": typeof w === "number" ? `${w}px` : w,
        "data-template-id": widget.templateId,
        "data-token": widget.token,
        "data-stars": props.widget === "carousel" || props.widget === "grid" ? props.stars ? props.stars.join(",") : "1,2,3,4,5" : undefined,
        children: (0, $4vwom.jsx)("a", {
            href: "https://no.trustpilot.com/review/redoit.no",
            target: "_blank",
            rel: "noopener",
            children: "Trustpilot"
        })
    });
}



function $047f6f355e30d7d1$var$useCurrentPhoneOffer() {
    return (0, $eK8Q4.useSessionState)("offer", undefined);
}
function $047f6f355e30d7d1$export$5b1a6a2d762c097c() {
    return (0, $eK8Q4.useSessionState)("currentPhoneOfferOptions", undefined);
}
function $047f6f355e30d7d1$export$d42da32bb85d5739() {
    return (0, $eK8Q4.useSessionState)("checkoutTradeInForm", undefined);
}
function $047f6f355e30d7d1$export$b7eadabbf1e81c9b() {
    return (0, $eK8Q4.useSessionState)("checkoutTradeInPriceRequest", undefined);
}
function $047f6f355e30d7d1$export$db65bad7d1fa5d6f() {
    return (0, $eK8Q4.useSessionState)("checkoutTradeInResult", undefined);
}
function $047f6f355e30d7d1$var$useCurrentShippingOption() {
    return (0, $eK8Q4.useSessionState)("shippingOption", undefined);
}
function $047f6f355e30d7d1$export$745963d6dc3bf932() {
    return (0, $eK8Q4.useSessionState)("checkoutDiscountState", undefined);
}
function $047f6f355e30d7d1$export$4a755370e8335b36() {
    return (0, $eK8Q4.useSessionState)("checkoutShippingState", {
        options: [],
        selectedOption: undefined,
        form: undefined
    });
}
function $047f6f355e30d7d1$export$7643def88ccd06be() {
    return (0, $eK8Q4.useSessionState)("checkoutState", {
        id: (0, $dAwef.Uuid)(),
        currentStep: "TradeIn",
        availableSteps: [],
        marketingAccepted: false,
        termsAccepted: false
    });
}
/**
 * Used to store whether or not user need to log in during checkout flow. Is set based on
 * login state when the checkout flow is entered.
 */ function $047f6f355e30d7d1$var$useCheckoutSkipAuthStep() {
    return (0, $eK8Q4.useSessionState)("checkoutSkipAuthStep", undefined);
}
function $047f6f355e30d7d1$export$aed04c9c9fee3492() {
    return (0, $eK8Q4.useSessionState)("checkoutCalculatedOrderPrice", undefined);
}
function $047f6f355e30d7d1$export$800784442c3f48f8() {
    const [offer, setOffer] = $047f6f355e30d7d1$var$useCurrentPhoneOffer();
    const [, setShippingOption] = $047f6f355e30d7d1$var$useCurrentShippingOption();
    const [, setCheckoutState] = $047f6f355e30d7d1$export$7643def88ccd06be();
    const [, setCurrentTradeInStep] = (0, $eK8Q4.useSessionState)("tradein-modal-step", undefined);
    const id = (0, $dAwef.Uuid)();
    const [, setTradeInResponses] = (0, $eK8Q4.useSessionState)("tradein-responses", []);
    const [, setTradeInResult] = (0, $eK8Q4.useSessionState)("tradein-result", undefined);
    const [, setTradeInModalOpen] = (0, $eK8Q4.useSessionState)("tradein-modal-open", false);
    const [, setSkipAuthStep] = $047f6f355e30d7d1$var$useCheckoutSkipAuthStep();
    const [, setShippingState] = $047f6f355e30d7d1$export$4a755370e8335b36();
    const [, setCheckoutTradeInForm] = $047f6f355e30d7d1$export$d42da32bb85d5739();
    const [, setCheckoutTradeInPriceRequest] = $047f6f355e30d7d1$export$b7eadabbf1e81c9b();
    const [, setCheckoutTradeInResult] = $047f6f355e30d7d1$export$db65bad7d1fa5d6f();
    const [, , resetConsents] = $047f6f355e30d7d1$export$5a952ffba9a79dc5();
    const [, setCheckoutDiscount] = $047f6f355e30d7d1$export$745963d6dc3bf932();
    return [
        offer,
        (phoneOffer)=>{
            setCheckoutState({
                id: id,
                currentStep: "TradeIn",
                availableSteps: [
                    "TradeIn"
                ],
                marketingAccepted: false,
                termsAccepted: false
            });
            setOffer(phoneOffer);
            setShippingState({});
            setCurrentTradeInStep(0);
            setTradeInResponses([]);
            setTradeInResult(undefined);
            setTradeInModalOpen(false);
            setShippingOption(undefined);
            setSkipAuthStep(undefined);
            setCheckoutTradeInForm(undefined);
            setCheckoutTradeInPriceRequest(undefined);
            setCheckoutTradeInResult(undefined);
            setCheckoutDiscount(undefined);
            resetConsents();
        }
    ];
}
function $047f6f355e30d7d1$export$5a952ffba9a79dc5() {
    const [consents, setConsents] = (0, $eK8Q4.useSessionState)("checkout-consents", {
        marketing: {
            consentGiven: false,
            preConsented: undefined
        }
    });
    const getFromUser = (0, $eeH7J.useCallback)(()=>{
        if (consents.marketing.preConsented === undefined) (0, $e18f565b44c7bc7d$export$dd7946daa6163e94)().then((result)=>{
            setConsents({
                marketing: {
                    consentGiven: !!result.marketingConsent,
                    preConsented: !!result.marketingConsent
                }
            });
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, $eeH7J.useEffect)(()=>{
        getFromUser();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return [
        consents,
        (val)=>{
            setConsents(val);
            (0, $e18f565b44c7bc7d$export$97519be7b2793f54)({
                consent: val.marketing.consentGiven
            });
        },
        ()=>{
            setConsents({
                marketing: {
                    consentGiven: false,
                    preConsented: undefined
                }
            });
            getFromUser();
        }
    ];
}
function $047f6f355e30d7d1$export$cba61477bceac75() {
    const [order, setOrder] = (0, $eK8Q4.useSessionState)("CheckoutOrder", undefined);
    const [errorMessage, setErrorMessage] = (0, $eeH7J.useState)();
    const [isLoading, setIsLoading] = (0, $eeH7J.useState)(false);
    const ensureOrder = (0, $eeH7J.useCallback)(async (orderRequest)=>{
        if (isLoading) return;
        setIsLoading(true);
        // If the phone is unchanged, check if current order exists. If the order doesn't
        // exist anymore, or we want an order for a different phone, we'll try to create
        // a new order below.
        if (order && order.phone.id === orderRequest.phone.id) try {
            const o = await (0, $e18f565b44c7bc7d$export$b2d4561583563d44)(order.id);
            setOrder(o);
            setIsLoading(false);
            return;
        } catch (err) {
        // Order does not exist any more and is expired, will try to create new one
        // below, so no further error handling is needed.
        }
        // Create new order, based on the config.
        try {
            const postOrderResult = await (0, $e18f565b44c7bc7d$export$6cb3fb5ed3274c4c)(orderRequest);
            const getOrderResult = await (0, $e18f565b44c7bc7d$export$b2d4561583563d44)(postOrderResult.id);
            if (getOrderResult.id !== (order === null || order === void 0 ? void 0 : order.id)) setOrder(getOrderResult);
        } catch (err) {
            // eslint-disable-next-line no-console
            console.error(err);
            setErrorMessage(JSON.stringify(err));
            throw err;
        } finally{
            setIsLoading(false);
        }
    }, [
        isLoading,
        order,
        setOrder
    ]);
    const deleteOrder = (0, $eeH7J.useCallback)(async ()=>{
        if (order === null || order === void 0 ? void 0 : order.id) try {
            await (0, $e18f565b44c7bc7d$export$a2c4756bb6719a7)(order.id);
        } catch (err) {
        // If this fails it is most likely because of an order id that should not have been
        // set anyway. It was probably deleted server side because of reservation
        // expiration set in order settings. So no more handling than just unsetting the
        // order, which we'll also do if the request succeeds.
        } finally{
            setOrder(undefined);
        }
    }, [
        order === null || order === void 0 ? void 0 : order.id,
        setOrder
    ]);
    return {
        order: order,
        ensureOrder: ensureOrder,
        deleteOrder: deleteOrder,
        isLoading: isLoading,
        errorMessage: errorMessage,
        setOrder: setOrder
    };
}
function $047f6f355e30d7d1$var$Checkout(section) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
    const localize = (0, $aIeEI.useLocalize)();
    const [searchParams, setSearchParams] = (0, $5K1mb.useSearchParams)();
    const [phoneOfferOptions] = $047f6f355e30d7d1$export$5b1a6a2d762c097c();
    const tradeInForm = (0, $e18f565b44c7bc7d$export$f8778ca18805596d)("Phones");
    const webPageContext = (0, $eeH7J.useContext)((0, $9fe8ccb750b589bb$export$6245f31671de0b04));
    const formatAmount = (0, $b274814d74f89bd0$export$cd05f017078a61a8)();
    const localizeCurrency = (0, $b274814d74f89bd0$export$2daf9f30efa60400)();
    const [checkoutState, setCheckoutState] = $047f6f355e30d7d1$export$7643def88ccd06be();
    const [offer, setOffer] = $047f6f355e30d7d1$var$useCurrentPhoneOffer();
    const [checkoutTradeInForm, setCheckoutTradeInForm] = $047f6f355e30d7d1$export$d42da32bb85d5739();
    const [checkoutTradeInPriceRequest] = $047f6f355e30d7d1$export$b7eadabbf1e81c9b();
    const [checkoutTradeInResult] = $047f6f355e30d7d1$export$db65bad7d1fa5d6f();
    const [shipping, setShipping] = $047f6f355e30d7d1$export$4a755370e8335b36();
    const [checkoutShippingState] = $047f6f355e30d7d1$export$4a755370e8335b36();
    const [skipAuthStep, setSkipAuthStep] = $047f6f355e30d7d1$var$useCheckoutSkipAuthStep();
    const [checkoutDiscount, setCheckoutDiscount] = $047f6f355e30d7d1$export$745963d6dc3bf932();
    const [sessionDiscountCode, setSessionDiscountCode] = (0, $ca337ff74984d5af$export$a603663adc682cac)();
    const currentStep = (0, $eeH7J.useMemo)(()=>checkoutState.currentStep, [
        checkoutState.currentStep
    ]);
    const setCurrentStep = (0, $eeH7J.useCallback)((s)=>{
        setCheckoutState(Object.assign(Object.assign({}, checkoutState), {
            currentStep: s
        }));
    }, [
        checkoutState,
        setCheckoutState
    ]);
    const me = (0, $e18f565b44c7bc7d$export$f637e1cf42d15a62)();
    // Need a way to determine if the page is rendered client side and checkout state should be
    // available, so that an error can be presented if checkout state is missing.
    const [offerShouldBeLoaded, setOfferShouldBeLoaded] = (0, $eeH7J.useState)(false);
    (0, $eeH7J.useEffect)(()=>{
        setOfferShouldBeLoaded(true);
    }, []);
    const { order: order, ensureOrder: ensureOrder, deleteOrder: deleteOrder, isLoading: isLoading, errorMessage: errorMessage, setOrder: setOrder } = $047f6f355e30d7d1$export$cba61477bceac75();
    // Don't request updated price if we have an order, as it will result in not found error.
    const price = (0, $e18f565b44c7bc7d$export$541c7c1cebe5b937)(offer && !(order === null || order === void 0 ? void 0 : order.id) ? {
        phone: offer,
        shippingType: (_a = shipping.selectedOption) === null || _a === void 0 ? void 0 : _a.type,
        shippingSlot: ((_b = shipping.selectedOption) === null || _b === void 0 ? void 0 : _b.type) === "Manual" ? (_c = shipping.selectedOption.selectedSlot) === null || _c === void 0 ? void 0 : _c.id : undefined,
        tradeIn: checkoutTradeInPriceRequest,
        discountId: checkoutDiscount === null || checkoutDiscount === void 0 ? void 0 : checkoutDiscount.id
    } : null);
    const [calculatedOrderPrice, setCalculatedOrderPrice] = $047f6f355e30d7d1$export$aed04c9c9fee3492();
    (0, $eeH7J.useEffect)(()=>{
        if (price.data && JSON.stringify(price.data) !== JSON.stringify(calculatedOrderPrice)) setCalculatedOrderPrice(price.data);
    }, [
        calculatedOrderPrice,
        price.data,
        setCalculatedOrderPrice
    ]);
    const currentStepBySearchParam = (0, $eeH7J.useMemo)(()=>{
        const stepParam = searchParams.get("s");
        const s = Object.keys((0, $c90be680bf4410a3$export$68c0e99bc234a4d)).find((k)=>{
            const stepProps = section[k];
            return localize(stepProps.slug) === stepParam;
        });
        return s;
    }, [
        localize,
        searchParams,
        section
    ]);
    // Sets the step search param "s" to the slug defined for the provided CheckoutStep.
    const setSearchParamStep = (0, $eeH7J.useCallback)((s, options)=>{
        const sp = Object.fromEntries(searchParams);
        delete sp.auth;
        setSearchParams(Object.assign(Object.assign({}, sp), {
            s: localize(section[s].slug)
        }), options);
    }, [
        localize,
        searchParams,
        section,
        setSearchParams
    ]);
    // If changing step to a different step than Payment, delete the order to be able
    // to modify it and get updated prices from usePhoneOrderPrice.
    (0, $eeH7J.useEffect)(()=>{
        if (currentStep !== "Payment" && (order === null || order === void 0 ? void 0 : order.id)) deleteOrder();
    }, [
        currentStep,
        deleteOrder,
        order === null || order === void 0 ? void 0 : order.id
    ]);
    const postAnalyticsCheckoutEvent = (0, $eeH7J.useCallback)(async (entity, data)=>{
        var _a, _b;
        (0, $dUDPg.postAnalyticsEvent)("checkout", {
            entity: entity,
            data: data
        }, // Override default Fuse Analytics session id with the current checkout id,
        // to get a unique Fuse Analytics session per checkout and not mixed with other
        // checkouts from same user during the same "user session".
        {
            "Fuse-Analytics-Session": (_b = (_a = checkoutState.id) === null || _a === void 0 ? void 0 : _a.valueOf()) !== null && _b !== void 0 ? _b : ""
        });
    }, [
        checkoutState.id
    ]);
    // It appears that it is a good idea to both set the step and update the search param, rather
    // than setting search param and relying on the effect to set current step by search param,
    // so use this function to set step.
    const setStep = (0, $eeH7J.useCallback)((s, options)=>{
        var _a, _b;
        setCurrentStep(s);
        setSearchParamStep(s, options);
        if (!checkoutState.availableSteps.includes(s)) setCheckoutState(Object.assign(Object.assign({}, checkoutState), {
            availableSteps: [
                ...checkoutState.availableSteps,
                s
            ]
        }));
        // Ensure page is scrolled to top after changing step.
        if (typeof window !== "undefined") window.scrollTo({
            top: 0,
            behavior: "instant"
        });
        postAnalyticsCheckoutEvent([
            "step",
            s.toLowerCase(),
            "enter"
        ], {
            userId: (_b = (_a = me.data) === null || _a === void 0 ? void 0 : _a.id) === null || _b === void 0 ? void 0 : _b.valueOf(),
            phoneId: offer === null || offer === void 0 ? void 0 : offer.id.valueOf(),
            rentalPeriod: offer === null || offer === void 0 ? void 0 : offer.rentalPeriod.toString()
        });
    }, [
        checkoutState,
        (_d = me.data) === null || _d === void 0 ? void 0 : _d.id,
        offer === null || offer === void 0 ? void 0 : offer.id,
        offer === null || offer === void 0 ? void 0 : offer.rentalPeriod,
        postAnalyticsCheckoutEvent,
        setCheckoutState,
        setCurrentStep,
        setSearchParamStep
    ]);
    // When first entering the checkout flow, the search param "s" might not be set. This effect
    // sets the param as a replacement, to ensure back button takes the user back to the previous
    // page and not checkout without the "s" search param.
    (0, $eeH7J.useEffect)(()=>{
        const auth = searchParams.get("auth");
        if (auth === "success") {
            postAnalyticsCheckoutEvent([
                "step",
                "login",
                "success"
            ]);
            setStep("Shipping");
        } else if (auth === "failed") {
            postAnalyticsCheckoutEvent([
                "step",
                "login",
                "failed"
            ]);
            setStep("Login");
        } else if (!currentStepBySearchParam && !webPageContext.isNavigating) setStep("TradeIn", {
            replace: true
        });
    }, [
        checkoutState.id,
        currentStepBySearchParam,
        postAnalyticsCheckoutEvent,
        searchParams,
        setStep,
        webPageContext.isNavigating
    ]);
    // Effect to keep current step up to date with the step defined by the step search param "s".
    (0, $eeH7J.useEffect)(()=>{
        if (currentStepBySearchParam && currentStepBySearchParam !== currentStep) setCurrentStep(currentStepBySearchParam);
    }, [
        currentStepBySearchParam,
        setCurrentStep,
        currentStep
    ]);
    (0, $eeH7J.useEffect)(()=>{
        if (skipAuthStep === undefined) {
            async function setSkipAuthIfLoggedIn() {
                const checkMe = await (0, $e18f565b44c7bc7d$export$dd7946daa6163e94)();
                setSkipAuthStep(checkMe.canSkipLoginInCheckout);
            }
            setSkipAuthIfLoggedIn();
        }
    }, [
        skipAuthStep,
        setSkipAuthStep
    ]);
    const insuranceOptions = (0, $e18f565b44c7bc7d$export$fd8b73cd610fc548)((_e = offer === null || offer === void 0 ? void 0 : offer.model) !== null && _e !== void 0 ? _e : null, (_f = offer === null || offer === void 0 ? void 0 : offer.storage) !== null && _f !== void 0 ? _f : null, (_g = offer === null || offer === void 0 ? void 0 : offer.color) !== null && _g !== void 0 ? _g : null, (_h = offer === null || offer === void 0 ? void 0 : offer.rentalPeriod) !== null && _h !== void 0 ? _h : null);
    const purchasedInsurance = (0, $eeH7J.useMemo)(()=>{
        var _a;
        return (offer === null || offer === void 0 ? void 0 : offer.insurance) ? (_a = insuranceOptions.data) === null || _a === void 0 ? void 0 : _a.find((io)=>io.id === offer.insurance) : null;
    }, [
        insuranceOptions.data,
        offer === null || offer === void 0 ? void 0 : offer.insurance
    ]);
    const deviceCheckoutCardInfoItems = (0, $eeH7J.useMemo)(()=>{
        var _a, _b, _c, _d;
        const infoItems = [];
        if (offer) {
            const ii = {
                id: "device",
                icon: "device",
                title: localize(offer.name),
                text: [
                    localize((_b = (_a = phoneOfferOptions === null || phoneOfferOptions === void 0 ? void 0 : phoneOfferOptions.colors.find((c)=>c.name === offer.color)) === null || _a === void 0 ? void 0 : _a.displayName) !== null && _b !== void 0 ? _b : {}),
                    localize((_d = (_c = phoneOfferOptions === null || phoneOfferOptions === void 0 ? void 0 : phoneOfferOptions.storageSizes.find((ss)=>ss.name === offer.storage)) === null || _c === void 0 ? void 0 : _c.displayName) !== null && _d !== void 0 ? _d : {}),
                    `${offer.rentalPeriod} ${localize({
                        no: "m\xe5neder",
                        en: "months"
                    })}`
                ].join(" \xb7 ")
            };
            infoItems.push(ii);
        }
        if (checkoutTradeInPriceRequest && checkoutTradeInResult) {
            const ii = {
                id: "trade-in",
                icon: "handCoins",
                title: (0, $87d2193cf0695c20$export$4493d2932fe76cf8)(localize(section.CheckoutDeviceCard.tradeInInfoItem.title), {
                    cashback: formatAmount(checkoutTradeInResult.value)
                }),
                text: (0, $87d2193cf0695c20$export$4493d2932fe76cf8)(localize(section.CheckoutDeviceCard.tradeInInfoItem.text), {
                    monthlyDiscount: formatAmount(checkoutTradeInResult.monthlyDiscount),
                    discountPeriod: `${checkoutTradeInResult.months.valueOf()}`
                })
            };
            infoItems.push(ii);
        }
        if (checkoutDiscount) infoItems.push({
            id: "discount-code",
            icon: "sealPercent",
            title: (0, $87d2193cf0695c20$export$4493d2932fe76cf8)(`Rabattkode: {{discountCode}}`, {
                discountName: localize(checkoutDiscount.name),
                discountCode: checkoutDiscount.code.valueOf()
            }),
            text: checkoutDiscount.durationMonths ? (0, $87d2193cf0695c20$export$4493d2932fe76cf8)(localize(section.CheckoutDeviceCard.discountInfoItem.textForMonths), {
                discountDescription: localize(checkoutDiscount.description),
                months: checkoutDiscount.durationMonths.toString(),
                totalAfterDiscountPeriod: (calculatedOrderPrice === null || calculatedOrderPrice === void 0 ? void 0 : calculatedOrderPrice.monthlyCost.totalAfterCodeDiscountPeriod) ? `${formatAmount(calculatedOrderPrice.monthlyCost.totalAfterCodeDiscountPeriod)} ${localize({
                    no: "kr/md",
                    en: "kr/mo"
                })}` : ""
            }) : (0, $87d2193cf0695c20$export$4493d2932fe76cf8)(localize(section.CheckoutDeviceCard.discountInfoItem.textForEntireRentalPeriod), {
                discountDescription: localize(checkoutDiscount.description)
            })
        });
        if ((offer === null || offer === void 0 ? void 0 : offer.insurance) && (calculatedOrderPrice === null || calculatedOrderPrice === void 0 ? void 0 : calculatedOrderPrice.monthlyCost.insurance) && purchasedInsurance) {
            const ii = {
                id: "protection-plan",
                icon: "shield",
                title: localize(section.CheckoutDeviceCard.insuranceInfoItem.title),
                text: (0, $87d2193cf0695c20$export$4493d2932fe76cf8)(localize(section.CheckoutDeviceCard.insuranceInfoItem.text), {
                    insuranceName: localize(purchasedInsurance.displayName),
                    amount: `${formatAmount(calculatedOrderPrice.monthlyCost.insurance)}/${localize((0, $b274814d74f89bd0$export$b4b23bfab2f68498))}`
                })
            };
            infoItems.push(ii);
        }
        if (checkoutShippingState.selectedOption && checkoutShippingState.form) {
            const ii = {
                id: "shipping",
                icon: "truck",
                title: localize(checkoutShippingState.selectedOption.name),
                text: (0, $87d2193cf0695c20$export$4493d2932fe76cf8)(!checkoutShippingState.selectedOption.cost.valueOf() && section.CheckoutDeviceCard.shippingInfoItem.freeShippingText ? localize(section.CheckoutDeviceCard.shippingInfoItem.freeShippingText) : localize(section.CheckoutDeviceCard.shippingInfoItem.text), {
                    shippingPrice: formatAmount({
                        minorUnits: checkoutShippingState.selectedOption.cost * 10,
                        majorUnits: checkoutShippingState.selectedOption.cost,
                        currency: "NOK"
                    }),
                    shippingName: localize(checkoutShippingState.selectedOption.name),
                    shippingDescription: localize(checkoutShippingState.selectedOption.description)
                })
            };
            infoItems.push(ii);
        }
        return infoItems;
    }, [
        calculatedOrderPrice === null || calculatedOrderPrice === void 0 ? void 0 : calculatedOrderPrice.monthlyCost.insurance,
        calculatedOrderPrice === null || calculatedOrderPrice === void 0 ? void 0 : calculatedOrderPrice.monthlyCost.totalAfterCodeDiscountPeriod,
        checkoutDiscount,
        checkoutShippingState.form,
        checkoutShippingState.selectedOption,
        checkoutTradeInPriceRequest,
        checkoutTradeInResult,
        formatAmount,
        localize,
        offer,
        phoneOfferOptions === null || phoneOfferOptions === void 0 ? void 0 : phoneOfferOptions.colors,
        phoneOfferOptions === null || phoneOfferOptions === void 0 ? void 0 : phoneOfferOptions.storageSizes,
        purchasedInsurance,
        section.CheckoutDeviceCard.discountInfoItem.textForMonths,
        section.CheckoutDeviceCard.discountInfoItem.textForEntireRentalPeriod,
        section.CheckoutDeviceCard.insuranceInfoItem.text,
        section.CheckoutDeviceCard.insuranceInfoItem.title,
        section.CheckoutDeviceCard.shippingInfoItem.freeShippingText,
        section.CheckoutDeviceCard.shippingInfoItem.text,
        section.CheckoutDeviceCard.tradeInInfoItem.text,
        section.CheckoutDeviceCard.tradeInInfoItem.title
    ]);
    const checkoutNavigationInclStepName = (0, $eeH7J.useMemo)(()=>(0, $c90be680bf4410a3$export$c81bc4f691c81d42).map((cn)=>Object.assign(Object.assign({}, cn), {
                name: localize(section[cn.id].name),
                isAvailable: checkoutState.availableSteps.includes(cn.id)
            })), [
        checkoutState.availableSteps,
        localize,
        section
    ]);
    (0, $eeH7J.useEffect)(()=>{
        if (tradeInForm.data && !checkoutTradeInForm) setCheckoutTradeInForm(tradeInForm.data);
    }, [
        checkoutTradeInForm,
        setCheckoutTradeInForm,
        tradeInForm.data
    ]);
    /**
     * Used both to apply discount code, and remove it by not passing a discount code.
     */ const applyDiscountCode = (0, $eeH7J.useCallback)(async (code)=>{
        var _a, _b, _c;
        let d;
        if (code) d = await (0, $e18f565b44c7bc7d$export$d76bb2fa6025fa2e)({
            discountCode: code
        });
        if (offer) {
            const p = await (0, $e18f565b44c7bc7d$export$3645f875e233981)({
                phone: offer,
                shippingType: (_a = shipping.selectedOption) === null || _a === void 0 ? void 0 : _a.type,
                shippingSlot: ((_b = shipping.selectedOption) === null || _b === void 0 ? void 0 : _b.type) === "Manual" ? (_c = shipping.selectedOption.selectedSlot) === null || _c === void 0 ? void 0 : _c.id : undefined,
                tradeIn: checkoutTradeInPriceRequest,
                discountId: d === null || d === void 0 ? void 0 : d.id
            });
            // If order has been created, update it.
            if (order === null || order === void 0 ? void 0 : order.id) {
                const o = await (0, $e18f565b44c7bc7d$export$49b90017145ffe19)({
                    discountId: d === null || d === void 0 ? void 0 : d.id,
                    orderId: order.id
                });
                setOrder(o);
            }
            // Update calculated order price in checkout state after updated
            // price has been fetched to avoid prices out of sync, in case
            // `postPhoneOrderPrice` is successful but then
            // `postPhoneReservationDiscount` fails.
            setCalculatedOrderPrice(p);
        }
        // Set discount code to checkout state after updated price has been
        // fetched to ensure they are successful before assuming discount
        // code is applied.
        setCheckoutDiscount(d);
    }, [
        setCheckoutDiscount,
        offer,
        order === null || order === void 0 ? void 0 : order.id,
        shipping.selectedOption,
        checkoutTradeInPriceRequest,
        setCalculatedOrderPrice,
        setOrder
    ]);
    const clearDiscountCode = (0, $eeH7J.useCallback)(()=>{
        // At this point, we also need to remove the session discount code, to avoid it being
        // automatically applied to the order again. Avoiding that in other ways is possible,
        // but assumed not to be worth the extra complexity.
        setSessionDiscountCode(undefined);
        applyDiscountCode(undefined);
    }, [
        applyDiscountCode,
        setSessionDiscountCode
    ]);
    const [attemptedSessionDiscountCode, setAttemptedSessionDiscountCode] = (0, $eeH7J.useState)();
    (0, $eeH7J.useEffect)(()=>{
        async function effect() {
            // If discount code is stored in session (fetched from query param),
            // apply it to checkout, if not already applied. We don't want to clear
            // it from the session yet, in case the user cancels and starts a new checkout.
            if (sessionDiscountCode && !checkoutDiscount && attemptedSessionDiscountCode !== sessionDiscountCode) try {
                setAttemptedSessionDiscountCode(sessionDiscountCode);
                await applyDiscountCode(sessionDiscountCode);
            } catch (err) {
            // No user feedback for discount codes grabbed from URL/session.
            }
        }
        effect();
    }, [
        applyDiscountCode,
        checkoutDiscount,
        attemptedSessionDiscountCode,
        sessionDiscountCode
    ]);
    if (offerShouldBeLoaded && !offer) return (0, $4vwom.jsx)((0, $b97c03a91b0e5a47$export$c120a0e80fd44ca6), {});
    if (!offer || skipAuthStep === undefined || me.loading) return (0, $4vwom.jsx)((0, $4vwom.Fragment), {});
    // If current step is not up to date with search param step, wait with rendering until they
    // are aligned to prevent flash of incorrect step.
    if (currentStepBySearchParam !== currentStep) return (0, $4vwom.jsx)((0, $4vwom.Fragment), {});
    const StepContent = (0, $c90be680bf4410a3$export$68c0e99bc234a4d)[currentStep];
    return (0, $4vwom.jsxs)((0, $c90be680bf4410a3$export$5558864fbda6a534).Provider, {
        value: {
            props: {
                TradeIn: section.TradeIn,
                Insurance: section.Insurance,
                Login: section.Login,
                Shipping: section.Shipping,
                Payment: section.Payment,
                SoldOut: section.SoldOut
            },
            insuranceOptions: insuranceOptions,
            skipAuthStep: skipAuthStep,
            offer: offer,
            setOffer: setOffer,
            shipping: shipping,
            setShipping: setShipping,
            price: calculatedOrderPrice,
            step: currentStep,
            setStep: setStep,
            checkoutState: checkoutState,
            applyDiscountCode: applyDiscountCode,
            clearDiscountCode: clearDiscountCode,
            setCheckoutState: setCheckoutState,
            postAnalyticsCheckoutEvent: postAnalyticsCheckoutEvent,
            useOrder: ()=>({
                    order: order,
                    ensureOrder: ensureOrder,
                    deleteOrder: deleteOrder,
                    isLoading: isLoading,
                    errorMessage: errorMessage,
                    setOrder: setOrder
                })
        },
        children: [
            (0, $4vwom.jsx)((0, $lhaLc.Global), {
                styles: {
                    body: {
                        backgroundColor: (0, $06eb0d21a8b1f440$export$8f45430ccf837300).gray100
                    }
                }
            }),
            (0, $4vwom.jsxs)("div", {
                css: (0, $lhaLc.css)({
                    display: "grid",
                    gridTemplateAreas: '"logo" "progress" "content" "device"',
                    gap: 16,
                    paddingTop: 16,
                    marginBottom: 16
                }, (0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("min", "md", {
                    gridTemplateAreas: '"progress logo" "content device"',
                    gridTemplateColumns: "1fr 0.68fr",
                    gap: 24,
                    paddingTop: 24,
                    marginBottom: 24
                })),
                children: [
                    (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                        gap: 8,
                        style: {
                            gridArea: "logo",
                            minWidth: 0
                        },
                        justifyContent: section.Trustpilot.hide ? "flex-end" : "space-between",
                        alignItems: "center",
                        children: [
                            !section.Trustpilot.hide ? (0, $4vwom.jsx)((0, $b86e57b36afa5734$export$2ab84a49a8797035), {
                                widget: "microStar",
                                height: 20
                            }) : null,
                            (0, $4vwom.jsx)((0, $df8c0007eabe8257$export$45c9c5c7ee057bfb), {
                                style: {
                                    height: (0, $756948b644e82cf2$export$981516ee4691055c)(48)
                                }
                            })
                        ]
                    }),
                    (0, $4vwom.jsx)("div", {
                        style: {
                            gridArea: "progress",
                            minWidth: 0
                        },
                        children: (0, $4vwom.jsx)((0, $c4ee9fc699106494$export$2a0ca3f7657e279), {
                            steps: skipAuthStep ? checkoutNavigationInclStepName.filter((s)=>s.id !== "Login") : checkoutNavigationInclStepName,
                            currentStep: currentStep
                        })
                    }),
                    (0, $4vwom.jsx)("div", {
                        style: {
                            gridArea: "device",
                            minWidth: 0
                        },
                        children: offer.images && offer.images[0] ? (0, $4vwom.jsx)("div", {
                            style: {
                                position: "sticky",
                                top: 24
                            },
                            children: (0, $4vwom.jsx)((0, $6b5c692995a5ffa5$export$d175a07b9db3024e), {
                                subscription: {
                                    duration: offer.rentalPeriod,
                                    unit: "months"
                                },
                                checkout: {
                                    rentalPeriodCurrencyPeriodUnit: (calculatedOrderPrice === null || calculatedOrderPrice === void 0 ? void 0 : calculatedOrderPrice.monthlyCost.itemsTotal.currency) ? `${localizeCurrency(calculatedOrderPrice.monthlyCost.itemsTotal.currency)}/${localize((0, $b274814d74f89bd0$export$b4b23bfab2f68498))}` : "",
                                    originalPrice: (_j = calculatedOrderPrice === null || calculatedOrderPrice === void 0 ? void 0 : calculatedOrderPrice.monthlyCost.itemsTotal.majorUnits) !== null && _j !== void 0 ? _j : 0,
                                    discountedPrice: (_k = calculatedOrderPrice === null || calculatedOrderPrice === void 0 ? void 0 : calculatedOrderPrice.monthlyCost.discountedTotal.majorUnits) !== null && _k !== void 0 ? _k : 0,
                                    monthlyTotalPriceLabel: localize(section.CheckoutDeviceCard.monthlyTotalPriceLabel),
                                    rentalPeriodTotalPriceText: (0, $87d2193cf0695c20$export$4493d2932fe76cf8)(localize(section.CheckoutDeviceCard.rentalPeriodTotalPriceText), {
                                        rentalPeriod: `${offer.rentalPeriod.valueOf()} ${localize((0, $b274814d74f89bd0$export$b4b23bfab2f68498))}`,
                                        totalPrice: calculatedOrderPrice ? formatAmount(calculatedOrderPrice.rentalPeriodTotalPrice) : ""
                                    })
                                },
                                infoItems: deviceCheckoutCardInfoItems,
                                product: {
                                    image: offer.images[0],
                                    color: localize((_m = (_l = phoneOfferOptions === null || phoneOfferOptions === void 0 ? void 0 : phoneOfferOptions.colors.find((c)=>c.name === offer.color)) === null || _l === void 0 ? void 0 : _l.displayName) !== null && _m !== void 0 ? _m : {}),
                                    storageSize: localize((_p = (_o = phoneOfferOptions === null || phoneOfferOptions === void 0 ? void 0 : phoneOfferOptions.storageSizes.find((ss)=>ss.name === offer.storage)) === null || _o === void 0 ? void 0 : _o.displayName) !== null && _p !== void 0 ? _p : {})
                                }
                            })
                        }) : null
                    }),
                    (0, $4vwom.jsx)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                        direction: "column",
                        borderRadius: "lg",
                        backgroundColor: "grayWhite",
                        css: (0, $lhaLc.css)({
                            "--padding-x": "16px",
                            padding: "20px var(--padding-x)",
                            gridArea: "content",
                            minWidth: 0,
                            borderRadius: 16
                        }, (0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("min", "md", {
                            "--padding-x": "80px",
                            padding: (0, $756948b644e82cf2$export$981516ee4691055c)(80)
                        })),
                        children: ((_q = me.data) === null || _q === void 0 ? void 0 : _q.orderLimitReached) ? (0, $4vwom.jsx)((0, $652a00d43f507d25$export$13d90034f51c5979), Object.assign({}, section.OrderLimitReached)) : price.error ? // Sure enough, there could be other reasons for price error, but let's
                        // assume it's sold out for now.
                        (0, $4vwom.jsx)((0, $440c4b5b9e7400e5$export$55aa795759f227b9), Object.assign({}, section.SoldOut)) : (0, $4vwom.jsx)(StepContent, Object.assign({}, section[currentStep]))
                    })
                ]
            })
        ]
    });
}
(0, $9G56J.Section)($047f6f355e30d7d1$var$Checkout);




var $4vwom = parcelRequire("4vwom");

var $lhaLc = parcelRequire("lhaLc");

var $eSiQ2 = parcelRequire("eSiQ2");
parcelRequire("2LTO8");
var $14q7s = parcelRequire("14q7s");

var $7m9cQ = parcelRequire("7m9cQ");



var $eeH7J = parcelRequire("eeH7J");



function $3128e8049110e334$export$35bf746fc814fa9a(props) {
    const { colors: colors, responsiveCss: responsiveCss } = (0, $756948b644e82cf2$export$559a0f07c8df6570)();
    const [currentIndex, setCurrentIndex] = (0, $eeH7J.useState)(0);
    const containerRef = (0, $eeH7J.useRef)(null);
    const scrollRef = (0, $eeH7J.useRef)(null);
    const imageRefs = (0, $eeH7J.useRef)([]);
    const imageRefsMap = (0, $eeH7J.useRef)(new Map());
    const handleIntersectionChange = (0, $eeH7J.useCallback)((entries)=>{
        const intersectingEntry = entries.find((entry)=>entry.isIntersecting);
        if (!intersectingEntry) return;
        for (const [key, value] of imageRefsMap.current.entries())if (value === intersectingEntry.target) {
            const index = props.images.findIndex((ir)=>ir.valueOf() === key);
            setCurrentIndex(index);
            break;
        }
    }, [
        setCurrentIndex,
        props.images
    ]);
    // Keep track of which image is the first image, to be able to only scroll into view if first
    // image has actually changed.
    const [firstImage, setFirstImage] = (0, $eeH7J.useState)();
    (0, $eeH7J.useEffect)(()=>{
        var _a, _b, _c, _d, _e;
        const fi = (_a = props.images[0]) === null || _a === void 0 ? void 0 : _a.valueOf();
        if (fi && fi !== firstImage) {
            setFirstImage(fi);
            if (((_c = (_b = containerRef.current) === null || _b === void 0 ? void 0 : _b.getBoundingClientRect().top) !== null && _c !== void 0 ? _c : 0) > window.scrollY) (_d = imageRefsMap.current.get(fi)) === null || _d === void 0 || _d.scrollIntoView({
                behavior: "smooth",
                block: "nearest",
                inline: "center"
            });
            else if ((_e = scrollRef.current) === null || _e === void 0 ? void 0 : _e.scrollLeft) scrollRef.current.scrollLeft = 0;
        }
    }, [
        firstImage,
        props.images
    ]);
    // Does not use props.images directly, but depend on it to update the observers whenever
    // props.images changes.
    (0, $eeH7J.useEffect)(()=>{
        const observer = new IntersectionObserver(handleIntersectionChange, {
            root: containerRef.current,
            // Reduce threshold to fire a little before the scroll is ended.
            threshold: 0.8
        });
        props.images.forEach((image)=>{
            const ir = imageRefsMap.current.get(image.valueOf());
            if (ir) observer.observe(ir);
        });
        return ()=>{
            observer.disconnect();
        };
    }, [
        handleIntersectionChange,
        containerRef,
        imageRefs,
        props.images
    ]);
    return (0, $4vwom.jsx)("div", {
        ref: containerRef,
        style: {
            flex: "1 1 auto",
            position: "relative",
            overflow: "hidden"
        },
        children: (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
            elementRef: scrollRef,
            backgroundColor: "gray100",
            borderRadius: "md",
            padding: {
                top: 40,
                bottom: props.images.length > 1 ? 64 : 40
            },
            style: {
                overflowX: "scroll",
                scrollSnapType: "x mandatory",
                scrollbarWidth: "none",
                height: "100%",
                width: "100%"
            },
            css: (0, $lhaLc.css)`
                    &::-webkit-scrollbar {
                        display: none;
                    }
                `,
            children: [
                (0, $4vwom.jsx)((0, $4292e3b361a44985$export$caa69d61d2de10d9), {
                    transition: {
                        duration: 0.2
                    },
                    children: (0, $4vwom.jsx)((0, $0df0f0e5b644e49a$export$3ae376d12526dd6f), {
                        mode: "popLayout",
                        initial: false,
                        children: props.images.map((image, index)=>(0, $4vwom.jsx)((0, $ad7a054f4530c130$export$e25e478948902b8b).div, {
                                initial: {
                                    opacity: 0
                                },
                                animate: {
                                    opacity: 1
                                },
                                exit: {
                                    opacity: 0
                                },
                                style: {
                                    display: "flex",
                                    flex: "1 0 100%",
                                    width: "100%",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    scrollSnapAlign: "center"
                                },
                                children: (0, $4vwom.jsx)("div", {
                                    ref: (el)=>{
                                        if (el) imageRefsMap.current.set(image.valueOf(), el);
                                        else imageRefsMap.current.delete(image.valueOf());
                                    },
                                    style: {
                                        display: "flex",
                                        height: "100%",
                                        width: "100%",
                                        flexDirection: "column",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        maxHeight: (0, $756948b644e82cf2$export$981516ee4691055c)(420),
                                        overflow: "hidden"
                                    },
                                    children: (0, $4vwom.jsx)((0, $6a1a23ca93758ec8$export$686e15a6b88a698c), {
                                        style: {
                                            width: "auto",
                                            height: "auto",
                                            maxWidth: "100%",
                                            maxHeight: "100%"
                                        },
                                        image: image,
                                        width: 304
                                    })
                                })
                            }, (0, $14q7s.ImageToUrl)(image)))
                    })
                }),
                props.images.length > 1 && (0, $4vwom.jsx)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                    style: {
                        position: "absolute",
                        bottom: 0,
                        left: 0,
                        right: 0
                    },
                    padding: 12,
                    alignItems: "center",
                    justifyContent: "center",
                    gap: 4,
                    css: (0, $lhaLc.css)({
                        "--current-indicator-width": "16px"
                    }, responsiveCss("min", "md", {
                        "--current-indicator-width": "48px"
                    })),
                    children: (0, $4vwom.jsx)((0, $0df0f0e5b644e49a$export$3ae376d12526dd6f), {
                        initial: false,
                        children: props.images.map((image, index)=>(0, $4vwom.jsx)((0, $ad7a054f4530c130$export$e25e478948902b8b).div, {
                                initial: {
                                    width: 0,
                                    height: 0
                                },
                                animate: {
                                    height: 8,
                                    width: index === currentIndex ? "var(--current-indicator-width)" : 8,
                                    backgroundColor: index === currentIndex ? colors.gray500 : `${colors.gray500}66`
                                },
                                exit: {
                                    opacity: 0,
                                    width: 0,
                                    height: 0
                                },
                                css: (0, $lhaLc.css)({
                                    height: 8,
                                    borderRadius: 4,
                                    overflow: "hidden"
                                })
                            }, index))
                    })
                })
            ]
        })
    });
}
(0, $eSiQ2.Component)($3128e8049110e334$export$35bf746fc814fa9a, {
    name: "ProductCarousel",
    gallery: {
        path: "Carousel/Product",
        items: [
            {
                variants: [
                    {
                        props: {
                            images: [
                                `${(0, $7m9cQ.server)()}/static/redoit/product-card-product-image3.png`,
                                `${(0, $7m9cQ.server)()}/static/redoit/product-card-product-image4.png`
                            ]
                        },
                        render: (cmp)=>(0, $4vwom.jsx)("div", {
                                style: {
                                    width: 600
                                },
                                children: cmp
                            })
                    }
                ]
            }
        ]
    }
});



var $4vwom = parcelRequire("4vwom");

var $lhaLc = parcelRequire("lhaLc");

var $eeH7J = parcelRequire("eeH7J");

var $eSiQ2 = parcelRequire("eSiQ2");
parcelRequire("2LTO8");
var $14q7s = parcelRequire("14q7s");

var $7m9cQ = parcelRequire("7m9cQ");







function $be4b37daa90ce555$export$dc2f2ee2b949f61f(props) {
    const [modalIsOpen, setModalIsOpen] = (0, $eeH7J.useState)(false);
    if (props.compact) return (0, $4vwom.jsxs)((0, $4vwom.Fragment), {
        children: [
            (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                gap: 8,
                alignItems: "center",
                borderRadius: "md",
                borderColor: "gray200",
                padding: 16,
                role: "button",
                onClick: ()=>setModalIsOpen(true),
                style: {
                    cursor: "pointer"
                },
                children: [
                    (0, $4vwom.jsx)((0, $f8cdd04128a131cf$export$f04a61298a47a40f), {
                        icon: "delivery"
                    }),
                    (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                        variant: "body",
                        size: "md",
                        underline: true,
                        children: props.heading
                    })
                ]
            }),
            (0, $4vwom.jsx)((0, $37d4981a6b4c97c0$export$2b77a92f1a5ad772), {
                isOpen: modalIsOpen,
                onClose: ()=>setModalIsOpen(false),
                header: {
                    title: props.heading,
                    closeButton: true,
                    icon: "delivery"
                },
                children: (0, $4vwom.jsx)($be4b37daa90ce555$var$BoxItems, {
                    items: props.items
                })
            })
        ]
    });
    return (0, $4vwom.jsxs)((0, $bee1a5e35c892a21$export$e71c4d32a2263218), {
        borderRadius: "md",
        borderColor: "gray200",
        padding: 24,
        children: [
            (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                gap: 8,
                margin: {
                    bottom: 24
                },
                alignItems: "center",
                children: [
                    (0, $4vwom.jsx)((0, $f8cdd04128a131cf$export$f04a61298a47a40f), {
                        icon: "delivery"
                    }),
                    (0, $4vwom.jsx)((0, $789b8639be592288$export$a8a3e93435678ff9), {
                        level: 4,
                        children: props.heading
                    })
                ]
            }),
            (0, $4vwom.jsx)($be4b37daa90ce555$var$BoxItems, {
                items: props.items
            })
        ]
    });
}
function $be4b37daa90ce555$var$BoxItems(props) {
    const { helpers: helpers } = (0, $756948b644e82cf2$export$559a0f07c8df6570)();
    return (0, $4vwom.jsx)("div", {
        css: (0, $lhaLc.css)({
            display: "grid",
            gridTemplateColumns: "1fr",
            gap: 8,
            gridAutoRows: "1fr",
            width: "100%"
        }, helpers.responsiveCss("min", "sm", {
            gridTemplateColumns: "1fr 1fr"
        })),
        children: props.items.map((item, index)=>(0, $4vwom.jsx)($be4b37daa90ce555$var$BoxItem, Object.assign({}, item), `${index}${item.heading}`))
    });
}
function $be4b37daa90ce555$var$BoxItem(props) {
    return (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
        backgroundColor: "gray100",
        borderRadius: "sm",
        padding: 20,
        gap: 16,
        alignItems: "center",
        children: [
            (0, $4vwom.jsx)("img", {
                src: (0, $14q7s.ImageToUrl)(props.image),
                style: {
                    width: 32,
                    maxHeight: 40
                }
            }),
            (0, $4vwom.jsx)("div", {
                children: (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                    variant: "body",
                    size: "md",
                    children: props.heading
                })
            })
        ]
    });
}
(0, $eSiQ2.Component)($be4b37daa90ce555$export$dc2f2ee2b949f61f, {
    name: "WhatsInTheBoxBlock",
    gallery: {
        path: "Blocks/WhatsInTheBoxBlock",
        items: [
            {
                variants: [
                    {
                        props: {
                            heading: "What\u2019s in the box?",
                            items: [
                                {
                                    heading: "Phone",
                                    text: "The phone you ordered",
                                    image: `${(0, $7m9cQ.server)()}/static/redoit/in-the-box-item-phone.svg`
                                },
                                {
                                    heading: "Booklet",
                                    text: "Pellentesque quis erat id enim elementum molestie quis sit amet neque",
                                    image: `${(0, $7m9cQ.server)()}/static/redoit/in-the-box-item-booklet.svg`
                                },
                                {
                                    heading: "Protective case",
                                    text: "The phone you ordered",
                                    image: `${(0, $7m9cQ.server)()}/static/redoit/in-the-box-item-case.svg`
                                },
                                {
                                    heading: "Charging cable",
                                    text: "Donec faucibus fermentum turpis, vitae pulvinar tortor semper non",
                                    image: `${(0, $7m9cQ.server)()}/static/redoit/in-the-box-item-chargingcable.svg`
                                },
                                {
                                    heading: "Redoit gurantee",
                                    text: "The phone you ordered",
                                    image: `${(0, $7m9cQ.server)()}/static/redoit/in-the-box-item-redoitguarantee.svg`
                                },
                                {
                                    heading: "Screen protector",
                                    text: "The phone you ordered",
                                    image: `${(0, $7m9cQ.server)()}/static/redoit/in-the-box-item-screenprotector.svg`
                                }
                            ]
                        }
                    }
                ]
            },
            {
                variants: [
                    {
                        props: {
                            heading: "What\u2019s in the box?",
                            compact: true,
                            items: [
                                {
                                    heading: "Phone",
                                    text: "The phone you ordered",
                                    image: `${(0, $7m9cQ.server)()}/static/redoit/in-the-box-item-phone.svg`
                                },
                                {
                                    heading: "Booklet",
                                    text: "Pellentesque quis erat id enim elementum molestie quis sit amet neque",
                                    image: `${(0, $7m9cQ.server)()}/static/redoit/in-the-box-item-booklet.svg`
                                },
                                {
                                    heading: "Protective case",
                                    text: "The phone you ordered",
                                    image: `${(0, $7m9cQ.server)()}/static/redoit/in-the-box-item-case.svg`
                                },
                                {
                                    heading: "Charging cable",
                                    text: "Donec faucibus fermentum turpis, vitae pulvinar tortor semper non",
                                    image: `${(0, $7m9cQ.server)()}/static/redoit/in-the-box-item-chargingcable.svg`
                                },
                                {
                                    heading: "Redoit gurantee",
                                    text: "The phone you ordered",
                                    image: `${(0, $7m9cQ.server)()}/static/redoit/in-the-box-item-redoitguarantee.svg`
                                },
                                {
                                    heading: "Screen protector",
                                    text: "The phone you ordered",
                                    image: `${(0, $7m9cQ.server)()}/static/redoit/in-the-box-item-screenprotector.svg`
                                }
                            ]
                        }
                    }
                ]
            }
        ]
    }
});








var $4vwom = parcelRequire("4vwom");
function $8e85e0d8eea1dda5$export$a98f0dcb43a68a25(props) {
    return (0, $4vwom.jsx)((0, $4vwom.Fragment), {
        children: props.options.map((o)=>(0, $4vwom.jsxs)("label", {
                style: {
                    position: "relative"
                },
                children: [
                    props.renderOption(o, props.value === o.value),
                    (0, $4vwom.jsx)("input", {
                        type: "radio",
                        checked: props.value === o.value,
                        style: {
                            position: "absolute",
                            top: 0,
                            left: 0,
                            height: "100%",
                            width: "100%",
                            opacity: "0",
                            zIndex: -1
                        },
                        onChange: (e)=>{
                            props.onChange(e, o.value);
                        }
                    })
                ]
            }, JSON.stringify(o.value)))
    });
}






var $4vwom = parcelRequire("4vwom");






function $c886ce39010e35d8$export$5c260416423351e0(props) {
    return (0, $4vwom.jsxs)("div", {
        children: [
            (0, $4vwom.jsx)((0, $789b8639be592288$export$a8a3e93435678ff9), {
                level: 2,
                margin: {
                    bottom: "md"
                },
                children: props.heading
            }),
            (0, $4vwom.jsx)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                direction: "column",
                padding: "md",
                borderColor: "gray200",
                style: {
                    borderRadius: 16
                },
                children: props.items.map((item, index)=>(0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                        direction: "column",
                        children: [
                            index > 0 && (0, $4vwom.jsx)((0, $67d1e32b493d1bb5$export$2e0a83ec2e27ecbb), {
                                horizontal: true,
                                spacing: "md"
                            }),
                            (0, $4vwom.jsx)((0, $f8cdd04128a131cf$export$f04a61298a47a40f), {
                                size: 32,
                                icon: item.icon,
                                margin: {
                                    bottom: (0, $756948b644e82cf2$export$981516ee4691055c)(16)
                                }
                            }),
                            (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                variant: "body",
                                size: "lg",
                                margin: {
                                    bottom: (0, $756948b644e82cf2$export$981516ee4691055c)(8)
                                },
                                children: item.heading
                            }),
                            (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                variant: "body",
                                size: "md",
                                color: "gray300",
                                children: item.text
                            })
                        ]
                    }, item.id))
            })
        ]
    });
}



var $4vwom = parcelRequire("4vwom");

var $lhaLc = parcelRequire("lhaLc");






function $02316f5bb92deb21$export$4f8c96a4412d9797(props) {
    const { colors: colors } = (0, $756948b644e82cf2$export$559a0f07c8df6570)();
    return (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
        as: "section",
        direction: "column",
        gap: (0, $756948b644e82cf2$export$981516ee4691055c)(24),
        children: [
            (0, $4vwom.jsx)((0, $789b8639be592288$export$a8a3e93435678ff9), {
                level: 2,
                children: props.heading
            }),
            (0, $4vwom.jsx)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                direction: "column",
                gap: [
                    8,
                    [
                        "min",
                        "md",
                        12
                    ]
                ],
                children: props.items.map((item, index)=>(0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                        gap: 24,
                        backgroundColor: "gray100",
                        padding: "md",
                        style: {
                            borderRadius: 16
                        },
                        alignItems: "center",
                        children: [
                            (0, $4vwom.jsx)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                                backgroundColor: "gray500",
                                alignItems: "center",
                                justifyContent: "center",
                                style: {
                                    flexShrink: 0,
                                    color: colors.grayWhite,
                                    borderRadius: 100
                                },
                                css: (0, $lhaLc.css)({
                                    width: 24,
                                    height: 24
                                }, (0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("min", "md", {
                                    height: (0, $756948b644e82cf2$export$981516ee4691055c)(48),
                                    width: (0, $756948b644e82cf2$export$981516ee4691055c)(48)
                                })),
                                children: (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                    variant: "heading",
                                    level: [
                                        5,
                                        [
                                            "min",
                                            "md",
                                            4
                                        ]
                                    ],
                                    children: index + 1
                                })
                            }),
                            (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                variant: "body",
                                size: "md",
                                children: item.text
                            })
                        ]
                    }, item.id))
            }),
            props.image && (0, $4vwom.jsx)((0, $6a1a23ca93758ec8$export$686e15a6b88a698c), {
                image: props.image,
                width: 560,
                style: {
                    borderRadius: 16,
                    width: "100%"
                }
            })
        ]
    });
}







const $f4c4c9282b17128a$var$searchParamsSlugs = {
    phoneId: "phone"
};
function $f4c4c9282b17128a$export$cefacdcddab7996c(params) {
    return Object.entries(params).map(([k, v])=>{
        // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
        if (!v) return;
        if (k in $f4c4c9282b17128a$var$searchParamsSlugs === false) return;
        // Assert k as a key of searchParamsKeys to satisfy TypeScript
        const key = k;
        return `${$f4c4c9282b17128a$var$searchParamsSlugs[key]}=${v.valueOf()}`;
    }).filter((s)=>!!s).join("&");
}
(0, $9G56J.Section)($f4c4c9282b17128a$var$ProductDetails);
function $f4c4c9282b17128a$var$ProductDetails(section) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
    const localize = (0, $aIeEI.useLocalize)();
    const conditionGrades = (0, $e18f565b44c7bc7d$export$713f13fb69b50c52)();
    const [phoneState, setPhone] = (0, $047f6f355e30d7d1$export$800784442c3f48f8)();
    const [offerOptions, setOfferOptions] = (0, $047f6f355e30d7d1$export$5b1a6a2d762c097c)();
    const frequentlyAskedQuestions = (0, $e18f565b44c7bc7d$export$6eb271ef04c4063b)();
    const [searchParams] = (0, $5K1mb.useSearchParams)();
    const phoneId = searchParams.get($f4c4c9282b17128a$var$searchParamsSlugs.phoneId);
    const me = (0, $e18f565b44c7bc7d$export$f637e1cf42d15a62)();
    // Just pass 0 to get the shortest available rental period.
    const phoneOffer = (0, $e18f565b44c7bc7d$export$b1c43cd413897984)(phoneId !== null && phoneId !== void 0 ? phoneId : null, 0);
    const [descriptionModalIsOpen, setDescriptionModalIsOpen] = (0, $eeH7J.useState)(false);
    const checkoutPage = (0, $dUDPg.useWebPageInfo)(section.configure.cta.page);
    const localizeSlug = (0, $02ba3a727a0f8ecd$export$32f719dfac03c1cb)();
    const [sessionStateReset, setSessionStateReset] = (0, $eeH7J.useState)(false);
    const formatAmount = (0, $b274814d74f89bd0$export$cd05f017078a61a8)();
    const [showOrderLimitReachedModal, setShowOrderLimitReachedModal] = (0, $eeH7J.useState)(false);
    const [checkoutState] = (0, $047f6f355e30d7d1$export$7643def88ccd06be)();
    const handleOrderLimitReachedCtaClick = (0, $eeH7J.useCallback)(()=>{
        setShowOrderLimitReachedModal(true);
    }, []);
    // Effect to ensure checkout state is reset whenever returning to product details page.
    // Might want to move to the checkout section.
    (0, $eeH7J.useEffect)(()=>{
        var _a;
        if (!sessionStateReset && ((_a = phoneOffer.data) === null || _a === void 0 ? void 0 : _a.offer)) {
            setPhone(phoneOffer.data.offer);
            setSessionStateReset(true);
        }
    }, [
        (_a = phoneOffer.data) === null || _a === void 0 ? void 0 : _a.offer,
        sessionStateReset,
        setPhone
    ]);
    (0, $eeH7J.useEffect)(()=>{
        var _a;
        // Keep options session state up do date for use later in checkout flow.
        if ((_a = phoneOffer.data) === null || _a === void 0 ? void 0 : _a.options) setOfferOptions(phoneOffer.data.options);
    }, [
        (_b = phoneOffer.data) === null || _b === void 0 ? void 0 : _b.options,
        setOfferOptions
    ]);
    (0, $eeH7J.useEffect)(()=>{
        var _a;
        // If phoneState is for a different model than currently viewing, replace it.
        if (((_a = phoneOffer.data) === null || _a === void 0 ? void 0 : _a.offer) && (phoneState === null || phoneState === void 0 ? void 0 : phoneState.model) !== phoneOffer.data.offer.model) setPhone(phoneOffer.data.offer);
    }, [
        (_c = phoneOffer.data) === null || _c === void 0 ? void 0 : _c.offer,
        phoneState === null || phoneState === void 0 ? void 0 : phoneState.model,
        setOfferOptions,
        setPhone
    ]);
    // Reset phone state when the current state is for a different model than currently viewed.
    (0, $eeH7J.useEffect)(()=>{
        if (phoneOffer.data && phoneOffer.data.offer.model !== (phoneState === null || phoneState === void 0 ? void 0 : phoneState.model)) {
            setPhone(phoneOffer.data.offer);
            setOfferOptions(phoneOffer.data.options);
        }
    }, [
        phoneOffer.data,
        phoneState === null || phoneState === void 0 ? void 0 : phoneState.model,
        setOfferOptions,
        setPhone
    ]);
    // Primarily use the state stored in session storage,
    // fall back to intial data from hook for SSR support.
    const phone = phoneState !== null && phoneState !== void 0 ? phoneState : (_d = phoneOffer.data) === null || _d === void 0 ? void 0 : _d.offer;
    const options = offerOptions !== null && offerOptions !== void 0 ? offerOptions : (_e = phoneOffer.data) === null || _e === void 0 ? void 0 : _e.options;
    const phoneConditionGrade = (_f = conditionGrades.data) === null || _f === void 0 ? void 0 : _f.find((cid)=>cid.id === (phone === null || phone === void 0 ? void 0 : phone.condition));
    if (!phone || !options || !frequentlyAskedQuestions.data) return (0, $4vwom.jsx)((0, $4vwom.Fragment), {});
    if (!((_g = checkoutPage.data) === null || _g === void 0 ? void 0 : _g.slug)) return (0, $4vwom.jsx)("div", {
        children: "Missing checkout page slug, or product details configure CTA page."
    });
    return (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
        css: (0, $lhaLc.css)({
            flexDirection: "column",
            gap: 32
        }, (0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("min", "md", {
            flexDirection: "row"
        }), (0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("min", "lg", {
            gap: (0, $756948b644e82cf2$export$981516ee4691055c)(144)
        }), (0, $756948b644e82cf2$export$f1cf1885b6bfef23)()),
        children: [
            (0, $4vwom.jsx)("div", {
                style: {
                    flex: "1 0 0"
                },
                children: (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                    gap: 48,
                    direction: "column",
                    alignSelf: "flex-start",
                    css: (0, $lhaLc.css)((0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("max", "sm", {
                        maxHeight: 372
                    }), (0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("min", "md", {
                        position: "sticky",
                        top: 24,
                        left: 0,
                        height: "calc(100vh - 24px - 24px)",
                        maxHeight: "calc(100vh - 24px - 24px)"
                    })),
                    children: [
                        (0, $4vwom.jsx)("div", {
                            style: {
                                display: "flex",
                                flexDirection: "column",
                                aspectRatio: "1 / 1",
                                minHeight: 0
                            },
                            children: (0, $4vwom.jsx)((0, $3128e8049110e334$export$35bf746fc814fa9a), {
                                images: (_h = phone.images) !== null && _h !== void 0 ? _h : []
                            })
                        }),
                        section.whatsInTheBox ? (0, $4vwom.jsx)("div", {
                            style: {
                                flex: "0 0 auto"
                            },
                            "aria-hidden": true,
                            css: (0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("max", "sm", {
                                display: "none"
                            }),
                            children: (0, $4vwom.jsx)((0, $be4b37daa90ce555$export$dc2f2ee2b949f61f), {
                                heading: localize(section.whatsInTheBox.heading),
                                items: section.whatsInTheBox.items.map((item)=>({
                                        image: item.image,
                                        heading: localize(item.heading),
                                        text: localize(item.text)
                                    }))
                            })
                        }) : null
                    ]
                })
            }),
            (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                flex: "1 0 0",
                direction: "column",
                gap: 48,
                children: [
                    (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                        direction: "column",
                        gap: 16,
                        children: [
                            (0, $4vwom.jsxs)((0, $bee1a5e35c892a21$export$e71c4d32a2263218), {
                                children: [
                                    !!phoneConditionGrade && (0, $4vwom.jsx)("div", {
                                        style: {
                                            marginBottom: 8
                                        },
                                        children: (0, $4vwom.jsxs)((0, $cf418bf541887e36$export$28c660c63b792dea), {
                                            renderTrigger: (ref)=>(0, $4vwom.jsx)((0, $1c19a55e13f5780a$export$48c441fbee531268), {
                                                    color: "sand",
                                                    elementRef: ref,
                                                    children: localize(phoneConditionGrade.name)
                                                }),
                                            children: [
                                                (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                                    variant: "label",
                                                    size: "md",
                                                    color: "sand",
                                                    margin: {
                                                        bottom: 4
                                                    },
                                                    children: localize(phoneConditionGrade.name)
                                                }),
                                                (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                                    variant: "body",
                                                    size: "sm",
                                                    children: (0, $4vwom.jsx)((0, $82d66b15b8f4758d$export$d5163f1ce1e6a5f9), {
                                                        value: localize(phoneConditionGrade.description)
                                                    })
                                                })
                                            ]
                                        })
                                    }),
                                    (0, $4vwom.jsx)("div", {
                                        children: (0, $4vwom.jsxs)("div", {
                                            css: (0, $lhaLc.css)({
                                                display: "grid",
                                                gridTemplateAreas: phone.features && phone.features.length > 0 ? '"heading button" "features button"' : '"heading button"',
                                                gridTemplateColumns: "1fr auto",
                                                gridTemplateRows: "auto auto",
                                                gap: 8
                                            }, (0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("min", "lg", {
                                                gridTemplateAreas: phone.features && phone.features.length > 0 ? '"heading heading" "features button"' : '"heading button"',
                                                gap: "0px 16px",
                                                marginBottom: 16
                                            })),
                                            children: [
                                                (0, $4vwom.jsx)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                                                    style: {
                                                        gridArea: "heading",
                                                        height: "100%"
                                                    },
                                                    alignItems: "center",
                                                    children: (0, $4vwom.jsx)((0, $789b8639be592288$export$a8a3e93435678ff9), {
                                                        level: 1,
                                                        children: localize(phone.name)
                                                    })
                                                }),
                                                phone.features && phone.features.length > 0 && (0, $4vwom.jsx)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                                                    gap: 8,
                                                    alignItems: "center",
                                                    style: {
                                                        gridArea: "features",
                                                        overflow: "hidden"
                                                    },
                                                    children: (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                                        variant: "body",
                                                        size: "xl",
                                                        color: "gray300",
                                                        css: (0, $lhaLc.css)({
                                                            display: "inline-block",
                                                            whiteSpace: "nowrap",
                                                            overflow: "hidden",
                                                            textOverflow: "ellipsis",
                                                            flex: "1 1 auto"
                                                        }),
                                                        children: phone.features.map((feature, index)=>(0, $4vwom.jsxs)((0, $eeH7J.Fragment), {
                                                                children: [
                                                                    index > 0 && (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                                                        variant: "body",
                                                                        size: [
                                                                            "lg",
                                                                            [
                                                                                "min",
                                                                                "lg",
                                                                                "xl"
                                                                            ]
                                                                        ],
                                                                        color: "gray300",
                                                                        css: (0, $lhaLc.css)({
                                                                            display: "inline-block",
                                                                            marginLeft: 8,
                                                                            marginRight: 8
                                                                        }),
                                                                        children: "\xb7"
                                                                    }),
                                                                    localize(feature.text)
                                                                ]
                                                            }, feature.id.valueOf()))
                                                    })
                                                }),
                                                (0, $4vwom.jsx)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                                                    style: {
                                                        gridArea: "button",
                                                        height: "100%"
                                                    },
                                                    alignItems: "center",
                                                    children: (0, $4vwom.jsx)((0, $4b4086f8a1c6b2f8$export$353f5b6fc5456de1), {
                                                        size: "sm",
                                                        variant: "secondary",
                                                        iconStart: "chevronDown",
                                                        onClick: ()=>setDescriptionModalIsOpen(true)
                                                    })
                                                }),
                                                phone.description && (0, $4vwom.jsx)((0, $37d4981a6b4c97c0$export$2b77a92f1a5ad772), {
                                                    header: {
                                                        icon: "device",
                                                        title: localize(section.productDetailsModalHeading),
                                                        closeButton: true
                                                    },
                                                    isOpen: descriptionModalIsOpen,
                                                    onClose: ()=>setDescriptionModalIsOpen(false),
                                                    children: (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                                        variant: "body",
                                                        size: "sm",
                                                        children: (0, $4vwom.jsx)((0, $82d66b15b8f4758d$export$d5163f1ce1e6a5f9), {
                                                            value: localize(phone.description)
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            section.whatsInTheBox ? (0, $4vwom.jsx)("div", {
                                "aria-hidden": true,
                                css: (0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("min", "md", {
                                    display: "none"
                                }),
                                children: (0, $4vwom.jsx)((0, $be4b37daa90ce555$export$dc2f2ee2b949f61f), {
                                    compact: true,
                                    heading: localize(section.whatsInTheBox.heading),
                                    items: section.whatsInTheBox.items.map((item)=>({
                                            image: item.image,
                                            heading: localize(item.heading),
                                            text: localize(item.text)
                                        }))
                                })
                            }) : null,
                            (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                                borderRadius: "lg",
                                borderColor: "gray200",
                                padding: "md",
                                direction: "column",
                                css: (0, $lhaLc.css)({
                                    gap: 24
                                }, (0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("min", "md", {
                                    gap: 28
                                })),
                                children: [
                                    (0, $4vwom.jsxs)("div", {
                                        children: [
                                            (0, $4vwom.jsx)((0, $789b8639be592288$export$a8a3e93435678ff9), {
                                                level: 4,
                                                margin: {
                                                    bottom: 16
                                                },
                                                children: (0, $87d2193cf0695c20$export$4493d2932fe76cf8)(localize(section.configure.colorLabel), {
                                                    selectedColor: localize((_k = (_j = options.colors.find((c)=>c.name === phone.color)) === null || _j === void 0 ? void 0 : _j.displayName) !== null && _k !== void 0 ? _k : {})
                                                })
                                            }),
                                            (0, $4vwom.jsx)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                                                gap: 16,
                                                children: (0, $4vwom.jsx)((0, $8e85e0d8eea1dda5$export$a98f0dcb43a68a25), {
                                                    options: options.colors.map((color)=>({
                                                            value: color.name,
                                                            text: localize(color.displayName),
                                                            disabled: !color.inStock
                                                        })),
                                                    value: phone.color,
                                                    renderOption: (option, selected)=>{
                                                        const color = options.colors.find((c)=>c.name === option.value);
                                                        // Show limited availability tooltip selectin this config
                                                        // option is not compatible with other selected options, and
                                                        // will cause a change in the selected config.
                                                        const limitedAvailability = color && color.storageSizes.length && options.storageSizes.length > color.storageSizes.length ? color.storageSizes.map((ss)=>{
                                                            var _a;
                                                            const ssdn = (_a = options.storageSizes.find((oss)=>oss.name === ss)) === null || _a === void 0 ? void 0 : _a.displayName;
                                                            if (ssdn) return {
                                                                id: ss,
                                                                displayName: localize(ssdn)
                                                            };
                                                        }).filter((ss)=>!!ss) : undefined;
                                                        const showLimitedAvailability = !selected && !(limitedAvailability === null || limitedAvailability === void 0 ? void 0 : limitedAvailability.filter((ss)=>ss.id === phone.storage).length);
                                                        return color && (0, $4vwom.jsx)((0, $cf418bf541887e36$export$28c660c63b792dea), {
                                                            renderTrigger: (ref)=>(0, $4vwom.jsx)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                                                                    elementRef: ref,
                                                                    alignItems: "center",
                                                                    justifyContent: "center",
                                                                    borderWidth: 2,
                                                                    borderColor: selected ? "brand" : undefined,
                                                                    css: (0, $lhaLc.css)({
                                                                        borderRadius: 100,
                                                                        height: 38,
                                                                        width: 38
                                                                    }, (0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("min", "xl", {
                                                                        height: 44,
                                                                        width: 44
                                                                    })),
                                                                    children: (0, $4vwom.jsx)("div", {
                                                                        role: "radio",
                                                                        "aria-label": localize(color.displayName),
                                                                        style: {
                                                                            backgroundColor: color.color,
                                                                            opacity: option.disabled ? 0.2 : 1,
                                                                            cursor: option.disabled ? "not-allowed" : "pointer"
                                                                        },
                                                                        css: (0, $lhaLc.css)({
                                                                            borderRadius: 100,
                                                                            height: 30,
                                                                            width: 30
                                                                        }, (0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("min", "xl", {
                                                                            height: 36,
                                                                            width: 36
                                                                        }))
                                                                    })
                                                                }),
                                                            children: (limitedAvailability === null || limitedAvailability === void 0 ? void 0 : limitedAvailability.length) && showLimitedAvailability ? (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                                                variant: "body",
                                                                size: "sm",
                                                                children: (0, $87d2193cf0695c20$export$4493d2932fe76cf8)(localize(section.configure.limitedStorageSizesAvailabilityTooltip), {
                                                                    storageSizes: limitedAvailability.map((la)=>la.displayName).join(", ")
                                                                })
                                                            }) : option.disabled ? (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                                                variant: "body",
                                                                size: "sm",
                                                                children: localize(section.configure.outOfStockTooltip)
                                                            }) : null
                                                        });
                                                    },
                                                    onChange: async (e, val)=>{
                                                        setPhone(await (0, $e18f565b44c7bc7d$export$a5ae59f6dafb10b4)("color", Object.assign(Object.assign({}, phone), {
                                                            color: val
                                                        })));
                                                    }
                                                })
                                            })
                                        ]
                                    }),
                                    (0, $4vwom.jsx)((0, $67d1e32b493d1bb5$export$2e0a83ec2e27ecbb), {
                                        horizontal: true,
                                        spacing: 0
                                    }),
                                    (0, $4vwom.jsxs)("div", {
                                        children: [
                                            (0, $4vwom.jsx)((0, $789b8639be592288$export$a8a3e93435678ff9), {
                                                level: 4,
                                                margin: {
                                                    bottom: 16
                                                },
                                                children: localize(section.configure.storageSizeLabel)
                                            }),
                                            (0, $4vwom.jsx)("div", {
                                                style: {
                                                    gap: 8,
                                                    display: "flex"
                                                },
                                                css: (0, $lhaLc.css)({
                                                    "> *": {
                                                        flex: "1 0 0"
                                                    }
                                                }),
                                                children: (0, $4vwom.jsx)((0, $8e85e0d8eea1dda5$export$a98f0dcb43a68a25), {
                                                    value: phone.storage,
                                                    options: options.storageSizes.map((storage)=>({
                                                            value: storage.name,
                                                            text: localize(storage.displayName),
                                                            disabled: !storage.inStock
                                                        })),
                                                    renderOption: (option, selected)=>{
                                                        const storageSize = options.storageSizes.find((ss)=>ss.name === option.value);
                                                        // Show limited availability tooltip selectin this config
                                                        // option is not compatible with other selected options, and
                                                        // will cause a change in the selected config.
                                                        const limitedAvailability = storageSize && storageSize.colors.length && options.colors.length > storageSize.colors.length ? storageSize.colors.map((c)=>{
                                                            var _a;
                                                            const cdn = (_a = options.colors.find((colorOption)=>colorOption.name === c)) === null || _a === void 0 ? void 0 : _a.displayName;
                                                            if (cdn) return {
                                                                id: c,
                                                                displayName: localize(cdn)
                                                            };
                                                        }).filter((c)=>!!c) : undefined;
                                                        const showLimitedAvailability = !selected && !(limitedAvailability === null || limitedAvailability === void 0 ? void 0 : limitedAvailability.filter((c)=>c.id === phone.color).length);
                                                        return storageSize && (0, $4vwom.jsx)((0, $cf418bf541887e36$export$28c660c63b792dea), {
                                                            renderTrigger: (ref)=>(0, $4vwom.jsx)("div", {
                                                                    ref: ref,
                                                                    children: (0, $4vwom.jsx)((0, $4b4086f8a1c6b2f8$export$353f5b6fc5456de1), {
                                                                        variant: "select",
                                                                        selected: selected,
                                                                        fullwidth: true,
                                                                        as: "div",
                                                                        size: "sm",
                                                                        disabled: option.disabled,
                                                                        children: option.text
                                                                    })
                                                                }),
                                                            children: showLimitedAvailability && (limitedAvailability === null || limitedAvailability === void 0 ? void 0 : limitedAvailability.length) ? (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                                                variant: "body",
                                                                size: "sm",
                                                                children: (0, $87d2193cf0695c20$export$4493d2932fe76cf8)(localize(section.configure.limitedColorsAvailabilityTooltip), {
                                                                    colors: limitedAvailability.map((la)=>la.displayName).join(", ")
                                                                })
                                                            }) : option.disabled ? (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                                                variant: "body",
                                                                size: "sm",
                                                                children: localize(section.configure.outOfStockTooltip)
                                                            }) : null
                                                        });
                                                    },
                                                    onChange: async (e, val)=>{
                                                        setPhone(await (0, $e18f565b44c7bc7d$export$a5ae59f6dafb10b4)("storage", Object.assign(Object.assign({}, phone), {
                                                            storage: val
                                                        })));
                                                    }
                                                })
                                            })
                                        ]
                                    }),
                                    (0, $4vwom.jsx)((0, $67d1e32b493d1bb5$export$2e0a83ec2e27ecbb), {
                                        horizontal: true,
                                        spacing: 0
                                    }),
                                    (0, $4vwom.jsxs)("div", {
                                        children: [
                                            (0, $4vwom.jsx)((0, $789b8639be592288$export$a8a3e93435678ff9), {
                                                level: 4,
                                                margin: {
                                                    bottom: 16
                                                },
                                                children: localize(section.configure.rentalPeriodLabel)
                                            }),
                                            (0, $4vwom.jsx)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                                                direction: "column",
                                                gap: 8,
                                                css: (0, $lhaLc.css)({
                                                    "> *": {
                                                        flex: "1 0 0"
                                                    }
                                                }),
                                                children: (0, $4vwom.jsx)((0, $8e85e0d8eea1dda5$export$a98f0dcb43a68a25), {
                                                    value: phone.rentalPeriod,
                                                    options: options.rentalPeriods.map((rp)=>({
                                                            value: rp.months,
                                                            text: localize(rp.displayName)
                                                        })),
                                                    renderOption: (option, selected)=>{
                                                        const rentalPeriodPrice = phone.monthlyPrices.find((rpp)=>rpp.rentalPeriod === option.value);
                                                        if (!rentalPeriodPrice) return null;
                                                        return (0, $4vwom.jsx)((0, $4b4086f8a1c6b2f8$export$353f5b6fc5456de1), {
                                                            variant: "select",
                                                            selected: selected,
                                                            fullwidth: true,
                                                            as: "div",
                                                            size: "md",
                                                            children: (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                                                                style: {
                                                                    width: "100%"
                                                                },
                                                                justifyContent: "space-between",
                                                                children: [
                                                                    (0, $4vwom.jsxs)("div", {
                                                                        style: !selected ? {
                                                                            fontWeight: 300
                                                                        } : {},
                                                                        children: [
                                                                            option.value,
                                                                            " ",
                                                                            localize((0, $b274814d74f89bd0$export$2bb3eb27682a776))
                                                                        ]
                                                                    }),
                                                                    (0, $4vwom.jsxs)("div", {
                                                                        children: [
                                                                            formatAmount(rentalPeriodPrice.price.discountedTotal),
                                                                            "/",
                                                                            localize((0, $b274814d74f89bd0$export$b4b23bfab2f68498))
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        });
                                                    },
                                                    onChange: async (e, val)=>{
                                                        setPhone(await (0, $e18f565b44c7bc7d$export$a5ae59f6dafb10b4)("rentalPeriod", Object.assign(Object.assign({}, phone), {
                                                            rentalPeriod: val
                                                        })));
                                                    }
                                                })
                                            })
                                        ]
                                    }),
                                    (0, $4vwom.jsx)((0, $67d1e32b493d1bb5$export$2e0a83ec2e27ecbb), {
                                        horizontal: true,
                                        spacing: 0
                                    }),
                                    (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                                        alignItems: "baseline",
                                        gap: "4px 8px",
                                        style: {
                                            whiteSpace: "nowrap",
                                            flexWrap: "wrap"
                                        },
                                        children: [
                                            (0, $4vwom.jsxs)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                                variant: "heading",
                                                level: [
                                                    2,
                                                    [
                                                        "min",
                                                        "md",
                                                        3
                                                    ]
                                                ],
                                                color: "brand",
                                                children: [
                                                    formatAmount(phone.monthlyPrice.itemsTotal),
                                                    "/",
                                                    localize((0, $b274814d74f89bd0$export$b4b23bfab2f68498))
                                                ]
                                            }),
                                            (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                                variant: "body",
                                                size: "md",
                                                children: (0, $87d2193cf0695c20$export$4493d2932fe76cf8)(localize(section.configure.totalPricePostFix), {
                                                    rentalPeriod: `${phone.rentalPeriod}`
                                                })
                                            }),
                                            (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                                variant: "body",
                                                size: "sm",
                                                color: "gray300",
                                                children: (0, $87d2193cf0695c20$export$4493d2932fe76cf8)(localize(section.configure.rentalPeriodTotalPrice), {
                                                    rentalPeriod: `${phone.rentalPeriod.valueOf()}`,
                                                    totalPrice: `${formatAmount(phone.rentalPeriodTotalPrice)}`,
                                                    monthsShort: localize((0, $b274814d74f89bd0$export$b4b23bfab2f68498)),
                                                    monthsLong: localize((0, $b274814d74f89bd0$export$2bb3eb27682a776))
                                                })
                                            })
                                        ]
                                    }),
                                    (0, $4vwom.jsx)((0, $4b4086f8a1c6b2f8$export$353f5b6fc5456de1), {
                                        as: "a",
                                        variant: "primary",
                                        href: ((_l = me.data) === null || _l === void 0 ? void 0 : _l.orderLimitReached) ? undefined : localizeSlug(checkoutPage.data.slug),
                                        fullwidth: true,
                                        onClick: ((_m = me.data) === null || _m === void 0 ? void 0 : _m.orderLimitReached) ? handleOrderLimitReachedCtaClick : ()=>{
                                            var _a, _b, _c, _d;
                                            (0, $dUDPg.postAnalyticsEvent)("checkout", {
                                                entity: [
                                                    "init"
                                                ],
                                                data: {
                                                    userId: (_b = (_a = me.data) === null || _a === void 0 ? void 0 : _a.id) === null || _b === void 0 ? void 0 : _b.valueOf(),
                                                    phoneId: phone.id.valueOf(),
                                                    rentalPeriod: phone.rentalPeriod.toString()
                                                }
                                            }, {
                                                "Fuse-Analytics-Session": (_d = (_c = checkoutState.id) === null || _c === void 0 ? void 0 : _c.valueOf()) !== null && _d !== void 0 ? _d : ""
                                            });
                                            if (typeof fbq !== "undefined") fbq("track", "AddToCart", {
                                                content_ids: [
                                                    phone.id.valueOf()
                                                ],
                                                content_name: localize(phone.name),
                                                content_type: "product",
                                                value: phone.monthlyPrice.itemsTotal.majorUnits,
                                                currency: phone.monthlyPrice.itemsTotal.currency,
                                                num_items: 1
                                            });
                                            if (typeof snaptr !== "undefined") snaptr("track", "ADD_CART", {
                                                price: phone.monthlyPrice.itemsTotal.majorUnits,
                                                currency: phone.monthlyPrice.itemsTotal.currency,
                                                item_ids: [
                                                    phone.id
                                                ],
                                                item_category: "phone",
                                                number_items: 1
                                            });
                                        },
                                        children: localize(section.configure.cta.buttonText)
                                    }),
                                    (0, $4vwom.jsx)((0, $37d4981a6b4c97c0$export$2b77a92f1a5ad772), {
                                        width: 600,
                                        isOpen: showOrderLimitReachedModal,
                                        header: {
                                            title: localize(section.orderLimitReachedModal.title)
                                        },
                                        children: (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                                            direction: "column",
                                            gap: 24,
                                            children: [
                                                (0, $4vwom.jsx)((0, $82d66b15b8f4758d$export$d5163f1ce1e6a5f9), {
                                                    value: localize(section.orderLimitReachedModal.text)
                                                }),
                                                (0, $4vwom.jsx)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                                                    justifyContent: "flex-end",
                                                    children: (0, $4vwom.jsx)((0, $4b4086f8a1c6b2f8$export$353f5b6fc5456de1), {
                                                        variant: "primary",
                                                        size: "md",
                                                        onClick: ()=>setShowOrderLimitReachedModal(false),
                                                        children: localize(section.orderLimitReachedModal.closeButtonText)
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    (_o = section.notifications) === null || _o === void 0 ? void 0 : _o.map((n)=>(0, $4vwom.jsx)((0, $192171ee7c657b77$export$14834abbfce3b8cd), {
                            icon: n.icon,
                            text: localize(n.text),
                            color: n.color
                        }, n.id.valueOf())),
                    section.steps && (0, $4vwom.jsx)((0, $02316f5bb92deb21$export$4f8c96a4412d9797), {
                        heading: localize(section.steps.heading),
                        items: section.steps.items.map((item)=>({
                                id: item.id.valueOf(),
                                text: localize(item.text)
                            })),
                        image: section.steps.image
                    }),
                    section.benefits && (0, $4vwom.jsx)((0, $c886ce39010e35d8$export$5c260416423351e0), {
                        heading: localize(section.benefits.heading),
                        items: section.benefits.items.map((item)=>({
                                id: item.id.valueOf(),
                                icon: item.icon,
                                heading: localize(item.heading),
                                text: localize(item.text)
                            }))
                    }),
                    !!section.frequentlyAskedQuestions && frequentlyAskedQuestions.data.questions.length > 0 && (0, $4vwom.jsx)((0, $27039c694c31ccef$export$91f5553634f65df6), {
                        heading: localize(section.frequentlyAskedQuestions.heading),
                        questions: frequentlyAskedQuestions.data.questions.map((item)=>({
                                id: item.id,
                                question: localize(item.question),
                                answer: localize(item.answer)
                            })),
                        showAllButtonText: localize(section.frequentlyAskedQuestions.showAllButtonText),
                        maxInitialQuestions: (_p = section.frequentlyAskedQuestions.maxInitialQuestions) === null || _p === void 0 ? void 0 : _p.valueOf()
                    })
                ]
            })
        ]
    });
}



var $4vwom = parcelRequire("4vwom");

var $eeH7J = parcelRequire("eeH7J");

var $lhaLc = parcelRequire("lhaLc");

var $9G56J = parcelRequire("9G56J");

var $dUDPg = parcelRequire("dUDPg");


var $4vwom = parcelRequire("4vwom");

var $eeH7J = parcelRequire("eeH7J");


var $lhaLc = parcelRequire("lhaLc");

var $eSiQ2 = parcelRequire("eSiQ2");

var $7m9cQ = parcelRequire("7m9cQ");










function $b7d6468cd3704e06$export$e6cbe35324ccf844(props) {
    var _a, _b, _c;
    const [hover, setHover] = (0, $eeH7J.useState)(false);
    const { helpers: helpers, colors: colors, responsiveCss: responsiveCss } = (0, $756948b644e82cf2$export$559a0f07c8df6570)();
    const { responsiveSpacing: responsiveSpacing, responsiveBodyCss: responsiveBodyCss } = helpers;
    const href = props.onClick || !props.cta ? undefined : props.cta.url;
    if (props.compact) return (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
        backgroundColor: "gray100",
        padding: "sm",
        borderRadius: "md",
        grow: 1,
        css: (0, $lhaLc.css)({
            position: "relative",
            "&:hover": {
                cursor: props.disabled ? "default" : "pointer"
            }
        }),
        children: [
            (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                as: "a",
                grow: 1,
                href: href,
                onClick: props.onClick,
                children: [
                    (0, $4vwom.jsx)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                        css: (0, $lhaLc.css)({
                            width: 96,
                            height: 112,
                            marginRight: 24
                        }),
                        alignItems: "center",
                        justifyContent: "center",
                        children: props.image ? (0, $4vwom.jsx)((0, $6a1a23ca93758ec8$export$686e15a6b88a698c), {
                            image: props.image,
                            width: 100,
                            style: {
                                flex: "0 0 0",
                                height: "auto",
                                width: "auto",
                                maxHeight: `${(_a = props.relativePhysicalSize) !== null && _a !== void 0 ? _a : 100}%`,
                                maxWidth: "100%"
                            }
                        }) : null
                    }),
                    (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                        direction: "column",
                        justifyContent: "space-between",
                        grow: 1,
                        style: {
                            paddingTop: 12,
                            paddingBottom: 12
                        },
                        children: [
                            (0, $4vwom.jsxs)("div", {
                                children: [
                                    props.label ? (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                        variant: "label",
                                        size: "md",
                                        color: props.label.color,
                                        children: props.label.text
                                    }) : null,
                                    (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                        variant: "body",
                                        size: "xl",
                                        children: props.name
                                    }),
                                    (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                        variant: "body",
                                        size: "sm",
                                        color: "gray350",
                                        children: (0, $4vwom.jsx)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                                            gap: 4,
                                            children: props.features.slice(0, 2).map((f, i)=>(0, $4vwom.jsxs)((0, $eeH7J.Fragment), {
                                                    children: [
                                                        i > 0 ? (0, $4vwom.jsx)("div", {
                                                            children: "\xb7"
                                                        }) : null,
                                                        (0, $4vwom.jsx)("div", {
                                                            children: f
                                                        })
                                                    ]
                                                }, f))
                                        })
                                    })
                                ]
                            }),
                            (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                variant: "body",
                                size: "xl",
                                fontWeight: 600,
                                color: props.disabled ? "gray350" : props.highlightPrice ? "brand" : undefined,
                                children: props.price
                            })
                        ]
                    })
                ]
            }),
            !props.disabled && (0, $4vwom.jsx)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: "grayWhite",
                style: {
                    position: "absolute",
                    bottom: 16,
                    right: 16,
                    borderRadius: "100vw",
                    width: 40,
                    height: 40,
                    pointerEvents: "none"
                },
                children: (0, $4vwom.jsx)((0, $f8cdd04128a131cf$export$f04a61298a47a40f), {
                    icon: "arrowRight"
                })
            })
        ]
    });
    return (0, $4vwom.jsx)((0, $4292e3b361a44985$export$caa69d61d2de10d9), {
        transition: (0, $7f851218870bc850$export$f1ff28cd2162b6d5).card,
        children: (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
            as: "a",
            href: props.disabled ? undefined : href,
            onClick: props.disabled ? undefined : props.onClick,
            role: "button",
            "aria-labelledby": props.cta ? props.cta.text : undefined,
            motion: {
                initial: {
                    backgroundColor: colors.gray100,
                    boxShadow: "none"
                },
                animate: hover ? {
                    backgroundColor: colors.grayWhite,
                    boxShadow: "var(--product-card-box-shadow)"
                } : {
                    backgroundColor: colors.gray100,
                    boxShadow: "none"
                }
            },
            "aria-disabled": (_b = props.disabled) !== null && _b !== void 0 ? _b : false,
            borderRadius: "md",
            alignItems: "center",
            justifyContent: "space-between",
            onMouseOver: props.disabled ? undefined : ()=>setHover(true),
            onMouseOut: props.disabled ? undefined : ()=>setHover(false),
            css: (0, $lhaLc.css)({
                position: "relative",
                containerSize: "size",
                containerName: "card",
                "&:hover": {
                    cursor: props.disabled ? "default" : "pointer"
                },
                height: "100%",
                flexDirection: "column",
                paddingTop: 50,
                paddingBottom: 30
            }, responsiveCss("min", "lg", {
                paddingBottom: 38
            }), responsiveCss("min", "xl", {
                paddingTop: 64 * (0, $1c2a8fb378443a1d$export$adc5746a202ff4b),
                paddingBottom: 48 * (0, $1c2a8fb378443a1d$export$adc5746a202ff4b)
            }), responsiveSpacing("md", [
                "paddingLeft",
                "paddingRight"
            ]), (0, $756948b644e82cf2$export$88d2c1aa53be97d2)("--product-card-box-shadow")),
            children: [
                (0, $4vwom.jsx)("div", {
                    css: (0, $lhaLc.css)({
                        position: "absolute",
                        top: 19,
                        right: 19
                    }, responsiveCss("min", "xl", {
                        top: 24 * (0, $1c2a8fb378443a1d$export$adc5746a202ff4b),
                        right: 24 * (0, $1c2a8fb378443a1d$export$adc5746a202ff4b)
                    })),
                    children: props.label ? (0, $4vwom.jsx)((0, $1c19a55e13f5780a$export$48c441fbee531268), {
                        color: props.label.color,
                        children: props.label.text
                    }) : null
                }),
                (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                    direction: "column",
                    style: {
                        maxWidth: "100%"
                    },
                    children: [
                        (0, $4vwom.jsx)((0, $ad7a054f4530c130$export$e25e478948902b8b).div, {
                            css: (0, $lhaLc.css)({
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "flex-end",
                                height: 192,
                                marginBottom: 30,
                                transform: props.alwaysShowCta ? "translateY(var(--product-card-image-translate-y))" : "",
                                "--product-card-image-translate-y": `${8 * (0, $1c2a8fb378443a1d$export$adc5746a202ff4b) * (0, $1c2a8fb378443a1d$export$adc5746a202ff4b)}px`
                            }, responsiveCss("min", "lg", {
                                height: 220,
                                marginBottom: 38,
                                "--product-card-image-translate-y": `${8 * (0, $1c2a8fb378443a1d$export$adc5746a202ff4b)}px`
                            }), responsiveCss("min", "xl", {
                                height: 284 * (0, $1c2a8fb378443a1d$export$adc5746a202ff4b),
                                marginBottom: 48 * (0, $1c2a8fb378443a1d$export$adc5746a202ff4b),
                                "--product-card-image-translate-y": `${8}px`
                            })),
                            animate: !props.alwaysShowCta ? hover ? {
                                translateY: "var(--product-card-image-translate-y)"
                            } : {
                                translateY: 0
                            } : {},
                            children: props.image ? (0, $4vwom.jsx)((0, $6a1a23ca93758ec8$export$686e15a6b88a698c), {
                                image: props.image,
                                width: 220,
                                style: {
                                    height: "auto",
                                    width: "auto",
                                    maxHeight: `${(_c = props.relativePhysicalSize) !== null && _c !== void 0 ? _c : 100}%`,
                                    maxWidth: "100%"
                                }
                            }) : null
                        }),
                        (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                            direction: "column",
                            alignItems: "center",
                            css: (0, $lhaLc.css)({
                                marginBottom: 30
                            }, responsiveCss("min", "lg", {
                                marginBottom: 38
                            }), responsiveCss("min", "xl", {
                                marginBottom: 48 * (0, $1c2a8fb378443a1d$export$adc5746a202ff4b)
                            })),
                            children: [
                                (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                    variant: "body",
                                    size: "xl",
                                    margin: {
                                        bottom: 4
                                    },
                                    truncate: true,
                                    children: props.name
                                }),
                                (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                    variant: "body",
                                    size: "md",
                                    color: "gray400",
                                    truncate: true,
                                    children: (0, $4vwom.jsx)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                                        gap: 4,
                                        children: props.features.length ? props.features.slice(0, 2).map((f, i)=>(0, $4vwom.jsxs)((0, $eeH7J.Fragment), {
                                                children: [
                                                    i > 0 ? (0, $4vwom.jsx)("div", {
                                                        children: "\xb7"
                                                    }) : null,
                                                    (0, $4vwom.jsx)("div", {
                                                        children: f
                                                    })
                                                ]
                                            }, f)) : "\xa0"
                                    })
                                })
                            ]
                        }),
                        (0, $4vwom.jsxs)("div", {
                            children: [
                                (0, $4vwom.jsx)((0, $ad7a054f4530c130$export$e25e478948902b8b).div, {
                                    animate: hover && !props.alwaysShowCta ? {
                                        translateY: "var(--product-card-price-translate-y)"
                                    } : {},
                                    css: (0, $lhaLc.css)({
                                        "--product-card-price-translate-y": `-${16 * (0, $1c2a8fb378443a1d$export$adc5746a202ff4b) * (0, $1c2a8fb378443a1d$export$adc5746a202ff4b)}px`,
                                        transform: props.alwaysShowCta ? "translateY(var(--product-card-price-translate-y))" : ""
                                    }, responsiveCss("min", "lg", {
                                        "--product-card-price-translate-y": `-${16 * (0, $1c2a8fb378443a1d$export$adc5746a202ff4b)}px`
                                    }), responsiveCss("min", "xl", {
                                        "--product-card-price-translate-y": "-16px"
                                    })),
                                    children: (0, $4vwom.jsx)("div", {
                                        css: (0, $lhaLc.css)(props.highlightPrice && {
                                            color: colors.brand
                                        }, props.disabled && {
                                            color: colors.gray350
                                        }, responsiveBodyCss("xl"), {
                                            fontFamily: "Catalogue",
                                            fontWeight: "600 !important",
                                            textAlign: "center"
                                        }),
                                        children: props.price
                                    })
                                }),
                                !!props.cta && (0, $4vwom.jsx)((0, $ad7a054f4530c130$export$e25e478948902b8b).div, {
                                    css: (0, $lhaLc.css)({
                                        textAlign: "center",
                                        "--initial-button-opacity": 0,
                                        "--initial-button-transform": `${8 * (0, $1c2a8fb378443a1d$export$adc5746a202ff4b) * (0, $1c2a8fb378443a1d$export$adc5746a202ff4b)}px`,
                                        "--initial-button-margin-top": "4px",
                                        pointerEvents: props.alwaysShowCta || hover ? "all" : "none"
                                    }, responsiveCss("min", "lg", {
                                        "--initial-button-transform": `${8 * (0, $1c2a8fb378443a1d$export$adc5746a202ff4b)}px`
                                    }), responsiveCss("min", "xl", {
                                        "--initial-button-transform": "8px"
                                    }), (0, $e82ba787de72625c$export$c874afaabcd4d5bc)({
                                        "--initial-button-opacity": 1,
                                        "--initial-button-transform": "none",
                                        "--initial-button-margin-top": "20px",
                                        pointerEvents: "all"
                                    })),
                                    initial: props.alwaysShowCta ? {
                                        opacity: 1,
                                        translateY: 0
                                    } : {
                                        opacity: "var(--initial-button-opacity)",
                                        translateY: "var(--initial-button-transform)",
                                        marginTop: "var(--initial-button-margin-top)"
                                    },
                                    animate: !props.alwaysShowCta && hover ? {
                                        opacity: 1,
                                        translateY: 0
                                    } : {},
                                    children: (0, $4vwom.jsx)((0, $4b4086f8a1c6b2f8$export$353f5b6fc5456de1), {
                                        variant: "primary",
                                        iconEnd: "arrowRight",
                                        children: props.cta.text
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}
(0, $eSiQ2.Component)($b7d6468cd3704e06$export$e6cbe35324ccf844, {
    name: "ProductCard",
    gallery: {
        path: "Cards/ProductCard",
        items: [
            {
                variants: [
                    {
                        props: {
                            name: "iPhone 15 Pro",
                            features: [
                                "6,7\u201D Skjerm",
                                "48MP Kamera"
                            ],
                            price: "Fra kr 163 /m",
                            cta: {
                                text: "Kj\xf8p n\xe5",
                                url: "/devices/iphone-15-pro"
                            },
                            label: {
                                color: "sky",
                                text: "New"
                            },
                            image: `${(0, $7m9cQ.server)()}/static/redoit/product-card-product-image1.png`
                        }
                    },
                    {
                        props: {
                            name: "iPhone 15 Pro",
                            features: [
                                "6,7\u201D Skjerm",
                                "48MP Kamera"
                            ],
                            price: "Fra kr 163 /m",
                            cta: {
                                text: "Kj\xf8p n\xe5",
                                url: "/devices/iphone-15-pro"
                            },
                            label: {
                                color: "brand",
                                text: "Deal"
                            },
                            highlightPrice: true,
                            image: `${(0, $7m9cQ.server)()}/static/redoit/product-card-product-image3.png`
                        }
                    },
                    {
                        props: {
                            name: "iPhone 15 Pro",
                            features: [
                                "6,7\u201D Skjerm",
                                "48MP Kamera"
                            ],
                            price: "Fra kr 163 /m",
                            cta: {
                                text: "Kj\xf8p n\xe5",
                                url: "/devices/iphone-15-pro"
                            },
                            image: `${(0, $7m9cQ.server)()}/static/redoit/product-card-product-image2.png`
                        }
                    }
                ]
            }
        ]
    }
});



var $aIeEI = parcelRequire("aIeEI");





var $4vwom = parcelRequire("4vwom");

var $lhaLc = parcelRequire("lhaLc");



var $eSiQ2 = parcelRequire("eSiQ2");




var $7m9cQ = parcelRequire("7m9cQ");

function $aa16a84e4a514505$export$b60a58e8d2266310(props) {
    return (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
        as: "a",
        href: props.cta.url,
        direction: "column",
        justifyContent: "space-between",
        borderRadius: "md",
        backgroundColor: "_productsSeeAllBg",
        style: {
            position: "relative",
            height: "100%",
            overflow: "clip",
            flexGrow: 0
        },
        "aria-label": props.cta.text,
        children: [
            (0, $4vwom.jsxs)((0, $bee1a5e35c892a21$export$e71c4d32a2263218), {
                css: (0, $lhaLc.css)({
                    padding: 32
                }, (0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("min", "md", {
                    padding: 64
                })),
                style: {
                    zIndex: 1
                },
                children: [
                    (0, $4vwom.jsx)((0, $789b8639be592288$export$a8a3e93435678ff9), {
                        level: 2,
                        margin: {
                            bottom: 16
                        },
                        children: props.heading
                    }),
                    (0, $4vwom.jsx)((0, $4b4086f8a1c6b2f8$export$353f5b6fc5456de1), {
                        variant: "dark",
                        children: props.cta.text
                    })
                ]
            }),
            props.image ? (0, $4vwom.jsx)("div", {
                style: {
                    flexGrow: 1,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-end",
                    overflow: "hidden",
                    backgroundPosition: "bottom",
                    backgroundSize: "contain",
                    backgroundRepeat: "no-repeat"
                },
                css: (0, $lhaLc.css)({
                    marginLeft: 32,
                    marginRight: 32
                }, (0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("min", "md", {
                    marginLeft: 64,
                    marginRight: 64
                }), (0, $6a1a23ca93758ec8$export$8b235cefb9710a9e)({
                    image: props.image,
                    width: 700,
                    format: "webp"
                }))
            }) : null
        ]
    });
}
(0, $eSiQ2.Component)($aa16a84e4a514505$export$b60a58e8d2266310, {
    name: "SeeAllCard",
    gallery: {
        path: "Cards/SeeAllCard",
        items: [
            {
                variants: [
                    {
                        props: {
                            heading: "Se hele v\xe5rt utvalg",
                            cta: {
                                text: "Vis alt (14)",
                                url: ""
                            },
                            image: `${(0, $7m9cQ.server)()}/static/redoit/see-all-card.png`
                        }
                    }
                ]
            }
        ]
    }
});





var $34lt5 = parcelRequire("34lt5");


/**
 * Same as PromotedProducts, presenting 4 promoted products from the product catalogue, but with
 * the products automatically selected based on some criteria.
 */ function $75e14dce901ce6bb$var$PromotedProductsAuto(section) {
    var _a;
    const offers = (0, $e18f565b44c7bc7d$export$88e20cfc122b8557)(section.phoneModels, undefined, undefined, undefined);
    const localize = (0, $aIeEI.useLocalize)();
    const formatAmount = (0, $b274814d74f89bd0$export$cd05f017078a61a8)();
    const phoneModels = (0, $e18f565b44c7bc7d$export$b99855a9ac1ee5b2)((_a = section.phoneModels) !== null && _a !== void 0 ? _a : null);
    if (!offers.data || !phoneModels.data) return (0, $4vwom.jsx)((0, $4vwom.Fragment), {});
    return (0, $4vwom.jsx)($75e14dce901ce6bb$var$PromotedProducts, Object.assign({}, section, {
        products: phoneModels.data.map((pm)=>{
            var _a, _b, _c, _d, _e, _f, _g;
            const offer = (_a = offers.data) === null || _a === void 0 ? void 0 : _a.find((o)=>o.model === pm.id);
            if (!offer) return {
                phoneModelId: pm.id,
                name: pm.name,
                features: (_c = (_b = pm.features) === null || _b === void 0 ? void 0 : _b.map((f)=>f.text)) !== null && _c !== void 0 ? _c : [],
                price: {
                    no: "Utsolgt",
                    en: "Sold out"
                },
                image: (_d = pm.images) === null || _d === void 0 ? void 0 : _d[0],
                relativePhysicalSize: pm.relativePhysicalSize,
                soldOut: true
            };
            return {
                phoneModelId: pm.id,
                phoneId: offer.id,
                name: offer.name,
                features: (_f = (_e = offer.features) === null || _e === void 0 ? void 0 : _e.map((f)=>f.text)) !== null && _f !== void 0 ? _f : [],
                price: {
                    no: `Fra ${formatAmount(offer.monthlyPrice.itemsTotal)}/${localize((0, $b274814d74f89bd0$export$b4b23bfab2f68498), (0, $34lt5.LocaleKey).no)}`,
                    en: `From ${formatAmount(offer.monthlyPrice.itemsTotal)}/${localize((0, $b274814d74f89bd0$export$b4b23bfab2f68498), (0, $34lt5.LocaleKey).en)}`
                },
                image: (_g = offer.images) === null || _g === void 0 ? void 0 : _g[0],
                relativePhysicalSize: offer.relativePhysicalSize
            };
        })
    }));
}
(0, $9G56J.Section)($75e14dce901ce6bb$var$PromotedProductsAuto);
/**
 * Section presenting 4 promoted products from the product catalogue. Renders as a grid on desktop
 * and list on mobile.
 */ function $75e14dce901ce6bb$var$PromotedProducts(section) {
    var _a, _b, _c, _d;
    const localize = (0, $aIeEI.useLocalize)();
    // NOTE: Apparently, judging from all the console errors, these can be undefined.
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    const productCtaPageInfo = (0, $dUDPg.useWebPageInfo)((_a = section.productCta.page) !== null && _a !== void 0 ? _a : null);
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    const seeAllCtaPageInfo = (0, $dUDPg.useWebPageInfo)((_b = section.seeAll.cta.page) !== null && _b !== void 0 ? _b : null);
    const localizeSlug = (0, $02ba3a727a0f8ecd$export$32f719dfac03c1cb)();
    if (!((_c = productCtaPageInfo.data) === null || _c === void 0 ? void 0 : _c.slug)) return (0, $4vwom.jsx)((0, $4vwom.Fragment), {});
    return (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
        direction: "column",
        css: (0, $lhaLc.css)((0, $756948b644e82cf2$export$f1cf1885b6bfef23)()),
        children: [
            (0, $4vwom.jsx)("div", {
                css: (0, $lhaLc.css)({
                    marginBottom: 16
                }, (0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("min", "md", {
                    marginBottom: 24
                })),
                children: (0, $4vwom.jsx)((0, $789b8639be592288$export$a8a3e93435678ff9), {
                    level: 2,
                    children: localize(section.heading)
                })
            }),
            (0, $4vwom.jsxs)((0, $bee1a5e35c892a21$export$e71c4d32a2263218), {
                css: (0, $lhaLc.css)({
                    display: "grid",
                    gridAutoFlow: "row",
                    gridTemplateRows: "1fr"
                }, (0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("min", "md", {
                    gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
                    gridTemplateAreas: '"C1 C2 C3" "C4 AA AA"',
                    gridTemplateRows: "1fr 1fr"
                }), (0, $aace75a797ac78f1$export$9c33585a37942ee0)("sm", "gap")),
                children: [
                    section.products.slice(0, 4).map((p, i)=>{
                        var _a, _b, _c, _d;
                        return (0, $4vwom.jsxs)((0, $eeH7J.Fragment), {
                            children: [
                                (0, $4vwom.jsx)((0, $bee1a5e35c892a21$export$e71c4d32a2263218), {
                                    css: (0, $lhaLc.css)((0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("max", "sm", {
                                        display: "none"
                                    }), (0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("min", "md", {
                                        gridArea: `C${i + 1}`
                                    })),
                                    children: (0, $4vwom.jsx)((0, $b7d6468cd3704e06$export$e6cbe35324ccf844), {
                                        disabled: p.soldOut,
                                        alwaysShowCta: section.productCta.alwaysShow,
                                        name: localize(p.name),
                                        features: p.features.map((f)=>localize(f)),
                                        price: localize(p.price),
                                        highlightPrice: p.highlightPrice,
                                        image: p.image,
                                        cta: p.soldOut || !p.phoneId ? undefined : {
                                            text: localize(section.productCta.text),
                                            url: `${localizeSlug((_a = productCtaPageInfo.data) === null || _a === void 0 ? void 0 : _a.slug)}?${(0, $f4c4c9282b17128a$export$cefacdcddab7996c)({
                                                phoneId: p.phoneId
                                            })}`
                                        },
                                        relativePhysicalSize: (_b = p.relativePhysicalSize) === null || _b === void 0 ? void 0 : _b.valueOf(),
                                        label: p.label ? {
                                            text: localize(p.label.text),
                                            color: p.label.color
                                        } : undefined
                                    })
                                }),
                                (0, $4vwom.jsx)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                                    direction: "column",
                                    gap: 16,
                                    css: (0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("min", "md", {
                                        display: "none"
                                    }),
                                    children: (0, $4vwom.jsx)((0, $b7d6468cd3704e06$export$e6cbe35324ccf844), {
                                        disabled: p.soldOut,
                                        name: localize(p.name),
                                        features: p.features.map((f)=>localize(f)),
                                        price: localize(p.price),
                                        image: p.image,
                                        highlightPrice: p.highlightPrice,
                                        relativePhysicalSize: (_c = p.relativePhysicalSize) === null || _c === void 0 ? void 0 : _c.valueOf(),
                                        label: p.label ? {
                                            text: localize(p.label.text),
                                            color: p.label.color
                                        } : undefined,
                                        cta: p.soldOut || !p.phoneId ? undefined : {
                                            text: localize(section.productCta.text),
                                            url: `${localizeSlug((_d = productCtaPageInfo.data) === null || _d === void 0 ? void 0 : _d.slug)}?${(0, $f4c4c9282b17128a$export$cefacdcddab7996c)({
                                                phoneId: p.phoneId
                                            })}`
                                        },
                                        compact: true
                                    })
                                })
                            ]
                        }, p.phoneModelId.valueOf());
                    }),
                    (0, $4vwom.jsx)((0, $bee1a5e35c892a21$export$e71c4d32a2263218), {
                        css: (0, $lhaLc.css)((0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("max", "xs", {
                            height: 280
                        }), (0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("min", "sm", {
                            minHeight: 372
                        }), (0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("min", "md", {
                            gridArea: "AA"
                        })),
                        children: (0, $4vwom.jsx)((0, $aa16a84e4a514505$export$b60a58e8d2266310), {
                            heading: localize(section.seeAll.heading),
                            cta: {
                                text: localize(section.seeAll.cta.text),
                                url: localizeSlug((_d = seeAllCtaPageInfo.data) === null || _d === void 0 ? void 0 : _d.slug)
                            },
                            image: section.seeAll.image
                        })
                    })
                ]
            })
        ]
    });
}
(0, $9G56J.Section)($75e14dce901ce6bb$var$PromotedProducts);



var $4vwom = parcelRequire("4vwom");

var $lhaLc = parcelRequire("lhaLc");

var $alVaN = parcelRequire("alVaN");
var $13a9f30e9fa4b734$exports = {};
!function(r, e) {
    $13a9f30e9fa4b734$exports = e();
}($13a9f30e9fa4b734$exports, function() {
    "use strict";
    return function(r, e, t) {
        r = r || {};
        var n = e.prototype, o = {
            future: "in %s",
            past: "%s ago",
            s: "a few seconds",
            m: "a minute",
            mm: "%d minutes",
            h: "an hour",
            hh: "%d hours",
            d: "a day",
            dd: "%d days",
            M: "a month",
            MM: "%d months",
            y: "a year",
            yy: "%d years"
        };
        function i(r, e, t, o) {
            return n.fromToBase(r, e, t, o);
        }
        t.en.relativeTime = o, n.fromToBase = function(e, n, i, d, u) {
            for(var f, a, s, l = i.$locale().relativeTime || o, h = r.thresholds || [
                {
                    l: "s",
                    r: 44,
                    d: "second"
                },
                {
                    l: "m",
                    r: 89
                },
                {
                    l: "mm",
                    r: 44,
                    d: "minute"
                },
                {
                    l: "h",
                    r: 89
                },
                {
                    l: "hh",
                    r: 21,
                    d: "hour"
                },
                {
                    l: "d",
                    r: 35
                },
                {
                    l: "dd",
                    r: 25,
                    d: "day"
                },
                {
                    l: "M",
                    r: 45
                },
                {
                    l: "MM",
                    r: 10,
                    d: "month"
                },
                {
                    l: "y",
                    r: 17
                },
                {
                    l: "yy",
                    d: "year"
                }
            ], m = h.length, c = 0; c < m; c += 1){
                var y = h[c];
                y.d && (f = d ? t(e).diff(i, y.d, !0) : i.diff(e, y.d, !0));
                var p = (r.rounding || Math.round)(Math.abs(f));
                if (s = f > 0, p <= y.r || !y.r) {
                    p <= 1 && c > 0 && (y = h[c - 1]);
                    var v = l[y.l];
                    u && (p = u("" + p)), a = "string" == typeof v ? v.replace("%d", p) : v(p, n, y.l, s);
                    break;
                }
            }
            if (n) return a;
            var M = s ? l.future : l.past;
            return "function" == typeof M ? M(a) : M.replace("%s", a);
        }, n.to = function(r, e) {
            return i(r, e, this, !0);
        }, n.from = function(r, e) {
            return i(r, e, this);
        };
        var d = function(r) {
            return r.$u ? t.utc() : t();
        };
        n.toNow = function(r) {
            return this.to(d(this), r);
        }, n.fromNow = function(r) {
            return this.from(d(this), r);
        };
    };
});



var $9G56J = parcelRequire("9G56J");

var $aIeEI = parcelRequire("aIeEI");



var $4vwom = parcelRequire("4vwom");

var $eeH7J = parcelRequire("eeH7J");

var $lhaLc = parcelRequire("lhaLc");

var $eSiQ2 = parcelRequire("eSiQ2");
parcelRequire("2LTO8");
var $dAwef = parcelRequire("dAwef");


var $4vwom = parcelRequire("4vwom");

var $lhaLc = parcelRequire("lhaLc");

var $eSiQ2 = parcelRequire("eSiQ2");


var $4vwom = parcelRequire("4vwom");

var $eSiQ2 = parcelRequire("eSiQ2");

var $c886316c6bbfde71$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
function $c886316c6bbfde71$export$72aac81228d325e1(_a) {
    var { css: css } = _a, rest = $c886316c6bbfde71$var$__rest(_a, [
        "css"
    ]);
    const { colors: colors } = (0, $756948b644e82cf2$export$559a0f07c8df6570)();
    return (0, $4vwom.jsx)("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 24 24"
    }, rest, {
        children: (0, $4vwom.jsx)("path", {
            fill: colors.forest,
            d: "M0 0v24h24V0H0Zm20.305 10.27c-1.473 1.25-2.946 2.5-4.424 3.745-.103.087-.111.162-.082.282.488 1.907.976 3.81 1.46 5.718.013.046.017.095.03.162-.071-.042-.12-.07-.175-.104-1.65-1.043-3.302-2.085-4.949-3.132-.111-.07-.19-.079-.306-.004-1.642 1.046-3.29 2.085-4.936 3.124-.054.033-.112.07-.203.124.178-.695.343-1.362.513-2.028.327-1.29.654-2.578.99-3.865.032-.124.016-.194-.084-.281-1.485-1.254-2.967-2.512-4.448-3.77-.033-.029-.062-.058-.124-.111.256-.021.476-.038.7-.05 1.245-.083 2.494-.161 3.74-.244.525-.033 1.055-.075 1.58-.1.125-.004.137-.086.17-.165l1.531-3.844c.215-.538.426-1.072.642-1.61.02-.054.045-.107.082-.186l.075.17c.724 1.825 1.452 3.645 2.176 5.47.046.12.108.161.236.17 1.457.09 2.913.19 4.366.285.414.03.823.05 1.237.079.108.008.215.016.356.029-.066.058-.108.1-.153.136Z"
        })
    }));
}
function $c886316c6bbfde71$export$67d4fc5adb232641(props) {
    const { colors: colors } = (0, $756948b644e82cf2$export$559a0f07c8df6570)();
    if (props.rating < 0 || props.rating > 5) // eslint-disable-next-line no-console
    console.warn("Prop `rating` should be between 1 and 5.");
    return (0, $4vwom.jsx)("div", {
        style: {
            display: "grid",
            gap: 2,
            gridAutoFlow: "column"
        },
        children: [
            1,
            2,
            3,
            4,
            5
        ].map((i)=>(0, $4vwom.jsx)("div", {
                style: {
                    display: "flex",
                    height: 20,
                    width: 20,
                    justifyContent: "center",
                    alignItems: "center",
                    backgroundColor: colors.grayWhite
                },
                children: (0, $4vwom.jsx)($c886316c6bbfde71$export$72aac81228d325e1, {
                    style: {
                        height: "100%",
                        width: "100%"
                    }
                })
            }, i))
    });
}
(0, $eSiQ2.Component)($c886316c6bbfde71$export$67d4fc5adb232641, {
    name: "RedoitStars",
    gallery: {
        items: [
            {
                variants: [
                    {
                        props: {
                            rating: 1
                        }
                    },
                    {
                        props: {
                            rating: 2
                        }
                    },
                    {
                        props: {
                            rating: 3
                        }
                    },
                    {
                        props: {
                            rating: 4
                        }
                    },
                    {
                        props: {
                            rating: 5
                        }
                    }
                ]
            }
        ]
    }
});






function $a5c835cc32440a49$export$82cac57774882155(props) {
    var _a;
    const backgroundColor = (_a = props.backgroundColor) !== null && _a !== void 0 ? _a : "gray100";
    return (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
        direction: "column",
        justifyContent: "space-between",
        backgroundColor: backgroundColor,
        borderRadius: "md",
        css: (0, $lhaLc.css)({
            height: 196,
            width: 296,
            padding: 16
        }, (0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("min", "md", {
            height: (0, $756948b644e82cf2$export$981516ee4691055c)(280),
            width: (0, $756948b644e82cf2$export$981516ee4691055c)(480),
            padding: 24
        }), (0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("min", "lg", {
            height: (0, $756948b644e82cf2$export$981516ee4691055c)(290),
            width: (0, $756948b644e82cf2$export$981516ee4691055c)(550),
            padding: 24
        })),
        children: [
            (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                justifyContent: "space-between",
                alignItems: "center",
                children: [
                    (0, $4vwom.jsx)((0, $c886316c6bbfde71$export$67d4fc5adb232641), {
                        rating: props.rating
                    }),
                    (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                        variant: "label",
                        size: "md",
                        children: props.timestamp
                    })
                ]
            }),
            (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                direction: "column",
                margin: {
                    y: 20
                },
                shrink: 1,
                style: {
                    overflow: "hidden"
                },
                children: [
                    (0, $4vwom.jsx)("div", {
                        css: (0, $lhaLc.css)({
                            marginBottom: 4
                        }, (0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("min", "md", {
                            marginBottom: 12
                        })),
                        children: (0, $4vwom.jsx)((0, $789b8639be592288$export$a8a3e93435678ff9), {
                            level: 3,
                            children: props.title
                        })
                    }),
                    (0, $4vwom.jsx)("div", {
                        style: {
                            flexShrink: 1
                        },
                        children: (0, $4vwom.jsx)((0, $72c5ae9e0017e167$export$4b2c32e08f77ff18), {
                            size: "md",
                            color: "gray400",
                            style: {
                                overflow: "hidden",
                                display: "-webkit-box",
                                WebkitLineClamp: "3",
                                lineClamp: "3",
                                textOverflow: "ellipsis",
                                WebkitBoxOrient: "vertical"
                            },
                            children: props.text
                        })
                    })
                ]
            }),
            (0, $4vwom.jsx)("div", {
                css: (0, $lhaLc.css)((0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("min", "md", {
                    padding: 10
                })),
                children: (0, $4vwom.jsx)((0, $789b8639be592288$export$a8a3e93435678ff9), {
                    level: 4,
                    children: props.name
                })
            })
        ]
    });
}
(0, $eSiQ2.Component)($a5c835cc32440a49$export$82cac57774882155, {
    name: "ReviewCard",
    gallery: {
        path: "Cards/ReviewCard",
        items: [
            {
                variants: [
                    {
                        props: {
                            title: "Impressive!",
                            rating: 5,
                            name: "John",
                            text: "This service was so impressive, I won't hesitate to use it again.",
                            timestamp: "2 days ago"
                        }
                    }
                ]
            },
            {
                variants: [
                    {
                        props: {
                            title: "Impressive!",
                            rating: 5,
                            name: "John",
                            text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla diam sem, sagittis et nisl eget, sagittis varius tortor. Aenean id arcu et erat tristique posuere. Integer quis leo dictum, iaculis augue at, fringilla augue. Nullam eu enim mauris.",
                            timestamp: "2 days ago"
                        }
                    }
                ]
            }
        ]
    }
});



var $e0d6729bf3c3c3ec$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $e0d6729bf3c3c3ec$var$defaultSpeed = 30;
function $e0d6729bf3c3c3ec$export$a606a0d663523950(props) {
    var _a;
    const ref = (0, $eeH7J.useRef)(null);
    const [size, setSize] = (0, $eeH7J.useState)(0);
    const direction = (_a = props.direction) !== null && _a !== void 0 ? _a : "row";
    (0, $eeH7J.useEffect)(()=>{
        var _a;
        const rect = (_a = ref.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
        if (rect) setSize(rect[direction === "row" ? "width" : "height"]);
    }, [
        direction
    ]);
    const animationDuration = (0, $eeH7J.useMemo)(()=>{
        var _a;
        return `${size / ((_a = props.speed) !== null && _a !== void 0 ? _a : $e0d6729bf3c3c3ec$var$defaultSpeed) * 1000}ms`;
    }, [
        props.speed,
        size
    ]);
    const reviewElements = (0, $eeH7J.useMemo)(()=>/*#__PURE__*/ (0, $eeH7J.cloneElement)((0, $4vwom.jsx)((0, $4vwom.Fragment), {
            children: props.reviews.map((_a)=>{
                var _b;
                var { id: id } = _a, review = $e0d6729bf3c3c3ec$var$__rest(_a, [
                    "id"
                ]);
                return (0, $4vwom.jsx)("div", {
                    css: (0, $lhaLc.css)((0, $aace75a797ac78f1$export$9c33585a37942ee0)("sm", direction === "row" ? "marginLeft" : "marginTop")),
                    children: (0, $4vwom.jsx)((0, $a5c835cc32440a49$export$82cac57774882155), Object.assign({}, review, (_b = props.ReviewCardProps) !== null && _b !== void 0 ? _b : {}))
                }, id);
            })
        })), [
        props.ReviewCardProps,
        direction,
        props.reviews
    ]);
    const animationCss = (0, $lhaLc.css)({
        display: "flex",
        flexDirection: direction,
        animationName: direction === "row" ? $e0d6729bf3c3c3ec$var$horizontalScroll : $e0d6729bf3c3c3ec$var$verticalScroll
    });
    return (0, $4vwom.jsxs)("div", {
        style: {
            position: "relative",
            flexWrap: "nowrap",
            display: "flex",
            flexDirection: direction,
            [direction === "row" ? "width" : "height"]: "100%"
        },
        css: $e0d6729bf3c3c3ec$var$containerCss,
        children: [
            (0, $4vwom.jsx)("div", {
                ref: ref,
                style: {
                    animationDuration: animationDuration
                },
                css: [
                    $e0d6729bf3c3c3ec$var$responsiveGridCss,
                    animationCss
                ],
                children: reviewElements
            }),
            (0, $4vwom.jsx)("div", {
                "aria-hidden": true,
                style: {
                    animationDuration: animationDuration
                },
                css: [
                    $e0d6729bf3c3c3ec$var$responsiveGridCss,
                    animationCss
                ],
                children: reviewElements
            }),
            (0, $4vwom.jsx)("div", {
                "aria-hidden": true,
                style: {
                    animationDuration: animationDuration
                },
                css: [
                    $e0d6729bf3c3c3ec$var$responsiveGridCss,
                    animationCss
                ],
                children: reviewElements
            }),
            (0, $4vwom.jsx)("div", {
                "aria-hidden": true,
                style: {
                    animationDuration: animationDuration
                },
                css: [
                    $e0d6729bf3c3c3ec$var$responsiveGridCss,
                    animationCss
                ],
                children: reviewElements
            }),
            (0, $4vwom.jsx)("div", {
                "aria-hidden": true,
                style: {
                    animationDuration: animationDuration
                },
                css: [
                    $e0d6729bf3c3c3ec$var$responsiveGridCss,
                    animationCss
                ],
                children: reviewElements
            })
        ]
    });
}
const $e0d6729bf3c3c3ec$var$verticalScroll = (0, $lhaLc.keyframes)({
    from: {
        transform: "translateY(-200%)"
    },
    to: {
        transform: "translateY(-300%)"
    }
});
const $e0d6729bf3c3c3ec$var$horizontalScroll = (0, $lhaLc.keyframes)({
    from: {
        transform: "translateX(-200%)"
    },
    to: {
        transform: "translateX(-300%)"
    }
});
const $e0d6729bf3c3c3ec$var$responsiveGridCss = (0, $lhaLc.css)({
    display: "inline-flex",
    alignItems: "center",
    animationIterationCount: "infinite",
    animationTimingFunction: "linear"
});
const $e0d6729bf3c3c3ec$var$containerCss = (0, $e82ba787de72625c$export$601469075a80284e)({
    "&:hover div": {
        userSelect: "none",
        animationPlayState: "paused"
    }
});
(0, $eSiQ2.Component)($e0d6729bf3c3c3ec$export$a606a0d663523950, {
    name: "ReviewsCarousel",
    gallery: {
        path: "Carousel",
        items: [
            {
                variants: [
                    {
                        props: {
                            reviews: [
                                ...new Array(3)
                            ].map((_, index, arr)=>({
                                    id: (0, $dAwef.Uuid)().valueOf(),
                                    title: "Impressive!",
                                    rating: 5,
                                    name: "John",
                                    text: "This service was so impressive, I won't hesitate to use it again.",
                                    timestamp: `${arr.length - index} days ago`
                                }))
                        }
                    }
                ]
            }
        ]
    }
});









var $f757eace85782171$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
/**
 * @icon ui-message-heart-square
 */ function $f757eace85782171$var$PromotedReviews(section) {
    var _a, _b;
    const localize = (0, $aIeEI.useLocalize)();
    const reviews = (0, $e18f565b44c7bc7d$export$dfd0f591c1636cc4)();
    (0, (/*@__PURE__*/$parcel$interopDefault($alVaN))).extend((0, (/*@__PURE__*/$parcel$interopDefault($13a9f30e9fa4b734$exports))));
    if (reviews.loading) return (0, $4vwom.jsx)((0, $4vwom.Fragment), {});
    return (0, $4vwom.jsxs)("div", {
        css: (0, $lhaLc.css)({
            display: "flex",
            flexDirection: "column"
        }, (0, $756948b644e82cf2$export$f1cf1885b6bfef23)()),
        children: [
            (0, $4vwom.jsx)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                alignItems: "center",
                justifyContent: "space-between",
                children: (0, $4vwom.jsx)((0, $789b8639be592288$export$a8a3e93435678ff9), {
                    level: 2,
                    padding: {
                        y: 8
                    },
                    truncate: true,
                    children: localize(section.heading)
                })
            }),
            section.text && (0, $4vwom.jsx)((0, $72c5ae9e0017e167$export$4b2c32e08f77ff18), {
                size: "lg",
                color: "gray400",
                margin: {
                    bottom: "sm"
                },
                children: localize(section.text)
            }),
            (0, $4vwom.jsx)("div", {
                style: {
                    overflow: "hidden",
                    width: "100vw",
                    marginLeft: "calc(50% - 50vw)"
                },
                children: (0, $4vwom.jsx)((0, $e0d6729bf3c3c3ec$export$a606a0d663523950), {
                    reviews: (_b = (_a = reviews.data) === null || _a === void 0 ? void 0 : _a.reviews.map((_a)=>{
                        var { id: id, rating: rating } = _a, r = $f757eace85782171$var$__rest(_a, [
                            "id",
                            "rating"
                        ]);
                        return {
                            id: id.valueOf(),
                            rating: rating.valueOf(),
                            name: localize(r.name),
                            title: localize(r.title),
                            text: localize(r.text),
                            timestamp: (Date.now() - new Date(r.timestamp.valueOf()).valueOf()) / 86400000 > 7 ? (0, (/*@__PURE__*/$parcel$interopDefault($alVaN)))(r.timestamp.valueOf()).format("DD.MM.YYYY") : (0, (/*@__PURE__*/$parcel$interopDefault($alVaN)))(r.timestamp.valueOf()).fromNow()
                        };
                    })) !== null && _b !== void 0 ? _b : [],
                    speed: section.carouselSpeed
                })
            }),
            section.cta ? (0, $4vwom.jsx)((0, $bee1a5e35c892a21$export$e71c4d32a2263218), {
                margin: {
                    top: "sm"
                },
                children: (0, $4vwom.jsxs)((0, $4b4086f8a1c6b2f8$export$353f5b6fc5456de1), {
                    size: "md",
                    variant: "secondary",
                    iconEnd: "arrowRight",
                    css: (0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("max", "xs", {
                        width: "100%"
                    }),
                    as: "a",
                    href: section.cta.url.valueOf(),
                    children: [
                        (0, $4vwom.jsx)("div", {
                            css: (0, $lhaLc.css)((0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("max", "xs", {
                                display: "none"
                            })),
                            children: (0, $4vwom.jsx)((0, $f8cdd04128a131cf$export$f04a61298a47a40f), {
                                icon: "trustpilot",
                                margin: {
                                    right: 8
                                }
                            })
                        }),
                        localize(section.cta.text)
                    ]
                })
            }) : null
        ]
    });
}
(0, $9G56J.Section)($f757eace85782171$var$PromotedReviews);



var $4vwom = parcelRequire("4vwom");

var $lhaLc = parcelRequire("lhaLc");

var $9G56J = parcelRequire("9G56J");

var $aIeEI = parcelRequire("aIeEI");

var $4vwom = parcelRequire("4vwom");

var $lhaLc = parcelRequire("lhaLc");


var $eSiQ2 = parcelRequire("eSiQ2");




const $b5697d901823e04f$var$themes = {
    light: {
        backgroundColor: "gray100",
        textColor: "gray500",
        iconColor: "forest",
        borderColor: "gray200"
    },
    dark: {
        backgroundColor: "gray500",
        textColor: "grayWhite",
        iconColor: "highlight",
        borderColor: "gray400"
    }
};
function $b5697d901823e04f$export$d02301dd4aaaa084(props) {
    var _a, _b;
    const theme = (_a = props.theme) !== null && _a !== void 0 ? _a : "light";
    const { helpers: helpers, colors: colors } = (0, $756948b644e82cf2$export$559a0f07c8df6570)();
    const { responsiveCss: responsiveCss } = helpers;
    const stackBreakpoint = (_b = props.stackBreakpoint) !== null && _b !== void 0 ? _b : "md";
    return (0, $4vwom.jsx)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
        borderRadius: props.fullWidth ? undefined : "lg",
        justifyContent: "center",
        css: (0, $lhaLc.css)(props.fullWidth && {
            width: "100vw",
            marginLeft: "calc(50% - 50vw)"
        }, {
            backgroundColor: colors[$b5697d901823e04f$var$themes[theme].backgroundColor]
        }, theme === "light" && responsiveCss("max", stackBreakpoint, {
            backgroundColor: "transparent"
        }), theme === "dark" && responsiveCss("max", stackBreakpoint, {
            paddingTop: (0, $756948b644e82cf2$export$981516ee4691055c)(24),
            paddingBottom: (0, $756948b644e82cf2$export$981516ee4691055c)(24)
        })),
        children: (0, $4vwom.jsx)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
            justifyContent: "space-evenly",
            css: (0, $lhaLc.css)({
                flexDirection: "row",
                padding: (0, $756948b644e82cf2$export$981516ee4691055c)(18)
            }, responsiveCss("max", stackBreakpoint, {
                flexDirection: "column",
                padding: 0
            }), props.fullWidth ? (0, $756948b644e82cf2$export$629e292a677297c2)() : {
                width: "100%"
            }),
            children: props.items.map((item)=>{
                var _a, _b;
                return (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                    margin: {
                        x: 12
                    },
                    css: responsiveCss("max", stackBreakpoint, {
                        borderTop: `1px solid ${colors[$b5697d901823e04f$var$themes[theme].borderColor]}`,
                        margin: 0,
                        paddingTop: 16,
                        paddingBottom: 16,
                        "&:first-of-type": ((_a = props.divider) === null || _a === void 0 ? void 0 : _a.top) ? undefined : {
                            borderTop: "none",
                            paddingTop: 0
                        },
                        "&:last-of-type": ((_b = props.divider) === null || _b === void 0 ? void 0 : _b.bottom) ? {
                            borderBottom: `1px solid ${colors[$b5697d901823e04f$var$themes[theme].borderColor]}`
                        } : {
                            paddingBottom: 0
                        }
                    }),
                    alignItems: "center",
                    children: [
                        (0, $4vwom.jsx)("div", {
                            children: (0, $4vwom.jsx)((0, $f8cdd04128a131cf$export$f04a61298a47a40f), {
                                icon: "check",
                                color: $b5697d901823e04f$var$themes[theme].iconColor
                            })
                        }),
                        (0, $4vwom.jsx)("div", {
                            css: (0, $lhaLc.css)({
                                marginLeft: 10,
                                marginTop: 0,
                                color: colors[$b5697d901823e04f$var$themes[theme].textColor]
                            }, responsiveCss("max", stackBreakpoint, {
                                marginLeft: 8
                            })),
                            children: (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                variant: "body",
                                size: "md",
                                children: (0, $4vwom.jsx)("div", {
                                    style: {
                                        fontWeight: "normal"
                                    },
                                    children: item
                                })
                            })
                        })
                    ]
                }, item);
            })
        })
    });
}
(0, $eSiQ2.Component)($b5697d901823e04f$export$d02301dd4aaaa084, {
    name: "UniqueSellingPoints",
    gallery: {
        items: [
            {
                variants: [
                    {
                        props: {
                            items: [
                                "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
                                "Donec eget fermentum lorem. Phasellus vulputate tortor a augue commodo efficitur.",
                                "Vestibulum efficitur tortor ante, quis varius tortor blandit in."
                            ]
                        }
                    }
                ]
            }
        ]
    }
});



function $487a5c3b29120f99$var$UniqueSellingPoints(section) {
    var _a, _b;
    const localize = (0, $aIeEI.useLocalize)();
    return (0, $4vwom.jsx)("div", {
        css: (0, $lhaLc.css)(!section.fullWidth && ((_a = section.spacing) === null || _a === void 0 ? void 0 : _a.top) && (0, $aace75a797ac78f1$export$9c33585a37942ee0)(section.spacing.top, "paddingTop"), !section.fullWidth && ((_b = section.spacing) === null || _b === void 0 ? void 0 : _b.bottom) && (0, $aace75a797ac78f1$export$9c33585a37942ee0)(section.spacing.bottom, "paddingBottom"), section.hideBreakpoint && (0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("max", section.hideBreakpoint, {
            display: "none"
        })),
        children: (0, $4vwom.jsx)((0, $b5697d901823e04f$export$d02301dd4aaaa084), {
            fullWidth: section.fullWidth,
            theme: section.theme,
            stackBreakpoint: section.stackBreakpoint,
            items: section.uniqueSellingPoints.map((item)=>localize(item.text)),
            divider: section.divider
        })
    });
}
(0, $9G56J.Section)("UniqueSellingPoints", $487a5c3b29120f99$var$UniqueSellingPoints);



var $4vwom = parcelRequire("4vwom");

var $eeH7J = parcelRequire("eeH7J");

var $9G56J = parcelRequire("9G56J");

var $aIeEI = parcelRequire("aIeEI");

var $4vwom = parcelRequire("4vwom");

var $eeH7J = parcelRequire("eeH7J");

var $eSiQ2 = parcelRequire("eSiQ2");

var $aIeEI = parcelRequire("aIeEI");





parcelRequire("2LTO8");
var $2uVAW = parcelRequire("2uVAW");
var $gGZ2r = parcelRequire("gGZ2r");




function $6fd7eb60c364c4b3$export$f844f713529fc0d1(props) {
    const emailInputRef = (0, $eeH7J.useRef)(null);
    const localize = (0, $aIeEI.useLocalize)();
    const [formValues, setFormValues] = (0, $eeH7J.useState)($6fd7eb60c364c4b3$var$initialFormValue);
    const setFormValue = (0, $eeH7J.useCallback)((key, value)=>{
        setFormValues(Object.assign(Object.assign({}, formValues), {
            [key]: value
        }));
    }, [
        formValues,
        setFormValues
    ]);
    const [emailIsValid, setEmailIsValid] = (0, $eeH7J.useState)();
    const validatedFormValues = (0, $eeH7J.useMemo)(()=>{
        try {
            return Object.assign(Object.assign({}, formValues), {
                email: (0, $2uVAW.Email)(formValues.email)
            });
        } catch (err) {
            return undefined;
        }
    }, [
        formValues
    ]);
    const validateEmail = (0, $eeH7J.useCallback)(()=>{
        try {
            (0, $2uVAW.Email)(formValues.email);
            setEmailIsValid(true);
            return true;
        } catch (err) {
            setEmailIsValid(false);
            return false;
        }
    }, [
        formValues.email
    ]);
    const handleSubmitButtonClick = (0, $eeH7J.useCallback)(()=>{
        var _a;
        if (validatedFormValues) props.onSubmit(validatedFormValues);
        else (_a = emailInputRef.current) === null || _a === void 0 || _a.focus();
    }, [
        props,
        validatedFormValues
    ]);
    const handleClose = (0, $eeH7J.useCallback)(()=>{
        var _a;
        setFormValues($6fd7eb60c364c4b3$var$initialFormValue);
        setEmailIsValid(undefined);
        (_a = props.onClose) === null || _a === void 0 || _a.call(props);
    }, [
        props
    ]);
    return (0, $4vwom.jsx)((0, $37d4981a6b4c97c0$export$2b77a92f1a5ad772), {
        isOpen: props.isOpen,
        header: {
            title: props.title,
            closeButton: true
        },
        onClose: handleClose,
        children: props.submitSuccess ? (0, $4vwom.jsxs)("div", {
            style: {
                display: "grid",
                gridAutoFlow: "row",
                gap: 24
            },
            children: [
                (0, $4vwom.jsx)((0, $82d66b15b8f4758d$export$d5163f1ce1e6a5f9), {
                    value: props.successMessage
                }),
                (0, $4vwom.jsx)((0, $4b4086f8a1c6b2f8$export$353f5b6fc5456de1), {
                    variant: "secondary",
                    onClick: props.onClose,
                    children: localize({
                        no: "Lukk",
                        en: "Close"
                    })
                })
            ]
        }) : (0, $4vwom.jsxs)("div", {
            style: {
                display: "grid",
                gridAutoFlow: "row",
                gap: 24
            },
            children: [
                (0, $4vwom.jsx)((0, $72c5ae9e0017e167$export$4b2c32e08f77ff18), {
                    size: "xl",
                    children: props.text
                }),
                (0, $4vwom.jsx)((0, $46d788785e7b9d76$export$c86715117507e8e5), {
                    type: "email",
                    autoComplete: "email",
                    ref: emailInputRef,
                    label: props.form.email.label,
                    value: formValues.email,
                    state: emailIsValid === false ? "error" : emailIsValid === true ? "completed" : undefined,
                    onChange: (e)=>{
                        if (emailIsValid === false) validateEmail();
                        setFormValue("email", e.target.value);
                    },
                    onBlur: validateEmail,
                    warning: emailIsValid === false ? localize($6fd7eb60c364c4b3$var$invalidEmailMessage) : undefined
                }),
                (0, $4vwom.jsx)((0, $50112aaf62b7ce57$export$ef9b1a59e592288f), {
                    label: props.form.phoneModel.label,
                    placeholder: localize($6fd7eb60c364c4b3$var$optionalTextLocalized),
                    options: props.form.phoneModel.options.map((o)=>({
                            value: o,
                            text: o
                        })),
                    value: formValues.phoneModel,
                    onChange: (e)=>setFormValue("phoneModel", e.target.value)
                }),
                (0, $4vwom.jsx)((0, $50112aaf62b7ce57$export$ef9b1a59e592288f), {
                    label: props.form.rentalPeriod.label,
                    placeholder: localize($6fd7eb60c364c4b3$var$optionalTextLocalized),
                    options: props.form.rentalPeriod.options,
                    value: formValues.rentalPeriod,
                    onChange: (e)=>setFormValue("rentalPeriod", e.target.value)
                }),
                (0, $4vwom.jsx)((0, $06e3a36d2d83b339$export$48513f6b9f8ce62d), {
                    checked: formValues.newsletterConsent,
                    onChange: (e)=>setFormValue("newsletterConsent", e.target.checked),
                    label: props.form.newsletterConsent.label
                }),
                props.errorMessage ? (0, $4vwom.jsx)((0, $a9f507254d800340$export$fbbf1dbfdbfcef12), {
                    margin: 0,
                    children: (0, $4vwom.jsx)((0, $82d66b15b8f4758d$export$d5163f1ce1e6a5f9), {
                        value: props.errorMessage,
                        renderers: {
                            paragraph: (p)=>(0, $4vwom.jsx)("div", {
                                    children: p.children
                                })
                        }
                    })
                }) : null,
                (0, $4vwom.jsxs)("div", {
                    style: {
                        display: "grid",
                        gridAutoFlow: "row",
                        gap: 8
                    },
                    children: [
                        (0, $4vwom.jsx)((0, $4b4086f8a1c6b2f8$export$353f5b6fc5456de1), {
                            onClick: handleSubmitButtonClick,
                            children: props.submitButtonText
                        }),
                        props.submitButtonSubText ? (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                            variant: "body",
                            size: "sm",
                            color: "gray300",
                            style: {
                                textAlign: "center"
                            },
                            children: (0, $4vwom.jsx)((0, $82d66b15b8f4758d$export$d5163f1ce1e6a5f9), {
                                value: props.submitButtonSubText,
                                renderers: {
                                    paragraph: (p)=>(0, $4vwom.jsx)("div", {
                                            children: p.children
                                        })
                                }
                            })
                        }) : null
                    ]
                })
            ]
        })
    });
}
const $6fd7eb60c364c4b3$var$optionalTextLocalized = {
    no: "Valgfritt",
    en: "Optional"
};
const $6fd7eb60c364c4b3$var$initialFormValue = {
    email: "",
    phoneModel: "",
    rentalPeriod: "",
    newsletterConsent: false
};
const $6fd7eb60c364c4b3$var$invalidEmailMessage = {
    no: "Ugyldig e-postadresse.",
    en: "Invalid email address."
};
(0, $eSiQ2.Component)($6fd7eb60c364c4b3$export$f844f713529fc0d1, {
    name: "WaitingListSignupModal",
    gallery: {
        path: "Modal/WaitingListSignupModal",
        items: [
            {
                variants: [
                    {
                        props: {
                            title: "Stay up to date",
                            text: (0, $gGZ2r.Markdown)("We're super excited to let you in on a little secret \u2013 something amazing is coming your way soon! Get ready to be wowed by the future of Redoing it. Stay in the loop by signing up for exclusive updates and be the first to know when we go live. Thanks for sticking with us \u2013 we promise it'll be worth the wait!"),
                            submitButtonText: "Sign up",
                            isOpen: true,
                            onSubmit: (consent)=>{
                                // eslint-disable-next-line no-console
                                console.log("Submitted", consent);
                            },
                            form: {
                                email: {
                                    label: "E-postadresse"
                                },
                                phoneModel: {
                                    label: "Velg telefonmodell",
                                    options: [
                                        "iPhone 12",
                                        "iPhone 13"
                                    ]
                                },
                                rentalPeriod: {
                                    label: "Velg leieperiode",
                                    options: [
                                        {
                                            value: "1",
                                            text: "1 \xe5r"
                                        },
                                        {
                                            value: "2",
                                            text: "2 \xe5r"
                                        }
                                    ]
                                },
                                newsletterConsent: {
                                    label: "Jeg \xf8nsker \xe5 motta nyhetsbrev fra Redoit"
                                }
                            },
                            successMessage: (0, $gGZ2r.Markdown)("Success!")
                        }
                    }
                ]
            }
        ]
    }
});



const $942ca7574d2f9349$var$waitingListSignupModalId = "waiting-list-signup-modal";
/**
 * @icon ui-at-sign
 */ function $942ca7574d2f9349$var$WaitingListSignupModal(section) {
    const localize = (0, $aIeEI.useLocalize)();
    const modalRef = (0, $eeH7J.useRef)(null);
    const [modalIsOpen, setModalIsOpen] = (0, $eeH7J.useState)(false);
    const [submitSuccess, setSubmitSuccess] = (0, $eeH7J.useState)(false);
    const [submitError, setSubmitError] = (0, $eeH7J.useState)(false);
    const openModal = (0, $eeH7J.useCallback)(()=>{
        setModalIsOpen(true);
    }, [
        setModalIsOpen
    ]);
    const closeModal = (0, $eeH7J.useCallback)(()=>{
        setModalIsOpen(false);
    }, [
        setModalIsOpen
    ]);
    (0, $eeH7J.useEffect)(()=>{
        const ref = modalRef.current;
        ref === null || ref === void 0 || ref.addEventListener("open", openModal);
        return ()=>{
            ref === null || ref === void 0 || ref.removeEventListener("open", openModal);
        };
    }, [
        openModal
    ]);
    const locale = (0, $aIeEI.useCurrentLocale)();
    const handleSubmit = (0, $eeH7J.useCallback)(async (formData)=>{
        const data = {
            email: formData.email,
            phoneModel: formData.phoneModel || undefined,
            rentalPeriod: formData.rentalPeriod ? parseInt(formData.rentalPeriod) : undefined,
            newsletterConsent: formData.newsletterConsent,
            locale: locale
        };
        try {
            setSubmitError(false);
            await (0, $e18f565b44c7bc7d$export$2884e3ad03eef48)(data);
            setSubmitSuccess(true);
        } catch (err) {
            setSubmitError(true);
        }
        if (typeof fbq !== "undefined") fbq("track", "Lead");
    }, [
        setSubmitSuccess,
        setSubmitError,
        locale
    ]);
    return (0, $4vwom.jsx)("div", {
        id: $942ca7574d2f9349$var$waitingListSignupModalId,
        ref: modalRef,
        children: (0, $4vwom.jsx)((0, $6fd7eb60c364c4b3$export$f844f713529fc0d1), {
            isOpen: modalIsOpen,
            onClose: closeModal,
            title: localize(section.title),
            text: section.text ? localize(section.text) : undefined,
            form: {
                email: {
                    label: localize(section.emailInputLabel)
                },
                phoneModel: {
                    label: localize(section.phoneModelLabel),
                    options: section.phoneModelOptions.map((pmo)=>localize(pmo))
                },
                rentalPeriod: {
                    label: localize(section.rentalPeriodLabel),
                    options: [
                        ...Array(section.rentalPeriodMax)
                    ].map((_, i)=>({
                            value: `${i + 1}`,
                            text: `${i + 1} ${localize(section.rentalPeriodUnitLabel)}`
                        }))
                },
                newsletterConsent: {
                    label: localize(section.consentCheckboxLabel)
                }
            },
            submitButtonText: localize(section.signupButtonText),
            submitButtonSubText: localize(section.signupButtonSubText),
            onSubmit: handleSubmit,
            submitSuccess: submitSuccess,
            successMessage: localize(section.successMessage),
            errorMessage: submitError ? localize(section.errorMessage) : undefined
        })
    });
}
function $942ca7574d2f9349$export$d0de6de1c3580f91(source, e) {
    if (typeof window !== "undefined") {
        (0, $e18f565b44c7bc7d$export$a5a1f41fba9e8ed4)(source);
        const el = window.document.getElementById($942ca7574d2f9349$var$waitingListSignupModalId);
        const openModalEvent = new Event("open");
        el === null || el === void 0 || el.dispatchEvent(openModalEvent);
    }
    e === null || e === void 0 || e.preventDefault();
}
(0, $9G56J.Section)($942ca7574d2f9349$var$WaitingListSignupModal);



var $4vwom = parcelRequire("4vwom");

var $9G56J = parcelRequire("9G56J");

var $aIeEI = parcelRequire("aIeEI");
parcelRequire("2LTO8");
var $14q7s = parcelRequire("14q7s");







function $e44ce30914311b18$var$WaitingListTrigger(section) {
    const localize = (0, $aIeEI.useLocalize)();
    return (0, $4vwom.jsx)("div", {
        css: (0, $756948b644e82cf2$export$f1cf1885b6bfef23)(),
        children: (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
            alignItems: "center",
            justifyContent: "center",
            borderRadius: "lg",
            direction: "column",
            padding: 24,
            style: Object.assign({
                textAlign: "center",
                height: 300
            }, section.backgroundImage ? {
                backgroundImage: (0, $14q7s.ImageToCSS)(section.backgroundImage),
                backgroundSize: "cover",
                backgroundPosition: "center"
            } : {}),
            backgroundColor: section.backgroundColor,
            children: [
                section.heading ? (0, $4vwom.jsx)((0, $789b8639be592288$export$a8a3e93435678ff9), {
                    level: 1,
                    margin: {
                        bottom: (0, $756948b644e82cf2$export$981516ee4691055c)(24)
                    },
                    color: section.textColor,
                    children: localize(section.heading)
                }) : null,
                section.text ? (0, $4vwom.jsx)("div", {
                    style: {
                        marginBottom: (0, $756948b644e82cf2$export$981516ee4691055c)(24)
                    },
                    children: (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                        variant: "body",
                        size: "lg",
                        color: section.textColor,
                        children: localize(section.text)
                    })
                }) : null,
                (0, $4vwom.jsx)((0, $4b4086f8a1c6b2f8$export$353f5b6fc5456de1), {
                    variant: "dark",
                    size: "md",
                    onClick: ()=>{
                        var _a;
                        return (0, $942ca7574d2f9349$export$d0de6de1c3580f91)((_a = section.source) !== null && _a !== void 0 ? _a : "waiting-list-trigger");
                    },
                    children: localize(section.ctaText)
                })
            ]
        })
    });
}
(0, $9G56J.Section)($e44ce30914311b18$var$WaitingListTrigger);



var $4vwom = parcelRequire("4vwom");

var $eeH7J = parcelRequire("eeH7J");

var $lhaLc = parcelRequire("lhaLc");

var $aIeEI = parcelRequire("aIeEI");


var $dUDPg = parcelRequire("dUDPg");






var $9G56J = parcelRequire("9G56J");




var $4vwom = parcelRequire("4vwom");

var $eeH7J = parcelRequire("eeH7J");

function $1516a01fcc6e5048$export$ce1fcb9bf7d61ea1(props) {
    const { colors: colors } = (0, $756948b644e82cf2$export$559a0f07c8df6570)();
    const [lock, setLock] = (0, $eeH7J.useState)(null);
    return (0, $4vwom.jsxs)("div", {
        style: {
            height: 32,
            position: "relative"
        },
        children: [
            (0, $4vwom.jsx)("div", {
                style: {
                    pointerEvents: "none",
                    userSelect: "none",
                    position: "absolute",
                    width: 32,
                    height: 32,
                    boxShadow: "0px 2px 8px 0px #1307221F",
                    borderRadius: 32,
                    top: 0,
                    left: `${props.left * 90}%`,
                    zIndex: 10,
                    backgroundColor: "white"
                }
            }),
            (0, $4vwom.jsx)("div", {
                style: {
                    pointerEvents: "none",
                    userSelect: "none",
                    position: "absolute",
                    width: 32,
                    height: 32,
                    boxShadow: "0px 2px 8px 0px #1307221F",
                    borderRadius: 32,
                    top: 0,
                    right: `${(1 - props.right) * 90}%`,
                    zIndex: 10,
                    backgroundColor: "white"
                }
            }),
            (0, $4vwom.jsx)("div", {
                onPointerDown: (e)=>{
                    e.currentTarget.setPointerCapture(e.pointerId);
                    const rect = e.currentTarget.getBoundingClientRect();
                    const x = (e.clientX - rect.left) / rect.width;
                    const distLeft = Math.abs(x - props.left);
                    const distRight = Math.abs(x - props.right);
                    if (distLeft < distRight) setLock("left");
                    else setLock("right");
                },
                onPointerUp: ()=>setLock(null),
                onPointerMove: (e)=>{
                    const rect = e.currentTarget.getBoundingClientRect();
                    const x = (e.clientX - rect.left) / rect.width;
                    if (lock === "left") props.setLeft(Math.max(0, Math.min(x, props.right - 0.1)));
                    if (lock === "right") props.setRight(Math.min(1, Math.max(x, props.left + 0.1)));
                },
                style: {
                    height: 32,
                    width: "100%"
                }
            }),
            (0, $4vwom.jsx)("div", {
                style: {
                    position: "absolute",
                    top: "50%",
                    transform: "translateY(-50%)",
                    height: 4,
                    borderRadius: 4,
                    backgroundColor: colors.brand,
                    width: "100%",
                    zIndex: -1
                }
            })
        ]
    });
}













(0, $9G56J.Section)($8a1361c8e89a1a34$var$AllProducts);
/**
 * Section presenting all available products.
 */ function $8a1361c8e89a1a34$var$AllProducts(section) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
    const { colors: colors, responsiveCss: responsiveCss, helpers: helpers } = (0, $756948b644e82cf2$export$559a0f07c8df6570)();
    const { responsiveSpacing: responsiveSpacing } = helpers;
    const localize = (0, $aIeEI.useLocalize)();
    const productCtaPageInfo = (0, $dUDPg.useWebPageInfo)(section.productCta.page);
    const localizeSlug = (0, $02ba3a727a0f8ecd$export$32f719dfac03c1cb)();
    const allColors = (0, $e18f565b44c7bc7d$export$b75b9022126d533b)();
    const allSizes = (0, $e18f565b44c7bc7d$export$4df04d41a3cf32b1)();
    const priceHistogram = (0, $e18f565b44c7bc7d$export$ada9abdd52b4cf46)();
    const [selectedSizes, setSelectedSizes] = (0, $eeH7J.useState)([]);
    const [selectedColors, setSelectedColors] = (0, $eeH7J.useState)([]);
    const [minPrice, setMinPrice] = (0, $eeH7J.useState)((_b = (_a = priceHistogram.data) === null || _a === void 0 ? void 0 : _a.min) !== null && _b !== void 0 ? _b : undefined);
    const [maxPrice, setMaxPrice] = (0, $eeH7J.useState)((_d = (_c = priceHistogram.data) === null || _c === void 0 ? void 0 : _c.max) !== null && _d !== void 0 ? _d : undefined);
    const [priceRangeCollsapsed, setPriceRangeCollsapsed] = (0, $eeH7J.useState)(false);
    const [colorsCollsapsed, setColorsCollapsed] = (0, $eeH7J.useState)(false);
    const [storageSizesCollapsed, setStorageSizesCollapsed] = (0, $eeH7J.useState)(false);
    (0, $eeH7J.useEffect)(()=>{
        if (priceHistogram.data) {
            setMinPrice(priceHistogram.data.min);
            setMaxPrice(priceHistogram.data.max);
        }
    }, [
        priceHistogram.data
    ]);
    const rangeMin = (_f = (_e = priceHistogram.data) === null || _e === void 0 ? void 0 : _e.min) !== null && _f !== void 0 ? _f : 0;
    const rangeMax = (_h = (_g = priceHistogram.data) === null || _g === void 0 ? void 0 : _g.max) !== null && _h !== void 0 ? _h : 1;
    const range = rangeMax - rangeMin;
    const left = ((minPrice !== null && minPrice !== void 0 ? minPrice : 0) - rangeMin) / range;
    const right = ((maxPrice !== null && maxPrice !== void 0 ? maxPrice : 0) - rangeMin) / range;
    const [sortOrder, setSortOrder] = (0, $eeH7J.useState)("desc");
    const products = (0, $e18f565b44c7bc7d$export$88e20cfc122b8557)(undefined, selectedSizes, selectedColors, undefined);
    const filteredAndSortedProducts = (0, $eeH7J.useMemo)(()=>{
        var _a, _b;
        const fp = (_b = (_a = products.data) === null || _a === void 0 ? void 0 : _a.filter((p)=>p.monthlyPrice.itemsTotal.majorUnits.valueOf() >= (minPrice !== null && minPrice !== void 0 ? minPrice : 0) && p.monthlyPrice.itemsTotal.majorUnits.valueOf() <= (maxPrice !== null && maxPrice !== void 0 ? maxPrice : 1000000)).sort((a, b)=>(a.modelReleaseDate ? Date.parse(a.modelReleaseDate.valueOf()) : 0) > (b.modelReleaseDate ? Date.parse(b.modelReleaseDate.valueOf()) : 0) ? 1 : -1)) !== null && _b !== void 0 ? _b : [];
        if (sortOrder === "asc") return fp.reverse();
        return fp;
    }, [
        maxPrice,
        minPrice,
        sortOrder,
        products.data
    ]);
    const sortOrderOptions = [
        {
            value: "desc",
            text: localize({
                no: "Nyeste f\xf8rst",
                en: "Newest first"
            })
        },
        {
            value: "asc",
            text: localize({
                no: "Eldste f\xf8rst",
                en: "Oldest first"
            })
        }
    ];
    const [showFiltersModal, setShowFiltersModal] = (0, $eeH7J.useState)(false);
    if (allColors.loading || allSizes.loading || priceHistogram.loading) return (0, $4vwom.jsx)((0, $4vwom.Fragment), {});
    const Filters = (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
        direction: "column",
        gap: 24,
        css: (0, $lhaLc.css)({
            gridColumn: "1"
        }),
        children: [
            (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                direction: "column",
                gap: 24,
                children: [
                    (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                        justifyContent: "space-between",
                        style: {
                            cursor: "pointer"
                        },
                        onClick: ()=>setPriceRangeCollsapsed(!priceRangeCollsapsed),
                        children: [
                            (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                variant: "heading",
                                level: 3,
                                children: localize(section.filters.priceRange.heading)
                            }),
                            (0, $4vwom.jsx)((0, $f8cdd04128a131cf$export$f04a61298a47a40f), {
                                icon: "chevronDown",
                                style: {
                                    transform: `rotate(${priceRangeCollsapsed ? 180 : 0}deg)`,
                                    transition: "all 200ms linear"
                                }
                            })
                        ]
                    }),
                    (0, $4vwom.jsx)((0, $efb0893865373669$export$6eb0f7ddcda6131f), {
                        collapsed: priceRangeCollsapsed,
                        children: (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                            direction: "column",
                            gap: 24,
                            children: [
                                (0, $4vwom.jsxs)("div", {
                                    children: [
                                        (0, $4vwom.jsx)("div", {
                                            style: {
                                                display: "flex",
                                                flexDirection: "row",
                                                height: 102,
                                                alignItems: "flex-end",
                                                padding: "0 40px",
                                                marginBottom: 2,
                                                gap: 2,
                                                position: "relative",
                                                zIndex: 0
                                            },
                                            children: (_j = priceHistogram.data) === null || _j === void 0 ? void 0 : _j.bars.map((p, i)=>(0, $4vwom.jsx)("div", {
                                                    style: {
                                                        bottom: 0,
                                                        height: p * 100 + "%",
                                                        borderTopLeftRadius: 4,
                                                        borderTopRightRadius: 4,
                                                        backgroundColor: colors.brandLight,
                                                        flex: 1
                                                    },
                                                    css: (0, $lhaLc.css)`
                                            font-size: 500;
                                        `
                                                }, `${p.toString()}${i}`))
                                        }),
                                        (0, $4vwom.jsx)("div", {
                                            style: {
                                                marginTop: -14,
                                                position: "relative",
                                                zIndex: 10
                                            },
                                            children: (0, $4vwom.jsx)((0, $1516a01fcc6e5048$export$ce1fcb9bf7d61ea1), {
                                                left: left,
                                                setLeft: (newLeft)=>setMinPrice(newLeft * range + rangeMin),
                                                right: right,
                                                setRight: (newRight)=>setMaxPrice(newRight * range + rangeMin)
                                            })
                                        })
                                    ]
                                }),
                                (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                                    gap: 16,
                                    children: [
                                        (0, $4vwom.jsx)("div", {
                                            style: {
                                                flex: 1
                                            },
                                            children: (0, $4vwom.jsx)((0, $46d788785e7b9d76$export$c86715117507e8e5), {
                                                label: localize(section.filters.priceRange.minLabel),
                                                value: Math.round(minPrice !== null && minPrice !== void 0 ? minPrice : 0).toString()
                                            })
                                        }),
                                        (0, $4vwom.jsx)("div", {
                                            style: {
                                                flex: 1
                                            },
                                            children: (0, $4vwom.jsx)((0, $46d788785e7b9d76$export$c86715117507e8e5), {
                                                label: localize(section.filters.priceRange.maxLabel),
                                                value: Math.round(maxPrice !== null && maxPrice !== void 0 ? maxPrice : 0).toString()
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            }),
            (0, $4vwom.jsx)((0, $67d1e32b493d1bb5$export$2e0a83ec2e27ecbb), {
                horizontal: true,
                spacing: 0
            }),
            (0, $4vwom.jsx)("div", {
                children: (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                    direction: "column",
                    children: [
                        (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                            justifyContent: "space-between",
                            style: {
                                cursor: "pointer"
                            },
                            onClick: ()=>setColorsCollapsed(!colorsCollsapsed),
                            children: [
                                (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                    variant: "heading",
                                    level: 3,
                                    margin: {
                                        bottom: 24
                                    },
                                    children: localize(section.filters.colors.heading)
                                }),
                                (0, $4vwom.jsx)((0, $f8cdd04128a131cf$export$f04a61298a47a40f), {
                                    icon: "chevronDown",
                                    style: {
                                        transform: `rotate(${colorsCollsapsed ? 180 : 0}deg)`,
                                        transition: "all 200ms linear"
                                    }
                                })
                            ]
                        }),
                        (0, $4vwom.jsx)((0, $efb0893865373669$export$6eb0f7ddcda6131f), {
                            collapsed: colorsCollsapsed,
                            children: (_k = allColors.data) === null || _k === void 0 ? void 0 : _k.map((c)=>(0, $4vwom.jsx)((0, $06e3a36d2d83b339$export$48513f6b9f8ce62d), {
                                    padding: (0, $756948b644e82cf2$export$981516ee4691055c)(20),
                                    label: (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                                        gap: 16,
                                        children: [
                                            (0, $4vwom.jsx)("div", {
                                                style: {
                                                    flexShrink: 0,
                                                    backgroundColor: c.color,
                                                    height: 24,
                                                    width: 24,
                                                    borderRadius: 24
                                                }
                                            }),
                                            localize(c.displayName)
                                        ]
                                    }),
                                    checked: selectedColors.includes(c.name),
                                    onChange: (v)=>setSelectedColors(v.target.checked ? [
                                            ...selectedColors,
                                            c.name
                                        ] : selectedColors.filter((id)=>id !== c.name))
                                }, `${c.name}`))
                        })
                    ]
                })
            }),
            (0, $4vwom.jsx)((0, $67d1e32b493d1bb5$export$2e0a83ec2e27ecbb), {
                horizontal: true,
                spacing: 0
            }),
            (0, $4vwom.jsxs)("div", {
                children: [
                    (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                        justifyContent: "space-between",
                        style: {
                            cursor: "pointer"
                        },
                        onClick: ()=>setStorageSizesCollapsed(!storageSizesCollapsed),
                        children: [
                            (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                variant: "heading",
                                level: 3,
                                margin: {
                                    bottom: 24
                                },
                                children: localize(section.filters.storageSizes.heading)
                            }),
                            (0, $4vwom.jsx)((0, $f8cdd04128a131cf$export$f04a61298a47a40f), {
                                icon: "chevronDown",
                                style: {
                                    transform: `rotate(${storageSizesCollapsed ? 180 : 0}deg)`,
                                    transition: "all 200ms linear"
                                }
                            })
                        ]
                    }),
                    (0, $4vwom.jsx)((0, $efb0893865373669$export$6eb0f7ddcda6131f), {
                        collapsed: storageSizesCollapsed,
                        children: (_l = allSizes.data) === null || _l === void 0 ? void 0 : _l.map((s)=>(0, $4vwom.jsx)((0, $06e3a36d2d83b339$export$48513f6b9f8ce62d), {
                                label: s.displayName,
                                checked: selectedSizes.includes(s.name),
                                onChange: (v)=>setSelectedSizes(v.target.checked ? [
                                        ...selectedSizes,
                                        s.name
                                    ] : selectedSizes.filter((id)=>id !== s.name)),
                                padding: (0, $756948b644e82cf2$export$981516ee4691055c)(20)
                            }, s.name))
                    })
                ]
            })
        ]
    });
    if (!((_m = productCtaPageInfo.data) === null || _m === void 0 ? void 0 : _m.slug)) return (0, $4vwom.jsx)((0, $4vwom.Fragment), {});
    return (0, $4vwom.jsx)("div", {
        css: (0, $lhaLc.css)((0, $756948b644e82cf2$export$f1cf1885b6bfef23)()),
        children: (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
            direction: "column",
            children: [
                (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                    justifyContent: "space-between",
                    alignItems: "center",
                    css: (0, $lhaLc.css)({
                        marginBottom: 16
                    }, responsiveCss("min", "md", {
                        marginBottom: 40
                    })),
                    children: [
                        (0, $4vwom.jsx)((0, $789b8639be592288$export$a8a3e93435678ff9), {
                            level: 2,
                            children: localize(section.heading)
                        }),
                        (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                            gap: 16,
                            alignItems: "center",
                            children: [
                                (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                    variant: "body",
                                    size: "md",
                                    css: responsiveCss("max", "md", {
                                        display: "none"
                                    }),
                                    children: localize({
                                        no: "Vis",
                                        en: "Show"
                                    })
                                }),
                                (0, $4vwom.jsx)((0, $f8bb6ad0e871adee$export$931cbfb6bfb85fc), {
                                    value: sortOrder,
                                    options: sortOrderOptions,
                                    onChange: (e, val)=>setSortOrder(val)
                                })
                            ]
                        })
                    ]
                }),
                (0, $4vwom.jsxs)("div", {
                    css: (0, $lhaLc.css)({
                        marginBottom: 16
                    }, responsiveCss("min", "md", {
                        display: "none"
                    })),
                    children: [
                        (0, $4vwom.jsx)((0, $67d1e32b493d1bb5$export$2e0a83ec2e27ecbb), {
                            horizontal: true,
                            spacing: "sm"
                        }),
                        (0, $4vwom.jsx)((0, $4b4086f8a1c6b2f8$export$353f5b6fc5456de1), {
                            iconStart: "filter",
                            variant: "light",
                            css: (0, $lhaLc.css)({
                                boxShadow: $e665a5c3bf2ac3f6$export$16e1fc8de5cd9687
                            }),
                            fullwidth: true,
                            onClick: ()=>setShowFiltersModal(true),
                            children: localize({
                                no: "Filter",
                                en: "Filter"
                            })
                        }),
                        (0, $4vwom.jsx)((0, $37d4981a6b4c97c0$export$2b77a92f1a5ad772), {
                            isOpen: showFiltersModal,
                            onClose: ()=>setShowFiltersModal(false),
                            header: {
                                icon: "filter",
                                closeButton: true,
                                title: localize({
                                    no: "Filter",
                                    en: "Filter"
                                }),
                                divider: true
                            },
                            width: "100%",
                            children: Filters
                        })
                    ]
                }),
                (0, $4vwom.jsxs)("div", {
                    css: (0, $lhaLc.css)({
                        display: "grid"
                    }, responsiveCss("max", "sm", {
                        gridAutoFlow: "row",
                        gridTemplateRows: "1fr"
                    }), responsiveCss("min", "md", {
                        gridTemplateColumns: "1fr 1fr 1fr",
                        alignItems: "start"
                    }), responsiveSpacing("sm", "gap")),
                    children: [
                        (0, $4vwom.jsx)("div", {
                            css: responsiveCss("max", "sm", {
                                display: "none"
                            }),
                            children: Filters
                        }),
                        (0, $4vwom.jsxs)("div", {
                            css: (0, $lhaLc.css)({
                                display: "grid"
                            }, responsiveCss("max", "sm", {
                                gridAutoFlow: "row",
                                gridTemplateRows: "1fr"
                            }), responsiveCss("min", "md", {
                                gridTemplateColumns: "1fr 1fr",
                                gridColumn: "2 / 4",
                                gridAutoRows: "1fr"
                            }), responsiveSpacing("sm", "gap")),
                            children: [
                                !filteredAndSortedProducts.length ? (0, $4vwom.jsx)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                                    gap: 32,
                                    direction: "column",
                                    style: {
                                        width: "100%",
                                        gridColumn: " span 2"
                                    },
                                    children: (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                                        backgroundColor: "gray100",
                                        justifyContent: "center",
                                        borderRadius: "md",
                                        padding: 64,
                                        children: [
                                            section.noMatches.image ? (0, $4vwom.jsx)((0, $6a1a23ca93758ec8$export$686e15a6b88a698c), {
                                                image: section.noMatches.image,
                                                width: 400
                                            }) : null,
                                            (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                                                gap: 16,
                                                alignItems: "center",
                                                justifyContent: "center",
                                                direction: "column",
                                                children: [
                                                    (0, $4vwom.jsx)((0, $789b8639be592288$export$a8a3e93435678ff9), {
                                                        level: 2,
                                                        children: localize(section.noMatches.heading)
                                                    }),
                                                    (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                                        variant: "body",
                                                        size: "lg",
                                                        children: localize(section.noMatches.text)
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }) : undefined,
                                filteredAndSortedProducts.map((p, i)=>{
                                    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
                                    return (0, $4vwom.jsxs)((0, $eeH7J.Fragment), {
                                        children: [
                                            (0, $4vwom.jsx)((0, $bee1a5e35c892a21$export$e71c4d32a2263218), {
                                                css: (0, $lhaLc.css)(responsiveCss("max", "sm", {
                                                    display: "none"
                                                })),
                                                children: (0, $4vwom.jsx)((0, $b7d6468cd3704e06$export$e6cbe35324ccf844), {
                                                    alwaysShowCta: section.productCta.alwaysShow,
                                                    name: localize(p.name),
                                                    features: (_b = (_a = p.features) === null || _a === void 0 ? void 0 : _a.map((f)=>localize(f.text))) !== null && _b !== void 0 ? _b : [],
                                                    price: localize({
                                                        no: `Fra ${p.monthlyPrice.itemsTotal.majorUnits.toString()} kr/md`,
                                                        en: `From ${p.monthlyPrice.itemsTotal.majorUnits.toString()} NOK/mo`
                                                    }),
                                                    // highlightPrice={p.highlightPrice}
                                                    image: (_c = p.images) === null || _c === void 0 ? void 0 : _c[0],
                                                    cta: {
                                                        text: localize(section.productCta.text),
                                                        url: `${localizeSlug((_d = productCtaPageInfo.data) === null || _d === void 0 ? void 0 : _d.slug)}?${(0, $f4c4c9282b17128a$export$cefacdcddab7996c)({
                                                            phoneId: p.id
                                                        })}`
                                                    },
                                                    relativePhysicalSize: (_e = p.relativePhysicalSize) === null || _e === void 0 ? void 0 : _e.valueOf()
                                                })
                                            }),
                                            (0, $4vwom.jsx)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                                                direction: "column",
                                                gap: 16,
                                                css: responsiveCss("min", "md", {
                                                    display: "none"
                                                }),
                                                children: (0, $4vwom.jsx)((0, $b7d6468cd3704e06$export$e6cbe35324ccf844), {
                                                    alwaysShowCta: section.productCta.alwaysShow,
                                                    name: localize(p.name),
                                                    features: (_g = (_f = p.features) === null || _f === void 0 ? void 0 : _f.map((f)=>localize(f.text))) !== null && _g !== void 0 ? _g : [],
                                                    price: localize({
                                                        no: `Fra ${p.monthlyPrice.itemsTotal.majorUnits.toString()} kr/md`,
                                                        en: `From ${p.monthlyPrice.itemsTotal.majorUnits.toString()} NOK/mo`
                                                    }),
                                                    // highlightPrice={p.highlightPrice}
                                                    image: (_h = p.images) === null || _h === void 0 ? void 0 : _h[0],
                                                    cta: {
                                                        text: localize(section.productCta.text),
                                                        url: `${localizeSlug((_j = productCtaPageInfo.data) === null || _j === void 0 ? void 0 : _j.slug)}?${(0, $f4c4c9282b17128a$export$cefacdcddab7996c)({
                                                            phoneId: p.id
                                                        })}`
                                                    },
                                                    relativePhysicalSize: (_k = p.relativePhysicalSize) === null || _k === void 0 ? void 0 : _k.valueOf(),
                                                    compact: true
                                                })
                                            })
                                        ]
                                    }, p.id.valueOf());
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}




var $4vwom = parcelRequire("4vwom");

var $lhaLc = parcelRequire("lhaLc");

var $alVaN = parcelRequire("alVaN");


var $9G56J = parcelRequire("9G56J");

var $hFOwS = parcelRequire("hFOwS");

var $aIeEI = parcelRequire("aIeEI");









var $eeH7J = parcelRequire("eeH7J");


parcelRequire("2LTO8");
var $dAwef = parcelRequire("dAwef");



var $dUDPg = parcelRequire("dUDPg");


parcelRequire("jniej");
var $eK8Q4 = parcelRequire("eK8Q4");

var $34lt5 = parcelRequire("34lt5");




(0, $9G56J.Section)($2446a2453fd6c8db$var$AccountOverview);
function $2446a2453fd6c8db$var$AccountOverview(section) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    const { helpers: helpers } = (0, $756948b644e82cf2$export$559a0f07c8df6570)();
    const { responsiveCss: responsiveCss } = helpers;
    const me = (0, $e18f565b44c7bc7d$export$f637e1cf42d15a62)();
    const localize = (0, $aIeEI.useLocalize)();
    const logOutWithVipps = (0, $f2e2333c5543d6d8$export$7a6e57dc0a3ed9e2)();
    (0, (/*@__PURE__*/$parcel$interopDefault($alVaN))).extend((0, (/*@__PURE__*/$parcel$interopDefault($hFOwS))));
    return (0, $4vwom.jsx)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
        justifyContent: "center",
        css: (0, $lhaLc.css)({
            paddingTop: 32,
            paddingBottom: 32
        }, responsiveCss("min", "md", {
            paddingTop: 64,
            paddingBottom: 64
        })),
        children: (0, $4vwom.jsxs)("div", {
            style: {
                width: "100%"
            },
            css: (0, $lhaLc.css)({
                display: "grid",
                gridTemplateAreas: '"text details" "menu details"',
                gridTemplateColumns: "56fr 70fr",
                gridTemplateRows: "minmax(0, auto)",
                columnGap: (0, $756948b644e82cf2$export$981516ee4691055c)(140)
            }, responsiveCss("max", "sm", {
                gridTemplateAreas: '"text" "details" "menu"',
                gridTemplateRows: "auto",
                gridTemplateColumns: "1fr",
                rowGap: 32
            }), responsiveCss("min", "lg", {
                paddingLeft: 96,
                paddingRight: 96
            })),
            children: [
                (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                    direction: "column",
                    gap: 16,
                    style: {
                        gridArea: "text",
                        minWidth: 0
                    },
                    children: [
                        (0, $4vwom.jsx)((0, $789b8639be592288$export$a8a3e93435678ff9), {
                            level: 1,
                            children: (0, $87d2193cf0695c20$export$4493d2932fe76cf8)(localize(section.heading), {
                                givenName: (_b = (_a = me.data) === null || _a === void 0 ? void 0 : _a.givenName) !== null && _b !== void 0 ? _b : "",
                                familyName: (_d = (_c = me.data) === null || _c === void 0 ? void 0 : _c.familyName) !== null && _d !== void 0 ? _d : ""
                            })
                        }),
                        (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                            variant: "body",
                            size: "lg",
                            color: "gray400",
                            children: (0, $87d2193cf0695c20$export$4493d2932fe76cf8)(localize(section.subheading), {
                                givenName: (_f = (_e = me.data) === null || _e === void 0 ? void 0 : _e.givenName) !== null && _f !== void 0 ? _f : "",
                                familyName: (_h = (_g = me.data) === null || _g === void 0 ? void 0 : _g.familyName) !== null && _h !== void 0 ? _h : ""
                            })
                        })
                    ]
                }),
                (0, $4vwom.jsx)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                    gap: 28,
                    direction: "column",
                    margin: {
                        top: (0, $756948b644e82cf2$export$981516ee4691055c)(48)
                    },
                    style: {
                        gridArea: "menu",
                        minWidth: 0
                    },
                    children: (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                        style: {
                            cursor: "pointer"
                        },
                        justifyContent: "space-between",
                        alignItems: "center",
                        onClick: async ()=>{
                            await logOutWithVipps();
                            window.location.href = "/";
                        },
                        children: [
                            (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                variant: "heading",
                                level: 3,
                                children: localize({
                                    no: "Logg ut",
                                    en: "Sign out"
                                })
                            }),
                            (0, $4vwom.jsx)((0, $f8cdd04128a131cf$export$f04a61298a47a40f), {
                                icon: "arrowRight"
                            })
                        ]
                    })
                }),
                (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                    direction: "column",
                    style: {
                        gridArea: "details",
                        minWidth: 0
                    },
                    children: [
                        (0, $4vwom.jsx)($2446a2453fd6c8db$var$ActiveSubscriptions, Object.assign({}, section.activeSubscriptions)),
                        (0, $4vwom.jsx)($2446a2453fd6c8db$var$PaymentMethods, Object.assign({}, section.paymentMethods))
                    ]
                })
            ]
        })
    });
}
function $2446a2453fd6c8db$var$ActiveSubscriptions(props) {
    var _a;
    const { colors: colors, helpers: helpers } = (0, $756948b644e82cf2$export$559a0f07c8df6570)();
    const { responsiveCss: responsiveCss } = helpers;
    const orders = (0, $e18f565b44c7bc7d$export$25a35ae850463813)();
    const localize = (0, $aIeEI.useLocalize)();
    const [descriptionModalIsOpen, setDescriptionModalIsOpen] = (0, $eeH7J.useState)();
    const detailsPageInfo = (0, $dUDPg.useWebPageInfo)(props.detailsPage);
    if (!((_a = orders.data) === null || _a === void 0 ? void 0 : _a.orders.length)) return (0, $4vwom.jsx)((0, $4vwom.Fragment), {});
    return (0, $4vwom.jsxs)((0, $4vwom.Fragment), {
        children: [
            (0, $4vwom.jsx)((0, $789b8639be592288$export$a8a3e93435678ff9), {
                level: 3,
                margin: {
                    bottom: (0, $756948b644e82cf2$export$981516ee4691055c)(24)
                },
                children: localize(props.heading)
            }),
            (0, $4vwom.jsx)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                gap: (0, $756948b644e82cf2$export$981516ee4691055c)(24),
                direction: "column",
                children: orders.data.orders.map((order)=>{
                    var _a, _b, _c, _d;
                    return (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                        as: "a",
                        backgroundColor: "gray100",
                        href: ((_a = detailsPageInfo.data) === null || _a === void 0 ? void 0 : _a.slug) ? `/${localize(detailsPageInfo.data.slug)}?id=${order.id.valueOf()}` : "",
                        direction: "column",
                        borderRadius: "md",
                        children: [
                            (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                                css: (0, $lhaLc.css)({
                                    padding: (0, $756948b644e82cf2$export$981516ee4691055c)(24),
                                    gap: (0, $756948b644e82cf2$export$981516ee4691055c)(16)
                                }, responsiveCss("min", "md", {
                                    padding: (0, $756948b644e82cf2$export$981516ee4691055c)(40),
                                    gap: (0, $756948b644e82cf2$export$981516ee4691055c)(32)
                                })),
                                children: [
                                    (0, $4vwom.jsx)("div", {
                                        css: (0, $lhaLc.css)({
                                            width: (0, $756948b644e82cf2$export$981516ee4691055c)(72),
                                            flex: "0 0 auto"
                                        }, responsiveCss("min", "md", {
                                            width: (0, $756948b644e82cf2$export$981516ee4691055c)(120)
                                        })),
                                        children: !!((_b = order.phone.images) === null || _b === void 0 ? void 0 : _b[0]) && (0, $4vwom.jsx)((0, $6a1a23ca93758ec8$export$686e15a6b88a698c), {
                                            image: order.phone.images[0],
                                            width: 120,
                                            style: {
                                                width: "100%"
                                            }
                                        })
                                    }),
                                    (0, $4vwom.jsx)("div", {
                                        style: {
                                            flexGrow: 1
                                        },
                                        children: (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                                            direction: "column",
                                            css: (0, $lhaLc.css)({
                                                gap: 16
                                            }, responsiveCss("min", "md", {
                                                gap: 24
                                            })),
                                            children: [
                                                (0, $4vwom.jsxs)("div", {
                                                    css: (0, $lhaLc.css)({
                                                        display: "grid",
                                                        gridTemplateAreas: order.model.features && order.model.features.length > 0 ? '"heading button" "features button"' : '"heading button"',
                                                        gridTemplateColumns: "1fr auto",
                                                        gridTemplateRows: "auto auto",
                                                        columnGap: 8
                                                    }),
                                                    children: [
                                                        (0, $4vwom.jsx)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                                                            style: {
                                                                gridArea: "heading"
                                                            },
                                                            alignItems: "center",
                                                            children: (0, $4vwom.jsx)((0, $789b8639be592288$export$a8a3e93435678ff9), {
                                                                level: 4,
                                                                children: localize(order.model.name)
                                                            })
                                                        }),
                                                        order.model.features && order.model.features.length > 0 && (0, $4vwom.jsx)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                                                            gap: 8,
                                                            alignItems: "center",
                                                            style: {
                                                                gridArea: "features",
                                                                overflow: "hidden"
                                                            },
                                                            children: (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                                                variant: "body",
                                                                size: "sm",
                                                                color: "gray300",
                                                                css: (0, $lhaLc.css)({
                                                                    display: "inline-block",
                                                                    whiteSpace: "nowrap",
                                                                    overflow: "hidden",
                                                                    textOverflow: "ellipsis",
                                                                    flex: "1 1 auto"
                                                                }),
                                                                children: order.model.features.map((feature, index)=>(0, $4vwom.jsxs)((0, $eeH7J.Fragment), {
                                                                        children: [
                                                                            index > 0 && (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                                                                variant: "body",
                                                                                size: [
                                                                                    "lg",
                                                                                    [
                                                                                        "min",
                                                                                        "lg",
                                                                                        "xl"
                                                                                    ]
                                                                                ],
                                                                                color: "gray300",
                                                                                css: (0, $lhaLc.css)({
                                                                                    display: "inline-block",
                                                                                    marginLeft: 8,
                                                                                    marginRight: 8
                                                                                }),
                                                                                children: "\xb7"
                                                                            }),
                                                                            localize(feature.text)
                                                                        ]
                                                                    }, feature.id.valueOf()))
                                                            })
                                                        }),
                                                        (0, $4vwom.jsx)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                                                            style: {
                                                                gridArea: "button"
                                                            },
                                                            alignItems: "center",
                                                            children: (0, $4vwom.jsx)((0, $4b4086f8a1c6b2f8$export$353f5b6fc5456de1), {
                                                                size: [
                                                                    "xs",
                                                                    [
                                                                        "min",
                                                                        "md",
                                                                        "sm"
                                                                    ]
                                                                ],
                                                                iconStart: "chevronDown",
                                                                variant: "light",
                                                                onClick: (e)=>{
                                                                    setDescriptionModalIsOpen(order.id);
                                                                    e.preventDefault();
                                                                    e.stopPropagation();
                                                                }
                                                            })
                                                        }),
                                                        order.model.description && (0, $4vwom.jsx)((0, $37d4981a6b4c97c0$export$2b77a92f1a5ad772), {
                                                            header: {
                                                                icon: "device",
                                                                title: localize({
                                                                    no: "Produktdetaljer",
                                                                    en: "Product details"
                                                                }),
                                                                closeButton: true
                                                            },
                                                            isOpen: descriptionModalIsOpen === order.id,
                                                            onClose: ()=>setDescriptionModalIsOpen(undefined),
                                                            children: (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                                                variant: "body",
                                                                size: "sm",
                                                                children: (0, $4vwom.jsx)((0, $82d66b15b8f4758d$export$d5163f1ce1e6a5f9), {
                                                                    value: localize(order.model.description)
                                                                })
                                                            })
                                                        })
                                                    ]
                                                }),
                                                (0, $4vwom.jsx)("div", {
                                                    css: responsiveCss("max", "sm", {
                                                        display: "none"
                                                    }),
                                                    children: (0, $4vwom.jsx)((0, $67d1e32b493d1bb5$export$2e0a83ec2e27ecbb), {
                                                        horizontal: true,
                                                        spacing: 0
                                                    })
                                                }),
                                                (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                                                    direction: "column",
                                                    gap: 4,
                                                    children: [
                                                        (0, $4vwom.jsx)("div", {
                                                            style: {
                                                                display: "inline-flex",
                                                                color: order.cancelled ? colors.gray300 : undefined
                                                            },
                                                            children: (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                                                                alignItems: "baseline",
                                                                gap: 4,
                                                                css: order.cancelled ? (0, $lhaLc.css)({
                                                                    position: "relative",
                                                                    ":after": {
                                                                        position: "absolute",
                                                                        content: '""',
                                                                        width: "100%",
                                                                        borderBottom: "1px solid",
                                                                        top: "56%"
                                                                    }
                                                                }) : undefined,
                                                                children: [
                                                                    (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                                                        variant: "heading",
                                                                        level: 3,
                                                                        children: (_c = order.rentalPeriods[0]) === null || _c === void 0 ? void 0 : _c.monthlyPrice.itemsTotal.majorUnits.valueOf()
                                                                    }),
                                                                    (0, $4vwom.jsxs)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                                                        variant: "body",
                                                                        size: "sm",
                                                                        children: [
                                                                            (_d = order.rentalPeriods[0]) === null || _d === void 0 ? void 0 : _d.monthlyPrice.itemsTotal.currency.toLowerCase(),
                                                                            "/",
                                                                            localize((0, $b274814d74f89bd0$export$b4b23bfab2f68498))
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        order.nextChargeDate ? (0, $4vwom.jsxs)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                                            variant: "body",
                                                            size: "sm",
                                                            children: [
                                                                localize({
                                                                    no: "Neste forfall",
                                                                    en: "Lease due date"
                                                                }),
                                                                ":",
                                                                " ",
                                                                (0, (/*@__PURE__*/$parcel$interopDefault($alVaN)))(order.nextChargeDate).format("Do MMMM YYYY")
                                                            ]
                                                        }) : null,
                                                        order.cancelled && (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                                                            gap: 4,
                                                            alignItems: "center",
                                                            children: [
                                                                (0, $4vwom.jsx)((0, $f8cdd04128a131cf$export$f04a61298a47a40f), {
                                                                    icon: "warning",
                                                                    color: "brand"
                                                                }),
                                                                (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                                                    variant: "body",
                                                                    size: "sm",
                                                                    color: "brand",
                                                                    children: localize(props.cancelledLabelText)
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            (0, $4vwom.jsx)((0, $67d1e32b493d1bb5$export$2e0a83ec2e27ecbb), {
                                horizontal: true,
                                spacing: 0
                            }),
                            (0, $4vwom.jsx)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                                padding: (0, $756948b644e82cf2$export$981516ee4691055c)(24),
                                justifyContent: "flex-end",
                                children: (0, $4vwom.jsx)((0, $4b4086f8a1c6b2f8$export$353f5b6fc5456de1), {
                                    variant: "dark",
                                    size: "sm",
                                    children: localize(props.detailsButtonText)
                                })
                            })
                        ]
                    }, order.id.valueOf());
                })
            })
        ]
    });
}
function $2446a2453fd6c8db$var$PaymentMethods(props) {
    var _a, _b, _c, _d;
    const theme = (0, $756948b644e82cf2$export$559a0f07c8df6570)();
    const { colors: colors, helpers: helpers } = theme;
    const { responsiveCss: responsiveCss } = helpers;
    const me = (0, $e18f565b44c7bc7d$export$f637e1cf42d15a62)();
    const localize = (0, $aIeEI.useLocalize)();
    const paymentOptions = (0, $e18f565b44c7bc7d$export$b66da2e92981394)();
    const orders = (0, $e18f565b44c7bc7d$export$25a35ae850463813)();
    // An id to provide as a parameter to the add card operation.
    const [addCardId, setAddCardId] = (0, $eK8Q4.useSessionState)("payment-methods-add-id", undefined);
    // For storing cards already added to the profile before adding a new one, so that we can set
    // the new card as the currently active automatically.
    const [originalCardIds, setOriginalCardIds] = (0, $eeH7J.useState)([]);
    const handleNewCardAdded = (0, $eeH7J.useCallback)(async ()=>{
        var _a;
        const newPaymentOption = (_a = paymentOptions.data) === null || _a === void 0 ? void 0 : _a.find((po)=>{
            var _a;
            return !originalCardIds.includes((_a = po.id) !== null && _a !== void 0 ? _a : "");
        });
        if (newPaymentOption === null || newPaymentOption === void 0 ? void 0 : newPaymentOption.id) {
            await (0, $e18f565b44c7bc7d$export$d1167dfb180ea832)({
                storedPaymentMethodId: newPaymentOption.id
            });
            me.refresh();
        }
    }, [
        paymentOptions.data,
        originalCardIds,
        me
    ]);
    const [optionsForId, setOptionsForId] = (0, $eeH7J.useState)();
    const [modalIsOpen, setModalIsOpen] = (0, $eeH7J.useState)(false);
    const [isError, setIsError] = (0, $eeH7J.useState)(false);
    if (!((_a = orders.data) === null || _a === void 0 ? void 0 : _a.orders.length) && !((_b = paymentOptions.data) === null || _b === void 0 ? void 0 : _b.length)) return (0, $4vwom.jsx)((0, $4vwom.Fragment), {});
    return (0, $4vwom.jsxs)((0, $4vwom.Fragment), {
        children: [
            (0, $4vwom.jsx)((0, $789b8639be592288$export$a8a3e93435678ff9), {
                level: 3,
                margin: {
                    top: 32,
                    bottom: 16
                },
                children: localize(props.heading)
            }),
            !((_c = paymentOptions.data) === null || _c === void 0 ? void 0 : _c.length) && (0, $4vwom.jsx)((0, $bee1a5e35c892a21$export$e71c4d32a2263218), {
                margin: {
                    bottom: "md"
                },
                children: (0, $4vwom.jsx)((0, $192171ee7c657b77$export$14834abbfce3b8cd), {
                    text: localize(props.noPaymentMethods),
                    icon: "warning",
                    color: "gray350"
                })
            }),
            (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                direction: "column",
                gap: 24,
                children: [
                    (_d = paymentOptions.data) === null || _d === void 0 ? void 0 : _d.map((paymentOption)=>{
                        var _a, _b, _c, _d;
                        return (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                            style: {
                                display: "flex",
                                flexDirection: "row",
                                width: "100%",
                                position: "relative"
                            },
                            borderColor: "gray200",
                            borderRadius: "md",
                            padding: "sm",
                            justifyContent: "space-between",
                            alignItems: "center",
                            children: [
                                (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                                    alignItems: "center",
                                    css: (0, $lhaLc.css)({
                                        gap: 16
                                    }, responsiveCss("min", "lg", {
                                        gap: 24
                                    })),
                                    children: [
                                        paymentOption.brand === "visa" ? (0, $4vwom.jsx)($2446a2453fd6c8db$var$Visa, {}) : paymentOption.brand === "mc" ? (0, $4vwom.jsx)($2446a2453fd6c8db$var$MasterCard, {}) : /applepay/.test((_a = paymentOption.brand) !== null && _a !== void 0 ? _a : "") ? (0, $4vwom.jsx)($2446a2453fd6c8db$var$ApplePay, {}) : paymentOption.brand,
                                        ((_b = me.data) === null || _b === void 0 ? void 0 : _b.preferredStoredPaymentMethodId) === paymentOption.id ? (0, $4vwom.jsx)((0, $1c19a55e13f5780a$export$48c441fbee531268), {
                                            color: "gray500",
                                            size: [
                                                "fixed",
                                                "xs",
                                                "md"
                                            ],
                                            children: localize(props.preferredLabel)
                                        }) : null
                                    ]
                                }),
                                (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                                    alignItems: "center",
                                    style: {
                                        fontVariantNumeric: "tabular-nums",
                                        position: "relative"
                                    },
                                    css: (0, $lhaLc.css)({
                                        gap: 16
                                    }, responsiveCss("min", "lg", {
                                        gap: 24
                                    })),
                                    children: [
                                        (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                                            alignItems: "center",
                                            gap: 8,
                                            children: [
                                                (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                                                    alignItems: "center",
                                                    children: [
                                                        (0, $4vwom.jsx)((0, $f8cdd04128a131cf$export$f04a61298a47a40f), {
                                                            icon: "asterisk",
                                                            size: 16,
                                                            color: "gray300"
                                                        }),
                                                        (0, $4vwom.jsx)((0, $f8cdd04128a131cf$export$f04a61298a47a40f), {
                                                            icon: "asterisk",
                                                            size: 16,
                                                            color: "gray300"
                                                        }),
                                                        (0, $4vwom.jsx)((0, $f8cdd04128a131cf$export$f04a61298a47a40f), {
                                                            icon: "asterisk",
                                                            size: 16,
                                                            color: "gray300"
                                                        }),
                                                        (0, $4vwom.jsx)((0, $f8cdd04128a131cf$export$f04a61298a47a40f), {
                                                            icon: "asterisk",
                                                            size: 16,
                                                            color: "gray300"
                                                        })
                                                    ]
                                                }),
                                                (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                                    variant: "body",
                                                    size: "md",
                                                    children: paymentOption.lastFour
                                                })
                                            ]
                                        }),
                                        (0, $4vwom.jsxs)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                            variant: "body",
                                            size: "md",
                                            children: [
                                                paymentOption.expiryMonth,
                                                "/",
                                                paymentOption.expiryYear
                                            ]
                                        }),
                                        (0, $4vwom.jsx)("div", {
                                            style: {
                                                flexShrink: 0
                                            },
                                            children: (0, $4vwom.jsx)((0, $4b4086f8a1c6b2f8$export$353f5b6fc5456de1), {
                                                iconStart: "more",
                                                size: "xs",
                                                variant: "secondary",
                                                disabled: ((_c = me.data) === null || _c === void 0 ? void 0 : _c.preferredStoredPaymentMethodId) === paymentOption.id,
                                                onClick: ()=>setOptionsForId(paymentOption.id)
                                            })
                                        }),
                                        optionsForId === paymentOption.id && (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                                            style: {
                                                position: "absolute",
                                                right: 0,
                                                top: 0,
                                                bottom: 0
                                            },
                                            backgroundColor: "grayWhite",
                                            css: (0, $lhaLc.css)({
                                                gap: 16
                                            }, responsiveCss("min", "lg", {
                                                gap: 24
                                            }), {
                                                "&:before": {
                                                    content: '""',
                                                    height: "100%",
                                                    width: 48,
                                                    background: "linear-gradient(270deg, rgba(255, 255,255,0), rgba(255, 255,255,1))"
                                                }
                                            }),
                                            children: [
                                                (0, $4vwom.jsx)((0, $4b4086f8a1c6b2f8$export$353f5b6fc5456de1), {
                                                    variant: "light",
                                                    size: "xs",
                                                    onClick: async ()=>{
                                                        if (paymentOption.id) {
                                                            await (0, $e18f565b44c7bc7d$export$d1167dfb180ea832)({
                                                                storedPaymentMethodId: paymentOption.id
                                                            });
                                                            me.refresh();
                                                            setOptionsForId(undefined);
                                                        }
                                                    },
                                                    children: localize(props.setAsPreferredButtonText)
                                                }),
                                                (0, $4vwom.jsx)((0, $4b4086f8a1c6b2f8$export$353f5b6fc5456de1), {
                                                    iconStart: "close",
                                                    size: "xs",
                                                    variant: "secondary",
                                                    onClick: ()=>setOptionsForId(undefined),
                                                    disabled: ((_d = me.data) === null || _d === void 0 ? void 0 : _d.preferredStoredPaymentMethodId) === paymentOption.id
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }, paymentOption.id);
                    }),
                    (0, $4vwom.jsx)((0, $4b4086f8a1c6b2f8$export$353f5b6fc5456de1), {
                        variant: "primary",
                        onClick: ()=>{
                            setAddCardId((0, $dAwef.Uuid)().toString());
                            setModalIsOpen(true);
                        },
                        children: localize(props.addPaymentMethods.modalTriggerButtonText)
                    })
                ]
            }),
            (0, $4vwom.jsx)((0, $37d4981a6b4c97c0$export$2b77a92f1a5ad772), {
                isOpen: modalIsOpen,
                width: 640,
                onClose: ()=>setModalIsOpen(false),
                header: {
                    title: localize(props.addPaymentMethods.modalTitle),
                    closeButton: true
                },
                children: (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                    direction: "column",
                    gap: 24,
                    css: (0, $lhaLc.css)((0, $756948b644e82cf2$export$682f474bed45e419), (0, $lhaLc.css)({
                        ".adyen-checkout__payment-method__header": {
                            display: "none"
                        }
                    })),
                    children: [
                        props.addPaymentMethods.modalText ? (0, $4vwom.jsx)((0, $82d66b15b8f4758d$export$d5163f1ce1e6a5f9), {
                            value: localize(props.addPaymentMethods.modalText)
                        }) : null,
                        isError ? (0, $4vwom.jsxs)((0, $4vwom.Fragment), {
                            children: [
                                (0, $4vwom.jsx)((0, $82d66b15b8f4758d$export$d5163f1ce1e6a5f9), {
                                    value: localize(props.addPaymentMethods.errorMessage)
                                }),
                                (0, $4vwom.jsx)((0, $4b4086f8a1c6b2f8$export$353f5b6fc5456de1), {
                                    variant: "dark",
                                    onClick: ()=>setIsError(false),
                                    children: localize({
                                        no: "Pr\xf8v igjen",
                                        en: "Try again"
                                    })
                                })
                            ]
                        }) : (0, $4vwom.jsx)((0, $ceb61c869c7a4551$export$8917e58bffe5ae62), {
                            onSuccess: async ()=>{
                                var _a, _b;
                                setOriginalCardIds((_b = (_a = paymentOptions.data) === null || _a === void 0 ? void 0 : _a.map((po)=>po.id)) !== null && _b !== void 0 ? _b : []);
                                await paymentOptions.refresh();
                                handleNewCardAdded();
                                setModalIsOpen(false);
                            },
                            onError: ()=>setIsError(true),
                            filterStoredPaymentMethods: ()=>false,
                            adyenOrder: "add-payment-method",
                            adyenOrderId: addCardId,
                            translations: {
                                "no-NO": {
                                    "creditCard.holderName.placeholder": localize(props.addPaymentMethods.cardholderNamePlaceholder, (0, $34lt5.LocaleKey).no)
                                },
                                "en-US": {
                                    "creditCard.holderName.placeholder": localize(props.addPaymentMethods.cardholderNamePlaceholder, (0, $34lt5.LocaleKey).en)
                                }
                            },
                            styles: {
                                base: {
                                    color: colors.gray500,
                                    fontWeight: "300",
                                    fontSize: "16px"
                                },
                                placeholder: {
                                    color: colors.gray300,
                                    fontWeight: "300",
                                    fontSize: "16px"
                                }
                            }
                        })
                    ]
                })
            })
        ]
    });
}
function $2446a2453fd6c8db$var$Visa(props) {
    return (0, $4vwom.jsxs)("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        width: 40,
        height: 26,
        viewBox: "0 0 40 26",
        fill: "none"
    }, props, {
        children: [
            (0, $4vwom.jsx)("path", {
                fill: "#fff",
                d: "M0 0h40v26H0z"
            }),
            (0, $4vwom.jsx)("path", {
                fill: "#1434CB",
                d: "m15.9 7.7-4.43 10.6h-2.9l-2.2-8.47c-.13-.52-.25-.71-.65-.93C5.05 8.55 3.96 8.2 3 8l.07-.32h4.67c.6 0 1.13.4 1.27 1.09l1.15 6.14 2.86-7.23h2.89Zm11.39 7.15c0-2.8-3.88-2.96-3.85-4.21 0-.38.37-.79 1.16-.9a5.2 5.2 0 0 1 2.71.48l.48-2.25a7.4 7.4 0 0 0-2.57-.47c-2.71 0-4.62 1.44-4.64 3.51-.02 1.53 1.36 2.38 2.4 2.9 1.08.51 1.44.85 1.43 1.31 0 .71-.85 1.03-1.64 1.04-1.39.02-2.19-.37-2.82-.67l-.5 2.33c.64.29 1.82.55 3.05.56 2.89 0 4.78-1.42 4.79-3.63Zm7.17 3.46H37L34.78 7.7h-2.34c-.53 0-.98.3-1.17.78l-4.12 9.84h2.88l.57-1.58h3.53l.33 1.58Zm-3.07-3.76 1.45-3.99.83 4H31.4ZM19.83 7.7l-2.27 10.62h-2.74L17.09 7.7h2.74Z"
            })
        ]
    }));
}
function $2446a2453fd6c8db$var$MasterCard(props) {
    return (0, $4vwom.jsxs)("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        width: 40,
        height: 26,
        viewBox: "0 0 40 26"
    }, props, {
        children: [
            (0, $4vwom.jsx)("path", {
                fill: "#fff",
                d: "M0 0h40v26H0z"
            }),
            (0, $4vwom.jsx)("path", {
                fill: "#F06022",
                d: "M16.13 19.29h7.74V6.7h-7.74v12.58z"
            }),
            (0, $4vwom.jsx)("path", {
                fill: "#EA1D25",
                d: "M16.93 13A7.93 7.93 0 0 1 20 6.71a8.02 8.02 0 0 0-10.65.65 7.96 7.96 0 0 0 0 11.28 8.02 8.02 0 0 0 10.65.65A8.02 8.02 0 0 1 16.93 13"
            }),
            (0, $4vwom.jsx)("path", {
                fill: "#F79D1D",
                d: "M33 13c0 2.12-.84 4.15-2.34 5.65a8.1 8.1 0 0 1-10.66.64A8.05 8.05 0 0 0 23.07 13 7.96 7.96 0 0 0 20 6.71a8.02 8.02 0 0 1 10.66.64A7.93 7.93 0 0 1 33 13"
            })
        ]
    }));
}
function $2446a2453fd6c8db$var$ApplePay(props) {
    return (0, $4vwom.jsxs)("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        width: 40,
        height: 26,
        viewBox: "0 0 40 26"
    }, props, {
        children: [
            (0, $4vwom.jsx)("path", {
                fill: "#000",
                d: "M36.42 0H3.58a69.25 69.25 0 0 0-.75 0c-.25.01-.5.03-.76.07a2.51 2.51 0 0 0-1.32.7A2.43 2.43 0 0 0 .07 2.1 5.14 5.14 0 0 0 0 3.22v19.91c.01.25.03.51.07.76a2.6 2.6 0 0 0 .68 1.35 2.39 2.39 0 0 0 1.32.69 4.98 4.98 0 0 0 1.1.07h34a5 5 0 0 0 .76-.07 2.5 2.5 0 0 0 1.32-.7 2.44 2.44 0 0 0 .68-1.34 5.13 5.13 0 0 0 .07-1.11V2.87a6.5 6.5 0 0 0-.07-.76 2.58 2.58 0 0 0-.68-1.35 2.4 2.4 0 0 0-1.32-.69 4.96 4.96 0 0 0-1.1-.07h-.41Z"
            }),
            (0, $4vwom.jsx)("path", {
                fill: "#fff",
                d: "M36.42.87h.73c.2 0 .42.02.62.06a1.67 1.67 0 0 1 .88.44 1.58 1.58 0 0 1 .44.89 4.38 4.38 0 0 1 .06.97v19.55a14.67 14.67 0 0 1-.06.96 1.7 1.7 0 0 1-.44.89 1.54 1.54 0 0 1-.87.44 4.27 4.27 0 0 1-.96.06H2.85a3.7 3.7 0 0 1-.63-.06 1.66 1.66 0 0 1-.87-.45 1.56 1.56 0 0 1-.44-.88 4.35 4.35 0 0 1-.06-.97V2.9c.01-.2.02-.42.06-.63.03-.18.08-.34.16-.49A1.56 1.56 0 0 1 2.22.93a4.2 4.2 0 0 1 .96-.06h33.24"
            }),
            (0, $4vwom.jsx)("path", {
                fill: "#000",
                d: "M10.92 8.61c.34-.43.57-1 .51-1.59a2.21 2.21 0 0 0-1.99 2.3c.56.04 1.12-.3 1.48-.7Zm.51.81c-.82-.05-1.52.46-1.9.46-.4 0-1-.44-1.64-.42-.84 0-1.62.48-2.05 1.24-.88 1.52-.23 3.76.62 5 .42.6.92 1.27 1.58 1.25.62-.02.86-.4 1.62-.4.75 0 .97.4 1.63.39.69-.01 1.11-.61 1.53-1.22.47-.7.67-1.37.68-1.4-.01-.02-1.32-.52-1.33-2.02-.01-1.26 1.03-1.85 1.07-1.9a2.34 2.34 0 0 0-1.81-.98Zm7.11-1.7a2.87 2.87 0 0 1 3.02 3c0 1.8-1.27 3.03-3.06 3.03h-1.97v3.12h-1.42V7.72h3.43Zm-2 4.83h1.62c1.24 0 1.94-.66 1.94-1.82 0-1.15-.7-1.81-1.93-1.81h-1.64v3.63Zm5.39 2.43c0-1.17.9-1.89 2.48-1.98l1.83-.1v-.52c0-.74-.5-1.18-1.34-1.18-.8 0-1.3.38-1.41.97h-1.3c.08-1.2 1.1-2.09 2.76-2.09 1.62 0 2.65.86 2.65 2.2v4.6h-1.31v-1.1h-.04a2.38 2.38 0 0 1-2.1 1.2c-1.3 0-2.22-.8-2.22-2Zm4.3-.6v-.53l-1.64.1c-.82.06-1.28.42-1.28.99 0 .58.48.96 1.22.96.96 0 1.7-.66 1.7-1.52Zm2.61 4.95v-1.11c.1.03.33.03.44.03.64 0 .98-.27 1.19-.96l.12-.4-2.41-6.69h1.48l1.7 5.43h.02l1.69-5.43h1.44l-2.5 7.02c-.57 1.62-1.23 2.14-2.61 2.14-.12 0-.46-.01-.56-.03Z"
            })
        ]
    }));
}



var $4vwom = parcelRequire("4vwom");

var $9G56J = parcelRequire("9G56J");



var $aIeEI = parcelRequire("aIeEI");

var $hFOwS = parcelRequire("hFOwS");


var $5K1mb = parcelRequire("5K1mb");

var $alVaN = parcelRequire("alVaN");

var $eeH7J = parcelRequire("eeH7J");



var $lhaLc = parcelRequire("lhaLc");







parcelRequire("2LTO8");
var $dAwef = parcelRequire("dAwef");





parcelRequire("jniej");
var $eK8Q4 = parcelRequire("eK8Q4");
var $87baa387e4f39550$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
(0, $9G56J.Section)($87baa387e4f39550$var$SubscriptionOverview);
function $87baa387e4f39550$var$SubscriptionOverview(section) {
    var _a, _b, _c, _d;
    const [params, setParams] = (0, $5K1mb.useSearchParams)();
    const orderId = params.get("id");
    const order = (0, $e18f565b44c7bc7d$export$42d4e273b2226793)((_a = orderId) !== null && _a !== void 0 ? _a : null);
    const localize = (0, $aIeEI.useLocalize)();
    const [renewalModalIsOpen, setRenewalModalIsOpen] = (0, $eeH7J.useState)(false);
    const tradeInForm = (0, $e18f565b44c7bc7d$export$f8778ca18805596d)("Phones");
    const [tradeInId, setTradeInId] = (0, $eK8Q4.useSessionState)("tradein-modal-id", undefined);
    const [tradeInModalIsOpen, setTradeInModalIsOpen] = (0, $eK8Q4.useSessionState)("tradein-modal-open", false);
    const renewalOptions = (0, $e18f565b44c7bc7d$export$cd3361f95bba4719)(((_b = order.data) === null || _b === void 0 ? void 0 : _b.status) === "delivered" ? (_c = orderId) !== null && _c !== void 0 ? _c : null : null);
    const renewalAvailable = !!((_d = renewalOptions.data) === null || _d === void 0 ? void 0 : _d.options);
    const [cancellationModalIsOpen, setCancellationModalIsOpen] = (0, $eeH7J.useState)(false);
    // If no subscription id is provided, redirect to the most recently placed order. Reason for
    // this being implemented is Redoit want to be able to include a (standard) QR-code in the
    // box when shipping the phones, encouraging making a trade-in if they have not already, that
    // should lead to the subscription page.
    (0, $eeH7J.useEffect)(()=>{
        async function redirectToSubscription() {
            const orders = await (0, $e18f565b44c7bc7d$export$cb8b42d135ef9214)();
            const activeOrders = [
                ...orders.orders
            ].sort((a, b)=>a.placed < b.placed ? 1 : -1);
            if (!activeOrders[0]) return;
            const sp = Object.fromEntries(params);
            setParams(Object.assign(Object.assign({}, sp), {
                id: activeOrders[0].id.valueOf()
            }), {
                replace: true
            });
        }
        if (!orderId) redirectToSubscription();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    if (!order.data) return (0, $4vwom.jsx)((0, $4vwom.Fragment), {});
    const { model: model } = order.data;
    return (0, $4vwom.jsx)((0, $4vwom.Fragment), {
        children: (0, $4vwom.jsx)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
            justifyContent: "center",
            css: (0, $lhaLc.css)({
                paddingTop: 32,
                paddingBottom: 32
            }, (0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("min", "md", {
                paddingTop: 64,
                paddingBottom: 64
            })),
            children: (0, $4vwom.jsxs)("div", {
                style: {
                    maxWidth: 1020,
                    width: "100%"
                },
                css: (0, $lhaLc.css)({
                    display: "grid",
                    gridTemplateAreas: '"text details" "menu details"',
                    gridTemplateColumns: "56fr 70fr",
                    gridTemplateRows: "minmax(0, auto)",
                    columnGap: (0, $756948b644e82cf2$export$981516ee4691055c)(140)
                }, (0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("max", "sm", {
                    gridTemplateAreas: '"text" "details" "menu"',
                    gridTemplateRows: "auto",
                    gridTemplateColumns: "1fr",
                    rowGap: 32
                })),
                children: [
                    (0, $4vwom.jsxs)("div", {
                        css: (0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("min", "md", {
                            marginBottom: 16
                        }),
                        children: [
                            (0, $4vwom.jsx)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                                alignItems: "center",
                                children: (0, $4vwom.jsx)((0, $789b8639be592288$export$a8a3e93435678ff9), {
                                    level: 1,
                                    truncate: true,
                                    children: localize(model.name)
                                })
                            }),
                            model.features && model.features.length > 0 && (0, $4vwom.jsx)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                                gap: 8,
                                alignItems: "center",
                                style: {
                                    overflow: "hidden"
                                },
                                children: (0, $4vwom.jsxs)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                    variant: "body",
                                    size: "xl",
                                    color: "gray300",
                                    css: (0, $lhaLc.css)({
                                        display: "inline-block",
                                        whiteSpace: "nowrap",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        flex: "1 1 auto"
                                    }),
                                    children: [
                                        localize(section.orderNumberLabel),
                                        ": ",
                                        order.data.orderNumber
                                    ]
                                })
                            })
                        ]
                    }),
                    (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                        gap: 28,
                        direction: "column",
                        margin: {
                            top: (0, $756948b644e82cf2$export$981516ee4691055c)(32)
                        },
                        style: {
                            gridArea: "menu",
                            alignSelf: "start"
                        },
                        children: [
                            (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                                style: {
                                    cursor: !order.data.tradeIn ? "pointer" : "inherit"
                                },
                                justifyContent: "space-between",
                                color: order.data.tradeIn ? "gray300" : undefined,
                                alignItems: "center",
                                onClick: ()=>{
                                    var _a;
                                    if ((_a = order.data) === null || _a === void 0 ? void 0 : _a.tradeIn) return;
                                    setTradeInId((0, $dAwef.Uuid)().valueOf());
                                    setTradeInModalIsOpen(true);
                                },
                                children: [
                                    (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                        variant: "heading",
                                        level: 3,
                                        children: localize(section.menu.tradeIn)
                                    }),
                                    (0, $4vwom.jsx)((0, $f8cdd04128a131cf$export$f04a61298a47a40f), {
                                        icon: "arrowRight"
                                    })
                                ]
                            }),
                            (0, $4vwom.jsx)((0, $67d1e32b493d1bb5$export$2e0a83ec2e27ecbb), {
                                horizontal: true,
                                spacing: 0
                            }),
                            (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                                style: {
                                    cursor: renewalAvailable ? "pointer" : "inherit"
                                },
                                justifyContent: "space-between",
                                color: !renewalAvailable ? "gray300" : undefined,
                                alignItems: "center",
                                onClick: ()=>{
                                    var _a;
                                    if (!((_a = renewalOptions.data) === null || _a === void 0 ? void 0 : _a.options)) return;
                                    setRenewalModalIsOpen(true);
                                },
                                children: [
                                    (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                        variant: "heading",
                                        level: 3,
                                        children: localize(section.menu.renewSubscription)
                                    }),
                                    (0, $4vwom.jsx)((0, $f8cdd04128a131cf$export$f04a61298a47a40f), {
                                        icon: "arrowRight"
                                    })
                                ]
                            }),
                            (0, $4vwom.jsx)((0, $67d1e32b493d1bb5$export$2e0a83ec2e27ecbb), {
                                horizontal: true,
                                spacing: 0
                            }),
                            (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                                color: order.data.cancelled || order.data.cancellationRequested ? "gray300" : "warning",
                                style: {
                                    cursor: order.data.cancelled || order.data.cancellationRequested ? "inherit" : "pointer"
                                },
                                justifyContent: "space-between",
                                alignItems: "center",
                                onClick: order.data.cancelled || order.data.cancellationRequested ? undefined : ()=>setCancellationModalIsOpen(true),
                                children: [
                                    (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                        variant: "heading",
                                        level: 3,
                                        children: localize(section.menu.cancelSubscription)
                                    }),
                                    (0, $4vwom.jsx)((0, $f8cdd04128a131cf$export$f04a61298a47a40f), {
                                        icon: "arrowRight"
                                    })
                                ]
                            })
                        ]
                    }),
                    (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                        direction: "column",
                        flex: "566 0 0",
                        gap: 24,
                        style: {
                            gridArea: "details",
                            alignSelf: "stretch"
                        },
                        children: [
                            (0, $4vwom.jsx)((0, $789b8639be592288$export$a8a3e93435678ff9), {
                                level: 3,
                                children: localize(section.details.heading)
                            }),
                            order.data.cancelled ? (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                variant: "body",
                                size: "md",
                                children: (0, $4vwom.jsx)((0, $82d66b15b8f4758d$export$d5163f1ce1e6a5f9), {
                                    value: section.details.subscriptionIsCancelled
                                })
                            }) : (0, $4vwom.jsx)($87baa387e4f39550$var$OrderSummary, Object.assign({
                                order: order.data
                            }, section.details)),
                            orderId && (0, $4vwom.jsx)($87baa387e4f39550$var$OrderReceipts, Object.assign({
                                order: order.data
                            }, section.details.receipts))
                        ]
                    }),
                    (0, $4vwom.jsx)($87baa387e4f39550$var$CancelSubscription, Object.assign({}, section.cancelSubscription, {
                        modalIsOpen: cancellationModalIsOpen,
                        setModalIsOpen: setCancellationModalIsOpen,
                        order: order.data,
                        refreshOrder: order.refresh
                    })),
                    (0, $4vwom.jsx)($87baa387e4f39550$var$RenewSubscription, Object.assign({}, section.renewSubscription, {
                        modalIsOpen: renewalModalIsOpen,
                        setModalIsOpen: setRenewalModalIsOpen,
                        order: order.data,
                        refreshOrder: order.refresh
                    })),
                    tradeInForm.data && !!tradeInId && (0, $4vwom.jsx)((0, $0eca38a3f9eebfa7$export$9e5a8dc8aab6dd64), Object.assign({
                        id: tradeInId,
                        form: tradeInForm.data,
                        onClose: ()=>{
                            setTradeInModalIsOpen(false);
                        },
                        open: tradeInModalIsOpen,
                        productName: localize(model.name),
                        months: order.data.monthsLeft,
                        originalPrice: order.data.rentalPeriod.monthlyPrice,
                        onTradeInConfirm: async (form, responses)=>{
                            if (!order.data) {
                                alert("Missing order");
                                return;
                            }
                            await (0, $e18f565b44c7bc7d$export$6b2bf9023d89c7d6)(order.data.id, {
                                tradeIn: {
                                    form: form.id,
                                    version: form.version,
                                    responses: responses
                                }
                            });
                            order.refresh();
                            setTradeInModalIsOpen(false);
                        }
                    }, section.tradeIn.modal))
                ]
            })
        })
    });
}
function $87baa387e4f39550$var$RenewSubscription(_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
    var { order: order, modalIsOpen: modalIsOpen, setModalIsOpen: setModalIsOpen, refreshOrder: refreshOrder } = _a, props = $87baa387e4f39550$var$__rest(_a, [
        "order",
        "modalIsOpen",
        "setModalIsOpen",
        "refreshOrder"
    ]);
    const localize = (0, $aIeEI.useLocalize)();
    const [termsAccepted, setTermsAccepted] = (0, $eeH7J.useState)(false);
    const [state, setState] = (0, $eeH7J.useState)("form");
    const renewalOptions = (0, $e18f565b44c7bc7d$export$cd3361f95bba4719)(order.status === "delivered" ? (_b = order.id) !== null && _b !== void 0 ? _b : null : null);
    // Selected option is referring to the number of months.
    const [selectedOptionMonths, setSelectedOptionMonths] = (0, $eeH7J.useState)();
    const selectedOption = (0, $eeH7J.useMemo)(()=>{
        var _a;
        return (_a = renewalOptions.data) === null || _a === void 0 ? void 0 : _a.options.find((o)=>o.months === selectedOptionMonths);
    }, [
        selectedOptionMonths,
        renewalOptions.data
    ]);
    const terms = (0, $e18f565b44c7bc7d$export$23e8c26267d65867)();
    (0, $eeH7J.useEffect)(()=>{
        var _a, _b;
        if (!selectedOptionMonths && ((_a = renewalOptions.data) === null || _a === void 0 ? void 0 : _a.options)) setSelectedOptionMonths((_b = renewalOptions.data.options.at(0)) === null || _b === void 0 ? void 0 : _b.months);
    }, [
        (_c = renewalOptions.data) === null || _c === void 0 ? void 0 : _c.options,
        selectedOptionMonths
    ]);
    const renewalPeriodTotalPrice = (0, $eeH7J.useMemo)(()=>{
        if (!selectedOption) return;
        return {
            minorUnits: selectedOption.months * selectedOption.price.itemsTotal.minorUnits,
            majorUnits: selectedOption.months * selectedOption.price.itemsTotal.majorUnits,
            currency: selectedOption.price.itemsTotal.currency
        };
    }, [
        selectedOption
    ]);
    const formatAmount = (0, $b274814d74f89bd0$export$cd05f017078a61a8)();
    const handleRenewConfirmation = (0, $eeH7J.useCallback)(async ()=>{
        try {
            if (!selectedOption || !terms.data) throw new Error("Missing data.");
            await (0, $e18f565b44c7bc7d$export$e88ba7c9a7cf1f6)(order.id, selectedOption.months, terms.data.phoneOrder.id, terms.data.insurance.id);
            refreshOrder();
            setModalIsOpen(false);
        } catch (err) {
            setState("error");
        }
    }, [
        order.id,
        refreshOrder,
        selectedOption,
        setModalIsOpen,
        terms.data
    ]);
    return (0, $4vwom.jsx)((0, $37d4981a6b4c97c0$export$2b77a92f1a5ad772), {
        width: 640,
        isOpen: modalIsOpen,
        header: {
            title: localize((_d = props.title) !== null && _d !== void 0 ? _d : {}),
            closeButton: true
        },
        onClose: ()=>setModalIsOpen(false),
        children: (0, $4vwom.jsx)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
            direction: "column",
            gap: 24,
            children: state === "error" ? (0, $4vwom.jsxs)((0, $4vwom.Fragment), {
                children: [
                    (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                        variant: "body",
                        size: "md",
                        children: (0, $4vwom.jsx)((0, $82d66b15b8f4758d$export$d5163f1ce1e6a5f9), {
                            value: localize((_e = props.renewalErrorText) !== null && _e !== void 0 ? _e : {})
                        })
                    }),
                    (0, $4vwom.jsx)((0, $4b4086f8a1c6b2f8$export$353f5b6fc5456de1), {
                        variant: "dark",
                        size: "md",
                        onClick: ()=>setState("form"),
                        children: localize({
                            no: "Pr\xf8v igjen",
                            en: "Try again"
                        })
                    })
                ]
            }) : (0, $4vwom.jsxs)((0, $4vwom.Fragment), {
                children: [
                    !!props.text && (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                        variant: "body",
                        size: "md",
                        children: localize(props.text)
                    }),
                    ((_f = renewalOptions.data) === null || _f === void 0 ? void 0 : _f.options.length) === 0 && (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                        variant: "body",
                        size: "md",
                        children: localize({
                            no: "Ingen fornyelsesalternativer tilgjengelig.",
                            en: "No renewal options available."
                        })
                    }),
                    renewalOptions.error && (0, $4vwom.jsx)("div", {
                        children: renewalOptions.error.detail
                    }),
                    renewalOptions.data && selectedOption && selectedOptionMonths && renewalPeriodTotalPrice && (0, $4vwom.jsxs)((0, $4vwom.Fragment), {
                        children: [
                            (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                                borderRadius: "lg",
                                borderColor: "gray200",
                                padding: "md",
                                direction: "column",
                                css: (0, $lhaLc.css)({
                                    gap: 24
                                }, (0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("min", "md", {
                                    gap: 28
                                })),
                                children: [
                                    (0, $4vwom.jsxs)("div", {
                                        children: [
                                            (0, $4vwom.jsx)((0, $789b8639be592288$export$a8a3e93435678ff9), {
                                                level: 4,
                                                margin: {
                                                    bottom: 16
                                                },
                                                children: localize((_g = props.renewalOptionsLabel) !== null && _g !== void 0 ? _g : {})
                                            }),
                                            (0, $4vwom.jsx)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                                                direction: "column",
                                                gap: 8,
                                                css: (0, $lhaLc.css)({
                                                    "> *": {
                                                        flex: "1 0 0"
                                                    }
                                                }),
                                                children: (0, $4vwom.jsx)((0, $8e85e0d8eea1dda5$export$a98f0dcb43a68a25), {
                                                    value: selectedOptionMonths,
                                                    options: renewalOptions.data.options.map((rp)=>({
                                                            value: rp.months,
                                                            text: localize({
                                                                no: `${rp.months} m\xe5neder`,
                                                                en: `${rp.months} months`
                                                            })
                                                        })),
                                                    renderOption: (option, selected)=>{
                                                        var _a, _b;
                                                        const rentalPeriodPrice = (_b = (_a = renewalOptions.data) === null || _a === void 0 ? void 0 : _a.options.find((o)=>o.months === option.value)) === null || _b === void 0 ? void 0 : _b.price;
                                                        if (!rentalPeriodPrice) return null;
                                                        return (0, $4vwom.jsx)((0, $4b4086f8a1c6b2f8$export$353f5b6fc5456de1), {
                                                            variant: "select",
                                                            selected: selected,
                                                            fullwidth: true,
                                                            as: "div",
                                                            size: "md",
                                                            children: (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                                                                style: {
                                                                    width: "100%"
                                                                },
                                                                justifyContent: "space-between",
                                                                children: [
                                                                    (0, $4vwom.jsxs)("div", {
                                                                        style: !selected ? {
                                                                            fontWeight: 300
                                                                        } : {},
                                                                        children: [
                                                                            option.value,
                                                                            " ",
                                                                            localize((0, $b274814d74f89bd0$export$2bb3eb27682a776))
                                                                        ]
                                                                    }),
                                                                    (0, $4vwom.jsxs)("div", {
                                                                        children: [
                                                                            formatAmount(rentalPeriodPrice.phone),
                                                                            "/",
                                                                            localize((0, $b274814d74f89bd0$export$b4b23bfab2f68498))
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        });
                                                    },
                                                    onChange: async (e, val)=>{
                                                        setSelectedOptionMonths(val);
                                                    }
                                                })
                                            })
                                        ]
                                    }),
                                    (0, $4vwom.jsx)((0, $67d1e32b493d1bb5$export$2e0a83ec2e27ecbb), {
                                        horizontal: true,
                                        spacing: 0
                                    }),
                                    !!selectedOption.price.insurance && renewalOptions.data.insurance && (0, $4vwom.jsxs)((0, $4vwom.Fragment), {
                                        children: [
                                            (0, $4vwom.jsx)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                                                direction: "column",
                                                children: (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                                                    gap: 8,
                                                    children: [
                                                        (0, $4vwom.jsx)((0, $f8cdd04128a131cf$export$f04a61298a47a40f), {
                                                            icon: "shield"
                                                        }),
                                                        (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                                            variant: "body",
                                                            size: "md",
                                                            children: (0, $87d2193cf0695c20$export$4493d2932fe76cf8)(localize(props.renewInsuranceLabel), {
                                                                monthlyPrice: formatAmount(selectedOption.price.insurance),
                                                                monthsShort: localize((0, $b274814d74f89bd0$export$b4b23bfab2f68498)),
                                                                insuranceName: localize(renewalOptions.data.insurance.displayName)
                                                            })
                                                        })
                                                    ]
                                                })
                                            }),
                                            (0, $4vwom.jsx)((0, $67d1e32b493d1bb5$export$2e0a83ec2e27ecbb), {
                                                horizontal: true,
                                                spacing: 0
                                            })
                                        ]
                                    }),
                                    renewalOptions.data.discounts && renewalOptions.data.discountsTotalValue && (0, $4vwom.jsxs)((0, $4vwom.Fragment), {
                                        children: [
                                            (0, $4vwom.jsx)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                                                direction: "column",
                                                children: (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                                                    gap: 8,
                                                    children: [
                                                        (0, $4vwom.jsx)((0, $f8cdd04128a131cf$export$f04a61298a47a40f), {
                                                            icon: "sealPercent"
                                                        }),
                                                        (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                                            variant: "body",
                                                            size: "md",
                                                            children: (0, $87d2193cf0695c20$export$4493d2932fe76cf8)(localize(props.renewDiscountsLabel), {
                                                                discountsTotalValue: formatAmount(renewalOptions.data.discountsTotalValue)
                                                            })
                                                        })
                                                    ]
                                                })
                                            }),
                                            (0, $4vwom.jsx)((0, $67d1e32b493d1bb5$export$2e0a83ec2e27ecbb), {
                                                horizontal: true,
                                                spacing: 0
                                            })
                                        ]
                                    }),
                                    (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                                        direction: "column",
                                        gap: 4,
                                        children: [
                                            (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                                                alignItems: "baseline",
                                                gap: "4px 8px",
                                                style: {
                                                    whiteSpace: "nowrap",
                                                    flexWrap: "wrap"
                                                },
                                                children: [
                                                    (0, $4vwom.jsxs)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                                        variant: "heading",
                                                        level: [
                                                            2,
                                                            [
                                                                "min",
                                                                "md",
                                                                3
                                                            ]
                                                        ],
                                                        color: "brand",
                                                        children: [
                                                            formatAmount(selectedOption.price.itemsTotal),
                                                            "/",
                                                            localize((0, $b274814d74f89bd0$export$b4b23bfab2f68498))
                                                        ]
                                                    }),
                                                    (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                                        variant: "body",
                                                        size: "md",
                                                        children: (0, $87d2193cf0695c20$export$4493d2932fe76cf8)(localize((_h = props.totalPricePostFix) !== null && _h !== void 0 ? _h : {}), {
                                                            rentalPeriod: `${selectedOptionMonths}`
                                                        })
                                                    })
                                                ]
                                            }),
                                            (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                                variant: "body",
                                                size: "sm",
                                                color: "gray300",
                                                children: (0, $87d2193cf0695c20$export$4493d2932fe76cf8)(localize((_j = props.rentalPeriodTotalPrice) !== null && _j !== void 0 ? _j : {}), {
                                                    rentalPeriod: `${selectedOptionMonths}`,
                                                    totalPrice: `${formatAmount(renewalPeriodTotalPrice)}`,
                                                    monthsShort: localize((0, $b274814d74f89bd0$export$b4b23bfab2f68498)),
                                                    monthsLong: localize((0, $b274814d74f89bd0$export$2bb3eb27682a776))
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            (0, $4vwom.jsx)((0, $06e3a36d2d83b339$export$48513f6b9f8ce62d), {
                                label: localize((_k = props.termsAndConditionsLabel) !== null && _k !== void 0 ? _k : {}),
                                checked: termsAccepted,
                                onChange: ()=>setTermsAccepted(!termsAccepted)
                            }),
                            (0, $4vwom.jsx)((0, $4b4086f8a1c6b2f8$export$353f5b6fc5456de1), {
                                variant: "primary",
                                fullwidth: true,
                                disabled: !termsAccepted,
                                onClick: handleRenewConfirmation,
                                children: localize((_l = props.confirmButtonText) !== null && _l !== void 0 ? _l : {})
                            })
                        ]
                    })
                ]
            })
        })
    });
}
function $87baa387e4f39550$var$CancelSubscription(_a) {
    var { order: order, modalIsOpen: modalIsOpen, setModalIsOpen: setModalIsOpen, refreshOrder: refreshOrder } = _a, props = $87baa387e4f39550$var$__rest(_a, [
        "order",
        "modalIsOpen",
        "setModalIsOpen",
        "refreshOrder"
    ]);
    const localize = (0, $aIeEI.useLocalize)();
    const cancellationTerms = (0, $e18f565b44c7bc7d$export$7a4a3d03ee7c067f)(order.id);
    const formatAmount = (0, $b274814d74f89bd0$export$cd05f017078a61a8)();
    const [state, setState] = (0, $eeH7J.useState)("prompt");
    const handleCancellationConfirmation = (0, $eeH7J.useCallback)(async ()=>{
        if (!cancellationTerms.data) {
            setState("error");
            return;
        }
        try {
            await (0, $e18f565b44c7bc7d$export$8061bbc383a29848)(order.id, {
                cancellationFee: cancellationTerms.data.cancellationFee,
                cancellationTerms: cancellationTerms.data.cancellationTerms
            });
            refreshOrder();
            setState("success");
        } catch (err) {
            setState("error");
        }
    }, [
        cancellationTerms.data,
        order.id,
        refreshOrder
    ]);
    if (!cancellationTerms.data) return (0, $4vwom.jsx)((0, $4vwom.Fragment), {});
    return (0, $4vwom.jsx)((0, $37d4981a6b4c97c0$export$2b77a92f1a5ad772), {
        isOpen: modalIsOpen,
        onClose: ()=>setModalIsOpen(false),
        header: {
            title: localize(props.title),
            closeButton: true
        },
        children: (0, $4vwom.jsx)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
            direction: "column",
            gap: 24,
            children: state === "prompt" ? (0, $4vwom.jsxs)((0, $4vwom.Fragment), {
                children: [
                    (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                        variant: "body",
                        size: "md",
                        children: (0, $87d2193cf0695c20$export$4493d2932fe76cf8)(localize(props.cancellationPrompt), {
                            cancellationFee: formatAmount(cancellationTerms.data.cancellationFee),
                            monthsRemaining: cancellationTerms.data.monthsRemaining.toString()
                        })
                    }),
                    (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                        variant: "body",
                        size: "md",
                        children: (0, $4vwom.jsx)((0, $82d66b15b8f4758d$export$d5163f1ce1e6a5f9), {
                            value: cancellationTerms.data.cancellationTerms
                        })
                    }),
                    (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                        gap: 8,
                        css: (0, $lhaLc.css)({
                            flexWrap: "wrap"
                        }, (0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("max", "xs", {
                            flexDirection: "column",
                            alignItems: "stretch"
                        })),
                        children: [
                            (0, $4vwom.jsx)((0, $4b4086f8a1c6b2f8$export$353f5b6fc5456de1), {
                                variant: "secondary",
                                size: "sm",
                                onClick: ()=>setModalIsOpen(false),
                                children: localize(props.cancelButtonText)
                            }),
                            (0, $4vwom.jsx)((0, $4b4086f8a1c6b2f8$export$353f5b6fc5456de1), {
                                variant: "dark",
                                size: "sm",
                                onClick: handleCancellationConfirmation,
                                children: localize(props.confirmButtonText)
                            })
                        ]
                    })
                ]
            }) : state === "error" ? (0, $4vwom.jsxs)((0, $4vwom.Fragment), {
                children: [
                    (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                        variant: "body",
                        size: "md",
                        children: (0, $4vwom.jsx)((0, $82d66b15b8f4758d$export$d5163f1ce1e6a5f9), {
                            value: props.cancellationErrorText
                        })
                    }),
                    (0, $4vwom.jsx)((0, $4b4086f8a1c6b2f8$export$353f5b6fc5456de1), {
                        variant: "secondary",
                        size: "sm",
                        onClick: ()=>setModalIsOpen(false),
                        children: localize(props.closeButtonText)
                    })
                ]
            }) : state === "success" ? (0, $4vwom.jsxs)((0, $4vwom.Fragment), {
                children: [
                    (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                        variant: "body",
                        size: "md",
                        children: (0, $4vwom.jsx)((0, $82d66b15b8f4758d$export$d5163f1ce1e6a5f9), {
                            value: props.cancellationSuccessText
                        })
                    }),
                    (0, $4vwom.jsx)((0, $4b4086f8a1c6b2f8$export$353f5b6fc5456de1), {
                        variant: "secondary",
                        size: "sm",
                        onClick: ()=>setModalIsOpen(false),
                        children: localize(props.closeButtonText)
                    })
                ]
            }) : null
        })
    });
}
function $87baa387e4f39550$var$OrderSummary(_a) {
    var _b, _c, _d;
    var { order: order } = _a, props = $87baa387e4f39550$var$__rest(_a, [
        "order"
    ]);
    const price = order.rentalPeriod.monthlyPrice;
    const localize = (0, $aIeEI.useLocalize)();
    const formatAmount = (0, $b274814d74f89bd0$export$cd05f017078a61a8)();
    const insuranceOptions = (0, $e18f565b44c7bc7d$export$fd8b73cd610fc548)(order.model.id, order.phone.storage, order.phone.color, order.rentalPeriod.months);
    const [showInsuranceTerms, setShowInsuranceTerms] = (0, $eeH7J.useState)(false);
    const insurance = (_b = insuranceOptions.data) === null || _b === void 0 ? void 0 : _b.find((io)=>io.id === order.insurance);
    const statusToDisplay = (0, $eeH7J.useMemo)(()=>{
        if (order.customStatus) return order.customStatus;
        if (order.cancellationRequested && props.status.cancellationRequestedStatusLabel) return props.status.cancellationRequestedStatusLabel;
        if (order.status in props.status.statusLabels) return props.status.statusLabels[order.status];
    }, [
        order.cancellationRequested,
        order.customStatus,
        order.status,
        props.status.cancellationRequestedStatusLabel,
        props.status.statusLabels
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($alVaN))).extend((0, (/*@__PURE__*/$parcel$interopDefault($hFOwS))));
    return (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
        direction: "column",
        gap: 24,
        children: [
            statusToDisplay ? (0, $4vwom.jsx)((0, $ad78a5ecb6406b10$export$ac61754cc5f685a7), {
                step: localize(props.status.heading),
                icon: props.status.icon,
                title: localize(statusToDisplay)
            }) : null,
            (0, $4vwom.jsx)((0, $ad78a5ecb6406b10$export$ac61754cc5f685a7), {
                step: (0, $87d2193cf0695c20$export$4493d2932fe76cf8)(localize(props.subscriptionPeriod.heading), {
                    nextChargeDate: (0, (/*@__PURE__*/$parcel$interopDefault($alVaN)))(order.nextChargeDate).format("DD.MM.YYYY")
                }),
                icon: "calendar",
                title: props.subscriptionPeriod.subtitle ? (0, $87d2193cf0695c20$export$4493d2932fe76cf8)(localize(props.subscriptionPeriod.subtitle), {
                    amount: formatAmount(order.nextCharge.total)
                }) : undefined,
                text: (0, $87d2193cf0695c20$export$4493d2932fe76cf8)(localize(props.subscriptionPeriod.text), {
                    monthsLeft: order.monthsLeft.toString(),
                    rentalPeriodMonths: order.rentalPeriod.months.toString()
                }),
                subtitle: (_c = order.nextCharge.discounts) === null || _c === void 0 ? void 0 : _c.map((d, index)=>{
                    var _a;
                    return (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                        variant: "body",
                        size: "md",
                        color: "brand",
                        children: (0, $87d2193cf0695c20$export$4493d2932fe76cf8)(localize(props.subscriptionPeriod.discountText), {
                            discountName: `${(_a = d.code) !== null && _a !== void 0 ? _a : localize(d.name)}`,
                            discountAmount: formatAmount(d.amount),
                            remainingMonths: d.remainingMonths.toString(),
                            totalMonths: d.totalMonths.toString()
                        })
                    }, `${index}${d.amount.majorUnits}${localize(d.name)}`);
                }),
                label: props.subscriptionPeriod.label ? localize(props.subscriptionPeriod.label) : undefined
            }),
            (0, $4vwom.jsx)((0, $9ef1a37a4c2e6964$export$161a6b098fcc9bc6), {
                originalPrice: price.phone.majorUnits,
                discountedPrice: order.tradeIn && order.tradeIn.discount.remainingMonths > 0 ? price.phone.majorUnits - order.tradeIn.discount.amount.majorUnits : price.phone.majorUnits,
                currency: localize((_d = (0, $b274814d74f89bd0$export$91d51a43b638ef12)[price.itemsTotal.currency]) !== null && _d !== void 0 ? _d : {
                    no: price.itemsTotal.currency
                }),
                label: localize(props.payment.monthlyLabel),
                itemName: localize(order.model.name),
                rentalPeriodUnit: localize((0, $b274814d74f89bd0$export$b4b23bfab2f68498)),
                text: order.tradeIn && order.tradeIn.discount.remainingMonths > 0 ? localize(props.payment.phonePriceWithTradeInText) : localize(props.payment.phonePriceText)
            }),
            insurance ? (0, $4vwom.jsxs)((0, $4vwom.Fragment), {
                children: [
                    (0, $4vwom.jsx)((0, $ad78a5ecb6406b10$export$ac61754cc5f685a7), {
                        step: localize(props.insurance.heading),
                        icon: "shield",
                        title: localize(insurance.displayName),
                        price: price.insurance ? formatAmount(price.insurance) : undefined,
                        list: insurance.sellingPoints.map((sp)=>({
                                id: sp.id.valueOf(),
                                icon: sp.icon,
                                text: localize(sp.text)
                            })),
                        text: (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                            variant: "body",
                            size: "md",
                            onClick: ()=>setShowInsuranceTerms(true),
                            underline: true,
                            style: {
                                cursor: "pointer"
                            },
                            children: localize(props.insurance.showTermsLink)
                        }),
                        label: props.insurance.label ? localize(props.insurance.label) : undefined
                    }),
                    (0, $4vwom.jsx)((0, $37d4981a6b4c97c0$export$2b77a92f1a5ad772), {
                        isOpen: showInsuranceTerms,
                        header: {
                            title: (0, $87d2193cf0695c20$export$4493d2932fe76cf8)(localize(props.insurance.termsModalTitle), {
                                insuranceName: localize(insurance.displayName)
                            }),
                            closeButton: true
                        },
                        onClose: ()=>setShowInsuranceTerms(false),
                        children: (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                            variant: "body",
                            size: "sm",
                            children: (0, $4vwom.jsx)((0, $82d66b15b8f4758d$export$d5163f1ce1e6a5f9), {
                                value: localize(insurance.termsAndConditions.content)
                            })
                        })
                    })
                ]
            }) : null
        ]
    });
}
function $87baa387e4f39550$var$OrderReceipts(_a) {
    var { order: order } = _a, props = $87baa387e4f39550$var$__rest(_a, [
        "order"
    ]);
    const localize = (0, $aIeEI.useLocalize)();
    const formatAmount = (0, $b274814d74f89bd0$export$cd05f017078a61a8)();
    (0, (/*@__PURE__*/$parcel$interopDefault($alVaN))).extend((0, (/*@__PURE__*/$parcel$interopDefault($hFOwS))));
    return (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
        borderRadius: "md",
        padding: "md",
        borderColor: "gray200",
        direction: "column",
        gap: 16,
        children: [
            (0, $4vwom.jsx)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                justifyContent: "space-between",
                alignItems: "center",
                children: (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                    gap: 8,
                    children: [
                        (0, $4vwom.jsx)((0, $f8cdd04128a131cf$export$f04a61298a47a40f), {
                            icon: "receipt"
                        }),
                        " ",
                        (0, $4vwom.jsx)((0, $789b8639be592288$export$a8a3e93435678ff9), {
                            level: 4,
                            children: localize(props.heading)
                        })
                    ]
                })
            }),
            (0, $4vwom.jsx)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                gap: 24,
                direction: "column",
                children: order.receipts.length ? order.receipts.map((receipt, index)=>(0, $4vwom.jsxs)((0, $eeH7J.Fragment), {
                        children: [
                            index > 0 && (0, $4vwom.jsx)((0, $67d1e32b493d1bb5$export$2e0a83ec2e27ecbb), {
                                horizontal: true,
                                spacing: 0
                            }),
                            (0, $4vwom.jsxs)("a", {
                                href: `/api/phone-orders/${order.id}/pdf-receipts/${receipt.id}`,
                                style: {
                                    cursor: "pointer",
                                    display: "flex",
                                    flexDirection: "row",
                                    width: "100%",
                                    justifyContent: "space-between"
                                },
                                children: [
                                    (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                        variant: "body",
                                        size: "md",
                                        children: (0, (/*@__PURE__*/$parcel$interopDefault($alVaN)))(receipt.date.valueOf()).format(localize(props.dateFormat))
                                    }),
                                    (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                                        gap: 24,
                                        children: [
                                            (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                                variant: "body",
                                                size: "md",
                                                children: formatAmount(receipt.total)
                                            }),
                                            (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                                variant: "body",
                                                size: "md",
                                                underline: true,
                                                children: localize(props.downloadLinkText)
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }, receipt.id.valueOf())) : (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                    variant: "body",
                    size: "sm",
                    color: "gray300",
                    children: localize(props.noReceiptsMessage)
                })
            })
        ]
    });
}



var $4vwom = parcelRequire("4vwom");

var $9G56J = parcelRequire("9G56J");
parcelRequire("jniej");
var $cWF8g = parcelRequire("cWF8g");



var $aIeEI = parcelRequire("aIeEI");

var $f2yFo = parcelRequire("f2yFo");


var $eeH7J = parcelRequire("eeH7J");

(0, $9G56J.Section)($577c7fc3efab75b3$var$CancelView);
function $577c7fc3efab75b3$var$CancelView(section) {
    var _a, _b, _c;
    const orderId = (0, $cWF8g.useQueryString)("id")[0];
    const order = (0, $e18f565b44c7bc7d$export$42d4e273b2226793)(orderId !== null && orderId !== void 0 ? orderId : null);
    const cancelTerms = (0, $e18f565b44c7bc7d$export$7a4a3d03ee7c067f)(orderId !== null && orderId !== void 0 ? orderId : null);
    const [accepted, setAccepted] = (0, $eeH7J.useState)(false);
    const localize = (0, $aIeEI.useLocalize)();
    if (!order.data) return (0, $4vwom.jsx)((0, $4vwom.Fragment), {});
    const { model: model } = order.data;
    async function cancel() {
        if (!orderId) {
            alert("No order ID");
            return;
        }
        if (!cancelTerms.data) {
            alert("No cancel terms");
            return;
        }
        await (0, $e18f565b44c7bc7d$export$8061bbc383a29848)(orderId, {
            cancellationFee: cancelTerms.data.cancellationFee,
            cancellationTerms: cancelTerms.data.cancellationTerms
        });
        alert(localize(section.confirmText));
        location.pathname = "/account";
    }
    return (0, $4vwom.jsxs)("div", {
        style: {
            backgroundColor: "#fee",
            padding: 32
        },
        children: [
            (0, $4vwom.jsxs)((0, $789b8639be592288$export$a8a3e93435678ff9), {
                level: 2,
                children: [
                    "Cancel your subscription - ",
                    localize(model.name)
                ]
            }),
            (0, $4vwom.jsx)("div", {
                children: cancelTerms.data && (0, $4vwom.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($f2yFo))), {
                    children: localize((_a = cancelTerms.data) === null || _a === void 0 ? void 0 : _a.cancellationTerms).valueOf()
                })
            }),
            (0, $4vwom.jsxs)("div", {
                children: [
                    localize(section.cancelFee),
                    ": ",
                    (_b = cancelTerms.data) === null || _b === void 0 ? void 0 : _b.cancellationFee.majorUnits,
                    " ",
                    (_c = cancelTerms.data) === null || _c === void 0 ? void 0 : _c.cancellationFee.currency
                ]
            }),
            (0, $4vwom.jsxs)("div", {
                children: [
                    (0, $4vwom.jsx)((0, $06e3a36d2d83b339$export$48513f6b9f8ce62d), {
                        disabled: !cancelTerms.data,
                        checked: accepted,
                        onChange: ()=>setAccepted(!accepted)
                    }),
                    (0, $4vwom.jsx)("div", {
                        children: localize(section.iAcceptTheTerms)
                    })
                ]
            }),
            (0, $4vwom.jsx)((0, $4b4086f8a1c6b2f8$export$353f5b6fc5456de1), {
                disabled: !cancelTerms.data && accepted,
                onClick: cancel,
                children: localize(section.confirmButton)
            })
        ]
    });
}



var $4vwom = parcelRequire("4vwom");

var $eeH7J = parcelRequire("eeH7J");

var $lhaLc = parcelRequire("lhaLc");

var $5K1mb = parcelRequire("5K1mb");


var $9G56J = parcelRequire("9G56J");

var $dUDPg = parcelRequire("dUDPg");
parcelRequire("2LTO8");
var $iXeBy = parcelRequire("iXeBy");

var $aIeEI = parcelRequire("aIeEI");



/**
 * @icon ui-slash-divider
 */ function $2e164f197f37655e$var$Breadcrumb(section) {
    var _a;
    const { colors: colors, responsiveCss: responsiveCss } = (0, $756948b644e82cf2$export$559a0f07c8df6570)();
    const pageContext = (0, $eeH7J.useContext)((0, $9fe8ccb750b589bb$export$6245f31671de0b04));
    const localize = (0, $aIeEI.useLocalize)();
    const currentLocale = (0, $aIeEI.useCurrentLocale)();
    const defaultLocale = (_a = (0, $dUDPg.useDefaultLocale)().data) === null || _a === void 0 ? void 0 : _a.defaultLocale;
    const items = (0, $eeH7J.useMemo)(()=>pageContext.breadcrumb.map((item)=>{
            const localePath = currentLocale === defaultLocale ? "" : `/${currentLocale}`;
            const path = item.slug ? `${localePath}/${localize(item.slug)}` : "/";
            const href = (0, $iXeBy.Url)(path);
            return Object.assign(Object.assign({}, item), {
                href: href
            });
        }), [
        currentLocale,
        defaultLocale,
        localize,
        pageContext.breadcrumb
    ]);
    return (0, $4vwom.jsx)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
        justifyContent: "center",
        css: (0, $lhaLc.css)({
            borderTop: `1px solid ${colors.gray200}`,
            borderBottom: `1px solid ${colors.gray200}`,
            width: "100vw",
            marginLeft: "calc(50% - 50vw)"
        }),
        children: (0, $4vwom.jsx)("div", {
            style: {
                paddingTop: 16,
                paddingBottom: 16
            },
            css: (0, $756948b644e82cf2$export$629e292a677297c2)(),
            children: (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                variant: "body",
                size: "md",
                color: "gray300",
                css: responsiveCss("min", "md", {
                    fontWeight: 500
                }),
                children: (0, $4vwom.jsx)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                    gap: 8,
                    children: items.map((page, index)=>(0, $4vwom.jsxs)((0, $eeH7J.Fragment), {
                            children: [
                                index > 0 && "/",
                                " ",
                                (0, $4vwom.jsx)("div", {
                                    style: index === pageContext.breadcrumb.length - 1 ? {
                                        color: colors.gray500
                                    } : {},
                                    children: index < items.length - 1 ? (0, $4vwom.jsx)((0, $5K1mb.Link), {
                                        to: page.href.valueOf(),
                                        style: {
                                            textDecoration: "none"
                                        },
                                        children: localize(page.title)
                                    }) : localize(page.title)
                                })
                            ]
                        }, page.id.valueOf()))
                })
            })
        })
    });
}
(0, $9G56J.Section)("Breadcrumb", $2e164f197f37655e$var$Breadcrumb);



var $4vwom = parcelRequire("4vwom");

var $lhaLc = parcelRequire("lhaLc");

var $9G56J = parcelRequire("9G56J");

var $aIeEI = parcelRequire("aIeEI");



var $lhaLc = parcelRequire("lhaLc");

function $45e35837a0ab7745$export$7e05df66519e325f(section) {
    return (0, $lhaLc.css)(section.margin && (0, $756948b644e82cf2$export$92c840cda8ec752c).helpers.spacingToCss("margin", section.margin), {
        "li::marker": {
            fontWeight: 600
        },
        maxWidth: section.maxWidth
    });
}




/**
 * @icon ui-align-left
 */ function $a9adfc42e654df60$var$TextContent(section) {
    const { colors: colors } = (0, $756948b644e82cf2$export$559a0f07c8df6570)();
    const localize = (0, $aIeEI.useLocalize)();
    return (0, $4vwom.jsx)("div", {
        css: (0, $lhaLc.css)((0, $45e35837a0ab7745$export$7e05df66519e325f)(section), {
            // Workaround for emotions reluctance to allow :first-child selector.
            [`${[
                "h1",
                "h2",
                "h3",
                "h4"
            ].map((h)=>`${h}:not(:first-of-type:not(style):not(:first-of-type ~ *))`)}`]: {
                marginTop: ".8em"
            },
            a: {
                color: colors.brand,
                textDecoration: "none"
            },
            "a:hover": {
                color: colors.brand
            }
        }),
        children: (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
            variant: "body",
            size: section.bodyTextSize,
            children: (0, $4vwom.jsx)((0, $82d66b15b8f4758d$export$d5163f1ce1e6a5f9), {
                value: localize(section.text),
                renderers: {
                    paragraph: (p)=>(0, $4vwom.jsx)((0, $72c5ae9e0017e167$export$4b2c32e08f77ff18), {
                            size: section.bodyTextSize,
                            color: section.bodyTextColor,
                            children: p.children
                        })
                }
            })
        })
    });
}
(0, $9G56J.Section)("TextContent", $a9adfc42e654df60$var$TextContent);



var $4vwom = parcelRequire("4vwom");

var $lhaLc = parcelRequire("lhaLc");

var $9G56J = parcelRequire("9G56J");

var $aIeEI = parcelRequire("aIeEI");



/**
 * @icon ui-image-01
 */ function $d94ba389b32d537a$var$ImageContent(section) {
    const localize = (0, $aIeEI.useLocalize)();
    return (0, $4vwom.jsx)("div", {
        css: (0, $lhaLc.css)((0, $45e35837a0ab7745$export$7e05df66519e325f)(section)),
        children: (0, $4vwom.jsx)((0, $6a1a23ca93758ec8$export$686e15a6b88a698c), {
            "aria-hidden": !section.altText,
            alt: section.altText ? localize(section.altText) : undefined,
            style: {
                width: "auto",
                height: "auto",
                maxWidth: "100%",
                maxHeight: "100%",
                objectFit: "cover",
                aspectRatio: section.aspectRatio
            },
            image: section.image,
            width: section.width,
            css: section.borderRadius ? (0, $aace75a797ac78f1$export$ae2d933239aa09a1)(section.borderRadius) : undefined
        })
    });
}
(0, $9G56J.Section)("ImageContent", $d94ba389b32d537a$var$ImageContent);



var $4vwom = parcelRequire("4vwom");

var $lhaLc = parcelRequire("lhaLc");

var $9G56J = parcelRequire("9G56J");

var $aIeEI = parcelRequire("aIeEI");







(0, $9G56J.Section)("ListWithIconsContent", $6defc054f4b82fac$var$ListWithIconsContent);
/**
 * @icon ui-dotpoints-02
 */ function $6defc054f4b82fac$var$ListWithIconsContent(section) {
    const localize = (0, $aIeEI.useLocalize)();
    return (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
        variant: "body",
        size: section.bodyTextSize,
        css: (0, $lhaLc.css)([
            (0, $45e35837a0ab7745$export$7e05df66519e325f)(section)
        ]),
        children: (0, $4vwom.jsx)("ul", {
            css: (0, $lhaLc.css)((0, $e82ba787de72625c$export$6b6f359a824920a4)("ul")),
            style: {
                display: "flex",
                flexDirection: "column",
                gap: (0, $756948b644e82cf2$export$981516ee4691055c)(24)
            },
            children: section.items.map((li)=>(0, $4vwom.jsx)("li", {
                    css: (0, $e82ba787de72625c$export$6b6f359a824920a4)("li"),
                    children: (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                        alignItems: "center",
                        gap: 24,
                        children: [
                            (0, $4vwom.jsx)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                                style: {
                                    flex: "0 0 auto"
                                },
                                borderRadius: "md",
                                alignItems: "center",
                                justifyContent: "center",
                                backgroundColor: "gray100",
                                padding: (0, $756948b644e82cf2$export$981516ee4691055c)(24),
                                children: (0, $4vwom.jsx)((0, $f8cdd04128a131cf$export$f04a61298a47a40f), {
                                    icon: li.icon,
                                    size: 48
                                })
                            }),
                            (0, $4vwom.jsx)((0, $82d66b15b8f4758d$export$d5163f1ce1e6a5f9), {
                                value: localize(li.text),
                                renderers: {
                                    paragraph: (p)=>(0, $4vwom.jsx)("div", {
                                            children: p.children
                                        })
                                }
                            })
                        ]
                    })
                }, li.id.valueOf()))
        })
    });
}



var $4vwom = parcelRequire("4vwom");

var $lhaLc = parcelRequire("lhaLc");

var $9G56J = parcelRequire("9G56J");

var $aIeEI = parcelRequire("aIeEI");






(0, $9G56J.Section)("ListWithStepsContent", $feabaebffd5687e7$var$ListWithStepsContent);
/**
 * @icon ui-dotpoints-01
 */ function $feabaebffd5687e7$var$ListWithStepsContent(section) {
    const localize = (0, $aIeEI.useLocalize)();
    return (0, $4vwom.jsx)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
        direction: "column",
        gap: [
            8,
            [
                "min",
                "md",
                12
            ]
        ],
        css: (0, $lhaLc.css)((0, $45e35837a0ab7745$export$7e05df66519e325f)(section)),
        children: section.items.map((item, index)=>(0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                gap: 24,
                backgroundColor: "gray100",
                padding: "md",
                style: {
                    borderRadius: 16
                },
                alignItems: "center",
                children: [
                    (0, $4vwom.jsx)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                        backgroundColor: "gray500",
                        alignItems: "center",
                        justifyContent: "center",
                        style: {
                            flexShrink: 0,
                            color: (0, $06eb0d21a8b1f440$export$8f45430ccf837300).grayWhite,
                            borderRadius: 100
                        },
                        css: (0, $lhaLc.css)({
                            width: 24,
                            height: 24
                        }, (0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("min", "md", {
                            height: (0, $756948b644e82cf2$export$981516ee4691055c)(48),
                            width: (0, $756948b644e82cf2$export$981516ee4691055c)(48)
                        })),
                        children: (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                            variant: "heading",
                            level: [
                                5,
                                [
                                    "min",
                                    "md",
                                    4
                                ]
                            ],
                            children: index + 1
                        })
                    }),
                    (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                        variant: "body",
                        size: "md",
                        children: (0, $4vwom.jsx)((0, $82d66b15b8f4758d$export$d5163f1ce1e6a5f9), {
                            value: localize(item.text),
                            renderers: {
                                paragraph: (p)=>(0, $4vwom.jsx)("div", {
                                        children: p.children
                                    })
                            }
                        })
                    })
                ]
            }, item.id.valueOf()))
    });
}



var $4vwom = parcelRequire("4vwom");

var $lhaLc = parcelRequire("lhaLc");

var $7KZCj = parcelRequire("7KZCj");

var $9G56J = parcelRequire("9G56J");


(0, $9G56J.Section)($d13e58e07b0e8c39$var$ContentGroup);
/**
 * Combine a group of content sections side by side and/or stacked.
 *
 * @icon ui-columns-01
 */ function $d13e58e07b0e8c39$var$ContentGroup(section) {
    const sections = (0, $4vwom.jsx)((0, $7KZCj.EditableSections), {
        sections: section.contents.flatMap((c)=>c.sections),
        itemCss: (index)=>{
            var _a;
            return ((_a = section.contents[index]) === null || _a === void 0 ? void 0 : _a.hideBreakpoint) ? (0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("max", section.contents[index].hideBreakpoint, {
                display: "none !important"
            }) : (0, $lhaLc.css)();
        }
    });
    return (0, $4vwom.jsx)("div", {
        css: (0, $lhaLc.css)((0, $45e35837a0ab7745$export$7e05df66519e325f)(section), {
            display: "grid",
            gridAutoFlow: "column",
            gridAutoColumns: "minmax(0, 1fr)"
        }, section.gap && (0, $aace75a797ac78f1$export$9c33585a37942ee0)(section.gap, "gap"), section.stackingBreakpoint && (0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("max", section.stackingBreakpoint, {
            gridAutoFlow: "row",
            gridAutoRows: "auto"
        })),
        children: sections
    });
}



var $4vwom = parcelRequire("4vwom");


var $9G56J = parcelRequire("9G56J");
/**
 * @icon ui-divider
 * @param section
 * @returns
 */ function $6dd6bf1d6cf26135$var$ContentDivider(section) {
    return (0, $4vwom.jsx)((0, $67d1e32b493d1bb5$export$2e0a83ec2e27ecbb), {
        horizontal: true,
        spacing: section.spacing
    });
}
(0, $9G56J.Section)($6dd6bf1d6cf26135$var$ContentDivider);



var $4vwom = parcelRequire("4vwom");

var $eeH7J = parcelRequire("eeH7J");

var $5K1mb = parcelRequire("5K1mb");

var $lhaLc = parcelRequire("lhaLc");

var $alVaN = parcelRequire("alVaN");

var $hFOwS = parcelRequire("hFOwS");

var $9G56J = parcelRequire("9G56J");


var $aIeEI = parcelRequire("aIeEI");








var $dUDPg = parcelRequire("dUDPg");







var $eeH7J = parcelRequire("eeH7J");
parcelRequire("jniej");
var $eK8Q4 = parcelRequire("eK8Q4");

var $dUDPg = parcelRequire("dUDPg");
function $17c7c3ed779c19d9$export$4d5dcc1e958e7f7e(orderNumber) {
    var _a, _b;
    const cookieConsents = (0, $dUDPg.useCookieConsents)();
    const [isReported, setIsReported] = (0, $eK8Q4.useSessionState)(`tmt-reported-${orderNumber}`, false);
    (0, $eeH7J.useEffect)(()=>{
        var _a, _b;
        if (orderNumber && !isReported && ((_b = (_a = cookieConsents.data) === null || _a === void 0 ? void 0 : _a.consents) === null || _b === void 0 ? void 0 : _b.marketing) && typeof document !== "undefined" && // If this is not set (entrypoint script is not initialized), we won't report the sale.
        typeof tmt_offer_sid !== "undefined" && typeof tmt_event_sid !== "undefined" && // Avoid appending this script more than once.
        !document.querySelector('script[src*="cdn.trackmytarget.com/tracking/s/checkout.min.js"]')) {
            const el = document.createElement("script");
            el.setAttribute("src", "https://cdn.trackmytarget.com/tracking/s/checkout.min.js");
            el.setAttribute("data-type", "sale");
            el.setAttribute("data-offer-sid", tmt_offer_sid);
            el.setAttribute("data-event-sid", tmt_event_sid);
            el.setAttribute("data-id", orderNumber);
            document.body.appendChild(el);
            setIsReported(true);
        }
    }, [
        (_b = (_a = cookieConsents.data) === null || _a === void 0 ? void 0 : _a.consents) === null || _b === void 0 ? void 0 : _b.marketing,
        orderNumber,
        isReported,
        setIsReported
    ]);
}


(0, $9G56J.Section)($002abb89de0ca022$var$OrderConfirmation);
function $002abb89de0ca022$var$OrderConfirmation(section) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3;
    const localize = (0, $aIeEI.useLocalize)();
    const formatAmount = (0, $b274814d74f89bd0$export$cd05f017078a61a8)();
    const [phone] = (0, $047f6f355e30d7d1$export$800784442c3f48f8)();
    const [options] = (0, $047f6f355e30d7d1$export$5b1a6a2d762c097c)();
    const [searchParams] = (0, $5K1mb.useSearchParams)();
    const { order: order } = (0, $047f6f355e30d7d1$export$cba61477bceac75)();
    const [checkoutShippingState] = (0, $047f6f355e30d7d1$export$4a755370e8335b36)();
    const [checkoutTradeInPriceRequest] = (0, $047f6f355e30d7d1$export$b7eadabbf1e81c9b)();
    const [checkoutTradeInForm] = (0, $047f6f355e30d7d1$export$d42da32bb85d5739)();
    const [checkoutTradeInResult] = (0, $047f6f355e30d7d1$export$db65bad7d1fa5d6f)();
    const [calculatedOrderPrice] = (0, $047f6f355e30d7d1$export$aed04c9c9fee3492)();
    const [checkoutDiscount] = (0, $047f6f355e30d7d1$export$745963d6dc3bf932)();
    (0, $17c7c3ed779c19d9$export$4d5dcc1e958e7f7e)(order === null || order === void 0 ? void 0 : order.orderNumber);
    (0, (/*@__PURE__*/$parcel$interopDefault($alVaN))).extend((0, (/*@__PURE__*/$parcel$interopDefault($hFOwS))));
    (0, $eeH7J.useEffect)(()=>{
        var _a, _b;
        if (typeof fbq !== "undefined") fbq("track", "Purchase", {
            content_ids: [
                phone === null || phone === void 0 ? void 0 : phone.id.valueOf()
            ],
            content_name: (phone === null || phone === void 0 ? void 0 : phone.name) ? localize(phone.name) : undefined,
            content_type: "product",
            value: phone === null || phone === void 0 ? void 0 : phone.monthlyPrice.itemsTotal.majorUnits,
            currency: phone === null || phone === void 0 ? void 0 : phone.monthlyPrice.itemsTotal.currency
        });
        if (typeof snaptr !== "undefined") snaptr("track", "PURCHASE", {
            price: phone === null || phone === void 0 ? void 0 : phone.monthlyPrice.itemsTotal.majorUnits,
            currency: phone === null || phone === void 0 ? void 0 : phone.monthlyPrice.itemsTotal.currency,
            transaction_id: order === null || order === void 0 ? void 0 : order.id,
            item_ids: [
                phone === null || phone === void 0 ? void 0 : phone.id.valueOf()
            ],
            item_category: "phone",
            number_items: 1
        });
        if (typeof ttq !== "undefined") ttq.track("Purchase", {
            contents: [
                {
                    content_id: phone === null || phone === void 0 ? void 0 : phone.id.valueOf(),
                    content_type: "phone",
                    content_name: order === null || order === void 0 ? void 0 : order.model.name
                }
            ],
            value: phone === null || phone === void 0 ? void 0 : phone.monthlyPrice.itemsTotal.majorUnits,
            currency: phone === null || phone === void 0 ? void 0 : phone.monthlyPrice.itemsTotal.currency
        });
        // Check of `dataLayer` (global array used by Google Tag Manager to track events)
        // exists before trying to push the event. If it does, push the conversion event
        // including Google Ads reference + separate purchase event to GA4.
        if (typeof dataLayer !== "undefined" && dataLayer instanceof Array) {
            // Send to GA4. No need for `send_to`, will send to GTM that was used
            // to init GTM, which is set up to forward to GA4.
            dataLayer.push({
                event: "purchase",
                value: phone === null || phone === void 0 ? void 0 : phone.monthlyPrice.itemsTotal.majorUnits,
                purchase_timestamp: order === null || order === void 0 ? void 0 : order.placed.valueOf(),
                rental_period: (_a = order === null || order === void 0 ? void 0 : order.rentalPeriods.at(0)) === null || _a === void 0 ? void 0 : _a.months,
                device_model: (order === null || order === void 0 ? void 0 : order.model.name) ? localize(order.model.name) : undefined,
                monthly_price: (_b = order === null || order === void 0 ? void 0 : order.rentalPeriods.at(0)) === null || _b === void 0 ? void 0 : _b.monthlyPrice.itemsTotal.majorUnits.valueOf(),
                insurance_selected: selectedInsurance === null || selectedInsurance === void 0 ? void 0 : selectedInsurance.valueOf(),
                trade_in: !!(order === null || order === void 0 ? void 0 : order.tradeIn),
                currency: order === null || order === void 0 ? void 0 : order.rentalPeriod.monthlyPrice.itemsTotal.currency.valueOf()
            });
            // Google Ads
            dataLayer.push({
                event: "conversion",
                send_to: "AW-16797113852/fQOfCKbFq-8ZEPy7vsk-",
                value: phone === null || phone === void 0 ? void 0 : phone.monthlyPrice.itemsTotal.majorUnits,
                currency: order === null || order === void 0 ? void 0 : order.rentalPeriod.monthlyPrice.itemsTotal.currency.valueOf(),
                transaction_id: ""
            });
        }
    }, // Should only trigger once, when the component mounts
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    const insuranceOptions = (0, $e18f565b44c7bc7d$export$fd8b73cd610fc548)((_a = order === null || order === void 0 ? void 0 : order.model.id) !== null && _a !== void 0 ? _a : null, (_b = order === null || order === void 0 ? void 0 : order.phone.storage) !== null && _b !== void 0 ? _b : null, (_c = order === null || order === void 0 ? void 0 : order.phone.color) !== null && _c !== void 0 ? _c : null, (_d = order === null || order === void 0 ? void 0 : order.rentalPeriod.months) !== null && _d !== void 0 ? _d : null);
    const selectedInsurance = (0, $eeH7J.useMemo)(()=>{
        var _a;
        return (_a = insuranceOptions.data) === null || _a === void 0 ? void 0 : _a.find((insurance)=>insurance.id === (order === null || order === void 0 ? void 0 : order.insurance));
    }, [
        insuranceOptions.data,
        order === null || order === void 0 ? void 0 : order.insurance
    ]);
    if (!phone || !options || !order) return (0, $4vwom.jsx)((0, $4vwom.Fragment), {});
    const orderParam = searchParams.get("o");
    if (order.id.valueOf() !== orderParam) return (0, $4vwom.jsx)($002abb89de0ca022$export$dd3ed613a7315750, Object.assign({}, section.orderMismatchError));
    return (0, $4vwom.jsx)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
        justifyContent: "center",
        css: (0, $lhaLc.css)((0, $756948b644e82cf2$export$f1cf1885b6bfef23)()),
        children: (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
            direction: "column",
            gap: 24,
            style: {
                minWidth: 0,
                maxWidth: 560
            },
            children: [
                (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                    direction: "column",
                    gap: 24,
                    children: [
                        section.topImage ? (0, $4vwom.jsx)("div", {
                            css: (0, $lhaLc.css)({
                                paddingLeft: 12,
                                paddingRight: 12
                            }, (0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("min", "sm", {
                                paddingLeft: 32,
                                paddingRight: 32
                            }), (0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("min", "md", {
                                paddingLeft: 48,
                                paddingRight: 48
                            })),
                            children: (0, $4vwom.jsx)((0, $6a1a23ca93758ec8$export$686e15a6b88a698c), {
                                image: section.topImage,
                                width: 560,
                                style: {
                                    width: "100%"
                                }
                            })
                        }) : null,
                        (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                            direction: "column",
                            gap: 12,
                            children: [
                                (0, $4vwom.jsx)((0, $789b8639be592288$export$a8a3e93435678ff9), {
                                    level: 2,
                                    children: localize(section.heading)
                                }),
                                (0, $4vwom.jsx)((0, $789b8639be592288$export$a8a3e93435678ff9), {
                                    level: 3,
                                    children: localize(section.subheading)
                                })
                            ]
                        }),
                        (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                            borderColor: "gray200",
                            borderRadius: "md",
                            padding: "md",
                            direction: "column",
                            gap: 8,
                            children: [
                                (0, $4vwom.jsx)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                                    justifyContent: "space-between",
                                    alignItems: "flex-start",
                                    children: (0, $4vwom.jsxs)("div", {
                                        children: [
                                            (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                                variant: "heading",
                                                level: 4,
                                                children: localize(section.monthlyTotalPrice.heading)
                                            }),
                                            (0, $4vwom.jsx)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                                                alignItems: "baseline",
                                                gap: 2,
                                                children: (0, $4vwom.jsxs)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                                    variant: "heading",
                                                    level: 3,
                                                    color: "brand",
                                                    children: [
                                                        formatAmount((_e = calculatedOrderPrice === null || calculatedOrderPrice === void 0 ? void 0 : calculatedOrderPrice.monthlyCost.discountedTotal) !== null && _e !== void 0 ? _e : order.nextCharge.total),
                                                        "/",
                                                        localize((0, $b274814d74f89bd0$export$b4b23bfab2f68498))
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                }),
                                (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                    variant: "body",
                                    size: "sm",
                                    color: "gray300",
                                    children: ((_g = (_f = order.rentalPeriod.discounts) === null || _f === void 0 ? void 0 : _f.at(0)) === null || _g === void 0 ? void 0 : _g.months) && ((_j = (_h = order.rentalPeriod.discounts.at(0)) === null || _h === void 0 ? void 0 : _h.months.valueOf()) !== null && _j !== void 0 ? _j : 0) < order.rentalPeriod.months.valueOf() ? (0, $87d2193cf0695c20$export$4493d2932fe76cf8)(localize(section.monthlyTotalPrice.discountMonthsText), {
                                        discountMonths: (_l = (_k = order.rentalPeriod.discounts.at(0)) === null || _k === void 0 ? void 0 : _k.months.toString()) !== null && _l !== void 0 ? _l : "",
                                        totalAfterDiscountPeriodFormatted: (calculatedOrderPrice === null || calculatedOrderPrice === void 0 ? void 0 : calculatedOrderPrice.monthlyCost.totalAfterCodeDiscountPeriod) ? formatAmount(calculatedOrderPrice.monthlyCost.totalAfterCodeDiscountPeriod) : "",
                                        rentalPeriod: `${order.rentalPeriod.months.valueOf()}`
                                    }) : (0, $87d2193cf0695c20$export$4493d2932fe76cf8)(localize(section.monthlyTotalPrice.text), {
                                        rentalPeriod: `${order.rentalPeriod.months.valueOf()}`
                                    })
                                })
                            ]
                        })
                    ]
                }),
                (0, $4vwom.jsx)((0, $67d1e32b493d1bb5$export$2e0a83ec2e27ecbb), {
                    horizontal: true,
                    spacing: 0
                }),
                (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                    direction: "column",
                    gap: 24,
                    children: [
                        (0, $4vwom.jsx)((0, $789b8639be592288$export$a8a3e93435678ff9), {
                            level: 3,
                            children: localize(section.summary.heading)
                        }),
                        (0, $4vwom.jsx)((0, $ad78a5ecb6406b10$export$ac61754cc5f685a7), {
                            icon: "device",
                            step: localize(section.summary.device.stepName),
                            title: localize(order.model.name),
                            price: `${formatAmount(order.rentalPeriod.monthlyPrice.phone)}/${localize((0, $b274814d74f89bd0$export$b4b23bfab2f68498))}`,
                            subtitle: (0, $87d2193cf0695c20$export$4493d2932fe76cf8)(localize(section.summary.device.rentalPeriodTotalPrice), {
                                rentalPeriod: `${order.rentalPeriod.months.valueOf()}`,
                                monthsShort: `${localize((0, $b274814d74f89bd0$export$b4b23bfab2f68498))}`,
                                monthsLong: `${localize((0, $b274814d74f89bd0$export$2bb3eb27682a776))}`,
                                totalPrice: `${formatAmount({
                                    minorUnits: order.rentalPeriod.monthlyPrice.phone.minorUnits * order.rentalPeriod.months.valueOf(),
                                    majorUnits: order.rentalPeriod.monthlyPrice.phone.majorUnits * order.rentalPeriod.months.valueOf(),
                                    currency: order.rentalPeriod.monthlyPrice.phone.currency
                                })}`
                            })
                        }),
                        checkoutDiscount ? (0, $4vwom.jsx)((0, $ad78a5ecb6406b10$export$ac61754cc5f685a7), {
                            icon: "sealPercent",
                            step: localize(section.summary.discount.stepName),
                            title: checkoutDiscount.durationMonths ? (0, $87d2193cf0695c20$export$4493d2932fe76cf8)(localize(section.summary.discount.monthsOfRentalPeriod), {
                                months: checkoutDiscount.durationMonths.toString()
                            }) : localize(section.summary.discount.entireRentalPeriod),
                            price: `${formatAmount((_p = (_o = (_m = order.rentalPeriod.discounts) === null || _m === void 0 ? void 0 : _m.at(0)) === null || _o === void 0 ? void 0 : _o.amount) !== null && _p !== void 0 ? _p : {
                                minorUnits: 0,
                                majorUnits: 0,
                                currency: "NOK"
                            })}/${localize((0, $b274814d74f89bd0$export$b4b23bfab2f68498))}`,
                            subtitle: (0, $87d2193cf0695c20$export$4493d2932fe76cf8)(localize(section.summary.discount.rentalPeriodTotalDiscount), {
                                totalDiscount: `${formatAmount({
                                    minorUnits: ((_s = (_r = (_q = order.rentalPeriod.discounts) === null || _q === void 0 ? void 0 : _q.at(0)) === null || _r === void 0 ? void 0 : _r.amount.minorUnits.valueOf()) !== null && _s !== void 0 ? _s : 0) * ((_u = (_t = checkoutDiscount.durationMonths) === null || _t === void 0 ? void 0 : _t.valueOf()) !== null && _u !== void 0 ? _u : order.rentalPeriod.months.valueOf()),
                                    majorUnits: ((_x = (_w = (_v = order.rentalPeriod.discounts) === null || _v === void 0 ? void 0 : _v.at(0)) === null || _w === void 0 ? void 0 : _w.amount.majorUnits.valueOf()) !== null && _x !== void 0 ? _x : 0) * ((_z = (_y = checkoutDiscount.durationMonths) === null || _y === void 0 ? void 0 : _y.valueOf()) !== null && _z !== void 0 ? _z : order.rentalPeriod.months.valueOf()),
                                    currency: order.rentalPeriod.monthlyPrice.phone.currency
                                })}`
                            })
                        }) : null,
                        checkoutTradeInForm && checkoutTradeInPriceRequest && typeof (checkoutTradeInResult === null || checkoutTradeInResult === void 0 ? void 0 : checkoutTradeInResult.value) !== "undefined" && order.tradeIn && checkoutTradeInResult.deviceName ? (0, $4vwom.jsx)((0, $ad78a5ecb6406b10$export$ac61754cc5f685a7), {
                            icon: "handCoins",
                            step: localize(section.summary.tradeIn.stepName),
                            title: localize(checkoutTradeInResult.deviceName),
                            subtitle: (0, $87d2193cf0695c20$export$4493d2932fe76cf8)(localize(section.summary.tradeIn.text), {
                                monthlyDiscount: formatAmount(checkoutTradeInResult.monthlyDiscount),
                                discountPeriod: `${checkoutTradeInResult.months.valueOf()}`
                            }),
                            price: formatAmount(checkoutTradeInResult.value),
                            list: (_0 = section.summary.tradeIn.list) === null || _0 === void 0 ? void 0 : _0.map((li)=>({
                                    id: li.id.valueOf(),
                                    text: localize(li.text)
                                }))
                        }) : null,
                        selectedInsurance && order.rentalPeriod.monthlyPrice.insurance ? (0, $4vwom.jsx)((0, $ad78a5ecb6406b10$export$ac61754cc5f685a7), {
                            icon: "shield",
                            step: localize(section.summary.insurance.stepName),
                            title: localize(selectedInsurance.displayName),
                            price: `${formatAmount(order.rentalPeriod.monthlyPrice.insurance)}/${localize((0, $b274814d74f89bd0$export$b4b23bfab2f68498))}`,
                            list: selectedInsurance.sellingPoints.map((isp)=>({
                                    id: isp.id.valueOf(),
                                    text: localize(isp.text)
                                }))
                        }) : null,
                        checkoutShippingState.selectedOption ? (0, $4vwom.jsx)((0, $ad78a5ecb6406b10$export$ac61754cc5f685a7), {
                            icon: "truck",
                            step: localize(section.summary.shipping.stepName),
                            title: localize(checkoutShippingState.selectedOption.name),
                            subtitle: checkoutShippingState.selectedOption.type === "Manual" && checkoutShippingState.selectedOption.selectedSlot ? (0, $87d2193cf0695c20$export$4493d2932fe76cf8)(localize(section.summary.shipping.deliverySlotText), {
                                deliveryDate: (0, (/*@__PURE__*/$parcel$interopDefault($alVaN)))(checkoutShippingState.selectedOption.selectedSlot.date).format("dddd Do MMMM"),
                                deliverySlotFrom: checkoutShippingState.selectedOption.selectedSlot.from,
                                deliverySlotTo: checkoutShippingState.selectedOption.selectedSlot.to
                            }) : section.summary.shipping.otherDeliveryOptionText ? (0, $87d2193cf0695c20$export$4493d2932fe76cf8)(localize(section.summary.shipping.otherDeliveryOptionText), {
                                deliveryOptionName: localize(checkoutShippingState.selectedOption.name),
                                deliveryOptionDescription: localize(checkoutShippingState.selectedOption.description)
                            }) : localize(checkoutShippingState.selectedOption.description),
                            price: order.shippingCost.majorUnits.valueOf() > 0 ? formatAmount(order.shippingCost) : localize({
                                no: "Gratis",
                                en: "Free"
                            }),
                            text: [
                                (_1 = checkoutShippingState.form) === null || _1 === void 0 ? void 0 : _1.street.value,
                                `${(_2 = checkoutShippingState.form) === null || _2 === void 0 ? void 0 : _2.postalCode.value} ${(_3 = checkoutShippingState.form) === null || _3 === void 0 ? void 0 : _3.region.value}`
                            ].filter((t)=>!!t).join(", ")
                        }) : null,
                        section.summary.image ? (0, $4vwom.jsx)((0, $6a1a23ca93758ec8$export$686e15a6b88a698c), {
                            image: section.summary.image,
                            width: 600,
                            css: (0, $aace75a797ac78f1$export$ae2d933239aa09a1)("md")
                        }) : null
                    ]
                })
            ]
        })
    });
}
function $002abb89de0ca022$export$dd3ed613a7315750(props) {
    var _a;
    const localize = (0, $aIeEI.useLocalize)();
    const primaryActionPageInfo = (0, $dUDPg.useWebPageInfo)(props.primaryAction.page);
    return (0, $4vwom.jsx)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
        justifyContent: "center",
        alignItems: "center",
        style: {
            width: "100%",
            height: "100%",
            padding: "80px 0"
        },
        children: (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
            direction: "column",
            justifyContent: "center",
            alignItems: "center",
            css: (0, $lhaLc.css)((0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("max", "sm", {
                padding: "16px 0"
            }), {
                maxWidth: 600
            }),
            children: [
                (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                    direction: "column",
                    alignItems: "center",
                    gap: 12,
                    css: (0, $lhaLc.css)((0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("max", "sm", {
                        gap: 8,
                        marginBottom: 32
                    }), (0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("min", "md", {
                        padding: "0 40px",
                        gap: 12,
                        marginBottom: 40
                    })),
                    children: [
                        (0, $4vwom.jsx)((0, $789b8639be592288$export$a8a3e93435678ff9), {
                            color: "gray500",
                            level: 2,
                            children: localize(props.heading)
                        }),
                        (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                            color: "gray400",
                            variant: "body",
                            size: "md",
                            style: {
                                textAlign: "center"
                            },
                            children: (0, $4vwom.jsx)((0, $82d66b15b8f4758d$export$d5163f1ce1e6a5f9), {
                                value: localize(props.text)
                            })
                        })
                    ]
                }),
                ((_a = primaryActionPageInfo.data) === null || _a === void 0 ? void 0 : _a.slug) ? (0, $4vwom.jsx)((0, $4b4086f8a1c6b2f8$export$353f5b6fc5456de1), {
                    variant: "primary",
                    size: "md",
                    as: "a",
                    href: `/${localize(primaryActionPageInfo.data.slug)}`,
                    children: localize(props.primaryAction.buttonText)
                }) : null
            ]
        })
    });
}



var $4vwom = parcelRequire("4vwom");

var $9G56J = parcelRequire("9G56J");

var $aIeEI = parcelRequire("aIeEI");

var $dUDPg = parcelRequire("dUDPg");

var $4vwom = parcelRequire("4vwom");

var $lhaLc = parcelRequire("lhaLc");




var $eSiQ2 = parcelRequire("eSiQ2");



var $7m9cQ = parcelRequire("7m9cQ");

function $e502eb7414347b57$export$ad00a5af021e778b(props) {
    var _a, _b, _c;
    const p = {
        css: (0, $lhaLc.css)({
            height: 360
        }, (0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("min", "sm", {
            height: (0, $756948b644e82cf2$export$981516ee4691055c)(440)
        }), (0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("min", "md", {
            height: (0, $756948b644e82cf2$export$981516ee4691055c)(600)
        })),
        color: (_a = props.textColor) !== null && _a !== void 0 ? _a : "gray500",
        direction: "column",
        justifyContent: "space-between",
        borderRadius: "md",
        style: {
            backgroundColor: (_b = props.backgroundColor) === null || _b === void 0 ? void 0 : _b.valueOf(),
            position: "relative",
            overflow: "clip",
            flexGrow: 0
        }
    };
    return (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), Object.assign({}, p, props.soldOut ? {} : {
        as: "a",
        href: props.cta.url,
        "aria-label": props.cta.text
    }, {
        children: [
            (0, $4vwom.jsxs)((0, $bee1a5e35c892a21$export$e71c4d32a2263218), {
                css: (0, $lhaLc.css)({
                    padding: 32
                }, (0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("min", "md", {
                    padding: 48
                })),
                style: {
                    zIndex: 1
                },
                children: [
                    (0, $4vwom.jsx)((0, $789b8639be592288$export$a8a3e93435678ff9), {
                        level: 2,
                        margin: {
                            bottom: 24
                        },
                        children: props.heading
                    }),
                    (0, $4vwom.jsx)((0, $4b4086f8a1c6b2f8$export$353f5b6fc5456de1), {
                        variant: (_c = props.cta.buttonVariant) !== null && _c !== void 0 ? _c : "dark",
                        size: "md",
                        disabled: props.soldOut,
                        children: props.cta.text
                    })
                ]
            }),
            props.image ? (0, $4vwom.jsx)((0, $6a1a23ca93758ec8$export$686e15a6b88a698c), {
                image: props.image,
                width: 640
            }) : null
        ]
    }));
}
(0, $eSiQ2.Component)($e502eb7414347b57$export$ad00a5af021e778b, {
    name: "SeeAllCard",
    gallery: {
        path: "Cards/SeeAllCard",
        items: [
            {
                variants: [
                    {
                        props: {
                            heading: "Se hele v\xe5rt utvalg",
                            cta: {
                                text: "Vis alt (14)",
                                url: "",
                                buttonVariant: "light"
                            },
                            image: `${(0, $7m9cQ.server)()}/static/redoit/see-all-card.png`
                        }
                    }
                ]
            }
        ]
    }
});






function $9edbed8e79cbd892$var$PromoCard(section) {
    var _a;
    const localize = (0, $aIeEI.useLocalize)();
    const ctaPageInfo = (0, $dUDPg.useWebPageInfo)(section.cta.page);
    const phoneOffers = (0, $e18f565b44c7bc7d$export$88e20cfc122b8557)([
        section.cta.phone
    ], undefined, undefined, undefined);
    const phoneOffer = (_a = phoneOffers.data) === null || _a === void 0 ? void 0 : _a.at(0);
    const formatAmount = (0, $b274814d74f89bd0$export$cd05f017078a61a8)();
    if (!ctaPageInfo.data) return (0, $4vwom.jsx)((0, $4vwom.Fragment), {});
    return (0, $4vwom.jsx)((0, $e502eb7414347b57$export$ad00a5af021e778b), {
        heading: localize(section.heading),
        image: section.image,
        backgroundColor: section.backgroundColor,
        cta: {
            buttonVariant: section.cta.buttonVariant,
            url: phoneOffer && ctaPageInfo.data.slug ? `/${localize(ctaPageInfo.data.slug)}?${(0, $f4c4c9282b17128a$export$cefacdcddab7996c)({
                phoneId: phoneOffer.id
            })}` : "/",
            text: !phoneOffer ? localize(section.cta.soldOutText) : (0, $87d2193cf0695c20$export$4493d2932fe76cf8)(localize(section.cta.text), {
                fromPrice: formatAmount(phoneOffer.monthlyPrice.phone),
                monthsShort: localize((0, $b274814d74f89bd0$export$b4b23bfab2f68498))
            })
        },
        soldOut: !phoneOffer
    });
}
(0, $9G56J.Section)($9edbed8e79cbd892$var$PromoCard);



var $4vwom = parcelRequire("4vwom");

var $9G56J = parcelRequire("9G56J");

var $aIeEI = parcelRequire("aIeEI");



/**
 * @icon ui-info-square
 */ function $fc55fad046a7eb48$var$MoreReasonsToRedoit(section) {
    const localize = (0, $aIeEI.useLocalize)();
    const moreReasonsToRedoit = (0, $e18f565b44c7bc7d$export$3b68074ea3526841)();
    if (moreReasonsToRedoit.loading || !moreReasonsToRedoit.data) return (0, $4vwom.jsx)((0, $4vwom.Fragment), {});
    return (0, $4vwom.jsx)((0, $8160ea1f3816c70f$export$e0b2a4a0e3a11a62), {
        heading: localize(moreReasonsToRedoit.data.heading),
        showSlideButtons: true,
        cards: moreReasonsToRedoit.data.cards.map((c)=>Object.assign(Object.assign({}, c), {
                id: c.id.valueOf()
            })),
        enterAnimation: true,
        renderCard: (c, i)=>{
            var _a, _b;
            return (0, $4vwom.jsx)((0, $0273ae0bc8f90076$export$5fbe01e9406810ee), {
                title: localize(c.heading),
                text: localize(c.text),
                image: c.image,
                readMoreAriaPrefix: localize((_b = (_a = moreReasonsToRedoit.data) === null || _a === void 0 ? void 0 : _a.readMoreAriaPrefix) !== null && _b !== void 0 ? _b : {}),
                runningAnimation: i === 0
            });
        }
    });
}
(0, $9G56J.Section)($fc55fad046a7eb48$var$MoreReasonsToRedoit);



var $4vwom = parcelRequire("4vwom");

var $lhaLc = parcelRequire("lhaLc");

var $alVaN = parcelRequire("alVaN");



var $9G56J = parcelRequire("9G56J");

var $aIeEI = parcelRequire("aIeEI");







/**
 * @icon ui-message-heart-square
 */ function $a5492242b55a6dcc$var$TrustpilotRateUs(section) {
    const localize = (0, $aIeEI.useLocalize)();
    const reviews = (0, $e18f565b44c7bc7d$export$dfd0f591c1636cc4)();
    const { helpers: helpers } = (0, $756948b644e82cf2$export$559a0f07c8df6570)();
    const { responsiveCss: responsiveCss } = helpers;
    (0, (/*@__PURE__*/$parcel$interopDefault($alVaN))).extend((0, (/*@__PURE__*/$parcel$interopDefault($13a9f30e9fa4b734$exports))));
    if (reviews.loading) return (0, $4vwom.jsx)((0, $4vwom.Fragment), {});
    return (0, $4vwom.jsx)("div", {
        css: (0, $lhaLc.css)({
            display: "flex",
            flexDirection: "column"
        }),
        children: (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
            backgroundColor: "gray100",
            borderRadius: "lg",
            css: (0, $lhaLc.css)({
                overflow: "hidden",
                gap: 48,
                alignItems: "flex-start",
                flexDirection: "column",
                padding: 32
            }, responsiveCss("min", "md", {
                padding: 64,
                gap: 64,
                alignItems: "center",
                flexDirection: "row",
                height: 600
            }), responsiveCss("min", "lg", {
                paddingLeft: 96,
                paddingRight: 96,
                gap: 112
            })),
            children: [
                (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                    direction: "column",
                    alignItems: "flex-start",
                    style: {
                        minWidth: 0,
                        flex: 1
                    },
                    css: responsiveCss("max", "sm", {
                        paddingLeft: 24,
                        paddingRight: 24
                    }),
                    children: [
                        (0, $4vwom.jsx)("div", {
                            css: responsiveCss("max", "sm", {
                                display: "none"
                            }),
                            children: (0, $4vwom.jsx)((0, $b86e57b36afa5734$export$2ab84a49a8797035), {
                                widget: "mini",
                                width: 160
                            })
                        }),
                        (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                            direction: "column",
                            gap: (0, $756948b644e82cf2$export$981516ee4691055c)(24),
                            css: responsiveCss("max", "sm", {
                                alignItems: "center",
                                textAlign: "center"
                            }),
                            children: [
                                (0, $4vwom.jsx)((0, $789b8639be592288$export$a8a3e93435678ff9), {
                                    level: 1,
                                    children: localize(section.heading)
                                }),
                                section.text && (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                    variant: "body",
                                    size: "lg",
                                    color: "gray400",
                                    children: localize(section.text)
                                })
                            ]
                        }),
                        section.cta ? (0, $4vwom.jsx)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                            margin: {
                                top: "sm"
                            },
                            css: responsiveCss("max", "sm", {
                                justifyContent: "center",
                                width: "100%"
                            }),
                            children: (0, $4vwom.jsx)((0, $4b4086f8a1c6b2f8$export$353f5b6fc5456de1), {
                                as: "a",
                                href: section.cta.url.valueOf(),
                                target: "_blank",
                                variant: "primary",
                                css: responsiveCss("max", "xs", {
                                    width: "100%"
                                }),
                                children: localize(section.cta.text)
                            })
                        }) : null
                    ]
                }),
                (0, $4vwom.jsx)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                    flex: 1,
                    css: (0, $lhaLc.css)({
                        width: "100%",
                        justifyContent: "center",
                        marginBottom: 16
                    }, responsiveCss("min", "md", {
                        display: "none"
                    })),
                    children: (0, $4vwom.jsx)((0, $b86e57b36afa5734$export$2ab84a49a8797035), {
                        widget: "carousel"
                    })
                }),
                (0, $4vwom.jsx)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                    flex: 1,
                    css: responsiveCss("max", "sm", {
                        display: "none"
                    }),
                    children: (0, $4vwom.jsx)("div", {
                        style: {
                            width: "100%",
                            overflow: "hidden",
                            height: 500
                        },
                        children: (0, $4vwom.jsx)("div", {
                            style: {
                                width: "100%",
                                transform: "translateY(-120px)"
                            },
                            children: (0, $4vwom.jsx)((0, $b86e57b36afa5734$export$2ab84a49a8797035), {
                                widget: "grid",
                                height: 620,
                                stars: [
                                    4,
                                    5
                                ]
                            })
                        })
                    })
                })
            ]
        })
    });
}
(0, $9G56J.Section)($a5492242b55a6dcc$var$TrustpilotRateUs);



var $4vwom = parcelRequire("4vwom");

var $lhaLc = parcelRequire("lhaLc");

var $9G56J = parcelRequire("9G56J");

var $aIeEI = parcelRequire("aIeEI");








function $10310d8384b35b03$var$TrustpilotCarousel(section) {
    const localize = (0, $aIeEI.useLocalize)();
    const theme = (0, $756948b644e82cf2$export$559a0f07c8df6570)();
    return (0, $4vwom.jsx)("div", {
        css: (0, $756948b644e82cf2$export$f1cf1885b6bfef23)(),
        children: (0, $4vwom.jsx)("div", {
            style: {
                backgroundColor: (0, $06eb0d21a8b1f440$export$8f45430ccf837300).gray100,
                overflow: "hidden",
                justifyContent: "center"
            },
            css: (0, $lhaLc.css)({
                display: "flex"
            }, (0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("max", "xs", {
                borderRadius: theme.borderRadiuses.md.xs,
                paddingLeft: 16,
                paddingRight: 16
            }), (0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("min", "sm", {
                width: "100vw",
                marginLeft: "calc(50% - 50vw)"
            })),
            children: (0, $4vwom.jsxs)("div", {
                style: {
                    paddingBottom: 0,
                    paddingTop: !section.heading && !section.text ? 0 : undefined
                },
                css: (0, $lhaLc.css)({
                    display: "flex",
                    flexDirection: "column"
                }, (0, $756948b644e82cf2$export$f1cf1885b6bfef23)(), (0, $756948b644e82cf2$export$629e292a677297c2)()),
                children: [
                    section.heading || section.text ? (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                        direction: "column",
                        children: [
                            section.heading ? (0, $4vwom.jsx)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                                alignItems: "center",
                                justifyContent: "space-between",
                                children: (0, $4vwom.jsx)((0, $789b8639be592288$export$a8a3e93435678ff9), {
                                    level: 2,
                                    padding: {
                                        bottom: 8
                                    },
                                    css: (0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("max", "xs", {
                                        lineHeight: "120%"
                                    }),
                                    children: localize(section.heading)
                                })
                            }) : null,
                            section.text && (0, $4vwom.jsx)((0, $72c5ae9e0017e167$export$4b2c32e08f77ff18), {
                                size: "lg",
                                color: "gray400",
                                children: localize(section.text)
                            })
                        ]
                    }) : null,
                    (0, $4vwom.jsx)((0, $bee1a5e35c892a21$export$e71c4d32a2263218), {
                        padding: {
                            y: "xl"
                        },
                        css: (0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("max", "xs", {
                            marginTop: 32,
                            marginBottom: 40
                        }),
                        children: (0, $4vwom.jsx)((0, $bee1a5e35c892a21$export$e71c4d32a2263218), {
                            css: (0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("max", "xs", {
                                scale: "1.15"
                            }),
                            children: (0, $4vwom.jsx)((0, $b86e57b36afa5734$export$2ab84a49a8797035), {
                                widget: "carousel",
                                stars: section.stars ? Object.entries(section.stars).filter(([k, v])=>v).map(([k, v])=>Number(k)) : undefined
                            })
                        })
                    })
                ]
            })
        })
    });
}
(0, $9G56J.Section)("TrustpilotCarousel", $10310d8384b35b03$var$TrustpilotCarousel);



var $4vwom = parcelRequire("4vwom");

var $lhaLc = parcelRequire("lhaLc");

var $9G56J = parcelRequire("9G56J");


function $f8157e9e123a0818$var$TrustpilotHorizontal(section) {
    return (0, $4vwom.jsx)((0, $4vwom.Fragment), {
        children: (0, $4vwom.jsxs)("div", {
            style: {
                marginTop: 20,
                marginBottom: 20
            },
            children: [
                (0, $4vwom.jsx)("div", {
                    style: {
                        scale: "0.9",
                        transform: "translateY(2px)"
                    },
                    css: (0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("max", "sm", {
                        display: "none"
                    }),
                    children: (0, $4vwom.jsx)((0, $b86e57b36afa5734$export$2ab84a49a8797035), {
                        widget: "horizontal"
                    })
                }),
                (0, $4vwom.jsx)("div", {
                    css: (0, $lhaLc.css)({
                        scale: "0.8",
                        display: "flex",
                        justifyContent: "center"
                    }, (0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("min", "sm", {
                        scale: "0.9"
                    }), (0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("min", "md", {
                        display: "none"
                    })),
                    children: (0, $4vwom.jsx)((0, $b86e57b36afa5734$export$2ab84a49a8797035), {
                        widget: "microCombo",
                        width: 500
                    })
                })
            ]
        })
    });
}
(0, $9G56J.Section)("TrustpilotHorizontal", $f8157e9e123a0818$var$TrustpilotHorizontal);



var $4vwom = parcelRequire("4vwom");

var $lhaLc = parcelRequire("lhaLc");

var $9G56J = parcelRequire("9G56J");



parcelRequire("2LTO8");
var $14q7s = parcelRequire("14q7s");


function $f041dd6a8ee36363$var$TrustpilotAndPressLogos(section) {
    return (0, $4vwom.jsx)("div", {
        children: (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
            justifyContent: "space-between",
            style: {
                gap: 20,
                overflow: "clip"
            },
            css: (0, $lhaLc.css)({
                marginTop: 20,
                marginBottom: 20
            }, (0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("max", "xs", {
                flexDirection: "column"
            }), (0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("min", "sm", {
                flexDirection: "row-reverse"
            }), (0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("min", "md", {
                marginTop: 24,
                marginBottom: 24
            })),
            children: [
                (0, $4vwom.jsx)("div", {
                    style: {
                        display: "flex",
                        justifyContent: "flex-end"
                    },
                    css: (0, $lhaLc.css)({
                        flex: "0 0 auto"
                    }),
                    children: (0, $4vwom.jsxs)("div", {
                        css: (0, $lhaLc.css)((0, $lhaLc.css)({
                            display: "flex",
                            flex: "0 0 auto",
                            alignItems: "center"
                        }), (0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("max", "xs", {
                            width: "100%",
                            justifyContent: "center"
                        })),
                        children: [
                            (0, $4vwom.jsx)("div", {
                                css: (0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("max", "xs", {
                                    display: "none"
                                }),
                                children: (0, $4vwom.jsx)((0, $b86e57b36afa5734$export$2ab84a49a8797035), {
                                    widget: "microStar",
                                    style: {
                                        transform: "translateY(1px)",
                                        scale: "0.9"
                                    }
                                })
                            }),
                            (0, $4vwom.jsx)("div", {
                                css: (0, $lhaLc.css)({
                                    "@media (max-width: 380px)": {
                                        scale: "0.72"
                                    },
                                    scale: "0.8",
                                    display: "flex",
                                    justifyContent: "center"
                                }, (0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("min", "sm", {
                                    display: "none"
                                })),
                                children: (0, $4vwom.jsx)((0, $b86e57b36afa5734$export$2ab84a49a8797035), {
                                    widget: "microCombo",
                                    width: 500
                                })
                            })
                        ]
                    })
                }),
                section.logosShouldScrollWhenStacked ? (0, $4vwom.jsx)("div", {
                    style: {
                        flex: "1 1 0",
                        height: 24
                    },
                    css: (0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("min", "sm", {
                        display: "none"
                    }),
                    children: (0, $4vwom.jsx)((0, $52a8e4eb4bf14158$export$a5e58535c47c4073), {
                        speed: section.carouselSpeed,
                        logos: section.logos
                    })
                }) : null,
                (0, $4vwom.jsx)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                    flex: "1 1 0",
                    gap: 40,
                    css: (0, $lhaLc.css)((0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("max", "xs", {
                        justifyContent: section.logos.length > 2 ? "space-between" : "center",
                        gap: section.logos.length > 2 ? 24 : undefined,
                        display: section.logosShouldScrollWhenStacked ? "none" : undefined
                    }), (0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("min", "sm", {
                        overflow: "hidden"
                    }), (0, $lhaLc.css)({
                        flexWrap: "wrap",
                        color: (0, $06eb0d21a8b1f440$export$8f45430ccf837300).gray300,
                        height: 24,
                        justifyContent: "flex-start"
                    })),
                    children: section.logos.map((l)=>(0, $4vwom.jsx)("div", {
                            style: {
                                display: "flex",
                                alignItems: "center",
                                height: "100%"
                            },
                            children: (0, $4vwom.jsx)("img", {
                                src: (0, $14q7s.ImageToUrl)(l.image, {
                                    width: 300
                                }),
                                style: {
                                    width: "auto",
                                    maxHeight: "100%"
                                }
                            })
                        }, l.id.valueOf()))
                })
            ]
        })
    });
}
(0, $9G56J.Section)("TrustpilotAndPressLogos", $f041dd6a8ee36363$var$TrustpilotAndPressLogos);














var $4vwom = parcelRequire("4vwom");

var $eeH7J = parcelRequire("eeH7J");

var $eeH7J = parcelRequire("eeH7J");



/**
 * Creates a `MotionValue` to track the state and velocity of a value.
 *
 * Usually, these are created automatically. For advanced use-cases, like use with `useTransform`, you can create `MotionValue`s externally and pass them into the animated component via the `style` prop.
 *
 * ```jsx
 * export const MyComponent = () => {
 *   const scale = useMotionValue(1)
 *
 *   return <motion.div style={{ scale }} />
 * }
 * ```
 *
 * @param initial - The initial state.
 *
 * @public
 */ function $43acddfce38ee705$export$15b697acf84c78b9(initial) {
    const value = (0, $450f33b6a8740b8a$export$fe4300aa8eebea86)(()=>(0, $ebb6b8b1a738bf1d$export$ce8bdc721e76545f)(initial));
    /**
     * If this motion value is being used in static mode, like on
     * the Framer canvas, force components to rerender when the motion
     * value is updated.
     */ const { isStatic: isStatic } = (0, $eeH7J.useContext)((0, $f79c9a1bd76bed7c$export$22a697fb29aac98d));
    if (isStatic) {
        const [, setLatest] = (0, $eeH7J.useState)(initial);
        (0, $eeH7J.useEffect)(()=>value.on("change", setLatest), []);
    }
    return value;
}



var $7m9cQ = parcelRequire("7m9cQ");
parcelRequire("2LTO8");
var $gGZ2r = parcelRequire("gGZ2r");

var $eSiQ2 = parcelRequire("eSiQ2");


// When swiping sideways, the minimum width of a card that should be visible before snapping to it.
const $451387dc0010b0f6$var$currentCardVisibleMinimum = 0.25;
const $451387dc0010b0f6$export$1ee075080fb07ea7 = /*#__PURE__*/ (0, $eeH7J.forwardRef)(function CarouselBase(props, ref) {
    const dragContainerRef = (0, $eeH7J.useRef)(null);
    const cardsContainerRef = (0, $eeH7J.useRef)(null);
    const cardsRef = (0, $eeH7J.useRef)(props.items.map(()=>/*#__PURE__*/ (0, $eeH7J.createRef)()));
    const dragX = (0, $43acddfce38ee705$export$15b697acf84c78b9)(0);
    const [offsetX, setOffsetX] = (0, $eeH7J.useState)(0);
    const [dragOffsetX, setDragOffsetX] = (0, $eeH7J.useState)(0);
    const [position, setPosition] = (0, $eeH7J.useState)({
        atStart: true,
        atEnd: false
    });
    const updateOffsetX = (0, $eeH7J.useCallback)((o)=>{
        const newOffset = o;
        setOffsetX(newOffset);
        // As Framer Motion also keeps the drag offset applied, we need to store that.
        setDragOffsetX(dragX.get());
    }, [
        setOffsetX,
        dragX
    ]);
    // Returns a set of DOMRects used frequently in the component.
    function getRects() {
        var _a, _b, _c, _d, _e, _f;
        const container = (_a = dragContainerRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
        const grid = (_b = cardsContainerRef.current) === null || _b === void 0 ? void 0 : _b.getBoundingClientRect();
        const firstCard = (_d = (_c = cardsRef.current[0]) === null || _c === void 0 ? void 0 : _c.current) === null || _d === void 0 ? void 0 : _d.getBoundingClientRect();
        const lastCard = (_f = (_e = cardsRef.current[cardsRef.current.length - 1]) === null || _e === void 0 ? void 0 : _e.current) === null || _f === void 0 ? void 0 : _f.getBoundingClientRect();
        if (!container || !grid || !firstCard || !lastCard) {
            // eslint-disable-next-line no-console
            console.warn("Missing reference to container, card, or grid.");
            return;
        }
        return {
            container: container,
            grid: grid,
            firstCard: firstCard,
            lastCard: lastCard
        };
    }
    const updatePosition = (0, $eeH7J.useCallback)(()=>{
        const rects = getRects();
        if (!rects) return;
        const newPosition = {
            atStart: Math.round(rects.container.left) === Math.round(rects.firstCard.left),
            atEnd: Math.round(rects.container.right) === Math.round(rects.lastCard.right)
        };
        if (newPosition.atStart === position.atStart && newPosition.atEnd === position.atEnd) return;
        setPosition(newPosition);
    }, [
        position
    ]);
    // Update position object whenever offsetX changes.
    (0, $eeH7J.useEffect)(()=>{
        updatePosition();
    }, [
        offsetX,
        updatePosition
    ]);
    const { onPositionChange: onPositionChange } = props;
    // Call onPositionChange when position changes.
    (0, $eeH7J.useEffect)(()=>{
        onPositionChange === null || onPositionChange === void 0 || onPositionChange(position);
    }, [
        position,
        onPositionChange
    ]);
    // Ref functions that allow other components consuming this one to trigger next/prev switch.
    (0, $eeH7J.useImperativeHandle)(ref, ()=>({
            next () {
                handleSlideClick("next");
            },
            prev () {
                handleSlideClick("prev");
            }
        }));
    const debouncedUpdatePosition = (0, $eeH7J.useMemo)(()=>$451387dc0010b0f6$var$debounce(updatePosition, 500), [
        updatePosition
    ]);
    const resizeHandler = (0, $eeH7J.useCallback)(()=>{
        const rects = getRects();
        if (!rects) return;
        const atEnd = rects.lastCard.right < rects.container.right;
        if (atEnd) {
            const newOffsetX = rects.firstCard.left - (rects.lastCard.right - rects.container.width);
            updateOffsetX(newOffsetX);
        }
        debouncedUpdatePosition();
    }, [
        updateOffsetX,
        debouncedUpdatePosition
    ]);
    (0, $eeH7J.useEffect)(()=>{
        const resizeObserver = new ResizeObserver(resizeHandler);
        resizeObserver.observe(document.body);
        return ()=>{
            resizeObserver.disconnect();
        };
    }, [
        resizeHandler
    ]);
    (0, $eeH7J.useEffect)(()=>{
        // The intersection observer is used to observe when any of the cards intersect with
        // the container.
        const intersectionObserver = new IntersectionObserver(debouncedUpdatePosition, {
            root: dragContainerRef.current,
            rootMargin: "0px",
            threshold: 1.0
        });
        for (const c of cardsRef.current)if (c.current) intersectionObserver.observe(c.current);
        // We need the mutation observer to observe for changes in position controlled by style
        // attribute of child elements. Because of that it's difficult to trigger in a better way.
        const mutationObserver = new MutationObserver(debouncedUpdatePosition);
        if (cardsContainerRef.current) mutationObserver.observe(cardsContainerRef.current, {
            attributes: true,
            subtree: true
        });
        return ()=>{
            mutationObserver.disconnect();
            intersectionObserver.disconnect();
        };
    }, [
        debouncedUpdatePosition
    ]);
    // Find the index of the (first) card that should be presented as the current card.
    const findCurrentCardIndex = (0, $eeH7J.useCallback)((info)=>{
        var _a;
        const containerRect = (_a = dragContainerRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
        if (!containerRect) {
            // eslint-disable-next-line no-console
            console.warn("Unable to find current card index without a reference to the container element.");
            return;
        }
        let returnIndex;
        return cardsRef.current.findIndex((item, index)=>{
            var _a, _b, _c;
            if (returnIndex === index) {
                returnIndex = undefined;
                return true;
            }
            const itemRect = (_a = item.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
            if (!itemRect) throw new Error(`No element for card item at index ${index}.`);
            // The first card is dragged to the right of the left edge of the container
            if (index === 0 && itemRect.left > containerRect.left) return true;
            const nextRect = (_c = (_b = cardsRef.current[index + 1]) === null || _b === void 0 ? void 0 : _b.current) === null || _c === void 0 ? void 0 : _c.getBoundingClientRect();
            if (!nextRect) return true;
            const isLeftEdgeInside = itemRect.left > containerRect.left && itemRect.left < containerRect.right;
            const isRightEdgeInside = itemRect.right > containerRect.left && itemRect.right < containerRect.right;
            // If neither the left nor the right edge is inside this is not the card.
            if (!isLeftEdgeInside && !isRightEdgeInside) return false;
            // If the whole card is inside, this is it.
            if (isLeftEdgeInside && isRightEdgeInside) return true;
            if (info.offset.x < 0) {
                // Dragged towards the left.
                // Some but less than `currentCardVisibleMinimum` of right side is inside, move to next.
                const pmoveToNext = !isLeftEdgeInside && isRightEdgeInside;
                if (pmoveToNext) {
                    const moveToNext = itemRect.right - containerRect.left < itemRect.width - itemRect.width * $451387dc0010b0f6$var$currentCardVisibleMinimum;
                    if (moveToNext) {
                        returnIndex = index + 1;
                        return false;
                    }
                }
                // If more than right half is visible, this is it.
                const rightHalfPlusInside = isRightEdgeInside && itemRect.right - containerRect.left > itemRect.width * $451387dc0010b0f6$var$currentCardVisibleMinimum;
                if (rightHalfPlusInside) return true;
                // If none of the above is the case for any cards until now, this is the one.
                const leftHalfPlusInside = isLeftEdgeInside && containerRect.right - itemRect.left > itemRect.width * $451387dc0010b0f6$var$currentCardVisibleMinimum;
                if (leftHalfPlusInside) return true;
            } else if (info.offset.x > 0) {
                // Dragged towards the right
                const rightThirdPlusInside = isRightEdgeInside && itemRect.right - containerRect.left > itemRect.width * $451387dc0010b0f6$var$currentCardVisibleMinimum;
                if (rightThirdPlusInside) return true;
            }
            return false;
        });
    }, []);
    const handleDragEnd = (0, $eeH7J.useCallback)((e, info)=>{
        var _a, _b, _c, _d, _e, _f, _g, _h;
        const containerRect = (_a = dragContainerRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
        const gridRect = (_b = cardsContainerRef.current) === null || _b === void 0 ? void 0 : _b.getBoundingClientRect();
        const firstCardRect = (_d = (_c = cardsRef.current[0]) === null || _c === void 0 ? void 0 : _c.current) === null || _d === void 0 ? void 0 : _d.getBoundingClientRect();
        const lastCardRect = (_f = (_e = cardsRef.current[cardsRef.current.length - 1]) === null || _e === void 0 ? void 0 : _e.current) === null || _f === void 0 ? void 0 : _f.getBoundingClientRect();
        if (!containerRect || !gridRect || !firstCardRect || !lastCardRect) {
            // eslint-disable-next-line no-console
            console.warn("Missing reference to container or grid.");
            return;
        }
        // The actual width of the cards. As opposed to the rect width, which is cut off at the
        // overflow point.
        const cardsContainerActualWidth = lastCardRect.right - firstCardRect.left;
        // If the whole grid is visible, no need to set any offset, but as always take dragX
        // into account.
        if (cardsContainerActualWidth <= containerRect.width) {
            updateOffsetX(0);
            return;
        }
        // Last card is to the right side of container edge.
        if (lastCardRect.right < containerRect.right) {
            const newOffsetX = firstCardRect.left - (lastCardRect.right - containerRect.width);
            updateOffsetX(newOffsetX);
            return;
        }
        const currentCardIndex = findCurrentCardIndex(info);
        if (typeof currentCardIndex === "undefined") {
            // eslint-disable-next-line no-console
            console.warn("Couldn't find a current card index. Reset offset and dragX.");
            updateOffsetX(0);
            dragX.set(0);
            return;
        }
        const currCardRect = (_h = (_g = cardsRef.current[currentCardIndex]) === null || _g === void 0 ? void 0 : _g.current) === null || _h === void 0 ? void 0 : _h.getBoundingClientRect();
        if (!firstCardRect || !currCardRect) {
            // eslint-disable-next-line no-console
            console.warn("Missing reference to first card or current card.");
            return;
        }
        // If the width from the current card to the last card is less than the container, align
        // the last card to the right side.
        if (lastCardRect.right - currCardRect.left < containerRect.width) {
            const newOffsetX = firstCardRect.left - (lastCardRect.right - containerRect.width);
            updateOffsetX(newOffsetX);
            return;
        }
        // Find new offset. It is usually the distance from the first card to the current card.
        // Except if current card is the last card, as that should not be aligned with the left
        // side of the container, but the right side.
        const newOffsetX = firstCardRect.left - (currentCardIndex === props.items.length - 1 ? currCardRect.right - containerRect.width : currCardRect.left);
        updateOffsetX(newOffsetX);
    }, [
        updateOffsetX,
        findCurrentCardIndex,
        dragX,
        props.items.length
    ]);
    // Just copied from CardsBlock, probably a good candidate for rafactoring.
    const handleSlideClick = (0, $eeH7J.useCallback)((direction)=>{
        var _a, _b, _c;
        if (!dragContainerRef.current) return;
        // Direction is the direction the cards will slide in, which is the opposite of the way the
        // arrow on the button is pointing.
        const slideDirection = direction === "prev" ? "right" : "left";
        const containerRect = dragContainerRef.current.getBoundingClientRect();
        try {
            // Find first card that is partially on the inside and partially on the outside of
            // container. Or the card before a card that is just inside the container This is
            // the card we'll want to move to the edge of the container.
            const firstCardPartiallyOutside = cardsRef.current.find((item, index)=>{
                var _a, _b, _c;
                const itemRect = (_a = item.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
                if (!itemRect) throw new Error(`No element for card item at index ${index}.`);
                if (slideDirection === "left") return itemRect.right > containerRect.right;
                else {
                    const nextRect = (_c = (_b = cardsRef.current[index + 1]) === null || _b === void 0 ? void 0 : _b.current) === null || _c === void 0 ? void 0 : _c.getBoundingClientRect();
                    if (!nextRect) return true;
                    return itemRect.left < containerRect.left && Math.round(nextRect.left) === Math.round(containerRect.left) || itemRect.left < containerRect.left && itemRect.right > containerRect.left;
                }
            });
            const firstCardPartiallyOutsideRect = (_a = firstCardPartiallyOutside === null || firstCardPartiallyOutside === void 0 ? void 0 : firstCardPartiallyOutside.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
            if (!firstCardPartiallyOutsideRect) throw new Error("Couldn't find rect for first card outside container.");
            // Find if remaining width outside is less than will fit in container.
            const outerMostCardRect = (_c = (_b = slideDirection === "left" ? cardsRef.current[cardsRef.current.length - 1] : cardsRef.current[0]) === null || _b === void 0 ? void 0 : _b.current) === null || _c === void 0 ? void 0 : _c.getBoundingClientRect();
            if (!outerMostCardRect) throw new Error("No outermost card.");
            const remainingWidthOutside = slideDirection === "left" ? outerMostCardRect.right - containerRect.right : containerRect.left - outerMostCardRect.left;
            if (remainingWidthOutside < containerRect.width) updateOffsetX(slideDirection === "left" ? offsetX - remainingWidthOutside : 0);
            else {
                // Else, scroll to where the first card partially outside, will be at the
                // container edge in the slide direction.
                const distanceFromCardToContainerEdge = containerRect[slideDirection] - firstCardPartiallyOutsideRect[slideDirection];
                updateOffsetX(offsetX + distanceFromCardToContainerEdge);
                return;
            }
            return;
        } catch (err) {
            //eslint-disable-next-line no-console
            console.log(err);
        }
    }, [
        offsetX,
        updateOffsetX
    ]);
    return (0, $4vwom.jsx)("div", {
        ref: dragContainerRef,
        children: (0, $4vwom.jsx)((0, $ad7a054f4530c130$export$e25e478948902b8b).div, {
            drag: "x",
            dragDirectionLock: true,
            dragMomentum: false,
            onDragEnd: handleDragEnd,
            transition: (0, $7f851218870bc850$export$f4e4ad51b471de36)["200"],
            animate: {
                translateX: `${offsetX - dragOffsetX}px`
            },
            onAnimationComplete: ()=>updatePosition(),
            style: {
                x: dragX
            },
            children: (0, $4vwom.jsx)("div", {
                ref: cardsContainerRef,
                children: props.renderContainer(props.items.map((item, index)=>(0, $4vwom.jsx)("div", {
                        ref: cardsRef.current[index],
                        children: props.renderItem(item, index)
                    }, index)))
            })
        })
    });
});
const $451387dc0010b0f6$var$arr = [
    ...new Array(3)
].map(()=>"Hello, World!");
(0, $eSiQ2.Component)($451387dc0010b0f6$export$1ee075080fb07ea7, {
    name: "CarouselBase",
    gallery: {
        items: [
            {
                variants: [
                    {
                        props: {
                            items: $451387dc0010b0f6$var$arr,
                            renderContainer: (children)=>(0, $4vwom.jsx)("div", {
                                    style: {
                                        display: "grid",
                                        gridAutoFlow: "column",
                                        gap: 16,
                                        gridAutoColumns: "min-content"
                                    },
                                    children: children
                                }),
                            renderItem: (_, index)=>(0, $4vwom.jsx)((0, $0273ae0bc8f90076$export$5fbe01e9406810ee), {
                                    title: `Hello ${index}${index}${index}${index}`,
                                    text: (0, $gGZ2r.Markdown)(`${index}`),
                                    image: `${(0, $7m9cQ.server)()}/static/redoit/how-it-works-card-illustration-3.svg`,
                                    readMoreAriaPrefix: "Read more"
                                })
                        }
                    }
                ]
            }
        ]
    }
});
function $451387dc0010b0f6$var$debounce(callback, wait) {
    let timeoutId;
    return (...args)=>{
        if (typeof window === "undefined") callback(...args);
        window.clearTimeout(timeoutId);
        timeoutId = window.setTimeout(()=>{
            callback(...args);
        }, wait);
    };
}













var $4vwom = parcelRequire("4vwom");

var $eeH7J = parcelRequire("eeH7J");

var $lhaLc = parcelRequire("lhaLc");

var $eSiQ2 = parcelRequire("eSiQ2");

function $d69bccca6c93b4b8$export$20d89a4afa1a58fa(props) {
    const { responsiveCss: responsiveCss } = (0, $756948b644e82cf2$export$559a0f07c8df6570)();
    const containerCss = (0, $eeH7J.useMemo)(()=>(0, $lhaLc.css)({
            maxHeight: 64,
            "&:hover div": {
                animationPlayState: "paused"
            },
            "&:before, &:after": {
                content: '""',
                position: "absolute",
                top: 0,
                bottom: 0,
                width: 50,
                zIndex: 1,
                pointerEvents: "none"
            },
            "&:before": {
                left: 0,
                background: "linear-gradient(270deg, rgba(255, 255,255,0), rgba(255, 255,255,1))"
            },
            "&:after": {
                right: 0,
                background: "linear-gradient(90deg, rgba(255, 255,255,0), rgba(255, 255,255,1))"
            }
        }, responsiveCss("min", "md", {
            "&:before, &:after": {
                width: 360,
                maxHeight: 80
            }
        })), [
        responsiveCss
    ]);
    return (0, $4vwom.jsxs)("div", {
        style: {
            position: "relative",
            overflow: "hidden",
            whiteSpace: "nowrap"
        },
        css: containerCss,
        children: [
            (0, $4vwom.jsx)("div", {
                style: {
                    animationDuration: `${props.items.length * 5}s`
                },
                css: [
                    $d69bccca6c93b4b8$var$responsiveGridCss,
                    $d69bccca6c93b4b8$var$animationCss
                ],
                children: props.items.map((item, index)=>(0, $4vwom.jsx)("div", {
                        children: item
                    }, index))
            }),
            (0, $4vwom.jsx)("div", {
                style: {
                    animationDuration: `${props.items.length * 5}s`
                },
                css: [
                    $d69bccca6c93b4b8$var$responsiveGridCss,
                    $d69bccca6c93b4b8$var$animationCss
                ],
                children: props.items.map((item, index)=>(0, $4vwom.jsx)("div", {
                        children: item
                    }, index))
            })
        ]
    });
}
const $d69bccca6c93b4b8$var$marquee = (0, $lhaLc.keyframes)({
    from: {
        transform: "translateX(0%)"
    },
    to: {
        transform: "translateX(-100%)"
    }
});
const $d69bccca6c93b4b8$var$animationCss = (0, $lhaLc.css)({
    animationName: $d69bccca6c93b4b8$var$marquee
});
const $d69bccca6c93b4b8$var$responsiveGridCss = (0, $lhaLc.css)({
    display: "inline-flex",
    alignItems: "center",
    animationIterationCount: "infinite",
    animationTimingFunction: "linear"
});
(0, $eSiQ2.Component)($d69bccca6c93b4b8$export$20d89a4afa1a58fa, {
    name: "ContinuousSlideCarousel",
    gallery: {
        items: [
            {
                variants: [
                    {
                        props: {
                            items: [
                                ...new Array(5)
                            ].map((item, index)=>(0, $4vwom.jsx)("div", {
                                    children: "Hello, world!"
                                }, index))
                        }
                    }
                ]
            }
        ]
    }
});







var $4vwom = parcelRequire("4vwom");

var $eeH7J = parcelRequire("eeH7J");

var $18Pjr = parcelRequire("18Pjr");

var $lhaLc = parcelRequire("lhaLc");

var $gssTr = parcelRequire("gssTr");

var $ikBJm = parcelRequire("ikBJm");

var $4vwom = parcelRequire("4vwom");

var $18Pjr = parcelRequire("18Pjr");

var $lhaLc = parcelRequire("lhaLc");

var $2chu2 = parcelRequire("2chu2");
function $a2a649cb2a0219fd$export$ace63239d21d36e() {
    return (0, $4vwom.jsx)((0, $4vwom.Fragment), {
        children: (0, $4vwom.jsxs)((0, $18Pjr.Route), {
            path: "/gallery",
            element: (0, $4vwom.jsxs)((0, $4vwom.Fragment), {
                children: [
                    (0, $4vwom.jsx)((0, $lhaLc.Global), {
                        styles: (0, $lhaLc.css)`
                                @import url("https://fonts.googleapis.com/css2?family=Inter:wght@100..900&display=swap");

                                *,
                                *:before,
                                *:after {
                                    box-sizing: border-box;
                                }

                                html,
                                body {
                                    font-family: "Inter", sans-serif;
                                    background-color: "#f4f5f7";
                                }
                            `
                    }),
                    (0, $4vwom.jsx)((0, $18Pjr.Outlet), {})
                ]
            }),
            children: [
                (0, $4vwom.jsx)((0, $18Pjr.Route), {
                    index: true,
                    element: (0, $4vwom.jsx)($a2a649cb2a0219fd$var$IndexLazy, {})
                }),
                (0, $4vwom.jsx)((0, $18Pjr.Route), {
                    path: "components/*",
                    element: (0, $4vwom.jsx)($a2a649cb2a0219fd$var$ComponentLazy, {})
                })
            ]
        })
    });
}

function $a2a649cb2a0219fd$var$IndexLazy() {
    return (0, $4vwom.jsx)((0, $2chu2.Lazy), {
        target: async ()=>(await (parcelRequire("btSzs"))).Index
    });
}

function $a2a649cb2a0219fd$var$ComponentLazy() {
    return (0, $4vwom.jsx)((0, $2chu2.Lazy), {
        target: async ()=>(await (parcelRequire("jwy4G"))).ComponentPage
    });
}



var $4vwom = parcelRequire("4vwom");

var $2chu2 = parcelRequire("2chu2");

var $18Pjr = parcelRequire("18Pjr");


var $4vwom = parcelRequire("4vwom");

var $eeH7J = parcelRequire("eeH7J");

var $dUDPg = parcelRequire("dUDPg");

var $18Pjr = parcelRequire("18Pjr");
function $32200496962fa240$export$415e2b10a0b89d5b(pathParam) {
    const params = (0, $18Pjr.useParams)();
    const value = params[pathParam];
    if (typeof value !== "string") throw new Error("Path parameter not found: " + pathParam);
    return value;
}



var $hV5w0 = parcelRequire("hV5w0");

var $4rY0U = parcelRequire("4rY0U");
function $c2d74f90fd30fcae$export$5b5b1e59dd8f64fe() {
    var _a;
    const urlSecret = (0, $32200496962fa240$export$415e2b10a0b89d5b)("urlSecret");
    const [state, setState] = (0, $eeH7J.useState)({});
    const body = (0, $eeH7J.useMemo)(()=>({
            state: state
        }), [
        state
    ]);
    const { data: data, refresh: refresh } = (0, $dUDPg.useSharedWidget)((_a = urlSecret) !== null && _a !== void 0 ? _a : null, body);
    return (0, $4vwom.jsx)((0, $hV5w0.WidgetContext).Provider, {
        value: {
            root: data === null || data === void 0 ? void 0 : data.content,
            async performAction () {
                alert("Not implemented");
            },
            refresh: refresh,
            state: Object.assign(Object.assign({}, data === null || data === void 0 ? void 0 : data.defaultState), state),
            async setState (newState) {
                setState((state)=>Object.assign(Object.assign({}, state), newState));
            }
        },
        children: (0, $4vwom.jsx)((0, $4rY0U.WidgetView), {
            value: data === null || data === void 0 ? void 0 : data.content
        })
    });
}



var $3SKqX = parcelRequire("3SKqX");

var $dUDPg = parcelRequire("dUDPg");
(0, $dUDPg.defaults).headers["Fuse-Timezone"] = Intl.DateTimeFormat().resolvedOptions().timeZone;
function $f6fc29e20a2ebf5b$export$83fb124b13439b08(plugins) {
    return (0, $4vwom.jsxs)((0, $4vwom.Fragment), {
        children: [
            (0, $4vwom.jsx)((0, $18Pjr.Route), {
                path: "shared-widgets/:urlSecret",
                element: (0, $4vwom.jsx)((0, $c2d74f90fd30fcae$export$5b5b1e59dd8f64fe), {})
            }),
            (0, $4vwom.jsx)((0, $18Pjr.Route), {
                path: "print/:collection/:document/:widgetKey",
                element: (0, $4vwom.jsx)($f6fc29e20a2ebf5b$var$PrintLazy, {})
            }),
            (0, $4vwom.jsxs)((0, $18Pjr.Route), {
                path: "/studio",
                element: (0, $4vwom.jsx)($f6fc29e20a2ebf5b$var$DatasetLazy, {
                    plugins: plugins
                }),
                children: [
                    (0, $4vwom.jsx)((0, $18Pjr.Route), {
                        index: true,
                        element: (0, $4vwom.jsx)($f6fc29e20a2ebf5b$var$PageLazy, {})
                    }),
                    (0, $4vwom.jsx)((0, $18Pjr.Route), {
                        path: "post/:endpoint/*",
                        element: (0, $4vwom.jsx)($f6fc29e20a2ebf5b$var$PostLazy, {})
                    }),
                    (0, $4vwom.jsx)((0, $18Pjr.Route), {
                        path: "search",
                        element: (0, $4vwom.jsx)($f6fc29e20a2ebf5b$var$SearchLazy, {})
                    }),
                    (0, $4vwom.jsx)((0, $18Pjr.Route), {
                        path: "diagnostics",
                        element: (0, $4vwom.jsx)($f6fc29e20a2ebf5b$var$DiagnosticsLazy, {})
                    }),
                    (0, $4vwom.jsx)((0, $18Pjr.Route), {
                        path: "import",
                        element: (0, $4vwom.jsx)($f6fc29e20a2ebf5b$var$ImportLazy, {})
                    }),
                    (0, $4vwom.jsx)((0, $18Pjr.Route), {
                        path: "console",
                        element: (0, $4vwom.jsx)($f6fc29e20a2ebf5b$var$ConsoleLazy, {})
                    }),
                    (0, $4vwom.jsx)((0, $18Pjr.Route), {
                        path: "console/:id",
                        element: (0, $4vwom.jsx)($f6fc29e20a2ebf5b$var$ConsoleLazy, {})
                    }),
                    (0, $4vwom.jsx)((0, $18Pjr.Route), {
                        path: ":page",
                        element: (0, $4vwom.jsx)($f6fc29e20a2ebf5b$var$PageLazy, {})
                    }),
                    (0, $4vwom.jsx)((0, $18Pjr.Route), {
                        path: ":page/:doc/:slug",
                        element: (0, $4vwom.jsx)($f6fc29e20a2ebf5b$var$PageLazy, {})
                    }),
                    (0, $4vwom.jsx)((0, $18Pjr.Route), {
                        path: ":page/:doc",
                        element: (0, $4vwom.jsx)($f6fc29e20a2ebf5b$var$PageLazy, {})
                    }),
                    (0, $4vwom.jsx)((0, $18Pjr.Route), {
                        path: "*",
                        element: (0, $4vwom.jsx)($f6fc29e20a2ebf5b$var$NotFoundView, {})
                    })
                ]
            })
        ]
    });
}


function $f6fc29e20a2ebf5b$var$DatasetLazy({ plugins: plugins }) {
    return (0, $4vwom.jsx)((0, $3SKqX.WebSocketContextProvider), {
        children: (0, $4vwom.jsx)((0, $2chu2.Lazy), {
            target: async ()=>{
                if (plugins) await plugins();
                await (parcelRequire("lCPdv"));
                return (await (parcelRequire("gOSPg"))).Dataset;
            }
        })
    });
}

function $f6fc29e20a2ebf5b$var$PageLazy() {
    return (0, $4vwom.jsx)((0, $2chu2.Lazy), {
        target: async ()=>(await (parcelRequire("gOSPg"))).Page
    });
}

function $f6fc29e20a2ebf5b$var$ConsoleLazy() {
    return (0, $4vwom.jsx)((0, $2chu2.Lazy), {
        target: async ()=>(await (parcelRequire("3HqLx"))).ConsoleView
    });
}

function $f6fc29e20a2ebf5b$var$PostLazy() {
    return (0, $4vwom.jsx)((0, $2chu2.Lazy), {
        target: async ()=>(await (parcelRequire("cxmpT"))).PostView
    });
}

function $f6fc29e20a2ebf5b$var$SearchLazy() {
    return (0, $4vwom.jsx)((0, $2chu2.Lazy), {
        target: async ()=>(await (parcelRequire("ii2We"))).SearchResults
    });
}

function $f6fc29e20a2ebf5b$var$DiagnosticsLazy() {
    return (0, $4vwom.jsx)((0, $2chu2.Lazy), {
        target: async ()=>(await (parcelRequire("2g57I"))).Diagnostics
    });
}

function $f6fc29e20a2ebf5b$var$ImportLazy() {
    return (0, $4vwom.jsx)((0, $2chu2.Lazy), {
        target: async ()=>(await (parcelRequire("hTPrL"))).ImportView
    });
}

function $f6fc29e20a2ebf5b$var$PrintLazy() {
    return (0, $4vwom.jsx)((0, $2chu2.Lazy), {
        target: async ()=>(await (parcelRequire("fCOl2"))).TablePrint
    });
}
function $f6fc29e20a2ebf5b$var$NotFoundView() {
    (0, $f3376239f4cdc33f$export$18dc2edb475b04ff).code = 404;
    const path = (0, $18Pjr.useParams)()["*"];
    return (0, $4vwom.jsxs)("div", {
        children: [
            "There is no page at this location: ",
            path
        ]
    });
}



var $dUDPg = parcelRequire("dUDPg");

var $4vwom = parcelRequire("4vwom");

var $2chu2 = parcelRequire("2chu2");

var $18Pjr = parcelRequire("18Pjr");

var $7FrRx = parcelRequire("7FrRx");

var $knIBr = parcelRequire("knIBr");
parcelRequire("jniej");
var $3SKqX = parcelRequire("3SKqX");

function $bc2d4ca19ef81dfc$export$e2ae8835b525498d(props) {
    return (0, $4vwom.jsx)((0, $3SKqX.WebSocketContextProvider), {
        children: (0, $4vwom.jsx)((0, $2chu2.Lazy), {
            load: props.condition,
            target: async ()=>{
                if (props.plugins) await props.plugins();
                return (await (parcelRequire("4DSuQ"))).EditableSite;
            },
            fallback: $bc2d4ca19ef81dfc$var$NonEditableSite
        })
    });
}
function $bc2d4ca19ef81dfc$var$NonEditableSite() {
    return (0, $4vwom.jsx)((0, $7FrRx.CurrentLocaleProvider), {
        children: (0, $4vwom.jsx)((0, $knIBr.SelectionContext).Provider, {
            value: (0, $knIBr.DummySelectionContext),
            children: (0, $4vwom.jsx)((0, $18Pjr.Outlet), {})
        })
    });
}



var $4vwom = parcelRequire("4vwom");

var $lhaLc = parcelRequire("lhaLc");

var $dUDPg = parcelRequire("dUDPg");

var $9Q5xE = parcelRequire("9Q5xE");

var $eeH7J = parcelRequire("eeH7J");

var $aIeEI = parcelRequire("aIeEI");
function $ff100056042ab63c$export$27cef3a4b5908de4() {
    const { data: data, refresh: refresh } = (0, $dUDPg.useCookieConsents)();
    const localize = (0, $aIeEI.useLocalize)();
    const [necessary, setNecessary] = (0, $eeH7J.useState)(true);
    const [preferences, setPreferences] = (0, $eeH7J.useState)(false);
    const [statistics, setStatistics] = (0, $eeH7J.useState)(false);
    const [marketing, setMarketing] = (0, $eeH7J.useState)(false);
    if ((data === null || data === void 0 ? void 0 : data.consents) || !(data === null || data === void 0 ? void 0 : data.info)) return null;
    return (0, $4vwom.jsxs)("div", {
        css: (0, $lhaLc.css)`
                position: fixed;
                bottom: 0;
                left: 0;
                right: 0;
                padding: 32px;
                background-color: ${data.info.colorMode === "dark" ? "#000e" : "#fff"};
                color: ${data.info.colorMode === "light" ? "black" : "white"};
                display: flex;
                flex-direction: row;
                z-index: 1000;
                box-shadow: 0 -4px 16px rgba(0, 0, 0, 0.1);
                overflow-y: scroll;

                @media (max-width: 600px) {
                    flex-direction: column;
                    top: 0;
                    margin: 16px;
                    margin-top: 32px;
                    margin-bottom: 32px;
                    border-radius: 8px;
                    font-size: 12px;
                }
            `,
        children: [
            (0, $4vwom.jsx)("div", {
                style: {
                    flex: 1,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center"
                },
                children: data.info.logo && (0, $4vwom.jsx)("img", {
                    src: data.info.logo.valueOf(),
                    alt: "",
                    css: (0, $lhaLc.css)`
                            width: 50%;
                            max-width: 96px;

                            @media (max-width: 600px) {
                                max-width: 64px;
                                margin-bottom: 16px;
                            }
                        `
                })
            }),
            (0, $4vwom.jsxs)("div", {
                style: {
                    flex: 2,
                    paddingRight: 32,
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center"
                },
                children: [
                    (0, $4vwom.jsx)("div", {
                        style: {
                            marginBottom: 8
                        },
                        children: (0, $4vwom.jsx)("b", {
                            children: localize(data.info.title)
                        })
                    }),
                    (0, $4vwom.jsx)("div", {
                        children: localize(data.info.description)
                    }),
                    (0, $4vwom.jsxs)("div", {
                        style: {
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "space-evenly",
                            marginTop: 16,
                            flexWrap: "wrap"
                        },
                        children: [
                            (0, $4vwom.jsx)($ff100056042ab63c$var$Switch, {
                                label: localize(data.info.necessary),
                                value: necessary,
                                onChange: setNecessary,
                                disabled: true
                            }),
                            (0, $4vwom.jsx)($ff100056042ab63c$var$Switch, {
                                label: localize(data.info.preferences),
                                value: preferences,
                                onChange: setPreferences
                            }),
                            (0, $4vwom.jsx)($ff100056042ab63c$var$Switch, {
                                label: localize(data.info.statistics),
                                value: statistics,
                                onChange: setStatistics
                            }),
                            (0, $4vwom.jsx)($ff100056042ab63c$var$Switch, {
                                label: localize(data.info.marketing),
                                value: marketing,
                                onChange: setMarketing
                            })
                        ]
                    })
                ]
            }),
            (0, $4vwom.jsxs)("div", {
                style: {
                    flex: 1,
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    padding: 32
                },
                children: [
                    (0, $4vwom.jsx)("div", {
                        style: {
                            backgroundColor: (0, $9Q5xE.ColorStyles).primary[700],
                            borderRadius: 8,
                            color: "white",
                            marginBottom: 8,
                            textAlign: "center",
                            padding: 12,
                            cursor: "pointer"
                        },
                        onClick: async ()=>{
                            await (0, $dUDPg.putCookieConsents)({
                                necessary: true,
                                marketing: true,
                                preferences: true,
                                statistics: true
                            });
                            if (GiveCookieConsent) {
                                // Calling GiveCookieConsent will execute all
                                // callbacks registered with WithCookieConsent for
                                // the specified type. This allows the consents to
                                // take effect without reloading the page.
                                GiveCookieConsent("necessary");
                                GiveCookieConsent("marketing");
                                GiveCookieConsent("preferences");
                                GiveCookieConsent("statistics");
                            }
                            await refresh();
                        },
                        children: localize(data.info.allowAll)
                    }),
                    (0, $4vwom.jsx)("div", {
                        style: {
                            backgroundColor: (0, $9Q5xE.ColorStyles).primary[100],
                            borderRadius: 8,
                            color: "#333",
                            marginBottom: 8,
                            textAlign: "center",
                            padding: 12,
                            cursor: "pointer"
                        },
                        onClick: async ()=>{
                            await (0, $dUDPg.putCookieConsents)({
                                necessary: true,
                                marketing: marketing,
                                preferences: preferences,
                                statistics: statistics
                            });
                            await refresh();
                            if (GiveCookieConsent && necessary) GiveCookieConsent("necessary");
                            if (GiveCookieConsent && preferences) GiveCookieConsent("preferences");
                            if (GiveCookieConsent && statistics) GiveCookieConsent("statistics");
                            if (GiveCookieConsent && marketing) GiveCookieConsent("marketing");
                        },
                        children: localize(data.info.allowSelection)
                    }),
                    (0, $4vwom.jsx)("div", {
                        style: {
                            backgroundColor: (0, $9Q5xE.ColorStyles).primary[100],
                            borderRadius: 8,
                            color: "#333",
                            marginBottom: 8,
                            textAlign: "center",
                            padding: 12,
                            cursor: "pointer"
                        },
                        onClick: async ()=>{
                            await (0, $dUDPg.putCookieConsents)({
                                necessary: true,
                                marketing: false,
                                preferences: false,
                                statistics: false
                            });
                            await refresh();
                            if (GiveCookieConsent) GiveCookieConsent("necessary");
                        },
                        children: localize(data.info.deny)
                    })
                ]
            })
        ]
    });
}
// A sliding switch component that can be used to toggle a boolean value.
function $ff100056042ab63c$var$Switch({ label: label, value: value, onChange: onChange, disabled: disabled }) {
    return (0, $4vwom.jsxs)("div", {
        style: {
            display: "flex",
            flexDirection: "row",
            alignItems: "center"
        },
        children: [
            label,
            (0, $4vwom.jsx)("div", {
                css: (0, $lhaLc.css)`
                    position: relative;
                    margin: 8px;
                    width: 50px;
                    height: 24px;
                    background-color: ${value ? (0, $9Q5xE.ColorStyles).primary[700] : (0, $9Q5xE.ColorStyles).gray[300]};
                    transition: background-color 0.2s;
                    border-radius: 12px;
                    cursor: ${disabled ? "not-allowed" : "pointer"};
                    box-shadow: inset 0 0 4px rgba(0, 0, 0, 0.4);
                `,
                onClick: ()=>{
                    if (!disabled) onChange(!value);
                },
                children: (0, $4vwom.jsx)("div", {
                    css: (0, $lhaLc.css)`
                        position: absolute;
                        top: 0;
                        left: ${value ? "26px" : "0"};
                        width: 24px;
                        height: 24px;
                        background-color: white;
                        border-radius: 50%;
                        transition: left 0.2s;
                        box-shadow: 0 0 4px rgba(0, 0, 0, 0.4);
                    `
                })
            })
        ]
    });
}




var $7FrRx = parcelRequire("7FrRx");


var $4vwom = parcelRequire("4vwom");

var $eK8Q4 = parcelRequire("eK8Q4");

var $dUDPg = parcelRequire("dUDPg");
function $a8ed3ba28c9b5ed3$export$61adcb461425a0d7(props) {
    var _a;
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const permissions = (_a = props.permissions) !== null && _a !== void 0 ? _a : (0, $dUDPg.useWebPermissions)().data;
    const env = permissions === null || permissions === void 0 ? void 0 : permissions.environment;
    const [hideEnvironmentSticker, setHideEnvironmentSticker] = (0, $eK8Q4.useSessionState)("hideEnvironmentSticker", false);
    return env && env !== "production" && !hideEnvironmentSticker ? (0, $4vwom.jsx)("div", {
        onClick: ()=>{
            alert("This will hide the environment sticker for this session. Close the tab and reopen to see it again.");
            setHideEnvironmentSticker(true);
        },
        style: {
            position: "absolute",
            left: 0,
            top: 0,
            backgroundColor: env === "staging" ? "yellow" : "skyblue",
            width: 90,
            zIndex: 1000,
            textAlign: "center",
            transform: "translate(-25%,70%) rotate(-45deg)",
            fontSize: 12
        },
        children: env.toUpperCase()
    }) : null;
}


function $1c5aafb56c97617e$export$8fde984557d8b466(config) {
    var _a, _b, _c;
    const ErrorScreen = (_a = config.errorScreen) !== null && _a !== void 0 ? _a : (0, $5fb7d8fdb47c7fea$export$38cf3de59bf684f4);
    const { data: locales } = (0, $dUDPg.useLocales)();
    const { data: permissions } = (0, $dUDPg.useWebPermissions)();
    const defaultLocale = (_b = (0, $dUDPg.useDefaultLocale)().data) === null || _b === void 0 ? void 0 : _b.defaultLocale;
    const PageComponent = (_c = config.pageComponent) !== null && _c !== void 0 ? _c : (0, $9fe8ccb750b589bb$export$32c792df021ab666);
    if (!locales || !permissions || !defaultLocale) return null;
    return (0, $4vwom.jsxs)((0, $4vwom.Fragment), {
        children: [
            (0, $4vwom.jsx)((0, $a8ed3ba28c9b5ed3$export$61adcb461425a0d7), {
                permissions: permissions
            }),
            (0, $4vwom.jsxs)((0, $ikBJm.ModalProvider), {
                children: [
                    config.globalStyles ? (0, $4vwom.jsx)((0, $lhaLc.Global), {
                        styles: config.globalStyles
                    }) : null,
                    (0, $4vwom.jsx)((0, $gssTr.LocalesContext).Provider, {
                        value: locales,
                        children: (0, $4vwom.jsxs)((0, $18Pjr.Routes), {
                            children: [
                                config.studio && (0, $f6fc29e20a2ebf5b$export$83fb124b13439b08)(config.studioPlugins),
                                config.gallery && (0, $a2a649cb2a0219fd$export$ace63239d21d36e)(),
                                (0, $4vwom.jsxs)((0, $18Pjr.Route), {
                                    element: (0, $4vwom.jsx)((0, $4vwom.Fragment), {
                                        children: (0, $4vwom.jsx)((0, $bc2d4ca19ef81dfc$export$e2ae8835b525498d), {
                                            condition: !!permissions.canEditWebsite,
                                            plugins: config.studioPlugins
                                        })
                                    }),
                                    children: [
                                        locales.map((l)=>{
                                            var _a, _b, _c, _d;
                                            return l.key === defaultLocale ? (0, $4vwom.jsx)((0, $18Pjr.Route), {
                                                element: (0, $4vwom.jsxs)((0, $7FrRx.CurrentLocaleContext).Provider, {
                                                    value: {
                                                        get locale () {
                                                            return l.key;
                                                        }
                                                    },
                                                    children: [
                                                        (_b = (_a = config.renderCookieConsentView) === null || _a === void 0 ? void 0 : _a.call(config)) !== null && _b !== void 0 ? _b : (0, $4vwom.jsx)((0, $ff100056042ab63c$export$27cef3a4b5908de4), {}),
                                                        (0, $4vwom.jsx)((0, $18Pjr.Outlet), {})
                                                    ]
                                                }),
                                                children: (0, $4vwom.jsxs)((0, $eeH7J.Fragment), {
                                                    children: [
                                                        (0, $4vwom.jsx)((0, $18Pjr.Route), {
                                                            index: true,
                                                            element: (0, $4vwom.jsx)(PageComponent, {
                                                                errorScreen: ErrorScreen,
                                                                EditableSectionsProps: config.EditableSectionsProps,
                                                                locale: l.key
                                                            })
                                                        }),
                                                        (0, $4vwom.jsx)((0, $18Pjr.Route), {
                                                            path: "/:slug",
                                                            element: (0, $4vwom.jsx)(PageComponent, {
                                                                errorScreen: ErrorScreen,
                                                                locale: l.key,
                                                                EditableSectionsProps: config.EditableSectionsProps
                                                            })
                                                        })
                                                    ]
                                                }, l.key.toString())
                                            }, l.key.valueOf()) : (0, $4vwom.jsx)((0, $18Pjr.Route), {
                                                element: (0, $4vwom.jsxs)((0, $7FrRx.CurrentLocaleContext).Provider, {
                                                    value: {
                                                        get locale () {
                                                            return l.key;
                                                        }
                                                    },
                                                    children: [
                                                        (_d = (_c = config.renderCookieConsentView) === null || _c === void 0 ? void 0 : _c.call(config)) !== null && _d !== void 0 ? _d : (0, $4vwom.jsx)((0, $ff100056042ab63c$export$27cef3a4b5908de4), {}),
                                                        (0, $4vwom.jsx)((0, $18Pjr.Outlet), {})
                                                    ]
                                                }),
                                                children: (0, $4vwom.jsxs)((0, $eeH7J.Fragment), {
                                                    children: [
                                                        (0, $4vwom.jsx)((0, $18Pjr.Route), {
                                                            index: true,
                                                            path: `/${l.key.toString()}`,
                                                            element: (0, $4vwom.jsx)(PageComponent, {
                                                                errorScreen: ErrorScreen,
                                                                EditableSectionsProps: config.EditableSectionsProps,
                                                                locale: l.key
                                                            })
                                                        }),
                                                        (0, $4vwom.jsx)((0, $18Pjr.Route), {
                                                            path: `/${l.key.toString()}/:slug`,
                                                            element: (0, $4vwom.jsx)(PageComponent, {
                                                                errorScreen: ErrorScreen,
                                                                EditableSectionsProps: config.EditableSectionsProps,
                                                                locale: l.key
                                                            })
                                                        })
                                                    ]
                                                }, l.key.toString())
                                            }, l.key.valueOf());
                                        }),
                                        config.children,
                                        (0, $4vwom.jsx)((0, $18Pjr.Route), {
                                            path: "*",
                                            element: (0, $4vwom.jsx)(ErrorScreen, {
                                                error: {
                                                    status: 404,
                                                    type: "Not found",
                                                    detail: "No page exists at this path"
                                                }
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
}



var $eeH7J = parcelRequire("eeH7J");
parcelRequire("5K1mb");
var $18Pjr = parcelRequire("18Pjr");

var $dUDPg = parcelRequire("dUDPg");
function $1685c589a1400a85$export$61e35ff362657020() {
    const location = (0, $18Pjr.useLocation)();
    // This should be resolved at SSR time so in practice, if analytics is
    // disabled, no API calls will be made by this hook.
    const status = (0, $dUDPg.useAnalyticsEventStatus)("web");
    const [disabled, setDisabled] = (0, $eeH7J.useState)(status.data ? status.data.disabled : false);
    (0, $eeH7J.useEffect)(()=>{
        async function postIt() {
            const path = location.pathname.split("/").filter((p)=>p !== "");
            const res = await (0, $dUDPg.postAnalyticsEvent)("web", {
                entity: path.slice(0, 4)
            });
            if ("disabled" in res && res.disabled) // Analytics is disabled, so we should disable the logger
            setDisabled(true);
        }
        if (!disabled) postIt();
    }, [
        location.pathname,
        disabled
    ]);
}



var $4vwom = parcelRequire("4vwom");

var $eeH7J = parcelRequire("eeH7J");

var $5K1mb = parcelRequire("5K1mb");

var $aIeEI = parcelRequire("aIeEI");







var $lhaLc = parcelRequire("lhaLc");


function $40092465e16f7bc3$export$c10f6b7a0de7b58a(props) {
    const l = (0, $aIeEI.useLocalize)();
    const page = (0, $e18f565b44c7bc7d$export$61180300cc91551d)();
    const [searchParams] = (0, $5K1mb.useSearchParams)();
    const [errorMessage, setErrorMessage] = (0, $eeH7J.useState)();
    const [success, setSuccess] = (0, $eeH7J.useState)(false);
    const id = searchParams.get("id");
    const { locale: locale } = props;
    const localize = (val)=>l(val, locale);
    const handleUnsubscribeClick = (0, $eeH7J.useCallback)(async ()=>{
        if (id && page.data) try {
            await (0, $e18f565b44c7bc7d$export$bc4051c7d3b69526)({
                id: id
            });
            setSuccess(true);
        } catch (err) {
            setErrorMessage(page.data.errorMessage);
        }
    }, [
        id,
        page.data
    ]);
    if (!page.data) return (0, $4vwom.jsx)((0, $4vwom.Fragment), {});
    return (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
        direction: "column",
        padding: {
            x: 24
        },
        children: [
            (0, $4vwom.jsx)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                alignItems: "center",
                style: {
                    height: (0, $756948b644e82cf2$export$981516ee4691055c)(100)
                },
                children: (0, $4vwom.jsx)((0, $67cf5539992d1dd3$export$e6ff31bff12b7ff4), {
                    css: (0, $lhaLc.css)({
                        width: (0, $756948b644e82cf2$export$981516ee4691055c)(114),
                        height: "auto",
                        marginRight: (0, $756948b644e82cf2$export$981516ee4691055c)(16)
                    })
                })
            }),
            (0, $4vwom.jsxs)("div", {
                children: [
                    (0, $4vwom.jsx)((0, $789b8639be592288$export$a8a3e93435678ff9), {
                        level: 2,
                        margin: {
                            bottom: "sm"
                        },
                        children: localize(page.data.heading)
                    }),
                    !id ? (0, $4vwom.jsx)((0, $82d66b15b8f4758d$export$d5163f1ce1e6a5f9), {
                        value: localize(page.data.missingParameterMessage)
                    }) : success ? (0, $4vwom.jsx)((0, $82d66b15b8f4758d$export$d5163f1ce1e6a5f9), {
                        value: localize(page.data.successMessage)
                    }) : (0, $4vwom.jsxs)((0, $4vwom.Fragment), {
                        children: [
                            (0, $4vwom.jsx)((0, $82d66b15b8f4758d$export$d5163f1ce1e6a5f9), {
                                value: localize(page.data.text)
                            }),
                            errorMessage ? (0, $4vwom.jsx)((0, $a9f507254d800340$export$fbbf1dbfdbfcef12), {
                                children: (0, $4vwom.jsx)((0, $82d66b15b8f4758d$export$d5163f1ce1e6a5f9), {
                                    value: localize(errorMessage)
                                })
                            }) : null,
                            (0, $4vwom.jsx)((0, $4b4086f8a1c6b2f8$export$353f5b6fc5456de1), {
                                variant: "dark",
                                onClick: handleUnsubscribeClick,
                                children: localize(page.data.buttonText)
                            })
                        ]
                    })
                ]
            })
        ]
    });
}



var $34lt5 = parcelRequire("34lt5");

var $4vwom = parcelRequire("4vwom");

var $eeH7J = parcelRequire("eeH7J");

var $lhaLc = parcelRequire("lhaLc");

var $dUDPg = parcelRequire("dUDPg");









var $aIeEI = parcelRequire("aIeEI");


var $5K1mb = parcelRequire("5K1mb");
function $8d4f21e1d9bbd8d8$export$27cef3a4b5908de4() {
    var _a, _b, _c, _d, _e, _f;
    const { data: data, refresh: refresh } = (0, $dUDPg.useCookieConsents)();
    const localize = (0, $aIeEI.useLocalize)();
    const [necessary, setNecessary] = (0, $eeH7J.useState)(true);
    const [preferences, setPreferences] = (0, $eeH7J.useState)(false);
    const [statistics, setStatistics] = (0, $eeH7J.useState)(false);
    const [marketing, setMarketing] = (0, $eeH7J.useState)(false);
    const [isCustomize, setIsCustomize] = (0, $eeH7J.useState)(false);
    const defaultRef = (0, $eeH7J.useRef)(null);
    const customizeRef = (0, $eeH7J.useRef)(null);
    const privacyPolicyPageInfo = (0, $dUDPg.useWebPageInfo)((_b = (_a = data === null || data === void 0 ? void 0 : data.info) === null || _a === void 0 ? void 0 : _a.privacyPolicyPage) !== null && _b !== void 0 ? _b : null);
    const handleAllowAllClick = (0, $eeH7J.useCallback)(async ()=>{
        await (0, $dUDPg.putCookieConsents)({
            necessary: true,
            marketing: true,
            preferences: true,
            statistics: true
        });
        if (GiveCookieConsent) {
            // Calling GiveCookieConsent will execute all
            // callbacks registered with WithCookieConsent for
            // the specified type. This allows the consents to
            // take effect without reloading the page.
            GiveCookieConsent("necessary");
            GiveCookieConsent("marketing");
            GiveCookieConsent("preferences");
            GiveCookieConsent("statistics");
        }
        await refresh();
    }, [
        refresh
    ]);
    const handleDenyClick = (0, $eeH7J.useCallback)(async ()=>{
        await (0, $dUDPg.putCookieConsents)({
            necessary: true,
            marketing: false,
            preferences: false,
            statistics: false
        });
        await refresh();
        if (GiveCookieConsent) GiveCookieConsent("necessary");
    }, [
        refresh
    ]);
    const handleAllowSelectionClick = (0, $eeH7J.useCallback)(async ()=>{
        await (0, $dUDPg.putCookieConsents)({
            necessary: true,
            marketing: marketing,
            preferences: preferences,
            statistics: statistics
        });
        await refresh();
        if (GiveCookieConsent && necessary) GiveCookieConsent("necessary");
        if (GiveCookieConsent && preferences) GiveCookieConsent("preferences");
        if (GiveCookieConsent && statistics) GiveCookieConsent("statistics");
        if (GiveCookieConsent && marketing) GiveCookieConsent("marketing");
    }, [
        marketing,
        preferences,
        statistics,
        refresh,
        necessary
    ]);
    return (0, $4vwom.jsx)((0, $0df0f0e5b644e49a$export$3ae376d12526dd6f), {
        children: (data === null || data === void 0 ? void 0 : data.consents) || !(data === null || data === void 0 ? void 0 : data.info) ? (0, $4vwom.jsx)((0, $4vwom.Fragment), {}) : (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
            css: $8d4f21e1d9bbd8d8$var$popupCss,
            backgroundColor: "grayWhite",
            borderRadius: "lg",
            elevation: true,
            direction: "column",
            motion: {
                transition: (0, $7f851218870bc850$export$f4e4ad51b471de36)["200"],
                initial: {
                    transform: "translateY(50px)",
                    scale: 0.75,
                    opacity: 0
                },
                animate: {
                    transform: "translateY(0px)",
                    scale: 1,
                    opacity: 1
                },
                exit: {
                    opacity: 0
                }
            },
            children: [
                (0, $4vwom.jsx)((0, $ad7a054f4530c130$export$e25e478948902b8b).div, {
                    animate: isCustomize ? {
                        translateY: ((_d = (_c = defaultRef.current) === null || _c === void 0 ? void 0 : _c.clientHeight) !== null && _d !== void 0 ? _d : 0) * -1,
                        opacity: 0,
                        height: 0
                    } : {},
                    children: (0, $4vwom.jsxs)("div", {
                        ref: defaultRef,
                        children: [
                            (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                variant: "heading",
                                level: [
                                    "fixed",
                                    "md",
                                    3
                                ],
                                style: {
                                    marginBottom: 16
                                },
                                children: localize(data.info.title)
                            }),
                            (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                variant: "body",
                                size: "md",
                                children: localize(data.info.description)
                            }),
                            ((_e = privacyPolicyPageInfo.data) === null || _e === void 0 ? void 0 : _e.slug) && privacyPolicyPageInfo.data.title ? (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                variant: "body",
                                size: "md",
                                style: {
                                    marginTop: 8,
                                    marginBottom: 24
                                },
                                children: (0, $4vwom.jsx)((0, $5K1mb.Link), {
                                    to: `/${localize(privacyPolicyPageInfo.data.slug)}`,
                                    children: localize(privacyPolicyPageInfo.data.title)
                                })
                            }) : null,
                            (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                                margin: {
                                    top: 16
                                },
                                children: [
                                    (0, $4vwom.jsx)("div", {
                                        style: {
                                            flex: "1 0 0"
                                        },
                                        children: (0, $4vwom.jsx)((0, $4b4086f8a1c6b2f8$export$353f5b6fc5456de1), {
                                            size: "sm",
                                            variant: "secondary",
                                            fullwidth: true,
                                            onClick: ()=>setIsCustomize(true),
                                            children: localize(data.info.customize)
                                        })
                                    }),
                                    (0, $4vwom.jsx)("div", {
                                        style: {
                                            marginLeft: 8,
                                            flex: "1 0 0"
                                        },
                                        children: (0, $4vwom.jsx)((0, $4b4086f8a1c6b2f8$export$353f5b6fc5456de1), {
                                            size: "sm",
                                            onClick: handleAllowAllClick,
                                            fullwidth: true,
                                            children: localize(data.info.allowAll)
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                }),
                (0, $4vwom.jsx)((0, $ad7a054f4530c130$export$e25e478948902b8b).div, {
                    initial: {
                        height: 0,
                        overflow: "hidden",
                        opacity: 0
                    },
                    animate: isCustomize ? {
                        height: (_f = customizeRef.current) === null || _f === void 0 ? void 0 : _f.clientHeight,
                        opacity: 1
                    } : {},
                    children: (0, $4vwom.jsxs)("div", {
                        ref: customizeRef,
                        children: [
                            (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                variant: "heading",
                                level: [
                                    "fixed",
                                    "md",
                                    3
                                ],
                                style: {
                                    marginBottom: 16
                                },
                                children: localize(data.info.customize)
                            }),
                            (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                                as: "label",
                                margin: {
                                    bottom: 16
                                },
                                direction: "column",
                                children: [
                                    (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                        margin: {
                                            bottom: 8
                                        },
                                        children: [
                                            (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                                variant: "body",
                                                size: "lg",
                                                children: localize(data.info.necessary)
                                            }),
                                            (0, $4vwom.jsx)((0, $06e3a36d2d83b339$export$48513f6b9f8ce62d), {
                                                disabled: true,
                                                checked: necessary,
                                                onChange: (e)=>setNecessary(e.target.checked)
                                            })
                                        ]
                                    }),
                                    (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                        variant: "body",
                                        size: "md",
                                        children: localize(data.info.necessaryDescription)
                                    })
                                ]
                            }),
                            (0, $4vwom.jsx)((0, $67d1e32b493d1bb5$export$2e0a83ec2e27ecbb), {
                                horizontal: true,
                                spacing: 16
                            }),
                            (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                                as: "label",
                                margin: {
                                    bottom: 16
                                },
                                direction: "column",
                                style: {
                                    cursor: "pointer"
                                },
                                children: [
                                    (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                        margin: {
                                            bottom: 8
                                        },
                                        children: [
                                            (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                                variant: "body",
                                                size: "lg",
                                                children: localize(data.info.preferences)
                                            }),
                                            (0, $4vwom.jsx)((0, $06e3a36d2d83b339$export$48513f6b9f8ce62d), {
                                                checked: preferences,
                                                onChange: (e)=>setPreferences(e.target.checked)
                                            })
                                        ]
                                    }),
                                    (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                        variant: "body",
                                        size: "md",
                                        children: localize(data.info.preferencesDescription)
                                    })
                                ]
                            }),
                            (0, $4vwom.jsx)((0, $67d1e32b493d1bb5$export$2e0a83ec2e27ecbb), {
                                horizontal: true,
                                spacing: 16
                            }),
                            (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                                as: "label",
                                margin: {
                                    bottom: 16
                                },
                                direction: "column",
                                style: {
                                    cursor: "pointer"
                                },
                                children: [
                                    (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                        margin: {
                                            bottom: 8
                                        },
                                        children: [
                                            (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                                variant: "body",
                                                size: "lg",
                                                children: localize(data.info.statistics)
                                            }),
                                            (0, $4vwom.jsx)((0, $06e3a36d2d83b339$export$48513f6b9f8ce62d), {
                                                checked: statistics,
                                                onChange: (e)=>setStatistics(e.target.checked)
                                            })
                                        ]
                                    }),
                                    (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                        variant: "body",
                                        size: "md",
                                        children: localize(data.info.statisticsDescription)
                                    })
                                ]
                            }),
                            (0, $4vwom.jsx)((0, $67d1e32b493d1bb5$export$2e0a83ec2e27ecbb), {
                                horizontal: true,
                                spacing: 16
                            }),
                            (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                                as: "label",
                                margin: {
                                    bottom: 16
                                },
                                direction: "column",
                                style: {
                                    cursor: "pointer"
                                },
                                children: [
                                    (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                        margin: {
                                            bottom: 8
                                        },
                                        children: [
                                            (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                                variant: "body",
                                                size: "lg",
                                                children: localize(data.info.marketing)
                                            }),
                                            (0, $4vwom.jsx)((0, $06e3a36d2d83b339$export$48513f6b9f8ce62d), {
                                                checked: marketing,
                                                onChange: (e)=>setMarketing(e.target.checked)
                                            })
                                        ]
                                    }),
                                    (0, $4vwom.jsx)((0, $38bb2c2712b5525d$export$5f1af8db9871e1d6), {
                                        variant: "body",
                                        size: "md",
                                        children: localize(data.info.marketingDescription)
                                    })
                                ]
                            }),
                            (0, $4vwom.jsxs)((0, $6aab0c65d5445347$export$f51f4c4ede09e011), {
                                margin: {
                                    top: 16
                                },
                                children: [
                                    (0, $4vwom.jsx)("div", {
                                        style: {
                                            flex: "1 0 0"
                                        },
                                        children: (0, $4vwom.jsx)((0, $4b4086f8a1c6b2f8$export$353f5b6fc5456de1), {
                                            size: "sm",
                                            variant: "secondary",
                                            fullwidth: true,
                                            onClick: handleDenyClick,
                                            children: localize(data.info.deny)
                                        })
                                    }),
                                    (0, $4vwom.jsx)("div", {
                                        style: {
                                            marginLeft: 8,
                                            flex: "1 0 0"
                                        },
                                        children: (0, $4vwom.jsx)((0, $4b4086f8a1c6b2f8$export$353f5b6fc5456de1), {
                                            size: "sm",
                                            onClick: handleAllowSelectionClick,
                                            fullwidth: true,
                                            children: localize(data.info.allowSelection)
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        }, "cookie-consent-view")
    });
}
const $8d4f21e1d9bbd8d8$var$popupCss = (0, $lhaLc.css)((0, $lhaLc.css)`
        z-index: 3000000000; // Extreme z-index to get above Intercom at 2147483000.
        position: fixed;
        bottom: ${(0, $1c2a8fb378443a1d$export$3a40bd8b0ff0173c).xs.paddingBottom}px;
        left: ${(0, $1c2a8fb378443a1d$export$3a40bd8b0ff0173c).xs.paddingLeft}px;
        right: ${(0, $1c2a8fb378443a1d$export$3a40bd8b0ff0173c).xs.paddingLeft}px;
        padding: 16px;
        overflow: hidden;
    `, (0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("min", "sm", (0, $lhaLc.css)`
            width: 400px;
        `), (0, $aace75a797ac78f1$export$cb4ef526fe7dcbbb)("min", "md", (0, $lhaLc.css)`
            bottom: ${(0, $1c2a8fb378443a1d$export$3a40bd8b0ff0173c).md.paddingBottom}px;
            left: ${(0, $1c2a8fb378443a1d$export$3a40bd8b0ff0173c).md.paddingLeft}px;
            padding: 24px;
            width: 400px;
        `));




var $501397ab7dd8f562$exports = {};
"use strict";
var $501397ab7dd8f562$var$__rest = $501397ab7dd8f562$exports && $501397ab7dd8f562$exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
Object.defineProperty($501397ab7dd8f562$exports, "__esModule", {
    value: true
});
$501397ab7dd8f562$exports.onUserEmailSupplied = $501397ab7dd8f562$exports.showConversation = $501397ab7dd8f562$exports.showTicket = $501397ab7dd8f562$exports.startChecklist = $501397ab7dd8f562$exports.startSurvey = $501397ab7dd8f562$exports.showNews = $501397ab7dd8f562$exports.showArticle = $501397ab7dd8f562$exports.startTour = $501397ab7dd8f562$exports.getVisitorId = $501397ab7dd8f562$exports.trackEvent = $501397ab7dd8f562$exports.onUnreadCountChange = $501397ab7dd8f562$exports.onShow = $501397ab7dd8f562$exports.onHide = $501397ab7dd8f562$exports.showNewMessage = $501397ab7dd8f562$exports.showMessages = $501397ab7dd8f562$exports.showSpace = $501397ab7dd8f562$exports.show = $501397ab7dd8f562$exports.hide = $501397ab7dd8f562$exports.update = $501397ab7dd8f562$exports.shutdown = $501397ab7dd8f562$exports.boot = $501397ab7dd8f562$exports.Intercom = void 0;
var $cb398febf310f866$exports = {};
"use strict";
Object.defineProperty($cb398febf310f866$exports, "__esModule", {
    value: true
});
$cb398febf310f866$exports.regionAPIs = void 0;
$cb398febf310f866$exports.regionAPIs = new Map([
    [
        "us",
        "https://api-iam.intercom.io"
    ],
    [
        "eu",
        "https://api-iam.eu.intercom.io"
    ],
    [
        "ap",
        "https://api-iam.au.intercom.io"
    ]
]);


var $27cc9c13607bafed$exports = {};
"use strict";
var $27cc9c13607bafed$var$__awaiter = $27cc9c13607bafed$exports && $27cc9c13607bafed$exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty($27cc9c13607bafed$exports, "__esModule", {
    value: true
});
$27cc9c13607bafed$exports.ref = $27cc9c13607bafed$exports.init = void 0;
const $27cc9c13607bafed$var$scriptElementId = "_intercom_npm_loader";
// This holds a queue of commands to be passed to the messenger widget API after it is added to the page
const $27cc9c13607bafed$var$queueHolder = function() {
    $27cc9c13607bafed$var$queueHolder.loaderQueue(arguments);
};
$27cc9c13607bafed$var$queueHolder.q = [];
$27cc9c13607bafed$var$queueHolder.loaderQueue = function(args) {
    $27cc9c13607bafed$var$queueHolder.q.push(args);
};
const $27cc9c13607bafed$var$addWidgetToPage = function() {
    var _a, _b;
    var d = document;
    if (d.getElementById($27cc9c13607bafed$var$scriptElementId)) // script is already in DOM
    return;
    var s = d.createElement("script");
    s.type = "text/javascript";
    s.async = true;
    s.id = $27cc9c13607bafed$var$scriptElementId;
    s.src = "https://widget.intercom.io/widget/" + ((_a = window.intercomSettings) === null || _a === void 0 ? void 0 : _a.app_id);
    var x = d.getElementsByTagName("script")[0];
    (_b = x.parentNode) === null || _b === void 0 || _b.insertBefore(s, x);
};
const $27cc9c13607bafed$var$isDocumentReady = ()=>document.readyState === "complete" || document.readyState === "interactive";
const $27cc9c13607bafed$var$init = ()=>$27cc9c13607bafed$var$__awaiter(void 0, void 0, void 0, function*() {
        var w = window;
        var ic = w.Intercom;
        if (w.intercomSettings) w.intercomSettings.installation_type = "npm-package";
        if (typeof ic === "function") {
            ic("reattach_activator");
            ic("update", w.intercomSettings);
        } else {
            w.Intercom = $27cc9c13607bafed$var$queueHolder;
            if ($27cc9c13607bafed$var$isDocumentReady()) $27cc9c13607bafed$var$addWidgetToPage();
            else {
                document.addEventListener("readystatechange", function() {
                    if ($27cc9c13607bafed$var$isDocumentReady()) $27cc9c13607bafed$var$addWidgetToPage();
                });
                if (w.attachEvent) w.attachEvent("onload", $27cc9c13607bafed$var$addWidgetToPage);
                else w.addEventListener("load", $27cc9c13607bafed$var$addWidgetToPage, false);
            }
        }
    });
$27cc9c13607bafed$exports.init = $27cc9c13607bafed$var$init;
$27cc9c13607bafed$exports.ref = undefined;


const $501397ab7dd8f562$var$callIntercomMethod = (method, ...args)=>{
    // window is undefined on server-side and this breaks our widget
    if (0, window.Intercom) window.Intercom(method, ...args);
    else console.warn("Please ensure Intercom is setup and running on client-side!");
};
const $501397ab7dd8f562$var$Intercom = (props)=>{
    if (typeof props !== "object") {
        console.warn("Intercom initialiser called with invalid parameters.");
        return;
    }
    const { region: region = "us" } = props, args = $501397ab7dd8f562$var$__rest(props, [
        "region"
    ]);
    if (typeof window !== "undefined" && !$27cc9c13607bafed$exports.ref) {
        window.intercomSettings = Object.assign(Object.assign({}, args), {
            api_base: $cb398febf310f866$exports.regionAPIs.get(region)
        });
        (0, $27cc9c13607bafed$exports.init)();
    }
};
$501397ab7dd8f562$exports.Intercom = $501397ab7dd8f562$var$Intercom;
// Public functions that can be called from outside the module
$501397ab7dd8f562$exports.default = $501397ab7dd8f562$exports.Intercom;
const $501397ab7dd8f562$var$boot = (arg)=>$501397ab7dd8f562$var$callIntercomMethod("boot", arg);
$501397ab7dd8f562$exports.boot = $501397ab7dd8f562$var$boot;
const $501397ab7dd8f562$var$shutdown = ()=>$501397ab7dd8f562$var$callIntercomMethod("shutdown");
$501397ab7dd8f562$exports.shutdown = $501397ab7dd8f562$var$shutdown;
const $501397ab7dd8f562$var$update = (arg)=>$501397ab7dd8f562$var$callIntercomMethod("update", arg);
$501397ab7dd8f562$exports.update = $501397ab7dd8f562$var$update;
const $501397ab7dd8f562$var$hide = ()=>$501397ab7dd8f562$var$callIntercomMethod("hide");
$501397ab7dd8f562$exports.hide = $501397ab7dd8f562$var$hide;
const $501397ab7dd8f562$var$show = ()=>$501397ab7dd8f562$var$callIntercomMethod("show");
$501397ab7dd8f562$exports.show = $501397ab7dd8f562$var$show;
const $501397ab7dd8f562$var$showSpace = (spaceName)=>$501397ab7dd8f562$var$callIntercomMethod("showSpace", spaceName);
$501397ab7dd8f562$exports.showSpace = $501397ab7dd8f562$var$showSpace;
const $501397ab7dd8f562$var$showMessages = ()=>$501397ab7dd8f562$var$callIntercomMethod("showMessages");
$501397ab7dd8f562$exports.showMessages = $501397ab7dd8f562$var$showMessages;
const $501397ab7dd8f562$var$showNewMessage = (prePopulatedContent)=>$501397ab7dd8f562$var$callIntercomMethod("showNewMessage", prePopulatedContent);
$501397ab7dd8f562$exports.showNewMessage = $501397ab7dd8f562$var$showNewMessage;
const $501397ab7dd8f562$var$onHide = (callback)=>$501397ab7dd8f562$var$callIntercomMethod("onHide", callback);
$501397ab7dd8f562$exports.onHide = $501397ab7dd8f562$var$onHide;
const $501397ab7dd8f562$var$onShow = (callback)=>$501397ab7dd8f562$var$callIntercomMethod("onShow", callback);
$501397ab7dd8f562$exports.onShow = $501397ab7dd8f562$var$onShow;
const $501397ab7dd8f562$var$onUnreadCountChange = (callback)=>$501397ab7dd8f562$var$callIntercomMethod("onUnreadCountChange", callback);
$501397ab7dd8f562$exports.onUnreadCountChange = $501397ab7dd8f562$var$onUnreadCountChange;
const $501397ab7dd8f562$var$trackEvent = (...args)=>$501397ab7dd8f562$var$callIntercomMethod("trackEvent", ...args);
$501397ab7dd8f562$exports.trackEvent = $501397ab7dd8f562$var$trackEvent;
const $501397ab7dd8f562$var$getVisitorId = ()=>$501397ab7dd8f562$var$callIntercomMethod("getVisitorId");
$501397ab7dd8f562$exports.getVisitorId = $501397ab7dd8f562$var$getVisitorId;
const $501397ab7dd8f562$var$startTour = (tourId)=>$501397ab7dd8f562$var$callIntercomMethod("startTour", tourId);
$501397ab7dd8f562$exports.startTour = $501397ab7dd8f562$var$startTour;
const $501397ab7dd8f562$var$showArticle = (articleId)=>$501397ab7dd8f562$var$callIntercomMethod("showArticle", articleId);
$501397ab7dd8f562$exports.showArticle = $501397ab7dd8f562$var$showArticle;
const $501397ab7dd8f562$var$showNews = (newsItemId)=>$501397ab7dd8f562$var$callIntercomMethod("showNews", newsItemId);
$501397ab7dd8f562$exports.showNews = $501397ab7dd8f562$var$showNews;
const $501397ab7dd8f562$var$startSurvey = (surveyId)=>$501397ab7dd8f562$var$callIntercomMethod("startSurvey", surveyId);
$501397ab7dd8f562$exports.startSurvey = $501397ab7dd8f562$var$startSurvey;
const $501397ab7dd8f562$var$startChecklist = (checklistId)=>$501397ab7dd8f562$var$callIntercomMethod("startChecklist", checklistId);
$501397ab7dd8f562$exports.startChecklist = $501397ab7dd8f562$var$startChecklist;
const $501397ab7dd8f562$var$showTicket = (ticketId)=>$501397ab7dd8f562$var$callIntercomMethod("showTicket", ticketId);
$501397ab7dd8f562$exports.showTicket = $501397ab7dd8f562$var$showTicket;
const $501397ab7dd8f562$var$showConversation = (conversationId)=>$501397ab7dd8f562$var$callIntercomMethod("showConversation", conversationId);
$501397ab7dd8f562$exports.showConversation = $501397ab7dd8f562$var$showConversation;
const $501397ab7dd8f562$var$onUserEmailSupplied = (callback)=>$501397ab7dd8f562$var$callIntercomMethod("onUserEmailSupplied", callback);
$501397ab7dd8f562$exports.onUserEmailSupplied = $501397ab7dd8f562$var$onUserEmailSupplied;



var $4vwom = parcelRequire("4vwom");

var $18Pjr = parcelRequire("18Pjr");

var $lhaLc = parcelRequire("lhaLc");


var $cSf8f = parcelRequire("cSf8f");


const $219dea6263a37832$var$styles = `
@page {
    /* General print page margin */
    margin: 20mm;
}

@media print {
    body {
        font-size: 12px;
    }

    h1 {
        font-size: 2em;
    }
    
    h2 {
        margin-top: 1.6em;
        font-size: 1.6em;
    }
    
    h3 {
        font-size: 1.4em;
    }
}

@media screen {
    body {
        margin: 20px; /* Set margin for screen */
        max-width: 800px;
        font-size: 16px;
    }
}
    h1 {
        font-size: 2em;
        margin-top: 32px;
    }

    h2 {
        margin-top: 24px;
        font-size: 2em;
    }
`;
function $219dea6263a37832$export$71c56c718a357b5() {
    var _a, _b, _c, _d, _e, _f, _g;
    const orderId = (0, $18Pjr.useParams)().id;
    const { helpers: helpers } = (0, $756948b644e82cf2$export$559a0f07c8df6570)();
    const { responsiveHeadingCss: responsiveHeadingCss } = helpers;
    const order = (0, $e18f565b44c7bc7d$export$42d4e273b2226793)((_a = orderId) !== null && _a !== void 0 ? _a : null);
    if (!order.data) return null;
    const { user: user, model: model, colorDisplayName: colorDisplayName, storageDisplayName: storageDisplayName, gradeDisplayName: gradeDisplayName, invoiceDateOfMonth: invoiceDateOfMonth, shippingAddress: shippingAddress, shippingSlot: shippingSlot, rentalPeriods: rentalPeriods, rentalPeriod: rentalPeriod } = order.data;
    return (0, $4vwom.jsxs)("div", {
        css: {
            h1: (0, $lhaLc.css)(responsiveHeadingCss(1), {
                marginBottom: ".4em",
                marginTop: ".4em"
            }),
            h2: (0, $lhaLc.css)(responsiveHeadingCss(2), {
                marginBottom: ".4em",
                marginTop: ".4em"
            }),
            h3: (0, $lhaLc.css)(responsiveHeadingCss(3), {
                marginBottom: ".4em",
                marginTop: ".4em"
            }),
            h4: (0, $lhaLc.css)(responsiveHeadingCss(4), {
                marginBottom: ".4em",
                marginTop: ".4em"
            })
        },
        style: {
            display: "flex",
            justifyContent: "center"
        },
        children: [
            (0, $4vwom.jsx)("style", {
                children: $219dea6263a37832$var$styles
            }),
            (0, $4vwom.jsxs)("div", {
                style: {
                    maxWidth: 800
                },
                children: [
                    (0, $4vwom.jsxs)("div", {
                        style: {
                            pageBreakAfter: "always",
                            marginBottom: 64
                        },
                        children: [
                            (0, $4vwom.jsx)("img", {
                                src: "/static/redoit-black.svg",
                                style: {
                                    width: 200,
                                    marginTop: 64
                                }
                            }),
                            (0, $4vwom.jsx)("h2", {
                                children: "Ordreskjema"
                            }),
                            (0, $4vwom.jsx)("h3", {
                                style: {
                                    fontWeight: 600
                                },
                                children: "Kontaktinformasjon"
                            }),
                            (0, $4vwom.jsx)($219dea6263a37832$var$Row, {
                                label: "Navn",
                                value: `${user.givenName} ${user.familyName}`
                            }),
                            (0, $4vwom.jsx)($219dea6263a37832$var$Row, {
                                label: "Telefonnummer",
                                value: (_b = user.phoneNumber) === null || _b === void 0 ? void 0 : _b.valueOf()
                            }),
                            (0, $4vwom.jsx)($219dea6263a37832$var$Row, {
                                label: "E-post",
                                value: (_c = user.email) === null || _c === void 0 ? void 0 : _c.valueOf()
                            }),
                            (0, $4vwom.jsx)($219dea6263a37832$var$Row, {
                                label: "Adresse",
                                value: `${(_d = user.address) === null || _d === void 0 ? void 0 : _d.street}, ${(_e = user.address) === null || _e === void 0 ? void 0 : _e.zip} ${(_f = user.address) === null || _f === void 0 ? void 0 : _f.city}`
                            }),
                            (0, $4vwom.jsx)("h3", {
                                style: {
                                    fontWeight: 600
                                },
                                children: "Beskrivelse av Utstyret"
                            }),
                            (0, $4vwom.jsx)($219dea6263a37832$var$Row, {
                                label: "Modell",
                                value: model.name
                            }),
                            (0, $4vwom.jsx)($219dea6263a37832$var$Row, {
                                label: "Farge",
                                value: colorDisplayName
                            }),
                            (0, $4vwom.jsx)($219dea6263a37832$var$Row, {
                                label: "Lagring",
                                value: storageDisplayName
                            }),
                            (0, $4vwom.jsx)($219dea6263a37832$var$Row, {
                                label: "Tilstandsgrad",
                                value: gradeDisplayName
                            }),
                            (0, $4vwom.jsx)("h3", {
                                style: {
                                    fontWeight: 600
                                },
                                children: "Pris og varighet"
                            }),
                            (0, $4vwom.jsx)($219dea6263a37832$var$Row, {
                                label: "M\xe5nedsbel\xf8p",
                                value: `kr ${(_g = rentalPeriods[rentalPeriods.length - 1]) === null || _g === void 0 ? void 0 : _g.monthlyPrice.itemsTotal.majorUnits}`
                            }),
                            (0, $4vwom.jsx)($219dea6263a37832$var$Row, {
                                label: "Faktureringsdato",
                                value: `M\xe5nedlig den ${invoiceDateOfMonth}.`
                            }),
                            (0, $4vwom.jsx)($219dea6263a37832$var$Row, {
                                label: "Bindingstid",
                                value: `${rentalPeriod.months} m\xe5neder`
                            }),
                            (0, $4vwom.jsx)("h3", {
                                style: {
                                    fontWeight: 600
                                },
                                children: "Levering av Utstyret"
                            }),
                            shippingSlot ? (0, $4vwom.jsx)($219dea6263a37832$var$Row, {
                                label: "Leveringsdato",
                                value: shippingSlot.startDate.valueOf()
                            }) : null,
                            (0, $4vwom.jsx)($219dea6263a37832$var$Row, {
                                label: "Leveringsadresse",
                                value: `${shippingAddress.street}, ${shippingAddress.zip} ${shippingAddress.city}`
                            })
                        ]
                    }),
                    (0, $4vwom.jsx)($219dea6263a37832$export$556363f0b1068104, {})
                ]
            })
        ]
    });
}
function $219dea6263a37832$export$66802dd86d4b9603() {
    const r = (0, $e18f565b44c7bc7d$export$23e8c26267d65867)();
    if (!r.data) return null;
    return (0, $4vwom.jsxs)("div", {
        style: {
            maxWidth: 800
        },
        children: [
            (0, $4vwom.jsx)("style", {
                children: $219dea6263a37832$var$styles
            }),
            (0, $4vwom.jsx)((0, $82d66b15b8f4758d$export$d5163f1ce1e6a5f9), {
                value: r.data.insurance.content
            })
        ]
    });
}
function $219dea6263a37832$export$556363f0b1068104() {
    const r = (0, $e18f565b44c7bc7d$export$23e8c26267d65867)();
    if (!r.data) return null;
    return (0, $4vwom.jsxs)("div", {
        style: {
            maxWidth: 800
        },
        children: [
            (0, $4vwom.jsx)("style", {
                children: $219dea6263a37832$var$styles
            }),
            (0, $4vwom.jsx)((0, $82d66b15b8f4758d$export$d5163f1ce1e6a5f9), {
                value: r.data.phoneOrder.content
            }),
            (0, $4vwom.jsx)("div", {
                style: {
                    pageBreakAfter: "always"
                }
            }),
            (0, $4vwom.jsx)((0, $82d66b15b8f4758d$export$d5163f1ce1e6a5f9), {
                value: r.data.insurance.content
            })
        ]
    });
}
function $219dea6263a37832$var$Row({ label: label, value: value }) {
    return (0, $4vwom.jsxs)("div", {
        style: {
            display: "flex",
            flexDirection: "row",
            justifyContent: "flex-strt"
        },
        children: [
            (0, $4vwom.jsxs)("div", {
                style: {
                    fontWeight: "bold",
                    marginRight: 16,
                    width: 200
                },
                children: [
                    label,
                    ": "
                ]
            }),
            (0, $4vwom.jsx)("div", {
                children: typeof value === "object" ? (0, $cSf8f.ClientSideLocalize)(value) : value
            })
        ]
    });
}






var $eeH7J = parcelRequire("eeH7J");
parcelRequire("jniej");
var $eK8Q4 = parcelRequire("eK8Q4");
function $ca337ff74984d5af$export$a603663adc682cac() {
    return (0, $eK8Q4.useSessionState)("discount-code", undefined);
}
function $ca337ff74984d5af$var$sectionItemCss() {
    return (0, $lhaLc.css)({
        margin: "0 auto",
        // Override Bootstrap line height variable.
        "--bs-body-line-height": "1",
        lineHeight: "1"
    }, (0, $756948b644e82cf2$export$629e292a677297c2)());
}

function $ca337ff74984d5af$export$86fbec116b87613f() {
    (0, $1685c589a1400a85$export$61e35ff362657020)();
    const [, setDiscountCode] = $ca337ff74984d5af$export$a603663adc682cac();
    const [searchParams, setSearchParams] = (0, $5K1mb.useSearchParams)();
    (0, $eeH7J.useEffect)(()=>{
        const discountCodeQueryParamKey = "discountCode";
        const discountCode = searchParams.get(discountCodeQueryParamKey);
        if (discountCode) {
            setDiscountCode(discountCode);
            setSearchParams((prev)=>{
                prev.delete(discountCodeQueryParamKey);
                return Object.fromEntries(prev);
            });
        }
    }, [
        searchParams,
        setDiscountCode,
        setSearchParams
    ]);
    return (0, $4vwom.jsx)((0, $dc53c17a4a911fba$export$d8964aec282183a3), {
        theme: (0, $756948b644e82cf2$export$92c840cda8ec752c),
        children: (0, $4vwom.jsxs)((0, $1c5aafb56c97617e$export$8fde984557d8b466), {
            gallery: true,
            studio: true,
            studioPlugins: async ()=>{
                await (parcelRequire("98lGN"));
            },
            globalStyles: (0, $756948b644e82cf2$export$aa0e86c7c0d2f400),
            EditableSectionsProps: {
                itemCss: $ca337ff74984d5af$var$sectionItemCss
            },
            pageComponent: $ca337ff74984d5af$var$RedoitPage,
            renderCookieConsentView: ()=>(0, $4vwom.jsx)((0, $8d4f21e1d9bbd8d8$export$27cef3a4b5908de4), {}),
            errorScreen: ()=>(0, $4vwom.jsx)((0, $b97c03a91b0e5a47$export$c120a0e80fd44ca6), {}),
            children: [
                (0, $4vwom.jsx)((0, $18Pjr.Route), {
                    path: "/terms-and-conditions/phone-order/:id",
                    element: (0, $4vwom.jsx)((0, $219dea6263a37832$export$71c56c718a357b5), {})
                }),
                (0, $4vwom.jsx)((0, $18Pjr.Route), {
                    path: "/terms-and-conditions/phone-protection-plan",
                    element: (0, $4vwom.jsx)((0, $219dea6263a37832$export$66802dd86d4b9603), {})
                }),
                (0, $4vwom.jsx)((0, $18Pjr.Route), {
                    path: "/terms-and-conditions/phone-order",
                    element: (0, $4vwom.jsx)((0, $219dea6263a37832$export$556363f0b1068104), {})
                }),
                (0, $4vwom.jsx)((0, $18Pjr.Route), {
                    path: "/system/nyhetsbrev-meld-av",
                    element: (0, $4vwom.jsx)((0, $40092465e16f7bc3$export$c10f6b7a0de7b58a), {
                        locale: (0, $34lt5.LocaleKey).no
                    })
                }),
                (0, $4vwom.jsx)((0, $18Pjr.Route), {
                    path: "/system/en/newsletter-unsubscribe",
                    element: (0, $4vwom.jsx)((0, $40092465e16f7bc3$export$c10f6b7a0de7b58a), {
                        locale: (0, $34lt5.LocaleKey).en
                    })
                })
            ]
        })
    });
}
function $ca337ff74984d5af$var$RedoitPage(props) {
    var _a, _b;
    const user = (0, $e18f565b44c7bc7d$export$f637e1cf42d15a62)();
    if (user.data && user.data.anonymous === false) (0, (/*@__PURE__*/$parcel$interopDefault($501397ab7dd8f562$exports)))({
        app_id: "wve6w27x",
        user_id: (_a = user.data.id) === null || _a === void 0 ? void 0 : _a.valueOf(),
        name: `${user.data.givenName} ${user.data.familyName}`,
        email: (_b = user.data.email) === null || _b === void 0 ? void 0 : _b.valueOf(),
        created_at: user.data.createdAt
    });
    else (0, (/*@__PURE__*/$parcel$interopDefault($501397ab7dd8f562$exports)))({
        app_id: "wve6w27x"
    });
    return (0, $4vwom.jsx)((0, $9fe8ccb750b589bb$export$32c792df021ab666), Object.assign({}, props));
}



var $9Q5xE = parcelRequire("9Q5xE");

var $5gIPd = parcelRequire("5gIPd");
(0, $9Q5xE.ColorStyles).primary = (0, $9Q5xE.ColorStyles).teal;
(0, $5gIPd.SidebarTheme).light = false;
(0, $5gIPd.SidebarTheme).background = "#130722";



(0, $19ea5142dc1f8ebf$export$e547c4fd78449aad)(()=>(0, $4vwom.jsx)((0, $4DHNO.Login), {
        always: false,
        tokenReady: (token)=>{
            (0, $e18f565b44c7bc7d$export$ebe90cb607ad99e).headers.Authorization = `Bearer ${token}`;
            (0, $dUDPg.defaults).headers.Authorization = `Bearer ${token}`;
        },
        clearTokens: ()=>{
            (0, $e18f565b44c7bc7d$export$ebe90cb607ad99e).headers.Authorization = "";
            (0, $dUDPg.defaults).headers.Authorization = "";
        },
        login: async (defaultLogin, returnTo, error)=>{
            if ((error === null || error === void 0 ? void 0 : error.type) === "UnauthorizedWithVipps") {
                if (await (0, $f2e2333c5543d6d8$export$5eda4f58d84268b6)(returnTo !== null && returnTo !== void 0 ? returnTo : "/", returnTo !== null && returnTo !== void 0 ? returnTo : "/")) return;
                else window.history.back();
            } else defaultLogin(returnTo);
        },
        children: (0, $4vwom.jsx)((0, $5K1mb.BrowserRouter), {
            children: (0, $4vwom.jsx)((0, $ca337ff74984d5af$export$86fbec116b87613f), {})
        })
    }));


//# sourceMappingURL=index.664f9d1b.js.map
